/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".build.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 229);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(306)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(285);
var _st_rs, _state;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//*  topcg/scr/store.js
//*      Establece la inicialización con Firebase y el almacen con las variables globales.
//*
//*
//*
//*      Muestra el menú de opciones    
//*======================================================================================================== */






// import deptos from './modules/deptos.js'




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* Exportamos a través de la constante STORE los valores de la base de datos (db) 
   la ruta, path o nodo a acceder */
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({

     // modules: {
     //      deptos,
     // },
     state: (_state = {
          auth: true,

          //** Obtiene el path del nodo de las evaluaciones y usuarios, 
          //*  así como la referencia para su acceso (st_dbxyz) 
          st_db: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["a" /* db */],
          st_rutaEvalTipolo: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["B" /* rutaEvalTipolo */],
          st_rutaEvalFactor: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["w" /* rutaEvalFactor */],
          st_rutaEvalEstabi: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["v" /* rutaEvalEstabi */],
          st_rutaEvalSociab: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["y" /* rutaEvalSociab */],
          st_rutaEvalPerfil: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["x" /* rutaEvalPerfil */],
          st_rutaEvalSuperv: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["A" /* rutaEvalSuperv */],
          st_rutaEvalApvtas: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["s" /* rutaEvalApvtas */],
          st_rutaEvalSolemp: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["z" /* rutaEvalSolemp */],
          st_rutaEvalEmoc: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["u" /* rutaEvalEmoc */],
          st_rutaEvalVta2s: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["C" /* rutaEvalVtas2 */],
          st_rutaEvalAuxi: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["t" /* rutaEvalAuxi */],
          st_rutaEvalAEDP: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["r" /* rutaEvalAEDP */],

          st_rutaUsuarios: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["E" /* rutaUsuarios */],
          st_rutaCVs: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["p" /* rutaCV */],

          st_dbEvalTipolo: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["m" /* dbEvalTipolo */],
          st_dbEvalFactor: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["h" /* dbEvalFactor */],
          st_dbEvalEstabi: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["g" /* dbEvalEstabi */],
          st_dbEvalSociab: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["j" /* dbEvalSociab */],
          st_dbEvalPerfil: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["i" /* dbEvalPerfil */],
          st_dbEvalSuperv: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["l" /* dbEvalSuperv */],
          st_dbEvalApvtas: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["d" /* dbEvalApvtas */],
          st_dbEvalSolemp: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["k" /* dbEvalSolemp */],
          st_dbEvalEmoc: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["f" /* dbEvalEmoc */],
          st_dbEvalVtas2: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["n" /* dbEvalVtas2 */],
          st_dbEvalAuxi: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["e" /* dbEvalAuxi */],
          st_dbEvalAEDP: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["c" /* dbEvalAEDP */],

          st_dbUsuarios: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["o" /* dbUsuarios */],
          st_dbCVs: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["b" /* dbCV */],

          //** Obtiene el path de la carpeta de los CVs y Fotos de usuarios
          //*  así como la referencia para su acceso (st_sthxyz) 
          st_stg: __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["F" /* stg */]
     }, _defineProperty(_state, 'st_rutaCVs', __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["q" /* rutaCVs */]), _defineProperty(_state, 'st_rutaFotosU', __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["D" /* rutaFotosU */]), _defineProperty(_state, 'st_stgCVs', __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["G" /* stgCVs */]), _defineProperty(_state, 'st_stgFotosU', __WEBPACK_IMPORTED_MODULE_2__myFirebaseApp__["H" /* stgFotosU */]), _defineProperty(_state, 'st_logeado', false), _defineProperty(_state, 'st_usuario', ""), _defineProperty(_state, 'st_clave', ""), _defineProperty(_state, 'st_email', ""), _defineProperty(_state, 'st_nusuario', ""), _defineProperty(_state, 'st_usuarios', []), _defineProperty(_state, 'st_roles', ""), _defineProperty(_state, 'st_activo', ""), _defineProperty(_state, 'st_admin', false), _defineProperty(_state, 'st_empresa', ""), _defineProperty(_state, 'st_llave', ""), _defineProperty(_state, 'st_modo', "INGRESO"), _defineProperty(_state, 'pagina', 1), _defineProperty(_state, 'lini', 0), _defineProperty(_state, 'lfin', 5), _defineProperty(_state, 'limite', 5), _defineProperty(_state, 'diferencia', 5), _defineProperty(_state, 'esLimiteSup', false), _defineProperty(_state, 'esLimiteInf', true), _defineProperty(_state, 'st_eval', []), _defineProperty(_state, 'Cpagina', 1), _defineProperty(_state, 'Clini', 0), _defineProperty(_state, 'Clfin', 5), _defineProperty(_state, 'CesLimiteSup', false), _defineProperty(_state, 'CesLimiteInf', true), _defineProperty(_state, 'Dpagina', 1), _defineProperty(_state, 'Dlini', 0), _defineProperty(_state, 'Dlfin', 5), _defineProperty(_state, 'DesLimiteSup', false), _defineProperty(_state, 'DesLimiteInf', true), _defineProperty(_state, 'st_ev01', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/01/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
          pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
          pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
          pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
          pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0, pg049: 0, pg050: 0,
          pg051: 0, pg052: 0, pg053: 0, pg054: 0, pg055: 0, pg056: 0, pg057: 0, pg058: 0, pg059: 0, pg060: 0,
          pg061: 0, pg062: 0, pg063: 0, pg064: 0, pg065: 0, pg066: 0, pg067: 0, pg068: 0, pg069: 0, pg070: 0
     }), _defineProperty(_state, 'st_rs01', {
          a1: 0, b2: 0, a5: 0, b6: 0, a9: 0, b10: 0, a3: 0, b4: 0, a7: 0, b8: 0, a11: 0, b12: 0,
          E: 0, I: 0, S: 0, N: 0, T: 0, F: 0, J: 0, P: 0,
          par1iguales: false, par2iguales: false, par3iguales: false, par4iguales: false,
          topologia: "",
          topologiaEI1: "", topologiaSN1: "", topologiaTF1: "", topologiaJP1: "",
          topologia1: "", topologia2: "", topologia3: "", topologia4: "", topologia5: "",
          topologia6: "", topologia7: "", topologia8: "", topologia9: "", topologia10: "",
          topologia11: "", topologia12: "", topologia13: "", topologia14: "", topologia15: "",
          topologia16: ""
     }), _defineProperty(_state, 'st_ev02', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/01/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
          pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
          pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
          pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
          pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0, pg049: 0, pg050: 0,
          pg051: 0, pg052: 0, pg053: 0, pg054: 0, pg055: 0, pg056: 0, pg057: 0, pg058: 0, pg059: 0, pg060: 0,
          pg061: 0, pg062: 0, pg063: 0, pg064: 0, pg065: 0, pg066: 0, pg067: 0, pg068: 0, pg069: 0, pg070: 0,
          pg071: 0, pg072: 0, pg073: 0, pg074: 0, pg075: 0, pg076: 0, pg077: 0, pg078: 0, pg079: 0, pg080: 0,
          pg081: 0, pg082: 0, pg083: 0, pg084: 0, pg085: 0, pg086: 0, pg087: 0, pg088: 0, pg089: 0, pg090: 0,
          pg091: 0, pg092: 0, pg093: 0, pg094: 0, pg095: 0, pg096: 0, pg097: 0, pg098: 0, pg099: 0, pg100: 0,
          pg101: 0, pg102: 0
     }), _defineProperty(_state, 'st_rs02', (_st_rs = {
          resA: 0, resP: 0 }, _defineProperty(_st_rs, 'resA', 0), _defineProperty(_st_rs, 'resB', 0), _defineProperty(_st_rs, 'resC', 0), _defineProperty(_st_rs, 'resE', 0), _defineProperty(_st_rs, 'resF', 0), _defineProperty(_st_rs, 'resG', 0), _defineProperty(_st_rs, 'resH', 0), _defineProperty(_st_rs, 'resI', 0), _defineProperty(_st_rs, 'resL', 0), _defineProperty(_st_rs, 'resM', 0), _defineProperty(_st_rs, 'resN', 0), _defineProperty(_st_rs, 'resO', 0), _defineProperty(_st_rs, 'resQ1', 0), _defineProperty(_st_rs, 'resQ2', 0), _defineProperty(_st_rs, 'resQ3', 0), _defineProperty(_st_rs, 'resQ4', 0), _defineProperty(_st_rs, 'rangoP', 0), _defineProperty(_st_rs, 'rangoA', 0), _defineProperty(_st_rs, 'rangoB', 0), _defineProperty(_st_rs, 'rangoC', 0), _defineProperty(_st_rs, 'rangoE', 0), _defineProperty(_st_rs, 'rangoF', 0), _defineProperty(_st_rs, 'rangoG', 0), _defineProperty(_st_rs, 'rangoH', 0), _defineProperty(_st_rs, 'rangoI', 0), _defineProperty(_st_rs, 'rangoL', 0), _defineProperty(_st_rs, 'rangoM', 0), _defineProperty(_st_rs, 'rangoN', 0), _defineProperty(_st_rs, 'rangoO', 0), _defineProperty(_st_rs, 'rangoQ1', 0), _defineProperty(_st_rs, 'rangoQ2', 0), _defineProperty(_st_rs, 'rangoQ3', 0), _defineProperty(_st_rs, 'rangoQ4', 0), _st_rs)), _defineProperty(_state, 'st_ev03', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/01/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
          pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
          pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
          pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0
     }), _defineProperty(_state, 'st_rs03', {
          Uno: 0, Dos: 0, Cero: 0, Uno2: 0, Dos2: 0, Cero2: 0,
          cpreviaIzq: 0, cpreviaDer: 0,
          rangos: 0
     }), _defineProperty(_state, 'st_ev04', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/01/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
          pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
          pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
          pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0
     }), _defineProperty(_state, 'st_rs04', {
          Uno: 0, Dos: 0, Cero: 0, Uno2: 0, Dos2: 0, Cero2: 0,
          cpreviaIzq: 0, cpreviaDer: 0,
          rangos: 0
     }), _defineProperty(_state, 'st_ev05', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/01/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
          pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
          pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
          pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
          pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: ""
     }), _defineProperty(_state, 'st_rs05', {
          mas_D: 0, menos_D: 0, mas_I: 0, menos_I: 0, mas_S: 0, menos_S: 0,
          mas_C: 0, menos_C: 0, mas_N: 0, menos_N: 0, mas_W: 0, menos_W: 0,
          total_mas: 0, total_menos: 0
     }), _defineProperty(_state, 'st_ev06', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/01/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
          pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
          pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: ""
     }), _defineProperty(_state, 'st_rs06', {
          hs: 0, cd: 0, ce: 0, hr: 0, sc: 0,
          aciertos: 0,
          percentilHS: 0, rangoHS: ""
     }), _defineProperty(_state, 'st_ev07', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/01/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
          pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
          pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: ""
     }), _defineProperty(_state, 'st_rs07', {
          rango: 0, resta: 0,
          aciertos: 0, errores: 0,
          genero: ""
     }), _defineProperty(_state, 'st_ev08', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/02/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: "", pg002: "", pg003: new Date(), pg004: 0, pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
          pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
          pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
          pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
          pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: "", pg049: "", pg050: "",
          pg051: "", pg052: "", pg053: "", pg054: "", pg055: "", pg056: "", pg057: "", pg058: "", pg059: "", pg060: "",
          pg061: "", pg062: "", pg063: "", pg064: "", pg065: "", pg066: "", pg067: "", pg068: "", pg069: "", pg070: "",
          pg071: "", pg072: "", pg073: "", pg074: "", pg075: "", pg076: "", pg077: "", pg078: "", pg079: "", pg080: "",
          pg081: "", pg082: "", pg083: "", pg084: "", pg085: "", pg086: "", pg087: "", pg088: "", pg089: "", pg090: "",
          pg091: "", pg092: "", pg093: "", pg094: "", pg095: "", pg096: "", pg097: "", pg098: "", pg099: "", pg100: "",
          pg101: "", pg102: "", pg103: "", pg104: "", pg105: "", pg106: "", pg107: "", pg108: "", pg109: "", pg110: "",
          pg111: "", pg112: "", pg113: "", pg114: "", pg115: "", pg116: "", pg117: "", pg118: "", pg119: "", pg120: "",
          pg121: "", pg122: "", pg123: "", pg124: "", pg125: "", pg126: "", pg127: "", pg128: "", pg129: "", pg130: "",
          pg131: "", pg132: "", pg133: "", pg134: "", pg135: "", pg136: "", pg137: "", pg138: "", pg139: "", pg140: "",
          pg141: "", pg142: "", pg143: "", pg144: "", pg145: "", pg146: "", pg147: "", pg148: "", pg149: "", pg150: "",
          pg151: "", pg152: "", pg153: "", pg154: "", pg155: "", pg156: "", pg157: "", pg158: "", pg159: "", pg160: "",
          pg161: "", pg162: "", pg163: "", pg164: "", pg165: "", pg166: "", pg167: "", pg168: "", pg169: "", pg170: "",
          pg171: "", pg172: "", pg173: "", pg174: "", pg175: "", pg176: "", pg177: "", pg178: "", pg179: "", pg180: "",
          pg181: "", pg182: "", pg183: "", pg184: "", pg185: "", pg186: "", pg187: "", pg188: "", pg189: "", pg190: "",
          pg191: "", pg192: "", pg193: "", pg194: "", pg195: "", pg196: "", pg197: "", pg198: "", pg199: "", pg200: "",
          pg201: "", pg202: "", pg203: "", pg204: "", pg205: "", pg206: "", pg207: ""
     }), _defineProperty(_state, 'st_rs08', {
          rango: 0, resta: 0,
          aciertos: 0, errores: 0,
          genero: ""
     }), _defineProperty(_state, 'st_ev09', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/02/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
          pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
          pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
          pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
          pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0
     }), _defineProperty(_state, 'st_rs09', {
          autocon_A: 0, autocon_B: 0, autocon: 0,
          emocion_A: 0, emocion_B: 0, emocion: 0,
          motivacion_A: 0, motivacion_B: 0, motivacion: 0,
          relacionarse_A: 0, relacionarse_B: 0, relacionarse: 0,
          asesoria_A: 0, asesoria_B: 0, asesoria: 0
     }), _defineProperty(_state, 'st_ev10', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/01/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
          pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
          pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
          pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
          pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0, pg049: 0, pg050: 0,
          pg051: 0, pg052: 0, pg053: 0, pg054: 0, pg055: 0, pg056: 0, pg057: 0, pg058: 0, pg059: 0, pg060: 0,
          pg061: 0, pg062: 0, pg063: 0, pg064: 0, pg065: 0, pg066: 0, pg067: 0, pg068: 0, pg069: 0, pg070: 0,
          pg071: 0, pg072: 0, pg073: 0, pg074: 0, pg075: 0, pg076: 0, pg077: 0, pg078: 0, pg079: 0, pg080: 0,
          pg081: 0, pg082: 0, pg083: 0, pg084: 0, pg085: 0, pg086: 0, pg087: 0
     }), _defineProperty(_state, 'st_ev12', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/01/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
          pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
          pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
          pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
          pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: "", pg049: "", pg050: "",
          pg051: "", pg052: "", pg053: "", pg054: "", pg055: "", pg056: "", pg057: "", pg058: "", pg059: "", pg060: "",
          pg061: "", pg062: "", pg063: "", pg064: "", pg065: "", pg066: "", pg067: "", pg068: "", pg069: "", pg070: "",
          pg071: "", pg072: "", pg073: "", pg074: "",
          pg074b: "", pg074c: "", pg074d: "", pg074e: "", pg074f: "", pg074g: "", pg074h: "", pg074i: "",
          pg075: "", pg076: "", pg077: "", pg078: "", pg079: "", pg080: "",
          pg081: "", pg082: "", pg083: "", pg084: "", pg085: "", pg086: "", pg087: "", pg088: "", pg089: "", pg090: "",
          pg091: "", pg092: "", pg093: "", pg094: "", pg095: "", pg096: "", pg097: "", pg098: "", pg099: "", pg100: "",
          pg101: "", pg102: "", pg103: "", pg104: "", pg105: "", pg106: "", pg107: "", pg108: "", pg109: "", pg110: "",
          pg111: "", pg112: "", pg113: "", pg114: "", pg115: "", pg116: "", pg117: "", pg118: "", pg119: "", pg120: "",
          pg121: "", pg122: "", pg123: "", pg124: "", pg125: "", pg126: "", pg127: "", pg128: "", pg129: "", pg130: "",
          pg131: "", pg132: "", pg133: "", pg134: "", pg135: "", pg136: "", pg137: "", pg138: "", pg139: "", pg140: "",
          pg141: "", pg142: "", pg143: "", pg144: "", pg145: "", pg146: "", pg147: "", pg148: "", pg149: "", pg150: "",
          pg151: "", pg152: "", pg153: "", pg154: "", pg155: "", pg156: "", pg157: "", pg158: "", pg159: "", pg160: "",
          pg161: "", pg162: "", pg163: "", pg164: "", pg165: "", pg166: "", pg167: "", pg168: "", pg169: "", pg170: "",
          pg171: "", pg172: "", pg173: "", pg174: "", pg175: "", pg176: "", pg177: "", pg178: "", pg179: "", pg180: "",
          pg181: "", pg182: "", pg183: "", pg184: "", pg185: "", pg186: "", pg187: "", pg188: "", pg189: "", pg190: "",
          pg191: "", pg192: "", pg193: "", pg194: "", pg195: "", pg196: "", pg197: "", pg198: "", pg199: "", pg200: "",
          pg201: "", pg202: "", pg203: "", pg204: "", pg205: "", pg206: "", pg207: "", pg208: "", pg209: "", pg210: "",
          pg211: "", pg212: "", pg213: "", pg214: "", pg215: "", pg216: "", pg217: "", pg218: "", pg219: "", pg220: "",
          pg221: "", pg222: "", pg223: "", pg224: "", pg225: "", pg226: "", pg227: "", pg228: "", pg229: "", pg230: "",
          pg231: "", pg232: "", pg233: "", pg234: "", pg235: "", pg236: "", pg237: "", pg238: "", pg239: "", pg240: "",
          pg241: "", pg242: "", pg243: "", pg244: "", pg245: "", pg246: "", pg247: "", pg248: "", pg249: "", pg250: "",
          pg251: "", pg252: "", pg253: "", pg254: "", pg255: "", pg256: "", pg257: "", pg258: "", pg259: "", pg260: ""
     }), _defineProperty(_state, 'st_rs12', {
          grupo1: 0, grupo2: 0, grupo3: 0, grupo4: 0,
          grupo5: 0, grupo6: 0, grupo7: 0, grupo8: 0,
          grupo9: 0, grupo10: 0, grupo11: 0, grupo12: 0,
          grupo13: 0, grupo14: 0, grupo15: 0, grupo16: 0,
          grupo17: 0, grupo18: 0, grupo19: 0, grupo20: 0,
          grupo21: 0,
          grupoCol: 0
     }), _defineProperty(_state, 'st_rs10', {
          grupo1: 0, grupo2: 0, grupo3: 0, grupo4: 0,
          grupo5: 0, grupo6: 0, grupo7: 0, grupo8: 0,
          grupoR: 0, grupoA: 0, grupoCol: 0
     }), _defineProperty(_state, 'st_ev11', {
          depto: "Guatemala",
          empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
          fecha: "16/01/2019", sexo: "",
          empezo: "10am", termino: "12am",
          pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
          pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
          pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
          pg02a: "", pg017a: "", pg018a: "", pg019a: ""
     }), _defineProperty(_state, 'st_rs11', {}), _defineProperty(_state, 'st_urlfoto', ""), _defineProperty(_state, 'st_urlcv', ""), _state),
     getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* getters */],
     mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* mutations */] // mutations
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.17
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.17';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
}

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
}

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
}

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
}

var modules$1 = [
  klass$1,
  style$1,
  model$2
]

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
}

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
}

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8), __webpack_require__(56).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Materialize v1.0.0 (http://materializecss.com)
 * Copyright 2014-2017 Materialize
 * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)
 */
var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*! cash-dom 1.3.5, https://github.com/kenwheeler/cash @license MIT */
(function (factory) {
  window.cash = factory();
})(function () {
  var doc = document,
      win = window,
      ArrayProto = Array.prototype,
      slice = ArrayProto.slice,
      filter = ArrayProto.filter,
      push = ArrayProto.push;

  var noop = function () {},
      isFunction = function (item) {
    // @see https://crbug.com/568448
    return typeof item === typeof noop && item.call;
  },
      isString = function (item) {
    return typeof item === typeof "";
  };

  var idMatch = /^#[\w-]*$/,
      classMatch = /^\.[\w-]*$/,
      htmlMatch = /<.+>/,
      singlet = /^\w+$/;

  function find(selector, context) {
    context = context || doc;
    var elems = classMatch.test(selector) ? context.getElementsByClassName(selector.slice(1)) : singlet.test(selector) ? context.getElementsByTagName(selector) : context.querySelectorAll(selector);
    return elems;
  }

  var frag;
  function parseHTML(str) {
    if (!frag) {
      frag = doc.implementation.createHTMLDocument(null);
      var base = frag.createElement("base");
      base.href = doc.location.href;
      frag.head.appendChild(base);
    }

    frag.body.innerHTML = str;

    return frag.body.childNodes;
  }

  function onReady(fn) {
    if (doc.readyState !== "loading") {
      fn();
    } else {
      doc.addEventListener("DOMContentLoaded", fn);
    }
  }

  function Init(selector, context) {
    if (!selector) {
      return this;
    }

    // If already a cash collection, don't do any further processing
    if (selector.cash && selector !== win) {
      return selector;
    }

    var elems = selector,
        i = 0,
        length;

    if (isString(selector)) {
      elems = idMatch.test(selector) ?
      // If an ID use the faster getElementById check
      doc.getElementById(selector.slice(1)) : htmlMatch.test(selector) ?
      // If HTML, parse it into real elements
      parseHTML(selector) :
      // else use `find`
      find(selector, context);

      // If function, use as shortcut for DOM ready
    } else if (isFunction(selector)) {
      onReady(selector);return this;
    }

    if (!elems) {
      return this;
    }

    // If a single DOM element is passed in or received via ID, return the single element
    if (elems.nodeType || elems === win) {
      this[0] = elems;
      this.length = 1;
    } else {
      // Treat like an array and loop through each item.
      length = this.length = elems.length;
      for (; i < length; i++) {
        this[i] = elems[i];
      }
    }

    return this;
  }

  function cash(selector, context) {
    return new Init(selector, context);
  }

  var fn = cash.fn = cash.prototype = Init.prototype = { // jshint ignore:line
    cash: true,
    length: 0,
    push: push,
    splice: ArrayProto.splice,
    map: ArrayProto.map,
    init: Init
  };

  Object.defineProperty(fn, "constructor", { value: cash });

  cash.parseHTML = parseHTML;
  cash.noop = noop;
  cash.isFunction = isFunction;
  cash.isString = isString;

  cash.extend = fn.extend = function (target) {
    target = target || {};

    var args = slice.call(arguments),
        length = args.length,
        i = 1;

    if (args.length === 1) {
      target = this;
      i = 0;
    }

    for (; i < length; i++) {
      if (!args[i]) {
        continue;
      }
      for (var key in args[i]) {
        if (args[i].hasOwnProperty(key)) {
          target[key] = args[i][key];
        }
      }
    }

    return target;
  };

  function each(collection, callback) {
    var l = collection.length,
        i = 0;

    for (; i < l; i++) {
      if (callback.call(collection[i], collection[i], i, collection) === false) {
        break;
      }
    }
  }

  function matches(el, selector) {
    var m = el && (el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector || el.oMatchesSelector);
    return !!m && m.call(el, selector);
  }

  function getCompareFunction(selector) {
    return (
      /* Use browser's `matches` function if string */
      isString(selector) ? matches :
      /* Match a cash element */
      selector.cash ? function (el) {
        return selector.is(el);
      } :
      /* Direct comparison */
      function (el, selector) {
        return el === selector;
      }
    );
  }

  function unique(collection) {
    return cash(slice.call(collection).filter(function (item, index, self) {
      return self.indexOf(item) === index;
    }));
  }

  cash.extend({
    merge: function (first, second) {
      var len = +second.length,
          i = first.length,
          j = 0;

      for (; j < len; i++, j++) {
        first[i] = second[j];
      }

      first.length = i;
      return first;
    },

    each: each,
    matches: matches,
    unique: unique,
    isArray: Array.isArray,
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

  });

  var uid = cash.uid = "_cash" + Date.now();

  function getDataCache(node) {
    return node[uid] = node[uid] || {};
  }

  function setData(node, key, value) {
    return getDataCache(node)[key] = value;
  }

  function getData(node, key) {
    var c = getDataCache(node);
    if (c[key] === undefined) {
      c[key] = node.dataset ? node.dataset[key] : cash(node).attr("data-" + key);
    }
    return c[key];
  }

  function removeData(node, key) {
    var c = getDataCache(node);
    if (c) {
      delete c[key];
    } else if (node.dataset) {
      delete node.dataset[key];
    } else {
      cash(node).removeAttr("data-" + name);
    }
  }

  fn.extend({
    data: function (name, value) {
      if (isString(name)) {
        return value === undefined ? getData(this[0], name) : this.each(function (v) {
          return setData(v, name, value);
        });
      }

      for (var key in name) {
        this.data(key, name[key]);
      }

      return this;
    },

    removeData: function (key) {
      return this.each(function (v) {
        return removeData(v, key);
      });
    }

  });

  var notWhiteMatch = /\S+/g;

  function getClasses(c) {
    return isString(c) && c.match(notWhiteMatch);
  }

  function hasClass(v, c) {
    return v.classList ? v.classList.contains(c) : new RegExp("(^| )" + c + "( |$)", "gi").test(v.className);
  }

  function addClass(v, c, spacedName) {
    if (v.classList) {
      v.classList.add(c);
    } else if (spacedName.indexOf(" " + c + " ")) {
      v.className += " " + c;
    }
  }

  function removeClass(v, c) {
    if (v.classList) {
      v.classList.remove(c);
    } else {
      v.className = v.className.replace(c, "");
    }
  }

  fn.extend({
    addClass: function (c) {
      var classes = getClasses(c);

      return classes ? this.each(function (v) {
        var spacedName = " " + v.className + " ";
        each(classes, function (c) {
          addClass(v, c, spacedName);
        });
      }) : this;
    },

    attr: function (name, value) {
      if (!name) {
        return undefined;
      }

      if (isString(name)) {
        if (value === undefined) {
          return this[0] ? this[0].getAttribute ? this[0].getAttribute(name) : this[0][name] : undefined;
        }

        return this.each(function (v) {
          if (v.setAttribute) {
            v.setAttribute(name, value);
          } else {
            v[name] = value;
          }
        });
      }

      for (var key in name) {
        this.attr(key, name[key]);
      }

      return this;
    },

    hasClass: function (c) {
      var check = false,
          classes = getClasses(c);
      if (classes && classes.length) {
        this.each(function (v) {
          check = hasClass(v, classes[0]);
          return !check;
        });
      }
      return check;
    },

    prop: function (name, value) {
      if (isString(name)) {
        return value === undefined ? this[0][name] : this.each(function (v) {
          v[name] = value;
        });
      }

      for (var key in name) {
        this.prop(key, name[key]);
      }

      return this;
    },

    removeAttr: function (name) {
      return this.each(function (v) {
        if (v.removeAttribute) {
          v.removeAttribute(name);
        } else {
          delete v[name];
        }
      });
    },

    removeClass: function (c) {
      if (!arguments.length) {
        return this.attr("class", "");
      }
      var classes = getClasses(c);
      return classes ? this.each(function (v) {
        each(classes, function (c) {
          removeClass(v, c);
        });
      }) : this;
    },

    removeProp: function (name) {
      return this.each(function (v) {
        delete v[name];
      });
    },

    toggleClass: function (c, state) {
      if (state !== undefined) {
        return this[state ? "addClass" : "removeClass"](c);
      }
      var classes = getClasses(c);
      return classes ? this.each(function (v) {
        var spacedName = " " + v.className + " ";
        each(classes, function (c) {
          if (hasClass(v, c)) {
            removeClass(v, c);
          } else {
            addClass(v, c, spacedName);
          }
        });
      }) : this;
    } });

  fn.extend({
    add: function (selector, context) {
      return unique(cash.merge(this, cash(selector, context)));
    },

    each: function (callback) {
      each(this, callback);
      return this;
    },

    eq: function (index) {
      return cash(this.get(index));
    },

    filter: function (selector) {
      if (!selector) {
        return this;
      }

      var comparator = isFunction(selector) ? selector : getCompareFunction(selector);

      return cash(filter.call(this, function (e) {
        return comparator(e, selector);
      }));
    },

    first: function () {
      return this.eq(0);
    },

    get: function (index) {
      if (index === undefined) {
        return slice.call(this);
      }
      return index < 0 ? this[index + this.length] : this[index];
    },

    index: function (elem) {
      var child = elem ? cash(elem)[0] : this[0],
          collection = elem ? this : cash(child).parent().children();
      return slice.call(collection).indexOf(child);
    },

    last: function () {
      return this.eq(-1);
    }

  });

  var camelCase = function () {
    var camelRegex = /(?:^\w|[A-Z]|\b\w)/g,
        whiteSpace = /[\s-_]+/g;
    return function (str) {
      return str.replace(camelRegex, function (letter, index) {
        return letter[index === 0 ? "toLowerCase" : "toUpperCase"]();
      }).replace(whiteSpace, "");
    };
  }();

  var getPrefixedProp = function () {
    var cache = {},
        doc = document,
        div = doc.createElement("div"),
        style = div.style;

    return function (prop) {
      prop = camelCase(prop);
      if (cache[prop]) {
        return cache[prop];
      }

      var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
          prefixes = ["webkit", "moz", "ms", "o"],
          props = (prop + " " + prefixes.join(ucProp + " ") + ucProp).split(" ");

      each(props, function (p) {
        if (p in style) {
          cache[p] = prop = cache[prop] = p;
          return false;
        }
      });

      return cache[prop];
    };
  }();

  cash.prefixedProp = getPrefixedProp;
  cash.camelCase = camelCase;

  fn.extend({
    css: function (prop, value) {
      if (isString(prop)) {
        prop = getPrefixedProp(prop);
        return arguments.length > 1 ? this.each(function (v) {
          return v.style[prop] = value;
        }) : win.getComputedStyle(this[0])[prop];
      }

      for (var key in prop) {
        this.css(key, prop[key]);
      }

      return this;
    }

  });

  function compute(el, prop) {
    return parseInt(win.getComputedStyle(el[0], null)[prop], 10) || 0;
  }

  each(["Width", "Height"], function (v) {
    var lower = v.toLowerCase();

    fn[lower] = function () {
      return this[0].getBoundingClientRect()[lower];
    };

    fn["inner" + v] = function () {
      return this[0]["client" + v];
    };

    fn["outer" + v] = function (margins) {
      return this[0]["offset" + v] + (margins ? compute(this, "margin" + (v === "Width" ? "Left" : "Top")) + compute(this, "margin" + (v === "Width" ? "Right" : "Bottom")) : 0);
    };
  });

  function registerEvent(node, eventName, callback) {
    var eventCache = getData(node, "_cashEvents") || setData(node, "_cashEvents", {});
    eventCache[eventName] = eventCache[eventName] || [];
    eventCache[eventName].push(callback);
    node.addEventListener(eventName, callback);
  }

  function removeEvent(node, eventName, callback) {
    var events = getData(node, "_cashEvents"),
        eventCache = events && events[eventName],
        index;

    if (!eventCache) {
      return;
    }

    if (callback) {
      node.removeEventListener(eventName, callback);
      index = eventCache.indexOf(callback);
      if (index >= 0) {
        eventCache.splice(index, 1);
      }
    } else {
      each(eventCache, function (event) {
        node.removeEventListener(eventName, event);
      });
      eventCache = [];
    }
  }

  fn.extend({
    off: function (eventName, callback) {
      return this.each(function (v) {
        return removeEvent(v, eventName, callback);
      });
    },

    on: function (eventName, delegate, callback, runOnce) {
      // jshint ignore:line
      var originalCallback;
      if (!isString(eventName)) {
        for (var key in eventName) {
          this.on(key, delegate, eventName[key]);
        }
        return this;
      }

      if (isFunction(delegate)) {
        callback = delegate;
        delegate = null;
      }

      if (eventName === "ready") {
        onReady(callback);
        return this;
      }

      if (delegate) {
        originalCallback = callback;
        callback = function (e) {
          var t = e.target;
          while (!matches(t, delegate)) {
            if (t === this || t === null) {
              return t = false;
            }

            t = t.parentNode;
          }

          if (t) {
            originalCallback.call(t, e);
          }
        };
      }

      return this.each(function (v) {
        var finalCallback = callback;
        if (runOnce) {
          finalCallback = function () {
            callback.apply(this, arguments);
            removeEvent(v, eventName, finalCallback);
          };
        }
        registerEvent(v, eventName, finalCallback);
      });
    },

    one: function (eventName, delegate, callback) {
      return this.on(eventName, delegate, callback, true);
    },

    ready: onReady,

    /**
     * Modified
     * Triggers browser event
     * @param String eventName
     * @param Object data - Add properties to event object
     */
    trigger: function (eventName, data) {
      if (document.createEvent) {
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent(eventName, true, false);
        evt = this.extend(evt, data);
        return this.each(function (v) {
          return v.dispatchEvent(evt);
        });
      }
    }

  });

  function encode(name, value) {
    return "&" + encodeURIComponent(name) + "=" + encodeURIComponent(value).replace(/%20/g, "+");
  }

  function getSelectMultiple_(el) {
    var values = [];
    each(el.options, function (o) {
      if (o.selected) {
        values.push(o.value);
      }
    });
    return values.length ? values : null;
  }

  function getSelectSingle_(el) {
    var selectedIndex = el.selectedIndex;
    return selectedIndex >= 0 ? el.options[selectedIndex].value : null;
  }

  function getValue(el) {
    var type = el.type;
    if (!type) {
      return null;
    }
    switch (type.toLowerCase()) {
      case "select-one":
        return getSelectSingle_(el);
      case "select-multiple":
        return getSelectMultiple_(el);
      case "radio":
        return el.checked ? el.value : null;
      case "checkbox":
        return el.checked ? el.value : null;
      default:
        return el.value ? el.value : null;
    }
  }

  fn.extend({
    serialize: function () {
      var query = "";

      each(this[0].elements || this, function (el) {
        if (el.disabled || el.tagName === "FIELDSET") {
          return;
        }
        var name = el.name;
        switch (el.type.toLowerCase()) {
          case "file":
          case "reset":
          case "submit":
          case "button":
            break;
          case "select-multiple":
            var values = getValue(el);
            if (values !== null) {
              each(values, function (value) {
                query += encode(name, value);
              });
            }
            break;
          default:
            var value = getValue(el);
            if (value !== null) {
              query += encode(name, value);
            }
        }
      });

      return query.substr(1);
    },

    val: function (value) {
      if (value === undefined) {
        return getValue(this[0]);
      }

      return this.each(function (v) {
        return v.value = value;
      });
    }

  });

  function insertElement(el, child, prepend) {
    if (prepend) {
      var first = el.childNodes[0];
      el.insertBefore(child, first);
    } else {
      el.appendChild(child);
    }
  }

  function insertContent(parent, child, prepend) {
    var str = isString(child);

    if (!str && child.length) {
      each(child, function (v) {
        return insertContent(parent, v, prepend);
      });
      return;
    }

    each(parent, str ? function (v) {
      return v.insertAdjacentHTML(prepend ? "afterbegin" : "beforeend", child);
    } : function (v, i) {
      return insertElement(v, i === 0 ? child : child.cloneNode(true), prepend);
    });
  }

  fn.extend({
    after: function (selector) {
      cash(selector).insertAfter(this);
      return this;
    },

    append: function (content) {
      insertContent(this, content);
      return this;
    },

    appendTo: function (parent) {
      insertContent(cash(parent), this);
      return this;
    },

    before: function (selector) {
      cash(selector).insertBefore(this);
      return this;
    },

    clone: function () {
      return cash(this.map(function (v) {
        return v.cloneNode(true);
      }));
    },

    empty: function () {
      this.html("");
      return this;
    },

    html: function (content) {
      if (content === undefined) {
        return this[0].innerHTML;
      }
      var source = content.nodeType ? content[0].outerHTML : content;
      return this.each(function (v) {
        return v.innerHTML = source;
      });
    },

    insertAfter: function (selector) {
      var _this = this;

      cash(selector).each(function (el, i) {
        var parent = el.parentNode,
            sibling = el.nextSibling;
        _this.each(function (v) {
          parent.insertBefore(i === 0 ? v : v.cloneNode(true), sibling);
        });
      });

      return this;
    },

    insertBefore: function (selector) {
      var _this2 = this;
      cash(selector).each(function (el, i) {
        var parent = el.parentNode;
        _this2.each(function (v) {
          parent.insertBefore(i === 0 ? v : v.cloneNode(true), el);
        });
      });
      return this;
    },

    prepend: function (content) {
      insertContent(this, content, true);
      return this;
    },

    prependTo: function (parent) {
      insertContent(cash(parent), this, true);
      return this;
    },

    remove: function () {
      return this.each(function (v) {
        if (!!v.parentNode) {
          return v.parentNode.removeChild(v);
        }
      });
    },

    text: function (content) {
      if (content === undefined) {
        return this[0].textContent;
      }
      return this.each(function (v) {
        return v.textContent = content;
      });
    }

  });

  var docEl = doc.documentElement;

  fn.extend({
    position: function () {
      var el = this[0];
      return {
        left: el.offsetLeft,
        top: el.offsetTop
      };
    },

    offset: function () {
      var rect = this[0].getBoundingClientRect();
      return {
        top: rect.top + win.pageYOffset - docEl.clientTop,
        left: rect.left + win.pageXOffset - docEl.clientLeft
      };
    },

    offsetParent: function () {
      return cash(this[0].offsetParent);
    }

  });

  fn.extend({
    children: function (selector) {
      var elems = [];
      this.each(function (el) {
        push.apply(elems, el.children);
      });
      elems = unique(elems);

      return !selector ? elems : elems.filter(function (v) {
        return matches(v, selector);
      });
    },

    closest: function (selector) {
      if (!selector || this.length < 1) {
        return cash();
      }
      if (this.is(selector)) {
        return this.filter(selector);
      }
      return this.parent().closest(selector);
    },

    is: function (selector) {
      if (!selector) {
        return false;
      }

      var match = false,
          comparator = getCompareFunction(selector);

      this.each(function (el) {
        match = comparator(el, selector);
        return !match;
      });

      return match;
    },

    find: function (selector) {
      if (!selector || selector.nodeType) {
        return cash(selector && this.has(selector).length ? selector : null);
      }

      var elems = [];
      this.each(function (el) {
        push.apply(elems, find(selector, el));
      });

      return unique(elems);
    },

    has: function (selector) {
      var comparator = isString(selector) ? function (el) {
        return find(selector, el).length !== 0;
      } : function (el) {
        return el.contains(selector);
      };

      return this.filter(comparator);
    },

    next: function () {
      return cash(this[0].nextElementSibling);
    },

    not: function (selector) {
      if (!selector) {
        return this;
      }

      var comparator = getCompareFunction(selector);

      return this.filter(function (el) {
        return !comparator(el, selector);
      });
    },

    parent: function () {
      var result = [];

      this.each(function (item) {
        if (item && item.parentNode) {
          result.push(item.parentNode);
        }
      });

      return unique(result);
    },

    parents: function (selector) {
      var last,
          result = [];

      this.each(function (item) {
        last = item;

        while (last && last.parentNode && last !== doc.body.parentNode) {
          last = last.parentNode;

          if (!selector || selector && matches(last, selector)) {
            result.push(last);
          }
        }
      });

      return unique(result);
    },

    prev: function () {
      return cash(this[0].previousElementSibling);
    },

    siblings: function (selector) {
      var collection = this.parent().children(selector),
          el = this[0];

      return collection.filter(function (i) {
        return i !== el;
      });
    }

  });

  return cash;
});
;
var Component = function () {
  /**
   * Generic constructor for all components
   * @constructor
   * @param {Element} el
   * @param {Object} options
   */
  function Component(classDef, el, options) {
    _classCallCheck(this, Component);

    // Display error if el is valid HTML Element
    if (!(el instanceof Element)) {
      console.error(Error(el + ' is not an HTML Element'));
    }

    // If exists, destroy and reinitialize in child
    var ins = classDef.getInstance(el);
    if (!!ins) {
      ins.destroy();
    }

    this.el = el;
    this.$el = cash(el);
  }

  /**
   * Initializes components
   * @param {class} classDef
   * @param {Element | NodeList | jQuery} els
   * @param {Object} options
   */


  _createClass(Component, null, [{
    key: "init",
    value: function init(classDef, els, options) {
      var instances = null;
      if (els instanceof Element) {
        instances = new classDef(els, options);
      } else if (!!els && (els.jquery || els.cash || els instanceof NodeList)) {
        var instancesArr = [];
        for (var i = 0; i < els.length; i++) {
          instancesArr.push(new classDef(els[i], options));
        }
        instances = instancesArr;
      }

      return instances;
    }
  }]);

  return Component;
}();

; // Required for Meteor package, the use of window prevents export by Meteor
(function (window) {
  if (window.Package) {
    M = {};
  } else {
    window.M = {};
  }

  // Check for jQuery
  M.jQueryLoaded = !!window.jQuery;
})(window);

// AMD
if (true) {
  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return M;
  }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Common JS
} else if (typeof exports !== 'undefined' && !exports.nodeType) {
  if (typeof module !== 'undefined' && !module.nodeType && module.exports) {
    exports = module.exports = M;
  }
  exports.default = M;
}

M.version = '1.0.0';

M.keys = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  ARROW_UP: 38,
  ARROW_DOWN: 40
};

/**
 * TabPress Keydown handler
 */
M.tabPressed = false;
M.keyDown = false;
var docHandleKeydown = function (e) {
  M.keyDown = true;
  if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) {
    M.tabPressed = true;
  }
};
var docHandleKeyup = function (e) {
  M.keyDown = false;
  if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) {
    M.tabPressed = false;
  }
};
var docHandleFocus = function (e) {
  if (M.keyDown) {
    document.body.classList.add('keyboard-focused');
  }
};
var docHandleBlur = function (e) {
  document.body.classList.remove('keyboard-focused');
};
document.addEventListener('keydown', docHandleKeydown, true);
document.addEventListener('keyup', docHandleKeyup, true);
document.addEventListener('focus', docHandleFocus, true);
document.addEventListener('blur', docHandleBlur, true);

/**
 * Initialize jQuery wrapper for plugin
 * @param {Class} plugin  javascript class
 * @param {string} pluginName  jQuery plugin name
 * @param {string} classRef  Class reference name
 */
M.initializeJqueryWrapper = function (plugin, pluginName, classRef) {
  jQuery.fn[pluginName] = function (methodOrOptions) {
    // Call plugin method if valid method name is passed in
    if (plugin.prototype[methodOrOptions]) {
      var params = Array.prototype.slice.call(arguments, 1);

      // Getter methods
      if (methodOrOptions.slice(0, 3) === 'get') {
        var instance = this.first()[0][classRef];
        return instance[methodOrOptions].apply(instance, params);
      }

      // Void methods
      return this.each(function () {
        var instance = this[classRef];
        instance[methodOrOptions].apply(instance, params);
      });

      // Initialize plugin if options or no argument is passed in
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      plugin.init(this, arguments[0]);
      return this;
    }

    // Return error if an unrecognized  method name is passed in
    jQuery.error("Method " + methodOrOptions + " does not exist on jQuery." + pluginName);
  };
};

/**
 * Automatically initialize components
 * @param {Element} context  DOM Element to search within for components
 */
M.AutoInit = function (context) {
  // Use document.body if no context is given
  var root = !!context ? context : document.body;

  var registry = {
    Autocomplete: root.querySelectorAll('.autocomplete:not(.no-autoinit)'),
    Carousel: root.querySelectorAll('.carousel:not(.no-autoinit)'),
    Chips: root.querySelectorAll('.chips:not(.no-autoinit)'),
    Collapsible: root.querySelectorAll('.collapsible:not(.no-autoinit)'),
    Datepicker: root.querySelectorAll('.datepicker:not(.no-autoinit)'),
    Dropdown: root.querySelectorAll('.dropdown-trigger:not(.no-autoinit)'),
    Materialbox: root.querySelectorAll('.materialboxed:not(.no-autoinit)'),
    Modal: root.querySelectorAll('.modal:not(.no-autoinit)'),
    Parallax: root.querySelectorAll('.parallax:not(.no-autoinit)'),
    Pushpin: root.querySelectorAll('.pushpin:not(.no-autoinit)'),
    ScrollSpy: root.querySelectorAll('.scrollspy:not(.no-autoinit)'),
    FormSelect: root.querySelectorAll('select:not(.no-autoinit)'),
    Sidenav: root.querySelectorAll('.sidenav:not(.no-autoinit)'),
    Tabs: root.querySelectorAll('.tabs:not(.no-autoinit)'),
    TapTarget: root.querySelectorAll('.tap-target:not(.no-autoinit)'),
    Timepicker: root.querySelectorAll('.timepicker:not(.no-autoinit)'),
    Tooltip: root.querySelectorAll('.tooltipped:not(.no-autoinit)'),
    FloatingActionButton: root.querySelectorAll('.fixed-action-btn:not(.no-autoinit)')
  };

  for (var pluginName in registry) {
    var plugin = M[pluginName];
    plugin.init(registry[pluginName]);
  }
};

/**
 * Generate approximated selector string for a jQuery object
 * @param {jQuery} obj  jQuery object to be parsed
 * @returns {string}
 */
M.objectSelectorString = function (obj) {
  var tagStr = obj.prop('tagName') || '';
  var idStr = obj.attr('id') || '';
  var classStr = obj.attr('class') || '';
  return (tagStr + idStr + classStr).replace(/\s/g, '');
};

// Unique Random ID
M.guid = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  };
}();

/**
 * Escapes hash from special characters
 * @param {string} hash  String returned from this.hash
 * @returns {string}
 */
M.escapeHash = function (hash) {
  return hash.replace(/(:|\.|\[|\]|,|=|\/)/g, '\\$1');
};

M.elementOrParentIsFixed = function (element) {
  var $element = $(element);
  var $checkElements = $element.add($element.parents());
  var isFixed = false;
  $checkElements.each(function () {
    if ($(this).css('position') === 'fixed') {
      isFixed = true;
      return false;
    }
  });
  return isFixed;
};

/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */

/**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */

/**
 * Escapes hash from special characters
 * @param {Element} container  Container element that acts as the boundary
 * @param {Bounding} bounding  element bounding that is being checked
 * @param {Number} offset  offset from edge that counts as exceeding
 * @returns {Edges}
 */
M.checkWithinContainer = function (container, bounding, offset) {
  var edges = {
    top: false,
    right: false,
    bottom: false,
    left: false
  };

  var containerRect = container.getBoundingClientRect();
  // If body element is smaller than viewport, use viewport height instead.
  var containerBottom = container === document.body ? Math.max(containerRect.bottom, window.innerHeight) : containerRect.bottom;

  var scrollLeft = container.scrollLeft;
  var scrollTop = container.scrollTop;

  var scrolledX = bounding.left - scrollLeft;
  var scrolledY = bounding.top - scrollTop;

  // Check for container and viewport for each edge
  if (scrolledX < containerRect.left + offset || scrolledX < offset) {
    edges.left = true;
  }

  if (scrolledX + bounding.width > containerRect.right - offset || scrolledX + bounding.width > window.innerWidth - offset) {
    edges.right = true;
  }

  if (scrolledY < containerRect.top + offset || scrolledY < offset) {
    edges.top = true;
  }

  if (scrolledY + bounding.height > containerBottom - offset || scrolledY + bounding.height > window.innerHeight - offset) {
    edges.bottom = true;
  }

  return edges;
};

M.checkPossibleAlignments = function (el, container, bounding, offset) {
  var canAlign = {
    top: true,
    right: true,
    bottom: true,
    left: true,
    spaceOnTop: null,
    spaceOnRight: null,
    spaceOnBottom: null,
    spaceOnLeft: null
  };

  var containerAllowsOverflow = getComputedStyle(container).overflow === 'visible';
  var containerRect = container.getBoundingClientRect();
  var containerHeight = Math.min(containerRect.height, window.innerHeight);
  var containerWidth = Math.min(containerRect.width, window.innerWidth);
  var elOffsetRect = el.getBoundingClientRect();

  var scrollLeft = container.scrollLeft;
  var scrollTop = container.scrollTop;

  var scrolledX = bounding.left - scrollLeft;
  var scrolledYTopEdge = bounding.top - scrollTop;
  var scrolledYBottomEdge = bounding.top + elOffsetRect.height - scrollTop;

  // Check for container and viewport for left
  canAlign.spaceOnRight = !containerAllowsOverflow ? containerWidth - (scrolledX + bounding.width) : window.innerWidth - (elOffsetRect.left + bounding.width);
  if (canAlign.spaceOnRight < 0) {
    canAlign.left = false;
  }

  // Check for container and viewport for Right
  canAlign.spaceOnLeft = !containerAllowsOverflow ? scrolledX - bounding.width + elOffsetRect.width : elOffsetRect.right - bounding.width;
  if (canAlign.spaceOnLeft < 0) {
    canAlign.right = false;
  }

  // Check for container and viewport for Top
  canAlign.spaceOnBottom = !containerAllowsOverflow ? containerHeight - (scrolledYTopEdge + bounding.height + offset) : window.innerHeight - (elOffsetRect.top + bounding.height + offset);
  if (canAlign.spaceOnBottom < 0) {
    canAlign.top = false;
  }

  // Check for container and viewport for Bottom
  canAlign.spaceOnTop = !containerAllowsOverflow ? scrolledYBottomEdge - (bounding.height - offset) : elOffsetRect.bottom - (bounding.height + offset);
  if (canAlign.spaceOnTop < 0) {
    canAlign.bottom = false;
  }

  return canAlign;
};

M.getOverflowParent = function (element) {
  if (element == null) {
    return null;
  }

  if (element === document.body || getComputedStyle(element).overflow !== 'visible') {
    return element;
  }

  return M.getOverflowParent(element.parentElement);
};

/**
 * Gets id of component from a trigger
 * @param {Element} trigger  trigger
 * @returns {string}
 */
M.getIdFromTrigger = function (trigger) {
  var id = trigger.getAttribute('data-target');
  if (!id) {
    id = trigger.getAttribute('href');
    if (id) {
      id = id.slice(1);
    } else {
      id = '';
    }
  }
  return id;
};

/**
 * Multi browser support for document scroll top
 * @returns {Number}
 */
M.getDocumentScrollTop = function () {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
};

/**
 * Multi browser support for document scroll left
 * @returns {Number}
 */
M.getDocumentScrollLeft = function () {
  return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
};

/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */

/**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */

/**
 * Get time in ms
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @type {function}
 * @return {number}
 */
var getTime = Date.now || function () {
  return new Date().getTime();
};

/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 * `{leading: false}`. To disable execution on the trailing edge, ditto.
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @param {function} func
 * @param {number} wait
 * @param {Object=} options
 * @returns {Function}
 */
M.throttle = function (func, wait, options) {
  var context = void 0,
      args = void 0,
      result = void 0;
  var timeout = null;
  var previous = 0;
  options || (options = {});
  var later = function () {
    previous = options.leading === false ? 0 : getTime();
    timeout = null;
    result = func.apply(context, args);
    context = args = null;
  };
  return function () {
    var now = getTime();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0) {
      clearTimeout(timeout);
      timeout = null;
      previous = now;
      result = func.apply(context, args);
      context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};
; /*
  v2.2.0
  2017 Julian Garnier
  Released under the MIT license
  */
var $jscomp = { scope: {} };$jscomp.defineProperty = "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, r, p) {
  if (p.get || p.set) throw new TypeError("ES3 does not support getters and setters.");e != Array.prototype && e != Object.prototype && (e[r] = p.value);
};$jscomp.getGlobal = function (e) {
  return "undefined" != typeof window && window === e ? e : "undefined" != typeof global && null != global ? global : e;
};$jscomp.global = $jscomp.getGlobal(this);$jscomp.SYMBOL_PREFIX = "jscomp_symbol_";
$jscomp.initSymbol = function () {
  $jscomp.initSymbol = function () {};$jscomp.global.Symbol || ($jscomp.global.Symbol = $jscomp.Symbol);
};$jscomp.symbolCounter_ = 0;$jscomp.Symbol = function (e) {
  return $jscomp.SYMBOL_PREFIX + (e || "") + $jscomp.symbolCounter_++;
};
$jscomp.initSymbolIterator = function () {
  $jscomp.initSymbol();var e = $jscomp.global.Symbol.iterator;e || (e = $jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator"));"function" != typeof Array.prototype[e] && $jscomp.defineProperty(Array.prototype, e, { configurable: !0, writable: !0, value: function () {
      return $jscomp.arrayIterator(this);
    } });$jscomp.initSymbolIterator = function () {};
};$jscomp.arrayIterator = function (e) {
  var r = 0;return $jscomp.iteratorPrototype(function () {
    return r < e.length ? { done: !1, value: e[r++] } : { done: !0 };
  });
};
$jscomp.iteratorPrototype = function (e) {
  $jscomp.initSymbolIterator();e = { next: e };e[$jscomp.global.Symbol.iterator] = function () {
    return this;
  };return e;
};$jscomp.array = $jscomp.array || {};$jscomp.iteratorFromArray = function (e, r) {
  $jscomp.initSymbolIterator();e instanceof String && (e += "");var p = 0,
      m = { next: function () {
      if (p < e.length) {
        var u = p++;return { value: r(u, e[u]), done: !1 };
      }m.next = function () {
        return { done: !0, value: void 0 };
      };return m.next();
    } };m[Symbol.iterator] = function () {
    return m;
  };return m;
};
$jscomp.polyfill = function (e, r, p, m) {
  if (r) {
    p = $jscomp.global;e = e.split(".");for (m = 0; m < e.length - 1; m++) {
      var u = e[m];u in p || (p[u] = {});p = p[u];
    }e = e[e.length - 1];m = p[e];r = r(m);r != m && null != r && $jscomp.defineProperty(p, e, { configurable: !0, writable: !0, value: r });
  }
};$jscomp.polyfill("Array.prototype.keys", function (e) {
  return e ? e : function () {
    return $jscomp.iteratorFromArray(this, function (e) {
      return e;
    });
  };
}, "es6-impl", "es3");var $jscomp$this = this;
(function (r) {
  M.anime = r();
})(function () {
  function e(a) {
    if (!h.col(a)) try {
      return document.querySelectorAll(a);
    } catch (c) {}
  }function r(a, c) {
    for (var d = a.length, b = 2 <= arguments.length ? arguments[1] : void 0, f = [], n = 0; n < d; n++) {
      if (n in a) {
        var k = a[n];c.call(b, k, n, a) && f.push(k);
      }
    }return f;
  }function p(a) {
    return a.reduce(function (a, d) {
      return a.concat(h.arr(d) ? p(d) : d);
    }, []);
  }function m(a) {
    if (h.arr(a)) return a;
    h.str(a) && (a = e(a) || a);return a instanceof NodeList || a instanceof HTMLCollection ? [].slice.call(a) : [a];
  }function u(a, c) {
    return a.some(function (a) {
      return a === c;
    });
  }function C(a) {
    var c = {},
        d;for (d in a) {
      c[d] = a[d];
    }return c;
  }function D(a, c) {
    var d = C(a),
        b;for (b in a) {
      d[b] = c.hasOwnProperty(b) ? c[b] : a[b];
    }return d;
  }function z(a, c) {
    var d = C(a),
        b;for (b in c) {
      d[b] = h.und(a[b]) ? c[b] : a[b];
    }return d;
  }function T(a) {
    a = a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (a, c, d, k) {
      return c + c + d + d + k + k;
    });var c = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);
    a = parseInt(c[1], 16);var d = parseInt(c[2], 16),
        c = parseInt(c[3], 16);return "rgba(" + a + "," + d + "," + c + ",1)";
  }function U(a) {
    function c(a, c, b) {
      0 > b && (b += 1);1 < b && --b;return b < 1 / 6 ? a + 6 * (c - a) * b : .5 > b ? c : b < 2 / 3 ? a + (c - a) * (2 / 3 - b) * 6 : a;
    }var d = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(a);a = parseInt(d[1]) / 360;var b = parseInt(d[2]) / 100,
        f = parseInt(d[3]) / 100,
        d = d[4] || 1;if (0 == b) f = b = a = f;else {
      var n = .5 > f ? f * (1 + b) : f + b - f * b,
          k = 2 * f - n,
          f = c(k, n, a + 1 / 3),
          b = c(k, n, a);a = c(k, n, a - 1 / 3);
    }return "rgba(" + 255 * f + "," + 255 * b + "," + 255 * a + "," + d + ")";
  }function y(a) {
    if (a = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(a)) return a[2];
  }function V(a) {
    if (-1 < a.indexOf("translate") || "perspective" === a) return "px";if (-1 < a.indexOf("rotate") || -1 < a.indexOf("skew")) return "deg";
  }function I(a, c) {
    return h.fnc(a) ? a(c.target, c.id, c.total) : a;
  }function E(a, c) {
    if (c in a.style) return getComputedStyle(a).getPropertyValue(c.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()) || "0";
  }function J(a, c) {
    if (h.dom(a) && u(W, c)) return "transform";if (h.dom(a) && (a.getAttribute(c) || h.svg(a) && a[c])) return "attribute";if (h.dom(a) && "transform" !== c && E(a, c)) return "css";if (null != a[c]) return "object";
  }function X(a, c) {
    var d = V(c),
        d = -1 < c.indexOf("scale") ? 1 : 0 + d;a = a.style.transform;if (!a) return d;for (var b = [], f = [], n = [], k = /(\w+)\((.+?)\)/g; b = k.exec(a);) {
      f.push(b[1]), n.push(b[2]);
    }a = r(n, function (a, b) {
      return f[b] === c;
    });return a.length ? a[0] : d;
  }function K(a, c) {
    switch (J(a, c)) {case "transform":
        return X(a, c);case "css":
        return E(a, c);case "attribute":
        return a.getAttribute(c);}return a[c] || 0;
  }function L(a, c) {
    var d = /^(\*=|\+=|-=)/.exec(a);if (!d) return a;var b = y(a) || 0;c = parseFloat(c);a = parseFloat(a.replace(d[0], ""));switch (d[0][0]) {case "+":
        return c + a + b;case "-":
        return c - a + b;case "*":
        return c * a + b;}
  }function F(a, c) {
    return Math.sqrt(Math.pow(c.x - a.x, 2) + Math.pow(c.y - a.y, 2));
  }function M(a) {
    a = a.points;for (var c = 0, d, b = 0; b < a.numberOfItems; b++) {
      var f = a.getItem(b);0 < b && (c += F(d, f));d = f;
    }return c;
  }function N(a) {
    if (a.getTotalLength) return a.getTotalLength();switch (a.tagName.toLowerCase()) {case "circle":
        return 2 * Math.PI * a.getAttribute("r");case "rect":
        return 2 * a.getAttribute("width") + 2 * a.getAttribute("height");case "line":
        return F({ x: a.getAttribute("x1"), y: a.getAttribute("y1") }, { x: a.getAttribute("x2"), y: a.getAttribute("y2") });case "polyline":
        return M(a);case "polygon":
        var c = a.points;return M(a) + F(c.getItem(c.numberOfItems - 1), c.getItem(0));}
  }function Y(a, c) {
    function d(b) {
      b = void 0 === b ? 0 : b;return a.el.getPointAtLength(1 <= c + b ? c + b : 0);
    }var b = d(),
        f = d(-1),
        n = d(1);switch (a.property) {case "x":
        return b.x;case "y":
        return b.y;
      case "angle":
        return 180 * Math.atan2(n.y - f.y, n.x - f.x) / Math.PI;}
  }function O(a, c) {
    var d = /-?\d*\.?\d+/g,
        b;b = h.pth(a) ? a.totalLength : a;if (h.col(b)) {
      if (h.rgb(b)) {
        var f = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(b);b = f ? "rgba(" + f[1] + ",1)" : b;
      } else b = h.hex(b) ? T(b) : h.hsl(b) ? U(b) : void 0;
    } else f = (f = y(b)) ? b.substr(0, b.length - f.length) : b, b = c && !/\s/g.test(b) ? f + c : f;b += "";return { original: b, numbers: b.match(d) ? b.match(d).map(Number) : [0], strings: h.str(a) || c ? b.split(d) : [] };
  }function P(a) {
    a = a ? p(h.arr(a) ? a.map(m) : m(a)) : [];return r(a, function (a, d, b) {
      return b.indexOf(a) === d;
    });
  }function Z(a) {
    var c = P(a);return c.map(function (a, b) {
      return { target: a, id: b, total: c.length };
    });
  }function aa(a, c) {
    var d = C(c);if (h.arr(a)) {
      var b = a.length;2 !== b || h.obj(a[0]) ? h.fnc(c.duration) || (d.duration = c.duration / b) : a = { value: a };
    }return m(a).map(function (a, b) {
      b = b ? 0 : c.delay;a = h.obj(a) && !h.pth(a) ? a : { value: a };h.und(a.delay) && (a.delay = b);return a;
    }).map(function (a) {
      return z(a, d);
    });
  }function ba(a, c) {
    var d = {},
        b;for (b in a) {
      var f = I(a[b], c);h.arr(f) && (f = f.map(function (a) {
        return I(a, c);
      }), 1 === f.length && (f = f[0]));d[b] = f;
    }d.duration = parseFloat(d.duration);d.delay = parseFloat(d.delay);return d;
  }function ca(a) {
    return h.arr(a) ? A.apply(this, a) : Q[a];
  }function da(a, c) {
    var d;return a.tweens.map(function (b) {
      b = ba(b, c);var f = b.value,
          e = K(c.target, a.name),
          k = d ? d.to.original : e,
          k = h.arr(f) ? f[0] : k,
          w = L(h.arr(f) ? f[1] : f, k),
          e = y(w) || y(k) || y(e);b.from = O(k, e);b.to = O(w, e);b.start = d ? d.end : a.offset;b.end = b.start + b.delay + b.duration;b.easing = ca(b.easing);b.elasticity = (1E3 - Math.min(Math.max(b.elasticity, 1), 999)) / 1E3;b.isPath = h.pth(f);b.isColor = h.col(b.from.original);b.isColor && (b.round = 1);return d = b;
    });
  }function ea(a, c) {
    return r(p(a.map(function (a) {
      return c.map(function (b) {
        var c = J(a.target, b.name);if (c) {
          var d = da(b, a);b = { type: c, property: b.name, animatable: a, tweens: d, duration: d[d.length - 1].end, delay: d[0].delay };
        } else b = void 0;return b;
      });
    })), function (a) {
      return !h.und(a);
    });
  }function R(a, c, d, b) {
    var f = "delay" === a;return c.length ? (f ? Math.min : Math.max).apply(Math, c.map(function (b) {
      return b[a];
    })) : f ? b.delay : d.offset + b.delay + b.duration;
  }function fa(a) {
    var c = D(ga, a),
        d = D(S, a),
        b = Z(a.targets),
        f = [],
        e = z(c, d),
        k;for (k in a) {
      e.hasOwnProperty(k) || "targets" === k || f.push({ name: k, offset: e.offset, tweens: aa(a[k], d) });
    }a = ea(b, f);return z(c, { children: [], animatables: b, animations: a, duration: R("duration", a, c, d), delay: R("delay", a, c, d) });
  }function q(a) {
    function c() {
      return window.Promise && new Promise(function (a) {
        return p = a;
      });
    }function d(a) {
      return g.reversed ? g.duration - a : a;
    }function b(a) {
      for (var b = 0, c = {}, d = g.animations, f = d.length; b < f;) {
        var e = d[b],
            k = e.animatable,
            h = e.tweens,
            n = h.length - 1,
            l = h[n];n && (l = r(h, function (b) {
          return a < b.end;
        })[0] || l);for (var h = Math.min(Math.max(a - l.start - l.delay, 0), l.duration) / l.duration, w = isNaN(h) ? 1 : l.easing(h, l.elasticity), h = l.to.strings, p = l.round, n = [], m = void 0, m = l.to.numbers.length, t = 0; t < m; t++) {
          var x = void 0,
              x = l.to.numbers[t],
              q = l.from.numbers[t],
              x = l.isPath ? Y(l.value, w * x) : q + w * (x - q);p && (l.isColor && 2 < t || (x = Math.round(x * p) / p));n.push(x);
        }if (l = h.length) for (m = h[0], w = 0; w < l; w++) {
          p = h[w + 1], t = n[w], isNaN(t) || (m = p ? m + (t + p) : m + (t + " "));
        } else m = n[0];ha[e.type](k.target, e.property, m, c, k.id);e.currentValue = m;b++;
      }if (b = Object.keys(c).length) for (d = 0; d < b; d++) {
        H || (H = E(document.body, "transform") ? "transform" : "-webkit-transform"), g.animatables[d].target.style[H] = c[d].join(" ");
      }g.currentTime = a;g.progress = a / g.duration * 100;
    }function f(a) {
      if (g[a]) g[a](g);
    }function e() {
      g.remaining && !0 !== g.remaining && g.remaining--;
    }function k(a) {
      var k = g.duration,
          n = g.offset,
          w = n + g.delay,
          r = g.currentTime,
          x = g.reversed,
          q = d(a);if (g.children.length) {
        var u = g.children,
            v = u.length;
        if (q >= g.currentTime) for (var G = 0; G < v; G++) {
          u[G].seek(q);
        } else for (; v--;) {
          u[v].seek(q);
        }
      }if (q >= w || !k) g.began || (g.began = !0, f("begin")), f("run");if (q > n && q < k) b(q);else if (q <= n && 0 !== r && (b(0), x && e()), q >= k && r !== k || !k) b(k), x || e();f("update");a >= k && (g.remaining ? (t = h, "alternate" === g.direction && (g.reversed = !g.reversed)) : (g.pause(), g.completed || (g.completed = !0, f("complete"), "Promise" in window && (p(), m = c()))), l = 0);
    }a = void 0 === a ? {} : a;var h,
        t,
        l = 0,
        p = null,
        m = c(),
        g = fa(a);g.reset = function () {
      var a = g.direction,
          c = g.loop;g.currentTime = 0;g.progress = 0;g.paused = !0;g.began = !1;g.completed = !1;g.reversed = "reverse" === a;g.remaining = "alternate" === a && 1 === c ? 2 : c;b(0);for (a = g.children.length; a--;) {
        g.children[a].reset();
      }
    };g.tick = function (a) {
      h = a;t || (t = h);k((l + h - t) * q.speed);
    };g.seek = function (a) {
      k(d(a));
    };g.pause = function () {
      var a = v.indexOf(g);-1 < a && v.splice(a, 1);g.paused = !0;
    };g.play = function () {
      g.paused && (g.paused = !1, t = 0, l = d(g.currentTime), v.push(g), B || ia());
    };g.reverse = function () {
      g.reversed = !g.reversed;t = 0;l = d(g.currentTime);
    };g.restart = function () {
      g.pause();
      g.reset();g.play();
    };g.finished = m;g.reset();g.autoplay && g.play();return g;
  }var ga = { update: void 0, begin: void 0, run: void 0, complete: void 0, loop: 1, direction: "normal", autoplay: !0, offset: 0 },
      S = { duration: 1E3, delay: 0, easing: "easeOutElastic", elasticity: 500, round: 0 },
      W = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),
      H,
      h = { arr: function (a) {
      return Array.isArray(a);
    }, obj: function (a) {
      return -1 < Object.prototype.toString.call(a).indexOf("Object");
    },
    pth: function (a) {
      return h.obj(a) && a.hasOwnProperty("totalLength");
    }, svg: function (a) {
      return a instanceof SVGElement;
    }, dom: function (a) {
      return a.nodeType || h.svg(a);
    }, str: function (a) {
      return "string" === typeof a;
    }, fnc: function (a) {
      return "function" === typeof a;
    }, und: function (a) {
      return "undefined" === typeof a;
    }, hex: function (a) {
      return (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)
      );
    }, rgb: function (a) {
      return (/^rgb/.test(a)
      );
    }, hsl: function (a) {
      return (/^hsl/.test(a)
      );
    }, col: function (a) {
      return h.hex(a) || h.rgb(a) || h.hsl(a);
    } },
      A = function () {
    function a(a, d, b) {
      return (((1 - 3 * b + 3 * d) * a + (3 * b - 6 * d)) * a + 3 * d) * a;
    }return function (c, d, b, f) {
      if (0 <= c && 1 >= c && 0 <= b && 1 >= b) {
        var e = new Float32Array(11);if (c !== d || b !== f) for (var k = 0; 11 > k; ++k) {
          e[k] = a(.1 * k, c, b);
        }return function (k) {
          if (c === d && b === f) return k;if (0 === k) return 0;if (1 === k) return 1;for (var h = 0, l = 1; 10 !== l && e[l] <= k; ++l) {
            h += .1;
          }--l;var l = h + (k - e[l]) / (e[l + 1] - e[l]) * .1,
              n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;if (.001 <= n) {
            for (h = 0; 4 > h; ++h) {
              n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;if (0 === n) break;var m = a(l, c, b) - k,
                  l = l - m / n;
            }k = l;
          } else if (0 === n) k = l;else {
            var l = h,
                h = h + .1,
                g = 0;do {
              m = l + (h - l) / 2, n = a(m, c, b) - k, 0 < n ? h = m : l = m;
            } while (1e-7 < Math.abs(n) && 10 > ++g);k = m;
          }return a(k, d, f);
        };
      }
    };
  }(),
      Q = function () {
    function a(a, b) {
      return 0 === a || 1 === a ? a : -Math.pow(2, 10 * (a - 1)) * Math.sin(2 * (a - 1 - b / (2 * Math.PI) * Math.asin(1)) * Math.PI / b);
    }var c = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),
        d = { In: [[.55, .085, .68, .53], [.55, .055, .675, .19], [.895, .03, .685, .22], [.755, .05, .855, .06], [.47, 0, .745, .715], [.95, .05, .795, .035], [.6, .04, .98, .335], [.6, -.28, .735, .045], a], Out: [[.25, .46, .45, .94], [.215, .61, .355, 1], [.165, .84, .44, 1], [.23, 1, .32, 1], [.39, .575, .565, 1], [.19, 1, .22, 1], [.075, .82, .165, 1], [.175, .885, .32, 1.275], function (b, c) {
        return 1 - a(1 - b, c);
      }], InOut: [[.455, .03, .515, .955], [.645, .045, .355, 1], [.77, 0, .175, 1], [.86, 0, .07, 1], [.445, .05, .55, .95], [1, 0, 0, 1], [.785, .135, .15, .86], [.68, -.55, .265, 1.55], function (b, c) {
        return .5 > b ? a(2 * b, c) / 2 : 1 - a(-2 * b + 2, c) / 2;
      }] },
        b = { linear: A(.25, .25, .75, .75) },
        f = {},
        e;for (e in d) {
      f.type = e, d[f.type].forEach(function (a) {
        return function (d, f) {
          b["ease" + a.type + c[f]] = h.fnc(d) ? d : A.apply($jscomp$this, d);
        };
      }(f)), f = { type: f.type };
    }return b;
  }(),
      ha = { css: function (a, c, d) {
      return a.style[c] = d;
    }, attribute: function (a, c, d) {
      return a.setAttribute(c, d);
    }, object: function (a, c, d) {
      return a[c] = d;
    }, transform: function (a, c, d, b, f) {
      b[f] || (b[f] = []);b[f].push(c + "(" + d + ")");
    } },
      v = [],
      B = 0,
      ia = function () {
    function a() {
      B = requestAnimationFrame(c);
    }function c(c) {
      var b = v.length;if (b) {
        for (var d = 0; d < b;) {
          v[d] && v[d].tick(c), d++;
        }a();
      } else cancelAnimationFrame(B), B = 0;
    }return a;
  }();q.version = "2.2.0";q.speed = 1;q.running = v;q.remove = function (a) {
    a = P(a);for (var c = v.length; c--;) {
      for (var d = v[c], b = d.animations, f = b.length; f--;) {
        u(a, b[f].animatable.target) && (b.splice(f, 1), b.length || d.pause());
      }
    }
  };q.getValue = K;q.path = function (a, c) {
    var d = h.str(a) ? e(a)[0] : a,
        b = c || 100;return function (a) {
      return { el: d, property: a, totalLength: N(d) * (b / 100) };
    };
  };q.setDashoffset = function (a) {
    var c = N(a);a.setAttribute("stroke-dasharray", c);return c;
  };q.bezier = A;q.easings = Q;q.timeline = function (a) {
    var c = q(a);c.pause();c.duration = 0;c.add = function (d) {
      c.children.forEach(function (a) {
        a.began = !0;a.completed = !0;
      });m(d).forEach(function (b) {
        var d = z(b, D(S, a || {}));d.targets = d.targets || a.targets;b = c.duration;var e = d.offset;d.autoplay = !1;d.direction = c.direction;d.offset = h.und(e) ? b : L(e, b);c.began = !0;c.completed = !0;c.seek(d.offset);d = q(d);d.began = !0;d.completed = !0;d.duration > b && (c.duration = d.duration);c.children.push(d);
      });c.seek(0);c.reset();c.autoplay && c.restart();return c;
    };return c;
  };q.random = function (a, c) {
    return Math.floor(Math.random() * (c - a + 1)) + a;
  };return q;
});
;(function ($, anim) {
  'use strict';

  var _defaults = {
    accordion: true,
    onOpenStart: undefined,
    onOpenEnd: undefined,
    onCloseStart: undefined,
    onCloseEnd: undefined,
    inDuration: 300,
    outDuration: 300
  };

  /**
   * @class
   *
   */

  var Collapsible = function (_Component) {
    _inherits(Collapsible, _Component);

    /**
     * Construct Collapsible instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Collapsible(el, options) {
      _classCallCheck(this, Collapsible);

      var _this3 = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, Collapsible, el, options));

      _this3.el.M_Collapsible = _this3;

      /**
       * Options for the collapsible
       * @member Collapsible#options
       * @prop {Boolean} [accordion=false] - Type of the collapsible
       * @prop {Function} onOpenStart - Callback function called before collapsible is opened
       * @prop {Function} onOpenEnd - Callback function called after collapsible is opened
       * @prop {Function} onCloseStart - Callback function called before collapsible is closed
       * @prop {Function} onCloseEnd - Callback function called after collapsible is closed
       * @prop {Number} inDuration - Transition in duration in milliseconds.
       * @prop {Number} outDuration - Transition duration in milliseconds.
       */
      _this3.options = $.extend({}, Collapsible.defaults, options);

      // Setup tab indices
      _this3.$headers = _this3.$el.children('li').children('.collapsible-header');
      _this3.$headers.attr('tabindex', 0);

      _this3._setupEventHandlers();

      // Open first active
      var $activeBodies = _this3.$el.children('li.active').children('.collapsible-body');
      if (_this3.options.accordion) {
        // Handle Accordion
        $activeBodies.first().css('display', 'block');
      } else {
        // Handle Expandables
        $activeBodies.css('display', 'block');
      }
      return _this3;
    }

    _createClass(Collapsible, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_Collapsible = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this4 = this;

        this._handleCollapsibleClickBound = this._handleCollapsibleClick.bind(this);
        this._handleCollapsibleKeydownBound = this._handleCollapsibleKeydown.bind(this);
        this.el.addEventListener('click', this._handleCollapsibleClickBound);
        this.$headers.each(function (header) {
          header.addEventListener('keydown', _this4._handleCollapsibleKeydownBound);
        });
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this5 = this;

        this.el.removeEventListener('click', this._handleCollapsibleClickBound);
        this.$headers.each(function (header) {
          header.removeEventListener('keydown', _this5._handleCollapsibleKeydownBound);
        });
      }

      /**
       * Handle Collapsible Click
       * @param {Event} e
       */

    }, {
      key: "_handleCollapsibleClick",
      value: function _handleCollapsibleClick(e) {
        var $header = $(e.target).closest('.collapsible-header');
        if (e.target && $header.length) {
          var $collapsible = $header.closest('.collapsible');
          if ($collapsible[0] === this.el) {
            var $collapsibleLi = $header.closest('li');
            var $collapsibleLis = $collapsible.children('li');
            var isActive = $collapsibleLi[0].classList.contains('active');
            var index = $collapsibleLis.index($collapsibleLi);

            if (isActive) {
              this.close(index);
            } else {
              this.open(index);
            }
          }
        }
      }

      /**
       * Handle Collapsible Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleCollapsibleKeydown",
      value: function _handleCollapsibleKeydown(e) {
        if (e.keyCode === 13) {
          this._handleCollapsibleClickBound(e);
        }
      }

      /**
       * Animate in collapsible slide
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "_animateIn",
      value: function _animateIn(index) {
        var _this6 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length) {
          var $body = $collapsibleLi.children('.collapsible-body');

          anim.remove($body[0]);
          $body.css({
            display: 'block',
            overflow: 'hidden',
            height: 0,
            paddingTop: '',
            paddingBottom: ''
          });

          var pTop = $body.css('padding-top');
          var pBottom = $body.css('padding-bottom');
          var finalHeight = $body[0].scrollHeight;
          $body.css({
            paddingTop: 0,
            paddingBottom: 0
          });

          anim({
            targets: $body[0],
            height: finalHeight,
            paddingTop: pTop,
            paddingBottom: pBottom,
            duration: this.options.inDuration,
            easing: 'easeInOutCubic',
            complete: function (anim) {
              $body.css({
                overflow: '',
                paddingTop: '',
                paddingBottom: '',
                height: ''
              });

              // onOpenEnd callback
              if (typeof _this6.options.onOpenEnd === 'function') {
                _this6.options.onOpenEnd.call(_this6, $collapsibleLi[0]);
              }
            }
          });
        }
      }

      /**
       * Animate out collapsible slide
       * @param {Number} index - 0th index of slide to open
       */

    }, {
      key: "_animateOut",
      value: function _animateOut(index) {
        var _this7 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length) {
          var $body = $collapsibleLi.children('.collapsible-body');
          anim.remove($body[0]);
          $body.css('overflow', 'hidden');
          anim({
            targets: $body[0],
            height: 0,
            paddingTop: 0,
            paddingBottom: 0,
            duration: this.options.outDuration,
            easing: 'easeInOutCubic',
            complete: function () {
              $body.css({
                height: '',
                overflow: '',
                padding: '',
                display: ''
              });

              // onCloseEnd callback
              if (typeof _this7.options.onCloseEnd === 'function') {
                _this7.options.onCloseEnd.call(_this7, $collapsibleLi[0]);
              }
            }
          });
        }
      }

      /**
       * Open Collapsible
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "open",
      value: function open(index) {
        var _this8 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length && !$collapsibleLi[0].classList.contains('active')) {
          // onOpenStart callback
          if (typeof this.options.onOpenStart === 'function') {
            this.options.onOpenStart.call(this, $collapsibleLi[0]);
          }

          // Handle accordion behavior
          if (this.options.accordion) {
            var $collapsibleLis = this.$el.children('li');
            var $activeLis = this.$el.children('li.active');
            $activeLis.each(function (el) {
              var index = $collapsibleLis.index($(el));
              _this8.close(index);
            });
          }

          // Animate in
          $collapsibleLi[0].classList.add('active');
          this._animateIn(index);
        }
      }

      /**
       * Close Collapsible
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "close",
      value: function close(index) {
        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length && $collapsibleLi[0].classList.contains('active')) {
          // onCloseStart callback
          if (typeof this.options.onCloseStart === 'function') {
            this.options.onCloseStart.call(this, $collapsibleLi[0]);
          }

          // Animate out
          $collapsibleLi[0].classList.remove('active');
          this._animateOut(index);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Collapsible.__proto__ || Object.getPrototypeOf(Collapsible), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Collapsible;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Collapsible;
  }(Component);

  M.Collapsible = Collapsible;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Collapsible, 'collapsible', 'M_Collapsible');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    alignment: 'left',
    autoFocus: true,
    constrainWidth: true,
    container: null,
    coverTrigger: true,
    closeOnClick: true,
    hover: false,
    inDuration: 150,
    outDuration: 250,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    onItemClick: null
  };

  /**
   * @class
   */

  var Dropdown = function (_Component2) {
    _inherits(Dropdown, _Component2);

    function Dropdown(el, options) {
      _classCallCheck(this, Dropdown);

      var _this9 = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, Dropdown, el, options));

      _this9.el.M_Dropdown = _this9;
      Dropdown._dropdowns.push(_this9);

      _this9.id = M.getIdFromTrigger(el);
      _this9.dropdownEl = document.getElementById(_this9.id);
      _this9.$dropdownEl = $(_this9.dropdownEl);

      /**
       * Options for the dropdown
       * @member Dropdown#options
       * @prop {String} [alignment='left'] - Edge which the dropdown is aligned to
       * @prop {Boolean} [autoFocus=true] - Automatically focus dropdown el for keyboard
       * @prop {Boolean} [constrainWidth=true] - Constrain width to width of the button
       * @prop {Element} container - Container element to attach dropdown to (optional)
       * @prop {Boolean} [coverTrigger=true] - Place dropdown over trigger
       * @prop {Boolean} [closeOnClick=true] - Close on click of dropdown item
       * @prop {Boolean} [hover=false] - Open dropdown on hover
       * @prop {Number} [inDuration=150] - Duration of open animation in ms
       * @prop {Number} [outDuration=250] - Duration of close animation in ms
       * @prop {Function} onOpenStart - Function called when dropdown starts opening
       * @prop {Function} onOpenEnd - Function called when dropdown finishes opening
       * @prop {Function} onCloseStart - Function called when dropdown starts closing
       * @prop {Function} onCloseEnd - Function called when dropdown finishes closing
       */
      _this9.options = $.extend({}, Dropdown.defaults, options);

      /**
       * Describes open/close state of dropdown
       * @type {Boolean}
       */
      _this9.isOpen = false;

      /**
       * Describes if dropdown content is scrollable
       * @type {Boolean}
       */
      _this9.isScrollable = false;

      /**
       * Describes if touch moving on dropdown content
       * @type {Boolean}
       */
      _this9.isTouchMoving = false;

      _this9.focusedIndex = -1;
      _this9.filterQuery = [];

      // Move dropdown-content after dropdown-trigger
      if (!!_this9.options.container) {
        $(_this9.options.container).append(_this9.dropdownEl);
      } else {
        _this9.$el.after(_this9.dropdownEl);
      }

      _this9._makeDropdownFocusable();
      _this9._resetFilterQueryBound = _this9._resetFilterQuery.bind(_this9);
      _this9._handleDocumentClickBound = _this9._handleDocumentClick.bind(_this9);
      _this9._handleDocumentTouchmoveBound = _this9._handleDocumentTouchmove.bind(_this9);
      _this9._handleDropdownClickBound = _this9._handleDropdownClick.bind(_this9);
      _this9._handleDropdownKeydownBound = _this9._handleDropdownKeydown.bind(_this9);
      _this9._handleTriggerKeydownBound = _this9._handleTriggerKeydown.bind(_this9);
      _this9._setupEventHandlers();
      return _this9;
    }

    _createClass(Dropdown, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._resetDropdownStyles();
        this._removeEventHandlers();
        Dropdown._dropdowns.splice(Dropdown._dropdowns.indexOf(this), 1);
        this.el.M_Dropdown = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        // Trigger keydown handler
        this.el.addEventListener('keydown', this._handleTriggerKeydownBound);

        // Item click handler
        this.dropdownEl.addEventListener('click', this._handleDropdownClickBound);

        // Hover event handlers
        if (this.options.hover) {
          this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
          this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
          this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
          this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
          this.dropdownEl.addEventListener('mouseleave', this._handleMouseLeaveBound);

          // Click event handlers
        } else {
          this._handleClickBound = this._handleClick.bind(this);
          this.el.addEventListener('click', this._handleClickBound);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('keydown', this._handleTriggerKeydownBound);
        this.dropdownEl.removeEventListener('click', this._handleDropdownClickBound);

        if (this.options.hover) {
          this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
          this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
          this.dropdownEl.removeEventListener('mouseleave', this._handleMouseLeaveBound);
        } else {
          this.el.removeEventListener('click', this._handleClickBound);
        }
      }
    }, {
      key: "_setupTemporaryEventHandlers",
      value: function _setupTemporaryEventHandlers() {
        // Use capture phase event handler to prevent click
        document.body.addEventListener('click', this._handleDocumentClickBound, true);
        document.body.addEventListener('touchend', this._handleDocumentClickBound);
        document.body.addEventListener('touchmove', this._handleDocumentTouchmoveBound);
        this.dropdownEl.addEventListener('keydown', this._handleDropdownKeydownBound);
      }
    }, {
      key: "_removeTemporaryEventHandlers",
      value: function _removeTemporaryEventHandlers() {
        // Use capture phase event handler to prevent click
        document.body.removeEventListener('click', this._handleDocumentClickBound, true);
        document.body.removeEventListener('touchend', this._handleDocumentClickBound);
        document.body.removeEventListener('touchmove', this._handleDocumentTouchmoveBound);
        this.dropdownEl.removeEventListener('keydown', this._handleDropdownKeydownBound);
      }
    }, {
      key: "_handleClick",
      value: function _handleClick(e) {
        e.preventDefault();
        this.open();
      }
    }, {
      key: "_handleMouseEnter",
      value: function _handleMouseEnter() {
        this.open();
      }
    }, {
      key: "_handleMouseLeave",
      value: function _handleMouseLeave(e) {
        var toEl = e.toElement || e.relatedTarget;
        var leaveToDropdownContent = !!$(toEl).closest('.dropdown-content').length;
        var leaveToActiveDropdownTrigger = false;

        var $closestTrigger = $(toEl).closest('.dropdown-trigger');
        if ($closestTrigger.length && !!$closestTrigger[0].M_Dropdown && $closestTrigger[0].M_Dropdown.isOpen) {
          leaveToActiveDropdownTrigger = true;
        }

        // Close hover dropdown if mouse did not leave to either active dropdown-trigger or dropdown-content
        if (!leaveToActiveDropdownTrigger && !leaveToDropdownContent) {
          this.close();
        }
      }
    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        var _this10 = this;

        var $target = $(e.target);
        if (this.options.closeOnClick && $target.closest('.dropdown-content').length && !this.isTouchMoving) {
          // isTouchMoving to check if scrolling on mobile.
          setTimeout(function () {
            _this10.close();
          }, 0);
        } else if ($target.closest('.dropdown-trigger').length || !$target.closest('.dropdown-content').length) {
          setTimeout(function () {
            _this10.close();
          }, 0);
        }
        this.isTouchMoving = false;
      }
    }, {
      key: "_handleTriggerKeydown",
      value: function _handleTriggerKeydown(e) {
        // ARROW DOWN OR ENTER WHEN SELECT IS CLOSED - open Dropdown
        if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ENTER) && !this.isOpen) {
          e.preventDefault();
          this.open();
        }
      }

      /**
       * Handle Document Touchmove
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentTouchmove",
      value: function _handleDocumentTouchmove(e) {
        var $target = $(e.target);
        if ($target.closest('.dropdown-content').length) {
          this.isTouchMoving = true;
        }
      }

      /**
       * Handle Dropdown Click
       * @param {Event} e
       */

    }, {
      key: "_handleDropdownClick",
      value: function _handleDropdownClick(e) {
        // onItemClick callback
        if (typeof this.options.onItemClick === 'function') {
          var itemEl = $(e.target).closest('li')[0];
          this.options.onItemClick.call(this, itemEl);
        }
      }

      /**
       * Handle Dropdown Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleDropdownKeydown",
      value: function _handleDropdownKeydown(e) {
        if (e.which === M.keys.TAB) {
          e.preventDefault();
          this.close();

          // Navigate down dropdown list
        } else if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) && this.isOpen) {
          e.preventDefault();
          var direction = e.which === M.keys.ARROW_DOWN ? 1 : -1;
          var newFocusedIndex = this.focusedIndex;
          var foundNewIndex = false;
          do {
            newFocusedIndex = newFocusedIndex + direction;

            if (!!this.dropdownEl.children[newFocusedIndex] && this.dropdownEl.children[newFocusedIndex].tabIndex !== -1) {
              foundNewIndex = true;
              break;
            }
          } while (newFocusedIndex < this.dropdownEl.children.length && newFocusedIndex >= 0);

          if (foundNewIndex) {
            this.focusedIndex = newFocusedIndex;
            this._focusFocusedItem();
          }

          // ENTER selects choice on focused item
        } else if (e.which === M.keys.ENTER && this.isOpen) {
          // Search for <a> and <button>
          var focusedElement = this.dropdownEl.children[this.focusedIndex];
          var $activatableElement = $(focusedElement).find('a, button').first();

          // Click a or button tag if exists, otherwise click li tag
          if (!!$activatableElement.length) {
            $activatableElement[0].click();
          } else if (!!focusedElement) {
            focusedElement.click();
          }

          // Close dropdown on ESC
        } else if (e.which === M.keys.ESC && this.isOpen) {
          e.preventDefault();
          this.close();
        }

        // CASE WHEN USER TYPE LETTERS
        var letter = String.fromCharCode(e.which).toLowerCase(),
            nonLetters = [9, 13, 27, 38, 40];
        if (letter && nonLetters.indexOf(e.which) === -1) {
          this.filterQuery.push(letter);

          var string = this.filterQuery.join(''),
              newOptionEl = $(this.dropdownEl).find('li').filter(function (el) {
            return $(el).text().toLowerCase().indexOf(string) === 0;
          })[0];

          if (newOptionEl) {
            this.focusedIndex = $(newOptionEl).index();
            this._focusFocusedItem();
          }
        }

        this.filterTimeout = setTimeout(this._resetFilterQueryBound, 1000);
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_resetFilterQuery",
      value: function _resetFilterQuery() {
        this.filterQuery = [];
      }
    }, {
      key: "_resetDropdownStyles",
      value: function _resetDropdownStyles() {
        this.$dropdownEl.css({
          display: '',
          width: '',
          height: '',
          left: '',
          top: '',
          'transform-origin': '',
          transform: '',
          opacity: ''
        });
      }
    }, {
      key: "_makeDropdownFocusable",
      value: function _makeDropdownFocusable() {
        // Needed for arrow key navigation
        this.dropdownEl.tabIndex = 0;

        // Only set tabindex if it hasn't been set by user
        $(this.dropdownEl).children().each(function (el) {
          if (!el.getAttribute('tabindex')) {
            el.setAttribute('tabindex', 0);
          }
        });
      }
    }, {
      key: "_focusFocusedItem",
      value: function _focusFocusedItem() {
        if (this.focusedIndex >= 0 && this.focusedIndex < this.dropdownEl.children.length && this.options.autoFocus) {
          this.dropdownEl.children[this.focusedIndex].focus();
        }
      }
    }, {
      key: "_getDropdownPosition",
      value: function _getDropdownPosition() {
        var offsetParentBRect = this.el.offsetParent.getBoundingClientRect();
        var triggerBRect = this.el.getBoundingClientRect();
        var dropdownBRect = this.dropdownEl.getBoundingClientRect();

        var idealHeight = dropdownBRect.height;
        var idealWidth = dropdownBRect.width;
        var idealXPos = triggerBRect.left - dropdownBRect.left;
        var idealYPos = triggerBRect.top - dropdownBRect.top;

        var dropdownBounds = {
          left: idealXPos,
          top: idealYPos,
          height: idealHeight,
          width: idealWidth
        };

        // Countainer here will be closest ancestor with overflow: hidden
        var closestOverflowParent = !!this.dropdownEl.offsetParent ? this.dropdownEl.offsetParent : this.dropdownEl.parentNode;

        var alignments = M.checkPossibleAlignments(this.el, closestOverflowParent, dropdownBounds, this.options.coverTrigger ? 0 : triggerBRect.height);

        var verticalAlignment = 'top';
        var horizontalAlignment = this.options.alignment;
        idealYPos += this.options.coverTrigger ? 0 : triggerBRect.height;

        // Reset isScrollable
        this.isScrollable = false;

        if (!alignments.top) {
          if (alignments.bottom) {
            verticalAlignment = 'bottom';
          } else {
            this.isScrollable = true;

            // Determine which side has most space and cutoff at correct height
            if (alignments.spaceOnTop > alignments.spaceOnBottom) {
              verticalAlignment = 'bottom';
              idealHeight += alignments.spaceOnTop;
              idealYPos -= alignments.spaceOnTop;
            } else {
              idealHeight += alignments.spaceOnBottom;
            }
          }
        }

        // If preferred horizontal alignment is possible
        if (!alignments[horizontalAlignment]) {
          var oppositeAlignment = horizontalAlignment === 'left' ? 'right' : 'left';
          if (alignments[oppositeAlignment]) {
            horizontalAlignment = oppositeAlignment;
          } else {
            // Determine which side has most space and cutoff at correct height
            if (alignments.spaceOnLeft > alignments.spaceOnRight) {
              horizontalAlignment = 'right';
              idealWidth += alignments.spaceOnLeft;
              idealXPos -= alignments.spaceOnLeft;
            } else {
              horizontalAlignment = 'left';
              idealWidth += alignments.spaceOnRight;
            }
          }
        }

        if (verticalAlignment === 'bottom') {
          idealYPos = idealYPos - dropdownBRect.height + (this.options.coverTrigger ? triggerBRect.height : 0);
        }
        if (horizontalAlignment === 'right') {
          idealXPos = idealXPos - dropdownBRect.width + triggerBRect.width;
        }
        return {
          x: idealXPos,
          y: idealYPos,
          verticalAlignment: verticalAlignment,
          horizontalAlignment: horizontalAlignment,
          height: idealHeight,
          width: idealWidth
        };
      }

      /**
       * Animate in dropdown
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        var _this11 = this;

        anim.remove(this.dropdownEl);
        anim({
          targets: this.dropdownEl,
          opacity: {
            value: [0, 1],
            easing: 'easeOutQuad'
          },
          scaleX: [0.3, 1],
          scaleY: [0.3, 1],
          duration: this.options.inDuration,
          easing: 'easeOutQuint',
          complete: function (anim) {
            if (_this11.options.autoFocus) {
              _this11.dropdownEl.focus();
            }

            // onOpenEnd callback
            if (typeof _this11.options.onOpenEnd === 'function') {
              _this11.options.onOpenEnd.call(_this11, _this11.el);
            }
          }
        });
      }

      /**
       * Animate out dropdown
       */

    }, {
      key: "_animateOut",
      value: function _animateOut() {
        var _this12 = this;

        anim.remove(this.dropdownEl);
        anim({
          targets: this.dropdownEl,
          opacity: {
            value: 0,
            easing: 'easeOutQuint'
          },
          scaleX: 0.3,
          scaleY: 0.3,
          duration: this.options.outDuration,
          easing: 'easeOutQuint',
          complete: function (anim) {
            _this12._resetDropdownStyles();

            // onCloseEnd callback
            if (typeof _this12.options.onCloseEnd === 'function') {
              _this12.options.onCloseEnd.call(_this12, _this12.el);
            }
          }
        });
      }

      /**
       * Place dropdown
       */

    }, {
      key: "_placeDropdown",
      value: function _placeDropdown() {
        // Set width before calculating positionInfo
        var idealWidth = this.options.constrainWidth ? this.el.getBoundingClientRect().width : this.dropdownEl.getBoundingClientRect().width;
        this.dropdownEl.style.width = idealWidth + 'px';

        var positionInfo = this._getDropdownPosition();
        this.dropdownEl.style.left = positionInfo.x + 'px';
        this.dropdownEl.style.top = positionInfo.y + 'px';
        this.dropdownEl.style.height = positionInfo.height + 'px';
        this.dropdownEl.style.width = positionInfo.width + 'px';
        this.dropdownEl.style.transformOrigin = (positionInfo.horizontalAlignment === 'left' ? '0' : '100%') + " " + (positionInfo.verticalAlignment === 'top' ? '0' : '100%');
      }

      /**
       * Open Dropdown
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }
        this.isOpen = true;

        // onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        }

        // Reset styles
        this._resetDropdownStyles();
        this.dropdownEl.style.display = 'block';

        this._placeDropdown();
        this._animateIn();
        this._setupTemporaryEventHandlers();
      }

      /**
       * Close Dropdown
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }
        this.isOpen = false;
        this.focusedIndex = -1;

        // onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        this._animateOut();
        this._removeTemporaryEventHandlers();

        if (this.options.autoFocus) {
          this.el.focus();
        }
      }

      /**
       * Recalculate dimensions
       */

    }, {
      key: "recalculateDimensions",
      value: function recalculateDimensions() {
        if (this.isOpen) {
          this.$dropdownEl.css({
            width: '',
            height: '',
            left: '',
            top: '',
            'transform-origin': ''
          });
          this._placeDropdown();
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Dropdown.__proto__ || Object.getPrototypeOf(Dropdown), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Dropdown;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Dropdown;
  }(Component);

  /**
   * @static
   * @memberof Dropdown
   */


  Dropdown._dropdowns = [];

  M.Dropdown = Dropdown;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Dropdown, 'dropdown', 'M_Dropdown');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    opacity: 0.5,
    inDuration: 250,
    outDuration: 250,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    preventScrolling: true,
    dismissible: true,
    startingTop: '4%',
    endingTop: '10%'
  };

  /**
   * @class
   *
   */

  var Modal = function (_Component3) {
    _inherits(Modal, _Component3);

    /**
     * Construct Modal instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Modal(el, options) {
      _classCallCheck(this, Modal);

      var _this13 = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, Modal, el, options));

      _this13.el.M_Modal = _this13;

      /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [opacity=0.5] - Opacity of the modal overlay
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=250] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before modal is opened
       * @prop {Function} onOpenEnd - Callback function called after modal is opened
       * @prop {Function} onCloseStart - Callback function called before modal is closed
       * @prop {Function} onCloseEnd - Callback function called after modal is closed
       * @prop {Boolean} [dismissible=true] - Allow modal to be dismissed by keyboard or overlay click
       * @prop {String} [startingTop='4%'] - startingTop
       * @prop {String} [endingTop='10%'] - endingTop
       */
      _this13.options = $.extend({}, Modal.defaults, options);

      /**
       * Describes open/close state of modal
       * @type {Boolean}
       */
      _this13.isOpen = false;

      _this13.id = _this13.$el.attr('id');
      _this13._openingTrigger = undefined;
      _this13.$overlay = $('<div class="modal-overlay"></div>');
      _this13.el.tabIndex = 0;
      _this13._nthModalOpened = 0;

      Modal._count++;
      _this13._setupEventHandlers();
      return _this13;
    }

    _createClass(Modal, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        Modal._count--;
        this._removeEventHandlers();
        this.el.removeAttribute('style');
        this.$overlay.remove();
        this.el.M_Modal = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleOverlayClickBound = this._handleOverlayClick.bind(this);
        this._handleModalCloseClickBound = this._handleModalCloseClick.bind(this);

        if (Modal._count === 1) {
          document.body.addEventListener('click', this._handleTriggerClick);
        }
        this.$overlay[0].addEventListener('click', this._handleOverlayClickBound);
        this.el.addEventListener('click', this._handleModalCloseClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (Modal._count === 0) {
          document.body.removeEventListener('click', this._handleTriggerClick);
        }
        this.$overlay[0].removeEventListener('click', this._handleOverlayClickBound);
        this.el.removeEventListener('click', this._handleModalCloseClickBound);
      }

      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target).closest('.modal-trigger');
        if ($trigger.length) {
          var modalId = M.getIdFromTrigger($trigger[0]);
          var modalInstance = document.getElementById(modalId).M_Modal;
          if (modalInstance) {
            modalInstance.open($trigger);
          }
          e.preventDefault();
        }
      }

      /**
       * Handle Overlay Click
       */

    }, {
      key: "_handleOverlayClick",
      value: function _handleOverlayClick() {
        if (this.options.dismissible) {
          this.close();
        }
      }

      /**
       * Handle Modal Close Click
       * @param {Event} e
       */

    }, {
      key: "_handleModalCloseClick",
      value: function _handleModalCloseClick(e) {
        var $closeTrigger = $(e.target).closest('.modal-close');
        if ($closeTrigger.length) {
          this.close();
        }
      }

      /**
       * Handle Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleKeydown",
      value: function _handleKeydown(e) {
        // ESC key
        if (e.keyCode === 27 && this.options.dismissible) {
          this.close();
        }
      }

      /**
       * Handle Focus
       * @param {Event} e
       */

    }, {
      key: "_handleFocus",
      value: function _handleFocus(e) {
        // Only trap focus if this modal is the last model opened (prevents loops in nested modals).
        if (!this.el.contains(e.target) && this._nthModalOpened === Modal._modalsOpen) {
          this.el.focus();
        }
      }

      /**
       * Animate in modal
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        var _this14 = this;

        // Set initial styles
        $.extend(this.el.style, {
          display: 'block',
          opacity: 0
        });
        $.extend(this.$overlay[0].style, {
          display: 'block',
          opacity: 0
        });

        // Animate overlay
        anim({
          targets: this.$overlay[0],
          opacity: this.options.opacity,
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        });

        // Define modal animation options
        var enterAnimOptions = {
          targets: this.el,
          duration: this.options.inDuration,
          easing: 'easeOutCubic',
          // Handle modal onOpenEnd callback
          complete: function () {
            if (typeof _this14.options.onOpenEnd === 'function') {
              _this14.options.onOpenEnd.call(_this14, _this14.el, _this14._openingTrigger);
            }
          }
        };

        // Bottom sheet animation
        if (this.el.classList.contains('bottom-sheet')) {
          $.extend(enterAnimOptions, {
            bottom: 0,
            opacity: 1
          });
          anim(enterAnimOptions);

          // Normal modal animation
        } else {
          $.extend(enterAnimOptions, {
            top: [this.options.startingTop, this.options.endingTop],
            opacity: 1,
            scaleX: [0.8, 1],
            scaleY: [0.8, 1]
          });
          anim(enterAnimOptions);
        }
      }

      /**
       * Animate out modal
       */

    }, {
      key: "_animateOut",
      value: function _animateOut() {
        var _this15 = this;

        // Animate overlay
        anim({
          targets: this.$overlay[0],
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuart'
        });

        // Define modal animation options
        var exitAnimOptions = {
          targets: this.el,
          duration: this.options.outDuration,
          easing: 'easeOutCubic',
          // Handle modal ready callback
          complete: function () {
            _this15.el.style.display = 'none';
            _this15.$overlay.remove();

            // Call onCloseEnd callback
            if (typeof _this15.options.onCloseEnd === 'function') {
              _this15.options.onCloseEnd.call(_this15, _this15.el);
            }
          }
        };

        // Bottom sheet animation
        if (this.el.classList.contains('bottom-sheet')) {
          $.extend(exitAnimOptions, {
            bottom: '-100%',
            opacity: 0
          });
          anim(exitAnimOptions);

          // Normal modal animation
        } else {
          $.extend(exitAnimOptions, {
            top: [this.options.endingTop, this.options.startingTop],
            opacity: 0,
            scaleX: 0.8,
            scaleY: 0.8
          });
          anim(exitAnimOptions);
        }
      }

      /**
       * Open Modal
       * @param {cash} [$trigger]
       */

    }, {
      key: "open",
      value: function open($trigger) {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        Modal._modalsOpen++;
        this._nthModalOpened = Modal._modalsOpen;

        // Set Z-Index based on number of currently open modals
        this.$overlay[0].style.zIndex = 1000 + Modal._modalsOpen * 2;
        this.el.style.zIndex = 1000 + Modal._modalsOpen * 2 + 1;

        // Set opening trigger, undefined indicates modal was opened by javascript
        this._openingTrigger = !!$trigger ? $trigger[0] : undefined;

        // onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el, this._openingTrigger);
        }

        if (this.options.preventScrolling) {
          document.body.style.overflow = 'hidden';
        }

        this.el.classList.add('open');
        this.el.insertAdjacentElement('afterend', this.$overlay[0]);

        if (this.options.dismissible) {
          this._handleKeydownBound = this._handleKeydown.bind(this);
          this._handleFocusBound = this._handleFocus.bind(this);
          document.addEventListener('keydown', this._handleKeydownBound);
          document.addEventListener('focus', this._handleFocusBound, true);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);
        this._animateIn();

        // Focus modal
        this.el.focus();

        return this;
      }

      /**
       * Close Modal
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        Modal._modalsOpen--;
        this._nthModalOpened = 0;

        // Call onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        this.el.classList.remove('open');

        // Enable body scrolling only if there are no more modals open.
        if (Modal._modalsOpen === 0) {
          document.body.style.overflow = '';
        }

        if (this.options.dismissible) {
          document.removeEventListener('keydown', this._handleKeydownBound);
          document.removeEventListener('focus', this._handleFocusBound, true);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);
        this._animateOut();
        return this;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Modal.__proto__ || Object.getPrototypeOf(Modal), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Modal;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Modal;
  }(Component);

  /**
   * @static
   * @memberof Modal
   */


  Modal._modalsOpen = 0;

  /**
   * @static
   * @memberof Modal
   */
  Modal._count = 0;

  M.Modal = Modal;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Modal, 'modal', 'M_Modal');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    inDuration: 275,
    outDuration: 200,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null
  };

  /**
   * @class
   *
   */

  var Materialbox = function (_Component4) {
    _inherits(Materialbox, _Component4);

    /**
     * Construct Materialbox instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Materialbox(el, options) {
      _classCallCheck(this, Materialbox);

      var _this16 = _possibleConstructorReturn(this, (Materialbox.__proto__ || Object.getPrototypeOf(Materialbox)).call(this, Materialbox, el, options));

      _this16.el.M_Materialbox = _this16;

      /**
       * Options for the modal
       * @member Materialbox#options
       * @prop {Number} [inDuration=275] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before materialbox is opened
       * @prop {Function} onOpenEnd - Callback function called after materialbox is opened
       * @prop {Function} onCloseStart - Callback function called before materialbox is closed
       * @prop {Function} onCloseEnd - Callback function called after materialbox is closed
       */
      _this16.options = $.extend({}, Materialbox.defaults, options);

      _this16.overlayActive = false;
      _this16.doneAnimating = true;
      _this16.placeholder = $('<div></div>').addClass('material-placeholder');
      _this16.originalWidth = 0;
      _this16.originalHeight = 0;
      _this16.originInlineStyles = _this16.$el.attr('style');
      _this16.caption = _this16.el.getAttribute('data-caption') || '';

      // Wrap
      _this16.$el.before(_this16.placeholder);
      _this16.placeholder.append(_this16.$el);

      _this16._setupEventHandlers();
      return _this16;
    }

    _createClass(Materialbox, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_Materialbox = undefined;

        // Unwrap image
        $(this.placeholder).after(this.el).remove();

        this.$el.removeAttr('style');
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleMaterialboxClickBound = this._handleMaterialboxClick.bind(this);
        this.el.addEventListener('click', this._handleMaterialboxClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleMaterialboxClickBound);
      }

      /**
       * Handle Materialbox Click
       * @param {Event} e
       */

    }, {
      key: "_handleMaterialboxClick",
      value: function _handleMaterialboxClick(e) {
        // If already modal, return to original
        if (this.doneAnimating === false || this.overlayActive && this.doneAnimating) {
          this.close();
        } else {
          this.open();
        }
      }

      /**
       * Handle Window Scroll
       */

    }, {
      key: "_handleWindowScroll",
      value: function _handleWindowScroll() {
        if (this.overlayActive) {
          this.close();
        }
      }

      /**
       * Handle Window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        if (this.overlayActive) {
          this.close();
        }
      }

      /**
       * Handle Window Resize
       * @param {Event} e
       */

    }, {
      key: "_handleWindowEscape",
      value: function _handleWindowEscape(e) {
        // ESC key
        if (e.keyCode === 27 && this.doneAnimating && this.overlayActive) {
          this.close();
        }
      }

      /**
       * Find ancestors with overflow: hidden; and make visible
       */

    }, {
      key: "_makeAncestorsOverflowVisible",
      value: function _makeAncestorsOverflowVisible() {
        this.ancestorsChanged = $();
        var ancestor = this.placeholder[0].parentNode;
        while (ancestor !== null && !$(ancestor).is(document)) {
          var curr = $(ancestor);
          if (curr.css('overflow') !== 'visible') {
            curr.css('overflow', 'visible');
            if (this.ancestorsChanged === undefined) {
              this.ancestorsChanged = curr;
            } else {
              this.ancestorsChanged = this.ancestorsChanged.add(curr);
            }
          }
          ancestor = ancestor.parentNode;
        }
      }

      /**
       * Animate image in
       */

    }, {
      key: "_animateImageIn",
      value: function _animateImageIn() {
        var _this17 = this;

        var animOptions = {
          targets: this.el,
          height: [this.originalHeight, this.newHeight],
          width: [this.originalWidth, this.newWidth],
          left: M.getDocumentScrollLeft() + this.windowWidth / 2 - this.placeholder.offset().left - this.newWidth / 2,
          top: M.getDocumentScrollTop() + this.windowHeight / 2 - this.placeholder.offset().top - this.newHeight / 2,
          duration: this.options.inDuration,
          easing: 'easeOutQuad',
          complete: function () {
            _this17.doneAnimating = true;

            // onOpenEnd callback
            if (typeof _this17.options.onOpenEnd === 'function') {
              _this17.options.onOpenEnd.call(_this17, _this17.el);
            }
          }
        };

        // Override max-width or max-height if needed
        this.maxWidth = this.$el.css('max-width');
        this.maxHeight = this.$el.css('max-height');
        if (this.maxWidth !== 'none') {
          animOptions.maxWidth = this.newWidth;
        }
        if (this.maxHeight !== 'none') {
          animOptions.maxHeight = this.newHeight;
        }

        anim(animOptions);
      }

      /**
       * Animate image out
       */

    }, {
      key: "_animateImageOut",
      value: function _animateImageOut() {
        var _this18 = this;

        var animOptions = {
          targets: this.el,
          width: this.originalWidth,
          height: this.originalHeight,
          left: 0,
          top: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            _this18.placeholder.css({
              height: '',
              width: '',
              position: '',
              top: '',
              left: ''
            });

            // Revert to width or height attribute
            if (_this18.attrWidth) {
              _this18.$el.attr('width', _this18.attrWidth);
            }
            if (_this18.attrHeight) {
              _this18.$el.attr('height', _this18.attrHeight);
            }

            _this18.$el.removeAttr('style');
            _this18.originInlineStyles && _this18.$el.attr('style', _this18.originInlineStyles);

            // Remove class
            _this18.$el.removeClass('active');
            _this18.doneAnimating = true;

            // Remove overflow overrides on ancestors
            if (_this18.ancestorsChanged.length) {
              _this18.ancestorsChanged.css('overflow', '');
            }

            // onCloseEnd callback
            if (typeof _this18.options.onCloseEnd === 'function') {
              _this18.options.onCloseEnd.call(_this18, _this18.el);
            }
          }
        };

        anim(animOptions);
      }

      /**
       * Update open and close vars
       */

    }, {
      key: "_updateVars",
      value: function _updateVars() {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        this.caption = this.el.getAttribute('data-caption') || '';
      }

      /**
       * Open Materialbox
       */

    }, {
      key: "open",
      value: function open() {
        var _this19 = this;

        this._updateVars();
        this.originalWidth = this.el.getBoundingClientRect().width;
        this.originalHeight = this.el.getBoundingClientRect().height;

        // Set states
        this.doneAnimating = false;
        this.$el.addClass('active');
        this.overlayActive = true;

        // onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        }

        // Set positioning for placeholder
        this.placeholder.css({
          width: this.placeholder[0].getBoundingClientRect().width + 'px',
          height: this.placeholder[0].getBoundingClientRect().height + 'px',
          position: 'relative',
          top: 0,
          left: 0
        });

        this._makeAncestorsOverflowVisible();

        // Set css on origin
        this.$el.css({
          position: 'absolute',
          'z-index': 1000,
          'will-change': 'left, top, width, height'
        });

        // Change from width or height attribute to css
        this.attrWidth = this.$el.attr('width');
        this.attrHeight = this.$el.attr('height');
        if (this.attrWidth) {
          this.$el.css('width', this.attrWidth + 'px');
          this.$el.removeAttr('width');
        }
        if (this.attrHeight) {
          this.$el.css('width', this.attrHeight + 'px');
          this.$el.removeAttr('height');
        }

        // Add overlay
        this.$overlay = $('<div id="materialbox-overlay"></div>').css({
          opacity: 0
        }).one('click', function () {
          if (_this19.doneAnimating) {
            _this19.close();
          }
        });

        // Put before in origin image to preserve z-index layering.
        this.$el.before(this.$overlay);

        // Set dimensions if needed
        var overlayOffset = this.$overlay[0].getBoundingClientRect();
        this.$overlay.css({
          width: this.windowWidth + 'px',
          height: this.windowHeight + 'px',
          left: -1 * overlayOffset.left + 'px',
          top: -1 * overlayOffset.top + 'px'
        });

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);

        // Animate Overlay
        anim({
          targets: this.$overlay[0],
          opacity: 1,
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        });

        // Add and animate caption if it exists
        if (this.caption !== '') {
          if (this.$photocaption) {
            anim.remove(this.$photoCaption[0]);
          }
          this.$photoCaption = $('<div class="materialbox-caption"></div>');
          this.$photoCaption.text(this.caption);
          $('body').append(this.$photoCaption);
          this.$photoCaption.css({ display: 'inline' });

          anim({
            targets: this.$photoCaption[0],
            opacity: 1,
            duration: this.options.inDuration,
            easing: 'easeOutQuad'
          });
        }

        // Resize Image
        var ratio = 0;
        var widthPercent = this.originalWidth / this.windowWidth;
        var heightPercent = this.originalHeight / this.windowHeight;
        this.newWidth = 0;
        this.newHeight = 0;

        if (widthPercent > heightPercent) {
          ratio = this.originalHeight / this.originalWidth;
          this.newWidth = this.windowWidth * 0.9;
          this.newHeight = this.windowWidth * 0.9 * ratio;
        } else {
          ratio = this.originalWidth / this.originalHeight;
          this.newWidth = this.windowHeight * 0.9 * ratio;
          this.newHeight = this.windowHeight * 0.9;
        }

        this._animateImageIn();

        // Handle Exit triggers
        this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
        this._handleWindowEscapeBound = this._handleWindowEscape.bind(this);

        window.addEventListener('scroll', this._handleWindowScrollBound);
        window.addEventListener('resize', this._handleWindowResizeBound);
        window.addEventListener('keyup', this._handleWindowEscapeBound);
      }

      /**
       * Close Materialbox
       */

    }, {
      key: "close",
      value: function close() {
        var _this20 = this;

        this._updateVars();
        this.doneAnimating = false;

        // onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);

        if (this.caption !== '') {
          anim.remove(this.$photoCaption[0]);
        }

        // disable exit handlers
        window.removeEventListener('scroll', this._handleWindowScrollBound);
        window.removeEventListener('resize', this._handleWindowResizeBound);
        window.removeEventListener('keyup', this._handleWindowEscapeBound);

        anim({
          targets: this.$overlay[0],
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            _this20.overlayActive = false;
            _this20.$overlay.remove();
          }
        });

        this._animateImageOut();

        // Remove Caption + reset css settings on image
        if (this.caption !== '') {
          anim({
            targets: this.$photoCaption[0],
            opacity: 0,
            duration: this.options.outDuration,
            easing: 'easeOutQuad',
            complete: function () {
              _this20.$photoCaption.remove();
            }
          });
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Materialbox.__proto__ || Object.getPrototypeOf(Materialbox), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Materialbox;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Materialbox;
  }(Component);

  M.Materialbox = Materialbox;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Materialbox, 'materialbox', 'M_Materialbox');
  }
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    responsiveThreshold: 0 // breakpoint for swipeable
  };

  var Parallax = function (_Component5) {
    _inherits(Parallax, _Component5);

    function Parallax(el, options) {
      _classCallCheck(this, Parallax);

      var _this21 = _possibleConstructorReturn(this, (Parallax.__proto__ || Object.getPrototypeOf(Parallax)).call(this, Parallax, el, options));

      _this21.el.M_Parallax = _this21;

      /**
       * Options for the Parallax
       * @member Parallax#options
       * @prop {Number} responsiveThreshold
       */
      _this21.options = $.extend({}, Parallax.defaults, options);
      _this21._enabled = window.innerWidth > _this21.options.responsiveThreshold;

      _this21.$img = _this21.$el.find('img').first();
      _this21.$img.each(function () {
        var el = this;
        if (el.complete) $(el).trigger('load');
      });

      _this21._updateParallax();
      _this21._setupEventHandlers();
      _this21._setupStyles();

      Parallax._parallaxes.push(_this21);
      return _this21;
    }

    _createClass(Parallax, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        Parallax._parallaxes.splice(Parallax._parallaxes.indexOf(this), 1);
        this.$img[0].style.transform = '';
        this._removeEventHandlers();

        this.$el[0].M_Parallax = undefined;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleImageLoadBound = this._handleImageLoad.bind(this);
        this.$img[0].addEventListener('load', this._handleImageLoadBound);

        if (Parallax._parallaxes.length === 0) {
          Parallax._handleScrollThrottled = M.throttle(Parallax._handleScroll, 5);
          window.addEventListener('scroll', Parallax._handleScrollThrottled);

          Parallax._handleWindowResizeThrottled = M.throttle(Parallax._handleWindowResize, 5);
          window.addEventListener('resize', Parallax._handleWindowResizeThrottled);
        }
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.$img[0].removeEventListener('load', this._handleImageLoadBound);

        if (Parallax._parallaxes.length === 0) {
          window.removeEventListener('scroll', Parallax._handleScrollThrottled);
          window.removeEventListener('resize', Parallax._handleWindowResizeThrottled);
        }
      }
    }, {
      key: "_setupStyles",
      value: function _setupStyles() {
        this.$img[0].style.opacity = 1;
      }
    }, {
      key: "_handleImageLoad",
      value: function _handleImageLoad() {
        this._updateParallax();
      }
    }, {
      key: "_updateParallax",
      value: function _updateParallax() {
        var containerHeight = this.$el.height() > 0 ? this.el.parentNode.offsetHeight : 500;
        var imgHeight = this.$img[0].offsetHeight;
        var parallaxDist = imgHeight - containerHeight;
        var bottom = this.$el.offset().top + containerHeight;
        var top = this.$el.offset().top;
        var scrollTop = M.getDocumentScrollTop();
        var windowHeight = window.innerHeight;
        var windowBottom = scrollTop + windowHeight;
        var percentScrolled = (windowBottom - top) / (containerHeight + windowHeight);
        var parallax = parallaxDist * percentScrolled;

        if (!this._enabled) {
          this.$img[0].style.transform = '';
        } else if (bottom > scrollTop && top < scrollTop + windowHeight) {
          this.$img[0].style.transform = "translate3D(-50%, " + parallax + "px, 0)";
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Parallax.__proto__ || Object.getPrototypeOf(Parallax), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Parallax;
      }
    }, {
      key: "_handleScroll",
      value: function _handleScroll() {
        for (var i = 0; i < Parallax._parallaxes.length; i++) {
          var parallaxInstance = Parallax._parallaxes[i];
          parallaxInstance._updateParallax.call(parallaxInstance);
        }
      }
    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        for (var i = 0; i < Parallax._parallaxes.length; i++) {
          var parallaxInstance = Parallax._parallaxes[i];
          parallaxInstance._enabled = window.innerWidth > parallaxInstance.options.responsiveThreshold;
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Parallax;
  }(Component);

  /**
   * @static
   * @memberof Parallax
   */


  Parallax._parallaxes = [];

  M.Parallax = Parallax;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Parallax, 'parallax', 'M_Parallax');
  }
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    duration: 300,
    onShow: null,
    swipeable: false,
    responsiveThreshold: Infinity // breakpoint for swipeable
  };

  /**
   * @class
   *
   */

  var Tabs = function (_Component6) {
    _inherits(Tabs, _Component6);

    /**
     * Construct Tabs instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Tabs(el, options) {
      _classCallCheck(this, Tabs);

      var _this22 = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, Tabs, el, options));

      _this22.el.M_Tabs = _this22;

      /**
       * Options for the Tabs
       * @member Tabs#options
       * @prop {Number} duration
       * @prop {Function} onShow
       * @prop {Boolean} swipeable
       * @prop {Number} responsiveThreshold
       */
      _this22.options = $.extend({}, Tabs.defaults, options);

      // Setup
      _this22.$tabLinks = _this22.$el.children('li.tab').children('a');
      _this22.index = 0;
      _this22._setupActiveTabLink();

      // Setup tabs content
      if (_this22.options.swipeable) {
        _this22._setupSwipeableTabs();
      } else {
        _this22._setupNormalTabs();
      }

      // Setup tabs indicator after content to ensure accurate widths
      _this22._setTabsAndTabWidth();
      _this22._createIndicator();

      _this22._setupEventHandlers();
      return _this22;
    }

    _createClass(Tabs, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._indicator.parentNode.removeChild(this._indicator);

        if (this.options.swipeable) {
          this._teardownSwipeableTabs();
        } else {
          this._teardownNormalTabs();
        }

        this.$el[0].M_Tabs = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
        window.addEventListener('resize', this._handleWindowResizeBound);

        this._handleTabClickBound = this._handleTabClick.bind(this);
        this.el.addEventListener('click', this._handleTabClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        window.removeEventListener('resize', this._handleWindowResizeBound);
        this.el.removeEventListener('click', this._handleTabClickBound);
      }

      /**
       * Handle window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        this._setTabsAndTabWidth();

        if (this.tabWidth !== 0 && this.tabsWidth !== 0) {
          this._indicator.style.left = this._calcLeftPos(this.$activeTabLink) + 'px';
          this._indicator.style.right = this._calcRightPos(this.$activeTabLink) + 'px';
        }
      }

      /**
       * Handle tab click
       * @param {Event} e
       */

    }, {
      key: "_handleTabClick",
      value: function _handleTabClick(e) {
        var _this23 = this;

        var tab = $(e.target).closest('li.tab');
        var tabLink = $(e.target).closest('a');

        // Handle click on tab link only
        if (!tabLink.length || !tabLink.parent().hasClass('tab')) {
          return;
        }

        if (tab.hasClass('disabled')) {
          e.preventDefault();
          return;
        }

        // Act as regular link if target attribute is specified.
        if (!!tabLink.attr('target')) {
          return;
        }

        // Make the old tab inactive.
        this.$activeTabLink.removeClass('active');
        var $oldContent = this.$content;

        // Update the variables with the new link and content
        this.$activeTabLink = tabLink;
        this.$content = $(M.escapeHash(tabLink[0].hash));
        this.$tabLinks = this.$el.children('li.tab').children('a');

        // Make the tab active.
        this.$activeTabLink.addClass('active');
        var prevIndex = this.index;
        this.index = Math.max(this.$tabLinks.index(tabLink), 0);

        // Swap content
        if (this.options.swipeable) {
          if (this._tabsCarousel) {
            this._tabsCarousel.set(this.index, function () {
              if (typeof _this23.options.onShow === 'function') {
                _this23.options.onShow.call(_this23, _this23.$content[0]);
              }
            });
          }
        } else {
          if (this.$content.length) {
            this.$content[0].style.display = 'block';
            this.$content.addClass('active');
            if (typeof this.options.onShow === 'function') {
              this.options.onShow.call(this, this.$content[0]);
            }

            if ($oldContent.length && !$oldContent.is(this.$content)) {
              $oldContent[0].style.display = 'none';
              $oldContent.removeClass('active');
            }
          }
        }

        // Update widths after content is swapped (scrollbar bugfix)
        this._setTabsAndTabWidth();

        // Update indicator
        this._animateIndicator(prevIndex);

        // Prevent the anchor's default click action
        e.preventDefault();
      }

      /**
       * Generate elements for tab indicator.
       */

    }, {
      key: "_createIndicator",
      value: function _createIndicator() {
        var _this24 = this;

        var indicator = document.createElement('li');
        indicator.classList.add('indicator');

        this.el.appendChild(indicator);
        this._indicator = indicator;

        setTimeout(function () {
          _this24._indicator.style.left = _this24._calcLeftPos(_this24.$activeTabLink) + 'px';
          _this24._indicator.style.right = _this24._calcRightPos(_this24.$activeTabLink) + 'px';
        }, 0);
      }

      /**
       * Setup first active tab link.
       */

    }, {
      key: "_setupActiveTabLink",
      value: function _setupActiveTabLink() {
        // If the location.hash matches one of the links, use that as the active tab.
        this.$activeTabLink = $(this.$tabLinks.filter('[href="' + location.hash + '"]'));

        // If no match is found, use the first link or any with class 'active' as the initial active tab.
        if (this.$activeTabLink.length === 0) {
          this.$activeTabLink = this.$el.children('li.tab').children('a.active').first();
        }
        if (this.$activeTabLink.length === 0) {
          this.$activeTabLink = this.$el.children('li.tab').children('a').first();
        }

        this.$tabLinks.removeClass('active');
        this.$activeTabLink[0].classList.add('active');

        this.index = Math.max(this.$tabLinks.index(this.$activeTabLink), 0);

        if (this.$activeTabLink.length) {
          this.$content = $(M.escapeHash(this.$activeTabLink[0].hash));
          this.$content.addClass('active');
        }
      }

      /**
       * Setup swipeable tabs
       */

    }, {
      key: "_setupSwipeableTabs",
      value: function _setupSwipeableTabs() {
        var _this25 = this;

        // Change swipeable according to responsive threshold
        if (window.innerWidth > this.options.responsiveThreshold) {
          this.options.swipeable = false;
        }

        var $tabsContent = $();
        this.$tabLinks.each(function (link) {
          var $currContent = $(M.escapeHash(link.hash));
          $currContent.addClass('carousel-item');
          $tabsContent = $tabsContent.add($currContent);
        });

        var $tabsWrapper = $('<div class="tabs-content carousel carousel-slider"></div>');
        $tabsContent.first().before($tabsWrapper);
        $tabsWrapper.append($tabsContent);
        $tabsContent[0].style.display = '';

        // Keep active tab index to set initial carousel slide
        var activeTabIndex = this.$activeTabLink.closest('.tab').index();

        this._tabsCarousel = M.Carousel.init($tabsWrapper[0], {
          fullWidth: true,
          noWrap: true,
          onCycleTo: function (item) {
            var prevIndex = _this25.index;
            _this25.index = $(item).index();
            _this25.$activeTabLink.removeClass('active');
            _this25.$activeTabLink = _this25.$tabLinks.eq(_this25.index);
            _this25.$activeTabLink.addClass('active');
            _this25._animateIndicator(prevIndex);
            if (typeof _this25.options.onShow === 'function') {
              _this25.options.onShow.call(_this25, _this25.$content[0]);
            }
          }
        });

        // Set initial carousel slide to active tab
        this._tabsCarousel.set(activeTabIndex);
      }

      /**
       * Teardown normal tabs.
       */

    }, {
      key: "_teardownSwipeableTabs",
      value: function _teardownSwipeableTabs() {
        var $tabsWrapper = this._tabsCarousel.$el;
        this._tabsCarousel.destroy();

        // Unwrap
        $tabsWrapper.after($tabsWrapper.children());
        $tabsWrapper.remove();
      }

      /**
       * Setup normal tabs.
       */

    }, {
      key: "_setupNormalTabs",
      value: function _setupNormalTabs() {
        // Hide Tabs Content
        this.$tabLinks.not(this.$activeTabLink).each(function (link) {
          if (!!link.hash) {
            var $currContent = $(M.escapeHash(link.hash));
            if ($currContent.length) {
              $currContent[0].style.display = 'none';
            }
          }
        });
      }

      /**
       * Teardown normal tabs.
       */

    }, {
      key: "_teardownNormalTabs",
      value: function _teardownNormalTabs() {
        // show Tabs Content
        this.$tabLinks.each(function (link) {
          if (!!link.hash) {
            var $currContent = $(M.escapeHash(link.hash));
            if ($currContent.length) {
              $currContent[0].style.display = '';
            }
          }
        });
      }

      /**
       * set tabs and tab width
       */

    }, {
      key: "_setTabsAndTabWidth",
      value: function _setTabsAndTabWidth() {
        this.tabsWidth = this.$el.width();
        this.tabWidth = Math.max(this.tabsWidth, this.el.scrollWidth) / this.$tabLinks.length;
      }

      /**
       * Finds right attribute for indicator based on active tab.
       * @param {cash} el
       */

    }, {
      key: "_calcRightPos",
      value: function _calcRightPos(el) {
        return Math.ceil(this.tabsWidth - el.position().left - el[0].getBoundingClientRect().width);
      }

      /**
       * Finds left attribute for indicator based on active tab.
       * @param {cash} el
       */

    }, {
      key: "_calcLeftPos",
      value: function _calcLeftPos(el) {
        return Math.floor(el.position().left);
      }
    }, {
      key: "updateTabIndicator",
      value: function updateTabIndicator() {
        this._setTabsAndTabWidth();
        this._animateIndicator(this.index);
      }

      /**
       * Animates Indicator to active tab.
       * @param {Number} prevIndex
       */

    }, {
      key: "_animateIndicator",
      value: function _animateIndicator(prevIndex) {
        var leftDelay = 0,
            rightDelay = 0;

        if (this.index - prevIndex >= 0) {
          leftDelay = 90;
        } else {
          rightDelay = 90;
        }

        // Animate
        var animOptions = {
          targets: this._indicator,
          left: {
            value: this._calcLeftPos(this.$activeTabLink),
            delay: leftDelay
          },
          right: {
            value: this._calcRightPos(this.$activeTabLink),
            delay: rightDelay
          },
          duration: this.options.duration,
          easing: 'easeOutQuad'
        };
        anim.remove(this._indicator);
        anim(animOptions);
      }

      /**
       * Select tab.
       * @param {String} tabId
       */

    }, {
      key: "select",
      value: function select(tabId) {
        var tab = this.$tabLinks.filter('[href="#' + tabId + '"]');
        if (tab.length) {
          tab.trigger('click');
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Tabs.__proto__ || Object.getPrototypeOf(Tabs), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Tabs;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Tabs;
  }(Component);

  M.Tabs = Tabs;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Tabs, 'tabs', 'M_Tabs');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    exitDelay: 200,
    enterDelay: 0,
    html: null,
    margin: 5,
    inDuration: 250,
    outDuration: 200,
    position: 'bottom',
    transitionMovement: 10
  };

  /**
   * @class
   *
   */

  var Tooltip = function (_Component7) {
    _inherits(Tooltip, _Component7);

    /**
     * Construct Tooltip instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Tooltip(el, options) {
      _classCallCheck(this, Tooltip);

      var _this26 = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, Tooltip, el, options));

      _this26.el.M_Tooltip = _this26;
      _this26.options = $.extend({}, Tooltip.defaults, options);

      _this26.isOpen = false;
      _this26.isHovered = false;
      _this26.isFocused = false;
      _this26._appendTooltipEl();
      _this26._setupEventHandlers();
      return _this26;
    }

    _createClass(Tooltip, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        $(this.tooltipEl).remove();
        this._removeEventHandlers();
        this.el.M_Tooltip = undefined;
      }
    }, {
      key: "_appendTooltipEl",
      value: function _appendTooltipEl() {
        var tooltipEl = document.createElement('div');
        tooltipEl.classList.add('material-tooltip');
        this.tooltipEl = tooltipEl;

        var tooltipContentEl = document.createElement('div');
        tooltipContentEl.classList.add('tooltip-content');
        tooltipContentEl.innerHTML = this.options.html;
        tooltipEl.appendChild(tooltipContentEl);
        document.body.appendChild(tooltipEl);
      }
    }, {
      key: "_updateTooltipContent",
      value: function _updateTooltipContent() {
        this.tooltipEl.querySelector('.tooltip-content').innerHTML = this.options.html;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
        this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
        this._handleFocusBound = this._handleFocus.bind(this);
        this._handleBlurBound = this._handleBlur.bind(this);
        this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
        this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
        this.el.addEventListener('focus', this._handleFocusBound, true);
        this.el.addEventListener('blur', this._handleBlurBound, true);
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
        this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
        this.el.removeEventListener('focus', this._handleFocusBound, true);
        this.el.removeEventListener('blur', this._handleBlurBound, true);
      }
    }, {
      key: "open",
      value: function open(isManual) {
        if (this.isOpen) {
          return;
        }
        isManual = isManual === undefined ? true : undefined; // Default value true
        this.isOpen = true;
        // Update tooltip content with HTML attribute options
        this.options = $.extend({}, this.options, this._getAttributeOptions());
        this._updateTooltipContent();
        this._setEnterDelayTimeout(isManual);
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isHovered = false;
        this.isFocused = false;
        this.isOpen = false;
        this._setExitDelayTimeout();
      }

      /**
       * Create timeout which delays when the tooltip closes
       */

    }, {
      key: "_setExitDelayTimeout",
      value: function _setExitDelayTimeout() {
        var _this27 = this;

        clearTimeout(this._exitDelayTimeout);

        this._exitDelayTimeout = setTimeout(function () {
          if (_this27.isHovered || _this27.isFocused) {
            return;
          }

          _this27._animateOut();
        }, this.options.exitDelay);
      }

      /**
       * Create timeout which delays when the toast closes
       */

    }, {
      key: "_setEnterDelayTimeout",
      value: function _setEnterDelayTimeout(isManual) {
        var _this28 = this;

        clearTimeout(this._enterDelayTimeout);

        this._enterDelayTimeout = setTimeout(function () {
          if (!_this28.isHovered && !_this28.isFocused && !isManual) {
            return;
          }

          _this28._animateIn();
        }, this.options.enterDelay);
      }
    }, {
      key: "_positionTooltip",
      value: function _positionTooltip() {
        var origin = this.el,
            tooltip = this.tooltipEl,
            originHeight = origin.offsetHeight,
            originWidth = origin.offsetWidth,
            tooltipHeight = tooltip.offsetHeight,
            tooltipWidth = tooltip.offsetWidth,
            newCoordinates = void 0,
            margin = this.options.margin,
            targetTop = void 0,
            targetLeft = void 0;

        this.xMovement = 0, this.yMovement = 0;

        targetTop = origin.getBoundingClientRect().top + M.getDocumentScrollTop();
        targetLeft = origin.getBoundingClientRect().left + M.getDocumentScrollLeft();

        if (this.options.position === 'top') {
          targetTop += -tooltipHeight - margin;
          targetLeft += originWidth / 2 - tooltipWidth / 2;
          this.yMovement = -this.options.transitionMovement;
        } else if (this.options.position === 'right') {
          targetTop += originHeight / 2 - tooltipHeight / 2;
          targetLeft += originWidth + margin;
          this.xMovement = this.options.transitionMovement;
        } else if (this.options.position === 'left') {
          targetTop += originHeight / 2 - tooltipHeight / 2;
          targetLeft += -tooltipWidth - margin;
          this.xMovement = -this.options.transitionMovement;
        } else {
          targetTop += originHeight + margin;
          targetLeft += originWidth / 2 - tooltipWidth / 2;
          this.yMovement = this.options.transitionMovement;
        }

        newCoordinates = this._repositionWithinScreen(targetLeft, targetTop, tooltipWidth, tooltipHeight);
        $(tooltip).css({
          top: newCoordinates.y + 'px',
          left: newCoordinates.x + 'px'
        });
      }
    }, {
      key: "_repositionWithinScreen",
      value: function _repositionWithinScreen(x, y, width, height) {
        var scrollLeft = M.getDocumentScrollLeft();
        var scrollTop = M.getDocumentScrollTop();
        var newX = x - scrollLeft;
        var newY = y - scrollTop;

        var bounding = {
          left: newX,
          top: newY,
          width: width,
          height: height
        };

        var offset = this.options.margin + this.options.transitionMovement;
        var edges = M.checkWithinContainer(document.body, bounding, offset);

        if (edges.left) {
          newX = offset;
        } else if (edges.right) {
          newX -= newX + width - window.innerWidth;
        }

        if (edges.top) {
          newY = offset;
        } else if (edges.bottom) {
          newY -= newY + height - window.innerHeight;
        }

        return {
          x: newX + scrollLeft,
          y: newY + scrollTop
        };
      }
    }, {
      key: "_animateIn",
      value: function _animateIn() {
        this._positionTooltip();
        this.tooltipEl.style.visibility = 'visible';
        anim.remove(this.tooltipEl);
        anim({
          targets: this.tooltipEl,
          opacity: 1,
          translateX: this.xMovement,
          translateY: this.yMovement,
          duration: this.options.inDuration,
          easing: 'easeOutCubic'
        });
      }
    }, {
      key: "_animateOut",
      value: function _animateOut() {
        anim.remove(this.tooltipEl);
        anim({
          targets: this.tooltipEl,
          opacity: 0,
          translateX: 0,
          translateY: 0,
          duration: this.options.outDuration,
          easing: 'easeOutCubic'
        });
      }
    }, {
      key: "_handleMouseEnter",
      value: function _handleMouseEnter() {
        this.isHovered = true;
        this.isFocused = false; // Allows close of tooltip when opened by focus.
        this.open(false);
      }
    }, {
      key: "_handleMouseLeave",
      value: function _handleMouseLeave() {
        this.isHovered = false;
        this.isFocused = false; // Allows close of tooltip when opened by focus.
        this.close();
      }
    }, {
      key: "_handleFocus",
      value: function _handleFocus() {
        if (M.tabPressed) {
          this.isFocused = true;
          this.open(false);
        }
      }
    }, {
      key: "_handleBlur",
      value: function _handleBlur() {
        this.isFocused = false;
        this.close();
      }
    }, {
      key: "_getAttributeOptions",
      value: function _getAttributeOptions() {
        var attributeOptions = {};
        var tooltipTextOption = this.el.getAttribute('data-tooltip');
        var positionOption = this.el.getAttribute('data-position');

        if (tooltipTextOption) {
          attributeOptions.html = tooltipTextOption;
        }

        if (positionOption) {
          attributeOptions.position = positionOption;
        }
        return attributeOptions;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Tooltip.__proto__ || Object.getPrototypeOf(Tooltip), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Tooltip;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Tooltip;
  }(Component);

  M.Tooltip = Tooltip;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Tooltip, 'tooltip', 'M_Tooltip');
  }
})(cash, M.anime);
; /*!
  * Waves v0.6.4
  * http://fian.my.id/Waves
  *
  * Copyright 2014 Alfiana E. Sibuea and other contributors
  * Released under the MIT license
  * https://github.com/fians/Waves/blob/master/LICENSE
  */

;(function (window) {
  'use strict';

  var Waves = Waves || {};
  var $$ = document.querySelectorAll.bind(document);

  // Find exact position of element
  function isWindow(obj) {
    return obj !== null && obj === obj.window;
  }

  function getWindow(elem) {
    return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
  }

  function offset(elem) {
    var docElem,
        win,
        box = { top: 0, left: 0 },
        doc = elem && elem.ownerDocument;

    docElem = doc.documentElement;

    if (typeof elem.getBoundingClientRect !== typeof undefined) {
      box = elem.getBoundingClientRect();
    }
    win = getWindow(doc);
    return {
      top: box.top + win.pageYOffset - docElem.clientTop,
      left: box.left + win.pageXOffset - docElem.clientLeft
    };
  }

  function convertStyle(obj) {
    var style = '';

    for (var a in obj) {
      if (obj.hasOwnProperty(a)) {
        style += a + ':' + obj[a] + ';';
      }
    }

    return style;
  }

  var Effect = {

    // Effect delay
    duration: 750,

    show: function (e, element) {

      // Disable right click
      if (e.button === 2) {
        return false;
      }

      var el = element || this;

      // Create ripple
      var ripple = document.createElement('div');
      ripple.className = 'waves-ripple';
      el.appendChild(ripple);

      // Get click coordinate and element witdh
      var pos = offset(el);
      var relativeY = e.pageY - pos.top;
      var relativeX = e.pageX - pos.left;
      var scale = 'scale(' + el.clientWidth / 100 * 10 + ')';

      // Support for touch devices
      if ('touches' in e) {
        relativeY = e.touches[0].pageY - pos.top;
        relativeX = e.touches[0].pageX - pos.left;
      }

      // Attach data to element
      ripple.setAttribute('data-hold', Date.now());
      ripple.setAttribute('data-scale', scale);
      ripple.setAttribute('data-x', relativeX);
      ripple.setAttribute('data-y', relativeY);

      // Set ripple position
      var rippleStyle = {
        'top': relativeY + 'px',
        'left': relativeX + 'px'
      };

      ripple.className = ripple.className + ' waves-notransition';
      ripple.setAttribute('style', convertStyle(rippleStyle));
      ripple.className = ripple.className.replace('waves-notransition', '');

      // Scale the ripple
      rippleStyle['-webkit-transform'] = scale;
      rippleStyle['-moz-transform'] = scale;
      rippleStyle['-ms-transform'] = scale;
      rippleStyle['-o-transform'] = scale;
      rippleStyle.transform = scale;
      rippleStyle.opacity = '1';

      rippleStyle['-webkit-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['-moz-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['-o-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['transition-duration'] = Effect.duration + 'ms';

      rippleStyle['-webkit-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['-moz-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['-o-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';

      ripple.setAttribute('style', convertStyle(rippleStyle));
    },

    hide: function (e) {
      TouchHandler.touchup(e);

      var el = this;
      var width = el.clientWidth * 1.4;

      // Get first ripple
      var ripple = null;
      var ripples = el.getElementsByClassName('waves-ripple');
      if (ripples.length > 0) {
        ripple = ripples[ripples.length - 1];
      } else {
        return false;
      }

      var relativeX = ripple.getAttribute('data-x');
      var relativeY = ripple.getAttribute('data-y');
      var scale = ripple.getAttribute('data-scale');

      // Get delay beetween mousedown and mouse leave
      var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
      var delay = 350 - diff;

      if (delay < 0) {
        delay = 0;
      }

      // Fade out ripple after delay
      setTimeout(function () {
        var style = {
          'top': relativeY + 'px',
          'left': relativeX + 'px',
          'opacity': '0',

          // Duration
          '-webkit-transition-duration': Effect.duration + 'ms',
          '-moz-transition-duration': Effect.duration + 'ms',
          '-o-transition-duration': Effect.duration + 'ms',
          'transition-duration': Effect.duration + 'ms',
          '-webkit-transform': scale,
          '-moz-transform': scale,
          '-ms-transform': scale,
          '-o-transform': scale,
          'transform': scale
        };

        ripple.setAttribute('style', convertStyle(style));

        setTimeout(function () {
          try {
            el.removeChild(ripple);
          } catch (e) {
            return false;
          }
        }, Effect.duration);
      }, delay);
    },

    // Little hack to make <input> can perform waves effect
    wrapInput: function (elements) {
      for (var a = 0; a < elements.length; a++) {
        var el = elements[a];

        if (el.tagName.toLowerCase() === 'input') {
          var parent = el.parentNode;

          // If input already have parent just pass through
          if (parent.tagName.toLowerCase() === 'i' && parent.className.indexOf('waves-effect') !== -1) {
            continue;
          }

          // Put element class and style to the specified parent
          var wrapper = document.createElement('i');
          wrapper.className = el.className + ' waves-input-wrapper';

          var elementStyle = el.getAttribute('style');

          if (!elementStyle) {
            elementStyle = '';
          }

          wrapper.setAttribute('style', elementStyle);

          el.className = 'waves-button-input';
          el.removeAttribute('style');

          // Put element as child
          parent.replaceChild(wrapper, el);
          wrapper.appendChild(el);
        }
      }
    }
  };

  /**
   * Disable mousedown event for 500ms during and after touch
   */
  var TouchHandler = {
    /* uses an integer rather than bool so there's no issues with
     * needing to clear timeouts if another touch event occurred
     * within the 500ms. Cannot mouseup between touchstart and
     * touchend, nor in the 500ms after touchend. */
    touches: 0,
    allowEvent: function (e) {
      var allow = true;

      if (e.type === 'touchstart') {
        TouchHandler.touches += 1; //push
      } else if (e.type === 'touchend' || e.type === 'touchcancel') {
        setTimeout(function () {
          if (TouchHandler.touches > 0) {
            TouchHandler.touches -= 1; //pop after 500ms
          }
        }, 500);
      } else if (e.type === 'mousedown' && TouchHandler.touches > 0) {
        allow = false;
      }

      return allow;
    },
    touchup: function (e) {
      TouchHandler.allowEvent(e);
    }
  };

  /**
   * Delegated click handler for .waves-effect element.
   * returns null when .waves-effect element not in "click tree"
   */
  function getWavesEffectElement(e) {
    if (TouchHandler.allowEvent(e) === false) {
      return null;
    }

    var element = null;
    var target = e.target || e.srcElement;

    while (target.parentNode !== null) {
      if (!(target instanceof SVGElement) && target.className.indexOf('waves-effect') !== -1) {
        element = target;
        break;
      }
      target = target.parentNode;
    }
    return element;
  }

  /**
   * Bubble the click and show effect if .waves-effect elem was found
   */
  function showEffect(e) {
    var element = getWavesEffectElement(e);

    if (element !== null) {
      Effect.show(e, element);

      if ('ontouchstart' in window) {
        element.addEventListener('touchend', Effect.hide, false);
        element.addEventListener('touchcancel', Effect.hide, false);
      }

      element.addEventListener('mouseup', Effect.hide, false);
      element.addEventListener('mouseleave', Effect.hide, false);
      element.addEventListener('dragend', Effect.hide, false);
    }
  }

  Waves.displayEffect = function (options) {
    options = options || {};

    if ('duration' in options) {
      Effect.duration = options.duration;
    }

    //Wrap input inside <i> tag
    Effect.wrapInput($$('.waves-effect'));

    if ('ontouchstart' in window) {
      document.body.addEventListener('touchstart', showEffect, false);
    }

    document.body.addEventListener('mousedown', showEffect, false);
  };

  /**
   * Attach Waves to an input element (or any element which doesn't
   * bubble mouseup/mousedown events).
   *   Intended to be used with dynamically loaded forms/inputs, or
   * where the user doesn't want a delegated click handler.
   */
  Waves.attach = function (element) {
    //FUTURE: automatically add waves classes and allow users
    // to specify them with an options param? Eg. light/classic/button
    if (element.tagName.toLowerCase() === 'input') {
      Effect.wrapInput([element]);
      element = element.parentNode;
    }

    if ('ontouchstart' in window) {
      element.addEventListener('touchstart', showEffect, false);
    }

    element.addEventListener('mousedown', showEffect, false);
  };

  window.Waves = Waves;

  document.addEventListener('DOMContentLoaded', function () {
    Waves.displayEffect();
  }, false);
})(window);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    html: '',
    displayLength: 4000,
    inDuration: 300,
    outDuration: 375,
    classes: '',
    completeCallback: null,
    activationPercent: 0.8
  };

  var Toast = function () {
    function Toast(options) {
      _classCallCheck(this, Toast);

      /**
       * Options for the toast
       * @member Toast#options
       */
      this.options = $.extend({}, Toast.defaults, options);
      this.message = this.options.html;

      /**
       * Describes current pan state toast
       * @type {Boolean}
       */
      this.panning = false;

      /**
       * Time remaining until toast is removed
       */
      this.timeRemaining = this.options.displayLength;

      if (Toast._toasts.length === 0) {
        Toast._createContainer();
      }

      // Create new toast
      Toast._toasts.push(this);
      var toastElement = this._createToast();
      toastElement.M_Toast = this;
      this.el = toastElement;
      this.$el = $(toastElement);
      this._animateIn();
      this._setTimer();
    }

    _createClass(Toast, [{
      key: "_createToast",


      /**
       * Create toast and append it to toast container
       */
      value: function _createToast() {
        var toast = document.createElement('div');
        toast.classList.add('toast');

        // Add custom classes onto toast
        if (!!this.options.classes.length) {
          $(toast).addClass(this.options.classes);
        }

        // Set content
        if (typeof HTMLElement === 'object' ? this.message instanceof HTMLElement : this.message && typeof this.message === 'object' && this.message !== null && this.message.nodeType === 1 && typeof this.message.nodeName === 'string') {
          toast.appendChild(this.message);

          // Check if it is jQuery object
        } else if (!!this.message.jquery) {
          $(toast).append(this.message[0]);

          // Insert as html;
        } else {
          toast.innerHTML = this.message;
        }

        // Append toasft
        Toast._container.appendChild(toast);
        return toast;
      }

      /**
       * Animate in toast
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        // Animate toast in
        anim({
          targets: this.el,
          top: 0,
          opacity: 1,
          duration: this.options.inDuration,
          easing: 'easeOutCubic'
        });
      }

      /**
       * Create setInterval which automatically removes toast when timeRemaining >= 0
       * has been reached
       */

    }, {
      key: "_setTimer",
      value: function _setTimer() {
        var _this29 = this;

        if (this.timeRemaining !== Infinity) {
          this.counterInterval = setInterval(function () {
            // If toast is not being dragged, decrease its time remaining
            if (!_this29.panning) {
              _this29.timeRemaining -= 20;
            }

            // Animate toast out
            if (_this29.timeRemaining <= 0) {
              _this29.dismiss();
            }
          }, 20);
        }
      }

      /**
       * Dismiss toast with animation
       */

    }, {
      key: "dismiss",
      value: function dismiss() {
        var _this30 = this;

        window.clearInterval(this.counterInterval);
        var activationDistance = this.el.offsetWidth * this.options.activationPercent;

        if (this.wasSwiped) {
          this.el.style.transition = 'transform .05s, opacity .05s';
          this.el.style.transform = "translateX(" + activationDistance + "px)";
          this.el.style.opacity = 0;
        }

        anim({
          targets: this.el,
          opacity: 0,
          marginTop: -40,
          duration: this.options.outDuration,
          easing: 'easeOutExpo',
          complete: function () {
            // Call the optional callback
            if (typeof _this30.options.completeCallback === 'function') {
              _this30.options.completeCallback();
            }
            // Remove toast from DOM
            _this30.$el.remove();
            Toast._toasts.splice(Toast._toasts.indexOf(_this30), 1);
            if (Toast._toasts.length === 0) {
              Toast._removeContainer();
            }
          }
        });
      }
    }], [{
      key: "getInstance",


      /**
       * Get Instance
       */
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Toast;
      }

      /**
       * Append toast container and add event handlers
       */

    }, {
      key: "_createContainer",
      value: function _createContainer() {
        var container = document.createElement('div');
        container.setAttribute('id', 'toast-container');

        // Add event handler
        container.addEventListener('touchstart', Toast._onDragStart);
        container.addEventListener('touchmove', Toast._onDragMove);
        container.addEventListener('touchend', Toast._onDragEnd);

        container.addEventListener('mousedown', Toast._onDragStart);
        document.addEventListener('mousemove', Toast._onDragMove);
        document.addEventListener('mouseup', Toast._onDragEnd);

        document.body.appendChild(container);
        Toast._container = container;
      }

      /**
       * Remove toast container and event handlers
       */

    }, {
      key: "_removeContainer",
      value: function _removeContainer() {
        // Add event handler
        document.removeEventListener('mousemove', Toast._onDragMove);
        document.removeEventListener('mouseup', Toast._onDragEnd);

        $(Toast._container).remove();
        Toast._container = null;
      }

      /**
       * Begin drag handler
       * @param {Event} e
       */

    }, {
      key: "_onDragStart",
      value: function _onDragStart(e) {
        if (e.target && $(e.target).closest('.toast').length) {
          var $toast = $(e.target).closest('.toast');
          var toast = $toast[0].M_Toast;
          toast.panning = true;
          Toast._draggedToast = toast;
          toast.el.classList.add('panning');
          toast.el.style.transition = '';
          toast.startingXPos = Toast._xPos(e);
          toast.time = Date.now();
          toast.xPos = Toast._xPos(e);
        }
      }

      /**
       * Drag move handler
       * @param {Event} e
       */

    }, {
      key: "_onDragMove",
      value: function _onDragMove(e) {
        if (!!Toast._draggedToast) {
          e.preventDefault();
          var toast = Toast._draggedToast;
          toast.deltaX = Math.abs(toast.xPos - Toast._xPos(e));
          toast.xPos = Toast._xPos(e);
          toast.velocityX = toast.deltaX / (Date.now() - toast.time);
          toast.time = Date.now();

          var totalDeltaX = toast.xPos - toast.startingXPos;
          var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
          toast.el.style.transform = "translateX(" + totalDeltaX + "px)";
          toast.el.style.opacity = 1 - Math.abs(totalDeltaX / activationDistance);
        }
      }

      /**
       * End drag handler
       */

    }, {
      key: "_onDragEnd",
      value: function _onDragEnd() {
        if (!!Toast._draggedToast) {
          var toast = Toast._draggedToast;
          toast.panning = false;
          toast.el.classList.remove('panning');

          var totalDeltaX = toast.xPos - toast.startingXPos;
          var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
          var shouldBeDismissed = Math.abs(totalDeltaX) > activationDistance || toast.velocityX > 1;

          // Remove toast
          if (shouldBeDismissed) {
            toast.wasSwiped = true;
            toast.dismiss();

            // Animate toast back to original position
          } else {
            toast.el.style.transition = 'transform .2s, opacity .2s';
            toast.el.style.transform = '';
            toast.el.style.opacity = '';
          }
          Toast._draggedToast = null;
        }
      }

      /**
       * Get x position of mouse or touch event
       * @param {Event} e
       */

    }, {
      key: "_xPos",
      value: function _xPos(e) {
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientX;
        }
        // mouse event
        return e.clientX;
      }

      /**
       * Remove all toasts
       */

    }, {
      key: "dismissAll",
      value: function dismissAll() {
        for (var toastIndex in Toast._toasts) {
          Toast._toasts[toastIndex].dismiss();
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Toast;
  }();

  /**
   * @static
   * @memberof Toast
   * @type {Array.<Toast>}
   */


  Toast._toasts = [];

  /**
   * @static
   * @memberof Toast
   */
  Toast._container = null;

  /**
   * @static
   * @memberof Toast
   * @type {Toast}
   */
  Toast._draggedToast = null;

  M.Toast = Toast;
  M.toast = function (options) {
    return new Toast(options);
  };
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    edge: 'left',
    draggable: true,
    inDuration: 250,
    outDuration: 200,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    preventScrolling: true
  };

  /**
   * @class
   */

  var Sidenav = function (_Component8) {
    _inherits(Sidenav, _Component8);

    /**
     * Construct Sidenav instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Sidenav(el, options) {
      _classCallCheck(this, Sidenav);

      var _this31 = _possibleConstructorReturn(this, (Sidenav.__proto__ || Object.getPrototypeOf(Sidenav)).call(this, Sidenav, el, options));

      _this31.el.M_Sidenav = _this31;
      _this31.id = _this31.$el.attr('id');

      /**
       * Options for the Sidenav
       * @member Sidenav#options
       * @prop {String} [edge='left'] - Side of screen on which Sidenav appears
       * @prop {Boolean} [draggable=true] - Allow swipe gestures to open/close Sidenav
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Function called when sidenav starts entering
       * @prop {Function} onOpenEnd - Function called when sidenav finishes entering
       * @prop {Function} onCloseStart - Function called when sidenav starts exiting
       * @prop {Function} onCloseEnd - Function called when sidenav finishes exiting
       */
      _this31.options = $.extend({}, Sidenav.defaults, options);

      /**
       * Describes open/close state of Sidenav
       * @type {Boolean}
       */
      _this31.isOpen = false;

      /**
       * Describes if Sidenav is fixed
       * @type {Boolean}
       */
      _this31.isFixed = _this31.el.classList.contains('sidenav-fixed');

      /**
       * Describes if Sidenav is being draggeed
       * @type {Boolean}
       */
      _this31.isDragged = false;

      // Window size variables for window resize checks
      _this31.lastWindowWidth = window.innerWidth;
      _this31.lastWindowHeight = window.innerHeight;

      _this31._createOverlay();
      _this31._createDragTarget();
      _this31._setupEventHandlers();
      _this31._setupClasses();
      _this31._setupFixed();

      Sidenav._sidenavs.push(_this31);
      return _this31;
    }

    _createClass(Sidenav, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._enableBodyScrolling();
        this._overlay.parentNode.removeChild(this._overlay);
        this.dragTarget.parentNode.removeChild(this.dragTarget);
        this.el.M_Sidenav = undefined;
        this.el.style.transform = '';

        var index = Sidenav._sidenavs.indexOf(this);
        if (index >= 0) {
          Sidenav._sidenavs.splice(index, 1);
        }
      }
    }, {
      key: "_createOverlay",
      value: function _createOverlay() {
        var overlay = document.createElement('div');
        this._closeBound = this.close.bind(this);
        overlay.classList.add('sidenav-overlay');

        overlay.addEventListener('click', this._closeBound);

        document.body.appendChild(overlay);
        this._overlay = overlay;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        if (Sidenav._sidenavs.length === 0) {
          document.body.addEventListener('click', this._handleTriggerClick);
        }

        this._handleDragTargetDragBound = this._handleDragTargetDrag.bind(this);
        this._handleDragTargetReleaseBound = this._handleDragTargetRelease.bind(this);
        this._handleCloseDragBound = this._handleCloseDrag.bind(this);
        this._handleCloseReleaseBound = this._handleCloseRelease.bind(this);
        this._handleCloseTriggerClickBound = this._handleCloseTriggerClick.bind(this);

        this.dragTarget.addEventListener('touchmove', this._handleDragTargetDragBound);
        this.dragTarget.addEventListener('touchend', this._handleDragTargetReleaseBound);
        this._overlay.addEventListener('touchmove', this._handleCloseDragBound);
        this._overlay.addEventListener('touchend', this._handleCloseReleaseBound);
        this.el.addEventListener('touchmove', this._handleCloseDragBound);
        this.el.addEventListener('touchend', this._handleCloseReleaseBound);
        this.el.addEventListener('click', this._handleCloseTriggerClickBound);

        // Add resize for side nav fixed
        if (this.isFixed) {
          this._handleWindowResizeBound = this._handleWindowResize.bind(this);
          window.addEventListener('resize', this._handleWindowResizeBound);
        }
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (Sidenav._sidenavs.length === 1) {
          document.body.removeEventListener('click', this._handleTriggerClick);
        }

        this.dragTarget.removeEventListener('touchmove', this._handleDragTargetDragBound);
        this.dragTarget.removeEventListener('touchend', this._handleDragTargetReleaseBound);
        this._overlay.removeEventListener('touchmove', this._handleCloseDragBound);
        this._overlay.removeEventListener('touchend', this._handleCloseReleaseBound);
        this.el.removeEventListener('touchmove', this._handleCloseDragBound);
        this.el.removeEventListener('touchend', this._handleCloseReleaseBound);
        this.el.removeEventListener('click', this._handleCloseTriggerClickBound);

        // Remove resize for side nav fixed
        if (this.isFixed) {
          window.removeEventListener('resize', this._handleWindowResizeBound);
        }
      }

      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target).closest('.sidenav-trigger');
        if (e.target && $trigger.length) {
          var sidenavId = M.getIdFromTrigger($trigger[0]);

          var sidenavInstance = document.getElementById(sidenavId).M_Sidenav;
          if (sidenavInstance) {
            sidenavInstance.open($trigger);
          }
          e.preventDefault();
        }
      }

      /**
       * Set variables needed at the beggining of drag
       * and stop any current transition.
       * @param {Event} e
       */

    }, {
      key: "_startDrag",
      value: function _startDrag(e) {
        var clientX = e.targetTouches[0].clientX;
        this.isDragged = true;
        this._startingXpos = clientX;
        this._xPos = this._startingXpos;
        this._time = Date.now();
        this._width = this.el.getBoundingClientRect().width;
        this._overlay.style.display = 'block';
        this._initialScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
        this._verticallyScrolling = false;
        anim.remove(this.el);
        anim.remove(this._overlay);
      }

      /**
       * Set variables needed at each drag move update tick
       * @param {Event} e
       */

    }, {
      key: "_dragMoveUpdate",
      value: function _dragMoveUpdate(e) {
        var clientX = e.targetTouches[0].clientX;
        var currentScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
        this.deltaX = Math.abs(this._xPos - clientX);
        this._xPos = clientX;
        this.velocityX = this.deltaX / (Date.now() - this._time);
        this._time = Date.now();
        if (this._initialScrollTop !== currentScrollTop) {
          this._verticallyScrolling = true;
        }
      }

      /**
       * Handles Dragging of Sidenav
       * @param {Event} e
       */

    }, {
      key: "_handleDragTargetDrag",
      value: function _handleDragTargetDrag(e) {
        // Check if draggable
        if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) {
          return;
        }

        // If not being dragged, set initial drag start variables
        if (!this.isDragged) {
          this._startDrag(e);
        }

        // Run touchmove updates
        this._dragMoveUpdate(e);

        // Calculate raw deltaX
        var totalDeltaX = this._xPos - this._startingXpos;

        // dragDirection is the attempted user drag direction
        var dragDirection = totalDeltaX > 0 ? 'right' : 'left';

        // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
        totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
        if (this.options.edge === dragDirection) {
          totalDeltaX = 0;
        }

        /**
         * transformX is the drag displacement
         * transformPrefix is the initial transform placement
         * Invert values if Sidenav is right edge
         */
        var transformX = totalDeltaX;
        var transformPrefix = 'translateX(-100%)';
        if (this.options.edge === 'right') {
          transformPrefix = 'translateX(100%)';
          transformX = -transformX;
        }

        // Calculate open/close percentage of sidenav, with open = 1 and close = 0
        this.percentOpen = Math.min(1, totalDeltaX / this._width);

        // Set transform and opacity styles
        this.el.style.transform = transformPrefix + " translateX(" + transformX + "px)";
        this._overlay.style.opacity = this.percentOpen;
      }

      /**
       * Handle Drag Target Release
       */

    }, {
      key: "_handleDragTargetRelease",
      value: function _handleDragTargetRelease() {
        if (this.isDragged) {
          if (this.percentOpen > 0.2) {
            this.open();
          } else {
            this._animateOut();
          }

          this.isDragged = false;
          this._verticallyScrolling = false;
        }
      }

      /**
       * Handle Close Drag
       * @param {Event} e
       */

    }, {
      key: "_handleCloseDrag",
      value: function _handleCloseDrag(e) {
        if (this.isOpen) {
          // Check if draggable
          if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) {
            return;
          }

          // If not being dragged, set initial drag start variables
          if (!this.isDragged) {
            this._startDrag(e);
          }

          // Run touchmove updates
          this._dragMoveUpdate(e);

          // Calculate raw deltaX
          var totalDeltaX = this._xPos - this._startingXpos;

          // dragDirection is the attempted user drag direction
          var dragDirection = totalDeltaX > 0 ? 'right' : 'left';

          // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
          totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
          if (this.options.edge !== dragDirection) {
            totalDeltaX = 0;
          }

          var transformX = -totalDeltaX;
          if (this.options.edge === 'right') {
            transformX = -transformX;
          }

          // Calculate open/close percentage of sidenav, with open = 1 and close = 0
          this.percentOpen = Math.min(1, 1 - totalDeltaX / this._width);

          // Set transform and opacity styles
          this.el.style.transform = "translateX(" + transformX + "px)";
          this._overlay.style.opacity = this.percentOpen;
        }
      }

      /**
       * Handle Close Release
       */

    }, {
      key: "_handleCloseRelease",
      value: function _handleCloseRelease() {
        if (this.isOpen && this.isDragged) {
          if (this.percentOpen > 0.8) {
            this._animateIn();
          } else {
            this.close();
          }

          this.isDragged = false;
          this._verticallyScrolling = false;
        }
      }

      /**
       * Handles closing of Sidenav when element with class .sidenav-close
       */

    }, {
      key: "_handleCloseTriggerClick",
      value: function _handleCloseTriggerClick(e) {
        var $closeTrigger = $(e.target).closest('.sidenav-close');
        if ($closeTrigger.length && !this._isCurrentlyFixed()) {
          this.close();
        }
      }

      /**
       * Handle Window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        // Only handle horizontal resizes
        if (this.lastWindowWidth !== window.innerWidth) {
          if (window.innerWidth > 992) {
            this.open();
          } else {
            this.close();
          }
        }

        this.lastWindowWidth = window.innerWidth;
        this.lastWindowHeight = window.innerHeight;
      }
    }, {
      key: "_setupClasses",
      value: function _setupClasses() {
        if (this.options.edge === 'right') {
          this.el.classList.add('right-aligned');
          this.dragTarget.classList.add('right-aligned');
        }
      }
    }, {
      key: "_removeClasses",
      value: function _removeClasses() {
        this.el.classList.remove('right-aligned');
        this.dragTarget.classList.remove('right-aligned');
      }
    }, {
      key: "_setupFixed",
      value: function _setupFixed() {
        if (this._isCurrentlyFixed()) {
          this.open();
        }
      }
    }, {
      key: "_isCurrentlyFixed",
      value: function _isCurrentlyFixed() {
        return this.isFixed && window.innerWidth > 992;
      }
    }, {
      key: "_createDragTarget",
      value: function _createDragTarget() {
        var dragTarget = document.createElement('div');
        dragTarget.classList.add('drag-target');
        document.body.appendChild(dragTarget);
        this.dragTarget = dragTarget;
      }
    }, {
      key: "_preventBodyScrolling",
      value: function _preventBodyScrolling() {
        var body = document.body;
        body.style.overflow = 'hidden';
      }
    }, {
      key: "_enableBodyScrolling",
      value: function _enableBodyScrolling() {
        var body = document.body;
        body.style.overflow = '';
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen === true) {
          return;
        }

        this.isOpen = true;

        // Run onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        }

        // Handle fixed Sidenav
        if (this._isCurrentlyFixed()) {
          anim.remove(this.el);
          anim({
            targets: this.el,
            translateX: 0,
            duration: 0,
            easing: 'easeOutQuad'
          });
          this._enableBodyScrolling();
          this._overlay.style.display = 'none';

          // Handle non-fixed Sidenav
        } else {
          if (this.options.preventScrolling) {
            this._preventBodyScrolling();
          }

          if (!this.isDragged || this.percentOpen != 1) {
            this._animateIn();
          }
        }
      }
    }, {
      key: "close",
      value: function close() {
        if (this.isOpen === false) {
          return;
        }

        this.isOpen = false;

        // Run onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        // Handle fixed Sidenav
        if (this._isCurrentlyFixed()) {
          var transformX = this.options.edge === 'left' ? '-105%' : '105%';
          this.el.style.transform = "translateX(" + transformX + ")";

          // Handle non-fixed Sidenav
        } else {
          this._enableBodyScrolling();

          if (!this.isDragged || this.percentOpen != 0) {
            this._animateOut();
          } else {
            this._overlay.style.display = 'none';
          }
        }
      }
    }, {
      key: "_animateIn",
      value: function _animateIn() {
        this._animateSidenavIn();
        this._animateOverlayIn();
      }
    }, {
      key: "_animateSidenavIn",
      value: function _animateSidenavIn() {
        var _this32 = this;

        var slideOutPercent = this.options.edge === 'left' ? -1 : 1;
        if (this.isDragged) {
          slideOutPercent = this.options.edge === 'left' ? slideOutPercent + this.percentOpen : slideOutPercent - this.percentOpen;
        }

        anim.remove(this.el);
        anim({
          targets: this.el,
          translateX: [slideOutPercent * 100 + "%", 0],
          duration: this.options.inDuration,
          easing: 'easeOutQuad',
          complete: function () {
            // Run onOpenEnd callback
            if (typeof _this32.options.onOpenEnd === 'function') {
              _this32.options.onOpenEnd.call(_this32, _this32.el);
            }
          }
        });
      }
    }, {
      key: "_animateOverlayIn",
      value: function _animateOverlayIn() {
        var start = 0;
        if (this.isDragged) {
          start = this.percentOpen;
        } else {
          $(this._overlay).css({
            display: 'block'
          });
        }

        anim.remove(this._overlay);
        anim({
          targets: this._overlay,
          opacity: [start, 1],
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        });
      }
    }, {
      key: "_animateOut",
      value: function _animateOut() {
        this._animateSidenavOut();
        this._animateOverlayOut();
      }
    }, {
      key: "_animateSidenavOut",
      value: function _animateSidenavOut() {
        var _this33 = this;

        var endPercent = this.options.edge === 'left' ? -1 : 1;
        var slideOutPercent = 0;
        if (this.isDragged) {
          slideOutPercent = this.options.edge === 'left' ? endPercent + this.percentOpen : endPercent - this.percentOpen;
        }

        anim.remove(this.el);
        anim({
          targets: this.el,
          translateX: [slideOutPercent * 100 + "%", endPercent * 105 + "%"],
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            // Run onOpenEnd callback
            if (typeof _this33.options.onCloseEnd === 'function') {
              _this33.options.onCloseEnd.call(_this33, _this33.el);
            }
          }
        });
      }
    }, {
      key: "_animateOverlayOut",
      value: function _animateOverlayOut() {
        var _this34 = this;

        anim.remove(this._overlay);
        anim({
          targets: this._overlay,
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            $(_this34._overlay).css('display', 'none');
          }
        });
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Sidenav.__proto__ || Object.getPrototypeOf(Sidenav), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Sidenav;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Sidenav;
  }(Component);

  /**
   * @static
   * @memberof Sidenav
   * @type {Array.<Sidenav>}
   */


  Sidenav._sidenavs = [];

  M.Sidenav = Sidenav;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Sidenav, 'sidenav', 'M_Sidenav');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    throttle: 100,
    scrollOffset: 200, // offset - 200 allows elements near bottom of page to scroll
    activeClass: 'active',
    getActiveElement: function (id) {
      return 'a[href="#' + id + '"]';
    }
  };

  /**
   * @class
   *
   */

  var ScrollSpy = function (_Component9) {
    _inherits(ScrollSpy, _Component9);

    /**
     * Construct ScrollSpy instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function ScrollSpy(el, options) {
      _classCallCheck(this, ScrollSpy);

      var _this35 = _possibleConstructorReturn(this, (ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy)).call(this, ScrollSpy, el, options));

      _this35.el.M_ScrollSpy = _this35;

      /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [throttle=100] - Throttle of scroll handler
       * @prop {Number} [scrollOffset=200] - Offset for centering element when scrolled to
       * @prop {String} [activeClass='active'] - Class applied to active elements
       * @prop {Function} [getActiveElement] - Used to find active element
       */
      _this35.options = $.extend({}, ScrollSpy.defaults, options);

      // setup
      ScrollSpy._elements.push(_this35);
      ScrollSpy._count++;
      ScrollSpy._increment++;
      _this35.tickId = -1;
      _this35.id = ScrollSpy._increment;
      _this35._setupEventHandlers();
      _this35._handleWindowScroll();
      return _this35;
    }

    _createClass(ScrollSpy, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        ScrollSpy._elements.splice(ScrollSpy._elements.indexOf(this), 1);
        ScrollSpy._elementsInView.splice(ScrollSpy._elementsInView.indexOf(this), 1);
        ScrollSpy._visibleElements.splice(ScrollSpy._visibleElements.indexOf(this.$el), 1);
        ScrollSpy._count--;
        this._removeEventHandlers();
        $(this.options.getActiveElement(this.$el.attr('id'))).removeClass(this.options.activeClass);
        this.el.M_ScrollSpy = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var throttledResize = M.throttle(this._handleWindowScroll, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);
        this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
        if (ScrollSpy._count === 1) {
          window.addEventListener('scroll', this._handleWindowScrollBound);
          window.addEventListener('resize', this._handleThrottledResizeBound);
          document.body.addEventListener('click', this._handleTriggerClick);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (ScrollSpy._count === 0) {
          window.removeEventListener('scroll', this._handleWindowScrollBound);
          window.removeEventListener('resize', this._handleThrottledResizeBound);
          document.body.removeEventListener('click', this._handleTriggerClick);
        }
      }

      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target);
        for (var i = ScrollSpy._elements.length - 1; i >= 0; i--) {
          var scrollspy = ScrollSpy._elements[i];
          if ($trigger.is('a[href="#' + scrollspy.$el.attr('id') + '"]')) {
            e.preventDefault();
            var offset = scrollspy.$el.offset().top + 1;

            anim({
              targets: [document.documentElement, document.body],
              scrollTop: offset - scrollspy.options.scrollOffset,
              duration: 400,
              easing: 'easeOutCubic'
            });
            break;
          }
        }
      }

      /**
       * Handle Window Scroll
       */

    }, {
      key: "_handleWindowScroll",
      value: function _handleWindowScroll() {
        // unique tick id
        ScrollSpy._ticks++;

        // viewport rectangle
        var top = M.getDocumentScrollTop(),
            left = M.getDocumentScrollLeft(),
            right = left + window.innerWidth,
            bottom = top + window.innerHeight;

        // determine which elements are in view
        var intersections = ScrollSpy._findElements(top, right, bottom, left);
        for (var i = 0; i < intersections.length; i++) {
          var scrollspy = intersections[i];
          var lastTick = scrollspy.tickId;
          if (lastTick < 0) {
            // entered into view
            scrollspy._enter();
          }

          // update tick id
          scrollspy.tickId = ScrollSpy._ticks;
        }

        for (var _i = 0; _i < ScrollSpy._elementsInView.length; _i++) {
          var _scrollspy = ScrollSpy._elementsInView[_i];
          var _lastTick = _scrollspy.tickId;
          if (_lastTick >= 0 && _lastTick !== ScrollSpy._ticks) {
            // exited from view
            _scrollspy._exit();
            _scrollspy.tickId = -1;
          }
        }

        // remember elements in view for next tick
        ScrollSpy._elementsInView = intersections;
      }

      /**
       * Find elements that are within the boundary
       * @param {number} top
       * @param {number} right
       * @param {number} bottom
       * @param {number} left
       * @return {Array.<ScrollSpy>}   A collection of elements
       */

    }, {
      key: "_enter",
      value: function _enter() {
        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (value) {
          return value.height() != 0;
        });

        if (ScrollSpy._visibleElements[0]) {
          $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);
          if (ScrollSpy._visibleElements[0][0].M_ScrollSpy && this.id < ScrollSpy._visibleElements[0][0].M_ScrollSpy.id) {
            ScrollSpy._visibleElements.unshift(this.$el);
          } else {
            ScrollSpy._visibleElements.push(this.$el);
          }
        } else {
          ScrollSpy._visibleElements.push(this.$el);
        }

        $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
      }
    }, {
      key: "_exit",
      value: function _exit() {
        var _this36 = this;

        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (value) {
          return value.height() != 0;
        });

        if (ScrollSpy._visibleElements[0]) {
          $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);

          ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (el) {
            return el.attr('id') != _this36.$el.attr('id');
          });
          if (ScrollSpy._visibleElements[0]) {
            // Check if empty
            $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
          }
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_ScrollSpy;
      }
    }, {
      key: "_findElements",
      value: function _findElements(top, right, bottom, left) {
        var hits = [];
        for (var i = 0; i < ScrollSpy._elements.length; i++) {
          var scrollspy = ScrollSpy._elements[i];
          var currTop = top + scrollspy.options.scrollOffset || 200;

          if (scrollspy.$el.height() > 0) {
            var elTop = scrollspy.$el.offset().top,
                elLeft = scrollspy.$el.offset().left,
                elRight = elLeft + scrollspy.$el.width(),
                elBottom = elTop + scrollspy.$el.height();

            var isIntersect = !(elLeft > right || elRight < left || elTop > bottom || elBottom < currTop);

            if (isIntersect) {
              hits.push(scrollspy);
            }
          }
        }
        return hits;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return ScrollSpy;
  }(Component);

  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */


  ScrollSpy._elements = [];

  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */
  ScrollSpy._elementsInView = [];

  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<cash>}
   */
  ScrollSpy._visibleElements = [];

  /**
   * @static
   * @memberof ScrollSpy
   */
  ScrollSpy._count = 0;

  /**
   * @static
   * @memberof ScrollSpy
   */
  ScrollSpy._increment = 0;

  /**
   * @static
   * @memberof ScrollSpy
   */
  ScrollSpy._ticks = 0;

  M.ScrollSpy = ScrollSpy;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(ScrollSpy, 'scrollSpy', 'M_ScrollSpy');
  }
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    data: {}, // Autocomplete data set
    limit: Infinity, // Limit of results the autocomplete shows
    onAutocomplete: null, // Callback for when autocompleted
    minLength: 1, // Min characters before autocomplete starts
    sortFunction: function (a, b, inputString) {
      // Sort function for sorting autocomplete results
      return a.indexOf(inputString) - b.indexOf(inputString);
    }
  };

  /**
   * @class
   *
   */

  var Autocomplete = function (_Component10) {
    _inherits(Autocomplete, _Component10);

    /**
     * Construct Autocomplete instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Autocomplete(el, options) {
      _classCallCheck(this, Autocomplete);

      var _this37 = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, Autocomplete, el, options));

      _this37.el.M_Autocomplete = _this37;

      /**
       * Options for the autocomplete
       * @member Autocomplete#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {number} shift
       * @prop {number} padding
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */
      _this37.options = $.extend({}, Autocomplete.defaults, options);

      // Setup
      _this37.isOpen = false;
      _this37.count = 0;
      _this37.activeIndex = -1;
      _this37.oldVal;
      _this37.$inputField = _this37.$el.closest('.input-field');
      _this37.$active = $();
      _this37._mousedown = false;
      _this37._setupDropdown();

      _this37._setupEventHandlers();
      return _this37;
    }

    _createClass(Autocomplete, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._removeDropdown();
        this.el.M_Autocomplete = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputBlurBound = this._handleInputBlur.bind(this);
        this._handleInputKeyupAndFocusBound = this._handleInputKeyupAndFocus.bind(this);
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleContainerMousedownAndTouchstartBound = this._handleContainerMousedownAndTouchstart.bind(this);
        this._handleContainerMouseupAndTouchendBound = this._handleContainerMouseupAndTouchend.bind(this);

        this.el.addEventListener('blur', this._handleInputBlurBound);
        this.el.addEventListener('keyup', this._handleInputKeyupAndFocusBound);
        this.el.addEventListener('focus', this._handleInputKeyupAndFocusBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.el.addEventListener('click', this._handleInputClickBound);
        this.container.addEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
        this.container.addEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);

        if (typeof window.ontouchstart !== 'undefined') {
          this.container.addEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
          this.container.addEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('blur', this._handleInputBlurBound);
        this.el.removeEventListener('keyup', this._handleInputKeyupAndFocusBound);
        this.el.removeEventListener('focus', this._handleInputKeyupAndFocusBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.container.removeEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
        this.container.removeEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);

        if (typeof window.ontouchstart !== 'undefined') {
          this.container.removeEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
          this.container.removeEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
        }
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_setupDropdown",
      value: function _setupDropdown() {
        var _this38 = this;

        this.container = document.createElement('ul');
        this.container.id = "autocomplete-options-" + M.guid();
        $(this.container).addClass('autocomplete-content dropdown-content');
        this.$inputField.append(this.container);
        this.el.setAttribute('data-target', this.container.id);

        this.dropdown = M.Dropdown.init(this.el, {
          autoFocus: false,
          closeOnClick: false,
          coverTrigger: false,
          onItemClick: function (itemEl) {
            _this38.selectOption($(itemEl));
          }
        });

        // Sketchy removal of dropdown click handler
        this.el.removeEventListener('click', this.dropdown._handleClickBound);
      }

      /**
       * Remove dropdown
       */

    }, {
      key: "_removeDropdown",
      value: function _removeDropdown() {
        this.container.parentNode.removeChild(this.container);
      }

      /**
       * Handle Input Blur
       */

    }, {
      key: "_handleInputBlur",
      value: function _handleInputBlur() {
        if (!this._mousedown) {
          this.close();
          this._resetAutocomplete();
        }
      }

      /**
       * Handle Input Keyup and Focus
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeyupAndFocus",
      value: function _handleInputKeyupAndFocus(e) {
        if (e.type === 'keyup') {
          Autocomplete._keydown = false;
        }

        this.count = 0;
        var val = this.el.value.toLowerCase();

        // Don't capture enter or arrow key usage.
        if (e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) {
          return;
        }

        // Check if the input isn't empty
        // Check if focus triggered by tab
        if (this.oldVal !== val && (M.tabPressed || e.type !== 'focus')) {
          this.open();
        }

        // Update oldVal
        this.oldVal = val;
      }

      /**
       * Handle Input Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        Autocomplete._keydown = true;

        // Arrow keys and enter key usage
        var keyCode = e.keyCode,
            liElement = void 0,
            numItems = $(this.container).children('li').length;

        // select element on Enter
        if (keyCode === M.keys.ENTER && this.activeIndex >= 0) {
          liElement = $(this.container).children('li').eq(this.activeIndex);
          if (liElement.length) {
            this.selectOption(liElement);
            e.preventDefault();
          }
          return;
        }

        // Capture up and down key
        if (keyCode === M.keys.ARROW_UP || keyCode === M.keys.ARROW_DOWN) {
          e.preventDefault();

          if (keyCode === M.keys.ARROW_UP && this.activeIndex > 0) {
            this.activeIndex--;
          }

          if (keyCode === M.keys.ARROW_DOWN && this.activeIndex < numItems - 1) {
            this.activeIndex++;
          }

          this.$active.removeClass('active');
          if (this.activeIndex >= 0) {
            this.$active = $(this.container).children('li').eq(this.activeIndex);
            this.$active.addClass('active');
          }
        }
      }

      /**
       * Handle Input Click
       * @param {Event} e
       */

    }, {
      key: "_handleInputClick",
      value: function _handleInputClick(e) {
        this.open();
      }

      /**
       * Handle Container Mousedown and Touchstart
       * @param {Event} e
       */

    }, {
      key: "_handleContainerMousedownAndTouchstart",
      value: function _handleContainerMousedownAndTouchstart(e) {
        this._mousedown = true;
      }

      /**
       * Handle Container Mouseup and Touchend
       * @param {Event} e
       */

    }, {
      key: "_handleContainerMouseupAndTouchend",
      value: function _handleContainerMouseupAndTouchend(e) {
        this._mousedown = false;
      }

      /**
       * Highlight partial match
       */

    }, {
      key: "_highlight",
      value: function _highlight(string, $el) {
        var img = $el.find('img');
        var matchStart = $el.text().toLowerCase().indexOf('' + string.toLowerCase() + ''),
            matchEnd = matchStart + string.length - 1,
            beforeMatch = $el.text().slice(0, matchStart),
            matchText = $el.text().slice(matchStart, matchEnd + 1),
            afterMatch = $el.text().slice(matchEnd + 1);
        $el.html("<span>" + beforeMatch + "<span class='highlight'>" + matchText + "</span>" + afterMatch + "</span>");
        if (img.length) {
          $el.prepend(img);
        }
      }

      /**
       * Reset current element position
       */

    }, {
      key: "_resetCurrentElement",
      value: function _resetCurrentElement() {
        this.activeIndex = -1;
        this.$active.removeClass('active');
      }

      /**
       * Reset autocomplete elements
       */

    }, {
      key: "_resetAutocomplete",
      value: function _resetAutocomplete() {
        $(this.container).empty();
        this._resetCurrentElement();
        this.oldVal = null;
        this.isOpen = false;
        this._mousedown = false;
      }

      /**
       * Select autocomplete option
       * @param {Element} el  Autocomplete option list item element
       */

    }, {
      key: "selectOption",
      value: function selectOption(el) {
        var text = el.text().trim();
        this.el.value = text;
        this.$el.trigger('change');
        this._resetAutocomplete();
        this.close();

        // Handle onAutocomplete callback.
        if (typeof this.options.onAutocomplete === 'function') {
          this.options.onAutocomplete.call(this, text);
        }
      }

      /**
       * Render dropdown content
       * @param {Object} data  data set
       * @param {String} val  current input value
       */

    }, {
      key: "_renderDropdown",
      value: function _renderDropdown(data, val) {
        var _this39 = this;

        this._resetAutocomplete();

        var matchingData = [];

        // Gather all matching data
        for (var key in data) {
          if (data.hasOwnProperty(key) && key.toLowerCase().indexOf(val) !== -1) {
            // Break if past limit
            if (this.count >= this.options.limit) {
              break;
            }

            var entry = {
              data: data[key],
              key: key
            };
            matchingData.push(entry);

            this.count++;
          }
        }

        // Sort
        if (this.options.sortFunction) {
          var sortFunctionBound = function (a, b) {
            return _this39.options.sortFunction(a.key.toLowerCase(), b.key.toLowerCase(), val.toLowerCase());
          };
          matchingData.sort(sortFunctionBound);
        }

        // Render
        for (var i = 0; i < matchingData.length; i++) {
          var _entry = matchingData[i];
          var $autocompleteOption = $('<li></li>');
          if (!!_entry.data) {
            $autocompleteOption.append("<img src=\"" + _entry.data + "\" class=\"right circle\"><span>" + _entry.key + "</span>");
          } else {
            $autocompleteOption.append('<span>' + _entry.key + '</span>');
          }

          $(this.container).append($autocompleteOption);
          this._highlight(val, $autocompleteOption);
        }
      }

      /**
       * Open Autocomplete Dropdown
       */

    }, {
      key: "open",
      value: function open() {
        var val = this.el.value.toLowerCase();

        this._resetAutocomplete();

        if (val.length >= this.options.minLength) {
          this.isOpen = true;
          this._renderDropdown(this.options.data, val);
        }

        // Open dropdown
        if (!this.dropdown.isOpen) {
          this.dropdown.open();
        } else {
          // Recalculate dropdown when its already open
          this.dropdown.recalculateDimensions();
        }
      }

      /**
       * Close Autocomplete Dropdown
       */

    }, {
      key: "close",
      value: function close() {
        this.dropdown.close();
      }

      /**
       * Update Data
       * @param {Object} data
       */

    }, {
      key: "updateData",
      value: function updateData(data) {
        var val = this.el.value.toLowerCase();
        this.options.data = data;

        if (this.isOpen) {
          this._renderDropdown(data, val);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Autocomplete;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Autocomplete;
  }(Component);

  /**
   * @static
   * @memberof Autocomplete
   */


  Autocomplete._keydown = false;

  M.Autocomplete = Autocomplete;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Autocomplete, 'autocomplete', 'M_Autocomplete');
  }
})(cash);
;(function ($) {
  // Function to update labels of text fields
  M.updateTextFields = function () {
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea';
    $(input_selector).each(function (element, index) {
      var $this = $(this);
      if (element.value.length > 0 || $(element).is(':focus') || element.autofocus || $this.attr('placeholder') !== null) {
        $this.siblings('label').addClass('active');
      } else if (element.validity) {
        $this.siblings('label').toggleClass('active', element.validity.badInput === true);
      } else {
        $this.siblings('label').removeClass('active');
      }
    });
  };

  M.validate_field = function (object) {
    var hasLength = object.attr('data-length') !== null;
    var lenAttr = parseInt(object.attr('data-length'));
    var len = object[0].value.length;

    if (len === 0 && object[0].validity.badInput === false && !object.is(':required')) {
      if (object.hasClass('validate')) {
        object.removeClass('valid');
        object.removeClass('invalid');
      }
    } else {
      if (object.hasClass('validate')) {
        // Check for character counter attributes
        if (object.is(':valid') && hasLength && len <= lenAttr || object.is(':valid') && !hasLength) {
          object.removeClass('invalid');
          object.addClass('valid');
        } else {
          object.removeClass('valid');
          object.addClass('invalid');
        }
      }
    }
  };

  M.textareaAutoResize = function ($textarea) {
    // Wrap if native element
    if ($textarea instanceof Element) {
      $textarea = $($textarea);
    }

    if (!$textarea.length) {
      console.error('No textarea element found');
      return;
    }

    // Textarea Auto Resize
    var hiddenDiv = $('.hiddendiv').first();
    if (!hiddenDiv.length) {
      hiddenDiv = $('<div class="hiddendiv common"></div>');
      $('body').append(hiddenDiv);
    }

    // Set font properties of hiddenDiv
    var fontFamily = $textarea.css('font-family');
    var fontSize = $textarea.css('font-size');
    var lineHeight = $textarea.css('line-height');

    // Firefox can't handle padding shorthand.
    var paddingTop = $textarea.css('padding-top');
    var paddingRight = $textarea.css('padding-right');
    var paddingBottom = $textarea.css('padding-bottom');
    var paddingLeft = $textarea.css('padding-left');

    if (fontSize) {
      hiddenDiv.css('font-size', fontSize);
    }
    if (fontFamily) {
      hiddenDiv.css('font-family', fontFamily);
    }
    if (lineHeight) {
      hiddenDiv.css('line-height', lineHeight);
    }
    if (paddingTop) {
      hiddenDiv.css('padding-top', paddingTop);
    }
    if (paddingRight) {
      hiddenDiv.css('padding-right', paddingRight);
    }
    if (paddingBottom) {
      hiddenDiv.css('padding-bottom', paddingBottom);
    }
    if (paddingLeft) {
      hiddenDiv.css('padding-left', paddingLeft);
    }

    // Set original-height, if none
    if (!$textarea.data('original-height')) {
      $textarea.data('original-height', $textarea.height());
    }

    if ($textarea.attr('wrap') === 'off') {
      hiddenDiv.css('overflow-wrap', 'normal').css('white-space', 'pre');
    }

    hiddenDiv.text($textarea[0].value + '\n');
    var content = hiddenDiv.html().replace(/\n/g, '<br>');
    hiddenDiv.html(content);

    // When textarea is hidden, width goes crazy.
    // Approximate with half of window size

    if ($textarea[0].offsetWidth > 0 && $textarea[0].offsetHeight > 0) {
      hiddenDiv.css('width', $textarea.width() + 'px');
    } else {
      hiddenDiv.css('width', window.innerWidth / 2 + 'px');
    }

    /**
     * Resize if the new height is greater than the
     * original height of the textarea
     */
    if ($textarea.data('original-height') <= hiddenDiv.innerHeight()) {
      $textarea.css('height', hiddenDiv.innerHeight() + 'px');
    } else if ($textarea[0].value.length < $textarea.data('previous-length')) {
      /**
       * In case the new height is less than original height, it
       * means the textarea has less text than before
       * So we set the height to the original one
       */
      $textarea.css('height', $textarea.data('original-height') + 'px');
    }
    $textarea.data('previous-length', $textarea[0].value.length);
  };

  $(document).ready(function () {
    // Text based inputs
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea';

    // Add active if form auto complete
    $(document).on('change', input_selector, function () {
      if (this.value.length !== 0 || $(this).attr('placeholder') !== null) {
        $(this).siblings('label').addClass('active');
      }
      M.validate_field($(this));
    });

    // Add active if input element has been pre-populated on document ready
    $(document).ready(function () {
      M.updateTextFields();
    });

    // HTML DOM FORM RESET handling
    $(document).on('reset', function (e) {
      var formReset = $(e.target);
      if (formReset.is('form')) {
        formReset.find(input_selector).removeClass('valid').removeClass('invalid');
        formReset.find(input_selector).each(function (e) {
          if (this.value.length) {
            $(this).siblings('label').removeClass('active');
          }
        });

        // Reset select (after native reset)
        setTimeout(function () {
          formReset.find('select').each(function () {
            // check if initialized
            if (this.M_FormSelect) {
              $(this).trigger('change');
            }
          });
        }, 0);
      }
    });

    /**
     * Add active when element has focus
     * @param {Event} e
     */
    document.addEventListener('focus', function (e) {
      if ($(e.target).is(input_selector)) {
        $(e.target).siblings('label, .prefix').addClass('active');
      }
    }, true);

    /**
     * Remove active when element is blurred
     * @param {Event} e
     */
    document.addEventListener('blur', function (e) {
      var $inputElement = $(e.target);
      if ($inputElement.is(input_selector)) {
        var selector = '.prefix';

        if ($inputElement[0].value.length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') === null) {
          selector += ', label';
        }
        $inputElement.siblings(selector).removeClass('active');
        M.validate_field($inputElement);
      }
    }, true);

    // Radio and Checkbox focus class
    var radio_checkbox = 'input[type=radio], input[type=checkbox]';
    $(document).on('keyup', radio_checkbox, function (e) {
      // TAB, check if tabbing to radio or checkbox.
      if (e.which === M.keys.TAB) {
        $(this).addClass('tabbed');
        var $this = $(this);
        $this.one('blur', function (e) {
          $(this).removeClass('tabbed');
        });
        return;
      }
    });

    var text_area_selector = '.materialize-textarea';
    $(text_area_selector).each(function () {
      var $textarea = $(this);
      /**
       * Resize textarea on document load after storing
       * the original height and the original length
       */
      $textarea.data('original-height', $textarea.height());
      $textarea.data('previous-length', this.value.length);
      M.textareaAutoResize($textarea);
    });

    $(document).on('keyup', text_area_selector, function () {
      M.textareaAutoResize($(this));
    });
    $(document).on('keydown', text_area_selector, function () {
      M.textareaAutoResize($(this));
    });

    // File Input Path
    $(document).on('change', '.file-field input[type="file"]', function () {
      var file_field = $(this).closest('.file-field');
      var path_input = file_field.find('input.file-path');
      var files = $(this)[0].files;
      var file_names = [];
      for (var i = 0; i < files.length; i++) {
        file_names.push(files[i].name);
      }
      path_input[0].value = file_names.join(', ');
      path_input.trigger('change');
    });
  }); // End of $(document).ready
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    indicators: true,
    height: 400,
    duration: 500,
    interval: 6000
  };

  /**
   * @class
   *
   */

  var Slider = function (_Component11) {
    _inherits(Slider, _Component11);

    /**
     * Construct Slider instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Slider(el, options) {
      _classCallCheck(this, Slider);

      var _this40 = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, Slider, el, options));

      _this40.el.M_Slider = _this40;

      /**
       * Options for the modal
       * @member Slider#options
       * @prop {Boolean} [indicators=true] - Show indicators
       * @prop {Number} [height=400] - height of slider
       * @prop {Number} [duration=500] - Length in ms of slide transition
       * @prop {Number} [interval=6000] - Length in ms of slide interval
       */
      _this40.options = $.extend({}, Slider.defaults, options);

      // setup
      _this40.$slider = _this40.$el.find('.slides');
      _this40.$slides = _this40.$slider.children('li');
      _this40.activeIndex = _this40.$slides.filter(function (item) {
        return $(item).hasClass('active');
      }).first().index();
      if (_this40.activeIndex != -1) {
        _this40.$active = _this40.$slides.eq(_this40.activeIndex);
      }

      _this40._setSliderHeight();

      // Set initial positions of captions
      _this40.$slides.find('.caption').each(function (el) {
        _this40._animateCaptionIn(el, 0);
      });

      // Move img src into background-image
      _this40.$slides.find('img').each(function (el) {
        var placeholderBase64 = 'data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
        if ($(el).attr('src') !== placeholderBase64) {
          $(el).css('background-image', 'url("' + $(el).attr('src') + '")');
          $(el).attr('src', placeholderBase64);
        }
      });

      _this40._setupIndicators();

      // Show active slide
      if (_this40.$active) {
        _this40.$active.css('display', 'block');
      } else {
        _this40.$slides.first().addClass('active');
        anim({
          targets: _this40.$slides.first()[0],
          opacity: 1,
          duration: _this40.options.duration,
          easing: 'easeOutQuad'
        });

        _this40.activeIndex = 0;
        _this40.$active = _this40.$slides.eq(_this40.activeIndex);

        // Update indicators
        if (_this40.options.indicators) {
          _this40.$indicators.eq(_this40.activeIndex).addClass('active');
        }
      }

      // Adjust height to current slide
      _this40.$active.find('img').each(function (el) {
        anim({
          targets: _this40.$active.find('.caption')[0],
          opacity: 1,
          translateX: 0,
          translateY: 0,
          duration: _this40.options.duration,
          easing: 'easeOutQuad'
        });
      });

      _this40._setupEventHandlers();

      // auto scroll
      _this40.start();
      return _this40;
    }

    _createClass(Slider, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this.pause();
        this._removeIndicators();
        this._removeEventHandlers();
        this.el.M_Slider = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this41 = this;

        this._handleIntervalBound = this._handleInterval.bind(this);
        this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);

        if (this.options.indicators) {
          this.$indicators.each(function (el) {
            el.addEventListener('click', _this41._handleIndicatorClickBound);
          });
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this42 = this;

        if (this.options.indicators) {
          this.$indicators.each(function (el) {
            el.removeEventListener('click', _this42._handleIndicatorClickBound);
          });
        }
      }

      /**
       * Handle indicator click
       * @param {Event} e
       */

    }, {
      key: "_handleIndicatorClick",
      value: function _handleIndicatorClick(e) {
        var currIndex = $(e.target).index();
        this.set(currIndex);
      }

      /**
       * Handle Interval
       */

    }, {
      key: "_handleInterval",
      value: function _handleInterval() {
        var newActiveIndex = this.$slider.find('.active').index();
        if (this.$slides.length === newActiveIndex + 1) newActiveIndex = 0;
        // loop to start
        else newActiveIndex += 1;

        this.set(newActiveIndex);
      }

      /**
       * Animate in caption
       * @param {Element} caption
       * @param {Number} duration
       */

    }, {
      key: "_animateCaptionIn",
      value: function _animateCaptionIn(caption, duration) {
        var animOptions = {
          targets: caption,
          opacity: 0,
          duration: duration,
          easing: 'easeOutQuad'
        };

        if ($(caption).hasClass('center-align')) {
          animOptions.translateY = -100;
        } else if ($(caption).hasClass('right-align')) {
          animOptions.translateX = 100;
        } else if ($(caption).hasClass('left-align')) {
          animOptions.translateX = -100;
        }

        anim(animOptions);
      }

      /**
       * Set height of slider
       */

    }, {
      key: "_setSliderHeight",
      value: function _setSliderHeight() {
        // If fullscreen, do nothing
        if (!this.$el.hasClass('fullscreen')) {
          if (this.options.indicators) {
            // Add height if indicators are present
            this.$el.css('height', this.options.height + 40 + 'px');
          } else {
            this.$el.css('height', this.options.height + 'px');
          }
          this.$slider.css('height', this.options.height + 'px');
        }
      }

      /**
       * Setup indicators
       */

    }, {
      key: "_setupIndicators",
      value: function _setupIndicators() {
        var _this43 = this;

        if (this.options.indicators) {
          this.$indicators = $('<ul class="indicators"></ul>');
          this.$slides.each(function (el, index) {
            var $indicator = $('<li class="indicator-item"></li>');
            _this43.$indicators.append($indicator[0]);
          });
          this.$el.append(this.$indicators[0]);
          this.$indicators = this.$indicators.children('li.indicator-item');
        }
      }

      /**
       * Remove indicators
       */

    }, {
      key: "_removeIndicators",
      value: function _removeIndicators() {
        this.$el.find('ul.indicators').remove();
      }

      /**
       * Cycle to nth item
       * @param {Number} index
       */

    }, {
      key: "set",
      value: function set(index) {
        var _this44 = this;

        // Wrap around indices.
        if (index >= this.$slides.length) index = 0;else if (index < 0) index = this.$slides.length - 1;

        // Only do if index changes
        if (this.activeIndex != index) {
          this.$active = this.$slides.eq(this.activeIndex);
          var $caption = this.$active.find('.caption');
          this.$active.removeClass('active');

          anim({
            targets: this.$active[0],
            opacity: 0,
            duration: this.options.duration,
            easing: 'easeOutQuad',
            complete: function () {
              _this44.$slides.not('.active').each(function (el) {
                anim({
                  targets: el,
                  opacity: 0,
                  translateX: 0,
                  translateY: 0,
                  duration: 0,
                  easing: 'easeOutQuad'
                });
              });
            }
          });

          this._animateCaptionIn($caption[0], this.options.duration);

          // Update indicators
          if (this.options.indicators) {
            this.$indicators.eq(this.activeIndex).removeClass('active');
            this.$indicators.eq(index).addClass('active');
          }

          anim({
            targets: this.$slides.eq(index)[0],
            opacity: 1,
            duration: this.options.duration,
            easing: 'easeOutQuad'
          });

          anim({
            targets: this.$slides.eq(index).find('.caption')[0],
            opacity: 1,
            translateX: 0,
            translateY: 0,
            duration: this.options.duration,
            delay: this.options.duration,
            easing: 'easeOutQuad'
          });

          this.$slides.eq(index).addClass('active');
          this.activeIndex = index;

          // Reset interval
          this.start();
        }
      }

      /**
       * Pause slider interval
       */

    }, {
      key: "pause",
      value: function pause() {
        clearInterval(this.interval);
      }

      /**
       * Start slider interval
       */

    }, {
      key: "start",
      value: function start() {
        clearInterval(this.interval);
        this.interval = setInterval(this._handleIntervalBound, this.options.duration + this.options.interval);
      }

      /**
       * Move to next slide
       */

    }, {
      key: "next",
      value: function next() {
        var newIndex = this.activeIndex + 1;

        // Wrap around indices.
        if (newIndex >= this.$slides.length) newIndex = 0;else if (newIndex < 0) newIndex = this.$slides.length - 1;

        this.set(newIndex);
      }

      /**
       * Move to previous slide
       */

    }, {
      key: "prev",
      value: function prev() {
        var newIndex = this.activeIndex - 1;

        // Wrap around indices.
        if (newIndex >= this.$slides.length) newIndex = 0;else if (newIndex < 0) newIndex = this.$slides.length - 1;

        this.set(newIndex);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Slider.__proto__ || Object.getPrototypeOf(Slider), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Slider;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Slider;
  }(Component);

  M.Slider = Slider;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Slider, 'slider', 'M_Slider');
  }
})(cash, M.anime);
;(function ($, anim) {
  $(document).on('click', '.card', function (e) {
    if ($(this).children('.card-reveal').length) {
      var $card = $(e.target).closest('.card');
      if ($card.data('initialOverflow') === undefined) {
        $card.data('initialOverflow', $card.css('overflow') === undefined ? '' : $card.css('overflow'));
      }
      var $cardReveal = $(this).find('.card-reveal');
      if ($(e.target).is($('.card-reveal .card-title')) || $(e.target).is($('.card-reveal .card-title i'))) {
        // Make Reveal animate down and display none
        anim({
          targets: $cardReveal[0],
          translateY: 0,
          duration: 225,
          easing: 'easeInOutQuad',
          complete: function (anim) {
            var el = anim.animatables[0].target;
            $(el).css({ display: 'none' });
            $card.css('overflow', $card.data('initialOverflow'));
          }
        });
      } else if ($(e.target).is($('.card .activator')) || $(e.target).is($('.card .activator i'))) {
        $card.css('overflow', 'hidden');
        $cardReveal.css({ display: 'block' });
        anim({
          targets: $cardReveal[0],
          translateY: '-100%',
          duration: 300,
          easing: 'easeInOutQuad'
        });
      }
    }
  });
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    data: [],
    placeholder: '',
    secondaryPlaceholder: '',
    autocompleteOptions: {},
    limit: Infinity,
    onChipAdd: null,
    onChipSelect: null,
    onChipDelete: null
  };

  /**
   * @typedef {Object} chip
   * @property {String} tag  chip tag string
   * @property {String} [image]  chip avatar image string
   */

  /**
   * @class
   *
   */

  var Chips = function (_Component12) {
    _inherits(Chips, _Component12);

    /**
     * Construct Chips instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Chips(el, options) {
      _classCallCheck(this, Chips);

      var _this45 = _possibleConstructorReturn(this, (Chips.__proto__ || Object.getPrototypeOf(Chips)).call(this, Chips, el, options));

      _this45.el.M_Chips = _this45;

      /**
       * Options for the modal
       * @member Chips#options
       * @prop {Array} data
       * @prop {String} placeholder
       * @prop {String} secondaryPlaceholder
       * @prop {Object} autocompleteOptions
       */
      _this45.options = $.extend({}, Chips.defaults, options);

      _this45.$el.addClass('chips input-field');
      _this45.chipsData = [];
      _this45.$chips = $();
      _this45._setupInput();
      _this45.hasAutocomplete = Object.keys(_this45.options.autocompleteOptions).length > 0;

      // Set input id
      if (!_this45.$input.attr('id')) {
        _this45.$input.attr('id', M.guid());
      }

      // Render initial chips
      if (_this45.options.data.length) {
        _this45.chipsData = _this45.options.data;
        _this45._renderChips(_this45.chipsData);
      }

      // Setup autocomplete if needed
      if (_this45.hasAutocomplete) {
        _this45._setupAutocomplete();
      }

      _this45._setPlaceholder();
      _this45._setupLabel();
      _this45._setupEventHandlers();
      return _this45;
    }

    _createClass(Chips, [{
      key: "getData",


      /**
       * Get Chips Data
       */
      value: function getData() {
        return this.chipsData;
      }

      /**
       * Teardown component
       */

    }, {
      key: "destroy",
      value: function destroy() {
        this._removeEventHandlers();
        this.$chips.remove();
        this.el.M_Chips = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleChipClickBound = this._handleChipClick.bind(this);
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputFocusBound = this._handleInputFocus.bind(this);
        this._handleInputBlurBound = this._handleInputBlur.bind(this);

        this.el.addEventListener('click', this._handleChipClickBound);
        document.addEventListener('keydown', Chips._handleChipsKeydown);
        document.addEventListener('keyup', Chips._handleChipsKeyup);
        this.el.addEventListener('blur', Chips._handleChipsBlur, true);
        this.$input[0].addEventListener('focus', this._handleInputFocusBound);
        this.$input[0].addEventListener('blur', this._handleInputBlurBound);
        this.$input[0].addEventListener('keydown', this._handleInputKeydownBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleChipClickBound);
        document.removeEventListener('keydown', Chips._handleChipsKeydown);
        document.removeEventListener('keyup', Chips._handleChipsKeyup);
        this.el.removeEventListener('blur', Chips._handleChipsBlur, true);
        this.$input[0].removeEventListener('focus', this._handleInputFocusBound);
        this.$input[0].removeEventListener('blur', this._handleInputBlurBound);
        this.$input[0].removeEventListener('keydown', this._handleInputKeydownBound);
      }

      /**
       * Handle Chip Click
       * @param {Event} e
       */

    }, {
      key: "_handleChipClick",
      value: function _handleChipClick(e) {
        var $chip = $(e.target).closest('.chip');
        var clickedClose = $(e.target).is('.close');
        if ($chip.length) {
          var index = $chip.index();
          if (clickedClose) {
            // delete chip
            this.deleteChip(index);
            this.$input[0].focus();
          } else {
            // select chip
            this.selectChip(index);
          }

          // Default handle click to focus on input
        } else {
          this.$input[0].focus();
        }
      }

      /**
       * Handle Chips Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputFocus",


      /**
       * Handle Input Focus
       */
      value: function _handleInputFocus() {
        this.$el.addClass('focus');
      }

      /**
       * Handle Input Blur
       */

    }, {
      key: "_handleInputBlur",
      value: function _handleInputBlur() {
        this.$el.removeClass('focus');
      }

      /**
       * Handle Input Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        Chips._keydown = true;

        // enter
        if (e.keyCode === 13) {
          // Override enter if autocompleting.
          if (this.hasAutocomplete && this.autocomplete && this.autocomplete.isOpen) {
            return;
          }

          e.preventDefault();
          this.addChip({
            tag: this.$input[0].value
          });
          this.$input[0].value = '';

          // delete or left
        } else if ((e.keyCode === 8 || e.keyCode === 37) && this.$input[0].value === '' && this.chipsData.length) {
          e.preventDefault();
          this.selectChip(this.chipsData.length - 1);
        }
      }

      /**
       * Render Chip
       * @param {chip} chip
       * @return {Element}
       */

    }, {
      key: "_renderChip",
      value: function _renderChip(chip) {
        if (!chip.tag) {
          return;
        }

        var renderedChip = document.createElement('div');
        var closeIcon = document.createElement('i');
        renderedChip.classList.add('chip');
        renderedChip.textContent = chip.tag;
        renderedChip.setAttribute('tabindex', 0);
        $(closeIcon).addClass('material-icons close');
        closeIcon.textContent = 'close';

        // attach image if needed
        if (chip.image) {
          var img = document.createElement('img');
          img.setAttribute('src', chip.image);
          renderedChip.insertBefore(img, renderedChip.firstChild);
        }

        renderedChip.appendChild(closeIcon);
        return renderedChip;
      }

      /**
       * Render Chips
       */

    }, {
      key: "_renderChips",
      value: function _renderChips() {
        this.$chips.remove();
        for (var i = 0; i < this.chipsData.length; i++) {
          var chipEl = this._renderChip(this.chipsData[i]);
          this.$el.append(chipEl);
          this.$chips.add(chipEl);
        }

        // move input to end
        this.$el.append(this.$input[0]);
      }

      /**
       * Setup Autocomplete
       */

    }, {
      key: "_setupAutocomplete",
      value: function _setupAutocomplete() {
        var _this46 = this;

        this.options.autocompleteOptions.onAutocomplete = function (val) {
          _this46.addChip({
            tag: val
          });
          _this46.$input[0].value = '';
          _this46.$input[0].focus();
        };

        this.autocomplete = M.Autocomplete.init(this.$input[0], this.options.autocompleteOptions);
      }

      /**
       * Setup Input
       */

    }, {
      key: "_setupInput",
      value: function _setupInput() {
        this.$input = this.$el.find('input');
        if (!this.$input.length) {
          this.$input = $('<input></input>');
          this.$el.append(this.$input);
        }

        this.$input.addClass('input');
      }

      /**
       * Setup Label
       */

    }, {
      key: "_setupLabel",
      value: function _setupLabel() {
        this.$label = this.$el.find('label');
        if (this.$label.length) {
          this.$label.setAttribute('for', this.$input.attr('id'));
        }
      }

      /**
       * Set placeholder
       */

    }, {
      key: "_setPlaceholder",
      value: function _setPlaceholder() {
        if (this.chipsData !== undefined && !this.chipsData.length && this.options.placeholder) {
          $(this.$input).prop('placeholder', this.options.placeholder);
        } else if ((this.chipsData === undefined || !!this.chipsData.length) && this.options.secondaryPlaceholder) {
          $(this.$input).prop('placeholder', this.options.secondaryPlaceholder);
        }
      }

      /**
       * Check if chip is valid
       * @param {chip} chip
       */

    }, {
      key: "_isValid",
      value: function _isValid(chip) {
        if (chip.hasOwnProperty('tag') && chip.tag !== '') {
          var exists = false;
          for (var i = 0; i < this.chipsData.length; i++) {
            if (this.chipsData[i].tag === chip.tag) {
              exists = true;
              break;
            }
          }
          return !exists;
        }

        return false;
      }

      /**
       * Add chip
       * @param {chip} chip
       */

    }, {
      key: "addChip",
      value: function addChip(chip) {
        if (!this._isValid(chip) || this.chipsData.length >= this.options.limit) {
          return;
        }

        var renderedChip = this._renderChip(chip);
        this.$chips.add(renderedChip);
        this.chipsData.push(chip);
        $(this.$input).before(renderedChip);
        this._setPlaceholder();

        // fire chipAdd callback
        if (typeof this.options.onChipAdd === 'function') {
          this.options.onChipAdd.call(this, this.$el, renderedChip);
        }
      }

      /**
       * Delete chip
       * @param {Number} chip
       */

    }, {
      key: "deleteChip",
      value: function deleteChip(chipIndex) {
        var $chip = this.$chips.eq(chipIndex);
        this.$chips.eq(chipIndex).remove();
        this.$chips = this.$chips.filter(function (el) {
          return $(el).index() >= 0;
        });
        this.chipsData.splice(chipIndex, 1);
        this._setPlaceholder();

        // fire chipDelete callback
        if (typeof this.options.onChipDelete === 'function') {
          this.options.onChipDelete.call(this, this.$el, $chip[0]);
        }
      }

      /**
       * Select chip
       * @param {Number} chip
       */

    }, {
      key: "selectChip",
      value: function selectChip(chipIndex) {
        var $chip = this.$chips.eq(chipIndex);
        this._selectedChip = $chip;
        $chip[0].focus();

        // fire chipSelect callback
        if (typeof this.options.onChipSelect === 'function') {
          this.options.onChipSelect.call(this, this.$el, $chip[0]);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Chips.__proto__ || Object.getPrototypeOf(Chips), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Chips;
      }
    }, {
      key: "_handleChipsKeydown",
      value: function _handleChipsKeydown(e) {
        Chips._keydown = true;

        var $chips = $(e.target).closest('.chips');
        var chipsKeydown = e.target && $chips.length;

        // Don't handle keydown inputs on input and textarea
        if ($(e.target).is('input, textarea') || !chipsKeydown) {
          return;
        }

        var currChips = $chips[0].M_Chips;

        // backspace and delete
        if (e.keyCode === 8 || e.keyCode === 46) {
          e.preventDefault();

          var selectIndex = currChips.chipsData.length;
          if (currChips._selectedChip) {
            var index = currChips._selectedChip.index();
            currChips.deleteChip(index);
            currChips._selectedChip = null;

            // Make sure selectIndex doesn't go negative
            selectIndex = Math.max(index - 1, 0);
          }

          if (currChips.chipsData.length) {
            currChips.selectChip(selectIndex);
          }

          // left arrow key
        } else if (e.keyCode === 37) {
          if (currChips._selectedChip) {
            var _selectIndex = currChips._selectedChip.index() - 1;
            if (_selectIndex < 0) {
              return;
            }
            currChips.selectChip(_selectIndex);
          }

          // right arrow key
        } else if (e.keyCode === 39) {
          if (currChips._selectedChip) {
            var _selectIndex2 = currChips._selectedChip.index() + 1;

            if (_selectIndex2 >= currChips.chipsData.length) {
              currChips.$input[0].focus();
            } else {
              currChips.selectChip(_selectIndex2);
            }
          }
        }
      }

      /**
       * Handle Chips Keyup
       * @param {Event} e
       */

    }, {
      key: "_handleChipsKeyup",
      value: function _handleChipsKeyup(e) {
        Chips._keydown = false;
      }

      /**
       * Handle Chips Blur
       * @param {Event} e
       */

    }, {
      key: "_handleChipsBlur",
      value: function _handleChipsBlur(e) {
        if (!Chips._keydown) {
          var $chips = $(e.target).closest('.chips');
          var currChips = $chips[0].M_Chips;

          currChips._selectedChip = null;
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Chips;
  }(Component);

  /**
   * @static
   * @memberof Chips
   */


  Chips._keydown = false;

  M.Chips = Chips;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Chips, 'chips', 'M_Chips');
  }

  $(document).ready(function () {
    // Handle removal of static chips.
    $(document.body).on('click', '.chip .close', function () {
      var $chips = $(this).closest('.chips');
      if ($chips.length && $chips[0].M_Chips) {
        return;
      }
      $(this).closest('.chip').remove();
    });
  });
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    top: 0,
    bottom: Infinity,
    offset: 0,
    onPositionChange: null
  };

  /**
   * @class
   *
   */

  var Pushpin = function (_Component13) {
    _inherits(Pushpin, _Component13);

    /**
     * Construct Pushpin instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Pushpin(el, options) {
      _classCallCheck(this, Pushpin);

      var _this47 = _possibleConstructorReturn(this, (Pushpin.__proto__ || Object.getPrototypeOf(Pushpin)).call(this, Pushpin, el, options));

      _this47.el.M_Pushpin = _this47;

      /**
       * Options for the modal
       * @member Pushpin#options
       */
      _this47.options = $.extend({}, Pushpin.defaults, options);

      _this47.originalOffset = _this47.el.offsetTop;
      Pushpin._pushpins.push(_this47);
      _this47._setupEventHandlers();
      _this47._updatePosition();
      return _this47;
    }

    _createClass(Pushpin, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this.el.style.top = null;
        this._removePinClasses();
        this._removeEventHandlers();

        // Remove pushpin Inst
        var index = Pushpin._pushpins.indexOf(this);
        Pushpin._pushpins.splice(index, 1);
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        document.addEventListener('scroll', Pushpin._updateElements);
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        document.removeEventListener('scroll', Pushpin._updateElements);
      }
    }, {
      key: "_updatePosition",
      value: function _updatePosition() {
        var scrolled = M.getDocumentScrollTop() + this.options.offset;

        if (this.options.top <= scrolled && this.options.bottom >= scrolled && !this.el.classList.contains('pinned')) {
          this._removePinClasses();
          this.el.style.top = this.options.offset + "px";
          this.el.classList.add('pinned');

          // onPositionChange callback
          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'pinned');
          }
        }

        // Add pin-top (when scrolled position is above top)
        if (scrolled < this.options.top && !this.el.classList.contains('pin-top')) {
          this._removePinClasses();
          this.el.style.top = 0;
          this.el.classList.add('pin-top');

          // onPositionChange callback
          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'pin-top');
          }
        }

        // Add pin-bottom (when scrolled position is below bottom)
        if (scrolled > this.options.bottom && !this.el.classList.contains('pin-bottom')) {
          this._removePinClasses();
          this.el.classList.add('pin-bottom');
          this.el.style.top = this.options.bottom - this.originalOffset + "px";

          // onPositionChange callback
          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'pin-bottom');
          }
        }
      }
    }, {
      key: "_removePinClasses",
      value: function _removePinClasses() {
        // IE 11 bug (can't remove multiple classes in one line)
        this.el.classList.remove('pin-top');
        this.el.classList.remove('pinned');
        this.el.classList.remove('pin-bottom');
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Pushpin.__proto__ || Object.getPrototypeOf(Pushpin), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Pushpin;
      }
    }, {
      key: "_updateElements",
      value: function _updateElements() {
        for (var elIndex in Pushpin._pushpins) {
          var pInstance = Pushpin._pushpins[elIndex];
          pInstance._updatePosition();
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Pushpin;
  }(Component);

  /**
   * @static
   * @memberof Pushpin
   */


  Pushpin._pushpins = [];

  M.Pushpin = Pushpin;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Pushpin, 'pushpin', 'M_Pushpin');
  }
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    direction: 'top',
    hoverEnabled: true,
    toolbarEnabled: false
  };

  $.fn.reverse = [].reverse;

  /**
   * @class
   *
   */

  var FloatingActionButton = function (_Component14) {
    _inherits(FloatingActionButton, _Component14);

    /**
     * Construct FloatingActionButton instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function FloatingActionButton(el, options) {
      _classCallCheck(this, FloatingActionButton);

      var _this48 = _possibleConstructorReturn(this, (FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton)).call(this, FloatingActionButton, el, options));

      _this48.el.M_FloatingActionButton = _this48;

      /**
       * Options for the fab
       * @member FloatingActionButton#options
       * @prop {Boolean} [direction] - Direction fab menu opens
       * @prop {Boolean} [hoverEnabled=true] - Enable hover vs click
       * @prop {Boolean} [toolbarEnabled=false] - Enable toolbar transition
       */
      _this48.options = $.extend({}, FloatingActionButton.defaults, options);

      _this48.isOpen = false;
      _this48.$anchor = _this48.$el.children('a').first();
      _this48.$menu = _this48.$el.children('ul').first();
      _this48.$floatingBtns = _this48.$el.find('ul .btn-floating');
      _this48.$floatingBtnsReverse = _this48.$el.find('ul .btn-floating').reverse();
      _this48.offsetY = 0;
      _this48.offsetX = 0;

      _this48.$el.addClass("direction-" + _this48.options.direction);
      if (_this48.options.direction === 'top') {
        _this48.offsetY = 40;
      } else if (_this48.options.direction === 'right') {
        _this48.offsetX = -40;
      } else if (_this48.options.direction === 'bottom') {
        _this48.offsetY = -40;
      } else {
        _this48.offsetX = 40;
      }
      _this48._setupEventHandlers();
      return _this48;
    }

    _createClass(FloatingActionButton, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_FloatingActionButton = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleFABClickBound = this._handleFABClick.bind(this);
        this._handleOpenBound = this.open.bind(this);
        this._handleCloseBound = this.close.bind(this);

        if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
          this.el.addEventListener('mouseenter', this._handleOpenBound);
          this.el.addEventListener('mouseleave', this._handleCloseBound);
        } else {
          this.el.addEventListener('click', this._handleFABClickBound);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
          this.el.removeEventListener('mouseenter', this._handleOpenBound);
          this.el.removeEventListener('mouseleave', this._handleCloseBound);
        } else {
          this.el.removeEventListener('click', this._handleFABClickBound);
        }
      }

      /**
       * Handle FAB Click
       */

    }, {
      key: "_handleFABClick",
      value: function _handleFABClick() {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      /**
       * Handle Document Click
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        if (!$(e.target).closest(this.$menu).length) {
          this.close();
        }
      }

      /**
       * Open FAB
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        if (this.options.toolbarEnabled) {
          this._animateInToolbar();
        } else {
          this._animateInFAB();
        }
        this.isOpen = true;
      }

      /**
       * Close FAB
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        if (this.options.toolbarEnabled) {
          window.removeEventListener('scroll', this._handleCloseBound, true);
          document.body.removeEventListener('click', this._handleDocumentClickBound, true);
          this._animateOutToolbar();
        } else {
          this._animateOutFAB();
        }
        this.isOpen = false;
      }

      /**
       * Classic FAB Menu open
       */

    }, {
      key: "_animateInFAB",
      value: function _animateInFAB() {
        var _this49 = this;

        this.$el.addClass('active');

        var time = 0;
        this.$floatingBtnsReverse.each(function (el) {
          anim({
            targets: el,
            opacity: 1,
            scale: [0.4, 1],
            translateY: [_this49.offsetY, 0],
            translateX: [_this49.offsetX, 0],
            duration: 275,
            delay: time,
            easing: 'easeInOutQuad'
          });
          time += 40;
        });
      }

      /**
       * Classic FAB Menu close
       */

    }, {
      key: "_animateOutFAB",
      value: function _animateOutFAB() {
        var _this50 = this;

        this.$floatingBtnsReverse.each(function (el) {
          anim.remove(el);
          anim({
            targets: el,
            opacity: 0,
            scale: 0.4,
            translateY: _this50.offsetY,
            translateX: _this50.offsetX,
            duration: 175,
            easing: 'easeOutQuad',
            complete: function () {
              _this50.$el.removeClass('active');
            }
          });
        });
      }

      /**
       * Toolbar transition Menu open
       */

    }, {
      key: "_animateInToolbar",
      value: function _animateInToolbar() {
        var _this51 = this;

        var scaleFactor = void 0;
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var btnRect = this.el.getBoundingClientRect();
        var backdrop = $('<div class="fab-backdrop"></div>');
        var fabColor = this.$anchor.css('background-color');
        this.$anchor.append(backdrop);

        this.offsetX = btnRect.left - windowWidth / 2 + btnRect.width / 2;
        this.offsetY = windowHeight - btnRect.bottom;
        scaleFactor = windowWidth / backdrop[0].clientWidth;
        this.btnBottom = btnRect.bottom;
        this.btnLeft = btnRect.left;
        this.btnWidth = btnRect.width;

        // Set initial state
        this.$el.addClass('active');
        this.$el.css({
          'text-align': 'center',
          width: '100%',
          bottom: 0,
          left: 0,
          transform: 'translateX(' + this.offsetX + 'px)',
          transition: 'none'
        });
        this.$anchor.css({
          transform: 'translateY(' + -this.offsetY + 'px)',
          transition: 'none'
        });
        backdrop.css({
          'background-color': fabColor
        });

        setTimeout(function () {
          _this51.$el.css({
            transform: '',
            transition: 'transform .2s cubic-bezier(0.550, 0.085, 0.680, 0.530), background-color 0s linear .2s'
          });
          _this51.$anchor.css({
            overflow: 'visible',
            transform: '',
            transition: 'transform .2s'
          });

          setTimeout(function () {
            _this51.$el.css({
              overflow: 'hidden',
              'background-color': fabColor
            });
            backdrop.css({
              transform: 'scale(' + scaleFactor + ')',
              transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
            });
            _this51.$menu.children('li').children('a').css({
              opacity: 1
            });

            // Scroll to close.
            _this51._handleDocumentClickBound = _this51._handleDocumentClick.bind(_this51);
            window.addEventListener('scroll', _this51._handleCloseBound, true);
            document.body.addEventListener('click', _this51._handleDocumentClickBound, true);
          }, 100);
        }, 0);
      }

      /**
       * Toolbar transition Menu close
       */

    }, {
      key: "_animateOutToolbar",
      value: function _animateOutToolbar() {
        var _this52 = this;

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var backdrop = this.$el.find('.fab-backdrop');
        var fabColor = this.$anchor.css('background-color');

        this.offsetX = this.btnLeft - windowWidth / 2 + this.btnWidth / 2;
        this.offsetY = windowHeight - this.btnBottom;

        // Hide backdrop
        this.$el.removeClass('active');
        this.$el.css({
          'background-color': 'transparent',
          transition: 'none'
        });
        this.$anchor.css({
          transition: 'none'
        });
        backdrop.css({
          transform: 'scale(0)',
          'background-color': fabColor
        });
        this.$menu.children('li').children('a').css({
          opacity: ''
        });

        setTimeout(function () {
          backdrop.remove();

          // Set initial state.
          _this52.$el.css({
            'text-align': '',
            width: '',
            bottom: '',
            left: '',
            overflow: '',
            'background-color': '',
            transform: 'translate3d(' + -_this52.offsetX + 'px,0,0)'
          });
          _this52.$anchor.css({
            overflow: '',
            transform: 'translate3d(0,' + _this52.offsetY + 'px,0)'
          });

          setTimeout(function () {
            _this52.$el.css({
              transform: 'translate3d(0,0,0)',
              transition: 'transform .2s'
            });
            _this52.$anchor.css({
              transform: 'translate3d(0,0,0)',
              transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
            });
          }, 20);
        }, 200);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_FloatingActionButton;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return FloatingActionButton;
  }(Component);

  M.FloatingActionButton = FloatingActionButton;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(FloatingActionButton, 'floatingActionButton', 'M_FloatingActionButton');
  }
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    // Close when date is selected
    autoClose: false,

    // the default output format for the input field value
    format: 'mmm dd, yyyy',

    // Used to create date object from current input string
    parse: null,

    // The initial date to view when first opened
    defaultDate: null,

    // Make the `defaultDate` the initial selected value
    setDefaultDate: false,

    disableWeekends: false,

    disableDayFn: null,

    // First day of week (0: Sunday, 1: Monday etc)
    firstDay: 0,

    // The earliest date that can be selected
    minDate: null,
    // Thelatest date that can be selected
    maxDate: null,

    // Number of years either side, or array of upper/lower range
    yearRange: 10,

    // used internally (don't config outside)
    minYear: 0,
    maxYear: 9999,
    minMonth: undefined,
    maxMonth: undefined,

    startRange: null,
    endRange: null,

    isRTL: false,

    // Render the month after year in the calendar title
    showMonthAfterYear: false,

    // Render days of the calendar grid that fall in the next or previous month
    showDaysInNextAndPreviousMonths: false,

    // Specify a DOM element to render the calendar in
    container: null,

    // Show clear button
    showClearBtn: false,

    // internationalization
    i18n: {
      cancel: 'Cancel',
      clear: 'Clear',
      done: 'Ok',
      previousMonth: '‹',
      nextMonth: '›',
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdaysAbbrev: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    },

    // events array
    events: [],

    // callback function
    onSelect: null,
    onOpen: null,
    onClose: null,
    onDraw: null
  };

  /**
   * @class
   *
   */

  var Datepicker = function (_Component15) {
    _inherits(Datepicker, _Component15);

    /**
     * Construct Datepicker instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Datepicker(el, options) {
      _classCallCheck(this, Datepicker);

      var _this53 = _possibleConstructorReturn(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).call(this, Datepicker, el, options));

      _this53.el.M_Datepicker = _this53;

      _this53.options = $.extend({}, Datepicker.defaults, options);

      // make sure i18n defaults are not lost when only few i18n option properties are passed
      if (!!options && options.hasOwnProperty('i18n') && typeof options.i18n === 'object') {
        _this53.options.i18n = $.extend({}, Datepicker.defaults.i18n, options.i18n);
      }

      // Remove time component from minDate and maxDate options
      if (_this53.options.minDate) _this53.options.minDate.setHours(0, 0, 0, 0);
      if (_this53.options.maxDate) _this53.options.maxDate.setHours(0, 0, 0, 0);

      _this53.id = M.guid();

      _this53._setupVariables();
      _this53._insertHTMLIntoDOM();
      _this53._setupModal();

      _this53._setupEventHandlers();

      if (!_this53.options.defaultDate) {
        _this53.options.defaultDate = new Date(Date.parse(_this53.el.value));
      }

      var defDate = _this53.options.defaultDate;
      if (Datepicker._isDate(defDate)) {
        if (_this53.options.setDefaultDate) {
          _this53.setDate(defDate, true);
          _this53.setInputValue();
        } else {
          _this53.gotoDate(defDate);
        }
      } else {
        _this53.gotoDate(new Date());
      }

      /**
       * Describes open/close state of datepicker
       * @type {Boolean}
       */
      _this53.isOpen = false;
      return _this53;
    }

    _createClass(Datepicker, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.modal.destroy();
        $(this.modalEl).remove();
        this.destroySelects();
        this.el.M_Datepicker = undefined;
      }
    }, {
      key: "destroySelects",
      value: function destroySelects() {
        var oldYearSelect = this.calendarEl.querySelector('.orig-select-year');
        if (oldYearSelect) {
          M.FormSelect.getInstance(oldYearSelect).destroy();
        }
        var oldMonthSelect = this.calendarEl.querySelector('.orig-select-month');
        if (oldMonthSelect) {
          M.FormSelect.getInstance(oldMonthSelect).destroy();
        }
      }
    }, {
      key: "_insertHTMLIntoDOM",
      value: function _insertHTMLIntoDOM() {
        if (this.options.showClearBtn) {
          $(this.clearBtn).css({ visibility: '' });
          this.clearBtn.innerHTML = this.options.i18n.clear;
        }

        this.doneBtn.innerHTML = this.options.i18n.done;
        this.cancelBtn.innerHTML = this.options.i18n.cancel;

        if (this.options.container) {
          this.$modalEl.appendTo(this.options.container);
        } else {
          this.$modalEl.insertBefore(this.el);
        }
      }
    }, {
      key: "_setupModal",
      value: function _setupModal() {
        var _this54 = this;

        this.modalEl.id = 'modal-' + this.id;
        this.modal = M.Modal.init(this.modalEl, {
          onCloseEnd: function () {
            _this54.isOpen = false;
          }
        });
      }
    }, {
      key: "toString",
      value: function toString(format) {
        var _this55 = this;

        format = format || this.options.format;
        if (!Datepicker._isDate(this.date)) {
          return '';
        }

        var formatArray = format.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g);
        var formattedDate = formatArray.map(function (label) {
          if (_this55.formats[label]) {
            return _this55.formats[label]();
          }

          return label;
        }).join('');
        return formattedDate;
      }
    }, {
      key: "setDate",
      value: function setDate(date, preventOnSelect) {
        if (!date) {
          this.date = null;
          this._renderDateDisplay();
          return this.draw();
        }
        if (typeof date === 'string') {
          date = new Date(Date.parse(date));
        }
        if (!Datepicker._isDate(date)) {
          return;
        }

        var min = this.options.minDate,
            max = this.options.maxDate;

        if (Datepicker._isDate(min) && date < min) {
          date = min;
        } else if (Datepicker._isDate(max) && date > max) {
          date = max;
        }

        this.date = new Date(date.getTime());

        this._renderDateDisplay();

        Datepicker._setToStartOfDay(this.date);
        this.gotoDate(this.date);

        if (!preventOnSelect && typeof this.options.onSelect === 'function') {
          this.options.onSelect.call(this, this.date);
        }
      }
    }, {
      key: "setInputValue",
      value: function setInputValue() {
        this.el.value = this.toString();
        this.$el.trigger('change', { firedBy: this });
      }
    }, {
      key: "_renderDateDisplay",
      value: function _renderDateDisplay() {
        var displayDate = Datepicker._isDate(this.date) ? this.date : new Date();
        var i18n = this.options.i18n;
        var day = i18n.weekdaysShort[displayDate.getDay()];
        var month = i18n.monthsShort[displayDate.getMonth()];
        var date = displayDate.getDate();
        this.yearTextEl.innerHTML = displayDate.getFullYear();
        this.dateTextEl.innerHTML = day + ", " + month + " " + date;
      }

      /**
       * change view to a specific date
       */

    }, {
      key: "gotoDate",
      value: function gotoDate(date) {
        var newCalendar = true;

        if (!Datepicker._isDate(date)) {
          return;
        }

        if (this.calendars) {
          var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
              lastVisibleDate = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1),
              visibleDate = date.getTime();
          // get the end of the month
          lastVisibleDate.setMonth(lastVisibleDate.getMonth() + 1);
          lastVisibleDate.setDate(lastVisibleDate.getDate() - 1);
          newCalendar = visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate;
        }

        if (newCalendar) {
          this.calendars = [{
            month: date.getMonth(),
            year: date.getFullYear()
          }];
        }

        this.adjustCalendars();
      }
    }, {
      key: "adjustCalendars",
      value: function adjustCalendars() {
        this.calendars[0] = this.adjustCalendar(this.calendars[0]);
        this.draw();
      }
    }, {
      key: "adjustCalendar",
      value: function adjustCalendar(calendar) {
        if (calendar.month < 0) {
          calendar.year -= Math.ceil(Math.abs(calendar.month) / 12);
          calendar.month += 12;
        }
        if (calendar.month > 11) {
          calendar.year += Math.floor(Math.abs(calendar.month) / 12);
          calendar.month -= 12;
        }
        return calendar;
      }
    }, {
      key: "nextMonth",
      value: function nextMonth() {
        this.calendars[0].month++;
        this.adjustCalendars();
      }
    }, {
      key: "prevMonth",
      value: function prevMonth() {
        this.calendars[0].month--;
        this.adjustCalendars();
      }
    }, {
      key: "render",
      value: function render(year, month, randId) {
        var opts = this.options,
            now = new Date(),
            days = Datepicker._getDaysInMonth(year, month),
            before = new Date(year, month, 1).getDay(),
            data = [],
            row = [];
        Datepicker._setToStartOfDay(now);
        if (opts.firstDay > 0) {
          before -= opts.firstDay;
          if (before < 0) {
            before += 7;
          }
        }
        var previousMonth = month === 0 ? 11 : month - 1,
            nextMonth = month === 11 ? 0 : month + 1,
            yearOfPreviousMonth = month === 0 ? year - 1 : year,
            yearOfNextMonth = month === 11 ? year + 1 : year,
            daysInPreviousMonth = Datepicker._getDaysInMonth(yearOfPreviousMonth, previousMonth);
        var cells = days + before,
            after = cells;
        while (after > 7) {
          after -= 7;
        }
        cells += 7 - after;
        var isWeekSelected = false;
        for (var i = 0, r = 0; i < cells; i++) {
          var day = new Date(year, month, 1 + (i - before)),
              isSelected = Datepicker._isDate(this.date) ? Datepicker._compareDates(day, this.date) : false,
              isToday = Datepicker._compareDates(day, now),
              hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
              isEmpty = i < before || i >= days + before,
              dayNumber = 1 + (i - before),
              monthNumber = month,
              yearNumber = year,
              isStartRange = opts.startRange && Datepicker._compareDates(opts.startRange, day),
              isEndRange = opts.endRange && Datepicker._compareDates(opts.endRange, day),
              isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
              isDisabled = opts.minDate && day < opts.minDate || opts.maxDate && day > opts.maxDate || opts.disableWeekends && Datepicker._isWeekend(day) || opts.disableDayFn && opts.disableDayFn(day);

          if (isEmpty) {
            if (i < before) {
              dayNumber = daysInPreviousMonth + dayNumber;
              monthNumber = previousMonth;
              yearNumber = yearOfPreviousMonth;
            } else {
              dayNumber = dayNumber - days;
              monthNumber = nextMonth;
              yearNumber = yearOfNextMonth;
            }
          }

          var dayConfig = {
            day: dayNumber,
            month: monthNumber,
            year: yearNumber,
            hasEvent: hasEvent,
            isSelected: isSelected,
            isToday: isToday,
            isDisabled: isDisabled,
            isEmpty: isEmpty,
            isStartRange: isStartRange,
            isEndRange: isEndRange,
            isInRange: isInRange,
            showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths
          };

          row.push(this.renderDay(dayConfig));

          if (++r === 7) {
            data.push(this.renderRow(row, opts.isRTL, isWeekSelected));
            row = [];
            r = 0;
            isWeekSelected = false;
          }
        }
        return this.renderTable(opts, data, randId);
      }
    }, {
      key: "renderDay",
      value: function renderDay(opts) {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
          if (opts.showDaysInNextAndPreviousMonths) {
            arr.push('is-outside-current-month');
            arr.push('is-selection-disabled');
          } else {
            return '<td class="is-empty"></td>';
          }
        }
        if (opts.isDisabled) {
          arr.push('is-disabled');
        }

        if (opts.isToday) {
          arr.push('is-today');
        }
        if (opts.isSelected) {
          arr.push('is-selected');
          ariaSelected = 'true';
        }
        if (opts.hasEvent) {
          arr.push('has-event');
        }
        if (opts.isInRange) {
          arr.push('is-inrange');
        }
        if (opts.isStartRange) {
          arr.push('is-startrange');
        }
        if (opts.isEndRange) {
          arr.push('is-endrange');
        }
        return "<td data-day=\"" + opts.day + "\" class=\"" + arr.join(' ') + "\" aria-selected=\"" + ariaSelected + "\">" + ("<button class=\"datepicker-day-button\" type=\"button\" data-year=\"" + opts.year + "\" data-month=\"" + opts.month + "\" data-day=\"" + opts.day + "\">" + opts.day + "</button>") + '</td>';
      }
    }, {
      key: "renderRow",
      value: function renderRow(days, isRTL, isRowSelected) {
        return '<tr class="datepicker-row' + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
      }
    }, {
      key: "renderTable",
      value: function renderTable(opts, data, randId) {
        return '<div class="datepicker-table-wrapper"><table cellpadding="0" cellspacing="0" class="datepicker-table" role="grid" aria-labelledby="' + randId + '">' + this.renderHead(opts) + this.renderBody(data) + '</table></div>';
      }
    }, {
      key: "renderHead",
      value: function renderHead(opts) {
        var i = void 0,
            arr = [];
        for (i = 0; i < 7; i++) {
          arr.push("<th scope=\"col\"><abbr title=\"" + this.renderDayName(opts, i) + "\">" + this.renderDayName(opts, i, true) + "</abbr></th>");
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
      }
    }, {
      key: "renderBody",
      value: function renderBody(rows) {
        return '<tbody>' + rows.join('') + '</tbody>';
      }
    }, {
      key: "renderTitle",
      value: function renderTitle(instance, c, year, month, refYear, randId) {
        var i = void 0,
            j = void 0,
            arr = void 0,
            opts = this.options,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="datepicker-controls" role="heading" aria-live="assertive">',
            monthHtml = void 0,
            yearHtml = void 0,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
          arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' + (i === month ? ' selected="selected"' : '') + (isMinYear && i < opts.minMonth || isMaxYear && i > opts.maxMonth ? 'disabled="disabled"' : '') + '>' + opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<select class="datepicker-select orig-select-month" tabindex="-1">' + arr.join('') + '</select>';

        if ($.isArray(opts.yearRange)) {
          i = opts.yearRange[0];
          j = opts.yearRange[1] + 1;
        } else {
          i = year - opts.yearRange;
          j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
          if (i >= opts.minYear) {
            arr.push("<option value=\"" + i + "\" " + (i === year ? 'selected="selected"' : '') + ">" + i + "</option>");
          }
        }

        yearHtml = "<select class=\"datepicker-select orig-select-year\" tabindex=\"-1\">" + arr.join('') + "</select>";

        var leftArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/><path d="M0-.5h24v24H0z" fill="none"/></svg>';
        html += "<button class=\"month-prev" + (prev ? '' : ' is-disabled') + "\" type=\"button\">" + leftArrow + "</button>";

        html += '<div class="selects-container">';
        if (opts.showMonthAfterYear) {
          html += yearHtml + monthHtml;
        } else {
          html += monthHtml + yearHtml;
        }
        html += '</div>';

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
          prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
          next = false;
        }

        var rightArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/></svg>';
        html += "<button class=\"month-next" + (next ? '' : ' is-disabled') + "\" type=\"button\">" + rightArrow + "</button>";

        return html += '</div>';
      }

      /**
       * refresh the HTML
       */

    }, {
      key: "draw",
      value: function draw(force) {
        if (!this.isOpen && !force) {
          return;
        }
        var opts = this.options,
            minYear = opts.minYear,
            maxYear = opts.maxYear,
            minMonth = opts.minMonth,
            maxMonth = opts.maxMonth,
            html = '',
            randId = void 0;

        if (this._y <= minYear) {
          this._y = minYear;
          if (!isNaN(minMonth) && this._m < minMonth) {
            this._m = minMonth;
          }
        }
        if (this._y >= maxYear) {
          this._y = maxYear;
          if (!isNaN(maxMonth) && this._m > maxMonth) {
            this._m = maxMonth;
          }
        }

        randId = 'datepicker-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

        for (var c = 0; c < 1; c++) {
          this._renderDateDisplay();
          html += this.renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId);
        }

        this.destroySelects();

        this.calendarEl.innerHTML = html;

        // Init Materialize Select
        var yearSelect = this.calendarEl.querySelector('.orig-select-year');
        var monthSelect = this.calendarEl.querySelector('.orig-select-month');
        M.FormSelect.init(yearSelect, {
          classes: 'select-year',
          dropdownOptions: { container: document.body, constrainWidth: false }
        });
        M.FormSelect.init(monthSelect, {
          classes: 'select-month',
          dropdownOptions: { container: document.body, constrainWidth: false }
        });

        // Add change handlers for select
        yearSelect.addEventListener('change', this._handleYearChange.bind(this));
        monthSelect.addEventListener('change', this._handleMonthChange.bind(this));

        if (typeof this.options.onDraw === 'function') {
          this.options.onDraw(this);
        }
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleInputChangeBound = this._handleInputChange.bind(this);
        this._handleCalendarClickBound = this._handleCalendarClick.bind(this);
        this._finishSelectionBound = this._finishSelection.bind(this);
        this._handleMonthChange = this._handleMonthChange.bind(this);
        this._closeBound = this.close.bind(this);

        this.el.addEventListener('click', this._handleInputClickBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.el.addEventListener('change', this._handleInputChangeBound);
        this.calendarEl.addEventListener('click', this._handleCalendarClickBound);
        this.doneBtn.addEventListener('click', this._finishSelectionBound);
        this.cancelBtn.addEventListener('click', this._closeBound);

        if (this.options.showClearBtn) {
          this._handleClearClickBound = this._handleClearClick.bind(this);
          this.clearBtn.addEventListener('click', this._handleClearClickBound);
        }
      }
    }, {
      key: "_setupVariables",
      value: function _setupVariables() {
        var _this56 = this;

        this.$modalEl = $(Datepicker._template);
        this.modalEl = this.$modalEl[0];

        this.calendarEl = this.modalEl.querySelector('.datepicker-calendar');

        this.yearTextEl = this.modalEl.querySelector('.year-text');
        this.dateTextEl = this.modalEl.querySelector('.date-text');
        if (this.options.showClearBtn) {
          this.clearBtn = this.modalEl.querySelector('.datepicker-clear');
        }
        this.doneBtn = this.modalEl.querySelector('.datepicker-done');
        this.cancelBtn = this.modalEl.querySelector('.datepicker-cancel');

        this.formats = {
          d: function () {
            return _this56.date.getDate();
          },
          dd: function () {
            var d = _this56.date.getDate();
            return (d < 10 ? '0' : '') + d;
          },
          ddd: function () {
            return _this56.options.i18n.weekdaysShort[_this56.date.getDay()];
          },
          dddd: function () {
            return _this56.options.i18n.weekdays[_this56.date.getDay()];
          },
          m: function () {
            return _this56.date.getMonth() + 1;
          },
          mm: function () {
            var m = _this56.date.getMonth() + 1;
            return (m < 10 ? '0' : '') + m;
          },
          mmm: function () {
            return _this56.options.i18n.monthsShort[_this56.date.getMonth()];
          },
          mmmm: function () {
            return _this56.options.i18n.months[_this56.date.getMonth()];
          },
          yy: function () {
            return ('' + _this56.date.getFullYear()).slice(2);
          },
          yyyy: function () {
            return _this56.date.getFullYear();
          }
        };
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
        this.el.removeEventListener('change', this._handleInputChangeBound);
        this.calendarEl.removeEventListener('click', this._handleCalendarClickBound);
      }
    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        this.open();
      }
    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        if (e.which === M.keys.ENTER) {
          e.preventDefault();
          this.open();
        }
      }
    }, {
      key: "_handleCalendarClick",
      value: function _handleCalendarClick(e) {
        if (!this.isOpen) {
          return;
        }

        var $target = $(e.target);
        if (!$target.hasClass('is-disabled')) {
          if ($target.hasClass('datepicker-day-button') && !$target.hasClass('is-empty') && !$target.parent().hasClass('is-disabled')) {
            this.setDate(new Date(e.target.getAttribute('data-year'), e.target.getAttribute('data-month'), e.target.getAttribute('data-day')));
            if (this.options.autoClose) {
              this._finishSelection();
            }
          } else if ($target.closest('.month-prev').length) {
            this.prevMonth();
          } else if ($target.closest('.month-next').length) {
            this.nextMonth();
          }
        }
      }
    }, {
      key: "_handleClearClick",
      value: function _handleClearClick() {
        this.date = null;
        this.setInputValue();
        this.close();
      }
    }, {
      key: "_handleMonthChange",
      value: function _handleMonthChange(e) {
        this.gotoMonth(e.target.value);
      }
    }, {
      key: "_handleYearChange",
      value: function _handleYearChange(e) {
        this.gotoYear(e.target.value);
      }

      /**
       * change view to a specific month (zero-index, e.g. 0: January)
       */

    }, {
      key: "gotoMonth",
      value: function gotoMonth(month) {
        if (!isNaN(month)) {
          this.calendars[0].month = parseInt(month, 10);
          this.adjustCalendars();
        }
      }

      /**
       * change view to a specific full year (e.g. "2012")
       */

    }, {
      key: "gotoYear",
      value: function gotoYear(year) {
        if (!isNaN(year)) {
          this.calendars[0].year = parseInt(year, 10);
          this.adjustCalendars();
        }
      }
    }, {
      key: "_handleInputChange",
      value: function _handleInputChange(e) {
        var date = void 0;

        // Prevent change event from being fired when triggered by the plugin
        if (e.firedBy === this) {
          return;
        }
        if (this.options.parse) {
          date = this.options.parse(this.el.value, this.options.format);
        } else {
          date = new Date(Date.parse(this.el.value));
        }

        if (Datepicker._isDate(date)) {
          this.setDate(date);
        }
      }
    }, {
      key: "renderDayName",
      value: function renderDayName(opts, day, abbr) {
        day += opts.firstDay;
        while (day >= 7) {
          day -= 7;
        }
        return abbr ? opts.i18n.weekdaysAbbrev[day] : opts.i18n.weekdays[day];
      }

      /**
       * Set input value to the selected date and close Datepicker
       */

    }, {
      key: "_finishSelection",
      value: function _finishSelection() {
        this.setInputValue();
        this.close();
      }

      /**
       * Open Datepicker
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        if (typeof this.options.onOpen === 'function') {
          this.options.onOpen.call(this);
        }
        this.draw();
        this.modal.open();
        return this;
      }

      /**
       * Close Datepicker
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        if (typeof this.options.onClose === 'function') {
          this.options.onClose.call(this);
        }
        this.modal.close();
        return this;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Datepicker.__proto__ || Object.getPrototypeOf(Datepicker), "init", this).call(this, this, els, options);
      }
    }, {
      key: "_isDate",
      value: function _isDate(obj) {
        return (/Date/.test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime())
        );
      }
    }, {
      key: "_isWeekend",
      value: function _isWeekend(date) {
        var day = date.getDay();
        return day === 0 || day === 6;
      }
    }, {
      key: "_setToStartOfDay",
      value: function _setToStartOfDay(date) {
        if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
      }
    }, {
      key: "_getDaysInMonth",
      value: function _getDaysInMonth(year, month) {
        return [31, Datepicker._isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
      }
    }, {
      key: "_isLeapYear",
      value: function _isLeapYear(year) {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      }
    }, {
      key: "_compareDates",
      value: function _compareDates(a, b) {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
      }
    }, {
      key: "_setToStartOfDay",
      value: function _setToStartOfDay(date) {
        if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Datepicker;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Datepicker;
  }(Component);

  Datepicker._template = ['<div class= "modal datepicker-modal">', '<div class="modal-content datepicker-container">', '<div class="datepicker-date-display">', '<span class="year-text"></span>', '<span class="date-text"></span>', '</div>', '<div class="datepicker-calendar-container">', '<div class="datepicker-calendar"></div>', '<div class="datepicker-footer">', '<button class="btn-flat datepicker-clear waves-effect" style="visibility: hidden;" type="button"></button>', '<div class="confirmation-btns">', '<button class="btn-flat datepicker-cancel waves-effect" type="button"></button>', '<button class="btn-flat datepicker-done waves-effect" type="button"></button>', '</div>', '</div>', '</div>', '</div>', '</div>'].join('');

  M.Datepicker = Datepicker;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Datepicker, 'datepicker', 'M_Datepicker');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    dialRadius: 135,
    outerRadius: 105,
    innerRadius: 70,
    tickRadius: 20,
    duration: 350,
    container: null,
    defaultTime: 'now', // default time, 'now' or '13:14' e.g.
    fromNow: 0, // Millisecond offset from the defaultTime
    showClearBtn: false,

    // internationalization
    i18n: {
      cancel: 'Cancel',
      clear: 'Clear',
      done: 'Ok'
    },

    autoClose: false, // auto close when minute is selected
    twelveHour: true, // change to 12 hour AM/PM clock from 24 hour
    vibrate: true, // vibrate the device when dragging clock hand

    // Callbacks
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    onSelect: null
  };

  /**
   * @class
   *
   */

  var Timepicker = function (_Component16) {
    _inherits(Timepicker, _Component16);

    function Timepicker(el, options) {
      _classCallCheck(this, Timepicker);

      var _this57 = _possibleConstructorReturn(this, (Timepicker.__proto__ || Object.getPrototypeOf(Timepicker)).call(this, Timepicker, el, options));

      _this57.el.M_Timepicker = _this57;

      _this57.options = $.extend({}, Timepicker.defaults, options);

      _this57.id = M.guid();
      _this57._insertHTMLIntoDOM();
      _this57._setupModal();
      _this57._setupVariables();
      _this57._setupEventHandlers();

      _this57._clockSetup();
      _this57._pickerSetup();
      return _this57;
    }

    _createClass(Timepicker, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.modal.destroy();
        $(this.modalEl).remove();
        this.el.M_Timepicker = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleClockClickStartBound = this._handleClockClickStart.bind(this);
        this._handleDocumentClickMoveBound = this._handleDocumentClickMove.bind(this);
        this._handleDocumentClickEndBound = this._handleDocumentClickEnd.bind(this);

        this.el.addEventListener('click', this._handleInputClickBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.plate.addEventListener('mousedown', this._handleClockClickStartBound);
        this.plate.addEventListener('touchstart', this._handleClockClickStartBound);

        $(this.spanHours).on('click', this.showView.bind(this, 'hours'));
        $(this.spanMinutes).on('click', this.showView.bind(this, 'minutes'));
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
      }
    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        this.open();
      }
    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        if (e.which === M.keys.ENTER) {
          e.preventDefault();
          this.open();
        }
      }
    }, {
      key: "_handleClockClickStart",
      value: function _handleClockClickStart(e) {
        e.preventDefault();
        var clockPlateBR = this.plate.getBoundingClientRect();
        var offset = { x: clockPlateBR.left, y: clockPlateBR.top };

        this.x0 = offset.x + this.options.dialRadius;
        this.y0 = offset.y + this.options.dialRadius;
        this.moved = false;
        var clickPos = Timepicker._Pos(e);
        this.dx = clickPos.x - this.x0;
        this.dy = clickPos.y - this.y0;

        // Set clock hands
        this.setHand(this.dx, this.dy, false);

        // Mousemove on document
        document.addEventListener('mousemove', this._handleDocumentClickMoveBound);
        document.addEventListener('touchmove', this._handleDocumentClickMoveBound);

        // Mouseup on document
        document.addEventListener('mouseup', this._handleDocumentClickEndBound);
        document.addEventListener('touchend', this._handleDocumentClickEndBound);
      }
    }, {
      key: "_handleDocumentClickMove",
      value: function _handleDocumentClickMove(e) {
        e.preventDefault();
        var clickPos = Timepicker._Pos(e);
        var x = clickPos.x - this.x0;
        var y = clickPos.y - this.y0;
        this.moved = true;
        this.setHand(x, y, false, true);
      }
    }, {
      key: "_handleDocumentClickEnd",
      value: function _handleDocumentClickEnd(e) {
        var _this58 = this;

        e.preventDefault();
        document.removeEventListener('mouseup', this._handleDocumentClickEndBound);
        document.removeEventListener('touchend', this._handleDocumentClickEndBound);
        var clickPos = Timepicker._Pos(e);
        var x = clickPos.x - this.x0;
        var y = clickPos.y - this.y0;
        if (this.moved && x === this.dx && y === this.dy) {
          this.setHand(x, y);
        }

        if (this.currentView === 'hours') {
          this.showView('minutes', this.options.duration / 2);
        } else if (this.options.autoClose) {
          $(this.minutesView).addClass('timepicker-dial-out');
          setTimeout(function () {
            _this58.done();
          }, this.options.duration / 2);
        }

        if (typeof this.options.onSelect === 'function') {
          this.options.onSelect.call(this, this.hours, this.minutes);
        }

        // Unbind mousemove event
        document.removeEventListener('mousemove', this._handleDocumentClickMoveBound);
        document.removeEventListener('touchmove', this._handleDocumentClickMoveBound);
      }
    }, {
      key: "_insertHTMLIntoDOM",
      value: function _insertHTMLIntoDOM() {
        this.$modalEl = $(Timepicker._template);
        this.modalEl = this.$modalEl[0];
        this.modalEl.id = 'modal-' + this.id;

        // Append popover to input by default
        var containerEl = document.querySelector(this.options.container);
        if (this.options.container && !!containerEl) {
          this.$modalEl.appendTo(containerEl);
        } else {
          this.$modalEl.insertBefore(this.el);
        }
      }
    }, {
      key: "_setupModal",
      value: function _setupModal() {
        var _this59 = this;

        this.modal = M.Modal.init(this.modalEl, {
          onOpenStart: this.options.onOpenStart,
          onOpenEnd: this.options.onOpenEnd,
          onCloseStart: this.options.onCloseStart,
          onCloseEnd: function () {
            if (typeof _this59.options.onCloseEnd === 'function') {
              _this59.options.onCloseEnd.call(_this59);
            }
            _this59.isOpen = false;
          }
        });
      }
    }, {
      key: "_setupVariables",
      value: function _setupVariables() {
        this.currentView = 'hours';
        this.vibrate = navigator.vibrate ? 'vibrate' : navigator.webkitVibrate ? 'webkitVibrate' : null;

        this._canvas = this.modalEl.querySelector('.timepicker-canvas');
        this.plate = this.modalEl.querySelector('.timepicker-plate');

        this.hoursView = this.modalEl.querySelector('.timepicker-hours');
        this.minutesView = this.modalEl.querySelector('.timepicker-minutes');
        this.spanHours = this.modalEl.querySelector('.timepicker-span-hours');
        this.spanMinutes = this.modalEl.querySelector('.timepicker-span-minutes');
        this.spanAmPm = this.modalEl.querySelector('.timepicker-span-am-pm');
        this.footer = this.modalEl.querySelector('.timepicker-footer');
        this.amOrPm = 'PM';
      }
    }, {
      key: "_pickerSetup",
      value: function _pickerSetup() {
        var $clearBtn = $("<button class=\"btn-flat timepicker-clear waves-effect\" style=\"visibility: hidden;\" type=\"button\" tabindex=\"" + (this.options.twelveHour ? '3' : '1') + "\">" + this.options.i18n.clear + "</button>").appendTo(this.footer).on('click', this.clear.bind(this));
        if (this.options.showClearBtn) {
          $clearBtn.css({ visibility: '' });
        }

        var confirmationBtnsContainer = $('<div class="confirmation-btns"></div>');
        $('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.cancel + '</button>').appendTo(confirmationBtnsContainer).on('click', this.close.bind(this));
        $('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.done + '</button>').appendTo(confirmationBtnsContainer).on('click', this.done.bind(this));
        confirmationBtnsContainer.appendTo(this.footer);
      }
    }, {
      key: "_clockSetup",
      value: function _clockSetup() {
        if (this.options.twelveHour) {
          this.$amBtn = $('<div class="am-btn">AM</div>');
          this.$pmBtn = $('<div class="pm-btn">PM</div>');
          this.$amBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
          this.$pmBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
        }

        this._buildHoursView();
        this._buildMinutesView();
        this._buildSVGClock();
      }
    }, {
      key: "_buildSVGClock",
      value: function _buildSVGClock() {
        // Draw clock hands and others
        var dialRadius = this.options.dialRadius;
        var tickRadius = this.options.tickRadius;
        var diameter = dialRadius * 2;

        var svg = Timepicker._createSVGEl('svg');
        svg.setAttribute('class', 'timepicker-svg');
        svg.setAttribute('width', diameter);
        svg.setAttribute('height', diameter);
        var g = Timepicker._createSVGEl('g');
        g.setAttribute('transform', 'translate(' + dialRadius + ',' + dialRadius + ')');
        var bearing = Timepicker._createSVGEl('circle');
        bearing.setAttribute('class', 'timepicker-canvas-bearing');
        bearing.setAttribute('cx', 0);
        bearing.setAttribute('cy', 0);
        bearing.setAttribute('r', 4);
        var hand = Timepicker._createSVGEl('line');
        hand.setAttribute('x1', 0);
        hand.setAttribute('y1', 0);
        var bg = Timepicker._createSVGEl('circle');
        bg.setAttribute('class', 'timepicker-canvas-bg');
        bg.setAttribute('r', tickRadius);
        g.appendChild(hand);
        g.appendChild(bg);
        g.appendChild(bearing);
        svg.appendChild(g);
        this._canvas.appendChild(svg);

        this.hand = hand;
        this.bg = bg;
        this.bearing = bearing;
        this.g = g;
      }
    }, {
      key: "_buildHoursView",
      value: function _buildHoursView() {
        var $tick = $('<div class="timepicker-tick"></div>');
        // Hours view
        if (this.options.twelveHour) {
          for (var i = 1; i < 13; i += 1) {
            var tick = $tick.clone();
            var radian = i / 6 * Math.PI;
            var radius = this.options.outerRadius;
            tick.css({
              left: this.options.dialRadius + Math.sin(radian) * radius - this.options.tickRadius + 'px',
              top: this.options.dialRadius - Math.cos(radian) * radius - this.options.tickRadius + 'px'
            });
            tick.html(i === 0 ? '00' : i);
            this.hoursView.appendChild(tick[0]);
            // tick.on(mousedownEvent, mousedown);
          }
        } else {
          for (var _i2 = 0; _i2 < 24; _i2 += 1) {
            var _tick = $tick.clone();
            var _radian = _i2 / 6 * Math.PI;
            var inner = _i2 > 0 && _i2 < 13;
            var _radius = inner ? this.options.innerRadius : this.options.outerRadius;
            _tick.css({
              left: this.options.dialRadius + Math.sin(_radian) * _radius - this.options.tickRadius + 'px',
              top: this.options.dialRadius - Math.cos(_radian) * _radius - this.options.tickRadius + 'px'
            });
            _tick.html(_i2 === 0 ? '00' : _i2);
            this.hoursView.appendChild(_tick[0]);
            // tick.on(mousedownEvent, mousedown);
          }
        }
      }
    }, {
      key: "_buildMinutesView",
      value: function _buildMinutesView() {
        var $tick = $('<div class="timepicker-tick"></div>');
        // Minutes view
        for (var i = 0; i < 60; i += 5) {
          var tick = $tick.clone();
          var radian = i / 30 * Math.PI;
          tick.css({
            left: this.options.dialRadius + Math.sin(radian) * this.options.outerRadius - this.options.tickRadius + 'px',
            top: this.options.dialRadius - Math.cos(radian) * this.options.outerRadius - this.options.tickRadius + 'px'
          });
          tick.html(Timepicker._addLeadingZero(i));
          this.minutesView.appendChild(tick[0]);
        }
      }
    }, {
      key: "_handleAmPmClick",
      value: function _handleAmPmClick(e) {
        var $btnClicked = $(e.target);
        this.amOrPm = $btnClicked.hasClass('am-btn') ? 'AM' : 'PM';
        this._updateAmPmView();
      }
    }, {
      key: "_updateAmPmView",
      value: function _updateAmPmView() {
        if (this.options.twelveHour) {
          this.$amBtn.toggleClass('text-primary', this.amOrPm === 'AM');
          this.$pmBtn.toggleClass('text-primary', this.amOrPm === 'PM');
        }
      }
    }, {
      key: "_updateTimeFromInput",
      value: function _updateTimeFromInput() {
        // Get the time
        var value = ((this.el.value || this.options.defaultTime || '') + '').split(':');
        if (this.options.twelveHour && !(typeof value[1] === 'undefined')) {
          if (value[1].toUpperCase().indexOf('AM') > 0) {
            this.amOrPm = 'AM';
          } else {
            this.amOrPm = 'PM';
          }
          value[1] = value[1].replace('AM', '').replace('PM', '');
        }
        if (value[0] === 'now') {
          var now = new Date(+new Date() + this.options.fromNow);
          value = [now.getHours(), now.getMinutes()];
          if (this.options.twelveHour) {
            this.amOrPm = value[0] >= 12 && value[0] < 24 ? 'PM' : 'AM';
          }
        }
        this.hours = +value[0] || 0;
        this.minutes = +value[1] || 0;
        this.spanHours.innerHTML = this.hours;
        this.spanMinutes.innerHTML = Timepicker._addLeadingZero(this.minutes);

        this._updateAmPmView();
      }
    }, {
      key: "showView",
      value: function showView(view, delay) {
        if (view === 'minutes' && $(this.hoursView).css('visibility') === 'visible') {
          // raiseCallback(this.options.beforeHourSelect);
        }
        var isHours = view === 'hours',
            nextView = isHours ? this.hoursView : this.minutesView,
            hideView = isHours ? this.minutesView : this.hoursView;
        this.currentView = view;

        $(this.spanHours).toggleClass('text-primary', isHours);
        $(this.spanMinutes).toggleClass('text-primary', !isHours);

        // Transition view
        hideView.classList.add('timepicker-dial-out');
        $(nextView).css('visibility', 'visible').removeClass('timepicker-dial-out');

        // Reset clock hand
        this.resetClock(delay);

        // After transitions ended
        clearTimeout(this.toggleViewTimer);
        this.toggleViewTimer = setTimeout(function () {
          $(hideView).css('visibility', 'hidden');
        }, this.options.duration);
      }
    }, {
      key: "resetClock",
      value: function resetClock(delay) {
        var view = this.currentView,
            value = this[view],
            isHours = view === 'hours',
            unit = Math.PI / (isHours ? 6 : 30),
            radian = value * unit,
            radius = isHours && value > 0 && value < 13 ? this.options.innerRadius : this.options.outerRadius,
            x = Math.sin(radian) * radius,
            y = -Math.cos(radian) * radius,
            self = this;

        if (delay) {
          $(this.canvas).addClass('timepicker-canvas-out');
          setTimeout(function () {
            $(self.canvas).removeClass('timepicker-canvas-out');
            self.setHand(x, y);
          }, delay);
        } else {
          this.setHand(x, y);
        }
      }
    }, {
      key: "setHand",
      value: function setHand(x, y, roundBy5) {
        var _this60 = this;

        var radian = Math.atan2(x, -y),
            isHours = this.currentView === 'hours',
            unit = Math.PI / (isHours || roundBy5 ? 6 : 30),
            z = Math.sqrt(x * x + y * y),
            inner = isHours && z < (this.options.outerRadius + this.options.innerRadius) / 2,
            radius = inner ? this.options.innerRadius : this.options.outerRadius;

        if (this.options.twelveHour) {
          radius = this.options.outerRadius;
        }

        // Radian should in range [0, 2PI]
        if (radian < 0) {
          radian = Math.PI * 2 + radian;
        }

        // Get the round value
        var value = Math.round(radian / unit);

        // Get the round radian
        radian = value * unit;

        // Correct the hours or minutes
        if (this.options.twelveHour) {
          if (isHours) {
            if (value === 0) value = 12;
          } else {
            if (roundBy5) value *= 5;
            if (value === 60) value = 0;
          }
        } else {
          if (isHours) {
            if (value === 12) {
              value = 0;
            }
            value = inner ? value === 0 ? 12 : value : value === 0 ? 0 : value + 12;
          } else {
            if (roundBy5) {
              value *= 5;
            }
            if (value === 60) {
              value = 0;
            }
          }
        }

        // Once hours or minutes changed, vibrate the device
        if (this[this.currentView] !== value) {
          if (this.vibrate && this.options.vibrate) {
            // Do not vibrate too frequently
            if (!this.vibrateTimer) {
              navigator[this.vibrate](10);
              this.vibrateTimer = setTimeout(function () {
                _this60.vibrateTimer = null;
              }, 100);
            }
          }
        }

        this[this.currentView] = value;
        if (isHours) {
          this['spanHours'].innerHTML = value;
        } else {
          this['spanMinutes'].innerHTML = Timepicker._addLeadingZero(value);
        }

        // Set clock hand and others' position
        var cx1 = Math.sin(radian) * (radius - this.options.tickRadius),
            cy1 = -Math.cos(radian) * (radius - this.options.tickRadius),
            cx2 = Math.sin(radian) * radius,
            cy2 = -Math.cos(radian) * radius;
        this.hand.setAttribute('x2', cx1);
        this.hand.setAttribute('y2', cy1);
        this.bg.setAttribute('cx', cx2);
        this.bg.setAttribute('cy', cy2);
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        this._updateTimeFromInput();
        this.showView('hours');

        this.modal.open();
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        this.modal.close();
      }

      /**
       * Finish timepicker selection.
       */

    }, {
      key: "done",
      value: function done(e, clearValue) {
        // Set input value
        var last = this.el.value;
        var value = clearValue ? '' : Timepicker._addLeadingZero(this.hours) + ':' + Timepicker._addLeadingZero(this.minutes);
        this.time = value;
        if (!clearValue && this.options.twelveHour) {
          value = value + " " + this.amOrPm;
        }
        this.el.value = value;

        // Trigger change event
        if (value !== last) {
          this.$el.trigger('change');
        }

        this.close();
        this.el.focus();
      }
    }, {
      key: "clear",
      value: function clear() {
        this.done(null, true);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Timepicker.__proto__ || Object.getPrototypeOf(Timepicker), "init", this).call(this, this, els, options);
      }
    }, {
      key: "_addLeadingZero",
      value: function _addLeadingZero(num) {
        return (num < 10 ? '0' : '') + num;
      }
    }, {
      key: "_createSVGEl",
      value: function _createSVGEl(name) {
        var svgNS = 'http://www.w3.org/2000/svg';
        return document.createElementNS(svgNS, name);
      }

      /**
       * @typedef {Object} Point
       * @property {number} x The X Coordinate
       * @property {number} y The Y Coordinate
       */

      /**
       * Get x position of mouse or touch event
       * @param {Event} e
       * @return {Point} x and y location
       */

    }, {
      key: "_Pos",
      value: function _Pos(e) {
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return { x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY };
        }
        // mouse event
        return { x: e.clientX, y: e.clientY };
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Timepicker;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Timepicker;
  }(Component);

  Timepicker._template = ['<div class= "modal timepicker-modal">', '<div class="modal-content timepicker-container">', '<div class="timepicker-digital-display">', '<div class="timepicker-text-container">', '<div class="timepicker-display-column">', '<span class="timepicker-span-hours text-primary"></span>', ':', '<span class="timepicker-span-minutes"></span>', '</div>', '<div class="timepicker-display-column timepicker-display-am-pm">', '<div class="timepicker-span-am-pm"></div>', '</div>', '</div>', '</div>', '<div class="timepicker-analog-display">', '<div class="timepicker-plate">', '<div class="timepicker-canvas"></div>', '<div class="timepicker-dial timepicker-hours"></div>', '<div class="timepicker-dial timepicker-minutes timepicker-dial-out"></div>', '</div>', '<div class="timepicker-footer"></div>', '</div>', '</div>', '</div>'].join('');

  M.Timepicker = Timepicker;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Timepicker, 'timepicker', 'M_Timepicker');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {};

  /**
   * @class
   *
   */

  var CharacterCounter = function (_Component17) {
    _inherits(CharacterCounter, _Component17);

    /**
     * Construct CharacterCounter instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function CharacterCounter(el, options) {
      _classCallCheck(this, CharacterCounter);

      var _this61 = _possibleConstructorReturn(this, (CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter)).call(this, CharacterCounter, el, options));

      _this61.el.M_CharacterCounter = _this61;

      /**
       * Options for the character counter
       */
      _this61.options = $.extend({}, CharacterCounter.defaults, options);

      _this61.isInvalid = false;
      _this61.isValidLength = false;
      _this61._setupCounter();
      _this61._setupEventHandlers();
      return _this61;
    }

    _createClass(CharacterCounter, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.CharacterCounter = undefined;
        this._removeCounter();
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleUpdateCounterBound = this.updateCounter.bind(this);

        this.el.addEventListener('focus', this._handleUpdateCounterBound, true);
        this.el.addEventListener('input', this._handleUpdateCounterBound, true);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('focus', this._handleUpdateCounterBound, true);
        this.el.removeEventListener('input', this._handleUpdateCounterBound, true);
      }

      /**
       * Setup counter element
       */

    }, {
      key: "_setupCounter",
      value: function _setupCounter() {
        this.counterEl = document.createElement('span');
        $(this.counterEl).addClass('character-counter').css({
          float: 'right',
          'font-size': '12px',
          height: 1
        });

        this.$el.parent().append(this.counterEl);
      }

      /**
       * Remove counter element
       */

    }, {
      key: "_removeCounter",
      value: function _removeCounter() {
        $(this.counterEl).remove();
      }

      /**
       * Update counter
       */

    }, {
      key: "updateCounter",
      value: function updateCounter() {
        var maxLength = +this.$el.attr('data-length'),
            actualLength = this.el.value.length;
        this.isValidLength = actualLength <= maxLength;
        var counterString = actualLength;

        if (maxLength) {
          counterString += '/' + maxLength;
          this._validateInput();
        }

        $(this.counterEl).html(counterString);
      }

      /**
       * Add validation classes
       */

    }, {
      key: "_validateInput",
      value: function _validateInput() {
        if (this.isValidLength && this.isInvalid) {
          this.isInvalid = false;
          this.$el.removeClass('invalid');
        } else if (!this.isValidLength && !this.isInvalid) {
          this.isInvalid = true;
          this.$el.removeClass('valid');
          this.$el.addClass('invalid');
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_CharacterCounter;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return CharacterCounter;
  }(Component);

  M.CharacterCounter = CharacterCounter;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(CharacterCounter, 'characterCounter', 'M_CharacterCounter');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    duration: 200, // ms
    dist: -100, // zoom scale TODO: make this more intuitive as an option
    shift: 0, // spacing for center image
    padding: 0, // Padding between non center items
    numVisible: 5, // Number of visible items in carousel
    fullWidth: false, // Change to full width styles
    indicators: false, // Toggle indicators
    noWrap: false, // Don't wrap around and cycle through items.
    onCycleTo: null // Callback for when a new slide is cycled to.
  };

  /**
   * @class
   *
   */

  var Carousel = function (_Component18) {
    _inherits(Carousel, _Component18);

    /**
     * Construct Carousel instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Carousel(el, options) {
      _classCallCheck(this, Carousel);

      var _this62 = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, Carousel, el, options));

      _this62.el.M_Carousel = _this62;

      /**
       * Options for the carousel
       * @member Carousel#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {Number} shift
       * @prop {Number} padding
       * @prop {Number} numVisible
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */
      _this62.options = $.extend({}, Carousel.defaults, options);

      // Setup
      _this62.hasMultipleSlides = _this62.$el.find('.carousel-item').length > 1;
      _this62.showIndicators = _this62.options.indicators && _this62.hasMultipleSlides;
      _this62.noWrap = _this62.options.noWrap || !_this62.hasMultipleSlides;
      _this62.pressed = false;
      _this62.dragged = false;
      _this62.offset = _this62.target = 0;
      _this62.images = [];
      _this62.itemWidth = _this62.$el.find('.carousel-item').first().innerWidth();
      _this62.itemHeight = _this62.$el.find('.carousel-item').first().innerHeight();
      _this62.dim = _this62.itemWidth * 2 + _this62.options.padding || 1; // Make sure dim is non zero for divisions.
      _this62._autoScrollBound = _this62._autoScroll.bind(_this62);
      _this62._trackBound = _this62._track.bind(_this62);

      // Full Width carousel setup
      if (_this62.options.fullWidth) {
        _this62.options.dist = 0;
        _this62._setCarouselHeight();

        // Offset fixed items when indicators.
        if (_this62.showIndicators) {
          _this62.$el.find('.carousel-fixed-item').addClass('with-indicators');
        }
      }

      // Iterate through slides
      _this62.$indicators = $('<ul class="indicators"></ul>');
      _this62.$el.find('.carousel-item').each(function (el, i) {
        _this62.images.push(el);
        if (_this62.showIndicators) {
          var $indicator = $('<li class="indicator-item"></li>');

          // Add active to first by default.
          if (i === 0) {
            $indicator[0].classList.add('active');
          }

          _this62.$indicators.append($indicator);
        }
      });
      if (_this62.showIndicators) {
        _this62.$el.append(_this62.$indicators);
      }
      _this62.count = _this62.images.length;

      // Cap numVisible at count
      _this62.options.numVisible = Math.min(_this62.count, _this62.options.numVisible);

      // Setup cross browser string
      _this62.xform = 'transform';
      ['webkit', 'Moz', 'O', 'ms'].every(function (prefix) {
        var e = prefix + 'Transform';
        if (typeof document.body.style[e] !== 'undefined') {
          _this62.xform = e;
          return false;
        }
        return true;
      });

      _this62._setupEventHandlers();
      _this62._scroll(_this62.offset);
      return _this62;
    }

    _createClass(Carousel, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_Carousel = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this63 = this;

        this._handleCarouselTapBound = this._handleCarouselTap.bind(this);
        this._handleCarouselDragBound = this._handleCarouselDrag.bind(this);
        this._handleCarouselReleaseBound = this._handleCarouselRelease.bind(this);
        this._handleCarouselClickBound = this._handleCarouselClick.bind(this);

        if (typeof window.ontouchstart !== 'undefined') {
          this.el.addEventListener('touchstart', this._handleCarouselTapBound);
          this.el.addEventListener('touchmove', this._handleCarouselDragBound);
          this.el.addEventListener('touchend', this._handleCarouselReleaseBound);
        }

        this.el.addEventListener('mousedown', this._handleCarouselTapBound);
        this.el.addEventListener('mousemove', this._handleCarouselDragBound);
        this.el.addEventListener('mouseup', this._handleCarouselReleaseBound);
        this.el.addEventListener('mouseleave', this._handleCarouselReleaseBound);
        this.el.addEventListener('click', this._handleCarouselClickBound);

        if (this.showIndicators && this.$indicators) {
          this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);
          this.$indicators.find('.indicator-item').each(function (el, i) {
            el.addEventListener('click', _this63._handleIndicatorClickBound);
          });
        }

        // Resize
        var throttledResize = M.throttle(this._handleResize, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);

        window.addEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this64 = this;

        if (typeof window.ontouchstart !== 'undefined') {
          this.el.removeEventListener('touchstart', this._handleCarouselTapBound);
          this.el.removeEventListener('touchmove', this._handleCarouselDragBound);
          this.el.removeEventListener('touchend', this._handleCarouselReleaseBound);
        }
        this.el.removeEventListener('mousedown', this._handleCarouselTapBound);
        this.el.removeEventListener('mousemove', this._handleCarouselDragBound);
        this.el.removeEventListener('mouseup', this._handleCarouselReleaseBound);
        this.el.removeEventListener('mouseleave', this._handleCarouselReleaseBound);
        this.el.removeEventListener('click', this._handleCarouselClickBound);

        if (this.showIndicators && this.$indicators) {
          this.$indicators.find('.indicator-item').each(function (el, i) {
            el.removeEventListener('click', _this64._handleIndicatorClickBound);
          });
        }

        window.removeEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Handle Carousel Tap
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselTap",
      value: function _handleCarouselTap(e) {
        // Fixes firefox draggable image bug
        if (e.type === 'mousedown' && $(e.target).is('img')) {
          e.preventDefault();
        }
        this.pressed = true;
        this.dragged = false;
        this.verticalDragged = false;
        this.reference = this._xpos(e);
        this.referenceY = this._ypos(e);

        this.velocity = this.amplitude = 0;
        this.frame = this.offset;
        this.timestamp = Date.now();
        clearInterval(this.ticker);
        this.ticker = setInterval(this._trackBound, 100);
      }

      /**
       * Handle Carousel Drag
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselDrag",
      value: function _handleCarouselDrag(e) {
        var x = void 0,
            y = void 0,
            delta = void 0,
            deltaY = void 0;
        if (this.pressed) {
          x = this._xpos(e);
          y = this._ypos(e);
          delta = this.reference - x;
          deltaY = Math.abs(this.referenceY - y);
          if (deltaY < 30 && !this.verticalDragged) {
            // If vertical scrolling don't allow dragging.
            if (delta > 2 || delta < -2) {
              this.dragged = true;
              this.reference = x;
              this._scroll(this.offset + delta);
            }
          } else if (this.dragged) {
            // If dragging don't allow vertical scroll.
            e.preventDefault();
            e.stopPropagation();
            return false;
          } else {
            // Vertical scrolling.
            this.verticalDragged = true;
          }
        }

        if (this.dragged) {
          // If dragging don't allow vertical scroll.
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }

      /**
       * Handle Carousel Release
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselRelease",
      value: function _handleCarouselRelease(e) {
        if (this.pressed) {
          this.pressed = false;
        } else {
          return;
        }

        clearInterval(this.ticker);
        this.target = this.offset;
        if (this.velocity > 10 || this.velocity < -10) {
          this.amplitude = 0.9 * this.velocity;
          this.target = this.offset + this.amplitude;
        }
        this.target = Math.round(this.target / this.dim) * this.dim;

        // No wrap of items.
        if (this.noWrap) {
          if (this.target >= this.dim * (this.count - 1)) {
            this.target = this.dim * (this.count - 1);
          } else if (this.target < 0) {
            this.target = 0;
          }
        }
        this.amplitude = this.target - this.offset;
        this.timestamp = Date.now();
        requestAnimationFrame(this._autoScrollBound);

        if (this.dragged) {
          e.preventDefault();
          e.stopPropagation();
        }
        return false;
      }

      /**
       * Handle Carousel CLick
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselClick",
      value: function _handleCarouselClick(e) {
        // Disable clicks if carousel was dragged.
        if (this.dragged) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        } else if (!this.options.fullWidth) {
          var clickedIndex = $(e.target).closest('.carousel-item').index();
          var diff = this._wrap(this.center) - clickedIndex;

          // Disable clicks if carousel was shifted by click
          if (diff !== 0) {
            e.preventDefault();
            e.stopPropagation();
          }
          this._cycleTo(clickedIndex);
        }
      }

      /**
       * Handle Indicator CLick
       * @param {Event} e
       */

    }, {
      key: "_handleIndicatorClick",
      value: function _handleIndicatorClick(e) {
        e.stopPropagation();

        var indicator = $(e.target).closest('.indicator-item');
        if (indicator.length) {
          this._cycleTo(indicator.index());
        }
      }

      /**
       * Handle Throttle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleResize",
      value: function _handleResize(e) {
        if (this.options.fullWidth) {
          this.itemWidth = this.$el.find('.carousel-item').first().innerWidth();
          this.imageHeight = this.$el.find('.carousel-item.active').height();
          this.dim = this.itemWidth * 2 + this.options.padding;
          this.offset = this.center * 2 * this.itemWidth;
          this.target = this.offset;
          this._setCarouselHeight(true);
        } else {
          this._scroll();
        }
      }

      /**
       * Set carousel height based on first slide
       * @param {Booleam} imageOnly - true for image slides
       */

    }, {
      key: "_setCarouselHeight",
      value: function _setCarouselHeight(imageOnly) {
        var _this65 = this;

        var firstSlide = this.$el.find('.carousel-item.active').length ? this.$el.find('.carousel-item.active').first() : this.$el.find('.carousel-item').first();
        var firstImage = firstSlide.find('img').first();
        if (firstImage.length) {
          if (firstImage[0].complete) {
            // If image won't trigger the load event
            var imageHeight = firstImage.height();
            if (imageHeight > 0) {
              this.$el.css('height', imageHeight + 'px');
            } else {
              // If image still has no height, use the natural dimensions to calculate
              var naturalWidth = firstImage[0].naturalWidth;
              var naturalHeight = firstImage[0].naturalHeight;
              var adjustedHeight = this.$el.width() / naturalWidth * naturalHeight;
              this.$el.css('height', adjustedHeight + 'px');
            }
          } else {
            // Get height when image is loaded normally
            firstImage.one('load', function (el, i) {
              _this65.$el.css('height', el.offsetHeight + 'px');
            });
          }
        } else if (!imageOnly) {
          var slideHeight = firstSlide.height();
          this.$el.css('height', slideHeight + 'px');
        }
      }

      /**
       * Get x position from event
       * @param {Event} e
       */

    }, {
      key: "_xpos",
      value: function _xpos(e) {
        // touch event
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientX;
        }

        // mouse event
        return e.clientX;
      }

      /**
       * Get y position from event
       * @param {Event} e
       */

    }, {
      key: "_ypos",
      value: function _ypos(e) {
        // touch event
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientY;
        }

        // mouse event
        return e.clientY;
      }

      /**
       * Wrap index
       * @param {Number} x
       */

    }, {
      key: "_wrap",
      value: function _wrap(x) {
        return x >= this.count ? x % this.count : x < 0 ? this._wrap(this.count + x % this.count) : x;
      }

      /**
       * Tracks scrolling information
       */

    }, {
      key: "_track",
      value: function _track() {
        var now = void 0,
            elapsed = void 0,
            delta = void 0,
            v = void 0;

        now = Date.now();
        elapsed = now - this.timestamp;
        this.timestamp = now;
        delta = this.offset - this.frame;
        this.frame = this.offset;

        v = 1000 * delta / (1 + elapsed);
        this.velocity = 0.8 * v + 0.2 * this.velocity;
      }

      /**
       * Auto scrolls to nearest carousel item.
       */

    }, {
      key: "_autoScroll",
      value: function _autoScroll() {
        var elapsed = void 0,
            delta = void 0;

        if (this.amplitude) {
          elapsed = Date.now() - this.timestamp;
          delta = this.amplitude * Math.exp(-elapsed / this.options.duration);
          if (delta > 2 || delta < -2) {
            this._scroll(this.target - delta);
            requestAnimationFrame(this._autoScrollBound);
          } else {
            this._scroll(this.target);
          }
        }
      }

      /**
       * Scroll to target
       * @param {Number} x
       */

    }, {
      key: "_scroll",
      value: function _scroll(x) {
        var _this66 = this;

        // Track scrolling state
        if (!this.$el.hasClass('scrolling')) {
          this.el.classList.add('scrolling');
        }
        if (this.scrollingTimeout != null) {
          window.clearTimeout(this.scrollingTimeout);
        }
        this.scrollingTimeout = window.setTimeout(function () {
          _this66.$el.removeClass('scrolling');
        }, this.options.duration);

        // Start actual scroll
        var i = void 0,
            half = void 0,
            delta = void 0,
            dir = void 0,
            tween = void 0,
            el = void 0,
            alignment = void 0,
            zTranslation = void 0,
            tweenedOpacity = void 0,
            centerTweenedOpacity = void 0;
        var lastCenter = this.center;
        var numVisibleOffset = 1 / this.options.numVisible;

        this.offset = typeof x === 'number' ? x : this.offset;
        this.center = Math.floor((this.offset + this.dim / 2) / this.dim);
        delta = this.offset - this.center * this.dim;
        dir = delta < 0 ? 1 : -1;
        tween = -dir * delta * 2 / this.dim;
        half = this.count >> 1;

        if (this.options.fullWidth) {
          alignment = 'translateX(0)';
          centerTweenedOpacity = 1;
        } else {
          alignment = 'translateX(' + (this.el.clientWidth - this.itemWidth) / 2 + 'px) ';
          alignment += 'translateY(' + (this.el.clientHeight - this.itemHeight) / 2 + 'px)';
          centerTweenedOpacity = 1 - numVisibleOffset * tween;
        }

        // Set indicator active
        if (this.showIndicators) {
          var diff = this.center % this.count;
          var activeIndicator = this.$indicators.find('.indicator-item.active');
          if (activeIndicator.index() !== diff) {
            activeIndicator.removeClass('active');
            this.$indicators.find('.indicator-item').eq(diff)[0].classList.add('active');
          }
        }

        // center
        // Don't show wrapped items.
        if (!this.noWrap || this.center >= 0 && this.center < this.count) {
          el = this.images[this._wrap(this.center)];

          // Add active class to center item.
          if (!$(el).hasClass('active')) {
            this.$el.find('.carousel-item').removeClass('active');
            el.classList.add('active');
          }
          var transformString = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween * i + "px) translateZ(" + this.options.dist * tween + "px)";
          this._updateItemStyle(el, centerTweenedOpacity, 0, transformString);
        }

        for (i = 1; i <= half; ++i) {
          // right side
          if (this.options.fullWidth) {
            zTranslation = this.options.dist;
            tweenedOpacity = i === half && delta < 0 ? 1 - tween : 1;
          } else {
            zTranslation = this.options.dist * (i * 2 + tween * dir);
            tweenedOpacity = 1 - numVisibleOffset * (i * 2 + tween * dir);
          }
          // Don't show wrapped items.
          if (!this.noWrap || this.center + i < this.count) {
            el = this.images[this._wrap(this.center + i)];
            var _transformString = alignment + " translateX(" + (this.options.shift + (this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
            this._updateItemStyle(el, tweenedOpacity, -i, _transformString);
          }

          // left side
          if (this.options.fullWidth) {
            zTranslation = this.options.dist;
            tweenedOpacity = i === half && delta > 0 ? 1 - tween : 1;
          } else {
            zTranslation = this.options.dist * (i * 2 - tween * dir);
            tweenedOpacity = 1 - numVisibleOffset * (i * 2 - tween * dir);
          }
          // Don't show wrapped items.
          if (!this.noWrap || this.center - i >= 0) {
            el = this.images[this._wrap(this.center - i)];
            var _transformString2 = alignment + " translateX(" + (-this.options.shift + (-this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
            this._updateItemStyle(el, tweenedOpacity, -i, _transformString2);
          }
        }

        // center
        // Don't show wrapped items.
        if (!this.noWrap || this.center >= 0 && this.center < this.count) {
          el = this.images[this._wrap(this.center)];
          var _transformString3 = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween + "px) translateZ(" + this.options.dist * tween + "px)";
          this._updateItemStyle(el, centerTweenedOpacity, 0, _transformString3);
        }

        // onCycleTo callback
        var $currItem = this.$el.find('.carousel-item').eq(this._wrap(this.center));
        if (lastCenter !== this.center && typeof this.options.onCycleTo === 'function') {
          this.options.onCycleTo.call(this, $currItem[0], this.dragged);
        }

        // One time callback
        if (typeof this.oneTimeCallback === 'function') {
          this.oneTimeCallback.call(this, $currItem[0], this.dragged);
          this.oneTimeCallback = null;
        }
      }

      /**
       * Cycle to target
       * @param {Element} el
       * @param {Number} opacity
       * @param {Number} zIndex
       * @param {String} transform
       */

    }, {
      key: "_updateItemStyle",
      value: function _updateItemStyle(el, opacity, zIndex, transform) {
        el.style[this.xform] = transform;
        el.style.zIndex = zIndex;
        el.style.opacity = opacity;
        el.style.visibility = 'visible';
      }

      /**
       * Cycle to target
       * @param {Number} n
       * @param {Function} callback
       */

    }, {
      key: "_cycleTo",
      value: function _cycleTo(n, callback) {
        var diff = this.center % this.count - n;

        // Account for wraparound.
        if (!this.noWrap) {
          if (diff < 0) {
            if (Math.abs(diff + this.count) < Math.abs(diff)) {
              diff += this.count;
            }
          } else if (diff > 0) {
            if (Math.abs(diff - this.count) < diff) {
              diff -= this.count;
            }
          }
        }

        this.target = this.dim * Math.round(this.offset / this.dim);
        // Next
        if (diff < 0) {
          this.target += this.dim * Math.abs(diff);

          // Prev
        } else if (diff > 0) {
          this.target -= this.dim * diff;
        }

        // Set one time callback
        if (typeof callback === 'function') {
          this.oneTimeCallback = callback;
        }

        // Scroll
        if (this.offset !== this.target) {
          this.amplitude = this.target - this.offset;
          this.timestamp = Date.now();
          requestAnimationFrame(this._autoScrollBound);
        }
      }

      /**
       * Cycle to next item
       * @param {Number} [n]
       */

    }, {
      key: "next",
      value: function next(n) {
        if (n === undefined || isNaN(n)) {
          n = 1;
        }

        var index = this.center + n;
        if (index >= this.count || index < 0) {
          if (this.noWrap) {
            return;
          }

          index = this._wrap(index);
        }
        this._cycleTo(index);
      }

      /**
       * Cycle to previous item
       * @param {Number} [n]
       */

    }, {
      key: "prev",
      value: function prev(n) {
        if (n === undefined || isNaN(n)) {
          n = 1;
        }

        var index = this.center - n;
        if (index >= this.count || index < 0) {
          if (this.noWrap) {
            return;
          }

          index = this._wrap(index);
        }

        this._cycleTo(index);
      }

      /**
       * Cycle to nth item
       * @param {Number} [n]
       * @param {Function} callback
       */

    }, {
      key: "set",
      value: function set(n, callback) {
        if (n === undefined || isNaN(n)) {
          n = 0;
        }

        if (n > this.count || n < 0) {
          if (this.noWrap) {
            return;
          }

          n = this._wrap(n);
        }

        this._cycleTo(n, callback);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Carousel.__proto__ || Object.getPrototypeOf(Carousel), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Carousel;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Carousel;
  }(Component);

  M.Carousel = Carousel;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Carousel, 'carousel', 'M_Carousel');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    onOpen: undefined,
    onClose: undefined
  };

  /**
   * @class
   *
   */

  var TapTarget = function (_Component19) {
    _inherits(TapTarget, _Component19);

    /**
     * Construct TapTarget instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function TapTarget(el, options) {
      _classCallCheck(this, TapTarget);

      var _this67 = _possibleConstructorReturn(this, (TapTarget.__proto__ || Object.getPrototypeOf(TapTarget)).call(this, TapTarget, el, options));

      _this67.el.M_TapTarget = _this67;

      /**
       * Options for the select
       * @member TapTarget#options
       * @prop {Function} onOpen - Callback function called when feature discovery is opened
       * @prop {Function} onClose - Callback function called when feature discovery is closed
       */
      _this67.options = $.extend({}, TapTarget.defaults, options);

      _this67.isOpen = false;

      // setup
      _this67.$origin = $('#' + _this67.$el.attr('data-target'));
      _this67._setup();

      _this67._calculatePositioning();
      _this67._setupEventHandlers();
      return _this67;
    }

    _createClass(TapTarget, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.TapTarget = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleDocumentClickBound = this._handleDocumentClick.bind(this);
        this._handleTargetClickBound = this._handleTargetClick.bind(this);
        this._handleOriginClickBound = this._handleOriginClick.bind(this);

        this.el.addEventListener('click', this._handleTargetClickBound);
        this.originEl.addEventListener('click', this._handleOriginClickBound);

        // Resize
        var throttledResize = M.throttle(this._handleResize, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);

        window.addEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleTargetClickBound);
        this.originEl.removeEventListener('click', this._handleOriginClickBound);
        window.removeEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Handle Target Click
       * @param {Event} e
       */

    }, {
      key: "_handleTargetClick",
      value: function _handleTargetClick(e) {
        this.open();
      }

      /**
       * Handle Origin Click
       * @param {Event} e
       */

    }, {
      key: "_handleOriginClick",
      value: function _handleOriginClick(e) {
        this.close();
      }

      /**
       * Handle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleResize",
      value: function _handleResize(e) {
        this._calculatePositioning();
      }

      /**
       * Handle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        if (!$(e.target).closest('.tap-target-wrapper').length) {
          this.close();
          e.preventDefault();
          e.stopPropagation();
        }
      }

      /**
       * Setup Tap Target
       */

    }, {
      key: "_setup",
      value: function _setup() {
        // Creating tap target
        this.wrapper = this.$el.parent()[0];
        this.waveEl = $(this.wrapper).find('.tap-target-wave')[0];
        this.originEl = $(this.wrapper).find('.tap-target-origin')[0];
        this.contentEl = this.$el.find('.tap-target-content')[0];

        // Creating wrapper
        if (!$(this.wrapper).hasClass('.tap-target-wrapper')) {
          this.wrapper = document.createElement('div');
          this.wrapper.classList.add('tap-target-wrapper');
          this.$el.before($(this.wrapper));
          this.wrapper.append(this.el);
        }

        // Creating content
        if (!this.contentEl) {
          this.contentEl = document.createElement('div');
          this.contentEl.classList.add('tap-target-content');
          this.$el.append(this.contentEl);
        }

        // Creating foreground wave
        if (!this.waveEl) {
          this.waveEl = document.createElement('div');
          this.waveEl.classList.add('tap-target-wave');

          // Creating origin
          if (!this.originEl) {
            this.originEl = this.$origin.clone(true, true);
            this.originEl.addClass('tap-target-origin');
            this.originEl.removeAttr('id');
            this.originEl.removeAttr('style');
            this.originEl = this.originEl[0];
            this.waveEl.append(this.originEl);
          }

          this.wrapper.append(this.waveEl);
        }
      }

      /**
       * Calculate positioning
       */

    }, {
      key: "_calculatePositioning",
      value: function _calculatePositioning() {
        // Element or parent is fixed position?
        var isFixed = this.$origin.css('position') === 'fixed';
        if (!isFixed) {
          var parents = this.$origin.parents();
          for (var i = 0; i < parents.length; i++) {
            isFixed = $(parents[i]).css('position') == 'fixed';
            if (isFixed) {
              break;
            }
          }
        }

        // Calculating origin
        var originWidth = this.$origin.outerWidth();
        var originHeight = this.$origin.outerHeight();
        var originTop = isFixed ? this.$origin.offset().top - M.getDocumentScrollTop() : this.$origin.offset().top;
        var originLeft = isFixed ? this.$origin.offset().left - M.getDocumentScrollLeft() : this.$origin.offset().left;

        // Calculating screen
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var centerX = windowWidth / 2;
        var centerY = windowHeight / 2;
        var isLeft = originLeft <= centerX;
        var isRight = originLeft > centerX;
        var isTop = originTop <= centerY;
        var isBottom = originTop > centerY;
        var isCenterX = originLeft >= windowWidth * 0.25 && originLeft <= windowWidth * 0.75;

        // Calculating tap target
        var tapTargetWidth = this.$el.outerWidth();
        var tapTargetHeight = this.$el.outerHeight();
        var tapTargetTop = originTop + originHeight / 2 - tapTargetHeight / 2;
        var tapTargetLeft = originLeft + originWidth / 2 - tapTargetWidth / 2;
        var tapTargetPosition = isFixed ? 'fixed' : 'absolute';

        // Calculating content
        var tapTargetTextWidth = isCenterX ? tapTargetWidth : tapTargetWidth / 2 + originWidth;
        var tapTargetTextHeight = tapTargetHeight / 2;
        var tapTargetTextTop = isTop ? tapTargetHeight / 2 : 0;
        var tapTargetTextBottom = 0;
        var tapTargetTextLeft = isLeft && !isCenterX ? tapTargetWidth / 2 - originWidth : 0;
        var tapTargetTextRight = 0;
        var tapTargetTextPadding = originWidth;
        var tapTargetTextAlign = isBottom ? 'bottom' : 'top';

        // Calculating wave
        var tapTargetWaveWidth = originWidth > originHeight ? originWidth * 2 : originWidth * 2;
        var tapTargetWaveHeight = tapTargetWaveWidth;
        var tapTargetWaveTop = tapTargetHeight / 2 - tapTargetWaveHeight / 2;
        var tapTargetWaveLeft = tapTargetWidth / 2 - tapTargetWaveWidth / 2;

        // Setting tap target
        var tapTargetWrapperCssObj = {};
        tapTargetWrapperCssObj.top = isTop ? tapTargetTop + 'px' : '';
        tapTargetWrapperCssObj.right = isRight ? windowWidth - tapTargetLeft - tapTargetWidth + 'px' : '';
        tapTargetWrapperCssObj.bottom = isBottom ? windowHeight - tapTargetTop - tapTargetHeight + 'px' : '';
        tapTargetWrapperCssObj.left = isLeft ? tapTargetLeft + 'px' : '';
        tapTargetWrapperCssObj.position = tapTargetPosition;
        $(this.wrapper).css(tapTargetWrapperCssObj);

        // Setting content
        $(this.contentEl).css({
          width: tapTargetTextWidth + 'px',
          height: tapTargetTextHeight + 'px',
          top: tapTargetTextTop + 'px',
          right: tapTargetTextRight + 'px',
          bottom: tapTargetTextBottom + 'px',
          left: tapTargetTextLeft + 'px',
          padding: tapTargetTextPadding + 'px',
          verticalAlign: tapTargetTextAlign
        });

        // Setting wave
        $(this.waveEl).css({
          top: tapTargetWaveTop + 'px',
          left: tapTargetWaveLeft + 'px',
          width: tapTargetWaveWidth + 'px',
          height: tapTargetWaveHeight + 'px'
        });
      }

      /**
       * Open TapTarget
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        // onOpen callback
        if (typeof this.options.onOpen === 'function') {
          this.options.onOpen.call(this, this.$origin[0]);
        }

        this.isOpen = true;
        this.wrapper.classList.add('open');

        document.body.addEventListener('click', this._handleDocumentClickBound, true);
        document.body.addEventListener('touchend', this._handleDocumentClickBound);
      }

      /**
       * Close Tap Target
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        // onClose callback
        if (typeof this.options.onClose === 'function') {
          this.options.onClose.call(this, this.$origin[0]);
        }

        this.isOpen = false;
        this.wrapper.classList.remove('open');

        document.body.removeEventListener('click', this._handleDocumentClickBound, true);
        document.body.removeEventListener('touchend', this._handleDocumentClickBound);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(TapTarget.__proto__ || Object.getPrototypeOf(TapTarget), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_TapTarget;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return TapTarget;
  }(Component);

  M.TapTarget = TapTarget;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(TapTarget, 'tapTarget', 'M_TapTarget');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    classes: '',
    dropdownOptions: {}
  };

  /**
   * @class
   *
   */

  var FormSelect = function (_Component20) {
    _inherits(FormSelect, _Component20);

    /**
     * Construct FormSelect instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function FormSelect(el, options) {
      _classCallCheck(this, FormSelect);

      // Don't init if browser default version
      var _this68 = _possibleConstructorReturn(this, (FormSelect.__proto__ || Object.getPrototypeOf(FormSelect)).call(this, FormSelect, el, options));

      if (_this68.$el.hasClass('browser-default')) {
        return _possibleConstructorReturn(_this68);
      }

      _this68.el.M_FormSelect = _this68;

      /**
       * Options for the select
       * @member FormSelect#options
       */
      _this68.options = $.extend({}, FormSelect.defaults, options);

      _this68.isMultiple = _this68.$el.prop('multiple');

      // Setup
      _this68.el.tabIndex = -1;
      _this68._keysSelected = {};
      _this68._valueDict = {}; // Maps key to original and generated option element.
      _this68._setupDropdown();

      _this68._setupEventHandlers();
      return _this68;
    }

    _createClass(FormSelect, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._removeDropdown();
        this.el.M_FormSelect = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this69 = this;

        this._handleSelectChangeBound = this._handleSelectChange.bind(this);
        this._handleOptionClickBound = this._handleOptionClick.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);

        $(this.dropdownOptions).find('li:not(.optgroup)').each(function (el) {
          el.addEventListener('click', _this69._handleOptionClickBound);
        });
        this.el.addEventListener('change', this._handleSelectChangeBound);
        this.input.addEventListener('click', this._handleInputClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this70 = this;

        $(this.dropdownOptions).find('li:not(.optgroup)').each(function (el) {
          el.removeEventListener('click', _this70._handleOptionClickBound);
        });
        this.el.removeEventListener('change', this._handleSelectChangeBound);
        this.input.removeEventListener('click', this._handleInputClickBound);
      }

      /**
       * Handle Select Change
       * @param {Event} e
       */

    }, {
      key: "_handleSelectChange",
      value: function _handleSelectChange(e) {
        this._setValueToInput();
      }

      /**
       * Handle Option Click
       * @param {Event} e
       */

    }, {
      key: "_handleOptionClick",
      value: function _handleOptionClick(e) {
        e.preventDefault();
        var option = $(e.target).closest('li')[0];
        var key = option.id;
        if (!$(option).hasClass('disabled') && !$(option).hasClass('optgroup') && key.length) {
          var selected = true;

          if (this.isMultiple) {
            // Deselect placeholder option if still selected.
            var placeholderOption = $(this.dropdownOptions).find('li.disabled.selected');
            if (placeholderOption.length) {
              placeholderOption.removeClass('selected');
              placeholderOption.find('input[type="checkbox"]').prop('checked', false);
              this._toggleEntryFromArray(placeholderOption[0].id);
            }
            selected = this._toggleEntryFromArray(key);
          } else {
            $(this.dropdownOptions).find('li').removeClass('selected');
            $(option).toggleClass('selected', selected);
          }

          // Set selected on original select option
          // Only trigger if selected state changed
          var prevSelected = $(this._valueDict[key].el).prop('selected');
          if (prevSelected !== selected) {
            $(this._valueDict[key].el).prop('selected', selected);
            this.$el.trigger('change');
          }
        }

        e.stopPropagation();
      }

      /**
       * Handle Input Click
       */

    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        if (this.dropdown && this.dropdown.isOpen) {
          this._setValueToInput();
          this._setSelectedStates();
        }
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_setupDropdown",
      value: function _setupDropdown() {
        var _this71 = this;

        this.wrapper = document.createElement('div');
        $(this.wrapper).addClass('select-wrapper ' + this.options.classes);
        this.$el.before($(this.wrapper));
        this.wrapper.appendChild(this.el);

        if (this.el.disabled) {
          this.wrapper.classList.add('disabled');
        }

        // Create dropdown
        this.$selectOptions = this.$el.children('option, optgroup');
        this.dropdownOptions = document.createElement('ul');
        this.dropdownOptions.id = "select-options-" + M.guid();
        $(this.dropdownOptions).addClass('dropdown-content select-dropdown ' + (this.isMultiple ? 'multiple-select-dropdown' : ''));

        // Create dropdown structure.
        if (this.$selectOptions.length) {
          this.$selectOptions.each(function (el) {
            if ($(el).is('option')) {
              // Direct descendant option.
              var optionEl = void 0;
              if (_this71.isMultiple) {
                optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'multiple');
              } else {
                optionEl = _this71._appendOptionWithIcon(_this71.$el, el);
              }

              _this71._addOptionToValueDict(el, optionEl);
            } else if ($(el).is('optgroup')) {
              // Optgroup.
              var selectOptions = $(el).children('option');
              $(_this71.dropdownOptions).append($('<li class="optgroup"><span>' + el.getAttribute('label') + '</span></li>')[0]);

              selectOptions.each(function (el) {
                var optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'optgroup-option');
                _this71._addOptionToValueDict(el, optionEl);
              });
            }
          });
        }

        this.$el.after(this.dropdownOptions);

        // Add input dropdown
        this.input = document.createElement('input');
        $(this.input).addClass('select-dropdown dropdown-trigger');
        this.input.setAttribute('type', 'text');
        this.input.setAttribute('readonly', 'true');
        this.input.setAttribute('data-target', this.dropdownOptions.id);
        if (this.el.disabled) {
          $(this.input).prop('disabled', 'true');
        }

        this.$el.before(this.input);
        this._setValueToInput();

        // Add caret
        var dropdownIcon = $('<svg class="caret" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
        this.$el.before(dropdownIcon[0]);

        // Initialize dropdown
        if (!this.el.disabled) {
          var dropdownOptions = $.extend({}, this.options.dropdownOptions);

          // Add callback for centering selected option when dropdown content is scrollable
          dropdownOptions.onOpenEnd = function (el) {
            var selectedOption = $(_this71.dropdownOptions).find('.selected').first();

            if (selectedOption.length) {
              // Focus selected option in dropdown
              M.keyDown = true;
              _this71.dropdown.focusedIndex = selectedOption.index();
              _this71.dropdown._focusFocusedItem();
              M.keyDown = false;

              // Handle scrolling to selected option
              if (_this71.dropdown.isScrollable) {
                var scrollOffset = selectedOption[0].getBoundingClientRect().top - _this71.dropdownOptions.getBoundingClientRect().top; // scroll to selected option
                scrollOffset -= _this71.dropdownOptions.clientHeight / 2; // center in dropdown
                _this71.dropdownOptions.scrollTop = scrollOffset;
              }
            }
          };

          if (this.isMultiple) {
            dropdownOptions.closeOnClick = false;
          }
          this.dropdown = M.Dropdown.init(this.input, dropdownOptions);
        }

        // Add initial selections
        this._setSelectedStates();
      }

      /**
       * Add option to value dict
       * @param {Element} el  original option element
       * @param {Element} optionEl  generated option element
       */

    }, {
      key: "_addOptionToValueDict",
      value: function _addOptionToValueDict(el, optionEl) {
        var index = Object.keys(this._valueDict).length;
        var key = this.dropdownOptions.id + index;
        var obj = {};
        optionEl.id = key;

        obj.el = el;
        obj.optionEl = optionEl;
        this._valueDict[key] = obj;
      }

      /**
       * Remove dropdown
       */

    }, {
      key: "_removeDropdown",
      value: function _removeDropdown() {
        $(this.wrapper).find('.caret').remove();
        $(this.input).remove();
        $(this.dropdownOptions).remove();
        $(this.wrapper).before(this.$el);
        $(this.wrapper).remove();
      }

      /**
       * Setup dropdown
       * @param {Element} select  select element
       * @param {Element} option  option element from select
       * @param {String} type
       * @return {Element}  option element added
       */

    }, {
      key: "_appendOptionWithIcon",
      value: function _appendOptionWithIcon(select, option, type) {
        // Add disabled attr if disabled
        var disabledClass = option.disabled ? 'disabled ' : '';
        var optgroupClass = type === 'optgroup-option' ? 'optgroup-option ' : '';
        var multipleCheckbox = this.isMultiple ? "<label><input type=\"checkbox\"" + disabledClass + "\"/><span>" + option.innerHTML + "</span></label>" : option.innerHTML;
        var liEl = $('<li></li>');
        var spanEl = $('<span></span>');
        spanEl.html(multipleCheckbox);
        liEl.addClass(disabledClass + " " + optgroupClass);
        liEl.append(spanEl);

        // add icons
        var iconUrl = option.getAttribute('data-icon');
        if (!!iconUrl) {
          var imgEl = $("<img alt=\"\" src=\"" + iconUrl + "\">");
          liEl.prepend(imgEl);
        }

        // Check for multiple type.
        $(this.dropdownOptions).append(liEl[0]);
        return liEl[0];
      }

      /**
       * Toggle entry from option
       * @param {String} key  Option key
       * @return {Boolean}  if entry was added or removed
       */

    }, {
      key: "_toggleEntryFromArray",
      value: function _toggleEntryFromArray(key) {
        var notAdded = !this._keysSelected.hasOwnProperty(key);
        var $optionLi = $(this._valueDict[key].optionEl);

        if (notAdded) {
          this._keysSelected[key] = true;
        } else {
          delete this._keysSelected[key];
        }

        $optionLi.toggleClass('selected', notAdded);

        // Set checkbox checked value
        $optionLi.find('input[type="checkbox"]').prop('checked', notAdded);

        // use notAdded instead of true (to detect if the option is selected or not)
        $optionLi.prop('selected', notAdded);

        return notAdded;
      }

      /**
       * Set text value to input
       */

    }, {
      key: "_setValueToInput",
      value: function _setValueToInput() {
        var values = [];
        var options = this.$el.find('option');

        options.each(function (el) {
          if ($(el).prop('selected')) {
            var text = $(el).text();
            values.push(text);
          }
        });

        if (!values.length) {
          var firstDisabled = this.$el.find('option:disabled').eq(0);
          if (firstDisabled.length && firstDisabled[0].value === '') {
            values.push(firstDisabled.text());
          }
        }

        this.input.value = values.join(', ');
      }

      /**
       * Set selected state of dropdown to match actual select element
       */

    }, {
      key: "_setSelectedStates",
      value: function _setSelectedStates() {
        this._keysSelected = {};

        for (var key in this._valueDict) {
          var option = this._valueDict[key];
          var optionIsSelected = $(option.el).prop('selected');
          $(option.optionEl).find('input[type="checkbox"]').prop('checked', optionIsSelected);
          if (optionIsSelected) {
            this._activateOption($(this.dropdownOptions), $(option.optionEl));
            this._keysSelected[key] = true;
          } else {
            $(option.optionEl).removeClass('selected');
          }
        }
      }

      /**
       * Make option as selected and scroll to selected position
       * @param {jQuery} collection  Select options jQuery element
       * @param {Element} newOption  element of the new option
       */

    }, {
      key: "_activateOption",
      value: function _activateOption(collection, newOption) {
        if (newOption) {
          if (!this.isMultiple) {
            collection.find('li.selected').removeClass('selected');
          }
          var option = $(newOption);
          option.addClass('selected');
        }
      }

      /**
       * Get Selected Values
       * @return {Array}  Array of selected values
       */

    }, {
      key: "getSelectedValues",
      value: function getSelectedValues() {
        var selectedValues = [];
        for (var key in this._keysSelected) {
          selectedValues.push(this._valueDict[key].el.value);
        }
        return selectedValues;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(FormSelect.__proto__ || Object.getPrototypeOf(FormSelect), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_FormSelect;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return FormSelect;
  }(Component);

  M.FormSelect = FormSelect;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(FormSelect, 'formSelect', 'M_FormSelect');
  }
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {};

  /**
   * @class
   *
   */

  var Range = function (_Component21) {
    _inherits(Range, _Component21);

    /**
     * Construct Range instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Range(el, options) {
      _classCallCheck(this, Range);

      var _this72 = _possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, Range, el, options));

      _this72.el.M_Range = _this72;

      /**
       * Options for the range
       * @member Range#options
       */
      _this72.options = $.extend({}, Range.defaults, options);

      _this72._mousedown = false;

      // Setup
      _this72._setupThumb();

      _this72._setupEventHandlers();
      return _this72;
    }

    _createClass(Range, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._removeThumb();
        this.el.M_Range = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleRangeChangeBound = this._handleRangeChange.bind(this);
        this._handleRangeMousedownTouchstartBound = this._handleRangeMousedownTouchstart.bind(this);
        this._handleRangeInputMousemoveTouchmoveBound = this._handleRangeInputMousemoveTouchmove.bind(this);
        this._handleRangeMouseupTouchendBound = this._handleRangeMouseupTouchend.bind(this);
        this._handleRangeBlurMouseoutTouchleaveBound = this._handleRangeBlurMouseoutTouchleave.bind(this);

        this.el.addEventListener('change', this._handleRangeChangeBound);

        this.el.addEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
        this.el.addEventListener('touchstart', this._handleRangeMousedownTouchstartBound);

        this.el.addEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.addEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.addEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);

        this.el.addEventListener('mouseup', this._handleRangeMouseupTouchendBound);
        this.el.addEventListener('touchend', this._handleRangeMouseupTouchendBound);

        this.el.addEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.addEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.addEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('change', this._handleRangeChangeBound);

        this.el.removeEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
        this.el.removeEventListener('touchstart', this._handleRangeMousedownTouchstartBound);

        this.el.removeEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.removeEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.removeEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);

        this.el.removeEventListener('mouseup', this._handleRangeMouseupTouchendBound);
        this.el.removeEventListener('touchend', this._handleRangeMouseupTouchendBound);

        this.el.removeEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.removeEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.removeEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
      }

      /**
       * Handle Range Change
       * @param {Event} e
       */

    }, {
      key: "_handleRangeChange",
      value: function _handleRangeChange() {
        $(this.value).html(this.$el.val());

        if (!$(this.thumb).hasClass('active')) {
          this._showRangeBubble();
        }

        var offsetLeft = this._calcRangeOffset();
        $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
      }

      /**
       * Handle Range Mousedown and Touchstart
       * @param {Event} e
       */

    }, {
      key: "_handleRangeMousedownTouchstart",
      value: function _handleRangeMousedownTouchstart(e) {
        // Set indicator value
        $(this.value).html(this.$el.val());

        this._mousedown = true;
        this.$el.addClass('active');

        if (!$(this.thumb).hasClass('active')) {
          this._showRangeBubble();
        }

        if (e.type !== 'input') {
          var offsetLeft = this._calcRangeOffset();
          $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
        }
      }

      /**
       * Handle Range Input, Mousemove and Touchmove
       */

    }, {
      key: "_handleRangeInputMousemoveTouchmove",
      value: function _handleRangeInputMousemoveTouchmove() {
        if (this._mousedown) {
          if (!$(this.thumb).hasClass('active')) {
            this._showRangeBubble();
          }

          var offsetLeft = this._calcRangeOffset();
          $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
          $(this.value).html(this.$el.val());
        }
      }

      /**
       * Handle Range Mouseup and Touchend
       */

    }, {
      key: "_handleRangeMouseupTouchend",
      value: function _handleRangeMouseupTouchend() {
        this._mousedown = false;
        this.$el.removeClass('active');
      }

      /**
       * Handle Range Blur, Mouseout and Touchleave
       */

    }, {
      key: "_handleRangeBlurMouseoutTouchleave",
      value: function _handleRangeBlurMouseoutTouchleave() {
        if (!this._mousedown) {
          var paddingLeft = parseInt(this.$el.css('padding-left'));
          var marginLeft = 7 + paddingLeft + 'px';

          if ($(this.thumb).hasClass('active')) {
            anim.remove(this.thumb);
            anim({
              targets: this.thumb,
              height: 0,
              width: 0,
              top: 10,
              easing: 'easeOutQuad',
              marginLeft: marginLeft,
              duration: 100
            });
          }
          $(this.thumb).removeClass('active');
        }
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_setupThumb",
      value: function _setupThumb() {
        this.thumb = document.createElement('span');
        this.value = document.createElement('span');
        $(this.thumb).addClass('thumb');
        $(this.value).addClass('value');
        $(this.thumb).append(this.value);
        this.$el.after(this.thumb);
      }

      /**
       * Remove dropdown
       */

    }, {
      key: "_removeThumb",
      value: function _removeThumb() {
        $(this.thumb).remove();
      }

      /**
       * morph thumb into bubble
       */

    }, {
      key: "_showRangeBubble",
      value: function _showRangeBubble() {
        var paddingLeft = parseInt($(this.thumb).parent().css('padding-left'));
        var marginLeft = -7 + paddingLeft + 'px'; // TODO: fix magic number?
        anim.remove(this.thumb);
        anim({
          targets: this.thumb,
          height: 30,
          width: 30,
          top: -30,
          marginLeft: marginLeft,
          duration: 300,
          easing: 'easeOutQuint'
        });
      }

      /**
       * Calculate the offset of the thumb
       * @return {Number}  offset in pixels
       */

    }, {
      key: "_calcRangeOffset",
      value: function _calcRangeOffset() {
        var width = this.$el.width() - 15;
        var max = parseFloat(this.$el.attr('max')) || 100; // Range default max
        var min = parseFloat(this.$el.attr('min')) || 0; // Range default min
        var percent = (parseFloat(this.$el.val()) - min) / (max - min);
        return percent * width;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Range.__proto__ || Object.getPrototypeOf(Range), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Range;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Range;
  }(Component);

  M.Range = Range;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Range, 'range', 'M_Range');
  }

  Range.init($('input[type=range]'));
})(cash, M.anime);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ingreso_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afe6101_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ingreso_vue__ = __webpack_require__(309);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ingreso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afe6101_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ingreso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.jsPDF=e()}(this,function(){"use strict";var t,y,e,I,i,o,a,h,C,T,d,p,F,n,r,s,c,P,E,q,g,m,w,l,v,b,x,S,u,k,_,f,A,O,B,R,j,D,M,U,N,z,L,H,W,G,V,Y,X,J,K,Q,Z,vt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},$=function(pt){var gt="1.3",mt={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};function wt(o){var a={};this.subscribe=function(t,e,n){if("function"!=typeof e)return!1;a.hasOwnProperty(t)||(a[t]={});var r=Math.random().toString(35);return a[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in a)if(a[e][t])return delete a[e][t],!0;return!1},this.publish=function(t){if(a.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in a[t]){var i=a[t][r];try{i[0].apply(o,e)}catch(t){pt.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}}}function yt(t,e,n,r){var i={};"object"===(void 0===t?"undefined":vt(t))&&(t=(i=t).orientation,e=i.unit||e,n=i.format||n,r=i.compress||i.compressPdf||r),e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();(""+n).toLowerCase();var K,w,y,o,u,v,a,s,h,c,l,f=!!r&&"function"==typeof Uint8Array,Q=i.textColor||"0 g",d=i.drawColor||"0 G",Z=i.fontSize||16,$=i.charSpace||0,tt=i.R2L||!1,et=i.lineHeight||1.15,p=i.lineWidth||.200025,g="00000000000000000000000000000000",m=2,b=!1,x=[],nt={},S={},k=0,_=[],A=[],I=[],C=[],T=[],F=0,P=0,E=0,q={title:"",subject:"",author:"",keywords:"",creator:""},O={},rt=new wt(O),B=i.hotfixes||[],R=function(t){var e,n=t.ch1,r=t.ch2,i=t.ch3,o=t.ch4,a=(t.precision,"draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"]);if("string"==typeof n&&"#"!==n.charAt(0)){var s=new RGBColor(n);s.ok&&(n=s.toHex())}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var h=parseInt(n.substr(1),16);n=h>>16&255,r=h>>8&255,i=255&h}if(void 0===r||void 0===o&&n===r&&r===i)if("string"==typeof n)e=n+" "+a[0];else switch(t.precision){case 2:e=N(n/255)+" "+a[0];break;case 3:default:e=z(n/255)+" "+a[0]}else if(void 0===o||"object"===(void 0===o?"undefined":vt(o))){if("string"==typeof n)e=[n,r,i,a[1]].join(" ");else switch(t.precision){case 2:e=[N(n/255),N(r/255),N(i/255),a[1]].join(" ");break;default:case 3:e=[z(n/255),z(r/255),z(i/255),a[1]].join(" ")}o&&0===o.a&&(e=["255","255","255",a[1]].join(" "))}else if("string"==typeof n)e=[n,r,i,o,a[2]].join(" ");else switch(t.precision){case 2:e=[N(n),N(r),N(i),N(o),a[2]].join(" ");break;case 3:default:e=[z(n),z(r),z(i),z(o),a[2]].join(" ")}return e},j=function(t){var e=function(t){return("0"+parseInt(t)).slice(-2)},n=t.getTimezoneOffset(),r=n<0?"+":"-",i=Math.floor(Math.abs(n/60)),o=Math.abs(n%60),a=[r,e(i),"'",e(o),"'"].join("");return["D:",t.getFullYear(),e(t.getMonth()+1),e(t.getDate()),e(t.getHours()),e(t.getMinutes()),e(t.getSeconds()),a].join("")},D=function(t){var e;return void 0===(void 0===t?"undefined":vt(t))&&(t=new Date),e="object"===(void 0===t?"undefined":vt(t))&&"[object Date]"===Object.prototype.toString.call(t)?j(t):/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t)?t:j(new Date),c=e},M=function(t){var e=c;return"jsDate"===t&&(e=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),o=parseInt(t.substr(12,2),10),a=parseInt(t.substr(14,2),10);parseInt(t.substr(16,2),10),parseInt(t.substr(20,2),10);return new Date(e,n,r,i,o,a,0)}(c)),e},U=function(t){return t=t||"12345678901234567890123456789012".split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join(""),g=t},N=function(t){return t.toFixed(2)},z=function(t){return t.toFixed(3)},it=function(t){t="string"==typeof t?t:t.toString(),b?_[o].push(t):(E+=t.length+1,C.push(t))},L=function(){return x[++m]=E,it(m+" 0 obj"),m},H=function(t){it("stream"),it(t),it("endstream")},W=function(){for(var t in it("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),it("/Font <<"),nt)nt.hasOwnProperty(t)&&it("/"+t+" "+nt[t].objectNumber+" 0 R");it(">>"),it("/XObject <<"),rt.publish("putXobjectDict"),it(">>")},G=function(){!function(){for(var t in nt)nt.hasOwnProperty(t)&&(e=nt[t],rt.publish("putFont",{font:e,out:it,newObject:L}),!0!==e.isAlreadyPutted&&(e.objectNumber=L(),it("<<"),it("/Type /Font"),it("/BaseFont /"+e.postScriptName),it("/Subtype /Type1"),"string"==typeof e.encoding&&it("/Encoding /"+e.encoding),it("/FirstChar 32"),it("/LastChar 255"),it(">>"),it("endobj")));var e}(),rt.publish("putResources"),x[2]=E,it("2 0 obj"),it("<<"),W(),it(">>"),it("endobj"),rt.publish("postPutResources")},V=function(t,e,n){S.hasOwnProperty(e)||(S[e]={}),S[e][n]=t},Y=function(t,e,n,r){var i="F"+(Object.keys(nt).length+1).toString(10),o=nt[i]={id:i,postScriptName:t,fontName:e,fontStyle:n,encoding:r,metadata:{}};return V(i,e,n),rt.publish("addFont",o),i},ot=function(t,e){return function(t,e){var n,r,i,o,a,s,h,c,l;if(i=(e=e||{}).sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&nt[K].metadata&&nt[K].metadata[i]&&nt[K].metadata[i].encoding&&(o=nt[K].metadata[i].encoding,!a&&nt[K].encoding&&(a=nt[K].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(h=!1,s=[],n=0,r=t.length;n<r;n++)(c=a[t.charCodeAt(n)])?s.push(String.fromCharCode(c)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(h=!0);t=s.join("")}for(n=t.length;void 0===h&&0!==n;)t.charCodeAt(n-1)>>8&&(h=!0),n--;if(!h)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((l=(c=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(l),s.push(c-(l<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},X=function(){(function(t,e){var n="string"==typeof e&&e.toLowerCase();if("string"==typeof t){var r=t.toLowerCase();mt.hasOwnProperty(r)&&(t=mt[r][0]/w,e=mt[r][1]/w)}if(Array.isArray(t)&&(e=t[1],t=t[0]),n){switch(n.substr(0,1)){case"l":t<e&&(n="s");break;case"p":e<t&&(n="s")}"s"===n&&(y=t,t=e,e=y)}b=!0,_[++k]=[],I[k]={width:Number(t)||u,height:Number(e)||v},A[k]={},J(k)}).apply(this,arguments),it(N(p*w)+" w"),it(d),0!==F&&it(F+" J"),0!==P&&it(P+" j"),rt.publish("addPage",{pageNumber:k})},J=function(t){0<t&&t<=k&&(u=I[o=t].width,v=I[t].height)},at=function(t,e,n){var r,i=void 0;return n=n||{},t=void 0!==t?t:nt[K].fontName,e=void 0!==e?e:nt[K].fontStyle,r=t.toLowerCase(),void 0!==S[r]&&void 0!==S[r][e]?i=S[r][e]:void 0!==S[t]&&void 0!==S[t][e]?i=S[t][e]:!1===n.disableWarning&&console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||n.noFallback||null==(i=S.times[e])&&(i=S.times.normal),i},st=function(){b=!1,m=2,E=0,C=[],x=[],T=[],rt.publish("buildDocument"),it("%PDF-"+gt),it("%ºß¬à"),function(){var t,e,n,r,i,o,a,s,h,c=[];for(a=pt.adler32cs||yt.API.adler32cs,f&&void 0===a&&(f=!1),t=1;t<=k;t++){if(c.push(L()),s=(u=I[t].width)*w,h=(v=I[t].height)*w,it("<</Type /Page"),it("/Parent 1 0 R"),it("/Resources 2 0 R"),it("/MediaBox [0 0 "+N(s)+" "+N(h)+"]"),rt.publish("putPage",{pageNumber:t,page:_[t]}),it("/Contents "+(m+1)+" 0 R"),it(">>"),it("endobj"),e=_[t].join("\n"),L(),f){for(n=[],r=e.length;r--;)n[r]=e.charCodeAt(r);o=a.from(e),(i=new Deflater(6)).append(new Uint8Array(n)),e=i.flush(),(n=new Uint8Array(e.length+6)).set(new Uint8Array([120,156])),n.set(e,2),n.set(new Uint8Array([255&o,o>>8&255,o>>16&255,o>>24&255]),e.length+2),e=String.fromCharCode.apply(null,n),it("<</Length "+e.length+" /Filter [/FlateDecode]>>")}else it("<</Length "+e.length+">>");H(e),it("endobj")}x[1]=E,it("1 0 obj"),it("<</Type /Pages");var l="/Kids [";for(r=0;r<k;r++)l+=c[r]+" 0 R ";it(l+"]"),it("/Count "+k),it(">>"),it("endobj"),rt.publish("postPutPages")}(),function(){rt.publish("putAdditionalObjects");for(var t=0;t<T.length;t++){var e=T[t];x[e.objId]=E,it(e.objId+" 0 obj"),it(e.content),it("endobj")}m+=T.length,rt.publish("postPutAdditionalObjects")}(),G(),L(),it("<<"),function(){for(var t in it("/Producer (jsPDF "+yt.version+")"),q)q.hasOwnProperty(t)&&q[t]&&it("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+ot(q[t])+")");it("/CreationDate ("+c+")")}(),it(">>"),it("endobj"),L(),it("<<"),function(){switch(it("/Type /Catalog"),it("/Pages 1 0 R"),s||(s="fullwidth"),s){case"fullwidth":it("/OpenAction [3 0 R /FitH null]");break;case"fullheight":it("/OpenAction [3 0 R /FitV null]");break;case"fullpage":it("/OpenAction [3 0 R /Fit]");break;case"original":it("/OpenAction [3 0 R /XYZ null null 1]");break;default:var t=""+s;"%"===t.substr(t.length-1)&&(s=parseInt(s)/100),"number"==typeof s&&it("/OpenAction [3 0 R /XYZ null null "+N(s)+"]")}switch(h||(h="continuous"),h){case"continuous":it("/PageLayout /OneColumn");break;case"single":it("/PageLayout /SinglePage");break;case"two":case"twoleft":it("/PageLayout /TwoColumnLeft");break;case"tworight":it("/PageLayout /TwoColumnRight")}a&&it("/PageMode /"+a),rt.publish("putCatalog")}(),it(">>"),it("endobj");var t,e=E,n="0000000000";for(it("xref"),it("0 "+(m+1)),it(n+" 65535 f "),t=1;t<=m;t++){var r=x[t];it("function"==typeof r?(n+x[t]()).slice(-10)+" 00000 n ":(n+x[t]).slice(-10)+" 00000 n ")}return it("trailer"),it("<<"),it("/Size "+(m+1)),it("/Root "+m+" 0 R"),it("/Info "+(m-1)+" 0 R"),it("/ID [ <"+g+"> <"+g+"> ]"),it(">>"),it("startxref"),it(""+e),it("%%EOF"),b=!0,C.join("\n")},ht=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e},ct=function(){for(var t=st(),e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},lt=function(){return new Blob([ct()],{type:"application/pdf"})},ut=((l=function(t,e){var n="dataur"===(""+t).substr(0,6)?"data:application/pdf;base64,"+btoa(st()):0;switch(t){case void 0:return st();case"save":if("object"===("undefined"==typeof navigator?"undefined":vt(navigator))&&navigator.getUserMedia&&(void 0===pt.URL||void 0===pt.URL.createObjectURL))return O.output("dataurlnewwindow");bt(lt(),e),"function"==typeof bt.unload&&pt.setTimeout&&setTimeout(bt.unload,911);break;case"arraybuffer":return ct();case"blob":return lt();case"bloburi":case"bloburl":return pt.URL&&pt.URL.createObjectURL(lt())||void 0;case"datauristring":case"dataurlstring":return n;case"dataurlnewwindow":var r=pt.open(n);if(r||"undefined"==typeof safari)return r;case"datauri":case"dataurl":return pt.document.location.href=n;default:throw new Error('Output type "'+t+'" is not supported.')}}).foo=function(){try{return l.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!pt.console)throw new Error(n);pt.console.error(n,t),pt.alert&&alert(n)}},(l.foo.bar=l).foo),ft=function(t){return!0===Array.isArray(B)&&-1<B.indexOf(t)};switch(e){case"pt":w=1;break;case"mm":w=72/25.4;break;case"cm":w=72/2.54;break;case"in":w=72;break;case"px":w=1==ft("px_scaling")?.75:96/72;break;case"pc":case"em":w=12;break;case"ex":w=6;break;default:throw"Invalid unit: "+e}for(var dt in D(),U(),O.internal={pdfEscape:ot,getStyle:ht,getFont:function(){return nt[at.apply(O,arguments)]},getFontSize:function(){return Z},getCharSpace:function(){return $},getTextColor:function(){var t=Q.split(" ");if(2===t.length&&"g"===t[1]){var e=parseFloat(t[0]);t=[e,e,e,"r"]}for(var n="#",r=0;r<3;r++)n+=("0"+Math.floor(255*parseFloat(t[r])).toString(16)).slice(-2);return n},getLineHeight:function(){return Z*et},write:function(t){it(1===arguments.length?t:Array.prototype.join.call(arguments," "))},getCoordinateString:function(t){return N(t*w)},getVerticalCoordinateString:function(t){return N((v-t)*w)},collections:{},newObject:L,newAdditionalObject:function(){var t=2*_.length+1,e={objId:t+=T.length,content:""};return T.push(e),e},newObjectDeferred:function(){return x[++m]=function(){return E},m},newObjectDeferredBegin:function(t){x[t]=E},putStream:H,events:rt,scaleFactor:w,pageSize:{getWidth:function(){return u},getHeight:function(){return v}},output:function(t,e){return ut(t,e)},getNumberOfPages:function(){return _.length-1},pages:_,out:it,f2:N,getPageInfo:function(t){return{objId:2*(t-1)+3,pageNumber:t,pageContext:A[t]}},getCurrentPageInfo:function(){return{objId:2*(o-1)+3,pageNumber:o,pageContext:A[o]}},getPDFVersion:function(){return gt},hasHotfix:ft},O.addPage=function(){return X.apply(this,arguments),this},O.setPage=function(){return J.apply(this,arguments),this},O.insertPage=function(t){return this.addPage(),this.movePage(o,t),this},O.movePage=function(t,e){if(e<t){for(var n=_[t],r=I[t],i=A[t],o=t;e<o;o--)_[o]=_[o-1],I[o]=I[o-1],A[o]=A[o-1];_[e]=n,I[e]=r,A[e]=i,this.setPage(e)}else if(t<e){for(n=_[t],r=I[t],i=A[t],o=t;o<e;o++)_[o]=_[o+1],I[o]=I[o+1],A[o]=A[o+1];_[e]=n,I[e]=r,A[e]=i,this.setPage(e)}return this},O.deletePage=function(){return function(t){0<t&&t<=k&&(_.splice(t,1),I.splice(t,1),--k<o&&(o=k),this.setPage(o))}.apply(this,arguments),this},O.setCreationDate=function(t){return D(t),this},O.getCreationDate=function(t){return M(t)},O.setFileId=function(t){return U(t),this},O.getFileId=function(){return g},O.setDisplayMode=function(t,e,n){if(s=t,h=e,-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(a=n))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+n+'" is not recognized.');return this},O.text=function(t,e,n,i){var r,o,a="",s=et,h=this;function c(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):"[object Array]"===Object.prototype.toString.call(t)&&1===e.length?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function l(t,e){var n;if("string"==typeof t)n=e(t)[0];else if("[object Array]"===Object.prototype.toString.call(t)){for(var r,i,o=t.concat(),a=[],s=o.length;s--;)"string"==typeof(r=o.shift())?a.push(e(r)[0]):"[object Array]"===Object.prototype.toString.call(r)&&"string"===r[0]&&(i=e(r[0],r[1],r[2]),a.push([i[0],i[1],i[2]]));n=a}return n}"number"==typeof t&&(o=n,n=e,e=t,t=o);var u=i,f=arguments[4],d=arguments[5];"object"===(void 0===u?"undefined":vt(u))&&null!==u||("string"==typeof f&&(d=f,f=null),"string"==typeof u&&(d=u,u=null),"number"==typeof u&&(f=u,u=null),i={flags:u,angle:f,align:d});var p=!1,g=!0;if("string"==typeof t)p=!0;else if("[object Array]"===Object.prototype.toString.call(t)){for(var m,w=t.concat(),y=[],v=w.length;v--;)("string"!=typeof(m=w.shift())||"[object Array]"===Object.prototype.toString.call(m)&&"string"!=typeof m[0])&&(g=!1);p=g}if(!1===p)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');var b=nt[K].encoding;"WinAnsiEncoding"!==b&&"StandardEncoding"!==b||(t=l(t,function(t,e,n){return[(r=t,r=r.split("\t").join(Array(i.TabLen||9).join(" ")),ot(r,u)),e,n];var r})),"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]),0<(j=i.maxWidth||0)&&("string"==typeof t?t=h.splitTextToSize(t,j):"[object Array]"===Object.prototype.toString.call(t)&&(t=h.splitTextToSize(t.join(" "),j)));var x={text:t,x:e,y:n,options:i,mutex:{pdfEscape:ot,activeFontKey:K,fonts:nt,activeFontSize:Z}};rt.publish("preProcessText",x),t=x.text;f=(i=x.options).angle;var S=h.internal.scaleFactor,k=(h.internal.pageSize.getHeight(),[]);if(f){f*=Math.PI/180;var _=Math.cos(f),A=Math.sin(f),I=function(t){return t.toFixed(2)};k=[I(_),I(A),I(-1*A),I(_)]}void 0!==(R=i.charSpace)&&(a+=R+" Tc\n");i.lang;var C=-1,T=i.renderingMode||i.stroke,F=h.internal.getCurrentPageInfo().pageContext;switch(T){case 0:case!1:case"fill":C=0;break;case 1:case!0:case"stroke":C=1;break;case 2:case"fillThenStroke":C=2;break;case 3:case"invisible":C=3;break;case 4:case"fillAndAddForClipping":C=4;break;case 5:case"strokeAndAddPathForClipping":C=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":C=6;break;case 7:case"addToPathForClipping":C=7}var P=F.usedRenderingMode||-1;-1!==C?a+=C+" Tr\n":-1!==P&&(a+="0 Tr\n"),-1!==C&&(F.usedRenderingMode=C);d=i.align||"left";var E=Z*s,q=h.internal.pageSize.getHeight(),O=h.internal.pageSize.getWidth(),B=(S=h.internal.scaleFactor,nt[K]),R=i.charSpace||$,j=i.maxWidth||0,D=(u={},[]);if("[object Array]"===Object.prototype.toString.call(t)){var M,U;y=c(t);"left"!==d&&(U=y.map(function(t){return h.getStringUnitWidth(t,{font:B,charSpace:R,fontSize:Z})*Z/S}));var N,z=Math.max.apply(Math,U),L=0;if("right"===d){e-=U[0],t=[];var H=0;for(v=y.length;H<v;H++)z-U[H],0===H?(N=e*S,M=(q-n)*S):(N=(L-U[H])*S,M=-E),t.push([y[H],N,M]),L=U[H]}else if("center"===d){e-=U[0]/2,t=[];for(H=0,v=y.length;H<v;H++)(z-U[H])/2,0===H?(N=e*S,M=(q-n)*S):(N=(L-U[H])/2*S,M=-E),t.push([y[H],N,M]),L=U[H]}else if("left"===d){t=[];for(H=0,v=y.length;H<v;H++)M=0===H?(q-n)*S:-E,N=0===H?e*S:0,t.push(y[H])}else{if("justify"!==d)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[];for(j=0!==j?j:O,H=0,v=y.length;H<v;H++)M=0===H?(q-n)*S:-E,N=0===H?e*S:0,H<v-1&&D.push(((j-U[H])/(y[H].split(" ").length-1)*S).toFixed(2)),t.push([y[H],N,M])}}!0===("boolean"==typeof i.R2L?i.R2L:tt)&&(t=l(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]}));x={text:t,x:e,y:n,options:i,mutex:{pdfEscape:ot,activeFontKey:K,fonts:nt,activeFontSize:Z}};rt.publish("postProcessText",x),t=x.text,r=x.mutex.isHex;y=c(t);t=[];var W,G,V,Y=0,X=(v=y.length,"");for(H=0;H<v;H++)X="","[object Array]"!==Object.prototype.toString.call(y[H])?(W=parseFloat(e*S).toFixed(2),G=parseFloat((q-n)*S).toFixed(2),V=(r?"<":"(")+y[H]+(r?">":")")):"[object Array]"===Object.prototype.toString.call(y[H])&&(W=parseFloat(y[H][1]).toFixed(2),G=parseFloat(y[H][2]).toFixed(2),V=(r?"<":"(")+y[H][0]+(r?">":")"),Y=1),void 0!==D&&void 0!==D[H]&&(X=D[H]+" Tw\n"),0!==k.length&&0===H?t.push(X+k.join(" ")+" "+W+" "+G+" Tm\n"+V):1===Y||0===Y&&0===H?t.push(X+W+" "+G+" Td\n"+V):t.push(X+V);t=0===Y?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var J="BT\n/"+K+" "+Z+" Tf\n"+(Z*s).toFixed(2)+" TL\n"+Q+"\n";return J+=a,J+=t,it(J+="ET"),h},O.lstext=function(t,e,n,r){console.warn("jsPDF.lstext is deprecated");for(var i=0,o=t.length;i<o;i++,e+=r)this.text(t[i],e,n);return this},O.line=function(t,e,n,r){return this.lines([[n-t,r-e]],t,e)},O.clip=function(){it("W"),it("S")},O.clip_fixed=function(t){it("evenodd"===t?"W*":"W"),it("n")},O.lines=function(t,e,n,r,i,o){var a,s,h,c,l,u,f,d,p,g,m;for("number"==typeof t&&(y=n,n=e,e=t,t=y),r=r||[1,1],it(z(e*w)+" "+z((v-n)*w)+" m "),a=r[0],s=r[1],c=t.length,g=e,m=n,h=0;h<c;h++)2===(l=t[h]).length?(g=l[0]*a+g,m=l[1]*s+m,it(z(g*w)+" "+z((v-m)*w)+" l")):(u=l[0]*a+g,f=l[1]*s+m,d=l[2]*a+g,p=l[3]*s+m,g=l[4]*a+g,m=l[5]*s+m,it(z(u*w)+" "+z((v-f)*w)+" "+z(d*w)+" "+z((v-p)*w)+" "+z(g*w)+" "+z((v-m)*w)+" c"));return o&&it(" h"),null!==i&&it(ht(i)),this},O.rect=function(t,e,n,r,i){ht(i);return it([N(t*w),N((v-e)*w),N(n*w),N(-r*w),"re"].join(" ")),null!==i&&it(ht(i)),this},O.triangle=function(t,e,n,r,i,o,a){return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},O.roundedRect=function(t,e,n,r,i,o,a){var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},O.ellipse=function(t,e,n,r,i){var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return it([N((t+n)*w),N((v-e)*w),"m",N((t+n)*w),N((v-(e-a))*w),N((t+o)*w),N((v-(e-r))*w),N(t*w),N((v-(e-r))*w),"c"].join(" ")),it([N((t-o)*w),N((v-(e-r))*w),N((t-n)*w),N((v-(e-a))*w),N((t-n)*w),N((v-e)*w),"c"].join(" ")),it([N((t-n)*w),N((v-(e+a))*w),N((t-o)*w),N((v-(e+r))*w),N(t*w),N((v-(e+r))*w),"c"].join(" ")),it([N((t+o)*w),N((v-(e+r))*w),N((t+n)*w),N((v-(e+a))*w),N((t+n)*w),N((v-e)*w),"c"].join(" ")),null!==i&&it(ht(i)),this},O.circle=function(t,e,n,r){return this.ellipse(t,e,n,n,r)},O.setProperties=function(t){for(var e in q)q.hasOwnProperty(e)&&t[e]&&(q[e]=t[e]);return this},O.setFontSize=function(t){return Z=t,this},O.setFont=function(t,e){return K=at(t,e),this},O.setFontStyle=O.setFontType=function(t){return K=at(void 0,t),this},O.getFontList=function(){var t,e,n,r={};for(t in S)if(S.hasOwnProperty(t))for(e in r[t]=n=[],S[t])S[t].hasOwnProperty(e)&&n.push(e);return r},O.addFont=function(t,e,n,r){Y(t,e,n,r=r||"Identity-H")},O.setLineWidth=function(t){return it((t*w).toFixed(2)+" w"),this},O.setDrawColor=function(t,e,n,r){return it(R({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2})),this},O.setFillColor=function(t,e,n,r){return it(R({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2})),this},O.setTextColor=function(t,e,n,r){return Q=R({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this},O.setCharSpace=function(t){return $=t,this},O.setR2L=function(t){return tt=t,this},O.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},O.setLineCap=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return it((F=e)+" J"),this},O.setLineJoin=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return it((P=e)+" j"),this},O.output=ut,O.save=function(t){O.output("save",t)},yt.API)yt.API.hasOwnProperty(dt)&&("events"===dt&&yt.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(rt,yt.API.events):O[dt]=yt.API[dt]);return function(){for(var t="helvetica",e="times",n="courier",r="normal",i="bold",o="italic",a="bolditalic",s=[["Helvetica",t,r,"WinAnsiEncoding"],["Helvetica-Bold",t,i,"WinAnsiEncoding"],["Helvetica-Oblique",t,o,"WinAnsiEncoding"],["Helvetica-BoldOblique",t,a,"WinAnsiEncoding"],["Courier",n,r,"WinAnsiEncoding"],["Courier-Bold",n,i,"WinAnsiEncoding"],["Courier-Oblique",n,o,"WinAnsiEncoding"],["Courier-BoldOblique",n,a,"WinAnsiEncoding"],["Times-Roman",e,r,"WinAnsiEncoding"],["Times-Bold",e,i,"WinAnsiEncoding"],["Times-Italic",e,o,"WinAnsiEncoding"],["Times-BoldItalic",e,a,"WinAnsiEncoding"],["ZapfDingbats","zapfdingbats",r,null],["Symbol","symbol",r,null]],h=0,c=s.length;h<c;h++){var l=Y(s[h][0],s[h][1],s[h][2],s[h][3]),u=s[h][0].split("-");V(l,u[0],u[1]||"")}rt.publish("addFonts",{fonts:nt,dictionary:S})}(),K="F1",X(n,t),rt.publish("initialized"),O}return yt.API={events:[]},yt.version="0.0.0", true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return yt}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?(module.exports=yt,module.exports.jsPDF=yt):pt.jsPDF=yt,yt}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
/** @preserve
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.4.1 Built on 2018-06-06T07:49:34.040Z
   *                           CommitID 3233f44044
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */
/**
   * jsPDF AcroForm Plugin Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
!function(n,t){var l,a,e=1,r=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},s=function(t){return t*(e/1)},h=function(t){var e=new I,n=N.internal.getHeight(t)||0,r=N.internal.getWidth(t)||0;return e.BBox=[0,0,r.toFixed(2),n.toFixed(2)],e},i=function(t,e,n){t=t||0;var r=1;if(r<<=e-1,1==(n=n||1))t=t|r;else t=t&~r;return t},o=function(t,e,n){n=n||1.3,t=t||0;return 1==e.readOnly&&(t=i(t,1)),1==e.required&&(t=i(t,2)),1==e.noExport&&(t=i(t,3)),1==e.multiline&&(t=i(t,13)),e.password&&(t=i(t,14)),e.noToggleToOff&&(t=i(t,15)),e.radio&&(t=i(t,16)),e.pushbutton&&(t=i(t,17)),e.combo&&(t=i(t,18)),e.edit&&(t=i(t,19)),e.sort&&(t=i(t,20)),e.fileSelect&&1.4<=n&&(t=i(t,21)),e.multiSelect&&1.4<=n&&(t=i(t,22)),e.doNotSpellCheck&&1.4<=n&&(t=i(t,23)),1==e.doNotScroll&&1.4<=n&&(t=i(t,24)),e.richText&&1.4<=n&&(t=i(t,25)),t},u=function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o={};return Array.isArray(e)?(e[0]=s(e[0]),e[1]=s(e[1]),e[2]=s(e[2]),e[3]=s(e[3])):(e=s(e),n=s(n),r=s(r),i=s(i)),o.lowerLeft_X=e||0,o.lowerLeft_Y=s(a)-n-i||0,o.upperRight_X=e+r||0,o.upperRight_Y=s(a)-n||0,[o.lowerLeft_X.toFixed(2),o.lowerLeft_Y.toFixed(2),o.upperRight_X.toFixed(2),o.upperRight_Y.toFixed(2)]},f=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=c(t,n);e.push("/Tx BMC"),e.push("q"),e.push("/F1 "+r.fontSize.toFixed(2)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push("BT"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var i=new h(t);return i.stream=e.join("\n"),i}},c=function(t,e,i,n){n=n||12,i=i||"helvetica";var r={text:"",fontSize:""},o=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" "),a=n,s=N.internal.getHeight(t)||0;s=s<0?-s:s;var h=N.internal.getWidth(t)||0;h=h<0?-h:h;var c=function(t,e,n){if(t+1<o.length){var r=e+" "+o[t+1];return A(r,n+"px",i).width<=h-4}return!1};a++;t:for(;;){e="";var l=A("3",--a+"px",i).height,u=t.multiline?s-a:(s-l)/2,f=-2,d=u+=2,p=0,g=0,m=0;if(a<=0){a=12,e="(...) Tj\n",e+="% Width of Text: "+A(e,"1px").width+", FieldWidth:"+h+"\n";break}m=A(o[0]+" ",a+"px",i).width;var w="",y=0;for(var v in o){w=" "==(w+=o[v]+" ").substr(w.length-1)?w.substr(0,w.length-1):w;var b=parseInt(v);m=A(w+" ",a+"px",i).width;var x=c(b,w,a),S=v>=o.length-1;if(!x||S){if(x||S){if(S)g=b;else if(t.multiline&&s<(l+2)*(y+2)+2)continue t}else{if(!t.multiline)continue t;if(s<(l+2)*(y+2)+2)continue t;g=b}for(var k="",_=p;_<=g;_++)k+=o[_]+" ";switch(k=" "==k.substr(k.length-1)?k.substr(0,k.length-1):k,m=A(k,a+"px",i).width,t.Q){case 2:f=h-m-2;break;case 1:f=(h-m)/2;break;case 0:default:f=2}e+=f.toFixed(2)+" "+d.toFixed(2)+" Td\n",e+="("+k+") Tj\n",e+=-f.toFixed(2)+" 0 Td\n",d=-(a+2),m=0,p=g+1,y++,w=""}else w+=" "}break}return r.text=e,r.fontSize=a,r},A=function(t,e,n){n=n||"helvetica";var r=l.internal.getFont(n),i=l.getStringUnitWidth(t,{font:r,fontSize:parseFloat(e),charSpace:0})*parseFloat(e);return{height:l.getStringUnitWidth("3",{font:r,fontSize:parseFloat(e),charSpace:0})*parseFloat(e)*1.5,width:i}},d={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},p=function(){for(var t in l.internal.acroformPlugin.acroFormDictionaryRoot.Fields){var e=l.internal.acroformPlugin.acroFormDictionaryRoot.Fields[t];e.hasAnnotation&&m.call(l,e)}},g=function(t){l.internal.acroformPlugin.printedOut&&(l.internal.acroformPlugin.printedOut=!1,l.internal.acroformPlugin.acroFormDictionaryRoot=null),l.internal.acroformPlugin.acroFormDictionaryRoot||x.call(l),l.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)},m=function(t){var e={type:"reference",object:t};l.annotationPlugin.annotations[l.internal.getPageInfo(t.page).pageNumber].push(e)},w=function(){void 0!==l.internal.acroformPlugin.acroFormDictionaryRoot?l.internal.write("/AcroForm "+l.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R"):console.log("Root missing...")},y=function(){l.internal.events.unsubscribe(l.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete l.internal.acroformPlugin.acroFormDictionaryRoot._eventID,l.internal.acroformPlugin.printedOut=!0},v=function(t){var e=!t;t||(l.internal.newObjectDeferredBegin(l.internal.acroformPlugin.acroFormDictionaryRoot.objId),l.internal.out(l.internal.acroformPlugin.acroFormDictionaryRoot.getString()));t=t||l.internal.acroformPlugin.acroFormDictionaryRoot.Kids;for(var n in t){var r=t[n],i=r.Rect;r.Rect&&(r.Rect=u.call(this,r.Rect)),l.internal.newObjectDeferredBegin(r.objId);var o=r.objId+" 0 obj\n<<\n";if("object"===(void 0===r?"undefined":vt(r))&&"function"==typeof r.getContent&&(o+=r.getContent()),r.Rect=i,r.hasAppearanceStream&&!r.appearanceStreamContent){var a=f.call(this,r);o+="/AP << /N "+a+" >>\n",l.internal.acroformPlugin.xForms.push(a)}if(r.appearanceStreamContent){for(var s in o+="/AP << ",r.appearanceStreamContent){var h=r.appearanceStreamContent[s];if(o+="/"+s+" ",o+="<< ",1<=Object.keys(h).length||Array.isArray(h))for(var n in h){var c;"function"==typeof(c=h[n])&&(c=c.call(this,r)),o+="/"+n+" "+c+" ",0<=l.internal.acroformPlugin.xForms.indexOf(c)||l.internal.acroformPlugin.xForms.push(c)}else"function"==typeof(c=h)&&(c=c.call(this,r)),o+="/"+n+" "+c+" \n",0<=l.internal.acroformPlugin.xForms.indexOf(c)||l.internal.acroformPlugin.xForms.push(c);o+=" >>\n"}o+=">>\n"}o+=">>\nendobj\n",l.internal.out(o)}e&&b.call(this,l.internal.acroformPlugin.xForms)},b=function(t){for(var e in t){var n=e,r=t[e];l.internal.newObjectDeferredBegin(r&&r.objId);var i="";"object"===(void 0===r?"undefined":vt(r))&&"function"==typeof r.getString&&(i=r.getString()),l.internal.out(i),delete t[n]}},x=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(l=this,T.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(d)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");e=l.internal.scaleFactor,a=l.internal.pageSize.getHeight(),l.internal.acroformPlugin.acroFormDictionaryRoot=new C,l.internal.acroformPlugin.acroFormDictionaryRoot._eventID=l.internal.events.subscribe("postPutResources",y),l.internal.events.subscribe("buildDocument",p),l.internal.events.subscribe("putCatalog",w),l.internal.events.subscribe("postPutPages",v),l.internal.acroformPlugin.isInitialized=!0}},S=function(t){if(Array.isArray(t)){var e=" [";for(var n in t){e+=t[n].toString(),e+=n<t.length-1?" ":""}return e+="]"}},k=function(t){return 0!==(t=t||"").indexOf("(")&&(t="("+t),")"!=t.substring(t.length-1)&&(t+=")"),t},_=function(){var t;Object.defineProperty(this,"objId",{get:function(){return t||(t=l.internal.newObjectDeferred()),t||console.log("Couldn't create Object ID"),t},configurable:!1})};_.prototype.toString=function(){return this.objId+" 0 R"},_.prototype.getString=function(){var t=this.objId+" 0 obj\n<<";return t+=this.getContent()+">>\n",this.stream&&(t+="stream\n",t+=this.stream,t+="\nendstream\n"),t+="endobj\n"},_.prototype.getContent=function(){var t="";return t+=function(t){var e="",n=Object.keys(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n){var i=n[r],o=t[i];o&&(Array.isArray(o)?e+="/"+i+" "+S(o)+"\n":e+=o instanceof _?"/"+i+" "+o.objId+" 0 R\n":"/"+i+" "+o+"\n")}return e}(this)};var I=function(){var e;_.call(this),this.Type="/XObject",this.Subtype="/Form",this.FormType=1,this.BBox,this.Matrix,this.Resources="2 0 R",this.PieceInfo,Object.defineProperty(this,"Length",{enumerable:!0,get:function(){return void 0!==e?e.length:0}}),Object.defineProperty(this,"stream",{enumerable:!1,set:function(t){e=t.trim()},get:function(){return e||null}})};r(I,_);var C=function(){_.call(this);var t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!0,configurable:!0,get:function(){return t}}),this.DA};r(C,_);var T=function t(){var e;_.call(this),Object.defineProperty(this,"Rect",{enumerable:!0,configurable:!1,get:function(){if(e)return e},set:function(t){e=t}});var n,r,i,o,a="";Object.defineProperty(this,"FT",{enumerable:!0,set:function(t){a=t},get:function(){return a}}),Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,set:function(t){n=t},get:function(){if(!n||n.length<1){if(this instanceof j)return;return"(FieldObject"+t.FieldNum+++")"}return"("==n.substring(0,1)&&n.substring(n.length-1)?n:"("+n+")"}}),Object.defineProperty(this,"DA",{enumerable:!0,get:function(){if(r)return"("+r+")"},set:function(t){r=t}}),Object.defineProperty(this,"DV",{enumerable:!0,configurable:!0,get:function(){if(i)return i},set:function(t){i=t}}),Object.defineProperty(this,"V",{enumerable:!0,configurable:!0,get:function(){if(o)return o},set:function(t){o=t}}),Object.defineProperty(this,"Type",{enumerable:!0,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,get:function(){return this.hasAnnotation?"/Widget":null}}),this.BG,Object.defineProperty(this,"hasAnnotation",{enumerable:!1,get:function(){return!!(this.Rect||this.BC||this.BG)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,configurable:!0,writable:!0}),Object.defineProperty(this,"page",{enumerable:!1,configurable:!0,writable:!0})};r(T,_);var F=function(){T.call(this),this.FT="/Ch",this.Opt=[],this.V="()",this.TI=0;var e=!1;Object.defineProperty(this,"combo",{enumerable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"edit",{enumerable:!0,set:function(t){1==t?(this._edit=!0,this.combo=!0):this._edit=!1},get:function(){return!!this._edit&&this._edit},configurable:!1}),this.hasAppearanceStream=!0};r(F,T);var P=function(){F.call(this),this.combo=!1};r(P,F);var E=function(){P.call(this),this.combo=!0};r(E,P);var q=function(){E.call(this),this.edit=!0};r(q,E);var O=function(){T.call(this),this.FT="/Btn"};r(O,T);var B=function(){O.call(this);var e=!0;Object.defineProperty(this,"pushbutton",{enumerable:!1,get:function(){return e},set:function(t){e=t}})};r(B,O);var R=function(){O.call(this);var e=!0;Object.defineProperty(this,"radio",{enumerable:!1,get:function(){return e},set:function(t){e=t}});var n,t=[];Object.defineProperty(this,"Kids",{enumerable:!0,get:function(){if(0<t.length)return t}}),Object.defineProperty(this,"__Kids",{get:function(){return t}}),Object.defineProperty(this,"noToggleToOff",{enumerable:!1,get:function(){return n},set:function(t){n=t}})};r(R,O);var j=function(t,e){T.call(this),this.Parent=t,this._AppearanceType=N.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(e),this.F=i(this.F,3,1),this.MK=this._AppearanceType.createMK(),this.AS="/Off",this._Name=e};r(j,T),R.prototype.setAppearance=function(t){if("createAppearanceStream"in t&&"createMK"in t)for(var e in this.__Kids){var n=this.__Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n._Name),n.MK=t.createMK()}else console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!")},R.prototype.createOption=function(t){this.__Kids.length;var e=new j(this,t);return this.__Kids.push(e),n.addField(e),e};var D=function(){O.call(this),this.appearanceStreamContent=N.CheckBox.createAppearanceStream(),this.MK=N.CheckBox.createMK(),this.AS="/On",this.V="/On"};r(D,O);var M=function(){var e,n;T.call(this),this.DA=N.createDefaultAppearanceStream(),this.F=4,Object.defineProperty(this,"V",{get:function(){return e?k(e):e},enumerable:!0,set:function(t){e=t}}),Object.defineProperty(this,"DV",{get:function(){return n?k(n):n},enumerable:!0,set:function(t){n=t}});var r=!1;Object.defineProperty(this,"multiline",{enumerable:!1,get:function(){return r},set:function(t){r=t}});var i=!1;Object.defineProperty(this,"fileSelect",{enumerable:!1,get:function(){return i},set:function(t){i=t}});var o=!1;Object.defineProperty(this,"doNotSpellCheck",{enumerable:!1,get:function(){return o},set:function(t){o=t}});var a=!1;Object.defineProperty(this,"doNotScroll",{enumerable:!1,get:function(){return a},set:function(t){a=t}});var s=!1;Object.defineProperty(this,"MaxLen",{enumerable:!0,get:function(){return s},set:function(t){s=t}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,get:function(){return this.V||this.DV}})};r(M,T);var U=function(){M.call(this);var e=!0;Object.defineProperty(this,"password",{enumerable:!1,get:function(){return e},set:function(t){e=t}})};r(U,M);var N={CheckBox:{createAppearanceStream:function(){return{N:{On:N.CheckBox.YesNormal},D:{On:N.CheckBox.YesPushDown,Off:N.CheckBox.OffPushDown}}},createMK:function(){return"<< /CA (3)>>"},YesPushDown:function(t){var e=h(t),n=[],r=l.internal.getFont("zapfdingbats","normal").id;t.Q=1;var i=c(t,"3","ZapfDingbats",50);return n.push("0.749023 g"),n.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+i.fontSize.toFixed(2)+" Tf 0 g"),n.push("BT"),n.push(i.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=h(t),n=l.internal.getFont("zapfdingbats","normal").id,r=[];t.Q=1;var i=N.internal.getHeight(t),o=N.internal.getWidth(t),a=c(t,"3","ZapfDingbats",.9*i);return r.push("1 g"),r.push("0 0 "+o.toFixed(2)+" "+i.toFixed(2)+" re"),r.push("f"),r.push("q"),r.push("0 0 1 rg"),r.push("0 0 "+(o-1).toFixed(2)+" "+(i-1).toFixed(2)+" re"),r.push("W"),r.push("n"),r.push("0 g"),r.push("BT"),r.push("/"+n+" "+a.fontSize.toFixed(2)+" Tf 0 g"),r.push(a.text),r.push("ET"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=h(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:N.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=N.RadioButton.Circle.YesNormal,e.D[t]=N.RadioButton.Circle.YesPushDown,e},createMK:function(){return"<< /CA (l)>>"},YesNormal:function(t){var e=h(t),n=[],r=N.internal.getWidth(t)<=N.internal.getHeight(t)?N.internal.getWidth(t)/4:N.internal.getHeight(t)/4;r*=.9;var i=N.internal.Bezier_C;return n.push("q"),n.push("1 0 0 1 "+N.internal.getWidth(t)/2+" "+N.internal.getHeight(t)/2+" cm"),n.push(r+" 0 m"),n.push(r+" "+r*i+" "+r*i+" "+r+" 0 "+r+" c"),n.push("-"+r*i+" "+r+" -"+r+" "+r*i+" -"+r+" 0 c"),n.push("-"+r+" -"+r*i+" -"+r*i+" -"+r+" 0 -"+r+" c"),n.push(r*i+" -"+r+" "+r+" -"+r*i+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=h(t),n=[],r=N.internal.getWidth(t)<=N.internal.getHeight(t)?N.internal.getWidth(t)/4:N.internal.getHeight(t)/4,i=2*(r*=.9),o=i*N.internal.Bezier_C,a=r*N.internal.Bezier_C;return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+(N.internal.getWidth(t)/2).toFixed(2)+" "+(N.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+(N.internal.getWidth(t)/2).toFixed(2)+" "+(N.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=h(t),n=[],r=N.internal.getWidth(t)<=N.internal.getHeight(t)?N.internal.getWidth(t)/4:N.internal.getHeight(t)/4,i=2*(r*=.9),o=i*N.internal.Bezier_C;return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+(N.internal.getWidth(t)/2).toFixed(2)+" "+(N.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:N.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=N.RadioButton.Cross.YesNormal,e.D[t]=N.RadioButton.Cross.YesPushDown,e},createMK:function(){return"<< /CA (8)>>"},YesNormal:function(t){var e=h(t),n=[],r=N.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+(N.internal.getWidth(t)-2).toFixed(2)+" "+(N.internal.getHeight(t)-2).toFixed(2)+" re"),n.push("W"),n.push("n"),n.push(r.x1.x.toFixed(2)+" "+r.x1.y.toFixed(2)+" m"),n.push(r.x2.x.toFixed(2)+" "+r.x2.y.toFixed(2)+" l"),n.push(r.x4.x.toFixed(2)+" "+r.x4.y.toFixed(2)+" m"),n.push(r.x3.x.toFixed(2)+" "+r.x3.y.toFixed(2)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=h(t),n=N.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),r.push("f"),r.push("q"),r.push("1 1 "+(N.internal.getWidth(t)-2).toFixed(2)+" "+(N.internal.getHeight(t)-2).toFixed(2)+" re"),r.push("W"),r.push("n"),r.push(n.x1.x.toFixed(2)+" "+n.x1.y.toFixed(2)+" m"),r.push(n.x2.x.toFixed(2)+" "+n.x2.y.toFixed(2)+" l"),r.push(n.x4.x.toFixed(2)+" "+n.x4.y.toFixed(2)+" m"),r.push(n.x3.x.toFixed(2)+" "+n.x3.y.toFixed(2)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=h(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){return"/F1 0 Tf 0 g"}};N.internal={Bezier_C:.551915024494,calculateCross:function(t){var e,n,r=N.internal.getWidth(t),i=N.internal.getHeight(t),o=(n=i)<(e=r)?n:e;return{x1:{x:(r-o)/2,y:(i-o)/2+o},x2:{x:(r-o)/2+o,y:(i-o)/2},x3:{x:(r-o)/2,y:(i-o)/2},x4:{x:(r-o)/2+o,y:(i-o)/2+o}}}},N.internal.getWidth=function(t){var e=0;return"object"===(void 0===t?"undefined":vt(t))&&(e=s(t.Rect[2])),e},N.internal.getHeight=function(t){var e=0;return"object"===(void 0===t?"undefined":vt(t))&&(e=s(t.Rect[3])),e},n.addField=function(t){return x.call(this),t instanceof M?this.addTextField.call(this,t):t instanceof F?this.addChoiceField.call(this,t):t instanceof O?this.addButton.call(this,t):t instanceof j?g.call(this,t):t&&g.call(this,t),t.page=l.internal.getCurrentPageInfo().pageNumber,this},n.addButton=function(t){x.call(this);var e=t||new T;e.FT="/Btn",e.Ff=o(e.Ff,t,l.internal.getPDFVersion()),g.call(this,e)},n.addTextField=function(t){x.call(this);var e=t||new T;e.FT="/Tx",e.Ff=o(e.Ff,t,l.internal.getPDFVersion()),g.call(this,e)},n.addChoiceField=function(t){x.call(this);var e=t||new T;e.FT="/Ch",e.Ff=o(e.Ff,t,l.internal.getPDFVersion()),g.call(this,e)},"object"==(void 0===t?"undefined":vt(t))&&(t.ChoiceField=F,t.ListBox=P,t.ComboBox=E,t.EditBox=q,t.Button=O,t.PushButton=B,t.RadioButton=R,t.CheckBox=D,t.TextField=M,t.PasswordField=U,t.AcroForm={Appearance:N}),n.AcroFormChoiceField=F,n.AcroFormListBox=P,n.AcroFormComboBox=E,n.AcroFormEditBox=q,n.AcroFormButton=O,n.AcroFormPushButton=B,n.AcroFormRadioButton=R,n.AcroFormCheckBox=D,n.AcroFormTextField=M,n.AcroFormPasswordField=U,n.AcroForm={ChoiceField:F,ListBox:P,ComboBox:E,EditBox:q,Button:O,PushButton:B,RadioButton:R,CheckBox:D,TextField:M,PasswordField:U}}($.API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),$.API.addHTML=function(t,p,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof p&&(s=p,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,w=e.scaleFactor,y=e.pageSize.getWidth(),v=e.pageSize.getHeight();if((s=s||{}).onrendered=function(h){p=parseInt(p)||0,g=parseInt(g)||0;var t=s.dim||{},c=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(v,h.height/w),l=t.w||Math.min(y,h.width/w)-p,u=s.format||"JPEG",f=s.imageCompression||"SLOW";if(h.height>v-c.top-c.bottom&&s.pagesplit){var d=function(t,e,n,r,i){var o=document.createElement("canvas");o.height=i,o.width=r;var a=o.getContext("2d");return a.mozImageSmoothingEnabled=!1,a.webkitImageSmoothingEnabled=!1,a.msImageSmoothingEnabled=!1,a.imageSmoothingEnabled=!1,a.fillStyle=s.backgroundColor||"#ffffff",a.fillRect(0,0,r,i),a.drawImage(t,e,n,r,i,0,0,r,i),o},n=function(){for(var t,e,n=0,r=0,i={},o=!1;;){var a;if(r=0,i.top=0!==n?c.top:g,i.left=0!==n?c.left:p,o=(y-c.left-c.right)*w<h.width,"content"===c.useFor?0===n?(t=Math.min((y-c.left)*w,h.width),e=Math.min((v-c.top)*w,h.height-n)):(t=Math.min(y*w,h.width),e=Math.min(v*w,h.height-n),i.top=0):(t=Math.min((y-c.left-c.right)*w,h.width),e=Math.min((v-c.bottom-c.top)*w,h.height-n)),o)for(;;){"content"===c.useFor&&(0===r?t=Math.min((y-c.left)*w,h.width):(t=Math.min(y*w,h.width-r),i.left=0));var s=[a=d(h,r,n,t,e),i.left,i.top,a.width/w,a.height/w,u,null,f];if(this.addImage.apply(this,s),(r+=t)>=h.width)break;this.addPage()}else s=[a=d(h,0,n,t,e),i.left,i.top,a.width/w,a.height/w,u,null,f],this.addImage.apply(this,s);if((n+=e)>=h.height)break;this.addPage()}m(l,n,null,s)}.bind(this);if("CANVAS"===h.nodeName){var r=new Image;r.onload=n,r.src=h.toDataURL("image/png"),h=r}else n()}else{var i=Math.random().toString(35),o=[h,p,g,l,e,u,i,f];this.addImage.apply(this,o),m(l,e,i,o)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"!=typeof rasterizeHTML){var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||y*w,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})}return null},
/** @preserve
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */
function(b){var x="addImage_",h={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]};b.getImageFileTypeByImageData=function(t,e){var n,r;e=e||"UNKNOWN";var i,o,a,s="UNKNOWN";for(a in h)for(i=h[a],n=0;n<i.length;n+=1){for(o=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t.charCodeAt(r)){o=!1;break}if(!0===o){s=a;break}}return"UNKOWN"===s&&"UNKNOWN"!==e&&(console.warn('FileType of Image not recognized. Processing image as "'+e+'".'),s=e),s};var n=function t(e){var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream;if(e.n=n,r("<</Type /XObject"),r("/Subtype /Image"),r("/Width "+e.w),r("/Height "+e.h),e.cs===this.color_spaces.INDEXED?r("/ColorSpace [/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"):(r("/ColorSpace /"+e.cs),e.cs===this.color_spaces.DEVICE_CMYK&&r("/Decode [1 0 1 0 1 0 1 0]")),r("/BitsPerComponent "+e.bpc),"f"in e&&r("/Filter /"+e.f),"dp"in e&&r("/DecodeParms <<"+e.dp+">>"),"trns"in e&&e.trns.constructor==Array){for(var o="",a=0,s=e.trns.length;a<s;a++)o+=e.trns[a]+" "+e.trns[a]+" ";r("/Mask ["+o+"]")}if("smask"in e&&r("/SMask "+(n+1)+" 0 R"),r("/Length "+e.data.length+">>"),i(e.data),r("endobj"),"smask"in e){var h="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,c={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:h,data:e.smask};"f"in e&&(c.f=e.f),t.call(this,c)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),r("<< /Length "+e.pal.length+">>"),i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))),r("endobj"))},S=function(){var t=this.internal.collections[x+"images"];for(var e in t)n.call(this,t[e])},k=function(){var t,e=this.internal.collections[x+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},_=function(t){return"function"==typeof b["process"+t.toUpperCase()]},A=function(t){return"object"===(void 0===t?"undefined":vt(t))&&1===t.nodeType},I=function(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return n;!e&&/\.png(?:[?#].*)?$/i.test(n)&&(e="png")}if("CANVAS"===t.nodeName)var r=t;else{(r=document.createElement("canvas")).width=t.clientWidth||t.width,r.height=t.clientHeight||t.height;var i=r.getContext("2d");if(!i)throw"addImage requires canvas to be supported by browser.";i.drawImage(t,0,0,r.width,r.height)}return r.toDataURL("png"==(""+e).toLowerCase()?"image/png":"image/jpeg")},C=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n};b.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},b.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},b.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},b.sHashCode=function(t){return t=t||"",Array.prototype.reduce&&t.split("").reduce(function(t,e){return(t=(t<<5)-t+e.charCodeAt(0))&t},0)},b.isString=function(t){return"string"==typeof t},b.validateStringAsBase64=function(t){var e=!0;return(t=t||"").length%4!=0&&(e=!1),!1===/[A-Za-z0-9\/]+/.test(t.substr(0,t.length-2))&&(e=!1),!1===/[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==/.test(t.substr(-2))&&(e=!1),e},b.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));base64,(.+)$/g.exec(t)},b.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},b.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},b.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},b.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},b.arrayBufferToBinaryString=function(t){if("function"==typeof atob)return atob(this.arrayBufferToBase64(t));if("function"==typeof TextDecoder){var e=new TextDecoder("ascii");if("ascii"===e.encoding)return e.decode(t)}for(var n=this.isArrayBuffer(t)?t:new Uint8Array(t),r=20480,i="",o=Math.ceil(n.byteLength/r),a=0;a<o;a++)i+=String.fromCharCode.apply(null,n.slice(a*r,a*r+r));return i},b.arrayBufferToBase64=function(t){for(var e,n="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=new Uint8Array(t),o=i.byteLength,a=o%3,s=o-a,h=0;h<s;h+=3)n+=r[(16515072&(e=i[h]<<16|i[h+1]<<8|i[h+2]))>>18]+r[(258048&e)>>12]+r[(4032&e)>>6]+r[63&e];return 1==a?n+=r[(252&(e=i[s]))>>2]+r[(3&e)<<4]+"==":2==a&&(n+=r[(64512&(e=i[s]<<8|i[s+1]))>>10]+r[(1008&e)>>4]+r[(15&e)<<2]+"="),n},b.createImageInfo=function(t,e,n,r,i,o,a,s,h,c,l,u,f){var d={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(d.f=o),h&&(d.dp=h),c&&(d.trns=c),l&&(d.pal=l),u&&(d.smask=u),f&&(d.p=f),d},b.addImage=function(t,e,n,r,i,o,a,s,h){var c="";if("string"!=typeof e){var l=o;o=i,i=r,r=n,n=e,e=l}if("object"===(void 0===t?"undefined":vt(t))&&!A(t)&&"imageData"in t){var u=t;t=u.imageData,e=u.format||e,n=u.x||n||0,r=u.y||r||0,i=u.w||i,o=u.h||o,a=u.alias||a,s=u.compression||s,h=u.rotation||u.angle||h}if(isNaN(n)||isNaN(r))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var f,d,p,g,m,w,y,v=function(){var t=this.internal.collections[x+"images"];return t||(this.internal.collections[x+"images"]=t={},this.internal.events.subscribe("putResources",S),this.internal.events.subscribe("putXobjectDict",k)),t}.call(this);if(!(f=C(t,v))&&(A(t)&&(t=I(t,e)),(null==(y=a)||0===y.length)&&(a="string"==typeof(w=t)&&b.sHashCode(w)),!(f=C(a,v)))){if(this.isString(t)&&(""!==(c=this.convertStringToImageData(t))?t=c:void 0!==(c=this.loadImageFile(t))&&(t=c)),e=this.getImageFileTypeByImageData(t,e),!_(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(d=t,t=this.binaryStringToUint8Array(t))),!(f=this["process"+e.toUpperCase()](t,(m=0,(g=v)&&(m=Object.keys?Object.keys(g).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(g)),m),a,((p=s)&&"string"==typeof p&&(p=p.toUpperCase()),p in b.image_compression?p:b.image_compression.NONE),d)))throw new Error("An unkwown error occurred whilst processing the image")}return function(t,e,n,r,i,o,a,s){var h=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]}.call(this,n,r,i),c=this.internal.getCoordinateString,l=this.internal.getVerticalCoordinateString;if(n=h[0],r=h[1],a[o]=i,s){s*=Math.PI/180;var u=Math.cos(s),f=Math.sin(s),d=function(t){return t.toFixed(4)},p=[d(u),d(f),d(-1*f),d(u),0,0,"cm"]}this.internal.write("q"),s?(this.internal.write([1,"0","0",1,c(t),l(e+r),"cm"].join(" ")),this.internal.write(p.join(" ")),this.internal.write([c(n),"0","0",c(r),"0","0","cm"].join(" "))):this.internal.write([c(n),"0","0",c(r),c(t),l(e+r),"cm"].join(" ")),this.internal.write("/I"+i.i+" Do"),this.internal.write("Q")}.call(this,n,r,i,o,f,f.i,v,h),this},b.convertStringToImageData=function(t){var e,n="";this.isString(t)&&(null!==(e=this.extractInfoFromBase64DataURI(t))?b.validateStringAsBase64(e[3])&&(n=atob(e[3])):b.validateStringAsBase64(t)&&(n=atob(t)));return n};var c=function(t,e){return t.subarray(e,e+5)};b.processJPEG=function(t,e,n,r,i,o){var a,s=this.decode.DCT_DECODE;if(!this.isString(t)&&!this.isArrayBuffer(t)&&!this.isArrayBufferView(t))return null;if(this.isString(t)&&(a=function(t){var e;if(255===!t.charCodeAt(0)||216===!t.charCodeAt(1)||255===!t.charCodeAt(2)||224===!t.charCodeAt(3)||!t.charCodeAt(6)==="J".charCodeAt(0)||!t.charCodeAt(7)==="F".charCodeAt(0)||!t.charCodeAt(8)==="I".charCodeAt(0)||!t.charCodeAt(9)==="F".charCodeAt(0)||0===!t.charCodeAt(10))throw new Error("getJpegSize requires a binary string jpeg file");for(var n=256*t.charCodeAt(4)+t.charCodeAt(5),r=4,i=t.length;r<i;){if(r+=n,255!==t.charCodeAt(r))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(r+1)||193===t.charCodeAt(r+1)||194===t.charCodeAt(r+1)||195===t.charCodeAt(r+1)||196===t.charCodeAt(r+1)||197===t.charCodeAt(r+1)||198===t.charCodeAt(r+1)||199===t.charCodeAt(r+1))return e=256*t.charCodeAt(r+5)+t.charCodeAt(r+6),[256*t.charCodeAt(r+7)+t.charCodeAt(r+8),e,t.charCodeAt(r+9)];r+=2,n=256*t.charCodeAt(r)+t.charCodeAt(r+1)}}(t)),this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)&&(a=function(t){if(65496!=(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n=t.length,r=(t[4]<<8)+t[5],i=4;i<n;){if(r=((e=c(t,i+=r))[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&7<r)return{width:((e=c(t,i+5))[2]<<8)+e[3],height:(e[0]<<8)+e[1],numcomponents:e[4]};i+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")}(t),t=i||this.arrayBufferToBinaryString(t)),void 0===o)switch(a.numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;default:case 3:o=this.color_spaces.DEVICE_RGB}return this.createImageInfo(t,a.width,a.height,o,8,s,e,n)},b.processJPG=function(){return this.processJPEG.apply(this,arguments)},b.loadImageFile=function(t,e,n){e=e||!0,n=n||function(){};Object.prototype.toString.call("undefined"!=typeof process?process:0);if(void 0!==("undefined"==typeof window?"undefined":vt(window))&&"object"===("undefined"==typeof location?"undefined":vt(location))&&"http"===location.protocol.substr(0,4))return function(t,e,n){var r=new XMLHttpRequest,i=[],o=0,a=function(t){var e=t.length,n=String.fromCharCode;for(o=0;o<e;o+=1)i.push(n(255&t.charCodeAt(o)));return i.join("")};if(r.open("GET",t,!e),r.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(r.onload=function(){return a(this.responseText)}),r.send(null),200===r.status)return e?a(r.responseText):void 0;console.warn('Unable to load file "'+t+'"')}(t,e)},b.getImageProperties=function(t){var e,n,r="";if(A(t)&&(t=I(t)),this.isString(t)&&(""!==(r=this.convertStringToImageData(t))?t=r:void 0!==(r=this.loadImageFile(t))&&(t=r)),n=this.getImageFileTypeByImageData(t),!_(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(t=this.binaryStringToUint8Array(t))),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unkwown error occurred whilst processing the image");return{fileType:n,width:e.w,height:e.h,colorSpace:e.cs,compressionMode:e.f,bitsPerComponent:e.bpc}}}($.API),
/**
   * jsPDF Annotations PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
t=$.API,y={annotations:[],f2:function(t){return t.toFixed(2)},notEmpty:function(t){if(void 0!==t&&""!=t)return!0}},$.API.annotationPlugin=y,$.API.events.push(["addPage",function(t){this.annotationPlugin.annotations[t.pageNumber]=[]}]),t.events.push(["putPage",function(t){for(var e=this.annotationPlugin.annotations[t.pageNumber],n=!1,r=0;r<e.length&&!n;r++)switch((h=e[r]).type){case"link":if(y.notEmpty(h.options.url)||y.notEmpty(h.options.pageNumber)){n=!0;break}case"reference":case"text":case"freetext":n=!0}if(0!=n){this.internal.write("/Annots [");var i=this.annotationPlugin.f2,o=this.internal.scaleFactor,a=this.internal.pageSize.getHeight(),s=this.internal.getPageInfo(t.pageNumber);for(r=0;r<e.length;r++){var h;switch((h=e[r]).type){case"reference":this.internal.write(" "+h.object.objId+" 0 R ");break;case"text":var c=this.internal.newAdditionalObject(),l=this.internal.newAdditionalObject(),u=h.title||"Note";m="<</Type /Annot /Subtype /Text "+(d="/Rect ["+i(h.bounds.x*o)+" "+i(a-(h.bounds.y+h.bounds.h)*o)+" "+i((h.bounds.x+h.bounds.w)*o)+" "+i((a-h.bounds.y)*o)+"] ")+"/Contents ("+h.contents+")",m+=" /Popup "+l.objId+" 0 R",m+=" /P "+s.objId+" 0 R",m+=" /T ("+u+") >>",c.content=m;var f=c.objId+" 0 R";m="<</Type /Annot /Subtype /Popup "+(d="/Rect ["+i((h.bounds.x+30)*o)+" "+i(a-(h.bounds.y+h.bounds.h)*o)+" "+i((h.bounds.x+h.bounds.w+30)*o)+" "+i((a-h.bounds.y)*o)+"] ")+" /Parent "+f,h.open&&(m+=" /Open true"),m+=" >>",l.content=m,this.internal.write(c.objId,"0 R",l.objId,"0 R");break;case"freetext":var d="/Rect ["+i(h.bounds.x*o)+" "+i((a-h.bounds.y)*o)+" "+i(h.bounds.x+h.bounds.w*o)+" "+i(a-(h.bounds.y+h.bounds.h)*o)+"] ",p=h.color||"#000000";m="<</Type /Annot /Subtype /FreeText "+d+"/Contents ("+h.contents+")",m+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+p+")",m+=" /Border [0 0 0]",m+=" >>",this.internal.write(m);break;case"link":if(h.options.name){var g=this.annotations._nameMap[h.options.name];h.options.pageNumber=g.page,h.options.top=g.y}else h.options.top||(h.options.top=0);d="/Rect ["+i(h.x*o)+" "+i((a-h.y)*o)+" "+i((h.x+h.w)*o)+" "+i((a-(h.y+h.h))*o)+"] ";var m="";if(h.options.url)m="<</Type /Annot /Subtype /Link "+d+"/Border [0 0 0] /A <</S /URI /URI ("+h.options.url+") >>";else if(h.options.pageNumber)switch(m="<</Type /Annot /Subtype /Link "+d+"/Border [0 0 0] /Dest ["+(t=this.internal.getPageInfo(h.options.pageNumber)).objId+" 0 R",h.options.magFactor=h.options.magFactor||"XYZ",h.options.magFactor){case"Fit":m+=" /Fit]";break;case"FitH":m+=" /FitH "+h.options.top+"]";break;case"FitV":h.options.left=h.options.left||0,m+=" /FitV "+h.options.left+"]";break;case"XYZ":default:var w=i((a-h.options.top)*o);h.options.left=h.options.left||0,void 0===h.options.zoom&&(h.options.zoom=0),m+=" /XYZ "+h.options.left+" "+w+" "+h.options.zoom+"]"}""!=m&&(m+=" >>",this.internal.write(m))}}this.internal.write("]")}}]),t.createAnnotation=function(t){switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t)}},t.link=function(t,e,n,r,i){this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},t.getLineHeight=function(){return this.internal.getLineHeight()},function(t){var a=Object.keys({ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",fa:"Persian","fa-IR":"Persian/Iran",ur:"Urdu"}),u={1569:[65152],1570:[65153,65154,65153,65154],1571:[65155,65156,65155,65156],1572:[65157,65158],1573:[65159,65160,65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166,65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194,65193],1584:[65195,65196,65195],1585:[65197,65198,65197],1586:[65199,65200,65199],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262,65261],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395,64394],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},f={1570:[65269,65270,65269,65270],1571:[65271,65272,65271,65272],1573:[65273,65274,65273,65274],1575:[65275,65276,65275,65276]},d={1570:[65153,65154,65153,65154],1571:[65155,65156,65155,65156],1573:[65159,65160,65159,65160],1575:[65165,65166,65165,65166]},p={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},e=[1570,1571,1573,1575],n=[1569,1570,1571,1572,1573,1575,1577,1583,1584,1585,1586,1608,1688],o=0,s=1,h=2,c=3;function g(t){return void 0!==t&&void 0!==u[t.charCodeAt(0)]}function l(t){return void 0!==t&&0<=n.indexOf(t.charCodeAt(0))}function m(t){return void 0!==t&&0<=e.indexOf(t.charCodeAt(0))}function w(t){return g(t)&&2<=u[t.charCodeAt(0)].length}function y(t,e,n,r){return g(t)?(r=r||{},u=Object.assign(u,r),!w(t)||!g(e)&&!g(n)||!g(n)&&l(e)||l(t)&&!g(e)||l(t)&&m(e)||l(t)&&l(e)?(u=Object.assign(u,d),o):g(i=t)&&4==u[i.charCodeAt(0)].length&&g(e)&&!l(e)&&g(n)&&w(n)?(u=Object.assign(u,d),c):l(t)||!g(n)?(u=Object.assign(u,d),s):(u=Object.assign(u,d),h)):-1;var i}var v=t.processArabic=function(t,e){t=t||"",e=e||!1;var n,r,i,o="",a=0,s=0,h="",c="",l="";for(a=0;a<t.length;a+=1)h=t[a],c=t[a-1],l=t[a+1],g(h)?void 0!==c&&1604===c.charCodeAt(0)&&m(h)?(s=y(h,t[a-2],t[a+1],f),n=String.fromCharCode(f[h.charCodeAt(0)][s]),o=o.substr(0,o.length-1)+n):void 0!==c&&1617===c.charCodeAt(0)&&(void 0!==(r=h)&&void 0!==p[r.charCodeAt(0)])?(s=y(h,t[a-2],t[a+1],d),n=String.fromCharCode(p[h.charCodeAt(0)][s]),o=o.substr(0,o.length-1)+n):(s=y(h,c,l,d),o+=String.fromCharCode(u[h.charCodeAt(0)][s])):o+=e?{"(":")",")":"("}[i=h]||i:h;return e?o.split("").reverse().join(""):o};t.events.push(["preProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang),i=[];if(0<=a.indexOf(r)){if("[object Array]"===Object.prototype.toString.call(e)){var o=0;for(i=[],o=0;o<e.length;o+=1)"[object Array]"===Object.prototype.toString.call(e[o])?i.push([v(e[o][0],!0),e[o][1],e[o][2]]):i.push([v(e[o],!0)]);t.text=i}else t.text=v(e,!0);void 0===n.charSpace&&(t.options.charSpace=0),!0===n.R2L&&(t.options.R2L=!1)}}])}($.API),$.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},(
/**
   * jsPDF Canvas PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
e=$.API).events.push(["initialized",function(){this.canvas.pdf=this}]),e.canvas={getContext:function(t){return(this.pdf.context2d._canvas=this).pdf.context2d},childNodes:[]},Object.defineProperty(e.canvas,"width",{get:function(){return this._width},set:function(t){this._width=t,this.getContext("2d").pageWrapX=t+1}}),Object.defineProperty(e.canvas,"height",{get:function(){return this._height},set:function(t){this._height=t,this.getContext("2d").pageWrapY=t+1}}),
/** ====================================================================
   * jsPDF Cell plugin
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
I=$.API,C={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1,d=function(t,e,n,r,i){C={x:t,y:e,w:n,h:r,ln:i}},p=function(){return C},F={left:0,top:0,bottom:0},I.setHeaderFunction=function(t){h=t},I.getTextDimensions=function(e){i=this.internal.getFont().fontName,o=this.table_font_size||this.internal.getFontSize(),a=this.internal.getFont().fontStyle;var t,n,r=19.049976/25.4;(n=document.createElement("font")).id="jsPDFCell";try{n.style.fontStyle=a}catch(t){n.style.fontWeight=a}n.style.fontSize=o+"pt",n.style.fontFamily=i;try{n.textContent=e}catch(t){n.innerText=e}return document.body.appendChild(n),t={w:(n.offsetWidth+1)*r,h:(n.offsetHeight+1)*r},document.body.removeChild(n),t},I.cellAddPage=function(){var t=this.margins||F;this.addPage(),d(t.left,t.top,void 0,void 0),T+=1},I.cellInitialize=function(){C={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1},I.cell=function(t,e,n,r,i,o,a){var s=p(),h=!1;if(void 0!==s.ln)if(s.ln===o)t=s.x+s.w,e=s.y;else{var c=this.margins||F;s.y+s.h+r+13>=this.internal.pageSize.getHeight()-c.bottom&&(this.cellAddPage(),h=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=p().y+p().h,h&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var l=0;l<i.length;l++){var u=i[l],f=this.getStringUnitWidth(u)*this.internal.getFontSize();this.text(u,t+n-f-3,e+this.internal.getLineHeight()*(l+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return d(t,e,n,r,o),this},I.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):o<i&&(o=i);return o},I.table=function(t,e,n,r,i){if(!n)throw"No data for PDF table";var o,a,s,h,c,l,u,f,d,p,g=[],m=[],w={},y={},v=[],b=[],x=!1,S=!0,k=12,_=F;if(_.width=this.internal.pageSize.getWidth(),i&&(!0===i.autoSize&&(x=!0),!1===i.printHeaders&&(S=!1),i.fontSize&&(k=i.fontSize),i.css&&void 0!==i.css["font-size"]&&(k=16*i.css["font-size"]),i.margins&&(_=i.margins)),this.lnMod=0,C={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1,this.printHeaders=S,this.margins=_,this.setFontSize(k),this.table_font_size=k,null==r)g=Object.keys(n[0]);else if(r[0]&&"string"!=typeof r[0])for(a=0,s=r.length;a<s;a+=1)o=r[a],g.push(o.name),m.push(o.prompt),y[o.name]=o.width*(19.049976/25.4);else g=r;if(x)for(p=function(t){return t[o]},a=0,s=g.length;a<s;a+=1){for(w[o=g[a]]=n.map(p),v.push(this.getTextDimensions(m[a]||o).w),u=0,h=(l=w[o]).length;u<h;u+=1)c=l[u],v.push(this.getTextDimensions(c).w);y[o]=I.arrayMax(v),v=[]}if(S){var A=this.calculateLineHeight(g,y,m.length?m:g);for(a=0,s=g.length;a<s;a+=1)o=g[a],b.push([t,e,y[o],A,String(m.length?m[a]:o)]);this.setTableHeaderRow(b),this.printHeaderRow(1,!1)}for(a=0,s=n.length;a<s;a+=1)for(f=n[a],A=this.calculateLineHeight(g,y,f),u=0,d=g.length;u<d;u+=1)o=g[u],this.cell(t,e,y[o],A,f[o],a+2,o.align);return this.lastCellPos=C,this.table_x=t,this.table_y=e,this},I.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;i<a&&(i=a)}return i},I.setTableHeaderRow=function(t){this.tableHeaderRow=t},I.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,i,o;if(this.printingHeaderRow=!0,void 0!==h){var a=h(this,T);d(a[0],a[1],a[2],a[3],-1)}this.setFontStyle("bold");var s=[];for(i=0,o=this.tableHeaderRow.length;i<o;i+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[i],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,s.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));0<s.length&&this.setTableHeaderRow(s),this.setFontStyle("normal"),this.printingHeaderRow=!1},
/**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
function(t){t.events.push(["initialized",function(){((this.context2d.pdf=this).context2d.internal.pdf=this).context2d.ctx=new e,this.context2d.ctxStack=[],this.context2d.path=[]}]),t.context2d={pageWrapXEnabled:!1,pageWrapYEnabled:!1,pageWrapX:9999999,pageWrapY:9999999,ctx:new e,f2:function(t){return t.toFixed(2)},fillRect:function(t,e,n,r){if(!this._isFillTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"f")}},strokeRect:function(t,e,n,r){if(!this._isStrokeTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"s")}},clearRect:function(t,e,n,r){if(!this.ctx.ignoreClearRect){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.save(),this.setFillStyle("#ffffff"),this.pdf.rect(i.x,i.y,i.w,i.h,"f"),this.restore()}},save:function(){this.ctx._fontSize=this.pdf.internal.getFontSize();var t=new e;t.copy(this.ctx),this.ctxStack.push(this.ctx),this.ctx=t},restore:function(){this.ctx=this.ctxStack.pop(),this.setFillStyle(this.ctx.fillStyle),this.setStrokeStyle(this.ctx.strokeStyle),this.setFont(this.ctx.font),this.pdf.setFontSize(this.ctx._fontSize),this.setLineCap(this.ctx.lineCap),this.setLineWidth(this.ctx.lineWidth),this.setLineJoin(this.ctx.lineJoin)},rect:function(t,e,n,r){this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.closePath()},beginPath:function(){this.path=[]},closePath:function(){this.path.push({type:"close"})},_getRGBA:function(t){var e,n,r,i,o=new RGBColor(t);if(!t)return{r:0,g:0,b:0,a:0,style:t};if(this.internal.rxTransparent.test(t))i=r=n=e=0;else{var a=this.internal.rxRgb.exec(t);null!=a?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),i=1):null!=(a=this.internal.rxRgba.exec(t))?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),i=parseFloat(a[4])):(i=1,"#"!=t.charAt(0)&&(t=o.ok?o.toHex():"#000000"),4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16))}return{r:e,g:n,b:r,a:i,style:t}},setFillStyle:function(t){var e=this._getRGBA(t);this.ctx.fillStyle=t,this.ctx._isFillTransparent=0===e.a,this.ctx._fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})},setStrokeStyle:function(t){var e=this._getRGBA(t);this.ctx.strokeStyle=e.style,this.ctx._isStrokeTransparent=0===e.a,this.ctx._strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))},fillText:function(t,e,n,r){if(!this._isFillTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(0<this.ctx._clip_path.length){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var h=1;try{h=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(h<.01)this.pdf.text(t,e,this._getBaseline(n),null,o);else{var c=this.pdf.internal.getFontSize();this.pdf.setFontSize(c*h),this.pdf.text(t,e,this._getBaseline(n),null,o),this.pdf.setFontSize(c)}0<this.ctx._clip_path.length&&a.push("Q")}},strokeText:function(t,e,n,r){if(!this._isStrokeTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(0<this.ctx._clip_path.length){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var h=1;try{h=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(1===h)this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o);else{var c=this.pdf.internal.getFontSize();this.pdf.setFontSize(c*h),this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o),this.pdf.setFontSize(c)}0<this.ctx._clip_path.length&&a.push("Q")}},setFont:function(t){if(this.ctx.font=t,null!=(c=/\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/.exec(t))){var e=c[1],n=(c[2],c[3]),r=c[4],i=c[5],o=c[6];r="px"===i?Math.floor(parseFloat(r)):"em"===i?Math.floor(parseFloat(r)*this.pdf.getFontSize()):Math.floor(parseFloat(r)),this.pdf.setFontSize(r),"bold"===n||"700"===n?this.pdf.setFontStyle("bold"):"italic"===e?this.pdf.setFontStyle("italic"):this.pdf.setFontStyle("normal"),l="bold"===n||"700"===n?"italic"===e?"bolditalic":"bold":"italic"===e?"italic":"normal";for(var a=o.toLowerCase().split(/\s*,\s*/),s="Times",h=0;h<a.length;h++){if(void 0!==this.pdf.internal.getFont(a[h],l,{noFallback:!0,disableWarning:!0})){s=a[h];break}if("bolditalic"===l&&void 0!==this.pdf.internal.getFont(a[h],"bold",{noFallback:!0,disableWarning:!0}))s=a[h],l="bold";else if(void 0!==this.pdf.internal.getFont(a[h],"normal",{noFallback:!0,disableWarning:!0})){s=a[h],l="normal";break}}this.pdf.setFont(s,l)}else{var c=/\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/.exec(t);if(null!=c){var l,u=c[1],f=(c[2],c[3]);(l=c[4])||(l="normal"),u="em"===i?Math.floor(parseFloat(r)*this.pdf.getFontSize()):Math.floor(parseFloat(u)),this.pdf.setFontSize(u),this.pdf.setFont(f,l)}}},setTextBaseline:function(t){this.ctx.textBaseline=t},getTextBaseline:function(){return this.ctx.textBaseline},setTextAlign:function(t){this.ctx.textAlign=t},getTextAlign:function(){return this.ctx.textAlign},setLineWidth:function(t){this.ctx.lineWidth=t,this.pdf.setLineWidth(t)},setLineCap:function(t){this.ctx.lineCap=t,this.pdf.setLineCap(t)},setLineJoin:function(t){this.ctx.lineJoin=t,this.pdf.setLineJoin(t)},moveTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"mt",x:t=n[0],y:e=n[1]};this.path.push(r)},_wrapX:function(t){return this.pageWrapXEnabled?t%this.pageWrapX:t},_wrapY:function(t){return this.pageWrapYEnabled?(this._gotoPage(this._page(t)),(t-this.lastBreak)%this.pageWrapY):t},transform:function(t,e,n,r,i,o){this.ctx._transform=this._matrix_multiply(this.ctx._transform,[t,e,n,r,i,o])},setTransform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},_getTransform:function(){return this.ctx._transform},lastBreak:0,pageBreaks:[],_page:function(t){if(this.pageWrapYEnabled){for(var e=this.lastBreak=0,n=0,r=0;r<this.pageBreaks.length;r++)if(t>=this.pageBreaks[r]){e++,0===this.lastBreak&&n++;var i=this.pageBreaks[r]-this.lastBreak;this.lastBreak=this.pageBreaks[r],n+=Math.floor(i/this.pageWrapY)}if(0===this.lastBreak)n+=Math.floor(t/this.pageWrapY)+1;return n+e}return this.pdf.internal.getCurrentPageInfo().pageNumber},_gotoPage:function(t){},lineTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"lt",x:t=n[0],y:e=n[1]};this.path.push(r)},bezierCurveTo:function(t,e,n,r,i,o){var a;t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),i=this._wrapX(i),o=this._wrapY(o),i=(a=this._matrix_map_point(this.ctx._transform,[i,o]))[0],o=a[1];var s={type:"bct",x1:t=(a=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=a[1],x2:n=(a=this._matrix_map_point(this.ctx._transform,[n,r]))[0],y2:r=a[1],x:i,y:o};this.path.push(s)},quadraticCurveTo:function(t,e,n,r){var i;t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),n=(i=this._matrix_map_point(this.ctx._transform,[n,r]))[0],r=i[1];var o={type:"qct",x1:t=(i=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=i[1],x:n,y:r};this.path.push(o)},arc:function(t,e,n,r,i,o){if(t=this._wrapX(t),e=this._wrapY(e),!this._matrix_is_identity(this.ctx._transform)){var a=this._matrix_map_point(this.ctx._transform,[t,e]);t=a[0],e=a[1];var s=this._matrix_map_point(this.ctx._transform,[0,0]),h=this._matrix_map_point(this.ctx._transform,[0,n]);n=Math.sqrt(Math.pow(h[0]-s[0],2)+Math.pow(h[1]-s[1],2))}var c={type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,anticlockwise:o};this.path.push(c)},drawImage:function(t,e,n,r,i,o,a,s,h){void 0!==o&&(e=o,n=a,r=s,i=h),e=this._wrapX(e),n=this._wrapY(n);var c,l=this._matrix_map_rect(this.ctx._transform,{x:e,y:n,w:r,h:i}),u=(this._matrix_map_rect(this.ctx._transform,{x:o,y:a,w:s,h:h}),/data:image\/(\w+).*/i.exec(t));c=null!=u?u[1]:"png",this.pdf.addImage(t,c,l.x,l.y,l.w,l.h)},_matrix_multiply:function(t,e){var n=e[0],r=e[1],i=e[2],o=e[3],a=e[4],s=e[5],h=n*t[0]+r*t[2],c=i*t[0]+o*t[2],l=a*t[0]+s*t[2]+t[4];return r=n*t[1]+r*t[3],o=i*t[1]+o*t[3],s=a*t[1]+s*t[3]+t[5],[n=h,r,i=c,o,a=l,s]},_matrix_rotation:function(t){return Math.atan2(t[2],t[0])},_matrix_decompose:function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o=Math.sqrt(e*e+n*n),a=(e/=o)*r+(n/=o)*i;r-=e*a,i-=n*a;var s=Math.sqrt(r*r+i*i);return a/=s,e*(i/=s)<n*(r/=s)&&(e=-e,n=-n,a=-a,o=-o),{scale:[o,0,0,s,0,0],translate:[1,0,0,1,t[4],t[5]],rotate:[e,n,-n,e,0,0],skew:[1,0,a,1,0,0]}},_matrix_map_point:function(t,e){var n=t[0],r=t[1],i=t[2],o=t[3],a=t[4],s=t[5],h=e[0],c=e[1];return[h*n+c*i+a,h*r+c*o+s]},_matrix_map_point_obj:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]);return{x:n[0],y:n[1]}},_matrix_map_rect:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]),r=this._matrix_map_point(t,[e.x+e.w,e.y+e.h]);return{x:n[0],y:n[1],w:r[0]-n[0],h:r[1]-n[1]}},_matrix_is_identity:function(t){return 1==t[0]&&(0==t[1]&&(0==t[2]&&(1==t[3]&&(0==t[4]&&0==t[5]))))},rotate:function(t){var e=[Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,e)},scale:function(t,e){var n=[t,0,0,e,0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},translate:function(t,e){var n=[1,0,0,1,t,e];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},stroke:function(){if(0<this.ctx._clip_path.length){var t;(t=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var e=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._stroke(!0),this.ctx._clip_path=this.path,this.path=e,this._stroke(!1),t.push("Q")}else this._stroke(!1)},_stroke:function(t){if(t||!this._isStrokeTransparent()){for(var e=[],n=this.path,r=0;r<n.length;r++){var i=n[r];switch(i.type){case"mt":e.push({start:i,deltas:[],abs:[]});break;case"lt":var o=[i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(o),e[e.length-1].abs.push(i);break;case"bct":o=[i.x1-n[r-1].x,i.y1-n[r-1].y,i.x2-n[r-1].x,i.y2-n[r-1].y,i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(o);break;case"qct":var a=n[r-1].x+2/3*(i.x1-n[r-1].x),s=n[r-1].y+2/3*(i.y1-n[r-1].y),h=i.x+2/3*(i.x1-i.x),c=i.y+2/3*(i.y1-i.y),l=i.x,u=i.y;o=[a-n[r-1].x,s-n[r-1].y,h-n[r-1].x,c-n[r-1].y,l-n[r-1].x,u-n[r-1].y];e[e.length-1].deltas.push(o);break;case"arc":0==e.length&&e.push({start:{x:0,y:0},deltas:[],abs:[]}),e[e.length-1].arc=!0,Array.isArray(e[e.length-1].abs)&&e[e.length-1].abs.push(i)}}for(r=0;r<e.length;r++){var f;if(f=r==e.length-1?"s":null,e[r].arc)for(var d=e[r].abs,p=0;p<d.length;p++){var g=d[p],m=360*g.startAngle/(2*Math.PI),w=360*g.endAngle/(2*Math.PI),y=g.x,v=g.y;this.internal.arc2(this,y,v,g.radius,m,w,g.anticlockwise,f,t)}else{y=e[r].start.x,v=e[r].start.y;t?(this.pdf.lines(e[r].deltas,y,v,null,null),this.pdf.clip_fixed()):this.pdf.lines(e[r].deltas,y,v,null,f)}}}},_isFillTransparent:function(){return this.ctx._isFillTransparent||0==this.globalAlpha},_isStrokeTransparent:function(){return this.ctx._isStrokeTransparent||0==this.globalAlpha},fill:function(t){if(0<this.ctx._clip_path.length){var e;(e=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var n=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(t,!0),this.ctx._clip_path=this.path,this.path=n,this._fill(t,!1),e.push("Q")}else this._fill(t,!1)},_fill:function(t,e){if(!this._isFillTransparent()){var n,r="function"==typeof this.pdf.internal.newObject2;n=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage();var i=[],o=window.outIntercept;if(r)switch(this.ctx.globalCompositeOperation){case"normal":case"source-over":break;case"destination-in":case"destination-out":var a=this.pdf.internal.newStreamObject(),s=this.pdf.internal.newObject2();s.push("<</Type /ExtGState"),s.push("/SMask <</S /Alpha /G "+a.objId+" 0 R>>"),s.push(">>");var h="MASK"+s.objId;this.pdf.internal.addGraphicsState(h,s.objId);var c="/"+h+" gs";n.splice(0,0,"q"),n.splice(1,0,c),n.push("Q"),window.outIntercept=a;break;default:var l="/"+this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];l&&this.pdf.internal.out(l+" gs")}var u=this.ctx.globalAlpha;if(this.ctx._fillOpacity<1&&(u=this.ctx._fillOpacity),r){var f=this.pdf.internal.newObject2();f.push("<</Type /ExtGState"),f.push("/CA "+u),f.push("/ca "+u),f.push(">>");h="GS_O_"+f.objId;this.pdf.internal.addGraphicsState(h,f.objId),this.pdf.internal.out("/"+h+" gs")}for(var d=this.path,p=0;p<d.length;p++){var g=d[p];switch(g.type){case"mt":i.push({start:g,deltas:[],abs:[]});break;case"lt":var m=[g.x-d[p-1].x,g.y-d[p-1].y];i[i.length-1].deltas.push(m),i[i.length-1].abs.push(g);break;case"bct":m=[g.x1-d[p-1].x,g.y1-d[p-1].y,g.x2-d[p-1].x,g.y2-d[p-1].y,g.x-d[p-1].x,g.y-d[p-1].y];i[i.length-1].deltas.push(m);break;case"qct":var w=d[p-1].x+2/3*(g.x1-d[p-1].x),y=d[p-1].y+2/3*(g.y1-d[p-1].y),v=g.x+2/3*(g.x1-g.x),b=g.y+2/3*(g.y1-g.y),x=g.x,S=g.y;m=[w-d[p-1].x,y-d[p-1].y,v-d[p-1].x,b-d[p-1].y,x-d[p-1].x,S-d[p-1].y];i[i.length-1].deltas.push(m);break;case"arc":0===i.length&&i.push({deltas:[],abs:[]}),i[i.length-1].arc=!0,Array.isArray(i[i.length-1].abs)&&i[i.length-1].abs.push(g);break;case"close":i.push({close:!0})}}for(p=0;p<i.length;p++){var k;if(p==i.length-1?(k="f","evenodd"===t&&(k+="*")):k=null,i[p].close)this.pdf.internal.out("h"),k&&this.pdf.internal.out(k);else if(i[p].arc){i[p].start&&this.internal.move2(this,i[p].start.x,i[p].start.y);for(var _=i[p].abs,A=0;A<_.length;A++){var I=_[A];if(void 0!==I.startAngle){var C=360*I.startAngle/(2*Math.PI),T=360*I.endAngle/(2*Math.PI),F=I.x,P=I.y;if(0===A&&this.internal.move2(this,F,P),this.internal.arc2(this,F,P,I.radius,C,T,I.anticlockwise,null,e),A===_.length-1&&i[p].start){F=i[p].start.x,P=i[p].start.y;this.internal.line2(E,F,P)}}else this.internal.line2(E,I.x,I.y)}}else{F=i[p].start.x,P=i[p].start.y;e?(this.pdf.lines(i[p].deltas,F,P,null,null),this.pdf.clip_fixed()):this.pdf.lines(i[p].deltas,F,P,null,k)}}window.outIntercept=o}},pushMask:function(){if("function"==typeof this.pdf.internal.newObject2){var t=this.pdf.internal.newStreamObject(),e=this.pdf.internal.newObject2();e.push("<</Type /ExtGState"),e.push("/SMask <</S /Alpha /G "+t.objId+" 0 R>>"),e.push(">>");var n="MASK"+e.objId;this.pdf.internal.addGraphicsState(n,e.objId);var r="/"+n+" gs";this.pdf.internal.out(r)}else console.log("jsPDF v2 not enabled")},clip:function(){if(0<this.ctx._clip_path.length)for(var t=0;t<this.path.length;t++)this.ctx._clip_path.push(this.path[t]);else this.ctx._clip_path=this.path;this.path=[]},measureText:function(n){var r=this.pdf;return{getWidth:function(){var t=r.internal.getFontSize(),e=r.getStringUnitWidth(n)*t/r.internal.scaleFactor;return e*=1.3333},get width(){return this.getWidth(n)}}},_getBaseline:function(t){var e=parseInt(this.pdf.internal.getFontSize()),n=.25*e;switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e;case"hanging":return t+e-n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}}};var E=t.context2d;function e(){this._isStrokeTransparent=!1,this._strokeOpacity=1,this.strokeStyle="#000000",this.fillStyle="#000000",this._isFillTransparent=!1,this._fillOpacity=1,this.font="12pt times",this.textBaseline="alphabetic",this.textAlign="start",this.lineWidth=1,this.lineJoin="miter",this.lineCap="butt",this._transform=[1,0,0,1,0,0],this.globalCompositeOperation="normal",this.globalAlpha=1,this._clip_path=[],this.ignoreClearRect=!1,this.copy=function(t){this._isStrokeTransparent=t._isStrokeTransparent,this._strokeOpacity=t._strokeOpacity,this.strokeStyle=t.strokeStyle,this._isFillTransparent=t._isFillTransparent,this._fillOpacity=t._fillOpacity,this.fillStyle=t.fillStyle,this.font=t.font,this.lineWidth=t.lineWidth,this.lineJoin=t.lineJoin,this.lineCap=t.lineCap,this.textBaseline=t.textBaseline,this.textAlign=t.textAlign,this._fontSize=t._fontSize,this._transform=t._transform.slice(0),this.globalCompositeOperation=t.globalCompositeOperation,this.globalAlpha=t.globalAlpha,this._clip_path=t._clip_path.slice(0),this.ignoreClearRect=t.ignoreClearRect}}Object.defineProperty(E,"fillStyle",{set:function(t){this.setFillStyle(t)},get:function(){return this.ctx.fillStyle}}),Object.defineProperty(E,"strokeStyle",{set:function(t){this.setStrokeStyle(t)},get:function(){return this.ctx.strokeStyle}}),Object.defineProperty(E,"lineWidth",{set:function(t){this.setLineWidth(t)},get:function(){return this.ctx.lineWidth}}),Object.defineProperty(E,"lineCap",{set:function(t){this.setLineCap(t)},get:function(){return this.ctx.lineCap}}),Object.defineProperty(E,"lineJoin",{set:function(t){this.setLineJoin(t)},get:function(){return this.ctx.lineJoin}}),Object.defineProperty(E,"miterLimit",{set:function(t){this.ctx.miterLimit=t},get:function(){return this.ctx.miterLimit}}),Object.defineProperty(E,"textBaseline",{set:function(t){this.setTextBaseline(t)},get:function(){return this.getTextBaseline()}}),Object.defineProperty(E,"textAlign",{set:function(t){this.setTextAlign(t)},get:function(){return this.getTextAlign()}}),Object.defineProperty(E,"font",{set:function(t){this.setFont(t)},get:function(){return this.ctx.font}}),Object.defineProperty(E,"globalCompositeOperation",{set:function(t){this.ctx.globalCompositeOperation=t},get:function(){return this.ctx.globalCompositeOperation}}),Object.defineProperty(E,"globalAlpha",{set:function(t){this.ctx.globalAlpha=t},get:function(){return this.ctx.globalAlpha}}),Object.defineProperty(E,"canvas",{get:function(){return{parentNode:!1,style:!1}}}),Object.defineProperty(E,"ignoreClearRect",{set:function(t){this.ctx.ignoreClearRect=t},get:function(){return this.ctx.ignoreClearRect}}),E.internal={},E.internal.rxRgb=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/,E.internal.rxRgba=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/,E.internal.rxTransparent=/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/,E.internal.arc=function(t,e,n,r,i,o,a,s){for(var h=this.pdf.internal.scaleFactor,c=this.pdf.internal.pageSize.getHeight(),l=this.pdf.internal.f2,u=i*(Math.PI/180),f=o*(Math.PI/180),d=this.createArc(r,u,f,a),p=0;p<d.length;p++){var g=d[p];0===p?this.pdf.internal.out([l((g.x1+e)*h),l((c-(g.y1+n))*h),"m",l((g.x2+e)*h),l((c-(g.y2+n))*h),l((g.x3+e)*h),l((c-(g.y3+n))*h),l((g.x4+e)*h),l((c-(g.y4+n))*h),"c"].join(" ")):this.pdf.internal.out([l((g.x2+e)*h),l((c-(g.y2+n))*h),l((g.x3+e)*h),l((c-(g.y3+n))*h),l((g.x4+e)*h),l((c-(g.y4+n))*h),"c"].join(" ")),t._lastPoint={x:e,y:n}}null!==s&&this.pdf.internal.out(this.pdf.internal.getStyle(s))},E.internal.arc2=function(t,e,n,r,i,o,a,s,h){var c=e,l=n;h?(this.arc(t,c,l,r,i,o,a,null),this.pdf.clip_fixed()):this.arc(t,c,l,r,i,o,a,s)},E.internal.move2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.getHeight(),o=this.pdf.internal.f2;this.pdf.internal.out([o(e*r),o((i-n)*r),"m"].join(" ")),t._lastPoint={x:e,y:n}},E.internal.line2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.getHeight(),o=this.pdf.internal.f2,a={x:e,y:n};this.pdf.internal.out([o(a.x*r),o((i-a.y)*r),"l"].join(" ")),t._lastPoint=a},E.internal.createArc=function(t,e,n,r){var i=2*Math.PI,o=Math.PI/2,a=e;for((a<i||i<a)&&(a%=i),a<0&&(a=i+a);n<e;)e-=i;var s=Math.abs(n-e);s<i&&r&&(s=i-s);for(var h=[],c=r?-1:1,l=a;1e-5<s;){var u=l+c*Math.min(s,o);h.push(this.createSmallArc(t,l,u)),s-=Math.abs(u-l),l=u}return h},E.internal.getCurrentPage=function(){return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber]},E.internal.createSmallArc=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,h=a*a+s*s,c=h+a*i+s*o,l=4/3*(Math.sqrt(2*h*c)-c)/(a*o-s*i),u=a-l*s,f=s+l*a,d=u,p=-f,g=r+e,m=Math.cos(g),w=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:u*m-f*w,y2:u*w+f*m,x3:d*m-p*w,y3:d*w+p*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}}}($.API,"undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
/** @preserve
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * 
   * ====================================================================
   */
function(t){var T,F,i,a,s,h,c,l,P,v,f,u,d,n,E,q,p,g,m,O;T=function(){return function(t){return e.prototype=t,new e};function e(){}}(),v=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,a=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},u=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},d=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[t])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:(e=t.match(/([\d\.]+)(px)/),Array.isArray(e)&&3===e.length?n[t]=parseFloat(e[1])/16:n[t]=1)},P=function(t){var e,n,r,i,o;return o=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(o,null):o.currentStyle?o.currentStyle:o.style,n=void 0,(e={})["font-family"]=u((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=h[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=d(r("font-size"))||1,e["line-height"]=d(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&d(r("margin-top"))||0,e["margin-bottom"]=n&&d(r("margin-bottom"))||0,e["padding-top"]=n&&d(r("padding-top"))||0,e["padding-bottom"]=n&&d(r("padding-bottom"))||0,e["margin-left"]=n&&d(r("margin-left"))||0,e["margin-right"]=n&&d(r("margin-right"))||0,e["padding-left"]=n&&d(r("padding-left"))||0,e["padding-right"]=n&&d(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=c[r("cssFloat")]||"none",e.clear=l[r("clear")]||"none",e.color=r("color"),e},E=function(t,e,n){var r,i,o,a,s;if(o=!1,a=i=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},O=function(t,e){var n,r,i,o,a,s,h,c,l;for(n=[],r=[],i=0,l=t.rows[0].cells.length,h=t.clientWidth;i<l;)c=t.rows[0].cells[i],r[i]={name:c.textContent.toLowerCase().replace(/\s+/g,""),prompt:c.textContent.replace(/\r?\n/g,""),width:c.clientWidth/h*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var B={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},R=1;F=function(t,i,e){var n,r,o,a,s,h,c,l;for(r=t.childNodes,n=void 0,(s="block"===(o=P(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(o)),a=0,h=r.length;a<h;){if("object"===(void 0===(n=r[a])?"undefined":vt(n))){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var u=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,F(u,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||B[n.nodeName])if(3===n.nodeType){var d=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)d=R+++". "+d;else{var p=o["font-size"],g=(3-.75*p)*i.pdf.internal.scaleFactor,m=.75*p*i.pdf.internal.scaleFactor,w=1.74*p/i.pdf.internal.scaleFactor;l=function(t,e){this.pdf.circle(t+g,e+m,w,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(d,o)}else"string"==typeof n&&i.addText(n,o);else{var y;if("IMG"===n.nodeName){var v=n.getAttribute("src");y=q[i.pdf.sHashCode(v)||v]}if(y){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var b=P(n),x=i.x,S=12/i.pdf.internal.scaleFactor,k=(b["margin-left"]+b["padding-left"])*S,_=(b["margin-right"]+b["padding-right"])*S,A=(b["margin-top"]+b["padding-top"])*S,I=(b["margin-bottom"]+b["padding-bottom"])*S;void 0!==b.float&&"right"===b.float?x+=i.settings.width-n.width-_:x+=k,i.pdf.addImage(y,x,i.y+A,n.width,n.height),y=void 0,"right"===b.float||"left"===b.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!B[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===b.float?-n.width-k-_:0,i.y+n.height+A+I,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===P(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+k+_,"left"===b.float&&(i.x+=n.width+k+_)):i.y+=n.height+A+I}else if("TABLE"===n.nodeName)c=O(n,i),i.y+=10,i.pdf.table(i.x,i.y,c.rows,c.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:P(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)R=1,E(n,i,e)||F(n,i,e),i.y+=10;else if("LI"===n.nodeName){var C=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,E(n,i,e)||F(n,i,e),i.x=C}else"BR"===n.nodeName?(i.y+=o["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",T(o))):E(n,i,e)||F(n,i,e)}}a++}if(e.outY=i.y,s)return i.setBlockBoundary(l)},q={},p=function(t,o,e,n){var a,r=t.getElementsByTagName("img"),i=r.length,s=0;function h(){o.pdf.internal.events.publish("imagesLoaded"),n(a)}function c(e,n,r){if(e){var i=new Image;a=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=o.pdf.sHashCode(e)||e;q[t]=q[t]||i}--s||h()},i.src=e}}for(;i--;)c(r[i].getAttribute("src"),r[i].width,r[i].height);return s||h()},g=function(t,o,a){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=o.pdf.internal.write,n=o.y;o.pdf.internal.write=function(){},F(s,o,a);var h=Math.ceil(o.y-n)+5;o.y=n,o.pdf.internal.write=e,o.pdf.margins_doc.bottom+=h;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=o.y;o.y=o.pdf.internal.pageSize.getHeight()-o.pdf.margins_doc.bottom,o.pdf.margins_doc.bottom-=h;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");F(s,o,a),o.pdf.margins_doc.bottom+=h,o.y=n},i=s.getElementsByTagName("span"),c=0;c<i.length;++c)-1<(" "+i[c].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&o.pdf.internal.events.subscribe("htmlRenderingFinished",o.pdf.putTotalPages.bind(o.pdf,"###jsPDFVarTotalPages###"),!0);o.pdf.internal.events.subscribe("addPage",r,!1),r(),B.FOOTER=1}},m=function(t,e,n,r,i,o){if(!e)return!1;var a,s,h,c;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(a=e.replace(/<\/?script[^>]*?>/gi,""),c="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(h=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",h.innerHTML='<iframe style="height:1px;width:1px" name="'+c+'" />',document.body.appendChild(h),(s=window.frames[c]).document.open(),s.document.writeln(a),s.document.close(),e=s.document.body);var l,u=new f(t,n,r,i);return p.call(this,e,u,i.elementHandlers,function(t){g(e,u,i.elementHandlers),F(e,u,i.elementHandlers),u.pdf.internal.events.publish("htmlRenderingFinished"),l=u.dispose(),"function"==typeof o?o(l):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),l||{x:u.x,y:u.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,o,a,s,h,c,l,u,f,d,p,g;for(12,u=this.pdf.internal.scaleFactor,o={},s=h=c=g=a=i=l=r=void 0,d=[f=[]],n=0,p=this.settings.width;t.length;)if(a=t.shift(),g=e.shift(),a)if((i=o[(r=g["font-family"])+(l=g["font-style"])])||(i=this.pdf.internal.getFont(r,l).metadata.Unicode,o[r+l]=i),c={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},h=this.pdf.getStringUnitWidth(a,c)*c.fontSize/u,"\u2028"==a)f=[],d.push(f);else if(p<n+h){for(s=this.pdf.splitTextToSize(a,p,c),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],d.push(f);n=this.pdf.getStringUnitWidth(f[0][0],c)*c.fontSize/u}else f.push([a,g]),n+=h;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<d.length;++m){var w=this.pdf.getStringUnitWidth(d[m][0][0],c)*c.fontSize/u;0<m&&(d[m][0][1]=T(d[m][0][1]));var y=p-w;if("right"===g["text-align"])d[m][0][1]["margin-left"]=y;else if("center"===g["text-align"])d[m][0][1]["margin-left"]=y/2;else if("justify"===g["text-align"]){var v=d[m][0][0].split(" ").length-1;d[m][0][1]["word-spacing"]=y/v,m===d.length-1&&(d[m][0][1]["word-spacing"]=0)}}return d},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=new RGBColor(t),o=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=o?(e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3])):("#"!=t.charAt(0)&&(t=i.ok?i.toHex():"#000000"),e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)),"string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,h,c,l,u,f,d;if(r=v(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),h=a=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,u=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,l=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,u=((e["margin-top"]||0)+(e["padding-top"]||0))*n),c=this.pdf.internal.write,o=i=void 0,this.y+=u,c("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var p=0;s.length;){for(i=h=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(h=Math.max(h,a[i][1]["line-height"],a[i][1]["font-size"]),d=7*a[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==a[0][1]["margin-left"]&&0<a[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-p,p=m),c(g+Math.max(e["margin-left"]||0,0)*n,(-12*h).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=h*n,this.executeWatchFunctions(a[0][1])&&0<s.length){var w=[],y=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(w.push(t[e][0]+" "),y.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(v(w),y),c("ET","Q"),c("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-d/2),c("ET","Q"),this.y+=l}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},h={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},c={none:"none",right:"right",left:"left"},l={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}($.API),$.API.addJS=function(t){return s=t,this.internal.events.subscribe("postPutResources",function(t){n=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(n+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),r=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+s+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==n&&void 0!==r&&this.internal.out("/Names <</JavaScript "+n+" 0 R>>")}),this},(
/**
   * jsPDF Outline PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
c=$.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,h=[];for(r=0;r<s;r++){var c=t.internal.newObject();h.push(c);var l=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+l.objId+" 0 R /XYZ null null null]>> endobj")}var u=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<h.length;r++)t.internal.write("(page_"+(r+1)+")"+h[r]+" 0 R");t.internal.write(" ] >>","endobj"),t.internal.newObject(),t.internal.write("<< /Dests "+u+" 0 R"),t.internal.write(">>","endobj")}}]),c.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+namesOid+" 0 R"))}]),c.events.push(["initialized",function(){var o=this;o.outline={createNamedDestinations:!1,root:{children:[]}},o.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},o.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=o,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},o.outline.genIds_r=function(t){t.id=o.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},o.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},o.outline.renderItems=function(t){for(var e=0;e<t.children.length;e++){var n=t.children[e];this.objStart(n),this.line("/Title "+this.makeString(n.title)),this.line("/Parent "+this.makeRef(t)),0<e&&this.line("/Prev "+this.makeRef(t.children[e-1])),e<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[e+1])),0<n.children.length&&(this.line("/First "+this.makeRef(n.children[0])),this.line("/Last "+this.makeRef(n.children[n.children.length-1])));var r=this.count=this.count_r({count:0},n);if(0<r&&this.line("/Count "+r),n.options&&n.options.pageNumber){var i=o.internal.getPageInfo(n.options.pageNumber);this.line("/Dest ["+i.objId+" 0 R /XYZ 0 "+this.ctx.pdf.internal.pageSize.getHeight()*this.ctx.pdf.internal.scaleFactor+" 0]")}this.objEnd()}for(e=0;e<t.children.length;e++)n=t.children[e],this.renderItems(n)},o.outline.line=function(t){this.ctx.val+=t+"\r\n"},o.outline.makeRef=function(t){return t.id+" 0 R"},o.outline.makeString=function(t){return"("+o.internal.pdfEscape(t)+")"},o.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},o.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},o.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
/**@preserve
   *  ====================================================================
   * jsPDF PNG PlugIn
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */
P=$.API,E=function(){var t="function"==typeof Deflater;if(!t)throw new Error("requires deflate.js for compression");return t},q=function(t,e,n,r){var i=5,o=b;switch(r){case P.image_compression.FAST:i=3,o=v;break;case P.image_compression.MEDIUM:i=6,o=x;break;case P.image_compression.SLOW:i=9,o=S}t=w(t,e,n,o);var a=new Uint8Array(g(i)),s=m(t),h=new Deflater(i),c=h.append(t),l=h.flush(),u=a.length+c.length+l.length,f=new Uint8Array(u+4);return f.set(a),f.set(c,a.length),f.set(l,a.length+c.length),f[u++]=s>>>24&255,f[u++]=s>>>16&255,f[u++]=s>>>8&255,f[u++]=255&s,P.arrayBufferToBinaryString(f)},g=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,[n,255&(r+=31-r%31)]},m=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;0<o;){for(o-=n=e<o?e:o;i+=r+=t[a++],--n;);r%=65521,i%=65521}return(i<<16|r)>>>0},w=function(t,e,n,r){for(var i,o,a,s=t.length/e,h=new Uint8Array(t.length+s),c=k(),l=0;l<s;l++){if(a=l*e,i=t.subarray(a,a+e),r)h.set(r(i,n,o),a+l);else{for(var u=0,f=c.length,d=[];u<f;u++)d[u]=c[u](i,n,o);var p=_(d.concat());h.set(d[p],a+l)}o=i}return h},l=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},v=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},b=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},x=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},S=function(t,e,n){var r,i,o,a,s=[],h=0,c=t.length;for(s[0]=4;h<c;h++)r=t[h-e]||0,i=n&&n[h]||0,o=n&&n[h-e]||0,a=u(r,i,o),s[h+1]=t[h]-a+256&255;return s},u=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},k=function(){return[l,v,b,x,S]},_=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=f(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},f=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},P.processPNG=function(t,e,n,r,i){var o,a,s,h,c,l,u=this.color_spaces.DEVICE_RGB,f=this.decode.FLATE_DECODE,d=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if("function"!=typeof PNG||"function"!=typeof kt)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,d=o.bits,u=o.colorSpace,h=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits)for(var p,g=(I=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*o.colors),w=new Uint8Array(g),y=o.pixelBitlength-o.bits,v=0,b=0;v<g;v++){for(x=I[v],p=0;p<y;)m[b++]=x>>>p&255,p+=o.bits;w[v]=x>>>p&255}if(16===o.bits){g=(I=new Uint32Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*(32/o.pixelBitlength)*o.colors),w=new Uint8Array(g*(32/o.pixelBitlength));for(var x,S=1<o.colors,k=b=v=0;v<g;)x=I[v++],m[b++]=x>>>0&255,S&&(m[b++]=x>>>16&255,x=I[v++],m[b++]=x>>>0&255),w[k++]=x>>>16&255;d=8}r!==P.image_compression.NONE&&E()?(t=q(m,o.width*o.colors,o.colors,r),l=q(w,o.width,1,r)):(t=m,l=w,f=null)}if(3===o.colorType&&(u=this.color_spaces.INDEXED,c=o.palette,o.transparency.indexed)){var _=o.transparency.indexed,A=0;for(v=0,g=_.length;v<g;++v)A+=_[v];if((A/=255)==g-1&&-1!==_.indexOf(0))s=[_.indexOf(0)];else if(A!==g){var I=o.decodePixels();for(w=new Uint8Array(I.length),v=0,g=I.length;v<g;v++)w[v]=_[I[v]];l=q(w,o.width,1)}}var C=function(t){var e;switch(t){case P.image_compression.FAST:e=11;break;case P.image_compression.MEDIUM:e=13;break;case P.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return a=f===this.decode.FLATE_DECODE?"/Predictor "+C+" /Colors "+h+" /BitsPerComponent "+d+" /Columns "+o.width:"/Colors "+h+" /BitsPerComponent "+d+" /Columns "+o.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(l&&this.isArrayBuffer(l)||this.isArrayBufferView(l))&&(l=this.arrayBufferToBinaryString(l)),this.createImageInfo(t,o.width,o.height,u,d,f,e,n,a,s,c,l,C)}throw new Error("Unsupported PNG image data, try using JPEG instead.")},(
/**
   * jsPDF gif Support PlugIn
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
A=$.API).processGIF89A=function(t,e,n,r,i){var o=new mt(t),a=o.width,s=o.height,h=[];o.decodeAndBlitFrameRGBA(0,h);var c={data:h,width:a,height:s},l=new yt(100).encode(c,100);return A.processJPEG.call(this,l,e,n,r)},A.processGIF87A=A.processGIF89A,(
/**
   * jsPDF bmp Support PlugIn
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
O=$.API).processBMP=function(t,e,n,r,i){var o=new xt(t,!1),a=o.width,s=o.height,h={data:o.getData(),width:a,height:s},c=new yt(100).encode(h,100);return O.processJPEG.call(this,c,e,n,r)},$.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
/** @preserve
   * jsPDF split_text_to_size plugin - MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   */
B=$.API,R=B.getCharWidthsArray=function(t,e){var n,r,i,o=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),s=e.charSpace||this.internal.getCharSpace(),h=e.widths?e.widths:o.metadata.Unicode.widths,c=h.fof?h.fof:1,l=e.kerning?e.kerning:o.metadata.Unicode.kerning,u=l.fof?l.fof:1,f=0,d=h[0]||c,p=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),"function"==typeof o.metadata.widthOfString?p.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i))+s*(1e3/a)||0)/1e3):p.push((h[i]||d)/c+(l[i]&&l[i][f]||0)/u),f=i;return p},j=B.getArraySum=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},D=B.getStringUnitWidth=function(t,e){var n=(e=e||{}).fontSize||this.internal.getFontSize(),r=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return"function"==typeof r.metadata.widthOfString?r.metadata.widthOfString(t,n,i)/n:j(R.apply(this,arguments))},M=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var h=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(h,o)),s=0,h=o),s+=e[o],o++;return h!==o&&i.push(t.slice(h,o)),i},U=function(t,e,n){n||(n={});var r,i,o,a,s,h,c=[],l=[c],u=n.textIndent||0,f=0,d=0,p=t.split(" "),g=R.apply(this,[" ",n])[0];if(h=-1===n.lineIndent?p[0].length+2:n.lineIndent||0){var m=Array(h).join(" "),w=[];p.map(function(t){1<(t=t.split(/\s*\n/)).length?w=w.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):w.push(t[0])}),p=w,h=D.apply(this,[m,n])}for(o=0,a=p.length;o<a;o++){var y=0;if(r=p[o],h&&"\n"==r[0]&&(r=r.substr(1),y=1),i=R.apply(this,[r,n]),e<u+f+(d=j(i))||y){if(e<d){for(s=M.apply(this,[r,i,e-(u+f),e]),c.push(s.shift()),c=[s.pop()];s.length;)l.push([s.shift()]);d=j(i.slice(r.length-(c[0]?c[0].length:0)))}else c=[r];l.push(c),u=d+h,f=g}else c.push(r),u+=f+d,f=g}if(h)var v=function(t,e){return(e?m:"")+t.join(" ")};else v=function(t){return t.join(" ")};return l.map(v)},B.splitTextToSize=function(t,e,n){var r,i=(n=n||{}).fontSize||this.internal.getFontSize(),o=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{font:r.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var a=1*this.internal.scaleFactor*e/i;o.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,o.lineIndent=n.lineIndent;var s,h,c=[];for(s=0,h=r.length;s<h;s++)c=c.concat(U.apply(this,[r[s],a,o]));return c},
/** @preserve 
  jsPDF standard_fonts_metrics plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  MIT license.
  */
N=$.API,L={codePages:["WinAnsiEncoding"],WinAnsiEncoding:(z=function(t){for(var e="klmnopqrstuvwxyz",n={},r=0;r<e.length;r++)n[e[r]]="0123456789abcdef"[r];var i,o,a,s,h,c={},l=1,u=c,f=[],d="",p="",g=t.length-1;for(r=1;r!=g;)h=t[r],r+=1,"'"==h?o?(s=o.join(""),o=i):o=[]:o?o.push(h):"{"==h?(f.push([u,s]),u={},s=i):"}"==h?((a=f.pop())[0][a[1]]=u,s=i,u=a[0]):"-"==h?l=-1:s===i?n.hasOwnProperty(h)?(d+=n[h],s=parseInt(d,16)*l,l=1,d=""):d+=h:n.hasOwnProperty(h)?(p+=n[h],u[s]=parseInt(p,16)*l,l=1,s=i,p=""):p+=h;return c})("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},H={Unicode:{Courier:L,"Courier-Bold":L,"Courier-BoldOblique":L,"Courier-Oblique":L,Helvetica:L,"Helvetica-Bold":L,"Helvetica-BoldOblique":L,"Helvetica-Oblique":L,"Times-Roman":L,"Times-Bold":L,"Times-BoldItalic":L,"Times-Italic":L}
/** 
    Resources:
    Font metrics data is reprocessed derivative of contents of
    "Font Metrics for PDF Core 14 Fonts" package, which exhibits the following copyright and license:
    
    Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated. All Rights Reserved.
    
    This file and the 14 PostScript(R) AFM files it accompanies may be used,
    copied, and distributed for any purpose and without charge, with or without
    modification, provided that all copyright notices are retained; that the AFM
    files are not distributed without this file; that all modifications to this
    file or any of the AFM files are prominently noted in the modified file(s);
    and that this paragraph is not modified. Adobe Systems has no responsibility
    or obligation to support the use of the AFM files.
    
    */},W={Unicode:{"Courier-Oblique":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":z("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":z("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:z("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:z("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":z("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":z("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}},N.events.push(["addFont",function(t){var e,n,r,i="Unicode";(e=W[i][t.postScriptName])&&((n=t.metadata[i]?t.metadata[i]:t.metadata[i]={}).widths=e.widths,n.kerning=e.kerning),(r=H[i][t.postScriptName])&&((n=t.metadata[i]?t.metadata[i]:t.metadata[i]={}).encoding=r).codePages&&r.codePages.length&&(t.encoding=r.codePages[0])}]),G=$,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")(),G.API.events.push(["addFont",function(t){G.API.existsFileInVFS(t.postScriptName)?(t.metadata=G.API.TTFFont.open(t.postScriptName,t.fontName,G.API.getFileFromVFS(t.postScriptName),t.encoding),t.metadata.Unicode=t.metadata.Unicode||{encoding:{},kerning:{},widths:[]}):14<t.id.slice(1)&&console.error("Font does not exist in FileInVFS, import fonts or remove declaration doc.addFont('"+t.postScriptName+"').")}]),(
/** @preserve
  jsPDF SVG plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  */
V=$.API).addSvg=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function o(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var a,s,h,c,l,u,f,d,p=(c=document,d=c.createElement("iframe"),l=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(f=(u=c).createElement("style")).type="text/css",f.styleSheet?f.styleSheet.cssText=l:f.appendChild(u.createTextNode(l)),u.getElementsByTagName("head")[0].appendChild(f),d.name="childframe",d.setAttribute("width",0),d.setAttribute("height",0),d.setAttribute("frameborder","0"),d.setAttribute("scrolling","no"),d.setAttribute("seamless","seamless"),d.setAttribute("class","jsPDF_sillysvg_iframe"),c.body.appendChild(d),d),g=(a=t,(h=((s=p).contentWindow||s.contentDocument).document).write(a),h.close(),h.getElementsByTagName("svg")[0]),m=[1,1],w=parseFloat(g.getAttribute("width")),y=parseFloat(g.getAttribute("height"));w&&y&&(r&&i?m=[r/w,i/y]:r?m=[r/w,r/w]:i&&(m=[i/y,i/y]));var v,b,x,S,k=g.childNodes;for(v=0,b=k.length;v<b;v++)(x=k[v]).tagName&&"PATH"===x.tagName.toUpperCase()&&((S=o(x.getAttribute("d").split(" ")))[0]=S[0]*m[0]+e,S[1]=S[1]*m[1]+n,this.lines.call(this,S[2],S[0],S[1],m));return this},V.addSVG=V.addSvg,V.addSvgAsImage=function(t,e,n,r,i,o,a,s){if(isNaN(e)||isNaN(n))throw console.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(r)||isNaN(i))throw console.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var h=document.createElement("canvas");h.width=r,h.height=i;var c=h.getContext("2d");return c.fillStyle="#fff",c.fillRect(0,0,h.width,h.height),canvg(h,t,{ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0,ignoreClear:!0}),this.addImage(h.toDataURL("image/jpeg",1),e,n,r,i,a,s),this},$.API.putTotalPages=function(t){for(var e=new RegExp(t,"g"),n=1;n<=this.internal.getNumberOfPages();n++)for(var r=0;r<this.internal.pages[n].length;r++)this.internal.pages[n][r]=this.internal.pages[n][r].replace(e,this.internal.getNumberOfPages());return this},$.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},a=Object.keys(o),s=[],h=0,c=0,l=0,u=!0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var d=a.length;for(l=0;l<d;l+=1)n[a[l]].value=n[a[l]].defaultValue,n[a[l]].explicitSet=!1}if("object"===(void 0===t?"undefined":vt(t)))for(r in t)if(i=t[r],f(a,r)&&void 0!==i){if("boolean"===n[r].type&&"boolean"==typeof i)n[r].value=i;else if("name"===n[r].type&&f(n[r].valueSet,i))n[r].value=i;else if("integer"===n[r].type&&Number.isInteger(i))n[r].value=i;else if("array"===n[r].type){for(h=0;h<i.length;h+=1)if(u=!0,1===i[h].length&&"number"==typeof i[h][0])s.push(String(i[h]));else if(1<i[h].length){for(c=0;c<i[h].length;c+=1)"number"!=typeof i[h][c]&&(u=!1);!0===u&&s.push(String(i[h].join("-")))}n[r].value=String(s)}else n[r].value=n[r].defaultValue;n[r].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */
Y=$.API,K=J=X="",Y.addMetadata=function(t,e){return J=e||"http://jspdf.default.namespaceuri/",X=t,this.internal.events.subscribe("postPutResources",function(){if(X){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+J+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(X)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),o=unescape(encodeURIComponent("</x:xmpmeta>")),a=n.length+r.length+i.length+e.length+o.length;K=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+a+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+o),this.internal.write("endstream"),this.internal.write("endobj")}else K=""}),this.internal.events.subscribe("putCatalog",function(){K&&this.internal.write("/Metadata "+K+" 0 R")}),this},function(l,t){var e=l.API,m=[0];e.events.push(["putFont",function(t){!function(t,e,n){if(t.metadata instanceof l.API.TTFFont&&"Identity-H"===t.encoding){for(var r=t.metadata.Unicode.widths,i=t.metadata.subset.encode(m),o="",a=0;a<i.length;a++)o+=String.fromCharCode(i[a]);var s=n();e("<<"),e("/Length "+o.length),e("/Length1 "+o.length),e(">>"),e("stream"),e(o),e("endstream"),e("endobj");var h=n();e("<<"),e("/Type /FontDescriptor"),e("/FontName /"+t.fontName),e("/FontFile2 "+s+" 0 R"),e("/FontBBox "+l.API.PDFObject.convert(t.metadata.bbox)),e("/Flags "+t.metadata.flags),e("/StemV "+t.metadata.stemV),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e(">>"),e("endobj");var c=n();e("<<"),e("/Type /Font"),e("/BaseFont /"+t.fontName),e("/FontDescriptor "+h+" 0 R"),e("/W "+l.API.PDFObject.convert(r)),e("/CIDToGIDMap /Identity"),e("/DW 1000"),e("/Subtype /CIDFontType2"),e("/CIDSystemInfo"),e("<<"),e("/Supplement 0"),e("/Registry (Adobe)"),e("/Ordering ("+t.encoding+")"),e(">>"),e(">>"),e("endobj"),t.objectNumber=n(),e("<<"),e("/Type /Font"),e("/Subtype /Type0"),e("/BaseFont /"+t.fontName),e("/Encoding /"+t.encoding),e("/DescendantFonts ["+c+" 0 R]"),e(">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject)}]);e.events.push(["putFont",function(t){!function(t,e,n){if(t.metadata instanceof l.API.TTFFont&&"WinAnsiEncoding"===t.encoding){t.metadata.Unicode.widths;for(var r=t.metadata.rawData,i="",o=0;o<r.length;o++)i+=String.fromCharCode(r[o]);var a=n();e("<<"),e("/Length "+i.length),e("/Length1 "+i.length),e(">>"),e("stream"),e(i),e("endstream"),e("endobj");var s=n();for(e("<<"),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e("/StemV "+t.metadata.stemV),e("/Type /FontDescriptor"),e("/FontFile2 "+a+" 0 R"),e("/Flags 96"),e("/FontBBox "+l.API.PDFObject.convert(t.metadata.bbox)),e("/FontName /"+t.fontName),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e(">>"),e("endobj"),t.objectNumber=n(),o=0;o<t.metadata.hmtx.widths.length;o++)t.metadata.hmtx.widths[o]=parseInt(t.metadata.hmtx.widths[o]*(1e3/t.metadata.head.unitsPerEm));e("<</Subtype/TrueType/Type/Font/BaseFont/"+t.fontName+"/FontDescriptor "+s+" 0 R/Encoding/"+t.encoding+" /FirstChar 29 /LastChar 255 /Widths "+l.API.PDFObject.convert(t.metadata.hmtx.widths)+">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject)}]);var c=function(t){var e,n,r=t.text||"",i=t.x,o=t.y,a=t.options||{},s=t.mutex||{},h=s.pdfEscape,c=s.activeFontKey,l=s.fonts,u=(s.activeFontSize,""),f=0,d="",p=l[n=c].encoding;if("Identity-H"!==l[n].encoding)return{text:r,x:i,y:o,options:a,mutex:s};for(d=r,n=c,"[object Array]"===Object.prototype.toString.call(r)&&(d=r[0]),f=0;f<d.length;f+=1)l[n].metadata.hasOwnProperty("cmap")&&(e=l[n].metadata.cmap.unicode.codeMap[d[f].charCodeAt(0)]),e?u+=d[f]:d[f].charCodeAt(0)<256&&l[n].metadata.hasOwnProperty("Unicode")?u+=d[f]:u+="";var g="";return parseInt(n.slice(1))<14||"WinAnsiEncoding"===p?g=function(t){for(var e="",n=0;n<t.length;n++)e+=""+t.charCodeAt(n).toString(16);return e}(h(u,n)):"Identity-H"===p&&(g=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],o=[""],a=0,s=t.length;a<s;++a){if(n=e.metadata.characterToGlyph(t.charCodeAt(a)),m.push(n),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return o.join("");n=n.toString(16),o.push(i[4-n.length],n)}return o.join("")}(u,l[n])),s.isHex=!0,{text:g,x:i,y:o,options:a,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",n=t.x,r=t.y,i=t.options,o=t.mutex,a=(i.lang,[]),s={text:e,x:n,y:r,options:i,mutex:o};if("[object Array]"===Object.prototype.toString.call(e)){var h=0;for(h=0;h<e.length;h+=1)"[object Array]"===Object.prototype.toString.call(e[h])&&3===e[h].length?a.push([c(Object.assign({},s,{text:e[h][0]})).text,e[h][1],e[h][2]]):a.push(c(Object.assign({},s,{text:e[h]})).text);t.text=a}else t.text=c(Object.assign({},s,{text:e})).text}])}($,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")()),Q=$.API,Z={},Q.existsFileInVFS=function(t){return Z.hasOwnProperty(t)},Q.addFileToVFS=function(t,e){return Z[t]=e,this},Q.getFileFromVFS=function(t){return Z.hasOwnProperty(t)?Z[t]:null},function(t){if(t.URL=t.URL||t.webkitURL,t.Blob&&t.URL)try{return new Blob}catch(t){}var s=t.BlobBuilder||t.WebKitBlobBuilder||t.MozBlobBuilder||function(t){var s=function(t){return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1]},e=function(){this.data=[]},h=function(t,e,n){this.data=t,this.size=t.length,this.type=e,this.encoding=n},n=e.prototype,r=h.prototype,c=t.FileReaderSync,l=function(t){this.code=this[this.name=t]},i="NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "),o=i.length,a=t.URL||t.webkitURL||t,u=a.createObjectURL,f=a.revokeObjectURL,d=a,p=t.btoa,g=t.atob,m=t.ArrayBuffer,w=t.Uint8Array,y=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;for(h.fake=r.fake=!0;o--;)l.prototype[i[o]]=o+1;return a.createObjectURL||(d=t.URL=function(t){var e,n=document.createElementNS("http://www.w3.org/1999/xhtml","a");return n.href=t,"origin"in n||("data:"===n.protocol.toLowerCase()?n.origin=null:(e=t.match(y),n.origin=e&&e[1])),n}),d.createObjectURL=function(t){var e,n=t.type;return null===n&&(n="application/octet-stream"),t instanceof h?(e="data:"+n,"base64"===t.encoding?e+";base64,"+t.data:"URI"===t.encoding?e+","+decodeURIComponent(t.data):p?e+";base64,"+p(t.data):e+","+encodeURIComponent(t.data)):u?u.call(a,t):void 0},d.revokeObjectURL=function(t){"data:"!==t.substring(0,5)&&f&&f.call(a,t)},n.append=function(t){var e=this.data;if(w&&(t instanceof m||t instanceof w)){for(var n="",r=new w(t),i=0,o=r.length;i<o;i++)n+=String.fromCharCode(r[i]);e.push(n)}else if("Blob"===s(t)||"File"===s(t)){if(!c)throw new l("NOT_READABLE_ERR");var a=new c;e.push(a.readAsBinaryString(t))}else t instanceof h?"base64"===t.encoding&&g?e.push(g(t.data)):"URI"===t.encoding?e.push(decodeURIComponent(t.data)):"raw"===t.encoding&&e.push(t.data):("string"!=typeof t&&(t+=""),e.push(unescape(encodeURIComponent(t))))},n.getBlob=function(t){return arguments.length||(t=null),new h(this.data.join(""),t,"raw")},n.toString=function(){return"[object BlobBuilder]"},r.slice=function(t,e,n){var r=arguments.length;return r<3&&(n=null),new h(this.data.slice(t,1<r?e:this.data.length),n,this.encoding)},r.toString=function(){return"[object Blob]"},r.close=function(){this.size=0,delete this.data},e}(t);t.Blob=function(t,e){var n=e&&e.type||"",r=new s;if(t)for(var i=0,o=t.length;i<o;i++)Uint8Array&&t[i]instanceof Uint8Array?r.append(t[i].buffer):r.append(t[i]);var a=r.getBlob(n);return!a.slice&&a.webkitSlice&&(a.slice=a.webkitSlice),a};var e=Object.getPrototypeOf||function(t){return t.__proto__};t.Blob.prototype=e(new t.Blob)}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||window.content||window);var tt,et,nt,rt,it,ot,at,st,ht,ct,lt,ut,ft,dt,pt,gt,bt=bt||function(s){if(!(void 0===s||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var t=s.document,h=function(){return s.URL||s.webkitURL||s},c=t.createElementNS("http://www.w3.org/1999/xhtml","a"),l="download"in c,u=/constructor/i.test(s.HTMLElement)||s.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),d=function(t){(s.setImmediate||s.setTimeout)(function(){throw t},0)},p=function(t){setTimeout(function(){"string"==typeof t?h().revokeObjectURL(t):t.remove()},4e4)},g=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},r=function(t,n,e){e||(t=g(t));var r,i=this,o="application/octet-stream"===t.type,a=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){d(t)}}}(i,"writestart progress write writeend".split(" "))};if(i.readyState=i.INIT,l)return r=h().createObjectURL(t),void setTimeout(function(){var t,e;c.href=r,c.download=n,t=c,e=new MouseEvent("click"),t.dispatchEvent(e),a(),p(r),i.readyState=i.DONE});!function(){if((f||o&&u)&&s.FileReader){var e=new FileReader;return e.onloadend=function(){var t=f?e.result:e.result.replace(/^data:[^;]*;/,"data:attachment/file;");s.open(t,"_blank")||(s.location.href=t),t=void 0,i.readyState=i.DONE,a()},e.readAsDataURL(t),i.readyState=i.INIT}r||(r=h().createObjectURL(t)),o?s.location.href=r:s.open(r,"_blank")||(s.location.href=r);i.readyState=i.DONE,a(),p(r)}()},e=r.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=g(t)),navigator.msSaveOrOpenBlob(t,e)}:(e.abort=function(){},e.readyState=e.INIT=0,e.WRITING=1,e.DONE=2,e.error=e.onwritestart=e.onprogress=e.onwrite=e.onabort=e.onerror=e.onwriteend=null,function(t,e,n){return new r(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||window.content);function mt(x){var t=0;if(71!==x[t++]||73!==x[t++]||70!==x[t++]||56!==x[t++]||56!=(x[t++]+1&253)||97!==x[t++])throw"Invalid GIF 87a/89a header.";var S=x[t++]|x[t++]<<8,e=x[t++]|x[t++]<<8,n=x[t++],r=n>>7,i=1<<(7&n)+1;x[t++];x[t++];var o=null;r&&(o=t,t+=3*i);var a=!0,s=[],h=0,c=null,l=0,u=null;for(this.width=S,this.height=e;a&&t<x.length;)switch(x[t++]){case 33:switch(x[t++]){case 255:if(11!==x[t]||78==x[t+1]&&69==x[t+2]&&84==x[t+3]&&83==x[t+4]&&67==x[t+5]&&65==x[t+6]&&80==x[t+7]&&69==x[t+8]&&50==x[t+9]&&46==x[t+10]&&48==x[t+11]&&3==x[t+12]&&1==x[t+13]&&0==x[t+16])t+=14,u=x[t++]|x[t++]<<8,t++;else for(t+=12;;){if(0===(_=x[t++]))break;t+=_}break;case 249:if(4!==x[t++]||0!==x[t+4])throw"Invalid graphics extension block.";var f=x[t++];h=x[t++]|x[t++]<<8,c=x[t++],0==(1&f)&&(c=null),l=f>>2&7,t++;break;case 254:for(;;){if(0===(_=x[t++]))break;t+=_}break;default:throw"Unknown graphic control label: 0x"+x[t-1].toString(16)}break;case 44:var d=x[t++]|x[t++]<<8,p=x[t++]|x[t++]<<8,g=x[t++]|x[t++]<<8,m=x[t++]|x[t++]<<8,w=x[t++],y=w>>6&1,v=o,b=!1;if(w>>7){b=!0;v=t,t+=3*(1<<(7&w)+1)}var k=t;for(t++;;){var _;if(0===(_=x[t++]))break;t+=_}s.push({x:d,y:p,width:g,height:m,has_local_palette:b,palette_offset:v,data_offset:k,data_length:t-k,transparent_index:c,interlaced:!!y,delay:h,disposal:l});break;case 59:a=!1;break;default:throw"Unknown gif block: 0x"+x[t-1].toString(16)}this.numFrames=function(){return s.length},this.loopCount=function(){return u},this.frameInfo=function(t){if(t<0||t>=s.length)throw"Frame index out of range.";return s[t]},this.decodeAndBlitFrameBGRA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);wt(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,h=S-s,c=s,l=4*(n.y*S+n.x),u=4*((n.y+n.height)*S+n.x),f=l,d=4*h;!0===n.interlaced&&(d+=4*(s+h)*7);for(var p=8,g=0,m=i.length;g<m;++g){var w=i[g];if(0===c&&(c=s,u<=(f+=d)&&(d=h+4*(s+h)*(p-1),f=l+(s+h)*(p<<1),p>>=1)),w===a)f+=4;else{var y=x[o+3*w],v=x[o+3*w+1],b=x[o+3*w+2];e[f++]=b,e[f++]=v,e[f++]=y,e[f++]=255}--c}},this.decodeAndBlitFrameRGBA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);wt(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,h=S-s,c=s,l=4*(n.y*S+n.x),u=4*((n.y+n.height)*S+n.x),f=l,d=4*h;!0===n.interlaced&&(d+=4*(s+h)*7);for(var p=8,g=0,m=i.length;g<m;++g){var w=i[g];if(0===c&&(c=s,u<=(f+=d)&&(d=h+4*(s+h)*(p-1),f=l+(s+h)*(p<<1),p>>=1)),w===a)f+=4;else{var y=x[o+3*w],v=x[o+3*w+1],b=x[o+3*w+2];e[f++]=y,e[f++]=v,e[f++]=b,e[f++]=255}--c}}}function wt(t,e,n,r){for(var i=t[e++],o=1<<i,a=o+1,s=a+1,h=i+1,c=(1<<h)-1,l=0,u=0,f=0,d=t[e++],p=new Int32Array(4096),g=null;;){for(;l<16&&0!==d;)u|=t[e++]<<l,l+=8,1===d?d=t[e++]:--d;if(l<h)break;var m=u&c;if(u>>=h,l-=h,m!==o){if(m===a)break;for(var w=m<s?m:g,y=0,v=w;o<v;)v=p[v]>>8,++y;var b=v;if(r<f+y+(w!==m?1:0))return void console.log("Warning, gif stream longer than expected.");n[f++]=b;var x=f+=y;for(w!==m&&(n[f++]=b),v=w;y--;)v=p[v],n[--x]=255&v,v>>=8;null!==g&&s<4096&&(p[s++]=g<<8|b,c+1<=s&&h<12&&(++h,c=c<<1|1)),g=m}else s=a+1,c=(1<<(h=i+1))-1,g=null}return f!==r&&console.log("Warning, gif stream shorter than expected."),n}"undefined"!=typeof module&&module.exports?module.exports.saveAs=bt:"undefined"!="function"&&null!==__webpack_require__(310)&&null!==__webpack_require__(311)&&!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return bt}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
/*
   * Copyright (c) 2012 chick307 <chick307@gmail.com>
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */,$.API.adler32cs=(ot="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,at=null,st=function(){if(!ot)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(at=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==at&&t instanceof at}}(),ht=null!==at?function(t){return new at(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},ct=65521,lt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+(255&e.charCodeAt(i)))%ct,r=(r+n)%ct;return(r<<16|n)>>>0},ut=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+e[i])%ct,r=(r+n)%ct;return(r<<16|n)>>>0},dt=(ft={}).Adler32=(((it=(rt=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0}).prototype={}).constructor=rt).from=((tt=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=lt(1,t.toString())}).prototype=it,tt),rt.fromUtf8=((et=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var e=ht(t.toString());this.checksum=lt(1,e)}).prototype=it,et),ot&&(rt.fromBuffer=((nt=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(!st(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=ut(1,e)}).prototype=it,nt)),it.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=lt(this.checksum,t)},it.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=ht(t.toString());return this.checksum=lt(this.checksum,e)},ot&&(it.updateBuffer=function(t){if(!st(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=ut(this.checksum,e)}),it.clone=function(){return new dt(this.checksum)},rt),ft.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return lt(1,t.toString())},ft.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=ht(t.toString());return lt(1,e)},ot&&(ft.fromBuffer=function(t){if(!st(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return ut(1,e)}),ft);try{exports.GifWriter=function(w,t,e,n){var y=0,r=void 0===(n=void 0===n?{}:n).loop?null:n.loop,v=void 0===n.palette?null:n.palette;if(t<=0||e<=0||65535<t||65535<e)throw"Width/Height invalid.";function b(t){var e=t.length;if(e<2||256<e||e&e-1)throw"Invalid code/color length, must be power of 2 and 2 .. 256.";return e}w[y++]=71,w[y++]=73,w[y++]=70,w[y++]=56,w[y++]=57,w[y++]=97;var i=0,o=0;if(null!==v){for(var a=b(v);a>>=1;)++i;if(a=1<<i,--i,void 0!==n.background){if(a<=(o=n.background))throw"Background index out of range.";if(0===o)throw"Background index explicitly passed as 0."}}if(w[y++]=255&t,w[y++]=t>>8&255,w[y++]=255&e,w[y++]=e>>8&255,w[y++]=(null!==v?128:0)|i,w[y++]=o,w[y++]=0,null!==v)for(var s=0,h=v.length;s<h;++s){var c=v[s];w[y++]=c>>16&255,w[y++]=c>>8&255,w[y++]=255&c}if(null!==r){if(r<0||65535<r)throw"Loop count invalid.";w[y++]=33,w[y++]=255,w[y++]=11,w[y++]=78,w[y++]=69,w[y++]=84,w[y++]=83,w[y++]=67,w[y++]=65,w[y++]=80,w[y++]=69,w[y++]=50,w[y++]=46,w[y++]=48,w[y++]=3,w[y++]=1,w[y++]=255&r,w[y++]=r>>8&255,w[y++]=0}var x=!1;this.addFrame=function(t,e,n,r,i,o){if(!0===x&&(--y,x=!1),o=void 0===o?{}:o,t<0||e<0||65535<t||65535<e)throw"x/y invalid.";if(n<=0||r<=0||65535<n||65535<r)throw"Width/Height invalid.";if(i.length<n*r)throw"Not enough pixels for the frame size.";var a=!0,s=o.palette;if(null==s&&(a=!1,s=v),null==s)throw"Must supply either a local or global palette.";for(var h=b(s),c=0;h>>=1;)++c;h=1<<c;var l=void 0===o.delay?0:o.delay,u=void 0===o.disposal?0:o.disposal;if(u<0||3<u)throw"Disposal out of range.";var f=!1,d=0;if(void 0!==o.transparent&&null!==o.transparent&&(f=!0,(d=o.transparent)<0||h<=d))throw"Transparent color index.";if((0!==u||f||0!==l)&&(w[y++]=33,w[y++]=249,w[y++]=4,w[y++]=u<<2|(!0===f?1:0),w[y++]=255&l,w[y++]=l>>8&255,w[y++]=d,w[y++]=0),w[y++]=44,w[y++]=255&t,w[y++]=t>>8&255,w[y++]=255&e,w[y++]=e>>8&255,w[y++]=255&n,w[y++]=n>>8&255,w[y++]=255&r,w[y++]=r>>8&255,w[y++]=!0===a?128|c-1:0,!0===a)for(var p=0,g=s.length;p<g;++p){var m=s[p];w[y++]=m>>16&255,w[y++]=m>>8&255,w[y++]=255&m}y=function(e,n,t,r){e[n++]=t;var i=n++,o=1<<t,a=o-1,s=o+1,h=s+1,c=t+1,l=0,u=0;function f(t){for(;t<=l;)e[n++]=255&u,u>>=8,l-=8,n===i+256&&(e[i]=255,i=n++)}function d(t){u|=t<<l,l+=c,f(8)}var p=r[0]&a,g={};d(o);for(var m=1,w=r.length;m<w;++m){var y=r[m]&a,v=p<<8|y,b=g[v];if(void 0===b){for(u|=p<<l,l+=c;8<=l;)e[n++]=255&u,u>>=8,l-=8,n===i+256&&(e[i]=255,i=n++);4096===h?(d(o),h=s+1,c=t+1,g={}):(1<<c<=h&&++c,g[v]=h++),p=y}else p=b}return d(p),d(s),f(1),i+1===n?e[i]=0:(e[i]=n-i-1,e[n++]=0),n}(w,y,c<2?2:c,i)},this.end=function(){return!1===x&&(w[y++]=59,x=!0),y}},exports.GifReader=mt}catch(t){}
/*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */function yt(t){var S,k,_,A,e,u=Math.floor,I=new Array(64),C=new Array(64),T=new Array(64),F=new Array(64),w=new Array(65535),y=new Array(65535),Q=new Array(64),v=new Array(64),P=[],E=0,q=7,O=new Array(64),B=new Array(64),R=new Array(64),n=new Array(256),j=new Array(2048),b=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],D=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],M=[0,1,2,3,4,5,6,7,8,9,10,11],U=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],N=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],z=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],L=[0,1,2,3,4,5,6,7,8,9,10,11],H=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],W=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function r(t,e){for(var n=0,r=0,i=new Array,o=1;o<=16;o++){for(var a=1;a<=t[o];a++)i[e[r]]=[],i[e[r]][0]=n,i[e[r]][1]=o,r++,n++;n*=2}return i}function G(t){for(var e=t[0],n=t[1]-1;0<=n;)e&1<<n&&(E|=1<<q),n--,--q<0&&(255==E?(V(255),V(0)):V(E),q=7,E=0)}function V(t){P.push(t)}function Y(t){V(t>>8&255),V(255&t)}function X(t,e,n,r,i){for(var o,a=i[0],s=i[240],h=function(t,e){var n,r,i,o,a,s,h,c,l,u,f=0;for(l=0;l<8;++l){n=t[f],r=t[f+1],i=t[f+2],o=t[f+3],a=t[f+4],s=t[f+5],h=t[f+6];var d=n+(c=t[f+7]),p=n-c,g=r+h,m=r-h,w=i+s,y=i-s,v=o+a,b=o-a,x=d+v,S=d-v,k=g+w,_=g-w;t[f]=x+k,t[f+4]=x-k;var A=.707106781*(_+S);t[f+2]=S+A,t[f+6]=S-A;var I=.382683433*((x=b+y)-(_=m+p)),C=.5411961*x+I,T=1.306562965*_+I,F=.707106781*(k=y+m),P=p+F,E=p-F;t[f+5]=E+C,t[f+3]=E-C,t[f+1]=P+T,t[f+7]=P-T,f+=8}for(l=f=0;l<8;++l){n=t[f],r=t[f+8],i=t[f+16],o=t[f+24],a=t[f+32],s=t[f+40],h=t[f+48];var q=n+(c=t[f+56]),O=n-c,B=r+h,R=r-h,j=i+s,D=i-s,M=o+a,U=o-a,N=q+M,z=q-M,L=B+j,H=B-j;t[f]=N+L,t[f+32]=N-L;var W=.707106781*(H+z);t[f+16]=z+W,t[f+48]=z-W;var G=.382683433*((N=U+D)-(H=R+O)),V=.5411961*N+G,Y=1.306562965*H+G,X=.707106781*(L=D+R),J=O+X,K=O-X;t[f+40]=K+V,t[f+24]=K-V,t[f+8]=J+Y,t[f+56]=J-Y,f++}for(l=0;l<64;++l)u=t[l]*e[l],Q[l]=0<u?u+.5|0:u-.5|0;return Q}(t,e),c=0;c<64;++c)v[b[c]]=h[c];var l=v[0]-n;n=v[0],0==l?G(r[0]):(G(r[y[o=32767+l]]),G(w[o]));for(var u=63;0<u&&0==v[u];u--);if(0==u)return G(a),n;for(var f,d=1;d<=u;){for(var p=d;0==v[d]&&d<=u;++d);var g=d-p;if(16<=g){f=g>>4;for(var m=1;m<=f;++m)G(s);g&=15}o=32767+v[d],G(i[(g<<4)+y[o]]),G(w[o]),d++}return 63!=u&&G(a),n}function J(t){if(t<=0&&(t=1),100<t&&(t=100),e!=t){(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],n=0;n<64;n++){var r=u((e[n]*t+50)/100);r<1?r=1:255<r&&(r=255),I[b[n]]=r}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],o=0;o<64;o++){var a=u((i[o]*t+50)/100);a<1?a=1:255<a&&(a=255),C[b[o]]=a}for(var s=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],h=0,c=0;c<8;c++)for(var l=0;l<8;l++)T[h]=1/(I[b[h]]*s[c]*s[l]*8),F[h]=1/(C[b[h]]*s[c]*s[l]*8),h++})(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),e=t}}this.encode=function(t,e){var n,r;(new Date).getTime();e&&J(e),P=new Array,E=0,q=7,Y(65496),Y(65504),Y(16),V(74),V(70),V(73),V(70),V(0),V(1),V(1),V(0),Y(1),Y(1),V(0),V(0),function(){Y(65499),Y(132),V(0);for(var t=0;t<64;t++)V(I[t]);V(1);for(var e=0;e<64;e++)V(C[e])}(),n=t.width,r=t.height,Y(65472),Y(17),V(8),Y(r),Y(n),V(3),V(1),V(17),V(0),V(2),V(17),V(1),V(3),V(17),V(1),function(){Y(65476),Y(418),V(0);for(var t=0;t<16;t++)V(D[t+1]);for(var e=0;e<=11;e++)V(M[e]);V(16);for(var n=0;n<16;n++)V(U[n+1]);for(var r=0;r<=161;r++)V(N[r]);V(1);for(var i=0;i<16;i++)V(z[i+1]);for(var o=0;o<=11;o++)V(L[o]);V(17);for(var a=0;a<16;a++)V(H[a+1]);for(var s=0;s<=161;s++)V(W[s])}(),Y(65498),Y(12),V(3),V(1),V(0),V(2),V(17),V(3),V(17),V(0),V(63),V(0);var i=0,o=0,a=0;E=0,q=7,this.encode.displayName="_encode_";for(var s,h,c,l,u,f,d,p,g,m=t.data,w=t.width,y=t.height,v=4*w,b=0;b<y;){for(s=0;s<v;){for(f=u=v*b+s,d=-1,g=p=0;g<64;g++)f=u+(p=g>>3)*v+(d=4*(7&g)),y<=b+p&&(f-=v*(b+1+p-y)),v<=s+d&&(f-=s+d-v+4),h=m[f++],c=m[f++],l=m[f++],O[g]=(j[h]+j[c+256>>0]+j[l+512>>0]>>16)-128,B[g]=(j[h+768>>0]+j[c+1024>>0]+j[l+1280>>0]>>16)-128,R[g]=(j[h+1280>>0]+j[c+1536>>0]+j[l+1792>>0]>>16)-128;i=X(O,T,i,S,_),o=X(B,F,o,k,A),a=X(R,F,a,k,A),s+=32}b+=8}if(0<=q){var x=[];x[1]=q+1,x[0]=(1<<q+1)-1,G(x)}return Y(65497),new Uint8Array(P)},function(){(new Date).getTime();t||(t=50),function(){for(var t=String.fromCharCode,e=0;e<256;e++)n[e]=t(e)}(),S=r(D,M),k=r(z,L),_=r(U,N),A=r(H,W),function(){for(var t=1,e=2,n=1;n<=15;n++){for(var r=t;r<e;r++)y[32767+r]=n,w[32767+r]=[],w[32767+r][1]=n,w[32767+r][0]=r;for(var i=-(e-1);i<=-t;i++)y[32767+i]=n,w[32767+i]=[],w[32767+i][1]=n,w[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)j[t]=19595*t,j[t+256>>0]=38470*t,j[t+512>>0]=7471*t+32768,j[t+768>>0]=-11059*t,j[t+1024>>0]=-21709*t,j[t+1280>>0]=32768*t+8421375,j[t+1536>>0]=-27439*t,j[t+1792>>0]=-5329*t}(),J(t),(new Date).getTime()}()}try{module.exports=yt}catch(t){}function xt(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}xt.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var n=this.datav.getUint8(this.pos++,!0),r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:r,blue:n,quad:o}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},xt.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){console.log("bit decode error:"+t)}},xt.prototype.bit1=function(){var t=Math.ceil(this.width/8),e=t%4,n=0<=this.height?this.height-1:-this.height;for(n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++)for(var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var h=this.palette[o>>7-s&1];this.data[a+4*s]=h.blue,this.data[a+4*s+1]=h.green,this.data[a+4*s+2]=h.red,this.data[a+4*s+3]=255}0!=e&&(this.pos+=4-e)}},xt.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++){var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+2*i*4,s=o>>4,h=15&o,c=this.palette[s];if(this.data[a]=c.blue,this.data[a+1]=c.green,this.data[a+2]=c.red,this.data[a+3]=255,2*i+1>=this.width)break;c=this.palette[h],this.data[a+4]=c.blue,this.data[a+4+1]=c.green,this.data[a+4+2]=c.red,this.data[a+4+3]=255}0!=e&&(this.pos+=4-e)}},xt.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;0<=e;e--){for(var n=this.bottom_up?e:this.height-1-e,r=0;r<this.width;r++){var i=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+4*r;if(i<this.palette.length){var a=this.palette[i];this.data[o]=a.red,this.data[o+1]=a.green,this.data[o+2]=a.blue,this.data[o+3]=255}else this.data[o]=255,this.data[o+1]=255,this.data[o+2]=255,this.data[o+3]=255}0!=t&&(this.pos+=4-t)}},xt.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<this.width;i++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var a=(o&e)/e*255|0,s=(o>>5&e)/e*255|0,h=(o>>10&e)/e*255|0,c=o>>15?255:0,l=r*this.width*4+4*i;this.data[l]=h,this.data[l+1]=s,this.data[l+2]=a,this.data[l+3]=c}this.pos+=t}},xt.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),n=parseInt("111111",2),r=this.height-1;0<=r;r--){for(var i=this.bottom_up?r:this.height-1-r,o=0;o<this.width;o++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(a&e)/e*255|0,h=(a>>5&n)/n*255|0,c=(a>>11)/e*255|0,l=i*this.width*4+4*o;this.data[l]=c,this.data[l+1]=h,this.data[l+2]=s,this.data[l+3]=255}this.pos+=t}},xt.prototype.bit24=function(){for(var t=this.height-1;0<=t;t--){for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=e*this.width*4+4*n;this.data[a]=o,this.data[a+1]=i,this.data[a+2]=r,this.data[a+3]=255}this.pos+=this.width%4}},xt.prototype.bit32=function(){for(var t=this.height-1;0<=t;t--)for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*n;this.data[s]=o,this.data[s+1]=i,this.data[s+2]=r,this.data[s+3]=a}},xt.prototype.getData=function(){return this.data};try{module.exports=function(t){var e=new xt(t);return{data:e.getData(),width:e.width,height:e.height}}}catch(t){}
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
!function(t){var p=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ut(){var d=this;function h(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}d.build_tree=function(t){var e,n,r,i=d.dyn_tree,o=d.stat_desc.static_tree,a=d.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<a;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,o&&(t.static_len-=o[2*r+1]);for(d.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=a;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,o,a,s=d.dyn_tree,h=d.stat_desc.static_tree,c=d.stat_desc.extra_bits,l=d.stat_desc.extra_base,u=d.stat_desc.max_length,f=0;for(i=0;i<=p;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)u<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=u,f++),s[2*n+1]=i,n>d.max_code||(t.bl_count[i]++,o=0,l<=n&&(o=c[n-l]),a=s[2*n],t.opt_len+=a*(i+o),h&&(t.static_len+=a*(h[2*n+1]+o)));if(0!==f){do{for(i=u-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[u]--,f-=2}while(0<f);for(i=u;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>d.max_code||(s[2*r+1]!=i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,o,a=[],s=0;for(r=1;r<=p;r++)a[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(o=t[2*i+1])&&(t[2*i]=h(a[o]++,o))}(i,d.max_code,t.bl_count)}}function ft(t,e,n,r,i){var o=this;o.static_tree=t,o.extra_bits=e,o.extra_base=n,o.elems=r,o.max_length=i}ut._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ut.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ut.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ut.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ut.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ut.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ut.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ut.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ut.extra_lbits,257,286,p),ft.static_d_desc=new ft(ft.static_dtree,ut.extra_dbits,0,30,p),ft.static_bl_desc=new ft(null,ut.extra_blbits,0,19,7);function n(t,e,n,r,i){var o=this;o.good_length=t,o.max_lazy=e,o.nice_length=n,o.max_chain=r,o.func=i}var dt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],pt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""],gt=262;function mt(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function r(){var h,c,l,u,f,d,p,g,i,m,w,y,v,a,b,x,S,k,_,A,I,C,T,F,P,E,q,O,B,R,s,j,D,M,U,N,z,o,L,H,W,G=this,V=new ut,Y=new ut,X=new ut;function J(){var t;for(t=0;t<286;t++)s[2*t]=0;for(t=0;t<30;t++)j[2*t]=0;for(t=0;t<19;t++)D[2*t]=0;s[512]=1,G.opt_len=G.static_len=0,N=o=0}function K(t,e){var n,r,i=-1,o=t[1],a=0,s=7,h=4;for(0===o&&(s=138,h=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<h?D[2*r]+=a:0!==r?(r!=i&&D[2*r]++,D[32]++):a<=10?D[34]++:D[36]++,i=r,(a=0)===o?(s=138,h=3):r==o?(s=6,h=3):(s=7,h=4))}function Q(t){G.pending_buf[G.pending++]=t}function Z(t){Q(255&t),Q(t>>>8&255)}function $(t,e){var n,r=e;16-r<W?(Z(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;$(65535&e[n],65535&e[n+1])}function et(t,e){var n,r,i=-1,o=t[1],a=0,s=7,h=4;for(0===o&&(s=138,h=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<h)for(;tt(r,D),0!=--a;);else 0!==r?(r!=i&&(tt(r,D),a--),tt(16,D),$(a-3,2)):a<=10?(tt(17,D),$(a-3,3)):(tt(18,D),$(a-11,7));i=r,(a=0)===o?(s=138,h=3):r==o?(s=6,h=3):(s=7,h=4)}}function nt(){16==W?(Z(H),W=H=0):8<=W&&(Q(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(G.pending_buf[z+2*N]=t>>>8&255,G.pending_buf[z+2*N+1]=255&t,G.pending_buf[M+N]=255&e,N++,0===t?s[2*e]++:(o++,t--,s[2*(ut._length_code[e]+256+1)]++,j[2*ut.d_code(t)]++),0==(8191&N)&&2<q){for(n=8*N,r=I-S,i=0;i<30;i++)n+=j[2*i]*(5+ut.extra_dbits[i]);if(n>>>=3,o<Math.floor(N/2)&&n<Math.floor(r/2))return!0}return N==U-1}function it(t,e){var n,r,i,o,a=0;if(0!==N)for(;n=G.pending_buf[z+2*a]<<8&65280|255&G.pending_buf[z+2*a+1],r=255&G.pending_buf[M+a],a++,0===n?tt(r,t):(tt((i=ut._length_code[r])+256+1,t),0!==(o=ut.extra_lbits[i])&&$(r-=ut.base_length[i],o),tt(i=ut.d_code(--n),e),0!==(o=ut.extra_dbits[i])&&$(n-=ut.base_dist[i],o)),a<N;);tt(256,t),L=t[513]}function ot(){8<W?Z(H):0<W&&Q(255&H),W=H=0}function at(t,e,n){var r,i,o;$(0+(n?1:0),3),r=t,i=e,o=!0,ot(),L=8,o&&(Z(i),Z(~i)),G.pending_buf.set(g.subarray(r,r+i),G.pending),G.pending+=i}function e(t,e,n){var r,i,o=0;0<q?(V.build_tree(G),Y.build_tree(G),o=function(){var t;for(K(s,V.max_code),K(j,Y.max_code),X.build_tree(G),t=18;3<=t&&0===D[2*ut.bl_order[t]+1];t--);return G.opt_len+=3*(t+1)+5+5+4,t}(),r=G.opt_len+3+7>>>3,(i=G.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!=t?at(t,e,n):i==r?($(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):($(4+(n?1:0),3),function(t,e,n){var r;for($(t-257,5),$(e-1,5),$(n-4,4),r=0;r<n;r++)$(D[2*ut.bl_order[r]+1],3);et(s,t-1),et(j,e-1)}(V.max_code+1,Y.max_code+1,o+1),it(s,j)),J(),n&&ot()}function st(t){e(0<=S?S:-1,I-S,t),S=I,h.flush_pending()}function ht(){var t,e,n,r;do{if(0===(r=i-T-I)&&0===I&&0===T)r=f;else if(-1==r)r--;else if(f+f-gt<=I){for(g.set(g.subarray(f,f+f),0),C-=f,I-=f,S-=f,n=t=v;e=65535&w[--n],w[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===h.avail_in)return;t=h.read_buf(g,I+T,r),3<=(T+=t)&&(y=((y=255&g[I])<<x^255&g[I+1])&b)}while(T<gt&&0!==h.avail_in)}function ct(t){var e,n,r=P,i=I,o=F,a=f-gt<I?I-(f-gt):0,s=R,h=p,c=I+258,l=g[i+o-1],u=g[i+o];B<=F&&(r>>=2),T<s&&(s=T);do{if(g[(e=t)+o]==u&&g[e+o-1]==l&&g[e]==g[i]&&g[++e]==g[i+1]){i+=2,e++;do{}while(g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&i<c);if(n=258-(c-i),i=c-258,o<n){if(C=t,s<=(o=n))break;l=g[i+o-1],u=g[i+o]}}}while((t=65535&m[t&h])>a&&0!=--r);return o<=T?o:T}function lt(t){return t.total_in=t.total_out=0,t.msg=null,G.pending=0,G.pending_out=0,c=113,u=0,V.dyn_tree=s,V.stat_desc=ft.static_l_desc,Y.dyn_tree=j,Y.stat_desc=ft.static_d_desc,X.dyn_tree=D,X.stat_desc=ft.static_bl_desc,W=H=0,L=8,J(),function(){var t;for(i=2*f,t=w[v-1]=0;t<v-1;t++)w[t]=0;E=dt[q].max_lazy,B=dt[q].good_length,R=dt[q].nice_length,P=dt[q].max_chain,k=F=2,y=A=T=S=I=0}(),0}G.depth=[],G.bl_count=[],G.heap=[],s=[],j=[],D=[],G.pqdownheap=function(t,e){for(var n=G.heap,r=n[e],i=e<<1;i<=G.heap_len&&(i<G.heap_len&&mt(t,n[i+1],n[i],G.depth)&&i++,!mt(t,r,n[i],G.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},G.deflateInit=function(t,e,n,r,i,o){return r||(r=8),i||(i=8),o||(o=0),t.msg=null,-1==e&&(e=6),i<1||9<i||8!=r||n<9||15<n||e<0||9<e||o<0||2<o?-2:(t.dstate=G,p=(f=1<<(d=n))-1,b=(v=1<<(a=i+7))-1,x=Math.floor((a+3-1)/3),g=new Uint8Array(2*f),m=[],w=[],U=1<<i+6,G.pending_buf=new Uint8Array(4*U),l=4*U,z=Math.floor(U/2),M=3*U,q=e,O=o,lt(t))},G.deflateEnd=function(){return 42!=c&&113!=c&&666!=c?-2:(G.pending_buf=null,g=m=w=null,G.dstate=null,113==c?-3:0)},G.deflateParams=function(t,e,n){var r=0;return-1==e&&(e=6),e<0||9<e||n<0||2<n?-2:(dt[q].func!=dt[e].func&&0!==t.total_in&&(r=t.deflate(1)),q!=e&&(E=dt[q=e].max_lazy,B=dt[q].good_length,R=dt[q].nice_length,P=dt[q].max_chain),O=n,r)},G.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||42!=c)return-2;if(i<3)return 0;for(f-gt<i&&(o=n-(i=f-gt)),g.set(e.subarray(o,o+i),0),S=I=i,y=((y=255&g[0])<<x^255&g[1])&b,r=0;r<=i-3;r++)y=(y<<x^255&g[r+2])&b,m[r&p]=w[y],w[y]=r;return 0},G.deflate=function(t,e){var n,r,i,o,a,s;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666==c&&4!=e)return t.msg=pt[4],-2;if(0===t.avail_out)return t.msg=pt[7],-5;if(h=t,o=u,u=e,42==c&&(r=8+(d-8<<4)<<8,3<(i=(q-1&255)>>1)&&(i=3),r|=i<<6,0!==I&&(r|=32),c=113,Q((s=r+=31-r%31)>>8&255),Q(255&s)),0!==G.pending){if(h.flush_pending(),0===h.avail_out)return u=-1,0}else if(0===h.avail_in&&e<=o&&4!=e)return h.msg=pt[7],-5;if(666==c&&0!==h.avail_in)return t.msg=pt[7],-5;if(0!==h.avail_in||0!==T||0!=e&&666!=c){switch(a=-1,dt[q].func){case 0:a=function(t){var e,n=65535;for(l-5<n&&(n=l-5);;){if(T<=1){if(ht(),0===T&&0==t)return 0;if(0===T)break}if(I+=T,e=S+n,((T=0)===I||e<=I)&&(T=I-e,I=e,st(!1),0===h.avail_out))return 0;if(f-gt<=I-S&&(st(!1),0===h.avail_out))return 0}return st(4==t),0===h.avail_out?4==t?2:0:4==t?3:1}(e);break;case 1:a=function(t){for(var e,n=0;;){if(T<gt){if(ht(),T<gt&&0==t)return 0;if(0===T)break}if(3<=T&&(y=(y<<x^255&g[I+2])&b,n=65535&w[y],m[I&p]=w[y],w[y]=I),0!==n&&(I-n&65535)<=f-gt&&2!=O&&(k=ct(n)),3<=k)if(e=rt(I-C,k-3),T-=k,k<=E&&3<=T){for(k--;y=(y<<x^255&g[++I+2])&b,n=65535&w[y],m[I&p]=w[y],w[y]=I,0!=--k;);I++}else I+=k,k=0,y=((y=255&g[I])<<x^255&g[I+1])&b;else e=rt(0,255&g[I]),T--,I++;if(e&&(st(!1),0===h.avail_out))return 0}return st(4==t),0===h.avail_out?4==t?2:0:4==t?3:1}(e);break;case 2:a=function(t){for(var e,n,r=0;;){if(T<gt){if(ht(),T<gt&&0==t)return 0;if(0===T)break}if(3<=T&&(y=(y<<x^255&g[I+2])&b,r=65535&w[y],m[I&p]=w[y],w[y]=I),F=k,_=C,k=2,0!==r&&F<E&&(I-r&65535)<=f-gt&&(2!=O&&(k=ct(r)),k<=5&&(1==O||3==k&&4096<I-C)&&(k=2)),3<=F&&k<=F){for(n=I+T-3,e=rt(I-1-_,F-3),T-=F-1,F-=2;++I<=n&&(y=(y<<x^255&g[I+2])&b,r=65535&w[y],m[I&p]=w[y],w[y]=I),0!=--F;);if(A=0,k=2,I++,e&&(st(!1),0===h.avail_out))return 0}else if(0!==A){if((e=rt(0,255&g[I-1]))&&st(!1),I++,T--,0===h.avail_out)return 0}else A=1,I++,T--}return 0!==A&&(e=rt(0,255&g[I-1]),A=0),st(4==t),0===h.avail_out?4==t?2:0:4==t?3:1}(e)}if(2!=a&&3!=a||(c=666),0==a||2==a)return 0===h.avail_out&&(u=-1),0;if(1==a){if(1==e)$(2,3),tt(256,ft.static_ltree),nt(),1+L+10-W<9&&($(2,3),tt(256,ft.static_ltree),nt()),L=7;else if(at(0,0,!1),3==e)for(n=0;n<v;n++)w[n]=0;if(h.flush_pending(),0===h.avail_out)return u=-1,0}}return 4!=e?0:1}}function i(){var t=this;t.next_in_index=0,t.next_out_index=0,t.avail_in=0,t.total_in=0,t.avail_out=0,t.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=p),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this,i=r.avail_in;return n<i&&(i=n),0===i?0:(r.avail_in-=i,t.set(r.next_in.subarray(r.next_in_index,r.next_in_index+i),e),r.next_in_index+=i,r.total_in+=i,i)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var o=t.zip||t;o.Deflater=o._jzlib_Deflater=function(t){var s=new i,h=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=h,this.append=function(t,e){var n,r=[],i=0,o=0,a=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!=s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512==s.next_out_index?r.push(new Uint8Array(h)):r.push(new Uint8Array(h.subarray(0,s.next_out_index)))),a+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!=i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(a),r.forEach(function(t){n.set(t,o),o+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!=(t=s.deflate(4))&&0!=t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(h.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
/**
   * A class to parse color values
   * @author Stoyan Stefanov <sstoo@gmail.com>
   * @link   http://www.phpied.com/rgb-color-parser-in-javascript/
   * @license Use it if you like it
   */
function(t){function f(t){var e;this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6)),t=(t=t.replace(/ /g,"")).toLowerCase();var l={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"};for(var n in l)t==n&&(t=l[n]);for(var u=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],r=0;r<u.length;r++){var i=u[r].re,o=u[r].process,a=i.exec(t);a&&(e=o(a),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:255<this.r?255:this.r,this.g=this.g<0||isNaN(this.g)?0:255<this.g?255:this.g,this.b=this.b<0||isNaN(this.b)?0:255<this.b?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),n=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==n.length&&(n="0"+n),"#"+t+e+n},this.getHelpXML=function(){for(var t=new Array,e=0;e<u.length;e++)for(var n=u[e].example,r=0;r<n.length;r++)t[t.length]=n[r];for(var i in l)t[t.length]=i;var o=document.createElement("ul");o.setAttribute("id","rgbcolor-examples");for(e=0;e<t.length;e++)try{var a=document.createElement("li"),s=new f(t[e]),h=document.createElement("div");h.style.cssText="margin: 3px; border: 1px solid black; background:"+s.toHex()+"; color:"+s.toHex(),h.appendChild(document.createTextNode("test"));var c=document.createTextNode(" "+t[e]+" -> "+s.toRGB()+" -> "+s.toHex());a.appendChild(h),a.appendChild(c),o.appendChild(a)}catch(t){}return o}} true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return f}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports&&(module.exports=f),t.RGBColor=f}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),function(t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.html2canvas=t()}}(function(){return function o(a,s,h){function c(n,t){if(!s[n]){if(!a[n]){var e="function"==typeof require&&require;if(!t&&e)return require(n,!0);if(l)return l(n,!0);var r=new Error("Cannot find module '"+n+"'");throw r.code="MODULE_NOT_FOUND",r}var i=s[n]={exports:{}};a[n][0].call(i.exports,function(t){var e=a[n][1][t];return c(e||t)},i,i.exports,o,a,s,h)}return s[n].exports}for(var l="function"==typeof require&&require,t=0;t<h.length;t++)c(h[t]);return c}({1:[function(t,q,O){(function(E){!function(t){var e="object"==typeof O&&O,n="object"==typeof q&&q&&q.exports==e&&q,r="object"==typeof E&&E;r.global!==r&&r.window!==r||(t=r);var i,o,w=2147483647,y=36,v=1,b=26,a=38,s=700,x=72,S=128,k="-",h=/^xn--/,c=/[^ -~]/,l=/\x2E|\u3002|\uFF0E|\uFF61/g,u={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},f=y-v,_=Math.floor,A=String.fromCharCode;function I(t){throw RangeError(u[t])}function d(t,e){for(var n=t.length;n--;)t[n]=e(t[n]);return t}function p(t,e){return d(t.split(l),e).join(".")}function C(t){for(var e,n,r=[],i=0,o=t.length;i<o;)55296<=(e=t.charCodeAt(i++))&&e<=56319&&i<o?56320==(64512&(n=t.charCodeAt(i++)))?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),i--):r.push(e);return r}function T(t){return d(t,function(t){var e="";return 65535<t&&(e+=A((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+=A(t)}).join("")}function F(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function P(t,e,n){var r=0;for(t=n?_(t/s):t>>1,t+=_(t/e);f*b>>1<t;r+=y)t=_(t/f);return _(r+(f+1)*t/(t+a))}function g(t){var e,n,r,i,o,a,s,h,c,l,u,f=[],d=t.length,p=0,g=S,m=x;for((n=t.lastIndexOf(k))<0&&(n=0),r=0;r<n;++r)128<=t.charCodeAt(r)&&I("not-basic"),f.push(t.charCodeAt(r));for(i=0<n?n+1:0;i<d;){for(o=p,a=1,s=y;d<=i&&I("invalid-input"),u=t.charCodeAt(i++),(y<=(h=u-48<10?u-22:u-65<26?u-65:u-97<26?u-97:y)||h>_((w-p)/a))&&I("overflow"),p+=h*a,!(h<(c=s<=m?v:m+b<=s?b:s-m));s+=y)a>_(w/(l=y-c))&&I("overflow"),a*=l;m=P(p-o,e=f.length+1,0==o),_(p/e)>w-g&&I("overflow"),g+=_(p/e),p%=e,f.splice(p++,0,g)}return T(f)}function m(t){var e,n,r,i,o,a,s,h,c,l,u,f,d,p,g,m=[];for(f=(t=C(t)).length,e=S,o=x,a=n=0;a<f;++a)(u=t[a])<128&&m.push(A(u));for(r=i=m.length,i&&m.push(k);r<f;){for(s=w,a=0;a<f;++a)e<=(u=t[a])&&u<s&&(s=u);for(s-e>_((w-n)/(d=r+1))&&I("overflow"),n+=(s-e)*d,e=s,a=0;a<f;++a)if((u=t[a])<e&&++n>w&&I("overflow"),u==e){for(h=n,c=y;!(h<(l=c<=o?v:o+b<=c?b:c-o));c+=y)g=h-l,p=y-l,m.push(A(F(l+g%p,0))),h=_(g/p);m.push(A(F(h,0))),o=P(n,d,r==i),n=0,++r}++n,++e}return m.join("")}if(i={version:"1.2.4",ucs2:{decode:C,encode:T},decode:g,encode:m,toASCII:function(t){return p(t,function(t){return c.test(t)?"xn--"+m(t):t})},toUnicode:function(t){return p(t,function(t){return h.test(t)?g(t.slice(4).toLowerCase()):t})}},e&&!e.nodeType)if(n)n.exports=i;else for(o in i)i.hasOwnProperty(o)&&(e[o]=i[o]);else t.punycode=i}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],2:[function(t,e,n){var i=t("./log");function u(t,e){for(var n=3===t.nodeType?document.createTextNode(t.nodeValue):t.cloneNode(!1),r=t.firstChild;r;)!0!==e&&1===r.nodeType&&"SCRIPT"===r.nodeName||n.appendChild(u(r,e)),r=r.nextSibling;return 1===t.nodeType&&(n._scrollTop=t.scrollTop,n._scrollLeft=t.scrollLeft,"CANVAS"===t.nodeName?function(e,t){try{t&&(t.width=e.width,t.height=e.height,t.getContext("2d").putImageData(e.getContext("2d").getImageData(0,0,e.width,e.height),0,0))}catch(t){i("Unable to copy canvas content from",e,t)}}(t,n):"TEXTAREA"!==t.nodeName&&"SELECT"!==t.nodeName||(n.value=t.value)),n}e.exports=function(o,t,e,n,a,s,h){var c=u(o.documentElement,a.javascriptEnabled),l=t.createElement("iframe");return l.className="html2canvas-container",l.style.visibility="hidden",l.style.position="fixed",l.style.left="-10000px",l.style.top="0px",l.style.border="0",l.width=e,l.height=n,l.scrolling="no",t.body.appendChild(l),new Promise(function(e){var t,n,r,i=l.contentWindow.document;l.contentWindow.onload=l.onload=function(){var t=setInterval(function(){0<i.body.childNodes.length&&(!function t(e){if(1===e.nodeType){e.scrollTop=e._scrollTop,e.scrollLeft=e._scrollLeft;for(var n=e.firstChild;n;)t(n),n=n.nextSibling}}(i.documentElement),clearInterval(t),"view"===a.type&&(l.contentWindow.scrollTo(s,h),!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)||l.contentWindow.scrollY===h&&l.contentWindow.scrollX===s||(i.documentElement.style.top=-h+"px",i.documentElement.style.left=-s+"px",i.documentElement.style.position="absolute")),e(l))},50)},i.open(),i.write("<!DOCTYPE html><html></html>"),n=s,r=h,!(t=o).defaultView||n===t.defaultView.pageXOffset&&r===t.defaultView.pageYOffset||t.defaultView.scrollTo(n,r),i.replaceChild(i.adoptNode(c),i.documentElement),i.close()})}},{"./log":13}],3:[function(t,e,n){function r(t){this.r=0,this.g=0,this.b=0,this.a=null;this.fromArray(t)||this.namedColor(t)||this.rgb(t)||this.rgba(t)||this.hex6(t)||this.hex3(t)}r.prototype.darken=function(t){var e=1-t;return new r([Math.round(this.r*e),Math.round(this.g*e),Math.round(this.b*e),this.a])},r.prototype.isTransparent=function(){return 0===this.a},r.prototype.isBlack=function(){return 0===this.r&&0===this.g&&0===this.b},r.prototype.fromArray=function(t){return Array.isArray(t)&&(this.r=Math.min(t[0],255),this.g=Math.min(t[1],255),this.b=Math.min(t[2],255),3<t.length&&(this.a=t[3])),Array.isArray(t)};var i=/^#([a-f0-9]{3})$/i;r.prototype.hex3=function(t){var e;return null!==(e=t.match(i))&&(this.r=parseInt(e[1][0]+e[1][0],16),this.g=parseInt(e[1][1]+e[1][1],16),this.b=parseInt(e[1][2]+e[1][2],16)),null!==e};var o=/^#([a-f0-9]{6})$/i;r.prototype.hex6=function(t){var e=null;return null!==(e=t.match(o))&&(this.r=parseInt(e[1].substring(0,2),16),this.g=parseInt(e[1].substring(2,4),16),this.b=parseInt(e[1].substring(4,6),16)),null!==e};var a=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;r.prototype.rgb=function(t){var e;return null!==(e=t.match(a))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3])),null!==e};var s=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;r.prototype.rgba=function(t){var e;return null!==(e=t.match(s))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3]),this.a=Number(e[4])),null!==e},r.prototype.toString=function(){return null!==this.a&&1!==this.a?"rgba("+[this.r,this.g,this.b,this.a].join(",")+")":"rgb("+[this.r,this.g,this.b].join(",")+")"},r.prototype.namedColor=function(t){t=t.toLowerCase();var e=h[t];if(e)this.r=e[0],this.g=e[1],this.b=e[2];else if("transparent"===t)return this.r=this.g=this.b=this.a=0,!0;return!!e},r.prototype.isColor=!0;var h={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]};e.exports=r},{}],4:[function(t,e,n){var p=t("./support"),d=t("./renderers/canvas"),g=t("./imageloader"),m=t("./nodeparser"),r=t("./nodecontainer"),w=t("./log"),i=t("./utils"),y=t("./clone"),v=t("./proxy").loadUrlDocument,b=i.getBounds,x="data-html2canvas-node",S=0;function o(t,e){var n,r,i=S++;if((e=e||{}).logging&&(w.options.logging=!0,w.options.start=Date.now()),e.async=void 0===e.async||e.async,e.allowTaint=void 0!==e.allowTaint&&e.allowTaint,e.removeContainer=void 0===e.removeContainer||e.removeContainer,e.javascriptEnabled=void 0!==e.javascriptEnabled&&e.javascriptEnabled,e.imageTimeout=void 0===e.imageTimeout?1e4:e.imageTimeout,e.renderer="function"==typeof e.renderer?e.renderer:d,e.strict=!!e.strict,"string"==typeof t){if("string"!=typeof e.proxy)return Promise.reject("Proxy must be used when rendering url");var o=null!=e.width?e.width:window.innerWidth,a=null!=e.height?e.height:window.innerHeight;return v((n=t,r=document.createElement("a"),r.href=n,r.href=r.href,r),e.proxy,document,o,a,e).then(function(t){return k(t.contentWindow.document.documentElement,t,e,o,a)})}var s,h,c,l,u,f=(void 0===t?[document.documentElement]:t.length?t:[t])[0];return f.setAttribute(x+i,i),(s=f.ownerDocument,h=e,c=f.ownerDocument.defaultView.innerWidth,l=f.ownerDocument.defaultView.innerHeight,u=i,y(s,s,c,l,h,s.defaultView.pageXOffset,s.defaultView.pageYOffset).then(function(t){w("Document cloned");var e=x+u,n="["+e+"='"+u+"']";s.querySelector(n).removeAttribute(e);var r=t.contentWindow,i=r.document.querySelector(n),o="function"==typeof h.onclone?Promise.resolve(h.onclone(r.document)):Promise.resolve(!0);return o.then(function(){return k(i,t,h,c,l)})})).then(function(t){return"function"==typeof e.onrendered&&(w("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"),e.onrendered(t)),t})}o.CanvasRenderer=d,o.NodeContainer=r,o.log=w,o.utils=i;var a="undefined"==typeof document||"function"!=typeof Object.create||"function"!=typeof document.createElement("canvas").getContext?function(){return Promise.reject("No canvas support")}:o;function k(n,r,i,t,e){var o,a,s=r.contentWindow,h=new p(s.document),c=new g(i,h),l=b(n),u="view"===i.type?t:(o=s.document,Math.max(Math.max(o.body.scrollWidth,o.documentElement.scrollWidth),Math.max(o.body.offsetWidth,o.documentElement.offsetWidth),Math.max(o.body.clientWidth,o.documentElement.clientWidth))),f="view"===i.type?e:(a=s.document,Math.max(Math.max(a.body.scrollHeight,a.documentElement.scrollHeight),Math.max(a.body.offsetHeight,a.documentElement.offsetHeight),Math.max(a.body.clientHeight,a.documentElement.clientHeight))),d=new i.renderer(u,f,c,i,document);return new m(n,d,h,c,i).ready.then(function(){var t,e;return w("Finished rendering"),t="view"===i.type?_(d.canvas,{width:d.canvas.width,height:d.canvas.height,top:0,left:0,x:0,y:0}):n===s.document.body||n===s.document.documentElement||null!=i.canvas?d.canvas:_(d.canvas,{width:null!=i.width?i.width:l.width,height:null!=i.height?i.height:l.height,top:l.top,left:l.left,x:0,y:0}),e=r,i.removeContainer&&(e.parentNode.removeChild(e),w("Cleaned up container")),t})}function _(t,e){var n=document.createElement("canvas"),r=Math.min(t.width-1,Math.max(0,e.left)),i=Math.min(t.width,Math.max(1,e.left+e.width)),o=Math.min(t.height-1,Math.max(0,e.top)),a=Math.min(t.height,Math.max(1,e.top+e.height));n.width=e.width,n.height=e.height;var s=i-r,h=a-o;return w("Cropping canvas at:","left:",e.left,"top:",e.top,"width:",s,"height:",h),w("Resulting crop with width",e.width,"and height",e.height,"with x",r,"and y",o),n.getContext("2d").drawImage(t,r,o,s,h,e.x,e.y,s,h),n}e.exports=a},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(t,e,n){var r=t("./log"),i=t("./utils").smallImage;e.exports=function t(e){if(this.src=e,r("DummyImageContainer for",e),!this.promise||!this.image){r("Initiating DummyImageContainer"),t.prototype.image=new Image;var n=this.image;t.prototype.promise=new Promise(function(t,e){n.onload=t,n.onerror=e,n.src=i(),!0===n.complete&&t(n)})}}},{"./log":13,"./utils":26}],6:[function(t,e,n){var h=t("./utils").smallImage;e.exports=function(t,e){var n,r,i=document.createElement("div"),o=document.createElement("img"),a=document.createElement("span"),s="Hidden Text";i.style.visibility="hidden",i.style.fontFamily=t,i.style.fontSize=e,i.style.margin=0,i.style.padding=0,document.body.appendChild(i),o.src=h(),o.width=1,o.height=1,o.style.margin=0,o.style.padding=0,o.style.verticalAlign="baseline",a.style.fontFamily=t,a.style.fontSize=e,a.style.margin=0,a.style.padding=0,a.appendChild(document.createTextNode(s)),i.appendChild(a),i.appendChild(o),n=o.offsetTop-a.offsetTop+1,i.removeChild(a),i.appendChild(document.createTextNode(s)),i.style.lineHeight="normal",o.style.verticalAlign="super",r=o.offsetTop-i.offsetTop+1,document.body.removeChild(i),this.baseline=n,this.lineWidth=1,this.middle=r}},{"./utils":26}],7:[function(t,e,n){var r=t("./font");function i(){this.data={}}i.prototype.getMetrics=function(t,e){return void 0===this.data[t+"-"+e]&&(this.data[t+"-"+e]=new r(t,e)),this.data[t+"-"+e]},e.exports=i},{"./font":6}],8:[function(o,t,e){var a=o("./utils").getBounds,i=o("./proxy").loadUrlDocument;function n(e,t,n){this.image=null,this.src=e;var r=this,i=a(e);this.promise=(t?new Promise(function(t){"about:blank"===e.contentWindow.document.URL||null==e.contentWindow.document.documentElement?e.contentWindow.onload=e.onload=function(){t(e)}:t(e)}):this.proxyLoad(n.proxy,i,n)).then(function(t){return o("./core")(t.contentWindow.document.documentElement,{type:"view",width:t.width,height:t.height,proxy:n.proxy,javascriptEnabled:n.javascriptEnabled,removeContainer:n.removeContainer,allowTaint:n.allowTaint,imageTimeout:n.imageTimeout/2})}).then(function(t){return r.image=t})}n.prototype.proxyLoad=function(t,e,n){var r=this.src;return i(r.src,t,r.ownerDocument,e.width,e.height,n)},t.exports=n},{"./core":4,"./proxy":16,"./utils":26}],9:[function(t,e,n){function r(t){this.src=t.value,this.colorStops=[],this.type=null,this.x0=.5,this.y0=.5,this.x1=.5,this.y1=.5,this.promise=Promise.resolve(!0)}r.TYPES={LINEAR:1,RADIAL:2},r.REGEXP_COLORSTOP=/^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i,e.exports=r},{}],10:[function(t,e,n){e.exports=function(n,r){this.src=n,this.image=new Image;var i=this;this.tainted=null,this.promise=new Promise(function(t,e){i.image.onload=t,i.image.onerror=e,r&&(i.image.crossOrigin="anonymous"),i.image.src=n,!0===i.image.complete&&t(i.image)})}},{}],11:[function(t,e,n){var o=t("./log"),r=t("./imagecontainer"),i=t("./dummyimagecontainer"),a=t("./proxyimagecontainer"),s=t("./framecontainer"),h=t("./svgcontainer"),c=t("./svgnodecontainer"),l=t("./lineargradientcontainer"),u=t("./webkitgradientcontainer"),f=t("./utils").bind;function d(t,e){this.link=null,this.options=t,this.support=e,this.origin=this.getOrigin(window.location.href)}d.prototype.findImages=function(t){var e=[];return t.reduce(function(t,e){switch(e.node.nodeName){case"IMG":return t.concat([{args:[e.node.src],method:"url"}]);case"svg":case"IFRAME":return t.concat([{args:[e.node],method:e.node.nodeName}])}return t},[]).forEach(this.addImage(e,this.loadImage),this),e},d.prototype.findBackgroundImage=function(t,e){return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t,this.loadImage),this),t},d.prototype.addImage=function(n,r){return function(e){e.args.forEach(function(t){this.imageExists(n,t)||(n.splice(0,0,r.call(this,e)),o("Added image #"+n.length,"string"==typeof t?t.substring(0,100):t))},this)}},d.prototype.hasImageBackground=function(t){return"none"!==t.method},d.prototype.loadImage=function(t){if("url"===t.method){var e=t.args[0];return!this.isSVG(e)||this.support.svg||this.options.allowTaint?e.match(/data:image\/.*;base64,/i)?new r(e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi,""),!1):this.isSameOrigin(e)||!0===this.options.allowTaint||this.isSVG(e)?new r(e,!1):this.support.cors&&!this.options.allowTaint&&this.options.useCORS?new r(e,!0):this.options.proxy?new a(e,this.options.proxy):new i(e):new h(e)}return"linear-gradient"===t.method?new l(t):"gradient"===t.method?new u(t):"svg"===t.method?new c(t.args[0],this.support.svg):"IFRAME"===t.method?new s(t.args[0],this.isSameOrigin(t.args[0].src),this.options):new i(t)},d.prototype.isSVG=function(t){return"svg"===t.substring(t.length-3).toLowerCase()||h.prototype.isInline(t)},d.prototype.imageExists=function(t,e){return t.some(function(t){return t.src===e})},d.prototype.isSameOrigin=function(t){return this.getOrigin(t)===this.origin},d.prototype.getOrigin=function(t){var e=this.link||(this.link=document.createElement("a"));return e.href=t,e.href=e.href,e.protocol+e.hostname+e.port},d.prototype.getPromise=function(e){return this.timeout(e,this.options.imageTimeout).catch(function(){return new i(e.src).promise.then(function(t){e.image=t})})},d.prototype.get=function(e){var n=null;return this.images.some(function(t){return(n=t).src===e})?n:null},d.prototype.fetch=function(t){return this.images=t.reduce(f(this.findBackgroundImage,this),this.findImages(t)),this.images.forEach(function(e,n){e.promise.then(function(){o("Succesfully loaded image #"+(n+1),e)},function(t){o("Failed loading image #"+(n+1),e,t)})}),this.ready=Promise.all(this.images.map(this.getPromise,this)),o("Finished searching images"),this},d.prototype.timeout=function(n,r){var i,t=Promise.race([n.promise,new Promise(function(t,e){i=setTimeout(function(){o("Timed out loading image",n),e(n)},r)})]).then(function(t){return clearTimeout(i),t});return t.catch(function(){clearTimeout(i)}),t},e.exports=d},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(t,e,n){var i=t("./gradientcontainer"),o=t("./color");function r(t){i.apply(this,arguments),this.type=i.TYPES.LINEAR;var e=r.REGEXP_DIRECTION.test(t.args[0])||!i.REGEXP_COLORSTOP.test(t.args[0]);e?t.args[0].split(/\s+/).reverse().forEach(function(t,e){switch(t){case"left":this.x0=0,this.x1=1;break;case"top":this.y0=0,this.y1=1;break;case"right":this.x0=1,this.x1=0;break;case"bottom":this.y0=1,this.y1=0;break;case"to":var n=this.y0,r=this.x0;this.y0=this.y1,this.x0=this.x1,this.x1=r,this.y1=n;break;case"center":break;default:var i=.01*parseFloat(t,10);if(isNaN(i))break;0===e?(this.y0=i,this.y1=1-this.y0):(this.x0=i,this.x1=1-this.x0)}},this):(this.y0=0,this.y1=1),this.colorStops=t.args.slice(e?1:0).map(function(t){var e=t.match(i.REGEXP_COLORSTOP),n=+e[2],r=0===n?"%":e[3];return{color:new o(e[1]),stop:"%"===r?n/100:null}}),null===this.colorStops[0].stop&&(this.colorStops[0].stop=0),null===this.colorStops[this.colorStops.length-1].stop&&(this.colorStops[this.colorStops.length-1].stop=1),this.colorStops.forEach(function(n,r){null===n.stop&&this.colorStops.slice(r).some(function(t,e){return null!==t.stop&&(n.stop=(t.stop-this.colorStops[r-1].stop)/(e+1)+this.colorStops[r-1].stop,!0)},this)},this)}r.prototype=Object.create(i.prototype),r.REGEXP_DIRECTION=/^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i,e.exports=r},{"./color":3,"./gradientcontainer":9}],13:[function(t,e,n){var r=function(){r.options.logging&&window.console&&window.console.log&&Function.prototype.bind.call(window.console.log,window.console).apply(window.console,[Date.now()-r.options.start+"ms","html2canvas:"].concat([].slice.call(arguments,0)))};r.options={logging:!1},e.exports=r},{}],14:[function(t,e,n){var o=t("./color"),r=t("./utils"),i=r.getBounds,a=r.parseBackgrounds,s=r.offsetBounds;function h(t,e){this.node=t,this.parent=e,this.stack=null,this.bounds=null,this.borders=null,this.clip=[],this.backgroundClip=[],this.offsetBounds=null,this.visible=null,this.computedStyles=null,this.colors={},this.styles={},this.backgroundImages=null,this.transformData=null,this.transformMatrix=null,this.isPseudoElement=!1,this.opacity=null}function c(t){return-1!==t.toString().indexOf("%")}function l(t){return t.replace("px","")}function u(t){return parseFloat(t)}h.prototype.cloneTo=function(t){t.visible=this.visible,t.borders=this.borders,t.bounds=this.bounds,t.clip=this.clip,t.backgroundClip=this.backgroundClip,t.computedStyles=this.computedStyles,t.styles=this.styles,t.backgroundImages=this.backgroundImages,t.opacity=this.opacity},h.prototype.getOpacity=function(){return null===this.opacity?this.opacity=this.cssFloat("opacity"):this.opacity},h.prototype.assignStack=function(t){(this.stack=t).children.push(this)},h.prototype.isElementVisible=function(){return this.node.nodeType===Node.TEXT_NODE?this.parent.visible:"none"!==this.css("display")&&"hidden"!==this.css("visibility")&&!this.node.hasAttribute("data-html2canvas-ignore")&&("INPUT"!==this.node.nodeName||"hidden"!==this.node.getAttribute("type"))},h.prototype.css=function(t){return this.computedStyles||(this.computedStyles=this.isPseudoElement?this.parent.computedStyle(this.before?":before":":after"):this.computedStyle(null)),this.styles[t]||(this.styles[t]=this.computedStyles[t])},h.prototype.prefixedCss=function(e){var n=this.css(e);return void 0===n&&["webkit","moz","ms","o"].some(function(t){return void 0!==(n=this.css(t+e.substr(0,1).toUpperCase()+e.substr(1)))},this),void 0===n?null:n},h.prototype.computedStyle=function(t){return this.node.ownerDocument.defaultView.getComputedStyle(this.node,t)},h.prototype.cssInt=function(t){var e=parseInt(this.css(t),10);return isNaN(e)?0:e},h.prototype.color=function(t){return this.colors[t]||(this.colors[t]=new o(this.css(t)))},h.prototype.cssFloat=function(t){var e=parseFloat(this.css(t));return isNaN(e)?0:e},h.prototype.fontWeight=function(){var t=this.css("fontWeight");switch(parseInt(t,10)){case 401:t="bold";break;case 400:t="normal"}return t},h.prototype.parseClip=function(){var t=this.css("clip").match(this.CLIP);return t?{top:parseInt(t[1],10),right:parseInt(t[2],10),bottom:parseInt(t[3],10),left:parseInt(t[4],10)}:null},h.prototype.parseBackgroundImages=function(){return this.backgroundImages||(this.backgroundImages=a(this.css("backgroundImage")))},h.prototype.cssList=function(t,e){var n=(this.css(t)||"").split(",");return 1===(n=(n=n[e||0]||n[0]||"auto").trim().split(" ")).length&&(n=[n[0],c(n[0])?"auto":n[0]]),n},h.prototype.parseBackgroundSize=function(t,e,n){var r,i,o=this.cssList("backgroundSize",n);if(c(o[0]))r=t.width*parseFloat(o[0])/100;else{if(/contain|cover/.test(o[0])){var a=t.width/t.height,s=e.width/e.height;return a<s^"contain"===o[0]?{width:t.height*s,height:t.height}:{width:t.width,height:t.width/s}}r=parseInt(o[0],10)}return i="auto"===o[0]&&"auto"===o[1]?e.height:"auto"===o[1]?r/e.width*e.height:c(o[1])?t.height*parseFloat(o[1])/100:parseInt(o[1],10),"auto"===o[0]&&(r=i/e.height*e.width),{width:r,height:i}},h.prototype.parseBackgroundPosition=function(t,e,n,r){var i,o,a=this.cssList("backgroundPosition",n);return i=c(a[0])?(t.width-(r||e).width)*(parseFloat(a[0])/100):parseInt(a[0],10),o="auto"===a[1]?i/e.width*e.height:c(a[1])?(t.height-(r||e).height)*parseFloat(a[1])/100:parseInt(a[1],10),"auto"===a[0]&&(i=o/e.height*e.width),{left:i,top:o}},h.prototype.parseBackgroundRepeat=function(t){return this.cssList("backgroundRepeat",t)[0]},h.prototype.parseTextShadows=function(){var t=this.css("textShadow"),e=[];if(t&&"none"!==t)for(var n=t.match(this.TEXT_SHADOW_PROPERTY),r=0;n&&r<n.length;r++){var i=n[r].match(this.TEXT_SHADOW_VALUES);e.push({color:new o(i[0]),offsetX:i[1]?parseFloat(i[1].replace("px","")):0,offsetY:i[2]?parseFloat(i[2].replace("px","")):0,blur:i[3]?i[3].replace("px",""):0})}return e},h.prototype.parseTransform=function(){if(!this.transformData)if(this.hasTransform()){var t=this.parseBounds(),e=this.prefixedCss("transformOrigin").split(" ").map(l).map(u);e[0]+=t.left,e[1]+=t.top,this.transformData={origin:e,matrix:this.parseTransformMatrix()}}else this.transformData={origin:[0,0],matrix:[1,0,0,1,0,0]};return this.transformData},h.prototype.parseTransformMatrix=function(){if(!this.transformMatrix){var t=this.prefixedCss("transform"),e=t?function(t){{if(t&&"matrix"===t[1])return t[2].split(",").map(function(t){return parseFloat(t.trim())});if(t&&"matrix3d"===t[1]){var e=t[2].split(",").map(function(t){return parseFloat(t.trim())});return[e[0],e[1],e[4],e[5],e[12],e[13]]}}}(t.match(this.MATRIX_PROPERTY)):null;this.transformMatrix=e||[1,0,0,1,0,0]}return this.transformMatrix},h.prototype.parseBounds=function(){return this.bounds||(this.bounds=this.hasTransform()?s(this.node):i(this.node))},h.prototype.hasTransform=function(){return"1,0,0,1,0,0"!==this.parseTransformMatrix().join(",")||this.parent&&this.parent.hasTransform()},h.prototype.getValue=function(){var t,e,n=this.node.value||"";return"SELECT"===this.node.tagName?(t=this.node,n=(e=t.options[t.selectedIndex||0])&&e.text||""):"password"===this.node.type&&(n=Array(n.length+1).join("•")),0===n.length?this.node.placeholder||"":n},h.prototype.MATRIX_PROPERTY=/(matrix|matrix3d)\((.+)\)/,h.prototype.TEXT_SHADOW_PROPERTY=/((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g,h.prototype.TEXT_SHADOW_VALUES=/(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g,h.prototype.CLIP=/^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/,e.exports=h},{"./color":3,"./utils":26}],15:[function(t,e,n){var s=t("./log"),h=t("punycode"),c=t("./nodecontainer"),f=t("./textcontainer"),d=t("./pseudoelementcontainer"),l=t("./fontmetrics"),u=t("./color"),p=t("./stackingcontext"),r=t("./utils"),g=r.bind,a=r.getBounds,m=r.parseBackgrounds,w=r.offsetBounds;function i(t,e,n,r,i){s("Starting NodeParser"),this.renderer=e,this.options=i,this.range=null,this.support=n,this.renderQueue=[],this.stack=new p(!0,1,t.ownerDocument,null);var o=new c(t,null);if(i.background&&e.rectangle(0,0,e.width,e.height,new u(i.background)),t===t.ownerDocument.documentElement){var a=new c(o.color("backgroundColor").isTransparent()?t.ownerDocument.body:t.ownerDocument.documentElement,null);e.rectangle(0,0,e.width,e.height,a.color("backgroundColor"))}o.visibile=o.isElementVisible(),this.createPseudoHideStyles(t.ownerDocument),this.disableAnimations(t.ownerDocument),this.nodes=L([o].concat(this.getChildren(o)).filter(function(t){return t.visible=t.isElementVisible()}).map(this.getPseudoElements,this)),this.fontMetrics=new l,s("Fetched nodes, total:",this.nodes.length),s("Calculate overflow clips"),this.calculateOverflowClips(),s("Start fetching images"),this.images=r.fetch(this.nodes.filter(j)),this.ready=this.images.ready.then(g(function(){return s("Images loaded, starting parsing"),s("Creating stacking contexts"),this.createStackingContexts(),s("Sorting stacking contexts"),this.sortStackingContexts(this.stack),this.parse(this.stack),s("Render queue created with "+this.renderQueue.length+" items"),new Promise(g(function(t){i.async?"function"==typeof i.async?i.async.call(this,this.renderQueue,t):0<this.renderQueue.length?(this.renderIndex=0,this.asyncRenderer(this.renderQueue,t)):t():(this.renderQueue.forEach(this.paint,this),t())},this))},this))}function o(t){return t.parent&&t.parent.clip.length}function y(){}i.prototype.calculateOverflowClips=function(){this.nodes.forEach(function(t){if(j(t)){D(t)&&t.appendToDOM(),t.borders=this.parseBorders(t);var e="hidden"===t.css("overflow")?[t.borders.clip]:[],n=t.parseClip();n&&-1!==["absolute","fixed"].indexOf(t.css("position"))&&e.push([["rect",t.bounds.left+n.left,t.bounds.top+n.top,n.right-n.left,n.bottom-n.top]]),t.clip=o(t)?t.parent.clip.concat(e):e,t.backgroundClip="hidden"!==t.css("overflow")?t.clip.concat([t.borders.clip]):t.clip,D(t)&&t.cleanDOM()}else M(t)&&(t.clip=o(t)?t.parent.clip:[]);D(t)||(t.bounds=null)},this)},i.prototype.asyncRenderer=function(t,e,n){n=n||Date.now(),this.paint(t[this.renderIndex++]),t.length===this.renderIndex?e():n+20>Date.now()?this.asyncRenderer(t,e,n):setTimeout(g(function(){this.asyncRenderer(t,e)},this),0)},i.prototype.createPseudoHideStyles=function(t){this.createStyles(t,"."+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+':before { content: "" !important; display: none !important; }.'+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER+':after { content: "" !important; display: none !important; }')},i.prototype.disableAnimations=function(t){this.createStyles(t,"* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}")},i.prototype.createStyles=function(t,e){var n=t.createElement("style");n.innerHTML=e,t.body.appendChild(n)},i.prototype.getPseudoElements=function(t){var e=[[t]];if(t.node.nodeType===Node.ELEMENT_NODE){var n=this.getPseudoElement(t,":before"),r=this.getPseudoElement(t,":after");n&&e.push(n),r&&e.push(r)}return L(e)},i.prototype.getPseudoElement=function(t,e){var n=t.computedStyle(e);if(!n||!n.content||"none"===n.content||"-moz-alt-content"===n.content||"none"===n.display)return null;for(var r,i,o=(r=n.content,(i=r.substr(0,1))===r.substr(r.length-1)&&i.match(/'|"/)?r.substr(1,r.length-2):r),a="url"===o.substr(0,3),s=document.createElement(a?"img":"html2canvaspseudoelement"),h=new d(s,t,e),c=n.length-1;0<=c;c--){var l=n.item(c).replace(/(\-[a-z])/g,function(t){return t.toUpperCase().replace("-","")});s.style[l]=n[l]}if(s.className=d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+" "+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER,a)return s.src=m(o)[0].args[0],[h];var u=document.createTextNode(o);return s.appendChild(u),[h,new f(u,h)]},i.prototype.getChildren=function(n){return L([].filter.call(n.node.childNodes,q).map(function(t){var e=[t.nodeType===Node.TEXT_NODE?new f(t,n):new c(t,n)].filter(z);return t.nodeType===Node.ELEMENT_NODE&&e.length&&"TEXTAREA"!==t.tagName?e[0].isElementVisible()?e.concat(this.getChildren(e[0])):[]:e},this))},i.prototype.newStackingContext=function(t,e){var n=new p(e,t.getOpacity(),t.node,t.parent);t.cloneTo(n),(e?n.getParentStack(this):n.parent.stack).contexts.push(n),t.stack=n},i.prototype.createStackingContexts=function(){this.nodes.forEach(function(t){var e,n;j(t)&&(this.isRootElement(t)||t.getOpacity()<1||(n=(e=t).css("position"),"auto"!==(-1!==["absolute","relative","fixed"].indexOf(n)?e.css("zIndex"):"auto"))||this.isBodyWithTransparentRoot(t)||t.hasTransform())?this.newStackingContext(t,!0):j(t)&&(O(t)&&T(t)||-1!==["inline-block","inline-table"].indexOf(t.css("display"))||B(t))?this.newStackingContext(t,!1):t.assignStack(t.parent.stack)},this)},i.prototype.isBodyWithTransparentRoot=function(t){return"BODY"===t.node.nodeName&&t.parent.color("backgroundColor").isTransparent()},i.prototype.isRootElement=function(t){return null===t.parent},i.prototype.sortStackingContexts=function(t){var n;t.contexts.sort((n=t.contexts.slice(0),function(t,e){return t.cssInt("zIndex")+n.indexOf(t)/n.length-(e.cssInt("zIndex")+n.indexOf(e)/n.length)})),t.contexts.forEach(this.sortStackingContexts,this)},i.prototype.parseTextBounds=function(a){return function(t,e,n){if("none"!==a.parent.css("textDecoration").substr(0,4)||0!==t.trim().length){if(this.support.rangeBounds&&!a.parent.hasTransform()){var r=n.slice(0,e).join("").length;return this.getRangeBounds(a.node,r,t.length)}if(a.node&&"string"==typeof a.node.data){var i=a.node.splitText(t.length),o=this.getWrapperBounds(a.node,a.parent.hasTransform());return a.node=i,o}}else this.support.rangeBounds&&!a.parent.hasTransform()||(a.node=a.node.splitText(t.length));return{}}},i.prototype.getWrapperBounds=function(t,e){var n=t.ownerDocument.createElement("html2canvaswrapper"),r=t.parentNode,i=t.cloneNode(!0);n.appendChild(t.cloneNode(!0)),r.replaceChild(n,t);var o=e?w(n):a(n);return r.replaceChild(i,n),o},i.prototype.getRangeBounds=function(t,e,n){var r=this.range||(this.range=t.ownerDocument.createRange());return r.setStart(t,e),r.setEnd(t,e+n),r.getBoundingClientRect()},i.prototype.parse=function(t){var e=t.contexts.filter(I),n=t.children.filter(j),r=n.filter(R(B)),i=r.filter(R(O)).filter(R(F)),o=n.filter(R(O)).filter(B),a=r.filter(R(O)).filter(F),s=t.contexts.concat(r.filter(O)).filter(T),h=t.children.filter(M).filter(E),c=t.contexts.filter(C);e.concat(i).concat(o).concat(a).concat(s).concat(h).concat(c).forEach(function(t){this.renderQueue.push(t),P(t)&&(this.parse(t),this.renderQueue.push(new y))},this)},i.prototype.paint=function(t){try{t instanceof y?this.renderer.ctx.restore():M(t)?(D(t.parent)&&t.parent.appendToDOM(),this.paintText(t),D(t.parent)&&t.parent.cleanDOM()):this.paintNode(t)}catch(t){if(s(t),this.options.strict)throw t}},i.prototype.paintNode=function(t){P(t)&&(this.renderer.setOpacity(t.opacity),this.renderer.ctx.save(),t.hasTransform()&&this.renderer.setTransform(t.parseTransform())),"INPUT"===t.node.nodeName&&"checkbox"===t.node.type?this.paintCheckbox(t):"INPUT"===t.node.nodeName&&"radio"===t.node.type?this.paintRadio(t):this.paintElement(t)},i.prototype.paintElement=function(n){var r=n.parseBounds();this.renderer.clip(n.backgroundClip,function(){this.renderer.renderBackground(n,r,n.borders.borders.map(N))},this),this.renderer.clip(n.clip,function(){this.renderer.renderBorders(n.borders.borders)},this),this.renderer.clip(n.backgroundClip,function(){switch(n.node.nodeName){case"svg":case"IFRAME":var t=this.images.get(n.node);t?this.renderer.renderImage(n,r,n.borders,t):s("Error loading <"+n.node.nodeName+">",n.node);break;case"IMG":var e=this.images.get(n.node.src);e?this.renderer.renderImage(n,r,n.borders,e):s("Error loading <img>",n.node.src);break;case"CANVAS":this.renderer.renderImage(n,r,n.borders,{image:n.node});break;case"SELECT":case"INPUT":case"TEXTAREA":this.paintFormValue(n)}},this)},i.prototype.paintCheckbox=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height),r={width:n-1,height:n-1,top:e.top,left:e.left},i=[3,3],o=[i,i,i,i],a=[1,1,1,1].map(function(t){return{color:new u("#A5A5A5"),width:t}}),s=S(r,o,a);this.renderer.clip(t.backgroundClip,function(){this.renderer.rectangle(r.left+1,r.top+1,r.width-2,r.height-2,new u("#DEDEDE")),this.renderer.renderBorders(b(a,r,s,o)),t.node.checked&&(this.renderer.font(new u("#424242"),"normal","normal","bold",n-3+"px","arial"),this.renderer.text("✔",r.left+n/6,r.top+n-1))},this)},i.prototype.paintRadio=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height)-2;this.renderer.clip(t.backgroundClip,function(){this.renderer.circleStroke(e.left+1,e.top+1,n,new u("#DEDEDE"),1,new u("#A5A5A5")),t.node.checked&&this.renderer.circle(Math.ceil(e.left+n/4)+1,Math.ceil(e.top+n/4)+1,Math.floor(n/2),new u("#424242"))},this)},i.prototype.paintFormValue=function(e){var t=e.getValue();if(0<t.length){var n=e.node.ownerDocument,r=n.createElement("html2canvaswrapper");["lineHeight","textAlign","fontFamily","fontWeight","fontSize","color","paddingLeft","paddingTop","paddingRight","paddingBottom","width","height","borderLeftStyle","borderTopStyle","borderLeftWidth","borderTopWidth","boxSizing","whiteSpace","wordWrap"].forEach(function(t){try{r.style[t]=e.css(t)}catch(t){s("html2canvas: Parse: Exception caught in renderFormValue: "+t.message)}});var i=e.parseBounds();r.style.position="fixed",r.style.left=i.left+"px",r.style.top=i.top+"px",r.textContent=t,n.body.appendChild(r),this.paintText(new f(r.firstChild,e)),n.body.removeChild(r)}},i.prototype.paintText=function(n){n.applyTextTransform();var t,e=h.ucs2.decode(n.node.data),r=this.options.letterRendering&&!/^(normal|none|0px)$/.test(n.parent.css("letterSpacing"))||(t=n.node.data,/[^\u0000-\u00ff]/.test(t))?e.map(function(t){return h.ucs2.encode([t])}):function(t){var e,n=[],r=0,i=!1;for(;t.length;)o=t[r],-1!==[32,13,10,9,45].indexOf(o)===i?((e=t.splice(0,r)).length&&n.push(h.ucs2.encode(e)),i=!i,r=0):r++,r>=t.length&&(e=t.splice(0,r)).length&&n.push(h.ucs2.encode(e));var o;return n}(e),i=n.parent.fontWeight(),o=n.parent.css("fontSize"),a=n.parent.css("fontFamily"),s=n.parent.parseTextShadows();this.renderer.font(n.parent.color("color"),n.parent.css("fontStyle"),n.parent.css("fontVariant"),i,o,a),s.length?this.renderer.fontShadow(s[0].color,s[0].offsetX,s[0].offsetY,s[0].blur):this.renderer.clearShadow(),this.renderer.clip(n.parent.clip,function(){r.map(this.parseTextBounds(n),this).forEach(function(t,e){t&&!1===/^\s*$/.test(r[e])&&(this.renderer.text(r[e],t.left,t.bottom),this.renderTextDecoration(n.parent,t,this.fontMetrics.getMetrics(a,o)))},this)},this)},i.prototype.renderTextDecoration=function(t,e,n){switch(t.css("textDecoration").split(" ")[0]){case"underline":this.renderer.rectangle(e.left,Math.round(e.top+n.baseline+n.lineWidth),e.width,1,t.color("color"));break;case"overline":this.renderer.rectangle(e.left,Math.round(e.top),e.width,1,t.color("color"));break;case"line-through":this.renderer.rectangle(e.left,Math.ceil(e.top+n.middle+n.lineWidth),e.width,1,t.color("color"))}};var v={inset:[["darken",.6],["darken",.1],["darken",.1],["darken",.6]]};function b(a,s,h,c){return a.map(function(t,e){if(0<t.width){var n=s.left,r=s.top,i=s.width,o=s.height-a[2].width;switch(e){case 0:o=a[0].width,t.args=_({c1:[n,r],c2:[n+i,r],c3:[n+i-a[1].width,r+o],c4:[n+a[3].width,r+o]},c[0],c[1],h.topLeftOuter,h.topLeftInner,h.topRightOuter,h.topRightInner);break;case 1:n=s.left+s.width-a[1].width,i=a[1].width,t.args=_({c1:[n+i,r],c2:[n+i,r+o+a[2].width],c3:[n,r+o],c4:[n,r+a[0].width]},c[1],c[2],h.topRightOuter,h.topRightInner,h.bottomRightOuter,h.bottomRightInner);break;case 2:r=r+s.height-a[2].width,o=a[2].width,t.args=_({c1:[n+i,r+o],c2:[n,r+o],c3:[n+a[3].width,r],c4:[n+i-a[3].width,r]},c[2],c[3],h.bottomRightOuter,h.bottomRightInner,h.bottomLeftOuter,h.bottomLeftInner);break;case 3:i=a[3].width,t.args=_({c1:[n,r+o+a[2].width],c2:[n,r],c3:[n+i,r+a[0].width],c4:[n+i,r+o]},c[3],c[0],h.bottomLeftOuter,h.bottomLeftInner,h.topLeftOuter,h.topLeftInner)}}return t})}function x(t,e,n,r){var i=(Math.sqrt(2)-1)/3*4,o=n*i,a=r*i,s=t+n,h=e+r;return{topLeft:k({x:t,y:h},{x:t,y:h-a},{x:s-o,y:e},{x:s,y:e}),topRight:k({x:t,y:e},{x:t+o,y:e},{x:s,y:h-a},{x:s,y:h}),bottomRight:k({x:s,y:e},{x:s,y:e+a},{x:t+o,y:h},{x:t,y:h}),bottomLeft:k({x:s,y:h},{x:s-o,y:h},{x:t,y:e+a},{x:t,y:e})}}function S(t,e,n){var r=t.left,i=t.top,o=t.width,a=t.height,s=e[0][0]<o/2?e[0][0]:o/2,h=e[0][1]<a/2?e[0][1]:a/2,c=e[1][0]<o/2?e[1][0]:o/2,l=e[1][1]<a/2?e[1][1]:a/2,u=e[2][0]<o/2?e[2][0]:o/2,f=e[2][1]<a/2?e[2][1]:a/2,d=e[3][0]<o/2?e[3][0]:o/2,p=e[3][1]<a/2?e[3][1]:a/2,g=o-c,m=a-f,w=o-u,y=a-p;return{topLeftOuter:x(r,i,s,h).topLeft.subdivide(.5),topLeftInner:x(r+n[3].width,i+n[0].width,Math.max(0,s-n[3].width),Math.max(0,h-n[0].width)).topLeft.subdivide(.5),topRightOuter:x(r+g,i,c,l).topRight.subdivide(.5),topRightInner:x(r+Math.min(g,o+n[3].width),i+n[0].width,g>o+n[3].width?0:c-n[3].width,l-n[0].width).topRight.subdivide(.5),bottomRightOuter:x(r+w,i+m,u,f).bottomRight.subdivide(.5),bottomRightInner:x(r+Math.min(w,o-n[3].width),i+Math.min(m,a+n[0].width),Math.max(0,u-n[1].width),f-n[2].width).bottomRight.subdivide(.5),bottomLeftOuter:x(r,i+y,d,p).bottomLeft.subdivide(.5),bottomLeftInner:x(r+n[3].width,i+y,Math.max(0,d-n[3].width),p-n[2].width).bottomLeft.subdivide(.5)}}function k(s,h,c,l){var u=function(t,e,n){return{x:t.x+(e.x-t.x)*n,y:t.y+(e.y-t.y)*n}};return{start:s,startControl:h,endControl:c,end:l,subdivide:function(t){var e=u(s,h,t),n=u(h,c,t),r=u(c,l,t),i=u(e,n,t),o=u(n,r,t),a=u(i,o,t);return[k(s,e,i,a),k(a,o,r,l)]},curveTo:function(t){t.push(["bezierCurve",h.x,h.y,c.x,c.y,l.x,l.y])},curveToReversed:function(t){t.push(["bezierCurve",c.x,c.y,h.x,h.y,s.x,s.y])}}}function _(t,e,n,r,i,o,a){var s=[];return 0<e[0]||0<e[1]?(s.push(["line",r[1].start.x,r[1].start.y]),r[1].curveTo(s)):s.push(["line",t.c1[0],t.c1[1]]),0<n[0]||0<n[1]?(s.push(["line",o[0].start.x,o[0].start.y]),o[0].curveTo(s),s.push(["line",a[0].end.x,a[0].end.y]),a[0].curveToReversed(s)):(s.push(["line",t.c2[0],t.c2[1]]),s.push(["line",t.c3[0],t.c3[1]])),0<e[0]||0<e[1]?(s.push(["line",i[1].end.x,i[1].end.y]),i[1].curveToReversed(s)):s.push(["line",t.c4[0],t.c4[1]]),s}function A(t,e,n,r,i,o,a){0<e[0]||0<e[1]?(t.push(["line",r[0].start.x,r[0].start.y]),r[0].curveTo(t),r[1].curveTo(t)):t.push(["line",o,a]),(0<n[0]||0<n[1])&&t.push(["line",i[0].start.x,i[0].start.y])}function I(t){return t.cssInt("zIndex")<0}function C(t){return 0<t.cssInt("zIndex")}function T(t){return 0===t.cssInt("zIndex")}function F(t){return-1!==["inline","inline-block","inline-table"].indexOf(t.css("display"))}function P(t){return t instanceof p}function E(t){return 0<t.node.data.trim().length}function q(t){return t.nodeType===Node.TEXT_NODE||t.nodeType===Node.ELEMENT_NODE}function O(t){return"static"!==t.css("position")}function B(t){return"none"!==t.css("float")}function R(t){var e=this;return function(){return!t.apply(e,arguments)}}function j(t){return t.node.nodeType===Node.ELEMENT_NODE}function D(t){return!0===t.isPseudoElement}function M(t){return t.node.nodeType===Node.TEXT_NODE}function U(t){return parseInt(t,10)}function N(t){return t.width}function z(t){return t.node.nodeType!==Node.ELEMENT_NODE||-1===["SCRIPT","HEAD","TITLE","OBJECT","BR","OPTION"].indexOf(t.node.nodeName)}function L(t){return[].concat.apply([],t)}i.prototype.parseBorders=function(o){var r,t=o.parseBounds(),e=(r=o,["TopLeft","TopRight","BottomRight","BottomLeft"].map(function(t){var e=r.css("border"+t+"Radius"),n=e.split(" ");return n.length<=1&&(n[1]=n[0]),n.map(U)})),n=["Top","Right","Bottom","Left"].map(function(t,e){var n=o.css("border"+t+"Style"),r=o.color("border"+t+"Color");"inset"===n&&r.isBlack()&&(r=new u([255,255,255,r.a]));var i=v[n]?v[n][e]:null;return{width:o.cssInt("border"+t+"Width"),color:i?r[i[0]](i[1]):r,args:null}}),i=S(t,e,n);return{clip:this.parseBackgroundClip(o,i,n,e,t),borders:b(n,t,i,e)}},i.prototype.parseBackgroundClip=function(t,e,n,r,i){var o=[];switch(t.css("backgroundClip")){case"content-box":case"padding-box":A(o,r[0],r[1],e.topLeftInner,e.topRightInner,i.left+n[3].width,i.top+n[0].width),A(o,r[1],r[2],e.topRightInner,e.bottomRightInner,i.left+i.width-n[1].width,i.top+n[0].width),A(o,r[2],r[3],e.bottomRightInner,e.bottomLeftInner,i.left+i.width-n[1].width,i.top+i.height-n[2].width),A(o,r[3],r[0],e.bottomLeftInner,e.topLeftInner,i.left+n[3].width,i.top+i.height-n[2].width);break;default:A(o,r[0],r[1],e.topLeftOuter,e.topRightOuter,i.left,i.top),A(o,r[1],r[2],e.topRightOuter,e.bottomRightOuter,i.left+i.width,i.top),A(o,r[2],r[3],e.bottomRightOuter,e.bottomLeftOuter,i.left+i.width,i.top+i.height),A(o,r[3],r[0],e.bottomLeftOuter,e.topLeftOuter,i.left,i.top+i.height)}return o},e.exports=i},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,punycode:1}],16:[function(t,e,n){var a=t("./xhr"),r=t("./utils"),s=t("./log"),h=t("./clone"),c=r.decode64;function l(t,e,n){var r="withCredentials"in new XMLHttpRequest;if(!e)return Promise.reject("No proxy configured");var i=f(r),o=d(e,t,i);return r?a(o):u(n,o,i).then(function(t){return c(t.content)})}var i=0;function u(i,o,a){return new Promise(function(e,n){var t=i.createElement("script"),r=function(){delete window.html2canvas.proxy[a],i.body.removeChild(t)};window.html2canvas.proxy[a]=function(t){r(),e(t)},t.src=o,t.onerror=function(t){r(),n(t)},i.body.appendChild(t)})}function f(t){return t?"":"html2canvas_"+Date.now()+"_"+ ++i+"_"+Math.round(1e5*Math.random())}function d(t,e,n){return t+"?url="+encodeURIComponent(e)+(n.length?"&callback=html2canvas.proxy."+n:"")}n.Proxy=l,n.ProxyURL=function(t,e,n){var r="crossOrigin"in new Image,i=f(r),o=d(e,t,i);return r?Promise.resolve(o):u(n,o,i).then(function(t){return"data:"+t.type+";base64,"+t.content})},n.loadUrlDocument=function(t,e,n,r,i,o){return new l(t,e,window.document).then((a=t,function(e){var n,t=new DOMParser;try{n=t.parseFromString(e,"text/html")}catch(t){s("DOMParser not supported, falling back to createHTMLDocument"),n=document.implementation.createHTMLDocument("");try{n.open(),n.write(e),n.close()}catch(t){s("createHTMLDocument write not supported, falling back to document.body.innerHTML"),n.body.innerHTML=e}}var r=n.querySelector("base");if(!r||!r.href.host){var i=n.createElement("base");i.href=a,n.head.insertBefore(i,n.head.firstChild)}return n})).then(function(t){return h(t,n,r,i,o,0,0)});var a}},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(t,e,n){var o=t("./proxy").ProxyURL;e.exports=function(n,r){var t=document.createElement("a");t.href=n,n=t.href,this.src=n,this.image=new Image;var i=this;this.promise=new Promise(function(t,e){i.image.crossOrigin="Anonymous",i.image.onload=t,i.image.onerror=e,new o(n,r,document).then(function(t){i.image.src=t}).catch(e)})}},{"./proxy":16}],18:[function(t,e,n){var r=t("./nodecontainer");function i(t,e,n){r.call(this,t,e),this.isPseudoElement=!0,this.before=":before"===n}i.prototype.cloneTo=function(t){i.prototype.cloneTo.call(this,t),t.isPseudoElement=!0,t.before=this.before},(i.prototype=Object.create(r.prototype)).appendToDOM=function(){this.before?this.parent.node.insertBefore(this.node,this.parent.node.firstChild):this.parent.node.appendChild(this.node),this.parent.node.className+=" "+this.getHideClass()},i.prototype.cleanDOM=function(){this.node.parentNode.removeChild(this.node),this.parent.node.className=this.parent.node.className.replace(this.getHideClass(),"")},i.prototype.getHideClass=function(){return this["PSEUDO_HIDE_ELEMENT_CLASS_"+(this.before?"BEFORE":"AFTER")]},i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE="___html2canvas___pseudoelement_before",i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER="___html2canvas___pseudoelement_after",e.exports=i},{"./nodecontainer":14}],19:[function(t,e,n){var h=t("./log");function r(t,e,n,r,i){this.width=t,this.height=e,this.images=n,this.options=r,this.document=i}r.prototype.renderImage=function(t,e,n,r){var i=t.cssInt("paddingLeft"),o=t.cssInt("paddingTop"),a=t.cssInt("paddingRight"),s=t.cssInt("paddingBottom"),h=n.borders,c=e.width-(h[1].width+h[3].width+i+a),l=e.height-(h[0].width+h[2].width+o+s);this.drawImage(r,0,0,r.image.width||c,r.image.height||l,e.left+i+h[3].width,e.top+o+h[0].width,c,l)},r.prototype.renderBackground=function(t,e,n){0<e.height&&0<e.width&&(this.renderBackgroundColor(t,e),this.renderBackgroundImage(t,e,n))},r.prototype.renderBackgroundColor=function(t,e){var n=t.color("backgroundColor");n.isTransparent()||this.rectangle(e.left,e.top,e.width,e.height,n)},r.prototype.renderBorders=function(t){t.forEach(this.renderBorder,this)},r.prototype.renderBorder=function(t){t.color.isTransparent()||null===t.args||this.drawShape(t.args,t.color)},r.prototype.renderBackgroundImage=function(o,a,s){o.parseBackgroundImages().reverse().forEach(function(t,e,n){switch(t.method){case"url":var r=this.images.get(t.args[0]);r?this.renderBackgroundRepeating(o,a,r,n.length-(e+1),s):h("Error loading background-image",t.args[0]);break;case"linear-gradient":case"gradient":var i=this.images.get(t.value);i?this.renderBackgroundGradient(i,a,s):h("Error loading background-image",t.args[0]);break;case"none":break;default:h("Unknown background-image type",t.args[0])}},this)},r.prototype.renderBackgroundRepeating=function(t,e,n,r,i){var o=t.parseBackgroundSize(e,n.image,r),a=t.parseBackgroundPosition(e,n.image,r,o);switch(t.parseBackgroundRepeat(r)){case"repeat-x":case"repeat no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+i[3],e.top+a.top+i[0],99999,o.height,i);break;case"repeat-y":case"no-repeat repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+i[0],o.width,99999,i);break;case"no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+a.top+i[0],o.width,o.height,i);break;default:this.renderBackgroundRepeat(n,a,o,{top:e.top,left:e.left},i[3],i[0])}},e.exports=r},{"./log":13}],20:[function(t,e,n){var r=t("../renderer"),i=t("../lineargradientcontainer"),o=t("../log");function a(t,e){r.apply(this,arguments),this.canvas=this.options.canvas||this.document.createElement("canvas"),this.options.canvas||(this.canvas.width=t,this.canvas.height=e),this.ctx=this.canvas.getContext("2d"),this.taintCtx=this.document.createElement("canvas").getContext("2d"),this.ctx.textBaseline="bottom",this.variables={},o("Initialized CanvasRenderer with size",t,"x",e)}function s(t){return 0<t.length}(a.prototype=Object.create(r.prototype)).setFillStyle=function(t){return this.ctx.fillStyle="object"==typeof t&&t.isColor?t.toString():t,this.ctx},a.prototype.rectangle=function(t,e,n,r,i){this.setFillStyle(i).fillRect(t,e,n,r)},a.prototype.circle=function(t,e,n,r){this.setFillStyle(r),this.ctx.beginPath(),this.ctx.arc(t+n/2,e+n/2,n/2,0,2*Math.PI,!0),this.ctx.closePath(),this.ctx.fill()},a.prototype.circleStroke=function(t,e,n,r,i,o){this.circle(t,e,n,r),this.ctx.strokeStyle=o.toString(),this.ctx.stroke()},a.prototype.drawShape=function(t,e){this.shape(t),this.setFillStyle(e).fill()},a.prototype.taints=function(e){if(null===e.tainted){this.taintCtx.drawImage(e.image,0,0);try{this.taintCtx.getImageData(0,0,1,1),e.tainted=!1}catch(t){this.taintCtx=document.createElement("canvas").getContext("2d"),e.tainted=!0}}return e.tainted},a.prototype.drawImage=function(t,e,n,r,i,o,a,s,h){this.taints(t)&&!this.options.allowTaint||this.ctx.drawImage(t.image,e,n,r,i,o,a,s,h)},a.prototype.clip=function(t,e,n){this.ctx.save(),t.filter(s).forEach(function(t){this.shape(t).clip()},this),e.call(n),this.ctx.restore()},a.prototype.shape=function(t){return this.ctx.beginPath(),t.forEach(function(t,e){"rect"===t[0]?this.ctx.rect.apply(this.ctx,t.slice(1)):this.ctx[0===e?"moveTo":t[0]+"To"].apply(this.ctx,t.slice(1))},this),this.ctx.closePath(),this.ctx},a.prototype.font=function(t,e,n,r,i,o){this.setFillStyle(t).font=[e,n,r,i,o].join(" ").split(",")[0]},a.prototype.fontShadow=function(t,e,n,r){this.setVariable("shadowColor",t.toString()).setVariable("shadowOffsetY",e).setVariable("shadowOffsetX",n).setVariable("shadowBlur",r)},a.prototype.clearShadow=function(){this.setVariable("shadowColor","rgba(0,0,0,0)")},a.prototype.setOpacity=function(t){this.ctx.globalAlpha=t},a.prototype.setTransform=function(t){this.ctx.translate(t.origin[0],t.origin[1]),this.ctx.transform.apply(this.ctx,t.matrix),this.ctx.translate(-t.origin[0],-t.origin[1])},a.prototype.setVariable=function(t,e){return this.variables[t]!==e&&(this.variables[t]=this.ctx[t]=e),this},a.prototype.text=function(t,e,n){this.ctx.fillText(t,e,n)},a.prototype.backgroundRepeatShape=function(t,e,n,r,i,o,a,s,h){var c=[["line",Math.round(i),Math.round(o)],["line",Math.round(i+a),Math.round(o)],["line",Math.round(i+a),Math.round(s+o)],["line",Math.round(i),Math.round(s+o)]];this.clip([c],function(){this.renderBackgroundRepeat(t,e,n,r,h[3],h[0])},this)},a.prototype.renderBackgroundRepeat=function(t,e,n,r,i,o){var a=Math.round(r.left+e.left+i),s=Math.round(r.top+e.top+o);this.setFillStyle(this.ctx.createPattern(this.resizeImage(t,n),"repeat")),this.ctx.translate(a,s),this.ctx.fill(),this.ctx.translate(-a,-s)},a.prototype.renderBackgroundGradient=function(t,e){if(t instanceof i){var n=this.ctx.createLinearGradient(e.left+e.width*t.x0,e.top+e.height*t.y0,e.left+e.width*t.x1,e.top+e.height*t.y1);t.colorStops.forEach(function(t){n.addColorStop(t.stop,t.color.toString())}),this.rectangle(e.left,e.top,e.width,e.height,n)}},a.prototype.resizeImage=function(t,e){var n=t.image;if(n.width===e.width&&n.height===e.height)return n;var r=document.createElement("canvas");return r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(n,0,0,n.width,n.height,0,0,e.width,e.height),r},e.exports=a},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(t,e,n){var i=t("./nodecontainer");function r(t,e,n,r){i.call(this,n,r),this.ownStacking=t,this.contexts=[],this.children=[],this.opacity=(this.parent?this.parent.stack.opacity:1)*e}(r.prototype=Object.create(i.prototype)).getParentStack=function(t){var e=this.parent?this.parent.stack:null;return e?e.ownStacking?e:e.getParentStack(t):t.stack},e.exports=r},{"./nodecontainer":14}],22:[function(t,e,n){function r(t){this.rangeBounds=this.testRangeBounds(t),this.cors=this.testCORS(),this.svg=this.testSVG()}r.prototype.testRangeBounds=function(t){var e,n,r=!1;return t.createRange&&(e=t.createRange()).getBoundingClientRect&&((n=t.createElement("boundtest")).style.height="123px",n.style.display="block",t.body.appendChild(n),e.selectNode(n),123===e.getBoundingClientRect().height&&(r=!0),t.body.removeChild(n)),r},r.prototype.testCORS=function(){return void 0!==(new Image).crossOrigin},r.prototype.testSVG=function(){var t=new Image,e=document.createElement("canvas"),n=e.getContext("2d");t.src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{n.drawImage(t,0,0),e.toDataURL()}catch(t){return!1}return!0},e.exports=r},{}],23:[function(t,e,n){var r=t("./xhr"),i=t("./utils").decode64;function o(t){this.src=t,this.image=null;var n=this;this.promise=this.hasFabric().then(function(){return n.isInline(t)?Promise.resolve(n.inlineFormatting(t)):r(t)}).then(function(e){return new Promise(function(t){window.html2canvas.svg.fabric.loadSVGFromString(e,n.createCanvas.call(n,t))})})}o.prototype.hasFabric=function(){return window.html2canvas.svg&&window.html2canvas.svg.fabric?Promise.resolve():Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"))},o.prototype.inlineFormatting=function(t){return/^data:image\/svg\+xml;base64,/.test(t)?this.decode64(this.removeContentType(t)):this.removeContentType(t)},o.prototype.removeContentType=function(t){return t.replace(/^data:image\/svg\+xml(;base64)?,/,"")},o.prototype.isInline=function(t){return/^data:image\/svg\+xml/i.test(t)},o.prototype.createCanvas=function(r){var i=this;return function(t,e){var n=new window.html2canvas.svg.fabric.StaticCanvas("c");i.image=n.lowerCanvasEl,n.setWidth(e.width).setHeight(e.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(t,e)).renderAll(),r(n.lowerCanvasEl)}},o.prototype.decode64=function(t){return"function"==typeof window.atob?window.atob(t):i(t)},e.exports=o},{"./utils":26,"./xhr":28}],24:[function(t,e,n){var r=t("./svgcontainer");function i(n,t){this.src=n,this.image=null;var r=this;this.promise=t?new Promise(function(t,e){r.image=new Image,r.image.onload=t,r.image.onerror=e,r.image.src="data:image/svg+xml,"+(new XMLSerializer).serializeToString(n),!0===r.image.complete&&t(r.image)}):this.hasFabric().then(function(){return new Promise(function(t){window.html2canvas.svg.fabric.parseSVGDocument(n,r.createCanvas.call(r,t))})})}i.prototype=Object.create(r.prototype),e.exports=i},{"./svgcontainer":23}],25:[function(t,e,n){var r=t("./nodecontainer");function i(t,e){r.call(this,t,e)}function o(t,e,n){if(0<t.length)return e+n.toUpperCase()}(i.prototype=Object.create(r.prototype)).applyTextTransform=function(){this.node.data=this.transform(this.parent.css("textTransform"))},i.prototype.transform=function(t){var e=this.node.data;switch(t){case"lowercase":return e.toLowerCase();case"capitalize":return e.replace(/(^|\s|:|-|\(|\))([a-z])/g,o);case"uppercase":return e.toUpperCase();default:return e}},e.exports=i},{"./nodecontainer":14}],26:[function(t,e,n){n.smallImage=function(){return"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"},n.bind=function(t,e){return function(){return t.apply(e,arguments)}},
/*
   * base64-arraybuffer
   * https://github.com/niklasvh/base64-arraybuffer
   *
   * Copyright (c) 2012 Niklas von Hertzen
   * Licensed under the MIT license.
   */
n.decode64=function(t){var e,n,r,i,o,a,s,h="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",c=t.length,l="";for(e=0;e<c;e+=4)o=h.indexOf(t[e])<<2|(n=h.indexOf(t[e+1]))>>4,a=(15&n)<<4|(r=h.indexOf(t[e+2]))>>2,s=(3&r)<<6|(i=h.indexOf(t[e+3])),l+=64===r?String.fromCharCode(o):64===i||-1===i?String.fromCharCode(o,a):String.fromCharCode(o,a,s);return l},n.getBounds=function(t){if(t.getBoundingClientRect){var e=t.getBoundingClientRect(),n=null==t.offsetWidth?e.width:t.offsetWidth;return{top:e.top,bottom:e.bottom||e.top+e.height,right:e.left+n,left:e.left,width:n,height:null==t.offsetHeight?e.height:t.offsetHeight}}return{}},n.offsetBounds=function(t){var e=t.offsetParent?n.offsetBounds(t.offsetParent):{top:0,left:0};return{top:t.offsetTop+e.top,bottom:t.offsetTop+t.offsetHeight+e.top,right:t.offsetLeft+e.left+t.offsetWidth,left:t.offsetLeft+e.left,width:t.offsetWidth,height:t.offsetHeight}},n.parseBackgrounds=function(t){var e,n,r,i,o,a,s,h=[],c=0,l=0,u=function(){e&&('"'===n.substr(0,1)&&(n=n.substr(1,n.length-2)),n&&s.push(n),"-"===e.substr(0,1)&&0<(i=e.indexOf("-",1)+1)&&(r=e.substr(0,i),e=e.substr(i)),h.push({prefix:r,method:e.toLowerCase(),value:o,args:s,image:null})),s=[],e=r=n=o=""};return s=[],e=r=n=o="",t.split("").forEach(function(t){if(!(0===c&&-1<" \r\n\t".indexOf(t))){switch(t){case'"':a?a===t&&(a=null):a=t;break;case"(":if(a)break;if(0===c)return c=1,void(o+=t);l++;break;case")":if(a)break;if(1===c){if(0===l)return c=0,o+=t,void u();l--}break;case",":if(a)break;if(0===c)return void u();if(1===c&&0===l&&!e.match(/^url$/i))return s.push(n),n="",void(o+=t)}o+=t,0===c?e+=t:n+=t}}),u(),h}},{}],27:[function(t,e,n){var r=t("./gradientcontainer");function i(t){r.apply(this,arguments),this.type="linear"===t.args[0]?r.TYPES.LINEAR:r.TYPES.RADIAL}i.prototype=Object.create(r.prototype),e.exports=i},{"./gradientcontainer":9}],28:[function(t,e,n){e.exports=function(r){return new Promise(function(t,e){var n=new XMLHttpRequest;n.open("GET",r),n.onload=function(){200===n.status?t(n.responseText):e(new Error(n.statusText))},n.onerror=function(){e(new Error("Network Error"))},n.send()})}},{}]},{},[4])(4)}),function(t){var n="+".charCodeAt(0),r="/".charCodeAt(0),i="0".charCodeAt(0),o="a".charCodeAt(0),a="A".charCodeAt(0),s="-".charCodeAt(0),h="_".charCodeAt(0),l=function(t){var e=t.charCodeAt(0);return e===n||e===s?62:e===r||e===h?63:e<i?-1:e<i+10?e-i+26+26:e<a+26?e-a:e<o+26?e-o+26:void 0};t.API.TTFFont=function(){function i(t,e,n){var r;if(this.rawData=t,r=this.contents=new X(t),this.contents.pos=4,"ttcf"===r.readString(4)){if(!e)throw new Error("Must specify a font name for TTC files.");throw new Error("Font "+e+" not found in TTC file.")}r.pos=0,this.parse(),this.subset=new T(this),this.registerTTF()}return i.open=function(t,e,n,r){return new i(function(t){var e,n,r,i,o,a;if(0<t.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var s=t.length;o="="===t.charAt(s-2)?2:"="===t.charAt(s-1)?1:0,a=new Uint8Array(3*t.length/4-o),r=0<o?t.length-4:t.length;var h=0;function c(t){a[h++]=t}for(n=e=0;e<r;e+=4,n+=3)c((16711680&(i=l(t.charAt(e))<<18|l(t.charAt(e+1))<<12|l(t.charAt(e+2))<<6|l(t.charAt(e+3))))>>16),c((65280&i)>>8),c(255&i);return 2===o?c(255&(i=l(t.charAt(e))<<2|l(t.charAt(e+1))>>4)):1===o&&(c((i=l(t.charAt(e))<<10|l(t.charAt(e+1))<<4|l(t.charAt(e+2))>>2)>>8&255),c(255&i)),a}(n),e,r)},i.prototype.parse=function(){return this.directory=new e(this.contents),this.head=new d(this),this.name=new b(this),this.cmap=new m(this),this.hhea=new g(this),this.maxp=new x(this),this.hmtx=new S(this),this.post=new y(this),this.os2=new w(this),this.loca=new C(this),this.glyf=new _(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},i.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),!0&(t=n>>16)&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},i.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},i.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},i.prototype.widthOfString=function(t,e,n){var r,i,o,a,s;for(i=a=o=0,s=(t=""+t).length;0<=s?a<s:s<a;i=0<=s?++a:--a)r=t.charCodeAt(i),o+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return o*(e/1e3)},i.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},i}();var c,X=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r;for(n=[],e=r=0;0<=t?r<t:t<r;e=0<=t?++r:--r)n[e]=String.fromCharCode(this.readByte());return n.join("")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:r<n;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,o,a,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),o=this.readByte(),a=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^o)+256*(255^a)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*o+256*a+s},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;0<=t?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),e=function(){var p;function t(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return t.prototype.encode=function(t){var e,n,r,i,o,a,s,h,c,l,u,f,d;for(d in u=Object.keys(t).length,a=Math.log(2),c=16*Math.floor(Math.log(u)/a),i=Math.floor(c/a),h=16*u-c,(n=new X).writeInt(this.scalarType),n.writeShort(u),n.writeShort(c),n.writeShort(i),n.writeShort(h),r=16*u,s=n.pos+r,o=null,f=[],t)for(l=t[d],n.writeString(d),n.writeInt(p(l)),n.writeInt(s),n.writeInt(l.length),f=f.concat(l),"head"===d&&(o=s),s+=l.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-p(n.data),n.pos=o+8,n.writeUInt32(e),n.data},p=function(t){var e,n,r,i;for(t=k.call(t);t.length%4;)t.push(0);for(n=new X(t),r=e=0,i=t.length;r<i;r+=4)e+=n.readUInt32();return 4294967295&e},t}(),u={}.hasOwnProperty,f=function(t,e){for(var n in e)u.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t};c=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var d=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e}(),p=function(){function t(n,t){var e,r,i,o,a,s,h,c,l,u,f,d,p,g,m,w,y,v;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),l=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=m=0;m<256;s=++m)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),u=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,p=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),h=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),c=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,a=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=w=0,v=i.length;w<v;s=++w)for(g=i[s],e=y=d=p[s];d<=g?y<=g:g<=y;e=d<=g?++y:--y)0===c[s]?o=e+h[s]:0!==(o=a[c[s]/2+(e-d)-(u-s)]||0)&&(o+=h[s]),this.codeMap[e]=65535&o}n.pos=l}return t.encode=function(t,e){var n,r,i,o,a,s,h,c,l,u,f,d,p,g,m,w,y,v,b,x,S,k,_,A,I,C,T,F,P,E,q,O,B,R,j,D,M,U,N,z,L,H,W,G,V,Y;switch(F=new X,o=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(p=0,g=function(){var t,e;for(e=[],d=t=0;t<256;d=++t)e.push(0);return e}(),w={0:0},i={},P=0,B=o.length;P<B;P++)null==w[W=t[r=o[P]]]&&(w[W]=++p),i[r]={old:t[r],new:w[t[r]]},g[r]=w[t[r]];return F.writeUInt16(1),F.writeUInt16(0),F.writeUInt32(12),F.writeUInt16(0),F.writeUInt16(262),F.writeUInt16(0),F.write(g),{charMap:i,subtable:F.data,maxGlyphID:p+1};case"unicode":for(C=[],l=[],w={},n={},m=h=null,E=y=0,R=o.length;E<R;E++)null==w[b=t[r=o[E]]]&&(w[b]=++y),n[r]={old:b,new:w[b]},a=w[b]-r,null!=m&&a===h||(m&&l.push(m),C.push(r),h=a),m=r;for(m&&l.push(m),l.push(65535),C.push(65535),A=2*(_=C.length),k=2*Math.pow(Math.log(_)/Math.LN2,2),u=Math.log(k/2)/Math.LN2,S=2*_-k,s=[],x=[],f=[],d=q=0,j=C.length;q<j;d=++q){if(I=C[d],c=l[d],65535===I){s.push(0),x.push(0);break}if(32768<=I-(T=n[I].new))for(s.push(0),x.push(2*(f.length+_-d)),r=O=I;I<=c?O<=c:c<=O;r=I<=c?++O:--O)f.push(n[r].new);else s.push(T-I),x.push(0)}for(F.writeUInt16(3),F.writeUInt16(1),F.writeUInt32(12),F.writeUInt16(4),F.writeUInt16(16+8*_+2*f.length),F.writeUInt16(0),F.writeUInt16(A),F.writeUInt16(k),F.writeUInt16(u),F.writeUInt16(S),L=0,D=l.length;L<D;L++)r=l[L],F.writeUInt16(r);for(F.writeUInt16(0),H=0,M=C.length;H<M;H++)r=C[H],F.writeUInt16(r);for(G=0,U=s.length;G<U;G++)a=s[G],F.writeUInt16(a);for(V=0,N=x.length;V<N;V++)v=x[V],F.writeUInt16(v);for(Y=0,z=f.length;Y<z;Y++)p=f[Y],F.writeUInt16(p);return{charMap:n,subtable:F.data,maxGlyphID:y+1}}},t}(),m=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:n<r;0<=n?++r:--r)e=new p(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=p.encode(t,e),(r=new X).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},e}(),g=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),w=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="OS/2",e.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},e}(),y=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="post",e.prototype.parse=function(r){var t,e,n,i;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:for(e=r.readUInt16(),this.glyphNameIndex=[],n=0;0<=e?n<e:e<n;0<=e?++n:--n)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],i=[];r.pos<this.offset+this.length;)t=r.readByte(),i.push(this.names.push(r.readString(t)));return i;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},e}(),v=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},b=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="name",e.prototype.parse=function(t){var e,n,r,i,o,a,s,h,c,l,u,f;for(t.pos=this.offset,t.readShort(),e=t.readShort(),a=t.readShort(),n=[],i=c=0;0<=e?c<e:e<c;i=0<=e?++c:--c)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+a+t.readShort()});for(s={},i=l=0,u=n.length;l<u;i=++l)r=n[i],t.pos=r.offset,h=t.readString(r.length),o=new v(h,r),null==s[f=r.nameID]&&(s[f]=[]),s[r.nameID].push(o);return this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5],this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,""),this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),x=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),S=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="hmtx",e.prototype.parse=function(n){var t,r,i,e,o,a,s;for(n.pos=this.offset,this.metrics=[],e=0,a=this.file.hhea.numberOfMetrics;0<=a?e<a:a<e;0<=a?++e:--e)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(r=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],t=0;0<=r?t<r:r<t;0<=r?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)i=n[t],r.push(i.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],o=0;0<=r?o<r:r<o;0<=r?++o:--o)s.push(this.widths.push(t));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),k=[].slice,_=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="glyf",e.prototype.parse=function(t){return this.cache={}},e.prototype.glyphFor=function(t){var e,n,r,i,o,a,s,h,c,l;return(t=t)in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,o=(a=new X(e.read(r))).readShort(),h=a.readShort(),l=a.readShort(),s=a.readShort(),c=a.readShort(),this.cache[t]=-1===o?new I(a,h,l,s,c):new A(a,o,h,l,s,c),this.cache[t]))},e.prototype.encode=function(t,e,n){var r,i,o,a,s;for(o=[],i=[],a=0,s=e.length;a<s;a++)r=t[e[a]],i.push(o.length),r&&(o=o.concat(r.encode(n)));return i.push(o.length),{table:o,offsets:i}},e}(),A=function(){function t(t,e,n,r,i,o){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=o,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),I=function(){function t(t,e,n,r,i){var o,a;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],o=this.raw;a=o.readShort(),this.glyphOffsets.push(o.pos),this.glyphIDs.push(o.readShort()),32&a;)o.pos+=1&a?4:2,128&a?o.pos+=8:64&a?o.pos+=4:8&a&&(o.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(t){var e,n,r,i,o;for(n=new X(k.call(this.raw.data)),e=r=0,i=(o=this.glyphIDs).length;r<i;e=++r)o[e],n.pos=this.glyphOffsets[e];return n.data},t}(),C=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="loca",e.prototype.parse=function(r){var t;return r.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=2)n.push(2*r.readUInt16());return n}.call(this):function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=4)n.push(r.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,o=0;o<n.length;++o)if(n[o]=r,i<e.length&&e[i]==o){++i,n[o]=r;var a=this.offsets[o],s=this.offsets[o+1]-a;0<s&&(r+=s)}for(var h=new Array(4*n.length),c=0;c<n.length;++c)h[4*c+3]=255&n[c],h[4*c+2]=(65280&n[c])>>8,h[4*c+1]=(16711680&n[c])>>16,h[4*c]=(4278190080&n[c])>>24;return h},e}(),T=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},t.prototype.glyphsFor=function(t){var e,n,r,i,o,a,s;for(r={},o=0,a=t.length;o<a;o++)r[i=t[o]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},t.prototype.encode=function(t){var e,n,r,i,o,a,s,h,c,l,u,f,d,p,g;for(n in e=m.encode(this.generateCmap(),"unicode"),i=this.glyphsFor(t),u={0:0},g=e.charMap)u[(a=g[n]).old]=a.new;for(f in l=e.maxGlyphID,i)f in u||(u[f]=l++);return h=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(u),c=Object.keys(h).sort(function(t,e){return t-e}),d=function(){var t,e,n;for(n=[],t=0,e=c.length;t<e;t++)o=c[t],n.push(h[o]);return n}(),r=this.font.glyf.encode(i,d,u),s=this.font.loca.encode(r.offsets,d),p={cmap:this.font.cmap.raw(),glyf:r.table,loca:s,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.raw()},this.font.os2.exists&&(p["OS/2"]=this.font.os2.raw()),this.font.directory.encode(p)},t}();t.API.PDFObject=function(){var o;function a(){}return o=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},a.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(a.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+o(r.getUTCFullYear(),4)+o(r.getUTCMonth(),2)+o(r.getUTCDate(),2)+o(r.getUTCHours(),2)+o(r.getUTCMinutes(),2)+o(r.getUTCSeconds(),2)+"Z)";if("[object Object]"==={}.toString.call(r)){for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+a.convert(n));return e.push(">>"),e.join("\n")}return""+r},a}()}($),
/*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */
pt="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),gt=function(){var c,n,r;function i(t){var e,n,r,i,o,a,s,h,c,l,u,f,d,p;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),c=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===c&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(l=r-this.transparency.indexed.length))for(d=0;0<=l?d<l:l<d;0<=l?++d:--d)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(u=this.read(e)).indexOf(0),h=String.fromCharCode.apply(String,u.slice(0,s)),this.text[h]=String.fromCharCode.apply(String,u.slice(s+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(p=this.colorType)||6===p,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.load=function(t,e,n){var r;return"function"==typeof e&&(n=e),(r=new XMLHttpRequest).open("GET",t,!0),r.responseType="arraybuffer",r.onload=function(){var t;return t=new i(new Uint8Array(r.response||r.mozResponseArrayBuffer)),"function"==typeof(null!=e?e.getContext:void 0)&&t.render(e),"function"==typeof n?n(t):void 0},r.send(null)},i.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(E){var q=this.pixelBitlength/8,O=new Uint8Array(this.width*this.height*q),B=0,R=this;if(null==E&&(E=this.imgData),0===E.length)return new Uint8Array(0);function t(t,e,n,r){var i,o,a,s,h,c,l,u,f,d,p,g,m,w,y,v,b,x,S,k,_,A=Math.ceil((R.width-t)/n),I=Math.ceil((R.height-e)/r),C=R.width==A&&R.height==I;for(w=q*A,g=C?O:new Uint8Array(w*I),c=E.length,o=m=0;m<I&&B<c;){switch(E[B++]){case 0:for(s=b=0;b<w;s=b+=1)g[o++]=E[B++];break;case 1:for(s=x=0;x<w;s=x+=1)i=E[B++],h=s<q?0:g[o-q],g[o++]=(i+h)%256;break;case 2:for(s=S=0;S<w;s=S+=1)i=E[B++],a=(s-s%q)/q,y=m&&g[(m-1)*w+a*q+s%q],g[o++]=(y+i)%256;break;case 3:for(s=k=0;k<w;s=k+=1)i=E[B++],a=(s-s%q)/q,h=s<q?0:g[o-q],y=m&&g[(m-1)*w+a*q+s%q],g[o++]=(i+Math.floor((h+y)/2))%256;break;case 4:for(s=_=0;_<w;s=_+=1)i=E[B++],a=(s-s%q)/q,h=s<q?0:g[o-q],0===m?y=v=0:(y=g[(m-1)*w+a*q+s%q],v=a&&g[(m-1)*w+(a-1)*q+s%q]),l=h+y-v,u=Math.abs(l-h),d=Math.abs(l-y),p=Math.abs(l-v),f=u<=d&&u<=p?h:d<=p?y:v,g[o++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+E[B-1])}if(!C){var T=((e+m*r)*R.width+t)*q,F=m*w;for(s=0;s<A;s+=1){for(var P=0;P<q;P+=1)O[T++]=g[F++];T+=(n-1)*q}}m++}}return E=(E=new kt(E)).getBytes(),1==R.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),O},i.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,h;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,n.length,e=a=t=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(h=o[t++])?h:255;return i},i.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,h,c,l,u,f;if(r=this.colors,l=null,n=this.hasAlphaChannel,this.palette.length&&(l=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),c=(i=t.data||t).length,a=l||e,o=s=0,1===r)for(;o<c;)h=l?4*e[o/4]:s,u=a[h++],i[o++]=u,i[o++]=u,i[o++]=u,i[o++]=n?a[h++]:255,s=h;else for(;o<c;)h=l?4*e[o/4]:s,i[o++]=a[h++],i[o++]=a[h++],i[o++]=a[h++],i[o++]=n?a[h++]:255,s=h},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{n=pt.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return-1}return c=function(t){var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},i.prototype.decodeFrames=function(t){var e,n,r,i,o,a,s,h;if(this.animation){for(h=[],n=o=0,a=(s=this.animation.frames).length;o<a;n=++o)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,h.push(e.image=c(r));return h}},i.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},i.prototype.animate=function(n){var r,i,o,a,s,t,h=this;return i=0,t=this.animation,a=t.numFrames,o=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%a,e=o[t],h.renderFrame(n,t),1<a&&i/a<s)return h.animation._timeout=setTimeout(r,e.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},i}(),pt.PNG=gt;
/*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */
var St=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),kt=function(){if("undefined"!=typeof Uint32Array){var F=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),P=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),E=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),q=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],O=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(St.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,o=this.bytesPos;n<t;)void 0===(e=i[o++])&&B("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=o,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<n;){var s;void 0===(s=o[a++])&&B("Bad encoding in flate stream"),i|=s<<r,r+=8}var h=e[i&(1<<n)-1],c=h>>16,l=65535&h;return(0==r||r<c||0==c)&&B("Bad encoding in flate stream"),this.codeBuf=i>>c,this.codeSize=r-c,this.bytesPos=a,l},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,h=2;a<=n;++a,s<<=1,h<<=1)for(var c=0;c<e;++c)if(t[c]==a){var l=0,u=s;for(r=0;r<a;++r)l=l<<1|1&u,u>>=1;for(r=l;r<i;r+=h)o[r]=a<<16|c;++s}return[o,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var o=t.getBits(n)+r;0<o--;)e[h++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=q,r=O;else if(2==e){for(var i=this.getBits(5)+257,o=this.getBits(5)+1,a=this.getBits(4)+4,s=Array(F.length),h=0;h<a;)s[F[h++]]=this.getBits(3);for(var c=this.generateHuffmanTable(s),l=0,u=(h=0,i+o),f=new Array(u);h<u;){var d=this.getCode(c);16==d?t(this,f,2,3,l):17==d?t(this,f,3,3,l=0):18==d?t(this,f,7,11,l=0):f[h++]=l=d}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,u))}else B("Unknown block type in flate stream");for(var p=(I=this.buffer)?I.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)p<=g+1&&(p=(I=this.ensureBuffer(g+1)).length),I[g++]=m;else{if(256==m)return void(this.bufferLength=g);var w=(m=P[m-=257])>>16;0<w&&(w=this.getBits(w));l=(65535&m)+w;m=this.getCode(r),0<(w=(m=E[m])>>16)&&(w=this.getBits(w));var y=(65535&m)+w;p<=g+l&&(p=(I=this.ensureBuffer(g+l)).length);for(var v=0;v<l;++v,++g)I[g]=I[g-y]}}}else{var b,x=this.bytes,S=this.bytesPos;void 0===(b=x[S++])&&B("Bad block header in flate stream");var k=b;void 0===(b=x[S++])&&B("Bad block header in flate stream"),k|=b<<8,void 0===(b=x[S++])&&B("Bad block header in flate stream");var _=b;void 0===(b=x[S++])&&B("Bad block header in flate stream"),(_|=b<<8)!=(65535&~k)&&B("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var A=this.bufferLength,I=this.ensureBuffer(A+k),C=A+k;this.bufferLength=C;for(var T=A;T<C;++T){if(void 0===(b=x[S++])){this.eof=!0;break}I[T]=b}this.bytesPos=S}},t}function B(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||B("Invalid header in flate stream"),8!=(15&n)&&B("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&B("Bad FCHECK in flate stream"),32&r&&B("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,St.call(this)}}();return function(t){if("object"!=typeof t.console){t.console={};for(var e,n,r=t.console,i=function(){},o=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=o.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=i)}var s,h,c,l,u="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,o,a=0,s=0,h="",c=[];if(!t)return t;for(;e=(o=t.charCodeAt(a++)<<16|t.charCodeAt(a++)<<8|t.charCodeAt(a++))>>18&63,n=o>>12&63,r=o>>6&63,i=63&o,c[s++]=u.charAt(e)+u.charAt(n)+u.charAt(r)+u.charAt(i),a<t.length;);h=c.join("");var l=t.length%3;return(l?h.slice(0,l-3):h)+"===".slice(l||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,o,a,s=0,h=0,c=[];if(!t)return t;for(t+="";e=(a=u.indexOf(t.charAt(s++))<<18|u.indexOf(t.charAt(s++))<<12|(i=u.indexOf(t.charAt(s++)))<<6|(o=u.indexOf(t.charAt(s++))))>>16&255,n=a>>8&255,r=255&a,c[h++]=64==i?String.fromCharCode(e):64==o?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return c.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,h=!{toString:null}.propertyIsEnumerable("toString"),l=(c=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!=typeof t&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(h)for(n=0;n<l;n++)s.call(t,c[n])&&r.push(c[n]);return r})),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")})}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),$});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(30)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(43)('wks');
var uid = __webpack_require__(25);
var Symbol = __webpack_require__(10).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (options) {
  var mappedProps = options.mappedProps,
      name = options.name,
      ctr = options.ctr,
      ctrArgs = options.ctrArgs,
      events = options.events,
      beforeCreate = options.beforeCreate,
      afterCreate = options.afterCreate,
      props = options.props,
      rest = _objectWithoutProperties(options, ['mappedProps', 'name', 'ctr', 'ctrArgs', 'events', 'beforeCreate', 'afterCreate', 'props']);

  var promiseName = '$' + name + 'Promise';
  var instanceName = '$' + name + 'Object';

  assert(!(rest.props instanceof Array), '`props` should be an object, not Array');

  return _extends({}, typeof GENERATE_DOC !== 'undefined' ? { $vgmOptions: options } : {}, {
    mixins: [_mapElementMixin2.default],
    props: _extends({}, props, mappedPropsToVueProps(mappedProps)),
    render: function render() {
      return '';
    },
    provide: function provide() {
      var _this = this;

      var promise = this.$mapPromise.then(function (map) {
        // Infowindow needs this to be immediately available
        _this.$map = map;

        // Initialize the maps with the given options
        var options = _extends({}, _this.options, {
          map: map
        }, (0, _bindProps.getPropsValues)(_this, mappedProps));
        delete options.options; // delete the extra options

        if (beforeCreate) {
          var result = beforeCreate.bind(_this)(options);

          if (result instanceof Promise) {
            return result.then(function () {
              return { options: options };
            });
          }
        }
        return { options: options };
      }).then(function (_ref) {
        var _Function$prototype$b;

        var options = _ref.options;

        var ConstructorObject = ctr();
        // https://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
        _this[instanceName] = ctrArgs ? new ((_Function$prototype$b = Function.prototype.bind).call.apply(_Function$prototype$b, [ConstructorObject, null].concat(_toConsumableArray(ctrArgs(options, (0, _bindProps.getPropsValues)(_this, props || {}))))))() : new ConstructorObject(options);

        (0, _bindProps.bindProps)(_this, _this[instanceName], mappedProps);
        (0, _bindEvents2.default)(_this, _this[instanceName], events);

        if (afterCreate) {
          afterCreate.bind(_this)(_this[instanceName]);
        }
        return _this[instanceName];
      });
      this[promiseName] = promise;
      return _defineProperty({}, promiseName, promise);
    },
    destroyed: function destroyed() {
      // Note: not all Google Maps components support maps
      if (this[instanceName] && this[instanceName].setMap) {
        this[instanceName].setMap(null);
      }
    }
  }, rest);
};

exports.mappedPropsToVueProps = mappedPropsToVueProps;

var _bindEvents = __webpack_require__(53);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(29);

var _mapElementMixin = __webpack_require__(220);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 *
 * @param {Object} options
 * @param {Object} options.mappedProps - Definitions of props
 * @param {Object} options.mappedProps.PROP.type - Value type
 * @param {Boolean} options.mappedProps.PROP.twoWay
 *  - Whether the prop has a corresponding PROP_changed
 *   event
 * @param {Boolean} options.mappedProps.PROP.noBind
 *  - If true, do not apply the default bindProps / bindEvents.
 * However it will still be added to the list of component props
 * @param {Object} options.props - Regular Vue-style props.
 *  Note: must be in the Object form because it will be
 *  merged with the `mappedProps`
 *
 * @param {Object} options.events - Google Maps API events
 *  that are not bound to a corresponding prop
 * @param {String} options.name - e.g. `polyline`
 * @param {=> String} options.ctr - constructor, e.g.
 *  `google.maps.Polyline`. However, since this is not
 *  generally available during library load, this becomes
 *  a function instead, e.g. () => google.maps.Polyline
 *  which will be called only after the API has been loaded
 * @param {(MappedProps, OtherVueProps) => Array} options.ctrArgs -
 *   If the constructor in `ctr` needs to be called with
 *   arguments other than a single `options` object, e.g. for
 *   GroundOverlay, we call `new GroundOverlay(url, bounds, options)`
 *   then pass in a function that returns the argument list as an array
 *
 * Otherwise, the constructor will be called with an `options` object,
 *   with property and values merged from:
 *
 *   1. the `options` property, if any
 *   2. a `map` property with the Google Maps
 *   3. all the properties passed to the component in `mappedProps`
 * @param {Object => Any} options.beforeCreate -
 *  Hook to modify the options passed to the initializer
 * @param {(options.ctr, Object) => Any} options.afterCreate -
 *  Hook called when
 *
 */


function assert(v, message) {
  if (!v) throw new Error(message);
}

/**
 * Strips out the extraneous properties we have in our
 * props definitions
 * @param {Object} props
 */
function mappedPropsToVueProps(mappedProps) {
  return Object.entries(mappedProps).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        prop = _ref4[1];

    var value = {};

    if ('type' in prop) value.type = prop.type;
    if ('default' in prop) value.default = prop.default;
    if ('required' in prop) value.required = prop.required;

    return [key, value];
  }).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        val = _ref6[1];

    acc[key] = val;
    return acc;
  }, {});
}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 11 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(11);
var hide = __webpack_require__(13);
var redefine = __webpack_require__(24);
var ctx = __webpack_require__(60);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(18);
var createDesc = __webpack_require__(33);
module.exports = __webpack_require__(19) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var util = __webpack_require__(37);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled || false;
        this.options_ = util.deepCopy(options);
        this.INTERNAL = {
            getUid: function () { return null; },
            getToken: function () { return Promise.resolve(null); },
            addAuthTokenListener: function (callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () { return callback(null); }, 0);
            },
            removeAuthTokenListener: function (callback) {
                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this._automaticDataCollectionEnabled;
        },
        set: function (val) {
            this.checkDestroyed_();
            this._automaticDataCollectionEnabled = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            Object.keys(_this.services_).forEach(function (serviceKey) {
                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
                    services.push(_this.services_[serviceKey][instanceKey]);
                });
            });
            return Promise.all(services.map(function (service) {
                return service.INTERNAL.delete();
            }));
        })
            .then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage is the only one that is leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
                ? instanceIdentifier
                : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    FirebaseAppImpl.prototype.extendApp = function (props) {
        var _this = this;
        // Copy the object onto the FirebaseAppImpl prototype
        util.deepExtend(this, props);
        /**
         * If the app has overwritten the addAuthTokenListener stub, forward
         * the active token listeners on to the true fxn.
         *
         * TODO: This function is required due to our current module
         * structure. Once we are able to rely strictly upon a single module
         * implementation, this code should be refactored and Auth should
         * provide these stubs and the upgrade logic
         */
        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
            tokenListeners.forEach(function (listener) {
                _this.INTERNAL.addAuthTokenListener(listener);
            });
            tokenListeners = [];
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            error('app-deleted', { name: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var apps_ = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        __esModule: true,
        initializeApp: initializeApp,
        app: app,
        apps: null,
        Promise: Promise,
        SDK_VERSION: '5.8.3',
        INTERNAL: {
            registerService: registerService,
            createFirebaseNamespace: createFirebaseNamespace,
            extendNamespace: extendNamespace,
            createSubscribe: util.createSubscribe,
            ErrorFactory: util.ErrorFactory,
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService,
            Promise: Promise,
            deepExtend: util.deepExtend
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    util.patchProperty(namespace, 'default', namespace);
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps_[name];
        callAppHooks(app, 'delete');
        delete apps_[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!contains(apps_, name)) {
            error('no-app', { name: name });
        }
        return apps_[name];
    }
    util.patchProperty(app, 'App', FirebaseAppImpl);
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            error('bad-app-name', { name: name + '' });
        }
        if (contains(apps_, name)) {
            error('duplicate-app', { name: name });
        }
        var app = new FirebaseAppImpl(options, config, namespace);
        apps_[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps_).map(function (name) { return apps_[name]; });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        // Cannot re-register a service that already exists
        if (factories[name]) {
            error('duplicate-service', { name: name });
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        var serviceNamespace = function (appArg) {
            if (appArg === void 0) { appArg = app(); }
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                error('invalid-app-argument', { name: name });
            }
            // Forward service instance lookup to the FirebaseApp.
            return appArg[name]();
        };
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            util.deepExtend(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        FirebaseAppImpl.prototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var serviceFxn = this._getService.bind(this, name);
            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
        };
        return serviceNamespace;
    }
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        util.deepExtend(namespace, props);
    }
    function callAppHooks(app, eventName) {
        Object.keys(factories).forEach(function (serviceName) {
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        });
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        var options = app.options;
        return useService;
    }
    return namespace;
}
function error(code, args) {
    throw appErrors.create(code, args);
}
// TypeScript does not support non-string indexes!
// let errors: {[code: AppError: string} = {
var errors = {
    'no-app': "No Firebase App '{$name}' has been created - " +
        'call Firebase App.initializeApp()',
    'bad-app-name': "Illegal App name: '{$name}",
    'duplicate-app': "Firebase App named '{$name}' already exists",
    'app-deleted': "Firebase App named '{$name}' already deleted",
    'duplicate-service': "Firebase service named '{$name}' already registered",
    'sa-not-supported': 'Initializing the Firebase SDK with a service ' +
        'account is only allowed in a Node.js environment. On client ' +
        'devices, you should instead initialize the SDK with an api key and ' +
        'auth domain',
    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' +
        'Firebase App instance.'
};
var appErrors = new util.ErrorFactory('app', 'Firebase', errors);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firebase = createFirebaseNamespace();

exports.firebase = firebase;
exports.default = firebase;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

__webpack_require__(234);
var firebase = _interopDefault(__webpack_require__(16));
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
console.warn("\nIt looks like you're using the development build of the Firebase JS SDK.\nWhen deploying Firebase apps to production, it is advisable to only import\nthe individual SDK components you intend to use.\n\nFor the module builds, these are available in the following manner\n(replace <PACKAGE> with the name of a component - i.e. auth, database, etc):\n\nCommonJS Modules:\nconst firebase = require('firebase/app');\nrequire('firebase/<PACKAGE>');\n\nES Modules:\nimport firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n\nTypescript:\nimport * as firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n");

module.exports = firebase;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(32);
var IE8_DOM_DEFINE = __webpack_require__(58);
var toPrimitive = __webpack_require__(39);
var dP = Object.defineProperty;

exports.f = __webpack_require__(19) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(23)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(40);
var defined = __webpack_require__(26);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(293)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var hide = __webpack_require__(13);
var has = __webpack_require__(15);
var SRC = __webpack_require__(25)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(11).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 25 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(63);
var enumBugKeys = __webpack_require__(46);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropsValues = getPropsValues;
exports.bindProps = bindProps;

var _WatchPrimitiveProperties = __webpack_require__(54);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getPropsValues(vueInst, props) {
  return Object.keys(props).reduce(function (acc, prop) {
    if (vueInst[prop] !== undefined) {
      acc[prop] = vueInst[prop];
    }
    return acc;
  }, {});
}

/**
  * Binds the properties defined in props to the google maps instance.
  * If the prop is an Object type, and we wish to track the properties
  * of the object (e.g. the lat and lng of a LatLng), then we do a deep
  * watch. For deep watch, we also prevent the _changed event from being
  * emitted if the data source was external.
  */
function bindProps(vueInst, googleMapsInst, props) {
  var _loop = function (attribute) {
    var _props$attribute = props[attribute],
        twoWay = _props$attribute.twoWay,
        type = _props$attribute.type,
        trackProperties = _props$attribute.trackProperties,
        noBind = _props$attribute.noBind;


    if (noBind) return 'continue';

    var setMethodName = 'set' + capitalizeFirstLetter(attribute);
    var getMethodName = 'get' + capitalizeFirstLetter(attribute);
    var eventName = attribute.toLowerCase() + '_changed';
    var initialValue = vueInst[attribute];

    if (typeof googleMapsInst[setMethodName] === 'undefined') {
      throw new Error(setMethodName + ' is not a method of (the Maps object corresponding to) ' + vueInst.$options._componentTag);
    }

    // We need to avoid an endless
    // propChanged -> event emitted -> propChanged -> event emitted loop
    // although this may really be the user's responsibility
    if (type !== Object || !trackProperties) {
      // Track the object deeply
      vueInst.$watch(attribute, function () {
        var attributeValue = vueInst[attribute];

        googleMapsInst[setMethodName](attributeValue);
      }, {
        immediate: typeof initialValue !== 'undefined',
        deep: type === Object
      });
    } else {
      (0, _WatchPrimitiveProperties2.default)(vueInst, trackProperties.map(function (prop) {
        return attribute + '.' + prop;
      }), function () {
        googleMapsInst[setMethodName](vueInst[attribute]);
      }, vueInst[attribute] !== undefined);
    }

    if (twoWay && (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName])) {
      googleMapsInst.addListener(eventName, function () {
        // eslint-disable-line no-unused-vars
        vueInst.$emit(eventName, googleMapsInst[getMethodName]());
      });
    }
  };

  for (var attribute in props) {
    var _ret = _loop(attribute);

    if (_ret === 'continue') continue;
  }
}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapMutations; });
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__(28);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) == 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array<number>} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [], pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param {boolean=} opt_webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeByteArray: function (input, opt_webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = opt_webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param {string} input A string to encode.
     * @param {boolean=} opt_webSafe If true, we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param {string} input to decode.
     * @param {boolean=} opt_webSafe True if we should use the
     *     alternative alphabet.
     * @return {string} string representing the decoded value.
     */
    decodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param {string} input Input to decode.
     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
     * @return {!Array<number>} bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, opt_webSafe) {
        this.init_();
        var charToByteMap = opt_webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 != 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 != 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
     * @return {!function(?(Error), ?=)}
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return {string} user agent string
 */
var getUA = function () {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
};
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
 * Cordova `onDeviceReady`, which would normally wait for a callback.
 *
 * @return {boolean} isMobileCordova
 */
var isMobileCordova = function () {
    return (typeof window !== 'undefined' &&
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
};
/**
 * Detect React Native.
 *
 * @return {boolean} True if ReactNative environment is detected.
 */
var isReactNative = function () {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
};
/**
 * Detect Node.js.
 *
 * @return {boolean} True if Node.js environment is detected.
 */
var isNodeSdk = function () {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
};

var ERROR_NAME = 'FirebaseError';
var captureStackTrace = Error
    .captureStackTrace;
// Export for faking in tests
function patchCapture(captureFake) {
    var result = captureStackTrace;
    captureStackTrace = captureFake;
    return result;
}
var FirebaseError = /** @class */ (function () {
    function FirebaseError(code, message) {
        this.code = code;
        this.message = message;
        // We want the stack value, if implemented by Error
        if (captureStackTrace) {
            // Patches this.stack, omitted calls above ErrorFactory#create
            captureStackTrace(this, ErrorFactory.prototype.create);
        }
        else {
            try {
                // In case of IE11, stack will be set only after error is raised.
                // https://docs.microsoft.com/en-us/scripting/javascript/reference/stack-property-error-javascript
                throw Error.apply(this, arguments);
            }
            catch (err) {
                this.name = ERROR_NAME;
                // Make non-enumerable getter for the property.
                Object.defineProperty(this, 'stack', {
                    get: function () {
                        return err.stack;
                    }
                });
            }
        }
    }
    return FirebaseError;
}());
// Back-door inheritance
FirebaseError.prototype = Object.create(Error.prototype);
FirebaseError.prototype.constructor = FirebaseError;
FirebaseError.prototype.name = ERROR_NAME;
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
        // Matches {$name}, by default.
        this.pattern = /\{\$([^}]+)}/g;
        // empty
    }
    ErrorFactory.prototype.create = function (code, data) {
        if (data === undefined) {
            data = {};
        }
        var template = this.errors[code];
        var fullCode = this.service + '/' + code;
        var message;
        if (template === undefined) {
            message = 'Error';
        }
        else {
            message = template.replace(this.pattern, function (match, key) {
                var value = data[key];
                return value !== undefined ? value.toString() : '<' + key + '?>';
            });
        }
        // Service: Error message (service/code).
        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
        var err = new FirebaseError(fullCode, message);
        // Populate the Error object with message parts for programmatic
        // accesses (e.g., e.file).
        for (var prop in data) {
            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
                continue;
            }
            err[prop] = data[prop];
        }
        return err;
    };
    return ErrorFactory;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {{header: *, claims: *, data: *, signature: string}}
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {?number}
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var safeGet = function (obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key))
        return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var forEach = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
var extend = function (objTo, objFrom) {
    forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
var clone = function (obj) {
    return extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
var isNonNullObject = function (obj) {
    return typeof obj === 'object' && obj !== null;
};
var isEmpty = function (obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
var getCount = function (obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
var map = function (obj, f, opt_obj) {
    var res = {};
    for (var key in obj) {
        res[key] = f.call(opt_obj, obj[key], key, obj);
    }
    return res;
};
var findKey = function (obj, fn, opt_this) {
    for (var key in obj) {
        if (fn.call(opt_this, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
var findValue = function (obj, fn, opt_this) {
    var key = findKey(obj, fn, opt_this);
    return key && obj[key];
};
var getAnyKey = function (obj) {
    for (var key in obj) {
        return key;
    }
};
var getValues = function (obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var every = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 *
 * @param {!Object} querystringParams
 * @return {string}
 */
var querystring = function (querystringParams) {
    var params = [];
    forEach(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
var querystringDecode = function (querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Copyright 2011 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Abstract cryptographic hash interface.
 *
 * See Sha1 and Md5 for sample implementations.
 *
 */
/**
 * Create a cryptographic hash instance.
 *
 * @constructor
 * @struct
 */
var Hash = /** @class */ (function () {
    function Hash() {
        /**
         * The block size for the hasher.
         * @type {number}
         */
        this.blockSize = -1;
    }
    return Hash;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @extends {Hash}
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function (_super) {
    tslib_1.__extends(Sha1, _super);
    function Sha1() {
        var _this = _super.call(this) || this;
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @type {!Array<number>}
         * @private
         */
        _this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @type {!Array<number>}
         * @private
         */
        _this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @type {!Array<number>}
         * @private
         */
        _this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @type {!Array<number>}
         * @private
         */
        _this.pad_ = [];
        /**
         * @private {number}
         */
        _this.inbuf_ = 0;
        /**
         * @private {number}
         */
        _this.total_ = 0;
        _this.blockSize = 512 / 8;
        _this.pad_[0] = 128;
        for (var i = 1; i < _this.blockSize; ++i) {
            _this.pad_[i] = 0;
        }
        _this.reset();
        return _this;
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
     * @param {number=} opt_offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, opt_offset) {
        if (!opt_offset) {
            opt_offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(opt_offset) << 24) |
                        (buf.charCodeAt(opt_offset + 1) << 16) |
                        (buf.charCodeAt(opt_offset + 2) << 8) |
                        buf.charCodeAt(opt_offset + 3);
                opt_offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[opt_offset] << 24) |
                        (buf[opt_offset + 1] << 16) |
                        (buf[opt_offset + 2] << 8) |
                        buf[opt_offset + 3];
                opt_offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, opt_length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (opt_length === undefined) {
            opt_length = bytes.length;
        }
        var lengthMinusBlock = opt_length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < opt_length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf == 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < opt_length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < opt_length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += opt_length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}(Hash));

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param {!string} fnName The function name
 * @param {!number} minCount The minimum number of arguments to allow for the function call
 * @param {!number} maxCount The maximum number of argument to allow for the function call
 * @param {!number} argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param {!string} fnName The function name
 * @param {!number} argumentNumber The index of the argument
 * @param {boolean} optional Whether or not the argument is optional
 * @return {!string} The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param {!string} fnName
 * @param {!number} argumentNumber
 * @param {!string} namespace
 * @param {boolean} optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace)
        return;
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback)
        return;
    if (typeof callback !== 'function')
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context)
        return;
    if (typeof context !== 'object' || context === null)
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.assert = assert;
exports.assertionError = assertionError;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.CONSTANTS = CONSTANTS;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.patchProperty = patchProperty;
exports.Deferred = Deferred;
exports.getUA = getUA;
exports.isMobileCordova = isMobileCordova;
exports.isNodeSdk = isNodeSdk;
exports.isReactNative = isReactNative;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.patchCapture = patchCapture;
exports.jsonEval = jsonEval;
exports.stringify = stringify;
exports.decode = decode;
exports.isAdmin = isAdmin;
exports.issuedAtTime = issuedAtTime;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.clone = clone;
exports.contains = contains;
exports.every = every;
exports.extend = extend;
exports.findKey = findKey;
exports.findValue = findValue;
exports.forEach = forEach;
exports.getAnyKey = getAnyKey;
exports.getCount = getCount;
exports.getValues = getValues;
exports.isEmpty = isEmpty;
exports.isNonNullObject = isNonNullObject;
exports.map = map;
exports.safeGet = safeGet;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.Sha1 = Sha1;
exports.async = async;
exports.createSubscribe = createSubscribe;
exports.errorPrefix = errorPrefix;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateNamespace = validateNamespace;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(292);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(22)("b6db49fc", content, true, {});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(14);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(34);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(26);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(35);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(7)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(13)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(43)('keys');
var uid = __webpack_require__(25);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 47 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(18).f;
var has = __webpack_require__(15);
var TAG = __webpack_require__(7)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(7);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(11);
var LIBRARY = __webpack_require__(51);
var wksExt = __webpack_require__(49);
var defineProperty = __webpack_require__(18).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (vueInst, googleMapsInst, events) {
  var _loop = function (eventName) {
    if (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName]) {
      googleMapsInst.addListener(eventName, function (ev) {
        vueInst.$emit(eventName, ev);
      });
    }
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WatchPrimitiveProperties;
/**
 * Watch the individual properties of a PoD object, instead of the object
 * per se. This is different from a deep watch where both the reference
 * and the individual values are watched.
 *
 * In effect, it throttles the multiple $watch to execute at most once per tick.
 */
function WatchPrimitiveProperties(vueInst, propertiesToTrack, handler) {
  var immediate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var isHandled = false;

  function requestHandle() {
    if (!isHandled) {
      isHandled = true;
      vueInst.$nextTick(function () {
        isHandled = false;
        handler();
      });
    }
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = propertiesToTrack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var prop = _step.value;

      vueInst.$watch(prop, requestHandle, { immediate: immediate });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/

exports.default = {
  props: ['resizeBus'],

  data: function data() {
    return {
      _actualResizeBus: null
    };
  },
  created: function created() {
    if (typeof this.resizeBus === 'undefined') {
      this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
    } else {
      this.$data._actualResizeBus = this.resizeBus;
    }
  },


  methods: {
    _resizeCallback: function _resizeCallback() {
      this.resize();
    },
    _delayedResizeCallback: function _delayedResizeCallback() {
      var _this = this;

      this.$nextTick(function () {
        return _this._resizeCallback();
      });
    }
  },

  watch: {
    resizeBus: function resizeBus(newVal) {
      // eslint-disable-line no-unused-vars
      this.$data._actualResizeBus = newVal;
    },
    '$data._actualResizeBus': function $data_actualResizeBus(newVal, oldVal) {
      if (oldVal) {
        oldVal.$off('resize', this._delayedResizeCallback);
      }
      if (newVal) {
        newVal.$on('resize', this._delayedResizeCallback);
      }
    }
  },

  destroyed: function destroyed() {
    if (this.$data._actualResizeBus) {
      this.$data._actualResizeBus.$off('resize', this._delayedResizeCallback);
    }
  }
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(230);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* App.js 
       Instancia Principal para referenciarla en index.html
       Desarrollado por JC Yocop       
======================================================================================================== */
// import firebase     from 'firebase';

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'app',
  data: function data() {
    return {};
  },

  methods: {} // methods
  // export

});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(19) && !__webpack_require__(23)(function () {
  return Object.defineProperty(__webpack_require__(59)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var document = __webpack_require__(10).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(239);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(60);
var IObject = __webpack_require__(40);
var toObject = __webpack_require__(41);
var toLength = __webpack_require__(42);
var asc = __webpack_require__(240);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(34);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(15);
var toIObject = __webpack_require__(20);
var arrayIndexOf = __webpack_require__(247)(false);
var IE_PROTO = __webpack_require__(45)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(32);
var dPs = __webpack_require__(261);
var enumBugKeys = __webpack_require__(46);
var IE_PROTO = __webpack_require__(45)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(59)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(262).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(63);
var hiddenKeys = __webpack_require__(46).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(51);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(24);
var hide = __webpack_require__(13);
var Iterators = __webpack_require__(52);
var $iterCreate = __webpack_require__(272);
var setToStringTag = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(273);
var ITERATOR = __webpack_require__(7)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLogLevel", function() { return setLogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return LogLevel; });
/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel)
        return;
    var now = new Date().toISOString();
    switch (logType) {
        /**
         * By default, `console.debug` is not displayed in the developer console (in
         * chrome). To avoid forcing users to have to opt-in to these logs twice
         * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
         * logs to the `console.log` function.
         */
        case LogLevel.DEBUG:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.VERBOSE:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.INFO:
            console.info.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.WARN:
            console.warn.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.ERROR:
            console.error.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        default:
            throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The log handler for the Logger instance.
         */
        this._logHandler = defaultLogHandler;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError('Invalid value assigned to `logLevel`');
            }
            this._logLevel = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.DEBUG].concat(args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.INFO].concat(args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.WARN].concat(args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.ERROR].concat(args));
    };
    return Logger;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.logLevel = level;
    });
}




/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */
/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'login',
    data: function data() {

        return {
            passwordact: null, passwordnew1: null, passwordnew2: null,
            bClaveOld: false, bClaveNew: false
        };
    },
    methods: {
        verifPass: function verifPass() {
            if (this.passwordact.trim() === __WEBPACK_IMPORTED_MODULE_0__store_store_js__["a" /* store */].state.st_clave.trim()) {
                // alert("Claves coinciden !");
                this.bClaveOld = true;
                // console.log("Exito clave actual ?",this.bClaveOld);
            } else {
                alert("CLAVE ACTUAL INVALIDA !!! \n" + this.passwordact + "\n" + __WEBPACK_IMPORTED_MODULE_0__store_store_js__["a" /* store */].state.st_clave);
                this.bClaveOld = false;
                this.passwordact = null;
            }
        },
        verinPass: function verinPass() {
            if (this.passwordnew1.trim() === this.passwordnew2.trim()) {
                // alert("Nuevas claves Coinciden !");
                this.bClaveNew = true;
                // console.log("Exito clave actual ?",this.bClaveNew);
            } else {
                alert("NUEVAS CLAVES NO COINCIDEN !!!");
                this.passwordnew1 = null;
                this.passwordnew2 = null;
                this.bClaveNew = false;
            }
        },
        cambiarClave: function cambiarClave() {

            var confirma = confirm("Seguro de cambiar la clave de acceso para " + __WEBPACK_IMPORTED_MODULE_0__store_store_js__["a" /* store */].state.st_nusuario + " ?");
            if (confirma === true) {

                this.verifPass();
                this.verinPass();

                var self = this;
                // console.log("Cambiando clave ...",this.bClaveOld,this.bClaveNew);
                if (this.bClaveOld && this.bClaveNew) {

                    // console.log("Entre !")
                    var user = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser;
                    var newPassword = this.passwordnew1.trim();
                    // console.log("nueva clave ? ",newPassword);
                    // var newPassword = getASecureRandomPassword();

                    user.updatePassword(newPassword).then(function () {

                        // alert("Clave cambiada con Exito !")
                        self.$router.push('/'); // Direcciona el ruteo al HOME.                        
                        // Update successful.
                    }).then(function () {

                        var lanuevaRuta = __WEBPACK_IMPORTED_MODULE_0__store_store_js__["a" /* store */].state.st_rutaUsuarios + '/' + __WEBPACK_IMPORTED_MODULE_0__store_store_js__["a" /* store */].state.st_llave;
                        var dbelUsuario = __WEBPACK_IMPORTED_MODULE_0__store_store_js__["a" /* store */].state.st_db.ref(lanuevaRuta);
                        // console.log("La nueva ruta ? ",lanuevaRuta,", la nueva clave ? ",self.passwordnew1);

                        var elRegUsuario = dbelUsuario.update({

                            clave: self.passwordnew1
                        });

                        // console.log("limpiando variables !");
                        self.passwordact = null;self.passwordnew1 = null;self.passwordnew2 = null;
                        self.bClaveOld = false;self.bClaveNew = false;
                    }).catch(function (error) {
                        // An error happened.
                    });
                } // if()
            } // if(confirma)
        } // cambiarClave()

    } // methods
    // export

});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_materialize_css_dist_css_materialize_min_css__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_materialize_css_dist_css_materialize_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_materialize_css_dist_css_materialize_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_materialize_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










//     import cabecera from './login_header.vue'

/* :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */
/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'login',
    data: function data() {
        return {
            email: null, password: null,
            ocultarClave: true, mostrarCargador: false,
            errorIngreso: false //* Por default no hay error en el ingreso

        };
    },

    mounted: function mounted() {

        var elems = document.querySelectorAll('.collapsible');
        var instances = __WEBPACK_IMPORTED_MODULE_4_materialize_css___default.a.Collapsible.init(elems, {});

        this.enfocar();
    },

    methods: {
        enfocar: function enfocar() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick().then(function () {
                return _this.$refs.email_inline.focus();
            });
        },
        toogleClave: function toogleClave() {
            this.ocultarClave = !this.ocultarClave;
        },
        signInMem: function signInMem() {

            // console.log("Estoy en sigInMem !");
            __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_logeado = true;
            __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_activo = true;
            __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles = {};
            __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.encuesta = true;
            __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_admin = true;

            var self = this; // SELF es para usarlo dentro de las promesas en lugar de THIS                
            self.$router.push('/'); // Direcciona el ruteo al HOME.                
        },
        signIn: function signIn() {

            var self = this; // SELF es para usarlo dentro de las promesas en lugar de THIS
            var elUID = ""; // Preserva la llave del usuario autenticado.
            self.mostrarCargador = true;

            /* Verifica si el usuario y clave existen en Firebase */
            __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {

                self.mostrarCargador = false;
                elUID = user.user.uid; // Otiene el UID del usuario autenticado
                self.bdReadUsuarios(elUID); // Lee el nodo del usuario para obtener su nombre completo.
                self.$router.push('/'); // Direcciona el ruteo al HOME.
            }).then(function () {

                self.laUID = elUID; // Obtiene la UID preservada.

                /* Asigna en las variables globales (las definidas en el store) los valores para: 
                    i) saber si está logeado o no el usuario; ii) la UID del usuario, su email y 
                    su password. */
                __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_logeado = true;
                __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_usuario = self.laUID;
            }).catch(function (error) {

                self.mostrarCargador = false;

                /* Obtiene el número y mensaje de error cuando la autenticación es incorrecta */
                var errorCode = error.code;
                var errorMessage = error.message;

                var miMensaje = "NO ERROR"; // Asume que no hay mensaje de error.

                if (errorCode === "auth/user-not-found") {
                    miMensaje = "Email Invalido. Cuenta NO existe !";
                } else {
                    if (errorCode === "auth/wrong-password") {
                        miMensaje = "Password Invalido. El password NO existe o No escribió Password !";
                    } else {
                        if (errorCode === "auth/invalid-email") {
                            miMensaje = "Email Invalido. La cuenta de email tiene un formato NO válido.";
                        } else {
                            if (errorCode === "auth/operation-not-allowed") {
                                miMensaje = "El proveedor de inicio de sesión dado está deshabilitado para este proyecto de Firebase.\n" + "Habilítelo en la consola de Firebase, debajo del inicio de sesión: " + "pestaña de método de la sección de autenticación.";
                            } // if
                        } // else
                    } // else
                } // else

                /* Si Encontró algún error lo muestra !*/
                if (miMensaje != "NO ERROR") {
                    alert(miMensaje);
                }
            }); // catch()
        },
        // signIn()
        getUsuarios: function getUsuarios(losUsuarios, laLlave) {

            /* Recorro la info original del nodo para encontrar el nombre del usuario */
            /* Prepara el objeto de memoria para obtener la lista de usuarios */
            // store.state.usuarios= [];
            for (var key in losUsuarios) {

                // console.log("key ? ",key,"; id ? ",", usuario ? ",losUsuarios[key].nombre);
                /* Si la ID del usuario en sesión fue encontrada, entonces obtiene el nombre del usuario, 
                   los roles que tiene asignados y si está o no activo */
                if (losUsuarios[key].laid === laLlave) {

                    __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_nusuario = losUsuarios[key].nombre;
                    __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles = losUsuarios[key].roles;
                    __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_activo = losUsuarios[key].activo;
                    __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_admin = losUsuarios[key].administrador;
                    __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_email = losUsuarios[key].email;
                    __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_clave = losUsuarios[key].clave;
                    __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_empresa = losUsuarios[key].empresa;
                    __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_sexo = losUsuarios[key].sexo;
                    __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_depto = losUsuarios[key].depto;
                    __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_empezo = losUsuarios[key].empezo;

                    __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_llave = key;
                }; // if()
            } // for      
            // console.log("roles ? ",store.state.st_roles.ev02_perfil);
            __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.evalua = __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev01_tipolo || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev02_perfil || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev02_perfil || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev03_16pf || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev04_npf || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev05_cpf || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev06_moss || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev07_tav || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev08_solemp || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev09_emocio || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev10_auxili || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev11_vtas || __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles.ev12_aedp;
            console.log("evaluaciones ? ", __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.evalua);
            console.log("roles ? ", __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_roles);
        },
        // getUsuarios
        bdReadUsuarios: function bdReadUsuarios(laLlave) {
            var _this2 = this;

            var dummy = __WEBPACK_IMPORTED_MODULE_1__store_store_js__["a" /* store */].state.st_dbUsuarios.on('value', function (snapshot) {
                return _this2.getUsuarios(snapshot.val(), laLlave);
            });
        }
    } // methods
    // export

});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */
/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'logout',
    data: function data() {
        return {};
    },
    methods: {
        logOut: function logOut() {

            var self = this;
            __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signOut().then(function () {

                console.log("Exito en la Salida !");
                self.$router.push('/');
            }).then(function () {

                __WEBPACK_IMPORTED_MODULE_0__store_store_js__["a" /* store */].state.st_logeado = false;
            }).catch(function (error) {
                console.log(error);
            }); // catch()
        } // logOut()

    } // methods
    // export

});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_json_excel__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chartkick__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__culturaGforma_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__culturaGlistado_vue__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_store__ = __webpack_require__(2);
// *=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=: -->
// Al ser renderizado se comportaría como una sub-instancia o como el componente principal. 
/**
 *      culguraG.js
 *          Script de culturaG.vue
 */

/* ======================================================================================================== */
/* Importación de componentes instalados como dependencias o creados */


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('downloadExcel', __WEBPACK_IMPORTED_MODULE_1_vue_json_excel__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_chartkick__["a" /* default */]);








// import firebase         from 'firebase'


// import { ModelSelect } from 'vue-search-select'

/* ======================================================================================================== */
/* exporta todo el código necesario para ser usado en su correspondiente <template> */
/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'culturaG',
    components: {
        'formulario': __WEBPACK_IMPORTED_MODULE_5__culturaGforma_vue__["a" /* default */],
        'listado': __WEBPACK_IMPORTED_MODULE_6__culturaGlistado_vue__["a" /* default */],
        'input-date': __WEBPACK_IMPORTED_MODULE_7__ingreso_vue__["a" /* default */],
        'moment': __WEBPACK_IMPORTED_MODULE_4_moment___default.a
    },
    data: function data() {
        return {

            // caso: {},                       // Objeto que tendrá información vacía (nuevo caso) o heredará uno de la lista

            /** Definiciones para EXPORTACION a CVS */
            json_fields: {
                'Nombre': 'nombre'
            },
            json_meta: [[{
                'key': 'charset',
                'value': 'iso-8859-1'
                // 'value': 'utf-8'
            }]] // return
        };
    }, // data    
    mounted: function mounted() {

        /** Definiciones para el uso de los TABS */
        var elem = document.querySelectorAll('.tabs');
        var instances = __WEBPACK_IMPORTED_MODULE_3_materialize_css___default.a.Tabs.init(elem, {});
    }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_807d9fa8_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__ = __webpack_require__(299);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_807d9fa8_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_downloadjs__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		// mime type [xls, csv], default: xls
		'type': {
			type: String,
			default: "xls"
		},
		// Json to download
		'data': {
			type: Array,
			required: true
		},
		// fields inside the Json Object that you want to export
		// if no given, all the properties in the Json are exported
		'fields': {
			type: Object,
			required: false
		},
		// this prop is used to fix the problem with other components that use the
		// variable fields, like vee-validate. exportFields works exactly like fields
		'exportFields': {
			type: Object,
			required: false
		},
		// Title(s) for the data, could be a string or an array of strings (multiple titles)
		'title': {
			default: null
		},
		// Footer(s) for the data, could be a string or an array of strings (multiple footers)
		'footer': {
			default: null
		},
		// filename to export, deault: data.xls
		'name': {
			type: String,
			default: "data.xls"
		},
		'meta': {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	computed: {
		// unique identifier
		idName: function idName() {
			var now = new Date().getTime();
			return 'export_' + now;
		},

		downloadFields: function downloadFields() {
			if (this.fields !== undefined) return this.fields;

			if (this.exportFields !== undefined) return this.exportFields;
		}
	},
	methods: {
		generate: function generate() {
			if (!this.data.length) {
				return;
			}
			var json = this.getProcessedJson(this.data, this.downloadFields);
			if (this.type == 'csv') {
				return this.export(this.jsonToCSV(json), this.name, "application/csv");
			}
			return this.export(this.jsonToXLS(json), this.name, "application/vnd.ms-excel");
		},

		/*
  Use downloadjs to generate the download link
  */
		export: function _export(data, filename, mime) {
			var blob = this.base64ToBlob(data, mime);
			__WEBPACK_IMPORTED_MODULE_0_downloadjs___default()(blob, filename, mime);
		},

		/*
  jsonToXLS
  ---------------
  Transform json data into an xml document with MS Excel format, sadly
  this format show a prompt when open due to a default behavior
  on Microsoft office. It's recommended to use CSV format instead.
  */
		jsonToXLS: function jsonToXLS(data) {
			var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';
			var xlsData = '<thead><tr>';
			var colspan = Object.keys(data[0]).length;

			//Header
			if (this.title != null) {
				xlsData += this.parseExtraData(this.title, '<th colspan="' + colspan + '">${data}<th></tr><tr>');
			}
			//Fields
			for (var key in data[0]) {
				xlsData += '<th>' + key + '</th>';
			}
			xlsData += '</tr></thead>';
			xlsData += '<tbody>';
			//Data
			data.map(function (item, index) {
				xlsData += '<tbody><tr>';
				for (var _key in item) {
					xlsData += '<td>' + item[_key] + '</td>';
				}
				xlsData += '</tr></tbody>';
			});
			//Footer
			if (this.footer != null) {
				xlsData += '<tfooter><tr>';
				xlsData += this.parseExtraData(this.footer, '<td colspan="' + colspan + '">${data}<td></tr><tr>');
				xlsData += '</tr></tfooter>';
			}
			return xlsTemp.replace('${table}', xlsData);
		},

		/*
  jsonToCSV
  ---------------
  Transform json data into an CSV file.
  */
		jsonToCSV: function jsonToCSV(data) {
			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n');
			}
			//Fields
			for (var key in data[0]) {
				csvData += key + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function (item) {
				for (var _key2 in item) {
					var escapedCSV = item[_key2] + ''; // cast Numbers to string
					if (escapedCSV.match(/[,"\n]/)) {
						escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
					}
					csvData += escapedCSV + ',';
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			});
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			return csvData;
		},

		/*
  getProcessedJson
  ---------------
  Get only the data to export, if no fields are set return all the data
  */
		getProcessedJson: function getProcessedJson(data, header) {
			var keys = this.getKeys(data, header);
			var newData = [];
			var _self = this;
			data.map(function (item, index) {
				var newItem = {};
				for (var label in keys) {
					var iii = item;
					var property = keys[label];
					newItem[label] = _self.getNestedData(property, item);
				}
				newData.push(newItem);
			});

			return newData;
		},
		getKeys: function getKeys(data, header) {
			if (header) {
				return header;
			}

			var keys = {};
			for (var key in data[0]) {
				keys[key] = key;
			}
			return keys;
		},
		/*
  parseExtraData
  ---------------
  Parse title and footer attribute to the csv format
  */
		parseExtraData: function parseExtraData(extraData, format) {
			var parseData = '';
			if (Array.isArray(extraData)) {
				for (var i = 0; i < extraData.length; i++) {
					parseData += format.replace('${data}', extraData[i]);
				}
			} else {
				parseData += format.replace('${data}', extraData);
			}
			return parseData;
		},

		callItemCallback: function callItemCallback(field, itemValue) {
			if ((typeof field === 'undefined' ? 'undefined' : _typeof(field)) === 'object' && typeof field.callback === 'function') {
				return field.callback(itemValue);
			}
			return itemValue;
		},
		getNestedData: function getNestedData(key, item) {
			var field = (typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' ? key.field : key;

			var valueFromNestedKey = null;
			var keyNestedSplit = field.split(".");

			valueFromNestedKey = item[keyNestedSplit[0]];
			for (var j = 1; j < keyNestedSplit.length; j++) {
				valueFromNestedKey = valueFromNestedKey[keyNestedSplit[j]];
			}

			valueFromNestedKey = this.callItemCallback(key, valueFromNestedKey);

			return valueFromNestedKey;
		},
		base64ToBlob: function base64ToBlob(data, mime) {
			var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			var bstr = atob(base64);
			var n = bstr.length;
			var u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], { type: mime });
		}
	} // end methods
});

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ar;

})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arDz = moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arDz;

})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arKw = moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arKw;

})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var arLy = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arLy;

})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arMa = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arMa;

})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arSa;

})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;

})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return az;

})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return be;

})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bg;

})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bm = moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;

})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bn;

})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bo;

})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bs;

})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsParse : (function (months, monthsShort) {
            var i, _monthsParse = [];
            for (i = 0; i < 12; i++) {
                // use custom parser to solve problem with July (červenec)
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months, monthsShort)),
        shortMonthsParse : (function (monthsShort) {
            var i, _shortMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
            }
            return _shortMonthsParse;
        }(monthsShort)),
        longMonthsParse : (function (months) {
            var i, _longMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
            }
            return _longMonthsParse;
        }(months)),
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return cv;

})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return dv;

})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eo;

})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'MMMM [de] D [de] YYYY',
            LLL : 'MMMM [de] D [de] YYYY h:mm A',
            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eu;

})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return fa;

})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minutt',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaði',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka horan', 'ek hor'],
            'hh': [number + ' horanim', number + ' horam'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;

})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return gu;

})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hi;

})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var hyAm = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hyAm;

})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return id;

})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return jv;

})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return kk;

})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return kn;

})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кече саат] LT',
            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ky;

})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return me;

})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mk;

})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;

})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mr;

})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ms;

})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var msMy = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return msMy;

})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mt = moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;

})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return my;

})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ne;

})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return paIn;

})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ro;

})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    var sd = moment.defineLocale('sd', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;

})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sl;

})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sr;

})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return srCyrl;

})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sw;

})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ta;

})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return te;

})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tet = moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;

})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;

})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tlPh = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;

})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate,
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tr;

})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzm;

})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzmLatn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzmLatn;

})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;

})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return uk;

})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    var ur = moment.defineLocale('ur', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;

})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uzLatn = moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return uzLatn;

})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var xPseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;

})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var yo = moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;

})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhTw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhTw;

})));


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
/**
 *      culguraGforma.js
 *          Script de culturaGforma.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */

/* ======================================================================================================== */






__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'datosencuesta',
    components: {
        'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
        'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
    },
    template: '#formaEncuesta',
    data: function data() {
        return {
            caso: {},
            modo: "" // return
        };
    },
    // data()
    mounted: function mounted() {

        /** Definiciones para el uso de los slides y tooltips */
        var elems = document.querySelectorAll('.collapsible');
        var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

        var elems = document.querySelectorAll('.tooltipped');
        var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

        /** obtiene localmente el caso definido en el almacén (store) */
        this.cargaCaso();
    },

    computed: {
        sumaA: function sumaA() {
            return this.caso.g1pg1 + this.caso.g2pg1 + this.caso.g3pg1 + this.caso.g4pg1 + this.caso.g5pg1 + this.caso.g6pg1;
        },
        promedioA: function promedioA() {
            var lprom = this.sumaA / 6;
            return lprom.toFixed(2);
        },
        sumaB: function sumaB() {
            return this.caso.g1pg2 + this.caso.g2pg2 + this.caso.g3pg2 + this.caso.g4pg2 + this.caso.g5pg2 + this.caso.g6pg2;
        },
        promedioB: function promedioB() {
            var lprom = this.sumaB / 6;
            return lprom.toFixed(2);
        },
        sumaC: function sumaC() {
            return this.caso.g1pg3 + this.caso.g2pg3 + this.caso.g3pg3 + this.caso.g4pg3 + this.caso.g5pg3 + this.caso.g6pg3;
        },
        promedioC: function promedioC() {
            var lprom = this.sumaC / 6;
            return lprom.toFixed(2);
        },
        sumaD: function sumaD() {
            return this.caso.g1pg4 + this.caso.g2pg4 + this.caso.g3pg4 + this.caso.g4pg4 + this.caso.g5pg4 + this.caso.g6pg4;
        },
        promedioD: function promedioD() {
            var lprom = this.sumaD / 6;
            return lprom.toFixed(2);
        },
        totalG1: function totalG1() {
            var lTotal = Number(this.caso.g1pg1) + Number(this.caso.g1pg2) + Number(this.caso.g1pg3) + Number(this.caso.g1pg4);
            if (lTotal > 100) {
                lTotal = 100;
            }
            return lTotal;
        },
        totalG2: function totalG2() {
            var lTotal = Number(this.caso.g2pg1) + Number(this.caso.g2pg2) + Number(this.caso.g2pg3) + Number(this.caso.g2pg4);
            if (lTotal > 100) {
                lTotal = 100;
            }
            return lTotal;
        },
        totalG3: function totalG3() {
            var lTotal = Number(this.caso.g3pg1) + Number(this.caso.g3pg2) + Number(this.caso.g3pg3) + Number(this.caso.g3pg4);
            if (lTotal > 100) {
                lTotal = 100;
            }
            return lTotal;
        },
        totalG4: function totalG4() {
            var lTotal = Number(this.caso.g4pg1) + Number(this.caso.g4pg2) + Number(this.caso.g4pg3) + Number(this.caso.g4pg4);
            if (lTotal > 100) {
                lTotal = 100;
            }
            return lTotal;
        },
        totalG5: function totalG5() {
            var lTotal = Number(this.caso.g5pg1) + Number(this.caso.g5pg2) + Number(this.caso.g5pg3) + Number(this.caso.g5pg4);
            if (lTotal > 100) {
                lTotal = 100;
            }
            return lTotal;
        },
        totalG6: function totalG6() {
            var lTotal = Number(this.caso.g6pg1) + Number(this.caso.g6pg2) + Number(this.caso.g6pg3) + Number(this.caso.g6pg4);
            if (lTotal > 100) {
                lTotal = 100;
            }
            return lTotal;
        }
    },
    methods: {
        cargaCaso: function cargaCaso() {

            this.modo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_modo;
            this.caso = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_caso;
            // this.caso= this.casopar;

            /** Verifica de donde proviene el llamado de la forma */
            if (this.modo === "INGRESO") {

                this.caso.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario;
                this.caso.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa;
            } // if()
            // console.log("[culturaGforma.js- cargaCaso], modo ? ",this.modo);
            // console.log("[culturaGforma.js- cargaCaso], this.caso.nombre ? ",this.caso.nombre);
            // console.log("[culturaGforma.js- cargaCaso], this.caso.empresa ? ",this.caso.empresa);
        },

        /** .................... VALIDACIONES  .................... */
        validarValor: function validarValor(valor) {
            var lvalor = valor;
            if (valor < 1 || valor > 100) {
                lvalor = 0;
            }
            // console.log("validarValor, lvalor ? ",lvalor);
            return lvalor;
        },
        limpiarCaso: function limpiarCaso() {

            this.caso = {
                empresa: "", nombre: "",
                g1pg1: 0, g1pg2: 0, g1pg3: 0, g1pg4: 0, g1total: 0,
                g2pg1: 0, g2pg2: 0, g2pg3: 0, g2pg4: 0, g2total: 0,
                g3pg1: 0, g3pg2: 0, g3pg3: 0, g3pg4: 0, g3total: 0,
                g4pg1: 0, g4pg2: 0, g4pg3: 0, g4pg4: 0, g4total: 0,
                g5pg1: 0, g5pg2: 0, g5pg3: 0, g5pg4: 0, g5total: 0,
                g6pg1: 0, g6pg2: 0, g6pg3: 0, g6pg4: 0, g6total: 0,
                r1suma: 0, r1prom: 0, r2suma: 0, r2prom: 0,
                r3suma: 0, r3prom: 0, r4suma: 0, r4prom: 0

                /* Variables para un nuevo caso */
            };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_caso = this.caso;
            // this.caso=  store.state.st_caso;
            // console.log("[culturaGforma.js- limpiarCaso], store.state.st_caso ? ",store.state.st_caso);
            // console.log("[culturaGforma.js- limpiarCaso], caso ? ",this.caso);
        },

        /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
        /* Acciones del Floatting Button: Agregar Encuesta */
        agregarCasoMem: function agregarCasoMem() {

            if (this.caso.r1prom > 0 && this.caso.r2prom > 0 && this.caso.r4prom > 0 && this.caso.r4prom > 0) {

                var confirma = confirm("[culturaGforma.js- agregarEncuestaMem], Seguro de agregar la prueba de  " + this.caso.nombre.trim() + " ? ");
                if (confirma === true) {

                    __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_casos.push({
                        empresa: this.caso.empresa, nombre: this.caso.nombre,
                        g1pg1: this.caso.g1pg1, g1pg2: this.caso.g1pg2, g1pg3: this.caso.g1pg3, g1pg4: this.caso.g1pg4, g1total: this.caso.g1total,
                        g2pg1: this.caso.g2pg1, g2pg2: this.caso.g2pg2, g2pg3: this.caso.g2pg3, g2pg4: this.caso.g2pg4, g2total: this.caso.g2total,
                        g3pg1: this.caso.g3pg1, g3pg2: this.caso.g3pg2, g3pg3: this.caso.g3pg3, g3pg4: this.caso.g3pg4, g3total: this.caso.g3total,
                        g4pg1: this.caso.g4pg1, g4pg2: this.caso.g4pg2, g4pg3: this.caso.g4pg3, g4pg4: this.caso.g4pg4, g4total: this.caso.g4total,
                        g5pg1: this.caso.g5pg1, g5pg2: this.caso.g5pg2, g5pg3: this.caso.g5pg3, g5pg4: this.caso.g5pg4, g5total: this.caso.g5total,
                        g6pg1: this.caso.g6pg1, g6pg2: this.caso.g6pg2, g6pg3: this.caso.g6pg3, g6pg4: this.caso.g6pg4, g6total: this.caso.g6total,
                        r1suma: this.caso.r1suma, r1prom: this.caso.r1prom, r2suma: this.caso.r2suma, r2prom: this.caso.r2prom,
                        r3suma: this.caso.r3suma, r3prom: this.caso.r3prom, r4suma: this.caso.r4suma, r4prom: this.caso.r4prom,

                        editing: false
                    });
                } // if(confirm)
            } else {
                alert("Debe ingresar valores !");
            } // if()
            // console.log("[culturaGforma.js- agregarEncuestaMem], store.state.st_casos ? ",store.state.st_casos);

            /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
            this.limpiarCaso();
        },
        agregarCaso: function agregarCaso() {
            var _this = this;

            var confirma = confirm("Seguro de agregar el caso de " + this.caso.nombre.trim() + " ?");
            if (confirma === true) {

                if (this.caso.r1prom >= 0 && this.caso.r2prom >= 0 && this.caso.r3prom >= 0 && this.caso.r4prom >= 0) {

                    var dbCasos = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbCasos;
                    // console.log("[culturaGforma.js- agregarCaso], dbCasos ? ",dbCasos);
                    /* Agrega una colección al objeto */
                    dbCasos.push({
                        empresa: this.caso.empresa, nombre: this.caso.nombre,
                        g1pg1: this.caso.g1pg1, g1pg2: this.caso.g1pg2, g1pg3: this.caso.g1pg3, g1pg4: this.caso.g1pg4, g1total: this.caso.g1total,
                        g2pg1: this.caso.g2pg1, g2pg2: this.caso.g2pg2, g2pg3: this.caso.g2pg3, g2pg4: this.caso.g2pg4, g2total: this.caso.g2total,
                        g3pg1: this.caso.g3pg1, g3pg2: this.caso.g3pg2, g3pg3: this.caso.g3pg3, g3pg4: this.caso.g3pg4, g3total: this.caso.g3total,
                        g4pg1: this.caso.g4pg1, g4pg2: this.caso.g4pg2, g4pg3: this.caso.g4pg3, g4pg4: this.caso.g4pg4, g4total: this.caso.g4total,
                        g5pg1: this.caso.g5pg1, g5pg2: this.caso.g5pg2, g5pg3: this.caso.g5pg3, g5pg4: this.caso.g5pg4, g5total: this.caso.g5total,
                        g6pg1: this.caso.g6pg1, g6pg2: this.caso.g6pg2, g6pg3: this.caso.g6pg3, g6pg4: this.caso.g6pg4, g6total: this.caso.g6total,
                        r1suma: this.caso.r1suma, r1prom: this.caso.r1prom, r2suma: this.caso.r2suma, r2prom: this.caso.r2prom,
                        r3suma: this.caso.r3suma, r3prom: this.caso.r3prom, r4suma: this.caso.r4suma, r4prom: this.caso.r4prom,

                        editing: false
                    }).then(function (data) {

                        /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                        _this.limpiarCaso();

                        var laClave = data.key;
                        // console.log("[culturaGforma- agregarCaso], La clave almacenada es ? ",laClave);
                        alert("Formulario guardado con éxito.");
                    });

                    /* Reordena la lista según criterio de ordenamiento actual */
                    // this.reordenar(this.orderActual);
                } // if()
            } // if (confirma)
            // this.ocultarEncuesta();            
        },
        // agregarEncuesta()

        // Segmento 1, coord[1]: 148,8,8, 85,98,108,116; coord[2]: 144,9,8,82,95,112,120; coord[3]: 140,8,8, 79,92,118,124; coord[4]: 132,8,8, 83,81,118,126
        ploteoCuadrantesAyB: function ploteoCuadrantesAyB(doc, coord, valores) {

            doc.setFontSize(8);
            doc.setFontType("bold");
            doc.setTextColor(0, 0, 255);

            /** [1] = 1a. posición, del centro hacia afuera. */
            var linea = coord[1].linea;var posIf = linea + coord[1].inc1;var posDf = linea + coord[1].inc2;
            /** Lado Izquierdo */
            doc.text(coord[1].p_valI, posIf, cA_p11); // p_valI= posición_valor lado Izquierdo
            doc.text(coord[1].p_astI, posIf, cA_a11); // p_astI= posición_* lado Izquierdo
            /** Lado Derecho */
            doc.text(coord[1].p_valD, posDf, cB_a11); // p_valI= posición_valor lado derecho
            doc.text(coord[1].p_astD, posDf, cB_p11); // p_astI= posición_* lado derecho

            /** [2] = 2a. posición, del centro hacia afuera. inc1 = incremento 1. inc2 = incremento 2*/
            var linea = coord[2].linea;var posIf = linea + coord[2].inc1;var posDf = linea + coord[2].inc2;
            /** Lado Izquierdo */
            doc.text(coord[2].p_valI, posIf, cA_p12);
            doc.text(coord[2].p_astI, posIf, cA_a12);
            /** Lado Derecho */
            doc.text(coord[2].p_valD, posDf, cB_a12);
            doc.text(coord[2].p_astD, posDf, cB_p12);

            /** [3] = 3a. posición, del centro hacia afuera. inc1 = incremento 1. inc2 = incremento 2*/
            var linea = coord[3].linea;var posIf = linea + coord[3].inc1;var posDf = linea + coord[3].inc2;
            /** Lado Izquierdo */
            doc.text(coord[3].p_valI, posIf, cA_p13);
            doc.text(coord[3].p_astI, posIf, cA_a13);
            /** Lado Derecho */
            doc.text(coord[3].p_valD, posDf, cB_a13);
            doc.text(coord[3].p_astD, posDf, cB_p13);

            /** [4] = 4a. posición, del centro hacia afuera. inc1 = incremento 1. inc2 = incremento 2*/
            var linea = coord[4].linea;var posIf = linea + coord[4].inc1;var posDf = linea + coord[4].inc2;
            /** Lado Izquierdo */
            doc.text(coord[4].p_valI, posIf, cA_p14);
            doc.text(coord[4].p_astI, posIf, cA_a14);

            doc.text(coord[4].p_valD, posDf, cB_p14);
            doc.text(coord[4].p_astD, posDf, cB_a14);
        },
        ploteoCuadranteAyBSeg1: function ploteoCuadranteAyBSeg1(doc, cA_a11, cA_p11, cA_a12, cA_p12, cA_a13, cA_p13, cA_a14, cA_p14, cB_a11, cB_p11, cB_a12, cB_p12, cB_a13, cB_p13, cB_a14, cB_p14) {
            doc.setFontSize(8);
            doc.setFontType("bold");
            doc.setTextColor(0, 0, 255);
            // cA_a11="*"; cA_p11= "2.25"; cB_a11="*"; cB_p11= "2.35";
            // cA_a12="*"; cA_p12= "4.25"; cB_a12="*"; cB_p12= "4.35";
            // cA_a13="*"; cA_p13= "8.25"; cB_a13="*"; cB_p13= "8.35";
            // cA_a14="*"; cA_p14= "10.25"; cB_a14="*"; cB_p14= "10.35";                                        
            var linea = 148;var posIf = linea + 8;var posDf = linea + 8;
            doc.text(85, posIf, cA_p11);doc.text(98, posIf, cA_a11);doc.text(108, posDf, cB_a11);doc.text(116, posDf, cB_p11);

            var linea = 144;var posIf = linea + 9;var posDf = linea + 8;
            doc.text(82, posIf, cA_p12);doc.text(95, posIf, cA_a12);doc.text(112, posDf, cB_a12);doc.text(120, posDf, cB_p12);

            var linea = 140;var posIf = linea + 8;var posDf = linea + 8;
            doc.text(79, posIf, cA_p13);doc.text(92, posIf, cA_a13);doc.text(118, posDf, cB_a13);doc.text(124, posDf, cB_p13);

            var linea = 132;var posIf = linea + 8;var posDf = linea + 8;
            doc.text(81, posIf, cA_a14);doc.text(83, posIf, cA_p14);doc.text(118, posDf, cB_p14);doc.text(126, posDf, cB_a14);

            doc.setFontSize(9);
            doc.setFontType("normal");
            doc.setTextColor(0, 0, 0);
        },
        ploteoCuadranteAyBSeg2: function ploteoCuadranteAyBSeg2(doc, cA_a21, cA_p21, cA_a22, cA_p22, cA_a23, cA_p23, cA_a24, cA_p24, cB_a21, cB_p21, cB_a22, cB_p22, cB_a23, cB_p23, cB_a24, cB_p24) {

            doc.setFontSize(8);
            doc.setFontType("bold");
            doc.setTextColor(0, 0, 255);
            // cA_a21="*"; cA_p21= "13.25"; cB_a21="*"; cB_p21= "13.35";
            // cA_a22="*"; cA_p22= "15.25"; cB_a22="*"; cB_p22= "15.35";
            // cA_a23="*"; cA_p23= "22.25"; cB_a23="*"; cB_p23= "22.35";
            // cA_a24="*"; cA_p24= "26.25"; cB_a24="*"; cB_p24= "26.35";

            var linea = 106;var posIf = linea + 7;var posDf = linea + 8;
            doc.text(55, posIf, cA_a24);doc.text(59, posIf, cA_p24);doc.text(148, posDf, cB_p24);doc.text(157, posDf, cB_a24);

            var linea = 113;var posIf = linea + 5;var posDf = linea + 7;
            doc.text(61, posIf, cA_a23);doc.text(65, posIf, cA_p23);doc.text(143, posDf, cB_p23);doc.text(152, posDf, cB_a23);

            var linea = 123;var posIf = linea + 5;var posDf = linea + 8;
            doc.text(66, posIf, cA_p22);doc.text(75, posIf, cA_a22);doc.text(131, posDf, cB_p22);doc.text(139, posDf, cB_a22);

            var linea = 128;var posIf = linea + 5;var posDf = linea + 9;
            doc.text(69, posIf, cA_p21);doc.text(78, posIf, cA_a21);doc.text(135, posDf, cB_p21);doc.text(132, posDf, cB_a21);

            doc.setFontSize(9);
            doc.setFontType("normal");
            doc.setTextColor(0, 0, 0);
        },
        ploteoCuadranteAyBSeg3: function ploteoCuadranteAyBSeg3(doc, cA_a31, cA_p31, cA_a32, cA_p32, cA_a33, cA_p33, cA_a34, cA_p34, cB_a31, cB_p31, cB_a32, cB_p32, cB_a33, cB_p33, cB_a34, cB_p34) {
            // console.log("en ploteo cA_a34 ? ",cA_a34,", valor ? ",cA_p34);

            doc.setFontSize(8);
            doc.setFontType("bold");
            doc.setTextColor(0, 0, 255);
            // cA_a31="*"; cA_p31= "31.25"; cB_a31="*"; cB_p31= "31.35";
            // cA_a32="*"; cA_p32= "33.25"; cB_a32="*"; cB_p32= "33.35";
            // cA_a33="*"; cA_p33= "36.25"; cB_a33="*"; cB_p33= "36.35";
            // cA_a34="*"; cA_p34= "38.25"; cB_a34="*"; cB_p34= "38.35";

            var linea = 89;var posIf = linea + 7;var posDf = linea + 9;
            doc.text(39, posIf, cA_a34);doc.text(42, posIf, cA_p34);doc.text(163, posDf, cB_p34);doc.text(172, posDf, cB_a34);

            var linea = 94;var posIf = linea + 5;var posDf = linea + 7;
            doc.text(42, posIf, cA_a33);doc.text(46, posIf, cA_p33);doc.text(161, posDf, cB_p33);doc.text(169, posDf, cB_a33);

            var linea = 98;var posIf = linea + 5;var posDf = linea + 8;
            doc.text(36, posIf, cA_p32);doc.text(46, posIf, cA_a32);doc.text(156, posDf, cB_p32);doc.text(164, posDf, cB_a32);

            var linea = 102;var posIf = linea + 5;var posDf = linea + 10;
            doc.text(43, posIf, cA_p31);doc.text(51, posIf, cA_a31);doc.text(164, posDf + 1, cB_p31);doc.text(161, posDf, cB_a31);

            doc.setFontSize(9);
            doc.setFontType("normal");
            doc.setTextColor(0, 0, 0);
        },
        ploteoCuadranteAyBSeg4: function ploteoCuadranteAyBSeg4(doc, cA_a41, cA_p41, cA_a42, cA_p42, cB_a41, cB_p41, cB_a42, cB_p42) {

            doc.setFontSize(8);
            doc.setFontType("bold");
            doc.setTextColor(0, 0, 255);
            // cA_a41="*"; cA_p41= "41.25"; cB_a41="*"; cB_p41= "41.35";
            // cA_a42="*"; cA_p42= "44.25"; cB_a42="*"; cB_p42= "44.35";

            var linea = 85;var posIf = linea + 7;var posDf = linea + 11;
            doc.text(37, posIf, cA_a41);doc.text(42, posIf, cA_p41);doc.text(181, posDf, cB_p41);doc.text(176, posDf, cB_a41);

            var linea = 81;var posIf = linea + 4;var posDf = linea + 8;
            doc.text(31, posIf, cA_a42);doc.text(33, posIf, cA_p42);doc.text(183, posDf, cB_a42);doc.text(185, posDf, cB_p42);

            doc.setFontSize(9);
            doc.setFontType("normal");
            doc.setTextColor(0, 0, 0);
        },
        ploteoCuadranteCyDSeg1: function ploteoCuadranteCyDSeg1(doc, cC_a11, cC_p11, cC_a12, cC_p12, cC_a13, cC_p13, cC_a14, cC_p14, cD_a11, cD_p11, cD_a12, cD_p12, cD_a13, cD_p13, cD_a14, cD_p14) {

            doc.setFontSize(8);
            doc.setFontType("bold");
            doc.setTextColor(0, 0, 255);

            // cC_a11="*"; cC_p11= "2.25"; cD_a11="*"; cD_p11= "2.35";
            // cC_a12="*"; cC_p12= "4.25"; cD_a12="*"; cD_p12= "4.35";
            // cC_a13="*"; cC_p13= "8.25"; cD_a13="*"; cD_p13= "8.35";
            // cC_a14="*"; cC_p14= "10.25"; cD_a14="*"; cD_p14= "10.35";
            // console.log("ENTRE !");

            var linea = 158;var posIf = linea + 8;var posDf = linea + 8;
            doc.text(83, posIf, cC_p11);doc.text(90, posIf, cC_a11);doc.text(112, posDf, cD_a11);doc.text(114, posDf, cD_p11);

            var linea = 161;var posIf = linea + 8;var posDf = linea + 8;
            doc.text(90, posIf, cC_p12);doc.text(87, posIf, cC_a12);doc.text(116, posDf, cD_a12);doc.text(109, posDf, cD_p12);

            var linea = 165;var posIf = linea + 8;var posDf = linea + 8;
            doc.text(90, posIf, cC_p13);doc.text(84, posIf, cC_a13);doc.text(122, posDf, cD_a13);doc.text(112, posDf, cD_p13);

            var linea = 167;var posIf = linea + 8;var posDf = linea + 9;
            doc.text(82, posIf, cC_a14);doc.text(86, posIf, cC_p14);doc.text(116, posDf, cD_p14);doc.text(124, posDf, cD_a14);

            doc.setFontSize(9);
            doc.setFontType("normal");
            doc.setTextColor(0, 0, 0);
        },
        ploteoCuadranteCyDSeg2: function ploteoCuadranteCyDSeg2(doc, cC_a21, cC_p21, cC_a22, cC_p22, cC_a23, cC_p23, cC_a24, cC_p24, cD_a21, cD_p21, cD_a22, cD_p22, cD_a23, cD_p23, cD_a24, cD_p24) {

            doc.setFontSize(8);
            doc.setFontType("bold");
            doc.setTextColor(0, 0, 255);

            // cC_a21="*"; cC_p21= "14.25"; cD_a21="*"; cD_p21= "14.35";
            // cC_a22="*"; cC_p22= "18.25"; cD_a22="*"; cD_p22= "18.35";
            // cC_a23="*"; cC_p23= "22.25"; cD_a23="*"; cD_p23= "22.35";
            // cC_a24="*"; cC_p24= "27.25"; cD_a24="*"; cD_p24= "27.35";
            // console.log("ENTRE !");

            var linea = 177;var posIf = linea + 6;var posDf = linea + 8;
            doc.text(66, posIf, cC_p21);doc.text(74, posIf, cC_a21);doc.text(135, posDf, cD_a21);doc.text(137, posDf, cD_p21);

            var linea = 181;var posIf = linea + 8;var posDf = linea + 8;
            doc.text(53, posIf, cC_p22);doc.text(63, posIf, cC_a22);doc.text(141, posDf, cD_a22);doc.text(145, posDf, cD_p22);

            var linea = 185;var posIf = linea + 8;var posDf = linea + 11;
            doc.text(58, posIf, cC_p23);doc.text(53, posIf, cC_a23);doc.text(150, posDf, cD_a23);doc.text(154, posDf, cD_p23);

            var linea = 189;var posIf = linea + 8;var posDf = linea + 11;
            doc.text(54, posIf, cC_p24);doc.text(50, posIf, cC_a24);doc.text(145, posDf, cD_p24);doc.text(154, posDf, cD_a24);

            doc.setFontSize(9);
            doc.setFontType("normal");
            doc.setTextColor(0, 0, 0);
        },
        ploteoCuadranteCyDSeg3: function ploteoCuadranteCyDSeg3(doc, cC_a31, cC_p31, cC_a32, cC_p32, cC_a33, cC_p33, cC_a34, cC_p34, cD_a31, cD_p31, cD_a32, cD_p32, cD_a33, cD_p33, cD_a34, cD_p34) {

            doc.setFontSize(8);
            doc.setFontType("bold");
            doc.setTextColor(0, 0, 255);

            // cC_a31="*"; cC_p31= "31.25"; cD_a31="*"; cD_p31= "31.35";
            // cC_a32="*"; cC_p32= "33.25"; cD_a32="*"; cD_p32= "33.35";
            // cC_a33="*"; cC_p33= "36.25"; cD_a33="*"; cD_p33= "36.35";
            // cC_a34="*"; cC_p34= "38.25"; cD_a34="*"; cD_p34= "38.35";

            var linea = 198;var posIf = linea + 3;var posDf = linea + 8;
            doc.text(37, posIf, cC_p31);doc.text(47, posIf, cC_a31);doc.text(157, posDf, cD_a31);doc.text(159, posDf, cD_p31);

            var linea = 202;var posIf = linea + 2;var posDf = linea + 7;
            doc.text(33, posIf, cC_p32);doc.text(43, posIf, cC_a32);doc.text(160, posDf, cD_a32);doc.text(164, posDf, cD_p32);

            var linea = 207;var posIf = linea + 1;var posDf = linea + 5;
            doc.text(43, posIf, cC_p33);doc.text(39, posIf, cC_a33);doc.text(163, posDf, cD_a33);doc.text(166, posDf, cD_p33);

            var linea = 211;var posIf = linea + 1;var posDf = linea + 4;
            doc.text(41, posIf, cC_p34);doc.text(36, posIf, cC_a34);doc.text(159, posDf, cD_p34);doc.text(168, posDf, cD_a34);

            doc.setFontSize(9);
            doc.setFontType("normal");
            doc.setTextColor(0, 0, 0);
        },
        ploteoCuadranteCyDSeg4: function ploteoCuadranteCyDSeg4(doc, cC_a41, cC_p41, cC_a42, cC_p42, cD_a41, cD_p41, cD_a42, cD_p42) {

            doc.setFontSize(8);
            doc.setFontType("bold");
            doc.setTextColor(0, 0, 255);

            // console.log("ENTRE !");
            // cC_a41="*"; cC_p41="41.25"; cC_a42="*"; cC_p42="50.5"
            // cD_a41="*"; cD_p41="41.55"; cD_a42="*"; cD_p42="51.5"
            // console.log("1a ? ",cC_a41,", 1p ? ",cC_p41);
            // console.log("2a ? ",cC_a42,", 1p ? ",cC_p42);
            // console.log("3a ? ",cD_a41,", 1p ? ",cD_p41);
            // console.log("4a ? ",cD_a42,", 1p ? ",cD_p42);

            var linea = 210;var posIf = linea + 6;var posDf = linea + 9;
            doc.text(33, posIf, cC_a41);doc.text(40, posIf, cC_p41);doc.text(177, posDf, cD_p41);doc.text(173, posDf, cD_a41);

            var linea = 215;var posIf = linea + 3;var posDf = linea + 7;
            doc.text(27, posIf, cC_a42);doc.text(20, posIf, cC_p42);doc.text(178, posDf, cD_a42);doc.text(180, posDf, cD_p42);

            doc.setFontSize(9);
            doc.setFontType("normal");
            doc.setTextColor(0, 0, 0);
        },
        crearPDF: function crearPDF() {

            if (this.caso.r1prom >= 0 && this.caso.r2prom >= 0 && this.caso.r4prom >= 0 && this.caso.r4prom >= 0) {

                /** *:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:= 
                 * CUADRANTE A- SEGMENTO 1: del centro hacia afuera. */
                var cA_a11 = "";var cA_p11 = "";var cA_a12 = "";var cA_p12 = "";var cA_a13 = "";var cA_p13 = "";var cA_a14 = "";var cA_p14 = "";
                if (this.caso.r1prom <= 3.125) {
                    cA_a11 = "*";cA_p11 = this.caso.r1prom.toString();
                } else {
                    if (this.caso.r1prom > 3.125 && this.caso.r1prom <= 6.25) {
                        cA_a12 = "*";cA_p12 = this.caso.r1prom.toString();
                    } else {
                        if (this.caso.r1prom > 6.25 && this.caso.r1prom <= 9.375) {
                            cA_a13 = "*";cA_p13 = this.caso.r1prom.toString();
                        } else if (this.caso.r1prom > 9.375 && this.caso.r1prom <= 12.5) {
                            cA_a14 = "*";cA_p14 = this.caso.r1prom.toString();
                        }
                    }
                }
                /* CUADRANTE B- SEGMENTO 1: del centro hacia afuera. */
                var cB_a11 = "";var cB_p11 = "";var cB_a12 = "";var cB_p12 = "";var cB_a13 = "";var cB_p13 = "";var cB_a14 = "";var cB_p14 = "";
                if (this.caso.r2prom <= 3.125) {
                    cB_a11 = "*";cB_p11 = this.caso.r2prom.toString();
                } else {
                    if (this.caso.r2prom > 3.125 && this.caso.r2prom <= 6.25) {
                        cB_a12 = "*";cB_p12 = this.caso.r2prom.toString();
                    } else {
                        if (this.caso.r2prom > 6.25 && this.caso.r2prom <= 9.375) {
                            cB_a13 = "*";cB_p13 = this.caso.r2prom.toString();
                        } else if (this.caso.r2prom > 9.375 && this.caso.r2prom <= 12.5) {
                            cB_a14 = "*";cB_p14 = this.caso.r2prom.toString();
                        }
                    }
                }
                /* CUADRANTE A- SEGMENTO 2: del centro hacia afuera. */
                var cA_a21 = "";var cA_p21 = "";var cA_a22 = "";var cA_p22 = "";var cA_a23 = "";var cA_p23 = "";var cA_a24 = "";var cA_p24 = "";
                if (this.caso.r1prom > 12.5 && this.caso.r1prom <= 16.88) {
                    cA_a21 = "*";cA_p21 = this.caso.r1prom.toString();
                } else {
                    if (this.caso.r1prom > 16.88 && this.caso.r1prom <= 21.26) {
                        cA_a22 = "*";cA_p22 = this.caso.r1prom.toString();
                    } else {
                        if (this.caso.r1prom > 21.26 && this.caso.r1prom <= 25.63) {
                            cA_a23 = "*";cA_p23 = this.caso.r1prom.toString();
                        } else if (this.caso.r1prom > 25.63 && this.caso.r1prom <= 30) {
                            cA_a24 = "*";cA_p24 = this.caso.r1prom.toString();
                        }
                    }
                }
                /* CUADRANTE B- SEGMENTO 2: del centro hacia afuera. */
                var cB_a21 = "";var cB_p21 = "";var cB_a22 = "";var cB_p22 = "";var cB_a23 = "";var cB_p23 = "";var cB_a24 = "";var cB_p24 = "";
                if (this.caso.r2prom > 12.5 && this.caso.r2prom <= 16.88) {
                    cB_a21 = "*";cB_p21 = this.caso.r2prom.toString();
                } else {
                    if (this.caso.r2prom > 16.88 && this.caso.r2prom <= 21.26) {
                        cB_a22 = "*";cB_p22 = this.caso.r2prom.toString();
                    } else {
                        if (this.caso.r2prom > 21.26 && this.caso.r2prom <= 25.63) {
                            cB_a23 = "*";cB_p23 = this.caso.r2prom.toString();
                        } else if (this.caso.r2prom > 25.63 && this.caso.r2prom <= 30) {
                            cB_a24 = "*";cB_p24 = this.caso.r2prom.toString();
                        }
                    }
                }
                // this.ploteoCuadranteAyBSeg2(doc,
                //     cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                //     cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24);

                /** :*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*= */
                /* CUADRANTE B- SEGMENTO 3: del centro hacia afuera. */
                var cA_a31 = "";var cA_p31 = "";var cA_a32 = "";var cA_p32 = "";var cA_a33 = "";var cA_p33 = "";var cA_a34 = "";var cA_p34 = "";
                if (this.caso.r1prom > 30 && this.caso.r1prom <= 32.51) {
                    cA_a31 = "*";cA_p31 = this.caso.r1prom.toString();
                } else {
                    if (this.caso.r1prom > 32.51 && this.caso.r1prom <= 35.01) {
                        cA_a32 = "*";cA_p32 = this.caso.r1prom.toString();
                    } else {
                        if (this.caso.r1prom > 35.01 && this.caso.r1prom <= 37.5) {
                            cA_a33 = "*";cA_p33 = this.caso.r1prom.toString();
                        } else if (this.caso.r1prom > 37.5 && this.caso.r1prom <= 40) {
                            cA_a34 = "*";cA_p34 = this.caso.r1prom.toString();
                        }
                    }
                }

                /* CUADRANTE B- SEGMENTO 2: del centro hacia afuera. */
                var cB_a31 = "";var cB_p31 = "";var cB_a32 = "";var cB_p32 = "";var cB_a33 = "";var cB_p33 = "";var cB_a34 = "";var cB_p34 = "";
                if (this.caso.r2prom > 30 && this.caso.r2prom <= 32.51) {
                    cB_a31 = "*";cB_p31 = this.caso.r2prom.toString();
                } else {
                    if (this.caso.r2prom > 32.51 && this.caso.r2prom <= 35.01) {
                        cB_a32 = "*";cB_p32 = this.caso.r2prom.toString();
                    } else {
                        if (this.caso.r2prom > 35.01 && this.caso.r2prom <= 37.5) {
                            cB_a33 = "*";cB_p33 = this.caso.r2prom.toString();
                        } else if (this.caso.r2prom > 37.5 && this.caso.r2prom <= 40) {
                            cB_a34 = "*";cB_p34 = this.caso.r2prom.toString();
                        }
                    }
                }
                // console.log("en ploteo cA_a34 ? ",cA_a34,", valor ? ",cA_p34);

                // this.ploteoCuadranteAyBSeg3(doc,
                //     cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                //     cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34);                                                
                /* CUADRANTE B- SEGMENTO 4: del centro hacia afuera. */
                var cA_a41 = "";var cA_p41 = "";var cA_a42 = "";var cA_p42 = "";var cA_a43 = "";var cA_p43 = "";var cA_a44 = "";var cA_p44 = "";
                if (this.caso.r1prom > 40 && this.caso.r1prom <= 42.5) {
                    cA_a41 = "*";cA_p41 = this.caso.r1prom.toString();
                } else {
                    if (this.caso.r1prom > 42.5) {
                        cA_a42 = "*";cA_p42 = this.caso.r1prom.toString();
                    }
                }
                /* CUADRANTE B- SEGMENTO 4: del centro hacia afuera. */
                var cB_a41 = "";var cB_p41 = "";var cB_a42 = "";var cB_p42 = "";var cB_a43 = "";var cB_p43 = "";var cB_a44 = "";var cB_p44 = "";
                if (this.caso.r2prom > 40 && this.caso.r2prom <= 42.5) {
                    cB_a41 = "*";cB_p41 = this.caso.r2prom.toString();
                } else {
                    if (this.caso.r2prom > 42.5) {
                        cB_a42 = "*";cB_p42 = this.caso.r1prom.toString();
                    }
                }
                // console.log("fuera de ploteo, ",cA_a41,cA_p41,cA_a42,cA_p42,cB_a41,cB_p41,cB_a42,cB_p42);                    
                // this.ploteoCuadranteAyBSeg4(doc,
                //     cA_a41,cA_p41,cA_a42,cA_p42,
                //     cB_a41,cB_p41,cB_a42,cB_p42);

                /* -*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*                            
                /* CUADRANTE C- SEGMENTO 1: del centro hacia afuera. */
                // this.caso.r1prom= 11.5;
                var cC_a11 = "";var cC_p11 = "";var cC_a12 = "";var cC_p12 = "";var cC_a13 = "";var cC_p13 = "";var cC_a14 = "";var cC_p14 = "";
                if (this.caso.r3prom <= 3.125) {
                    cC_a11 = "*";cC_p11 = this.caso.r3prom.toString();
                } else {
                    if (this.caso.r3prom > 3.125 && this.caso.r3prom <= 6.25) {
                        cC_a11 = "*";cC_p12 = this.caso.r3prom.toString();
                    } else {
                        if (this.caso.r3prom > 6.25 && this.caso.r3prom <= 9.375) {
                            cC_a13 = "*";cC_p13 = this.caso.r3prom.toString();
                        } else if (this.caso.r3prom > 9.375 && this.caso.r3prom <= 12.5) {
                            cC_a14 = "*";cC_p14 = this.caso.r3prom.toString();
                        }
                    }
                }

                /* CUADRANTE D- SEGMENTO 1: del centro hacia afuera. */
                // this.caso.r2prom= 11.5;                
                var cD_a11 = "";var cD_p11 = "";var cD_a12 = "";var cD_p12 = "";var cD_a13 = "";var cD_p13 = "";var cD_a14 = "";var cD_p14 = "";
                if (this.caso.r4prom <= 3.125) {
                    cD_a11 = "*";cD_p11 = this.caso.r4prom.toString();
                } else {
                    if (this.caso.r4prom > 3.125 && this.caso.r4prom <= 6.25) {
                        cD_a12 = "*";cD_p12 = this.caso.r4prom.toString();
                    } else {
                        if (this.caso.r4prom > 6.25 && this.caso.r4prom <= 9.375) {
                            cD_a13 = "*";cD_p13 = this.caso.r4prom.toString();
                        } else if (this.caso.r4prom > 9.375 && this.caso.r4prom <= 12.5) {
                            cD_a14 = "*";cD_p14 = this.caso.r4prom.toString();
                        }
                    }
                }
                /* CUADRANTE C- SEGMENTO 2: del centro hacia afuera. */
                // this.caso.r1prom= 11.5;
                var cC_a21 = "";var cC_p21 = "";var cC_a22 = "";var cC_p22 = "";var cC_a23 = "";var cC_p23 = "";var cC_a24 = "";var cC_p24 = "";
                if (this.caso.r3prom > 12.5 && this.caso.r3prom <= 16.88) {
                    cC_a21 = "*";cC_p21 = this.caso.r3prom.toString();
                } else {
                    if (this.caso.r3prom > 16.88 && this.caso.r3prom <= 21.26) {
                        cC_a21 = "*";cC_p22 = this.caso.r3prom.toString();
                    } else {
                        if (this.caso.r3prom > 21.26 && this.caso.r3prom <= 25.63) {
                            cC_a23 = "*";cC_p23 = this.caso.r3prom.toString();
                        } else if (this.caso.r3prom > 25.63 && this.caso.r3prom <= 30) {
                            cC_a24 = "*";cC_p24 = this.caso.r3prom.toString();
                        }
                    }
                }
                /* CUADRANTE D- SEGMENTO 2: del centro hacia afuera. */
                // this.caso.r2prom= 11.5;                
                var cD_a21 = "";var cD_p21 = "";var cD_a22 = "";var cD_p22 = "";var cD_a23 = "";var cD_p23 = "";var cD_a24 = "";var cD_p24 = "";
                if (this.caso.r4prom > 12.5 && this.caso.r4prom <= 16.88) {
                    cD_a21 = "*";cD_p21 = this.caso.r4prom.toString();
                } else {
                    if (this.caso.r4prom > 16.88 && this.caso.r4prom <= 21.26) {
                        cD_a22 = "*";cD_p22 = this.caso.r4prom.toString();
                    } else {
                        if (this.caso.r4prom > 21.26 && this.caso.r4prom <= 25.63) {
                            cD_a23 = "*";cD_p23 = this.caso.r4prom.toString();
                        } else if (this.caso.r4prom > 25.63 && this.caso.r4prom <= 30) {
                            cD_a24 = "*";cD_p24 = this.caso.r4prom.toString();
                        }
                    }
                }
                console.log("> prom 4 ? ", this.caso.r4prom, "* cC_a32 ? ", cD_a23, ", valor ? ", cD_p23);
                console.log("> prom 4 ? ", this.caso.r4prom, "* cC_a32 ? ", cD_a24, ", valor ? ", cD_p24);

                /* CUADRANTE D- SEGMENTO 1: del centro hacia afuera. */
                var cC_a31 = "";var cC_p31 = "";var cC_a32 = "";var cC_p32 = "";var cC_a33 = "";var cC_p33 = "";var cC_a34 = "";var cC_p34 = "";
                if (this.caso.r3prom > 30 && this.caso.r3prom <= 32.51) {
                    cC_a31 = "*";cC_p31 = this.caso.r3prom.toString();
                } else {
                    if (this.caso.r3prom > 32.51 && this.caso.r3prom <= 35.01) {
                        cC_a32 = "*";cC_p32 = this.caso.r3prom.toString();
                    } else {
                        if (this.caso.r3prom > 35.01 && this.caso.r3prom <= 37.5) {
                            cC_a33 = "*";cC_p33 = this.caso.r3prom.toString();
                        } else if (this.caso.r3prom > 37.5 && this.caso.r3prom <= 40) {
                            cC_a34 = "*";cC_p34 = this.caso.r3prom.toString();
                        }
                    }
                }
                console.log("prom 4 ? ", this.caso.r4prom, "* cC_a32 ? ", cC_a33, ", valor ? ", cC_p33);

                /* CUADRANTE D- SEGMENTO 2: del centro hacia afuera. */
                var cD_a31 = "";var cD_p31 = "";var cD_a32 = "";var cD_p32 = "";var cD_a33 = "";var cD_p33 = "";var cD_a34 = "";var cD_p34 = "";
                if (this.caso.r4prom > 30 && this.caso.r4prom <= 32.51) {
                    cD_a31 = "*";cD_p31 = this.caso.r4prom.toString();
                } else {
                    if (this.caso.r4prom > 32.51 && this.caso.r4prom <= 35.01) {
                        cD_a32 = "*";cD_p32 = this.caso.r4prom.toString();
                    } else {
                        if (this.caso.r4prom > 35.01 && this.caso.r4prom <= 37.5) {
                            cD_a33 = "*";cD_p33 = this.caso.r4prom.toString();
                        } else if (this.caso.r4prom > 37.5 && this.caso.r4prom <= 40) {
                            cD_a34 = "*";cD_p34 = this.caso.r4prom.toString();
                        }
                    }
                }
                console.log("prom 4 ? ", this.caso.r4prom, "* cC_a32 ? ", cD_a33, ", valor ? ", cD_p33);

                /* CUADRANTE D- SEGMENTO 3: del centro hacia afuera. */
                var cC_a41 = "";var cC_p41 = "";var cC_a42 = "";var cC_p42 = "";
                if (this.caso.r3prom > 40 && this.caso.r3prom <= 42.5) {
                    cC_a41 = "*";cC_p41 = this.caso.r3prom.toString();
                } else {
                    if (this.caso.r3prom > 42.5) {
                        cC_a42 = "*";cC_p42 = this.caso.r3prom.toString();
                    }
                }
                /* CUADRANTE D- SEGMENTO 4: del centro hacia afuera. */
                var cD_a41 = "";var cD_p41 = "";var cD_a42 = "";var cD_p42 = "";
                if (this.caso.r4prom > 40 && this.caso.r4prom <= 42.5) {
                    cD_a41 = "*";cD_p41 = this.caso.r4prom.toString();
                } else {
                    if (this.caso.r4prom > 42.5) {
                        cD_a42 = "*";cD_p42 = this.caso.r4prom.toString();
                    }
                }

                // console.log("prom3 ? ",this.caso.r3prom,", prom4 ? ",this.caso.r4prom);

                /** Codificación de la imagen que representa el logotipo de Top Consultores */
                var imagen = "data:image/jpeg;base64,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";
                var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
                var linea = 5;

                /** Muestra el logo. (izq, top, ancho, alto) */
                doc.addImage(imagen, 'JPEG', 165, linea, 40, 20);
                /** fila, columna */

                /** CIRCULOS  */
                doc.setLineWidth(1); // Grosor de la línea del borde
                doc.setDrawColor(0);

                /** ................................................................................................................ 
                /* TEXTO INTRODUCTORIO */
                var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

                var lhoy = new Date();
                //lhoy=   lhoy.toString();
                var ldia = lhoy.getDate();
                var lmes = meses[lhoy.getMonth()];
                var lanio = lhoy.getFullYear();

                console.log("lhoy ? ", lhoy);
                console.log("ldia ? ", ldia, ", lmes ? ", lmes, ", lanio ? ", lanio);
                doc.setFontSize(9);
                linea = 25;
                doc.text(10, linea, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
                doc.text(10, linea + 7, this.caso.nombre);
                doc.text(10, linea + 12, this.caso.empresa);
                doc.text(10, linea + 19, "");
                doc.text(10, linea + 24, "");

                /** ................................................................................................................ 
                /* GRAFICA */

                /* El circulo rojo EXTERIOR. (left, bottom, tamaño) */
                linea = 155; // **LINEA= 115, 135
                doc.setFillColor(247, 189, 164); // Color rosadito
                doc.circle(105, linea, 95, 'FD'); // Ciculo

                /* El circulo azul INTERIOR. (left, bottom, tamaño)*/
                doc.setFillColor(177, 203, 233); // Color azul
                doc.circle(104, linea, 70, 'FD');

                /* El circulo rosado INTERIOR. (left, bottom, tamaño) */
                doc.setFillColor(247, 189, 164); // Color rosadito
                doc.circle(104, linea, 30, 'FD');

                /** ................................................................................................................ 
                 *  FRANJA 1 */
                /** Extremo Iquierdo y derecho SUPERIOR */
                linea = 60;
                doc.setFontType("bold");
                doc.setFontSize(10);
                doc.text(10, linea, "El Irresponsable");
                doc.text(182, linea, "Anarquía");
                doc.text(10, linea + 5, "Club Campestre");
                doc.text(180, linea + 5, "tumultuosa");
                doc.setFontType("normal");
                doc.setFontSize(9);

                var i = 63;
                while (i <= 250) {

                    var st = ":" + i.toString();
                    doc.text(102, i, ":");
                    i = i + 3;
                };

                linea = 65; // **LINEA 25, 45 (incremento de 20)
                doc.text(93, linea, "Zona Negativa");

                doc.text(59, linea + 10, "Tolerancia");
                doc.text(110, linea + 10, "C");
                doc.text(132, linea + 10, "Sensibilidad");

                doc.text(59, linea + 13, "extrema");
                doc.text(110, linea + 13, "A");
                doc.text(132, linea + 13, "prematura");

                doc.text(59, linea + 17, "individualismo");
                doc.text(110, linea + 16, "O");
                doc.text(132, linea + 17, "experimentación");

                doc.text(59, linea + 21, "incontrolado");
                doc.text(110, linea + 19, "S");
                doc.text(132, linea + 21, "desastroza");

                doc.setFontType("bold");
                doc.text(36, linea + 24, '-------', null, 135); // Diagonal exterior, superior-izquierdo \, (Columna, fila, texto, null, grados)
                doc.text(181, linea + 21, '-------', null, -135); // Diagonal exterior, superior-derecho /,   (Columna, fila, texto, null, grados)

                /// CUADRANTE A: PLOTEO DEL PUNTO 4
                // ******************************************************************************************
                doc.setFontSize(9);
                doc.setFontType("normal"); // 1A. GRADA, de arriba a abajo  
                doc.text(36, linea + 31, '-------', null, 45);
                doc.text(171, linea + 28, '-------', null, -45);

                // console.log("AyB, seg1. ",cA_a11,cA_p11,cA_a12,cA_p12,cA_a13,cA_p13,cA_a14,cA_p14,
                //                             cB_a11,cB_p11,cB_a12,cB_p12,cB_a13,cB_p13,cB_a14,cB_p14);
                this.ploteoCuadranteAyBSeg1(doc, cA_a11, cA_p11, cA_a12, cA_p12, cA_a13, cA_p13, cA_a14, cA_p14, cB_a11, cB_p11, cB_a12, cB_p12, cB_a13, cB_p13, cB_a14, cB_p14);
                // console.log("AyB, seg2. ",cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                //                             cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24);
                this.ploteoCuadranteAyBSeg2(doc, cA_a21, cA_p21, cA_a22, cA_p22, cA_a23, cA_p23, cA_a24, cA_p24, cB_a21, cB_p21, cB_a22, cB_p22, cB_a23, cB_p23, cB_a24, cB_p24);
                // console.log("AyB, seg3. ",cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                //                             cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34);
                this.ploteoCuadranteAyBSeg3(doc, cA_a31, cA_p31, cA_a32, cA_p32, cA_a33, cA_p33, cA_a34, cA_p34, cB_a31, cB_p31, cB_a32, cB_p32, cB_a33, cB_p33, cB_a34, cB_p34);
                // console.log("AyB, seg4. ",cA_a41,cA_p41,cA_a42,cA_p42,cB_a41,cB_p41,cB_a42,cB_p42);
                this.ploteoCuadranteAyBSeg4(doc, cA_a41, cA_p41, cA_a42, cA_p42, cB_a41, cB_p41, cB_a42, cB_p42);

                /** ................................................................................................................ 
                 *  FRANJA 2 */
                linea = 95; // **LINEA= 55 (incremento de 20)
                doc.text(93, linea, "Zona Positiva");

                doc.text(80, linea + 8, "Compromiso");
                doc.text(115, linea + 8, "Innovación");

                doc.text(25, linea + 12, "Participación");
                doc.text(80, linea + 12, "moral,");
                doc.text(115, linea + 12, "adaptación,");
                doc.text(165, linea + 12, "Conveniencia");

                doc.text(25, linea + 16, "inadecuada,");
                doc.text(80, linea + 16, "desarrollo");
                doc.text(115, linea + 16, "cambio");
                doc.text(165, linea + 16, "política");

                doc.text(25, linea + 20, "discusión no,");
                doc.text(80, linea + 20, "humano");
                doc.text(165, linea + 20, "oportunismo sin,");

                doc.text(25, linea + 24, "productiva");
                doc.text(165, linea + 24, "principios");

                doc.setFontType("bold");
                doc.setTextColor(0, 0, 255);
                doc.setFontSize(11);
                doc.text(51, linea + 16, '-------', null, 45); // 2DA. GRADA, de arriba a abajo
                doc.text(155, linea + 14, '-------', null, -45);
                doc.setTextColor(100);
                doc.setFontSize(9);

                doc.setFontType("bold");
                doc.setFontSize(13);

                doc.setFontSize(9);
                doc.setFontType("normal");
                doc.setTextColor(0, 0, 0);

                /** ................................................................................................................ 
                 *  FRANJA 3 */
                linea = 135; // **LINEA= 65, 105 (115 - 65= 50 incremento, incremento 30)
                doc.text(66, linea - 9, '-------', null, 45); // 3ERA. GRADA, de arriba a abajo
                doc.text(140, linea - 13, '-------', null, -45);
                doc.setFontType("bold");
                doc.setFontSize(13);
                doc.setFontSize(9);
                doc.setFontType("normal");

                doc.text(45, linea, "Participación,");
                doc.text(139, linea, "Apoyo externo,");

                doc.text(45, linea + 5, "franqueza,");
                doc.text(139, linea + 5, "adquisición de");

                doc.text(45, linea + 10, "discusión");
                doc.text(139, linea + 10, "recursos,");

                doc.setFontType("bold");
                doc.setTextColor(0, 0, 255);
                doc.setFontSize(11);
                doc.text(79, linea + 4, '-------', null, 45); // 3A-b. GRADA, de arriba a abajo
                doc.text(125, linea + 1, '-------', null, -45);
                doc.setFontType("normal");
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(9);

                doc.text(85, linea + 9, '-------', null, 45); // 4A. GRADA, de arriba a abajo
                doc.text(119, linea + 7, '-------', null, -45);

                doc.text(93, linea + 15, "Zona Negativa");
                doc.text(139, linea + 15, "crecimiento,");

                /** ................................................................................................................ 
                 *  FRANJA 4 */
                linea = 157; // **LINEA= 117 (incremento de 20)
                doc.text(15, linea, "Apatía");
                doc.text(91, linea, "- Valores claros");
                doc.text(177, linea, "Beligerancia");

                var zonaDiscontinua = "......................................................................................................................................................................................................................";
                doc.text(10, linea + 2, zonaDiscontinua);
                doc.text(15, linea + 6, "Indiferencia");
                doc.text(45, linea + 6, "Manejo de");
                doc.text(89, linea + 6, "- Valores Opuestos");
                doc.text(139, linea + 6, "Productividad");
                doc.text(177, linea + 6, "Hostilidad");

                doc.text(45, linea + 12, "información,");
                doc.text(139, linea + 12, "logro, impacto");

                doc.text(89, linea + 15, '-------', null, 135); // 1A. GRADA, del centro al exterior.
                doc.text(122, linea + 10, '-------', null, -135);
                this.ploteoCuadranteCyDSeg1(doc, cC_a11, cC_p11, cC_a12, cC_p12, cC_a13, cC_p13, cC_a14, cC_p14, cD_a11, cD_p11, cD_a12, cD_p12, cD_a13, cD_p13, cD_a14, cD_p14);
                this.ploteoCuadranteCyDSeg2(doc, cC_a21, cC_p21, cC_a22, cC_p22, cC_a23, cC_p23, cC_a24, cC_p24, cD_a21, cD_p21, cD_a22, cD_p22, cD_a23, cD_p23, cD_a24, cD_p24);
                this.ploteoCuadranteCyDSeg3(doc, cC_a31, cC_p31, cC_a32, cC_p32, cC_a33, cC_p33, cC_a34, cC_p34, cD_a31, cD_p31, cD_a32, cD_p32, cD_a33, cD_p33, cD_a34, cD_p34);
                this.ploteoCuadranteCyDSeg4(doc, cC_a41, cC_p41, cC_a42, cC_p42, cD_a41, cD_p41, cD_a42, cD_p42);

                doc.setFontType("bold");
                doc.setTextColor(0, 0, 255);
                doc.setFontSize(11);
                doc.text(85, linea + 20, '-------', null, 135); // 1Ab. GRADA, del centro al exterior.
                doc.text(128, linea + 15, '-------', null, -135);
                doc.setFontType("normal");
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(9);

                /** En esta fila NO HAY TEXTO solo las graas y los valores */
                linea = 168;
                doc.text(63, linea + 24, '-------', null, 135); // 2A. GRADA, del centro al exterior.
                doc.text(150, linea + 21, '-------', null, -135);

                doc.setFontType("bold");
                doc.setFontSize(13);
                doc.setFontSize(9);
                doc.setFontType("normal");

                /** ................................................................................................................ 
                 *  FRANJA 5 */
                linea = 187; // **LINEA= 147 (incremento de 20)
                var columna1 = "Esterelidad de";
                var columna4 = "Esfuerzo";
                doc.text(22, linea + 6, columna1);
                doc.text(167, linea + 6, columna4);
                doc.setFontType("bold");
                doc.setTextColor(0, 0, 255);
                doc.setFontSize(11);
                doc.text(52, linea + 13, '-------', null, 135); // 4A. GRADA, del centro al exterior.
                doc.text(158, linea + 11, '-------', null, -135);
                doc.setFontType("normal");
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(9);

                var columna1 = "procedimientos";
                var columna2 = "Estabilidad,";
                var columna3 = "Dirección,";
                var columna4 = "perpeto,";
                doc.text(22, linea + 9, columna1);
                doc.text(80, linea + 9, columna2);
                doc.text(114, linea + 9, columna3);
                doc.text(167, linea + 9, columna4);
                doc.setFontType("bold");
                doc.setFontSize(13);

                doc.setFontSize(9);
                doc.setFontType("normal");
                var columna1 = "rigor trivial";
                var columna2 = "control,";
                var columna3 = "claridad de";
                var columna4 = "agotamiento";
                doc.text(22, linea + 13, columna1);
                doc.text(80, linea + 13, columna2);
                doc.text(114, linea + 13, columna3);
                doc.text(167, linea + 13, columna4);

                var columna2 = "continuidad";
                var columna3 = "metas,";
                var columna4 = "humano";
                doc.text(80, linea + 17, columna2);
                doc.text(114, linea + 17, columna3);
                doc.text(167, linea + 16, columna4);

                var columna3 = "planificación,";
                doc.text(114, linea + 21, columna3);

                doc.text(39, linea + 28, '-------', null, 135); // 4A. GRADA, del centro al exterior.
                doc.text(173, linea + 26, '-------', null, -135);

                doc.text(32, linea + 28, '-------', null, -135); // DIAGONAL EXTERIOR, cuadrante C
                doc.text(180, linea + 38, '-------', null, 135); // DIAGONAL EXTERIOR, cuadrante D

                /** ................................................................................................................ 
                 *  FRANJA 6 */
                linea = 225; // **LINEA= 185, 205
                var columna1 = "Perpetuación";
                var columna2 = "R";
                var columna3 = "Regulación,";
                doc.text(60, linea, columna1);
                doc.text(100, linea + 4, columna2);
                doc.text(132, linea, columna3);

                var columna1 = "habitual,";
                var columna2 = "i";
                var columna3 = "indiscriminada,";
                doc.text(60, linea + 4, columna1);
                doc.text(100, linea + 4, columna2);
                doc.text(132, linea + 4, columna3);

                var columna1 = "tradicion";
                var columna2 = "g";
                var columna3 = "dogma ciego,";
                doc.text(60, linea + 8, columna1);
                doc.text(100, linea + 8, columna2);
                doc.text(132, linea + 8, columna3);

                var columna1 = "inflexible";
                var columna2 = "i";
                doc.text(60, linea + 12, columna1);
                doc.text(100, linea + 12, columna2);

                var columna2 = "d";
                doc.text(100, linea + 16, columna2);

                var columna2 = "e";
                doc.text(100, linea + 19, columna2);

                var columna2 = "z";
                doc.text(100, linea + 22, columna2);
                doc.setFontType("bold");
                doc.setFontSize(10);
                doc.text(10, linea + 22, "La burocracia");
                doc.text(181, linea + 22, "Fábrica");
                doc.text(13, linea + 27, "petrífica");
                doc.text(180, linea + 27, "opresiva");
                doc.setFontType("normal");
                doc.setFontSize(9);

                /** CREACION DEL ARCHIVO PDF */
                doc.save('CG.pdf');
            } else {

                var miMensajeAlerta = "Debe CARGAR los datos para " + __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_caso.nombre;
                if (__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_modo === "INGRESO") {

                    miMensajeAlerta = "Debe INGRESAR información para el nuevo caso";
                }
                alert(miMensajeAlerta);
            } // if()
        }
    } // methods
    // export

});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(308);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    components: {
        'eventBus': __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* default */]
    },
    props: {
        value: {
            type: Date,
            default: new Date()
        }
    },
    template: '#ingresoTemplate',
    methods: {
        dateToYYYYMMDD: function dateToYYYYMMDD(date) {

            return date && date.toISOString().split('T')[0];
        },
        // datetoYYYMMDD()
        updateValue: function updateValue(target) {

            this.$emit('input', target.valueAsDate);
        }, //updateValue()
        selectAll: function selectAll(event) {

            setTimeout(function () {
                event.target.select();
            }, 0);
        } // selectAll()
        // metodhs
    } // export

});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__culturaGCasosTotal_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__culturaGPagineo_vue__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(2);
/**
 *      culguraGlistado.js
 *          Script de culturaGlistado.vue
 *          Obtiene los casos de evaluación ya registrados permitiendo editarlos y eliminarlos
 */
/* ======================================================================================================== */










// import 'materialize-css/dist/css/materialize.min.css'

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'listadoencuesta',
    components: {
        'moment': __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
        'input-date': __WEBPACK_IMPORTED_MODULE_2__ingreso_vue__["a" /* default */],
        casosxEmpresa: __WEBPACK_IMPORTED_MODULE_3__culturaGCasosTotal_vue__["a" /* default */],
        pagineo: __WEBPACK_IMPORTED_MODULE_4__culturaGPagineo_vue__["a" /* default */]
    },
    template: '#listadoEncuesta',
    data: function data() {
        return {
            casos: [],
            casos_copia: null, // Necesario  una copia para borrar una encuesta después buscar por Descripción o Responsable.

            busqueda: "", busquedaR: "", // Variables para la búsqueda}
            lfuente: "C" // return
        };
    },
    // data()
    mounted: function mounted() {

        /** Definiciones para el uso de las secciones tipo slide y tooltips */
        var elems = document.querySelectorAll('.collapsible');
        var instances = __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.Collapsible.init(elems, {});

        var elems = document.querySelectorAll('.tooltipped');
        var instances = __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.Tooltip.init(elems, {});

        this.bdRead(); // CAMBIO 2: Leyendo la info de FireBase.
        // this.bdReadMem();        
    },

    computed: {
        lc_ini: function lc_ini() {
            return __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */].state.Clini;
        },
        lc_fin: function lc_fin() {
            return __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */].state.Clfin;
        },
        c_pagina: function c_pagina() {
            return __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */].state.Cpagina;
        },

        filtrarCasos: function filtrarCasos() {
            var _this = this;

            return this.casos.filter(function (caso) {

                /* Preserva el índice las tareas recién instanciadas ya que cuando se realiza una búsqueda y se quiere 
                   eliminar una tarea, el índice cambia y borra otra tarea. [ Ver función eliminar() ] en tareas.vue.  */
                if (caso.empresa.toUpperCase().includes(_this.busqueda.toUpperCase()) && caso.nombre.toUpperCase().includes(_this.busquedaR.toUpperCase())) {
                    return caso;
                }
            });
        } // filtarTareas()
    },
    methods: {
        eliminarCaso: function eliminarCaso(elCaso, index) {

            var confirma = confirm("Seguro de eliminar la evaluación de " + elCaso.nombre.trim() + " ? " + index + ")");
            if (confirma === true) {

                var lnuevaRuta = __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */].state.st_rutaCasos + "/" + index;
                var dbCasos = __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */].state.st_db.ref(lnuevaRuta);

                var elRegTarea = dbCasos.remove();
            }
        },
        mostrarCaso: function mostrarCaso(elcaso) {

            __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */].state.st_modo = "EDITAR";
            __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */].state.st_caso = elcaso;
            // console.log("[culturaGlistado- mostrarEncuesta], modo ? ",store.state.st_modo,", ",store.state.st_caso);
            // console.log("[culturaGlistado- mostrarEncuesta], nombre ? ",store.state.st_caso.nombre);

            //this.$refs.email.$el.focus()
            // culturaG.$refs.testt1.$el.focus();
        },

        /* ========================================================================================================= */
        getCasos: function getCasos(losCasos) {

            // console.log("[culturaGlistado.js- getCasos], losCasos ? ",losCasos);
            // console.log("[culturaGlistado.js- getCasos], casos antes ? ",this.casos);
            this.casos = [];
            // console.log("[culturaGlistado.js- getCasos], casos despues ? ",this.casos);

            for (var key in losCasos) {

                // console.log("[culturaGlistado.js]-getCasos(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
                this.casos.push({

                    llave: key, // 1
                    empresa: losCasos[key].empresa,
                    nombre: losCasos[key].nombre,
                    g1pg1: losCasos[key].g1pg1, g1pg2: losCasos[key].g1pg2, g1pg3: losCasos[key].g1pg3, g1pg4: losCasos[key].g1pg4,
                    g2pg1: losCasos[key].g2pg1, g2pg2: losCasos[key].g2pg2, g2pg3: losCasos[key].g2pg3, g2pg4: losCasos[key].g2pg4,
                    g3pg1: losCasos[key].g3pg1, g3pg2: losCasos[key].g3pg2, g3pg3: losCasos[key].g3pg3, g3pg4: losCasos[key].g3pg4,
                    g4pg1: losCasos[key].g4pg1, g4pg2: losCasos[key].g4pg2, g4pg3: losCasos[key].g4pg3, g4pg4: losCasos[key].g4pg4,
                    g5pg1: losCasos[key].g5pg1, g5pg2: losCasos[key].g5pg2, g5pg3: losCasos[key].g5pg3, g5pg4: losCasos[key].g5pg4,
                    g6pg1: losCasos[key].g6pg1, g6pg2: losCasos[key].g6pg2, g6pg3: losCasos[key].g6pg3, g6pg4: losCasos[key].g6pg4,
                    r1suma: losCasos[key].r1suma, r2suma: losCasos[key].r2suma, r3suma: losCasos[key].r3suma, r4suma: losCasos[key].r4suma,
                    r1prom: losCasos[key].r1prom, r2prom: losCasos[key].r2prom, r3prom: losCasos[key].r3prom, r4prom: losCasos[key].r4prom
                });
            } // for

            this.limite = this.casos.length; // cantidad de datos                
            this.casos_copia = this.casos;

            // console.log("[culturaGlistado.js- getCasos], st_casos antes ? ",store.state.st_casos);
            __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */].state.st_casos = this.casos;
            // console.log("[culturaGlistado.js- getCasos], st_casos despues ? ",store.state.st_casos);
        },
        bdRead: function bdRead() {
            var _this2 = this;

            // console.log("[culturaGlistado.js- bdRead], this.casos ? ",this.casos);
            // console.log("[culturaGlistado.js- bdRead], st_dbCasos ? ",store.state.st_dbCasos);
            var dummy = __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */].state.st_dbCasos.on('value', function (snapshot) {
                return _this2.getCasos(snapshot.val());
            });
        },
        // bdRead()            
        bdReadMem: function bdReadMem() {

            // console.log("[bdReadMem], store.state.st_casos ? ",store.state.st_casos);
            this.getCasos(__WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */].state.st_casos);

            // store.state.st_casos= this.losCasos;
            // console.log("[bdReadMem], casos ? ",this.casos);
        }
    } // methods    
    // export

});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['busqueda'],
    computed: {
        casosxEmpresa: function casosxEmpresa() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.st_casos.filter(function (caso) {

                console.log("caso ? ", caso.empresa.toUpperCase());
                if (caso.empresa.toUpperCase().includes(_this.busqueda.toUpperCase())) {
                    return caso;
                }
            });
        },
        // CasosxEmpresa()
        laEmpresa: function laEmpresa() {
            var ltexto = "";
            if (this.busqueda.length > 0) {
                ltexto = this.casosxEmpresa.length + " casos para " + this.busqueda + ".";
            }
            return ltexto;
        },
        // laEmpresa()
        totaldeCasos: function totaldeCasos() {
            return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].getters.totalCasos;
        }
    } // computed
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {store}          from './../store'  

// import {mapGetters}     from 'vuex'

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['lista', 'listaf', 'mensaje', 'liminf', 'limsup', 'npagina', 'fuente'],
    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])(['pagina', 'lini', 'lfin', 'limite', 'esLimiteInf', 'esLimiteSup']),
    methods: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapMutations */])(['anterior', 'siguiente'])
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *      ev01_tipologia.js
 *          Script de ev01_tipologia.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */

/* ======================================================================================================== */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
     name: 'tipologia',
     components: {
          'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
          'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
     },
     template: '#formaTipologia',
     data: function data() {
          return {
               temporal: 0,
               ejemplo: {},
               eval_tipolo: {}, res: {},
               modo: "",
               eval_fecha: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,

               //? .....................................................................................................................................................................................................................
               activott1: "active", activott2: '!active', activott3: "!active",
               vertt1: true, vertt2: false, vertt3: false,
               area1: "", area2: '', area3: ''

               //? .....................................................................................................................................................................................................................

               // return
          };
     },
     // data()
     mounted: function mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();
     },

     computed: {
          l_sinResponder: function l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder: function l_ejeSinResponder() {
               return this.ejeSinContestar();
          }
     },
     methods: {
          crearPDF: function crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_tipolo.nombre,
                   patron = / /g,
                   nuevoValor = "",
                   nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "TipoPer_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1); // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación TIPO DE PERSONALIDAD para " + this.eval_tipolo.nombre + " de " + this.eval_tipolo.empresa + " ( " + this.eval_tipolo.depto + " )");

               this.respuestas(doc);
               this.losresultados(doc);
               this.latopologia(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          latopologia: function latopologia(doc) {

               this.res.par1iguales = false;this.res.par2iguales = false;this.res.par3iguales = false;this.res.par4iguales = false;
               this.res.topologiaEI1 = "";this.res.topologiaSN1 = "";this.res.topologiaTF1 = "";this.res.topologiaJP1 = "";

               console.log("** resultados");
               console.log("E ? ", this.res.E, "; I ? ", this.res.I, "; par1iguales ? ", this.res.par1iguales, "; topologiaEI ? ", this.res.topologiaEI1);
               /* E > I, I > E, I = E */
               if (this.res.E > this.res.I) {
                    this.res.topologiaEI1 = "E -";
               } else if (this.res.I > this.res.E) {
                    this.res.topologiaEI1 = "I -";
               } else {
                    this.res.par1iguales = true;
                    this.res.topologiaEI1 = "E -";
               }
               console.log("E ? ", this.res.E, "; I ? ", this.res.I, "; par1iguales ? ", this.res.par1iguales, "; topologiaEI ? ", this.res.topologiaEI1);
               console.log("-------------------------------------------------------");

               /* S > N, N > S, S = N */
               console.log("S ? ", this.res.S, "; N ? ", this.res.N, "; par2iguales ? ", this.res.par2iguales, "; topologiaSN ? ", this.res.topologiaSN1);
               if (this.res.S > this.res.N) {
                    this.res.topologiaSN1 = "S -";
               } else if (this.res.N > this.res.S) {
                    this.res.topologiaSN1 = "N -";
               } else {
                    this.res.par2iguales = true;
                    this.res.topologiaSN1 = "S -";
               }
               console.log("S ? ", this.res.S, "; N ? ", this.res.N, "; par2iguales ? ", this.res.par2iguales, "; topologiaSN ? ", this.res.topologiaSN1);
               console.log("-------------------------------------------------------");

               /* T > F, F > T, T = F */
               console.log("T ? ", this.res.T, "; F ? ", this.res.F, "; par3iguales ? ", this.res.par3iguales, "; topologiaTF ? ", this.res.topologiaTF1);
               if (this.res.T > this.res.F) {
                    this.res.topologiaTF1 = "T -";
               } else if (this.res.F > this.res.T) {
                    this.res.topologiaTF1 = "F -";
               } else {
                    this.res.par3iguales = true;
                    this.res.topologiaTF1 = "T -";
               }
               console.log("T ? ", this.res.T, "; F ? ", this.res.F, "; par3iguales ? ", this.res.par3iguales, "; topologiaTF ? ", this.res.topologiaTF1);
               console.log("-------------------------------------------------------");

               /* J > P, P > J, J = P */
               console.log("J ? ", this.res.J, "; P ? ", this.res.P, "; par4iguales ? ", this.res.par4iguales, "; topologiaJP ? ", this.res.topologiaJP1);
               if (this.res.J > this.res.P) {
                    this.res.topologiaJP1 = "J -";
               } else if (this.res.P > this.res.J) {
                    this.res.topologiaJP1 = "P -";
               } else {
                    this.res.par4iguales = true;
                    this.res.topologiaJP1 = "J -";
               }
               console.log("J ? ", this.res.J, "; P ? ", this.res.P, "; par4iguales ? ", this.res.par4iguales, "; topologiaJP ? ", this.res.topologiaJP1);
               console.log("-------------------------------------------------------");

               this.res.topologia1 = "";this.res.topologia2 = "";this.res.topologia3 = "";this.res.topologia4 = "";this.res.topologia5 = "";
               this.res.topologia6 = "";this.res.topologia7 = "";this.res.topologia8 = "";this.res.topologia9 = "";this.res.topologia10 = "";
               this.res.topologia11 = "";this.res.topologia12 = "";this.res.topologia13 = "";this.res.topologia14 = "";this.res.topologia15 = "";
               this.res.topologia16 = "";

               /* Evalua cómo están los pares */
               /* Caso 1: Todos los pares diferentes */
               if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === false) {

                    this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + this.res.topologiaTF1 + this.res.topologiaJP1;

                    this.res.topologia = "CASO ESPERADO: todos los pares tienen valores diferentes.";
               } else {
                    /* Acá tengo los 15 casos restantes */
                    /* ================================ */

                    /* Caso 2: que el primer par (E,I) sea igual */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === false) {

                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + this.res.topologiaTF1 + this.res.topologiaJP1;
                    }
                    /* Caso 3: que el primero y segundo par (E,I) & (S,N) sean iguales */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === false) {

                         this.res.topologia1 = 'E -' + 'S -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + 'S -' + this.res.topologiaTF1 + this.res.topologiaJP1;

                         this.res.topologia3 = 'E -' + 'N -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia4 = 'I -' + 'N -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                    }
                    /* Caso 4: que el primero y tercer par (E,I) && (T,F) sean iguales */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === false) {

                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + 'T -' + this.res.topologiaJP1;

                         this.res.topologia3 = 'E -' + this.res.topologiaSN1 + 'F -' + this.res.topologiaJP1;
                         this.res.topologia4 = 'I -' + this.res.topologiaSN1 + 'F -' + this.res.topologiaJP1;
                    }
                    /* Caso 5: que el primero y cuarto par (E,I) && (J,P) sean iguales */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'J';

                         this.res.topologia3 = 'E -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'P';
                         this.res.topologia4 = 'I -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'P';
                    }
                    /* Caso 6: que solo el SEGUNDO (S,N) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === false) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                    }
                    /* Caso 7: que el segundo (S,N) y el tercero (T,F) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === true && this.res.par3iguales === true && this.res.par4iguales === false) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + 'T -' + this.res.topologiaJP1;

                         this.res.topologia3 = this.res.topologiaEI1 + 'S -' + 'F -' + this.res.topologiaJP1;
                         this.res.topologia4 = this.res.topologiaEI1 + 'N -' + 'F -' + this.res.topologiaJP1;
                    }
                    /* Caso 8: que el SEGUNDO (S,N) y el cuarto (J,P) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + this.res.topologiaTF1 + 'J';

                         this.res.topologia3 = this.res.topologiaEI1 + 'S -' + this.res.topologiaTF1 + 'P';
                         this.res.topologia4 = this.res.topologiaEI1 + 'N -' + this.res.topologiaTF1 + 'P';
                    }
                    /* Caso 9: que solo el TERCER (T,F) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === false) {
                         this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'F -' + this.res.topologiaJP1;
                    }
                    /* Caso 10: primero (E,I) y tercero (T,F) sean iguales  */
                    if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === true) {
                         /*  ESTE DEBE SER */
                         this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'T -' + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'F -' + 'J';

                         this.res.topologia3 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'T -' + 'P';
                         this.res.topologia4 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'F -' + 'P';
                    }
                    /* Caso 11: solo el ultimo (J,P) es iguale */
                    if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + this.res.topologiaSN1 + this.res.topologiaTF1 + 'P';
                    }
                    /* Caso 12: solo el cuarto es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === true && this.res.par4iguales === false) {
                         this.res.topologia1 = 'E -' + 'S -' + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + 'S -' + 'T -' + this.res.topologiaJP1;

                         this.res.topologia3 = 'E -' + 'S -' + 'F -' + this.res.topologiaJP1;
                         this.res.topologia4 = 'I -' + 'S -' + 'F -' + this.res.topologiaJP1;

                         this.res.topologia5 = 'E -' + 'N -' + 'T -' + this.res.topologiaJP1;
                         this.res.topologia6 = 'I -' + 'N -' + 'T -' + this.res.topologiaJP1;

                         this.res.topologia7 = 'E -' + 'N -' + 'F -' + this.res.topologiaJP1;
                         this.res.topologia8 = 'I -' + 'N -' + 'F -' + this.res.topologiaJP1;
                    }

                    /* Caso 13: solo el tercero es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + 'S -' + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = 'I -' + 'S -' + this.res.topologiaTF1 + 'J';

                         this.res.topologia3 = 'E -' + 'S -' + this.res.topologiaTF1 + 'P';
                         this.res.topologia4 = 'I -' + 'S -' + this.res.topologiaTF1 + 'P';

                         this.res.topologia5 = 'E -' + 'N -' + this.res.topologiaTF1 + 'J';
                         this.res.topologia6 = 'I -' + 'N -' + this.res.topologiaTF1 + 'J';

                         this.res.topologia7 = 'E -' + 'N -' + this.res.topologiaTF1 + 'P';
                         this.res.topologia8 = 'I -' + 'N -' + this.res.topologiaTF1 + 'P';
                    }

                    /* Caso 14: solo el segundo es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + 'T -' + 'J';
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + 'T -' + 'J';

                         this.res.topologia3 = 'E -' + this.res.topologiaSN1 + 'T -' + 'P';
                         this.res.topologia4 = 'I -' + this.res.topologiaSN1 + 'T -' + 'P';

                         this.res.topologia5 = 'E -' + this.res.topologiaSN1 + 'F -' + 'J';
                         this.res.topologia6 = 'I -' + this.res.topologiaSN1 + 'F -' + 'J';

                         this.res.topologia7 = 'E -' + this.res.topologiaSN1 + 'F -' + 'P';
                         this.res.topologia8 = 'I -' + this.res.topologiaSN1 + 'F -' + 'P';
                    }

                    /* Caso 15: solo el primero es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === true) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + 'T -' + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + 'T -' + 'J';

                         this.res.topologia3 = this.res.topologiaEI1 + 'S -' + 'T -' + 'P';
                         this.res.topologia4 = this.res.topologiaEI1 + 'N -' + 'T -' + 'P';

                         this.res.topologia5 = this.res.topologiaEI1 + 'S -' + 'F -' + 'J';
                         this.res.topologia6 = this.res.topologiaEI1 + 'N -' + 'F -' + 'J';

                         this.res.topologia7 = this.res.topologiaEI1 + 'S -' + 'F -' + 'P';
                         this.res.topologia8 = this.res.topologiaEI1 + 'N -' + 'F -' + 'P';
                    }

                    /* Caso 16: solo el primero es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === true && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + 'S -' + 'T -' + 'J';
                         this.res.topologia2 = 'E -' + 'S -' + 'T -' + 'P';
                         this.res.topologia3 = 'E -' + 'S -' + 'F -' + 'J';
                         this.res.topologia4 = 'E -' + 'S -' + 'F -' + 'P';

                         this.res.topologia5 = 'E -' + 'N -' + 'T -' + 'J';
                         this.res.topologia6 = 'E -' + 'N -' + 'T -' + 'P';

                         this.res.topologia7 = 'E -' + 'S -' + 'F -' + 'J';
                         this.res.topologia8 = 'E -' + 'N -' + 'F -' + 'J';

                         this.res.topologia9 = 'I -' + 'S -' + 'T -' + 'J';
                         this.res.topologia10 = 'I -' + 'S -' + 'T -' + 'P';
                         this.res.topologia11 = 'I -' + 'S -' + 'F -' + 'J';
                         this.res.topologia12 = 'I -' + 'S -' + 'F -' + 'P';

                         this.res.topologia13 = 'I -' + 'N -' + 'T -' + 'J';
                         this.res.topologia14 = 'I -' + 'N -' + 'T -' + 'P';

                         this.res.topologia15 = 'I -' + 'S -' + 'F -' + 'J';
                         this.res.topologia16 = 'I -' + 'N -' + 'F -' + 'J';
                    }
               }
               this.res.topologia = "CASO ESPECIAL: Por lo menos un par tiene valores diferentes.";

               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 136, "SECCION DE TOPOLOGIA " + this.res.topologia);
               doc.line(10, 138, 206, 138);
               doc.text(10, 142, " ( " + this.res.par1iguales + " , " + this.res.par2iguales + " , " + this.res.par3iguales + " , " + this.res.par4iguales + " ) ");
               doc.text(10, 146, "* " + this.res.topologia1);
               doc.text(10, 150, "* " + this.res.topologia2);
               doc.text(10, 154, "* " + this.res.topologia3);
               doc.text(10, 158, "* " + this.res.topologia4);
               doc.text(10, 162, "* " + this.res.topologia5);
               doc.text(10, 166, "* " + this.res.topologia6);
               doc.text(10, 170, "* " + this.res.topologia7);
               doc.text(10, 174, "* " + this.res.topologia8);
               doc.text(10, 178, "* " + this.res.topologia9);
               doc.text(10, 182, "* " + this.res.topologia10);
               doc.text(10, 186, "* " + this.res.topologia11);
               doc.text(10, 190, "* " + this.res.topologia12);
               doc.text(10, 194, "* " + this.res.topologia13);
               doc.text(10, 198, "* " + this.res.topologia14);
               doc.text(10, 202, "* " + this.res.topologia15);
               doc.text(10, 206, "* " + this.res.topologia16);
          },
          losresultados: function losresultados(doc) {

               /* Columnas E & I */
               this.res.E = 0;this.res.I = 0;
               if (this.eval_tipolo.pg001 === "1") {
                    this.res.E = this.res.E + 1;
               } else {
                    this.res.I = this.res.I + 1;
               }
               if (this.eval_tipolo.pg008 === "1") {
                    this.res.E = this.res.E + 1;
               } else {
                    this.res.I = this.res.I + 1;
               }
               if (this.eval_tipolo.pg015 === "1") {
                    this.res.E = this.res.E + 1;
               } else {
                    this.res.I = this.res.I + 1;
               }
               if (this.eval_tipolo.pg022 === "1") {
                    this.res.E = this.res.E + 1;
               } else {
                    this.res.I = this.res.I + 1;
               }
               if (this.eval_tipolo.pg029 === "1") {
                    this.res.E = this.res.E + 1;
               } else {
                    this.res.I = this.res.I + 1;
               }
               if (this.eval_tipolo.pg036 === "1") {
                    this.res.E = this.res.E + 1;
               } else {
                    this.res.I = this.res.I + 1;
               }
               if (this.eval_tipolo.pg043 === "1") {
                    this.res.E = this.res.E + 1;
               } else {
                    this.res.I = this.res.I + 1;
               }
               if (this.eval_tipolo.pg050 === "1") {
                    this.res.E = this.res.E + 1;
               } else {
                    this.res.I = this.res.I + 1;
               }
               if (this.eval_tipolo.pg057 === "1") {
                    this.res.E = this.res.E + 1;
               } else {
                    this.res.I = this.res.I + 1;
               }
               if (this.eval_tipolo.pg064 === "1") {
                    this.res.E = this.res.E + 1;
               } else {
                    this.res.I = this.res.I + 1;
               }

               /* Columnas intermedias entre (E - I) y (*S - N) 
                    ( a1= ncol11, b2= ncol12 ) */
               this.res.a1 = 0;this.res.b2 = 0; // 10 preguntas 
               if (this.eval_tipolo.pg002 === "1") {
                    this.res.a1 = this.res.a1 + 1;
               } else {
                    this.res.b2 = this.res.b2 + 1;
               }
               if (this.eval_tipolo.pg009 === "1") {
                    this.res.a1 = this.res.a1 + 1;
               } else {
                    this.res.b2 = this.res.b2 + 1;
               }
               if (this.eval_tipolo.pg016 === "1") {
                    this.res.a1 = this.res.a1 + 1;
               } else {
                    this.res.b2 = this.res.b2 + 1;
               }
               if (this.eval_tipolo.pg023 === "1") {
                    this.res.a1 = this.res.a1 + 1;
               } else {
                    this.res.b2 = this.res.b2 + 1;
               }
               if (this.eval_tipolo.pg030 === "1") {
                    this.res.a1 = this.res.a1 + 1;
               } else {
                    this.res.b2 = this.res.b2 + 1;
               }
               if (this.eval_tipolo.pg037 === "1") {
                    this.res.a1 = this.res.a1 + 1;
               } else {
                    this.res.b2 = this.res.b2 + 1;
               }
               if (this.eval_tipolo.pg044 === "1") {
                    this.res.a1 = this.res.a1 + 1;
               } else {
                    this.res.b2 = this.res.b2 + 1;
               }
               if (this.eval_tipolo.pg051 === "1") {
                    this.res.a1 = this.res.a1 + 1;
               } else {
                    this.res.b2 = this.res.b2 + 1;
               }
               if (this.eval_tipolo.pg058 === "1") {
                    this.res.a1 = this.res.a1 + 1;
               } else {
                    this.res.b2 = this.res.b2 + 1;
               }
               if (this.eval_tipolo.pg065 === "1") {
                    this.res.a1 = this.res.a1 + 1;
               } else {
                    this.res.b2 = this.res.b2 + 1;
               }

               /* Columnas T & F 
                   a3= ncol3, b4= ncol4  */
               this.res.a3 = 0;this.res.b4 = 0; // 10 preguntas
               if (this.eval_tipolo.pg003 === "1") {
                    this.res.a3 = this.res.a3 + 1;
               } else {
                    this.res.b4 = this.res.b4 + 1;
               }
               if (this.eval_tipolo.pg010 === "1") {
                    this.res.a3 = this.res.a3 + 1;
               } else {
                    this.res.b4 = this.res.b4 + 1;
               }
               if (this.eval_tipolo.pg017 === "1") {
                    this.res.a3 = this.res.a3 + 1;
               } else {
                    this.res.b4 = this.res.b4 + 1;
               }
               if (this.eval_tipolo.pg024 === "1") {
                    this.res.a3 = this.res.a3 + 1;
               } else {
                    this.res.b4 = this.res.b4 + 1;
               }
               if (this.eval_tipolo.pg031 === "1") {
                    this.res.a3 = this.res.a3 + 1;
               } else {
                    this.res.b4 = this.res.b4 + 1;
               }
               if (this.eval_tipolo.pg038 === "1") {
                    this.res.a3 = this.res.a3 + 1;
               } else {
                    this.res.b4 = this.res.b4 + 1;
               }
               if (this.eval_tipolo.pg045 === "1") {
                    this.res.a3 = this.res.a3 + 1;
               } else {
                    this.res.b4 = this.res.b4 + 1;
               }
               if (this.eval_tipolo.pg052 === "1") {
                    this.res.a3 = this.res.a3 + 1;
               } else {
                    this.res.b4 = this.res.b4 + 1;
               }
               if (this.eval_tipolo.pg059 === "1") {
                    this.res.a3 = this.res.a3 + 1;
               } else {
                    this.res.b4 = this.res.b4 + 1;
               }
               if (this.eval_tipolo.pg066 === "1") {
                    this.res.a3 = this.res.a3 + 1;
               } else {
                    this.res.b4 = this.res.b4 + 1;
               }

               /* Columnas intermedias entre (S - N) y (*T - F) 
                    a5= ncol5, b6= ncol6 */
               this.res.a5 = 0;this.res.b6 = 0; // 10 preguntas
               if (this.eval_tipolo.pg004 === "1") {
                    this.res.a5 = this.res.a5 + 1;
               } else {
                    this.res.b6 = this.res.b6 + 1;
               }
               if (this.eval_tipolo.pg011 === "1") {
                    this.res.a5 = this.res.a5 + 1;
               } else {
                    this.res.b6 = this.res.b6 + 1;
               }
               if (this.eval_tipolo.pg018 === "1") {
                    this.res.a5 = this.res.a5 + 1;
               } else {
                    this.res.b6 = this.res.b6 + 1;
               }
               if (this.eval_tipolo.pg025 === "1") {
                    this.res.a5 = this.res.a5 + 1;
               } else {
                    this.res.b6 = this.res.b6 + 1;
               }
               if (this.eval_tipolo.pg032 === "1") {
                    this.res.a5 = this.res.a5 + 1;
               } else {
                    this.res.b6 = this.res.b6 + 1;
               }
               if (this.eval_tipolo.pg039 === "1") {
                    this.res.a5 = this.res.a5 + 1;
               } else {
                    this.res.b6 = this.res.b6 + 1;
               }
               if (this.eval_tipolo.pg046 === "1") {
                    this.res.a5 = this.res.a5 + 1;
               } else {
                    this.res.b6 = this.res.b6 + 1;
               }
               if (this.eval_tipolo.pg053 === "1") {
                    this.res.a5 = this.res.a5 + 1;
               } else {
                    this.res.b6 = this.res.b6 + 1;
               }
               if (this.eval_tipolo.pg060 === "1") {
                    this.res.a5 = this.res.a5 + 1;
               } else {
                    this.res.b6 = this.res.b6 + 1;
               }
               if (this.eval_tipolo.pg067 === "1") {
                    this.res.a5 = this.res.a5 + 1;
               } else {
                    this.res.b6 = this.res.b6 + 1;
               }

               /* Columnas T & F 
                    a7= ncol7, b8= ncol8 */
               this.res.a7 = 0;this.res.b8 = 0; // 10 preguntas
               if (this.eval_tipolo.pg005 === "1") {
                    this.res.a7 = this.res.a7 + 1;
               } else {
                    this.res.b8 = this.res.b8 + 1;
               }
               if (this.eval_tipolo.pg012 === "1") {
                    this.res.a7 = this.res.a7 + 1;
               } else {
                    this.res.b8 = this.res.b8 + 1;
               }
               if (this.eval_tipolo.pg019 === "1") {
                    this.res.a7 = this.res.a7 + 1;
               } else {
                    this.res.b8 = this.res.b8 + 1;
               }
               if (this.eval_tipolo.pg026 === "1") {
                    this.res.a7 = this.res.a7 + 1;
               } else {
                    this.res.b8 = this.res.b8 + 1;
               }
               if (this.eval_tipolo.pg033 === "1") {
                    this.res.a7 = this.res.a7 + 1;
               } else {
                    this.res.b8 = this.res.b8 + 1;
               }
               if (this.eval_tipolo.pg040 === "1") {
                    this.res.a7 = this.res.a7 + 1;
               } else {
                    this.res.b8 = this.res.b8 + 1;
               }
               if (this.eval_tipolo.pg047 === "1") {
                    this.res.a7 = this.res.a7 + 1;
               } else {
                    this.res.b8 = this.res.b8 + 1;
               }
               if (this.eval_tipolo.pg054 === "1") {
                    this.res.a7 = this.res.a7 + 1;
               } else {
                    this.res.b8 = this.res.b8 + 1;
               }
               if (this.eval_tipolo.pg061 === "1") {
                    this.res.a7 = this.res.a7 + 1;
               } else {
                    this.res.b8 = this.res.b8 + 1;
               }
               if (this.eval_tipolo.pg068 === "1") {
                    this.res.a7 = this.res.a7 + 1;
               } else {
                    this.res.b8 = this.res.b8 + 1;
               }

               /* Columnas intermedias entre (T - F) y (*J - P) 
                    a9= ncol9, b10= ncol10 */
               this.res.a9 = 0;this.res.b10 = 0; // 10 preguntas !
               if (this.eval_tipolo.pg006 === "1") {
                    this.res.a9 = this.res.a9 + 1;
               } else {
                    this.res.b10 = this.res.b10 + 1;
               }
               if (this.eval_tipolo.pg013 === "1") {
                    this.res.a9 = this.res.a9 + 1;
               } else {
                    this.res.b10 = this.res.b10 + 1;
               }
               if (this.eval_tipolo.pg020 === "1") {
                    this.res.a9 = this.res.a9 + 1;
               } else {
                    this.res.b10 = this.res.b10 + 1;
               }
               if (this.eval_tipolo.pg027 === "1") {
                    this.res.a9 = this.res.a9 + 1;
               } else {
                    this.res.b10 = this.res.b10 + 1;
               }
               if (this.eval_tipolo.pg034 === "1") {
                    this.res.a9 = this.res.a9 + 1;
               } else {
                    this.res.b10 = this.res.b10 + 1;
               }
               if (this.eval_tipolo.pg041 === "1") {
                    this.res.a9 = this.res.a9 + 1;
               } else {
                    this.res.b10 = this.res.b10 + 1;
               }
               if (this.eval_tipolo.pg048 === "1") {
                    this.res.a9 = this.res.a9 + 1;
               } else {
                    this.res.b10 = this.res.b10 + 1;
               }
               if (this.eval_tipolo.pg055 === "1") {
                    this.res.a9 = this.res.a9 + 1;
               } else {
                    this.res.b10 = this.res.b10 + 1;
               }
               if (this.eval_tipolo.pg062 === "1") {
                    this.res.a9 = this.res.a9 + 1;
               } else {
                    this.res.b10 = this.res.b10 + 1;
               }
               if (this.eval_tipolo.pg069 === "1") {
                    this.res.a9 = this.res.a9 + 1;
               } else {
                    this.res.b10 = this.res.b10 + 1;
               }

               /* Columnas intermedias entre (T - F) y (*J - P) 
                    a11= ncol11, b12= ncol12 */
               this.res.a11 = 0;this.res.b12 = 0; // 10 preguntas
               if (this.eval_tipolo.pg007 === "1") {
                    this.res.a11 = this.res.a11 + 1;
               } else {
                    this.res.b12 = this.res.b12 + 1;
               }
               if (this.eval_tipolo.pg014 === "1") {
                    this.res.a11 = this.res.a11 + 1;
               } else {
                    this.res.b12 = this.res.b12 + 1;
               }
               if (this.eval_tipolo.pg021 === "1") {
                    this.res.a11 = this.res.a11 + 1;
               } else {
                    this.res.b12 = this.res.b12 + 1;
               }
               if (this.eval_tipolo.pg028 === "1") {
                    this.res.a11 = this.res.a11 + 1;
               } else {
                    this.res.b12 = this.res.b12 + 1;
               }
               if (this.eval_tipolo.pg035 === "1") {
                    this.res.a11 = this.res.a11 + 1;
               } else {
                    this.res.b12 = this.res.b12 + 1;
               }
               if (this.eval_tipolo.pg042 === "1") {
                    this.res.a11 = this.res.a11 + 1;
               } else {
                    this.res.b12 = this.res.b12 + 1;
               }
               if (this.eval_tipolo.pg049 === "1") {
                    this.res.a11 = this.res.a11 + 1;
               } else {
                    this.res.b12 = this.res.b12 + 1;
               }
               if (this.eval_tipolo.pg056 === "1") {
                    this.res.a11 = this.res.a11 + 1;
               } else {
                    this.res.b12 = this.res.b12 + 1;
               }
               if (this.eval_tipolo.pg063 === "1") {
                    this.res.a11 = this.res.a11 + 1;
               } else {
                    this.res.b12 = this.res.b12 + 1;
               }
               if (this.eval_tipolo.pg070 === "1") {
                    this.res.a11 = this.res.a11 + 1;
               } else {
                    this.res.b12 = this.res.b12 + 1;
               }

               // $scope.ncolS = $scope.ncol1 + $scope.ncol3;
               // $scope.ncolN = $scope.ncol2 + $scope.ncol4;
               // let S = 0; let N = 0; 
               this.res.S = 0;this.res.N = 0; // 10 preguntas
               this.res.S = this.res.a1 + this.res.a3;
               this.res.N = this.res.b2 + this.res.b4;

               // $scope.ncolT = $scope.ncol5 + $scope.ncol7;
               // $scope.ncolF = $scope.ncol6 + $scope.ncol8;
               // let T = 0; let F = 0; 
               this.res.T = 0;this.res.F = 0; // 10 preguntas
               this.res.T = this.res.a5 + this.res.a7;
               this.res.F = this.res.b6 + this.res.b8;

               // $scope.ncolJ = $scope.ncol9 + $scope.ncol11;
               // $scope.ncolP = $scope.ncol10 + $scope.ncol12;
               // let J = 0; let P = 0; 
               this.res.J = 0;this.res.P = 0; // 10 preguntas
               this.res.J = this.res.a9 + this.res.a11;
               this.res.P = this.res.b10 + this.res.b12;

               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 70, "SECCION DE RESULTADOS ");
               doc.line(10, 72, 206, 72);
               doc.text(10, 76, "a1 ( " + this.res.a1 + " , " + this.res.b2 + " ) b2");
               doc.text(10, 81, "a5 ( " + this.res.a5 + " , " + this.res.b6 + " ) b6");
               doc.text(10, 86, "a9 ( " + this.res.a9 + " , " + this.res.b10 + " ) b10");
               doc.text(10, 90, "");
               doc.text(10, 94, "a3 ( " + this.res.a3 + " , " + this.res.b4 + " ) b4");
               doc.text(10, 99, "a7 ( " + this.res.a7 + " , " + this.res.b8 + " ) b8");
               doc.text(10, 104, "a11 ( " + this.res.a11 + " , " + this.res.b12 + " ) b12");
               doc.text(10, 108, "");
               doc.text(10, 113, "E  ( " + this.res.E + " , " + this.res.I + " ) I");
               doc.text(10, 118, "S  ( " + this.res.S + " , " + this.res.N + " ) N");
               doc.text(10, 123, "T  ( " + this.res.T + " , " + this.res.F + " ) F");
               doc.text(10, 128, "J  ( " + this.res.J + " , " + this.res.P + " ) P");
          },
          respuestas: function respuestas(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ");
               doc.line(10, 42, 206, 42);
               doc.text(10, 45, this.eval_tipolo.pg001 === "1" ? "| 01= (a)" : "| 01= (b)");
               doc.text(23, 45, this.eval_tipolo.pg002 === "1" ? "| 02= (a)" : "| 02= (b)");
               doc.text(36, 45, this.eval_tipolo.pg003 === "1" ? "| 03= (a)" : "| 03= (b)");
               doc.text(49, 45, this.eval_tipolo.pg004 === "1" ? "| 04= (a)" : "| 04= (b)");
               doc.text(62, 45, this.eval_tipolo.pg005 === "1" ? "| 05= (a)" : "| 05= (b)");
               doc.text(75, 45, this.eval_tipolo.pg006 === "1" ? "| 06= (a)" : "| 06= (b)");
               doc.text(88, 45, this.eval_tipolo.pg007 === "1" ? "| 07= (a)" : "| 07= (b)");
               doc.text(101, 45, this.eval_tipolo.pg008 === "1" ? "| 08= (a)" : "| 08= (b)");
               doc.text(114, 45, this.eval_tipolo.pg009 === "1" ? "| 09= (a)" : "| 09= (b)");
               doc.text(127, 45, this.eval_tipolo.pg010 === "1" ? "| 10= (a)" : "| 10= (b)");
               doc.text(140, 45, this.eval_tipolo.pg011 === "1" ? "| 11= (a)" : "| 11= (b)");
               doc.text(153, 45, this.eval_tipolo.pg012 === "1" ? "| 12= (a)" : "| 12= (b)");
               doc.text(166, 45, this.eval_tipolo.pg013 === "1" ? "| 13= (a)" : "| 13= (b)");
               doc.text(179, 45, this.eval_tipolo.pg014 === "1" ? "| 14= (a)" : "| 14= (b)");
               doc.text(192, 45, this.eval_tipolo.pg015 === "1" ? "| 15= (a)" : "| 15= (b) |");
               doc.line(10, 46, 206, 46);
               doc.text(10, 49, this.eval_tipolo.pg016 === "1" ? "| 16= (a)" : "| 16= (b)");
               doc.text(23, 49, this.eval_tipolo.pg017 === "1" ? "| 17= (a)" : "| 17= (b)");
               doc.text(36, 49, this.eval_tipolo.pg018 === "1" ? "| 18= (a)" : "| 18= (b)");
               doc.text(49, 49, this.eval_tipolo.pg019 === "1" ? "| 19= (a)" : "| 19= (b)");
               doc.text(62, 49, this.eval_tipolo.pg020 === "1" ? "| 20= (a)" : "| 20= (b)");
               doc.text(75, 49, this.eval_tipolo.pg021 === "1" ? "| 21= (a)" : "| 21= (b)");
               doc.text(88, 49, this.eval_tipolo.pg022 === "1" ? "| 22= (a)" : "| 22= (b)");
               doc.text(101, 49, this.eval_tipolo.pg023 === "1" ? "| 23= (a)" : "| 23= (b)");
               doc.text(114, 49, this.eval_tipolo.pg024 === "1" ? "| 24= (a)" : "| 24= (b)");
               doc.text(127, 49, this.eval_tipolo.pg025 === "1" ? "| 25= (a)" : "| 25= (b)");
               doc.text(140, 49, this.eval_tipolo.pg026 === "1" ? "| 26= (a)" : "| 26= (b)");
               doc.text(153, 49, this.eval_tipolo.pg027 === "1" ? "| 27= (a)" : "| 27= (b)");
               doc.text(166, 49, this.eval_tipolo.pg028 === "1" ? "| 28= (a)" : "| 28= (b)");
               doc.text(179, 49, this.eval_tipolo.pg029 === "1" ? "| 29= (a)" : "| 29= (b)");
               doc.text(192, 49, this.eval_tipolo.pg030 === "1" ? "| 30= (a)" : "| 30= (b) |");
               doc.line(10, 50, 206, 50);
               doc.text(10, 53, this.eval_tipolo.pg031 === "1" ? "| 31= (a)" : "| 31= (b)");
               doc.text(23, 53, this.eval_tipolo.pg032 === "1" ? "| 32= (a)" : "| 32= (b)");
               doc.text(36, 53, this.eval_tipolo.pg033 === "1" ? "| 33= (a)" : "| 33= (b)");
               doc.text(49, 53, this.eval_tipolo.pg034 === "1" ? "| 34= (a)" : "| 34= (b)");
               doc.text(62, 53, this.eval_tipolo.pg035 === "1" ? "| 35= (a)" : "| 35= (b)");
               doc.text(75, 53, this.eval_tipolo.pg036 === "1" ? "| 36= (a)" : "| 36= (b)");
               doc.text(88, 53, this.eval_tipolo.pg037 === "1" ? "| 37= (a)" : "| 37= (b)");
               doc.text(101, 53, this.eval_tipolo.pg038 === "1" ? "| 38= (a)" : "| 38= (b)");
               doc.text(114, 53, this.eval_tipolo.pg039 === "1" ? "| 39= (a)" : "| 39= (b)");
               doc.text(127, 53, this.eval_tipolo.pg040 === "1" ? "| 40= (a)" : "| 40= (b)");
               doc.text(140, 53, this.eval_tipolo.pg041 === "1" ? "| 41= (a)" : "| 41= (b)");
               doc.text(153, 53, this.eval_tipolo.pg042 === "1" ? "| 42= (a)" : "| 42= (b)");
               doc.text(166, 53, this.eval_tipolo.pg043 === "1" ? "| 43= (a)" : "| 43= (b)");
               doc.text(179, 53, this.eval_tipolo.pg044 === "1" ? "| 44= (a)" : "| 44= (b)");
               doc.text(192, 53, this.eval_tipolo.pg045 === "1" ? "| 45= (a)" : "| 45= (b) |");
               doc.line(10, 54, 206, 54);
               doc.text(10, 57, this.eval_tipolo.pg046 === "1" ? "| 46= (a)" : "| 46= (b)");
               doc.text(23, 57, this.eval_tipolo.pg047 === "1" ? "| 47= (a)" : "| 47= (b)");
               doc.text(36, 57, this.eval_tipolo.pg048 === "1" ? "| 48= (a)" : "| 48= (b)");
               doc.text(49, 57, this.eval_tipolo.pg049 === "1" ? "| 49= (a)" : "| 49= (b)");
               doc.text(62, 57, this.eval_tipolo.pg050 === "1" ? "| 50= (a)" : "| 50= (b)");
               doc.text(75, 57, this.eval_tipolo.pg051 === "1" ? "| 51= (a)" : "| 51= (b)");
               doc.text(88, 57, this.eval_tipolo.pg052 === "1" ? "| 52= (a)" : "| 52= (b)");
               doc.text(101, 57, this.eval_tipolo.pg053 === "1" ? "| 53= (a)" : "| 53= (b)");
               doc.text(114, 57, this.eval_tipolo.pg054 === "1" ? "| 54= (a)" : "| 54= (b)");
               doc.text(127, 57, this.eval_tipolo.pg055 === "1" ? "| 55= (a)" : "| 55= (b)");
               doc.text(140, 57, this.eval_tipolo.pg056 === "1" ? "| 56= (a)" : "| 56= (b)");
               doc.text(153, 57, this.eval_tipolo.pg057 === "1" ? "| 57= (a)" : "| 57= (b)");
               doc.text(166, 57, this.eval_tipolo.pg058 === "1" ? "| 58= (a)" : "| 58= (b)");
               doc.text(179, 57, this.eval_tipolo.pg059 === "1" ? "| 59= (a)" : "| 59= (b)");
               doc.text(192, 57, this.eval_tipolo.pg060 === "1" ? "| 60= (a)" : "| 60= (b) |");
               doc.line(10, 58, 206, 58);
               doc.text(10, 61, this.eval_tipolo.pg061 === "1" ? "| 61= (a)" : "| 61= (b)");
               doc.text(23, 61, this.eval_tipolo.pg062 === "1" ? "| 62= (a)" : "| 62= (b)");
               doc.text(36, 61, this.eval_tipolo.pg063 === "1" ? "| 63= (a)" : "| 63= (b)");
               doc.text(49, 61, this.eval_tipolo.pg064 === "1" ? "| 64= (a)" : "| 64= (b)");
               doc.text(62, 61, this.eval_tipolo.pg065 === "1" ? "| 65= (a)" : "| 65= (b)");
               doc.text(75, 61, this.eval_tipolo.pg066 === "1" ? "| 66= (a)" : "| 66= (b)");
               doc.text(88, 61, this.eval_tipolo.pg067 === "1" ? "| 67= (a)" : "| 67= (b)");
               doc.text(101, 61, this.eval_tipolo.pg068 === "1" ? "| 68= (a)" : "| 68= (b)");
               doc.text(114, 61, this.eval_tipolo.pg069 === "1" ? "| 69= (a)" : "| 69= (b)");
               doc.text(127, 61, this.eval_tipolo.pg070 === "1" ? "| 70= (a)" : "| 70= (b) |");
               doc.line(10, 62, 141, 62);
          },

          ejeSinContestar: function ejeSinContestar() {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg002 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg003 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }

               return this.ejeSinResponder;
          },
          sinContestar: function sinContestar() {

               this.pregSinContestar = 0;

               if (this.eval_tipolo.pg001 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg002 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg003 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg004 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg005 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg006 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg007 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg008 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg009 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg010 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg011 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg012 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg013 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg014 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg015 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg016 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg017 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg018 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg019 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg020 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg021 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg022 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg023 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               if (this.eval_tipolo.pg024 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg025 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg026 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg027 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg028 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg029 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg030 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg031 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg032 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg033 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg034 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg035 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg036 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg037 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg038 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg039 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg040 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg041 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg042 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg043 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg044 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg045 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg046 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               if (this.eval_tipolo.pg047 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg048 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg049 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg050 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg051 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg052 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg053 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg054 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg055 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg056 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg057 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg058 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg059 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg060 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg061 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg062 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg063 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg064 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg065 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg066 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg067 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg068 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg069 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tipolo.pg070 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               return this.pregSinContestar;
          },
          dateToYYYYMMDD: function dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0];
          },
          cargaHora: function cargaHora() {

               // Convierte la hora obtenida a hora local (utc)
               this.eval_fecha = new Date();
               var d = this.eval_fecha;
               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               var localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion: function cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0
               };

               this.eval_tipolo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev01; // Crea el nodo para todos los campos.
               this.res = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs01;
               console.log("res ? ", this.res);

               this.eval_tipolo.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
               this.eval_tipolo.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_tipolo.depto = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_depto;
               this.eval_tipolo.sexo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_sexo;

               this.instrucciones = this.eval_tipolo.nombre.toUpperCase() + " haga click aqui para para leer las instrucciones para responder la evaluación de TIPOLOGIA DE LA PERSONALIDAD.";

               this.eval_fecha = new Date(); // Fecha del Día
          },
          empezarEvaluacion: function empezarEvaluacion() {

               this.eval_tipolo.empezo = this.cargaHora();
               this.inicioeval = true;
               // this.$refs.temporalito.focus()
               // this.$refs.pg1.focus()
               // this.$refs.pg1.$el.focus()
          },

          /** .................... VALIDACIONES  .................... */
          validarValor: function validarValor(valor) {
               var lvalor = valor;
               if (valor < 1 || valor > 2) {
                    lvalor = 0;
               }
               // console.log("validarValor, lvalor ? ",lvalor);
               return lvalor;
          },
          limpiarEvaluacion: function limpiarEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0
               };

               this.eval_tipolo = {
                    depto: "",
                    empresa: "", nombre: "",
                    fecha: "",
                    empezo: "", termino: "",
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                    pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                    pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
                    pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
                    pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0, pg049: 0, pg050: 0,
                    pg051: 0, pg052: 0, pg053: 0, pg054: 0, pg055: 0, pg056: 0, pg057: 0, pg058: 0, pg059: 0, pg060: 0,
                    pg061: 0, pg062: 0, pg063: 0, pg064: 0, pg065: 0, pg066: 0, pg067: 0, pg068: 0, pg069: 0, pg070: 0

                    /* Variables para un nuevo caso */
               };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.eval_tipolo = this.eval_tipolo;
          },

          //** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          //* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion: function agregarEvaluacion() {
               var _this = this;

               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ");
                    return;
               }

               this.finalizoeval = true;
               this.eval_tipolo.termino = this.cargaHora();

               this.eval_fecha = new Date();

               var ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               var lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de TIPOLOGIA DE PERSONALIDAD para " + this.eval_tipolo.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvalTipolo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalTipolo;
                    dbEvalTipolo.push({

                         empresa: this.eval_tipolo.empresa, nombre: this.eval_tipolo.nombre,
                         empezo: this.eval_tipolo.empezo, termino: this.eval_tipolo.termino,
                         fecha: lingreso, sexo: this.eval_tipolo.sexo, depto: this.eval_tipolo.depto,
                         pg001: this.eval_tipolo.pg001, pg002: this.eval_tipolo.pg002, pg003: this.eval_tipolo.pg003, pg004: this.eval_tipolo.pg004, pg005: this.eval_tipolo.pg005,
                         pg006: this.eval_tipolo.pg006, pg007: this.eval_tipolo.pg007, pg008: this.eval_tipolo.pg008, pg009: this.eval_tipolo.pg009, pg010: this.eval_tipolo.pg010,
                         pg011: this.eval_tipolo.pg011, pg012: this.eval_tipolo.pg012, pg013: this.eval_tipolo.pg013, pg014: this.eval_tipolo.pg014, pg015: this.eval_tipolo.pg015,
                         pg016: this.eval_tipolo.pg016, pg017: this.eval_tipolo.pg017, pg018: this.eval_tipolo.pg018, pg019: this.eval_tipolo.pg019, pg020: this.eval_tipolo.pg020,
                         pg021: this.eval_tipolo.pg021, pg022: this.eval_tipolo.pg022, pg023: this.eval_tipolo.pg023, pg024: this.eval_tipolo.pg024, pg025: this.eval_tipolo.pg025,
                         pg026: this.eval_tipolo.pg026, pg027: this.eval_tipolo.pg027, pg028: this.eval_tipolo.pg028, pg029: this.eval_tipolo.pg029, pg030: this.eval_tipolo.pg030,
                         pg031: this.eval_tipolo.pg031, pg032: this.eval_tipolo.pg032, pg033: this.eval_tipolo.pg033, pg034: this.eval_tipolo.pg034, pg035: this.eval_tipolo.pg035,
                         pg036: this.eval_tipolo.pg036, pg037: this.eval_tipolo.pg037, pg038: this.eval_tipolo.pg038, pg039: this.eval_tipolo.pg039, pg040: this.eval_tipolo.pg040,
                         pg041: this.eval_tipolo.pg041, pg042: this.eval_tipolo.pg042, pg043: this.eval_tipolo.pg043, pg044: this.eval_tipolo.pg044, pg045: this.eval_tipolo.pg045,
                         pg046: this.eval_tipolo.pg046, pg047: this.eval_tipolo.pg047, pg048: this.eval_tipolo.pg048, pg049: this.eval_tipolo.pg049, pg050: this.eval_tipolo.pg050,
                         pg051: this.eval_tipolo.pg051, pg052: this.eval_tipolo.pg052, pg053: this.eval_tipolo.pg053, pg054: this.eval_tipolo.pg054, pg055: this.eval_tipolo.pg055,
                         pg056: this.eval_tipolo.pg056, pg057: this.eval_tipolo.pg057, pg058: this.eval_tipolo.pg058, pg059: this.eval_tipolo.pg059, pg060: this.eval_tipolo.pg060,
                         pg061: this.eval_tipolo.pg061, pg062: this.eval_tipolo.pg062, pg063: this.eval_tipolo.pg063, pg064: this.eval_tipolo.pg064, pg065: this.eval_tipolo.pg065,
                         pg066: this.eval_tipolo.pg066, pg067: this.eval_tipolo.pg067, pg068: this.eval_tipolo.pg068, pg069: this.eval_tipolo.pg069, pg070: this.eval_tipolo.pg070
                    }).then(function (data) {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         _this.limpiarEvaluacion();

                         var laClave = data.key;
                         _this.grabado = true;
                         _this.inicioeval = false;

                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de TIPOLOGIA DE PERSONALIDAD guardado con éxito.");
                    });
               } // if (confirma)
          },


          //? =================================================================================
          enfoqueG1: function enfoqueG1(pestana) {
               var _this2 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         //* Estoy en el 1 y quiero irme al 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt2.focus();
                         });

                         this.activott1 = "!active";
                         this.activott2 = "active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         break;
                    case 3:
                         //* Estoy en el 2 y quiero irme al 3
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt3.focus();
                         });
                         this.activott2 = "!active";
                         this.activott3 = "active";

                         this.vertt2 = false;
                         this.vertt3 = true;
                         break;
                    case 0:
                         //* Estoy en el 3 y quiero irme al 2 o al 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt1.focus();
                         });
                         this.activott3 = "!active";
                         this.activott1 = "active";

                         this.vertt3 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },
          nadaG1: function nadaG1(pestana) {
               var _this3 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt1.focus();
                         });

                         this.activott1 = "active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";

                         this.vertt1 = true;
                         this.vertt2 = false;
                         this.vertt3 = false;

                         break;
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt2.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "active";
                         this.activott3 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         this.vertt3 = false;

                         break;
                    case 3:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt3.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = true;

                         break;
                    default:
                    // code block
               } //* switch
          },
          enfoqueRG1: function enfoqueRG1(pestana) {
               var _this4 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         //* Estoy en 3 regreso a 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt2.focus();
                         });

                         this.activott3 = "!active";
                         this.activott2 = "active";

                         this.vertt3 = false;
                         this.vertt2 = true;
                         break;
                    case 1:
                         //* Estoy en 2 regreso a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt1.focus();
                         });
                         this.activott2 = "!active";
                         this.activott1 = "active";

                         this.vertt2 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          }
     } // methods
     // export

});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *      ev02_16pf.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
     name: 'factores',
     components: {
          'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
          'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
     },
     template: '#forma16pf',
     data: function data() {
          return {
               ejemplo: {},
               eval_16pf: {}, res: {},
               modo: "",
               eval_fecha: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,

               //? .....................................................................................................................................................................................................................
               activott1: "active", activott2: '!active', activott3: "!active", activott4: "!active",
               vertt1: true, vertt2: false, vertt3: false, vertt4: false,
               area1: "", area2: '', area3: '', area4: "" // return
          };
     },
     // data()
     mounted: function mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();
     },

     computed: {
          l_sinResponder: function l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder: function l_ejeSinResponder() {
               return this.ejeSinContestar();
          }
     },
     methods: {
          crearPDF: function crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_16pf.nombre,
                   patron = / /g,
                   nuevoValor = "",
                   nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "16pf_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1); // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación FACTORES DE PERSONALIDAD para " + this.eval_16pf.nombre + " de " + this.eval_16pf.empresa + " ( " + this.eval_16pf.depto + " )");

               this.respuestas(doc);
               this.resultados(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          resultadosJ: function resultadosJ() {
               return "hola estuve en J";
          },
          resultados: function resultados(doc) {

               // this.res_16pf.resP = resultadosJ();   
               // console.log("resultadosJ ? ", this.res_16pf.resP);
               this.res_16pf.resA = -1;
               this.res_16pf.resP = this.resultadosH(this.eval_16pf.pg001, this.eval_16pf.pg018, this.eval_16pf.pg035, this.eval_16pf.pg052, this.eval_16pf.pg069, this.eval_16pf.pg086, 'P');
               this.res_16pf.resA = this.resultadosH(this.eval_16pf.pg002, this.eval_16pf.pg019, this.eval_16pf.pg036, this.eval_16pf.pg053, this.eval_16pf.pg070, this.eval_16pf.pg087, 'A');
               this.res_16pf.resB = this.resultadosH(this.eval_16pf.pg003, this.eval_16pf.pg020, this.eval_16pf.pg037, this.eval_16pf.pg054, this.eval_16pf.pg071, this.eval_16pf.pg088, 'B');
               this.res_16pf.resC = this.resultadosH(this.eval_16pf.pg004, this.eval_16pf.pg021, this.eval_16pf.pg038, this.eval_16pf.pg055, this.eval_16pf.pg072, this.eval_16pf.pg089, 'C');
               this.res_16pf.resE = this.resultadosH(this.eval_16pf.pg005, this.eval_16pf.pg022, this.eval_16pf.pg039, this.eval_16pf.pg056, this.eval_16pf.pg073, this.eval_16pf.pg090, 'E');
               this.res_16pf.resF = this.resultadosH(this.eval_16pf.pg006, this.eval_16pf.pg023, this.eval_16pf.pg040, this.eval_16pf.pg057, this.eval_16pf.pg074, this.eval_16pf.pg091, 'F');
               this.res_16pf.resG = this.resultadosH(this.eval_16pf.pg007, this.eval_16pf.pg024, this.eval_16pf.pg041, this.eval_16pf.pg058, this.eval_16pf.pg075, this.eval_16pf.pg092, 'G');
               this.res_16pf.resH = this.resultadosH(this.eval_16pf.pg008, this.eval_16pf.pg025, this.eval_16pf.pg042, this.eval_16pf.pg059, this.eval_16pf.pg076, this.eval_16pf.pg093, 'H');
               this.res_16pf.resI = this.resultadosH(this.eval_16pf.pg009, this.eval_16pf.pg026, this.eval_16pf.pg043, this.eval_16pf.pg060, this.eval_16pf.pg077, this.eval_16pf.pg094, 'I');
               this.res_16pf.resL = this.resultadosH(this.eval_16pf.pg010, this.eval_16pf.pg027, this.eval_16pf.pg044, this.eval_16pf.pg061, this.eval_16pf.pg078, this.eval_16pf.pg095, 'L');
               this.res_16pf.resM = this.resultadosH(this.eval_16pf.pg011, this.eval_16pf.pg028, this.eval_16pf.pg045, this.eval_16pf.pg062, this.eval_16pf.pg079, this.eval_16pf.pg096, 'M');
               this.res_16pf.resN = this.resultadosH(this.eval_16pf.pg012, this.eval_16pf.pg029, this.eval_16pf.pg046, this.eval_16pf.pg063, this.eval_16pf.pg080, this.eval_16pf.pg097, 'N');
               this.res_16pf.resO = this.resultadosH(this.eval_16pf.pg013, this.eval_16pf.pg030, this.eval_16pf.pg047, this.eval_16pf.pg064, this.eval_16pf.pg081, this.eval_16pf.pg098, 'O');
               this.res_16pf.resQ1 = this.resultadosH(this.eval_16pf.pg014, this.eval_16pf.pg031, this.eval_16pf.pg048, this.eval_16pf.pg065, this.eval_16pf.pg082, this.eval_16pf.pg099, 'Q1');
               this.res_16pf.resQ2 = this.resultadosH(this.eval_16pf.pg015, this.eval_16pf.pg032, this.eval_16pf.pg049, this.eval_16pf.pg066, this.eval_16pf.pg083, this.eval_16pf.pg100, 'Q2');
               this.res_16pf.resQ3 = this.resultadosH(this.eval_16pf.pg016, this.eval_16pf.pg033, this.eval_16pf.pg050, this.eval_16pf.pg067, this.eval_16pf.pg084, this.eval_16pf.pg101, 'Q3');
               this.res_16pf.resQ4 = this.resultadosH(this.eval_16pf.pg017, this.eval_16pf.pg034, this.eval_16pf.pg051, this.eval_16pf.pg068, this.eval_16pf.pg085, this.eval_16pf.pg102, 'Q4');

               console.log("P ? ", this.res_16pf.resP, ", ", "A ? ", this.res_16pf.resA, ", ", "B ? ", this.res_16pf.resB, ", ", "C ? ", this.res_16pf.resC, ", ", "E ? ", this.res_16pf.resE, ", ", "F ? ", this.res_16pf.resF, ", ", "G ? ", this.res_16pf.resG, ", ", "H ? ", this.res_16pf.resH, ", ", "I ? ", this.res_16pf.resI, ", ", "L ? ", this.res_16pf.resL, ", ", "M ? ", this.res_16pf.resM, ", ", "N ? ", this.res_16pf.resN, ", ", "O ? ", this.res_16pf.resO, ", ", "Q1 ? ", this.res_16pf.resQ1, ", ", "Q2 ? ", this.res_16pf.resQ2, ", ", "Q3 ? ", this.res_16pf.resQ3, ", ", "Q4 ? ", this.res_16pf.resQ4);
               if (this.res_16pf.resP >= 10) {

                    this.res_16pf.resA = this.res_16pf.resA - 1;
                    this.res_16pf.resB = this.res_16pf.resB - 1;
                    this.res_16pf.resC = this.res_16pf.resC - 1;
                    this.res_16pf.resE = this.res_16pf.resE - 1;
                    this.res_16pf.resF = this.res_16pf.resF - 1;
                    this.res_16pf.resG = this.res_16pf.resG - 1;
                    this.res_16pf.resH = this.res_16pf.resH - 1;
                    this.res_16pf.resI = this.res_16pf.resI - 1;
                    this.res_16pf.resL = this.res_16pf.resL - 1;
                    this.res_16pf.resM = this.res_16pf.resM - 1;
                    this.res_16pf.resN = this.res_16pf.resN - 1;
                    this.res_16pf.resO = this.res_16pf.resO - 1;
                    this.res_16pf.resQ1 = this.res_16pf.resQ1 - 1;
                    this.res_16pf.resQ2 = this.res_16pf.resQ2 - 1;
                    this.res_16pf.resQ3 = this.res_16pf.resQ3 - 1;
                    this.res_16pf.resQ4 = this.res_16pf.resQ4 - 1;
               } // if   

               console.log("Q4 ?", this.res_16pf.resQ4);
               this.res_16pf.rangoP = this.res_16pf.resP;
               this.res_16pf.rangoA = this.rangosH(this.res_16pf.resA, 'A');
               this.res_16pf.rangoB = this.rangosH(this.res_16pf.resB, 'B');
               this.res_16pf.rangoC = this.rangosH(this.res_16pf.resC, 'C');
               this.res_16pf.rangoE = this.rangosH(this.res_16pf.resE, 'E');
               this.res_16pf.rangoF = this.rangosH(this.res_16pf.resF, 'F');
               this.res_16pf.rangoG = this.rangosH(this.res_16pf.resG, 'G');
               this.res_16pf.rangoH = this.rangosH(this.res_16pf.resH, 'H');
               this.res_16pf.rangoI = this.rangosH(this.res_16pf.resI, 'I');
               this.res_16pf.rangoL = this.rangosH(this.res_16pf.resL, 'L');
               this.res_16pf.rangoM = this.rangosH(this.res_16pf.resM, 'M');
               this.res_16pf.rangoN = this.rangosH(this.res_16pf.resN, 'N');
               this.res_16pf.rangoO = this.rangosH(this.res_16pf.resO, 'O');
               this.res_16pf.rangoQ1 = this.rangosH(this.res_16pf.resQ1, 'Q1');
               this.res_16pf.rangoQ2 = this.rangosH(this.res_16pf.resQ2, 'Q2');
               this.res_16pf.rangoQ3 = this.rangosH(this.res_16pf.resQ3, 'Q3');
               this.res_16pf.rangoQ4 = this.rangosH(this.res_16pf.resQ4, 'Q4');

               doc.setLineWidth(0.25);

               doc.text(10, 85, "SECCION DE RESULTADOS ");
               doc.line(10, 86, 206, 86);

               // doc.text(21, 81, "F");   doc.text(61, 81, "P");
               // doc.text(20, 85, "---"); doc.text(60, 85, "---");
               // doc.text(10, 89, "D"); doc.text(20, 89, this.res_16pf.rangoP.toString()); doc.text(60, 89, this.res_16pf.resP.toString());
               // doc.text(10, 93, "A"); doc.text(20, 93, this.res_16pf.rangoA.toString()); doc.text(60, 93, this.res_16pf.resA.toString());

               doc.text(26, 91, "F");doc.text(36, 91, "P");
               doc.text(25, 95, "---");doc.text(35, 95, "---");
               doc.text(15, 99, "D");doc.text(25, 99, this.res_16pf.rangoP.toString());doc.text(35, 99, this.res_16pf.resP.toString());
               doc.text(15, 103, "A");doc.text(25, 103, this.res_16pf.rangoA.toString());doc.text(35, 103, this.res_16pf.resA.toString());
               doc.text(15, 107, "B");doc.text(25, 107, this.res_16pf.rangoB.toString());doc.text(35, 107, this.res_16pf.resB.toString());
               doc.text(15, 111, "C");doc.text(25, 111, this.res_16pf.rangoC.toString());doc.text(35, 111, this.res_16pf.resC.toString());
               doc.text(15, 115, "E");doc.text(25, 115, this.res_16pf.rangoE.toString());doc.text(35, 115, this.res_16pf.resE.toString());
               doc.text(15, 119, "F");doc.text(25, 119, this.res_16pf.rangoF.toString());doc.text(35, 119, this.res_16pf.resF.toString());
               doc.text(15, 123, "G");doc.text(25, 123, this.res_16pf.rangoG.toString());doc.text(35, 123, this.res_16pf.resG.toString());
               doc.text(15, 127, "H");doc.text(25, 127, this.res_16pf.rangoH.toString());doc.text(35, 127, this.res_16pf.resH.toString());
               doc.text(15, 131, "I");doc.text(25, 131, this.res_16pf.rangoI.toString());doc.text(35, 131, this.res_16pf.resI.toString());
               doc.text(15, 135, "L");doc.text(25, 135, this.res_16pf.rangoL.toString());doc.text(35, 135, this.res_16pf.resL.toString());
               doc.text(15, 139, "M");doc.text(25, 139, this.res_16pf.rangoM.toString());doc.text(35, 139, this.res_16pf.resM.toString());
               doc.text(15, 143, "N");doc.text(25, 143, this.res_16pf.rangoN.toString());doc.text(35, 143, this.res_16pf.resN.toString());
               doc.text(15, 147, "O");doc.text(25, 147, this.res_16pf.rangoO.toString());doc.text(35, 147, this.res_16pf.resO.toString());
               doc.text(15, 151, "Q1");doc.text(25, 151, this.res_16pf.rangoQ1.toString());doc.text(35, 151, this.res_16pf.resQ1.toString());
               doc.text(15, 155, "Q2");doc.text(25, 155, this.res_16pf.rangoQ2.toString());doc.text(35, 155, this.res_16pf.resQ2.toString());
               doc.text(15, 159, "Q3");doc.text(25, 159, this.res_16pf.rangoQ3.toString());doc.text(35, 159, this.res_16pf.resQ3.toString());
               doc.text(15, 163, "Q4");doc.text(25, 163, this.res_16pf.rangoQ4.toString());doc.text(35, 163, this.res_16pf.resQ4.toString());
          },

          rangosH: function rangosH(res, caso) {

               var rango = '*';
               switch (caso) {
                    case 'A':
                         {
                              var comp1 = res >= 0 && res <= 3;if (comp1 === true) {
                                   rango = '1';
                              }
                              var comp2 = res >= 4 && res <= 5;if (comp2 === true) {
                                   rango = '2';
                              }
                              var comp3 = res >= 6 && res <= 6;if (comp3 === true) {
                                   rango = '3';
                              }
                              var comp4 = res >= 7 && res <= 7;if (comp4 === true) {
                                   rango = '4';
                              }
                              var comp5 = res >= 8 && res <= 8;if (comp5 === true) {
                                   rango = '5';
                              }
                              var comp6 = res >= 9 && res <= 9;if (comp6 === true) {
                                   rango = '6';
                              }
                              var comp7 = res >= 10 && res <= 10;if (comp7 === true) {
                                   rango = '7';
                              }
                              var comp8 = res >= 11 && res <= 11;if (comp8 === true) {
                                   rango = '8';
                              }
                              var comp9 = res >= 12 && res <= 12;if (comp9 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'B':
                         {
                              var _comp = res >= 0 && res <= 1;if (_comp === true) {
                                   rango = '1';
                              }
                              var _comp2 = res >= 2 && res <= 2;if (_comp2 === true) {
                                   rango = '2';
                              }
                              var _comp3 = res >= 3 && res <= 3;if (_comp3 === true) {
                                   rango = '3';
                              }
                              var _comp4 = res >= 4 && res <= 4;if (_comp4 === true) {
                                   rango = '4';
                              }
                              var _comp5 = res >= 5 && res <= 5;if (_comp5 === true) {
                                   rango = '7';
                              }
                              var _comp6 = res >= 6 && res <= 6;if (_comp6 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'C':
                         {
                              var _comp7 = res >= 0 && res <= 3;if (_comp7 === true) {
                                   rango = '1';
                              }
                              var _comp8 = res >= 4 && res <= 5;if (_comp8 === true) {
                                   rango = '2';
                              }
                              var _comp9 = res >= 6 && res <= 6;if (_comp9 === true) {
                                   rango = '3';
                              }
                              var _comp10 = res >= 7 && res <= 7;if (_comp10 === true) {
                                   rango = '4';
                              }
                              var _comp11 = res >= 8 && res <= 8;if (_comp11 === true) {
                                   rango = '5';
                              }
                              var _comp12 = res >= 9 && res <= 9;if (_comp12 === true) {
                                   rango = '6';
                              }
                              var _comp13 = res >= 10 && res <= 10;if (_comp13 === true) {
                                   rango = '7';
                              }
                              var _comp14 = res >= 11 && res <= 11;if (_comp14 === true) {
                                   rango = '8';
                              }
                              var _comp15 = res >= 12 && res <= 12;if (_comp15 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'E':
                         {
                              var _comp16 = res >= 0 && res <= 0;if (_comp16 === true) {
                                   rango = '1';
                              }
                              var _comp17 = res >= 1 && res <= 1;if (_comp17 === true) {
                                   rango = '2';
                              }
                              var _comp18 = res >= 2 && res <= 2;if (_comp18 === true) {
                                   rango = '3';
                              }
                              var _comp19 = res >= 3 && res <= 3;if (_comp19 === true) {
                                   rango = '4';
                              }
                              var _comp20 = res >= 4 && res <= 4;if (_comp20 === true) {
                                   rango = '5';
                              }
                              var _comp21 = res >= 5 && res <= 6;if (_comp21 === true) {
                                   rango = '6';
                              }
                              var _comp22 = res >= 7 && res <= 7;if (_comp22 === true) {
                                   rango = '7';
                              }
                              var _comp23 = res >= 8 && res <= 9;if (_comp23 === true) {
                                   rango = '8';
                              }
                              var _comp24 = res >= 10 && res <= 12;if (_comp24 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'F':
                         {
                              var _comp25 = res >= 0 && res <= 2;if (_comp25 === true) {
                                   rango = '1';
                              }
                              var _comp26 = res >= 3 && res <= 4;if (_comp26 === true) {
                                   rango = '2';
                              }
                              var _comp27 = res >= 5 && res <= 5;if (_comp27 === true) {
                                   rango = '3';
                              }
                              var _comp28 = res >= 6 && res <= 6;if (_comp28 === true) {
                                   rango = '4';
                              }
                              var _comp29 = res >= 7 && res <= 7;if (_comp29 === true) {
                                   rango = '5';
                              }
                              var _comp30 = res >= 8 && res <= 8;if (_comp30 === true) {
                                   rango = '6';
                              }
                              var _comp31 = res >= 9 && res <= 9;if (_comp31 === true) {
                                   rango = '7';
                              }
                              var _comp32 = res >= 10 && res <= 10;if (_comp32 === true) {
                                   rango = '8';
                              }
                              var _comp33 = res >= 11 && res <= 12;if (_comp33 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'G':
                         {
                              var _comp34 = res >= 1 && res <= 2;if (_comp34 === true) {
                                   rango = '1';
                              }
                              var _comp35 = res >= 2 && res <= 4;if (_comp35 === true) {
                                   rango = '2';
                              }
                              var _comp36 = res >= 4 && res <= 5;if (_comp36 === true) {
                                   rango = '3';
                              }
                              var _comp37 = res >= 6 && res <= 6;if (_comp37 === true) {
                                   rango = '4';
                              }
                              var _comp38 = res >= 7 && res <= 7;if (_comp38 === true) {
                                   rango = '5';
                              }
                              var _comp39 = res >= 8 && res <= 8;if (_comp39 === true) {
                                   rango = '6';
                              }
                              var _comp40 = res >= 9 && res <= 10;if (_comp40 === true) {
                                   rango = '7';
                              }
                              var _comp41 = res >= 11 && res <= 11;if (_comp41 === true) {
                                   rango = '8';
                              }
                              var _comp42 = res >= 12 && res <= 12;if (_comp42 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'H':
                         {
                              var _comp43 = res >= 0 && res <= 3;if (_comp43 === true) {
                                   rango = '1';
                              }
                              var _comp44 = res >= 4 && res <= 5;if (_comp44 === true) {
                                   rango = '2';
                              }
                              var _comp45 = res >= 6 && res <= 6;if (_comp45 === true) {
                                   rango = '3';
                              }
                              var _comp46 = res >= 7 && res <= 7;if (_comp46 === true) {
                                   rango = '4';
                              }
                              var _comp47 = res >= 8 && res <= 8;if (_comp47 === true) {
                                   rango = '5';
                              }
                              var _comp48 = res >= 9 && res <= 9;if (_comp48 === true) {
                                   rango = '6';
                              }
                              var _comp49 = res >= 10 && res <= 10;if (_comp49 === true) {
                                   rango = '7';
                              }
                              var _comp50 = res >= 11 && res <= 11;if (_comp50 === true) {
                                   rango = '8';
                              }
                              var _comp51 = res >= 11 && res <= 12;if (_comp51 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'I':
                         {
                              var _comp52 = res >= 11 && res <= 12;if (_comp52 === true) {
                                   rango = '1';
                              }
                              var _comp53 = res >= 10 && res <= 10;if (_comp53 === true) {
                                   rango = '2';
                              }
                              var _comp54 = res >= 8 && res <= 9;if (_comp54 === true) {
                                   rango = '3';
                              }
                              var _comp55 = res >= 7 && res <= 7;if (_comp55 === true) {
                                   rango = '4';
                              }
                              var _comp56 = res >= 5 && res <= 6;if (_comp56 === true) {
                                   rango = '5';
                              }
                              var _comp57 = res >= 4 && res <= 4;if (_comp57 === true) {
                                   rango = '6';
                              }
                              var _comp58 = res >= 2 && res <= 3;if (_comp58 === true) {
                                   rango = '7';
                              }
                              var _comp59 = res >= 1 && res <= 1;if (_comp59 === true) {
                                   rango = '8';
                              }
                              var _comp60 = res >= 0 && res <= 0;if (_comp60 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'L':
                         {
                              var _comp61 = res >= 11 && res <= 12;if (_comp61 === true) {
                                   rango = '1';
                              }
                              var _comp62 = res >= 10 && res <= 10;if (_comp62 === true) {
                                   rango = '2';
                              }
                              var _comp63 = res >= 9 && res <= 9;if (_comp63 === true) {
                                   rango = '3';
                              }
                              var _comp64 = res >= 8 && res <= 8;if (_comp64 === true) {
                                   rango = '4';
                              }
                              var _comp65 = res >= 6 && res <= 7;if (_comp65 === true) {
                                   rango = '5';
                              }
                              var _comp66 = res >= 5 && res <= 5;if (_comp66 === true) {
                                   rango = '6';
                              }
                              var _comp67 = res >= 4 && res <= 4;if (_comp67 === true) {
                                   rango = '7';
                              }
                              var _comp68 = res >= 2 && res <= 2;if (_comp68 === true) {
                                   rango = '8';
                              }
                              var _comp69 = res >= 0 && res <= 1;if (_comp69 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'M':
                         {
                              var _comp70 = res >= 11 && res <= 12;if (_comp70 === true) {
                                   rango = '1';
                              }
                              var _comp71 = res >= 9 && res <= 10;if (_comp71 === true) {
                                   rango = '2';
                              }
                              var _comp72 = res >= 8 && res <= 8;if (_comp72 === true) {
                                   rango = '3';
                              }
                              var _comp73 = res >= 7 && res <= 7;if (_comp73 === true) {
                                   rango = '4';
                              }
                              var _comp74 = res >= 6 && res <= 6;if (_comp74 === true) {
                                   rango = '5';
                              }
                              var _comp75 = res >= 5 && res <= 5;if (_comp75 === true) {
                                   rango = '6';
                              }
                              var _comp76 = res >= 3 && res <= 4;if (_comp76 === true) {
                                   rango = '7';
                              }
                              var _comp77 = res >= 2 && res <= 2;if (_comp77 === true) {
                                   rango = '8';
                              }
                              var _comp78 = res >= 0 && res <= 1;if (_comp78 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'N':
                         {
                              var _comp79 = res >= 0 && res <= 1;if (_comp79 === true) {
                                   rango = '1';
                              }
                              var _comp80 = res >= 2 && res <= 2;if (_comp80 === true) {
                                   rango = '2';
                              }
                              var _comp81 = res >= 3 && res <= 3;if (_comp81 === true) {
                                   rango = '3';
                              }
                              var _comp82 = res >= 4 && res <= 4;if (_comp82 === true) {
                                   rango = '4';
                              }
                              var _comp83 = res >= 5 && res <= 5;if (_comp83 === true) {
                                   rango = '5';
                              }
                              var _comp84 = res >= 6 && res <= 6;if (_comp84 === true) {
                                   rango = '6';
                              }
                              var _comp85 = res >= 7 && res <= 7;if (_comp85 === true) {
                                   rango = '7';
                              }
                              var _comp86 = res >= 8 && res <= 9;if (_comp86 === true) {
                                   rango = '8';
                              }
                              var _comp87 = res >= 10 && res <= 12;if (_comp87 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'O':
                         {
                              var _comp88 = res >= 9 && res <= 12;if (_comp88 === true) {
                                   rango = '1';
                              }
                              var _comp89 = res >= 7 && res <= 8;if (_comp89 === true) {
                                   rango = '2';
                              }
                              var _comp90 = res >= 6 && res <= 6;if (_comp90 === true) {
                                   rango = '3';
                              }
                              var _comp91 = res >= 5 && res <= 5;if (_comp91 === true) {
                                   rango = '4';
                              }
                              var _comp92 = res >= 4 && res <= 4;if (_comp92 === true) {
                                   rango = '5';
                              }
                              var _comp93 = res >= 3 && res <= 3;if (_comp93 === true) {
                                   rango = '6';
                              }
                              var _comp94 = res >= 2 && res <= 2;if (_comp94 === true) {
                                   rango = '7';
                              }
                              var _comp95 = res >= 1 && res <= 1;if (_comp95 === true) {
                                   rango = '8';
                              }
                              var _comp96 = res >= 0 && res <= 0;if (_comp96 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'Q1':
                         {
                              var _comp97 = res >= 0 && res <= 0;if (_comp97 === true) {
                                   rango = '1';
                              }
                              var _comp98 = res >= 1 && res <= 1;if (_comp98 === true) {
                                   rango = '2';
                              }
                              var _comp99 = res >= 2 && res <= 3;if (_comp99 === true) {
                                   rango = '3';
                              }
                              var _comp100 = res >= 4 && res <= 4;if (_comp100 === true) {
                                   rango = '4';
                              }
                              var _comp101 = res >= 5 && res <= 5;if (_comp101 === true) {
                                   rango = '5';
                              }
                              var _comp102 = res >= 6 && res <= 7;if (_comp102 === true) {
                                   rango = '6';
                              }
                              var _comp103 = res >= 8 && res <= 8;if (_comp103 === true) {
                                   rango = '7';
                              }
                              var _comp104 = res >= 9 && res <= 10;if (_comp104 === true) {
                                   rango = '8';
                              }
                              var _comp105 = res >= 11 && res <= 12;if (_comp105 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'Q2':
                         {
                              var _comp106 = res >= 0 && res <= 3;if (_comp106 === true) {
                                   rango = '1';
                              }
                              var _comp107 = res >= 4 && res <= 5;if (_comp107 === true) {
                                   rango = '2';
                              }
                              var _comp108 = res >= 6 && res <= 6;if (_comp108 === true) {
                                   rango = '3';
                              }
                              var _comp109 = res >= 7 && res <= 7;if (_comp109 === true) {
                                   rango = '4';
                              }
                              var _comp110 = res >= 8 && res <= 8;if (_comp110 === true) {
                                   rango = '5';
                              }
                              var _comp111 = res >= 9 && res <= 9;if (_comp111 === true) {
                                   rango = '6';
                              }
                              var _comp112 = res >= 10 && res <= 10;if (_comp112 === true) {
                                   rango = '7';
                              }
                              var _comp113 = res >= 11 && res <= 11;if (_comp113 === true) {
                                   rango = '8';
                              }
                              var _comp114 = res >= 12 && res <= 12;if (_comp114 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'Q3':
                         {
                              var _comp115 = res >= 0 && res <= 2;if (_comp115 === true) {
                                   rango = '1';
                              }
                              var _comp116 = res >= 3 && res <= 4;if (_comp116 === true) {
                                   rango = '2';
                              }
                              var _comp117 = res >= 5 && res <= 5;if (_comp117 === true) {
                                   rango = '3';
                              }
                              var _comp118 = res >= 6 && res <= 6;if (_comp118 === true) {
                                   rango = '4';
                              }
                              var _comp119 = res >= 7 && res <= 8;if (_comp119 === true) {
                                   rango = '5';
                              }
                              var _comp120 = res >= 9 && res <= 9;if (_comp120 === true) {
                                   rango = '6';
                              }
                              var _comp121 = res >= 10 && res <= 10;if (_comp121 === true) {
                                   rango = '7';
                              }
                              var _comp122 = res >= 11 && res <= 11;if (_comp122 === true) {
                                   rango = '8';
                              }
                              var _comp123 = res >= 12 && res <= 12;if (_comp123 === true) {
                                   rango = '9';
                              }
                              break;
                         }
                    case 'Q4':
                         {
                              var _comp124 = res >= 11 && res <= 12;if (_comp124 === true) {
                                   rango = '1';
                              }
                              var _comp125 = res >= 9 && res <= 10;if (_comp125 === true) {
                                   rango = '2';
                              }
                              var _comp126 = res >= 8 && res <= 8;if (_comp126 === true) {
                                   rango = '3';
                              }
                              var _comp127 = res >= 6 && res <= 7;if (_comp127 === true) {
                                   rango = '4';
                              }
                              var _comp128 = res >= 5 && res <= 5;if (_comp128 === true) {
                                   rango = '5';
                              }
                              var _comp129 = res >= 4 && res <= 4;if (_comp129 === true) {
                                   rango = '6';
                              }
                              var _comp130 = res >= 3 && res <= 3;if (_comp130 === true) {
                                   rango = '7';
                              }
                              var _comp131 = res >= 2 && res <= 2;if (_comp131 === true) {
                                   rango = '8';
                              }
                              var _comp132 = res >= 0 && res <= 1;if (_comp132 === true) {
                                   rango = '9';
                              }
                              break;
                         }
               } // switch
               return rango;
          }, // rangosH()

          resultadosH: function resultadosH(pg1, pg2, pg3, pg4, pg5, pg6, caso) {

               var conteo = 0;
               var cadena = '**';
               switch (caso) {
                    case 'P':
                         {
                              if (pg1 === 'a') {
                                   conteo = conteo + 2;cadena = cadena + "pg01-a; ";
                              } else {
                                   if (pg1 === 'b') {
                                        conteo = conteo + 1;cadena = cadena + "pg01-b; ";
                                   }
                              }
                              if (pg2 === 'b') {
                                   conteo = conteo + 1;cadena = cadena + "pg18-b; ";
                              } else {
                                   if (pg2 === 'c') {
                                        conteo = conteo + 2;cadena = cadena + "pg18-c; ";
                                   }
                              }
                              if (pg3 === 'b') {
                                   conteo = conteo + 1;cadena = cadena + "pg35-b; ";
                              } else {
                                   if (pg3 === 'c') {
                                        conteo = conteo + 2;cadena = cadena + "pg35-c; ";
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;cadena = cadena + "pg52-a; ";
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;cadena = cadena + "pg52-b; ";
                                   }
                              }
                              if (pg5 === 'b') {
                                   conteo = conteo + 1;cadena = cadena + "pg69-b; ";
                              } else {
                                   if (pg5 === 'c') {
                                        conteo = conteo + 2;cadena = cadena + "pg69-c; ";
                                   }
                              }
                              if (pg6 === 'b') {
                                   conteo = conteo + 1;cadena = cadena + "pg86-b; ";
                              } else {
                                   if (pg6 === 'c') {
                                        conteo = conteo + 2;cadena = cadena + "pg86-c; ";
                                   }
                              }
                              break;
                         }
                    case 'A':
                         {
                              if (pg1 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg1 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg2 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg2 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg3 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg3 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg5 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg5 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg6 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg6 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              break;
                         }
                    case 'B':
                         {
                              if (pg1 === 'b') {
                                   conteo = conteo + 1;
                              }
                              if (pg2 === 'c') {
                                   conteo = conteo + 1;
                              }
                              if (pg3 === 'b') {
                                   conteo = conteo + 1;
                              }
                              if (pg4 === 'c') {
                                   conteo = conteo + 1;
                              }
                              if (pg5 === 'b') {
                                   conteo = conteo + 1;
                              }
                              if (pg6 === 'c') {
                                   conteo = conteo + 1;
                              }
                              break;
                         }
                    case 'C':
                         {
                              if (pg1 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg1 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg2 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg2 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg3 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg3 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg5 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg5 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg6 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg6 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              break;
                         }
                    case 'E':
                         {
                              if (pg1 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg1 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg2 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg2 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg3 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg3 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg5 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg5 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg6 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg6 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              break;
                         }
                    case 'F':
                         {
                              if (pg1 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg1 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg2 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg2 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg3 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg3 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg5 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg5 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg6 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg6 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              break;
                         }
                    case 'G':
                         {
                              if (pg1 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg1 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg2 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg2 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg3 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg3 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg4 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg4 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg5 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg5 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg6 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg6 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              break;
                         }
                    case 'H':
                         {
                              if (pg1 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg1 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg2 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg2 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg3 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg3 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg5 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg5 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg6 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg6 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              break;
                         }
                    case 'I':
                         {
                              if (pg1 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg1 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg2 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg2 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg3 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg3 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg5 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg5 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg6 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg6 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              break;
                         }
                    case 'L':
                         {
                              if (pg1 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg1 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              } // 1
                              if (pg2 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg2 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg3 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg3 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg4 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg4 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg5 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg5 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg6 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg6 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              break;
                         }
                    case 'M':
                         {
                              if (pg1 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg1 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg2 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg2 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg3 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg3 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg5 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg5 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg6 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg6 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              break;
                         }
                    case 'N':
                         {
                              if (pg1 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg1 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg2 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg2 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg3 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg3 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg5 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg5 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg6 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg6 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              break;
                         }
                    case 'O':
                         {
                              if (pg1 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg1 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg2 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg2 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg3 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg3 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg5 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg5 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg6 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg6 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              break;
                         }
                    case 'Q1':
                         {
                              if (pg1 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg1 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg2 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg2 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg3 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg3 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg4 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg4 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg5 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg5 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg6 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg6 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              break;
                         }
                    case 'Q2':
                         {
                              if (pg1 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg1 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg2 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg2 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg3 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg3 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg5 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg5 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg6 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg6 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              break;
                         }
                    case 'Q3':
                         {
                              if (pg1 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg1 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg2 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg2 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg3 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg3 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg4 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg4 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg5 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg5 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg6 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg6 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              break;
                         }
                    case 'Q4':
                         {
                              if (pg1 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg1 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg2 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg2 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg3 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg3 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg4 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg4 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              if (pg5 === 'b') {
                                   conteo = conteo + 1;
                              } else {
                                   if (pg5 === 'c') {
                                        conteo = conteo + 2;
                                   }
                              }
                              if (pg6 === 'a') {
                                   conteo = conteo + 2;
                              } else {
                                   if (pg6 === 'b') {
                                        conteo = conteo + 1;
                                   }
                              }
                              break;
                         }
               } // switch

               console.log("[ resultadosH ] ( ", pg1, pg2, pg3, pg4, pg5, pg6, caso, " ) ( ", conteo, cadena, " )");
               return conteo;
          }, // resultadosH()
          respuestas: function respuestas(doc) {

               console.log("Respuestas ");
               console.log(this.eval_16pf);
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ");
               doc.line(10, 42, 206, 42);
               // doc.text(10, 45, this.eval_16pf.pg001 === "a" ? "| 01= (a)" : "| 01= (b)");
               doc.text(10, 45, this.eval_16pf.pg001 === "a" ? "| 01= (a)" : this.eval_16pf.pg001 === "b" ? "| 01= (b)" : "| 01= (c)");
               doc.text(23, 45, this.eval_16pf.pg002 === "a" ? "| 02= (a)" : this.eval_16pf.pg002 === "b" ? "| 02= (b)" : "| 02= (c)");
               doc.text(36, 45, this.eval_16pf.pg003 === "a" ? "| 03= (a)" : this.eval_16pf.pg003 === "b" ? "| 03= (b)" : "| 03= (c)");
               doc.text(49, 45, this.eval_16pf.pg004 === "a" ? "| 04= (a)" : this.eval_16pf.pg004 === "b" ? "| 04= (b)" : "| 04= (c)");
               doc.text(62, 45, this.eval_16pf.pg005 === "a" ? "| 05= (a)" : this.eval_16pf.pg005 === "b" ? "| 05= (b)" : "| 05= (c)");
               doc.text(75, 45, this.eval_16pf.pg006 === "a" ? "| 06= (a)" : this.eval_16pf.pg006 === "b" ? "| 06= (b)" : "| 06= (c)");
               doc.text(88, 45, this.eval_16pf.pg007 === "a" ? "| 07= (a)" : this.eval_16pf.pg007 === "b" ? "| 07= (b)" : "| 07= (c)");
               doc.text(101, 45, this.eval_16pf.pg008 === "a" ? "| 08= (a)" : this.eval_16pf.pg008 === "b" ? "| 08= (b)" : "| 08= (c)");
               doc.text(114, 45, this.eval_16pf.pg009 === "a" ? "| 09= (a)" : this.eval_16pf.pg009 === "b" ? "| 09= (b)" : "| 09= (c)");
               doc.text(127, 45, this.eval_16pf.pg010 === "a" ? "| 10= (a)" : this.eval_16pf.pg010 === "b" ? "| 10= (b)" : "| 10= (c)");
               doc.text(140, 45, this.eval_16pf.pg011 === "a" ? "| 11= (a)" : this.eval_16pf.pg011 === "b" ? "| 11= (b)" : "| 11= (c)");
               doc.text(153, 45, this.eval_16pf.pg012 === "a" ? "| 12= (a)" : this.eval_16pf.pg012 === "b" ? "| 12= (b)" : "| 12= (c)");
               doc.text(166, 45, this.eval_16pf.pg013 === "a" ? "| 13= (a)" : this.eval_16pf.pg013 === "b" ? "| 13= (b)" : "| 13= (c)");
               doc.text(179, 45, this.eval_16pf.pg014 === "a" ? "| 14= (a)" : this.eval_16pf.pg014 === "b" ? "| 14= (b)" : "| 14= (c)");
               doc.text(192, 45, this.eval_16pf.pg015 === "a" ? "| 15= (a) |" : this.eval_16pf.pg015 === "b" ? "| 15= (b) |" : "| 15= (c) |");
               doc.line(10, 46, 206, 46);

               doc.text(10, 49, this.eval_16pf.pg016 === "a" ? "| 16= (a)" : this.eval_16pf.pg016 === "b" ? "| 16= (b)" : "| 16= (c)");
               doc.text(23, 49, this.eval_16pf.pg017 === "a" ? "| 17= (a)" : this.eval_16pf.pg017 === "b" ? "| 17= (b)" : "| 17= (c)");
               doc.text(36, 49, this.eval_16pf.pg018 === "a" ? "| 18= (a)" : this.eval_16pf.pg018 === "b" ? "| 18= (b)" : "| 18= (c)");
               doc.text(49, 49, this.eval_16pf.pg019 === "a" ? "| 19= (a)" : this.eval_16pf.pg019 === "b" ? "| 19= (b)" : "| 19= (c)");
               doc.text(62, 49, this.eval_16pf.pg020 === "a" ? "| 20= (a)" : this.eval_16pf.pg020 === "b" ? "| 20= (b)" : "| 20= (c)");
               doc.text(75, 49, this.eval_16pf.pg021 === "a" ? "| 21= (a)" : this.eval_16pf.pg021 === "b" ? "| 21= (b)" : "| 21= (c)");
               doc.text(88, 49, this.eval_16pf.pg022 === "a" ? "| 22= (a)" : this.eval_16pf.pg022 === "b" ? "| 22= (b)" : "| 22= (c)");
               doc.text(101, 49, this.eval_16pf.pg023 === "a" ? "| 23= (a)" : this.eval_16pf.pg023 === "b" ? "| 23= (b)" : "| 23= (c)");
               doc.text(114, 49, this.eval_16pf.pg024 === "a" ? "| 24= (a)" : this.eval_16pf.pg024 === "b" ? "| 24= (b)" : "| 24= (c)");
               doc.text(127, 49, this.eval_16pf.pg025 === "a" ? "| 25= (a)" : this.eval_16pf.pg025 === "b" ? "| 25= (b)" : "| 25= (c)");
               doc.text(140, 49, this.eval_16pf.pg026 === "a" ? "| 26= (a)" : this.eval_16pf.pg026 === "b" ? "| 26= (b)" : "| 26= (c)");
               doc.text(153, 49, this.eval_16pf.pg027 === "a" ? "| 27= (a)" : this.eval_16pf.pg027 === "b" ? "| 27= (b)" : "| 27= (c)");
               doc.text(166, 49, this.eval_16pf.pg028 === "a" ? "| 28= (a)" : this.eval_16pf.pg028 === "b" ? "| 28= (b)" : "| 28= (c)");
               doc.text(179, 49, this.eval_16pf.pg029 === "a" ? "| 29= (a)" : this.eval_16pf.pg029 === "b" ? "| 29= (b)" : "| 29= (c)");
               doc.text(192, 49, this.eval_16pf.pg030 === "a" ? "| 30= (a) |" : this.eval_16pf.pg030 === "b" ? "| 30= (b) |" : "| 30= (c) |");
               doc.line(10, 50, 206, 50);

               doc.text(10, 53, this.eval_16pf.pg031 === "a" ? "| 31= (a)" : this.eval_16pf.pg031 === "b" ? "| 39= (b)" : "| 31= (c)");
               doc.text(23, 53, this.eval_16pf.pg032 === "a" ? "| 32= (a)" : this.eval_16pf.pg032 === "b" ? "| 39= (b)" : "| 32= (c)");
               doc.text(36, 53, this.eval_16pf.pg033 === "a" ? "| 33= (a)" : this.eval_16pf.pg033 === "b" ? "| 39= (b)" : "| 33= (c)");
               doc.text(49, 53, this.eval_16pf.pg034 === "a" ? "| 34= (a)" : this.eval_16pf.pg034 === "b" ? "| 39= (b)" : "| 34= (c)");
               doc.text(62, 53, this.eval_16pf.pg035 === "a" ? "| 35= (a)" : this.eval_16pf.pg035 === "b" ? "| 39= (b)" : "| 35= (c)");
               doc.text(75, 53, this.eval_16pf.pg036 === "a" ? "| 36= (a)" : this.eval_16pf.pg036 === "b" ? "| 39= (b)" : "| 36= (c)");
               doc.text(88, 53, this.eval_16pf.pg037 === "a" ? "| 37= (a)" : this.eval_16pf.pg037 === "b" ? "| 39= (b)" : "| 37= (c)");
               doc.text(101, 53, this.eval_16pf.pg038 === "a" ? "| 38= (a)" : this.eval_16pf.pg038 === "b" ? "| 39= (b)" : "| 38= (c)");
               doc.text(114, 53, this.eval_16pf.pg039 === "a" ? "| 39= (a)" : this.eval_16pf.pg039 === "b" ? "| 39= (b)" : "| 39= (c)");
               doc.text(127, 53, this.eval_16pf.pg040 === "a" ? "| 40= (a)" : this.eval_16pf.pg040 === "b" ? "| 39= (b)" : "| 40= (c)");
               doc.text(140, 53, this.eval_16pf.pg041 === "a" ? "| 41= (a)" : this.eval_16pf.pg041 === "b" ? "| 39= (b)" : "| 41= (c)");
               doc.text(153, 53, this.eval_16pf.pg042 === "a" ? "| 42= (a)" : this.eval_16pf.pg042 === "b" ? "| 39= (b)" : "| 42= (c)");
               doc.text(166, 53, this.eval_16pf.pg043 === "a" ? "| 43= (a)" : this.eval_16pf.pg043 === "b" ? "| 39= (b)" : "| 43= (c)");
               doc.text(179, 53, this.eval_16pf.pg044 === "a" ? "| 44= (a)" : this.eval_16pf.pg044 === "b" ? "| 39= (b)" : "| 44= (c)");
               doc.text(192, 53, this.eval_16pf.pg045 === "a" ? "| 45= (a) |" : this.eval_16pf.pg045 === "b" ? "| 39= (b) |" : "| 45= (c) |");
               doc.line(10, 54, 206, 54);

               doc.text(10, 57, this.eval_16pf.pg046 === "a" ? "| 46= (a)" : this.eval_16pf.pg046 === "b" ? "| 46= (b)" : "| 46= (c)");
               doc.text(23, 57, this.eval_16pf.pg047 === "a" ? "| 47= (a)" : this.eval_16pf.pg047 === "b" ? "| 47= (b)" : "| 47= (c)");
               doc.text(36, 57, this.eval_16pf.pg048 === "a" ? "| 48= (a)" : this.eval_16pf.pg048 === "b" ? "| 48= (b)" : "| 48= (c)");
               doc.text(49, 57, this.eval_16pf.pg049 === "a" ? "| 49= (a)" : this.eval_16pf.pg049 === "b" ? "| 49= (b)" : "| 49= (c)");
               doc.text(62, 57, this.eval_16pf.pg050 === "a" ? "| 50= (a)" : this.eval_16pf.pg050 === "b" ? "| 50= (b)" : "| 50= (c)");
               doc.text(75, 57, this.eval_16pf.pg051 === "a" ? "| 51= (a)" : this.eval_16pf.pg051 === "b" ? "| 51= (b)" : "| 51= (c)");
               doc.text(88, 57, this.eval_16pf.pg052 === "a" ? "| 52= (a)" : this.eval_16pf.pg052 === "b" ? "| 52= (b)" : "| 52= (c)");
               doc.text(101, 57, this.eval_16pf.pg053 === "a" ? "| 53= (a)" : this.eval_16pf.pg053 === "b" ? "| 53= (b)" : "| 53= (c)");
               doc.text(114, 57, this.eval_16pf.pg054 === "a" ? "| 54= (a)" : this.eval_16pf.pg054 === "b" ? "| 54= (b)" : "| 54= (c)");
               doc.text(127, 57, this.eval_16pf.pg055 === "a" ? "| 55= (a)" : this.eval_16pf.pg055 === "b" ? "| 55= (b)" : "| 55= (c)");
               doc.text(140, 57, this.eval_16pf.pg056 === "a" ? "| 56= (a)" : this.eval_16pf.pg056 === "b" ? "| 56= (b)" : "| 56= (c)");
               doc.text(153, 57, this.eval_16pf.pg057 === "a" ? "| 57= (a)" : this.eval_16pf.pg057 === "b" ? "| 57= (b)" : "| 57= (c)");
               doc.text(166, 57, this.eval_16pf.pg058 === "a" ? "| 58= (a)" : this.eval_16pf.pg058 === "b" ? "| 58= (b)" : "| 58= (c)");
               doc.text(179, 57, this.eval_16pf.pg059 === "a" ? "| 59= (a)" : this.eval_16pf.pg059 === "b" ? "| 59= (b)" : "| 59= (c)");
               doc.text(192, 57, this.eval_16pf.pg060 === "a" ? "| 60= (a) |" : this.eval_16pf.pg060 === "b" ? "| 60= (b) |" : "| 60= (c) |");
               doc.line(10, 58, 206, 58);

               doc.text(10, 61, this.eval_16pf.pg061 === "a" ? "| 61= (a)" : this.eval_16pf.pg061 === "b" ? "| 61= (b)" : "| 61= (c)");
               doc.text(23, 61, this.eval_16pf.pg062 === "a" ? "| 62= (a)" : this.eval_16pf.pg062 === "b" ? "| 62= (b)" : "| 62= (c)");
               doc.text(36, 61, this.eval_16pf.pg063 === "a" ? "| 63= (a)" : this.eval_16pf.pg063 === "b" ? "| 63= (b)" : "| 63= (c)");
               doc.text(49, 61, this.eval_16pf.pg064 === "a" ? "| 64= (a)" : this.eval_16pf.pg064 === "b" ? "| 64= (b)" : "| 64= (c)");
               doc.text(62, 61, this.eval_16pf.pg065 === "a" ? "| 65= (a)" : this.eval_16pf.pg065 === "b" ? "| 65= (b)" : "| 65= (c)");
               doc.text(75, 61, this.eval_16pf.pg066 === "a" ? "| 66= (a)" : this.eval_16pf.pg066 === "b" ? "| 66= (b)" : "| 66= (c)");
               doc.text(88, 61, this.eval_16pf.pg067 === "a" ? "| 67= (a)" : this.eval_16pf.pg067 === "b" ? "| 67= (b)" : "| 67= (c)");
               doc.text(101, 61, this.eval_16pf.pg068 === "a" ? "| 68= (a)" : this.eval_16pf.pg068 === "b" ? "| 68= (b)" : "| 68= (c)");
               doc.text(114, 61, this.eval_16pf.pg069 === "a" ? "| 69= (a)" : this.eval_16pf.pg069 === "b" ? "| 69= (b)" : "| 69= (c)");
               doc.text(127, 61, this.eval_16pf.pg070 === "a" ? "| 70= (a)" : this.eval_16pf.pg070 === "b" ? "| 70= (b)" : "| 70= (c)");
               doc.text(140, 61, this.eval_16pf.pg071 === "a" ? "| 71= (a)" : this.eval_16pf.pg071 === "b" ? "| 71= (b)" : "| 71= (c)");
               doc.text(153, 61, this.eval_16pf.pg072 === "a" ? "| 72= (a)" : this.eval_16pf.pg072 === "b" ? "| 72= (b)" : "| 72= (c)");
               doc.text(166, 61, this.eval_16pf.pg073 === "a" ? "| 73= (a)" : this.eval_16pf.pg073 === "b" ? "| 73= (b)" : "| 73= (c)");
               doc.text(179, 61, this.eval_16pf.pg074 === "a" ? "| 74= (a)" : this.eval_16pf.pg074 === "b" ? "| 74= (b)" : "| 74= (c)");
               doc.text(192, 61, this.eval_16pf.pg075 === "a" ? "| 75= (a) |" : this.eval_16pf.pg075 === "b" ? "| 75= (b) |" : "| 75= (c) |");
               doc.line(10, 62, 206, 62);

               doc.text(10, 65, this.eval_16pf.pg076 === "a" ? "| 76= (a)" : this.eval_16pf.pg076 === "b" ? "| 76= (b)" : "| 76= (c)");
               doc.text(23, 65, this.eval_16pf.pg077 === "a" ? "| 77= (a)" : this.eval_16pf.pg077 === "b" ? "| 77= (b)" : "| 77= (c)");
               doc.text(36, 65, this.eval_16pf.pg078 === "a" ? "| 78= (a)" : this.eval_16pf.pg078 === "b" ? "| 78= (b)" : "| 78= (c)");
               doc.text(49, 65, this.eval_16pf.pg079 === "a" ? "| 79= (a)" : this.eval_16pf.pg079 === "b" ? "| 79= (b)" : "| 79= (c)");
               doc.text(62, 65, this.eval_16pf.pg080 === "a" ? "| 80= (a)" : this.eval_16pf.pg080 === "b" ? "| 80= (b)" : "| 80= (c)");
               doc.text(75, 65, this.eval_16pf.pg081 === "a" ? "| 81= (a)" : this.eval_16pf.pg081 === "b" ? "| 81= (b)" : "| 81= (c)");
               doc.text(88, 65, this.eval_16pf.pg082 === "a" ? "| 82= (a)" : this.eval_16pf.pg082 === "b" ? "| 82= (b)" : "| 82= (c)");
               doc.text(101, 65, this.eval_16pf.pg083 === "a" ? "| 83= (a)" : this.eval_16pf.pg083 === "b" ? "| 83= (b)" : "| 83= (c)");
               doc.text(114, 65, this.eval_16pf.pg084 === "a" ? "| 84= (a)" : this.eval_16pf.pg084 === "b" ? "| 84= (b)" : "| 84= (c)");
               doc.text(127, 65, this.eval_16pf.pg085 === "a" ? "| 85= (a)" : this.eval_16pf.pg085 === "b" ? "| 85= (b)" : "| 85= (c)");
               doc.text(140, 65, this.eval_16pf.pg086 === "a" ? "| 86= (a)" : this.eval_16pf.pg086 === "b" ? "| 86= (b)" : "| 86= (c)");
               doc.text(153, 65, this.eval_16pf.pg087 === "a" ? "| 87= (a)" : this.eval_16pf.pg087 === "b" ? "| 87= (b)" : "| 87= (c)");
               doc.text(166, 65, this.eval_16pf.pg088 === "a" ? "| 88= (a)" : this.eval_16pf.pg088 === "b" ? "| 88= (b)" : "| 88= (c)");
               doc.text(179, 65, this.eval_16pf.pg089 === "a" ? "| 89= (a)" : this.eval_16pf.pg089 === "b" ? "| 89= (b)" : "| 89= (c)");
               doc.text(192, 65, this.eval_16pf.pg090 === "a" ? "| 90= (a) |" : this.eval_16pf.pg090 === "b" ? "| 90= (b) |" : "| 90= (c) |");
               doc.line(10, 66, 206, 66);

               doc.text(10, 69, this.eval_16pf.pg091 === "a" ? "| 91= (a)" : this.eval_16pf.pg091 === "b" ? "| 91= (b)" : "| 91= (c)");
               doc.text(23, 69, this.eval_16pf.pg092 === "a" ? "| 92= (a)" : this.eval_16pf.pg092 === "b" ? "| 92= (b)" : "| 92= (c)");
               doc.text(36, 69, this.eval_16pf.pg093 === "a" ? "| 93= (a)" : this.eval_16pf.pg093 === "b" ? "| 93= (b)" : "| 93= (c)");
               doc.text(49, 69, this.eval_16pf.pg094 === "a" ? "| 94= (a)" : this.eval_16pf.pg094 === "b" ? "| 94= (b)" : "| 94= (c)");
               doc.text(62, 69, this.eval_16pf.pg095 === "a" ? "| 95= (a)" : this.eval_16pf.pg095 === "b" ? "| 95= (b)" : "| 95= (c)");
               doc.text(75, 69, this.eval_16pf.pg096 === "a" ? "| 96= (a)" : this.eval_16pf.pg096 === "b" ? "| 96= (b)" : "| 96= (c)");
               doc.text(88, 69, this.eval_16pf.pg097 === "a" ? "| 97= (a)" : this.eval_16pf.pg097 === "b" ? "| 97= (b)" : "| 97= (c)");
               doc.text(101, 69, this.eval_16pf.pg098 === "a" ? "| 98= (a)" : this.eval_16pf.pg098 === "b" ? "| 98= (b)" : "| 98= (c)");
               doc.text(114, 69, this.eval_16pf.pg099 === "a" ? "| 99= (a)" : this.eval_16pf.pg099 === "b" ? "| 99= (b)" : "| 99= (c)");
               doc.text(127, 69, this.eval_16pf.pg100 === "a" ? "| 100= (a)" : this.eval_16pf.pg100 === "b" ? "| 100= (b)" : "| 100= (c)");
               doc.text(140, 69, this.eval_16pf.pg101 === "a" ? "| 101= (a)" : this.eval_16pf.pg101 === "b" ? "| 101= (b)" : "| 101= (c)");
               doc.text(153, 69, this.eval_16pf.pg102 === "a" ? "| 102= (a) |" : this.eval_16pf.pg102 === "b" ? "| 102= (b) |" : "| 102= (c) |");
               doc.line(10, 70, 168, 70);
          },

          ejeSinContestar: function ejeSinContestar() {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg002 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg003 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }

               return this.ejeSinResponder;
          },
          sinContestar: function sinContestar() {

               this.pregSinContestar = 0;

               if (this.eval_16pf.pg001 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg002 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg003 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg004 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg005 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg006 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg007 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg008 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg009 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg010 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg011 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg012 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg013 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg014 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg015 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg016 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg017 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg018 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg019 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg020 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg021 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg022 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg023 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg024 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg025 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               if (this.eval_16pf.pg026 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg027 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg028 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg029 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg030 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg031 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg032 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg033 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg034 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg035 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg036 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg037 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg038 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg039 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg040 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg041 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg042 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg043 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg044 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg045 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg046 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg047 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg048 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg049 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg050 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               if (this.eval_16pf.pg051 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg052 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg053 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg054 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg055 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg056 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg057 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg058 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg059 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg060 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg061 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg062 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg063 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg064 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg065 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg066 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg067 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg068 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg069 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg070 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg071 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg072 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg073 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg074 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg075 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               if (this.eval_16pf.pg076 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg077 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg078 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg079 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg080 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg081 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg082 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg083 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg084 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg085 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg086 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg087 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg088 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg089 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg090 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg091 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg092 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg093 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg094 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg095 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg096 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg097 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg098 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg099 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg100 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg101 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_16pf.pg102 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               return this.pregSinContestar;
          },
          addADayToMyDate: function addADayToMyDate() {
               if (this.eval_fecha) // as myDate can be null
                    // you have to set the this.myDate again, so vue can detect it changed
                    // this is not a caveat of this specific solution, but of any binding of dates
                    this.eval_16pf.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
          },
          dateToYYYYMMDD: function dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0];
          },
          cargaHora: function cargaHora() {

               // Convierte la hora obtenida a hora local (utc)
               this.eval_fecha = new Date();
               var d = this.eval_fecha;
               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               var localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion: function cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0
               };

               this.eval_16pf = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev02; // Crea el nodo para todos los campos.
               this.res_16pf = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs02;
               console.log("res ? ", this.res_16pf);

               this.eval_16pf.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
               this.eval_16pf.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_16pf.depto = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_depto;
               this.eval_16pf.sexo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_sexo;

               this.instrucciones = this.eval_16pf.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de FACTORES DE LA PERSONALIDAD.";

               this.eval_fecha = new Date(); // Fecha del Día
          },
          empezarEvaluacion: function empezarEvaluacion() {

               this.eval_16pf.empezo = this.cargaHora();
               this.inicioeval = true;
          },

          /** .................... VALIDACIONES  .................... */
          validarValor: function validarValor(valor) {
               var lvalor = valor;
               if (valor < 1 || valor > 2) {
                    lvalor = 0;
               }
               // console.log("validarValor, lvalor ? ",lvalor);
               return lvalor;
          },
          limpiarEvaluacion: function limpiarEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0
               };

               this.eval_16pf = {
                    depto: "",
                    empresa: "", nombre: "",
                    fecha: "",
                    empezo: "", termino: "",
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                    pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                    pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
                    pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
                    pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0, pg049: 0, pg050: 0,
                    pg051: 0, pg052: 0, pg053: 0, pg054: 0, pg055: 0, pg056: 0, pg057: 0, pg058: 0, pg059: 0, pg060: 0,
                    pg061: 0, pg062: 0, pg063: 0, pg064: 0, pg065: 0, pg066: 0, pg067: 0, pg068: 0, pg069: 0, pg070: 0,
                    pg071: 0, pg072: 0, pg073: 0, pg074: 0, pg075: 0, pg076: 0, pg077: 0, pg078: 0, pg079: 0, pg080: 0,
                    pg081: 0, pg082: 0, pg083: 0, pg084: 0, pg085: 0, pg086: 0, pg087: 0, pg088: 0, pg089: 0, pg090: 0,
                    pg091: 0, pg092: 0, pg093: 0, pg094: 0, pg095: 0, pg096: 0, pg097: 0, pg098: 0, pg099: 0, pg100: 0,
                    pg101: 0, pg102: 0

                    /* Variables para un nuevo caso */
               };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.eval_16pf = this.eval_16pf;
          },

          /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          /* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion: function agregarEvaluacion() {
               var _this = this;

               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ");
                    return;
               }

               this.finalizoeval = true;
               this.eval_16pf.termino = this.cargaHora();

               this.eval_fecha = new Date();

               var ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               var lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de FACTORES DE PERSONALIDAD para " + this.eval_16pf.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvaluaciones = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalFactor;
                    dbEvaluaciones.push({

                         empresa: this.eval_16pf.empresa, nombre: this.eval_16pf.nombre,
                         empezo: this.eval_16pf.empezo, termino: this.eval_16pf.termino,
                         fecha: lingreso, depto: this.eval_16pf.depto, sexo: this.eval_16pf.sexo,
                         pg001: this.eval_16pf.pg001, pg002: this.eval_16pf.pg002, pg003: this.eval_16pf.pg003, pg004: this.eval_16pf.pg004, pg005: this.eval_16pf.pg005,
                         pg006: this.eval_16pf.pg006, pg007: this.eval_16pf.pg007, pg008: this.eval_16pf.pg008, pg009: this.eval_16pf.pg009, pg010: this.eval_16pf.pg010,
                         pg011: this.eval_16pf.pg011, pg012: this.eval_16pf.pg012, pg013: this.eval_16pf.pg013, pg014: this.eval_16pf.pg014, pg015: this.eval_16pf.pg015,
                         pg016: this.eval_16pf.pg016, pg017: this.eval_16pf.pg017, pg018: this.eval_16pf.pg018, pg019: this.eval_16pf.pg019, pg020: this.eval_16pf.pg020,
                         pg021: this.eval_16pf.pg021, pg022: this.eval_16pf.pg022, pg023: this.eval_16pf.pg023, pg024: this.eval_16pf.pg024, pg025: this.eval_16pf.pg025,
                         pg026: this.eval_16pf.pg026, pg027: this.eval_16pf.pg027, pg028: this.eval_16pf.pg028, pg029: this.eval_16pf.pg029, pg030: this.eval_16pf.pg030,
                         pg031: this.eval_16pf.pg031, pg032: this.eval_16pf.pg032, pg033: this.eval_16pf.pg033, pg034: this.eval_16pf.pg034, pg035: this.eval_16pf.pg035,
                         pg036: this.eval_16pf.pg036, pg037: this.eval_16pf.pg037, pg038: this.eval_16pf.pg038, pg039: this.eval_16pf.pg039, pg040: this.eval_16pf.pg040,
                         pg041: this.eval_16pf.pg041, pg042: this.eval_16pf.pg042, pg043: this.eval_16pf.pg043, pg044: this.eval_16pf.pg044, pg045: this.eval_16pf.pg045,
                         pg046: this.eval_16pf.pg046, pg047: this.eval_16pf.pg047, pg048: this.eval_16pf.pg048, pg049: this.eval_16pf.pg049, pg050: this.eval_16pf.pg050,
                         pg051: this.eval_16pf.pg051, pg052: this.eval_16pf.pg052, pg053: this.eval_16pf.pg053, pg054: this.eval_16pf.pg054, pg055: this.eval_16pf.pg055,
                         pg056: this.eval_16pf.pg056, pg057: this.eval_16pf.pg057, pg058: this.eval_16pf.pg058, pg059: this.eval_16pf.pg059, pg060: this.eval_16pf.pg060,
                         pg061: this.eval_16pf.pg061, pg062: this.eval_16pf.pg062, pg063: this.eval_16pf.pg063, pg064: this.eval_16pf.pg064, pg065: this.eval_16pf.pg065,
                         pg066: this.eval_16pf.pg066, pg067: this.eval_16pf.pg067, pg068: this.eval_16pf.pg068, pg069: this.eval_16pf.pg069, pg070: this.eval_16pf.pg070,
                         pg071: this.eval_16pf.pg071, pg072: this.eval_16pf.pg072, pg073: this.eval_16pf.pg073, pg074: this.eval_16pf.pg074, pg075: this.eval_16pf.pg075,
                         pg076: this.eval_16pf.pg076, pg077: this.eval_16pf.pg077, pg078: this.eval_16pf.pg078, pg079: this.eval_16pf.pg079, pg080: this.eval_16pf.pg080,
                         pg081: this.eval_16pf.pg081, pg082: this.eval_16pf.pg082, pg083: this.eval_16pf.pg083, pg084: this.eval_16pf.pg084, pg085: this.eval_16pf.pg085,
                         pg086: this.eval_16pf.pg086, pg087: this.eval_16pf.pg087, pg088: this.eval_16pf.pg088, pg089: this.eval_16pf.pg089, pg090: this.eval_16pf.pg090,
                         pg091: this.eval_16pf.pg091, pg092: this.eval_16pf.pg092, pg093: this.eval_16pf.pg093, pg094: this.eval_16pf.pg094, pg095: this.eval_16pf.pg095,
                         pg096: this.eval_16pf.pg096, pg097: this.eval_16pf.pg097, pg098: this.eval_16pf.pg098, pg099: this.eval_16pf.pg099, pg100: this.eval_16pf.pg100,
                         pg101: this.eval_16pf.pg101, pg102: this.eval_16pf.pg102
                    }).then(function (data) {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         _this.limpiarEvaluacion();

                         var laClave = data.key;
                         _this.grabado = true;
                         _this.inicioeval = false;

                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de FACTORES DE PERSONALIDAD guardado con éxito.");
                    });
               } // if (confirma)
          },
          // agregarEncuesta()

          //? =================================================================================
          enfoqueG1: function enfoqueG1(pestana) {
               var _this2 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         //* Vengo de 1, voy a 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt2.focus();
                         });

                         this.activott1 = "!active";
                         this.activott2 = "active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         break;
                    case 3:
                         //* Vengo de 2, voy a 3
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt3.focus();
                         });
                         this.activott2 = "!active";
                         this.activott3 = "active";

                         this.vertt2 = false;
                         this.vertt3 = true;
                         break;
                    case 4:
                         //* Vengo de 3, voy a 4
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt4.focus();
                         });
                         this.activott3 = "!active";
                         this.activott4 = "active";

                         this.vertt3 = false;
                         this.vertt4 = true;
                         break;
                    case 0:
                         //* Vengo de 4, voy a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt1.focus();
                         });
                         this.activott4 = "!active";
                         this.activott1 = "active";

                         this.vertt4 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },
          nadaG1: function nadaG1(pestana) {
               var _this3 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt1.focus();
                         });

                         this.activott1 = "active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";

                         this.vertt1 = true;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = false;

                         break;
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt2.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         this.vertt3 = false;
                         this.vertt4 = false;

                         break;
                    case 3:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt3.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "active";
                         this.activott4 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = true;
                         this.vertt4 = false;

                         break;
                    case 4:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt4.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = true;

                         break;
                    default:
                    // code block
               } //* switch
          },
          enfoqueRG1: function enfoqueRG1(pestana) {
               var _this4 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 3:
                         //* Estoy en 4 regreso a 3
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt3.focus();
                         });

                         this.activott4 = "!active";
                         this.activott3 = "active";

                         this.vertt4 = false;
                         this.vertt3 = true;
                         break;
                    case 2:
                         //* Estoy en 3 regreso a 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt2.focus();
                         });

                         this.activott3 = "!active";
                         this.activott2 = "active";

                         this.vertt3 = false;
                         this.vertt2 = true;
                         break;
                    case 1:
                         //* Estoy en 2 regreso a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt1.focus();
                         });
                         this.activott2 = "!active";
                         this.activott1 = "active";

                         this.vertt2 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          }
     } // methods
     // export

});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *      ev03_npf.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
     name: 'estabilidad',
     components: {
          'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
          'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
     },
     template: '#formanpf',
     data: function data() {
          return {
               ejemplo: {},
               eval_npf: {}, res: {},
               modo: "",
               eval_fecha: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,

               //? .....................................................................................................................................................................................................................
               activott1: "active", activott2: '!active',
               vertt1: true, vertt2: false // return
          };
     },
     // data()
     mounted: function mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();
     },

     computed: {
          l_sinResponder: function l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder: function l_ejeSinResponder() {
               return this.ejeSinContestar();
          }
     },
     methods: {
          crearPDF: function crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_npf.nombre,
                   patron = / /g,
                   nuevoValor = "",
                   nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "npf_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1); // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de ESTABILIDAD para " + this.eval_npf.nombre + " de " + this.eval_npf.empresa + " ( " + this.eval_npf.depto + " )");

               this.respuestas(doc);
               this.resultados(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangosnpf: function rangosnpf() {

               switch (this.eval_npf.pg001) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;console.log("Es a)");
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;console.log("Es b)");
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;console.log("Es c)");
                         break;
               }
               console.log("uno ? ", this.res_npf.Uno, "; dos ? ", this.res_npf.Dos, "; Cero ? ", this.res_npf.Cero);

               /* Resuelve para la pregunta 2 */
               switch (this.eval_npf.pg002) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 3 */
               switch (this.eval_npf.pg003) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg004) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 5 */
               switch (this.eval_npf.pg005) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 6 */
               switch (this.eval_npf.pg006) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }

               /* Resuelve para la pregunta 3 */
               switch (this.eval_npf.pg007) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg008) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }

               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 9 */
               /* ======================================================== */
               switch (this.eval_npf.pg009) {
                    case 'a':
                         this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno2 = this.res_npf.Uno2 + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg010) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg011) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }

               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg012) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg013) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }

               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 14 */
               /* ======================================================== */
               switch (this.eval_npf.pg014) {
                    case 'a':
                         this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno2 = this.res_npf.Uno2 + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
               }
               switch (this.eval_npf.pg015) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 16 */
               switch (this.eval_npf.pg016) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 17 */
               switch (this.eval_npf.pg017) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg018) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 19 */
               /* ======================================================== */
               console.log("a evaluar 19");
               switch (this.eval_npf.pg019) {
                    case 'a':
                         this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno2 = this.res_npf.Uno2 + 1;console.log("19 es b !!");
                         break;
                    case 'c':
                         this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
               }
               switch (this.eval_npf.pg020) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 17 */
               switch (this.eval_npf.pg021) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg022) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 23 */
               /* ======================================================== */
               switch (this.eval_npf.pg023) {
                    case 'a':
                         this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno2 = this.res_npf.Uno2 + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
               }
               switch (this.eval_npf.pg024) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg025) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg026) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg027) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 28 */
               /* ======================================================== */
               switch (this.eval_npf.pg028) {
                    case 'a':
                         this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno2 = this.res_npf.Uno2 + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
               }
               switch (this.eval_npf.pg029) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg030) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg031) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg032) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg033) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg034) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg035) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg036) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 37 */
               /* ======================================================== */
               switch (this.eval_npf.pg037) {
                    case 'a':
                         this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno2 = this.res_npf.Uno2 + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
               }
               switch (this.eval_npf.pg038) {
                    case 'a':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg039) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg040) {
                    case 'a':
                         this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b':
                         this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c':
                         this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               console.log(">>> PRIMERAS 15 PREGUNTAS");
               console.log("pg1 ? ", this.eval_npf.pg001, "pg2 ? ", this.eval_npf.pg002, "pg3 ? ", this.eval_npf.pg003, "pg4 ? ", this.eval_npf.pg004, "pg5 ? ", this.eval_npf.pg005, "pg6 ? ", this.eval_npf.pg006, "pg7 ? ", this.eval_npf.pg007, "pg8 ? ", this.eval_npf.pg008, "pg9 ? ", this.eval_npf.pg009, "pg10 ? ", this.eval_npf.pg010, "pg11 ? ", this.eval_npf.pg011, "pg12 ? ", this.eval_npf.pg012, "pg13 ? ", this.eval_npf.pg013, "pg14 ? ", this.eval_npf.pg014, "pg15 ? ", this.eval_npf.pg015, "pg16 ? ", this.eval_npf.pg016, "pg17 ? ", this.eval_npf.pg017, "pg18 ? ", this.eval_npf.pg018, "pg19 ? ", this.eval_npf.pg019, "pg20 ? ", this.eval_npf.pg020, "pg21 ? ", this.eval_npf.pg021, "pg22 ? ", this.eval_npf.pg022, "pg23 ? ", this.eval_npf.pg023, "pg24 ? ", this.eval_npf.pg024, "pg25 ? ", this.eval_npf.pg025, "pg26 ? ", this.eval_npf.pg026, "pg27 ? ", this.eval_npf.pg027, "pg28 ? ", this.eval_npf.pg028, "pg29 ? ", this.eval_npf.pg029, "pg30 ? ", this.eval_npf.pg030, "pg31 ? ", this.eval_npf.pg031, "pg32 ? ", this.eval_npf.pg032, "pg33 ? ", this.eval_npf.pg033, "pg34 ? ", this.eval_npf.pg034, "pg35 ? ", this.eval_npf.pg035, "pg36 ? ", this.eval_npf.pg036, "pg37 ? ", this.eval_npf.pg037, "pg38 ? ", this.eval_npf.pg038, "pg39 ? ", this.eval_npf.pg039, "pg40 ? ", this.eval_npf.pg040);
               console.log("uno ? ", this.res_npf.Uno, "; dos ? ", this.res_npf.Dos, "; Cero ? ", this.res_npf.Cero);
               console.log("uno2 ? ", this.res_npf.Uno2, "; dos2 ? ", this.res_npf.Dos2, "; Cero2 ? ", this.res_npf.Cero2);

               console.log("**");
               console.log("uno ? ", this.res_npf.Uno, "; dos ? ", this.res_npf.Dos, "; Cero ? ", this.res_npf.Cero);
               console.log("uno2 ? ", this.res_npf.Uno2, "; dos2 ? ", this.res_npf.Dos2, "; Cero2 ? ", this.res_npf.Cero2);

               this.res_npf.cprevia = this.res_npf.Uno + this.res_npf.Dos;
               this.res_npf.cpreviaIzq = 0;
               this.res_npf.cpreviaDer = this.res_npf.Uno2 + this.res_npf.Dos2;
               if (this.res_npf.cpreviaDer >= 1000000) {
                    this.res_npf.cpreviaIzq = this.res_npf.cprevia - this.res_npf.cpreviaDer;
               } else {
                    this.res_npf.cpreviaIzq = this.res_npf.cprevia;
               }

               /* ================================================================================================= */
               /*  COMPARADOR DE RANGOS */
               var comp1 = this.res_npf.cpreviaIzq >= 21 && this.res_npf.cpreviaIzq <= 25;
               if (comp1 === true) {
                    this.res_npf.rango = 1;
               }
               var comp2 = this.res_npf.cpreviaIzq >= 26 && this.res_npf.cpreviaIzq <= 28;
               if (comp2 === true) {
                    this.res_npf.rango = 2;
               }
               var comp3 = this.res_npf.cpreviaIzq >= 29 && this.res_npf.cpreviaIzq <= 31;
               if (comp3 === true) {
                    this.res_npf.rango = 3;
               }
               var comp4 = this.res_npf.cpreviaIzq >= 32 && this.res_npf.cpreviaIzq <= 34;
               if (comp4 === true) {
                    this.res_npf.rango = 4;
               }
               var comp5 = this.res_npf.cpreviaIzq >= 35 && this.res_npf.cpreviaIzq <= 37;
               if (comp5 === true) {
                    this.res_npf.rango = 5;
               }
               var comp6 = this.res_npf.cpreviaIzq >= 38 && this.res_npf.cpreviaIzq <= 39;
               if (comp6 === true) {
                    this.res_npf.rango = 6;
               }
               var comp7 = this.res_npf.cpreviaIzq >= 40 && this.res_npf.cpreviaIzq <= 44;
               if (comp7 === true) {
                    this.res_npf.rango = 7;
               }
               var comp8 = this.res_npf.cpreviaIzq >= 45 && this.res_npf.cpreviaIzq <= 51;
               if (comp8 === true) {
                    this.res_npf.rango = 8;
               }
               var comp9 = this.res_npf.cpreviaIzq >= 52 && this.res_npf.cpreviaIzq <= 68;
               if (comp9 === true) {
                    this.res_npf.rango = 9;
               }
               if (this.res_npf.cpreviaDer >= 10) {
                    this.res_npf.rango = this.res_npf.rango - 1;
               }

               this.res_npf.rangos = this.res_npf.rango;
               console.log("El rango es ? ", this.res_npf.rangos);
          },
          // rangos()

          resultados: function resultados(doc) {

               this.rangosnpf();

               doc.setLineWidth(0.25);

               doc.text(10, 70, "SECCION DE RESULTADOS ");
               doc.line(10, 71, 206, 71);

               doc.text(10, 74, "Conteo:       ( 0= ");
               doc.text(35, 74, this.res_npf.Uno.toString());
               doc.text(38, 74, ", 1= ");
               doc.text(45, 74, this.res_npf.Dos.toString());
               doc.text(49, 74, ", 2= ");
               doc.text(56, 74, this.res_npf.Cero.toString());
               doc.text(59, 74, " )");

               doc.text(70, 74, "( 0= ");
               doc.text(78, 74, this.res_npf.Uno2.toString());
               doc.text(81, 74, ", 1= ");
               doc.text(88, 74, this.res_npf.Dos2.toString());
               doc.text(91, 74, ", 2= ");
               doc.text(98, 74, this.res_npf.Cero2.toString());
               doc.text(101, 74, " )");

               doc.text(10, 80, "Resultados: [ ");
               doc.text(30, 80, this.res_npf.cpreviaIzq.toString());
               doc.text(35, 80, ", ");
               doc.text(40, 80, this.res_npf.cpreviaDer.toString());
               doc.text(45, 80, " ] ");

               doc.text(10, 85, "Rangos: ");
               doc.text(28, 85, this.res_npf.rangos.toString());
          },
          respuestas: function respuestas(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ");
               doc.line(10, 42, 206, 42);
               doc.text(10, 45, this.eval_npf.pg001 === "a" ? "| 01= (a)" : this.eval_npf.pg001 === "b" ? "| 01= (b)" : "| 01= (c)");
               doc.text(23, 45, this.eval_npf.pg002 === "a" ? "| 02= (a)" : this.eval_npf.pg002 === "b" ? "| 02= (b)" : "| 02= (c)");
               doc.text(36, 45, this.eval_npf.pg003 === "a" ? "| 03= (a)" : this.eval_npf.pg003 === "b" ? "| 03= (b)" : "| 03= (c)");
               doc.text(49, 45, this.eval_npf.pg004 === "a" ? "| 04= (a)" : this.eval_npf.pg004 === "b" ? "| 04= (b)" : "| 04= (c)");
               doc.text(62, 45, this.eval_npf.pg005 === "a" ? "| 05= (a)" : this.eval_npf.pg005 === "b" ? "| 05= (b)" : "| 05= (c)");
               doc.text(75, 45, this.eval_npf.pg006 === "a" ? "| 06= (a)" : this.eval_npf.pg006 === "b" ? "| 06= (b)" : "| 06= (c)");
               doc.text(88, 45, this.eval_npf.pg007 === "a" ? "| 07= (a)" : this.eval_npf.pg007 === "b" ? "| 07= (b)" : "| 07= (c)");
               doc.text(101, 45, this.eval_npf.pg008 === "a" ? "| 08= (a)" : this.eval_npf.pg008 === "b" ? "| 08= (b)" : "| 08= (c)");
               doc.text(114, 45, this.eval_npf.pg009 === "a" ? "| 09= (a)" : this.eval_npf.pg009 === "b" ? "| 09= (b)" : "| 09= (c)");
               doc.text(127, 45, this.eval_npf.pg010 === "a" ? "| 10= (a)" : this.eval_npf.pg010 === "b" ? "| 10= (b)" : "| 10= (c)");
               doc.text(140, 45, this.eval_npf.pg011 === "a" ? "| 11= (a)" : this.eval_npf.pg011 === "b" ? "| 11= (b)" : "| 11= (c)");
               doc.text(153, 45, this.eval_npf.pg012 === "a" ? "| 12= (a)" : this.eval_npf.pg012 === "b" ? "| 12= (b)" : "| 12= (c)");
               doc.text(166, 45, this.eval_npf.pg013 === "a" ? "| 13= (a)" : this.eval_npf.pg013 === "b" ? "| 13= (b)" : "| 13= (c)");
               doc.text(179, 45, this.eval_npf.pg014 === "a" ? "| 14= (a)" : this.eval_npf.pg014 === "b" ? "| 14= (b)" : "| 14= (c)");
               doc.text(192, 45, this.eval_npf.pg015 === "a" ? "| 15= (a) |" : this.eval_npf.pg015 === "b" ? "| 15= (b) |" : "| 15= (c) |");
               doc.line(10, 46, 206, 46);

               doc.text(10, 49, this.eval_npf.pg016 === "a" ? "| 16= (a)" : this.eval_npf.pg016 === "b" ? "| 16= (b)" : "| 16= (c)");
               doc.text(23, 49, this.eval_npf.pg017 === "a" ? "| 17= (a)" : this.eval_npf.pg017 === "b" ? "| 17= (b)" : "| 17= (c)");
               doc.text(36, 49, this.eval_npf.pg018 === "a" ? "| 18= (a)" : this.eval_npf.pg018 === "b" ? "| 18= (b)" : "| 18= (c)");
               doc.text(49, 49, this.eval_npf.pg019 === "a" ? "| 19= (a)" : this.eval_npf.pg019 === "b" ? "| 19= (b)" : "| 19= (c)");
               doc.text(62, 49, this.eval_npf.pg020 === "a" ? "| 20= (a)" : this.eval_npf.pg020 === "b" ? "| 20= (b)" : "| 20= (c)");
               doc.text(75, 49, this.eval_npf.pg021 === "a" ? "| 21= (a)" : this.eval_npf.pg021 === "b" ? "| 21= (b)" : "| 21= (c)");
               doc.text(88, 49, this.eval_npf.pg022 === "a" ? "| 22= (a)" : this.eval_npf.pg022 === "b" ? "| 22= (b)" : "| 22= (c)");
               doc.text(101, 49, this.eval_npf.pg023 === "a" ? "| 23= (a)" : this.eval_npf.pg023 === "b" ? "| 23= (b)" : "| 23= (c)");
               doc.text(114, 49, this.eval_npf.pg024 === "a" ? "| 24= (a)" : this.eval_npf.pg024 === "b" ? "| 24= (b)" : "| 24= (c)");
               doc.text(127, 49, this.eval_npf.pg025 === "a" ? "| 25= (a)" : this.eval_npf.pg025 === "b" ? "| 25= (b)" : "| 25= (c)");
               doc.text(140, 49, this.eval_npf.pg026 === "a" ? "| 26= (a)" : this.eval_npf.pg026 === "b" ? "| 26= (b)" : "| 26= (c)");
               doc.text(153, 49, this.eval_npf.pg027 === "a" ? "| 27= (a)" : this.eval_npf.pg027 === "b" ? "| 27= (b)" : "| 27= (c)");
               doc.text(166, 49, this.eval_npf.pg028 === "a" ? "| 28= (a)" : this.eval_npf.pg028 === "b" ? "| 28= (b)" : "| 28= (c)");
               doc.text(179, 49, this.eval_npf.pg029 === "a" ? "| 29= (a)" : this.eval_npf.pg029 === "b" ? "| 29= (b)" : "| 29= (c)");
               doc.text(192, 49, this.eval_npf.pg030 === "a" ? "| 30= (a) |" : this.eval_npf.pg030 === "b" ? "| 30= (b) |" : "| 30= (c) |");
               doc.line(10, 50, 206, 50);

               doc.text(10, 53, this.eval_npf.pg031 === "a" ? "| 31= (a)" : this.eval_npf.pg031 === "b" ? "| 31= (b)" : "| 31= (c)");
               doc.text(23, 53, this.eval_npf.pg032 === "a" ? "| 32= (a)" : this.eval_npf.pg032 === "b" ? "| 32= (b)" : "| 32= (c)");
               doc.text(36, 53, this.eval_npf.pg033 === "a" ? "| 33= (a)" : this.eval_npf.pg033 === "b" ? "| 33= (b)" : "| 33= (c)");
               doc.text(49, 53, this.eval_npf.pg034 === "a" ? "| 34= (a)" : this.eval_npf.pg034 === "b" ? "| 34= (b)" : "| 34= (c)");
               doc.text(62, 53, this.eval_npf.pg035 === "a" ? "| 35= (a)" : this.eval_npf.pg035 === "b" ? "| 35= (b)" : "| 35= (c)");
               doc.text(75, 53, this.eval_npf.pg036 === "a" ? "| 36= (a)" : this.eval_npf.pg036 === "b" ? "| 36= (b)" : "| 36= (c)");
               doc.text(88, 53, this.eval_npf.pg037 === "a" ? "| 37= (a)" : this.eval_npf.pg037 === "b" ? "| 37= (b)" : "| 37= (c)");
               doc.text(101, 53, this.eval_npf.pg038 === "a" ? "| 38= (a)" : this.eval_npf.pg038 === "b" ? "| 38= (b)" : "| 38= (c)");
               doc.text(114, 53, this.eval_npf.pg039 === "a" ? "| 39= (a)" : this.eval_npf.pg039 === "b" ? "| 39= (b)" : "| 39= (c)");
               doc.text(127, 53, this.eval_npf.pg040 === "a" ? "| 40= (a)" : this.eval_npf.pg040 === "b" ? "| 40= (b)" : "| 40= (c)");
               doc.line(10, 54, 141, 54);
          },

          ejeSinContestar: function ejeSinContestar() {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg002 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg003 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg004 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg005 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }

               return this.ejeSinResponder;
          },
          sinContestar: function sinContestar() {

               this.pregSinContestar = 0;

               if (this.eval_npf.pg001 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg002 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg003 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg004 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg005 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg006 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg007 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg008 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg009 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg010 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg011 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg012 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg013 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg014 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg015 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg016 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg017 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg018 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg019 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg020 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg021 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg022 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg023 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg024 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg025 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               if (this.eval_npf.pg026 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg027 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg028 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg029 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg030 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg031 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg032 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg033 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg034 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg035 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg036 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg037 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg038 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg039 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_npf.pg040 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               return this.pregSinContestar;
          },
          addADayToMyDate: function addADayToMyDate() {
               if (this.eval_fecha) // as myDate can be null
                    // you have to set the this.myDate again, so vue can detect it changed
                    // this is not a caveat of this specific solution, but of any binding of dates
                    this.eval_npf.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
          },
          dateToYYYYMMDD: function dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0];
          },
          cargaHora: function cargaHora() {

               // Convierte la hora obtenida a hora local (utc)
               this.eval_fecha = new Date();
               var d = this.eval_fecha;
               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               var localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion: function cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_npf = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev03; // Crea el nodo para todos los campos.
               this.res_npf = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs03;
               console.log("res ? ", this.res_16pf);

               this.eval_npf.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
               this.eval_npf.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_npf.depto = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_depto; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_npf.sexo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_sexo; // Nombre de la empresa a la cual pertenece el usuario

               this.instrucciones = this.eval_npf.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de ESTABILIDAD.";

               this.eval_fecha = new Date(); // Fecha del Día
          },
          empezarEvaluacion: function empezarEvaluacion() {

               this.eval_npf.empezo = this.cargaHora();
               this.inicioeval = true;
          },

          /** .................... VALIDACIONES  .................... */
          validarValor: function validarValor(valor) {
               var lvalor = valor;
               if (valor < 1 || valor > 2) {
                    lvalor = 0;
               }
               // console.log("validarValor, lvalor ? ",lvalor);
               return lvalor;
          },
          limpiarEvaluacion: function limpiarEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_npf = {
                    depto: "",
                    empresa: "", nombre: "",
                    fecha: "",
                    empezo: "", termino: "",
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                    pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                    pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
                    pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0

                    /* Variables para un nuevo caso */
               };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.eval_npf = this.eval_npf;
          },

          /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          /* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion: function agregarEvaluacion() {
               var _this = this;

               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ");
                    return;
               }

               this.finalizoeval = true;
               this.eval_npf.termino = this.cargaHora();

               this.eval_fecha = new Date();

               var ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               var lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de ESTABILIDAD para " + this.eval_npf.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvaluaciones = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalEstabi;
                    dbEvaluaciones.push({

                         empresa: this.eval_npf.empresa, nombre: this.eval_npf.nombre,
                         empezo: this.eval_npf.empezo, termino: this.eval_npf.termino,
                         fecha: lingreso, depto: this.eval_npf.depto, sexo: this.eval_npf.sexo,
                         pg001: this.eval_npf.pg001, pg002: this.eval_npf.pg002, pg003: this.eval_npf.pg003, pg004: this.eval_npf.pg004, pg005: this.eval_npf.pg005,
                         pg006: this.eval_npf.pg006, pg007: this.eval_npf.pg007, pg008: this.eval_npf.pg008, pg009: this.eval_npf.pg009, pg010: this.eval_npf.pg010,
                         pg011: this.eval_npf.pg011, pg012: this.eval_npf.pg012, pg013: this.eval_npf.pg013, pg014: this.eval_npf.pg014, pg015: this.eval_npf.pg015,
                         pg016: this.eval_npf.pg016, pg017: this.eval_npf.pg017, pg018: this.eval_npf.pg018, pg019: this.eval_npf.pg019, pg020: this.eval_npf.pg020,
                         pg021: this.eval_npf.pg021, pg022: this.eval_npf.pg022, pg023: this.eval_npf.pg023, pg024: this.eval_npf.pg024, pg025: this.eval_npf.pg025,
                         pg026: this.eval_npf.pg026, pg027: this.eval_npf.pg027, pg028: this.eval_npf.pg028, pg029: this.eval_npf.pg029, pg030: this.eval_npf.pg030,
                         pg031: this.eval_npf.pg031, pg032: this.eval_npf.pg032, pg033: this.eval_npf.pg033, pg034: this.eval_npf.pg034, pg035: this.eval_npf.pg035,
                         pg036: this.eval_npf.pg036, pg037: this.eval_npf.pg037, pg038: this.eval_npf.pg038, pg039: this.eval_npf.pg039, pg040: this.eval_npf.pg040
                    }).then(function (data) {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         _this.limpiarEvaluacion();

                         var laClave = data.key;
                         _this.grabado = true;
                         _this.inicioeval = false;

                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de ESTABILIDAD guardado con éxito.");
                    });
               } // if (confirma)
          },
          // agregarEncuesta()

          //? =================================================================================
          enfoqueG1: function enfoqueG1(pestana) {
               var _this2 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         //* Vengo de 1, voy a 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt2.focus();
                         });

                         this.activott1 = "!active";
                         this.activott2 = "active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         break;
                    case 0:
                         //* Vengo de 2, voy a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt1.focus();
                         });
                         this.activott2 = "!active";
                         this.activott1 = "active";

                         this.vertt2 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },
          nadaG1: function nadaG1(pestana) {
               var _this3 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt1.focus();
                         });

                         this.activott1 = "active";
                         this.activott2 = "!active";

                         this.vertt1 = true;
                         this.vertt2 = false;

                         break;
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt2.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "active";

                         this.vertt1 = false;
                         this.vertt2 = true;

                         break;
                    default:
                    // code block
               } //* switch
          },
          enfoqueRG1: function enfoqueRG1(pestana) {
               var _this4 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         //* Estoy en 2 regreso a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt1.focus();
                         });
                         this.activott2 = "!active";
                         this.activott1 = "active";

                         this.vertt2 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          }
     } // methods
     // export

});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *      ev04_cpf.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
     name: 'sociabilidad',
     components: {
          'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
          'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
     },
     template: '#formacpf',
     data: function data() {
          return {
               ejemplo: {},
               eval_cpf: {}, res: {},
               modo: "",
               eval_fecha: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,

               //? .....................................................................................................................................................................................................................
               activott1: "active", activott2: '!active',
               vertt1: true, vertt2: false // return
          };
     },
     // data()
     mounted: function mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();
     },

     computed: {
          l_sinResponder: function l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder: function l_ejeSinResponder() {
               return this.ejeSinContestar();
          }
     },
     methods: {
          crearPDF: function crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_cpf.nombre,
                   patron = / /g,
                   nuevoValor = "",
                   nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "cpf_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1); // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de SOCIABILIDAD para " + this.eval_cpf.nombre + " de " + this.eval_cpf.empresa + " ( " + this.eval_cpf.depto + " )");

               this.respuestas(doc);
               this.resultados(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangosnpf: function rangosnpf() {

               switch (this.eval_cpf.pg001) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;console.log("Es a)");
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;console.log("Es b)");
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;console.log("Es c)");
                         break;
               }
               console.log("uno ? ", this.res_cpf.Uno, "; dos ? ", this.res_cpf.Dos, "; Cero ? ", this.res_cpf.Cero);

               /* Resuelve para la pregunta 2 */
               switch (this.eval_cpf.pg002) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 3 */
               switch (this.eval_cpf.pg003) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg004) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 5 */
               switch (this.eval_cpf.pg005) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 6 */
               switch (this.eval_cpf.pg006) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* Resuelve para la pregunta 3 */
               switch (this.eval_cpf.pg007) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg008) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 9 */
               /* ======================================================== */
               switch (this.eval_cpf.pg009) {
                    case 'a':
                         this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg010) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg011) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg012) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg013) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 14 */
               /* ======================================================== */
               switch (this.eval_cpf.pg014) {
                    case 'a':
                         this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
               }
               switch (this.eval_cpf.pg015) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 16 */
               switch (this.eval_cpf.pg016) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 17 */
               switch (this.eval_cpf.pg017) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg018) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 19 */
               /* ======================================================== */
               console.log("a evaluar 19");
               switch (this.eval_cpf.pg019) {
                    case 'a':
                         this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;console.log("19 es b !!");
                         break;
                    case 'c':
                         this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
               }
               switch (this.eval_cpf.pg020) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 17 */
               switch (this.eval_cpf.pg021) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg022) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 23 */
               /* ======================================================== */
               switch (this.eval_cpf.pg023) {
                    case 'a':
                         this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
               }
               switch (this.eval_cpf.pg024) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg025) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg026) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg027) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 28 */
               /* ======================================================== */
               switch (this.eval_cpf.pg028) {
                    case 'a':
                         this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
               }
               switch (this.eval_cpf.pg029) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg030) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg031) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg032) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg033) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg034) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg035) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg036) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 37 */
               /* ======================================================== */
               switch (this.eval_cpf.pg037) {
                    case 'a':
                         this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
               }
               switch (this.eval_cpf.pg038) {
                    case 'a':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg039) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg040) {
                    case 'a':
                         this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b':
                         this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c':
                         this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               console.log(">>> PRIMERAS 15 PREGUNTAS");
               console.log("pg1 ? ", this.eval_cpf.pg001, "pg2 ? ", this.eval_cpf.pg002, "pg3 ? ", this.eval_cpf.pg003, "pg4 ? ", this.eval_cpf.pg004, "pg5 ? ", this.eval_cpf.pg005, "pg6 ? ", this.eval_cpf.pg006, "pg7 ? ", this.eval_cpf.pg007, "pg8 ? ", this.eval_cpf.pg008, "pg9 ? ", this.eval_cpf.pg009, "pg10 ? ", this.eval_cpf.pg010, "pg11 ? ", this.eval_cpf.pg011, "pg12 ? ", this.eval_cpf.pg012, "pg13 ? ", this.eval_cpf.pg013, "pg14 ? ", this.eval_cpf.pg014, "pg15 ? ", this.eval_cpf.pg015, "pg16 ? ", this.eval_cpf.pg016, "pg17 ? ", this.eval_cpf.pg017, "pg18 ? ", this.eval_cpf.pg018, "pg19 ? ", this.eval_cpf.pg019, "pg20 ? ", this.eval_cpf.pg020, "pg21 ? ", this.eval_cpf.pg021, "pg22 ? ", this.eval_cpf.pg022, "pg23 ? ", this.eval_cpf.pg023, "pg24 ? ", this.eval_cpf.pg024, "pg25 ? ", this.eval_cpf.pg025, "pg26 ? ", this.eval_cpf.pg026, "pg27 ? ", this.eval_cpf.pg027, "pg28 ? ", this.eval_cpf.pg028, "pg29 ? ", this.eval_cpf.pg029, "pg30 ? ", this.eval_cpf.pg030, "pg31 ? ", this.eval_cpf.pg031, "pg32 ? ", this.eval_cpf.pg032, "pg33 ? ", this.eval_cpf.pg033, "pg34 ? ", this.eval_cpf.pg034, "pg35 ? ", this.eval_cpf.pg035, "pg36 ? ", this.eval_cpf.pg036, "pg37 ? ", this.eval_cpf.pg037, "pg38 ? ", this.eval_cpf.pg038, "pg39 ? ", this.eval_cpf.pg039, "pg40 ? ", this.eval_cpf.pg040);
               console.log("uno ? ", this.res_cpf.Uno, "; dos ? ", this.res_cpf.Dos, "; Cero ? ", this.res_cpf.Cero);
               console.log("uno2 ? ", this.res_cpf.Uno2, "; dos2 ? ", this.res_cpf.Dos2, "; Cero2 ? ", this.res_cpf.Cero2);

               console.log("**");
               console.log("uno ? ", this.res_cpf.Uno, "; dos ? ", this.res_cpf.Dos, "; Cero ? ", this.res_cpf.Cero);
               console.log("uno2 ? ", this.res_cpf.Uno2, "; dos2 ? ", this.res_cpf.Dos2, "; Cero2 ? ", this.res_cpf.Cero2);

               this.res_cpf.cprevia = this.res_cpf.Uno + this.res_cpf.Dos;
               this.res_cpf.cpreviaIzq = 0;
               this.res_cpf.cpreviaDer = this.res_cpf.Uno2 + this.res_cpf.Dos2;
               if (this.res_cpf.cpreviaDer >= 1000000) {
                    this.res_cpf.cpreviaIzq = this.res_cpf.cprevia - this.res_cpf.cpreviaDer;
               } else {
                    this.res_cpf.cpreviaIzq = this.res_cpf.cprevia;
               }

               /* ================================================================================================= */
               /*  COMPARADOR DE RANGOS */
               this.res_cpf.rango = -1;
               var comp1 = this.res_cpf.cpreviaIzq >= 21 && this.res_cpf.cpreviaIzq <= 25;
               if (comp1 === true) {
                    this.res_cpf.rango = 1;
               }
               var comp2 = this.res_cpf.cpreviaIzq >= 26 && this.res_cpf.cpreviaIzq <= 28;
               if (comp2 === true) {
                    this.res_cpf.rango = 2;
               }
               var comp3 = this.res_cpf.cpreviaIzq >= 29 && this.res_cpf.cpreviaIzq <= 31;
               if (comp3 === true) {
                    this.res_cpf.rango = 3;
               }
               var comp4 = this.res_cpf.cpreviaIzq >= 32 && this.res_cpf.cpreviaIzq <= 34;
               if (comp4 === true) {
                    this.res_cpf.rango = 4;
               }
               var comp5 = this.res_cpf.cpreviaIzq >= 35 && this.res_cpf.cpreviaIzq <= 37;
               if (comp5 === true) {
                    this.res_cpf.rango = 5;
               }
               var comp6 = this.res_cpf.cpreviaIzq >= 38 && this.res_cpf.cpreviaIzq <= 39;
               if (comp6 === true) {
                    this.res_cpf.rango = 6;
               }
               var comp7 = this.res_cpf.cpreviaIzq >= 40 && this.res_cpf.cpreviaIzq <= 44;
               if (comp7 === true) {
                    this.res_cpf.rango = 7;
               }
               var comp8 = this.res_cpf.cpreviaIzq >= 45 && this.res_cpf.cpreviaIzq <= 51;
               if (comp8 === true) {
                    this.res_cpf.rango = 8;
               }
               var comp9 = this.res_cpf.cpreviaIzq >= 52 && this.res_cpf.cpreviaIzq <= 68;
               if (comp9 === true) {
                    this.res_cpf.rango = 9;
               }
               if (this.res_cpf.cpreviaDer >= 10) {
                    this.res_cpf.rango = this.res_cpf.rango - 1;
               }

               this.res_cpf.rangos = this.res_cpf.rango;
               console.log("El rango es ? ", this.res_cpf.rangos);
          },
          // rangos()

          resultados: function resultados(doc) {

               this.rangosnpf();

               doc.setLineWidth(0.25);

               doc.text(10, 70, "SECCION DE RESULTADOS ");
               doc.line(10, 71, 206, 71);

               doc.text(10, 74, "Conteo:       ( 0= ");
               doc.text(35, 74, this.res_cpf.Uno.toString());
               doc.text(38, 74, ", 1= ");
               doc.text(45, 74, this.res_cpf.Dos.toString());
               doc.text(49, 74, ", 2= ");
               doc.text(56, 74, this.res_cpf.Cero.toString());
               doc.text(59, 74, " )");

               doc.text(70, 74, "( 0= ");
               doc.text(78, 74, this.res_cpf.Uno2.toString());
               doc.text(81, 74, ", 1= ");
               doc.text(88, 74, this.res_cpf.Dos2.toString());
               doc.text(91, 74, ", 2= ");
               doc.text(98, 74, this.res_cpf.Cero2.toString());
               doc.text(101, 74, " )");

               doc.text(10, 80, "Resultados: [ ");
               doc.text(30, 80, this.res_cpf.cpreviaIzq.toString());
               doc.text(35, 80, ", ");
               doc.text(40, 80, this.res_cpf.cpreviaDer.toString());
               doc.text(45, 80, " ] ");

               doc.text(10, 85, "Rangos: ");
               doc.text(28, 85, this.res_cpf.rangos.toString());
          },
          respuestas: function respuestas(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ");
               doc.line(10, 42, 206, 42);
               doc.text(10, 45, this.eval_cpf.pg001 === "a" ? "| 01= (a)" : this.eval_cpf.pg001 === "b" ? "| 01= (b)" : "| 01= (c)");
               doc.text(23, 45, this.eval_cpf.pg002 === "a" ? "| 02= (a)" : this.eval_cpf.pg002 === "b" ? "| 02= (b)" : "| 02= (c)");
               doc.text(36, 45, this.eval_cpf.pg003 === "a" ? "| 03= (a)" : this.eval_cpf.pg003 === "b" ? "| 03= (b)" : "| 03= (c)");
               doc.text(49, 45, this.eval_cpf.pg004 === "a" ? "| 04= (a)" : this.eval_cpf.pg004 === "b" ? "| 04= (b)" : "| 04= (c)");
               doc.text(62, 45, this.eval_cpf.pg005 === "a" ? "| 05= (a)" : this.eval_cpf.pg005 === "b" ? "| 05= (b)" : "| 05= (c)");
               doc.text(75, 45, this.eval_cpf.pg006 === "a" ? "| 06= (a)" : this.eval_cpf.pg006 === "b" ? "| 06= (b)" : "| 06= (c)");
               doc.text(88, 45, this.eval_cpf.pg007 === "a" ? "| 07= (a)" : this.eval_cpf.pg007 === "b" ? "| 07= (b)" : "| 07= (c)");
               doc.text(101, 45, this.eval_cpf.pg008 === "a" ? "| 08= (a)" : this.eval_cpf.pg008 === "b" ? "| 08= (b)" : "| 08= (c)");
               doc.text(114, 45, this.eval_cpf.pg009 === "a" ? "| 09= (a)" : this.eval_cpf.pg009 === "b" ? "| 09= (b)" : "| 09= (c)");
               doc.text(127, 45, this.eval_cpf.pg010 === "a" ? "| 10= (a)" : this.eval_cpf.pg010 === "b" ? "| 10= (b)" : "| 10= (c)");
               doc.text(140, 45, this.eval_cpf.pg011 === "a" ? "| 11= (a)" : this.eval_cpf.pg011 === "b" ? "| 11= (b)" : "| 11= (c)");
               doc.text(153, 45, this.eval_cpf.pg012 === "a" ? "| 12= (a)" : this.eval_cpf.pg012 === "b" ? "| 12= (b)" : "| 12= (c)");
               doc.text(166, 45, this.eval_cpf.pg013 === "a" ? "| 13= (a)" : this.eval_cpf.pg013 === "b" ? "| 13= (b)" : "| 13= (c)");
               doc.text(179, 45, this.eval_cpf.pg014 === "a" ? "| 14= (a)" : this.eval_cpf.pg014 === "b" ? "| 14= (b)" : "| 14= (c)");
               doc.text(192, 45, this.eval_cpf.pg015 === "a" ? "| 15= (a) |" : this.eval_cpf.pg015 === "b" ? "| 15= (b) |" : "| 15= (c) |");
               doc.line(10, 46, 206, 46);

               doc.text(10, 49, this.eval_cpf.pg016 === "a" ? "| 16= (a)" : this.eval_cpf.pg016 === "b" ? "| 16= (b)" : "| 16= (c)");
               doc.text(23, 49, this.eval_cpf.pg017 === "a" ? "| 17= (a)" : this.eval_cpf.pg017 === "b" ? "| 17= (b)" : "| 17= (c)");
               doc.text(36, 49, this.eval_cpf.pg018 === "a" ? "| 18= (a)" : this.eval_cpf.pg018 === "b" ? "| 18= (b)" : "| 18= (c)");
               doc.text(49, 49, this.eval_cpf.pg019 === "a" ? "| 19= (a)" : this.eval_cpf.pg019 === "b" ? "| 19= (b)" : "| 19= (c)");
               doc.text(62, 49, this.eval_cpf.pg020 === "a" ? "| 20= (a)" : this.eval_cpf.pg020 === "b" ? "| 20= (b)" : "| 20= (c)");
               doc.text(75, 49, this.eval_cpf.pg021 === "a" ? "| 21= (a)" : this.eval_cpf.pg021 === "b" ? "| 21= (b)" : "| 21= (c)");
               doc.text(88, 49, this.eval_cpf.pg022 === "a" ? "| 22= (a)" : this.eval_cpf.pg022 === "b" ? "| 22= (b)" : "| 22= (c)");
               doc.text(101, 49, this.eval_cpf.pg023 === "a" ? "| 23= (a)" : this.eval_cpf.pg023 === "b" ? "| 23= (b)" : "| 23= (c)");
               doc.text(114, 49, this.eval_cpf.pg024 === "a" ? "| 24= (a)" : this.eval_cpf.pg024 === "b" ? "| 24= (b)" : "| 24= (c)");
               doc.text(127, 49, this.eval_cpf.pg025 === "a" ? "| 25= (a)" : this.eval_cpf.pg025 === "b" ? "| 25= (b)" : "| 25= (c)");
               doc.text(140, 49, this.eval_cpf.pg026 === "a" ? "| 26= (a)" : this.eval_cpf.pg026 === "b" ? "| 26= (b)" : "| 26= (c)");
               doc.text(153, 49, this.eval_cpf.pg027 === "a" ? "| 27= (a)" : this.eval_cpf.pg027 === "b" ? "| 27= (b)" : "| 27= (c)");
               doc.text(166, 49, this.eval_cpf.pg028 === "a" ? "| 28= (a)" : this.eval_cpf.pg028 === "b" ? "| 28= (b)" : "| 28= (c)");
               doc.text(179, 49, this.eval_cpf.pg029 === "a" ? "| 29= (a)" : this.eval_cpf.pg029 === "b" ? "| 29= (b)" : "| 29= (c)");
               doc.text(192, 49, this.eval_cpf.pg030 === "a" ? "| 30= (a) |" : this.eval_cpf.pg030 === "b" ? "| 30= (b) |" : "| 30= (c) |");
               doc.line(10, 50, 206, 50);

               doc.text(10, 53, this.eval_cpf.pg031 === "a" ? "| 31= (a)" : this.eval_cpf.pg031 === "b" ? "| 31= (b)" : "| 31= (c)");
               doc.text(23, 53, this.eval_cpf.pg032 === "a" ? "| 32= (a)" : this.eval_cpf.pg032 === "b" ? "| 32= (b)" : "| 32= (c)");
               doc.text(36, 53, this.eval_cpf.pg033 === "a" ? "| 33= (a)" : this.eval_cpf.pg033 === "b" ? "| 33= (b)" : "| 33= (c)");
               doc.text(49, 53, this.eval_cpf.pg034 === "a" ? "| 34= (a)" : this.eval_cpf.pg034 === "b" ? "| 34= (b)" : "| 34= (c)");
               doc.text(62, 53, this.eval_cpf.pg035 === "a" ? "| 35= (a)" : this.eval_cpf.pg035 === "b" ? "| 35= (b)" : "| 35= (c)");
               doc.text(75, 53, this.eval_cpf.pg036 === "a" ? "| 36= (a)" : this.eval_cpf.pg036 === "b" ? "| 36= (b)" : "| 36= (c)");
               doc.text(88, 53, this.eval_cpf.pg037 === "a" ? "| 37= (a)" : this.eval_cpf.pg037 === "b" ? "| 37= (b)" : "| 37= (c)");
               doc.text(101, 53, this.eval_cpf.pg038 === "a" ? "| 38= (a)" : this.eval_cpf.pg038 === "b" ? "| 38= (b)" : "| 38= (c)");
               doc.text(114, 53, this.eval_cpf.pg039 === "a" ? "| 39= (a)" : this.eval_cpf.pg039 === "b" ? "| 39= (b)" : "| 39= (c)");
               doc.text(127, 53, this.eval_cpf.pg040 === "a" ? "| 40= (a)" : this.eval_cpf.pg040 === "b" ? "| 40= (b)" : "| 40= (c)");
               doc.line(10, 54, 141, 54);
          },

          ejeSinContestar: function ejeSinContestar() {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg002 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg003 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg004 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg005 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }

               return this.ejeSinResponder;
          },
          sinContestar: function sinContestar() {

               this.pregSinContestar = 0;

               if (this.eval_cpf.pg001 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg002 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg003 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg004 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg005 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg006 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg007 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg008 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg009 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg010 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg011 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg012 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg013 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg014 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg015 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg016 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg017 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg018 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg019 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg020 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg021 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg022 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg023 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg024 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg025 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               if (this.eval_cpf.pg026 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg027 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg028 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg029 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg030 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg031 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg032 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg033 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg034 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg035 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg036 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg037 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg038 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg039 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_cpf.pg040 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               return this.pregSinContestar;
          },
          addADayToMyDate: function addADayToMyDate() {
               if (this.eval_fecha) // as myDate can be null
                    // you have to set the this.myDate again, so vue can detect it changed
                    // this is not a caveat of this specific solution, but of any binding of dates
                    this.eval_cpf.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
          },
          dateToYYYYMMDD: function dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0];
          },
          cargaHora: function cargaHora() {

               // Convierte la hora obtenida a hora local (utc)
               this.eval_fecha = new Date();
               var d = this.eval_fecha;
               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               var localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion: function cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_cpf = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev04; // Crea el nodo para todos los campos.
               this.res_cpf = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs04;
               console.log("res ? ", this.res_16pf);

               this.eval_cpf.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
               this.eval_cpf.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_cpf.depto = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_depto; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_cpf.sexo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_sexo; // Nombre de la empresa a la cual pertenece el usuario

               this.instrucciones = this.eval_cpf.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de SOCIABILIDAD.";

               this.eval_fecha = new Date(); // Fecha del Día
          },
          empezarEvaluacion: function empezarEvaluacion() {

               this.eval_cpf.empezo = this.cargaHora();
               this.inicioeval = true;
          },

          /** .................... VALIDACIONES  .................... */
          validarValor: function validarValor(valor) {
               var lvalor = valor;
               if (valor < 1 || valor > 2) {
                    lvalor = 0;
               }
               // console.log("validarValor, lvalor ? ",lvalor);
               return lvalor;
          },
          limpiarEvaluacion: function limpiarEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_cpf = {
                    depto: "",
                    empresa: "", nombre: "",
                    fecha: "",
                    empezo: "", termino: "",
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                    pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                    pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
                    pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0

                    /* Variables para un nuevo caso */
               };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.eval_cpf = this.eval_cpf;
          },

          /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          /* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion: function agregarEvaluacion() {
               var _this = this;

               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ");
                    return;
               }

               this.finalizoeval = true;
               this.eval_cpf.termino = this.cargaHora();

               this.eval_fecha = new Date();

               var ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               var lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de SOCIABILIDAD para " + this.eval_cpf.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvaluaciones = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalSociab;
                    dbEvaluaciones.push({

                         empresa: this.eval_cpf.empresa, nombre: this.eval_cpf.nombre,
                         empezo: this.eval_cpf.empezo, termino: this.eval_cpf.termino,
                         fecha: lingreso, depto: this.eval_cpf.depto, sexo: this.eval_cpf.sexo,
                         pg001: this.eval_cpf.pg001, pg002: this.eval_cpf.pg002, pg003: this.eval_cpf.pg003, pg004: this.eval_cpf.pg004, pg005: this.eval_cpf.pg005,
                         pg006: this.eval_cpf.pg006, pg007: this.eval_cpf.pg007, pg008: this.eval_cpf.pg008, pg009: this.eval_cpf.pg009, pg010: this.eval_cpf.pg010,
                         pg011: this.eval_cpf.pg011, pg012: this.eval_cpf.pg012, pg013: this.eval_cpf.pg013, pg014: this.eval_cpf.pg014, pg015: this.eval_cpf.pg015,
                         pg016: this.eval_cpf.pg016, pg017: this.eval_cpf.pg017, pg018: this.eval_cpf.pg018, pg019: this.eval_cpf.pg019, pg020: this.eval_cpf.pg020,
                         pg021: this.eval_cpf.pg021, pg022: this.eval_cpf.pg022, pg023: this.eval_cpf.pg023, pg024: this.eval_cpf.pg024, pg025: this.eval_cpf.pg025,
                         pg026: this.eval_cpf.pg026, pg027: this.eval_cpf.pg027, pg028: this.eval_cpf.pg028, pg029: this.eval_cpf.pg029, pg030: this.eval_cpf.pg030,
                         pg031: this.eval_cpf.pg031, pg032: this.eval_cpf.pg032, pg033: this.eval_cpf.pg033, pg034: this.eval_cpf.pg034, pg035: this.eval_cpf.pg035,
                         pg036: this.eval_cpf.pg036, pg037: this.eval_cpf.pg037, pg038: this.eval_cpf.pg038, pg039: this.eval_cpf.pg039, pg040: this.eval_cpf.pg040
                    }).then(function (data) {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         _this.limpiarEvaluacion();

                         var laClave = data.key;
                         _this.grabado = true;
                         _this.inicioeval = false;

                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de SOCIABILIDAD guardado con éxito.");
                    });
               } // if (confirma)
          },
          // agregarEncuesta()

          //? =================================================================================
          enfoqueG1: function enfoqueG1(pestana) {
               var _this2 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         //* Vengo de 1, voy a 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt2.focus();
                         });

                         this.activott1 = "!active";
                         this.activott2 = "active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         break;
                    case 0:
                         //* Vengo de 2, voy a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt1.focus();
                         });
                         this.activott2 = "!active";
                         this.activott1 = "active";

                         this.vertt2 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },
          nadaG1: function nadaG1(pestana) {
               var _this3 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt1.focus();
                         });

                         this.activott1 = "active";
                         this.activott2 = "!active";

                         this.vertt1 = true;
                         this.vertt2 = false;

                         break;
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt2.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "active";

                         this.vertt1 = false;
                         this.vertt2 = true;

                         break;
                    default:
                    // code block
               } //* switch
          },
          enfoqueRG1: function enfoqueRG1(pestana) {
               var _this4 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         //* Estoy en 2 regreso a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt1.focus();
                         });
                         this.activott2 = "!active";
                         this.activott1 = "active";

                         this.vertt2 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          }
     } // methods
     // export

});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *      ev05_fig.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
     name: 'perfil',
     components: {
          'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
          'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
     },
     template: '#formafig',
     data: function data() {
          return {
               ejemplo: {},
               eval_fig: {}, res_fig: {},
               modo: "",
               eval_fecha: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,

               //? .....................................................................................................................................................................................................................
               activott1: "active", activott2: '!active', activott3: "!active", activott4: "!active",
               vertt1: true, vertt2: false, vertt3: false, vertt4: false,
               area1: "", area2: '', area3: '', area4: "" // return
          };
     },
     // data()
     mounted: function mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();
     },

     computed: {
          l_sinResponder: function l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder: function l_ejeSinResponder() {
               return this.ejeSinContestar();
          }
     },
     methods: {
          crearPDF: function crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_fig.nombre,
                   patron = / /g,
                   nuevoValor = "",
                   nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "fig_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1); // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de PERFIL DE PERSONALIDAD para " + this.eval_fig.nombre + " de " + this.eval_fig.empresa + " ( " + this.eval_fig.depto + " )");

               this.respuestas(doc);
               this.resultados(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangosfig: function rangosfig() {

               this.res_fig = {
                    mas_D: 0, menos_D: 0, mas_I: 0, menos_I: 0, mas_S: 0, menos_S: 0,
                    mas_C: 0, menos_C: 0, mas_N: 0, menos_N: 0, mas_W: 0, menos_W: 0,
                    total_mas: 0, total_menos: 0
               };

               switch (this.eval_fig.pg001) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 2 */
               switch (this.eval_fig.pg002) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 3 */
               switch (this.eval_fig.pg003) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_fig.pg004) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 5 */
               switch (this.eval_fig.pg005) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N+':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 6 */
               switch (this.eval_fig.pg006) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 7 */
               switch (this.eval_fig.pg007) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 8 */
               switch (this.eval_fig.pg008) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 1 */
               switch (this.eval_fig.pg009) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 2 */
               switch (this.eval_fig.pg010) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 11 */
               switch (this.eval_fig.pg011) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N+':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 12 */
               switch (this.eval_fig.pg012) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 13 */
               switch (this.eval_fig.pg013) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 14 */
               switch (this.eval_fig.pg014) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 15 */
               switch (this.eval_fig.pg015) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N+':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 16 */
               switch (this.eval_fig.pg016) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    case 'N+':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 17 */
               switch (this.eval_fig.pg017) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 18 */
               switch (this.eval_fig.pg018) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 19 */
               switch (this.eval_fig.pg019) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 11 */
               switch (this.eval_fig.pg020) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 12 */
               switch (this.eval_fig.pg021) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 18 */
               switch (this.eval_fig.pg022) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 23 */
               switch (this.eval_fig.pg023) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 24 */
               switch (this.eval_fig.pg024) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 25 */
               switch (this.eval_fig.pg025) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 26 */
               switch (this.eval_fig.pg026) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 27 */
               switch (this.eval_fig.pg027) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 28 */
               switch (this.eval_fig.pg028) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    case 'N+':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 29 */
               switch (this.eval_fig.pg029) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 30 */
               switch (this.eval_fig.pg030) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 31 */
               switch (this.eval_fig.pg031) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 32 */
               switch (this.eval_fig.pg032) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 33 */
               switch (this.eval_fig.pg033) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 34 */
               switch (this.eval_fig.pg034) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 35 */
               switch (this.eval_fig.pg035) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 36 */
               switch (this.eval_fig.pg036) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    case 'N+':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 37 */
               switch (this.eval_fig.pg037) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 38 */
               switch (this.eval_fig.pg038) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 39 */
               switch (this.eval_fig.pg039) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 40 */
               switch (this.eval_fig.pg040) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 41 */
               switch (this.eval_fig.pg041) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 42 */
               switch (this.eval_fig.pg042) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 43 */
               switch (this.eval_fig.pg043) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 44 */
               switch (this.eval_fig.pg044) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 45 */
               switch (this.eval_fig.pg045) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 46 */
               switch (this.eval_fig.pg046) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 47 */
               switch (this.eval_fig.pg047) {
                    case 'D':
                         this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I':
                         this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S':
                         this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C':
                         this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N':
                         this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default:
                         this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 48 */
               switch (this.eval_fig.pg048) {
                    case 'D':
                         this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I':
                         this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S':
                         this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C':
                         this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N':
                         this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default:
                         this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }

               this.res_fig.total_mas = this.res_fig.mas_D + this.res_fig.mas_I + this.res_fig.mas_S + this.res_fig.mas_C + this.res_fig.mas_N;
               this.res_fig.total_menos = this.res_fig.menos_D + this.res_fig.menos_I + this.res_fig.menos_S + this.res_fig.menos_C + this.res_fig.menos_N;
          },
          resultados: function resultados(doc) {

               this.rangosfig();

               console.log("***-*-*-*-****---*******");
               console.log("resultados ? ", this.res_fig);
               doc.setLineWidth(0.25);

               doc.text(10, 88, "SECCION DE RESULTADOS ");
               doc.line(10, 89, 206, 89);

               var menos_D = this.res_fig.menos_D;
               var mas_D = this.res_fig.mas_D;
               var difD = mas_D - menos_D;
               doc.text(20, 94, "MAS");doc.text(30, 94, "MENOS");doc.text(50, 94, "DIFERENCIA");
               doc.text(20, 96, "-------");doc.text(30, 96, "-----------");doc.text(50, 96, "-------------------");
               doc.text(10, 100, "D");
               doc.text(22, 100, mas_D.toString());doc.text(35, 100, menos_D.toString());doc.text(57, 100, difD.toString());

               var menos_I = this.res_fig.menos_I;
               var mas_I = this.res_fig.mas_I;
               var difI = mas_I - menos_I;
               doc.text(10, 105, "I");
               doc.text(22, 105, mas_I.toString());doc.text(35, 105, menos_I.toString());doc.text(57, 105, difI.toString());

               var menos_S = this.res_fig.menos_S;
               var mas_S = this.res_fig.mas_S;
               var difS = mas_S - menos_S;
               doc.text(10, 110, "S");
               doc.text(22, 110, mas_S.toString());doc.text(35, 110, menos_S.toString());doc.text(57, 110, difS.toString());

               var menos_C = this.res_fig.menos_C;
               var mas_C = this.res_fig.mas_C;
               var difC = mas_C - menos_C;
               doc.text(10, 115, "C");
               doc.text(22, 115, mas_C.toString());doc.text(35, 115, menos_C.toString());doc.text(57, 115, difC.toString());

               var menos_N = this.res_fig.menos_N;
               var mas_N = this.res_fig.mas_N;
               var difN = mas_N - menos_N;
               doc.text(10, 120, "N");
               doc.text(22, 120, mas_N.toString());doc.text(35, 120, menos_N.toString());doc.text(57, 120, difN.toString());
               doc.text(20, 122, "-------");doc.text(30, 122, "-----------");doc.text(50, 122, "-------------------");

               var total_mas = 0;var total_menos = 0;
               total_mas = mas_D + mas_I + mas_S + mas_C + mas_N;
               total_menos = menos_D + menos_I + menos_S + menos_C + menos_N;
               doc.text(22, 125, total_mas.toString());doc.text(35, 125, total_menos.toString());
          },
          respuestas: function respuestas(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ");
               doc.line(10, 42, 190, 42);
               doc.text(10, 45, "01= ");
               doc.text(23, 45, this.eval_fig.pg001);
               doc.text(30, 45, "03= ");
               doc.text(43, 45, this.eval_fig.pg003);
               doc.text(50, 45, "05= ");
               doc.text(63, 45, this.eval_fig.pg005);
               doc.text(70, 45, "07= ");
               doc.text(83, 45, this.eval_fig.pg007);
               doc.text(90, 45, "09= ");doc.text(103, 45, this.eval_fig.pg009);doc.text(110, 45, "11= ");doc.text(123, 45, this.eval_fig.pg011);
               doc.text(130, 45, "13= ");doc.text(143, 45, this.eval_fig.pg013);doc.text(150, 45, "15= ");doc.text(163, 45, this.eval_fig.pg015);
               doc.text(170, 45, "17= ");doc.text(183, 45, this.eval_fig.pg017);
               doc.line(10, 46, 190, 46);
               doc.text(10, 49, "19= ");doc.text(23, 49, this.eval_fig.pg019);doc.text(30, 49, "21= ");doc.text(43, 49, this.eval_fig.pg021);
               doc.text(50, 49, "23= ");doc.text(63, 49, this.eval_fig.pg023);doc.text(70, 49, "25= ");doc.text(83, 49, this.eval_fig.pg025);
               doc.text(90, 49, "27= ");doc.text(103, 49, this.eval_fig.pg027);doc.text(110, 49, "29= ");doc.text(123, 49, this.eval_fig.pg029);
               doc.text(130, 49, "31= ");doc.text(143, 49, this.eval_fig.pg031);doc.text(150, 49, "33= ");doc.text(163, 49, this.eval_fig.pg033);
               doc.text(170, 49, "35= ");doc.text(183, 49, this.eval_fig.pg035);
               doc.line(10, 50, 190, 50);
               doc.text(10, 53, "37= ");doc.text(23, 53, this.eval_fig.pg037);doc.text(30, 53, "39= ");doc.text(43, 53, this.eval_fig.pg039);
               doc.text(50, 53, "41= ");doc.text(63, 53, this.eval_fig.pg041);doc.text(70, 53, "43= ");doc.text(83, 53, this.eval_fig.pg043);
               doc.text(90, 53, "45= ");doc.text(103, 53, this.eval_fig.pg045);doc.text(110, 53, "47= ");doc.text(123, 53, this.eval_fig.pg047);
               doc.line(10, 54, 130, 54);

               doc.line(10, 62, 190, 62);
               doc.text(10, 65, "02= ");doc.text(23, 65, this.eval_fig.pg002);doc.text(30, 65, "04= ");doc.text(43, 65, this.eval_fig.pg004);
               doc.text(50, 65, "06= ");doc.text(63, 65, this.eval_fig.pg006);doc.text(70, 65, "08= ");doc.text(83, 65, this.eval_fig.pg008);
               doc.text(90, 65, "10= ");doc.text(103, 65, this.eval_fig.pg010);doc.text(110, 65, "12= ");doc.text(123, 65, this.eval_fig.pg012);
               doc.text(130, 65, "14= ");doc.text(143, 65, this.eval_fig.pg014);doc.text(150, 65, "16= ");doc.text(163, 65, this.eval_fig.pg016);
               doc.text(170, 65, "18= ");doc.text(183, 65, this.eval_fig.pg018);
               doc.line(10, 66, 190, 66);
               doc.text(10, 69, "20= ");doc.text(23, 69, this.eval_fig.pg020);doc.text(30, 69, "22= ");doc.text(43, 69, this.eval_fig.pg022);
               doc.text(50, 69, "24= ");doc.text(63, 69, this.eval_fig.pg024);doc.text(70, 69, "26= ");doc.text(83, 69, this.eval_fig.pg026);
               doc.text(90, 69, "28= ");doc.text(103, 69, this.eval_fig.pg028);doc.text(110, 69, "30= ");doc.text(123, 69, this.eval_fig.pg030);
               doc.text(130, 69, "32= ");doc.text(143, 69, this.eval_fig.pg032);doc.text(150, 69, "34= ");doc.text(163, 69, this.eval_fig.pg034);
               doc.text(170, 69, "36= ");doc.text(183, 69, this.eval_fig.pg036);
               doc.line(10, 70, 190, 70);
               doc.text(10, 73, "38= ");doc.text(23, 73, this.eval_fig.pg038);doc.text(30, 73, "40= ");doc.text(43, 73, this.eval_fig.pg040);
               doc.text(50, 73, "42= ");doc.text(63, 73, this.eval_fig.pg042);doc.text(70, 73, "44= ");doc.text(83, 73, this.eval_fig.pg044);
               doc.text(90, 73, "46= ");doc.text(103, 73, this.eval_fig.pg046);doc.text(110, 73, "48= ");doc.text(123, 73, this.eval_fig.pg048);
               doc.line(10, 74, 130, 74);
          },

          ejeSinContestar: function ejeSinContestar() {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg002 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg003 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg004 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg005 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }

               return this.ejeSinResponder;
          },
          sinContestar: function sinContestar() {

               this.pregSinContestar = 0;
               // console.log("===============");
               // console.log("pg1 ? ", this.eval_fig.pg001, ", largo ?", this.eval_fig.pg001.length)
               if (this.eval_fig.pg001 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               // console.log("sin contestar ? ", this.pregSinContestar)
               if (this.eval_fig.pg002 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg003 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg004 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg005 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg006 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg007 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg008 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg009 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg010 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg011 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg012 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg013 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg014 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg015 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg016 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg017 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg018 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg019 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg020 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg021 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg022 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg023 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg024 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg025 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               if (this.eval_fig.pg026 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg027 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg028 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg029 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg030 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg031 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg032 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg033 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg034 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg035 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg036 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg037 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg038 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg039 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg040 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               if (this.eval_fig.pg041 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg042 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg043 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg044 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg045 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg046 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg047 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_fig.pg048 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               return this.pregSinContestar;
          },
          addADayToMyDate: function addADayToMyDate() {
               if (this.eval_fecha) // as myDate can be null
                    // you have to set the this.myDate again, so vue can detect it changed
                    // this is not a caveat of this specific solution, but of any binding of dates
                    this.eval_fig.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
          },
          dateToYYYYMMDD: function dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0];
          },
          cargaHora: function cargaHora() {

               // Convierte la hora obtenida a hora local (utc)
               this.eval_fecha = new Date();
               var d = this.eval_fecha;
               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               var localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion: function cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_fig = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev05; // Crea el nodo para todos los campos.
               this.res_fig = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs05;
               console.log("eva ? ", this.eval_fig);
               console.log("res ? ", this.res_fig);

               this.eval_fig.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
               this.eval_fig.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_fig.depto = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_depto; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_fig.sexo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_sexo; // Nombre de la empresa a la cual pertenece el usuario

               this.instrucciones = this.eval_fig.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de PERFIL DE PERSONALIDAD.";

               this.eval_fecha = new Date(); // Fecha del Día
          },
          empezarEvaluacion: function empezarEvaluacion() {

               this.eval_fig.empezo = this.cargaHora();
               this.inicioeval = true;
          },

          /** .................... VALIDACIONES  .................... */
          validarValor: function validarValor(valor) {
               var lvalor = valor;
               if (valor < 1 || valor > 2) {
                    lvalor = 0;
               }
               // console.log("validarValor, lvalor ? ",lvalor);
               return lvalor;
          },
          limpiarEvaluacion: function limpiarEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_fig = {
                    depto: "",
                    empresa: "", nombre: "",
                    fecha: "",
                    empezo: "", termino: "",
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                    pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                    pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
                    pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
                    pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0

                    /* Variables para un nuevo caso */
               };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.eval_fig = this.eval_fig;
          },

          /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          /* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion: function agregarEvaluacion() {
               var _this = this;

               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ");
                    return;
               }

               this.finalizoeval = true;
               this.eval_fig.termino = this.cargaHora();

               this.eval_fecha = new Date();

               var ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               var lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de PERFIL DE PERSONALIDAD para " + this.eval_fig.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvaluaciones = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalPerfil;
                    dbEvaluaciones.push({

                         empresa: this.eval_fig.empresa, nombre: this.eval_fig.nombre,
                         empezo: this.eval_fig.empezo, termino: this.eval_fig.termino,
                         fecha: lingreso, depto: this.eval_fig.depto, sexo: this.eval_fig.sexo,
                         pg001: this.eval_fig.pg001, pg002: this.eval_fig.pg002, pg003: this.eval_fig.pg003, pg004: this.eval_fig.pg004, pg005: this.eval_fig.pg005,
                         pg006: this.eval_fig.pg006, pg007: this.eval_fig.pg007, pg008: this.eval_fig.pg008, pg009: this.eval_fig.pg009, pg010: this.eval_fig.pg010,
                         pg011: this.eval_fig.pg011, pg012: this.eval_fig.pg012, pg013: this.eval_fig.pg013, pg014: this.eval_fig.pg014, pg015: this.eval_fig.pg015,
                         pg016: this.eval_fig.pg016, pg017: this.eval_fig.pg017, pg018: this.eval_fig.pg018, pg019: this.eval_fig.pg019, pg020: this.eval_fig.pg020,
                         pg021: this.eval_fig.pg021, pg022: this.eval_fig.pg022, pg023: this.eval_fig.pg023, pg024: this.eval_fig.pg024, pg025: this.eval_fig.pg025,
                         pg026: this.eval_fig.pg026, pg027: this.eval_fig.pg027, pg028: this.eval_fig.pg028, pg029: this.eval_fig.pg029, pg030: this.eval_fig.pg030,
                         pg031: this.eval_fig.pg031, pg032: this.eval_fig.pg032, pg033: this.eval_fig.pg033, pg034: this.eval_fig.pg034, pg035: this.eval_fig.pg035,
                         pg036: this.eval_fig.pg036, pg037: this.eval_fig.pg037, pg038: this.eval_fig.pg038, pg039: this.eval_fig.pg039, pg040: this.eval_fig.pg040,
                         pg041: this.eval_fig.pg041, pg042: this.eval_fig.pg042, pg043: this.eval_fig.pg043, pg044: this.eval_fig.pg044, pg045: this.eval_fig.pg045,
                         pg046: this.eval_fig.pg046, pg047: this.eval_fig.pg047, pg048: this.eval_fig.pg048
                    }).then(function (data) {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         _this.limpiarEvaluacion();

                         var laClave = data.key;
                         _this.grabado = true;
                         _this.inicioeval = false;

                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de PERFIL DE PERSONALIDAD guardado con éxito.");
                    });
               } // if (confirma)
          },
          // agregarEncuesta()

          //? =================================================================================
          enfoqueG1: function enfoqueG1(pestana) {
               var _this2 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         //* Vengo de 1, voy a 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt2.focus();
                         });

                         this.activott1 = "!active";
                         this.activott2 = "active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         break;
                    case 3:
                         //* Vengo de 2, voy a 3
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt3.focus();
                         });
                         this.activott2 = "!active";
                         this.activott3 = "active";

                         this.vertt2 = false;
                         this.vertt3 = true;
                         break;
                    case 4:
                         //* Vengo de 3, voy a 4
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt4.focus();
                         });
                         this.activott3 = "!active";
                         this.activott4 = "active";

                         this.vertt3 = false;
                         this.vertt4 = true;
                         break;
                    case 0:
                         //* Vengo de 4, voy a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt1.focus();
                         });
                         this.activott4 = "!active";
                         this.activott1 = "active";

                         this.vertt4 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },
          nadaG1: function nadaG1(pestana) {
               var _this3 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt1.focus();
                         });

                         this.activott1 = "active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";

                         this.vertt1 = true;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = false;

                         break;
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt2.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         this.vertt3 = false;
                         this.vertt4 = false;

                         break;
                    case 3:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt3.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "active";
                         this.activott4 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = true;
                         this.vertt4 = false;

                         break;
                    case 4:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt4.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = true;

                         break;
                    default:
                    // code block
               } //* switch
          },
          enfoqueRG1: function enfoqueRG1(pestana) {
               var _this4 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 3:
                         //* Estoy en 4 regreso a 3
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt3.focus();
                         });

                         this.activott4 = "!active";
                         this.activott3 = "active";

                         this.vertt4 = false;
                         this.vertt3 = true;
                         break;
                    case 2:
                         //* Estoy en 3 regreso a 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt2.focus();
                         });

                         this.activott3 = "!active";
                         this.activott2 = "active";

                         this.vertt3 = false;
                         this.vertt2 = true;
                         break;
                    case 1:
                         //* Estoy en 2 regreso a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt1.focus();
                         });
                         this.activott2 = "!active";
                         this.activott1 = "active";

                         this.vertt2 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          }
     } // methods
     // export

});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *      ev06_moss.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
               name: 'supervision',
               components: {
                              'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
                              'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
               },
               template: '#formanpf',
               data: function data() {
                              return {
                                             ejemplo: {},
                                             eval_moss: {}, res: {},
                                             modo: "",
                                             eval_fecha: new Date(),
                                             instrucciones: "",
                                             inicioeval: false, finalizoeval: false, grabado: false,
                                             pregSinContestar: 0, ejeSinResponder: 0,

                                             //? .....................................................................................................................................................................................................................
                                             activott1: "active", activott2: '!active',
                                             vertt1: true, vertt2: false // return
                              };
               },
               // data()
               mounted: function mounted() {

                              /** Definiciones para el uso de los slides y tooltips */
                              var elems = document.querySelectorAll('.collapsible');
                              var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

                              var elems = document.querySelectorAll('.tooltipped');
                              var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

                              var elem = document.querySelectorAll('.tabs');
                              var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

                              /** obtiene localmente el caso definido en el almacén (store) */
                              this.cargaEvaluacion();
               },

               computed: {
                              l_sinResponder: function l_sinResponder() {
                                             return this.sinContestar();
                              },
                              l_ejeSinResponder: function l_ejeSinResponder() {
                                             return this.ejeSinContestar();
                              }
               },
               methods: {
                              crearPDF: function crearPDF() {

                                             /** CREACION DEL ARCHIVO PDF */
                                             var cadena = this.eval_moss.nombre,
                                                 patron = / /g,
                                                 nuevoValor = "",
                                                 nusuario = cadena.replace(patron, nuevoValor);

                                             var nArchivo = "moss_" + nusuario;
                                             console.log("archivo a crear ? ", nArchivo);

                                             var imagen = "data:image/jpeg;base64,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";
                                             var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
                                             var linea = 5;

                                             /** Muestra el logo.        (izq, top, ancho, alto) */
                                             doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
                                             /** fila, columna */

                                             /** CIRCULOS  */
                                             doc.setLineWidth(1); // Grosor de la línea del borde
                                             doc.setDrawColor(0);

                                             /** ................................................................................................................ 
                                             /* TEXTO INTRODUCTORIO */
                                             var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

                                             var lhoy = new Date();
                                             //lhoy=   lhoy.toString();
                                             var ldia = lhoy.getDate();
                                             var lmes = meses[lhoy.getMonth()];
                                             var lanio = lhoy.getFullYear();

                                             // console.log("lhoy ? ",lhoy);
                                             // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
                                             doc.setFontSize(9);
                                             doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
                                             doc.text(10, 30, "Evaluación de SUPERVISION para " + this.eval_moss.nombre + " de " + this.eval_moss.empresa + " ( " + this.eval_moss.depto + " )");

                                             this.respuestas(doc);
                                             this.resultados(doc);

                                             doc.save(nArchivo);
                                             doc.autoPrint();
                                             window.open(doc.output('bloburl'), '_blank');
                              },
                              rangosmoss: function rangosmoss() {

                                             /* ================================================================================= */
                                             /* Conteo para HR */
                                             if (this.eval_moss.pg001 === "c") {
                                                            this.res_moss.hr = this.res_moss.hr + 1;
                                             }
                                             if (this.eval_moss.pg010 === "c") {
                                                            this.res_moss.hr = this.res_moss.hr + 1;
                                             }
                                             if (this.eval_moss.pg011 === "a") {
                                                            this.res_moss.hr = this.res_moss.hr + 1;
                                             }
                                             if (this.eval_moss.pg013 === "d") {
                                                            this.res_moss.hr = this.res_moss.hr + 1;
                                             }
                                             if (this.eval_moss.pg025 === "b") {
                                                            this.res_moss.hr = this.res_moss.hr + 1;
                                             }

                                             /* ================================================================================= */
                                             /* Conteo para HS */
                                             if (this.eval_moss.pg002 === "b") {
                                                            this.res_moss.hs = this.res_moss.hs + 1;
                                             }
                                             if (this.eval_moss.pg003 === "d") {
                                                            this.res_moss.hs = this.res_moss.hs + 1;
                                             }
                                             if (this.eval_moss.pg016 === "d") {
                                                            this.res_moss.hs = this.res_moss.hs + 1;
                                             }
                                             if (this.eval_moss.pg018 === "d") {
                                                            this.res_moss.hs = this.res_moss.hs + 1;
                                             }
                                             if (this.eval_moss.pg024 === "d") {
                                                            this.res_moss.hs = this.res_moss.hs + 1;
                                             }
                                             if (this.eval_moss.pg030 === "a") {
                                                            this.res_moss.hs = this.res_moss.hs + 1;
                                             }

                                             /* ================================================================================= */
                                             /* Conteo para CD */
                                             if (this.eval_moss.pg004 === "b") {
                                                            this.res_moss.cd = this.res_moss.cd + 1;
                                             }
                                             if (this.eval_moss.pg006 === "b") {
                                                            this.res_moss.cd = this.res_moss.cd + 1;
                                             }
                                             if (this.eval_moss.pg020 === "b") {
                                                            this.res_moss.cd = this.res_moss.cd + 1;
                                             }
                                             if (this.eval_moss.pg023 === "a") {
                                                            this.res_moss.cd = this.res_moss.cd + 1;
                                             }
                                             if (this.eval_moss.pg029 === "c") {
                                                            this.res_moss.cd = this.res_moss.cd + 1;
                                             }

                                             /* ================================================================================= */
                                             /* Conteo para SC */
                                             if (this.eval_moss.pg005 === "b") {
                                                            this.res_moss.sc = this.res_moss.sc + 1;
                                             }
                                             if (this.eval_moss.pg008 === "b") {
                                                            this.res_moss.sc = this.res_moss.sc + 1;
                                             }
                                             if (this.eval_moss.pg015 === "d") {
                                                            this.res_moss.sc = this.res_moss.sc + 1;
                                             }
                                             if (this.eval_moss.pg017 === "b") {
                                                            this.res_moss.sc = this.res_moss.sc + 1;
                                             }
                                             if (this.eval_moss.pg022 === "a") {
                                                            this.res_moss.sc = this.res_moss.sc + 1;
                                             }
                                             if (this.eval_moss.pg028 === "c") {
                                                            this.res_moss.sc = this.res_moss.sc + 1;
                                             }

                                             /* ================================================================================= */
                                             /* Conteo para CE */
                                             if (this.eval_moss.pg007 === "b") {
                                                            this.res_moss.ce = this.res_moss.ce + 1;
                                             }
                                             if (this.eval_moss.pg009 === "c") {
                                                            this.res_moss.ce = this.res_moss.ce + 1;
                                             }
                                             if (this.eval_moss.pg012 === "c") {
                                                            this.res_moss.ce = this.res_moss.ce + 1;
                                             }
                                             if (this.eval_moss.pg014 === "d") {
                                                            this.res_moss.ce = this.res_moss.ce + 1;
                                             }
                                             if (this.eval_moss.pg019 === "c") {
                                                            this.res_moss.ce = this.res_moss.ce + 1;
                                             }
                                             if (this.eval_moss.pg021 === "a") {
                                                            this.res_moss.ce = this.res_moss.ce + 1;
                                             }
                                             if (this.eval_moss.pg026 === "c") {
                                                            this.res_moss.ce = this.res_moss.ce + 1;
                                             }
                                             if (this.eval_moss.pg027 === "a") {
                                                            this.res_moss.ce = this.res_moss.ce + 1;
                                             }
                                             /* ================================================================================= */

                                             /* ================================================================================= */
                                             /* Conteo de todos los aciertos */
                                             this.res_moss.aciertos = 0;
                                             this.res_moss.aciertos = this.res_moss.hs + this.res_moss.cd + this.res_moss.ce + this.res_moss.hr + this.res_moss.sc;

                                             /* Busca el rango que le corresponde */
                                             this.res_moss.rangosHS = '';
                                             var comp1 = this.res_moss.aciertos >= 0 && this.res_moss.aciertos <= 8;if (comp1 === true) {
                                                            this.res_moss.rangosHS = 'INFERIOR';
                                             }
                                             var comp2 = this.res_moss.aciertos >= 9 && this.res_moss.aciertos <= 11;if (comp2 === true) {
                                                            this.res_moss.rangosHS = 'POBRE';
                                             }
                                             var comp3 = this.res_moss.aciertos >= 12 && this.res_moss.aciertos <= 18;if (comp3 === true) {
                                                            this.res_moss.rangosHS = 'MEDIO';
                                             }
                                             var comp4 = this.res_moss.aciertos >= 19 && this.res_moss.aciertos <= 23;if (comp4 === true) {
                                                            this.res_moss.rangosHS = 'BUENO';
                                             }
                                             var comp5 = this.res_moss.aciertos >= 24 && this.res_moss.aciertos <= 30;if (comp5 === true) {
                                                            this.res_moss.rangosHS = 'SUPERIOR';
                                             }
                              },
                              // rangos()

                              resultados: function resultados(doc) {

                                             this.res_moss = {
                                                            hs: 0, cd: 0, ce: 0, hr: 0, sc: 0,
                                                            aciertos: 0,
                                                            percentilHS: 0, rangoHS: ""
                                             };

                                             this.rangosmoss();

                                             doc.setLineWidth(0.25);

                                             doc.text(10, 88, "SECCION DE RESULTADOS ");
                                             doc.line(10, 89, 206, 89);

                                             var aciertos = this.res_moss.aciertos;
                                             var rangosHS = this.res_moss.rangosHS;
                                             var hs = this.res_moss.hs;
                                             var cd = this.res_moss.cd;
                                             var ce = this.res_moss.ce;
                                             var hr = this.res_moss.hr;
                                             var sc = this.res_moss.sc;

                                             doc.text(20, 94, "Pc.");doc.text(30, 94, "RESULTADOS");doc.text(63, 94, "RANGO");
                                             doc.text(20, 96, "-------");doc.text(30, 96, "--------------------");doc.text(60, 96, "-------------------");
                                             doc.text(10, 100, "[HS]");
                                             doc.text(22, 100, hs.toString());doc.text(35, 100, aciertos.toString());doc.text(62, 100, rangosHS);

                                             doc.text(10, 105, "[CD]");
                                             doc.text(22, 105, cd.toString());

                                             doc.text(10, 110, "[CE]");
                                             doc.text(22, 110, ce.toString());

                                             doc.text(10, 115, "[HR]");
                                             doc.text(22, 115, hr.toString());

                                             doc.text(10, 120, "[SC]");
                                             doc.text(22, 120, sc.toString());
                                             doc.text(20, 122, "-------");doc.text(30, 122, "--------------------");doc.text(60, 122, "-------------------");
                                             var desaciertos = 30 - aciertos;
                                             doc.text(10, 127, "Aciertos ? ");
                                             doc.text(25, 127, aciertos.toString());
                                             doc.text(32, 127, "No Aciertos ? ");
                                             doc.text(52, 127, desaciertos.toString());
                              },
                              respuestas: function respuestas(doc) {
                                             /* Muestra las preguntas */
                                             /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
                                             doc.setLineWidth(0.25);

                                             doc.text(10, 40, "SECCION DE RESPUESTAS ");
                                             doc.line(10, 42, 190, 42);
                                             doc.text(10, 45, "01= ");doc.text(23, 45, this.eval_moss.pg001);doc.text(30, 45, "02= ");doc.text(43, 45, this.eval_moss.pg002);
                                             doc.text(50, 45, "03= ");doc.text(63, 45, this.eval_moss.pg003);doc.text(70, 45, "04= ");doc.text(83, 45, this.eval_moss.pg004);
                                             doc.text(90, 45, "05= ");doc.text(103, 45, this.eval_moss.pg005);doc.text(110, 45, "06= ");doc.text(123, 45, this.eval_moss.pg006);
                                             doc.text(130, 45, "07= ");doc.text(143, 45, this.eval_moss.pg007);doc.text(150, 45, "08= ");doc.text(163, 45, this.eval_moss.pg008);
                                             doc.text(170, 45, "09= ");doc.text(183, 45, this.eval_moss.pg009);
                                             doc.line(10, 46, 190, 46);
                                             doc.text(10, 49, "10= ");doc.text(23, 49, this.eval_moss.pg010);doc.text(30, 49, "11= ");doc.text(43, 49, this.eval_moss.pg011);
                                             doc.text(50, 49, "12= ");doc.text(63, 49, this.eval_moss.pg012);doc.text(70, 49, "13= ");doc.text(83, 49, this.eval_moss.pg013);
                                             doc.text(90, 49, "14= ");doc.text(103, 49, this.eval_moss.pg014);doc.text(110, 49, "15= ");doc.text(123, 49, this.eval_moss.pg015);
                                             doc.text(130, 49, "16= ");doc.text(143, 49, this.eval_moss.pg016);doc.text(150, 49, "17= ");doc.text(163, 49, this.eval_moss.pg017);
                                             doc.text(170, 49, "18= ");doc.text(183, 49, this.eval_moss.pg018);
                                             doc.line(10, 50, 190, 50);
                                             doc.text(10, 53, "19= ");doc.text(23, 53, this.eval_moss.pg019);doc.text(30, 53, "20= ");doc.text(43, 53, this.eval_moss.pg020);
                                             doc.text(50, 53, "21= ");doc.text(63, 53, this.eval_moss.pg021);doc.text(70, 53, "22= ");doc.text(83, 53, this.eval_moss.pg022);
                                             doc.text(90, 53, "23= ");doc.text(103, 53, this.eval_moss.pg023);doc.text(110, 53, "24= ");doc.text(123, 53, this.eval_moss.pg024);
                                             doc.text(130, 53, "25= ");doc.text(143, 53, this.eval_moss.pg025);doc.text(150, 53, "26= ");doc.text(163, 53, this.eval_moss.pg026);
                                             doc.text(170, 53, "27= ");doc.text(183, 53, this.eval_moss.pg027);
                                             doc.line(10, 54, 190, 54);
                                             doc.text(10, 57, "28= ");doc.text(23, 57, this.eval_moss.pg028);doc.text(30, 57, "29= ");doc.text(43, 57, this.eval_moss.pg029);
                                             doc.text(50, 57, "30= ");doc.text(63, 57, this.eval_moss.pg030);
                                             doc.line(10, 59, 65, 59);
                              },

                              ejeSinContestar: function ejeSinContestar() {

                                             this.ejeSinResponder = 0;
                                             console.log("1 ? ", this.ejemplo.pg001);
                                             if (this.ejemplo.pg001 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }
                                             if (this.ejemplo.pg002 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }
                                             if (this.ejemplo.pg003 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }
                                             if (this.ejemplo.pg004 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }
                                             if (this.ejemplo.pg005 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }

                                             return this.ejeSinResponder;
                              },
                              sinContestar: function sinContestar() {

                                             this.pregSinContestar = 0;

                                             if (this.eval_moss.pg001 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg002 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg003 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg004 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg005 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg006 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg007 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg008 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg009 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg010 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg011 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg012 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg013 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg014 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg015 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg016 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg017 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg018 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg019 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg020 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg021 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg022 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg023 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg024 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg025 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }

                                             if (this.eval_moss.pg026 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg027 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg028 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg029 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_moss.pg030 === "") {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }

                                             return this.pregSinContestar;
                              },
                              addADayToMyDate: function addADayToMyDate() {
                                             if (this.eval_fecha) // as myDate can be null
                                                            // you have to set the this.myDate again, so vue can detect it changed
                                                            // this is not a caveat of this specific solution, but of any binding of dates
                                                            this.eval_moss.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
                              },
                              dateToYYYYMMDD: function dateToYYYYMMDD(date) {
                                             console.log("***********************************************************************************");
                                             console.log("Estoy en dateToYYYYMMDD ");
                                             console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
                                             console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
                                             console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

                                             console.log("Desmenuzando ...");
                                             var a = date.toISOString();
                                             var b = a.split("T");
                                             var c = b[0];
                                             var d = b[1];
                                             console.log("a) date.toISOString() ", date.toISOString());
                                             console.log("b) ", a.split("T"));
                                             console.log("c) b[0]", b[0], "; b[1] ", b[1]);
                                             console.log("***********************************************************************************");

                                             // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
                                             return date && date.toISOString().split('T')[0];
                              },
                              cargaHora: function cargaHora() {

                                             // Convierte la hora obtenida a hora local (utc)
                                             this.eval_fecha = new Date();
                                             var d = this.eval_fecha;
                                             var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

                                             // obtain local UTC offset and convert to msec
                                             var localOffset = d.getTimezoneOffset() * 60000;
                                             var newdate = new Date(utcd + localOffset);
                                             var hours = newdate.getHours();
                                             var minutes = newdate.getMinutes();
                                             var seconds = newdate.getSeconds();
                                             var hora = hours + ":" + minutes + ":" + seconds;
                                             console.log("newdate ? ", newdate, " | ", hora);

                                             return hora;
                              },
                              cargaEvaluacion: function cargaEvaluacion() {

                                             this.ejemplo = {
                                                            pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
                                             };

                                             this.eval_moss = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev06; // Crea el nodo para todos los campos.
                                             this.res_moss = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs06;
                                             console.log("res ? ", this.res_16pf);

                                             this.eval_moss.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
                                             this.eval_moss.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
                                             this.eval_moss.depto = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_depto; // Nombre de la empresa a la cual pertenece el usuario
                                             this.eval_moss.sexo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_sexo; // Nombre de la empresa a la cual pertenece el usuario

                                             this.instrucciones = this.eval_moss.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de SUPERVISION.";

                                             this.eval_fecha = new Date(); // Fecha del Día
                              },
                              empezarEvaluacion: function empezarEvaluacion() {

                                             this.eval_moss.empezo = this.cargaHora();
                                             this.inicioeval = true;
                              },

                              /** .................... VALIDACIONES  .................... */
                              validarValor: function validarValor(valor) {
                                             var lvalor = valor;
                                             if (valor < 1 || valor > 2) {
                                                            lvalor = 0;
                                             }
                                             // console.log("validarValor, lvalor ? ",lvalor);
                                             return lvalor;
                              },
                              limpiarEvaluacion: function limpiarEvaluacion() {

                                             this.ejemplo = {
                                                            pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
                                             };

                                             this.eval_moss = {
                                                            depto: "",
                                                            empresa: "", nombre: "",
                                                            fecha: "",
                                                            empezo: "", termino: "",
                                                            pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                                                            pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                                                            pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0

                                                            /* Variables para un nuevo caso */
                                             };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.eval_moss = this.eval_moss;
                              },

                              /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
                              /* Acciones del Floatting Button: Agregar Encuesta */
                              agregarEvaluacion: function agregarEvaluacion() {
                                             var _this = this;

                                             if (this.pregSinContestar > 0) {
                                                            alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ");
                                                            return;
                                             }

                                             this.finalizoeval = true;
                                             this.eval_moss.termino = this.cargaHora();

                                             this.eval_fecha = new Date();

                                             var ldia = this.eval_fecha.getDate();
                                             if (ldia <= 9) {
                                                            ldia = '0' + ldia.toString().trim();
                                             } else {
                                                            ldia = ldia.toString().trim();
                                             }
                                             var lmes = this.eval_fecha.getMonth() + 1;
                                             if (lmes <= 9) {
                                                            lmes = '0' + lmes.toString().trim();
                                             } else {
                                                            lmes = lmes.toString().trim();
                                             }
                                             console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
                                             var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

                                             console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
                                             console.log("** fecha de ingreso ? ", this.eval_fecha);
                                             console.log("** formato  ingreso ? ", lingreso);

                                             var confirma = confirm("Seguro de grabar la evaluación de SUPERVISION para " + this.eval_moss.nombre.toUpperCase().trim() + " ?");
                                             if (confirma === true) {

                                                            /* Agrega una colección al objeto */
                                                            var dbEvaluaciones = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalSuperv;
                                                            dbEvaluaciones.push({

                                                                           empresa: this.eval_moss.empresa, nombre: this.eval_moss.nombre,
                                                                           empezo: this.eval_moss.empezo, termino: this.eval_moss.termino,
                                                                           fecha: lingreso, depto: this.eval_moss.depto, sexo: this.eval_moss.sexo,
                                                                           pg001: this.eval_moss.pg001, pg002: this.eval_moss.pg002, pg003: this.eval_moss.pg003, pg004: this.eval_moss.pg004, pg005: this.eval_moss.pg005,
                                                                           pg006: this.eval_moss.pg006, pg007: this.eval_moss.pg007, pg008: this.eval_moss.pg008, pg009: this.eval_moss.pg009, pg010: this.eval_moss.pg010,
                                                                           pg011: this.eval_moss.pg011, pg012: this.eval_moss.pg012, pg013: this.eval_moss.pg013, pg014: this.eval_moss.pg014, pg015: this.eval_moss.pg015,
                                                                           pg016: this.eval_moss.pg016, pg017: this.eval_moss.pg017, pg018: this.eval_moss.pg018, pg019: this.eval_moss.pg019, pg020: this.eval_moss.pg020,
                                                                           pg021: this.eval_moss.pg021, pg022: this.eval_moss.pg022, pg023: this.eval_moss.pg023, pg024: this.eval_moss.pg024, pg025: this.eval_moss.pg025,
                                                                           pg026: this.eval_moss.pg026, pg027: this.eval_moss.pg027, pg028: this.eval_moss.pg028, pg029: this.eval_moss.pg029, pg030: this.eval_moss.pg030
                                                            }).then(function (data) {

                                                                           /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                                                                           _this.limpiarEvaluacion();

                                                                           var laClave = data.key;
                                                                           _this.grabado = true;
                                                                           _this.inicioeval = false;

                                                                           // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                                                                           alert("Evaluación de SUPERVISION guardado con éxito.");
                                                            });
                                             } // if (confirma)
                              },
                              // agregarEncuesta()

                              //? =================================================================================
                              enfoqueG1: function enfoqueG1(pestana) {
                                             var _this2 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {
                                                            case 2:
                                                                           //* Vengo de 1, voy a 2
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt2.focus();
                                                                           });

                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = true;
                                                                           break;
                                                            case 0:
                                                                           //* Vengo de 2, voy a 1
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt1.focus();
                                                                           });
                                                                           this.activott2 = "!active";
                                                                           this.activott1 = "active";

                                                                           this.vertt2 = false;
                                                                           this.vertt1 = true;
                                                                           break;
                                                            default:
                                                            // code block
                                             } //* switch
                              },
                              nadaG1: function nadaG1(pestana) {
                                             var _this3 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {
                                                            case 1:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt1.focus();
                                                                           });

                                                                           this.activott1 = "active";
                                                                           this.activott2 = "!active";

                                                                           this.vertt1 = true;
                                                                           this.vertt2 = false;

                                                                           break;
                                                            case 2:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt2.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = true;

                                                                           break;
                                                            default:
                                                            // code block
                                             } //* switch
                              },
                              enfoqueRG1: function enfoqueRG1(pestana) {
                                             var _this4 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {
                                                            case 1:
                                                                           //* Estoy en 2 regreso a 1
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt1.focus();
                                                                           });
                                                                           this.activott2 = "!active";
                                                                           this.activott1 = "active";

                                                                           this.vertt2 = false;
                                                                           this.vertt1 = true;
                                                                           break;
                                                            default:
                                                            // code block
                                             } //* switch
                              }
               } // methods
               // export

});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *      ev07_tav.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
     name: 'aptitud',
     components: {
          'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
          'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
     },
     template: '#formanpf',
     data: function data() {
          return {
               ejemplo: {},
               eval_tav: {}, res: {},
               modo: "",
               eval_fecha: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,

               //? .....................................................................................................................................................................................................................
               activott1: "active", activott2: '!active',
               vertt1: true, vertt2: false // return
          };
     },
     // data()
     mounted: function mounted() {

          var elems = document.querySelectorAll('.collapsible');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();
     },

     computed: {
          l_sinResponder: function l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder: function l_ejeSinResponder() {
               return this.ejeSinContestar();
          }
     },
     methods: {
          crearPDF: function crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_tav.nombre,
                   patron = / /g,
                   nuevoValor = "",
                   nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "tav_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1); // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de APTITUD EN VENTAS para " + this.eval_tav.nombre + " de " + this.eval_tav.empresa + " ( " + this.eval_tav.depto + " )");

               this.respuestas(doc);
               this.resultados(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangostav: function rangostav() {

               /* ============================================================================================= */
               /* Pregunta 1 */
               if (this.eval_tav.pg001 === 'a') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg001 === 'c') {
                         this.res_tav.errores = this.res_tav.errores + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 2 */
               if (this.eval_tav.pg002 === 'd') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 3 */
               if (this.eval_tav.pg003 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 1;
               } else {
                    if (this.eval_tav.pg003 === 'b') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    } else {
                         if (this.eval_tav.pg003 === 'd') {
                              this.res_tav.aciertos = this.res_tav.aciertos + 2;
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 4 */
               if (this.eval_tav.pg004 === 'a') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg004 === 'c') {
                         this.res_tav.errores = this.res_tav.errores + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 5 */
               if (this.eval_tav.pg005 === 'b') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 6 */
               /*  NO TIENE PONDERACION */

               /* ============================================================================================= */
               /* Pregunta 7 */
               if (this.eval_tav.pg007 === 'b') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg007 === 'd') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 8 */
               if (this.eval_tav.pg008 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg008 === 'b') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    } else {
                         if (this.eval_tav.pg008 === 'c') {
                              this.res_tav.aciertos = this.res_tav.aciertos + 1;
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 9 */
               if (this.eval_tav.pg009 === 'b') {

                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg009 === 'd') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 10 */
               if (this.eval_tav.pg010 === 'a') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg010 === 'b') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    } else {
                         if (this.eval_tav.pg010 === 'c') {
                              this.res_tav.errores = this.res_tav.errores + 2;
                         } else {
                              if (this.eval_tav.pg010 === 'd') {
                                   this.res_tav.aciertos = this.res_tav.aciertos + 2;
                              }
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 11 */
               if (this.eval_tav.pg011 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg011 === 'b') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 12 */
               if (this.eval_tav.pg012 === 'b') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 13 */
               /*  NO TIENE PONDERACION */

               /* ============================================================================================= */
               /* Pregunta 14 */
               if (this.eval_tav.pg014 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 1;
               } else {
                    if (this.eval_tav.pg014 === 'c') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 15 */
               if (this.eval_tav.pg015 === 'b') {
                    this.res_tav.errores = this.res_tav.errores + 1;
               }
               /* ============================================================================================= */
               /* Pregunta 16 */
               if (this.eval_tav.pg016 === 'b') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 17 */
               if (this.eval_tav.pg017 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 1;
               } else {
                    if (this.eval_tav.pg017 === 'b') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 18 */
               if (this.eval_tav.pg018 === 'c') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 19 */
               if (this.eval_tav.pg019 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg019 === 'd') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 20 */
               if (this.eval_tav.pg020 === 'a') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 2;
               } else {
                    if (this.eval_tav.pg020 === 'd') {
                         this.res_tav.errores = this.res_tav.errores + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 21 */
               if (this.eval_tav.pg021 === 'b') {

                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg021 === 'c') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 22 */
               if (this.eval_tav.pg022 === 'c') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg022 === 'd') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 23 */
               if (this.eval_tav.pg023 === 'b') {
                    this.res_tav.errores = this.res_tav.errores + 1;
               } else {
                    if (this.eval_tav.pg023 === 'c') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 24 */
               /*  NO TIENE PONDERACION */

               /* ============================================================================================= */
               /* Pregunta 25 */
               if (this.eval_tav.pg025 === 'b') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg025 === 'c') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    } else {
                         if (this.eval_tav.pg025 === 'd') {
                              this.res_tav.errores = this.res_tav.errores + 2;
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 26 */
               if (this.eval_tav.pg026 === 'b') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg026 === 'c') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 27 */
               if (this.eval_tav.pg027 === 'd') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 28 */
               if (this.eval_tav.pg028 === 'a') {

                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg028 === 'b') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    } else {
                         if (this.eval_tav.pg028 === 'c') {
                              this.res_tav.aciertos = this.res_tav.aciertos + 1;
                         } else {
                              if (this.eval_tav.pg028 === 'd') {
                                   this.res_tav.errores = this.res_tav.errores + 1;
                              }
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 29 */
               if (this.eval_tav.pg029 === 'b') {

                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg029 === 'c') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    } else {
                         if (this.eval_tav.pg029 === 'd') {
                              this.res_tav.errores = this.res_tav.errores + 1;
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 30 */
               if (this.eval_tav.pg030 === 'b') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg030 === 'c') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    }
               }

               this.res_tav.resta = this.res_tav.aciertos - this.res_tav.errores;

               this.res_tav.rango = '';
               var comp1 = false;
               if (this.eval_tav.sexo === "M") {

                    comp1 = this.res_tav.resta >= 1 && this.res_tav.resta <= 12;if (comp1 === true) {
                         this.res_tav.rango = "Bajo";
                    }
                    comp1 = this.res_tav.resta >= 13 && this.res_tav.resta <= 15;if (comp1 === true) {
                         this.res_tav.rango = "Medio";
                    }
                    comp1 = this.res_tav.resta >= 16 && this.res_tav.resta <= 18;if (comp1 === true) {
                         this.res_tav.rango = "Bueno";
                    }
                    comp1 = this.res_tav.resta >= 19 && this.res_tav.resta <= 20;if (comp1 === true) {
                         this.res_tav.rango = "Muy Bueno";
                    }
                    comp1 = this.res_tav.resta >= 21 && this.res_tav.resta <= 34;if (comp1 === true) {
                         this.res_tav.rango = "Superior";
                    }
               } else {
                    comp1 = this.res_tav.resta >= -4 && this.res_tav.resta <= 9;if (comp1 === true) {
                         this.res_tav.rango = "Bajo";
                    }
                    comp1 = this.res_tav.resta >= 10 && this.res_tav.resta <= 13;if (comp1 === true) {
                         this.res_tav.rango = "Medio";
                    }
                    comp1 = this.res_tav.resta >= 14 && this.res_tav.resta <= 15;if (comp1 === true) {
                         this.res_tav.rango = "Bueno";
                    }
                    comp1 = this.res_tav.resta >= 16 && this.res_tav.resta <= 17;if (comp1 === true) {
                         this.res_tav.rango = "Muy Bueno";
                    }
                    comp1 = this.res_tav.resta >= 18 && this.res_tav.resta <= 20;if (comp1 === true) {
                         this.res_tav.rango = "Superior";
                    }
               }

               this.res_tav.genero = "NA";
               switch (this.eval_tav.sexo) {
                    case 'M':
                         this.res_tav.genero = 'MASCULINO';
                         break;
                    case 'F':
                         this.res_tav.genero = 'FEMENINO';
                         break;
               }
          },
          // rangos()

          resultados: function resultados(doc) {

               this.res_tav = {
                    rango: 0, resta: 0,
                    aciertos: 0, errores: 0,
                    genero: ""
               };

               this.rangostav();

               doc.setLineWidth(0.25);

               doc.text(10, 80, "SECCION DE RESULTADOS ");
               doc.line(10, 83, 206, 83);

               console.log("*-*-*-*-*-*-*-*-*-*-*- RESULTADOS *-*-*-*-*-*-*-*-*-*-*-");
               console.log("aciertos ? ", this.res_tav.aciertos, "; errores ? ", this.res_tav.errores);

               // let dif = this.res_tav.aciertos - this.res_tav.errores;
               var aciertos = this.res_tav.aciertos;
               var errores = this.res_tav.errores;
               var resta = this.res_tav.resta;
               var rango = this.res_tav.rango;
               var genero = this.res_tav.genero;
               doc.text(10, 90, "[ aciertos : ");doc.text(30, 90, aciertos.toString());doc.text(50, 90, " ]");
               doc.text(10, 94, "[ errores : ");doc.text(30, 94, errores.toString());doc.text(50, 94, " ]");
               doc.text(10, 98, "[ diferencia : ");doc.text(30, 98, resta.toString());doc.text(50, 98, " ]");
               doc.text(10, 104, "[ rango : ");doc.text(30, 104, rango);doc.text(50, 104, " ]");
               doc.text(25, 108, genero);
          },
          respuestas: function respuestas(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ");
               doc.line(10, 42, 190, 42);
               doc.text(10, 45, "01= ");doc.text(23, 45, this.eval_tav.pg001);doc.text(30, 45, "02= ");doc.text(43, 45, this.eval_tav.pg002);
               doc.text(50, 45, "03= ");doc.text(63, 45, this.eval_tav.pg003);doc.text(70, 45, "04= ");doc.text(83, 45, this.eval_tav.pg004);
               doc.text(90, 45, "05= ");doc.text(103, 45, this.eval_tav.pg005);doc.text(110, 45, "06= ");doc.text(123, 45, this.eval_tav.pg006);
               doc.text(130, 45, "07= ");doc.text(143, 45, this.eval_tav.pg007);doc.text(150, 45, "08= ");doc.text(163, 45, this.eval_tav.pg008);
               doc.text(170, 45, "09= ");doc.text(183, 45, this.eval_tav.pg009);
               doc.line(10, 46, 190, 46);
               doc.text(10, 49, "10= ");doc.text(23, 49, this.eval_tav.pg010);doc.text(30, 49, "11= ");doc.text(43, 49, this.eval_tav.pg011);
               doc.text(50, 49, "12= ");doc.text(63, 49, this.eval_tav.pg012);doc.text(70, 49, "13= ");doc.text(83, 49, this.eval_tav.pg013);
               doc.text(90, 49, "14= ");doc.text(103, 49, this.eval_tav.pg014);doc.text(110, 49, "15= ");doc.text(123, 49, this.eval_tav.pg015);
               doc.text(130, 49, "16= ");doc.text(143, 49, this.eval_tav.pg016);doc.text(150, 49, "17= ");doc.text(163, 49, this.eval_tav.pg017);
               doc.text(170, 49, "18= ");doc.text(183, 49, this.eval_tav.pg018);
               doc.line(10, 50, 190, 50);
               doc.text(10, 53, "19= ");doc.text(23, 53, this.eval_tav.pg019);doc.text(30, 53, "20= ");doc.text(43, 53, this.eval_tav.pg020);
               doc.text(50, 53, "21= ");doc.text(63, 53, this.eval_tav.pg021);doc.text(70, 53, "22= ");doc.text(83, 53, this.eval_tav.pg022);
               doc.text(90, 53, "23= ");doc.text(103, 53, this.eval_tav.pg023);doc.text(110, 53, "24= ");doc.text(123, 53, this.eval_tav.pg024);
               doc.text(130, 53, "25= ");doc.text(143, 53, this.eval_tav.pg025);doc.text(150, 53, "26= ");doc.text(163, 53, this.eval_tav.pg026);
               doc.text(170, 53, "27= ");doc.text(183, 53, this.eval_tav.pg027);
               doc.line(10, 54, 190, 54);
               doc.text(10, 57, "28= ");doc.text(23, 57, this.eval_tav.pg028);doc.text(30, 57, "29= ");doc.text(43, 57, this.eval_tav.pg029);
               doc.text(50, 57, "30= ");doc.text(63, 57, this.eval_tav.pg030);
               doc.line(10, 59, 65, 59);
          },

          ejeSinContestar: function ejeSinContestar() {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg002 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg003 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg004 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg005 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }

               return this.ejeSinResponder;
          },
          sinContestar: function sinContestar() {

               this.pregSinContestar = 0;

               if (this.eval_tav.pg001 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg002 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg003 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg004 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg005 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg006 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg007 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg008 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg009 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg010 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg011 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg012 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg013 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg014 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg015 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg016 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg017 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg018 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg019 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg020 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg021 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg022 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg023 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg024 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg025 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               if (this.eval_tav.pg026 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg027 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg028 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg029 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_tav.pg030 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               return this.pregSinContestar;
          },
          addADayToMyDate: function addADayToMyDate() {
               if (this.eval_fecha) // as myDate can be null
                    // you have to set the this.myDate again, so vue can detect it changed
                    // this is not a caveat of this specific solution, but of any binding of dates
                    this.eval_tav.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
          },
          dateToYYYYMMDD: function dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0];
          },
          cargaHora: function cargaHora() {

               // Convierte la hora obtenida a hora local (utc)
               this.eval_fecha = new Date();
               var d = this.eval_fecha;
               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               var localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion: function cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_tav = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev07; // Crea el nodo para todos los campos.
               this.res_tav = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs07;
               console.log("res ? ", this.res_16pf);

               this.eval_tav.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
               this.eval_tav.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_tav.depto = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_depto; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_tav.sexo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_sexo; // Nombre de la empresa a la cual pertenece el usuario

               this.instrucciones = this.eval_tav.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de APTITUD EN VENTAS.";

               this.eval_fecha = new Date(); // Fecha del Día
          },
          empezarEvaluacion: function empezarEvaluacion() {

               this.eval_tav.empezo = this.cargaHora();
               this.inicioeval = true;
          },

          /** .................... VALIDACIONES  .................... */
          validarValor: function validarValor(valor) {
               var lvalor = valor;
               if (valor < 1 || valor > 2) {
                    lvalor = 0;
               }
               // console.log("validarValor, lvalor ? ",lvalor);
               return lvalor;
          },
          limpiarEvaluacion: function limpiarEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_tav = {
                    depto: "",
                    empresa: "", nombre: "",
                    fecha: "",
                    empezo: "", termino: "",
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                    pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                    pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0

                    /* Variables para un nuevo caso */
               };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.eval_tav = this.eval_tav;
          },

          /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          /* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion: function agregarEvaluacion() {
               var _this = this;

               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ");
                    return;
               }

               this.finalizoeval = true;
               this.eval_tav.termino = this.cargaHora();

               this.eval_fecha = new Date();

               var ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               var lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de APTITUD EN VENTAS para " + this.eval_tav.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvaluaciones = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalApvtas;
                    dbEvaluaciones.push({

                         empresa: this.eval_tav.empresa, nombre: this.eval_tav.nombre,
                         empezo: this.eval_tav.empezo, termino: this.eval_tav.termino,
                         fecha: lingreso, sexo: this.eval_tav.sexo, depto: this.eval_tav.depto,
                         pg001: this.eval_tav.pg001, pg002: this.eval_tav.pg002, pg003: this.eval_tav.pg003, pg004: this.eval_tav.pg004, pg005: this.eval_tav.pg005,
                         pg006: this.eval_tav.pg006, pg007: this.eval_tav.pg007, pg008: this.eval_tav.pg008, pg009: this.eval_tav.pg009, pg010: this.eval_tav.pg010,
                         pg011: this.eval_tav.pg011, pg012: this.eval_tav.pg012, pg013: this.eval_tav.pg013, pg014: this.eval_tav.pg014, pg015: this.eval_tav.pg015,
                         pg016: this.eval_tav.pg016, pg017: this.eval_tav.pg017, pg018: this.eval_tav.pg018, pg019: this.eval_tav.pg019, pg020: this.eval_tav.pg020,
                         pg021: this.eval_tav.pg021, pg022: this.eval_tav.pg022, pg023: this.eval_tav.pg023, pg024: this.eval_tav.pg024, pg025: this.eval_tav.pg025,
                         pg026: this.eval_tav.pg026, pg027: this.eval_tav.pg027, pg028: this.eval_tav.pg028, pg029: this.eval_tav.pg029, pg030: this.eval_tav.pg030
                    }).then(function (data) {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         _this.limpiarEvaluacion();

                         var laClave = data.key;
                         _this.grabado = true;
                         _this.inicioeval = false;

                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de APTITUD EN VENTAS guardado con éxito.");
                    });
               } // if (confirma)
          },
          // agregarEncuesta()

          //? =================================================================================
          enfoqueG1: function enfoqueG1(pestana) {
               var _this2 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         //* Vengo de 1, voy a 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt2.focus();
                         });

                         this.activott1 = "!active";
                         this.activott2 = "active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         break;
                    case 0:
                         //* Vengo de 2, voy a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt1.focus();
                         });
                         this.activott2 = "!active";
                         this.activott1 = "active";

                         this.vertt2 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },
          nadaG1: function nadaG1(pestana) {
               var _this3 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt1.focus();
                         });

                         this.activott1 = "active";
                         this.activott2 = "!active";

                         this.vertt1 = true;
                         this.vertt2 = false;

                         break;
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt2.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "active";

                         this.vertt1 = false;
                         this.vertt2 = true;

                         break;
                    default:
                    // code block
               } //* switch
          },
          enfoqueRG1: function enfoqueRG1(pestana) {
               var _this4 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         //* Estoy en 2 regreso a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt1.focus();
                         });
                         this.activott2 = "!active";
                         this.activott1 = "active";

                         this.vertt2 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          }
     } // methods
     // export

});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css_dist_css_materialize_min_css__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css_dist_css_materialize_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css_dist_css_materialize_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *      ev08_solemp.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);






/* harmony default export */ __webpack_exports__["a"] = ({
               name: 'solempleo',
               components: {
                              'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
                              'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
               },
               template: '#formanpf',
               data: function data() {
                              var vm = this;
                              return {
                                             estados: [{ text: 'Soltero', value: 'Soltero' }, { text: 'Casado', value: 'Casado' }, { text: 'Viudo', value: 'Viudo' }, { text: 'Unido', value: 'Unido' }],
                                             nacionalidades: [{ text: 'Guatemalteco', value: 'Guatemalteco' }, { text: 'Salvadoreño', value: 'Salvadoreño' }, { text: 'Hondureño', value: 'Hondureño' }, { text: 'Nicaraguense', value: 'Nicaraguense' }, { text: 'Costarricense', value: 'Costarricense' }, { text: 'Mejicano', value: 'Mejicano' }, { text: 'Estadounidense', value: 'Estadounidense' }],
                                             ejemplo: {},
                                             eval_solemp: {}, res: {},
                                             modo: "",
                                             eval_fecha: new Date(),
                                             eval_naci: new Date(),
                                             instrucciones: "",
                                             inicioeval: false, finalizoeval: false, grabado: false,
                                             pregSinContestar: 0, ejeSinResponder: 0,
                                             conteo1: null, conteo2: null, seconds: 0, minutos: 0,

                                             //? .....................................................................................................................................................................................................................
                                             activott1: "active", activott2: '!active', activott3: "!active", activott4: "!active", activott5: '!active',
                                             activott6: "!active", activott7: "!active", activott8: '!active', activott9: "!active",
                                             vertt1: true, vertt2: false, vertt3: false, vertt4: false, vertt5: false,
                                             vertt6: false, vertt7: false, vertt8: false, vertt9: false // return
                              };
               },
               // data()
               mounted: function mounted() {

                              /** Definiciones para el uso de los slides y tooltips */
                              var elems = document.querySelectorAll('.collapsible');
                              var instances = __WEBPACK_IMPORTED_MODULE_6_materialize_css___default.a.Collapsible.init(elems, {});

                              var elems = document.querySelectorAll('.tooltipped');
                              var instances = __WEBPACK_IMPORTED_MODULE_6_materialize_css___default.a.Tooltip.init(elems, {});

                              var elem = document.querySelectorAll('.tabs');
                              var instances = __WEBPACK_IMPORTED_MODULE_6_materialize_css___default.a.Tabs.init(elem, {});

                              var elems = document.querySelectorAll('select');
                              var instances = __WEBPACK_IMPORTED_MODULE_6_materialize_css___default.a.FormSelect.init(elems, {});

                              this.conteo1 = new Date().getTime();

                              // var vm = this;
                              // var x = setInterval(
                              //      function(){

                              //           vm.conteo2 = new Date().getTime();
                              //           vm.diferen = vm.conteo2 - vm.conteo1;
                              //           vm.seconds = Math.floor((vm.diferen % (1000 * 60)) / 1000);
                              //           console.log("inicia: ", vm.conteo1, ", finaliza: ",vm.conteo2,", dif ? ",vm.seconds);

                              //           if (vm.seconds >= 59){

                              //                vm.minutos = vm.minutos + 1;
                              //                console.log("minutos ? ", vm.minutos);
                              //           }
                              //      },1000);

                              /** obtiene localmente el caso definido en el almacén (store) */
                              this.cargaEvaluacion();
               },

               methods: {
                              solicitud: function solicitud(doc) {

                                             var lblanco = '';
                                             var lfaplico = this.eval_solemp.fecha;
                                             var lempezo = this.eval_solemp.empezo;
                                             var ltermino = this.eval_solemp.termino;
                                             var lcodigo = this.eval_solemp.codigo;
                                             var lncompleto = this.eval_solemp.pg001;
                                             var llugnac = this.eval_solemp.pg002;
                                             var lfecnac = this.eval_solemp.pg003;
                                             var ledad = this.eval_solemp.pg004;
                                             var ldpi = this.eval_solemp.pg005;
                                             var lextendido = this.eval_solemp.pg006;
                                             var ligss = this.eval_solemp.pg007;
                                             var lnit = this.eval_solemp.pg008;
                                             var lpg007 = this.eval_solemp.pg007;
                                             var lpg008 = this.eval_solemp.pg008;
                                             var lpg009 = this.eval_solemp.pg009;
                                             var lpg010 = this.eval_solemp.pg010;
                                             var lpg011 = this.eval_solemp.pg011;
                                             var lpg012 = this.eval_solemp.pg012;
                                             var lpg013 = this.eval_solemp.pg013;
                                             var lpg014 = this.eval_solemp.pg014;
                                             var lpg015 = this.eval_solemp.pg015;
                                             var lpg016 = this.eval_solemp.pg016;
                                             var lpg017 = this.eval_solemp.pg017;
                                             var lpg018 = this.eval_solemp.pg018;
                                             var lpg019 = this.eval_solemp.pg019;
                                             var lpg020 = this.eval_solemp.pg020;
                                             var lpg021 = this.eval_solemp.pg021;
                                             var lpg023 = this.eval_solemp.pg023;
                                             var lpg025 = this.eval_solemp.pg025;
                                             var lpg022 = this.eval_solemp.pg022.toString() + '; ' + lpg023;
                                             var lpg024 = this.eval_solemp.pg024.toString() + '; ' + lpg025;

                                             var lpg026 = this.eval_solemp.pg026;
                                             var lpg027 = this.eval_solemp.pg027;
                                             var lpg028 = this.eval_solemp.pg028;
                                             var lpg029 = this.eval_solemp.pg029;
                                             var lpg030 = this.eval_solemp.pg030;
                                             var lpg031 = this.eval_solemp.pg031;
                                             var lpg032 = this.eval_solemp.pg032;
                                             var lpg033 = this.eval_solemp.pg033;
                                             var lpg034 = this.eval_solemp.pg034;
                                             var lpg035 = this.eval_solemp.pg035;
                                             var lpg036 = this.eval_solemp.pg036;
                                             var lpg037 = this.eval_solemp.pg037;
                                             var lpg038 = this.eval_solemp.pg038;
                                             var lpg039 = this.eval_solemp.pg039;
                                             var lpg040 = this.eval_solemp.pg040;
                                             var lpg041 = this.eval_solemp.pg041;
                                             var lpg042 = this.eval_solemp.pg042;
                                             var lpg043 = this.eval_solemp.pg043;
                                             var lpg044 = this.eval_solemp.pg044;
                                             var lpg045 = this.eval_solemp.pg045;
                                             var lpg046 = this.eval_solemp.pg046;
                                             var lpg047 = this.eval_solemp.pg047;
                                             var lpg048 = this.eval_solemp.pg048;
                                             var lpg049 = this.eval_solemp.pg049;
                                             var lpg050 = this.eval_solemp.pg050;
                                             var lpg051 = this.eval_solemp.pg051;
                                             var lpg052 = this.eval_solemp.pg052;
                                             var lpg053 = this.eval_solemp.pg053;
                                             var lpg054 = this.eval_solemp.pg054;
                                             var lpg055 = this.eval_solemp.pg055;
                                             var lpg056 = this.eval_solemp.pg056;
                                             var lpg057 = this.eval_solemp.pg057;
                                             var lpg058 = this.eval_solemp.pg058;
                                             var lpg059 = this.eval_solemp.pg059;
                                             var lpg060 = this.eval_solemp.pg060;
                                             var lpg061 = this.eval_solemp.pg061;
                                             var lpg062 = this.eval_solemp.pg062;
                                             var lpg063 = this.eval_solemp.pg063;
                                             var lpg064 = this.eval_solemp.pg064;
                                             var lpg065 = this.eval_solemp.pg065;
                                             var lpg066 = this.eval_solemp.pg066;
                                             var lpg067 = this.eval_solemp.pg067;
                                             var lpg068 = this.eval_solemp.pg068;
                                             var lpg069 = this.eval_solemp.pg069;
                                             var lpg070 = this.eval_solemp.pg070;
                                             var lpg071 = this.eval_solemp.pg071;
                                             var lpg072 = this.eval_solemp.pg072;
                                             var lpg073 = this.eval_solemp.pg073;
                                             var lpg074 = this.eval_solemp.pg074;
                                             var lpg075 = this.eval_solemp.pg075;
                                             var lpg076 = this.eval_solemp.pg076;
                                             var lpg077 = this.eval_solemp.pg077;
                                             var lpg078 = this.eval_solemp.pg078;
                                             var lpg079 = this.eval_solemp.pg079;
                                             var lpg080 = this.eval_solemp.pg080;
                                             var lpg081 = this.eval_solemp.pg081;
                                             var lpg082 = this.eval_solemp.pg082;
                                             var lpg083 = this.eval_solemp.pg083;
                                             var lpg084 = this.eval_solemp.pg084;
                                             var lpg085 = this.eval_solemp.pg085;
                                             var lpg086 = this.eval_solemp.pg086;
                                             var lpg087 = this.eval_solemp.pg087;
                                             var lpg088 = this.eval_solemp.pg088;
                                             var lpg089 = this.eval_solemp.pg089;
                                             var lpg090 = this.eval_solemp.pg090;
                                             var lpg091 = this.eval_solemp.pg091;
                                             var lpg092 = this.eval_solemp.pg092;
                                             var lpg093 = this.eval_solemp.pg093;
                                             var lpg094 = this.eval_solemp.pg094;
                                             var lpg095 = this.eval_solemp.pg095;
                                             var lpg096 = this.eval_solemp.pg096;
                                             var lpg097 = this.eval_solemp.pg097;
                                             var lpg098 = this.eval_solemp.pg098;
                                             var lpg099 = this.eval_solemp.pg099;
                                             var lpg100 = this.eval_solemp.pg100;
                                             var lpg101 = this.eval_solemp.pg101;
                                             var lpg102 = this.eval_solemp.pg102;
                                             var lpg103 = this.eval_solemp.pg103;
                                             var lpg104 = this.eval_solemp.pg104;
                                             var lpg105 = this.eval_solemp.pg105;
                                             var lpg106 = this.eval_solemp.pg106;
                                             var lpg107 = this.eval_solemp.pg107;
                                             var lpg108 = this.eval_solemp.pg108;
                                             var lpg109 = this.eval_solemp.pg109;
                                             var lpg110 = this.eval_solemp.pg110;
                                             var lpg111 = this.eval_solemp.pg111;
                                             var lpg112 = this.eval_solemp.pg112;
                                             var lpg113 = this.eval_solemp.pg113;
                                             var lpg114 = this.eval_solemp.pg114;
                                             var lpg115 = this.eval_solemp.pg115;
                                             var lpg116 = this.eval_solemp.pg116;
                                             var lpg117 = this.eval_solemp.pg117;
                                             var lpg118 = this.eval_solemp.pg118;
                                             var lpg119 = this.eval_solemp.pg119;
                                             var lpg120 = this.eval_solemp.pg120;
                                             var lpg121 = this.eval_solemp.pg121;
                                             var lpg122 = this.eval_solemp.pg122;
                                             var lpg123 = this.eval_solemp.pg123;
                                             var lpg124 = this.eval_solemp.pg124;
                                             var lpg125 = this.eval_solemp.pg125;
                                             var lpg126 = this.eval_solemp.pg126;
                                             var lpg127 = this.eval_solemp.pg127;
                                             var lpg128 = this.eval_solemp.pg128;
                                             var lpg129 = this.eval_solemp.pg129;
                                             var lpg130 = this.eval_solemp.pg130;
                                             var lpg131 = this.eval_solemp.pg131;
                                             var lpg132 = this.eval_solemp.pg132;
                                             var lpg133 = this.eval_solemp.pg133;
                                             var lpg134 = this.eval_solemp.pg134;
                                             var lpg135 = this.eval_solemp.pg135;
                                             var lpg136 = this.eval_solemp.pg136;
                                             var lpg137 = this.eval_solemp.pg137;
                                             var lpg138 = this.eval_solemp.pg138;
                                             var lpg139 = this.eval_solemp.pg139;
                                             var lpg140 = this.eval_solemp.pg140;
                                             var lpg141 = this.eval_solemp.pg141;
                                             var lpg142 = this.eval_solemp.pg142;
                                             var lpg143 = this.eval_solemp.pg143;
                                             var lpg144 = this.eval_solemp.pg144;
                                             var lpg145 = this.eval_solemp.pg145;
                                             var lpg146 = this.eval_solemp.pg146;
                                             var lpg147 = this.eval_solemp.pg147;
                                             var lpg148 = this.eval_solemp.pg148;
                                             var lpg149 = this.eval_solemp.pg149;
                                             var lpg150 = this.eval_solemp.pg150;
                                             var lpg151 = this.eval_solemp.pg151;
                                             var lpg152 = this.eval_solemp.pg152;
                                             var lpg153 = this.eval_solemp.pg153;
                                             var lpg154 = this.eval_solemp.pg154;
                                             var lpg155 = this.eval_solemp.pg155;
                                             var lpg156 = this.eval_solemp.pg156;
                                             var lpg157 = this.eval_solemp.pg157;
                                             var lpg158 = this.eval_solemp.pg158;
                                             var lpg159 = this.eval_solemp.pg159;
                                             var lpg160 = this.eval_solemp.pg160;
                                             var lpg161 = this.eval_solemp.pg161;
                                             var lpg162 = this.eval_solemp.pg162;
                                             var lpg163 = this.eval_solemp.pg163;
                                             var lpg164 = this.eval_solemp.pg164;
                                             var lpg165 = this.eval_solemp.pg165;
                                             var lpg166 = this.eval_solemp.pg166;
                                             var lpg167 = this.eval_solemp.pg167;
                                             var lpg168 = this.eval_solemp.pg168;
                                             var lpg169 = this.eval_solemp.pg169;
                                             var lpg170 = this.eval_solemp.pg170;
                                             var lpg171 = this.eval_solemp.pg171;
                                             var lpg172 = this.eval_solemp.pg172;
                                             var lpg173 = this.eval_solemp.pg173;
                                             var lpg174 = this.eval_solemp.pg174;
                                             var lpg175 = this.eval_solemp.pg175;
                                             var lpg176 = this.eval_solemp.pg176;
                                             var lpg177 = this.eval_solemp.pg177;
                                             var lpg178 = this.eval_solemp.pg178;
                                             var lpg179 = this.eval_solemp.pg179;
                                             var lpg180 = this.eval_solemp.pg180;
                                             var lpg181 = this.eval_solemp.pg181;
                                             var lpg182 = this.eval_solemp.pg182;
                                             var lpg183 = this.eval_solemp.pg183;
                                             var lpg184 = this.eval_solemp.pg184;
                                             var lpg185 = this.eval_solemp.pg185;
                                             var lpg186 = this.eval_solemp.pg186;
                                             var lpg187 = this.eval_solemp.pg187;
                                             var lpg188 = this.eval_solemp.pg188;
                                             var lpg189 = this.eval_solemp.pg189;
                                             var lpg190 = this.eval_solemp.pg190;
                                             var lpg191 = this.eval_solemp.pg191;
                                             var lpg192 = this.eval_solemp.pg192;
                                             var lpg193 = this.eval_solemp.pg193;
                                             var lpg194 = this.eval_solemp.pg194;
                                             var lpg195 = this.eval_solemp.pg195;
                                             var lpg196 = this.eval_solemp.pg196;
                                             var lpg197 = this.eval_solemp.pg197;
                                             var lpg198 = this.eval_solemp.pg198;
                                             var lpg199 = this.eval_solemp.pg199;
                                             var lpg200 = this.eval_solemp.pg200;
                                             var lpg201 = this.eval_solemp.pg201;
                                             var lpg202 = this.eval_solemp.pg202;
                                             var lpg203 = this.eval_solemp.pg203;
                                             var lpg204 = this.eval_solemp.pg204;
                                             var lpg205 = this.eval_solemp.pg205;
                                             var lpg206 = this.eval_solemp.pg206;
                                             var lpg207 = this.eval_solemp.pg207;

                                             doc.setLineWidth(0.7);
                                             doc.line(13, 50, 195, 50); // horizontal line (init_col, init_row, , )

                                             doc.setFontSize(9);
                                             doc.setFontType("bold");
                                             doc.text(13, 57, 'I) INFORMACION PERSONAL');
                                             doc.setLineWidth(0.5);
                                             doc.rect(12, 59, 185, 45); /*  rect(init_col, init_row, end_col, end_row) */
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 70, 'LUGAR Y FECHA DE NACIMIENTO:');
                                             doc.text(15, 76, 'EDAD:');
                                             doc.text(35, 76, 'DPI:');
                                             doc.text(100, 76, 'EXTENDIDA EN:');
                                             var llugfecnac = llugnac + '; ' + lfecnac;
                                             console.log("llugnac ?", llugnac, "; lfecnad ? ", lfecnac, "; llugfecnad ? ", llugfecnac);
                                             doc.setFontType("normal");
                                             doc.text(72, 70, llugfecnac);
                                             doc.text(27, 76, ledad.toString());
                                             doc.text(45, 76, ldpi);
                                             doc.text(127, 76, lextendido);
                                             console.log("pasé !!!!");
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 82, 'AFILIACION AL IGSS:');
                                             doc.text(95, 82, 'NIT:');
                                             doc.text(130, 82, 'ESTADO CIVIL:');
                                             doc.setFontType("normal");
                                             doc.text(50, 82, lpg007);
                                             doc.text(103, 82, lpg008);
                                             doc.text(160, 82, lpg009);

                                             doc.setFontType("bolditalic");
                                             doc.text(15, 88, 'NACIONALIDAD:'); /* pg010 */
                                             doc.text(100, 88, 'PROFESION U OFICIO:');
                                             doc.setFontType("normal");
                                             doc.text(45, 88, lpg010);
                                             doc.text(150, 88, lpg011);

                                             doc.setFontType("bolditalic");
                                             doc.text(15, 94, 'DIRECCION ACTUAL:');
                                             doc.text(140, 94, 'E-MAIL:');
                                             doc.setFontType("normal");
                                             var msg = 'E-MAIL';
                                             var pos1 = 140 + msg.length + 7;
                                             doc.text(52, 94, lpg012);
                                             doc.text(pos1, 94, lpg013);

                                             doc.setFontType("bolditalic");
                                             var msg1 = 'TELEFONO DOMICILIO:';
                                             var msg2 = 'TELEFONO CELULAR:';
                                             pos1 = 15 + msg1.length + 20;
                                             var pos2 = 100 + msg2.length + 20;
                                             doc.text(15, 100, msg1);
                                             doc.text(100, 100, msg2);
                                             doc.setFontType("normal");
                                             doc.text(pos1, 100, lpg014);
                                             doc.text(pos2, 100, lpg015);

                                             doc.rect(12, 111, 185, 120); /*  rect(init_col, init_row, end_col, end_row) */
                                             doc.setFontType("bold");
                                             doc.text(13, 110, 'II) DATOS FAMILIARES');
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 116, 'NOMBRE DEL PADRE:');
                                             doc.text(110, 116, 'TELEFONO:');
                                             doc.setFontType("normal");
                                             doc.text(55, 116, lpg016);
                                             doc.text(135, 116, lpg017);
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 121, 'LUGAR DE TRABAJO:');
                                             doc.setFontType("normal");
                                             doc.text(55, 121, lpg018);

                                             doc.setFontType("bolditalic");
                                             doc.text(15, 127, 'NOMBRE DE LA MADRE:');
                                             doc.text(110, 127, 'TELEFONO:');
                                             doc.setFontType("normal");
                                             doc.text(55, 127, lpg019);
                                             doc.text(135, 127, lpg020);

                                             doc.setFontType("bolditalic");
                                             doc.text(15, 133, 'LUGAR DE TRABAJO:');
                                             doc.setFontType("normal");
                                             doc.text(55, 133, lpg021);

                                             doc.setFontType("bolditalic");
                                             doc.text(15, 139, 'No. DE HERMANOS Y PROFESIONES:');
                                             doc.text(15, 145, 'No. DE CARGAS FAMILIARES Y QUIENES:');
                                             doc.setFontType("normal");
                                             doc.text(85, 139, lpg022);
                                             doc.text(85, 145, lpg024);

                                             doc.setFontType("bolditalic");
                                             doc.text(75, 151, '------ DATOS DEL CONYUGUE ------');
                                             doc.text(15, 157, 'NOMBRE COMPLETO:');
                                             doc.text(110, 157, 'OCUPACION:');
                                             doc.setFontType("normal");
                                             doc.text(55, 157, lpg026);
                                             doc.text(135, 157, lpg027);
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 163, 'LUGAR DE TRABAJO:');
                                             doc.setFontType("normal");
                                             doc.text(55, 163, lpg028);
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 169, 'DIRECCION:');
                                             doc.text(110, 169, 'TELEFONO:');
                                             doc.setFontType("normal");
                                             doc.text(55, 169, lpg029);
                                             doc.text(135, 169, lpg030);
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 174, 'CARGO QUE OCUPA:');
                                             doc.setFontType("normal");
                                             doc.text(55, 174, lpg031);
                                             doc.setFontType("bolditalic");

                                             doc.text(75, 180, '------ DATOS DE LOS HIJOS ------');
                                             doc.text(15, 186, '1) NOMBRE:');
                                             doc.text(110, 186, 'EDAD:');
                                             doc.setFontType("normal");
                                             doc.text(55, 186, lpg032);
                                             doc.text(135, 186, lpg033);
                                             doc.setFontType("bolditalic");
                                             doc.text(18, 192, 'ESCOLARIDAD:');
                                             doc.text(110, 192, 'INSTITUCION:');
                                             doc.setFontType("normal");
                                             doc.text(55, 192, lpg034);
                                             doc.text(135, 192, lpg035);
                                             doc.setFontType("bolditalic");

                                             doc.text(15, 198, '2) NOMBRE:');
                                             doc.text(110, 198, 'EDAD:');
                                             doc.setFontType("normal");
                                             doc.text(55, 198, lpg036);
                                             doc.text(135, 198, lpg037);
                                             doc.setFontType("bolditalic");
                                             doc.text(18, 204, 'ESCOLARIDAD:');
                                             doc.text(110, 204, 'INSTITUCION:');
                                             doc.setFontType("normal");
                                             doc.text(55, 204, lpg038);
                                             doc.text(135, 204, lpg039);
                                             doc.setFontType("bolditalic");

                                             doc.text(15, 210, '3) NOMBRE:');
                                             doc.text(110, 210, 'EDAD:');
                                             doc.setFontType("normal");
                                             doc.text(55, 210, lpg040);
                                             doc.text(135, 210, lpg041);
                                             doc.setFontType("bolditalic");
                                             doc.text(18, 216, 'ESCOLARIDAD:');
                                             doc.text(110, 216, 'INSTITUCION:');
                                             doc.setFontType("normal");
                                             doc.text(55, 216, lpg042);
                                             doc.text(135, 216, lpg043);
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 222, '4) NOMBRE:');
                                             doc.text(110, 222, 'EDAD:');
                                             doc.setFontType("normal");
                                             doc.text(55, 222, lpg044);
                                             doc.text(135, 222, lpg045);
                                             doc.setFontType("bolditalic");
                                             doc.text(18, 228, 'ESCOLARIDAD:');
                                             doc.text(110, 228, 'INSTITUCION:');
                                             doc.setFontType("normal");
                                             doc.text(55, 228, lpg046);
                                             doc.text(135, 228, lpg047);

                                             doc.rect(12, 239, 185, 30); /*  rect(init_col, init_row, end_col, end_row) */
                                             doc.setFontType("bold");
                                             doc.text(13, 238, 'III) INFORMACION SOCIOECONOMICA');
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 244, 'VIVE EN CASA PROPIA ?');
                                             doc.text(85, 244, 'ALQUILA ?');
                                             doc.text(130, 244, 'DE SUS PADRES ?');
                                             doc.setFontType("normal");
                                             doc.text(55, 244, lpg048);
                                             doc.text(105, 244, lpg049);
                                             doc.text(160, 244, lpg050);
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 250, 'TIENE VEHICULO PROPIO ?');
                                             doc.text(130, 250, 'MARCA Y AÑO');
                                             doc.setFontType("normal");
                                             doc.text(60, 250, lpg051);
                                             var lpg5253 = lpg052 + '; ' + lpg053;
                                             doc.text(160, 250, lpg5253);
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 256, 'RECIBE OTROS INGRESOS QUE NO SEAN DE SU SUELDO ?');
                                             doc.text(130, 256, 'MONTO');
                                             doc.setFontType("normal");
                                             doc.text(110, 256, lpg054);
                                             doc.text(160, 256, lpg055);
                                             doc.setFontType("bolditalic");
                                             doc.text(15, 262, 'DE DONDE PROCEDE ESTE INGRESO');
                                             doc.setFontType("normal");
                                             doc.text(80, 262, lpg056);
                                             doc.setFontType("bolditalic");

                                             doc.setFontType("normal");

                                             /* ========================================================================================== */
                                             /* PAGINA 2 */
                                             doc.addPage();
                                             doc.text(15, 10, 'Segunda Página');
                                             doc.text(135, 10, lncompleto);
                                             doc.setLineWidth(0.7);
                                             doc.line(13, 14, 200, 14); // horizontal line (init_col, init_row, , )
                                             doc.setFontType("bold");
                                             doc.text(13, 20, 'IV) FORMACION ACADEMICA');
                                             doc.rect(12, 22, 190, 125); /*  RECTANGULO (init_col, init_row, end_col, end_row) */
                                             doc.setFontType("bolditalic");
                                             doc.text(13, 26, '- POSTGRADO ');
                                             doc.text(13, 32, '1) INSTITUCION:');
                                             doc.text(98, 32, 'GRADO OBTENIDO Y TITULO:');
                                             doc.text(13, 38, 'FECHA:');
                                             doc.setFontType("normal");
                                             doc.text(39, 32, lpg057);
                                             doc.text(145, 32, lpg058);
                                             doc.text(30, 38, lpg059);
                                             doc.setFontType("bolditalic");
                                             doc.text(13, 44, '2) INSTITUCION:');
                                             doc.text(98, 44, 'GRADO OBTENIDO Y TITULO:');
                                             doc.text(13, 50, 'FECHA:');
                                             doc.setFontType("normal");
                                             doc.text(39, 44, lpg060);
                                             doc.text(145, 44, lpg061);
                                             doc.text(30, 50, lpg062);
                                             doc.setFontType("bolditalic");

                                             doc.text(13, 56, '- UNIVERSITARIA');
                                             doc.text(13, 62, 'INSTITUCION:');
                                             doc.text(93, 62, 'GRADO OBTENIDO Y TITULO:');
                                             doc.text(13, 68, 'FECHA:');
                                             doc.setFontType("normal");
                                             doc.text(36, 62, lpg063);
                                             doc.text(141, 62, lpg064);
                                             doc.text(30, 68, lpg065);
                                             doc.setFontType("bolditalic");

                                             doc.text(13, 74, '- DIVERSIFICADA');
                                             doc.text(13, 80, 'INSTITUCION:');
                                             doc.text(93, 80, 'GRADO OBTENIDO Y TITULO:');
                                             doc.text(13, 86, 'FECHA:');
                                             doc.setFontType("normal");
                                             doc.text(39, 80, lpg066);
                                             doc.text(141, 80, lpg067);
                                             doc.text(30, 86, lpg068);
                                             doc.setFontType("bolditalic");

                                             doc.text(13, 92, '- OTROS CURSOS DE ACTUALIZACION RELACIONADOS CON SU PROFESION:');
                                             doc.setFontType("normal");
                                             doc.text(140, 92, lpg069);
                                             doc.setFontType("bolditalic");
                                             doc.text(13, 98, '- OTROS CONOCIMIENTOS O HABILIDADES QUE POSEE:');
                                             doc.setFontType("normal");
                                             doc.text(110, 98, lpg070);
                                             doc.setFontType("bolditalic");
                                             doc.text(13, 104, '- PREMIOS O MENCIONES HONORIFICAS OBTENIDAS:');
                                             doc.text(13, 116, '- ESTUDIA ACTUALMENTE ?');
                                             doc.text(65, 116, 'ESPECIFIQUE:');
                                             doc.text(13, 122, '  HORARIO:');
                                             doc.setFontType("normal");
                                             doc.text(13, 110, lpg071);
                                             doc.text(59, 116, lpg072);
                                             doc.text(90, 116, lpg073);
                                             doc.text(35, 122, lpg074);
                                             doc.setFontType("bolditalic");

                                             doc.text(75, 128, '------ IDIOMAS ADICIONALES ------');
                                             doc.text(13, 136, '1) IDIOMA:');
                                             doc.text(110, 136, 'LEE ');
                                             doc.text(130, 136, 'ESCRIBE');
                                             doc.text(155, 136, 'CONVERSA');
                                             doc.setFontType("normal");
                                             doc.text(35, 136, lpg075);
                                             doc.text(120, 136, lpg076);
                                             doc.text(148, 136, lpg077);
                                             doc.text(180, 136, lpg078);
                                             doc.setFontType("bolditalic");

                                             doc.text(13, 142, '2) IDIOMA:');
                                             doc.text(110, 142, 'LEE ');
                                             doc.text(130, 142, 'ESCRIBE');
                                             doc.text(155, 142, 'CONVERSA');
                                             doc.setFontType("normal");
                                             doc.text(35, 142, lpg079);
                                             doc.text(120, 142, lpg080);
                                             doc.text(148, 142, lpg081);
                                             doc.text(180, 142, lpg082);

                                             doc.setFontType("bold");
                                             doc.text(13, 150, 'V) EXPERIENCIA LABORAL (LOS TRES ULTIMOS EMPLEOS)');
                                             doc.rect(12, 152, 190, 130); /*  rect(init_col, init_row, end_col, end_row) */
                                             doc.setFontType("bolditalic");
                                             doc.text(13, 156, '- EMPRESA 1 ');
                                             doc.text(13, 162, '  NOMBRE:');
                                             doc.text(125, 162, 'TELEFONO:');
                                             doc.text(13, 168, '  DIRECCION:');
                                             doc.text(13, 174, '  GIRO DEL NEGOCIO:');
                                             doc.text(13, 180, '  FECHA DE INGRESO:');
                                             doc.text(67, 180, 'FECHA DE EGRESO:');
                                             doc.text(118, 180, 'TRABAJA ACTUALMENTE EN ESTA EMPRESA ?');
                                             doc.text(13, 186, '  CARGO INICIAL:');
                                             doc.text(110, 186, 'CARGO ACTUAL:');
                                             doc.text(13, 192, '  SALARIO INICIAL:');
                                             doc.text(110, 192, 'SALARIO ACTUAL:');
                                             doc.text(13, 198, '  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');
                                             doc.text(65, 206, '------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');
                                             doc.text(13, 212, '  1) ');
                                             doc.text(13, 218, '  2) ');
                                             doc.text(13, 224, '  3) ');
                                             doc.text(13, 230, '  4) ');
                                             doc.text(13, 236, '  5) ');
                                             doc.text(13, 242, '  6) ');
                                             doc.text(13, 248, '  NOMBRE DE SU JEFE INMEDIATO:');
                                             doc.text(13, 254, '  PUESTO DE SU JEFE INMEDIATO:');
                                             doc.text(13, 260, '  NUMERO DE PERSONAS A SU CARGO:');
                                             doc.text(13, 266, '  MOTIVO DE SU RETIRO:');
                                             doc.text(13, 272, '  PODEMOS PEDIR REFERENCIAS ?');
                                             doc.text(13, 278, '  PORQUE:');
                                             doc.setFontType("normal");
                                             doc.text(35, 162, lpg083);
                                             doc.text(150, 162, lpg084);
                                             doc.text(35, 168, lpg085);
                                             doc.text(50, 174, lpg086);
                                             doc.text(49, 180, lpg087);
                                             doc.text(100, 180, lpg088);
                                             doc.text(196, 180, lpg089);
                                             doc.text(45, 186, lpg090);
                                             doc.text(140, 186, lpg091);
                                             doc.text(45, 192, lpg092);
                                             doc.text(145, 192, lpg093);
                                             doc.text(15, 202, lpg094);
                                             doc.text(21, 212, lpg095);
                                             doc.text(21, 218, lpg096);
                                             doc.text(21, 224, lpg097);
                                             doc.text(21, 230, lpg098);
                                             doc.text(21, 236, lpg099);
                                             doc.text(21, 242, lpg100);
                                             doc.text(79, 248, lpg101);
                                             doc.text(79, 254, lpg102);
                                             doc.text(79, 260, lpg103);
                                             doc.text(79, 266, lpg104);
                                             doc.text(79, 272, lpg105);
                                             doc.text(79, 278, lpg106);

                                             /* ========================================================================================== */
                                             /* PAGINA 3 */
                                             doc.addPage();
                                             doc.text(15, 10, 'Tercera Página');
                                             doc.text(135, 10, lncompleto);
                                             doc.setLineWidth(0.7);
                                             doc.line(13, 14, 200, 14); // horizontal line (init_col, init_row, , )

                                             doc.rect(12, 20, 190, 265); /*  RECTANGULO (init_col, init_row, end_col, end_row) */
                                             doc.setFontType("bolditalic");
                                             doc.text(13, 24, '- EMPRESA 2 ');
                                             doc.text(13, 30, '  NOMBRE:');
                                             doc.text(125, 30, 'TELEFONO:');
                                             doc.text(13, 36, ' DIRECCION:');
                                             doc.text(13, 42, '  GIRO DEL NEGOCIO:');
                                             doc.text(13, 48, '  FECHA DE INGRESO:');
                                             doc.text(67, 48, 'FECHA DE EGRESO:');
                                             doc.text(115, 48, 'TRABAJA ACTUALMENTE EN ESTA EMPRESA ?');
                                             doc.text(13, 54, '  CARGO INICIAL:');
                                             doc.text(110, 54, 'CARGO ACTUAL:');
                                             doc.text(13, 60, '  SALARIO INICIAL:');
                                             doc.text(110, 60, 'SALARIO ACTUAL:');
                                             doc.text(13, 65, '  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');
                                             doc.text(65, 74, '------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');
                                             doc.text(13, 80, '  1) ');
                                             doc.text(13, 86, '  2) ');
                                             doc.text(13, 92, '  3) ');
                                             doc.text(13, 98, '  4) ');
                                             doc.text(13, 104, '  5) ');
                                             doc.text(13, 110, '  6) ');
                                             doc.text(13, 116, '  NOMBRE DE SU JEFE INMEDIATO:');
                                             doc.text(13, 122, '  PUESTO DE SU JEFE INMEDIATO:');
                                             doc.text(13, 128, '  NUMERO DE PERSONAS A SU CARGO:');
                                             doc.text(13, 134, '  MOTIVO DE SU RETIRO:');
                                             doc.text(13, 140, '  PODEMOS PEDIR REFERENCIAS ?');
                                             doc.text(13, 146, '  PORQUE:');
                                             doc.setFontType("normal");
                                             doc.text(35, 30, lpg107);
                                             doc.text(150, 30, lpg108);
                                             doc.text(35, 36, lpg109);
                                             doc.text(50, 42, lpg110);
                                             doc.text(49, 48, lpg111);
                                             doc.text(100, 48, lpg112);
                                             doc.text(196, 48, lpg113);
                                             doc.text(45, 54, lpg114);
                                             doc.text(140, 54, lpg115);
                                             doc.text(45, 60, lpg116);
                                             doc.text(145, 60, lpg117);
                                             doc.text(15, 70, lpg118);
                                             doc.text(21, 80, lpg119);
                                             doc.text(21, 86, lpg120);
                                             doc.text(21, 92, lpg121);
                                             doc.text(21, 98, lpg122);
                                             doc.text(21, 104, lpg123);
                                             doc.text(21, 110, lpg124);
                                             doc.text(79, 116, lpg125);
                                             doc.text(79, 122, lpg126);
                                             doc.text(79, 128, lpg127);
                                             doc.text(79, 134, lpg128);
                                             doc.text(79, 140, lpg129);
                                             doc.text(79, 146, lpg130);

                                             doc.line(13, 150, 200, 150); // horizontal line (init_col, init_row, , )
                                             doc.setFontType("bolditalic");
                                             doc.text(13, 156, '- EMPRESA 3 ');
                                             doc.text(13, 161, '  NOMBRE:');
                                             doc.text(125, 161, 'TELEFONO:');
                                             doc.text(13, 166, ' DIRECCION:');
                                             doc.text(13, 172, '  GIRO DEL NEGOCIO:');
                                             doc.text(13, 178, '  FECHA DE INGRESO:');
                                             doc.text(67, 178, 'FECHA DE EGRESO:');
                                             doc.text(115, 178, 'TRABAJA ACTUALMENTE EN ESTA EMPRESA ?');
                                             doc.text(13, 184, '  CARGO INICIAL:');
                                             doc.text(110, 184, 'CARGO ACTUAL:');
                                             doc.text(13, 191, '  SALARIO INICIAL:');
                                             doc.text(110, 191, 'SALARIO ACTUAL:');
                                             doc.text(13, 196, '  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');
                                             doc.text(65, 206, '------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');
                                             doc.text(13, 212, '  1) ');
                                             doc.text(13, 218, '  2) ');
                                             doc.text(13, 224, '  3) ');
                                             doc.text(13, 230, '  4) ');
                                             doc.text(13, 236, '  5) ');
                                             doc.text(13, 242, '  6) ');
                                             doc.text(13, 248, '  NOMBRE DE SU JEFE INMEDIATO:');
                                             doc.text(13, 254, '  PUESTO DE SU JEFE INMEDIATO:');
                                             doc.text(13, 260, '  NUMERO DE PERSONAS A SU CARGO:');
                                             doc.text(13, 266, '  MOTIVO DE SU RETIRO:');
                                             doc.text(13, 272, '  PODEMOS PEDIR REFERENCIAS ?');
                                             doc.text(13, 278, '  PORQUE:');
                                             doc.setFontType("normal");
                                             doc.text(35, 161, lpg131);
                                             doc.text(150, 161, lpg132);
                                             doc.text(35, 166, lpg133);
                                             doc.text(50, 172, lpg134);
                                             doc.text(49, 178, lpg135);
                                             doc.text(100, 178, lpg136);
                                             doc.text(196, 178, lpg137);
                                             doc.text(45, 184, lpg138);
                                             doc.text(140, 184, lpg139);
                                             doc.text(45, 191, lpg140);
                                             doc.text(145, 191, lpg141);
                                             doc.text(15, 200, lpg142);
                                             doc.text(21, 212, lpg143);
                                             doc.text(21, 218, lpg144);
                                             doc.text(21, 224, lpg145);
                                             doc.text(21, 230, lpg146);
                                             doc.text(21, 236, lpg147);
                                             doc.text(21, 242, lpg148);
                                             doc.text(79, 248, lpg149);
                                             doc.text(79, 254, lpg150);
                                             doc.text(79, 260, lpg151);
                                             doc.text(79, 266, lpg152);
                                             doc.text(79, 272, lpg153);
                                             doc.text(79, 278, lpg154);

                                             /* ========================================================================================== */
                                             /* PAGINA 4 */
                                             doc.addPage();
                                             doc.text(15, 10, 'Cuarta Página');
                                             doc.text(135, 10, lncompleto);
                                             doc.setLineWidth(0.7);
                                             doc.line(13, 14, 200, 14); // horizontal line (init_col, init_row, , )
                                             doc.setFontType("bold");
                                             doc.text(13, 20, 'VI) FORMACION ACADEMICA');
                                             doc.rect(12, 22, 190, 260); /*  RECTANGULO (init_col, init_row, end_col, end_row) */
                                             doc.setFontType("bolditalic");
                                             doc.text(13, 32, 'Organización, cultural, deportiva, religiosa, sindical u otras a las que pertenecido:');
                                             doc.text(13, 50, 'Escriba algún deporte o pasatiempo preferido:');
                                             doc.text(13, 68, '* Salud en General:');
                                             doc.text(13, 74, '  Ha padecido de alguna enfermedad en los últimos 3 años ?');
                                             doc.text(13, 80, '  ESPECIFIQUE:');
                                             doc.text(13, 86, '* Condiciones de Trabajo:');
                                             doc.text(13, 92, '  Puesto al que aplica ?');
                                             doc.text(13, 98, '  Expectativa salarial ');
                                             doc.text(13, 106, '  Tiene limitaciones de horario ?');
                                             doc.text(75, 106, '  ESPECIFIQUE:');
                                             doc.text(13, 112, '  ¿ A partir de qué fecha está disponible ?');
                                             doc.text(13, 118, '  Está dispuesto a viajar como parte de su trabajo ?');
                                             doc.text(13, 124, '  Posee pasaporte vigente ?');
                                             doc.text(70, 124, '  No. de Pasaporte ');
                                             doc.text(13, 130, '* Información complementaria:');
                                             doc.text(13, 136, '  Ha tenido problemas con la justicia ?');
                                             doc.text(85, 136, '  EXPLIQUE:');
                                             doc.text(13, 142, '  Hay deudas de alguna naturaleza ?');
                                             doc.text(85, 142, '  EXPLIQUE:');
                                             doc.text(13, 148, '  Tiene tatuajes ?');
                                             doc.setFontType("normal");
                                             doc.text(13, 36, '* ' + lpg155);
                                             doc.text(13, 42, '* ' + lpg156);
                                             doc.text(13, 54, lpg157);
                                             doc.text(110, 54, lpg158);
                                             doc.text(13, 60, lpg159);
                                             doc.text(110, 60, lpg160);
                                             doc.text(120, 74, lpg161);
                                             doc.text(55, 80, lpg162);
                                             doc.text(65, 92, lpg163);
                                             doc.text(65, 98, lpg164);
                                             doc.text(65, 106, lpg165);
                                             doc.text(102, 106, lpg166);
                                             doc.text(80, 112, lpg167);
                                             doc.text(95, 118, lpg168);
                                             doc.text(62, 124, lpg169);
                                             doc.text(99, 124, lpg170);
                                             doc.text(75, 136, lpg171);
                                             doc.text(135, 136, lpg172);
                                             doc.text(75, 142, lpg173);
                                             doc.text(135, 142, lpg174);
                                             doc.text(75, 148, lpg175);

                                             doc.line(13, 151, 200, 151); // horizontal line (init_col, init_row, , )
                                             doc.setFontType("bolditalic");
                                             doc.text(13, 160, 'VII) REFERENCIAS PERSONALES Y LABORALES');
                                             doc.text(13, 166, '* Referencias Personales:');
                                             doc.text(13, 172, '  a) NOMBRE:');
                                             doc.text(100, 172, '  TELEFONO:');
                                             doc.text(13, 178, '       E-MAIL:');
                                             doc.text(100, 178, '  OCUPACION:');
                                             doc.text(13, 184, '  b) NOMBRE:');
                                             doc.text(100, 184, '  TELEFONO:');
                                             doc.text(13, 190, '       E-MAIL:');
                                             doc.text(100, 190, '  OCUPACION:');
                                             doc.text(13, 196, '  c) NOMBRE:');
                                             doc.text(100, 196, '  TELEFONO:');
                                             doc.text(13, 202, '       E-MAIL:');
                                             doc.text(100, 202, '  OCUPACION:');
                                             doc.text(13, 208, '  d) NOMBRE:');
                                             doc.text(100, 208, '  TELEFONO:');
                                             doc.text(13, 214, '       E-MAIL:');
                                             doc.text(100, 214, '  OCUPACION:');
                                             doc.setFontType("normal");
                                             doc.text(35, 172, lpg176);
                                             doc.text(125, 172, lpg177);
                                             doc.text(35, 178, lpg178);
                                             doc.text(125, 178, lpg179);
                                             doc.text(35, 184, lpg180);
                                             doc.text(125, 184, lpg181);
                                             doc.text(35, 190, lpg182);
                                             doc.text(125, 190, lpg183);
                                             doc.text(35, 196, lpg184);
                                             doc.text(125, 196, lpg185);
                                             doc.text(35, 202, lpg186);
                                             doc.text(125, 202, lpg187);
                                             doc.text(35, 208, lpg188);
                                             doc.text(125, 208, lpg189);
                                             doc.text(35, 214, lpg190);
                                             doc.text(125, 214, lpg191);

                                             doc.setFontType("bolditalic");
                                             doc.text(13, 228, '* Referencias Labrales:');
                                             doc.text(13, 234, '  a) EMPRESA:');
                                             doc.text(100, 234, '  NOMBRE:');
                                             doc.text(13, 240, '       TEL Y E-MAIL:');
                                             doc.text(100, 240, '  OCUPACION:');
                                             doc.text(13, 246, '  b) EMPRESA:');
                                             doc.text(100, 246, '  NOMBRE:');
                                             doc.text(13, 252, '       TEL Y E-MAIL:');
                                             doc.text(100, 252, '  OCUPACION:');
                                             doc.text(13, 258, '  c) EMPRES:');
                                             doc.text(100, 258, '  NOMBRE:');
                                             doc.text(13, 264, '       TEL Y E-MAIL:');
                                             doc.text(100, 264, '  OCUPACION:');
                                             doc.text(13, 270, '  d) EMPRESA:');
                                             doc.text(100, 270, '  NOMBRE:');
                                             doc.text(13, 276, '       TEL Y E-MAIL:');
                                             doc.text(100, 276, '  OCUPACION:');
                                             doc.setFontType("normal");
                                             doc.text(37, 234, lpg192);
                                             doc.text(125, 234, lpg193);
                                             doc.text(43, 240, lpg194);
                                             doc.text(125, 240, lpg195);
                                             doc.text(37, 246, lpg196);
                                             doc.text(125, 246, lpg197);
                                             doc.text(43, 252, lpg198);
                                             doc.text(125, 252, lpg199);
                                             doc.text(37, 258, lpg200);
                                             doc.text(125, 258, lpg201);
                                             doc.text(43, 264, lpg202);
                                             doc.text(125, 264, lpg203);
                                             doc.text(37, 270, lpg204);
                                             doc.text(125, 270, lpg205);
                                             doc.text(43, 276, lpg206);
                                             doc.text(125, 276, lpg207);
                              },
                              crearPDF: function crearPDF() {

                                             /** CREACION DEL ARCHIVO PDF */
                                             var cadena = this.eval_solemp.nombre,
                                                 patron = / /g,
                                                 nuevoValor = "",
                                                 nusuario = cadena.replace(patron, nuevoValor);

                                             var nArchivo = "solemp_" + nusuario;
                                             console.log("archivo a crear ? ", nArchivo);

                                             var imagen = "data:image/jpeg;base64,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";
                                             var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
                                             var linea = 5;

                                             /** Muestra el logo.        (izq, top, ancho, alto) */
                                             doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
                                             /** fila, columna */

                                             /** CIRCULOS  */
                                             doc.setLineWidth(1); // Grosor de la línea del borde
                                             doc.setDrawColor(0);

                                             /** ................................................................................................................ 
                                             /* TEXTO INTRODUCTORIO */
                                             var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

                                             var lhoy = new Date();
                                             //lhoy=   lhoy.toString();
                                             var ldia = lhoy.getDate();
                                             var lmes = meses[lhoy.getMonth()];
                                             var lanio = lhoy.getFullYear();

                                             // console.log("lhoy ? ",lhoy);
                                             // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
                                             doc.setFontSize(9);
                                             doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
                                             doc.text(10, 30, "Evaluación de SOLICITUD DE EMPLEO para " + this.eval_solemp.nombre + " de " + this.eval_solemp.empresa);

                                             this.solicitud(doc);

                                             doc.save(nArchivo);
                                             doc.autoPrint();
                                             window.open(doc.output('bloburl'), '_blank');
                              },
                              addADayToMyDate: function addADayToMyDate() {
                                             if (this.eval_fecha) // as myDate can be null
                                                            // you have to set the this.myDate again, so vue can detect it changed
                                                            // this is not a caveat of this specific solution, but of any binding of dates
                                                            this.eval_solemp.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
                              },
                              dateToYYYYMMDD: function dateToYYYYMMDD(date) {
                                             console.log("***********************************************************************************");
                                             console.log("Estoy en dateToYYYYMMDD ");
                                             console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
                                             console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
                                             console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

                                             console.log("Desmenuzando ...");
                                             var a = date.toISOString();
                                             var b = a.split("T");
                                             var c = b[0];
                                             var d = b[1];
                                             console.log("a) date.toISOString() ", date.toISOString());
                                             console.log("b) ", a.split("T"));
                                             console.log("c) b[0]", b[0], "; b[1] ", b[1]);
                                             console.log("***********************************************************************************");

                                             // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
                                             return date && date.toISOString().split('T')[0];
                              },
                              cargaHora: function cargaHora() {

                                             // Convierte la hora obtenida a hora local (utc)
                                             // this.eval_fecha = new Date();
                                             var d = new Date();
                                             var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

                                             // obtain local UTC offset and convert to msec
                                             var localOffset = d.getTimezoneOffset() * 60000;
                                             var newdate = new Date(utcd + localOffset);
                                             var hours = newdate.getHours();
                                             var minutes = newdate.getMinutes();
                                             var seconds = newdate.getSeconds();
                                             var hora = hours + ":" + minutes + ":" + seconds;
                                             console.log("newdate ? ", newdate, " | ", hora);

                                             return hora;
                              },
                              cargaEvaluacion: function cargaEvaluacion() {

                                             this.ejemplo = {
                                                            pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
                                             };

                                             this.eval_solemp = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev08; // Crea el nodo para todos los campos.
                                             this.res_solemp = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs08;

                                             console.log("Cargando evaluación !");
                                             console.log(this.eval_solemp);
                                             this.eval_solemp.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
                                             this.eval_solemp.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
                                             this.eval_solemp.fecha = this.eval_fecha;

                                             this.instrucciones = this.eval_solemp.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de SOLICITUD DE EMPLEO.";

                                             // this.eval_fecha = new Date();                 // Fecha del Día
                              },
                              empezarEvaluacion: function empezarEvaluacion() {

                                             this.eval_solemp.empezo = this.cargaHora();
                                             this.inicioeval = true;
                              },

                              /** .................... VALIDACIONES  .................... */
                              limpiarEvaluacion: function limpiarEvaluacion() {

                                             this.ejemplo = {
                                                            pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
                                             };

                                             this.eval_solemp = {
                                                            depto: "",
                                                            empresa: "", nombre: "",
                                                            fecha: "",
                                                            empezo: "", termino: "",
                                                            pg001: "", pg002: "", pg003: new Date(), pg004: 0, pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
                                                            pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
                                                            pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
                                                            pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
                                                            pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: "", pg049: "", pg050: "",
                                                            pg051: "", pg052: "", pg053: "", pg054: "", pg055: "", pg056: "", pg057: "", pg058: "", pg059: "", pg060: "",
                                                            pg061: "", pg062: "", pg063: "", pg064: "", pg065: "", pg066: "", pg067: "", pg068: "", pg069: "", pg070: "",
                                                            pg071: "", pg072: "", pg073: "", pg074: "", pg075: "", pg076: "", pg077: "", pg078: "", pg079: "", pg080: "",
                                                            pg081: "", pg082: "", pg083: "", pg084: "", pg085: "", pg086: "", pg087: "", pg088: "", pg089: "", pg090: "",
                                                            pg091: "", pg092: "", pg093: "", pg094: "", pg095: "", pg096: "", pg097: "", pg098: "", pg099: "", pg100: "",
                                                            pg101: "", pg102: "", pg103: "", pg104: "", pg105: "", pg106: "", pg107: "", pg108: "", pg109: "", pg110: "",
                                                            pg111: "", pg112: "", pg113: "", pg114: "", pg115: "", pg116: "", pg117: "", pg118: "", pg119: "", pg120: "",
                                                            pg121: "", pg122: "", pg123: "", pg124: "", pg125: "", pg126: "", pg127: "", pg128: "", pg129: "", pg130: "",
                                                            pg131: "", pg132: "", pg133: "", pg134: "", pg135: "", pg136: "", pg137: "", pg138: "", pg139: "", pg140: "",
                                                            pg141: "", pg142: "", pg143: "", pg144: "", pg145: "", pg146: "", pg147: "", pg148: "", pg149: "", pg150: "",
                                                            pg151: "", pg152: "", pg153: "", pg154: "", pg155: "", pg156: "", pg157: "", pg158: "", pg159: "", pg160: "",
                                                            pg161: "", pg162: "", pg163: "", pg164: "", pg165: "", pg166: "", pg167: "", pg168: "", pg169: "", pg170: "",
                                                            pg171: "", pg172: "", pg173: "", pg174: "", pg175: "", pg176: "", pg177: "", pg178: "", pg179: "", pg180: "",
                                                            pg181: "", pg182: "", pg183: "", pg184: "", pg185: "", pg186: "", pg187: "", pg188: "", pg189: "", pg190: "",
                                                            pg191: "", pg192: "", pg193: "", pg194: "", pg195: "", pg196: "", pg197: "", pg198: "", pg199: "", pg200: "",
                                                            pg201: "", pg202: "", pg203: "", pg204: "", pg205: "", pg206: "", pg207: ""

                                                            /* Variables para un nuevo caso */
                                             };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.eval_solemp = this.eval_solemp;
                              },

                              /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
                              /* Acciones del Floatting Button: Agregar Encuesta */
                              agregarEvaluacion: function agregarEvaluacion() {
                                             var _this = this;

                                             this.finalizoeval = true;
                                             this.eval_solemp.termino = this.cargaHora();

                                             /** la pregunta 3 */
                                             var fecha3 = this.dateToYYYYMMDD(this.eval_solemp.pg003);
                                             console.log("fecha 3 ? ", fecha3, ", tipo ? ", typeof fecha3 === 'undefined' ? 'undefined' : _typeof(fecha3));

                                             var ldia2 = fecha3.substring(9, 10);
                                             var ldia22 = parseInt(ldia2);
                                             if (ldia22 <= 9) {
                                                            ldia2 = '0' + ldia2;
                                             } else {
                                                            ldia2 = ldia2;
                                             }
                                             var lmes2 = fecha3.substring(6, 7);
                                             var lmes22 = parseInt(lmes2);
                                             if (lmes22 <= 9) {
                                                            lmes2 = '0' + lmes2;
                                             } else {
                                                            lmes = lmes2;
                                             }
                                             var lanio = fecha3.substring(0, 4);
                                             console.log("dia ? ", ldia2, ", mes ? ", lmes2, ", anio ? ", lanio);
                                             var latres = ldia2 + '/' + lmes2 + '/' + lanio;
                                             console.log("latres ? ", latres);

                                             /** ****************************************** */
                                             // this.eval_fecha = new Date();

                                             var ldia = this.eval_fecha.getDate();
                                             if (ldia <= 9) {
                                                            ldia = '0' + ldia.toString().trim();
                                             } else {
                                                            ldia = ldia.toString().trim();
                                             }
                                             var lmes = this.eval_fecha.getMonth() + 1;
                                             if (lmes <= 9) {
                                                            lmes = '0' + lmes.toString().trim();
                                             } else {
                                                            lmes = lmes.toString().trim();
                                             }
                                             console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
                                             var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

                                             console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
                                             console.log("** fecha de ingreso ? ", this.eval_fecha);
                                             console.log("** formato  ingreso ? ", lingreso);
                                             console.log("bd ? ", __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalSolemp);
                                             console.log("solicitud ? ", this.eval_solemp);

                                             var confirma = confirm("Seguro de grabar la evaluación de SOLICITUD DE EMPLEO para " + this.eval_solemp.nombre.toUpperCase().trim() + " ?");
                                             if (confirma === true) {

                                                            /* Agrega una colección al objeto */
                                                            var dbEvaluaciones = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalSolemp;
                                                            dbEvaluaciones.push({

                                                                           empresa: this.eval_solemp.empresa, nombre: this.eval_solemp.nombre,
                                                                           empezo: this.eval_solemp.empezo, termino: this.eval_solemp.termino,
                                                                           fecha: lingreso, sexo: this.eval_solemp.sexo,
                                                                           pg001: this.eval_solemp.pg001, pg002: this.eval_solemp.pg002, pg003: latres, pg004: this.eval_solemp.pg004, pg005: this.eval_solemp.pg005,
                                                                           pg006: this.eval_solemp.pg006, pg007: this.eval_solemp.pg007, pg008: this.eval_solemp.pg008, pg009: this.eval_solemp.pg009, pg010: this.eval_solemp.pg010,
                                                                           pg011: this.eval_solemp.pg011, pg012: this.eval_solemp.pg012, pg013: this.eval_solemp.pg013, pg014: this.eval_solemp.pg014, pg015: this.eval_solemp.pg015,
                                                                           pg016: this.eval_solemp.pg016, pg017: this.eval_solemp.pg017, pg018: this.eval_solemp.pg018, pg019: this.eval_solemp.pg019, pg020: this.eval_solemp.pg020,
                                                                           pg021: this.eval_solemp.pg021, pg022: this.eval_solemp.pg022, pg023: this.eval_solemp.pg023, pg024: this.eval_solemp.pg024, pg025: this.eval_solemp.pg025,
                                                                           pg026: this.eval_solemp.pg026, pg027: this.eval_solemp.pg027, pg028: this.eval_solemp.pg028, pg029: this.eval_solemp.pg029, pg030: this.eval_solemp.pg030,
                                                                           pg031: this.eval_solemp.pg031, pg032: this.eval_solemp.pg032, pg033: this.eval_solemp.pg033, pg034: this.eval_solemp.pg034, pg035: this.eval_solemp.pg035,
                                                                           pg036: this.eval_solemp.pg036, pg037: this.eval_solemp.pg037, pg038: this.eval_solemp.pg038, pg039: this.eval_solemp.pg039, pg040: this.eval_solemp.pg040,
                                                                           pg041: this.eval_solemp.pg041, pg042: this.eval_solemp.pg042, pg043: this.eval_solemp.pg043, pg044: this.eval_solemp.pg044, pg045: this.eval_solemp.pg045,
                                                                           pg046: this.eval_solemp.pg046, pg047: this.eval_solemp.pg047, pg048: this.eval_solemp.pg048, pg049: this.eval_solemp.pg049, pg050: this.eval_solemp.pg050,
                                                                           pg051: this.eval_solemp.pg051, pg052: this.eval_solemp.pg052, pg053: this.eval_solemp.pg053, pg054: this.eval_solemp.pg054, pg055: this.eval_solemp.pg055,
                                                                           pg056: this.eval_solemp.pg056, pg057: this.eval_solemp.pg057, pg058: this.eval_solemp.pg058, pg059: this.eval_solemp.pg059, pg060: this.eval_solemp.pg060,
                                                                           pg061: this.eval_solemp.pg061, pg062: this.eval_solemp.pg062, pg063: this.eval_solemp.pg063, pg064: this.eval_solemp.pg064, pg065: this.eval_solemp.pg065,
                                                                           pg066: this.eval_solemp.pg066, pg067: this.eval_solemp.pg067, pg068: this.eval_solemp.pg068, pg069: this.eval_solemp.pg069, pg070: this.eval_solemp.pg070,
                                                                           pg071: this.eval_solemp.pg071, pg072: this.eval_solemp.pg072, pg073: this.eval_solemp.pg073, pg074: this.eval_solemp.pg074, pg075: this.eval_solemp.pg075,
                                                                           pg076: this.eval_solemp.pg076, pg077: this.eval_solemp.pg077, pg078: this.eval_solemp.pg078, pg079: this.eval_solemp.pg079, pg080: this.eval_solemp.pg080,
                                                                           pg081: this.eval_solemp.pg081, pg082: this.eval_solemp.pg082, pg083: this.eval_solemp.pg083, pg084: this.eval_solemp.pg084, pg085: this.eval_solemp.pg085,
                                                                           pg086: this.eval_solemp.pg086, pg087: this.eval_solemp.pg087, pg088: this.eval_solemp.pg088, pg089: this.eval_solemp.pg089, pg090: this.eval_solemp.pg090,
                                                                           pg091: this.eval_solemp.pg091, pg092: this.eval_solemp.pg092, pg093: this.eval_solemp.pg093, pg094: this.eval_solemp.pg094, pg095: this.eval_solemp.pg095,
                                                                           pg096: this.eval_solemp.pg096, pg097: this.eval_solemp.pg097, pg098: this.eval_solemp.pg098, pg099: this.eval_solemp.pg099, pg100: this.eval_solemp.pg100,
                                                                           pg101: this.eval_solemp.pg101, pg102: this.eval_solemp.pg102, pg103: this.eval_solemp.pg103, pg104: this.eval_solemp.pg104, pg105: this.eval_solemp.pg105,
                                                                           pg106: this.eval_solemp.pg106, pg107: this.eval_solemp.pg107, pg108: this.eval_solemp.pg108, pg109: this.eval_solemp.pg109, pg110: this.eval_solemp.pg110,

                                                                           pg111: this.eval_solemp.pg111, pg112: this.eval_solemp.pg112, pg113: this.eval_solemp.pg113, pg114: this.eval_solemp.pg114, pg115: this.eval_solemp.pg115,
                                                                           pg116: this.eval_solemp.pg116, pg117: this.eval_solemp.pg117, pg118: this.eval_solemp.pg118, pg119: this.eval_solemp.pg119, pg120: this.eval_solemp.pg120,
                                                                           pg121: this.eval_solemp.pg121, pg122: this.eval_solemp.pg122, pg123: this.eval_solemp.pg123, pg124: this.eval_solemp.pg124, pg125: this.eval_solemp.pg125,
                                                                           pg126: this.eval_solemp.pg126, pg127: this.eval_solemp.pg127, pg128: this.eval_solemp.pg128, pg129: this.eval_solemp.pg129, pg130: this.eval_solemp.pg130,
                                                                           pg131: this.eval_solemp.pg131, pg132: this.eval_solemp.pg132, pg133: this.eval_solemp.pg133, pg134: this.eval_solemp.pg134, pg135: this.eval_solemp.pg135,
                                                                           pg136: this.eval_solemp.pg136, pg137: this.eval_solemp.pg137, pg138: this.eval_solemp.pg138, pg139: this.eval_solemp.pg139, pg140: this.eval_solemp.pg140,
                                                                           pg141: this.eval_solemp.pg141, pg142: this.eval_solemp.pg142, pg143: this.eval_solemp.pg143, pg144: this.eval_solemp.pg144, pg145: this.eval_solemp.pg145,
                                                                           pg146: this.eval_solemp.pg146, pg147: this.eval_solemp.pg147, pg148: this.eval_solemp.pg148, pg149: this.eval_solemp.pg149, pg150: this.eval_solemp.pg150,
                                                                           pg151: this.eval_solemp.pg151, pg152: this.eval_solemp.pg152, pg153: this.eval_solemp.pg153, pg154: this.eval_solemp.pg154, pg155: this.eval_solemp.pg155,
                                                                           pg156: this.eval_solemp.pg156, pg157: this.eval_solemp.pg157, pg158: this.eval_solemp.pg158, pg159: this.eval_solemp.pg159, pg160: this.eval_solemp.pg160,
                                                                           pg161: this.eval_solemp.pg161, pg162: this.eval_solemp.pg162, pg163: this.eval_solemp.pg163, pg164: this.eval_solemp.pg164, pg165: this.eval_solemp.pg165,
                                                                           pg166: this.eval_solemp.pg166, pg167: this.eval_solemp.pg167, pg168: this.eval_solemp.pg168, pg169: this.eval_solemp.pg169, pg170: this.eval_solemp.pg170,
                                                                           pg171: this.eval_solemp.pg171, pg172: this.eval_solemp.pg172, pg173: this.eval_solemp.pg173, pg174: this.eval_solemp.pg174, pg175: this.eval_solemp.pg175,
                                                                           pg176: this.eval_solemp.pg176, pg177: this.eval_solemp.pg177, pg178: this.eval_solemp.pg178, pg179: this.eval_solemp.pg179, pg180: this.eval_solemp.pg180,
                                                                           pg181: this.eval_solemp.pg181, pg182: this.eval_solemp.pg182, pg183: this.eval_solemp.pg183, pg184: this.eval_solemp.pg184, pg185: this.eval_solemp.pg185,
                                                                           pg186: this.eval_solemp.pg186, pg187: this.eval_solemp.pg187, pg188: this.eval_solemp.pg188, pg189: this.eval_solemp.pg189, pg190: this.eval_solemp.pg190,
                                                                           pg191: this.eval_solemp.pg191, pg192: this.eval_solemp.pg192, pg193: this.eval_solemp.pg193, pg194: this.eval_solemp.pg194, pg195: this.eval_solemp.pg195,
                                                                           pg196: this.eval_solemp.pg196, pg197: this.eval_solemp.pg197, pg198: this.eval_solemp.pg198, pg199: this.eval_solemp.pg199, pg200: this.eval_solemp.pg200,
                                                                           pg201: this.eval_solemp.pg201, pg202: this.eval_solemp.pg202, pg203: this.eval_solemp.pg203, pg204: this.eval_solemp.pg204, pg205: this.eval_solemp.pg205,
                                                                           pg206: this.eval_solemp.pg206, pg207: this.eval_solemp.pg207

                                                            }).then(function (data) {

                                                                           /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                                                                           _this.limpiarEvaluacion();

                                                                           var laClave = data.key;
                                                                           _this.grabado = true;
                                                                           _this.inicioeval = false;

                                                                           // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                                                                           alert("Evaluación de SOLICITUD DE EMPLEO guardado con éxito.");
                                                            });
                                             } // if (confirma)
                              },
                              // agregarEncuesta()


                              //? =================================================================================
                              enfoqueG1: function enfoqueG1(pestana) {
                                             var _this2 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {
                                                            case 2:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt2.focus();
                                                                           });

                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = true;
                                                                           break;
                                                            case 3:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt3.focus();
                                                                           });
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "active";

                                                                           this.vertt2 = false;
                                                                           this.vertt3 = true;
                                                                           break;
                                                            case 4:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt4.focus();
                                                                           });
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "active";

                                                                           this.vertt3 = false;
                                                                           this.vertt4 = true;
                                                                           break;
                                                            case 5:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt5.focus();
                                                                           });
                                                                           this.activott4 = "!active";
                                                                           this.activott5 = "active";

                                                                           this.vertt4 = false;
                                                                           this.vertt5 = true;
                                                                           break;
                                                            case 6:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt6.focus();
                                                                           });
                                                                           this.activott5 = "!active";
                                                                           this.activott6 = "active";

                                                                           this.vertt5 = false;
                                                                           this.vertt6 = true;
                                                                           break;
                                                            case 7:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt7.focus();
                                                                           });
                                                                           this.activott6 = "!active";
                                                                           this.activott7 = "active";

                                                                           this.vertt6 = false;
                                                                           this.vertt7 = true;
                                                                           break;
                                                            case 8:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt8.focus();
                                                                           });
                                                                           this.activott9 = "!active";
                                                                           this.activott8 = "active";

                                                                           this.vertt7 = false;
                                                                           this.vertt8 = true;
                                                                           break;
                                                            case 9:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt9.focus();
                                                                           });
                                                                           this.activott8 = "!active";
                                                                           this.activott9 = "active";

                                                                           this.vertt8 = false;
                                                                           this.vertt9 = true;
                                                                           break;

                                                            case 0:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt1.focus();
                                                                           });
                                                                           this.activott9 = "!active";
                                                                           this.activott1 = "active";

                                                                           this.vertt9 = false;
                                                                           this.vertt1 = true;
                                                                           break;
                                                            default:
                                                            // code block
                                             } //* switch
                              },
                              nadaG1: function nadaG1(pestana) {
                                             var _this3 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {
                                                            case 1:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt1.focus();
                                                                           });

                                                                           this.activott1 = "active";
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "!active";
                                                                           this.activott5 = "!active";
                                                                           this.activott6 = "!active";
                                                                           this.activott7 = "!active";
                                                                           this.activott8 = "!active";
                                                                           this.activott9 = "!active";

                                                                           this.vertt1 = true;
                                                                           this.vertt2 = false;
                                                                           this.vertt3 = false;
                                                                           this.vertt4 = false;
                                                                           this.vertt5 = false;
                                                                           this.vertt6 = false;
                                                                           this.vertt7 = false;
                                                                           this.vertt8 = false;
                                                                           this.vertt9 = false;

                                                                           break;
                                                            case 2:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt2.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "active";
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "!active";
                                                                           this.activott5 = "!active";
                                                                           this.activott6 = "!active";
                                                                           this.activott7 = "!active";
                                                                           this.activott8 = "!active";
                                                                           this.activott9 = "!active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = true;
                                                                           this.vertt3 = false;
                                                                           this.vertt4 = false;
                                                                           this.vertt5 = false;
                                                                           this.vertt6 = false;
                                                                           this.vertt7 = false;
                                                                           this.vertt8 = false;
                                                                           this.vertt9 = false;

                                                                           break;
                                                            case 3:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt3.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "active";
                                                                           this.activott4 = "!active";
                                                                           this.activott5 = "!active";
                                                                           this.activott6 = "!active";
                                                                           this.activott7 = "!active";
                                                                           this.activott8 = "!active";
                                                                           this.activott9 = "!active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = false;
                                                                           this.vertt3 = true;
                                                                           this.vertt4 = false;
                                                                           this.vertt5 = false;
                                                                           this.vertt6 = false;
                                                                           this.vertt7 = false;
                                                                           this.vertt8 = false;
                                                                           this.vertt9 = false;
                                                                           break;
                                                            case 4:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt4.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "active";
                                                                           this.activott5 = "!active";
                                                                           this.activott6 = "!active";
                                                                           this.activott7 = "!active";
                                                                           this.activott8 = "!active";
                                                                           this.activott9 = "!active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = false;
                                                                           this.vertt3 = false;
                                                                           this.vertt4 = true;
                                                                           this.vertt5 = false;
                                                                           this.vertt6 = false;
                                                                           this.vertt7 = false;
                                                                           this.vertt8 = false;
                                                                           this.vertt9 = false;
                                                                           break;
                                                            case 5:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt5.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "!active";
                                                                           this.activott5 = "active";
                                                                           this.activott6 = "!active";
                                                                           this.activott7 = "!active";
                                                                           this.activott8 = "!active";
                                                                           this.activott9 = "!active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = false;
                                                                           this.vertt3 = false;
                                                                           this.vertt4 = false;
                                                                           this.vertt5 = true;
                                                                           this.vertt6 = false;
                                                                           this.vertt7 = false;
                                                                           this.vertt8 = false;
                                                                           this.vertt9 = false;
                                                                           break;
                                                            case 6:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt6.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "!active";
                                                                           this.activott5 = "!active";
                                                                           this.activott6 = "active";
                                                                           this.activott7 = "!active";
                                                                           this.activott8 = "!active";
                                                                           this.activott9 = "!active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = false;
                                                                           this.vertt3 = false;
                                                                           this.vertt4 = false;
                                                                           this.vertt5 = false;
                                                                           this.vertt6 = true;
                                                                           this.vertt7 = false;
                                                                           this.vertt8 = false;
                                                                           this.vertt9 = false;
                                                                           break;
                                                            case 7:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt7.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "!active";
                                                                           this.activott5 = "!active";
                                                                           this.activott6 = "!active";
                                                                           this.activott7 = "active";
                                                                           this.activott8 = "!active";
                                                                           this.activott9 = "!active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = false;
                                                                           this.vertt3 = false;
                                                                           this.vertt4 = false;
                                                                           this.vertt5 = false;
                                                                           this.vertt6 = false;
                                                                           this.vertt7 = true;
                                                                           this.vertt8 = false;
                                                                           this.vertt9 = false;
                                                                           break;
                                                            case 8:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt8.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "!active";
                                                                           this.activott5 = "!active";
                                                                           this.activott6 = "!active";
                                                                           this.activott7 = "!active";
                                                                           this.activott8 = "active";
                                                                           this.activott9 = "!active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = false;
                                                                           this.vertt3 = false;
                                                                           this.vertt4 = false;
                                                                           this.vertt5 = false;
                                                                           this.vertt6 = false;
                                                                           this.vertt7 = false;
                                                                           this.vertt8 = true;
                                                                           this.vertt9 = false;
                                                                           break;
                                                            case 9:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt9.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "!active";
                                                                           this.activott5 = "!active";
                                                                           this.activott6 = "!active";
                                                                           this.activott7 = "!active";
                                                                           this.activott8 = "!active";
                                                                           this.activott9 = "active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = false;
                                                                           this.vertt3 = false;
                                                                           this.vertt4 = false;
                                                                           this.vertt5 = false;
                                                                           this.vertt6 = false;
                                                                           this.vertt7 = false;
                                                                           this.vertt8 = false;
                                                                           this.vertt9 = true;
                                                                           break;

                                                            default:
                                                            // code block
                                             } //* switch
                              },
                              enfoqueRG1: function enfoqueRG1(pestana) {
                                             var _this4 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {

                                                            case 8:
                                                                           //* Estoy en 9 regreso a 8
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt8.focus();
                                                                           });

                                                                           this.activott9 = "!active";
                                                                           this.activott8 = "active";

                                                                           this.vertt9 = false;
                                                                           this.vertt8 = true;
                                                                           break;
                                                            case 7:
                                                                           //* Estoy en 8 regreso a 7
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt7.focus();
                                                                           });

                                                                           this.activott8 = "!active";
                                                                           this.activott7 = "active";

                                                                           this.vertt8 = false;
                                                                           this.vertt7 = true;
                                                                           break;
                                                            case 6:
                                                                           //* Estoy en 7 regreso a 6
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt6.focus();
                                                                           });

                                                                           this.activott7 = "!active";
                                                                           this.activott6 = "active";

                                                                           this.vertt7 = false;
                                                                           this.vertt6 = true;
                                                                           break;
                                                            case 5:
                                                                           //* Estoy en 6 regreso a 5
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt5.focus();
                                                                           });

                                                                           this.activott6 = "!active";
                                                                           this.activott5 = "active";

                                                                           this.vertt6 = false;
                                                                           this.vertt5 = true;
                                                                           break;

                                                            case 4:
                                                                           //* Estoy en 5 regreso a 4
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt4.focus();
                                                                           });

                                                                           this.activott5 = "!active";
                                                                           this.activott4 = "active";

                                                                           this.vertt5 = false;
                                                                           this.vertt4 = true;
                                                                           break;
                                                            case 3:
                                                                           //* Estoy en 4 regreso a 3
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt3.focus();
                                                                           });

                                                                           this.activott4 = "!active";
                                                                           this.activott3 = "active";

                                                                           this.vertt4 = false;
                                                                           this.vertt3 = true;
                                                                           break;
                                                            case 2:
                                                                           //* Estoy en 3 regreso a 2
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt2.focus();
                                                                           });

                                                                           this.activott3 = "!active";
                                                                           this.activott2 = "active";

                                                                           this.vertt3 = false;
                                                                           this.vertt2 = true;
                                                                           break;
                                                            case 1:
                                                                           //* Estoy en 2 regreso a 1
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt1.focus();
                                                                           });
                                                                           this.activott2 = "!active";
                                                                           this.activott1 = "active";

                                                                           this.vertt2 = false;
                                                                           this.vertt1 = true;
                                                                           break;
                                                            default:
                                                            // code block
                                             } //* switch
                              }
               } // methods
               // export

});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *      ev09_emoc.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
               name: 'emociones',
               components: {
                              'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
                              'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
               },
               template: '#formaemoc',
               data: function data() {
                              return {
                                             ejemplo: {},
                                             eval_emoc: {}, res: {},
                                             modo: "",
                                             eval_fecha: new Date(),
                                             instrucciones: "",
                                             inicioeval: false, finalizoeval: false, grabado: false,
                                             pregSinContestar: 0, ejeSinResponder: 0,

                                             //? .....................................................................................................................................................................................................................
                                             activott1: "active", activott2: '!active',
                                             vertt1: true, vertt2: false // return
                              };
               },
               // data()
               mounted: function mounted() {

                              /** Definiciones para el uso de los slides y tooltips */
                              var elems = document.querySelectorAll('.collapsible');
                              var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

                              var elems = document.querySelectorAll('.tooltipped');
                              var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

                              var elem = document.querySelectorAll('.tabs');
                              var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

                              /** obtiene localmente el caso definido en el almacén (store) */
                              this.cargaEvaluacion();
               },

               computed: {
                              l_sinResponder: function l_sinResponder() {
                                             return this.sinContestar();
                              },
                              l_ejeSinResponder: function l_ejeSinResponder() {
                                             return this.ejeSinContestar();
                              }
               },
               methods: {
                              crearPDF: function crearPDF() {

                                             /** CREACION DEL ARCHIVO PDF */
                                             var cadena = this.eval_emoc.nombre,
                                                 patron = / /g,
                                                 nuevoValor = "",
                                                 nusuario = cadena.replace(patron, nuevoValor);

                                             var nArchivo = "emoc_" + nusuario;
                                             console.log("archivo a crear ? ", nArchivo);

                                             var imagen = "data:image/jpeg;base64,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";
                                             var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
                                             var linea = 5;

                                             /** Muestra el logo.        (izq, top, ancho, alto) */
                                             doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
                                             /** fila, columna */

                                             /** CIRCULOS  */
                                             doc.setLineWidth(1); // Grosor de la línea del borde
                                             doc.setDrawColor(0);

                                             /** ................................................................................................................ 
                                             /* TEXTO INTRODUCTORIO */
                                             var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

                                             var lhoy = new Date();
                                             //lhoy=   lhoy.toString();
                                             var ldia = lhoy.getDate();
                                             var lmes = meses[lhoy.getMonth()];
                                             var lanio = lhoy.getFullYear();

                                             // console.log("lhoy ? ",lhoy);
                                             // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
                                             doc.setFontSize(9);
                                             doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
                                             doc.text(10, 30, "Evaluación de EMOCIONES para " + this.eval_emoc.nombre + " de " + this.eval_emoc.empresa + " ( " + this.eval_emoc.depto + " )");

                                             this.respuestas(doc);
                                             this.resultados(doc);

                                             doc.save(nArchivo);
                                             doc.autoPrint();
                                             window.open(doc.output('bloburl'), '_blank');
                              },
                              rangosemoc: function rangosemoc() {

                                             /* ==============================================================================================================
                                             *  AUTO CONCIENCIA */
                                             var comp1 = false;
                                             this.res_emoc.autocon_A = 0;
                                             this.res_emoc.autocon_B = 0;
                                             comp1 = this.eval_emoc.pg001 >= 1 && this.eval_emoc.pg001 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg006 >= 1 && this.eval_emoc.pg006 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg011 >= 1 && this.eval_emoc.pg011 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg012 >= 1 && this.eval_emoc.pg012 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg013 >= 1 && this.eval_emoc.pg013 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg014 >= 1 && this.eval_emoc.pg014 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg015 >= 1 && this.eval_emoc.pg015 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg017 >= 1 && this.eval_emoc.pg017 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg018 >= 1 && this.eval_emoc.pg018 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg019 >= 1 && this.eval_emoc.pg019 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg020 >= 1 && this.eval_emoc.pg020 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg021 >= 1 && this.eval_emoc.pg021 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1;
                                             } else {
                                                            this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1;
                                             }
                                             this.res_emoc.autocon = this.res_emoc.autocon_A + this.res_emoc.autocon_B;

                                             /* ==============================================================================================================
                                              *  CONTROL EMOCIONES */
                                             this.res_emoc.emocion_A = 0;
                                             this.res_emoc.emocion_B = 0;
                                             comp1 = this.eval_emoc.pg001 >= 1 && this.eval_emoc.pg001 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1;
                                             } else {
                                                            this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg002 >= 1 && this.eval_emoc.pg002 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1;
                                             } else {
                                                            this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg003 >= 1 && this.eval_emoc.pg003 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1;
                                             } else {
                                                            this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg004 >= 1 && this.eval_emoc.pg004 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1;
                                             } else {
                                                            this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg005 >= 1 && this.eval_emoc.pg005 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1;
                                             } else {
                                                            this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg007 >= 1 && this.eval_emoc.pg007 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1;
                                             } else {
                                                            this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg009 >= 1 && this.eval_emoc.pg009 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1;
                                             } else {
                                                            this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg010 >= 1 && this.eval_emoc.pg010 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1;
                                             } else {
                                                            this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg013 >= 1 && this.eval_emoc.pg013 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1;
                                             } else {
                                                            this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg027 >= 1 && this.eval_emoc.pg027 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1;
                                             } else {
                                                            this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1;
                                             }
                                             this.res_emoc.emocion = this.res_emoc.emocion_A + this.res_emoc.emocion_B;

                                             /* ==============================================================================================================
                                              *  CONTROL EMOCIONES */
                                             this.res_emoc.motivacion_A = 0;
                                             this.res_emoc.motivacion_B = 0;
                                             comp1 = this.eval_emoc.pg007 >= 1 && this.eval_emoc.pg007 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1;
                                             } else {
                                                            this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg022 >= 1 && this.eval_emoc.pg022 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1;
                                             } else {
                                                            this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg023 >= 1 && this.eval_emoc.pg023 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1;
                                             } else {
                                                            this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg025 >= 1 && this.eval_emoc.pg025 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1;
                                             } else {
                                                            this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg026 >= 1 && this.eval_emoc.pg026 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1;
                                             } else {
                                                            this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg027 >= 1 && this.eval_emoc.pg027 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1;
                                             } else {
                                                            this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg028 >= 1 && this.eval_emoc.pg028 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1;
                                             } else {
                                                            this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1;
                                             }
                                             this.res_emoc.motivacion = this.res_emoc.motivacion_A + this.res_emoc.motivacion_B;

                                             /* ==============================================================================================================
                                              *  CONTROL EMOCIONES */
                                             this.res_emoc.relacionarse_A = 0;
                                             this.res_emoc.relacionarse_B = 0;
                                             comp1 = this.eval_emoc.pg008 >= 1 && this.eval_emoc.pg008 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg010 >= 1 && this.eval_emoc.pg010 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg016 >= 1 && this.eval_emoc.pg016 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg019 >= 1 && this.eval_emoc.pg019 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg020 >= 1 && this.eval_emoc.pg020 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg029 >= 1 && this.eval_emoc.pg029 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg030 >= 1 && this.eval_emoc.pg030 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg031 >= 1 && this.eval_emoc.pg031 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg032 >= 1 && this.eval_emoc.pg032 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg033 >= 1 && this.eval_emoc.pg033 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg034 >= 1 && this.eval_emoc.pg034 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg035 >= 1 && this.eval_emoc.pg035 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg036 >= 1 && this.eval_emoc.pg036 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg037 >= 1 && this.eval_emoc.pg037 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg038 >= 1 && this.eval_emoc.pg038 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg039 >= 1 && this.eval_emoc.pg039 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg042 >= 1 && this.eval_emoc.pg042 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg043 >= 1 && this.eval_emoc.pg043 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg044 >= 1 && this.eval_emoc.pg044 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg045 >= 1 && this.eval_emoc.pg045 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1;
                                             } else {
                                                            this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1;
                                             }
                                             this.res_emoc.relacionarse = this.res_emoc.relacionarse_A + this.res_emoc.relacionarse_B;

                                             /* ==============================================================================================================
                                              *  AUTO CONCIENCIA */
                                             this.res_emoc.asesoria_A = 0;
                                             this.res_emoc.asesoria_B = 0;
                                             comp1 = this.eval_emoc.pg008 >= 1 && this.eval_emoc.pg008 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg010 >= 1 && this.eval_emoc.pg010 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg016 >= 1 && this.eval_emoc.pg016 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg018 >= 1 && this.eval_emoc.pg018 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg034 >= 1 && this.eval_emoc.pg034 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg035 >= 1 && this.eval_emoc.pg035 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg037 >= 1 && this.eval_emoc.pg037 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg038 >= 1 && this.eval_emoc.pg038 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg039 >= 1 && this.eval_emoc.pg039 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg040 >= 1 && this.eval_emoc.pg040 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg041 >= 1 && this.eval_emoc.pg041 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg044 >= 1 && this.eval_emoc.pg044 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             comp1 = this.eval_emoc.pg045 >= 1 && this.eval_emoc.pg045 <= 4;
                                             if (comp1 === true) {
                                                            this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1;
                                             } else {
                                                            this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1;
                                             }
                                             this.res_emoc.asesoria = this.res_emoc.asesoria_A + this.res_emoc.asesoria_B;
                              },
                              resultados: function resultados(doc) {
                                             this.res_emoc = {
                                                            autocon_A: 0, autocon_B: 0, autocon: 0,
                                                            emocion_A: 0, emocion_B: 0, emocion: 0,
                                                            motivacion_A: 0, motivacion_B: 0, motivacion: 0,
                                                            relacionarse_A: 0, relacionarse_B: 0, relacionarse: 0,
                                                            asesoria_A: 0, asesoria_B: 0, asesoria: 0
                                             };

                                             this.rangosemoc();

                                             doc.setLineWidth(0.25);

                                             doc.text(10, 88, "SECCION DE RESULTADOS ");
                                             doc.line(10, 89, 206, 89);

                                             var autocon_A = this.res_emoc.autocon_A;
                                             var autocon_B = this.res_emoc.autocon_B;
                                             var autocon = this.res_emoc.autocon;

                                             var emocion_A = this.res_emoc.emocion_A;
                                             var emocion_B = this.res_emoc.emocion_B;
                                             var emocion = this.res_emoc.emocion;

                                             var motivacion_A = this.res_emoc.motivacion_A;
                                             var motivacion_B = this.res_emoc.motivacion_B;
                                             var motivacion = this.res_emoc.motivacion;

                                             var relacionarse_A = this.res_emoc.relacionarse_A;
                                             var relacionarse_B = this.res_emoc.relacionarse_B;
                                             var relacionarse = this.res_emoc.relacionarse;

                                             var asesoria_A = this.res_emoc.asesoria_A;
                                             var asesoria_B = this.res_emoc.asesoria_B;
                                             var asesoria = this.res_emoc.asesoria;

                                             doc.text(43, 94, "APTITUD");doc.text(63, 94, "CON 4 MAS");doc.text(83, 94, "CON 5 O MAS");
                                             doc.text(43, 96, "-------------");doc.text(63, 96, "-----------------");doc.text(83, 96, "-------------------");
                                             doc.text(15, 100, "INTRA-PERSONAL");
                                             doc.text(15, 105, "Autoconciencia");
                                             doc.text(48, 105, autocon_A.toString());doc.text(68, 105, autocon_B.toString());doc.text(90, 105, autocon.toString());

                                             doc.text(15, 110, "Control Emociones");
                                             doc.text(48, 110, emocion_A.toString());doc.text(68, 110, emocion_B.toString());doc.text(90, 110, emocion.toString());

                                             doc.text(15, 115, "Automotivación");
                                             doc.text(48, 115, motivacion_A.toString());doc.text(68, 115, motivacion_B.toString());doc.text(90, 115, motivacion.toString());

                                             doc.text(15, 120, "INTER-PERSONAL");
                                             doc.text(15, 125, "Relacionarse bien");
                                             doc.text(48, 125, relacionarse_A.toString());doc.text(68, 125, relacionarse_B.toString());doc.text(90, 125, relacionarse.toString());

                                             doc.text(15, 130, "Asesoría emocional");
                                             doc.text(48, 130, asesoria_A.toString());doc.text(68, 130, asesoria_B.toString());doc.text(90, 130, asesoria.toString());
                              },
                              respuestas: function respuestas(doc) {

                                             console.log("EN RESPUESTAS");
                                             console.log(this.eval_emoc);

                                             /* Muestra las preguntas */
                                             /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
                                             doc.setLineWidth(0.25);
                                             doc.text(10, 40, "SECCION DE RESPUESTAS ");
                                             doc.line(10, 42, 190, 42);
                                             doc.text(10, 45, "01) ");doc.text(23, 45, this.eval_emoc.pg001.toString());doc.text(30, 45, "02) ");doc.text(43, 45, this.eval_emoc.pg002.toString());
                                             doc.text(50, 45, "03) ");doc.text(63, 45, this.eval_emoc.pg003.toString());doc.text(70, 45, "04) ");doc.text(83, 45, this.eval_emoc.pg004.toString());
                                             doc.text(90, 45, "05) ");doc.text(103, 45, this.eval_emoc.pg005.toString());doc.text(110, 45, "06) ");doc.text(123, 45, this.eval_emoc.pg006.toString());
                                             doc.text(130, 45, "07) ");doc.text(143, 45, this.eval_emoc.pg007.toString());doc.text(150, 45, "08) ");doc.text(163, 45, this.eval_emoc.pg008.toString());
                                             doc.text(170, 45, "09) ");doc.text(183, 45, this.eval_emoc.pg009.toString());
                                             doc.line(10, 46, 190, 46);
                                             console.log(this.eval_emoc.pg010, this.eval_emoc.pg011, this.eval_emoc.pg012, this.eval_emoc.pg013, this.eval_emoc.pg014, this.eval_emoc.pg015, this.eval_emoc.pg016, this.eval_emoc.pg017, this.eval_emoc.pg018);
                                             // let pg10 = this.eval_emoc.pg010; let pg11 = this.eval_emoc.pg011; let pg12 = this.eval_emoc.pg012; let pg13 = this.eval_emoc.pg013; 
                                             // let pg15 = this.eval_emoc.pg014; let pg15 = this.eval_emoc.pg015; let pg17 = this.eval_emoc.pg017; let pg18 = this.eval_emoc.pg018
                                             doc.text(10, 49, "10) ");doc.text(23, 49, this.eval_emoc.pg010.toString());doc.text(30, 49, "11) ");doc.text(43, 49, this.eval_emoc.pg011.toString());
                                             doc.text(50, 49, "12) ");doc.text(63, 49, this.eval_emoc.pg012.toString());doc.text(70, 49, "13) ");doc.text(83, 49, this.eval_emoc.pg013.toString());
                                             doc.text(90, 49, "14) ");doc.text(103, 49, this.eval_emoc.pg014.toString());doc.text(110, 49, "15) ");doc.text(123, 49, this.eval_emoc.pg015.toString());
                                             doc.text(130, 49, "16) ");doc.text(143, 49, this.eval_emoc.pg016.toString());doc.text(150, 49, "17) ");doc.text(163, 49, this.eval_emoc.pg017.toString());
                                             doc.text(170, 49, "18) ");doc.text(183, 49, this.eval_emoc.pg018.toString());
                                             doc.line(10, 50, 190, 50);
                                             doc.text(10, 53, "19) ");doc.text(23, 53, this.eval_emoc.pg019.toString());doc.text(30, 53, "20) ");doc.text(43, 53, this.eval_emoc.pg020.toString());
                                             doc.text(50, 53, "21) ");doc.text(63, 53, this.eval_emoc.pg021.toString());doc.text(70, 53, "22) ");doc.text(83, 53, this.eval_emoc.pg022.toString());
                                             doc.text(90, 53, "23) ");doc.text(103, 53, this.eval_emoc.pg023.toString());doc.text(110, 53, "24) ");doc.text(123, 53, this.eval_emoc.pg024.toString());
                                             doc.text(130, 53, "25) ");doc.text(143, 53, this.eval_emoc.pg025.toString());doc.text(150, 53, "26) ");doc.text(163, 53, this.eval_emoc.pg026.toString());
                                             doc.text(170, 53, "27) ");doc.text(183, 53, this.eval_emoc.pg027.toString());
                                             doc.line(10, 54, 190, 54);
                                             doc.text(10, 57, "28) ");doc.text(23, 57, this.eval_emoc.pg028.toString());doc.text(30, 57, "29) ");doc.text(43, 57, this.eval_emoc.pg029.toString());
                                             doc.text(50, 57, "30) ");doc.text(63, 57, this.eval_emoc.pg030.toString());doc.text(70, 57, "31) ");doc.text(83, 57, this.eval_emoc.pg031.toString());
                                             doc.text(90, 57, "32) ");doc.text(103, 57, this.eval_emoc.pg032.toString());doc.text(110, 57, "33) ");doc.text(123, 57, this.eval_emoc.pg033.toString());
                                             doc.text(130, 57, "34) ");doc.text(143, 57, this.eval_emoc.pg034.toString());doc.text(150, 57, "35) ");doc.text(163, 57, this.eval_emoc.pg035.toString());
                                             doc.text(170, 57, "36) ");doc.text(183, 57, this.eval_emoc.pg036.toString());
                                             doc.line(10, 58, 190, 58);
                                             doc.text(10, 61, "37) ");doc.text(23, 61, this.eval_emoc.pg037.toString());doc.text(30, 61, "38) ");doc.text(43, 61, this.eval_emoc.pg038.toString());
                                             doc.text(50, 61, "39) ");doc.text(63, 61, this.eval_emoc.pg039.toString());doc.text(70, 61, "40) ");doc.text(83, 61, this.eval_emoc.pg040.toString());
                                             doc.text(90, 61, "41) ");doc.text(103, 61, this.eval_emoc.pg041.toString());doc.text(110, 61, "42) ");doc.text(123, 61, this.eval_emoc.pg042.toString());
                                             doc.text(130, 61, "43) ");doc.text(143, 61, this.eval_emoc.pg043.toString());doc.text(150, 61, "44) ");doc.text(163, 61, this.eval_emoc.pg044.toString());
                                             doc.text(170, 61, "45) ");doc.text(183, 61, this.eval_emoc.pg045.toString());
                                             doc.line(10, 62, 190, 62);
                              },

                              ejeSinContestar: function ejeSinContestar() {

                                             this.ejeSinResponder = 0;
                                             console.log("1 ? ", this.ejemplo.pg001);
                                             if (this.ejemplo.pg001 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }
                                             if (this.ejemplo.pg002 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }
                                             if (this.ejemplo.pg003 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }
                                             if (this.ejemplo.pg004 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }
                                             if (this.ejemplo.pg005 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }

                                             return this.ejeSinResponder;
                              },
                              sinContestar: function sinContestar() {

                                             this.pregSinContestar = 0;

                                             if (this.eval_emoc.pg001 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg002 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg003 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg004 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg005 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg006 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg007 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg008 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg009 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg010 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg011 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg012 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg013 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg014 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg015 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg016 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg017 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg018 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg019 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg020 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg021 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg022 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg023 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg024 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg025 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }

                                             if (this.eval_emoc.pg026 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg027 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg028 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg029 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg030 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg031 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg032 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg033 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg034 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg035 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg036 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg037 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg038 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg039 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg040 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg041 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg042 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg043 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg044 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_emoc.pg045 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }

                                             return this.pregSinContestar;
                              },
                              addADayToMyDate: function addADayToMyDate() {
                                             if (this.eval_fecha) // as myDate can be null
                                                            // you have to set the this.myDate again, so vue can detect it changed
                                                            // this is not a caveat of this specific solution, but of any binding of dates
                                                            this.eval_emoc.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
                              },
                              dateToYYYYMMDD: function dateToYYYYMMDD(date) {
                                             console.log("***********************************************************************************");
                                             console.log("Estoy en dateToYYYYMMDD ");
                                             console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
                                             console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
                                             console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

                                             console.log("Desmenuzando ...");
                                             var a = date.toISOString();
                                             var b = a.split("T");
                                             var c = b[0];
                                             var d = b[1];
                                             console.log("a) date.toISOString() ", date.toISOString());
                                             console.log("b) ", a.split("T"));
                                             console.log("c) b[0]", b[0], "; b[1] ", b[1]);
                                             console.log("***********************************************************************************");

                                             // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
                                             return date && date.toISOString().split('T')[0];
                              },
                              cargaHora: function cargaHora() {

                                             // Convierte la hora obtenida a hora local (utc)
                                             this.eval_fecha = new Date();
                                             var d = this.eval_fecha;
                                             var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

                                             // obtain local UTC offset and convert to msec
                                             var localOffset = d.getTimezoneOffset() * 60000;
                                             var newdate = new Date(utcd + localOffset);
                                             var hours = newdate.getHours();
                                             var minutes = newdate.getMinutes();
                                             var seconds = newdate.getSeconds();
                                             var hora = hours + ":" + minutes + ":" + seconds;
                                             console.log("newdate ? ", newdate, " | ", hora);

                                             return hora;
                              },
                              cargaEvaluacion: function cargaEvaluacion() {

                                             this.ejemplo = {
                                                            pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
                                             };

                                             this.eval_emoc = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev09; // Crea el nodo para todos los campos.
                                             this.res_emoc = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs09;
                                             console.log("res ? ", this.res_emoc);

                                             this.eval_emoc.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
                                             this.eval_emoc.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
                                             this.eval_emoc.depto = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_depto; // Nombre de la empresa a la cual pertenece el usuario
                                             this.eval_emoc.sexo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_sexo; // Nombre de la empresa a la cual pertenece el usuario

                                             this.instrucciones = this.eval_emoc.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de EMOCIONES.";

                                             this.eval_fecha = new Date(); // Fecha del Día

                                             console.log("[ CARGANDO ]", this.eval_emoc);
                              },
                              empezarEvaluacion: function empezarEvaluacion() {

                                             this.eval_emoc.empezo = this.cargaHora();
                                             this.inicioeval = true;
                              },

                              /** .................... VALIDACIONES  .................... */
                              validarValor: function validarValor(valor) {
                                             var lvalor = valor;
                                             if (valor < 1 || valor > 2) {
                                                            lvalor = 0;
                                             }
                                             // console.log("validarValor, lvalor ? ",lvalor);
                                             return lvalor;
                              },
                              limpiarEvaluacion: function limpiarEvaluacion() {

                                             this.ejemplo = {
                                                            pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
                                             };

                                             this.eval_emoc = {
                                                            depto: "",
                                                            empresa: "", nombre: "",
                                                            fecha: "",
                                                            empezo: "", termino: "",
                                                            pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                                                            pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                                                            pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
                                                            pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
                                                            pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0

                                                            /* Variables para un nuevo caso */
                                             };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.eval_emoc = this.eval_emoc;
                              },

                              /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
                              /* Acciones del Floatting Button: Agregar Encuesta */
                              agregarEvaluacion: function agregarEvaluacion() {
                                             var _this = this;

                                             if (this.pregSinContestar > 0) {
                                                            alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ");
                                                            return;
                                             }

                                             this.finalizoeval = true;
                                             this.eval_emoc.termino = this.cargaHora();

                                             this.eval_fecha = new Date();

                                             var ldia = this.eval_fecha.getDate();
                                             if (ldia <= 9) {
                                                            ldia = '0' + ldia.toString().trim();
                                             } else {
                                                            ldia = ldia.toString().trim();
                                             }
                                             var lmes = this.eval_fecha.getMonth() + 1;
                                             if (lmes <= 9) {
                                                            lmes = '0' + lmes.toString().trim();
                                             } else {
                                                            lmes = lmes.toString().trim();
                                             }
                                             console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
                                             var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

                                             console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
                                             console.log("** fecha de ingreso ? ", this.eval_fecha);
                                             console.log("** formato  ingreso ? ", lingreso);
                                             console.log(this.eval_emoc.pg001);

                                             var confirma = confirm("Seguro de grabar la evaluación de EMOCIONES para " + this.eval_emoc.nombre.toUpperCase().trim() + " ?");
                                             if (confirma === true) {

                                                            /* Agrega una colección al objeto */
                                                            var dbEvaluaciones = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalEmoc;
                                                            dbEvaluaciones.push({

                                                                           empresa: this.eval_emoc.empresa, nombre: this.eval_emoc.nombre,
                                                                           empezo: this.eval_emoc.empezo, termino: this.eval_emoc.termino,
                                                                           fecha: lingreso, sexo: this.eval_emoc.sexo, depto: this.eval_emoc.depto,
                                                                           pg001: this.eval_emoc.pg001, pg002: this.eval_emoc.pg002, pg003: this.eval_emoc.pg003, pg004: this.eval_emoc.pg004, pg005: this.eval_emoc.pg005,
                                                                           pg006: this.eval_emoc.pg006, pg007: this.eval_emoc.pg007, pg008: this.eval_emoc.pg008, pg009: this.eval_emoc.pg009, pg010: this.eval_emoc.pg010,
                                                                           pg011: this.eval_emoc.pg011, pg012: this.eval_emoc.pg012, pg013: this.eval_emoc.pg013, pg014: this.eval_emoc.pg014, pg015: this.eval_emoc.pg015,
                                                                           pg016: this.eval_emoc.pg016, pg017: this.eval_emoc.pg017, pg018: this.eval_emoc.pg018, pg019: this.eval_emoc.pg019, pg020: this.eval_emoc.pg020,
                                                                           pg021: this.eval_emoc.pg021, pg022: this.eval_emoc.pg022, pg023: this.eval_emoc.pg023, pg024: this.eval_emoc.pg024, pg025: this.eval_emoc.pg025,
                                                                           pg026: this.eval_emoc.pg026, pg027: this.eval_emoc.pg027, pg028: this.eval_emoc.pg028, pg029: this.eval_emoc.pg029, pg030: this.eval_emoc.pg030,
                                                                           pg031: this.eval_emoc.pg031, pg032: this.eval_emoc.pg032, pg033: this.eval_emoc.pg033, pg034: this.eval_emoc.pg034, pg035: this.eval_emoc.pg035,
                                                                           pg036: this.eval_emoc.pg036, pg037: this.eval_emoc.pg037, pg038: this.eval_emoc.pg038, pg039: this.eval_emoc.pg039, pg040: this.eval_emoc.pg040,
                                                                           pg041: this.eval_emoc.pg041, pg042: this.eval_emoc.pg042, pg043: this.eval_emoc.pg043, pg044: this.eval_emoc.pg044, pg045: this.eval_emoc.pg045
                                                            }).then(function (data) {

                                                                           /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                                                                           _this.limpiarEvaluacion();

                                                                           var laClave = data.key;
                                                                           _this.grabado = true;
                                                                           _this.inicioeval = false;

                                                                           // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                                                                           alert("Evaluación de EMOCIONES guardado con éxito.");
                                                            });
                                             } // if (confirma)
                              },
                              // agregarEncuesta()

                              //? =================================================================================
                              enfoqueG1: function enfoqueG1(pestana) {
                                             var _this2 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {
                                                            case 2:
                                                                           //* Vengo de 1, voy a 2
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt2.focus();
                                                                           });

                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = true;
                                                                           break;
                                                            case 0:
                                                                           //* Vengo de 2, voy a 1
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt1.focus();
                                                                           });
                                                                           this.activott2 = "!active";
                                                                           this.activott1 = "active";

                                                                           this.vertt2 = false;
                                                                           this.vertt1 = true;
                                                                           break;
                                                            default:
                                                            // code block
                                             } //* switch
                              },
                              nadaG1: function nadaG1(pestana) {
                                             var _this3 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {
                                                            case 1:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt1.focus();
                                                                           });

                                                                           this.activott1 = "active";
                                                                           this.activott2 = "!active";

                                                                           this.vertt1 = true;
                                                                           this.vertt2 = false;

                                                                           break;
                                                            case 2:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt2.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = true;

                                                                           break;
                                                            default:
                                                            // code block
                                             } //* switch
                              },
                              enfoqueRG1: function enfoqueRG1(pestana) {
                                             var _this4 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {
                                                            case 1:
                                                                           //* Estoy en 2 regreso a 1
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt1.focus();
                                                                           });
                                                                           this.activott2 = "!active";
                                                                           this.activott1 = "active";

                                                                           this.vertt2 = false;
                                                                           this.vertt1 = true;
                                                                           break;
                                                            default:
                                                            // code block
                                             } //* switch
                              }
               } // methods
               // export

});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *      ev10_vtas.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
               name: 'factores',
               components: {
                              'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
                              'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
               },
               template: '#formavtas',
               data: function data() {
                              return {
                                             ejemplo: {},
                                             eval_vtas: {}, res: {},
                                             modo: "",
                                             eval_fecha: new Date(),
                                             instrucciones: "",
                                             inicioeval: false, finalizoeval: false, grabado: false,
                                             pregSinContestar: 0, ejeSinResponder: 0,

                                             //? .....................................................................................................................................................................................................................
                                             activott1: "active", activott2: '!active', activott3: "!active", activott4: "!active",
                                             vertt1: true, vertt2: false, vertt3: false, vertt4: false,
                                             area1: "", area2: '', area3: '', area4: "" // return
                              };
               },
               // data()
               mounted: function mounted() {

                              /** Definiciones para el uso de los slides y tooltips */
                              var elems = document.querySelectorAll('.collapsible');
                              var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

                              var elems = document.querySelectorAll('.tooltipped');
                              var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

                              var elem = document.querySelectorAll('.tabs');
                              var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

                              /** obtiene localmente el caso definido en el almacén (store) */
                              this.cargaEvaluacion();
               },

               computed: {
                              l_sinResponder: function l_sinResponder() {
                                             return this.sinContestar();
                              },
                              l_ejeSinResponder: function l_ejeSinResponder() {
                                             return this.ejeSinContestar();
                              }
               },
               methods: {
                              crearPDF: function crearPDF() {

                                             /** CREACION DEL ARCHIVO PDF */
                                             var cadena = this.eval_vtas.nombre,
                                                 patron = / /g,
                                                 nuevoValor = "",
                                                 nusuario = cadena.replace(patron, nuevoValor);

                                             var nArchivo = "vtas_" + nusuario;
                                             console.log("archivo a crear ? ", nArchivo);

                                             var imagen = "data:image/jpeg;base64,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";
                                             var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
                                             var linea = 5;

                                             /** Muestra el logo.        (izq, top, ancho, alto) */
                                             doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
                                             /** fila, columna */

                                             /** CIRCULOS  */
                                             doc.setLineWidth(1); // Grosor de la línea del borde
                                             doc.setDrawColor(0);

                                             /** ................................................................................................................ 
                                             /* TEXTO INTRODUCTORIO */
                                             var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

                                             var lhoy = new Date();
                                             //lhoy=   lhoy.toString();
                                             var ldia = lhoy.getDate();
                                             var lmes = meses[lhoy.getMonth()];
                                             var lanio = lhoy.getFullYear();

                                             // console.log("lhoy ? ",lhoy);
                                             // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
                                             doc.setFontSize(9);
                                             doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
                                             doc.text(10, 30, "Evaluación ORIENTACION EN VENTAS para " + this.eval_vtas.nombre + " de " + this.eval_vtas.empresa + " ( " + this.eval_vtas.depto + " )");

                                             this.respuestas(doc);
                                             this.resultados(doc);

                                             doc.save(nArchivo);
                                             doc.autoPrint();
                                             window.open(doc.output('bloburl'), '_blank');
                              },
                              rangosvtas: function rangosvtas() {
                                             this.res_vtas = {
                                                            grupo1: 0, grupo2: 0, grupo3: 0, grupo4: 0,
                                                            grupo5: 0, grupo6: 0, grupo7: 0, grupo8: 0,
                                                            grupoR: 0, grupoA: 0, grupoCol: 0
                                                            /* ==============================================================================================================
                                                             *  AUTO CONCIENCIA */

                                             };this.res_vtas.grupo1 = 0;
                                             if (this.eval_vtas.pg001 === "b") {
                                                            this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1;
                                             }
                                             if (this.eval_vtas.pg002 === "b") {
                                                            this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1;
                                             }
                                             if (this.eval_vtas.pg019 === "c") {
                                                            this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1;
                                             }
                                             if (this.eval_vtas.pg020 === "b") {
                                                            this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1;
                                             }
                                             if (this.eval_vtas.pg037 === "a") {
                                                            this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1;
                                             }
                                             if (this.eval_vtas.pg038 === "c") {
                                                            this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1;
                                             }
                                             if (this.eval_vtas.pg055 === "b") {
                                                            this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1;
                                             }
                                             if (this.eval_vtas.pg056 === "a") {
                                                            this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1;
                                             }
                                             if (this.eval_vtas.pg073 === "c") {
                                                            this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1;
                                             }
                                             if (this.eval_vtas.pg074 === "a") {
                                                            this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1;
                                             }
                                             if (this.eval_vtas.pg075 === "c") {
                                                            this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1;
                                             }

                                             this.res_vtas.grupo2 = 0;
                                             if (this.eval_vtas.pg003 === "b") {
                                                            this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1;
                                             }
                                             if (this.eval_vtas.pg004 === "b") {
                                                            this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1;
                                             }
                                             if (this.eval_vtas.pg021 === "c") {
                                                            this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1;
                                             }
                                             if (this.eval_vtas.pg022 === "c") {
                                                            this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1;
                                             }
                                             if (this.eval_vtas.pg039 === "a") {
                                                            this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1;
                                             }
                                             if (this.eval_vtas.pg040 === "a") {
                                                            this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1;
                                             }
                                             if (this.eval_vtas.pg057 === "a") {
                                                            this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1;
                                             }
                                             if (this.eval_vtas.pg058 === "c") {
                                                            this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1;
                                             }
                                             if (this.eval_vtas.pg059 === "b") {
                                                            this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1;
                                             }
                                             if (this.eval_vtas.pg076 === "c") {
                                                            this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1;
                                             }
                                             if (this.eval_vtas.pg077 === "b") {
                                                            this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1;
                                             }

                                             this.res_vtas.grupo3 = 0;
                                             if (this.eval_vtas.pg005 === "a") {
                                                            this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1;
                                             }
                                             if (this.eval_vtas.pg006 === "c") {
                                                            this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1;
                                             }
                                             if (this.eval_vtas.pg007 === "a") {
                                                            this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1;
                                             }
                                             if (this.eval_vtas.pg023 === "b") {
                                                            this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1;
                                             }
                                             if (this.eval_vtas.pg024 === "c") {
                                                            this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1;
                                             }
                                             if (this.eval_vtas.pg025 === "c") {
                                                            this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1;
                                             }
                                             if (this.eval_vtas.pg041 === "a") {
                                                            this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1;
                                             }
                                             if (this.eval_vtas.pg042 === "a") {
                                                            this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1;
                                             }
                                             if (this.eval_vtas.pg043 === "b") {
                                                            this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1;
                                             }
                                             if (this.eval_vtas.pg060 === "b") {
                                                            this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1;
                                             }
                                             if (this.eval_vtas.pg078 === "b") {
                                                            this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1;
                                             }

                                             this.res_vtas.grupo4 = 0;
                                             if (this.eval_vtas.pg008 === "b") {
                                                            this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1;
                                             }
                                             if (this.eval_vtas.pg026 === "b") {
                                                            this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1;
                                             }
                                             if (this.eval_vtas.pg044 === "a") {
                                                            this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1;
                                             }
                                             if (this.eval_vtas.pg061 === "b") {
                                                            this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1;
                                             }
                                             if (this.eval_vtas.pg062 === "a") {
                                                            this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1;
                                             }
                                             if (this.eval_vtas.pg079 === "b") {
                                                            this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1;
                                             }
                                             if (this.eval_vtas.pg080 === "c") {
                                                            this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1;
                                             }
                                             if (this.eval_vtas.pg081 === "c") {
                                                            this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1;
                                             }
                                             this.res_vtas.grupo4 = 8 - this.res_vtas.grupo4;

                                             this.res_vtas.grupo5 = 0;
                                             if (this.eval_vtas.pg009 === "a") {
                                                            this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1;
                                             }
                                             if (this.eval_vtas.pg010 === "b") {
                                                            this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1;
                                             }
                                             if (this.eval_vtas.pg011 === "b") {
                                                            this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1;
                                             }
                                             if (this.eval_vtas.pg027 === "a") {
                                                            this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1;
                                             }
                                             if (this.eval_vtas.pg028 === "c") {
                                                            this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1;
                                             }
                                             if (this.eval_vtas.pg029 === "c") {
                                                            this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1;
                                             }
                                             if (this.eval_vtas.pg045 === "b") {
                                                            this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1;
                                             }
                                             if (this.eval_vtas.pg046 === "b") {
                                                            this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1;
                                             }
                                             if (this.eval_vtas.pg063 === "b") {
                                                            this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1;
                                             }
                                             if (this.eval_vtas.pg064 === "a") {
                                                            this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1;
                                             }
                                             if (this.eval_vtas.pg082 === "c") {
                                                            this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1;
                                             }

                                             this.res_vtas.grupo6 = 0;
                                             if (this.eval_vtas.pg012 === "c") {
                                                            this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1;
                                             }
                                             if (this.eval_vtas.pg013 === "b") {
                                                            this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1;
                                             }
                                             if (this.eval_vtas.pg030 === "b") {
                                                            this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1;
                                             }
                                             if (this.eval_vtas.pg031 === "c") {
                                                            this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1;
                                             }
                                             if (this.eval_vtas.pg047 === "c") {
                                                            this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1;
                                             }
                                             if (this.eval_vtas.pg048 === "a") {
                                                            this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1;
                                             }
                                             if (this.eval_vtas.pg049 === "a") {
                                                            this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1;
                                             }
                                             if (this.eval_vtas.pg065 === "c") {
                                                            this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1;
                                             }
                                             if (this.eval_vtas.pg066 === "a") {
                                                            this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1;
                                             }
                                             if (this.eval_vtas.pg083 === "b") {
                                                            this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1;
                                             }
                                             if (this.eval_vtas.pg084 === "a") {
                                                            this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1;
                                             }

                                             this.res_vtas.grupo7 = 0;
                                             if (this.eval_vtas.pg014 === "b") {
                                                            this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1;
                                             }
                                             if (this.eval_vtas.pg032 === "c") {
                                                            this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1;
                                             }
                                             if (this.eval_vtas.pg050 === "c") {
                                                            this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1;
                                             }
                                             if (this.eval_vtas.pg067 === "b") {
                                                            this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1;
                                             }
                                             if (this.eval_vtas.pg068 === "a") {
                                                            this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1;
                                             }
                                             if (this.eval_vtas.pg085 === "c") {
                                                            this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1;
                                             }
                                             if (this.eval_vtas.pg086 === "a") {
                                                            this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1;
                                             }
                                             if (this.eval_vtas.pg087 === "a") {
                                                            this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1;
                                             }

                                             this.res_vtas.grupo8 = 0;
                                             if (this.eval_vtas.pg015 === "a") {
                                                            this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1;
                                             }
                                             if (this.eval_vtas.pg033 === "b") {
                                                            this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1;
                                             }
                                             if (this.eval_vtas.pg034 === "c") {
                                                            this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1;
                                             }
                                             if (this.eval_vtas.pg051 === "b") {
                                                            this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1;
                                             }
                                             if (this.eval_vtas.pg052 === "a") {
                                                            this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1;
                                             }
                                             if (this.eval_vtas.pg069 === "b") {
                                                            this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1;
                                             }
                                             if (this.eval_vtas.pg070 === "c") {
                                                            this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1;
                                             }
                                             if (this.eval_vtas.pg071 === "b") {
                                                            this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1;
                                             }

                                             this.res_vtas.grupo9 = 0;
                                             if (this.eval_vtas.pg016 === "c") {
                                                            this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1;
                                             }
                                             if (this.eval_vtas.pg017 === "b") {
                                                            this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1;
                                             }
                                             if (this.eval_vtas.pg018 === "c") {
                                                            this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1;
                                             }
                                             if (this.eval_vtas.pg035 === "a") {
                                                            this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1;
                                             }
                                             if (this.eval_vtas.pg036 === "c") {
                                                            this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1;
                                             }
                                             if (this.eval_vtas.pg053 === "b") {
                                                            this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1;
                                             }
                                             if (this.eval_vtas.pg054 === "a") {
                                                            this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1;
                                             }
                                             if (this.eval_vtas.pg072 === "a") {
                                                            this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1;
                                             }
                                             console.log("17 ", this.eval_vtas.pg017);
                                             console.log("18 ", this.eval_vtas.pg018);
                                             console.log("35 ", this.eval_vtas.pg035);
                                             console.log("g9 ", this.res_vtas.grupo9);

                                             this.res_vtas.grupoR = this.res_vtas.grupo1 + this.res_vtas.grupo2 + this.res_vtas.grupo3 + this.res_vtas.grupo4;
                                             this.res_vtas.grupoA = this.res_vtas.grupo5 + this.res_vtas.grupo6 + this.res_vtas.grupo7 + this.res_vtas.grupo8 + this.res_vtas.grupo9;

                                             this.res_vtas.grupoCol = 0;
                                             if (this.eval_vtas.pg001 === "b") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg002 === "b") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg003 === "b") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg004 === "b") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg005 === "a") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg006 === "c") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg007 === "a") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg008 === "b") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg009 === "a") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg010 === "b") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg011 === "b") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg012 === "c") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg013 === "b") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg014 === "b") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg015 === "a") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg016 === "c") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg017 === "b") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg018 === "c") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg027 === "a") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                                             if (this.eval_vtas.pg035 === "a") {
                                                            this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1;
                                             }
                              },
                              resultados: function resultados(doc) {

                                             this.rangosvtas();

                                             doc.setLineWidth(0.25);

                                             doc.text(10, 85, "SECCION DE RESULTADOS ");
                                             doc.line(10, 86, 206, 86);

                                             doc.text(10, 95, "* Grupo 1 ");doc.text(30, 95, this.res_vtas.grupo1.toString());
                                             doc.text(10, 100, "* Grupo 2 ");doc.text(30, 100, this.res_vtas.grupo2.toString());
                                             doc.text(10, 105, "* Grupo 3 ");doc.text(30, 105, this.res_vtas.grupo3.toString());
                                             doc.text(10, 110, "* Grupo 4 ");doc.text(30, 110, this.res_vtas.grupo4.toString());
                                             doc.text(10, 115, "* Grupo 5 ");doc.text(30, 115, this.res_vtas.grupo5.toString());
                                             doc.text(10, 120, "* Grupo 6 ");doc.text(30, 120, this.res_vtas.grupo6.toString());
                                             doc.text(10, 125, "* Grupo 7 ");doc.text(30, 125, this.res_vtas.grupo7.toString());
                                             doc.text(10, 130, "* Grupo 8 ");doc.text(30, 130, this.res_vtas.grupo8.toString());
                                             doc.text(10, 135, "* Grupo 9 ");doc.text(30, 135, this.res_vtas.grupo9.toString());
                                             doc.text(10, 140, "* Grupo R ");doc.text(30, 140, this.res_vtas.grupoR.toString());
                                             doc.text(10, 145, "* Grupo A ");doc.text(30, 145, this.res_vtas.grupoA.toString());
                                             doc.text(10, 150, "* Grupo Columna ");doc.text(40, 150, this.res_vtas.grupoCol.toString());
                              },
                              respuestas: function respuestas(doc) {

                                             console.log("Respuestas ");
                                             console.log(this.eval_vtas);
                                             /* Muestra las preguntas */
                                             /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
                                             doc.setLineWidth(0.25);

                                             doc.text(10, 40, "SECCION DE RESPUESTAS ");
                                             doc.line(10, 42, 206, 42);
                                             // doc.text(10, 45, this.eval_vtas.pg001 === "a" ? "| 01= (a)" : "| 01= (b)");
                                             doc.text(10, 45, this.eval_vtas.pg001 === "a" ? "| 01= (a)" : this.eval_vtas.pg001 === "b" ? "| 01= (b)" : "| 01= (c)");
                                             doc.text(23, 45, this.eval_vtas.pg002 === "a" ? "| 02= (a)" : this.eval_vtas.pg002 === "b" ? "| 02= (b)" : "| 02= (c)");
                                             doc.text(36, 45, this.eval_vtas.pg003 === "a" ? "| 03= (a)" : this.eval_vtas.pg003 === "b" ? "| 03= (b)" : "| 03= (c)");
                                             doc.text(49, 45, this.eval_vtas.pg004 === "a" ? "| 04= (a)" : this.eval_vtas.pg004 === "b" ? "| 04= (b)" : "| 04= (c)");
                                             doc.text(62, 45, this.eval_vtas.pg005 === "a" ? "| 05= (a)" : this.eval_vtas.pg005 === "b" ? "| 05= (b)" : "| 05= (c)");
                                             doc.text(75, 45, this.eval_vtas.pg006 === "a" ? "| 06= (a)" : this.eval_vtas.pg006 === "b" ? "| 06= (b)" : "| 06= (c)");
                                             doc.text(88, 45, this.eval_vtas.pg007 === "a" ? "| 07= (a)" : this.eval_vtas.pg007 === "b" ? "| 07= (b)" : "| 07= (c)");
                                             doc.text(101, 45, this.eval_vtas.pg008 === "a" ? "| 08= (a)" : this.eval_vtas.pg008 === "b" ? "| 08= (b)" : "| 08= (c)");
                                             doc.text(114, 45, this.eval_vtas.pg009 === "a" ? "| 09= (a)" : this.eval_vtas.pg009 === "b" ? "| 09= (b)" : "| 09= (c)");
                                             doc.text(127, 45, this.eval_vtas.pg010 === "a" ? "| 10= (a)" : this.eval_vtas.pg010 === "b" ? "| 10= (b)" : "| 10= (c)");
                                             doc.text(140, 45, this.eval_vtas.pg011 === "a" ? "| 11= (a)" : this.eval_vtas.pg011 === "b" ? "| 11= (b)" : "| 11= (c)");
                                             doc.text(153, 45, this.eval_vtas.pg012 === "a" ? "| 12= (a)" : this.eval_vtas.pg012 === "b" ? "| 12= (b)" : "| 12= (c)");
                                             doc.text(166, 45, this.eval_vtas.pg013 === "a" ? "| 13= (a)" : this.eval_vtas.pg013 === "b" ? "| 13= (b)" : "| 13= (c)");
                                             doc.text(179, 45, this.eval_vtas.pg014 === "a" ? "| 14= (a)" : this.eval_vtas.pg014 === "b" ? "| 14= (b)" : "| 14= (c)");
                                             doc.text(192, 45, this.eval_vtas.pg015 === "a" ? "| 15= (a) |" : this.eval_vtas.pg015 === "b" ? "| 15= (b) |" : "| 15= (c) |");
                                             doc.line(10, 46, 206, 46);

                                             doc.text(10, 49, this.eval_vtas.pg016 === "a" ? "| 16= (a)" : this.eval_vtas.pg016 === "b" ? "| 16= (b)" : "| 16= (c)");
                                             doc.text(23, 49, this.eval_vtas.pg017 === "a" ? "| 17= (a)" : this.eval_vtas.pg017 === "b" ? "| 17= (b)" : "| 17= (c)");
                                             doc.text(36, 49, this.eval_vtas.pg018 === "a" ? "| 18= (a)" : this.eval_vtas.pg018 === "b" ? "| 18= (b)" : "| 18= (c)");
                                             doc.text(49, 49, this.eval_vtas.pg019 === "a" ? "| 19= (a)" : this.eval_vtas.pg019 === "b" ? "| 19= (b)" : "| 19= (c)");
                                             doc.text(62, 49, this.eval_vtas.pg020 === "a" ? "| 20= (a)" : this.eval_vtas.pg020 === "b" ? "| 20= (b)" : "| 20= (c)");
                                             doc.text(75, 49, this.eval_vtas.pg021 === "a" ? "| 21= (a)" : this.eval_vtas.pg021 === "b" ? "| 21= (b)" : "| 21= (c)");
                                             doc.text(88, 49, this.eval_vtas.pg022 === "a" ? "| 22= (a)" : this.eval_vtas.pg022 === "b" ? "| 22= (b)" : "| 22= (c)");
                                             doc.text(101, 49, this.eval_vtas.pg023 === "a" ? "| 23= (a)" : this.eval_vtas.pg023 === "b" ? "| 23= (b)" : "| 23= (c)");
                                             doc.text(114, 49, this.eval_vtas.pg024 === "a" ? "| 24= (a)" : this.eval_vtas.pg024 === "b" ? "| 24= (b)" : "| 24= (c)");
                                             doc.text(127, 49, this.eval_vtas.pg025 === "a" ? "| 25= (a)" : this.eval_vtas.pg025 === "b" ? "| 25= (b)" : "| 25= (c)");
                                             doc.text(140, 49, this.eval_vtas.pg026 === "a" ? "| 26= (a)" : this.eval_vtas.pg026 === "b" ? "| 26= (b)" : "| 26= (c)");
                                             doc.text(153, 49, this.eval_vtas.pg027 === "a" ? "| 27= (a)" : this.eval_vtas.pg027 === "b" ? "| 27= (b)" : "| 27= (c)");
                                             doc.text(166, 49, this.eval_vtas.pg028 === "a" ? "| 28= (a)" : this.eval_vtas.pg028 === "b" ? "| 28= (b)" : "| 28= (c)");
                                             doc.text(179, 49, this.eval_vtas.pg029 === "a" ? "| 29= (a)" : this.eval_vtas.pg029 === "b" ? "| 29= (b)" : "| 29= (c)");
                                             doc.text(192, 49, this.eval_vtas.pg030 === "a" ? "| 30= (a) |" : this.eval_vtas.pg030 === "b" ? "| 30= (b) |" : "| 30= (c) |");
                                             doc.line(10, 50, 206, 50);

                                             doc.text(10, 53, this.eval_vtas.pg031 === "a" ? "| 31= (a)" : this.eval_vtas.pg031 === "b" ? "| 39= (b)" : "| 31= (c)");
                                             doc.text(23, 53, this.eval_vtas.pg032 === "a" ? "| 32= (a)" : this.eval_vtas.pg032 === "b" ? "| 39= (b)" : "| 32= (c)");
                                             doc.text(36, 53, this.eval_vtas.pg033 === "a" ? "| 33= (a)" : this.eval_vtas.pg033 === "b" ? "| 39= (b)" : "| 33= (c)");
                                             doc.text(49, 53, this.eval_vtas.pg034 === "a" ? "| 34= (a)" : this.eval_vtas.pg034 === "b" ? "| 39= (b)" : "| 34= (c)");
                                             doc.text(62, 53, this.eval_vtas.pg035 === "a" ? "| 35= (a)" : this.eval_vtas.pg035 === "b" ? "| 39= (b)" : "| 35= (c)");
                                             doc.text(75, 53, this.eval_vtas.pg036 === "a" ? "| 36= (a)" : this.eval_vtas.pg036 === "b" ? "| 39= (b)" : "| 36= (c)");
                                             doc.text(88, 53, this.eval_vtas.pg037 === "a" ? "| 37= (a)" : this.eval_vtas.pg037 === "b" ? "| 39= (b)" : "| 37= (c)");
                                             doc.text(101, 53, this.eval_vtas.pg038 === "a" ? "| 38= (a)" : this.eval_vtas.pg038 === "b" ? "| 39= (b)" : "| 38= (c)");
                                             doc.text(114, 53, this.eval_vtas.pg039 === "a" ? "| 39= (a)" : this.eval_vtas.pg039 === "b" ? "| 39= (b)" : "| 39= (c)");
                                             doc.text(127, 53, this.eval_vtas.pg040 === "a" ? "| 40= (a)" : this.eval_vtas.pg040 === "b" ? "| 39= (b)" : "| 40= (c)");
                                             doc.text(140, 53, this.eval_vtas.pg041 === "a" ? "| 41= (a)" : this.eval_vtas.pg041 === "b" ? "| 39= (b)" : "| 41= (c)");
                                             doc.text(153, 53, this.eval_vtas.pg042 === "a" ? "| 42= (a)" : this.eval_vtas.pg042 === "b" ? "| 39= (b)" : "| 42= (c)");
                                             doc.text(166, 53, this.eval_vtas.pg043 === "a" ? "| 43= (a)" : this.eval_vtas.pg043 === "b" ? "| 39= (b)" : "| 43= (c)");
                                             doc.text(179, 53, this.eval_vtas.pg044 === "a" ? "| 44= (a)" : this.eval_vtas.pg044 === "b" ? "| 39= (b)" : "| 44= (c)");
                                             doc.text(192, 53, this.eval_vtas.pg045 === "a" ? "| 45= (a) |" : this.eval_vtas.pg045 === "b" ? "| 39= (b) |" : "| 45= (c) |");
                                             doc.line(10, 54, 206, 54);

                                             doc.text(10, 57, this.eval_vtas.pg046 === "a" ? "| 46= (a)" : this.eval_vtas.pg046 === "b" ? "| 46= (b)" : "| 46= (c)");
                                             doc.text(23, 57, this.eval_vtas.pg047 === "a" ? "| 47= (a)" : this.eval_vtas.pg047 === "b" ? "| 47= (b)" : "| 47= (c)");
                                             doc.text(36, 57, this.eval_vtas.pg048 === "a" ? "| 48= (a)" : this.eval_vtas.pg048 === "b" ? "| 48= (b)" : "| 48= (c)");
                                             doc.text(49, 57, this.eval_vtas.pg049 === "a" ? "| 49= (a)" : this.eval_vtas.pg049 === "b" ? "| 49= (b)" : "| 49= (c)");
                                             doc.text(62, 57, this.eval_vtas.pg050 === "a" ? "| 50= (a)" : this.eval_vtas.pg050 === "b" ? "| 50= (b)" : "| 50= (c)");
                                             doc.text(75, 57, this.eval_vtas.pg051 === "a" ? "| 51= (a)" : this.eval_vtas.pg051 === "b" ? "| 51= (b)" : "| 51= (c)");
                                             doc.text(88, 57, this.eval_vtas.pg052 === "a" ? "| 52= (a)" : this.eval_vtas.pg052 === "b" ? "| 52= (b)" : "| 52= (c)");
                                             doc.text(101, 57, this.eval_vtas.pg053 === "a" ? "| 53= (a)" : this.eval_vtas.pg053 === "b" ? "| 53= (b)" : "| 53= (c)");
                                             doc.text(114, 57, this.eval_vtas.pg054 === "a" ? "| 54= (a)" : this.eval_vtas.pg054 === "b" ? "| 54= (b)" : "| 54= (c)");
                                             doc.text(127, 57, this.eval_vtas.pg055 === "a" ? "| 55= (a)" : this.eval_vtas.pg055 === "b" ? "| 55= (b)" : "| 55= (c)");
                                             doc.text(140, 57, this.eval_vtas.pg056 === "a" ? "| 56= (a)" : this.eval_vtas.pg056 === "b" ? "| 56= (b)" : "| 56= (c)");
                                             doc.text(153, 57, this.eval_vtas.pg057 === "a" ? "| 57= (a)" : this.eval_vtas.pg057 === "b" ? "| 57= (b)" : "| 57= (c)");
                                             doc.text(166, 57, this.eval_vtas.pg058 === "a" ? "| 58= (a)" : this.eval_vtas.pg058 === "b" ? "| 58= (b)" : "| 58= (c)");
                                             doc.text(179, 57, this.eval_vtas.pg059 === "a" ? "| 59= (a)" : this.eval_vtas.pg059 === "b" ? "| 59= (b)" : "| 59= (c)");
                                             doc.text(192, 57, this.eval_vtas.pg060 === "a" ? "| 60= (a) |" : this.eval_vtas.pg060 === "b" ? "| 60= (b) |" : "| 60= (c) |");
                                             doc.line(10, 58, 206, 58);

                                             doc.text(10, 61, this.eval_vtas.pg061 === "a" ? "| 61= (a)" : this.eval_vtas.pg061 === "b" ? "| 61= (b)" : "| 61= (c)");
                                             doc.text(23, 61, this.eval_vtas.pg062 === "a" ? "| 62= (a)" : this.eval_vtas.pg062 === "b" ? "| 62= (b)" : "| 62= (c)");
                                             doc.text(36, 61, this.eval_vtas.pg063 === "a" ? "| 63= (a)" : this.eval_vtas.pg063 === "b" ? "| 63= (b)" : "| 63= (c)");
                                             doc.text(49, 61, this.eval_vtas.pg064 === "a" ? "| 64= (a)" : this.eval_vtas.pg064 === "b" ? "| 64= (b)" : "| 64= (c)");
                                             doc.text(62, 61, this.eval_vtas.pg065 === "a" ? "| 65= (a)" : this.eval_vtas.pg065 === "b" ? "| 65= (b)" : "| 65= (c)");
                                             doc.text(75, 61, this.eval_vtas.pg066 === "a" ? "| 66= (a)" : this.eval_vtas.pg066 === "b" ? "| 66= (b)" : "| 66= (c)");
                                             doc.text(88, 61, this.eval_vtas.pg067 === "a" ? "| 67= (a)" : this.eval_vtas.pg067 === "b" ? "| 67= (b)" : "| 67= (c)");
                                             doc.text(101, 61, this.eval_vtas.pg068 === "a" ? "| 68= (a)" : this.eval_vtas.pg068 === "b" ? "| 68= (b)" : "| 68= (c)");
                                             doc.text(114, 61, this.eval_vtas.pg069 === "a" ? "| 69= (a)" : this.eval_vtas.pg069 === "b" ? "| 69= (b)" : "| 69= (c)");
                                             doc.text(127, 61, this.eval_vtas.pg070 === "a" ? "| 70= (a)" : this.eval_vtas.pg070 === "b" ? "| 70= (b)" : "| 70= (c)");
                                             doc.text(140, 61, this.eval_vtas.pg071 === "a" ? "| 71= (a)" : this.eval_vtas.pg071 === "b" ? "| 71= (b)" : "| 71= (c)");
                                             doc.text(153, 61, this.eval_vtas.pg072 === "a" ? "| 72= (a)" : this.eval_vtas.pg072 === "b" ? "| 72= (b)" : "| 72= (c)");
                                             doc.text(166, 61, this.eval_vtas.pg073 === "a" ? "| 73= (a)" : this.eval_vtas.pg073 === "b" ? "| 73= (b)" : "| 73= (c)");
                                             doc.text(179, 61, this.eval_vtas.pg074 === "a" ? "| 74= (a)" : this.eval_vtas.pg074 === "b" ? "| 74= (b)" : "| 74= (c)");
                                             doc.text(192, 61, this.eval_vtas.pg075 === "a" ? "| 75= (a) |" : this.eval_vtas.pg075 === "b" ? "| 75= (b) |" : "| 75= (c) |");
                                             doc.line(10, 62, 206, 62);

                                             doc.text(10, 65, this.eval_vtas.pg076 === "a" ? "| 76= (a)" : this.eval_vtas.pg076 === "b" ? "| 76= (b)" : "| 76= (c)");
                                             doc.text(23, 65, this.eval_vtas.pg077 === "a" ? "| 77= (a)" : this.eval_vtas.pg077 === "b" ? "| 77= (b)" : "| 77= (c)");
                                             doc.text(36, 65, this.eval_vtas.pg078 === "a" ? "| 78= (a)" : this.eval_vtas.pg078 === "b" ? "| 78= (b)" : "| 78= (c)");
                                             doc.text(49, 65, this.eval_vtas.pg079 === "a" ? "| 79= (a)" : this.eval_vtas.pg079 === "b" ? "| 79= (b)" : "| 79= (c)");
                                             doc.text(62, 65, this.eval_vtas.pg080 === "a" ? "| 80= (a)" : this.eval_vtas.pg080 === "b" ? "| 80= (b)" : "| 80= (c)");
                                             doc.text(75, 65, this.eval_vtas.pg081 === "a" ? "| 81= (a)" : this.eval_vtas.pg081 === "b" ? "| 81= (b)" : "| 81= (c)");
                                             doc.text(88, 65, this.eval_vtas.pg082 === "a" ? "| 82= (a)" : this.eval_vtas.pg082 === "b" ? "| 82= (b)" : "| 82= (c)");
                                             doc.text(101, 65, this.eval_vtas.pg083 === "a" ? "| 83= (a)" : this.eval_vtas.pg083 === "b" ? "| 83= (b)" : "| 83= (c)");
                                             doc.text(114, 65, this.eval_vtas.pg084 === "a" ? "| 84= (a)" : this.eval_vtas.pg084 === "b" ? "| 84= (b)" : "| 84= (c)");
                                             doc.text(127, 65, this.eval_vtas.pg085 === "a" ? "| 85= (a)" : this.eval_vtas.pg085 === "b" ? "| 85= (b)" : "| 85= (c)");
                                             doc.text(140, 65, this.eval_vtas.pg086 === "a" ? "| 86= (a)" : this.eval_vtas.pg086 === "b" ? "| 86= (b)" : "| 86= (c)");
                                             doc.text(153, 65, this.eval_vtas.pg087 === "a" ? "| 87= (a)" : this.eval_vtas.pg087 === "b" ? "| 87= (b)" : "| 87= (c)");
                                             doc.line(10, 66, 206, 66);
                              },

                              ejeSinContestar: function ejeSinContestar() {

                                             this.ejeSinResponder = 0;
                                             console.log("1 ? ", this.ejemplo.pg001);
                                             if (this.ejemplo.pg001 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }
                                             if (this.ejemplo.pg002 === 0) {
                                                            this.ejeSinResponder = this.ejeSinResponder + 1;
                                             }

                                             return this.ejeSinResponder;
                              },
                              sinContestar: function sinContestar() {

                                             this.pregSinContestar = 0;

                                             if (this.eval_vtas.pg001 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg002 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg003 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg004 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg005 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg006 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg007 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg008 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg009 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg010 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg011 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg012 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg013 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg014 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg015 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg016 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg017 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg018 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg019 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg020 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg021 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg022 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg023 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg024 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg025 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }

                                             if (this.eval_vtas.pg026 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg027 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg028 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg029 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg030 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg031 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg032 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg033 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg034 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg035 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg036 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg037 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg038 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg039 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg040 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg041 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg042 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg043 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg044 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg045 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg046 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg047 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg048 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg049 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg050 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }

                                             if (this.eval_vtas.pg051 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg052 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg053 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg054 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg055 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg056 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg057 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg058 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg059 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg060 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg061 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg062 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg063 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg064 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg065 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg066 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg067 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg068 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg069 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg070 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg071 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg072 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg073 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg074 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg075 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }

                                             if (this.eval_vtas.pg076 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg077 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg078 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg079 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg080 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg081 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg082 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg083 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg084 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg085 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg086 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }
                                             if (this.eval_vtas.pg087 === 0) {
                                                            this.pregSinContestar = this.pregSinContestar + 1;
                                             }

                                             return this.pregSinContestar;
                              },
                              addADayToMyDate: function addADayToMyDate() {
                                             if (this.eval_fecha) // as myDate can be null
                                                            // you have to set the this.myDate again, so vue can detect it changed
                                                            // this is not a caveat of this specific solution, but of any binding of dates
                                                            this.eval_vtas.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
                              },
                              dateToYYYYMMDD: function dateToYYYYMMDD(date) {
                                             console.log("***********************************************************************************");
                                             console.log("Estoy en dateToYYYYMMDD ");
                                             console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
                                             console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
                                             console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

                                             console.log("Desmenuzando ...");
                                             var a = date.toISOString();
                                             var b = a.split("T");
                                             var c = b[0];
                                             var d = b[1];
                                             console.log("a) date.toISOString() ", date.toISOString());
                                             console.log("b) ", a.split("T"));
                                             console.log("c) b[0]", b[0], "; b[1] ", b[1]);
                                             console.log("***********************************************************************************");

                                             // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
                                             return date && date.toISOString().split('T')[0];
                              },
                              cargaHora: function cargaHora() {

                                             // Convierte la hora obtenida a hora local (utc)
                                             this.eval_fecha = new Date();
                                             var d = this.eval_fecha;
                                             var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

                                             // obtain local UTC offset and convert to msec
                                             var localOffset = d.getTimezoneOffset() * 60000;
                                             var newdate = new Date(utcd + localOffset);
                                             var hours = newdate.getHours();
                                             var minutes = newdate.getMinutes();
                                             var seconds = newdate.getSeconds();
                                             var hora = hours + ":" + minutes + ":" + seconds;
                                             console.log("newdate ? ", newdate, " | ", hora);

                                             return hora;
                              },
                              cargaEvaluacion: function cargaEvaluacion() {

                                             this.ejemplo = {
                                                            pg001: 0, pg002: 0, pg003: 0
                                             };

                                             this.eval_vtas = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev10; // Crea el nodo para todos los campos.
                                             this.res_vtas = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs10;
                                             console.log("res ? ", this.res_vtas);

                                             this.eval_vtas.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
                                             this.eval_vtas.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
                                             this.eval_vtas.depto = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_depto; // Nombre de la empresa a la cual pertenece el usuario
                                             this.eval_vtas.sexo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_sexo; // Nombre de la empresa a la cual pertenece el usuario

                                             this.instrucciones = this.eval_vtas.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de ORIENTACION EN VENTAS.";

                                             this.eval_fecha = new Date(); // Fecha del Día
                              },
                              empezarEvaluacion: function empezarEvaluacion() {

                                             this.eval_vtas.empezo = this.cargaHora();
                                             this.inicioeval = true;
                              },

                              /** .................... VALIDACIONES  .................... */
                              limpiarEvaluacion: function limpiarEvaluacion() {

                                             this.ejemplo = {
                                                            pg001: 0, pg002: 0
                                             };

                                             this.eval_vtas = {
                                                            depto: "",
                                                            empresa: "", nombre: "",
                                                            fecha: "",
                                                            empezo: "", termino: "",
                                                            pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                                                            pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                                                            pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
                                                            pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
                                                            pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0, pg049: 0, pg050: 0,
                                                            pg051: 0, pg052: 0, pg053: 0, pg054: 0, pg055: 0, pg056: 0, pg057: 0, pg058: 0, pg059: 0, pg060: 0,
                                                            pg061: 0, pg062: 0, pg063: 0, pg064: 0, pg065: 0, pg066: 0, pg067: 0, pg068: 0, pg069: 0, pg070: 0,
                                                            pg071: 0, pg072: 0, pg073: 0, pg074: 0, pg075: 0, pg076: 0, pg077: 0, pg078: 0, pg079: 0, pg080: 0,
                                                            pg081: 0, pg082: 0, pg083: 0, pg084: 0, pg085: 0, pg086: 0, pg087: 0

                                                            /* Variables para un nuevo caso */
                                             };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.eval_vtas = this.eval_vtas;
                              },

                              /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
                              /* Acciones del Floatting Button: Agregar Encuesta */
                              agregarEvaluacion: function agregarEvaluacion() {
                                             var _this = this;

                                             if (this.pregSinContestar > 0) {
                                                            alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ");
                                                            return;
                                             }

                                             this.finalizoeval = true;
                                             this.eval_vtas.termino = this.cargaHora();

                                             this.eval_fecha = new Date();

                                             var ldia = this.eval_fecha.getDate();
                                             if (ldia <= 9) {
                                                            ldia = '0' + ldia.toString().trim();
                                             } else {
                                                            ldia = ldia.toString().trim();
                                             }
                                             var lmes = this.eval_fecha.getMonth() + 1;
                                             if (lmes <= 9) {
                                                            lmes = '0' + lmes.toString().trim();
                                             } else {
                                                            lmes = lmes.toString().trim();
                                             }
                                             console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
                                             var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

                                             console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
                                             console.log("db ? ", __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalVtas2);
                                             console.log("** fecha de ingreso ? ", this.eval_fecha);
                                             console.log("** formato  ingreso ? ", lingreso);
                                             console.log("eval_vtas ? ", this.eval_vtas);
                                             console.log("depto ? ", this.eval_vtas.depto, ", sexo ? ", this.eval_vtas.sexo);

                                             var confirma = confirm("Seguro de grabar la evaluación de ORIENTACION EN VENTAS para " + this.eval_vtas.nombre.toUpperCase().trim() + " ?");
                                             if (confirma === true) {

                                                            /* Agrega una colección al objeto */
                                                            var dbEvaluaciones = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalVtas2;
                                                            dbEvaluaciones.push({

                                                                           empresa: this.eval_vtas.empresa, nombre: this.eval_vtas.nombre,
                                                                           empezo: this.eval_vtas.empezo, termino: this.eval_vtas.termino,
                                                                           fecha: lingreso, depto: this.eval_vtas.depto, sexo: this.eval_vtas.sexo,
                                                                           pg001: this.eval_vtas.pg001, pg002: this.eval_vtas.pg002, pg003: this.eval_vtas.pg003, pg004: this.eval_vtas.pg004, pg005: this.eval_vtas.pg005,
                                                                           pg006: this.eval_vtas.pg006, pg007: this.eval_vtas.pg007, pg008: this.eval_vtas.pg008, pg009: this.eval_vtas.pg009, pg010: this.eval_vtas.pg010,
                                                                           pg011: this.eval_vtas.pg011, pg012: this.eval_vtas.pg012, pg013: this.eval_vtas.pg013, pg014: this.eval_vtas.pg014, pg015: this.eval_vtas.pg015,
                                                                           pg016: this.eval_vtas.pg016, pg017: this.eval_vtas.pg017, pg018: this.eval_vtas.pg018, pg019: this.eval_vtas.pg019, pg020: this.eval_vtas.pg020,
                                                                           pg021: this.eval_vtas.pg021, pg022: this.eval_vtas.pg022, pg023: this.eval_vtas.pg023, pg024: this.eval_vtas.pg024, pg025: this.eval_vtas.pg025,
                                                                           pg026: this.eval_vtas.pg026, pg027: this.eval_vtas.pg027, pg028: this.eval_vtas.pg028, pg029: this.eval_vtas.pg029, pg030: this.eval_vtas.pg030,
                                                                           pg031: this.eval_vtas.pg031, pg032: this.eval_vtas.pg032, pg033: this.eval_vtas.pg033, pg034: this.eval_vtas.pg034, pg035: this.eval_vtas.pg035,
                                                                           pg036: this.eval_vtas.pg036, pg037: this.eval_vtas.pg037, pg038: this.eval_vtas.pg038, pg039: this.eval_vtas.pg039, pg040: this.eval_vtas.pg040,
                                                                           pg041: this.eval_vtas.pg041, pg042: this.eval_vtas.pg042, pg043: this.eval_vtas.pg043, pg044: this.eval_vtas.pg044, pg045: this.eval_vtas.pg045,
                                                                           pg046: this.eval_vtas.pg046, pg047: this.eval_vtas.pg047, pg048: this.eval_vtas.pg048, pg049: this.eval_vtas.pg049, pg050: this.eval_vtas.pg050,
                                                                           pg051: this.eval_vtas.pg051, pg052: this.eval_vtas.pg052, pg053: this.eval_vtas.pg053, pg054: this.eval_vtas.pg054, pg055: this.eval_vtas.pg055,
                                                                           pg056: this.eval_vtas.pg056, pg057: this.eval_vtas.pg057, pg058: this.eval_vtas.pg058, pg059: this.eval_vtas.pg059, pg060: this.eval_vtas.pg060,
                                                                           pg061: this.eval_vtas.pg061, pg062: this.eval_vtas.pg062, pg063: this.eval_vtas.pg063, pg064: this.eval_vtas.pg064, pg065: this.eval_vtas.pg065,
                                                                           pg066: this.eval_vtas.pg066, pg067: this.eval_vtas.pg067, pg068: this.eval_vtas.pg068, pg069: this.eval_vtas.pg069, pg070: this.eval_vtas.pg070,
                                                                           pg071: this.eval_vtas.pg071, pg072: this.eval_vtas.pg072, pg073: this.eval_vtas.pg073, pg074: this.eval_vtas.pg074, pg075: this.eval_vtas.pg075,
                                                                           pg076: this.eval_vtas.pg076, pg077: this.eval_vtas.pg077, pg078: this.eval_vtas.pg078, pg079: this.eval_vtas.pg079, pg080: this.eval_vtas.pg080,
                                                                           pg081: this.eval_vtas.pg081, pg082: this.eval_vtas.pg082, pg083: this.eval_vtas.pg083, pg084: this.eval_vtas.pg084, pg085: this.eval_vtas.pg085,
                                                                           pg086: this.eval_vtas.pg086, pg087: this.eval_vtas.pg087
                                                            }).then(function (data) {

                                                                           /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                                                                           _this.limpiarEvaluacion();

                                                                           var laClave = data.key;
                                                                           _this.grabado = true;
                                                                           _this.inicioeval = false;

                                                                           // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                                                                           alert("Evaluación de ORIENTACION EN VENTAS guardado con éxito.");
                                                            });
                                             } // if (confirma)
                              },
                              // agregarEncuesta()

                              //? =================================================================================
                              enfoqueG1: function enfoqueG1(pestana) {
                                             var _this2 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {
                                                            case 2:
                                                                           //* Vengo de 1, voy a 2
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt2.focus();
                                                                           });

                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = true;
                                                                           break;
                                                            case 3:
                                                                           //* Vengo de 2, voy a 3
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt3.focus();
                                                                           });
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "active";

                                                                           this.vertt2 = false;
                                                                           this.vertt3 = true;
                                                                           break;
                                                            case 4:
                                                                           //* Vengo de 3, voy a 4
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt4.focus();
                                                                           });
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "active";

                                                                           this.vertt3 = false;
                                                                           this.vertt4 = true;
                                                                           break;
                                                            case 0:
                                                                           //* Vengo de 4, voy a 1
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this2.$refs.testtt1.focus();
                                                                           });
                                                                           this.activott4 = "!active";
                                                                           this.activott1 = "active";

                                                                           this.vertt4 = false;
                                                                           this.vertt1 = true;
                                                                           break;
                                                            default:
                                                            // code block
                                             } //* switch
                              },
                              nadaG1: function nadaG1(pestana) {
                                             var _this3 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {
                                                            case 1:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt1.focus();
                                                                           });

                                                                           this.activott1 = "active";
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "!active";

                                                                           this.vertt1 = true;
                                                                           this.vertt2 = false;
                                                                           this.vertt3 = false;
                                                                           this.vertt4 = false;

                                                                           break;
                                                            case 2:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt2.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "active";
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "!active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = true;
                                                                           this.vertt3 = false;
                                                                           this.vertt4 = false;

                                                                           break;
                                                            case 3:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt3.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "active";
                                                                           this.activott4 = "!active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = false;
                                                                           this.vertt3 = true;
                                                                           this.vertt4 = false;

                                                                           break;
                                                            case 4:
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this3.$refs.testtt4.focus();
                                                                           });
                                                                           this.activott1 = "!active";
                                                                           this.activott2 = "!active";
                                                                           this.activott3 = "!active";
                                                                           this.activott4 = "active";

                                                                           this.vertt1 = false;
                                                                           this.vertt2 = false;
                                                                           this.vertt3 = false;
                                                                           this.vertt4 = true;

                                                                           break;
                                                            default:
                                                            // code block
                                             } //* switch
                              },
                              enfoqueRG1: function enfoqueRG1(pestana) {
                                             var _this4 = this;

                                             //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
                                             switch (pestana) {
                                                            case 3:
                                                                           //* Estoy en 4 regreso a 3
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt3.focus();
                                                                           });

                                                                           this.activott4 = "!active";
                                                                           this.activott3 = "active";

                                                                           this.vertt4 = false;
                                                                           this.vertt3 = true;
                                                                           break;
                                                            case 2:
                                                                           //* Estoy en 3 regreso a 2
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt2.focus();
                                                                           });

                                                                           this.activott3 = "!active";
                                                                           this.activott2 = "active";

                                                                           this.vertt3 = false;
                                                                           this.vertt2 = true;
                                                                           break;
                                                            case 1:
                                                                           //* Estoy en 2 regreso a 1
                                                                           __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                                                                                          return _this4.$refs.testtt1.focus();
                                                                           });
                                                                           this.activott2 = "!active";
                                                                           this.activott1 = "active";

                                                                           this.vertt2 = false;
                                                                           this.vertt1 = true;
                                                                           break;
                                                            default:
                                                            // code block
                                             } //* switch
                              }
               } // methods
               // export

});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 *      ev12_aedp.js
 *          Script de ev12_aedp.vue          
 */
/* ======================================================================================================== */






__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
     name: 'formaaedp',
     components: {
          'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
          'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
     },
     template: '#formaaedp',
     data: function data() {
          return {
               activo: true, //! BORRAR ?


               activo1: "active", activo2: '!active', activo3: "!active",
               ver1: true, ver2: false, ver3: false,
               prueba: "", prueba2: '', prueba3: '',

               ejemplo: {},
               eval_aedp: {}, res: {},
               modo: "",
               eval_fecha: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,
               totalPreguntas: 0,
               grupo1: true,
               grupo2: false,

               //? .....................................................................................................................................................................................................................
               activott1: "active", activott2: '!active', activott3: "!active", activott4: "!active", activott5: '!active',
               activott6: "!active", activott7: "!active", activott8: '!active', activott9: "!active", activott10: "!active",
               vertt1: true, vertt2: false, vertt3: false, vertt4: false, vertt5: false,
               vertt6: false, vertt7: false, vertt8: false, vertt9: false, vertt10: false,
               area1: "", area2: '', area3: '', area4: "", area5: '', area6: '', area7: "", area8: '', area9: '', area10: '',

               //? .....................................................................................................................................................................................................................
               activott11: "active", activott12: '!active', activott13: "!active", activott14: "!active", activott15: '!active',
               activott16: "!active", activott17: "!active", activott18: '!active', activott19: "!active", activott20: "!active",
               activott21: "!active",
               vertt11: true, vertt12: false, vertt13: false, vertt14: false, vertt15: false,
               vertt16: false, vertt17: false, vertt18: false, vertt19: false, vertt20: false,
               vertt21: false,
               area11: "", area12: '', area13: '', area14: "", area15: '', area16: '', area17: "", area18: '', area19: '',
               area20: '', area21: '' // return
          };
     },
     // data()
     mounted: function mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

          this.limpiarEvaluacion();

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();

          this.totalPreguntas = this.sinContestar();

          document.getElementById("grupo1").disabled = this.grupo1;
          document.getElementById("grupo2").disabled = this.grupo2;
     },

     computed: {
          l_sinResponder: function l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder: function l_ejeSinResponder() {
               return this.ejeSinContestar();
          }
     },
     methods: {
          grabarEvaluacion: function grabarEvaluacion() {
               if (this.pregSinContestar > 0) {
                    alert("Aún hay preguntas sin responder !");
               }
          },
          areas1_10: function areas1_10() {
               this.grupo1 = true;
               this.grupo2 = false;
               document.getElementById("grupo1").disabled = this.grupo1;
               document.getElementById("grupo2").disabled = this.grupo2;
          },
          areas11_21: function areas11_21() {
               this.grupo1 = false;
               this.grupo2 = true;
               document.getElementById("grupo1").disabled = this.grupo1;
               document.getElementById("grupo2").disabled = this.grupo2;
          },

          //* ----------------------------------------------------------------------
          crearPDF: function crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_aedp.nombre,
                   patron = / /g,
                   nuevoValor = "",
                   nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "aedp_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1); // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de SUPERVISION para " + this.eval_aedp.nombre + " de " + this.eval_aedp.empresa + " ( " + this.eval_aedp.depto + " )");

               this.respuestas(doc);
               this.resultados(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          resultados: function resultados(doc) {

               this.res_aedp = {
                    hs: 0, cd: 0, ce: 0, hr: 0, sc: 0,
                    aciertos: 0,
                    percentilHS: 0, rangoHS: ""
               };

               this.rangosaedp();

               doc.setLineWidth(0.25);

               doc.text(10, 88, "SECCION DE RESULTADOS ");
               doc.line(10, 89, 206, 89);

               var aciertos = this.res_aedp.aciertos;
               var rangosHS = this.res_aedp.rangosHS;
               var hs = this.res_aedp.hs;
               var cd = this.res_aedp.cd;
               var ce = this.res_aedp.ce;
               var hr = this.res_aedp.hr;
               var sc = this.res_aedp.sc;

               doc.text(20, 94, "Pc.");doc.text(30, 94, "RESULTADOS");doc.text(63, 94, "RANGO");
               doc.text(20, 96, "-------");doc.text(30, 96, "--------------------");doc.text(60, 96, "-------------------");
               doc.text(10, 100, "[HS]");
               doc.text(22, 100, hs.toString());doc.text(35, 100, aciertos.toString());doc.text(62, 100, rangosHS);

               doc.text(10, 105, "[CD]");
               doc.text(22, 105, cd.toString());

               doc.text(10, 110, "[CE]");
               doc.text(22, 110, ce.toString());

               doc.text(10, 115, "[HR]");
               doc.text(22, 115, hr.toString());

               doc.text(10, 120, "[SC]");
               doc.text(22, 120, sc.toString());
               doc.text(20, 122, "-------");doc.text(30, 122, "--------------------");doc.text(60, 122, "-------------------");
               var desaciertos = 30 - aciertos;
               doc.text(10, 127, "Aciertos ? ");
               doc.text(25, 127, aciertos.toString());
               doc.text(32, 127, "No Aciertos ? ");
               doc.text(52, 127, desaciertos.toString());
          },
          respuestas: function respuestas(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ");
               doc.line(10, 42, 190, 42);
               doc.text(10, 45, "01= ");doc.text(23, 45, this.eval_aedp.pg001);doc.text(30, 45, "02= ");doc.text(43, 45, this.eval_aedp.pg002);
               doc.text(50, 45, "03= ");doc.text(63, 45, this.eval_aedp.pg003);doc.text(70, 45, "04= ");doc.text(83, 45, this.eval_aedp.pg004);
               doc.text(90, 45, "05= ");doc.text(103, 45, this.eval_aedp.pg005);doc.text(110, 45, "06= ");doc.text(123, 45, this.eval_aedp.pg006);
               doc.text(130, 45, "07= ");doc.text(143, 45, this.eval_aedp.pg007);doc.text(150, 45, "08= ");doc.text(163, 45, this.eval_aedp.pg008);
               doc.text(170, 45, "09= ");doc.text(183, 45, this.eval_aedp.pg009);
               doc.line(10, 46, 190, 46);
               doc.text(10, 49, "10= ");doc.text(23, 49, this.eval_aedp.pg010);doc.text(30, 49, "11= ");doc.text(43, 49, this.eval_aedp.pg011);
               doc.text(50, 49, "12= ");doc.text(63, 49, this.eval_aedp.pg012);doc.text(70, 49, "13= ");doc.text(83, 49, this.eval_aedp.pg013);
               doc.text(90, 49, "14= ");doc.text(103, 49, this.eval_aedp.pg014);doc.text(110, 49, "15= ");doc.text(123, 49, this.eval_aedp.pg015);
               doc.text(130, 49, "16= ");doc.text(143, 49, this.eval_aedp.pg016);doc.text(150, 49, "17= ");doc.text(163, 49, this.eval_aedp.pg017);
               doc.text(170, 49, "18= ");doc.text(183, 49, this.eval_aedp.pg018);
               doc.line(10, 50, 190, 50);
               doc.text(10, 53, "19= ");doc.text(23, 53, this.eval_aedp.pg019);doc.text(30, 53, "20= ");doc.text(43, 53, this.eval_aedp.pg020);
               doc.text(50, 53, "21= ");doc.text(63, 53, this.eval_aedp.pg021);doc.text(70, 53, "22= ");doc.text(83, 53, this.eval_aedp.pg022);
               doc.text(90, 53, "23= ");doc.text(103, 53, this.eval_aedp.pg023);doc.text(110, 53, "24= ");doc.text(123, 53, this.eval_aedp.pg024);
               doc.text(130, 53, "25= ");doc.text(143, 53, this.eval_aedp.pg025);doc.text(150, 53, "26= ");doc.text(163, 53, this.eval_aedp.pg026);
               doc.text(170, 53, "27= ");doc.text(183, 53, this.eval_aedp.pg027);
               doc.line(10, 54, 190, 54);
               doc.text(10, 57, "28= ");doc.text(23, 57, this.eval_aedp.pg028);doc.text(30, 57, "29= ");doc.text(43, 57, this.eval_aedp.pg029);
               doc.text(50, 57, "30= ");doc.text(63, 57, this.eval_aedp.pg030);
               doc.line(10, 59, 65, 59);
          },
          rangosaedp: function rangosaedp() {

               /* ================================================================================= */
               /* Conteo para HR */
               if (this.eval_aedp.pg001 === "c") {
                    this.res_aedp.hr = this.res_aedp.hr + 1;
               }
               if (this.eval_aedp.pg010 === "c") {
                    this.res_aedp.hr = this.res_aedp.hr + 1;
               }
               if (this.eval_aedp.pg011 === "a") {
                    this.res_aedp.hr = this.res_aedp.hr + 1;
               }
               if (this.eval_aedp.pg013 === "d") {
                    this.res_aedp.hr = this.res_aedp.hr + 1;
               }
               if (this.eval_aedp.pg025 === "b") {
                    this.res_aedp.hr = this.res_aedp.hr + 1;
               }

               /* ================================================================================= */
               /* Conteo para HS */
               if (this.eval_aedp.pg002 === "b") {
                    this.res_aedp.hs = this.res_aedp.hs + 1;
               }
               if (this.eval_aedp.pg003 === "d") {
                    this.res_aedp.hs = this.res_aedp.hs + 1;
               }
               if (this.eval_aedp.pg016 === "d") {
                    this.res_aedp.hs = this.res_aedp.hs + 1;
               }
               if (this.eval_aedp.pg018 === "d") {
                    this.res_aedp.hs = this.res_aedp.hs + 1;
               }
               if (this.eval_aedp.pg024 === "d") {
                    this.res_aedp.hs = this.res_aedp.hs + 1;
               }
               if (this.eval_aedp.pg030 === "a") {
                    this.res_aedp.hs = this.res_aedp.hs + 1;
               }

               /* ================================================================================= */
               /* Conteo para CD */
               if (this.eval_aedp.pg004 === "b") {
                    this.res_aedp.cd = this.res_aedp.cd + 1;
               }
               if (this.eval_aedp.pg006 === "b") {
                    this.res_aedp.cd = this.res_aedp.cd + 1;
               }
               if (this.eval_aedp.pg020 === "b") {
                    this.res_aedp.cd = this.res_aedp.cd + 1;
               }
               if (this.eval_aedp.pg023 === "a") {
                    this.res_aedp.cd = this.res_aedp.cd + 1;
               }
               if (this.eval_aedp.pg029 === "c") {
                    this.res_aedp.cd = this.res_aedp.cd + 1;
               }

               /* ================================================================================= */
               /* Conteo para SC */
               if (this.eval_aedp.pg005 === "b") {
                    this.res_aedp.sc = this.res_aedp.sc + 1;
               }
               if (this.eval_aedp.pg008 === "b") {
                    this.res_aedp.sc = this.res_aedp.sc + 1;
               }
               if (this.eval_aedp.pg015 === "d") {
                    this.res_aedp.sc = this.res_aedp.sc + 1;
               }
               if (this.eval_aedp.pg017 === "b") {
                    this.res_aedp.sc = this.res_aedp.sc + 1;
               }
               if (this.eval_aedp.pg022 === "a") {
                    this.res_aedp.sc = this.res_aedp.sc + 1;
               }
               if (this.eval_aedp.pg028 === "c") {
                    this.res_aedp.sc = this.res_aedp.sc + 1;
               }

               /* ================================================================================= */
               /* Conteo para CE */
               if (this.eval_aedp.pg007 === "b") {
                    this.res_aedp.ce = this.res_aedp.ce + 1;
               }
               if (this.eval_aedp.pg009 === "c") {
                    this.res_aedp.ce = this.res_aedp.ce + 1;
               }
               if (this.eval_aedp.pg012 === "c") {
                    this.res_aedp.ce = this.res_aedp.ce + 1;
               }
               if (this.eval_aedp.pg014 === "d") {
                    this.res_aedp.ce = this.res_aedp.ce + 1;
               }
               if (this.eval_aedp.pg019 === "c") {
                    this.res_aedp.ce = this.res_aedp.ce + 1;
               }
               if (this.eval_aedp.pg021 === "a") {
                    this.res_aedp.ce = this.res_aedp.ce + 1;
               }
               if (this.eval_aedp.pg026 === "c") {
                    this.res_aedp.ce = this.res_aedp.ce + 1;
               }
               if (this.eval_aedp.pg027 === "a") {
                    this.res_aedp.ce = this.res_aedp.ce + 1;
               }
               /* ================================================================================= */

               /* ================================================================================= */
               /* Conteo de todos los aciertos */
               this.res_aedp.aciertos = 0;
               this.res_aedp.aciertos = this.res_aedp.hs + this.res_aedp.cd + this.res_aedp.ce + this.res_aedp.hr + this.res_aedp.sc;

               /* Busca el rango que le corresponde */
               this.res_aedp.rangosHS = '';
               var comp1 = this.res_aedp.aciertos >= 0 && this.res_aedp.aciertos <= 8;if (comp1 === true) {
                    this.res_aedp.rangosHS = 'INFERIOR';
               }
               var comp2 = this.res_aedp.aciertos >= 9 && this.res_aedp.aciertos <= 11;if (comp2 === true) {
                    this.res_aedp.rangosHS = 'POBRE';
               }
               var comp3 = this.res_aedp.aciertos >= 12 && this.res_aedp.aciertos <= 18;if (comp3 === true) {
                    this.res_aedp.rangosHS = 'MEDIO';
               }
               var comp4 = this.res_aedp.aciertos >= 19 && this.res_aedp.aciertos <= 23;if (comp4 === true) {
                    this.res_aedp.rangosHS = 'BUENO';
               }
               var comp5 = this.res_aedp.aciertos >= 24 && this.res_aedp.aciertos <= 30;if (comp5 === true) {
                    this.res_aedp.rangosHS = 'SUPERIOR';
               }
          },
          // rangos()
          //* ----------------------------------------------------------------------

          ejeSinContestar: function ejeSinContestar() {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg002 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg003 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg004 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg005 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }

               return this.ejeSinResponder;
          },
          sinContestar: function sinContestar() {

               this.pregSinContestar = 0;

               //? ÁREA 1
               if (this.eval_aedp.pg001 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg002 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg003 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg004 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg005 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg006 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg007 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg008 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg009 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg010 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg011 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg012 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg013 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg014 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg015 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg016 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg017 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg018 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 2
               if (this.eval_aedp.pg019 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg020 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg021 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg022 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg023 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg024 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg025 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg026 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg027 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg028 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg029 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg030 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg031 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg032 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg033 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg034 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg035 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 3
               if (this.eval_aedp.pg036 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg037 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg038 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg039 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg040 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg041 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg042 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg043 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg044 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg045 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg046 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg047 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg048 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg049 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 4
               if (this.eval_aedp.pg050 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg051 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg052 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg053 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg054 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg055 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg056 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg057 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg058 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg059 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg060 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 5
               if (this.eval_aedp.pg061 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg062 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg063 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg064 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg065 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg066 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg067 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg068 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg069 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 6
               if (this.eval_aedp.pg070 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg071 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg072 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg073 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg074 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg074b === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg074c === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg074d === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg074e === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg074f === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg074g === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg074h === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg074i === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 7
               if (this.eval_aedp.pg075 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg076 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg077 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg078 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg079 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg080 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg081 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg082 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg083 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg084 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg085 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg086 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg087 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg088 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 8
               if (this.eval_aedp.pg089 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg090 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg091 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg092 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg093 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg094 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg095 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg096 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg097 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg098 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 9
               if (this.eval_aedp.pg099 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg100 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg101 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg102 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg103 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg104 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg105 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg106 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg107 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg108 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg109 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg110 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg111 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 10
               if (this.eval_aedp.pg112 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg113 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg114 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg115 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg116 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg117 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg118 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg119 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg120 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg121 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 11
               if (this.eval_aedp.pg122 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg123 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg124 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg125 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg126 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg127 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg128 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg129 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg130 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg131 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg132 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg133 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg134 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 12
               if (this.eval_aedp.pg135 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg136 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg137 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg138 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg139 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg140 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg141 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg142 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg143 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg144 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg145 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg146 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 13
               if (this.eval_aedp.pg147 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg148 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg149 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg150 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg151 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg152 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg153 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg154 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 14
               if (this.eval_aedp.pg155 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg156 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg157 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg158 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg159 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg160 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg161 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg162 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg163 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg164 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg165 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 15
               if (this.eval_aedp.pg166 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg167 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg168 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg169 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg170 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg171 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg172 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg173 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg174 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg175 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 16
               if (this.eval_aedp.pg176 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg177 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg178 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg179 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg180 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg181 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg182 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg183 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg184 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg185 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg186 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg187 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg188 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 17
               if (this.eval_aedp.pg189 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg190 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg191 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg192 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg193 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg194 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg195 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg196 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg197 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 18
               if (this.eval_aedp.pg198 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg199 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg200 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg201 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg202 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg203 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg204 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg205 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg206 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg207 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg208 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg209 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg210 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg211 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg212 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg213 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg214 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg215 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg216 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg217 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg218 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg219 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg220 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg221 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg222 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg223 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg224 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg225 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg226 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg227 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg228 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg229 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 19
               if (this.eval_aedp.pg230 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg231 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg232 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg233 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg234 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg235 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg236 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg237 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg238 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg239 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg240 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg241 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 20
               if (this.eval_aedp.pg242 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg243 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg244 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg245 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg246 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg247 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg248 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               //? ÁREA 21
               if (this.eval_aedp.pg249 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg250 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg251 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg252 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg253 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_aedp.pg254 === "") {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               return this.pregSinContestar;
          },

          addADayToMyDate: function addADayToMyDate() {
               if (this.eval_fecha) // as myDate can be null
                    // you have to set the this.myDate again, so vue can detect it changed
                    // this is not a caveat of this specific solution, but of any binding of dates
                    this.eval_aedp.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
          },
          dateToYYYYMMDD: function dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0];
          },
          cargaHora: function cargaHora() {

               // Convierte la hora obtenida a hora local (utc)
               this.eval_fecha = new Date();
               var d = this.eval_fecha;
               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               var localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion: function cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_aedp = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev12; // Crea el nodo para todos los campos.
               this.res_aedp = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs12;
               console.log("res ? ", this.res_16pf);

               this.eval_aedp.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
               this.eval_aedp.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_aedp.depto = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_depto; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_aedp.sexo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_sexo; // Nombre de la empresa a la cual pertenece el usuario

               this.instrucciones = this.eval_aedp.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de AUTO EXPLORACIÓN EMOCIONAL PARA EL DESARROLLO PERSONAL.";

               this.eval_fecha = new Date(); // Fecha del Día
          },
          empezarEvaluacion: function empezarEvaluacion() {

               this.eval_aedp.empezo = this.cargaHora();
               this.inicioeval = true;

               this.limpiarEvaluacion2();
          },

          /** .................... VALIDACIONES  .................... */
          validarValor: function validarValor(valor) {
               var lvalor = valor;
               if (valor < 0 || valor > 3) {
                    lvalor = 0;
               }
               // console.log("validarValor, lvalor ? ",lvalor);
               return lvalor;
          },
          limpiarEvaluacion: function limpiarEvaluacion() {

               console.log("LIMPIANDO EVALUACIÓN !!!");

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_aedp = {
                    depto: "Guatemala",
                    empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
                    fecha: "16/01/2019", sexo: "",
                    empezo: "10am", termino: "12am",
                    pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
                    pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
                    pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
                    pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
                    pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: "", pg049: "", pg050: "",
                    pg051: "", pg052: "", pg053: "", pg054: "", pg055: "", pg056: "", pg057: "", pg058: "", pg059: "", pg060: "",
                    pg061: "", pg062: "", pg063: "", pg064: "", pg065: "", pg066: "", pg067: "", pg068: "", pg069: "", pg070: "",
                    pg071: "", pg072: "", pg073: "", pg074: "",
                    pg074b: "", pg074c: "", pg074d: "", pg074e: "", pg074f: "", pg074g: "", pg074h: "", pg074i: "",
                    pg075: "", pg076: "", pg077: "", pg078: "", pg079: "", pg080: "",
                    pg081: "", pg082: "", pg083: "", pg084: "", pg085: "", pg086: "", pg087: "", pg088: "", pg089: "", pg090: "",
                    pg091: "", pg092: "", pg093: "", pg094: "", pg095: "", pg096: "", pg097: "", pg098: "", pg099: "", pg100: "",
                    pg101: "", pg102: "", pg103: "", pg104: "", pg105: "", pg106: "", pg107: "", pg108: "", pg109: "", pg110: "",
                    pg111: "", pg112: "", pg113: "", pg114: "", pg115: "", pg116: "", pg117: "", pg118: "", pg119: "", pg120: "",
                    pg121: "", pg122: "", pg123: "", pg124: "", pg125: "", pg126: "", pg127: "", pg128: "", pg129: "", pg130: "",
                    pg131: "", pg132: "", pg133: "", pg134: "", pg135: "", pg136: "", pg137: "", pg138: "", pg139: "", pg140: "",
                    pg141: "", pg142: "", pg143: "", pg144: "", pg145: "", pg146: "", pg147: "", pg148: "", pg149: "", pg150: "",
                    pg151: "", pg152: "", pg153: "", pg154: "", pg155: "", pg156: "", pg157: "", pg158: "", pg159: "", pg160: "",
                    pg161: "", pg162: "", pg163: "", pg164: "", pg165: "", pg166: "", pg167: "", pg168: "", pg169: "", pg170: "",
                    pg171: "", pg172: "", pg173: "", pg174: "", pg175: "", pg176: "", pg177: "", pg178: "", pg179: "", pg180: "",
                    pg181: "", pg182: "", pg183: "", pg184: "", pg185: "", pg186: "", pg187: "", pg188: "", pg189: "", pg190: "",
                    pg191: "", pg192: "", pg193: "", pg194: "", pg195: "", pg196: "", pg197: "", pg198: "", pg199: "", pg200: "",
                    pg201: "", pg202: "", pg203: "", pg204: "", pg205: "", pg206: "", pg207: "", pg208: "", pg209: "", pg210: "",
                    pg211: "", pg212: "", pg213: "", pg214: "", pg215: "", pg216: "", pg217: "", pg218: "", pg219: "", pg220: "",
                    pg221: "", pg222: "", pg223: "", pg224: "", pg225: "", pg226: "", pg227: "", pg228: "", pg229: "", pg230: "",
                    pg231: "", pg232: "", pg233: "", pg234: "", pg235: "", pg236: "", pg237: "", pg238: "", pg239: "", pg240: "",
                    pg241: "", pg242: "", pg243: "", pg244: "", pg245: "", pg246: "", pg247: "", pg248: "", pg249: "", pg250: "",
                    pg251: "", pg252: "", pg253: "", pg254: "", pg255: "", pg256: "", pg257: "", pg258: "", pg259: "", pg260: ""

                    /* Variables para un nuevo caso */
                    // store.state.eval_aedp = this.eval_aedp;
               };
          },
          limpiarEvaluacion2: function limpiarEvaluacion2() {

               console.log("LIMPIANDO EVALUACIÓN !!!");

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               var tdepto = this.eval_aedp.depto;
               var tnombre = this.eval_aedp.nombre;
               var tempresa = this.eval_aedp.empresa;
               var tfecha = this.eval_fecha;
               var tempezo = this.eval_aedp.empezo;
               var ttermino = this.eval_aedp.termino;

               this.eval_aedp = {};

               this.eval_aedp = {
                    depto: tdepto,
                    empresa: tempresa, nombre: tnombre,
                    fecha: tfecha, sexo: "",
                    empezo: tempezo, termino: ttermino,
                    pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
                    pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
                    pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
                    pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
                    pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: "", pg049: "", pg050: "",
                    pg051: "", pg052: "", pg053: "", pg054: "", pg055: "", pg056: "", pg057: "", pg058: "", pg059: "", pg060: "",
                    pg061: "", pg062: "", pg063: "", pg064: "", pg065: "", pg066: "", pg067: "", pg068: "", pg069: "", pg070: "",
                    pg071: "", pg072: "", pg073: "", pg074: "",
                    pg074b: "", pg074c: "", pg074d: "", pg074e: "", pg074f: "", pg074g: "", pg074h: "", pg074i: "",
                    pg075: "", pg076: "", pg077: "", pg078: "", pg079: "", pg080: "",
                    pg081: "", pg082: "", pg083: "", pg084: "", pg085: "", pg086: "", pg087: "", pg088: "", pg089: "", pg090: "",
                    pg091: "", pg092: "", pg093: "", pg094: "", pg095: "", pg096: "", pg097: "", pg098: "", pg099: "", pg100: "",
                    pg101: "", pg102: "", pg103: "", pg104: "", pg105: "", pg106: "", pg107: "", pg108: "", pg109: "", pg110: "",
                    pg111: "", pg112: "", pg113: "", pg114: "", pg115: "", pg116: "", pg117: "", pg118: "", pg119: "", pg120: "",
                    pg121: "", pg122: "", pg123: "", pg124: "", pg125: "", pg126: "", pg127: "", pg128: "", pg129: "", pg130: "",
                    pg131: "", pg132: "", pg133: "", pg134: "", pg135: "", pg136: "", pg137: "", pg138: "", pg139: "", pg140: "",
                    pg141: "", pg142: "", pg143: "", pg144: "", pg145: "", pg146: "", pg147: "", pg148: "", pg149: "", pg150: "",
                    pg151: "", pg152: "", pg153: "", pg154: "", pg155: "", pg156: "", pg157: "", pg158: "", pg159: "", pg160: "",
                    pg161: "", pg162: "", pg163: "", pg164: "", pg165: "", pg166: "", pg167: "", pg168: "", pg169: "", pg170: "",
                    pg171: "", pg172: "", pg173: "", pg174: "", pg175: "", pg176: "", pg177: "", pg178: "", pg179: "", pg180: "",
                    pg181: "", pg182: "", pg183: "", pg184: "", pg185: "", pg186: "", pg187: "", pg188: "", pg189: "", pg190: "",
                    pg191: "", pg192: "", pg193: "", pg194: "", pg195: "", pg196: "", pg197: "", pg198: "", pg199: "", pg200: "",
                    pg201: "", pg202: "", pg203: "", pg204: "", pg205: "", pg206: "", pg207: "", pg208: "", pg209: "", pg210: "",
                    pg211: "", pg212: "", pg213: "", pg214: "", pg215: "", pg216: "", pg217: "", pg218: "", pg219: "", pg220: "",
                    pg221: "", pg222: "", pg223: "", pg224: "", pg225: "", pg226: "", pg227: "", pg228: "", pg229: "", pg230: "",
                    pg231: "", pg232: "", pg233: "", pg234: "", pg235: "", pg236: "", pg237: "", pg238: "", pg239: "", pg240: "",
                    pg241: "", pg242: "", pg243: "", pg244: "", pg245: "", pg246: "", pg247: "", pg248: "", pg249: "", pg250: "",
                    pg251: "", pg252: "", pg253: "", pg254: "", pg255: "", pg256: "", pg257: "", pg258: "", pg259: "", pg260: ""
               };

               console.log('aedp ? ', this.eval_aedp);
               /* Variables para un nuevo caso */
               // store.state.eval_aedp = this.eval_aedp;
          },

          //** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          //* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion: function agregarEvaluacion() {
               var _this = this;

               console.log("preguntas sin contestar ? ", this.pregSinContestar);
               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ");
                    return;
               }

               this.finalizoeval = true;
               this.eval_aedp.termino = this.cargaHora();

               this.eval_fecha = new Date();

               var ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               var lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de SUPERVISION para " + this.eval_aedp.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvaluaciones = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalAEDP;
                    dbEvaluaciones.push({

                         empresa: this.eval_aedp.empresa, nombre: this.eval_aedp.nombre,
                         empezo: this.eval_aedp.empezo, termino: this.eval_aedp.termino,
                         fecha: lingreso, depto: this.eval_aedp.depto, sexo: this.eval_aedp.sexo,
                         pg001: this.eval_aedp.pg001, pg002: this.eval_aedp.pg002, pg003: this.eval_aedp.pg003, pg004: this.eval_aedp.pg004, pg005: this.eval_aedp.pg005,
                         pg006: this.eval_aedp.pg006, pg007: this.eval_aedp.pg007, pg008: this.eval_aedp.pg008, pg009: this.eval_aedp.pg009, pg010: this.eval_aedp.pg010,
                         pg011: this.eval_aedp.pg011, pg012: this.eval_aedp.pg012, pg013: this.eval_aedp.pg013, pg014: this.eval_aedp.pg014, pg015: this.eval_aedp.pg015,
                         pg016: this.eval_aedp.pg016, pg017: this.eval_aedp.pg017, pg018: this.eval_aedp.pg018, pg019: this.eval_aedp.pg019, pg020: this.eval_aedp.pg020,
                         pg021: this.eval_aedp.pg021, pg022: this.eval_aedp.pg022, pg023: this.eval_aedp.pg023, pg024: this.eval_aedp.pg024, pg025: this.eval_aedp.pg025,
                         pg026: this.eval_aedp.pg026, pg027: this.eval_aedp.pg027, pg028: this.eval_aedp.pg028, pg029: this.eval_aedp.pg029, pg030: this.eval_aedp.pg030,
                         pg031: this.eval_aedp.pg031, pg032: this.eval_aedp.pg032, pg033: this.eval_aedp.pg033, pg034: this.eval_aedp.pg034, pg035: this.eval_aedp.pg035,
                         pg036: this.eval_aedp.pg036, pg037: this.eval_aedp.pg037, pg038: this.eval_aedp.pg038, pg039: this.eval_aedp.pg039, pg040: this.eval_aedp.pg040,

                         pg041: this.eval_aedp.pg041, pg042: this.eval_aedp.pg042, pg043: this.eval_aedp.pg043, pg044: this.eval_aedp.pg044, pg045: this.eval_aedp.pg045,
                         pg046: this.eval_aedp.pg046, pg047: this.eval_aedp.pg047, pg048: this.eval_aedp.pg048, pg049: this.eval_aedp.pg049, pg050: this.eval_aedp.pg050,
                         pg051: this.eval_aedp.pg051, pg052: this.eval_aedp.pg052, pg053: this.eval_aedp.pg053, pg054: this.eval_aedp.pg054, pg055: this.eval_aedp.pg055,
                         pg056: this.eval_aedp.pg056, pg057: this.eval_aedp.pg057, pg058: this.eval_aedp.pg058, pg059: this.eval_aedp.pg059, pg060: this.eval_aedp.pg060,
                         pg061: this.eval_aedp.pg061, pg062: this.eval_aedp.pg062, pg063: this.eval_aedp.pg063, pg064: this.eval_aedp.pg064, pg065: this.eval_aedp.pg065,
                         pg066: this.eval_aedp.pg066, pg067: this.eval_aedp.pg067, pg068: this.eval_aedp.pg068, pg069: this.eval_aedp.pg069, pg070: this.eval_aedp.pg070,
                         pg071: this.eval_aedp.pg071, pg072: this.eval_aedp.pg072, pg073: this.eval_aedp.pg073, pg074: this.eval_aedp.pg074,
                         pg074b: this.eval_aedp.pg074b,
                         pg074c: this.eval_aedp.pg074c, pg074d: this.eval_aedp.pg074d, pg074e: this.eval_aedp.pg074e, pg074f: this.eval_aedp.pg074f,
                         pg074g: this.eval_aedp.pg074g, pg074h: this.eval_aedp.pg074h, pg074i: this.eval_aedp.pg074i,
                         pg075: this.eval_aedp.pg075,
                         pg076: this.eval_aedp.pg076, pg077: this.eval_aedp.pg077, pg078: this.eval_aedp.pg078, pg079: this.eval_aedp.pg079, pg080: this.eval_aedp.pg080,

                         pg081: this.eval_aedp.pg081, pg082: this.eval_aedp.pg082, pg083: this.eval_aedp.pg083, pg084: this.eval_aedp.pg084, pg085: this.eval_aedp.pg085,
                         pg086: this.eval_aedp.pg086, pg087: this.eval_aedp.pg087, pg088: this.eval_aedp.pg088, pg089: this.eval_aedp.pg089, pg090: this.eval_aedp.pg090,
                         pg091: this.eval_aedp.pg091, pg092: this.eval_aedp.pg092, pg093: this.eval_aedp.pg093, pg094: this.eval_aedp.pg094, pg095: this.eval_aedp.pg095,
                         pg096: this.eval_aedp.pg096, pg097: this.eval_aedp.pg097, pg098: this.eval_aedp.pg098, pg099: this.eval_aedp.pg099, pg100: this.eval_aedp.pg100,
                         pg101: this.eval_aedp.pg101, pg102: this.eval_aedp.pg102, pg103: this.eval_aedp.pg103, pg104: this.eval_aedp.pg104, pg105: this.eval_aedp.pg105,
                         pg106: this.eval_aedp.pg106, pg107: this.eval_aedp.pg107, pg108: this.eval_aedp.pg108, pg109: this.eval_aedp.pg109, pg110: this.eval_aedp.pg110,
                         pg111: this.eval_aedp.pg111, pg112: this.eval_aedp.pg112, pg113: this.eval_aedp.pg113, pg114: this.eval_aedp.pg114, pg115: this.eval_aedp.pg115,
                         pg116: this.eval_aedp.pg116, pg117: this.eval_aedp.pg117, pg118: this.eval_aedp.pg118, pg119: this.eval_aedp.pg119, pg120: this.eval_aedp.pg120,

                         pg121: this.eval_aedp.pg121, pg122: this.eval_aedp.pg122, pg123: this.eval_aedp.pg123, pg124: this.eval_aedp.pg124, pg125: this.eval_aedp.pg125,
                         pg126: this.eval_aedp.pg126, pg127: this.eval_aedp.pg127, pg128: this.eval_aedp.pg128, pg129: this.eval_aedp.pg129, pg130: this.eval_aedp.pg130,
                         pg131: this.eval_aedp.pg131, pg132: this.eval_aedp.pg132, pg133: this.eval_aedp.pg133, pg134: this.eval_aedp.pg134, pg135: this.eval_aedp.pg135,
                         pg136: this.eval_aedp.pg136, pg137: this.eval_aedp.pg137, pg138: this.eval_aedp.pg138, pg139: this.eval_aedp.pg139, pg140: this.eval_aedp.pg140,
                         pg141: this.eval_aedp.pg141, pg142: this.eval_aedp.pg142, pg143: this.eval_aedp.pg143, pg144: this.eval_aedp.pg144, pg145: this.eval_aedp.pg145,
                         pg146: this.eval_aedp.pg146, pg147: this.eval_aedp.pg147, pg148: this.eval_aedp.pg148, pg149: this.eval_aedp.pg149, pg150: this.eval_aedp.pg150,
                         pg151: this.eval_aedp.pg151, pg152: this.eval_aedp.pg152, pg153: this.eval_aedp.pg153, pg154: this.eval_aedp.pg154, pg155: this.eval_aedp.pg155,
                         pg156: this.eval_aedp.pg156, pg157: this.eval_aedp.pg157, pg158: this.eval_aedp.pg158, pg159: this.eval_aedp.pg159, pg160: this.eval_aedp.pg160,

                         pg161: this.eval_aedp.pg161, pg162: this.eval_aedp.pg162, pg163: this.eval_aedp.pg163, pg164: this.eval_aedp.pg164, pg165: this.eval_aedp.pg165,
                         pg166: this.eval_aedp.pg166, pg167: this.eval_aedp.pg167, pg168: this.eval_aedp.pg168, pg169: this.eval_aedp.pg169, pg170: this.eval_aedp.pg170,
                         pg171: this.eval_aedp.pg171, pg172: this.eval_aedp.pg172, pg173: this.eval_aedp.pg173, pg174: this.eval_aedp.pg174, pg175: this.eval_aedp.pg175,
                         pg176: this.eval_aedp.pg176, pg177: this.eval_aedp.pg177, pg178: this.eval_aedp.pg178, pg179: this.eval_aedp.pg179, pg180: this.eval_aedp.pg180,
                         pg181: this.eval_aedp.pg181, pg182: this.eval_aedp.pg182, pg183: this.eval_aedp.pg183, pg184: this.eval_aedp.pg184, pg185: this.eval_aedp.pg185,
                         pg186: this.eval_aedp.pg186, pg187: this.eval_aedp.pg187, pg188: this.eval_aedp.pg188, pg189: this.eval_aedp.pg189, pg190: this.eval_aedp.pg190,
                         pg191: this.eval_aedp.pg191, pg192: this.eval_aedp.pg192, pg193: this.eval_aedp.pg193, pg194: this.eval_aedp.pg194, pg195: this.eval_aedp.pg195,
                         pg196: this.eval_aedp.pg196, pg197: this.eval_aedp.pg197, pg198: this.eval_aedp.pg198, pg199: this.eval_aedp.pg199, pg200: this.eval_aedp.pg200,

                         pg201: this.eval_aedp.pg201, pg202: this.eval_aedp.pg202, pg203: this.eval_aedp.pg203, pg204: this.eval_aedp.pg204, pg205: this.eval_aedp.pg205,
                         pg206: this.eval_aedp.pg206, pg207: this.eval_aedp.pg207, pg208: this.eval_aedp.pg208, pg209: this.eval_aedp.pg209, pg210: this.eval_aedp.pg210,
                         pg211: this.eval_aedp.pg211, pg212: this.eval_aedp.pg212, pg213: this.eval_aedp.pg213, pg214: this.eval_aedp.pg214, pg215: this.eval_aedp.pg215,
                         pg216: this.eval_aedp.pg216, pg217: this.eval_aedp.pg217, pg218: this.eval_aedp.pg218, pg219: this.eval_aedp.pg219, pg220: this.eval_aedp.pg220,

                         pg221: this.eval_aedp.pg221, pg222: this.eval_aedp.pg222, pg223: this.eval_aedp.pg223, pg224: this.eval_aedp.pg224, pg225: this.eval_aedp.pg225,
                         pg226: this.eval_aedp.pg226, pg227: this.eval_aedp.pg227, pg228: this.eval_aedp.pg228, pg229: this.eval_aedp.pg229, pg230: this.eval_aedp.pg230,
                         pg231: this.eval_aedp.pg231, pg232: this.eval_aedp.pg232, pg233: this.eval_aedp.pg233, pg234: this.eval_aedp.pg234, pg235: this.eval_aedp.pg235,
                         pg236: this.eval_aedp.pg236, pg237: this.eval_aedp.pg237, pg238: this.eval_aedp.pg238, pg239: this.eval_aedp.pg239, pg240: this.eval_aedp.pg240,
                         pg241: this.eval_aedp.pg241, pg242: this.eval_aedp.pg242, pg243: this.eval_aedp.pg243, pg244: this.eval_aedp.pg244, pg245: this.eval_aedp.pg245,
                         pg246: this.eval_aedp.pg246, pg247: this.eval_aedp.pg247, pg248: this.eval_aedp.pg248, pg249: this.eval_aedp.pg249, pg250: this.eval_aedp.pg250,
                         pg251: this.eval_aedp.pg251, pg252: this.eval_aedp.pg252, pg253: this.eval_aedp.pg253, pg254: this.eval_aedp.pg254

                    }).then(function (data) {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         _this.limpiarEvaluacion();

                         var laClave = data.key;
                         _this.grabado = true;
                         _this.inicioeval = false;

                         _this.cargaEvaluacion();
                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de AEDP guardado con éxito.");
                    });
               } //* if (confirma)
          },
          //* agregarEncuesta()

          //? -------------------------------------------------------------------
          enfoqueE: function enfoqueE(pestana) {
               var _this2 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.tabul2.focus();
                         });

                         this.activo1 = "!active";
                         this.activo2 = "active";

                         this.ver1 = false;
                         this.ver2 = true;
                         break;
                    case 3:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.tabul3.focus();
                         });
                         this.activo2 = "!active";
                         this.activo3 = "active";

                         this.ver2 = false;
                         this.ver3 = true;
                         break;
                    case 0:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.tabul1.focus();
                         });
                         this.activo3 = "!active";
                         this.activo1 = "active";

                         this.ver3 = false;
                         this.ver1 = true;
                    default:
                    // code block
               } //* switch
          },
          nadaE: function nadaE(pestana) {
               var _this3 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.tabul1.focus();
                         });

                         this.activo1 = "active";
                         this.activo2 = "!active";

                         this.ver1 = true;
                         this.ver2 = false;
                         this.ver3 = false;
                         break;
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.tabul2.focus();
                         });
                         this.activo2 = "active";
                         this.activo1 = "!active";

                         this.ver1 = false;
                         this.ver2 = true;
                         this.ver3 = false;
                         break;
                    case 3:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.tabul3.focus();
                         });
                         this.activo3 = "active";
                         this.activo2 = "!active";

                         this.ver1 = false;
                         this.ver2 = false;
                         this.ver3 = true;
                    default:
                    // code block
               } //* switch
          },
          enfoqueRE: function enfoqueRE(pestana) {
               var _this4 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.tabul2.focus();
                         });

                         this.activo3 = "!active";
                         this.activo2 = "active";

                         this.ver3 = false;
                         this.ver2 = true;
                         break;
                    case 1:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.tabul1.focus();
                         });
                         this.activo2 = "!active";
                         this.activo1 = "active";

                         this.ver2 = false;
                         this.ver1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },


          //? =================================================================================
          enfoqueG1: function enfoqueG1(pestana) {
               var _this5 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this5.$refs.testtt2.focus();
                         });

                         this.activott1 = "!active";
                         this.activott2 = "active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         break;
                    case 3:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this5.$refs.testtt3.focus();
                         });
                         this.activott2 = "!active";
                         this.activott3 = "active";

                         this.vertt2 = false;
                         this.vertt3 = true;
                         break;
                    case 4:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this5.$refs.testtt4.focus();
                         });
                         this.activott3 = "!active";
                         this.activott4 = "active";

                         this.vertt3 = false;
                         this.vertt4 = true;
                         break;
                    case 5:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this5.$refs.testtt5.focus();
                         });
                         this.activott4 = "!active";
                         this.activott5 = "active";

                         this.vertt4 = false;
                         this.vertt5 = true;
                         break;
                    case 6:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this5.$refs.testtt6.focus();
                         });
                         this.activott5 = "!active";
                         this.activott6 = "active";

                         this.vertt5 = false;
                         this.vertt6 = true;
                         break;
                    case 7:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this5.$refs.testtt7.focus();
                         });
                         this.activott6 = "!active";
                         this.activott7 = "active";

                         this.vertt6 = false;
                         this.vertt7 = true;
                         break;
                    case 8:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this5.$refs.testtt8.focus();
                         });
                         this.activott9 = "!active";
                         this.activott8 = "active";

                         this.vertt7 = false;
                         this.vertt8 = true;
                         break;
                    case 9:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this5.$refs.testtt9.focus();
                         });
                         this.activott8 = "!active";
                         this.activott9 = "active";

                         this.vertt8 = false;
                         this.vertt9 = true;
                         break;
                    case 10:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this5.$refs.testtt10.focus();
                         });
                         this.activott9 = "!active";
                         this.activott10 = "active";

                         this.vertt9 = false;
                         this.vertt10 = true;
                         break;
                    case 0:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this5.$refs.testtt1.focus();
                         });
                         this.activott10 = "!active";
                         this.activott1 = "active";

                         this.vertt10 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },
          nadaG1: function nadaG1(pestana) {
               var _this6 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this6.$refs.testtt1.focus();
                         });

                         this.activott1 = "active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";
                         this.activott5 = "!active";
                         this.activott6 = "!active";
                         this.activott7 = "!active";
                         this.activott8 = "!active";
                         this.activott9 = "!active";
                         this.activott10 = "!active";

                         this.vertt1 = true;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = false;
                         this.vertt5 = false;
                         this.vertt6 = false;
                         this.vertt7 = false;
                         this.vertt8 = false;
                         this.vertt9 = false;
                         this.vertt10 = false;

                         break;
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this6.$refs.testtt2.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";
                         this.activott5 = "!active";
                         this.activott6 = "!active";
                         this.activott7 = "!active";
                         this.activott8 = "!active";
                         this.activott9 = "!active";
                         this.activott10 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         this.vertt3 = false;
                         this.vertt4 = false;
                         this.vertt5 = false;
                         this.vertt6 = false;
                         this.vertt7 = false;
                         this.vertt8 = false;
                         this.vertt9 = false;
                         this.vertt10 = false;

                         break;
                    case 3:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this6.$refs.testtt3.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "active";
                         this.activott4 = "!active";
                         this.activott5 = "!active";
                         this.activott6 = "!active";
                         this.activott7 = "!active";
                         this.activott8 = "!active";
                         this.activott9 = "!active";
                         this.activott10 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = true;
                         this.vertt4 = false;
                         this.vertt5 = false;
                         this.vertt6 = false;
                         this.vertt7 = false;
                         this.vertt8 = false;
                         this.vertt9 = false;
                         this.vertt10 = false;
                         break;
                    case 4:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this6.$refs.testtt4.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "active";
                         this.activott5 = "!active";
                         this.activott6 = "!active";
                         this.activott7 = "!active";
                         this.activott8 = "!active";
                         this.activott9 = "!active";
                         this.activott10 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = true;
                         this.vertt5 = false;
                         this.vertt6 = false;
                         this.vertt7 = false;
                         this.vertt8 = false;
                         this.vertt9 = false;
                         this.vertt10 = false;
                         break;
                    case 5:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this6.$refs.testtt5.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";
                         this.activott5 = "active";
                         this.activott6 = "!active";
                         this.activott7 = "!active";
                         this.activott8 = "!active";
                         this.activott9 = "!active";
                         this.activott10 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = false;
                         this.vertt5 = true;
                         this.vertt6 = false;
                         this.vertt7 = false;
                         this.vertt8 = false;
                         this.vertt9 = false;
                         this.vertt10 = false;
                         break;
                    case 6:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this6.$refs.testtt6.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";
                         this.activott5 = "!active";
                         this.activott6 = "active";
                         this.activott7 = "!active";
                         this.activott8 = "!active";
                         this.activott9 = "!active";
                         this.activott10 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = false;
                         this.vertt5 = false;
                         this.vertt6 = true;
                         this.vertt7 = false;
                         this.vertt8 = false;
                         this.vertt9 = false;
                         this.vertt10 = false;
                         break;
                    case 7:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this6.$refs.testtt7.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";
                         this.activott5 = "!active";
                         this.activott6 = "!active";
                         this.activott7 = "active";
                         this.activott8 = "!active";
                         this.activott9 = "!active";
                         this.activott10 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = false;
                         this.vertt5 = false;
                         this.vertt6 = false;
                         this.vertt7 = true;
                         this.vertt8 = false;
                         this.vertt9 = false;
                         this.vertt10 = false;
                         break;
                    case 8:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this6.$refs.testtt8.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";
                         this.activott5 = "!active";
                         this.activott6 = "!active";
                         this.activott7 = "!active";
                         this.activott8 = "active";
                         this.activott9 = "!active";
                         this.activott10 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = false;
                         this.vertt5 = false;
                         this.vertt6 = false;
                         this.vertt7 = false;
                         this.vertt8 = true;
                         this.vertt9 = false;
                         this.vertt10 = false;
                         break;
                    case 9:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this6.$refs.testtt9.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";
                         this.activott5 = "!active";
                         this.activott6 = "!active";
                         this.activott7 = "!active";
                         this.activott8 = "!active";
                         this.activott9 = "active";
                         this.activott10 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = false;
                         this.vertt5 = false;
                         this.vertt6 = false;
                         this.vertt7 = false;
                         this.vertt8 = false;
                         this.vertt9 = true;
                         this.vertt10 = false;
                         break;
                    case 10:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this6.$refs.testtt10.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";
                         this.activott5 = "!active";
                         this.activott6 = "!active";
                         this.activott7 = "!active";
                         this.activott8 = "!active";
                         this.activott9 = "!active";
                         this.activott10 = "active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = false;
                         this.vertt5 = false;
                         this.vertt6 = false;
                         this.vertt7 = false;
                         this.vertt8 = false;
                         this.vertt9 = false;
                         this.vertt10 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },
          enfoqueRG1: function enfoqueRG1(pestana) {
               var _this7 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 9:
                         //* Estoy en 10 regreso a 9
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this7.$refs.testtt9.focus();
                         });

                         this.activott10 = "!active";
                         this.activott9 = "active";

                         this.vertt10 = false;
                         this.vertt9 = true;
                         break;

                    case 8:
                         //* Estoy en 9 regreso a 8
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this7.$refs.testtt8.focus();
                         });

                         this.activott9 = "!active";
                         this.activott8 = "active";

                         this.vertt9 = false;
                         this.vertt8 = true;
                         break;
                    case 7:
                         //* Estoy en 8 regreso a 7
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this7.$refs.testtt7.focus();
                         });

                         this.activott8 = "!active";
                         this.activott7 = "active";

                         this.vertt8 = false;
                         this.vertt7 = true;
                         break;
                    case 6:
                         //* Estoy en 7 regreso a 6
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this7.$refs.testtt6.focus();
                         });

                         this.activott7 = "!active";
                         this.activott6 = "active";

                         this.vertt7 = false;
                         this.vertt6 = true;
                         break;
                    case 5:
                         //* Estoy en 6 regreso a 5
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this7.$refs.testtt5.focus();
                         });

                         this.activott6 = "!active";
                         this.activott5 = "active";

                         this.vertt6 = false;
                         this.vertt5 = true;
                         break;

                    case 4:
                         //* Estoy en 5 regreso a 4
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this7.$refs.testtt4.focus();
                         });

                         this.activott5 = "!active";
                         this.activott4 = "active";

                         this.vertt5 = false;
                         this.vertt4 = true;
                         break;
                    case 3:
                         //* Estoy en 4 regreso a 3
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this7.$refs.testtt3.focus();
                         });

                         this.activott4 = "!active";
                         this.activott3 = "active";

                         this.vertt4 = false;
                         this.vertt3 = true;
                         break;
                    case 2:
                         //* Estoy en 3 regreso a 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this7.$refs.testtt2.focus();
                         });

                         this.activott3 = "!active";
                         this.activott2 = "active";

                         this.vertt3 = false;
                         this.vertt2 = true;
                         break;
                    case 1:
                         //* Estoy en 2 regreso a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this7.$refs.testtt1.focus();
                         });
                         this.activott2 = "!active";
                         this.activott1 = "active";

                         this.vertt2 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },


          //? =================================================================================
          enfoqueG2: function enfoqueG2(pestana) {
               var _this8 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this8.$refs.testtt12.focus();
                         });

                         this.activott11 = "!active";
                         this.activott12 = "active";

                         this.vertt11 = false;
                         this.vertt12 = true;
                         break;
                    case 3:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this8.$refs.testtt13.focus();
                         });
                         this.activott12 = "!active";
                         this.activott13 = "active";

                         this.vertt12 = false;
                         this.vertt13 = true;
                         break;
                    case 4:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this8.$refs.testtt14.focus();
                         });
                         this.activott13 = "!active";
                         this.activott14 = "active";

                         this.vertt13 = false;
                         this.vertt14 = true;
                         break;
                    case 5:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this8.$refs.testtt15.focus();
                         });
                         this.activott14 = "!active";
                         this.activott15 = "active";

                         this.vertt14 = false;
                         this.vertt15 = true;
                         break;
                    case 6:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this8.$refs.testtt16.focus();
                         });
                         this.activott15 = "!active";
                         this.activott16 = "active";

                         this.vertt15 = false;
                         this.vertt16 = true;
                         break;
                    case 7:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this8.$refs.testtt17.focus();
                         });
                         this.activott16 = "!active";
                         this.activott17 = "active";

                         this.vertt16 = false;
                         this.vertt17 = true;
                         break;
                    case 8:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this8.$refs.testtt18.focus();
                         });
                         this.activott19 = "!active";
                         this.activott18 = "active";

                         this.vertt17 = false;
                         this.vertt18 = true;
                         break;
                    case 9:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this8.$refs.testtt19.focus();
                         });
                         this.activott18 = "!active";
                         this.activott19 = "active";

                         this.vertt18 = false;
                         this.vertt19 = true;
                         break;
                    case 10:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this8.$refs.testtt20.focus();
                         });
                         this.activott19 = "!active";
                         this.activott20 = "active";

                         this.vertt19 = false;
                         this.vertt20 = true;
                         break;
                    case 11:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this8.$refs.testtt21.focus();
                         });
                         this.activott20 = "!active";
                         this.activott21 = "active";

                         this.vertt20 = false;
                         this.vertt21 = true;
                         break;

                    case 0:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this8.$refs.testtt11.focus();
                         });
                         this.activott21 = "!active";
                         this.activott11 = "active";

                         this.vertt21 = false;
                         this.vertt11 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },
          nadaG2: function nadaG2(pestana) {
               var _this9 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this9.$refs.testtt11.focus();
                         });

                         this.activott11 = "active";
                         this.activott12 = "!active";
                         this.activott13 = "!active";
                         this.activott14 = "!active";
                         this.activott15 = "!active";
                         this.activott16 = "!active";
                         this.activott17 = "!active";
                         this.activott18 = "!active";
                         this.activott19 = "!active";
                         this.activott20 = "!active";
                         this.activott21 = "!active";

                         this.vertt11 = true;
                         this.vertt12 = false;
                         this.vertt13 = false;
                         this.vertt14 = false;
                         this.vertt15 = false;
                         this.vertt16 = false;
                         this.vertt17 = false;
                         this.vertt18 = false;
                         this.vertt19 = false;
                         this.vertt20 = false;
                         this.vertt21 = false;

                         break;
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this9.$refs.testtt12.focus();
                         });
                         this.activott11 = "!active";
                         this.activott12 = "active";
                         this.activott13 = "!active";
                         this.activott14 = "!active";
                         this.activott15 = "!active";
                         this.activott16 = "!active";
                         this.activott17 = "!active";
                         this.activott18 = "!active";
                         this.activott19 = "!active";
                         this.activott20 = "!active";
                         this.activott21 = "!active";

                         this.vertt11 = false;
                         this.vertt12 = true;
                         this.vertt13 = false;
                         this.vertt14 = false;
                         this.vertt15 = false;
                         this.vertt16 = false;
                         this.vertt17 = false;
                         this.vertt18 = false;
                         this.vertt19 = false;
                         this.vertt20 = false;
                         this.vertt21 = false;

                         break;
                    case 3:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this9.$refs.testtt13.focus();
                         });
                         this.activott11 = "!active";
                         this.activott12 = "!active";
                         this.activott13 = "active";
                         this.activott14 = "!active";
                         this.activott15 = "!active";
                         this.activott16 = "!active";
                         this.activott17 = "!active";
                         this.activott18 = "!active";
                         this.activott19 = "!active";
                         this.activott20 = "!active";
                         this.activott21 = "!active";

                         this.vertt11 = false;
                         this.vertt12 = false;
                         this.vertt13 = true;
                         this.vertt14 = false;
                         this.vertt15 = false;
                         this.vertt16 = false;
                         this.vertt17 = false;
                         this.vertt18 = false;
                         this.vertt19 = false;
                         this.vertt20 = false;
                         this.vertt21 = false;

                         break;
                    case 4:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this9.$refs.testtt14.focus();
                         });
                         this.activott11 = "!active";
                         this.activott12 = "!active";
                         this.activott13 = "!active";
                         this.activott14 = "active";
                         this.activott15 = "!active";
                         this.activott16 = "!active";
                         this.activott17 = "!active";
                         this.activott18 = "!active";
                         this.activott19 = "!active";
                         this.activott20 = "!active";
                         this.activott21 = "!active";

                         this.vertt11 = false;
                         this.vertt12 = false;
                         this.vertt13 = false;
                         this.vertt14 = true;
                         this.vertt15 = false;
                         this.vertt16 = false;
                         this.vertt17 = false;
                         this.vertt18 = false;
                         this.vertt19 = false;
                         this.vertt20 = false;
                         this.vertt21 = false;

                         break;
                    case 5:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this9.$refs.testtt15.focus();
                         });
                         this.activott11 = "!active";
                         this.activott12 = "!active";
                         this.activott13 = "!active";
                         this.activott14 = "!active";
                         this.activott15 = "active";
                         this.activott16 = "!active";
                         this.activott17 = "!active";
                         this.activott18 = "!active";
                         this.activott19 = "!active";
                         this.activott20 = "!active";
                         this.activott21 = "!active";

                         this.vertt11 = false;
                         this.vertt12 = false;
                         this.vertt13 = false;
                         this.vertt14 = false;
                         this.vertt15 = true;
                         this.vertt16 = false;
                         this.vertt17 = false;
                         this.vertt18 = false;
                         this.vertt19 = false;
                         this.vertt20 = false;
                         this.vertt21 = false;

                         break;
                    case 6:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this9.$refs.testtt16.focus();
                         });
                         this.activott11 = "!active";
                         this.activott12 = "!active";
                         this.activott13 = "!active";
                         this.activott14 = "!active";
                         this.activott15 = "!active";
                         this.activott16 = "active";
                         this.activott17 = "!active";
                         this.activott18 = "!active";
                         this.activott19 = "!active";
                         this.activott20 = "!active";
                         this.activott21 = "!active";

                         this.vertt11 = false;
                         this.vertt12 = false;
                         this.vertt13 = false;
                         this.vertt14 = false;
                         this.vertt15 = false;
                         this.vertt16 = true;
                         this.vertt17 = false;
                         this.vertt18 = false;
                         this.vertt19 = false;
                         this.vertt20 = false;
                         this.vertt21 = false;

                         break;
                    case 7:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this9.$refs.testtt17.focus();
                         });
                         this.activott11 = "!active";
                         this.activott12 = "!active";
                         this.activott13 = "!active";
                         this.activott14 = "!active";
                         this.activott15 = "!active";
                         this.activott16 = "!active";
                         this.activott17 = "active";
                         this.activott18 = "!active";
                         this.activott19 = "!active";
                         this.activott20 = "!active";
                         this.activott21 = "!active";

                         this.vertt11 = false;
                         this.vertt12 = false;
                         this.vertt13 = false;
                         this.vertt14 = false;
                         this.vertt15 = false;
                         this.vertt16 = false;
                         this.vertt17 = true;
                         this.vertt18 = false;
                         this.vertt19 = false;
                         this.vertt20 = false;
                         this.vertt21 = false;

                         break;
                    case 8:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this9.$refs.testtt18.focus();
                         });
                         this.activott11 = "!active";
                         this.activott12 = "!active";
                         this.activott13 = "!active";
                         this.activott14 = "!active";
                         this.activott15 = "!active";
                         this.activott16 = "!active";
                         this.activott17 = "!active";
                         this.activott18 = "active";
                         this.activott19 = "!active";
                         this.activott20 = "!active";
                         this.activott21 = "!active";

                         this.vertt11 = false;
                         this.vertt12 = false;
                         this.vertt13 = false;
                         this.vertt14 = false;
                         this.vertt15 = false;
                         this.vertt16 = false;
                         this.vertt17 = false;
                         this.vertt18 = true;
                         this.vertt19 = false;
                         this.vertt20 = false;
                         this.vertt21 = false;

                         break;
                    case 9:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this9.$refs.testtt19.focus();
                         });
                         this.activott11 = "!active";
                         this.activott12 = "!active";
                         this.activott13 = "!active";
                         this.activott14 = "!active";
                         this.activott15 = "!active";
                         this.activott16 = "!active";
                         this.activott17 = "!active";
                         this.activott18 = "!active";
                         this.activott19 = "active";
                         this.activott20 = "!active";
                         this.activott21 = "!active";

                         this.vertt11 = false;
                         this.vertt12 = false;
                         this.vertt13 = false;
                         this.vertt14 = false;
                         this.vertt15 = false;
                         this.vertt16 = false;
                         this.vertt17 = false;
                         this.vertt18 = false;
                         this.vertt19 = true;
                         this.vertt20 = false;
                         this.vertt21 = false;

                         break;
                    case 10:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this9.$refs.testtt20.focus();
                         });
                         this.activott11 = "!active";
                         this.activott12 = "!active";
                         this.activott13 = "!active";
                         this.activott14 = "!active";
                         this.activott15 = "!active";
                         this.activott16 = "!active";
                         this.activott17 = "!active";
                         this.activott18 = "!active";
                         this.activott19 = "!active";
                         this.activott20 = "active";
                         this.activott21 = "!active";

                         this.vertt11 = false;
                         this.vertt12 = false;
                         this.vertt13 = false;
                         this.vertt14 = false;
                         this.vertt15 = false;
                         this.vertt16 = false;
                         this.vertt17 = false;
                         this.vertt18 = false;
                         this.vertt19 = false;
                         this.vertt20 = true;
                         this.vertt21 = false;

                         break;
                    case 11:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this9.$refs.testtt21.focus();
                         });
                         this.activott11 = "!active";
                         this.activott12 = "!active";
                         this.activott13 = "!active";
                         this.activott14 = "!active";
                         this.activott15 = "!active";
                         this.activott16 = "!active";
                         this.activott17 = "!active";
                         this.activott18 = "!active";
                         this.activott19 = "!active";
                         this.activott20 = "!active";
                         this.activott21 = "active";

                         this.vertt11 = false;
                         this.vertt12 = false;
                         this.vertt13 = false;
                         this.vertt14 = false;
                         this.vertt15 = false;
                         this.vertt16 = false;
                         this.vertt17 = false;
                         this.vertt18 = false;
                         this.vertt19 = false;
                         this.vertt20 = false;
                         this.vertt21 = true;

                         break;

                    default:
                    // code block
               } //* switch
          },
          enfoqueRG2: function enfoqueRG2(pestana) {
               var _this10 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 10:
                         //* Estoy en 21 regreso a 20
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this10.$refs.testtt20.focus();
                         });

                         this.activott21 = "!active";
                         this.activott20 = "active";

                         this.vertt21 = false;
                         this.vertt20 = true;
                         break;

                    case 9:
                         //* Estoy en 20 regreso a 19
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this10.$refs.testtt19.focus();
                         });

                         this.activott20 = "!active";
                         this.activott19 = "active";

                         this.vertt20 = false;
                         this.vertt19 = true;
                         break;

                    case 8:
                         //* Estoy en 19 regreso a 18
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this10.$refs.testtt18.focus();
                         });

                         this.activott19 = "!active";
                         this.activott18 = "active";

                         this.vertt19 = false;
                         this.vertt18 = true;
                         break;
                    case 7:
                         //* Estoy en 18 regreso a 17
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this10.$refs.testtt17.focus();
                         });

                         this.activott18 = "!active";
                         this.activott17 = "active";

                         this.vertt18 = false;
                         this.vertt17 = true;
                         break;
                    case 6:
                         //* Estoy en 17 regreso a 16
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this10.$refs.testtt16.focus();
                         });

                         this.activott17 = "!active";
                         this.activott16 = "active";

                         this.vertt17 = false;
                         this.vertt16 = true;
                         break;
                    case 5:
                         //* Estoy en 16 regreso a 15
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this10.$refs.testtt15.focus();
                         });

                         this.activott16 = "!active";
                         this.activott15 = "active";

                         this.vertt16 = false;
                         this.vertt15 = true;
                         break;

                    case 4:
                         //* Estoy en 15 regreso a 14
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this10.$refs.testtt14.focus();
                         });

                         this.activott15 = "!active";
                         this.activott14 = "active";

                         this.vertt15 = false;
                         this.vertt14 = true;
                         break;
                    case 3:
                         //* Estoy en 14 regreso a 13
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this10.$refs.testtt13.focus();
                         });

                         this.activott14 = "!active";
                         this.activott13 = "active";

                         this.vertt14 = false;
                         this.vertt13 = true;
                         break;
                    case 2:
                         //* Estoy en 13 regreso a 12
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this10.$refs.testtt12.focus();
                         });

                         this.activott13 = "!active";
                         this.activott12 = "active";

                         this.vertt13 = false;
                         this.vertt12 = true;
                         break;
                    case 1:
                         //* Estoy en 12 regreso a 11
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this10.$refs.testtt11.focus();
                         });
                         this.activott12 = "!active";
                         this.activott11 = "active";

                         this.vertt12 = false;
                         this.vertt11 = true;
                         break;
                    default:
                    // code block
               } //* switch
          }
     } // methods
     // export

});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *      ev11_auxi.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_jspdf___default.a);



// import 'materialize-css/dist/css/materialize.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
     name: 'auxiliar',
     components: {
          'moment': __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
          'input-date': __WEBPACK_IMPORTED_MODULE_1__ingreso_vue__["a" /* default */]
     },
     template: '#formaauxi',
     data: function data() {
          return {
               ejemplo: {},
               eval_auxi: {}, res: {},
               modo: "",
               eval_fecha: new Date(),
               eval_fecha2: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,

               activott1: "active", activott2: '!active', activott3: "!active", activott4: "!active",
               vertt1: true, vertt2: false, vertt3: false, vertt4: false // return
          };
     },
     // data()
     mounted: function mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

          this.horafinal();

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();
     },

     computed: {
          l_sinResponder: function l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder: function l_ejeSinResponder() {
               return this.ejeSinContestar();
          }
     },
     methods: {
          horafinal: function horafinal() {

               this.eval_fecha2 = new Date();
               var minutoinicial = this.cargaHora(this.eval_fecha);
               var minutoactual = this.cargaHora(this.eval_fecha2);
               console.log("[ ", this.eval_fecha2, ", ", minutoactual, " ]");
               return minutoactual;
          },
          crearPDF: function crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_auxi.nombre,
                   patron = / /g,
                   nuevoValor = "",
                   nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "auxi_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBUODAsLDBkSEw8VHhsgHx4bHR0hJTApISMtJB0dKjkqLTEzNjY2ICg7Pzo0PjA1NjP/2wBDAQkJCQwLDBgODhgzIh0iMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzP/wAARCACMAS0DASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD3+iiigAooooAKKKKACjIqnqWpW2l2T3V1IEjUdz19q8+0/wCI5bXpPtS7bGUgJz9z3qowb2MamIp02lJ7nptFRwzRzxLJE4dGGQwOQakqTbcKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAoopDQBg6zrz2Nx9mgQGQDLFugyKl0XW21F2hlQLIBkFehFU9c0S4uLs3Nuu/djcueRgUzS7I6QHvb47AowqjrVaWObmqKprsdTVPUtSttKs3urqQJGv61x9/rFxe3BdXZEHCqDjiqEztcpsnYyLnOGOaOUmeKS0icp4l8T3PiG8LMSluv+rj9Pc1g16EbaDH+pj/75FY9lBG3iO+UxqVCjC44rqhNJaHh1qM5z5pO7ZP4O8ZyaPMtleuzWbHAJ5KH/AAr1+GZJo1kjYMjDII715j9mg/54p/3yKsx3E0SBI5GRB0APArGaTd0elha0qUeWWp6Qa5vU/EctvdtBbIuE4ZmqlpGuvazeXcuXhY4yedtP1LRZ5bprizXzYpPmBBrO1nqdcqrlG9M29G1f+042DJtlT7w7GtSsXQdIl09Xknx5j8bQegrapM3p83L724UZrG8VTSW/hq+khcpII+GXqKxbHwbb3FjBM+oX+XjDH976ikWdnRXGXHhTSrQZuNZvIh/t3GKrxaHoE0ixxa/cO7HAUXGSTQB3dFcr/wAILaf9BC//AO/1Ml8FWMMZkk1K/VFGSTN0oA62jNcCNI8O5AHiK45/6eavQ+D9OuU3w6teyL6rPmgDsM0V594g0BfD9gl/a3180scycGTORn0rSWXxJr65jCaVaEZDH5pWH9KAOtZ1RdzsFHqTUf2u3/57xf8AfYrkLzw1o1lD9p1nUriY/wB6WUjP0FZB/wCEMzgWt4y/3wr4oA9KR1dcqwYeoOadXDWHh7QdRUy6PqVzC6/885TkfUGrjf8ACS6ENwK6taDqD8sqj+tAHW0Vw2ueLRc6Vby6XcSW7+eFuf3ZMkI9xVS0v7m9nWCLxZIsjdBJBtz+YoA9EorlhoniE9PET/8AfoUf2H4i/wChif8A79CgDqaK5NtI11G2t4mIPoYwKUaP4kxmPxDu9N0QoA6uiuUJ8YWWOLK+UdQBsY1NZ+LoPtK2mqW0unXLcKJfuN9GoA6WikDBgCDkHoaWgAooooAazbVLHoBmuC1PUptQnLSfKin5UB4Fdlqd/b6fZST3MgRMY+prgCcsffmrgceKnZWQlGKKKs4bGJc+IRaTNDNZyK4/2utZlvraQ6rcXZhYiVQAueldBqemx6jFtYbZQPlb0rl7fRbqa+Nsybdh+dyOMVrBwtqcVVVVJWOh0/WTqE2yO1cKPvPuGBWrUFraRWcCxQqAo7+tT1m7X0Oumnb3twIyMHpW54f1OWG5SzY7on4GT90+1YdT2d1FZXcdxO22KM5Y0mro3pTcZJno1FRwzJPEskTB0YZDDvUlYnqmH4v/AORWv/8ArnVS+1d9K8N2S26b7y4jSOBM9WIFW/F//Iq3/wD1zrF0nbqfieyGd8Wn2SsBkYDsOv5UAaFh4PtSouNXJv7xxl2l+6D6AVn+JdI0/T59He0tIoXN6gLIuDiu26Vy/jL7+jf9fyUAdRWZ4h/5F++/64t/KtOszxD/AMi/f/8AXFv5UAZeh+HdIudBsZZdPgd3hUsxXknFUNZ0+PwqU1TSpDCC4V7TPyy59B610fh3/kXNO/64L/KsSAf8JH4pknf5rHTWKRqejydz+FAHSxhLy1jeWIfMA+x1ztNM1G+h0ywmu5mASJdxz/KrYrlfFGdS1fS9EH3JX86b/dXt+dADNG0V9XlGs60vmSycwQMPkiXtx611It4gu0RoB6BRipFUKoAGAKWgDmNc8OjnUtJH2fUIRuAjGFkHoRWnomqJrGmR3IG1/uun91h1FaeAa5bRx/Zvi/UdP6RXKi4iHoe9AEmv+HjO/wDaWl7YdQi54HEo/ukVRllsfEXhW7mNqkV5bqd64AaNxXZmuF8VQf2HfSapCpFrdxNDcoOm4jhqAOm8O3DXWgWMznLNEMmtQ1i+EQP+EX0/H/PIVt0AcXe6XBrPje4t7l5RGlqjKEcrg5xT7nRNS0BGvNHvZ54owWe1nbduA9DVq2/5KFd/9eSfzrpmAIwRkUAUdJ1GHVtOivIeA45HdT3FO1DTLTU7Zre7hWWNvUcj6VheFB9l1PW7BT+7hutyD0DDNdV1oA5LRbi40LVv7CvZGkgkybKZjzj+4a6zNcv41j8vSodRX/W2U6yg9wM8it/T7tb7T7e7QYWaMOAfegC1VLU9SttKsnurqQIiDv1J9BV2vIPiH/bB1PN2D9iyfI2/dx7+9XCPM7HPiqzo03JK5leIPEtz4g1RHclLdXHlx9h7mum7V53H/rU2/e3DH1zXV58QY48iuicEkkjwaNaU5OUtWxusahLp99bOnKlTvUdxmtW0u4r23WaJsqevsa5PWzfmSH7cE3BTt2fWn+HvtZvT9n/1X/LTPSiUUoXHCs3V5TqZ7hYE3Hk9h61nR3si3BkJyD1FR3IlMx8373b0xUXT6V8djcxrSre7okfomX5TQjQ973nLr/kb8ciyoHUgiqmpanFpsGThpWGET1qtYifzCIunv0rmNQ+1C+f7WD5vv0/Cvo8urvE01KSsfHZzQWCquEHdfkdRoNzJdWkksr7nMh/CrOqHGl3P+5WBo41QWZ+xCPytx+961ZvTrf2KYT+T5W35sdcV3OPvHmqo/Zlvwb4xl0eZLO8YvZvxknlD/hXr8E8dxCssTh0cZVh3r5wr1X4a/wBqmyl+0Z+w/wDLPf1z7e1TWgl7yOrLcVOUvZS1O5ubaK7t5IJ0DxSKVZT0Iqnpehadoxf7BbLD5mN2CTnFaVFcx7QVy/jL7+jf9fyf1rqK5fxl9/Rv+v5P60AdRWZ4h/5F+/8A+uLfyrTrM8Q/8i/f/wDXFv5UAZ8F5/Z/gOK67x2YI+uMCrPhay+w6Baow/eOvmOfVjyaw9TYj4eafGD/AK3yUP0NdlCgSNEHRVAFADzXL2gNx4/vZTyLe1WMexJzXUGuZ0D5vE2uuevmIv5CgDp6KKKACuV1nNv4y0O4AwJBJET68ZFdVXK+Kjt1jw+46i7x+YoA6kc81meIbBdR0O7t2GdyZH1Faa011DqVPQjFAGP4T48M2A9I8GtuqemWhsrJIP7ucVcoA5i2/wCShXf/AF5L/OunPSuWgYL8QbslgB9jXqfermt+JLXTrcxQus97INsUMZyS3v6UAUvDn73xH4gmTlPPVc+pArqelYvhfTH0vSQJ+bqdjLMf9onpWwzhQWJAA6kmgDnPHEmPDcsA+/cMsaD1JNa+i2jWOi2Vq/3oYVQ/UCueWT/hKPEsRi+bTtNbcX7SSdgPpXXgYoAWqepabbapZva3UYeNxj3HuKuUUCaTVmeF+IPDVz4f1VFYF7ZnHlyY6iun7V6Bqljb6jZSQXMYdMZGexFcC3U1tzuSPJqYVUZNx2ZhazpsuoX9qicIFO5vTmtW1tYrOBYYVCqP1qainzNqxlGmlLmIp7dZ0II+bsfSsyOykecxt0HU1a1LU4tOt8khpT9xO5965e31q7gvmuXfcGPzoehHtXDXyuliJqbR30M8q4ODpRd0/wADtI41ijCqMAVT1LTYtRg2sNsg+4/pU9rdxXkAmiYFT+lT12RiqatHSxxTn7b3pa3MvQbaS0spIpRh1kNWNUGdLuc/3KuVPZ2sV7dx2s43RSNhh7VXN1JhT05EYfgzwbJrEi3t6pSzU8A9XP8AhXr0MMcESxRIERRgKOgFEMKQRLHGgVFGAB2qSs5zcndnqYfDQoRtEKKKKg6Arl/GX39G/wCv5P611Fcv4y+/o3/X8n9aAOorN8Qf8i/f/wDXFv5VpVmeIf8AkX7/AP64t/KgDm9T48CaOewkgrtV6D6VyF9A03w2i2DLx28cgx2Iwf5V0um3C3WnW06nIeMH9KALbdq5nw7/AMjBr3/Xdf8A0GumPauY0g+V4w1qH++scgH4UAdRRRRQAVyni3/kJ6B/1+iurrlvEmJfEPh+AdfPZyPYCgDqBSHrSjrUF7MLe0mmJwEQnNAEkUiyruQ5FPNZPhqRptBtZWPLruP51r0Acl4htvDban5up3ZhudgBCyFcjt0qtYan4N0di9tNF5vdzl2/OrItbe68f3azwpKBZoQHXOOa6JdLsIzlLOAEeiCgDAbxvZSEpY2l5eSnosUR5/GojY694jONQI02xP3oY2zI49z2rrEjSMfIir9Bin0AVrKxttOtktrWJY4kGAoqzRRQAUUUGgBrDcCp6GuC1PTpdPuCrfMhOVbHWtnXNauILw21uwTaBuPc8ZpumXx1gPY3oEhIyr4wRVLTU5arhUfJ1OaorQ1DR7mzuNixs6H7rKM5qjNG1um+dTGucbnGBVp3OKUJR3MK48Oi6naaa8kZj7VnW+ixzarc2ZmcLEAQwHWun+0wf894/wDvqseyniXxHfM0iAFRg7uDWsXI4qkKd0WNP0b+z5t8V05U8MpHBrVqL7Tb/wDPeL/voVaS3mkUOkbOp6FRwahtt6nTCKWkSKt3w/pcstwl2/yxJ0yPvGmaRob3UokuVZIVOcEY3e1SalrM8V09vaN5UUfygAVDd9EdVOCgueZ19FYugatLqCvHP/rE5yO4rarNqx3xkpK6CiiigoK5bxl9/Rv+v5K6muW8Y/63Rv8Ar+SgDqazPEP/ACL9/wD9cW/lWnWb4g/5AF9/1wb+VAEWhwpceFrKJxlXtlUj2xWd4PnaCG60eY/vrGUqAe6Hoa1PDn/Iuaf/ANcF/lWV4ht5tL1CLxBZoT5Y2XUY/jT1/CgDpya5a4P2H4g20p4jvbYx5/2l5rorO8hvrWO5gcPFIMqRWJ4vs5ZtOivrVc3NjIJkA6kDqPyoA6SiqemahFqmnw3kLZSRc49D6VcoAK5aXF94/gVeRY2xLH3auhvLuOxtJbmZsRxruJrA8JwSyi61i5XbNfSblB/hQdBQB03SuU8d6i1torWsGTcXPyqo67RyTXS3V1Fa27zzOEjQZZiegrjLdJdaj1LxFdIViEDx2cZ7LjlvxoA3/CX/ACK+n/8AXIVt1ieEv+RX0/8A65CtugDmLb/koV3/ANeS/wA66euYtv8AkoV3/wBeS/zrp6ACiiigAooooAKKKKAMLWNCa+uPtELgORhg3Q0/RdEOnMZpSDKRjjoK2qKdzP2cebm6hVPUtNttVs3tbqPfE/6e4q5RSLavozwrxN4YuPD12QQXtn/1cn9DWB0/xr6I1HTbfVLGS1ukDxuMHI6VwGn/AA2aPXHN24exjbcmOr+xrphWXLqeHictl7S9PZmT4N8GPq8y3t6hWzXoM4L/AP1q9diiSGNY41CoowAOgoihSCJYolCIowqgcCpKwlJyd2erhsPGhCyENc5qnhyS4umntmUbzllJxzXSUVNzacFNWZl6PpI02NizBpX6kdBWpRRQ3ccYqKsgoNFFAzD1nxNa6Ncw2zwXE88qlgkKbiB6msnzbvxPqtjL9hmtbG0fzSZxhnbsAK1dZ8Mx6tfQ3iXtxaTxoU3QnqDVH/hDbkf8zHqX/fQoA6kVDewC6s5rc9JEK/mK53/hDrn/AKGLUv8AvoUf8Idcf9DFqX/fQoAp2Gt33h20TTdQ0q6mEPyxzQLuVl7V0ekata6/p5uIEcJuKPHIuCD3BFY//CG3H/Qxal/30K2ND0WLQ7JraOaSYvIZGkk6sTQBhT2N94VuXutNje40uQlpbUctF6lfb2rd0zWtP1m28y1nV+zIeGX2IrSIzWFqXhHTdQnNygktbr/ntbnac+/rQBnzaTqmhXct1oQWe1lbdLZyHGD6qe1OHiy9HyHw7qAmHGABjP1o/sfxNacWmtRXCjoLiLnH1FSbfGQ43aYf9r5s0AV/7N1bxHcRvrCLaaeh3C1Rss57bjW9f6pYaNaB7mVIkUYVe59gKxjpXim84uNYgtkJ5FvFk/nVvT/CGn2k4urhpL266+bcndz7DtQBg397/awjvdaZrDQ1kAjibO+du2QO1WdR8UWeoadJpeiwS3E0yeWm2MqiDpnJrZ8SaFJrVtbLBci3lt5fMRiu4flWcmg+I05j1u3T/dtgKAN7SLM6fpVraHG6KMKSPXFXea5f+xvFH/QwRf8Afij+xvFH/QwQ/wDfigBmsvPoviePWjBJNZPB5M3lLkpzwcVetfGeh3U8UCXZWWRtqq8bDJ9OlVDovicg51+I5/6YVAfCWq3N3avfatE8UMokIjgCkke9AHY0UCigAooooAKKKKACg9KKD0oArpfWsly1ulzE06/ejDgsPwqwOleeeGbCwk1Nb+abyr4X9wsYzzMPQ/SvQxQBXmvrW3mSGa4ijkf7qM4BNTivMfGUSSa/qcjoDJFDAY2P8HzjJFelwnMKZ/uj+VACS3EMDossqIXOFDHG4+1LBPHcRLLDIskbdGU5BrgfihLLCulSwj94kzEY/wB2ug8Dc+ELA4xlSf1oA35ZUhjMkjqiKMlmOAKZb3UF3EJbeaOaM/xxsGH5isrxZai98OXVv56QlgNrOcKTngH69KzfAqWqafd+RE8EonxPAekbgfw+xHNAHWMQqkk4AqCK+tpmRYp43Z13KFYHI9add/8AHnP/ANc2/lXnfgwf8TjSuP8AmHyf+h0AelVElxFJO8KSq0iffUHlfrUo6VyujceOde/3Iv5UAdVVO71SxsZAl1dwwswyA7gEirlcd44sbWefR5ZYEdzeJGSRklT2+lAHXo6yKHU5UjII702eeK2iMk8qRRjqzsAKWONY0VEUKqjAA7CuY8eIsulWUTjdG97GGX+8OeKAOmhmiuIhJDIkiHoyEEGnSOscbO7BVUZJJ4ArmPAqiPQ7iNRhUvJVUegzWp4lz/wjOpY/592/lQBdtb61vULWtzFMo6mNw2PyqxXnPw3VXvbyaGAwwrbxRsp4y3c/jXow6UAU49TsZbw2aXcLXC5zEHG4Y9quVw3haMnxZrT/ANnRsou5P9LyNyH+7Xc0AV5ry1t5khluYY5H+6juAW+gqxXnPjGxtv8AhJhd3ZEls8caSGI/vbY5+VsehNeiJjYuDkYoAdRgUUUAFQXN3b2aB7meKFScAyOFBP41PXFePrTz47KcrHOIS5e1ZsF1xyV9xQB2aMroGUhlIyCOQaJJEhjaSRwiKMszHAArN8O/ZR4fsRZu72/lDYz9ce9VfGcyw+ENSYnGYto/GgDYtrqC8hE1vMksR6MhyDU1cZ8M3UeGXt0YMsM7AMO+ea7OgAooooAKKKKACgjIoooA5+z8H6bZa0dTjacyb2dY2fKIzdSBXQUUUAYGqeEdO1fUkvrhpg4Ch1R8K+05GRW8qhVAHQcClooAzNV0K01iW3kud37gsVCnGcjBzU2k6ZDo+mQ2MDM0UQwpY81dooAp6pptvq+ny2V0CYpBg4OCPeq+iaFbaFbPDbvLIZH3vJK2WY1qUUAI6h0ZG6MMGsLR/CWn6LfSXds87OwKqJHyEUnOBW9RQADisM+GYP8AhITrCXdzHK2N8SPhHwO4rcooAAMVQ1PSYNUNsZ2YfZ5hMu09SPWr9FABWdrWjW+uWH2S5aRFDB1aM4ZWHQitGigDP0fSLfRdPWztmdkBLFnOSxPUmrN7aR31jPaSkiOZCjFTg4NT0UAZGkeHbTRZpZLVpMyRojBjkfKMA/WteiigDDsvDFtYa3PqcNzchpnZ3i3/ACEn2rcoooAwNW8I6drGppfXDTLIAodUbCuAcgGtHTbB9PjlR7qS43ys6l/4Qf4R7Cr1FABRRRQAVj654cs9fSEXLzRtESVeF9rYPUZrYooAzdN0aHSmItpZvK8tUWJ2yq47ipNV0qDWLE2lyW8ourHb3wc4q9RQBiW3hm1sr03FrPcQhpvNaJGAQnGMYx0rb7UUUAFFFFAH/9k=";
               var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1); // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de AUXILIAR DE COMPUTO para " + this.eval_auxi.nombre + " de " + this.eval_auxi.empresa + " ( " + this.eval_auxi.depto + " )");

               this.respuestas(doc);
               this.resultados(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          resultados: function resultados(doc) {

               doc.setLineWidth(0.25);

               doc.text(10, 70, "SECCION DE RESULTADOS ");
               doc.line(10, 71, 206, 71);

               doc.text(10, 74, "Conteo:       ( 0= ");
               doc.text(35, 74, this.res_auxi.Uno.toString());
               doc.text(38, 74, ", 1= ");
               doc.text(45, 74, this.res_auxi.Dos.toString());
               doc.text(49, 74, ", 2= ");
               doc.text(56, 74, this.res_auxi.Cero.toString());
               doc.text(59, 74, " )");

               doc.text(70, 74, "( 0= ");
               doc.text(78, 74, this.res_auxi.Uno2.toString());
               doc.text(81, 74, ", 1= ");
               doc.text(88, 74, this.res_auxi.Dos2.toString());
               doc.text(91, 74, ", 2= ");
               doc.text(98, 74, this.res_auxi.Cero2.toString());
               doc.text(101, 74, " )");

               doc.text(10, 80, "Resultados: [ ");
               doc.text(30, 80, this.res_auxi.cpreviaIzq.toString());
               doc.text(35, 80, ", ");
               doc.text(40, 80, this.res_auxi.cpreviaDer.toString());
               doc.text(45, 80, " ] ");

               doc.text(10, 85, "Rangos: ");
               doc.text(28, 85, this.res_auxi.rangos.toString());
          },
          respuestas: function respuestas(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ");
               doc.line(10, 42, 206, 42);
               doc.text(10, 45, this.eval_auxi.pg001 === "a" ? "| 01= (a)" : this.eval_auxi.pg001 === "b" ? "| 01= (b)" : "| 01= (c)");
               doc.text(23, 45, this.eval_auxi.pg002 === "a" ? "| 02= (a)" : this.eval_auxi.pg002 === "b" ? "| 02= (b)" : "| 02= (c)");
               doc.text(36, 45, this.eval_auxi.pg003 === "a" ? "| 03= (a)" : this.eval_auxi.pg003 === "b" ? "| 03= (b)" : "| 03= (c)");
               doc.text(49, 45, this.eval_auxi.pg004 === "a" ? "| 04= (a)" : this.eval_auxi.pg004 === "b" ? "| 04= (b)" : "| 04= (c)");
               doc.text(62, 45, this.eval_auxi.pg005 === "a" ? "| 05= (a)" : this.eval_auxi.pg005 === "b" ? "| 05= (b)" : "| 05= (c)");
               doc.text(75, 45, this.eval_auxi.pg006 === "a" ? "| 06= (a)" : this.eval_auxi.pg006 === "b" ? "| 06= (b)" : "| 06= (c)");
               doc.text(88, 45, this.eval_auxi.pg007 === "a" ? "| 07= (a)" : this.eval_auxi.pg007 === "b" ? "| 07= (b)" : "| 07= (c)");
               doc.text(101, 45, this.eval_auxi.pg008 === "a" ? "| 08= (a)" : this.eval_auxi.pg008 === "b" ? "| 08= (b)" : "| 08= (c)");
               doc.text(114, 45, this.eval_auxi.pg009 === "a" ? "| 09= (a)" : this.eval_auxi.pg009 === "b" ? "| 09= (b)" : "| 09= (c)");
               doc.text(127, 45, this.eval_auxi.pg010 === "a" ? "| 10= (a)" : this.eval_auxi.pg010 === "b" ? "| 10= (b)" : "| 10= (c)");
               doc.text(140, 45, this.eval_auxi.pg011 === "a" ? "| 11= (a)" : this.eval_auxi.pg011 === "b" ? "| 11= (b)" : "| 11= (c)");
               doc.text(153, 45, this.eval_auxi.pg012 === "a" ? "| 12= (a)" : this.eval_auxi.pg012 === "b" ? "| 12= (b)" : "| 12= (c)");
               doc.text(166, 45, this.eval_auxi.pg013 === "a" ? "| 13= (a)" : this.eval_auxi.pg013 === "b" ? "| 13= (b)" : "| 13= (c)");
               doc.text(179, 45, this.eval_auxi.pg014 === "a" ? "| 14= (a)" : this.eval_auxi.pg014 === "b" ? "| 14= (b)" : "| 14= (c)");
               doc.text(192, 45, this.eval_auxi.pg015 === "a" ? "| 15= (a) |" : this.eval_auxi.pg015 === "b" ? "| 15= (b) |" : "| 15= (c) |");
               doc.line(10, 46, 206, 46);

               doc.text(10, 49, this.eval_auxi.pg016 === "a" ? "| 16= (a)" : this.eval_auxi.pg016 === "b" ? "| 16= (b)" : "| 16= (c)");
               doc.text(23, 49, this.eval_auxi.pg017 === "a" ? "| 17= (a)" : this.eval_auxi.pg017 === "b" ? "| 17= (b)" : "| 17= (c)");
               doc.text(36, 49, this.eval_auxi.pg018 === "a" ? "| 18= (a)" : this.eval_auxi.pg018 === "b" ? "| 18= (b)" : "| 18= (c)");
               doc.text(49, 49, this.eval_auxi.pg019 === "a" ? "| 19= (a)" : this.eval_auxi.pg019 === "b" ? "| 19= (b)" : "| 19= (c)");
               doc.text(62, 49, this.eval_auxi.pg020 === "a" ? "| 20= (a)" : this.eval_auxi.pg020 === "b" ? "| 20= (b)" : "| 20= (c)");
               doc.text(75, 49, this.eval_auxi.pg021 === "a" ? "| 21= (a)" : this.eval_auxi.pg021 === "b" ? "| 21= (b)" : "| 21= (c)");
               doc.text(88, 49, this.eval_auxi.pg022 === "a" ? "| 22= (a)" : this.eval_auxi.pg022 === "b" ? "| 22= (b)" : "| 22= (c)");
               doc.text(101, 49, this.eval_auxi.pg023 === "a" ? "| 23= (a)" : this.eval_auxi.pg023 === "b" ? "| 23= (b)" : "| 23= (c)");
               doc.text(114, 49, this.eval_auxi.pg024 === "a" ? "| 24= (a)" : this.eval_auxi.pg024 === "b" ? "| 24= (b)" : "| 24= (c)");
               doc.text(127, 49, this.eval_auxi.pg025 === "a" ? "| 25= (a)" : this.eval_auxi.pg025 === "b" ? "| 25= (b)" : "| 25= (c)");
               doc.text(140, 49, this.eval_auxi.pg026 === "a" ? "| 26= (a)" : this.eval_auxi.pg026 === "b" ? "| 26= (b)" : "| 26= (c)");
               doc.text(153, 49, this.eval_auxi.pg027 === "a" ? "| 27= (a)" : this.eval_auxi.pg027 === "b" ? "| 27= (b)" : "| 27= (c)");
               doc.text(166, 49, this.eval_auxi.pg028 === "a" ? "| 28= (a)" : this.eval_auxi.pg028 === "b" ? "| 28= (b)" : "| 28= (c)");
               doc.text(179, 49, this.eval_auxi.pg029 === "a" ? "| 29= (a)" : this.eval_auxi.pg029 === "b" ? "| 29= (b)" : "| 29= (c)");
               doc.text(192, 49, this.eval_auxi.pg030 === "a" ? "| 30= (a) |" : this.eval_auxi.pg030 === "b" ? "| 30= (b) |" : "| 30= (c) |");
               doc.line(10, 50, 206, 50);
          },

          ejeSinContestar: function ejeSinContestar() {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg002 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg003 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg004 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }
               if (this.ejemplo.pg005 === 0) {
                    this.ejeSinResponder = this.ejeSinResponder + 1;
               }

               return this.ejeSinResponder;
          },
          sinContestar: function sinContestar() {

               this.horafinal();

               this.pregSinContestar = 0;

               if (this.eval_auxi.pg001 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg002 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg003 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg004 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg005 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg006 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg007 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg008 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg009 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg010 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg011 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg012 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg013 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg014 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg015 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg016 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg017 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg018 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg019 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg020 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg021 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg022 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg023 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg024 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg025 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               if (this.eval_auxi.pg026 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg027 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg028 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg029 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }
               if (this.eval_auxi.pg030 === 0) {
                    this.pregSinContestar = this.pregSinContestar + 1;
               }

               return this.pregSinContestar;
          },
          addADayToMyDate: function addADayToMyDate() {
               if (this.eval_fecha) // as myDate can be null
                    // you have to set the this.myDate again, so vue can detect it changed
                    // this is not a caveat of this specific solution, but of any binding of dates
                    this.eval_auxi.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
          },
          dateToYYYYMMDD: function dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof date === 'undefined' ? 'undefined' : _typeof(date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0];
          },
          cargaHora: function cargaHora(lafecha) {

               // Convierte la hora obtenida a hora local (utc)
               // var d = this.eval_fecha;
               var d = lafecha;

               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               var localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion: function cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_auxi = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_ev11; // Crea el nodo para todos los campos.
               this.res_auxi = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_rs11;
               console.log("res ? ", this.res_auxi);

               this.eval_auxi.nombre = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_nusuario; // Nombre del usuario que hará la evaluación
               this.eval_auxi.empresa = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_empresa; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_auxi.depto = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_depto; // Nombre de la empresa a la cual pertenece el usuario
               this.eval_auxi.sexo = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_sexo; // Nombre de la empresa a la cual pertenece el usuario

               this.instrucciones = this.eval_auxi.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de AUXILIAR DE COMPUTO.";

               this.eval_fecha = new Date(); // Fecha del Día
          },
          empezarEvaluacion: function empezarEvaluacion() {

               this.eval_fecha = new Date();
               this.eval_auxi.empezo = this.cargaHora(this.eval_fecha);
               this.inicioeval = true;
          },

          /** .................... VALIDACIONES  .................... */
          limpiarEvaluacion: function limpiarEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0
               };

               this.eval_auxi = {
                    depto: "",
                    empresa: "", nombre: "",
                    fecha: "",
                    empezo: "", termino: "",
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                    pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                    pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0

                    /* Variables para un nuevo caso */
               };__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.eval_auxi = this.eval_auxi;
          },

          /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          /* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion: function agregarEvaluacion() {
               var _this = this;

               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ");
                    return;
               }

               this.finalizoeval = true;
               var lafechafinal = new Date();
               this.eval_auxi.termino = this.cargaHora(lafechafinal);

               this.eval_fecha = new Date();

               var ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               var lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               var lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de AUXILIAR DE COMPUTO para " + this.eval_auxi.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvaluaciones = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.st_dbEvalAuxi;
                    dbEvaluaciones.push({

                         empresa: this.eval_auxi.empresa, nombre: this.eval_auxi.nombre,
                         empezo: this.eval_auxi.empezo, termino: this.eval_auxi.termino,
                         fecha: lingreso, depto: this.eval_auxi.depto, sexo: this.eval_auxi.sexo,
                         pg001: this.eval_auxi.pg001, pg002: this.eval_auxi.pg002, pg003: this.eval_auxi.pg003, pg004: this.eval_auxi.pg004, pg005: this.eval_auxi.pg005,
                         pg006: this.eval_auxi.pg006, pg007: this.eval_auxi.pg007, pg008: this.eval_auxi.pg008, pg009: this.eval_auxi.pg009, pg010: this.eval_auxi.pg010,
                         pg011: this.eval_auxi.pg011, pg012: this.eval_auxi.pg012, pg013: this.eval_auxi.pg013, pg014: this.eval_auxi.pg014, pg015: this.eval_auxi.pg015,
                         pg016: this.eval_auxi.pg016, pg017: this.eval_auxi.pg017, pg018: this.eval_auxi.pg018, pg019: this.eval_auxi.pg019, pg020: this.eval_auxi.pg020,
                         pg021: this.eval_auxi.pg021, pg022: this.eval_auxi.pg022, pg023: this.eval_auxi.pg023, pg024: this.eval_auxi.pg024, pg025: this.eval_auxi.pg025,
                         pg026: this.eval_auxi.pg026, pg027: this.eval_auxi.pg027, pg028: this.eval_auxi.pg028, pg029: this.eval_auxi.pg029, pg030: this.eval_auxi.pg030,
                         pg02a: this.eval_auxi.pg02a, pg017a: this.eval_auxi.pg017a, pg018a: this.eval_auxi.pg018a, pg019a: this.eval_auxi.pg019a
                    }).then(function (data) {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         _this.limpiarEvaluacion();

                         var laClave = data.key;
                         _this.grabado = true;
                         _this.inicioeval = false;

                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de AUXILIAR DE COMPUTO guardado con éxito.");
                    });
               } // if (confirma)
          },
          // agregarEncuesta()

          //? =================================================================================
          enfoqueG1: function enfoqueG1(pestana) {
               var _this2 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         //* Vengo de 1, voy a 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt2.focus();
                         });

                         this.activott1 = "!active";
                         this.activott2 = "active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         break;
                    case 3:
                         //* Vengo de 2, voy a 3
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt3.focus();
                         });
                         this.activott2 = "!active";
                         this.activott3 = "active";

                         this.vertt2 = false;
                         this.vertt3 = true;
                         break;
                    case 4:
                         //* Vengo de 3, voy a 4
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt4.focus();
                         });
                         this.activott3 = "!active";
                         this.activott4 = "active";

                         this.vertt3 = false;
                         this.vertt4 = true;
                         break;
                    case 0:
                         //* Vengo de 4, voy a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this2.$refs.testtt1.focus();
                         });
                         this.activott4 = "!active";
                         this.activott1 = "active";

                         this.vertt4 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          },
          nadaG1: function nadaG1(pestana) {
               var _this3 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt1.focus();
                         });

                         this.activott1 = "active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";

                         this.vertt1 = true;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = false;

                         break;
                    case 2:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt2.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "active";
                         this.activott3 = "!active";
                         this.activott4 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = true;
                         this.vertt3 = false;
                         this.vertt4 = false;

                         break;
                    case 3:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt3.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "active";
                         this.activott4 = "!active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = true;
                         this.vertt4 = false;

                         break;
                    case 4:
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this3.$refs.testtt4.focus();
                         });
                         this.activott1 = "!active";
                         this.activott2 = "!active";
                         this.activott3 = "!active";
                         this.activott4 = "active";

                         this.vertt1 = false;
                         this.vertt2 = false;
                         this.vertt3 = false;
                         this.vertt4 = true;

                         break;
                    default:
                    // code block
               } //* switch
          },
          enfoqueRG1: function enfoqueRG1(pestana) {
               var _this4 = this;

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 3:
                         //* Estoy en 4 regreso a 3
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt3.focus();
                         });

                         this.activott4 = "!active";
                         this.activott3 = "active";

                         this.vertt4 = false;
                         this.vertt3 = true;
                         break;
                    case 2:
                         //* Estoy en 3 regreso a 2
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt2.focus();
                         });

                         this.activott3 = "!active";
                         this.activott2 = "active";

                         this.vertt3 = false;
                         this.vertt2 = true;
                         break;
                    case 1:
                         //* Estoy en 2 regreso a 1
                         __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
                              return _this4.$refs.testtt1.focus();
                         });
                         this.activott2 = "!active";
                         this.activott1 = "active";

                         this.vertt2 = false;
                         this.vertt1 = true;
                         break;
                    default:
                    // code block
               } //* switch
          }
     } // methods
     // export

});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pdf__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_materialize_css_dist_css_materialize_min_css__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_materialize_css_dist_css_materialize_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_materialize_css_dist_css_materialize_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store_js__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["a"] = ({
     components: {
          pdf: __WEBPACK_IMPORTED_MODULE_0_vue_pdf__["a" /* default */]
     },
     data: function data() {
          return {

               pdfList: ['https://firebasestorage.googleapis.com/v0/b/topcg-95de7.appspot.com/o/cvs%2Fcv8.pdf?alt=media&token=b071d36d-b1fe-44ed-99f2-0a95a7ede5ed', 'https://firebasestorage.googleapis.com/v0/b/topcg-95de7.appspot.com/o/cvs%2FJCJA-CV%202018.pdf?alt=media&token=33d6b4d1-e050-4f54-83ce-01ea8aba6c1c', 'https://firebasestorage.googleapis.com/v0/b/topcg-95de7.appspot.com/o/cvs%2Ftav_AlfredoPa.pdf?alt=media&token=ed7fdc14-0882-4290-bea2-7d94ea70b1fb', 'https://cdn.mozilla.net/pdfjs/tracemonkey.pdf', 'https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/freeculture.pdf', 'https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/annotation-link-text-popup.pdf', 'https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/calrgb.pdf', 'https://cdn.rawgit.com/sayanee/angularjs-pdf/68066e85/example/pdf/relativity.protected.pdf', 'data:application/pdf;base64,JVBERi0xLjUKJbXtrvsKMyAwIG9iago8PCAvTGVuZ3RoIDQgMCBSCiAgIC9GaWx0ZXIgL0ZsYXRlRGVjb2RlCj4+CnN0cmVhbQp4nE2NuwoCQQxF+/mK+wMbk5lkHl+wIFislmIhPhYEi10Lf9/MVgZCAufmZAkMppJ6+ZLUuFWsM3ZXxvzpFNaMYjEriqpCtbZSBOsDzw0zjqPHZYtTrEmz4eto7/0K54t7GfegOGCBbBdDH3+y2zsMsVERc9SoRkXORqKGJupS6/9OmMIUfgypJL4KZW5kc3RyZWFtCmVuZG9iago0IDAgb2JqCiAgIDEzOAplbmRvYmoKMiAwIG9iago8PAogICAvRXh0R1N0YXRlIDw8CiAgICAgIC9hMCA8PCAvQ0EgMC42MTE5ODcgL2NhIDAuNjExOTg3ID4+CiAgICAgIC9hMSA8PCAvQ0EgMSAvY2EgMSA+PgogICA+Pgo+PgplbmRvYmoKNSAwIG9iago8PCAvVHlwZSAvUGFnZQogICAvUGFyZW50IDEgMCBSCiAgIC9NZWRpYUJveCBbIDAgMCA1OTUuMjc1NTc0IDg0MS44ODk3NzEgXQogICAvQ29udGVudHMgMyAwIFIKICAgL0dyb3VwIDw8CiAgICAgIC9UeXBlIC9Hcm91cAogICAgICAvUyAvVHJhbnNwYXJlbmN5CiAgICAgIC9DUyAvRGV2aWNlUkdCCiAgID4+CiAgIC9SZXNvdXJjZXMgMiAwIFIKPj4KZW5kb2JqCjEgMCBvYmoKPDwgL1R5cGUgL1BhZ2VzCiAgIC9LaWRzIFsgNSAwIFIgXQogICAvQ291bnQgMQo+PgplbmRvYmoKNiAwIG9iago8PCAvQ3JlYXRvciAoY2Fpcm8gMS4xMS4yIChodHRwOi8vY2Fpcm9ncmFwaGljcy5vcmcpKQogICAvUHJvZHVjZXIgKGNhaXJvIDEuMTEuMiAoaHR0cDovL2NhaXJvZ3JhcGhpY3Mub3JnKSkKPj4KZW5kb2JqCjcgMCBvYmoKPDwgL1R5cGUgL0NhdGFsb2cKICAgL1BhZ2VzIDEgMCBSCj4+CmVuZG9iagp4cmVmCjAgOAowMDAwMDAwMDAwIDY1NTM1IGYgCjAwMDAwMDA1ODAgMDAwMDAgbiAKMDAwMDAwMDI1MiAwMDAwMCBuIAowMDAwMDAwMDE1IDAwMDAwIG4gCjAwMDAwMDAyMzAgMDAwMDAgbiAKMDAwMDAwMDM2NiAwMDAwMCBuIAowMDAwMDAwNjQ1IDAwMDAwIG4gCjAwMDAwMDA3NzIgMDAwMDAgbiAKdHJhaWxlcgo8PCAvU2l6ZSA4CiAgIC9Sb290IDcgMCBSCiAgIC9JbmZvIDYgMCBSCj4+CnN0YXJ0eHJlZgo4MjQKJSVFT0YK'],
               show: true,
               src: '',
               loadedRatio: 0,
               page: 1,
               numPages: 0,
               rotate: 0,

               /** Para la busqueda y manejo de foto y cvs */
               /** ./cvdocente.pdf */
               urlfoto: "", urlcv: "",
               currFoto: "", currCV: "./cvdocente.pdf",
               currFotoT: "",

               CVs: [],
               selectedFile: "",
               selectedFoto: "",

               /** Datos del participante */
               nombre: "", direccion: "", movil: "", email: "", sexo: "",
               edad: 0, profesion: "", puesto: "", ecivil: "",

               /** Otros */
               busqueda: "",
               mostrarCargador: false,
               porcentaje: 0,
               exito: false,

               profesiones: ['Ingeniero Civil', 'Ingeniero Electrónico', 'Ingeniero en Informática', 'Licenciado(a) en Administración de Empresas', 'Licenciado(a) en Pedagogía', 'Licenciado en Auditoría', 'Obrero'],
               puestos: ['Gerente General', 'Gerente Financiero', 'Gerente Informática', 'Secretaria', 'Conserje'],
               estadocivil: ['Casado', 'Soltero', 'Viudo', 'Unido']
          };
     },

     /** Para usar pdfvuer descomentarizar esta linea de codigo y el watch */
     mounted: function mounted() {

          var elems = document.querySelectorAll('select');
          var instances = M.FormSelect.init(elems, {});

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = M.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = M.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = M.Tabs.init(elem, {});

          this.bdReadCVs();
     },

     computed: {
          elporcentaje: function elporcentaje() {
               return this.porcentaje;
          },

          /* Filtra las tareas cuando la búsqueda es por descripción o responsable */
          filtrarCVs: function filtrarCVs() {
               var _this = this;

               // console.log("[ filtrarCVs ]");
               // console.log(this.CVs)
               return this.CVs.filter(function (cv, index) {

                    /* Preserva el índice las tareas recién instanciadas ya que cuando se realiza una búsqueda y se quiere 
                       eliminar una tarea, el índice cambia y borra otra tarea. [ Ver función eliminar() ] en tareas.vue.   && (usuario.activo===this.activos)   */
                    // tarea.codigo = index;
                    if (cv.nombre.toUpperCase().includes(_this.busqueda.toUpperCase())) {
                         return cv;
                    }
               });
          } // filtarTareas()    (usuario.administrador===this.administradores)
     },
     methods: {
          limpiar: function limpiar() {
               this.exito = false;
               this.agrabar = false;

               this.nombre = "";this.direccion = "";this.movil = "";
               this.email = "";this.sexo = "";
               this.edad = 0, this.profesion = "", this.puesto = "", this.ecivil = "", this.selectedFile = "";this.selectedFoto = "";
               this.urlfoto = "", this.urlcv = "";
          },

          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
          verjspdf: function verjspdf() {
               /** */
               var nArchivo = "demo";

               var doc = new jsPDF();

               doc.setFontSize(40);
               doc.text("Octonyan loves jsPDF", 35, 25);

               // Set the document to automatically print via JS
               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');

               // doc.output('dataurlnewwindow');               
          },

          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
          password: function password(updatePassword, reason) {

               updatePassword(prompt('password is "test"'));
          },
          error: function error(err) {

               console.log(err);
          },
          verPDF: function verPDF(seleccionado, vieneurl) {

               // console.log("pdfdocument ", this.src);
               vieneurl = vieneurl.trim();
               this.currCV = vieneurl;
               this.pdfdata = vieneurl;
               this.src = vieneurl;
               console.log("$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#");
               console.log("[verPDF], url ? ", vieneurl);
               console.log("[verPDF], currCV ? ", this.src);

               // this.getPdf();
          },
          verFoto: function verFoto(imagen, url) {

               url = url.trim();
               console.log("URL ? ", url);
               var currFoto = '<img src="' + url + '">';
               this.currFotoT = url;
               this.currFoto = currFoto;
          },

          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
          deleteCV: function deleteCV(elNombre, laLlave) {

               var self = this;

               var confirma = confirm("Seguro de eliminar el CV ? " + elNombre + "(" + laLlave + ")");
               if (confirma === true) {

                    /* Borra del nodo /usuarios al usuario deseado */
                    self.borrarCV(laLlave); // También se borra el usuario del nodo /usuarios
               } // if(confirma)
          },
          // deleteUser()
          borrarCV: function borrarCV(laLlave) {

               var lanuevaRuta = __WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_rutaCVs + '/' + laLlave;
               var dbelCV = __WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_db.ref(lanuevaRuta);

               var elRegEmpresa = dbelCV.remove();

               this.bdReadCVs();
          },
          // borrarTarea()            

          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
          agregaCV: function agregaCV() {

               var llargoNombre = this.nombre.trim().length;
               var llargocvs = this.selectedFile.name.trim().length;
               var llargofoto = this.selectedFoto.name.trim().length;

               if (llargoNombre === 0 || llargocvs === 0 || llargofoto === 0) {

                    alert("Debe ingresar un nombre de participante, seleccionar un cvs y una foto !");
               } else {

                    var confirma = confirm("Seguro de agregar el participante " + this.nombre + " ?");
                    if (confirma === true) {

                         this.cargarCVyFoto();
                    } // if confirma()
               } // if this.nombre

               this.ver = false;

               this.bdReadCVs();
          },
          grabaParticipante: function grabaParticipante(laurlfoto, laurlcv) {
               var _this2 = this;

               this.ladbCVs = __WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_dbCVs;
               this.ladbCVs.push({

                    nombre: this.nombre, direccion: this.direccion, movil: this.movil,
                    email: this.email, sexo: this.sexo,
                    edad: this.edad, profesion: this.profesion, puesto: this.puesto, ecivil: this.ecivil,
                    cfoto: this.selectedFoto.name, ccv: this.selectedFile.name,
                    urlfoto: laurlfoto, urlcv: laurlcv
               }).then(function () {

                    /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                    _this2.nombre = "";_this2.direccion = "";_this2.movil = "";
                    _this2.email = "";_this2.sexo = "";
                    _this2.edad = 0, _this2.profesion = "", _this2.puesto = "", _this2.ecivil = "", _this2.selectedFile = "";_this2.selectedFoto = "";
                    _this2.urlfoto = "", _this2.urlcv = "";

                    _this2.agrabar = false;_this2.exito = false;
               });
          },


          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
          getCV: function getCV(losCVs) {

               this.CVs = [];
               this.limite = 0;

               /* Tipología = Myers */
               for (var key in losCVs) {
                    this.CVs.push({

                         llave: key, // 1
                         nombre: losCVs[key].nombre, direccion: losCVs[key].direccion,
                         movil: losCVs[key].movil, email: losCVs[key].email,
                         sexo: losCVs[key].sexo,
                         edad: losCVs[key].edad,
                         profesion: losCVs[key].profesion,
                         puesto: losCVs[key].puesto,
                         ecivil: losCVs[key].ecivil,
                         cfoto: losCVs[key].cfoto, ccv: losCVs[key].ccv,
                         urlfoto: losCVs[key].urlfoto, urlcv: losCVs[key].urlcv
                    });
               } // for
          },
          bdReadCVs: function bdReadCVs() {
               var _this3 = this;

               var dummy = __WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_dbCVs.on('value', function (snapshot) {
                    return _this3.getCV(snapshot.val());
               });
          },


          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
          /** Funciones para cargar un archivo a storage */
          onFileSelected: function onFileSelected(event) {
               console.log(event);
               this.selectedFile = event.target.files[0];
               console.log("Archivo seleccionado: ", this.selectedFile.name);
          },
          onFileSelectedF: function onFileSelectedF(event) {
               console.log(event);
               this.selectedFoto = event.target.files[0];
               console.log("Archivo seleccionado: ", this.selectedFoto.name);
          },
          cargarCVyFoto: function cargarCVyFoto() {

               this.subirFoto(__WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_rutaFotosU, this.selectedFoto);

               this.subirCV(__WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_rutaCVs, this.selectedFile);
          },
          subirFoto: function subirFoto(laruta, seleccionado) {

               console.log("la ruta: ", laruta);
               console.log("seleccionado ? ", seleccionado);
               this.mostrarCargador = true;
               this.porcentaje = 0;

               /** Obtiene el archivo seleccionado en "file" y establece en "hijo" la nueva ruta de acceso que incluye 
                *  solo el nombre del archivo seleccionado.  */
               var file = seleccionado;
               var hijo = laruta + seleccionado.name;

               /** Referencia a la carpeta donde estarán los CVs */
               var storageRef = __WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_stg.ref(hijo);

               /** Graba el archivo seleccionado en la carpeta correspondiente en storage */
               var uploadTaskFoto = storageRef.put(file);

               // Listen for state changes, errors, and completion of the upload.
               var self = this;

               uploadTaskFoto.on(__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
               function (snapshot) {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                    self.porcentaje = Math.round(progress);
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                         case __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage.TaskState.PAUSED:
                              // or 'paused'
                              console.log('Upload is paused');
                              break;
                         case __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage.TaskState.RUNNING:
                              // or 'running'
                              console.log('Upload is running');
                              break;
                    } // switch
               }, // function(snapshot)
               function (error) {

                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                         case 'storage/unauthorized':
                              // User doesn't have permission to access the object
                              break;

                         case 'storage/canceled':
                              // User canceled the upload
                              break;

                         case 'storage/unknown':
                              // Unknown error occurred, inspect error.serverResponse
                              break;
                    } // switch
               }, // function(error)
               function () {
                    // Upload completed successfully, now we can get the download URL
                    uploadTaskFoto.snapshot.ref.getDownloadURL().then(function (downloadURL) {

                         __WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_urlfoto = downloadURL;

                         self.mostrarCargador = false;
                         self.exito = true;

                         self.urlfoto = __WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_urlfoto;
                    });
               } // function()
               ); // uploadTaskFoto()
          },
          // subir
          subirCV: function subirCV(laruta, seleccionado) {

               this.mostrarCargador = true;
               this.porcentaje = 0;

               /** Obtiene el archivo seleccionado en "file" y establece en "hijo" la nueva ruta de acceso que incluye 
                *  solo el nombre del archivo seleccionado.  */
               var file = seleccionado;
               var hijo = laruta + seleccionado.name;

               /** Referencia a la carpeta donde estarán los CVs */
               var storageRef = __WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_stg.ref(hijo);

               /** Graba el archivo seleccionado en la carpeta correspondiente en storage */
               var uploadTaskCV = storageRef.put(file);

               // Listen for state changes, errors, and completion of the upload.
               var self = this;

               uploadTaskCV.on(__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
               function (snapshot) {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                    self.porcentaje = Math.round(progress);
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                         case __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage.TaskState.PAUSED:
                              // or 'paused'
                              console.log('Upload is paused');
                              break;
                         case __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage.TaskState.RUNNING:
                              // or 'running'
                              console.log('Upload is running');
                              break;
                    } // switch
               }, // function(snapshot)
               function (error) {
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                         case 'storage/unauthorized':
                              // User doesn't have permission to access the object
                              break;
                         case 'storage/canceled':
                              // User canceled the upload
                              break;
                         case 'storage/unknown':
                              // Unknown error occurred, inspect error.serverResponse
                              break;
                    } // switch
               }, // function(error)
               function () {
                    // Upload completed successfully, now we can get the download URL
                    uploadTaskCV.snapshot.ref.getDownloadURL().then(function (downloadURL) {

                         __WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_urlcv = downloadURL;
                         self.urlcv = __WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* store */].state.st_urlcv;

                         self.mostrarCargador = false;
                         self.exito = true;

                         self.grabarFB(self.urlfoto, self.urlcv);
                    });
               } // function()
               ); // uploadTaskCV()
          },
          // subir
          grabarFB: function grabarFB(uno, dos) {

               this.urlfoto = uno;this.urlcv = dos;
               this.grabaParticipante(this.urlfoto, this.urlcv);
          }
     } // methods
     //

});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentFactory_js__ = __webpack_require__(350);
//




if (Object({"NODE_ENV":"production"}).VUE_ENV !== 'server') {

	var pdfjsWrapper = __webpack_require__(354).default;
	var PDFJS = __webpack_require__(360);

	if (typeof window !== 'undefined' && 'Worker' in window && navigator.appVersion.indexOf('MSIE 10') === -1) {

		var PdfjsWorker = __webpack_require__(374);
		PDFJS.GlobalWorkerOptions.workerPort = new PdfjsWorker();
	}

	var component = Object(__WEBPACK_IMPORTED_MODULE_0__componentFactory_js__["a" /* default */])(pdfjsWrapper(PDFJS));
} else {

	var component = Object(__WEBPACK_IMPORTED_MODULE_0__componentFactory_js__["a" /* default */])({});
}

/* harmony default export */ __webpack_exports__["a"] = (component);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

	// thanks to https://github.com/marcj/css-element-queries
	props: {
		initial: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			size: {
				width: -1,
				height: -1
			}
		};
	},
	methods: {
		reset: function () {

			var expand = this.$el.firstChild;
			var shrink = this.$el.lastChild;
			expand.scrollLeft = 100000;
			expand.scrollTop = 100000;
			shrink.scrollLeft = 100000;
			shrink.scrollTop = 100000;
		},
		update: function () {

			this.size.width = this.$el.offsetWidth;
			this.size.height = this.$el.offsetHeight;
		}
	},
	watch: {
		size: {
			deep: true,
			handler: function (size) {

				this.reset();
				this.$emit('resize', { width: this.size.width, height: this.size.height });
			}
		}
	},
	render: function (create) {

		var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
		var styleChild = 'position: absolute; left: 0; top: 0;';

		return create('div', {
			style: style + 'animation-name: resizeSensorVisibility;',
			on: {
				'~animationstart': this.update
			}
		}, [create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 100000px; height: 100000px;'
		})]), create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 200%; height: 200%;'
		})])]);
	},
	beforeDestroy: function () {

		this.$emit('resize', { width: 0, height: 0 });
		this.$emit('resizeSensorBeforeDestroy');
	},
	mounted: function () {

		if (this.initial === true) this.$nextTick(this.update);

		if (this.$el.offsetParent !== this.$el.parentNode) this.$el.parentNode.style.position = 'relative';

		if ('attachEvent' in this.$el && !('AnimationEvent' in window)) {

			var onresizeHandler = function () {

				this.update();
				removeOnresizeEvent();
			}.bind(this);

			var removeOnresizeEvent = function () {

				this.$el.detachEvent('onresize', onresizeHandler);
				this.$off('resizeSensorBeforeDestroy', removeOnresizeEvent);
			}.bind(this);

			this.$el.attachEvent('onresize', onresizeHandler);
			this.$on('resizeSensorBeforeDestroy', removeOnresizeEvent);
			this.reset();
		}
	}
});

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2018 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moveToEndOfArray = exports.waitOnEventOrTimeout = exports.WaitOnType = exports.animationStarted = exports.normalizeWheelEventDelta = exports.binarySearchFirstItem = exports.watchScroll = exports.scrollIntoView = exports.getOutputScale = exports.approximateFraction = exports.getPageSizeInches = exports.roundToDivide = exports.getVisibleElements = exports.backtrackBeforeAllVisibleElements = exports.parseQueryString = exports.noContextMenuHandler = exports.getPDFFileNameFromURL = exports.ProgressBar = exports.EventBus = exports.NullL10n = exports.TextLayerMode = exports.RendererType = exports.PresentationModeState = exports.isPortraitOrientation = exports.isValidRotation = exports.VERTICAL_PADDING = exports.SCROLLBAR_PADDING = exports.MAX_AUTO_SCALE = exports.UNKNOWN_SCALE = exports.MAX_SCALE = exports.MIN_SCALE = exports.DEFAULT_SCALE = exports.DEFAULT_SCALE_VALUE = exports.CSS_UNITS = undefined;

var _regenerator = __webpack_require__(357);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var CSS_UNITS = 96.0 / 72.0;
var DEFAULT_SCALE_VALUE = 'auto';
var DEFAULT_SCALE = 1.0;
var MIN_SCALE = 0.10;
var MAX_SCALE = 10.0;
var UNKNOWN_SCALE = 0;
var MAX_AUTO_SCALE = 1.25;
var SCROLLBAR_PADDING = 40;
var VERTICAL_PADDING = 5;
var PresentationModeState = {
  UNKNOWN: 0,
  NORMAL: 1,
  CHANGING: 2,
  FULLSCREEN: 3
};
var RendererType = {
  CANVAS: 'canvas',
  SVG: 'svg'
};
var TextLayerMode = {
  DISABLE: 0,
  ENABLE: 1,
  ENABLE_ENHANCE: 2
};
function formatL10nValue(text, args) {
  if (!args) {
    return text;
  }
  return text.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, name) {
    return name in args ? args[name] : '{{' + name + '}}';
  });
}
var NullL10n = {
  getLanguage: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', 'en-us');

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getLanguage() {
      return _ref.apply(this, arguments);
    }

    return getLanguage;
  }(),
  getDirection: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', 'ltr');

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getDirection() {
      return _ref2.apply(this, arguments);
    }

    return getDirection;
  }(),
  get: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee3(property, args, fallback) {
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', formatL10nValue(fallback, args));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function get(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    }

    return get;
  }(),
  translate: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee4(element) {
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function translate(_x4) {
      return _ref4.apply(this, arguments);
    }

    return translate;
  }()
};
function getOutputScale(ctx) {
  var devicePixelRatio = window.devicePixelRatio || 1;
  var backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
  var pixelRatio = devicePixelRatio / backingStoreRatio;
  return {
    sx: pixelRatio,
    sy: pixelRatio,
    scaled: pixelRatio !== 1
  };
}
function scrollIntoView(element, spot) {
  var skipOverflowHiddenElements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var parent = element.offsetParent;
  if (!parent) {
    console.error('offsetParent is not set -- cannot scroll');
    return;
  }
  var offsetY = element.offsetTop + element.clientTop;
  var offsetX = element.offsetLeft + element.clientLeft;
  while (parent.clientHeight === parent.scrollHeight && parent.clientWidth === parent.scrollWidth || skipOverflowHiddenElements && getComputedStyle(parent).overflow === 'hidden') {
    if (parent.dataset._scaleY) {
      offsetY /= parent.dataset._scaleY;
      offsetX /= parent.dataset._scaleX;
    }
    offsetY += parent.offsetTop;
    offsetX += parent.offsetLeft;
    parent = parent.offsetParent;
    if (!parent) {
      return;
    }
  }
  if (spot) {
    if (spot.top !== undefined) {
      offsetY += spot.top;
    }
    if (spot.left !== undefined) {
      offsetX += spot.left;
      parent.scrollLeft = offsetX;
    }
  }
  parent.scrollTop = offsetY;
}
function watchScroll(viewAreaElement, callback) {
  var debounceScroll = function debounceScroll(evt) {
    if (rAF) {
      return;
    }
    rAF = window.requestAnimationFrame(function viewAreaElementScrolled() {
      rAF = null;
      var currentX = viewAreaElement.scrollLeft;
      var lastX = state.lastX;
      if (currentX !== lastX) {
        state.right = currentX > lastX;
      }
      state.lastX = currentX;
      var currentY = viewAreaElement.scrollTop;
      var lastY = state.lastY;
      if (currentY !== lastY) {
        state.down = currentY > lastY;
      }
      state.lastY = currentY;
      callback(state);
    });
  };
  var state = {
    right: true,
    down: true,
    lastX: viewAreaElement.scrollLeft,
    lastY: viewAreaElement.scrollTop,
    _eventHandler: debounceScroll
  };
  var rAF = null;
  viewAreaElement.addEventListener('scroll', debounceScroll, true);
  return state;
}
function parseQueryString(query) {
  var parts = query.split('&');
  var params = Object.create(null);
  for (var i = 0, ii = parts.length; i < ii; ++i) {
    var param = parts[i].split('=');
    var key = param[0].toLowerCase();
    var value = param.length > 1 ? param[1] : null;
    params[decodeURIComponent(key)] = decodeURIComponent(value);
  }
  return params;
}
function binarySearchFirstItem(items, condition) {
  var minIndex = 0;
  var maxIndex = items.length - 1;
  if (items.length === 0 || !condition(items[maxIndex])) {
    return items.length;
  }
  if (condition(items[minIndex])) {
    return minIndex;
  }
  while (minIndex < maxIndex) {
    var currentIndex = minIndex + maxIndex >> 1;
    var currentItem = items[currentIndex];
    if (condition(currentItem)) {
      maxIndex = currentIndex;
    } else {
      minIndex = currentIndex + 1;
    }
  }
  return minIndex;
}
function approximateFraction(x) {
  if (Math.floor(x) === x) {
    return [x, 1];
  }
  var xinv = 1 / x;
  var limit = 8;
  if (xinv > limit) {
    return [1, limit];
  } else if (Math.floor(xinv) === xinv) {
    return [1, xinv];
  }
  var x_ = x > 1 ? xinv : x;
  var a = 0,
      b = 1,
      c = 1,
      d = 1;
  while (true) {
    var p = a + c,
        q = b + d;
    if (q > limit) {
      break;
    }
    if (x_ <= p / q) {
      c = p;
      d = q;
    } else {
      a = p;
      b = q;
    }
  }
  var result = void 0;
  if (x_ - a / b < c / d - x_) {
    result = x_ === x ? [a, b] : [b, a];
  } else {
    result = x_ === x ? [c, d] : [d, c];
  }
  return result;
}
function roundToDivide(x, div) {
  var r = x % div;
  return r === 0 ? x : Math.round(x - r + div);
}
function getPageSizeInches(_ref5) {
  var view = _ref5.view,
      userUnit = _ref5.userUnit,
      rotate = _ref5.rotate;

  var _view = _slicedToArray(view, 4),
      x1 = _view[0],
      y1 = _view[1],
      x2 = _view[2],
      y2 = _view[3];

  var changeOrientation = rotate % 180 !== 0;
  var width = (x2 - x1) / 72 * userUnit;
  var height = (y2 - y1) / 72 * userUnit;
  return {
    width: changeOrientation ? height : width,
    height: changeOrientation ? width : height
  };
}
function backtrackBeforeAllVisibleElements(index, views, top) {
  if (index < 2) {
    return index;
  }
  var elt = views[index].div;
  var pageTop = elt.offsetTop + elt.clientTop;
  if (pageTop >= top) {
    elt = views[index - 1].div;
    pageTop = elt.offsetTop + elt.clientTop;
  }
  for (var i = index - 2; i >= 0; --i) {
    elt = views[i].div;
    if (elt.offsetTop + elt.clientTop + elt.clientHeight <= pageTop) {
      break;
    }
    index = i;
  }
  return index;
}
function getVisibleElements(scrollEl, views) {
  var sortByVisibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var horizontal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var top = scrollEl.scrollTop,
      bottom = top + scrollEl.clientHeight;
  var left = scrollEl.scrollLeft,
      right = left + scrollEl.clientWidth;
  function isElementBottomAfterViewTop(view) {
    var element = view.div;
    var elementBottom = element.offsetTop + element.clientTop + element.clientHeight;
    return elementBottom > top;
  }
  function isElementRightAfterViewLeft(view) {
    var element = view.div;
    var elementRight = element.offsetLeft + element.clientLeft + element.clientWidth;
    return elementRight > left;
  }
  var visible = [],
      view = void 0,
      element = void 0;
  var currentHeight = void 0,
      viewHeight = void 0,
      viewBottom = void 0,
      hiddenHeight = void 0;
  var currentWidth = void 0,
      viewWidth = void 0,
      viewRight = void 0,
      hiddenWidth = void 0;
  var percentVisible = void 0;
  var firstVisibleElementInd = views.length === 0 ? 0 : binarySearchFirstItem(views, horizontal ? isElementRightAfterViewLeft : isElementBottomAfterViewTop);
  if (views.length > 0 && !horizontal) {
    firstVisibleElementInd = backtrackBeforeAllVisibleElements(firstVisibleElementInd, views, top);
  }
  var lastEdge = horizontal ? right : -1;
  for (var i = firstVisibleElementInd, ii = views.length; i < ii; i++) {
    view = views[i];
    element = view.div;
    currentWidth = element.offsetLeft + element.clientLeft;
    currentHeight = element.offsetTop + element.clientTop;
    viewWidth = element.clientWidth;
    viewHeight = element.clientHeight;
    viewRight = currentWidth + viewWidth;
    viewBottom = currentHeight + viewHeight;
    if (lastEdge === -1) {
      if (viewBottom >= bottom) {
        lastEdge = viewBottom;
      }
    } else if ((horizontal ? currentWidth : currentHeight) > lastEdge) {
      break;
    }
    if (viewBottom <= top || currentHeight >= bottom || viewRight <= left || currentWidth >= right) {
      continue;
    }
    hiddenHeight = Math.max(0, top - currentHeight) + Math.max(0, viewBottom - bottom);
    hiddenWidth = Math.max(0, left - currentWidth) + Math.max(0, viewRight - right);
    percentVisible = (viewHeight - hiddenHeight) * (viewWidth - hiddenWidth) * 100 / viewHeight / viewWidth | 0;
    visible.push({
      id: view.id,
      x: currentWidth,
      y: currentHeight,
      view: view,
      percent: percentVisible
    });
  }
  var first = visible[0];
  var last = visible[visible.length - 1];
  if (sortByVisibility) {
    visible.sort(function (a, b) {
      var pc = a.percent - b.percent;
      if (Math.abs(pc) > 0.001) {
        return -pc;
      }
      return a.id - b.id;
    });
  }
  return {
    first: first,
    last: last,
    views: visible
  };
}
function noContextMenuHandler(evt) {
  evt.preventDefault();
}
function isDataSchema(url) {
  var i = 0,
      ii = url.length;
  while (i < ii && url[i].trim() === '') {
    i++;
  }
  return url.substring(i, i + 5).toLowerCase() === 'data:';
}
function getPDFFileNameFromURL(url) {
  var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'document.pdf';

  if (typeof url !== 'string') {
    return defaultFilename;
  }
  if (isDataSchema(url)) {
    console.warn('getPDFFileNameFromURL: ' + 'ignoring "data:" URL for performance reasons.');
    return defaultFilename;
  }
  var reURI = /^(?:(?:[^:]+:)?\/\/[^\/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
  var reFilename = /[^\/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
  var splitURI = reURI.exec(url);
  var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
  if (suggestedFilename) {
    suggestedFilename = suggestedFilename[0];
    if (suggestedFilename.includes('%')) {
      try {
        suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
      } catch (ex) {}
    }
  }
  return suggestedFilename || defaultFilename;
}
function normalizeWheelEventDelta(evt) {
  var delta = Math.sqrt(evt.deltaX * evt.deltaX + evt.deltaY * evt.deltaY);
  var angle = Math.atan2(evt.deltaY, evt.deltaX);
  if (-0.25 * Math.PI < angle && angle < 0.75 * Math.PI) {
    delta = -delta;
  }
  var MOUSE_DOM_DELTA_PIXEL_MODE = 0;
  var MOUSE_DOM_DELTA_LINE_MODE = 1;
  var MOUSE_PIXELS_PER_LINE = 30;
  var MOUSE_LINES_PER_PAGE = 30;
  if (evt.deltaMode === MOUSE_DOM_DELTA_PIXEL_MODE) {
    delta /= MOUSE_PIXELS_PER_LINE * MOUSE_LINES_PER_PAGE;
  } else if (evt.deltaMode === MOUSE_DOM_DELTA_LINE_MODE) {
    delta /= MOUSE_LINES_PER_PAGE;
  }
  return delta;
}
function isValidRotation(angle) {
  return Number.isInteger(angle) && angle % 90 === 0;
}
function isPortraitOrientation(size) {
  return size.width <= size.height;
}
var WaitOnType = {
  EVENT: 'event',
  TIMEOUT: 'timeout'
};
function waitOnEventOrTimeout(_ref6) {
  var target = _ref6.target,
      name = _ref6.name,
      _ref6$delay = _ref6.delay,
      delay = _ref6$delay === undefined ? 0 : _ref6$delay;

  return new Promise(function (resolve, reject) {
    if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || !(name && typeof name === 'string') || !(Number.isInteger(delay) && delay >= 0)) {
      throw new Error('waitOnEventOrTimeout - invalid parameters.');
    }
    function handler(type) {
      if (target instanceof EventBus) {
        target.off(name, eventHandler);
      } else {
        target.removeEventListener(name, eventHandler);
      }
      if (timeout) {
        clearTimeout(timeout);
      }
      resolve(type);
    }
    var eventHandler = handler.bind(null, WaitOnType.EVENT);
    if (target instanceof EventBus) {
      target.on(name, eventHandler);
    } else {
      target.addEventListener(name, eventHandler);
    }
    var timeoutHandler = handler.bind(null, WaitOnType.TIMEOUT);
    var timeout = setTimeout(timeoutHandler, delay);
  });
}
var animationStarted = new Promise(function (resolve) {
  if (typeof window === 'undefined') {
    setTimeout(resolve, 20);
    return;
  }
  window.requestAnimationFrame(resolve);
});

var EventBus = function () {
  function EventBus() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref7$dispatchToDOM = _ref7.dispatchToDOM,
        dispatchToDOM = _ref7$dispatchToDOM === undefined ? false : _ref7$dispatchToDOM;

    _classCallCheck(this, EventBus);

    this._listeners = Object.create(null);
    this._dispatchToDOM = dispatchToDOM === true;
  }

  _createClass(EventBus, [{
    key: 'on',
    value: function on(eventName, listener) {
      var eventListeners = this._listeners[eventName];
      if (!eventListeners) {
        eventListeners = [];
        this._listeners[eventName] = eventListeners;
      }
      eventListeners.push(listener);
    }
  }, {
    key: 'off',
    value: function off(eventName, listener) {
      var eventListeners = this._listeners[eventName];
      var i = void 0;
      if (!eventListeners || (i = eventListeners.indexOf(listener)) < 0) {
        return;
      }
      eventListeners.splice(i, 1);
    }
  }, {
    key: 'dispatch',
    value: function dispatch(eventName) {
      var eventListeners = this._listeners[eventName];
      if (!eventListeners || eventListeners.length === 0) {
        if (this._dispatchToDOM) {
          var _args5 = Array.prototype.slice.call(arguments, 1);
          this._dispatchDOMEvent(eventName, _args5);
        }
        return;
      }
      var args = Array.prototype.slice.call(arguments, 1);
      eventListeners.slice(0).forEach(function (listener) {
        listener.apply(null, args);
      });
      if (this._dispatchToDOM) {
        this._dispatchDOMEvent(eventName, args);
      }
    }
  }, {
    key: '_dispatchDOMEvent',
    value: function _dispatchDOMEvent(eventName) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this._dispatchToDOM) {
        return;
      }
      var details = Object.create(null);
      if (args && args.length > 0) {
        var obj = args[0];
        for (var key in obj) {
          var value = obj[key];
          if (key === 'source') {
            if (value === window || value === document) {
              return;
            }
            continue;
          }
          details[key] = value;
        }
      }
      var event = document.createEvent('CustomEvent');
      event.initCustomEvent(eventName, true, true, details);
      document.dispatchEvent(event);
    }
  }]);

  return EventBus;
}();

function clamp(v, min, max) {
  return Math.min(Math.max(v, min), max);
}

var ProgressBar = function () {
  function ProgressBar(id) {
    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        height = _ref8.height,
        width = _ref8.width,
        units = _ref8.units;

    _classCallCheck(this, ProgressBar);

    this.visible = true;
    this.div = document.querySelector(id + ' .progress');
    this.bar = this.div.parentNode;
    this.height = height || 100;
    this.width = width || 100;
    this.units = units || '%';
    this.div.style.height = this.height + this.units;
    this.percent = 0;
  }

  _createClass(ProgressBar, [{
    key: '_updateBar',
    value: function _updateBar() {
      if (this._indeterminate) {
        this.div.classList.add('indeterminate');
        this.div.style.width = this.width + this.units;
        return;
      }
      this.div.classList.remove('indeterminate');
      var progressSize = this.width * this._percent / 100;
      this.div.style.width = progressSize + this.units;
    }
  }, {
    key: 'setWidth',
    value: function setWidth(viewer) {
      if (!viewer) {
        return;
      }
      var container = viewer.parentNode;
      var scrollbarWidth = container.offsetWidth - viewer.offsetWidth;
      if (scrollbarWidth > 0) {
        this.bar.setAttribute('style', 'width: calc(100% - ' + scrollbarWidth + 'px);');
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (!this.visible) {
        return;
      }
      this.visible = false;
      this.bar.classList.add('hidden');
      document.body.classList.remove('loadingInProgress');
    }
  }, {
    key: 'show',
    value: function show() {
      if (this.visible) {
        return;
      }
      this.visible = true;
      document.body.classList.add('loadingInProgress');
      this.bar.classList.remove('hidden');
    }
  }, {
    key: 'percent',
    get: function get() {
      return this._percent;
    },
    set: function set(val) {
      this._indeterminate = isNaN(val);
      this._percent = clamp(val, 0, 100);
      this._updateBar();
    }
  }]);

  return ProgressBar;
}();

function moveToEndOfArray(arr, condition) {
  var moved = [],
      len = arr.length;
  var write = 0;
  for (var read = 0; read < len; ++read) {
    if (condition(arr[read])) {
      moved.push(arr[read]);
    } else {
      arr[write] = arr[read];
      ++write;
    }
  }
  for (var _read = 0; write < len; ++_read, ++write) {
    arr[write] = moved[_read];
  }
}
exports.CSS_UNITS = CSS_UNITS;
exports.DEFAULT_SCALE_VALUE = DEFAULT_SCALE_VALUE;
exports.DEFAULT_SCALE = DEFAULT_SCALE;
exports.MIN_SCALE = MIN_SCALE;
exports.MAX_SCALE = MAX_SCALE;
exports.UNKNOWN_SCALE = UNKNOWN_SCALE;
exports.MAX_AUTO_SCALE = MAX_AUTO_SCALE;
exports.SCROLLBAR_PADDING = SCROLLBAR_PADDING;
exports.VERTICAL_PADDING = VERTICAL_PADDING;
exports.isValidRotation = isValidRotation;
exports.isPortraitOrientation = isPortraitOrientation;
exports.PresentationModeState = PresentationModeState;
exports.RendererType = RendererType;
exports.TextLayerMode = TextLayerMode;
exports.NullL10n = NullL10n;
exports.EventBus = EventBus;
exports.ProgressBar = ProgressBar;
exports.getPDFFileNameFromURL = getPDFFileNameFromURL;
exports.noContextMenuHandler = noContextMenuHandler;
exports.parseQueryString = parseQueryString;
exports.backtrackBeforeAllVisibleElements = backtrackBeforeAllVisibleElements;
exports.getVisibleElements = getVisibleElements;
exports.roundToDivide = roundToDivide;
exports.getPageSizeInches = getPageSizeInches;
exports.approximateFraction = approximateFraction;
exports.getOutputScale = getOutputScale;
exports.scrollIntoView = scrollIntoView;
exports.watchScroll = watchScroll;
exports.binarySearchFirstItem = binarySearchFirstItem;
exports.normalizeWheelEventDelta = normalizeWheelEventDelta;
exports.animationStarted = animationStarted;
exports.WaitOnType = WaitOnType;
exports.waitOnEventOrTimeout = waitOnEventOrTimeout;
exports.moveToEndOfArray = moveToEndOfArray;

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_json_excel__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ingreso_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_store__ = __webpack_require__(2);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 *      culguraGlistado.js
 *          Script de culturaGlistado.vue
 *          Obtiene los evaluacionesT de evaluación ya registrados permitiendo editarlos y eliminarlos
 *//* ======================================================================================================== */__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component('downloadExcel',__WEBPACK_IMPORTED_MODULE_0_vue_json_excel__["a" /* default */]);__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_jspdf___default.a);// import 'materialize-css/dist/css/materialize.min.css'
/* harmony default export */ __webpack_exports__["a"] = ({name:'evconsultas',components:{'moment':__WEBPACK_IMPORTED_MODULE_2_moment___default.a,'input-date':__WEBPACK_IMPORTED_MODULE_3__ingreso_vue__["a" /* default */]},template:'#evconsultas',data:function data(){return{limite:0,eval_tipolo:{},res:{},eval_16pf:{},res_16pf:{},eval_npf:{},eval_cpf:{},eval_fig:{},evaluacionesT:[],eval_copia:null,//* Necesario  una copia para borrar una encuesta después buscar por Descripción o Responsable.
busqueda:"",busquedaR:"",//* Variables para la búsqueda}
busquedaI:"",lfuente:"C",lc_ini:0,eval_aedp:{},res_aedp:{},//? Para la exportación para la gráfica
aedp_grafica:[{columna1:"Variables Evaluadas",columna2:"Cautela",columna3:"Vulnerable",columna4:"Diestro",columna5:"Óptimo"},{columna1:"Sucesos de la vida",columna2:29,columna3:"",columna4:"",columna5:""},{columna1:"Presiones laborales",columna2:"",columna3:15,columna4:"",columna5:""},{columna1:"Presiones personales",columna2:"",columna3:17,columna4:"",columna5:""},{columna1:"Expresión Emocional",columna2:"",columna3:13,columna4:"",columna5:""}],json_fields:{"Variables evaluadas":"variable","Cautela":"cautela","Vulnerable":"vulnerable","Diestro":"diestro","Optimo":"optimo"},// json_data: [
//      {
//           variable: "Sucesos de la vida",
//           cautela: "29",
//           vulnerable: "",
//           diestro: "",
//           optimo: "",
//      },
//      {
//           variable: "Presiones laborales",
//           cautela: "",
//           vulnerable: "15",
//           diestro: "",
//           optimo: "",
//      },
//      {
//           variable: "Presiones personales",
//           cautela: "",
//           vulnerable: "17",
//           diestro: "",
//           optimo: "",
//      },
//      {
//           variable: "Expresión Emocional",
//           cautela: "",
//           vulnerable: "13",
//           diestro: "",
//           optimo: "",
//      },
//      {
//           variable: "Conciencia Emocional de otros",
//           cautela: "",
//           vulnerable: "",
//           diestro: "25",
//           optimo: "",
//      },
//      {
//           variable: "Intención",
//           cautela: "",
//           vulnerable: "25",
//           diestro: "",
//           optimo: "",
//      },
//      {
//           variable: "Creatividad",
//           cautela: "",
//           vulnerable: "",
//           diestro: "19",
//           optimo: "",
//      },
//      {
//           variable: "Flexibilidad",
//           cautela: "",
//           vulnerable: "",
//           diestro: "31",
//           optimo: "",
//      },
// ],
json_data:[],json_meta:[[{key:"charset",value:"utf-8"}]]// return
};},// data()
mounted:function mounted(){//* Definiciones para el uso de las secciones tipo slide y tooltips 
var elems=document.querySelectorAll('.collapsible');var instances=__WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.Collapsible.init(elems,{});var elems=document.querySelectorAll('.tooltipped');var instances=__WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.Tooltip.init(elems,{});this.bdRead();// CAMBIO 2: Leyendo la info de FireBase.
},computed:{filtrarEvaluaciones:function filtrarEvaluaciones(){var _this=this;return this.evaluacionesT.filter(function(evaluacion){//* steval
/* Preserva el índice las tareas recién instanciadas ya que cuando se realiza una búsqueda y se quiere 
                       eliminar una tarea, el índice cambia y borra otra tarea. [ Ver función eliminar() ] en tareas.vue.  */if(evaluacion.empresa.toUpperCase().includes(_this.busqueda.toUpperCase())&&evaluacion.nombre.toUpperCase().includes(_this.busquedaR.toUpperCase())&&evaluacion.steval.toUpperCase().includes(_this.busquedaI.toUpperCase())){return evaluacion;}});}// filtarTareas()
},methods:{dateToYYYYMMDD:function dateToYYYYMMDD(date){date=new Date(date);// convierte a tipo Date la fecha de fcapturadatos y Vencimiento (.split(' ')[0])
return date&&date.toString();},// datetoYYYMMDD()                     
getRuta:function getRuta(elTipoEval){console.log("Tipo de Evaluación ? ",elTipoEval);var laRuta="";switch(elTipoEval){case"TIPOLOGIA":laRuta=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rutaEvalTipolo;break;case"FACTORES":laRuta=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rutaEvalFactor;break;case"ESTABILIDAD":laRuta=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rutaEvalEstabi;break;case"SOCIABILIDAD":laRuta=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rutaEvalSociab;break;case"PEFIL":laRuta=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rutaEvalPerfil;break;case"MOSS":laRuta=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rutaEvalSuperv;break;case"TAV":laRuta=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rutaEvalApvtas;break;case"SOLEMP":laRuta=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rutaEvalSolemp;break;case"EMOCIONES":laRuta=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rutaEvalEmoc;break;case"ORIENTACION":laRuta=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rutaEvalApVtas2;break;case"AEDP":laRuta=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rutaEvalAEDP;break;default:// code block
}return laRuta;},eliminarEvaluacion:function eliminarEvaluacion(laEvaluacion,index){console.log("Tipo de Evaluación ? ",laEvaluacion.steval);var lnuevaRuta=this.getRuta(laEvaluacion.steval);var confirma=confirm("Seguro de eliminar la evaluación de ( "+laEvaluacion.nombre.trim()+" ? "+index+" )");if(confirma===true){lnuevaRuta=lnuevaRuta+"/"+index;console.log("la nueva Ruta ? ",lnuevaRuta);var dbEvaluaciones=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_db.ref(lnuevaRuta);var elRegTarea=dbEvaluaciones.remove();};this.bdRead();},mostrarEvaluacion:function mostrarEvaluacion(laEvaluacion){console.log("La evaluación es ");console.log(laEvaluacion);var elTipoEval=laEvaluacion.steval;console.log("el tipo es ? ",elTipoEval);switch(elTipoEval){case"TIPOLOGIA":this.eval_tipolo=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_ev01;// Crea el nodo para todos los campos.
this.res=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs01;console.log("1. eval_tipolo ? ",this.eval_tipolo);this.eval_tipolo=laEvaluacion;console.log("2. eval_tipolo ? ",this.eval_tipolo);this.crearPDF_Tipolo();break;case"FACTORES":this.eval_16pf=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_ev02;// Crea el nodo para todos los campos.
this.res_16pf=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs02;console.log("1. eval_16pf ? ",this.eval_16pf);this.eval_16pf=laEvaluacion;console.log("2. eval_16pf ? ",this.eval_16pf);this.crearPDF_16pf();break;case"ESTABILIDAD":this.eval_npf=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_ev03;// Crea el nodo para todos los campos.
this.res_npf=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs03;console.log("===============================================");console.log("1. eval_npf ? ",this.eval_npf);this.eval_npf=laEvaluacion;console.log("2. eval_npf ? ",this.eval_npf);console.log("===============================================");console.log("3. res_npf ? ",this.res_npf);this.crearPDF_npf();break;case"SOCIABILIDAD":this.eval_cpf=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_ev04;// Crea el nodo para todos los campos.
this.res_cpf=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs04;console.log("===============================================");console.log("1.- eval_cpf ? ",this.eval_cpf);this.eval_cpf=laEvaluacion;console.log("2.- eval_cpf ? ",this.eval_cpf);console.log("===============================================");console.log("3.- res_cpf ? ",this.res_cpf);this.crearPDF_cpf();__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs04={Uno:0,Dos:0,Cero:0,Uno2:0,Dos2:0,Cero2:0,cpreviaIzq:0,cpreviaDer:0,rangos:0};break;case"PERFIL":this.eval_fig=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_ev05;// Crea el nodo para todos los campos.
this.res_fig=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs05;console.log("===============================================");console.log("1. eval_fig ? ",this.eval_fig);this.eval_fig=laEvaluacion;console.log("2. eval_fig ? ",this.eval_fig);console.log("===============================================");console.log("3. res_fig ? ",this.res_fig);this.crearPDF_fig();break;case"MOSS":this.eval_moss=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_ev06;// Crea el nodo para todos los campos.
this.res_moss=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs06;console.log("===============================================");console.log("1. eval_moss ? ",this.eval_moss);this.eval_moss=laEvaluacion;console.log("2. eval_mos ? ",this.eval_moss);console.log("===============================================");console.log("3. res_moss ? ",this.res_moss);this.crearPDF_moss();break;case"TAV":this.eval_tav=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_ev07;// Crea el nodo para todos los campos.
this.res_tav=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs07;console.log("===============================================");console.log("1. eval_tav ? ",this.eval_tav);this.eval_tav=laEvaluacion;console.log("2. eval_tav ? ",this.eval_tav);console.log("===============================================");console.log("3. res_tav ? ",this.res_tav);this.crearPDF_tav();break;case"SOLEMP":this.eval_solemp=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_ev08;// Crea el nodo para todos los campos.
this.res_solemp=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs08;console.log("===============================================");console.log("1. eval_solemp ? ",this.eval_solemp);this.eval_solemp=laEvaluacion;console.log("2. eval_solemp ? ",this.eval_solemp);console.log("===============================================");console.log("3. res_solemp ? ",this.res_solemp);this.crearPDF_solemp();break;case"EMOCIONES":this.eval_emoc=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_ev09;// Crea el nodo para todos los campos.
this.res_emoc=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs09;console.log("===============================================");console.log("1. eval_emoc ? ",this.eval_emoc);this.eval_emoc=laEvaluacion;console.log("2. eval_emoc ? ",this.eval_emoc);console.log("===============================================");console.log("3. res_emoc ? ",this.res_emoc);this.crearPDF_emoc();break;case"ORIENTACION":this.eval_vtas=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_ev10;// Crea el nodo para todos los campos.
this.res_vtas=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs10;console.log("===============================================");console.log("1. eval_vtas ? ",this.eval_vtas);this.eval_vtas=laEvaluacion;console.log("2. eval_vtas ? ",this.eval_vtas);console.log("===============================================");console.log("3. res_vtas ? ",this.res_vtas);this.crearPDF_vtas2();break;case"AEDP":this.eval_aedp=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_ev12;// Crea el nodo para todos los campos.
this.res_aedp=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_rs12;console.log("1. eval_aedp ? ",this.eval_aedp);this.eval_aedp=laEvaluacion;console.log("2. eval_aedp ? ",this.eval_aedp);this.crearPDF_AEDP();break;default:// code block
}},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
crearPDF_AEDP:function crearPDF_AEDP(){/** CREACION DEL ARCHIVO PDF */var cadena=this.eval_aedp.nombre,patron=/ /g,nuevoValor="",nusuario=cadena.replace(patron,nuevoValor);var nArchivo="AEDP_"+nusuario;console.log("archivo a crear ? ",nArchivo);var imagen="data:image/jpeg;base64,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";var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a('portrait');var linea=5;/** Muestra el logo.        (izq, top, ancho, alto) */doc.addImage(imagen,'JPEG',155,linea,50,20);/** fila, columna *//** CIRCULOS  */doc.setLineWidth(1);// Grosor de la línea del borde
doc.setDrawColor(0);var meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var lhoy=new Date();//lhoy=   lhoy.toString();
var ldia=lhoy.getDate();var lmes=meses[lhoy.getMonth()];var lanio=lhoy.getFullYear();// console.log("lhoy ? ",lhoy);
// console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
doc.setFontSize(9);doc.text(5,20,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);doc.text(5,30,"Evaluación AUTOEXPLORACIÓN EMOCIONAL PARA EL DESARROLLO PERSONAL de "+this.eval_aedp.nombre+" de "+this.eval_aedp.empresa);this.respuestas_aedp(doc);this.resultados_aedp(doc);doc.save(nArchivo);doc.autoPrint();window.open(doc.output('bloburl'),'_blank');},respuestas_aedp:function respuestas_aedp(doc){doc.setLineWidth(0.25);doc.text(5,40,"SECCION DE RESPUESTAS ");doc.line(5,42,209,42);doc.text(5,45,'| Escala |');var colum=16;for(var i=1;i<=32;i++){colum=colum+2;doc.text(colum,45,i.toString());colum=colum+4;doc.text(colum,45,'|');}var espacio='';//? ESCALA 1
doc.line(5,48,209,48);doc.text(5,51,'|');doc.text(8,51,'01');doc.text(17,51,'|');doc.text(19,51,this.eval_aedp.pg001);doc.text(23,51,'|');doc.text(25,51,this.eval_aedp.pg002);doc.text(29,51,'|');doc.text(31,51,this.eval_aedp.pg003);doc.text(34,51,'|');doc.text(36,51,this.eval_aedp.pg004);doc.text(40,51,'|');doc.text(42,51,this.eval_aedp.pg005);doc.text(46,51,'|');doc.text(48,51,this.eval_aedp.pg006);doc.text(52,51,'|');doc.text(54,51,this.eval_aedp.pg007);doc.text(58,51,'|');doc.text(60,51,this.eval_aedp.pg008);doc.text(64,51,'|');doc.text(66,51,this.eval_aedp.pg009);doc.text(70,51,'|');doc.text(72,51,this.eval_aedp.pg010);doc.text(76,51,'|');doc.text(78,51,this.eval_aedp.pg011);doc.text(82,51,'|');doc.text(84,51,this.eval_aedp.pg012);doc.text(88,51,'|');doc.text(90,51,this.eval_aedp.pg013);doc.text(94,51,'|');doc.text(96,51,this.eval_aedp.pg014);doc.text(100,51,'|');doc.text(102,51,this.eval_aedp.pg015);doc.text(106,51,'|');doc.text(108,51,this.eval_aedp.pg016);doc.text(112,51,'|');doc.text(114,51,this.eval_aedp.pg017);doc.text(118,51,'|');doc.text(120,51,this.eval_aedp.pg018);doc.text(124,51,'|');doc.line(5,53,209,53);//? ESCALA 2
doc.text(5,56,'|');doc.text(8,56,'02');doc.text(17,56,'|');doc.text(19,56,this.eval_aedp.pg019);doc.text(23,56,'|');doc.text(25,56,this.eval_aedp.pg020);doc.text(29,56,'|');doc.text(31,56,this.eval_aedp.pg021);doc.text(34,56,'|');doc.text(36,56,this.eval_aedp.pg022);doc.text(40,56,'|');doc.text(42,56,this.eval_aedp.pg023);doc.text(46,56,'|');doc.text(48,56,this.eval_aedp.pg024);doc.text(52,56,'|');doc.text(54,56,this.eval_aedp.pg025);doc.text(58,56,'|');doc.text(60,56,this.eval_aedp.pg026);doc.text(64,56,'|');doc.text(66,56,this.eval_aedp.pg027);doc.text(70,56,'|');doc.text(72,56,this.eval_aedp.pg028);doc.text(76,56,'|');doc.text(78,56,this.eval_aedp.pg029);doc.text(82,56,'|');doc.text(84,56,this.eval_aedp.pg030);doc.text(88,56,'|');doc.text(90,56,this.eval_aedp.pg031);doc.text(94,56,'|');doc.text(96,56,this.eval_aedp.pg032);doc.text(100,56,'|');doc.text(102,56,this.eval_aedp.pg033);doc.text(106,56,'|');doc.text(108,56,this.eval_aedp.pg034);doc.text(112,56,'|');doc.text(114,56,this.eval_aedp.pg035);doc.text(118,56,'|');doc.line(5,58,209,58);//? ESCALA 3
doc.text(5,61,'|');doc.text(8,61,'03');doc.text(17,61,'|');doc.text(19,61,this.eval_aedp.pg036);doc.text(23,61,'|');doc.text(25,61,this.eval_aedp.pg037);doc.text(29,61,'|');doc.text(31,61,this.eval_aedp.pg038);doc.text(34,61,'|');doc.text(36,61,this.eval_aedp.pg039);doc.text(40,61,'|');doc.text(42,61,this.eval_aedp.pg040);doc.text(46,61,'|');doc.text(48,61,this.eval_aedp.pg041);doc.text(52,61,'|');doc.text(54,61,this.eval_aedp.pg042);doc.text(58,61,'|');doc.text(60,61,this.eval_aedp.pg043);doc.text(64,61,'|');doc.text(66,61,this.eval_aedp.pg044);doc.text(70,61,'|');doc.text(72,61,this.eval_aedp.pg045);doc.text(76,61,'|');doc.text(78,61,this.eval_aedp.pg046);doc.text(82,61,'|');doc.text(84,61,this.eval_aedp.pg047);doc.text(88,61,'|');doc.text(90,61,this.eval_aedp.pg048);doc.text(94,61,'|');doc.text(96,61,this.eval_aedp.pg049);doc.text(100,61,'|');doc.line(5,63,209,63);//? ESCALA 4
doc.text(5,66,'|');doc.text(8,66,'04');doc.text(17,66,'|');doc.text(19,66,this.eval_aedp.pg050);doc.text(23,66,'|');doc.text(25,66,this.eval_aedp.pg051);doc.text(29,66,'|');doc.text(31,66,this.eval_aedp.pg052);doc.text(34,66,'|');doc.text(36,66,this.eval_aedp.pg053);doc.text(40,66,'|');doc.text(42,66,this.eval_aedp.pg054);doc.text(46,66,'|');doc.text(48,66,this.eval_aedp.pg055);doc.text(52,66,'|');doc.text(54,66,this.eval_aedp.pg056);doc.text(58,66,'|');doc.text(60,66,this.eval_aedp.pg057);doc.text(64,66,'|');doc.text(66,66,this.eval_aedp.pg058);doc.text(70,66,'|');doc.text(72,66,this.eval_aedp.pg059);doc.text(76,66,'|');doc.text(78,66,this.eval_aedp.pg060);doc.text(82,66,'|');doc.line(5,68,209,68);//? ESCALA 5
doc.text(5,71,'|');doc.text(8,71,'05');doc.text(17,71,'|');doc.text(19,71,this.eval_aedp.pg061);doc.text(23,71,'|');doc.text(25,71,this.eval_aedp.pg062);doc.text(29,71,'|');doc.text(31,71,this.eval_aedp.pg063);doc.text(34,71,'|');doc.text(36,71,this.eval_aedp.pg064);doc.text(40,71,'|');doc.text(42,71,this.eval_aedp.pg065);doc.text(46,71,'|');doc.text(48,71,this.eval_aedp.pg071);doc.text(52,71,'|');doc.text(54,71,this.eval_aedp.pg067);doc.text(58,71,'|');doc.text(60,71,this.eval_aedp.pg068);doc.text(64,71,'|');doc.text(66,71,this.eval_aedp.pg069);doc.text(70,71,'|');doc.line(5,73,209,73);//? ESCALA 6
doc.text(5,76,'|');doc.text(8,76,'06');doc.text(17,76,'|');doc.text(19,76,this.eval_aedp.pg070);doc.text(23,76,'|');doc.text(25,76,this.eval_aedp.pg071);doc.text(29,76,'|');doc.text(31,76,this.eval_aedp.pg072);doc.text(34,76,'|');doc.text(36,76,this.eval_aedp.pg073);doc.text(40,76,'|');doc.text(42,76,this.eval_aedp.pg074);doc.text(46,76,'|');doc.text(48,76,this.eval_aedp.pg074b);doc.text(52,76,'|');doc.text(54,76,this.eval_aedp.pg074c);doc.text(58,76,'|');doc.text(60,76,this.eval_aedp.pg074d);doc.text(64,76,'|');doc.text(66,76,this.eval_aedp.pg074e);doc.text(70,76,'|');doc.text(72,76,this.eval_aedp.pg074f);doc.text(76,76,'|');doc.text(78,76,this.eval_aedp.pg074g);doc.text(82,76,'|');doc.text(84,76,this.eval_aedp.pg074h);doc.text(88,76,'|');doc.text(90,76,this.eval_aedp.pg074i);doc.text(94,76,'|');doc.line(5,78,209,78);//? ESCALA 7
doc.text(5,81,'|');doc.text(8,81,'07');doc.text(17,81,'|');doc.text(19,81,this.eval_aedp.pg075);doc.text(23,81,'|');doc.text(25,81,this.eval_aedp.pg081);doc.text(29,81,'|');doc.text(31,81,this.eval_aedp.pg077);doc.text(34,81,'|');doc.text(36,81,this.eval_aedp.pg078);doc.text(40,81,'|');doc.text(42,81,this.eval_aedp.pg079);doc.text(46,81,'|');doc.text(48,81,this.eval_aedp.pg080);doc.text(52,81,'|');doc.text(54,81,this.eval_aedp.pg081);doc.text(58,81,'|');doc.text(60,81,this.eval_aedp.pg082);doc.text(64,81,'|');doc.text(66,81,this.eval_aedp.pg083);doc.text(70,81,'|');doc.text(72,81,this.eval_aedp.pg084);doc.text(76,81,'|');doc.text(78,81,this.eval_aedp.pg085);doc.text(82,81,'|');doc.text(84,81,this.eval_aedp.pg086);doc.text(88,81,'|');doc.text(90,81,this.eval_aedp.pg087);doc.text(94,81,'|');doc.text(96,81,this.eval_aedp.pg088);doc.text(100,81,'|');doc.line(5,83,209,83);//? ESCALA 8
doc.text(5,86,'|');doc.text(8,86,'08');doc.text(17,86,'|');doc.text(19,86,this.eval_aedp.pg089);doc.text(23,86,'|');doc.text(25,86,this.eval_aedp.pg090);doc.text(29,86,'|');doc.text(31,86,this.eval_aedp.pg091);doc.text(34,86,'|');doc.text(36,86,this.eval_aedp.pg092);doc.text(40,86,'|');doc.text(42,86,this.eval_aedp.pg093);doc.text(46,86,'|');doc.text(48,86,this.eval_aedp.pg094);doc.text(52,86,'|');doc.text(54,86,this.eval_aedp.pg095);doc.text(58,86,'|');doc.text(60,86,this.eval_aedp.pg096);doc.text(64,86,'|');doc.text(66,86,this.eval_aedp.pg097);doc.text(70,86,'|');doc.text(72,86,this.eval_aedp.pg098);doc.text(76,86,'|');doc.line(5,88,209,88);//? ESCALA 9
doc.text(5,91,'|');doc.text(8,91,'09');doc.text(17,91,'|');doc.text(19,91,this.eval_aedp.pg099);doc.text(23,91,'|');doc.text(25,91,this.eval_aedp.pg100);doc.text(29,91,'|');doc.text(31,91,this.eval_aedp.pg101);doc.text(34,91,'|');doc.text(36,91,this.eval_aedp.pg102);doc.text(40,91,'|');doc.text(42,91,this.eval_aedp.pg103);doc.text(46,91,'|');doc.text(48,91,this.eval_aedp.pg104);doc.text(52,91,'|');doc.text(54,91,this.eval_aedp.pg105);doc.text(58,91,'|');doc.text(60,91,this.eval_aedp.pg106);doc.text(64,91,'|');doc.text(66,91,this.eval_aedp.pg107);doc.text(70,91,'|');doc.text(72,91,this.eval_aedp.pg108);doc.text(76,91,'|');doc.text(78,91,this.eval_aedp.pg109);doc.text(82,91,'|');doc.text(84,91,this.eval_aedp.pg110);doc.text(88,91,'|');doc.text(90,91,this.eval_aedp.pg111);doc.text(94,91,'|');doc.line(5,93,209,93);//? ESCALA 10
doc.text(5,96,'|');doc.text(8,96,'10');doc.text(17,96,'|');doc.text(19,96,this.eval_aedp.pg112);doc.text(23,96,'|');doc.text(25,96,this.eval_aedp.pg113);doc.text(29,96,'|');doc.text(31,96,this.eval_aedp.pg114);doc.text(34,96,'|');doc.text(36,96,this.eval_aedp.pg115);doc.text(40,96,'|');doc.text(42,96,this.eval_aedp.pg116);doc.text(46,96,'|');doc.text(48,96,this.eval_aedp.pg117);doc.text(52,96,'|');doc.text(54,96,this.eval_aedp.pg118);doc.text(58,96,'|');doc.text(60,96,this.eval_aedp.pg119);doc.text(64,96,'|');doc.text(66,96,this.eval_aedp.pg120);doc.text(70,96,'|');doc.text(72,96,this.eval_aedp.pg121);doc.text(76,96,'|');doc.line(5,98,209,98);//? ESCALA 11
doc.text(5,101,'|');doc.text(8,101,'11');doc.text(17,101,'|');doc.text(19,101,this.eval_aedp.pg122);doc.text(23,101,'|');doc.text(25,101,this.eval_aedp.pg123);doc.text(29,101,'|');doc.text(31,101,this.eval_aedp.pg124);doc.text(34,101,'|');doc.text(36,101,this.eval_aedp.pg125);doc.text(40,101,'|');doc.text(42,101,this.eval_aedp.pg126);doc.text(46,101,'|');doc.text(48,101,this.eval_aedp.pg127);doc.text(52,101,'|');doc.text(54,101,this.eval_aedp.pg128);doc.text(58,101,'|');doc.text(60,101,this.eval_aedp.pg129);doc.text(64,101,'|');doc.text(66,101,this.eval_aedp.pg130);doc.text(70,101,'|');doc.text(72,101,this.eval_aedp.pg131);doc.text(76,101,'|');doc.text(78,101,this.eval_aedp.pg132);doc.text(82,101,'|');doc.text(84,101,this.eval_aedp.pg133);doc.text(88,101,'|');doc.text(90,101,this.eval_aedp.pg134);doc.text(94,101,'|');doc.line(5,103,209,103);//? ESCALA 12
doc.text(5,106,'|');doc.text(8,106,'12');doc.text(17,106,'|');doc.text(19,106,this.eval_aedp.pg135);doc.text(23,106,'|');doc.text(25,106,this.eval_aedp.pg136);doc.text(29,106,'|');doc.text(31,106,this.eval_aedp.pg137);doc.text(34,106,'|');doc.text(36,106,this.eval_aedp.pg138);doc.text(40,106,'|');doc.text(42,106,this.eval_aedp.pg139);doc.text(46,106,'|');doc.text(48,106,this.eval_aedp.pg140);doc.text(52,106,'|');doc.text(54,106,this.eval_aedp.pg141);doc.text(58,106,'|');doc.text(60,106,this.eval_aedp.pg142);doc.text(64,106,'|');doc.text(66,106,this.eval_aedp.pg143);doc.text(70,106,'|');doc.text(72,106,this.eval_aedp.pg144);doc.text(76,106,'|');doc.text(78,106,this.eval_aedp.pg145);doc.text(82,106,'|');doc.text(84,106,this.eval_aedp.pg146);doc.text(88,106,'|');doc.line(5,108,209,108);//? ESCALA 13
doc.text(5,111,'|');doc.text(8,111,'13');doc.text(17,111,'|');doc.text(19,111,this.eval_aedp.pg147);doc.text(23,111,'|');doc.text(25,111,this.eval_aedp.pg148);doc.text(29,111,'|');doc.text(31,111,this.eval_aedp.pg149);doc.text(34,111,'|');doc.text(36,111,this.eval_aedp.pg150);doc.text(40,111,'|');doc.text(42,111,this.eval_aedp.pg151);doc.text(46,111,'|');doc.text(48,111,this.eval_aedp.pg152);doc.text(52,111,'|');doc.text(54,111,this.eval_aedp.pg153);doc.text(58,111,'|');doc.text(60,111,this.eval_aedp.pg154);doc.text(64,111,'|');doc.line(5,113,209,113);//? ESCALA 14
doc.text(5,116,'|');doc.text(8,116,'14');doc.text(17,116,'|');doc.text(19,116,this.eval_aedp.pg155);doc.text(23,116,'|');doc.text(25,116,this.eval_aedp.pg156);doc.text(29,116,'|');doc.text(31,116,this.eval_aedp.pg157);doc.text(34,116,'|');doc.text(36,116,this.eval_aedp.pg158);doc.text(40,116,'|');doc.text(42,116,this.eval_aedp.pg159);doc.text(46,116,'|');doc.text(48,116,this.eval_aedp.pg160);doc.text(52,116,'|');doc.text(54,116,this.eval_aedp.pg161);doc.text(58,116,'|');doc.text(60,116,this.eval_aedp.pg162);doc.text(64,116,'|');doc.text(66,116,this.eval_aedp.pg163);doc.text(70,116,'|');doc.text(72,116,this.eval_aedp.pg164);doc.text(76,116,'|');doc.text(78,116,this.eval_aedp.pg165);doc.text(82,116,'|');doc.line(5,118,209,118);//? ESCALA 15
doc.text(5,121,'|');doc.text(8,121,'15');doc.text(17,121,'|');doc.text(19,121,this.eval_aedp.pg166);doc.text(23,121,'|');doc.text(25,121,this.eval_aedp.pg167);doc.text(29,121,'|');doc.text(31,121,this.eval_aedp.pg168);doc.text(34,121,'|');doc.text(36,121,this.eval_aedp.pg169);doc.text(40,121,'|');doc.text(42,121,this.eval_aedp.pg170);doc.text(46,121,'|');doc.text(48,121,this.eval_aedp.pg171);doc.text(52,121,'|');doc.text(54,121,this.eval_aedp.pg172);doc.text(58,121,'|');doc.text(60,121,this.eval_aedp.pg173);doc.text(64,121,'|');doc.text(66,121,this.eval_aedp.pg174);doc.text(70,121,'|');doc.text(72,121,this.eval_aedp.pg175);doc.text(76,121,'|');doc.line(5,123,209,123);//? ESCALA 16
doc.text(5,126,'|');doc.text(8,126,'16');doc.text(17,126,'|');doc.text(19,126,this.eval_aedp.pg176);doc.text(23,126,'|');doc.text(25,126,this.eval_aedp.pg177);doc.text(29,126,'|');doc.text(31,126,this.eval_aedp.pg178);doc.text(34,126,'|');doc.text(36,126,this.eval_aedp.pg179);doc.text(40,126,'|');doc.text(42,126,this.eval_aedp.pg180);doc.text(46,126,'|');doc.text(48,126,this.eval_aedp.pg181);doc.text(52,126,'|');doc.text(54,126,this.eval_aedp.pg182);doc.text(58,126,'|');doc.text(60,126,this.eval_aedp.pg183);doc.text(64,126,'|');doc.text(66,126,this.eval_aedp.pg184);doc.text(70,126,'|');doc.text(72,126,this.eval_aedp.pg185);doc.text(76,126,'|');doc.text(78,126,this.eval_aedp.pg186);doc.text(82,126,'|');doc.text(84,126,this.eval_aedp.pg187);doc.text(88,126,'|');doc.text(90,126,this.eval_aedp.pg188);doc.text(94,126,'|');doc.line(5,128,209,128);//? ESCALA 17
doc.text(5,131,'|');doc.text(8,131,'17');doc.text(17,131,'|');doc.text(19,131,this.eval_aedp.pg189);doc.text(23,131,'|');doc.text(25,131,this.eval_aedp.pg190);doc.text(29,131,'|');doc.text(31,131,this.eval_aedp.pg191);doc.text(34,131,'|');doc.text(36,131,this.eval_aedp.pg192);doc.text(40,131,'|');doc.text(42,131,this.eval_aedp.pg193);doc.text(46,131,'|');doc.text(48,131,this.eval_aedp.pg194);doc.text(52,131,'|');doc.text(54,131,this.eval_aedp.pg195);doc.text(58,131,'|');doc.text(60,131,this.eval_aedp.pg196);doc.text(64,131,'|');doc.text(66,131,this.eval_aedp.pg197);doc.text(70,131,'|');doc.line(5,133,209,133);//? ESCALA 18
doc.text(5,136,'|');doc.text(8,136,'18');doc.text(17,136,'|');doc.text(19,136,this.eval_aedp.pg198);doc.text(23,136,'|');doc.text(25,136,this.eval_aedp.pg199);doc.text(29,136,'|');doc.text(31,136,this.eval_aedp.pg200);doc.text(34,136,'|');doc.text(36,136,this.eval_aedp.pg201);doc.text(40,136,'|');doc.text(42,136,this.eval_aedp.pg202);doc.text(46,136,'|');doc.text(48,136,this.eval_aedp.pg203);doc.text(52,136,'|');doc.text(54,136,this.eval_aedp.pg204);doc.text(58,136,'|');doc.text(60,136,this.eval_aedp.pg205);doc.text(64,136,'|');doc.text(66,136,this.eval_aedp.pg206);doc.text(70,136,'|');doc.text(72,136,this.eval_aedp.pg207);doc.text(76,136,'|');doc.text(78,136,this.eval_aedp.pg208);doc.text(82,136,'|');doc.text(84,136,this.eval_aedp.pg209);doc.text(88,136,'|');doc.text(90,136,this.eval_aedp.pg210);doc.text(94,136,'|');doc.text(96,136,this.eval_aedp.pg211);doc.text(100,136,'|');doc.text(102,136,this.eval_aedp.pg212);doc.text(106,136,'|');doc.text(108,136,this.eval_aedp.pg213);doc.text(112,136,'|');doc.text(114,136,this.eval_aedp.pg214);doc.text(118,136,'|');doc.text(120,136,this.eval_aedp.pg215);doc.text(124,136,'|');doc.text(126,136,this.eval_aedp.pg216);doc.text(130,136,'|');doc.text(132,136,this.eval_aedp.pg217);doc.text(136,136,'|');doc.text(138,136,this.eval_aedp.pg218);doc.text(142,136,'|');doc.text(144,136,this.eval_aedp.pg219);//*22
doc.text(148,136,'|');doc.text(150,136,this.eval_aedp.pg220);doc.text(154,136,'|');doc.text(156,136,this.eval_aedp.pg221);doc.text(160,136,'|');doc.text(162,136,this.eval_aedp.pg222);doc.text(166,136,'|');doc.text(168,136,this.eval_aedp.pg223);doc.text(172,136,'|');doc.text(174,136,this.eval_aedp.pg224);doc.text(178,136,'|');doc.text(180,136,this.eval_aedp.pg225);doc.text(184,136,'|');doc.text(186,136,this.eval_aedp.pg226);doc.text(190,136,'|');doc.text(192,136,this.eval_aedp.pg227);doc.text(196,136,'|');doc.text(198,136,this.eval_aedp.pg228);doc.text(202,136,'|');doc.text(204,136,this.eval_aedp.pg229);doc.text(208,136,'|');doc.line(5,138,209,138);//? ESCALA 19
doc.text(5,141,'|');doc.text(8,141,'19');doc.text(17,141,'|');doc.text(19,141,this.eval_aedp.pg230);doc.text(23,141,'|');doc.text(25,141,this.eval_aedp.pg231);doc.text(29,141,'|');doc.text(31,141,this.eval_aedp.pg232);doc.text(34,141,'|');doc.text(36,141,this.eval_aedp.pg233);doc.text(40,141,'|');doc.text(42,141,this.eval_aedp.pg234);doc.text(46,141,'|');doc.text(48,141,this.eval_aedp.pg235);doc.text(52,141,'|');doc.text(54,141,this.eval_aedp.pg236);doc.text(58,141,'|');doc.text(60,141,this.eval_aedp.pg237);doc.text(64,141,'|');doc.text(66,141,this.eval_aedp.pg238);doc.text(70,141,'|');doc.text(72,141,this.eval_aedp.pg239);doc.text(76,141,'|');doc.text(78,141,this.eval_aedp.pg240);doc.text(82,141,'|');doc.line(5,143,209,143);//? ESCALA 20
doc.text(5,146,'|');doc.text(8,146,'20');doc.text(17,146,'|');doc.text(19,146,this.eval_aedp.pg241);doc.text(23,146,'|');doc.text(25,146,this.eval_aedp.pg242);doc.text(29,146,'|');doc.text(31,146,this.eval_aedp.pg243);doc.text(34,146,'|');doc.text(36,146,this.eval_aedp.pg244);doc.text(40,146,'|');doc.text(42,146,this.eval_aedp.pg245);doc.text(46,146,'|');doc.text(48,146,this.eval_aedp.pg246);doc.text(52,146,'|');doc.text(54,146,this.eval_aedp.pg247);doc.text(58,146,'|');doc.line(5,148,209,148);//? ESCALA 21
doc.text(5,151,'|');doc.text(8,151,'21');doc.text(17,151,'|');doc.text(19,151,this.eval_aedp.pg248);doc.text(23,151,'|');doc.text(25,151,this.eval_aedp.pg249);doc.text(29,151,'|');doc.text(31,151,this.eval_aedp.pg250);doc.text(34,151,'|');doc.text(36,151,this.eval_aedp.pg251);doc.text(40,151,'|');doc.text(42,151,this.eval_aedp.pg252);doc.text(46,151,'|');doc.text(48,151,this.eval_aedp.pg253);doc.text(52,151,'|');doc.text(54,151,this.eval_aedp.pg254);doc.text(58,151,'|');doc.line(5,153,209,153);},resultados_aedp:function resultados_aedp(doc){doc.text(5,160,"SECCION DE RESULTADOS ");doc.line(5,161,209,161);doc.text(5,164,'| Dimensión Conocimiento | ÓPTIMO | DIESTRO | VULNERABLE | CAUTELA | Puntaje  | Zona    de     |  Categorías    Total       |');doc.text(5,167,'| Emocional');doc.text(43,167,'|');doc.text(56,167,'Puntaje Máximo y Puntaje Mínimo');doc.text(116,167,'|');doc.text(117,167,'Obtenido');doc.text(130,167,'|');doc.text(132,167,'Rendimiento');doc.text(150,167,'|');doc.text(152,167,'Inteligencia Emocional');doc.text(185,167,'|');doc.line(5,169,209,169);//? .....................................................................................................................................
this.json_data=[];var registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};//? .....................................................................................................................................
//? ESCALA 1: SUCESOS DE LA VIDA
doc.text(5,172,'|');doc.text(7,172,'Sucesos de');doc.text(43,172,'|');doc.text(48,172,'0');doc.text(59,172,'|');doc.text(63,172,'3');doc.text(75,172,'|');doc.text(80,172,'8');doc.text(98,172,'|');doc.text(103,172,'16');doc.text(116,172,'|');var sumaE1=0;var pg001=parseInt(this.eval_aedp.pg001);var pg002=parseInt(this.eval_aedp.pg002);var pg003=parseInt(this.eval_aedp.pg003);var pg004=parseInt(this.eval_aedp.pg004);var pg005=parseInt(this.eval_aedp.pg005);var pg006=parseInt(this.eval_aedp.pg006);var pg007=parseInt(this.eval_aedp.pg007);var pg008=parseInt(this.eval_aedp.pg008);var pg009=parseInt(this.eval_aedp.pg009);var pg010=parseInt(this.eval_aedp.pg010);var pg011=parseInt(this.eval_aedp.pg011);var pg012=parseInt(this.eval_aedp.pg012);var pg013=parseInt(this.eval_aedp.pg013);var pg014=parseInt(this.eval_aedp.pg014);var pg015=parseInt(this.eval_aedp.pg015);var pg016=parseInt(this.eval_aedp.pg016);var pg017=parseInt(this.eval_aedp.pg017);var pg018=parseInt(this.eval_aedp.pg018);sumaE1=pg001+pg002+pg003+pg004+pg005+pg006+pg007+pg008+pg009+pg010+pg011+pg012+pg013+pg014+pg015+pg016+pg017+pg018;var st_sumaE1=sumaE1.toString();doc.text(119,172,st_sumaE1);doc.text(130,172,'|');var desc_E1='';if(sumaE1<=2){desc_E1='Óptimo';registro.optimo=sumaE1;}else{if(sumaE1>=3&&sumaE1<=7){desc_E1='Diestro';registro.diestro=sumaE1;}else{if(sumaE1>=8&&sumaE1<=15){desc_E1='Vulnerable';registro.vulnerable=sumaE1;}else{desc_E1='Cautela';registro.cautela=sumaE1;}}};registro.variable='Sucesos de la Vida';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};console.log('que hay en json_data ahora ? ');console.log(this.json_data);doc.text(133,172,desc_E1);doc.text(150,172,'|');doc.text(185,172,'|');doc.line(43,173,117,173);doc.text(5,176,'|');doc.text(7,176,'la vida');doc.text(43,176,'|');doc.text(48,176,'2');doc.text(59,176,'|');doc.text(63,176,'7');doc.text(75,176,'|');doc.text(80,176,'15');doc.text(98,176,'|');doc.text(103,176,'54');doc.text(116,176,'|');doc.text(130,176,'|');doc.text(150,176,'|');doc.text(185,176,'|');doc.line(5,177,151,177);//? .....................................................................................................................................
//? ESCALA 2: PRESIONES DEL TRABAJO
doc.text(5,180,'|');doc.text(7,180,'Presiones del');doc.text(43,180,'|');doc.text(48,180,'0');doc.text(59,180,'|');doc.text(63,180,'7');doc.text(75,180,'|');doc.text(80,180,'14');doc.text(98,180,'|');doc.text(103,180,'21');doc.text(116,180,'|');var sumaE2=0;var pg019=parseInt(this.eval_aedp.pg019);var pg020=parseInt(this.eval_aedp.pg020);var pg021=parseInt(this.eval_aedp.pg021);var pg022=parseInt(this.eval_aedp.pg022);var pg023=parseInt(this.eval_aedp.pg023);var pg024=parseInt(this.eval_aedp.pg024);var pg025=parseInt(this.eval_aedp.pg025);var pg026=parseInt(this.eval_aedp.pg026);var pg027=parseInt(this.eval_aedp.pg027);var pg028=parseInt(this.eval_aedp.pg028);var pg029=parseInt(this.eval_aedp.pg029);var pg030=parseInt(this.eval_aedp.pg030);var pg031=parseInt(this.eval_aedp.pg031);var pg032=parseInt(this.eval_aedp.pg032);var pg033=parseInt(this.eval_aedp.pg033);var pg034=parseInt(this.eval_aedp.pg034);var pg035=parseInt(this.eval_aedp.pg035);sumaE2=pg019+pg020+pg021+pg022+pg023+pg024+pg025+pg026+pg027+pg028+pg029+pg030+pg031+pg032+pg033+pg034+pg035;var st_sumaE2=sumaE2.toString();doc.text(119,180,st_sumaE2);doc.text(130,180,'|');var desc_E2='';if(sumaE2<=6){desc_E2='Óptimo';registro.optimo=sumaE2;}else{if(sumaE2>=7&&sumaE2<=13){desc_E2='Diestro';registro.diestro=sumaE2;}else{if(sumaE2>=14&&sumaE2<=20){desc_E2='Vulnerable';registro.vulnerable=sumaE2;}else{desc_E2='Cautela';registro.cautela=sumaE2;}}};registro.variable='Presiones del trabajo';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,180,desc_E2);doc.text(150,180,'|');doc.text(185,180,'|');doc.line(43,181,117,181);doc.text(5,184,'|');doc.text(7,184,'trabajo');doc.text(43,184,'|');doc.text(48,184,'6');doc.text(59,184,'|');doc.text(63,184,'13');doc.text(75,184,'|');doc.text(80,184,'20');doc.text(98,184,'|');doc.text(103,184,'51');doc.text(116,184,'|');doc.text(130,184,'|');doc.text(150,184,'|');doc.text(185,184,'|');doc.line(5,185,151,185);//? .....................................................................................................................................
//? ESCALA 3: PRESIONES PERSONALES
doc.text(5,188,'|');doc.text(7,188,'Presiones');doc.text(43,188,'|');doc.text(48,188,'0');doc.text(59,188,'|');doc.text(63,188,'3');doc.text(75,188,'|');doc.text(80,188,'8');doc.text(98,188,'|');doc.text(103,188,'15');doc.text(116,188,'|');var sumaE3=0;var pg036=parseInt(this.eval_aedp.pg036);var pg037=parseInt(this.eval_aedp.pg037);var pg038=parseInt(this.eval_aedp.pg038);var pg039=parseInt(this.eval_aedp.pg039);var pg040=parseInt(this.eval_aedp.pg040);var pg041=parseInt(this.eval_aedp.pg041);var pg042=parseInt(this.eval_aedp.pg042);var pg043=parseInt(this.eval_aedp.pg043);var pg044=parseInt(this.eval_aedp.pg044);var pg045=parseInt(this.eval_aedp.pg045);var pg046=parseInt(this.eval_aedp.pg046);var pg047=parseInt(this.eval_aedp.pg047);var pg048=parseInt(this.eval_aedp.pg048);var pg049=parseInt(this.eval_aedp.pg049);sumaE3=pg036+pg037+pg038+pg039+pg040+pg041+pg042+pg043+pg044+pg045+pg046+pg047+pg048+pg049;var st_sumaE3=sumaE3.toString();doc.text(119,188,st_sumaE3);doc.text(130,188,'|');var desc_E3='';if(sumaE3<=2){desc_E3='Óptimo';registro.optimo=sumaE3;}else{if(sumaE3>=3&&sumaE3<=7){desc_E3='Diestro';registro.diestro=sumaE3;}else{if(sumaE3>=8&&sumaE3<=14){desc_E3='Vulnerable';registro.vulnerable=sumaE3;}else{desc_E3='Cautela';registro.cautela=sumaE3;}}};registro.variable='Presiones personales';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,188,desc_E3);doc.text(150,188,'|');doc.text(185,188,'|');doc.line(43,189,117,189);doc.text(5,192,'|');doc.text(7,192,'personales');doc.text(43,192,'|');doc.text(48,192,'2');doc.text(59,192,'|');doc.text(63,192,'7');doc.text(75,192,'|');doc.text(80,192,'14');doc.text(98,192,'|');doc.text(103,192,'42');doc.text(116,192,'|');doc.text(130,192,'|');doc.text(150,192,'|');doc.text(185,192,'|');doc.line(5,193,209,193);//? .....................................................................................................................................
//? ESCALA 4: CONOCIMIENTO DE SÍ MISMO
doc.text(5,196,'|');doc.text(7,196,'Conocimiento');doc.text(43,196,'|');doc.text(48,196,'33');doc.text(59,196,'|');doc.text(63,196,'28');doc.text(75,196,'|');doc.text(80,196,'23');doc.text(98,196,'|');doc.text(103,196,'18');doc.text(116,196,'|');var sumaE4=0;var pg050=parseInt(this.eval_aedp.pg050);var pg051=parseInt(this.eval_aedp.pg051);var pg052=parseInt(this.eval_aedp.pg052);var pg053=parseInt(this.eval_aedp.pg053);var pg054=parseInt(this.eval_aedp.pg054);var pg055=parseInt(this.eval_aedp.pg055);var pg056=parseInt(this.eval_aedp.pg056);var pg057=parseInt(this.eval_aedp.pg057);var pg058=parseInt(this.eval_aedp.pg058);var pg059=parseInt(this.eval_aedp.pg059);var pg060=parseInt(this.eval_aedp.pg060);// console.log('Escala 4: ',pg050,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE4=pg050+pg051+pg052+pg053+pg054+pg055+pg056+pg057+pg058+pg059+pg060;var st_sumaE4=sumaE4.toString();doc.text(119,196,st_sumaE4);doc.text(130,196,'|');var desc_E4='';if(sumaE4>=29&&sumaE4<=33){desc_E4='Óptimo';registro.optimo=sumaE4;}else{if(sumaE4>=24&&sumaE4<=28){desc_E4='Diestro';registro.diestro=sumaE4;}else{if(sumaE4>=19&&sumaE4<=23){desc_E4='Vulnerable';registro.vulnerable=sumaE4;}else{desc_E4='Cautela';registro.cautela=sumaE4;}}};registro.variable='Conocimiento de sí mismo';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,196,desc_E4);doc.text(150,196,'|');doc.text(185,196,'|');doc.line(43,197,117,197);doc.text(5,200,'|');doc.text(7,200,'de sí mismo');doc.text(43,200,'|');doc.text(48,200,'29');doc.text(59,200,'|');doc.text(63,200,'24');doc.text(75,200,'|');doc.text(80,200,'19');doc.text(98,200,'|');doc.text(103,200,'0');doc.text(116,200,'|');doc.text(130,200,'|');doc.text(150,200,'|');doc.text(185,200,'|');doc.line(5,201,151,201);//? .....................................................................................................................................
//? ESCALA 5: EXPRESIÓN EMOCIONAL
doc.text(5,204,'|');doc.text(7,204,'Expresión');doc.text(43,204,'|');doc.text(48,204,'27');doc.text(59,204,'|');doc.text(63,204,'19');doc.text(75,204,'|');doc.text(80,204,'16');doc.text(98,204,'|');doc.text(103,204,'12');doc.text(116,204,'|');var sumaE5=0;var pg061=parseInt(this.eval_aedp.pg061);var pg062=parseInt(this.eval_aedp.pg062);var pg063=parseInt(this.eval_aedp.pg063);var pg064=parseInt(this.eval_aedp.pg064);var pg065=parseInt(this.eval_aedp.pg065);var pg066=parseInt(this.eval_aedp.pg066);var pg067=parseInt(this.eval_aedp.pg067);var pg068=parseInt(this.eval_aedp.pg068);var pg069=parseInt(this.eval_aedp.pg069);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE5=pg061+pg062+pg063+pg064+pg065+pg066+pg067+pg068+pg069;var st_sumaE5=sumaE5.toString();doc.text(119,204,st_sumaE5);doc.text(130,204,'|');var desc_E5='';if(sumaE5>=20&&sumaE5<=27){desc_E5='Óptimo';registro.optimo=sumaE5;}else{if(sumaE5>=17&&sumaE5<=19){desc_E5='Diestro';registro.diestro=sumaE5;}else{if(sumaE5>=13&&sumaE5<=16){desc_E5='Vulnerable';registro.vulnerable=sumaE5;}else{desc_E5='Cautela';registro.cautela=sumaE5;}}}registro.variable='Expresión emocional';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,204,desc_E5);doc.text(150,204,'|');doc.text(185,204,'|');doc.line(43,205,117,205);doc.text(5,208,'|');doc.text(7,208,'emocional');doc.text(43,208,'|');doc.text(48,208,'20');doc.text(59,208,'|');doc.text(63,208,'17');doc.text(75,208,'|');doc.text(80,208,'13');doc.text(98,208,'|');doc.text(103,208,'0');doc.text(116,208,'|');doc.text(130,208,'|');doc.text(150,208,'|');doc.text(185,208,'|');doc.line(5,209,151,209);//? .....................................................................................................................................
//? ESCALA 6: CONCIENCIA EMOCIONAL DE OTROS
doc.text(5,212,'|');doc.text(7,212,'Conciencia emocional');doc.text(43,212,'|');doc.text(48,212,'39');doc.text(59,212,'|');doc.text(63,212,'27');doc.text(75,212,'|');doc.text(80,212,'21');doc.text(98,212,'|');doc.text(103,212,'14');doc.text(116,212,'|');var sumaE6=0;var pg070=parseInt(this.eval_aedp.pg070);var pg071=parseInt(this.eval_aedp.pg071);var pg072=parseInt(this.eval_aedp.pg072);var pg073=parseInt(this.eval_aedp.pg073);var pg074=parseInt(this.eval_aedp.pg074);var pg074b=parseInt(this.eval_aedp.pg074b);var pg074c=parseInt(this.eval_aedp.pg074c);var pg074d=parseInt(this.eval_aedp.pg074d);var pg074e=parseInt(this.eval_aedp.pg074e);var pg074f=parseInt(this.eval_aedp.pg074f);var pg074g=parseInt(this.eval_aedp.pg074g);var pg074h=parseInt(this.eval_aedp.pg074h);var pg074i=parseInt(this.eval_aedp.pg074i);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE6=pg070+pg071+pg072+pg073+pg074+pg074b+pg074c+pg074d+pg074e+pg074f+pg074g+pg074h+pg074i;var st_sumaE6=sumaE6.toString();doc.text(119,212,st_sumaE6);doc.text(130,212,'|');var desc_E6='';if(sumaE6>=28&&sumaE6<=39){desc_E6='Óptimo';registro.optimo=sumaE6;}else{if(sumaE6>=22&&sumaE6<=27){desc_E6='Diestro';registro.diestro=sumaE6;}else{if(sumaE6>=15&&sumaE6<=21){desc_E6='Vulnerable';registro.vulnerable=sumaE6;}else{desc_E6='Cautela';registro.cautela=sumaE6;}}};registro.variable='Conciencia emocional';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,212,desc_E6);doc.text(150,212,'|');doc.text(185,212,'|');doc.line(43,213,117,213);doc.text(5,216,'|');doc.text(7,216,'de otros');doc.text(43,216,'|');doc.text(48,216,'28');doc.text(59,216,'|');doc.text(63,216,'22');doc.text(75,216,'|');doc.text(80,216,'15');doc.text(98,216,'|');doc.text(103,216,'0');doc.text(116,216,'|');doc.text(130,216,'|');doc.text(150,216,'|');doc.text(185,216,'|');doc.line(5,217,209,217);//? .....................................................................................................................................
//? ESCALA 7: INTENCIÓN
doc.text(5,220,'|');doc.text(7,220,'Intención');doc.text(43,220,'|');doc.text(48,220,'42');doc.text(59,220,'|');doc.text(63,220,'32');doc.text(75,220,'|');doc.text(80,220,'26');doc.text(98,220,'|');doc.text(103,220,'20');doc.text(116,220,'|');var sumaE7=0;var pg075=parseInt(this.eval_aedp.pg075);var pg076=parseInt(this.eval_aedp.pg076);var pg077=parseInt(this.eval_aedp.pg077);var pg078=parseInt(this.eval_aedp.pg078);var pg079=parseInt(this.eval_aedp.pg079);var pg080=parseInt(this.eval_aedp.pg080);var pg081=parseInt(this.eval_aedp.pg081);var pg082=parseInt(this.eval_aedp.pg082);var pg083=parseInt(this.eval_aedp.pg083);var pg084=parseInt(this.eval_aedp.pg084);var pg085=parseInt(this.eval_aedp.pg085);var pg086=parseInt(this.eval_aedp.pg086);var pg087=parseInt(this.eval_aedp.pg087);var pg088=parseInt(this.eval_aedp.pg088);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE7=pg075+pg076+pg077+pg078+pg079+pg080+pg081+pg082+pg083+pg084+pg085+pg086+pg087+pg088;var st_sumaE7=sumaE7.toString();doc.text(119,220,st_sumaE7);doc.text(130,220,'|');var desc_E7='';if(sumaE7>=33&&sumaE7<=42){desc_E7='Óptimo';registro.optimo=sumaE7;}else{if(sumaE7>=27&&sumaE7<=32){desc_E7='Diestro';registro.diestro=sumaE7;}else{if(sumaE7>=21&&sumaE7<=26){desc_E7='Vulnerable';registro.vulnerable=sumaE7;}else{desc_E7='Cautela';registro.cautela=sumaE7;}}};registro.variable='Intención';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,220,desc_E7);doc.text(150,220,'|');doc.text(185,220,'|');doc.line(43,221,117,221);doc.text(5,224,'|');doc.text(7,224,' ');doc.text(43,224,'|');doc.text(48,224,'33');doc.text(59,224,'|');doc.text(63,224,'27');doc.text(75,224,'|');doc.text(80,224,'21');doc.text(98,224,'|');doc.text(103,224,'0');doc.text(116,224,'|');doc.text(130,224,'|');doc.text(150,224,'|');doc.text(185,224,'|');doc.line(5,225,151,225);//? .....................................................................................................................................
//? ESCALA 8: CREATIVIDAD
doc.text(5,228,'|');doc.text(7,228,'Creatividad');doc.text(43,228,'|');doc.text(48,228,'30');doc.text(59,228,'|');doc.text(63,228,'23');doc.text(75,228,'|');doc.text(80,228,'18');doc.text(98,228,'|');doc.text(103,228,'14');doc.text(116,228,'|');var sumaE8=0;var pg089=parseInt(this.eval_aedp.pg089);var pg090=parseInt(this.eval_aedp.pg090);var pg091=parseInt(this.eval_aedp.pg091);var pg092=parseInt(this.eval_aedp.pg092);var pg093=parseInt(this.eval_aedp.pg093);var pg094=parseInt(this.eval_aedp.pg094);var pg095=parseInt(this.eval_aedp.pg095);var pg096=parseInt(this.eval_aedp.pg096);var pg097=parseInt(this.eval_aedp.pg097);var pg098=parseInt(this.eval_aedp.pg098);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE8=pg089+pg090+pg091+pg092+pg093+pg094+pg095+pg096+pg097+pg098;var st_sumaE8=sumaE8.toString();doc.text(119,228,st_sumaE8);doc.text(130,228,'|');var desc_E8='';if(sumaE8>=24&&sumaE8<=30){desc_E8='Óptimo';registro.optimo=sumaE8;}else{if(sumaE8>=19&&sumaE8<=23){desc_E8='Diestro';registro.diestro=sumaE8;}else{if(sumaE8>=13&&sumaE8<=18){desc_E8='Vulnerable';registro.vulnerable=sumaE8;}else{desc_E8='Cautela';registro.cautela=sumaE8;}}};registro.variable='Creatividad';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,228,desc_E8);doc.text(150,228,'|');doc.text(185,228,'|');doc.line(43,229,117,229);doc.text(5,232,'|');doc.text(7,232,' ');doc.text(43,232,'|');doc.text(48,232,'24');doc.text(59,232,'|');doc.text(63,232,'19');doc.text(75,232,'|');doc.text(80,232,'13');doc.text(98,232,'|');doc.text(103,232,'0');doc.text(116,232,'|');doc.text(130,232,'|');doc.text(150,232,'|');doc.text(185,232,'|');doc.line(5,233,151,233);//? .....................................................................................................................................
//? ESCALA 9: FLEXIBILIDAD
doc.text(5,236,'|');doc.text(7,236,'Flexibilidad');doc.text(43,236,'|');doc.text(48,236,'39');doc.text(59,228,'|');doc.text(63,236,'33');doc.text(75,236,'|');doc.text(80,236,'27');doc.text(98,236,'|');doc.text(103,236,'20');doc.text(116,236,'|');var sumaE9=0;var pg099=parseInt(this.eval_aedp.pg099);var pg100=parseInt(this.eval_aedp.pg100);var pg101=parseInt(this.eval_aedp.pg101);var pg102=parseInt(this.eval_aedp.pg092);var pg103=parseInt(this.eval_aedp.pg103);var pg104=parseInt(this.eval_aedp.pg104);var pg105=parseInt(this.eval_aedp.pg105);var pg106=parseInt(this.eval_aedp.pg106);var pg107=parseInt(this.eval_aedp.pg107);var pg108=parseInt(this.eval_aedp.pg108);var pg109=parseInt(this.eval_aedp.pg109);var pg110=parseInt(this.eval_aedp.pg110);var pg111=parseInt(this.eval_aedp.pg111);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE9=pg099+pg100+pg101+pg102+pg103+pg104+pg105+pg106+pg107+pg108+pg109+pg110+pg111;var st_sumaE9=sumaE9.toString();doc.text(119,236,st_sumaE9);doc.text(130,236,'|');var desc_E9='';if(sumaE9>=34&&sumaE9<=39){desc_E9='Óptimo';registro.optimo=sumaE9;}else{if(sumaE9>=28&&sumaE9<=33){desc_E9='Diestro';registro.diestro=sumaE9;}else{if(sumaE9>=21&&sumaE9<=27){desc_E9='Vulnerable';registro.vulnerable=sumaE9;}else{desc_E9='Cautela';registro.cautela=sumaE9;}}};registro.variable='Flexibilidad';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,236,desc_E9);doc.text(150,236,'|');doc.text(185,236,'|');doc.line(43,237,117,237);doc.text(5,240,'|');doc.text(7,240,' ');doc.text(43,240,'|');doc.text(48,240,'34');doc.text(59,240,'|');doc.text(63,240,'28');doc.text(75,240,'|');doc.text(80,240,'21');doc.text(98,240,'|');doc.text(103,240,'0');doc.text(116,240,'|');doc.text(130,240,'|');doc.text(150,240,'|');doc.text(185,240,'|');doc.line(5,241,151,241);//? .....................................................................................................................................
//? ESCALA 10: CONEXIONES INTERPERSONALES
doc.text(5,244,'|');doc.text(7,244,'Conexiones');doc.text(43,244,'|');doc.text(48,244,'30');doc.text(59,244,'|');doc.text(63,244,'27');doc.text(75,244,'|');doc.text(80,244,'22');doc.text(98,244,'|');doc.text(103,244,'17');doc.text(116,244,'|');var sumaE10=0;var pg112=parseInt(this.eval_aedp.pg112);var pg113=parseInt(this.eval_aedp.pg113);var pg114=parseInt(this.eval_aedp.pg114);var pg115=parseInt(this.eval_aedp.pg115);var pg116=parseInt(this.eval_aedp.pg116);var pg117=parseInt(this.eval_aedp.pg117);var pg118=parseInt(this.eval_aedp.pg118);var pg119=parseInt(this.eval_aedp.pg119);var pg120=parseInt(this.eval_aedp.pg120);var pg121=parseInt(this.eval_aedp.pg121);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE10=pg112+pg113+pg114+pg115+pg116+pg117+pg118+pg119+pg120+pg121;var st_sumaE10=sumaE10.toString();doc.text(119,244,st_sumaE10);doc.text(130,244,'|');var desc_E10='';if(sumaE10>=28&&sumaE10<=30){desc_E10='Óptimo';registro.optimo=sumaE10;}else{if(sumaE10>=23&&sumaE10<=27){desc_E10='Diestro';registro.diestro=sumaE10;}else{if(sumaE10>=18&&sumaE10<=22){desc_E10='Vulnerable';registro.vulnerable=sumaE10;}else{desc_E10='Cautela';registro.cautela=sumaE10;}}};registro.variable='Conexiones interpersonales';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,244,desc_E10);doc.text(150,244,'|');doc.text(185,244,'|');doc.line(43,245,117,245);doc.text(5,248,'|');doc.text(7,248,'interpersonales');doc.text(43,248,'|');doc.text(48,248,'28');doc.text(59,248,'|');doc.text(63,248,'23');doc.text(75,248,'|');doc.text(80,248,'18');doc.text(98,248,'|');doc.text(103,248,'0');doc.text(116,248,'|');doc.text(130,248,'|');doc.text(150,248,'|');doc.text(185,248,'|');doc.line(5,249,151,249);//? .....................................................................................................................................
//? ESCALA 11: DESCONTENTO DESTRUCTIVO
doc.text(5,252,'|');doc.text(7,252,'Descontento');doc.text(43,252,'|');doc.text(48,252,'39');doc.text(59,252,'|');doc.text(63,252,'33');doc.text(75,252,'|');doc.text(80,252,'26');doc.text(98,252,'|');doc.text(103,252,'19');doc.text(116,252,'|');var sumaE11=0;var pg122=parseInt(this.eval_aedp.pg122);var pg123=parseInt(this.eval_aedp.pg123);var pg124=parseInt(this.eval_aedp.pg124);var pg125=parseInt(this.eval_aedp.pg125);var pg126=parseInt(this.eval_aedp.pg126);var pg127=parseInt(this.eval_aedp.pg127);var pg128=parseInt(this.eval_aedp.pg128);var pg129=parseInt(this.eval_aedp.pg129);var pg130=parseInt(this.eval_aedp.pg130);var pg131=parseInt(this.eval_aedp.pg131);var pg132=parseInt(this.eval_aedp.pg132);var pg133=parseInt(this.eval_aedp.pg133);var pg134=parseInt(this.eval_aedp.pg134);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE11=pg122+pg123+pg124+pg125+pg126+pg127+pg128+pg129+pg130+pg131+pg132+pg133+pg134;var st_sumaE11=sumaE11.toString();doc.text(119,252,st_sumaE11);doc.text(130,252,'|');var desc_E11='';if(sumaE11>=34&&sumaE11<=39){desc_E11='Óptimo';registro.optimo=sumaE11;}else{if(sumaE11>=27&&sumaE11<=33){desc_E11='Diestro';registro.diestro=sumaE11;}else{if(sumaE11>=20&&sumaE11<=26){desc_E11='Vulnerable';registro.vulnerable=sumaE11;}else{desc_E11='Cautela';registro.cautela=sumaE11;}}};registro.variable='Descontento destructivo';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,252,desc_E11);doc.text(150,252,'|');doc.text(185,252,'|');doc.line(43,253,117,253);doc.text(5,256,'|');doc.text(7,256,'destructivo');doc.text(43,256,'|');doc.text(48,256,'34');doc.text(59,256,'|');doc.text(63,256,'27');doc.text(75,256,'|');doc.text(80,256,'20');doc.text(98,256,'|');doc.text(103,256,'0');doc.text(116,256,'|');doc.text(130,256,'|');doc.text(150,256,'|');doc.text(185,256,'|');doc.line(5,257,151,257);//? .....................................................................................................................................
//? ESCALA 12: COMPASIÓN
doc.text(5,260,'|');doc.text(7,260,'Compasión');doc.text(43,260,'|');doc.text(48,260,'36');doc.text(59,260,'|');doc.text(63,260,'32');doc.text(75,260,'|');doc.text(80,260,'28');doc.text(98,260,'|');doc.text(103,260,'20');doc.text(116,260,'|');var sumaE12=0;var pg135=parseInt(this.eval_aedp.pg135);var pg136=parseInt(this.eval_aedp.pg136);var pg137=parseInt(this.eval_aedp.pg137);var pg138=parseInt(this.eval_aedp.pg138);var pg139=parseInt(this.eval_aedp.pg139);var pg140=parseInt(this.eval_aedp.pg140);var pg141=parseInt(this.eval_aedp.pg141);var pg142=parseInt(this.eval_aedp.pg142);var pg143=parseInt(this.eval_aedp.pg143);var pg144=parseInt(this.eval_aedp.pg144);var pg145=parseInt(this.eval_aedp.pg145);var pg146=parseInt(this.eval_aedp.pg146);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE12=pg135+pg136+pg137+pg138+pg139+pg140+pg141+pg142+pg143+pg144+pg145+pg146;var st_sumaE12=sumaE12.toString();doc.text(119,260,st_sumaE12);doc.text(130,260,'|');var desc_E12='';if(sumaE12>=33&&sumaE12<=36){desc_E12='Óptimo';registro.optimo=sumaE12;}else{if(sumaE12>=29&&sumaE12<=32){desc_E12='Diestro';registro.diestro=sumaE12;}else{if(sumaE12>=21&&sumaE12<=28){desc_E12='Vulnerable';registro.vulnerable=sumaE12;}else{desc_E12='Cautela';registro.cautela=sumaE12;}}};registro.variable='Compasión';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,260,desc_E12);doc.text(150,260,'|');doc.text(185,260,'|');doc.line(43,261,117,261);doc.text(5,264,'|');doc.text(7,264,'');doc.text(43,264,'|');doc.text(48,264,'33');doc.text(59,264,'|');doc.text(63,264,'29');doc.text(75,264,'|');doc.text(80,264,'21');doc.text(98,264,'|');doc.text(103,264,'0');doc.text(116,264,'|');doc.text(130,264,'|');doc.text(150,264,'|');doc.text(185,264,'|');doc.line(5,265,206,265);//? .....................................................................................................................................
//? ESCALA 13: PERSPECTIVA
doc.text(5,268,'|');doc.text(7,268,'Perspectiva');doc.text(43,268,'|');doc.text(48,268,'24');doc.text(59,268,'|');doc.text(63,268,'22');doc.text(75,268,'|');doc.text(80,268,'18');doc.text(98,268,'|');doc.text(103,268,'12');doc.text(116,268,'|');var sumaE13=0;var pg147=parseInt(this.eval_aedp.pg147);var pg148=parseInt(this.eval_aedp.pg148);var pg149=parseInt(this.eval_aedp.pg149);var pg150=parseInt(this.eval_aedp.pg150);var pg151=parseInt(this.eval_aedp.pg151);var pg152=parseInt(this.eval_aedp.pg152);var pg153=parseInt(this.eval_aedp.pg153);var pg154=parseInt(this.eval_aedp.pg154);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE13=pg147+pg148+pg149+pg150+pg151+pg152+pg153+pg154;var st_sumaE13=sumaE13.toString();doc.text(119,268,st_sumaE13);doc.text(130,268,'|');var desc_E13='';if(sumaE13>=23&&sumaE13<=24){desc_E13='Óptimo';registro.optimo=sumaE13;}else{if(sumaE13>=19&&sumaE13<=22){desc_E13='Diestro';registro.diestro=sumaE13;}else{if(sumaE13>=13&&sumaE13<=18){desc_E13='Vulnerable';registro.vulnerable=sumaE13;}else{desc_E13='Cautela';registro.cautela=sumaE13;}}};registro.variable='Perspectiva';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,268,desc_E13);doc.text(150,268,'|');doc.text(185,268,'|');doc.line(43,269,117,269);doc.text(5,272,'|');doc.text(7,272,'');doc.text(43,272,'|');doc.text(48,272,'23');doc.text(59,272,'|');doc.text(63,272,'19');doc.text(75,272,'|');doc.text(80,272,'13');doc.text(98,272,'|');doc.text(103,272,'0');doc.text(116,272,'|');doc.text(130,272,'|');doc.text(150,272,'|');doc.text(185,272,'|');doc.line(5,273,151,273);//? .....................................................................................................................................
//? ESCALA 14: INTUICIÓN
doc.text(5,276,'|');doc.text(7,276,'Intuición');doc.text(43,276,'|');doc.text(48,276,'33');doc.text(59,276,'|');doc.text(63,276,'28');doc.text(75,276,'|');doc.text(80,276,'22');doc.text(98,276,'|');doc.text(103,276,'17');doc.text(116,276,'|');var sumaE14=0;var pg155=parseInt(this.eval_aedp.pg155);var pg156=parseInt(this.eval_aedp.pg156);var pg157=parseInt(this.eval_aedp.pg157);var pg158=parseInt(this.eval_aedp.pg158);var pg159=parseInt(this.eval_aedp.pg159);var pg160=parseInt(this.eval_aedp.pg160);var pg161=parseInt(this.eval_aedp.pg161);var pg162=parseInt(this.eval_aedp.pg162);var pg163=parseInt(this.eval_aedp.pg163);var pg164=parseInt(this.eval_aedp.pg164);var pg165=parseInt(this.eval_aedp.pg165);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE14=pg155+pg156+pg157+pg158+pg159+pg160+pg161+pg162+pg163+pg164+pg165;var st_sumaE14=sumaE14.toString();doc.text(119,276,st_sumaE14);doc.text(130,276,'|');var desc_E14='';if(sumaE14>=29&&sumaE14<=33){desc_E14='Óptimo';registro.optimo=sumaE14;}else{if(sumaE14>=23&&sumaE14<=28){desc_E14='Diestro';registro.diestro=sumaE14;}else{if(sumaE14>=18&&sumaE14<=22){desc_E14='Vulnerable';registro.vulnerable=sumaE14;}else{desc_E14='Cautela';registro.cautela=sumaE14;}}};registro.variable='Intuición';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,276,desc_E14);doc.text(150,276,'|');doc.text(185,276,'|');doc.line(43,277,117,277);doc.text(5,280,'|');doc.text(7,280,'');doc.text(43,280,'|');doc.text(48,280,'29');doc.text(59,280,'|');doc.text(63,280,'23');doc.text(75,280,'|');doc.text(80,280,'18');doc.text(98,280,'|');doc.text(103,280,'0');doc.text(116,280,'|');doc.text(130,280,'|');doc.text(150,280,'|');doc.text(185,280,'|');doc.line(5,281,151,281);//? .....................................................................................................................................
//? ESCALA 15: CONFIANZA EN OTROS
doc.addPage("","l");doc.line(5,12,151,12);doc.text(5,15,'|');doc.text(7,15,'Confianza');doc.text(43,15,'|');doc.text(48,15,'30');doc.text(59,15,'|');doc.text(63,15,'25');doc.text(75,15,'|');doc.text(80,15,'20');doc.text(98,15,'|');doc.text(103,15,'15');doc.text(116,15,'|');var sumaE15=0;var pg166=parseInt(this.eval_aedp.pg166);var pg167=parseInt(this.eval_aedp.pg167);var pg168=parseInt(this.eval_aedp.pg168);var pg169=parseInt(this.eval_aedp.pg169);var pg170=parseInt(this.eval_aedp.pg170);var pg171=parseInt(this.eval_aedp.pg171);var pg172=parseInt(this.eval_aedp.pg172);var pg173=parseInt(this.eval_aedp.pg173);var pg174=parseInt(this.eval_aedp.pg174);var pg175=parseInt(this.eval_aedp.pg175);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE15=pg166+pg167+pg168+pg169+pg170+pg171+pg172+pg173+pg174+pg175;var st_sumaE15=sumaE15.toString();doc.text(119,15,st_sumaE15);doc.text(130,15,'|');var desc_E15='';if(sumaE15>=29&&sumaE15<=33){desc_E15='Óptimo';registro.optimo=sumaE15;}else{if(sumaE15>=23&&sumaE15<=28){desc_E15='Diestro';registro.diestro=sumaE15;}else{if(sumaE15>=18&&sumaE15<=22){desc_E15='Vulnerable';registro.vulnerable=sumaE15;}else{desc_E15='Cautela';registro.cautela=sumaE15;}}};registro.variable='Confianza';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,15,desc_E15);doc.text(150,15,'|');doc.text(185,15,'|');doc.line(43,16,117,16);doc.text(5,19,'|');doc.text(7,19,'en otros');doc.text(43,19,'|');doc.text(48,19,'26');doc.text(59,19,'|');doc.text(63,19,'21');doc.text(75,19,'|');doc.text(80,19,'16');doc.text(98,19,'|');doc.text(103,19,'0');doc.text(116,19,'|');doc.text(130,19,'|');doc.text(150,19,'|');doc.text(185,19,'|');doc.line(5,20,151,20);//? .....................................................................................................................................
//? ESCALA 16: PODER PERSONAL
doc.text(5,23,'|');doc.text(7,23,'Poder');doc.text(43,23,'|');doc.text(48,23,'39');doc.text(59,23,'|');doc.text(63,23,'33');doc.text(75,23,'|');doc.text(80,23,'28');doc.text(98,23,'|');doc.text(103,23,'23');doc.text(116,23,'|');var sumaE16=0;var pg176=parseInt(this.eval_aedp.pg176);var pg177=parseInt(this.eval_aedp.pg177);var pg178=parseInt(this.eval_aedp.pg178);var pg179=parseInt(this.eval_aedp.pg179);var pg180=parseInt(this.eval_aedp.pg180);var pg181=parseInt(this.eval_aedp.pg181);var pg182=parseInt(this.eval_aedp.pg182);var pg183=parseInt(this.eval_aedp.pg183);var pg184=parseInt(this.eval_aedp.pg184);var pg185=parseInt(this.eval_aedp.pg185);var pg186=parseInt(this.eval_aedp.pg186);var pg187=parseInt(this.eval_aedp.pg187);var pg188=parseInt(this.eval_aedp.pg188);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE16=pg176+pg177+pg178+pg179+pg180+pg181+pg182+pg183+pg184+pg185+pg186+pg187+pg188;var st_sumaE16=sumaE16.toString();doc.text(119,23,st_sumaE16);doc.text(130,23,'|');var desc_E16='';if(sumaE16>=34&&sumaE16<=39){desc_E16='Óptimo';registro.optimo=sumaE16;}else{if(sumaE16>=29&&sumaE16<=33){desc_E16='Diestro';registro.diestro=sumaE16;}else{if(sumaE16>=24&&sumaE16<=28){desc_E16='Vulnerable';registro.vulnerable=sumaE16;}else{desc_E16='Cautela';registro.cautela=sumaE16;}}};registro.variable='Poder personal';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,23,desc_E16);doc.text(150,23,'|');doc.text(185,23,'|');doc.line(43,24,117,24);doc.text(5,27,'|');doc.text(7,27,'personal');doc.text(43,27,'|');doc.text(48,27,'34');doc.text(59,27,'|');doc.text(63,27,'29');doc.text(75,27,'|');doc.text(80,27,'24');doc.text(98,27,'|');doc.text(103,27,'0');doc.text(116,27,'|');doc.text(130,27,'|');doc.text(150,27,'|');doc.text(185,27,'|');doc.line(5,28,151,28);//? .....................................................................................................................................
//? ESCALA 17: INTEGRIDAD
doc.text(5,31,'|');doc.text(7,31,'Integridad');doc.text(43,31,'|');doc.text(48,31,'27');doc.text(59,31,'|');doc.text(63,31,'19');doc.text(75,31,'|');doc.text(80,31,'16');doc.text(98,31,'|');doc.text(103,31,'12');doc.text(116,31,'|');var sumaE17=0;var pg189=parseInt(this.eval_aedp.pg189);var pg190=parseInt(this.eval_aedp.pg190);var pg191=parseInt(this.eval_aedp.pg191);var pg192=parseInt(this.eval_aedp.pg192);var pg193=parseInt(this.eval_aedp.pg193);var pg194=parseInt(this.eval_aedp.pg194);var pg195=parseInt(this.eval_aedp.pg195);var pg196=parseInt(this.eval_aedp.pg196);var pg197=parseInt(this.eval_aedp.pg197);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE17=pg189+pg190+pg191+pg192+pg193+pg194+pg195+pg196+pg197;var st_sumaE17=sumaE17.toString();doc.text(119,31,st_sumaE17);doc.text(130,31,'|');var desc_E17='';if(sumaE17>=20&&sumaE17<=27){desc_E17='Óptimo';registro.optimo=sumaE17;}else{if(sumaE17>=17&&sumaE17<=19){desc_E17='Diestro';registro.diestro=sumaE17;}else{if(sumaE17>=13&&sumaE17<=16){desc_E17='Vulnerable';registro.vulnerable=sumaE17;}else{desc_E17='Cautela';registro.cautela=sumaE17;}}};registro.variable='Integridad';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,31,desc_E17);doc.text(150,31,'|');doc.text(185,31,'|');doc.line(43,32,117,32);doc.text(5,35,'|');doc.text(7,35,'');doc.text(43,35,'|');doc.text(48,35,'20');doc.text(59,35,'|');doc.text(63,35,'17');doc.text(75,35,'|');doc.text(80,35,'13');doc.text(98,35,'|');doc.text(103,35,'0');doc.text(116,35,'|');doc.text(130,35,'|');doc.text(150,35,'|');doc.text(185,35,'|');doc.line(5,36,209,36);//? .....................................................................................................................................
//? ESCALA 18: SALUD GENERAL
doc.text(5,39,'|');doc.text(7,39,'Salud general');doc.text(43,39,'|');doc.text(48,39,'0');doc.text(59,39,'|');doc.text(63,39,'9');doc.text(75,39,'|');doc.text(80,39,'19');doc.text(98,39,'|');doc.text(103,39,'32');doc.text(116,39,'|');var sumaE18=0;var pg198=parseInt(this.eval_aedp.pg198);var pg199=parseInt(this.eval_aedp.pg199);var pg200=parseInt(this.eval_aedp.pg200);var pg201=parseInt(this.eval_aedp.pg201);var pg202=parseInt(this.eval_aedp.pg202);var pg203=parseInt(this.eval_aedp.pg203);var pg204=parseInt(this.eval_aedp.pg204);var pg205=parseInt(this.eval_aedp.pg205);var pg206=parseInt(this.eval_aedp.pg206);var pg207=parseInt(this.eval_aedp.pg207);var pg208=parseInt(this.eval_aedp.pg208);var pg209=parseInt(this.eval_aedp.pg209);var pg210=parseInt(this.eval_aedp.pg210);var pg211=parseInt(this.eval_aedp.pg211);var pg212=parseInt(this.eval_aedp.pg212);var pg213=parseInt(this.eval_aedp.pg213);var pg214=parseInt(this.eval_aedp.pg214);var pg215=parseInt(this.eval_aedp.pg215);var pg216=parseInt(this.eval_aedp.pg216);var pg217=parseInt(this.eval_aedp.pg217);var pg218=parseInt(this.eval_aedp.pg218);var pg219=parseInt(this.eval_aedp.pg219);var pg220=parseInt(this.eval_aedp.pg220);var pg221=parseInt(this.eval_aedp.pg221);var pg222=parseInt(this.eval_aedp.pg222);var pg223=parseInt(this.eval_aedp.pg223);var pg224=parseInt(this.eval_aedp.pg224);var pg225=parseInt(this.eval_aedp.pg225);var pg226=parseInt(this.eval_aedp.pg226);var pg227=parseInt(this.eval_aedp.pg227);var pg228=parseInt(this.eval_aedp.pg228);var pg229=parseInt(this.eval_aedp.pg229);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE18=pg198+pg199+pg200+pg201+pg202+pg203+pg204+pg205+pg206+pg207+pg208+pg209+pg210+pg211+pg212+pg213+pg214+pg215+pg216+pg217+pg218+pg219+pg220+pg221+pg222+pg223+pg224+pg225+pg226+pg227+pg228+pg229;var st_sumaE18=sumaE18.toString();doc.text(119,39,st_sumaE18);doc.text(130,39,'|');var desc_E18='';if(sumaE18>=0&&sumaE18<=8){desc_E18='Óptimo';registro.optimo=sumaE18;}else{if(sumaE18>=9&&sumaE18<=18){desc_E18='Diestro';registro.diestro=sumaE18;}else{if(sumaE18>=19&&sumaE18<=31){desc_E18='Vulnerable';registro.vulnerable=sumaE18;}else{desc_E18='Cautela';registro.cautela=sumaE18;}}};registro.variable='Salud general';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,39,desc_E18);doc.text(150,39,'|');doc.text(185,39,'|');doc.line(43,40,117,40);doc.text(5,43,'|');doc.text(7,43,'');doc.text(43,43,'|');doc.text(48,43,'8');doc.text(59,43,'|');doc.text(63,43,'18');doc.text(75,43,'|');doc.text(80,43,'31');doc.text(98,43,'|');doc.text(103,43,'96');doc.text(116,43,'|');doc.text(130,43,'|');doc.text(150,43,'|');doc.text(185,43,'|');doc.line(5,44,151,44);//? .....................................................................................................................................
//? ESCALA 19: CALIDAD DE VIDA
doc.text(5,47,'|');doc.text(7,47,'Calidad de Vida');doc.text(43,47,'|');doc.text(48,47,'33');doc.text(59,47,'|');doc.text(63,47,'26');doc.text(75,47,'|');doc.text(80,47,'21');doc.text(98,47,'|');doc.text(103,47,'16');doc.text(116,47,'|');var sumaE19=0;var pg230=parseInt(this.eval_aedp.pg230);var pg231=parseInt(this.eval_aedp.pg231);var pg232=parseInt(this.eval_aedp.pg232);var pg233=parseInt(this.eval_aedp.pg233);var pg234=parseInt(this.eval_aedp.pg234);var pg235=parseInt(this.eval_aedp.pg235);var pg236=parseInt(this.eval_aedp.pg236);var pg237=parseInt(this.eval_aedp.pg237);var pg238=parseInt(this.eval_aedp.pg238);var pg239=parseInt(this.eval_aedp.pg239);var pg240=parseInt(this.eval_aedp.pg240);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE19=pg230+pg231+pg232+pg233+pg234+pg235+pg236+pg237+pg238+pg239+pg240;var st_sumaE19=sumaE19.toString();doc.text(119,47,st_sumaE19);doc.text(130,47,'|');var desc_E19='';if(sumaE19>=27&&sumaE19<=33){desc_E19='Óptimo';registro.optimo=sumaE19;}else{if(sumaE19>=22&&sumaE19<=26){desc_E19='Diestro';registro.diestro=sumaE19;}else{if(sumaE19>=17&&sumaE19<=21){desc_E19='Vulnerable';registro.vulnerable=sumaE19;}else{desc_E19='Cautela';registro.cautela=sumaE19;}}};registro.variable='Calidad de vida';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,47,desc_E19);doc.text(150,47,'|');doc.text(185,47,'|');doc.line(43,48,117,48);doc.text(5,51,'|');doc.text(7,51,'');doc.text(43,51,'|');doc.text(48,51,'27');doc.text(59,51,'|');doc.text(63,51,'22');doc.text(75,51,'|');doc.text(80,51,'17');doc.text(98,51,'|');doc.text(103,51,'0');doc.text(116,51,'|');doc.text(130,51,'|');doc.text(150,51,'|');doc.text(185,51,'|');doc.line(5,52,151,52);//? .....................................................................................................................................
//? ESCALA 20: COCIENTE DE RELACIONES
doc.text(5,55,'|');doc.text(7,55,'Cociente de');doc.text(43,55,'|');doc.text(48,55,'21');doc.text(59,55,'|');doc.text(63,55,'19');doc.text(75,55,'|');doc.text(80,55,'16');doc.text(98,55,'|');doc.text(103,55,'13');doc.text(116,55,'|');var sumaE20=0;var pg241=parseInt(this.eval_aedp.pg241);var pg242=parseInt(this.eval_aedp.pg242);var pg243=parseInt(this.eval_aedp.pg243);var pg244=parseInt(this.eval_aedp.pg244);var pg245=parseInt(this.eval_aedp.pg245);var pg246=parseInt(this.eval_aedp.pg246);var pg247=parseInt(this.eval_aedp.pg247);// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE20=pg241+pg242+pg243+pg244+pg245+pg246+pg247;var st_sumaE20=sumaE20.toString();doc.text(119,55,st_sumaE20);doc.text(130,55,'|');var desc_E20='';if(sumaE20>=20&&sumaE20<=21){desc_E20='Óptimo';registro.optimo=sumaE20;}else{if(sumaE20>=17&&sumaE20<=19){desc_E20='Diestro';registro.diestro=sumaE20;}else{if(sumaE20>=14&&sumaE20<=16){desc_E20='Vulnerable';registro.vulnerable=sumaE20;}else{desc_E20='Cautela';registro.cautela=sumaE20;}}};registro.variable='Cociente de relaciones';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,55,desc_E20);doc.text(150,55,'|');doc.text(185,55,'|');doc.line(43,56,117,56);doc.text(5,59,'|');doc.text(7,59,'relaciones');doc.text(43,59,'|');doc.text(48,59,'20');doc.text(59,59,'|');doc.text(63,59,'17');doc.text(75,59,'|');doc.text(80,59,'14');doc.text(98,59,'|');doc.text(103,59,'0');doc.text(116,59,'|');doc.text(130,59,'|');doc.text(150,59,'|');doc.text(185,59,'|');doc.line(5,60,151,60);//? .....................................................................................................................................
//? ESCALA 21: OPTIMO RENDIMIENTO
doc.text(5,63,'|');doc.text(7,63,'Óptimo');doc.text(43,63,'|');doc.text(48,63,'21');doc.text(59,63,'|');doc.text(63,63,'19');doc.text(75,63,'|');doc.text(80,63,'16');doc.text(98,63,'|');doc.text(103,63,'12');doc.text(116,63,'|');var sumaE21=0;var pg248=parseInt(this.eval_aedp.pg248);var pg249=parseInt(this.eval_aedp.pg249);var pg250=parseInt(this.eval_aedp.pg250);var pg251=parseInt(this.eval_aedp.pg251);var pg252=parseInt(this.eval_aedp.pg252);var pg253=parseInt(this.eval_aedp.pg253);var pg254=parseInt(this.eval_aedp.pg254);;// console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
sumaE21=pg248+pg249+pg250+pg251+pg252+pg253+pg254;var st_sumaE21=sumaE21.toString();doc.text(119,63,st_sumaE21);doc.text(130,63,'|');var desc_E21='';if(sumaE21>=20&&sumaE21<=21){desc_E21='Óptimo';registro.optimo=sumaE21;}else{if(sumaE21>=17&&sumaE21<=19){desc_E21='Diestro';registro.diestro=sumaE21;}else{if(sumaE21>=13&&sumaE21<=16){desc_E21='Vulnerable';registro.vulnerable=sumaE21;}else{desc_E21='Cautela';registro.cautela=sumaE21;}}};registro.variable='Optimo rendimiento';this.json_data.push(registro);registro={variable:'',cautela:"",vulnerable:"",diestro:"",optimo:""};doc.text(133,63,desc_E21);doc.text(150,63,'|');doc.text(185,63,'|');doc.line(43,64,117,64);doc.text(5,67,'|');doc.text(7,67,'rendimiento');doc.text(43,67,'|');doc.text(48,67,'20');doc.text(59,67,'|');doc.text(63,67,'17');doc.text(75,67,'|');doc.text(80,67,'13');doc.text(98,67,'|');doc.text(103,67,'0');doc.text(116,67,'|');doc.text(130,67,'|');doc.text(150,67,'|');doc.text(185,67,'|');doc.line(5,68,207,68);},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
crearPDF_Tipolo:function crearPDF_Tipolo(){/** CREACION DEL ARCHIVO PDF */var cadena=this.eval_tipolo.nombre,patron=/ /g,nuevoValor="",nusuario=cadena.replace(patron,nuevoValor);var nArchivo="TipoPer_"+nusuario;console.log("archivo a crear ? ",nArchivo);var imagen="data:image/jpeg;base64,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";var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a('portrait');var linea=5;/** Muestra el logo.        (izq, top, ancho, alto) */doc.addImage(imagen,'JPEG',155,linea,50,20);/** fila, columna *//** CIRCULOS  */doc.setLineWidth(1);// Grosor de la línea del borde
doc.setDrawColor(0);/** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */var meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var lhoy=new Date();//lhoy=   lhoy.toString();
var ldia=lhoy.getDate();var lmes=meses[lhoy.getMonth()];var lanio=lhoy.getFullYear();// console.log("lhoy ? ",lhoy);
// console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
doc.setFontSize(9);doc.text(10,20,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);doc.text(10,30,"Evaluación TIPO DE PERSONALIDAD para "+this.eval_tipolo.nombre+" de "+this.eval_tipolo.empresa);this.respuestasTipolo(doc);this.losresultadosTipolo(doc);this.latipologia(doc);doc.save(nArchivo);doc.autoPrint();window.open(doc.output('bloburl'),'_blank');},latipologia:function latipologia(doc){this.res.par1iguales=false;this.res.par2iguales=false;this.res.par3iguales=false;this.res.par4iguales=false;this.res.topologiaEI1="";this.res.topologiaSN1="";this.res.topologiaTF1="";this.res.topologiaJP1="";console.log("** resultados");console.log("E ? ",this.res.E,"; I ? ",this.res.I,"; par1iguales ? ",this.res.par1iguales,"; topologiaEI ? ",this.res.topologiaEI1);/* E > I, I > E, I = E */if(this.res.E>this.res.I){this.res.topologiaEI1="E -";}else if(this.res.I>this.res.E){this.res.topologiaEI1="I -";}else{this.res.par1iguales=true;this.res.topologiaEI1="E -";}console.log("E ? ",this.res.E,"; I ? ",this.res.I,"; par1iguales ? ",this.res.par1iguales,"; topologiaEI ? ",this.res.topologiaEI1);console.log("-------------------------------------------------------");/* S > N, N > S, S = N */console.log("S ? ",this.res.S,"; N ? ",this.res.N,"; par2iguales ? ",this.res.par2iguales,"; topologiaSN ? ",this.res.topologiaSN1);if(this.res.S>this.res.N){this.res.topologiaSN1="S -";}else if(this.res.N>this.res.S){this.res.topologiaSN1="N -";}else{this.res.par2iguales=true;this.res.topologiaSN1="S -";}console.log("S ? ",this.res.S,"; N ? ",this.res.N,"; par2iguales ? ",this.res.par2iguales,"; topologiaSN ? ",this.res.topologiaSN1);console.log("-------------------------------------------------------");/* T > F, F > T, T = F */console.log("T ? ",this.res.T,"; F ? ",this.res.F,"; par3iguales ? ",this.res.par3iguales,"; topologiaTF ? ",this.res.topologiaTF1);if(this.res.T>this.res.F){this.res.topologiaTF1="T -";}else if(this.res.F>this.res.T){this.res.topologiaTF1="F -";}else{this.res.par3iguales=true;this.res.topologiaTF1="T -";}console.log("T ? ",this.res.T,"; F ? ",this.res.F,"; par3iguales ? ",this.res.par3iguales,"; topologiaTF ? ",this.res.topologiaTF1);console.log("-------------------------------------------------------");/* J > P, P > J, J = P */console.log("J ? ",this.res.J,"; P ? ",this.res.P,"; par4iguales ? ",this.res.par4iguales,"; topologiaJP ? ",this.res.topologiaJP1);if(this.res.J>this.res.P){this.res.topologiaJP1="J -";}else if(this.res.P>this.res.J){this.res.topologiaJP1="P -";}else{this.res.par4iguales=true;this.res.topologiaJP1="J -";}console.log("J ? ",this.res.J,"; P ? ",this.res.P,"; par4iguales ? ",this.res.par4iguales,"; topologiaJP ? ",this.res.topologiaJP1);console.log("-------------------------------------------------------");this.res.topologia1="";this.res.topologia2="";this.res.topologia3="";this.res.topologia4="";this.res.topologia5="";this.res.topologia6="";this.res.topologia7="";this.res.topologia8="";this.res.topologia9="";this.res.topologia10="";this.res.topologia11="";this.res.topologia12="";this.res.topologia13="";this.res.topologia14="";this.res.topologia15="";this.res.topologia16="";/* Evalua cómo están los pares *//* Caso 1: Todos los pares diferentes */if(this.res.par1iguales===false&&this.res.par2iguales===false&&this.res.par3iguales===false&&this.res.par4iguales===false){this.res.topologia1=this.res.topologiaEI1+this.res.topologiaSN1+this.res.topologiaTF1+this.res.topologiaJP1;this.res.topologia="CASO ESPERADO: todos los pares tienen valores diferentes.";}else{/* Acá tengo los 15 casos restantes *//* ================================ *//* Caso 2: que el primer par (E,I) sea igual */if(this.res.par1iguales===true&&this.res.par2iguales===false&&this.res.par3iguales===false&&this.res.par4iguales===false){this.res.topologia1='E -'+this.res.topologiaSN1+this.res.topologiaTF1+this.res.topologiaJP1;this.res.topologia2='I -'+this.res.topologiaSN1+this.res.topologiaTF1+this.res.topologiaJP1;}/* Caso 3: que el primero y segundo par (E,I) & (S,N) sean iguales */if(this.res.par1iguales===true&&this.res.par2iguales===true&&this.res.par3iguales===false&&this.res.par4iguales===false){this.res.topologia1='E -'+'S -'+this.res.topologiaTF1+this.res.topologiaJP1;this.res.topologia2='I -'+'S -'+this.res.topologiaTF1+this.res.topologiaJP1;this.res.topologia3='E -'+'N -'+this.res.topologiaTF1+this.res.topologiaJP1;this.res.topologia4='I -'+'N -'+this.res.topologiaTF1+this.res.topologiaJP1;}/* Caso 4: que el primero y tercer par (E,I) && (T,F) sean iguales */if(this.res.par1iguales===true&&this.res.par2iguales===false&&this.res.par3iguales===true&&this.res.par4iguales===false){this.res.topologia1='E -'+this.res.topologiaSN1+'T -'+this.res.topologiaJP1;this.res.topologia2='I -'+this.res.topologiaSN1+'T -'+this.res.topologiaJP1;this.res.topologia3='E -'+this.res.topologiaSN1+'F -'+this.res.topologiaJP1;this.res.topologia4='I -'+this.res.topologiaSN1+'F -'+this.res.topologiaJP1;}/* Caso 5: que el primero y cuarto par (E,I) && (J,P) sean iguales */if(this.res.par1iguales===true&&this.res.par2iguales===false&&this.res.par3iguales===false&&this.res.par4iguales===true){this.res.topologia1='E -'+this.res.topologiaSN1+this.res.topologiaTF1+'J';this.res.topologia2='I -'+this.res.topologiaSN1+this.res.topologiaTF1+'J';this.res.topologia3='E -'+this.res.topologiaSN1+this.res.topologiaTF1+'P';this.res.topologia4='I -'+this.res.topologiaSN1+this.res.topologiaTF1+'P';}/* Caso 6: que solo el SEGUNDO (S,N) sean iguales */if(this.res.par1iguales===false&&this.res.par2iguales===true&&this.res.par3iguales===false&&this.res.par4iguales===false){this.res.topologia1=this.res.topologiaEI1+'S -'+this.res.topologiaTF1+this.res.topologiaJP1;this.res.topologia2=this.res.topologiaEI1+'N -'+this.res.topologiaTF1+this.res.topologiaJP1;}/* Caso 7: que el segundo (S,N) y el tercero (T,F) sean iguales */if(this.res.par1iguales===false&&this.res.par2iguales===true&&this.res.par3iguales===true&&this.res.par4iguales===false){this.res.topologia1=this.res.topologiaEI1+'S -'+'T -'+this.res.topologiaJP1;this.res.topologia2=this.res.topologiaEI1+'N -'+'T -'+this.res.topologiaJP1;this.res.topologia3=this.res.topologiaEI1+'S -'+'F -'+this.res.topologiaJP1;this.res.topologia4=this.res.topologiaEI1+'N -'+'F -'+this.res.topologiaJP1;}/* Caso 8: que el SEGUNDO (S,N) y el cuarto (J,P) sean iguales */if(this.res.par1iguales===false&&this.res.par2iguales===true&&this.res.par3iguales===false&&this.res.par4iguales===true){this.res.topologia1=this.res.topologiaEI1+'S -'+this.res.topologiaTF1+'J';this.res.topologia2=this.res.topologiaEI1+'N -'+this.res.topologiaTF1+'J';this.res.topologia3=this.res.topologiaEI1+'S -'+this.res.topologiaTF1+'P';this.res.topologia4=this.res.topologiaEI1+'N -'+this.res.topologiaTF1+'P';}/* Caso 9: que solo el TERCER (T,F) sean iguales */if(this.res.par1iguales===false&&this.res.par2iguales===false&&this.res.par3iguales===true&&this.res.par4iguales===false){this.res.topologia1=this.res.topologiaEI1+this.res.topologiaSN1+'T -'+this.res.topologiaJP1;this.res.topologia2=this.res.topologiaEI1+this.res.topologiaSN1+'F -'+this.res.topologiaJP1;}/* Caso 10: primero (E,I) y tercero (T,F) sean iguales  */if(this.res.par1iguales===false&&this.res.par2iguales===false&&this.res.par3iguales===true&&this.res.par4iguales===true){/*  ESTE DEBE SER */this.res.topologia1=this.res.topologiaEI1+this.res.topologiaSN1+'T -'+'J';this.res.topologia2=this.res.topologiaEI1+this.res.topologiaSN1+'F -'+'J';this.res.topologia3=this.res.topologiaEI1+this.res.topologiaSN1+'T -'+'P';this.res.topologia4=this.res.topologiaEI1+this.res.topologiaSN1+'F -'+'P';}/* Caso 11: solo el ultimo (J,P) es iguale */if(this.res.par1iguales===false&&this.res.par2iguales===false&&this.res.par3iguales===false&&this.res.par4iguales===true){this.res.topologia1=this.res.topologiaEI1+this.res.topologiaSN1+this.res.topologiaTF1+'J';this.res.topologia2=this.res.topologiaEI1+this.res.topologiaSN1+this.res.topologiaTF1+'P';}/* Caso 12: solo el cuarto es DIFERENTE  */if(this.res.par1iguales===true&&this.res.par2iguales===true&&this.res.par3iguales===true&&this.res.par4iguales===false){this.res.topologia1='E -'+'S -'+'T -'+this.res.topologiaJP1;this.res.topologia2='I -'+'S -'+'T -'+this.res.topologiaJP1;this.res.topologia3='E -'+'S -'+'F -'+this.res.topologiaJP1;this.res.topologia4='I -'+'S -'+'F -'+this.res.topologiaJP1;this.res.topologia5='E -'+'N -'+'T -'+this.res.topologiaJP1;this.res.topologia6='I -'+'N -'+'T -'+this.res.topologiaJP1;this.res.topologia7='E -'+'N -'+'F -'+this.res.topologiaJP1;this.res.topologia8='I -'+'N -'+'F -'+this.res.topologiaJP1;}/* Caso 13: solo el tercero es DIFERENTE  */if(this.res.par1iguales===true&&this.res.par2iguales===true&&this.res.par3iguales===false&&this.res.par4iguales===true){this.res.topologia1='E -'+'S -'+this.res.topologiaTF1+'J';this.res.topologia2='I -'+'S -'+this.res.topologiaTF1+'J';this.res.topologia3='E -'+'S -'+this.res.topologiaTF1+'P';this.res.topologia4='I -'+'S -'+this.res.topologiaTF1+'P';this.res.topologia5='E -'+'N -'+this.res.topologiaTF1+'J';this.res.topologia6='I -'+'N -'+this.res.topologiaTF1+'J';this.res.topologia7='E -'+'N -'+this.res.topologiaTF1+'P';this.res.topologia8='I -'+'N -'+this.res.topologiaTF1+'P';}/* Caso 14: solo el segundo es DIFERENTE  */if(this.res.par1iguales===true&&this.res.par2iguales===false&&this.res.par3iguales===true&&this.res.par4iguales===true){this.res.topologia1='E -'+this.res.topologiaSN1+'T -'+'J';this.res.topologia2='I -'+this.res.topologiaSN1+'T -'+'J';this.res.topologia3='E -'+this.res.topologiaSN1+'T -'+'P';this.res.topologia4='I -'+this.res.topologiaSN1+'T -'+'P';this.res.topologia5='E -'+this.res.topologiaSN1+'F -'+'J';this.res.topologia6='I -'+this.res.topologiaSN1+'F -'+'J';this.res.topologia7='E -'+this.res.topologiaSN1+'F -'+'P';this.res.topologia8='I -'+this.res.topologiaSN1+'F -'+'P';}/* Caso 15: solo el primero es DIFERENTE  */if(this.res.par1iguales===true&&this.res.par2iguales===false&&this.res.par3iguales===true&&this.res.par4iguales===true){this.res.topologia1=this.res.topologiaEI1+'S -'+'T -'+'J';this.res.topologia2=this.res.topologiaEI1+'N -'+'T -'+'J';this.res.topologia3=this.res.topologiaEI1+'S -'+'T -'+'P';this.res.topologia4=this.res.topologiaEI1+'N -'+'T -'+'P';this.res.topologia5=this.res.topologiaEI1+'S -'+'F -'+'J';this.res.topologia6=this.res.topologiaEI1+'N -'+'F -'+'J';this.res.topologia7=this.res.topologiaEI1+'S -'+'F -'+'P';this.res.topologia8=this.res.topologiaEI1+'N -'+'F -'+'P';}/* Caso 16: solo el primero es DIFERENTE  */if(this.res.par1iguales===true&&this.res.par2iguales===true&&this.res.par3iguales===true&&this.res.par4iguales===true){this.res.topologia1='E -'+'S -'+'T -'+'J';this.res.topologia2='E -'+'S -'+'T -'+'P';this.res.topologia3='E -'+'S -'+'F -'+'J';this.res.topologia4='E -'+'S -'+'F -'+'P';this.res.topologia5='E -'+'N -'+'T -'+'J';this.res.topologia6='E -'+'N -'+'T -'+'P';this.res.topologia7='E -'+'S -'+'F -'+'J';this.res.topologia8='E -'+'N -'+'F -'+'J';this.res.topologia9='I -'+'S -'+'T -'+'J';this.res.topologia10='I -'+'S -'+'T -'+'P';this.res.topologia11='I -'+'S -'+'F -'+'J';this.res.topologia12='I -'+'S -'+'F -'+'P';this.res.topologia13='I -'+'N -'+'T -'+'J';this.res.topologia14='I -'+'N -'+'T -'+'P';this.res.topologia15='I -'+'S -'+'F -'+'J';this.res.topologia16='I -'+'N -'+'F -'+'J';}}this.res.topologia="CASO ESPECIAL: Por lo menos un par tiene valores diferentes.";/* Muestra las preguntas *//* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */doc.setLineWidth(0.25);doc.text(10,136,"SECCION DE TOPOLOGIA "+this.res.topologia);doc.line(10,138,206,138);doc.text(10,142," ( "+this.res.par1iguales+" , "+this.res.par2iguales+" , "+this.res.par3iguales+" , "+this.res.par4iguales+" ) ");doc.text(10,146,"* "+this.res.topologia1);doc.text(10,150,"* "+this.res.topologia2);doc.text(10,154,"* "+this.res.topologia3);doc.text(10,158,"* "+this.res.topologia4);doc.text(10,162,"* "+this.res.topologia5);doc.text(10,166,"* "+this.res.topologia6);doc.text(10,170,"* "+this.res.topologia7);doc.text(10,174,"* "+this.res.topologia8);doc.text(10,178,"* "+this.res.topologia9);doc.text(10,182,"* "+this.res.topologia10);doc.text(10,186,"* "+this.res.topologia11);doc.text(10,190,"* "+this.res.topologia12);doc.text(10,194,"* "+this.res.topologia13);doc.text(10,198,"* "+this.res.topologia14);doc.text(10,202,"* "+this.res.topologia15);doc.text(10,206,"* "+this.res.topologia16);},losresultadosTipolo:function losresultadosTipolo(doc){/* Columnas E & I */this.res.E=0;this.res.I=0;if(this.eval_tipolo.pg001==="1"){this.res.E=this.res.E+1;}else{this.res.I=this.res.I+1;}if(this.eval_tipolo.pg008==="1"){this.res.E=this.res.E+1;}else{this.res.I=this.res.I+1;}if(this.eval_tipolo.pg015==="1"){this.res.E=this.res.E+1;}else{this.res.I=this.res.I+1;}if(this.eval_tipolo.pg022==="1"){this.res.E=this.res.E+1;}else{this.res.I=this.res.I+1;}if(this.eval_tipolo.pg029==="1"){this.res.E=this.res.E+1;}else{this.res.I=this.res.I+1;}if(this.eval_tipolo.pg036==="1"){this.res.E=this.res.E+1;}else{this.res.I=this.res.I+1;}if(this.eval_tipolo.pg043==="1"){this.res.E=this.res.E+1;}else{this.res.I=this.res.I+1;}if(this.eval_tipolo.pg050==="1"){this.res.E=this.res.E+1;}else{this.res.I=this.res.I+1;}if(this.eval_tipolo.pg057==="1"){this.res.E=this.res.E+1;}else{this.res.I=this.res.I+1;}if(this.eval_tipolo.pg064==="1"){this.res.E=this.res.E+1;}else{this.res.I=this.res.I+1;}/* Columnas intermedias entre (E - I) y (*S - N) 
                    ( a1= ncol11, b2= ncol12 ) */this.res.a1=0;this.res.b2=0;// 10 preguntas 
if(this.eval_tipolo.pg002==="1"){this.res.a1=this.res.a1+1;}else{this.res.b2=this.res.b2+1;}if(this.eval_tipolo.pg009==="1"){this.res.a1=this.res.a1+1;}else{this.res.b2=this.res.b2+1;}if(this.eval_tipolo.pg016==="1"){this.res.a1=this.res.a1+1;}else{this.res.b2=this.res.b2+1;}if(this.eval_tipolo.pg023==="1"){this.res.a1=this.res.a1+1;}else{this.res.b2=this.res.b2+1;}if(this.eval_tipolo.pg030==="1"){this.res.a1=this.res.a1+1;}else{this.res.b2=this.res.b2+1;}if(this.eval_tipolo.pg037==="1"){this.res.a1=this.res.a1+1;}else{this.res.b2=this.res.b2+1;}if(this.eval_tipolo.pg044==="1"){this.res.a1=this.res.a1+1;}else{this.res.b2=this.res.b2+1;}if(this.eval_tipolo.pg051==="1"){this.res.a1=this.res.a1+1;}else{this.res.b2=this.res.b2+1;}if(this.eval_tipolo.pg058==="1"){this.res.a1=this.res.a1+1;}else{this.res.b2=this.res.b2+1;}if(this.eval_tipolo.pg065==="1"){this.res.a1=this.res.a1+1;}else{this.res.b2=this.res.b2+1;}/* Columnas T & F 
                   a3= ncol3, b4= ncol4  */this.res.a3=0;this.res.b4=0;// 10 preguntas
if(this.eval_tipolo.pg003==="1"){this.res.a3=this.res.a3+1;}else{this.res.b4=this.res.b4+1;}if(this.eval_tipolo.pg010==="1"){this.res.a3=this.res.a3+1;}else{this.res.b4=this.res.b4+1;}if(this.eval_tipolo.pg017==="1"){this.res.a3=this.res.a3+1;}else{this.res.b4=this.res.b4+1;}if(this.eval_tipolo.pg024==="1"){this.res.a3=this.res.a3+1;}else{this.res.b4=this.res.b4+1;}if(this.eval_tipolo.pg031==="1"){this.res.a3=this.res.a3+1;}else{this.res.b4=this.res.b4+1;}if(this.eval_tipolo.pg038==="1"){this.res.a3=this.res.a3+1;}else{this.res.b4=this.res.b4+1;}if(this.eval_tipolo.pg045==="1"){this.res.a3=this.res.a3+1;}else{this.res.b4=this.res.b4+1;}if(this.eval_tipolo.pg052==="1"){this.res.a3=this.res.a3+1;}else{this.res.b4=this.res.b4+1;}if(this.eval_tipolo.pg059==="1"){this.res.a3=this.res.a3+1;}else{this.res.b4=this.res.b4+1;}if(this.eval_tipolo.pg066==="1"){this.res.a3=this.res.a3+1;}else{this.res.b4=this.res.b4+1;}/* Columnas intermedias entre (S - N) y (*T - F) 
                    a5= ncol5, b6= ncol6 */this.res.a5=0;this.res.b6=0;// 10 preguntas
if(this.eval_tipolo.pg004==="1"){this.res.a5=this.res.a5+1;}else{this.res.b6=this.res.b6+1;}if(this.eval_tipolo.pg011==="1"){this.res.a5=this.res.a5+1;}else{this.res.b6=this.res.b6+1;}if(this.eval_tipolo.pg018==="1"){this.res.a5=this.res.a5+1;}else{this.res.b6=this.res.b6+1;}if(this.eval_tipolo.pg025==="1"){this.res.a5=this.res.a5+1;}else{this.res.b6=this.res.b6+1;}if(this.eval_tipolo.pg032==="1"){this.res.a5=this.res.a5+1;}else{this.res.b6=this.res.b6+1;}if(this.eval_tipolo.pg039==="1"){this.res.a5=this.res.a5+1;}else{this.res.b6=this.res.b6+1;}if(this.eval_tipolo.pg046==="1"){this.res.a5=this.res.a5+1;}else{this.res.b6=this.res.b6+1;}if(this.eval_tipolo.pg053==="1"){this.res.a5=this.res.a5+1;}else{this.res.b6=this.res.b6+1;}if(this.eval_tipolo.pg060==="1"){this.res.a5=this.res.a5+1;}else{this.res.b6=this.res.b6+1;}if(this.eval_tipolo.pg067==="1"){this.res.a5=this.res.a5+1;}else{this.res.b6=this.res.b6+1;}/* Columnas T & F 
                    a7= ncol7, b8= ncol8 */this.res.a7=0;this.res.b8=0;// 10 preguntas
if(this.eval_tipolo.pg005==="1"){this.res.a7=this.res.a7+1;}else{this.res.b8=this.res.b8+1;}if(this.eval_tipolo.pg012==="1"){this.res.a7=this.res.a7+1;}else{this.res.b8=this.res.b8+1;}if(this.eval_tipolo.pg019==="1"){this.res.a7=this.res.a7+1;}else{this.res.b8=this.res.b8+1;}if(this.eval_tipolo.pg026==="1"){this.res.a7=this.res.a7+1;}else{this.res.b8=this.res.b8+1;}if(this.eval_tipolo.pg033==="1"){this.res.a7=this.res.a7+1;}else{this.res.b8=this.res.b8+1;}if(this.eval_tipolo.pg040==="1"){this.res.a7=this.res.a7+1;}else{this.res.b8=this.res.b8+1;}if(this.eval_tipolo.pg047==="1"){this.res.a7=this.res.a7+1;}else{this.res.b8=this.res.b8+1;}if(this.eval_tipolo.pg054==="1"){this.res.a7=this.res.a7+1;}else{this.res.b8=this.res.b8+1;}if(this.eval_tipolo.pg061==="1"){this.res.a7=this.res.a7+1;}else{this.res.b8=this.res.b8+1;}if(this.eval_tipolo.pg068==="1"){this.res.a7=this.res.a7+1;}else{this.res.b8=this.res.b8+1;}/* Columnas intermedias entre (T - F) y (*J - P) 
                    a9= ncol9, b10= ncol10 */this.res.a9=0;this.res.b10=0;// 10 preguntas !
if(this.eval_tipolo.pg006==="1"){this.res.a9=this.res.a9+1;}else{this.res.b10=this.res.b10+1;}if(this.eval_tipolo.pg013==="1"){this.res.a9=this.res.a9+1;}else{this.res.b10=this.res.b10+1;}if(this.eval_tipolo.pg020==="1"){this.res.a9=this.res.a9+1;}else{this.res.b10=this.res.b10+1;}if(this.eval_tipolo.pg027==="1"){this.res.a9=this.res.a9+1;}else{this.res.b10=this.res.b10+1;}if(this.eval_tipolo.pg034==="1"){this.res.a9=this.res.a9+1;}else{this.res.b10=this.res.b10+1;}if(this.eval_tipolo.pg041==="1"){this.res.a9=this.res.a9+1;}else{this.res.b10=this.res.b10+1;}if(this.eval_tipolo.pg048==="1"){this.res.a9=this.res.a9+1;}else{this.res.b10=this.res.b10+1;}if(this.eval_tipolo.pg055==="1"){this.res.a9=this.res.a9+1;}else{this.res.b10=this.res.b10+1;}if(this.eval_tipolo.pg062==="1"){this.res.a9=this.res.a9+1;}else{this.res.b10=this.res.b10+1;}if(this.eval_tipolo.pg069==="1"){this.res.a9=this.res.a9+1;}else{this.res.b10=this.res.b10+1;}/* Columnas intermedias entre (T - F) y (*J - P) 
                    a11= ncol11, b12= ncol12 */this.res.a11=0;this.res.b12=0;// 10 preguntas
if(this.eval_tipolo.pg007==="1"){this.res.a11=this.res.a11+1;}else{this.res.b12=this.res.b12+1;}if(this.eval_tipolo.pg014==="1"){this.res.a11=this.res.a11+1;}else{this.res.b12=this.res.b12+1;}if(this.eval_tipolo.pg021==="1"){this.res.a11=this.res.a11+1;}else{this.res.b12=this.res.b12+1;}if(this.eval_tipolo.pg028==="1"){this.res.a11=this.res.a11+1;}else{this.res.b12=this.res.b12+1;}if(this.eval_tipolo.pg035==="1"){this.res.a11=this.res.a11+1;}else{this.res.b12=this.res.b12+1;}if(this.eval_tipolo.pg042==="1"){this.res.a11=this.res.a11+1;}else{this.res.b12=this.res.b12+1;}if(this.eval_tipolo.pg049==="1"){this.res.a11=this.res.a11+1;}else{this.res.b12=this.res.b12+1;}if(this.eval_tipolo.pg056==="1"){this.res.a11=this.res.a11+1;}else{this.res.b12=this.res.b12+1;}if(this.eval_tipolo.pg063==="1"){this.res.a11=this.res.a11+1;}else{this.res.b12=this.res.b12+1;}if(this.eval_tipolo.pg070==="1"){this.res.a11=this.res.a11+1;}else{this.res.b12=this.res.b12+1;}// $scope.ncolS = $scope.ncol1 + $scope.ncol3;
// $scope.ncolN = $scope.ncol2 + $scope.ncol4;
// let S = 0; let N = 0; 
this.res.S=0;this.res.N=0;// 10 preguntas
this.res.S=this.res.a1+this.res.a3;this.res.N=this.res.b2+this.res.b4;// $scope.ncolT = $scope.ncol5 + $scope.ncol7;
// $scope.ncolF = $scope.ncol6 + $scope.ncol8;
// let T = 0; let F = 0; 
this.res.T=0;this.res.F=0;// 10 preguntas
this.res.T=this.res.a5+this.res.a7;this.res.F=this.res.b6+this.res.b8;// $scope.ncolJ = $scope.ncol9 + $scope.ncol11;
// $scope.ncolP = $scope.ncol10 + $scope.ncol12;
// let J = 0; let P = 0; 
this.res.J=0;this.res.P=0;// 10 preguntas
this.res.J=this.res.a9+this.res.a11;this.res.P=this.res.b10+this.res.b12;/* Muestra las preguntas *//* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */doc.setLineWidth(0.25);doc.text(10,70,"SECCION DE RESULTADOS ");doc.line(10,72,206,72);doc.text(10,76,"a1 ( "+this.res.a1+" , "+this.res.b2+" ) b2");doc.text(10,81,"a5 ( "+this.res.a5+" , "+this.res.b6+" ) b6");doc.text(10,86,"a9 ( "+this.res.a9+" , "+this.res.b10+" ) b10");doc.text(10,90,"");doc.text(10,94,"a3 ( "+this.res.a3+" , "+this.res.b4+" ) b4");doc.text(10,99,"a7 ( "+this.res.a7+" , "+this.res.b8+" ) b8");doc.text(10,104,"a11 ( "+this.res.a11+" , "+this.res.b12+" ) b12");doc.text(10,108,"");doc.text(10,113,"E  ( "+this.res.E+" , "+this.res.I+" ) I");doc.text(10,118,"S  ( "+this.res.S+" , "+this.res.N+" ) N");doc.text(10,123,"T  ( "+this.res.T+" , "+this.res.F+" ) F");doc.text(10,128,"J  ( "+this.res.J+" , "+this.res.P+" ) P");},respuestasTipolo:function respuestasTipolo(doc){/* Muestra las preguntas *//* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */doc.setLineWidth(0.25);doc.text(10,40,"SECCION DE RESPUESTAS ");doc.line(10,42,206,42);doc.text(10,45,this.eval_tipolo.pg001==="1"?"| 01= (a)":"| 01= (b)");doc.text(23,45,this.eval_tipolo.pg002==="1"?"| 02= (a)":"| 02= (b)");doc.text(36,45,this.eval_tipolo.pg003==="1"?"| 03= (a)":"| 03= (b)");doc.text(49,45,this.eval_tipolo.pg004==="1"?"| 04= (a)":"| 04= (b)");doc.text(62,45,this.eval_tipolo.pg005==="1"?"| 05= (a)":"| 05= (b)");doc.text(75,45,this.eval_tipolo.pg006==="1"?"| 06= (a)":"| 06= (b)");doc.text(88,45,this.eval_tipolo.pg007==="1"?"| 07= (a)":"| 07= (b)");doc.text(101,45,this.eval_tipolo.pg008==="1"?"| 08= (a)":"| 08= (b)");doc.text(114,45,this.eval_tipolo.pg009==="1"?"| 09= (a)":"| 09= (b)");doc.text(127,45,this.eval_tipolo.pg010==="1"?"| 10= (a)":"| 10= (b)");doc.text(140,45,this.eval_tipolo.pg011==="1"?"| 11= (a)":"| 11= (b)");doc.text(153,45,this.eval_tipolo.pg012==="1"?"| 12= (a)":"| 12= (b)");doc.text(166,45,this.eval_tipolo.pg013==="1"?"| 13= (a)":"| 13= (b)");doc.text(179,45,this.eval_tipolo.pg014==="1"?"| 14= (a)":"| 14= (b)");doc.text(192,45,this.eval_tipolo.pg015==="1"?"| 15= (a)":"| 15= (b) |");doc.line(10,46,206,46);doc.text(10,49,this.eval_tipolo.pg016==="1"?"| 16= (a)":"| 16= (b)");doc.text(23,49,this.eval_tipolo.pg017==="1"?"| 17= (a)":"| 17= (b)");doc.text(36,49,this.eval_tipolo.pg018==="1"?"| 18= (a)":"| 18= (b)");doc.text(49,49,this.eval_tipolo.pg019==="1"?"| 19= (a)":"| 19= (b)");doc.text(62,49,this.eval_tipolo.pg020==="1"?"| 20= (a)":"| 20= (b)");doc.text(75,49,this.eval_tipolo.pg021==="1"?"| 21= (a)":"| 21= (b)");doc.text(88,49,this.eval_tipolo.pg022==="1"?"| 22= (a)":"| 22= (b)");doc.text(101,49,this.eval_tipolo.pg023==="1"?"| 23= (a)":"| 23= (b)");doc.text(114,49,this.eval_tipolo.pg024==="1"?"| 24= (a)":"| 24= (b)");doc.text(127,49,this.eval_tipolo.pg025==="1"?"| 25= (a)":"| 25= (b)");doc.text(140,49,this.eval_tipolo.pg026==="1"?"| 26= (a)":"| 26= (b)");doc.text(153,49,this.eval_tipolo.pg027==="1"?"| 27= (a)":"| 27= (b)");doc.text(166,49,this.eval_tipolo.pg028==="1"?"| 28= (a)":"| 28= (b)");doc.text(179,49,this.eval_tipolo.pg029==="1"?"| 29= (a)":"| 29= (b)");doc.text(192,49,this.eval_tipolo.pg030==="1"?"| 30= (a)":"| 30= (b) |");doc.line(10,50,206,50);doc.text(10,53,this.eval_tipolo.pg031==="1"?"| 31= (a)":"| 31= (b)");doc.text(23,53,this.eval_tipolo.pg032==="1"?"| 32= (a)":"| 32= (b)");doc.text(36,53,this.eval_tipolo.pg033==="1"?"| 33= (a)":"| 33= (b)");doc.text(49,53,this.eval_tipolo.pg034==="1"?"| 34= (a)":"| 34= (b)");doc.text(62,53,this.eval_tipolo.pg035==="1"?"| 35= (a)":"| 35= (b)");doc.text(75,53,this.eval_tipolo.pg036==="1"?"| 36= (a)":"| 36= (b)");doc.text(88,53,this.eval_tipolo.pg037==="1"?"| 37= (a)":"| 37= (b)");doc.text(101,53,this.eval_tipolo.pg038==="1"?"| 38= (a)":"| 38= (b)");doc.text(114,53,this.eval_tipolo.pg039==="1"?"| 39= (a)":"| 39= (b)");doc.text(127,53,this.eval_tipolo.pg040==="1"?"| 40= (a)":"| 40= (b)");doc.text(140,53,this.eval_tipolo.pg041==="1"?"| 41= (a)":"| 41= (b)");doc.text(153,53,this.eval_tipolo.pg042==="1"?"| 42= (a)":"| 42= (b)");doc.text(166,53,this.eval_tipolo.pg043==="1"?"| 43= (a)":"| 43= (b)");doc.text(179,53,this.eval_tipolo.pg044==="1"?"| 44= (a)":"| 44= (b)");doc.text(192,53,this.eval_tipolo.pg045==="1"?"| 45= (a)":"| 45= (b) |");doc.line(10,54,206,54);doc.text(10,57,this.eval_tipolo.pg046==="1"?"| 46= (a)":"| 46= (b)");doc.text(23,57,this.eval_tipolo.pg047==="1"?"| 47= (a)":"| 47= (b)");doc.text(36,57,this.eval_tipolo.pg048==="1"?"| 48= (a)":"| 48= (b)");doc.text(49,57,this.eval_tipolo.pg049==="1"?"| 49= (a)":"| 49= (b)");doc.text(62,57,this.eval_tipolo.pg050==="1"?"| 50= (a)":"| 50= (b)");doc.text(75,57,this.eval_tipolo.pg051==="1"?"| 51= (a)":"| 51= (b)");doc.text(88,57,this.eval_tipolo.pg052==="1"?"| 52= (a)":"| 52= (b)");doc.text(101,57,this.eval_tipolo.pg053==="1"?"| 53= (a)":"| 53= (b)");doc.text(114,57,this.eval_tipolo.pg054==="1"?"| 54= (a)":"| 54= (b)");doc.text(127,57,this.eval_tipolo.pg055==="1"?"| 55= (a)":"| 55= (b)");doc.text(140,57,this.eval_tipolo.pg056==="1"?"| 56= (a)":"| 56= (b)");doc.text(153,57,this.eval_tipolo.pg057==="1"?"| 57= (a)":"| 57= (b)");doc.text(166,57,this.eval_tipolo.pg058==="1"?"| 58= (a)":"| 58= (b)");doc.text(179,57,this.eval_tipolo.pg059==="1"?"| 59= (a)":"| 59= (b)");doc.text(192,57,this.eval_tipolo.pg060==="1"?"| 60= (a)":"| 60= (b) |");doc.line(10,58,206,58);doc.text(10,61,this.eval_tipolo.pg061==="1"?"| 61= (a)":"| 61= (b)");doc.text(23,61,this.eval_tipolo.pg062==="1"?"| 62= (a)":"| 62= (b)");doc.text(36,61,this.eval_tipolo.pg063==="1"?"| 63= (a)":"| 63= (b)");doc.text(49,61,this.eval_tipolo.pg064==="1"?"| 64= (a)":"| 64= (b)");doc.text(62,61,this.eval_tipolo.pg065==="1"?"| 65= (a)":"| 65= (b)");doc.text(75,61,this.eval_tipolo.pg066==="1"?"| 66= (a)":"| 66= (b)");doc.text(88,61,this.eval_tipolo.pg067==="1"?"| 67= (a)":"| 67= (b)");doc.text(101,61,this.eval_tipolo.pg068==="1"?"| 68= (a)":"| 68= (b)");doc.text(114,61,this.eval_tipolo.pg069==="1"?"| 69= (a)":"| 69= (b)");doc.text(127,61,this.eval_tipolo.pg070==="1"?"| 70= (a)":"| 70= (b) |");doc.line(10,62,141,62);},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
crearPDF_16pf:function crearPDF_16pf(){/** CREACION DEL ARCHIVO PDF */var cadena=this.eval_16pf.nombre,patron=/ /g,nuevoValor="",nusuario=cadena.replace(patron,nuevoValor);var nArchivo="16pf_"+nusuario;console.log("archivo a crear ? ",nArchivo);var imagen="data:image/jpeg;base64,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";var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a('portrait');var linea=5;/** Muestra el logo.        (izq, top, ancho, alto) */doc.addImage(imagen,'JPEG',155,linea,50,20);/** fila, columna *//** CIRCULOS  */doc.setLineWidth(1);// Grosor de la línea del borde
doc.setDrawColor(0);/** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */var meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var lhoy=new Date();//lhoy=   lhoy.toString();
var ldia=lhoy.getDate();var lmes=meses[lhoy.getMonth()];var lanio=lhoy.getFullYear();// console.log("lhoy ? ",lhoy);
// console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
doc.setFontSize(9);doc.text(10,20,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);doc.text(10,30,"Evaluación FACTORES DE PERSONALIDAD para "+this.eval_16pf.nombre+" de "+this.eval_16pf.empresa);this.respuestas16pf(doc);this.resultados16pf(doc);doc.save(nArchivo);doc.autoPrint();window.open(doc.output('bloburl'),'_blank');},resultados16pf:function resultados16pf(doc){// this.res_16pf.resP = resultadosJ();   
// console.log("resultadosJ ? ", this.res_16pf.resP);
this.res_16pf.resA=-1;this.res_16pf.resP=this.resultadosH(this.eval_16pf.pg001,this.eval_16pf.pg018,this.eval_16pf.pg035,this.eval_16pf.pg052,this.eval_16pf.pg069,this.eval_16pf.pg086,'P');this.res_16pf.resA=this.resultadosH(this.eval_16pf.pg002,this.eval_16pf.pg019,this.eval_16pf.pg036,this.eval_16pf.pg053,this.eval_16pf.pg070,this.eval_16pf.pg087,'A');this.res_16pf.resB=this.resultadosH(this.eval_16pf.pg003,this.eval_16pf.pg020,this.eval_16pf.pg037,this.eval_16pf.pg054,this.eval_16pf.pg071,this.eval_16pf.pg088,'B');this.res_16pf.resC=this.resultadosH(this.eval_16pf.pg004,this.eval_16pf.pg021,this.eval_16pf.pg038,this.eval_16pf.pg055,this.eval_16pf.pg072,this.eval_16pf.pg089,'C');this.res_16pf.resE=this.resultadosH(this.eval_16pf.pg005,this.eval_16pf.pg022,this.eval_16pf.pg039,this.eval_16pf.pg056,this.eval_16pf.pg073,this.eval_16pf.pg090,'E');this.res_16pf.resF=this.resultadosH(this.eval_16pf.pg006,this.eval_16pf.pg023,this.eval_16pf.pg040,this.eval_16pf.pg057,this.eval_16pf.pg074,this.eval_16pf.pg091,'F');this.res_16pf.resG=this.resultadosH(this.eval_16pf.pg007,this.eval_16pf.pg024,this.eval_16pf.pg041,this.eval_16pf.pg058,this.eval_16pf.pg075,this.eval_16pf.pg092,'G');this.res_16pf.resH=this.resultadosH(this.eval_16pf.pg008,this.eval_16pf.pg025,this.eval_16pf.pg042,this.eval_16pf.pg059,this.eval_16pf.pg076,this.eval_16pf.pg093,'H');this.res_16pf.resI=this.resultadosH(this.eval_16pf.pg009,this.eval_16pf.pg026,this.eval_16pf.pg043,this.eval_16pf.pg060,this.eval_16pf.pg077,this.eval_16pf.pg094,'I');this.res_16pf.resL=this.resultadosH(this.eval_16pf.pg010,this.eval_16pf.pg027,this.eval_16pf.pg044,this.eval_16pf.pg061,this.eval_16pf.pg078,this.eval_16pf.pg095,'L');this.res_16pf.resM=this.resultadosH(this.eval_16pf.pg011,this.eval_16pf.pg028,this.eval_16pf.pg045,this.eval_16pf.pg062,this.eval_16pf.pg079,this.eval_16pf.pg096,'M');this.res_16pf.resN=this.resultadosH(this.eval_16pf.pg012,this.eval_16pf.pg029,this.eval_16pf.pg046,this.eval_16pf.pg063,this.eval_16pf.pg080,this.eval_16pf.pg097,'N');this.res_16pf.resO=this.resultadosH(this.eval_16pf.pg013,this.eval_16pf.pg030,this.eval_16pf.pg047,this.eval_16pf.pg064,this.eval_16pf.pg081,this.eval_16pf.pg098,'O');this.res_16pf.resQ1=this.resultadosH(this.eval_16pf.pg014,this.eval_16pf.pg031,this.eval_16pf.pg048,this.eval_16pf.pg065,this.eval_16pf.pg082,this.eval_16pf.pg099,'Q1');this.res_16pf.resQ2=this.resultadosH(this.eval_16pf.pg015,this.eval_16pf.pg032,this.eval_16pf.pg049,this.eval_16pf.pg066,this.eval_16pf.pg083,this.eval_16pf.pg100,'Q2');this.res_16pf.resQ3=this.resultadosH(this.eval_16pf.pg016,this.eval_16pf.pg033,this.eval_16pf.pg050,this.eval_16pf.pg067,this.eval_16pf.pg084,this.eval_16pf.pg101,'Q3');this.res_16pf.resQ4=this.resultadosH(this.eval_16pf.pg017,this.eval_16pf.pg034,this.eval_16pf.pg051,this.eval_16pf.pg068,this.eval_16pf.pg085,this.eval_16pf.pg102,'Q4');console.log("P ? ",this.res_16pf.resP,", ","A ? ",this.res_16pf.resA,", ","B ? ",this.res_16pf.resB,", ","C ? ",this.res_16pf.resC,", ","E ? ",this.res_16pf.resE,", ","F ? ",this.res_16pf.resF,", ","G ? ",this.res_16pf.resG,", ","H ? ",this.res_16pf.resH,", ","I ? ",this.res_16pf.resI,", ","L ? ",this.res_16pf.resL,", ","M ? ",this.res_16pf.resM,", ","N ? ",this.res_16pf.resN,", ","O ? ",this.res_16pf.resO,", ","Q1 ? ",this.res_16pf.resQ1,", ","Q2 ? ",this.res_16pf.resQ2,", ","Q3 ? ",this.res_16pf.resQ3,", ","Q4 ? ",this.res_16pf.resQ4);if(this.res_16pf.resP>=10){this.res_16pf.resA=this.res_16pf.resA-1;this.res_16pf.resB=this.res_16pf.resB-1;this.res_16pf.resC=this.res_16pf.resC-1;this.res_16pf.resE=this.res_16pf.resE-1;this.res_16pf.resF=this.res_16pf.resF-1;this.res_16pf.resG=this.res_16pf.resG-1;this.res_16pf.resH=this.res_16pf.resH-1;this.res_16pf.resI=this.res_16pf.resI-1;this.res_16pf.resL=this.res_16pf.resL-1;this.res_16pf.resM=this.res_16pf.resM-1;this.res_16pf.resN=this.res_16pf.resN-1;this.res_16pf.resO=this.res_16pf.resO-1;this.res_16pf.resQ1=this.res_16pf.resQ1-1;this.res_16pf.resQ2=this.res_16pf.resQ2-1;this.res_16pf.resQ3=this.res_16pf.resQ3-1;this.res_16pf.resQ4=this.res_16pf.resQ4-1;}// if   
console.log("Q4 ?",this.res_16pf.resQ4);this.res_16pf.rangoP=this.res_16pf.resP;this.res_16pf.rangoA=this.rangosH(this.res_16pf.resA,'A');this.res_16pf.rangoB=this.rangosH(this.res_16pf.resB,'B');this.res_16pf.rangoC=this.rangosH(this.res_16pf.resC,'C');this.res_16pf.rangoE=this.rangosH(this.res_16pf.resE,'E');this.res_16pf.rangoF=this.rangosH(this.res_16pf.resF,'F');this.res_16pf.rangoG=this.rangosH(this.res_16pf.resG,'G');this.res_16pf.rangoH=this.rangosH(this.res_16pf.resH,'H');this.res_16pf.rangoI=this.rangosH(this.res_16pf.resI,'I');this.res_16pf.rangoL=this.rangosH(this.res_16pf.resL,'L');this.res_16pf.rangoM=this.rangosH(this.res_16pf.resM,'M');this.res_16pf.rangoN=this.rangosH(this.res_16pf.resN,'N');this.res_16pf.rangoO=this.rangosH(this.res_16pf.resO,'O');this.res_16pf.rangoQ1=this.rangosH(this.res_16pf.resQ1,'Q1');this.res_16pf.rangoQ2=this.rangosH(this.res_16pf.resQ2,'Q2');this.res_16pf.rangoQ3=this.rangosH(this.res_16pf.resQ3,'Q3');this.res_16pf.rangoQ4=this.rangosH(this.res_16pf.resQ4,'Q4');doc.setLineWidth(0.25);doc.text(10,85,"SECCION DE RESULTADOS ");doc.line(10,86,206,86);// doc.text(21, 81, "F");   doc.text(61, 81, "P");
// doc.text(20, 85, "---"); doc.text(60, 85, "---");
// doc.text(10, 89, "D"); doc.text(20, 89, this.res_16pf.rangoP.toString()); doc.text(60, 89, this.res_16pf.resP.toString());
// doc.text(10, 93, "A"); doc.text(20, 93, this.res_16pf.rangoA.toString()); doc.text(60, 93, this.res_16pf.resA.toString());
doc.text(26,91,"F");doc.text(36,91,"P");doc.text(25,95,"---");doc.text(35,95,"---");doc.text(15,99,"D");doc.text(25,99,this.res_16pf.rangoP.toString());doc.text(35,99,this.res_16pf.resP.toString());doc.text(15,103,"A");doc.text(25,103,this.res_16pf.rangoA.toString());doc.text(35,103,this.res_16pf.resA.toString());doc.text(15,107,"B");doc.text(25,107,this.res_16pf.rangoB.toString());doc.text(35,107,this.res_16pf.resB.toString());doc.text(15,111,"C");doc.text(25,111,this.res_16pf.rangoC.toString());doc.text(35,111,this.res_16pf.resC.toString());doc.text(15,115,"E");doc.text(25,115,this.res_16pf.rangoE.toString());doc.text(35,115,this.res_16pf.resE.toString());doc.text(15,119,"F");doc.text(25,119,this.res_16pf.rangoF.toString());doc.text(35,119,this.res_16pf.resF.toString());doc.text(15,123,"G");doc.text(25,123,this.res_16pf.rangoG.toString());doc.text(35,123,this.res_16pf.resG.toString());doc.text(15,127,"H");doc.text(25,127,this.res_16pf.rangoH.toString());doc.text(35,127,this.res_16pf.resH.toString());doc.text(15,131,"I");doc.text(25,131,this.res_16pf.rangoI.toString());doc.text(35,131,this.res_16pf.resI.toString());doc.text(15,135,"L");doc.text(25,135,this.res_16pf.rangoL.toString());doc.text(35,135,this.res_16pf.resL.toString());doc.text(15,139,"M");doc.text(25,139,this.res_16pf.rangoM.toString());doc.text(35,139,this.res_16pf.resM.toString());doc.text(15,143,"N");doc.text(25,143,this.res_16pf.rangoN.toString());doc.text(35,143,this.res_16pf.resN.toString());doc.text(15,147,"O");doc.text(25,147,this.res_16pf.rangoO.toString());doc.text(35,147,this.res_16pf.resO.toString());doc.text(15,151,"Q1");doc.text(25,151,this.res_16pf.rangoQ1.toString());doc.text(35,151,this.res_16pf.resQ1.toString());doc.text(15,155,"Q2");doc.text(25,155,this.res_16pf.rangoQ2.toString());doc.text(35,155,this.res_16pf.resQ2.toString());doc.text(15,159,"Q3");doc.text(25,159,this.res_16pf.rangoQ3.toString());doc.text(35,159,this.res_16pf.resQ3.toString());doc.text(15,163,"Q4");doc.text(25,163,this.res_16pf.rangoQ4.toString());doc.text(35,163,this.res_16pf.resQ4.toString());},rangosH:function rangosH(res,caso){var rango='*';switch(caso){case'A':{var comp1=res>=0&&res<=3;if(comp1===true){rango='1';}var comp2=res>=4&&res<=5;if(comp2===true){rango='2';}var comp3=res>=6&&res<=6;if(comp3===true){rango='3';}var comp4=res>=7&&res<=7;if(comp4===true){rango='4';}var comp5=res>=8&&res<=8;if(comp5===true){rango='5';}var comp6=res>=9&&res<=9;if(comp6===true){rango='6';}var comp7=res>=10&&res<=10;if(comp7===true){rango='7';}var comp8=res>=11&&res<=11;if(comp8===true){rango='8';}var comp9=res>=12&&res<=12;if(comp9===true){rango='9';}break;}case'B':{var _comp=res>=0&&res<=1;if(_comp===true){rango='1';}var _comp2=res>=2&&res<=2;if(_comp2===true){rango='2';}var _comp3=res>=3&&res<=3;if(_comp3===true){rango='3';}var _comp4=res>=4&&res<=4;if(_comp4===true){rango='4';}var _comp5=res>=5&&res<=5;if(_comp5===true){rango='7';}var _comp6=res>=6&&res<=6;if(_comp6===true){rango='9';}break;}case'C':{var _comp7=res>=0&&res<=3;if(_comp7===true){rango='1';}var _comp8=res>=4&&res<=5;if(_comp8===true){rango='2';}var _comp9=res>=6&&res<=6;if(_comp9===true){rango='3';}var _comp10=res>=7&&res<=7;if(_comp10===true){rango='4';}var _comp11=res>=8&&res<=8;if(_comp11===true){rango='5';}var _comp12=res>=9&&res<=9;if(_comp12===true){rango='6';}var _comp13=res>=10&&res<=10;if(_comp13===true){rango='7';}var _comp14=res>=11&&res<=11;if(_comp14===true){rango='8';}var _comp15=res>=12&&res<=12;if(_comp15===true){rango='9';}break;}case'E':{var _comp16=res>=0&&res<=0;if(_comp16===true){rango='1';}var _comp17=res>=1&&res<=1;if(_comp17===true){rango='2';}var _comp18=res>=2&&res<=2;if(_comp18===true){rango='3';}var _comp19=res>=3&&res<=3;if(_comp19===true){rango='4';}var _comp20=res>=4&&res<=4;if(_comp20===true){rango='5';}var _comp21=res>=5&&res<=6;if(_comp21===true){rango='6';}var _comp22=res>=7&&res<=7;if(_comp22===true){rango='7';}var _comp23=res>=8&&res<=9;if(_comp23===true){rango='8';}var _comp24=res>=10&&res<=12;if(_comp24===true){rango='9';}break;}case'F':{var _comp25=res>=0&&res<=2;if(_comp25===true){rango='1';}var _comp26=res>=3&&res<=4;if(_comp26===true){rango='2';}var _comp27=res>=5&&res<=5;if(_comp27===true){rango='3';}var _comp28=res>=6&&res<=6;if(_comp28===true){rango='4';}var _comp29=res>=7&&res<=7;if(_comp29===true){rango='5';}var _comp30=res>=8&&res<=8;if(_comp30===true){rango='6';}var _comp31=res>=9&&res<=9;if(_comp31===true){rango='7';}var _comp32=res>=10&&res<=10;if(_comp32===true){rango='8';}var _comp33=res>=11&&res<=12;if(_comp33===true){rango='9';}break;}case'G':{var _comp34=res>=1&&res<=2;if(_comp34===true){rango='1';}var _comp35=res>=2&&res<=4;if(_comp35===true){rango='2';}var _comp36=res>=4&&res<=5;if(_comp36===true){rango='3';}var _comp37=res>=6&&res<=6;if(_comp37===true){rango='4';}var _comp38=res>=7&&res<=7;if(_comp38===true){rango='5';}var _comp39=res>=8&&res<=8;if(_comp39===true){rango='6';}var _comp40=res>=9&&res<=10;if(_comp40===true){rango='7';}var _comp41=res>=11&&res<=11;if(_comp41===true){rango='8';}var _comp42=res>=12&&res<=12;if(_comp42===true){rango='9';}break;}case'H':{var _comp43=res>=0&&res<=3;if(_comp43===true){rango='1';}var _comp44=res>=4&&res<=5;if(_comp44===true){rango='2';}var _comp45=res>=6&&res<=6;if(_comp45===true){rango='3';}var _comp46=res>=7&&res<=7;if(_comp46===true){rango='4';}var _comp47=res>=8&&res<=8;if(_comp47===true){rango='5';}var _comp48=res>=9&&res<=9;if(_comp48===true){rango='6';}var _comp49=res>=10&&res<=10;if(_comp49===true){rango='7';}var _comp50=res>=11&&res<=11;if(_comp50===true){rango='8';}var _comp51=res>=11&&res<=12;if(_comp51===true){rango='9';}break;}case'I':{var _comp52=res>=11&&res<=12;if(_comp52===true){rango='1';}var _comp53=res>=10&&res<=10;if(_comp53===true){rango='2';}var _comp54=res>=8&&res<=9;if(_comp54===true){rango='3';}var _comp55=res>=7&&res<=7;if(_comp55===true){rango='4';}var _comp56=res>=5&&res<=6;if(_comp56===true){rango='5';}var _comp57=res>=4&&res<=4;if(_comp57===true){rango='6';}var _comp58=res>=2&&res<=3;if(_comp58===true){rango='7';}var _comp59=res>=1&&res<=1;if(_comp59===true){rango='8';}var _comp60=res>=0&&res<=0;if(_comp60===true){rango='9';}break;}case'L':{var _comp61=res>=11&&res<=12;if(_comp61===true){rango='1';}var _comp62=res>=10&&res<=10;if(_comp62===true){rango='2';}var _comp63=res>=9&&res<=9;if(_comp63===true){rango='3';}var _comp64=res>=8&&res<=8;if(_comp64===true){rango='4';}var _comp65=res>=6&&res<=7;if(_comp65===true){rango='5';}var _comp66=res>=5&&res<=5;if(_comp66===true){rango='6';}var _comp67=res>=4&&res<=4;if(_comp67===true){rango='7';}var _comp68=res>=2&&res<=2;if(_comp68===true){rango='8';}var _comp69=res>=0&&res<=1;if(_comp69===true){rango='9';}break;}case'M':{var _comp70=res>=11&&res<=12;if(_comp70===true){rango='1';}var _comp71=res>=9&&res<=10;if(_comp71===true){rango='2';}var _comp72=res>=8&&res<=8;if(_comp72===true){rango='3';}var _comp73=res>=7&&res<=7;if(_comp73===true){rango='4';}var _comp74=res>=6&&res<=6;if(_comp74===true){rango='5';}var _comp75=res>=5&&res<=5;if(_comp75===true){rango='6';}var _comp76=res>=3&&res<=4;if(_comp76===true){rango='7';}var _comp77=res>=2&&res<=2;if(_comp77===true){rango='8';}var _comp78=res>=0&&res<=1;if(_comp78===true){rango='9';}break;}case'N':{var _comp79=res>=0&&res<=1;if(_comp79===true){rango='1';}var _comp80=res>=2&&res<=2;if(_comp80===true){rango='2';}var _comp81=res>=3&&res<=3;if(_comp81===true){rango='3';}var _comp82=res>=4&&res<=4;if(_comp82===true){rango='4';}var _comp83=res>=5&&res<=5;if(_comp83===true){rango='5';}var _comp84=res>=6&&res<=6;if(_comp84===true){rango='6';}var _comp85=res>=7&&res<=7;if(_comp85===true){rango='7';}var _comp86=res>=8&&res<=9;if(_comp86===true){rango='8';}var _comp87=res>=10&&res<=12;if(_comp87===true){rango='9';}break;}case'O':{var _comp88=res>=9&&res<=12;if(_comp88===true){rango='1';}var _comp89=res>=7&&res<=8;if(_comp89===true){rango='2';}var _comp90=res>=6&&res<=6;if(_comp90===true){rango='3';}var _comp91=res>=5&&res<=5;if(_comp91===true){rango='4';}var _comp92=res>=4&&res<=4;if(_comp92===true){rango='5';}var _comp93=res>=3&&res<=3;if(_comp93===true){rango='6';}var _comp94=res>=2&&res<=2;if(_comp94===true){rango='7';}var _comp95=res>=1&&res<=1;if(_comp95===true){rango='8';}var _comp96=res>=0&&res<=0;if(_comp96===true){rango='9';}break;}case'Q1':{var _comp97=res>=0&&res<=0;if(_comp97===true){rango='1';}var _comp98=res>=1&&res<=1;if(_comp98===true){rango='2';}var _comp99=res>=2&&res<=3;if(_comp99===true){rango='3';}var _comp100=res>=4&&res<=4;if(_comp100===true){rango='4';}var _comp101=res>=5&&res<=5;if(_comp101===true){rango='5';}var _comp102=res>=6&&res<=7;if(_comp102===true){rango='6';}var _comp103=res>=8&&res<=8;if(_comp103===true){rango='7';}var _comp104=res>=9&&res<=10;if(_comp104===true){rango='8';}var _comp105=res>=11&&res<=12;if(_comp105===true){rango='9';}break;}case'Q2':{var _comp106=res>=0&&res<=3;if(_comp106===true){rango='1';}var _comp107=res>=4&&res<=5;if(_comp107===true){rango='2';}var _comp108=res>=6&&res<=6;if(_comp108===true){rango='3';}var _comp109=res>=7&&res<=7;if(_comp109===true){rango='4';}var _comp110=res>=8&&res<=8;if(_comp110===true){rango='5';}var _comp111=res>=9&&res<=9;if(_comp111===true){rango='6';}var _comp112=res>=10&&res<=10;if(_comp112===true){rango='7';}var _comp113=res>=11&&res<=11;if(_comp113===true){rango='8';}var _comp114=res>=12&&res<=12;if(_comp114===true){rango='9';}break;}case'Q3':{var _comp115=res>=0&&res<=2;if(_comp115===true){rango='1';}var _comp116=res>=3&&res<=4;if(_comp116===true){rango='2';}var _comp117=res>=5&&res<=5;if(_comp117===true){rango='3';}var _comp118=res>=6&&res<=6;if(_comp118===true){rango='4';}var _comp119=res>=7&&res<=8;if(_comp119===true){rango='5';}var _comp120=res>=9&&res<=9;if(_comp120===true){rango='6';}var _comp121=res>=10&&res<=10;if(_comp121===true){rango='7';}var _comp122=res>=11&&res<=11;if(_comp122===true){rango='8';}var _comp123=res>=12&&res<=12;if(_comp123===true){rango='9';}break;}case'Q4':{var _comp124=res>=11&&res<=12;if(_comp124===true){rango='1';}var _comp125=res>=9&&res<=10;if(_comp125===true){rango='2';}var _comp126=res>=8&&res<=8;if(_comp126===true){rango='3';}var _comp127=res>=6&&res<=7;if(_comp127===true){rango='4';}var _comp128=res>=5&&res<=5;if(_comp128===true){rango='5';}var _comp129=res>=4&&res<=4;if(_comp129===true){rango='6';}var _comp130=res>=3&&res<=3;if(_comp130===true){rango='7';}var _comp131=res>=2&&res<=2;if(_comp131===true){rango='8';}var _comp132=res>=0&&res<=1;if(_comp132===true){rango='9';}break;}}// switch
return rango;},resultadosH:function resultadosH(pg1,pg2,pg3,pg4,pg5,pg6,caso){var conteo=0;var cadena='**';switch(caso){case'P':{if(pg1==='a'){conteo=conteo+2;cadena=cadena+"pg01-a; ";}else{if(pg1==='b'){conteo=conteo+1;cadena=cadena+"pg01-b; ";}}if(pg2==='b'){conteo=conteo+1;cadena=cadena+"pg18-b; ";}else{if(pg2==='c'){conteo=conteo+2;cadena=cadena+"pg18-c; ";}}if(pg3==='b'){conteo=conteo+1;cadena=cadena+"pg35-b; ";}else{if(pg3==='c'){conteo=conteo+2;cadena=cadena+"pg35-c; ";}}if(pg4==='a'){conteo=conteo+2;cadena=cadena+"pg52-a; ";}else{if(pg4==='b'){conteo=conteo+1;cadena=cadena+"pg52-b; ";}}if(pg5==='b'){conteo=conteo+1;cadena=cadena+"pg69-b; ";}else{if(pg5==='c'){conteo=conteo+2;cadena=cadena+"pg69-c; ";}}if(pg6==='b'){conteo=conteo+1;cadena=cadena+"pg86-b; ";}else{if(pg6==='c'){conteo=conteo+2;cadena=cadena+"pg86-c; ";}}break;}case'A':{if(pg1==='b'){conteo=conteo+1;}else{if(pg1==='c'){conteo=conteo+2;}}if(pg2==='a'){conteo=conteo+2;}else{if(pg2==='b'){conteo=conteo+1;}}if(pg3==='b'){conteo=conteo+1;}else{if(pg3==='c'){conteo=conteo+2;}}if(pg4==='a'){conteo=conteo+2;}else{if(pg4==='b'){conteo=conteo+1;}}if(pg5==='a'){conteo=conteo+2;}else{if(pg5==='b'){conteo=conteo+1;}}if(pg6==='b'){conteo=conteo+1;}else{if(pg6==='c'){conteo=conteo+2;}}break;}case'B':{if(pg1==='b'){conteo=conteo+1;}if(pg2==='c'){conteo=conteo+1;}if(pg3==='b'){conteo=conteo+1;}if(pg4==='c'){conteo=conteo+1;}if(pg5==='b'){conteo=conteo+1;}if(pg6==='c'){conteo=conteo+1;}break;}case'C':{if(pg1==='a'){conteo=conteo+2;}else{if(pg1==='b'){conteo=conteo+1;}}if(pg2==='a'){conteo=conteo+2;}else{if(pg2==='b'){conteo=conteo+1;}}if(pg3==='b'){conteo=conteo+1;}else{if(pg3==='c'){conteo=conteo+2;}}if(pg4==='a'){conteo=conteo+2;}else{if(pg4==='b'){conteo=conteo+1;}}if(pg5==='b'){conteo=conteo+1;}else{if(pg5==='c'){conteo=conteo+2;}}if(pg6==='b'){conteo=conteo+1;}else{if(pg6==='c'){conteo=conteo+2;}}break;}case'E':{if(pg1==='b'){conteo=conteo+1;}else{if(pg1==='c'){conteo=conteo+2;}}if(pg2==='b'){conteo=conteo+1;}else{if(pg2==='c'){conteo=conteo+2;}}if(pg3==='a'){conteo=conteo+2;}else{if(pg3==='b'){conteo=conteo+1;}}if(pg4==='a'){conteo=conteo+2;}else{if(pg4==='b'){conteo=conteo+1;}}if(pg5==='b'){conteo=conteo+1;}else{if(pg5==='c'){conteo=conteo+2;}}if(pg6==='a'){conteo=conteo+2;}else{if(pg6==='b'){conteo=conteo+1;}}break;}case'F':{if(pg1==='b'){conteo=conteo+1;}else{if(pg1==='c'){conteo=conteo+2;}}if(pg2==='a'){conteo=conteo+2;}else{if(pg2==='b'){conteo=conteo+1;}}if(pg3==='b'){conteo=conteo+1;}else{if(pg3==='c'){conteo=conteo+2;}}if(pg4==='a'){conteo=conteo+2;}else{if(pg4==='b'){conteo=conteo+1;}}if(pg5==='a'){conteo=conteo+2;}else{if(pg5==='b'){conteo=conteo+1;}}if(pg6==='b'){conteo=conteo+1;}else{if(pg6==='c'){conteo=conteo+2;}}break;}case'G':{if(pg1==='a'){conteo=conteo+2;}else{if(pg1==='b'){conteo=conteo+1;}}if(pg2==='b'){conteo=conteo+1;}else{if(pg2==='c'){conteo=conteo+2;}}if(pg3==='a'){conteo=conteo+2;}else{if(pg3==='b'){conteo=conteo+1;}}if(pg4==='b'){conteo=conteo+1;}else{if(pg4==='c'){conteo=conteo+2;}}if(pg5==='a'){conteo=conteo+2;}else{if(pg5==='b'){conteo=conteo+1;}}if(pg6==='b'){conteo=conteo+1;}else{if(pg6==='c'){conteo=conteo+2;}}break;}case'H':{if(pg1==='a'){conteo=conteo+2;}else{if(pg1==='b'){conteo=conteo+1;}}if(pg2==='b'){conteo=conteo+1;}else{if(pg2==='c'){conteo=conteo+2;}}if(pg3==='b'){conteo=conteo+1;}else{if(pg3==='c'){conteo=conteo+2;}}if(pg4==='a'){conteo=conteo+2;}else{if(pg4==='b'){conteo=conteo+1;}}if(pg5==='a'){conteo=conteo+2;}else{if(pg5==='b'){conteo=conteo+1;}}if(pg6==='b'){conteo=conteo+1;}else{if(pg6==='c'){conteo=conteo+2;}}break;}case'I':{if(pg1==='a'){conteo=conteo+2;}else{if(pg1==='b'){conteo=conteo+1;}}if(pg2==='a'){conteo=conteo+2;}else{if(pg2==='b'){conteo=conteo+1;}}if(pg3==='b'){conteo=conteo+1;}else{if(pg3==='c'){conteo=conteo+2;}}if(pg4==='a'){conteo=conteo+2;}else{if(pg4==='b'){conteo=conteo+1;}}if(pg5==='b'){conteo=conteo+1;}else{if(pg5==='c'){conteo=conteo+2;}}if(pg6==='b'){conteo=conteo+1;}else{if(pg6==='c'){conteo=conteo+2;}}break;}case'L':{if(pg1==='a'){conteo=conteo+2;}else{if(pg1==='b'){conteo=conteo+1;}}// 1
if(pg2==='b'){conteo=conteo+1;}else{if(pg2==='c'){conteo=conteo+2;}}if(pg3==='b'){conteo=conteo+1;}else{if(pg3==='c'){conteo=conteo+2;}}if(pg4==='b'){conteo=conteo+1;}else{if(pg4==='c'){conteo=conteo+2;}}if(pg5==='a'){conteo=conteo+2;}else{if(pg5==='b'){conteo=conteo+1;}}if(pg6==='a'){conteo=conteo+2;}else{if(pg6==='b'){conteo=conteo+1;}}break;}case'M':{if(pg1==='b'){conteo=conteo+1;}else{if(pg1==='c'){conteo=conteo+2;}}if(pg2==='b'){conteo=conteo+1;}else{if(pg2==='c'){conteo=conteo+2;}}if(pg3==='a'){conteo=conteo+2;}else{if(pg3==='b'){conteo=conteo+1;}}if(pg4==='a'){conteo=conteo+2;}else{if(pg4==='b'){conteo=conteo+1;}}if(pg5==='a'){conteo=conteo+2;}else{if(pg5==='b'){conteo=conteo+1;}}if(pg6==='b'){conteo=conteo+1;}else{if(pg6==='c'){conteo=conteo+2;}}break;}case'N':{if(pg1==='b'){conteo=conteo+1;}else{if(pg1==='c'){conteo=conteo+2;}}if(pg2==='a'){conteo=conteo+2;}else{if(pg2==='b'){conteo=conteo+1;}}if(pg3==='a'){conteo=conteo+2;}else{if(pg3==='b'){conteo=conteo+1;}}if(pg4==='a'){conteo=conteo+2;}else{if(pg4==='b'){conteo=conteo+1;}}if(pg5==='b'){conteo=conteo+1;}else{if(pg5==='c'){conteo=conteo+2;}}if(pg6==='b'){conteo=conteo+1;}else{if(pg6==='c'){conteo=conteo+2;}}break;}case'O':{if(pg1==='a'){conteo=conteo+2;}else{if(pg1==='b'){conteo=conteo+1;}}if(pg2==='b'){conteo=conteo+1;}else{if(pg2==='c'){conteo=conteo+2;}}if(pg3==='b'){conteo=conteo+1;}else{if(pg3==='c'){conteo=conteo+2;}}if(pg4==='a'){conteo=conteo+2;}else{if(pg4==='b'){conteo=conteo+1;}}if(pg5==='b'){conteo=conteo+1;}else{if(pg5==='c'){conteo=conteo+2;}}if(pg6==='a'){conteo=conteo+2;}else{if(pg6==='b'){conteo=conteo+1;}}break;}case'Q1':{if(pg1==='a'){conteo=conteo+2;}else{if(pg1==='b'){conteo=conteo+1;}}if(pg2==='a'){conteo=conteo+2;}else{if(pg2==='b'){conteo=conteo+1;}}if(pg3==='b'){conteo=conteo+1;}else{if(pg3==='c'){conteo=conteo+2;}}if(pg4==='b'){conteo=conteo+1;}else{if(pg4==='c'){conteo=conteo+2;}}if(pg5==='b'){conteo=conteo+1;}else{if(pg5==='c'){conteo=conteo+2;}}if(pg6==='a'){conteo=conteo+2;}else{if(pg6==='b'){conteo=conteo+1;}}break;}case'Q2':{if(pg1==='a'){conteo=conteo+2;}else{if(pg1==='b'){conteo=conteo+1;}}if(pg2==='b'){conteo=conteo+1;}else{if(pg2==='c'){conteo=conteo+2;}}if(pg3==='a'){conteo=conteo+2;}else{if(pg3==='b'){conteo=conteo+1;}}if(pg4==='a'){conteo=conteo+2;}else{if(pg4==='b'){conteo=conteo+1;}}if(pg5==='b'){conteo=conteo+1;}else{if(pg5==='c'){conteo=conteo+2;}}if(pg6==='b'){conteo=conteo+1;}else{if(pg6==='c'){conteo=conteo+2;}}break;}case'Q3':{if(pg1==='a'){conteo=conteo+2;}else{if(pg1==='b'){conteo=conteo+1;}}if(pg2==='a'){conteo=conteo+2;}else{if(pg2==='b'){conteo=conteo+1;}}if(pg3==='a'){conteo=conteo+2;}else{if(pg3==='b'){conteo=conteo+1;}}if(pg4==='b'){conteo=conteo+1;}else{if(pg4==='c'){conteo=conteo+2;}}if(pg5==='b'){conteo=conteo+1;}else{if(pg5==='c'){conteo=conteo+2;}}if(pg6==='b'){conteo=conteo+1;}else{if(pg6==='c'){conteo=conteo+2;}}break;}case'Q4':{if(pg1==='b'){conteo=conteo+1;}else{if(pg1==='c'){conteo=conteo+2;}}if(pg2==='a'){conteo=conteo+2;}else{if(pg2==='b'){conteo=conteo+1;}}if(pg3==='b'){conteo=conteo+1;}else{if(pg3==='c'){conteo=conteo+2;}}if(pg4==='a'){conteo=conteo+2;}else{if(pg4==='b'){conteo=conteo+1;}}if(pg5==='b'){conteo=conteo+1;}else{if(pg5==='c'){conteo=conteo+2;}}if(pg6==='a'){conteo=conteo+2;}else{if(pg6==='b'){conteo=conteo+1;}}break;}}// switch
console.log("[ resultadosH ] ( ",pg1,pg2,pg3,pg4,pg5,pg6,caso," ) ( ",conteo,cadena," )");return conteo;},// resultadosH()
respuestas16pf:function respuestas16pf(doc){console.log("Respuestas ");console.log(this.eval_16pf);/* Muestra las preguntas *//* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */doc.setLineWidth(0.25);doc.text(10,40,"SECCION DE RESPUESTAS ");doc.line(10,42,206,42);// doc.text(10, 45, this.eval_16pf.pg001 === "a" ? "| 01= (a)" : "| 01= (b)");
doc.text(10,45,this.eval_16pf.pg001==="a"?"| 01= (a)":this.eval_16pf.pg001==="b"?"| 01= (b)":"| 01= (c)");doc.text(23,45,this.eval_16pf.pg002==="a"?"| 02= (a)":this.eval_16pf.pg002==="b"?"| 02= (b)":"| 02= (c)");doc.text(36,45,this.eval_16pf.pg003==="a"?"| 03= (a)":this.eval_16pf.pg003==="b"?"| 03= (b)":"| 03= (c)");doc.text(49,45,this.eval_16pf.pg004==="a"?"| 04= (a)":this.eval_16pf.pg004==="b"?"| 04= (b)":"| 04= (c)");doc.text(62,45,this.eval_16pf.pg005==="a"?"| 05= (a)":this.eval_16pf.pg005==="b"?"| 05= (b)":"| 05= (c)");doc.text(75,45,this.eval_16pf.pg006==="a"?"| 06= (a)":this.eval_16pf.pg006==="b"?"| 06= (b)":"| 06= (c)");doc.text(88,45,this.eval_16pf.pg007==="a"?"| 07= (a)":this.eval_16pf.pg007==="b"?"| 07= (b)":"| 07= (c)");doc.text(101,45,this.eval_16pf.pg008==="a"?"| 08= (a)":this.eval_16pf.pg008==="b"?"| 08= (b)":"| 08= (c)");doc.text(114,45,this.eval_16pf.pg009==="a"?"| 09= (a)":this.eval_16pf.pg009==="b"?"| 09= (b)":"| 09= (c)");doc.text(127,45,this.eval_16pf.pg010==="a"?"| 10= (a)":this.eval_16pf.pg010==="b"?"| 10= (b)":"| 10= (c)");doc.text(140,45,this.eval_16pf.pg011==="a"?"| 11= (a)":this.eval_16pf.pg011==="b"?"| 11= (b)":"| 11= (c)");doc.text(153,45,this.eval_16pf.pg012==="a"?"| 12= (a)":this.eval_16pf.pg012==="b"?"| 12= (b)":"| 12= (c)");doc.text(166,45,this.eval_16pf.pg013==="a"?"| 13= (a)":this.eval_16pf.pg013==="b"?"| 13= (b)":"| 13= (c)");doc.text(179,45,this.eval_16pf.pg014==="a"?"| 14= (a)":this.eval_16pf.pg014==="b"?"| 14= (b)":"| 14= (c)");doc.text(192,45,this.eval_16pf.pg015==="a"?"| 15= (a) |":this.eval_16pf.pg015==="b"?"| 15= (b) |":"| 15= (c) |");doc.line(10,46,206,46);doc.text(10,49,this.eval_16pf.pg016==="a"?"| 16= (a)":this.eval_16pf.pg016==="b"?"| 16= (b)":"| 16= (c)");doc.text(23,49,this.eval_16pf.pg017==="a"?"| 17= (a)":this.eval_16pf.pg017==="b"?"| 17= (b)":"| 17= (c)");doc.text(36,49,this.eval_16pf.pg018==="a"?"| 18= (a)":this.eval_16pf.pg018==="b"?"| 18= (b)":"| 18= (c)");doc.text(49,49,this.eval_16pf.pg019==="a"?"| 19= (a)":this.eval_16pf.pg019==="b"?"| 19= (b)":"| 19= (c)");doc.text(62,49,this.eval_16pf.pg020==="a"?"| 20= (a)":this.eval_16pf.pg020==="b"?"| 20= (b)":"| 20= (c)");doc.text(75,49,this.eval_16pf.pg021==="a"?"| 21= (a)":this.eval_16pf.pg021==="b"?"| 21= (b)":"| 21= (c)");doc.text(88,49,this.eval_16pf.pg022==="a"?"| 22= (a)":this.eval_16pf.pg022==="b"?"| 22= (b)":"| 22= (c)");doc.text(101,49,this.eval_16pf.pg023==="a"?"| 23= (a)":this.eval_16pf.pg023==="b"?"| 23= (b)":"| 23= (c)");doc.text(114,49,this.eval_16pf.pg024==="a"?"| 24= (a)":this.eval_16pf.pg024==="b"?"| 24= (b)":"| 24= (c)");doc.text(127,49,this.eval_16pf.pg025==="a"?"| 25= (a)":this.eval_16pf.pg025==="b"?"| 25= (b)":"| 25= (c)");doc.text(140,49,this.eval_16pf.pg026==="a"?"| 26= (a)":this.eval_16pf.pg026==="b"?"| 26= (b)":"| 26= (c)");doc.text(153,49,this.eval_16pf.pg027==="a"?"| 27= (a)":this.eval_16pf.pg027==="b"?"| 27= (b)":"| 27= (c)");doc.text(166,49,this.eval_16pf.pg028==="a"?"| 28= (a)":this.eval_16pf.pg028==="b"?"| 28= (b)":"| 28= (c)");doc.text(179,49,this.eval_16pf.pg029==="a"?"| 29= (a)":this.eval_16pf.pg029==="b"?"| 29= (b)":"| 29= (c)");doc.text(192,49,this.eval_16pf.pg030==="a"?"| 30= (a) |":this.eval_16pf.pg030==="b"?"| 30= (b) |":"| 30= (c) |");doc.line(10,50,206,50);doc.text(10,53,this.eval_16pf.pg031==="a"?"| 31= (a)":this.eval_16pf.pg031==="b"?"| 39= (b)":"| 31= (c)");doc.text(23,53,this.eval_16pf.pg032==="a"?"| 32= (a)":this.eval_16pf.pg032==="b"?"| 39= (b)":"| 32= (c)");doc.text(36,53,this.eval_16pf.pg033==="a"?"| 33= (a)":this.eval_16pf.pg033==="b"?"| 39= (b)":"| 33= (c)");doc.text(49,53,this.eval_16pf.pg034==="a"?"| 34= (a)":this.eval_16pf.pg034==="b"?"| 39= (b)":"| 34= (c)");doc.text(62,53,this.eval_16pf.pg035==="a"?"| 35= (a)":this.eval_16pf.pg035==="b"?"| 39= (b)":"| 35= (c)");doc.text(75,53,this.eval_16pf.pg036==="a"?"| 36= (a)":this.eval_16pf.pg036==="b"?"| 39= (b)":"| 36= (c)");doc.text(88,53,this.eval_16pf.pg037==="a"?"| 37= (a)":this.eval_16pf.pg037==="b"?"| 39= (b)":"| 37= (c)");doc.text(101,53,this.eval_16pf.pg038==="a"?"| 38= (a)":this.eval_16pf.pg038==="b"?"| 39= (b)":"| 38= (c)");doc.text(114,53,this.eval_16pf.pg039==="a"?"| 39= (a)":this.eval_16pf.pg039==="b"?"| 39= (b)":"| 39= (c)");doc.text(127,53,this.eval_16pf.pg040==="a"?"| 40= (a)":this.eval_16pf.pg040==="b"?"| 39= (b)":"| 40= (c)");doc.text(140,53,this.eval_16pf.pg041==="a"?"| 41= (a)":this.eval_16pf.pg041==="b"?"| 39= (b)":"| 41= (c)");doc.text(153,53,this.eval_16pf.pg042==="a"?"| 42= (a)":this.eval_16pf.pg042==="b"?"| 39= (b)":"| 42= (c)");doc.text(166,53,this.eval_16pf.pg043==="a"?"| 43= (a)":this.eval_16pf.pg043==="b"?"| 39= (b)":"| 43= (c)");doc.text(179,53,this.eval_16pf.pg044==="a"?"| 44= (a)":this.eval_16pf.pg044==="b"?"| 39= (b)":"| 44= (c)");doc.text(192,53,this.eval_16pf.pg045==="a"?"| 45= (a) |":this.eval_16pf.pg045==="b"?"| 39= (b) |":"| 45= (c) |");doc.line(10,54,206,54);doc.text(10,57,this.eval_16pf.pg046==="a"?"| 46= (a)":this.eval_16pf.pg046==="b"?"| 46= (b)":"| 46= (c)");doc.text(23,57,this.eval_16pf.pg047==="a"?"| 47= (a)":this.eval_16pf.pg047==="b"?"| 47= (b)":"| 47= (c)");doc.text(36,57,this.eval_16pf.pg048==="a"?"| 48= (a)":this.eval_16pf.pg048==="b"?"| 48= (b)":"| 48= (c)");doc.text(49,57,this.eval_16pf.pg049==="a"?"| 49= (a)":this.eval_16pf.pg049==="b"?"| 49= (b)":"| 49= (c)");doc.text(62,57,this.eval_16pf.pg050==="a"?"| 50= (a)":this.eval_16pf.pg050==="b"?"| 50= (b)":"| 50= (c)");doc.text(75,57,this.eval_16pf.pg051==="a"?"| 51= (a)":this.eval_16pf.pg051==="b"?"| 51= (b)":"| 51= (c)");doc.text(88,57,this.eval_16pf.pg052==="a"?"| 52= (a)":this.eval_16pf.pg052==="b"?"| 52= (b)":"| 52= (c)");doc.text(101,57,this.eval_16pf.pg053==="a"?"| 53= (a)":this.eval_16pf.pg053==="b"?"| 53= (b)":"| 53= (c)");doc.text(114,57,this.eval_16pf.pg054==="a"?"| 54= (a)":this.eval_16pf.pg054==="b"?"| 54= (b)":"| 54= (c)");doc.text(127,57,this.eval_16pf.pg055==="a"?"| 55= (a)":this.eval_16pf.pg055==="b"?"| 55= (b)":"| 55= (c)");doc.text(140,57,this.eval_16pf.pg056==="a"?"| 56= (a)":this.eval_16pf.pg056==="b"?"| 56= (b)":"| 56= (c)");doc.text(153,57,this.eval_16pf.pg057==="a"?"| 57= (a)":this.eval_16pf.pg057==="b"?"| 57= (b)":"| 57= (c)");doc.text(166,57,this.eval_16pf.pg058==="a"?"| 58= (a)":this.eval_16pf.pg058==="b"?"| 58= (b)":"| 58= (c)");doc.text(179,57,this.eval_16pf.pg059==="a"?"| 59= (a)":this.eval_16pf.pg059==="b"?"| 59= (b)":"| 59= (c)");doc.text(192,57,this.eval_16pf.pg060==="a"?"| 60= (a) |":this.eval_16pf.pg060==="b"?"| 60= (b) |":"| 60= (c) |");doc.line(10,58,206,58);doc.text(10,61,this.eval_16pf.pg061==="a"?"| 61= (a)":this.eval_16pf.pg061==="b"?"| 61= (b)":"| 61= (c)");doc.text(23,61,this.eval_16pf.pg062==="a"?"| 62= (a)":this.eval_16pf.pg062==="b"?"| 62= (b)":"| 62= (c)");doc.text(36,61,this.eval_16pf.pg063==="a"?"| 63= (a)":this.eval_16pf.pg063==="b"?"| 63= (b)":"| 63= (c)");doc.text(49,61,this.eval_16pf.pg064==="a"?"| 64= (a)":this.eval_16pf.pg064==="b"?"| 64= (b)":"| 64= (c)");doc.text(62,61,this.eval_16pf.pg065==="a"?"| 65= (a)":this.eval_16pf.pg065==="b"?"| 65= (b)":"| 65= (c)");doc.text(75,61,this.eval_16pf.pg066==="a"?"| 66= (a)":this.eval_16pf.pg066==="b"?"| 66= (b)":"| 66= (c)");doc.text(88,61,this.eval_16pf.pg067==="a"?"| 67= (a)":this.eval_16pf.pg067==="b"?"| 67= (b)":"| 67= (c)");doc.text(101,61,this.eval_16pf.pg068==="a"?"| 68= (a)":this.eval_16pf.pg068==="b"?"| 68= (b)":"| 68= (c)");doc.text(114,61,this.eval_16pf.pg069==="a"?"| 69= (a)":this.eval_16pf.pg069==="b"?"| 69= (b)":"| 69= (c)");doc.text(127,61,this.eval_16pf.pg070==="a"?"| 70= (a)":this.eval_16pf.pg070==="b"?"| 70= (b)":"| 70= (c)");doc.text(140,61,this.eval_16pf.pg071==="a"?"| 71= (a)":this.eval_16pf.pg071==="b"?"| 71= (b)":"| 71= (c)");doc.text(153,61,this.eval_16pf.pg072==="a"?"| 72= (a)":this.eval_16pf.pg072==="b"?"| 72= (b)":"| 72= (c)");doc.text(166,61,this.eval_16pf.pg073==="a"?"| 73= (a)":this.eval_16pf.pg073==="b"?"| 73= (b)":"| 73= (c)");doc.text(179,61,this.eval_16pf.pg074==="a"?"| 74= (a)":this.eval_16pf.pg074==="b"?"| 74= (b)":"| 74= (c)");doc.text(192,61,this.eval_16pf.pg075==="a"?"| 75= (a) |":this.eval_16pf.pg075==="b"?"| 75= (b) |":"| 75= (c) |");doc.line(10,62,206,62);doc.text(10,65,this.eval_16pf.pg076==="a"?"| 76= (a)":this.eval_16pf.pg076==="b"?"| 76= (b)":"| 76= (c)");doc.text(23,65,this.eval_16pf.pg077==="a"?"| 77= (a)":this.eval_16pf.pg077==="b"?"| 77= (b)":"| 77= (c)");doc.text(36,65,this.eval_16pf.pg078==="a"?"| 78= (a)":this.eval_16pf.pg078==="b"?"| 78= (b)":"| 78= (c)");doc.text(49,65,this.eval_16pf.pg079==="a"?"| 79= (a)":this.eval_16pf.pg079==="b"?"| 79= (b)":"| 79= (c)");doc.text(62,65,this.eval_16pf.pg080==="a"?"| 80= (a)":this.eval_16pf.pg080==="b"?"| 80= (b)":"| 80= (c)");doc.text(75,65,this.eval_16pf.pg081==="a"?"| 81= (a)":this.eval_16pf.pg081==="b"?"| 81= (b)":"| 81= (c)");doc.text(88,65,this.eval_16pf.pg082==="a"?"| 82= (a)":this.eval_16pf.pg082==="b"?"| 82= (b)":"| 82= (c)");doc.text(101,65,this.eval_16pf.pg083==="a"?"| 83= (a)":this.eval_16pf.pg083==="b"?"| 83= (b)":"| 83= (c)");doc.text(114,65,this.eval_16pf.pg084==="a"?"| 84= (a)":this.eval_16pf.pg084==="b"?"| 84= (b)":"| 84= (c)");doc.text(127,65,this.eval_16pf.pg085==="a"?"| 85= (a)":this.eval_16pf.pg085==="b"?"| 85= (b)":"| 85= (c)");doc.text(140,65,this.eval_16pf.pg086==="a"?"| 86= (a)":this.eval_16pf.pg086==="b"?"| 86= (b)":"| 86= (c)");doc.text(153,65,this.eval_16pf.pg087==="a"?"| 87= (a)":this.eval_16pf.pg087==="b"?"| 87= (b)":"| 87= (c)");doc.text(166,65,this.eval_16pf.pg088==="a"?"| 88= (a)":this.eval_16pf.pg088==="b"?"| 88= (b)":"| 88= (c)");doc.text(179,65,this.eval_16pf.pg089==="a"?"| 89= (a)":this.eval_16pf.pg089==="b"?"| 89= (b)":"| 89= (c)");doc.text(192,65,this.eval_16pf.pg090==="a"?"| 90= (a) |":this.eval_16pf.pg090==="b"?"| 90= (b) |":"| 90= (c) |");doc.line(10,66,206,66);doc.text(10,69,this.eval_16pf.pg091==="a"?"| 91= (a)":this.eval_16pf.pg091==="b"?"| 91= (b)":"| 91= (c)");doc.text(23,69,this.eval_16pf.pg092==="a"?"| 92= (a)":this.eval_16pf.pg092==="b"?"| 92= (b)":"| 92= (c)");doc.text(36,69,this.eval_16pf.pg093==="a"?"| 93= (a)":this.eval_16pf.pg093==="b"?"| 93= (b)":"| 93= (c)");doc.text(49,69,this.eval_16pf.pg094==="a"?"| 94= (a)":this.eval_16pf.pg094==="b"?"| 94= (b)":"| 94= (c)");doc.text(62,69,this.eval_16pf.pg095==="a"?"| 95= (a)":this.eval_16pf.pg095==="b"?"| 95= (b)":"| 95= (c)");doc.text(75,69,this.eval_16pf.pg096==="a"?"| 96= (a)":this.eval_16pf.pg096==="b"?"| 96= (b)":"| 96= (c)");doc.text(88,69,this.eval_16pf.pg097==="a"?"| 97= (a)":this.eval_16pf.pg097==="b"?"| 97= (b)":"| 97= (c)");doc.text(101,69,this.eval_16pf.pg098==="a"?"| 98= (a)":this.eval_16pf.pg098==="b"?"| 98= (b)":"| 98= (c)");doc.text(114,69,this.eval_16pf.pg099==="a"?"| 99= (a)":this.eval_16pf.pg099==="b"?"| 99= (b)":"| 99= (c)");doc.text(127,69,this.eval_16pf.pg100==="a"?"| 100= (a)":this.eval_16pf.pg100==="b"?"| 100= (b)":"| 100= (c)");doc.text(140,69,this.eval_16pf.pg101==="a"?"| 101= (a)":this.eval_16pf.pg101==="b"?"| 101= (b)":"| 101= (c)");doc.text(153,69,this.eval_16pf.pg102==="a"?"| 102= (a) |":this.eval_16pf.pg102==="b"?"| 102= (b) |":"| 102= (c) |");doc.line(10,70,168,70);},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
crearPDF_npf:function crearPDF_npf(){/** CREACION DEL ARCHIVO PDF */var cadena=this.eval_npf.nombre,patron=/ /g,nuevoValor="",nusuario=cadena.replace(patron,nuevoValor);var nArchivo="npf_"+nusuario;console.log("archivo a crear ? ",nArchivo);var imagen="data:image/jpeg;base64,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";var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a('portrait');var linea=5;/** Muestra el logo.        (izq, top, ancho, alto) */doc.addImage(imagen,'JPEG',155,linea,50,20);/** fila, columna *//** CIRCULOS  */doc.setLineWidth(1);// Grosor de la línea del borde
doc.setDrawColor(0);/** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */var meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var lhoy=new Date();//lhoy=   lhoy.toString();
var ldia=lhoy.getDate();var lmes=meses[lhoy.getMonth()];var lanio=lhoy.getFullYear();// console.log("lhoy ? ",lhoy);
// console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
doc.setFontSize(9);doc.text(10,20,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);doc.text(10,30,"Evaluación de ESTABILIDAD para "+this.eval_npf.nombre+" de "+this.eval_npf.empresa);this.respuestasnpf(doc);this.resultadosnpf(doc);doc.save(nArchivo);doc.autoPrint();window.open(doc.output('bloburl'),'_blank');},rangosnpf:function rangosnpf(){this.res_npf={Uno:0,Dos:0,Cero:0,Uno2:0,Dos2:0,Cero2:0,cpreviaIzq:0,cpreviaDer:0,rangos:0},/* Resuelve para la pregunta 1 */console.log("================================");console.log("En rangosnpf");switch(this.eval_npf.pg001){case'a':this.res_npf.Dos=this.res_npf.Dos+2;console.log("Es a)");break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;console.log("Es b)");break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;console.log("Es c)");break;}console.log("uno ? ",this.res_npf.Uno,"; dos ? ",this.res_npf.Dos,"; Cero ? ",this.res_npf.Cero);/* Resuelve para la pregunta 2 */switch(this.eval_npf.pg002){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}/* Resuelve para la pregunta 3 */switch(this.eval_npf.pg003){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}/* Resuelve para la pregunta 4 */switch(this.eval_npf.pg004){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}/* Resuelve para la pregunta 5 */switch(this.eval_npf.pg005){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}/* Resuelve para la pregunta 6 */switch(this.eval_npf.pg006){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}/* Resuelve para la pregunta 3 */switch(this.eval_npf.pg007){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}/* Resuelve para la pregunta 4 */switch(this.eval_npf.pg008){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 9 *//* ======================================================== */switch(this.eval_npf.pg009){case'a':this.res_npf.Cero2=this.res_npf.Cero2+1;break;case'b':this.res_npf.Uno2=this.res_npf.Uno2+1;break;case'c':this.res_npf.Dos2=this.res_npf.Dos2+2;break;}/* Resuelve para la pregunta 4 */switch(this.eval_npf.pg010){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}/* Resuelve para la pregunta 4 */switch(this.eval_npf.pg011){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}/* Resuelve para la pregunta 4 */switch(this.eval_npf.pg012){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}/* Resuelve para la pregunta 4 */switch(this.eval_npf.pg013){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 14 *//* ======================================================== */switch(this.eval_npf.pg014){case'a':this.res_npf.Dos2=this.res_npf.Dos2+2;break;case'b':this.res_npf.Uno2=this.res_npf.Uno2+1;break;case'c':this.res_npf.Cero2=this.res_npf.Cero2+1;break;}switch(this.eval_npf.pg015){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}/* Resuelve para la pregunta 16 */switch(this.eval_npf.pg016){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}/* Resuelve para la pregunta 17 */switch(this.eval_npf.pg017){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}switch(this.eval_npf.pg018){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 19 *//* ======================================================== */console.log("a evaluar 19");switch(this.eval_npf.pg019){case'a':this.res_npf.Dos2=this.res_npf.Dos2+2;break;case'b':this.res_npf.Uno2=this.res_npf.Uno2+1;console.log("19 es b !!");break;case'c':this.res_npf.Cero2=this.res_npf.Cero2+1;break;}switch(this.eval_npf.pg020){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}/* Resuelve para la pregunta 17 */switch(this.eval_npf.pg021){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}switch(this.eval_npf.pg022){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 23 *//* ======================================================== */switch(this.eval_npf.pg023){case'a':this.res_npf.Cero2=this.res_npf.Cero2+1;break;case'b':this.res_npf.Uno2=this.res_npf.Uno2+1;break;case'c':this.res_npf.Dos2=this.res_npf.Dos2+2;break;}switch(this.eval_npf.pg024){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}switch(this.eval_npf.pg025){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}switch(this.eval_npf.pg026){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}switch(this.eval_npf.pg027){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 28 *//* ======================================================== */switch(this.eval_npf.pg028){case'a':this.res_npf.Dos2=this.res_npf.Dos2+2;break;case'b':this.res_npf.Uno2=this.res_npf.Uno2+1;break;case'c':this.res_npf.Cero2=this.res_npf.Cero2+1;break;}switch(this.eval_npf.pg029){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}switch(this.eval_npf.pg030){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}switch(this.eval_npf.pg031){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}switch(this.eval_npf.pg032){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}switch(this.eval_npf.pg033){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}switch(this.eval_npf.pg034){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}switch(this.eval_npf.pg035){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}switch(this.eval_npf.pg036){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 37 *//* ======================================================== */switch(this.eval_npf.pg037){case'a':this.res_npf.Cero2=this.res_npf.Cero2+1;break;case'b':this.res_npf.Uno2=this.res_npf.Uno2+1;break;case'c':this.res_npf.Dos2=this.res_npf.Dos2+2;break;}switch(this.eval_npf.pg038){case'a':this.res_npf.Cero=this.res_npf.Cero+1;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Dos=this.res_npf.Dos+2;break;}switch(this.eval_npf.pg039){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}switch(this.eval_npf.pg040){case'a':this.res_npf.Dos=this.res_npf.Dos+2;break;case'b':this.res_npf.Uno=this.res_npf.Uno+1;break;case'c':this.res_npf.Cero=this.res_npf.Cero+1;break;}console.log(">>> PRIMERAS 15 PREGUNTAS");console.log("pg1 ? ",this.eval_npf.pg001,"pg2 ? ",this.eval_npf.pg002,"pg3 ? ",this.eval_npf.pg003,"pg4 ? ",this.eval_npf.pg004,"pg5 ? ",this.eval_npf.pg005,"pg6 ? ",this.eval_npf.pg006,"pg7 ? ",this.eval_npf.pg007,"pg8 ? ",this.eval_npf.pg008,"pg9 ? ",this.eval_npf.pg009,"pg10 ? ",this.eval_npf.pg010,"pg11 ? ",this.eval_npf.pg011,"pg12 ? ",this.eval_npf.pg012,"pg13 ? ",this.eval_npf.pg013,"pg14 ? ",this.eval_npf.pg014,"pg15 ? ",this.eval_npf.pg015,"pg16 ? ",this.eval_npf.pg016,"pg17 ? ",this.eval_npf.pg017,"pg18 ? ",this.eval_npf.pg018,"pg19 ? ",this.eval_npf.pg019,"pg20 ? ",this.eval_npf.pg020,"pg21 ? ",this.eval_npf.pg021,"pg22 ? ",this.eval_npf.pg022,"pg23 ? ",this.eval_npf.pg023,"pg24 ? ",this.eval_npf.pg024,"pg25 ? ",this.eval_npf.pg025,"pg26 ? ",this.eval_npf.pg026,"pg27 ? ",this.eval_npf.pg027,"pg28 ? ",this.eval_npf.pg028,"pg29 ? ",this.eval_npf.pg029,"pg30 ? ",this.eval_npf.pg030,"pg31 ? ",this.eval_npf.pg031,"pg32 ? ",this.eval_npf.pg032,"pg33 ? ",this.eval_npf.pg033,"pg34 ? ",this.eval_npf.pg034,"pg35 ? ",this.eval_npf.pg035,"pg36 ? ",this.eval_npf.pg036,"pg37 ? ",this.eval_npf.pg037,"pg38 ? ",this.eval_npf.pg038,"pg39 ? ",this.eval_npf.pg039,"pg40 ? ",this.eval_npf.pg040);console.log("uno ? ",this.res_npf.Uno,"; dos ? ",this.res_npf.Dos,"; Cero ? ",this.res_npf.Cero);console.log("uno2 ? ",this.res_npf.Uno2,"; dos2 ? ",this.res_npf.Dos2,"; Cero2 ? ",this.res_npf.Cero2);console.log("**");console.log("uno ? ",this.res_npf.Uno,"; dos ? ",this.res_npf.Dos,"; Cero ? ",this.res_npf.Cero);console.log("uno2 ? ",this.res_npf.Uno2,"; dos2 ? ",this.res_npf.Dos2,"; Cero2 ? ",this.res_npf.Cero2);this.res_npf.cprevia=this.res_npf.Uno+this.res_npf.Dos;this.res_npf.cpreviaIzq=0;this.res_npf.cpreviaDer=this.res_npf.Uno2+this.res_npf.Dos2;if(this.res_npf.cpreviaDer>=1000000){this.res_npf.cpreviaIzq=this.res_npf.cprevia-this.res_npf.cpreviaDer;}else{this.res_npf.cpreviaIzq=this.res_npf.cprevia;}/* ================================================================================================= *//*  COMPARADOR DE RANGOS */var comp1=this.res_npf.cpreviaIzq>=21&&this.res_npf.cpreviaIzq<=25;if(comp1===true){this.res_npf.rango=1;}var comp2=this.res_npf.cpreviaIzq>=26&&this.res_npf.cpreviaIzq<=28;if(comp2===true){this.res_npf.rango=2;}var comp3=this.res_npf.cpreviaIzq>=29&&this.res_npf.cpreviaIzq<=31;if(comp3===true){this.res_npf.rango=3;}var comp4=this.res_npf.cpreviaIzq>=32&&this.res_npf.cpreviaIzq<=34;if(comp4===true){this.res_npf.rango=4;}var comp5=this.res_npf.cpreviaIzq>=35&&this.res_npf.cpreviaIzq<=37;if(comp5===true){this.res_npf.rango=5;}var comp6=this.res_npf.cpreviaIzq>=38&&this.res_npf.cpreviaIzq<=39;if(comp6===true){this.res_npf.rango=6;}var comp7=this.res_npf.cpreviaIzq>=40&&this.res_npf.cpreviaIzq<=44;if(comp7===true){this.res_npf.rango=7;}var comp8=this.res_npf.cpreviaIzq>=45&&this.res_npf.cpreviaIzq<=51;if(comp8===true){this.res_npf.rango=8;}var comp9=this.res_npf.cpreviaIzq>=52&&this.res_npf.cpreviaIzq<=68;if(comp9===true){this.res_npf.rango=9;}if(this.res_npf.cpreviaDer>=10){this.res_npf.rango=this.res_npf.rango-1;}this.res_npf.rangos=this.res_npf.rango;console.log("El rango es ? ",this.res_npf.rangos);},resultadosnpf:function resultadosnpf(doc){this.rangosnpf();doc.setLineWidth(0.25);doc.text(10,70,"SECCION DE RESULTADOS ");doc.line(10,71,206,71);doc.text(10,74,"Conteo:       ( 0= ");doc.text(35,74,this.res_npf.Uno.toString());doc.text(38,74,", 1= ");doc.text(45,74,this.res_npf.Dos.toString());doc.text(49,74,", 2= ");doc.text(56,74,this.res_npf.Cero.toString());doc.text(59,74," )");doc.text(70,74,"( 0= ");doc.text(78,74,this.res_npf.Uno2.toString());doc.text(81,74,", 1= ");doc.text(88,74,this.res_npf.Dos2.toString());doc.text(91,74,", 2= ");doc.text(98,74,this.res_npf.Cero2.toString());doc.text(101,74," )");doc.text(10,80,"Resultados: [ ");doc.text(30,80,this.res_npf.cpreviaIzq.toString());doc.text(35,80,", ");doc.text(40,80,this.res_npf.cpreviaDer.toString());doc.text(45,80," ] ");doc.text(10,85,"Rangos: ");doc.text(28,85,this.res_npf.rangos.toString());// doc.text(28, 85, this.res_npf.rangos.toString());
},respuestasnpf:function respuestasnpf(doc){/* Muestra las preguntas *//* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */doc.setLineWidth(0.25);doc.text(10,40,"SECCION DE RESPUESTAS ");doc.line(10,42,206,42);doc.text(10,45,this.eval_npf.pg001==="a"?"| 01= (a)":this.eval_npf.pg001==="b"?"| 01= (b)":"| 01= (c)");doc.text(23,45,this.eval_npf.pg002==="a"?"| 02= (a)":this.eval_npf.pg002==="b"?"| 02= (b)":"| 02= (c)");doc.text(36,45,this.eval_npf.pg003==="a"?"| 03= (a)":this.eval_npf.pg003==="b"?"| 03= (b)":"| 03= (c)");doc.text(49,45,this.eval_npf.pg004==="a"?"| 04= (a)":this.eval_npf.pg004==="b"?"| 04= (b)":"| 04= (c)");doc.text(62,45,this.eval_npf.pg005==="a"?"| 05= (a)":this.eval_npf.pg005==="b"?"| 05= (b)":"| 05= (c)");doc.text(75,45,this.eval_npf.pg006==="a"?"| 06= (a)":this.eval_npf.pg006==="b"?"| 06= (b)":"| 06= (c)");doc.text(88,45,this.eval_npf.pg007==="a"?"| 07= (a)":this.eval_npf.pg007==="b"?"| 07= (b)":"| 07= (c)");doc.text(101,45,this.eval_npf.pg008==="a"?"| 08= (a)":this.eval_npf.pg008==="b"?"| 08= (b)":"| 08= (c)");doc.text(114,45,this.eval_npf.pg009==="a"?"| 09= (a)":this.eval_npf.pg009==="b"?"| 09= (b)":"| 09= (c)");doc.text(127,45,this.eval_npf.pg010==="a"?"| 10= (a)":this.eval_npf.pg010==="b"?"| 10= (b)":"| 10= (c)");doc.text(140,45,this.eval_npf.pg011==="a"?"| 11= (a)":this.eval_npf.pg011==="b"?"| 11= (b)":"| 11= (c)");doc.text(153,45,this.eval_npf.pg012==="a"?"| 12= (a)":this.eval_npf.pg012==="b"?"| 12= (b)":"| 12= (c)");doc.text(166,45,this.eval_npf.pg013==="a"?"| 13= (a)":this.eval_npf.pg013==="b"?"| 13= (b)":"| 13= (c)");doc.text(179,45,this.eval_npf.pg014==="a"?"| 14= (a)":this.eval_npf.pg014==="b"?"| 14= (b)":"| 14= (c)");doc.text(192,45,this.eval_npf.pg015==="a"?"| 15= (a) |":this.eval_npf.pg015==="b"?"| 15= (b) |":"| 15= (c) |");doc.line(10,46,206,46);doc.text(10,49,this.eval_npf.pg016==="a"?"| 16= (a)":this.eval_npf.pg016==="b"?"| 16= (b)":"| 16= (c)");doc.text(23,49,this.eval_npf.pg017==="a"?"| 17= (a)":this.eval_npf.pg017==="b"?"| 17= (b)":"| 17= (c)");doc.text(36,49,this.eval_npf.pg018==="a"?"| 18= (a)":this.eval_npf.pg018==="b"?"| 18= (b)":"| 18= (c)");doc.text(49,49,this.eval_npf.pg019==="a"?"| 19= (a)":this.eval_npf.pg019==="b"?"| 19= (b)":"| 19= (c)");doc.text(62,49,this.eval_npf.pg020==="a"?"| 20= (a)":this.eval_npf.pg020==="b"?"| 20= (b)":"| 20= (c)");doc.text(75,49,this.eval_npf.pg021==="a"?"| 21= (a)":this.eval_npf.pg021==="b"?"| 21= (b)":"| 21= (c)");doc.text(88,49,this.eval_npf.pg022==="a"?"| 22= (a)":this.eval_npf.pg022==="b"?"| 22= (b)":"| 22= (c)");doc.text(101,49,this.eval_npf.pg023==="a"?"| 23= (a)":this.eval_npf.pg023==="b"?"| 23= (b)":"| 23= (c)");doc.text(114,49,this.eval_npf.pg024==="a"?"| 24= (a)":this.eval_npf.pg024==="b"?"| 24= (b)":"| 24= (c)");doc.text(127,49,this.eval_npf.pg025==="a"?"| 25= (a)":this.eval_npf.pg025==="b"?"| 25= (b)":"| 25= (c)");doc.text(140,49,this.eval_npf.pg026==="a"?"| 26= (a)":this.eval_npf.pg026==="b"?"| 26= (b)":"| 26= (c)");doc.text(153,49,this.eval_npf.pg027==="a"?"| 27= (a)":this.eval_npf.pg027==="b"?"| 27= (b)":"| 27= (c)");doc.text(166,49,this.eval_npf.pg028==="a"?"| 28= (a)":this.eval_npf.pg028==="b"?"| 28= (b)":"| 28= (c)");doc.text(179,49,this.eval_npf.pg029==="a"?"| 29= (a)":this.eval_npf.pg029==="b"?"| 29= (b)":"| 29= (c)");doc.text(192,49,this.eval_npf.pg030==="a"?"| 30= (a) |":this.eval_npf.pg030==="b"?"| 30= (b) |":"| 30= (c) |");doc.line(10,50,206,50);doc.text(10,53,this.eval_npf.pg031==="a"?"| 31= (a)":this.eval_npf.pg031==="b"?"| 31= (b)":"| 31= (c)");doc.text(23,53,this.eval_npf.pg032==="a"?"| 32= (a)":this.eval_npf.pg032==="b"?"| 32= (b)":"| 32= (c)");doc.text(36,53,this.eval_npf.pg033==="a"?"| 33= (a)":this.eval_npf.pg033==="b"?"| 33= (b)":"| 33= (c)");doc.text(49,53,this.eval_npf.pg034==="a"?"| 34= (a)":this.eval_npf.pg034==="b"?"| 34= (b)":"| 34= (c)");doc.text(62,53,this.eval_npf.pg035==="a"?"| 35= (a)":this.eval_npf.pg035==="b"?"| 35= (b)":"| 35= (c)");doc.text(75,53,this.eval_npf.pg036==="a"?"| 36= (a)":this.eval_npf.pg036==="b"?"| 36= (b)":"| 36= (c)");doc.text(88,53,this.eval_npf.pg037==="a"?"| 37= (a)":this.eval_npf.pg037==="b"?"| 37= (b)":"| 37= (c)");doc.text(101,53,this.eval_npf.pg038==="a"?"| 38= (a)":this.eval_npf.pg038==="b"?"| 38= (b)":"| 38= (c)");doc.text(114,53,this.eval_npf.pg039==="a"?"| 39= (a)":this.eval_npf.pg039==="b"?"| 39= (b)":"| 39= (c)");doc.text(127,53,this.eval_npf.pg040==="a"?"| 40= (a)":this.eval_npf.pg040==="b"?"| 40= (b)":"| 40= (c)");doc.line(10,54,141,54);},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
crearPDF_cpf:function crearPDF_cpf(){/** CREACION DEL ARCHIVO PDF */var cadena=this.eval_cpf.nombre,patron=/ /g,nuevoValor="",nusuario=cadena.replace(patron,nuevoValor);var nArchivo="cpf_"+nusuario;console.log("archivo a crear ? ",nArchivo);var imagen="data:image/jpeg;base64,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";var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a('portrait');var linea=5;/** Muestra el logo.        (izq, top, ancho, alto) */doc.addImage(imagen,'JPEG',155,linea,50,20);/** fila, columna *//** CIRCULOS  */doc.setLineWidth(1);// Grosor de la línea del borde
doc.setDrawColor(0);/** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */var meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var lhoy=new Date();//lhoy=   lhoy.toString();
var ldia=lhoy.getDate();var lmes=meses[lhoy.getMonth()];var lanio=lhoy.getFullYear();// console.log("lhoy ? ",lhoy);
// console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
doc.setFontSize(9);doc.text(10,20,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);doc.text(10,30,"Evaluación de SOCIABILIDAD para "+this.eval_cpf.nombre+" de "+this.eval_cpf.empresa);//? Calculo de respuestas y resultados
this.respuestascpf(doc);this.resultadoscpf(doc);doc.save(nArchivo);doc.autoPrint();window.open(doc.output('bloburl'),'_blank');},rangoscpf:function rangoscpf(){switch(this.eval_cpf.pg001){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;console.log("Es a)");break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;console.log("Es b)");break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;console.log("Es c)");break;}console.log("uno ? ",this.res_cpf.Uno,"; dos ? ",this.res_cpf.Dos,"; Cero ? ",this.res_cpf.Cero);/* Resuelve para la pregunta 2 */switch(this.eval_cpf.pg002){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}/* Resuelve para la pregunta 3 */switch(this.eval_cpf.pg003){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}/* Resuelve para la pregunta 4 */switch(this.eval_cpf.pg004){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}/* Resuelve para la pregunta 5 */switch(this.eval_cpf.pg005){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}/* Resuelve para la pregunta 6 */switch(this.eval_cpf.pg006){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}/* Resuelve para la pregunta 3 */switch(this.eval_cpf.pg007){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}/* Resuelve para la pregunta 4 */switch(this.eval_cpf.pg008){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 9 *//* ======================================================== */switch(this.eval_cpf.pg009){case'a':this.res_cpf.Cero2=this.res_cpf.Cero2+1;break;case'b':this.res_cpf.Uno2=this.res_cpf.Uno2+1;break;case'c':this.res_cpf.Dos2=this.res_cpf.Dos2+2;break;}/* Resuelve para la pregunta 4 */switch(this.eval_cpf.pg010){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}/* Resuelve para la pregunta 4 */switch(this.eval_cpf.pg011){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}/* Resuelve para la pregunta 4 */switch(this.eval_cpf.pg012){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}/* Resuelve para la pregunta 4 */switch(this.eval_cpf.pg013){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 14 *//* ======================================================== */switch(this.eval_cpf.pg014){case'a':this.res_cpf.Dos2=this.res_cpf.Dos2+2;break;case'b':this.res_cpf.Uno2=this.res_cpf.Uno2+1;break;case'c':this.res_cpf.Cero2=this.res_cpf.Cero2+1;break;}switch(this.eval_cpf.pg015){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}/* Resuelve para la pregunta 16 */switch(this.eval_cpf.pg016){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}/* Resuelve para la pregunta 17 */switch(this.eval_cpf.pg017){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}switch(this.eval_cpf.pg018){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 19 *//* ======================================================== */console.log("a evaluar 19");switch(this.eval_cpf.pg019){case'a':this.res_cpf.Dos2=this.res_cpf.Dos2+2;break;case'b':this.res_cpf.Uno2=this.res_cpf.Uno2+1;console.log("19 es b !!");break;case'c':this.res_cpf.Cero2=this.res_cpf.Cero2+1;break;}switch(this.eval_cpf.pg020){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}/* Resuelve para la pregunta 17 */switch(this.eval_cpf.pg021){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}switch(this.eval_cpf.pg022){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 23 *//* ======================================================== */switch(this.eval_cpf.pg023){case'a':this.res_cpf.Cero2=this.res_cpf.Cero2+1;break;case'b':this.res_cpf.Uno2=this.res_cpf.Uno2+1;break;case'c':this.res_cpf.Dos2=this.res_cpf.Dos2+2;break;}switch(this.eval_cpf.pg024){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}switch(this.eval_cpf.pg025){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}switch(this.eval_cpf.pg026){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}switch(this.eval_cpf.pg027){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 28 *//* ======================================================== */switch(this.eval_cpf.pg028){case'a':this.res_cpf.Dos2=this.res_cpf.Dos2+2;break;case'b':this.res_cpf.Uno2=this.res_cpf.Uno2+1;break;case'c':this.res_cpf.Cero2=this.res_cpf.Cero2+1;break;}switch(this.eval_cpf.pg029){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}switch(this.eval_cpf.pg030){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}switch(this.eval_cpf.pg031){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}switch(this.eval_cpf.pg032){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}switch(this.eval_cpf.pg033){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}switch(this.eval_cpf.pg034){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}switch(this.eval_cpf.pg035){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}switch(this.eval_cpf.pg036){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}/* ======================================================== *//* CASO ESPECIAL *//* Resuelve para la pregunta 37 *//* ======================================================== */switch(this.eval_cpf.pg037){case'a':this.res_cpf.Cero2=this.res_cpf.Cero2+1;break;case'b':this.res_cpf.Uno2=this.res_cpf.Uno2+1;break;case'c':this.res_cpf.Dos2=this.res_cpf.Dos2+2;break;}switch(this.eval_cpf.pg038){case'a':this.res_cpf.Cero=this.res_cpf.Cero+1;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Dos=this.res_cpf.Dos+2;break;}switch(this.eval_cpf.pg039){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}switch(this.eval_cpf.pg040){case'a':this.res_cpf.Dos=this.res_cpf.Dos+2;break;case'b':this.res_cpf.Uno=this.res_cpf.Uno+1;break;case'c':this.res_cpf.Cero=this.res_cpf.Cero+1;break;}console.log(">>> PRIMERAS 15 PREGUNTAS");console.log("pg1 ? ",this.eval_cpf.pg001,"pg2 ? ",this.eval_cpf.pg002,"pg3 ? ",this.eval_cpf.pg003,"pg4 ? ",this.eval_cpf.pg004,"pg5 ? ",this.eval_cpf.pg005,"pg6 ? ",this.eval_cpf.pg006,"pg7 ? ",this.eval_cpf.pg007,"pg8 ? ",this.eval_cpf.pg008,"pg9 ? ",this.eval_cpf.pg009,"pg10 ? ",this.eval_cpf.pg010,"pg11 ? ",this.eval_cpf.pg011,"pg12 ? ",this.eval_cpf.pg012,"pg13 ? ",this.eval_cpf.pg013,"pg14 ? ",this.eval_cpf.pg014,"pg15 ? ",this.eval_cpf.pg015,"pg16 ? ",this.eval_cpf.pg016,"pg17 ? ",this.eval_cpf.pg017,"pg18 ? ",this.eval_cpf.pg018,"pg19 ? ",this.eval_cpf.pg019,"pg20 ? ",this.eval_cpf.pg020,"pg21 ? ",this.eval_cpf.pg021,"pg22 ? ",this.eval_cpf.pg022,"pg23 ? ",this.eval_cpf.pg023,"pg24 ? ",this.eval_cpf.pg024,"pg25 ? ",this.eval_cpf.pg025,"pg26 ? ",this.eval_cpf.pg026,"pg27 ? ",this.eval_cpf.pg027,"pg28 ? ",this.eval_cpf.pg028,"pg29 ? ",this.eval_cpf.pg029,"pg30 ? ",this.eval_cpf.pg030,"pg31 ? ",this.eval_cpf.pg031,"pg32 ? ",this.eval_cpf.pg032,"pg33 ? ",this.eval_cpf.pg033,"pg34 ? ",this.eval_cpf.pg034,"pg35 ? ",this.eval_cpf.pg035,"pg36 ? ",this.eval_cpf.pg036,"pg37 ? ",this.eval_cpf.pg037,"pg38 ? ",this.eval_cpf.pg038,"pg39 ? ",this.eval_cpf.pg039,"pg40 ? ",this.eval_cpf.pg040);console.log("uno ? ",this.res_cpf.Uno,"; dos ? ",this.res_cpf.Dos,"; Cero ? ",this.res_cpf.Cero);console.log("uno2 ? ",this.res_cpf.Uno2,"; dos2 ? ",this.res_cpf.Dos2,"; Cero2 ? ",this.res_cpf.Cero2);console.log("**");console.log("uno ? ",this.res_cpf.Uno,"; dos ? ",this.res_cpf.Dos,"; Cero ? ",this.res_cpf.Cero);console.log("uno2 ? ",this.res_cpf.Uno2,"; dos2 ? ",this.res_cpf.Dos2,"; Cero2 ? ",this.res_cpf.Cero2);this.res_cpf.cprevia=this.res_cpf.Uno+this.res_cpf.Dos;this.res_cpf.cpreviaIzq=0;this.res_cpf.cpreviaDer=this.res_cpf.Uno2+this.res_cpf.Dos2;if(this.res_cpf.cpreviaDer>=1000000){this.res_cpf.cpreviaIzq=this.res_cpf.cprevia-this.res_cpf.cpreviaDer;}else{this.res_cpf.cpreviaIzq=this.res_cpf.cprevia;}/* ================================================================================================= *//*  COMPARADOR DE RANGOS */var comp1=this.res_cpf.cpreviaIzq>=21&&this.res_cpf.cpreviaIzq<=25;if(comp1===true){this.res_cpf.rango=1;}var comp2=this.res_cpf.cpreviaIzq>=26&&this.res_cpf.cpreviaIzq<=28;if(comp2===true){this.res_cpf.rango=2;}var comp3=this.res_cpf.cpreviaIzq>=29&&this.res_cpf.cpreviaIzq<=31;if(comp3===true){this.res_cpf.rango=3;}var comp4=this.res_cpf.cpreviaIzq>=32&&this.res_cpf.cpreviaIzq<=34;if(comp4===true){this.res_cpf.rango=4;}var comp5=this.res_cpf.cpreviaIzq>=35&&this.res_cpf.cpreviaIzq<=37;if(comp5===true){this.res_cpf.rango=5;}var comp6=this.res_cpf.cpreviaIzq>=38&&this.res_cpf.cpreviaIzq<=39;if(comp6===true){this.res_cpf.rango=6;}var comp7=this.res_cpf.cpreviaIzq>=40&&this.res_cpf.cpreviaIzq<=44;if(comp7===true){this.res_cpf.rango=7;}var comp8=this.res_cpf.cpreviaIzq>=45&&this.res_cpf.cpreviaIzq<=51;if(comp8===true){this.res_cpf.rango=8;}var comp9=this.res_cpf.cpreviaIzq>=52&&this.res_cpf.cpreviaIzq<=68;if(comp9===true){this.res_cpf.rango=9;}if(this.res_cpf.cpreviaDer>=10){this.res_cpf.rango=this.res_cpf.rango-1;}this.res_cpf.rangos=this.res_cpf.rango;console.log("El rango es ? ",this.res_cpf.rangos);},// rangos()
resultadoscpf:function resultadoscpf(doc){this.rangoscpf();doc.setLineWidth(0.25);doc.text(10,70,"SECCION DE RESULTADOS ");doc.line(10,71,206,71);doc.text(10,74,"Conteo:       ( 0= ");doc.text(35,74,this.res_cpf.Uno.toString());doc.text(38,74,", 1= ");doc.text(45,74,this.res_cpf.Dos.toString());doc.text(49,74,", 2= ");doc.text(56,74,this.res_cpf.Cero.toString());doc.text(59,74," )");doc.text(70,74,"( 0= ");doc.text(78,74,this.res_cpf.Uno2.toString());doc.text(81,74,", 1= ");doc.text(88,74,this.res_cpf.Dos2.toString());doc.text(91,74,", 2= ");doc.text(98,74,this.res_cpf.Cero2.toString());doc.text(101,74," )");doc.text(10,80,"Resultados: [ ");doc.text(30,80,this.res_cpf.cpreviaIzq.toString());doc.text(35,80,", ");doc.text(40,80,this.res_cpf.cpreviaDer.toString());doc.text(45,80," ] ");doc.text(10,85,"Rangos: ");doc.text(28,85,this.res_cpf.rangos.toString());},respuestascpf:function respuestascpf(doc){/* Muestra las preguntas *//* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */doc.setLineWidth(0.25);doc.text(10,40,"SECCION DE RESPUESTAS ");doc.line(10,42,206,42);doc.text(10,45,this.eval_cpf.pg001==="a"?"| 01= (a)":this.eval_cpf.pg001==="b"?"| 01= (b)":"| 01= (c)");doc.text(23,45,this.eval_cpf.pg002==="a"?"| 02= (a)":this.eval_cpf.pg002==="b"?"| 02= (b)":"| 02= (c)");doc.text(36,45,this.eval_cpf.pg003==="a"?"| 03= (a)":this.eval_cpf.pg003==="b"?"| 03= (b)":"| 03= (c)");doc.text(49,45,this.eval_cpf.pg004==="a"?"| 04= (a)":this.eval_cpf.pg004==="b"?"| 04= (b)":"| 04= (c)");doc.text(62,45,this.eval_cpf.pg005==="a"?"| 05= (a)":this.eval_cpf.pg005==="b"?"| 05= (b)":"| 05= (c)");doc.text(75,45,this.eval_cpf.pg006==="a"?"| 06= (a)":this.eval_cpf.pg006==="b"?"| 06= (b)":"| 06= (c)");doc.text(88,45,this.eval_cpf.pg007==="a"?"| 07= (a)":this.eval_cpf.pg007==="b"?"| 07= (b)":"| 07= (c)");doc.text(101,45,this.eval_cpf.pg008==="a"?"| 08= (a)":this.eval_cpf.pg008==="b"?"| 08= (b)":"| 08= (c)");doc.text(114,45,this.eval_cpf.pg009==="a"?"| 09= (a)":this.eval_cpf.pg009==="b"?"| 09= (b)":"| 09= (c)");doc.text(127,45,this.eval_cpf.pg010==="a"?"| 10= (a)":this.eval_cpf.pg010==="b"?"| 10= (b)":"| 10= (c)");doc.text(140,45,this.eval_cpf.pg011==="a"?"| 11= (a)":this.eval_cpf.pg011==="b"?"| 11= (b)":"| 11= (c)");doc.text(153,45,this.eval_cpf.pg012==="a"?"| 12= (a)":this.eval_cpf.pg012==="b"?"| 12= (b)":"| 12= (c)");doc.text(166,45,this.eval_cpf.pg013==="a"?"| 13= (a)":this.eval_cpf.pg013==="b"?"| 13= (b)":"| 13= (c)");doc.text(179,45,this.eval_cpf.pg014==="a"?"| 14= (a)":this.eval_cpf.pg014==="b"?"| 14= (b)":"| 14= (c)");doc.text(192,45,this.eval_cpf.pg015==="a"?"| 15= (a) |":this.eval_cpf.pg015==="b"?"| 15= (b) |":"| 15= (c) |");doc.line(10,46,206,46);doc.text(10,49,this.eval_cpf.pg016==="a"?"| 16= (a)":this.eval_cpf.pg016==="b"?"| 16= (b)":"| 16= (c)");doc.text(23,49,this.eval_cpf.pg017==="a"?"| 17= (a)":this.eval_cpf.pg017==="b"?"| 17= (b)":"| 17= (c)");doc.text(36,49,this.eval_cpf.pg018==="a"?"| 18= (a)":this.eval_cpf.pg018==="b"?"| 18= (b)":"| 18= (c)");doc.text(49,49,this.eval_cpf.pg019==="a"?"| 19= (a)":this.eval_cpf.pg019==="b"?"| 19= (b)":"| 19= (c)");doc.text(62,49,this.eval_cpf.pg020==="a"?"| 20= (a)":this.eval_cpf.pg020==="b"?"| 20= (b)":"| 20= (c)");doc.text(75,49,this.eval_cpf.pg021==="a"?"| 21= (a)":this.eval_cpf.pg021==="b"?"| 21= (b)":"| 21= (c)");doc.text(88,49,this.eval_cpf.pg022==="a"?"| 22= (a)":this.eval_cpf.pg022==="b"?"| 22= (b)":"| 22= (c)");doc.text(101,49,this.eval_cpf.pg023==="a"?"| 23= (a)":this.eval_cpf.pg023==="b"?"| 23= (b)":"| 23= (c)");doc.text(114,49,this.eval_cpf.pg024==="a"?"| 24= (a)":this.eval_cpf.pg024==="b"?"| 24= (b)":"| 24= (c)");doc.text(127,49,this.eval_cpf.pg025==="a"?"| 25= (a)":this.eval_cpf.pg025==="b"?"| 25= (b)":"| 25= (c)");doc.text(140,49,this.eval_cpf.pg026==="a"?"| 26= (a)":this.eval_cpf.pg026==="b"?"| 26= (b)":"| 26= (c)");doc.text(153,49,this.eval_cpf.pg027==="a"?"| 27= (a)":this.eval_cpf.pg027==="b"?"| 27= (b)":"| 27= (c)");doc.text(166,49,this.eval_cpf.pg028==="a"?"| 28= (a)":this.eval_cpf.pg028==="b"?"| 28= (b)":"| 28= (c)");doc.text(179,49,this.eval_cpf.pg029==="a"?"| 29= (a)":this.eval_cpf.pg029==="b"?"| 29= (b)":"| 29= (c)");doc.text(192,49,this.eval_cpf.pg030==="a"?"| 30= (a) |":this.eval_cpf.pg030==="b"?"| 30= (b) |":"| 30= (c) |");doc.line(10,50,206,50);doc.text(10,53,this.eval_cpf.pg031==="a"?"| 31= (a)":this.eval_cpf.pg031==="b"?"| 31= (b)":"| 31= (c)");doc.text(23,53,this.eval_cpf.pg032==="a"?"| 32= (a)":this.eval_cpf.pg032==="b"?"| 32= (b)":"| 32= (c)");doc.text(36,53,this.eval_cpf.pg033==="a"?"| 33= (a)":this.eval_cpf.pg033==="b"?"| 33= (b)":"| 33= (c)");doc.text(49,53,this.eval_cpf.pg034==="a"?"| 34= (a)":this.eval_cpf.pg034==="b"?"| 34= (b)":"| 34= (c)");doc.text(62,53,this.eval_cpf.pg035==="a"?"| 35= (a)":this.eval_cpf.pg035==="b"?"| 35= (b)":"| 35= (c)");doc.text(75,53,this.eval_cpf.pg036==="a"?"| 36= (a)":this.eval_cpf.pg036==="b"?"| 36= (b)":"| 36= (c)");doc.text(88,53,this.eval_cpf.pg037==="a"?"| 37= (a)":this.eval_cpf.pg037==="b"?"| 37= (b)":"| 37= (c)");doc.text(101,53,this.eval_cpf.pg038==="a"?"| 38= (a)":this.eval_cpf.pg038==="b"?"| 38= (b)":"| 38= (c)");doc.text(114,53,this.eval_cpf.pg039==="a"?"| 39= (a)":this.eval_cpf.pg039==="b"?"| 39= (b)":"| 39= (c)");doc.text(127,53,this.eval_cpf.pg040==="a"?"| 40= (a)":this.eval_cpf.pg040==="b"?"| 40= (b)":"| 40= (c)");doc.line(10,54,141,54);},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
crearPDF_fig:function crearPDF_fig(){/** CREACION DEL ARCHIVO PDF */var cadena=this.eval_fig.nombre,patron=/ /g,nuevoValor="",nusuario=cadena.replace(patron,nuevoValor);var nArchivo="fig_"+nusuario;console.log("archivo a crear ? ",nArchivo);var imagen="data:image/jpeg;base64,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";var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a('portrait');var linea=5;/** Muestra el logo.        (izq, top, ancho, alto) */doc.addImage(imagen,'JPEG',155,linea,50,20);/** fila, columna *//** CIRCULOS  */doc.setLineWidth(1);// Grosor de la línea del borde
doc.setDrawColor(0);/** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */var meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var lhoy=new Date();//lhoy=   lhoy.toString();
var ldia=lhoy.getDate();var lmes=meses[lhoy.getMonth()];var lanio=lhoy.getFullYear();// console.log("lhoy ? ",lhoy);
// console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
doc.setFontSize(9);doc.text(10,20,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);doc.text(10,30,"Evaluación de PERFIL DE PERSONALIDAD para "+this.eval_fig.nombre+" de "+this.eval_fig.empresa);this.respuestasfig(doc);this.resultadosfig(doc);doc.save(nArchivo);doc.autoPrint();window.open(doc.output('bloburl'),'_blank');},rangosfig:function rangosfig(){this.res_fig={mas_D:0,menos_D:0,mas_I:0,menos_I:0,mas_S:0,menos_S:0,mas_C:0,menos_C:0,mas_N:0,menos_N:0,mas_W:0,menos_W:0,total_mas:0,total_menos:0};switch(this.eval_fig.pg001){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 2 */switch(this.eval_fig.pg002){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 3 */switch(this.eval_fig.pg003){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 4 */switch(this.eval_fig.pg004){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 5 */switch(this.eval_fig.pg005){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;case'N+':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 6 */switch(this.eval_fig.pg006){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 7 */switch(this.eval_fig.pg007){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 8 */switch(this.eval_fig.pg008){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 1 */switch(this.eval_fig.pg009){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 2 */switch(this.eval_fig.pg010){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 11 */switch(this.eval_fig.pg011){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;case'N+':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 12 */switch(this.eval_fig.pg012){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 13 */switch(this.eval_fig.pg013){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 14 */switch(this.eval_fig.pg014){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 15 */switch(this.eval_fig.pg015){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;case'N+':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 16 */switch(this.eval_fig.pg016){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;case'N+':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 17 */switch(this.eval_fig.pg017){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 18 */switch(this.eval_fig.pg018){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 19 */switch(this.eval_fig.pg019){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 11 */switch(this.eval_fig.pg020){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 12 */switch(this.eval_fig.pg021){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 18 */switch(this.eval_fig.pg022){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 23 */switch(this.eval_fig.pg023){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 24 */switch(this.eval_fig.pg024){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 25 */switch(this.eval_fig.pg025){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 26 */switch(this.eval_fig.pg026){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 27 */switch(this.eval_fig.pg027){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 28 */switch(this.eval_fig.pg028){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;case'N+':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 29 */switch(this.eval_fig.pg029){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 30 */switch(this.eval_fig.pg030){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 31 */switch(this.eval_fig.pg031){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 32 */switch(this.eval_fig.pg032){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 33 */switch(this.eval_fig.pg033){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 34 */switch(this.eval_fig.pg034){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 35 */switch(this.eval_fig.pg035){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 36 */switch(this.eval_fig.pg036){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;case'N+':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 37 */switch(this.eval_fig.pg037){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 38 */switch(this.eval_fig.pg038){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 39 */switch(this.eval_fig.pg039){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 40 */switch(this.eval_fig.pg040){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 41 */switch(this.eval_fig.pg041){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 42 */switch(this.eval_fig.pg042){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 43 */switch(this.eval_fig.pg043){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 44 */switch(this.eval_fig.pg044){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 45 */switch(this.eval_fig.pg045){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 46 */switch(this.eval_fig.pg046){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}/* Resuelve para la pregunta 47 */switch(this.eval_fig.pg047){case'D':this.res_fig.mas_D=this.res_fig.mas_D+1;break;case'I':this.res_fig.mas_I=this.res_fig.mas_I+1;break;case'S':this.res_fig.mas_S=this.res_fig.mas_S+1;break;case'C':this.res_fig.mas_C=this.res_fig.mas_C+1;break;case'N':this.res_fig.mas_N=this.res_fig.mas_N+1;break;default:this.res_fig.mas_W=this.res_fig.mas_W+1;}/* Resuelve para la pregunta 48 */switch(this.eval_fig.pg048){case'D':this.res_fig.menos_D=this.res_fig.menos_D+1;break;case'I':this.res_fig.menos_I=this.res_fig.menos_I+1;break;case'S':this.res_fig.menos_S=this.res_fig.menos_S+1;break;case'C':this.res_fig.menos_C=this.res_fig.menos_C+1;break;case'N':this.res_fig.menos_N=this.res_fig.menos_N+1;break;default:this.res_fig.menos_W=this.res_fig.menos_W+1;}this.res_fig.total_mas=this.res_fig.mas_D+this.res_fig.mas_I+this.res_fig.mas_S+this.res_fig.mas_C+this.res_fig.mas_N;this.res_fig.total_menos=this.res_fig.menos_D+this.res_fig.menos_I+this.res_fig.menos_S+this.res_fig.menos_C+this.res_fig.menos_N;},resultadosfig:function resultadosfig(doc){this.rangosfig();console.log("***-*-*-*-****---*******");console.log("resultados ? ",this.res_fig);doc.setLineWidth(0.25);doc.text(10,88,"SECCION DE RESULTADOS ");doc.line(10,89,190,89);var menos_D=this.res_fig.menos_D;var mas_D=this.res_fig.mas_D;var difD=mas_D-menos_D;doc.text(20,94,"MAS");doc.text(30,94,"MENOS");doc.text(50,94,"DIFERENCIA");doc.text(20,96,"-------");doc.text(30,96,"-----------");doc.text(50,96,"-------------------");doc.text(10,100,"D");doc.text(22,100,mas_D.toString());doc.text(35,100,menos_D.toString());doc.text(57,100,difD.toString());var menos_I=this.res_fig.menos_I;var mas_I=this.res_fig.mas_I;var difI=mas_I-menos_I;doc.text(10,105,"I");doc.text(22,105,mas_I.toString());doc.text(35,105,menos_I.toString());doc.text(57,105,difI.toString());var menos_S=this.res_fig.menos_S;var mas_S=this.res_fig.mas_S;var difS=mas_S-menos_S;doc.text(10,110,"S");doc.text(22,110,mas_S.toString());doc.text(35,110,menos_S.toString());doc.text(57,110,difS.toString());var menos_C=this.res_fig.menos_C;var mas_C=this.res_fig.mas_C;var difC=mas_C-menos_C;doc.text(10,115,"C");doc.text(22,115,mas_C.toString());doc.text(35,115,menos_C.toString());doc.text(57,115,difC.toString());var menos_N=this.res_fig.menos_N;var mas_N=this.res_fig.mas_N;var difN=mas_N-menos_N;doc.text(10,120,"N");doc.text(22,120,mas_N.toString());doc.text(35,120,menos_N.toString());doc.text(57,120,difN.toString());doc.text(20,122,"-------");doc.text(30,122,"-----------");doc.text(50,122,"-------------------");var total_mas=0;var total_menos=0;total_mas=mas_D+mas_I+mas_S+mas_C+mas_N;total_menos=menos_D+menos_I+menos_S+menos_C+menos_N;doc.text(22,125,total_mas.toString());doc.text(35,125,total_menos.toString());},respuestasfig:function respuestasfig(doc){/* Muestra las preguntas *//* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */doc.setLineWidth(0.25);doc.text(10,40,"SECCION DE RESPUESTAS ");doc.line(10,42,190,42);doc.text(10,45,"01= ");doc.text(23,45,this.eval_fig.pg001);doc.text(30,45,"03= ");doc.text(43,45,this.eval_fig.pg003);doc.text(50,45,"05= ");doc.text(63,45,this.eval_fig.pg005);doc.text(70,45,"07= ");doc.text(83,45,this.eval_fig.pg007);doc.text(90,45,"09= ");doc.text(103,45,this.eval_fig.pg009);doc.text(110,45,"11= ");doc.text(123,45,this.eval_fig.pg011);doc.text(130,45,"13= ");doc.text(143,45,this.eval_fig.pg013);doc.text(150,45,"15= ");doc.text(163,45,this.eval_fig.pg015);doc.text(170,45,"17= ");doc.text(183,45,this.eval_fig.pg017);doc.line(10,46,190,46);doc.text(10,49,"19= ");doc.text(23,49,this.eval_fig.pg019);doc.text(30,49,"21= ");doc.text(43,49,this.eval_fig.pg021);doc.text(50,49,"23= ");doc.text(63,49,this.eval_fig.pg023);doc.text(70,49,"25= ");doc.text(83,49,this.eval_fig.pg025);doc.text(90,49,"27= ");doc.text(103,49,this.eval_fig.pg027);doc.text(110,49,"29= ");doc.text(123,49,this.eval_fig.pg029);doc.text(130,49,"31= ");doc.text(143,49,this.eval_fig.pg031);doc.text(150,49,"33= ");doc.text(163,49,this.eval_fig.pg033);doc.text(170,49,"35= ");doc.text(183,49,this.eval_fig.pg035);doc.line(10,50,190,50);doc.text(10,53,"37= ");doc.text(23,53,this.eval_fig.pg037);doc.text(30,53,"39= ");doc.text(43,53,this.eval_fig.pg039);doc.text(50,53,"41= ");doc.text(63,53,this.eval_fig.pg041);doc.text(70,53,"43= ");doc.text(83,53,this.eval_fig.pg043);doc.text(90,53,"45= ");doc.text(103,53,this.eval_fig.pg045);doc.text(110,53,"47= ");doc.text(123,53,this.eval_fig.pg047);doc.line(10,54,130,54);doc.line(10,62,190,62);doc.text(10,65,"02= ");doc.text(23,65,this.eval_fig.pg002);doc.text(30,65,"04= ");doc.text(43,65,this.eval_fig.pg004);doc.text(50,65,"06= ");doc.text(63,65,this.eval_fig.pg006);doc.text(70,65,"08= ");doc.text(83,65,this.eval_fig.pg008);doc.text(90,65,"10= ");doc.text(103,65,this.eval_fig.pg010);doc.text(110,65,"12= ");doc.text(123,65,this.eval_fig.pg012);doc.text(130,65,"14= ");doc.text(143,65,this.eval_fig.pg014);doc.text(150,65,"16= ");doc.text(163,65,this.eval_fig.pg016);doc.text(170,65,"18= ");doc.text(183,65,this.eval_fig.pg018);doc.line(10,66,190,66);doc.text(10,69,"20= ");doc.text(23,69,this.eval_fig.pg020);doc.text(30,69,"22= ");doc.text(43,69,this.eval_fig.pg022);doc.text(50,69,"24= ");doc.text(63,69,this.eval_fig.pg024);doc.text(70,69,"26= ");doc.text(83,69,this.eval_fig.pg026);doc.text(90,69,"28= ");doc.text(103,69,this.eval_fig.pg028);doc.text(110,69,"30= ");doc.text(123,69,this.eval_fig.pg030);doc.text(130,69,"32= ");doc.text(143,69,this.eval_fig.pg032);doc.text(150,69,"34= ");doc.text(163,69,this.eval_fig.pg034);doc.text(170,69,"36= ");doc.text(183,69,this.eval_fig.pg036);doc.line(10,70,190,70);doc.text(10,73,"38= ");doc.text(23,73,this.eval_fig.pg038);doc.text(30,73,"40= ");doc.text(43,73,this.eval_fig.pg040);doc.text(50,73,"42= ");doc.text(63,73,this.eval_fig.pg042);doc.text(70,73,"44= ");doc.text(83,73,this.eval_fig.pg044);doc.text(90,73,"46= ");doc.text(103,73,this.eval_fig.pg046);doc.text(110,73,"48= ");doc.text(123,73,this.eval_fig.pg048);doc.line(10,74,130,74);},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
crearPDF_moss:function crearPDF_moss(){/** CREACION DEL ARCHIVO PDF */var cadena=this.eval_moss.nombre,patron=/ /g,nuevoValor="",nusuario=cadena.replace(patron,nuevoValor);var nArchivo="moss_"+nusuario;console.log("archivo a crear ? ",nArchivo);var imagen="data:image/jpeg;base64,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";var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a('portrait');var linea=5;/** Muestra el logo.        (izq, top, ancho, alto) */doc.addImage(imagen,'JPEG',155,linea,50,20);/** fila, columna *//** CIRCULOS  */doc.setLineWidth(1);// Grosor de la línea del borde
doc.setDrawColor(0);/** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */var meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var lhoy=new Date();//lhoy=   lhoy.toString();
var ldia=lhoy.getDate();var lmes=meses[lhoy.getMonth()];var lanio=lhoy.getFullYear();// console.log("lhoy ? ",lhoy);
// console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
doc.setFontSize(9);doc.text(10,20,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);doc.text(10,30,"Evaluación de SUPERVISION para "+this.eval_moss.nombre+" de "+this.eval_moss.empresa);this.respuestasmoss(doc);this.resultadosmoss(doc);doc.save(nArchivo);doc.autoPrint();window.open(doc.output('bloburl'),'_blank');},rangosmoss:function rangosmoss(){/* ================================================================================= *//* Conteo para HR */if(this.eval_moss.pg001==="c"){this.res_moss.hr=this.res_moss.hr+1;}if(this.eval_moss.pg010==="c"){this.res_moss.hr=this.res_moss.hr+1;}if(this.eval_moss.pg011==="a"){this.res_moss.hr=this.res_moss.hr+1;}if(this.eval_moss.pg013==="d"){this.res_moss.hr=this.res_moss.hr+1;}if(this.eval_moss.pg025==="b"){this.res_moss.hr=this.res_moss.hr+1;}/* ================================================================================= *//* Conteo para HS */if(this.eval_moss.pg002==="b"){this.res_moss.hs=this.res_moss.hs+1;}if(this.eval_moss.pg003==="d"){this.res_moss.hs=this.res_moss.hs+1;}if(this.eval_moss.pg016==="d"){this.res_moss.hs=this.res_moss.hs+1;}if(this.eval_moss.pg018==="d"){this.res_moss.hs=this.res_moss.hs+1;}if(this.eval_moss.pg024==="d"){this.res_moss.hs=this.res_moss.hs+1;}if(this.eval_moss.pg030==="a"){this.res_moss.hs=this.res_moss.hs+1;}/* ================================================================================= *//* Conteo para CD */if(this.eval_moss.pg004==="b"){this.res_moss.cd=this.res_moss.cd+1;}if(this.eval_moss.pg006==="b"){this.res_moss.cd=this.res_moss.cd+1;}if(this.eval_moss.pg020==="b"){this.res_moss.cd=this.res_moss.cd+1;}if(this.eval_moss.pg023==="a"){this.res_moss.cd=this.res_moss.cd+1;}if(this.eval_moss.pg029==="c"){this.res_moss.cd=this.res_moss.cd+1;}/* ================================================================================= *//* Conteo para SC */if(this.eval_moss.pg005==="b"){this.res_moss.sc=this.res_moss.sc+1;}if(this.eval_moss.pg008==="b"){this.res_moss.sc=this.res_moss.sc+1;}if(this.eval_moss.pg015==="d"){this.res_moss.sc=this.res_moss.sc+1;}if(this.eval_moss.pg017==="b"){this.res_moss.sc=this.res_moss.sc+1;}if(this.eval_moss.pg022==="a"){this.res_moss.sc=this.res_moss.sc+1;}if(this.eval_moss.pg028==="c"){this.res_moss.sc=this.res_moss.sc+1;}/* ================================================================================= *//* Conteo para CE */if(this.eval_moss.pg007==="b"){this.res_moss.ce=this.res_moss.ce+1;}if(this.eval_moss.pg009==="c"){this.res_moss.ce=this.res_moss.ce+1;}if(this.eval_moss.pg012==="c"){this.res_moss.ce=this.res_moss.ce+1;}if(this.eval_moss.pg014==="d"){this.res_moss.ce=this.res_moss.ce+1;}if(this.eval_moss.pg019==="c"){this.res_moss.ce=this.res_moss.ce+1;}if(this.eval_moss.pg021==="a"){this.res_moss.ce=this.res_moss.ce+1;}if(this.eval_moss.pg026==="c"){this.res_moss.ce=this.res_moss.ce+1;}if(this.eval_moss.pg027==="a"){this.res_moss.ce=this.res_moss.ce+1;}/* ================================================================================= *//* ================================================================================= *//* Conteo de todos los aciertos */this.res_moss.aciertos=0;this.res_moss.aciertos=this.res_moss.hs+this.res_moss.cd+this.res_moss.ce+this.res_moss.hr+this.res_moss.sc;/* Busca el rango que le corresponde */this.res_moss.rangosHS='';var comp1=this.res_moss.aciertos>=0&&this.res_moss.aciertos<=8;if(comp1===true){this.res_moss.rangosHS='INFERIOR';}var comp2=this.res_moss.aciertos>=9&&this.res_moss.aciertos<=11;if(comp2===true){this.res_moss.rangosHS='POBRE';}var comp3=this.res_moss.aciertos>=12&&this.res_moss.aciertos<=18;if(comp3===true){this.res_moss.rangosHS='MEDIO';}var comp4=this.res_moss.aciertos>=19&&this.res_moss.aciertos<=23;if(comp4===true){this.res_moss.rangosHS='BUENO';}var comp5=this.res_moss.aciertos>=24&&this.res_moss.aciertos<=30;if(comp5===true){this.res_moss.rangosHS='SUPERIOR';}},resultadosmoss:function resultadosmoss(doc){this.res_moss={hs:0,cd:0,ce:0,hr:0,sc:0,aciertos:0,percentilHS:0,rangoHS:""};this.rangosmoss();doc.setLineWidth(0.25);doc.text(10,88,"SECCION DE RESULTADOS ");doc.line(10,89,195,89);var aciertos=this.res_moss.aciertos;var rangosHS=this.res_moss.rangosHS;var hs=this.res_moss.hs;var cd=this.res_moss.cd;var ce=this.res_moss.ce;var hr=this.res_moss.hr;var sc=this.res_moss.sc;doc.text(20,94,"Pc.");doc.text(30,94,"RESULTADOS");doc.text(63,94,"RANGO");doc.text(20,96,"-------");doc.text(30,96,"--------------------");doc.text(60,96,"-------------------");doc.text(10,100,"[HS]");doc.text(22,100,hs.toString());doc.text(35,100,aciertos.toString());doc.text(62,100,rangosHS);doc.text(10,105,"[CD]");doc.text(22,105,cd.toString());doc.text(10,110,"[CE]");doc.text(22,110,ce.toString());doc.text(10,115,"[HR]");doc.text(22,115,hr.toString());doc.text(10,120,"[SC]");doc.text(22,120,sc.toString());doc.text(20,122,"-------");doc.text(30,122,"--------------------");doc.text(60,122,"-------------------");var desaciertos=30-aciertos;doc.text(10,127,"Aciertos ? ");doc.text(25,127,aciertos.toString());doc.text(32,127,"No Aciertos ? ");doc.text(52,127,desaciertos.toString());},respuestasmoss:function respuestasmoss(doc){/* Muestra las preguntas *//* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */doc.setLineWidth(0.25);doc.text(10,40,"SECCION DE RESPUESTAS ");doc.line(10,42,190,42);doc.text(10,45,"01= ");doc.text(23,45,this.eval_moss.pg001);doc.text(30,45,"02= ");doc.text(43,45,this.eval_moss.pg002);doc.text(50,45,"03= ");doc.text(63,45,this.eval_moss.pg003);doc.text(70,45,"04= ");doc.text(83,45,this.eval_moss.pg004);doc.text(90,45,"05= ");doc.text(103,45,this.eval_moss.pg005);doc.text(110,45,"06= ");doc.text(123,45,this.eval_moss.pg006);doc.text(130,45,"07= ");doc.text(143,45,this.eval_moss.pg007);doc.text(150,45,"08= ");doc.text(163,45,this.eval_moss.pg008);doc.text(170,45,"09= ");doc.text(183,45,this.eval_moss.pg009);doc.line(10,46,190,46);doc.text(10,49,"10= ");doc.text(23,49,this.eval_moss.pg010);doc.text(30,49,"11= ");doc.text(43,49,this.eval_moss.pg011);doc.text(50,49,"12= ");doc.text(63,49,this.eval_moss.pg012);doc.text(70,49,"13= ");doc.text(83,49,this.eval_moss.pg013);doc.text(90,49,"14= ");doc.text(103,49,this.eval_moss.pg014);doc.text(110,49,"15= ");doc.text(123,49,this.eval_moss.pg015);doc.text(130,49,"16= ");doc.text(143,49,this.eval_moss.pg016);doc.text(150,49,"17= ");doc.text(163,49,this.eval_moss.pg017);doc.text(170,49,"18= ");doc.text(183,49,this.eval_moss.pg018);doc.line(10,50,190,50);doc.text(10,53,"19= ");doc.text(23,53,this.eval_moss.pg019);doc.text(30,53,"20= ");doc.text(43,53,this.eval_moss.pg020);doc.text(50,53,"21= ");doc.text(63,53,this.eval_moss.pg021);doc.text(70,53,"22= ");doc.text(83,53,this.eval_moss.pg022);doc.text(90,53,"23= ");doc.text(103,53,this.eval_moss.pg023);doc.text(110,53,"24= ");doc.text(123,53,this.eval_moss.pg024);doc.text(130,53,"25= ");doc.text(143,53,this.eval_moss.pg025);doc.text(150,53,"26= ");doc.text(163,53,this.eval_moss.pg026);doc.text(170,53,"27= ");doc.text(183,53,this.eval_moss.pg027);doc.line(10,54,190,54);doc.text(10,57,"28= ");doc.text(23,57,this.eval_moss.pg028);doc.text(30,57,"29= ");doc.text(43,57,this.eval_moss.pg029);doc.text(50,57,"30= ");doc.text(63,57,this.eval_moss.pg030);doc.line(10,59,65,59);},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
crearPDF_tav:function crearPDF_tav(){/** CREACION DEL ARCHIVO PDF */var cadena=this.eval_tav.nombre,patron=/ /g,nuevoValor="",nusuario=cadena.replace(patron,nuevoValor);var nArchivo="tav_"+nusuario;console.log("archivo a crear ? ",nArchivo);var imagen="data:image/jpeg;base64,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";var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a('portrait');var linea=5;/** Muestra el logo.        (izq, top, ancho, alto) */doc.addImage(imagen,'JPEG',155,linea,50,20);/** fila, columna *//** CIRCULOS  */doc.setLineWidth(1);// Grosor de la línea del borde
doc.setDrawColor(0);/** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */var meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var lhoy=new Date();//lhoy=   lhoy.toString();
var ldia=lhoy.getDate();var lmes=meses[lhoy.getMonth()];var lanio=lhoy.getFullYear();// console.log("lhoy ? ",lhoy);
// console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
doc.setFontSize(9);doc.text(10,20,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);doc.text(10,30,"Evaluación de APTITUD EN VENTAS para "+this.eval_tav.nombre+" de "+this.eval_tav.empresa);this.respuestastav(doc);this.resultadostav(doc);doc.save(nArchivo);doc.autoPrint();window.open(doc.output('bloburl'),'_blank');},rangostav:function rangostav(){/* ============================================================================================= *//* Pregunta 1 */if(this.eval_tav.pg001==='a'){this.res_tav.aciertos=this.res_tav.aciertos+1;}else{if(this.eval_tav.pg001==='c'){this.res_tav.errores=this.res_tav.errores+2;}}/* ============================================================================================= *//* Pregunta 2 */if(this.eval_tav.pg002==='d'){this.res_tav.errores=this.res_tav.errores+2;}/* ============================================================================================= *//* Pregunta 3 */if(this.eval_tav.pg003==='a'){this.res_tav.errores=this.res_tav.errores+1;}else{if(this.eval_tav.pg003==='b'){this.res_tav.errores=this.res_tav.errores+1;}else{if(this.eval_tav.pg003==='d'){this.res_tav.aciertos=this.res_tav.aciertos+2;}}}/* ============================================================================================= *//* Pregunta 4 */if(this.eval_tav.pg004==='a'){this.res_tav.aciertos=this.res_tav.aciertos+1;}else{if(this.eval_tav.pg004==='c'){this.res_tav.errores=this.res_tav.errores+2;}}/* ============================================================================================= *//* Pregunta 5 */if(this.eval_tav.pg005==='b'){this.res_tav.errores=this.res_tav.errores+2;}/* ============================================================================================= *//* Pregunta 6 *//*  NO TIENE PONDERACION *//* ============================================================================================= *//* Pregunta 7 */if(this.eval_tav.pg007==='b'){this.res_tav.errores=this.res_tav.errores+2;}else{if(this.eval_tav.pg007==='d'){this.res_tav.aciertos=this.res_tav.aciertos+2;}}/* ============================================================================================= *//* Pregunta 8 */if(this.eval_tav.pg008==='a'){this.res_tav.errores=this.res_tav.errores+2;}else{if(this.eval_tav.pg008==='b'){this.res_tav.aciertos=this.res_tav.aciertos+2;}else{if(this.eval_tav.pg008==='c'){this.res_tav.aciertos=this.res_tav.aciertos+1;}}}/* ============================================================================================= *//* Pregunta 9 */if(this.eval_tav.pg009==='b'){this.res_tav.aciertos=this.res_tav.aciertos+1;}else{if(this.eval_tav.pg009==='d'){this.res_tav.errores=this.res_tav.errores+1;}}/* ============================================================================================= *//* Pregunta 10 */if(this.eval_tav.pg010==='a'){this.res_tav.aciertos=this.res_tav.aciertos+1;}else{if(this.eval_tav.pg010==='b'){this.res_tav.errores=this.res_tav.errores+1;}else{if(this.eval_tav.pg010==='c'){this.res_tav.errores=this.res_tav.errores+2;}else{if(this.eval_tav.pg010==='d'){this.res_tav.aciertos=this.res_tav.aciertos+2;}}}}/* ============================================================================================= *//* Pregunta 11 */if(this.eval_tav.pg011==='a'){this.res_tav.errores=this.res_tav.errores+2;}else{if(this.eval_tav.pg011==='b'){this.res_tav.aciertos=this.res_tav.aciertos+2;}}/* ============================================================================================= *//* Pregunta 12 */if(this.eval_tav.pg012==='b'){this.res_tav.aciertos=this.res_tav.aciertos+2;}/* ============================================================================================= *//* Pregunta 13 *//*  NO TIENE PONDERACION *//* ============================================================================================= *//* Pregunta 14 */if(this.eval_tav.pg014==='a'){this.res_tav.errores=this.res_tav.errores+1;}else{if(this.eval_tav.pg014==='c'){this.res_tav.aciertos=this.res_tav.aciertos+1;}}/* ============================================================================================= *//* Pregunta 15 */if(this.eval_tav.pg015==='b'){this.res_tav.errores=this.res_tav.errores+1;}/* ============================================================================================= *//* Pregunta 16 */if(this.eval_tav.pg016==='b'){this.res_tav.errores=this.res_tav.errores+2;}/* ============================================================================================= *//* Pregunta 17 */if(this.eval_tav.pg017==='a'){this.res_tav.errores=this.res_tav.errores+1;}else{if(this.eval_tav.pg017==='b'){this.res_tav.aciertos=this.res_tav.aciertos+1;}}/* ============================================================================================= *//* Pregunta 18 */if(this.eval_tav.pg018==='c'){this.res_tav.errores=this.res_tav.errores+2;}/* ============================================================================================= *//* Pregunta 19 */if(this.eval_tav.pg019==='a'){this.res_tav.errores=this.res_tav.errores+2;}else{if(this.eval_tav.pg019==='d'){this.res_tav.aciertos=this.res_tav.aciertos+2;}}/* ============================================================================================= *//* Pregunta 20 */if(this.eval_tav.pg020==='a'){this.res_tav.aciertos=this.res_tav.aciertos+2;}else{if(this.eval_tav.pg020==='d'){this.res_tav.errores=this.res_tav.errores+2;}}/* ============================================================================================= *//* Pregunta 21 */if(this.eval_tav.pg021==='b'){this.res_tav.errores=this.res_tav.errores+2;}else{if(this.eval_tav.pg021==='c'){this.res_tav.aciertos=this.res_tav.aciertos+2;}}/* ============================================================================================= *//* Pregunta 22 */if(this.eval_tav.pg022==='c'){this.res_tav.errores=this.res_tav.errores+2;}else{if(this.eval_tav.pg022==='d'){this.res_tav.aciertos=this.res_tav.aciertos+1;}}/* ============================================================================================= *//* Pregunta 23 */if(this.eval_tav.pg023==='b'){this.res_tav.errores=this.res_tav.errores+1;}else{if(this.eval_tav.pg023==='c'){this.res_tav.aciertos=this.res_tav.aciertos+1;}}/* ============================================================================================= *//* Pregunta 24 *//*  NO TIENE PONDERACION *//* ============================================================================================= *//* Pregunta 25 */if(this.eval_tav.pg025==='b'){this.res_tav.aciertos=this.res_tav.aciertos+1;}else{if(this.eval_tav.pg025==='c'){this.res_tav.errores=this.res_tav.errores+1;}else{if(this.eval_tav.pg025==='d'){this.res_tav.errores=this.res_tav.errores+2;}}}/* ============================================================================================= *//* Pregunta 26 */if(this.eval_tav.pg026==='b'){this.res_tav.aciertos=this.res_tav.aciertos+1;}else{if(this.eval_tav.pg026==='c'){this.res_tav.errores=this.res_tav.errores+1;}}/* ============================================================================================= *//* Pregunta 27 */if(this.eval_tav.pg027==='d'){this.res_tav.aciertos=this.res_tav.aciertos+2;}/* ============================================================================================= *//* Pregunta 28 */if(this.eval_tav.pg028==='a'){this.res_tav.errores=this.res_tav.errores+2;}else{if(this.eval_tav.pg028==='b'){this.res_tav.aciertos=this.res_tav.aciertos+2;}else{if(this.eval_tav.pg028==='c'){this.res_tav.aciertos=this.res_tav.aciertos+1;}else{if(this.eval_tav.pg028==='d'){this.res_tav.errores=this.res_tav.errores+1;}}}}/* ============================================================================================= *//* Pregunta 29 */if(this.eval_tav.pg029==='b'){this.res_tav.errores=this.res_tav.errores+2;}else{if(this.eval_tav.pg029==='c'){this.res_tav.aciertos=this.res_tav.aciertos+2;}else{if(this.eval_tav.pg029==='d'){this.res_tav.errores=this.res_tav.errores+1;}}}/* ============================================================================================= *//* Pregunta 30 */if(this.eval_tav.pg030==='b'){this.res_tav.aciertos=this.res_tav.aciertos+1;}else{if(this.eval_tav.pg030==='c'){this.res_tav.errores=this.res_tav.errores+1;}}this.res_tav.resta=this.res_tav.aciertos-this.res_tav.errores;this.res_tav.rango='';var comp1=false;if(this.eval_tav.sexo==="M"){comp1=this.res_tav.resta>=1&&this.res_tav.resta<=12;if(comp1===true){this.res_tav.rango="Bajo";}comp1=this.res_tav.resta>=13&&this.res_tav.resta<=15;if(comp1===true){this.res_tav.rango="Medio";}comp1=this.res_tav.resta>=16&&this.res_tav.resta<=18;if(comp1===true){this.res_tav.rango="Bueno";}comp1=this.res_tav.resta>=19&&this.res_tav.resta<=20;if(comp1===true){this.res_tav.rango="Muy Bueno";}comp1=this.res_tav.resta>=21&&this.res_tav.resta<=34;if(comp1===true){this.res_tav.rango="Superior";}}else{comp1=this.res_tav.resta>=-4&&this.res_tav.resta<=9;if(comp1===true){this.res_tav.rango="Bajo";}comp1=this.res_tav.resta>=10&&this.res_tav.resta<=13;if(comp1===true){this.res_tav.rango="Medio";}comp1=this.res_tav.resta>=14&&this.res_tav.resta<=15;if(comp1===true){this.res_tav.rango="Bueno";}comp1=this.res_tav.resta>=16&&this.res_tav.resta<=17;if(comp1===true){this.res_tav.rango="Muy Bueno";}comp1=this.res_tav.resta>=18&&this.res_tav.resta<=20;if(comp1===true){this.res_tav.rango="Superior";}}this.res_tav.genero="NA";switch(this.eval_tav.sexo){case'M':this.res_tav.genero='MASCULINO';break;case'F':this.res_tav.genero='FEMENINO';break;}},resultadostav:function resultadostav(doc){this.res_tav={rango:0,resta:0,aciertos:0,errores:0,genero:""};this.rangostav();doc.setLineWidth(0.25);doc.text(10,80,"SECCION DE RESULTADOS ");doc.line(10,83,206,83);console.log("*-*-*-*-*-*-*-*-*-*-*- RESULTADOS *-*-*-*-*-*-*-*-*-*-*-");console.log("aciertos ? ",this.res_tav.aciertos,"; errores ? ",this.res_tav.errores);// let dif = this.res_tav.aciertos - this.res_tav.errores;
var aciertos=this.res_tav.aciertos;var errores=this.res_tav.errores;var resta=this.res_tav.resta;var rango=this.res_tav.rango;var genero=this.res_tav.genero;doc.text(10,90,"[ aciertos : ");doc.text(30,90,aciertos.toString());doc.text(50,90," ]");doc.text(10,94,"[ errores : ");doc.text(30,94,errores.toString());doc.text(50,94," ]");doc.text(10,98,"[ diferencia : ");doc.text(30,98,resta.toString());doc.text(50,98," ]");doc.text(10,104,"[ rango : ");doc.text(30,104,rango);doc.text(50,104," ]");doc.text(25,108,genero);},respuestastav:function respuestastav(doc){/* Muestra las preguntas *//* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */doc.setLineWidth(0.25);doc.text(10,40,"SECCION DE RESPUESTAS ");doc.line(10,42,190,42);doc.text(10,45,"01= ");doc.text(23,45,this.eval_tav.pg001);doc.text(30,45,"02= ");doc.text(43,45,this.eval_tav.pg002);doc.text(50,45,"03= ");doc.text(63,45,this.eval_tav.pg003);doc.text(70,45,"04= ");doc.text(83,45,this.eval_tav.pg004);doc.text(90,45,"05= ");doc.text(103,45,this.eval_tav.pg005);doc.text(110,45,"06= ");doc.text(123,45,this.eval_tav.pg006);doc.text(130,45,"07= ");doc.text(143,45,this.eval_tav.pg007);doc.text(150,45,"08= ");doc.text(163,45,this.eval_tav.pg008);doc.text(170,45,"09= ");doc.text(183,45,this.eval_tav.pg009);doc.line(10,46,190,46);doc.text(10,49,"10= ");doc.text(23,49,this.eval_tav.pg010);doc.text(30,49,"11= ");doc.text(43,49,this.eval_tav.pg011);doc.text(50,49,"12= ");doc.text(63,49,this.eval_tav.pg012);doc.text(70,49,"13= ");doc.text(83,49,this.eval_tav.pg013);doc.text(90,49,"14= ");doc.text(103,49,this.eval_tav.pg014);doc.text(110,49,"15= ");doc.text(123,49,this.eval_tav.pg015);doc.text(130,49,"16= ");doc.text(143,49,this.eval_tav.pg016);doc.text(150,49,"17= ");doc.text(163,49,this.eval_tav.pg017);doc.text(170,49,"18= ");doc.text(183,49,this.eval_tav.pg018);doc.line(10,50,190,50);doc.text(10,53,"19= ");doc.text(23,53,this.eval_tav.pg019);doc.text(30,53,"20= ");doc.text(43,53,this.eval_tav.pg020);doc.text(50,53,"21= ");doc.text(63,53,this.eval_tav.pg021);doc.text(70,53,"22= ");doc.text(83,53,this.eval_tav.pg022);doc.text(90,53,"23= ");doc.text(103,53,this.eval_tav.pg023);doc.text(110,53,"24= ");doc.text(123,53,this.eval_tav.pg024);doc.text(130,53,"25= ");doc.text(143,53,this.eval_tav.pg025);doc.text(150,53,"26= ");doc.text(163,53,this.eval_tav.pg026);doc.text(170,53,"27= ");doc.text(183,53,this.eval_tav.pg027);doc.line(10,54,190,54);doc.text(10,57,"28= ");doc.text(23,57,this.eval_tav.pg028);doc.text(30,57,"29= ");doc.text(43,57,this.eval_tav.pg029);doc.text(50,57,"30= ");doc.text(63,57,this.eval_tav.pg030);doc.line(10,59,65,59);},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
crearPDF_solemp:function crearPDF_solemp(){/** CREACION DEL ARCHIVO PDF */var cadena=this.eval_solemp.nombre,patron=/ /g,nuevoValor="",nusuario=cadena.replace(patron,nuevoValor);var nArchivo="solemp_"+nusuario;// console.log("archivo a crear ? ", nArchivo);
var imagen="data:image/jpeg;base64,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";var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a('portrait');var linea=5;/** Muestra el logo.        (izq, top, ancho, alto) */doc.addImage(imagen,'JPEG',155,linea,50,20);/** fila, columna *//** CIRCULOS  */doc.setLineWidth(1);// Grosor de la línea del borde
doc.setDrawColor(0);/** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */var meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var lhoy=new Date();//lhoy=   lhoy.toString();
var ldia=lhoy.getDate();var lmes=meses[lhoy.getMonth()];var lanio=lhoy.getFullYear();// console.log("lhoy ? ",lhoy);
// console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
doc.setFontSize(9);doc.text(13,20,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);doc.text(13,45,"SOLICITUD DE EMPLEO para "+this.eval_solemp.nombre+" de "+this.eval_solemp.empresa);this.solicitud(doc);doc.save(nArchivo);doc.autoPrint();window.open(doc.output('bloburl'),'_blank');},solicitud:function solicitud(doc){// console.log("********************************");
// console.log("EN SOLICITUD !!");
// console.log(this.eval_solemp);
var lblanco='';var lfaplico=this.eval_solemp.fecha;var lempezo=this.eval_solemp.empezo;var ltermino=this.eval_solemp.termino;var lcodigo=this.eval_solemp.codigo;var lncompleto=this.eval_solemp.pg001;var llugnac=this.eval_solemp.pg002;var lfecnac=this.eval_solemp.pg003;var ledad=this.eval_solemp.pg004;var ldpi=this.eval_solemp.pg005;var lextendido=this.eval_solemp.pg006;var ligss=this.eval_solemp.pg007;var lnit=this.eval_solemp.pg008;var lpg007=this.eval_solemp.pg007;var lpg008=this.eval_solemp.pg008;var lpg009=this.eval_solemp.pg009;var lpg010=this.eval_solemp.pg010;var lpg011=this.eval_solemp.pg011;var lpg012=this.eval_solemp.pg012;var lpg013=this.eval_solemp.pg013;var lpg014=this.eval_solemp.pg014;var lpg015=this.eval_solemp.pg015;var lpg016=this.eval_solemp.pg016;var lpg017=this.eval_solemp.pg017;var lpg018=this.eval_solemp.pg018;var lpg019=this.eval_solemp.pg019;var lpg020=this.eval_solemp.pg020;var lpg021=this.eval_solemp.pg021;var lpg023=this.eval_solemp.pg023;var lpg025=this.eval_solemp.pg025;var lpg022=this.eval_solemp.pg022.toString()+'; '+lpg023;var lpg024=this.eval_solemp.pg024.toString()+'; '+lpg025;var lpg026=this.eval_solemp.pg026;var lpg027=this.eval_solemp.pg027;var lpg028=this.eval_solemp.pg028;var lpg029=this.eval_solemp.pg029;var lpg030=this.eval_solemp.pg030;var lpg031=this.eval_solemp.pg031;var lpg032=this.eval_solemp.pg032;var lpg033=this.eval_solemp.pg033;var lpg034=this.eval_solemp.pg034;var lpg035=this.eval_solemp.pg035;var lpg036=this.eval_solemp.pg036;var lpg037=this.eval_solemp.pg037;var lpg038=this.eval_solemp.pg038;var lpg039=this.eval_solemp.pg039;var lpg040=this.eval_solemp.pg040;var lpg041=this.eval_solemp.pg041;var lpg042=this.eval_solemp.pg042;var lpg043=this.eval_solemp.pg043;var lpg044=this.eval_solemp.pg044;var lpg045=this.eval_solemp.pg045;var lpg046=this.eval_solemp.pg046;var lpg047=this.eval_solemp.pg047;var lpg048=this.eval_solemp.pg048;var lpg049=this.eval_solemp.pg049;var lpg050=this.eval_solemp.pg050;var lpg051=this.eval_solemp.pg051;var lpg052=this.eval_solemp.pg052;var lpg053=this.eval_solemp.pg053;var lpg054=this.eval_solemp.pg054;var lpg055=this.eval_solemp.pg055;var lpg056=this.eval_solemp.pg056;var lpg057=this.eval_solemp.pg057;var lpg058=this.eval_solemp.pg058;var lpg059=this.eval_solemp.pg059;var lpg060=this.eval_solemp.pg060;var lpg061=this.eval_solemp.pg061;var lpg062=this.eval_solemp.pg062;var lpg063=this.eval_solemp.pg063;var lpg064=this.eval_solemp.pg064;var lpg065=this.eval_solemp.pg065;var lpg066=this.eval_solemp.pg066;var lpg067=this.eval_solemp.pg067;var lpg068=this.eval_solemp.pg068;var lpg069=this.eval_solemp.pg069;var lpg070=this.eval_solemp.pg070;var lpg071=this.eval_solemp.pg071;var lpg072=this.eval_solemp.pg072;var lpg073=this.eval_solemp.pg073;var lpg074=this.eval_solemp.pg074;var lpg075=this.eval_solemp.pg075;var lpg076=this.eval_solemp.pg076;var lpg077=this.eval_solemp.pg077;var lpg078=this.eval_solemp.pg078;var lpg079=this.eval_solemp.pg079;var lpg080=this.eval_solemp.pg080;var lpg081=this.eval_solemp.pg081;var lpg082=this.eval_solemp.pg082;var lpg083=this.eval_solemp.pg083;var lpg084=this.eval_solemp.pg084;var lpg085=this.eval_solemp.pg085;var lpg086=this.eval_solemp.pg086;var lpg087=this.eval_solemp.pg087;var lpg088=this.eval_solemp.pg088;var lpg089=this.eval_solemp.pg089;var lpg090=this.eval_solemp.pg090;var lpg091=this.eval_solemp.pg091;var lpg092=this.eval_solemp.pg092;var lpg093=this.eval_solemp.pg093;var lpg094=this.eval_solemp.pg094;var lpg095=this.eval_solemp.pg095;var lpg096=this.eval_solemp.pg096;var lpg097=this.eval_solemp.pg097;var lpg098=this.eval_solemp.pg098;var lpg099=this.eval_solemp.pg099;var lpg100=this.eval_solemp.pg100;var lpg101=this.eval_solemp.pg101;var lpg102=this.eval_solemp.pg102;var lpg103=this.eval_solemp.pg103;var lpg104=this.eval_solemp.pg104;var lpg105=this.eval_solemp.pg105;var lpg106=this.eval_solemp.pg106;var lpg107=this.eval_solemp.pg107;var lpg108=this.eval_solemp.pg108;var lpg109=this.eval_solemp.pg109;var lpg110=this.eval_solemp.pg110;var lpg111=this.eval_solemp.pg111;var lpg112=this.eval_solemp.pg112;var lpg113=this.eval_solemp.pg113;var lpg114=this.eval_solemp.pg114;var lpg115=this.eval_solemp.pg115;var lpg116=this.eval_solemp.pg116;var lpg117=this.eval_solemp.pg117;var lpg118=this.eval_solemp.pg118;var lpg119=this.eval_solemp.pg119;var lpg120=this.eval_solemp.pg120;var lpg121=this.eval_solemp.pg121;var lpg122=this.eval_solemp.pg122;var lpg123=this.eval_solemp.pg123;var lpg124=this.eval_solemp.pg124;var lpg125=this.eval_solemp.pg125;var lpg126=this.eval_solemp.pg126;var lpg127=this.eval_solemp.pg127;var lpg128=this.eval_solemp.pg128;var lpg129=this.eval_solemp.pg129;var lpg130=this.eval_solemp.pg130;var lpg131=this.eval_solemp.pg131;var lpg132=this.eval_solemp.pg132;var lpg133=this.eval_solemp.pg133;var lpg134=this.eval_solemp.pg134;var lpg135=this.eval_solemp.pg135;var lpg136=this.eval_solemp.pg136;var lpg137=this.eval_solemp.pg137;var lpg138=this.eval_solemp.pg138;var lpg139=this.eval_solemp.pg139;var lpg140=this.eval_solemp.pg140;var lpg141=this.eval_solemp.pg141;var lpg142=this.eval_solemp.pg142;var lpg143=this.eval_solemp.pg143;var lpg144=this.eval_solemp.pg144;var lpg145=this.eval_solemp.pg145;var lpg146=this.eval_solemp.pg146;var lpg147=this.eval_solemp.pg147;var lpg148=this.eval_solemp.pg148;var lpg149=this.eval_solemp.pg149;var lpg150=this.eval_solemp.pg150;var lpg151=this.eval_solemp.pg151;var lpg152=this.eval_solemp.pg152;var lpg153=this.eval_solemp.pg153;var lpg154=this.eval_solemp.pg154;var lpg155=this.eval_solemp.pg155;var lpg156=this.eval_solemp.pg156;var lpg157=this.eval_solemp.pg157;var lpg158=this.eval_solemp.pg158;var lpg159=this.eval_solemp.pg159;var lpg160=this.eval_solemp.pg160;var lpg161=this.eval_solemp.pg161;var lpg162=this.eval_solemp.pg162;var lpg163=this.eval_solemp.pg163;var lpg164=this.eval_solemp.pg164;var lpg165=this.eval_solemp.pg165;var lpg166=this.eval_solemp.pg166;var lpg167=this.eval_solemp.pg167;var lpg168=this.eval_solemp.pg168;var lpg169=this.eval_solemp.pg169;var lpg170=this.eval_solemp.pg170;var lpg171=this.eval_solemp.pg171;var lpg172=this.eval_solemp.pg172;var lpg173=this.eval_solemp.pg173;var lpg174=this.eval_solemp.pg174;var lpg175=this.eval_solemp.pg175;var lpg176=this.eval_solemp.pg176;var lpg177=this.eval_solemp.pg177;var lpg178=this.eval_solemp.pg178;var lpg179=this.eval_solemp.pg179;var lpg180=this.eval_solemp.pg180;var lpg181=this.eval_solemp.pg181;var lpg182=this.eval_solemp.pg182;var lpg183=this.eval_solemp.pg183;var lpg184=this.eval_solemp.pg184;var lpg185=this.eval_solemp.pg185;var lpg186=this.eval_solemp.pg186;var lpg187=this.eval_solemp.pg187;var lpg188=this.eval_solemp.pg188;var lpg189=this.eval_solemp.pg189;var lpg190=this.eval_solemp.pg190;var lpg191=this.eval_solemp.pg191;var lpg192=this.eval_solemp.pg192;var lpg193=this.eval_solemp.pg193;var lpg194=this.eval_solemp.pg194;var lpg195=this.eval_solemp.pg195;var lpg196=this.eval_solemp.pg196;var lpg197=this.eval_solemp.pg197;var lpg198=this.eval_solemp.pg198;var lpg199=this.eval_solemp.pg199;var lpg200=this.eval_solemp.pg200;var lpg201=this.eval_solemp.pg201;var lpg202=this.eval_solemp.pg202;var lpg203=this.eval_solemp.pg203;var lpg204=this.eval_solemp.pg204;var lpg205=this.eval_solemp.pg205;var lpg206=this.eval_solemp.pg206;var lpg207=this.eval_solemp.pg207;console.log("1. termine de cargar valores");doc.setLineWidth(0.7);doc.line(13,50,195,50);// horizontal line (init_col, init_row, , )
doc.setFontSize(9);doc.setFontType("bold");doc.text(13,57,'I) INFORMACION PERSONAL');doc.setLineWidth(0.5);doc.rect(12,59,185,45);/*  rect(init_col, init_row, end_col, end_row) */doc.setFontType("bolditalic");doc.text(15,65,'LUGAR Y FECHA DE NACIMIENTO:');doc.text(15,71,'EDAD:');doc.text(35,71,'DPI:');doc.text(100,71,'EXTENDIDA EN:');var llugfecnac=llugnac+'; '+lfecnac;doc.setFontType("normal");doc.text(72,65,llugfecnac);doc.text(27,71,ledad.toString());doc.text(45,71,ldpi);doc.text(127,71,lextendido);doc.setFontType("bolditalic");doc.text(15,77,'AFILIACION AL IGSS:');doc.text(95,77,'NIT:');doc.text(130,77,'ESTADO CIVIL:');doc.setFontType("normal");doc.text(50,77,lpg007);doc.text(103,77,lpg008);doc.text(160,77,lpg009);doc.setFontType("bolditalic");doc.text(15,81.5,'NACIONALIDAD:');/* pg010 */doc.text(15,85,'PROFESION U OFICIO:');doc.setFontType("normal");doc.text(45,81.5,lpg010);doc.text(15,88,lpg011);doc.setFontType("bolditalic");doc.text(15,91,'DIRECCION ACTUAL:');doc.text(15,98,'E-MAIL:');doc.setFontType("normal");var msg='E-MAIL';var pos1=140+msg.length+7;doc.text(15,94,lpg012);doc.text(35,98,lpg013);doc.setFontType("bolditalic");var msg1='TELEFONO DOMICILIO:';var msg2='TELEFONO CELULAR:';pos1=15+msg1.length+20;var pos2=101+msg2.length+20;doc.text(15,102.5,msg1);doc.text(100,102.5,msg2);doc.setFontType("normal");doc.text(pos1,102.5,lpg014);doc.text(pos2,102.5,lpg015);doc.rect(12,111,185,120);/*  rect(init_col, init_row, end_col, end_row) */doc.setFontType("bold");doc.text(13,110,'II) DATOS FAMILIARES');doc.setFontType("bolditalic");doc.text(15,116,'NOMBRE DEL PADRE:');doc.text(145,116,'TELEFONO:');doc.setFontType("normal");doc.text(53,116,lpg016);doc.text(165,116,lpg017);doc.setFontType("bolditalic");doc.text(15,121,'LUGAR DE TRABAJO:');doc.setFontType("normal");doc.text(53,121,lpg018);doc.setFontType("bolditalic");doc.text(15,127,'NOMBRE DE LA MADRE:');doc.text(145,127,'TELEFONO:');doc.setFontType("normal");doc.text(55,127,lpg019);doc.text(165,127,lpg020);doc.setFontType("bolditalic");doc.text(15,133,'LUGAR DE TRABAJO:');doc.setFontType("normal");doc.text(55,133,lpg021);doc.setFontType("bolditalic");doc.text(15,137.5,'No. DE HERMANOS Y PROFESIONES:');doc.text(15,144.5,'No. DE CARGAS FAMILIARES Y QUIENES:');doc.setFontType("normal");doc.text(15,140.5,lpg022);doc.text(15,147,lpg024);doc.setFontType("bolditalic");doc.text(75,150.5,'------ DATOS DEL CONYUGUE ------');doc.text(15,154,'NOMBRE COMPLETO:');doc.text(15,157,'OCUPACION:');doc.setFontType("normal");doc.text(55,154,lpg026);doc.text(35,158,lpg027);doc.setFontType("bolditalic");doc.text(15,163,'LUGAR DE TRABAJO:');doc.setFontType("normal");doc.text(55,163,lpg028);doc.setFontType("bolditalic");doc.text(15,168,'DIRECCION:');doc.text(110,168,'TELEFONO:');doc.setFontType("normal");doc.text(15,171,lpg029);doc.text(135,169,lpg030);doc.setFontType("bolditalic");doc.text(15,175,'CARGO QUE OCUPA:');doc.setFontType("normal");doc.text(55,175,lpg031);doc.setFontType("bolditalic");doc.text(75,180,'------ DATOS DE LOS HIJOS ------');doc.text(15,186,'1) NOMBRE:');doc.text(140,186,'EDAD:');doc.setFontType("normal");doc.text(55,186,lpg032);doc.text(165,186,lpg033);doc.setFontType("bolditalic");doc.text(18,190,'ESCOLARIDAD:');doc.text(18,193,'INSTITUCION:');doc.setFontType("normal");doc.text(45,190,lpg034);doc.text(45,193,lpg035);doc.setFontType("bolditalic");doc.text(15,198,'2) NOMBRE:');doc.text(140,198,'EDAD:');doc.setFontType("normal");doc.text(55,198,lpg036);doc.text(165,198,lpg037);doc.setFontType("bolditalic");doc.text(18,202,'ESCOLARIDAD:');doc.text(18,205,'INSTITUCION:');doc.setFontType("normal");doc.text(45,202,lpg038);doc.text(45,205,lpg039);doc.setFontType("bolditalic");doc.text(15,210,'3) NOMBRE:');doc.text(140,210,'EDAD:');doc.setFontType("normal");doc.text(55,210,lpg040);doc.text(165,210,lpg041);doc.setFontType("bolditalic");doc.text(18,214,'ESCOLARIDAD:');doc.text(18,217,'INSTITUCION:');doc.setFontType("normal");doc.text(45,214,lpg042);doc.text(45,217,lpg043);doc.setFontType("bolditalic");doc.text(15,222,'4) NOMBRE:');doc.text(140,222,'EDAD:');doc.setFontType("normal");doc.text(55,222,lpg044);doc.text(165,222,lpg045);doc.setFontType("bolditalic");doc.text(18,226,'ESCOLARIDAD:');doc.text(18,229,'INSTITUCION:');doc.setFontType("normal");doc.text(45,226,lpg046);doc.text(45,229,lpg047);console.log("antes de informacion socioeconomica");doc.rect(12,239,185,30);/*  rect(init_col, init_row, end_col, end_row) */doc.setFontType("bold");doc.text(13,238,'III) INFORMACION SOCIOECONOMICA');doc.setFontType("bolditalic");doc.text(15,244,'VIVE EN CASA PROPIA ?');doc.text(85,244,'ALQUILA ?');doc.text(130,244,'DE SUS PADRES ?');doc.setFontType("normal");doc.text(55,244,lpg048);doc.text(105,244,lpg049);doc.text(160,244,lpg050);doc.setFontType("bolditalic");doc.text(15,250,'TIENE VEHICULO PROPIO ?');doc.text(70,250,'MARCA Y AÑO');doc.setFontType("normal");doc.text(60,250,lpg051);var lpg5253=lpg052+'; '+lpg053;doc.text(95,250,lpg5253);doc.setFontType("bolditalic");doc.text(15,256,'RECIBE OTROS INGRESOS QUE NO SEAN DE SU SUELDO ?');doc.text(130,256,'MONTO');doc.setFontType("normal");doc.text(110,256,lpg054);doc.text(160,256,lpg055);doc.setFontType("bolditalic");doc.text(15,262,'DE DONDE PROCEDE ESTE INGRESO');doc.setFontType("normal");doc.text(15,265,lpg056);doc.setFontType("bolditalic");doc.setFontType("normal");console.log("antes de pagina 2");/* ========================================================================================== *//* PAGINA 2 */doc.addPage();doc.text(15,10,'Segunda Página');doc.text(125,10,lncompleto);doc.setLineWidth(0.7);doc.line(13,14,200,14);// horizontal line (init_col, init_row, , )
doc.setFontType("bold");doc.text(13,20,'IV) FORMACION ACADEMICA');doc.rect(12,22,190,125);/*  RECTANGULO (init_col, init_row, end_col, end_row) */doc.setFontType("bolditalic");doc.text(73,26,'- POSTGRADO ');doc.text(13,29,'1) INSTITUCION:');doc.text(13,33,'GRADO Y TITULO:');doc.text(13,39,'FECHA:');doc.setFontType("normal");doc.text(43,30,lpg057);doc.text(13,36,lpg058);doc.text(30,39,lpg059);doc.setFontType("bolditalic");doc.text(13,44,'2) INSTITUCION:');doc.text(13,48,'GRADO Y TITULO:');doc.text(13,55,'FECHA:');doc.setFontType("normal");doc.text(39,44,lpg060);doc.text(13,51,lpg061);doc.text(30,55,lpg062);doc.setFontType("bolditalic");doc.text(73,59,'- UNIVERSITARIA');doc.text(13,62,'INSTITUCION:');doc.text(13,66,'GRADO Y TITULO:');doc.text(13,73,'FECHA:');doc.setFontType("normal");doc.text(36,62,lpg063);doc.text(13,69,lpg064);doc.text(30,73,lpg065);doc.setFontType("bolditalic");doc.text(73,76,'- DIVERSIFICADA');doc.text(13,79,'INSTITUCION:');doc.text(13,85,'GRADO OBTENIDO Y TITULO:');doc.text(13,91,'FECHA:');doc.setFontType("normal");doc.text(13,82,lpg066);doc.text(13,87,lpg067);doc.text(30,91,lpg068);doc.setFontType("bolditalic");doc.text(13,96,'- OTROS CURSOS DE ACTUALIZACION RELACIONADOS CON SU PROFESION:');doc.setFontType("normal");doc.text(13,99,lpg069);doc.setFontType("bolditalic");doc.text(13,103,'- OTROS CONOCIMIENTOS O HABILIDADES QUE POSEE:');doc.setFontType("normal");doc.text(13,105,lpg070);doc.setFontType("bolditalic");doc.text(13,110,'- PREMIOS O MENCIONES HONORIFICAS OBTENIDAS:');doc.text(13,119,'- ESTUDIA ACTUALMENTE ?');doc.text(65,119,'ESPECIFIQUE:');doc.text(13,126,'  HORARIO:');doc.setFontType("normal");doc.text(13,112,lpg071.substring(0,100));doc.text(13,114,lpg071.substring(101));doc.text(59,118.5,lpg072);doc.text(13,122,lpg073);doc.text(13,128,lpg074);doc.setFontType("bolditalic");console.log("antes de idiomas adicionales");doc.text(75,132,'------ IDIOMAS ADICIONALES ------');doc.text(13,135,'1) IDIOMA:');doc.text(13,138,'LEE ');doc.text(45,138,'ESCRIBE');doc.text(85,138,'CONVERSA');doc.setFontType("normal");doc.text(35,135,lpg075);doc.text(25,138,lpg076);doc.text(65,138,lpg077);doc.text(110,138,lpg078);doc.setFontType("bolditalic");doc.text(13,142,'2) IDIOMA:');doc.text(13,145,'LEE ');doc.text(45,145,'ESCRIBE');doc.text(85,145,'CONVERSA');doc.setFontType("normal");doc.text(35,142,lpg079);doc.text(25,145,lpg080);doc.text(65,145,lpg081);doc.text(110,145,lpg082);doc.setFontType("bold");doc.text(13,150,'V) EXPERIENCIA LABORAL (LOS TRES ULTIMOS EMPLEOS)');doc.rect(12,152,190,130);/*  rect(init_col, init_row, end_col, end_row) */doc.setFontType("bolditalic");doc.text(13,156,'- EMPRESA 1 ');doc.text(13,160,'  NOMBRE:');doc.text(13,163,'  TELEFONO:');doc.text(13,168,'  DIRECCION:');doc.text(13,174,'  GIRO DEL NEGOCIO:');doc.setFontSize(8);doc.text(13,180,'FECHA DE INGRESO:');doc.setFontSize(9);doc.text(85,180,'FECHA EGRESO:');doc.text(143,180,'TRABAJA ACTUALMENTE AQUI ?');doc.text(13,184,'  CARGO INICIAL:');doc.text(13,187,'  CARGO ACTUAL:');doc.text(13,192,'  SALARIO INICIAL:');doc.text(110,192,'SALARIO ACTUAL:');doc.text(13,198,'  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');doc.text(65,206,'------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');doc.text(13,212,' 1) ');doc.text(13,218,' 2) ');doc.text(13,224,' 3) ');doc.text(13,230,' 4) ');doc.text(13,236,' 5) ');doc.text(13,242,' 6) ');doc.text(13,248,'  NOMBRE DE SU JEFE INMEDIATO:');doc.text(13,253,'  PUESTO DE SU JEFE INMEDIATO:');doc.text(13,260,'  NUMERO DE PERSONAS A SU CARGO:');doc.text(13,265,'  MOTIVO DE SU RETIRO:');doc.text(13,272,'  PODEMOS PEDIR REFERENCIAS ?');doc.text(13,278,'  PORQUE:');doc.setFontType("normal");console.log("lpg090 ? ",this.eval_solemp.pg090);doc.text(35,160,lpg083);doc.text(35,163,lpg085);doc.text(15,171,lpg084);doc.text(15,176,lpg086);doc.setFontSize(8);doc.text(49,180,lpg087);doc.text(113,180,lpg088);doc.text(196,180,lpg089);doc.setFontSize(9);doc.text(42,184,lpg090);doc.text(42,187,lpg091);doc.text(45,192,lpg092);doc.text(145,192,lpg093);doc.text(15,202,lpg094);doc.setFontSize(8);doc.text(19,212,lpg095);doc.text(19,218,lpg096);doc.text(19,224,lpg097);doc.text(19,230,lpg098);doc.text(19,236,lpg099);doc.text(19,242,lpg100);doc.setFontSize(9);doc.text(79,248,lpg101);doc.text(15,256,lpg102);doc.text(79,260,lpg103);doc.text(15,267,lpg104);doc.text(79,272,lpg105);doc.text(15,281,lpg106);/* PAGINA 3 */doc.addPage();doc.text(15,10,'Tercera Página');doc.text(125,10,lncompleto);doc.setLineWidth(0.7);doc.line(13,14,200,14);// horizontal line (init_col, init_row, , )
doc.rect(12,20,190,265);/*  RECTANGULO (init_col, init_row, end_col, end_row) */doc.setFontType("bolditalic");doc.text(13,24,'- EMPRESA 2 ');doc.text(13,30,'  NOMBRE:');doc.text(13,33,'  TELEFONO:');doc.text(13,38,'  DIRECCION:');doc.text(13,44,'  GIRO DEL NEGOCIO:');doc.text(13,50,'FECHA DE INGRESO:');doc.text(85,50,'FECHA EGRESO:');doc.text(143,50,'TRABAJA ACTUALMENTE AQUI ?');doc.text(13,54,'  CARGO INICIAL:');doc.text(13,57,'  CARGO ACTUAL:');doc.text(13,62,'  SALARIO INICIAL:');doc.text(110,62,'  SALARIO ACTUAL:');doc.text(13,68,'  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');doc.text(65,76,'------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');doc.text(13,82,' 1) ');doc.text(13,88,' 2) ');doc.text(13,94,' 3) ');doc.text(13,100,'4) ');doc.text(13,106,'5) ');doc.text(13,112,'6) ');doc.text(13,118,'  NOMBRE DE SU JEFE INMEDIATO:');doc.text(13,123,'  PUESTO DE SU JEFE INMEDIATO:');doc.text(13,130,'  NUMERO DE PERSONAS A SU CARGO:');doc.text(13,135,'  MOTIVO DE SU RETIRO:');doc.text(13,142,'  PODEMOS PEDIR REFERENCIAS ?');doc.text(13,147,'  PORQUE:');doc.setFontType("normal");doc.text(35,30,lpg107);doc.text(35,33,lpg108);doc.text(15,41,lpg109);doc.text(15,46,lpg110);doc.setFontSize(8);doc.text(49,50,lpg111);doc.text(113,50,lpg112);doc.text(196,50,lpg113);doc.setFontSize(9);doc.text(45,54,lpg114);doc.text(45,57,lpg115);doc.text(45,62,lpg116);doc.text(145,62,lpg117);doc.text(15,72,lpg118);doc.setFontSize(8);doc.text(19,82,lpg119);doc.text(19,88,lpg120);doc.text(19,94,lpg121);doc.text(19,100,lpg122);doc.text(19,106,lpg123);doc.text(19,112,lpg124);doc.setFontSize(9);doc.text(15,121,lpg125);doc.text(15,126,lpg126);doc.text(79,130,lpg127);doc.text(15,138,lpg128);doc.text(79,142,lpg129);doc.text(15,149,lpg130);doc.line(13,150,200,150);// horizontal line (init_col, init_row, , )
doc.setFontType("bolditalic");doc.text(13,156,'- EMPRESA 3 ');doc.text(13,160,'  NOMBRE:');doc.text(13,163,'TELEFONO:');doc.text(13,168,' DIRECCION:');doc.text(13,174,'  GIRO DEL NEGOCIO:');doc.setFontSize(8);doc.text(13,180,'FECHA DE INGRESO:');doc.setFontSize(9);doc.text(85,180,'FECHA DE EGRESO:');doc.text(145,180,'TRABAJA ACTUALMENTE AQUI ?');doc.text(13,184,'  CARGO INICIAL:');doc.text(13,187,'CARGO ACTUAL:');doc.text(13,192,'  SALARIO INICIAL:');doc.text(110,192,'SALARIO ACTUAL:');doc.text(13,198,'  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');doc.text(65,206,'------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');doc.text(13,212,' 1) ');doc.text(13,218,' 2) ');doc.text(13,224,' 3) ');doc.text(13,230,' 4) ');doc.text(13,236,' 5) ');doc.text(13,242,' 6) ');doc.text(13,248,'  NOMBRE DE SU JEFE INMEDIATO:');doc.text(13,253,'  PUESTO DE SU JEFE INMEDIATO:');doc.text(13,260,'  NUMERO DE PERSONAS A SU CARGO:');doc.text(13,265,'  MOTIVO DE SU RETIRO:');doc.text(13,272,'  PODEMOS PEDIR REFERENCIAS ?');doc.text(13,278,'  PORQUE:');doc.setFontType("normal");doc.text(35,160,lpg131);doc.text(35,163,lpg133);doc.text(15,171,lpg132);doc.text(15,176,lpg134);doc.setFontSize(8);doc.text(49,180,lpg135);doc.text(118,180,lpg136);doc.text(198,180,lpg137);doc.setFontSize(9);doc.text(42,184,lpg138);doc.text(42,187,lpg139);doc.text(45,192,lpg140);doc.text(145,192,lpg141);doc.text(15,202,lpg142);doc.setFontSize(8);doc.text(19,212,lpg143);doc.text(19,218,lpg144);doc.text(19,224,lpg145);doc.text(19,230,lpg146);doc.text(19,236,lpg147);doc.text(19,242,lpg148);doc.setFontSize(9);doc.text(79,248,lpg149);doc.text(15,256,lpg150);doc.text(79,260,lpg151);doc.text(15,267,lpg152);doc.text(79,272,lpg153);doc.text(15,281,lpg154);/* PAGINA 4 */doc.addPage();doc.text(15,10,'Cuarta Página');doc.text(125,10,lncompleto);doc.setLineWidth(0.7);doc.line(13,14,200,14);// horizontal line (init_col, init_row, , )
doc.setFontType("bold");doc.text(13,20,'VI) FORMACION ACADEMICA');doc.rect(12,22,190,260);/*  RECTANGULO (init_col, init_row, end_col, end_row) */doc.setFontType("bolditalic");doc.text(13,32,'Organización, cultural, deportiva, religiosa, sindical u otras a las que pertenecido:');doc.text(13,50,'Escriba algún deporte o pasatiempo preferido:');doc.text(13,68,'* Salud en General:');doc.text(13,74,'  Ha padecido de alguna enfermedad en los últimos 3 años ?');doc.text(13,80,'  ESPECIFIQUE:');doc.text(13,86,'* Condiciones de Trabajo:');doc.text(13,92,'  Puesto al que aplica ?');doc.text(13,98,'  Expectativa salarial ');doc.text(13,106,'  Tiene limitaciones de horario ?');doc.text(75,106,'  ESPECIFIQUE:');doc.text(13,112,'  ¿ A partir de qué fecha está disponible ?');doc.text(13,118,'  Está dispuesto a viajar como parte de su trabajo ?');doc.text(13,124,'  Posee pasaporte vigente ?');doc.text(70,124,'  No. de Pasaporte ');doc.text(13,130,'* Información complementaria:');doc.text(13,136,'  Ha tenido problemas con la justicia ?');doc.text(85,136,'  EXPLIQUE:');doc.text(13,142,'  Hay deudas de alguna naturaleza ?');doc.text(85,142,'  EXPLIQUE:');doc.text(13,148,'  Tiene tatuajes ?');doc.setFontType("normal");doc.text(13,36,'* '+lpg155);doc.text(13,42,'* '+lpg156);doc.text(13,54,lpg157);doc.text(13,57,lpg158);doc.text(13,60,lpg159);doc.text(13,63,lpg160);doc.text(120,74,lpg161);doc.text(15,83,lpg162);doc.text(15,89,lpg163);doc.text(15,95,lpg164);doc.text(63,106,lpg165);doc.text(15,109,lpg166);doc.text(15,115,lpg167);doc.text(95,118,lpg168);doc.text(62,124,lpg169);doc.text(99,124,lpg170);doc.text(75,136,lpg171);doc.text(15,139,lpg172);doc.text(75,142,lpg173);doc.text(15,145,lpg174);doc.text(75,148,lpg175);doc.line(13,151,200,151);// horizontal line (init_col, init_row, , )
doc.setFontType("bolditalic");doc.text(13,160,'VII) REFERENCIAS PERSONALES Y LABORALES');doc.text(13,166,'* Referencias Personales:');doc.text(13,172,'  a) NOMBRE:');doc.text(140,172,'  TELEFONO:');doc.text(13,178,'       E-MAIL:');doc.text(140,178,'  OCUPACION:');doc.text(13,184,'  b) NOMBRE:');doc.text(140,184,'  TELEFONO:');doc.text(13,190,'       E-MAIL:');doc.text(140,190,'  OCUPACION:');doc.text(13,196,'  c) NOMBRE:');doc.text(140,196,'  TELEFONO:');doc.text(13,202,'       E-MAIL:');doc.text(140,202,'  OCUPACION:');doc.text(13,208,'  d) NOMBRE:');doc.text(140,208,'  TELEFONO:');doc.text(13,214,'       E-MAIL:');doc.text(140,214,'  OCUPACION:');doc.setFontType("normal");doc.text(35,172,lpg176);doc.text(165,172,lpg177);doc.text(35,178,lpg178);doc.text(15,181,lpg179);doc.text(35,184,lpg180);doc.text(165,184,lpg181);doc.text(35,190,lpg182);doc.text(15,193,lpg183);doc.text(35,196,lpg184);doc.text(165,196,lpg185);doc.text(35,202,lpg186);doc.text(15,205,lpg187);doc.text(35,208,lpg188);doc.text(165,208,lpg189);doc.text(35,214,lpg190);doc.text(15,217,lpg191);doc.setFontType("bolditalic");doc.text(13,228,'* Referencias Laborales:');doc.text(13,234,'  a) EMPRESA:');doc.text(16,237,'  NOMBRE:');doc.text(13,240,'       TEL Y E-MAIL:');doc.text(16,243,'  OCUPACION:');doc.text(13,246,'  b) EMPRESA:');doc.text(16,249,'  NOMBRE:');doc.text(13,252,'       TEL Y E-MAIL:');doc.text(16,255,'  OCUPACION:');doc.text(13,258,'  c) EMPRESA:');doc.text(16,261,'  NOMBRE:');doc.text(13,264,'       TEL Y E-MAIL:');doc.text(16,267,'  OCUPACION:');doc.text(13,270,'  d) EMPRESA:');doc.text(16,273,'  NOMBRE:');doc.text(13,276,'       TEL Y E-MAIL:');doc.text(16,279,'  OCUPACION:');doc.setFontType("normal");doc.text(37,234,lpg192);doc.text(35,237,lpg193);doc.text(43,240,lpg194);doc.text(39,243,lpg195);doc.text(37,246,lpg196);doc.text(35,249,lpg197);doc.text(43,252,lpg198);doc.text(39,255,lpg199);doc.text(37,258,lpg200);doc.text(35,261,lpg201);doc.text(43,264,lpg202);doc.text(39,267,lpg203);doc.text(37,270,lpg204);doc.text(35,273,lpg205);doc.text(43,276,lpg206);doc.text(39,279,lpg207);},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
crearPDF_emoc:function crearPDF_emoc(){/** CREACION DEL ARCHIVO PDF */var cadena=this.eval_emoc.nombre,patron=/ /g,nuevoValor="",nusuario=cadena.replace(patron,nuevoValor);var nArchivo="emoc_"+nusuario;console.log("archivo a crear ? ",nArchivo);var imagen="data:image/jpeg;base64,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";var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a('portrait');var linea=5;/** Muestra el logo.        (izq, top, ancho, alto) */doc.addImage(imagen,'JPEG',155,linea,50,20);/** fila, columna *//** CIRCULOS  */doc.setLineWidth(1);// Grosor de la línea del borde
doc.setDrawColor(0);/** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */var meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var lhoy=new Date();//lhoy=   lhoy.toString();
var ldia=lhoy.getDate();var lmes=meses[lhoy.getMonth()];var lanio=lhoy.getFullYear();// console.log("lhoy ? ",lhoy);
// console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
doc.setFontSize(9);doc.text(10,20,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);doc.text(10,30,"Evaluación de EMOCIONES para "+this.eval_emoc.nombre+" de "+this.eval_emoc.empresa);this.respuestasemoc(doc);this.resultadosemoc(doc);doc.save(nArchivo);doc.autoPrint();window.open(doc.output('bloburl'),'_blank');},rangosemoc:function rangosemoc(){/* ==============================================================================================================
               *  AUTO CONCIENCIA */var comp1=false;this.res_emoc.autocon_A=0;this.res_emoc.autocon_B=0;comp1=this.eval_emoc.pg001>=1&&this.eval_emoc.pg001<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}comp1=this.eval_emoc.pg006>=1&&this.eval_emoc.pg006<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}comp1=this.eval_emoc.pg011>=1&&this.eval_emoc.pg011<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}comp1=this.eval_emoc.pg012>=1&&this.eval_emoc.pg012<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}comp1=this.eval_emoc.pg013>=1&&this.eval_emoc.pg013<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}comp1=this.eval_emoc.pg014>=1&&this.eval_emoc.pg014<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}comp1=this.eval_emoc.pg015>=1&&this.eval_emoc.pg015<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}comp1=this.eval_emoc.pg017>=1&&this.eval_emoc.pg017<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}comp1=this.eval_emoc.pg018>=1&&this.eval_emoc.pg018<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}comp1=this.eval_emoc.pg019>=1&&this.eval_emoc.pg019<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}comp1=this.eval_emoc.pg020>=1&&this.eval_emoc.pg020<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}comp1=this.eval_emoc.pg021>=1&&this.eval_emoc.pg021<=4;if(comp1===true){this.res_emoc.autocon_A=this.res_emoc.autocon_A+1;}else{this.res_emoc.autocon_B=this.res_emoc.autocon_B+1;}this.res_emoc.autocon=this.res_emoc.autocon_A+this.res_emoc.autocon_B;/* ==============================================================================================================
                *  CONTROL EMOCIONES */this.res_emoc.emocion_A=0;this.res_emoc.emocion_B=0;comp1=this.eval_emoc.pg001>=1&&this.eval_emoc.pg001<=4;if(comp1===true){this.res_emoc.emocion_A=this.res_emoc.emocion_A+1;}else{this.res_emoc.emocion_B=this.res_emoc.emocion_B+1;}comp1=this.eval_emoc.pg002>=1&&this.eval_emoc.pg002<=4;if(comp1===true){this.res_emoc.emocion_A=this.res_emoc.emocion_A+1;}else{this.res_emoc.emocion_B=this.res_emoc.emocion_B+1;}comp1=this.eval_emoc.pg003>=1&&this.eval_emoc.pg003<=4;if(comp1===true){this.res_emoc.emocion_A=this.res_emoc.emocion_A+1;}else{this.res_emoc.emocion_B=this.res_emoc.emocion_B+1;}comp1=this.eval_emoc.pg004>=1&&this.eval_emoc.pg004<=4;if(comp1===true){this.res_emoc.emocion_A=this.res_emoc.emocion_A+1;}else{this.res_emoc.emocion_B=this.res_emoc.emocion_B+1;}comp1=this.eval_emoc.pg005>=1&&this.eval_emoc.pg005<=4;if(comp1===true){this.res_emoc.emocion_A=this.res_emoc.emocion_A+1;}else{this.res_emoc.emocion_B=this.res_emoc.emocion_B+1;}comp1=this.eval_emoc.pg007>=1&&this.eval_emoc.pg007<=4;if(comp1===true){this.res_emoc.emocion_A=this.res_emoc.emocion_A+1;}else{this.res_emoc.emocion_B=this.res_emoc.emocion_B+1;}comp1=this.eval_emoc.pg009>=1&&this.eval_emoc.pg009<=4;if(comp1===true){this.res_emoc.emocion_A=this.res_emoc.emocion_A+1;}else{this.res_emoc.emocion_B=this.res_emoc.emocion_B+1;}comp1=this.eval_emoc.pg010>=1&&this.eval_emoc.pg010<=4;if(comp1===true){this.res_emoc.emocion_A=this.res_emoc.emocion_A+1;}else{this.res_emoc.emocion_B=this.res_emoc.emocion_B+1;}comp1=this.eval_emoc.pg013>=1&&this.eval_emoc.pg013<=4;if(comp1===true){this.res_emoc.emocion_A=this.res_emoc.emocion_A+1;}else{this.res_emoc.emocion_B=this.res_emoc.emocion_B+1;}comp1=this.eval_emoc.pg027>=1&&this.eval_emoc.pg027<=4;if(comp1===true){this.res_emoc.emocion_A=this.res_emoc.emocion_A+1;}else{this.res_emoc.emocion_B=this.res_emoc.emocion_B+1;}this.res_emoc.emocion=this.res_emoc.emocion_A+this.res_emoc.emocion_B;/* ==============================================================================================================
                *  CONTROL EMOCIONES */this.res_emoc.motivacion_A=0;this.res_emoc.motivacion_B=0;comp1=this.eval_emoc.pg007>=1&&this.eval_emoc.pg007<=4;if(comp1===true){this.res_emoc.motivacion_A=this.res_emoc.motivacion_A+1;}else{this.res_emoc.motivacion_B=this.res_emoc.motivacion_B+1;}comp1=this.eval_emoc.pg022>=1&&this.eval_emoc.pg022<=4;if(comp1===true){this.res_emoc.motivacion_A=this.res_emoc.motivacion_A+1;}else{this.res_emoc.motivacion_B=this.res_emoc.motivacion_B+1;}comp1=this.eval_emoc.pg023>=1&&this.eval_emoc.pg023<=4;if(comp1===true){this.res_emoc.motivacion_A=this.res_emoc.motivacion_A+1;}else{this.res_emoc.motivacion_B=this.res_emoc.motivacion_B+1;}comp1=this.eval_emoc.pg025>=1&&this.eval_emoc.pg025<=4;if(comp1===true){this.res_emoc.motivacion_A=this.res_emoc.motivacion_A+1;}else{this.res_emoc.motivacion_B=this.res_emoc.motivacion_B+1;}comp1=this.eval_emoc.pg026>=1&&this.eval_emoc.pg026<=4;if(comp1===true){this.res_emoc.motivacion_A=this.res_emoc.motivacion_A+1;}else{this.res_emoc.motivacion_B=this.res_emoc.motivacion_B+1;}comp1=this.eval_emoc.pg027>=1&&this.eval_emoc.pg027<=4;if(comp1===true){this.res_emoc.motivacion_A=this.res_emoc.motivacion_A+1;}else{this.res_emoc.motivacion_B=this.res_emoc.motivacion_B+1;}comp1=this.eval_emoc.pg028>=1&&this.eval_emoc.pg028<=4;if(comp1===true){this.res_emoc.motivacion_A=this.res_emoc.motivacion_A+1;}else{this.res_emoc.motivacion_B=this.res_emoc.motivacion_B+1;}this.res_emoc.motivacion=this.res_emoc.motivacion_A+this.res_emoc.motivacion_B;/* ==============================================================================================================
                *  CONTROL EMOCIONES */this.res_emoc.relacionarse_A=0;this.res_emoc.relacionarse_B=0;comp1=this.eval_emoc.pg008>=1&&this.eval_emoc.pg008<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg010>=1&&this.eval_emoc.pg010<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg016>=1&&this.eval_emoc.pg016<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg019>=1&&this.eval_emoc.pg019<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg020>=1&&this.eval_emoc.pg020<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg029>=1&&this.eval_emoc.pg029<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg030>=1&&this.eval_emoc.pg030<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg031>=1&&this.eval_emoc.pg031<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg032>=1&&this.eval_emoc.pg032<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg033>=1&&this.eval_emoc.pg033<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg034>=1&&this.eval_emoc.pg034<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg035>=1&&this.eval_emoc.pg035<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg036>=1&&this.eval_emoc.pg036<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg037>=1&&this.eval_emoc.pg037<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg038>=1&&this.eval_emoc.pg038<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg039>=1&&this.eval_emoc.pg039<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg042>=1&&this.eval_emoc.pg042<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg043>=1&&this.eval_emoc.pg043<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg044>=1&&this.eval_emoc.pg044<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}comp1=this.eval_emoc.pg045>=1&&this.eval_emoc.pg045<=4;if(comp1===true){this.res_emoc.relacionarse_A=this.res_emoc.relacionarse_A+1;}else{this.res_emoc.relacionarse_B=this.res_emoc.relacionarse_B+1;}this.res_emoc.relacionarse=this.res_emoc.relacionarse_A+this.res_emoc.relacionarse_B;/* ==============================================================================================================
                *  AUTO CONCIENCIA */this.res_emoc.asesoria_A=0;this.res_emoc.asesoria_B=0;comp1=this.eval_emoc.pg008>=1&&this.eval_emoc.pg008<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg010>=1&&this.eval_emoc.pg010<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg016>=1&&this.eval_emoc.pg016<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg018>=1&&this.eval_emoc.pg018<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg034>=1&&this.eval_emoc.pg034<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg035>=1&&this.eval_emoc.pg035<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg037>=1&&this.eval_emoc.pg037<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg038>=1&&this.eval_emoc.pg038<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg039>=1&&this.eval_emoc.pg039<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg040>=1&&this.eval_emoc.pg040<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg041>=1&&this.eval_emoc.pg041<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg044>=1&&this.eval_emoc.pg044<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}comp1=this.eval_emoc.pg045>=1&&this.eval_emoc.pg045<=4;if(comp1===true){this.res_emoc.asesoria_A=this.res_emoc.asesoria_A+1;}else{this.res_emoc.asesoria_B=this.res_emoc.asesoria_B+1;}this.res_emoc.asesoria=this.res_emoc.asesoria_A+this.res_emoc.asesoria_B;},resultadosemoc:function resultadosemoc(doc){this.res_emoc={autocon_A:0,autocon_B:0,autocon:0,emocion_A:0,emocion_B:0,emocion:0,motivacion_A:0,motivacion_B:0,motivacion:0,relacionarse_A:0,relacionarse_B:0,relacionarse:0,asesoria_A:0,asesoria_B:0,asesoria:0};this.rangosemoc();doc.setLineWidth(0.25);doc.text(10,88,"SECCION DE RESULTADOS ");doc.line(10,89,206,89);var autocon_A=this.res_emoc.autocon_A;var autocon_B=this.res_emoc.autocon_B;var autocon=this.res_emoc.autocon;var emocion_A=this.res_emoc.emocion_A;var emocion_B=this.res_emoc.emocion_B;var emocion=this.res_emoc.emocion;var motivacion_A=this.res_emoc.motivacion_A;var motivacion_B=this.res_emoc.motivacion_B;var motivacion=this.res_emoc.motivacion;var relacionarse_A=this.res_emoc.relacionarse_A;var relacionarse_B=this.res_emoc.relacionarse_B;var relacionarse=this.res_emoc.relacionarse;var asesoria_A=this.res_emoc.asesoria_A;var asesoria_B=this.res_emoc.asesoria_B;var asesoria=this.res_emoc.asesoria;doc.text(43,94,"APTITUD");doc.text(63,94,"CON 4 MAS");doc.text(83,94,"CON 5 O MAS");doc.text(43,96,"-------------");doc.text(63,96,"-----------------");doc.text(83,96,"-------------------");doc.text(15,100,"INTRA-PERSONAL");doc.text(15,105,"Autoconciencia");doc.text(48,105,autocon_A.toString());doc.text(68,105,autocon_B.toString());doc.text(90,105,autocon.toString());doc.text(15,110,"Control Emociones");doc.text(48,110,emocion_A.toString());doc.text(68,110,emocion_B.toString());doc.text(90,110,emocion.toString());doc.text(15,115,"Automotivación");doc.text(48,115,motivacion_A.toString());doc.text(68,115,motivacion_B.toString());doc.text(90,115,motivacion.toString());doc.text(15,120,"INTER-PERSONAL");doc.text(15,125,"Relacionarse bien");doc.text(48,125,relacionarse_A.toString());doc.text(68,125,relacionarse_B.toString());doc.text(90,125,relacionarse.toString());doc.text(15,130,"Asesoría emocional");doc.text(48,130,asesoria_A.toString());doc.text(68,130,asesoria_B.toString());doc.text(90,130,asesoria.toString());},respuestasemoc:function respuestasemoc(doc){console.log("EN RESPUESTAS");console.log(this.eval_emoc);/* Muestra las preguntas *//* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */doc.setLineWidth(0.25);doc.text(10,40,"SECCION DE RESPUESTAS ");doc.line(10,42,190,42);doc.text(10,45,"01) ");doc.text(23,45,this.eval_emoc.pg001.toString());doc.text(30,45,"02) ");doc.text(43,45,this.eval_emoc.pg002.toString());doc.text(50,45,"03) ");doc.text(63,45,this.eval_emoc.pg003.toString());doc.text(70,45,"04) ");doc.text(83,45,this.eval_emoc.pg004.toString());doc.text(90,45,"05) ");doc.text(103,45,this.eval_emoc.pg005.toString());doc.text(110,45,"06) ");doc.text(123,45,this.eval_emoc.pg006.toString());doc.text(130,45,"07) ");doc.text(143,45,this.eval_emoc.pg007.toString());doc.text(150,45,"08) ");doc.text(163,45,this.eval_emoc.pg008.toString());doc.text(170,45,"09) ");doc.text(183,45,this.eval_emoc.pg009.toString());doc.line(10,46,190,46);console.log(this.eval_emoc.pg010,this.eval_emoc.pg011,this.eval_emoc.pg012,this.eval_emoc.pg013,this.eval_emoc.pg014,this.eval_emoc.pg015,this.eval_emoc.pg016,this.eval_emoc.pg017,this.eval_emoc.pg018);// let pg10 = this.eval_emoc.pg010; let pg11 = this.eval_emoc.pg011; let pg12 = this.eval_emoc.pg012; let pg13 = this.eval_emoc.pg013; 
// let pg15 = this.eval_emoc.pg014; let pg15 = this.eval_emoc.pg015; let pg17 = this.eval_emoc.pg017; let pg18 = this.eval_emoc.pg018
doc.text(10,49,"10) ");doc.text(23,49,this.eval_emoc.pg010.toString());doc.text(30,49,"11) ");doc.text(43,49,this.eval_emoc.pg011.toString());doc.text(50,49,"12) ");doc.text(63,49,this.eval_emoc.pg012.toString());doc.text(70,49,"13) ");doc.text(83,49,this.eval_emoc.pg013.toString());doc.text(90,49,"14) ");doc.text(103,49,this.eval_emoc.pg014.toString());doc.text(110,49,"15) ");doc.text(123,49,this.eval_emoc.pg015.toString());doc.text(130,49,"16) ");doc.text(143,49,this.eval_emoc.pg016.toString());doc.text(150,49,"17) ");doc.text(163,49,this.eval_emoc.pg017.toString());doc.text(170,49,"18) ");doc.text(183,49,this.eval_emoc.pg018.toString());doc.line(10,50,190,50);doc.text(10,53,"19) ");doc.text(23,53,this.eval_emoc.pg019.toString());doc.text(30,53,"20) ");doc.text(43,53,this.eval_emoc.pg020.toString());doc.text(50,53,"21) ");doc.text(63,53,this.eval_emoc.pg021.toString());doc.text(70,53,"22) ");doc.text(83,53,this.eval_emoc.pg022.toString());doc.text(90,53,"23) ");doc.text(103,53,this.eval_emoc.pg023.toString());doc.text(110,53,"24) ");doc.text(123,53,this.eval_emoc.pg024.toString());doc.text(130,53,"25) ");doc.text(143,53,this.eval_emoc.pg025.toString());doc.text(150,53,"26) ");doc.text(163,53,this.eval_emoc.pg026.toString());doc.text(170,53,"27) ");doc.text(183,53,this.eval_emoc.pg027.toString());doc.line(10,54,190,54);doc.text(10,57,"28) ");doc.text(23,57,this.eval_emoc.pg028.toString());doc.text(30,57,"29) ");doc.text(43,57,this.eval_emoc.pg029.toString());doc.text(50,57,"30) ");doc.text(63,57,this.eval_emoc.pg030.toString());doc.text(70,57,"31) ");doc.text(83,57,this.eval_emoc.pg031.toString());doc.text(90,57,"32) ");doc.text(103,57,this.eval_emoc.pg032.toString());doc.text(110,57,"33) ");doc.text(123,57,this.eval_emoc.pg033.toString());doc.text(130,57,"34) ");doc.text(143,57,this.eval_emoc.pg034.toString());doc.text(150,57,"35) ");doc.text(163,57,this.eval_emoc.pg035.toString());doc.text(170,57,"36) ");doc.text(183,57,this.eval_emoc.pg036.toString());doc.line(10,58,190,58);doc.text(10,61,"37) ");doc.text(23,61,this.eval_emoc.pg037.toString());doc.text(30,61,"38) ");doc.text(43,61,this.eval_emoc.pg038.toString());doc.text(50,61,"39) ");doc.text(63,61,this.eval_emoc.pg039.toString());doc.text(70,61,"40) ");doc.text(83,61,this.eval_emoc.pg040.toString());doc.text(90,61,"41) ");doc.text(103,61,this.eval_emoc.pg041.toString());doc.text(110,61,"42) ");doc.text(123,61,this.eval_emoc.pg042.toString());doc.text(130,61,"43) ");doc.text(143,61,this.eval_emoc.pg043.toString());doc.text(150,61,"44) ");doc.text(163,61,this.eval_emoc.pg044.toString());doc.text(170,61,"45) ");doc.text(183,61,this.eval_emoc.pg045.toString());doc.line(10,62,190,62);},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
crearPDF_vtas2:function crearPDF_vtas2(){/** CREACION DEL ARCHIVO PDF */var cadena=this.eval_vtas.nombre,patron=/ /g,nuevoValor="",nusuario=cadena.replace(patron,nuevoValor);var nArchivo="vtas_"+nusuario;console.log("archivo a crear ? ",nArchivo);var imagen="data:image/jpeg;base64,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";var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a('portrait');var linea=5;/** Muestra el logo.        (izq, top, ancho, alto) */doc.addImage(imagen,'JPEG',155,linea,50,20);/** fila, columna *//** CIRCULOS  */doc.setLineWidth(1);// Grosor de la línea del borde
doc.setDrawColor(0);/** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */var meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var lhoy=new Date();//lhoy=   lhoy.toString();
var ldia=lhoy.getDate();var lmes=meses[lhoy.getMonth()];var lanio=lhoy.getFullYear();// console.log("lhoy ? ",lhoy);
// console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
doc.setFontSize(9);doc.text(10,20,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);doc.text(10,30,"Evaluación ORIENTACION EN VENTAS para "+this.eval_vtas.nombre+" de "+this.eval_vtas.empresa);this.respuestasvtas2(doc);this.resultadosvtas2(doc);doc.save(nArchivo);doc.autoPrint();window.open(doc.output('bloburl'),'_blank');},rangosvtas2:function rangosvtas2(){this.res_vtas={grupo1:0,grupo2:0,grupo3:0,grupo4:0,grupo5:0,grupo6:0,grupo7:0,grupo8:0,grupoR:0,grupoA:0,grupoCol:0/* ==============================================================================================================
                *  AUTO CONCIENCIA */};this.res_vtas.grupo1=0;if(this.eval_vtas.pg001==="b"){this.res_vtas.grupo1=this.res_vtas.grupo1+1;}if(this.eval_vtas.pg002==="b"){this.res_vtas.grupo1=this.res_vtas.grupo1+1;}if(this.eval_vtas.pg019==="c"){this.res_vtas.grupo1=this.res_vtas.grupo1+1;}if(this.eval_vtas.pg020==="b"){this.res_vtas.grupo1=this.res_vtas.grupo1+1;}if(this.eval_vtas.pg037==="a"){this.res_vtas.grupo1=this.res_vtas.grupo1+1;}if(this.eval_vtas.pg038==="c"){this.res_vtas.grupo1=this.res_vtas.grupo1+1;}if(this.eval_vtas.pg055==="b"){this.res_vtas.grupo1=this.res_vtas.grupo1+1;}if(this.eval_vtas.pg056==="a"){this.res_vtas.grupo1=this.res_vtas.grupo1+1;}if(this.eval_vtas.pg073==="c"){this.res_vtas.grupo1=this.res_vtas.grupo1+1;}if(this.eval_vtas.pg074==="a"){this.res_vtas.grupo1=this.res_vtas.grupo1+1;}if(this.eval_vtas.pg075==="c"){this.res_vtas.grupo1=this.res_vtas.grupo1+1;}this.res_vtas.grupo2=0;if(this.eval_vtas.pg003==="b"){this.res_vtas.grupo2=this.res_vtas.grupo2+1;}if(this.eval_vtas.pg004==="b"){this.res_vtas.grupo2=this.res_vtas.grupo2+1;}if(this.eval_vtas.pg021==="c"){this.res_vtas.grupo2=this.res_vtas.grupo2+1;}if(this.eval_vtas.pg022==="c"){this.res_vtas.grupo2=this.res_vtas.grupo2+1;}if(this.eval_vtas.pg039==="a"){this.res_vtas.grupo2=this.res_vtas.grupo2+1;}if(this.eval_vtas.pg040==="a"){this.res_vtas.grupo2=this.res_vtas.grupo2+1;}if(this.eval_vtas.pg057==="a"){this.res_vtas.grupo2=this.res_vtas.grupo2+1;}if(this.eval_vtas.pg058==="c"){this.res_vtas.grupo2=this.res_vtas.grupo2+1;}if(this.eval_vtas.pg059==="b"){this.res_vtas.grupo2=this.res_vtas.grupo2+1;}if(this.eval_vtas.pg076==="c"){this.res_vtas.grupo2=this.res_vtas.grupo2+1;}if(this.eval_vtas.pg077==="b"){this.res_vtas.grupo2=this.res_vtas.grupo2+1;}this.res_vtas.grupo3=0;if(this.eval_vtas.pg005==="a"){this.res_vtas.grupo3=this.res_vtas.grupo3+1;}if(this.eval_vtas.pg006==="c"){this.res_vtas.grupo3=this.res_vtas.grupo3+1;}if(this.eval_vtas.pg007==="a"){this.res_vtas.grupo3=this.res_vtas.grupo3+1;}if(this.eval_vtas.pg023==="b"){this.res_vtas.grupo3=this.res_vtas.grupo3+1;}if(this.eval_vtas.pg024==="c"){this.res_vtas.grupo3=this.res_vtas.grupo3+1;}if(this.eval_vtas.pg025==="c"){this.res_vtas.grupo3=this.res_vtas.grupo3+1;}if(this.eval_vtas.pg041==="a"){this.res_vtas.grupo3=this.res_vtas.grupo3+1;}if(this.eval_vtas.pg042==="a"){this.res_vtas.grupo3=this.res_vtas.grupo3+1;}if(this.eval_vtas.pg043==="b"){this.res_vtas.grupo3=this.res_vtas.grupo3+1;}if(this.eval_vtas.pg060==="b"){this.res_vtas.grupo3=this.res_vtas.grupo3+1;}if(this.eval_vtas.pg078==="b"){this.res_vtas.grupo3=this.res_vtas.grupo3+1;}this.res_vtas.grupo4=0;if(this.eval_vtas.pg008==="b"){this.res_vtas.grupo4=this.res_vtas.grupo4+1;}if(this.eval_vtas.pg026==="b"){this.res_vtas.grupo4=this.res_vtas.grupo4+1;}if(this.eval_vtas.pg044==="a"){this.res_vtas.grupo4=this.res_vtas.grupo4+1;}if(this.eval_vtas.pg061==="b"){this.res_vtas.grupo4=this.res_vtas.grupo4+1;}if(this.eval_vtas.pg062==="a"){this.res_vtas.grupo4=this.res_vtas.grupo4+1;}if(this.eval_vtas.pg079==="b"){this.res_vtas.grupo4=this.res_vtas.grupo4+1;}if(this.eval_vtas.pg080==="c"){this.res_vtas.grupo4=this.res_vtas.grupo4+1;}if(this.eval_vtas.pg081==="c"){this.res_vtas.grupo4=this.res_vtas.grupo4+1;}this.res_vtas.grupo4=8-this.res_vtas.grupo4;this.res_vtas.grupo5=0;if(this.eval_vtas.pg009==="a"){this.res_vtas.grupo5=this.res_vtas.grupo5+1;}if(this.eval_vtas.pg010==="b"){this.res_vtas.grupo5=this.res_vtas.grupo5+1;}if(this.eval_vtas.pg011==="b"){this.res_vtas.grupo5=this.res_vtas.grupo5+1;}if(this.eval_vtas.pg027==="a"){this.res_vtas.grupo5=this.res_vtas.grupo5+1;}if(this.eval_vtas.pg028==="c"){this.res_vtas.grupo5=this.res_vtas.grupo5+1;}if(this.eval_vtas.pg029==="c"){this.res_vtas.grupo5=this.res_vtas.grupo5+1;}if(this.eval_vtas.pg045==="b"){this.res_vtas.grupo5=this.res_vtas.grupo5+1;}if(this.eval_vtas.pg046==="b"){this.res_vtas.grupo5=this.res_vtas.grupo5+1;}if(this.eval_vtas.pg063==="b"){this.res_vtas.grupo5=this.res_vtas.grupo5+1;}if(this.eval_vtas.pg064==="a"){this.res_vtas.grupo5=this.res_vtas.grupo5+1;}if(this.eval_vtas.pg082==="c"){this.res_vtas.grupo5=this.res_vtas.grupo5+1;}this.res_vtas.grupo6=0;if(this.eval_vtas.pg012==="c"){this.res_vtas.grupo6=this.res_vtas.grupo6+1;}if(this.eval_vtas.pg013==="b"){this.res_vtas.grupo6=this.res_vtas.grupo6+1;}if(this.eval_vtas.pg030==="b"){this.res_vtas.grupo6=this.res_vtas.grupo6+1;}if(this.eval_vtas.pg031==="c"){this.res_vtas.grupo6=this.res_vtas.grupo6+1;}if(this.eval_vtas.pg047==="c"){this.res_vtas.grupo6=this.res_vtas.grupo6+1;}if(this.eval_vtas.pg048==="a"){this.res_vtas.grupo6=this.res_vtas.grupo6+1;}if(this.eval_vtas.pg049==="a"){this.res_vtas.grupo6=this.res_vtas.grupo6+1;}if(this.eval_vtas.pg065==="c"){this.res_vtas.grupo6=this.res_vtas.grupo6+1;}if(this.eval_vtas.pg066==="a"){this.res_vtas.grupo6=this.res_vtas.grupo6+1;}if(this.eval_vtas.pg083==="b"){this.res_vtas.grupo6=this.res_vtas.grupo6+1;}if(this.eval_vtas.pg084==="a"){this.res_vtas.grupo6=this.res_vtas.grupo6+1;}this.res_vtas.grupo7=0;if(this.eval_vtas.pg014==="b"){this.res_vtas.grupo7=this.res_vtas.grupo7+1;}if(this.eval_vtas.pg032==="c"){this.res_vtas.grupo7=this.res_vtas.grupo7+1;}if(this.eval_vtas.pg050==="c"){this.res_vtas.grupo7=this.res_vtas.grupo7+1;}if(this.eval_vtas.pg067==="b"){this.res_vtas.grupo7=this.res_vtas.grupo7+1;}if(this.eval_vtas.pg068==="a"){this.res_vtas.grupo7=this.res_vtas.grupo7+1;}if(this.eval_vtas.pg085==="c"){this.res_vtas.grupo7=this.res_vtas.grupo7+1;}if(this.eval_vtas.pg086==="a"){this.res_vtas.grupo7=this.res_vtas.grupo7+1;}if(this.eval_vtas.pg087==="a"){this.res_vtas.grupo7=this.res_vtas.grupo7+1;}this.res_vtas.grupo8=0;if(this.eval_vtas.pg015==="a"){this.res_vtas.grupo8=this.res_vtas.grupo8+1;}if(this.eval_vtas.pg033==="b"){this.res_vtas.grupo8=this.res_vtas.grupo8+1;}if(this.eval_vtas.pg034==="c"){this.res_vtas.grupo8=this.res_vtas.grupo8+1;}if(this.eval_vtas.pg051==="b"){this.res_vtas.grupo8=this.res_vtas.grupo8+1;}if(this.eval_vtas.pg052==="a"){this.res_vtas.grupo8=this.res_vtas.grupo8+1;}if(this.eval_vtas.pg069==="b"){this.res_vtas.grupo8=this.res_vtas.grupo8+1;}if(this.eval_vtas.pg070==="c"){this.res_vtas.grupo8=this.res_vtas.grupo8+1;}if(this.eval_vtas.pg071==="b"){this.res_vtas.grupo8=this.res_vtas.grupo8+1;}this.res_vtas.grupo9=0;if(this.eval_vtas.pg016==="c"){this.res_vtas.grupo9=this.res_vtas.grupo9+1;}if(this.eval_vtas.pg017==="b"){this.res_vtas.grupo9=this.res_vtas.grupo9+1;}if(this.eval_vtas.pg018==="c"){this.res_vtas.grupo9=this.res_vtas.grupo9+1;}if(this.eval_vtas.pg035==="a"){this.res_vtas.grupo9=this.res_vtas.grupo9+1;}if(this.eval_vtas.pg036==="c"){this.res_vtas.grupo9=this.res_vtas.grupo9+1;}if(this.eval_vtas.pg053==="b"){this.res_vtas.grupo9=this.res_vtas.grupo9+1;}if(this.eval_vtas.pg054==="a"){this.res_vtas.grupo9=this.res_vtas.grupo9+1;}if(this.eval_vtas.pg072==="a"){this.res_vtas.grupo9=this.res_vtas.grupo9+1;}console.log("17 ",this.eval_vtas.pg017);console.log("18 ",this.eval_vtas.pg018);console.log("35 ",this.eval_vtas.pg035);console.log("g9 ",this.res_vtas.grupo9);this.res_vtas.grupoR=this.res_vtas.grupo1+this.res_vtas.grupo2+this.res_vtas.grupo3+this.res_vtas.grupo4;this.res_vtas.grupoA=this.res_vtas.grupo5+this.res_vtas.grupo6+this.res_vtas.grupo7+this.res_vtas.grupo8+this.res_vtas.grupo9;this.res_vtas.grupoCol=0;if(this.eval_vtas.pg001==="b"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg002==="b"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg003==="b"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg004==="b"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg005==="a"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg006==="c"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg007==="a"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg008==="b"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg009==="a"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg010==="b"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg011==="b"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg012==="c"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg013==="b"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg014==="b"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg015==="a"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg016==="c"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg017==="b"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg018==="c"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg027==="a"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}if(this.eval_vtas.pg035==="a"){this.res_vtas.grupoCol=this.res_vtas.grupoCol+1;}},resultadosvtas2:function resultadosvtas2(doc){this.rangosvtas2();doc.setLineWidth(0.25);doc.text(10,85,"SECCION DE RESULTADOS ");doc.line(10,86,206,86);doc.text(10,95,"* Grupo 1 ");doc.text(30,95,this.res_vtas.grupo1.toString());doc.text(10,100,"* Grupo 2 ");doc.text(30,100,this.res_vtas.grupo2.toString());doc.text(10,105,"* Grupo 3 ");doc.text(30,105,this.res_vtas.grupo3.toString());doc.text(10,110,"* Grupo 4 ");doc.text(30,110,this.res_vtas.grupo4.toString());doc.text(10,115,"* Grupo 5 ");doc.text(30,115,this.res_vtas.grupo5.toString());doc.text(10,120,"* Grupo 6 ");doc.text(30,120,this.res_vtas.grupo6.toString());doc.text(10,125,"* Grupo 7 ");doc.text(30,125,this.res_vtas.grupo7.toString());doc.text(10,130,"* Grupo 8 ");doc.text(30,130,this.res_vtas.grupo8.toString());doc.text(10,135,"* Grupo 9 ");doc.text(30,135,this.res_vtas.grupo9.toString());doc.text(10,140,"* Grupo R ");doc.text(30,140,this.res_vtas.grupoR.toString());doc.text(10,145,"* Grupo A ");doc.text(30,145,this.res_vtas.grupoA.toString());doc.text(10,150,"* Grupo Columna ");doc.text(40,150,this.res_vtas.grupoCol.toString());},respuestasvtas2:function respuestasvtas2(doc){console.log("Respuestas ");console.log(this.eval_vtas);/* Muestra las preguntas *//* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */doc.setLineWidth(0.25);doc.text(10,40,"SECCION DE RESPUESTAS ");doc.line(10,42,206,42);// doc.text(10, 45, this.eval_vtas.pg001 === "a" ? "| 01= (a)" : "| 01= (b)");
doc.text(10,45,this.eval_vtas.pg001==="a"?"| 01= (a)":this.eval_vtas.pg001==="b"?"| 01= (b)":"| 01= (c)");doc.text(23,45,this.eval_vtas.pg002==="a"?"| 02= (a)":this.eval_vtas.pg002==="b"?"| 02= (b)":"| 02= (c)");doc.text(36,45,this.eval_vtas.pg003==="a"?"| 03= (a)":this.eval_vtas.pg003==="b"?"| 03= (b)":"| 03= (c)");doc.text(49,45,this.eval_vtas.pg004==="a"?"| 04= (a)":this.eval_vtas.pg004==="b"?"| 04= (b)":"| 04= (c)");doc.text(62,45,this.eval_vtas.pg005==="a"?"| 05= (a)":this.eval_vtas.pg005==="b"?"| 05= (b)":"| 05= (c)");doc.text(75,45,this.eval_vtas.pg006==="a"?"| 06= (a)":this.eval_vtas.pg006==="b"?"| 06= (b)":"| 06= (c)");doc.text(88,45,this.eval_vtas.pg007==="a"?"| 07= (a)":this.eval_vtas.pg007==="b"?"| 07= (b)":"| 07= (c)");doc.text(101,45,this.eval_vtas.pg008==="a"?"| 08= (a)":this.eval_vtas.pg008==="b"?"| 08= (b)":"| 08= (c)");doc.text(114,45,this.eval_vtas.pg009==="a"?"| 09= (a)":this.eval_vtas.pg009==="b"?"| 09= (b)":"| 09= (c)");doc.text(127,45,this.eval_vtas.pg010==="a"?"| 10= (a)":this.eval_vtas.pg010==="b"?"| 10= (b)":"| 10= (c)");doc.text(140,45,this.eval_vtas.pg011==="a"?"| 11= (a)":this.eval_vtas.pg011==="b"?"| 11= (b)":"| 11= (c)");doc.text(153,45,this.eval_vtas.pg012==="a"?"| 12= (a)":this.eval_vtas.pg012==="b"?"| 12= (b)":"| 12= (c)");doc.text(166,45,this.eval_vtas.pg013==="a"?"| 13= (a)":this.eval_vtas.pg013==="b"?"| 13= (b)":"| 13= (c)");doc.text(179,45,this.eval_vtas.pg014==="a"?"| 14= (a)":this.eval_vtas.pg014==="b"?"| 14= (b)":"| 14= (c)");doc.text(192,45,this.eval_vtas.pg015==="a"?"| 15= (a) |":this.eval_vtas.pg015==="b"?"| 15= (b) |":"| 15= (c) |");doc.line(10,46,206,46);doc.text(10,49,this.eval_vtas.pg016==="a"?"| 16= (a)":this.eval_vtas.pg016==="b"?"| 16= (b)":"| 16= (c)");doc.text(23,49,this.eval_vtas.pg017==="a"?"| 17= (a)":this.eval_vtas.pg017==="b"?"| 17= (b)":"| 17= (c)");doc.text(36,49,this.eval_vtas.pg018==="a"?"| 18= (a)":this.eval_vtas.pg018==="b"?"| 18= (b)":"| 18= (c)");doc.text(49,49,this.eval_vtas.pg019==="a"?"| 19= (a)":this.eval_vtas.pg019==="b"?"| 19= (b)":"| 19= (c)");doc.text(62,49,this.eval_vtas.pg020==="a"?"| 20= (a)":this.eval_vtas.pg020==="b"?"| 20= (b)":"| 20= (c)");doc.text(75,49,this.eval_vtas.pg021==="a"?"| 21= (a)":this.eval_vtas.pg021==="b"?"| 21= (b)":"| 21= (c)");doc.text(88,49,this.eval_vtas.pg022==="a"?"| 22= (a)":this.eval_vtas.pg022==="b"?"| 22= (b)":"| 22= (c)");doc.text(101,49,this.eval_vtas.pg023==="a"?"| 23= (a)":this.eval_vtas.pg023==="b"?"| 23= (b)":"| 23= (c)");doc.text(114,49,this.eval_vtas.pg024==="a"?"| 24= (a)":this.eval_vtas.pg024==="b"?"| 24= (b)":"| 24= (c)");doc.text(127,49,this.eval_vtas.pg025==="a"?"| 25= (a)":this.eval_vtas.pg025==="b"?"| 25= (b)":"| 25= (c)");doc.text(140,49,this.eval_vtas.pg026==="a"?"| 26= (a)":this.eval_vtas.pg026==="b"?"| 26= (b)":"| 26= (c)");doc.text(153,49,this.eval_vtas.pg027==="a"?"| 27= (a)":this.eval_vtas.pg027==="b"?"| 27= (b)":"| 27= (c)");doc.text(166,49,this.eval_vtas.pg028==="a"?"| 28= (a)":this.eval_vtas.pg028==="b"?"| 28= (b)":"| 28= (c)");doc.text(179,49,this.eval_vtas.pg029==="a"?"| 29= (a)":this.eval_vtas.pg029==="b"?"| 29= (b)":"| 29= (c)");doc.text(192,49,this.eval_vtas.pg030==="a"?"| 30= (a) |":this.eval_vtas.pg030==="b"?"| 30= (b) |":"| 30= (c) |");doc.line(10,50,206,50);doc.text(10,53,this.eval_vtas.pg031==="a"?"| 31= (a)":this.eval_vtas.pg031==="b"?"| 39= (b)":"| 31= (c)");doc.text(23,53,this.eval_vtas.pg032==="a"?"| 32= (a)":this.eval_vtas.pg032==="b"?"| 39= (b)":"| 32= (c)");doc.text(36,53,this.eval_vtas.pg033==="a"?"| 33= (a)":this.eval_vtas.pg033==="b"?"| 39= (b)":"| 33= (c)");doc.text(49,53,this.eval_vtas.pg034==="a"?"| 34= (a)":this.eval_vtas.pg034==="b"?"| 39= (b)":"| 34= (c)");doc.text(62,53,this.eval_vtas.pg035==="a"?"| 35= (a)":this.eval_vtas.pg035==="b"?"| 39= (b)":"| 35= (c)");doc.text(75,53,this.eval_vtas.pg036==="a"?"| 36= (a)":this.eval_vtas.pg036==="b"?"| 39= (b)":"| 36= (c)");doc.text(88,53,this.eval_vtas.pg037==="a"?"| 37= (a)":this.eval_vtas.pg037==="b"?"| 39= (b)":"| 37= (c)");doc.text(101,53,this.eval_vtas.pg038==="a"?"| 38= (a)":this.eval_vtas.pg038==="b"?"| 39= (b)":"| 38= (c)");doc.text(114,53,this.eval_vtas.pg039==="a"?"| 39= (a)":this.eval_vtas.pg039==="b"?"| 39= (b)":"| 39= (c)");doc.text(127,53,this.eval_vtas.pg040==="a"?"| 40= (a)":this.eval_vtas.pg040==="b"?"| 39= (b)":"| 40= (c)");doc.text(140,53,this.eval_vtas.pg041==="a"?"| 41= (a)":this.eval_vtas.pg041==="b"?"| 39= (b)":"| 41= (c)");doc.text(153,53,this.eval_vtas.pg042==="a"?"| 42= (a)":this.eval_vtas.pg042==="b"?"| 39= (b)":"| 42= (c)");doc.text(166,53,this.eval_vtas.pg043==="a"?"| 43= (a)":this.eval_vtas.pg043==="b"?"| 39= (b)":"| 43= (c)");doc.text(179,53,this.eval_vtas.pg044==="a"?"| 44= (a)":this.eval_vtas.pg044==="b"?"| 39= (b)":"| 44= (c)");doc.text(192,53,this.eval_vtas.pg045==="a"?"| 45= (a) |":this.eval_vtas.pg045==="b"?"| 39= (b) |":"| 45= (c) |");doc.line(10,54,206,54);doc.text(10,57,this.eval_vtas.pg046==="a"?"| 46= (a)":this.eval_vtas.pg046==="b"?"| 46= (b)":"| 46= (c)");doc.text(23,57,this.eval_vtas.pg047==="a"?"| 47= (a)":this.eval_vtas.pg047==="b"?"| 47= (b)":"| 47= (c)");doc.text(36,57,this.eval_vtas.pg048==="a"?"| 48= (a)":this.eval_vtas.pg048==="b"?"| 48= (b)":"| 48= (c)");doc.text(49,57,this.eval_vtas.pg049==="a"?"| 49= (a)":this.eval_vtas.pg049==="b"?"| 49= (b)":"| 49= (c)");doc.text(62,57,this.eval_vtas.pg050==="a"?"| 50= (a)":this.eval_vtas.pg050==="b"?"| 50= (b)":"| 50= (c)");doc.text(75,57,this.eval_vtas.pg051==="a"?"| 51= (a)":this.eval_vtas.pg051==="b"?"| 51= (b)":"| 51= (c)");doc.text(88,57,this.eval_vtas.pg052==="a"?"| 52= (a)":this.eval_vtas.pg052==="b"?"| 52= (b)":"| 52= (c)");doc.text(101,57,this.eval_vtas.pg053==="a"?"| 53= (a)":this.eval_vtas.pg053==="b"?"| 53= (b)":"| 53= (c)");doc.text(114,57,this.eval_vtas.pg054==="a"?"| 54= (a)":this.eval_vtas.pg054==="b"?"| 54= (b)":"| 54= (c)");doc.text(127,57,this.eval_vtas.pg055==="a"?"| 55= (a)":this.eval_vtas.pg055==="b"?"| 55= (b)":"| 55= (c)");doc.text(140,57,this.eval_vtas.pg056==="a"?"| 56= (a)":this.eval_vtas.pg056==="b"?"| 56= (b)":"| 56= (c)");doc.text(153,57,this.eval_vtas.pg057==="a"?"| 57= (a)":this.eval_vtas.pg057==="b"?"| 57= (b)":"| 57= (c)");doc.text(166,57,this.eval_vtas.pg058==="a"?"| 58= (a)":this.eval_vtas.pg058==="b"?"| 58= (b)":"| 58= (c)");doc.text(179,57,this.eval_vtas.pg059==="a"?"| 59= (a)":this.eval_vtas.pg059==="b"?"| 59= (b)":"| 59= (c)");doc.text(192,57,this.eval_vtas.pg060==="a"?"| 60= (a) |":this.eval_vtas.pg060==="b"?"| 60= (b) |":"| 60= (c) |");doc.line(10,58,206,58);doc.text(10,61,this.eval_vtas.pg061==="a"?"| 61= (a)":this.eval_vtas.pg061==="b"?"| 61= (b)":"| 61= (c)");doc.text(23,61,this.eval_vtas.pg062==="a"?"| 62= (a)":this.eval_vtas.pg062==="b"?"| 62= (b)":"| 62= (c)");doc.text(36,61,this.eval_vtas.pg063==="a"?"| 63= (a)":this.eval_vtas.pg063==="b"?"| 63= (b)":"| 63= (c)");doc.text(49,61,this.eval_vtas.pg064==="a"?"| 64= (a)":this.eval_vtas.pg064==="b"?"| 64= (b)":"| 64= (c)");doc.text(62,61,this.eval_vtas.pg065==="a"?"| 65= (a)":this.eval_vtas.pg065==="b"?"| 65= (b)":"| 65= (c)");doc.text(75,61,this.eval_vtas.pg066==="a"?"| 66= (a)":this.eval_vtas.pg066==="b"?"| 66= (b)":"| 66= (c)");doc.text(88,61,this.eval_vtas.pg067==="a"?"| 67= (a)":this.eval_vtas.pg067==="b"?"| 67= (b)":"| 67= (c)");doc.text(101,61,this.eval_vtas.pg068==="a"?"| 68= (a)":this.eval_vtas.pg068==="b"?"| 68= (b)":"| 68= (c)");doc.text(114,61,this.eval_vtas.pg069==="a"?"| 69= (a)":this.eval_vtas.pg069==="b"?"| 69= (b)":"| 69= (c)");doc.text(127,61,this.eval_vtas.pg070==="a"?"| 70= (a)":this.eval_vtas.pg070==="b"?"| 70= (b)":"| 70= (c)");doc.text(140,61,this.eval_vtas.pg071==="a"?"| 71= (a)":this.eval_vtas.pg071==="b"?"| 71= (b)":"| 71= (c)");doc.text(153,61,this.eval_vtas.pg072==="a"?"| 72= (a)":this.eval_vtas.pg072==="b"?"| 72= (b)":"| 72= (c)");doc.text(166,61,this.eval_vtas.pg073==="a"?"| 73= (a)":this.eval_vtas.pg073==="b"?"| 73= (b)":"| 73= (c)");doc.text(179,61,this.eval_vtas.pg074==="a"?"| 74= (a)":this.eval_vtas.pg074==="b"?"| 74= (b)":"| 74= (c)");doc.text(192,61,this.eval_vtas.pg075==="a"?"| 75= (a) |":this.eval_vtas.pg075==="b"?"| 75= (b) |":"| 75= (c) |");doc.line(10,62,206,62);doc.text(10,65,this.eval_vtas.pg076==="a"?"| 76= (a)":this.eval_vtas.pg076==="b"?"| 76= (b)":"| 76= (c)");doc.text(23,65,this.eval_vtas.pg077==="a"?"| 77= (a)":this.eval_vtas.pg077==="b"?"| 77= (b)":"| 77= (c)");doc.text(36,65,this.eval_vtas.pg078==="a"?"| 78= (a)":this.eval_vtas.pg078==="b"?"| 78= (b)":"| 78= (c)");doc.text(49,65,this.eval_vtas.pg079==="a"?"| 79= (a)":this.eval_vtas.pg079==="b"?"| 79= (b)":"| 79= (c)");doc.text(62,65,this.eval_vtas.pg080==="a"?"| 80= (a)":this.eval_vtas.pg080==="b"?"| 80= (b)":"| 80= (c)");doc.text(75,65,this.eval_vtas.pg081==="a"?"| 81= (a)":this.eval_vtas.pg081==="b"?"| 81= (b)":"| 81= (c)");doc.text(88,65,this.eval_vtas.pg082==="a"?"| 82= (a)":this.eval_vtas.pg082==="b"?"| 82= (b)":"| 82= (c)");doc.text(101,65,this.eval_vtas.pg083==="a"?"| 83= (a)":this.eval_vtas.pg083==="b"?"| 83= (b)":"| 83= (c)");doc.text(114,65,this.eval_vtas.pg084==="a"?"| 84= (a)":this.eval_vtas.pg084==="b"?"| 84= (b)":"| 84= (c)");doc.text(127,65,this.eval_vtas.pg085==="a"?"| 85= (a)":this.eval_vtas.pg085==="b"?"| 85= (b)":"| 85= (c)");doc.text(140,65,this.eval_vtas.pg086==="a"?"| 86= (a)":this.eval_vtas.pg086==="b"?"| 86= (b)":"| 86= (c)");doc.text(153,65,this.eval_vtas.pg087==="a"?"| 87= (a)":this.eval_vtas.pg087==="b"?"| 87= (b)":"| 87= (c)");doc.line(10,66,206,66);},//? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
getEvalTipolo:function getEvalTipolo(losCasos){this.evaluacionesT=[];this.limite=0;/* Tipología = Myers */for(var key in losCasos){var _evaluacionesT$push;this.evaluacionesT.push((_evaluacionesT$push={llave:key,// 1
empresa:losCasos[key].empresa,nombre:losCasos[key].nombre,fecha:losCasos[key].fecha,empezo:losCasos[key].empezo,termino:losCasos[key].termino,steval:"TIPOLOGIA",pg001:losCasos[key].pg001,pg002:losCasos[key].pg002,pg003:losCasos[key].pg003,pg004:losCasos[key].pg004,pg005:losCasos[key].pg005,pg006:losCasos[key].pg006,pg007:losCasos[key].pg007,pg008:losCasos[key].pg008,pg009:losCasos[key].pg009,pg010:losCasos[key].pg010,pg011:losCasos[key].pg011,pg012:losCasos[key].pg012,pg013:losCasos[key].pg013,pg014:losCasos[key].pg013},_defineProperty(_evaluacionesT$push,'pg014',losCasos[key].pg014),_defineProperty(_evaluacionesT$push,'pg016',losCasos[key].pg016),_defineProperty(_evaluacionesT$push,'pg017',losCasos[key].pg017),_defineProperty(_evaluacionesT$push,'pg018',losCasos[key].pg018),_defineProperty(_evaluacionesT$push,'pg019',losCasos[key].pg019),_defineProperty(_evaluacionesT$push,'pg020',losCasos[key].pg020),_defineProperty(_evaluacionesT$push,'pg021',losCasos[key].pg021),_defineProperty(_evaluacionesT$push,'pg022',losCasos[key].pg022),_defineProperty(_evaluacionesT$push,'pg023',losCasos[key].pg023),_defineProperty(_evaluacionesT$push,'pg024',losCasos[key].pg024),_defineProperty(_evaluacionesT$push,'pg025',losCasos[key].pg025),_defineProperty(_evaluacionesT$push,'pg026',losCasos[key].pg026),_defineProperty(_evaluacionesT$push,'pg027',losCasos[key].pg027),_defineProperty(_evaluacionesT$push,'pg028',losCasos[key].pg028),_defineProperty(_evaluacionesT$push,'pg029',losCasos[key].pg029),_defineProperty(_evaluacionesT$push,'pg030',losCasos[key].pg030),_defineProperty(_evaluacionesT$push,'pg031',losCasos[key].pg031),_defineProperty(_evaluacionesT$push,'pg032',losCasos[key].pg032),_defineProperty(_evaluacionesT$push,'pg033',losCasos[key].pg033),_defineProperty(_evaluacionesT$push,'pg034',losCasos[key].pg034),_defineProperty(_evaluacionesT$push,'pg035',losCasos[key].pg035),_defineProperty(_evaluacionesT$push,'pg036',losCasos[key].pg036),_defineProperty(_evaluacionesT$push,'pg037',losCasos[key].pg037),_defineProperty(_evaluacionesT$push,'pg038',losCasos[key].pg038),_defineProperty(_evaluacionesT$push,'pg039',losCasos[key].pg039),_defineProperty(_evaluacionesT$push,'pg040',losCasos[key].pg040),_defineProperty(_evaluacionesT$push,'pg041',losCasos[key].pg041),_defineProperty(_evaluacionesT$push,'pg042',losCasos[key].pg042),_defineProperty(_evaluacionesT$push,'pg043',losCasos[key].pg043),_defineProperty(_evaluacionesT$push,'pg044',losCasos[key].pg044),_defineProperty(_evaluacionesT$push,'pg045',losCasos[key].pg045),_defineProperty(_evaluacionesT$push,'pg046',losCasos[key].pg046),_defineProperty(_evaluacionesT$push,'pg047',losCasos[key].pg047),_defineProperty(_evaluacionesT$push,'pg048',losCasos[key].pg048),_defineProperty(_evaluacionesT$push,'pg049',losCasos[key].pg049),_defineProperty(_evaluacionesT$push,'pg050',losCasos[key].pg050),_defineProperty(_evaluacionesT$push,'pg051',losCasos[key].pg051),_defineProperty(_evaluacionesT$push,'pg052',losCasos[key].pg052),_defineProperty(_evaluacionesT$push,'pg053',losCasos[key].pg053),_defineProperty(_evaluacionesT$push,'pg054',losCasos[key].pg054),_defineProperty(_evaluacionesT$push,'pg055',losCasos[key].pg055),_defineProperty(_evaluacionesT$push,'pg056',losCasos[key].pg056),_defineProperty(_evaluacionesT$push,'pg057',losCasos[key].pg057),_defineProperty(_evaluacionesT$push,'pg058',losCasos[key].pg058),_defineProperty(_evaluacionesT$push,'pg059',losCasos[key].pg059),_defineProperty(_evaluacionesT$push,'pg060',losCasos[key].pg060),_defineProperty(_evaluacionesT$push,'pg061',losCasos[key].pg061),_defineProperty(_evaluacionesT$push,'pg062',losCasos[key].pg062),_defineProperty(_evaluacionesT$push,'pg063',losCasos[key].pg063),_defineProperty(_evaluacionesT$push,'pg064',losCasos[key].pg064),_defineProperty(_evaluacionesT$push,'pg065',losCasos[key].pg065),_defineProperty(_evaluacionesT$push,'pg066',losCasos[key].pg066),_defineProperty(_evaluacionesT$push,'pg067',losCasos[key].pg067),_defineProperty(_evaluacionesT$push,'pg068',losCasos[key].pg068),_defineProperty(_evaluacionesT$push,'pg069',losCasos[key].pg069),_defineProperty(_evaluacionesT$push,'pg070',losCasos[key].pg070),_evaluacionesT$push));}// for
},getEvalFactor:function getEvalFactor(losCasos){/* Tipología = Myers */for(var key in losCasos){var _evaluacionesT$push2;// console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
this.evaluacionesT.push((_evaluacionesT$push2={llave:key,// 1
empresa:losCasos[key].empresa,nombre:losCasos[key].nombre,fecha:losCasos[key].fecha,empezo:losCasos[key].empezo,termino:losCasos[key].termino,steval:"FACTORES",pg001:losCasos[key].pg001,pg002:losCasos[key].pg002,pg003:losCasos[key].pg003,pg004:losCasos[key].pg004,pg005:losCasos[key].pg005,pg006:losCasos[key].pg006,pg007:losCasos[key].pg007,pg008:losCasos[key].pg008,pg009:losCasos[key].pg009,pg010:losCasos[key].pg010,pg011:losCasos[key].pg011,pg012:losCasos[key].pg012,pg013:losCasos[key].pg013,pg014:losCasos[key].pg013},_defineProperty(_evaluacionesT$push2,'pg014',losCasos[key].pg014),_defineProperty(_evaluacionesT$push2,'pg016',losCasos[key].pg016),_defineProperty(_evaluacionesT$push2,'pg017',losCasos[key].pg017),_defineProperty(_evaluacionesT$push2,'pg018',losCasos[key].pg018),_defineProperty(_evaluacionesT$push2,'pg019',losCasos[key].pg019),_defineProperty(_evaluacionesT$push2,'pg020',losCasos[key].pg020),_defineProperty(_evaluacionesT$push2,'pg021',losCasos[key].pg021),_defineProperty(_evaluacionesT$push2,'pg022',losCasos[key].pg022),_defineProperty(_evaluacionesT$push2,'pg023',losCasos[key].pg023),_defineProperty(_evaluacionesT$push2,'pg024',losCasos[key].pg024),_defineProperty(_evaluacionesT$push2,'pg025',losCasos[key].pg025),_defineProperty(_evaluacionesT$push2,'pg026',losCasos[key].pg026),_defineProperty(_evaluacionesT$push2,'pg027',losCasos[key].pg027),_defineProperty(_evaluacionesT$push2,'pg028',losCasos[key].pg028),_defineProperty(_evaluacionesT$push2,'pg029',losCasos[key].pg029),_defineProperty(_evaluacionesT$push2,'pg030',losCasos[key].pg030),_defineProperty(_evaluacionesT$push2,'pg031',losCasos[key].pg031),_defineProperty(_evaluacionesT$push2,'pg032',losCasos[key].pg032),_defineProperty(_evaluacionesT$push2,'pg033',losCasos[key].pg033),_defineProperty(_evaluacionesT$push2,'pg034',losCasos[key].pg034),_defineProperty(_evaluacionesT$push2,'pg035',losCasos[key].pg035),_defineProperty(_evaluacionesT$push2,'pg036',losCasos[key].pg036),_defineProperty(_evaluacionesT$push2,'pg037',losCasos[key].pg037),_defineProperty(_evaluacionesT$push2,'pg038',losCasos[key].pg038),_defineProperty(_evaluacionesT$push2,'pg039',losCasos[key].pg039),_defineProperty(_evaluacionesT$push2,'pg040',losCasos[key].pg040),_defineProperty(_evaluacionesT$push2,'pg041',losCasos[key].pg041),_defineProperty(_evaluacionesT$push2,'pg042',losCasos[key].pg042),_defineProperty(_evaluacionesT$push2,'pg043',losCasos[key].pg043),_defineProperty(_evaluacionesT$push2,'pg044',losCasos[key].pg044),_defineProperty(_evaluacionesT$push2,'pg045',losCasos[key].pg045),_defineProperty(_evaluacionesT$push2,'pg046',losCasos[key].pg046),_defineProperty(_evaluacionesT$push2,'pg047',losCasos[key].pg047),_defineProperty(_evaluacionesT$push2,'pg048',losCasos[key].pg048),_defineProperty(_evaluacionesT$push2,'pg049',losCasos[key].pg049),_defineProperty(_evaluacionesT$push2,'pg050',losCasos[key].pg050),_defineProperty(_evaluacionesT$push2,'pg051',losCasos[key].pg051),_defineProperty(_evaluacionesT$push2,'pg052',losCasos[key].pg052),_defineProperty(_evaluacionesT$push2,'pg053',losCasos[key].pg053),_defineProperty(_evaluacionesT$push2,'pg054',losCasos[key].pg054),_defineProperty(_evaluacionesT$push2,'pg055',losCasos[key].pg055),_defineProperty(_evaluacionesT$push2,'pg056',losCasos[key].pg056),_defineProperty(_evaluacionesT$push2,'pg057',losCasos[key].pg057),_defineProperty(_evaluacionesT$push2,'pg058',losCasos[key].pg058),_defineProperty(_evaluacionesT$push2,'pg059',losCasos[key].pg059),_defineProperty(_evaluacionesT$push2,'pg060',losCasos[key].pg060),_defineProperty(_evaluacionesT$push2,'pg061',losCasos[key].pg061),_defineProperty(_evaluacionesT$push2,'pg062',losCasos[key].pg062),_defineProperty(_evaluacionesT$push2,'pg063',losCasos[key].pg063),_defineProperty(_evaluacionesT$push2,'pg064',losCasos[key].pg064),_defineProperty(_evaluacionesT$push2,'pg065',losCasos[key].pg065),_defineProperty(_evaluacionesT$push2,'pg066',losCasos[key].pg066),_defineProperty(_evaluacionesT$push2,'pg067',losCasos[key].pg067),_defineProperty(_evaluacionesT$push2,'pg068',losCasos[key].pg068),_defineProperty(_evaluacionesT$push2,'pg069',losCasos[key].pg069),_defineProperty(_evaluacionesT$push2,'pg070',losCasos[key].pg070),_defineProperty(_evaluacionesT$push2,'pg071',losCasos[key].pg071),_defineProperty(_evaluacionesT$push2,'pg062',losCasos[key].pg072),_defineProperty(_evaluacionesT$push2,'pg073',losCasos[key].pg073),_defineProperty(_evaluacionesT$push2,'pg074',losCasos[key].pg074),_defineProperty(_evaluacionesT$push2,'pg075',losCasos[key].pg075),_defineProperty(_evaluacionesT$push2,'pg076',losCasos[key].pg076),_defineProperty(_evaluacionesT$push2,'pg067',losCasos[key].pg077),_defineProperty(_evaluacionesT$push2,'pg078',losCasos[key].pg078),_defineProperty(_evaluacionesT$push2,'pg079',losCasos[key].pg079),_defineProperty(_evaluacionesT$push2,'pg080',losCasos[key].pg080),_defineProperty(_evaluacionesT$push2,'pg081',losCasos[key].pg081),_defineProperty(_evaluacionesT$push2,'pg082',losCasos[key].pg082),_defineProperty(_evaluacionesT$push2,'pg083',losCasos[key].pg083),_defineProperty(_evaluacionesT$push2,'pg084',losCasos[key].pg084),_defineProperty(_evaluacionesT$push2,'pg085',losCasos[key].pg085),_defineProperty(_evaluacionesT$push2,'pg086',losCasos[key].pg086),_defineProperty(_evaluacionesT$push2,'pg087',losCasos[key].pg087),_defineProperty(_evaluacionesT$push2,'pg088',losCasos[key].pg088),_defineProperty(_evaluacionesT$push2,'pg089',losCasos[key].pg089),_defineProperty(_evaluacionesT$push2,'pg080',losCasos[key].pg090),_defineProperty(_evaluacionesT$push2,'pg091',losCasos[key].pg091),_defineProperty(_evaluacionesT$push2,'pg092',losCasos[key].pg092),_defineProperty(_evaluacionesT$push2,'pg093',losCasos[key].pg093),_defineProperty(_evaluacionesT$push2,'pg094',losCasos[key].pg094),_defineProperty(_evaluacionesT$push2,'pg095',losCasos[key].pg095),_defineProperty(_evaluacionesT$push2,'pg096',losCasos[key].pg096),_defineProperty(_evaluacionesT$push2,'pg097',losCasos[key].pg097),_defineProperty(_evaluacionesT$push2,'pg098',losCasos[key].pg098),_defineProperty(_evaluacionesT$push2,'pg099',losCasos[key].pg099),_defineProperty(_evaluacionesT$push2,'pg090',losCasos[key].pg100),_defineProperty(_evaluacionesT$push2,'pg061',losCasos[key].pg061),_defineProperty(_evaluacionesT$push2,'pg062',losCasos[key].pg062),_defineProperty(_evaluacionesT$push2,'pg063',losCasos[key].pg063),_defineProperty(_evaluacionesT$push2,'pg064',losCasos[key].pg064),_defineProperty(_evaluacionesT$push2,'pg065',losCasos[key].pg065),_defineProperty(_evaluacionesT$push2,'pg0101',losCasos[key].pg101),_defineProperty(_evaluacionesT$push2,'pg0102',losCasos[key].pg102),_evaluacionesT$push2));}// for
},getEvalEstabi:function getEvalEstabi(losCasos){/* Tipología = Myers */for(var key in losCasos){// console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
this.evaluacionesT.push({llave:key,// 1
empresa:losCasos[key].empresa,nombre:losCasos[key].nombre,fecha:losCasos[key].fecha,empezo:losCasos[key].empezo,termino:losCasos[key].termino,steval:"ESTABILIDAD",pg001:losCasos[key].pg001,pg002:losCasos[key].pg002,pg003:losCasos[key].pg003,pg004:losCasos[key].pg004,pg005:losCasos[key].pg005,pg006:losCasos[key].pg006,pg007:losCasos[key].pg007,pg008:losCasos[key].pg008,pg009:losCasos[key].pg009,pg010:losCasos[key].pg010,pg011:losCasos[key].pg011,pg012:losCasos[key].pg012,pg013:losCasos[key].pg013,pg014:losCasos[key].pg014,pg015:losCasos[key].pg015,pg016:losCasos[key].pg016,pg017:losCasos[key].pg017,pg018:losCasos[key].pg018,pg019:losCasos[key].pg019,pg020:losCasos[key].pg020,pg021:losCasos[key].pg021,pg022:losCasos[key].pg022,pg023:losCasos[key].pg023,pg024:losCasos[key].pg024,pg025:losCasos[key].pg025,pg026:losCasos[key].pg026,pg027:losCasos[key].pg027,pg028:losCasos[key].pg028,pg029:losCasos[key].pg029,pg030:losCasos[key].pg030,pg031:losCasos[key].pg031,pg032:losCasos[key].pg032,pg033:losCasos[key].pg033,pg034:losCasos[key].pg034,pg035:losCasos[key].pg035,pg036:losCasos[key].pg036,pg037:losCasos[key].pg037,pg038:losCasos[key].pg038,pg039:losCasos[key].pg039,pg040:losCasos[key].pg040});}// for
// this.limite = this.evaluacionesT.length; // cantidad de datos                
// this.eval_copia = this.evaluacionesT;
// store.state.st_eval = this.evaluacionesT;
},getEvalSociab:function getEvalSociab(losCasos){/* Tipología = Myers */for(var key in losCasos){// console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
this.evaluacionesT.push({llave:key,// 1
empresa:losCasos[key].empresa,nombre:losCasos[key].nombre,fecha:losCasos[key].fecha,empezo:losCasos[key].empezo,termino:losCasos[key].termino,steval:"SOCIABILIDAD",pg001:losCasos[key].pg001,pg002:losCasos[key].pg002,pg003:losCasos[key].pg003,pg004:losCasos[key].pg004,pg005:losCasos[key].pg005,pg006:losCasos[key].pg006,pg007:losCasos[key].pg007,pg008:losCasos[key].pg008,pg009:losCasos[key].pg009,pg010:losCasos[key].pg010,pg011:losCasos[key].pg011,pg012:losCasos[key].pg012,pg013:losCasos[key].pg013,pg014:losCasos[key].pg014,pg015:losCasos[key].pg015,pg016:losCasos[key].pg016,pg017:losCasos[key].pg017,pg018:losCasos[key].pg018,pg019:losCasos[key].pg019,pg020:losCasos[key].pg020,pg021:losCasos[key].pg021,pg022:losCasos[key].pg022,pg023:losCasos[key].pg023,pg024:losCasos[key].pg024,pg025:losCasos[key].pg025,pg026:losCasos[key].pg026,pg027:losCasos[key].pg027,pg028:losCasos[key].pg028,pg029:losCasos[key].pg029,pg030:losCasos[key].pg030,pg031:losCasos[key].pg031,pg032:losCasos[key].pg032,pg033:losCasos[key].pg033,pg034:losCasos[key].pg034,pg035:losCasos[key].pg035,pg036:losCasos[key].pg036,pg037:losCasos[key].pg037,pg038:losCasos[key].pg038,pg039:losCasos[key].pg039,pg040:losCasos[key].pg040});}// for
// this.limite = this.evaluacionesT.length; // cantidad de datos                
// this.eval_copia = this.evaluacionesT;
// store.state.st_eval = this.evaluacionesT;
},getEvalPerfil:function getEvalPerfil(losCasos){/* Tipología = Myers */for(var key in losCasos){// console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
this.evaluacionesT.push({llave:key,// 1
empresa:losCasos[key].empresa,nombre:losCasos[key].nombre,fecha:losCasos[key].fecha,empezo:losCasos[key].empezo,termino:losCasos[key].termino,steval:"PERFIL",pg001:losCasos[key].pg001,pg002:losCasos[key].pg002,pg003:losCasos[key].pg003,pg004:losCasos[key].pg004,pg005:losCasos[key].pg005,pg006:losCasos[key].pg006,pg007:losCasos[key].pg007,pg008:losCasos[key].pg008,pg009:losCasos[key].pg009,pg010:losCasos[key].pg010,pg011:losCasos[key].pg011,pg012:losCasos[key].pg012,pg013:losCasos[key].pg013,pg014:losCasos[key].pg014,pg015:losCasos[key].pg015,pg016:losCasos[key].pg016,pg017:losCasos[key].pg017,pg018:losCasos[key].pg018,pg019:losCasos[key].pg019,pg020:losCasos[key].pg020,pg021:losCasos[key].pg021,pg022:losCasos[key].pg022,pg023:losCasos[key].pg023,pg024:losCasos[key].pg024,pg025:losCasos[key].pg025,pg026:losCasos[key].pg026,pg027:losCasos[key].pg027,pg028:losCasos[key].pg028,pg029:losCasos[key].pg029,pg030:losCasos[key].pg030,pg031:losCasos[key].pg031,pg032:losCasos[key].pg032,pg033:losCasos[key].pg033,pg034:losCasos[key].pg034,pg035:losCasos[key].pg035,pg036:losCasos[key].pg036,pg037:losCasos[key].pg037,pg038:losCasos[key].pg038,pg039:losCasos[key].pg039,pg040:losCasos[key].pg040,pg041:losCasos[key].pg041,pg042:losCasos[key].pg042,pg043:losCasos[key].pg043,pg044:losCasos[key].pg044,pg045:losCasos[key].pg045,pg046:losCasos[key].pg046,pg047:losCasos[key].pg047,pg048:losCasos[key].pg048});}// for
// this.limite = this.evaluacionesT.length; // cantidad de datos                
// this.eval_copia = this.evaluacionesT;
// store.state.st_eval = this.evaluacionesT;
},getEvalSuperv:function getEvalSuperv(losCasos){/* Tipología = Myers */for(var key in losCasos){// console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
this.evaluacionesT.push({llave:key,// 1
empresa:losCasos[key].empresa,nombre:losCasos[key].nombre,fecha:losCasos[key].fecha,empezo:losCasos[key].empezo,termino:losCasos[key].termino,steval:"MOSS",pg001:losCasos[key].pg001,pg002:losCasos[key].pg002,pg003:losCasos[key].pg003,pg004:losCasos[key].pg004,pg005:losCasos[key].pg005,pg006:losCasos[key].pg006,pg007:losCasos[key].pg007,pg008:losCasos[key].pg008,pg009:losCasos[key].pg009,pg010:losCasos[key].pg010,pg011:losCasos[key].pg011,pg012:losCasos[key].pg012,pg013:losCasos[key].pg013,pg014:losCasos[key].pg014,pg015:losCasos[key].pg015,pg016:losCasos[key].pg016,pg017:losCasos[key].pg017,pg018:losCasos[key].pg018,pg019:losCasos[key].pg019,pg020:losCasos[key].pg020,pg021:losCasos[key].pg021,pg022:losCasos[key].pg022,pg023:losCasos[key].pg023,pg024:losCasos[key].pg024,pg025:losCasos[key].pg025,pg026:losCasos[key].pg026,pg027:losCasos[key].pg027,pg028:losCasos[key].pg028,pg029:losCasos[key].pg029,pg030:losCasos[key].pg030});}// for
// this.limite = this.evaluacionesT.length; // cantidad de datos                
// this.eval_copia = this.evaluacionesT;
// store.state.st_eval = this.evaluacionesT;
},getEvalApvtas:function getEvalApvtas(losCasos){/* Tipología = Myers */for(var key in losCasos){// console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
this.evaluacionesT.push({llave:key,// 1
empresa:losCasos[key].empresa,nombre:losCasos[key].nombre,fecha:losCasos[key].fecha,empezo:losCasos[key].empezo,termino:losCasos[key].termino,sexo:losCasos[key].sexo,steval:"TAV",pg001:losCasos[key].pg001,pg002:losCasos[key].pg002,pg003:losCasos[key].pg003,pg004:losCasos[key].pg004,pg005:losCasos[key].pg005,pg006:losCasos[key].pg006,pg007:losCasos[key].pg007,pg008:losCasos[key].pg008,pg009:losCasos[key].pg009,pg010:losCasos[key].pg010,pg011:losCasos[key].pg011,pg012:losCasos[key].pg012,pg013:losCasos[key].pg013,pg014:losCasos[key].pg014,pg015:losCasos[key].pg015,pg016:losCasos[key].pg016,pg017:losCasos[key].pg017,pg018:losCasos[key].pg018,pg019:losCasos[key].pg019,pg020:losCasos[key].pg020,pg021:losCasos[key].pg021,pg022:losCasos[key].pg022,pg023:losCasos[key].pg023,pg024:losCasos[key].pg024,pg025:losCasos[key].pg025,pg026:losCasos[key].pg026,pg027:losCasos[key].pg027,pg028:losCasos[key].pg028,pg029:losCasos[key].pg029,pg030:losCasos[key].pg030});}// for
// this.limite = this.evaluacionesT.length; // cantidad de datos                
// this.eval_copia = this.evaluacionesT;
// store.state.st_eval = this.evaluacionesT;
},getEvalSolemp:function getEvalSolemp(losCasos){// console.log("entre a getEvalSolemp !!")
/* Tipología = Myers */for(var key in losCasos){// console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
this.evaluacionesT.push({llave:key,// 1
empresa:losCasos[key].empresa,nombre:losCasos[key].nombre,fecha:losCasos[key].fecha,empezo:losCasos[key].empezo,termino:losCasos[key].termino,sexo:losCasos[key].sexo,steval:"SOLEMP",pg001:losCasos[key].pg001,pg002:losCasos[key].pg002,pg003:losCasos[key].pg003,pg004:losCasos[key].pg004,pg005:losCasos[key].pg005,pg006:losCasos[key].pg006,pg007:losCasos[key].pg007,pg008:losCasos[key].pg008,pg009:losCasos[key].pg009,pg010:losCasos[key].pg010,pg011:losCasos[key].pg011,pg012:losCasos[key].pg012,pg013:losCasos[key].pg013,pg014:losCasos[key].pg014,pg015:losCasos[key].pg015,pg016:losCasos[key].pg016,pg017:losCasos[key].pg017,pg018:losCasos[key].pg018,pg019:losCasos[key].pg019,pg020:losCasos[key].pg020,pg021:losCasos[key].pg021,pg022:losCasos[key].pg022,pg023:losCasos[key].pg023,pg024:losCasos[key].pg024,pg025:losCasos[key].pg025,pg026:losCasos[key].pg026,pg027:losCasos[key].pg027,pg028:losCasos[key].pg028,pg029:losCasos[key].pg029,pg030:losCasos[key].pg030,pg031:losCasos[key].pg031,pg032:losCasos[key].pg032,pg033:losCasos[key].pg033,pg034:losCasos[key].pg034,pg035:losCasos[key].pg035,pg036:losCasos[key].pg036,pg037:losCasos[key].pg037,pg038:losCasos[key].pg038,pg039:losCasos[key].pg039,pg040:losCasos[key].pg040,pg041:losCasos[key].pg041,pg042:losCasos[key].pg042,pg043:losCasos[key].pg043,pg044:losCasos[key].pg044,pg045:losCasos[key].pg045,pg046:losCasos[key].pg046,pg047:losCasos[key].pg047,pg048:losCasos[key].pg048,pg049:losCasos[key].pg049,pg050:losCasos[key].pg050,pg051:losCasos[key].pg051,pg052:losCasos[key].pg052,pg053:losCasos[key].pg053,pg054:losCasos[key].pg054,pg055:losCasos[key].pg055,pg056:losCasos[key].pg056,pg057:losCasos[key].pg057,pg058:losCasos[key].pg058,pg059:losCasos[key].pg059,pg060:losCasos[key].pg060,pg061:losCasos[key].pg061,pg062:losCasos[key].pg062,pg063:losCasos[key].pg063,pg064:losCasos[key].pg064,pg065:losCasos[key].pg065,pg066:losCasos[key].pg066,pg067:losCasos[key].pg067,pg068:losCasos[key].pg068,pg069:losCasos[key].pg069,pg070:losCasos[key].pg070,pg071:losCasos[key].pg071,pg072:losCasos[key].pg072,pg073:losCasos[key].pg073,pg074:losCasos[key].pg074,pg075:losCasos[key].pg075,pg076:losCasos[key].pg076,pg077:losCasos[key].pg077,pg078:losCasos[key].pg078,pg079:losCasos[key].pg079,pg080:losCasos[key].pg080,pg081:losCasos[key].pg081,pg082:losCasos[key].pg082,pg083:losCasos[key].pg083,pg084:losCasos[key].pg084,pg085:losCasos[key].pg085,pg086:losCasos[key].pg086,pg087:losCasos[key].pg087,pg088:losCasos[key].pg088,pg089:losCasos[key].pg089,pg090:losCasos[key].pg090,pg091:losCasos[key].pg091,pg092:losCasos[key].pg092,pg093:losCasos[key].pg093,pg094:losCasos[key].pg094,pg095:losCasos[key].pg095,pg096:losCasos[key].pg096,pg097:losCasos[key].pg097,pg098:losCasos[key].pg098,pg099:losCasos[key].pg099,pg100:losCasos[key].pg100,pg101:losCasos[key].pg101,pg102:losCasos[key].pg102,pg103:losCasos[key].pg103,pg104:losCasos[key].pg104,pg105:losCasos[key].pg105,pg106:losCasos[key].pg106,pg107:losCasos[key].pg107,pg108:losCasos[key].pg108,pg109:losCasos[key].pg109,pg110:losCasos[key].pg110,pg111:losCasos[key].pg111,pg112:losCasos[key].pg112,pg113:losCasos[key].pg113,pg114:losCasos[key].pg114,pg115:losCasos[key].pg115,pg116:losCasos[key].pg116,pg117:losCasos[key].pg117,pg118:losCasos[key].pg118,pg119:losCasos[key].pg119,pg120:losCasos[key].pg120,pg121:losCasos[key].pg121,pg122:losCasos[key].pg122,pg123:losCasos[key].pg123,pg124:losCasos[key].pg124,pg125:losCasos[key].pg125,pg126:losCasos[key].pg126,pg127:losCasos[key].pg127,pg128:losCasos[key].pg128,pg129:losCasos[key].pg129,pg130:losCasos[key].pg130,pg131:losCasos[key].pg131,pg132:losCasos[key].pg132,pg133:losCasos[key].pg133,pg134:losCasos[key].pg134,pg135:losCasos[key].pg135,pg136:losCasos[key].pg136,pg137:losCasos[key].pg137,pg138:losCasos[key].pg138,pg139:losCasos[key].pg139,pg140:losCasos[key].pg140,pg141:losCasos[key].pg141,pg142:losCasos[key].pg142,pg143:losCasos[key].pg143,pg144:losCasos[key].pg144,pg145:losCasos[key].pg145,pg146:losCasos[key].pg146,pg147:losCasos[key].pg147,pg148:losCasos[key].pg148,pg149:losCasos[key].pg149,pg150:losCasos[key].pg150,pg151:losCasos[key].pg151,pg152:losCasos[key].pg152,pg153:losCasos[key].pg153,pg154:losCasos[key].pg154,pg155:losCasos[key].pg155,pg156:losCasos[key].pg156,pg157:losCasos[key].pg157,pg158:losCasos[key].pg158,pg159:losCasos[key].pg159,pg160:losCasos[key].pg160,pg161:losCasos[key].pg161,pg162:losCasos[key].pg162,pg163:losCasos[key].pg163,pg164:losCasos[key].pg164,pg165:losCasos[key].pg165,pg166:losCasos[key].pg166,pg167:losCasos[key].pg167,pg168:losCasos[key].pg168,pg169:losCasos[key].pg169,pg170:losCasos[key].pg170,pg171:losCasos[key].pg171,pg172:losCasos[key].pg172,pg173:losCasos[key].pg173,pg174:losCasos[key].pg174,pg175:losCasos[key].pg175,pg176:losCasos[key].pg176,pg177:losCasos[key].pg177,pg178:losCasos[key].pg178,pg179:losCasos[key].pg179,pg180:losCasos[key].pg180,pg181:losCasos[key].pg181,pg182:losCasos[key].pg182,pg183:losCasos[key].pg183,pg184:losCasos[key].pg184,pg185:losCasos[key].pg185,pg186:losCasos[key].pg186,pg187:losCasos[key].pg187,pg188:losCasos[key].pg188,pg189:losCasos[key].pg189,pg190:losCasos[key].pg190,pg191:losCasos[key].pg191,pg192:losCasos[key].pg192,pg193:losCasos[key].pg193,pg194:losCasos[key].pg194,pg195:losCasos[key].pg195,pg196:losCasos[key].pg196,pg197:losCasos[key].pg197,pg198:losCasos[key].pg198,pg199:losCasos[key].pg199,pg200:losCasos[key].pg200,pg201:losCasos[key].pg201,pg202:losCasos[key].pg102,pg203:losCasos[key].pg203,pg204:losCasos[key].pg204,pg205:losCasos[key].pg205,pg206:losCasos[key].pg206,pg207:losCasos[key].pg207});}// for
// console.log("SALI CON ", this.evaluacionesT);
this.limite=this.evaluacionesT.length;// cantidad de datos                
this.eval_copia=this.evaluacionesT;__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_eval=this.evaluacionesT;},getEvalEmoc:function getEvalEmoc(losCasos){// this.evaluacionesT = [];
// this.limite = 0;
/* Tipología = Myers */for(var key in losCasos){var _evaluacionesT$push3;this.evaluacionesT.push((_evaluacionesT$push3={llave:key,// 1
empresa:losCasos[key].empresa,nombre:losCasos[key].nombre,fecha:losCasos[key].fecha,empezo:losCasos[key].empezo,termino:losCasos[key].termino,steval:"EMOCIONES",pg001:losCasos[key].pg001,pg002:losCasos[key].pg002,pg003:losCasos[key].pg003,pg004:losCasos[key].pg004,pg005:losCasos[key].pg005,pg006:losCasos[key].pg006,pg007:losCasos[key].pg007,pg008:losCasos[key].pg008,pg009:losCasos[key].pg009,pg010:losCasos[key].pg010,pg011:losCasos[key].pg011,pg012:losCasos[key].pg012,pg013:losCasos[key].pg013,pg014:losCasos[key].pg013},_defineProperty(_evaluacionesT$push3,'pg014',losCasos[key].pg014),_defineProperty(_evaluacionesT$push3,'pg015',losCasos[key].pg015),_defineProperty(_evaluacionesT$push3,'pg016',losCasos[key].pg016),_defineProperty(_evaluacionesT$push3,'pg017',losCasos[key].pg017),_defineProperty(_evaluacionesT$push3,'pg018',losCasos[key].pg018),_defineProperty(_evaluacionesT$push3,'pg019',losCasos[key].pg019),_defineProperty(_evaluacionesT$push3,'pg020',losCasos[key].pg020),_defineProperty(_evaluacionesT$push3,'pg021',losCasos[key].pg021),_defineProperty(_evaluacionesT$push3,'pg022',losCasos[key].pg022),_defineProperty(_evaluacionesT$push3,'pg023',losCasos[key].pg023),_defineProperty(_evaluacionesT$push3,'pg024',losCasos[key].pg024),_defineProperty(_evaluacionesT$push3,'pg025',losCasos[key].pg025),_defineProperty(_evaluacionesT$push3,'pg026',losCasos[key].pg026),_defineProperty(_evaluacionesT$push3,'pg027',losCasos[key].pg027),_defineProperty(_evaluacionesT$push3,'pg028',losCasos[key].pg028),_defineProperty(_evaluacionesT$push3,'pg029',losCasos[key].pg029),_defineProperty(_evaluacionesT$push3,'pg030',losCasos[key].pg030),_defineProperty(_evaluacionesT$push3,'pg031',losCasos[key].pg031),_defineProperty(_evaluacionesT$push3,'pg032',losCasos[key].pg032),_defineProperty(_evaluacionesT$push3,'pg033',losCasos[key].pg033),_defineProperty(_evaluacionesT$push3,'pg034',losCasos[key].pg034),_defineProperty(_evaluacionesT$push3,'pg035',losCasos[key].pg035),_defineProperty(_evaluacionesT$push3,'pg036',losCasos[key].pg036),_defineProperty(_evaluacionesT$push3,'pg037',losCasos[key].pg037),_defineProperty(_evaluacionesT$push3,'pg038',losCasos[key].pg038),_defineProperty(_evaluacionesT$push3,'pg039',losCasos[key].pg039),_defineProperty(_evaluacionesT$push3,'pg040',losCasos[key].pg040),_defineProperty(_evaluacionesT$push3,'pg041',losCasos[key].pg041),_defineProperty(_evaluacionesT$push3,'pg042',losCasos[key].pg042),_defineProperty(_evaluacionesT$push3,'pg043',losCasos[key].pg043),_defineProperty(_evaluacionesT$push3,'pg044',losCasos[key].pg044),_defineProperty(_evaluacionesT$push3,'pg045',losCasos[key].pg045),_evaluacionesT$push3));}// for
this.limite=this.evaluacionesT.length;// cantidad de datos                
this.eval_copia=this.evaluacionesT;__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_eval=this.evaluacionesT;},getEvalApvtas2:function getEvalApvtas2(losCasos){// this.evaluacionesT = [];
// this.limite = 0;
/* Tipología = Myers */for(var key in losCasos){var _evaluacionesT$push4;this.evaluacionesT.push((_evaluacionesT$push4={llave:key,// 1
empresa:losCasos[key].empresa,nombre:losCasos[key].nombre,fecha:losCasos[key].fecha,empezo:losCasos[key].empezo,termino:losCasos[key].termino,steval:"ORIENTACION",pg001:losCasos[key].pg001,pg002:losCasos[key].pg002,pg003:losCasos[key].pg003,pg004:losCasos[key].pg004,pg005:losCasos[key].pg005,pg006:losCasos[key].pg006,pg007:losCasos[key].pg007,pg008:losCasos[key].pg008,pg009:losCasos[key].pg009,pg010:losCasos[key].pg010,pg011:losCasos[key].pg011,pg012:losCasos[key].pg012,pg013:losCasos[key].pg013,pg014:losCasos[key].pg013},_defineProperty(_evaluacionesT$push4,'pg014',losCasos[key].pg014),_defineProperty(_evaluacionesT$push4,'pg015',losCasos[key].pg015),_defineProperty(_evaluacionesT$push4,'pg016',losCasos[key].pg016),_defineProperty(_evaluacionesT$push4,'pg017',losCasos[key].pg017),_defineProperty(_evaluacionesT$push4,'pg018',losCasos[key].pg018),_defineProperty(_evaluacionesT$push4,'pg019',losCasos[key].pg019),_defineProperty(_evaluacionesT$push4,'pg020',losCasos[key].pg020),_defineProperty(_evaluacionesT$push4,'pg021',losCasos[key].pg021),_defineProperty(_evaluacionesT$push4,'pg022',losCasos[key].pg022),_defineProperty(_evaluacionesT$push4,'pg023',losCasos[key].pg023),_defineProperty(_evaluacionesT$push4,'pg024',losCasos[key].pg024),_defineProperty(_evaluacionesT$push4,'pg025',losCasos[key].pg025),_defineProperty(_evaluacionesT$push4,'pg026',losCasos[key].pg026),_defineProperty(_evaluacionesT$push4,'pg027',losCasos[key].pg027),_defineProperty(_evaluacionesT$push4,'pg028',losCasos[key].pg028),_defineProperty(_evaluacionesT$push4,'pg029',losCasos[key].pg029),_defineProperty(_evaluacionesT$push4,'pg030',losCasos[key].pg030),_defineProperty(_evaluacionesT$push4,'pg031',losCasos[key].pg031),_defineProperty(_evaluacionesT$push4,'pg032',losCasos[key].pg032),_defineProperty(_evaluacionesT$push4,'pg033',losCasos[key].pg033),_defineProperty(_evaluacionesT$push4,'pg034',losCasos[key].pg034),_defineProperty(_evaluacionesT$push4,'pg035',losCasos[key].pg035),_defineProperty(_evaluacionesT$push4,'pg036',losCasos[key].pg036),_defineProperty(_evaluacionesT$push4,'pg037',losCasos[key].pg037),_defineProperty(_evaluacionesT$push4,'pg038',losCasos[key].pg038),_defineProperty(_evaluacionesT$push4,'pg039',losCasos[key].pg039),_defineProperty(_evaluacionesT$push4,'pg040',losCasos[key].pg040),_defineProperty(_evaluacionesT$push4,'pg041',losCasos[key].pg041),_defineProperty(_evaluacionesT$push4,'pg042',losCasos[key].pg042),_defineProperty(_evaluacionesT$push4,'pg043',losCasos[key].pg043),_defineProperty(_evaluacionesT$push4,'pg044',losCasos[key].pg044),_defineProperty(_evaluacionesT$push4,'pg045',losCasos[key].pg045),_defineProperty(_evaluacionesT$push4,'pg046',losCasos[key].pg046),_defineProperty(_evaluacionesT$push4,'pg047',losCasos[key].pg047),_defineProperty(_evaluacionesT$push4,'pg048',losCasos[key].pg048),_defineProperty(_evaluacionesT$push4,'pg049',losCasos[key].pg049),_defineProperty(_evaluacionesT$push4,'pg050',losCasos[key].pg050),_defineProperty(_evaluacionesT$push4,'pg051',losCasos[key].pg051),_defineProperty(_evaluacionesT$push4,'pg052',losCasos[key].pg052),_defineProperty(_evaluacionesT$push4,'pg053',losCasos[key].pg053),_defineProperty(_evaluacionesT$push4,'pg054',losCasos[key].pg054),_defineProperty(_evaluacionesT$push4,'pg055',losCasos[key].pg055),_defineProperty(_evaluacionesT$push4,'pg056',losCasos[key].pg056),_defineProperty(_evaluacionesT$push4,'pg057',losCasos[key].pg057),_defineProperty(_evaluacionesT$push4,'pg058',losCasos[key].pg058),_defineProperty(_evaluacionesT$push4,'pg059',losCasos[key].pg059),_defineProperty(_evaluacionesT$push4,'pg060',losCasos[key].pg060),_defineProperty(_evaluacionesT$push4,'pg061',losCasos[key].pg061),_defineProperty(_evaluacionesT$push4,'pg062',losCasos[key].pg062),_defineProperty(_evaluacionesT$push4,'pg063',losCasos[key].pg063),_defineProperty(_evaluacionesT$push4,'pg064',losCasos[key].pg064),_defineProperty(_evaluacionesT$push4,'pg065',losCasos[key].pg065),_defineProperty(_evaluacionesT$push4,'pg066',losCasos[key].pg066),_defineProperty(_evaluacionesT$push4,'pg067',losCasos[key].pg067),_defineProperty(_evaluacionesT$push4,'pg068',losCasos[key].pg068),_defineProperty(_evaluacionesT$push4,'pg069',losCasos[key].pg069),_defineProperty(_evaluacionesT$push4,'pg070',losCasos[key].pg070),_defineProperty(_evaluacionesT$push4,'pg071',losCasos[key].pg071),_defineProperty(_evaluacionesT$push4,'pg072',losCasos[key].pg072),_defineProperty(_evaluacionesT$push4,'pg073',losCasos[key].pg073),_defineProperty(_evaluacionesT$push4,'pg074',losCasos[key].pg074),_defineProperty(_evaluacionesT$push4,'pg075',losCasos[key].pg075),_defineProperty(_evaluacionesT$push4,'pg076',losCasos[key].pg076),_defineProperty(_evaluacionesT$push4,'pg077',losCasos[key].pg077),_defineProperty(_evaluacionesT$push4,'pg078',losCasos[key].pg078),_defineProperty(_evaluacionesT$push4,'pg079',losCasos[key].pg079),_defineProperty(_evaluacionesT$push4,'pg080',losCasos[key].pg080),_defineProperty(_evaluacionesT$push4,'pg081',losCasos[key].pg081),_defineProperty(_evaluacionesT$push4,'pg082',losCasos[key].pg082),_defineProperty(_evaluacionesT$push4,'pg083',losCasos[key].pg083),_defineProperty(_evaluacionesT$push4,'pg084',losCasos[key].pg084),_defineProperty(_evaluacionesT$push4,'pg085',losCasos[key].pg085),_defineProperty(_evaluacionesT$push4,'pg086',losCasos[key].pg086),_defineProperty(_evaluacionesT$push4,'pg087',losCasos[key].pg087),_evaluacionesT$push4));}// for
this.limite=this.evaluacionesT.length;// cantidad de datos                
this.eval_copia=this.evaluacionesT;__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_eval=this.evaluacionesT;},getEvalAEDP:function getEvalAEDP(losCasos){// this.evaluacionesT = [];
// this.limite = 0;
/* Tipología = Myers */for(var key in losCasos){var _evaluacionesT$push5;this.evaluacionesT.push((_evaluacionesT$push5={llave:key,// 1
empresa:losCasos[key].empresa,nombre:losCasos[key].nombre,fecha:losCasos[key].fecha,empezo:losCasos[key].empezo,termino:losCasos[key].termino,steval:"AEDP",pg001:losCasos[key].pg001,pg002:losCasos[key].pg002,pg003:losCasos[key].pg003,pg004:losCasos[key].pg004,pg005:losCasos[key].pg005,pg006:losCasos[key].pg006,pg007:losCasos[key].pg007,pg008:losCasos[key].pg008,pg009:losCasos[key].pg009,pg010:losCasos[key].pg010,pg011:losCasos[key].pg011,pg012:losCasos[key].pg012,pg013:losCasos[key].pg013,pg014:losCasos[key].pg013},_defineProperty(_evaluacionesT$push5,'pg014',losCasos[key].pg014),_defineProperty(_evaluacionesT$push5,'pg015',losCasos[key].pg015),_defineProperty(_evaluacionesT$push5,'pg016',losCasos[key].pg016),_defineProperty(_evaluacionesT$push5,'pg017',losCasos[key].pg017),_defineProperty(_evaluacionesT$push5,'pg018',losCasos[key].pg018),_defineProperty(_evaluacionesT$push5,'pg019',losCasos[key].pg019),_defineProperty(_evaluacionesT$push5,'pg020',losCasos[key].pg020),_defineProperty(_evaluacionesT$push5,'pg021',losCasos[key].pg021),_defineProperty(_evaluacionesT$push5,'pg022',losCasos[key].pg022),_defineProperty(_evaluacionesT$push5,'pg023',losCasos[key].pg023),_defineProperty(_evaluacionesT$push5,'pg024',losCasos[key].pg024),_defineProperty(_evaluacionesT$push5,'pg025',losCasos[key].pg025),_defineProperty(_evaluacionesT$push5,'pg026',losCasos[key].pg026),_defineProperty(_evaluacionesT$push5,'pg027',losCasos[key].pg027),_defineProperty(_evaluacionesT$push5,'pg028',losCasos[key].pg028),_defineProperty(_evaluacionesT$push5,'pg029',losCasos[key].pg029),_defineProperty(_evaluacionesT$push5,'pg030',losCasos[key].pg030),_defineProperty(_evaluacionesT$push5,'pg031',losCasos[key].pg031),_defineProperty(_evaluacionesT$push5,'pg032',losCasos[key].pg032),_defineProperty(_evaluacionesT$push5,'pg033',losCasos[key].pg033),_defineProperty(_evaluacionesT$push5,'pg034',losCasos[key].pg034),_defineProperty(_evaluacionesT$push5,'pg035',losCasos[key].pg035),_defineProperty(_evaluacionesT$push5,'pg036',losCasos[key].pg036),_defineProperty(_evaluacionesT$push5,'pg037',losCasos[key].pg037),_defineProperty(_evaluacionesT$push5,'pg038',losCasos[key].pg038),_defineProperty(_evaluacionesT$push5,'pg039',losCasos[key].pg039),_defineProperty(_evaluacionesT$push5,'pg040',losCasos[key].pg040),_defineProperty(_evaluacionesT$push5,'pg041',losCasos[key].pg041),_defineProperty(_evaluacionesT$push5,'pg042',losCasos[key].pg042),_defineProperty(_evaluacionesT$push5,'pg043',losCasos[key].pg043),_defineProperty(_evaluacionesT$push5,'pg044',losCasos[key].pg044),_defineProperty(_evaluacionesT$push5,'pg045',losCasos[key].pg045),_defineProperty(_evaluacionesT$push5,'pg046',losCasos[key].pg046),_defineProperty(_evaluacionesT$push5,'pg047',losCasos[key].pg047),_defineProperty(_evaluacionesT$push5,'pg048',losCasos[key].pg048),_defineProperty(_evaluacionesT$push5,'pg049',losCasos[key].pg049),_defineProperty(_evaluacionesT$push5,'pg050',losCasos[key].pg050),_defineProperty(_evaluacionesT$push5,'pg051',losCasos[key].pg051),_defineProperty(_evaluacionesT$push5,'pg052',losCasos[key].pg052),_defineProperty(_evaluacionesT$push5,'pg053',losCasos[key].pg053),_defineProperty(_evaluacionesT$push5,'pg054',losCasos[key].pg054),_defineProperty(_evaluacionesT$push5,'pg055',losCasos[key].pg055),_defineProperty(_evaluacionesT$push5,'pg056',losCasos[key].pg056),_defineProperty(_evaluacionesT$push5,'pg057',losCasos[key].pg057),_defineProperty(_evaluacionesT$push5,'pg058',losCasos[key].pg058),_defineProperty(_evaluacionesT$push5,'pg059',losCasos[key].pg059),_defineProperty(_evaluacionesT$push5,'pg060',losCasos[key].pg060),_defineProperty(_evaluacionesT$push5,'pg061',losCasos[key].pg061),_defineProperty(_evaluacionesT$push5,'pg062',losCasos[key].pg062),_defineProperty(_evaluacionesT$push5,'pg063',losCasos[key].pg063),_defineProperty(_evaluacionesT$push5,'pg064',losCasos[key].pg064),_defineProperty(_evaluacionesT$push5,'pg065',losCasos[key].pg065),_defineProperty(_evaluacionesT$push5,'pg066',losCasos[key].pg066),_defineProperty(_evaluacionesT$push5,'pg067',losCasos[key].pg067),_defineProperty(_evaluacionesT$push5,'pg068',losCasos[key].pg068),_defineProperty(_evaluacionesT$push5,'pg069',losCasos[key].pg069),_defineProperty(_evaluacionesT$push5,'pg070',losCasos[key].pg070),_defineProperty(_evaluacionesT$push5,'pg071',losCasos[key].pg071),_defineProperty(_evaluacionesT$push5,'pg072',losCasos[key].pg072),_defineProperty(_evaluacionesT$push5,'pg073',losCasos[key].pg073),_defineProperty(_evaluacionesT$push5,'pg074',losCasos[key].pg074),_defineProperty(_evaluacionesT$push5,'pg074b',losCasos[key].pg074b),_defineProperty(_evaluacionesT$push5,'pg074c',losCasos[key].pg074c),_defineProperty(_evaluacionesT$push5,'pg074d',losCasos[key].pg074d),_defineProperty(_evaluacionesT$push5,'pg074e',losCasos[key].pg074e),_defineProperty(_evaluacionesT$push5,'pg074f',losCasos[key].pg074f),_defineProperty(_evaluacionesT$push5,'pg074g',losCasos[key].pg074g),_defineProperty(_evaluacionesT$push5,'pg074h',losCasos[key].pg074h),_defineProperty(_evaluacionesT$push5,'pg074i',losCasos[key].pg074i),_defineProperty(_evaluacionesT$push5,'pg075',losCasos[key].pg075),_defineProperty(_evaluacionesT$push5,'pg076',losCasos[key].pg076),_defineProperty(_evaluacionesT$push5,'pg077',losCasos[key].pg077),_defineProperty(_evaluacionesT$push5,'pg078',losCasos[key].pg078),_defineProperty(_evaluacionesT$push5,'pg079',losCasos[key].pg079),_defineProperty(_evaluacionesT$push5,'pg080',losCasos[key].pg080),_defineProperty(_evaluacionesT$push5,'pg081',losCasos[key].pg081),_defineProperty(_evaluacionesT$push5,'pg082',losCasos[key].pg082),_defineProperty(_evaluacionesT$push5,'pg083',losCasos[key].pg083),_defineProperty(_evaluacionesT$push5,'pg084',losCasos[key].pg084),_defineProperty(_evaluacionesT$push5,'pg085',losCasos[key].pg085),_defineProperty(_evaluacionesT$push5,'pg086',losCasos[key].pg086),_defineProperty(_evaluacionesT$push5,'pg087',losCasos[key].pg087),_defineProperty(_evaluacionesT$push5,'pg088',losCasos[key].pg088),_defineProperty(_evaluacionesT$push5,'pg089',losCasos[key].pg089),_defineProperty(_evaluacionesT$push5,'pg090',losCasos[key].pg090),_defineProperty(_evaluacionesT$push5,'pg091',losCasos[key].pg091),_defineProperty(_evaluacionesT$push5,'pg092',losCasos[key].pg092),_defineProperty(_evaluacionesT$push5,'pg093',losCasos[key].pg093),_defineProperty(_evaluacionesT$push5,'pg094',losCasos[key].pg094),_defineProperty(_evaluacionesT$push5,'pg095',losCasos[key].pg095),_defineProperty(_evaluacionesT$push5,'pg096',losCasos[key].pg096),_defineProperty(_evaluacionesT$push5,'pg097',losCasos[key].pg097),_defineProperty(_evaluacionesT$push5,'pg098',losCasos[key].pg098),_defineProperty(_evaluacionesT$push5,'pg099',losCasos[key].pg099),_defineProperty(_evaluacionesT$push5,'pg100',losCasos[key].pg100),_defineProperty(_evaluacionesT$push5,'pg101',losCasos[key].pg101),_defineProperty(_evaluacionesT$push5,'pg102',losCasos[key].pg102),_defineProperty(_evaluacionesT$push5,'pg103',losCasos[key].pg103),_defineProperty(_evaluacionesT$push5,'pg104',losCasos[key].pg104),_defineProperty(_evaluacionesT$push5,'pg105',losCasos[key].pg105),_defineProperty(_evaluacionesT$push5,'pg106',losCasos[key].pg106),_defineProperty(_evaluacionesT$push5,'pg107',losCasos[key].pg107),_defineProperty(_evaluacionesT$push5,'pg108',losCasos[key].pg108),_defineProperty(_evaluacionesT$push5,'pg109',losCasos[key].pg109),_defineProperty(_evaluacionesT$push5,'pg110',losCasos[key].pg110),_defineProperty(_evaluacionesT$push5,'pg111',losCasos[key].pg111),_defineProperty(_evaluacionesT$push5,'pg112',losCasos[key].pg112),_defineProperty(_evaluacionesT$push5,'pg113',losCasos[key].pg113),_defineProperty(_evaluacionesT$push5,'pg114',losCasos[key].pg114),_defineProperty(_evaluacionesT$push5,'pg115',losCasos[key].pg115),_defineProperty(_evaluacionesT$push5,'pg116',losCasos[key].pg116),_defineProperty(_evaluacionesT$push5,'pg117',losCasos[key].pg117),_defineProperty(_evaluacionesT$push5,'pg118',losCasos[key].pg118),_defineProperty(_evaluacionesT$push5,'pg119',losCasos[key].pg119),_defineProperty(_evaluacionesT$push5,'pg120',losCasos[key].pg120),_defineProperty(_evaluacionesT$push5,'pg121',losCasos[key].pg121),_defineProperty(_evaluacionesT$push5,'pg122',losCasos[key].pg122),_defineProperty(_evaluacionesT$push5,'pg123',losCasos[key].pg123),_defineProperty(_evaluacionesT$push5,'pg124',losCasos[key].pg124),_defineProperty(_evaluacionesT$push5,'pg125',losCasos[key].pg125),_defineProperty(_evaluacionesT$push5,'pg126',losCasos[key].pg126),_defineProperty(_evaluacionesT$push5,'pg127',losCasos[key].pg127),_defineProperty(_evaluacionesT$push5,'pg128',losCasos[key].pg128),_defineProperty(_evaluacionesT$push5,'pg129',losCasos[key].pg129),_defineProperty(_evaluacionesT$push5,'pg130',losCasos[key].pg130),_defineProperty(_evaluacionesT$push5,'pg131',losCasos[key].pg131),_defineProperty(_evaluacionesT$push5,'pg132',losCasos[key].pg132),_defineProperty(_evaluacionesT$push5,'pg133',losCasos[key].pg133),_defineProperty(_evaluacionesT$push5,'pg134',losCasos[key].pg134),_defineProperty(_evaluacionesT$push5,'pg135',losCasos[key].pg135),_defineProperty(_evaluacionesT$push5,'pg136',losCasos[key].pg136),_defineProperty(_evaluacionesT$push5,'pg137',losCasos[key].pg137),_defineProperty(_evaluacionesT$push5,'pg138',losCasos[key].pg138),_defineProperty(_evaluacionesT$push5,'pg139',losCasos[key].pg139),_defineProperty(_evaluacionesT$push5,'pg140',losCasos[key].pg140),_defineProperty(_evaluacionesT$push5,'pg141',losCasos[key].pg141),_defineProperty(_evaluacionesT$push5,'pg142',losCasos[key].pg142),_defineProperty(_evaluacionesT$push5,'pg143',losCasos[key].pg143),_defineProperty(_evaluacionesT$push5,'pg144',losCasos[key].pg144),_defineProperty(_evaluacionesT$push5,'pg145',losCasos[key].pg145),_defineProperty(_evaluacionesT$push5,'pg146',losCasos[key].pg146),_defineProperty(_evaluacionesT$push5,'pg147',losCasos[key].pg147),_defineProperty(_evaluacionesT$push5,'pg148',losCasos[key].pg148),_defineProperty(_evaluacionesT$push5,'pg149',losCasos[key].pg149),_defineProperty(_evaluacionesT$push5,'pg150',losCasos[key].pg150),_defineProperty(_evaluacionesT$push5,'pg151',losCasos[key].pg151),_defineProperty(_evaluacionesT$push5,'pg152',losCasos[key].pg152),_defineProperty(_evaluacionesT$push5,'pg153',losCasos[key].pg153),_defineProperty(_evaluacionesT$push5,'pg154',losCasos[key].pg154),_defineProperty(_evaluacionesT$push5,'pg155',losCasos[key].pg155),_defineProperty(_evaluacionesT$push5,'pg156',losCasos[key].pg156),_defineProperty(_evaluacionesT$push5,'pg157',losCasos[key].pg157),_defineProperty(_evaluacionesT$push5,'pg158',losCasos[key].pg158),_defineProperty(_evaluacionesT$push5,'pg159',losCasos[key].pg159),_defineProperty(_evaluacionesT$push5,'pg160',losCasos[key].pg160),_defineProperty(_evaluacionesT$push5,'pg161',losCasos[key].pg161),_defineProperty(_evaluacionesT$push5,'pg162',losCasos[key].pg162),_defineProperty(_evaluacionesT$push5,'pg163',losCasos[key].pg163),_defineProperty(_evaluacionesT$push5,'pg164',losCasos[key].pg164),_defineProperty(_evaluacionesT$push5,'pg165',losCasos[key].pg165),_defineProperty(_evaluacionesT$push5,'pg166',losCasos[key].pg166),_defineProperty(_evaluacionesT$push5,'pg167',losCasos[key].pg167),_defineProperty(_evaluacionesT$push5,'pg168',losCasos[key].pg168),_defineProperty(_evaluacionesT$push5,'pg169',losCasos[key].pg169),_defineProperty(_evaluacionesT$push5,'pg170',losCasos[key].pg170),_defineProperty(_evaluacionesT$push5,'pg171',losCasos[key].pg171),_defineProperty(_evaluacionesT$push5,'pg172',losCasos[key].pg172),_defineProperty(_evaluacionesT$push5,'pg173',losCasos[key].pg173),_defineProperty(_evaluacionesT$push5,'pg174',losCasos[key].pg174),_defineProperty(_evaluacionesT$push5,'pg175',losCasos[key].pg175),_defineProperty(_evaluacionesT$push5,'pg176',losCasos[key].pg176),_defineProperty(_evaluacionesT$push5,'pg177',losCasos[key].pg177),_defineProperty(_evaluacionesT$push5,'pg178',losCasos[key].pg178),_defineProperty(_evaluacionesT$push5,'pg179',losCasos[key].pg179),_defineProperty(_evaluacionesT$push5,'pg180',losCasos[key].pg180),_defineProperty(_evaluacionesT$push5,'pg181',losCasos[key].pg181),_defineProperty(_evaluacionesT$push5,'pg182',losCasos[key].pg182),_defineProperty(_evaluacionesT$push5,'pg183',losCasos[key].pg183),_defineProperty(_evaluacionesT$push5,'pg184',losCasos[key].pg184),_defineProperty(_evaluacionesT$push5,'pg185',losCasos[key].pg185),_defineProperty(_evaluacionesT$push5,'pg186',losCasos[key].pg186),_defineProperty(_evaluacionesT$push5,'pg187',losCasos[key].pg187),_defineProperty(_evaluacionesT$push5,'pg188',losCasos[key].pg188),_defineProperty(_evaluacionesT$push5,'pg189',losCasos[key].pg189),_defineProperty(_evaluacionesT$push5,'pg190',losCasos[key].pg190),_defineProperty(_evaluacionesT$push5,'pg191',losCasos[key].pg191),_defineProperty(_evaluacionesT$push5,'pg192',losCasos[key].pg192),_defineProperty(_evaluacionesT$push5,'pg193',losCasos[key].pg193),_defineProperty(_evaluacionesT$push5,'pg194',losCasos[key].pg194),_defineProperty(_evaluacionesT$push5,'pg195',losCasos[key].pg195),_defineProperty(_evaluacionesT$push5,'pg196',losCasos[key].pg196),_defineProperty(_evaluacionesT$push5,'pg197',losCasos[key].pg197),_defineProperty(_evaluacionesT$push5,'pg198',losCasos[key].pg198),_defineProperty(_evaluacionesT$push5,'pg199',losCasos[key].pg199),_defineProperty(_evaluacionesT$push5,'pg200',losCasos[key].pg200),_defineProperty(_evaluacionesT$push5,'pg201',losCasos[key].pg201),_defineProperty(_evaluacionesT$push5,'pg202',losCasos[key].pg202),_defineProperty(_evaluacionesT$push5,'pg203',losCasos[key].pg203),_defineProperty(_evaluacionesT$push5,'pg204',losCasos[key].pg204),_defineProperty(_evaluacionesT$push5,'pg205',losCasos[key].pg205),_defineProperty(_evaluacionesT$push5,'pg206',losCasos[key].pg206),_defineProperty(_evaluacionesT$push5,'pg207',losCasos[key].pg207),_defineProperty(_evaluacionesT$push5,'pg208',losCasos[key].pg208),_defineProperty(_evaluacionesT$push5,'pg209',losCasos[key].pg209),_defineProperty(_evaluacionesT$push5,'pg210',losCasos[key].pg210),_defineProperty(_evaluacionesT$push5,'pg211',losCasos[key].pg211),_defineProperty(_evaluacionesT$push5,'pg212',losCasos[key].pg212),_defineProperty(_evaluacionesT$push5,'pg213',losCasos[key].pg213),_defineProperty(_evaluacionesT$push5,'pg214',losCasos[key].pg214),_defineProperty(_evaluacionesT$push5,'pg215',losCasos[key].pg215),_defineProperty(_evaluacionesT$push5,'pg216',losCasos[key].pg216),_defineProperty(_evaluacionesT$push5,'pg217',losCasos[key].pg217),_defineProperty(_evaluacionesT$push5,'pg218',losCasos[key].pg218),_defineProperty(_evaluacionesT$push5,'pg219',losCasos[key].pg219),_defineProperty(_evaluacionesT$push5,'pg220',losCasos[key].pg220),_defineProperty(_evaluacionesT$push5,'pg221',losCasos[key].pg221),_defineProperty(_evaluacionesT$push5,'pg222',losCasos[key].pg222),_defineProperty(_evaluacionesT$push5,'pg223',losCasos[key].pg223),_defineProperty(_evaluacionesT$push5,'pg224',losCasos[key].pg224),_defineProperty(_evaluacionesT$push5,'pg225',losCasos[key].pg225),_defineProperty(_evaluacionesT$push5,'pg226',losCasos[key].pg226),_defineProperty(_evaluacionesT$push5,'pg227',losCasos[key].pg227),_defineProperty(_evaluacionesT$push5,'pg228',losCasos[key].pg228),_defineProperty(_evaluacionesT$push5,'pg229',losCasos[key].pg229),_defineProperty(_evaluacionesT$push5,'pg230',losCasos[key].pg230),_defineProperty(_evaluacionesT$push5,'pg231',losCasos[key].pg231),_defineProperty(_evaluacionesT$push5,'pg232',losCasos[key].pg232),_defineProperty(_evaluacionesT$push5,'pg233',losCasos[key].pg233),_defineProperty(_evaluacionesT$push5,'pg234',losCasos[key].pg234),_defineProperty(_evaluacionesT$push5,'pg235',losCasos[key].pg235),_defineProperty(_evaluacionesT$push5,'pg236',losCasos[key].pg236),_defineProperty(_evaluacionesT$push5,'pg237',losCasos[key].pg237),_defineProperty(_evaluacionesT$push5,'pg238',losCasos[key].pg238),_defineProperty(_evaluacionesT$push5,'pg239',losCasos[key].pg239),_defineProperty(_evaluacionesT$push5,'pg240',losCasos[key].pg240),_defineProperty(_evaluacionesT$push5,'pg241',losCasos[key].pg241),_defineProperty(_evaluacionesT$push5,'pg242',losCasos[key].pg242),_defineProperty(_evaluacionesT$push5,'pg243',losCasos[key].pg243),_defineProperty(_evaluacionesT$push5,'pg244',losCasos[key].pg244),_defineProperty(_evaluacionesT$push5,'pg245',losCasos[key].pg245),_defineProperty(_evaluacionesT$push5,'pg246',losCasos[key].pg246),_defineProperty(_evaluacionesT$push5,'pg247',losCasos[key].pg247),_defineProperty(_evaluacionesT$push5,'pg248',losCasos[key].pg248),_defineProperty(_evaluacionesT$push5,'pg249',losCasos[key].pg249),_defineProperty(_evaluacionesT$push5,'pg250',losCasos[key].pg250),_defineProperty(_evaluacionesT$push5,'pg251',losCasos[key].pg251),_defineProperty(_evaluacionesT$push5,'pg252',losCasos[key].pg252),_defineProperty(_evaluacionesT$push5,'pg253',losCasos[key].pg253),_defineProperty(_evaluacionesT$push5,'pg254',losCasos[key].pg254),_evaluacionesT$push5));}// for
this.limite=this.evaluacionesT.length;// cantidad de datos                
this.eval_copia=this.evaluacionesT;__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_eval=this.evaluacionesT;},bdRead:function bdRead(){var _this2=this;var dummy=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_dbEvalTipolo.on('value',function(snapshot){return _this2.getEvalTipolo(snapshot.val());});var dummy=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_dbEvalFactor.on('value',function(snapshot){return _this2.getEvalFactor(snapshot.val());});var dummy=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_dbEvalEstabi.on('value',function(snapshot){return _this2.getEvalEstabi(snapshot.val());});var dummy=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_dbEvalSociab.on('value',function(snapshot){return _this2.getEvalSociab(snapshot.val());});var dummy=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_dbEvalPerfil.on('value',function(snapshot){return _this2.getEvalPerfil(snapshot.val());});var dummy=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_dbEvalSuperv.on('value',function(snapshot){return _this2.getEvalSuperv(snapshot.val());});var dummy=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_dbEvalApvtas.on('value',function(snapshot){return _this2.getEvalApvtas(snapshot.val());});var dummy=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_dbEvalSolemp.on('value',function(snapshot){return _this2.getEvalSolemp(snapshot.val());});var dummy=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_dbEvalEmoc.on('value',function(snapshot){return _this2.getEvalEmoc(snapshot.val());});var dummy=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_dbEvalVtas2.on('value',function(snapshot){return _this2.getEvalApvtas2(snapshot.val());});var dummy=__WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */].state.st_dbEvalAEDP.on('value',function(snapshot){return _this2.getEvalAEDP(snapshot.val());});}}// methods    
// export
});

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @class MapElementMixin
 *
 * Extends components to include the following fields:
 *
 * @property $map        The Google map (valid only after the promise returns)
 *
 *
 * */
exports.default = {
  inject: {
    '$mapPromise': { default: 'abcdef' }
  },

  provide: function provide() {
    var _this = this;

    // Note: although this mixin is not "providing" anything,
    // components' expect the `$map` property to be present on the component.
    // In order for that to happen, this mixin must intercept the $mapPromise
    // .then(() =>) first before its component does so.
    //
    // Since a provide() on a mixin is executed before a provide() on the
    // component, putting this code in provide() ensures that the $map is
    // already set by the time the
    // component's provide() is called.
    this.$mapPromise.then(function (map) {
      _this.$map = map;
    });

    return {};
  }
};

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(388)));

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(393)));

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TwoWayBindingWrapper;
/**
 * When you have two-way bindings, but the actual bound value will not equal
 * the value you initially passed in, then to avoid an infinite loop you
 * need to increment a counter every time you pass in a value, decrement the
 * same counter every time the bound value changed, but only bubble up
 * the event when the counter is zero.
 *
Example:

Let's say DrawingRecognitionCanvas is a deep-learning backed canvas
that, when given the name of an object (e.g. 'dog'), draws a dog.
But whenever the drawing on it changes, it also sends back its interpretation
of the image by way of the @newObjectRecognized event.

<input
  type="text"
  placeholder="an object, e.g. Dog, Cat, Frog"
  v-model="identifiedObject" />
<DrawingRecognitionCanvas
  :object="identifiedObject"
  @newObjectRecognized="identifiedObject = $event"
  />

new TwoWayBindingWrapper((increment, decrement, shouldUpdate) => {
  this.$watch('identifiedObject', () => {
    // new object passed in
    increment()
  })
  this.$deepLearningBackend.on('drawingChanged', () => {
    recognizeObject(this.$deepLearningBackend)
      .then((object) => {
        decrement()
        if (shouldUpdate()) {
          this.$emit('newObjectRecognized', object.name)
        }
      })
  })
})
 */
function TwoWayBindingWrapper(fn) {
  var counter = 0;

  fn(function () {
    counter += 1;
  }, function () {
    counter = Math.max(0, counter - 1);
  }, function () {
    return counter === 0;
  });
}

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(398)));

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bindProps = __webpack_require__(29);

var _simulateArrowDown = __webpack_require__(226);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var props = {
  bounds: {
    type: Object
  },
  defaultPlace: {
    type: String,
    default: ''
  },
  componentRestrictions: {
    type: Object,
    default: null
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  placeholder: {
    required: false,
    type: String
  },
  className: {
    required: false,
    type: String
  },
  label: {
    required: false,
    type: String,
    default: null
  },
  selectFirstOnEnter: {
    require: false,
    type: Boolean,
    default: false
  }
};

exports.default = {
  mounted: function mounted() {
    var _this = this;

    var input = this.$refs.input;

    // Allow default place to be set
    input.value = this.defaultPlace;
    this.$watch('defaultPlace', function () {
      input.value = _this.defaultPlace;
    });

    this.$gmapApiPromiseLazy().then(function () {
      var options = (0, _bindProps.getPropsValues)(_this, props);
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      _this.autoCompleter = new google.maps.places.Autocomplete(_this.$refs.input, options);

      var placeholder = props.placeholder,
          place = props.place,
          defaultPlace = props.defaultPlace,
          className = props.className,
          label = props.label,
          selectFirstOnEnter = props.selectFirstOnEnter,
          rest = _objectWithoutProperties(props, ['placeholder', 'place', 'defaultPlace', 'className', 'label', 'selectFirstOnEnter']); // eslint-disable-line


      (0, _bindProps.bindProps)(_this, _this.autoCompleter, rest);

      _this.autoCompleter.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.autoCompleter.getPlace());
      });
    });
  },
  created: function created() {
    console.warn('The PlaceInput class is deprecated! Please consider using the Autocomplete input instead'); // eslint-disable-line no-console
  },

  props: props
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by amirnissim and can be seen here
// http://stackoverflow.com/a/11703018/2694653
// This has been ported to Vanilla.js by GuillaumeLeclerc
exports.default = function (input) {
  var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

  function addEventListenerWrapper(type, listener) {
    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
    // and then trigger the original listener.
    if (type === 'keydown') {
      var origListener = listener;
      listener = function (event) {
        var suggestionSelected = document.getElementsByClassName('pac-item-selected').length > 0;
        if (event.which === 13 && !suggestionSelected) {
          var simulatedEvent = document.createEvent('Event');
          simulatedEvent.keyCode = 40;
          simulatedEvent.which = 40;
          origListener.apply(input, [simulatedEvent]);
        }
        origListener.apply(input, [event]);
      };
    }
    _addEventListener.apply(input, [type, listener]);
  }

  input.addEventListener = addEventListenerWrapper;
  input.attachEvent = addEventListenerWrapper;
};

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(403)));

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(361)
var ieee754 = __webpack_require__(362)
var isArray = __webpack_require__(363)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_js__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css_dist_css_materialize_min_css__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css_dist_css_materialize_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_materialize_css_dist_css_materialize_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_router__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__);
/** main.js
  
    Prepara el uso de rutas, firebase, vuex, así como el instanciamiento de App.vue
    Desarrollado por JC Yocop
 ======================================================================================================== */

/** Importaciones  */



 // Definido en /scr/store.js como una constante
 // {{routes}} importa lo que está en 







/** Manejador de rutas */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_7_vue_router__["a" /* default */]({
    // mode: 'history', /** El hashtag desaparece */
    routes: __WEBPACK_IMPORTED_MODULE_3__routes_js__["a" /* routes */]
});
router.beforeEach(function (to, from, next) {

    /* 
       * Al utilizar "store.state.auth" variable, cuando está en true
       * se obtiene bien el TRACE, cuando cambia a false, pierde la ruta
       * del "from" dejando la última ruta del "f rom".     */
    var currentUser = __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.auth().currentUser;
    var requiresAuth = to.matched.some(function (record) {
        return record.meta.requiresAuth;
    });
    // ! let currentUser = true;
    // ! let requiresAuth= true;

    if (requiresAuth && !currentUser) {

        next('login');
    } else {
        if (!requiresAuth && currentUser) {

            next('home');
        } else {

            next(); // falso y falso, debiera irse a home
        }
    }
});


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__, {
    load: {
        key: 'YOUR_API_TOKEN',
        libraries: 'places' // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    }
});

/*
  ? review: Para utilizar los íconos 
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-icon', {
    template: '\n              <span aria-hidden="true"> <i class="material-icons">{{img}}</i></span>\n              ',
    props: ['img']
});

/** 1. router hacer referencia a la constante definida arriba */
var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({

    el: '#app',
    router: router,
    store: __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */], // incluye vuex ya que es usado en "next()"
    mounted: function mounted() {

        var elems = document.querySelectorAll('.collapsible');
        var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Collapsible.init(elems, {});

        var elems = document.querySelectorAll('.tooltipped');
        var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tooltip.init(elems, {});

        var elems = document.querySelectorAll('.modal');
        var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Modal.init(elems, { dismissible: false });

        var elem = document.querySelectorAll('.tabs');
        var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Tabs.init(elem, {});

        var elems = document.querySelectorAll('select');
        var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.FormSelect.init(elems, {});

        document.addEventListener('DOMContentLoaded', function () {
            var elems = document.querySelectorAll('.sidenav');
            var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Sidenav.init(elems, { show: true });
        });

        var elem = document.querySelectorAll('.dropdown-trigger');
        var instances = __WEBPACK_IMPORTED_MODULE_5_materialize_css___default.a.Dropdown.init(elem, {});
    },


    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
    }
});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(30)))

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_App_js__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd12ea8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(232);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_App_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd12ea8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ul',{staticClass:"dropdown-content",attrs:{"id":"dropdown1"}},[_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo),expression:"$store.state.st_logeado && $store.state.st_activo"}],attrs:{"to":"/chgpass","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Cambiar Clave","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("vpn_key")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado),expression:"$store.state.st_logeado"}],attrs:{"to":"/logout","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Salir","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("exit_to_app")])])])],1)]),_vm._v(" "),_c('ul',{staticClass:"dropdown-content",attrs:{"id":"dropdown2"}},[_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev01_tipolo),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev01_tipolo"}],attrs:{"to":"/tipologia","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Tipología de personalidad","data-position":"right"}},[_c('i',{staticClass:"material-icons"},[_vm._v("accessibility")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev02_perfil),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev02_perfil"}],attrs:{"to":"/perfil","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"perfil","data-position":"right"}},[_c('i',{staticClass:"material-icons"},[_vm._v("brightness_high")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev03_16pf),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev03_16pf"}],attrs:{"to":"/factores","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Factores de personalidad","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("art_track")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev04_npf),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev04_npf"}],attrs:{"to":"/estabilidad","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Estabilidad","data-position":"right"}},[_c('i',{staticClass:"material-icons"},[_vm._v("account_balance")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev05_cpf),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev05_cpf"}],attrs:{"to":"/sociabilidad","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Sociabilidad","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("group")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev06_moss),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev06_moss"}],attrs:{"to":"/supervision","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Supervision","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("style")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev07_tav),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev07_tav"}],attrs:{"to":"/aptitudvtas","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Aptitud Ventas","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("shopping_cart")])])])],1),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev08_solemp),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev08_solemp"}],attrs:{"to":"/solempleo","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Solicitud de empleo","data-position":"right"}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment_ind")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev09_emocio),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev09_emocio"}],attrs:{"to":"/emociones","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Emociones","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("directions_run")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev11_vtas),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev11_vtas"}],attrs:{"to":"/orientacion","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Orientación Ventas","data-position":"right"}},[_c('i',{staticClass:"material-icons"},[_vm._v("add_shopping_cart")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev10_auxili),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev10_auxili"}],attrs:{"to":"/auxiliar","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Auxiliar Cómputo","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("desktop_mac")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo && _vm.$store.state.st_roles.ev12_aedp),expression:"$store.state.st_logeado && $store.state.st_activo && $store.state.st_roles.ev12_aedp"}],attrs:{"to":"/aedp","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"A.E.D.P","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("airline_seat_flat_angled")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"navbar-fixed"},[_c('nav',[_c('div',{staticClass:"nav-wrapper blue lighten-1"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"right hide-on-med-and-down",attrs:{"id":"nav-mobile"}},[_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado),expression:"$store.state.st_logeado"}],attrs:{"to":"/","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Home","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("home")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$store.state.st_logeado),expression:"!$store.state.st_logeado"}],staticClass:"active",attrs:{"to":"/login","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Login","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("https")])])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.evalua),expression:"$store.state.st_logeado && $store.state.evalua"}]},[_vm._m(2)]),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_roles.ev_consultas),expression:"$store.state.st_logeado && $store.state.st_roles.ev_consultas"}],attrs:{"to":"/consultas","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Consultas","data-position":"bottom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("search")])])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado),expression:"$store.state.st_logeado"}]},[_c('a',{staticClass:"dropdown-trigger tooltipped",attrs:{"data-target":"dropdown1","data-tooltip":_vm.$store.state.st_nusuario,"data-position":"bottom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("person arrow_drop_down")])])])])])])]),_vm._v(" "),_c('ul',{staticClass:"sidenav",attrs:{"id":"mobile-demo"}},[_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado),expression:"$store.state.st_logeado"}],attrs:{"to":"/","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("home")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$store.state.st_logeado),expression:"!$store.state.st_logeado"}],staticClass:"active",attrs:{"to":"/login","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Acceso","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("https")])])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado),expression:"$store.state.st_logeado"}]},[_vm._m(3)]),_vm._v(" "),_c('ul',{staticClass:"dropdown-content",attrs:{"id":"dropdown4"}},[_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo),expression:"$store.state.st_logeado && $store.state.st_activo"}],attrs:{"to":"/tipologia","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"*Tipología de Personalidad","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("accessibility")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo),expression:"$store.state.st_logeado && $store.state.st_activo"}],attrs:{"to":"/factores","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Factores de Personalidad","data-position":"left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("art_track")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo),expression:"$store.state.st_logeado && $store.state.st_activo"}],attrs:{"to":"/estabilidad","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Estabilidad","data-position":"bottom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("account_balance")])])])],1)]),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$store.state.st_logeado),expression:"!$store.state.st_logeado"}],staticClass:"active",attrs:{"to":"/consultas","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Consultas","data-position":"bottom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("search")])])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado),expression:"$store.state.st_logeado"}]},[_c('a',{staticClass:"dropdown-trigger tooltipped",attrs:{"data-target":"dropdown3","data-tooltip":_vm.$store.state.st_nusuario,"data-position":"bottom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("person arrow_drop_down")])])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-content",attrs:{"id":"dropdown3"}},[_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado && _vm.$store.state.st_activo),expression:"$store.state.st_logeado && $store.state.st_activo"}],attrs:{"to":"/chgpass","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Cambiar Clave","data-position":"right"}},[_c('i',{staticClass:"material-icons"},[_vm._v("vpn_key")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_logeado),expression:"$store.state.st_logeado"}],attrs:{"to":"/logout","tag":"li","exact":""}},[_c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Salir","data-position":"right"}},[_c('i',{staticClass:"material-icons"},[_vm._v("exit_to_app")])])])],1)])]),_vm._v(" "),_c('router-view'),_vm._v(" "),_vm._m(4)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"brand-logo"},[_c('img',{attrs:{"src":"/topevaluaciones/src/assets/imagenes/logotopnav.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"sidenav-trigger",attrs:{"data-target":"mobile-demo"}},[_c('i',{staticClass:"material-icons"},[_vm._v("menu")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-trigger tooltipped",attrs:{"data-target":"dropdown2","data-tooltip":"Evaluaciones","data-position":"rigth"}},[_c('i',{staticClass:"material-icons"},[_vm._v("content_paste arrow_drop_down")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-trigger tooltipped",attrs:{"data-target":"dropdown4","data-tooltip":"Evaluaciones","data-position":"rigth"}},[_c('i',{staticClass:"material-icons"},[_vm._v("content_paste arrow_drop_down")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"left"},[_c('a',{staticClass:"sidenav-trigger",staticStyle:{"font-weight":"bold"},attrs:{"data-target":"slide-out"}},[_vm._v("\n               Créditos\n            ")]),_vm._v(" "),_c('ul',{staticClass:"sidenav",attrs:{"id":"slide-out"}},[_c('br'),_vm._v(" "),_c('li',[_c('div',{staticClass:"user-view"},[_c('div',{staticClass:"background center"},[_c('img',{attrs:{"src":"/topevaluaciones/src/assets/imagenes/logotopslide.png"}})]),_vm._v(" "),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('a',[_vm._v("Sistema de Evaluaciones")]),_vm._v(" "),_c('b',{staticClass:"waves-effect",staticStyle:{"font-size":"14px"}},[_vm._v("©2022. All rights reserved.")]),_c('br'),_vm._v(" "),_c('b',{staticClass:"waves-effect"},[_vm._v("Servinsa")]),_c('br')])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"divider"})]),_vm._v(" "),_c('li',[_c('div',{staticClass:"user-view"},[_c('div',{staticClass:"center"},[_c('b',{staticClass:"waves-effect",staticStyle:{"font-size":"14px"}},[_vm._v("Designed by jcjocop@gmail.com")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"user-view"},[_c('div',{staticClass:"background center"},[_c('img',{attrs:{"src":"/topevaluaciones/src/assets/imagenes/milogomedium.jpg"}})]),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('p',{staticStyle:{"font-size":"10px"}},[_vm._v("© 2018. All rights reserved....")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return rutaEvalTipolo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return rutaEvalFactor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return rutaEvalEstabi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return rutaEvalSociab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return rutaEvalPerfil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return rutaEvalSuperv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return rutaEvalApvtas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return rutaEvalSolemp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return rutaEvalEmoc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return rutaEvalVtas2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return rutaEvalAuxi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return rutaEvalAEDP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return rutaUsuarios; });
/* unused harmony export rutaDeptos */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return rutaCV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return dbEvalTipolo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return dbEvalFactor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return dbEvalEstabi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return dbEvalSociab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return dbEvalPerfil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return dbEvalSuperv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dbEvalApvtas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return dbEvalSolemp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return dbEvalEmoc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return dbEvalVtas2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dbEvalAuxi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dbEvalAEDP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return dbUsuarios; });
/* unused harmony export dbDeptos */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dbCV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return rutaCVs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return rutaFotosU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return stg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return stgCVs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return stgFotosU; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/**
myFirebaseApp.js
Accede a la configuración del proyecto FB que usaré en mi aplicación.
Las rutas son los nodos a los que accederé a través de los dbXXXXX.
**********************************************************************************************************************************
*/


/* Obtenemos la configuración de nuestro proyecto en Firebase */
var config = {

     apiKey: "AIzaSyCZ1oyLNZg2CKrSO-FkZ0P_MSctBs_0duw",
     authDomain: "topcg-95de7.firebaseapp.com",
     databaseURL: "https://topcg-95de7.firebaseio.com",
     projectId: "topcg-95de7",
     storageBucket: "topcg-95de7.appspot.com",
     messagingSenderId: "399798762836"
};
__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config); // Inicializamos la configuración de FB

//? 
//? :¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.:¬.
//? Configuración en FB-jcjocop@gmail.com
// const firebaseConfig = {
//      apiKey: "AIzaSyBTOwLPa3tC1H_y9ZkkLyu9jQd251QzHTg",
//      authDomain: "servinsaeval.firebaseapp.com",
//      databaseURL: "https://servinsaeval-default-rtdb.firebaseio.com",
//      projectId: "servinsaeval",
//      storageBucket: "servinsaeval.appspot.com",
//      messagingSenderId: "488374041153",
//      appId: "1:488374041153:web:3f18c5d2b063186480a4c0"
// };

//? Configuración en FB-jcjocop@gmail.com
// const firebaseConfig = {
//      apiKey: "AIzaSyBvoCoMDbP0h4RmkEaNaPPk7HBb0SUNajA",
//      authDomain: "servinsaeval-6667b.firebaseapp.com",
//      databaseURL: "https://servinsaeval-6667b-default-rtdb.firebaseio.com",
//      projectId: "servinsaeval-6667b",
//      storageBucket: "servinsaeval-6667b.appspot.com",
//      messagingSenderId: "977023563164",
//      appId: "1:977023563164:web:43c1805490869cb7448459"
// };

/* Inicializamos la configuración */
// firebase.initializeApp(firebaseConfig); // Inicializamos la configuración de FB

/** Obtenemos las rutas para el nodo de las evaluaciones de:  */
var rutaEvalTipolo = "/evaluaciones/tipologia"; // Tipología (myers)
var rutaEvalFactor = "/evaluaciones/factores"; // Factores (16pf)
var rutaEvalEstabi = "/evaluaciones/estabilidad"; // Estabilidad (npf)
var rutaEvalSociab = "/evaluaciones/sociabilidad"; // Sociabilidad (cpf)
var rutaEvalPerfil = "/evaluaciones/perfil"; // Perfil (fig)
var rutaEvalSuperv = "/evaluaciones/supervision"; // Supervisión (moss)
var rutaEvalApvtas = "/evaluaciones/aptitudvtas"; // Aptitud den Ventas (tav)
var rutaEvalSolemp = "/evaluaciones/solemp"; // Solicitud de Empleo
var rutaEvalEmoc = "/evaluaciones/emociones"; // Emociones
var rutaEvalVtas2 = "/evaluaciones/orientacion"; // Orientación en Ventas
var rutaEvalAuxi = "/evaluaciones/auxiliar"; // Auxiliar de Computación
var rutaEvalAEDP = "/evaluaciones/aedp"; // Auxiliar de Computación

var rutaUsuarios = "/usuarios"; // Usuarios del Sistema
var rutaDeptos = "/catalogos/deptos"; // Departamentos del País.
var rutaCV = "/cvs";

/**  Accedemos a la Base de datos */
var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database();

/** Direccionamos al nodo correspondiente. */
var dbEvalTipolo = db.ref(rutaEvalTipolo);
var dbEvalFactor = db.ref(rutaEvalFactor);
var dbEvalEstabi = db.ref(rutaEvalEstabi);
var dbEvalSociab = db.ref(rutaEvalSociab);
var dbEvalPerfil = db.ref(rutaEvalPerfil);
var dbEvalSuperv = db.ref(rutaEvalSuperv);
var dbEvalApvtas = db.ref(rutaEvalApvtas);
var dbEvalSolemp = db.ref(rutaEvalSolemp);
var dbEvalEmoc = db.ref(rutaEvalEmoc);
var dbEvalVtas2 = db.ref(rutaEvalVtas2);
var dbEvalAuxi = db.ref(rutaEvalAuxi);
var dbEvalAEDP = db.ref(rutaEvalAEDP);

var dbUsuarios = db.ref(rutaUsuarios);
var dbDeptos = db.ref(rutaDeptos);
var dbCV = db.ref(rutaCV);
/** ================================================================================================================== */

/** Obtenemos las rutas para las carpetas del Storage donde estarán:  */
var rutaCVs = "/cvs/"; // Los CVs
var rutaFotosU = "/fotosu/"; // Las fotos de los usuarios

/** Accedemos a Storage */
var stg = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.storage();

/** Direccionamos a la carpeta correspondiente */
var stgCVs = stg.ref(rutaCVs);
var stgFotosU = stg.ref(rutaFotosU);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_promise_polyfill_lib_polyfill__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_promise_polyfill_lib_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_promise_polyfill_lib_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_starts_with__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_fn_string_repeat__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_fn_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_fn_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_fn_symbol__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_fn_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_fn_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_fn_symbol_iterator__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_fn_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_fn_symbol_iterator__);










/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/***/ }),
/* 235 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate, global) {

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

var globalNS = (function() {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  throw new Error('unable to locate global object');
})();

if (!globalNS.Promise) {
  globalNS.Promise = Promise;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56).setImmediate, __webpack_require__(8)))

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(238);
module.exports = __webpack_require__(11).Array.find;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(12);
var $find = __webpack_require__(61)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(44)(KEY);


/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(241);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var isArray = __webpack_require__(62);
var SPECIES = __webpack_require__(7)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(243);
module.exports = __webpack_require__(11).Array.findIndex;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(12);
var $find = __webpack_require__(61)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(44)(KEY);


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(245);
module.exports = __webpack_require__(11).Object.assign;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(12);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(246) });


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(27);
var gOPS = __webpack_require__(47);
var pIE = __webpack_require__(36);
var toObject = __webpack_require__(41);
var IObject = __webpack_require__(40);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(23)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(20);
var toLength = __webpack_require__(42);
var toAbsoluteIndex = __webpack_require__(248);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(35);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(250);
module.exports = __webpack_require__(11).String.startsWith;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(12);
var toLength = __webpack_require__(42);
var context = __webpack_require__(251);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(253)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(252);
var defined = __webpack_require__(26);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(14);
var cof = __webpack_require__(34);
var MATCH = __webpack_require__(7)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(7)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(255);
module.exports = __webpack_require__(11).String.repeat;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(256)
});


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(35);
var defined = __webpack_require__(26);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(258);
__webpack_require__(265);
__webpack_require__(267);
__webpack_require__(268);
module.exports = __webpack_require__(11).Symbol;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(10);
var has = __webpack_require__(15);
var DESCRIPTORS = __webpack_require__(19);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(24);
var META = __webpack_require__(259).KEY;
var $fails = __webpack_require__(23);
var shared = __webpack_require__(43);
var setToStringTag = __webpack_require__(48);
var uid = __webpack_require__(25);
var wks = __webpack_require__(7);
var wksExt = __webpack_require__(49);
var wksDefine = __webpack_require__(50);
var enumKeys = __webpack_require__(260);
var isArray = __webpack_require__(62);
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(14);
var toIObject = __webpack_require__(20);
var toPrimitive = __webpack_require__(39);
var createDesc = __webpack_require__(33);
var _create = __webpack_require__(64);
var gOPNExt = __webpack_require__(263);
var $GOPD = __webpack_require__(264);
var $DP = __webpack_require__(18);
var $keys = __webpack_require__(27);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(65).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(36).f = $propertyIsEnumerable;
  __webpack_require__(47).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(51)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(13)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(25)('meta');
var isObject = __webpack_require__(14);
var has = __webpack_require__(15);
var setDesc = __webpack_require__(18).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(23)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(27);
var gOPS = __webpack_require__(47);
var pIE = __webpack_require__(36);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(18);
var anObject = __webpack_require__(32);
var getKeys = __webpack_require__(27);

module.exports = __webpack_require__(19) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(10).document;
module.exports = document && document.documentElement;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(20);
var gOPN = __webpack_require__(65).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(36);
var createDesc = __webpack_require__(33);
var toIObject = __webpack_require__(20);
var toPrimitive = __webpack_require__(39);
var has = __webpack_require__(15);
var IE8_DOM_DEFINE = __webpack_require__(58);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(19) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(266);
var test = {};
test[__webpack_require__(7)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(24)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(34);
var TAG = __webpack_require__(7)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('asyncIterator');


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('observable');


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(270);
__webpack_require__(274);
module.exports = __webpack_require__(49).f('iterator');


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(271)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(66)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(35);
var defined = __webpack_require__(26);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(64);
var descriptor = __webpack_require__(33);
var setToStringTag = __webpack_require__(48);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(13)(IteratorPrototype, __webpack_require__(7)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(15);
var toObject = __webpack_require__(41);
var IE_PROTO = __webpack_require__(45)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(275);
var getKeys = __webpack_require__(27);
var redefine = __webpack_require__(24);
var global = __webpack_require__(10);
var hide = __webpack_require__(13);
var Iterators = __webpack_require__(52);
var wks = __webpack_require__(7);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(44);
var step = __webpack_require__(276);
var Iterators = __webpack_require__(52);
var toIObject = __webpack_require__(20);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(66)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
(function() {var g,aa=aa||{},k=this;function l(a){return"string"==typeof a}function ba(a){return"boolean"==typeof a}function ca(){}
function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return null===a}function fa(a){return"array"==da(a)}function ha(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function n(a){return"function"==da(a)}function q(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var ia="closure_uid_"+(1E9*Math.random()>>>0),ja=0;function ka(a,b,c){return a.call.apply(a.bind,arguments)}
function ma(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=ka:r=ma;return r.apply(null,arguments)}
function na(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var oa=Date.now||function(){return+new Date};function t(a,b){function c(){}c.prototype=b.prototype;a.ob=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.ed=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};function pa(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0}function qa(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function u(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}t(u,Error);u.prototype.name="CustomError";function ra(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");u.call(this,c+a[d])}t(ra,u);ra.prototype.name="AssertionError";function sa(a,b){throw new ra("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function ta(a,b){this.c=a;this.f=b;this.b=0;this.a=null}ta.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function ua(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function va(){this.b=this.a=null}var xa=new ta(function(){return new wa},function(a){a.reset()});va.prototype.add=function(a,b){var c=xa.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function ya(){var a=za,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function wa(){this.next=this.b=this.a=null}wa.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};wa.prototype.reset=function(){this.next=this.b=this.a=null};var Aa=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(l(a))return l(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},v=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=l(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
function Ba(a,b){var c=a.length,d=l(a)?a.split(""):a;for(--c;0<=c;--c)c in d&&b.call(void 0,d[c],c,a)}
var Ca=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=l(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Da=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};
function Ea(a){a:{var b=Fa;for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:l(a)?a.charAt(b):a[b]}function Ga(a,b){return 0<=Aa(a,b)}function Ha(a,b){b=Aa(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function w(a,b){var c=0;Ba(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Ia(a){return Array.prototype.concat.apply([],arguments)}
function Ja(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};function Ka(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var La=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};
function Ma(a){if(!Na.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(Oa,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(Pa,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(Qa,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(Ra,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(Sa,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(Ta,"&#0;"));return a}var Oa=/&/g,Pa=/</g,Qa=/>/g,Ra=/"/g,Sa=/'/g,Ta=/\x00/g,Na=/[\x00&<>"']/;function y(a,b){return-1!=a.indexOf(b)}function Ua(a,b){return a<b?-1:a>b?1:0};var Va;a:{var Wa=k.navigator;if(Wa){var Xa=Wa.userAgent;if(Xa){Va=Xa;break a}}Va=""}function z(a){return y(Va,a)};function Ya(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Za(a){for(var b in a)return!1;return!0}function $a(a){var b={},c;for(c in a)b[c]=a[c];return b}var ab="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function bb(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<ab.length;f++)c=ab[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function cb(a){k.setTimeout(function(){throw a;},0)}var db;
function eb(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!z("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=r(function(a){if(("*"==d||a.origin==d)&&a.data==
c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!z("Trident")&&!z("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.wb;c.wb=null;a()}};return function(a){d.next={wb:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};function fb(a,b){hb||ib();jb||(hb(),jb=!0);za.add(a,b)}var hb;function ib(){if(k.Promise&&k.Promise.resolve){var a=k.Promise.resolve(void 0);hb=function(){a.then(kb)}}else hb=function(){var a=kb;!n(k.setImmediate)||k.Window&&k.Window.prototype&&!z("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(db||(db=eb()),db(a)):k.setImmediate(a)}}var jb=!1,za=new va;function kb(){for(var a;a=ya();){try{a.a.call(a.b)}catch(b){cb(b)}ua(xa,a)}jb=!1};function A(a,b){this.a=lb;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ca)try{var c=this;a.call(b,function(a){mb(c,nb,a)},function(a){if(!(a instanceof ob))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}mb(c,pb,a)})}catch(d){mb(this,pb,d)}}var lb=0,nb=2,pb=3;function qb(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}qb.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var rb=new ta(function(){return new qb},function(a){a.reset()});
function sb(a,b,c){var d=rb.get();d.g=a;d.b=b;d.f=c;return d}function B(a){if(a instanceof A)return a;var b=new A(ca);mb(b,nb,a);return b}function C(a){return new A(function(b,c){c(a)})}function tb(a,b,c){ub(a,b,c,null)||fb(na(b,a))}function vb(a){return new A(function(b,c){var d=a.length,e=[];if(d)for(var f=function(a,c){d--;e[a]=c;0==d&&b(e)},h=function(a){c(a)},m=0,p;m<a.length;m++)p=a[m],tb(p,na(f,m),h);else b(e)})}
function wb(a){return new A(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Db:!0,value:f}:{Db:!1,reason:f};0==c&&b(d)},f=0,h;f<a.length;f++)h=a[f],tb(h,na(e,f,!0),na(e,f,!1));else b(d)})}A.prototype.then=function(a,b,c){return xb(this,n(a)?a:null,n(b)?b:null,c)};pa(A);g=A.prototype;g.ia=function(a,b){a=sb(a,a,b);a.c=!0;yb(this,a);return this};g.s=function(a,b){return xb(this,null,a,b)};g.cancel=function(a){this.a==lb&&fb(function(){var b=new ob(a);zb(this,b)},this)};
function zb(a,b){if(a.a==lb)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,h=c.b;h&&(h.c||(d++,h.a==a&&(e=h),!(e&&1<d)));h=h.next)e||(f=h);e&&(c.a==lb&&1==d?zb(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):Ab(c),Bb(c,e,pb,b)))}a.c=null}else mb(a,pb,b)}function yb(a,b){a.b||a.a!=nb&&a.a!=pb||Cb(a);a.f?a.f.next=b:a.b=b;a.f=b}
function xb(a,b,c,d){var e=sb(null,null,null);e.a=new A(function(a,h){e.g=b?function(c){try{var e=b.call(d,c);a(e)}catch(x){h(x)}}:a;e.b=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof ob?h(b):a(e)}catch(x){h(x)}}:h});e.a.c=a;yb(a,e);return e.a}g.Nc=function(a){this.a=lb;mb(this,nb,a)};g.Oc=function(a){this.a=lb;mb(this,pb,a)};
function mb(a,b,c){a.a==lb&&(a===c&&(b=pb,c=new TypeError("Promise cannot resolve to itself")),a.a=1,ub(c,a.Nc,a.Oc,a)||(a.i=c,a.a=b,a.c=null,Cb(a),b!=pb||c instanceof ob||Db(a,c)))}function ub(a,b,c,d){if(a instanceof A)return yb(a,sb(b||ca,c||null,d)),!0;if(qa(a))return a.then(b,c,d),!0;if(q(a))try{var e=a.then;if(n(e))return Eb(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
function Eb(a,b,c,d,e){function f(a){m||(m=!0,d.call(e,a))}function h(a){m||(m=!0,c.call(e,a))}var m=!1;try{b.call(a,h,f)}catch(p){f(p)}}function Cb(a){a.h||(a.h=!0,fb(a.Yb,a))}function Ab(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}g.Yb=function(){for(var a;a=Ab(this);)Bb(this,a,this.a,this.i);this.h=!1};
function Bb(a,b,c,d){if(c==pb&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Fb(b,c,d);else try{b.c?b.g.call(b.f):Fb(b,c,d)}catch(e){Gb.call(null,e)}ua(rb,b)}function Fb(a,b,c){b==nb?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Db(a,b){a.g=!0;fb(function(){a.g&&Gb.call(null,b)})}var Gb=cb;function ob(a){u.call(this,a)}t(ob,u);ob.prototype.name="cancel";function Hb(){0!=Ib&&(Jb[this[ia]||(this[ia]=++ja)]=this);this.qa=this.qa;this.ja=this.ja}var Ib=0,Jb={};Hb.prototype.qa=!1;function Kb(a){if(!a.qa&&(a.qa=!0,a.va(),0!=Ib)){var b=a[ia]||(a[ia]=++ja);if(0!=Ib&&a.ja&&0<a.ja.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Jb[b]}}Hb.prototype.va=function(){if(this.ja)for(;this.ja.length;)this.ja.shift()()};function Lb(a){Lb[" "](a);return a}Lb[" "]=ca;function Mb(a,b){var c=Nb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Ob=z("Opera"),Pb=z("Trident")||z("MSIE"),Qb=z("Edge"),Rb=Qb||Pb,Sb=z("Gecko")&&!(y(Va.toLowerCase(),"webkit")&&!z("Edge"))&&!(z("Trident")||z("MSIE"))&&!z("Edge"),Tb=y(Va.toLowerCase(),"webkit")&&!z("Edge");function Ub(){var a=k.document;return a?a.documentMode:void 0}var Vb;
a:{var Wb="",Xb=function(){var a=Va;if(Sb)return/rv:([^\);]+)(\)|;)/.exec(a);if(Qb)return/Edge\/([\d\.]+)/.exec(a);if(Pb)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Tb)return/WebKit\/(\S+)/.exec(a);if(Ob)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Xb&&(Wb=Xb?Xb[1]:"");if(Pb){var Yb=Ub();if(null!=Yb&&Yb>parseFloat(Wb)){Vb=String(Yb);break a}}Vb=Wb}var Nb={};
function Zb(a){return Mb(a,function(){for(var b=0,c=La(String(Vb)).split("."),d=La(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var h=c[f]||"",m=d[f]||"";do{h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];m=/(\d*)(\D*)(.*)/.exec(m)||["","","",""];if(0==h[0].length&&0==m[0].length)break;b=Ua(0==h[1].length?0:parseInt(h[1],10),0==m[1].length?0:parseInt(m[1],10))||Ua(0==h[2].length,0==m[2].length)||Ua(h[2],m[2]);h=h[3];m=m[3]}while(0==b)}return 0<=b})}var $b;var ac=k.document;
$b=ac&&Pb?Ub()||("CSS1Compat"==ac.compatMode?parseInt(Vb,10):5):void 0;var bc=Object.freeze||function(a){return a};var cc=!Pb||9<=Number($b),dc=Pb&&!Zb("9"),ec=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",ca,b);k.removeEventListener("test",ca,b);return a}();function D(a,b){this.type=a;this.b=this.target=b;this.Kb=!0}D.prototype.preventDefault=function(){this.Kb=!1};function fc(a,b){D.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(Sb){a:{try{Lb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=
a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=l(a.pointerType)?a.pointerType:gc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}t(fc,D);var gc=bc({2:"touch",3:"pen",4:"mouse"});fc.prototype.preventDefault=function(){fc.ob.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,dc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};fc.prototype.f=function(){return this.a};var hc="closure_listenable_"+(1E6*Math.random()|0),ic=0;function jc(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.La=e;this.key=++ic;this.oa=this.Ia=!1}function kc(a){a.oa=!0;a.listener=null;a.proxy=null;a.src=null;a.La=null};function lc(a){this.src=a;this.a={};this.b=0}lc.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var h=mc(a,b,d,e);-1<h?(b=a[h],c||(b.Ia=!1)):(b=new jc(b,this.src,f,!!d,e),b.Ia=c,a.push(b));return b};function nc(a,b){var c=b.type;c in a.a&&Ha(a.a[c],b)&&(kc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function mc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.oa&&f.listener==b&&f.capture==!!c&&f.La==d)return e}return-1};var oc="closure_lm_"+(1E6*Math.random()|0),pc={},qc=0;function rc(a,b,c,d,e){if(d&&d.once)sc(a,b,c,d,e);else if(fa(b))for(var f=0;f<b.length;f++)rc(a,b[f],c,d,e);else c=tc(c),a&&a[hc]?uc(a,b,c,q(d)?!!d.capture:!!d,e):vc(a,b,c,!1,d,e)}
function vc(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var h=q(e)?!!e.capture:!!e,m=wc(a);m||(a[oc]=m=new lc(a));c=m.add(b,c,d,h,f);if(!c.proxy){d=xc();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)ec||(e=h),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(yc(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");qc++}}
function xc(){var a=zc,b=cc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function sc(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)sc(a,b[f],c,d,e);else c=tc(c),a&&a[hc]?Ac(a,b,c,q(d)?!!d.capture:!!d,e):vc(a,b,c,!0,d,e)}
function E(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)E(a,b[f],c,d,e);else(d=q(d)?!!d.capture:!!d,c=tc(c),a&&a[hc])?(a=a.l,b=String(b).toString(),b in a.a&&(f=a.a[b],c=mc(f,c,d,e),-1<c&&(kc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=wc(a))&&(b=a.a[b.toString()],a=-1,b&&(a=mc(b,c,d,e)),(c=-1<a?b[a]:null)&&Bc(c))}
function Bc(a){if("number"!=typeof a&&a&&!a.oa){var b=a.src;if(b&&b[hc])nc(b.l,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(yc(c),d):b.addListener&&b.removeListener&&b.removeListener(d);qc--;(c=wc(b))?(nc(c,a),0==c.b&&(c.src=null,b[oc]=null)):kc(a)}}}function yc(a){return a in pc?pc[a]:pc[a]="on"+a}
function Cc(a,b,c,d){var e=!0;if(a=wc(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.oa&&(f=Dc(f,d),e=e&&!1!==f)}return e}function Dc(a,b){var c=a.listener,d=a.La||a.src;a.Ia&&Bc(a);return c.call(d,b)}
function zc(a,b){if(a.oa)return!0;if(!cc){if(!b)a:{b=["window","event"];for(var c=k,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new fc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(h){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=Cc(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=Cc(d[e],a,!1,b),c=c&&f}return c}return Dc(a,
new fc(b,this))}function wc(a){a=a[oc];return a instanceof lc?a:null}var Ec="__closure_events_fn_"+(1E9*Math.random()>>>0);function tc(a){if(n(a))return a;a[Ec]||(a[Ec]=function(b){return a.handleEvent(b)});return a[Ec]};function F(){Hb.call(this);this.l=new lc(this);this.Rb=this;this.Va=null}t(F,Hb);F.prototype[hc]=!0;F.prototype.addEventListener=function(a,b,c,d){rc(this,a,b,c,d)};F.prototype.removeEventListener=function(a,b,c,d){E(this,a,b,c,d)};
F.prototype.dispatchEvent=function(a){var b,c=this.Va;if(c)for(b=[];c;c=c.Va)b.push(c);c=this.Rb;var d=a.type||a;if(l(a))a=new D(a,c);else if(a instanceof D)a.target=a.target||c;else{var e=a;a=new D(d,c);bb(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var h=a.b=b[f];e=Fc(h,d,!0,a)&&e}h=a.b=c;e=Fc(h,d,!0,a)&&e;e=Fc(h,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)h=a.b=b[f],e=Fc(h,d,!1,a)&&e;return e};
F.prototype.va=function(){F.ob.va.call(this);if(this.l){var a=this.l,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,kc(d[e]);delete a.a[c];a.b--}}this.Va=null};function uc(a,b,c,d,e){a.l.add(String(b),c,!1,d,e)}function Ac(a,b,c,d,e){a.l.add(String(b),c,!0,d,e)}
function Fc(a,b,c,d){b=a.l.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var h=b[f];if(h&&!h.oa&&h.capture==c){var m=h.listener,p=h.La||h.src;h.Ia&&nc(a.l,h);e=!1!==m.call(p,d)&&e}}return e&&0!=d.Kb};function Gc(a,b,c){if(n(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)}function Hc(a){var b=null;return(new A(function(c,d){b=Gc(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).s(function(a){k.clearTimeout(b);throw a;})};function Ic(a){if(a.S&&"function"==typeof a.S)return a.S();if(l(a))return a.split("");if(ha(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function Jc(a){if(a.U&&"function"==typeof a.U)return a.U();if(!a.S||"function"!=typeof a.S){if(ha(a)||l(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
function Kc(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ha(a)||l(a))v(a,b,void 0);else for(var c=Jc(a),d=Ic(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function Lc(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof Lc)for(c=a.U(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}g=Lc.prototype;g.S=function(){Mc(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};g.U=function(){Mc(this);return this.a.concat()};
g.clear=function(){this.b={};this.c=this.a.length=0};function Mc(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Nc(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Nc(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}g.get=function(a,b){return Nc(this.b,a)?this.b[a]:b};g.set=function(a,b){Nc(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
g.forEach=function(a,b){for(var c=this.U(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Nc(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Oc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Pc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function Qc(a,b){this.b=this.l=this.c="";this.i=null;this.h=this.g="";this.f=!1;if(a instanceof Qc){this.f=void 0!==b?b:a.f;Rc(this,a.c);this.l=a.l;this.b=a.b;Sc(this,a.i);this.g=a.g;b=a.a;var c=new Tc;c.c=b.c;b.a&&(c.a=new Lc(b.a),c.b=b.b);Uc(this,c);this.h=a.h}else a&&(c=String(a).match(Oc))?(this.f=!!b,Rc(this,c[1]||"",!0),this.l=Vc(c[2]||""),this.b=Vc(c[3]||"",!0),Sc(this,c[4]),this.g=Vc(c[5]||"",!0),Uc(this,c[6]||"",!0),this.h=Vc(c[7]||"")):(this.f=!!b,this.a=new Tc(null,this.f))}
Qc.prototype.toString=function(){var a=[],b=this.c;b&&a.push(Wc(b,Xc,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.l)&&a.push(Wc(b,Xc,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.g)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Wc(c,"/"==c.charAt(0)?Yc:Zc,!0));(c=this.a.toString())&&a.push("?",c);(c=this.h)&&a.push("#",Wc(c,$c));return a.join("")};
function Rc(a,b,c){a.c=c?Vc(b,!0):b;a.c&&(a.c=a.c.replace(/:$/,""))}function Sc(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b}else a.i=null}function Uc(a,b,c){b instanceof Tc?(a.a=b,ad(a.a,a.f)):(c||(b=Wc(b,bd)),a.a=new Tc(b,a.f))}function G(a,b,c){a.a.set(b,c)}function cd(a,b){return a.a.get(b)}function dd(a){return a instanceof Qc?new Qc(a):new Qc(a,void 0)}function ed(a,b){var c=new Qc(null,void 0);Rc(c,"https");a&&(c.b=a);b&&(c.g=b);return c}
function Vc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Wc(a,b,c){return l(a)?(a=encodeURI(a).replace(b,fd),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function fd(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Xc=/[#\/\?@]/g,Zc=/[#\?:]/g,Yc=/[#\?]/g,bd=/[#\?@]/g,$c=/#/g;function Tc(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}
function gd(a){a.a||(a.a=new Lc,a.b=0,a.c&&Pc(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function hd(a){var b=Jc(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Tc(null,void 0);a=Ic(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];fa(f)?id(c,e,f):c.add(e,f)}return c}g=Tc.prototype;g.add=function(a,b){gd(this);this.c=null;a=jd(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};
function kd(a,b){gd(a);b=jd(a,b);Nc(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Nc(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Mc(a)))}g.clear=function(){this.a=this.c=null;this.b=0};function ld(a,b){gd(a);b=jd(a,b);return Nc(a.a.b,b)}g.forEach=function(a,b){gd(this);this.a.forEach(function(c,d){v(c,function(c){a.call(b,c,d,this)},this)},this)};g.U=function(){gd(this);for(var a=this.a.S(),b=this.a.U(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
g.S=function(a){gd(this);var b=[];if(l(a))ld(this,a)&&(b=Ia(b,this.a.get(jd(this,a))));else{a=this.a.S();for(var c=0;c<a.length;c++)b=Ia(b,a[c])}return b};g.set=function(a,b){gd(this);this.c=null;a=jd(this,a);ld(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};g.get=function(a,b){a=a?this.S(a):[];return 0<a.length?String(a[0]):b};function id(a,b,c){kd(a,b);0<c.length&&(a.c=null,a.a.set(jd(a,b),Ja(c)),a.b+=c.length)}
g.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.U(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.S(d);for(var f=0;f<d.length;f++){var h=e;""!==d[f]&&(h+="="+encodeURIComponent(String(d[f])));a.push(h)}}return this.c=a.join("&")};function jd(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function ad(a,b){b&&!a.f&&(gd(a),a.c=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(kd(this,b),id(this,c,a))},a));a.f=b};var md=!Pb||9<=Number($b);function nd(){this.a="";this.b=od}nd.prototype.na=!0;nd.prototype.ma=function(){return this.a};nd.prototype.toString=function(){return"Const{"+this.a+"}"};function pd(a){if(a instanceof nd&&a.constructor===nd&&a.b===od)return a.a;sa("expected object of type Const, got '"+a+"'");return"type_error:Const"}var od={};function qd(a){var b=new nd;b.a=a;return b}qd("");function rd(){this.a="";this.b=sd}rd.prototype.na=!0;rd.prototype.ma=function(){return this.a};rd.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function td(a){if(a instanceof rd&&a.constructor===rd&&a.b===sd)return a.a;sa("expected object of type TrustedResourceUrl, got '"+a+"' of type "+da(a));return"type_error:TrustedResourceUrl"}
function ud(a,b){var c=pd(a);if(!vd.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(wd,function(a,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));a=b[e];return a instanceof nd?pd(a):encodeURIComponent(String(a))});return xd(a)}var wd=/%{(\w+)}/g,vd=/^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank#/i,sd={};
function xd(a){var b=new rd;b.a=a;return b};function yd(){this.a="";this.b=zd}yd.prototype.na=!0;yd.prototype.ma=function(){return this.a};yd.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Ad(a){if(a instanceof yd&&a.constructor===yd&&a.b===zd)return a.a;sa("expected object of type SafeUrl, got '"+a+"' of type "+da(a));return"type_error:SafeUrl"}var Bd=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
function Cd(a){if(a instanceof yd)return a;a=a.na?a.ma():String(a);Bd.test(a)||(a="about:invalid#zClosurez");return Dd(a)}var zd={};function Dd(a){var b=new yd;b.a=a;return b}Dd("about:blank");function Ed(){this.a="";this.b=Fd}Ed.prototype.na=!0;Ed.prototype.ma=function(){return this.a};Ed.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Gd(a){if(a instanceof Ed&&a.constructor===Ed&&a.b===Fd)return a.a;sa("expected object of type SafeHtml, got '"+a+"' of type "+da(a));return"type_error:SafeHtml"}var Fd={};function Hd(a){var b=new Ed;b.a=a;return b}Hd("<!DOCTYPE html>");Hd("");Hd("<br>");function Id(a){var b=document;return l(a)?b.getElementById(a):a}function Jd(a,b){Ya(b,function(b,d){b&&b.na&&(b=b.ma());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:Kd.hasOwnProperty(d)?a.setAttribute(Kd[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})}
var Kd={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
function Ld(a,b,c){var d=arguments,e=document,f=String(d[0]),h=d[1];if(!md&&h&&(h.name||h.type)){f=["<",f];h.name&&f.push(' name="',Ma(h.name),'"');if(h.type){f.push(' type="',Ma(h.type),'"');var m={};bb(m,h);delete m.type;h=m}f.push(">");f=f.join("")}f=e.createElement(f);h&&(l(h)?f.className=h:fa(h)?f.className=h.join(" "):Jd(f,h));2<d.length&&Md(e,f,d);return f}
function Md(a,b,c){function d(c){c&&b.appendChild(l(c)?a.createTextNode(c):c)}for(var e=2;e<c.length;e++){var f=c[e];!ha(f)||q(f)&&0<f.nodeType?d(f):v(Nd(f)?Ja(f):f,d)}}function Nd(a){if(a&&"number"==typeof a.length){if(q(a))return"function"==typeof a.item||"string"==typeof a.item;if(n(a))return"function"==typeof a.item}return!1};function Od(a){var b=[];Pd(new Qd,a,b);return b.join("")}function Qd(){}
function Pd(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(fa(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Pd(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Rd(d,c),c.push(":"),Pd(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Rd(b,c);break;case "number":c.push(isFinite(b)&&
!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Sd={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Td=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
function Rd(a,b){b.push('"',a.replace(Td,function(a){var b=Sd[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Sd[a]=b);return b}),'"')};/*

 Copyright 2017 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function Ud(){var a=H();return Pb&&!!$b&&11==$b||/Edge\/\d+/.test(a)}function Vd(){return k.window&&k.window.location.href||self&&self.location&&self.location.href||""}function Wd(a,b){b=b||k.window;var c="about:blank";a&&(c=Ad(Cd(a)));b.location.href=c}function Xd(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<Xd(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
function Yd(){var a=H();a=Zd(a)!=$d?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!Pb||!$b||9<$b}function ae(a){a=(a||H()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function be(a){a=a||k.window;try{a.close()}catch(b){}}
function ce(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=H().toLowerCase();d&&(b.target=d,y(c,"crios/")&&(b.target="_blank"));Zd(H())==de&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof yd?c:Cd("undefined"!=typeof c.href?c.href:String(c));c=a.target||c.target;e=[];
for(h in a)switch(h){case "width":case "height":case "top":case "left":e.push(h+"="+a[h]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(h+"="+(a[h]?1:0))}var h=e.join(",");(z("iPhone")&&!z("iPod")&&!z("iPad")||z("iPad")||z("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c?(h=d.document.createElement("A"),b instanceof yd||b instanceof yd||(b=b.na?b.ma():String(b),Bd.test(b)||(b="about:invalid#zClosurez"),b=Dd(b)),h.href=Ad(b),h.setAttribute("target",c),a.noreferrer&&
h.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,d,1),h.dispatchEvent(a),h={}):a.noreferrer?(h=d.open("",c,h),a=Ad(b),h&&(Rb&&y(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),h.opener=null,qd("b/12014412, meta tag with sanitized URL"),a='<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+Ma(a)+'">',a=Hd(a),h.document.write(Gd(a)),h.document.close())):(h=d.open(Ad(b),c,h))&&a.noopener&&(h.opener=null);if(h)try{h.focus()}catch(m){}return h}
function ee(a){return new A(function(b){function c(){Hc(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var fe=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,ge=/^[^@]+@[^@]+$/;function he(){var a=null;return(new A(function(b){"complete"==k.document.readyState?b():(a=function(){b()},sc(window,"load",a))})).s(function(b){E(window,"load",a);throw b;})}
function ie(){return je(void 0)?he().then(function(){return new A(function(a,b){var c=k.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):C(Error("Cordova must run in an Android or iOS file scheme."))}function je(a){a=a||H();return!("file:"!==ke()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function le(){var a=k.window;try{return!(!a||a==a.top)}catch(b){return!1}}
function me(){return"object"!==typeof k.window&&"function"===typeof k.importScripts}function ne(){return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("node")?"Node":me()?"Worker":"Browser"}function oe(){var a=ne();return"ReactNative"===a||"Node"===a}function pe(){for(var a=50,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}var de="Firefox",$d="Chrome";
function Zd(a){var b=a.toLowerCase();if(y(b,"opera/")||y(b,"opr/")||y(b,"opios/"))return"Opera";if(y(b,"iemobile"))return"IEMobile";if(y(b,"msie")||y(b,"trident/"))return"IE";if(y(b,"edge/"))return"Edge";if(y(b,"firefox/"))return de;if(y(b,"silk/"))return"Silk";if(y(b,"blackberry"))return"Blackberry";if(y(b,"webos"))return"Webos";if(!y(b,"safari/")||y(b,"chrome/")||y(b,"crios/")||y(b,"android"))if(!y(b,"chrome/")&&!y(b,"crios/")||y(b,"edge/")){if(y(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
2==a.length)return a[1]}else return $d;else return"Safari";return"Other"}var qe={Uc:"FirebaseCore-web",Wc:"FirebaseUI-web"};function re(a,b){b=b||[];var c=[],d={},e;for(e in qe)d[qe[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=ne();"Browser"===c?(d=H(),c=Zd(d)):"Worker"===c&&(d=H(),c=Zd(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function H(){return k.navigator&&k.navigator.userAgent||""}
function I(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function se(){try{var a=k.localStorage,b=te();if(a)return a.setItem(b,"1"),a.removeItem(b),Ud()?!!k.indexedDB:!0}catch(c){return me()&&!!k.indexedDB}return!1}function ue(){return(ve()||"chrome-extension:"===ke()||je())&&!oe()&&se()&&!me()}function ve(){return"http:"===ke()||"https:"===ke()}function ke(){return k.location&&k.location.protocol||null}
function we(a){a=a||H();return ae(a)||Zd(a)==de?!1:!0}function xe(a){return"undefined"===typeof a?null:Od(a)}function ye(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function ze(a){if(null!==a)return JSON.parse(a)}function te(a){return a?a:Math.floor(1E9*Math.random()).toString()}function Ae(a){a=a||H();return"Safari"==Zd(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
function Be(){var a=k.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function Ce(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=H();b=ne();this.b=ae(a)||"ReactNative"===b}
Ce.prototype.get=function(){var a=k.navigator;return(a&&"boolean"===typeof a.onLine&&(ve()||"chrome-extension:"===ke()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function De(){var a=k.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
function Ee(){var a=k.document,b=null;return De()||!a?B():(new A(function(c){b=function(){De()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).s(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function Fe(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function Ge(){return!(!I("fireauth.oauthhelper",k)&&!I("fireauth.iframe",k))}
function He(){var a=k.navigator;return a&&a.serviceWorker&&a.serviceWorker.controller||null}function Ie(){var a=k.navigator;return a&&a.serviceWorker?B().then(function(){return a.serviceWorker.ready}).then(function(a){return a.active||null}).s(function(){return null}):B(null)};var Je={};function Ke(a){Je[a]||(Je[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Le;try{var Me={};Object.defineProperty(Me,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Me,"abcd",{configurable:!0,enumerable:!0,value:2});Le=2==Me.abcd}catch(a){Le=!1}function J(a,b,c){Le?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function K(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&J(a,c,b[c])}function Ne(a){var b={};K(b,a);return b}function Oe(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
function Pe(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function Qe(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)J(b,c,Qe(a[c]))}return b};function Re(a){var b={},c=a[Se],d=a[Te];a=a[Ue];if(!a||a!=Ve&&!c)throw Error("Invalid provider user info!");b[We]=d||null;b[Xe]=c||null;J(this,Ye,a);J(this,Ze,Qe(b))}var Ve="EMAIL_SIGNIN",Se="email",Te="newEmail",Ue="requestType",Xe="email",We="fromEmail",Ze="data",Ye="operation";function L(a,b){this.code=$e+a;this.message=b||af[a]||""}t(L,Error);L.prototype.C=function(){return{code:this.code,message:this.message}};L.prototype.toJSON=function(){return this.C()};function bf(a){var b=a&&a.code;return b?new L(b.substring($e.length),a.message):null}
var $e="auth/",af={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
"code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
"dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
"invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
"invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-dynamic-link-domain":"The provided dynamic link domain is not configured or authorized for the current project.",
"invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
"invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
"wrong-password":"The password is invalid or the user does not have a password.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].","invalid-provider-id":"The specified provider ID is invalid.","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.",
"invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
"missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.","missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-or-invalid-nonce":"The OIDC ID token requires a valid unhashed nonce.",
"missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.","network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
"no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","null-user":"A null user object was provided as the argument for an operation which requires a non-null user object.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
"rejected-credential":"The request contains malformed or mismatching credentials.",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-persistence-type":"The current environment does not support the specified persistence type.",
"user-cancelled":"User did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function cf(a){var b=a[df];if("undefined"===typeof b)throw new L("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new L("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[ef];if(c&&"object"===typeof c){b=c[ff];var d=c[gf];c=c[hf];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new L("argument-error",gf+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
typeof c||"string"===typeof c&&!c.length))throw new L("argument-error",hf+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new L("argument-error",ff+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new L("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new L("argument-error",ef+" property must be a non null object when specified.");this.f=null;if((b=a[jf])&&"object"===
typeof b)if(b=b[kf],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new L("argument-error",kf+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new L("argument-error",jf+" property must be a non null object when specified.");b=a[lf];if("undefined"!==typeof b&&"boolean"!==typeof b)throw new L("argument-error",lf+" property must be a boolean when specified.");this.c=!!b;a=a[mf];if("undefined"!==typeof a&&("string"!==typeof a||"string"===
typeof a&&!a.length))throw new L("argument-error",mf+" property must be a non empty string when specified.");this.i=a||null}var ef="android",mf="dynamicLinkDomain",lf="handleCodeInApp",jf="iOS",df="url",gf="installApp",hf="minimumVersion",ff="packageName",kf="bundleId";
function nf(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;b.dynamicLinkDomain=a.i;for(var c in b)null===b[c]&&delete b[c];return b};function of(a){return Ca(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var pf=null,qf=null;function rf(a){var b="";sf(a,function(a){b+=String.fromCharCode(a)});return b}function sf(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=qf[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}tf();for(var d=0;;){var e=c(-1),f=c(0),h=c(64),m=c(64);if(64===m&&-1===e)break;b(e<<2|f>>4);64!=h&&(b(f<<4&240|h>>2),64!=m&&b(h<<6&192|m))}}
function tf(){if(!pf){pf={};qf={};for(var a=0;65>a;a++)pf[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),qf[pf[a]]=a,62<=a&&(qf["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};function uf(a){this.c=a.sub;oa();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null;this.b=!!a.is_anonymous||"anonymous"==this.a}uf.prototype.f=function(){return this.b};function vf(a){return(a=wf(a))&&a.sub&&a.iss&&a.aud&&a.exp?new uf(a):null}function wf(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{return JSON.parse(rf(a))}catch(d){}return null};var xf={$c:{ab:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",ib:"https://securetoken.googleapis.com/v1/token",id:"p"},bd:{ab:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",ib:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},cd:{ab:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",ib:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
function yf(a){for(var b in xf)if(xf[b].id===a)return a=xf[b],{firebaseEndpoint:a.ab,secureTokenEndpoint:a.ib};return null}var zf;zf=yf("__EID__")?"__EID__":void 0;var Af="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Bf=["client_id","response_type","scope","redirect_uri","state"],Cf={Vc:{Ma:"locale",Ba:500,Aa:600,Na:"facebook.com",hb:Bf},Xc:{Ma:null,Ba:500,Aa:620,Na:"github.com",hb:Bf},Yc:{Ma:"hl",Ba:515,Aa:680,Na:"google.com",hb:Bf},dd:{Ma:"lang",Ba:485,Aa:705,Na:"twitter.com",hb:Af}};function Df(a){for(var b in Cf)if(Cf[b].Na==a)return Cf[b];return null};function Ef(a){var b={};b["facebook.com"]=Ff;b["google.com"]=Gf;b["github.com"]=Hf;b["twitter.com"]=If;var c=a&&a[Jf];try{if(c)return b[c]?new b[c](a):new Kf(a);if("undefined"!==typeof a[Lf])return new Mf(a)}catch(d){}return null}var Lf="idToken",Jf="providerId";
function Mf(a){var b=a[Jf];if(!b&&a[Lf]){var c=vf(a[Lf]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);J(this,"providerId",b);J(this,"isNewUser",c)}function Kf(a){Mf.call(this,a);a=ze(a.rawUserInfo||"{}");J(this,"profile",Qe(a||{}))}t(Kf,Mf);
function Ff(a){Kf.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Ff,Kf);function Hf(a){Kf.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");J(this,"username",this.profile&&this.profile.login||null)}t(Hf,Kf);function Gf(a){Kf.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Gf,Kf);
function If(a){Kf.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");J(this,"username",a.screenName||null)}t(If,Kf);function Nf(a){this.a=dd(a)};function Of(a){var b=dd(a),c=cd(b,"link"),d=cd(dd(c),"link");b=cd(b,"deep_link_id");return cd(dd(b),"link")||b||d||c||a};function Pf(a,b){return a.then(function(a){if(a[M]){var c=vf(a[M]);if(!c||b!=c.c)throw new L("user-mismatch");return a}throw new L("user-mismatch");}).s(function(a){throw a&&a.code&&a.code==$e+"user-not-found"?new L("user-mismatch"):a;})}function Qf(a,b){if(b)this.a=b;else throw new L("internal-error","failed to construct a credential");J(this,"providerId",a);J(this,"signInMethod",a)}Qf.prototype.la=function(a){return Rf(a,Sf(this))};
Qf.prototype.b=function(a,b){var c=Sf(this);c.idToken=b;return Tf(a,c)};Qf.prototype.f=function(a,b){return Pf(Uf(a,Sf(this)),b)};function Sf(a){return{pendingToken:a.a,requestUri:"http://localhost"}}Qf.prototype.C=function(){return{providerId:this.providerId,signInMethod:this.signInMethod,pendingToken:this.a}};
function Vf(a,b,c){this.a=null;if(b.idToken||b.accessToken)b.idToken&&J(this,"idToken",b.idToken),b.accessToken&&J(this,"accessToken",b.accessToken),b.nonce&&!b.pendingToken&&J(this,"nonce",b.nonce),b.pendingToken&&(this.a=b.pendingToken);else if(b.oauthToken&&b.oauthTokenSecret)J(this,"accessToken",b.oauthToken),J(this,"secret",b.oauthTokenSecret);else throw new L("internal-error","failed to construct a credential");J(this,"providerId",a);J(this,"signInMethod",c)}
Vf.prototype.la=function(a){return Rf(a,Wf(this))};Vf.prototype.b=function(a,b){var c=Wf(this);c.idToken=b;return Tf(a,c)};Vf.prototype.f=function(a,b){var c=Wf(this);return Pf(Uf(a,c),b)};
function Wf(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;a.nonce&&!a.a&&(b.nonce=a.nonce);b={postBody:hd(b).toString(),requestUri:"http://localhost"};a.a&&(delete b.postBody,b.pendingToken=a.a);return b}
Vf.prototype.C=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);this.nonce&&(a.nonce=this.nonce);this.a&&(a.pendingToken=this.a);return a};function Xf(a,b){this.Dc=b||[];K(this,{providerId:a,isOAuthProvider:!0});this.yb={};this.cb=(Df(a)||{}).Ma||null;this.$a=null}Xf.prototype.Da=function(a){this.yb=$a(a);return this};
function Yf(a){if("string"!==typeof a||0!=a.indexOf("saml."))throw new L("argument-error",'SAML provider IDs must be prefixed with "saml."');Xf.call(this,a,[])}t(Yf,Xf);function N(a){Xf.call(this,a,Bf);this.a=[]}t(N,Xf);N.prototype.ua=function(a){Ga(this.a,a)||this.a.push(a);return this};N.prototype.Eb=function(){return Ja(this.a)};
N.prototype.credential=function(a,b,c){if(!a&&!b)throw new L("argument-error","credential failed: must provide the ID token and/or the access token.");return new Vf(this.providerId,{idToken:a||null,accessToken:b||null,nonce:c||null},this.providerId)};function Zf(){N.call(this,"facebook.com")}t(Zf,N);J(Zf,"PROVIDER_ID","facebook.com");J(Zf,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
function $f(a){if(!a)throw new L("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new Zf).credential(null,b)}function ag(){N.call(this,"github.com")}t(ag,N);J(ag,"PROVIDER_ID","github.com");J(ag,"GITHUB_SIGN_IN_METHOD","github.com");function bg(a){if(!a)throw new L("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new ag).credential(null,b)}
function cg(){N.call(this,"google.com");this.ua("profile")}t(cg,N);J(cg,"PROVIDER_ID","google.com");J(cg,"GOOGLE_SIGN_IN_METHOD","google.com");function dg(a,b){var c=a;q(a)&&(c=a.idToken,b=a.accessToken);return(new cg).credential(c,b)}function eg(){Xf.call(this,"twitter.com",Af)}t(eg,Xf);J(eg,"PROVIDER_ID","twitter.com");J(eg,"TWITTER_SIGN_IN_METHOD","twitter.com");
function fg(a,b){var c=a;q(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new L("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Vf("twitter.com",c,"twitter.com")}function gg(a,b,c){this.a=a;this.c=b;J(this,"providerId","password");J(this,"signInMethod",c===O.EMAIL_LINK_SIGN_IN_METHOD?O.EMAIL_LINK_SIGN_IN_METHOD:O.EMAIL_PASSWORD_SIGN_IN_METHOD)}
gg.prototype.la=function(a){return this.signInMethod==O.EMAIL_LINK_SIGN_IN_METHOD?P(a,hg,{email:this.a,oobCode:this.c}):P(a,ig,{email:this.a,password:this.c})};gg.prototype.b=function(a,b){return this.signInMethod==O.EMAIL_LINK_SIGN_IN_METHOD?P(a,jg,{idToken:b,email:this.a,oobCode:this.c}):P(a,kg,{idToken:b,email:this.a,password:this.c})};gg.prototype.f=function(a,b){return Pf(this.la(a),b)};gg.prototype.C=function(){return{email:this.a,password:this.c,signInMethod:this.signInMethod}};
function O(){K(this,{providerId:"password",isOAuthProvider:!1})}function lg(a,b){b=mg(b);if(!b)throw new L("argument-error","Invalid email link!");return new gg(a,b,O.EMAIL_LINK_SIGN_IN_METHOD)}function mg(a){a=Of(a);a=new Nf(a);var b=cd(a.a,"oobCode")||null;return"signIn"===(cd(a.a,"mode")||null)&&b?b:null}K(O,{PROVIDER_ID:"password"});K(O,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});K(O,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});
function ng(a){if(!(a.Ta&&a.Sa||a.Fa&&a.$))throw new L("internal-error");this.a=a;J(this,"providerId","phone");J(this,"signInMethod","phone")}ng.prototype.la=function(a){return a.Ua(og(this))};ng.prototype.b=function(a,b){var c=og(this);c.idToken=b;return P(a,pg,c)};ng.prototype.f=function(a,b){var c=og(this);c.operation="REAUTH";a=P(a,qg,c);return Pf(a,b)};
ng.prototype.C=function(){var a={providerId:"phone"};this.a.Ta&&(a.verificationId=this.a.Ta);this.a.Sa&&(a.verificationCode=this.a.Sa);this.a.Fa&&(a.temporaryProof=this.a.Fa);this.a.$&&(a.phoneNumber=this.a.$);return a};function og(a){return a.a.Fa&&a.a.$?{temporaryProof:a.a.Fa,phoneNumber:a.a.$}:{sessionInfo:a.a.Ta,code:a.a.Sa}}
function rg(a){try{this.a=a||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth()}catch(b){throw new L("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}K(this,{providerId:"phone",isOAuthProvider:!1})}
rg.prototype.Ua=function(a,b){var c=this.a.b;return B(b.verify()).then(function(d){if(!l(d))throw new L("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return sg(c,{phoneNumber:a,recaptchaToken:d}).then(function(a){"function"===typeof b.reset&&b.reset();return a},function(a){"function"===typeof b.reset&&b.reset();throw a;});default:throw new L("argument-error",
'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function tg(a,b){if(!a)throw new L("missing-verification-id");if(!b)throw new L("missing-verification-code");return new ng({Ta:a,Sa:b})}K(rg,{PROVIDER_ID:"phone"});K(rg,{PHONE_SIGN_IN_METHOD:"phone"});
function ug(a){if(a.temporaryProof&&a.phoneNumber)return new ng({Fa:a.temporaryProof,$:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret,e=a&&a.nonce,f=a&&a.oauthIdToken,h=a&&a.pendingToken;try{switch(b){case "google.com":return dg(f,c);case "facebook.com":return $f(c);case "github.com":return bg(c);case "twitter.com":return fg(c,d);default:return c||d||f||h?h?0==b.indexOf("saml.")?new Qf(b,h):new Vf(b,{pendingToken:h,idToken:a.oauthIdToken,
accessToken:a.oauthAccessToken},b):(new N(b)).credential(f,c,e):null}}catch(m){return null}}function vg(a){if(!a.isOAuthProvider)throw new L("invalid-oauth-provider");};function wg(a,b,c,d,e,f){this.b=a;this.c=b||null;this.f=c||null;this.g=d||null;this.h=f||null;this.a=e||null;if(this.f||this.a){if(this.f&&this.a)throw new L("invalid-auth-event");if(this.f&&!this.g)throw new L("invalid-auth-event");}else throw new L("invalid-auth-event");}wg.prototype.C=function(){return{type:this.b,eventId:this.c,urlResponse:this.f,sessionId:this.g,postBody:this.h,error:this.a&&this.a.C()}};
function xg(a){a=a||{};return a.type?new wg(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&bf(a.error),a.postBody):null};/*

 Copyright 2018 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function yg(){this.b=null;this.a=[]}var zg=null;yg.prototype.subscribe=function(a){var b=this;this.a.push(a);this.b||(this.b=function(a){for(var c=0;c<b.a.length;c++)b.a[c](a)},a=I("universalLinks.subscribe",k),"function"===typeof a&&a(null,this.b))};yg.prototype.unsubscribe=function(a){w(this.a,function(b){return b==a})};function Ag(a){var b="unauthorized-domain",c=void 0,d=dd(a);a=d.b;d=d.c;"chrome-extension"==d?c=Ka("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=Ka("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
L.call(this,b,c)}t(Ag,L);function Bg(a,b,c){L.call(this,a,c);a=b||{};a.zb&&J(this,"email",a.zb);a.$&&J(this,"phoneNumber",a.$);a.credential&&J(this,"credential",a.credential)}t(Bg,L);Bg.prototype.C=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.C();b&&bb(a,b);return a};Bg.prototype.toJSON=function(){return this.C()};
function Cg(a){if(a.code){var b=a.code||"";0==b.indexOf($e)&&(b=b.substring($e.length));var c={credential:ug(a)};if(a.email)c.zb=a.email;else if(a.phoneNumber)c.$=a.phoneNumber;else if(!c.credential)return new L(b,a.message||void 0);return new Bg(b,c,a.message)}return null};function Dg(){}Dg.prototype.c=null;function Eg(a){return a.c||(a.c=a.b())};var Fg;function Gg(){}t(Gg,Dg);Gg.prototype.a=function(){var a=Hg(this);return a?new ActiveXObject(a):new XMLHttpRequest};Gg.prototype.b=function(){var a={};Hg(this)&&(a[0]=!0,a[1]=!0);return a};
function Hg(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}Fg=new Gg;function Ig(){}t(Ig,Dg);Ig.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Jg;throw Error("Unsupported browser");};Ig.prototype.b=function(){return{}};
function Jg(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText="";this.a.onload=r(this.ec,this);this.a.onerror=r(this.Fb,this);this.a.onprogress=r(this.fc,this);this.a.ontimeout=r(this.ic,this)}g=Jg.prototype;g.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
g.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};g.abort=function(){this.a.abort()};g.setRequestHeader=function(){};g.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};g.ec=function(){this.status=200;this.responseText=this.a.responseText;Kg(this,4)};g.Fb=function(){this.status=500;this.responseText="";Kg(this,4)};g.ic=function(){this.Fb()};
g.fc=function(){this.status=200;Kg(this,1)};function Kg(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}g.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function Lg(a,b,c){this.reset(a,b,c,void 0,void 0)}Lg.prototype.a=null;var Mg=0;Lg.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Mg++;d||oa();delete this.a};function Ng(a){this.f=a;this.b=this.c=this.a=null}function Og(a,b){this.name=a;this.value=b}Og.prototype.toString=function(){return this.name};var Pg=new Og("SEVERE",1E3),Qg=new Og("WARNING",900),Rg=new Og("CONFIG",700),Sg=new Og("FINE",500);function Tg(a){if(a.c)return a.c;if(a.a)return Tg(a.a);sa("Root logger has no level set.");return null}Ng.prototype.log=function(a,b,c){if(a.value>=Tg(this).value)for(n(b)&&(b=b()),a=new Lg(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var Ug={},Vg=null;
function Wg(a){Vg||(Vg=new Ng(""),Ug[""]=Vg,Vg.c=Rg);var b;if(!(b=Ug[a])){b=new Ng(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Wg(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;Ug[a]=b}return b};function Xg(a,b){a&&a.log(Sg,b,void 0)};function Yg(a){this.f=a}t(Yg,Dg);Yg.prototype.a=function(){return new Zg(this.f)};Yg.prototype.b=function(a){return function(){return a}}({});function Zg(a){F.call(this);this.i=a;this.readyState=$g;this.status=0;this.responseText=this.statusText="";this.onreadystatechange=null;this.g=new Headers;this.b=null;this.h="GET";this.c="";this.a=!1;this.f=Wg("goog.net.FetchXmlHttp")}t(Zg,F);var $g=0;g=Zg.prototype;
g.open=function(a,b){if(this.readyState!=$g)throw this.abort(),Error("Error reopening a connection");this.h=a;this.c=b;this.readyState=1;ah(this)};g.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.g,method:this.h,credentials:void 0,cache:void 0};a&&(b.body=a);this.i.fetch(new Request(this.c,b)).then(this.hc.bind(this),this.Gb.bind(this))};
g.abort=function(){this.responseText="";this.g=new Headers;this.status=0;1<=this.readyState&&this.a&&4!=this.readyState&&(this.readyState=4,this.a=!1,ah(this));this.readyState=$g};g.hc=function(a){this.a&&(this.b||(this.b=a.headers,this.readyState=2,ah(this)),this.a&&(this.readyState=3,ah(this),this.a&&a.text().then(this.gc.bind(this,a),this.Gb.bind(this))))};g.gc=function(a,b){this.a&&(this.status=a.status,this.statusText=a.statusText,this.responseText=b,this.readyState=4,ah(this))};
g.Gb=function(a){var b=this.f;b&&b.log(Qg,"Failed to fetch url "+this.c,a instanceof Error?a:Error(a));this.a&&(this.readyState=4,ah(this))};g.setRequestHeader=function(a,b){this.g.append(a,b)};g.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.f)&&a.log(Qg,"Attempting to get response header but no headers have been received for url: "+this.c,void 0),"")};
g.getAllResponseHeaders=function(){if(!this.b){var a=this.f;a&&a.log(Qg,"Attempting to get all response headers but no headers have been received for url: "+this.c,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function ah(a){a.onreadystatechange&&a.onreadystatechange.call(a)};function bh(a){F.call(this);this.headers=new Lc;this.D=a||null;this.c=!1;this.w=this.a=null;this.h=this.N=this.m="";this.f=this.I=this.i=this.G=!1;this.g=0;this.u=null;this.o=ch;this.v=this.O=!1}t(bh,F);var ch="";bh.prototype.b=Wg("goog.net.XhrIo");var dh=/^https?$/i,eh=["POST","PUT"];
function fh(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.m+"; newUri="+b);c=c?c.toUpperCase():"GET";a.m=b;a.h="";a.N=c;a.G=!1;a.c=!0;a.a=a.D?a.D.a():Fg.a();a.w=a.D?Eg(a.D):Eg(Fg);a.a.onreadystatechange=r(a.Jb,a);try{Xg(a.b,gh(a,"Opening Xhr")),a.I=!0,a.a.open(c,String(b),!0),a.I=!1}catch(h){Xg(a.b,gh(a,"Error opening Xhr: "+h.message));hh(a,h);return}b=d||"";var f=new Lc(a.headers);e&&Kc(e,function(a,b){f.set(b,a)});e=Ea(f.U());d=k.FormData&&b instanceof
k.FormData;!Ga(eh,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(a,b){this.a.setRequestHeader(b,a)},a);a.o&&(a.a.responseType=a.o);"withCredentials"in a.a&&a.a.withCredentials!==a.O&&(a.a.withCredentials=a.O);try{ih(a),0<a.g&&(a.v=jh(a.a),Xg(a.b,gh(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.v)),a.v?(a.a.timeout=a.g,a.a.ontimeout=r(a.Ga,a)):a.u=Gc(a.Ga,a.g,a)),Xg(a.b,gh(a,"Sending request")),a.i=!0,a.a.send(b),a.i=!1}catch(h){Xg(a.b,
gh(a,"Send error: "+h.message)),hh(a,h)}}function jh(a){return Pb&&Zb(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function Fa(a){return"content-type"==a.toLowerCase()}g=bh.prototype;g.Ga=function(){"undefined"!=typeof aa&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",Xg(this.b,gh(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function hh(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;kh(a);lh(a)}
function kh(a){a.G||(a.G=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}g.abort=function(){this.a&&this.c&&(Xg(this.b,gh(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),lh(this))};g.va=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),lh(this,!0));bh.ob.va.call(this)};g.Jb=function(){this.qa||(this.I||this.i||this.f?mh(this):this.wc())};g.wc=function(){mh(this)};
function mh(a){if(a.c&&"undefined"!=typeof aa)if(a.w[1]&&4==nh(a)&&2==oh(a))Xg(a.b,gh(a,"Local request error detected and ignored"));else if(a.i&&4==nh(a))Gc(a.Jb,0,a);else if(a.dispatchEvent("readystatechange"),4==nh(a)){Xg(a.b,gh(a,"Request complete"));a.c=!1;try{var b=oh(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.m).match(Oc)[1]||null;if(!f&&k.self&&k.self.location){var h=k.self.location.protocol;
f=h.substr(0,h.length-1)}e=!dh.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var m=2<nh(a)?a.a.statusText:""}catch(p){Xg(a.b,"Can not get status: "+p.message),m=""}a.h=m+" ["+oh(a)+"]";kh(a)}}finally{lh(a)}}}function lh(a,b){if(a.a){ih(a);var c=a.a,d=a.w[0]?ca:null;a.a=null;a.w=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(Pg,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
function ih(a){a.a&&a.v&&(a.a.ontimeout=null);a.u&&(k.clearTimeout(a.u),a.u=null)}function nh(a){return a.a?a.a.readyState:0}function oh(a){try{return 2<nh(a)?a.a.status:-1}catch(b){return-1}}function ph(a){try{return a.a?a.a.responseText:""}catch(b){return Xg(a.b,"Can not get responseText: "+b.message),""}}
g.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.o){case ch:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(Pg,"Response type "+this.o+" is not supported on this browser",void 0);return null}catch(b){return Xg(this.b,"Can not get response: "+b.message),null}};function gh(a,b){return b+" ["+a.N+" "+a.m+" "+oh(a)+"]"};/*
 Portions of this code are from MochiKit, received by
 The Closure Authors under the MIT license. All other code is Copyright
 2005-2009 The Closure Authors. All Rights Reserved.
*/
function qh(a,b){this.g=[];this.v=a;this.u=b||null;this.f=this.a=!1;this.c=void 0;this.m=this.w=this.i=!1;this.h=0;this.b=null;this.l=0}qh.prototype.cancel=function(a){if(this.a)this.c instanceof qh&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.l--,0>=b.l&&b.cancel())}this.v?this.v.call(this.u,this):this.m=!0;this.a||(a=new rh(this),sh(this),th(this,!1,a))}};qh.prototype.o=function(a,b){this.i=!1;th(this,a,b)};function th(a,b,c){a.a=!0;a.c=c;a.f=!b;uh(a)}
function sh(a){if(a.a){if(!a.m)throw new vh(a);a.m=!1}}qh.prototype.D=function(){sh(this);th(this,!0,null)};function wh(a,b){xh(a,null,b,void 0)}function xh(a,b,c,d){a.g.push([b,c,d]);a.a&&uh(a)}qh.prototype.then=function(a,b,c){var d,e,f=new A(function(a,b){d=a;e=b});xh(this,d,function(a){a instanceof rh?f.cancel():e(a)});return f.then(a,b,c)};pa(qh);function yh(a){return Da(a.g,function(a){return n(a[1])})}
function uh(a){if(a.h&&a.a&&yh(a)){var b=a.h,c=zh[b];c&&(k.clearTimeout(c.a),delete zh[b]);a.h=0}a.b&&(a.b.l--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],h=e[1];e=e[2];if(f=a.f?h:f)try{var m=f.call(e||a.u,b);void 0!==m&&(a.f=a.f&&(m==b||m instanceof Error),a.c=b=m);if(qa(b)||"function"===typeof k.Promise&&b instanceof k.Promise)d=!0,a.i=!0}catch(p){b=p,a.f=!0,yh(a)||(c=!0)}}a.c=b;d&&(m=r(a.o,a,!0),d=r(a.o,a,!1),b instanceof qh?(xh(b,m,d),b.w=!0):b.then(m,d));c&&(b=
new Ah(b),zh[b.a]=b,a.h=b.a)}function vh(){u.call(this)}t(vh,u);vh.prototype.message="Deferred has already fired";vh.prototype.name="AlreadyCalledError";function rh(){u.call(this)}t(rh,u);rh.prototype.message="Deferred was canceled";rh.prototype.name="CanceledError";function Ah(a){this.a=k.setTimeout(r(this.c,this),0);this.b=a}Ah.prototype.c=function(){delete zh[this.a];throw this.b;};var zh={};function Bh(a){var b={},c=b.document||document,d=td(a),e=document.createElement("SCRIPT"),f={Lb:e,Ga:void 0},h=new qh(Ch,f),m=null,p=null!=b.timeout?b.timeout:5E3;0<p&&(m=window.setTimeout(function(){Dh(e,!0);var a=new Eh(Fh,"Timeout reached for loading script "+d);sh(h);th(h,!1,a)},p),f.Ga=m);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Dh(e,b.fd||!1,m),h.D())};e.onerror=function(){Dh(e,!0,m);var a=new Eh(Gh,"Error while loading script "+
d);sh(h);th(h,!1,a)};f=b.attributes||{};bb(f,{type:"text/javascript",charset:"UTF-8"});Jd(e,f);e.src=td(a);Hh(c).appendChild(e);return h}function Hh(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function Ch(){if(this&&this.Lb){var a=this.Lb;a&&"SCRIPT"==a.tagName&&Dh(a,!0,this.Ga)}}
function Dh(a,b,c){null!=c&&k.clearTimeout(c);a.onload=ca;a.onerror=ca;a.onreadystatechange=ca;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var Gh=0,Fh=1;function Eh(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a}t(Eh,u);function Ih(a){this.f=a}t(Ih,Dg);Ih.prototype.a=function(){return new this.f};Ih.prototype.b=function(){return{}};
function Jh(a,b,c){this.b=a;a=b||{};this.i=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.l=a.secureTokenTimeout||Kh;this.f=$a(a.secureTokenHeaders||Lh);this.g=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h=a.firebaseTimeout||Mh;this.a=$a(a.firebaseHeaders||Nh);c&&(this.a["X-Client-Version"]=c,this.f["X-Client-Version"]=c);c="Node"==ne();c=k.XMLHttpRequest||c&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.XMLHttpRequest;if(!c&&
!me())throw new L("internal-error","The XMLHttpRequest compatibility library was not found.");this.c=void 0;me()?this.c=new Yg(self):oe()?this.c=new Ih(c):this.c=new Ig}var Oh,M="idToken",Kh=new Ce(3E4,6E4),Lh={"Content-Type":"application/x-www-form-urlencoded"},Mh=new Ce(3E4,6E4),Nh={"Content-Type":"application/json"};function Ph(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
function Qh(a,b){b?(a.a["X-Client-Version"]=b,a.f["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.f["X-Client-Version"])}function Rh(a,b,c,d,e,f,h){Yd()||me()?a=r(a.o,a):(Oh||(Oh=new A(function(a,b){Sh(a,b)})),a=r(a.m,a));a(b,c,d,e,f,h)}
Jh.prototype.o=function(a,b,c,d,e,f){if(me()&&("undefined"===typeof k.fetch||"undefined"===typeof k.Headers||"undefined"===typeof k.Request))throw new L("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var h=new bh(this.c);if(f){h.g=Math.max(0,f);var m=setTimeout(function(){h.dispatchEvent("timeout")},f)}uc(h,"complete",function(){m&&clearTimeout(m);var a=null;try{a=
JSON.parse(ph(this))||null}catch(x){a=null}b&&b(a)});Ac(h,"ready",function(){m&&clearTimeout(m);Kb(this)});Ac(h,"timeout",function(){m&&clearTimeout(m);Kb(this);b&&b(null)});fh(h,a,c,d,e)};var Th=qd("https://apis.google.com/js/client.js?onload=%{onload}"),Uh="__fcb"+Math.floor(1E6*Math.random()).toString();
function Sh(a,b){if(((window.gapi||{}).client||{}).request)a();else{k[Uh]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=ud(Th,{onload:Uh});wh(Bh(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
Jh.prototype.m=function(a,b,c,d,e){var f=this;Oh.then(function(){window.gapi.client.setApiKey(f.b);var h=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(h);b&&b(a)}})}).s(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
function Vh(a,b){return new A(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Rh(a,a.i+"?key="+encodeURIComponent(a.b),function(a){a?a.error?d(Wh(a)):a.access_token&&a.refresh_token?c(a):d(new L("internal-error")):d(new L("network-request-failed"))},"POST",hd(b).toString(),a.f,a.l.get()):d(new L("internal-error"))})}
function Xh(a,b,c,d,e,f){var h=dd(a.g+b);G(h,"key",a.b);f&&G(h,"cb",oa().toString());var m="GET"==c;if(m)for(var p in d)d.hasOwnProperty(p)&&G(h,p,d[p]);return new A(function(b,f){Rh(a,h.toString(),function(a){a?a.error?f(Wh(a,e||{})):b(a):f(new L("network-request-failed"))},c,m?void 0:Od(ye(d)),a.a,a.h.get())})}function Yh(a){a=a.email;if(!l(a)||!ge.test(a))throw new L("invalid-email");}function Zh(a){"email"in a&&Yh(a)}
function $h(a,b){return P(a,ai,{identifier:b,continueUri:ve()?Vd():"http://localhost"}).then(function(a){return a.allProviders||[]})}function bi(a,b){return P(a,ai,{identifier:b,continueUri:ve()?Vd():"http://localhost"}).then(function(a){return a.signinMethods||[]})}function ci(a){return P(a,di,{}).then(function(a){return a.authorizedDomains||[]})}function ei(a){if(!a[M])throw new L("internal-error");}
function fi(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new L("internal-error");}else{if(!a.sessionInfo)throw new L("missing-verification-id");if(!a.code)throw new L("missing-verification-code");}}Jh.prototype.Qa=function(){return P(this,gi,{})};Jh.prototype.pb=function(a,b){return P(this,hi,{idToken:a,email:b})};Jh.prototype.qb=function(a,b){return P(this,kg,{idToken:a,password:b})};var ii={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};g=Jh.prototype;
g.rb=function(a,b){var c={idToken:a},d=[];Ya(ii,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return P(this,hi,c)};g.kb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};bb(a,b);return P(this,ji,a)};g.lb=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};bb(a,b);return P(this,ki,a)};g.jb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};bb(a,b);return P(this,li,a)};function sg(a,b){return P(a,mi,b)}g.Ua=function(a){return P(this,ni,a)};
function oi(a,b,c){return P(a,pi,{idToken:b,deleteProvider:c})}function qi(a){if(!a.requestUri||!a.sessionId&&!a.postBody&&!a.pendingToken)throw new L("internal-error");}function ri(a,b){b.oauthIdToken&&b.providerId&&0==b.providerId.indexOf("oidc.")&&!b.pendingToken&&(a.sessionId?b.nonce=a.sessionId:a.postBody&&(a=new Tc(a.postBody),ld(a,"nonce")&&(b.nonce=a.get("nonce"))));return b}
function si(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=Cg(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=Cg(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=Cg(a)):a.errorMessage&&(b=ti(a.errorMessage));if(b)throw b;if(!a[M])throw new L("internal-error");}function Rf(a,b){b.returnIdpCredential=!0;return P(a,ui,b)}function Tf(a,b){b.returnIdpCredential=!0;return P(a,vi,b)}
function Uf(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return P(a,wi,b)}function xi(a){if(!a.oobCode)throw new L("invalid-action-code");}g.Za=function(a,b){return P(this,yi,{oobCode:a,newPassword:b})};g.Ja=function(a){return P(this,zi,{oobCode:a})};g.Wa=function(a){return P(this,Ai,{oobCode:a})};
var Ai={endpoint:"setAccountInfo",B:xi,da:"email"},zi={endpoint:"resetPassword",B:xi,J:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b)throw new L("internal-error");}},Bi={endpoint:"signupNewUser",B:function(a){Yh(a);if(!a.password)throw new L("weak-password");},J:ei,R:!0},ai={endpoint:"createAuthUri"},Ci={endpoint:"deleteAccount",T:["idToken"]},pi={endpoint:"setAccountInfo",T:["idToken","deleteProvider"],B:function(a){if(!fa(a.deleteProvider))throw new L("internal-error");}},hg=
{endpoint:"emailLinkSignin",T:["email","oobCode"],B:Yh,J:ei,R:!0},jg={endpoint:"emailLinkSignin",T:["idToken","email","oobCode"],B:Yh,J:ei,R:!0},Di={endpoint:"getAccountInfo"},ki={endpoint:"getOobConfirmationCode",T:["requestType"],B:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new L("internal-error");Yh(a)},da:"email"},li={endpoint:"getOobConfirmationCode",T:["idToken","requestType"],B:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new L("internal-error");},da:"email"},ji={endpoint:"getOobConfirmationCode",
T:["requestType"],B:function(a){if("PASSWORD_RESET"!=a.requestType)throw new L("internal-error");Yh(a)},da:"email"},di={ub:!0,endpoint:"getProjectConfig",Ib:"GET"},Ei={ub:!0,endpoint:"getRecaptchaParam",Ib:"GET",J:function(a){if(!a.recaptchaSiteKey)throw new L("internal-error");}},yi={endpoint:"resetPassword",B:xi,da:"email"},mi={endpoint:"sendVerificationCode",T:["phoneNumber","recaptchaToken"],da:"sessionInfo"},hi={endpoint:"setAccountInfo",T:["idToken"],B:Zh,R:!0},kg={endpoint:"setAccountInfo",
T:["idToken"],B:function(a){Zh(a);if(!a.password)throw new L("weak-password");},J:ei,R:!0},gi={endpoint:"signupNewUser",J:ei,R:!0},ui={endpoint:"verifyAssertion",B:qi,Oa:ri,J:si,R:!0},wi={endpoint:"verifyAssertion",B:qi,Oa:ri,J:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new L("user-not-found");if(a.errorMessage)throw ti(a.errorMessage);if(!a[M])throw new L("internal-error");},R:!0},vi={endpoint:"verifyAssertion",B:function(a){qi(a);if(!a.idToken)throw new L("internal-error");
},Oa:ri,J:si,R:!0},Fi={endpoint:"verifyCustomToken",B:function(a){if(!a.token)throw new L("invalid-custom-token");},J:ei,R:!0},ig={endpoint:"verifyPassword",B:function(a){Yh(a);if(!a.password)throw new L("wrong-password");},J:ei,R:!0},ni={endpoint:"verifyPhoneNumber",B:fi,J:ei},pg={endpoint:"verifyPhoneNumber",B:function(a){if(!a.idToken)throw new L("internal-error");fi(a)},J:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",Cg(a);ei(a)}},qg={Xb:{USER_NOT_FOUND:"user-not-found"},
endpoint:"verifyPhoneNumber",B:fi,J:ei};function P(a,b,c){if(!Pe(c,b.T))return C(new L("internal-error"));var d=b.Ib||"POST",e;return B(c).then(b.B).then(function(){b.R&&(c.returnSecureToken=!0);return Xh(a,b.endpoint,d,c,b.Xb,b.ub||!1)}).then(function(a){e=a;return b.Oa?b.Oa(c,e):e}).then(b.J).then(function(){if(!b.da)return e;if(!(b.da in e))throw new L("internal-error");return e[b.da]})}function ti(a){return Wh({error:{errors:[{message:a}],code:400,message:a}})}
function Wh(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new L(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",INVALID_PENDING_TOKEN:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",MISSING_OR_INVALID_NONCE:"missing-or-invalid-nonce",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",RESET_PASSWORD_EXCEED_LIMIT:"too-many-requests",
EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",INVALID_PROVIDER_ID:"invalid-provider-id",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",
OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",
QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",REJECTED_CREDENTIAL:"rejected-credential",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_DYNAMIC_LINK_DOMAIN:"invalid-dynamic-link-domain",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash"};bb(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?
b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new L(d[e],b);!b&&a&&(b=xe(a));return new L("internal-error",b)};function Gi(a){this.b=a;this.a=null;this.fb=Hi(this)}
function Hi(a){return Ii().then(function(){return new A(function(b,c){I("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:I("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},Ji.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
function Ki(a,b){return a.fb.then(function(){return new A(function(c){a.a.send(b.type,b,c,I("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Li(a,b){a.fb.then(function(){a.a.register("authEvent",b,I("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Mi=qd("https://apis.google.com/js/api.js?onload=%{onload}"),Ni=new Ce(3E4,6E4),Ji=new Ce(5E3,15E3),Oi=null;
function Ii(){return Oi?Oi:Oi=(new A(function(a,b){function c(){Be();I("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Be();b(Error("Network Error"))},timeout:Ni.get()})}if(I("gapi.iframes.Iframe"))a();else if(I("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();k[d]=function(){I("gapi.load")?c():b(Error("Network Error"))};d=ud(Mi,{onload:d});B(Bh(d)).s(function(){b(Error("Network Error"))})}})).s(function(a){Oi=null;throw a;})};function Pi(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=ed(this.i,"/__/auth/iframe");G(this.a,"apiKey",this.g);G(this.a,"appName",this.h);this.b=null;this.c=[]}Pi.prototype.toString=function(){this.f?G(this.a,"v",this.f):kd(this.a.a,"v");this.b?G(this.a,"eid",this.b):kd(this.a.a,"eid");this.c.length?G(this.a,"fw",this.c.join(",")):kd(this.a.a,"fw");return this.a.toString()};function Qi(a,b,c,d,e){this.o=a;this.m=b;this.c=c;this.l=d;this.h=this.g=this.i=null;this.a=e;this.f=null}
Qi.prototype.toString=function(){var a=ed(this.o,"/__/auth/handler");G(a,"apiKey",this.m);G(a,"appName",this.c);G(a,"authType",this.l);if(this.a.isOAuthProvider){var b=this.a;try{var c=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(this.c).auth().ea()}catch(m){c=null}b.$a=c;G(a,"providerId",this.a.providerId);b=this.a;c=ye(b.yb);for(var d in c)c[d]=c[d].toString();d=b.Dc;c=$a(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.cb&&b.$a&&!c[b.cb]&&(c[b.cb]=b.$a);Za(c)||G(a,"customParameters",xe(c))}"function"===typeof this.a.Eb&&
(b=this.a.Eb(),b.length&&G(a,"scopes",b.join(",")));this.i?G(a,"redirectUrl",this.i):kd(a.a,"redirectUrl");this.g?G(a,"eventId",this.g):kd(a.a,"eventId");this.h?G(a,"v",this.h):kd(a.a,"v");if(this.b)for(var h in this.b)this.b.hasOwnProperty(h)&&!cd(a,h)&&G(a,h,this.b[h]);this.f?G(a,"eid",this.f):kd(a.a,"eid");h=Ri(this.c);h.length&&G(a,"fw",h.join(","));return a.toString()};function Ri(a){try{return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a).auth().ya()}catch(b){return[]}}
function Si(a,b,c,d,e){this.m=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.o=this.u=this.v=null;this.g=[];this.l=this.a=null}
function Ti(a){var b=Vd();return ci(a).then(function(a){a:{var c=dd(b),e=c.c;c=c.b;for(var f=0;f<a.length;f++){var h=a[f];var m=c;var p=e;0==h.indexOf("chrome-extension://")?m=dd(h).b==m&&"chrome-extension"==p:"http"!=p&&"https"!=p?m=!1:fe.test(h)?m=m==h:(h=h.split(".").join("\\."),m=(new RegExp("^(.+\\."+h+"|"+h+")$","i")).test(m));if(m){a=!0;break a}}a=!1}if(!a)throw new Ag(Vd());})}
function Ui(a){if(a.l)return a.l;a.l=he().then(function(){if(!a.u){var b=a.c,c=a.h,d=Ri(a.b),e=new Pi(a.m,a.f,a.b);e.f=b;e.b=c;e.c=Ja(d||[]);a.u=e.toString()}a.i=new Gi(a.u);Vi(a)});return a.l}g=Si.prototype;g.Ea=function(a,b,c){var d=new L("popup-closed-by-user"),e=new L("web-storage-unsupported"),f=this,h=!1;return this.ga().then(function(){Wi(f).then(function(c){c||(a&&be(a),b(e),h=!0)})}).s(function(){}).then(function(){if(!h)return ee(a)}).then(function(){if(!h)return Hc(c).then(function(){b(d)})})};
g.Mb=function(){var a=H();return!we(a)&&!Ae(a)};g.Hb=function(){return!1};
g.Cb=function(a,b,c,d,e,f,h){if(!a)return C(new L("popup-blocked"));if(h&&!we())return this.ga().s(function(b){be(a);e(b)}),d(),B();this.a||(this.a=Ti(Xi(this)));var m=this;return this.a.then(function(){var b=m.ga().s(function(b){be(a);e(b);throw b;});d();return b}).then(function(){vg(c);if(!h){var d=Yi(m.m,m.f,m.b,b,c,null,f,m.c,void 0,m.h);Wd(d,a)}}).s(function(a){"auth/network-request-failed"==a.code&&(m.a=null);throw a;})};
function Xi(a){a.o||(a.v=a.c?re(a.c,Ri(a.b)):null,a.o=new Jh(a.f,yf(a.h),a.v));return a.o}g.Ca=function(a,b,c){this.a||(this.a=Ti(Xi(this)));var d=this;return this.a.then(function(){vg(b);var e=Yi(d.m,d.f,d.b,a,b,Vd(),c,d.c,void 0,d.h);Wd(e)}).s(function(a){"auth/network-request-failed"==a.code&&(d.a=null);throw a;})};g.ga=function(){var a=this;return Ui(this).then(function(){return a.i.fb}).s(function(){a.a=null;throw new L("network-request-failed");})};g.Qb=function(){return!0};
function Yi(a,b,c,d,e,f,h,m,p,x){a=new Qi(a,b,c,d,e);a.i=f;a.g=h;a.h=m;a.b=$a(p||null);a.f=x;return a.toString()}function Vi(a){if(!a.i)throw Error("IfcHandler must be initialized!");Li(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=xg(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return B(c)}c.status="ERROR";return B(c)})}
function Wi(a){var b={type:"webStorageSupport"};return Ui(a).then(function(){return Ki(a.i,b)}).then(function(a){if(a&&a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})}g.wa=function(a){this.g.push(a)};g.Ka=function(a){w(this.g,function(b){return b==a})};function Zi(a){this.a=a||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new L("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}g=Zi.prototype;g.get=function(a){return B(this.a.getItem(a)).then(function(a){return a&&ze(a)})};g.set=function(a,b){return B(this.a.setItem(a,xe(b)))};g.P=function(a){return B(this.a.removeItem(a))};g.Y=function(){};g.ca=function(){};function $i(a){this.b=a;this.a={};this.c=r(this.f,this)}var aj=[];function bj(){var a=me()?self:null;v(aj,function(c){c.b==a&&(b=c)});if(!b){var b=new $i(a);aj.push(b)}return b}
$i.prototype.f=function(a){var b=a.data.eventType,c=a.data.eventId,d=this.a[b];if(d&&0<d.length){a.ports[0].postMessage({status:"ack",eventId:c,eventType:b,response:null});var e=[];v(d,function(b){e.push(B().then(function(){return b(a.origin,a.data.data)}))});wb(e).then(function(d){var e=[];v(d,function(a){e.push({fulfilled:a.Db,value:a.value,reason:a.reason?a.reason.message:void 0})});v(e,function(a){for(var b in a)"undefined"===typeof a[b]&&delete a[b]});a.ports[0].postMessage({status:"done",eventId:c,
eventType:b,response:e})})}};$i.prototype.subscribe=function(a,b){Za(this.a)&&this.b.addEventListener("message",this.c);"undefined"===typeof this.a[a]&&(this.a[a]=[]);this.a[a].push(b)};$i.prototype.unsubscribe=function(a,b){"undefined"!==typeof this.a[a]&&b?(w(this.a[a],function(a){return a==b}),0==this.a[a].length&&delete this.a[a]):b||delete this.a[a];Za(this.a)&&this.b.removeEventListener("message",this.c)};function cj(a){this.a=a}cj.prototype.postMessage=function(a,b){this.a.postMessage(a,b)};function dj(a){this.c=a;this.b=!1;this.a=[]}
function ej(a,b,c,d){var e,f=c||{},h,m,p,x=null;if(a.b)return C(Error("connection_unavailable"));var gb=d?800:50,la="undefined"!==typeof MessageChannel?new MessageChannel:null;return(new A(function(c,d){la?(e=Math.floor(Math.random()*Math.pow(10,20)).toString(),la.port1.start(),m=setTimeout(function(){d(Error("unsupported_event"))},gb),h=function(a){a.data.eventId===e&&("ack"===a.data.status?(clearTimeout(m),p=setTimeout(function(){d(Error("timeout"))},3E3)):"done"===a.data.status?(clearTimeout(p),
"undefined"!==typeof a.data.response?c(a.data.response):d(Error("unknown_error"))):(clearTimeout(m),clearTimeout(p),d(Error("invalid_response"))))},x={messageChannel:la,onMessage:h},a.a.push(x),la.port1.addEventListener("message",h),a.c.postMessage({eventType:b,eventId:e,data:f},[la.port2])):d(Error("connection_unavailable"))})).then(function(b){fj(a,x);return b}).s(function(b){fj(a,x);throw b;})}
function fj(a,b){if(b){var c=b.messageChannel,d=b.onMessage;c&&(c.port1.removeEventListener("message",d),c.port1.close());w(a.a,function(a){return a==b})}}dj.prototype.close=function(){for(;0<this.a.length;)fj(this,this.a[0]);this.b=!0};function gj(){if(!hj())throw new L("web-storage-unsupported");this.c={};this.a=[];this.b=0;this.m=k.indexedDB;this.type="indexedDB";this.g=this.l=this.f=this.i=null;this.u=!1;this.h=null;var a=this;me()&&self?(this.l=bj(),this.l.subscribe("keyChanged",function(b,c){return ij(a).then(function(b){0<b.length&&v(a.a,function(a){a(b)});return{keyProcessed:Ga(b,c.key)}})}),this.l.subscribe("ping",function(){return B(["keyChanged"])})):Ie().then(function(b){if(a.h=b)a.g=new dj(new cj(b)),ej(a.g,"ping",null,
!0).then(function(b){b[0].fulfilled&&Ga(b[0].value,"keyChanged")&&(a.u=!0)}).s(function(){})})}var jj;function kj(a){return new A(function(b,c){var d=a.m.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(a){c(Error(a.target.error))}})}
function lj(a){return new A(function(b,c){var d=a.m.open("firebaseLocalStorageDb",1);d.onerror=function(a){try{a.preventDefault()}catch(f){}c(Error(a.target.error))};d.onupgradeneeded=function(a){a=a.target.result;try{a.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(d){d=d.target.result;d.objectStoreNames.contains("firebaseLocalStorage")?b(d):kj(a).then(function(){return lj(a)}).then(function(a){b(a)}).s(function(a){c(a)})}})}
function mj(a){a.o||(a.o=lj(a));return a.o}function hj(){try{return!!k.indexedDB}catch(a){return!1}}function nj(a){return a.objectStore("firebaseLocalStorage")}function oj(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}function pj(a){return new A(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(a.target.error)}})}g=gj.prototype;
g.set=function(a,b){var c=!1,d,e=this;return mj(this).then(function(b){d=b;b=nj(oj(d,!0));return pj(b.get(a))}).then(function(f){var h=nj(oj(d,!0));if(f)return f.value=b,pj(h.put(f));e.b++;c=!0;f={};f.fbase_key=a;f.value=b;return pj(h.add(f))}).then(function(){e.c[a]=b;return qj(e,a)}).ia(function(){c&&e.b--})};function qj(a,b){return a.g&&a.h&&He()===a.h?ej(a.g,"keyChanged",{key:b},a.u).then(function(){}).s(function(){}):B()}
g.get=function(a){return mj(this).then(function(b){return pj(nj(oj(b,!1)).get(a))}).then(function(a){return a&&a.value})};g.P=function(a){var b=!1,c=this;return mj(this).then(function(d){b=!0;c.b++;return pj(nj(oj(d,!0))["delete"](a))}).then(function(){delete c.c[a];return qj(c,a)}).ia(function(){b&&c.b--})};
function ij(a){return mj(a).then(function(a){var b=nj(oj(a,!1));return b.getAll?pj(b.getAll()):new A(function(a,c){var d=[],e=b.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){c(a.target.error)}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=Xd(a.c,c);a.c=c}return d})}g.Y=function(a){0==this.a.length&&rj(this);this.a.push(a)};
g.ca=function(a){w(this.a,function(b){return b==a});0==this.a.length&&sj(this)};function rj(a){function b(){a.f=setTimeout(function(){a.i=ij(a).then(function(b){0<b.length&&v(a.a,function(a){a(b)})}).then(function(){b()}).s(function(a){"STOP_EVENT"!=a.message&&b()})},800)}sj(a);b()}function sj(a){a.i&&a.i.cancel("STOP_EVENT");a.f&&(clearTimeout(a.f),a.f=null)};function tj(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=B().then(function(){if(hj()){var a=te(),e="__sak"+a;jj||(jj=new gj);c=jj;return c.set(e,a).then(function(){return c.get(e)}).then(function(b){if(b!==a)throw Error("indexedDB not supported!");return c.P(e)}).then(function(){return c}).s(function(){return b.c})}return b.c}).then(function(a){b.type=a.type;a.Y(function(a){v(b.a,function(b){b(a)})});return a})}g=tj.prototype;g.get=function(a){return this.b.then(function(b){return b.get(a)})};
g.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};g.P=function(a){return this.b.then(function(b){return b.P(a)})};g.Y=function(a){this.a.push(a)};g.ca=function(a){w(this.a,function(b){return b==a})};function uj(){this.a={};this.type="inMemory"}g=uj.prototype;g.get=function(a){return B(this.a[a])};g.set=function(a,b){this.a[a]=b;return B()};g.P=function(a){delete this.a[a];return B()};g.Y=function(){};g.ca=function(){};function vj(){if(!wj()){if("Node"==ne())throw new L("internal-error","The LocalStorage compatibility library was not found.");throw new L("web-storage-unsupported");}this.a=xj()||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;this.type="localStorage"}function xj(){try{var a=k.localStorage,b=te();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function wj(){var a="Node"==ne();a=xj()||a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}g=vj.prototype;g.get=function(a){var b=this;return B().then(function(){var c=b.a.getItem(a);return ze(c)})};g.set=function(a,b){var c=this;return B().then(function(){var d=xe(b);null===d?c.P(a):c.a.setItem(a,d)})};g.P=function(a){var b=this;return B().then(function(){b.a.removeItem(a)})};
g.Y=function(a){k.window&&rc(k.window,"storage",a)};g.ca=function(a){k.window&&E(k.window,"storage",a)};function yj(){this.type="nullStorage"}g=yj.prototype;g.get=function(){return B(null)};g.set=function(){return B()};g.P=function(){return B()};g.Y=function(){};g.ca=function(){};function zj(){if(!Aj()){if("Node"==ne())throw new L("internal-error","The SessionStorage compatibility library was not found.");throw new L("web-storage-unsupported");}this.a=Bj()||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function Bj(){try{var a=k.sessionStorage,b=te();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function Aj(){var a="Node"==ne();a=Bj()||a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}g=zj.prototype;g.get=function(a){var b=this;return B().then(function(){var c=b.a.getItem(a);return ze(c)})};g.set=function(a,b){var c=this;return B().then(function(){var d=xe(b);null===d?c.P(a):c.a.setItem(a,d)})};g.P=function(a){var b=this;return B().then(function(){b.a.removeItem(a)})};g.Y=function(){};
g.ca=function(){};function Cj(){var a={};a.Browser=Dj;a.Node=Ej;a.ReactNative=Fj;a.Worker=Gj;this.a=a[ne()]}var Hj,Dj={A:vj,Ra:zj},Ej={A:vj,Ra:zj},Fj={A:Zi,Ra:yj},Gj={A:vj,Ra:yj};var Ij={Zc:"local",NONE:"none",ad:"session"};function Jj(a){var b=new L("invalid-persistence-type"),c=new L("unsupported-persistence-type");a:{for(d in Ij)if(Ij[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(ne()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!se()&&"none"!==a)throw c;}}
function Kj(){var a=!Ae(H())&&le()?!0:!1,b=we(),c=se();this.o=a;this.h=b;this.l=c;this.a={};Hj||(Hj=new Cj);a=Hj;try{this.g=!Ud()&&Ge()||!k.indexedDB?new a.a.A:new tj(me()?new uj:new a.a.A)}catch(d){this.g=new uj,this.h=!0}try{this.i=new a.a.Ra}catch(d){this.i=new uj}this.m=new uj;this.f=r(this.Pb,this);this.b={}}var Lj;function Mj(){Lj||(Lj=new Kj);return Lj}function Nj(a,b){switch(b){case "session":return a.i;case "none":return a.m;default:return a.g}}
function Oj(a,b){return"firebase:"+a.name+(b?":"+b:"")}function Pj(a,b,c){var d=Oj(b,c),e=Nj(a,b.A);return a.get(b,c).then(function(f){var h=null;try{h=ze(k.localStorage.getItem(d))}catch(m){}if(h&&!f)return k.localStorage.removeItem(d),a.set(b,h,c);h&&f&&"localStorage"!=e.type&&k.localStorage.removeItem(d)})}g=Kj.prototype;g.get=function(a,b){return Nj(this,a.A).get(Oj(a,b))};function Qj(a,b,c){c=Oj(b,c);"local"==b.A&&(a.b[c]=null);return Nj(a,b.A).P(c)}
g.set=function(a,b,c){var d=Oj(a,c),e=this,f=Nj(this,a.A);return f.set(d,b).then(function(){return f.get(d)}).then(function(b){"local"==a.A&&(e.b[d]=b)})};g.addListener=function(a,b,c){a=Oj(a,b);this.l&&(this.b[a]=k.localStorage.getItem(a));Za(this.a)&&(Nj(this,"local").Y(this.f),this.h||(Ud()||!Ge())&&k.indexedDB||!this.l||Rj(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
g.removeListener=function(a,b,c){a=Oj(a,b);this.a[a]&&(w(this.a[a],function(a){return a==c}),0==this.a[a].length&&delete this.a[a]);Za(this.a)&&(Nj(this,"local").ca(this.f),Sj(this))};function Rj(a){Sj(a);a.c=setInterval(function(){for(var b in a.a){var c=k.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new fc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Pb(c))}},1E3)}function Sj(a){a.c&&(clearInterval(a.c),a.c=null)}
g.Pb=function(a){if(a&&a.f){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=k.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.Xa(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?Nj(this,"local").ca(this.f):Sj(this);if(this.o)if(c=k.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?k.localStorage.setItem(b,d):k.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
typeof a.a.a||f.b[b]!==k.localStorage.getItem(b))f.b[b]=k.localStorage.getItem(b),f.Xa(b)};Pb&&$b&&10==$b&&k.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else v(a,r(this.Xa,this))};g.Xa=function(a){this.a[a]&&v(this.a[a],function(a){a()})};function Tj(a){this.a=a;this.b=Mj()}var Uj={name:"authEvent",A:"local"};function Vj(a){return a.b.get(Uj,a.a).then(function(a){return xg(a)})};function Wj(){this.a=Mj()};function Xj(){this.b=-1};function Yj(a,b){this.b=Zj;this.f=k.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.l=k.Int32Array?new Int32Array(64):Array(64);void 0!==ak||(k.Int32Array?ak=new Int32Array(bk):ak=bk);this.reset()}var ak;t(Yj,Xj);for(var Zj=64,ck=Zj-1,dk=[],ek=0;ek<ck;ek++)dk[ek]=0;var fk=Ia(128,dk);Yj.prototype.reset=function(){this.g=this.c=0;this.a=k.Int32Array?new Int32Array(this.h):Ja(this.h)};
function gk(a){for(var b=a.f,c=a.l,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,h=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+h|0}d=a.a[0]|0;e=a.a[1]|0;var m=a.a[2]|0,p=a.a[3]|0,x=a.a[4]|0,gb=a.a[5]|0,la=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var Rl=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&m^e&m)|0;h=x&gb^~x&la;f=f+((x>>>6|x<<26)^(x>>>11|x<<21)^(x>>>
25|x<<7))|0;h=h+(ak[b]|0)|0;h=f+(h+(c[b]|0)|0)|0;f=la;la=gb;gb=x;x=p+h|0;p=m;m=e;e=d;d=h+Rl|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+m|0;a.a[3]=a.a[3]+p|0;a.a[4]=a.a[4]+x|0;a.a[5]=a.a[5]+gb|0;a.a[6]=a.a[6]+la|0;a.a[7]=a.a[7]+f|0}
function hk(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(l(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(gk(a),e=0);else if(ha(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(gk(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
var bk=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function ik(){Yj.call(this,8,jk)}t(ik,Yj);var jk=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function kk(a,b,c,d,e){this.m=a;this.i=b;this.l=c;this.o=d||null;this.u=e||null;this.h=b+":"+c;this.v=new Wj;this.g=new Tj(this.h);this.f=null;this.b=[];this.a=this.c=null}function lk(a){return new L("invalid-cordova-configuration",a)}g=kk.prototype;
g.ga=function(){return this.za?this.za:this.za=ie().then(function(){if("function"!==typeof I("universalLinks.subscribe",k))throw lk("cordova-universal-links-plugin-fix is not installed");if("undefined"===typeof I("BuildInfo.packageName",k))throw lk("cordova-plugin-buildinfo is not installed");if("function"!==typeof I("cordova.plugins.browsertab.openUrl",k))throw lk("cordova-plugin-browsertab is not installed");if("function"!==typeof I("cordova.InAppBrowser.open",k))throw lk("cordova-plugin-inappbrowser is not installed");
},function(){throw new L("cordova-not-ready");})};function mk(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function nk(a){var b=new ik;hk(b,a);a=[];var c=8*b.g;56>b.c?hk(b,fk,56-b.c):hk(b,fk,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;gk(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return of(a)}
g.Ea=function(a,b){b(new L("operation-not-supported-in-this-environment"));return B()};g.Cb=function(){return C(new L("operation-not-supported-in-this-environment"))};g.Qb=function(){return!1};g.Mb=function(){return!0};g.Hb=function(){return!0};
g.Ca=function(a,b,c){if(this.c)return C(new L("redirect-operation-pending"));var d=this,e=k.document,f=null,h=null,m=null,p=null;return this.c=B().then(function(){vg(b);return ok(d)}).then(function(){return pk(d,a,b,c)}).then(function(){return(new A(function(a,b){h=function(){var b=I("cordova.plugins.browsertab.close",k);a();"function"===typeof b&&b();d.a&&"function"===typeof d.a.close&&(d.a.close(),d.a=null);return!1};d.wa(h);m=function(){f||(f=Hc(2E3).then(function(){b(new L("redirect-cancelled-by-user"))}))};
p=function(){De()&&m()};e.addEventListener("resume",m,!1);H().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",p,!1)})).s(function(a){return qk(d).then(function(){throw a;})})}).ia(function(){m&&e.removeEventListener("resume",m,!1);p&&e.removeEventListener("visibilitychange",p,!1);f&&f.cancel();h&&d.Ka(h);d.c=null})};
function pk(a,b,c,d){var e=mk(),f=new wg(b,d,null,e,new L("no-auth-event")),h=I("BuildInfo.packageName",k);if("string"!==typeof h)throw new L("invalid-cordova-configuration");var m=I("BuildInfo.displayName",k),p={};if(H().toLowerCase().match(/iphone|ipad|ipod/))p.ibi=h;else if(H().toLowerCase().match(/android/))p.apn=h;else return C(new L("operation-not-supported-in-this-environment"));m&&(p.appDisplayName=m);e=nk(e);p.sessionId=e;var x=Yi(a.m,a.i,a.l,b,c,null,d,a.o,p,a.u);return a.ga().then(function(){var b=
a.h;return a.v.a.set(Uj,f.C(),b)}).then(function(){var b=I("cordova.plugins.browsertab.isAvailable",k);if("function"!==typeof b)throw new L("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=I("cordova.plugins.browsertab.openUrl",k);if("function"!==typeof c)throw new L("invalid-cordova-configuration");c(x)}else{c=I("cordova.InAppBrowser.open",k);if("function"!==typeof c)throw new L("invalid-cordova-configuration");b=H();b=!(!b.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!b.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
a.a=c(x,b?"_blank":"_system","location=yes")}})})}function rk(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function ok(a){a.f||(a.f=a.ga().then(function(){return new A(function(b){function c(d){b(d);a.Ka(c);return!1}a.wa(c);sk(a)})}));return a.f}function qk(a){var b=null;return Vj(a.g).then(function(c){b=c;c=a.g;return Qj(c.b,Uj,c.a)}).then(function(){return b})}
function sk(a){function b(b){d=!0;e&&e.cancel();qk(a).then(function(d){var e=c;if(d&&b&&b.url){var f=null;e=Of(b.url);-1!=e.indexOf("/__/auth/callback")&&(f=dd(e),f=ze(cd(f,"firebaseError")||null),f=(f="object"===typeof f?bf(f):null)?new wg(d.b,d.c,null,null,f):new wg(d.b,d.c,e,d.g));e=f||c}rk(a,e)})}var c=new wg("unknown",null,null,null,new L("no-auth-event")),d=!1,e=Hc(500).then(function(){return qk(a).then(function(){d||rk(a,c)})}),f=k.handleOpenURL;k.handleOpenURL=function(a){0==a.toLowerCase().indexOf(I("BuildInfo.packageName",
k).toLowerCase()+"://")&&b({url:a});if("function"===typeof f)try{f(a)}catch(m){console.error(m)}};zg||(zg=new yg);zg.subscribe(b)}g.wa=function(a){this.b.push(a);ok(this).s(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new wg("unknown",null,null,null,new L("no-auth-event")),a(b))})};g.Ka=function(a){w(this.b,function(b){return b==a})};function tk(a){this.a=a;this.b=Mj()}var uk={name:"pendingRedirect",A:"session"};function vk(a){return a.b.set(uk,"pending",a.a)}function wk(a){return Qj(a.b,uk,a.a)}function xk(a){return a.b.get(uk,a.a).then(function(a){return"pending"==a})};function yk(a,b,c){this.u=a;this.l=b;this.m=c;this.h=[];this.f=!1;this.i=r(this.bb,this);this.b=new zk;this.o=new Ak;this.g=new tk(this.l+":"+this.m);this.c={};this.c.unknown=this.b;this.c.signInViaRedirect=this.b;this.c.linkViaRedirect=this.b;this.c.reauthViaRedirect=this.b;this.c.signInViaPopup=this.o;this.c.linkViaPopup=this.o;this.c.reauthViaPopup=this.o;this.a=Bk(this.u,this.l,this.m,zf)}function Bk(a,b,c,d){var e=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null;return je()?new kk(a,b,c,e,d):new Si(a,b,c,e,d)}g=yk.prototype;
g.reset=function(){this.f=!1;this.a.Ka(this.i);this.a=Bk(this.u,this.l,this.m)};g.Ya=function(){this.b.Ya()};function Ck(a){a.f||(a.f=!0,a.a.wa(a.i));var b=a.a;return a.a.ga().s(function(c){a.a==b&&a.reset();throw c;})}function Dk(a){a.a.Mb()&&Ck(a).s(function(b){var c=new wg("unknown",null,null,null,new L("operation-not-supported-in-this-environment"));Ek(b)&&a.bb(c)});a.a.Hb()||Fk(a.b)}
g.subscribe=function(a){Ga(this.h,a)||this.h.push(a);if(!this.f){var b=this;xk(this.g).then(function(a){a?wk(b.g).then(function(){Ck(b).s(function(a){var c=new wg("unknown",null,null,null,new L("operation-not-supported-in-this-environment"));Ek(a)&&b.bb(c)})}):Dk(b)}).s(function(){Dk(b)})}};g.unsubscribe=function(a){w(this.h,function(b){return b==a})};
g.bb=function(a){if(!a)throw new L("invalid-auth-event");for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.vb(a.b,a.c)){(b=this.c[a.b])&&b.h(a,d);b=!0;break}}Fk(this.b);return b};var Gk=new Ce(2E3,1E4),Hk=new Ce(3E4,6E4);yk.prototype.fa=function(){return this.b.fa()};function Ik(a,b,c,d,e,f){return a.a.Cb(b,c,d,function(){a.f||(a.f=!0,a.a.wa(a.i))},function(){a.reset()},e,f)}function Ek(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
yk.prototype.Ca=function(a,b,c){var d=this,e;return vk(this.g).then(function(){return d.a.Ca(a,b,c).s(function(a){if(Ek(a))throw new L("operation-not-supported-in-this-environment");e=a;return wk(d.g).then(function(){throw e;})}).then(function(){return d.a.Qb()?new A(function(){}):wk(d.g).then(function(){return d.fa()}).then(function(){}).s(function(){})})})};yk.prototype.Ea=function(a,b,c,d){return this.a.Ea(c,function(c){a.ha(b,null,c,d)},Gk.get())};var Jk={};
function Kk(a,b,c){var d=b+":"+c;Jk[d]||(Jk[d]=new yk(a,b,c));return Jk[d]}function zk(){this.b=null;this.f=[];this.c=[];this.a=null;this.i=this.g=!1}zk.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
zk.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.b,d=a.c,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;this.i=!(!e&&!f);"unknown"!=c||e||f?a.a?(Lk(this,!0,null,a.a),B()):b.xa(c,d)?Mk(this,a,b):C(new L("invalid-auth-event")):(Lk(this,!1,null,null),B())}else C(new L("invalid-auth-event"))};function Fk(a){a.g||(a.g=!0,Lk(a,!1,null,null))}zk.prototype.Ya=function(){this.g&&!this.i&&Lk(this,!1,null,null)};
function Mk(a,b,c){c=c.xa(b.b,b.c);var d=b.f,e=b.g,f=b.h,h=!!b.b.match(/Redirect$/);c(d,e,f).then(function(b){Lk(a,h,b,null)}).s(function(b){Lk(a,h,null,b)})}function Nk(a,b){a.b=function(){return C(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function Ok(a,b){a.b=function(){return B(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function Lk(a,b,c,d){b?d?Nk(a,d):Ok(a,c):Ok(a,{user:null});a.f=[];a.c=[]}
zk.prototype.fa=function(){var a=this;return new A(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),Pk(a))})};function Pk(a){var b=new L("timeout");a.a&&a.a.cancel();a.a=Hc(Hk.get()).then(function(){a.b||(a.g=!0,Lk(a,!0,null,b))})}function Ak(){}Ak.prototype.h=function(a,b){if(a){var c=a.b,d=a.c;a.a?(b.ha(a.b,null,a.a,a.c),B()):b.xa(c,d)?Qk(a,b):C(new L("invalid-auth-event"))}else C(new L("invalid-auth-event"))};
function Qk(a,b){var c=a.c,d=a.b;b.xa(d,c)(a.f,a.g,a.h).then(function(a){b.ha(d,a,null,c)}).s(function(a){b.ha(d,null,a,c)})};function Rk(){this.sb=!1;Object.defineProperty(this,"appVerificationDisabled",{get:function(){return this.sb},set:function(a){this.sb=a},enumerable:!1})};function Sk(a,b){this.a=b;J(this,"verificationId",a)}Sk.prototype.confirm=function(a){a=tg(this.verificationId,a);return this.a(a)};function Tk(a,b,c,d){return(new rg(a)).Ua(b,c).then(function(a){return new Sk(a,d)})};function Uk(a){var b=wf(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new L("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");K(this,{token:a,expirationTime:Fe(1E3*b.exp),authTime:Fe(1E3*b.auth_time),issuedAtTime:Fe(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,claims:b})};function Vk(a,b,c){this.h=a;this.i=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}Vk.prototype.start=function(){this.a=this.c;Wk(this,!0)};function Xk(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function Wk(a,b){a.stop();a.b=Hc(Xk(a,b)).then(function(){return Ee()}).then(function(){return a.h()}).then(function(){Wk(a,!0)}).s(function(b){a.i(b)&&Wk(a,!1)})}
Vk.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function Yk(a){this.f=a;this.b=this.a=null;this.c=0}Yk.prototype.C=function(){return{apiKey:this.f.b,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function Zk(a,b){var c=b[M],d=b.refreshToken;b=$k(b.expiresIn);a.b=c;a.c=b;a.a=d}function al(a,b){a.b=b.b;a.a=b.a;a.c=b.c}function $k(a){return oa()+1E3*parseInt(a,10)}
function bl(a,b){return Vh(a.f,b).then(function(b){a.b=b.access_token;a.c=$k(b.expires_in);a.a=b.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).s(function(b){"auth/user-token-expired"==b.code&&(a.a=null);throw b;})}Yk.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?C(new L("user-token-expired")):a||!this.b||oa()>this.c-3E4?this.a?bl(this,{grant_type:"refresh_token",refresh_token:this.a}):B(null):B({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function cl(a,b){this.a=a||null;this.b=b||null;K(this,{lastSignInTime:Fe(b||null),creationTime:Fe(a||null)})}function dl(a){return new cl(a.a,a.b)}cl.prototype.C=function(){return{lastLoginAt:this.b,createdAt:this.a}};function el(a,b,c,d,e,f){K(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function fl(a,b){D.call(this,a);for(var c in b)this[c]=b[c]}t(fl,D);
function Q(a,b,c){this.G=[];this.m=a.apiKey;this.o=a.appName;this.u=a.authDomain||null;a=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?re(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION):null;this.b=new Jh(this.m,yf(zf),a);this.h=new Yk(this.b);gl(this,b[M]);Zk(this.h,b);J(this,"refreshToken",this.h.a);hl(this,c||{});F.call(this);this.I=!1;this.u&&ue()&&(this.a=Kk(this.u,this.m,this.o));this.N=[];this.i=null;this.w=il(this);this.V=r(this.Ha,this);var d=this;this.ka=null;this.ta=function(a){d.pa(a.g)};this.X=null;this.O=[];this.sa=function(a){jl(d,
a.c)};this.W=null}t(Q,F);Q.prototype.pa=function(a){this.ka=a;Ph(this.b,a)};Q.prototype.ea=function(){return this.ka};function kl(a,b){a.X&&E(a.X,"languageCodeChanged",a.ta);(a.X=b)&&rc(b,"languageCodeChanged",a.ta)}function jl(a,b){a.O=b;Qh(a.b,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?re(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,a.O):null)}Q.prototype.ya=function(){return Ja(this.O)};function ll(a,b){a.W&&E(a.W,"frameworkChanged",a.sa);(a.W=b)&&rc(b,"frameworkChanged",a.sa)}Q.prototype.Ha=function(){this.w.b&&(this.w.stop(),this.w.start())};
function ml(a){try{return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a.o).auth()}catch(b){throw new L("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.o+"'!");}}function il(a){return new Vk(function(){return a.F(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.h.c-oa()-3E5;return 0<b?b:0})}function nl(a){a.D||a.w.b||(a.w.start(),E(a,"tokenChanged",a.V),rc(a,"tokenChanged",a.V))}function ol(a){E(a,"tokenChanged",a.V);a.w.stop()}
function gl(a,b){a.ra=b;J(a,"_lat",b)}function pl(a,b){w(a.N,function(a){return a==b})}function ql(a){for(var b=[],c=0;c<a.N.length;c++)b.push(a.N[c](a));return wb(b).then(function(){return a})}function rl(a){a.a&&!a.I&&(a.I=!0,a.a.subscribe(a))}
function hl(a,b){K(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,metadata:new cl(b.createdAt,b.lastLoginAt),providerData:[]})}J(Q.prototype,"providerId","firebase");function sl(){}function tl(a){return B().then(function(){if(a.D)throw new L("app-deleted");})}function ul(a){return Ca(a.providerData,function(a){return a.providerId})}
function vl(a,b){b&&(wl(a,b.providerId),a.providerData.push(b))}function wl(a,b){w(a.providerData,function(a){return a.providerId==b})}function xl(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&J(a,b,c)}
function yl(a,b){a!=b&&(K(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,providerData:[]}),b.metadata?J(a,"metadata",dl(b.metadata)):J(a,"metadata",new cl),v(b.providerData,function(b){vl(a,b)}),al(a.h,b.h),J(a,"refreshToken",a.h.a))}g=Q.prototype;g.reload=function(){var a=this;return R(this,tl(this).then(function(){return zl(a).then(function(){return ql(a)}).then(sl)}))};
function zl(a){return a.F().then(function(b){var c=a.isAnonymous;return Al(a,b).then(function(){c||xl(a,"isAnonymous",!1);return b})})}g.dc=function(a){return this.F(a).then(function(a){return new Uk(a)})};g.F=function(a){var b=this;return R(this,tl(this).then(function(){return b.h.getToken(a)}).then(function(a){if(!a)throw new L("internal-error");a.accessToken!=b.ra&&(gl(b,a.accessToken),b.dispatchEvent(new fl("tokenChanged")));xl(b,"refreshToken",a.refreshToken);return a.accessToken}))};
function Bl(a,b){b[M]&&a.ra!=b[M]&&(Zk(a.h,b),a.dispatchEvent(new fl("tokenChanged")),gl(a,b[M]),xl(a,"refreshToken",a.h.a))}function Al(a,b){return P(a.b,Di,{idToken:b}).then(r(a.xc,a))}
g.xc=function(a){a=a.users;if(!a||!a.length)throw new L("internal-error");a=a[0];hl(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt});for(var b=Cl(a),c=0;c<b.length;c++)vl(this,b[c]);xl(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
function Cl(a){return(a=a.providerUserInfo)&&a.length?Ca(a,function(a){return new el(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl,a.phoneNumber)}):[]}g.gb=function(a){var b=this,c=null;return R(this,a.f(this.b,this.uid).then(function(a){Bl(b,a);c=Dl(b,a,"reauthenticate");b.i=null;return b.reload()}).then(function(){return c}),!0)};
g.yc=function(a){Ke("firebase.User.prototype.reauthenticateWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential instead.");return this.gb(a).then(function(){})};function El(a,b){return zl(a).then(function(){if(Ga(ul(a),b))return ql(a).then(function(){throw new L("provider-already-linked");})})}
g.eb=function(a){var b=this,c=null;return R(this,El(this,a.providerId).then(function(){return b.F()}).then(function(c){return a.b(b.b,c)}).then(function(a){c=Dl(b,a,"link");return Fl(b,a)}).then(function(){return c}))};g.pc=function(a){Ke("firebase.User.prototype.linkWithCredential is deprecated. Please use firebase.User.prototype.linkAndRetrieveDataWithCredential instead.");return this.eb(a).then(function(a){return a.user})};
g.qc=function(a,b){var c=this;return R(this,El(this,"phone").then(function(){return Tk(ml(c),a,b,r(c.eb,c))}))};g.zc=function(a,b){var c=this;return R(this,B().then(function(){return Tk(ml(c),a,b,r(c.gb,c))}),!0)};function Dl(a,b,c){var d=ug(b);b=Ef(b);return Ne({user:a,credential:d,additionalUserInfo:b,operationType:c})}function Fl(a,b){Bl(a,b);return a.reload().then(function(){return a})}
g.pb=function(a){var b=this;return R(this,this.F().then(function(c){return b.b.pb(c,a)}).then(function(a){Bl(b,a);return b.reload()}))};g.Rc=function(a){var b=this;return R(this,this.F().then(function(c){return a.b(b.b,c)}).then(function(a){Bl(b,a);return b.reload()}))};g.qb=function(a){var b=this;return R(this,this.F().then(function(c){return b.b.qb(c,a)}).then(function(a){Bl(b,a);return b.reload()}))};
g.rb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return tl(this);var b=this;return R(this,this.F().then(function(c){return b.b.rb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){Bl(b,a);xl(b,"displayName",a.displayName||null);xl(b,"photoURL",a.photoUrl||null);v(b.providerData,function(a){"password"===a.providerId&&(J(a,"displayName",b.displayName),J(a,"photoURL",b.photoURL))});return ql(b)}).then(sl))};
g.Pc=function(a){var b=this;return R(this,zl(this).then(function(c){return Ga(ul(b),a)?oi(b.b,c,[a]).then(function(a){var c={};v(a.providerUserInfo||[],function(a){c[a.providerId]=!0});v(ul(b),function(a){c[a]||wl(b,a)});c[rg.PROVIDER_ID]||J(b,"phoneNumber",null);return ql(b)}):ql(b).then(function(){throw new L("no-such-provider");})}))};
g.delete=function(){var a=this;return R(this,this.F().then(function(b){return P(a.b,Ci,{idToken:b})}).then(function(){a.dispatchEvent(new fl("userDeleted"))})).then(function(){for(var b=0;b<a.G.length;b++)a.G[b].cancel("app-deleted");kl(a,null);ll(a,null);a.G=[];a.D=!0;ol(a);J(a,"refreshToken",null);a.a&&a.a.unsubscribe(a)})};
g.vb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.aa||null)==b||"reauthViaRedirect"==a&&(this.aa||null)==b?!0:!1};g.ha=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};
g.xa=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?r(this.Ab,this):"reauthViaPopup"==a&&b==(this.g||null)?r(this.Bb,this):"linkViaRedirect"==a&&(this.aa||null)==b?r(this.Ab,this):"reauthViaRedirect"==a&&(this.aa||null)==b?r(this.Bb,this):null};g.rc=function(a){var b=this;return Gl(this,"linkViaPopup",a,function(){return El(b,a.providerId).then(function(){return ql(b)})},!1)};g.Ac=function(a){return Gl(this,"reauthViaPopup",a,function(){return B()},!0)};
function Gl(a,b,c,d,e){if(!ue())return C(new L("operation-not-supported-in-this-environment"));if(a.i&&!e)return C(a.i);var f=Df(c.providerId),h=te(a.uid+":::"),m=null;(!we()||le())&&a.u&&c.isOAuthProvider&&(m=Yi(a.u,a.m,a.o,b,c,null,h,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null));var p=ce(m,f&&f.Ba,f&&f.Aa);d=d().then(function(){Hl(a);if(!e)return a.F().then(function(){})}).then(function(){return Ik(a.a,p,b,c,h,!!m)}).then(function(){return new A(function(c,d){a.ha(b,null,new L("cancelled-popup-request"),a.g||null);
a.f=c;a.v=d;a.g=h;a.c=a.a.Ea(a,b,p,h)})}).then(function(a){p&&be(p);return a?Ne(a):null}).s(function(a){p&&be(p);throw a;});return R(a,d,e)}g.sc=function(a){var b=this;return Il(this,"linkViaRedirect",a,function(){return El(b,a.providerId)},!1)};g.Bc=function(a){return Il(this,"reauthViaRedirect",a,function(){return B()},!0)};
function Il(a,b,c,d,e){if(!ue())return C(new L("operation-not-supported-in-this-environment"));if(a.i&&!e)return C(a.i);var f=null,h=te(a.uid+":::");d=d().then(function(){Hl(a);if(!e)return a.F().then(function(){})}).then(function(){a.aa=h;return ql(a)}).then(function(b){a.ba&&(b=a.ba,b=b.b.set(Jl,a.C(),b.a));return b}).then(function(){return a.a.Ca(b,c,h)}).s(function(b){f=b;if(a.ba)return Kl(a.ba);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
function Hl(a){if(!a.a||!a.I){if(a.a&&!a.I)throw new L("internal-error");throw new L("auth-domain-config-required");}}g.Ab=function(a,b,c){var d=this;this.c&&(this.c.cancel(),this.c=null);var e=null,f=this.F().then(function(e){return Tf(d.b,{requestUri:a,postBody:c,sessionId:b,idToken:e})}).then(function(a){e=Dl(d,a,"link");return Fl(d,a)}).then(function(){return e});return R(this,f)};
g.Bb=function(a,b,c){var d=this;this.c&&(this.c.cancel(),this.c=null);var e=null,f=B().then(function(){return Pf(Uf(d.b,{requestUri:a,sessionId:b,postBody:c}),d.uid)}).then(function(a){e=Dl(d,a,"reauthenticate");Bl(d,a);d.i=null;return d.reload()}).then(function(){return e});return R(this,f,!0)};g.jb=function(a){var b=this,c=null;return R(this,this.F().then(function(b){c=b;return"undefined"===typeof a||Za(a)?{}:nf(new cf(a))}).then(function(a){return b.b.jb(c,a)}).then(function(a){if(b.email!=a)return b.reload()}).then(function(){}))};
function R(a,b,c){var d=Ll(a,b,c);a.G.push(d);d.ia(function(){Ha(a.G,d)});return d}function Ll(a,b,c){return a.i&&!c?(b.cancel(),C(a.i)):b.s(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.i||a.dispatchEvent(new fl("userInvalidated")),a.i=b);throw b;})}g.toJSON=function(){return this.C()};
g.C=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.m,appName:this.o,authDomain:this.u,stsTokenManager:this.h.C(),redirectEventId:this.aa||null};this.metadata&&bb(a,this.metadata.C());v(this.providerData,function(b){a.providerData.push(Oe(b))});return a};
function Ml(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[M]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-oa())/1E3;else return null;var d=new Q(b,c,a);a.providerData&&v(a.providerData,function(a){a&&vl(d,Ne(a))});a.redirectEventId&&(d.aa=a.redirectEventId);return d}
function Nl(a,b,c,d){var e=new Q(a,b);c&&(e.ba=c);d&&jl(e,d);return e.reload().then(function(){return e})}function Ol(a,b,c,d){b=b||{apiKey:a.m,authDomain:a.u,appName:a.o};var e=a.h,f={};f[M]=e.b;f.refreshToken=e.a;f.expiresIn=(e.c-oa())/1E3;b=new Q(b,f);c&&(b.ba=c);d&&jl(b,d);yl(b,a);return b};function Pl(a){this.a=a;this.b=Mj()}var Jl={name:"redirectUser",A:"session"};function Kl(a){return Qj(a.b,Jl,a.a)}function Ql(a,b){return a.b.get(Jl,a.a).then(function(a){a&&b&&(a.authDomain=b);return Ml(a||{})})};function Sl(a){this.a=a;this.b=Mj();this.c=null;this.f=Tl(this);this.b.addListener(Ul("local"),this.a,r(this.g,this))}Sl.prototype.g=function(){var a=this,b=Ul("local");Vl(this,function(){return B().then(function(){return a.c&&"local"!=a.c.A?a.b.get(b,a.a):null}).then(function(c){if(c)return Wl(a,"local").then(function(){a.c=b})})})};function Wl(a,b){var c=[],d;for(d in Ij)Ij[d]!==b&&c.push(Qj(a.b,Ul(Ij[d]),a.a));c.push(Qj(a.b,Xl,a.a));return vb(c)}
function Tl(a){var b=Ul("local"),c=Ul("session"),d=Ul("none");return Pj(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(c){return c?d:a.b.get(b,a.a).then(function(c){return c?b:a.b.get(Xl,a.a).then(function(a){return a?Ul(a):b})})})}).then(function(b){a.c=b;return Wl(a,b.A)}).s(function(){a.c||(a.c=b)})}var Xl={name:"persistence",A:"session"};function Ul(a){return{name:"authUser",A:a}}
Sl.prototype.mb=function(a){var b=null,c=this;Jj(a);return Vl(this,function(){return a!=c.c.A?c.b.get(c.c,c.a).then(function(d){b=d;return Wl(c,a)}).then(function(){c.c=Ul(a);if(b)return c.b.set(c.c,b,c.a)}):B()})};function Yl(a){return Vl(a,function(){return a.b.set(Xl,a.c.A,a.a)})}function Zl(a,b){return Vl(a,function(){return a.b.set(a.c,b.C(),a.a)})}function $l(a){return Vl(a,function(){return Qj(a.b,a.c,a.a)})}
function am(a,b){return Vl(a,function(){return a.b.get(a.c,a.a).then(function(a){a&&b&&(a.authDomain=b);return Ml(a||{})})})}function Vl(a,b){a.f=a.f.then(b,b);return a.f};function bm(a){this.m=!1;J(this,"settings",new Rk);J(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?re(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION):null,this.b=new Jh(S(this).options&&S(this).options.apiKey,yf(zf),a);else throw new L("invalid-api-key");this.N=[];this.o=[];this.I=[];this.Tb=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(r(this.mc,this));this.O=void 0;this.Ub=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(r(this.nc,this));cm(this,null);this.h=new Sl(S(this).options.apiKey+":"+S(this).name);this.w=
new Pl(S(this).options.apiKey+":"+S(this).name);this.V=T(this,dm(this));this.i=T(this,em(this));this.X=!1;this.ka=r(this.Mc,this);this.Ha=r(this.Z,this);this.ra=r(this.bc,this);this.sa=r(this.jc,this);this.ta=r(this.kc,this);fm(this);this.INTERNAL={};this.INTERNAL["delete"]=r(this.delete,this);this.INTERNAL.logFramework=r(this.tc,this);this.u=0;F.call(this);gm(this);this.G=[]}t(bm,F);function hm(a){D.call(this,"languageCodeChanged");this.g=a}t(hm,D);
function im(a){D.call(this,"frameworkChanged");this.c=a}t(im,D);g=bm.prototype;g.mb=function(a){a=this.h.mb(a);return T(this,a)};g.pa=function(a){this.W===a||this.m||(this.W=a,Ph(this.b,this.W),this.dispatchEvent(new hm(this.ea())))};g.ea=function(){return this.W};g.Sc=function(){var a=k.navigator;this.pa(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};g.tc=function(a){this.G.push(a);Qh(this.b,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?re(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,this.G):null);this.dispatchEvent(new im(this.G))};
g.ya=function(){return Ja(this.G)};function gm(a){Object.defineProperty(a,"lc",{get:function(){return this.ea()},set:function(a){this.pa(a)},enumerable:!1});a.W=null}g.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).C()}};function jm(a){return a.Sb||C(new L("auth-domain-config-required"))}
function fm(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&ue()&&(a.Sb=a.V.then(function(){if(!a.m){a.a=Kk(b,c,S(a).name);a.a.subscribe(a);U(a)&&rl(U(a));if(a.D){rl(a.D);var d=a.D;d.pa(a.ea());kl(d,a);d=a.D;jl(d,a.G);ll(d,a);a.D=null}return a.a}}))}g.vb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};
g.ha=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};g.xa=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?r(this.ac,this):null};
g.ac=function(a,b,c){var d=this;a={requestUri:a,postBody:c,sessionId:b};this.c&&(this.c.cancel(),this.c=null);var e=null,f=null,h=Rf(d.b,a).then(function(a){e=ug(a);f=Ef(a);return a});a=d.V.then(function(){return h}).then(function(a){return km(d,a)}).then(function(){return Ne({user:U(d),credential:e,additionalUserInfo:f,operationType:"signIn"})});return T(this,a)};
g.Kc=function(a){if(!ue())return C(new L("operation-not-supported-in-this-environment"));var b=this,c=Df(a.providerId),d=te(),e=null;(!we()||le())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Yi(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null));var f=ce(e,c&&c.Ba,c&&c.Aa);c=jm(this).then(function(b){return Ik(b,f,"signInViaPopup",a,d,!!e)}).then(function(){return new A(function(a,c){b.ha("signInViaPopup",null,new L("cancelled-popup-request"),
b.g);b.f=a;b.v=c;b.g=d;b.c=b.a.Ea(b,"signInViaPopup",f,d)})}).then(function(a){f&&be(f);return a?Ne(a):null}).s(function(a){f&&be(f);throw a;});return T(this,c)};g.Lc=function(a){if(!ue())return C(new L("operation-not-supported-in-this-environment"));var b=this,c=jm(this).then(function(){return Yl(b.h)}).then(function(){return b.a.Ca("signInViaRedirect",a)});return T(this,c)};
g.fa=function(){if(!ue())return C(new L("operation-not-supported-in-this-environment"));var a=this,b=jm(this).then(function(){return a.a.fa()}).then(function(a){return a?Ne(a):null});return T(this,b)};
g.Qc=function(a){if(!a)return C(new L("null-user"));var b=this,c={};c.apiKey=S(this).options.apiKey;c.authDomain=S(this).options.authDomain;c.appName=S(this).name;var d=Ol(a,c,b.w,b.ya());return T(this,this.i.then(function(){if(S(b).options.apiKey!=a.m)return d.reload()}).then(function(){if(U(b)&&a.uid==U(b).uid)return yl(U(b),a),b.Z(a);cm(b,d);rl(d);return b.Z(d)}).then(function(){lm(b)}))};
function km(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.V.then(function(){return Nl(c,b,a.w,a.ya())}).then(function(b){if(U(a)&&b.uid==U(a).uid)return yl(U(a),b),a.Z(b);cm(a,b);rl(b);return a.Z(b)}).then(function(){lm(a)})}
function cm(a,b){U(a)&&(pl(U(a),a.Ha),E(U(a),"tokenChanged",a.ra),E(U(a),"userDeleted",a.sa),E(U(a),"userInvalidated",a.ta),ol(U(a)));b&&(b.N.push(a.Ha),rc(b,"tokenChanged",a.ra),rc(b,"userDeleted",a.sa),rc(b,"userInvalidated",a.ta),0<a.u&&nl(b));J(a,"currentUser",b);b&&(b.pa(a.ea()),kl(b,a),jl(b,a.G),ll(b,a))}g.nb=function(){var a=this,b=this.i.then(function(){if(!U(a))return B();cm(a,null);return $l(a.h).then(function(){lm(a)})});return T(this,b)};
function mm(a){var b=Ql(a.w,S(a).options.authDomain).then(function(b){if(a.D=b)b.ba=a.w;return Kl(a.w)});return T(a,b)}function dm(a){var b=S(a).options.authDomain,c=mm(a).then(function(){return am(a.h,b)}).then(function(b){return b?(b.ba=a.w,a.D&&(a.D.aa||null)==(b.aa||null)?b:b.reload().then(function(){return Zl(a.h,b).then(function(){return b})}).s(function(c){return"auth/network-request-failed"==c.code?b:$l(a.h)})):null}).then(function(b){cm(a,b||null)});return T(a,c)}
function em(a){return a.V.then(function(){return a.fa()}).s(function(){}).then(function(){if(!a.m)return a.ka()}).s(function(){}).then(function(){if(!a.m){a.X=!0;var b=a.h;b.b.addListener(Ul("local"),b.a,a.ka)}})}
g.Mc=function(){var a=this;return am(this.h,S(this).options.authDomain).then(function(b){if(!a.m){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return yl(U(a),b),U(a).F();if(U(a)||b)cm(a,b),b&&(rl(b),b.ba=a.w),a.a&&a.a.subscribe(a),lm(a)}})};g.Z=function(a){return Zl(this.h,a)};g.bc=function(){lm(this);this.Z(U(this))};g.jc=function(){this.nb()};g.kc=function(){this.nb()};
function nm(a,b){var c=null,d=null;return T(a,b.then(function(b){c=ug(b);d=Ef(b);return km(a,b)}).then(function(){return Ne({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}g.mc=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};g.nc=function(a){var b=this;om(this,function(){a.next(U(b))})};g.vc=function(a,b,c){var d=this;this.X&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.Promise.resolve().then(function(){n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.Tb(a,b,c)};
g.uc=function(a,b,c){var d=this;this.X&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.Promise.resolve().then(function(){d.O=d.getUid();n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.Ub(a,b,c)};g.cc=function(a){var b=this,c=this.i.then(function(){return U(b)?U(b).F(a).then(function(a){return{accessToken:a}}):null});return T(this,c)};g.Nb=function(a){var b=this;return this.i.then(function(){return nm(b,P(b.b,Fi,{token:a}))}).then(function(a){var c=a.user;xl(c,"isAnonymous",!1);b.Z(c);return a})};
g.Ec=function(a){Ke("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCustomToken is deprecated. Please use firebase.auth.Auth.prototype.signInWithCustomToken instead.");return this.Nb(a)};g.Fc=function(a,b){Ke("firebase.auth.Auth.prototype.signInAndRetrieveDataWithEmailAndPassword is deprecated. Please use firebase.auth.Auth.prototype.signInWithEmailAndPassword instead.");return this.Ob(a,b)};g.Ob=function(a,b){var c=this;return this.i.then(function(){return nm(c,P(c.b,ig,{email:a,password:b}))})};
g.xb=function(a,b){var c=this;return this.i.then(function(){return nm(c,P(c.b,Bi,{email:a,password:b}))})};g.Wb=function(a,b){Ke("firebase.auth.Auth.prototype.createUserAndRetrieveDataWithEmailAndPassword is deprecated. Please use firebase.auth.Auth.prototype.createUserWithEmailAndPassword instead.");return this.xb(a,b)};g.Hc=function(a){Ke("firebase.auth.Auth.prototype.signInWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential instead.");return this.Pa(a).then(function(a){return a.user})};
g.Pa=function(a){var b=this;return this.i.then(function(){return nm(b,a.la(b.b))})};g.Qa=function(){var a=this;return this.i.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=Ne({providerId:null,isNewUser:!1});return Ne({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return nm(a,a.b.Qa()).then(function(b){var c=b.user;xl(c,"isAnonymous",!0);a.Z(c);return b})})};
g.Gc=function(){Ke("firebase.auth.Auth.prototype.signInAnonymouslyAndRetrieveData is deprecated. Please use firebase.auth.Auth.prototype.signInAnonymously instead.");return this.Qa()};function S(a){return a.app}function U(a){return a.currentUser}g.getUid=function(){return U(this)&&U(this).uid||null};function pm(a){return U(a)&&U(a)._lat||null}
function lm(a){if(a.X){for(var b=0;b<a.o.length;b++)if(a.o[b])a.o[b](pm(a));if(a.O!==a.getUid()&&a.I.length)for(a.O=a.getUid(),b=0;b<a.I.length;b++)if(a.I[b])a.I[b](pm(a))}}g.Vb=function(a){this.addAuthTokenListener(a);this.u++;0<this.u&&U(this)&&nl(U(this))};g.Cc=function(a){var b=this;v(this.o,function(c){c==a&&b.u--});0>this.u&&(this.u=0);0==this.u&&U(this)&&ol(U(this));this.removeAuthTokenListener(a)};
g.addAuthTokenListener=function(a){var b=this;this.o.push(a);T(this,this.i.then(function(){b.m||Ga(b.o,a)&&a(pm(b))}))};g.removeAuthTokenListener=function(a){w(this.o,function(b){return b==a})};function om(a,b){a.I.push(b);T(a,a.i.then(function(){!a.m&&Ga(a.I,b)&&a.O!==a.getUid()&&(a.O=a.getUid(),b(pm(a)))}))}
g.delete=function(){this.m=!0;for(var a=0;a<this.N.length;a++)this.N[a].cancel("app-deleted");this.N=[];this.h&&(a=this.h,a.b.removeListener(Ul("local"),a.a,this.ka));this.a&&(this.a.unsubscribe(this),this.a.Ya());return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.Promise.resolve()};function T(a,b){a.N.push(b);b.ia(function(){Ha(a.N,b)});return b}
g.Zb=function(a){Ke("firebase.auth.Auth.prototype.fetchProvidersForEmail is deprecated. Please use firebase.auth.Auth.prototype.fetchSignInMethodsForEmail instead.");return T(this,$h(this.b,a))};g.$b=function(a){return T(this,bi(this.b,a))};g.oc=function(a){return!!mg(a)};g.lb=function(a,b){var c=this;return T(this,B().then(function(){var a=new cf(b);if(!a.c)throw new L("argument-error",lf+" must be true when sending sign in link to email");return nf(a)}).then(function(b){return c.b.lb(a,b)}).then(function(){}))};
g.Tc=function(a){return this.Ja(a).then(function(a){return a.data.email})};g.Za=function(a,b){return T(this,this.b.Za(a,b).then(function(){}))};g.Ja=function(a){return T(this,this.b.Ja(a).then(function(a){return new Re(a)}))};g.Wa=function(a){return T(this,this.b.Wa(a).then(function(){}))};g.kb=function(a,b){var c=this;return T(this,B().then(function(){return"undefined"===typeof b||Za(b)?{}:nf(new cf(b))}).then(function(b){return c.b.kb(a,b)}).then(function(){}))};
g.Jc=function(a,b){return T(this,Tk(this,a,b,r(this.Pa,this)))};g.Ic=function(a,b){var c=this;return T(this,B().then(function(){var d=lg(a,b||Vd());return c.Pa(d)}))};function qm(){}qm.prototype.render=function(){};qm.prototype.reset=function(){};qm.prototype.getResponse=function(){};qm.prototype.execute=function(){};function rm(){this.a={};this.b=1E12}var sm=null;rm.prototype.render=function(a,b){this.a[this.b.toString()]=new tm(a,b);return this.b++};rm.prototype.reset=function(a){var b=um(this,a);a=vm(a);b&&a&&(b.delete(),delete this.a[a])};rm.prototype.getResponse=function(a){return(a=um(this,a))?a.getResponse():null};rm.prototype.execute=function(a){(a=um(this,a))&&a.execute()};function um(a,b){return(b=vm(b))?a.a[b]||null:null}function vm(a){return(a="undefined"===typeof a?1E12:a)?a.toString():null}
function tm(a,b){this.g=!1;this.c=b;this.a=this.b=null;this.h="invisible"!==this.c.size;this.f=Id(a);var c=this;this.i=function(){c.execute()};this.h?this.execute():rc(this.f,"click",this.i)}tm.prototype.getResponse=function(){wm(this);return this.b};
tm.prototype.execute=function(){wm(this);var a=this;this.a||(this.a=setTimeout(function(){a.b=pe();var b=a.c.callback,c=a.c["expired-callback"];if(b)try{b(a.b)}catch(d){}a.a=setTimeout(function(){a.a=null;a.b=null;if(c)try{c()}catch(d){}a.h&&a.execute()},6E4)},500))};tm.prototype.delete=function(){wm(this);this.g=!0;clearTimeout(this.a);this.a=null;E(this.f,"click",this.i)};function wm(a){if(a.g)throw Error("reCAPTCHA mock was already deleted!");};function xm(){}xm.prototype.g=function(){sm||(sm=new rm);return B(sm)};xm.prototype.c=function(){};var ym=null;function zm(){this.b=k.grecaptcha?Infinity:0;this.f=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var Am=qd("https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),Bm=new Ce(3E4,6E4);
zm.prototype.g=function(a){var b=this;return new A(function(c,d){var e=setTimeout(function(){d(new L("network-request-failed"))},Bm.get());if(!k.grecaptcha||a!==b.f&&!b.b){k[b.a]=function(){if(k.grecaptcha){b.f=a;var f=k.grecaptcha.render;k.grecaptcha.render=function(a,c){a=f(a,c);b.b++;return a};clearTimeout(e);c(k.grecaptcha)}else clearTimeout(e),d(new L("internal-error"));delete k[b.a]};var f=ud(Am,{onload:b.a,hl:a||""});B(Bh(f)).s(function(){clearTimeout(e);d(new L("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
c(k.grecaptcha)})};zm.prototype.c=function(){this.b--};var Cm=null;function Dm(a,b,c,d,e,f,h){J(this,"type","recaptcha");this.c=this.f=null;this.D=!1;this.m=b;this.g=null;h?(ym||(ym=new xm),h=ym):(Cm||(Cm=new zm),h=Cm);this.o=h;this.a=c||{theme:"light",type:"image"};this.h=[];if(this.a[Em])throw new L("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i="invisible"===this.a[Fm];if(!k.document)throw new L("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
if(!Id(b)||!this.i&&Id(b).hasChildNodes())throw new L("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.u=new Jh(a,f||null,e||null);this.v=d||function(){return null};var m=this;this.l=[];var p=this.a[Gm];this.a[Gm]=function(a){Hm(m,a);if("function"===typeof p)p(a);else if("string"===typeof p){var b=I(p,k);"function"===typeof b&&b(a)}};var x=this.a[Im];this.a[Im]=function(){Hm(m,null);if("function"===typeof x)x();else if("string"===typeof x){var a=
I(x,k);"function"===typeof a&&a()}}}var Gm="callback",Im="expired-callback",Em="sitekey",Fm="size";function Hm(a,b){for(var c=0;c<a.l.length;c++)try{a.l[c](b)}catch(d){}}function Jm(a,b){w(a.l,function(a){return a==b})}function Km(a,b){a.h.push(b);b.ia(function(){Ha(a.h,b)});return b}g=Dm.prototype;
g.za=function(){var a=this;return this.f?this.f:this.f=Km(this,B().then(function(){if(ve()&&!me())return he();throw new L("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return a.o.g(a.v())}).then(function(b){a.g=b;return P(a.u,Ei,{})}).then(function(b){a.a[Em]=b.recaptchaSiteKey}).s(function(b){a.f=null;throw b;}))};
g.render=function(){Lm(this);var a=this;return Km(this,this.za().then(function(){if(null===a.c){var b=a.m;if(!a.i){var c=Id(b);b=Ld("DIV");c.appendChild(b)}a.c=a.g.render(b,a.a)}return a.c}))};g.verify=function(){Lm(this);var a=this;return Km(this,this.render().then(function(b){return new A(function(c){var d=a.g.getResponse(b);if(d)c(d);else{var e=function(b){b&&(Jm(a,e),c(b))};a.l.push(e);a.i&&a.g.execute(a.c)}})}))};g.reset=function(){Lm(this);null!==this.c&&this.g.reset(this.c)};
function Lm(a){if(a.D)throw new L("internal-error","RecaptchaVerifier instance has been destroyed.");}g.clear=function(){Lm(this);this.D=!0;this.o.c();for(var a=0;a<this.h.length;a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.i){a=Id(this.m);for(var b;b=a.firstChild;)a.removeChild(b)}};
function Mm(a,b,c){var d=!1;try{this.b=c||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app()}catch(h){throw new L("argument-error","No firebase.app.App instance is currently initialized.");}if(this.b.options&&this.b.options.apiKey)c=this.b.options.apiKey;else throw new L("invalid-api-key");var e=this,f=null;try{f=this.b.auth().ya()}catch(h){}try{d=this.b.auth().settings.appVerificationDisabledForTesting}catch(h){}f=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?re(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,f):null;Dm.call(this,c,a,b,function(){try{var a=e.b.auth().ea()}catch(m){a=
null}return a},f,yf(zf),d)}t(Mm,Dm);function Nm(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,h=0;h<b.length;h++)if(b[h].optional)f=!0;else{if(f)throw new L("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].M(c[e])&&!f){b=b[e];if(0>e||e>=Om.length)throw new L("internal-error",
"Argument validator received an unsupported number of arguments.");c=Om[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.K+".";break a}d=null}}if(d)throw new L("argument-error",a+" failed: "+d);}var Om="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",K:"a valid string",optional:!!b,M:l}}function Pm(a,b){return{name:a||"",K:"a boolean",optional:!!b,M:ba}}
function W(a,b){return{name:a||"",K:"a valid object",optional:!!b,M:q}}function Qm(a,b){return{name:a||"",K:"a function",optional:!!b,M:n}}function Rm(a,b){return{name:a||"",K:"null",optional:!!b,M:ea}}function Sm(){return{name:"",K:"an HTML element",optional:!1,M:function(a){return!!(a&&a instanceof Element)}}}function Tm(){return{name:"auth",K:"an instance of Firebase Auth",optional:!0,M:function(a){return!!(a&&a instanceof bm)}}}
function Um(){return{name:"app",K:"an instance of Firebase App",optional:!0,M:function(a){return!!(a&&a instanceof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app.App)}}}function Vm(a){return{name:a?a+"Credential":"credential",K:a?"a valid "+a+" credential":"a valid credential",optional:!1,M:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.la||!c)}}}
function Wm(){return{name:"authProvider",K:"a valid Auth provider",optional:!1,M:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function Xm(){return{name:"applicationVerifier",K:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,M:function(a){return!!(a&&l(a.type)&&n(a.verify))}}}function X(a,b,c,d){return{name:c||"",K:a.K+" or "+b.K,optional:!!d,M:function(c){return a.M(c)||b.M(c)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=Ym(d,a[c],b[c].j)}}function Zm(a,b){for(var c in b){var d=b[c].name;d!==c&&Object.defineProperty(a,d,{get:na(function(a){return this[a]},c),set:na(function(a,b,c,d){Nm(a,[c],[d],!0);this[b]=d},d,c,b[c].tb),enumerable:!0})}}function Z(a,b,c,d){a[b]=Ym(b,c,d)}
function Ym(a,b,c){function d(){var a=Array.prototype.slice.call(arguments);Nm(e,c,a);return b.apply(this,a)}if(!c)return b;var e=$m(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function $m(a){a=a.split(".");return a[a.length-1]};Y(bm.prototype,{Wa:{name:"applyActionCode",j:[V("code")]},Ja:{name:"checkActionCode",j:[V("code")]},Za:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},xb:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},Wb:{name:"createUserAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},Zb:{name:"fetchProvidersForEmail",j:[V("email")]},$b:{name:"fetchSignInMethodsForEmail",j:[V("email")]},fa:{name:"getRedirectResult",j:[]},oc:{name:"isSignInWithEmailLink",j:[V("emailLink")]},
uc:{name:"onAuthStateChanged",j:[X(W(),Qm(),"nextOrObserver"),Qm("opt_error",!0),Qm("opt_completed",!0)]},vc:{name:"onIdTokenChanged",j:[X(W(),Qm(),"nextOrObserver"),Qm("opt_error",!0),Qm("opt_completed",!0)]},kb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),Rm(null,!0),"opt_actionCodeSettings",!0)]},lb:{name:"sendSignInLinkToEmail",j:[V("email"),W("actionCodeSettings")]},mb:{name:"setPersistence",j:[V("persistence")]},Pa:{name:"signInAndRetrieveDataWithCredential",
j:[Vm()]},Qa:{name:"signInAnonymously",j:[]},Gc:{name:"signInAnonymouslyAndRetrieveData",j:[]},Hc:{name:"signInWithCredential",j:[Vm()]},Nb:{name:"signInWithCustomToken",j:[V("token")]},Ec:{name:"signInAndRetrieveDataWithCustomToken",j:[V("token")]},Ob:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Ic:{name:"signInWithEmailLink",j:[V("email"),V("emailLink",!0)]},Fc:{name:"signInAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},Jc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),
Xm()]},Kc:{name:"signInWithPopup",j:[Wm()]},Lc:{name:"signInWithRedirect",j:[Wm()]},Qc:{name:"updateCurrentUser",j:[X(function(a){return{name:"user",K:"an instance of Firebase User",optional:!!a,M:function(a){return!!(a&&a instanceof Q)}}}(),Rm(),"user")]},nb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},Sc:{name:"useDeviceLanguage",j:[]},Tc:{name:"verifyPasswordResetCode",j:[V("code")]}});Zm(bm.prototype,{lc:{name:"languageCode",tb:X(V(),Rm(),"languageCode")}});bm.Persistence=Ij;
bm.Persistence.LOCAL="local";bm.Persistence.SESSION="session";bm.Persistence.NONE="none";
Y(Q.prototype,{"delete":{name:"delete",j:[]},dc:{name:"getIdTokenResult",j:[Pm("opt_forceRefresh",!0)]},F:{name:"getIdToken",j:[Pm("opt_forceRefresh",!0)]},eb:{name:"linkAndRetrieveDataWithCredential",j:[Vm()]},pc:{name:"linkWithCredential",j:[Vm()]},qc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),Xm()]},rc:{name:"linkWithPopup",j:[Wm()]},sc:{name:"linkWithRedirect",j:[Wm()]},gb:{name:"reauthenticateAndRetrieveDataWithCredential",j:[Vm()]},yc:{name:"reauthenticateWithCredential",j:[Vm()]},zc:{name:"reauthenticateWithPhoneNumber",
j:[V("phoneNumber"),Xm()]},Ac:{name:"reauthenticateWithPopup",j:[Wm()]},Bc:{name:"reauthenticateWithRedirect",j:[Wm()]},reload:{name:"reload",j:[]},jb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),Rm(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},Pc:{name:"unlink",j:[V("provider")]},pb:{name:"updateEmail",j:[V("email")]},qb:{name:"updatePassword",j:[V("password")]},Rc:{name:"updatePhoneNumber",j:[Vm("phone")]},rb:{name:"updateProfile",j:[W("profile")]}});
Y(rm.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(qm.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(A.prototype,{ia:{name:"finally"},s:{name:"catch"},then:{name:"then"}});Zm(Rk.prototype,{appVerificationDisabled:{name:"appVerificationDisabledForTesting",tb:Pm("appVerificationDisabledForTesting")}});Y(Sk.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});
Z(O,"credential",function(a,b){return new gg(a,b)},[V("email"),V("password")]);Y(Zf.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Zf,"credential",$f,[X(V(),W(),"token")]);Z(O,"credentialWithLink",lg,[V("email"),V("emailLink")]);Y(ag.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(ag,"credential",bg,[X(V(),W(),"token")]);
Y(cg.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(cg,"credential",dg,[X(V(),X(W(),Rm()),"idToken"),X(V(),Rm(),"accessToken",!0)]);Y(eg.prototype,{Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(eg,"credential",fg,[X(V(),W(),"token"),V("secret",!0)]);
Y(N.prototype,{ua:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),Rm(),"idToken",!0),X(V(),Rm(),"accessToken",!0),X(V(),Rm(),"nonce",!0)]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(rg,"credential",tg,[V("verificationId"),V("verificationCode")]);Y(rg.prototype,{Ua:{name:"verifyPhoneNumber",j:[V("phoneNumber"),Xm()]}});Y(L.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(Bg.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});
Y(Ag.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(Mm.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});
(function(){if("undefined"!==typeof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService){var a={Auth:bm,Error:L};Z(a,"EmailAuthProvider",O,[]);Z(a,"FacebookAuthProvider",Zf,[]);Z(a,"GithubAuthProvider",ag,[]);Z(a,"GoogleAuthProvider",cg,[]);Z(a,"TwitterAuthProvider",eg,[]);Z(a,"OAuthProvider",N,[V("providerId")]);Z(a,"SAMLAuthProvider",Yf,[V("providerId")]);Z(a,"PhoneAuthProvider",rg,[Tm()]);Z(a,"RecaptchaVerifier",Mm,[X(V(),Sm(),"recaptchaContainer"),W("recaptchaParameters",!0),Um()]);
__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService("auth",function(a,c){a=new bm(a);c({INTERNAL:{getUid:r(a.getUid,a),getToken:r(a.cc,a),addAuthTokenListener:r(a.Vb,a),removeAuthTokenListener:r(a.Cc,a)}});return a},a,function(a,c){if("create"===a)try{c.auth()}catch(d){}});__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.extendNamespace({User:Q})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).apply(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

//# sourceMappingURL=auth.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var util = __webpack_require__(37);
var logger = __webpack_require__(67);
var tslib_1 = __webpack_require__(28);
var firebase = _interopDefault(__webpack_require__(16));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */
var DOMStorageWrapper = /** @class */ (function () {
    /**
     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
     */
    function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param {string} key The key to save the value under
     * @param {?Object} value The value being stored, or null to remove the key.
     */
    DOMStorageWrapper.prototype.set = function (key, value) {
        if (value == null) {
            this.domStorage_.removeItem(this.prefixedName_(key));
        }
        else {
            this.domStorage_.setItem(this.prefixedName_(key), util.stringify(value));
        }
    };
    /**
     * @param {string} key
     * @return {*} The value that was stored under this key, or null
     */
    DOMStorageWrapper.prototype.get = function (key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) {
            return null;
        }
        else {
            return util.jsonEval(storedVal);
        }
    };
    /**
     * @param {string} key
     */
    DOMStorageWrapper.prototype.remove = function (key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    /**
     * @param {string} name
     * @return {string}
     */
    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function () {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function (key, value) {
        if (value == null) {
            delete this.cache_[key];
        }
        else {
            this.cache_[key] = value;
        }
    };
    MemoryStorage.prototype.get = function (key) {
        if (util.contains(this.cache_, key)) {
            return this.cache_[key];
        }
        return null;
    };
    MemoryStorage.prototype.remove = function (key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param {string} domStorageName Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @return {?} Turning off type information until a common interface is defined.
 */
var createStoragefor = function (domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' &&
            typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new DOMStorageWrapper(domStorage);
        }
    }
    catch (e) { }
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new MemoryStorage();
};
/** A storage object that lasts across sessions */
var PersistentStorage = createStoragefor('localStorage');
/** A storage object that only lasts one session */
var SessionStorage = createStoragefor('sessionStorage');

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new logger.Logger('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 * @type {function(): number} Generated ID.
 */
var LUIDGenerator = (function () {
    var id = 1;
    return function () {
        return id++;
    };
})();
/**
 * Sha1 hash of the input string
 * @param {!string} str The string to hash
 * @return {!string} The resulting hash
 */
var sha1 = function (str) {
    var utf8Bytes = util.stringToByteArray(str);
    var sha1 = new util.Sha1();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return util.base64.encodeByteArray(sha1Bytes);
};
/**
 * @param {...*} var_args
 * @return {string}
 * @private
 */
var buildLogMessage_ = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = '';
    for (var i = 0; i < var_args.length; i++) {
        if (Array.isArray(var_args[i]) ||
            (var_args[i] &&
                typeof var_args[i] === 'object' &&
                typeof var_args[i].length === 'number')) {
            message += buildLogMessage_.apply(null, var_args[i]);
        }
        else if (typeof var_args[i] === 'object') {
            message += util.stringify(var_args[i]);
        }
        else {
            message += var_args[i];
        }
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 * @type {?function(string)}
 */
var logger$1 = null;
/**
 * Flag to check for log availability on first log message
 * @type {boolean}
 * @private
 */
var firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
 */
var enableLogging = function (logger_, persistent) {
    util.assert(!persistent || (logger_ === true || logger_ === false), "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        logClient.logLevel = logger.LogLevel.VERBOSE;
        logger$1 = logClient.log.bind(logClient);
        if (persistent)
            SessionStorage.set('logging_enabled', true);
    }
    else if (typeof logger_ === 'function') {
        logger$1 = logger_;
    }
    else {
        logger$1 = null;
        SessionStorage.remove('logging_enabled');
    }
};
/**
 *
 * @param {...(string|Arguments)} var_args
 */
var log = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (firstLog_ === true) {
        firstLog_ = false;
        if (logger$1 === null && SessionStorage.get('logging_enabled') === true)
            enableLogging(true);
    }
    if (logger$1) {
        var message = buildLogMessage_.apply(null, var_args);
        logger$1(message);
    }
};
/**
 * @param {!string} prefix
 * @return {function(...[*])}
 */
var logWrapper = function (prefix) {
    return function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        log.apply(void 0, [prefix].concat(var_args));
    };
};
/**
 * @param {...string} var_args
 */
var error = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, var_args);
    logClient.error(message);
};
/**
 * @param {...string} var_args
 */
var fatal = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, var_args);
    logClient.error(message);
    throw new Error(message);
};
/**
 * @param {...*} var_args
 */
var warn = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, var_args);
    logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */
var warnIfPageIsSecure = function () {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' &&
        window.location &&
        window.location.protocol &&
        window.location.protocol.indexOf('https:') !== -1) {
        warn('Insecure Firebase access from a secure page. ' +
            'Please use https in calls to new Firebase().');
    }
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 * @param {*} data
 * @return {boolean}
 */
var isInvalidJSONNumber = function (data) {
    return (typeof data === 'number' &&
        (data != data || // NaN
            data == Number.POSITIVE_INFINITY ||
            data == Number.NEGATIVE_INFINITY));
};
/**
 * @param {function()} fn
 */
var executeWhenDOMReady = function (fn) {
    if (util.isNodeSdk() || document.readyState === 'complete') {
        fn();
    }
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function () {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn_1, false);
        }
        else if (document.attachEvent) {
            // IE.
            document.attachEvent('onreadystatechange', function () {
                if (document.readyState === 'complete')
                    wrappedFn_1();
            });
            // fallback to onload.
            window.attachEvent('onload', wrappedFn_1);
            // jQuery has an extra hack for IE that we could employ (based on
            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
            // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 * @type {!string}
 */
var MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 * @type {!string}
 */
var MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 * @param {!string} a
 * @param {!string} b
 * @return {!number}
 */
var nameCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a === MIN_NAME || b === MAX_NAME) {
        return -1;
    }
    else if (b === MIN_NAME || a === MAX_NAME) {
        return 1;
    }
    else {
        var aAsInt = tryParseInt(a), bAsInt = tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) {
                return aAsInt - bAsInt == 0 ? a.length - b.length : aAsInt - bAsInt;
            }
            else {
                return -1;
            }
        }
        else if (bAsInt !== null) {
            return 1;
        }
        else {
            return a < b ? -1 : 1;
        }
    }
};
/**
 * @param {!string} a
 * @param {!string} b
 * @return {!number} comparison result.
 */
var stringCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a < b) {
        return -1;
    }
    else {
        return 1;
    }
};
/**
 * @param {string} key
 * @param {Object} obj
 * @return {*}
 */
var requireKey = function (key, obj) {
    if (obj && key in obj) {
        return obj[key];
    }
    else {
        throw new Error('Missing required key (' + key + ') in object: ' + util.stringify(obj));
    }
};
/**
 * @param {*} obj
 * @return {string}
 */
var ObjectToUniqueKey = function (obj) {
    if (typeof obj !== 'object' || obj === null)
        return util.stringify(obj);
    var keys = [];
    for (var k in obj) {
        keys.push(k);
    }
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = '{';
    for (var i = 0; i < keys.length; i++) {
        if (i !== 0)
            key += ',';
        key += util.stringify(keys[i]);
        key += ':';
        key += ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param {!string} str The string
 * @param {!number} segsize The maximum number of chars in the string.
 * @return {Array.<string>} The string, split into appropriately-sized chunks
 */
var splitStringBySize = function (str, segsize) {
    var len = str.length;
    if (len <= segsize) {
        return [str];
    }
    var dataSegs = [];
    for (var c = 0; c < len; c += segsize) {
        if (c + segsize > len) {
            dataSegs.push(str.substring(c, len));
        }
        else {
            dataSegs.push(str.substring(c, c + segsize));
        }
    }
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param {!(Object|Array)} obj The object or array to iterate over
 * @param {function(?, ?)} fn The function to apply
 */
var each = function (obj, fn) {
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; ++i) {
            fn(i, obj[i]);
        }
    }
    else {
        /**
         * in the conversion of code we removed the goog.object.forEach
         * function which did a value,key callback. We standardized on
         * a single impl that does a key, value callback. So we invert
         * to not have to touch the `each` code points
         */
        util.forEach(obj, function (key, val) { return fn(val, key); });
    }
};
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param {!number} v A double
 * @return {string}
 */
var doubleToIEEE754String = function (v) {
    util.assert(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    var ebits = 11, fbits = 52;
    var bias = (1 << (ebits - 1)) - 1, s, e, f, ln, i, bits, str;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    }
    else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        }
        else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    bits = [];
    for (i = fbits; i; i -= 1) {
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for (i = ebits; i; i -= 1) {
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    str = bits.join('');
    // Return the data as a hex string. --MJL
    var hexByteString = '';
    for (i = 0; i < 64; i += 8) {
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1)
            hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 * @return {boolean}
 */
var isChromeExtensionContentScript = function () {
    return !!(typeof window === 'object' &&
        window['chrome'] &&
        window['chrome']['extension'] &&
        !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 * @return {boolean}
 */
var isWindowsStoreApp = function () {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a Javascript Error
 * @param {!string} code
 * @param {!Query} query
 * @return {Error}
 */
var errorForServerCode = function (code, query) {
    var reason = 'Unknown Error';
    if (code === 'too_big') {
        reason =
            'The data requested exceeds the maximum size ' +
                'that can be accessed with a single request.';
    }
    else if (code == 'permission_denied') {
        reason = "Client doesn't have permission to access the desired data.";
    }
    else if (code == 'unavailable') {
        reason = 'The service is unavailable';
    }
    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
    error.code = code.toUpperCase();
    return error;
};
/**
 * Used to test for integer-looking strings
 * @type {RegExp}
 * @private
 */
var INTEGER_REGEXP_ = new RegExp('^-?\\d{1,10}$');
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 * @param {!string} str
 * @return {?number}
 */
var tryParseInt = function (str) {
    if (INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= -2147483648 && intVal <= 2147483647) {
            return intVal;
        }
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param {!function()} fn The code to guard.
 */
var exceptionGuard = function (fn) {
    try {
        fn();
    }
    catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function () {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || '';
            warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @return {boolean} true if we think we're currently being crawled.
 */
var beingCrawled = function () {
    var userAgent = (typeof window === 'object' &&
        window['navigator'] &&
        window['navigator']['userAgent']) ||
        '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param {Function} fn Function to run.
 * @param {number} time Milliseconds to wait before running.
 * @return {number|Object} The setTimeout() return value.
 */
var setTimeoutNonBlocking = function (fn, time) {
    var timeout = setTimeout(fn, time);
    if (typeof timeout === 'object' && timeout['unref']) {
        timeout['unref']();
    }
    return timeout;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */
var Path = /** @class */ (function () {
    /**
     * @param {string|Array.<string>} pathOrString Path string to parse,
     *      or another path, or the raw tokens array
     * @param {number=} pieceNum
     */
    function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            var copyTo = 0;
            for (var i = 0; i < this.pieces_.length; i++) {
                if (this.pieces_[i].length > 0) {
                    this.pieces_[copyTo] = this.pieces_[i];
                    copyTo++;
                }
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        }
        else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Object.defineProperty(Path, "Empty", {
        /**
         * Singleton to represent an empty path
         *
         * @const
         */
        get: function () {
            return new Path('');
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.getFront = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        return this.pieces_[this.pieceNum_];
    };
    /**
     * @return {number} The number of segments in this path
     */
    Path.prototype.getLength = function () {
        return this.pieces_.length - this.pieceNum_;
    };
    /**
     * @return {!Path}
     */
    Path.prototype.popFront = function () {
        var pieceNum = this.pieceNum_;
        if (pieceNum < this.pieces_.length) {
            pieceNum++;
        }
        return new Path(this.pieces_, pieceNum);
    };
    /**
     * @return {?string}
     */
    Path.prototype.getBack = function () {
        if (this.pieceNum_ < this.pieces_.length)
            return this.pieces_[this.pieces_.length - 1];
        return null;
    };
    Path.prototype.toString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + this.pieces_[i];
        }
        return pathString || '/';
    };
    Path.prototype.toUrlEncodedString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
        }
        return pathString || '/';
    };
    /**
     * Shallow copy of the parts of the path.
     *
     * @param {number=} begin
     * @return {!Array<string>}
     */
    Path.prototype.slice = function (begin) {
        if (begin === void 0) { begin = 0; }
        return this.pieces_.slice(this.pieceNum_ + begin);
    };
    /**
     * @return {?Path}
     */
    Path.prototype.parent = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++)
            pieces.push(this.pieces_[i]);
        return new Path(pieces, 0);
    };
    /**
     * @param {string|!Path} childPathObj
     * @return {!Path}
     */
    Path.prototype.child = function (childPathObj) {
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length; i++)
            pieces.push(this.pieces_[i]);
        if (childPathObj instanceof Path) {
            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
                pieces.push(childPathObj.pieces_[i]);
            }
        }
        else {
            var childPieces = childPathObj.split('/');
            for (var i = 0; i < childPieces.length; i++) {
                if (childPieces[i].length > 0)
                    pieces.push(childPieces[i]);
            }
        }
        return new Path(pieces, 0);
    };
    /**
     * @return {boolean} True if there are no segments in this path
     */
    Path.prototype.isEmpty = function () {
        return this.pieceNum_ >= this.pieces_.length;
    };
    /**
     * @param {!Path} outerPath
     * @param {!Path} innerPath
     * @return {!Path} The path from outerPath to innerPath
     */
    Path.relativePath = function (outerPath, innerPath) {
        var outer = outerPath.getFront(), inner = innerPath.getFront();
        if (outer === null) {
            return innerPath;
        }
        else if (outer === inner) {
            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
        }
        else {
            throw new Error('INTERNAL ERROR: innerPath (' +
                innerPath +
                ') is not within ' +
                'outerPath (' +
                outerPath +
                ')');
        }
    };
    /**
     * @param {!Path} left
     * @param {!Path} right
     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
     */
    Path.comparePaths = function (left, right) {
        var leftKeys = left.slice();
        var rightKeys = right.slice();
        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
            var cmp = nameCompare(leftKeys[i], rightKeys[i]);
            if (cmp !== 0)
                return cmp;
        }
        if (leftKeys.length === rightKeys.length)
            return 0;
        return leftKeys.length < rightKeys.length ? -1 : 1;
    };
    /**
     *
     * @param {Path} other
     * @return {boolean} true if paths are the same.
     */
    Path.prototype.equals = function (other) {
        if (this.getLength() !== other.getLength()) {
            return false;
        }
        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
        }
        return true;
    };
    /**
     *
     * @param {!Path} other
     * @return {boolean} True if this path is a parent (or the same as) other
     */
    Path.prototype.contains = function (other) {
        var i = this.pieceNum_;
        var j = other.pieceNum_;
        if (this.getLength() > other.getLength()) {
            return false;
        }
        while (i < this.pieces_.length) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
            ++i;
            ++j;
        }
        return true;
    };
    return Path;
}()); // end Path
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */
var ValidationPath = /** @class */ (function () {
    /**
     * @param {!Path} path Initial Path.
     * @param {string} errorPrefix_ Prefix for any error messages.
     */
    function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        /** @type {!Array<string>} */
        this.parts_ = path.slice();
        /** @type {number} Initialize to number of '/' chars needed in path. */
        this.byteLength_ = Math.max(1, this.parts_.length);
        for (var i = 0; i < this.parts_.length; i++) {
            this.byteLength_ += util.stringLength(this.parts_[i]);
        }
        this.checkValid_();
    }
    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
        /** @const {number} Maximum key depth. */
        get: function () {
            return 32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
        get: function () {
            return 768;
        },
        enumerable: true,
        configurable: true
    });
    /** @param {string} child */
    ValidationPath.prototype.push = function (child) {
        // Count the needed '/'
        if (this.parts_.length > 0) {
            this.byteLength_ += 1;
        }
        this.parts_.push(child);
        this.byteLength_ += util.stringLength(child);
        this.checkValid_();
    };
    ValidationPath.prototype.pop = function () {
        var last = this.parts_.pop();
        this.byteLength_ -= util.stringLength(last);
        // Un-count the previous '/'
        if (this.parts_.length > 0) {
            this.byteLength_ -= 1;
        }
    };
    ValidationPath.prototype.checkValid_ = function () {
        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
            throw new Error(this.errorPrefix_ +
                'has a key path longer than ' +
                ValidationPath.MAX_PATH_LENGTH_BYTES +
                ' bytes (' +
                this.byteLength_ +
                ').');
        }
        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
            throw new Error(this.errorPrefix_ +
                'path specified exceeds the maximum depth that can be written (' +
                ValidationPath.MAX_PATH_DEPTH +
                ') or object contains a cycle ' +
                this.toErrorString());
        }
    };
    /**
     * String for use in error messages - uses '.' notation for path.
     *
     * @return {string}
     */
    ValidationPath.prototype.toErrorString = function () {
        if (this.parts_.length == 0) {
            return '';
        }
        return "in property '" + this.parts_.join('.') + "'";
    };
    return ValidationPath;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PROTOCOL_VERSION = '5';
var VERSION_PARAM = 'v';
var TRANSPORT_SESSION_PARAM = 's';
var REFERER_PARAM = 'r';
var FORGE_REF = 'f';
var FORGE_DOMAIN = 'firebaseio.com';
var LAST_SESSION_PARAM = 'ls';
var WEBSOCKET = 'websocket';
var LONG_POLLING = 'long_polling';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */
var RepoInfo = /** @class */ (function () {
    /**
     * @param {string} host Hostname portion of the url for the repo
     * @param {boolean} secure Whether or not this repo is accessed over ssl
     * @param {string} namespace The namespace represented by the repo
     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
     * @param {string=} persistenceKey Override the default session persistence storage key
     */
    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey) {
        if (persistenceKey === void 0) { persistenceKey = ''; }
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.persistenceKey = persistenceKey;
        this.host = host.toLowerCase();
        this.domain = this.host.substr(this.host.indexOf('.') + 1);
        this.internalHost = PersistentStorage.get('host:' + host) || this.host;
    }
    RepoInfo.prototype.needsQueryParam = function () {
        return this.host !== this.internalHost || this.isCustomHost();
    };
    RepoInfo.prototype.isCacheableHost = function () {
        return this.internalHost.substr(0, 2) === 's-';
    };
    RepoInfo.prototype.isDemoHost = function () {
        return this.domain === 'firebaseio-demo.com';
    };
    RepoInfo.prototype.isCustomHost = function () {
        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
    };
    RepoInfo.prototype.updateHost = function (newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) {
                PersistentStorage.set('host:' + this.host, this.internalHost);
            }
        }
    };
    /**
     * Returns the websocket URL for this repo
     * @param {string} type of connection
     * @param {Object} params list
     * @return {string} The URL for this repo
     */
    RepoInfo.prototype.connectionURL = function (type, params) {
        util.assert(typeof type === 'string', 'typeof type must == string');
        util.assert(typeof params === 'object', 'typeof params must == object');
        var connURL;
        if (type === WEBSOCKET) {
            connURL =
                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
        }
        else if (type === LONG_POLLING) {
            connURL =
                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
        }
        else {
            throw new Error('Unknown connection type: ' + type);
        }
        if (this.needsQueryParam()) {
            params['ns'] = this.namespace;
        }
        var pairs = [];
        util.forEach(params, function (key, value) {
            pairs.push(key + '=' + value);
        });
        return connURL + pairs.join('&');
    };
    /** @return {string} */
    RepoInfo.prototype.toString = function () {
        var str = this.toURLString();
        if (this.persistenceKey) {
            str += '<' + this.persistenceKey + '>';
        }
        return str;
    };
    /** @return {string} */
    RepoInfo.prototype.toURLString = function () {
        return (this.secure ? 'https://' : 'http://') + this.host;
    };
    return RepoInfo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!string} pathString
 * @return {string}
 */
function decodePath(pathString) {
    var pathStringDecoded = '';
    var pieces = pathString.split('/');
    for (var i = 0; i < pieces.length; i++) {
        if (pieces[i].length > 0) {
            var piece = pieces[i];
            try {
                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
            }
            catch (e) { }
            pathStringDecoded += '/' + piece;
        }
    }
    return pathStringDecoded;
}
/**
 * @param {!string} queryString
 * @return {!{[key:string]:string}} key value hash
 */
function decodeQuery(queryString) {
    var results = {};
    if (queryString.charAt(0) === '?') {
        queryString = queryString.substring(1);
    }
    for (var _i = 0, _a = queryString.split('&'); _i < _a.length; _i++) {
        var segment = _a[_i];
        if (segment.length === 0) {
            continue;
        }
        var kv = segment.split('=');
        if (kv.length === 2) {
            results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        }
        else {
            warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
        }
    }
    return results;
}
/**
 *
 * @param {!string} dataURL
 * @return {{repoInfo: !RepoInfo, path: !Path}}
 */
var parseRepoInfo = function (dataURL) {
    var parsedUrl = parseURL(dataURL), namespace = parsedUrl.subdomain;
    if (parsedUrl.domain === 'firebase') {
        fatal(parsedUrl.host +
            ' is no longer supported. ' +
            'Please use <YOUR FIREBASE>.firebaseio.com instead');
    }
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace == 'undefined') &&
        parsedUrl.domain !== 'localhost') {
        fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    }
    if (!parsedUrl.secure) {
        warnIfPageIsSecure();
    }
    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly),
        path: new Path(parsedUrl.pathString)
    };
};
/**
 *
 * @param {!string} dataURL
 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string}}
 */
var parseURL = function (dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = '', domain = '', subdomain = '', pathString = '';
    // Always default to SSL, unless otherwise specified.
    var secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        var colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        var slashInd = dataURL.indexOf('/');
        if (slashInd === -1) {
            slashInd = dataURL.length;
        }
        var questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) {
            questionMarkInd = dataURL.length;
        }
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) {
            // For pathString, questionMarkInd will always come after slashInd
            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
        }
        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        }
        else {
            colonInd = dataURL.length;
        }
        var parts = host.split('.');
        if (parts.length === 3) {
            // Normalize namespaces to lowercase to share storage / connection.
            domain = parts[1];
            subdomain = parts[0].toLowerCase();
        }
        else if (parts.length === 2) {
            domain = parts[0];
        }
        else if (parts[0].slice(0, colonInd).toLowerCase() === 'localhost') {
            domain = 'localhost';
        }
        // Support `ns` query param if subdomain not already set
        if (subdomain === '' && 'ns' in queryParams) {
            subdomain = queryParams['ns'];
        }
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString
    };
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * True for invalid Firebase keys
 * @type {RegExp}
 * @private
 */
var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 * @type {RegExp}
 * @private
 */
var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 * @type {number}
 * @private
 */
var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
/**
 * @param {*} key
 * @return {boolean}
 */
var isValidKey = function (key) {
    return (typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidPathString = function (pathString) {
    return (typeof pathString === 'string' &&
        pathString.length !== 0 &&
        !INVALID_PATH_REGEX_.test(pathString));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidRootPathString = function (pathString) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    return isValidPathString(pathString);
};
/**
 * @param {*} priority
 * @return {boolean}
 */
var isValidPriority = function (priority) {
    return (priority === null ||
        typeof priority === 'string' ||
        (typeof priority === 'number' && !isInvalidJSONNumber(priority)) ||
        (priority && typeof priority === 'object' && util.contains(priority, '.sv')));
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    validateFirebaseData(util.errorPrefix(fnName, argumentNumber, optional), data, path);
};
/**
 * Validate a data object client-side before sending to server.
 *
 * @param {string} errorPrefix
 * @param {*} data
 * @param {!Path|!ValidationPath} path_
 */
var validateFirebaseData = function (errorPrefix, data, path_) {
    var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) {
        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
    }
    if (typeof data === 'function') {
        throw new Error(errorPrefix +
            'contains a function ' +
            path.toErrorString() +
            ' with contents = ' +
            data.toString());
    }
    if (isInvalidJSONNumber(data)) {
        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
    }
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' &&
        data.length > MAX_LEAF_SIZE_ / 3 &&
        util.stringLength(data) > MAX_LEAF_SIZE_) {
        throw new Error(errorPrefix +
            'contains a string greater than ' +
            MAX_LEAF_SIZE_ +
            ' utf8 bytes ' +
            path.toErrorString() +
            " ('" +
            data.substring(0, 50) +
            "...')");
    }
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        var hasDotValue_1 = false, hasActualChild_1 = false;
        util.forEach(data, function (key, value) {
            if (key === '.value') {
                hasDotValue_1 = true;
            }
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild_1 = true;
                if (!isValidKey(key)) {
                    throw new Error(errorPrefix +
                        ' contains an invalid key (' +
                        key +
                        ') ' +
                        path.toErrorString() +
                        '.  Keys must be non-empty strings ' +
                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
                }
            }
            path.push(key);
            validateFirebaseData(errorPrefix, value, path);
            path.pop();
        });
        if (hasDotValue_1 && hasActualChild_1) {
            throw new Error(errorPrefix +
                ' contains ".value" child ' +
                path.toErrorString() +
                ' in addition to actual children.');
        }
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 *
 * @param {string} errorPrefix
 * @param {Array<!Path>} mergePaths
 */
var validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
    var i, curPath;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        var keys = curPath.slice();
        for (var j = 0; j < keys.length; j++) {
            if (keys[j] === '.priority' && j === keys.length - 1) {
                // .priority is OK
            }
            else if (!isValidKey(keys[j])) {
                throw new Error(errorPrefix +
                    'contains an invalid key (' +
                    keys[j] +
                    ') in path ' +
                    curPath.toString() +
                    '. Keys must be non-empty strings ' +
                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort(Path.comparePaths);
    var prevPath = null;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        if (prevPath !== null && prevPath.contains(curPath)) {
            throw new Error(errorPrefix +
                'contains a path ' +
                prevPath.toString() +
                ' that is ancestor of another path ' +
                curPath.toString());
        }
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    var errorPrefix = util.errorPrefix(fnName, argumentNumber, optional);
    if (!(data && typeof data === 'object') || Array.isArray(data)) {
        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
    }
    var mergePaths = [];
    util.forEach(data, function (key, value) {
        var curPath = new Path(key);
        validateFirebaseData(errorPrefix, value, path.child(curPath));
        if (curPath.getBack() === '.priority') {
            if (!isValidPriority(value)) {
                throw new Error(errorPrefix +
                    "contains an invalid value for '" +
                    curPath.toString() +
                    "', which must be a valid " +
                    'Firebase priority (a string, finite number, server value, or null).');
            }
        }
        mergePaths.push(curPath);
    });
    validateFirebaseMergePaths(errorPrefix, mergePaths);
};
var validatePriority = function (fnName, argumentNumber, priority, optional) {
    if (optional && priority === undefined)
        return;
    if (isInvalidJSONNumber(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'is ' +
            priority.toString() +
            ', but must be a valid Firebase priority (a string, finite number, ' +
            'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!isValidPriority(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid Firebase priority ' +
            '(a string, finite number, server value, or null).');
};
var validateEventType = function (fnName, argumentNumber, eventType, optional) {
    if (optional && eventType === undefined)
        return;
    switch (eventType) {
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
                'must be a valid event type = "value", "child_added", "child_removed", ' +
                '"child_changed", or "child_moved".');
    }
};
var validateKey = function (fnName, argumentNumber, key, optional) {
    if (optional && key === undefined)
        return;
    if (!isValidKey(key))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid key = "' +
            key +
            '".  Firebase keys must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
var validatePathString = function (fnName, argumentNumber, pathString, optional) {
    if (optional && pathString === undefined)
        return;
    if (!isValidPathString(pathString))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid path = "' +
            pathString +
            '". Paths must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "[", or "]"');
};
var validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    validatePathString(fnName, argumentNumber, pathString, optional);
};
var validateWritablePath = function (fnName, path) {
    if (path.getFront() === '.info') {
        throw new Error(fnName + " failed = Can't modify data under /.info/");
    }
};
var validateUrl = function (fnName, argumentNumber, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
        parsedUrl.repoInfo.host.length === 0 ||
        (!isValidKey(parsedUrl.repoInfo.namespace) &&
            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
        (pathString.length !== 0 && !isValidRootPathString(pathString))) {
        throw new Error(util.errorPrefix(fnName, argumentNumber, false) +
            'must be a valid firebase URL and ' +
            'the path can\'t contain ".", "#", "$", "[", or "]".');
    }
};
var validateBoolean = function (fnName, argumentNumber, bool, optional) {
    if (optional && bool === undefined)
        return;
    if (typeof bool !== 'boolean')
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var OnDisconnect = /** @class */ (function () {
    /**
     * @param {!Repo} repo_
     * @param {!Path} path_
     */
    function OnDisconnect(repo_, path_) {
        this.repo_ = repo_;
        this.path_ = path_;
    }
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.cancel = function (onComplete) {
        util.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
        util.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.remove = function (onComplete) {
        util.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
        validateWritablePath('OnDisconnect.remove', this.path_);
        util.validateCallback('OnDisconnect.remove', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.set = function (value, onComplete) {
        util.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.set', this.path_);
        validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
        util.validateCallback('OnDisconnect.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {number|string|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
        util.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('OnDisconnect.setWithPriority', this.path_);
        validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
        validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
        util.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.update', this.path_);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
        }
        validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
        util.validateCallback('OnDisconnect.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    return OnDisconnect;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TransactionResult = /** @class */ (function () {
    /**
     * A type for the resolve value of Firebase.transaction.
     * @constructor
     * @dict
     * @param {boolean} committed
     * @param {DataSnapshot} snapshot
     */
    function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function () {
        util.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
    };
    return TransactionResult;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */
var nextPushId = (function () {
    // Modeled after base64 web-safe chars, but ordered by ASCII.
    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function (now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for (i = 7; i >= 0; i--) {
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        util.assert(now === 0, 'Cannot push at time == 0');
        var id = timeStampChars.join('');
        if (!duplicateTime) {
            for (i = 0; i < 12; i++) {
                lastRandChars[i] = Math.floor(Math.random() * 64);
            }
        }
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
                lastRandChars[i] = 0;
            }
            lastRandChars[i]++;
        }
        for (i = 0; i < 12; i++) {
            id += PUSH_CHARS.charAt(lastRandChars[i]);
        }
        util.assert(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
})();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @param {!string} name
 * @param {!Node} node
 * @constructor
 * @struct
 */
var NamedNode = /** @class */ (function () {
    function NamedNode(name, node) {
        this.name = name;
        this.node = node;
    }
    /**
     *
     * @param {!string} name
     * @param {!Node} node
     * @return {NamedNode}
     */
    NamedNode.Wrap = function (name, node) {
        return new NamedNode(name, node);
    };
    return NamedNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @constructor
 */
var Index = /** @class */ (function () {
    function Index() {
    }
    /**
     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
     * this index
     */
    Index.prototype.getCompare = function () {
        return this.compare.bind(this);
    };
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     * @param {!Node} oldNode
     * @param {!Node} newNode
     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
     */
    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
        var oldWrapped = new NamedNode(MIN_NAME, oldNode);
        var newWrapped = new NamedNode(MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    };
    /**
     * @return {!NamedNode} a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */
    Index.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    return Index;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __EMPTY_NODE;
var KeyIndex = /** @class */ (function (_super) {
    tslib_1.__extends(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function () {
            return __EMPTY_NODE;
        },
        set: function (val) {
            __EMPTY_NODE = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.compare = function (a, b) {
        return nameCompare(a.name, b.name);
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.isDefinedOn = function (node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw util.assertionError('KeyIndex.isDefinedOn not expected to be called.');
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.maxPost = function () {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new NamedNode(MAX_NAME, __EMPTY_NODE);
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    KeyIndex.prototype.makePost = function (indexValue, name) {
        util.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new NamedNode(indexValue, __EMPTY_NODE);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    KeyIndex.prototype.toString = function () {
        return '.key';
    };
    return KeyIndex;
}(Index));
var KEY_INDEX = new KeyIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_NODE;
function setMaxNode(val) {
    MAX_NODE = val;
}
/**
 * @param {(!string|!number)} priority
 * @return {!string}
 */
var priorityHashText = function (priority) {
    if (typeof priority === 'number')
        return 'number:' + doubleToIEEE754String(priority);
    else
        return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 *
 * @param {!Node} priorityNode
 */
var validatePriorityNode = function (priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        util.assert(typeof val === 'string' ||
            typeof val === 'number' ||
            (typeof val === 'object' && util.contains(val, '.sv')), 'Priority must be a string or number.');
    }
    else {
        util.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
    }
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    util.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */
var LeafNode = /** @class */ (function () {
    /**
     * @implements {Node}
     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
     *                                         The object type is possible in the event of a deferred value
     * @param {!Node=} priorityNode_ The priority of this node.
     */
    function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        util.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        validatePriorityNode(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function () {
            return __childrenNodeConstructor;
        },
        set: function (val) {
            __childrenNodeConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    LeafNode.prototype.isLeafNode = function () {
        return true;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPriority = function () {
        return this.priorityNode_;
    };
    /** @inheritDoc */
    LeafNode.prototype.updatePriority = function (newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */
    LeafNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.getChild = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else if (path.getFront() === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.hasChild = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
        return null;
    };
    /** @inheritDoc */
    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else if (newChildNode.isEmpty() && childName !== '.priority') {
            return this;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else if (newChildNode.isEmpty() && front !== '.priority') {
            return this;
        }
        else {
            util.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.isEmpty = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.numChildren = function () {
        return 0;
    };
    /** @inheritDoc */
    LeafNode.prototype.forEachChild = function (index, action) {
        return false;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.val = function (exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty())
            return {
                '.value': this.getValue(),
                '.priority': this.getPriority().val()
            };
        else
            return this.getValue();
    };
    /** @inheritDoc */
    LeafNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash = '';
            if (!this.priorityNode_.isEmpty())
                toHash +=
                    'priority:' +
                        priorityHashText(this.priorityNode_.val()) +
                        ':';
            var type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') {
                toHash += doubleToIEEE754String(this.value_);
            }
            else {
                toHash += this.value_;
            }
            this.lazyHash_ = sha1(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @return {Object|string|number|boolean} The value of the node.
     */
    LeafNode.prototype.getValue = function () {
        return this.value_;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.compareTo = function (other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
            return 1;
        }
        else if (other instanceof LeafNode.__childrenNodeConstructor) {
            return -1;
        }
        else {
            util.assert(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     * @param {!LeafNode} otherLeaf
     * @return {!number}
     * @private
     */
    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
        var otherLeafType = typeof otherLeaf.value_;
        var thisLeafType = typeof this.value_;
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        util.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        util.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') {
                // Deferred value nodes are all equal, but we should also never get to this point...
                return 0;
            }
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) {
                    return -1;
                }
                else if (this.value_ === otherLeaf.value_) {
                    return 0;
                }
                else {
                    return 1;
                }
            }
        }
        else {
            return thisIndex - otherIndex;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.withIndex = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.isIndexed = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.equals = function (other) {
        /**
         * @inheritDoc
         */
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            var otherLeaf = other;
            return (this.value_ === otherLeaf.value_ &&
                this.priorityNode_.equals(otherLeaf.priorityNode_));
        }
        else {
            return false;
        }
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     * @type {Array.<!string>}
     * @const
     */
    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
    return LeafNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var nodeFromJSON;
var MAX_NODE$1;
function setNodeFromJSON(val) {
    nodeFromJSON = val;
}
function setMaxNode$1(val) {
    MAX_NODE$1 = val;
}
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var PriorityIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.compare = function (a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.isDefinedOn = function (node) {
        return !node.getPriority().isEmpty();
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.maxPost = function () {
        return new NamedNode(MAX_NAME, new LeafNode('[PRIORITY-POST]', MAX_NODE$1));
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    PriorityIndex.prototype.makePost = function (indexValue, name) {
        var priorityNode = nodeFromJSON(indexValue);
        return new NamedNode(name, new LeafNode('[PRIORITY-POST]', priorityNode));
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    PriorityIndex.prototype.toString = function () {
        return '.priority';
    };
    return PriorityIndex;
}(Index));
var PRIORITY_INDEX = new PriorityIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An iterator over an LLRBNode.
 */
var SortedMapIterator = /** @class */ (function () {
    /**
     * @template K, V, T
     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
     * @param {?K} startKey
     * @param {function(K, K): number} comparator
     * @param {boolean} isReverse_ Whether or not to iterate in reverse
     * @param {(function(K, V):T)=} resultGenerator_
     */
    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        /** @private
         * @type {Array.<!LLRBNode>}
         */
        this.nodeStack_ = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            node = node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_)
                cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_)
            result = this.resultGenerator_(node.key, node.value);
        else
            result = { key: node.key, value: node.value };
        if (this.isReverse_) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) {
            return this.resultGenerator_(node.key, node.value);
        }
        else {
            return { key: node.key, value: node.value };
        }
    };
    return SortedMapIterator;
}());
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */
var LLRBNode = /** @class */ (function () {
    /**
     * @template K, V
     * @param {!K} key Key associated with this node.
     * @param {!V} value Value associated with this node.
     * @param {?boolean} color Whether this node is red.
     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
     */
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left =
            left != null ? left : SortedMap.EMPTY_NODE;
        this.right =
            right != null ? right : SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param {?K} key New key for the node, or null.
     * @param {?V} value New value for the node, or null.
     * @param {?boolean} color New color for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
     * @return {!LLRBNode} The node copy.
     */
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBNode.prototype.count = function () {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!Object, !Object)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {*} True if traversal was aborted.
     */
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    /**
     * @return {!Object} The minimum node in the tree.
     * @private
     */
    LLRBNode.prototype.min_ = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min_();
        }
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.minKey = function () {
        return this.min_().key;
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    /**
     *
     * @param {!Object} key Key to insert.
     * @param {!Object} value Value to insert.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with the key/value added.
     */
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var cmp, n;
        n = this;
        cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
     */
    LLRBNode.prototype.removeMin_ = function () {
        if (this.left.isEmpty()) {
            return SortedMap.EMPTY_NODE;
        }
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_())
            n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param {!Object} key The key of the item to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
     */
    LLRBNode.prototype.remove = function (key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
                n = n.moveRedLeft_();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed_())
                n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
                n = n.moveRedRight_();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return SortedMap.EMPTY_NODE;
                }
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {boolean} Whether this is a RED node.
     */
    LLRBNode.prototype.isRed_ = function () {
        return this.color;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree after performing any needed rotations.
     */
    LLRBNode.prototype.fixUp_ = function () {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_())
            n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_())
            n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_())
            n = n.colorFlip_();
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedLeft.
     */
    LLRBNode.prototype.moveRedLeft_ = function () {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedRight.
     */
    LLRBNode.prototype.moveRedRight_ = function () {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateLeft.
     */
    LLRBNode.prototype.rotateLeft_ = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateRight.
     */
    LLRBNode.prototype.rotateRight_ = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after colorFlip.
     */
    LLRBNode.prototype.colorFlip_ = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @private
     * @return {boolean} True if all is well.
     */
    LLRBNode.prototype.checkMaxDepth_ = function () {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBNode.prototype.check_ = function () {
        var blackDepth;
        if (this.isRed_() && this.left.isRed_()) {
            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed_()) {
            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) {
            throw new Error('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed_() ? 0 : 1);
        }
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}());
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
    }
    /**
     * Returns a copy of the current node.
     *
     * @return {!LLRBEmptyNode} The node copy.
     */
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with item added.
     */
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBEmptyNode} New tree, with item removed.
     */
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBEmptyNode.prototype.count = function () {
        return 0;
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBEmptyNode.prototype.check_ = function () {
        return 0;
    };
    /**
     * @private
     * @return {boolean} Whether this node is red.
     */
    LLRBEmptyNode.prototype.isRed_ = function () {
        return false;
    };
    return LLRBEmptyNode;
}());
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */
var SortedMap = /** @class */ (function () {
    /**
     * @template K, V
     * @param {function(K, K):number} comparator_ Key comparator.
     * @param {LLRBNode=} root_ (Optional) Root node for the map.
     */
    function SortedMap(comparator_, root_) {
        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @return {!SortedMap.<K, V>} New map, with item added.
     */
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator_, this.root_
            .insert(key, value, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @return {!SortedMap.<K, V>} New map, with item removed.
     */
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator_, this.root_
            .remove(key, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param {!K} key The key to look up.
     * @return {?V} The value of the node with the given key, or null if the
     * key doesn't exist.
     */
    SortedMap.prototype.get = function (key) {
        var cmp;
        var node = this.root_;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param {K} key The key to find the predecessor of
     * @return {?K} The predecessor key.
     */
    SortedMap.prototype.getPredecessorKey = function (key) {
        var cmp, node = this.root_, rightParent = null;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while (!node.right.isEmpty())
                        node = node.right;
                    return node.key;
                }
                else if (rightParent) {
                    return rightParent.key;
                }
                else {
                    return null; // first item.
                }
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    };
    /**
     * @return {boolean} True if the map is empty.
     */
    SortedMap.prototype.isEmpty = function () {
        return this.root_.isEmpty();
    };
    /**
     * @return {number} The total number of nodes in the map.
     */
    SortedMap.prototype.count = function () {
        return this.root_.count();
    };
    /**
     * @return {?K} The minimum key in the map.
     */
    SortedMap.prototype.minKey = function () {
        return this.root_.minKey();
    };
    /**
     * @return {?K} The maximum key in the map.
     */
    SortedMap.prototype.maxKey = function () {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!K, !V):*} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!Object, !Object)} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} True if the traversal was aborted.
     */
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @template T
     * @param {(function(K, V):T)=} resultGenerator
     * @return {SortedMapIterator.<K, V, T>} The iterator.
     */
    SortedMap.prototype.getIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     * @const
     */
    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
    return SortedMap;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_2 = Math.log(2);
/**
 * @constructor
 */
var Base12Num = /** @class */ (function () {
    /**
     * @param {number} length
     */
    function Base12Num(length) {
        var logBase2 = function (num) {
            return parseInt((Math.log(num) / LOG_2), 10);
        };
        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = (length + 1) & mask;
    }
    /**
     * @return {boolean}
     */
    Base12Num.prototype.nextBitIsOne = function () {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & (0x1 << this.current_));
        this.current_--;
        return result;
    };
    return Base12Num;
}());
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @template K, V
 * @param {Array.<!NamedNode>} childList Unsorted list of children
 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
 *                                                        type is not NamedNode
 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
 * @return {SortedMap.<K, V>}
 */
var buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function (low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length == 0) {
            return null;
        }
        else if (length == 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
        }
        else {
            var middle = parseInt((length / 2), 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function (base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function (chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function (pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            }
            else {
                root = pennant;
                node = pennant;
            }
        };
        for (var i = 0; i < base12.count; ++i) {
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) {
                buildPennant(chunkSize, LLRBNode.BLACK);
            }
            else {
                // current == 2
                buildPennant(chunkSize, LLRBNode.BLACK);
                buildPennant(chunkSize, LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    return new SortedMap(mapSortFn || cmp, root);
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _defaultIndexMap;
var fallbackObject = {};
/**
 *
 * @param {Object.<string, FallbackType|SortedMap.<NamedNode, Node>>} indexes
 * @param {Object.<string, Index>} indexSet
 * @constructor
 */
var IndexMap = /** @class */ (function () {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         * @type {!IndexMap}
         * @const
         */
        get: function () {
            util.assert(fallbackObject && PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
            _defaultIndexMap =
                _defaultIndexMap ||
                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PRIORITY_INDEX });
            return _defaultIndexMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @param {!string} indexKey
     * @return {?SortedMap.<NamedNode, Node>}
     */
    IndexMap.prototype.get = function (indexKey) {
        var sortedMap = util.safeGet(this.indexes_, indexKey);
        if (!sortedMap)
            throw new Error('No index defined for ' + indexKey);
        if (sortedMap === fallbackObject) {
            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
            // regular child map
            return null;
        }
        else {
            return sortedMap;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {boolean}
     */
    IndexMap.prototype.hasIndex = function (indexDefinition) {
        return util.contains(this.indexSet_, indexDefinition.toString());
    };
    /**
     * @param {!Index} indexDefinition
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
        util.assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator(NamedNode.Wrap);
        var next = iter.getNext();
        while (next) {
            sawIndexedValue =
                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) {
            newIndex = buildChildSet(childList, indexDefinition.getCompare());
        }
        else {
            newIndex = fallbackObject;
        }
        var indexName = indexDefinition.toString();
        var newIndexSet = util.clone(this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = util.clone(this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
        var _this = this;
        var newIndexes = util.map(this.indexes_, function (indexedChildren, indexName) {
            var index = util.safeGet(_this.indexSet_, indexName);
            util.assert(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator(NamedNode.Wrap);
                    var next = iter.getNext();
                    while (next) {
                        if (next.name != namedNode.name) {
                            childList.push(next);
                        }
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return buildChildSet(childList, index.getCompare());
                }
                else {
                    // No change, this remains a fallback
                    return fallbackObject;
                }
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) {
                    newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
        var newIndexes = util.map(this.indexes_, function (indexedChildren) {
            if (indexedChildren === fallbackObject) {
                // This is the fallback. Just return it, nothing to do in this case
                return indexedChildren;
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) {
                    return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                else {
                    // No record of this child
                    return indexedChildren;
                }
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function NAME_ONLY_COMPARATOR(left, right) {
    return nameCompare(left.name, right.name);
}
function NAME_COMPARATOR(left, right) {
    return nameCompare(left, right);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: For memory savings, don't store priorityNode_ if it's empty.
var EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 *
 * @constructor
 * @implements {Node}
 */
var ChildrenNode = /** @class */ (function () {
    /**
     *
     * @param {!SortedMap.<string, !Node>} children_ List of children
     * of this node..
     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
     * @param {!IndexMap} indexMap_
     */
    function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */
        if (this.priorityNode_) {
            validatePriorityNode(this.priorityNode_);
        }
        if (this.children_.isEmpty()) {
            util.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
        }
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function () {
            return (EMPTY_NODE ||
                (EMPTY_NODE = new ChildrenNode(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default)));
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    ChildrenNode.prototype.isLeafNode = function () {
        return false;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPriority = function () {
        return this.priorityNode_ || EMPTY_NODE;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
        if (this.children_.isEmpty()) {
            // Don't allow priorities on empty nodes
            return this;
        }
        else {
            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.getPriority();
        }
        else {
            var child = this.children_.get(childName);
            return child === null ? EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getChild = function (path) {
        var front = path.getFront();
        if (front === null)
            return this;
        return this.getImmediateChild(front).getChild(path.popFront());
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hasChild = function (childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        util.assert(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else {
            var namedNode = new NamedNode(childName, newChildNode);
            var newChildren = void 0, newIndexMap = void 0, newPriority = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            }
            else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else {
            util.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.isEmpty = function () {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.numChildren = function () {
        return this.children_.count();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.val = function (exportFormat) {
        if (this.isEmpty())
            return null;
        var obj = {};
        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
                maxKey = Math.max(maxKey, Number(key));
            }
            else {
                allIntegerKeys = false;
            }
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            for (var key in obj)
                array[key] = obj[key];
            return array;
        }
        else {
            if (exportFormat && !this.getPriority().isEmpty()) {
                obj['.priority'] = this.getPriority().val();
            }
            return obj;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash_1 = '';
            if (!this.getPriority().isEmpty())
                toHash_1 +=
                    'priority:' +
                        priorityHashText(this.getPriority().val()) +
                        ':';
            this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== '')
                    toHash_1 += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash_1 === '' ? '' : sha1(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        }
        else {
            return this.children_.getPredecessorKey(childName);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        }
        else {
            return this.children_.minKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) {
            return new NamedNode(minKey, this.children_.get(minKey));
        }
        else {
            return null;
        }
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        }
        else {
            return this.children_.maxKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) {
            return new NamedNode(maxKey, this.children_.get(maxKey));
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.forEachChild = function (index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            return idx.inorderTraversal(function (wrappedNode) {
                return action(wrappedNode.name, wrappedNode.node);
            });
        }
        else {
            return this.children_.inorderTraversal(action);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {SortedMapIterator}
     */
    ChildrenNode.prototype.getIterator = function (indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    /**
     *
     * @param {!NamedNode} startPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getIteratorFrom(startPost, function (key) { return key; });
        }
        else {
            var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, startPost) < 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    /**
     * @param {!NamedNode} endPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getReverseIteratorFrom(endPost, function (key) {
                return key;
            });
        }
        else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, endPost) > 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.compareTo = function (other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) {
                return 0;
            }
            else {
                return -1;
            }
        }
        else if (other.isLeafNode() || other.isEmpty()) {
            return 1;
        }
        else if (other === MAX_NODE$2) {
            return -1;
        }
        else {
            // Must be another node with children.
            return 0;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.withIndex = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX ||
            this.indexMap_.hasIndex(indexDefinition)) {
            return this;
        }
        else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.isIndexed = function (index) {
        return index === KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.equals = function (other) {
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            return false;
        }
        else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
                return false;
            }
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator(PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while (thisCurrent && otherCurrent) {
                    if (thisCurrent.name !== otherCurrent.name ||
                        !thisCurrent.node.equals(otherCurrent.node)) {
                        return false;
                    }
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            }
            else {
                return false;
            }
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     * @private
     * @param {!Index} indexDefinition
     * @return {?SortedMap.<NamedNode, Node>}
     */
    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX) {
            return null;
        }
        else {
            return this.indexMap_.get(indexDefinition.toString());
        }
    };
    /**
     * @private
     * @type {RegExp}
     */
    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}());
/**
 * @constructor
 * @extends {ChildrenNode}
 * @private
 */
var MaxNode = /** @class */ (function (_super) {
    tslib_1.__extends(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function (other) {
        if (other === this) {
            return 0;
        }
        else {
            return 1;
        }
    };
    MaxNode.prototype.equals = function (other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function () {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function (childName) {
        return ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function () {
        return false;
    };
    return MaxNode;
}(ChildrenNode));
/**
 * Marker that will sort higher than any other snapshot.
 * @type {!MAX_NODE}
 * @const
 */
var MAX_NODE$2 = new MaxNode();
Object.defineProperties(NamedNode, {
    MIN: {
        value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new NamedNode(MAX_NAME, MAX_NODE$2)
    }
});
/**
 * Reference Extensions
 */
KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
LeafNode.__childrenNodeConstructor = ChildrenNode;
setMaxNode(MAX_NODE$2);
setMaxNode$1(MAX_NODE$2);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param {*} json JSON to create a node for.
 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 * @return {!Node}
 */
function nodeFromJSON$1(json, priority) {
    if (priority === void 0) { priority = null; }
    if (json === null) {
        return ChildrenNode.EMPTY_NODE;
    }
    if (typeof json === 'object' && '.priority' in json) {
        priority = json['.priority'];
    }
    util.assert(priority === null ||
        typeof priority === 'string' ||
        typeof priority === 'number' ||
        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
        json = json['.value'];
    }
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        var jsonLeaf = json;
        return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
    }
    if (!(json instanceof Array) && USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj_1 = json;
        util.forEach(hinzeJsonObj_1, function (key, child) {
            if (typeof key !== 'string' || key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                var childNode = nodeFromJSON$1(hinzeJsonObj_1[key]);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 =
                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length == 0) {
            return ChildrenNode.EMPTY_NODE;
        }
        var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ '.priority': sortedChildSet }, { '.priority': PRIORITY_INDEX }));
        }
        else {
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
        }
    }
    else {
        var node_1 = ChildrenNode.EMPTY_NODE;
        var jsonObj_1 = json;
        util.forEach(jsonObj_1, function (key, childData) {
            if (util.contains(jsonObj_1, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    var childNode = nodeFromJSON$1(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty())
                        node_1 = node_1.updateImmediateChild(key, childNode);
                }
            }
        });
        return node_1.updatePriority(nodeFromJSON$1(priority));
    }
}
setNodeFromJSON(nodeFromJSON$1);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var ValueIndex = /** @class */ (function (_super) {
    tslib_1.__extends(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.compare = function (a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.isDefinedOn = function (node) {
        return true;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.maxPost = function () {
        return NamedNode.MAX;
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    ValueIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        return new NamedNode(name, valueNode);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    ValueIndex.prototype.toString = function () {
        return '.value';
    };
    return ValueIndex;
}(Index));
var VALUE_INDEX = new ValueIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!Path} indexPath
 * @constructor
 * @extends {Index}
 */
var PathIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        util.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    /**
     * @param {!Node} snap
     * @return {!Node}
     * @protected
     */
    PathIndex.prototype.extractChild = function (snap) {
        return snap.getChild(this.indexPath_);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.isDefinedOn = function (node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.compare = function (a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new NamedNode(name, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.maxPost = function () {
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
        return new NamedNode(MAX_NAME, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.toString = function () {
        return this.indexPath_.slice().join('/');
    };
    return PathIndex;
}(Index));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */
var DataSnapshot = /** @class */ (function () {
    /**
     * @param {!Node} node_ A SnapshotNode to wrap.
     * @param {!Reference} ref_ The ref of the location this snapshot came from.
     * @param {!Index} index_ The iteration order for this snapshot
     */
    function DataSnapshot(node_, ref_, index_) {
        this.node_ = node_;
        this.ref_ = ref_;
        this.index_ = index_;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.val = function () {
        util.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
        return this.node_.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.exportVal = function () {
        util.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this.node_.val(true);
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function () {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        util.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this.exportVal();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
     */
    DataSnapshot.prototype.exists = function () {
        util.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
        return !this.node_.isEmpty();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param {!string} childPathString Path to a child.
     * @return {!DataSnapshot} DataSnapshot for child node.
     */
    DataSnapshot.prototype.child = function (childPathString) {
        util.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        childPathString = String(childPathString);
        validatePathString('DataSnapshot.child', 1, childPathString, false);
        var childPath = new Path(childPathString);
        var childRef = this.ref_.child(childPath);
        return new DataSnapshot(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param {!string} childPathString Path to a child.
     * @return {boolean} Whether the child exists.
     */
    DataSnapshot.prototype.hasChild = function (childPathString) {
        util.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
        validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
        var childPath = new Path(childPathString);
        return !this.node_.getChild(childPath).isEmpty();
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @return {string|number|null} The priority.
     */
    DataSnapshot.prototype.getPriority = function () {
        util.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this.node_.getPriority().val();
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param {function(!DataSnapshot)} action Callback function to be called
     * for each child.
     * @return {boolean} True if forEach was canceled by action returning true for
     * one of the child nodes.
     */
    DataSnapshot.prototype.forEach = function (action) {
        var _this = this;
        util.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
        util.validateCallback('DataSnapshot.forEach', 1, action, false);
        if (this.node_.isLeafNode())
            return false;
        var childrenNode = this.node_;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this.index_, function (key, node) {
            return action(new DataSnapshot(node, _this.ref_.child(key), PRIORITY_INDEX));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
     */
    DataSnapshot.prototype.hasChildren = function () {
        util.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
        if (this.node_.isLeafNode())
            return false;
        else
            return !this.node_.isEmpty();
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function () {
            return this.ref_.getKey();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @return {number} The number of children that this DataSnapshot contains.
     */
    DataSnapshot.prototype.numChildren = function () {
        util.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this.node_.numChildren();
    };
    /**
     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
     */
    DataSnapshot.prototype.getRef = function () {
        util.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
        return this.ref_;
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return DataSnapshot;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */
var DataEvent = /** @class */ (function () {
    /**
     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
     * @param {!DataSnapshot} snapshot The data backing the event
     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
     */
    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getPath = function () {
        var ref = this.snapshot.getRef();
        if (this.eventType === 'value') {
            return ref.path;
        }
        else {
            return ref.getParent().path;
        }
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventType = function () {
        return this.eventType;
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.toString = function () {
        return (this.getPath().toString() +
            ':' +
            this.eventType +
            ':' +
            util.stringify(this.snapshot.exportVal()));
    };
    return DataEvent;
}());
var CancelEvent = /** @class */ (function () {
    /**
     * @param {EventRegistration} eventRegistration
     * @param {Error} error
     * @param {!Path} path
     */
    function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getPath = function () {
        return this.path;
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventType = function () {
        return 'cancel';
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.toString = function () {
        return this.path.toString() + ':cancel';
    };
    return CancelEvent;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents registration for 'value' events.
 */
var ValueEventRegistration = /** @class */ (function () {
    /**
     * @param {?function(!DataSnapshot)} callback_
     * @param {?function(Error)} cancelCallback_
     * @param {?Object} context_
     */
    function ValueEventRegistration(callback_, cancelCallback_, context_) {
        this.callback_ = callback_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.respondsTo = function (eventType) {
        return eventType === 'value';
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createEvent = function (change, query) {
        var index = query.getQueryParams().getIndex();
        return new DataEvent('value', this, new DataSnapshot(change.snapshotNode, query.getRef(), index));
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_1 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_1.call(ctx, eventData.error);
            };
        }
        else {
            var cb_1 = this.callback_;
            return function () {
                cb_1.call(ctx, eventData.snapshot);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.matches = function (other) {
        if (!(other instanceof ValueEventRegistration)) {
            return false;
        }
        else if (!other.callback_ || !this.callback_) {
            // If no callback specified, we consider it to match any callback.
            return true;
        }
        else {
            return (other.callback_ === this.callback_ && other.context_ === this.context_);
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.hasAnyCallback = function () {
        return this.callback_ !== null;
    };
    return ValueEventRegistration;
}());
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */
var ChildEventRegistration = /** @class */ (function () {
    /**
     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
     * @param {?function(Error)} cancelCallback_
     * @param {Object=} context_
     */
    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
        this.callbacks_ = callbacks_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.respondsTo = function (eventType) {
        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck =
            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return util.contains(this.callbacks_, eventToCheck);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createEvent = function (change, query) {
        util.assert(change.childName != null, 'Child events should have a childName.');
        var ref = query.getRef().child(/** @type {!string} */ (change.childName));
        var index = query.getQueryParams().getIndex();
        return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref, index), change.prevName);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_2 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_2.call(ctx, eventData.error);
            };
        }
        else {
            var cb_2 = this.callbacks_[eventData.eventType];
            return function () {
                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.matches = function (other) {
        if (other instanceof ChildEventRegistration) {
            if (!this.callbacks_ || !other.callbacks_) {
                return true;
            }
            else if (this.context_ === other.context_) {
                var otherCount = util.getCount(other.callbacks_);
                var thisCount = util.getCount(this.callbacks_);
                if (otherCount === thisCount) {
                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
                    //  If event types don't match, not a match
                    // If count is not 1, exact match across all
                    if (otherCount === 1) {
                        var otherKey /** @type {!string} */ = util.getAnyKey(other.callbacks_);
                        var thisKey /** @type {!string} */ = util.getAnyKey(this.callbacks_);
                        return (thisKey === otherKey &&
                            (!other.callbacks_[otherKey] ||
                                !this.callbacks_[thisKey] ||
                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
                    }
                    else {
                        // Exact match on each key.
                        return util.every(this.callbacks_, function (eventType, cb) { return other.callbacks_[eventType] === cb; });
                    }
                }
            }
        }
        return false;
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.hasAnyCallback = function () {
        return this.callbacks_ !== null;
    };
    return ChildEventRegistration;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor;
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */
var Query = /** @class */ (function () {
    function Query(repo, path, queryParams_, orderByCalled_) {
        this.repo = repo;
        this.path = path;
        this.queryParams_ = queryParams_;
        this.orderByCalled_ = orderByCalled_;
    }
    Object.defineProperty(Query, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor, 'Reference.ts has not been loaded');
            return __referenceConstructor;
        },
        set: function (val) {
            __referenceConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Validates start/end values for queries.
     * @param {!QueryParams} params
     * @private
     */
    Query.validateQueryEndpoints_ = function (params) {
        var startNode = null;
        var endNode = null;
        if (params.hasStart()) {
            startNode = params.getIndexStartValue();
        }
        if (params.hasEnd()) {
            endNode = params.getIndexEndValue();
        }
        if (params.getIndex() === KEY_INDEX) {
            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
                'startAt(), endAt(), or equalTo().';
            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
                'or equalTo() must be a string.';
            if (params.hasStart()) {
                var startName = params.getIndexStartName();
                if (startName != MIN_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof startNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
            if (params.hasEnd()) {
                var endName = params.getIndexEndName();
                if (endName != MAX_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof endNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
        }
        else if (params.getIndex() === PRIORITY_INDEX) {
            if ((startNode != null && !isValidPriority(startNode)) ||
                (endNode != null && !isValidPriority(endNode))) {
                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
            }
        }
        else {
            util.assert(params.getIndex() instanceof PathIndex ||
                params.getIndex() === VALUE_INDEX, 'unknown index type.');
            if ((startNode != null && typeof startNode === 'object') ||
                (endNode != null && typeof endNode === 'object')) {
                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
                    'an object.');
            }
        }
    };
    /**
     * Validates that limit* has been called with the correct combination of parameters
     * @param {!QueryParams} params
     * @private
     */
    Query.validateLimit_ = function (params) {
        if (params.hasStart() &&
            params.hasEnd() &&
            params.hasLimit() &&
            !params.hasAnchoredLimit()) {
            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
        }
    };
    /**
     * Validates that no other order by call has been made
     * @param {!string} fnName
     * @private
     */
    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
        if (this.orderByCalled_ === true) {
            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
        }
    };
    /**
     * @return {!QueryParams}
     */
    Query.prototype.getQueryParams = function () {
        return this.queryParams_;
    };
    /**
     * @return {!Reference}
     */
    Query.prototype.getRef = function () {
        util.validateArgCount('Query.ref', 0, 0, arguments.length);
        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
        // method gets called.
        return new Query.__referenceConstructor(this.repo, this.path);
    };
    /**
     * @param {!string} eventType
     * @param {!function(DataSnapshot, string=)} callback
     * @param {(function(Error)|Object)=} cancelCallbackOrContext
     * @param {Object=} context
     * @return {!function(DataSnapshot, string=)}
     */
    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
        util.validateArgCount('Query.on', 2, 4, arguments.length);
        validateEventType('Query.on', 1, eventType, false);
        util.validateCallback('Query.on', 2, callback, false);
        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        if (eventType === 'value') {
            this.onValueEvent(callback, ret.cancel, ret.context);
        }
        else {
            var callbacks = {};
            callbacks[eventType] = callback;
            this.onChildEvent(callbacks, ret.cancel, ret.context);
        }
        return callback;
    };
    /**
     * @param {!function(!DataSnapshot)} callback
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
        var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
        var container = new ChildEventRegistration(callbacks, cancelCallback, context);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {string=} eventType
     * @param {(function(!DataSnapshot, ?string=))=} callback
     * @param {Object=} context
     */
    Query.prototype.off = function (eventType, callback, context) {
        util.validateArgCount('Query.off', 0, 3, arguments.length);
        validateEventType('Query.off', 1, eventType, true);
        util.validateCallback('Query.off', 2, callback, true);
        util.validateContextObject('Query.off', 3, context, true);
        var container = null;
        var callbacks = null;
        if (eventType === 'value') {
            var valueCallback = callback || null;
            container = new ValueEventRegistration(valueCallback, null, context || null);
        }
        else if (eventType) {
            if (callback) {
                callbacks = {};
                callbacks[eventType] = callback;
            }
            container = new ChildEventRegistration(callbacks, null, context || null);
        }
        this.repo.removeEventCallbackForQuery(this, container);
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     * @param {!string} eventType
     * @param {!function(!DataSnapshot, string=)} userCallback
     * @param cancelOrContext
     * @param context
     * @return {!firebase.Promise}
     */
    Query.prototype.once = function (eventType, userCallback, cancelOrContext, context) {
        var _this = this;
        util.validateArgCount('Query.once', 1, 4, arguments.length);
        validateEventType('Query.once', 1, eventType, false);
        util.validateCallback('Query.once', 2, userCallback, true);
        var ret = Query.getCancelAndContextArgs_('Query.once', cancelOrContext, context);
        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
        // against the Promise specification.
        var firstCall = true;
        var deferred = new util.Deferred();
        // A dummy error handler in case a user wasn't expecting promises
        deferred.promise.catch(function () { });
        var onceCallback = function (snapshot) {
            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
            // triggers multiple events (e.g. child_added or child_changed).
            if (firstCall) {
                firstCall = false;
                _this.off(eventType, onceCallback);
                if (userCallback) {
                    userCallback.bind(ret.context)(snapshot);
                }
                deferred.resolve(snapshot);
            }
        };
        this.on(eventType, onceCallback, 
        /*cancel=*/ function (err) {
            _this.off(eventType, onceCallback);
            if (ret.cancel)
                ret.cancel.bind(ret.context)(err);
            deferred.reject(err);
        });
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToFirst = function (limit) {
        util.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
    };
    /**
     * Set a limit and anchor it to the end of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToLast = function (limit) {
        util.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToLast: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     * @param {!string} path
     * @return {!Query}
     */
    Query.prototype.orderByChild = function (path) {
        util.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
        if (path === '$key') {
            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
        }
        else if (path === '$priority') {
            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
        }
        else if (path === '$value') {
            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
        }
        validatePathString('Query.orderByChild', 1, path, false);
        this.validateNoPreviousOrderByCall_('Query.orderByChild');
        var parsedPath = new Path(path);
        if (parsedPath.isEmpty()) {
            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
        }
        var index = new PathIndex(parsedPath);
        var newParams = this.queryParams_.orderBy(index);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the KeyIndex
     * @return {!Query}
     */
    Query.prototype.orderByKey = function () {
        util.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByKey');
        var newParams = this.queryParams_.orderBy(KEY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the PriorityIndex
     * @return {!Query}
     */
    Query.prototype.orderByPriority = function () {
        util.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
        var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the ValueIndex
     * @return {!Query}
     */
    Query.prototype.orderByValue = function () {
        util.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByValue');
        var newParams = this.queryParams_.orderBy(VALUE_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.startAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.startAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
        validateKey('Query.startAt', 2, name, true);
        var newParams = this.queryParams_.startAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
                'or equalTo).');
        }
        // Calling with no params tells us to start at the beginning.
        if (value === undefined) {
            value = null;
            name = null;
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.endAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.endAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
        validateKey('Query.endAt', 2, name, true);
        var newParams = this.queryParams_.endAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     * @param {number|string|boolean|null} value
     * @param {string=} name
     * @return {!Query}
     */
    Query.prototype.equalTo = function (value, name) {
        util.validateArgCount('Query.equalTo', 1, 2, arguments.length);
        validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
        validateKey('Query.equalTo', 2, name, true);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
                'equalTo).');
        }
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return this.startAt(value, name).endAt(value, name);
    };
    /**
     * @return {!string} URL for this location.
     */
    Query.prototype.toString = function () {
        util.validateArgCount('Query.toString', 0, 0, arguments.length);
        return this.repo.toString() + this.path.toUrlEncodedString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function () {
        // An optional spacer argument is unnecessary for a string.
        util.validateArgCount('Query.toJSON', 0, 1, arguments.length);
        return this.toString();
    };
    /**
     * An object representation of the query parameters used by this Query.
     * @return {!Object}
     */
    Query.prototype.queryObject = function () {
        return this.queryParams_.getQueryObject();
    };
    /**
     * @return {!string}
     */
    Query.prototype.queryIdentifier = function () {
        var obj = this.queryObject();
        var id = ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     * @param {Query} other
     * @return {boolean}
     */
    Query.prototype.isEqual = function (other) {
        util.validateArgCount('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error$$1 = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error$$1);
        }
        var sameRepo = this.repo === other.repo;
        var samePath = this.path.equals(other.path);
        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
        return sameRepo && samePath && sameQueryIdentifier;
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param {!string} fnName The function name (on or once)
     * @param {(function(Error)|Object)=} cancelOrContext
     * @param {Object=} context
     * @return {{cancel: ?function(Error), context: ?Object}}
     * @private
     */
    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
        var ret = { cancel: null, context: null };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            util.validateCallback(fnName, 3, ret.cancel, true);
            ret.context = context;
            util.validateContextObject(fnName, 4, ret.context, true);
        }
        else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
                // it's a context!
                ret.context = cancelOrContext;
            }
            else if (typeof cancelOrContext === 'function') {
                ret.cancel = cancelOrContext;
            }
            else {
                throw new Error(util.errorPrefix(fnName, 3, true) +
                    ' must either be a cancel callback or a context object.');
            }
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return Query;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements a set with a count of elements.
 *
 * @template K, V
 */
var CountedSet = /** @class */ (function () {
    function CountedSet() {
        this.set = {};
    }
    /**
     * @param {!K} item
     * @param {V} val
     */
    CountedSet.prototype.add = function (item, val) {
        this.set[item] = val !== null ? val : true;
    };
    /**
     * @param {!K} key
     * @return {boolean}
     */
    CountedSet.prototype.contains = function (key) {
        return util.contains(this.set, key);
    };
    /**
     * @param {!K} item
     * @return {V}
     */
    CountedSet.prototype.get = function (item) {
        return this.contains(item) ? this.set[item] : undefined;
    };
    /**
     * @param {!K} item
     */
    CountedSet.prototype.remove = function (item) {
        delete this.set[item];
    };
    /**
     * Deletes everything in the set
     */
    CountedSet.prototype.clear = function () {
        this.set = {};
    };
    /**
     * True if there's nothing in the set
     * @return {boolean}
     */
    CountedSet.prototype.isEmpty = function () {
        return util.isEmpty(this.set);
    };
    /**
     * @return {number} The number of items in the set
     */
    CountedSet.prototype.count = function () {
        return util.getCount(this.set);
    };
    /**
     * Run a function on each k,v pair in the set
     * @param {function(K, V)} fn
     */
    CountedSet.prototype.each = function (fn) {
        util.forEach(this.set, function (k, v) { return fn(k, v); });
    };
    /**
     * Mostly for debugging
     * @return {Array.<K>} The keys present in this CountedSet
     */
    CountedSet.prototype.keys = function () {
        var keys = [];
        util.forEach(this.set, function (k) {
            keys.push(k);
        });
        return keys;
    };
    return CountedSet;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper class to store a sparse set of snapshots.
 *
 * @constructor
 */
var SparseSnapshotTree = /** @class */ (function () {
    function SparseSnapshotTree() {
        /**
         * @private
         * @type {Node}
         */
        this.value_ = null;
        /**
         * @private
         * @type {CountedSet}
         */
        this.children_ = null;
    }
    /**
     * Gets the node stored at the given path if one exists.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {?Node} The retrieved node, or null.
     */
    SparseSnapshotTree.prototype.find = function (path) {
        if (this.value_ != null) {
            return this.value_.getChild(path);
        }
        else if (!path.isEmpty() && this.children_ != null) {
            var childKey = path.getFront();
            path = path.popFront();
            if (this.children_.contains(childKey)) {
                var childTree = this.children_.get(childKey);
                return childTree.find(path);
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    /**
     * Stores the given node at the specified path. If there is already a node
     * at a shallower path, it merges the new data into that snapshot node.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @param {!Node} data The new data, or null.
     */
    SparseSnapshotTree.prototype.remember = function (path, data) {
        if (path.isEmpty()) {
            this.value_ = data;
            this.children_ = null;
        }
        else if (this.value_ !== null) {
            this.value_ = this.value_.updateChild(path, data);
        }
        else {
            if (this.children_ == null) {
                this.children_ = new CountedSet();
            }
            var childKey = path.getFront();
            if (!this.children_.contains(childKey)) {
                this.children_.add(childKey, new SparseSnapshotTree());
            }
            var child = this.children_.get(childKey);
            path = path.popFront();
            child.remember(path, data);
        }
    };
    /**
     * Purge the data at path from the cache.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {boolean} True if this node should now be removed.
     */
    SparseSnapshotTree.prototype.forget = function (path) {
        if (path.isEmpty()) {
            this.value_ = null;
            this.children_ = null;
            return true;
        }
        else {
            if (this.value_ !== null) {
                if (this.value_.isLeafNode()) {
                    // We're trying to forget a node that doesn't exist
                    return false;
                }
                else {
                    var value = this.value_;
                    this.value_ = null;
                    var self_1 = this;
                    value.forEachChild(PRIORITY_INDEX, function (key, tree) {
                        self_1.remember(new Path(key), tree);
                    });
                    return this.forget(path);
                }
            }
            else if (this.children_ !== null) {
                var childKey = path.getFront();
                path = path.popFront();
                if (this.children_.contains(childKey)) {
                    var safeToRemove = this.children_.get(childKey).forget(path);
                    if (safeToRemove) {
                        this.children_.remove(childKey);
                    }
                }
                if (this.children_.isEmpty()) {
                    this.children_ = null;
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        }
    };
    /**
     * Recursively iterates through all of the stored tree and calls the
     * callback on each one.
     *
     * @param {!Path} prefixPath Path to look up node for.
     * @param {!Function} func The function to invoke for each tree.
     */
    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
        if (this.value_ !== null) {
            func(prefixPath, this.value_);
        }
        else {
            this.forEachChild(function (key, tree) {
                var path = new Path(prefixPath.toString() + '/' + key);
                tree.forEachTree(path, func);
            });
        }
    };
    /**
     * Iterates through each immediate child and triggers the callback.
     *
     * @param {!Function} func The function to invoke for each child.
     */
    SparseSnapshotTree.prototype.forEachChild = function (func) {
        if (this.children_ !== null) {
            this.children_.each(function (key, tree) {
                func(key, tree);
            });
        }
    };
    return SparseSnapshotTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Generate placeholders for deferred values.
 * @param {?Object} values
 * @return {!Object}
 */
var generateWithValues = function (values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 * @param {(Object|string|number|boolean)} value
 * @param {!Object} serverValues
 * @return {!(string|number|boolean)}
 */
var resolveDeferredValue = function (value, serverValues) {
    if (!value || typeof value !== 'object') {
        return value;
    }
    else {
        util.assert('.sv' in value, 'Unexpected leaf node or priority contents');
        return serverValues[value['.sv']];
    }
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param {!SparseSnapshotTree} tree
 * @param {!Object} serverValues
 * @return {!SparseSnapshotTree}
 */
var resolveDeferredValueTree = function (tree, serverValues) {
    var resolvedTree = new SparseSnapshotTree();
    tree.forEachTree(new Path(''), function (path, node) {
        resolvedTree.remember(path, resolveDeferredValueSnapshot(node, serverValues));
    });
    return resolvedTree;
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 * @param {!Node} node
 * @param {!Object} serverValues
 * @return {!Node}
 */
var resolveDeferredValueSnapshot = function (node, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = resolveDeferredValue(rawPri, serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = resolveDeferredValue(leafNode.getValue(), serverValues);
        if (value !== leafNode.getValue() ||
            priority !== leafNode.getPriority().val()) {
            return new LeafNode(value, nodeFromJSON$1(priority));
        }
        else {
            return node;
        }
    }
    else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) {
            newNode = newNode.updatePriority(new LeafNode(priority));
        }
        childrenNode.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
            var newChildNode = resolveDeferredValueSnapshot(childNode, serverValues);
            if (newChildNode !== childNode) {
                newNode = newNode.updateImmediateChild(childName, newChildNode);
            }
        });
        return newNode;
    }
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @enum
 */
var OperationType;
(function (OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})(OperationType || (OperationType = {}));
/**
 * @param {boolean} fromUser
 * @param {boolean} fromServer
 * @param {?string} queryId
 * @param {boolean} tagged
 * @constructor
 */
var OperationSource = /** @class */ (function () {
    function OperationSource(fromUser, fromServer, queryId, tagged) {
        this.fromUser = fromUser;
        this.fromServer = fromServer;
        this.queryId = queryId;
        this.tagged = tagged;
        util.assert(!tagged || fromServer, 'Tagged queries must be from server.');
    }
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.User = new OperationSource(
    /*fromUser=*/ true, false, null, 
    /*tagged=*/ false);
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.Server = new OperationSource(false, 
    /*fromServer=*/ true, null, 
    /*tagged=*/ false);
    /**
     * @param {string} queryId
     * @return {!OperationSource}
     */
    OperationSource.forServerTaggedQuery = function (queryId) {
        return new OperationSource(false, 
        /*fromServer=*/ true, queryId, 
        /*tagged=*/ true);
    };
    return OperationSource;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AckUserWrite = /** @class */ (function () {
    /**
     *
     * @param {!Path} path
     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
     * @param {!boolean} revert
     */
    function AckUserWrite(
    /**@inheritDoc */ path, 
    /**@inheritDoc */ affectedTree, 
    /**@inheritDoc */ revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */
        this.type = OperationType.ACK_USER_WRITE;
        /** @inheritDoc */
        this.source = OperationSource.User;
    }
    /**
     * @inheritDoc
     */
    AckUserWrite.prototype.operationForChild = function (childName) {
        if (!this.path.isEmpty()) {
            util.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
        }
        else if (this.affectedTree.value != null) {
            util.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        }
        else {
            var childTree = this.affectedTree.subtree(new Path(childName));
            return new AckUserWrite(Path.Empty, childTree, this.revert);
        }
    };
    return AckUserWrite;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 * @const
 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
 */
var EmptyChildren = function () {
    if (!emptyChildrenSingleton) {
        emptyChildrenSingleton = new SortedMap(stringCompare);
    }
    return emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */
var ImmutableTree = /** @class */ (function () {
    /**
     * @template T
     * @param {?T} value
     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
     */
    function ImmutableTree(value, children) {
        if (children === void 0) { children = EmptyChildren(); }
        this.value = value;
        this.children = children;
    }
    /**
     * @template T
     * @param {!Object.<string, !T>} obj
     * @return {!ImmutableTree.<!T>}
     */
    ImmutableTree.fromObject = function (obj) {
        var tree = ImmutableTree.Empty;
        util.forEach(obj, function (childPath, childSnap) {
            tree = tree.set(new Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     * @return {boolean}
     */
    ImmutableTree.prototype.isEmpty = function () {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
     * on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param {!Path} relativePath The remainder of the path
     * @param {function(T):boolean} predicate The predicate to satisfy to return a
     *   node
     * @return {?{path:!Path, value:!T}}
     */
    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
        if (this.value != null && predicate(this.value)) {
            return { path: Path.Empty, value: this.value };
        }
        else {
            if (relativePath.isEmpty()) {
                return null;
            }
            else {
                var front = relativePath.getFront();
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = new Path(front).child(childExistingPathAndValue.path);
                        return { path: fullPath, value: childExistingPathAndValue.value };
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     * @param {!Path} relativePath
     * @return {?{path: !Path, value: !T}}
     */
    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
    };
    /**
     * @param {!Path} relativePath
     * @return {!ImmutableTree.<T>} The subtree at the given path
     */
    ImmutableTree.prototype.subtree = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this;
        }
        else {
            var front = relativePath.getFront();
            var childTree = this.children.get(front);
            if (childTree !== null) {
                return childTree.subtree(relativePath.popFront());
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param {!Path} relativePath Path to set value at.
     * @param {?T} toSet Value to set.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.set = function (relativePath, toSet) {
        if (relativePath.isEmpty()) {
            return new ImmutableTree(toSet, this.children);
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.set(relativePath.popFront(), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param {!Path} relativePath Path to value to remove.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.remove = function (relativePath) {
        if (relativePath.isEmpty()) {
            if (this.children.isEmpty()) {
                return ImmutableTree.Empty;
            }
            else {
                return new ImmutableTree(null, this.children);
            }
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove(relativePath.popFront());
                var newChildren = void 0;
                if (newChild.isEmpty()) {
                    newChildren = this.children.remove(front);
                }
                else {
                    newChildren = this.children.insert(front, newChild);
                }
                if (this.value === null && newChildren.isEmpty()) {
                    return ImmutableTree.Empty;
                }
                else {
                    return new ImmutableTree(this.value, newChildren);
                }
            }
            else {
                return this;
            }
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param {!Path} relativePath Path to get value for.
     * @return {?T} Value at path, or null.
     */
    ImmutableTree.prototype.get = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this.value;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                return child.get(relativePath.popFront());
            }
            else {
                return null;
            }
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param {!Path} relativePath Path to replace subtree for.
     * @param {!ImmutableTree} newTree New tree.
     * @return {!ImmutableTree} Resulting tree.
     */
    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
        if (relativePath.isEmpty()) {
            return newTree;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.setTree(relativePath.popFront(), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) {
                newChildren = this.children.remove(front);
            }
            else {
                newChildren = this.children.insert(front, newChild);
            }
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     * @template V
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     */
    ImmutableTree.prototype.fold = function (fn) {
        return this.fold_(Path.Empty, fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     * @template V
     * @param {!Path} pathSoFar
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     * @private
     */
    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function (childKey, childTree) {
            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     * @template V
     * @param {!Path} path
     * @param {!function(!Path, !T):?V} f
     * @return {?V}
     */
    ImmutableTree.prototype.findOnPath = function (path, f) {
        return this.findOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) {
            return result;
        }
        else {
            if (pathToFollow.isEmpty()) {
                return null;
            }
            else {
                var front = pathToFollow.getFront();
                var nextChild = this.children.get(front);
                if (nextChild) {
                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     *
     * @param {!Path} path
     * @param {!function(!Path, !T)} f
     * @returns {!ImmutableTree.<T>}
     */
    ImmutableTree.prototype.foreachOnPath = function (path, f) {
        return this.foreachOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
        if (pathToFollow.isEmpty()) {
            return this;
        }
        else {
            if (this.value) {
                f(currentRelativePath, this.value);
            }
            var front = pathToFollow.getFront();
            var nextChild = this.children.get(front);
            if (nextChild) {
                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param {function(!Path, !T)} f A function to be called with
     *   the path from the root of the tree to a node, and the value at that node.
     *   Called in depth-first order.
     */
    ImmutableTree.prototype.foreach = function (f) {
        this.foreach_(Path.Empty, f);
    };
    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
        this.children.inorderTraversal(function (childName, childTree) {
            childTree.foreach_(currentRelativePath.child(childName), f);
        });
        if (this.value) {
            f(currentRelativePath, this.value);
        }
    };
    /**
     *
     * @param {function(string, !T)} f
     */
    ImmutableTree.prototype.foreachChild = function (f) {
        this.children.inorderTraversal(function (childName, childTree) {
            if (childTree.value) {
                f(childName, childTree.value);
            }
        });
    };
    ImmutableTree.Empty = new ImmutableTree(null);
    return ImmutableTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */
var ListenComplete = /** @class */ (function () {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */
        this.type = OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new ListenComplete(this.source, Path.Empty);
        }
        else {
            return new ListenComplete(this.source, this.path.popFront());
        }
    };
    return ListenComplete;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */
var Overwrite = /** @class */ (function () {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */
        this.type = OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new Overwrite(this.source, Path.Empty, this.snap.getImmediateChild(childName));
        }
        else {
            return new Overwrite(this.source, this.path.popFront(), this.snap);
        }
    };
    return Overwrite;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.<!Node>} children
 * @constructor
 * @implements {Operation}
 */
var Merge = /** @class */ (function () {
    function Merge(
    /**@inheritDoc */ source, 
    /**@inheritDoc */ path, 
    /**@inheritDoc */ children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */
        this.type = OperationType.MERGE;
    }
    /**
     * @inheritDoc
     */
    Merge.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            var childTree = this.children.subtree(new Path(childName));
            if (childTree.isEmpty()) {
                // This child is unaffected
                return null;
            }
            else if (childTree.value) {
                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
                return new Overwrite(this.source, Path.Empty, childTree.value);
            }
            else {
                // This is a merge at a deeper level
                return new Merge(this.source, Path.Empty, childTree);
            }
        }
        else {
            util.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, this.path.popFront(), this.children);
        }
    };
    /**
     * @inheritDoc
     */
    Merge.prototype.toString = function () {
        return ('Operation(' +
            this.path +
            ': ' +
            this.source.toString() +
            ' merge: ' +
            this.children.toString() +
            ')');
    };
    return Merge;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */
var CacheNode = /** @class */ (function () {
    /**
     * @param {!Node} node_
     * @param {boolean} fullyInitialized_
     * @param {boolean} filtered_
     */
    function CacheNode(node_, fullyInitialized_, filtered_) {
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     * @return {boolean}
     */
    CacheNode.prototype.isFullyInitialized = function () {
        return this.fullyInitialized_;
    };
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     * @return {boolean}
     */
    CacheNode.prototype.isFiltered = function () {
        return this.filtered_;
    };
    /**
     * @param {!Path} path
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForPath = function (path) {
        if (path.isEmpty()) {
            return this.isFullyInitialized() && !this.filtered_;
        }
        var childKey = path.getFront();
        return this.isCompleteForChild(childKey);
    };
    /**
     * @param {!string} key
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForChild = function (key) {
        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
    };
    /**
     * @return {!Node}
     */
    CacheNode.prototype.getNode = function () {
        return this.node_;
    };
    return CacheNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Stores the data we have cached for a view.
 *
 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
 *
 * @constructor
 */
var ViewCache = /** @class */ (function () {
    /**
     *
     * @param {!CacheNode} eventCache_
     * @param {!CacheNode} serverCache_
     */
    function ViewCache(eventCache_, serverCache_) {
        this.eventCache_ = eventCache_;
        this.serverCache_ = serverCache_;
    }
    /**
     * @param {!Node} eventSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
        return new ViewCache(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
    };
    /**
     * @param {!Node} serverSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
        return new ViewCache(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getEventCache = function () {
        return this.eventCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteEventSnap = function () {
        return this.eventCache_.isFullyInitialized()
            ? this.eventCache_.getNode()
            : null;
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getServerCache = function () {
        return this.serverCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteServerSnap = function () {
        return this.serverCache_.isFullyInitialized()
            ? this.serverCache_.getNode()
            : null;
    };
    /**
     * @const
     * @type {ViewCache}
     */
    ViewCache.Empty = new ViewCache(new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false), new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false));
    return ViewCache;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 * @param {!string} type The event type
 * @param {!Node} snapshotNode The data
 * @param {string=} childName The name for this child, if it's a child event
 * @param {Node=} oldSnap Used for intermediate processing of child changed events
 * @param {string=} prevName The name for the previous child, if applicable
 */
var Change = /** @class */ (function () {
    function Change(type, snapshotNode, childName, oldSnap, prevName) {
        this.type = type;
        this.snapshotNode = snapshotNode;
        this.childName = childName;
        this.oldSnap = oldSnap;
        this.prevName = prevName;
    }
    /**
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.valueChange = function (snapshot) {
        return new Change(Change.VALUE, snapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childAddedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_ADDED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childRemovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} newSnapshot
     * @param {!Node} oldSnapshot
     * @return {!Change}
     */
    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childMovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_MOVED, snapshot, childKey);
    };
    //event types
    /** Event type for a child added */
    Change.CHILD_ADDED = 'child_added';
    /** Event type for a child removed */
    Change.CHILD_REMOVED = 'child_removed';
    /** Event type for a child changed */
    Change.CHILD_CHANGED = 'child_changed';
    /** Event type for a child moved */
    Change.CHILD_MOVED = 'child_moved';
    /** Event type for a value change */
    Change.VALUE = 'value';
    return Change;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 *
 * @constructor
 * @implements {NodeFilter}
 * @param {!Index} index
 */
var IndexedFilter = /** @class */ (function () {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        util.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() == newChild.isEmpty()) {
                // Nothing changed.
                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
                return snap;
            }
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) {
                    optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
                }
                else {
                    util.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
                }
            }
            else if (oldChild.isEmpty()) {
                optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
            }
            else {
                optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
            }
        }
        if (snap.isLeafNode() && newChild.isEmpty()) {
            return snap;
        }
        else {
            // Make sure the node is indexed
            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) {
                oldSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (!newSnap.hasChild(key)) {
                        optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
                    }
                });
            }
            if (!newSnap.isLeafNode()) {
                newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (oldSnap.hasChild(key)) {
                        var oldChild = oldSnap.getImmediateChild(key);
                        if (!oldChild.equals(childNode)) {
                            optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
                        }
                    }
                    else {
                        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
                    }
                });
            }
        }
        return newSnap.withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        if (oldSnap.isEmpty()) {
            return ChildrenNode.EMPTY_NODE;
        }
        else {
            return oldSnap.updatePriority(newPriority);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.filtersNodes = function () {
        return false;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndexedFilter = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    return IndexedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var ChildChangeAccumulator = /** @class */ (function () {
    function ChildChangeAccumulator() {
        this.changeMap_ = {};
    }
    /**
     * @param {!Change} change
     */
    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
        var type = change.type;
        var childKey /** @type {!string} */ = change.childName;
        util.assert(type == Change.CHILD_ADDED ||
            type == Change.CHILD_CHANGED ||
            type == Change.CHILD_REMOVED, 'Only child changes supported for tracking');
        util.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        var oldChange = util.safeGet(this.changeMap_, childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type == Change.CHILD_ADDED && oldType == Change.CHILD_REMOVED) {
                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode);
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_ADDED) {
                delete this.changeMap_[childKey];
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change.childRemovedChange(childKey, oldChange.oldSnap);
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_ADDED) {
                this.changeMap_[childKey] = Change.childAddedChange(childKey, change.snapshotNode);
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap);
            }
            else {
                throw util.assertionError('Illegal combination of changes: ' +
                    change +
                    ' occurred after ' +
                    oldChange);
            }
        }
        else {
            this.changeMap_[childKey] = change;
        }
    };
    /**
     * @return {!Array.<!Change>}
     */
    ChildChangeAccumulator.prototype.getChanges = function () {
        return util.getValues(this.changeMap_);
    };
    return ChildChangeAccumulator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */
var NoCompleteChildSource_ = /** @class */ (function () {
    function NoCompleteChildSource_() {
    }
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
        return null;
    };
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}());
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */
var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */
var WriteTreeCompleteChildSource = /** @class */ (function () {
    /**
     * @param {!WriteTreeRef} writes_
     * @param {!ViewCache} viewCache_
     * @param {?Node} optCompleteServerCache_
     */
    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
        var node = this.viewCache_.getEventCache();
        if (node.isCompleteForChild(childKey)) {
            return node.getNode().getImmediateChild(childKey);
        }
        else {
            var serverNode = this.optCompleteServerCache_ != null
                ? new CacheNode(this.optCompleteServerCache_, true, false)
                : this.viewCache_.getServerCache();
            return this.writes_.calcCompleteChild(childKey, serverNode);
        }
    };
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null
            ? this.optCompleteServerCache_
            : this.viewCache_.getCompleteServerSnap();
        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) {
            return null;
        }
        else {
            return nodes[0];
        }
    };
    return WriteTreeCompleteChildSource;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 */
var ProcessorResult = /** @class */ (function () {
    /**
     * @param {!ViewCache} viewCache
     * @param {!Array.<!Change>} changes
     */
    function ProcessorResult(viewCache, changes) {
        this.viewCache = viewCache;
        this.changes = changes;
    }
    return ProcessorResult;
}());
/**
 * @constructor
 */
var ViewProcessor = /** @class */ (function () {
    /**
     * @param {!NodeFilter} filter_
     */
    function ViewProcessor(filter_) {
        this.filter_ = filter_;
    }
    /**
     * @param {!ViewCache} viewCache
     */
    ViewProcessor.prototype.assertIndexed = function (viewCache) {
        util.assert(viewCache
            .getEventCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
        util.assert(viewCache
            .getServerCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @return {!ProcessorResult}
     */
    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
        var accumulator = new ChildChangeAccumulator();
        var newViewCache, filterServerNode;
        if (operation.type === OperationType.OVERWRITE) {
            var overwrite = operation;
            if (overwrite.source.fromUser) {
                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(overwrite.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered  and the
                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
                // again
                filterServerNode =
                    overwrite.source.tagged ||
                        (oldViewCache.getServerCache().isFiltered() &&
                            !overwrite.path.isEmpty());
                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.MERGE) {
            var merge = operation;
            if (merge.source.fromUser) {
                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(merge.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered
                filterServerNode =
                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.ACK_USER_WRITE) {
            var ackUserWrite = operation;
            if (!ackUserWrite.revert) {
                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
            }
            else {
                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
            }
        }
        else if (operation.type === OperationType.LISTEN_COMPLETE) {
            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
        }
        else {
            throw util.assertionError('Unknown operation type: ' + operation.type);
        }
        var changes = accumulator.getChanges();
        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
        return new ProcessorResult(newViewCache, changes);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!ViewCache} newViewCache
     * @param {!Array.<!Change>} accumulator
     * @private
     */
    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
        var eventSnap = newViewCache.getEventCache();
        if (eventSnap.isFullyInitialized()) {
            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
            if (accumulator.length > 0 ||
                !oldViewCache.getEventCache().isFullyInitialized() ||
                (isLeafOrEmpty &&
                    !eventSnap
                        .getNode()
                        .equals(/** @type {!Node} */ (oldCompleteSnap))) ||
                !eventSnap
                    .getNode()
                    .getPriority()
                    .equals(oldCompleteSnap.getPriority())) {
                accumulator.push(Change.valueChange(
                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
            }
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} changePath
     * @param {!WriteTreeRef} writesCache
     * @param {!CompleteChildSource} source
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
        var oldEventSnap = viewCache.getEventCache();
        if (writesCache.shadowingWrite(changePath) != null) {
            // we have a shadowing write, ignore changes
            return viewCache;
        }
        else {
            var newEventCache = void 0, serverNode = void 0;
            if (changePath.isEmpty()) {
                // TODO: figure out how this plays with "sliding ack windows"
                util.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
                if (viewCache.getServerCache().isFiltered()) {
                    // We need to special case this, because we need to only apply writes to complete children, or
                    // we might end up raising events for incomplete children. If the server data is filtered deep
                    // writes cannot be guaranteed to be complete
                    var serverCache = viewCache.getCompleteServerSnap();
                    var completeChildren = serverCache instanceof ChildrenNode
                        ? serverCache
                        : ChildrenNode.EMPTY_NODE;
                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
                }
                else {
                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
                }
            }
            else {
                var childKey = changePath.getFront();
                if (childKey == '.priority') {
                    util.assert(changePath.getLength() == 1, "Can't have a priority with additional path components");
                    var oldEventNode = oldEventSnap.getNode();
                    serverNode = viewCache.getServerCache().getNode();
                    // we might have overwrites for this priority
                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
                    if (updatedPriority != null) {
                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
                    }
                    else {
                        // priority didn't change, keep old node
                        newEventCache = oldEventSnap.getNode();
                    }
                }
                else {
                    var childChangePath = changePath.popFront();
                    // update child
                    var newEventChild = void 0;
                    if (oldEventSnap.isCompleteForChild(childKey)) {
                        serverNode = viewCache.getServerCache().getNode();
                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
                        if (eventChildUpdate != null) {
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey)
                                .updateChild(childChangePath, eventChildUpdate);
                        }
                        else {
                            // Nothing changed, just keep the old child
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey);
                        }
                    }
                    else {
                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                    }
                    if (newEventChild != null) {
                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                    }
                    else {
                        // no complete child available or no change
                        newEventCache = oldEventSnap.getNode();
                    }
                }
            }
            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
        }
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
        var oldServerSnap = oldViewCache.getServerCache();
        var newServerCache;
        var serverFilter = filterServerNode
            ? this.filter_
            : this.filter_.getIndexedFilter();
        if (changePath.isEmpty()) {
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
        }
        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
            var newServerNode = oldServerSnap
                .getNode()
                .updateChild(changePath, changedSnap);
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
        }
        else {
            var childKey = changePath.getFront();
            if (!oldServerSnap.isCompleteForPath(changePath) &&
                changePath.getLength() > 1) {
                // We don't update incomplete nodes with updates intended for other listeners
                return oldViewCache;
            }
            var childChangePath = changePath.popFront();
            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
            if (childKey == '.priority') {
                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
            }
            else {
                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
            }
        }
        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
        var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
        var oldEventSnap = oldViewCache.getEventCache();
        var newViewCache, newEventCache;
        var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
        if (changePath.isEmpty()) {
            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
        }
        else {
            var childKey = changePath.getFront();
            if (childKey === '.priority') {
                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
            }
            else {
                var childChangePath = changePath.popFront();
                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
                var newChild = void 0;
                if (childChangePath.isEmpty()) {
                    // Child overwrite, we can replace the child
                    newChild = changedSnap;
                }
                else {
                    var childNode = source.getCompleteChild(childKey);
                    if (childNode != null) {
                        if (childChangePath.getBack() === '.priority' &&
                            childNode.getChild(childChangePath.parent()).isEmpty()) {
                            // This is a priority update on an empty node. If this node exists on the server, the
                            // server will send down the priority in the update, so ignore for now
                            newChild = childNode;
                        }
                        else {
                            newChild = childNode.updateChild(childChangePath, changedSnap);
                        }
                    }
                    else {
                        // There is no complete child node available
                        newChild = ChildrenNode.EMPTY_NODE;
                    }
                }
                if (!oldChild.equals(newChild)) {
                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
                }
                else {
                    newViewCache = oldViewCache;
                }
            }
        }
        return newViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {string} childKey
     * @return {boolean}
     * @private
     */
    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
        return viewCache.getEventCache().isCompleteForChild(childKey);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
        var _this = this;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!Node} node
     * @param {ImmutableTree.<!Node>} merge
     * @return {!Node}
     * @private
     */
    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
        merge.foreach(function (relativePath, childNode) {
            node = node.updateChild(relativePath, childNode);
        });
        return node;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
        var _this = this;
        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
        // wait for the complete data update coming soon.
        if (viewCache
            .getServerCache()
            .getNode()
            .isEmpty() &&
            !viewCache.getServerCache().isFullyInitialized()) {
            return viewCache;
        }
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        var viewMergeTree;
        if (path.isEmpty()) {
            viewMergeTree = changedChildren;
        }
        else {
            viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
        }
        var serverNode = viewCache.getServerCache().getNode();
        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
            if (serverNode.hasChild(childKey)) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
                childMergeTree.value == null;
            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childMergeTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} ackPath
     * @param {!ImmutableTree<!boolean>} affectedTree
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
        if (writesCache.shadowingWrite(ackPath) != null) {
            return viewCache;
        }
        // Only filter server node if it is currently filtered
        var filterServerNode = viewCache.getServerCache().isFiltered();
        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
        // now that it won't be shadowed.
        var serverCache = viewCache.getServerCache();
        if (affectedTree.value != null) {
            // This is an overwrite.
            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
                serverCache.isCompleteForPath(ackPath)) {
                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
            }
            else if (ackPath.isEmpty()) {
                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
                // should just re-apply whatever we have in our cache as a merge.
                var changedChildren_1 = ImmutableTree.Empty;
                serverCache.getNode().forEachChild(KEY_INDEX, function (name, node) {
                    changedChildren_1 = changedChildren_1.set(new Path(name), node);
                });
                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
            }
            else {
                return viewCache;
            }
        }
        else {
            // This is a merge.
            var changedChildren_2 = ImmutableTree.Empty;
            affectedTree.foreach(function (mergePath, value) {
                var serverCachePath = ackPath.child(mergePath);
                if (serverCache.isCompleteForPath(serverCachePath)) {
                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
                }
            });
            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
        var oldServerNode = viewCache.getServerCache();
        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
        var complete;
        if (writesCache.shadowingWrite(path) != null) {
            return viewCache;
        }
        else {
            var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
            var oldEventCache = viewCache.getEventCache().getNode();
            var newEventCache = void 0;
            if (path.isEmpty() || path.getFront() === '.priority') {
                var newNode = void 0;
                if (viewCache.getServerCache().isFullyInitialized()) {
                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                }
                else {
                    var serverChildren = viewCache.getServerCache().getNode();
                    util.assert(serverChildren instanceof ChildrenNode, 'serverChildren would be complete if leaf node');
                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
                }
                newNode = newNode;
                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
            }
            else {
                var childKey = path.getFront();
                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                if (newChild == null &&
                    viewCache.getServerCache().isCompleteForChild(childKey)) {
                    newChild = oldEventCache.getImmediateChild(childKey);
                }
                if (newChild != null) {
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
                }
                else if (viewCache
                    .getEventCache()
                    .getNode()
                    .hasChild(childKey)) {
                    // No complete child available, delete the existing one, if any
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
                }
                else {
                    newEventCache = oldEventCache;
                }
                if (newEventCache.isEmpty() &&
                    viewCache.getServerCache().isFullyInitialized()) {
                    // We might have reverted all child writes. Maybe the old event was a leaf node
                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    if (complete.isLeafNode()) {
                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
                    }
                }
            }
            complete =
                viewCache.getServerCache().isFullyInitialized() ||
                    writesCache.shadowingWrite(Path.Empty) != null;
            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
        }
    };
    return ViewProcessor;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */
var EventGenerator = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     */
    function EventGenerator(query_) {
        this.query_ = query_;
        /**
         * @private
         * @type {!Index}
         */
        this.index_ = this.query_.getQueryParams().getIndex();
    }
    /**
     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
     *
     * Notes:
     *  - child_moved events will be synthesized at this time for any child_changed events that affect
     *    our index.
     *  - prevName will be calculated based on the index ordering.
     *
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {!Array.<!EventRegistration>} eventRegistrations
     * @return {!Array.<!Event>}
     */
    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
        var _this = this;
        var events = [];
        var moves = [];
        changes.forEach(function (change) {
            if (change.type === Change.CHILD_CHANGED &&
                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
                moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
            }
        });
        this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
        return events;
    };
    /**
     * Given changes of a single change type, generate the corresponding events.
     *
     * @param {!Array.<!Event>} events
     * @param {!string} eventType
     * @param {!Array.<!Change>} changes
     * @param {!Array.<!EventRegistration>} registrations
     * @param {!Node} eventCache
     * @private
     */
    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
        var _this = this;
        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
        filteredChanges.sort(this.compareChanges_.bind(this));
        filteredChanges.forEach(function (change) {
            var materializedChange = _this.materializeSingleChange_(change, eventCache);
            registrations.forEach(function (registration) {
                if (registration.respondsTo(change.type)) {
                    events.push(registration.createEvent(materializedChange, _this.query_));
                }
            });
        });
    };
    /**
     * @param {!Change} change
     * @param {!Node} eventCache
     * @return {!Change}
     * @private
     */
    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
        if (change.type === 'value' || change.type === 'child_removed') {
            return change;
        }
        else {
            change.prevName = eventCache.getPredecessorChildName(
            /** @type {!string} */
            change.childName, change.snapshotNode, this.index_);
            return change;
        }
    };
    /**
     * @param {!Change} a
     * @param {!Change} b
     * @return {number}
     * @private
     */
    EventGenerator.prototype.compareChanges_ = function (a, b) {
        if (a.childName == null || b.childName == null) {
            throw util.assertionError('Should only compare child_ events.');
        }
        var aWrapped = new NamedNode(a.childName, a.snapshotNode);
        var bWrapped = new NamedNode(b.childName, b.snapshotNode);
        return this.index_.compare(aWrapped, bWrapped);
    };
    return EventGenerator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 * @constructor
 */
var View = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     * @param {!ViewCache} initialViewCache
     */
    function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_.getQueryParams();
        var indexFilter = new IndexedFilter(params.getIndex());
        var filter = params.getNodeFilter();
        /**
         * @type {ViewProcessor}
         * @private
         */
        this.processor_ = new ViewProcessor(filter);
        var initialServerCache = initialViewCache.getServerCache();
        var initialEventCache = initialViewCache.getEventCache();
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        /**
         * @type {!ViewCache}
         * @private
         */
        this.viewCache_ = new ViewCache(newEventCache, newServerCache);
        /**
         * @type {!EventGenerator}
         * @private
         */
        this.eventGenerator_ = new EventGenerator(this.query_);
    }
    /**
     * @return {!Query}
     */
    View.prototype.getQuery = function () {
        return this.query_;
    };
    /**
     * @return {?Node}
     */
    View.prototype.getServerCache = function () {
        return this.viewCache_.getServerCache().getNode();
    };
    /**
     * @param {!Path} path
     * @return {?Node}
     */
    View.prototype.getCompleteServerCache = function (path) {
        var cache = this.viewCache_.getCompleteServerSnap();
        if (cache) {
            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
            // we need to see if it contains the child we're interested in.
            if (this.query_.getQueryParams().loadsAllData() ||
                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
                return cache.getChild(path);
            }
        }
        return null;
    };
    /**
     * @return {boolean}
     */
    View.prototype.isEmpty = function () {
        return this.eventRegistrations_.length === 0;
    };
    /**
     * @param {!EventRegistration} eventRegistration
     */
    View.prototype.addEventRegistration = function (eventRegistration) {
        this.eventRegistrations_.push(eventRegistration);
    };
    /**
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
        var cancelEvents = [];
        if (cancelError) {
            util.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
            var path_1 = this.query_.path;
            this.eventRegistrations_.forEach(function (registration) {
                cancelError /** @type {!Error} */ = cancelError;
                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
                if (maybeEvent) {
                    cancelEvents.push(maybeEvent);
                }
            });
        }
        if (eventRegistration) {
            var remaining = [];
            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
                var existing = this.eventRegistrations_[i];
                if (!existing.matches(eventRegistration)) {
                    remaining.push(existing);
                }
                else if (eventRegistration.hasAnyCallback()) {
                    // We're removing just this one
                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
                    break;
                }
            }
            this.eventRegistrations_ = remaining;
        }
        else {
            this.eventRegistrations_ = [];
        }
        return cancelEvents;
    };
    /**
     * Applies the given Operation, updates our cache, and returns the appropriate events.
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @return {!Array.<!Event>}
     */
    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
        if (operation.type === OperationType.MERGE &&
            operation.source.queryId !== null) {
            util.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
            util.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
        }
        var oldViewCache = this.viewCache_;
        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
        this.processor_.assertIndexed(result.viewCache);
        util.assert(result.viewCache.getServerCache().isFullyInitialized() ||
            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
        this.viewCache_ = result.viewCache;
        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
    };
    /**
     * @param {!EventRegistration} registration
     * @return {!Array.<!Event>}
     */
    View.prototype.getInitialEvents = function (registration) {
        var eventSnap = this.viewCache_.getEventCache();
        var initialChanges = [];
        if (!eventSnap.getNode().isLeafNode()) {
            var eventNode = eventSnap.getNode();
            eventNode.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                initialChanges.push(Change.childAddedChange(key, childNode));
            });
        }
        if (eventSnap.isFullyInitialized()) {
            initialChanges.push(Change.valueChange(eventSnap.getNode()));
        }
        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
    };
    /**
     * @private
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {EventRegistration=} eventRegistration
     * @return {!Array.<!Event>}
     */
    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
        var registrations = eventRegistration
            ? [eventRegistration]
            : this.eventRegistrations_;
        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
    };
    return View;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */
var SyncPoint = /** @class */ (function () {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         *
         * @type {!Object.<!string, !View>}
         * @private
         */
        this.views_ = {};
    }
    Object.defineProperty(SyncPoint, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor$1, 'Reference.ts has not been loaded');
            return __referenceConstructor$1;
        },
        set: function (val) {
            util.assert(!__referenceConstructor$1, '__referenceConstructor has already been defined');
            __referenceConstructor$1 = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.isEmpty = function () {
        return util.isEmpty(this.views_);
    };
    /**
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} optCompleteServerCache
     * @return {!Array.<!Event>}
     */
    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
        var queryId = operation.source.queryId;
        if (queryId !== null) {
            var view = util.safeGet(this.views_, queryId);
            util.assert(view != null, 'SyncTree gave us an op for an invalid query.');
            return view.applyOperation(operation, writesCache, optCompleteServerCache);
        }
        else {
            var events_1 = [];
            util.forEach(this.views_, function (key, view) {
                events_1 = events_1.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
            });
            return events_1;
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache Complete server cache, if we have it.
     * @param {boolean} serverCacheComplete
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
        var queryId = query.queryIdentifier();
        var view = util.safeGet(this.views_, queryId);
        if (!view) {
            // TODO: make writesCache take flag for complete server node
            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
            var eventCacheComplete = false;
            if (eventCache) {
                eventCacheComplete = true;
            }
            else if (serverCache instanceof ChildrenNode) {
                eventCache = writesCache.calcCompleteEventChildren(serverCache);
                eventCacheComplete = false;
            }
            else {
                eventCache = ChildrenNode.EMPTY_NODE;
                eventCacheComplete = false;
            }
            var viewCache = new ViewCache(new CacheNode(
            /** @type {!Node} */ (eventCache), eventCacheComplete, false), new CacheNode(
            /** @type {!Node} */ (serverCache), serverCacheComplete, false));
            view = new View(query, viewCache);
            this.views_[queryId] = view;
        }
        // This is guaranteed to exist now, we just created anything that was missing
        view.addEventRegistration(eventRegistration);
        return view.getInitialEvents(eventRegistration);
    };
    /**
     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
     *
     * If query is the default query, we'll check all views for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
     */
    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var queryId = query.queryIdentifier();
        var removed = [];
        var cancelEvents = [];
        var hadCompleteView = this.hasCompleteView();
        if (queryId === 'default') {
            // When you do ref.off(...), we search all views for the registration to remove.
            var self_1 = this;
            util.forEach(this.views_, function (viewQueryId, view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete self_1.views_[viewQueryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            });
        }
        else {
            // remove the callback from the specific view.
            var view = util.safeGet(this.views_, queryId);
            if (view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete this.views_[queryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            }
        }
        if (hadCompleteView && !this.hasCompleteView()) {
            // We removed our last complete view.
            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
        }
        return { removed: removed, events: cancelEvents };
    };
    /**
     * @return {!Array.<!View>}
     */
    SyncPoint.prototype.getQueryViews = function () {
        var _this = this;
        var values = Object.keys(this.views_).map(function (key) { return _this.views_[key]; });
        return values.filter(function (view) {
            return !view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
    };
    /**
     *
     * @param {!Path} path The path to the desired complete snapshot
     * @return {?Node} A complete cache, if it exists
     */
    SyncPoint.prototype.getCompleteServerCache = function (path) {
        var serverCache = null;
        util.forEach(this.views_, function (key, view) {
            serverCache = serverCache || view.getCompleteServerCache(path);
        });
        return serverCache;
    };
    /**
     * @param {!Query} query
     * @return {?View}
     */
    SyncPoint.prototype.viewForQuery = function (query) {
        var params = query.getQueryParams();
        if (params.loadsAllData()) {
            return this.getCompleteView();
        }
        else {
            var queryId = query.queryIdentifier();
            return util.safeGet(this.views_, queryId);
        }
    };
    /**
     * @param {!Query} query
     * @return {boolean}
     */
    SyncPoint.prototype.viewExistsForQuery = function (query) {
        return this.viewForQuery(query) != null;
    };
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.hasCompleteView = function () {
        return this.getCompleteView() != null;
    };
    /**
     * @return {?View}
     */
    SyncPoint.prototype.getCompleteView = function () {
        var completeView = util.findValue(this.views_, function (view) {
            return view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
        return completeView || null;
    };
    return SyncPoint;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 *
 * @constructor
 * @param {!ImmutableTree.<!Node>} writeTree
 */
var CompoundWrite = /** @class */ (function () {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    /**
     * @param {!Path} path
     * @param {!Node} node
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrite = function (path, node) {
        if (path.isEmpty()) {
            return new CompoundWrite(new ImmutableTree(node));
        }
        else {
            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
            if (rootmost != null) {
                var rootMostPath = rootmost.path;
                var value = rootmost.value;
                var relativePath = Path.relativePath(rootMostPath, path);
                value = value.updateChild(relativePath, node);
                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
            }
            else {
                var subtree = new ImmutableTree(node);
                var newWriteTree = this.writeTree_.setTree(path, subtree);
                return new CompoundWrite(newWriteTree);
            }
        }
    };
    /**
     * @param {!Path} path
     * @param {!Object.<string, !Node>} updates
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrites = function (path, updates) {
        var newWrite = this;
        util.forEach(updates, function (childKey, node) {
            newWrite = newWrite.addWrite(path.child(childKey), node);
        });
        return newWrite;
    };
    /**
     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
     * location, which must be removed by calling this method with that path.
     *
     * @param {!Path} path The path at which a write and all deeper writes should be removed
     * @return {!CompoundWrite} The new CompoundWrite with the removed path
     */
    CompoundWrite.prototype.removeWrite = function (path) {
        if (path.isEmpty()) {
            return CompoundWrite.Empty;
        }
        else {
            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
            return new CompoundWrite(newWriteTree);
        }
    };
    /**
     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
     * considered "complete".
     *
     * @param {!Path} path The path to check for
     * @return {boolean} Whether there is a complete write at that path
     */
    CompoundWrite.prototype.hasCompleteWrite = function (path) {
        return this.getCompleteNode(path) != null;
    };
    /**
     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
     * writes from deeper paths, but will return child nodes from a more shallow path.
     *
     * @param {!Path} path The path to get a complete write
     * @return {?Node} The node if complete at that path, or null otherwise.
     */
    CompoundWrite.prototype.getCompleteNode = function (path) {
        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            return this.writeTree_
                .get(rootmost.path)
                .getChild(Path.relativePath(rootmost.path, path));
        }
        else {
            return null;
        }
    };
    /**
     * Returns all children that are guaranteed to be a complete overwrite.
     *
     * @return {!Array.<NamedNode>} A list of all complete children.
     */
    CompoundWrite.prototype.getCompleteChildren = function () {
        var children = [];
        var node = this.writeTree_.value;
        if (node != null) {
            // If it's a leaf node, it has no children; so nothing to do.
            if (!node.isLeafNode()) {
                node.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                    children.push(new NamedNode(childName, childNode));
                });
            }
        }
        else {
            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
                if (childTree.value != null) {
                    children.push(new NamedNode(childName, childTree.value));
                }
            });
        }
        return children;
    };
    /**
     * @param {!Path} path
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.childCompoundWrite = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else {
            var shadowingNode = this.getCompleteNode(path);
            if (shadowingNode != null) {
                return new CompoundWrite(new ImmutableTree(shadowingNode));
            }
            else {
                return new CompoundWrite(this.writeTree_.subtree(path));
            }
        }
    };
    /**
     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
     * @return {boolean} Whether this CompoundWrite is empty
     */
    CompoundWrite.prototype.isEmpty = function () {
        return this.writeTree_.isEmpty();
    };
    /**
     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
     * node
     * @param {!Node} node The node to apply this CompoundWrite to
     * @return {!Node} The node with all writes applied
     */
    CompoundWrite.prototype.apply = function (node) {
        return CompoundWrite.applySubtreeWrite_(Path.Empty, this.writeTree_, node);
    };
    /**
     * @type {!CompoundWrite}
     */
    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree(null));
    /**
     * @param {!Path} relativePath
     * @param {!ImmutableTree.<!Node>} writeTree
     * @param {!Node} node
     * @return {!Node}
     * @private
     */
    CompoundWrite.applySubtreeWrite_ = function (relativePath, writeTree, node) {
        if (writeTree.value != null) {
            // Since there a write is always a leaf, we're done here
            return node.updateChild(relativePath, writeTree.value);
        }
        else {
            var priorityWrite_1 = null;
            writeTree.children.inorderTraversal(function (childKey, childTree) {
                if (childKey === '.priority') {
                    // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                    // to apply priorities to empty nodes that are later filled
                    util.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
                    priorityWrite_1 = childTree.value;
                }
                else {
                    node = CompoundWrite.applySubtreeWrite_(relativePath.child(childKey), childTree, node);
                }
            });
            // If there was a priority write, we only apply it if the node is not empty
            if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
                node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
            }
            return node;
        }
    };
    return CompoundWrite;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */
var WriteTree = /** @class */ (function () {
    function WriteTree() {
        /**
         * A tree tracking the result of applying all visible writes.  This does not include transactions with
         * applyLocally=false or writes that are completely shadowed by other writes.
         *
         * @type {!CompoundWrite}
         * @private
         */
        this.visibleWrites_ = CompoundWrite.Empty;
        /**
         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
         * used by transactions).
         *
         * @type {!Array.<!WriteRecord>}
         * @private
         */
        this.allWrites_ = [];
        this.lastWriteId_ = -1;
    }
    /**
     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
     *
     * @param {!Path} path
     * @return {!WriteTreeRef}
     */
    WriteTree.prototype.childWrites = function (path) {
        return new WriteTreeRef(path, this);
    };
    /**
     * Record a new overwrite from user code.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} writeId
     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
     */
    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
        if (visible === undefined) {
            visible = true;
        }
        this.allWrites_.push({
            path: path,
            snap: snap,
            writeId: writeId,
            visible: visible
        });
        if (visible) {
            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
        }
        this.lastWriteId_ = writeId;
    };
    /**
     * Record a new merge from user code.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     */
    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
        this.allWrites_.push({
            path: path,
            children: changedChildren,
            writeId: writeId,
            visible: true
        });
        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
        this.lastWriteId_ = writeId;
    };
    /**
     * @param {!number} writeId
     * @return {?WriteRecord}
     */
    WriteTree.prototype.getWrite = function (writeId) {
        for (var i = 0; i < this.allWrites_.length; i++) {
            var record = this.allWrites_[i];
            if (record.writeId === writeId) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
     *
     * @param {!number} writeId
     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
     * events as a result).
     */
    WriteTree.prototype.removeWrite = function (writeId) {
        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
        // out of order.
        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
        var _this = this;
        var idx = this.allWrites_.findIndex(function (s) {
            return s.writeId === writeId;
        });
        util.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
        var writeToRemove = this.allWrites_[idx];
        this.allWrites_.splice(idx, 1);
        var removedWriteWasVisible = writeToRemove.visible;
        var removedWriteOverlapsWithOtherWrites = false;
        var i = this.allWrites_.length - 1;
        while (removedWriteWasVisible && i >= 0) {
            var currentWrite = this.allWrites_[i];
            if (currentWrite.visible) {
                if (i >= idx &&
                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
                    // The removed write was completely shadowed by a subsequent write.
                    removedWriteWasVisible = false;
                }
                else if (writeToRemove.path.contains(currentWrite.path)) {
                    // Either we're covering some writes or they're covering part of us (depending on which came first).
                    removedWriteOverlapsWithOtherWrites = true;
                }
            }
            i--;
        }
        if (!removedWriteWasVisible) {
            return false;
        }
        else if (removedWriteOverlapsWithOtherWrites) {
            // There's some shadowing going on. Just rebuild the visible writes from scratch.
            this.resetTree_();
            return true;
        }
        else {
            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
            if (writeToRemove.snap) {
                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
            }
            else {
                var children = writeToRemove.children;
                util.forEach(children, function (childName) {
                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
                });
            }
            return true;
        }
    };
    /**
     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
     * No server data is considered.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.getCompleteWriteData = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
     * writes), attempt to calculate a complete snapshot for the given path
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        if (!writeIdsToExclude && !includeHiddenWrites) {
            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
            if (shadowingNode != null) {
                return shadowingNode;
            }
            else {
                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
                if (subMerge.isEmpty()) {
                    return completeServerCache;
                }
                else if (completeServerCache == null &&
                    !subMerge.hasCompleteWrite(Path.Empty)) {
                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
                    return null;
                }
                else {
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return subMerge.apply(layeredCache);
                }
            }
        }
        else {
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            if (!includeHiddenWrites && merge.isEmpty()) {
                return completeServerCache;
            }
            else {
                // If the server cache is null, and we don't have a complete cache, we need to return null
                if (!includeHiddenWrites &&
                    completeServerCache == null &&
                    !merge.hasCompleteWrite(Path.Empty)) {
                    return null;
                }
                else {
                    var filter = function (write) {
                        return ((write.visible || includeHiddenWrites) &&
                            (!writeIdsToExclude ||
                                !~writeIdsToExclude.indexOf(write.writeId)) &&
                            (write.path.contains(treePath) || treePath.contains(write.path)));
                    };
                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return mergeAtPath.apply(layeredCache);
                }
            }
        }
    };
    /**
     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
     * Used when creating new views, to pre-fill their complete event children snapshot.
     *
     * @param {!Path} treePath
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
        var completeChildren = ChildrenNode.EMPTY_NODE;
        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
        if (topLevelSet) {
            if (!topLevelSet.isLeafNode()) {
                // we're shadowing everything. Return the children.
                topLevelSet.forEachChild(PRIORITY_INDEX, function (childName, childSnap) {
                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
                });
            }
            return completeChildren;
        }
        else if (completeServerChildren) {
            // Layer any children we have on top of this
            // We know we don't have a top-level set, so just enumerate existing children
            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
            completeServerChildren.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                var node = merge_1
                    .childCompoundWrite(new Path(childName))
                    .apply(childNode);
                completeChildren = completeChildren.updateImmediateChild(childName, node);
            });
            // Add any complete children we have from the set
            merge_1.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
        else {
            // We don't have anything to layer on top of. Layer on any children we have
            // Note that we can return an empty snap if we have a defined delete
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            merge.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
    };
    /**
     * Given that the underlying server data has updated, determine what, if anything, needs to be
     * applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events
     *
     * Either existingEventSnap or existingServerSnap must exist
     *
     * @param {!Path} treePath
     * @param {!Path} childPath
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
        util.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
        var path = treePath.child(childPath);
        if (this.visibleWrites_.hasCompleteWrite(path)) {
            // At this point we can probably guarantee that we're in case 2, meaning no events
            // May need to check visibility while doing the findRootMostValueAndPath call
            return null;
        }
        else {
            // No complete shadowing. We're either partially shadowing or not shadowing at all.
            var childMerge = this.visibleWrites_.childCompoundWrite(path);
            if (childMerge.isEmpty()) {
                // We're not shadowing at all. Case 1
                return existingServerSnap.getChild(childPath);
            }
            else {
                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
                // However this is tricky to find out, since user updates don't necessary change the server
                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
                // only check if the updates change the serverNode.
                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
                return childMerge.apply(existingServerSnap.getChild(childPath));
            }
        }
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!Path} treePath
     * @param {!string} childKey
     * @param {!CacheNode} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
        var path = treePath.child(childKey);
        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
        if (shadowingNode != null) {
            return shadowingNode;
        }
        else {
            if (existingServerSnap.isCompleteForChild(childKey)) {
                var childMerge = this.visibleWrites_.childCompoundWrite(path);
                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
            }
            else {
                return null;
            }
        }
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.shadowingWrite = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window.
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
        var toIterate;
        var merge = this.visibleWrites_.childCompoundWrite(treePath);
        var shadowingNode = merge.getCompleteNode(Path.Empty);
        if (shadowingNode != null) {
            toIterate = shadowingNode;
        }
        else if (completeServerData != null) {
            toIterate = merge.apply(completeServerData);
        }
        else {
            // no children to iterate on
            return [];
        }
        toIterate = toIterate.withIndex(index);
        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
            var nodes = [];
            var cmp = index.getCompare();
            var iter = reverse
                ? toIterate.getReverseIteratorFrom(startPost, index)
                : toIterate.getIteratorFrom(startPost, index);
            var next = iter.getNext();
            while (next && nodes.length < count) {
                if (cmp(next, startPost) !== 0) {
                    nodes.push(next);
                }
                next = iter.getNext();
            }
            return nodes;
        }
        else {
            return [];
        }
    };
    /**
     * @param {!WriteRecord} writeRecord
     * @param {!Path} path
     * @return {boolean}
     * @private
     */
    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
        if (writeRecord.snap) {
            return writeRecord.path.contains(path);
        }
        else {
            // findKey can return undefined, so use !! to coerce to boolean
            return !!util.findKey(writeRecord.children, function (childSnap, childName) {
                return writeRecord.path.child(childName).contains(path);
            });
        }
    };
    /**
     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
     * @private
     */
    WriteTree.prototype.resetTree_ = function () {
        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path.Empty);
        if (this.allWrites_.length > 0) {
            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
        }
        else {
            this.lastWriteId_ = -1;
        }
    };
    /**
     * The default filter used when constructing the tree. Keep everything that's visible.
     *
     * @param {!WriteRecord} write
     * @return {boolean}
     * @private
     */
    WriteTree.DefaultFilter_ = function (write) {
        return write.visible;
    };
    /**
     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
     * event data at that path.
     *
     * @param {!Array.<!WriteRecord>} writes
     * @param {!function(!WriteRecord):boolean} filter
     * @param {!Path} treeRoot
     * @return {!CompoundWrite}
     * @private
     */
    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
        var compoundWrite = CompoundWrite.Empty;
        for (var i = 0; i < writes.length; ++i) {
            var write = writes[i];
            // Theory, a later set will either:
            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
            if (filter(write)) {
                var writePath = write.path;
                var relativePath = void 0;
                if (write.snap) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
                    }
                    else {
                        // There is no overlap between root path and write path, ignore write
                    }
                }
                else if (write.children) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        if (relativePath.isEmpty()) {
                            compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
                        }
                        else {
                            var child = util.safeGet(write.children, relativePath.getFront());
                            if (child) {
                                // There exists a child in this node that matches the root path
                                var deepNode = child.getChild(relativePath.popFront());
                                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
                            }
                        }
                    }
                    else {
                        // There is no overlap between root path and write path, ignore write
                    }
                }
                else {
                    throw util.assertionError('WriteRecord should have .snap or .children');
                }
            }
        }
        return compoundWrite;
    };
    return WriteTree;
}());
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */
var WriteTreeRef = /** @class */ (function () {
    /**
     * @param {!Path} path
     * @param {!WriteTree} writeTree
     */
    function WriteTreeRef(path, writeTree) {
        this.treePath_ = path;
        this.writeTree_ = writeTree;
    }
    /**
     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
     * can lead to a more expensive calculation.
     *
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
    };
    /**
     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
     * mix of the given server data and write data.
     *
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
    };
    /**
     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
     * if anything, needs to be applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events should be raised
     *
     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
     *
     * @param {!Path} path
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTreeRef.prototype.shadowingWrite = function (path) {
        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window
     *
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!string} childKey
     * @param {!CacheNode} existingServerCache
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
    };
    /**
     * Return a WriteTreeRef for a child.
     *
     * @param {string} childName
     * @return {!WriteTreeRef}
     */
    WriteTreeRef.prototype.child = function (childName) {
        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
    };
    return WriteTreeRef;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */
var SyncTree = /** @class */ (function () {
    /**
     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
     *   to server data.
     */
    function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         * @type {!ImmutableTree.<!SyncPoint>}
         * @private
         */
        this.syncPointTree_ = ImmutableTree.Empty;
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         * @type {!WriteTree}
         * @private
         */
        this.pendingWriteTree_ = new WriteTree();
        this.tagToQueryMap_ = {};
        this.queryToTagMap_ = {};
    }
    /**
     * Apply the data changes for a user-generated set() or transaction() call.
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @param {number} writeId
     * @param {boolean=} visible
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
        // Record pending write.
        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
        if (!visible) {
            return [];
        }
        else {
            return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
        }
    };
    /**
     * Apply the data from a user-generated update() call
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
        // Record pending merge.
        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
    };
    /**
     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
     *
     * @param {!number} writeId
     * @param {boolean=} revert True if the given write failed and needs to be reverted
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
        if (revert === void 0) { revert = false; }
        var write = this.pendingWriteTree_.getWrite(writeId);
        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
        if (!needToReevaluate) {
            return [];
        }
        else {
            var affectedTree_1 = ImmutableTree.Empty;
            if (write.snap != null) {
                // overwrite
                affectedTree_1 = affectedTree_1.set(Path.Empty, true);
            }
            else {
                util.forEach(write.children, function (pathString, node) {
                    affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
                });
            }
            return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
        }
    };
    /**
     * Apply new server data for the specified path..
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
        return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
    };
    /**
     * Apply new server data to be merged in at the specified path.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
    };
    /**
     * Apply a listen complete for a query
     *
     * @param {!Path} path
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyListenComplete = function (path) {
        return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
    };
    /**
     * Apply new server data for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey != null) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // Query must have been removed already
            return [];
        }
    };
    /**
     * Apply server data to be merged in for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var changeTree = ImmutableTree.fromObject(changedChildren);
            var op = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Apply a listen complete for a tagged query
     *
     * @param {!Path} path
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
        var path = query.path;
        var serverCache = null;
        var foundAncestorDefaultView = false;
        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
        // Consider optimizing this once there's a better understanding of what actual behavior will be.
        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
            var relativePath = Path.relativePath(pathToSyncPoint, path);
            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
            foundAncestorDefaultView =
                foundAncestorDefaultView || sp.hasCompleteView();
        });
        var syncPoint = this.syncPointTree_.get(path);
        if (!syncPoint) {
            syncPoint = new SyncPoint();
            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
        }
        else {
            foundAncestorDefaultView =
                foundAncestorDefaultView || syncPoint.hasCompleteView();
            serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
        }
        var serverCacheComplete;
        if (serverCache != null) {
            serverCacheComplete = true;
        }
        else {
            serverCacheComplete = false;
            serverCache = ChildrenNode.EMPTY_NODE;
            var subtree = this.syncPointTree_.subtree(path);
            subtree.foreachChild(function (childName, childSyncPoint) {
                var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
                if (completeCache) {
                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
                }
            });
        }
        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
            // We need to track a tag for this query
            var queryKey = SyncTree.makeQueryKey_(query);
            util.assert(!(queryKey in this.queryToTagMap_), 'View does not exist, but we have a tag');
            var tag = SyncTree.getNextQueryTag_();
            this.queryToTagMap_[queryKey] = tag;
            // Coerce to string to avoid sparse arrays.
            this.tagToQueryMap_['_' + tag] = queryKey;
        }
        var writesCache = this.pendingWriteTree_.childWrites(path);
        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
        if (!viewAlreadyExists && !foundAncestorDefaultView) {
            var view /** @type !View */ = syncPoint.viewForQuery(query);
            events = events.concat(this.setupListener_(query, view));
        }
        return events;
    };
    /**
     * Remove event callback(s).
     *
     * If query is the default query, we'll check all queries for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, all callbacks are removed.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var _this = this;
        // Find the syncPoint first. Then deal with whether or not it has matching listeners
        var path = query.path;
        var maybeSyncPoint = this.syncPointTree_.get(path);
        var cancelEvents = [];
        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
        // not loadsAllData().
        if (maybeSyncPoint &&
            (query.queryIdentifier() === 'default' ||
                maybeSyncPoint.viewExistsForQuery(query))) {
            /**
             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
             */
            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
            if (maybeSyncPoint.isEmpty()) {
                this.syncPointTree_ = this.syncPointTree_.remove(path);
            }
            var removed = removedAndEvents.removed;
            cancelEvents = removedAndEvents.events;
            // We may have just removed one of many listeners and can short-circuit this whole process
            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
            // properly set up.
            //
            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            var removingDefault = -1 !==
                removed.findIndex(function (query) {
                    return query.getQueryParams().loadsAllData();
                });
            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
                return parentSyncPoint.hasCompleteView();
            });
            if (removingDefault && !covered) {
                var subtree = this.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for (var i = 0; i < newViews.length; ++i) {
                        var view = newViews[i], newQuery = view.getQuery();
                        var listener = this.createListenerForView_(view);
                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
                    }
                }
                else {
                    // There's nothing below us, so nothing we need to start listening on
                }
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    var defaultTag = null;
                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
                }
                else {
                    removed.forEach(function (queryToRemove) {
                        var tagToRemove = _this.queryToTagMap_[SyncTree.makeQueryKey_(queryToRemove)];
                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
                    });
                }
            }
            // Now, clear all of the tags we're tracking for the removed listens
            this.removeTags_(removed);
        }
        else {
            // No-op, this listener must've been already removed
        }
        return cancelEvents;
    };
    /**
     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
     * it, but as this is only used by transaction code, that should always be the case anyways.
     *
     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
     * @param {!Path} path The path to the data we want
     * @param {Array.<number>=} writeIdsToExclude A specific set to be excluded
     * @return {?Node}
     */
    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
        var includeHiddenSets = true;
        var writeTree = this.pendingWriteTree_;
        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
            var relativePath = Path.relativePath(pathSoFar, path);
            var serverCache = syncPoint.getCompleteServerCache(relativePath);
            if (serverCache) {
                return serverCache;
            }
        });
        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
    };
    /**
     * This collapses multiple unfiltered views into a single view, since we only need a single
     * listener for them.
     *
     * @param {!ImmutableTree.<!SyncPoint>} subtree
     * @return {!Array.<!View>}
     * @private
     */
    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                var completeView = maybeChildSyncPoint.getCompleteView();
                return [completeView];
            }
            else {
                // No complete view here, flatten any deeper listens into an array
                var views_1 = [];
                if (maybeChildSyncPoint) {
                    views_1 = maybeChildSyncPoint.getQueryViews();
                }
                util.forEach(childMap, function (key, childViews) {
                    views_1 = views_1.concat(childViews);
                });
                return views_1;
            }
        });
    };
    /**
     * @param {!Array.<!Query>} queries
     * @private
     */
    SyncTree.prototype.removeTags_ = function (queries) {
        for (var j = 0; j < queries.length; ++j) {
            var removedQuery = queries[j];
            if (!removedQuery.getQueryParams().loadsAllData()) {
                // We should have a tag for this
                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
                var removedQueryTag = this.queryToTagMap_[removedQueryKey];
                delete this.queryToTagMap_[removedQueryKey];
                delete this.tagToQueryMap_['_' + removedQueryTag];
            }
        }
    };
    /**
     * Normalizes a query to a query we send the server for listening
     * @param {!Query} query
     * @return {!Query} The normalized query
     * @private
     */
    SyncTree.queryForListening_ = function (query) {
        if (query.getQueryParams().loadsAllData() &&
            !query.getQueryParams().isDefault()) {
            // We treat queries that load all data as default queries
            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
            // from Query
            return /** @type {!Query} */ query.getRef();
        }
        else {
            return query;
        }
    };
    /**
     * For a given new listen, manage the de-duplication of outstanding subscriptions.
     *
     * @param {!Query} query
     * @param {!View} view
     * @return {!Array.<!Event>} This method can return events to support synchronous data sources
     * @private
     */
    SyncTree.prototype.setupListener_ = function (query, view) {
        var path = query.path;
        var tag = this.tagForQuery_(query);
        var listener = this.createListenerForView_(view);
        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
        var subtree = this.syncPointTree_.subtree(path);
        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
        // may need to shadow other listens as well.
        if (tag) {
            util.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
        }
        else {
            // Shadow everything at or below this location, this is a default listener.
            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
                if (!relativePath.isEmpty() &&
                    maybeChildSyncPoint &&
                    maybeChildSyncPoint.hasCompleteView()) {
                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
                }
                else {
                    // No default listener here, flatten any deeper queries into an array
                    var queries_1 = [];
                    if (maybeChildSyncPoint) {
                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
                    }
                    util.forEach(childMap, function (key, childQueries) {
                        queries_1 = queries_1.concat(childQueries);
                    });
                    return queries_1;
                }
            });
            for (var i = 0; i < queriesToStop.length; ++i) {
                var queryToStop = queriesToStop[i];
                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
            }
        }
        return events;
    };
    /**
     *
     * @param {!View} view
     * @return {{hashFn: function(), onComplete: function(!string, *)}}
     * @private
     */
    SyncTree.prototype.createListenerForView_ = function (view) {
        var _this = this;
        var query = view.getQuery();
        var tag = this.tagForQuery_(query);
        return {
            hashFn: function () {
                var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
                return cache.hash();
            },
            onComplete: function (status) {
                if (status === 'ok') {
                    if (tag) {
                        return _this.applyTaggedListenComplete(query.path, tag);
                    }
                    else {
                        return _this.applyListenComplete(query.path);
                    }
                }
                else {
                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                    var error$$1 = errorForServerCode(status, query);
                    return _this.removeEventRegistration(query, 
                    /*eventRegistration*/ null, error$$1);
                }
            }
        };
    };
    /**
     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
     * @private
     * @param {!Query} query
     * @return {string}
     */
    SyncTree.makeQueryKey_ = function (query) {
        return query.path.toString() + '$' + query.queryIdentifier();
    };
    /**
     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
     * @private
     * @param {!string} queryKey
     * @return {{queryId: !string, path: !Path}}
     */
    SyncTree.parseQueryKey_ = function (queryKey) {
        var splitIndex = queryKey.indexOf('$');
        util.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
        return {
            queryId: queryKey.substr(splitIndex + 1),
            path: new Path(queryKey.substr(0, splitIndex))
        };
    };
    /**
     * Return the query associated with the given tag, if we have one
     * @param {!number} tag
     * @return {?string}
     * @private
     */
    SyncTree.prototype.queryKeyForTag_ = function (tag) {
        return this.tagToQueryMap_['_' + tag];
    };
    /**
     * Return the tag associated with the given query.
     * @param {!Query} query
     * @return {?number}
     * @private
     */
    SyncTree.prototype.tagForQuery_ = function (query) {
        var queryKey = SyncTree.makeQueryKey_(query);
        return util.safeGet(this.queryToTagMap_, queryKey);
    };
    /**
     * Static accessor for query tags.
     * @return {number}
     * @private
     */
    SyncTree.getNextQueryTag_ = function () {
        return SyncTree.nextQueryTag_++;
    };
    /**
     * A helper method to apply tagged operations
     *
     * @param {!Path} queryPath
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
        var syncPoint = this.syncPointTree_.get(queryPath);
        util.assert(syncPoint, "Missing sync point for query tag that we're tracking");
        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
        return syncPoint.applyOperation(operation, writesCache, 
        /*serverCache=*/ null);
    };
    /**
     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
     *
     * NOTES:
     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
  
     * - We call applyOperation() on each SyncPoint passing three things:
     *   1. A version of the Operation that has been made relative to the SyncPoint location.
     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
     *   3. A snapshot Node with cached server data, if we have it.
  
     * - We concatenate all of the events returned by each SyncPoint and return the result.
     *
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
        return this.applyOperationHelper_(operation, this.syncPointTree_, 
        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path.Empty));
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        if (operation.path.isEmpty()) {
            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
        }
        else {
            var syncPoint = syncPointTree.get(Path.Empty);
            // If we don't have cached server data, see if we can get it from this SyncPoint.
            if (serverCache == null && syncPoint != null) {
                serverCache = syncPoint.getCompleteServerCache(Path.Empty);
            }
            var events = [];
            var childName = operation.path.getFront();
            var childOperation = operation.operationForChild(childName);
            var childTree = syncPointTree.children.get(childName);
            if (childTree && childOperation) {
                var childServerCache = serverCache
                    ? serverCache.getImmediateChild(childName)
                    : null;
                var childWritesCache = writesCache.child(childName);
                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
            if (syncPoint) {
                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
            }
            return events;
        }
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        var _this = this;
        var syncPoint = syncPointTree.get(Path.Empty);
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) {
            serverCache = syncPoint.getCompleteServerCache(Path.Empty);
        }
        var events = [];
        syncPointTree.children.inorderTraversal(function (childName, childTree) {
            var childServerCache = serverCache
                ? serverCache.getImmediateChild(childName)
                : null;
            var childWritesCache = writesCache.child(childName);
            var childOperation = operation.operationForChild(childName);
            if (childOperation) {
                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
        });
        if (syncPoint) {
            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
        }
        return events;
    };
    /**
     * Static tracker for next query tag.
     * @type {number}
     * @private
     */
    SyncTree.nextQueryTag_ = 1;
    return SyncTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */
var SnapshotHolder = /** @class */ (function () {
    function SnapshotHolder() {
        this.rootNode_ = ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function (path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */
var AuthTokenProvider = /** @class */ (function () {
    /**
     * @param {!FirebaseApp} app_
     */
    function AuthTokenProvider(app_) {
        this.app_ = app_;
    }
    /**
     * @param {boolean} forceRefresh
     * @return {!Promise<FirebaseAuthTokenData>}
     */
    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
        return this.app_['INTERNAL']['getToken'](forceRefresh).then(null, 
        // .catch
        function (error$$1) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error$$1 && error$$1.code === 'auth/token-not-initialized') {
                log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            }
            else {
                return Promise.reject(error$$1);
            }
        });
    };
    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        this.app_['INTERNAL']['addAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
        this.app_['INTERNAL']['removeAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
        var errorMessage = 'Provided authentication credentials for the app named "' +
            this.app_.name +
            '" are invalid. This usually indicates your app was not ' +
            'initialized correctly. ';
        if ('credential' in this.app_.options) {
            errorMessage +=
                'Make sure the "credential" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else if ('serviceAccount' in this.app_.options) {
            errorMessage +=
                'Make sure the "serviceAccount" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else {
            errorMessage +=
                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
                    'initializeApp() match the values provided for your app at ' +
                    'https://console.firebase.google.com/.';
        }
        warn(errorMessage);
    };
    return AuthTokenProvider;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Tracks a collection of stats.
 *
 * @constructor
 */
var StatsCollection = /** @class */ (function () {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function (name, amount) {
        if (amount === void 0) { amount = 1; }
        if (!util.contains(this.counters_, name))
            this.counters_[name] = 0;
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function () {
        return util.deepCopy(this.counters_);
    };
    return StatsCollection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StatsManager = /** @class */ (function () {
    function StatsManager() {
    }
    StatsManager.getCollection = function (repoInfo) {
        var hashString = repoInfo.toString();
        if (!this.collections_[hashString]) {
            this.collections_[hashString] = new StatsCollection();
        }
        return this.collections_[hashString];
    };
    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
        var hashString = repoInfo.toString();
        if (!this.reporters_[hashString]) {
            this.reporters_[hashString] = creatorFunction();
        }
        return this.reporters_[hashString];
    };
    StatsManager.collections_ = {};
    StatsManager.reporters_ = {};
    return StatsManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */
var StatsListener = /** @class */ (function () {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function () {
        var newStats = this.collection_.get();
        var delta = util.clone(newStats);
        if (this.last_) {
            util.forEach(this.last_, function (stat, value) {
                delta[stat] = delta[stat] - value;
            });
        }
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var FIRST_STATS_MIN_TIME = 10 * 1000;
var FIRST_STATS_MAX_TIME = 30 * 1000;
// We'll continue to report stats on average every 5 minutes.
var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
/**
 * @constructor
 */
var StatsReporter = /** @class */ (function () {
    /**
     * @param collection
     * @param server_
     */
    function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new StatsListener(collection);
        var timeout = FIRST_STATS_MIN_TIME +
            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.includeStat = function (stat) {
        this.statsToReport_[stat] = true;
    };
    StatsReporter.prototype.reportStats_ = function () {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        util.forEach(stats, function (stat, value) {
            if (value > 0 && util.contains(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) {
            this.server_.reportStats(reportedStats);
        }
        // queue our next run.
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */
var EventQueue = /** @class */ (function () {
    function EventQueue() {
        /**
         * @private
         * @type {!Array.<EventList>}
         */
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         * @private
         * @type {!number}
         */
        this.recursionDepth_ = 0;
    }
    /**
     * @param {!Array.<Event>} eventDataList The new events to queue.
     */
    EventQueue.prototype.queueEvents = function (eventDataList) {
        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
        var currList = null;
        for (var i = 0; i < eventDataList.length; i++) {
            var eventData = eventDataList[i];
            var eventPath = eventData.getPath();
            if (currList !== null && !eventPath.equals(currList.getPath())) {
                this.eventLists_.push(currList);
                currList = null;
            }
            if (currList === null) {
                currList = new EventList(eventPath);
            }
            currList.add(eventData);
        }
        if (currList) {
            this.eventLists_.push(currList);
        }
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones)
     * for the specified path.
     *
     * It is assumed that the new events are all for the specified path.
     *
     * @param {!Path} path The path to raise events for.
     * @param {!Array.<Event>} eventDataList The new events to raise.
     */
    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.equals(path);
        });
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones) for
     * locations related to the specified change path (i.e. all ancestors and descendants).
     *
     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
     *
     * @param {!Path} changedPath The path to raise events for.
     * @param {!Array.<!Event>} eventDataList The events to raise
     */
    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
        });
    };
    /**
     * @param {!function(!Path):boolean} predicate
     * @private
     */
    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
        this.recursionDepth_++;
        var sentAll = true;
        for (var i = 0; i < this.eventLists_.length; i++) {
            var eventList = this.eventLists_[i];
            if (eventList) {
                var eventPath = eventList.getPath();
                if (predicate(eventPath)) {
                    this.eventLists_[i].raise();
                    this.eventLists_[i] = null;
                }
                else {
                    sentAll = false;
                }
            }
        }
        if (sentAll) {
            this.eventLists_ = [];
        }
        this.recursionDepth_--;
    };
    return EventQueue;
}());
/**
 * @param {!Path} path
 * @constructor
 */
var EventList = /** @class */ (function () {
    function EventList(path_) {
        this.path_ = path_;
        /**
         * @type {!Array.<Event>}
         * @private
         */
        this.events_ = [];
    }
    /**
     * @param {!Event} eventData
     */
    EventList.prototype.add = function (eventData) {
        this.events_.push(eventData);
    };
    /**
     * Iterates through the list and raises each event
     */
    EventList.prototype.raise = function () {
        for (var i = 0; i < this.events_.length; i++) {
            var eventData = this.events_[i];
            if (eventData !== null) {
                this.events_[i] = null;
                var eventFn = eventData.getEventRunner();
                if (logger$1) {
                    log('event: ' + eventData.toString());
                }
                exceptionGuard(eventFn);
            }
        }
    };
    /**
     * @return {!Path}
     */
    EventList.prototype.getPath = function () {
        return this.path_;
    };
    return EventList;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */
var EventEmitter = /** @class */ (function () {
    /**
     * @param {!Array.<string>} allowedEvents_
     */
    function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        util.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     * @param {!string} eventType
     * @param {...*} var_args
     */
    EventEmitter.prototype.trigger = function (eventType) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = this.listeners_[eventType].slice();
            for (var i = 0; i < listeners.length; i++) {
                listeners[i].callback.apply(listeners[i].context, var_args);
            }
        }
    };
    EventEmitter.prototype.on = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({ callback: callback, context: context });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) {
            callback.apply(context, eventData);
        }
    };
    EventEmitter.prototype.off = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for (var i = 0; i < listeners.length; i++) {
            if (listeners[i].callback === callback &&
                (!context || context === listeners[i].context)) {
                listeners.splice(i, 1);
                return;
            }
        }
    };
    EventEmitter.prototype.validateEventType_ = function (eventType) {
        util.assert(this.allowedEvents_.find(function (et) {
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    };
    return EventEmitter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @extends {EventEmitter}
 */
var VisibilityMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, ['visible']) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== 'undefined' &&
            typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            }
            else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            }
            else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            }
            else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) {
            document.addEventListener(visibilityChange, function () {
                var visible = !document[hidden];
                if (visible !== _this.visible_) {
                    _this.visible_ = visible;
                    _this.trigger('visible', visible);
                }
            }, false);
        }
        return _this;
    }
    VisibilityMonitor.getInstance = function () {
        return new VisibilityMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [this.visible_];
    };
    return VisibilityMonitor;
}(EventEmitter));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */
var OnlineMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, ['online']) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' &&
            typeof window.addEventListener !== 'undefined' &&
            !util.isMobileCordova()) {
            window.addEventListener('online', function () {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', function () {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger('online', false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function () {
        return new OnlineMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'online', 'Unknown event type: ' + eventType);
        return [this.online_];
    };
    /**
     * @return {boolean}
     */
    OnlineMonitor.prototype.currentlyOnline = function () {
        return this.online_;
    };
    return OnlineMonitor;
}(EventEmitter));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */
var PacketReceiver = /** @class */ (function () {
    /**
     * @param onMessage_
     */
    function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     * @param {number} requestNum
     * @param {Array} data
     */
    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function () {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function (i) {
                if (toProcess[i]) {
                    exceptionGuard(function () {
                        _this.onMessage_(toProcess[i]);
                    });
                }
            };
            for (var i = 0; i < toProcess.length; ++i) {
                _loop_2(i);
            }
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while (this.pendingResponses[this.currentResponseNum]) {
            var state_1 = _loop_1();
            if (state_1 === "break")
                break;
        }
    };
    return PacketReceiver;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// URL query parameters associated with longpolling
var FIREBASE_LONGPOLL_START_PARAM = 'start';
var FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
var FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
var FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
var FIREBASE_LONGPOLL_ID_PARAM = 'id';
var FIREBASE_LONGPOLL_PW_PARAM = 'pw';
var FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
var FIREBASE_LONGPOLL_DATA_PARAM = 'd';
var FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = 'disconn';
var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var MAX_URL_DATA_SIZE = 1870;
var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 * @const
 * @type {number}
 */
var KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 * @const
 * @type {number}
 */
var LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 *
 * @constructor
 * @implements {Transport}
 */
var BrowserPollConnection = /** @class */ (function () {
    /**
     * @param {string} connId An identifier for this connection, used for logging
     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
     *                                         transport session
     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
     *                                     connection previously
     */
    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = logWrapper(connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.urlFn = function (params) {
            return repoInfo.connectionURL(LONG_POLLING, params);
        };
    }
    /**
     *
     * @param {function(Object)} onMessage Callback when messages arrive
     * @param {function()} onDisconnect Callback with connection lost.
     */
    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function () {
            _this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
        }, Math.floor(LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        executeWhenDOMReady(function () {
            if (_this.isClosed_)
                return;
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var command = args[0], arg1 = args[1], arg2 = args[2];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder)
                    return; // we closed the connection.
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command == FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                }
                else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function () {
                            _this.onClosed_();
                        });
                    }
                    else {
                        _this.onClosed_();
                    }
                }
                else {
                    throw new Error('Unrecognized command received: ' + command);
                }
            }, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var pN = args[0], data = args[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function () {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier)
                urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
            if (_this.transportSessionId) {
                urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            }
            if (_this.lastSessionId) {
                urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
            }
            if (!util.isNodeSdk() &&
                typeof location !== 'undefined' &&
                location.href &&
                location.href.indexOf(FORGE_DOMAIN) !== -1) {
                urlParams[REFERER_PARAM] = FORGE_REF;
            }
            var connectURL = _this.urlFn(urlParams);
            _this.log_('Connecting via long-poll to ' + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function () {
                /* do nothing */
            });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */
    BrowserPollConnection.prototype.start = function () {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */
    BrowserPollConnection.forceAllow = function () {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */
    BrowserPollConnection.forceDisallow = function () {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function () {
        // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return (BrowserPollConnection.forceAllow_ ||
            (!BrowserPollConnection.forceDisallow_ &&
                typeof document !== 'undefined' &&
                document.createElement != null &&
                !isChromeExtensionContentScript() &&
                !isWindowsStoreApp() &&
                !util.isNodeSdk()));
    };
    /**
     * No-op for polling
     */
    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
    /**
     * Stops polling and cleans up the iframe
     * @private
     */
    BrowserPollConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     * @private
     */
    BrowserPollConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */
    BrowserPollConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param {!Object} data The JSON data to transmit.
     */
    BrowserPollConnection.prototype.send = function (data) {
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = util.base64Encode(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for (var i = 0; i < dataSegs.length; i++) {
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     * @param {!string} id
     * @param {!string} pw
     */
    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
        if (util.isNodeSdk())
            return;
        this.myDisconnFrame = document.createElement('iframe');
        var urlParams = {};
        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     * @param {*} args
     * @private
     */
    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = util.stringify(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    };
    return BrowserPollConnection;
}());
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 * @constructor
 *********************************************************************************************/
var FirebaseIFrameScriptHolder = /** @class */ (function () {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */
    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        /**
         * @type {CountedSet.<number, number>}
         */
        this.outstandingRequests = new CountedSet();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!util.isNodeSdk()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = LUIDGenerator();
            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src &&
                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            }
            catch (e) {
                log('frame writing exception');
                if (e.stack) {
                    log(e.stack);
                }
                log(e);
            }
        }
        else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     * @private
     * @return {Element}
     */
    FirebaseIFrameScriptHolder.createIFrame_ = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) {
                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                    log('No IE domain setting required');
                }
            }
            catch (e) {
                var domain = document.domain;
                iframe.src =
                    "javascript:void((function(){document.open();document.domain='" +
                        domain +
                        "';document.close();})())";
            }
        }
        else {
            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
            // never gets hit.
            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        }
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) {
            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        }
        else if (iframe.contentWindow) {
            iframe.doc = iframe.contentWindow.document; // Internet Explorer
        }
        else if (iframe.document) {
            iframe.doc = iframe.document; //others?
        }
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */
    FirebaseIFrameScriptHolder.prototype.close = function () {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = '';
            setTimeout(function () {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        if (util.isNodeSdk() && this.myID) {
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            var theURL = this.urlFn(urlParams);
            FirebaseIFrameScriptHolder.nodeRestRequest(theURL);
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param {!string} id - The ID of this connection
     * @param {!string} pw - The password for this connection
     */
    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while (this.newRequest_()) { }
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */
    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive &&
            this.sendNewPolls &&
            this.outstandingRequests.count() < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = '';
            var i = 0;
            while (this.pendingSegs.length > 0) {
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <=
                    MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString =
                        curDataString +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
                            i +
                            '=' +
                            theSeg.seg +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
                            i +
                            '=' +
                            theSeg.ts +
                            '&' +
                            FIREBASE_LONGPOLL_DATA_PARAM +
                            i +
                            '=' +
                            theSeg.d;
                    i++;
                }
                else {
                    break;
                }
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */
    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) {
            this.newRequest_();
        }
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param {!string} url - The URL of the script tag.
     * @param {!number} serial - The serial number of the request.
     * @private
     */
    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial, 1);
        var doNewRequest = function () {
            _this.outstandingRequests.remove(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function () {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param {!string} url - The URL for the script tag source.
     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
     */
    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
        var _this = this;
        if (util.isNodeSdk()) {
            this.doNodeLongPoll(url, loadCB);
        }
        else {
            setTimeout(function () {
                try {
                    // if we're already closed, don't add this poll
                    if (!_this.sendNewPolls)
                        return;
                    var newScript_1 = _this.myIFrame.doc.createElement('script');
                    newScript_1.type = 'text/javascript';
                    newScript_1.async = true;
                    newScript_1.src = url;
                    newScript_1.onload = newScript_1.onreadystatechange = function () {
                        var rstate = newScript_1.readyState;
                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                            newScript_1.onload = newScript_1.onreadystatechange = null;
                            if (newScript_1.parentNode) {
                                newScript_1.parentNode.removeChild(newScript_1);
                            }
                            loadCB();
                        }
                    };
                    newScript_1.onerror = function () {
                        log('Long-poll script failed to load: ' + url);
                        _this.sendNewPolls = false;
                        _this.close();
                    };
                    _this.myIFrame.doc.body.appendChild(newScript_1);
                }
                catch (e) {
                    // TODO: we should make this error visible somehow
                }
            }, Math.floor(1));
        }
    };
    return FirebaseIFrameScriptHolder;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WEBSOCKET_MAX_FRAME_SIZE = 16384;
var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') {
    WebSocketImpl = MozWebSocket;
}
else if (typeof WebSocket !== 'undefined') {
    WebSocketImpl = WebSocket;
}
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */
var WebSocketConnection = /** @class */ (function () {
    /**
     * @param {string} connId identifier for this transport
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     */
    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = logWrapper(this.connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
    }
    /**
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     * @return {string} connection url
     * @private
     */
    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
        var urlParams = {};
        urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
        if (!util.isNodeSdk() &&
            typeof location !== 'undefined' &&
            location.href &&
            location.href.indexOf(FORGE_DOMAIN) !== -1) {
            urlParams[REFERER_PARAM] = FORGE_REF;
        }
        if (transportSessionId) {
            urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
        }
        if (lastSessionId) {
            urlParams[LAST_SESSION_PARAM] = lastSessionId;
        }
        return repoInfo.connectionURL(WEBSOCKET, urlParams);
    };
    /**
     *
     * @param onMessage Callback when messages arrive
     * @param onDisconnect Callback with connection lost.
     */
    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        PersistentStorage.set('previous_websocket_failure', true);
        try {
            if (util.isNodeSdk()) {
                var device = util.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                var options = {
                    headers: {
                        'User-Agent': "Firebase/" + PROTOCOL_VERSION + "/" + firebase.SDK_VERSION + "/" + process.platform + "/" + device
                    }
                };
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                var env = Object({"NODE_ENV":"production"});
                var proxy = this.connURL.indexOf('wss://') == 0
                    ? env['HTTPS_PROXY'] || env['https_proxy']
                    : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) {
                    options['proxy'] = { origin: proxy };
                }
                this.mySock = new WebSocketImpl(this.connURL, [], options);
            }
            else {
                this.mySock = new WebSocketImpl(this.connURL);
            }
        }
        catch (e) {
            this.log_('Error instantiating WebSocket.');
            var error$$1 = e.message || e.data;
            if (error$$1) {
                this.log_(error$$1);
            }
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function () {
            _this.log_('Websocket connected.');
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function () {
            _this.log_('Websocket connection was disconnected.');
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function (m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function (e) {
            _this.log_('WebSocket error.  Closing connection.');
            var error$$1 = e.message || e.data;
            if (error$$1) {
                _this.log_(error$$1);
            }
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */
    WebSocketConnection.prototype.start = function () { };
    WebSocketConnection.forceDisallow = function () {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function () {
        var isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
                    isOldAndroid = true;
                }
            }
        }
        return (!isOldAndroid &&
            WebSocketImpl !== null &&
            !WebSocketConnection.forceDisallow_);
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     * @return {boolean}
     */
    WebSocketConnection.previouslyFailed = function () {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return (PersistentStorage.isInMemoryStorage ||
            PersistentStorage.get('previous_websocket_failure') === true);
    };
    WebSocketConnection.prototype.markConnectionHealthy = function () {
        PersistentStorage.remove('previous_websocket_failure');
    };
    WebSocketConnection.prototype.appendFrame_ = function (data) {
        this.frames.push(data);
        if (this.frames.length == this.totalFrames) {
            var fullMess = this.frames.join('');
            this.frames = null;
            var jsonMess = util.jsonEval(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param {number} frameCount The number of frames we are expecting from the server
     * @private
     */
    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @param {!String} data
     * @return {?String} Any remaining data to be process, or null if there is none
     * @private
     */
    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
        util.assert(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess The frame data
     */
    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
        if (this.mySock === null)
            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        var data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) {
            // we're buffering
            this.appendFrame_(data);
        }
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) {
                this.appendFrame_(remainingData);
            }
        }
    };
    /**
     * Send a message to the server
     * @param {Object} data The JSON object to transmit
     */
    WebSocketConnection.prototype.send = function (data) {
        this.resetKeepAlive();
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) {
            this.sendString_(String(dataSegs.length));
        }
        //Send the actual data in segments.
        for (var i = 0; i < dataSegs.length; i++) {
            this.sendString_(dataSegs[i]);
        }
    };
    WebSocketConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */
    WebSocketConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */
    WebSocketConnection.prototype.resetKeepAlive = function () {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function () {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) {
                _this.sendString_('0');
            }
            _this.resetKeepAlive();
        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param {string} str String to send.
     * @private
     */
    WebSocketConnection.prototype.sendString_ = function (str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        }
        catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     * @type {number}
     */
    WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     * @type {number}
     */
    WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */
var TransportManager = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
     */
    function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        /**
         * @const
         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
         */
        get: function () {
            return [BrowserPollConnection, WebSocketConnection];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {!RepoInfo} repoInfo
     * @private
     */
    TransportManager.prototype.initTransports_ = function (repoInfo) {
        var isWebSocketsAvailable = WebSocketConnection && WebSocketConnection['isAvailable']();
        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable)
                warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) {
            this.transports_ = [WebSocketConnection];
        }
        else {
            var transports_1 = (this.transports_ = []);
            each(TransportManager.ALL_TRANSPORTS, function (i, transport) {
                if (transport && transport['isAvailable']()) {
                    transports_1.push(transport);
                }
            });
        }
    };
    /**
     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
     * initial transport to use
     */
    TransportManager.prototype.initialTransport = function () {
        if (this.transports_.length > 0) {
            return this.transports_[0];
        }
        else {
            throw new Error('No transports available');
        }
    };
    /**
     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
     * transport, or null
     */
    TransportManager.prototype.upgradeTransport = function () {
        if (this.transports_.length > 1) {
            return this.transports_[1];
        }
        else {
            return null;
        }
    };
    return TransportManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Abort upgrade attempt if it takes longer than 60s.
var UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
var MESSAGE_TYPE = 't';
var MESSAGE_DATA = 'd';
var CONTROL_SHUTDOWN = 's';
var CONTROL_RESET = 'r';
var CONTROL_ERROR = 'e';
var CONTROL_PONG = 'o';
var SWITCH_ACK = 'a';
var END_TRANSMISSION = 'n';
var PING = 'p';
var SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 *
 * @constructor
 */
var Connection = /** @class */ (function () {
    /**
     * @param {!string} id - an id for this connection
     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */
    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */;
        this.log_ = logWrapper('c:' + this.id + ':');
        this.transportManager_ = new TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     * @private
     */
    Connection.prototype.start_ = function () {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */
        setTimeout(function () {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeout_ms = conn['healthyTimeout'] || 0;
        if (healthyTimeout_ms > 0) {
            this.healthyTimeout_ = setTimeoutNonBlocking(function () {
                _this.healthyTimeout_ = null;
                if (!_this.isHealthy_) {
                    if (_this.conn_ &&
                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has received ' +
                            _this.conn_.bytesReceived +
                            ' bytes.  Marking connection healthy.');
                        _this.isHealthy_ = true;
                        _this.conn_.markConnectionHealthy();
                    }
                    else if (_this.conn_ &&
                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has sent ' +
                            _this.conn_.bytesSent +
                            ' bytes.  Leaving connection alive.');
                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
                        // the server.
                    }
                    else {
                        _this.log_('Closing unhealthy connection after timeout.');
                        _this.close();
                    }
                }
            }, Math.floor(healthyTimeout_ms));
        }
    };
    /**
     * @return {!string}
     * @private
     */
    Connection.prototype.nextTransportId_ = function () {
        return 'c:' + this.id + ':' + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function (conn) {
        var _this = this;
        return function (everConnected) {
            if (conn === _this.conn_) {
                _this.onConnectionLost_(everConnected);
            }
            else if (conn === _this.secondaryConn_) {
                _this.log_('Secondary connection lost.');
                _this.onSecondaryConnectionLost_();
            }
            else {
                _this.log_('closing an old connection');
            }
        };
    };
    Connection.prototype.connReceiver_ = function (conn) {
        var _this = this;
        return function (message) {
            if (_this.state_ != 2 /* DISCONNECTED */) {
                if (conn === _this.rx_) {
                    _this.onPrimaryMessageReceived_(message);
                }
                else if (conn === _this.secondaryConn_) {
                    _this.onSecondaryMessageReceived_(message);
                }
                else {
                    _this.log_('message on old connection');
                }
            }
        };
    };
    /**
     *
     * @param {Object} dataMsg An arbitrary data message to be sent to the server
     */
    Connection.prototype.sendRequest = function (dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = { t: 'd', d: dataMsg };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function () {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
            // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function (controlData) {
        if (MESSAGE_TYPE in controlData) {
            var cmd = controlData[MESSAGE_TYPE];
            if (cmd === SWITCH_ACK) {
                this.upgradeIfSecondaryHealthy_();
            }
            else if (cmd === CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ ||
                    this.rx_ === this.secondaryConn_) {
                    this.close();
                }
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onSecondaryControl_(data);
        }
        else if (layer == 'd') {
            // got a data message, but we're still second connection. Need to buffer it up
            this.pendingDataMessages.push(data);
        }
        else {
            throw new Error('Unknown protocol layer: ' + layer);
        }
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        }
        else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function () {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onControl_(data);
        }
        else if (layer == 'd') {
            this.onDataMessage_(data);
        }
    };
    Connection.prototype.onDataMessage_ = function (message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function () {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function (controlData) {
        var cmd = requireKey(MESSAGE_TYPE, controlData);
        if (MESSAGE_DATA in controlData) {
            var payload = controlData[MESSAGE_DATA];
            if (cmd === SERVER_HELLO) {
                this.onHandshake_(payload);
            }
            else if (cmd === END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
                    this.onDataMessage_(this.pendingDataMessages[i]);
                }
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            }
            else if (cmd === CONTROL_SHUTDOWN) {
                // This was previously the 'onKill' callback passed to the lower-level connection
                // payload in this case is the reason for the shutdown. Generally a human-readable error
                this.onConnectionShutdown_(payload);
            }
            else if (cmd === CONTROL_RESET) {
                // payload in this case is the host we should contact
                this.onReset_(payload);
            }
            else if (cmd === CONTROL_ERROR) {
                error('Server Error: ' + payload);
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            }
            else {
                error('Unknown control packet command: ' + cmd);
            }
        }
    };
    /**
     *
     * @param {Object} handshake The handshake data returned from the server
     * @private
     */
    Connection.prototype.onHandshake_ = function (handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.updateHost(host);
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ == 0 /* CONNECTING */) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if (PROTOCOL_VERSION !== version) {
                warn('Protocol version mismatch detected');
            }
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    };
    Connection.prototype.tryStartUpgrade_ = function () {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) {
            this.startUpgrade_(conn);
        }
    };
    Connection.prototype.startUpgrade_ = function (conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ =
            conn['responsesRequiredToBeHealthy'] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        setTimeoutNonBlocking(function () {
            if (_this.secondaryConn_) {
                _this.log_('Timed out trying to upgrade.');
                _this.secondaryConn_.close();
            }
        }, Math.floor(UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function (host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.updateHost(host);
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */) {
            this.close();
        }
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
        var _this = this;
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        }
        else {
            setTimeoutNonBlocking(function () {
                _this.sendPingOnPrimaryIfNecessary_();
            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
        }
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
            this.log_('sending ping on primary.');
            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function () {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) {
            // we are relying on this connection already in some capacity. Therefore, a failure is real
            this.close();
        }
    };
    /**
     *
     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     * @private
     */
    Connection.prototype.onConnectionLost_ = function (everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        }
        else if (this.state_ === 1 /* CONNECTED */) {
            this.log_('Realtime connection lost.');
        }
        this.close();
    };
    /**
     *
     * @param {string} reason
     * @private
     */
    Connection.prototype.onConnectionShutdown_ = function (reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function (data) {
        if (this.state_ !== 1 /* CONNECTED */) {
            throw 'Connection is not connected';
        }
        else {
            this.tx_.send(data);
        }
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */
    Connection.prototype.close = function () {
        if (this.state_ !== 2 /* DISCONNECTED */) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* DISCONNECTED */;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     *
     * @private
     */
    Connection.prototype.closeConnections_ = function () {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */
var ServerActions = /** @class */ (function () {
    function ServerActions() {
    }
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, ?string)} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
    /**
     * Refreshes the auth token for the current connection.
     * @param {string} token The authentication token
     */
    ServerActions.prototype.refreshAuthToken = function (token) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
    /**
     * @param {Object.<string, *>} stats
     */
    ServerActions.prototype.reportStats = function (stats) { };
    return ServerActions;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RECONNECT_MIN_DELAY = 1000;
var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
var RECONNECT_DELAY_MULTIPLIER = 1.3;
var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var INVALID_AUTH_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */
var PersistentConnection = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentConnection, _super);
    /**
     * @implements {ServerActions}
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param onConnectStatus_
     * @param onServerInfoUpdate_
     * @param authTokenProvider_
     * @param authOverride_
     */
    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = logWrapper('p:' + _this.id + ':');
        /** @private {Object} */
        _this.interruptReasons_ = {};
        _this.listens_ = {};
        _this.outstandingPuts_ = [];
        _this.outstandingPutCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        /** @private {number|null} */
        _this.establishConnectionTimer_ = null;
        /** @private {boolean} */
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        /** @private {?{
         *   sendRequest(Object),
         *   close()
         * }} */
        _this.realtime_ = null;
        /** @private {string|null} */
        _this.authToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !util.isNodeSdk()) {
            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        }
        _this.scheduleConnect_(0);
        VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
        if (repoInfo_.host.indexOf('fblocal') === -1) {
            OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
        }
        return _this;
    }
    /**
     * @param {!string} action
     * @param {*} body
     * @param {function(*)=} onResponse
     * @protected
     */
    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = { r: curReqNum, a: action, b: body };
        this.log_(util.stringify(msg));
        util.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) {
            this.requestCBHash_[curReqNum] = onResponse;
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var queryId = query.queryIdentifier();
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        this.listens_[pathString] = this.listens_[pathString] || {};
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
        util.assert(!this.listens_[pathString][queryId], 'listen() called twice for same path/queryId.');
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens_[pathString][queryId] = listenSpec;
        if (this.connected_) {
            this.sendListen_(listenSpec);
        }
    };
    /**
     * @param {!{onComplete(),
     *           hashFn():!string,
     *           query: !Query,
     *           tag: ?number}} listenSpec
     * @private
     */
    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query.queryObject();
            req['t'] = listenSpec.tag;
        }
        req[ /*hash*/'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, function (message) {
            var payload = message[ /*data*/'d'];
            var status = message[ /*status*/'s'];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens_[pathString] && _this.listens_[pathString][queryId];
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_('listen response', message);
                if (status !== 'ok') {
                    _this.removeListen_(pathString, queryId);
                }
                if (listenSpec.onComplete) {
                    listenSpec.onComplete(status, payload);
                }
            }
        });
    };
    /**
     * @param {*} payload
     * @param {!Query} query
     * @private
     */
    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
        if (payload && typeof payload === 'object' && util.contains(payload, 'w')) {
            var warnings = util.safeGet(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                var indexSpec = '".indexOn": "' +
                    query
                        .getQueryParams()
                        .getIndex()
                        .toString() +
                    '"';
                var indexPath = query.path.toString();
                warn("Using an unspecified index. Your data will be downloaded and " +
                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
                    (indexPath + " to your security rules for better performance."));
            }
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.refreshAuthToken = function (token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) {
            this.tryAuth();
        }
        else {
            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
            //the credential so we dont become authenticated next time we connect.
            if (this.connected_) {
                this.sendRequest('unauth', {}, function () { });
            }
        }
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    /**
     * @param {!string} credential
     * @private
     */
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || util.isAdmin(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */
    PersistentConnection.prototype.tryAuth = function () {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = util.isValidFormat(token_1) ? 'auth' : 'gauth';
            var requestData = { cred: token_1 };
            if (this.authOverride_ === null) {
                requestData['noauth'] = true;
            }
            else if (typeof this.authOverride_ === 'object') {
                requestData['authvar'] = this.authOverride_;
            }
            this.sendRequest(authMethod, requestData, function (res) {
                var status = res[ /*status*/'s'];
                var data = res[ /*data*/'d'] || 'error';
                if (_this.authToken_ === token_1) {
                    if (status === 'ok') {
                        _this.invalidAuthTokenCount_ = 0;
                    }
                    else {
                        // Triggers reconnect and force refresh for auth token
                        _this.onAuthRevoked_(status, data);
                    }
                }
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.unlisten = function (query, tag) {
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) {
            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
        }
    };
    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('o', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'o',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('om', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'om',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('oc', pathString, null, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'oc',
                data: null,
                onComplete: onComplete
            });
        }
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
        var request = { /*path*/ p: pathString, /*data*/ d: data };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, function (response) {
            if (onComplete) {
                setTimeout(function () {
                    onComplete(response[ /*status*/'s'], response[ /* data */'d']);
                }, Math.floor(0));
            }
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
        var request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined)
            request[ /*hash*/'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) {
            this.sendPut_(index);
        }
        else {
            this.log_('Buffering put: ' + pathString);
        }
    };
    PersistentConnection.prototype.sendPut_ = function (index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function (message) {
            _this.log_(action + ' response', message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) {
                _this.outstandingPuts_ = [];
            }
            if (onComplete)
                onComplete(message[ /*status*/'s'], message[ /* data */'d']);
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.reportStats = function (stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = { /*counters*/ c: stats };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, function (result) {
                var status = result[ /*status*/'s'];
                if (status !== 'ok') {
                    var errorReason = result[ /* data */'d'];
                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    };
    /**
     * @param {*} message
     * @private
     */
    PersistentConnection.prototype.onDataMessage_ = function (message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + util.stringify(message));
            var reqNum = message['r'];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[ /*body*/'b']);
            }
        }
        else if ('error' in message) {
            throw 'A server-side error has occurred: ' + message['error'];
        }
        else if ('a' in message) {
            // a and b are action and body, respectively
            this.onDataPush_(message['a'], message['b']);
        }
    };
    PersistentConnection.prototype.onDataPush_ = function (action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge*/ false, body['t']);
        else if (action === 'm')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge=*/ true, body['t']);
        else if (action === 'c')
            this.onListenRevoked_(body[ /*path*/'p'], body[ /*query*/'q']);
        else if (action === 'ac')
            this.onAuthRevoked_(body[ /*status code*/'s'], body[ /* explanation */'d']);
        else if (action === 'sd')
            this.onSecurityDebugPacket_(body);
        else
            error('Unrecognized action received from server: ' +
                util.stringify(action) +
                '\nAre you using the latest client?');
    };
    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) {
            this.sendConnectStats_();
        }
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
        var _this = this;
        util.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) {
            clearTimeout(this.establishConnectionTimer_);
        }
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function () {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
        }, Math.floor(timeout));
    };
    /**
     * @param {boolean} visible
     * @private
     */
    PersistentConnection.prototype.onVisible_ = function (visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible &&
            !this.visible_ &&
            this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function (online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) {
                this.realtime_.close();
            }
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            }
            else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT)
                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function () {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            var onDataMessage_1 = this.onDataMessage_.bind(this);
            var onReady_1 = this.onReady_.bind(this);
            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
            var self_1 = this;
            var lastSessionId_1 = this.lastSessionId;
            var canceled_1 = false;
            var connection_1 = null;
            var closeFn_1 = function () {
                if (connection_1) {
                    connection_1.close();
                }
                else {
                    canceled_1 = true;
                    onDisconnect_1();
                }
            };
            var sendRequestFn = function (msg) {
                util.assert(connection_1, "sendRequest call when we're not connected not allowed.");
                connection_1.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn_1,
                sendRequest: sendRequestFn
            };
            var forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            // First fetch auth token, and establish connection after fetching the token was successful
            this.authTokenProvider_
                .getToken(forceRefresh)
                .then(function (result) {
                if (!canceled_1) {
                    log('getToken() completed. Creating connection.');
                    self_1.authToken_ = result && result.accessToken;
                    connection_1 = new Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
                    /* onKill= */ function (reason) {
                        warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId_1);
                }
                else {
                    log('getToken() completed but was canceled');
                }
            })
                .then(null, function (error$$1) {
                self_1.log_('Failed to get token: ' + error$$1);
                if (!canceled_1) {
                    if (util.CONSTANTS.NODE_ADMIN) {
                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
                        // But getToken() may also just have temporarily failed, so we still want to
                        // continue retrying.
                        warn(error$$1);
                    }
                    closeFn_1();
                }
            });
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.interrupt = function (reason) {
        log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) {
            this.realtime_.close();
        }
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) {
                this.onRealtimeDisconnect_();
            }
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.resume = function (reason) {
        log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if (util.isEmpty(this.interruptReasons_)) {
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({ serverTimeOffset: delta });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function () {
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete)
                    put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0)
            this.outstandingPuts_ = [];
    };
    /**
     * @param {!string} pathString
     * @param {Array.<*>=} query
     * @private
     */
    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) {
            queryId = 'default';
        }
        else {
            queryId = query.map(function (q) { return ObjectToUniqueKey(q); }).join('$');
        }
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete)
            listen.onComplete('permission_denied');
    };
    /**
     * @param {!string} pathString
     * @param {!string} queryId
     * @return {{queries:Array.<Query>, onComplete:function(string)}}
     * @private
     */
    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
        var normalizedPathString = new Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens_[normalizedPathString] !== undefined) {
            listen = this.listens_[normalizedPathString][queryId];
            delete this.listens_[normalizedPathString][queryId];
            if (util.getCount(this.listens_[normalizedPathString]) === 0) {
                delete this.listens_[normalizedPathString];
            }
        }
        else {
            // all listens for this path has already been removed
            listen = undefined;
        }
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
        log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
        if (this.securityDebugCallback_) {
            this.securityDebugCallback_(body);
        }
        else {
            if ('msg' in body) {
                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
            }
        }
    };
    PersistentConnection.prototype.restoreState_ = function () {
        var _this = this;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        util.forEach(this.listens_, function (pathString, queries) {
            util.forEach(queries, function (key, listenSpec) {
                _this.sendListen_(listenSpec);
            });
        });
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            if (this.outstandingPuts_[i])
                this.sendPut_(i);
        }
        while (this.onDisconnectRequestQueue_.length) {
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
    };
    /**
     * Sends client stats for first connection
     * @private
     */
    PersistentConnection.prototype.sendConnectStats_ = function () {
        var stats = {};
        var clientName = 'js';
        if (util.CONSTANTS.NODE_ADMIN) {
            clientName = 'admin_node';
        }
        else if (util.CONSTANTS.NODE_CLIENT) {
            clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + firebase.SDK_VERSION.replace(/\./g, '-')] = 1;
        if (util.isMobileCordova()) {
            stats['framework.cordova'] = 1;
        }
        else if (util.isReactNative()) {
            stats['framework.reactnative'] = 1;
        }
        this.reportStats(stats);
    };
    /**
     * @return {boolean}
     * @private
     */
    PersistentConnection.prototype.shouldReconnect_ = function () {
        var online = OnlineMonitor.getInstance().currentlyOnline();
        return util.isEmpty(this.interruptReasons_) && online;
    };
    /**
     * @private
     */
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     * @type {number}
     * @private
     */
    PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}(ServerActions));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */
var ReadonlyRestClient = /** @class */ (function (_super) {
    tslib_1.__extends(ReadonlyRestClient, _super);
    /**
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param {AuthTokenProvider} authTokenProvider_
     * @implements {ServerActions}
     */
    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        /** @private {function(...[*])} */
        _this.log_ = logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         *
         * @private {!Object.<string, !Object>}
         */
        _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function (stats) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {!Query} query
     * @param {?number=} tag
     * @return {string}
     * @private
     */
    ReadonlyRestClient.getListenId_ = function (query, tag) {
        if (tag !== undefined) {
            return 'tag$' + tag;
        }
        else {
            util.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
            return query.path.toString();
        }
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParameters = query
            .getQueryParams()
            .toRestQueryStringParameters();
        this.restRequest_(pathString + '.json', queryStringParameters, function (error$$1, result) {
            var data = result;
            if (error$$1 === 404) {
                data = null;
                error$$1 = null;
            }
            if (error$$1 === null) {
                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            }
            if (util.safeGet(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error$$1) {
                    status_1 = 'ok';
                }
                else if (error$$1 == 401) {
                    status_1 = 'permission_denied';
                }
                else {
                    status_1 = 'rest_error:' + error$$1;
                }
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
        // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     *
     * @param {!string} pathString
     * @param {!Object.<string, *>} queryStringParameters
     * @param {?function(?number, *=)} callback
     * @private
     */
    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) { queryStringParameters = {}; }
        queryStringParameters['format'] = 'export';
        this.authTokenProvider_
            .getToken(/*forceRefresh=*/ false)
            .then(function (authTokenData) {
            var authToken = authTokenData && authTokenData.accessToken;
            if (authToken) {
                queryStringParameters['auth'] = authToken;
            }
            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
                _this.repoInfo_.host +
                pathString +
                '?' +
                'ns=' +
                _this.repoInfo_.namespace +
                util.querystring(queryStringParameters);
            _this.log_('Sending REST request for ' + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (callback && xhr.readyState === 4) {
                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = util.jsonEval(xhr.responseText);
                        }
                        catch (e) {
                            warn('Failed to parse JSON response for ' +
                                url +
                                ': ' +
                                xhr.responseText);
                        }
                        callback(null, res);
                    }
                    else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) {
                            warn('Got unsuccessful REST response for ' +
                                url +
                                ' Status: ' +
                                xhr.status);
                        }
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}(ServerActions));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var INTERRUPT_REASON = 'repo_interrupt';
/**
 * A connection to a single data repository.
 */
var Repo = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo_
     * @param {boolean} forceRestClient
     * @param {!FirebaseApp} app
     */
    function Repo(repoInfo_, forceRestClient, app) {
        var _this = this;
        this.repoInfo_ = repoInfo_;
        this.app = app;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        // A list of data pieces and paths to be set when this client disconnects.
        this.onDisconnect_ = new SparseSnapshotTree();
        /**
         * TODO: This should be @private but it's used by test_access.js and internal.js
         * @type {?PersistentConnection}
         */
        this.persistentConnection_ = null;
        /** @type {!AuthTokenProvider} */
        var authTokenProvider = new AuthTokenProvider(app);
        this.stats_ = StatsManager.getCollection(repoInfo_);
        if (forceRestClient || beingCrawled()) {
            this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
            // Minor hack: Fire onConnect immediately, since there's no actual connection.
            setTimeout(this.onConnectStatus_.bind(this, true), 0);
        }
        else {
            var authOverride = app.options['databaseAuthVariableOverride'];
            // Validate authOverride
            if (typeof authOverride !== 'undefined' && authOverride !== null) {
                if (typeof authOverride !== 'object') {
                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
                }
                try {
                    util.stringify(authOverride);
                }
                catch (e) {
                    throw new Error('Invalid authOverride provided: ' + e);
                }
            }
            this.persistentConnection_ = new PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
            this.server_ = this.persistentConnection_;
        }
        authTokenProvider.addTokenChangeListener(function (token) {
            _this.server_.refreshAuthToken(token);
        });
        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
        this.statsReporter_ = StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter(_this.stats_, _this.server_); });
        this.transactions_init_();
        // Used for .info.
        this.infoData_ = new SnapshotHolder();
        this.infoSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                var infoEvents = [];
                var node = _this.infoData_.getNode(query.path);
                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
                // on initial data...
                if (!node.isEmpty()) {
                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
                    setTimeout(function () {
                        onComplete('ok');
                    }, 0);
                }
                return infoEvents;
            },
            stopListening: function () { }
        });
        this.updateInfo_('connected', false);
        this.serverSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
                    var events = onComplete(status, data);
                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
                });
                // No synchronous events for network-backed sync trees
                return [];
            },
            stopListening: function (query, tag) {
                _this.server_.unlisten(query, tag);
            }
        });
    }
    /**
     * @return {string}  The URL corresponding to the root of this Firebase.
     */
    Repo.prototype.toString = function () {
        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
    };
    /**
     * @return {!string} The namespace represented by the repo.
     */
    Repo.prototype.name = function () {
        return this.repoInfo_.namespace;
    };
    /**
     * @return {!number} The time in milliseconds, taking the server offset into account if we have one.
     */
    Repo.prototype.serverTime = function () {
        var offsetNode = this.infoData_.getNode(new Path('.info/serverTimeOffset'));
        var offset = offsetNode.val() || 0;
        return new Date().getTime() + offset;
    };
    /**
     * Generate ServerValues using some variables from the repo object.
     * @return {!Object}
     */
    Repo.prototype.generateServerValues = function () {
        return generateWithValues({
            timestamp: this.serverTime()
        });
    };
    /**
     * Called by realtime when we get new messages from the server.
     *
     * @private
     * @param {string} pathString
     * @param {*} data
     * @param {boolean} isMerge
     * @param {?number} tag
     */
    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
        // For testing.
        this.dataUpdateCount++;
        var path = new Path(pathString);
        data = this.interceptServerDataCallback_
            ? this.interceptServerDataCallback_(pathString, data)
            : data;
        var events = [];
        if (tag) {
            if (isMerge) {
                var taggedChildren = util.map(data, function (raw) {
                    return nodeFromJSON$1(raw);
                });
                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
            }
            else {
                var taggedSnap = nodeFromJSON$1(data);
                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
            }
        }
        else if (isMerge) {
            var changedChildren = util.map(data, function (raw) {
                return nodeFromJSON$1(raw);
            });
            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
        }
        else {
            var snap = nodeFromJSON$1(data);
            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
        }
        var affectedPath = path;
        if (events.length > 0) {
            // Since we have a listener outstanding for each transaction, receiving any events
            // is a proxy for some change having occurred.
            affectedPath = this.rerunTransactions_(path);
        }
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
    };
    /**
     * TODO: This should be @private but it's used by test_access.js and internal.js
     * @param {?function(!string, *):*} callback
     * @private
     */
    Repo.prototype.interceptServerData_ = function (callback) {
        this.interceptServerDataCallback_ = callback;
    };
    /**
     * @param {!boolean} connectStatus
     * @private
     */
    Repo.prototype.onConnectStatus_ = function (connectStatus) {
        this.updateInfo_('connected', connectStatus);
        if (connectStatus === false) {
            this.runOnDisconnectEvents_();
        }
    };
    /**
     * @param {!Object} updates
     * @private
     */
    Repo.prototype.onServerInfoUpdate_ = function (updates) {
        var _this = this;
        each(updates, function (value, key) {
            _this.updateInfo_(key, value);
        });
    };
    /**
     *
     * @param {!string} pathString
     * @param {*} value
     * @private
     */
    Repo.prototype.updateInfo_ = function (pathString, value) {
        var path = new Path('/.info/' + pathString);
        var newNode = nodeFromJSON$1(value);
        this.infoData_.updateSnapshot(path, newNode);
        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
    };
    /**
     * @return {!number}
     * @private
     */
    Repo.prototype.getNextWriteId_ = function () {
        return this.nextWriteId_++;
    };
    /**
     * @param {!Path} path
     * @param {*} newVal
     * @param {number|string|null} newPriority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
        var _this = this;
        this.log_('set', {
            path: path.toString(),
            value: newVal,
            priority: newPriority
        });
        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
        // (b) store unresolved paths on JSON parse
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        var writeId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
        this.eventQueue_.queueEvents(events);
        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
            var success = status === 'ok';
            if (!success) {
                warn('set at ' + path + ' failed: ' + status);
            }
            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
        var affectedPath = this.abortTransactions_(path);
        this.rerunTransactions_(affectedPath);
        // We queued the events above, so just flush the queue here
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
    };
    /**
     * @param {!Path} path
     * @param {!Object} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
        var _this = this;
        this.log_('update', { path: path.toString(), value: childrenToMerge });
        // Start with our existing data and merge each child into it.
        var empty = true;
        var serverValues = this.generateServerValues();
        var changedChildren = {};
        util.forEach(childrenToMerge, function (changedKey, changedValue) {
            empty = false;
            var newNodeUnresolved = nodeFromJSON$1(changedValue);
            changedChildren[changedKey] = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        });
        if (!empty) {
            var writeId_1 = this.getNextWriteId_();
            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
            this.eventQueue_.queueEvents(events);
            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
                var success = status === 'ok';
                if (!success) {
                    warn('update at ' + path + ' failed: ' + status);
                }
                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
                _this.callOnCompleteCallback(onComplete, status, errorReason);
            });
            util.forEach(childrenToMerge, function (changedPath) {
                var affectedPath = _this.abortTransactions_(path.child(changedPath));
                _this.rerunTransactions_(affectedPath);
            });
            // We queued the events above, so just flush the queue here
            this.eventQueue_.raiseEventsForChangedPath(path, []);
        }
        else {
            log("update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
        }
    };
    /**
     * Applies all of the changes stored up in the onDisconnect_ tree.
     * @private
     */
    Repo.prototype.runOnDisconnectEvents_ = function () {
        var _this = this;
        this.log_('onDisconnectEvents');
        var serverValues = this.generateServerValues();
        var resolvedOnDisconnectTree = resolveDeferredValueTree(this.onDisconnect_, serverValues);
        var events = [];
        resolvedOnDisconnectTree.forEachTree(Path.Empty, function (path, snap) {
            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
            var affectedPath = _this.abortTransactions_(path);
            _this.rerunTransactions_(affectedPath);
        });
        this.onDisconnect_ = new SparseSnapshotTree();
        this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
    };
    /**
     * @param {!Path} path
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
        var _this = this;
        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.forget(path);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {*} priority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value, priority);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
        var _this = this;
        if (util.isEmpty(childrenToMerge)) {
            log("onDisconnect().update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
            return;
        }
        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
            if (status === 'ok') {
                util.forEach(childrenToMerge, function (childName, childNode) {
                    var newChildNode = nodeFromJSON$1(childNode);
                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
                });
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     */
    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    /**
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration
     */
    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
        // a little bit by handling the return values anyways.
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.interrupt = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.interrupt(INTERRUPT_REASON);
        }
    };
    Repo.prototype.resume = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.resume(INTERRUPT_REASON);
        }
    };
    Repo.prototype.stats = function (showDelta) {
        if (showDelta === void 0) { showDelta = false; }
        if (typeof console === 'undefined')
            return;
        var stats;
        if (showDelta) {
            if (!this.statsListener_)
                this.statsListener_ = new StatsListener(this.stats_);
            stats = this.statsListener_.get();
        }
        else {
            stats = this.stats_.get();
        }
        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
            return Math.max(currentValue.length, previousValue);
        }, 0);
        util.forEach(stats, function (stat, value) {
            // pad stat names to be the same length (plus 2 extra spaces).
            for (var i = stat.length; i < longestName + 2; i++)
                stat += ' ';
            console.log(stat + value);
        });
    };
    Repo.prototype.statsIncrementCounter = function (metric) {
        this.stats_.incrementCounter(metric);
        this.statsReporter_.includeStat(metric);
    };
    /**
     * @param {...*} var_args
     * @private
     */
    Repo.prototype.log_ = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        var prefix = '';
        if (this.persistentConnection_) {
            prefix = this.persistentConnection_.id + ':';
        }
        log.apply(void 0, [prefix].concat(var_args));
    };
    /**
     * @param {?function(?Error, *=)} callback
     * @param {!string} status
     * @param {?string=} errorReason
     */
    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
        if (callback) {
            exceptionGuard(function () {
                if (status == 'ok') {
                    callback(null);
                }
                else {
                    var code = (status || 'error').toUpperCase();
                    var message = code;
                    if (errorReason)
                        message += ': ' + errorReason;
                    var error$$1 = new Error(message);
                    error$$1.code = code;
                    callback(error$$1);
                }
            });
        }
    };
    Object.defineProperty(Repo.prototype, "database", {
        get: function () {
            return this.__database || (this.__database = new Database(this));
        },
        enumerable: true,
        configurable: true
    });
    return Repo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */
var RangedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function RangedFilter(params) {
        this.indexedFilter_ = new IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getStartPost = function () {
        return this.startPost_;
    };
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getEndPost = function () {
        return this.endPost_;
    };
    /**
     * @param {!NamedNode} node
     * @return {boolean}
     */
    RangedFilter.prototype.matches = function (node) {
        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
            this.index_.compare(node, this.getEndPost()) <= 0);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            newSnap = ChildrenNode.EMPTY_NODE;
        }
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            if (!self.matches(new NamedNode(key, childNode))) {
                filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
            }
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndexedFilter = function () {
        return this.indexedFilter_;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getStartPost_ = function (params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        }
        else {
            return params.getIndex().minPost();
        }
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getEndPost_ = function (params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        }
        else {
            return params.getIndex().maxPost();
        }
    };
    return RangedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */
var LimitedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function LimitedFilter(params) {
        this.rangedFilter_ = new RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        if (snap.getImmediateChild(key).equals(newChild)) {
            // No change
            return snap;
        }
        else if (snap.numChildren() < this.limit_) {
            return this.rangedFilter_
                .getIndexedFilter()
                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        }
        else {
            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
        }
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        }
        else {
            if (this.limit_ * 2 < newSnap.numChildren() &&
                newSnap.isIndexed(this.index_)) {
                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
                filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
                // anchor to the startPost, endPost, or last element as appropriate
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
                }
                else {
                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
                }
                var count = 0;
                while (iterator.hasNext() && count < this.limit_) {
                    var next = iterator.getNext();
                    var inRange = void 0;
                    if (this.reverse_) {
                        inRange =
                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                    }
                    else {
                        inRange =
                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                    }
                    if (inRange) {
                        filtered = filtered.updateImmediateChild(next.name, next.node);
                        count++;
                    }
                    else {
                        // if we have reached the end post, we cannot keep adding elemments
                        break;
                    }
                }
            }
            else {
                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
                filtered = newSnap.withIndex(this.index_);
                // Don't support priorities on queries
                filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
                var startPost = void 0;
                var endPost = void 0;
                var cmp = void 0;
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = filtered.getReverseIterator(this.index_);
                    startPost = this.rangedFilter_.getEndPost();
                    endPost = this.rangedFilter_.getStartPost();
                    var indexCompare_1 = this.index_.getCompare();
                    cmp = function (a, b) { return indexCompare_1(b, a); };
                }
                else {
                    iterator = filtered.getIterator(this.index_);
                    startPost = this.rangedFilter_.getStartPost();
                    endPost = this.rangedFilter_.getEndPost();
                    cmp = this.index_.getCompare();
                }
                var count = 0;
                var foundStartPost = false;
                while (iterator.hasNext()) {
                    var next = iterator.getNext();
                    if (!foundStartPost && cmp(startPost, next) <= 0) {
                        // start adding
                        foundStartPost = true;
                    }
                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                    if (inRange) {
                        count++;
                    }
                    else {
                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
                    }
                }
            }
        }
        return this.rangedFilter_
            .getIndexedFilter()
            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndexedFilter = function () {
        return this.rangedFilter_.getIndexedFilter();
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!Node} snap
     * @param {string} childKey
     * @param {!Node} childSnap
     * @param {!CompleteChildSource} source
     * @param {?ChildChangeAccumulator} changeAccumulator
     * @return {!Node}
     * @private
     */
    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function (a, b) { return indexCmp_1(b, a); };
        }
        else {
            cmp = this.index_.getCompare();
        }
        var oldEventCache = snap;
        util.assert(oldEventCache.numChildren() == this.limit_, '');
        var newChildNamedNode = new NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_
            ? oldEventCache.getFirstChild(this.index_)
            : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while (nextChild != null &&
                (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
                // been applied to the limited filter yet. Ignore this next child which will be updated later in
                // the limited filter...
                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            }
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            }
            else {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
                }
                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) {
                        changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
                    }
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                }
                else {
                    return newEventCache;
                }
            }
        }
        else if (childSnap.isEmpty()) {
            // we're deleting a node, but it was not in the window, so ignore it
            return snap;
        }
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
                }
                return oldEventCache
                    .updateImmediateChild(childKey, childSnap)
                    .updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
            }
            else {
                return snap;
            }
        }
        else {
            return snap;
        }
    };
    return LimitedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */
var QueryParams = /** @class */ (function () {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = PRIORITY_INDEX;
    }
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasStart = function () {
        return this.startSet_;
    };
    /**
     * @return {boolean} True if it would return from left.
     */
    QueryParams.prototype.isViewFromLeft = function () {
        if (this.viewFrom_ === '') {
            // limit(), rather than limitToFirst or limitToLast was called.
            // This means that only one of startSet_ and endSet_ is true. Use them
            // to calculate which side of the view to anchor to. If neither is set,
            // anchor to the end.
            return this.startSet_;
        }
        else {
            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
        }
    };
    /**
     * Only valid to call if hasStart() returns true
     * @return {*}
     */
    QueryParams.prototype.getIndexStartValue = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexStartName = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) {
            return this.indexStartName_;
        }
        else {
            return MIN_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasEnd = function () {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * @return {*}
     */
    QueryParams.prototype.getIndexEndValue = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexEndName = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) {
            return this.indexEndName_;
        }
        else {
            return MAX_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasLimit = function () {
        return this.limitSet_;
    };
    /**
     * @return {boolean} True if a limit has been set and it has been explicitly anchored
     */
    QueryParams.prototype.hasAnchoredLimit = function () {
        return this.limitSet_ && this.viewFrom_ !== '';
    };
    /**
     * Only valid to call if hasLimit() returns true
     * @return {!number}
     */
    QueryParams.prototype.getLimit = function () {
        util.assert(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    };
    /**
     * @return {!Index}
     */
    QueryParams.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @return {!QueryParams}
     * @private
     */
    QueryParams.prototype.copy_ = function () {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limit = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = '';
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToFirst = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToLast = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.startAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.startSet_ = true;
        if (!(indexValue !== undefined)) {
            indexValue = null;
        }
        newParams.indexStartValue_ = indexValue;
        if (key != null) {
            newParams.startNameSet_ = true;
            newParams.indexStartName_ = key;
        }
        else {
            newParams.startNameSet_ = false;
            newParams.indexStartName_ = '';
        }
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.endAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.endSet_ = true;
        if (!(indexValue !== undefined)) {
            indexValue = null;
        }
        newParams.indexEndValue_ = indexValue;
        if (key !== undefined) {
            newParams.endNameSet_ = true;
            newParams.indexEndName_ = key;
        }
        else {
            newParams.endNameSet_ = false;
            newParams.indexEndName_ = '';
        }
        return newParams;
    };
    /**
     * @param {!Index} index
     * @return {!QueryParams}
     */
    QueryParams.prototype.orderBy = function (index) {
        var newParams = this.copy_();
        newParams.index_ = index;
        return newParams;
    };
    /**
     * @return {!Object}
     */
    QueryParams.prototype.getQueryObject = function () {
        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
        var obj = {};
        if (this.startSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
            if (this.startNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
            }
        }
        if (this.endSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
            if (this.endNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
            }
        }
        if (this.limitSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
            var viewFrom = this.viewFrom_;
            if (viewFrom === '') {
                if (this.isViewFromLeft()) {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
                }
                else {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
                }
            }
            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
        }
        // For now, priority index is the default, so we only specify if it's some other index
        if (this.index_ !== PRIORITY_INDEX) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
        }
        return obj;
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.loadsAllData = function () {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.isDefault = function () {
        return this.loadsAllData() && this.index_ == PRIORITY_INDEX;
    };
    /**
     * @return {!NodeFilter}
     */
    QueryParams.prototype.getNodeFilter = function () {
        if (this.loadsAllData()) {
            return new IndexedFilter(this.getIndex());
        }
        else if (this.hasLimit()) {
            return new LimitedFilter(this);
        }
        else {
            return new RangedFilter(this);
        }
    };
    /**
     * Returns a set of REST query string parameters representing this query.
     *
     * @return {!Object.<string,*>} query string parameters
     */
    QueryParams.prototype.toRestQueryStringParameters = function () {
        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
        var qs = {};
        if (this.isDefault()) {
            return qs;
        }
        var orderBy;
        if (this.index_ === PRIORITY_INDEX) {
            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
        }
        else if (this.index_ === VALUE_INDEX) {
            orderBy = REST_CONSTANTS.VALUE_INDEX;
        }
        else if (this.index_ === KEY_INDEX) {
            orderBy = REST_CONSTANTS.KEY_INDEX;
        }
        else {
            util.assert(this.index_ instanceof PathIndex, 'Unrecognized index type!');
            orderBy = this.index_.toString();
        }
        qs[REST_CONSTANTS.ORDER_BY] = util.stringify(orderBy);
        if (this.startSet_) {
            qs[REST_CONSTANTS.START_AT] = util.stringify(this.indexStartValue_);
            if (this.startNameSet_) {
                qs[REST_CONSTANTS.START_AT] += ',' + util.stringify(this.indexStartName_);
            }
        }
        if (this.endSet_) {
            qs[REST_CONSTANTS.END_AT] = util.stringify(this.indexEndValue_);
            if (this.endNameSet_) {
                qs[REST_CONSTANTS.END_AT] += ',' + util.stringify(this.indexEndName_);
            }
        }
        if (this.limitSet_) {
            if (this.isViewFromLeft()) {
                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
            }
            else {
                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
            }
        }
        return qs;
    };
    /**
     * Wire Protocol Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
        INDEX_START_VALUE: 'sp',
        INDEX_START_NAME: 'sn',
        INDEX_END_VALUE: 'ep',
        INDEX_END_NAME: 'en',
        LIMIT: 'l',
        VIEW_FROM: 'vf',
        VIEW_FROM_LEFT: 'l',
        VIEW_FROM_RIGHT: 'r',
        INDEX: 'i'
    };
    /**
     * REST Query Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.REST_QUERY_CONSTANTS_ = {
        ORDER_BY: 'orderBy',
        PRIORITY_INDEX: '$priority',
        VALUE_INDEX: '$value',
        KEY_INDEX: '$key',
        START_AT: 'startAt',
        END_AT: 'endAt',
        LIMIT_TO_FIRST: 'limitToFirst',
        LIMIT_TO_LAST: 'limitToLast'
    };
    /**
     * Default, empty query parameters
     * @type {!QueryParams}
     * @const
     */
    QueryParams.DEFAULT = new QueryParams();
    return QueryParams;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Reference = /** @class */ (function (_super) {
    tslib_1.__extends(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     *
     * @param {!Repo} repo
     * @param {(!Path)} path
     * @extends {Query}
     */
    function Reference(repo, path) {
        var _this = this;
        if (!(repo instanceof Repo)) {
            throw new Error('new Reference() no longer supported - use app.database().');
        }
        // call Query's constructor, passing in the repo and path.
        _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
        return _this;
    }
    /** @return {?string} */
    Reference.prototype.getKey = function () {
        util.validateArgCount('Reference.key', 0, 0, arguments.length);
        if (this.path.isEmpty())
            return null;
        else
            return this.path.getBack();
    };
    /**
     * @param {!(string|Path)} pathString
     * @return {!Reference}
     */
    Reference.prototype.child = function (pathString) {
        util.validateArgCount('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') {
            pathString = String(pathString);
        }
        else if (!(pathString instanceof Path)) {
            if (this.path.getFront() === null)
                validateRootPathString('Reference.child', 1, pathString, false);
            else
                validatePathString('Reference.child', 1, pathString, false);
        }
        return new Reference(this.repo, this.path.child(pathString));
    };
    /** @return {?Reference} */
    Reference.prototype.getParent = function () {
        util.validateArgCount('Reference.parent', 0, 0, arguments.length);
        var parentPath = this.path.parent();
        return parentPath === null ? null : new Reference(this.repo, parentPath);
    };
    /** @return {!Reference} */
    Reference.prototype.getRoot = function () {
        util.validateArgCount('Reference.root', 0, 0, arguments.length);
        var ref = this;
        while (ref.getParent() !== null) {
            ref = ref.getParent();
        }
        return ref;
    };
    /** @return {!Database} */
    Reference.prototype.databaseProp = function () {
        return this.repo.database;
    };
    /**
     * @param {*} newVal
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.set = function (newVal, onComplete) {
        util.validateArgCount('Reference.set', 1, 2, arguments.length);
        validateWritablePath('Reference.set', this.path);
        validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
        util.validateCallback('Reference.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, 
        /*priority=*/ null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('Reference.update', 1, 2, arguments.length);
        validateWritablePath('Reference.update', this.path);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to Firebase.update() is deprecated. ' +
                'Use set() if you want to overwrite the existing data, or ' +
                'an Object with integer keys if you really do want to ' +
                'only update some of the children.');
        }
        validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
        util.validateCallback('Reference.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} newVal
     * @param {string|number|null} newPriority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
        util.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('Reference.setWithPriority', this.path);
        validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
        validatePriority('Reference.setWithPriority', 2, newPriority, false);
        util.validateCallback('Reference.setWithPriority', 3, onComplete, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.setWithPriority failed: ' +
                this.getKey() +
                ' is a read-only object.';
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.remove = function (onComplete) {
        util.validateArgCount('Reference.remove', 0, 1, arguments.length);
        validateWritablePath('Reference.remove', this.path);
        util.validateCallback('Reference.remove', 1, onComplete, true);
        return this.set(null, onComplete);
    };
    /**
     * @param {function(*):*} transactionUpdate
     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
     * @param {boolean=} applyLocally
     * @return {!Promise}
     */
    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
        util.validateArgCount('Reference.transaction', 1, 3, arguments.length);
        validateWritablePath('Reference.transaction', this.path);
        util.validateCallback('Reference.transaction', 1, transactionUpdate, false);
        util.validateCallback('Reference.transaction', 2, onComplete, true);
        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
        // to expose it.
        validateBoolean('Reference.transaction', 3, applyLocally, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.transaction failed: ' +
                this.getKey() +
                ' is a read-only object.';
        if (applyLocally === undefined)
            applyLocally = true;
        var deferred = new util.Deferred();
        if (typeof onComplete === 'function') {
            deferred.promise.catch(function () { });
        }
        var promiseComplete = function (error$$1, committed, snapshot) {
            if (error$$1) {
                deferred.reject(error$$1);
            }
            else {
                deferred.resolve(new TransactionResult(committed, snapshot));
            }
            if (typeof onComplete === 'function') {
                onComplete(error$$1, committed, snapshot);
            }
        };
        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
        return deferred.promise;
    };
    /**
     * @param {string|number|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setPriority = function (priority, onComplete) {
        util.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
        validateWritablePath('Reference.setPriority', this.path);
        validatePriority('Reference.setPriority', 1, priority, false);
        util.validateCallback('Reference.setPriority', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*=} value
     * @param {function(?Error)=} onComplete
     * @return {!Reference}
     */
    Reference.prototype.push = function (value, onComplete) {
        util.validateArgCount('Reference.push', 0, 2, arguments.length);
        validateWritablePath('Reference.push', this.path);
        validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
        util.validateCallback('Reference.push', 2, onComplete, true);
        var now = this.repo.serverTime();
        var name = nextPushId(now);
        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
        // We use child() to create handles to two different references. The first is turned into a
        // ThennableReference below by adding then() and catch() methods and is used as the
        // return value of push(). The second remains a regular Reference and is used as the fulfilled
        // value of the first ThennableReference.
        var thennablePushRef = this.child(name);
        var pushRef = this.child(name);
        var promise;
        if (value != null) {
            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
        }
        else {
            promise = Promise.resolve(pushRef);
        }
        thennablePushRef.then = promise.then.bind(promise);
        thennablePushRef.catch = promise.then.bind(promise, undefined);
        if (typeof onComplete === 'function') {
            promise.catch(function () { });
        }
        return thennablePushRef;
    };
    /**
     * @return {!OnDisconnect}
     */
    Reference.prototype.onDisconnect = function () {
        validateWritablePath('Reference.onDisconnect', this.path);
        return new OnDisconnect(this.repo, this.path);
    };
    Object.defineProperty(Reference.prototype, "database", {
        get: function () {
            return this.databaseProp();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "key", {
        get: function () {
            return this.getKey();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function () {
            return this.getParent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function () {
            return this.getRoot();
        },
        enumerable: true,
        configurable: true
    });
    return Reference;
}(Query));
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */
Query.__referenceConstructor = Reference;
SyncPoint.__referenceConstructor = Reference;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Node in a Tree.
 */
var TreeNode = /** @class */ (function () {
    function TreeNode() {
        // TODO: Consider making accessors that create children and value lazily or
        // separate Internal / Leaf 'types'.
        this.children = {};
        this.childCount = 0;
        this.value = null;
    }
    return TreeNode;
}());
/**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */
var Tree = /** @class */ (function () {
    /**
     * @template T
     * @param {string=} name_ Optional name of the node.
     * @param {Tree=} parent_ Optional parent node.
     * @param {TreeNode=} node_ Optional node to wrap.
     */
    function Tree(name_, parent_, node_) {
        if (name_ === void 0) { name_ = ''; }
        if (parent_ === void 0) { parent_ = null; }
        if (node_ === void 0) { node_ = new TreeNode(); }
        this.name_ = name_;
        this.parent_ = parent_;
        this.node_ = node_;
    }
    /**
     * Returns a sub-Tree for the given path.
     *
     * @param {!(string|Path)} pathObj Path to look up.
     * @return {!Tree.<T>} Tree for path.
     */
    Tree.prototype.subTree = function (pathObj) {
        // TODO: Require pathObj to be Path?
        var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
        var child = this, next;
        while ((next = path.getFront()) !== null) {
            var childNode = util.safeGet(child.node_.children, next) || new TreeNode();
            child = new Tree(next, child, childNode);
            path = path.popFront();
        }
        return child;
    };
    /**
     * Returns the data associated with this tree node.
     *
     * @return {?T} The data or null if no data exists.
     */
    Tree.prototype.getValue = function () {
        return this.node_.value;
    };
    /**
     * Sets data to this tree node.
     *
     * @param {!T} value Value to set.
     */
    Tree.prototype.setValue = function (value) {
        util.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
        this.node_.value = value;
        this.updateParents_();
    };
    /**
     * Clears the contents of the tree node (its value and all children).
     */
    Tree.prototype.clear = function () {
        this.node_.value = null;
        this.node_.children = {};
        this.node_.childCount = 0;
        this.updateParents_();
    };
    /**
     * @return {boolean} Whether the tree has any children.
     */
    Tree.prototype.hasChildren = function () {
        return this.node_.childCount > 0;
    };
    /**
     * @return {boolean} Whether the tree is empty (no value or children).
     */
    Tree.prototype.isEmpty = function () {
        return this.getValue() === null && !this.hasChildren();
    };
    /**
     * Calls action for each child of this tree node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachChild = function (action) {
        var _this = this;
        util.forEach(this.node_.children, function (child, childTree) {
            action(new Tree(child, _this, childTree));
        });
    };
    /**
     * Does a depth-first traversal of this node's descendants, calling action for each one.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
     *   false.
     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
     *   parent.
     */
    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
        if (includeSelf && !childrenFirst)
            action(this);
        this.forEachChild(function (child) {
            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
        });
        if (includeSelf && childrenFirst)
            action(this);
    };
    /**
     * Calls action on each ancestor node.
     *
     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
     *   true to abort.
     * @param {boolean=} includeSelf Whether to call action on this node as well.
     * @return {boolean} true if the action callback returned true.
     */
    Tree.prototype.forEachAncestor = function (action, includeSelf) {
        var node = includeSelf ? this : this.parent();
        while (node !== null) {
            if (action(node)) {
                return true;
            }
            node = node.parent();
        }
        return false;
    };
    /**
     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
     * is found, action is called on it and traversal does not continue inside the node.
     * Action is *not* called on this node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
        this.forEachChild(function (child) {
            if (child.getValue() !== null)
                action(child);
            else
                child.forEachImmediateDescendantWithValue(action);
        });
    };
    /**
     * @return {!Path} The path of this tree node, as a Path.
     */
    Tree.prototype.path = function () {
        return new Path(this.parent_ === null
            ? this.name_
            : this.parent_.path() + '/' + this.name_);
    };
    /**
     * @return {string} The name of the tree node.
     */
    Tree.prototype.name = function () {
        return this.name_;
    };
    /**
     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
     */
    Tree.prototype.parent = function () {
        return this.parent_;
    };
    /**
     * Adds or removes this child from its parent based on whether it's empty or not.
     *
     * @private
     */
    Tree.prototype.updateParents_ = function () {
        if (this.parent_ !== null)
            this.parent_.updateChild_(this.name_, this);
    };
    /**
     * Adds or removes the passed child to this tree node, depending on whether it's empty.
     *
     * @param {string} childName The name of the child to update.
     * @param {!Tree.<T>} child The child to update.
     * @private
     */
    Tree.prototype.updateChild_ = function (childName, child) {
        var childEmpty = child.isEmpty();
        var childExists = util.contains(this.node_.children, childName);
        if (childEmpty && childExists) {
            delete this.node_.children[childName];
            this.node_.childCount--;
            this.updateParents_();
        }
        else if (!childEmpty && !childExists) {
            this.node_.children[childName] = child.node_;
            this.node_.childCount++;
            this.updateParents_();
        }
    };
    return Tree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */
var TransactionStatus;
(function (TransactionStatus) {
    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
    // mismatched hash.
    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
    // or rejected yet).
    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
    // removed when we get a chance to prune completed ones.
    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
    // If it comes back as unsuccessful, we'll abort it.
    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
    // Temporary state used to mark transactions that need to be aborted.
    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})(TransactionStatus || (TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */
Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */
Repo.prototype.transactions_init_ = function () {
    /**
     * Stores queues of outstanding transactions for Firebase locations.
     *
     * @type {!Tree.<Array.<!Transaction>>}
     * @private
     */
    this.transactionQueueTree_ = new Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */
Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
    this.log_('transaction on ' + path);
    // Add a watch to make sure we get server updates.
    var valueCallback = function () { };
    var watchRef = new Reference(this, path);
    watchRef.on('value', valueCallback);
    var unwatcher = function () {
        watchRef.off('value', valueCallback);
    };
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out which one goes first.
        order: LUIDGenerator(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = this.getLatestState_(path);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) {
            // We just set the input snapshot, so this cast should be safe
            var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference(this, transaction.path), PRIORITY_INDEX);
            transaction.onComplete(null, false, snapshot);
        }
    }
    else {
        validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = TransactionStatus.RUN;
        var queueNode = this.transactionQueueTree_.subTree(path);
        var nodeQueue = queueNode.getValue() || [];
        nodeQueue.push(transaction);
        queueNode.setValue(nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our transaction state, since the user could
        // start new transactions from the event callbacks.
        var priorityForNode = void 0;
        if (typeof newVal === 'object' &&
            newVal !== null &&
            util.contains(newVal, '.priority')) {
            priorityForNode = util.safeGet(newVal, '.priority');
            util.assert(isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
                'Priority must be a valid string, finite number, server value, or null.');
        }
        else {
            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
                ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        priorityForNode /** @type {null|number|string} */ = priorityForNode;
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        this.sendReadyTransactions_();
    }
};
/**
 * @param {!Path} path
 * @param {Array.<number>=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */
Repo.prototype.getLatestState_ = function (path, excludeSets) {
    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
        ChildrenNode.EMPTY_NODE);
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
 * @private
 */
Repo.prototype.sendReadyTransactions_ = function (node) {
    var _this = this;
    if (node === void 0) { node = this.transactionQueueTree_; }
    // Before recursing, make sure any completed transactions are removed.
    if (!node) {
        this.pruneCompletedTransactionsBelowNode_(node);
    }
    if (node.getValue() !== null) {
        var queue = this.buildTransactionQueue_(node);
        util.assert(queue.length > 0, 'Sending zero length transaction queue');
        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) {
            this.sendTransactionQueue_(node.path(), queue);
        }
    }
    else if (node.hasChildren()) {
        node.forEachChild(function (childNode) {
            _this.sendReadyTransactions_(childNode);
        });
    }
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
 * @private
 */
Repo.prototype.sendTransactionQueue_ = function (path, queue) {
    var _this = this;
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function (txn) {
        return txn.currentWriteId;
    });
    var latestState = this.getLatestState_(path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for (var i = 0; i < queue.length; i++) {
        var txn = queue[i];
        util.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = TransactionStatus.SENT;
        txn.retryCount++;
        var relativePath = Path.relativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
        _this.log_('transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
            // the callback could trigger more transactions or sets.
            var callbacks = [];
            for (var i = 0; i < queue.length; i++) {
                queue[i].status = TransactionStatus.COMPLETED;
                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
                if (queue[i].onComplete) {
                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
                    var node = queue[i].currentOutputSnapshotResolved;
                    var ref = new Reference(_this, queue[i].path);
                    var snapshot = new DataSnapshot(node, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
                }
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
            // There may be pending transactions that we can now send.
            _this.sendReadyTransactions_();
            _this.eventQueue_.raiseEventsForChangedPath(path, events);
            // Finally, trigger onComplete callbacks.
            for (var i = 0; i < callbacks.length; i++) {
                exceptionGuard(callbacks[i]);
            }
        }
        else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for (var i = 0; i < queue.length; i++) {
                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT)
                        queue[i].status = TransactionStatus.NEEDS_ABORT;
                    else
                        queue[i].status = TransactionStatus.RUN;
                }
            }
            else {
                warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for (var i = 0; i < queue.length; i++) {
                    queue[i].status = TransactionStatus.NEEDS_ABORT;
                    queue[i].abortReason = status;
                }
            }
            _this.rerunTransactions_(path);
        }
    }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */
Repo.prototype.rerunTransactions_ = function (changedPath) {
    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
    var path = rootMostTransactionNode.path();
    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
    this.rerunTransactionQueue_(queue, path);
    return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.<Transaction>} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */
Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
    if (queue.length === 0) {
        return; // Nothing to do!
    }
    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
    // the callback could trigger more transactions or sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function (q) {
        return q.status === TransactionStatus.RUN;
    });
    var setsToIgnore = txnsToRerun.map(function (q) {
        return q.currentWriteId;
    });
    for (var i = 0; i < queue.length; i++) {
        var transaction = queue[i];
        var relativePath = Path.relativePath(path, transaction.path);
        var abortTransaction = false, abortReason = void 0;
        util.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        }
        else if (transaction.status === TransactionStatus.RUN) {
            if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
            }
            else {
                // This code reruns a transaction
                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    var newDataNode = nodeFromJSON$1(newData);
                    var hasExplicitPriority = typeof newData === 'object' &&
                        newData != null &&
                        util.contains(newData, '.priority');
                    if (!hasExplicitPriority) {
                        // Keep the old priority if there wasn't a priority explicitly specified.
                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    }
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = this.generateServerValues();
                    var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = this.getNextWriteId_();
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
                }
                else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
                }
            }
        }
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = TransactionStatus.COMPLETED;
            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
            // So defer the unwatcher until we're done.
            (function (unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') {
                    var ref = new Reference(this, queue[i].path);
                    // We set this field immediately, so it's safe to cast to an actual snapshot
                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
                    var snapshot = new DataSnapshot(lastInput, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
                }
                else {
                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
                }
            }
        }
    }
    // Clean up completed transactions.
    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for (var i = 0; i < callbacks.length; i++) {
        exceptionGuard(callbacks[i]);
    }
    // Try to send the transaction result to the server.
    this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
 * @private
 */
Repo.prototype.getAncestorTransactionNode_ = function (path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
    var transactionNode = this.transactionQueueTree_;
    while ((front = path.getFront()) !== null &&
        transactionNode.getValue() === null) {
        transactionNode = transactionNode.subTree(front);
        path = path.popFront();
    }
    return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.<Array.<Transaction>>} transactionNode
 * @return {Array.<Transaction>} The generated queue.
 * @private
 */
Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function (a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
};
/**
 * @param {!Tree.<Array.<Transaction>>} node
 * @param {Array.<Transaction>} queue
 * @private
 */
Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
    var _this = this;
    var nodeQueue = node.getValue();
    if (nodeQueue !== null) {
        for (var i = 0; i < nodeQueue.length; i++) {
            queue.push(nodeQueue[i]);
        }
    }
    node.forEachChild(function (child) {
        _this.aggregateTransactionQueuesForNode_(child, queue);
    });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.<Array.<!Transaction>>} node
 * @private
 */
Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
    var _this = this;
    var queue = node.getValue();
    if (queue) {
        var to = 0;
        for (var from = 0; from < queue.length; from++) {
            if (queue[from].status !== TransactionStatus.COMPLETED) {
                queue[to] = queue[from];
                to++;
            }
        }
        queue.length = to;
        node.setValue(queue.length > 0 ? queue : null);
    }
    node.forEachChild(function (childNode) {
        _this.pruneCompletedTransactionsBelowNode_(childNode);
    });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */
Repo.prototype.abortTransactions_ = function (path) {
    var _this = this;
    var affectedPath = this.getAncestorTransactionNode_(path).path();
    var transactionNode = this.transactionQueueTree_.subTree(path);
    transactionNode.forEachAncestor(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    this.abortTransactionsOnNode_(transactionNode);
    transactionNode.forEachDescendant(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
 * @private
 */
Repo.prototype.abortTransactionsOnNode_ = function (node) {
    var queue = node.getValue();
    if (queue !== null) {
        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
        // the callback could trigger more transactions or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
        // can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for (var i = 0; i < queue.length; i++) {
            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
                // Already marked.  No action needed.
            }
            else if (queue[i].status === TransactionStatus.SENT) {
                util.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
                queue[i].abortReason = 'set';
            }
            else {
                util.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
                if (queue[i].onComplete) {
                    var snapshot = null;
                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
                }
            }
        }
        if (lastSent === -1) {
            // We're not waiting for any sent transactions.  We can clear the queue.
            node.setValue(null);
        }
        else {
            // Remove the transactions we aborted.
            queue.length = lastSent + 1;
        }
        // Now fire the callbacks.
        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
        for (var i = 0; i < callbacks.length; i++) {
            exceptionGuard(callbacks[i]);
        }
    }
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** @const {string} */
var DATABASE_URL_OPTION = 'databaseURL';
var _staticInstance;
/**
 * Creates and caches Repo instances.
 */
var RepoManager = /** @class */ (function () {
    function RepoManager() {
        /**
         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
         */
        this.repos_ = {};
        /**
         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
         * @private {boolean}
         */
        this.useRestClient_ = false;
    }
    RepoManager.getInstance = function () {
        if (!_staticInstance) {
            _staticInstance = new RepoManager();
        }
        return _staticInstance;
    };
    // TODO(koss): Remove these functions unless used in tests?
    RepoManager.prototype.interrupt = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].interrupt();
            }
        }
    };
    RepoManager.prototype.resume = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].resume();
            }
        }
    };
    /**
     * This function should only ever be called to CREATE a new database instance.
     *
     * @param {!FirebaseApp} app
     * @return {!Database}
     */
    RepoManager.prototype.databaseFromApp = function (app, url) {
        var dbUrl = url || app.options[DATABASE_URL_OPTION];
        if (dbUrl === undefined) {
            fatal("Can't determine Firebase Database URL.  Be sure to include " +
                DATABASE_URL_OPTION +
                ' option when calling firebase.initializeApp().');
        }
        var parsedUrl = parseRepoInfo(dbUrl);
        var repoInfo = parsedUrl.repoInfo;
        validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
        if (!parsedUrl.path.isEmpty()) {
            fatal('Database URL must point to the root of a Firebase Database ' +
                '(not including a child path).');
        }
        var repo = this.createRepo(repoInfo, app);
        return repo.database;
    };
    /**
     * Remove the repo and make sure it is disconnected.
     *
     * @param {!Repo} repo
     */
    RepoManager.prototype.deleteRepo = function (repo) {
        var appRepos = util.safeGet(this.repos_, repo.app.name);
        // This should never happen...
        if (!appRepos || util.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
            fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
        }
        repo.interrupt();
        delete appRepos[repo.repoInfo_.toURLString()];
    };
    /**
     * Ensures a repo doesn't already exist and then creates one using the
     * provided app.
     *
     * @param {!RepoInfo} repoInfo The metadata about the Repo
     * @param {!FirebaseApp} app
     * @return {!Repo} The Repo object for the specified server / repoName.
     */
    RepoManager.prototype.createRepo = function (repoInfo, app) {
        var appRepos = util.safeGet(this.repos_, app.name);
        if (!appRepos) {
            appRepos = {};
            this.repos_[app.name] = appRepos;
        }
        var repo = util.safeGet(appRepos, repoInfo.toURLString());
        if (repo) {
            fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
        }
        repo = new Repo(repoInfo, this.useRestClient_, app);
        appRepos[repoInfo.toURLString()] = repo;
        return repo;
    };
    /**
     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
     * @param {boolean} forceRestClient
     */
    RepoManager.prototype.forceRestClient = function (forceRestClient) {
        this.useRestClient_ = forceRestClient;
    };
    return RepoManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase database.
 * @implements {FirebaseService}
 */
var Database = /** @class */ (function () {
    /**
     * The constructor should not be called by users of our public API.
     * @param {!Repo} repo_
     */
    function Database(repo_) {
        this.repo_ = repo_;
        if (!(repo_ instanceof Repo)) {
            fatal("Don't call new Database() directly - please use firebase.database().");
        }
        /** @type {Reference} */
        this.root_ = new Reference(repo_, Path.Empty);
        this.INTERNAL = new DatabaseInternals(this);
    }
    Object.defineProperty(Database.prototype, "app", {
        get: function () {
            return this.repo_.app;
        },
        enumerable: true,
        configurable: true
    });
    Database.prototype.ref = function (path) {
        this.checkDeleted_('ref');
        util.validateArgCount('database.ref', 0, 1, arguments.length);
        if (path instanceof Reference) {
            return this.refFromURL(path.toString());
        }
        return path !== undefined ? this.root_.child(path) : this.root_;
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @param {string} url
     * @return {!Reference} Firebase reference.
     */
    Database.prototype.refFromURL = function (url) {
        /** @const {string} */
        var apiName = 'database.refFromURL';
        this.checkDeleted_(apiName);
        util.validateArgCount(apiName, 1, 1, arguments.length);
        var parsedURL = parseRepoInfo(url);
        validateUrl(apiName, 1, parsedURL);
        var repoInfo = parsedURL.repoInfo;
        if (repoInfo.host !== this.repo_.repoInfo_.host) {
            fatal(apiName +
                ': Host name does not match the current database: ' +
                '(found ' +
                repoInfo.host +
                ' but expected ' +
                this.repo_.repoInfo_.host +
                ')');
        }
        return this.ref(parsedURL.path.toString());
    };
    /**
     * @param {string} apiName
     */
    Database.prototype.checkDeleted_ = function (apiName) {
        if (this.repo_ === null) {
            fatal('Cannot call ' + apiName + ' on a deleted database.');
        }
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function () {
        util.validateArgCount('database.goOffline', 0, 0, arguments.length);
        this.checkDeleted_('goOffline');
        this.repo_.interrupt();
    };
    Database.prototype.goOnline = function () {
        util.validateArgCount('database.goOnline', 0, 0, arguments.length);
        this.checkDeleted_('goOnline');
        this.repo_.resume();
    };
    Database.ServerValue = {
        TIMESTAMP: {
            '.sv': 'timestamp'
        }
    };
    return Database;
}());
var DatabaseInternals = /** @class */ (function () {
    /** @param {!Database} database */
    function DatabaseInternals(database) {
        this.database = database;
    }
    /** @return {Promise<void>} */
    DatabaseInternals.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.database.checkDeleted_('delete');
                RepoManager.getInstance().deleteRepo(this.database.repo_);
                this.database.repo_ = null;
                this.database.root_ = null;
                this.database.INTERNAL = null;
                this.database = null;
                return [2 /*return*/];
            });
        });
    };
    return DatabaseInternals;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */
var forceLongPolling = function () {
    WebSocketConnection.forceDisallow();
    BrowserPollConnection.forceAllow();
};
var forceWebSockets = function () {
    BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */
var isWebSocketsAvailable = function () {
    return WebSocketConnection['isAvailable']();
};
var setSecurityDebugCallback = function (ref, callback) {
    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
var stats = function (ref, showDelta) {
    ref.repo.stats(showDelta);
};
var statsIncrementCounter = function (ref, metric) {
    ref.repo.statsIncrementCounter(metric);
};
var dataUpdateCount = function (ref) {
    return ref.repo.dataUpdateCount;
};
var interceptServerData = function (ref, callback) {
    return ref.repo.interceptServerData_(callback);
};

var INTERNAL = /*#__PURE__*/Object.freeze({
  forceLongPolling: forceLongPolling,
  forceWebSockets: forceWebSockets,
  isWebSocketsAvailable: isWebSocketsAvailable,
  setSecurityDebugCallback: setSecurityDebugCallback,
  stats: stats,
  statsIncrementCounter: statsIncrementCounter,
  dataUpdateCount: dataUpdateCount,
  interceptServerData: interceptServerData
});

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataConnection = PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */
PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
    this.sendRequest('q', { p: pathString }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */
PersistentConnection.prototype.echo = function (data, onEcho) {
    this.sendRequest('echo', { d: data }, onEcho);
};
// RealTimeConnection properties that we use in tests.
var RealTimeConnection = Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */
var hijackHash = function (newHash) {
    var oldPut = PersistentConnection.prototype.put;
    PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
        if (opt_hash !== undefined) {
            opt_hash = newHash();
        }
        oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
    };
    return function () {
        PersistentConnection.prototype.put = oldPut;
    };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */
var ConnectionTarget = RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */
var queryIdentifier = function (query) {
    return query.queryIdentifier();
};
/**
 * @param {!Query} firebaseRef
 * @return {!Object}
 */
var listens = function (firebaseRef) {
    return firebaseRef.repo.persistentConnection_.listens_;
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */
var forceRestClient = function (forceRestClient) {
    RepoManager.getInstance().forceRestClient(forceRestClient);
};

var TEST_ACCESS = /*#__PURE__*/Object.freeze({
  DataConnection: DataConnection,
  RealTimeConnection: RealTimeConnection,
  hijackHash: hijackHash,
  ConnectionTarget: ConnectionTarget,
  queryIdentifier: queryIdentifier,
  listens: listens,
  forceRestClient: forceRestClient
});

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ServerValue = Database.ServerValue;
function registerDatabase(instance) {
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) { return RepoManager.getInstance().databaseFromApp(app, url); }, 
    // firebase.database namespace properties
    {
        Reference: Reference,
        Query: Query,
        Database: Database,
        enableLogging: enableLogging,
        INTERNAL: INTERNAL,
        ServerValue: ServerValue,
        TEST_ACCESS: TEST_ACCESS
    }, null, true);
    if (util.isNodeSdk()) {
        module.exports = namespace;
    }
}
registerDatabase(firebase);

exports.registerDatabase = registerDatabase;
exports.Database = Database;
exports.Query = Query;
exports.Reference = Reference;
exports.enableLogging = enableLogging;
exports.ServerValue = ServerValue;
exports.DataSnapshot = DataSnapshot;
exports.OnDisconnect = OnDisconnect;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(16));
var logger = __webpack_require__(67);
var tslib_1 = __webpack_require__(28);
var webchannelWrapper = __webpack_require__(280);
var util = __webpack_require__(37);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** The semver (www.semver.org) version of the SDK. */
var SDK_VERSION = firebase.SDK_VERSION;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new logger.Logger('@firebase/firestore');
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 2] = "SILENT";
})(LogLevel || (LogLevel = {}));
// Helper methods are needed because variables can't be exported as read/write
function getLogLevel() {
    if (logClient.logLevel === logger.LogLevel.DEBUG) {
        return LogLevel.DEBUG;
    }
    else if (logClient.logLevel === logger.LogLevel.SILENT) {
        return LogLevel.SILENT;
    }
    else {
        return LogLevel.ERROR;
    }
}
function setLogLevel(newLevel) {
    /**
     * Map the new log level to the associated Firebase Log Level
     */
    switch (newLevel) {
        case LogLevel.DEBUG:
            logClient.logLevel = logger.LogLevel.DEBUG;
            break;
        case LogLevel.ERROR:
            logClient.logLevel = logger.LogLevel.ERROR;
            break;
        case LogLevel.SILENT:
            logClient.logLevel = logger.LogLevel.SILENT;
            break;
        default:
            logClient.error("Firestore (" + SDK_VERSION + "): Invalid value passed to `setLogLevel`");
    }
}
function debug(tag, msg) {
    var obj = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        obj[_i - 2] = arguments[_i];
    }
    if (logClient.logLevel <= logger.LogLevel.DEBUG) {
        var args = obj.map(argToString);
        logClient.debug.apply(logClient, ["Firestore (" + SDK_VERSION + ") [" + tag + "]: " + msg].concat(args));
    }
}
function error(msg) {
    var obj = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        obj[_i - 1] = arguments[_i];
    }
    if (logClient.logLevel <= logger.LogLevel.ERROR) {
        var args = obj.map(argToString);
        logClient.error.apply(logClient, ["Firestore (" + SDK_VERSION + "): " + msg].concat(args));
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */
function argToString(obj) {
    if (typeof obj === 'string') {
        return obj;
    }
    else {
        var platform = PlatformSupport.getPlatform();
        try {
            return platform.formatJSON(obj);
        }
        catch (e) {
            // Converting to JSON failed, just log the object directly
            return obj;
        }
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Unconditionally fails, throwing an Error with the given message.
 *
 * Returns any so it can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */
function fail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var message = "FIRESTORE (" + SDK_VERSION + ") INTERNAL ASSERTION FAILED: " + failure;
    error(message);
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 */
function assert(assertion, message) {
    if (!assertion) {
        fail(message);
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides singleton helpers where setup code can inject a platform at runtime.
 * setPlatform needs to be set before Firestore is used and must be set exactly
 * once.
 */
var PlatformSupport = /** @class */ (function () {
    function PlatformSupport() {
    }
    PlatformSupport.setPlatform = function (platform) {
        if (PlatformSupport.platform) {
            fail('Platform already defined');
        }
        PlatformSupport.platform = platform;
    };
    PlatformSupport.getPlatform = function () {
        if (!PlatformSupport.platform) {
            fail('Platform not set');
        }
        return PlatformSupport.platform;
    };
    return PlatformSupport;
}());
/**
 * Returns the representation of an empty "proto" byte string for the
 * platform.
 */
function emptyByteString() {
    return PlatformSupport.getPlatform().emptyByteString;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO(mcg): Change to a string enum once we've upgraded to typescript 2.4.
//  tslint:disable-next-line:variable-name Intended to look like a TS 2.4 enum
var Code = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */
    OK: 'ok',
    /** The operation was cancelled (typically by the caller). */
    CANCELLED: 'cancelled',
    /** Unknown error or an error from a different error domain. */
    UNKNOWN: 'unknown',
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */
    INVALID_ARGUMENT: 'invalid-argument',
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    /** Some requested entity (e.g., file or directory) was not found. */
    NOT_FOUND: 'not-found',
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */
    ALREADY_EXISTS: 'already-exists',
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */
    PERMISSION_DENIED: 'permission-denied',
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */
    UNAUTHENTICATED: 'unauthenticated',
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */
    FAILED_PRECONDITION: 'failed-precondition',
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */
    ABORTED: 'aborted',
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */
    OUT_OF_RANGE: 'out-of-range',
    /** Operation is not implemented or not supported/enabled in this service. */
    UNIMPLEMENTED: 'unimplemented',
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */
    INTERNAL: 'internal',
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */
    UNAVAILABLE: 'unavailable',
    /** Unrecoverable data loss or corruption. */
    DATA_LOSS: 'data-loss'
};
/**
 * An error class used for Firestore-generated errors. Ideally we should be
 * using FirebaseError, but integrating with it is overly arduous at the moment,
 * so we define our own compatible error class (with a `name` of 'FirebaseError'
 * and compatible `code` and `message` fields.)
 */
var FirestoreError = /** @class */ (function (_super) {
    tslib_1.__extends(FirestoreError, _super);
    function FirestoreError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.message = message;
        _this.name = 'FirebaseError';
        // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        _this.toString = function () { return _this.name + ": [code=" + _this.code + "]: " + _this.message; };
        return _this;
    }
    return FirestoreError;
}(Error));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper function to prevent instantiation through the constructor.
 *
 * This method creates a new constructor that throws when it's invoked.
 * The prototype of that constructor is then set to the prototype of the hidden
 * "class" to expose all the prototype methods and allow for instanceof
 * checks.
 *
 * To also make all the static methods available, all properties of the
 * original constructor are copied to the new constructor.
 */
function makeConstructorPrivate(cls, optionalMessage) {
    function PublicConstructor() {
        var error = 'This constructor is private.';
        if (optionalMessage) {
            error += ' ';
            error += optionalMessage;
        }
        throw new FirestoreError(Code.INVALID_ARGUMENT, error);
    }
    // Make sure instanceof checks work and all methods are exposed on the public
    // constructor
    PublicConstructor.prototype = cls.prototype;
    // Copy any static methods/members
    for (var staticProperty in cls) {
        if (cls.hasOwnProperty(staticProperty)) {
            PublicConstructor[staticProperty] = cls[staticProperty];
        }
    }
    return PublicConstructor;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
/** Returns the given value if it's defined or the defaultValue otherwise. */
function defaulted(value, defaultValue) {
    return value !== undefined ? value : defaultValue;
}
function forEachNumber(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var num = Number(key);
            if (!isNaN(num)) {
                fn(num, obj[key]);
            }
        }
    }
}
function values(obj) {
    var vs = [];
    forEach(obj, function (_, v) { return vs.push(v); });
    return vs;
}
function forEach(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
}
function isEmpty(obj) {
    assert(obj != null && typeof obj === 'object', 'isEmpty() expects object parameter.');
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function shallowCopy(obj) {
    assert(obj && typeof obj === 'object', 'shallowCopy() expects object parameter.');
    var result = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            result[key] = obj[key];
        }
    }
    return result;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Validates the invocation of functionName has the exact number of arguments.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateExactNumberOfArgs('myFunction', arguments, 2);
 */
function validateExactNumberOfArgs(functionName, args, numberOfArgs) {
    if (args.length !== numberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires " +
            formatPlural(numberOfArgs, 'argument') +
            ', but was called with ' +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the invocation of functionName has at least the provided number of
 * arguments (but can have many more).
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
 */
function validateAtLeastNumberOfArgs(functionName, args, minNumberOfArgs) {
    if (args.length < minNumberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires at least " +
            formatPlural(minNumberOfArgs, 'argument') +
            ', but was called with ' +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the invocation of functionName has number of arguments between
 * the values provided.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
 */
function validateBetweenNumberOfArgs(functionName, args, minNumberOfArgs, maxNumberOfArgs) {
    if (args.length < minNumberOfArgs || args.length > maxNumberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires between " + minNumberOfArgs + " and " +
            (maxNumberOfArgs + " arguments, but was called with ") +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the provided argument is an array and has as least the expected
 * number of elements.
 */
function validateNamedArrayAtLeastNumberOfElements(functionName, value, name, minNumberOfElements) {
    if (!(value instanceof Array) || value.length < minNumberOfElements) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + name + " argument to be an " +
            'array with at least ' +
            (formatPlural(minNumberOfElements, 'element') + "."));
    }
}
/**
 * Validates the provided positional argument has the native JavaScript type
 * using typeof checks.
 */
function validateArgType(functionName, type, position, argument) {
    validateType(functionName, type, ordinal(position) + " argument", argument);
}
/**
 * Validates the provided argument has the native JavaScript type using
 * typeof checks or is undefined.
 */
function validateOptionalArgType(functionName, type, position, argument) {
    if (argument !== undefined) {
        validateArgType(functionName, type, position, argument);
    }
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks.
 */
function validateNamedType(functionName, type, optionName, argument) {
    validateType(functionName, type, optionName + " option", argument);
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks or is undefined.
 */
function validateNamedOptionalType(functionName, type, optionName, argument) {
    if (argument !== undefined) {
        validateNamedType(functionName, type, optionName, argument);
    }
}
function validateArrayElements(functionName, optionName, typeDescription, argument, validator) {
    if (!(argument instanceof Array)) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + optionName + " " +
            ("option to be an array, but it was: " + valueDescription(argument)));
    }
    for (var i = 0; i < argument.length; ++i) {
        if (!validator(argument[i])) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires all " + optionName + " " +
                ("elements to be " + typeDescription + ", but the value at index " + i + " ") +
                ("was: " + valueDescription(argument[i])));
        }
    }
}
function validateOptionalArrayElements(functionName, optionName, typeDescription, argument, validator) {
    if (argument !== undefined) {
        validateArrayElements(functionName, optionName, typeDescription, argument, validator);
    }
}
/**
 * Validates that the provided named option equals one of the expected values.
 */
function validateNamedPropertyEquals(functionName, inputName, optionName, input, expected) {
    var expectedDescription = [];
    for (var _i = 0, expected_1 = expected; _i < expected_1.length; _i++) {
        var val = expected_1[_i];
        if (val === input) {
            return;
        }
        expectedDescription.push(valueDescription(val));
    }
    var actualDescription = valueDescription(input);
    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid value " + actualDescription + " provided to function " + functionName + "() for option " +
        ("\"" + optionName + "\". Acceptable values: " + expectedDescription.join(', ')));
}
/**
 * Validates that the provided named option equals one of the expected values or
 * is undefined.
 */
function validateNamedOptionalPropertyEquals(functionName, inputName, optionName, input, expected) {
    if (input !== undefined) {
        validateNamedPropertyEquals(functionName, inputName, optionName, input, expected);
    }
}
/** Helper to validate the type of a provided input. */
function validateType(functionName, type, inputName, input) {
    var valid = false;
    if (type === 'object') {
        valid = isPlainObject(input);
    }
    else if (type === 'non-empty string') {
        valid = typeof input === 'string' && input !== '';
    }
    else {
        valid = typeof input === type;
    }
    if (!valid) {
        var description = valueDescription(input);
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + inputName + " " +
            ("to be of type " + type + ", but it was: " + description));
    }
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */
function isPlainObject(input) {
    return (typeof input === 'object' &&
        input !== null &&
        (Object.getPrototypeOf(input) === Object.prototype ||
            Object.getPrototypeOf(input) === null));
}
/** Returns a string describing the type / value of the provided input. */
function valueDescription(input) {
    if (input === undefined) {
        return 'undefined';
    }
    else if (input === null) {
        return 'null';
    }
    else if (typeof input === 'string') {
        if (input.length > 20) {
            input = input.substring(0, 20) + "...";
        }
        return JSON.stringify(input);
    }
    else if (typeof input === 'number' || typeof input === 'boolean') {
        return '' + input;
    }
    else if (typeof input === 'object') {
        if (input instanceof Array) {
            return 'an array';
        }
        else {
            var customObjectName = tryGetCustomObjectType(input);
            if (customObjectName) {
                return "a custom " + customObjectName + " object";
            }
            else {
                return 'an object';
            }
        }
    }
    else if (typeof input === 'function') {
        return 'a function';
    }
    else {
        return fail('Unknown wrong type: ' + typeof input);
    }
}
/** Hacky method to try to get the constructor name for an object. */
function tryGetCustomObjectType(input) {
    if (input.constructor) {
        var funcNameRegex = /function\s+([^\s(]+)\s*\(/;
        var results = funcNameRegex.exec(input.constructor.toString());
        if (results && results.length > 1) {
            return results[1];
        }
    }
    return null;
}
/** Validates the provided argument is defined. */
function validateDefined(functionName, position, argument) {
    if (argument === undefined) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires a valid " + ordinal(position) + " " +
            "argument, but it was undefined.");
    }
}
/**
 * Validates the provided positional argument is an object, and its keys and
 * values match the expected keys and types provided in optionTypes.
 */
function validateOptionNames(functionName, options, optionNames) {
    forEach(options, function (key, _) {
        if (optionNames.indexOf(key) < 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Unknown option '" + key + "' passed to function " + functionName + "(). " +
                'Available options: ' +
                optionNames.join(', '));
        }
    });
}
/**
 * Helper method to throw an error that the provided argument did not pass
 * an instanceof check.
 */
function invalidClassError(functionName, type, position, argument) {
    var description = valueDescription(argument);
    return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + ordinal(position) + " " +
        ("argument to be a " + type + ", but it was: " + description));
}
/** Converts a number to its english word representation */
function ordinal(num) {
    switch (num) {
        case 1:
            return 'first';
        case 2:
            return 'second';
        case 3:
            return 'third';
        default:
            return num + 'th';
    }
}
/**
 * Formats the given word as plural conditionally given the preceding number.
 */
function formatPlural(num, str) {
    return num + " " + str + (num === 1 ? '' : 's');
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// tslint:disable-next-line:class-as-namespace
var AutoId = /** @class */ (function () {
    function AutoId() {
    }
    AutoId.newId = function () {
        // Alphanumeric characters
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var autoId = '';
        for (var i = 0; i < 20; i++) {
            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        assert(autoId.length === 20, 'Invalid auto ID: ' + autoId);
        return autoId;
    };
    return AutoId;
}());
function primitiveComparator(left, right) {
    if (left < right)
        return -1;
    if (left > right)
        return 1;
    return 0;
}
/** Helper to compare nullable (or undefined-able) objects using isEqual(). */
function equals(left, right) {
    if (left !== null && left !== undefined) {
        return !!(right && left.isEqual(right));
    }
    else {
        // HACK: Explicitly cast since TypeScript's type narrowing apparently isn't
        // smart enough.
        return left === right;
    }
}
/** Helper to compare arrays using isEqual(). */
function arrayEquals(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    for (var i = 0; i < left.length; i++) {
        if (!left[i].isEqual(right[i])) {
            return false;
        }
    }
    return true;
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */
function immediateSuccessor(s) {
    // Return the input string, with an additional NUL byte appended.
    return s + '\0';
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Helper function to assert Uint8Array is available at runtime. */
function assertUint8ArrayAvailable() {
    if (typeof Uint8Array === 'undefined') {
        throw new FirestoreError(Code.UNIMPLEMENTED, 'Uint8Arrays are not available in this environment.');
    }
}
/** Helper function to assert Base64 functions are available at runtime. */
function assertBase64Available() {
    if (!PlatformSupport.getPlatform().base64Available) {
        throw new FirestoreError(Code.UNIMPLEMENTED, 'Blobs are unavailable in Firestore in this environment.');
    }
}
/**
 * Immutable class holding a blob (binary data).
 * This class is directly exposed in the public API.
 *
 * Note that while you can't hide the constructor in JavaScript code, we are
 * using the hack above to make sure no-one outside this module can call it.
 */
var Blob = /** @class */ (function () {
    function Blob(binaryString) {
        assertBase64Available();
        this._binaryString = binaryString;
    }
    Blob.fromBase64String = function (base64) {
        validateExactNumberOfArgs('Blob.fromBase64String', arguments, 1);
        validateArgType('Blob.fromBase64String', 'string', 1, base64);
        assertBase64Available();
        try {
            var binaryString = PlatformSupport.getPlatform().atob(base64);
            return new Blob(binaryString);
        }
        catch (e) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Failed to construct Blob from Base64 string: ' + e);
        }
    };
    Blob.fromUint8Array = function (array) {
        validateExactNumberOfArgs('Blob.fromUint8Array', arguments, 1);
        assertUint8ArrayAvailable();
        if (!(array instanceof Uint8Array)) {
            throw invalidClassError('Blob.fromUint8Array', 'Uint8Array', 1, array);
        }
        // We can't call array.map directly because it expects the return type to
        // be a Uint8Array, whereas we can convert it to a regular array by invoking
        // map on the Array prototype.
        var binaryString = Array.prototype.map
            .call(array, function (char) {
            return String.fromCharCode(char);
        })
            .join('');
        return new Blob(binaryString);
    };
    Blob.prototype.toBase64 = function () {
        validateExactNumberOfArgs('Blob.toBase64', arguments, 0);
        assertBase64Available();
        return PlatformSupport.getPlatform().btoa(this._binaryString);
    };
    Blob.prototype.toUint8Array = function () {
        validateExactNumberOfArgs('Blob.toUint8Array', arguments, 0);
        assertUint8ArrayAvailable();
        var buffer = new Uint8Array(this._binaryString.length);
        for (var i = 0; i < this._binaryString.length; i++) {
            buffer[i] = this._binaryString.charCodeAt(i);
        }
        return buffer;
    };
    Blob.prototype.toString = function () {
        return 'Blob(base64: ' + this.toBase64() + ')';
    };
    Blob.prototype.isEqual = function (other) {
        return this._binaryString === other._binaryString;
    };
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    Blob.prototype._compareTo = function (other) {
        return primitiveComparator(this._binaryString, other._binaryString);
    };
    return Blob;
}());
// Public instance that disallows construction at runtime. This constructor is
// used when exporting Blob on firebase.firestore.Blob and will be called Blob
// publicly. Internally we still use Blob which has a type checked private
// constructor. Note that Blob and PublicBlob can be used interchangeably in
// instanceof checks.
// For our internal TypeScript code PublicBlob doesn't exist as a type, and so
// we need to use Blob as type and export it too.
// tslint:disable-next-line:variable-name We're treating this as a class name.
var PublicBlob = makeConstructorPrivate(Blob, 'Use Blob.fromUint8Array() or Blob.fromBase64String() instead.');

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Immutable class representing a geo point as latitude-longitude pair.
 * This class is directly exposed in the public API, including its constructor.
 */
var GeoPoint = /** @class */ (function () {
    function GeoPoint(latitude, longitude) {
        validateExactNumberOfArgs('GeoPoint', arguments, 2);
        validateArgType('GeoPoint', 'number', 1, latitude);
        validateArgType('GeoPoint', 'number', 2, longitude);
        if (!isFinite(latitude) || latitude < -90 || latitude > 90) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Latitude must be a number between -90 and 90, but was: ' + latitude);
        }
        if (!isFinite(longitude) || longitude < -180 || longitude > 180) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Longitude must be a number between -180 and 180, but was: ' + longitude);
        }
        this._lat = latitude;
        this._long = longitude;
    }
    Object.defineProperty(GeoPoint.prototype, "latitude", {
        /**
         * Returns the latitude of this geo point, a number between -90 and 90.
         */
        get: function () {
            return this._lat;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeoPoint.prototype, "longitude", {
        /**
         * Returns the longitude of this geo point, a number between -180 and 180.
         */
        get: function () {
            return this._long;
        },
        enumerable: true,
        configurable: true
    });
    GeoPoint.prototype.isEqual = function (other) {
        return this._lat === other._lat && this._long === other._long;
    };
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    GeoPoint.prototype._compareTo = function (other) {
        return (primitiveComparator(this._lat, other._lat) ||
            primitiveComparator(this._long, other._long));
    };
    return GeoPoint;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Timestamp = /** @class */ (function () {
    function Timestamp(seconds, nanoseconds) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
        if (nanoseconds < 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
        }
        if (nanoseconds >= 1e9) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
        }
        // Midnight at the beginning of 1/1/1 is the earliest Firestore supports.
        if (seconds < -62135596800) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
        }
        // This will break in the year 10,000.
        if (seconds >= 253402300800) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
        }
    }
    Timestamp.now = function () {
        return Timestamp.fromMillis(Date.now());
    };
    Timestamp.fromDate = function (date) {
        return Timestamp.fromMillis(date.getTime());
    };
    Timestamp.fromMillis = function (milliseconds) {
        var seconds = Math.floor(milliseconds / 1000);
        var nanos = (milliseconds - seconds * 1000) * 1e6;
        return new Timestamp(seconds, nanos);
    };
    Timestamp.prototype.toDate = function () {
        return new Date(this.toMillis());
    };
    Timestamp.prototype.toMillis = function () {
        return this.seconds * 1000 + this.nanoseconds / 1e6;
    };
    Timestamp.prototype._compareTo = function (other) {
        if (this.seconds === other.seconds) {
            return primitiveComparator(this.nanoseconds, other.nanoseconds);
        }
        return primitiveComparator(this.seconds, other.seconds);
    };
    Timestamp.prototype.isEqual = function (other) {
        return (other.seconds === this.seconds && other.nanoseconds === this.nanoseconds);
    };
    Timestamp.prototype.toString = function () {
        return ('Timestamp(seconds=' +
            this.seconds +
            ', nanoseconds=' +
            this.nanoseconds +
            ')');
    };
    return Timestamp;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DatabaseInfo = /** @class */ (function () {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId The database to use.
     * @param persistenceKey A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host The Firestore backend host to connect to.
     * @param ssl Whether to use SSL when connecting.
     */
    function DatabaseInfo(databaseId, persistenceKey, host, ssl) {
        this.databaseId = databaseId;
        this.persistenceKey = persistenceKey;
        this.host = host;
        this.ssl = ssl;
    }
    return DatabaseInfo;
}());
/** The default database name for a project. */
var DEFAULT_DATABASE_NAME = '(default)';
/** Represents the database ID a Firestore client is associated with. */
var DatabaseId = /** @class */ (function () {
    function DatabaseId(projectId, database) {
        this.projectId = projectId;
        this.database = database ? database : DEFAULT_DATABASE_NAME;
    }
    Object.defineProperty(DatabaseId.prototype, "isDefaultDatabase", {
        get: function () {
            return this.database === DEFAULT_DATABASE_NAME;
        },
        enumerable: true,
        configurable: true
    });
    DatabaseId.prototype.isEqual = function (other) {
        return (other instanceof DatabaseId &&
            other.projectId === this.projectId &&
            other.database === this.database);
    };
    DatabaseId.prototype.compareTo = function (other) {
        return (primitiveComparator(this.projectId, other.projectId) ||
            primitiveComparator(this.database, other.database));
    };
    return DatabaseId;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DOCUMENT_KEY_NAME = '__name__';
/**
 * Path represents an ordered sequence of string segments.
 */
var Path = /** @class */ (function () {
    function Path(segments, offset, length) {
        this.init(segments, offset, length);
    }
    /**
     * An initialization method that can be called from outside the constructor.
     * We need this so that we can have a non-static construct method that returns
     * the polymorphic `this` type.
     */
    Path.prototype.init = function (segments, offset, length) {
        if (offset === undefined) {
            offset = 0;
        }
        else if (offset > segments.length) {
            fail('offset ' + offset + ' out of range ' + segments.length);
        }
        if (length === undefined) {
            length = segments.length - offset;
        }
        else if (length > segments.length - offset) {
            fail('length ' + length + ' out of range ' + (segments.length - offset));
        }
        this.segments = segments;
        this.offset = offset;
        this.len = length;
    };
    /**
     * Constructs a new instance of Path using the same concrete type as `this`.
     * We need this instead of using the normal constructor, because polymorphic
     * `this` doesn't work on static methods.
     */
    Path.prototype.construct = function (segments, offset, length) {
        var path = Object.create(Object.getPrototypeOf(this));
        path.init(segments, offset, length);
        return path;
    };
    Object.defineProperty(Path.prototype, "length", {
        get: function () {
            return this.len;
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.isEqual = function (other) {
        return Path.comparator(this, other) === 0;
    };
    Path.prototype.child = function (nameOrPath) {
        var segments = this.segments.slice(this.offset, this.limit());
        if (nameOrPath instanceof Path) {
            nameOrPath.forEach(function (segment) {
                segments.push(segment);
            });
        }
        else if (typeof nameOrPath === 'string') {
            segments.push(nameOrPath);
        }
        else {
            fail('Unknown parameter type for Path.child(): ' + nameOrPath);
        }
        return this.construct(segments);
    };
    /** The index of one past the last segment of the path. */
    Path.prototype.limit = function () {
        return this.offset + this.length;
    };
    Path.prototype.popFirst = function (size) {
        size = size === undefined ? 1 : size;
        assert(this.length >= size, "Can't call popFirst() with less segments");
        return this.construct(this.segments, this.offset + size, this.length - size);
    };
    Path.prototype.popLast = function () {
        assert(!this.isEmpty(), "Can't call popLast() on empty path");
        return this.construct(this.segments, this.offset, this.length - 1);
    };
    Path.prototype.firstSegment = function () {
        assert(!this.isEmpty(), "Can't call firstSegment() on empty path");
        return this.segments[this.offset];
    };
    Path.prototype.lastSegment = function () {
        assert(!this.isEmpty(), "Can't call lastSegment() on empty path");
        return this.segments[this.limit() - 1];
    };
    Path.prototype.get = function (index) {
        assert(index < this.length, 'Index out of range');
        return this.segments[this.offset + index];
    };
    Path.prototype.isEmpty = function () {
        return this.length === 0;
    };
    Path.prototype.isPrefixOf = function (other) {
        if (other.length < this.length) {
            return false;
        }
        for (var i = 0; i < this.length; i++) {
            if (this.get(i) !== other.get(i)) {
                return false;
            }
        }
        return true;
    };
    Path.prototype.isImmediateParentOf = function (potentialChild) {
        if (this.length + 1 !== potentialChild.length) {
            return false;
        }
        for (var i = 0; i < this.length; i++) {
            if (this.get(i) !== potentialChild.get(i)) {
                return false;
            }
        }
        return true;
    };
    Path.prototype.forEach = function (fn) {
        for (var i = this.offset, end = this.limit(); i < end; i++) {
            fn(this.segments[i]);
        }
    };
    Path.prototype.toArray = function () {
        return this.segments.slice(this.offset, this.limit());
    };
    Path.comparator = function (p1, p2) {
        var len = Math.min(p1.length, p2.length);
        for (var i = 0; i < len; i++) {
            var left = p1.get(i);
            var right = p2.get(i);
            if (left < right)
                return -1;
            if (left > right)
                return 1;
        }
        if (p1.length < p2.length)
            return -1;
        if (p1.length > p2.length)
            return 1;
        return 0;
    };
    return Path;
}());
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 */
var ResourcePath = /** @class */ (function (_super) {
    tslib_1.__extends(ResourcePath, _super);
    function ResourcePath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourcePath.prototype.canonicalString = function () {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join('/');
    };
    ResourcePath.prototype.toString = function () {
        return this.canonicalString();
    };
    /**
     * Creates a resource path from the given slash-delimited string.
     */
    ResourcePath.fromString = function (path) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        if (path.indexOf('//') >= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid path (" + path + "). Paths must not contain // in them.");
        }
        // We may still have an empty segment at the beginning or end if they had a
        // leading or trailing slash (which we allow).
        var segments = path.split('/').filter(function (segment) { return segment.length > 0; });
        return new ResourcePath(segments);
    };
    ResourcePath.EMPTY_PATH = new ResourcePath([]);
    return ResourcePath;
}(Path));
var identifierRegExp = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/** A dot-separated path for navigating sub-objects within a document. */
var FieldPath = /** @class */ (function (_super) {
    tslib_1.__extends(FieldPath, _super);
    function FieldPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */
    FieldPath.isValidIdentifier = function (segment) {
        return identifierRegExp.test(segment);
    };
    FieldPath.prototype.canonicalString = function () {
        return this.toArray()
            .map(function (str) {
            str = str.replace('\\', '\\\\').replace('`', '\\`');
            if (!FieldPath.isValidIdentifier(str)) {
                str = '`' + str + '`';
            }
            return str;
        })
            .join('.');
    };
    FieldPath.prototype.toString = function () {
        return this.canonicalString();
    };
    /**
     * Returns true if this field references the key of a document.
     */
    FieldPath.prototype.isKeyField = function () {
        return this.length === 1 && this.get(0) === DOCUMENT_KEY_NAME;
    };
    /**
     * The field designating the key of a document.
     */
    FieldPath.keyField = function () {
        return new FieldPath([DOCUMENT_KEY_NAME]);
    };
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */
    FieldPath.fromServerFormat = function (path) {
        var segments = [];
        var current = '';
        var i = 0;
        var addCurrentSegment = function () {
            if (current.length === 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, begin " +
                    "with '.', end with '.', or contain '..'");
            }
            segments.push(current);
            current = '';
        };
        var inBackticks = false;
        while (i < path.length) {
            var c = path[i];
            if (c === '\\') {
                if (i + 1 === path.length) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has trailing escape character: ' + path);
                }
                var next = path[i + 1];
                if (!(next === '\\' || next === '.' || next === '`')) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has invalid escape sequence: ' + path);
                }
                current += next;
                i += 2;
            }
            else if (c === '`') {
                inBackticks = !inBackticks;
                i++;
            }
            else if (c === '.' && !inBackticks) {
                addCurrentSegment();
                i++;
            }
            else {
                current += c;
                i++;
            }
        }
        addCurrentSegment();
        if (inBackticks) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Unterminated ` in path: ' + path);
        }
        return new FieldPath(segments);
    };
    FieldPath.EMPTY_PATH = new FieldPath([]);
    return FieldPath;
}(Path));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DocumentKey = /** @class */ (function () {
    function DocumentKey(path) {
        this.path = path;
        assert(DocumentKey.isDocumentKey(path), 'Invalid DocumentKey with an odd number of segments: ' +
            path.toArray().join('/'));
    }
    DocumentKey.prototype.isEqual = function (other) {
        return (other !== null && ResourcePath.comparator(this.path, other.path) === 0);
    };
    DocumentKey.prototype.toString = function () {
        return this.path.toString();
    };
    DocumentKey.comparator = function (k1, k2) {
        return ResourcePath.comparator(k1.path, k2.path);
    };
    DocumentKey.isDocumentKey = function (path) {
        return path.length % 2 === 0;
    };
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param path The segments of the path to the document
     * @return A new instance of DocumentKey
     */
    DocumentKey.fromSegments = function (segments) {
        return new DocumentKey(new ResourcePath(segments.slice()));
    };
    /**
     * Creates and returns a new document key using '/' to split the string into
     * segments.
     *
     * @param path The slash-separated path string to the document
     * @return A new instance of DocumentKey
     */
    DocumentKey.fromPathString = function (path) {
        return new DocumentKey(ResourcePath.fromString(path));
    };
    DocumentKey.EMPTY = new DocumentKey(new ResourcePath([]));
    return DocumentKey;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The result of a lookup for a given path may be an existing document or a
 * marker that this document does not exist at a given version.
 */
var MaybeDocument = /** @class */ (function () {
    function MaybeDocument(key, version) {
        this.key = key;
        this.version = version;
    }
    MaybeDocument.compareByKey = function (d1, d2) {
        return DocumentKey.comparator(d1.key, d2.key);
    };
    return MaybeDocument;
}());
/**
 * Represents a document in Firestore with a key, version, data and whether the
 * data has local mutations applied to it.
 */
var Document = /** @class */ (function (_super) {
    tslib_1.__extends(Document, _super);
    function Document(key, version, data, options, 
    /**
     * Memoized serialized form of the document for optimization purposes (avoids repeated
     * serialization). Might be undefined.
     */
    proto) {
        var _this = _super.call(this, key, version) || this;
        _this.data = data;
        _this.proto = proto;
        _this.hasLocalMutations = !!options.hasLocalMutations;
        _this.hasCommittedMutations = !!options.hasCommittedMutations;
        return _this;
    }
    Document.prototype.field = function (path) {
        return this.data.field(path);
    };
    Document.prototype.fieldValue = function (path) {
        var field = this.field(path);
        return field ? field.value() : undefined;
    };
    Document.prototype.value = function () {
        return this.data.value();
    };
    Document.prototype.isEqual = function (other) {
        return (other instanceof Document &&
            this.key.isEqual(other.key) &&
            this.version.isEqual(other.version) &&
            this.data.isEqual(other.data) &&
            this.hasLocalMutations === other.hasLocalMutations &&
            this.hasCommittedMutations === other.hasCommittedMutations);
    };
    Document.prototype.toString = function () {
        return ("Document(" + this.key + ", " + this.version + ", " + this.data.toString() + ", " +
            ("{hasLocalMutations: " + this.hasLocalMutations + "}), ") +
            ("{hasCommittedMutations: " + this.hasCommittedMutations + "})"));
    };
    Object.defineProperty(Document.prototype, "hasPendingWrites", {
        get: function () {
            return this.hasLocalMutations || this.hasCommittedMutations;
        },
        enumerable: true,
        configurable: true
    });
    Document.compareByField = function (field, d1, d2) {
        var v1 = d1.field(field);
        var v2 = d2.field(field);
        if (v1 !== undefined && v2 !== undefined) {
            return v1.compareTo(v2);
        }
        else {
            return fail("Trying to compare documents on fields that don't exist");
        }
    };
    return Document;
}(MaybeDocument));
/**
 * A class representing a deleted document.
 * Version is set to 0 if we don't point to any specific time, otherwise it
 * denotes time we know it didn't exist at.
 */
var NoDocument = /** @class */ (function (_super) {
    tslib_1.__extends(NoDocument, _super);
    function NoDocument(key, version, options) {
        var _this = _super.call(this, key, version) || this;
        _this.hasCommittedMutations = !!(options && options.hasCommittedMutations);
        return _this;
    }
    NoDocument.prototype.toString = function () {
        return "NoDocument(" + this.key + ", " + this.version + ")";
    };
    Object.defineProperty(NoDocument.prototype, "hasPendingWrites", {
        get: function () {
            return this.hasCommittedMutations;
        },
        enumerable: true,
        configurable: true
    });
    NoDocument.prototype.isEqual = function (other) {
        return (other instanceof NoDocument &&
            other.hasCommittedMutations === this.hasCommittedMutations &&
            other.version.isEqual(this.version) &&
            other.key.isEqual(this.key));
    };
    return NoDocument;
}(MaybeDocument));
/**
 * A class representing an existing document whose data is unknown (e.g. a
 * document that was updated without a known base document).
 */
var UnknownDocument = /** @class */ (function (_super) {
    tslib_1.__extends(UnknownDocument, _super);
    function UnknownDocument(key, version) {
        return _super.call(this, key, version) || this;
    }
    UnknownDocument.prototype.toString = function () {
        return "UnknownDocument(" + this.key + ", " + this.version + ")";
    };
    Object.defineProperty(UnknownDocument.prototype, "hasPendingWrites", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    UnknownDocument.prototype.isEqual = function (other) {
        return (other instanceof UnknownDocument &&
            other.version.isEqual(this.version) &&
            other.key.isEqual(this.key));
    };
    return UnknownDocument;
}(MaybeDocument));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var SortedMap = /** @class */ (function () {
    function SortedMap(comparator, root) {
        this.comparator = comparator;
        this.root = root ? root : LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator, this.root
            .insert(key, value, this.comparator)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    // Returns a copy of the map, with the specified key removed.
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator, this.root
            .remove(key, this.comparator)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    // Returns the value of the node with the given key, or null.
    SortedMap.prototype.get = function (key) {
        var node = this.root;
        while (!node.isEmpty()) {
            var cmp = this.comparator(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    SortedMap.prototype.indexOf = function (key) {
        // Number of nodes that were pruned when descending right
        var prunedNodes = 0;
        var node = this.root;
        while (!node.isEmpty()) {
            var cmp = this.comparator(key, node.key);
            if (cmp === 0) {
                return prunedNodes + node.left.size;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else {
                // Count all nodes left of the node plus the node itself
                prunedNodes += node.left.size + 1;
                node = node.right;
            }
        }
        // Node not found
        return -1;
    };
    SortedMap.prototype.isEmpty = function () {
        return this.root.isEmpty();
    };
    Object.defineProperty(SortedMap.prototype, "size", {
        // Returns the total number of nodes in the map.
        get: function () {
            return this.root.size;
        },
        enumerable: true,
        configurable: true
    });
    // Returns the minimum key in the map.
    SortedMap.prototype.minKey = function () {
        return this.root.minKey();
    };
    // Returns the maximum key in the map.
    SortedMap.prototype.maxKey = function () {
        return this.root.maxKey();
    };
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root.inorderTraversal(action);
    };
    SortedMap.prototype.forEach = function (fn) {
        this.inorderTraversal(function (k, v) {
            fn(k, v);
            return false;
        });
    };
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root.reverseTraversal(action);
    };
    // Returns an iterator over the SortedMap.
    SortedMap.prototype.getIterator = function () {
        return new SortedMapIterator(this.root, null, this.comparator, false);
    };
    SortedMap.prototype.getIteratorFrom = function (key) {
        return new SortedMapIterator(this.root, key, this.comparator, false);
    };
    SortedMap.prototype.getReverseIterator = function () {
        return new SortedMapIterator(this.root, null, this.comparator, true);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key) {
        return new SortedMapIterator(this.root, key, this.comparator, true);
    };
    return SortedMap;
}()); // end SortedMap
// An iterator over an LLRBNode.
var SortedMapIterator = /** @class */ (function () {
    function SortedMapIterator(node, startKey, comparator, isReverse) {
        this.isReverse = isReverse;
        this.nodeStack = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse)
                cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move
                // to the next one
                this.nodeStack.push(node);
                if (this.isReverse) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        assert(this.nodeStack.length > 0, 'getNext() called on iterator when hasNext() is false.');
        var node = this.nodeStack.pop();
        var result = { key: node.key, value: node.value };
        if (this.isReverse) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack.length === 0)
            return null;
        var node = this.nodeStack[this.nodeStack.length - 1];
        return { key: node.key, value: node.value };
    };
    return SortedMapIterator;
}()); // end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
var LLRBNode = /** @class */ (function () {
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left = left != null ? left : LLRBNode.EMPTY;
        this.right = right != null ? right : LLRBNode.EMPTY;
        this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    // Returns the minimum node in the tree.
    LLRBNode.prototype.min = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min();
        }
    };
    // Returns the maximum key in the tree.
    LLRBNode.prototype.minKey = function () {
        return this.min().key;
    };
    // Returns the maximum key in the tree.
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    // Returns new tree, with the key/value added.
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var n = this;
        var cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp();
    };
    LLRBNode.prototype.removeMin = function () {
        if (this.left.isEmpty()) {
            return LLRBNode.EMPTY;
        }
        var n = this;
        if (!n.left.isRed() && !n.left.left.isRed())
            n = n.moveRedLeft();
        n = n.copy(null, null, null, n.left.removeMin(), null);
        return n.fixUp();
    };
    // Returns new tree, with the specified item removed.
    LLRBNode.prototype.remove = function (key, comparator) {
        var smallest;
        var n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed() && !n.left.left.isRed()) {
                n = n.moveRedLeft();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed())
                n = n.rotateRight();
            if (!n.right.isEmpty() && !n.right.isRed() && !n.right.left.isRed()) {
                n = n.moveRedRight();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return LLRBNode.EMPTY;
                }
                else {
                    smallest = n.right.min();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp();
    };
    LLRBNode.prototype.isRed = function () {
        return this.color;
    };
    // Returns new tree after performing any needed rotations.
    LLRBNode.prototype.fixUp = function () {
        var n = this;
        if (n.right.isRed() && !n.left.isRed())
            n = n.rotateLeft();
        if (n.left.isRed() && n.left.left.isRed())
            n = n.rotateRight();
        if (n.left.isRed() && n.right.isRed())
            n = n.colorFlip();
        return n;
    };
    LLRBNode.prototype.moveRedLeft = function () {
        var n = this.colorFlip();
        if (n.right.left.isRed()) {
            n = n.copy(null, null, null, null, n.right.rotateRight());
            n = n.rotateLeft();
            n = n.colorFlip();
        }
        return n;
    };
    LLRBNode.prototype.moveRedRight = function () {
        var n = this.colorFlip();
        if (n.left.left.isRed()) {
            n = n.rotateRight();
            n = n.colorFlip();
        }
        return n;
    };
    LLRBNode.prototype.rotateLeft = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    LLRBNode.prototype.rotateRight = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    LLRBNode.prototype.colorFlip = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    // For testing.
    LLRBNode.prototype.checkMaxDepth = function () {
        var blackDepth = this.check();
        if (Math.pow(2.0, blackDepth) <= this.size + 1) {
            return true;
        }
        else {
            return false;
        }
    };
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    LLRBNode.prototype.check = function () {
        if (this.isRed() && this.left.isRed()) {
            throw fail('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed()) {
            throw fail('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        var blackDepth = this.left.check();
        if (blackDepth !== this.right.check()) {
            throw fail('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed() ? 0 : 1);
        }
    };
    // tslint:disable-next-line:no-any Empty node is shared between all LLRB trees.
    LLRBNode.EMPTY = null;
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}()); // end LLRBNode
// Represents an empty node (a leaf node in the Red-Black Tree).
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
        this.size = 0;
    }
    // Returns a copy of the current node.
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    // Returns a copy of the tree, with the specified key/value added.
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value);
    };
    // Returns a copy of the tree, with the specified key removed.
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    LLRBEmptyNode.prototype.isRed = function () {
        return false;
    };
    // For testing.
    LLRBEmptyNode.prototype.checkMaxDepth = function () {
        return true;
    };
    LLRBEmptyNode.prototype.check = function () {
        return 0;
    };
    return LLRBEmptyNode;
}()); // end LLRBEmptyNode
LLRBNode.EMPTY = new LLRBEmptyNode();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TypeOrder;
(function (TypeOrder) {
    // This order is defined by the backend.
    TypeOrder[TypeOrder["NullValue"] = 0] = "NullValue";
    TypeOrder[TypeOrder["BooleanValue"] = 1] = "BooleanValue";
    TypeOrder[TypeOrder["NumberValue"] = 2] = "NumberValue";
    TypeOrder[TypeOrder["TimestampValue"] = 3] = "TimestampValue";
    TypeOrder[TypeOrder["StringValue"] = 4] = "StringValue";
    TypeOrder[TypeOrder["BlobValue"] = 5] = "BlobValue";
    TypeOrder[TypeOrder["RefValue"] = 6] = "RefValue";
    TypeOrder[TypeOrder["GeoPointValue"] = 7] = "GeoPointValue";
    TypeOrder[TypeOrder["ArrayValue"] = 8] = "ArrayValue";
    TypeOrder[TypeOrder["ObjectValue"] = 9] = "ObjectValue";
})(TypeOrder || (TypeOrder = {}));
/** Defines the return value for pending server timestamps. */
var ServerTimestampBehavior;
(function (ServerTimestampBehavior) {
    ServerTimestampBehavior[ServerTimestampBehavior["Default"] = 0] = "Default";
    ServerTimestampBehavior[ServerTimestampBehavior["Estimate"] = 1] = "Estimate";
    ServerTimestampBehavior[ServerTimestampBehavior["Previous"] = 2] = "Previous";
})(ServerTimestampBehavior || (ServerTimestampBehavior = {}));
/** Holds properties that define field value deserialization options. */
var FieldValueOptions = /** @class */ (function () {
    function FieldValueOptions(serverTimestampBehavior, timestampsInSnapshots) {
        this.serverTimestampBehavior = serverTimestampBehavior;
        this.timestampsInSnapshots = timestampsInSnapshots;
    }
    FieldValueOptions.fromSnapshotOptions = function (options, timestampsInSnapshots) {
        switch (options.serverTimestamps) {
            case 'estimate':
                return new FieldValueOptions(ServerTimestampBehavior.Estimate, timestampsInSnapshots);
            case 'previous':
                return new FieldValueOptions(ServerTimestampBehavior.Previous, timestampsInSnapshots);
            case 'none': // Fall-through intended.
            case undefined:
                return new FieldValueOptions(ServerTimestampBehavior.Default, timestampsInSnapshots);
            default:
                return fail('fromSnapshotOptions() called with invalid options.');
        }
    };
    return FieldValueOptions;
}());
/**
 * A field value represents a datatype as stored by Firestore.
 */
var FieldValue = /** @class */ (function () {
    function FieldValue() {
    }
    FieldValue.prototype.toString = function () {
        var val = this.value();
        return val === null ? 'null' : val.toString();
    };
    FieldValue.prototype.defaultCompareTo = function (other) {
        assert(this.typeOrder !== other.typeOrder, 'Default compareTo should not be used for values of same type.');
        var cmp = primitiveComparator(this.typeOrder, other.typeOrder);
        return cmp;
    };
    return FieldValue;
}());
var NullValue = /** @class */ (function (_super) {
    tslib_1.__extends(NullValue, _super);
    function NullValue() {
        var _this = _super.call(this) || this;
        _this.typeOrder = TypeOrder.NullValue;
        // internalValue is unused but we add it to work around
        // https://github.com/Microsoft/TypeScript/issues/15585
        _this.internalValue = null;
        return _this;
    }
    NullValue.prototype.value = function (options) {
        return null;
    };
    NullValue.prototype.isEqual = function (other) {
        return other instanceof NullValue;
    };
    NullValue.prototype.compareTo = function (other) {
        if (other instanceof NullValue) {
            return 0;
        }
        return this.defaultCompareTo(other);
    };
    NullValue.INSTANCE = new NullValue();
    return NullValue;
}(FieldValue));
var BooleanValue = /** @class */ (function (_super) {
    tslib_1.__extends(BooleanValue, _super);
    function BooleanValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.BooleanValue;
        return _this;
    }
    BooleanValue.prototype.value = function (options) {
        return this.internalValue;
    };
    BooleanValue.prototype.isEqual = function (other) {
        return (other instanceof BooleanValue &&
            this.internalValue === other.internalValue);
    };
    BooleanValue.prototype.compareTo = function (other) {
        if (other instanceof BooleanValue) {
            return primitiveComparator(this, other);
        }
        return this.defaultCompareTo(other);
    };
    BooleanValue.of = function (value) {
        return value ? BooleanValue.TRUE : BooleanValue.FALSE;
    };
    BooleanValue.TRUE = new BooleanValue(true);
    BooleanValue.FALSE = new BooleanValue(false);
    return BooleanValue;
}(FieldValue));
/** Base class for IntegerValue and DoubleValue. */
var NumberValue = /** @class */ (function (_super) {
    tslib_1.__extends(NumberValue, _super);
    function NumberValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.NumberValue;
        return _this;
    }
    NumberValue.prototype.value = function (options) {
        return this.internalValue;
    };
    NumberValue.prototype.compareTo = function (other) {
        if (other instanceof NumberValue) {
            return numericComparator(this.internalValue, other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return NumberValue;
}(FieldValue));
/** Utility function to compare doubles (using Firestore semantics for NaN). */
function numericComparator(left, right) {
    if (left < right) {
        return -1;
    }
    else if (left > right) {
        return 1;
    }
    else if (left === right) {
        return 0;
    }
    else {
        // one or both are NaN.
        if (isNaN(left)) {
            return isNaN(right) ? 0 : -1;
        }
        else {
            return 1;
        }
    }
}
/**
 * Utility function to check numbers for equality using Firestore semantics
 * (NaN === NaN, -0.0 !== 0.0).
 */
function numericEquals(left, right) {
    // Implemented based on Object.is() polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    if (left === right) {
        // +0 != -0
        return left !== 0 || 1 / left === 1 / right;
    }
    else {
        // NaN == NaN
        return left !== left && right !== right;
    }
}
var IntegerValue = /** @class */ (function (_super) {
    tslib_1.__extends(IntegerValue, _super);
    function IntegerValue(internalValue) {
        return _super.call(this, internalValue) || this;
    }
    IntegerValue.prototype.isEqual = function (other) {
        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
        // but that doesn't make them equal via isEqual().
        if (other instanceof IntegerValue) {
            return numericEquals(this.internalValue, other.internalValue);
        }
        else {
            return false;
        }
    };
    return IntegerValue;
}(NumberValue));
var DoubleValue = /** @class */ (function (_super) {
    tslib_1.__extends(DoubleValue, _super);
    function DoubleValue(internalValue) {
        var _this = _super.call(this, internalValue) || this;
        _this.internalValue = internalValue;
        return _this;
    }
    DoubleValue.prototype.isEqual = function (other) {
        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
        // but that doesn't make them equal via isEqual().
        if (other instanceof DoubleValue) {
            return numericEquals(this.internalValue, other.internalValue);
        }
        else {
            return false;
        }
    };
    DoubleValue.NAN = new DoubleValue(NaN);
    DoubleValue.POSITIVE_INFINITY = new DoubleValue(Infinity);
    DoubleValue.NEGATIVE_INFINITY = new DoubleValue(-Infinity);
    return DoubleValue;
}(NumberValue));
// TODO(b/37267885): Add truncation support
var StringValue = /** @class */ (function (_super) {
    tslib_1.__extends(StringValue, _super);
    function StringValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.StringValue;
        return _this;
    }
    StringValue.prototype.value = function (options) {
        return this.internalValue;
    };
    StringValue.prototype.isEqual = function (other) {
        return (other instanceof StringValue && this.internalValue === other.internalValue);
    };
    StringValue.prototype.compareTo = function (other) {
        if (other instanceof StringValue) {
            return primitiveComparator(this.internalValue, other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return StringValue;
}(FieldValue));
var TimestampValue = /** @class */ (function (_super) {
    tslib_1.__extends(TimestampValue, _super);
    function TimestampValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.TimestampValue;
        return _this;
    }
    TimestampValue.prototype.value = function (options) {
        if (!options || options.timestampsInSnapshots) {
            return this.internalValue;
        }
        else {
            return this.internalValue.toDate();
        }
    };
    TimestampValue.prototype.isEqual = function (other) {
        return (other instanceof TimestampValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    TimestampValue.prototype.compareTo = function (other) {
        if (other instanceof TimestampValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        else if (other instanceof ServerTimestampValue) {
            // Concrete timestamps come before server timestamps.
            return -1;
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    return TimestampValue;
}(FieldValue));
/**
 * Represents a locally-applied ServerTimestamp.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
 *   the local view of a document. Therefore they do not need to be parsed or
 *   serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */
var ServerTimestampValue = /** @class */ (function (_super) {
    tslib_1.__extends(ServerTimestampValue, _super);
    function ServerTimestampValue(localWriteTime, previousValue) {
        var _this = _super.call(this) || this;
        _this.localWriteTime = localWriteTime;
        _this.previousValue = previousValue;
        _this.typeOrder = TypeOrder.TimestampValue;
        return _this;
    }
    ServerTimestampValue.prototype.value = function (options) {
        if (options &&
            options.serverTimestampBehavior === ServerTimestampBehavior.Estimate) {
            return new TimestampValue(this.localWriteTime).value(options);
        }
        else if (options &&
            options.serverTimestampBehavior === ServerTimestampBehavior.Previous) {
            return this.previousValue ? this.previousValue.value(options) : null;
        }
        else {
            return null;
        }
    };
    ServerTimestampValue.prototype.isEqual = function (other) {
        return (other instanceof ServerTimestampValue &&
            this.localWriteTime.isEqual(other.localWriteTime));
    };
    ServerTimestampValue.prototype.compareTo = function (other) {
        if (other instanceof ServerTimestampValue) {
            return this.localWriteTime._compareTo(other.localWriteTime);
        }
        else if (other instanceof TimestampValue) {
            // Server timestamps come after all concrete timestamps.
            return 1;
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ServerTimestampValue.prototype.toString = function () {
        return '<ServerTimestamp localTime=' + this.localWriteTime.toString() + '>';
    };
    return ServerTimestampValue;
}(FieldValue));
var BlobValue = /** @class */ (function (_super) {
    tslib_1.__extends(BlobValue, _super);
    function BlobValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.BlobValue;
        return _this;
    }
    BlobValue.prototype.value = function (options) {
        return this.internalValue;
    };
    BlobValue.prototype.isEqual = function (other) {
        return (other instanceof BlobValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    BlobValue.prototype.compareTo = function (other) {
        if (other instanceof BlobValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return BlobValue;
}(FieldValue));
var RefValue = /** @class */ (function (_super) {
    tslib_1.__extends(RefValue, _super);
    function RefValue(databaseId, key) {
        var _this = _super.call(this) || this;
        _this.databaseId = databaseId;
        _this.key = key;
        _this.typeOrder = TypeOrder.RefValue;
        return _this;
    }
    RefValue.prototype.value = function (options) {
        return this.key;
    };
    RefValue.prototype.isEqual = function (other) {
        if (other instanceof RefValue) {
            return (this.key.isEqual(other.key) && this.databaseId.isEqual(other.databaseId));
        }
        else {
            return false;
        }
    };
    RefValue.prototype.compareTo = function (other) {
        if (other instanceof RefValue) {
            var cmp = this.databaseId.compareTo(other.databaseId);
            return cmp !== 0 ? cmp : DocumentKey.comparator(this.key, other.key);
        }
        return this.defaultCompareTo(other);
    };
    return RefValue;
}(FieldValue));
var GeoPointValue = /** @class */ (function (_super) {
    tslib_1.__extends(GeoPointValue, _super);
    function GeoPointValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.GeoPointValue;
        return _this;
    }
    GeoPointValue.prototype.value = function (options) {
        return this.internalValue;
    };
    GeoPointValue.prototype.isEqual = function (other) {
        return (other instanceof GeoPointValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    GeoPointValue.prototype.compareTo = function (other) {
        if (other instanceof GeoPointValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return GeoPointValue;
}(FieldValue));
var ObjectValue = /** @class */ (function (_super) {
    tslib_1.__extends(ObjectValue, _super);
    function ObjectValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.ObjectValue;
        return _this;
    }
    ObjectValue.prototype.value = function (options) {
        var result = {};
        this.internalValue.inorderTraversal(function (key, val) {
            result[key] = val.value(options);
        });
        return result;
    };
    ObjectValue.prototype.forEach = function (action) {
        this.internalValue.inorderTraversal(action);
    };
    ObjectValue.prototype.isEqual = function (other) {
        if (other instanceof ObjectValue) {
            var it1 = this.internalValue.getIterator();
            var it2 = other.internalValue.getIterator();
            while (it1.hasNext() && it2.hasNext()) {
                var next1 = it1.getNext();
                var next2 = it2.getNext();
                if (next1.key !== next2.key || !next1.value.isEqual(next2.value)) {
                    return false;
                }
            }
            return !it1.hasNext() && !it2.hasNext();
        }
        return false;
    };
    ObjectValue.prototype.compareTo = function (other) {
        if (other instanceof ObjectValue) {
            var it1 = this.internalValue.getIterator();
            var it2 = other.internalValue.getIterator();
            while (it1.hasNext() && it2.hasNext()) {
                var next1 = it1.getNext();
                var next2 = it2.getNext();
                var cmp = primitiveComparator(next1.key, next2.key) ||
                    next1.value.compareTo(next2.value);
                if (cmp) {
                    return cmp;
                }
            }
            // Only equal if both iterators are exhausted
            return primitiveComparator(it1.hasNext(), it2.hasNext());
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ObjectValue.prototype.set = function (path, to) {
        assert(!path.isEmpty(), 'Cannot set field for empty path on ObjectValue');
        if (path.length === 1) {
            return this.setChild(path.firstSegment(), to);
        }
        else {
            var child = this.child(path.firstSegment());
            if (!(child instanceof ObjectValue)) {
                child = ObjectValue.EMPTY;
            }
            var newChild = child.set(path.popFirst(), to);
            return this.setChild(path.firstSegment(), newChild);
        }
    };
    ObjectValue.prototype.delete = function (path) {
        assert(!path.isEmpty(), 'Cannot delete field for empty path on ObjectValue');
        if (path.length === 1) {
            return new ObjectValue(this.internalValue.remove(path.firstSegment()));
        }
        else {
            // nested field
            var child = this.child(path.firstSegment());
            if (child instanceof ObjectValue) {
                var newChild = child.delete(path.popFirst());
                return new ObjectValue(this.internalValue.insert(path.firstSegment(), newChild));
            }
            else {
                // Don't actually change a primitive value to an object for a delete
                return this;
            }
        }
    };
    ObjectValue.prototype.contains = function (path) {
        return this.field(path) !== undefined;
    };
    ObjectValue.prototype.field = function (path) {
        assert(!path.isEmpty(), "Can't get field of empty path");
        var field = this;
        path.forEach(function (pathSegment) {
            if (field instanceof ObjectValue) {
                field = field.internalValue.get(pathSegment) || undefined;
            }
            else {
                field = undefined;
            }
        });
        return field;
    };
    ObjectValue.prototype.toString = function () {
        return JSON.stringify(this.value());
    };
    ObjectValue.prototype.child = function (childName) {
        return this.internalValue.get(childName) || undefined;
    };
    ObjectValue.prototype.setChild = function (childName, value) {
        return new ObjectValue(this.internalValue.insert(childName, value));
    };
    ObjectValue.EMPTY = new ObjectValue(new SortedMap(primitiveComparator));
    return ObjectValue;
}(FieldValue));
var ArrayValue = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayValue, _super);
    function ArrayValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.ArrayValue;
        return _this;
    }
    ArrayValue.prototype.value = function (options) {
        return this.internalValue.map(function (v) { return v.value(options); });
    };
    ArrayValue.prototype.forEach = function (action) {
        this.internalValue.forEach(action);
    };
    ArrayValue.prototype.isEqual = function (other) {
        if (other instanceof ArrayValue) {
            if (this.internalValue.length !== other.internalValue.length) {
                return false;
            }
            for (var i = 0; i < this.internalValue.length; i++) {
                if (!this.internalValue[i].isEqual(other.internalValue[i])) {
                    return false;
                }
            }
            return true;
        }
        return false;
    };
    ArrayValue.prototype.compareTo = function (other) {
        if (other instanceof ArrayValue) {
            var minLength = Math.min(this.internalValue.length, other.internalValue.length);
            for (var i = 0; i < minLength; i++) {
                var cmp = this.internalValue[i].compareTo(other.internalValue[i]);
                if (cmp) {
                    return cmp;
                }
            }
            return primitiveComparator(this.internalValue.length, other.internalValue.length);
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ArrayValue.prototype.toString = function () {
        return JSON.stringify(this.value());
    };
    return ArrayValue;
}(FieldValue));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Untyped Number alias we can use to check for ES6 methods / properties.
// tslint:disable-next-line:no-any variable-name
var NumberAsAny = Number;
/**
 * Minimum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */
var MIN_SAFE_INTEGER = NumberAsAny.MIN_SAFE_INTEGER || -(Math.pow(2, 53) - 1);
/**
 * Maximum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */
var MAX_SAFE_INTEGER = NumberAsAny.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
/**
 * Returns whether an number is an integer, uses native implementation if
 * available.
 * Added to not rely on ES6 features.
 * @param value The value to test for being an integer
 */
var isInteger = NumberAsAny.isInteger ||
    (function (value) {
        return typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value;
    });
/**
 * Returns whether a variable is either undefined or null.
 */
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value The value to test for being an integer and in the safe range
 */
function isSafeInteger(value) {
    return (isInteger(value) &&
        value <= MAX_SAFE_INTEGER &&
        value >= MIN_SAFE_INTEGER);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Query = /** @class */ (function () {
    function Query(path, explicitOrderBy, filters, limit, startAt, endAt) {
        if (explicitOrderBy === void 0) { explicitOrderBy = []; }
        if (filters === void 0) { filters = []; }
        if (limit === void 0) { limit = null; }
        if (startAt === void 0) { startAt = null; }
        if (endAt === void 0) { endAt = null; }
        this.path = path;
        this.explicitOrderBy = explicitOrderBy;
        this.filters = filters;
        this.limit = limit;
        this.startAt = startAt;
        this.endAt = endAt;
        this.memoizedCanonicalId = null;
        this.memoizedOrderBy = null;
        if (this.startAt) {
            this.assertValidBound(this.startAt);
        }
        if (this.endAt) {
            this.assertValidBound(this.endAt);
        }
    }
    Query.atPath = function (path) {
        return new Query(path);
    };
    Object.defineProperty(Query.prototype, "orderBy", {
        get: function () {
            if (this.memoizedOrderBy === null) {
                var inequalityField = this.getInequalityFilterField();
                var firstOrderByField = this.getFirstOrderByField();
                if (inequalityField !== null && firstOrderByField === null) {
                    // In order to implicitly add key ordering, we must also add the
                    // inequality filter field for it to be a valid query.
                    // Note that the default inequality field and key ordering is ascending.
                    if (inequalityField.isKeyField()) {
                        this.memoizedOrderBy = [KEY_ORDERING_ASC];
                    }
                    else {
                        this.memoizedOrderBy = [
                            new OrderBy(inequalityField),
                            KEY_ORDERING_ASC
                        ];
                    }
                }
                else {
                    assert(inequalityField === null ||
                        (firstOrderByField !== null &&
                            inequalityField.isEqual(firstOrderByField)), 'First orderBy should match inequality field.');
                    this.memoizedOrderBy = [];
                    var foundKeyOrdering = false;
                    for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
                        var orderBy = _a[_i];
                        this.memoizedOrderBy.push(orderBy);
                        if (orderBy.field.isKeyField()) {
                            foundKeyOrdering = true;
                        }
                    }
                    if (!foundKeyOrdering) {
                        // The order of the implicit key ordering always matches the last
                        // explicit order by
                        var lastDirection = this.explicitOrderBy.length > 0
                            ? this.explicitOrderBy[this.explicitOrderBy.length - 1].dir
                            : Direction.ASCENDING;
                        this.memoizedOrderBy.push(lastDirection === Direction.ASCENDING
                            ? KEY_ORDERING_ASC
                            : KEY_ORDERING_DESC);
                    }
                }
            }
            return this.memoizedOrderBy;
        },
        enumerable: true,
        configurable: true
    });
    Query.prototype.addFilter = function (filter) {
        assert(this.getInequalityFilterField() == null ||
            !(filter instanceof RelationFilter) ||
            !filter.isInequality() ||
            filter.field.isEqual(this.getInequalityFilterField()), 'Query must only have one inequality field.');
        assert(!DocumentKey.isDocumentKey(this.path), 'No filtering allowed for document query');
        var newFilters = this.filters.concat([filter]);
        return new Query(this.path, this.explicitOrderBy.slice(), newFilters, this.limit, this.startAt, this.endAt);
    };
    Query.prototype.addOrderBy = function (orderBy) {
        assert(!DocumentKey.isDocumentKey(this.path), 'No ordering allowed for document query');
        assert(!this.startAt && !this.endAt, 'Bounds must be set after orderBy');
        // TODO(dimond): validate that orderBy does not list the same key twice.
        var newOrderBy = this.explicitOrderBy.concat([orderBy]);
        return new Query(this.path, newOrderBy, this.filters.slice(), this.limit, this.startAt, this.endAt);
    };
    Query.prototype.withLimit = function (limit) {
        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), limit, this.startAt, this.endAt);
    };
    Query.prototype.withStartAt = function (bound) {
        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, bound, this.endAt);
    };
    Query.prototype.withEndAt = function (bound) {
        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.startAt, bound);
    };
    // TODO(b/29183165): This is used to get a unique string from a query to, for
    // example, use as a dictionary key, but the implementation is subject to
    // collisions. Make it collision-free.
    Query.prototype.canonicalId = function () {
        if (this.memoizedCanonicalId === null) {
            var canonicalId = this.path.canonicalString();
            canonicalId += '|f:';
            for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
                var filter = _a[_i];
                canonicalId += filter.canonicalId();
                canonicalId += ',';
            }
            canonicalId += '|ob:';
            // TODO(dimond): make this collision resistant
            for (var _b = 0, _c = this.orderBy; _b < _c.length; _b++) {
                var orderBy = _c[_b];
                canonicalId += orderBy.canonicalId();
                canonicalId += ',';
            }
            if (!isNullOrUndefined(this.limit)) {
                canonicalId += '|l:';
                canonicalId += this.limit;
            }
            if (this.startAt) {
                canonicalId += '|lb:';
                canonicalId += this.startAt.canonicalId();
            }
            if (this.endAt) {
                canonicalId += '|ub:';
                canonicalId += this.endAt.canonicalId();
            }
            this.memoizedCanonicalId = canonicalId;
        }
        return this.memoizedCanonicalId;
    };
    Query.prototype.toString = function () {
        var str = 'Query(' + this.path.canonicalString();
        if (this.filters.length > 0) {
            str += ", filters: [" + this.filters.join(', ') + "]";
        }
        if (!isNullOrUndefined(this.limit)) {
            str += ', limit: ' + this.limit;
        }
        if (this.explicitOrderBy.length > 0) {
            str += ", orderBy: [" + this.explicitOrderBy.join(', ') + "]";
        }
        if (this.startAt) {
            str += ', startAt: ' + this.startAt.canonicalId();
        }
        if (this.endAt) {
            str += ', endAt: ' + this.endAt.canonicalId();
        }
        return str + ')';
    };
    Query.prototype.isEqual = function (other) {
        if (this.limit !== other.limit) {
            return false;
        }
        if (this.orderBy.length !== other.orderBy.length) {
            return false;
        }
        for (var i = 0; i < this.orderBy.length; i++) {
            if (!this.orderBy[i].isEqual(other.orderBy[i])) {
                return false;
            }
        }
        if (this.filters.length !== other.filters.length) {
            return false;
        }
        for (var i = 0; i < this.filters.length; i++) {
            if (!this.filters[i].isEqual(other.filters[i])) {
                return false;
            }
        }
        if (!this.path.isEqual(other.path)) {
            return false;
        }
        if (this.startAt !== null
            ? !this.startAt.isEqual(other.startAt)
            : other.startAt !== null) {
            return false;
        }
        return this.endAt !== null
            ? this.endAt.isEqual(other.endAt)
            : other.endAt === null;
    };
    Query.prototype.docComparator = function (d1, d2) {
        var comparedOnKeyField = false;
        for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            var comp = orderBy.compare(d1, d2);
            if (comp !== 0)
                return comp;
            comparedOnKeyField = comparedOnKeyField || orderBy.field.isKeyField();
        }
        // Assert that we actually compared by key
        assert(comparedOnKeyField, "orderBy used that doesn't compare on key field");
        return 0;
    };
    Query.prototype.matches = function (doc) {
        return (this.matchesAncestor(doc) &&
            this.matchesOrderBy(doc) &&
            this.matchesFilters(doc) &&
            this.matchesBounds(doc));
    };
    Query.prototype.hasLimit = function () {
        return !isNullOrUndefined(this.limit);
    };
    Query.prototype.getFirstOrderByField = function () {
        return this.explicitOrderBy.length > 0
            ? this.explicitOrderBy[0].field
            : null;
    };
    Query.prototype.getInequalityFilterField = function () {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (filter instanceof RelationFilter && filter.isInequality()) {
                return filter.field;
            }
        }
        return null;
    };
    Query.prototype.hasArrayContainsFilter = function () {
        return (this.filters.find(function (filter) {
            return filter instanceof RelationFilter &&
                filter.op === RelationOp.ARRAY_CONTAINS;
        }) !== undefined);
    };
    Query.prototype.isDocumentQuery = function () {
        return DocumentKey.isDocumentKey(this.path) && this.filters.length === 0;
    };
    Query.prototype.matchesAncestor = function (doc) {
        var docPath = doc.key.path;
        if (DocumentKey.isDocumentKey(this.path)) {
            // exact match for document queries
            return this.path.isEqual(docPath);
        }
        else {
            // shallow ancestor queries by default
            return (this.path.isPrefixOf(docPath) && this.path.length === docPath.length - 1);
        }
    };
    /**
     * A document must have a value for every ordering clause in order to show up
     * in the results.
     */
    Query.prototype.matchesOrderBy = function (doc) {
        for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            // order by key always matches
            if (!orderBy.field.isKeyField() &&
                doc.field(orderBy.field) === undefined) {
                return false;
            }
        }
        return true;
    };
    Query.prototype.matchesFilters = function (doc) {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (!filter.matches(doc)) {
                return false;
            }
        }
        return true;
    };
    /**
     * Makes sure a document is within the bounds, if provided.
     */
    Query.prototype.matchesBounds = function (doc) {
        if (this.startAt && !this.startAt.sortsBeforeDocument(this.orderBy, doc)) {
            return false;
        }
        if (this.endAt && this.endAt.sortsBeforeDocument(this.orderBy, doc)) {
            return false;
        }
        return true;
    };
    Query.prototype.assertValidBound = function (bound) {
        assert(bound.position.length <= this.orderBy.length, 'Bound is longer than orderBy');
    };
    return Query;
}());
var Filter = /** @class */ (function () {
    function Filter() {
    }
    /**
     * Creates a filter based on the provided arguments.
     */
    Filter.create = function (field, op, value) {
        if (value.isEqual(NullValue.INSTANCE)) {
            if (op !== RelationOp.EQUAL) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals comparisons on null.');
            }
            return new NullFilter(field);
        }
        else if (value.isEqual(DoubleValue.NAN)) {
            if (op !== RelationOp.EQUAL) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals comparisons on NaN.');
            }
            return new NanFilter(field);
        }
        else {
            return new RelationFilter(field, op, value);
        }
    };
    return Filter;
}());
var RelationOp = /** @class */ (function () {
    function RelationOp(name) {
        this.name = name;
    }
    RelationOp.fromString = function (op) {
        switch (op) {
            case '<':
                return RelationOp.LESS_THAN;
            case '<=':
                return RelationOp.LESS_THAN_OR_EQUAL;
            case '==':
                return RelationOp.EQUAL;
            case '>=':
                return RelationOp.GREATER_THAN_OR_EQUAL;
            case '>':
                return RelationOp.GREATER_THAN;
            case 'array-contains':
                return RelationOp.ARRAY_CONTAINS;
            default:
                return fail('Unknown relation: ' + op);
        }
    };
    RelationOp.prototype.toString = function () {
        return this.name;
    };
    RelationOp.prototype.isEqual = function (other) {
        return this.name === other.name;
    };
    RelationOp.LESS_THAN = new RelationOp('<');
    RelationOp.LESS_THAN_OR_EQUAL = new RelationOp('<=');
    RelationOp.EQUAL = new RelationOp('==');
    RelationOp.GREATER_THAN = new RelationOp('>');
    RelationOp.GREATER_THAN_OR_EQUAL = new RelationOp('>=');
    RelationOp.ARRAY_CONTAINS = new RelationOp('array-contains');
    return RelationOp;
}());
var RelationFilter = /** @class */ (function (_super) {
    tslib_1.__extends(RelationFilter, _super);
    function RelationFilter(field, op, value) {
        var _this = _super.call(this) || this;
        _this.field = field;
        _this.op = op;
        _this.value = value;
        return _this;
    }
    RelationFilter.prototype.matches = function (doc) {
        if (this.field.isKeyField()) {
            assert(this.value instanceof RefValue, 'Comparing on key, but filter value not a RefValue');
            assert(this.op !== RelationOp.ARRAY_CONTAINS, "array-contains queries don't make sense on document keys.");
            var refValue = this.value;
            var comparison = DocumentKey.comparator(doc.key, refValue.key);
            return this.matchesComparison(comparison);
        }
        else {
            var val = doc.field(this.field);
            return val !== undefined && this.matchesValue(val);
        }
    };
    RelationFilter.prototype.matchesValue = function (value) {
        var _this = this;
        if (this.op === RelationOp.ARRAY_CONTAINS) {
            return (value instanceof ArrayValue &&
                value.internalValue.find(function (element) { return element.isEqual(_this.value); }) !==
                    undefined);
        }
        else {
            // Only compare types with matching backend order (such as double and int).
            return (this.value.typeOrder === value.typeOrder &&
                this.matchesComparison(value.compareTo(this.value)));
        }
    };
    RelationFilter.prototype.matchesComparison = function (comparison) {
        switch (this.op) {
            case RelationOp.LESS_THAN:
                return comparison < 0;
            case RelationOp.LESS_THAN_OR_EQUAL:
                return comparison <= 0;
            case RelationOp.EQUAL:
                return comparison === 0;
            case RelationOp.GREATER_THAN:
                return comparison > 0;
            case RelationOp.GREATER_THAN_OR_EQUAL:
                return comparison >= 0;
            default:
                return fail('Unknown relation op' + this.op);
        }
    };
    RelationFilter.prototype.isInequality = function () {
        return (this.op !== RelationOp.EQUAL && this.op !== RelationOp.ARRAY_CONTAINS);
    };
    RelationFilter.prototype.canonicalId = function () {
        // TODO(b/29183165): Technically, this won't be unique if two values have
        // the same description, such as the int 3 and the string "3". So we should
        // add the types in here somehow, too.
        return (this.field.canonicalString() + this.op.toString() + this.value.toString());
    };
    RelationFilter.prototype.isEqual = function (other) {
        if (other instanceof RelationFilter) {
            return (this.op.isEqual(other.op) &&
                this.field.isEqual(other.field) &&
                this.value.isEqual(other.value));
        }
        else {
            return false;
        }
    };
    RelationFilter.prototype.toString = function () {
        return this.field.canonicalString() + " " + this.op + " " + this.value.value();
    };
    return RelationFilter;
}(Filter));
/**
 * Filter that matches 'null' values.
 */
var NullFilter = /** @class */ (function (_super) {
    tslib_1.__extends(NullFilter, _super);
    function NullFilter(field) {
        var _this = _super.call(this) || this;
        _this.field = field;
        return _this;
    }
    NullFilter.prototype.matches = function (doc) {
        var val = doc.field(this.field);
        return val !== undefined && val.value() === null;
    };
    NullFilter.prototype.canonicalId = function () {
        return this.field.canonicalString() + ' IS null';
    };
    NullFilter.prototype.toString = function () {
        return this.field.canonicalString() + " IS null";
    };
    NullFilter.prototype.isEqual = function (other) {
        if (other instanceof NullFilter) {
            return this.field.isEqual(other.field);
        }
        else {
            return false;
        }
    };
    return NullFilter;
}(Filter));
/**
 * Filter that matches 'NaN' values.
 */
var NanFilter = /** @class */ (function (_super) {
    tslib_1.__extends(NanFilter, _super);
    function NanFilter(field) {
        var _this = _super.call(this) || this;
        _this.field = field;
        return _this;
    }
    NanFilter.prototype.matches = function (doc) {
        var field = doc.field(this.field);
        var val = field && field.value();
        return typeof val === 'number' && isNaN(val);
    };
    NanFilter.prototype.canonicalId = function () {
        return this.field.canonicalString() + ' IS NaN';
    };
    NanFilter.prototype.toString = function () {
        return this.field.canonicalString() + " IS NaN";
    };
    NanFilter.prototype.isEqual = function (other) {
        if (other instanceof NanFilter) {
            return this.field.isEqual(other.field);
        }
        else {
            return false;
        }
    };
    return NanFilter;
}(Filter));
/**
 * The direction of sorting in an order by.
 */
var Direction = /** @class */ (function () {
    function Direction(name) {
        this.name = name;
    }
    Direction.prototype.toString = function () {
        return this.name;
    };
    Direction.ASCENDING = new Direction('asc');
    Direction.DESCENDING = new Direction('desc');
    return Direction;
}());
/**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */
var Bound = /** @class */ (function () {
    function Bound(position, before) {
        this.position = position;
        this.before = before;
    }
    Bound.prototype.canonicalId = function () {
        // TODO(b/29183165): Make this collision robust.
        var canonicalId = this.before ? 'b:' : 'a:';
        for (var _i = 0, _a = this.position; _i < _a.length; _i++) {
            var component = _a[_i];
            canonicalId += component.toString();
        }
        return canonicalId;
    };
    /**
     * Returns true if a document sorts before a bound using the provided sort
     * order.
     */
    Bound.prototype.sortsBeforeDocument = function (orderBy, doc) {
        assert(this.position.length <= orderBy.length, "Bound has more components than query's orderBy");
        var comparison = 0;
        for (var i = 0; i < this.position.length; i++) {
            var orderByComponent = orderBy[i];
            var component = this.position[i];
            if (orderByComponent.field.isKeyField()) {
                assert(component instanceof RefValue, 'Bound has a non-key value where the key path is being used.');
                comparison = DocumentKey.comparator(component.key, doc.key);
            }
            else {
                var docValue = doc.field(orderByComponent.field);
                assert(docValue !== undefined, 'Field should exist since document matched the orderBy already.');
                comparison = component.compareTo(docValue);
            }
            if (orderByComponent.dir === Direction.DESCENDING) {
                comparison = comparison * -1;
            }
            if (comparison !== 0) {
                break;
            }
        }
        return this.before ? comparison <= 0 : comparison < 0;
    };
    Bound.prototype.isEqual = function (other) {
        if (other === null) {
            return false;
        }
        if (this.before !== other.before ||
            this.position.length !== other.position.length) {
            return false;
        }
        for (var i = 0; i < this.position.length; i++) {
            var thisPosition = this.position[i];
            var otherPosition = other.position[i];
            return thisPosition.isEqual(otherPosition);
        }
        return true;
    };
    return Bound;
}());
/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */
var OrderBy = /** @class */ (function () {
    function OrderBy(field, dir) {
        this.field = field;
        if (dir === undefined) {
            dir = Direction.ASCENDING;
        }
        this.dir = dir;
        this.isKeyOrderBy = field.isKeyField();
    }
    OrderBy.prototype.compare = function (d1, d2) {
        var comparison = this.isKeyOrderBy
            ? Document.compareByKey(d1, d2)
            : Document.compareByField(this.field, d1, d2);
        switch (this.dir) {
            case Direction.ASCENDING:
                return comparison;
            case Direction.DESCENDING:
                return -1 * comparison;
            default:
                return fail('Unknown direction: ' + this.dir);
        }
    };
    OrderBy.prototype.canonicalId = function () {
        // TODO(b/29183165): Make this collision robust.
        return this.field.canonicalString() + this.dir.toString();
    };
    OrderBy.prototype.toString = function () {
        return this.field.canonicalString() + " (" + this.dir + ")";
    };
    OrderBy.prototype.isEqual = function (other) {
        return this.dir === other.dir && this.field.isEqual(other.field);
    };
    return OrderBy;
}());
var KEY_ORDERING_ASC = new OrderBy(FieldPath.keyField(), Direction.ASCENDING);
var KEY_ORDERING_DESC = new OrderBy(FieldPath.keyField(), Direction.DESCENDING);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */
var SnapshotVersion = /** @class */ (function () {
    function SnapshotVersion(timestamp) {
        this.timestamp = timestamp;
    }
    // TODO(b/34176344): Once we no longer need to use the old alpha protos,
    // delete this constructor and use a timestamp-backed version everywhere.
    SnapshotVersion.fromMicroseconds = function (value) {
        var seconds = Math.floor(value / 1e6);
        var nanos = (value % 1e6) * 1e3;
        return new SnapshotVersion(new Timestamp(seconds, nanos));
    };
    SnapshotVersion.fromTimestamp = function (value) {
        return new SnapshotVersion(value);
    };
    SnapshotVersion.forDeletedDoc = function () {
        return SnapshotVersion.MIN;
    };
    SnapshotVersion.prototype.compareTo = function (other) {
        return this.timestamp._compareTo(other.timestamp);
    };
    SnapshotVersion.prototype.isEqual = function (other) {
        return this.timestamp.isEqual(other.timestamp);
    };
    /** Returns a number representation of the version for use in spec tests. */
    SnapshotVersion.prototype.toMicroseconds = function () {
        // Convert to microseconds.
        return this.timestamp.seconds * 1e6 + this.timestamp.nanoseconds / 1000;
    };
    SnapshotVersion.prototype.toString = function () {
        return 'SnapshotVersion(' + this.timestamp.toString() + ')';
    };
    SnapshotVersion.prototype.toTimestamp = function () {
        return this.timestamp;
    };
    SnapshotVersion.MIN = new SnapshotVersion(new Timestamp(0, 0));
    return SnapshotVersion;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** An enumeration of the different purposes we have for queries. */
var QueryPurpose;
(function (QueryPurpose) {
    /** A regular, normal query. */
    QueryPurpose[QueryPurpose["Listen"] = 0] = "Listen";
    /**
     * The query was used to refill a query after an existence filter mismatch.
     */
    QueryPurpose[QueryPurpose["ExistenceFilterMismatch"] = 1] = "ExistenceFilterMismatch";
    /** The query was used to resolve a limbo document. */
    QueryPurpose[QueryPurpose["LimboResolution"] = 2] = "LimboResolution";
})(QueryPurpose || (QueryPurpose = {}));
/**
 * An immutable set of metadata that the local store tracks for each query.
 */
var QueryData = /** @class */ (function () {
    function QueryData(
    /** The query being listened to. */
    query, 
    /**
     * The target ID to which the query corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */
    targetId, 
    /** The purpose of the query. */
    purpose, 
    /** The sequence number of the last transaction during which this query data was modified */
    sequenceNumber, 
    /** The latest snapshot version seen for this target. */
    snapshotVersion, 
    /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the query. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */
    resumeToken) {
        if (snapshotVersion === void 0) { snapshotVersion = SnapshotVersion.MIN; }
        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
        this.query = query;
        this.targetId = targetId;
        this.purpose = purpose;
        this.sequenceNumber = sequenceNumber;
        this.snapshotVersion = snapshotVersion;
        this.resumeToken = resumeToken;
    }
    /**
     * Creates a new query data instance with an updated snapshot version and
     * resume token.
     */
    QueryData.prototype.copy = function (overwrite) {
        return new QueryData(this.query, this.targetId, this.purpose, overwrite.sequenceNumber === undefined
            ? this.sequenceNumber
            : overwrite.sequenceNumber, overwrite.snapshotVersion === undefined
            ? this.snapshotVersion
            : overwrite.snapshotVersion, overwrite.resumeToken === undefined
            ? this.resumeToken
            : overwrite.resumeToken);
    };
    QueryData.prototype.isEqual = function (other) {
        return (this.targetId === other.targetId &&
            this.purpose === other.purpose &&
            this.sequenceNumber === other.sequenceNumber &&
            this.snapshotVersion.isEqual(other.snapshotVersion) &&
            this.resumeToken === other.resumeToken &&
            this.query.isEqual(other.query));
    };
    return QueryData;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */
var SortedSet = /** @class */ (function () {
    function SortedSet(comparator) {
        this.comparator = comparator;
        this.data = new SortedMap(this.comparator);
    }
    /**
     * Creates a SortedSet from the keys of the map.
     * This is currently implemented as an O(n) copy.
     */
    SortedSet.fromMapKeys = function (map) {
        var keys = new SortedSet(map.comparator);
        map.forEach(function (key) {
            keys = keys.add(key);
        });
        return keys;
    };
    SortedSet.prototype.has = function (elem) {
        return this.data.get(elem) !== null;
    };
    SortedSet.prototype.first = function () {
        return this.data.minKey();
    };
    SortedSet.prototype.last = function () {
        return this.data.maxKey();
    };
    Object.defineProperty(SortedSet.prototype, "size", {
        get: function () {
            return this.data.size;
        },
        enumerable: true,
        configurable: true
    });
    SortedSet.prototype.indexOf = function (elem) {
        return this.data.indexOf(elem);
    };
    /** Iterates elements in order defined by "comparator" */
    SortedSet.prototype.forEach = function (cb) {
        this.data.inorderTraversal(function (k, v) {
            cb(k);
            return false;
        });
    };
    /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */
    SortedSet.prototype.forEachInRange = function (range, cb) {
        var iter = this.data.getIteratorFrom(range[0]);
        while (iter.hasNext()) {
            var elem = iter.getNext();
            if (this.comparator(elem.key, range[1]) >= 0)
                return;
            cb(elem.key);
        }
    };
    /**
     * Iterates over `elem`s such that: start <= elem until false is returned.
     */
    SortedSet.prototype.forEachWhile = function (cb, start) {
        var iter;
        if (start !== undefined) {
            iter = this.data.getIteratorFrom(start);
        }
        else {
            iter = this.data.getIterator();
        }
        while (iter.hasNext()) {
            var elem = iter.getNext();
            var result = cb(elem.key);
            if (!result)
                return;
        }
    };
    /** Finds the least element greater than or equal to `elem`. */
    SortedSet.prototype.firstAfterOrEqual = function (elem) {
        var iter = this.data.getIteratorFrom(elem);
        return iter.hasNext() ? iter.getNext().key : null;
    };
    SortedSet.prototype.getIterator = function () {
        return new SortedSetIterator(this.data.getIterator());
    };
    SortedSet.prototype.getIteratorFrom = function (key) {
        return new SortedSetIterator(this.data.getIteratorFrom(key));
    };
    /** Inserts or updates an element */
    SortedSet.prototype.add = function (elem) {
        return this.copy(this.data.remove(elem).insert(elem, true));
    };
    /** Deletes an element */
    SortedSet.prototype.delete = function (elem) {
        if (!this.has(elem))
            return this;
        return this.copy(this.data.remove(elem));
    };
    SortedSet.prototype.isEmpty = function () {
        return this.data.isEmpty();
    };
    SortedSet.prototype.unionWith = function (other) {
        var result = this;
        other.forEach(function (elem) {
            result = result.add(elem);
        });
        return result;
    };
    SortedSet.prototype.isEqual = function (other) {
        if (!(other instanceof SortedSet))
            return false;
        if (this.size !== other.size)
            return false;
        var thisIt = this.data.getIterator();
        var otherIt = other.data.getIterator();
        while (thisIt.hasNext()) {
            var thisElem = thisIt.getNext().key;
            var otherElem = otherIt.getNext().key;
            if (this.comparator(thisElem, otherElem) !== 0)
                return false;
        }
        return true;
    };
    SortedSet.prototype.toArray = function () {
        var res = [];
        this.forEach(function (targetId) {
            res.push(targetId);
        });
        return res;
    };
    SortedSet.prototype.toString = function () {
        var result = [];
        this.forEach(function (elem) { return result.push(elem); });
        return 'SortedSet(' + result.toString() + ')';
    };
    SortedSet.prototype.copy = function (data) {
        var result = new SortedSet(this.comparator);
        result.data = data;
        return result;
    };
    return SortedSet;
}());
var SortedSetIterator = /** @class */ (function () {
    function SortedSetIterator(iter) {
        this.iter = iter;
    }
    SortedSetIterator.prototype.getNext = function () {
        return this.iter.getNext().key;
    };
    SortedSetIterator.prototype.hasNext = function () {
        return this.iter.hasNext();
    };
    return SortedSetIterator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */
var FieldMask = /** @class */ (function () {
    function FieldMask(fields) {
        this.fields = fields;
        // TODO(dimond): validation of FieldMask
    }
    FieldMask.fromSet = function (fields) {
        return new FieldMask(fields);
    };
    FieldMask.fromArray = function (fields) {
        var fieldsAsSet = new SortedSet(FieldPath.comparator);
        fields.forEach(function (fieldPath) { return (fieldsAsSet = fieldsAsSet.add(fieldPath)); });
        return new FieldMask(fieldsAsSet);
    };
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */
    FieldMask.prototype.covers = function (fieldPath) {
        var found = false;
        this.fields.forEach(function (fieldMaskPath) {
            if (fieldMaskPath.isPrefixOf(fieldPath)) {
                found = true;
            }
        });
        return found;
    };
    FieldMask.prototype.isEqual = function (other) {
        return this.fields.isEqual(other.fields);
    };
    return FieldMask;
}());
/** A field path and the TransformOperation to perform upon it. */
var FieldTransform = /** @class */ (function () {
    function FieldTransform(field, transform) {
        this.field = field;
        this.transform = transform;
    }
    FieldTransform.prototype.isEqual = function (other) {
        return (this.field.isEqual(other.field) && this.transform.isEqual(other.transform));
    };
    return FieldTransform;
}());
/** The result of successfully applying a mutation to the backend. */
var MutationResult = /** @class */ (function () {
    function MutationResult(
    /**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */
    version, 
    /**
     * The resulting fields returned from the backend after a
     * TransformMutation has been committed. Contains one FieldValue for each
     * FieldTransform that was in the mutation.
     *
     * Will be null if the mutation was not a TransformMutation.
     */
    transformResults) {
        this.version = version;
        this.transformResults = transformResults;
    }
    return MutationResult;
}());
var MutationType;
(function (MutationType) {
    MutationType[MutationType["Set"] = 0] = "Set";
    MutationType[MutationType["Patch"] = 1] = "Patch";
    MutationType[MutationType["Transform"] = 2] = "Transform";
    MutationType[MutationType["Delete"] = 3] = "Delete";
})(MutationType || (MutationType = {}));
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */
var Precondition = /** @class */ (function () {
    function Precondition(updateTime, exists) {
        this.updateTime = updateTime;
        this.exists = exists;
        assert(updateTime === undefined || exists === undefined, 'Precondition can specify "exists" or "updateTime" but not both');
    }
    /** Creates a new Precondition with an exists flag. */
    Precondition.exists = function (exists) {
        return new Precondition(undefined, exists);
    };
    /** Creates a new Precondition based on a version a document exists at. */
    Precondition.updateTime = function (version) {
        return new Precondition(version);
    };
    Object.defineProperty(Precondition.prototype, "isNone", {
        /** Returns whether this Precondition is empty. */
        get: function () {
            return this.updateTime === undefined && this.exists === undefined;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns true if the preconditions is valid for the given document
     * (or null if no document is available).
     */
    Precondition.prototype.isValidFor = function (maybeDoc) {
        if (this.updateTime !== undefined) {
            return (maybeDoc instanceof Document &&
                maybeDoc.version.isEqual(this.updateTime));
        }
        else if (this.exists !== undefined) {
            return this.exists === maybeDoc instanceof Document;
        }
        else {
            assert(this.isNone, 'Precondition should be empty');
            return true;
        }
    };
    Precondition.prototype.isEqual = function (other) {
        return (equals(this.updateTime, other.updateTime) &&
            this.exists === other.exists);
    };
    Precondition.NONE = new Precondition();
    return Precondition;
}());
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also it version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set, Patch, and Transform mutations. For Delete
 * mutations, we reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        null                  Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      null                  null
 * TransformMutation  Document(v3)          Document(v3)
 * TransformMutation  NoDocument(v3)        NoDocument(v3)
 * TransformMutation  null                  null
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     null                  NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set, Patch, and Transform mutations. As deletes
 * have no explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we return an `UnknownDocument` and rely on Watch to send us the
 * updated version.
 *
 * Note that TransformMutations don't create Documents (in the case of being
 * applied to a NoDocument), even though they would on the backend. This is
 * because the client always combines the TransformMutation with a SetMutation
 * or PatchMutation and we only want to apply the transform if the prior
 * mutation resulted in a Document (always true for a SetMutation, but not
 * necessarily for a PatchMutation).
 *
 * ## Subclassing Notes
 *
 * Subclasses of Mutation need to implement applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document.
 */
var Mutation = /** @class */ (function () {
    function Mutation() {
    }
    Mutation.prototype.verifyKeyMatches = function (maybeDoc) {
        if (maybeDoc != null) {
            assert(maybeDoc.key.isEqual(this.key), 'Can only apply a mutation to a document with the same key');
        }
    };
    /**
     * Returns the version from the given document for use as the result of a
     * mutation. Mutations are defined to return the version of the base document
     * only if it is an existing document. Deleted and unknown documents have a
     * post-mutation version of SnapshotVersion.MIN.
     */
    Mutation.getPostMutationVersion = function (maybeDoc) {
        if (maybeDoc instanceof Document) {
            return maybeDoc.version;
        }
        else {
            return SnapshotVersion.MIN;
        }
    };
    return Mutation;
}());
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */
var SetMutation = /** @class */ (function (_super) {
    tslib_1.__extends(SetMutation, _super);
    function SetMutation(key, value, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.value = value;
        _this.precondition = precondition;
        _this.type = MutationType.Set;
        return _this;
    }
    SetMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by SetMutation.');
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        var version = mutationResult.version;
        return new Document(this.key, version, this.value, {
            hasCommittedMutations: true
        });
    };
    SetMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var version = Mutation.getPostMutationVersion(maybeDoc);
        return new Document(this.key, version, this.value, {
            hasLocalMutations: true
        });
    };
    SetMutation.prototype.isEqual = function (other) {
        return (other instanceof SetMutation &&
            this.key.isEqual(other.key) &&
            this.value.isEqual(other.value) &&
            this.precondition.isEqual(other.precondition));
    };
    return SetMutation;
}(Mutation));
/**
 * A mutation that modifies fields of the document at the given key with the
 * given values. The values are applied through a field mask:
 *
 *  * When a field is in both the mask and the values, the corresponding field
 *    is updated.
 *  * When a field is in neither the mask nor the values, the corresponding
 *    field is unmodified.
 *  * When a field is in the mask but not in the values, the corresponding field
 *    is deleted.
 *  * When a field is not in the mask but is in the values, the values map is
 *    ignored.
 */
var PatchMutation = /** @class */ (function (_super) {
    tslib_1.__extends(PatchMutation, _super);
    function PatchMutation(key, data, fieldMask, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.data = data;
        _this.fieldMask = fieldMask;
        _this.precondition = precondition;
        _this.type = MutationType.Patch;
        return _this;
    }
    PatchMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by PatchMutation.');
        if (!this.precondition.isValidFor(maybeDoc)) {
            // Since the mutation was not rejected, we know that the  precondition
            // matched on the backend. We therefore must not have the expected version
            // of the document in our cache and return an UnknownDocument with the
            // known updateTime.
            return new UnknownDocument(this.key, mutationResult.version);
        }
        var newData = this.patchDocument(maybeDoc);
        return new Document(this.key, mutationResult.version, newData, {
            hasCommittedMutations: true
        });
    };
    PatchMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var version = Mutation.getPostMutationVersion(maybeDoc);
        var newData = this.patchDocument(maybeDoc);
        return new Document(this.key, version, newData, {
            hasLocalMutations: true
        });
    };
    PatchMutation.prototype.isEqual = function (other) {
        return (other instanceof PatchMutation &&
            this.key.isEqual(other.key) &&
            this.fieldMask.isEqual(other.fieldMask) &&
            this.precondition.isEqual(other.precondition));
    };
    /**
     * Patches the data of document if available or creates a new document. Note
     * that this does not check whether or not the precondition of this patch
     * holds.
     */
    PatchMutation.prototype.patchDocument = function (maybeDoc) {
        var data;
        if (maybeDoc instanceof Document) {
            data = maybeDoc.data;
        }
        else {
            data = ObjectValue.EMPTY;
        }
        return this.patchObject(data);
    };
    PatchMutation.prototype.patchObject = function (data) {
        var _this = this;
        this.fieldMask.fields.forEach(function (fieldPath) {
            if (!fieldPath.isEmpty()) {
                var newValue = _this.data.field(fieldPath);
                if (newValue !== undefined) {
                    data = data.set(fieldPath, newValue);
                }
                else {
                    data = data.delete(fieldPath);
                }
            }
        });
        return data;
    };
    return PatchMutation;
}(Mutation));
/**
 * A mutation that modifies specific fields of the document with transform
 * operations. Currently the only supported transform is a server timestamp, but
 * IP Address, increment(n), etc. could be supported in the future.
 *
 * It is somewhat similar to a PatchMutation in that it patches specific fields
 * and has no effect when applied to a null or NoDocument (see comment on
 * Mutation for rationale).
 */
var TransformMutation = /** @class */ (function (_super) {
    tslib_1.__extends(TransformMutation, _super);
    function TransformMutation(key, fieldTransforms) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.fieldTransforms = fieldTransforms;
        _this.type = MutationType.Transform;
        // NOTE: We set a precondition of exists: true as a safety-check, since we
        // always combine TransformMutations with a SetMutation or PatchMutation which
        // (if successful) should end up with an existing document.
        _this.precondition = Precondition.exists(true);
        return _this;
    }
    TransformMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults != null, 'Transform results missing for TransformMutation.');
        if (!this.precondition.isValidFor(maybeDoc)) {
            // Since the mutation was not rejected, we know that the  precondition
            // matched on the backend. We therefore must not have the expected version
            // of the document in our cache and return an UnknownDocument with the
            // known updateTime.
            return new UnknownDocument(this.key, mutationResult.version);
        }
        var doc = this.requireDocument(maybeDoc);
        var transformResults = this.serverTransformResults(maybeDoc, mutationResult.transformResults);
        var version = mutationResult.version;
        var newData = this.transformObject(doc.data, transformResults);
        return new Document(this.key, version, newData, {
            hasCommittedMutations: true
        });
    };
    TransformMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var doc = this.requireDocument(maybeDoc);
        var transformResults = this.localTransformResults(localWriteTime, baseDoc);
        var newData = this.transformObject(doc.data, transformResults);
        return new Document(this.key, doc.version, newData, {
            hasLocalMutations: true
        });
    };
    TransformMutation.prototype.isEqual = function (other) {
        return (other instanceof TransformMutation &&
            this.key.isEqual(other.key) &&
            arrayEquals(this.fieldTransforms, other.fieldTransforms) &&
            this.precondition.isEqual(other.precondition));
    };
    /**
     * Asserts that the given MaybeDocument is actually a Document and verifies
     * that it matches the key for this mutation. Since we only support
     * transformations with precondition exists this method is guaranteed to be
     * safe.
     */
    TransformMutation.prototype.requireDocument = function (maybeDoc) {
        assert(maybeDoc instanceof Document, 'Unknown MaybeDocument type ' + maybeDoc);
        var doc = maybeDoc;
        assert(doc.key.isEqual(this.key), 'Can only transform a document with the same key');
        return doc;
    };
    /**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use after a
     * TransformMutation has been acknowledged by the server.
     *
     * @param baseDoc The document prior to applying this mutation batch.
     * @param serverTransformResults The transform results received by the server.
     * @return The transform results list.
     */
    TransformMutation.prototype.serverTransformResults = function (baseDoc, serverTransformResults) {
        var transformResults = [];
        assert(this.fieldTransforms.length === serverTransformResults.length, "server transform result count (" + serverTransformResults.length + ") " +
            ("should match field transform count (" + this.fieldTransforms.length + ")"));
        for (var i = 0; i < serverTransformResults.length; i++) {
            var fieldTransform = this.fieldTransforms[i];
            var transform = fieldTransform.transform;
            var previousValue = null;
            if (baseDoc instanceof Document) {
                previousValue = baseDoc.field(fieldTransform.field) || null;
            }
            transformResults.push(transform.applyToRemoteDocument(previousValue, serverTransformResults[i]));
        }
        return transformResults;
    };
    /**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use when applying a
     * TransformMutation locally.
     *
     * @param localWriteTime The local time of the transform mutation (used to
     *     generate ServerTimestampValues).
     * @param baseDoc The document prior to applying this mutation batch.
     * @return The transform results list.
     */
    TransformMutation.prototype.localTransformResults = function (localWriteTime, baseDoc) {
        var transformResults = [];
        for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
            var fieldTransform = _a[_i];
            var transform = fieldTransform.transform;
            var previousValue = null;
            if (baseDoc instanceof Document) {
                previousValue = baseDoc.field(fieldTransform.field) || null;
            }
            transformResults.push(transform.applyToLocalView(previousValue, localWriteTime));
        }
        return transformResults;
    };
    TransformMutation.prototype.transformObject = function (data, transformResults) {
        assert(transformResults.length === this.fieldTransforms.length, 'TransformResults length mismatch.');
        for (var i = 0; i < this.fieldTransforms.length; i++) {
            var fieldTransform = this.fieldTransforms[i];
            var fieldPath = fieldTransform.field;
            data = data.set(fieldPath, transformResults[i]);
        }
        return data;
    };
    return TransformMutation;
}(Mutation));
/** A mutation that deletes the document at the given key. */
var DeleteMutation = /** @class */ (function (_super) {
    tslib_1.__extends(DeleteMutation, _super);
    function DeleteMutation(key, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.precondition = precondition;
        _this.type = MutationType.Delete;
        return _this;
    }
    DeleteMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by DeleteMutation.');
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        return new NoDocument(this.key, mutationResult.version, {
            hasCommittedMutations: true
        });
    };
    DeleteMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(this.key), 'Can only apply mutation to document with same key');
        }
        return new NoDocument(this.key, SnapshotVersion.forDeletedDoc());
    };
    DeleteMutation.prototype.isEqual = function (other) {
        return (other instanceof DeleteMutation &&
            this.key.isEqual(other.key) &&
            this.precondition.isEqual(other.precondition));
    };
    return DeleteMutation;
}(Mutation));

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Transforms a value into a server-generated timestamp. */
var ServerTimestampTransform = /** @class */ (function () {
    function ServerTimestampTransform() {
    }
    ServerTimestampTransform.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return new ServerTimestampValue(localWriteTime, previousValue);
    };
    ServerTimestampTransform.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        return transformResult;
    };
    ServerTimestampTransform.prototype.isEqual = function (other) {
        return other instanceof ServerTimestampTransform;
    };
    ServerTimestampTransform.instance = new ServerTimestampTransform();
    return ServerTimestampTransform;
}());
/** Transforms an array value via a union operation. */
var ArrayUnionTransformOperation = /** @class */ (function () {
    function ArrayUnionTransformOperation(elements) {
        this.elements = elements;
    }
    ArrayUnionTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return this.apply(previousValue);
    };
    ArrayUnionTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        // The server just sends null as the transform result for array operations,
        // so we have to calculate a result the same as we do for local
        // applications.
        return this.apply(previousValue);
    };
    ArrayUnionTransformOperation.prototype.apply = function (previousValue) {
        var result = coercedFieldValuesArray(previousValue);
        var _loop_1 = function (toUnion) {
            if (!result.find(function (element) { return element.isEqual(toUnion); })) {
                result.push(toUnion);
            }
        };
        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
            var toUnion = _a[_i];
            _loop_1(toUnion);
        }
        return new ArrayValue(result);
    };
    ArrayUnionTransformOperation.prototype.isEqual = function (other) {
        return (other instanceof ArrayUnionTransformOperation &&
            arrayEquals(other.elements, this.elements));
    };
    return ArrayUnionTransformOperation;
}());
/** Transforms an array value via a remove operation. */
var ArrayRemoveTransformOperation = /** @class */ (function () {
    function ArrayRemoveTransformOperation(elements) {
        this.elements = elements;
    }
    ArrayRemoveTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return this.apply(previousValue);
    };
    ArrayRemoveTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        // The server just sends null as the transform result for array operations,
        // so we have to calculate a result the same as we do for local
        // applications.
        return this.apply(previousValue);
    };
    ArrayRemoveTransformOperation.prototype.apply = function (previousValue) {
        var result = coercedFieldValuesArray(previousValue);
        var _loop_2 = function (toRemove) {
            result = result.filter(function (element) { return !element.isEqual(toRemove); });
        };
        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
            var toRemove = _a[_i];
            _loop_2(toRemove);
        }
        return new ArrayValue(result);
    };
    ArrayRemoveTransformOperation.prototype.isEqual = function (other) {
        return (other instanceof ArrayRemoveTransformOperation &&
            arrayEquals(other.elements, this.elements));
    };
    return ArrayRemoveTransformOperation;
}());
function coercedFieldValuesArray(value) {
    if (value instanceof ArrayValue) {
        return value.internalValue.slice();
    }
    else {
        // coerce to empty array.
        return [];
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ExistenceFilter = /** @class */ (function () {
    // TODO(b/33078163): just use simplest form of existence filter for now
    function ExistenceFilter(count) {
        this.count = count;
    }
    ExistenceFilter.prototype.isEqual = function (other) {
        return other && other.count === this.count;
    };
    return ExistenceFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers.
 */
var RpcCode;
(function (RpcCode) {
    RpcCode[RpcCode["OK"] = 0] = "OK";
    RpcCode[RpcCode["CANCELLED"] = 1] = "CANCELLED";
    RpcCode[RpcCode["UNKNOWN"] = 2] = "UNKNOWN";
    RpcCode[RpcCode["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
    RpcCode[RpcCode["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
    RpcCode[RpcCode["NOT_FOUND"] = 5] = "NOT_FOUND";
    RpcCode[RpcCode["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
    RpcCode[RpcCode["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
    RpcCode[RpcCode["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
    RpcCode[RpcCode["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
    RpcCode[RpcCode["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
    RpcCode[RpcCode["ABORTED"] = 10] = "ABORTED";
    RpcCode[RpcCode["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
    RpcCode[RpcCode["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
    RpcCode[RpcCode["INTERNAL"] = 13] = "INTERNAL";
    RpcCode[RpcCode["UNAVAILABLE"] = 14] = "UNAVAILABLE";
    RpcCode[RpcCode["DATA_LOSS"] = 15] = "DATA_LOSS";
})(RpcCode || (RpcCode = {}));
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */
function isPermanentError(code) {
    switch (code) {
        case Code.OK:
            return fail('Treated status OK as error');
        case Code.CANCELLED:
        case Code.UNKNOWN:
        case Code.DEADLINE_EXCEEDED:
        case Code.RESOURCE_EXHAUSTED:
        case Code.INTERNAL:
        case Code.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case Code.UNAUTHENTICATED:
            return false;
        case Code.INVALID_ARGUMENT:
        case Code.NOT_FOUND:
        case Code.ALREADY_EXISTS:
        case Code.PERMISSION_DENIED:
        case Code.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case Code.ABORTED:
        case Code.OUT_OF_RANGE:
        case Code.UNIMPLEMENTED:
        case Code.DATA_LOSS:
            return true;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */
function isPermanentWriteError(code) {
    return isPermanentError(code) && code !== Code.ABORTED;
}
/**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */
function mapCodeFromRpcStatus(status) {
    // tslint:disable-next-line:no-any lookup by string
    var code = RpcCode[status];
    if (code === undefined) {
        return undefined;
    }
    return mapCodeFromRpcCode(code);
}
/**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */
function mapCodeFromRpcCode(code) {
    if (code === undefined) {
        // This shouldn't normally happen, but in certain error cases (like trying
        // to send invalid proto messages) we may get an error with no GRPC code.
        error('GRPC error has no .code');
        return Code.UNKNOWN;
    }
    switch (code) {
        case RpcCode.OK:
            return Code.OK;
        case RpcCode.CANCELLED:
            return Code.CANCELLED;
        case RpcCode.UNKNOWN:
            return Code.UNKNOWN;
        case RpcCode.DEADLINE_EXCEEDED:
            return Code.DEADLINE_EXCEEDED;
        case RpcCode.RESOURCE_EXHAUSTED:
            return Code.RESOURCE_EXHAUSTED;
        case RpcCode.INTERNAL:
            return Code.INTERNAL;
        case RpcCode.UNAVAILABLE:
            return Code.UNAVAILABLE;
        case RpcCode.UNAUTHENTICATED:
            return Code.UNAUTHENTICATED;
        case RpcCode.INVALID_ARGUMENT:
            return Code.INVALID_ARGUMENT;
        case RpcCode.NOT_FOUND:
            return Code.NOT_FOUND;
        case RpcCode.ALREADY_EXISTS:
            return Code.ALREADY_EXISTS;
        case RpcCode.PERMISSION_DENIED:
            return Code.PERMISSION_DENIED;
        case RpcCode.FAILED_PRECONDITION:
            return Code.FAILED_PRECONDITION;
        case RpcCode.ABORTED:
            return Code.ABORTED;
        case RpcCode.OUT_OF_RANGE:
            return Code.OUT_OF_RANGE;
        case RpcCode.UNIMPLEMENTED:
            return Code.UNIMPLEMENTED;
        case RpcCode.DATA_LOSS:
            return Code.DATA_LOSS;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Maps an RPC code from a Code. This is the reverse operation from
 * mapCodeFromRpcCode and should really only be used in tests.
 */
function mapRpcCodeFromCode(code) {
    if (code === undefined) {
        return RpcCode.OK;
    }
    switch (code) {
        case Code.OK:
            return RpcCode.OK;
        case Code.CANCELLED:
            return RpcCode.CANCELLED;
        case Code.UNKNOWN:
            return RpcCode.UNKNOWN;
        case Code.DEADLINE_EXCEEDED:
            return RpcCode.DEADLINE_EXCEEDED;
        case Code.RESOURCE_EXHAUSTED:
            return RpcCode.RESOURCE_EXHAUSTED;
        case Code.INTERNAL:
            return RpcCode.INTERNAL;
        case Code.UNAVAILABLE:
            return RpcCode.UNAVAILABLE;
        case Code.UNAUTHENTICATED:
            return RpcCode.UNAUTHENTICATED;
        case Code.INVALID_ARGUMENT:
            return RpcCode.INVALID_ARGUMENT;
        case Code.NOT_FOUND:
            return RpcCode.NOT_FOUND;
        case Code.ALREADY_EXISTS:
            return RpcCode.ALREADY_EXISTS;
        case Code.PERMISSION_DENIED:
            return RpcCode.PERMISSION_DENIED;
        case Code.FAILED_PRECONDITION:
            return RpcCode.FAILED_PRECONDITION;
        case Code.ABORTED:
            return RpcCode.ABORTED;
        case Code.OUT_OF_RANGE:
            return RpcCode.OUT_OF_RANGE;
        case Code.UNIMPLEMENTED:
            return RpcCode.UNIMPLEMENTED;
        case Code.DATA_LOSS:
            return RpcCode.DATA_LOSS;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Converts an HTTP Status Code to the equivalent error code.
 *
 * @param status An HTTP Status Code, like 200, 404, 503, etc.
 * @returns The equivalent Code. Unknown status codes are mapped to
 *     Code.UNKNOWN.
 */
function mapCodeFromHttpStatus(status) {
    // The canonical error codes for Google APIs [1] specify mapping onto HTTP
    // status codes but the mapping is not bijective. In each case of ambiguity
    // this function chooses a primary error.
    //
    // [1]
    // https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
    switch (status) {
        case 200: // OK
            return Code.OK;
        case 400: // Bad Request
            return Code.INVALID_ARGUMENT;
        // Other possibilities based on the forward mapping
        // return Code.FAILED_PRECONDITION;
        // return Code.OUT_OF_RANGE;
        case 401: // Unauthorized
            return Code.UNAUTHENTICATED;
        case 403: // Forbidden
            return Code.PERMISSION_DENIED;
        case 404: // Not Found
            return Code.NOT_FOUND;
        case 409: // Conflict
            return Code.ABORTED;
        // Other possibilities:
        // return Code.ALREADY_EXISTS;
        case 416: // Range Not Satisfiable
            return Code.OUT_OF_RANGE;
        case 429: // Too Many Requests
            return Code.RESOURCE_EXHAUSTED;
        case 499: // Client Closed Request
            return Code.CANCELLED;
        case 500: // Internal Server Error
            return Code.UNKNOWN;
        // Other possibilities:
        // return Code.INTERNAL;
        // return Code.DATA_LOSS;
        case 501: // Unimplemented
            return Code.UNIMPLEMENTED;
        case 503: // Service Unavailable
            return Code.UNAVAILABLE;
        case 504: // Gateway Timeout
            return Code.DEADLINE_EXCEEDED;
        default:
            if (status >= 200 && status < 300)
                return Code.OK;
            if (status >= 400 && status < 500)
                return Code.FAILED_PRECONDITION;
            if (status >= 500 && status < 600)
                return Code.INTERNAL;
            return Code.UNKNOWN;
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var EMPTY_MAYBE_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
function maybeDocumentMap() {
    return EMPTY_MAYBE_DOCUMENT_MAP;
}
function nullableMaybeDocumentMap() {
    return maybeDocumentMap();
}
var EMPTY_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
function documentMap() {
    return EMPTY_DOCUMENT_MAP;
}
var EMPTY_DOCUMENT_VERSION_MAP = new SortedMap(DocumentKey.comparator);
function documentVersionMap() {
    return EMPTY_DOCUMENT_VERSION_MAP;
}
var EMPTY_DOCUMENT_KEY_SET = new SortedSet(DocumentKey.comparator);
function documentKeySet() {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    var set = EMPTY_DOCUMENT_KEY_SET;
    for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
        var key = keys_1[_a];
        set = set.add(key);
    }
    return set;
}
var EMPTY_TARGET_ID_SET = new SortedSet(primitiveComparator);
function targetIdSet() {
    return EMPTY_TARGET_ID_SET;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */
var DocumentSet = /** @class */ (function () {
    /** The default ordering is by key if the comparator is omitted */
    function DocumentSet(comp) {
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        if (comp) {
            this.comparator = function (d1, d2) {
                return comp(d1, d2) || DocumentKey.comparator(d1.key, d2.key);
            };
        }
        else {
            this.comparator = function (d1, d2) {
                return DocumentKey.comparator(d1.key, d2.key);
            };
        }
        this.keyedMap = documentMap();
        this.sortedSet = new SortedMap(this.comparator);
    }
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */
    DocumentSet.emptySet = function (oldSet) {
        return new DocumentSet(oldSet.comparator);
    };
    DocumentSet.prototype.has = function (key) {
        return this.keyedMap.get(key) != null;
    };
    DocumentSet.prototype.get = function (key) {
        return this.keyedMap.get(key);
    };
    DocumentSet.prototype.first = function () {
        return this.sortedSet.minKey();
    };
    DocumentSet.prototype.last = function () {
        return this.sortedSet.maxKey();
    };
    DocumentSet.prototype.isEmpty = function () {
        return this.sortedSet.isEmpty();
    };
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */
    DocumentSet.prototype.indexOf = function (key) {
        var doc = this.keyedMap.get(key);
        return doc ? this.sortedSet.indexOf(doc) : -1;
    };
    Object.defineProperty(DocumentSet.prototype, "size", {
        get: function () {
            return this.sortedSet.size;
        },
        enumerable: true,
        configurable: true
    });
    /** Iterates documents in order defined by "comparator" */
    DocumentSet.prototype.forEach = function (cb) {
        this.sortedSet.inorderTraversal(function (k, v) {
            cb(k);
            return false;
        });
    };
    /** Inserts or updates a document with the same key */
    DocumentSet.prototype.add = function (doc) {
        // First remove the element if we have it.
        var set = this.delete(doc.key);
        return set.copy(set.keyedMap.insert(doc.key, doc), set.sortedSet.insert(doc, null));
    };
    /** Deletes a document with a given key */
    DocumentSet.prototype.delete = function (key) {
        var doc = this.get(key);
        if (!doc) {
            return this;
        }
        return this.copy(this.keyedMap.remove(key), this.sortedSet.remove(doc));
    };
    DocumentSet.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentSet))
            return false;
        if (this.size !== other.size)
            return false;
        var thisIt = this.sortedSet.getIterator();
        var otherIt = other.sortedSet.getIterator();
        while (thisIt.hasNext()) {
            var thisDoc = thisIt.getNext().key;
            var otherDoc = otherIt.getNext().key;
            if (!thisDoc.isEqual(otherDoc))
                return false;
        }
        return true;
    };
    DocumentSet.prototype.toString = function () {
        var docStrings = [];
        this.forEach(function (doc) {
            docStrings.push(doc.toString());
        });
        if (docStrings.length === 0) {
            return 'DocumentSet ()';
        }
        else {
            return 'DocumentSet (\n  ' + docStrings.join('  \n') + '\n)';
        }
    };
    DocumentSet.prototype.copy = function (keyedMap, sortedSet) {
        var newSet = new DocumentSet();
        newSet.comparator = this.comparator;
        newSet.keyedMap = keyedMap;
        newSet.sortedSet = sortedSet;
        return newSet;
    };
    return DocumentSet;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ChangeType;
(function (ChangeType) {
    ChangeType[ChangeType["Added"] = 0] = "Added";
    ChangeType[ChangeType["Removed"] = 1] = "Removed";
    ChangeType[ChangeType["Modified"] = 2] = "Modified";
    ChangeType[ChangeType["Metadata"] = 3] = "Metadata";
})(ChangeType || (ChangeType = {}));
var SyncState;
(function (SyncState) {
    SyncState[SyncState["Local"] = 0] = "Local";
    SyncState[SyncState["Synced"] = 1] = "Synced";
})(SyncState || (SyncState = {}));
/**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */
var DocumentChangeSet = /** @class */ (function () {
    function DocumentChangeSet() {
        this.changeMap = new SortedMap(DocumentKey.comparator);
    }
    DocumentChangeSet.prototype.track = function (change) {
        var key = change.doc.key;
        var oldChange = this.changeMap.get(key);
        if (!oldChange) {
            this.changeMap = this.changeMap.insert(key, change);
            return;
        }
        // Merge the new change with the existing change.
        if (change.type !== ChangeType.Added &&
            oldChange.type === ChangeType.Metadata) {
            this.changeMap = this.changeMap.insert(key, change);
        }
        else if (change.type === ChangeType.Metadata &&
            oldChange.type !== ChangeType.Removed) {
            this.changeMap = this.changeMap.insert(key, {
                type: oldChange.type,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Modified &&
            oldChange.type === ChangeType.Modified) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Modified,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Modified &&
            oldChange.type === ChangeType.Added) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Added,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Removed &&
            oldChange.type === ChangeType.Added) {
            this.changeMap = this.changeMap.remove(key);
        }
        else if (change.type === ChangeType.Removed &&
            oldChange.type === ChangeType.Modified) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Removed,
                doc: oldChange.doc
            });
        }
        else if (change.type === ChangeType.Added &&
            oldChange.type === ChangeType.Removed) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Modified,
                doc: change.doc
            });
        }
        else {
            // This includes these cases, which don't make sense:
            // Added->Added
            // Removed->Removed
            // Modified->Added
            // Removed->Modified
            // Metadata->Added
            // Removed->Metadata
            fail('unsupported combination of changes: ' +
                JSON.stringify(change) +
                ' after ' +
                JSON.stringify(oldChange));
        }
    };
    DocumentChangeSet.prototype.getChanges = function () {
        var changes = [];
        this.changeMap.inorderTraversal(function (key, change) {
            changes.push(change);
        });
        return changes;
    };
    return DocumentChangeSet;
}());
var ViewSnapshot = /** @class */ (function () {
    function ViewSnapshot(query, docs, oldDocs, docChanges, mutatedKeys, fromCache, syncStateChanged, excludesMetadataChanges) {
        this.query = query;
        this.docs = docs;
        this.oldDocs = oldDocs;
        this.docChanges = docChanges;
        this.mutatedKeys = mutatedKeys;
        this.fromCache = fromCache;
        this.syncStateChanged = syncStateChanged;
        this.excludesMetadataChanges = excludesMetadataChanges;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */
    ViewSnapshot.fromInitialDocuments = function (query, documents, mutatedKeys, fromCache) {
        var changes = [];
        documents.forEach(function (doc) {
            changes.push({ type: ChangeType.Added, doc: doc });
        });
        return new ViewSnapshot(query, documents, DocumentSet.emptySet(documents), changes, mutatedKeys, fromCache, true, false);
    };
    Object.defineProperty(ViewSnapshot.prototype, "hasPendingWrites", {
        get: function () {
            return !this.mutatedKeys.isEmpty();
        },
        enumerable: true,
        configurable: true
    });
    ViewSnapshot.prototype.isEqual = function (other) {
        if (this.fromCache !== other.fromCache ||
            this.syncStateChanged !== other.syncStateChanged ||
            !this.mutatedKeys.isEqual(other.mutatedKeys) ||
            !this.query.isEqual(other.query) ||
            !this.docs.isEqual(other.docs) ||
            !this.oldDocs.isEqual(other.oldDocs)) {
            return false;
        }
        var changes = this.docChanges;
        var otherChanges = other.docChanges;
        if (changes.length !== otherChanges.length) {
            return false;
        }
        for (var i = 0; i < changes.length; i++) {
            if (changes[i].type !== otherChanges[i].type ||
                !changes[i].doc.isEqual(otherChanges[i].doc)) {
                return false;
            }
        }
        return true;
    };
    return ViewSnapshot;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */
var RemoteEvent = /** @class */ (function () {
    function RemoteEvent(
    /**
     * The snapshot version this event brings us up to, or MIN if not set.
     */
    snapshotVersion, 
    /**
     * A map from target to changes to the target. See TargetChange.
     */
    targetChanges, 
    /**
     * A set of targets that is known to be inconsistent. Listens for these
     * targets should be re-established without resume tokens.
     */
    targetMismatches, 
    /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */
    documentUpdates, 
    /**
     * A set of which document updates are due only to limbo resolution targets.
     */
    resolvedLimboDocuments) {
        this.snapshotVersion = snapshotVersion;
        this.targetChanges = targetChanges;
        this.targetMismatches = targetMismatches;
        this.documentUpdates = documentUpdates;
        this.resolvedLimboDocuments = resolvedLimboDocuments;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */
    // PORTING NOTE: Multi-tab only
    RemoteEvent.createSynthesizedRemoteEventForCurrentChange = function (targetId, current) {
        var targetChanges = (_a = {}, _a[targetId] = TargetChange.createSynthesizedTargetChangeForCurrentChange(targetId, current), _a);
        return new RemoteEvent(SnapshotVersion.MIN, targetChanges, targetIdSet(), maybeDocumentMap(), documentKeySet());
        var _a;
    };
    return RemoteEvent;
}());
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */
var TargetChange = /** @class */ (function () {
    function TargetChange(
    /**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */
    resumeToken, 
    /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */
    current, 
    /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */
    addedDocuments, 
    /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */
    modifiedDocuments, 
    /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */
    removedDocuments) {
        this.resumeToken = resumeToken;
        this.current = current;
        this.addedDocuments = addedDocuments;
        this.modifiedDocuments = modifiedDocuments;
        this.removedDocuments = removedDocuments;
    }
    /**
     * HACK: Views require TargetChanges in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized TargetChanges that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */
    // PORTING NOTE: Multi-tab only
    TargetChange.createSynthesizedTargetChangeForCurrentChange = function (targetId, current) {
        return new TargetChange(emptyByteString(), current, documentKeySet(), documentKeySet(), documentKeySet());
    };
    return TargetChange;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */
var DocumentWatchChange = /** @class */ (function () {
    function DocumentWatchChange(
    /** The new document applies to all of these targets. */
    updatedTargetIds, 
    /** The new document is removed from all of these targets. */
    removedTargetIds, 
    /** The key of the document for this change. */
    key, 
    /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */
    newDoc) {
        this.updatedTargetIds = updatedTargetIds;
        this.removedTargetIds = removedTargetIds;
        this.key = key;
        this.newDoc = newDoc;
    }
    return DocumentWatchChange;
}());
var ExistenceFilterChange = /** @class */ (function () {
    function ExistenceFilterChange(targetId, existenceFilter) {
        this.targetId = targetId;
        this.existenceFilter = existenceFilter;
    }
    return ExistenceFilterChange;
}());
var WatchTargetChangeState;
(function (WatchTargetChangeState) {
    WatchTargetChangeState[WatchTargetChangeState["NoChange"] = 0] = "NoChange";
    WatchTargetChangeState[WatchTargetChangeState["Added"] = 1] = "Added";
    WatchTargetChangeState[WatchTargetChangeState["Removed"] = 2] = "Removed";
    WatchTargetChangeState[WatchTargetChangeState["Current"] = 3] = "Current";
    WatchTargetChangeState[WatchTargetChangeState["Reset"] = 4] = "Reset";
})(WatchTargetChangeState || (WatchTargetChangeState = {}));
var WatchTargetChange = /** @class */ (function () {
    function WatchTargetChange(
    /** What kind of change occurred to the watch target. */
    state, 
    /** The target IDs that were added/removed/set. */
    targetIds, 
    /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the query. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */
    resumeToken, 
    /** An RPC error indicating why the watch failed. */
    cause) {
        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
        if (cause === void 0) { cause = null; }
        this.state = state;
        this.targetIds = targetIds;
        this.resumeToken = resumeToken;
        this.cause = cause;
    }
    return WatchTargetChange;
}());
/** Tracks the internal state of a Watch target. */
var TargetState = /** @class */ (function () {
    function TargetState() {
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */
        this.pendingResponses = 0;
        /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */
        this.documentChanges = snapshotChangesMap();
        /** See public getters for explanations of these fields. */
        this._resumeToken = emptyByteString();
        this._current = false;
        /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */
        this._hasPendingChanges = true;
    }
    Object.defineProperty(TargetState.prototype, "current", {
        /**
         * Whether this target has been marked 'current'.
         *
         * 'Current' has special meaning in the RPC protocol: It implies that the
         * Watch backend has sent us all changes up to the point at which the target
         * was added and that the target is consistent with the rest of the watch
         * stream.
         */
        get: function () {
            return this._current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "resumeToken", {
        /** The last resume token sent to us for this target. */
        get: function () {
            return this._resumeToken;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "isPending", {
        /** Whether this target has pending target adds or target removes. */
        get: function () {
            return this.pendingResponses !== 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "hasPendingChanges", {
        /** Whether we have modified any state that should trigger a snapshot. */
        get: function () {
            return this._hasPendingChanges;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */
    TargetState.prototype.updateResumeToken = function (resumeToken) {
        if (resumeToken.length > 0) {
            this._hasPendingChanges = true;
            this._resumeToken = resumeToken;
        }
    };
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */
    TargetState.prototype.toTargetChange = function () {
        var addedDocuments = documentKeySet();
        var modifiedDocuments = documentKeySet();
        var removedDocuments = documentKeySet();
        this.documentChanges.forEach(function (key, changeType) {
            switch (changeType) {
                case ChangeType.Added:
                    addedDocuments = addedDocuments.add(key);
                    break;
                case ChangeType.Modified:
                    modifiedDocuments = modifiedDocuments.add(key);
                    break;
                case ChangeType.Removed:
                    removedDocuments = removedDocuments.add(key);
                    break;
                default:
                    fail('Encountered invalid change type: ' + changeType);
            }
        });
        return new TargetChange(this._resumeToken, this._current, addedDocuments, modifiedDocuments, removedDocuments);
    };
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */
    TargetState.prototype.clearPendingChanges = function () {
        this._hasPendingChanges = false;
        this.documentChanges = snapshotChangesMap();
    };
    TargetState.prototype.addDocumentChange = function (key, changeType) {
        this._hasPendingChanges = true;
        this.documentChanges = this.documentChanges.insert(key, changeType);
    };
    TargetState.prototype.removeDocumentChange = function (key) {
        this._hasPendingChanges = true;
        this.documentChanges = this.documentChanges.remove(key);
    };
    TargetState.prototype.recordPendingTargetRequest = function () {
        this.pendingResponses += 1;
    };
    TargetState.prototype.recordTargetResponse = function () {
        this.pendingResponses -= 1;
    };
    TargetState.prototype.markCurrent = function () {
        this._hasPendingChanges = true;
        this._current = true;
    };
    return TargetState;
}());
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */
var WatchChangeAggregator = /** @class */ (function () {
    function WatchChangeAggregator(metadataProvider) {
        this.metadataProvider = metadataProvider;
        /** The internal state of all tracked targets. */
        this.targetStates = {};
        /** Keeps track of the documents to update since the last raised snapshot. */
        this.pendingDocumentUpdates = maybeDocumentMap();
        /** A mapping of document keys to their set of target IDs. */
        this.pendingDocumentTargetMapping = documentTargetMap();
        /**
         * A list of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */
        this.pendingTargetResets = new SortedSet(primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */
    WatchChangeAggregator.prototype.handleDocumentChange = function (docChange) {
        for (var _i = 0, _a = docChange.updatedTargetIds; _i < _a.length; _i++) {
            var targetId = _a[_i];
            if (docChange.newDoc instanceof Document) {
                this.addDocumentToTarget(targetId, docChange.newDoc);
            }
            else if (docChange.newDoc instanceof NoDocument) {
                this.removeDocumentFromTarget(targetId, docChange.key, docChange.newDoc);
            }
        }
        for (var _b = 0, _c = docChange.removedTargetIds; _b < _c.length; _b++) {
            var targetId = _c[_b];
            this.removeDocumentFromTarget(targetId, docChange.key, docChange.newDoc);
        }
    };
    /** Processes and adds the WatchTargetChange to the current set of changes. */
    WatchChangeAggregator.prototype.handleTargetChange = function (targetChange) {
        var _this = this;
        this.forEachTarget(targetChange, function (targetId) {
            var targetState = _this.ensureTargetState(targetId);
            switch (targetChange.state) {
                case WatchTargetChangeState.NoChange:
                    if (_this.isActiveTarget(targetId)) {
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                case WatchTargetChangeState.Added:
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    targetState.recordTargetResponse();
                    if (!targetState.isPending) {
                        // We have a freshly added target, so we need to reset any state
                        // that we had previously. This can happen e.g. when remove and add
                        // back a target for existence filter mismatches.
                        targetState.clearPendingChanges();
                    }
                    targetState.updateResumeToken(targetChange.resumeToken);
                    break;
                case WatchTargetChangeState.Removed:
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    targetState.recordTargetResponse();
                    if (!targetState.isPending) {
                        _this.removeTarget(targetId);
                    }
                    assert(!targetChange.cause, 'WatchChangeAggregator does not handle errored targets');
                    break;
                case WatchTargetChangeState.Current:
                    if (_this.isActiveTarget(targetId)) {
                        targetState.markCurrent();
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                case WatchTargetChangeState.Reset:
                    if (_this.isActiveTarget(targetId)) {
                        // Reset the target and synthesizes removes for all existing
                        // documents. The backend will re-add any documents that still
                        // match the target before it sends the next global snapshot.
                        _this.resetTarget(targetId);
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                default:
                    fail('Unknown target watch change state: ' + targetChange.state);
            }
        });
    };
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */
    WatchChangeAggregator.prototype.forEachTarget = function (targetChange, fn) {
        if (targetChange.targetIds.length > 0) {
            targetChange.targetIds.forEach(fn);
        }
        else {
            forEachNumber(this.targetStates, fn);
        }
    };
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */
    WatchChangeAggregator.prototype.handleExistenceFilter = function (watchChange) {
        var targetId = watchChange.targetId;
        var expectedCount = watchChange.existenceFilter.count;
        var queryData = this.queryDataForActiveTarget(targetId);
        if (queryData) {
            var query = queryData.query;
            if (query.isDocumentQuery()) {
                if (expectedCount === 0) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    var key = new DocumentKey(query.path);
                    this.removeDocumentFromTarget(targetId, key, new NoDocument(key, SnapshotVersion.forDeletedDoc()));
                }
                else {
                    assert(expectedCount === 1, 'Single document existence filter with count: ' + expectedCount);
                }
            }
            else {
                var currentSize = this.getCurrentDocumentCountForTarget(targetId);
                if (currentSize !== expectedCount) {
                    // Existence filter mismatch: We reset the mapping and raise a new
                    // snapshot with `isFromCache:true`.
                    this.resetTarget(targetId);
                    this.pendingTargetResets = this.pendingTargetResets.add(targetId);
                }
            }
        }
    };
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */
    WatchChangeAggregator.prototype.createRemoteEvent = function (snapshotVersion) {
        var _this = this;
        var targetChanges = {};
        forEachNumber(this.targetStates, function (targetId, targetState) {
            var queryData = _this.queryDataForActiveTarget(targetId);
            if (queryData) {
                if (targetState.current && queryData.query.isDocumentQuery()) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    //
                    // TODO(dimond): Ideally we would have an explicit lookup query
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    var key = new DocumentKey(queryData.query.path);
                    if (_this.pendingDocumentUpdates.get(key) === null &&
                        !_this.targetContainsDocument(targetId, key)) {
                        _this.removeDocumentFromTarget(targetId, key, new NoDocument(key, snapshotVersion));
                    }
                }
                if (targetState.hasPendingChanges) {
                    targetChanges[targetId] = targetState.toTargetChange();
                    targetState.clearPendingChanges();
                }
            }
        });
        var resolvedLimboDocuments = documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the query cache.
        //
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.pendingDocumentTargetMapping.forEach(function (key, targets) {
            var isOnlyLimboTarget = true;
            targets.forEachWhile(function (targetId) {
                var queryData = _this.queryDataForActiveTarget(targetId);
                if (queryData && queryData.purpose !== QueryPurpose.LimboResolution) {
                    isOnlyLimboTarget = false;
                    return false;
                }
                return true;
            });
            if (isOnlyLimboTarget) {
                resolvedLimboDocuments = resolvedLimboDocuments.add(key);
            }
        });
        var remoteEvent = new RemoteEvent(snapshotVersion, targetChanges, this.pendingTargetResets, this.pendingDocumentUpdates, resolvedLimboDocuments);
        this.pendingDocumentUpdates = maybeDocumentMap();
        this.pendingDocumentTargetMapping = documentTargetMap();
        this.pendingTargetResets = new SortedSet(primitiveComparator);
        return remoteEvent;
    };
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */
    // Visible for testing.
    WatchChangeAggregator.prototype.addDocumentToTarget = function (targetId, document) {
        if (!this.isActiveTarget(targetId)) {
            return;
        }
        var changeType = this.targetContainsDocument(targetId, document.key)
            ? ChangeType.Modified
            : ChangeType.Added;
        var targetState = this.ensureTargetState(targetId);
        targetState.addDocumentChange(document.key, changeType);
        this.pendingDocumentUpdates = this.pendingDocumentUpdates.insert(document.key, document);
        this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(document.key, this.ensureDocumentTargetMapping(document.key).add(targetId));
    };
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */
    // Visible for testing.
    WatchChangeAggregator.prototype.removeDocumentFromTarget = function (targetId, key, updatedDocument) {
        if (!this.isActiveTarget(targetId)) {
            return;
        }
        var targetState = this.ensureTargetState(targetId);
        if (this.targetContainsDocument(targetId, key)) {
            targetState.addDocumentChange(key, ChangeType.Removed);
        }
        else {
            // The document may have entered and left the target before we raised a
            // snapshot, so we can just ignore the change.
            targetState.removeDocumentChange(key);
        }
        this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(key, this.ensureDocumentTargetMapping(key).delete(targetId));
        if (updatedDocument) {
            this.pendingDocumentUpdates = this.pendingDocumentUpdates.insert(key, updatedDocument);
        }
    };
    WatchChangeAggregator.prototype.removeTarget = function (targetId) {
        delete this.targetStates[targetId];
    };
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */
    WatchChangeAggregator.prototype.getCurrentDocumentCountForTarget = function (targetId) {
        var targetState = this.ensureTargetState(targetId);
        var targetChange = targetState.toTargetChange();
        return (this.metadataProvider.getRemoteKeysForTarget(targetId).size +
            targetChange.addedDocuments.size -
            targetChange.removedDocuments.size);
    };
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */
    WatchChangeAggregator.prototype.recordPendingTargetRequest = function (targetId) {
        // For each request we get we need to record we need a response for it.
        var targetState = this.ensureTargetState(targetId);
        targetState.recordPendingTargetRequest();
    };
    WatchChangeAggregator.prototype.ensureTargetState = function (targetId) {
        if (!this.targetStates[targetId]) {
            this.targetStates[targetId] = new TargetState();
        }
        return this.targetStates[targetId];
    };
    WatchChangeAggregator.prototype.ensureDocumentTargetMapping = function (key) {
        var targetMapping = this.pendingDocumentTargetMapping.get(key);
        if (!targetMapping) {
            targetMapping = new SortedSet(primitiveComparator);
            this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(key, targetMapping);
        }
        return targetMapping;
    };
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getQueryDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */
    WatchChangeAggregator.prototype.isActiveTarget = function (targetId) {
        return this.queryDataForActiveTarget(targetId) !== null;
    };
    /**
     * Returns the QueryData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */
    WatchChangeAggregator.prototype.queryDataForActiveTarget = function (targetId) {
        var targetState = this.targetStates[targetId];
        return targetState && targetState.isPending
            ? null
            : this.metadataProvider.getQueryDataForTarget(targetId);
    };
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */
    WatchChangeAggregator.prototype.resetTarget = function (targetId) {
        var _this = this;
        assert(!this.targetStates[targetId].isPending, 'Should only reset active targets');
        this.targetStates[targetId] = new TargetState();
        // Trigger removal for any documents currently mapped to this target.
        // These removals will be part of the initial snapshot if Watch does not
        // resend these documents.
        var existingKeys = this.metadataProvider.getRemoteKeysForTarget(targetId);
        existingKeys.forEach(function (key) {
            _this.removeDocumentFromTarget(targetId, key, /*updatedDocument=*/ null);
        });
    };
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */
    WatchChangeAggregator.prototype.targetContainsDocument = function (targetId, key) {
        var existingKeys = this.metadataProvider.getRemoteKeysForTarget(targetId);
        return existingKeys.has(key);
    };
    return WatchChangeAggregator;
}());
function documentTargetMap() {
    return new SortedMap(DocumentKey.comparator);
}
function snapshotChangesMap() {
    return new SortedMap(DocumentKey.comparator);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DIRECTIONS = (function () {
    var dirs = {};
    dirs[Direction.ASCENDING.name] = 'ASCENDING';
    dirs[Direction.DESCENDING.name] = 'DESCENDING';
    return dirs;
})();
var OPERATORS = (function () {
    var ops = {};
    ops[RelationOp.LESS_THAN.name] = 'LESS_THAN';
    ops[RelationOp.LESS_THAN_OR_EQUAL.name] = 'LESS_THAN_OR_EQUAL';
    ops[RelationOp.GREATER_THAN.name] = 'GREATER_THAN';
    ops[RelationOp.GREATER_THAN_OR_EQUAL.name] = 'GREATER_THAN_OR_EQUAL';
    ops[RelationOp.EQUAL.name] = 'EQUAL';
    ops[RelationOp.ARRAY_CONTAINS.name] = 'ARRAY_CONTAINS';
    return ops;
})();
// A RegExp matching ISO 8601 UTC timestamps with optional fraction.
var ISO_REG_EXP = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
function assertPresent(value, description) {
    assert(!isNullOrUndefined(value), description + ' is missing');
}
function parseInt64(value) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    if (typeof value === 'number') {
        return value;
    }
    else if (typeof value === 'string') {
        return Number(value);
    }
    else {
        return fail("can't parse " + value);
    }
}
/**
 * Generates JsonObject values for the Datastore API suitable for sending to
 * either GRPC stub methods or via the JSON/HTTP REST API.
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */
var JsonProtoSerializer = /** @class */ (function () {
    function JsonProtoSerializer(databaseId, options) {
        this.databaseId = databaseId;
        this.options = options;
    }
    JsonProtoSerializer.prototype.emptyByteString = function () {
        if (this.options.useProto3Json) {
            return '';
        }
        else {
            return new Uint8Array(0);
        }
    };
    JsonProtoSerializer.prototype.unsafeCastProtoByteString = function (byteString) {
        // byteStrings can be either string or UInt8Array, but the typings say
        // it's always a string. Cast as string to avoid type check failing
        return byteString;
    };
    JsonProtoSerializer.prototype.fromRpcStatus = function (status) {
        var code = status.code === undefined
            ? Code.UNKNOWN
            : mapCodeFromRpcCode(status.code);
        return new FirestoreError(code, status.message || '');
    };
    /**
     * Returns a value for a number (or undefined) that's appropriate to put into
     * a google.protobuf.Int32Value proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "number" because that's what
     * our generated proto interfaces say Int32Value must be. But GRPC actually
     * expects a { value: <number> } struct.
     */
    JsonProtoSerializer.prototype.toInt32Value = function (val) {
        if (!isNullOrUndefined(val)) {
            // tslint:disable-next-line:no-any We need to match generated Proto types.
            return { value: val };
        }
        else {
            return undefined;
        }
    };
    /**
     * Returns a number (or null) from a google.protobuf.Int32Value proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as accepting "number" because that's what
     * our generated proto interfaces say Int32Value must be, but it actually
     * accepts { value: number } to match our serialization in toInt32Value().
     */
    JsonProtoSerializer.prototype.fromInt32Value = function (val) {
        var result;
        if (typeof val === 'object') {
            // tslint:disable-next-line:no-any We need to match generated Proto types.
            result = val.value;
        }
        else {
            // We accept raw numbers (without the {value: ... } wrapper) for
            // compatibility with legacy persisted data.
            result = val;
        }
        return isNullOrUndefined(result) ? null : result;
    };
    /**
     * Returns a value for a Date that's appropriate to put into a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say dates must be. But it's easier and safer
     * to actually return a Timestamp proto.
     */
    JsonProtoSerializer.prototype.toTimestamp = function (timestamp) {
        return {
            seconds: timestamp.seconds,
            nanos: timestamp.nanoseconds
            // tslint:disable-next-line:no-any
        };
    };
    JsonProtoSerializer.prototype.fromTimestamp = function (date) {
        // The json interface (for the browser) will return an iso timestamp string,
        // while the proto js library (for node) will return a
        // google.protobuf.Timestamp instance.
        if (typeof date === 'string') {
            // TODO(b/37282237): Use strings for Proto3 timestamps
            // assert(this.options.useProto3Json,
            //   'The timestamp string format requires Proto3.');
            return this.fromIso8601String(date);
        }
        else {
            assert(!!date, 'Cannot deserialize null or undefined timestamp.');
            // TODO(b/37282237): Use strings for Proto3 timestamps
            // assert(!this.options.useProto3Json,
            //   'The timestamp instance format requires Proto JS.');
            var seconds = parseInt64(date.seconds || '0');
            var nanos = date.nanos || 0;
            return new Timestamp(seconds, nanos);
        }
    };
    JsonProtoSerializer.prototype.fromIso8601String = function (utc) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        var nanos = 0;
        var fraction = ISO_REG_EXP.exec(utc);
        assert(!!fraction, 'invalid timestamp: ' + utc);
        if (fraction[1]) {
            // Pad the fraction out to 9 digits (nanos).
            var nanoStr = fraction[1];
            nanoStr = (nanoStr + '000000000').substr(0, 9);
            nanos = Number(nanoStr);
        }
        // Parse the date to get the seconds.
        var date = new Date(utc);
        var seconds = Math.floor(date.getTime() / 1000);
        return new Timestamp(seconds, nanos);
    };
    /**
     * Returns a value for bytes that's appropriate to put in a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say bytes must be. But it should return
     * an Uint8Array in Node.
     */
    JsonProtoSerializer.prototype.toBytes = function (bytes) {
        if (this.options.useProto3Json) {
            return bytes.toBase64();
        }
        else {
            // The typings say it's a string, but it needs to be a Uint8Array in Node.
            return this.unsafeCastProtoByteString(bytes.toUint8Array());
        }
    };
    /**
     * Parse the blob from the protos into the internal Blob class. Note that the
     * typings assume all blobs are strings, but they are actually Uint8Arrays
     * on Node.
     */
    JsonProtoSerializer.prototype.fromBlob = function (blob) {
        if (typeof blob === 'string') {
            assert(this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
            return Blob.fromBase64String(blob);
        }
        else {
            assert(!this.options.useProto3Json, 'Expected bytes to be passed in as string, but got something else instead.');
            return Blob.fromUint8Array(blob);
        }
    };
    JsonProtoSerializer.prototype.toVersion = function (version) {
        return this.toTimestamp(version.toTimestamp());
    };
    JsonProtoSerializer.prototype.fromVersion = function (version) {
        assert(!!version, "Trying to deserialize version that isn't set");
        return SnapshotVersion.fromTimestamp(this.fromTimestamp(version));
    };
    JsonProtoSerializer.prototype.toResourceName = function (databaseId, path) {
        return this.fullyQualifiedPrefixPath(databaseId)
            .child('documents')
            .child(path)
            .canonicalString();
    };
    JsonProtoSerializer.prototype.fromResourceName = function (name) {
        var resource = ResourcePath.fromString(name);
        assert(this.isValidResourceName(resource), 'Tried to deserialize invalid key ' + resource.toString());
        return resource;
    };
    JsonProtoSerializer.prototype.toName = function (key) {
        return this.toResourceName(this.databaseId, key.path);
    };
    JsonProtoSerializer.prototype.fromName = function (name) {
        var resource = this.fromResourceName(name);
        assert(resource.get(1) === this.databaseId.projectId, 'Tried to deserialize key from different project: ' +
            resource.get(1) +
            ' vs ' +
            this.databaseId.projectId);
        assert((!resource.get(3) && !this.databaseId.database) ||
            resource.get(3) === this.databaseId.database, 'Tried to deserialize key from different database: ' +
            resource.get(3) +
            ' vs ' +
            this.databaseId.database);
        return new DocumentKey(this.extractLocalPathFromResourceName(resource));
    };
    JsonProtoSerializer.prototype.toQueryPath = function (path) {
        return this.toResourceName(this.databaseId, path);
    };
    JsonProtoSerializer.prototype.fromQueryPath = function (name) {
        var resourceName = this.fromResourceName(name);
        // In v1beta1 queries for collections at the root did not have a trailing
        // "/documents". In v1 all resource paths contain "/documents". Preserve the
        // ability to read the v1beta1 form for compatibility with queries persisted
        // in the local query cache.
        if (resourceName.length === 4) {
            return ResourcePath.EMPTY_PATH;
        }
        return this.extractLocalPathFromResourceName(resourceName);
    };
    Object.defineProperty(JsonProtoSerializer.prototype, "encodedDatabaseId", {
        get: function () {
            var path = new ResourcePath([
                'projects',
                this.databaseId.projectId,
                'databases',
                this.databaseId.database
            ]);
            return path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    JsonProtoSerializer.prototype.fullyQualifiedPrefixPath = function (databaseId) {
        return new ResourcePath([
            'projects',
            databaseId.projectId,
            'databases',
            databaseId.database
        ]);
    };
    JsonProtoSerializer.prototype.extractLocalPathFromResourceName = function (resourceName) {
        assert(resourceName.length > 4 && resourceName.get(4) === 'documents', 'tried to deserialize invalid key ' + resourceName.toString());
        return resourceName.popFirst(5);
    };
    JsonProtoSerializer.prototype.isValidResourceName = function (path) {
        // Resource names have at least 4 components (project ID, database ID)
        return (path.length >= 4 &&
            path.get(0) === 'projects' &&
            path.get(2) === 'databases');
    };
    JsonProtoSerializer.prototype.toValue = function (val) {
        if (val instanceof NullValue) {
            return { nullValue: 'NULL_VALUE' };
        }
        else if (val instanceof BooleanValue) {
            return { booleanValue: val.value() };
        }
        else if (val instanceof IntegerValue) {
            return { integerValue: '' + val.value() };
        }
        else if (val instanceof DoubleValue) {
            var doubleValue = val.value();
            if (this.options.useProto3Json) {
                // Proto 3 let's us encode NaN and Infinity as string values as
                // expected by the backend. This is currently not checked by our unit
                // tests because they rely on protobuf.js.
                if (isNaN(doubleValue)) {
                    return { doubleValue: 'NaN' };
                }
                else if (doubleValue === Infinity) {
                    return { doubleValue: 'Infinity' };
                }
                else if (doubleValue === -Infinity) {
                    return { doubleValue: '-Infinity' };
                }
            }
            return { doubleValue: val.value() };
        }
        else if (val instanceof StringValue) {
            return { stringValue: val.value() };
        }
        else if (val instanceof ObjectValue) {
            return { mapValue: this.toMapValue(val) };
        }
        else if (val instanceof ArrayValue) {
            return { arrayValue: this.toArrayValue(val) };
        }
        else if (val instanceof TimestampValue) {
            return {
                timestampValue: this.toTimestamp(val.internalValue)
            };
        }
        else if (val instanceof GeoPointValue) {
            return {
                geoPointValue: {
                    latitude: val.value().latitude,
                    longitude: val.value().longitude
                }
            };
        }
        else if (val instanceof BlobValue) {
            return {
                bytesValue: this.toBytes(val.value())
            };
        }
        else if (val instanceof RefValue) {
            return {
                referenceValue: this.toResourceName(val.databaseId, val.key.path)
            };
        }
        else {
            return fail('Unknown FieldValue ' + JSON.stringify(val));
        }
    };
    JsonProtoSerializer.prototype.fromValue = function (obj) {
        var _this = this;
        // tslint:disable-next-line:no-any
        var type = obj['value_type'];
        if (hasTag(obj, type, 'nullValue')) {
            return NullValue.INSTANCE;
        }
        else if (hasTag(obj, type, 'booleanValue')) {
            return BooleanValue.of(obj.booleanValue);
        }
        else if (hasTag(obj, type, 'integerValue')) {
            return new IntegerValue(parseInt64(obj.integerValue));
        }
        else if (hasTag(obj, type, 'doubleValue')) {
            if (this.options.useProto3Json) {
                // Proto 3 uses the string values 'NaN' and 'Infinity'.
                if (obj.doubleValue === 'NaN') {
                    return DoubleValue.NAN;
                }
                else if (obj.doubleValue === 'Infinity') {
                    return DoubleValue.POSITIVE_INFINITY;
                }
                else if (obj.doubleValue === '-Infinity') {
                    return DoubleValue.NEGATIVE_INFINITY;
                }
            }
            return new DoubleValue(obj.doubleValue);
        }
        else if (hasTag(obj, type, 'stringValue')) {
            return new StringValue(obj.stringValue);
        }
        else if (hasTag(obj, type, 'mapValue')) {
            return this.fromFields(obj.mapValue.fields || {});
        }
        else if (hasTag(obj, type, 'arrayValue')) {
            // "values" is not present if the array is empty
            assertPresent(obj.arrayValue, 'arrayValue');
            var values$$1 = obj.arrayValue.values || [];
            return new ArrayValue(values$$1.map(function (v) { return _this.fromValue(v); }));
        }
        else if (hasTag(obj, type, 'timestampValue')) {
            assertPresent(obj.timestampValue, 'timestampValue');
            return new TimestampValue(this.fromTimestamp(obj.timestampValue));
        }
        else if (hasTag(obj, type, 'geoPointValue')) {
            assertPresent(obj.geoPointValue, 'geoPointValue');
            var latitude = obj.geoPointValue.latitude || 0;
            var longitude = obj.geoPointValue.longitude || 0;
            return new GeoPointValue(new GeoPoint(latitude, longitude));
        }
        else if (hasTag(obj, type, 'bytesValue')) {
            assertPresent(obj.bytesValue, 'bytesValue');
            var blob = this.fromBlob(obj.bytesValue);
            return new BlobValue(blob);
        }
        else if (hasTag(obj, type, 'referenceValue')) {
            assertPresent(obj.referenceValue, 'referenceValue');
            var resourceName = this.fromResourceName(obj.referenceValue);
            var dbId = new DatabaseId(resourceName.get(1), resourceName.get(3));
            var key = new DocumentKey(this.extractLocalPathFromResourceName(resourceName));
            return new RefValue(dbId, key);
        }
        else {
            return fail('Unknown Value proto ' + JSON.stringify(obj));
        }
    };
    /** Creates an api.Document from key and fields (but no create/update time) */
    JsonProtoSerializer.prototype.toMutationDocument = function (key, fields) {
        return {
            name: this.toName(key),
            fields: this.toFields(fields)
        };
    };
    JsonProtoSerializer.prototype.toDocument = function (document) {
        assert(!document.hasLocalMutations, "Can't serialize documents with mutations.");
        return {
            name: this.toName(document.key),
            fields: this.toFields(document.data),
            updateTime: this.toTimestamp(document.version.toTimestamp())
        };
    };
    JsonProtoSerializer.prototype.fromDocument = function (document, hasCommittedMutations) {
        return new Document(this.fromName(document.name), this.fromVersion(document.updateTime), this.fromFields(document.fields || {}), { hasCommittedMutations: !!hasCommittedMutations });
    };
    JsonProtoSerializer.prototype.toFields = function (fields) {
        var _this = this;
        var result = {};
        fields.forEach(function (key, value) {
            result[key] = _this.toValue(value);
        });
        return result;
    };
    JsonProtoSerializer.prototype.fromFields = function (object) {
        var _this = this;
        // Proto map<string, Value> gets mapped to Object, so cast it.
        var map = object;
        var result = ObjectValue.EMPTY;
        forEach(map, function (key, value) {
            result = result.set(new FieldPath([key]), _this.fromValue(value));
        });
        return result;
    };
    JsonProtoSerializer.prototype.toMapValue = function (map) {
        return {
            fields: this.toFields(map)
        };
    };
    JsonProtoSerializer.prototype.toArrayValue = function (array) {
        var _this = this;
        var result = [];
        array.forEach(function (value) {
            result.push(_this.toValue(value));
        });
        return { values: result };
    };
    JsonProtoSerializer.prototype.fromFound = function (doc) {
        assert(!!doc.found, 'Tried to deserialize a found document from a missing document.');
        assertPresent(doc.found.name, 'doc.found.name');
        assertPresent(doc.found.updateTime, 'doc.found.updateTime');
        var key = this.fromName(doc.found.name);
        var version = this.fromVersion(doc.found.updateTime);
        var fields = this.fromFields(doc.found.fields || {});
        return new Document(key, version, fields, {}, doc.found);
    };
    JsonProtoSerializer.prototype.fromMissing = function (result) {
        assert(!!result.missing, 'Tried to deserialize a missing document from a found document.');
        assert(!!result.readTime, 'Tried to deserialize a missing document without a read time.');
        var key = this.fromName(result.missing);
        var version = this.fromVersion(result.readTime);
        return new NoDocument(key, version);
    };
    JsonProtoSerializer.prototype.fromMaybeDocument = function (result) {
        // tslint:disable-next-line:no-any
        var type = result['result'];
        if (hasTag(result, type, 'found')) {
            return this.fromFound(result);
        }
        else if (hasTag(result, type, 'missing')) {
            return this.fromMissing(result);
        }
        return fail('invalid batch get response: ' + JSON.stringify(result));
    };
    JsonProtoSerializer.prototype.toWatchTargetChangeState = function (state) {
        switch (state) {
            case WatchTargetChangeState.Added:
                return 'ADD';
            case WatchTargetChangeState.Current:
                return 'CURRENT';
            case WatchTargetChangeState.NoChange:
                return 'NO_CHANGE';
            case WatchTargetChangeState.Removed:
                return 'REMOVE';
            case WatchTargetChangeState.Reset:
                return 'RESET';
            default:
                return fail('Unknown WatchTargetChangeState: ' + state);
        }
    };
    JsonProtoSerializer.prototype.toTestWatchChange = function (watchChange) {
        if (watchChange instanceof ExistenceFilterChange) {
            return {
                filter: {
                    count: watchChange.existenceFilter.count,
                    targetId: watchChange.targetId
                }
            };
        }
        if (watchChange instanceof DocumentWatchChange) {
            if (watchChange.newDoc instanceof Document) {
                var doc = watchChange.newDoc;
                return {
                    documentChange: {
                        document: {
                            name: this.toName(doc.key),
                            fields: this.toFields(doc.data),
                            updateTime: this.toVersion(doc.version)
                        },
                        targetIds: watchChange.updatedTargetIds,
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
            else if (watchChange.newDoc instanceof NoDocument) {
                var doc = watchChange.newDoc;
                return {
                    documentDelete: {
                        document: this.toName(doc.key),
                        readTime: this.toVersion(doc.version),
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
            else if (watchChange.newDoc === null) {
                return {
                    documentRemove: {
                        document: this.toName(watchChange.key),
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
        }
        if (watchChange instanceof WatchTargetChange) {
            var cause = undefined;
            if (watchChange.cause) {
                cause = {
                    code: mapRpcCodeFromCode(watchChange.cause.code),
                    message: watchChange.cause.message
                };
            }
            return {
                targetChange: {
                    targetChangeType: this.toWatchTargetChangeState(watchChange.state),
                    targetIds: watchChange.targetIds,
                    resumeToken: this.unsafeCastProtoByteString(watchChange.resumeToken),
                    cause: cause
                }
            };
        }
        return fail('Unrecognized watch change: ' + JSON.stringify(watchChange));
    };
    JsonProtoSerializer.prototype.fromWatchChange = function (change) {
        // tslint:disable-next-line:no-any
        var type = change['response_type'];
        var watchChange;
        if (hasTag(change, type, 'targetChange')) {
            assertPresent(change.targetChange, 'targetChange');
            // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
            // if unset
            var state = this.fromWatchTargetChangeState(change.targetChange.targetChangeType || 'NO_CHANGE');
            var targetIds = change.targetChange.targetIds || [];
            var resumeToken = change.targetChange.resumeToken || this.emptyByteString();
            var causeProto = change.targetChange.cause;
            var cause = causeProto && this.fromRpcStatus(causeProto);
            watchChange = new WatchTargetChange(state, targetIds, resumeToken, cause || null);
        }
        else if (hasTag(change, type, 'documentChange')) {
            assertPresent(change.documentChange, 'documentChange');
            assertPresent(change.documentChange.document, 'documentChange.name');
            assertPresent(change.documentChange.document.name, 'documentChange.document.name');
            assertPresent(change.documentChange.document.updateTime, 'documentChange.document.updateTime');
            var entityChange = change.documentChange;
            var key = this.fromName(entityChange.document.name);
            var version = this.fromVersion(entityChange.document.updateTime);
            var fields = this.fromFields(entityChange.document.fields || {});
            // The document may soon be re-serialized back to protos in order to store it in local
            // persistence. Memoize the encoded form to avoid encoding it again.
            var doc = new Document(key, version, fields, {}, entityChange.document);
            var updatedTargetIds = entityChange.targetIds || [];
            var removedTargetIds = entityChange.removedTargetIds || [];
            watchChange = new DocumentWatchChange(updatedTargetIds, removedTargetIds, doc.key, doc);
        }
        else if (hasTag(change, type, 'documentDelete')) {
            assertPresent(change.documentDelete, 'documentDelete');
            assertPresent(change.documentDelete.document, 'documentDelete.document');
            var docDelete = change.documentDelete;
            var key = this.fromName(docDelete.document);
            var version = docDelete.readTime
                ? this.fromVersion(docDelete.readTime)
                : SnapshotVersion.forDeletedDoc();
            var doc = new NoDocument(key, version);
            var removedTargetIds = docDelete.removedTargetIds || [];
            watchChange = new DocumentWatchChange([], removedTargetIds, doc.key, doc);
        }
        else if (hasTag(change, type, 'documentRemove')) {
            assertPresent(change.documentRemove, 'documentRemove');
            assertPresent(change.documentRemove.document, 'documentRemove');
            var docRemove = change.documentRemove;
            var key = this.fromName(docRemove.document);
            var removedTargetIds = docRemove.removedTargetIds || [];
            watchChange = new DocumentWatchChange([], removedTargetIds, key, null);
        }
        else if (hasTag(change, type, 'filter')) {
            // TODO(dimond): implement existence filter parsing with strategy.
            assertPresent(change.filter, 'filter');
            assertPresent(change.filter.targetId, 'filter.targetId');
            var filter = change.filter;
            var count = filter.count || 0;
            var existenceFilter = new ExistenceFilter(count);
            var targetId = filter.targetId;
            watchChange = new ExistenceFilterChange(targetId, existenceFilter);
        }
        else {
            return fail('Unknown change type ' + JSON.stringify(change));
        }
        return watchChange;
    };
    JsonProtoSerializer.prototype.fromWatchTargetChangeState = function (state) {
        if (state === 'NO_CHANGE') {
            return WatchTargetChangeState.NoChange;
        }
        else if (state === 'ADD') {
            return WatchTargetChangeState.Added;
        }
        else if (state === 'REMOVE') {
            return WatchTargetChangeState.Removed;
        }
        else if (state === 'CURRENT') {
            return WatchTargetChangeState.Current;
        }
        else if (state === 'RESET') {
            return WatchTargetChangeState.Reset;
        }
        else {
            return fail('Got unexpected TargetChange.state: ' + state);
        }
    };
    JsonProtoSerializer.prototype.versionFromListenResponse = function (change) {
        // We have only reached a consistent snapshot for the entire stream if there
        // is a read_time set and it applies to all targets (i.e. the list of
        // targets is empty). The backend is guaranteed to send such responses.
        // tslint:disable-next-line:no-any
        var type = change['response_type'];
        if (!hasTag(change, type, 'targetChange')) {
            return SnapshotVersion.MIN;
        }
        var targetChange = change.targetChange;
        if (targetChange.targetIds && targetChange.targetIds.length) {
            return SnapshotVersion.MIN;
        }
        if (!targetChange.readTime) {
            return SnapshotVersion.MIN;
        }
        return this.fromVersion(targetChange.readTime);
    };
    JsonProtoSerializer.prototype.toMutation = function (mutation) {
        var _this = this;
        var result;
        if (mutation instanceof SetMutation) {
            result = {
                update: this.toMutationDocument(mutation.key, mutation.value)
            };
        }
        else if (mutation instanceof DeleteMutation) {
            result = { delete: this.toName(mutation.key) };
        }
        else if (mutation instanceof PatchMutation) {
            result = {
                update: this.toMutationDocument(mutation.key, mutation.data),
                updateMask: this.toDocumentMask(mutation.fieldMask)
            };
        }
        else if (mutation instanceof TransformMutation) {
            result = {
                transform: {
                    document: this.toName(mutation.key),
                    fieldTransforms: mutation.fieldTransforms.map(function (transform) {
                        return _this.toFieldTransform(transform);
                    })
                }
            };
        }
        else {
            return fail('Unknown mutation type ' + mutation.type);
        }
        if (!mutation.precondition.isNone) {
            result.currentDocument = this.toPrecondition(mutation.precondition);
        }
        return result;
    };
    JsonProtoSerializer.prototype.fromMutation = function (proto) {
        var _this = this;
        var precondition = proto.currentDocument
            ? this.fromPrecondition(proto.currentDocument)
            : Precondition.NONE;
        if (proto.update) {
            assertPresent(proto.update.name, 'name');
            var key = this.fromName(proto.update.name);
            var value = this.fromFields(proto.update.fields || {});
            if (proto.updateMask) {
                var fieldMask = this.fromDocumentMask(proto.updateMask);
                return new PatchMutation(key, value, fieldMask, precondition);
            }
            else {
                return new SetMutation(key, value, precondition);
            }
        }
        else if (proto.delete) {
            var key = this.fromName(proto.delete);
            return new DeleteMutation(key, precondition);
        }
        else if (proto.transform) {
            var key = this.fromName(proto.transform.document);
            var fieldTransforms = proto.transform.fieldTransforms.map(function (transform) {
                return _this.fromFieldTransform(transform);
            });
            assert(precondition.exists === true, 'Transforms only support precondition "exists == true"');
            return new TransformMutation(key, fieldTransforms);
        }
        else {
            return fail('unknown mutation proto: ' + JSON.stringify(proto));
        }
    };
    JsonProtoSerializer.prototype.toPrecondition = function (precondition) {
        assert(!precondition.isNone, "Can't serialize an empty precondition");
        if (precondition.updateTime !== undefined) {
            return {
                updateTime: this.toVersion(precondition.updateTime)
            };
        }
        else if (precondition.exists !== undefined) {
            return { exists: precondition.exists };
        }
        else {
            return fail('Unknown precondition');
        }
    };
    JsonProtoSerializer.prototype.fromPrecondition = function (precondition) {
        if (precondition.updateTime !== undefined) {
            return Precondition.updateTime(this.fromVersion(precondition.updateTime));
        }
        else if (precondition.exists !== undefined) {
            return Precondition.exists(precondition.exists);
        }
        else {
            return Precondition.NONE;
        }
    };
    JsonProtoSerializer.prototype.fromWriteResult = function (proto, commitTime) {
        var _this = this;
        // NOTE: Deletes don't have an updateTime.
        var version = proto.updateTime
            ? this.fromVersion(proto.updateTime)
            : this.fromVersion(commitTime);
        var transformResults = null;
        if (proto.transformResults && proto.transformResults.length > 0) {
            transformResults = proto.transformResults.map(function (result) {
                return _this.fromValue(result);
            });
        }
        return new MutationResult(version, transformResults);
    };
    JsonProtoSerializer.prototype.fromWriteResults = function (protos, commitTime) {
        var _this = this;
        if (protos && protos.length > 0) {
            assert(commitTime !== undefined, 'Received a write result without a commit time');
            return protos.map(function (proto) { return _this.fromWriteResult(proto, commitTime); });
        }
        else {
            return [];
        }
    };
    JsonProtoSerializer.prototype.toFieldTransform = function (fieldTransform) {
        var _this = this;
        var transform = fieldTransform.transform;
        if (transform instanceof ServerTimestampTransform) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                setToServerValue: 'REQUEST_TIME'
            };
        }
        else if (transform instanceof ArrayUnionTransformOperation) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                appendMissingElements: {
                    values: transform.elements.map(function (v) { return _this.toValue(v); })
                }
            };
        }
        else if (transform instanceof ArrayRemoveTransformOperation) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                removeAllFromArray: {
                    values: transform.elements.map(function (v) { return _this.toValue(v); })
                }
            };
        }
        else {
            throw fail('Unknown transform: ' + fieldTransform.transform);
        }
    };
    JsonProtoSerializer.prototype.fromFieldTransform = function (proto) {
        var _this = this;
        // tslint:disable-next-line:no-any We need to match generated Proto types.
        var type = proto['transform_type'];
        var transform = null;
        if (hasTag(proto, type, 'setToServerValue')) {
            assert(proto.setToServerValue === 'REQUEST_TIME', 'Unknown server value transform proto: ' + JSON.stringify(proto));
            transform = ServerTimestampTransform.instance;
        }
        else if (hasTag(proto, type, 'appendMissingElements')) {
            var values$$1 = proto.appendMissingElements.values || [];
            transform = new ArrayUnionTransformOperation(values$$1.map(function (v) { return _this.fromValue(v); }));
        }
        else if (hasTag(proto, type, 'removeAllFromArray')) {
            var values$$1 = proto.removeAllFromArray.values || [];
            transform = new ArrayRemoveTransformOperation(values$$1.map(function (v) { return _this.fromValue(v); }));
        }
        else {
            fail('Unknown transform proto: ' + JSON.stringify(proto));
        }
        var fieldPath = FieldPath.fromServerFormat(proto.fieldPath);
        return new FieldTransform(fieldPath, transform);
    };
    JsonProtoSerializer.prototype.toDocumentsTarget = function (query) {
        return { documents: [this.toQueryPath(query.path)] };
    };
    JsonProtoSerializer.prototype.fromDocumentsTarget = function (documentsTarget) {
        var count = documentsTarget.documents.length;
        assert(count === 1, 'DocumentsTarget contained other than 1 document: ' + count);
        var name = documentsTarget.documents[0];
        return Query.atPath(this.fromQueryPath(name));
    };
    JsonProtoSerializer.prototype.toQueryTarget = function (query) {
        // Dissect the path into parent, collectionId, and optional key filter.
        var result = { structuredQuery: {} };
        if (query.path.isEmpty()) {
            result.parent = this.toQueryPath(ResourcePath.EMPTY_PATH);
        }
        else {
            var path = query.path;
            assert(path.length % 2 !== 0, 'Document queries with filters are not supported.');
            result.parent = this.toQueryPath(path.popLast());
            result.structuredQuery.from = [{ collectionId: path.lastSegment() }];
        }
        var where = this.toFilter(query.filters);
        if (where) {
            result.structuredQuery.where = where;
        }
        var orderBy = this.toOrder(query.orderBy);
        if (orderBy) {
            result.structuredQuery.orderBy = orderBy;
        }
        var limit = this.toInt32Value(query.limit);
        if (limit !== undefined) {
            result.structuredQuery.limit = limit;
        }
        if (query.startAt) {
            result.structuredQuery.startAt = this.toCursor(query.startAt);
        }
        if (query.endAt) {
            result.structuredQuery.endAt = this.toCursor(query.endAt);
        }
        return result;
    };
    JsonProtoSerializer.prototype.fromQueryTarget = function (target) {
        var path = this.fromQueryPath(target.parent);
        var query = target.structuredQuery;
        var fromCount = query.from ? query.from.length : 0;
        if (fromCount > 0) {
            assert(fromCount === 1, 'StructuredQuery.from with more than one collection is not supported.');
            var from = query.from[0];
            path = path.child(from.collectionId);
        }
        var filterBy = [];
        if (query.where) {
            filterBy = this.fromFilter(query.where);
        }
        var orderBy = [];
        if (query.orderBy) {
            orderBy = this.fromOrder(query.orderBy);
        }
        var limit = null;
        if (query.limit) {
            limit = this.fromInt32Value(query.limit);
        }
        var startAt = null;
        if (query.startAt) {
            startAt = this.fromCursor(query.startAt);
        }
        var endAt = null;
        if (query.endAt) {
            endAt = this.fromCursor(query.endAt);
        }
        return new Query(path, orderBy, filterBy, limit, startAt, endAt);
    };
    JsonProtoSerializer.prototype.toListenRequestLabels = function (queryData) {
        var value = this.toLabel(queryData.purpose);
        if (value == null) {
            return null;
        }
        else {
            return {
                'goog-listen-tags': value
            };
        }
    };
    JsonProtoSerializer.prototype.toLabel = function (purpose) {
        switch (purpose) {
            case QueryPurpose.Listen:
                return null;
            case QueryPurpose.ExistenceFilterMismatch:
                return 'existence-filter-mismatch';
            case QueryPurpose.LimboResolution:
                return 'limbo-document';
            default:
                return fail('Unrecognized query purpose: ' + purpose);
        }
    };
    JsonProtoSerializer.prototype.toTarget = function (queryData) {
        var result;
        var query = queryData.query;
        if (query.isDocumentQuery()) {
            result = { documents: this.toDocumentsTarget(query) };
        }
        else {
            result = { query: this.toQueryTarget(query) };
        }
        result.targetId = queryData.targetId;
        if (queryData.resumeToken.length > 0) {
            result.resumeToken = this.unsafeCastProtoByteString(queryData.resumeToken);
        }
        return result;
    };
    JsonProtoSerializer.prototype.toFilter = function (filters) {
        var _this = this;
        if (filters.length === 0)
            return;
        var protos = filters.map(function (filter) {
            return filter instanceof RelationFilter
                ? _this.toRelationFilter(filter)
                : _this.toUnaryFilter(filter);
        });
        if (protos.length === 1) {
            return protos[0];
        }
        return { compositeFilter: { op: 'AND', filters: protos } };
    };
    JsonProtoSerializer.prototype.fromFilter = function (filter) {
        var _this = this;
        if (!filter) {
            return [];
        }
        else if (filter.unaryFilter !== undefined) {
            return [this.fromUnaryFilter(filter)];
        }
        else if (filter.fieldFilter !== undefined) {
            return [this.fromRelationFilter(filter)];
        }
        else if (filter.compositeFilter !== undefined) {
            return filter.compositeFilter
                .filters.map(function (f) { return _this.fromFilter(f); })
                .reduce(function (accum, current) { return accum.concat(current); });
        }
        else {
            return fail('Unknown filter: ' + JSON.stringify(filter));
        }
    };
    JsonProtoSerializer.prototype.toOrder = function (orderBys) {
        var _this = this;
        if (orderBys.length === 0)
            return;
        return orderBys.map(function (order) { return _this.toPropertyOrder(order); });
    };
    JsonProtoSerializer.prototype.fromOrder = function (orderBys) {
        var _this = this;
        return orderBys.map(function (order) { return _this.fromPropertyOrder(order); });
    };
    JsonProtoSerializer.prototype.toCursor = function (cursor) {
        var _this = this;
        return {
            before: cursor.before,
            values: cursor.position.map(function (component) { return _this.toValue(component); })
        };
    };
    JsonProtoSerializer.prototype.fromCursor = function (cursor) {
        var _this = this;
        var before = !!cursor.before;
        var position = cursor.values.map(function (component) { return _this.fromValue(component); });
        return new Bound(position, before);
    };
    // visible for testing
    JsonProtoSerializer.prototype.toDirection = function (dir) {
        return DIRECTIONS[dir.name];
    };
    // visible for testing
    JsonProtoSerializer.prototype.fromDirection = function (dir) {
        switch (dir) {
            case 'ASCENDING':
                return Direction.ASCENDING;
            case 'DESCENDING':
                return Direction.DESCENDING;
            default:
                return undefined;
        }
    };
    // visible for testing
    JsonProtoSerializer.prototype.toOperatorName = function (op) {
        return OPERATORS[op.name];
    };
    JsonProtoSerializer.prototype.fromOperatorName = function (op) {
        switch (op) {
            case 'EQUAL':
                return RelationOp.EQUAL;
            case 'GREATER_THAN':
                return RelationOp.GREATER_THAN;
            case 'GREATER_THAN_OR_EQUAL':
                return RelationOp.GREATER_THAN_OR_EQUAL;
            case 'LESS_THAN':
                return RelationOp.LESS_THAN;
            case 'LESS_THAN_OR_EQUAL':
                return RelationOp.LESS_THAN_OR_EQUAL;
            case 'ARRAY_CONTAINS':
                return RelationOp.ARRAY_CONTAINS;
            case 'OPERATOR_UNSPECIFIED':
                return fail('Unspecified relation');
            default:
                return fail('Unknown relation');
        }
    };
    JsonProtoSerializer.prototype.toFieldPathReference = function (path) {
        return { fieldPath: path.canonicalString() };
    };
    JsonProtoSerializer.prototype.fromFieldPathReference = function (fieldReference) {
        return FieldPath.fromServerFormat(fieldReference.fieldPath);
    };
    // visible for testing
    JsonProtoSerializer.prototype.toPropertyOrder = function (orderBy) {
        return {
            field: this.toFieldPathReference(orderBy.field),
            direction: this.toDirection(orderBy.dir)
        };
    };
    JsonProtoSerializer.prototype.fromPropertyOrder = function (orderBy) {
        return new OrderBy(this.fromFieldPathReference(orderBy.field), this.fromDirection(orderBy.direction));
    };
    // visible for testing
    JsonProtoSerializer.prototype.toRelationFilter = function (filter) {
        if (filter instanceof RelationFilter) {
            return {
                fieldFilter: {
                    field: this.toFieldPathReference(filter.field),
                    op: this.toOperatorName(filter.op),
                    value: this.toValue(filter.value)
                }
            };
        }
        else {
            return fail('Unrecognized filter: ' + JSON.stringify(filter));
        }
    };
    JsonProtoSerializer.prototype.fromRelationFilter = function (filter) {
        return new RelationFilter(this.fromFieldPathReference(filter.fieldFilter.field), this.fromOperatorName(filter.fieldFilter.op), this.fromValue(filter.fieldFilter.value));
    };
    // visible for testing
    JsonProtoSerializer.prototype.toUnaryFilter = function (filter) {
        if (filter instanceof NanFilter) {
            return {
                unaryFilter: {
                    field: this.toFieldPathReference(filter.field),
                    op: 'IS_NAN'
                }
            };
        }
        else if (filter instanceof NullFilter) {
            return {
                unaryFilter: {
                    field: this.toFieldPathReference(filter.field),
                    op: 'IS_NULL'
                }
            };
        }
        else {
            return fail('Unrecognized filter: ' + JSON.stringify(filter));
        }
    };
    JsonProtoSerializer.prototype.fromUnaryFilter = function (filter) {
        switch (filter.unaryFilter.op) {
            case 'IS_NAN':
                var nanField = this.fromFieldPathReference(filter.unaryFilter.field);
                return new NanFilter(nanField);
            case 'IS_NULL':
                var nullField = this.fromFieldPathReference(filter.unaryFilter.field);
                return new NullFilter(nullField);
            case 'OPERATOR_UNSPECIFIED':
                return fail('Unspecified filter');
            default:
                return fail('Unknown filter');
        }
    };
    JsonProtoSerializer.prototype.toDocumentMask = function (fieldMask) {
        var canonicalFields = [];
        fieldMask.fields.forEach(function (field) {
            return canonicalFields.push(field.canonicalString());
        });
        return {
            fieldPaths: canonicalFields
        };
    };
    JsonProtoSerializer.prototype.fromDocumentMask = function (proto) {
        var paths = proto.fieldPaths || [];
        var fields = paths.map(function (path) { return FieldPath.fromServerFormat(path); });
        return FieldMask.fromArray(fields);
    };
    return JsonProtoSerializer;
}());
/**
 * Checks for a specific oneof tag in a protocol buffer message.
 *
 * This intentionally accommodates two distinct cases:
 *
 * 1) Messages containing a type tag: these are the format produced by GRPC in
 * return values. These may contain default-value mappings for all tags in the
 * oneof but the type tag specifies which one was actually set.
 *
 * 2) Messages that don't contain a type tag: these are the format required by
 * GRPC as inputs. If we emitted objects with type tags, ProtoBuf.js would
 * choke claiming that the tags aren't fields in the Message.
 *
 * Allowing both formats here makes the serializer able to consume the outputs
 * it produces: for all messages it supports, fromX(toX(value)) == value.
 *
 * Note that case 2 suffers from ambiguity: if multiple tags are present
 * without a type tag then the callers are structured in such a way that the
 * first invocation will win. Since we only parse in this mode when parsing
 * the output of a serialize method this works, but it's not a general
 * solution.
 *
 * Unfortunately there is no general solution here because proto3 makes it
 * impossible to distinguish unset from explicitly set fields: both have the
 * default value for the type. Without the type tag but multiple value tags
 * it's possible to have default values for each tag in the oneof and not be
 * able to know which was actually in effect.
 */
function hasTag(obj, type, tag) {
    return type === tag || (!type && tag in obj);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */
var StreamBridge = /** @class */ (function () {
    function StreamBridge(args) {
        this.sendFn = args.sendFn;
        this.closeFn = args.closeFn;
    }
    StreamBridge.prototype.onOpen = function (callback) {
        assert(!this.wrappedOnOpen, 'Called onOpen on stream twice!');
        this.wrappedOnOpen = callback;
    };
    StreamBridge.prototype.onClose = function (callback) {
        assert(!this.wrappedOnClose, 'Called onClose on stream twice!');
        this.wrappedOnClose = callback;
    };
    StreamBridge.prototype.onMessage = function (callback) {
        assert(!this.wrappedOnMessage, 'Called onMessage on stream twice!');
        this.wrappedOnMessage = callback;
    };
    StreamBridge.prototype.close = function () {
        this.closeFn();
    };
    StreamBridge.prototype.send = function (msg) {
        this.sendFn(msg);
    };
    StreamBridge.prototype.callOnOpen = function () {
        assert(this.wrappedOnOpen !== undefined, 'Cannot call onOpen because no callback was set');
        this.wrappedOnOpen();
    };
    StreamBridge.prototype.callOnClose = function (err) {
        assert(this.wrappedOnClose !== undefined, 'Cannot call onClose because no callback was set');
        this.wrappedOnClose(err);
    };
    StreamBridge.prototype.callOnMessage = function (msg) {
        assert(this.wrappedOnMessage !== undefined, 'Cannot call onMessage because no callback was set');
        this.wrappedOnMessage(msg);
    };
    return StreamBridge;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG = 'Connection';
var RPC_STREAM_SERVICE = 'google.firestore.v1.Firestore';
var RPC_URL_VERSION = 'v1';
/** Maps RPC names to the corresponding REST endpoint name. */
var RPC_NAME_REST_MAPPING = {
    BatchGetDocuments: 'batchGet',
    Commit: 'commit'
};
// TODO(b/38203344): The SDK_VERSION is set independently from Firebase because
// we are doing out-of-band releases. Once we release as part of Firebase, we
// should use the Firebase version instead.
var X_GOOG_API_CLIENT_VALUE = 'gl-js/ fire/' + SDK_VERSION;
var XHR_TIMEOUT_SECS = 15;
var WebChannelConnection = /** @class */ (function () {
    function WebChannelConnection(info) {
        this.databaseId = info.databaseId;
        this.pool = new webchannelWrapper.XhrIoPool();
        var proto = info.ssl ? 'https' : 'http';
        this.baseUrl = proto + '://' + info.host;
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */
    WebChannelConnection.prototype.modifyHeadersForRequest = function (headers, token) {
        if (token) {
            for (var header in token.authHeaders) {
                if (token.authHeaders.hasOwnProperty(header)) {
                    headers[header] = token.authHeaders[header];
                }
            }
        }
        headers['X-Goog-Api-Client'] = X_GOOG_API_CLIENT_VALUE;
    };
    WebChannelConnection.prototype.invokeRPC = function (rpcName, request, token) {
        var _this = this;
        var url = this.makeUrl(rpcName);
        return new Promise(function (resolve, reject) {
            // tslint:disable-next-line:no-any XhrIoPool doesn't have TS typings.
            _this.pool.getObject(function (xhr) {
                xhr.listenOnce(webchannelWrapper.EventType.COMPLETE, function () {
                    try {
                        switch (xhr.getLastErrorCode()) {
                            case webchannelWrapper.ErrorCode.NO_ERROR:
                                var json = xhr.getResponseJson();
                                debug(LOG_TAG, 'XHR received:', JSON.stringify(json));
                                resolve(json);
                                break;
                            case webchannelWrapper.ErrorCode.TIMEOUT:
                                debug(LOG_TAG, 'RPC "' + rpcName + '" timed out');
                                reject(new FirestoreError(Code.DEADLINE_EXCEEDED, 'Request time out'));
                                break;
                            case webchannelWrapper.ErrorCode.HTTP_ERROR:
                                var status_1 = xhr.getStatus();
                                debug(LOG_TAG, 'RPC "' + rpcName + '" failed with status:', status_1, 'response text:', xhr.getResponseText());
                                if (status_1 > 0) {
                                    reject(new FirestoreError(mapCodeFromHttpStatus(status_1), 'Server responded with status ' + xhr.getStatusText()));
                                }
                                else {
                                    // If we received an HTTP_ERROR but there's no status code,
                                    // it's most probably a connection issue
                                    debug(LOG_TAG, 'RPC "' + rpcName + '" failed');
                                    reject(new FirestoreError(Code.UNAVAILABLE, 'Connection failed.'));
                                }
                                break;
                            default:
                                fail('RPC "' +
                                    rpcName +
                                    '" failed with unanticipated ' +
                                    'webchannel error ' +
                                    xhr.getLastErrorCode() +
                                    ': ' +
                                    xhr.getLastError() +
                                    ', giving up.');
                        }
                    }
                    finally {
                        debug(LOG_TAG, 'RPC "' + rpcName + '" completed.');
                        _this.pool.releaseObject(xhr);
                    }
                });
                var requestString = JSON.stringify(request);
                debug(LOG_TAG, 'XHR sending: ', url + ' ' + requestString);
                // Content-Type: text/plain will avoid preflight requests which might
                // mess with CORS and redirects by proxies. If we add custom headers
                // we will need to change this code to potentially use the
                // $httpOverwrite parameter supported by ESF to avoid
                // triggering preflight requests.
                var headers = { 'Content-Type': 'text/plain' };
                _this.modifyHeadersForRequest(headers, token);
                xhr.send(url, 'POST', requestString, headers, XHR_TIMEOUT_SECS);
            });
        });
    };
    WebChannelConnection.prototype.invokeStreamingRPC = function (rpcName, request, token) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.invokeRPC(rpcName, request, token);
    };
    WebChannelConnection.prototype.openStream = function (rpcName, token) {
        var urlParts = [
            this.baseUrl,
            '/',
            RPC_STREAM_SERVICE,
            '/',
            rpcName,
            '/channel'
        ];
        var webchannelTransport = webchannelWrapper.createWebChannelTransport();
        var request = {
            // Background channel test avoids the initial two test calls and decreases
            // initial cold start time.
            // TODO(dimond): wenboz@ mentioned this might affect use with proxies and
            // we should monitor closely for any reports.
            backgroundChannelTest: true,
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: 'gsessionid',
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database
            },
            sendRawJson: true,
            supportsCrossDomainXhr: true
        };
        this.modifyHeadersForRequest(request.initMessageHeaders, token);
        // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        //
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
        // the headers should instead be encoded into a special "$httpHeaders" query
        // parameter, which is recognized by the webchannel backend. This is
        // formally defined here:
        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
        //
        // But for some unclear reason (see
        // https://github.com/firebase/firebase-js-sdk/issues/703), this breaks
        // ReactNative and so we exclude it, which just means ReactNative may be
        // subject to the extra network roundtrip for CORS preflight.
        if (!util.isReactNative()) {
            request['httpHeadersOverwriteParam'] = '$httpHeaders';
        }
        var url = urlParts.join('');
        debug(LOG_TAG, 'Creating WebChannel: ' + url + ' ' + request);
        // tslint:disable-next-line:no-any Because listen isn't defined on it.
        var channel = webchannelTransport.createWebChannel(url, request);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        var opened = false;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        var closed = false;
        var streamBridge = new StreamBridge({
            sendFn: function (msg) {
                if (!closed) {
                    if (!opened) {
                        debug(LOG_TAG, 'Opening WebChannel transport.');
                        channel.open();
                        opened = true;
                    }
                    debug(LOG_TAG, 'WebChannel sending:', msg);
                    channel.send(msg);
                }
                else {
                    debug(LOG_TAG, 'Not sending because WebChannel is closed:', msg);
                }
            },
            closeFn: function () { return channel.close(); }
        });
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        var unguardedEventListen = function (type, fn) {
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            channel.listen(type, function (param) {
                try {
                    fn(param);
                }
                catch (e) {
                    setTimeout(function () {
                        throw e;
                    }, 0);
                }
            });
        };
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.OPEN, function () {
            if (!closed) {
                debug(LOG_TAG, 'WebChannel transport opened.');
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.CLOSE, function () {
            if (!closed) {
                closed = true;
                debug(LOG_TAG, 'WebChannel transport closed');
                streamBridge.callOnClose();
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.ERROR, function (err) {
            if (!closed) {
                closed = true;
                debug(LOG_TAG, 'WebChannel transport errored:', err);
                streamBridge.callOnClose(new FirestoreError(Code.UNAVAILABLE, 'The operation could not be completed'));
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.MESSAGE, function (msg) {
            if (!closed) {
                var msgData = msg.data[0];
                assert(!!msgData, 'Got a webchannel message without data.');
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                var error$$1 = 
                // tslint:disable-next-line:no-any msgData.error is not typed.
                msgData.error || (msgData[0] && msgData[0].error);
                if (error$$1) {
                    debug(LOG_TAG, 'WebChannel received error:', error$$1);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    var status_2 = error$$1.status;
                    var code = mapCodeFromRpcStatus(status_2);
                    var message = error$$1.message;
                    if (code === undefined) {
                        code = Code.INTERNAL;
                        message =
                            'Unknown error status: ' +
                                status_2 +
                                ' with message ' +
                                error$$1.message;
                    }
                    // Mark closed so no further events are propagated
                    closed = true;
                    streamBridge.callOnClose(new FirestoreError(code, message));
                    channel.close();
                }
                else {
                    debug(LOG_TAG, 'WebChannel received:', msgData);
                    streamBridge.callOnMessage(msgData);
                }
            }
        });
        setTimeout(function () {
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            streamBridge.callOnOpen();
        }, 0);
        return streamBridge;
    };
    // visible for testing
    WebChannelConnection.prototype.makeUrl = function (rpcName) {
        var urlRpcName = RPC_NAME_REST_MAPPING[rpcName];
        assert(urlRpcName !== undefined, 'Unknown REST mapping for: ' + rpcName);
        var url = [this.baseUrl, '/', RPC_URL_VERSION];
        url.push('/projects/');
        url.push(this.databaseId.projectId);
        url.push('/databases/');
        url.push(this.databaseId.database);
        url.push('/documents');
        url.push(':');
        url.push(urlRpcName);
        return url.join('');
    };
    return WebChannelConnection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var BrowserPlatform = /** @class */ (function () {
    function BrowserPlatform() {
        this.emptyByteString = '';
        this.base64Available = typeof atob !== 'undefined';
    }
    Object.defineProperty(BrowserPlatform.prototype, "document", {
        get: function () {
            return typeof document !== 'undefined' ? document : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatform.prototype, "window", {
        get: function () {
            return typeof window !== 'undefined' ? window : null;
        },
        enumerable: true,
        configurable: true
    });
    BrowserPlatform.prototype.loadConnection = function (databaseInfo) {
        return Promise.resolve(new WebChannelConnection(databaseInfo));
    };
    BrowserPlatform.prototype.newSerializer = function (databaseId) {
        return new JsonProtoSerializer(databaseId, { useProto3Json: true });
    };
    BrowserPlatform.prototype.formatJSON = function (value) {
        return JSON.stringify(value);
    };
    BrowserPlatform.prototype.atob = function (encoded) {
        return atob(encoded);
    };
    BrowserPlatform.prototype.btoa = function (raw) {
        return btoa(raw);
    };
    return BrowserPlatform;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This code needs to run before Firestore is used. This can be achieved in
 * several ways:
 *   1) Through the JSCompiler compiling this code and then (automatically)
 *      executing it before exporting the Firestore symbols.
 *   2) Through importing this module first in a Firestore main module
 */
PlatformSupport.setPlatform(new BrowserPlatform());

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */
var ListenSequence = /** @class */ (function () {
    function ListenSequence(previousValue, sequenceNumberSyncer) {
        var _this = this;
        this.previousValue = previousValue;
        if (sequenceNumberSyncer) {
            sequenceNumberSyncer.sequenceNumberHandler = function (sequenceNumber) {
                return _this.setPreviousValue(sequenceNumber);
            };
            this.writeNewSequenceNumber = function (sequenceNumber) {
                return sequenceNumberSyncer.writeSequenceNumber(sequenceNumber);
            };
        }
    }
    ListenSequence.prototype.setPreviousValue = function (externalPreviousValue) {
        this.previousValue = Math.max(externalPreviousValue, this.previousValue);
        return this.previousValue;
    };
    ListenSequence.prototype.next = function () {
        var nextValue = ++this.previousValue;
        if (this.writeNewSequenceNumber) {
            this.writeNewSequenceNumber(nextValue);
        }
        return nextValue;
    };
    ListenSequence.INVALID = -1;
    return ListenSequence;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    return Deferred;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Wellknown "timer" IDs used when scheduling delayed operations on the
 * AsyncQueue. These IDs can then be used from tests to check for the presence
 * of operations or to run them early.
 *
 * The string values are used when encoding these timer IDs in JSON spec tests.
 */
var TimerId;
(function (TimerId) {
    /** All can be used with runDelayedOperationsEarly() to run all timers. */
    TimerId["All"] = "all";
    /**
     * The following 4 timers are used in persistent_stream.ts for the listen and
     * write streams. The "Idle" timer is used to close the stream due to
     * inactivity. The "ConnectionBackoff" timer is used to restart a stream once
     * the appropriate backoff delay has elapsed.
     */
    TimerId["ListenStreamIdle"] = "listen_stream_idle";
    TimerId["ListenStreamConnectionBackoff"] = "listen_stream_connection_backoff";
    TimerId["WriteStreamIdle"] = "write_stream_idle";
    TimerId["WriteStreamConnectionBackoff"] = "write_stream_connection_backoff";
    /**
     * A timer used in online_state_tracker.ts to transition from
     * OnlineState.Unknown to Offline after a set timeout, rather than waiting
     * indefinitely for success or failure.
     */
    TimerId["OnlineStateTimeout"] = "online_state_timeout";
    /**
     * A timer used to update the client metadata in IndexedDb, which is used
     * to determine the primary leaseholder.
     */
    TimerId["ClientMetadataRefresh"] = "client_metadata_refresh";
    /** A timer used to periodically attempt LRU Garbage collection */
    TimerId["LruGarbageCollection"] = "lru_garbage_collection";
})(TimerId || (TimerId = {}));
/**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 */
var DelayedOperation = /** @class */ (function () {
    function DelayedOperation(asyncQueue, timerId, targetTimeMs, op, removalCallback) {
        this.asyncQueue = asyncQueue;
        this.timerId = timerId;
        this.targetTimeMs = targetTimeMs;
        this.op = op;
        this.removalCallback = removalCallback;
        this.deferred = new Deferred();
        this.then = this.deferred.promise.then.bind(this.deferred.promise);
        this.catch = this.deferred.promise.catch.bind(this.deferred.promise);
        // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch(function (err) { });
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue The queue to schedule the operation on.
     * @param id A Timer ID identifying the type of operation this is.
     * @param delayMs The delay (ms) before the operation should be scheduled.
     * @param op The operation to run.
     * @param removalCallback A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */
    DelayedOperation.createAndSchedule = function (asyncQueue, timerId, delayMs, op, removalCallback) {
        var targetTime = Date.now() + delayMs;
        var delayedOp = new DelayedOperation(asyncQueue, timerId, targetTime, op, removalCallback);
        delayedOp.start(delayMs);
        return delayedOp;
    };
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */
    DelayedOperation.prototype.start = function (delayMs) {
        var _this = this;
        this.timerHandle = setTimeout(function () { return _this.handleDelayElapsed(); }, delayMs);
    };
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */
    DelayedOperation.prototype.skipDelay = function () {
        return this.handleDelayElapsed();
    };
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */
    DelayedOperation.prototype.cancel = function (reason) {
        if (this.timerHandle !== null) {
            this.clearTimeout();
            this.deferred.reject(new FirestoreError(Code.CANCELLED, 'Operation cancelled' + (reason ? ': ' + reason : '')));
        }
    };
    DelayedOperation.prototype.handleDelayElapsed = function () {
        var _this = this;
        this.asyncQueue.enqueueAndForget(function () {
            if (_this.timerHandle !== null) {
                _this.clearTimeout();
                return _this.op().then(function (result) {
                    return _this.deferred.resolve(result);
                });
            }
            else {
                return Promise.resolve();
            }
        });
    };
    DelayedOperation.prototype.clearTimeout = function () {
        if (this.timerHandle !== null) {
            this.removalCallback(this);
            clearTimeout(this.timerHandle);
            this.timerHandle = null;
        }
    };
    return DelayedOperation;
}());
var AsyncQueue = /** @class */ (function () {
    function AsyncQueue() {
        // The last promise in the queue.
        this.tail = Promise.resolve();
        // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.delayedOperations = [];
        // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.operationInProgress = false;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */
    AsyncQueue.prototype.enqueueAndForget = function (op) {
        // tslint:disable-next-line:no-floating-promises
        this.enqueue(op);
    };
    /**
     * Adds a new operation to the queue. Returns a promise that will be resolved
     * when the promise returned by the new operation is (with its value).
     */
    AsyncQueue.prototype.enqueue = function (op) {
        var _this = this;
        this.verifyNotFailed();
        var newTail = this.tail.then(function () {
            _this.operationInProgress = true;
            return op()
                .catch(function (error$$1) {
                _this.failure = error$$1;
                _this.operationInProgress = false;
                var message = error$$1.stack || error$$1.message || '';
                error('INTERNAL UNHANDLED ERROR: ', message);
                // Escape the promise chain and throw the error globally so that
                // e.g. any global crash reporting library detects and reports it.
                // (but not for simulated errors in our tests since this breaks mocha)
                if (message.indexOf('Firestore Test Simulated Error') < 0) {
                    setTimeout(function () {
                        throw error$$1;
                    }, 0);
                }
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw error$$1;
            })
                .then(function (result) {
                _this.operationInProgress = false;
                return result;
            });
        });
        this.tail = newTail;
        return newTail;
    };
    /**
     * Schedules an operation to be queued on the AsyncQueue once the specified
     * `delayMs` has elapsed. The returned CancelablePromise can be used to cancel
     * the operation prior to its running.
     */
    AsyncQueue.prototype.enqueueAfterDelay = function (timerId, delayMs, op) {
        var _this = this;
        this.verifyNotFailed();
        assert(delayMs >= 0, "Attempted to schedule an operation with a negative delay of " + delayMs);
        // While not necessarily harmful, we currently don't expect to have multiple
        // ops with the same timer id in the queue, so defensively reject them.
        assert(!this.containsDelayedOperation(timerId), "Attempted to schedule multiple operations with timer id " + timerId + ".");
        var delayedOp = DelayedOperation.createAndSchedule(this, timerId, delayMs, op, function (op) { return _this.removeDelayedOperation(op); });
        this.delayedOperations.push(delayedOp);
        return delayedOp;
    };
    AsyncQueue.prototype.verifyNotFailed = function () {
        if (this.failure) {
            fail('AsyncQueue is already failed: ' +
                (this.failure.stack || this.failure.message));
        }
    };
    /**
     * Verifies there's an operation currently in-progress on the AsyncQueue.
     * Unfortunately we can't verify that the running code is in the promise chain
     * of that operation, so this isn't a foolproof check, but it should be enough
     * to catch some bugs.
     */
    AsyncQueue.prototype.verifyOperationInProgress = function () {
        assert(this.operationInProgress, 'verifyOpInProgress() called when no op in progress on this queue.');
    };
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */
    AsyncQueue.prototype.drain = function () {
        return this.enqueue(function () { return Promise.resolve(); });
    };
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */
    AsyncQueue.prototype.containsDelayedOperation = function (timerId) {
        for (var _i = 0, _a = this.delayedOperations; _i < _a.length; _i++) {
            var op = _a[_i];
            if (op.timerId === timerId) {
                return true;
            }
        }
        return false;
    };
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId Delayed operations up to and including this TimerId will
     *  be drained. Throws if no such operation exists. Pass TimerId.All to run
     *  all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */
    AsyncQueue.prototype.runDelayedOperationsEarly = function (lastTimerId) {
        var _this = this;
        // Note that draining may generate more delayed ops, so we do that first.
        return this.drain().then(function () {
            assert(lastTimerId === TimerId.All ||
                _this.containsDelayedOperation(lastTimerId), "Attempted to drain to missing operation " + lastTimerId);
            // Run ops in the same order they'd run if they ran naturally.
            _this.delayedOperations.sort(function (a, b) { return a.targetTimeMs - b.targetTimeMs; });
            for (var _i = 0, _a = _this.delayedOperations; _i < _a.length; _i++) {
                var op = _a[_i];
                op.skipDelay();
                if (lastTimerId !== TimerId.All && op.timerId === lastTimerId) {
                    break;
                }
            }
            return _this.drain();
        });
    };
    /** Called once a DelayedOperation is run or canceled. */
    AsyncQueue.prototype.removeDelayedOperation = function (op) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        var index = this.delayedOperations.indexOf(op);
        assert(index >= 0, 'Delayed operation not found.');
        this.delayedOperations.splice(index, 1);
    };
    return AsyncQueue;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var escapeChar = '\u0001';
var encodedSeparatorChar = '\u0001';
var encodedNul = '\u0010';
var encodedEscape = '\u0011';
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */
function encode(path) {
    var result = '';
    for (var i = 0; i < path.length; i++) {
        if (result.length > 0) {
            result = encodeSeparator(result);
        }
        result = encodeSegment(path.get(i), result);
    }
    return encodeSeparator(result);
}
/** Encodes a single segment of a resource path into the given result */
function encodeSegment(segment, resultBuf) {
    var result = resultBuf;
    var length = segment.length;
    for (var i = 0; i < length; i++) {
        var c = segment.charAt(i);
        switch (c) {
            case '\0':
                result += escapeChar + encodedNul;
                break;
            case escapeChar:
                result += escapeChar + encodedEscape;
                break;
            default:
                result += c;
        }
    }
    return result;
}
/** Encodes a path separator into the given result */
function encodeSeparator(result) {
    return result + escapeChar + encodedSeparatorChar;
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */
function decode(path) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    var length = path.length;
    assert(length >= 2, 'Invalid path ' + path);
    if (length === 2) {
        assert(path.charAt(0) === escapeChar && path.charAt(1) === encodedSeparatorChar, 'Non-empty path ' + path + ' had length 2');
        return ResourcePath.EMPTY_PATH;
    }
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    var lastReasonableEscapeIndex = length - 2;
    var segments = [];
    var segmentBuilder = '';
    for (var start = 0; start < length;) {
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        var end = path.indexOf(escapeChar, start);
        if (end < 0 || end > lastReasonableEscapeIndex) {
            fail('Invalid encoded resource path: "' + path + '"');
        }
        var next = path.charAt(end + 1);
        switch (next) {
            case encodedSeparatorChar:
                var currentPiece = path.substring(start, end);
                var segment = void 0;
                if (segmentBuilder.length === 0) {
                    // Avoid copying for the common case of a segment that excludes \0
                    // and \001
                    segment = currentPiece;
                }
                else {
                    segmentBuilder += currentPiece;
                    segment = segmentBuilder;
                    segmentBuilder = '';
                }
                segments.push(segment);
                break;
            case encodedNul:
                segmentBuilder += path.substring(start, end);
                segmentBuilder += '\0';
                break;
            case encodedEscape:
                // The escape character can be used in the output to encode itself.
                segmentBuilder += path.substring(start, end + 1);
                break;
            default:
                fail('Invalid encoded resource path: "' + path + '"');
        }
        start = end + 2;
    }
    return new ResourcePath(segments);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var BATCHID_UNKNOWN = -1;
/**
 * A batch of mutations that will be sent as one unit to the backend.
 */
var MutationBatch = /** @class */ (function () {
    function MutationBatch(batchId, localWriteTime, mutations) {
        this.batchId = batchId;
        this.localWriteTime = localWriteTime;
        this.mutations = mutations;
        assert(mutations.length > 0, 'Cannot create an empty mutation batch');
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to create a new remote document
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     * @param batchResult The result of applying the MutationBatch to the
     * backend.
     */
    MutationBatch.prototype.applyToRemoteDocument = function (docKey, maybeDoc, batchResult) {
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(docKey), "applyToRemoteDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
        }
        var mutationResults = batchResult.mutationResults;
        assert(mutationResults.length === this.mutations.length, "Mismatch between mutations length\n      (" + this.mutations.length + ") and mutation results length\n      (" + mutationResults.length + ").");
        for (var i = 0; i < this.mutations.length; i++) {
            var mutation = this.mutations[i];
            if (mutation.key.isEqual(docKey)) {
                var mutationResult = mutationResults[i];
                maybeDoc = mutation.applyToRemoteDocument(maybeDoc, mutationResult);
            }
        }
        return maybeDoc;
    };
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     */
    MutationBatch.prototype.applyToLocalView = function (docKey, maybeDoc) {
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(docKey), "applyToLocalDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
        }
        var baseDoc = maybeDoc;
        for (var i = 0; i < this.mutations.length; i++) {
            var mutation = this.mutations[i];
            if (mutation.key.isEqual(docKey)) {
                maybeDoc = mutation.applyToLocalView(maybeDoc, baseDoc, this.localWriteTime);
            }
        }
        return maybeDoc;
    };
    MutationBatch.prototype.keys = function () {
        var keySet = documentKeySet();
        for (var _i = 0, _a = this.mutations; _i < _a.length; _i++) {
            var mutation = _a[_i];
            keySet = keySet.add(mutation.key);
        }
        return keySet;
    };
    MutationBatch.prototype.isEqual = function (other) {
        return (this.batchId === other.batchId &&
            arrayEquals(this.mutations, other.mutations));
    };
    return MutationBatch;
}());
/** The result of applying a mutation batch to the backend. */
var MutationBatchResult = /** @class */ (function () {
    function MutationBatchResult(batch, commitVersion, mutationResults, streamToken, 
    /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */
    docVersions) {
        this.batch = batch;
        this.commitVersion = commitVersion;
        this.mutationResults = mutationResults;
        this.streamToken = streamToken;
        this.docVersions = docVersions;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=>version mapping (docVersions).
     */
    MutationBatchResult.from = function (batch, commitVersion, results, streamToken) {
        assert(batch.mutations.length === results.length, 'Mutations sent ' +
            batch.mutations.length +
            ' must equal results received ' +
            results.length);
        var versionMap = documentVersionMap();
        var mutations = batch.mutations;
        for (var i = 0; i < mutations.length; i++) {
            versionMap = versionMap.insert(mutations[i].key, results[i].version);
        }
        return new MutationBatchResult(batch, commitVersion, results, streamToken, versionMap);
    };
    return MutationBatchResult;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RESERVED_BITS = 1;
var GeneratorIds;
(function (GeneratorIds) {
    GeneratorIds[GeneratorIds["QueryCache"] = 0] = "QueryCache";
    GeneratorIds[GeneratorIds["SyncEngine"] = 1] = "SyncEngine"; // The target IDs for limbo detection are odd (end in 1).
})(GeneratorIds || (GeneratorIds = {}));
/**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the query cache (via
 * forQueryCache()), and one for limbo documents (via forSyncEngine()). These
 * two generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */
// TODO(mrschmidt): Explore removing this class in favor of generating these IDs
// directly in SyncEngine and LocalStore.
var TargetIdGenerator = /** @class */ (function () {
    /**
     * Instantiates a new TargetIdGenerator. If a seed is provided, the generator
     * will use the seed value as the next target ID.
     */
    function TargetIdGenerator(generatorId, seed) {
        this.generatorId = generatorId;
        assert((generatorId & RESERVED_BITS) === generatorId, "Generator ID " + generatorId + " contains more than " + RESERVED_BITS + " reserved bits");
        this.seek(seed !== undefined ? seed : this.generatorId);
    }
    TargetIdGenerator.prototype.next = function () {
        var nextId = this.nextId;
        this.nextId += 1 << RESERVED_BITS;
        return nextId;
    };
    /**
     * Returns the ID that follows the given ID. Subsequent calls to `next()`
     * use the newly returned target ID as their base.
     */
    // PORTING NOTE: Multi-tab only.
    TargetIdGenerator.prototype.after = function (targetId) {
        this.seek(targetId + (1 << RESERVED_BITS));
        return this.next();
    };
    TargetIdGenerator.prototype.seek = function (targetId) {
        assert((targetId & RESERVED_BITS) === this.generatorId, 'Cannot supply target ID from different generator ID');
        this.nextId = targetId;
    };
    TargetIdGenerator.forQueryCache = function () {
        // We seed the query cache generator to return '2' as its first ID, as there
        // is no differentiation in the protocol layer between an unset number and
        // the number '0'. If we were to sent a target with target ID '0', the
        // backend would consider it unset and replace it with its own ID.
        var targetIdGenerator = new TargetIdGenerator(GeneratorIds.QueryCache, 2);
        return targetIdGenerator;
    };
    TargetIdGenerator.forSyncEngine = function () {
        // Sync engine assigns target IDs for limbo document detection.
        return new TargetIdGenerator(GeneratorIds.SyncEngine);
    };
    return TargetIdGenerator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * PersistencePromise<> is essentially a re-implementation of Promise<> except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise<> implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */
var PersistencePromise = /** @class */ (function () {
    function PersistencePromise(callback) {
        var _this = this;
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        // tslint:disable-next-line:no-any Accept any result type for the next call in the Promise chain.
        this.nextCallback = null;
        // tslint:disable-next-line:no-any Accept any result type for the error handler.
        this.catchCallback = null;
        // When the operation resolves, we'll set result or error and mark isDone.
        this.result = undefined;
        this.error = undefined;
        this.isDone = false;
        // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = false;
        callback(function (value) {
            _this.isDone = true;
            _this.result = value;
            if (_this.nextCallback) {
                // value should be defined unless T is Void, but we can't express
                // that in the type system.
                _this.nextCallback(value);
            }
        }, function (error) {
            _this.isDone = true;
            _this.error = error;
            if (_this.catchCallback) {
                _this.catchCallback(error);
            }
        });
    }
    PersistencePromise.prototype.catch = function (fn) {
        return this.next(undefined, fn);
    };
    PersistencePromise.prototype.next = function (nextFn, catchFn) {
        var _this = this;
        if (this.callbackAttached) {
            fail('Called next() or catch() twice for PersistencePromise');
        }
        this.callbackAttached = true;
        if (this.isDone) {
            if (!this.error) {
                return this.wrapSuccess(nextFn, this.result);
            }
            else {
                return this.wrapFailure(catchFn, this.error);
            }
        }
        else {
            return new PersistencePromise(function (resolve, reject) {
                _this.nextCallback = function (value) {
                    _this.wrapSuccess(nextFn, value).next(resolve, reject);
                };
                _this.catchCallback = function (error) {
                    _this.wrapFailure(catchFn, error).next(resolve, reject);
                };
            });
        }
    };
    PersistencePromise.prototype.toPromise = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.next(resolve, reject);
        });
    };
    PersistencePromise.prototype.wrapUserFunction = function (fn) {
        try {
            var result = fn();
            if (result instanceof PersistencePromise) {
                return result;
            }
            else {
                return PersistencePromise.resolve(result);
            }
        }
        catch (e) {
            return PersistencePromise.reject(e);
        }
    };
    PersistencePromise.prototype.wrapSuccess = function (nextFn, value) {
        if (nextFn) {
            return this.wrapUserFunction(function () { return nextFn(value); });
        }
        else {
            // If there's no nextFn, then R must be the same as T but we
            // can't express that in the type system.
            // tslint:disable-next-line:no-any
            return PersistencePromise.resolve(value);
        }
    };
    PersistencePromise.prototype.wrapFailure = function (catchFn, error) {
        if (catchFn) {
            return this.wrapUserFunction(function () { return catchFn(error); });
        }
        else {
            return PersistencePromise.reject(error);
        }
    };
    PersistencePromise.resolve = function (result) {
        return new PersistencePromise(function (resolve, reject) {
            resolve(result);
        });
    };
    PersistencePromise.reject = function (error) {
        return new PersistencePromise(function (resolve, reject) {
            reject(error);
        });
    };
    PersistencePromise.waitFor = function (
    // tslint:disable-next-line:no-any Accept all Promise types in waitFor().
    all) {
        return new PersistencePromise(function (resolve, reject) {
            var expectedCount = 0;
            var resolvedCount = 0;
            var done = false;
            all.forEach(function (element) {
                ++expectedCount;
                element.next(function () {
                    ++resolvedCount;
                    if (done && resolvedCount === expectedCount) {
                        resolve();
                    }
                }, function (err) { return reject(err); });
            });
            done = true;
            if (resolvedCount === expectedCount) {
                resolve();
            }
        });
    };
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */
    PersistencePromise.or = function (predicates) {
        var p = PersistencePromise.resolve(false);
        var _loop_1 = function (predicate) {
            p = p.next(function (isTrue) {
                if (isTrue) {
                    return PersistencePromise.resolve(isTrue);
                }
                else {
                    return predicate();
                }
            });
        };
        for (var _i = 0, predicates_1 = predicates; _i < predicates_1.length; _i++) {
            var predicate = predicates_1[_i];
            _loop_1(predicate);
        }
        return p;
    };
    /**
     * Given an iterable, call the given function on each element in the
     * collection and wait for all of the resulting concurrent PersistencePromises
     * to resolve.
     */
    PersistencePromise.forEach = function (collection, f) {
        var _this = this;
        var promises = [];
        collection.forEach(function (r, s) {
            promises.push(f.call(_this, r, s));
        });
        return this.waitFor(promises);
    };
    return PersistencePromise;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$1 = 'SimpleDb';
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */
var SimpleDb = /** @class */ (function () {
    function SimpleDb(db) {
        this.db = db;
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support downgrading the schema
     * version. We currently do not support any way to do versioning outside of IndexedDB's versioning
     * mechanism, as only version-upgrade transactions are allowed to do things like create
     * objectstores.
     */
    SimpleDb.openOrCreate = function (name, version, schemaConverter) {
        assert(SimpleDb.isAvailable(), 'IndexedDB not supported in current environment.');
        debug(LOG_TAG$1, 'Opening database:', name);
        return new PersistencePromise(function (resolve, reject) {
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            var request = window.indexedDB.open(name, version);
            request.onsuccess = function (event) {
                var db = event.target.result;
                resolve(new SimpleDb(db));
            };
            request.onblocked = function () {
                reject(new FirestoreError(Code.FAILED_PRECONDITION, 'Cannot upgrade IndexedDB schema while another tab is open. ' +
                    'Close all tabs that access Firestore and reload this page to proceed.'));
            };
            request.onerror = function (event) {
                var error$$1 = event.target.error;
                if (error$$1.name === 'VersionError') {
                    reject(new FirestoreError(Code.FAILED_PRECONDITION, 'A newer version of the Firestore SDK was previously used and so the persisted ' +
                        'data is not compatible with the version of the SDK you are now using. The SDK ' +
                        'will operate with persistence disabled. If you need persistence, please ' +
                        're-upgrade to a newer version of the SDK or else clear the persisted IndexedDB ' +
                        'data for your app to start fresh.'));
                }
                else {
                    reject(error$$1);
                }
            };
            request.onupgradeneeded = function (event) {
                debug(LOG_TAG$1, 'Database "' + name + '" requires upgrade from version:', event.oldVersion);
                var db = event.target.result;
                // We are provided a version upgrade transaction from the request, so
                // we wrap that in a SimpleDbTransaction to allow use of our friendlier
                // API for schema migration operations.
                var txn = new SimpleDbTransaction(request.transaction);
                schemaConverter
                    .createOrUpgrade(db, txn, event.oldVersion, SCHEMA_VERSION)
                    .next(function () {
                    debug(LOG_TAG$1, 'Database upgrade to version ' + SCHEMA_VERSION + ' complete');
                });
            };
        }).toPromise();
    };
    /** Deletes the specified database. */
    SimpleDb.delete = function (name) {
        debug(LOG_TAG$1, 'Removing database:', name);
        return wrapRequest(window.indexedDB.deleteDatabase(name)).toPromise();
    };
    /** Returns true if IndexedDB is available in the current environment. */
    SimpleDb.isAvailable = function () {
        if (typeof window === 'undefined' || window.indexedDB == null) {
            return false;
        }
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // If we are running in Node using the IndexedDBShim, `window` is defined,
        // but `window.navigator` is not. In this case, we support IndexedDB and
        // return `true`.
        if (window.navigator === undefined) {
            return Object({"NODE_ENV":"production"}).USE_MOCK_PERSISTENCE === 'YES';
        }
        // Check the UA string to find out the browser.
        // TODO(mikelehen): Move this logic into packages/util/environment.ts
        var ua = window.navigator.userAgent;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        if (ua.indexOf('MSIE ') > 0 ||
            ua.indexOf('Trident/') > 0 ||
            ua.indexOf('Edge/') > 0) {
            return false;
        }
        else {
            return true;
        }
    };
    /** Helper to get a typed SimpleDbStore from a transaction. */
    SimpleDb.getStore = function (txn, store) {
        return txn.store(store);
    };
    SimpleDb.prototype.runTransaction = function (mode, objectStores, transactionFn) {
        var transaction = SimpleDbTransaction.open(this.db, mode, objectStores);
        var transactionFnResult = transactionFn(transaction)
            .catch(function (error$$1) {
            // Abort the transaction if there was an error.
            transaction.abort(error$$1);
            // We cannot actually recover, and calling `abort()` will cause the transaction's
            // completion promise to be rejected. This in turn means that we won't use
            // `transactionFnResult` below. We return a rejection here so that we don't add the
            // possibility of returning `void` to the type of `transactionFnResult`.
            return PersistencePromise.reject(error$$1);
        })
            .toPromise();
        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
        // fire), but still return the original transactionFnResult back to the
        // caller.
        return transaction.completionPromise.then(function () { return transactionFnResult; });
    };
    SimpleDb.prototype.close = function () {
        this.db.close();
    };
    return SimpleDb;
}());
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */
var IterationController = /** @class */ (function () {
    function IterationController(dbCursor) {
        this.dbCursor = dbCursor;
        this.shouldStop = false;
        this.nextKey = null;
    }
    Object.defineProperty(IterationController.prototype, "isDone", {
        get: function () {
            return this.shouldStop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IterationController.prototype, "skipToKey", {
        get: function () {
            return this.nextKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IterationController.prototype, "cursor", {
        set: function (value) {
            this.dbCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This function can be called to stop iteration at any point.
     */
    IterationController.prototype.done = function () {
        this.shouldStop = true;
    };
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */
    IterationController.prototype.skip = function (key) {
        this.nextKey = key;
    };
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */
    IterationController.prototype.delete = function () {
        return wrapRequest(this.dbCursor.delete());
    };
    return IterationController;
}());
/**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */
var SimpleDbTransaction = /** @class */ (function () {
    function SimpleDbTransaction(transaction) {
        var _this = this;
        this.transaction = transaction;
        this.aborted = false;
        /**
         * A promise that resolves with the result of the IndexedDb transaction.
         */
        this.completionDeferred = new Deferred();
        this.transaction.oncomplete = function () {
            _this.completionDeferred.resolve();
        };
        this.transaction.onabort = function () {
            if (transaction.error) {
                _this.completionDeferred.reject(transaction.error);
            }
            else {
                _this.completionDeferred.resolve();
            }
        };
        this.transaction.onerror = function (event) {
            _this.completionDeferred.reject(event.target.error);
        };
    }
    SimpleDbTransaction.open = function (db, mode, objectStoreNames) {
        return new SimpleDbTransaction(db.transaction(objectStoreNames, mode));
    };
    Object.defineProperty(SimpleDbTransaction.prototype, "completionPromise", {
        get: function () {
            return this.completionDeferred.promise;
        },
        enumerable: true,
        configurable: true
    });
    SimpleDbTransaction.prototype.abort = function (error$$1) {
        if (error$$1) {
            this.completionDeferred.reject(error$$1);
        }
        if (!this.aborted) {
            debug(LOG_TAG$1, 'Aborting transaction:', error$$1 ? error$$1.message : 'Client-initiated abort');
            this.aborted = true;
            this.transaction.abort();
        }
    };
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */
    SimpleDbTransaction.prototype.store = function (storeName) {
        var store = this.transaction.objectStore(storeName);
        assert(!!store, 'Object store not part of transaction: ' + storeName);
        return new SimpleDbStore(store);
    };
    return SimpleDbTransaction;
}());
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */
var SimpleDbStore = /** @class */ (function () {
    function SimpleDbStore(store) {
        this.store = store;
    }
    SimpleDbStore.prototype.put = function (keyOrValue, value) {
        var request;
        if (value !== undefined) {
            debug(LOG_TAG$1, 'PUT', this.store.name, keyOrValue, value);
            request = this.store.put(value, keyOrValue);
        }
        else {
            debug(LOG_TAG$1, 'PUT', this.store.name, '<auto-key>', keyOrValue);
            request = this.store.put(keyOrValue);
        }
        return wrapRequest(request);
    };
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value The object to write.
     * @return The key of the value to add.
     */
    SimpleDbStore.prototype.add = function (value) {
        debug(LOG_TAG$1, 'ADD', this.store.name, value, value);
        var request = this.store.add(value);
        return wrapRequest(request);
    };
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @return The object with the specified key or null if no object exists.
     */
    SimpleDbStore.prototype.get = function (key) {
        var _this = this;
        var request = this.store.get(key);
        // tslint:disable-next-line:no-any We're doing an unsafe cast to ValueType.
        return wrapRequest(request).next(function (result) {
            // Normalize nonexistence to null.
            if (result === undefined) {
                result = null;
            }
            debug(LOG_TAG$1, 'GET', _this.store.name, key, result);
            return result;
        });
    };
    SimpleDbStore.prototype.delete = function (key) {
        debug(LOG_TAG$1, 'DELETE', this.store.name, key);
        var request = this.store.delete(key);
        return wrapRequest(request);
    };
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */
    SimpleDbStore.prototype.count = function () {
        debug(LOG_TAG$1, 'COUNT', this.store.name);
        var request = this.store.count();
        return wrapRequest(request);
    };
    SimpleDbStore.prototype.loadAll = function (indexOrRange, range) {
        var cursor = this.cursor(this.options(indexOrRange, range));
        var results = [];
        return this.iterateCursor(cursor, function (key, value) {
            results.push(value);
        }).next(function () {
            return results;
        });
    };
    SimpleDbStore.prototype.deleteAll = function (indexOrRange, range) {
        debug(LOG_TAG$1, 'DELETE ALL', this.store.name);
        var options = this.options(indexOrRange, range);
        options.keysOnly = false;
        var cursor = this.cursor(options);
        return this.iterateCursor(cursor, function (key, value, control) {
            // NOTE: Calling delete() on a cursor is documented as more efficient than
            // calling delete() on an object store with a single key
            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/delete),
            // however, this requires us *not* to use a keysOnly cursor
            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBCursor/delete). We
            // may want to compare the performance of each method.
            return control.delete();
        });
    };
    SimpleDbStore.prototype.iterate = function (optionsOrCallback, callback) {
        var options;
        if (!callback) {
            options = {};
            callback = optionsOrCallback;
        }
        else {
            options = optionsOrCallback;
        }
        var cursor = this.cursor(options);
        return this.iterateCursor(cursor, callback);
    };
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */
    SimpleDbStore.prototype.iterateSerial = function (callback) {
        var cursorRequest = this.cursor({});
        return new PersistencePromise(function (resolve, reject) {
            cursorRequest.onerror = function (event) {
                reject(event.target.error);
            };
            cursorRequest.onsuccess = function (event) {
                var cursor = event.target.result;
                if (!cursor) {
                    resolve();
                    return;
                }
                callback(cursor.primaryKey, cursor.value).next(function (shouldContinue) {
                    if (shouldContinue) {
                        cursor.continue();
                    }
                    else {
                        resolve();
                    }
                });
            };
        });
    };
    SimpleDbStore.prototype.iterateCursor = function (cursorRequest, fn) {
        var results = [];
        return new PersistencePromise(function (resolve, reject) {
            cursorRequest.onerror = function (event) {
                reject(event.target.error);
            };
            cursorRequest.onsuccess = function (event) {
                var cursor = event.target.result;
                if (!cursor) {
                    resolve();
                    return;
                }
                var controller = new IterationController(cursor);
                var userResult = fn(cursor.primaryKey, cursor.value, controller);
                if (userResult instanceof PersistencePromise) {
                    var userPromise = userResult.catch(function (err) {
                        controller.done();
                        return PersistencePromise.reject(err);
                    });
                    results.push(userPromise);
                }
                if (controller.isDone) {
                    resolve();
                }
                else if (controller.skipToKey === null) {
                    cursor.continue();
                }
                else {
                    cursor.continue(controller.skipToKey);
                }
            };
        }).next(function () {
            return PersistencePromise.waitFor(results);
        });
    };
    SimpleDbStore.prototype.options = function (indexOrRange, range) {
        var indexName = undefined;
        if (indexOrRange !== undefined) {
            if (typeof indexOrRange === 'string') {
                indexName = indexOrRange;
            }
            else {
                assert(range === undefined, '3rd argument must not be defined if 2nd is a range.');
                range = indexOrRange;
            }
        }
        return { index: indexName, range: range };
    };
    SimpleDbStore.prototype.cursor = function (options) {
        var direction = 'next';
        if (options.reverse) {
            direction = 'prev';
        }
        if (options.index) {
            var index = this.store.index(options.index);
            if (options.keysOnly) {
                return index.openKeyCursor(options.range, direction);
            }
            else {
                return index.openCursor(options.range, direction);
            }
        }
        else {
            return this.store.openCursor(options.range, direction);
        }
    };
    return SimpleDbStore;
}());
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */
function wrapRequest(request) {
    return new PersistencePromise(function (resolve, reject) {
        request.onsuccess = function (event) {
            var result = event.target.result;
            resolve(result);
        };
        request.onerror = function (event) {
            reject(event.target.error);
        };
    });
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IndexedDbQueryCache = /** @class */ (function () {
    function IndexedDbQueryCache(referenceDelegate, serializer) {
        this.referenceDelegate = referenceDelegate;
        this.serializer = serializer;
        // PORTING NOTE: We don't cache global metadata for the query cache, since
        // some of it (in particular `highestTargetId`) can be modified by secondary
        // tabs. We could perhaps be more granular (and e.g. still cache
        // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
        // to IndexedDb whenever we need to read metadata. We can revisit if it turns
        // out to have a meaningful performance impact.
        this.targetIdGenerator = TargetIdGenerator.forQueryCache();
    }
    IndexedDbQueryCache.prototype.allocateTargetId = function (transaction) {
        var _this = this;
        return this.retrieveMetadata(transaction).next(function (metadata) {
            metadata.highestTargetId = _this.targetIdGenerator.after(metadata.highestTargetId);
            return _this.saveMetadata(transaction, metadata).next(function () { return metadata.highestTargetId; });
        });
    };
    IndexedDbQueryCache.prototype.getLastRemoteSnapshotVersion = function (transaction) {
        return this.retrieveMetadata(transaction).next(function (metadata) {
            return SnapshotVersion.fromTimestamp(new Timestamp(metadata.lastRemoteSnapshotVersion.seconds, metadata.lastRemoteSnapshotVersion.nanoseconds));
        });
    };
    IndexedDbQueryCache.prototype.getHighestSequenceNumber = function (transaction) {
        return getHighestListenSequenceNumber(transaction.simpleDbTransaction);
    };
    IndexedDbQueryCache.prototype.setTargetsMetadata = function (transaction, highestListenSequenceNumber, lastRemoteSnapshotVersion) {
        var _this = this;
        return this.retrieveMetadata(transaction).next(function (metadata) {
            metadata.highestListenSequenceNumber = highestListenSequenceNumber;
            if (lastRemoteSnapshotVersion) {
                metadata.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion.toTimestamp();
            }
            if (highestListenSequenceNumber > metadata.highestListenSequenceNumber) {
                metadata.highestListenSequenceNumber = highestListenSequenceNumber;
            }
            return _this.saveMetadata(transaction, metadata);
        });
    };
    IndexedDbQueryCache.prototype.addQueryData = function (transaction, queryData) {
        var _this = this;
        return this.saveQueryData(transaction, queryData).next(function () {
            return _this.retrieveMetadata(transaction).next(function (metadata) {
                metadata.targetCount += 1;
                _this.updateMetadataFromQueryData(queryData, metadata);
                return _this.saveMetadata(transaction, metadata);
            });
        });
    };
    IndexedDbQueryCache.prototype.updateQueryData = function (transaction, queryData) {
        return this.saveQueryData(transaction, queryData);
    };
    IndexedDbQueryCache.prototype.removeQueryData = function (transaction, queryData) {
        var _this = this;
        return this.removeMatchingKeysForTargetId(transaction, queryData.targetId)
            .next(function () { return targetsStore(transaction).delete(queryData.targetId); })
            .next(function () { return _this.retrieveMetadata(transaction); })
            .next(function (metadata) {
            assert(metadata.targetCount > 0, 'Removing from an empty query cache');
            metadata.targetCount -= 1;
            return _this.saveMetadata(transaction, metadata);
        });
    };
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */
    IndexedDbQueryCache.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        var _this = this;
        var count = 0;
        var promises = [];
        return targetsStore(txn)
            .iterate(function (key, value) {
            var queryData = _this.serializer.fromDbTarget(value);
            if (queryData.sequenceNumber <= upperBound &&
                activeTargetIds[queryData.targetId] === undefined) {
                count++;
                promises.push(_this.removeQueryData(txn, queryData));
            }
        })
            .next(function () { return PersistencePromise.waitFor(promises); })
            .next(function () { return count; });
    };
    /**
     * Call provided function with each `QueryData` that we have cached.
     */
    IndexedDbQueryCache.prototype.forEachTarget = function (txn, f) {
        var _this = this;
        return targetsStore(txn).iterate(function (key, value) {
            var queryData = _this.serializer.fromDbTarget(value);
            f(queryData);
        });
    };
    IndexedDbQueryCache.prototype.retrieveMetadata = function (transaction) {
        return retrieveMetadata(transaction.simpleDbTransaction);
    };
    IndexedDbQueryCache.prototype.saveMetadata = function (transaction, metadata) {
        return globalTargetStore(transaction).put(DbTargetGlobal.key, metadata);
    };
    IndexedDbQueryCache.prototype.saveQueryData = function (transaction, queryData) {
        return targetsStore(transaction).put(this.serializer.toDbTarget(queryData));
    };
    /**
     * In-place updates the provided metadata to account for values in the given
     * QueryData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */
    IndexedDbQueryCache.prototype.updateMetadataFromQueryData = function (queryData, metadata) {
        var updated = false;
        if (queryData.targetId > metadata.highestTargetId) {
            metadata.highestTargetId = queryData.targetId;
            updated = true;
        }
        if (queryData.sequenceNumber > metadata.highestListenSequenceNumber) {
            metadata.highestListenSequenceNumber = queryData.sequenceNumber;
            updated = true;
        }
        return updated;
    };
    IndexedDbQueryCache.prototype.getQueryCount = function (transaction) {
        return this.retrieveMetadata(transaction).next(function (metadata) { return metadata.targetCount; });
    };
    IndexedDbQueryCache.prototype.getQueryData = function (transaction, query) {
        var _this = this;
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        var canonicalId = query.canonicalId();
        var range = IDBKeyRange.bound([canonicalId, Number.NEGATIVE_INFINITY], [canonicalId, Number.POSITIVE_INFINITY]);
        var result = null;
        return targetsStore(transaction)
            .iterate({ range: range, index: DbTarget.queryTargetsIndexName }, function (key, value, control) {
            var found = _this.serializer.fromDbTarget(value);
            // After finding a potential match, check that the query is
            // actually equal to the requested query.
            if (query.isEqual(found.query)) {
                result = found;
                control.done();
            }
        })
            .next(function () { return result; });
    };
    IndexedDbQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
        var _this = this;
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        var promises = [];
        var store = documentTargetStore(txn);
        keys.forEach(function (key) {
            var path = encode(key.path);
            promises.push(store.put(new DbTargetDocument(targetId, path)));
            promises.push(_this.referenceDelegate.addReference(txn, key));
        });
        return PersistencePromise.waitFor(promises);
    };
    IndexedDbQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
        var _this = this;
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        var store = documentTargetStore(txn);
        return PersistencePromise.forEach(keys, function (key) {
            var path = encode(key.path);
            return PersistencePromise.waitFor([
                store.delete([targetId, path]),
                _this.referenceDelegate.removeReference(txn, key)
            ]);
        });
    };
    IndexedDbQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
        var store = documentTargetStore(txn);
        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        return store.delete(range);
    };
    IndexedDbQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        var store = documentTargetStore(txn);
        var result = documentKeySet();
        return store
            .iterate({ range: range, keysOnly: true }, function (key, _, control) {
            var path = decode(key[1]);
            var docKey = new DocumentKey(path);
            result = result.add(docKey);
        })
            .next(function () { return result; });
    };
    IndexedDbQueryCache.prototype.containsKey = function (txn, key) {
        var path = encode(key.path);
        var range = IDBKeyRange.bound([path], [immediateSuccessor(path)], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        var count = 0;
        return documentTargetStore(txn)
            .iterate({
            index: DbTargetDocument.documentTargetsIndex,
            keysOnly: true,
            range: range
        }, function (_a, _, control) {
            var targetId = _a[0], path = _a[1];
            // Having a sentinel row for a document does not count as containing that document;
            // For the query cache, containing the document means the document is part of some
            // target.
            if (targetId !== 0) {
                count++;
                control.done();
            }
        })
            .next(function () { return count > 0; });
    };
    IndexedDbQueryCache.prototype.getQueryDataForTarget = function (transaction, targetId) {
        var _this = this;
        return targetsStore(transaction)
            .get(targetId)
            .next(function (found) {
            if (found) {
                return _this.serializer.fromDbTarget(found);
            }
            else {
                return null;
            }
        });
    };
    return IndexedDbQueryCache;
}());
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */
function targetsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTarget.store);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */
function globalTargetStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTargetGlobal.store);
}
function retrieveMetadata(txn) {
    var globalStore = SimpleDb.getStore(txn, DbTargetGlobal.store);
    return globalStore.get(DbTargetGlobal.key).next(function (metadata) {
        assert(metadata !== null, 'Missing metadata row.');
        return metadata;
    });
}
function getHighestListenSequenceNumber(txn) {
    return retrieveMetadata(txn).next(function (targetGlobal) { return targetGlobal.highestListenSequenceNumber; });
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */
function documentTargetStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTargetDocument.store);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A map implementation that uses objects as keys. Objects must implement the
 * Equatable interface and must be immutable. Entries in the map are stored
 * together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */
var ObjectMap = /** @class */ (function () {
    function ObjectMap(mapKeyFn) {
        this.mapKeyFn = mapKeyFn;
        /**
         * The inner map for a key -> value pair. Due to the possibility of
         * collisions we keep a list of entries that we do a linear search through
         * to find an actual match. Note that collisions should be rare, so we still
         * expect near constant time lookups in practice.
         */
        this.inner = {};
    }
    /** Get a value for this key, or undefined if it does not exist. */
    ObjectMap.prototype.get = function (key) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            return undefined;
        }
        for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
            var _a = matches_1[_i], otherKey = _a[0], value = _a[1];
            if (otherKey.isEqual(key)) {
                return value;
            }
        }
        return undefined;
    };
    ObjectMap.prototype.has = function (key) {
        return this.get(key) !== undefined;
    };
    /** Put this key and value in the map. */
    ObjectMap.prototype.set = function (key, value) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            this.inner[id] = [[key, value]];
            return;
        }
        for (var i = 0; i < matches.length; i++) {
            if (matches[i][0].isEqual(key)) {
                matches[i] = [key, value];
                return;
            }
        }
        matches.push([key, value]);
    };
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */
    ObjectMap.prototype.delete = function (key) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            return false;
        }
        for (var i = 0; i < matches.length; i++) {
            if (matches[i][0].isEqual(key)) {
                if (matches.length === 1) {
                    delete this.inner[id];
                }
                else {
                    matches.splice(i, 1);
                }
                return true;
            }
        }
        return false;
    };
    ObjectMap.prototype.forEach = function (fn) {
        forEach(this.inner, function (_, entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                fn(k, v);
            }
        });
    };
    ObjectMap.prototype.isEmpty = function () {
        return isEmpty(this.inner);
    };
    return ObjectMap;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */
var RemoteDocumentChangeBuffer = /** @class */ (function () {
    function RemoteDocumentChangeBuffer() {
        this.changes = maybeDocumentMap();
        this.documentSizes = new ObjectMap(function (key) {
            return key.toString();
        });
    }
    /** Buffers a `RemoteDocumentCache.addEntry()` call. */
    RemoteDocumentChangeBuffer.prototype.addEntry = function (maybeDocument) {
        var changes = this.assertChanges();
        this.changes = changes.insert(maybeDocument.key, maybeDocument);
    };
    // NOTE: removeEntry() is intentionally omitted. If it needs to be added in
    // the future it must take byte counting into account.
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKey The key of the entry to look up.
     * @return The cached Document or NoDocument entry, or null if we have nothing
     * cached.
     */
    RemoteDocumentChangeBuffer.prototype.getEntry = function (transaction, documentKey) {
        var _this = this;
        var changes = this.assertChanges();
        var bufferedEntry = changes.get(documentKey);
        if (bufferedEntry) {
            return PersistencePromise.resolve(bufferedEntry);
        }
        else {
            // Record the size of everything we load from the cache so we can compute a delta later.
            return this.getFromCache(transaction, documentKey).next(function (getResult) {
                if (getResult === null) {
                    _this.documentSizes.set(documentKey, 0);
                    return null;
                }
                else {
                    _this.documentSizes.set(documentKey, getResult.size);
                    return getResult.maybeDocument;
                }
            });
        }
    };
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys The keys of the entries to look up.
     * @return A map of cached `Document`s or `NoDocument`s, indexed by key. If an
     *     entry cannot be found, the corresponding key will be mapped to a null
     *     value.
     */
    RemoteDocumentChangeBuffer.prototype.getEntries = function (transaction, documentKeys) {
        var _this = this;
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.getAllFromCache(transaction, documentKeys).next(function (_a) {
            var maybeDocuments = _a.maybeDocuments, sizeMap = _a.sizeMap;
            // Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `NullableMaybeDocumentMap` directly, without a conversion.
            sizeMap.forEach(function (documentKey, size) {
                _this.documentSizes.set(documentKey, size);
            });
            return maybeDocuments;
        });
    };
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */
    RemoteDocumentChangeBuffer.prototype.apply = function (transaction) {
        var result = this.applyChanges(transaction);
        // We should not buffer any more changes.
        this.changes = null;
        return result;
    };
    /** Helper to assert this.changes is not null and return it. */
    RemoteDocumentChangeBuffer.prototype.assertChanges = function () {
        assert(this.changes !== null, 'Changes have already been applied.');
        return this.changes;
    };
    return RemoteDocumentChangeBuffer;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG = 'The remote document changelog no longer contains all changes for all ' +
    'local query views. It may be necessary to rebuild these views.';
var IndexedDbRemoteDocumentCache = /** @class */ (function () {
    /**
     * @param {LocalSerializer} serializer The document serializer.
     * @param keepDocumentChangeLog Whether to keep a document change log in
     * IndexedDb. This change log is required for Multi-Tab synchronization, but
     * not needed in clients that don't share access to their remote document
     * cache.
     */
    function IndexedDbRemoteDocumentCache(serializer, keepDocumentChangeLog) {
        this.serializer = serializer;
        this.keepDocumentChangeLog = keepDocumentChangeLog;
        /** The last id read by `getNewDocumentChanges()`. */
        this._lastProcessedDocumentChangeId = 0;
    }
    Object.defineProperty(IndexedDbRemoteDocumentCache.prototype, "lastProcessedDocumentChangeId", {
        get: function () {
            return this._lastProcessedDocumentChangeId;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Starts up the remote document cache.
     *
     * Reads the ID of the last  document change from the documentChanges store.
     * Existing changes will not be returned as part of
     * `getNewDocumentChanges()`.
     */
    // PORTING NOTE: This is only used for multi-tab synchronization.
    IndexedDbRemoteDocumentCache.prototype.start = function (transaction) {
        var store = SimpleDb.getStore(transaction, DbRemoteDocumentChanges.store);
        return this.synchronizeLastDocumentChangeId(store);
    };
    /**
     * Adds the supplied entries to the cache. Adds the given size delta to the cached size.
     */
    IndexedDbRemoteDocumentCache.prototype.addEntries = function (transaction, entries, sizeDelta) {
        var promises = [];
        if (entries.length > 0) {
            var documentStore = remoteDocumentsStore(transaction);
            var changedKeys = documentKeySet();
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], key = _a.key, doc = _a.doc;
                promises.push(documentStore.put(dbKey(key), doc));
                changedKeys = changedKeys.add(key);
            }
            if (this.keepDocumentChangeLog) {
                promises.push(documentChangesStore(transaction).put({
                    changes: this.serializer.toDbResourcePaths(changedKeys)
                }));
            }
            promises.push(this.updateSize(transaction, sizeDelta));
        }
        return PersistencePromise.waitFor(promises);
    };
    /**
     * Removes a document from the cache. Note that this method does *not* do any
     * size accounting. It is the responsibility of the caller to count the bytes removed
     * and issue a final updateSize() call after removing documents.
     *
     * @param documentKey The key of the document to remove
     * @return The size of the document that was removed.
     */
    IndexedDbRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
        // We don't need to keep changelog for these removals since `removeEntry` is
        // only used for garbage collection.
        var store = remoteDocumentsStore(transaction);
        var key = dbKey(documentKey);
        return store.get(key).next(function (document) {
            if (document) {
                return store.delete(key).next(function () { return dbDocumentSize(document); });
            }
            else {
                return PersistencePromise.resolve(0);
            }
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
        var _this = this;
        return remoteDocumentsStore(transaction)
            .get(dbKey(documentKey))
            .next(function (dbRemoteDoc) {
            return dbRemoteDoc
                ? _this.serializer.fromDbRemoteDocument(dbRemoteDoc)
                : null;
        });
    };
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey The key of the entry to look up.
     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
     */
    IndexedDbRemoteDocumentCache.prototype.getSizedEntry = function (transaction, documentKey) {
        var _this = this;
        return remoteDocumentsStore(transaction)
            .get(dbKey(documentKey))
            .next(function (dbRemoteDoc) {
            return dbRemoteDoc
                ? {
                    maybeDocument: _this.serializer.fromDbRemoteDocument(dbRemoteDoc),
                    size: dbDocumentSize(dbRemoteDoc)
                }
                : null;
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        return this.forEachDbEntry(transaction, documentKeys, function (key, dbRemoteDoc) {
            if (dbRemoteDoc) {
                results = results.insert(key, _this.serializer.fromDbRemoteDocument(dbRemoteDoc));
            }
            else {
                results = results.insert(key, null);
            }
        }).next(function () { return results; });
    };
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys The set of keys entries to look up.
     * @return A map of MaybeDocuments indexed by key (if a document cannot be
     *     found, the key will be mapped to null) and a map of sizes indexed by
     *     key (zero if the key cannot be found).
     */
    IndexedDbRemoteDocumentCache.prototype.getSizedEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        var sizeMap = new SortedMap(DocumentKey.comparator);
        return this.forEachDbEntry(transaction, documentKeys, function (key, dbRemoteDoc) {
            if (dbRemoteDoc) {
                results = results.insert(key, _this.serializer.fromDbRemoteDocument(dbRemoteDoc));
                sizeMap = sizeMap.insert(key, dbDocumentSize(dbRemoteDoc));
            }
            else {
                results = results.insert(key, null);
                sizeMap = sizeMap.insert(key, 0);
            }
        }).next(function () {
            return { maybeDocuments: results, sizeMap: sizeMap };
        });
    };
    IndexedDbRemoteDocumentCache.prototype.forEachDbEntry = function (transaction, documentKeys, callback) {
        if (documentKeys.isEmpty()) {
            return PersistencePromise.resolve();
        }
        var range = IDBKeyRange.bound(documentKeys.first().path.toArray(), documentKeys.last().path.toArray());
        var keyIter = documentKeys.getIterator();
        var nextKey = keyIter.getNext();
        return remoteDocumentsStore(transaction)
            .iterate({ range: range }, function (potentialKeyRaw, dbRemoteDoc, control) {
            var potentialKey = DocumentKey.fromSegments(potentialKeyRaw);
            // Go through keys not found in cache.
            while (nextKey && DocumentKey.comparator(nextKey, potentialKey) < 0) {
                callback(nextKey, null);
                nextKey = keyIter.getNext();
            }
            if (nextKey && nextKey.isEqual(potentialKey)) {
                // Key found in cache.
                callback(nextKey, dbRemoteDoc);
                nextKey = keyIter.hasNext() ? keyIter.getNext() : null;
            }
            // Skip to the next key (if there is one).
            if (nextKey) {
                control.skip(nextKey.path.toArray());
            }
            else {
                control.done();
            }
        })
            .next(function () {
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            while (nextKey) {
                callback(nextKey, null);
                nextKey = keyIter.hasNext() ? keyIter.getNext() : null;
            }
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        var _this = this;
        var results = documentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        var startKey = query.path.toArray();
        var range = IDBKeyRange.lowerBound(startKey);
        return remoteDocumentsStore(transaction)
            .iterate({ range: range }, function (key, dbRemoteDoc, control) {
            var maybeDoc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
            if (!query.path.isPrefixOf(maybeDoc.key.path)) {
                control.done();
            }
            else if (maybeDoc instanceof Document && query.matches(maybeDoc)) {
                results = results.insert(maybeDoc.key, maybeDoc);
            }
        })
            .next(function () { return results; });
    };
    IndexedDbRemoteDocumentCache.prototype.getNewDocumentChanges = function (transaction) {
        var _this = this;
        assert(this.keepDocumentChangeLog, 'Can only call getNewDocumentChanges() when document change log is enabled');
        var changedKeys = documentKeySet();
        var changedDocs = maybeDocumentMap();
        var range = IDBKeyRange.lowerBound(this._lastProcessedDocumentChangeId + 1);
        var firstIteration = true;
        var changesStore = documentChangesStore(transaction);
        return changesStore
            .iterate({ range: range }, function (_, documentChange) {
            if (firstIteration) {
                firstIteration = false;
                // If our client was throttled for more than 30 minutes, another
                // client may have garbage collected the remote document changelog.
                if (_this._lastProcessedDocumentChangeId + 1 !== documentChange.id) {
                    // Reset the `lastProcessedDocumentChangeId` to allow further
                    // invocations to successfully return the changes after this
                    // rejection.
                    return _this.synchronizeLastDocumentChangeId(changesStore).next(function () {
                        return PersistencePromise.reject(new FirestoreError(Code.DATA_LOSS, REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG));
                    });
                }
            }
            changedKeys = changedKeys.unionWith(_this.serializer.fromDbResourcePaths(documentChange.changes));
            _this._lastProcessedDocumentChangeId = documentChange.id;
        })
            .next(function () {
            var documentPromises = [];
            changedKeys.forEach(function (key) {
                documentPromises.push(_this.getEntry(transaction, key).next(function (maybeDocument) {
                    var doc = maybeDocument ||
                        new NoDocument(key, SnapshotVersion.forDeletedDoc());
                    changedDocs = changedDocs.insert(key, doc);
                }));
            });
            return PersistencePromise.waitFor(documentPromises);
        })
            .next(function () { return changedDocs; });
    };
    /**
     * Removes all changes in the remote document changelog through `changeId`
     * (inclusive).
     */
    IndexedDbRemoteDocumentCache.prototype.removeDocumentChangesThroughChangeId = function (transaction, changeId) {
        var range = IDBKeyRange.upperBound(changeId);
        return documentChangesStore(transaction).delete(range);
    };
    IndexedDbRemoteDocumentCache.prototype.synchronizeLastDocumentChangeId = function (documentChangesStore) {
        var _this = this;
        // If there are no existing changes, we set `lastProcessedDocumentChangeId`
        // to 0 since IndexedDb's auto-generated keys start at 1.
        this._lastProcessedDocumentChangeId = 0;
        return documentChangesStore.iterate({ keysOnly: true, reverse: true }, function (key, value, control) {
            _this._lastProcessedDocumentChangeId = key;
            control.done();
        });
    };
    IndexedDbRemoteDocumentCache.prototype.newChangeBuffer = function () {
        return new IndexedDbRemoteDocumentChangeBuffer(this);
    };
    IndexedDbRemoteDocumentCache.prototype.getSize = function (txn) {
        return this.getMetadata(txn).next(function (metadata) { return metadata.byteSize; });
    };
    IndexedDbRemoteDocumentCache.prototype.getMetadata = function (txn) {
        return documentGlobalStore(txn)
            .get(DbRemoteDocumentGlobal.key)
            .next(function (metadata) {
            assert(!!metadata, 'Missing document cache metadata');
            return metadata;
        });
    };
    IndexedDbRemoteDocumentCache.prototype.setMetadata = function (txn, metadata) {
        return documentGlobalStore(txn).put(DbRemoteDocumentGlobal.key, metadata);
    };
    /**
     * Adds the given delta to the cached current size. Callers to removeEntry *must* call this
     * afterwards to update the size of the cache.
     *
     * @param sizeDelta
     */
    IndexedDbRemoteDocumentCache.prototype.updateSize = function (txn, sizeDelta) {
        var _this = this;
        return this.getMetadata(txn).next(function (metadata) {
            metadata.byteSize += sizeDelta;
            return _this.setMetadata(txn, metadata);
        });
    };
    return IndexedDbRemoteDocumentCache;
}());
function documentGlobalStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbRemoteDocumentGlobal.store);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache
 */
var IndexedDbRemoteDocumentChangeBuffer = /** @class */ (function (_super) {
    tslib_1.__extends(IndexedDbRemoteDocumentChangeBuffer, _super);
    function IndexedDbRemoteDocumentChangeBuffer(documentCache) {
        var _this = _super.call(this) || this;
        _this.documentCache = documentCache;
        return _this;
    }
    IndexedDbRemoteDocumentChangeBuffer.prototype.applyChanges = function (transaction) {
        var _this = this;
        var changes = this.assertChanges();
        var delta = 0;
        var toApply = [];
        changes.forEach(function (key, maybeDocument) {
            var doc = _this.documentCache.serializer.toDbRemoteDocument(maybeDocument);
            var previousSize = _this.documentSizes.get(key);
            // NOTE: if we ever decide we need to support doing writes without
            // reading first, this assert will need to change to do the read automatically.
            assert(previousSize !== undefined, "Attempting to change document " + key.toString() + " without having read it first");
            var size = dbDocumentSize(doc);
            delta += size - previousSize;
            toApply.push({ key: key, doc: doc });
        });
        return this.documentCache.addEntries(transaction, toApply, delta);
    };
    IndexedDbRemoteDocumentChangeBuffer.prototype.getFromCache = function (transaction, documentKey) {
        return this.documentCache.getSizedEntry(transaction, documentKey);
    };
    IndexedDbRemoteDocumentChangeBuffer.prototype.getAllFromCache = function (transaction, documentKeys) {
        return this.documentCache.getSizedEntries(transaction, documentKeys);
    };
    return IndexedDbRemoteDocumentChangeBuffer;
}(RemoteDocumentChangeBuffer));
function isDocumentChangeMissingError(err) {
    return (err.code === Code.DATA_LOSS &&
        err.message === REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */
function remoteDocumentsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbRemoteDocument.store);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocumentChanges object
 * store.
 */
function documentChangesStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbRemoteDocumentChanges.store);
}
function dbKey(docKey) {
    return docKey.path.toArray();
}
/**
 * Retrusn an approximate size for the given document.
 */
function dbDocumentSize(doc) {
    var value;
    if (doc.document) {
        value = doc.document;
    }
    else if (doc.unknownDocument) {
        value = doc.unknownDocument;
    }
    else if (doc.noDocument) {
        value = doc.noDocument;
    }
    else {
        throw fail('Unknown remote document type');
    }
    return JSON.stringify(value).length;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Schema Version for the Web client:
 * 1. Initial version including Mutation Queue, Query Cache, and Remote Document
 *    Cache
 * 2. Used to ensure a targetGlobal object exists and add targetCount to it. No
 *    longer required because migration 3 unconditionally clears it.
 * 3. Dropped and re-created Query Cache to deal with cache corruption related
 *    to limbo resolution. Addresses
 *    https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4. Multi-Tab Support.
 * 5. Removal of held write acks.
 * 6. Create document global for tracking document cache size.
 * 7. Ensure every cached document has a sentinel row with a sequence number.
 */
var SCHEMA_VERSION = 7;
/** Performs database creation and schema upgrades. */
var SchemaConverter = /** @class */ (function () {
    function SchemaConverter(serializer) {
        this.serializer = serializer;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */
    SchemaConverter.prototype.createOrUpgrade = function (db, txn, fromVersion, toVersion) {
        var _this = this;
        assert(fromVersion < toVersion &&
            fromVersion >= 0 &&
            toVersion <= SCHEMA_VERSION, "Unexpected schema upgrade from v" + fromVersion + " to v{toVersion}.");
        if (fromVersion < 1 && toVersion >= 1) {
            createPrimaryClientStore(db);
            createMutationQueue(db);
            createQueryCache(db);
            createRemoteDocumentCache(db);
        }
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        var p = PersistencePromise.resolve();
        if (fromVersion < 3 && toVersion >= 3) {
            // Brand new clients don't need to drop and recreate--only clients that
            // potentially have corrupt data.
            if (fromVersion !== 0) {
                dropQueryCache(db);
                createQueryCache(db);
            }
            p = p.next(function () { return writeEmptyTargetGlobalEntry(txn); });
        }
        if (fromVersion < 4 && toVersion >= 4) {
            if (fromVersion !== 0) {
                // Schema version 3 uses auto-generated keys to generate globally unique
                // mutation batch IDs (this was previously ensured internally by the
                // client). To migrate to the new schema, we have to read all mutations
                // and write them back out. We preserve the existing batch IDs to guarantee
                // consistency with other object stores. Any further mutation batch IDs will
                // be auto-generated.
                p = p.next(function () { return upgradeMutationBatchSchemaAndMigrateData(db, txn); });
            }
            p = p.next(function () {
                createClientMetadataStore(db);
                createRemoteDocumentChangesStore(db);
            });
        }
        if (fromVersion < 5 && toVersion >= 5) {
            p = p.next(function () { return _this.removeAcknowledgedMutations(txn); });
        }
        if (fromVersion < 6 && toVersion >= 6) {
            p = p.next(function () {
                createDocumentGlobalStore(db);
                return _this.addDocumentGlobal(txn);
            });
        }
        if (fromVersion < 7 && toVersion >= 7) {
            p = p.next(function () { return _this.ensureSequenceNumbers(txn); });
        }
        return p;
    };
    SchemaConverter.prototype.addDocumentGlobal = function (txn) {
        var byteCount = 0;
        return txn
            .store(DbRemoteDocument.store)
            .iterate(function (_, doc) {
            byteCount += dbDocumentSize(doc);
        })
            .next(function () {
            var metadata = new DbRemoteDocumentGlobal(byteCount);
            return txn
                .store(DbRemoteDocumentGlobal.store)
                .put(DbRemoteDocumentGlobal.key, metadata);
        });
    };
    SchemaConverter.prototype.removeAcknowledgedMutations = function (txn) {
        var _this = this;
        var queuesStore = txn.store(DbMutationQueue.store);
        var mutationsStore = txn.store(DbMutationBatch.store);
        return queuesStore.loadAll().next(function (queues) {
            return PersistencePromise.forEach(queues, function (queue) {
                var range = IDBKeyRange.bound([queue.userId, BATCHID_UNKNOWN], [queue.userId, queue.lastAcknowledgedBatchId]);
                return mutationsStore
                    .loadAll(DbMutationBatch.userMutationsIndex, range)
                    .next(function (dbBatches) {
                    return PersistencePromise.forEach(dbBatches, function (dbBatch) {
                        assert(dbBatch.userId === queue.userId, "Cannot process batch " + dbBatch.batchId + " from unexpected user");
                        var batch = _this.serializer.fromDbMutationBatch(dbBatch);
                        return removeMutationBatch(txn, queue.userId, batch).next(function () { });
                    });
                });
            });
        });
    };
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */
    SchemaConverter.prototype.ensureSequenceNumbers = function (txn) {
        var documentTargetStore$$1 = txn.store(DbTargetDocument.store);
        var documentsStore = txn.store(DbRemoteDocument.store);
        return getHighestListenSequenceNumber(txn).next(function (currentSequenceNumber) {
            var writeSentinelKey = function (path) {
                return documentTargetStore$$1.put(new DbTargetDocument(0, encode(path), currentSequenceNumber));
            };
            var promises = [];
            return documentsStore
                .iterate(function (key, doc) {
                var path = new ResourcePath(key);
                var docSentinelKey = sentinelKey(path);
                promises.push(documentTargetStore$$1.get(docSentinelKey).next(function (maybeSentinel) {
                    if (!maybeSentinel) {
                        return writeSentinelKey(path);
                    }
                    else {
                        return PersistencePromise.resolve();
                    }
                }));
            })
                .next(function () { return PersistencePromise.waitFor(promises); });
        });
    };
    return SchemaConverter;
}());
function sentinelKey(path) {
    return [0, encode(path)];
}
/**
 * Wrapper class to store timestamps (seconds and nanos) in IndexedDb objects.
 */
var DbTimestamp = /** @class */ (function () {
    function DbTimestamp(seconds, nanoseconds) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
    }
    return DbTimestamp;
}());
/**
 * A singleton object to be stored in the 'owner' store in IndexedDb.
 *
 * A given database can have a single primary tab assigned at a given time. That
 * tab must validate that it is still holding the primary lease before every
 * operation that requires locked access. The primary tab should regularly
 * write an updated timestamp to this lease to prevent other tabs from
 * "stealing" the primary lease
 */
var DbPrimaryClient = /** @class */ (function () {
    function DbPrimaryClient(ownerId, 
    /** Whether to allow shared access from multiple tabs. */
    allowTabSynchronization, leaseTimestampMs) {
        this.ownerId = ownerId;
        this.allowTabSynchronization = allowTabSynchronization;
        this.leaseTimestampMs = leaseTimestampMs;
    }
    /**
     * Name of the IndexedDb object store.
     *
     * Note that the name 'owner' is chosen to ensure backwards compatibility with
     * older clients that only supported single locked access to the persistence
     * layer.
     */
    DbPrimaryClient.store = 'owner';
    /**
     * The key string used for the single object that exists in the
     * DbPrimaryClient store.
     */
    DbPrimaryClient.key = 'owner';
    return DbPrimaryClient;
}());
function createPrimaryClientStore(db) {
    db.createObjectStore(DbPrimaryClient.store);
}
/**
 * An object to be stored in the 'mutationQueues' store in IndexedDb.
 *
 * Each user gets a single queue of MutationBatches to apply to the server.
 * DbMutationQueue tracks the metadata about the queue.
 */
var DbMutationQueue = /** @class */ (function () {
    function DbMutationQueue(
    /**
     * The normalized user ID to which this queue belongs.
     */
    userId, 
    /**
     * An identifier for the highest numbered batch that has been acknowledged
     * by the server. All MutationBatches in this queue with batchIds less
     * than or equal to this value are considered to have been acknowledged by
     * the server.
     *
     * NOTE: this is deprecated and no longer used by the code.
     */
    lastAcknowledgedBatchId, 
    /**
     * A stream token that was previously sent by the server.
     *
     * See StreamingWriteRequest in datastore.proto for more details about
     * usage.
     *
     * After sending this token, earlier tokens may not be used anymore so
     * only a single stream token is retained.
     */
    lastStreamToken) {
        this.userId = userId;
        this.lastAcknowledgedBatchId = lastAcknowledgedBatchId;
        this.lastStreamToken = lastStreamToken;
    }
    /** Name of the IndexedDb object store.  */
    DbMutationQueue.store = 'mutationQueues';
    /** Keys are automatically assigned via the userId property. */
    DbMutationQueue.keyPath = 'userId';
    return DbMutationQueue;
}());
/**
 * An object to be stored in the 'mutations' store in IndexedDb.
 *
 * Represents a batch of user-level mutations intended to be sent to the server
 * in a single write. Each user-level batch gets a separate DbMutationBatch
 * with a new batchId.
 */
var DbMutationBatch = /** @class */ (function () {
    function DbMutationBatch(
    /**
     * The normalized user ID to which this batch belongs.
     */
    userId, 
    /**
     * An identifier for this batch, allocated using an auto-generated key.
     */
    batchId, 
    /**
     * The local write time of the batch, stored as milliseconds since the
     * epoch.
     */
    localWriteTimeMs, 
    /**
     * A list of mutations to apply. All mutations will be applied atomically.
     *
     * Mutations are serialized via JsonProtoSerializer.toMutation().
     */
    mutations) {
        this.userId = userId;
        this.batchId = batchId;
        this.localWriteTimeMs = localWriteTimeMs;
        this.mutations = mutations;
    }
    /** Name of the IndexedDb object store.  */
    DbMutationBatch.store = 'mutations';
    /** Keys are automatically assigned via the userId, batchId properties. */
    DbMutationBatch.keyPath = 'batchId';
    /** The index name for lookup of mutations by user. */
    DbMutationBatch.userMutationsIndex = 'userMutationsIndex';
    /** The user mutations index is keyed by [userId, batchId] pairs. */
    DbMutationBatch.userMutationsKeyPath = ['userId', 'batchId'];
    return DbMutationBatch;
}());
function createMutationQueue(db) {
    db.createObjectStore(DbMutationQueue.store, {
        keyPath: DbMutationQueue.keyPath
    });
    var mutationBatchesStore = db.createObjectStore(DbMutationBatch.store, {
        keyPath: DbMutationBatch.keyPath,
        autoIncrement: true
    });
    mutationBatchesStore.createIndex(DbMutationBatch.userMutationsIndex, DbMutationBatch.userMutationsKeyPath, { unique: true });
    db.createObjectStore(DbDocumentMutation.store);
}
/**
 * Upgrade function to migrate the 'mutations' store from V1 to V3. Loads
 * and rewrites all data.
 */
function upgradeMutationBatchSchemaAndMigrateData(db, txn) {
    var v1MutationsStore = txn.store(DbMutationBatch.store);
    return v1MutationsStore.loadAll().next(function (existingMutations) {
        db.deleteObjectStore(DbMutationBatch.store);
        var mutationsStore = db.createObjectStore(DbMutationBatch.store, {
            keyPath: DbMutationBatch.keyPath,
            autoIncrement: true
        });
        mutationsStore.createIndex(DbMutationBatch.userMutationsIndex, DbMutationBatch.userMutationsKeyPath, { unique: true });
        var v3MutationsStore = txn.store(DbMutationBatch.store);
        var writeAll = existingMutations.map(function (mutation) {
            return v3MutationsStore.put(mutation);
        });
        return PersistencePromise.waitFor(writeAll);
    });
}
/**
 * An object to be stored in the 'documentMutations' store in IndexedDb.
 *
 * A manually maintained index of all the mutation batches that affect a given
 * document key. The rows in this table are references based on the contents of
 * DbMutationBatch.mutations.
 */
var DbDocumentMutation = /** @class */ (function () {
    function DbDocumentMutation() {
    }
    /**
     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
     * over all of a user's document mutations.
     */
    DbDocumentMutation.prefixForUser = function (userId) {
        return [userId];
    };
    /**
     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
     * index to iterate over all at document mutations for a given path or lower.
     */
    DbDocumentMutation.prefixForPath = function (userId, path) {
        return [userId, encode(path)];
    };
    /**
     * Creates a full index key of [userId, encodedPath, batchId] for inserting
     * and deleting into the DbDocumentMutations index.
     */
    DbDocumentMutation.key = function (userId, path, batchId) {
        return [userId, encode(path), batchId];
    };
    DbDocumentMutation.store = 'documentMutations';
    /**
     * Because we store all the useful information for this store in the key,
     * there is no useful information to store as the value. The raw (unencoded)
     * path cannot be stored because IndexedDb doesn't store prototype
     * information.
     */
    DbDocumentMutation.PLACEHOLDER = new DbDocumentMutation();
    return DbDocumentMutation;
}());
function createRemoteDocumentCache(db) {
    db.createObjectStore(DbRemoteDocument.store);
}
/**
 * Represents the known absence of a document at a particular version.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */
var DbNoDocument = /** @class */ (function () {
    function DbNoDocument(path, readTime) {
        this.path = path;
        this.readTime = readTime;
    }
    return DbNoDocument;
}());
/**
 * Represents a document that is known to exist but whose data is unknown.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */
var DbUnknownDocument = /** @class */ (function () {
    function DbUnknownDocument(path, version) {
        this.path = path;
        this.version = version;
    }
    return DbUnknownDocument;
}());
/**
 * An object to be stored in the 'remoteDocuments' store in IndexedDb.
 * It represents either:
 *
 * - A complete document.
 * - A "no document" representing a document that is known not to exist (at
 * some version).
 * - An "unknown document" representing a document that is known to exist (at
 * some version) but whose contents are unknown.
 *
 * Note: This is the persisted equivalent of a MaybeDocument and could perhaps
 * be made more general if necessary.
 */
var DbRemoteDocument = /** @class */ (function () {
    function DbRemoteDocument(
    /**
     * Set to an instance of DbUnknownDocument if the data for a document is
     * not known, but it is known that a document exists at the specified
     * version (e.g. it had a successful update applied to it)
     */
    unknownDocument, 
    /**
     * Set to an instance of a DbNoDocument if it is known that no document
     * exists.
     */
    noDocument, 
    /**
     * Set to an instance of a Document if there's a cached version of the
     * document.
     */
    document, 
    /**
     * Documents that were written to the remote document store based on
     * a write acknowledgment are marked with `hasCommittedMutations`. These
     * documents are potentially inconsistent with the backend's copy and use
     * the write's commit version as their document version.
     */
    hasCommittedMutations) {
        this.unknownDocument = unknownDocument;
        this.noDocument = noDocument;
        this.document = document;
        this.hasCommittedMutations = hasCommittedMutations;
    }
    DbRemoteDocument.store = 'remoteDocuments';
    return DbRemoteDocument;
}());
/**
 * Contains a single entry that has metadata about the remote document cache.
 */
var DbRemoteDocumentGlobal = /** @class */ (function () {
    /**
     * @param byteSize Approximately the total size in bytes of all the documents in the document
     * cache.
     */
    function DbRemoteDocumentGlobal(byteSize) {
        this.byteSize = byteSize;
    }
    DbRemoteDocumentGlobal.store = 'remoteDocumentGlobal';
    DbRemoteDocumentGlobal.key = 'remoteDocumentGlobalKey';
    return DbRemoteDocumentGlobal;
}());
function createDocumentGlobalStore(db) {
    db.createObjectStore(DbRemoteDocumentGlobal.store);
}
/**
 * An object to be stored in the 'targets' store in IndexedDb.
 *
 * This is based on and should be kept in sync with the proto used in the iOS
 * client.
 *
 * Each query the client listens to against the server is tracked on disk so
 * that the query can be efficiently resumed on restart.
 */
var DbTarget = /** @class */ (function () {
    function DbTarget(
    /**
     * An auto-generated sequential numeric identifier for the query.
     *
     * Queries are stored using their canonicalId as the key, but these
     * canonicalIds can be quite long so we additionally assign a unique
     * queryId which can be used by referenced data structures (e.g.
     * indexes) to minimize the on-disk cost.
     */
    targetId, 
    /**
     * The canonical string representing this query. This is not unique.
     */
    canonicalId, 
    /**
     * The last readTime received from the Watch Service for this query.
     *
     * This is the same value as TargetChange.read_time in the protos.
     */
    readTime, 
    /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data
     * that matches the query. The resume token essentially identifies a
     * point in time from which the server should resume sending results.
     *
     * This is related to the snapshotVersion in that the resumeToken
     * effectively also encodes that value, but the resumeToken is opaque
     * and sometimes encodes additional information.
     *
     * A consequence of this is that the resumeToken should be used when
     * asking the server to reason about where this client is in the watch
     * stream, but the client should use the snapshotVersion for its own
     * purposes.
     *
     * This is the same value as TargetChange.resume_token in the protos.
     */
    resumeToken, 
    /**
     * A sequence number representing the last time this query was
     * listened to, used for garbage collection purposes.
     *
     * Conventionally this would be a timestamp value, but device-local
     * clocks are unreliable and they must be able to create new listens
     * even while disconnected. Instead this should be a monotonically
     * increasing number that's incremented on each listen call.
     *
     * This is different from the queryId since the queryId is an
     * immutable identifier assigned to the Query on first use while
     * lastListenSequenceNumber is updated every time the query is
     * listened to.
     */
    lastListenSequenceNumber, 
    /**
     * The query for this target.
     *
     * Because canonical ids are not unique we must store the actual query. We
     * use the proto to have an object we can persist without having to
     * duplicate translation logic to and from a `Query` object.
     */
    query) {
        this.targetId = targetId;
        this.canonicalId = canonicalId;
        this.readTime = readTime;
        this.resumeToken = resumeToken;
        this.lastListenSequenceNumber = lastListenSequenceNumber;
        this.query = query;
    }
    DbTarget.store = 'targets';
    /** Keys are automatically assigned via the targetId property. */
    DbTarget.keyPath = 'targetId';
    /** The name of the queryTargets index. */
    DbTarget.queryTargetsIndexName = 'queryTargetsIndex';
    /**
     * The index of all canonicalIds to the targets that they match. This is not
     * a unique mapping because canonicalId does not promise a unique name for all
     * possible queries, so we append the targetId to make the mapping unique.
     */
    DbTarget.queryTargetsKeyPath = ['canonicalId', 'targetId'];
    return DbTarget;
}());
/**
 * An object representing an association between a target and a document, or a
 * sentinel row marking the last sequence number at which a document was used.
 * Each document cached must have a corresponding sentinel row before lru
 * garbage collection is enabled.
 *
 * The target associations and sentinel rows are co-located so that orphaned
 * documents and their sequence numbers can be identified efficiently via a scan
 * of this store.
 */
var DbTargetDocument = /** @class */ (function () {
    function DbTargetDocument(
    /**
     * The targetId identifying a target or 0 for a sentinel row.
     */
    targetId, 
    /**
     * The path to the document, as encoded in the key.
     */
    path, 
    /**
     * If this is a sentinel row, this should be the sequence number of the last
     * time the document specified by `path` was used. Otherwise, it should be
     * `undefined`.
     */
    sequenceNumber) {
        this.targetId = targetId;
        this.path = path;
        this.sequenceNumber = sequenceNumber;
        assert((targetId === 0) === (sequenceNumber !== undefined), 
        // tslint:disable-next-line:max-line-length
        'A target-document row must either have targetId == 0 and a defined sequence number, or a non-zero targetId and no sequence number');
    }
    /** Name of the IndexedDb object store.  */
    DbTargetDocument.store = 'targetDocuments';
    /** Keys are automatically assigned via the targetId, path properties. */
    DbTargetDocument.keyPath = ['targetId', 'path'];
    /** The index name for the reverse index. */
    DbTargetDocument.documentTargetsIndex = 'documentTargetsIndex';
    /** We also need to create the reverse index for these properties. */
    DbTargetDocument.documentTargetsKeyPath = ['path', 'targetId'];
    return DbTargetDocument;
}());
/**
 * A record of global state tracked across all Targets, tracked separately
 * to avoid the need for extra indexes.
 *
 * This should be kept in-sync with the proto used in the iOS client.
 */
var DbTargetGlobal = /** @class */ (function () {
    function DbTargetGlobal(
    /**
     * The highest numbered target id across all targets.
     *
     * See DbTarget.targetId.
     */
    highestTargetId, 
    /**
     * The highest numbered lastListenSequenceNumber across all targets.
     *
     * See DbTarget.lastListenSequenceNumber.
     */
    highestListenSequenceNumber, 
    /**
     * A global snapshot version representing the last consistent snapshot we
     * received from the backend. This is monotonically increasing and any
     * snapshots received from the backend prior to this version (e.g. for
     * targets resumed with a resumeToken) should be suppressed (buffered)
     * until the backend has caught up to this snapshot version again. This
     * prevents our cache from ever going backwards in time.
     */
    lastRemoteSnapshotVersion, 
    /**
     * The number of targets persisted.
     */
    targetCount) {
        this.highestTargetId = highestTargetId;
        this.highestListenSequenceNumber = highestListenSequenceNumber;
        this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
        this.targetCount = targetCount;
    }
    /**
     * The key string used for the single object that exists in the
     * DbTargetGlobal store.
     */
    DbTargetGlobal.key = 'targetGlobalKey';
    DbTargetGlobal.store = 'targetGlobal';
    return DbTargetGlobal;
}());
function createQueryCache(db) {
    var targetDocumentsStore = db.createObjectStore(DbTargetDocument.store, {
        keyPath: DbTargetDocument.keyPath
    });
    targetDocumentsStore.createIndex(DbTargetDocument.documentTargetsIndex, DbTargetDocument.documentTargetsKeyPath, { unique: true });
    var targetStore = db.createObjectStore(DbTarget.store, {
        keyPath: DbTarget.keyPath
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    targetStore.createIndex(DbTarget.queryTargetsIndexName, DbTarget.queryTargetsKeyPath, { unique: true });
    db.createObjectStore(DbTargetGlobal.store);
}
function dropQueryCache(db) {
    db.deleteObjectStore(DbTargetDocument.store);
    db.deleteObjectStore(DbTarget.store);
    db.deleteObjectStore(DbTargetGlobal.store);
}
/**
 * Creates the target global singleton row.
 *
 * @param {IDBTransaction} txn The version upgrade transaction for indexeddb
 */
function writeEmptyTargetGlobalEntry(txn) {
    var globalStore = txn.store(DbTargetGlobal.store);
    var metadata = new DbTargetGlobal(
    /*highestTargetId=*/ 0, 
    /*lastListenSequenceNumber=*/ 0, SnapshotVersion.MIN.toTimestamp(), 
    /*targetCount=*/ 0);
    return globalStore.put(DbTargetGlobal.key, metadata);
}
/**
 * An object store to store the keys of changed documents. This is used to
 * facilitate storing document changelogs in the Remote Document Cache.
 *
 * PORTING NOTE: This is used for change propagation during multi-tab syncing
 * and not needed on iOS and Android.
 */
var DbRemoteDocumentChanges = /** @class */ (function () {
    function DbRemoteDocumentChanges(
    /** The keys of the changed documents. */
    changes) {
        this.changes = changes;
    }
    /** Name of the IndexedDb object store.  */
    DbRemoteDocumentChanges.store = 'remoteDocumentChanges';
    /** Keys are auto-generated via the `id` property. */
    DbRemoteDocumentChanges.keyPath = 'id';
    return DbRemoteDocumentChanges;
}());
function createRemoteDocumentChangesStore(db) {
    db.createObjectStore(DbRemoteDocumentChanges.store, {
        keyPath: 'id',
        autoIncrement: true
    });
}
/**
 * A record of the metadata state of each client.
 *
 * PORTING NOTE: This is used to synchronize multi-tab state and does not need
 * to be ported to iOS or Android.
 */
var DbClientMetadata = /** @class */ (function () {
    function DbClientMetadata(
    /** The auto-generated client id assigned at client startup. */
    clientId, 
    /** The last time this state was updated. */
    updateTimeMs, 
    /** Whether the client's network connection is enabled. */
    networkEnabled, 
    /** Whether this client is running in a foreground tab. */
    inForeground, 
    /**
     * The last change read from the DbRemoteDocumentChanges store.
     * Can be undefined for backwards compatibility.
     */
    lastProcessedDocumentChangeId) {
        this.clientId = clientId;
        this.updateTimeMs = updateTimeMs;
        this.networkEnabled = networkEnabled;
        this.inForeground = inForeground;
        this.lastProcessedDocumentChangeId = lastProcessedDocumentChangeId;
    }
    /** Name of the IndexedDb object store. */
    DbClientMetadata.store = 'clientMetadata';
    /** Keys are automatically assigned via the clientId properties. */
    DbClientMetadata.keyPath = 'clientId';
    return DbClientMetadata;
}());
function createClientMetadataStore(db) {
    db.createObjectStore(DbClientMetadata.store, {
        keyPath: DbClientMetadata.keyPath
    });
}
// Visible for testing
var V1_STORES = [
    DbMutationQueue.store,
    DbMutationBatch.store,
    DbDocumentMutation.store,
    DbRemoteDocument.store,
    DbTarget.store,
    DbPrimaryClient.store,
    DbTargetGlobal.store,
    DbTargetDocument.store
];
// V2 is no longer usable (see comment at top of file)
// Visible for testing
var V3_STORES = V1_STORES;
// Visible for testing
var V4_STORES = V3_STORES.concat([
    DbClientMetadata.store,
    DbRemoteDocumentChanges.store
]);
// V5 does not change the set of stores.
var V6_STORES = V4_STORES.concat([DbRemoteDocumentGlobal.store]);
/**
 * The list of all default IndexedDB stores used throughout the SDK. This is
 * used when creating transactions so that access across all stores is done
 * atomically.
 */
var ALL_STORES = V6_STORES;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** A mutation queue for a specific user, backed by IndexedDB. */
var IndexedDbMutationQueue = /** @class */ (function () {
    function IndexedDbMutationQueue(
    /**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */
    userId, serializer, referenceDelegate) {
        this.userId = userId;
        this.serializer = serializer;
        this.referenceDelegate = referenceDelegate;
        /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */
        // PORTING NOTE: Multi-tab only.
        this.documentKeysByBatchId = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user The user for which to create a mutation queue.
     * @param serializer The serializer to use when persisting to IndexedDb.
     */
    IndexedDbMutationQueue.forUser = function (user, serializer, referenceDelegate) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        assert(user.uid !== '', 'UserID must not be an empty string.');
        var userId = user.isAuthenticated() ? user.uid : '';
        return new IndexedDbMutationQueue(userId, serializer, referenceDelegate);
    };
    IndexedDbMutationQueue.prototype.checkEmpty = function (transaction) {
        var empty = true;
        var range = IDBKeyRange.bound([this.userId, Number.NEGATIVE_INFINITY], [this.userId, Number.POSITIVE_INFINITY]);
        return mutationsStore(transaction)
            .iterate({ index: DbMutationBatch.userMutationsIndex, range: range }, function (key, value, control) {
            empty = false;
            control.done();
        })
            .next(function () { return empty; });
    };
    IndexedDbMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
            metadata.lastStreamToken = convertStreamToken(streamToken);
            return mutationQueuesStore(transaction).put(metadata);
        });
    };
    IndexedDbMutationQueue.prototype.getLastStreamToken = function (transaction) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) { return metadata.lastStreamToken; });
    };
    IndexedDbMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
            metadata.lastStreamToken = convertStreamToken(streamToken);
            return mutationQueuesStore(transaction).put(metadata);
        });
    };
    IndexedDbMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
        var _this = this;
        var documentStore = documentMutationsStore(transaction);
        var mutationStore = mutationsStore(transaction);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // tslint:disable-next-line:no-any We write an empty object to obtain key
        return mutationStore.add({}).next(function (batchId) {
            assert(typeof batchId === 'number', 'Auto-generated key is not a number');
            var batch = new MutationBatch(batchId, localWriteTime, mutations);
            var dbBatch = _this.serializer.toDbMutationBatch(_this.userId, batch);
            _this.documentKeysByBatchId[batchId] = batch.keys();
            var promises = [];
            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
                var mutation = mutations_1[_i];
                var indexKey = DbDocumentMutation.key(_this.userId, mutation.key.path, batchId);
                promises.push(mutationStore.put(dbBatch));
                promises.push(documentStore.put(indexKey, DbDocumentMutation.PLACEHOLDER));
            }
            return PersistencePromise.waitFor(promises).next(function () { return batch; });
        });
    };
    IndexedDbMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
        var _this = this;
        return mutationsStore(transaction)
            .get(batchId)
            .next(function (dbBatch) {
            if (dbBatch) {
                assert(dbBatch.userId === _this.userId, "Unexpected user '" + dbBatch.userId + "' for mutation batch " + batchId);
                return _this.serializer.fromDbMutationBatch(dbBatch);
            }
            return null;
        });
    };
    IndexedDbMutationQueue.prototype.lookupMutationKeys = function (transaction, batchId) {
        var _this = this;
        if (this.documentKeysByBatchId[batchId]) {
            return PersistencePromise.resolve(this.documentKeysByBatchId[batchId]);
        }
        else {
            return this.lookupMutationBatch(transaction, batchId).next(function (batch) {
                if (batch) {
                    var keys = batch.keys();
                    _this.documentKeysByBatchId[batchId] = keys;
                    return keys;
                }
                else {
                    return null;
                }
            });
        }
    };
    IndexedDbMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
        var _this = this;
        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
            var nextBatchId = batchId + 1;
            var range = IDBKeyRange.lowerBound([_this.userId, nextBatchId]);
            var foundBatch = null;
            return mutationsStore(transaction)
                .iterate({ index: DbMutationBatch.userMutationsIndex, range: range }, function (key, dbBatch, control) {
                if (dbBatch.userId === _this.userId) {
                    assert(dbBatch.batchId >= nextBatchId, 'Should have found mutation after ' + nextBatchId);
                    foundBatch = _this.serializer.fromDbMutationBatch(dbBatch);
                }
                control.done();
            })
                .next(function () { return foundBatch; });
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatches = function (transaction) {
        var _this = this;
        var range = IDBKeyRange.bound([this.userId, BATCHID_UNKNOWN], [this.userId, Number.POSITIVE_INFINITY]);
        return mutationsStore(transaction)
            .loadAll(DbMutationBatch.userMutationsIndex, range)
            .next(function (dbBatches) {
            return dbBatches.map(function (dbBatch) { return _this.serializer.fromDbMutationBatch(dbBatch); });
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
        var _this = this;
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, documentKey.path);
        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
        var results = [];
        return documentMutationsStore(transaction)
            .iterate({ range: indexStart }, function (indexKey, _, control) {
            var userID = indexKey[0], encodedPath = indexKey[1], batchId = indexKey[2];
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            var path = decode(encodedPath);
            if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
                control.done();
                return;
            }
            // Look up the mutation batch in the store.
            return mutationsStore(transaction)
                .get(batchId)
                .next(function (mutation) {
                if (!mutation) {
                    throw fail('Dangling document-mutation reference found: ' +
                        indexKey +
                        ' which points to ' +
                        batchId);
                }
                assert(mutation.userId === _this.userId, "Unexpected user '" + mutation.userId + "' for mutation batch " + batchId);
                results.push(_this.serializer.fromDbMutationBatch(mutation));
            });
        })
            .next(function () { return results; });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys = function (transaction, documentKeys) {
        var _this = this;
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        var promises = [];
        documentKeys.forEach(function (documentKey) {
            var indexStart = DbDocumentMutation.prefixForPath(_this.userId, documentKey.path);
            var range = IDBKeyRange.lowerBound(indexStart);
            var promise = documentMutationsStore(transaction).iterate({ range: range }, function (indexKey, _, control) {
                var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                var path = decode(encodedPath);
                if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
                    control.done();
                    return;
                }
                uniqueBatchIDs = uniqueBatchIDs.add(batchID);
            });
            promises.push(promise);
        });
        return PersistencePromise.waitFor(promises).next(function () {
            return _this.lookupMutationBatches(transaction, uniqueBatchIDs);
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
        var _this = this;
        assert(!query.isDocumentQuery(), "Document queries shouldn't go down this path");
        var queryPath = query.path;
        var immediateChildrenLength = queryPath.length + 1;
        // TODO(mcg): Actually implement a single-collection query
        //
        // This is actually executing an ancestor query, traversing the whole
        // subtree below the collection which can be horrifically inefficient for
        // some structures. The right way to solve this is to implement the full
        // value index, but that's not in the cards in the near future so this is
        // the best we can do for the moment.
        //
        // Since we don't yet index the actual properties in the mutations, our
        // current approach is to just return all mutation batches that affect
        // documents in the collection being queried.
        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, queryPath);
        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        return documentMutationsStore(transaction)
            .iterate({ range: indexStart }, function (indexKey, _, control) {
            var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
            var path = decode(encodedPath);
            if (userID !== _this.userId || !queryPath.isPrefixOf(path)) {
                control.done();
                return;
            }
            // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            if (path.length !== immediateChildrenLength) {
                return;
            }
            uniqueBatchIDs = uniqueBatchIDs.add(batchID);
        })
            .next(function () { return _this.lookupMutationBatches(transaction, uniqueBatchIDs); });
    };
    IndexedDbMutationQueue.prototype.lookupMutationBatches = function (transaction, batchIDs) {
        var _this = this;
        var results = [];
        var promises = [];
        // TODO(rockwood): Implement this using iterate.
        batchIDs.forEach(function (batchId) {
            promises.push(mutationsStore(transaction)
                .get(batchId)
                .next(function (mutation) {
                if (mutation === null) {
                    throw fail('Dangling document-mutation reference found, ' +
                        'which points to ' +
                        batchId);
                }
                assert(mutation.userId === _this.userId, "Unexpected user '" + mutation.userId + "' for mutation batch " + batchId);
                results.push(_this.serializer.fromDbMutationBatch(mutation));
            }));
        });
        return PersistencePromise.waitFor(promises).next(function () { return results; });
    };
    IndexedDbMutationQueue.prototype.removeMutationBatch = function (transaction, batch) {
        var _this = this;
        return removeMutationBatch(transaction.simpleDbTransaction, this.userId, batch).next(function (removedDocuments) {
            _this.removeCachedMutationKeys(batch.batchId);
            return PersistencePromise.forEach(removedDocuments, function (key) {
                return _this.referenceDelegate.removeMutationReference(transaction, key);
            });
        });
    };
    IndexedDbMutationQueue.prototype.removeCachedMutationKeys = function (batchId) {
        delete this.documentKeysByBatchId[batchId];
    };
    IndexedDbMutationQueue.prototype.performConsistencyCheck = function (txn) {
        var _this = this;
        return this.checkEmpty(txn).next(function (empty) {
            if (!empty) {
                return PersistencePromise.resolve();
            }
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            var startRange = IDBKeyRange.lowerBound(DbDocumentMutation.prefixForUser(_this.userId));
            var danglingMutationReferences = [];
            return documentMutationsStore(txn)
                .iterate({ range: startRange }, function (key, _, control) {
                var userID = key[0];
                if (userID !== _this.userId) {
                    control.done();
                    return;
                }
                else {
                    var path = decode(key[1]);
                    danglingMutationReferences.push(path);
                }
            })
                .next(function () {
                assert(danglingMutationReferences.length === 0, 'Document leak -- detected dangling mutation references when queue is empty. ' +
                    'Dangling keys: ' +
                    danglingMutationReferences.map(function (p) { return p.canonicalString(); }));
            });
        });
    };
    IndexedDbMutationQueue.prototype.containsKey = function (txn, key) {
        return mutationQueueContainsKey(txn, this.userId, key);
    };
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */
    IndexedDbMutationQueue.prototype.getMutationQueueMetadata = function (transaction) {
        var _this = this;
        return mutationQueuesStore(transaction)
            .get(this.userId)
            .next(function (metadata) {
            return (metadata ||
                new DbMutationQueue(_this.userId, BATCHID_UNKNOWN, 
                /*lastStreamToken=*/ ''));
        });
    };
    return IndexedDbMutationQueue;
}());
/**
 * @return true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */
function mutationQueueContainsKey(txn, userId, key) {
    var indexKey = DbDocumentMutation.prefixForPath(userId, key.path);
    var encodedPath = indexKey[1];
    var startRange = IDBKeyRange.lowerBound(indexKey);
    var containsKey = false;
    return documentMutationsStore(txn)
        .iterate({ range: startRange, keysOnly: true }, function (key, value, control) {
        var userID = key[0], keyPath = key[1], /*batchID*/ _ = key[2];
        if (userID === userId && keyPath === encodedPath) {
            containsKey = true;
        }
        control.done();
    })
        .next(function () { return containsKey; });
}
/** Returns true if any mutation queue contains the given document. */
function mutationQueuesContainKey(txn, docKey) {
    var found = false;
    return mutationQueuesStore(txn)
        .iterateSerial(function (userId) {
        return mutationQueueContainsKey(txn, userId, docKey).next(function (containsKey) {
            if (containsKey) {
                found = true;
            }
            return PersistencePromise.resolve(!containsKey);
        });
    })
        .next(function () { return found; });
}
/**
 * Delete a mutation batch and the associated document mutations.
 * @return A PersistencePromise of the document mutations that were removed.
 */
function removeMutationBatch(txn, userId, batch) {
    var mutationStore = txn.store(DbMutationBatch.store);
    var indexTxn = txn.store(DbDocumentMutation.store);
    var promises = [];
    var range = IDBKeyRange.only(batch.batchId);
    var numDeleted = 0;
    var removePromise = mutationStore.iterate({ range: range }, function (key, value, control) {
        numDeleted++;
        return control.delete();
    });
    promises.push(removePromise.next(function () {
        assert(numDeleted === 1, 'Dangling document-mutation reference found: Missing batch ' +
            batch.batchId);
    }));
    var removedDocuments = [];
    for (var _i = 0, _a = batch.mutations; _i < _a.length; _i++) {
        var mutation = _a[_i];
        var indexKey = DbDocumentMutation.key(userId, mutation.key.path, batch.batchId);
        promises.push(indexTxn.delete(indexKey));
        removedDocuments.push(mutation.key);
    }
    return PersistencePromise.waitFor(promises).next(function () { return removedDocuments; });
}
function convertStreamToken(token) {
    if (token instanceof Uint8Array) {
        // TODO(b/78771403): Convert tokens to strings during deserialization
        assert(Object({"NODE_ENV":"production"}).USE_MOCK_PERSISTENCE === 'YES', 'Persisting non-string stream tokens is only supported with mock persistence.');
        return token.toString();
    }
    else {
        return token;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */
function mutationsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbMutationBatch.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */
function documentMutationsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbDocumentMutation.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */
function mutationQueuesStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbMutationQueue.store);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Serializer for values stored in the LocalStore. */
var LocalSerializer = /** @class */ (function () {
    function LocalSerializer(remoteSerializer) {
        this.remoteSerializer = remoteSerializer;
    }
    /** Decodes a remote document from storage locally to a Document. */
    LocalSerializer.prototype.fromDbRemoteDocument = function (remoteDoc) {
        if (remoteDoc.document) {
            return this.remoteSerializer.fromDocument(remoteDoc.document, !!remoteDoc.hasCommittedMutations);
        }
        else if (remoteDoc.noDocument) {
            var key = DocumentKey.fromSegments(remoteDoc.noDocument.path);
            var version = this.fromDbTimestamp(remoteDoc.noDocument.readTime);
            return new NoDocument(key, version, {
                hasCommittedMutations: !!remoteDoc.hasCommittedMutations
            });
        }
        else if (remoteDoc.unknownDocument) {
            var key = DocumentKey.fromSegments(remoteDoc.unknownDocument.path);
            var version = this.fromDbTimestamp(remoteDoc.unknownDocument.version);
            return new UnknownDocument(key, version);
        }
        else {
            return fail('Unexpected DbRemoteDocument');
        }
    };
    /** Encodes a document for storage locally. */
    LocalSerializer.prototype.toDbRemoteDocument = function (maybeDoc) {
        if (maybeDoc instanceof Document) {
            var doc = maybeDoc.proto
                ? maybeDoc.proto
                : this.remoteSerializer.toDocument(maybeDoc);
            var hasCommittedMutations = maybeDoc.hasCommittedMutations;
            return new DbRemoteDocument(
            /* unknownDocument= */ null, 
            /* noDocument= */ null, doc, hasCommittedMutations);
        }
        else if (maybeDoc instanceof NoDocument) {
            var path = maybeDoc.key.path.toArray();
            var readTime = this.toDbTimestamp(maybeDoc.version);
            var hasCommittedMutations = maybeDoc.hasCommittedMutations;
            return new DbRemoteDocument(
            /* unknownDocument= */ null, new DbNoDocument(path, readTime), 
            /* document= */ null, hasCommittedMutations);
        }
        else if (maybeDoc instanceof UnknownDocument) {
            var path = maybeDoc.key.path.toArray();
            var readTime = this.toDbTimestamp(maybeDoc.version);
            return new DbRemoteDocument(new DbUnknownDocument(path, readTime), 
            /* noDocument= */ null, 
            /* document= */ null, 
            /* hasCommittedMutations= */ true);
        }
        else {
            return fail('Unexpected MaybeDocumment');
        }
    };
    LocalSerializer.prototype.toDbTimestamp = function (snapshotVersion) {
        var timestamp = snapshotVersion.toTimestamp();
        return new DbTimestamp(timestamp.seconds, timestamp.nanoseconds);
    };
    LocalSerializer.prototype.fromDbTimestamp = function (dbTimestamp) {
        var timestamp = new Timestamp(dbTimestamp.seconds, dbTimestamp.nanoseconds);
        return SnapshotVersion.fromTimestamp(timestamp);
    };
    /** Encodes a batch of mutations into a DbMutationBatch for local storage. */
    LocalSerializer.prototype.toDbMutationBatch = function (userId, batch) {
        var _this = this;
        var serializedMutations = batch.mutations.map(function (m) {
            return _this.remoteSerializer.toMutation(m);
        });
        return new DbMutationBatch(userId, batch.batchId, batch.localWriteTime.toMillis(), serializedMutations);
    };
    /** Decodes a DbMutationBatch into a MutationBatch */
    LocalSerializer.prototype.fromDbMutationBatch = function (dbBatch) {
        var _this = this;
        var mutations = dbBatch.mutations.map(function (m) {
            return _this.remoteSerializer.fromMutation(m);
        });
        var timestamp = Timestamp.fromMillis(dbBatch.localWriteTimeMs);
        return new MutationBatch(dbBatch.batchId, timestamp, mutations);
    };
    /*
     * Encodes a set of document keys into an array of EncodedResourcePaths.
     */
    LocalSerializer.prototype.toDbResourcePaths = function (keys) {
        var encodedKeys = [];
        keys.forEach(function (key) {
            encodedKeys.push(encode(key.path));
        });
        return encodedKeys;
    };
    /** Decodes an array of EncodedResourcePaths into a set of document keys. */
    LocalSerializer.prototype.fromDbResourcePaths = function (encodedPaths) {
        var keys = documentKeySet();
        for (var _i = 0, encodedPaths_1 = encodedPaths; _i < encodedPaths_1.length; _i++) {
            var documentKey = encodedPaths_1[_i];
            keys = keys.add(new DocumentKey(decode(documentKey)));
        }
        return keys;
    };
    /** Decodes a DbTarget into QueryData */
    LocalSerializer.prototype.fromDbTarget = function (dbTarget) {
        var version = this.fromDbTimestamp(dbTarget.readTime);
        var query;
        if (isDocumentQuery(dbTarget.query)) {
            query = this.remoteSerializer.fromDocumentsTarget(dbTarget.query);
        }
        else {
            query = this.remoteSerializer.fromQueryTarget(dbTarget.query);
        }
        return new QueryData(query, dbTarget.targetId, QueryPurpose.Listen, dbTarget.lastListenSequenceNumber, version, dbTarget.resumeToken);
    };
    /** Encodes QueryData into a DbTarget for storage locally. */
    LocalSerializer.prototype.toDbTarget = function (queryData) {
        assert(QueryPurpose.Listen === queryData.purpose, 'Only queries with purpose ' +
            QueryPurpose.Listen +
            ' may be stored, got ' +
            queryData.purpose);
        var dbTimestamp = this.toDbTimestamp(queryData.snapshotVersion);
        var queryProto;
        if (queryData.query.isDocumentQuery()) {
            queryProto = this.remoteSerializer.toDocumentsTarget(queryData.query);
        }
        else {
            queryProto = this.remoteSerializer.toQueryTarget(queryData.query);
        }
        var resumeToken;
        if (queryData.resumeToken instanceof Uint8Array) {
            // TODO(b/78771403): Convert tokens to strings during deserialization
            assert(Object({"NODE_ENV":"production"}).USE_MOCK_PERSISTENCE === 'YES', 'Persisting non-string stream tokens is only supported with mock persistence .');
            resumeToken = queryData.resumeToken.toString();
        }
        else {
            resumeToken = queryData.resumeToken;
        }
        // lastListenSequenceNumber is always 0 until we do real GC.
        return new DbTarget(queryData.targetId, queryData.query.canonicalId(), dbTimestamp, resumeToken, queryData.sequenceNumber, queryProto);
    };
    return LocalSerializer;
}());
/**
 * A helper function for figuring out what kind of query has been stored.
 */
function isDocumentQuery(dbQuery) {
    return dbQuery.documents !== undefined;
}

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferEntryComparator(_a, _b) {
    var aSequence = _a[0], aIndex = _a[1];
    var bSequence = _b[0], bIndex = _b[1];
    var seqCmp = primitiveComparator(aSequence, bSequence);
    if (seqCmp === 0) {
        // This order doesn't matter, but we can bias against churn by sorting
        // entries created earlier as less than newer entries.
        return primitiveComparator(aIndex, bIndex);
    }
    else {
        return seqCmp;
    }
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */
var RollingSequenceNumberBuffer = /** @class */ (function () {
    function RollingSequenceNumberBuffer(maxElements) {
        this.maxElements = maxElements;
        this.buffer = new SortedSet(bufferEntryComparator);
        this.previousIndex = 0;
    }
    RollingSequenceNumberBuffer.prototype.nextIndex = function () {
        return ++this.previousIndex;
    };
    RollingSequenceNumberBuffer.prototype.addElement = function (sequenceNumber) {
        var entry = [sequenceNumber, this.nextIndex()];
        if (this.buffer.size < this.maxElements) {
            this.buffer = this.buffer.add(entry);
        }
        else {
            var highestValue = this.buffer.last();
            if (bufferEntryComparator(entry, highestValue) < 0) {
                this.buffer = this.buffer.delete(highestValue).add(entry);
            }
        }
    };
    Object.defineProperty(RollingSequenceNumberBuffer.prototype, "maxValue", {
        get: function () {
            // Guaranteed to be non-empty. If we decide we are not collecting any
            // sequence numbers, nthSequenceNumber below short-circuits. If we have
            // decided that we are collecting n sequence numbers, it's because n is some
            // percentage of the existing sequence numbers. That means we should never
            // be in a situation where we are collecting sequence numbers but don't
            // actually have any.
            return this.buffer.last()[0];
        },
        enumerable: true,
        configurable: true
    });
    return RollingSequenceNumberBuffer;
}());
var GC_DID_NOT_RUN = {
    didRun: false,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
var LruParams = /** @class */ (function () {
    function LruParams(
    // When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    cacheSizeCollectionThreshold, 
    // The percentage of sequence numbers that we will attempt to collect
    percentileToCollect, 
    // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    maximumSequenceNumbersToCollect) {
        this.cacheSizeCollectionThreshold = cacheSizeCollectionThreshold;
        this.percentileToCollect = percentileToCollect;
        this.maximumSequenceNumbersToCollect = maximumSequenceNumbersToCollect;
    }
    LruParams.withCacheSize = function (cacheSize) {
        return new LruParams(cacheSize, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    };
    LruParams.COLLECTION_DISABLED = -1;
    LruParams.MINIMUM_CACHE_SIZE_BYTES = 1 * 1024 * 1024;
    LruParams.DEFAULT_CACHE_SIZE_BYTES = 40 * 1024 * 1024;
    LruParams.DEFAULT_COLLECTION_PERCENTILE = 10;
    LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1000;
    LruParams.DEFAULT = new LruParams(LruParams.DEFAULT_CACHE_SIZE_BYTES, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    LruParams.DISABLED = new LruParams(LruParams.COLLECTION_DISABLED, 0, 0);
    return LruParams;
}());
/** How long we wait to try running LRU GC after SDK initialization. */
var INITIAL_GC_DELAY_MS = 1 * 60 * 1000;
/** Minimum amount of time between GC checks, after the first one. */
var REGULAR_GC_DELAY_MS = 5 * 60 * 1000;
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */
var LruScheduler = /** @class */ (function () {
    function LruScheduler(garbageCollector, asyncQueue, localStore) {
        this.garbageCollector = garbageCollector;
        this.asyncQueue = asyncQueue;
        this.localStore = localStore;
        this.gcTask = null;
    }
    LruScheduler.prototype.start = function () {
        assert(this.gcTask === null, 'Cannot start an already started LruScheduler');
        if (this.garbageCollector.params.cacheSizeCollectionThreshold !==
            LruParams.COLLECTION_DISABLED) {
            this.scheduleGC();
        }
    };
    LruScheduler.prototype.stop = function () {
        if (this.gcTask) {
            this.gcTask.cancel();
            this.gcTask = null;
        }
    };
    Object.defineProperty(LruScheduler.prototype, "started", {
        get: function () {
            return this.gcTask !== null;
        },
        enumerable: true,
        configurable: true
    });
    LruScheduler.prototype.scheduleGC = function () {
        var _this = this;
        assert(this.gcTask === null, 'Cannot schedule GC while a task is pending');
        var delay = this.hasRun ? REGULAR_GC_DELAY_MS : INITIAL_GC_DELAY_MS;
        debug('LruGarbageCollector', "Garbage collection scheduled in " + delay + "ms");
        this.gcTask = this.asyncQueue.enqueueAfterDelay(TimerId.LruGarbageCollection, delay, function () {
            _this.gcTask = null;
            _this.hasRun = true;
            return _this.localStore
                .collectGarbage(_this.garbageCollector)
                .then(function () { return _this.scheduleGC(); })
                .catch(ignoreIfPrimaryLeaseLoss);
        });
    };
    return LruScheduler;
}());
/** Implements the steps for LRU garbage collection. */
var LruGarbageCollector = /** @class */ (function () {
    function LruGarbageCollector(delegate, params) {
        this.delegate = delegate;
        this.params = params;
    }
    /** Given a percentile of target to collect, returns the number of targets to collect. */
    LruGarbageCollector.prototype.calculateTargetCount = function (txn, percentile) {
        return this.delegate.getSequenceNumberCount(txn).next(function (targetCount) {
            return Math.floor(percentile / 100.0 * targetCount);
        });
    };
    /** Returns the nth sequence number, counting in order from the smallest. */
    LruGarbageCollector.prototype.nthSequenceNumber = function (txn, n) {
        var _this = this;
        if (n === 0) {
            return PersistencePromise.resolve(ListenSequence.INVALID);
        }
        var buffer = new RollingSequenceNumberBuffer(n);
        return this.delegate
            .forEachTarget(txn, function (target) { return buffer.addElement(target.sequenceNumber); })
            .next(function () {
            return _this.delegate.forEachOrphanedDocumentSequenceNumber(txn, function (sequenceNumber) { return buffer.addElement(sequenceNumber); });
        })
            .next(function () { return buffer.maxValue; });
    };
    /**
     * Removes targets with a sequence number equal to or less than the given upper bound, and removes
     * document associations with those targets.
     */
    LruGarbageCollector.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.delegate.removeTargets(txn, upperBound, activeTargetIds);
    };
    /**
     * Removes documents that have a sequence number equal to or less than the upper bound and are not
     * otherwise pinned.
     */
    LruGarbageCollector.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        return this.delegate.removeOrphanedDocuments(txn, upperBound);
    };
    LruGarbageCollector.prototype.collect = function (txn, activeTargetIds) {
        var _this = this;
        if (this.params.cacheSizeCollectionThreshold === LruParams.COLLECTION_DISABLED) {
            debug('LruGarbageCollector', 'Garbage collection skipped; disabled');
            return PersistencePromise.resolve(GC_DID_NOT_RUN);
        }
        return this.getCacheSize(txn).next(function (cacheSize) {
            if (cacheSize < _this.params.cacheSizeCollectionThreshold) {
                debug('LruGarbageCollector', "Garbage collection skipped; Cache size " + cacheSize + " " +
                    ("is lower than threshold " + _this.params.cacheSizeCollectionThreshold));
                return GC_DID_NOT_RUN;
            }
            else {
                return _this.runGarbageCollection(txn, activeTargetIds);
            }
        });
    };
    LruGarbageCollector.prototype.getCacheSize = function (txn) {
        return this.delegate.getCacheSize(txn);
    };
    LruGarbageCollector.prototype.runGarbageCollection = function (txn, activeTargetIds) {
        var _this = this;
        var upperBoundSequenceNumber;
        var sequenceNumbersToCollect, targetsRemoved;
        // Timestamps for various pieces of the process
        var startTs, countedTargetsTs, foundUpperBoundTs, removedTargetsTs, removedDocumentsTs;
        startTs = Date.now();
        return this.calculateTargetCount(txn, this.params.percentileToCollect)
            .next(function (sequenceNumbers) {
            // Cap at the configured max
            if (sequenceNumbers > _this.params.maximumSequenceNumbersToCollect) {
                debug('LruGarbageCollector', 'Capping sequence numbers to collect down ' +
                    ("to the maximum of " + _this.params.maximumSequenceNumbersToCollect + " ") +
                    ("from " + sequenceNumbers));
                sequenceNumbersToCollect = _this.params
                    .maximumSequenceNumbersToCollect;
            }
            else {
                sequenceNumbersToCollect = sequenceNumbers;
            }
            countedTargetsTs = Date.now();
            return _this.nthSequenceNumber(txn, sequenceNumbersToCollect);
        })
            .next(function (upperBound) {
            upperBoundSequenceNumber = upperBound;
            foundUpperBoundTs = Date.now();
            return _this.removeTargets(txn, upperBoundSequenceNumber, activeTargetIds);
        })
            .next(function (numTargetsRemoved) {
            targetsRemoved = numTargetsRemoved;
            removedTargetsTs = Date.now();
            return _this.removeOrphanedDocuments(txn, upperBoundSequenceNumber);
        })
            .next(function (documentsRemoved) {
            removedDocumentsTs = Date.now();
            if (getLogLevel() <= LogLevel.DEBUG) {
                var desc = 'LRU Garbage Collection\n' +
                    ("\tCounted targets in " + (countedTargetsTs - startTs) + "ms\n") +
                    ("\tDetermined least recently used " + sequenceNumbersToCollect + " in ") +
                    (foundUpperBoundTs - countedTargetsTs + "ms\n") +
                    ("\tRemoved " + targetsRemoved + " targets in ") +
                    (removedTargetsTs - foundUpperBoundTs + "ms\n") +
                    ("\tRemoved " + documentsRemoved + " documents in ") +
                    (removedDocumentsTs - removedTargetsTs + "ms\n") +
                    ("Total Duration: " + (removedDocumentsTs - startTs) + "ms");
                debug('LruGarbageCollector', desc);
            }
            return PersistencePromise.resolve({
                didRun: true,
                sequenceNumbersCollected: sequenceNumbersToCollect,
                targetsRemoved: targetsRemoved,
                documentsRemoved: documentsRemoved
            });
        });
    };
    return LruGarbageCollector;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Opaque interface representing a persistence transaction.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */
var PersistenceTransaction = /** @class */ (function () {
    function PersistenceTransaction() {
    }
    return PersistenceTransaction;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$2 = 'IndexedDbPersistence';
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data (such as the remote document
 * cache changelog) is garbage collected.
 */
var MAX_CLIENT_AGE_MS = 30 * 60 * 1000; // 30 minutes
/**
 * Oldest acceptable metadata age for clients that may participate in the
 * primary lease election. Clients that have not updated their client metadata
 * within 5 seconds are not eligible to receive a primary lease.
 */
var MAX_PRIMARY_ELIGIBLE_AGE_MS = 5000;
/**
 * The interval at which clients will update their metadata, including
 * refreshing their primary lease if held or potentially trying to acquire it if
 * not held.
 *
 * Primary clients may opportunistically refresh their metadata earlier
 * if they're already performing an IndexedDB operation.
 */
var CLIENT_METADATA_REFRESH_INTERVAL_MS = 4000;
/** User-facing error when the primary lease is required but not available. */
var PRIMARY_LEASE_LOST_ERROR_MSG = 'The current tab is not in the required state to perform this operation. ' +
    'It might be necessary to refresh the browser tab.';
var PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG = 'Another tab has exclusive access to the persistence layer. ' +
    'To allow shared access, make sure to invoke ' +
    '`enablePersistence()` with `experimentalTabSynchronization:true` in all tabs.';
var UNSUPPORTED_PLATFORM_ERROR_MSG = 'This platform is either missing' +
    ' IndexedDB or is known to have an incomplete implementation. Offline' +
    ' persistence has been disabled.';
// The format of the LocalStorage key that stores zombied client is:
//     firestore_zombie_<persistence_prefix>_<instance_key>
var ZOMBIED_CLIENTS_KEY_PREFIX = 'firestore_zombie';
var IndexedDbTransaction = /** @class */ (function (_super) {
    tslib_1.__extends(IndexedDbTransaction, _super);
    function IndexedDbTransaction(simpleDbTransaction, currentSequenceNumber) {
        var _this = _super.call(this) || this;
        _this.simpleDbTransaction = simpleDbTransaction;
        _this.currentSequenceNumber = currentSequenceNumber;
        return _this;
    }
    return IndexedDbTransaction;
}(PersistenceTransaction));
var IndexedDbPersistence = /** @class */ (function () {
    // Note that `multiClientParams` must be present to enable multi-client support while multi-tab
    // is still experimental. When multi-client is switched to always on, `multiClientParams` will
    // no longer be optional.
    function IndexedDbPersistence(persistenceKey, clientId, platform, queue, serializer, lruParams, multiClientParams) {
        this.persistenceKey = persistenceKey;
        this.clientId = clientId;
        this.queue = queue;
        this.multiClientParams = multiClientParams;
        this._started = false;
        this.isPrimary = false;
        this.networkEnabled = true;
        this.inForeground = false;
        /** The last time we garbage collected the Remote Document Changelog. */
        this.lastGarbageCollectionTime = Number.NEGATIVE_INFINITY;
        /** A listener to notify on primary state changes. */
        this.primaryStateListener = function (_) { return Promise.resolve(); };
        if (!IndexedDbPersistence.isAvailable()) {
            throw new FirestoreError(Code.UNIMPLEMENTED, UNSUPPORTED_PLATFORM_ERROR_MSG);
        }
        this.referenceDelegate = new IndexedDbLruDelegate(this, lruParams);
        this.dbName = persistenceKey + IndexedDbPersistence.MAIN_DATABASE;
        this.serializer = new LocalSerializer(serializer);
        this.document = platform.document;
        this.allowTabSynchronization = multiClientParams !== undefined;
        this.queryCache = new IndexedDbQueryCache(this.referenceDelegate, this.serializer);
        this.remoteDocumentCache = new IndexedDbRemoteDocumentCache(this.serializer, 
        /*keepDocumentChangeLog=*/ this.allowTabSynchronization);
        if (platform.window && platform.window.localStorage) {
            this.window = platform.window;
            this.webStorage = this.window.localStorage;
        }
        else {
            throw new FirestoreError(Code.UNIMPLEMENTED, 'IndexedDB persistence is only available on platforms that support LocalStorage.');
        }
    }
    IndexedDbPersistence.getStore = function (txn, store) {
        if (txn instanceof IndexedDbTransaction) {
            return SimpleDb.getStore(txn.simpleDbTransaction, store);
        }
        else {
            throw fail('IndexedDbPersistence must use instances of IndexedDbTransaction');
        }
    };
    IndexedDbPersistence.createIndexedDbPersistence = function (persistenceKey, clientId, platform, queue, serializer, lruParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var persistence;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        persistence = new IndexedDbPersistence(persistenceKey, clientId, platform, queue, serializer, lruParams);
                        return [4 /*yield*/, persistence.start()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, persistence];
                }
            });
        });
    };
    IndexedDbPersistence.createMultiClientIndexedDbPersistence = function (persistenceKey, clientId, platform, queue, serializer, lruParams, multiClientParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var persistence;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        persistence = new IndexedDbPersistence(persistenceKey, clientId, platform, queue, serializer, lruParams, multiClientParams);
                        return [4 /*yield*/, persistence.start()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, persistence];
                }
            });
        });
    };
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @return {Promise<void>} Whether persistence was enabled.
     */
    IndexedDbPersistence.prototype.start = function () {
        var _this = this;
        assert(!this.started, 'IndexedDbPersistence double-started!');
        assert(this.window !== null, "Expected 'window' to be defined");
        return SimpleDb.openOrCreate(this.dbName, SCHEMA_VERSION, new SchemaConverter(this.serializer))
            .then(function (db) {
            _this.simpleDb = db;
        })
            .then(function () { return _this.startRemoteDocumentCache(); })
            .then(function () {
            _this.attachVisibilityHandler();
            _this.attachWindowUnloadHook();
            return _this.updateClientMetadataAndTryBecomePrimary().then(function () {
                return _this.scheduleClientMetadataAndPrimaryLeaseRefreshes();
            });
        })
            .then(function () {
            return _this.simpleDb.runTransaction('readonly', [DbTargetGlobal.store], function (txn) {
                return getHighestListenSequenceNumber(txn).next(function (highestListenSequenceNumber) {
                    var sequenceNumberSyncer = _this.multiClientParams
                        ? _this.multiClientParams.sequenceNumberSyncer
                        : undefined;
                    _this.listenSequence = new ListenSequence(highestListenSequenceNumber, sequenceNumberSyncer);
                });
            });
        })
            .then(function () {
            _this._started = true;
        })
            .catch(function (reason) {
            _this.simpleDb && _this.simpleDb.close();
            return Promise.reject(reason);
        });
    };
    IndexedDbPersistence.prototype.startRemoteDocumentCache = function () {
        var _this = this;
        return this.simpleDb.runTransaction('readonly', ALL_STORES, function (txn) {
            return _this.remoteDocumentCache.start(txn);
        });
    };
    IndexedDbPersistence.prototype.setPrimaryStateListener = function (primaryStateListener) {
        var _this = this;
        this.primaryStateListener = function (primaryState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.started) {
                    return [2 /*return*/, primaryStateListener(primaryState)];
                }
                return [2 /*return*/];
            });
        }); };
        return primaryStateListener(this.isPrimary);
    };
    IndexedDbPersistence.prototype.setNetworkEnabled = function (networkEnabled) {
        var _this = this;
        if (this.networkEnabled !== networkEnabled) {
            this.networkEnabled = networkEnabled;
            // Schedule a primary lease refresh for immediate execution. The eventual
            // lease update will be propagated via `primaryStateListener`.
            this.queue.enqueueAndForget(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.started) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.updateClientMetadataAndTryBecomePrimary()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        }
    };
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */
    IndexedDbPersistence.prototype.updateClientMetadataAndTryBecomePrimary = function () {
        var _this = this;
        return this.simpleDb.runTransaction('readwrite', ALL_STORES, function (txn) {
            var metadataStore = clientMetadataStore(txn);
            return metadataStore
                .put(new DbClientMetadata(_this.clientId, Date.now(), _this.networkEnabled, _this.inForeground, _this.remoteDocumentCache.lastProcessedDocumentChangeId))
                .next(function () {
                if (_this.isPrimary) {
                    return _this.verifyPrimaryLease(txn).next(function (success) {
                        if (!success) {
                            _this.isPrimary = false;
                            _this.queue.enqueueAndForget(function () {
                                return _this.primaryStateListener(false);
                            });
                        }
                    });
                }
            })
                .next(function () { return _this.canActAsPrimary(txn); })
                .next(function (canActAsPrimary) {
                var wasPrimary = _this.isPrimary;
                _this.isPrimary = canActAsPrimary;
                if (wasPrimary !== _this.isPrimary) {
                    _this.queue.enqueueAndForget(function () {
                        return _this.primaryStateListener(_this.isPrimary);
                    });
                }
                if (wasPrimary && !_this.isPrimary) {
                    return _this.releasePrimaryLeaseIfHeld(txn);
                }
                else if (_this.isPrimary) {
                    return _this.acquireOrExtendPrimaryLease(txn);
                }
            });
        });
    };
    IndexedDbPersistence.prototype.verifyPrimaryLease = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (primaryClient) {
            return PersistencePromise.resolve(_this.isLocalClient(primaryClient));
        });
    };
    IndexedDbPersistence.prototype.removeClientMetadata = function (txn) {
        var metadataStore = clientMetadataStore(txn);
        return metadataStore.delete(this.clientId);
    };
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */
    IndexedDbPersistence.prototype.maybeGarbageCollectMultiClientState = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var activeClients_1, inactiveClients_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.isPrimary &&
                            !this.isWithinAge(this.lastGarbageCollectionTime, MAX_CLIENT_AGE_MS))) return [3 /*break*/, 2];
                        this.lastGarbageCollectionTime = Date.now();
                        inactiveClients_1 = [];
                        return [4 /*yield*/, this.runTransaction('maybeGarbageCollectMultiClientState', 'readwrite-primary', function (txn) {
                                var metadataStore = IndexedDbPersistence.getStore(txn, DbClientMetadata.store);
                                return metadataStore
                                    .loadAll()
                                    .next(function (existingClients) {
                                    activeClients_1 = _this.filterActiveClients(existingClients, MAX_CLIENT_AGE_MS);
                                    inactiveClients_1 = existingClients.filter(function (client) { return activeClients_1.indexOf(client) === -1; });
                                })
                                    .next(function () {
                                    // Delete metadata for clients that are no longer considered active.
                                    return PersistencePromise.forEach(inactiveClients_1, function (inactiveClient) {
                                        return metadataStore.delete(inactiveClient.clientId);
                                    });
                                })
                                    .next(function () {
                                    // Retrieve the minimum change ID from the set of active clients.
                                    // The primary client doesn't read from the document change log,
                                    // and hence we exclude it when we determine the minimum
                                    // `lastProcessedDocumentChangeId`.
                                    activeClients_1 = activeClients_1.filter(function (client) { return client.clientId !== _this.clientId; });
                                    if (activeClients_1.length > 0) {
                                        var processedChangeIds = activeClients_1.map(function (client) { return client.lastProcessedDocumentChangeId || 0; });
                                        var oldestChangeId = Math.min.apply(Math, processedChangeIds);
                                        return _this.remoteDocumentCache.removeDocumentChangesThroughChangeId(txn, oldestChangeId);
                                    }
                                });
                            })];
                    case 1:
                        _a.sent();
                        // Delete potential leftover entries that may continue to mark the
                        // inactive clients as zombied in LocalStorage.
                        // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
                        // the client atomically, but we can't. So we opt to delete the IndexedDb
                        // entries first to avoid potentially reviving a zombied client.
                        inactiveClients_1.forEach(function (inactiveClient) {
                            _this.window.localStorage.removeItem(_this.zombiedClientLocalStorageKey(inactiveClient.clientId));
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */
    IndexedDbPersistence.prototype.scheduleClientMetadataAndPrimaryLeaseRefreshes = function () {
        var _this = this;
        this.clientMetadataRefresher = this.queue.enqueueAfterDelay(TimerId.ClientMetadataRefresh, CLIENT_METADATA_REFRESH_INTERVAL_MS, function () {
            return _this.updateClientMetadataAndTryBecomePrimary()
                .then(function () { return _this.maybeGarbageCollectMultiClientState(); })
                .then(function () { return _this.scheduleClientMetadataAndPrimaryLeaseRefreshes(); });
        });
    };
    /** Checks whether `client` is the local client. */
    IndexedDbPersistence.prototype.isLocalClient = function (client) {
        return client ? client.ownerId === this.clientId : false;
    };
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */
    IndexedDbPersistence.prototype.canActAsPrimary = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store
            .get(DbPrimaryClient.key)
            .next(function (currentPrimary) {
            var currentLeaseIsValid = currentPrimary !== null &&
                _this.isWithinAge(currentPrimary.leaseTimestampMs, MAX_PRIMARY_ELIGIBLE_AGE_MS) &&
                !_this.isClientZombied(currentPrimary.ownerId);
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            if (currentLeaseIsValid) {
                if (_this.isLocalClient(currentPrimary) && _this.networkEnabled) {
                    return true;
                }
                if (!_this.isLocalClient(currentPrimary)) {
                    if (!currentPrimary.allowTabSynchronization) {
                        // Fail the `canActAsPrimary` check if the current leaseholder has
                        // not opted into multi-tab synchronization. If this happens at
                        // client startup, we reject the Promise returned by
                        // `enablePersistence()` and the user can continue to use Firestore
                        // with in-memory persistence.
                        // If this fails during a lease refresh, we will instead block the
                        // AsyncQueue from executing further operations. Note that this is
                        // acceptable since mixing & matching different `synchronizeTabs`
                        // settings is not supported.
                        //
                        // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                        // no longer be turned off.
                        throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);
                    }
                    return false;
                }
            }
            if (_this.networkEnabled && _this.inForeground) {
                return true;
            }
            return clientMetadataStore(txn)
                .loadAll()
                .next(function (existingClients) {
                // Process all existing clients and determine whether at least one of
                // them is better suited to obtain the primary lease.
                var preferredCandidate = _this.filterActiveClients(existingClients, MAX_PRIMARY_ELIGIBLE_AGE_MS).find(function (otherClient) {
                    if (_this.clientId !== otherClient.clientId) {
                        var otherClientHasBetterNetworkState = !_this.networkEnabled && otherClient.networkEnabled;
                        var otherClientHasBetterVisibility = !_this.inForeground && otherClient.inForeground;
                        var otherClientHasSameNetworkState = _this.networkEnabled === otherClient.networkEnabled;
                        if (otherClientHasBetterNetworkState ||
                            (otherClientHasBetterVisibility &&
                                otherClientHasSameNetworkState)) {
                            return true;
                        }
                    }
                    return false;
                });
                return preferredCandidate === undefined;
            });
        })
            .next(function (canActAsPrimary) {
            if (_this.isPrimary !== canActAsPrimary) {
                debug(LOG_TAG$2, "Client " + (canActAsPrimary ? 'is' : 'is not') + " eligible for a primary lease.");
            }
            return canActAsPrimary;
        });
    };
    IndexedDbPersistence.prototype.shutdown = function (deleteData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // The shutdown() operations are idempotent and can be called even when
                        // start() aborted (e.g. because it couldn't acquire the persistence lease).
                        this._started = false;
                        this.markClientZombied();
                        if (this.clientMetadataRefresher) {
                            this.clientMetadataRefresher.cancel();
                        }
                        this.detachVisibilityHandler();
                        this.detachWindowUnloadHook();
                        return [4 /*yield*/, this.simpleDb.runTransaction('readwrite', [DbPrimaryClient.store, DbClientMetadata.store], function (txn) {
                                return _this.releasePrimaryLeaseIfHeld(txn).next(function () {
                                    return _this.removeClientMetadata(txn);
                                });
                            })];
                    case 1:
                        _a.sent();
                        this.simpleDb.close();
                        // Remove the entry marking the client as zombied from LocalStorage since
                        // we successfully deleted its metadata from IndexedDb.
                        this.removeClientZombiedEntry();
                        if (!deleteData) return [3 /*break*/, 3];
                        return [4 /*yield*/, SimpleDb.delete(this.dbName)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */
    IndexedDbPersistence.prototype.filterActiveClients = function (clients, activityThresholdMs) {
        var _this = this;
        return clients.filter(function (client) {
            return _this.isWithinAge(client.updateTimeMs, activityThresholdMs) &&
                !_this.isClientZombied(client.clientId);
        });
    };
    IndexedDbPersistence.prototype.getActiveClients = function () {
        var _this = this;
        return this.simpleDb.runTransaction('readonly', [DbClientMetadata.store], function (txn) {
            return clientMetadataStore(txn)
                .loadAll()
                .next(function (clients) {
                return _this.filterActiveClients(clients, MAX_CLIENT_AGE_MS).map(function (clientMetadata) { return clientMetadata.clientId; });
            });
        });
    };
    Object.defineProperty(IndexedDbPersistence.prototype, "started", {
        get: function () {
            return this._started;
        },
        enumerable: true,
        configurable: true
    });
    IndexedDbPersistence.prototype.getMutationQueue = function (user) {
        assert(this.started, 'Cannot initialize MutationQueue before persistence is started.');
        return IndexedDbMutationQueue.forUser(user, this.serializer, this.referenceDelegate);
    };
    IndexedDbPersistence.prototype.getQueryCache = function () {
        assert(this.started, 'Cannot initialize QueryCache before persistence is started.');
        return this.queryCache;
    };
    IndexedDbPersistence.prototype.getRemoteDocumentCache = function () {
        assert(this.started, 'Cannot initialize RemoteDocumentCache before persistence is started.');
        return this.remoteDocumentCache;
    };
    IndexedDbPersistence.prototype.runTransaction = function (action, mode, transactionOperation) {
        var _this = this;
        debug(LOG_TAG$2, 'Starting transaction:', action);
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.simpleDb.runTransaction(mode === 'readonly' ? 'readonly' : 'readwrite', ALL_STORES, function (simpleDbTxn) {
            if (mode === 'readwrite-primary') {
                // While we merely verify that we have (or can acquire) the lease
                // immediately, we wait to extend the primary lease until after
                // executing transactionOperation(). This ensures that even if the
                // transactionOperation takes a long time, we'll use a recent
                // leaseTimestampMs in the extended (or newly acquired) lease.
                return _this.verifyPrimaryLease(simpleDbTxn)
                    .next(function (success) {
                    if (!success) {
                        error("Failed to obtain primary lease for action '" + action + "'.");
                        _this.isPrimary = false;
                        _this.queue.enqueueAndForget(function () {
                            return _this.primaryStateListener(false);
                        });
                        throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_LOST_ERROR_MSG);
                    }
                    return transactionOperation(new IndexedDbTransaction(simpleDbTxn, _this.listenSequence.next()));
                })
                    .next(function (result) {
                    return _this.acquireOrExtendPrimaryLease(simpleDbTxn).next(function () { return result; });
                });
            }
            else {
                return _this.verifyAllowTabSynchronization(simpleDbTxn).next(function () {
                    return transactionOperation(new IndexedDbTransaction(simpleDbTxn, _this.listenSequence.next()));
                });
            }
        });
    };
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */
    // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    IndexedDbPersistence.prototype.verifyAllowTabSynchronization = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (currentPrimary) {
            var currentLeaseIsValid = currentPrimary !== null &&
                _this.isWithinAge(currentPrimary.leaseTimestampMs, MAX_PRIMARY_ELIGIBLE_AGE_MS) &&
                !_this.isClientZombied(currentPrimary.ownerId);
            if (currentLeaseIsValid && !_this.isLocalClient(currentPrimary)) {
                if (!currentPrimary.allowTabSynchronization) {
                    throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);
                }
            }
        });
    };
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */
    IndexedDbPersistence.prototype.acquireOrExtendPrimaryLease = function (txn) {
        var newPrimary = new DbPrimaryClient(this.clientId, this.allowTabSynchronization, Date.now());
        return primaryClientStore(txn).put(DbPrimaryClient.key, newPrimary);
    };
    IndexedDbPersistence.isAvailable = function () {
        return SimpleDb.isAvailable();
    };
    /**
     * Generates a string used as a prefix when storing data in IndexedDB and
     * LocalStorage.
     */
    IndexedDbPersistence.buildStoragePrefix = function (databaseInfo) {
        // Use two different prefix formats:
        //
        //   * firestore / persistenceKey / projectID . databaseID / ...
        //   * firestore / persistenceKey / projectID / ...
        //
        // projectIDs are DNS-compatible names and cannot contain dots
        // so there's no danger of collisions.
        var database = databaseInfo.databaseId.projectId;
        if (!databaseInfo.databaseId.isDefaultDatabase) {
            database += '.' + databaseInfo.databaseId.database;
        }
        return 'firestore/' + databaseInfo.persistenceKey + '/' + database + '/';
    };
    /** Checks the primary lease and removes it if we are the current primary. */
    IndexedDbPersistence.prototype.releasePrimaryLeaseIfHeld = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (primaryClient) {
            if (_this.isLocalClient(primaryClient)) {
                debug(LOG_TAG$2, 'Releasing primary lease.');
                return store.delete(DbPrimaryClient.key);
            }
            else {
                return PersistencePromise.resolve();
            }
        });
    };
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */
    IndexedDbPersistence.prototype.isWithinAge = function (updateTimeMs, maxAgeMs) {
        var now = Date.now();
        var minAcceptable = now - maxAgeMs;
        var maxAcceptable = now;
        if (updateTimeMs < minAcceptable) {
            return false;
        }
        else if (updateTimeMs > maxAcceptable) {
            error("Detected an update time that is in the future: " + updateTimeMs + " > " + maxAcceptable);
            return false;
        }
        return true;
    };
    IndexedDbPersistence.prototype.attachVisibilityHandler = function () {
        var _this = this;
        if (this.document !== null &&
            typeof this.document.addEventListener === 'function') {
            this.documentVisibilityHandler = function () {
                _this.queue.enqueueAndForget(function () {
                    _this.inForeground = _this.document.visibilityState === 'visible';
                    return _this.updateClientMetadataAndTryBecomePrimary();
                });
            };
            this.document.addEventListener('visibilitychange', this.documentVisibilityHandler);
            this.inForeground = this.document.visibilityState === 'visible';
        }
    };
    IndexedDbPersistence.prototype.detachVisibilityHandler = function () {
        if (this.documentVisibilityHandler) {
            assert(this.document !== null &&
                typeof this.document.addEventListener === 'function', "Expected 'document.addEventListener' to be a function");
            this.document.removeEventListener('visibilitychange', this.documentVisibilityHandler);
            this.documentVisibilityHandler = null;
        }
    };
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */
    IndexedDbPersistence.prototype.attachWindowUnloadHook = function () {
        var _this = this;
        if (typeof this.window.addEventListener === 'function') {
            this.windowUnloadHandler = function () {
                // Note: In theory, this should be scheduled on the AsyncQueue since it
                // accesses internal state. We execute this code directly during shutdown
                // to make sure it gets a chance to run.
                _this.markClientZombied();
                _this.queue.enqueueAndForget(function () {
                    // Attempt graceful shutdown (including releasing our primary lease),
                    // but there's no guarantee it will complete.
                    return _this.shutdown();
                });
            };
            this.window.addEventListener('unload', this.windowUnloadHandler);
        }
    };
    IndexedDbPersistence.prototype.detachWindowUnloadHook = function () {
        if (this.windowUnloadHandler) {
            assert(typeof this.window.removeEventListener === 'function', "Expected 'window.removeEventListener' to be a function");
            this.window.removeEventListener('unload', this.windowUnloadHandler);
            this.windowUnloadHandler = null;
        }
    };
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */
    IndexedDbPersistence.prototype.isClientZombied = function (clientId) {
        try {
            var isZombied = this.webStorage.getItem(this.zombiedClientLocalStorageKey(clientId)) !==
                null;
            debug(LOG_TAG$2, "Client '" + clientId + "' " + (isZombied ? 'is' : 'is not') + " zombied in LocalStorage");
            return isZombied;
        }
        catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            error(LOG_TAG$2, 'Failed to get zombied client id.', e);
            return false;
        }
    };
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */
    IndexedDbPersistence.prototype.markClientZombied = function () {
        try {
            this.webStorage.setItem(this.zombiedClientLocalStorageKey(this.clientId), String(Date.now()));
        }
        catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            error('Failed to set zombie client id.', e);
        }
    };
    /** Removes the zombied client entry if it exists. */
    IndexedDbPersistence.prototype.removeClientZombiedEntry = function () {
        try {
            this.webStorage.removeItem(this.zombiedClientLocalStorageKey(this.clientId));
        }
        catch (e) {
            // Ignore
        }
    };
    IndexedDbPersistence.prototype.zombiedClientLocalStorageKey = function (clientId) {
        return ZOMBIED_CLIENTS_KEY_PREFIX + "_" + this.persistenceKey + "_" + clientId;
    };
    /**
     * The name of the main (and currently only) IndexedDB database. this name is
     * appended to the prefix provided to the IndexedDbPersistence constructor.
     */
    IndexedDbPersistence.MAIN_DATABASE = 'main';
    return IndexedDbPersistence;
}());
function isPrimaryLeaseLostError(err) {
    return (err.code === Code.FAILED_PRECONDITION &&
        err.message === PRIMARY_LEASE_LOST_ERROR_MSG);
}
/**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err An error returned by a LocalStore operation.
 * @return A Promise that resolves after we recovered, or the original error.
 */
function ignoreIfPrimaryLeaseLoss(err) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (isPrimaryLeaseLostError(err)) {
                debug(LOG_TAG$2, 'Unexpectedly lost primary lease');
            }
            else {
                throw err;
            }
            return [2 /*return*/];
        });
    });
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */
function primaryClientStore(txn) {
    return txn.store(DbPrimaryClient.store);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */
function clientMetadataStore(txn) {
    return txn.store(DbClientMetadata.store);
}
/** Provides LRU functionality for IndexedDB persistence. */
var IndexedDbLruDelegate = /** @class */ (function () {
    function IndexedDbLruDelegate(db, params) {
        this.db = db;
        this.garbageCollector = new LruGarbageCollector(this, params);
    }
    IndexedDbLruDelegate.prototype.getSequenceNumberCount = function (txn) {
        var docCountPromise = this.orphanedDocmentCount(txn);
        var targetCountPromise = this.db.getQueryCache().getQueryCount(txn);
        return targetCountPromise.next(function (targetCount) {
            return docCountPromise.next(function (docCount) { return targetCount + docCount; });
        });
    };
    IndexedDbLruDelegate.prototype.orphanedDocmentCount = function (txn) {
        var orphanedCount = 0;
        return this.forEachOrphanedDocumentSequenceNumber(txn, function (_) {
            orphanedCount++;
        }).next(function () { return orphanedCount; });
    };
    IndexedDbLruDelegate.prototype.forEachTarget = function (txn, f) {
        return this.db.getQueryCache().forEachTarget(txn, f);
    };
    IndexedDbLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber = function (txn, f) {
        return this.forEachOrphanedDocument(txn, function (docKey, sequenceNumber) {
            return f(sequenceNumber);
        });
    };
    IndexedDbLruDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    IndexedDbLruDelegate.prototype.addReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    IndexedDbLruDelegate.prototype.removeReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    IndexedDbLruDelegate.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.db
            .getQueryCache()
            .removeTargets(txn, upperBound, activeTargetIds);
    };
    IndexedDbLruDelegate.prototype.removeMutationReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */
    IndexedDbLruDelegate.prototype.isPinned = function (txn, docKey) {
        if (this.inMemoryPins.containsKey(docKey)) {
            return PersistencePromise.resolve(true);
        }
        else {
            return mutationQueuesContainKey(txn, docKey);
        }
    };
    IndexedDbLruDelegate.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        var _this = this;
        var count = 0;
        var bytesRemoved = 0;
        var promises = [];
        var iteration = this.forEachOrphanedDocument(txn, function (docKey, sequenceNumber) {
            if (sequenceNumber <= upperBound) {
                var p = _this.isPinned(txn, docKey).next(function (isPinned) {
                    if (!isPinned) {
                        count++;
                        return _this.removeOrphanedDocument(txn, docKey).next(function (documentBytes) {
                            bytesRemoved += documentBytes;
                        });
                    }
                });
                promises.push(p);
            }
        });
        // Wait for iteration first to make sure we have a chance to add all of the
        // removal promises to the array.
        return iteration
            .next(function () { return PersistencePromise.waitFor(promises); })
            .next(function () {
            return _this.db.getRemoteDocumentCache().updateSize(txn, -bytesRemoved);
        })
            .next(function () { return count; });
    };
    /**
     * Clears a document from the cache. The document is assumed to be orphaned, so target-document
     * associations are not queried. We remove it from the remote document cache, as well as remove
     * its sentinel row.
     */
    IndexedDbLruDelegate.prototype.removeOrphanedDocument = function (txn, docKey) {
        var totalBytesRemoved = 0;
        var documentCache = this.db.getRemoteDocumentCache();
        return PersistencePromise.waitFor([
            documentTargetStore(txn).delete(sentinelKey$1(docKey)),
            documentCache.removeEntry(txn, docKey).next(function (bytesRemoved) {
                totalBytesRemoved += bytesRemoved;
            })
        ]).next(function () { return totalBytesRemoved; });
    };
    IndexedDbLruDelegate.prototype.removeTarget = function (txn, queryData) {
        var updated = queryData.copy({
            sequenceNumber: txn.currentSequenceNumber
        });
        return this.db.getQueryCache().updateQueryData(txn, updated);
    };
    IndexedDbLruDelegate.prototype.updateLimboDocument = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */
    IndexedDbLruDelegate.prototype.forEachOrphanedDocument = function (txn, f) {
        var store = documentTargetStore(txn);
        var nextToReport = ListenSequence.INVALID;
        var nextPath;
        return store
            .iterate({
            index: DbTargetDocument.documentTargetsIndex
        }, function (_a, _b) {
            var targetId = _a[0], docKey = _a[1];
            var path = _b.path, sequenceNumber = _b.sequenceNumber;
            if (targetId === 0) {
                // if nextToReport is valid, report it, this is a new key so the
                // last one must not be a member of any targets.
                if (nextToReport !== ListenSequence.INVALID) {
                    f(new DocumentKey(decode(nextPath)), nextToReport);
                }
                // set nextToReport to be this sequence number. It's the next one we
                // might report, if we don't find any targets for this document.
                // Note that the sequence number must be defined when the targetId
                // is 0.
                nextToReport = sequenceNumber;
                nextPath = path;
            }
            else {
                // set nextToReport to be invalid, we know we don't need to report
                // this one since we found a target for it.
                nextToReport = ListenSequence.INVALID;
            }
        })
            .next(function () {
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            if (nextToReport !== ListenSequence.INVALID) {
                f(new DocumentKey(decode(nextPath)), nextToReport);
            }
        });
    };
    IndexedDbLruDelegate.prototype.getCacheSize = function (txn) {
        return this.db.getRemoteDocumentCache().getSize(txn);
    };
    return IndexedDbLruDelegate;
}());
function sentinelKey$1(key) {
    return [0, encode(key.path)];
}
/**
 * @return A value suitable for writing a sentinel row in the target-document
 * store.
 */
function sentinelRow(key, sequenceNumber) {
    return new DbTargetDocument(0, encode(key.path), sequenceNumber);
}
function writeSentinelKey(txn, key) {
    return documentTargetStore(txn).put(sentinelRow(key, txn.currentSequenceNumber));
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */
var LocalDocumentsView = /** @class */ (function () {
    function LocalDocumentsView(remoteDocumentCache, mutationQueue) {
        this.remoteDocumentCache = remoteDocumentCache;
        this.mutationQueue = mutationQueue;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @return Local view of the document or null if we don't have any cached
     * state for it.
     */
    LocalDocumentsView.prototype.getDocument = function (transaction, key) {
        var _this = this;
        return this.mutationQueue
            .getAllMutationBatchesAffectingDocumentKey(transaction, key)
            .next(function (batches) { return _this.getDocumentInternal(transaction, key, batches); });
    };
    /** Internal version of `getDocument` that allows reusing batches. */
    LocalDocumentsView.prototype.getDocumentInternal = function (transaction, key, inBatches) {
        return this.remoteDocumentCache.getEntry(transaction, key).next(function (doc) {
            for (var _i = 0, inBatches_1 = inBatches; _i < inBatches_1.length; _i++) {
                var batch = inBatches_1[_i];
                doc = batch.applyToLocalView(key, doc);
            }
            return doc;
        });
    };
    // Returns the view of the given `docs` as they would appear after applying
    // all mutations in the given `batches`.
    LocalDocumentsView.prototype.applyLocalMutationsToDocuments = function (transaction, docs, batches) {
        var results = nullableMaybeDocumentMap();
        docs.forEach(function (key, localView) {
            for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
                var batch = batches_1[_i];
                localView = batch.applyToLocalView(key, localView);
            }
            results = results.insert(key, localView);
        });
        return results;
    };
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */
    LocalDocumentsView.prototype.getDocuments = function (transaction, keys) {
        var _this = this;
        return this.remoteDocumentCache
            .getEntries(transaction, keys)
            .next(function (docs) { return _this.getLocalViewOfDocuments(transaction, docs); });
    };
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     */
    LocalDocumentsView.prototype.getLocalViewOfDocuments = function (transaction, baseDocs) {
        var _this = this;
        return this.mutationQueue
            .getAllMutationBatchesAffectingDocumentKeys(transaction, baseDocs)
            .next(function (batches) {
            var docs = _this.applyLocalMutationsToDocuments(transaction, baseDocs, batches);
            var results = maybeDocumentMap();
            docs.forEach(function (key, maybeDoc) {
                // TODO(http://b/32275378): Don't conflate missing / deleted.
                if (!maybeDoc) {
                    maybeDoc = new NoDocument(key, SnapshotVersion.forDeletedDoc());
                }
                results = results.insert(key, maybeDoc);
            });
            return results;
        });
    };
    /** Performs a query against the local view of all documents. */
    LocalDocumentsView.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        if (DocumentKey.isDocumentKey(query.path)) {
            return this.getDocumentsMatchingDocumentQuery(transaction, query.path);
        }
        else {
            return this.getDocumentsMatchingCollectionQuery(transaction, query);
        }
    };
    LocalDocumentsView.prototype.getDocumentsMatchingDocumentQuery = function (transaction, docPath) {
        // Just do a simple document lookup.
        return this.getDocument(transaction, new DocumentKey(docPath)).next(function (maybeDoc) {
            var result = documentMap();
            if (maybeDoc instanceof Document) {
                result = result.insert(maybeDoc.key, maybeDoc);
            }
            return result;
        });
    };
    LocalDocumentsView.prototype.getDocumentsMatchingCollectionQuery = function (transaction, query) {
        var _this = this;
        // Query the remote documents and overlay mutations.
        var results;
        return this.remoteDocumentCache
            .getDocumentsMatchingQuery(transaction, query)
            .next(function (queryResults) {
            results = queryResults;
            return _this.mutationQueue.getAllMutationBatchesAffectingQuery(transaction, query);
        })
            .next(function (matchingMutationBatches) {
            for (var _i = 0, matchingMutationBatches_1 = matchingMutationBatches; _i < matchingMutationBatches_1.length; _i++) {
                var batch = matchingMutationBatches_1[_i];
                for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                    var mutation = _b[_a];
                    var key = mutation.key;
                    // Only process documents belonging to the collection.
                    if (!query.path.isImmediateParentOf(key.path)) {
                        continue;
                    }
                    var baseDoc = results.get(key);
                    var mutatedDoc = mutation.applyToLocalView(baseDoc, baseDoc, batch.localWriteTime);
                    if (mutatedDoc instanceof Document) {
                        results = results.insert(key, mutatedDoc);
                    }
                    else {
                        results = results.remove(key);
                    }
                }
            }
        })
            .next(function () {
            // Finally, filter out any documents that don't actually match
            // the query.
            results.forEach(function (key, doc) {
                if (!query.matches(doc)) {
                    results = results.remove(key);
                }
            });
            return results;
        });
    };
    return LocalDocumentsView;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */
var ReferenceSet = /** @class */ (function () {
    function ReferenceSet() {
        // A set of outstanding references to a document sorted by key.
        this.refsByKey = new SortedSet(DocReference.compareByKey);
        // A set of outstanding references to a document sorted by target id.
        this.refsByTarget = new SortedSet(DocReference.compareByTargetId);
    }
    /** Returns true if the reference set contains no references. */
    ReferenceSet.prototype.isEmpty = function () {
        return this.refsByKey.isEmpty();
    };
    /** Adds a reference to the given document key for the given ID. */
    ReferenceSet.prototype.addReference = function (key, id) {
        var ref = new DocReference(key, id);
        this.refsByKey = this.refsByKey.add(ref);
        this.refsByTarget = this.refsByTarget.add(ref);
    };
    /** Add references to the given document keys for the given ID. */
    ReferenceSet.prototype.addReferences = function (keys, id) {
        var _this = this;
        keys.forEach(function (key) { return _this.addReference(key, id); });
    };
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */
    ReferenceSet.prototype.removeReference = function (key, id) {
        this.removeRef(new DocReference(key, id));
    };
    ReferenceSet.prototype.removeReferences = function (keys, id) {
        var _this = this;
        keys.forEach(function (key) { return _this.removeReference(key, id); });
    };
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */
    ReferenceSet.prototype.removeReferencesForId = function (id) {
        var _this = this;
        var emptyKey = DocumentKey.EMPTY;
        var startRef = new DocReference(emptyKey, id);
        var endRef = new DocReference(emptyKey, id + 1);
        var keys = [];
        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
            _this.removeRef(ref);
            keys.push(ref.key);
        });
        return keys;
    };
    ReferenceSet.prototype.removeAllReferences = function () {
        var _this = this;
        this.refsByKey.forEach(function (ref) { return _this.removeRef(ref); });
    };
    ReferenceSet.prototype.removeRef = function (ref) {
        this.refsByKey = this.refsByKey.delete(ref);
        this.refsByTarget = this.refsByTarget.delete(ref);
    };
    ReferenceSet.prototype.referencesForId = function (id) {
        var emptyKey = DocumentKey.EMPTY;
        var startRef = new DocReference(emptyKey, id);
        var endRef = new DocReference(emptyKey, id + 1);
        var keys = documentKeySet();
        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
            keys = keys.add(ref.key);
        });
        return keys;
    };
    ReferenceSet.prototype.containsKey = function (key) {
        var ref = new DocReference(key, 0);
        var firstRef = this.refsByKey.firstAfterOrEqual(ref);
        return firstRef !== null && key.isEqual(firstRef.key);
    };
    return ReferenceSet;
}());
var DocReference = /** @class */ (function () {
    function DocReference(key, targetOrBatchId) {
        this.key = key;
        this.targetOrBatchId = targetOrBatchId;
    }
    /** Compare by key then by ID */
    DocReference.compareByKey = function (left, right) {
        return (DocumentKey.comparator(left.key, right.key) ||
            primitiveComparator(left.targetOrBatchId, right.targetOrBatchId));
    };
    /** Compare by ID then by key */
    DocReference.compareByTargetId = function (left, right) {
        return (primitiveComparator(left.targetOrBatchId, right.targetOrBatchId) ||
            DocumentKey.comparator(left.key, right.key));
    };
    return DocReference;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$3 = 'LocalStore';
/**
 * Local storage in the Firestore client. Coordinates persistence components
 * like the mutation queue and remote document cache to present a
 * latency-compensated view of stored data.
 *
 * The LocalStore is responsible for accepting mutations from the Sync Engine.
 * Writes from the client are put into a queue as provisional Mutations until
 * they are processed by the RemoteStore and confirmed as having been written
 * to the server.
 *
 * The local store provides the local version of documents that have been
 * modified locally. It maintains the constraint:
 *
 *   LocalDocument = RemoteDocument + Active(LocalMutations)
 *
 * (Active mutations are those that are enqueued and have not been previously
 * acknowledged or rejected).
 *
 * The RemoteDocument ("ground truth") state is provided via the
 * applyChangeBatch method. It will be some version of a server-provided
 * document OR will be a server-provided document PLUS acknowledged mutations:
 *
 *   RemoteDocument' = RemoteDocument + Acknowledged(LocalMutations)
 *
 * Note that this "dirty" version of a RemoteDocument will not be identical to a
 * server base version, since it has LocalMutations added to it pending getting
 * an authoritative copy from the server.
 *
 * Since LocalMutations can be rejected by the server, we have to be able to
 * revert a LocalMutation that has already been applied to the LocalDocument
 * (typically done by replaying all remaining LocalMutations to the
 * RemoteDocument to re-apply).
 *
 * The LocalStore is responsible for the garbage collection of the documents it
 * contains. For now, it every doc referenced by a view, the mutation queue, or
 * the RemoteStore.
 *
 * It also maintains the persistence of mapping queries to resume tokens and
 * target ids. It needs to know this data about queries to properly know what
 * docs it would be allowed to garbage collect.
 *
 * The LocalStore must be able to efficiently execute queries against its local
 * cache of the documents, to provide the initial set of results before any
 * remote changes have been received.
 *
 * Note: In TypeScript, most methods return Promises since the implementation
 * may rely on fetching data from IndexedDB which is async.
 * These Promises will only be rejected on an I/O error or other internal
 * (unexpected) failure (e.g. failed assert) and always represent an
 * unrecoverable error (should be caught / reported by the async_queue).
 */
var LocalStore = /** @class */ (function () {
    function LocalStore(
    /** Manages our in-memory or durable persistence. */
    persistence, initialUser) {
        this.persistence = persistence;
        /**
         * The set of document references maintained by any local views.
         */
        this.localViewReferences = new ReferenceSet();
        /** Maps a targetID to data about its query. */
        this.queryDataByTarget = {};
        assert(persistence.started, 'LocalStore was passed an unstarted persistence implementation');
        this.persistence.referenceDelegate.setInMemoryPins(this.localViewReferences);
        this.mutationQueue = persistence.getMutationQueue(initialUser);
        this.remoteDocuments = persistence.getRemoteDocumentCache();
        this.queryCache = persistence.getQueryCache();
        this.localDocuments = new LocalDocumentsView(this.remoteDocuments, this.mutationQueue);
    }
    /**
     * Tells the LocalStore that the currently authenticated user has changed.
     *
     * In response the local store switches the mutation queue to the new user and
     * returns any resulting document changes.
     */
    // PORTING NOTE: Android and iOS only return the documents affected by the
    // change.
    LocalStore.prototype.handleUserChange = function (user) {
        var _this = this;
        return this.persistence.runTransaction('Handle user change', 'readonly', function (txn) {
            // Swap out the mutation queue, grabbing the pending mutation batches
            // before and after.
            var oldBatches;
            return _this.mutationQueue
                .getAllMutationBatches(txn)
                .next(function (promisedOldBatches) {
                oldBatches = promisedOldBatches;
                _this.mutationQueue = _this.persistence.getMutationQueue(user);
                // Recreate our LocalDocumentsView using the new
                // MutationQueue.
                _this.localDocuments = new LocalDocumentsView(_this.remoteDocuments, _this.mutationQueue);
                return _this.mutationQueue.getAllMutationBatches(txn);
            })
                .next(function (newBatches) {
                var removedBatchIds = [];
                var addedBatchIds = [];
                // Union the old/new changed keys.
                var changedKeys = documentKeySet();
                for (var _i = 0, oldBatches_1 = oldBatches; _i < oldBatches_1.length; _i++) {
                    var batch = oldBatches_1[_i];
                    removedBatchIds.push(batch.batchId);
                    for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                        var mutation = _b[_a];
                        changedKeys = changedKeys.add(mutation.key);
                    }
                }
                for (var _c = 0, newBatches_1 = newBatches; _c < newBatches_1.length; _c++) {
                    var batch = newBatches_1[_c];
                    addedBatchIds.push(batch.batchId);
                    for (var _d = 0, _e = batch.mutations; _d < _e.length; _d++) {
                        var mutation = _e[_d];
                        changedKeys = changedKeys.add(mutation.key);
                    }
                }
                // Return the set of all (potentially) changed documents and the list
                // of mutation batch IDs that were affected by change.
                return _this.localDocuments
                    .getDocuments(txn, changedKeys)
                    .next(function (affectedDocuments) {
                    return {
                        affectedDocuments: affectedDocuments,
                        removedBatchIds: removedBatchIds,
                        addedBatchIds: addedBatchIds
                    };
                });
            });
        });
    };
    /* Accept locally generated Mutations and commit them to storage. */
    LocalStore.prototype.localWrite = function (mutations) {
        var _this = this;
        return this.persistence.runTransaction('Locally write mutations', 'readwrite', function (txn) {
            var batch;
            var localWriteTime = Timestamp.now();
            return _this.mutationQueue
                .addMutationBatch(txn, localWriteTime, mutations)
                .next(function (promisedBatch) {
                batch = promisedBatch;
                // TODO(koss): This is doing an N^2 update by replaying ALL the
                // mutations on each document (instead of just the ones added) in
                // this batch.
                var keys = batch.keys();
                return _this.localDocuments.getDocuments(txn, keys);
            })
                .next(function (changedDocuments) {
                return { batchId: batch.batchId, changes: changedDocuments };
            });
        });
    };
    /** Returns the local view of the documents affected by a mutation batch. */
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.lookupMutationDocuments = function (batchId) {
        var _this = this;
        return this.persistence.runTransaction('Lookup mutation documents', 'readonly', function (txn) {
            return _this.mutationQueue
                .lookupMutationKeys(txn, batchId)
                .next(function (keys) {
                if (keys) {
                    return _this.localDocuments.getDocuments(txn, keys);
                }
                else {
                    return PersistencePromise.resolve(null);
                }
            });
        });
    };
    /**
     * Acknowledge the given batch.
     *
     * On the happy path when a batch is acknowledged, the local store will
     *
     *  + remove the batch from the mutation queue;
     *  + apply the changes to the remote document cache;
     *  + recalculate the latency compensated view implied by those changes (there
     *    may be mutations in the queue that affect the documents but haven't been
     *    acknowledged yet); and
     *  + give the changed documents back the sync engine
     *
     * @returns The resulting (modified) documents.
     */
    LocalStore.prototype.acknowledgeBatch = function (batchResult) {
        var _this = this;
        return this.persistence.runTransaction('Acknowledge batch', 'readwrite-primary', function (txn) {
            var affected = batchResult.batch.keys();
            var documentBuffer = _this.remoteDocuments.newChangeBuffer();
            return _this.mutationQueue
                .acknowledgeBatch(txn, batchResult.batch, batchResult.streamToken)
                .next(function () {
                return _this.applyWriteToRemoteDocuments(txn, batchResult, documentBuffer);
            })
                .next(function () { return documentBuffer.apply(txn); })
                .next(function () { return _this.mutationQueue.performConsistencyCheck(txn); })
                .next(function () { return _this.localDocuments.getDocuments(txn, affected); });
        });
    };
    /**
     * Remove mutations from the MutationQueue for the specified batch;
     * LocalDocuments will be recalculated.
     *
     * @returns The resulting modified documents.
     */
    LocalStore.prototype.rejectBatch = function (batchId) {
        var _this = this;
        return this.persistence.runTransaction('Reject batch', 'readwrite-primary', function (txn) {
            var affectedKeys;
            return _this.mutationQueue
                .lookupMutationBatch(txn, batchId)
                .next(function (batch) {
                assert(batch !== null, 'Attempt to reject nonexistent batch!');
                affectedKeys = batch.keys();
                return _this.mutationQueue.removeMutationBatch(txn, batch);
            })
                .next(function () {
                return _this.mutationQueue.performConsistencyCheck(txn);
            })
                .next(function () {
                return _this.localDocuments.getDocuments(txn, affectedKeys);
            });
        });
    };
    /** Returns the last recorded stream token for the current user. */
    LocalStore.prototype.getLastStreamToken = function () {
        var _this = this;
        return this.persistence.runTransaction('Get last stream token', 'readonly', function (txn) {
            return _this.mutationQueue.getLastStreamToken(txn);
        });
    };
    /**
     * Sets the stream token for the current user without acknowledging any
     * mutation batch. This is usually only useful after a stream handshake or in
     * response to an error that requires clearing the stream token.
     */
    LocalStore.prototype.setLastStreamToken = function (streamToken) {
        var _this = this;
        return this.persistence.runTransaction('Set last stream token', 'readwrite-primary', function (txn) {
            return _this.mutationQueue.setLastStreamToken(txn, streamToken);
        });
    };
    /**
     * Returns the last consistent snapshot processed (used by the RemoteStore to
     * determine whether to buffer incoming snapshots from the backend).
     */
    LocalStore.prototype.getLastRemoteSnapshotVersion = function () {
        var _this = this;
        return this.persistence.runTransaction('Get last remote snapshot version', 'readonly', function (txn) { return _this.queryCache.getLastRemoteSnapshotVersion(txn); });
    };
    /**
     * Update the "ground-state" (remote) documents. We assume that the remote
     * event reflects any write batches that have been acknowledged or rejected
     * (i.e. we do not re-apply local mutations to updates from this event).
     *
     * LocalDocuments are re-calculated if there are remaining mutations in the
     * queue.
     */
    LocalStore.prototype.applyRemoteEvent = function (remoteEvent) {
        var _this = this;
        var documentBuffer = this.remoteDocuments.newChangeBuffer();
        return this.persistence.runTransaction('Apply remote event', 'readwrite-primary', function (txn) {
            var promises = [];
            var authoritativeUpdates = documentKeySet();
            forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
                // Do not ref/unref unassigned targetIds - it may lead to leaks.
                var queryData = _this.queryDataByTarget[targetId];
                if (!queryData)
                    return;
                // When a global snapshot contains updates (either add or modify) we
                // can completely trust these updates as authoritative and blindly
                // apply them to our cache (as a defensive measure to promote
                // self-healing in the unfortunate case that our cache is ever somehow
                // corrupted / out-of-sync).
                //
                // If the document is only updated while removing it from a target
                // then watch isn't obligated to send the absolute latest version: it
                // can send the first version that caused the document not to match.
                change.addedDocuments.forEach(function (key) {
                    authoritativeUpdates = authoritativeUpdates.add(key);
                });
                change.modifiedDocuments.forEach(function (key) {
                    authoritativeUpdates = authoritativeUpdates.add(key);
                });
                promises.push(_this.queryCache
                    .removeMatchingKeys(txn, change.removedDocuments, targetId)
                    .next(function () {
                    return _this.queryCache.addMatchingKeys(txn, change.addedDocuments, targetId);
                }));
                // Update the resume token if the change includes one. Don't clear
                // any preexisting value.
                var resumeToken = change.resumeToken;
                if (resumeToken.length > 0) {
                    var oldQueryData = queryData;
                    queryData = queryData.copy({
                        resumeToken: resumeToken,
                        snapshotVersion: remoteEvent.snapshotVersion
                    });
                    _this.queryDataByTarget[targetId] = queryData;
                    if (LocalStore.shouldPersistQueryData(oldQueryData, queryData, change)) {
                        promises.push(_this.queryCache.updateQueryData(txn, queryData));
                    }
                }
            });
            var changedDocs = maybeDocumentMap();
            var updatedKeys = documentKeySet();
            remoteEvent.documentUpdates.forEach(function (key, doc) {
                updatedKeys = updatedKeys.add(key);
            });
            // Each loop iteration only affects its "own" doc, so it's safe to get all the remote
            // documents in advance in a single call.
            promises.push(documentBuffer.getEntries(txn, updatedKeys).next(function (existingDocs) {
                remoteEvent.documentUpdates.forEach(function (key, doc) {
                    var existingDoc = existingDocs.get(key);
                    // If a document update isn't authoritative, make sure we don't
                    // apply an old document version to the remote cache. We make an
                    // exception for SnapshotVersion.MIN which can happen for
                    // manufactured events (e.g. in the case of a limbo document
                    // resolution failing).
                    if (existingDoc == null ||
                        doc.version.isEqual(SnapshotVersion.MIN) ||
                        (authoritativeUpdates.has(doc.key) &&
                            !existingDoc.hasPendingWrites) ||
                        doc.version.compareTo(existingDoc.version) >= 0) {
                        documentBuffer.addEntry(doc);
                        changedDocs = changedDocs.insert(key, doc);
                    }
                    else {
                        debug(LOG_TAG$3, 'Ignoring outdated watch update for ', key, '. Current version:', existingDoc.version, ' Watch version:', doc.version);
                    }
                    if (remoteEvent.resolvedLimboDocuments.has(key)) {
                        promises.push(_this.persistence.referenceDelegate.updateLimboDocument(txn, key));
                    }
                });
            }));
            // HACK: The only reason we allow a null snapshot version is so that we
            // can synthesize remote events when we get permission denied errors while
            // trying to resolve the state of a locally cached document that is in
            // limbo.
            var remoteVersion = remoteEvent.snapshotVersion;
            if (!remoteVersion.isEqual(SnapshotVersion.MIN)) {
                var updateRemoteVersion = _this.queryCache
                    .getLastRemoteSnapshotVersion(txn)
                    .next(function (lastRemoteVersion) {
                    assert(remoteVersion.compareTo(lastRemoteVersion) >= 0, 'Watch stream reverted to previous snapshot?? ' +
                        remoteVersion +
                        ' < ' +
                        lastRemoteVersion);
                    return _this.queryCache.setTargetsMetadata(txn, txn.currentSequenceNumber, remoteVersion);
                });
                promises.push(updateRemoteVersion);
            }
            return PersistencePromise.waitFor(promises)
                .next(function () { return documentBuffer.apply(txn); })
                .next(function () {
                return _this.localDocuments.getLocalViewOfDocuments(txn, changedDocs);
            });
        });
    };
    /**
     * Returns true if the newQueryData should be persisted during an update of
     * an active target. QueryData should always be persisted when a target is
     * being released and should not call this function.
     *
     * While the target is active, QueryData updates can be omitted when nothing
     * about the target has changed except metadata like the resume token or
     * snapshot version. Occasionally it's worth the extra write to prevent these
     * values from getting too stale after a crash, but this doesn't have to be
     * too frequent.
     */
    LocalStore.shouldPersistQueryData = function (oldQueryData, newQueryData, change) {
        // Avoid clearing any existing value
        if (newQueryData.resumeToken.length === 0)
            return false;
        // Any resume token is interesting if there isn't one already.
        if (oldQueryData.resumeToken.length === 0)
            return true;
        // Don't allow resume token changes to be buffered indefinitely. This
        // allows us to be reasonably up-to-date after a crash and avoids needing
        // to loop over all active queries on shutdown. Especially in the browser
        // we may not get time to do anything interesting while the current tab is
        // closing.
        var timeDelta = newQueryData.snapshotVersion.toMicroseconds() -
            oldQueryData.snapshotVersion.toMicroseconds();
        if (timeDelta >= this.RESUME_TOKEN_MAX_AGE_MICROS)
            return true;
        // Otherwise if the only thing that has changed about a target is its resume
        // token it's not worth persisting. Note that the RemoteStore keeps an
        // in-memory view of the currently active targets which includes the current
        // resume token, so stream failure or user changes will still use an
        // up-to-date resume token regardless of what we do here.
        var changes = change.addedDocuments.size +
            change.modifiedDocuments.size +
            change.removedDocuments.size;
        return changes > 0;
    };
    /**
     * Notify local store of the changed views to locally pin documents.
     */
    LocalStore.prototype.notifyLocalViewChanges = function (viewChanges) {
        var _this = this;
        return this.persistence.runTransaction('notifyLocalViewChanges', 'readwrite', function (txn) {
            return PersistencePromise.forEach(viewChanges, function (viewChange) {
                _this.localViewReferences.addReferences(viewChange.addedKeys, viewChange.targetId);
                _this.localViewReferences.removeReferences(viewChange.removedKeys, viewChange.targetId);
                return PersistencePromise.forEach(viewChange.removedKeys, function (key) {
                    return _this.persistence.referenceDelegate.removeReference(txn, key);
                });
            });
        });
    };
    /**
     * Gets the mutation batch after the passed in batchId in the mutation queue
     * or null if empty.
     * @param afterBatchId If provided, the batch to search after.
     * @returns The next mutation or null if there wasn't one.
     */
    LocalStore.prototype.nextMutationBatch = function (afterBatchId) {
        var _this = this;
        return this.persistence.runTransaction('Get next mutation batch', 'readonly', function (txn) {
            if (afterBatchId === undefined) {
                afterBatchId = BATCHID_UNKNOWN;
            }
            return _this.mutationQueue.getNextMutationBatchAfterBatchId(txn, afterBatchId);
        });
    };
    /**
     * Read the current value of a Document with a given key or null if not
     * found - used for testing.
     */
    LocalStore.prototype.readDocument = function (key) {
        var _this = this;
        return this.persistence.runTransaction('read document', 'readonly', function (txn) {
            return _this.localDocuments.getDocument(txn, key);
        });
    };
    /**
     * Assigns the given query an internal ID so that its results can be pinned so
     * they don't get GC'd. A query must be allocated in the local store before
     * the store can be used to manage its view.
     */
    LocalStore.prototype.allocateQuery = function (query) {
        var _this = this;
        return this.persistence.runTransaction('Allocate query', 'readwrite', function (txn) {
            var queryData;
            return _this.queryCache
                .getQueryData(txn, query)
                .next(function (cached) {
                if (cached) {
                    // This query has been listened to previously, so reuse the
                    // previous targetID.
                    // TODO(mcg): freshen last accessed date?
                    queryData = cached;
                    return PersistencePromise.resolve();
                }
                else {
                    return _this.queryCache.allocateTargetId(txn).next(function (targetId) {
                        queryData = new QueryData(query, targetId, QueryPurpose.Listen, txn.currentSequenceNumber);
                        return _this.queryCache.addQueryData(txn, queryData);
                    });
                }
            })
                .next(function () {
                assert(!_this.queryDataByTarget[queryData.targetId], 'Tried to allocate an already allocated query: ' + query);
                _this.queryDataByTarget[queryData.targetId] = queryData;
                return queryData;
            });
        });
    };
    /**
     * Unpin all the documents associated with the given query. If
     * `keepPersistedQueryData` is set to false and Eager GC enabled, the method
     * directly removes the associated query data from the query cache.
     */
    // PORTING NOTE: `keepPersistedQueryData` is multi-tab only.
    LocalStore.prototype.releaseQuery = function (query, keepPersistedQueryData) {
        var _this = this;
        var mode = keepPersistedQueryData ? 'readwrite' : 'readwrite-primary';
        return this.persistence.runTransaction('Release query', mode, function (txn) {
            return _this.queryCache
                .getQueryData(txn, query)
                .next(function (queryData) {
                assert(queryData != null, 'Tried to release nonexistent query: ' + query);
                var targetId = queryData.targetId;
                var cachedQueryData = _this.queryDataByTarget[targetId];
                // References for documents sent via Watch are automatically removed when we delete a
                // query's target data from the reference delegate. Since this does not remove references
                // for locally mutated documents, we have to remove the target associations for these
                // documents manually.
                var removed = _this.localViewReferences.removeReferencesForId(targetId);
                delete _this.queryDataByTarget[targetId];
                if (!keepPersistedQueryData) {
                    return PersistencePromise.forEach(removed, function (key) {
                        return _this.persistence.referenceDelegate.removeReference(txn, key);
                    }).next(function () {
                        return _this.persistence.referenceDelegate.removeTarget(txn, cachedQueryData);
                    });
                }
                else {
                    return PersistencePromise.resolve();
                }
            });
        });
    };
    /**
     * Runs the specified query against all the documents in the local store and
     * returns the results.
     */
    LocalStore.prototype.executeQuery = function (query) {
        var _this = this;
        return this.persistence.runTransaction('Execute query', 'readonly', function (txn) {
            return _this.localDocuments.getDocumentsMatchingQuery(txn, query);
        });
    };
    /**
     * Returns the keys of the documents that are associated with the given
     * target id in the remote table.
     */
    LocalStore.prototype.remoteDocumentKeys = function (targetId) {
        var _this = this;
        return this.persistence.runTransaction('Remote document keys', 'readonly', function (txn) {
            return _this.queryCache.getMatchingKeysForTargetId(txn, targetId);
        });
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getActiveClients = function () {
        return this.persistence.getActiveClients();
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.removeCachedMutationBatchMetadata = function (batchId) {
        this.mutationQueue.removeCachedMutationKeys(batchId);
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.setNetworkEnabled = function (networkEnabled) {
        this.persistence.setNetworkEnabled(networkEnabled);
    };
    LocalStore.prototype.applyWriteToRemoteDocuments = function (txn, batchResult, documentBuffer) {
        var _this = this;
        var batch = batchResult.batch;
        var docKeys = batch.keys();
        var promiseChain = PersistencePromise.resolve();
        docKeys.forEach(function (docKey) {
            promiseChain = promiseChain
                .next(function () {
                return documentBuffer.getEntry(txn, docKey);
            })
                .next(function (remoteDoc) {
                var doc = remoteDoc;
                var ackVersion = batchResult.docVersions.get(docKey);
                assert(ackVersion !== null, 'ackVersions should contain every doc in the write.');
                if (!doc || doc.version.compareTo(ackVersion) < 0) {
                    doc = batch.applyToRemoteDocument(docKey, doc, batchResult);
                    if (!doc) {
                        assert(!remoteDoc, 'Mutation batch ' +
                            batch +
                            ' applied to document ' +
                            remoteDoc +
                            ' resulted in null');
                    }
                    else {
                        documentBuffer.addEntry(doc);
                    }
                }
            });
        });
        return promiseChain.next(function () {
            return _this.mutationQueue.removeMutationBatch(txn, batch);
        });
    };
    LocalStore.prototype.collectGarbage = function (garbageCollector) {
        var _this = this;
        return this.persistence.runTransaction('Collect garbage', 'readwrite-primary', function (txn) { return garbageCollector.collect(txn, _this.queryDataByTarget); });
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getQueryForTarget = function (targetId) {
        var _this = this;
        if (this.queryDataByTarget[targetId]) {
            return Promise.resolve(this.queryDataByTarget[targetId].query);
        }
        else {
            return this.persistence.runTransaction('Get query data', 'readonly', function (txn) {
                return _this.queryCache
                    .getQueryDataForTarget(txn, targetId)
                    .next(function (queryData) { return (queryData ? queryData.query : null); });
            });
        }
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getNewDocumentChanges = function () {
        var _this = this;
        return this.persistence.runTransaction('Get new document changes', 'readonly', function (txn) {
            return _this.remoteDocuments.getNewDocumentChanges(txn);
        });
    };
    /**
     * The maximum time to leave a resume token buffered without writing it out.
     * This value is arbitrary: it's long enough to avoid several writes
     * (possibly indefinitely if updates come more frequently than this) but
     * short enough that restarting after crashing will still have a pretty
     * recent resume token.
     */
    LocalStore.RESUME_TOKEN_MAX_AGE_MICROS = 5 * 60 * 1e6;
    return LocalStore;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MemoryMutationQueue = /** @class */ (function () {
    function MemoryMutationQueue(referenceDelegate) {
        this.referenceDelegate = referenceDelegate;
        /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */
        this.mutationQueue = [];
        /** Next value to use when assigning sequential IDs to each mutation batch. */
        this.nextBatchId = 1;
        /** The last received stream token from the server, used to acknowledge which
         * responses the client has processed. Stream tokens are opaque checkpoint
         * markers whose only real value is their inclusion in the next request.
         */
        this.lastStreamToken = emptyByteString();
        /** An ordered mapping between documents and the mutations batch IDs. */
        this.batchesByDocumentKey = new SortedSet(DocReference.compareByKey);
    }
    MemoryMutationQueue.prototype.checkEmpty = function (transaction) {
        return PersistencePromise.resolve(this.mutationQueue.length === 0);
    };
    MemoryMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
        var batchId = batch.batchId;
        var batchIndex = this.indexOfExistingBatchId(batchId, 'acknowledged');
        assert(batchIndex === 0, 'Can only acknowledge the first batch in the mutation queue');
        // Verify that the batch in the queue is the one to be acknowledged.
        var check = this.mutationQueue[batchIndex];
        assert(batchId === check.batchId, 'Queue ordering failure: expected batch ' +
            batchId +
            ', got batch ' +
            check.batchId);
        this.lastStreamToken = streamToken;
        return PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.getLastStreamToken = function (transaction) {
        return PersistencePromise.resolve(this.lastStreamToken);
    };
    MemoryMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
        this.lastStreamToken = streamToken;
        return PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
        assert(mutations.length !== 0, 'Mutation batches should not be empty');
        var batchId = this.nextBatchId;
        this.nextBatchId++;
        if (this.mutationQueue.length > 0) {
            var prior = this.mutationQueue[this.mutationQueue.length - 1];
            assert(prior.batchId < batchId, 'Mutation batchIDs must be monotonically increasing order');
        }
        var batch = new MutationBatch(batchId, localWriteTime, mutations);
        this.mutationQueue.push(batch);
        // Track references by document key.
        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
            var mutation = mutations_1[_i];
            this.batchesByDocumentKey = this.batchesByDocumentKey.add(new DocReference(mutation.key, batchId));
        }
        return PersistencePromise.resolve(batch);
    };
    MemoryMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
        return PersistencePromise.resolve(this.findMutationBatch(batchId));
    };
    MemoryMutationQueue.prototype.lookupMutationKeys = function (transaction, batchId) {
        var mutationBatch = this.findMutationBatch(batchId);
        assert(mutationBatch != null, 'Failed to find local mutation batch.');
        return PersistencePromise.resolve(mutationBatch.keys());
    };
    MemoryMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
        var nextBatchId = batchId + 1;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        var rawIndex = this.indexOfBatchId(nextBatchId);
        var index = rawIndex < 0 ? 0 : rawIndex;
        return PersistencePromise.resolve(this.mutationQueue.length > index ? this.mutationQueue[index] : null);
    };
    MemoryMutationQueue.prototype.getAllMutationBatches = function (transaction) {
        return PersistencePromise.resolve(this.mutationQueue.slice());
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
        var _this = this;
        var start = new DocReference(documentKey, 0);
        var end = new DocReference(documentKey, Number.POSITIVE_INFINITY);
        var result = [];
        this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
            assert(documentKey.isEqual(ref.key), "Should only iterate over a single key's batches");
            var batch = _this.findMutationBatch(ref.targetOrBatchId);
            assert(batch !== null, 'Batches in the index must exist in the main table');
            result.push(batch);
        });
        return PersistencePromise.resolve(result);
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys = function (transaction, documentKeys) {
        var _this = this;
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        documentKeys.forEach(function (documentKey) {
            var start = new DocReference(documentKey, 0);
            var end = new DocReference(documentKey, Number.POSITIVE_INFINITY);
            _this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
                assert(documentKey.isEqual(ref.key), "For each key, should only iterate over a single key's batches");
                uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
            });
        });
        return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        var prefix = query.path;
        var immediateChildrenPathLength = prefix.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        var startPath = prefix;
        if (!DocumentKey.isDocumentKey(startPath)) {
            startPath = startPath.child('');
        }
        var start = new DocReference(new DocumentKey(startPath), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        this.batchesByDocumentKey.forEachWhile(function (ref) {
            var rowKeyPath = ref.key.path;
            if (!prefix.isPrefixOf(rowKeyPath)) {
                return false;
            }
            else {
                // Rows with document keys more than one segment longer than the query
                // path can't be matches. For example, a query on 'rooms' can't match
                // the document /rooms/abc/messages/xyx.
                // TODO(mcg): we'll need a different scanner when we implement
                // ancestor queries.
                if (rowKeyPath.length === immediateChildrenPathLength) {
                    uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
                }
                return true;
            }
        }, start);
        return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));
    };
    MemoryMutationQueue.prototype.findMutationBatches = function (batchIDs) {
        var _this = this;
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        var result = [];
        batchIDs.forEach(function (batchId) {
            var batch = _this.findMutationBatch(batchId);
            if (batch !== null) {
                result.push(batch);
            }
        });
        return result;
    };
    MemoryMutationQueue.prototype.removeMutationBatch = function (transaction, batch) {
        var _this = this;
        // Find the position of the first batch for removal. This need not be the
        // first entry in the queue.
        var batchIndex = this.indexOfExistingBatchId(batch.batchId, 'removed');
        assert(batchIndex === 0, 'Can only remove the first entry of the mutation queue');
        this.mutationQueue.shift();
        var references = this.batchesByDocumentKey;
        return PersistencePromise.forEach(batch.mutations, function (mutation) {
            var ref = new DocReference(mutation.key, batch.batchId);
            references = references.delete(ref);
            return _this.referenceDelegate.removeMutationReference(transaction, mutation.key);
        }).next(function () {
            _this.batchesByDocumentKey = references;
        });
    };
    MemoryMutationQueue.prototype.removeCachedMutationKeys = function (batchId) {
        // No-op since the memory mutation queue does not maintain a separate cache.
    };
    MemoryMutationQueue.prototype.containsKey = function (txn, key) {
        var ref = new DocReference(key, 0);
        var firstRef = this.batchesByDocumentKey.firstAfterOrEqual(ref);
        return PersistencePromise.resolve(key.isEqual(firstRef && firstRef.key));
    };
    MemoryMutationQueue.prototype.performConsistencyCheck = function (txn) {
        if (this.mutationQueue.length === 0) {
            assert(this.batchesByDocumentKey.isEmpty(), 'Document leak -- detected dangling mutation references when queue is empty.');
        }
        return PersistencePromise.resolve();
    };
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId The batchId to search for
     * @param action A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */
    MemoryMutationQueue.prototype.indexOfExistingBatchId = function (batchId, action) {
        var index = this.indexOfBatchId(batchId);
        assert(index >= 0 && index < this.mutationQueue.length, 'Batches must exist to be ' + action);
        return index;
    };
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @return The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */
    MemoryMutationQueue.prototype.indexOfBatchId = function (batchId) {
        if (this.mutationQueue.length === 0) {
            // As an index this is past the end of the queue
            return 0;
        }
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        var firstBatchId = this.mutationQueue[0].batchId;
        return batchId - firstBatchId;
    };
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */
    MemoryMutationQueue.prototype.findMutationBatch = function (batchId) {
        var index = this.indexOfBatchId(batchId);
        if (index < 0 || index >= this.mutationQueue.length) {
            return null;
        }
        var batch = this.mutationQueue[index];
        assert(batch.batchId === batchId, 'If found batch must match');
        return batch;
    };
    return MemoryMutationQueue;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MemoryQueryCache = /** @class */ (function () {
    function MemoryQueryCache(persistence) {
        this.persistence = persistence;
        /**
         * Maps a query to the data about that query
         */
        this.queries = new ObjectMap(function (q) { return q.canonicalId(); });
        /** The last received snapshot version. */
        this.lastRemoteSnapshotVersion = SnapshotVersion.MIN;
        /** The highest numbered target ID encountered. */
        this.highestTargetId = 0;
        /** The highest sequence number encountered. */
        this.highestSequenceNumber = 0;
        /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */
        this.references = new ReferenceSet();
        this.targetCount = 0;
        this.targetIdGenerator = TargetIdGenerator.forQueryCache();
    }
    MemoryQueryCache.prototype.getTargetCount = function (txn) {
        return PersistencePromise.resolve(this.targetCount);
    };
    MemoryQueryCache.prototype.forEachTarget = function (txn, f) {
        this.queries.forEach(function (_, queryData) { return f(queryData); });
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.getLastRemoteSnapshotVersion = function (transaction) {
        return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    };
    MemoryQueryCache.prototype.getHighestSequenceNumber = function (transaction) {
        return PersistencePromise.resolve(this.highestSequenceNumber);
    };
    MemoryQueryCache.prototype.allocateTargetId = function (transaction) {
        var nextTargetId = this.targetIdGenerator.after(this.highestTargetId);
        this.highestTargetId = nextTargetId;
        return PersistencePromise.resolve(nextTargetId);
    };
    MemoryQueryCache.prototype.setTargetsMetadata = function (transaction, highestListenSequenceNumber, lastRemoteSnapshotVersion) {
        if (lastRemoteSnapshotVersion) {
            this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
        }
        if (highestListenSequenceNumber > this.highestSequenceNumber) {
            this.highestSequenceNumber = highestListenSequenceNumber;
        }
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.saveQueryData = function (queryData) {
        this.queries.set(queryData.query, queryData);
        var targetId = queryData.targetId;
        if (targetId > this.highestTargetId) {
            this.highestTargetId = targetId;
        }
        if (queryData.sequenceNumber > this.highestSequenceNumber) {
            this.highestSequenceNumber = queryData.sequenceNumber;
        }
    };
    MemoryQueryCache.prototype.addQueryData = function (transaction, queryData) {
        assert(!this.queries.has(queryData.query), 'Adding a query that already exists');
        this.saveQueryData(queryData);
        this.targetCount += 1;
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.updateQueryData = function (transaction, queryData) {
        assert(this.queries.has(queryData.query), 'Updating a non-existent query');
        this.saveQueryData(queryData);
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.removeQueryData = function (transaction, queryData) {
        assert(this.targetCount > 0, 'Removing a target from an empty cache');
        assert(this.queries.has(queryData.query), 'Removing a non-existent target from the cache');
        this.queries.delete(queryData.query);
        this.references.removeReferencesForId(queryData.targetId);
        this.targetCount -= 1;
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.removeTargets = function (transaction, upperBound, activeTargetIds) {
        var _this = this;
        var count = 0;
        var removals = [];
        this.queries.forEach(function (key, queryData) {
            if (queryData.sequenceNumber <= upperBound &&
                !activeTargetIds[queryData.targetId]) {
                _this.queries.delete(key);
                removals.push(_this.removeMatchingKeysForTargetId(transaction, queryData.targetId));
                count++;
            }
        });
        return PersistencePromise.waitFor(removals).next(function () { return count; });
    };
    MemoryQueryCache.prototype.getQueryCount = function (transaction) {
        return PersistencePromise.resolve(this.targetCount);
    };
    MemoryQueryCache.prototype.getQueryData = function (transaction, query) {
        var queryData = this.queries.get(query) || null;
        return PersistencePromise.resolve(queryData);
    };
    MemoryQueryCache.prototype.getQueryDataForTarget = function (transaction, targetId) {
        // This method is only needed for multi-tab and we can't implement it
        // efficiently without additional data structures.
        return fail('Not yet implemented.');
    };
    MemoryQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
        this.references.addReferences(keys, targetId);
        var referenceDelegate = this.persistence.referenceDelegate;
        var promises = [];
        if (referenceDelegate) {
            keys.forEach(function (key) {
                promises.push(referenceDelegate.addReference(txn, key));
            });
        }
        return PersistencePromise.waitFor(promises);
    };
    MemoryQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
        this.references.removeReferences(keys, targetId);
        var referenceDelegate = this.persistence.referenceDelegate;
        var promises = [];
        if (referenceDelegate) {
            keys.forEach(function (key) {
                promises.push(referenceDelegate.removeReference(txn, key));
            });
        }
        return PersistencePromise.waitFor(promises);
    };
    MemoryQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
        this.references.removeReferencesForId(targetId);
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
        var matchingKeys = this.references.referencesForId(targetId);
        return PersistencePromise.resolve(matchingKeys);
    };
    MemoryQueryCache.prototype.containsKey = function (txn, key) {
        return PersistencePromise.resolve(this.references.containsKey(key));
    };
    return MemoryQueryCache;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function documentSizeMap() {
    return new SortedMap(DocumentKey.comparator);
}
var MemoryRemoteDocumentCache = /** @class */ (function () {
    /**
     * @param sizer Used to assess the size of a document. For eager GC, this is expected to just
     * return 0 to avoid unnecessarily doing the work of calculating the size.
     */
    function MemoryRemoteDocumentCache(sizer) {
        this.sizer = sizer;
        this.docs = documentSizeMap();
        this.newDocumentChanges = documentKeySet();
        this.size = 0;
    }
    /**
     * Adds the supplied entries to the cache. Adds the given size delta to the cached size.
     */
    MemoryRemoteDocumentCache.prototype.addEntries = function (transaction, entries, sizeDelta) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            var key = entry.maybeDocument.key;
            this.docs = this.docs.insert(key, entry);
            this.newDocumentChanges = this.newDocumentChanges.add(key);
        }
        this.size += sizeDelta;
        return PersistencePromise.resolve();
    };
    /**
     * Removes the specified entry from the cache and updates the size as appropriate.
     */
    MemoryRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
        var entry = this.docs.get(documentKey);
        if (entry) {
            this.docs = this.docs.remove(documentKey);
            this.size -= entry.size;
            return PersistencePromise.resolve(entry.size);
        }
        else {
            return PersistencePromise.resolve(0);
        }
    };
    MemoryRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
        var entry = this.docs.get(documentKey);
        return PersistencePromise.resolve(entry ? entry.maybeDocument : null);
    };
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey The key of the entry to look up.
     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
     */
    MemoryRemoteDocumentCache.prototype.getSizedEntry = function (transaction, documentKey) {
        return PersistencePromise.resolve(this.docs.get(documentKey));
    };
    MemoryRemoteDocumentCache.prototype.getEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        documentKeys.forEach(function (documentKey) {
            var entry = _this.docs.get(documentKey);
            results = results.insert(documentKey, entry ? entry.maybeDocument : null);
        });
        return PersistencePromise.resolve(results);
    };
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys The set of keys entries to look up.
     * @return A map of MaybeDocuments indexed by key (if a document cannot be
     *     found, the key will be mapped to null) and a map of sizes indexed by
     *     key (zero if the key cannot be found).
     */
    MemoryRemoteDocumentCache.prototype.getSizedEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        var sizeMap = new SortedMap(DocumentKey.comparator);
        documentKeys.forEach(function (documentKey) {
            var entry = _this.docs.get(documentKey);
            results = results.insert(documentKey, entry ? entry.maybeDocument : null);
            sizeMap = sizeMap.insert(documentKey, entry ? entry.size : 0);
        });
        return PersistencePromise.resolve({ maybeDocuments: results, sizeMap: sizeMap });
    };
    MemoryRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        var results = documentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        var prefix = new DocumentKey(query.path.child(''));
        var iterator = this.docs.getIteratorFrom(prefix);
        while (iterator.hasNext()) {
            var _a = iterator.getNext(), key = _a.key, maybeDocument = _a.value.maybeDocument;
            if (!query.path.isPrefixOf(key.path)) {
                break;
            }
            if (maybeDocument instanceof Document && query.matches(maybeDocument)) {
                results = results.insert(maybeDocument.key, maybeDocument);
            }
        }
        return PersistencePromise.resolve(results);
    };
    MemoryRemoteDocumentCache.prototype.forEachDocumentKey = function (transaction, f) {
        return PersistencePromise.forEach(this.docs, function (key) { return f(key); });
    };
    MemoryRemoteDocumentCache.prototype.getNewDocumentChanges = function (transaction) {
        var _this = this;
        var changedDocs = maybeDocumentMap();
        this.newDocumentChanges.forEach(function (key) {
            var entry = _this.docs.get(key);
            var changedDoc = entry
                ? entry.maybeDocument
                : new NoDocument(key, SnapshotVersion.forDeletedDoc());
            changedDocs = changedDocs.insert(key, changedDoc);
        });
        this.newDocumentChanges = documentKeySet();
        return PersistencePromise.resolve(changedDocs);
    };
    MemoryRemoteDocumentCache.prototype.newChangeBuffer = function () {
        return new MemoryRemoteDocumentChangeBuffer(this.sizer, this);
    };
    MemoryRemoteDocumentCache.prototype.getSize = function (txn) {
        return PersistencePromise.resolve(this.size);
    };
    return MemoryRemoteDocumentCache;
}());
/**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */
var MemoryRemoteDocumentChangeBuffer = /** @class */ (function (_super) {
    tslib_1.__extends(MemoryRemoteDocumentChangeBuffer, _super);
    function MemoryRemoteDocumentChangeBuffer(sizer, documentCache) {
        var _this = _super.call(this) || this;
        _this.sizer = sizer;
        _this.documentCache = documentCache;
        return _this;
    }
    MemoryRemoteDocumentChangeBuffer.prototype.applyChanges = function (transaction) {
        var _this = this;
        var changes = this.assertChanges();
        var delta = 0;
        var docs = [];
        changes.forEach(function (key, maybeDocument) {
            var previousSize = _this.documentSizes.get(key);
            assert(previousSize !== undefined, "Attempting to change document " + key.toString() + " without having read it first");
            var size = _this.sizer(maybeDocument);
            delta += size - previousSize;
            docs.push({ maybeDocument: maybeDocument, size: size });
        });
        return this.documentCache.addEntries(transaction, docs, delta);
    };
    MemoryRemoteDocumentChangeBuffer.prototype.getFromCache = function (transaction, documentKey) {
        return this.documentCache.getSizedEntry(transaction, documentKey);
    };
    MemoryRemoteDocumentChangeBuffer.prototype.getAllFromCache = function (transaction, documentKeys) {
        return this.documentCache.getSizedEntries(transaction, documentKeys);
    };
    return MemoryRemoteDocumentChangeBuffer;
}(RemoteDocumentChangeBuffer));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$4 = 'MemoryPersistence';
/**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */
var MemoryPersistence = /** @class */ (function () {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */
    function MemoryPersistence(clientId, referenceDelegateFactory) {
        var _this = this;
        this.clientId = clientId;
        /**
         * Note that these are retained here to make it easier to write tests
         * affecting both the in-memory and IndexedDB-backed persistence layers. Tests
         * can create a new LocalStore wrapping this Persistence instance and this
         * will make the in-memory persistence layer behave as if it were actually
         * persisting values.
         */
        this.mutationQueues = {};
        this.listenSequence = new ListenSequence(0);
        this._started = false;
        this._started = true;
        this.referenceDelegate = referenceDelegateFactory(this);
        this.queryCache = new MemoryQueryCache(this);
        var sizer = function (doc) {
            return _this.referenceDelegate.documentSize(doc);
        };
        this.remoteDocumentCache = new MemoryRemoteDocumentCache(sizer);
    }
    MemoryPersistence.createLruPersistence = function (clientId, serializer, params) {
        var factory = function (p) {
            return new MemoryLruDelegate(p, new LocalSerializer(serializer), params);
        };
        return new MemoryPersistence(clientId, factory);
    };
    MemoryPersistence.createEagerPersistence = function (clientId) {
        var factory = function (p) {
            return new MemoryEagerDelegate(p);
        };
        return new MemoryPersistence(clientId, factory);
    };
    MemoryPersistence.prototype.shutdown = function (deleteData) {
        // No durable state to ensure is closed on shutdown.
        this._started = false;
        return Promise.resolve();
    };
    Object.defineProperty(MemoryPersistence.prototype, "started", {
        get: function () {
            return this._started;
        },
        enumerable: true,
        configurable: true
    });
    MemoryPersistence.prototype.getActiveClients = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, [this.clientId]];
            });
        });
    };
    MemoryPersistence.prototype.setPrimaryStateListener = function (primaryStateListener) {
        // All clients using memory persistence act as primary.
        return primaryStateListener(true);
    };
    MemoryPersistence.prototype.setNetworkEnabled = function (networkEnabled) {
        // No op.
    };
    MemoryPersistence.prototype.getMutationQueue = function (user) {
        var queue = this.mutationQueues[user.toKey()];
        if (!queue) {
            queue = new MemoryMutationQueue(this.referenceDelegate);
            this.mutationQueues[user.toKey()] = queue;
        }
        return queue;
    };
    MemoryPersistence.prototype.getQueryCache = function () {
        return this.queryCache;
    };
    MemoryPersistence.prototype.getRemoteDocumentCache = function () {
        return this.remoteDocumentCache;
    };
    MemoryPersistence.prototype.runTransaction = function (action, mode, transactionOperation) {
        var _this = this;
        debug(LOG_TAG$4, 'Starting transaction:', action);
        var txn = new MemoryTransaction(this.listenSequence.next());
        this.referenceDelegate.onTransactionStarted();
        return transactionOperation(txn)
            .next(function (result) {
            return _this.referenceDelegate
                .onTransactionCommitted(txn)
                .next(function () { return result; });
        })
            .toPromise();
    };
    MemoryPersistence.prototype.mutationQueuesContainKey = function (transaction, key) {
        return PersistencePromise.or(values(this.mutationQueues)
            .map(function (queue) { return function () { return queue.containsKey(transaction, key); }; }));
    };
    return MemoryPersistence;
}());
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */
var MemoryTransaction = /** @class */ (function () {
    function MemoryTransaction(currentSequenceNumber) {
        this.currentSequenceNumber = currentSequenceNumber;
    }
    return MemoryTransaction;
}());
var MemoryEagerDelegate = /** @class */ (function () {
    function MemoryEagerDelegate(persistence) {
        this.persistence = persistence;
    }
    MemoryEagerDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    MemoryEagerDelegate.prototype.addReference = function (txn, key) {
        this.orphanedDocuments.delete(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeReference = function (txn, key) {
        this.orphanedDocuments.add(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeMutationReference = function (txn, key) {
        this.orphanedDocuments.add(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeTarget = function (txn, queryData) {
        var _this = this;
        var cache = this.persistence.getQueryCache();
        return cache
            .getMatchingKeysForTargetId(txn, queryData.targetId)
            .next(function (keys) {
            keys.forEach(function (key) { return _this.orphanedDocuments.add(key); });
        })
            .next(function () { return cache.removeQueryData(txn, queryData); });
    };
    MemoryEagerDelegate.prototype.onTransactionStarted = function () {
        this.orphanedDocuments = new Set();
    };
    MemoryEagerDelegate.prototype.onTransactionCommitted = function (txn) {
        var _this = this;
        var cache = this.persistence.getRemoteDocumentCache();
        return PersistencePromise.forEach(this.orphanedDocuments, function (key) {
            return _this.isReferenced(txn, key).next(function (isReferenced) {
                if (!isReferenced) {
                    // Since this is the eager delegate and memory persistence,
                    // we don't care about the size of documents. We don't track
                    // the size of the cache for eager GC.
                    return cache.removeEntry(txn, key).next(function () { });
                }
                return PersistencePromise.resolve();
            });
        });
    };
    MemoryEagerDelegate.prototype.updateLimboDocument = function (txn, key) {
        var _this = this;
        return this.isReferenced(txn, key).next(function (isReferenced) {
            if (isReferenced) {
                _this.orphanedDocuments.delete(key);
            }
            else {
                _this.orphanedDocuments.add(key);
            }
        });
    };
    MemoryEagerDelegate.prototype.documentSize = function (doc) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    };
    MemoryEagerDelegate.prototype.isReferenced = function (txn, key) {
        var _this = this;
        return PersistencePromise.or([
            function () { return _this.persistence.getQueryCache().containsKey(txn, key); },
            function () { return _this.persistence.mutationQueuesContainKey(txn, key); },
            function () { return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key)); }
        ]);
    };
    return MemoryEagerDelegate;
}());
var MemoryLruDelegate = /** @class */ (function () {
    function MemoryLruDelegate(persistence, serializer, lruParams) {
        this.persistence = persistence;
        this.serializer = serializer;
        this.orphanedSequenceNumbers = new ObjectMap(function (k) { return encode(k.path); });
        this.garbageCollector = new LruGarbageCollector(this, lruParams);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    MemoryLruDelegate.prototype.onTransactionStarted = function () { };
    MemoryLruDelegate.prototype.onTransactionCommitted = function (txn) {
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.forEachTarget = function (txn, f) {
        return this.persistence.getQueryCache().forEachTarget(txn, f);
    };
    MemoryLruDelegate.prototype.getSequenceNumberCount = function (txn) {
        var docCountPromise = this.orphanedDocumentCount(txn);
        var targetCountPromise = this.persistence
            .getQueryCache()
            .getTargetCount(txn);
        return targetCountPromise.next(function (targetCount) {
            return docCountPromise.next(function (docCount) { return targetCount + docCount; });
        });
    };
    MemoryLruDelegate.prototype.orphanedDocumentCount = function (txn) {
        var orphanedCount = 0;
        return this.forEachOrphanedDocumentSequenceNumber(txn, function (_) {
            orphanedCount++;
        }).next(function () { return orphanedCount; });
    };
    MemoryLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber = function (txn, f) {
        var _this = this;
        return PersistencePromise.forEach(this.orphanedSequenceNumbers, function (key, sequenceNumber) {
            // Pass in the exact sequence number as the upper bound so we know it won't be pinned by
            // being too recent.
            return _this.isPinned(txn, key, sequenceNumber).next(function (isPinned) {
                if (!isPinned) {
                    return f(sequenceNumber);
                }
                else {
                    return PersistencePromise.resolve();
                }
            });
        });
    };
    MemoryLruDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    MemoryLruDelegate.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.persistence
            .getQueryCache()
            .removeTargets(txn, upperBound, activeTargetIds);
    };
    MemoryLruDelegate.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        var _this = this;
        var count = 0;
        var cache = this.persistence.getRemoteDocumentCache();
        var p = cache.forEachDocumentKey(txn, function (key) {
            return _this.isPinned(txn, key, upperBound).next(function (isPinned) {
                if (isPinned) {
                    return PersistencePromise.resolve();
                }
                else {
                    count++;
                    // The memory remote document cache does its own byte
                    // accounting on removal. This is ok because updating the size
                    // for memory persistence does not incur IO.
                    return cache.removeEntry(txn, key).next();
                }
            });
        });
        return p.next(function () { return count; });
    };
    MemoryLruDelegate.prototype.removeMutationReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.removeTarget = function (txn, queryData) {
        var updated = queryData.copy({
            sequenceNumber: txn.currentSequenceNumber
        });
        return this.persistence.getQueryCache().updateQueryData(txn, updated);
    };
    MemoryLruDelegate.prototype.addReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.removeReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.updateLimboDocument = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.documentSize = function (maybeDoc) {
        var remoteDocument = this.serializer.toDbRemoteDocument(maybeDoc);
        var value;
        if (remoteDocument.document) {
            value = remoteDocument.document;
        }
        else if (remoteDocument.unknownDocument) {
            value = remoteDocument.unknownDocument;
        }
        else if (remoteDocument.noDocument) {
            value = remoteDocument.noDocument;
        }
        else {
            throw fail('Unknown remote document type');
        }
        return JSON.stringify(value).length;
    };
    MemoryLruDelegate.prototype.isPinned = function (txn, key, upperBound) {
        var _this = this;
        return PersistencePromise.or([
            function () { return _this.persistence.mutationQueuesContainKey(txn, key); },
            function () { return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key)); },
            function () { return _this.persistence.getQueryCache().containsKey(txn, key); },
            function () {
                var orphanedAt = _this.orphanedSequenceNumbers.get(key);
                return PersistencePromise.resolve(orphanedAt !== undefined && orphanedAt > upperBound);
            }
        ]);
    };
    MemoryLruDelegate.prototype.getCacheSize = function (txn) {
        return this.persistence.getRemoteDocumentCache().getSize(txn);
    };
    return MemoryLruDelegate;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$5 = 'ExponentialBackoff';
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */
var ExponentialBackoff = /** @class */ (function () {
    function ExponentialBackoff(
    /**
     * The AsyncQueue to run backoff operations on.
     */
    queue, 
    /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */
    timerId, 
    /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */
    initialDelayMs, 
    /**
     * The multiplier to use to determine the extended base delay after each
     * attempt.
     */
    backoffFactor, 
    /**
     * The maximum base delay after which no further backoff is performed.
     * Note that jitter will still be applied, so the actual delay could be as
     * much as 1.5*maxDelayMs.
     */
    maxDelayMs) {
        this.queue = queue;
        this.timerId = timerId;
        this.initialDelayMs = initialDelayMs;
        this.backoffFactor = backoffFactor;
        this.maxDelayMs = maxDelayMs;
        this.timerPromise = null;
        /** The last backoff attempt, as epoch milliseconds. */
        this.lastAttemptTime = Date.now();
        this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */
    ExponentialBackoff.prototype.reset = function () {
        this.currentBaseMs = 0;
    };
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */
    ExponentialBackoff.prototype.resetToMax = function () {
        this.currentBaseMs = this.maxDelayMs;
    };
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */
    ExponentialBackoff.prototype.backoffAndRun = function (op) {
        var _this = this;
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        var desiredDelayWithJitterMs = Math.floor(this.currentBaseMs + this.jitterDelayMs());
        // Guard against lastAttemptTime being in the future due to a clock change.
        var delaySoFarMs = Math.max(0, Date.now() - this.lastAttemptTime);
        // Guard against the backoff delay already being past.
        var remainingDelayMs = Math.max(0, desiredDelayWithJitterMs - delaySoFarMs);
        if (this.currentBaseMs > 0) {
            debug(LOG_TAG$5, "Backing off for " + remainingDelayMs + " ms " +
                ("(base delay: " + this.currentBaseMs + " ms, ") +
                ("delay with jitter: " + desiredDelayWithJitterMs + " ms, ") +
                ("last attempt: " + delaySoFarMs + " ms ago)"));
        }
        this.timerPromise = this.queue.enqueueAfterDelay(this.timerId, remainingDelayMs, function () {
            _this.lastAttemptTime = Date.now();
            return op();
        });
        // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.currentBaseMs *= this.backoffFactor;
        if (this.currentBaseMs < this.initialDelayMs) {
            this.currentBaseMs = this.initialDelayMs;
        }
        if (this.currentBaseMs > this.maxDelayMs) {
            this.currentBaseMs = this.maxDelayMs;
        }
    };
    ExponentialBackoff.prototype.cancel = function () {
        if (this.timerPromise !== null) {
            this.timerPromise.cancel();
            this.timerPromise = null;
        }
    };
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
    ExponentialBackoff.prototype.jitterDelayMs = function () {
        return (Math.random() - 0.5) * this.currentBaseMs;
    };
    return ExponentialBackoff;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$6 = 'PersistentStream';
/**
 * PersistentStream can be in one of 5 states (each described in detail below)
 * based on the following state transition diagram:
 *
 *          start() called             auth & connection succeeded
 * INITIAL ----------------> STARTING -----------------------------> OPEN
 *                             ^  |                                   |
 *                             |  |                    error occurred |
 *                             |  \-----------------------------v-----/
 *                             |                                |
 *                    backoff  |                                |
 *                    elapsed  |              start() called    |
 *                             \--- BACKOFF <---------------- ERROR
 *
 * [any state] --------------------------> INITIAL
 *               stop() called or
 *               idle timer expired
 */
var PersistentStreamState;
(function (PersistentStreamState) {
    /**
     * The streaming RPC is not yet running and there's no error condition.
     * Calling start() will start the stream immediately without backoff.
     * While in this state isStarted() will return false.
     */
    PersistentStreamState[PersistentStreamState["Initial"] = 0] = "Initial";
    /**
     * The stream is starting, either waiting for an auth token or for the stream
     * to successfully open. While in this state, isStarted() will return true but
     * isOpen() will return false.
     */
    PersistentStreamState[PersistentStreamState["Starting"] = 1] = "Starting";
    /**
     * The streaming RPC is up and running. Requests and responses can flow
     * freely. Both isStarted() and isOpen() will return true.
     */
    PersistentStreamState[PersistentStreamState["Open"] = 2] = "Open";
    /**
     * The stream encountered an error. The next start attempt will back off.
     * While in this state isStarted() will return false.
     */
    PersistentStreamState[PersistentStreamState["Error"] = 3] = "Error";
    /**
     * An in-between state after an error where the stream is waiting before
     * re-starting. After waiting is complete, the stream will try to open.
     * While in this state isStarted() will return true but isOpen() will return
     * false.
     */
    PersistentStreamState[PersistentStreamState["Backoff"] = 4] = "Backoff";
})(PersistentStreamState || (PersistentStreamState = {}));
/**
 * Initial backoff time in milliseconds after an error.
 * Set to 1s according to https://cloud.google.com/apis/design/errors.
 */
var BACKOFF_INITIAL_DELAY_MS = 1000;
/** Maximum backoff time in milliseconds */
var BACKOFF_MAX_DELAY_MS = 60 * 1000;
var BACKOFF_FACTOR = 1.5;
/** The time a stream stays open after it is marked idle. */
var IDLE_TIMEOUT_MS = 60 * 1000;
/**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */
var PersistentStream = /** @class */ (function () {
    function PersistentStream(queue, connectionTimerId, idleTimerId, connection, credentialsProvider, listener) {
        this.queue = queue;
        this.idleTimerId = idleTimerId;
        this.connection = connection;
        this.credentialsProvider = credentialsProvider;
        this.listener = listener;
        this.state = PersistentStreamState.Initial;
        /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */
        this.closeCount = 0;
        this.idleTimer = null;
        this.stream = null;
        this.backoff = new ExponentialBackoff(queue, connectionTimerId, BACKOFF_INITIAL_DELAY_MS, BACKOFF_FACTOR, BACKOFF_MAX_DELAY_MS);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */
    PersistentStream.prototype.isStarted = function () {
        return (this.state === PersistentStreamState.Starting ||
            this.state === PersistentStreamState.Open ||
            this.state === PersistentStreamState.Backoff);
    };
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */
    PersistentStream.prototype.isOpen = function () {
        return this.state === PersistentStreamState.Open;
    };
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */
    PersistentStream.prototype.start = function () {
        if (this.state === PersistentStreamState.Error) {
            this.performBackoff();
            return;
        }
        assert(this.state === PersistentStreamState.Initial, 'Already started');
        this.auth();
    };
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */
    PersistentStream.prototype.stop = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isStarted()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.close(PersistentStreamState.Initial)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */
    PersistentStream.prototype.inhibitBackoff = function () {
        assert(!this.isStarted(), 'Can only inhibit backoff in a stopped state');
        this.state = PersistentStreamState.Initial;
        this.backoff.reset();
    };
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */
    PersistentStream.prototype.markIdle = function () {
        var _this = this;
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        if (this.isOpen() && this.idleTimer === null) {
            this.idleTimer = this.queue.enqueueAfterDelay(this.idleTimerId, IDLE_TIMEOUT_MS, function () { return _this.handleIdleCloseTimer(); });
        }
    };
    /** Sends a message to the underlying stream. */
    PersistentStream.prototype.sendRequest = function (msg) {
        this.cancelIdleCheck();
        this.stream.send(msg);
    };
    /** Called by the idle timer when the stream should close due to inactivity. */
    PersistentStream.prototype.handleIdleCloseTimer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.isOpen()) {
                    // When timing out an idle stream there's no reason to force the stream into backoff when
                    // it restarts so set the stream state to Initial instead of Error.
                    return [2 /*return*/, this.close(PersistentStreamState.Initial)];
                }
                return [2 /*return*/];
            });
        });
    };
    /** Marks the stream as active again. */
    PersistentStream.prototype.cancelIdleCheck = function () {
        if (this.idleTimer) {
            this.idleTimer.cancel();
            this.idleTimer = null;
        }
    };
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState the intended state of the stream after closing.
     * @param error the error the connection was closed with.
     */
    PersistentStream.prototype.close = function (finalState, error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assert(this.isStarted(), 'Only started streams should be closed.');
                        assert(finalState === PersistentStreamState.Error || isNullOrUndefined(error$$1), "Can't provide an error when not in an error state.");
                        // Cancel any outstanding timers (they're guaranteed not to execute).
                        this.cancelIdleCheck();
                        this.backoff.cancel();
                        // Invalidates any stream-related callbacks (e.g. from auth or the
                        // underlying stream), guaranteeing they won't execute.
                        this.closeCount++;
                        if (finalState !== PersistentStreamState.Error) {
                            // If this is an intentional close ensure we don't delay our next connection attempt.
                            this.backoff.reset();
                        }
                        else if (error$$1 && error$$1.code === Code.RESOURCE_EXHAUSTED) {
                            // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
                            error(error$$1.toString());
                            error('Using maximum backoff delay to prevent overloading the backend.');
                            this.backoff.resetToMax();
                        }
                        else if (error$$1 && error$$1.code === Code.UNAUTHENTICATED) {
                            // "unauthenticated" error means the token was rejected. Try force refreshing it in case it
                            // just expired.
                            this.credentialsProvider.invalidateToken();
                        }
                        // Clean up the underlying stream because we are no longer interested in events.
                        if (this.stream !== null) {
                            this.tearDown();
                            this.stream.close();
                            this.stream = null;
                        }
                        // This state must be assigned before calling onClose() to allow the callback to
                        // inhibit backoff or otherwise manipulate the state in its non-started state.
                        this.state = finalState;
                        // Notify the listener that the stream closed.
                        return [4 /*yield*/, this.listener.onClose(error$$1)];
                    case 1:
                        // Notify the listener that the stream closed.
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */
    PersistentStream.prototype.tearDown = function () { };
    PersistentStream.prototype.auth = function () {
        var _this = this;
        assert(this.state === PersistentStreamState.Initial, 'Must be in initial state to auth');
        this.state = PersistentStreamState.Starting;
        var dispatchIfNotClosed = this.getCloseGuardedDispatcher(this.closeCount);
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        var closeCount = this.closeCount;
        this.credentialsProvider.getToken().then(function (token) {
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            if (_this.closeCount === closeCount) {
                // Normally we'd have to schedule the callback on the AsyncQueue.
                // However, the following calls are safe to be called outside the
                // AsyncQueue since they don't chain asynchronous calls
                _this.startStream(token);
            }
        }, function (error$$1) {
            dispatchIfNotClosed(function () {
                var rpcError = new FirestoreError(Code.UNKNOWN, 'Fetching auth token failed: ' + error$$1.message);
                return _this.handleStreamClose(rpcError);
            });
        });
    };
    PersistentStream.prototype.startStream = function (token) {
        var _this = this;
        assert(this.state === PersistentStreamState.Starting, 'Trying to start stream in a non-starting state');
        var dispatchIfNotClosed = this.getCloseGuardedDispatcher(this.closeCount);
        this.stream = this.startRpc(token);
        this.stream.onOpen(function () {
            dispatchIfNotClosed(function () {
                assert(_this.state === PersistentStreamState.Starting, 'Expected stream to be in state Starting, but was ' + _this.state);
                _this.state = PersistentStreamState.Open;
                return _this.listener.onOpen();
            });
        });
        this.stream.onClose(function (error$$1) {
            dispatchIfNotClosed(function () {
                return _this.handleStreamClose(error$$1);
            });
        });
        this.stream.onMessage(function (msg) {
            dispatchIfNotClosed(function () {
                return _this.onMessage(msg);
            });
        });
    };
    PersistentStream.prototype.performBackoff = function () {
        var _this = this;
        assert(this.state === PersistentStreamState.Error, 'Should only perform backoff when in Error state');
        this.state = PersistentStreamState.Backoff;
        this.backoff.backoffAndRun(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                assert(this.state === PersistentStreamState.Backoff, 'Backoff elapsed but state is now: ' + this.state);
                this.state = PersistentStreamState.Initial;
                this.start();
                assert(this.isStarted(), 'PersistentStream should have started');
                return [2 /*return*/];
            });
        }); });
    };
    // Visible for tests
    PersistentStream.prototype.handleStreamClose = function (error$$1) {
        assert(this.isStarted(), "Can't handle server close on non-started stream");
        debug(LOG_TAG$6, "close with error: " + error$$1);
        this.stream = null;
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return this.close(PersistentStreamState.Error, error$$1);
    };
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */
    PersistentStream.prototype.getCloseGuardedDispatcher = function (startCloseCount) {
        var _this = this;
        return function (fn) {
            _this.queue.enqueueAndForget(function () {
                if (_this.closeCount === startCloseCount) {
                    return fn();
                }
                else {
                    debug(LOG_TAG$6, 'stream callback skipped by getCloseGuardedDispatcher.');
                    return Promise.resolve();
                }
            });
        };
    };
    return PersistentStream;
}());
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */
var PersistentListenStream = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentListenStream, _super);
    function PersistentListenStream(queue, connection, credentials, serializer, listener) {
        var _this = _super.call(this, queue, TimerId.ListenStreamConnectionBackoff, TimerId.ListenStreamIdle, connection, credentials, listener) || this;
        _this.serializer = serializer;
        return _this;
    }
    PersistentListenStream.prototype.startRpc = function (token) {
        return this.connection.openStream('Listen', token);
    };
    PersistentListenStream.prototype.onMessage = function (watchChangeProto) {
        // A successful response means the stream is healthy
        this.backoff.reset();
        var watchChange = this.serializer.fromWatchChange(watchChangeProto);
        var snapshot = this.serializer.versionFromListenResponse(watchChangeProto);
        return this.listener.onWatchChange(watchChange, snapshot);
    };
    /**
     * Registers interest in the results of the given query. If the query
     * includes a resumeToken it will be included in the request. Results that
     * affect the query will be streamed back as WatchChange messages that
     * reference the targetId.
     */
    PersistentListenStream.prototype.watch = function (queryData) {
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        request.addTarget = this.serializer.toTarget(queryData);
        var labels = this.serializer.toListenRequestLabels(queryData);
        if (labels) {
            request.labels = labels;
        }
        this.sendRequest(request);
    };
    /**
     * Unregisters interest in the results of the query associated with the
     * given targetId.
     */
    PersistentListenStream.prototype.unwatch = function (targetId) {
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        request.removeTarget = targetId;
        this.sendRequest(request);
    };
    return PersistentListenStream;
}(PersistentStream));
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */
var PersistentWriteStream = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentWriteStream, _super);
    function PersistentWriteStream(queue, connection, credentials, serializer, listener) {
        var _this = _super.call(this, queue, TimerId.WriteStreamConnectionBackoff, TimerId.WriteStreamIdle, connection, credentials, listener) || this;
        _this.serializer = serializer;
        _this.handshakeComplete_ = false;
        return _this;
    }
    Object.defineProperty(PersistentWriteStream.prototype, "handshakeComplete", {
        /**
         * Tracks whether or not a handshake has been successfully exchanged and
         * the stream is ready to accept mutations.
         */
        get: function () {
            return this.handshakeComplete_;
        },
        enumerable: true,
        configurable: true
    });
    // Override of PersistentStream.start
    PersistentWriteStream.prototype.start = function () {
        this.handshakeComplete_ = false;
        _super.prototype.start.call(this);
    };
    PersistentWriteStream.prototype.tearDown = function () {
        if (this.handshakeComplete_) {
            this.writeMutations([]);
        }
    };
    PersistentWriteStream.prototype.startRpc = function (token) {
        return this.connection.openStream('Write', token);
    };
    PersistentWriteStream.prototype.onMessage = function (responseProto) {
        // Always capture the last stream token.
        assert(!!responseProto.streamToken, 'Got a write response without a stream token');
        this.lastStreamToken = responseProto.streamToken;
        if (!this.handshakeComplete_) {
            // The first response is always the handshake response
            assert(!responseProto.writeResults || responseProto.writeResults.length === 0, 'Got mutation results for handshake');
            this.handshakeComplete_ = true;
            return this.listener.onHandshakeComplete();
        }
        else {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.backoff.reset();
            var results = this.serializer.fromWriteResults(responseProto.writeResults, responseProto.commitTime);
            var commitVersion = this.serializer.fromVersion(responseProto.commitTime);
            return this.listener.onMutationResult(commitVersion, results);
        }
    };
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */
    PersistentWriteStream.prototype.writeHandshake = function () {
        assert(this.isOpen(), 'Writing handshake requires an opened stream');
        assert(!this.handshakeComplete_, 'Handshake already completed');
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        this.sendRequest(request);
    };
    /** Sends a group of mutations to the Firestore backend to apply. */
    PersistentWriteStream.prototype.writeMutations = function (mutations) {
        var _this = this;
        assert(this.isOpen(), 'Writing mutations requires an opened stream');
        assert(this.handshakeComplete_, 'Handshake must be complete before writing mutations');
        assert(this.lastStreamToken.length > 0, 'Trying to write mutation without a token');
        var request = {
            // Protos are typed with string, but we support UInt8Array on Node
            // tslint:disable-next-line:no-any
            streamToken: this.lastStreamToken,
            writes: mutations.map(function (mutation) { return _this.serializer.toMutation(mutation); })
        };
        this.sendRequest(request);
    };
    return PersistentWriteStream;
}(PersistentStream));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Datastore is a wrapper around the external Google Cloud Datastore grpc API,
 * which provides an interface that is more convenient for the rest of the
 * client SDK architecture to consume.
 */
var Datastore = /** @class */ (function () {
    function Datastore(queue, connection, credentials, serializer) {
        this.queue = queue;
        this.connection = connection;
        this.credentials = credentials;
        this.serializer = serializer;
    }
    Datastore.prototype.newPersistentWriteStream = function (listener) {
        return new PersistentWriteStream(this.queue, this.connection, this.credentials, this.serializer, listener);
    };
    Datastore.prototype.newPersistentWatchStream = function (listener) {
        return new PersistentListenStream(this.queue, this.connection, this.credentials, this.serializer, listener);
    };
    Datastore.prototype.commit = function (mutations) {
        var _this = this;
        var params = {
            database: this.serializer.encodedDatabaseId,
            writes: mutations.map(function (m) { return _this.serializer.toMutation(m); })
        };
        return this.invokeRPC('Commit', params).then(function (response) {
            return _this.serializer.fromWriteResults(response.writeResults, response.commitTime);
        });
    };
    Datastore.prototype.lookup = function (keys) {
        var _this = this;
        var params = {
            database: this.serializer.encodedDatabaseId,
            documents: keys.map(function (k) { return _this.serializer.toName(k); })
        };
        return this.invokeStreamingRPC('BatchGetDocuments', params).then(function (response) {
            var docs = maybeDocumentMap();
            response.forEach(function (proto) {
                var doc = _this.serializer.fromMaybeDocument(proto);
                docs = docs.insert(doc.key, doc);
            });
            var result = [];
            keys.forEach(function (key) {
                var doc = docs.get(key);
                assert(!!doc, 'Missing entity in write response for ' + key);
                result.push(doc);
            });
            return result;
        });
    };
    /** Gets an auth token and invokes the provided RPC. */
    Datastore.prototype.invokeRPC = function (rpcName, request) {
        var _this = this;
        return this.credentials
            .getToken()
            .then(function (token) {
            return _this.connection.invokeRPC(rpcName, request, token);
        })
            .catch(function (error) {
            if (error.code === Code.UNAUTHENTICATED) {
                _this.credentials.invalidateToken();
            }
            throw error;
        });
    };
    /** Gets an auth token and invokes the provided RPC with streamed results. */
    Datastore.prototype.invokeStreamingRPC = function (rpcName, request) {
        var _this = this;
        return this.credentials
            .getToken()
            .then(function (token) {
            return _this.connection.invokeStreamingRPC(rpcName, request, token);
        })
            .catch(function (error) {
            if (error.code === Code.UNAUTHENTICATED) {
                _this.credentials.invalidateToken();
            }
            throw error;
        });
    };
    return Datastore;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */
var Transaction = /** @class */ (function () {
    function Transaction(datastore) {
        this.datastore = datastore;
        // The version of each document that was read during this transaction.
        this.readVersions = documentVersionMap();
        this.mutations = [];
        this.committed = false;
    }
    Transaction.prototype.recordVersion = function (doc) {
        var docVersion;
        if (doc instanceof Document) {
            docVersion = doc.version;
        }
        else if (doc instanceof NoDocument) {
            // For deleted docs, we must use baseVersion 0 when we overwrite them.
            docVersion = SnapshotVersion.forDeletedDoc();
        }
        else {
            throw fail('Document in a transaction was a ' + doc.constructor.name);
        }
        var existingVersion = this.readVersions.get(doc.key);
        if (existingVersion !== null) {
            if (!docVersion.isEqual(existingVersion)) {
                // This transaction will fail no matter what.
                throw new FirestoreError(Code.ABORTED, 'Document version changed between two reads.');
            }
        }
        else {
            this.readVersions = this.readVersions.insert(doc.key, docVersion);
        }
    };
    Transaction.prototype.lookup = function (keys) {
        var _this = this;
        if (this.committed) {
            return Promise.reject('Transaction has already completed.');
        }
        if (this.mutations.length > 0) {
            return Promise.reject('Transactions lookups are invalid after writes.');
        }
        return this.datastore.lookup(keys).then(function (docs) {
            docs.forEach(function (doc) {
                if (doc instanceof NoDocument || doc instanceof Document) {
                    _this.recordVersion(doc);
                }
                else {
                    fail('Document in a transaction was a ' + doc.constructor.name);
                }
            });
            return docs;
        });
    };
    Transaction.prototype.write = function (mutations) {
        if (this.committed) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Transaction has already completed.');
        }
        this.mutations = this.mutations.concat(mutations);
    };
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */
    Transaction.prototype.precondition = function (key) {
        var version = this.readVersions.get(key);
        if (version) {
            return Precondition.updateTime(version);
        }
        else {
            return Precondition.NONE;
        }
    };
    /**
     * Returns the precondition for a document if the operation is an update.
     */
    Transaction.prototype.preconditionForUpdate = function (key) {
        var version = this.readVersions.get(key);
        if (version && version.isEqual(SnapshotVersion.forDeletedDoc())) {
            // The document doesn't exist, so fail the transaction.
            throw new FirestoreError(Code.FAILED_PRECONDITION, "Can't update a document that doesn't exist.");
        }
        else if (version) {
            // Document exists, base precondition on document update time.
            return Precondition.updateTime(version);
        }
        else {
            // Document was not read, so we just use the preconditions for a blind
            // update.
            return Precondition.exists(true);
        }
    };
    Transaction.prototype.set = function (key, data) {
        this.write(data.toMutations(key, this.precondition(key)));
    };
    Transaction.prototype.update = function (key, data) {
        this.write(data.toMutations(key, this.preconditionForUpdate(key)));
    };
    Transaction.prototype.delete = function (key) {
        this.write([new DeleteMutation(key, this.precondition(key))]);
        // Since the delete will be applied before all following writes, we need to
        // ensure that the precondition for the next write will be exists: false.
        this.readVersions = this.readVersions.insert(key, SnapshotVersion.forDeletedDoc());
    };
    Transaction.prototype.commit = function () {
        var _this = this;
        var unwritten = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach(function (mutation) {
            unwritten = unwritten.remove(mutation.key);
        });
        if (!unwritten.isEmpty()) {
            return Promise.reject(Error('Every document read in a transaction must also be written.'));
        }
        return this.datastore.commit(this.mutations).then(function () {
            _this.committed = true;
        });
    };
    return Transaction;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Describes the online state of the Firestore client. Note that this does not
 * indicate whether or not the remote store is trying to connect or not. This is
 * primarily used by the View / EventManager code to change their behavior while
 * offline (e.g. get() calls shouldn't wait for data from the server and
 * snapshot events should set metadata.isFromCache=true).
 */
var OnlineState;
(function (OnlineState) {
    /**
     * The Firestore client is in an unknown online state. This means the client
     * is either not actively trying to establish a connection or it is currently
     * trying to establish a connection, but it has not succeeded or failed yet.
     * Higher-level components should not operate in offline mode.
     */
    OnlineState[OnlineState["Unknown"] = 0] = "Unknown";
    /**
     * The client is connected and the connections are healthy. This state is
     * reached after a successful connection and there has been at least one
     * successful message received from the backends.
     */
    OnlineState[OnlineState["Online"] = 1] = "Online";
    /**
     * The client is either trying to establish a connection but failing, or it
     * has been explicitly marked offline via a call to disableNetwork().
     * Higher-level components should operate in offline mode.
     */
    OnlineState[OnlineState["Offline"] = 2] = "Offline";
})(OnlineState || (OnlineState = {}));
/** The source of an online state event. */
var OnlineStateSource;
(function (OnlineStateSource) {
    OnlineStateSource[OnlineStateSource["RemoteStore"] = 0] = "RemoteStore";
    OnlineStateSource[OnlineStateSource["SharedClientState"] = 1] = "SharedClientState";
})(OnlineStateSource || (OnlineStateSource = {}));

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$7 = 'OnlineStateTracker';
// To deal with transient failures, we allow multiple stream attempts before
// giving up and transitioning from OnlineState.Unknown to Offline.
// TODO(mikelehen): This used to be set to 2 as a mitigation for b/66228394.
// @jdimond thinks that bug is sufficiently fixed so that we can set this back
// to 1. If that works okay, we could potentially remove this logic entirely.
var MAX_WATCH_STREAM_FAILURES = 1;
// To deal with stream attempts that don't succeed or fail in a timely manner,
// we have a timeout for OnlineState to reach Online or Offline.
// If the timeout is reached, we transition to Offline rather than waiting
// indefinitely.
var ONLINE_STATE_TIMEOUT_MS = 10 * 1000;
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */
var OnlineStateTracker = /** @class */ (function () {
    function OnlineStateTracker(asyncQueue, onlineStateHandler) {
        this.asyncQueue = asyncQueue;
        this.onlineStateHandler = onlineStateHandler;
        /** The current OnlineState. */
        this.state = OnlineState.Unknown;
        /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */
        this.watchStreamFailures = 0;
        /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */
        this.onlineStateTimer = null;
        /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */
        this.shouldWarnClientIsOffline = true;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */
    OnlineStateTracker.prototype.handleWatchStreamStart = function () {
        var _this = this;
        if (this.watchStreamFailures === 0) {
            this.setAndBroadcast(OnlineState.Unknown);
            assert(this.onlineStateTimer === null, "onlineStateTimer shouldn't be started yet");
            this.onlineStateTimer = this.asyncQueue.enqueueAfterDelay(TimerId.OnlineStateTimeout, ONLINE_STATE_TIMEOUT_MS, function () {
                _this.onlineStateTimer = null;
                assert(_this.state === OnlineState.Unknown, 'Timer should be canceled if we transitioned to a different state.');
                _this.logClientOfflineWarningIfNecessary("Backend didn't respond within " + ONLINE_STATE_TIMEOUT_MS / 1000 + " " +
                    "seconds.");
                _this.setAndBroadcast(OnlineState.Offline);
                // NOTE: handleWatchStreamFailure() will continue to increment
                // watchStreamFailures even though we are already marked Offline,
                // but this is non-harmful.
                return Promise.resolve();
            });
        }
    };
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */
    OnlineStateTracker.prototype.handleWatchStreamFailure = function (error$$1) {
        if (this.state === OnlineState.Online) {
            this.setAndBroadcast(OnlineState.Unknown);
            // To get to OnlineState.Online, set() must have been called which would
            // have reset our heuristics.
            assert(this.watchStreamFailures === 0, 'watchStreamFailures must be 0');
            assert(this.onlineStateTimer === null, 'onlineStateTimer must be null');
        }
        else {
            this.watchStreamFailures++;
            if (this.watchStreamFailures >= MAX_WATCH_STREAM_FAILURES) {
                this.clearOnlineStateTimer();
                this.logClientOfflineWarningIfNecessary("Connection failed " + MAX_WATCH_STREAM_FAILURES + " " +
                    ("times. Most recent error: " + error$$1.toString()));
                this.setAndBroadcast(OnlineState.Offline);
            }
        }
    };
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */
    OnlineStateTracker.prototype.set = function (newState) {
        this.clearOnlineStateTimer();
        this.watchStreamFailures = 0;
        if (newState === OnlineState.Online) {
            // We've connected to watch at least once. Don't warn the developer
            // about being offline going forward.
            this.shouldWarnClientIsOffline = false;
        }
        this.setAndBroadcast(newState);
    };
    OnlineStateTracker.prototype.setAndBroadcast = function (newState) {
        if (newState !== this.state) {
            this.state = newState;
            this.onlineStateHandler(newState);
        }
    };
    OnlineStateTracker.prototype.logClientOfflineWarningIfNecessary = function (details) {
        var message = "Could not reach Cloud Firestore backend. " + details + "\n" +
            "This typically indicates that your device does not have a healthy " +
            "Internet connection at the moment. The client will operate in offline " +
            "mode until it is able to successfully connect to the backend.";
        if (this.shouldWarnClientIsOffline) {
            error(message);
            this.shouldWarnClientIsOffline = false;
        }
        else {
            debug(LOG_TAG$7, message);
        }
    };
    OnlineStateTracker.prototype.clearOnlineStateTimer = function () {
        if (this.onlineStateTimer !== null) {
            this.onlineStateTimer.cancel();
            this.onlineStateTimer = null;
        }
    };
    return OnlineStateTracker;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$8 = 'RemoteStore';
// TODO(b/35853402): Negotiate this with the stream.
var MAX_PENDING_WRITES = 10;
/**
 * RemoteStore - An interface to remotely stored data, basically providing a
 * wrapper around the Datastore that is more reliable for the rest of the
 * system.
 *
 * RemoteStore is responsible for maintaining the connection to the server.
 * - maintaining a list of active listens.
 * - reconnecting when the connection is dropped.
 * - resuming all the active listens on reconnect.
 *
 * RemoteStore handles all incoming events from the Datastore.
 * - listening to the watch stream and repackaging the events as RemoteEvents
 * - notifying SyncEngine of any changes to the active listens.
 *
 * RemoteStore takes writes from other components and handles them reliably.
 * - pulling pending mutations from LocalStore and sending them to Datastore.
 * - retrying mutations that failed because of network problems.
 * - acking mutations to the SyncEngine once they are accepted or rejected.
 */
var RemoteStore = /** @class */ (function () {
    function RemoteStore(
    /**
     * The local store, used to fill the write pipeline with outbound mutations.
     */
    localStore, 
    /** The client-side proxy for interacting with the backend. */
    datastore, asyncQueue, onlineStateHandler) {
        this.localStore = localStore;
        this.datastore = datastore;
        /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */
        this.writePipeline = [];
        /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */
        this.listenTargets = {};
        this.watchChangeAggregator = null;
        /**
         * Set to true by enableNetwork() and false by disableNetwork() and indicates
         * the user-preferred network state.
         */
        this.networkEnabled = false;
        this.isPrimary = false;
        this.onlineStateTracker = new OnlineStateTracker(asyncQueue, onlineStateHandler);
        // Create streams (but note they're not started yet).
        this.watchStream = this.datastore.newPersistentWatchStream({
            onOpen: this.onWatchStreamOpen.bind(this),
            onClose: this.onWatchStreamClose.bind(this),
            onWatchChange: this.onWatchStreamChange.bind(this)
        });
        this.writeStream = this.datastore.newPersistentWriteStream({
            onOpen: this.onWriteStreamOpen.bind(this),
            onClose: this.onWriteStreamClose.bind(this),
            onHandshakeComplete: this.onWriteHandshakeComplete.bind(this),
            onMutationResult: this.onMutationResult.bind(this)
        });
    }
    /**
     * Starts up the remote store, creating streams, restoring state from
     * LocalStore, etc.
     */
    RemoteStore.prototype.start = function () {
        return this.enableNetwork();
    };
    /** Re-enables the network. Idempotent. */
    RemoteStore.prototype.enableNetwork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.networkEnabled = true;
                        if (!this.canUseNetwork()) return [3 /*break*/, 3];
                        _a = this.writeStream;
                        return [4 /*yield*/, this.localStore.getLastStreamToken()];
                    case 1:
                        _a.lastStreamToken = _b.sent();
                        if (this.shouldStartWatchStream()) {
                            this.startWatchStream();
                        }
                        else {
                            this.onlineStateTracker.set(OnlineState.Unknown);
                        }
                        // This will start the write stream if necessary.
                        return [4 /*yield*/, this.fillWritePipeline()];
                    case 2:
                        // This will start the write stream if necessary.
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Temporarily disables the network. The network can be re-enabled using
     * enableNetwork().
     */
    RemoteStore.prototype.disableNetwork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        // Set the OnlineState to Offline so get()s return from cache, etc.
                        this.onlineStateTracker.set(OnlineState.Offline);
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteStore.prototype.disableNetworkInternal = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.writeStream.stop()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.watchStream.stop()];
                    case 2:
                        _a.sent();
                        if (this.writePipeline.length > 0) {
                            debug(LOG_TAG$8, "Stopping write stream with " + this.writePipeline.length + " pending writes");
                            this.writePipeline = [];
                        }
                        this.cleanUpWatchStreamState();
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteStore.prototype.shutdown = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug(LOG_TAG$8, 'RemoteStore shutting down.');
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
                        // triggering spurious listener events with cached data, etc.
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Starts new listen for the given query. Uses resume token if provided */
    RemoteStore.prototype.listen = function (queryData) {
        assert(!contains(this.listenTargets, queryData.targetId), 'listen called with duplicate targetId!');
        // Mark this as something the client is currently listening for.
        this.listenTargets[queryData.targetId] = queryData;
        if (this.shouldStartWatchStream()) {
            // The listen will be sent in onWatchStreamOpen
            this.startWatchStream();
        }
        else if (this.watchStream.isOpen()) {
            this.sendWatchRequest(queryData);
        }
    };
    /** Removes the listen from server */
    RemoteStore.prototype.unlisten = function (targetId) {
        assert(contains(this.listenTargets, targetId), 'unlisten called without assigned target ID!');
        delete this.listenTargets[targetId];
        if (this.watchStream.isOpen()) {
            this.sendUnwatchRequest(targetId);
        }
        if (isEmpty(this.listenTargets)) {
            if (this.watchStream.isOpen()) {
                this.watchStream.markIdle();
            }
            else if (this.canUseNetwork()) {
                // Revert to OnlineState.Unknown if the watch stream is not open and we
                // have no listeners, since without any listens to send we cannot
                // confirm if the stream is healthy and upgrade to OnlineState.Online.
                this.onlineStateTracker.set(OnlineState.Unknown);
            }
        }
    };
    /** {@link TargetMetadataProvider.getQueryDataForTarget} */
    RemoteStore.prototype.getQueryDataForTarget = function (targetId) {
        return this.listenTargets[targetId] || null;
    };
    /** {@link TargetMetadataProvider.getRemoteKeysForTarget} */
    RemoteStore.prototype.getRemoteKeysForTarget = function (targetId) {
        return this.syncEngine.getRemoteKeysForTarget(targetId);
    };
    /**
     * We need to increment the the expected number of pending responses we're due
     * from watch so we wait for the ack to process any messages from this target.
     */
    RemoteStore.prototype.sendWatchRequest = function (queryData) {
        this.watchChangeAggregator.recordPendingTargetRequest(queryData.targetId);
        this.watchStream.watch(queryData);
    };
    /**
     * We need to increment the expected number of pending responses we're due
     * from watch so we wait for the removal on the server before we process any
     * messages from this target.
     */
    RemoteStore.prototype.sendUnwatchRequest = function (targetId) {
        this.watchChangeAggregator.recordPendingTargetRequest(targetId);
        this.watchStream.unwatch(targetId);
    };
    RemoteStore.prototype.startWatchStream = function () {
        assert(this.shouldStartWatchStream(), 'startWatchStream() called when shouldStartWatchStream() is false.');
        this.watchChangeAggregator = new WatchChangeAggregator(this);
        this.watchStream.start();
        this.onlineStateTracker.handleWatchStreamStart();
    };
    /**
     * Returns whether the watch stream should be started because it's necessary
     * and has not yet been started.
     */
    RemoteStore.prototype.shouldStartWatchStream = function () {
        return (this.canUseNetwork() &&
            !this.watchStream.isStarted() &&
            !isEmpty(this.listenTargets));
    };
    RemoteStore.prototype.canUseNetwork = function () {
        return this.isPrimary && this.networkEnabled;
    };
    RemoteStore.prototype.cleanUpWatchStreamState = function () {
        this.watchChangeAggregator = null;
    };
    RemoteStore.prototype.onWatchStreamOpen = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                forEachNumber(this.listenTargets, function (targetId, queryData) {
                    _this.sendWatchRequest(queryData);
                });
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWatchStreamClose = function (error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (error$$1 === undefined) {
                    // Graceful stop (due to stop() or idle timeout). Make sure that's
                    // desirable.
                    assert(!this.shouldStartWatchStream(), 'Watch stream was stopped gracefully while still needed.');
                }
                this.cleanUpWatchStreamState();
                // If we still need the watch stream, retry the connection.
                if (this.shouldStartWatchStream()) {
                    this.onlineStateTracker.handleWatchStreamFailure(error$$1);
                    this.startWatchStream();
                }
                else {
                    // No need to restart watch stream because there are no active targets.
                    // The online state is set to unknown because there is no active attempt
                    // at establishing a connection
                    this.onlineStateTracker.set(OnlineState.Unknown);
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWatchStreamChange = function (watchChange, snapshotVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var lastRemoteSnapshotVersion;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Mark the client as online since we got a message from the server
                        this.onlineStateTracker.set(OnlineState.Online);
                        if (watchChange instanceof WatchTargetChange &&
                            watchChange.state === WatchTargetChangeState.Removed &&
                            watchChange.cause) {
                            // There was an error on a target, don't wait for a consistent snapshot
                            // to raise events
                            return [2 /*return*/, this.handleTargetError(watchChange)];
                        }
                        if (watchChange instanceof DocumentWatchChange) {
                            this.watchChangeAggregator.handleDocumentChange(watchChange);
                        }
                        else if (watchChange instanceof ExistenceFilterChange) {
                            this.watchChangeAggregator.handleExistenceFilter(watchChange);
                        }
                        else {
                            assert(watchChange instanceof WatchTargetChange, 'Expected watchChange to be an instance of WatchTargetChange');
                            this.watchChangeAggregator.handleTargetChange(watchChange);
                        }
                        if (!!snapshotVersion.isEqual(SnapshotVersion.MIN)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStore.getLastRemoteSnapshotVersion()];
                    case 1:
                        lastRemoteSnapshotVersion = _a.sent();
                        if (!(snapshotVersion.compareTo(lastRemoteSnapshotVersion) >= 0)) return [3 /*break*/, 3];
                        // We have received a target change with a global snapshot if the snapshot
                        // version is not equal to SnapshotVersion.MIN.
                        return [4 /*yield*/, this.raiseWatchSnapshot(snapshotVersion)];
                    case 2:
                        // We have received a target change with a global snapshot if the snapshot
                        // version is not equal to SnapshotVersion.MIN.
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Takes a batch of changes from the Datastore, repackages them as a
     * RemoteEvent, and passes that on to the listener, which is typically the
     * SyncEngine.
     */
    RemoteStore.prototype.raiseWatchSnapshot = function (snapshotVersion) {
        var _this = this;
        assert(!snapshotVersion.isEqual(SnapshotVersion.MIN), "Can't raise event for unknown SnapshotVersion");
        var remoteEvent = this.watchChangeAggregator.createRemoteEvent(snapshotVersion);
        // Update in-memory resume tokens. LocalStore will update the
        // persistent view of these when applying the completed RemoteEvent.
        forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
            if (change.resumeToken.length > 0) {
                var queryData = _this.listenTargets[targetId];
                // A watched target might have been removed already.
                if (queryData) {
                    _this.listenTargets[targetId] = queryData.copy({
                        resumeToken: change.resumeToken,
                        snapshotVersion: snapshotVersion
                    });
                }
            }
        });
        // Re-establish listens for the targets that have been invalidated by
        // existence filter mismatches.
        remoteEvent.targetMismatches.forEach(function (targetId) {
            var queryData = _this.listenTargets[targetId];
            if (!queryData) {
                // A watched target might have been removed already.
                return;
            }
            // Clear the resume token for the query, since we're in a known mismatch
            // state.
            _this.listenTargets[targetId] = queryData.copy({
                resumeToken: emptyByteString()
            });
            // Cause a hard reset by unwatching and rewatching immediately, but
            // deliberately don't send a resume token so that we get a full update.
            _this.sendUnwatchRequest(targetId);
            // Mark the query we send as being on behalf of an existence filter
            // mismatch, but don't actually retain that in listenTargets. This ensures
            // that we flag the first re-listen this way without impacting future
            // listens of this target (that might happen e.g. on reconnect).
            var requestQueryData = new QueryData(queryData.query, targetId, QueryPurpose.ExistenceFilterMismatch, queryData.sequenceNumber);
            _this.sendWatchRequest(requestQueryData);
        });
        // Finally raise remote event
        return this.syncEngine.applyRemoteEvent(remoteEvent);
    };
    /** Handles an error on a target */
    RemoteStore.prototype.handleTargetError = function (watchChange) {
        var _this = this;
        assert(!!watchChange.cause, 'Handling target error without a cause');
        var error$$1 = watchChange.cause;
        var promiseChain = Promise.resolve();
        watchChange.targetIds.forEach(function (targetId) {
            promiseChain = promiseChain.then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    // A watched target might have been removed already.
                    if (contains(this.listenTargets, targetId)) {
                        delete this.listenTargets[targetId];
                        this.watchChangeAggregator.removeTarget(targetId);
                        return [2 /*return*/, this.syncEngine.rejectListen(targetId, error$$1)];
                    }
                    return [2 /*return*/];
                });
            }); });
        });
        return promiseChain;
    };
    /**
     * Attempts to fill our write pipeline with writes from the LocalStore.
     *
     * Called internally to bootstrap or refill the write pipeline and by
     * SyncEngine whenever there are new mutations to process.
     *
     * Starts the write stream if necessary.
     */
    RemoteStore.prototype.fillWritePipeline = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var lastBatchIdRetrieved, batch;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canAddToWritePipeline()) return [3 /*break*/, 4];
                        lastBatchIdRetrieved = this.writePipeline.length > 0
                            ? this.writePipeline[this.writePipeline.length - 1].batchId
                            : BATCHID_UNKNOWN;
                        return [4 /*yield*/, this.localStore.nextMutationBatch(lastBatchIdRetrieved)];
                    case 1:
                        batch = _a.sent();
                        if (!(batch === null)) return [3 /*break*/, 2];
                        if (this.writePipeline.length === 0) {
                            this.writeStream.markIdle();
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        this.addToWritePipeline(batch);
                        return [4 /*yield*/, this.fillWritePipeline()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (this.shouldStartWriteStream()) {
                            this.startWriteStream();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns true if we can add to the write pipeline (i.e. the network is
     * enabled and the write pipeline is not full).
     */
    RemoteStore.prototype.canAddToWritePipeline = function () {
        return (this.canUseNetwork() && this.writePipeline.length < MAX_PENDING_WRITES);
    };
    // For testing
    RemoteStore.prototype.outstandingWrites = function () {
        return this.writePipeline.length;
    };
    /**
     * Queues additional writes to be sent to the write stream, sending them
     * immediately if the write stream is established.
     */
    RemoteStore.prototype.addToWritePipeline = function (batch) {
        assert(this.canAddToWritePipeline(), 'addToWritePipeline called when pipeline is full');
        this.writePipeline.push(batch);
        if (this.writeStream.isOpen() && this.writeStream.handshakeComplete) {
            this.writeStream.writeMutations(batch.mutations);
        }
    };
    RemoteStore.prototype.shouldStartWriteStream = function () {
        return (this.canUseNetwork() &&
            !this.writeStream.isStarted() &&
            this.writePipeline.length > 0);
    };
    RemoteStore.prototype.startWriteStream = function () {
        assert(this.shouldStartWriteStream(), 'startWriteStream() called when shouldStartWriteStream() is false.');
        this.writeStream.start();
    };
    RemoteStore.prototype.onWriteStreamOpen = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.writeStream.writeHandshake();
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWriteHandshakeComplete = function () {
        var _this = this;
        // Record the stream token.
        return this.localStore
            .setLastStreamToken(this.writeStream.lastStreamToken)
            .then(function () {
            // Send the write pipeline now that the stream is established.
            for (var _i = 0, _a = _this.writePipeline; _i < _a.length; _i++) {
                var batch = _a[_i];
                _this.writeStream.writeMutations(batch.mutations);
            }
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    RemoteStore.prototype.onMutationResult = function (commitVersion, results) {
        var _this = this;
        // This is a response to a write containing mutations and should be
        // correlated to the first write in our write pipeline.
        assert(this.writePipeline.length > 0, 'Got result for empty write pipeline');
        var batch = this.writePipeline.shift();
        var success = MutationBatchResult.from(batch, commitVersion, results, this.writeStream.lastStreamToken);
        return this.syncEngine.applySuccessfulWrite(success).then(function () {
            // It's possible that with the completion of this mutation another
            // slot has freed up.
            return _this.fillWritePipeline();
        });
    };
    RemoteStore.prototype.onWriteStreamClose = function (error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var errorHandling;
            return tslib_1.__generator(this, function (_a) {
                if (error$$1 === undefined) {
                    // Graceful stop (due to stop() or idle timeout). Make sure that's
                    // desirable.
                    assert(!this.shouldStartWriteStream(), 'Write stream was stopped gracefully while still needed.');
                }
                // If the write stream closed due to an error, invoke the error callbacks if
                // there are pending writes.
                if (error$$1 && this.writePipeline.length > 0) {
                    errorHandling = void 0;
                    if (this.writeStream.handshakeComplete) {
                        // This error affects the actual write.
                        errorHandling = this.handleWriteError(error$$1);
                    }
                    else {
                        // If there was an error before the handshake has finished, it's
                        // possible that the server is unable to process the stream token
                        // we're sending. (Perhaps it's too old?)
                        errorHandling = this.handleHandshakeError(error$$1);
                    }
                    return [2 /*return*/, errorHandling.then(function () {
                            // The write stream might have been started by refilling the write
                            // pipeline for failed writes
                            if (_this.shouldStartWriteStream()) {
                                _this.startWriteStream();
                            }
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.handleHandshakeError = function (error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // Reset the token if it's a permanent error, signaling the write stream is
                // no longer valid. Note that the handshake does not count as a write: see
                // comments on isPermanentWriteError for details.
                if (isPermanentError(error$$1.code)) {
                    debug(LOG_TAG$8, 'RemoteStore error before completed handshake; resetting stream token: ', this.writeStream.lastStreamToken);
                    this.writeStream.lastStreamToken = emptyByteString();
                    return [2 /*return*/, this.localStore
                            .setLastStreamToken(emptyByteString())
                            .catch(ignoreIfPrimaryLeaseLoss)];
                }
                else {
                    // Some other error, don't reset stream token. Our stream logic will
                    // just retry with exponential backoff.
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.handleWriteError = function (error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var batch;
            return tslib_1.__generator(this, function (_a) {
                // Only handle permanent errors here. If it's transient, just let the retry
                // logic kick in.
                if (isPermanentWriteError(error$$1.code)) {
                    batch = this.writePipeline.shift();
                    // In this case it's also unlikely that the server itself is melting
                    // down -- this was just a bad request so inhibit backoff on the next
                    // restart.
                    this.writeStream.inhibitBackoff();
                    return [2 /*return*/, this.syncEngine
                            .rejectFailedWrite(batch.batchId, error$$1)
                            .then(function () {
                            // It's possible that with the completion of this mutation
                            // another slot has freed up.
                            return _this.fillWritePipeline();
                        })];
                }
                else {
                    // Transient error, just let the retry logic kick in.
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.createTransaction = function () {
        return new Transaction(this.datastore);
    };
    RemoteStore.prototype.handleCredentialChange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canUseNetwork()) return [3 /*break*/, 3];
                        // Tear down and re-create our network streams. This will ensure we get a fresh auth token
                        // for the new user and re-fill the write pipeline with new mutations from the LocalStore
                        // (since mutations are per-user).
                        debug(LOG_TAG$8, 'RemoteStore restarting streams for new credential');
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        return [4 /*yield*/, this.enableNetwork()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Toggles the network state when the client gains or loses its primary lease.
     */
    RemoteStore.prototype.applyPrimaryState = function (isPrimary) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isPrimary = isPrimary;
                        if (!(isPrimary && this.networkEnabled)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.enableNetwork()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!!isPrimary) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 3:
                        _a.sent();
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return RemoteStore;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */
var QueryListenersInfo = /** @class */ (function () {
    function QueryListenersInfo() {
        this.listeners = [];
    }
    return QueryListenersInfo;
}());
/**
 * EventManager is responsible for mapping queries to query event emitters.
 * It handles "fan-out". -- Identical queries will re-use the same watch on the
 * backend.
 */
var EventManager = /** @class */ (function () {
    function EventManager(syncEngine) {
        this.syncEngine = syncEngine;
        this.queries = new ObjectMap(function (q) {
            return q.canonicalId();
        });
        this.onlineState = OnlineState.Unknown;
        this.syncEngine.subscribe(this);
    }
    EventManager.prototype.listen = function (listener) {
        var query = listener.query;
        var firstListen = false;
        var queryInfo = this.queries.get(query);
        if (!queryInfo) {
            firstListen = true;
            queryInfo = new QueryListenersInfo();
            this.queries.set(query, queryInfo);
        }
        queryInfo.listeners.push(listener);
        listener.applyOnlineStateChange(this.onlineState);
        if (queryInfo.viewSnap)
            listener.onViewSnapshot(queryInfo.viewSnap);
        if (firstListen) {
            return this.syncEngine.listen(query).then(function (targetId) {
                queryInfo.targetId = targetId;
                return targetId;
            });
        }
        else {
            return Promise.resolve(queryInfo.targetId);
        }
    };
    EventManager.prototype.unlisten = function (listener) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, lastListen, queryInfo, i;
            return tslib_1.__generator(this, function (_a) {
                query = listener.query;
                lastListen = false;
                queryInfo = this.queries.get(query);
                if (queryInfo) {
                    i = queryInfo.listeners.indexOf(listener);
                    if (i >= 0) {
                        queryInfo.listeners.splice(i, 1);
                        lastListen = queryInfo.listeners.length === 0;
                    }
                }
                if (lastListen) {
                    this.queries.delete(query);
                    return [2 /*return*/, this.syncEngine.unlisten(query)];
                }
                return [2 /*return*/];
            });
        });
    };
    EventManager.prototype.onWatchChange = function (viewSnaps) {
        for (var _i = 0, viewSnaps_1 = viewSnaps; _i < viewSnaps_1.length; _i++) {
            var viewSnap = viewSnaps_1[_i];
            var query = viewSnap.query;
            var queryInfo = this.queries.get(query);
            if (queryInfo) {
                for (var _a = 0, _b = queryInfo.listeners; _a < _b.length; _a++) {
                    var listener = _b[_a];
                    listener.onViewSnapshot(viewSnap);
                }
                queryInfo.viewSnap = viewSnap;
            }
        }
    };
    EventManager.prototype.onWatchError = function (query, error) {
        var queryInfo = this.queries.get(query);
        if (queryInfo) {
            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.onError(error);
            }
        }
        // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
        // after an error.
        this.queries.delete(query);
    };
    EventManager.prototype.onOnlineStateChange = function (onlineState) {
        this.onlineState = onlineState;
        this.queries.forEach(function (_, queryInfo) {
            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.applyOnlineStateChange(onlineState);
            }
        });
    };
    return EventManager;
}());
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */
var QueryListener = /** @class */ (function () {
    function QueryListener(query, queryObserver, options) {
        this.query = query;
        this.queryObserver = queryObserver;
        /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */
        this.raisedInitialEvent = false;
        this.onlineState = OnlineState.Unknown;
        this.options = options || {};
    }
    QueryListener.prototype.onViewSnapshot = function (snap) {
        assert(snap.docChanges.length > 0 || snap.syncStateChanged, 'We got a new snapshot with no changes?');
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            var docChanges = [];
            for (var _i = 0, _a = snap.docChanges; _i < _a.length; _i++) {
                var docChange = _a[_i];
                if (docChange.type !== ChangeType.Metadata) {
                    docChanges.push(docChange);
                }
            }
            snap = new ViewSnapshot(snap.query, snap.docs, snap.oldDocs, docChanges, snap.mutatedKeys, snap.fromCache, snap.syncStateChanged, 
            /* excludesMetadataChanges= */ true);
        }
        if (!this.raisedInitialEvent) {
            if (this.shouldRaiseInitialEvent(snap, this.onlineState)) {
                this.raiseInitialEvent(snap);
            }
        }
        else if (this.shouldRaiseEvent(snap)) {
            this.queryObserver.next(snap);
        }
        this.snap = snap;
    };
    QueryListener.prototype.onError = function (error) {
        this.queryObserver.error(error);
    };
    QueryListener.prototype.applyOnlineStateChange = function (onlineState) {
        this.onlineState = onlineState;
        if (this.snap &&
            !this.raisedInitialEvent &&
            this.shouldRaiseInitialEvent(this.snap, onlineState)) {
            this.raiseInitialEvent(this.snap);
        }
    };
    QueryListener.prototype.shouldRaiseInitialEvent = function (snap, onlineState) {
        assert(!this.raisedInitialEvent, 'Determining whether to raise first event but already had first event');
        // Always raise the first event when we're synced
        if (!snap.fromCache) {
            return true;
        }
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        var maybeOnline = onlineState !== OnlineState.Offline;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        if (this.options.waitForSyncWhenOnline && maybeOnline) {
            assert(snap.fromCache, 'Waiting for sync, but snapshot is not from cache');
            return false;
        }
        // Raise data from cache if we have any documents or we are offline
        return !snap.docs.isEmpty() || onlineState === OnlineState.Offline;
    };
    QueryListener.prototype.shouldRaiseEvent = function (snap) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (snap.docChanges.length > 0) {
            return true;
        }
        var hasPendingWritesChanged = this.snap && this.snap.hasPendingWrites !== snap.hasPendingWrites;
        if (snap.syncStateChanged || hasPendingWritesChanged) {
            return this.options.includeMetadataChanges === true;
        }
        // Generally we should have hit one of the cases above, but it's possible
        // to get here if there were only metadata docChanges and they got
        // stripped out.
        return false;
    };
    QueryListener.prototype.raiseInitialEvent = function (snap) {
        assert(!this.raisedInitialEvent, 'Trying to raise initial events for second time');
        snap = ViewSnapshot.fromInitialDocuments(snap.query, snap.docs, snap.mutatedKeys, snap.fromCache);
        this.raisedInitialEvent = true;
        this.queryObserver.next(snap);
    };
    return QueryListener;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */
var LocalViewChanges = /** @class */ (function () {
    function LocalViewChanges(targetId, addedKeys, removedKeys) {
        this.targetId = targetId;
        this.addedKeys = addedKeys;
        this.removedKeys = removedKeys;
    }
    LocalViewChanges.fromSnapshot = function (targetId, viewSnapshot) {
        var addedKeys = documentKeySet();
        var removedKeys = documentKeySet();
        for (var _i = 0, _a = viewSnapshot.docChanges; _i < _a.length; _i++) {
            var docChange = _a[_i];
            switch (docChange.type) {
                case ChangeType.Added:
                    addedKeys = addedKeys.add(docChange.doc.key);
                    break;
                case ChangeType.Removed:
                    removedKeys = removedKeys.add(docChange.doc.key);
                    break;
                default:
                // do nothing
            }
        }
        return new LocalViewChanges(targetId, addedKeys, removedKeys);
    };
    return LocalViewChanges;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AddedLimboDocument = /** @class */ (function () {
    function AddedLimboDocument(key) {
        this.key = key;
    }
    return AddedLimboDocument;
}());
var RemovedLimboDocument = /** @class */ (function () {
    function RemovedLimboDocument(key) {
        this.key = key;
    }
    return RemovedLimboDocument;
}());
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */
var View = /** @class */ (function () {
    function View(query, 
    /** Documents included in the remote target */
    _syncedDocuments) {
        this.query = query;
        this._syncedDocuments = _syncedDocuments;
        this.syncState = null;
        /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */
        this.current = false;
        /** Documents in the view but not in the remote target */
        this.limboDocuments = documentKeySet();
        /** Document Keys that have local changes */
        this.mutatedKeys = documentKeySet();
        this.documentSet = new DocumentSet(query.docComparator.bind(query));
    }
    Object.defineProperty(View.prototype, "syncedDocuments", {
        /**
         * The set of remote documents that the server has told us belongs to the target associated with
         * this view.
         */
        get: function () {
            return this._syncedDocuments;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges The doc changes to apply to this view.
     * @param previousChanges If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @return a new set of docs, changes, and refill flag.
     */
    View.prototype.computeDocChanges = function (docChanges, previousChanges) {
        var _this = this;
        var changeSet = previousChanges
            ? previousChanges.changeSet
            : new DocumentChangeSet();
        var oldDocumentSet = previousChanges
            ? previousChanges.documentSet
            : this.documentSet;
        var newMutatedKeys = previousChanges
            ? previousChanges.mutatedKeys
            : this.mutatedKeys;
        var newDocumentSet = oldDocumentSet;
        var needsRefill = false;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        //
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        var lastDocInLimit = this.query.hasLimit() && oldDocumentSet.size === this.query.limit
            ? oldDocumentSet.last()
            : null;
        docChanges.inorderTraversal(function (key, newMaybeDoc) {
            var oldDoc = oldDocumentSet.get(key);
            var newDoc = newMaybeDoc instanceof Document ? newMaybeDoc : null;
            if (newDoc) {
                assert(key.isEqual(newDoc.key), 'Mismatching keys found in document changes: ' +
                    key +
                    ' != ' +
                    newDoc.key);
                newDoc = _this.query.matches(newDoc) ? newDoc : null;
            }
            var oldDocHadPendingMutations = oldDoc
                ? _this.mutatedKeys.has(oldDoc.key)
                : false;
            var newDocHasPendingMutations = newDoc
                ? newDoc.hasLocalMutations ||
                    // We only consider committed mutations for documents that were
                    // mutated during the lifetime of the view.
                    (_this.mutatedKeys.has(newDoc.key) && newDoc.hasCommittedMutations)
                : false;
            var changeApplied = false;
            // Calculate change
            if (oldDoc && newDoc) {
                var docsEqual = oldDoc.data.isEqual(newDoc.data);
                if (!docsEqual) {
                    if (!_this.shouldWaitForSyncedDocument(oldDoc, newDoc)) {
                        changeSet.track({
                            type: ChangeType.Modified,
                            doc: newDoc
                        });
                        changeApplied = true;
                        if (lastDocInLimit &&
                            _this.query.docComparator(newDoc, lastDocInLimit) > 0) {
                            // This doc moved from inside the limit to after the limit.
                            // That means there may be some doc in the local cache that's
                            // actually less than this one.
                            needsRefill = true;
                        }
                    }
                }
                else if (oldDocHadPendingMutations !== newDocHasPendingMutations) {
                    changeSet.track({ type: ChangeType.Metadata, doc: newDoc });
                    changeApplied = true;
                }
            }
            else if (!oldDoc && newDoc) {
                changeSet.track({ type: ChangeType.Added, doc: newDoc });
                changeApplied = true;
            }
            else if (oldDoc && !newDoc) {
                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
                changeApplied = true;
                if (lastDocInLimit) {
                    // A doc was removed from a full limit query. We'll need to
                    // requery from the local cache to see if we know about some other
                    // doc that should be in the results.
                    needsRefill = true;
                }
            }
            if (changeApplied) {
                if (newDoc) {
                    newDocumentSet = newDocumentSet.add(newDoc);
                    if (newDocHasPendingMutations) {
                        newMutatedKeys = newMutatedKeys.add(key);
                    }
                    else {
                        newMutatedKeys = newMutatedKeys.delete(key);
                    }
                }
                else {
                    newDocumentSet = newDocumentSet.delete(key);
                    newMutatedKeys = newMutatedKeys.delete(key);
                }
            }
        });
        if (this.query.hasLimit()) {
            while (newDocumentSet.size > this.query.limit) {
                var oldDoc = newDocumentSet.last();
                newDocumentSet = newDocumentSet.delete(oldDoc.key);
                newMutatedKeys = newMutatedKeys.delete(oldDoc.key);
                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
            }
        }
        assert(!needsRefill || !previousChanges, 'View was refilled using docs that themselves needed refilling.');
        return {
            documentSet: newDocumentSet,
            changeSet: changeSet,
            needsRefill: needsRefill,
            mutatedKeys: newMutatedKeys
        };
    };
    View.prototype.shouldWaitForSyncedDocument = function (oldDoc, newDoc) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return (oldDoc.hasLocalMutations &&
            newDoc.hasCommittedMutations &&
            !newDoc.hasLocalMutations);
    };
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges The set of changes to make to the view's docs.
     * @param updateLimboDocuments Whether to update limbo documents based on this
     *        change.
     * @param targetChange A target change to apply for computing limbo docs and
     *        sync state.
     * @return A new ViewChange with the given docs, changes, and sync state.
     */
    // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    View.prototype.applyChanges = function (docChanges, updateLimboDocuments, targetChange) {
        var _this = this;
        assert(!docChanges.needsRefill, 'Cannot apply changes that need a refill');
        var oldDocs = this.documentSet;
        this.documentSet = docChanges.documentSet;
        this.mutatedKeys = docChanges.mutatedKeys;
        // Sort changes based on type and query comparator
        var changes = docChanges.changeSet.getChanges();
        changes.sort(function (c1, c2) {
            return (compareChangeType(c1.type, c2.type) ||
                _this.query.docComparator(c1.doc, c2.doc));
        });
        this.applyTargetChange(targetChange);
        var limboChanges = updateLimboDocuments
            ? this.updateLimboDocuments()
            : [];
        var synced = this.limboDocuments.size === 0 && this.current;
        var newSyncState = synced ? SyncState.Synced : SyncState.Local;
        var syncStateChanged = newSyncState !== this.syncState;
        this.syncState = newSyncState;
        if (changes.length === 0 && !syncStateChanged) {
            // no changes
            return { limboChanges: limboChanges };
        }
        else {
            var snap = new ViewSnapshot(this.query, docChanges.documentSet, oldDocs, changes, docChanges.mutatedKeys, newSyncState === SyncState.Local, syncStateChanged, 
            /* excludesMetadataChanges= */ false);
            return {
                snapshot: snap,
                limboChanges: limboChanges
            };
        }
    };
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */
    View.prototype.applyOnlineStateChange = function (onlineState) {
        if (this.current && onlineState === OnlineState.Offline) {
            // If we're offline, set `current` to false and then call applyChanges()
            // to refresh our syncState and generate a ViewChange as appropriate. We
            // are guaranteed to get a new TargetChange that sets `current` back to
            // true once the client is back online.
            this.current = false;
            return this.applyChanges({
                documentSet: this.documentSet,
                changeSet: new DocumentChangeSet(),
                mutatedKeys: this.mutatedKeys,
                needsRefill: false
            }, 
            /* updateLimboDocuments= */ false);
        }
        else {
            // No effect, just return a no-op ViewChange.
            return { limboChanges: [] };
        }
    };
    /**
     * Returns whether the doc for the given key should be in limbo.
     */
    View.prototype.shouldBeInLimbo = function (key) {
        // If the remote end says it's part of this query, it's not in limbo.
        if (this._syncedDocuments.has(key)) {
            return false;
        }
        // The local store doesn't think it's a result, so it shouldn't be in limbo.
        if (!this.documentSet.has(key)) {
            return false;
        }
        // If there are local changes to the doc, they might explain why the server
        // doesn't know that it's part of the query. So don't put it in limbo.
        // TODO(klimt): Ideally, we would only consider changes that might actually
        // affect this specific query.
        if (this.documentSet.get(key).hasLocalMutations) {
            return false;
        }
        // Everything else is in limbo.
        return true;
    };
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */
    View.prototype.applyTargetChange = function (targetChange) {
        var _this = this;
        if (targetChange) {
            targetChange.addedDocuments.forEach(function (key) { return (_this._syncedDocuments = _this._syncedDocuments.add(key)); });
            targetChange.modifiedDocuments.forEach(function (key) {
                return assert(_this._syncedDocuments.has(key), "Modified document " + key + " not found in view.");
            });
            targetChange.removedDocuments.forEach(function (key) { return (_this._syncedDocuments = _this._syncedDocuments.delete(key)); });
            this.current = targetChange.current;
        }
    };
    View.prototype.updateLimboDocuments = function () {
        var _this = this;
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) {
            return [];
        }
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        var oldLimboDocuments = this.limboDocuments;
        this.limboDocuments = documentKeySet();
        this.documentSet.forEach(function (doc) {
            if (_this.shouldBeInLimbo(doc.key)) {
                _this.limboDocuments = _this.limboDocuments.add(doc.key);
            }
        });
        // Diff the new limbo docs with the old limbo docs.
        var changes = [];
        oldLimboDocuments.forEach(function (key) {
            if (!_this.limboDocuments.has(key)) {
                changes.push(new RemovedLimboDocument(key));
            }
        });
        this.limboDocuments.forEach(function (key) {
            if (!oldLimboDocuments.has(key)) {
                changes.push(new AddedLimboDocument(key));
            }
        });
        return changes;
    };
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param localDocs - The documents that match the query according to the
     * LocalStore.
     * @param remoteKeys - The keys of the documents that match the query
     * according to the backend.
     *
     * @return The ViewChange that resulted from this synchronization.
     */
    // PORTING NOTE: Multi-tab only.
    View.prototype.synchronizeWithPersistedState = function (localDocs, remoteKeys) {
        this._syncedDocuments = remoteKeys;
        this.limboDocuments = documentKeySet();
        var docChanges = this.computeDocChanges(localDocs);
        return this.applyChanges(docChanges, /*updateLimboDocuments=*/ true);
    };
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */
    // PORTING NOTE: Multi-tab only.
    View.prototype.computeInitialSnapshot = function () {
        return ViewSnapshot.fromInitialDocuments(this.query, this.documentSet, this.mutatedKeys, this.syncState === SyncState.Local);
    };
    return View;
}());
function compareChangeType(c1, c2) {
    var order = function (change) {
        switch (change) {
            case ChangeType.Added:
                return 1;
            case ChangeType.Modified:
                return 2;
            case ChangeType.Metadata:
                // A metadata change is converted to a modified change at the public
                // api layer.  Since we sort by document key and then change type,
                // metadata and modified changes must be sorted equivalently.
                return 2;
            case ChangeType.Removed:
                return 0;
            default:
                return fail('Unknown ChangeType: ' + change);
        }
    };
    return order(c1) - order(c2);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$9 = 'SyncEngine';
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */
var QueryView = /** @class */ (function () {
    function QueryView(
    /**
     * The query itself.
     */
    query, 
    /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */
    targetId, 
    /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */
    view) {
        this.query = query;
        this.targetId = targetId;
        this.view = view;
    }
    return QueryView;
}());
/** Tracks a limbo resolution. */
var LimboResolution = /** @class */ (function () {
    function LimboResolution(key) {
        this.key = key;
    }
    return LimboResolution;
}());
/**
 * SyncEngine is the central controller in the client SDK architecture. It is
 * the glue code between the EventManager, LocalStore, and RemoteStore. Some of
 * SyncEngine's responsibilities include:
 * 1. Coordinating client requests and remote events between the EventManager
 *    and the local and remote data stores.
 * 2. Managing a View object for each query, providing the unified view between
 *    the local and remote data stores.
 * 3. Notifying the RemoteStore when the LocalStore has new mutations in its
 *    queue that need sending to the backend.
 *
 * The SyncEngine’s methods should only ever be called by methods running in the
 * global async queue.
 */
var SyncEngine = /** @class */ (function () {
    function SyncEngine(localStore, remoteStore, 
    // PORTING NOTE: Manages state synchronization in multi-tab environments.
    sharedClientState, currentUser) {
        this.localStore = localStore;
        this.remoteStore = remoteStore;
        this.sharedClientState = sharedClientState;
        this.currentUser = currentUser;
        this.syncEngineListener = null;
        this.queryViewsByQuery = new ObjectMap(function (q) {
            return q.canonicalId();
        });
        this.queryViewsByTarget = {};
        this.limboTargetsByKey = new SortedMap(DocumentKey.comparator);
        this.limboResolutionsByTarget = {};
        this.limboDocumentRefs = new ReferenceSet();
        /** Stores user completion handlers, indexed by User and BatchId. */
        this.mutationUserCallbacks = {};
        this.limboTargetIdGenerator = TargetIdGenerator.forSyncEngine();
        // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.isPrimary = undefined;
        this.onlineState = OnlineState.Unknown;
    }
    Object.defineProperty(SyncEngine.prototype, "isPrimaryClient", {
        // Only used for testing.
        get: function () {
            return this.isPrimary === true;
        },
        enumerable: true,
        configurable: true
    });
    /** Subscribes to SyncEngine notifications. Has to be called exactly once. */
    SyncEngine.prototype.subscribe = function (syncEngineListener) {
        assert(syncEngineListener !== null, 'SyncEngine listener cannot be null');
        assert(this.syncEngineListener === null, 'SyncEngine already has a subscriber.');
        this.syncEngineListener = syncEngineListener;
    };
    /**
     * Initiates the new listen, resolves promise when listen enqueued to the
     * server. All the subsequent view snapshots or errors are sent to the
     * subscribed handlers. Returns the targetId of the query.
     */
    SyncEngine.prototype.listen = function (query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var targetId, viewSnapshot, queryView, queryData, status_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('listen()');
                        queryView = this.queryViewsByQuery.get(query);
                        if (!queryView) return [3 /*break*/, 1];
                        // PORTING NOTE: With Mult-Tab Web, it is possible that a query view
                        // already exists when EventManager calls us for the first time. This
                        // happens when the primary tab is already listening to this query on
                        // behalf of another tab and the user of the primary also starts listening
                        // to the query. EventManager will not have an assigned target ID in this
                        // case and calls `listen` to obtain this ID.
                        targetId = queryView.targetId;
                        this.sharedClientState.addLocalQueryTarget(targetId);
                        viewSnapshot = queryView.view.computeInitialSnapshot();
                        return [3 /*break*/, 4];
                    case 1: return [4 /*yield*/, this.localStore.allocateQuery(query)];
                    case 2:
                        queryData = _a.sent();
                        status_1 = this.sharedClientState.addLocalQueryTarget(queryData.targetId);
                        targetId = queryData.targetId;
                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(queryData, status_1 === 'current')];
                    case 3:
                        viewSnapshot = _a.sent();
                        if (this.isPrimary) {
                            this.remoteStore.listen(queryData);
                        }
                        _a.label = 4;
                    case 4:
                        this.syncEngineListener.onWatchChange([viewSnapshot]);
                        return [2 /*return*/, targetId];
                }
            });
        });
    };
    /**
     * Registers a view for a previously unknown query and computes its initial
     * snapshot.
     */
    SyncEngine.prototype.initializeViewAndComputeSnapshot = function (queryData, current) {
        var _this = this;
        var query = queryData.query;
        return this.localStore.executeQuery(query).then(function (docs) {
            return _this.localStore
                .remoteDocumentKeys(queryData.targetId)
                .then(function (remoteKeys) {
                var view = new View(query, remoteKeys);
                var viewDocChanges = view.computeDocChanges(docs);
                // tslint:disable-next-line:max-line-length Prettier formats this exceed 100 characters.
                var synthesizedTargetChange = TargetChange.createSynthesizedTargetChangeForCurrentChange(queryData.targetId, current && _this.onlineState !== OnlineState.Offline);
                var viewChange = view.applyChanges(viewDocChanges, 
                /* updateLimboDocuments= */ _this.isPrimary === true, synthesizedTargetChange);
                assert(viewChange.limboChanges.length === 0, 'View returned limbo docs before target ack from the server.');
                assert(!!viewChange.snapshot, 'applyChanges for new view should always return a snapshot');
                var data = new QueryView(query, queryData.targetId, view);
                _this.queryViewsByQuery.set(query, data);
                _this.queryViewsByTarget[queryData.targetId] = data;
                return viewChange.snapshot;
            });
        });
    };
    /**
     * Reconcile the list of synced documents in an existing view with those
     * from persistence.
     */
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.synchronizeViewAndComputeSnapshot = function (queryView) {
        var _this = this;
        return this.localStore.executeQuery(queryView.query).then(function (docs) {
            return _this.localStore
                .remoteDocumentKeys(queryView.targetId)
                .then(function (remoteKeys) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var viewSnapshot;
                return tslib_1.__generator(this, function (_a) {
                    viewSnapshot = queryView.view.synchronizeWithPersistedState(docs, remoteKeys);
                    if (this.isPrimary) {
                        this.updateTrackedLimbos(queryView.targetId, viewSnapshot.limboChanges);
                    }
                    return [2 /*return*/, viewSnapshot];
                });
            }); });
        });
    };
    /** Stops listening to the query. */
    SyncEngine.prototype.unlisten = function (query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var queryView, targetRemainsActive;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('unlisten()');
                        queryView = this.queryViewsByQuery.get(query);
                        assert(!!queryView, 'Trying to unlisten on query not found:' + query);
                        if (!this.isPrimary) return [3 /*break*/, 3];
                        // We need to remove the local query target first to allow us to verify
                        // whether any other client is still interested in this target.
                        this.sharedClientState.removeLocalQueryTarget(queryView.targetId);
                        targetRemainsActive = this.sharedClientState.isActiveQueryTarget(queryView.targetId);
                        if (!!targetRemainsActive) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.localStore
                                .releaseQuery(query, /*keepPersistedQueryData=*/ false)
                                .then(function () {
                                _this.sharedClientState.clearQueryState(queryView.targetId);
                                _this.remoteStore.unlisten(queryView.targetId);
                                _this.removeAndCleanupQuery(queryView);
                            })
                                .catch(ignoreIfPrimaryLeaseLoss)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        this.removeAndCleanupQuery(queryView);
                        return [4 /*yield*/, this.localStore.releaseQuery(query, 
                            /*keepPersistedQueryData=*/ true)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initiates the write of local mutation batch which involves adding the
     * writes to the mutation queue, notifying the remote store about new
     * mutations and raising events for any changes this write caused.
     *
     * The promise returned by this call is resolved when the above steps
     * have completed, *not* when the write was acked by the backend. The
     * userCallback is resolved once the write was acked/rejected by the
     * backend (or failed locally for any other reason).
     */
    SyncEngine.prototype.write = function (batch, userCallback) {
        var _this = this;
        this.assertSubscribed('write()');
        return this.localStore
            .localWrite(batch)
            .then(function (result) {
            _this.sharedClientState.addPendingMutation(result.batchId);
            _this.addMutationCallback(result.batchId, userCallback);
            return _this.emitNewSnapsAndNotifyLocalStore(result.changes);
        })
            .then(function () {
            return _this.remoteStore.fillWritePipeline();
        });
    };
    // TODO(klimt): Wrap the given error in a standard Firestore error object.
    SyncEngine.prototype.wrapUpdateFunctionError = function (error$$1) {
        return error$$1;
    };
    /**
     * Takes an updateFunction in which a set of reads and writes can be performed
     * atomically. In the updateFunction, the client can read and write values
     * using the supplied transaction object. After the updateFunction, all
     * changes will be committed. If some other client has changed any of the data
     * referenced, then the updateFunction will be called again. If the
     * updateFunction still fails after the given number of retries, then the
     * transaction will be rejection.
     *
     * The transaction object passed to the updateFunction contains methods for
     * accessing documents and collections. Unlike other datastore access, data
     * accessed with the transaction will not reflect local changes that have not
     * been committed. For this reason, it is required that all reads are
     * performed before any writes. Transactions must be performed while online.
     *
     * The promise returned is resolved when the transaction is fully committed.
     */
    SyncEngine.prototype.runTransaction = function (updateFunction, retries) {
        var _this = this;
        if (retries === void 0) { retries = 5; }
        assert(retries >= 0, 'Got negative number of retries for transaction.');
        var transaction = this.remoteStore.createTransaction();
        var wrappedUpdateFunction = function () {
            try {
                var userPromise = updateFunction(transaction);
                if (isNullOrUndefined(userPromise) ||
                    !userPromise.catch ||
                    !userPromise.then) {
                    return Promise.reject(Error('Transaction callback must return a Promise'));
                }
                return userPromise.catch(function (e) {
                    return Promise.reject(_this.wrapUpdateFunctionError(e));
                });
            }
            catch (e) {
                return Promise.reject(_this.wrapUpdateFunctionError(e));
            }
        };
        return wrappedUpdateFunction().then(function (result) {
            return transaction
                .commit()
                .then(function () {
                return result;
            })
                .catch(function (error$$1) {
                if (retries === 0) {
                    return Promise.reject(error$$1);
                }
                // TODO(klimt): Put in a retry delay?
                return _this.runTransaction(updateFunction, retries - 1);
            });
        });
    };
    SyncEngine.prototype.applyRemoteEvent = function (remoteEvent) {
        var _this = this;
        this.assertSubscribed('applyRemoteEvent()');
        return this.localStore
            .applyRemoteEvent(remoteEvent)
            .then(function (changes) {
            // Update `receivedDocument` as appropriate for any limbo targets.
            forEach(remoteEvent.targetChanges, function (targetId, targetChange) {
                var limboResolution = _this.limboResolutionsByTarget[targetId];
                if (limboResolution) {
                    // Since this is a limbo resolution lookup, it's for a single document
                    // and it could be added, modified, or removed, but not a combination.
                    assert(targetChange.addedDocuments.size +
                        targetChange.modifiedDocuments.size +
                        targetChange.removedDocuments.size <=
                        1, 'Limbo resolution for single document contains multiple changes.');
                    if (targetChange.addedDocuments.size > 0) {
                        limboResolution.receivedDocument = true;
                    }
                    else if (targetChange.modifiedDocuments.size > 0) {
                        assert(limboResolution.receivedDocument, 'Received change for limbo target document without add.');
                    }
                    else if (targetChange.removedDocuments.size > 0) {
                        assert(limboResolution.receivedDocument, 'Received remove for limbo target document without add.');
                        limboResolution.receivedDocument = false;
                    }
                    else {
                        // This was probably just a CURRENT targetChange or similar.
                    }
                }
            });
            return _this.emitNewSnapsAndNotifyLocalStore(changes, remoteEvent);
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    /**
     * Applies an OnlineState change to the sync engine and notifies any views of
     * the change.
     */
    SyncEngine.prototype.applyOnlineStateChange = function (onlineState, source) {
        // If we are the secondary client, we explicitly ignore the remote store's
        // online state (the local client may go offline, even though the primary
        // tab remains online) and only apply the primary tab's online state from
        // SharedClientState.
        if ((this.isPrimary && source === OnlineStateSource.RemoteStore) ||
            (!this.isPrimary && source === OnlineStateSource.SharedClientState)) {
            var newViewSnapshots_1 = [];
            this.queryViewsByQuery.forEach(function (query, queryView) {
                var viewChange = queryView.view.applyOnlineStateChange(onlineState);
                assert(viewChange.limboChanges.length === 0, 'OnlineState should not affect limbo documents.');
                if (viewChange.snapshot) {
                    newViewSnapshots_1.push(viewChange.snapshot);
                }
            });
            this.syncEngineListener.onOnlineStateChange(onlineState);
            this.syncEngineListener.onWatchChange(newViewSnapshots_1);
            this.onlineState = onlineState;
            if (this.isPrimary) {
                this.sharedClientState.setOnlineState(onlineState);
            }
        }
    };
    SyncEngine.prototype.rejectListen = function (targetId, err) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var limboResolution, limboKey, documentUpdates, resolvedLimboDocuments, event_1, queryView_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('rejectListens()');
                        // PORTING NOTE: Multi-tab only.
                        this.sharedClientState.updateQueryState(targetId, 'rejected', err);
                        limboResolution = this.limboResolutionsByTarget[targetId];
                        limboKey = limboResolution && limboResolution.key;
                        if (!limboKey) return [3 /*break*/, 1];
                        // Since this query failed, we won't want to manually unlisten to it.
                        // So go ahead and remove it from bookkeeping.
                        this.limboTargetsByKey = this.limboTargetsByKey.remove(limboKey);
                        delete this.limboResolutionsByTarget[targetId];
                        documentUpdates = new SortedMap(DocumentKey.comparator);
                        documentUpdates = documentUpdates.insert(limboKey, new NoDocument(limboKey, SnapshotVersion.forDeletedDoc()));
                        resolvedLimboDocuments = documentKeySet().add(limboKey);
                        event_1 = new RemoteEvent(SnapshotVersion.MIN, 
                        /* targetChanges= */ {}, 
                        /* targetMismatches= */ new SortedSet(primitiveComparator), documentUpdates, resolvedLimboDocuments);
                        return [2 /*return*/, this.applyRemoteEvent(event_1)];
                    case 1:
                        queryView_1 = this.queryViewsByTarget[targetId];
                        assert(!!queryView_1, 'Unknown targetId: ' + targetId);
                        return [4 /*yield*/, this.localStore
                                .releaseQuery(queryView_1.query, /* keepPersistedQueryData */ false)
                                .then(function () { return _this.removeAndCleanupQuery(queryView_1); })
                                .catch(ignoreIfPrimaryLeaseLoss)];
                    case 2:
                        _a.sent();
                        this.syncEngineListener.onWatchError(queryView_1.query, err);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyBatchState = function (batchId, batchState, error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var documents;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('applyBatchState()');
                        return [4 /*yield*/, this.localStore.lookupMutationDocuments(batchId)];
                    case 1:
                        documents = _a.sent();
                        if (documents === null) {
                            // A throttled tab may not have seen the mutation before it was completed
                            // and removed from the mutation queue, in which case we won't have cached
                            // the affected documents. In this case we can safely ignore the update
                            // since that means we didn't apply the mutation locally at all (if we
                            // had, we would have cached the affected documents), and so we will just
                            // see any resulting document changes via normal remote document updates
                            // as applicable.
                            debug(LOG_TAG$9, 'Cannot apply mutation batch with id: ' + batchId);
                            return [2 /*return*/];
                        }
                        if (!(batchState === 'pending')) return [3 /*break*/, 3];
                        // If we are the primary client, we need to send this write to the
                        // backend. Secondary clients will ignore these writes since their remote
                        // connection is disabled.
                        return [4 /*yield*/, this.remoteStore.fillWritePipeline()];
                    case 2:
                        // If we are the primary client, we need to send this write to the
                        // backend. Secondary clients will ignore these writes since their remote
                        // connection is disabled.
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (batchState === 'acknowledged' || batchState === 'rejected') {
                            // NOTE: Both these methods are no-ops for batches that originated from
                            // other clients.
                            this.processUserCallback(batchId, error$$1 ? error$$1 : null);
                            this.localStore.removeCachedMutationBatchMetadata(batchId);
                        }
                        else {
                            fail("Unknown batchState: " + batchState);
                        }
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(documents)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SyncEngine.prototype.applySuccessfulWrite = function (mutationBatchResult) {
        var _this = this;
        this.assertSubscribed('applySuccessfulWrite()');
        var batchId = mutationBatchResult.batch.batchId;
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        this.processUserCallback(batchId, /*error=*/ null);
        return this.localStore
            .acknowledgeBatch(mutationBatchResult)
            .then(function (changes) {
            _this.sharedClientState.updateMutationState(batchId, 'acknowledged');
            return _this.emitNewSnapsAndNotifyLocalStore(changes);
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    SyncEngine.prototype.rejectFailedWrite = function (batchId, error$$1) {
        var _this = this;
        this.assertSubscribed('rejectFailedWrite()');
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        this.processUserCallback(batchId, error$$1);
        return this.localStore
            .rejectBatch(batchId)
            .then(function (changes) {
            _this.sharedClientState.updateMutationState(batchId, 'rejected', error$$1);
            return _this.emitNewSnapsAndNotifyLocalStore(changes);
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    SyncEngine.prototype.addMutationCallback = function (batchId, callback) {
        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
        if (!newCallbacks) {
            newCallbacks = new SortedMap(primitiveComparator);
        }
        newCallbacks = newCallbacks.insert(batchId, callback);
        this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
    };
    /**
     * Resolves or rejects the user callback for the given batch and then discards
     * it.
     */
    SyncEngine.prototype.processUserCallback = function (batchId, error$$1) {
        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
        // NOTE: Mutations restored from persistence won't have callbacks, so it's
        // okay for there to be no callback for this ID.
        if (newCallbacks) {
            var callback = newCallbacks.get(batchId);
            if (callback) {
                assert(batchId === newCallbacks.minKey(), 'Mutation callbacks processed out-of-order?');
                if (error$$1) {
                    callback.reject(error$$1);
                }
                else {
                    callback.resolve();
                }
                newCallbacks = newCallbacks.remove(batchId);
            }
            this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
        }
    };
    SyncEngine.prototype.removeAndCleanupQuery = function (queryView) {
        var _this = this;
        this.sharedClientState.removeLocalQueryTarget(queryView.targetId);
        this.queryViewsByQuery.delete(queryView.query);
        delete this.queryViewsByTarget[queryView.targetId];
        if (this.isPrimary) {
            var limboKeys = this.limboDocumentRefs.referencesForId(queryView.targetId);
            this.limboDocumentRefs.removeReferencesForId(queryView.targetId);
            limboKeys.forEach(function (limboKey) {
                var isReferenced = _this.limboDocumentRefs.containsKey(limboKey);
                if (!isReferenced) {
                    // We removed the last reference for this key
                    _this.removeLimboTarget(limboKey);
                }
            });
        }
    };
    SyncEngine.prototype.removeLimboTarget = function (key) {
        // It's possible that the target already got removed because the query failed. In that case,
        // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
        var limboTargetId = this.limboTargetsByKey.get(key);
        if (limboTargetId === null) {
            // This target already got removed, because the query failed.
            return;
        }
        this.remoteStore.unlisten(limboTargetId);
        this.limboTargetsByKey = this.limboTargetsByKey.remove(key);
        delete this.limboResolutionsByTarget[limboTargetId];
    };
    SyncEngine.prototype.updateTrackedLimbos = function (targetId, limboChanges) {
        for (var _i = 0, limboChanges_1 = limboChanges; _i < limboChanges_1.length; _i++) {
            var limboChange = limboChanges_1[_i];
            if (limboChange instanceof AddedLimboDocument) {
                this.limboDocumentRefs.addReference(limboChange.key, targetId);
                this.trackLimboChange(limboChange);
            }
            else if (limboChange instanceof RemovedLimboDocument) {
                debug(LOG_TAG$9, 'Document no longer in limbo: ' + limboChange.key);
                this.limboDocumentRefs.removeReference(limboChange.key, targetId);
                var isReferenced = this.limboDocumentRefs.containsKey(limboChange.key);
                if (!isReferenced) {
                    // We removed the last reference for this key
                    this.removeLimboTarget(limboChange.key);
                }
            }
            else {
                fail('Unknown limbo change: ' + JSON.stringify(limboChange));
            }
        }
    };
    SyncEngine.prototype.trackLimboChange = function (limboChange) {
        var key = limboChange.key;
        if (!this.limboTargetsByKey.get(key)) {
            debug(LOG_TAG$9, 'New document in limbo: ' + key);
            var limboTargetId = this.limboTargetIdGenerator.next();
            var query = Query.atPath(key.path);
            this.limboResolutionsByTarget[limboTargetId] = new LimboResolution(key);
            this.remoteStore.listen(new QueryData(query, limboTargetId, QueryPurpose.LimboResolution, ListenSequence.INVALID));
            this.limboTargetsByKey = this.limboTargetsByKey.insert(key, limboTargetId);
        }
    };
    // Visible for testing
    SyncEngine.prototype.currentLimboDocs = function () {
        return this.limboTargetsByKey;
    };
    SyncEngine.prototype.emitNewSnapsAndNotifyLocalStore = function (changes, remoteEvent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var newSnaps, docChangesInAllViews, queriesProcessed;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newSnaps = [];
                        docChangesInAllViews = [];
                        queriesProcessed = [];
                        this.queryViewsByQuery.forEach(function (_, queryView) {
                            queriesProcessed.push(Promise.resolve()
                                .then(function () {
                                var viewDocChanges = queryView.view.computeDocChanges(changes);
                                if (!viewDocChanges.needsRefill) {
                                    return viewDocChanges;
                                }
                                // The query has a limit and some docs were removed, so we need
                                // to re-run the query against the local store to make sure we
                                // didn't lose any good docs that had been past the limit.
                                return _this.localStore.executeQuery(queryView.query).then(function (docs) {
                                    return queryView.view.computeDocChanges(docs, viewDocChanges);
                                });
                            })
                                .then(function (viewDocChanges) {
                                var targetChange = remoteEvent && remoteEvent.targetChanges[queryView.targetId];
                                var viewChange = queryView.view.applyChanges(viewDocChanges, 
                                /* updateLimboDocuments= */ _this.isPrimary === true, targetChange);
                                _this.updateTrackedLimbos(queryView.targetId, viewChange.limboChanges);
                                if (viewChange.snapshot) {
                                    if (_this.isPrimary) {
                                        _this.sharedClientState.updateQueryState(queryView.targetId, viewChange.snapshot.fromCache ? 'not-current' : 'current');
                                    }
                                    newSnaps.push(viewChange.snapshot);
                                    var docChanges = LocalViewChanges.fromSnapshot(queryView.targetId, viewChange.snapshot);
                                    docChangesInAllViews.push(docChanges);
                                }
                            }));
                        });
                        return [4 /*yield*/, Promise.all(queriesProcessed)];
                    case 1:
                        _a.sent();
                        this.syncEngineListener.onWatchChange(newSnaps);
                        return [4 /*yield*/, this.localStore.notifyLocalViewChanges(docChangesInAllViews)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SyncEngine.prototype.assertSubscribed = function (fnName) {
        assert(this.syncEngineListener !== null, 'Trying to call ' + fnName + ' before calling subscribe().');
    };
    SyncEngine.prototype.handleCredentialChange = function (user) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userChanged, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userChanged = !this.currentUser.isEqual(user);
                        this.currentUser = user;
                        if (!userChanged) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStore.handleUserChange(user)];
                    case 1:
                        result = _a.sent();
                        // TODO(b/114226417): Consider calling this only in the primary tab.
                        this.sharedClientState.handleUserChange(user, result.removedBatchIds, result.addedBatchIds);
                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(result.affectedDocuments)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.remoteStore.handleCredentialChange()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyPrimaryState = function (isPrimary) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var activeTargets, activeQueries, _i, activeQueries_1, queryData, activeTargets_1, p_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(isPrimary === true && this.isPrimary !== true)) return [3 /*break*/, 3];
                        this.isPrimary = true;
                        return [4 /*yield*/, this.remoteStore.applyPrimaryState(true)];
                    case 1:
                        _a.sent();
                        activeTargets = this.sharedClientState.getAllActiveQueryTargets();
                        return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets.toArray())];
                    case 2:
                        activeQueries = _a.sent();
                        for (_i = 0, activeQueries_1 = activeQueries; _i < activeQueries_1.length; _i++) {
                            queryData = activeQueries_1[_i];
                            this.remoteStore.listen(queryData);
                        }
                        return [3 /*break*/, 7];
                    case 3:
                        if (!(isPrimary === false && this.isPrimary !== false)) return [3 /*break*/, 7];
                        this.isPrimary = false;
                        activeTargets_1 = [];
                        p_1 = Promise.resolve();
                        forEachNumber(this.queryViewsByTarget, function (targetId, queryView) {
                            if (_this.sharedClientState.isLocalQueryTarget(targetId)) {
                                activeTargets_1.push(targetId);
                            }
                            else {
                                p_1 = p_1.then(function () { return _this.unlisten(queryView.query); });
                            }
                            _this.remoteStore.unlisten(queryView.targetId);
                        });
                        return [4 /*yield*/, p_1];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets_1)];
                    case 5:
                        _a.sent();
                        this.resetLimboDocuments();
                        return [4 /*yield*/, this.remoteStore.applyPrimaryState(false)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.resetLimboDocuments = function () {
        var _this = this;
        forEachNumber(this.limboResolutionsByTarget, function (targetId) {
            _this.remoteStore.unlisten(targetId);
        });
        this.limboDocumentRefs.removeAllReferences();
        this.limboResolutionsByTarget = [];
        this.limboTargetsByKey = new SortedMap(DocumentKey.comparator);
    };
    /**
     * Reconcile the query views of the provided query targets with the state from
     * persistence. Raises snapshots for any changes that affect the local
     * client and returns the updated state of all target's query data.
     */
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.synchronizeQueryViewsAndRaiseSnapshots = function (targets) {
        var _this = this;
        var p = Promise.resolve();
        var activeQueries = [];
        var newViewSnapshots = [];
        var _loop_1 = function (targetId) {
            p = p.then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var queryData, queryView, viewChange, query;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            queryView = this.queryViewsByTarget[targetId];
                            if (!queryView) return [3 /*break*/, 4];
                            // For queries that have a local View, we need to update their state
                            // in LocalStore (as the resume token and the snapshot version
                            // might have changed) and reconcile their views with the persisted
                            // state (the list of syncedDocuments may have gotten out of sync).
                            return [4 /*yield*/, this.localStore.releaseQuery(queryView.query, 
                                /*keepPersistedQueryData=*/ true)];
                        case 1:
                            // For queries that have a local View, we need to update their state
                            // in LocalStore (as the resume token and the snapshot version
                            // might have changed) and reconcile their views with the persisted
                            // state (the list of syncedDocuments may have gotten out of sync).
                            _a.sent();
                            return [4 /*yield*/, this.localStore.allocateQuery(queryView.query)];
                        case 2:
                            queryData = _a.sent();
                            return [4 /*yield*/, this.synchronizeViewAndComputeSnapshot(queryView)];
                        case 3:
                            viewChange = _a.sent();
                            if (viewChange.snapshot) {
                                newViewSnapshots.push(viewChange.snapshot);
                            }
                            return [3 /*break*/, 8];
                        case 4:
                            assert(this.isPrimary === true, 'A secondary tab should never have an active query without an active view.');
                            return [4 /*yield*/, this.localStore.getQueryForTarget(targetId)];
                        case 5:
                            query = _a.sent();
                            assert(!!query, "Query data for target " + targetId + " not found");
                            return [4 /*yield*/, this.localStore.allocateQuery(query)];
                        case 6:
                            queryData = _a.sent();
                            return [4 /*yield*/, this.initializeViewAndComputeSnapshot(queryData, 
                                /*current=*/ false)];
                        case 7:
                            _a.sent();
                            _a.label = 8;
                        case 8:
                            activeQueries.push(queryData);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        for (var _i = 0, targets_1 = targets; _i < targets_1.length; _i++) {
            var targetId = targets_1[_i];
            _loop_1(targetId);
        }
        return p.then(function () {
            _this.syncEngineListener.onWatchChange(newViewSnapshots);
            return activeQueries;
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.getActiveClients = function () {
        return this.localStore.getActiveClients();
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyTargetState = function (targetId, state, error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, queryView;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isPrimary) {
                            // If we receive a target state notification via WebStorage, we are
                            // either already secondary or another tab has taken the primary lease.
                            debug(LOG_TAG$9, 'Ignoring unexpected query state notification.');
                            return [2 /*return*/];
                        }
                        if (!this.queryViewsByTarget[targetId]) return [3 /*break*/, 5];
                        _a = state;
                        switch (_a) {
                            case 'current': return [3 /*break*/, 1];
                            case 'not-current': return [3 /*break*/, 1];
                            case 'rejected': return [3 /*break*/, 2];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        {
                            return [2 /*return*/, this.localStore.getNewDocumentChanges().then(function (changes) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var synthesizedRemoteEvent;
                                    return tslib_1.__generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                synthesizedRemoteEvent = RemoteEvent.createSynthesizedRemoteEventForCurrentChange(targetId, state === 'current');
                                                return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(changes, synthesizedRemoteEvent)];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }, function (err) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var activeTargets_2;
                                    return tslib_1.__generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!isDocumentChangeMissingError(err)) return [3 /*break*/, 2];
                                                activeTargets_2 = [];
                                                forEachNumber(this.queryViewsByTarget, function (target) {
                                                    return activeTargets_2.push(target);
                                                });
                                                return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets_2)];
                                            case 1:
                                                _a.sent();
                                                return [3 /*break*/, 3];
                                            case 2: throw err;
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); })];
                        }
                        _b.label = 2;
                    case 2:
                        queryView = this.queryViewsByTarget[targetId];
                        this.removeAndCleanupQuery(queryView);
                        return [4 /*yield*/, this.localStore.releaseQuery(queryView.query, 
                            /*keepPersistedQueryData=*/ true)];
                    case 3:
                        _b.sent();
                        this.syncEngineListener.onWatchError(queryView.query, error$$1);
                        return [3 /*break*/, 5];
                    case 4:
                        fail('Unexpected target state: ' + state);
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyActiveTargetsChange = function (added, removed) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _i, added_1, targetId, query, queryData, _loop_2, this_1, _a, removed_1, targetId;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isPrimary) {
                            return [2 /*return*/];
                        }
                        _i = 0, added_1 = added;
                        _b.label = 1;
                    case 1:
                        if (!(_i < added_1.length)) return [3 /*break*/, 6];
                        targetId = added_1[_i];
                        assert(!this.queryViewsByTarget[targetId], 'Trying to add an already active target');
                        return [4 /*yield*/, this.localStore.getQueryForTarget(targetId)];
                    case 2:
                        query = _b.sent();
                        assert(!!query, "Query data for active target " + targetId + " not found");
                        return [4 /*yield*/, this.localStore.allocateQuery(query)];
                    case 3:
                        queryData = _b.sent();
                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(queryData, 
                            /*current=*/ false)];
                    case 4:
                        _b.sent();
                        this.remoteStore.listen(queryData);
                        _b.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        _loop_2 = function (targetId) {
                            var queryView;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        queryView = this_1.queryViewsByTarget[targetId];
                                        if (!queryView) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this_1.localStore
                                                .releaseQuery(queryView.query, /*keepPersistedQueryData=*/ false)
                                                .then(function () {
                                                _this.remoteStore.unlisten(targetId);
                                                _this.removeAndCleanupQuery(queryView);
                                            })
                                                .catch(ignoreIfPrimaryLeaseLoss)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a = 0, removed_1 = removed;
                        _b.label = 7;
                    case 7:
                        if (!(_a < removed_1.length)) return [3 /*break*/, 10];
                        targetId = removed_1[_a];
                        return [5 /*yield**/, _loop_2(targetId)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9:
                        _a++;
                        return [3 /*break*/, 7];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
    // the online state.
    SyncEngine.prototype.enableNetwork = function () {
        this.localStore.setNetworkEnabled(true);
        return this.remoteStore.enableNetwork();
    };
    // PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
    // the online state.
    SyncEngine.prototype.disableNetwork = function () {
        this.localStore.setNetworkEnabled(false);
        return this.remoteStore.disableNetwork();
    };
    SyncEngine.prototype.getRemoteKeysForTarget = function (targetId) {
        var limboResolution = this.limboResolutionsByTarget[targetId];
        if (limboResolution && limboResolution.receivedDocument) {
            return documentKeySet().add(limboResolution.key);
        }
        else {
            return this.queryViewsByTarget[targetId]
                ? this.queryViewsByTarget[targetId].view.syncedDocuments
                : documentKeySet();
        }
    };
    return SyncEngine;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */
var User = /** @class */ (function () {
    function User(uid) {
        this.uid = uid;
    }
    User.prototype.isAuthenticated = function () {
        return this.uid != null;
    };
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */
    User.prototype.toKey = function () {
        if (this.isAuthenticated()) {
            return 'uid:' + this.uid;
        }
        else {
            return 'anonymous-user';
        }
    };
    User.prototype.isEqual = function (otherUser) {
        return otherUser.uid === this.uid;
    };
    /** A user with a null UID. */
    User.UNAUTHENTICATED = new User(null);
    // TODO(mikelehen): Look into getting a proper uid-equivalent for
    // non-FirebaseAuth providers.
    User.GOOGLE_CREDENTIALS = new User('google-credentials-uid');
    User.FIRST_PARTY = new User('first-party-uid');
    return User;
}());

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$10 = 'SharedClientState';
// The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
var CLIENT_STATE_KEY_PREFIX = 'firestore_clients';
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
//
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
var MUTATION_BATCH_KEY_PREFIX = 'firestore_mutations';
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
var QUERY_TARGET_KEY_PREFIX = 'firestore_targets';
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
var ONLINE_STATE_KEY_PREFIX = 'firestore_online_state';
// The WebStorage key prefix for the key that stores the last sequence number allocated. The key
// looks like 'firestore_sequence_number_<persistence_prefix>'.
var SEQUENCE_NUMBER_KEY_PREFIX = 'firestore_sequence_number';
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */
// Visible for testing
var MutationMetadata = /** @class */ (function () {
    function MutationMetadata(user, batchId, state, error$$1) {
        this.user = user;
        this.batchId = batchId;
        this.state = state;
        this.error = error$$1;
        assert((error$$1 !== undefined) === (state === 'rejected'), "MutationMetadata must contain an error iff state is 'rejected'");
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    MutationMetadata.fromWebStorageEntry = function (user, batchId, value) {
        var mutationBatch = JSON.parse(value);
        var validData = typeof mutationBatch === 'object' &&
            ['pending', 'acknowledged', 'rejected'].indexOf(mutationBatch.state) !==
                -1 &&
            (mutationBatch.error === undefined ||
                typeof mutationBatch.error === 'object');
        var firestoreError = undefined;
        if (validData && mutationBatch.error) {
            validData =
                typeof mutationBatch.error.message === 'string' &&
                    typeof mutationBatch.error.code === 'string';
            if (validData) {
                firestoreError = new FirestoreError(mutationBatch.error.code, mutationBatch.error.message);
            }
        }
        if (validData) {
            return new MutationMetadata(user, batchId, mutationBatch.state, firestoreError);
        }
        else {
            error(LOG_TAG$10, "Failed to parse mutation state for ID '" + batchId + "': " + value);
            return null;
        }
    };
    MutationMetadata.prototype.toWebStorageJSON = function () {
        var batchMetadata = {
            state: this.state,
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        if (this.error) {
            batchMetadata.error = {
                code: this.error.code,
                message: this.error.message
            };
        }
        return JSON.stringify(batchMetadata);
    };
    return MutationMetadata;
}());
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */
// Visible for testing
var QueryTargetMetadata = /** @class */ (function () {
    function QueryTargetMetadata(targetId, state, error$$1) {
        this.targetId = targetId;
        this.state = state;
        this.error = error$$1;
        assert((error$$1 !== undefined) === (state === 'rejected'), "QueryTargetMetadata must contain an error iff state is 'rejected'");
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    QueryTargetMetadata.fromWebStorageEntry = function (targetId, value) {
        var targetState = JSON.parse(value);
        var validData = typeof targetState === 'object' &&
            ['not-current', 'current', 'rejected'].indexOf(targetState.state) !==
                -1 &&
            (targetState.error === undefined ||
                typeof targetState.error === 'object');
        var firestoreError = undefined;
        if (validData && targetState.error) {
            validData =
                typeof targetState.error.message === 'string' &&
                    typeof targetState.error.code === 'string';
            if (validData) {
                firestoreError = new FirestoreError(targetState.error.code, targetState.error.message);
            }
        }
        if (validData) {
            return new QueryTargetMetadata(targetId, targetState.state, firestoreError);
        }
        else {
            error(LOG_TAG$10, "Failed to parse target state for ID '" + targetId + "': " + value);
            return null;
        }
    };
    QueryTargetMetadata.prototype.toWebStorageJSON = function () {
        var targetState = {
            state: this.state,
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        if (this.error) {
            targetState.error = {
                code: this.error.code,
                message: this.error.message
            };
        }
        return JSON.stringify(targetState);
    };
    return QueryTargetMetadata;
}());
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */
var RemoteClientState = /** @class */ (function () {
    function RemoteClientState(clientId, activeTargetIds) {
        this.clientId = clientId;
        this.activeTargetIds = activeTargetIds;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    RemoteClientState.fromWebStorageEntry = function (clientId, value) {
        var clientState = JSON.parse(value);
        var validData = typeof clientState === 'object' &&
            clientState.activeTargetIds instanceof Array;
        var activeTargetIdsSet = targetIdSet();
        for (var i = 0; validData && i < clientState.activeTargetIds.length; ++i) {
            validData = isSafeInteger(clientState.activeTargetIds[i]);
            activeTargetIdsSet = activeTargetIdsSet.add(clientState.activeTargetIds[i]);
        }
        if (validData) {
            return new RemoteClientState(clientId, activeTargetIdsSet);
        }
        else {
            error(LOG_TAG$10, "Failed to parse client data for instance '" + clientId + "': " + value);
            return null;
        }
    };
    return RemoteClientState;
}());
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */
var SharedOnlineState = /** @class */ (function () {
    function SharedOnlineState(clientId, onlineState) {
        this.clientId = clientId;
        this.onlineState = onlineState;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    SharedOnlineState.fromWebStorageEntry = function (value) {
        var onlineState = JSON.parse(value);
        var validData = typeof onlineState === 'object' &&
            OnlineState[onlineState.onlineState] !== undefined &&
            typeof onlineState.clientId === 'string';
        if (validData) {
            return new SharedOnlineState(onlineState.clientId, OnlineState[onlineState.onlineState]);
        }
        else {
            error(LOG_TAG$10, "Failed to parse online state: " + value);
            return null;
        }
    };
    return SharedOnlineState;
}());
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */
// Visible for testing.
var LocalClientState = /** @class */ (function () {
    function LocalClientState() {
        this.activeTargetIds = targetIdSet();
    }
    LocalClientState.prototype.addQueryTarget = function (targetId) {
        assert(!this.activeTargetIds.has(targetId), "Target with ID '" + targetId + "' already active.");
        this.activeTargetIds = this.activeTargetIds.add(targetId);
    };
    LocalClientState.prototype.removeQueryTarget = function (targetId) {
        this.activeTargetIds = this.activeTargetIds.delete(targetId);
    };
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */
    LocalClientState.prototype.toWebStorageJSON = function () {
        var data = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        return JSON.stringify(data);
    };
    return LocalClientState;
}());
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */
var WebStorageSharedClientState = /** @class */ (function () {
    function WebStorageSharedClientState(queue, platform, persistenceKey, localClientId, initialUser) {
        this.queue = queue;
        this.platform = platform;
        this.persistenceKey = persistenceKey;
        this.localClientId = localClientId;
        this.syncEngine = null;
        this.onlineStateHandler = null;
        this.sequenceNumberHandler = null;
        this.activeClients = {};
        this.storageListener = this.handleWebStorageEvent.bind(this);
        this.started = false;
        /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */
        this.earlyEvents = [];
        if (!WebStorageSharedClientState.isAvailable(this.platform)) {
            throw new FirestoreError(Code.UNIMPLEMENTED, 'LocalStorage is not available on this platform.');
        }
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        var escapedPersistenceKey = persistenceKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        this.storage = this.platform.window.localStorage;
        this.currentUser = initialUser;
        this.localClientStorageKey = this.toWebStorageClientStateKey(this.localClientId);
        this.sequenceNumberKey = SEQUENCE_NUMBER_KEY_PREFIX + "_" + persistenceKey;
        this.activeClients[this.localClientId] = new LocalClientState();
        this.clientStateKeyRe = new RegExp("^" + CLIENT_STATE_KEY_PREFIX + "_" + escapedPersistenceKey + "_([^_]*)$");
        this.mutationBatchKeyRe = new RegExp("^" + MUTATION_BATCH_KEY_PREFIX + "_" + escapedPersistenceKey + "_(\\d+)(?:_(.*))?$");
        this.queryTargetKeyRe = new RegExp("^" + QUERY_TARGET_KEY_PREFIX + "_" + escapedPersistenceKey + "_(\\d+)$");
        this.onlineStateKey = ONLINE_STATE_KEY_PREFIX + "_" + persistenceKey;
        // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.platform.window.addEventListener('storage', this.storageListener);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */
    WebStorageSharedClientState.isAvailable = function (platform) {
        return !!(platform.window && platform.window.localStorage != null);
    };
    WebStorageSharedClientState.prototype.start = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var existingClients, _i, existingClients_1, clientId, storageItem, clientState, onlineStateJSON, onlineState, _a, _b, event_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        assert(!this.started, 'WebStorageSharedClientState already started');
                        assert(this.syncEngine !== null, 'syncEngine property must be set before calling start()');
                        assert(this.onlineStateHandler !== null, 'onlineStateHandler property must be set before calling start()');
                        return [4 /*yield*/, this.syncEngine.getActiveClients()];
                    case 1:
                        existingClients = _c.sent();
                        for (_i = 0, existingClients_1 = existingClients; _i < existingClients_1.length; _i++) {
                            clientId = existingClients_1[_i];
                            if (clientId === this.localClientId) {
                                continue;
                            }
                            storageItem = this.getItem(this.toWebStorageClientStateKey(clientId));
                            if (storageItem) {
                                clientState = RemoteClientState.fromWebStorageEntry(clientId, storageItem);
                                if (clientState) {
                                    this.activeClients[clientState.clientId] = clientState;
                                }
                            }
                        }
                        this.persistClientState();
                        onlineStateJSON = this.storage.getItem(this.onlineStateKey);
                        if (onlineStateJSON) {
                            onlineState = this.fromWebStorageOnlineState(onlineStateJSON);
                            if (onlineState) {
                                this.handleOnlineStateEvent(onlineState);
                            }
                        }
                        for (_a = 0, _b = this.earlyEvents; _a < _b.length; _a++) {
                            event_1 = _b[_a];
                            this.handleWebStorageEvent(event_1);
                        }
                        this.earlyEvents = [];
                        // Register a window unload hook to remove the client metadata entry from
                        // WebStorage even if `shutdown()` was not called.
                        this.platform.window.addEventListener('unload', function () { return _this.shutdown(); });
                        this.started = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    WebStorageSharedClientState.prototype.writeSequenceNumber = function (sequenceNumber) {
        this.setItem(this.sequenceNumberKey, JSON.stringify(sequenceNumber));
    };
    WebStorageSharedClientState.prototype.getAllActiveQueryTargets = function () {
        var activeTargets = targetIdSet();
        forEach(this.activeClients, function (key, value) {
            activeTargets = activeTargets.unionWith(value.activeTargetIds);
        });
        return activeTargets;
    };
    WebStorageSharedClientState.prototype.isActiveQueryTarget = function (targetId) {
        // This is not using `obj.forEach` since `forEach` doesn't support early
        // return.
        for (var clientId in this.activeClients) {
            if (this.activeClients.hasOwnProperty(clientId)) {
                if (this.activeClients[clientId].activeTargetIds.has(targetId)) {
                    return true;
                }
            }
        }
        return false;
    };
    WebStorageSharedClientState.prototype.addPendingMutation = function (batchId) {
        this.persistMutationState(batchId, 'pending');
    };
    WebStorageSharedClientState.prototype.updateMutationState = function (batchId, state, error$$1) {
        this.persistMutationState(batchId, state, error$$1);
        // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.removeMutationState(batchId);
    };
    WebStorageSharedClientState.prototype.addLocalQueryTarget = function (targetId) {
        var queryState = 'not-current';
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(targetId)) {
            var storageItem = this.storage.getItem(this.toWebStorageQueryTargetMetadataKey(targetId));
            if (storageItem) {
                var metadata = QueryTargetMetadata.fromWebStorageEntry(targetId, storageItem);
                if (metadata) {
                    queryState = metadata.state;
                }
            }
        }
        this.localClientState.addQueryTarget(targetId);
        this.persistClientState();
        return queryState;
    };
    WebStorageSharedClientState.prototype.removeLocalQueryTarget = function (targetId) {
        this.localClientState.removeQueryTarget(targetId);
        this.persistClientState();
    };
    WebStorageSharedClientState.prototype.isLocalQueryTarget = function (targetId) {
        return this.localClientState.activeTargetIds.has(targetId);
    };
    WebStorageSharedClientState.prototype.clearQueryState = function (targetId) {
        this.removeItem(this.toWebStorageQueryTargetMetadataKey(targetId));
    };
    WebStorageSharedClientState.prototype.updateQueryState = function (targetId, state, error$$1) {
        this.persistQueryTargetState(targetId, state, error$$1);
    };
    WebStorageSharedClientState.prototype.handleUserChange = function (user, removedBatchIds, addedBatchIds) {
        var _this = this;
        removedBatchIds.forEach(function (batchId) {
            _this.removeMutationState(batchId);
        });
        this.currentUser = user;
        addedBatchIds.forEach(function (batchId) {
            _this.addPendingMutation(batchId);
        });
    };
    WebStorageSharedClientState.prototype.setOnlineState = function (onlineState) {
        this.persistOnlineState(onlineState);
    };
    WebStorageSharedClientState.prototype.shutdown = function () {
        if (this.started) {
            this.platform.window.removeEventListener('storage', this.storageListener);
            this.removeItem(this.localClientStorageKey);
            this.started = false;
        }
    };
    WebStorageSharedClientState.prototype.getItem = function (key) {
        var value = this.storage.getItem(key);
        debug(LOG_TAG$10, 'READ', key, value);
        return value;
    };
    WebStorageSharedClientState.prototype.setItem = function (key, value) {
        debug(LOG_TAG$10, 'SET', key, value);
        this.storage.setItem(key, value);
    };
    WebStorageSharedClientState.prototype.removeItem = function (key) {
        debug(LOG_TAG$10, 'REMOVE', key);
        this.storage.removeItem(key);
    };
    WebStorageSharedClientState.prototype.handleWebStorageEvent = function (event) {
        var _this = this;
        if (event.storageArea === this.storage) {
            debug(LOG_TAG$10, 'EVENT', event.key, event.newValue);
            if (event.key === this.localClientStorageKey) {
                error('Received WebStorage notification for local change. Another client might have ' +
                    'garbage-collected our state');
                return;
            }
            this.queue.enqueueAndForget(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var clientState, clientId, mutationMetadata, queryTargetMetadata, onlineState, sequenceNumber;
                return tslib_1.__generator(this, function (_a) {
                    if (!this.started) {
                        this.earlyEvents.push(event);
                        return [2 /*return*/];
                    }
                    if (event.key === null) {
                        return [2 /*return*/];
                    }
                    if (this.clientStateKeyRe.test(event.key)) {
                        if (event.newValue != null) {
                            clientState = this.fromWebStorageClientState(event.key, event.newValue);
                            if (clientState) {
                                return [2 /*return*/, this.handleClientStateEvent(clientState.clientId, clientState)];
                            }
                        }
                        else {
                            clientId = this.fromWebStorageClientStateKey(event.key);
                            return [2 /*return*/, this.handleClientStateEvent(clientId, null)];
                        }
                    }
                    else if (this.mutationBatchKeyRe.test(event.key)) {
                        if (event.newValue !== null) {
                            mutationMetadata = this.fromWebStorageMutationMetadata(event.key, event.newValue);
                            if (mutationMetadata) {
                                return [2 /*return*/, this.handleMutationBatchEvent(mutationMetadata)];
                            }
                        }
                    }
                    else if (this.queryTargetKeyRe.test(event.key)) {
                        if (event.newValue !== null) {
                            queryTargetMetadata = this.fromWebStorageQueryTargetMetadata(event.key, event.newValue);
                            if (queryTargetMetadata) {
                                return [2 /*return*/, this.handleQueryTargetEvent(queryTargetMetadata)];
                            }
                        }
                    }
                    else if (event.key === this.onlineStateKey) {
                        if (event.newValue !== null) {
                            onlineState = this.fromWebStorageOnlineState(event.newValue);
                            if (onlineState) {
                                return [2 /*return*/, this.handleOnlineStateEvent(onlineState)];
                            }
                        }
                    }
                    else if (event.key === this.sequenceNumberKey) {
                        assert(!!this.sequenceNumberHandler, 'Missing sequenceNumberHandler');
                        sequenceNumber = fromWebStorageSequenceNumber(event.newValue);
                        if (sequenceNumber !== ListenSequence.INVALID) {
                            this.sequenceNumberHandler(sequenceNumber);
                        }
                    }
                    return [2 /*return*/];
                });
            }); });
        }
    };
    Object.defineProperty(WebStorageSharedClientState.prototype, "localClientState", {
        get: function () {
            return this.activeClients[this.localClientId];
        },
        enumerable: true,
        configurable: true
    });
    WebStorageSharedClientState.prototype.persistClientState = function () {
        this.setItem(this.localClientStorageKey, this.localClientState.toWebStorageJSON());
    };
    WebStorageSharedClientState.prototype.persistMutationState = function (batchId, state, error$$1) {
        var mutationState = new MutationMetadata(this.currentUser, batchId, state, error$$1);
        var mutationKey = this.toWebStorageMutationBatchKey(batchId);
        this.setItem(mutationKey, mutationState.toWebStorageJSON());
    };
    WebStorageSharedClientState.prototype.removeMutationState = function (batchId) {
        var mutationKey = this.toWebStorageMutationBatchKey(batchId);
        this.removeItem(mutationKey);
    };
    WebStorageSharedClientState.prototype.persistOnlineState = function (onlineState) {
        var entry = {
            clientId: this.localClientId,
            onlineState: OnlineState[onlineState]
        };
        this.storage.setItem(this.onlineStateKey, JSON.stringify(entry));
    };
    WebStorageSharedClientState.prototype.persistQueryTargetState = function (targetId, state, error$$1) {
        var targetKey = this.toWebStorageQueryTargetMetadataKey(targetId);
        var targetMetadata = new QueryTargetMetadata(targetId, state, error$$1);
        this.setItem(targetKey, targetMetadata.toWebStorageJSON());
    };
    /** Assembles the key for a client state in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageClientStateKey = function (clientId) {
        assert(clientId.indexOf('_') === -1, "Client key cannot contain '_', but was '" + clientId + "'");
        return CLIENT_STATE_KEY_PREFIX + "_" + this.persistenceKey + "_" + clientId;
    };
    /** Assembles the key for a query state in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageQueryTargetMetadataKey = function (targetId) {
        return QUERY_TARGET_KEY_PREFIX + "_" + this.persistenceKey + "_" + targetId;
    };
    /** Assembles the key for a mutation batch in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageMutationBatchKey = function (batchId) {
        var mutationKey = MUTATION_BATCH_KEY_PREFIX + "_" + this.persistenceKey + "_" + batchId;
        if (this.currentUser.isAuthenticated()) {
            mutationKey += "_" + this.currentUser.uid;
        }
        return mutationKey;
    };
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */
    WebStorageSharedClientState.prototype.fromWebStorageClientStateKey = function (key) {
        var match = this.clientStateKeyRe.exec(key);
        return match ? match[1] : null;
    };
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageClientState = function (key, value) {
        var clientId = this.fromWebStorageClientStateKey(key);
        assert(clientId !== null, "Cannot parse client state key '" + key + "'");
        return RemoteClientState.fromWebStorageEntry(clientId, value);
    };
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageMutationMetadata = function (key, value) {
        var match = this.mutationBatchKeyRe.exec(key);
        assert(match !== null, "Cannot parse mutation batch key '" + key + "'");
        var batchId = Number(match[1]);
        var userId = match[2] !== undefined ? match[2] : null;
        return MutationMetadata.fromWebStorageEntry(new User(userId), batchId, value);
    };
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageQueryTargetMetadata = function (key, value) {
        var match = this.queryTargetKeyRe.exec(key);
        assert(match !== null, "Cannot parse query target key '" + key + "'");
        var targetId = Number(match[1]);
        return QueryTargetMetadata.fromWebStorageEntry(targetId, value);
    };
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageOnlineState = function (value) {
        return SharedOnlineState.fromWebStorageEntry(value);
    };
    WebStorageSharedClientState.prototype.handleMutationBatchEvent = function (mutationBatch) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (mutationBatch.user.uid !== this.currentUser.uid) {
                    debug(LOG_TAG$10, "Ignoring mutation for non-active user " + mutationBatch.user.uid);
                    return [2 /*return*/];
                }
                return [2 /*return*/, this.syncEngine.applyBatchState(mutationBatch.batchId, mutationBatch.state, mutationBatch.error)];
            });
        });
    };
    WebStorageSharedClientState.prototype.handleQueryTargetEvent = function (targetMetadata) {
        return this.syncEngine.applyTargetState(targetMetadata.targetId, targetMetadata.state, targetMetadata.error);
    };
    WebStorageSharedClientState.prototype.handleClientStateEvent = function (clientId, clientState) {
        var _this = this;
        var existingTargets = this.getAllActiveQueryTargets();
        if (clientState) {
            this.activeClients[clientId] = clientState;
        }
        else {
            delete this.activeClients[clientId];
        }
        var newTargets = this.getAllActiveQueryTargets();
        var addedTargets = [];
        var removedTargets = [];
        newTargets.forEach(function (targetId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!existingTargets.has(targetId)) {
                    addedTargets.push(targetId);
                }
                return [2 /*return*/];
            });
        }); });
        existingTargets.forEach(function (targetId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!newTargets.has(targetId)) {
                    removedTargets.push(targetId);
                }
                return [2 /*return*/];
            });
        }); });
        return this.syncEngine.applyActiveTargetsChange(addedTargets, removedTargets);
    };
    WebStorageSharedClientState.prototype.handleOnlineStateEvent = function (onlineState) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        if (this.activeClients[onlineState.clientId]) {
            this.onlineStateHandler(onlineState.onlineState);
        }
    };
    return WebStorageSharedClientState;
}());
function fromWebStorageSequenceNumber(seqString) {
    var sequenceNumber = ListenSequence.INVALID;
    if (seqString != null) {
        try {
            var parsed = JSON.parse(seqString);
            assert(typeof parsed === 'number', 'Found non-numeric sequence number');
            sequenceNumber = parsed;
        }
        catch (e) {
            error(LOG_TAG$10, 'Failed to read sequence number from WebStorage', e);
        }
    }
    return sequenceNumber;
}
/**
 * `MemorySharedClientState` is a simple implementation of SharedClientState for
 * clients using memory persistence. The state in this class remains fully
 * isolated and no synchronization is performed.
 */
var MemorySharedClientState = /** @class */ (function () {
    function MemorySharedClientState() {
        this.localState = new LocalClientState();
        this.queryState = {};
        this.syncEngine = null;
        this.onlineStateHandler = null;
        this.sequenceNumberHandler = null;
    }
    MemorySharedClientState.prototype.addPendingMutation = function (batchId) {
        // No op.
    };
    MemorySharedClientState.prototype.updateMutationState = function (batchId, state, error$$1) {
        // No op.
    };
    MemorySharedClientState.prototype.addLocalQueryTarget = function (targetId) {
        this.localState.addQueryTarget(targetId);
        return this.queryState[targetId] || 'not-current';
    };
    MemorySharedClientState.prototype.updateQueryState = function (targetId, state, error$$1) {
        this.queryState[targetId] = state;
    };
    MemorySharedClientState.prototype.removeLocalQueryTarget = function (targetId) {
        this.localState.removeQueryTarget(targetId);
    };
    MemorySharedClientState.prototype.isLocalQueryTarget = function (targetId) {
        return this.localState.activeTargetIds.has(targetId);
    };
    MemorySharedClientState.prototype.clearQueryState = function (targetId) {
        delete this.queryState[targetId];
    };
    MemorySharedClientState.prototype.getAllActiveQueryTargets = function () {
        return this.localState.activeTargetIds;
    };
    MemorySharedClientState.prototype.isActiveQueryTarget = function (targetId) {
        return this.localState.activeTargetIds.has(targetId);
    };
    MemorySharedClientState.prototype.start = function () {
        this.localState = new LocalClientState();
        return Promise.resolve();
    };
    MemorySharedClientState.prototype.handleUserChange = function (user, removedBatchIds, addedBatchIds) {
        // No op.
    };
    MemorySharedClientState.prototype.setOnlineState = function (onlineState) {
        // No op.
    };
    MemorySharedClientState.prototype.shutdown = function () { };
    MemorySharedClientState.prototype.writeSequenceNumber = function (sequenceNumber) { };
    return MemorySharedClientState;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$11 = 'FirestoreClient';
/** The DOMException code for an aborted operation. */
var DOM_EXCEPTION_ABORTED = 20;
/** The DOMException code for quota exceeded. */
var DOM_EXCEPTION_QUOTA_EXCEEDED = 22;
var IndexedDbPersistenceSettings = /** @class */ (function () {
    function IndexedDbPersistenceSettings(cacheSizeBytes, experimentalTabSynchronization) {
        this.cacheSizeBytes = cacheSizeBytes;
        this.experimentalTabSynchronization = experimentalTabSynchronization;
    }
    IndexedDbPersistenceSettings.prototype.lruParams = function () {
        return LruParams.withCacheSize(this.cacheSizeBytes);
    };
    return IndexedDbPersistenceSettings;
}());
var MemoryPersistenceSettings = /** @class */ (function () {
    function MemoryPersistenceSettings() {
    }
    return MemoryPersistenceSettings;
}());
/**
 * FirestoreClient is a top-level class that constructs and owns all of the
 * pieces of the client SDK architecture. It is responsible for creating the
 * async queue that is shared by all of the other components in the system.
 */
var FirestoreClient = /** @class */ (function () {
    function FirestoreClient(platform, databaseInfo, credentials, 
    /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */
    asyncQueue) {
        this.platform = platform;
        this.databaseInfo = databaseInfo;
        this.credentials = credentials;
        this.asyncQueue = asyncQueue;
        this.clientId = AutoId.newId();
    }
    /**
     * Starts up the FirestoreClient, returning only whether or not enabling
     * persistence succeeded.
     *
     * The intent here is to "do the right thing" as far as users are concerned.
     * Namely, in cases where offline persistence is requested and possible,
     * enable it, but otherwise fall back to persistence disabled. For the most
     * part we expect this to succeed one way or the other so we don't expect our
     * users to actually wait on the firestore.enablePersistence Promise since
     * they generally won't care.
     *
     * Of course some users actually do care about whether or not persistence
     * was successfully enabled, so the Promise returned from this method
     * indicates this outcome.
     *
     * This presents a problem though: even before enablePersistence resolves or
     * rejects, users may have made calls to e.g. firestore.collection() which
     * means that the FirestoreClient in there will be available and will be
     * enqueuing actions on the async queue.
     *
     * Meanwhile any failure of an operation on the async queue causes it to
     * panic and reject any further work, on the premise that unhandled errors
     * are fatal.
     *
     * Consequently the fallback is handled internally here in start, and if the
     * fallback succeeds we signal success to the async queue even though the
     * start() itself signals failure.
     *
     * @param persistenceSettings Settings object to configure offline
     *     persistence.
     * @returns A deferred result indicating the user-visible result of enabling
     *     offline persistence. This method will reject this if IndexedDB fails to
     *     start for any reason. If usePersistence is false this is
     *     unconditionally resolved.
     */
    FirestoreClient.prototype.start = function (persistenceSettings) {
        var _this = this;
        // We defer our initialization until we get the current user from
        // setChangeListener(). We block the async queue until we got the initial
        // user and the initialization is completed. This will prevent any scheduled
        // work from happening before initialization is completed.
        //
        // If initializationDone resolved then the FirestoreClient is in a usable
        // state.
        var initializationDone = new Deferred();
        // If usePersistence is true, certain classes of errors while starting are
        // recoverable but only by falling back to persistence disabled.
        //
        // If there's an error in the first case but not in recovery we cannot
        // reject the promise blocking the async queue because this will cause the
        // async queue to panic.
        var persistenceResult = new Deferred();
        var initialized = false;
        this.credentials.setChangeListener(function (user) {
            if (!initialized) {
                initialized = true;
                _this.initializePersistence(persistenceSettings, persistenceResult, user)
                    .then(function (maybeLruGc) { return _this.initializeRest(user, maybeLruGc); })
                    .then(initializationDone.resolve, initializationDone.reject);
            }
            else {
                _this.asyncQueue.enqueueAndForget(function () {
                    return _this.handleCredentialChange(user);
                });
            }
        });
        // Block the async queue until initialization is done
        this.asyncQueue.enqueueAndForget(function () {
            return initializationDone.promise;
        });
        // Return only the result of enabling persistence. Note that this does not
        // need to await the completion of initializationDone because the result of
        // this method should not reflect any other kind of failure to start.
        return persistenceResult.promise;
    };
    /** Enables the network connection and requeues all pending operations. */
    FirestoreClient.prototype.enableNetwork = function () {
        var _this = this;
        return this.asyncQueue.enqueue(function () {
            return _this.syncEngine.enableNetwork();
        });
    };
    /**
     * Initializes persistent storage, attempting to use IndexedDB if
     * usePersistence is true or memory-only if false.
     *
     * If IndexedDB fails because it's already open in another tab or because the
     * platform can't possibly support our implementation then this method rejects
     * the persistenceResult and falls back on memory-only persistence.
     *
     * @param persistenceSettings Settings object to configure offline persistence
     * @param persistenceResult A deferred result indicating the user-visible
     *     result of enabling offline persistence. This method will reject this if
     *     IndexedDB fails to start for any reason. If usePersistence is false
     *     this is unconditionally resolved.
     * @returns a Promise indicating whether or not initialization should
     *     continue, i.e. that one of the persistence implementations actually
     *     succeeded.
     */
    FirestoreClient.prototype.initializePersistence = function (persistenceSettings, persistenceResult, user) {
        var _this = this;
        if (persistenceSettings instanceof IndexedDbPersistenceSettings) {
            return this.startIndexedDbPersistence(user, persistenceSettings)
                .then(function (maybeLruGc) {
                persistenceResult.resolve();
                return maybeLruGc;
            })
                .catch(function (error$$1) {
                // Regardless of whether or not the retry succeeds, from an user
                // perspective, offline persistence has failed.
                persistenceResult.reject(error$$1);
                // An unknown failure on the first stage shuts everything down.
                if (!_this.canFallback(error$$1)) {
                    throw error$$1;
                }
                console.warn('Error enabling offline storage. Falling back to' +
                    ' storage disabled: ' +
                    error$$1);
                return _this.startMemoryPersistence();
            });
        }
        else {
            // When usePersistence == false, enabling offline persistence is defined
            // to unconditionally succeed. This allows start() to have the same
            // signature for both cases, despite the fact that the returned promise
            // is only used in the enablePersistence call.
            persistenceResult.resolve();
            return this.startMemoryPersistence();
        }
    };
    /**
     * Decides whether the provided error allows us to gracefully disable
     * persistence (as opposed to crashing the client).
     */
    FirestoreClient.prototype.canFallback = function (error$$1) {
        if (error$$1 instanceof FirestoreError) {
            return (error$$1.code === Code.FAILED_PRECONDITION ||
                error$$1.code === Code.UNIMPLEMENTED);
        }
        else if (typeof DOMException !== 'undefined' &&
            error$$1 instanceof DOMException) {
            // We fall back to memory persistence if we cannot write the primary
            // lease. This can happen can during a schema migration, or if we run out
            // of quota when we try to write the primary lease.
            // For both the `QuotaExceededError` and the  `AbortError`, it is safe to
            // fall back to memory persistence since all modifications to IndexedDb
            // failed to commit.
            return (error$$1.code === DOM_EXCEPTION_QUOTA_EXCEEDED ||
                error$$1.code === DOM_EXCEPTION_ABORTED);
        }
        return true;
    };
    /**
     * Starts IndexedDB-based persistence.
     *
     * @returns A promise indicating success or failure.
     */
    FirestoreClient.prototype.startIndexedDbPersistence = function (user, settings) {
        var _this = this;
        // TODO(http://b/33384523): For now we just disable garbage collection
        // when persistence is enabled.
        var storagePrefix = IndexedDbPersistence.buildStoragePrefix(this.databaseInfo);
        // Opt to use proto3 JSON in case the platform doesn't support Uint8Array.
        var serializer = new JsonProtoSerializer(this.databaseInfo.databaseId, {
            useProto3Json: true
        });
        return Promise.resolve().then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var persistence, lruParams;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (settings.experimentalTabSynchronization &&
                            !WebStorageSharedClientState.isAvailable(this.platform)) {
                            throw new FirestoreError(Code.UNIMPLEMENTED, 'IndexedDB persistence is only available on platforms that support LocalStorage.');
                        }
                        lruParams = settings.lruParams();
                        if (!settings.experimentalTabSynchronization) return [3 /*break*/, 2];
                        this.sharedClientState = new WebStorageSharedClientState(this.asyncQueue, this.platform, storagePrefix, this.clientId, user);
                        return [4 /*yield*/, IndexedDbPersistence.createMultiClientIndexedDbPersistence(storagePrefix, this.clientId, this.platform, this.asyncQueue, serializer, lruParams, { sequenceNumberSyncer: this.sharedClientState })];
                    case 1:
                        persistence = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        this.sharedClientState = new MemorySharedClientState();
                        return [4 /*yield*/, IndexedDbPersistence.createIndexedDbPersistence(storagePrefix, this.clientId, this.platform, this.asyncQueue, serializer, lruParams)];
                    case 3:
                        persistence = _a.sent();
                        _a.label = 4;
                    case 4:
                        this.persistence = persistence;
                        return [2 /*return*/, persistence.referenceDelegate.garbageCollector];
                }
            });
        }); });
    };
    /**
     * Starts Memory-backed persistence. In practice this cannot fail.
     *
     * @returns A promise that will successfully resolve.
     */
    FirestoreClient.prototype.startMemoryPersistence = function () {
        this.persistence = MemoryPersistence.createEagerPersistence(this.clientId);
        this.sharedClientState = new MemorySharedClientState();
        return Promise.resolve(null);
    };
    /**
     * Initializes the rest of the FirestoreClient, assuming the initial user
     * has been obtained from the credential provider and some persistence
     * implementation is available in this.persistence.
     */
    FirestoreClient.prototype.initializeRest = function (user, maybeLruGc) {
        var _this = this;
        debug(LOG_TAG$11, 'Initializing. user=', user.uid);
        return this.platform
            .loadConnection(this.databaseInfo)
            .then(function (connection) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var serializer, datastore, remoteStoreOnlineStateChangedHandler, sharedClientStateOnlineStateChangedHandler;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.localStore = new LocalStore(this.persistence, user);
                        if (maybeLruGc) {
                            // We're running LRU Garbage collection. Set up the scheduler.
                            this.lruScheduler = new LruScheduler(maybeLruGc, this.asyncQueue, this.localStore);
                        }
                        serializer = this.platform.newSerializer(this.databaseInfo.databaseId);
                        datastore = new Datastore(this.asyncQueue, connection, this.credentials, serializer);
                        remoteStoreOnlineStateChangedHandler = function (onlineState) {
                            return _this.syncEngine.applyOnlineStateChange(onlineState, OnlineStateSource.RemoteStore);
                        };
                        sharedClientStateOnlineStateChangedHandler = function (onlineState) {
                            return _this.syncEngine.applyOnlineStateChange(onlineState, OnlineStateSource.SharedClientState);
                        };
                        this.remoteStore = new RemoteStore(this.localStore, datastore, this.asyncQueue, remoteStoreOnlineStateChangedHandler);
                        this.syncEngine = new SyncEngine(this.localStore, this.remoteStore, this.sharedClientState, user);
                        this.sharedClientState.onlineStateHandler = sharedClientStateOnlineStateChangedHandler;
                        // Set up wiring between sync engine and other components
                        this.remoteStore.syncEngine = this.syncEngine;
                        this.sharedClientState.syncEngine = this.syncEngine;
                        this.eventMgr = new EventManager(this.syncEngine);
                        // PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
                        return [4 /*yield*/, this.sharedClientState.start()];
                    case 1:
                        // PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
                        _a.sent();
                        return [4 /*yield*/, this.remoteStore.start()];
                    case 2:
                        _a.sent();
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return [4 /*yield*/, this.persistence.setPrimaryStateListener(function (isPrimary) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.syncEngine.applyPrimaryState(isPrimary)];
                                        case 1:
                                            _a.sent();
                                            if (this.lruScheduler) {
                                                if (isPrimary && !this.lruScheduler.started) {
                                                    this.lruScheduler.start();
                                                }
                                                else if (!isPrimary) {
                                                    this.lruScheduler.stop();
                                                }
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 3:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    FirestoreClient.prototype.handleCredentialChange = function (user) {
        this.asyncQueue.verifyOperationInProgress();
        debug(LOG_TAG$11, 'Credential Changed. Current user: ' + user.uid);
        return this.syncEngine.handleCredentialChange(user);
    };
    /** Disables the network connection. Pending operations will not complete. */
    FirestoreClient.prototype.disableNetwork = function () {
        var _this = this;
        return this.asyncQueue.enqueue(function () {
            return _this.syncEngine.disableNetwork();
        });
    };
    FirestoreClient.prototype.shutdown = function (options) {
        var _this = this;
        return this.asyncQueue.enqueue(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
                        if (this.lruScheduler) {
                            this.lruScheduler.stop();
                        }
                        return [4 /*yield*/, this.remoteStore.shutdown()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.sharedClientState.shutdown()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.persistence.shutdown(options && options.purgePersistenceWithDataLoss)];
                    case 3:
                        _a.sent();
                        // `removeChangeListener` must be called after shutting down the
                        // RemoteStore as it will prevent the RemoteStore from retrieving
                        // auth tokens.
                        this.credentials.removeChangeListener();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    FirestoreClient.prototype.listen = function (query, observer, options) {
        var _this = this;
        var listener = new QueryListener(query, observer, options);
        this.asyncQueue.enqueueAndForget(function () {
            return _this.eventMgr.listen(listener);
        });
        return listener;
    };
    FirestoreClient.prototype.unlisten = function (listener) {
        var _this = this;
        this.asyncQueue.enqueueAndForget(function () {
            return _this.eventMgr.unlisten(listener);
        });
    };
    FirestoreClient.prototype.getDocumentFromLocalCache = function (docKey) {
        var _this = this;
        return this.asyncQueue
            .enqueue(function () {
            return _this.localStore.readDocument(docKey);
        })
            .then(function (maybeDoc) {
            if (maybeDoc instanceof Document) {
                return maybeDoc;
            }
            else if (maybeDoc instanceof NoDocument) {
                return null;
            }
            else {
                throw new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from cache. (However, this document may ' +
                    "exist on the server. Run again without setting 'source' in " +
                    'the GetOptions to attempt to retrieve the document from the ' +
                    'server.)');
            }
        });
    };
    FirestoreClient.prototype.getDocumentsFromLocalCache = function (query) {
        var _this = this;
        return this.asyncQueue
            .enqueue(function () {
            return _this.localStore.executeQuery(query);
        })
            .then(function (docs) {
            var remoteKeys = documentKeySet();
            var view = new View(query, remoteKeys);
            var viewDocChanges = view.computeDocChanges(docs);
            return view.applyChanges(viewDocChanges, 
            /* updateLimboDocuments= */ false).snapshot;
        });
    };
    FirestoreClient.prototype.write = function (mutations) {
        var _this = this;
        var deferred = new Deferred();
        this.asyncQueue.enqueueAndForget(function () {
            return _this.syncEngine.write(mutations, deferred);
        });
        return deferred.promise;
    };
    FirestoreClient.prototype.databaseId = function () {
        return this.databaseInfo.databaseId;
    };
    FirestoreClient.prototype.transaction = function (updateFunction) {
        var _this = this;
        // We have to wait for the async queue to be sure syncEngine is initialized.
        return this.asyncQueue
            .enqueue(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/];
        }); }); })
            .then(function () { return _this.syncEngine.runTransaction(updateFunction); });
    };
    return FirestoreClient;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */
var AsyncObserver = /** @class */ (function () {
    function AsyncObserver(observer) {
        this.observer = observer;
        /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */
        this.muted = false;
    }
    AsyncObserver.prototype.next = function (value) {
        this.scheduleEvent(this.observer.next, value);
    };
    AsyncObserver.prototype.error = function (error) {
        this.scheduleEvent(this.observer.error, error);
    };
    AsyncObserver.prototype.mute = function () {
        this.muted = true;
    };
    AsyncObserver.prototype.scheduleEvent = function (eventHandler, event) {
        var _this = this;
        if (!this.muted) {
            setTimeout(function () {
                if (!_this.muted) {
                    eventHandler(event);
                }
            }, 0);
        }
    };
    return AsyncObserver;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
// tslint:disable:strip-private-property-underscore
/**
 * A FieldPath refers to a field in a document. The path may consist of a single
 * field name (referring to a top-level field in the document), or a list of
 * field names (referring to a nested field in the document).
 */
var FieldPath$1 = /** @class */ (function () {
    /**
     * Creates a FieldPath from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames A list of field names.
     */
    function FieldPath$$1() {
        var fieldNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fieldNames[_i] = arguments[_i];
        }
        validateNamedArrayAtLeastNumberOfElements('FieldPath', fieldNames, 'fieldNames', 1);
        for (var i = 0; i < fieldNames.length; ++i) {
            validateArgType('FieldPath', 'string', i, fieldNames[i]);
            if (fieldNames[i].length === 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). " +
                    'Field names must not be empty.');
            }
        }
        this._internalPath = new FieldPath(fieldNames);
    }
    FieldPath$$1.documentId = function () {
        return FieldPath$$1._DOCUMENT_ID;
    };
    FieldPath$$1.prototype.isEqual = function (other) {
        if (!(other instanceof FieldPath$$1)) {
            throw invalidClassError('isEqual', 'FieldPath', 1, other);
        }
        return this._internalPath.isEqual(other._internalPath);
    };
    /**
     * Internal Note: The backend doesn't technically support querying by
     * document ID. Instead it queries by the entire document name (full path
     * included), but in the cases we currently support documentId(), the net
     * effect is the same.
     */
    FieldPath$$1._DOCUMENT_ID = new FieldPath$$1(FieldPath.keyField().canonicalString());
    return FieldPath$$1;
}());
/**
 * Matches any characters in a field path string that are reserved.
 */
var RESERVED = new RegExp('[~\\*/\\[\\]]');
/**
 * Parses a field path string into a FieldPath, treating dots as separators.
 */
function fromDotSeparatedString(path) {
    var found = path.search(RESERVED);
    if (found >= 0) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not contain " +
            "'~', '*', '/', '[', or ']'");
    }
    try {
        return new (FieldPath$1.bind.apply(FieldPath$1, [void 0].concat(path.split('.'))))();
    }
    catch (e) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, " +
            "begin with '.', end with '.', or contain '..'");
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OAuthToken = /** @class */ (function () {
    function OAuthToken(value, user) {
        this.user = user;
        this.type = 'OAuth';
        this.authHeaders = { Authorization: "Bearer " + value };
    }
    return OAuthToken;
}());
/** A CredentialsProvider that always yields an empty token. */
var EmptyCredentialsProvider = /** @class */ (function () {
    function EmptyCredentialsProvider() {
        /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */
        this.changeListener = null;
    }
    EmptyCredentialsProvider.prototype.getToken = function () {
        return Promise.resolve(null);
    };
    EmptyCredentialsProvider.prototype.invalidateToken = function () { };
    EmptyCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        assert(!this.changeListener, 'Can only call setChangeListener() once.');
        this.changeListener = changeListener;
        // Fire with initial user.
        changeListener(User.UNAUTHENTICATED);
    };
    EmptyCredentialsProvider.prototype.removeChangeListener = function () {
        assert(this.changeListener !== null, 'removeChangeListener() when no listener registered');
        this.changeListener = null;
    };
    return EmptyCredentialsProvider;
}());
var FirebaseCredentialsProvider = /** @class */ (function () {
    function FirebaseCredentialsProvider(app) {
        var _this = this;
        this.app = app;
        /**
         * The auth token listener registered with FirebaseApp, retained here so we
         * can unregister it.
         */
        this.tokenListener = null;
        /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */
        this.tokenCounter = 0;
        /** The listener registered with setChangeListener(). */
        this.changeListener = null;
        this.forceRefresh = false;
        this.tokenListener = function () {
            _this.tokenCounter++;
            _this.currentUser = _this.getUser();
            if (_this.changeListener) {
                _this.changeListener(_this.currentUser);
            }
        };
        this.tokenCounter = 0;
        // Will fire at least once where we set this.currentUser
        this.app.INTERNAL.addAuthTokenListener(this.tokenListener);
    }
    FirebaseCredentialsProvider.prototype.getToken = function () {
        var _this = this;
        assert(this.tokenListener != null, 'getToken cannot be called after listener removed.');
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        var initialTokenCounter = this.tokenCounter;
        var forceRefresh = this.forceRefresh;
        this.forceRefresh = false;
        return this.app.INTERNAL.getToken(forceRefresh).then(function (tokenData) {
            // Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            if (_this.tokenCounter !== initialTokenCounter) {
                throw new FirestoreError(Code.ABORTED, 'getToken aborted due to token change.');
            }
            else {
                if (tokenData) {
                    assert(typeof tokenData.accessToken === 'string', 'Invalid tokenData returned from getToken():' + tokenData);
                    return new OAuthToken(tokenData.accessToken, _this.currentUser);
                }
                else {
                    return null;
                }
            }
        });
    };
    FirebaseCredentialsProvider.prototype.invalidateToken = function () {
        this.forceRefresh = true;
    };
    FirebaseCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        assert(!this.changeListener, 'Can only call setChangeListener() once.');
        this.changeListener = changeListener;
        // Fire the initial event, but only if we received the initial user
        if (this.currentUser) {
            changeListener(this.currentUser);
        }
    };
    FirebaseCredentialsProvider.prototype.removeChangeListener = function () {
        assert(this.tokenListener != null, 'removeChangeListener() called twice');
        assert(this.changeListener !== null, 'removeChangeListener() called when no listener registered');
        this.app.INTERNAL.removeAuthTokenListener(this.tokenListener);
        this.tokenListener = null;
        this.changeListener = null;
    };
    FirebaseCredentialsProvider.prototype.getUser = function () {
        var currentUid = this.app.INTERNAL.getUid();
        assert(currentUid === null || typeof currentUid === 'string', 'Received invalid UID: ' + currentUid);
        return new User(currentUid);
    };
    return FirebaseCredentialsProvider;
}());
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * TODO(b/33147818) this implementation violates the current assumption that
 * tokens are immutable.  We need to either revisit this assumption or come
 * up with some way for FPA to use the listen/unlisten interface.
 */
var FirstPartyToken = /** @class */ (function () {
    function FirstPartyToken(gapi, sessionIndex) {
        this.gapi = gapi;
        this.sessionIndex = sessionIndex;
        this.type = 'FirstParty';
        this.user = User.FIRST_PARTY;
        assert(this.gapi &&
            this.gapi['auth'] &&
            this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
    }
    Object.defineProperty(FirstPartyToken.prototype, "authHeaders", {
        get: function () {
            return {
                Authorization: this.gapi['auth']['getAuthHeaderValueForFirstParty']([]),
                'X-Goog-AuthUser': this.sessionIndex
            };
        },
        enumerable: true,
        configurable: true
    });
    return FirstPartyToken;
}());
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */
var FirstPartyCredentialsProvider = /** @class */ (function () {
    function FirstPartyCredentialsProvider(gapi, sessionIndex) {
        this.gapi = gapi;
        this.sessionIndex = sessionIndex;
        assert(this.gapi &&
            this.gapi['auth'] &&
            this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
    }
    FirstPartyCredentialsProvider.prototype.getToken = function () {
        return Promise.resolve(new FirstPartyToken(this.gapi, this.sessionIndex));
    };
    // TODO(33108925): can someone switch users w/o a page refresh?
    // TODO(33110621): need to understand token/session lifecycle
    FirstPartyCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        // Fire with initial uid.
        changeListener(User.FIRST_PARTY);
    };
    FirstPartyCredentialsProvider.prototype.removeChangeListener = function () { };
    FirstPartyCredentialsProvider.prototype.invalidateToken = function () { };
    return FirstPartyCredentialsProvider;
}());
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */
function makeCredentialsProvider(credentials) {
    if (!credentials) {
        return new EmptyCredentialsProvider();
    }
    switch (credentials.type) {
        case 'gapi':
            return new FirstPartyCredentialsProvider(credentials.client, credentials.sessionIndex || '0');
        case 'provider':
            return credentials.client;
        default:
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'makeCredentialsProvider failed due to invalid credential type');
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isPartialObserver(obj) {
    return implementsAnyMethods(obj, ['next', 'error', 'complete']);
}
/**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    var object = obj;
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in object && typeof object[method] === 'function') {
            return true;
        }
    }
    return false;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An opaque base class for FieldValue sentinel objects in our public API,
 * with public static methods for creating said sentinel objects.
 */
// tslint:disable-next-line:class-as-namespace  We use this as a base class.
var FieldValueImpl = /** @class */ (function () {
    function FieldValueImpl(_methodName) {
        this._methodName = _methodName;
    }
    FieldValueImpl.delete = function () {
        return DeleteFieldValueImpl.instance;
    };
    FieldValueImpl.serverTimestamp = function () {
        return ServerTimestampFieldValueImpl.instance;
    };
    FieldValueImpl.arrayUnion = function () {
        var elements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elements[_i] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('FieldValue.arrayUnion', arguments, 1);
        // NOTE: We don't actually parse the data until it's used in set() or
        // update() since we need access to the Firestore instance.
        return new ArrayUnionFieldValueImpl(elements);
    };
    FieldValueImpl.arrayRemove = function () {
        var elements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elements[_i] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('FieldValue.arrayRemove', arguments, 1);
        // NOTE: We don't actually parse the data until it's used in set() or
        // update() since we need access to the Firestore instance.
        return new ArrayRemoveFieldValueImpl(elements);
    };
    FieldValueImpl.prototype.isEqual = function (other) {
        return this === other;
    };
    return FieldValueImpl;
}());
var DeleteFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(DeleteFieldValueImpl, _super);
    function DeleteFieldValueImpl() {
        return _super.call(this, 'FieldValue.delete') || this;
    }
    /** Singleton instance. */
    DeleteFieldValueImpl.instance = new DeleteFieldValueImpl();
    return DeleteFieldValueImpl;
}(FieldValueImpl));
var ServerTimestampFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(ServerTimestampFieldValueImpl, _super);
    function ServerTimestampFieldValueImpl() {
        return _super.call(this, 'FieldValue.serverTimestamp') || this;
    }
    /** Singleton instance. */
    ServerTimestampFieldValueImpl.instance = new ServerTimestampFieldValueImpl();
    return ServerTimestampFieldValueImpl;
}(FieldValueImpl));
var ArrayUnionFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayUnionFieldValueImpl, _super);
    function ArrayUnionFieldValueImpl(_elements) {
        var _this = _super.call(this, 'FieldValue.arrayUnion') || this;
        _this._elements = _elements;
        return _this;
    }
    return ArrayUnionFieldValueImpl;
}(FieldValueImpl));
var ArrayRemoveFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayRemoveFieldValueImpl, _super);
    function ArrayRemoveFieldValueImpl(_elements) {
        var _this = _super.call(this, 'FieldValue.arrayRemove') || this;
        _this._elements = _elements;
        return _this;
    }
    return ArrayRemoveFieldValueImpl;
}(FieldValueImpl));
// Public instance that disallows construction at runtime. This constructor is
// used when exporting FieldValueImpl on firebase.firestore.FieldValue and will
// be called FieldValue publicly. Internally we still use FieldValueImpl which
// has a type-checked private constructor. Note that FieldValueImpl and
// PublicFieldValue can be used interchangeably in instanceof checks.
// For our internal TypeScript code PublicFieldValue doesn't exist as a type,
// and so we need to use FieldValueImpl as type and export it too.
// tslint:disable-next-line:variable-name  We treat this as a class name.
var PublicFieldValue = makeConstructorPrivate(FieldValueImpl, 'Use FieldValue.<field>() instead.');

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RESERVED_FIELD_REGEX = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */
var ParsedSetData = /** @class */ (function () {
    function ParsedSetData(data, fieldMask, fieldTransforms) {
        this.data = data;
        this.fieldMask = fieldMask;
        this.fieldTransforms = fieldTransforms;
    }
    ParsedSetData.prototype.toMutations = function (key, precondition) {
        var mutations = [];
        if (this.fieldMask !== null) {
            mutations.push(new PatchMutation(key, this.data, this.fieldMask, precondition));
        }
        else {
            mutations.push(new SetMutation(key, this.data, precondition));
        }
        if (this.fieldTransforms.length > 0) {
            mutations.push(new TransformMutation(key, this.fieldTransforms));
        }
        return mutations;
    };
    return ParsedSetData;
}());
/** The result of parsing "update" data (i.e. for an updateData call). */
var ParsedUpdateData = /** @class */ (function () {
    function ParsedUpdateData(data, fieldMask, fieldTransforms) {
        this.data = data;
        this.fieldMask = fieldMask;
        this.fieldTransforms = fieldTransforms;
    }
    ParsedUpdateData.prototype.toMutations = function (key, precondition) {
        var mutations = [
            new PatchMutation(key, this.data, this.fieldMask, precondition)
        ];
        if (this.fieldTransforms.length > 0) {
            mutations.push(new TransformMutation(key, this.fieldTransforms));
        }
        return mutations;
    };
    return ParsedUpdateData;
}());
/*
 * Represents what type of API method provided the data being parsed; useful
 * for determining which error conditions apply during parsing and providing
 * better error messages.
 */
var UserDataSource;
(function (UserDataSource) {
    UserDataSource[UserDataSource["Set"] = 0] = "Set";
    UserDataSource[UserDataSource["Update"] = 1] = "Update";
    UserDataSource[UserDataSource["MergeSet"] = 2] = "MergeSet";
    /**
     * Indicates the source is a where clause, cursor bound, arrayUnion()
     * element, etc. Of note, isWrite(source) will return false.
     */
    UserDataSource[UserDataSource["Argument"] = 3] = "Argument";
})(UserDataSource || (UserDataSource = {}));
function isWrite(dataSource) {
    switch (dataSource) {
        case UserDataSource.Set: // fall through
        case UserDataSource.MergeSet: // fall through
        case UserDataSource.Update:
            return true;
        case UserDataSource.Argument:
            return false;
        default:
            throw fail("Unexpected case for UserDataSource: " + dataSource);
    }
}
/** A "context" object passed around while parsing user data. */
var ParseContext = /** @class */ (function () {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param dataSource Indicates what kind of API method this data came from.
     * @param methodName The name of the method the user called to create this
     *     ParseContext.
     * @param path A path within the object being parsed. This could be an empty
     *     path (in which case the context represents the root of the data being
     *     parsed), or a nonempty path (indicating the context represents a nested
     *     location within the data).
     * @param arrayElement Whether or not this context corresponds to an element
     *     of an array.
     * @param fieldTransforms A mutable list of field transforms encountered while
     *     parsing the data.
     * @param fieldMask A mutable list of field paths encountered while parsing
     *     the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */
    function ParseContext(dataSource, methodName, path, arrayElement, fieldTransforms, fieldMask) {
        this.dataSource = dataSource;
        this.methodName = methodName;
        this.path = path;
        this.arrayElement = arrayElement;
        // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        if (fieldTransforms === undefined) {
            this.validatePath();
        }
        this.arrayElement = arrayElement !== undefined ? arrayElement : false;
        this.fieldTransforms = fieldTransforms || [];
        this.fieldMask = fieldMask || [];
    }
    ParseContext.prototype.childContextForField = function (field) {
        var childPath = this.path == null ? null : this.path.child(field);
        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
        context.validatePathSegment(field);
        return context;
    };
    ParseContext.prototype.childContextForFieldPath = function (field) {
        var childPath = this.path == null ? null : this.path.child(field);
        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
        context.validatePath();
        return context;
    };
    ParseContext.prototype.childContextForArray = function (index) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // null.
        return new ParseContext(this.dataSource, this.methodName, 
        /*path=*/ null, 
        /*arrayElement=*/ true, this.fieldTransforms, this.fieldMask);
    };
    ParseContext.prototype.createError = function (reason) {
        var fieldDescription = this.path === null || this.path.isEmpty()
            ? ''
            : " (found in field " + this.path.toString() + ")";
        return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + this.methodName + "() called with invalid data. " +
            reason +
            fieldDescription);
    };
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */
    ParseContext.prototype.contains = function (fieldPath) {
        return (this.fieldMask.find(function (field) { return fieldPath.isPrefixOf(field); }) !== undefined ||
            this.fieldTransforms.find(function (transform) {
                return fieldPath.isPrefixOf(transform.field);
            }) !== undefined);
    };
    ParseContext.prototype.validatePath = function () {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path === null) {
            return;
        }
        for (var i = 0; i < this.path.length; i++) {
            this.validatePathSegment(this.path.get(i));
        }
    };
    ParseContext.prototype.validatePathSegment = function (segment) {
        if (isWrite(this.dataSource) && RESERVED_FIELD_REGEX.test(segment)) {
            throw this.createError('Document fields cannot begin and end with __');
        }
    };
    return ParseContext;
}());
/**
 * A placeholder object for DocumentReferences in this file, in order to
 * avoid a circular dependency. See the comments for `DataPreConverter` for
 * the full context.
 */
var DocumentKeyReference = /** @class */ (function () {
    function DocumentKeyReference(databaseId, key) {
        this.databaseId = databaseId;
        this.key = key;
    }
    return DocumentKeyReference;
}());
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */
var UserDataConverter = /** @class */ (function () {
    function UserDataConverter(preConverter) {
        this.preConverter = preConverter;
    }
    /** Parse document data from a non-merge set() call. */
    UserDataConverter.prototype.parseSetData = function (methodName, input) {
        var context = new ParseContext(UserDataSource.Set, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var updateData = this.parseData(input, context);
        return new ParsedSetData(updateData, 
        /* fieldMask= */ null, context.fieldTransforms);
    };
    /** Parse document data from a set() call with '{merge:true}'. */
    UserDataConverter.prototype.parseMergeData = function (methodName, input, fieldPaths) {
        var context = new ParseContext(UserDataSource.MergeSet, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var updateData = this.parseData(input, context);
        var fieldMask;
        var fieldTransforms;
        if (!fieldPaths) {
            fieldMask = FieldMask.fromArray(context.fieldMask);
            fieldTransforms = context.fieldTransforms;
        }
        else {
            var validatedFieldPaths = new SortedSet(FieldPath.comparator);
            for (var _i = 0, fieldPaths_1 = fieldPaths; _i < fieldPaths_1.length; _i++) {
                var stringOrFieldPath = fieldPaths_1[_i];
                var fieldPath = void 0;
                if (stringOrFieldPath instanceof FieldPath$1) {
                    fieldPath = stringOrFieldPath._internalPath;
                }
                else if (typeof stringOrFieldPath === 'string') {
                    fieldPath = fieldPathFromDotSeparatedString(methodName, stringOrFieldPath);
                }
                else {
                    throw fail('Expected stringOrFieldPath to be a string or a FieldPath');
                }
                if (!context.contains(fieldPath)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Field '" + fieldPath + "' is specified in your field mask but missing from your input data.");
                }
                validatedFieldPaths = validatedFieldPaths.add(fieldPath);
            }
            fieldMask = FieldMask.fromSet(validatedFieldPaths);
            fieldTransforms = context.fieldTransforms.filter(function (transform) {
                return fieldMask.covers(transform.field);
            });
        }
        return new ParsedSetData(updateData, fieldMask, fieldTransforms);
    };
    /** Parse update data from an update() call. */
    UserDataConverter.prototype.parseUpdateData = function (methodName, input) {
        var _this = this;
        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var fieldMaskPaths = new SortedSet(FieldPath.comparator);
        var updateData = ObjectValue.EMPTY;
        forEach(input, function (key, value) {
            var path = fieldPathFromDotSeparatedString(methodName, key);
            var childContext = context.childContextForFieldPath(path);
            value = _this.runPreConverter(value, childContext);
            if (value instanceof DeleteFieldValueImpl) {
                // Add it to the field mask, but don't add anything to updateData.
                fieldMaskPaths = fieldMaskPaths.add(path);
            }
            else {
                var parsedValue = _this.parseData(value, childContext);
                if (parsedValue != null) {
                    fieldMaskPaths = fieldMaskPaths.add(path);
                    updateData = updateData.set(path, parsedValue);
                }
            }
        });
        var mask = FieldMask.fromSet(fieldMaskPaths);
        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
    };
    /** Parse update data from a list of field/value arguments. */
    UserDataConverter.prototype.parseUpdateVarargs = function (methodName, field, value, moreFieldsAndValues) {
        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
        var keys = [fieldPathFromArgument(methodName, field)];
        var values$$1 = [value];
        if (moreFieldsAndValues.length % 2 !== 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() needs to be called with an even number " +
                'of arguments that alternate between field names and values.');
        }
        for (var i = 0; i < moreFieldsAndValues.length; i += 2) {
            keys.push(fieldPathFromArgument(methodName, moreFieldsAndValues[i]));
            values$$1.push(moreFieldsAndValues[i + 1]);
        }
        var fieldMaskPaths = new SortedSet(FieldPath.comparator);
        var updateData = ObjectValue.EMPTY;
        for (var i = 0; i < keys.length; ++i) {
            var path = keys[i];
            var childContext = context.childContextForFieldPath(path);
            var value_1 = this.runPreConverter(values$$1[i], childContext);
            if (value_1 instanceof DeleteFieldValueImpl) {
                // Add it to the field mask, but don't add anything to updateData.
                fieldMaskPaths = fieldMaskPaths.add(path);
            }
            else {
                var parsedValue = this.parseData(value_1, childContext);
                if (parsedValue != null) {
                    fieldMaskPaths = fieldMaskPaths.add(path);
                    updateData = updateData.set(path, parsedValue);
                }
            }
        }
        var mask = FieldMask.fromSet(fieldMaskPaths);
        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
    };
    /**
     * Parse a "query value" (e.g. value in a where filter or a value in a cursor
     * bound).
     */
    UserDataConverter.prototype.parseQueryValue = function (methodName, input) {
        var context = new ParseContext(UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
        var parsed = this.parseData(input, context);
        assert(parsed != null, 'Parsed data should not be null.');
        assert(context.fieldTransforms.length === 0, 'Field transforms should have been disallowed.');
        return parsed;
    };
    /** Sends data through this.preConverter, handling any thrown errors. */
    UserDataConverter.prototype.runPreConverter = function (input, context) {
        try {
            return this.preConverter(input);
        }
        catch (e) {
            var message = errorMessage(e);
            throw context.createError(message);
        }
    };
    /**
     * Internal helper for parsing user data.
     *
     * @param input Data to be parsed.
     * @param context A context object representing the current path being parsed,
     * the source of the data being parsed, etc.
     * @return The parsed value, or null if the value was a FieldValue sentinel
     * that should not be included in the resulting parsed data.
     */
    UserDataConverter.prototype.parseData = function (input, context) {
        input = this.runPreConverter(input, context);
        if (looksLikeJsonObject(input)) {
            validatePlainObject('Unsupported field value:', context, input);
            return this.parseObject(input, context);
        }
        else if (input instanceof FieldValueImpl) {
            // FieldValues usually parse into transforms (except FieldValue.delete())
            // in which case we do not want to include this field in our parsed data
            // (as doing so will overwrite the field directly prior to the transform
            // trying to transform it). So we don't add this location to
            // context.fieldMask and we return null as our parsing result.
            this.parseSentinelFieldValue(input, context);
            return null;
        }
        else {
            // If context.path is null we are inside an array and we don't support
            // field mask paths more granular than the top-level array.
            if (context.path) {
                context.fieldMask.push(context.path);
            }
            if (input instanceof Array) {
                // TODO(b/34871131): Include the path containing the array in the error
                // message.
                if (context.arrayElement) {
                    throw context.createError('Nested arrays are not supported');
                }
                return this.parseArray(input, context);
            }
            else {
                return this.parseScalarValue(input, context);
            }
        }
    };
    UserDataConverter.prototype.parseObject = function (obj, context) {
        var _this = this;
        var result = new SortedMap(primitiveComparator);
        if (isEmpty(obj)) {
            // If we encounter an empty object, we explicitly add it to the update
            // mask to ensure that the server creates a map entry.
            if (context.path && context.path.length > 0) {
                context.fieldMask.push(context.path);
            }
        }
        else {
            forEach(obj, function (key, val) {
                var parsedValue = _this.parseData(val, context.childContextForField(key));
                if (parsedValue != null) {
                    result = result.insert(key, parsedValue);
                }
            });
        }
        return new ObjectValue(result);
    };
    UserDataConverter.prototype.parseArray = function (array, context) {
        var result = [];
        var entryIndex = 0;
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var entry = array_1[_i];
            var parsedEntry = this.parseData(entry, context.childContextForArray(entryIndex));
            if (parsedEntry == null) {
                // Just include nulls in the array for fields being replaced with a
                // sentinel.
                parsedEntry = NullValue.INSTANCE;
            }
            result.push(parsedEntry);
            entryIndex++;
        }
        return new ArrayValue(result);
    };
    /**
     * "Parses" the provided FieldValueImpl, adding any necessary transforms to
     * context.fieldTransforms.
     */
    UserDataConverter.prototype.parseSentinelFieldValue = function (value, context) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!isWrite(context.dataSource)) {
            throw context.createError(value._methodName + "() can only be used with update() and set()");
        }
        if (context.path === null) {
            throw context.createError(value._methodName + "() is not currently supported inside arrays");
        }
        if (value instanceof DeleteFieldValueImpl) {
            if (context.dataSource === UserDataSource.MergeSet) {
                // No transform to add for a delete, but we need to add it to our
                // fieldMask so it gets deleted.
                context.fieldMask.push(context.path);
            }
            else if (context.dataSource === UserDataSource.Update) {
                assert(context.path.length > 0, 'FieldValue.delete() at the top level should have already' +
                    ' been handled.');
                throw context.createError('FieldValue.delete() can only appear at the top level ' +
                    'of your update data');
            }
            else {
                // We shouldn't encounter delete sentinels for queries or non-merge set() calls.
                throw context.createError('FieldValue.delete() cannot be used with set() unless you pass ' +
                    '{merge:true}');
            }
        }
        else if (value instanceof ServerTimestampFieldValueImpl) {
            context.fieldTransforms.push(new FieldTransform(context.path, ServerTimestampTransform.instance));
        }
        else if (value instanceof ArrayUnionFieldValueImpl) {
            var parsedElements = this.parseArrayTransformElements(value._methodName, value._elements);
            var arrayUnion = new ArrayUnionTransformOperation(parsedElements);
            context.fieldTransforms.push(new FieldTransform(context.path, arrayUnion));
        }
        else if (value instanceof ArrayRemoveFieldValueImpl) {
            var parsedElements = this.parseArrayTransformElements(value._methodName, value._elements);
            var arrayRemove = new ArrayRemoveTransformOperation(parsedElements);
            context.fieldTransforms.push(new FieldTransform(context.path, arrayRemove));
        }
        else {
            fail('Unknown FieldValue type: ' + value);
        }
    };
    /**
     * Helper to parse a scalar value (i.e. not an Object, Array, or FieldValue)
     *
     * @return The parsed value
     */
    UserDataConverter.prototype.parseScalarValue = function (value, context) {
        if (value === null) {
            return NullValue.INSTANCE;
        }
        else if (typeof value === 'number') {
            if (isSafeInteger(value)) {
                return new IntegerValue(value);
            }
            else {
                return new DoubleValue(value);
            }
        }
        else if (typeof value === 'boolean') {
            return BooleanValue.of(value);
        }
        else if (typeof value === 'string') {
            return new StringValue(value);
        }
        else if (value instanceof Date) {
            return new TimestampValue(Timestamp.fromDate(value));
        }
        else if (value instanceof Timestamp) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            return new TimestampValue(new Timestamp(value.seconds, Math.floor(value.nanoseconds / 1000) * 1000));
        }
        else if (value instanceof GeoPoint) {
            return new GeoPointValue(value);
        }
        else if (value instanceof Blob) {
            return new BlobValue(value);
        }
        else if (value instanceof DocumentKeyReference) {
            return new RefValue(value.databaseId, value.key);
        }
        else {
            throw context.createError("Unsupported field value: " + valueDescription(value));
        }
    };
    UserDataConverter.prototype.parseArrayTransformElements = function (methodName, elements) {
        var _this = this;
        return elements.map(function (element, i) {
            // Although array transforms are used with writes, the actual elements
            // being unioned or removed are not considered writes since they cannot
            // contain any FieldValue sentinels, etc.
            var context = new ParseContext(UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
            return _this.parseData(element, context.childContextForArray(i));
        });
    };
    return UserDataConverter;
}());
/**
 * Checks whether an object looks like a JSON object that should be converted
 * into a struct. Normal class/prototype instances are considered to look like
 * JSON objects since they should be converted to a struct value. Arrays, Dates,
 * GeoPoints, etc. are not considered to look like JSON objects since they map
 * to specific FieldValue types other than ObjectValue.
 */
function looksLikeJsonObject(input) {
    return (typeof input === 'object' &&
        input !== null &&
        !(input instanceof Array) &&
        !(input instanceof Date) &&
        !(input instanceof Timestamp) &&
        !(input instanceof GeoPoint) &&
        !(input instanceof Blob) &&
        !(input instanceof DocumentKeyReference) &&
        !(input instanceof FieldValueImpl));
}
function validatePlainObject(message, context, input) {
    if (!looksLikeJsonObject(input) || !isPlainObject(input)) {
        var description = valueDescription(input);
        if (description === 'an object') {
            // Massage the error if it was an object.
            throw context.createError(message + ' a custom object');
        }
        else {
            throw context.createError(message + ' ' + description);
        }
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */
function fieldPathFromArgument(methodName, path) {
    if (path instanceof FieldPath$1) {
        return path._internalPath;
    }
    else if (typeof path === 'string') {
        return fieldPathFromDotSeparatedString(methodName, path);
    }
    else {
        var message = 'Field path arguments must be of type string or FieldPath.';
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
    }
}
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName The publicly visible method name
 * @param path The dot-separated string form of a field path which will be split
 * on dots.
 */
function fieldPathFromDotSeparatedString(methodName, path) {
    try {
        return fromDotSeparatedString(path)._internalPath;
    }
    catch (e) {
        var message = errorMessage(e);
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
    }
}
/**
 * Extracts the message from a caught exception, which should be an Error object
 * though JS doesn't guarantee that.
 */
function errorMessage(error) {
    return error instanceof Error ? error.message : error.toString();
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
// tslint:disable:strip-private-property-underscore
// settings() defaults:
var DEFAULT_HOST = 'firestore.googleapis.com';
var DEFAULT_SSL = true;
var DEFAULT_TIMESTAMPS_IN_SNAPSHOTS = true;
/**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * `Firestore` instance.
 */
var CACHE_SIZE_UNLIMITED = LruParams.COLLECTION_DISABLED;
// enablePersistence() defaults:
var DEFAULT_SYNCHRONIZE_TABS = false;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied firestore.Settings object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */
var FirestoreSettings = /** @class */ (function () {
    function FirestoreSettings(settings) {
        if (settings.host === undefined) {
            if (settings.ssl !== undefined) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            }
            this.host = DEFAULT_HOST;
            this.ssl = DEFAULT_SSL;
        }
        else {
            validateNamedType('settings', 'non-empty string', 'host', settings.host);
            this.host = settings.host;
            validateNamedOptionalType('settings', 'boolean', 'ssl', settings.ssl);
            this.ssl = defaulted(settings.ssl, DEFAULT_SSL);
        }
        validateOptionNames('settings', settings, [
            'host',
            'ssl',
            'credentials',
            'timestampsInSnapshots',
            'cacheSizeBytes'
        ]);
        validateNamedOptionalType('settings', 'object', 'credentials', settings.credentials);
        this.credentials = settings.credentials;
        validateNamedOptionalType('settings', 'boolean', 'timestampsInSnapshots', settings.timestampsInSnapshots);
        // Nobody should set timestampsInSnapshots anymore, but the error depends on
        // whether they set it to true or false...
        if (settings.timestampsInSnapshots === true) {
            error("\n  The timestampsInSnapshots setting now defaults to true and you no\n  longer need to explicitly set it. In a future release, the setting\n  will be removed entirely and so it is recommended that you remove it\n  from your firestore.settings() call now.");
        }
        else if (settings.timestampsInSnapshots === false) {
            error("\n  The timestampsInSnapshots setting will soon be removed. YOU MUST UPDATE\n  YOUR CODE.\n\n  To hide this warning, stop using the timestampsInSnapshots setting in your\n  firestore.settings({ ... }) call.\n\n  Once you remove the setting, Timestamps stored in Cloud Firestore will be\n  read back as Firebase Timestamp objects instead of as system Date objects.\n  So you will also need to update code expecting a Date to instead expect a\n  Timestamp. For example:\n\n  // Old:\n  const date = snapshot.get('created_at');\n  // New:\n  const timestamp = snapshot.get('created_at'); const date =\n  timestamp.toDate();\n\n  Please audit all existing usages of Date when you enable the new\n  behavior.");
        }
        this.timestampsInSnapshots = defaulted(settings.timestampsInSnapshots, DEFAULT_TIMESTAMPS_IN_SNAPSHOTS);
        validateNamedOptionalType('settings', 'number', 'cacheSizeBytes', settings.cacheSizeBytes);
        if (settings.cacheSizeBytes === undefined) {
            this.cacheSizeBytes = LruParams.DEFAULT_CACHE_SIZE_BYTES;
        }
        else {
            if (settings.cacheSizeBytes !== CACHE_SIZE_UNLIMITED &&
                settings.cacheSizeBytes < LruParams.MINIMUM_CACHE_SIZE_BYTES) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "cacheSizeBytes must be at least " + LruParams.MINIMUM_CACHE_SIZE_BYTES);
            }
            else {
                this.cacheSizeBytes = settings.cacheSizeBytes;
            }
        }
    }
    FirestoreSettings.prototype.isEqual = function (other) {
        return (this.host === other.host &&
            this.ssl === other.ssl &&
            this.timestampsInSnapshots === other.timestampsInSnapshots &&
            this.credentials === other.credentials &&
            this.cacheSizeBytes === other.cacheSizeBytes);
    };
    return FirestoreSettings;
}());
var FirestoreConfig = /** @class */ (function () {
    function FirestoreConfig() {
    }
    return FirestoreConfig;
}());
/**
 * The root reference to the database.
 */
var Firestore = /** @class */ (function () {
    function Firestore(databaseIdOrApp) {
        var _this = this;
        // Public for use in tests.
        // TODO(mikelehen): Use modularized initialization instead.
        this._queue = new AsyncQueue();
        this.INTERNAL = {
            delete: function (options) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    if (this._firestoreClient) {
                        return [2 /*return*/, this._firestoreClient.shutdown(options)];
                    }
                    return [2 /*return*/];
                });
            }); }
        };
        var config = new FirestoreConfig();
        if (typeof databaseIdOrApp.options === 'object') {
            // This is very likely a Firebase app object
            // TODO(b/34177605): Can we somehow use instanceof?
            var app = databaseIdOrApp;
            config.firebaseApp = app;
            config.databaseId = Firestore.databaseIdFromApp(app);
            config.persistenceKey = config.firebaseApp.name;
            config.credentials = new FirebaseCredentialsProvider(app);
        }
        else {
            var external_1 = databaseIdOrApp;
            if (!external_1.projectId) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide projectId');
            }
            config.databaseId = new DatabaseId(external_1.projectId, external_1.database);
            // Use a default persistenceKey that lines up with FirebaseApp.
            config.persistenceKey = '[DEFAULT]';
            config.credentials = new EmptyCredentialsProvider();
        }
        config.settings = new FirestoreSettings({});
        this._config = config;
        this._databaseId = config.databaseId;
    }
    Firestore.prototype.settings = function (settingsLiteral) {
        validateExactNumberOfArgs('Firestore.settings', arguments, 1);
        validateArgType('Firestore.settings', 'object', 1, settingsLiteral);
        if (contains(settingsLiteral, 'persistence')) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, '"persistence" is now specified with a separate call to ' +
                'firestore.enablePersistence().');
        }
        var newSettings = new FirestoreSettings(settingsLiteral);
        if (this._firestoreClient && !this._config.settings.isEqual(newSettings)) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and its settings can no longer ' +
                'be changed. You can only call settings() before calling any other ' +
                'methods on a Firestore object.');
        }
        this._config.settings = newSettings;
        if (newSettings.credentials !== undefined) {
            this._config.credentials = makeCredentialsProvider(newSettings.credentials);
        }
    };
    Firestore.prototype.enableNetwork = function () {
        this.ensureClientConfigured();
        return this._firestoreClient.enableNetwork();
    };
    Firestore.prototype.disableNetwork = function () {
        this.ensureClientConfigured();
        return this._firestoreClient.disableNetwork();
    };
    Firestore.prototype.enablePersistence = function (settings) {
        if (this._firestoreClient) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and persistence can no longer ' +
                'be enabled. You can only call enablePersistence() before calling ' +
                'any other methods on a Firestore object.');
        }
        return this.configureClient(new IndexedDbPersistenceSettings(this._config.settings.cacheSizeBytes, settings !== undefined &&
            defaulted(settings.experimentalTabSynchronization, DEFAULT_SYNCHRONIZE_TABS)));
    };
    Firestore.prototype.ensureClientConfigured = function () {
        if (!this._firestoreClient) {
            // Kick off starting the client but don't actually wait for it.
            // tslint:disable-next-line:no-floating-promises
            this.configureClient(new MemoryPersistenceSettings());
        }
        return this._firestoreClient;
    };
    Firestore.prototype.configureClient = function (persistenceSettings) {
        var _this = this;
        assert(!!this._config.settings.host, 'FirestoreSettings.host cannot be falsey');
        assert(!this._firestoreClient, 'configureClient() called multiple times');
        var databaseInfo = new DatabaseInfo(this._config.databaseId, this._config.persistenceKey, this._config.settings.host, this._config.settings.ssl);
        var preConverter = function (value) {
            if (value instanceof DocumentReference) {
                var thisDb = _this._config.databaseId;
                var otherDb = value.firestore._config.databaseId;
                if (!otherDb.isEqual(thisDb)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document reference is for database ' +
                        (otherDb.projectId + "/" + otherDb.database + " but should be ") +
                        ("for database " + thisDb.projectId + "/" + thisDb.database));
                }
                return new DocumentKeyReference(_this._config.databaseId, value._key);
            }
            else {
                return value;
            }
        };
        this._dataConverter = new UserDataConverter(preConverter);
        this._firestoreClient = new FirestoreClient(PlatformSupport.getPlatform(), databaseInfo, this._config.credentials, this._queue);
        return this._firestoreClient.start(persistenceSettings);
    };
    Firestore.databaseIdFromApp = function (app) {
        var options = app.options;
        if (!contains(options, 'projectId')) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
        }
        var projectId = options['projectId'];
        if (!projectId || typeof projectId !== 'string') {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'projectId must be a string in FirebaseApp.options');
        }
        return new DatabaseId(projectId);
    };
    Object.defineProperty(Firestore.prototype, "app", {
        get: function () {
            if (!this._config.firebaseApp) {
                throw new FirestoreError(Code.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is " +
                    'not available');
            }
            return this._config.firebaseApp;
        },
        enumerable: true,
        configurable: true
    });
    Firestore.prototype.collection = function (pathString) {
        validateExactNumberOfArgs('Firestore.collection', arguments, 1);
        validateArgType('Firestore.collection', 'non-empty string', 1, pathString);
        if (!pathString) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty collection path to collection()');
        }
        this.ensureClientConfigured();
        return new CollectionReference(ResourcePath.fromString(pathString), this);
    };
    Firestore.prototype.doc = function (pathString) {
        validateExactNumberOfArgs('Firestore.doc', arguments, 1);
        validateArgType('Firestore.doc', 'non-empty string', 1, pathString);
        if (!pathString) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty document path to doc()');
        }
        this.ensureClientConfigured();
        return DocumentReference.forPath(ResourcePath.fromString(pathString), this);
    };
    Firestore.prototype.runTransaction = function (updateFunction) {
        var _this = this;
        validateExactNumberOfArgs('Firestore.runTransaction', arguments, 1);
        validateArgType('Firestore.runTransaction', 'function', 1, updateFunction);
        return this.ensureClientConfigured().transaction(function (transaction) {
            return updateFunction(new Transaction$1(_this, transaction));
        });
    };
    Firestore.prototype.batch = function () {
        this.ensureClientConfigured();
        return new WriteBatch(this);
    };
    Object.defineProperty(Firestore, "logLevel", {
        get: function () {
            switch (getLogLevel()) {
                case LogLevel.DEBUG:
                    return 'debug';
                case LogLevel.ERROR:
                    return 'error';
                case LogLevel.SILENT:
                    return 'silent';
                default:
                    return fail('Unknown log level: ' + getLogLevel());
            }
        },
        enumerable: true,
        configurable: true
    });
    Firestore.setLogLevel = function (level) {
        validateExactNumberOfArgs('Firestore.setLogLevel', arguments, 1);
        validateArgType('Firestore.setLogLevel', 'non-empty string', 1, level);
        switch (level) {
            case 'debug':
                setLogLevel(LogLevel.DEBUG);
                break;
            case 'error':
                setLogLevel(LogLevel.ERROR);
                break;
            case 'silent':
                setLogLevel(LogLevel.SILENT);
                break;
            default:
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid log level: ' + level);
        }
    };
    // Note: this is not a property because the minifier can't work correctly with
    // the way TypeScript compiler outputs properties.
    Firestore.prototype._areTimestampsInSnapshotsEnabled = function () {
        return this._config.settings.timestampsInSnapshots;
    };
    return Firestore;
}());
/**
 * A reference to a transaction.
 */
var Transaction$1 = /** @class */ (function () {
    function Transaction(_firestore, _transaction) {
        this._firestore = _firestore;
        this._transaction = _transaction;
    }
    Transaction.prototype.get = function (documentRef) {
        var _this = this;
        validateExactNumberOfArgs('Transaction.get', arguments, 1);
        var ref = validateReference('Transaction.get', documentRef, this._firestore);
        return this._transaction
            .lookup([ref._key])
            .then(function (docs) {
            if (!docs || docs.length !== 1) {
                return fail('Mismatch in docs returned from document lookup.');
            }
            var doc = docs[0];
            if (doc instanceof NoDocument) {
                return new DocumentSnapshot(_this._firestore, ref._key, null, 
                /* fromCache= */ false, 
                /* hasPendingWrites= */ false);
            }
            else if (doc instanceof Document) {
                return new DocumentSnapshot(_this._firestore, ref._key, doc, 
                /* fromCache= */ false, 
                /* hasPendingWrites= */ false);
            }
            else {
                throw fail("BatchGetDocumentsRequest returned unexpected document type: " + doc.constructor.name);
            }
        });
    };
    Transaction.prototype.set = function (documentRef, value, options) {
        validateBetweenNumberOfArgs('Transaction.set', arguments, 2, 3);
        var ref = validateReference('Transaction.set', documentRef, this._firestore);
        options = validateSetOptions('Transaction.set', options);
        var parsed = options.merge || options.mergeFields
            ? this._firestore._dataConverter.parseMergeData('Transaction.set', value, options.mergeFields)
            : this._firestore._dataConverter.parseSetData('Transaction.set', value);
        this._transaction.set(ref._key, parsed);
        return this;
    };
    Transaction.prototype.update = function (documentRef, fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 3] = arguments[_i];
        }
        var ref;
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('Transaction.update', arguments, 3);
            ref = validateReference('Transaction.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateVarargs('Transaction.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('Transaction.update', arguments, 2);
            ref = validateReference('Transaction.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateData('Transaction.update', fieldOrUpdateData);
        }
        this._transaction.update(ref._key, parsed);
        return this;
    };
    Transaction.prototype.delete = function (documentRef) {
        validateExactNumberOfArgs('Transaction.delete', arguments, 1);
        var ref = validateReference('Transaction.delete', documentRef, this._firestore);
        this._transaction.delete(ref._key);
        return this;
    };
    return Transaction;
}());
var WriteBatch = /** @class */ (function () {
    function WriteBatch(_firestore) {
        this._firestore = _firestore;
        this._mutations = [];
        this._committed = false;
    }
    WriteBatch.prototype.set = function (documentRef, value, options) {
        validateBetweenNumberOfArgs('WriteBatch.set', arguments, 2, 3);
        this.verifyNotCommitted();
        var ref = validateReference('WriteBatch.set', documentRef, this._firestore);
        options = validateSetOptions('WriteBatch.set', options);
        var parsed = options.merge || options.mergeFields
            ? this._firestore._dataConverter.parseMergeData('WriteBatch.set', value, options.mergeFields)
            : this._firestore._dataConverter.parseSetData('WriteBatch.set', value);
        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.NONE));
        return this;
    };
    WriteBatch.prototype.update = function (documentRef, fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 3] = arguments[_i];
        }
        this.verifyNotCommitted();
        var ref;
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('WriteBatch.update', arguments, 3);
            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateVarargs('WriteBatch.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('WriteBatch.update', arguments, 2);
            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateData('WriteBatch.update', fieldOrUpdateData);
        }
        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.exists(true)));
        return this;
    };
    WriteBatch.prototype.delete = function (documentRef) {
        validateExactNumberOfArgs('WriteBatch.delete', arguments, 1);
        this.verifyNotCommitted();
        var ref = validateReference('WriteBatch.delete', documentRef, this._firestore);
        this._mutations = this._mutations.concat(new DeleteMutation(ref._key, Precondition.NONE));
        return this;
    };
    WriteBatch.prototype.commit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.verifyNotCommitted();
                this._committed = true;
                if (this._mutations.length > 0) {
                    return [2 /*return*/, this._firestore.ensureClientConfigured().write(this._mutations)];
                }
                return [2 /*return*/];
            });
        });
    };
    WriteBatch.prototype.verifyNotCommitted = function () {
        if (this._committed) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'A write batch can no longer be used after commit() ' +
                'has been called.');
        }
    };
    return WriteBatch;
}());
/**
 * A reference to a particular document in a collection in the database.
 */
var DocumentReference = /** @class */ (function () {
    function DocumentReference(_key, firestore) {
        this._key = _key;
        this.firestore = firestore;
        this._firestoreClient = this.firestore.ensureClientConfigured();
    }
    DocumentReference.forPath = function (path, firestore) {
        if (path.length % 2 !== 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid document reference. Document ' +
                'references must have an even number of segments, but ' +
                (path.canonicalString() + " has " + path.length));
        }
        return new DocumentReference(new DocumentKey(path), firestore);
    };
    Object.defineProperty(DocumentReference.prototype, "id", {
        get: function () {
            return this._key.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "parent", {
        get: function () {
            return new CollectionReference(this._key.path.popLast(), this.firestore);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "path", {
        get: function () {
            return this._key.path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    DocumentReference.prototype.collection = function (pathString) {
        validateExactNumberOfArgs('DocumentReference.collection', arguments, 1);
        validateArgType('DocumentReference.collection', 'non-empty string', 1, pathString);
        if (!pathString) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty collection name to collection()');
        }
        var path = ResourcePath.fromString(pathString);
        return new CollectionReference(this._key.path.child(path), this.firestore);
    };
    DocumentReference.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentReference)) {
            throw invalidClassError('isEqual', 'DocumentReference', 1, other);
        }
        return this.firestore === other.firestore && this._key.isEqual(other._key);
    };
    DocumentReference.prototype.set = function (value, options) {
        validateBetweenNumberOfArgs('DocumentReference.set', arguments, 1, 2);
        options = validateSetOptions('DocumentReference.set', options);
        var parsed = options.merge || options.mergeFields
            ? this.firestore._dataConverter.parseMergeData('DocumentReference.set', value, options.mergeFields)
            : this.firestore._dataConverter.parseSetData('DocumentReference.set', value);
        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.NONE));
    };
    DocumentReference.prototype.update = function (fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 2] = arguments[_i];
        }
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('DocumentReference.update', arguments, 2);
            parsed = this.firestore._dataConverter.parseUpdateVarargs('DocumentReference.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('DocumentReference.update', arguments, 1);
            parsed = this.firestore._dataConverter.parseUpdateData('DocumentReference.update', fieldOrUpdateData);
        }
        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.exists(true)));
    };
    DocumentReference.prototype.delete = function () {
        validateExactNumberOfArgs('DocumentReference.delete', arguments, 0);
        return this._firestoreClient.write([
            new DeleteMutation(this._key, Precondition.NONE)
        ]);
    };
    DocumentReference.prototype.onSnapshot = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        validateBetweenNumberOfArgs('DocumentReference.onSnapshot', arguments, 1, 4);
        var options = {
            includeMetadataChanges: false
        };
        var observer;
        var currArg = 0;
        if (typeof args[currArg] === 'object' &&
            !isPartialObserver(args[currArg])) {
            options = args[currArg];
            validateOptionNames('DocumentReference.onSnapshot', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('DocumentReference.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
            currArg++;
        }
        var internalOptions = {
            includeMetadataChanges: options.includeMetadataChanges
        };
        if (isPartialObserver(args[currArg])) {
            observer = args[currArg];
        }
        else {
            validateArgType('DocumentReference.onSnapshot', 'function', currArg, args[currArg]);
            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
            observer = {
                next: args[currArg],
                error: args[currArg + 1],
                complete: args[currArg + 2]
            };
        }
        return this.onSnapshotInternal(internalOptions, observer);
    };
    DocumentReference.prototype.onSnapshotInternal = function (options, observer) {
        var _this = this;
        var errHandler = function (err) {
            console.error('Uncaught Error in onSnapshot:', err);
        };
        if (observer.error) {
            errHandler = observer.error.bind(observer);
        }
        var asyncObserver = new AsyncObserver({
            next: function (snapshot) {
                if (observer.next) {
                    assert(snapshot.docs.size <= 1, 'Too many documents returned on a document query');
                    var doc = snapshot.docs.get(_this._key);
                    observer.next(new DocumentSnapshot(_this.firestore, _this._key, doc, snapshot.fromCache, snapshot.hasPendingWrites));
                }
            },
            error: errHandler
        });
        var internalListener = this._firestoreClient.listen(Query.atPath(this._key.path), asyncObserver, options);
        return function () {
            asyncObserver.mute();
            _this._firestoreClient.unlisten(internalListener);
        };
    };
    DocumentReference.prototype.get = function (options) {
        var _this = this;
        validateBetweenNumberOfArgs('DocumentReference.get', arguments, 0, 1);
        validateGetOptions('DocumentReference.get', options);
        return new Promise(function (resolve, reject) {
            if (options && options.source === 'cache') {
                _this.firestore
                    .ensureClientConfigured()
                    .getDocumentFromLocalCache(_this._key)
                    .then(function (doc) {
                    resolve(new DocumentSnapshot(_this.firestore, _this._key, doc, 
                    /*fromCache=*/ true, doc instanceof Document ? doc.hasLocalMutations : false));
                }, reject);
            }
            else {
                _this.getViaSnapshotListener(resolve, reject, options);
            }
        });
    };
    DocumentReference.prototype.getViaSnapshotListener = function (resolve, reject, options) {
        var unlisten = this.onSnapshotInternal({
            includeMetadataChanges: true,
            waitForSyncWhenOnline: true
        }, {
            next: function (snap) {
                // Remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                unlisten();
                if (!snap.exists && snap.metadata.fromCache) {
                    // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document because the client is ' + 'offline.'));
                }
                else if (snap.exists &&
                    snap.metadata.fromCache &&
                    options &&
                    options.source === 'server') {
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from server. (However, this ' +
                        'document does exist in the local cache. Run again ' +
                        'without setting source to "server" to ' +
                        'retrieve the cached document.)'));
                }
                else {
                    resolve(snap);
                }
            },
            error: reject
        });
    };
    return DocumentReference;
}());
var SnapshotMetadata = /** @class */ (function () {
    function SnapshotMetadata(hasPendingWrites, fromCache) {
        this.hasPendingWrites = hasPendingWrites;
        this.fromCache = fromCache;
    }
    SnapshotMetadata.prototype.isEqual = function (other) {
        return (this.hasPendingWrites === other.hasPendingWrites &&
            this.fromCache === other.fromCache);
    };
    return SnapshotMetadata;
}());
var DocumentSnapshot = /** @class */ (function () {
    function DocumentSnapshot(_firestore, _key, _document, _fromCache, _hasPendingWrites) {
        this._firestore = _firestore;
        this._key = _key;
        this._document = _document;
        this._fromCache = _fromCache;
        this._hasPendingWrites = _hasPendingWrites;
    }
    DocumentSnapshot.prototype.data = function (options) {
        validateBetweenNumberOfArgs('DocumentSnapshot.data', arguments, 0, 1);
        options = validateSnapshotOptions('DocumentSnapshot.data', options);
        return !this._document
            ? undefined
            : this.convertObject(this._document.data, FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
    };
    DocumentSnapshot.prototype.get = function (fieldPath, options) {
        validateBetweenNumberOfArgs('DocumentSnapshot.get', arguments, 1, 2);
        options = validateSnapshotOptions('DocumentSnapshot.get', options);
        if (this._document) {
            var value = this._document.data.field(fieldPathFromArgument('DocumentSnapshot.get', fieldPath));
            if (value !== undefined) {
                return this.convertValue(value, FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
            }
        }
        return undefined;
    };
    Object.defineProperty(DocumentSnapshot.prototype, "id", {
        get: function () {
            return this._key.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "ref", {
        get: function () {
            return new DocumentReference(this._key, this._firestore);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "exists", {
        get: function () {
            return this._document !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "metadata", {
        get: function () {
            return new SnapshotMetadata(this._hasPendingWrites, this._fromCache);
        },
        enumerable: true,
        configurable: true
    });
    DocumentSnapshot.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentSnapshot)) {
            throw invalidClassError('isEqual', 'DocumentSnapshot', 1, other);
        }
        return (this._firestore === other._firestore &&
            this._fromCache === other._fromCache &&
            this._key.isEqual(other._key) &&
            (this._document === null
                ? other._document === null
                : this._document.isEqual(other._document)));
    };
    DocumentSnapshot.prototype.convertObject = function (data, options) {
        var _this = this;
        var result = {};
        data.forEach(function (key, value) {
            result[key] = _this.convertValue(value, options);
        });
        return result;
    };
    DocumentSnapshot.prototype.convertValue = function (value, options) {
        if (value instanceof ObjectValue) {
            return this.convertObject(value, options);
        }
        else if (value instanceof ArrayValue) {
            return this.convertArray(value, options);
        }
        else if (value instanceof RefValue) {
            var key = value.value(options);
            var database = this._firestore.ensureClientConfigured().databaseId();
            if (!value.databaseId.isEqual(database)) {
                // TODO(b/64130202): Somehow support foreign references.
                error("Document " + this._key.path + " contains a document " +
                    "reference within a different database (" +
                    (value.databaseId.projectId + "/" + value.databaseId.database + ") which is not ") +
                    "supported. It will be treated as a reference in the current " +
                    ("database (" + database.projectId + "/" + database.database + ") ") +
                    "instead.");
            }
            return new DocumentReference(key, this._firestore);
        }
        else {
            return value.value(options);
        }
    };
    DocumentSnapshot.prototype.convertArray = function (data, options) {
        var _this = this;
        return data.internalValue.map(function (value) {
            return _this.convertValue(value, options);
        });
    };
    return DocumentSnapshot;
}());
var QueryDocumentSnapshot = /** @class */ (function (_super) {
    tslib_1.__extends(QueryDocumentSnapshot, _super);
    function QueryDocumentSnapshot(firestore, key, document, fromCache, hasPendingWrites) {
        return _super.call(this, firestore, key, document, fromCache, hasPendingWrites) || this;
    }
    QueryDocumentSnapshot.prototype.data = function (options) {
        var data = _super.prototype.data.call(this, options);
        assert(typeof data === 'object', 'Document in a QueryDocumentSnapshot should exist');
        return data;
    };
    return QueryDocumentSnapshot;
}(DocumentSnapshot));
var Query$1 = /** @class */ (function () {
    function Query$$1(_query, firestore) {
        this._query = _query;
        this.firestore = firestore;
    }
    Query$$1.prototype.where = function (field, opStr, value) {
        validateExactNumberOfArgs('Query.where', arguments, 3);
        validateArgType('Query.where', 'non-empty string', 2, opStr);
        validateDefined('Query.where', 3, value);
        var fieldValue;
        var fieldPath = fieldPathFromArgument('Query.where', field);
        var relationOp = RelationOp.fromString(opStr);
        if (fieldPath.isKeyField()) {
            if (relationOp === RelationOp.ARRAY_CONTAINS) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. You can't perform array-contains queries on " +
                    'FieldPath.documentId() since document IDs are not arrays.');
            }
            if (typeof value === 'string') {
                if (value.indexOf('/') !== -1) {
                    // TODO(dimond): Allow slashes once ancestor queries are supported
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' +
                        'valid document ID if the first parameter is ' +
                        'FieldPath.documentId(), but it contains a slash.');
                }
                if (value === '') {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' +
                        'valid document ID if the first parameter is ' +
                        'FieldPath.documentId(), but it was an empty string.');
                }
                var path = this._query.path.child(new ResourcePath([value]));
                assert(path.length % 2 === 0, 'Path should be a document key');
                fieldValue = new RefValue(this.firestore._databaseId, new DocumentKey(path));
            }
            else if (value instanceof DocumentReference) {
                var ref = value;
                fieldValue = new RefValue(this.firestore._databaseId, ref._key);
            }
            else {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.where() requires its third parameter to be a " +
                    "string or a DocumentReference if the first parameter is " +
                    "FieldPath.documentId(), but it was: " +
                    (valueDescription(value) + "."));
            }
        }
        else {
            fieldValue = this.firestore._dataConverter.parseQueryValue('Query.where', value);
        }
        var filter = Filter.create(fieldPath, relationOp, fieldValue);
        this.validateNewFilter(filter);
        return new Query$$1(this._query.addFilter(filter), this.firestore);
    };
    Query$$1.prototype.orderBy = function (field, directionStr) {
        validateBetweenNumberOfArgs('Query.orderBy', arguments, 1, 2);
        validateOptionalArgType('Query.orderBy', 'non-empty string', 2, directionStr);
        var direction;
        if (directionStr === undefined || directionStr === 'asc') {
            direction = Direction.ASCENDING;
        }
        else if (directionStr === 'desc') {
            direction = Direction.DESCENDING;
        }
        else {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + directionStr + "', " +
                "expected 'asc' or 'desc'.");
        }
        if (this._query.startAt !== null) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.startAt() or ' +
                'Query.startAfter() before calling Query.orderBy().');
        }
        if (this._query.endAt !== null) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.endAt() or ' +
                'Query.endBefore() before calling Query.orderBy().');
        }
        var fieldPath = fieldPathFromArgument('Query.orderBy', field);
        var orderBy = new OrderBy(fieldPath, direction);
        this.validateNewOrderBy(orderBy);
        return new Query$$1(this._query.addOrderBy(orderBy), this.firestore);
    };
    Query$$1.prototype.limit = function (n) {
        validateExactNumberOfArgs('Query.limit', arguments, 1);
        validateArgType('Query.limit', 'number', 1, n);
        if (n <= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. Query limit (" + n + ") is invalid. Limit must be " +
                'positive.');
        }
        return new Query$$1(this._query.withLimit(n), this.firestore);
    };
    Query$$1.prototype.startAt = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.startAt', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.startAt', docOrField, fields, 
        /*before=*/ true);
        return new Query$$1(this._query.withStartAt(bound), this.firestore);
    };
    Query$$1.prototype.startAfter = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.startAfter', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.startAfter', docOrField, fields, 
        /*before=*/ false);
        return new Query$$1(this._query.withStartAt(bound), this.firestore);
    };
    Query$$1.prototype.endBefore = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.endBefore', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.endBefore', docOrField, fields, 
        /*before=*/ true);
        return new Query$$1(this._query.withEndAt(bound), this.firestore);
    };
    Query$$1.prototype.endAt = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.endAt', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.endAt', docOrField, fields, 
        /*before=*/ false);
        return new Query$$1(this._query.withEndAt(bound), this.firestore);
    };
    Query$$1.prototype.isEqual = function (other) {
        if (!(other instanceof Query$$1)) {
            throw invalidClassError('isEqual', 'Query', 1, other);
        }
        return (this.firestore === other.firestore && this._query.isEqual(other._query));
    };
    /** Helper function to create a bound from a document or fields */
    Query$$1.prototype.boundFromDocOrFields = function (methodName, docOrField, fields, before) {
        validateDefined(methodName, 1, docOrField);
        if (docOrField instanceof DocumentSnapshot) {
            if (fields.length > 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "().");
            }
            var snap = docOrField;
            if (!snap.exists) {
                throw new FirestoreError(Code.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " +
                    (methodName + "()."));
            }
            return this.boundFromDocument(methodName, snap._document, before);
        }
        else {
            var allFields = [docOrField].concat(fields);
            return this.boundFromFields(methodName, allFields, before);
        }
    };
    /**
     * Create a Bound from a query and a document.
     *
     * Note that the Bound will always include the key of the document
     * and so only the provided document will compare equal to the returned
     * position.
     *
     * Will throw if the document does not contain all fields of the order by
     * of the query or if any of the fields in the order by are an uncommitted
     * server timestamp.
     */
    Query$$1.prototype.boundFromDocument = function (methodName, doc, before) {
        var components = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (var _i = 0, _a = this._query.orderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            if (orderBy.field.isKeyField()) {
                components.push(new RefValue(this.firestore._databaseId, doc.key));
            }
            else {
                var value = doc.field(orderBy.field);
                if (value instanceof ServerTimestampValue) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a ' +
                        'document for which the field "' +
                        orderBy.field +
                        '" is an uncommitted server timestamp. (Since the value of ' +
                        'this field is unknown, you cannot start/end a query with it.)');
                }
                else if (value !== undefined) {
                    components.push(value);
                }
                else {
                    var field = orderBy.field.canonicalString();
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a " +
                        ("document for which the field '" + field + "' (used as the ") +
                        "orderBy) does not exist.");
                }
            }
        }
        return new Bound(components, before);
    };
    /**
     * Converts a list of field values to a Bound for the given query.
     */
    Query$$1.prototype.boundFromFields = function (methodName, values$$1, before) {
        // Use explicit order by's because it has to match the query the user made
        var orderBy = this._query.explicitOrderBy;
        if (values$$1.length > orderBy.length) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "(). " +
                "The number of arguments must be less than or equal to the " +
                "number of Query.orderBy() clauses");
        }
        var components = [];
        for (var i = 0; i < values$$1.length; i++) {
            var rawValue = values$$1[i];
            var orderByComponent = orderBy[i];
            if (orderByComponent.field.isKeyField()) {
                if (typeof rawValue !== 'string') {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " +
                        (methodName + "(), but got a " + typeof rawValue));
                }
                if (rawValue.indexOf('/') !== -1) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. Document ID '" + rawValue + "' contains a slash in " +
                        (methodName + "()"));
                }
                var key = new DocumentKey(this._query.path.child(rawValue));
                components.push(new RefValue(this.firestore._databaseId, key));
            }
            else {
                var wrapped = this.firestore._dataConverter.parseQueryValue(methodName, rawValue);
                components.push(wrapped);
            }
        }
        return new Bound(components, before);
    };
    Query$$1.prototype.onSnapshot = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        validateBetweenNumberOfArgs('Query.onSnapshot', arguments, 1, 4);
        var options = {};
        var observer;
        var currArg = 0;
        if (typeof args[currArg] === 'object' &&
            !isPartialObserver(args[currArg])) {
            options = args[currArg];
            validateOptionNames('Query.onSnapshot', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
            currArg++;
        }
        if (isPartialObserver(args[currArg])) {
            observer = args[currArg];
        }
        else {
            validateArgType('Query.onSnapshot', 'function', currArg, args[currArg]);
            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
            observer = {
                next: args[currArg],
                error: args[currArg + 1],
                complete: args[currArg + 2]
            };
        }
        return this.onSnapshotInternal(options, observer);
    };
    Query$$1.prototype.onSnapshotInternal = function (options, observer) {
        var _this = this;
        var errHandler = function (err) {
            console.error('Uncaught Error in onSnapshot:', err);
        };
        if (observer.error) {
            errHandler = observer.error.bind(observer);
        }
        var asyncObserver = new AsyncObserver({
            next: function (result) {
                if (observer.next) {
                    observer.next(new QuerySnapshot(_this.firestore, _this._query, result));
                }
            },
            error: errHandler
        });
        var firestoreClient = this.firestore.ensureClientConfigured();
        var internalListener = firestoreClient.listen(this._query, asyncObserver, options);
        return function () {
            asyncObserver.mute();
            firestoreClient.unlisten(internalListener);
        };
    };
    Query$$1.prototype.get = function (options) {
        var _this = this;
        validateBetweenNumberOfArgs('Query.get', arguments, 0, 1);
        validateGetOptions('Query.get', options);
        return new Promise(function (resolve, reject) {
            if (options && options.source === 'cache') {
                _this.firestore
                    .ensureClientConfigured()
                    .getDocumentsFromLocalCache(_this._query)
                    .then(function (viewSnap) {
                    resolve(new QuerySnapshot(_this.firestore, _this._query, viewSnap));
                }, reject);
            }
            else {
                _this.getViaSnapshotListener(resolve, reject, options);
            }
        });
    };
    Query$$1.prototype.getViaSnapshotListener = function (resolve, reject, options) {
        var unlisten = this.onSnapshotInternal({
            includeMetadataChanges: true,
            waitForSyncWhenOnline: true
        }, {
            next: function (result) {
                // Remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                unlisten();
                if (result.metadata.fromCache &&
                    options &&
                    options.source === 'server') {
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get documents from server. (However, these ' +
                        'documents may exist in the local cache. Run again ' +
                        'without setting source to "server" to ' +
                        'retrieve the cached documents.)'));
                }
                else {
                    resolve(result);
                }
            },
            error: reject
        });
    };
    Query$$1.prototype.validateNewFilter = function (filter) {
        if (filter instanceof RelationFilter) {
            if (filter.isInequality()) {
                var existingField = this._query.getInequalityFilterField();
                if (existingField !== null && !existingField.isEqual(filter.field)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. All where filters with an inequality' +
                        ' (<, <=, >, or >=) must be on the same field. But you have' +
                        (" inequality filters on '" + existingField.toString() + "'") +
                        (" and '" + filter.field.toString() + "'"));
                }
                var firstOrderByField = this._query.getFirstOrderByField();
                if (firstOrderByField !== null) {
                    this.validateOrderByAndInequalityMatch(filter.field, firstOrderByField);
                }
            }
            else if (filter.op === RelationOp.ARRAY_CONTAINS) {
                if (this._query.hasArrayContainsFilter()) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. Queries only support a single array-contains ' +
                        'filter.');
                }
            }
        }
    };
    Query$$1.prototype.validateNewOrderBy = function (orderBy) {
        if (this._query.getFirstOrderByField() === null) {
            // This is the first order by. It must match any inequality.
            var inequalityField = this._query.getInequalityFilterField();
            if (inequalityField !== null) {
                this.validateOrderByAndInequalityMatch(inequalityField, orderBy.field);
            }
        }
    };
    Query$$1.prototype.validateOrderByAndInequalityMatch = function (inequality, orderBy) {
        if (!orderBy.isEqual(inequality)) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality " +
                ("(<, <=, >, or >=) on field '" + inequality.toString() + "' ") +
                ("and so you must also use '" + inequality.toString() + "' ") +
                "as your first Query.orderBy(), but your first Query.orderBy() " +
                ("is on field '" + orderBy.toString() + "' instead."));
        }
    };
    return Query$$1;
}());
var QuerySnapshot = /** @class */ (function () {
    function QuerySnapshot(_firestore, _originalQuery, _snapshot) {
        this._firestore = _firestore;
        this._originalQuery = _originalQuery;
        this._snapshot = _snapshot;
        this._cachedChanges = null;
        this._cachedChangesIncludeMetadataChanges = null;
        this.metadata = new SnapshotMetadata(_snapshot.hasPendingWrites, _snapshot.fromCache);
    }
    Object.defineProperty(QuerySnapshot.prototype, "docs", {
        get: function () {
            var result = [];
            this.forEach(function (doc) { return result.push(doc); });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuerySnapshot.prototype, "empty", {
        get: function () {
            return this._snapshot.docs.isEmpty();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuerySnapshot.prototype, "size", {
        get: function () {
            return this._snapshot.docs.size;
        },
        enumerable: true,
        configurable: true
    });
    QuerySnapshot.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        validateBetweenNumberOfArgs('QuerySnapshot.forEach', arguments, 1, 2);
        validateArgType('QuerySnapshot.forEach', 'function', 1, callback);
        this._snapshot.docs.forEach(function (doc) {
            callback.call(thisArg, _this.convertToDocumentImpl(doc));
        });
    };
    Object.defineProperty(QuerySnapshot.prototype, "query", {
        get: function () {
            return new Query$1(this._originalQuery, this._firestore);
        },
        enumerable: true,
        configurable: true
    });
    QuerySnapshot.prototype.docChanges = function (options) {
        if (options) {
            validateOptionNames('QuerySnapshot.docChanges', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('QuerySnapshot.docChanges', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
        }
        var includeMetadataChanges = !!(options && options.includeMetadataChanges);
        if (includeMetadataChanges && this._snapshot.excludesMetadataChanges) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'To include metadata changes with your document changes, you must ' +
                'also pass { includeMetadataChanges:true } to onSnapshot().');
        }
        if (!this._cachedChanges ||
            this._cachedChangesIncludeMetadataChanges !== includeMetadataChanges) {
            this._cachedChanges = changesFromSnapshot(this._firestore, includeMetadataChanges, this._snapshot);
            this._cachedChangesIncludeMetadataChanges = includeMetadataChanges;
        }
        return this._cachedChanges;
    };
    /** Check the equality. The call can be very expensive. */
    QuerySnapshot.prototype.isEqual = function (other) {
        if (!(other instanceof QuerySnapshot)) {
            throw invalidClassError('isEqual', 'QuerySnapshot', 1, other);
        }
        return (this._firestore === other._firestore &&
            this._originalQuery.isEqual(other._originalQuery) &&
            this._snapshot.isEqual(other._snapshot));
    };
    QuerySnapshot.prototype.convertToDocumentImpl = function (doc) {
        return new QueryDocumentSnapshot(this._firestore, doc.key, doc, this.metadata.fromCache, this._snapshot.mutatedKeys.has(doc.key));
    };
    return QuerySnapshot;
}());
// TODO(2018/11/01): As of 2018/04/17 we're changing docChanges from an array
// into a method. Because this is a runtime breaking change and somewhat subtle
// (both Array and Function have a .length, etc.), we'll replace commonly-used
// properties (including Symbol.iterator) to throw a custom error message. In
// ~6 months we can delete the custom error as most folks will have hopefully
// migrated.
function throwDocChangesMethodError() {
    throw new FirestoreError(Code.INVALID_ARGUMENT, 'QuerySnapshot.docChanges has been changed from a property into a ' +
        'method, so usages like "querySnapshot.docChanges" should become ' +
        '"querySnapshot.docChanges()"');
}
var docChangesPropertiesToOverride = [
    'length',
    'forEach',
    'map'
].concat((typeof Symbol !== 'undefined' ? [Symbol.iterator] : []));
docChangesPropertiesToOverride.forEach(function (property) {
    /**
     * We are (re-)defining properties on QuerySnapshot.prototype.docChanges which
     * is a Function. This could fail, in particular in the case of 'length' which
     * already exists on Function.prototype and on IE11 is improperly defined with
     * `{ configurable: false }`. So we wrap this in a try/catch to ensure that we
     * still have a functional SDK.
     */
    try {
        Object.defineProperty(QuerySnapshot.prototype.docChanges, property, {
            get: function () { return throwDocChangesMethodError(); }
        });
    }
    catch (err) { } // Ignore this failure intentionally
});
var CollectionReference = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionReference, _super);
    function CollectionReference(path, firestore) {
        var _this = _super.call(this, Query.atPath(path), firestore) || this;
        if (path.length % 2 !== 1) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid collection reference. Collection ' +
                'references must have an odd number of segments, but ' +
                (path.canonicalString() + " has " + path.length));
        }
        return _this;
    }
    Object.defineProperty(CollectionReference.prototype, "id", {
        get: function () {
            return this._query.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionReference.prototype, "parent", {
        get: function () {
            var parentPath = this._query.path.popLast();
            if (parentPath.isEmpty()) {
                return null;
            }
            else {
                return new DocumentReference(new DocumentKey(parentPath), this.firestore);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionReference.prototype, "path", {
        get: function () {
            return this._query.path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    CollectionReference.prototype.doc = function (pathString) {
        validateBetweenNumberOfArgs('CollectionReference.doc', arguments, 0, 1);
        // We allow omission of 'pathString' but explicitly prohibit passing in both
        // 'undefined' and 'null'.
        if (arguments.length === 0) {
            pathString = AutoId.newId();
        }
        validateArgType('CollectionReference.doc', 'non-empty string', 1, pathString);
        if (pathString === '') {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document path must be a non-empty string');
        }
        var path = ResourcePath.fromString(pathString);
        return DocumentReference.forPath(this._query.path.child(path), this.firestore);
    };
    CollectionReference.prototype.add = function (value) {
        validateExactNumberOfArgs('CollectionReference.add', arguments, 1);
        validateArgType('CollectionReference.add', 'object', 1, value);
        var docRef = this.doc();
        return docRef.set(value).then(function () { return docRef; });
    };
    return CollectionReference;
}(Query$1));
function validateSetOptions(methodName, options) {
    if (options === undefined) {
        return {
            merge: false
        };
    }
    validateOptionNames(methodName, options, ['merge', 'mergeFields']);
    validateNamedOptionalType(methodName, 'boolean', 'merge', options.merge);
    validateOptionalArrayElements(methodName, 'mergeFields', 'a string or a FieldPath', options.mergeFields, function (element) {
        return typeof element === 'string' || element instanceof FieldPath$1;
    });
    if (options.mergeFields !== undefined && options.merge !== undefined) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid options passed to function " + methodName + "(): You cannot specify both \"merge\" " +
            "and \"mergeFields\".");
    }
    return options;
}
function validateSnapshotOptions(methodName, options) {
    if (options === undefined) {
        return {};
    }
    validateOptionNames(methodName, options, ['serverTimestamps']);
    validateNamedOptionalPropertyEquals(methodName, 'options', 'serverTimestamps', options.serverTimestamps, ['estimate', 'previous', 'none']);
    return options;
}
function validateGetOptions(methodName, options) {
    validateOptionalArgType(methodName, 'object', 1, options);
    if (options) {
        validateOptionNames(methodName, options, ['source']);
        validateNamedOptionalPropertyEquals(methodName, 'options', 'source', options.source, ['default', 'server', 'cache']);
    }
}
function validateReference(methodName, documentRef, firestore) {
    if (!(documentRef instanceof DocumentReference)) {
        throw invalidClassError(methodName, 'DocumentReference', 1, documentRef);
    }
    else if (documentRef.firestore !== firestore) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, 'Provided document reference is from a different Firestore instance.');
    }
    else {
        return documentRef;
    }
}
/**
 * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
 *
 * Exported for testing.
 */
function changesFromSnapshot(firestore, includeMetadataChanges, snapshot) {
    if (snapshot.oldDocs.isEmpty()) {
        // Special case the first snapshot because index calculation is easy and
        // fast
        var lastDoc_1;
        var index_1 = 0;
        return snapshot.docChanges.map(function (change) {
            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache, snapshot.mutatedKeys.has(change.doc.key));
            assert(change.type === ChangeType.Added, 'Invalid event type for first snapshot');
            assert(!lastDoc_1 || snapshot.query.docComparator(lastDoc_1, change.doc) < 0, 'Got added events in wrong order');
            lastDoc_1 = change.doc;
            return {
                type: 'added',
                doc: doc,
                oldIndex: -1,
                newIndex: index_1++
            };
        });
    }
    else {
        // A DocumentSet that is updated incrementally as changes are applied to use
        // to lookup the index of a document.
        var indexTracker_1 = snapshot.oldDocs;
        return snapshot.docChanges
            .filter(function (change) { return includeMetadataChanges || change.type !== ChangeType.Metadata; })
            .map(function (change) {
            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache, snapshot.mutatedKeys.has(change.doc.key));
            var oldIndex = -1;
            var newIndex = -1;
            if (change.type !== ChangeType.Added) {
                oldIndex = indexTracker_1.indexOf(change.doc.key);
                assert(oldIndex >= 0, 'Index for document not found');
                indexTracker_1 = indexTracker_1.delete(change.doc.key);
            }
            if (change.type !== ChangeType.Removed) {
                indexTracker_1 = indexTracker_1.add(change.doc);
                newIndex = indexTracker_1.indexOf(change.doc.key);
            }
            return { type: resultChangeType(change.type), doc: doc, oldIndex: oldIndex, newIndex: newIndex };
        });
    }
}
function resultChangeType(type) {
    switch (type) {
        case ChangeType.Added:
            return 'added';
        case ChangeType.Modified:
        case ChangeType.Metadata:
            return 'modified';
        case ChangeType.Removed:
            return 'removed';
        default:
            return fail('Unknown change type: ' + type);
    }
}
// Export the classes with a private constructor (it will fail if invoked
// at runtime). Note that this still allows instanceof checks.
// We're treating the variables as class names, so disable checking for lower
// case variable names.
// tslint:disable:variable-name
var PublicFirestore = makeConstructorPrivate(Firestore, 'Use firebase.firestore() instead.');
var PublicTransaction = makeConstructorPrivate(Transaction$1, 'Use firebase.firestore().runTransaction() instead.');
var PublicWriteBatch = makeConstructorPrivate(WriteBatch, 'Use firebase.firestore().batch() instead.');
var PublicDocumentReference = makeConstructorPrivate(DocumentReference, 'Use firebase.firestore().doc() instead.');
var PublicDocumentSnapshot = makeConstructorPrivate(DocumentSnapshot);
var PublicQueryDocumentSnapshot = makeConstructorPrivate(QueryDocumentSnapshot);
var PublicQuery = makeConstructorPrivate(Query$1);
var PublicQuerySnapshot = makeConstructorPrivate(QuerySnapshot);
var PublicCollectionReference = makeConstructorPrivate(CollectionReference, 'Use firebase.firestore().collection() instead.');
// tslint:enable:variable-name

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firestoreNamespace = {
    Firestore: PublicFirestore,
    GeoPoint: GeoPoint,
    Timestamp: Timestamp,
    Blob: PublicBlob,
    Transaction: PublicTransaction,
    WriteBatch: PublicWriteBatch,
    DocumentReference: PublicDocumentReference,
    DocumentSnapshot: PublicDocumentSnapshot,
    Query: PublicQuery,
    QueryDocumentSnapshot: PublicQueryDocumentSnapshot,
    QuerySnapshot: PublicQuerySnapshot,
    CollectionReference: PublicCollectionReference,
    FieldPath: FieldPath$1,
    FieldValue: PublicFieldValue,
    setLogLevel: Firestore.setLogLevel,
    CACHE_SIZE_UNLIMITED: CACHE_SIZE_UNLIMITED
};
/**
 * Configures Firestore as part of the Firebase SDK by calling registerService.
 */
function configureForFirebase(firebase$$1) {
    firebase$$1.INTERNAL.registerService('firestore', function (app) { return new Firestore(app); }, shallowCopy(firestoreNamespace));
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerFirestore(instance) {
    configureForFirebase(instance);
}
registerFirestore(firebase);

exports.registerFirestore = registerFirestore;


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createWebChannelTransport", function() { return src_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorCode", function() { return src_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventType", function() { return src_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebChannel", function() { return src_4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XhrIoPool", function() { return src_5; });
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var e,goog=goog||{},h=commonjsGlobal;function l(a){return"string"==typeof a}function m(a,b){a=a.split(".");b=b||h;for(var c=0;c<a.length;c++)if(b=b[a[c]], null==b)return null;return b}function aa(){}
function ba(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function n(a){return"array"==ba(a)}function ca(a){var b=ba(a);return"array"==b||"object"==b&&"number"==typeof a.length}function q(a){return"function"==ba(a)}function r(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var t="closure_uid_"+(1E9*Math.random()>>>0),da=0;function ea(a,b,c){return a.call.apply(a.bind,arguments)}
function fa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function u(a,b,c){u=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ea:fa;return u.apply(null,arguments)}
function v(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var w=Date.now||function(){return+new Date};function x(a,b){function c(){}c.prototype=b.prototype;a.L=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.mh=function(a,c,g){for(var d=Array(arguments.length-2),f=2;f<arguments.length;f++)d[f-2]=arguments[f];return b.prototype[c].apply(a,d)};}function y(a){if(Error.captureStackTrace)Error.captureStackTrace(this,y);else{var b=Error().stack;b&&(this.stack=b);}a&&(this.message=String(a));}x(y,Error);y.prototype.name="CustomError";function ha(a,b){a=a.split("%s");for(var c="",d=a.length-1,f=0;f<d;f++)c+=a[f]+(f<b.length?b[f]:"%s");y.call(this,c+a[d]);}x(ha,y);ha.prototype.name="AssertionError";function ia(a,b){throw new ha("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));}function z(){0!=ja&&(ka[this[t]||(this[t]=++da)]=this);this.Ka=this.Ka;this.Qa=this.Qa;}var ja=0,ka={};z.prototype.Ka=!1;z.prototype.bb=function(){if(!this.Ka&&(this.Ka=!0, this.F(), 0!=ja)){var a=this[t]||(this[t]=++da);if(0!=ja&&this.Qa&&0<this.Qa.length)throw Error(this+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete ka[a];}};z.prototype.F=function(){if(this.Qa)for(;this.Qa.length;)this.Qa.shift()();};var la=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(l(a))return l(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},ma=Array.prototype.lastIndexOf?function(a,b){return Array.prototype.lastIndexOf.call(a,b,a.length-1)}:function(a,b){var c=a.length-1;0>c&&(c=Math.max(0,a.length+c));if(l(a))return l(b)&&1==b.length?a.lastIndexOf(b,c):-1;for(;0<=c;c--)if(c in a&&a[c]===b)return c;return-1},na=
Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c);}:function(a,b,c){for(var d=a.length,f=l(a)?a.split(""):a,g=0;g<d;g++)g in f&&b.call(c,f[g],g,a);},oa=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=l(a)?a.split(""):a,f=0;f<c;f++)if(f in d&&b.call(void 0,d[f],f,a))return!0;return!1};
function pa(a){a:{var b=qa;for(var c=a.length,d=l(a)?a.split(""):a,f=0;f<c;f++)if(f in d&&b.call(void 0,d[f],f,a)){b=f;break a}b=-1;}return 0>b?null:l(a)?a.charAt(b):a[b]}function ra(a){if(!n(a))for(var b=a.length-1;0<=b;b--)delete a[b];a.length=0;}function sa(a,b){b=la(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function ta(a){return Array.prototype.concat.apply([],arguments)}function ua(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]}function va(a){return/^[\s\xa0]*$/.test(a)}var wa=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};function xa(a,b){return a<b?-1:a>b?1:0}var A;a:{var ya=h.navigator;if(ya){var za=ya.userAgent;if(za){A=za;break a}}A="";}function B(a){return-1!=A.indexOf(a)}function Aa(a,b,c){for(var d in a)b.call(c,a[d],d,a);}function Ba(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Ca(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Da(a){var b={},c;for(c in a)b[c]=a[c];return b}var Ea="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function Fa(a,b){for(var c,d,f=1;f<arguments.length;f++){d=arguments[f];for(c in d)a[c]=d[c];for(var g=0;g<Ea.length;g++)c=Ea[g], Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c]);}}function Ga(a){Ga[" "](a);return a}Ga[" "]=aa;function Ha(a,b){var c=Ia;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)}var Ja=B("Opera"),C=B("Trident")||B("MSIE"),Ka=B("Edge"),La=Ka||C,Ma=B("Gecko")&&!(-1!=A.toLowerCase().indexOf("webkit")&&!B("Edge"))&&!(B("Trident")||B("MSIE"))&&!B("Edge"),Na=-1!=A.toLowerCase().indexOf("webkit")&&!B("Edge");function Oa(){var a=h.document;return a?a.documentMode:void 0}var Pa;
a:{var Qa="",Ra=function(){var a=A;if(Ma)return/rv:([^\);]+)(\)|;)/.exec(a);if(Ka)return/Edge\/([\d\.]+)/.exec(a);if(C)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Na)return/WebKit\/(\S+)/.exec(a);if(Ja)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Ra&&(Qa=Ra?Ra[1]:"");if(C){var Sa=Oa();if(null!=Sa&&Sa>parseFloat(Qa)){Pa=String(Sa);break a}}Pa=Qa;}var Ia={};
function Ta(a){return Ha(a,function(){for(var b=0,c=wa(String(Pa)).split("."),d=wa(String(a)).split("."),f=Math.max(c.length,d.length),g=0;0==b&&g<f;g++){var k=c[g]||"",p=d[g]||"";do{k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];p=/(\d*)(\D*)(.*)/.exec(p)||["","","",""];if(0==k[0].length&&0==p[0].length)break;b=xa(0==k[1].length?0:parseInt(k[1],10),0==p[1].length?0:parseInt(p[1],10))||xa(0==k[2].length,0==p[2].length)||xa(k[2],p[2]);k=k[3];p=p[3];}while(0==b)}return 0<=b})}var Ua;var Va=h.document;
Ua=Va&&C?Oa()||("CSS1Compat"==Va.compatMode?parseInt(Pa,10):5):void 0;var Wa=Object.freeze||function(a){return a};var Xa=!C||9<=Number(Ua),Ya=C&&!Ta("9"),Za=function(){if(!h.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0;}});try{h.addEventListener("test",aa,b), h.removeEventListener("test",aa,b);}catch(c){}return a}();function D(a,b){this.type=a;this.currentTarget=this.target=b;this.defaultPrevented=this.Ea=!1;this.Be=!0;}D.prototype.stopPropagation=function(){this.Ea=!0;};D.prototype.preventDefault=function(){this.defaultPrevented=!0;this.Be=!1;};function E(a,b){D.call(this,a?a.type:"");this.relatedTarget=this.currentTarget=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.key="";this.charCode=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.state=null;this.pointerId=0;this.pointerType="";this.fb=null;a&&this.Kf(a,b);}x(E,D);var $a=Wa({2:"touch",3:"pen",4:"mouse"});
E.prototype.Kf=function(a,b){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.currentTarget=b;if(b=a.relatedTarget){if(Ma){a:{try{Ga(b.nodeName);var f=!0;break a}catch(g){}f=!1;}f||(b=null);}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.offsetX=Na||void 0!==a.offsetX?a.offsetX:a.layerX, this.offsetY=Na||void 0!==a.offsetY?a.offsetY:a.layerY, this.clientX=void 0!==a.clientX?a.clientX:a.pageX, this.clientY=void 0!==a.clientY?a.clientY:a.pageY, this.screenX=a.screenX||0, this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX, this.clientY=void 0!==d.clientY?d.clientY:d.pageY, this.screenX=d.screenX||0, this.screenY=d.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.key=a.key||"";this.charCode=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=
l(a.pointerType)?a.pointerType:$a[a.pointerType]||"";this.state=a.state;this.fb=a;a.defaultPrevented&&this.preventDefault();};E.prototype.stopPropagation=function(){E.L.stopPropagation.call(this);this.fb.stopPropagation?this.fb.stopPropagation():this.fb.cancelBubble=!0;};E.prototype.preventDefault=function(){E.L.preventDefault.call(this);var a=this.fb;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1, Ya)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1;}catch(b){}};var ab="closure_listenable_"+(1E6*Math.random()|0);function F(a){return!(!a||!a[ab])}var bb=0;function cb(a,b,c,d,f){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.Ob=f;this.key=++bb;this.Sa=this.Eb=!1;}cb.prototype.Vb=function(){this.Sa=!0;this.Ob=this.src=this.proxy=this.listener=null;};function db(a){this.src=a;this.J={};this.xb=0;}e=db.prototype;e.add=function(a,b,c,d,f){var g=a.toString();a=this.J[g];a||(a=this.J[g]=[], this.xb++);var k=eb(a,b,d,f);-1<k?(b=a[k], c||(b.Eb=!1)):(b=new cb(b,this.src,g,!!d,f), b.Eb=c, a.push(b));return b};e.remove=function(a,b,c,d){a=a.toString();if(!(a in this.J))return!1;var f=this.J[a];b=eb(f,b,c,d);return-1<b?(f[b].Vb(), Array.prototype.splice.call(f,b,1), 0==f.length&&(delete this.J[a], this.xb--), !0):!1};
e.ye=function(a){var b=a.type;b in this.J&&sa(this.J[b],a)&&(a.Vb(), 0==this.J[b].length&&(delete this.J[b], this.xb--));};e.pb=function(a){a=a&&a.toString();var c;for(c in this.J)if(!a||c==a){for(var d=this.J[c],f=0;f<d.length;f++)d[f].Vb();delete this.J[c];this.xb--;}};e.jb=function(a,b,c,d){a=this.J[a.toString()];var f=-1;a&&(f=eb(a,b,c,d));return-1<f?a[f]:null};function eb(a,b,c,d){for(var f=0;f<a.length;++f){var g=a[f];if(!g.Sa&&g.listener==b&&g.capture==!!c&&g.Ob==d)return f}return-1}var fb="closure_lm_"+(1E6*Math.random()|0),gb={};function ib(a,b,c,d,f){if(d&&d.once)return jb(a,b,c,d,f);if(n(b)){for(var g=0;g<b.length;g++)ib(a,b[g],c,d,f);return null}c=kb(c);return F(a)?a.nb(b,c,r(d)?!!d.capture:!!d,f):lb(a,b,c,!1,d,f)}
function lb(a,b,c,d,f,g){if(!b)throw Error("Invalid event type");var k=r(f)?!!f.capture:!!f,p=G(a);p||(a[fb]=p=new db(a));c=p.add(b,c,d,k,g);if(c.proxy)return c;d=mb();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)Za||(f=k), void 0===f&&(f=!1), a.addEventListener(b.toString(),d,f);else if(a.attachEvent)a.attachEvent(nb(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");return c}
function mb(){var a=ob,b=Xa?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function jb(a,b,c,d,f){if(n(b)){for(var g=0;g<b.length;g++)jb(a,b[g],c,d,f);return null}c=kb(c);return F(a)?a.Oc(b,c,r(d)?!!d.capture:!!d,f):lb(a,b,c,!0,d,f)}function pb(a,b,c,d,f){if(n(b))for(var g=0;g<b.length;g++)pb(a,b[g],c,d,f);else d=r(d)?!!d.capture:!!d, c=kb(c), F(a)?a.ed(b,c,d,f):a&&(a=G(a))&&(b=a.jb(b,c,d,f))&&qb(b);}
function qb(a){if("number"!=typeof a&&a&&!a.Sa){var b=a.src;if(F(b))b.Le(a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(nb(c),d):b.addListener&&b.removeListener&&b.removeListener(d);(c=G(b))?(c.ye(a), 0==c.xb&&(c.src=null, b[fb]=null)):a.Vb();}}}function nb(a){return a in gb?gb[a]:gb[a]="on"+a}
function rb(a,b,c,d){var f=!0;if(a=G(a))if(b=a.J[b.toString()])for(b=b.concat(), a=0;a<b.length;a++){var g=b[a];g&&g.capture==c&&!g.Sa&&(g=sb(g,d), f=f&&!1!==g);}return f}function sb(a,b){var c=a.listener,d=a.Ob||a.src;a.Eb&&qb(a);return c.call(d,b)}
function ob(a,b){if(a.Sa)return!0;if(!Xa){var c=b||m("window.event");b=new E(c,this);var d=!0;if(!(0>c.keyCode||void 0!=c.returnValue)){a:{var f=!1;if(0==c.keyCode)try{c.keyCode=-1;break a}catch(k){f=!0;}if(f||void 0==c.returnValue)c.returnValue=!0;}c=[];for(f=b.currentTarget;f;f=f.parentNode)c.push(f);a=a.type;for(f=c.length-1;!b.Ea&&0<=f;f--){b.currentTarget=c[f];var g=rb(c[f],a,!0,b);d=d&&g;}for(f=0;!b.Ea&&f<c.length;f++)b.currentTarget=c[f], g=rb(c[f],a,!1,b), d=d&&g;}return d}return sb(a,new E(b,this))}
function G(a){a=a[fb];return a instanceof db?a:null}var tb="__closure_events_fn_"+(1E9*Math.random()>>>0);function kb(a){if(q(a))return a;a[tb]||(a[tb]=function(b){return a.handleEvent(b)});return a[tb]}function H(){z.call(this);this.ka=new db(this);this.Pe=this;this.Uc=null;}x(H,z);H.prototype[ab]=!0;e=H.prototype;e.addEventListener=function(a,b,c,d){ib(this,a,b,c,d);};e.removeEventListener=function(a,b,c,d){pb(this,a,b,c,d);};
e.dispatchEvent=function(a){var b,c=this.Uc;if(c)for(b=[];c;c=c.Uc)b.push(c);c=this.Pe;var d=a.type||a;if(l(a))a=new D(a,c);else if(a instanceof D)a.target=a.target||c;else{var f=a;a=new D(d,c);Fa(a,f);}f=!0;if(b)for(var g=b.length-1;!a.Ea&&0<=g;g--){var k=a.currentTarget=b[g];f=k.Lb(d,!0,a)&&f;}a.Ea||(k=a.currentTarget=c, f=k.Lb(d,!0,a)&&f, a.Ea||(f=k.Lb(d,!1,a)&&f));if(b)for(g=0;!a.Ea&&g<b.length;g++)k=a.currentTarget=b[g], f=k.Lb(d,!1,a)&&f;return f};
e.F=function(){H.L.F.call(this);this.pg();this.Uc=null;};e.nb=function(a,b,c,d){return this.ka.add(String(a),b,!1,c,d)};e.Oc=function(a,b,c,d){return this.ka.add(String(a),b,!0,c,d)};e.ed=function(a,b,c,d){this.ka.remove(String(a),b,c,d);};e.Le=function(a){this.ka.ye(a);};e.pg=function(){this.ka&&this.ka.pb(void 0);};
e.Lb=function(a,b,c){a=this.ka.J[String(a)];if(!a)return!0;a=a.concat();for(var d=!0,f=0;f<a.length;++f){var g=a[f];if(g&&!g.Sa&&g.capture==b){var k=g.listener,p=g.Ob||g.src;g.Eb&&this.Le(g);d=!1!==k.call(p,c)&&d;}}return d&&0!=c.Be};e.jb=function(a,b,c,d){return this.ka.jb(String(a),b,c,d)};var ub=h.JSON.stringify;function vb(a,b){this.Sf=100;this.ef=a;this.ug=b;this.Zb=0;this.Pb=null;}vb.prototype.get=function(){if(0<this.Zb){this.Zb--;var a=this.Pb;this.Pb=a.next;a.next=null;}else a=this.ef();return a};vb.prototype.put=function(a){this.ug(a);this.Zb<this.Sf&&(this.Zb++, a.next=this.Pb, this.Pb=a);};function I(){this.lc=this.Va=null;}var xb=new vb(function(){return new wb},function(a){a.reset();});I.prototype.add=function(a,b){var c=this.Af();c.set(a,b);this.lc?this.lc.next=c:this.Va=c;this.lc=c;};I.prototype.remove=function(){var a=null;this.Va&&(a=this.Va, this.Va=this.Va.next, this.Va||(this.lc=null), a.next=null);return a};I.prototype.wg=function(a){xb.put(a);};I.prototype.Af=function(){return xb.get()};function wb(){this.next=this.scope=this.Gc=null;}
wb.prototype.set=function(a,b){this.Gc=a;this.scope=b;this.next=null;};wb.prototype.reset=function(){this.next=this.scope=this.Gc=null;};function yb(a){h.setTimeout(function(){throw a;},0);}var zb;
function Ab(){var a=h.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!B("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=u(function(a){if(("*"==d||a.origin==d)&&a.data==
c)this.port1.onmessage();},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d);}};});if("undefined"!==typeof a&&!B("Trident")&&!B("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.rd;c.rd=null;a();}};return function(a){d.next={rd:a};d=d.next;b.port2.postMessage(0);}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null;};document.documentElement.appendChild(b);}:function(a){h.setTimeout(a,0);}}var Bb;function Cb(){if(h.Promise&&h.Promise.resolve){var a=h.Promise.resolve(void 0);Bb=function(){a.then(Db);};}else Bb=function(){var a=Db;!q(h.setImmediate)||h.Window&&h.Window.prototype&&!B("Edge")&&h.Window.prototype.setImmediate==h.setImmediate?(zb||(zb=Ab()), zb(a)):h.setImmediate(a);};}var Eb=!1,Fb=new I;function Db(){for(var a;a=Fb.remove();){try{a.Gc.call(a.scope);}catch(b){yb(b);}Fb.wg(a);}Eb=!1;}function Gb(a,b){H.call(this);this.Na=a||1;this.wb=b||h;this.nd=u(this.Rg,this);this.ie=w();}x(Gb,H);e=Gb.prototype;e.enabled=!1;e.B=null;e.setInterval=function(a){this.Na=a;this.B&&this.enabled?(this.stop(), this.start()):this.B&&this.stop();};e.Rg=function(){if(this.enabled){var a=w()-this.ie;0<a&&a<.8*this.Na?this.B=this.wb.setTimeout(this.nd,this.Na-a):(this.B&&(this.wb.clearTimeout(this.B), this.B=null), this.ff(), this.enabled&&(this.stop(), this.start()));}};e.ff=function(){this.dispatchEvent("tick");};
e.start=function(){this.enabled=!0;this.B||(this.B=this.wb.setTimeout(this.nd,this.Na), this.ie=w());};e.stop=function(){this.enabled=!1;this.B&&(this.wb.clearTimeout(this.B), this.B=null);};e.F=function(){Gb.L.F.call(this);this.stop();delete this.wb;};function Hb(a,b,c){if(q(a))c&&(a=u(a,c));else if(a&&"function"==typeof a.handleEvent)a=u(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:h.setTimeout(a,b||0)}function Ib(a,b,c){z.call(this);this.Uf=null!=c?u(a,c):a;this.Na=b;this.Xe=u(this.fg,this);this.qc=[];}x(Ib,z);e=Ib.prototype;e.Ta=!1;e.ob=0;e.B=null;e.mf=function(a){this.qc=arguments;this.B||this.ob?this.Ta=!0:this.Cc();};e.stop=function(){this.B&&(h.clearTimeout(this.B), this.B=null, this.Ta=!1, this.qc=[]);};e.pause=function(){this.ob++;};e.resume=function(){this.ob--;this.ob||!this.Ta||this.B||(this.Ta=!1, this.Cc());};e.F=function(){Ib.L.F.call(this);this.stop();};
e.fg=function(){this.B=null;this.Ta&&!this.ob&&(this.Ta=!1, this.Cc());};e.Cc=function(){this.B=Hb(this.Xe,this.Na);this.Uf.apply(null,this.qc);};function Jb(a){z.call(this);this.i=a;this.o={};}x(Jb,z);var Kb=[];e=Jb.prototype;e.nb=function(a,b,c,d){return this.Tf(a,b,c,d)};e.Tf=function(a,b,c,d){n(b)||(b&&(Kb[0]=b.toString()), b=Kb);for(var f=0;f<b.length;f++){var g=ib(a,b[f],c||this.handleEvent,d||!1,this.i||this);if(!g)break;this.o[g.key]=g;}return this};e.Oc=function(a,b,c,d){return this.je(a,b,c,d)};
e.je=function(a,b,c,d,f){if(n(b))for(var g=0;g<b.length;g++)this.je(a,b[g],c,d,f);else{a=jb(a,b,c||this.handleEvent,d,f||this.i||this);if(!a)return this;this.o[a.key]=a;}return this};e.ed=function(a,b,c,d,f){if(n(b))for(var g=0;g<b.length;g++)this.ed(a,b[g],c,d,f);else c=c||this.handleEvent, d=r(d)?!!d.capture:!!d, f=f||this.i||this, c=kb(c), d=!!d, b=F(a)?a.jb(b,c,d,f):a?(a=G(a))?a.jb(b,c,d,f):null:null, b&&(qb(b), delete this.o[b.key]);};
e.pb=function(){Aa(this.o,function(a,b){this.o.hasOwnProperty(b)&&qb(a);},this);this.o={};};e.F=function(){Jb.L.F.call(this);this.pb();};e.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};function J(a,b,c){this.reset(a,b,c,void 0,void 0);}J.prototype.Md=null;J.prototype.reset=function(a,b,c,d,f){this.mb=a;delete this.Md;};J.prototype.Bg=function(a){this.Md=a;};J.prototype.Ge=function(a){this.mb=a;};function Mb(a){this.pe=a;this.Zd=this.uc=this.mb=this.$b=null;}function K(a,b){this.name=a;this.value=b;}K.prototype.toString=function(){return this.name};var Nb=new K("SEVERE",1E3),Ob=new K("WARNING",900),Pb=new K("INFO",800),Qb=new K("CONFIG",700),Rb=new K("FINE",500);e=Mb.prototype;e.getName=function(){return this.pe};e.getParent=function(){return this.$b};e.pf=function(){this.uc||(this.uc={});return this.uc};e.Ge=function(a){this.mb=a;};
e.Qd=function(){if(this.mb)return this.mb;if(this.$b)return this.$b.Qd();ia("Root logger has no level set.");return null};e.Pf=function(a){return a.value>=this.Qd().value};e.log=function(a,b,c){this.Pf(a)&&(q(b)&&(b=b()), this.gf(this.uf(a,b,c)));};e.uf=function(a,b,c){a=new J(a,String(b),this.pe);c&&a.Bg(c);return a};e.ca=function(a,b){this.log(Nb,a,b);};e.T=function(a,b){this.log(Ob,a,b);};e.info=function(a,b){this.log(Pb,a,b);};e.lf=function(a){this.log(Rb,a,void 0);};
e.gf=function(a){for(var b=this;b;)b.We(a), b=b.getParent();};e.We=function(a){if(this.Zd)for(var b=0,c;c=this.Zd[b];b++)c(a);};e.Fg=function(a){this.$b=a;};e.Qe=function(a,b){this.pf()[a]=b;};var Sb={},Tb=null;function Vb(a){Tb||(Tb=new Mb(""), Sb[""]=Tb, Tb.Ge(Qb));var b;if(!(b=Sb[a])){b=new Mb(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Vb(a.substr(0,c));c.Qe(d,b);b.Fg(c);Sb[a]=b;}return b}function Wb(a,b){a&&a.info(b,void 0);}function L(a,b){a&&a.lf(b);}function Xb(){this.s=Vb("goog.labs.net.webChannel.WebChannelDebug");this.Wc=!0;}e=Xb.prototype;e.Id=function(){this.Wc=!1;};e.Tg=function(a,b,c,d,f){var g=this;this.info(function(){return"XMLHTTP REQ ("+c+") [attempt "+d+"]: "+a+"\n"+b+"\n"+g.Xf(f)});};e.Ug=function(a,b,c,d,f,g){this.info(function(){return"XMLHTTP RESP ("+c+") [ attempt "+d+"]: "+a+"\n"+b+"\n"+f+" "+g});};e.Wa=function(a,b,c){var d=this;this.info(function(){return"XMLHTTP TEXT ("+a+"): "+d.ng(b)+(c?" "+c:"")});};
e.Sg=function(a){this.info(function(){return"TIMEOUT: "+a});};e.debug=function(a){L(this.s,a);};e.cb=function(a,b){var c=this.s;c&&c.ca(b||"Exception",a);};e.info=function(a){Wb(this.s,a);};e.T=function(a){var b=this.s;b&&b.T(a,void 0);};e.ca=function(a){var b=this.s;b&&b.ca(a,void 0);};
e.ng=function(a){if(!this.Wc)return a;if(!a)return null;try{var b=JSON.parse(a);if(b)for(var c=0;c<b.length;c++)n(b[c])&&this.Wf(b[c]);return ub(b)}catch(d){return this.debug("Exception parsing expected JS array - probably was not JS"), a}};e.Wf=function(a){if(!(2>a.length||(a=a[1], !n(a)||1>a.length))){var b=a[0];if("noop"!=b&&"stop"!=b&&"close"!=b)for(b=1;b<a.length;b++)a[b]="";}};
e.Xf=function(a){if(!this.Wc)return a;if(!a)return null;var b="";a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].split("=");if(1<d.length){var f=d[0];d=d[1];var g=f.split("_");b=2<=g.length&&"type"==g[1]?b+(f+"="+d+"&"):b+(f+"=redacted&");}}return b};var M=new H;function Yb(a){D.call(this,"serverreachability",a);}x(Yb,D);function N(a){M.dispatchEvent(new Yb(M,a));}function Zb(a,b){D.call(this,"statevent",a);this.stat=b;}x(Zb,D);function O(a){M.dispatchEvent(new Zb(M,a));}function $b(a,b,c){D.call(this,"timingevent",a);this.size=b;this.rtt=c;}x($b,D);function ac(a,b,c){M.dispatchEvent(new $b(M,a,b,c));}function P(a,b){if(!q(a))throw Error("Fn must not be null and must be a function");return h.setTimeout(function(){a();},b)}var bc={NO_ERROR:0,Vg:1,bh:2,ah:3,Yg:4,$g:5,dh:6,Ne:7,TIMEOUT:8,gh:9};var cc={Xg:"complete",kh:"success",Oe:"error",Ne:"abort",ih:"ready",jh:"readystatechange",TIMEOUT:"timeout",eh:"incrementaldata",hh:"progress",Zg:"downloadprogress",lh:"uploadprogress"};function dc(){}dc.prototype.pd=null;dc.prototype.Vd=function(){return this.pd||(this.pd=this.Mf())};function ec(){}var Q={OPEN:"a",Wg:"b",Oe:"c",fh:"d"};function fc(){D.call(this,"d");}x(fc,D);function gc(){D.call(this,"c");}x(gc,D);var hc;function ic(){}x(ic,dc);ic.prototype.Dd=function(){var a=this.Wd();return a?new ActiveXObject(a):new XMLHttpRequest};ic.prototype.Mf=function(){var a={};this.Wd()&&(a[0]=!0, a[1]=!0);return a};
ic.prototype.Wd=function(){if(!this.be&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var a=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],b=0;b<a.length;b++){var c=a[b];try{return new ActiveXObject(c), this.be=c}catch(d){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return this.be};hc=new ic;function R(a,b,c,d,f){this.b=a;this.a=b;this.ra=c;this.R=d;this.Xc=f||1;this.Fc=new Jb(this);this.Ua=jc;a=La?125:void 0;this.Vc=new Gb(a);this.A=null;this.S=!1;this.Da=this.pa=this.ua=this.ic=this.qb=this.hd=this.Ga=null;this.ba=[];this.h=null;this.Bb=0;this.I=this.Fa=null;this.w=-1;this.Za=!1;this.Ra=0;this.ac=null;this.lb=this.Ed=this.yc=!1;}var jc=45E3;
function kc(a,b){switch(a){case 0:return"Non-200 return code ("+b+")";case 1:return"XMLHTTP failure (no data)";case 2:return"HttpConnection timeout";default:return"Unknown error"}}var lc={},mc={};e=R.prototype;e.ga=function(a){this.A=a;};e.setTimeout=function(a){this.Ua=a;};e.He=function(a){this.Ra=a;};e.Gg=function(a){this.ba=a;};e.la=function(){return this.ba};e.kd=function(a,b){this.ic=1;this.ua=a.clone().Ub();this.Da=b;this.yc=!0;this.Ce(null);};
e.jd=function(a,b,c){this.ic=1;this.ua=a.clone().Ub();this.Da=null;this.yc=b;this.Ce(c);};
e.Ce=function(a){this.qb=w();this.eb();this.pa=this.ua.clone();this.pa.dc("t",this.Xc);this.Bb=0;this.h=this.b.Jb(this.b.fc()?a:null);0<this.Ra&&(this.ac=new Ib(u(this.Me,this,this.h),this.Ra));this.Fc.nb(this.h,"readystatechange",this.mg);a=this.A?Da(this.A):{};this.Da?(this.Fa||(this.Fa="POST"), a["Content-Type"]="application/x-www-form-urlencoded", this.h.send(this.pa,this.Fa,this.Da,a)):(this.Fa="GET", this.h.send(this.pa,this.Fa,null,a));N(1);this.a.Tg(this.Fa,this.pa,this.R,this.Xc,this.Da);};
e.mg=function(a){a=a.target;var b=this.ac;b&&3==a.ma()?(this.a.debug("Throttling readystatechange."), b.mf()):this.Me(a);};e.Me=function(a){try{a==this.h?this.hg():this.a.T("Called back with an unexpected xmlhttp");}catch(c){if(this.a.debug("Failed call to OnXmlHttpReadyStateChanged_"), this.h&&this.h.ya()){var b=this;this.a.cb(c,function(){return"ResponseText: "+b.h.ya()});}else this.a.cb(c,"No response text");}finally{}};
e.hg=function(){var a=this.h.ma(),b=this.h.Ud(),c=this.h.za();if(!(3>a||3==a&&!La&&!this.h.ya())){this.Za||4!=a||7==b||(8==b||0>=c?N(3):N(2));this.Fb();var d=this.h.za();this.w=d;b=this.h.ya();if(!b){var f=this;this.a.debug(function(){return"No response text for uri "+f.pa+" status "+d});}this.S=200==d;this.a.Ug(this.Fa,this.pa,this.R,this.Xc,a,d);if(this.S){if(this.Ig())if(c=this.sf())this.a.Wa(this.R,c,"Initial handshake response via X-HTTP-Initial-Response"), this.lb=!0, this.Yc(c);else{this.S=!1;
this.I=3;O(12);this.a.T("XMLHTTP Missing X_HTTP_INITIAL_RESPONSE ("+this.R+")");this.Ia();this.Kb();return}this.yc?(this.Fd(a,b), La&&this.S&&3==a&&this.Ng()):(this.a.Wa(this.R,b,null), this.Yc(b));4==a&&this.Ia();this.S&&!this.Za&&(4==a?this.b.Tc(this):(this.S=!1, this.eb()));}else 400==d&&0<b.indexOf("Unknown SID")?(this.I=3, O(12), this.a.T("XMLHTTP Unknown SID ("+this.R+")")):(this.I=0, O(13), this.a.T("XMLHTTP Bad status "+d+" ("+this.R+")")), this.Ia(), this.Kb();}};e.Ig=function(){return this.Ed&&!this.lb};
e.sf=function(){if(this.h){var a=this.h.kb("X-HTTP-Initial-Response");if(a&&!va(a))return a}return null};e.Ag=function(){this.Ed=!0;};
e.Fd=function(a,b){for(var c=!0;!this.Za&&this.Bb<b.length;){var d=this.vf(b);if(d==mc){4==a&&(this.I=4, O(14), c=!1);this.a.Wa(this.R,null,"[Incomplete Response]");break}else if(d==lc){this.I=4;O(15);this.a.Wa(this.R,b,"[Invalid Chunk]");c=!1;break}else this.a.Wa(this.R,d,null), this.Yc(d);}4==a&&0==b.length&&(this.I=1, O(16), c=!1);this.S=this.S&&c;c||(this.a.Wa(this.R,b,"[Invalid Chunked Response]"), this.Ia(), this.Kb());};
e.kg=function(){if(this.h){var a=this.h.ma(),b=this.h.ya();this.Bb<b.length&&(this.Fb(), this.Fd(a,b), this.S&&4!=a&&this.eb());}};e.Ng=function(){this.Fc.nb(this.Vc,"tick",this.kg);this.Vc.start();};e.vf=function(a){var b=this.Bb,c=a.indexOf("\n",b);if(-1==c)return mc;b=Number(a.substring(b,c));if(isNaN(b))return lc;c+=1;if(c+b>a.length)return mc;a=a.substr(c,b);this.Bb=c+b;return a};
e.yg=function(a){this.ic=2;this.ua=a.clone().Ub();a=!1;h.navigator&&h.navigator.sendBeacon&&(a=h.navigator.sendBeacon(this.ua.toString(),""));!a&&h.Image&&((new Image).src=this.ua, a=!0);a||(this.h=this.b.Jb(null), this.h.send(this.ua));this.qb=w();this.eb();};e.cancel=function(){this.Za=!0;this.Ia();};e.tg=function(a){a&&this.setTimeout(a);this.Ga&&(this.Fb(), this.eb());};e.eb=function(){this.hd=w()+this.Ua;this.Ke(this.Ua);};
e.Ke=function(a){if(null!=this.Ga)throw Error("WatchDog timer not null");this.Ga=P(u(this.gg,this),a);};e.Fb=function(){this.Ga&&(h.clearTimeout(this.Ga), this.Ga=null);};e.gg=function(){this.Ga=null;var a=w();0<=a-this.hd?this.Df():(this.a.T("WatchDog timer called too early"), this.Ke(this.hd-a));};e.Df=function(){this.S&&this.a.ca("Received watchdog timeout even though request loaded successfully");this.a.Sg(this.pa);2!=this.ic&&(N(3), O(17));this.Ia();this.I=2;this.Kb();};
e.Kb=function(){this.b.de()||this.Za||this.b.Tc(this);};e.Ia=function(){this.Fb();var a=this.ac;a&&"function"==typeof a.bb&&a.bb();this.ac=null;this.Vc.stop();this.Fc.pb();this.h&&(a=this.h, this.h=null, a.abort(), a.bb());};e.Hc=function(){return this.I};e.Yc=function(a){try{this.b.ue(this,a), N(4);}catch(b){this.a.cb(b,"Error in httprequest callback");}};function nc(a){if(a.H&&"function"==typeof a.H)return a.H();if(l(a))return a.split("");if(ca(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Ba(a)}
function oc(a,b,c){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,c);else if(ca(a)||l(a))na(a,b,c);else{if(a.W&&"function"==typeof a.W)var d=a.W();else if(a.H&&"function"==typeof a.H)d=void 0;else if(ca(a)||l(a)){d=[];for(var f=a.length,g=0;g<f;g++)d.push(g);}else d=Ca(a);f=nc(a);g=f.length;for(var k=0;k<g;k++)b.call(c,f[k],d&&d[k],a);}}function S(a,b){this.D={};this.o=[];this.j=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1]);}else a&&this.addAll(a);}e=S.prototype;e.C=function(){return this.j};e.H=function(){this.wc();for(var a=[],b=0;b<this.o.length;b++)a.push(this.D[this.o[b]]);return a};e.W=function(){this.wc();return this.o.concat()};e.va=function(a){return T(this.D,a)};e.X=function(){return 0==this.j};
e.clear=function(){this.D={};this.j=this.o.length=0;};e.remove=function(a){return T(this.D,a)?(delete this.D[a], this.j--, this.o.length>2*this.j&&this.wc(), !0):!1};e.wc=function(){if(this.j!=this.o.length){for(var a=0,b=0;a<this.o.length;){var c=this.o[a];T(this.D,c)&&(this.o[b++]=c);a++;}this.o.length=b;}if(this.j!=this.o.length){var d={};for(b=a=0;a<this.o.length;)c=this.o[a], T(d,c)||(this.o[b++]=c, d[c]=1), a++;this.o.length=b;}};e.get=function(a,b){return T(this.D,a)?this.D[a]:b};
e.set=function(a,b){T(this.D,a)||(this.j++, this.o.push(a));this.D[a]=b;};e.addAll=function(a){if(a instanceof S)for(var b=a.W(),c=0;c<b.length;c++)this.set(b[c],a.get(b[c]));else for(b in a)this.set(b,a[b]);};e.forEach=function(a,b){for(var c=this.W(),d=0;d<c.length;d++){var f=c[d],g=this.get(f);a.call(b,g,f,this);}};e.clone=function(){return new S(this)};function T(a,b){return Object.prototype.hasOwnProperty.call(a,b)}var pc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function qc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),f=null;if(0<=d){var g=a[c].substring(0,d);f=a[c].substring(d+1);}else g=a[c];b(g,f?decodeURIComponent(f.replace(/\+/g," ")):"");}}}function U(a,b){this.xa=this.zb=this.qa="";this.Ca=null;this.ib=this.K="";this.O=this.Qf=!1;var c;a instanceof U?(this.O=void 0!==b?b:a.O, this.tb(a.qa), this.cd(a.zb), this.rb(a.xa), this.sb(a.Ca), this.ec(a.K), this.bd(a.P.clone()), this.$c(a.ib)):a&&(c=String(a).match(pc))?(this.O=!!b, this.tb(c[1]||"",!0), this.cd(c[2]||"",!0), this.rb(c[3]||"",!0), this.sb(c[4]), this.ec(c[5]||"",!0), this.bd(c[6]||"",!0), this.$c(c[7]||"",!0)):(this.O=!!b, this.P=new rc(null,this.O));}e=U.prototype;
e.toString=function(){var a=[],b=this.qa;b&&a.push(sc(b,tc,!0),":");var c=this.xa;if(c||"file"==b)a.push("//"), (b=this.zb)&&a.push(sc(b,tc,!0),"@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")), c=this.Ca, null!=c&&a.push(":",String(c));if(c=this.K)this.Ic()&&"/"!=c.charAt(0)&&a.push("/"), a.push(sc(c,"/"==c.charAt(0)?uc:wc,!0));(c=this.Rd())&&a.push("?",c);(c=this.ib)&&a.push("#",sc(c,xc));return a.join("")};
e.resolve=function(a){var b=this.clone(),c=a.Hf();c?b.tb(a.qa):c=a.If();c?b.cd(a.zb):c=a.Ic();c?b.rb(a.xa):c=a.Ff();var d=a.K;if(c)b.sb(a.Ca);else if(c=a.ae()){if("/"!=d.charAt(0))if(this.Ic()&&!this.ae())d="/"+d;else{var f=b.K.lastIndexOf("/");-1!=f&&(d=b.K.substr(0,f+1)+d);}f=d;if(".."==f||"."==f)d="";else if(-1!=f.indexOf("./")||-1!=f.indexOf("/.")){d=0==f.lastIndexOf("/",0);f=f.split("/");for(var g=[],k=0;k<f.length;){var p=f[k++];"."==p?d&&k==f.length&&g.push(""):".."==p?((1<g.length||1==g.length&&
""!=g[0])&&g.pop(), d&&k==f.length&&g.push("")):(g.push(p), d=!0);}d=g.join("/");}else d=f;}c?b.ec(d):c=a.Gf();c?b.bd(a.P.clone()):c=a.Ef();c&&b.$c(a.ib);return b};e.clone=function(){return new U(this)};e.tb=function(a,b){this.U();if(this.qa=b?yc(a,!0):a)this.qa=this.qa.replace(/:$/,"");};e.Hf=function(){return!!this.qa};e.cd=function(a,b){this.U();this.zb=b?yc(a):a;};e.If=function(){return!!this.zb};e.rb=function(a,b){this.U();this.xa=b?yc(a,!0):a;};e.Ic=function(){return!!this.xa};
e.sb=function(a){this.U();if(a){a=Number(a);if(isNaN(a)||0>a)throw Error("Bad port number "+a);this.Ca=a;}else this.Ca=null;};e.Ff=function(){return null!=this.Ca};e.ec=function(a,b){this.U();this.K=b?yc(a,!0):a;};e.ae=function(){return!!this.K};e.Gf=function(){return""!==this.P.toString()};e.bd=function(a,b){this.U();a instanceof rc?(this.P=a, this.P.ad(this.O)):(b||(a=sc(a,zc)), this.P=new rc(a,this.O));};e.Rd=function(){return this.P.toString()};e.getQuery=function(){return this.Rd()};
e.l=function(a,b){this.U();this.P.set(a,b);};e.dc=function(a,b){this.U();n(b)||(b=[String(b)]);this.P.Ie(a,b);};e.$c=function(a,b){this.U();this.ib=b?yc(a):a;};e.Ef=function(){return!!this.ib};e.Ub=function(){this.U();this.l("zx",Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^w()).toString(36));return this};e.removeParameter=function(a){this.U();this.P.remove(a);return this};e.U=function(){if(this.Qf)throw Error("Tried to modify a read-only Uri");};
e.ad=function(a){this.O=a;this.P&&this.P.ad(a);};function Ac(a){return a instanceof U?a.clone():new U(a,void 0)}function Bc(a,b,c,d){var f=new U(null,void 0);a&&f.tb(a);b&&f.rb(b);c&&f.sb(c);d&&f.ec(d);return f}function yc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function sc(a,b,c){return l(a)?(a=encodeURI(a).replace(b,Cc), c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")), a):null}
function Cc(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var tc=/[#\/\?@]/g,wc=/[#\?:]/g,uc=/[#\?]/g,zc=/[#\?@]/g,xc=/#/g;function rc(a,b){this.j=this.m=null;this.ja=a||null;this.O=!!b;}e=rc.prototype;e.$=function(){if(!this.m&&(this.m=new S, this.j=0, this.ja)){var a=this;qc(this.ja,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c);});}};e.C=function(){this.$();return this.j};
e.add=function(a,b){this.$();this.Oa();a=this.Ma(a);var c=this.m.get(a);c||this.m.set(a,c=[]);c.push(b);this.j+=1;return this};e.remove=function(a){this.$();a=this.Ma(a);return this.m.va(a)?(this.Oa(), this.j-=this.m.get(a).length, this.m.remove(a)):!1};e.clear=function(){this.Oa();this.m=null;this.j=0;};e.X=function(){this.$();return 0==this.j};e.va=function(a){this.$();a=this.Ma(a);return this.m.va(a)};
e.forEach=function(a,b){this.$();this.m.forEach(function(c,d){na(c,function(c){a.call(b,c,d,this);},this);},this);};e.W=function(){this.$();for(var a=this.m.H(),b=this.m.W(),c=[],d=0;d<b.length;d++)for(var f=a[d],g=0;g<f.length;g++)c.push(b[d]);return c};e.H=function(a){this.$();var b=[];if(l(a))this.va(a)&&(b=ta(b,this.m.get(this.Ma(a))));else{a=this.m.H();for(var c=0;c<a.length;c++)b=ta(b,a[c]);}return b};
e.set=function(a,b){this.$();this.Oa();a=this.Ma(a);this.va(a)&&(this.j-=this.m.get(a).length);this.m.set(a,[b]);this.j+=1;return this};e.get=function(a,b){if(!a)return b;a=this.H(a);return 0<a.length?String(a[0]):b};e.Ie=function(a,b){this.remove(a);0<b.length&&(this.Oa(), this.m.set(this.Ma(a),ua(b)), this.j+=b.length);};
e.toString=function(){if(this.ja)return this.ja;if(!this.m)return"";for(var a=[],b=this.m.W(),c=0;c<b.length;c++){var d=b[c],f=encodeURIComponent(String(d));d=this.H(d);for(var g=0;g<d.length;g++){var k=f;""!==d[g]&&(k+="="+encodeURIComponent(String(d[g])));a.push(k);}}return this.ja=a.join("&")};e.Oa=function(){this.ja=null;};e.clone=function(){var a=new rc;a.ja=this.ja;this.m&&(a.m=this.m.clone(), a.j=this.j);return a};e.Ma=function(a){a=String(a);this.O&&(a=a.toLowerCase());return a};
e.ad=function(a){a&&!this.O&&(this.$(), this.Oa(), this.m.forEach(function(a,c){var b=c.toLowerCase();c!=b&&(this.remove(c), this.Ie(b,a));},this));this.O=a;};e.extend=function(a){for(var b=0;b<arguments.length;b++)oc(arguments[b],function(a,b){this.add(b,a);},this);};function Fc(){}function Gc(){}x(Gc,Fc);function Hc(a,b){this.b=a;this.a=b;this.f=this.A=null;this.bc=!1;this.K=null;this.w=-1;this.Ad=this.na=null;}e=Hc.prototype;e.g=null;e.ga=function(a){this.A=a;};e.connect=function(a){this.K=a;a=this.b.Sd(this.K);O(3);var b=this.b.Ib.$d;null!=b?(this.na=this.b.$a(b[0]), this.g=1, this.xd()):(a.dc("MODE","init"), !this.b.ta&&this.b.aa&&a.dc("X-HTTP-Session-Id",this.b.aa), this.f=new R(this,this.a,void 0,void 0,void 0), this.f.ga(this.A), this.f.jd(a,!1,null), this.g=0);};
e.xd=function(){this.a.debug("TestConnection: starting stage 2");var a=this.b.Ib.od;if(null!=a)this.a.debug(function(){return true?"Buffered":"Unbuffered"}), O(4), a?(O(10), this.b.ub(this,!1)):(O(11), this.b.ub(this,!0));else{this.f=new R(this,this.a,void 0,void 0,void 0);this.f.ga(this.A);var b=this.b.Pd(this.na,this.K);O(4);b.dc("TYPE","xmlhttp");var c=this.b.aa,d=this.b.Kc;c&&d&&b.l(c,d);this.f.jd(b,!1,this.na);}};e.Jb=function(a){return this.b.Jb(a)};
e.abort=function(){this.f&&(this.f.cancel(), this.f=null);this.w=-1;};e.de=function(){return!1};
e.ue=function(a,b){this.w=a.w;if(0==this.g)if(this.a.debug("TestConnection: Got data for stage 1"), this.pc(a), b){try{var c=this.b.kc.zc(b);}catch(d){this.a.cb(d);this.b.dd(this);return}this.na=this.b.$a(c[0]);}else this.a.debug("TestConnection: Null responseText"), this.b.dd(this);else 1==this.g&&(this.bc?O(6):"11111"==b?(O(5), this.bc=!0, this.Ze()&&(this.w=200, this.f.cancel(), this.a.debug("Test connection succeeded; using streaming connection"), O(11), this.b.ub(this,!0))):(O(7), this.bc=!1));};
e.Tc=function(){this.w=this.f.w;this.f.S?0==this.g?(this.g=1, this.a.debug("TestConnection: request complete for initial check"), this.xd()):1==this.g&&(this.a.debug("TestConnection: request complete for stage 2"), this.bc?(this.a.debug("Test connection succeeded; using streaming connection"), O(11), this.b.ub(this,!0)):(this.a.debug("Test connection failed; not using streaming"), O(10), this.b.ub(this,!1))):(this.a.debug("TestConnection: request failed, in state "+this.g), 0==this.g?O(8):1==this.g&&O(9), this.b.dd(this));};e.pc=function(a){if(!this.b.ta&&(a=a.h)){var b=a.kb("X-Client-Wire-Protocol");this.Ad=b?b:null;this.b.aa&&((a=a.kb("X-HTTP-Session-Id"))?this.b.Fe(a):this.a.T("Missing X_HTTP_SESSION_ID in the handshake response"));}};e.fc=function(){return this.b.fc()};e.Ba=function(){return this.b.Ba()};e.Ze=function(){return!C||10<=Number(Ua)};function Ic(){this.od=this.$d=null;}function Jc(a){this.D=new S;a&&this.addAll(a);}function Kc(a){var b=typeof a;return"object"==b&&a||"function"==b?"o"+(a[t]||(a[t]=++da)):b.substr(0,1)+a}e=Jc.prototype;e.C=function(){return this.D.C()};e.add=function(a){this.D.set(Kc(a),a);};e.addAll=function(a){a=nc(a);for(var b=a.length,c=0;c<b;c++)this.add(a[c]);};e.pb=function(a){a=nc(a);for(var b=a.length,c=0;c<b;c++)this.remove(a[c]);};e.remove=function(a){return this.D.remove(Kc(a))};e.clear=function(){this.D.clear();};e.X=function(){return this.D.X()};
e.contains=function(a){return this.D.va(Kc(a))};e.H=function(){return this.D.H()};e.clone=function(){return new Jc(this)};function Lc(a,b){this.Pc=a;this.map=b;this.context=null;}function Mc(a){this.me=a||Nc;h.PerformanceNavigationTiming?(a=h.performance.getEntriesByType("navigation"), a=0<a.length&&("hq"==a[0].nextHopProtocol||"h2"==a[0].nextHopProtocol)):a=!!(h.vc&&h.vc.ke&&h.vc.ke()&&h.vc.ke().nh);this.Xb=a?this.me:1;this.v=null;1<this.Xb&&(this.v=new Jc);this.f=null;this.ba=[];}var Nc=10;e=Mc.prototype;e.ld=function(a){this.v||-1==a.indexOf("spdy")&&-1==a.indexOf("quic")&&-1==a.indexOf("h2")||(this.Xb=this.me, this.v=new Jc, this.f&&(this.oc(this.f), this.f=null));};
e.ee=function(){return this.f?!0:this.v?this.v.C()>=this.Xb:!1};e.xf=function(){return this.f?1:this.v?this.v.C():0};e.Jc=function(a){return this.f?this.f==a:this.v?this.v.contains(a):!1};e.oc=function(a){this.v?this.v.add(a):this.f=a;};e.ze=function(a){this.f&&this.f==a?this.f=null:this.v&&this.v.contains(a)&&this.v.remove(a);};e.cancel=function(){this.ba=this.la();this.f?(this.f.cancel(), this.f=null):this.v&&!this.v.X()&&(na(this.v.H(),function(a){a.cancel();}), this.v.clear());};
e.la=function(){if(null!=this.f)return this.ba.concat(this.f.la());if(null!=this.v&&!this.v.X()){var a=this.ba;na(this.v.H(),function(b){a=a.concat(b.la());});return a}return ua(this.ba)};e.Re=function(a){this.ba=this.ba.concat(a);};e.$e=function(){this.ba.length=0;};function Oc(){this.xg=this.rg=void 0;}Oc.prototype.stringify=function(a){return h.JSON.stringify(a,this.rg)};Oc.prototype.parse=function(a){return h.JSON.parse(a,this.xg)};function Pc(){this.jg=new Oc;}Pc.prototype.hf=function(a,b,c){var d=c||"";try{oc(a,function(a,c){var f=a;r(a)&&(f=ub(a));b.push(d+c+"="+encodeURIComponent(f));});}catch(f){throw b.push(d+"type="+encodeURIComponent("_badmap")), f;}};Pc.prototype.jf=function(a,b,c){for(var d=-1;;){var f=["count="+b];-1==d?0<b?(d=a[0].Pc, f.push("ofs="+d)):d=0:f.push("ofs="+d);for(var g=!0,k=0;k<b;k++){var p=a[k].Pc,Ub=a[k].map;p-=d;if(0>p)d=Math.max(0,a[k].Pc-100), g=!1;else try{this.hf(Ub,f,"req"+p+"_");}catch(md){c&&c(Ub);}}if(g)return f.join("&")}};
Pc.prototype.zc=function(a){return this.jg.parse(a)};function Qc(a,b){var c=new Xb;c.debug("TestLoadImage: loading "+a);var d=new Image;d.onload=v(Rc,c,d,"TestLoadImage: loaded",!0,b);d.onerror=v(Rc,c,d,"TestLoadImage: error",!1,b);d.onabort=v(Rc,c,d,"TestLoadImage: abort",!1,b);d.ontimeout=v(Rc,c,d,"TestLoadImage: timeout",!1,b);h.setTimeout(function(){if(d.ontimeout)d.ontimeout();},1E4);d.src=a;}function Rc(a,b,c,d,f){try{a.debug(c), b.onload=null, b.onerror=null, b.onabort=null, b.ontimeout=null, f(d);}catch(g){a.cb(g);}}var Sc=h.JSON.parse;function V(a){H.call(this);this.headers=new S;this.Xa=a||null;this.ha=!1;this.mc=this.c=null;this.ge=this.Tb="";this.Pa=0;this.I="";this.Aa=this.Lc=this.Qb=this.Ec=!1;this.vb=0;this.hc=null;this.Ae=Tc;this.jc=this.lg=this.Ab=!1;}x(V,H);var Tc="";V.prototype.s=Vb("goog.net.XhrIo");var Uc=/^https?$/i,Vc=["POST","PUT"];e=V.prototype;e.Je=function(a){this.Ab=a;};
e.send=function(a,b,c,d){if(this.c)throw Error("[goog.net.XhrIo] Object is active with another request="+this.Tb+"; newUri="+a);b=b?b.toUpperCase():"GET";this.Tb=a;this.I="";this.Pa=0;this.ge=b;this.Ec=!1;this.ha=!0;this.c=this.df();this.mc=this.Xa?this.Xa.Vd():hc.Vd();this.c.onreadystatechange=u(this.te,this);this.lg&&"onprogress"in this.c&&(this.c.onprogress=u(function(a){this.re(a,!0);},this), this.c.upload&&(this.c.upload.onprogress=u(this.re,this)));try{L(this.s,this.da("Opening Xhr")), this.Lc=
!0, this.c.open(b,String(a),!0), this.Lc=!1;}catch(g){L(this.s,this.da("Error opening Xhr: "+g.message));this.Ld(g);return}a=c||"";var f=this.headers.clone();d&&oc(d,function(a,b){f.set(b,a);});d=pa(f.W());c=h.FormData&&a instanceof h.FormData;!(0<=la(Vc,b))||d||c||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(a,b){this.c.setRequestHeader(b,a);},this);this.Ae&&(this.c.responseType=this.Ae);"withCredentials"in this.c&&this.c.withCredentials!==this.Ab&&(this.c.withCredentials=
this.Ab);try{this.yd(), 0<this.vb&&(this.jc=Wc(this.c), L(this.s,this.da("Will abort after "+this.vb+"ms if incomplete, xhr2 "+this.jc)), this.jc?(this.c.timeout=this.vb, this.c.ontimeout=u(this.Ua,this)):this.hc=Hb(this.Ua,this.vb,this)), L(this.s,this.da("Sending request")), this.Qb=!0, this.c.send(a), this.Qb=!1;}catch(g){L(this.s,this.da("Send error: "+g.message)), this.Ld(g);}};function Wc(a){return C&&Ta(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}
function qa(a){return"content-type"==a.toLowerCase()}e.df=function(){return this.Xa?this.Xa.Dd():hc.Dd()};e.Ua=function(){"undefined"!=typeof goog&&this.c&&(this.I="Timed out after "+this.vb+"ms, aborting", this.Pa=8, L(this.s,this.da(this.I)), this.dispatchEvent("timeout"), this.abort(8));};e.Ld=function(a){this.ha=!1;this.c&&(this.Aa=!0, this.c.abort(), this.Aa=!1);this.I=a;this.Pa=5;this.Jd();this.Gb();};e.Jd=function(){this.Ec||(this.Ec=!0, this.dispatchEvent("complete"), this.dispatchEvent("error"));};
e.abort=function(a){this.c&&this.ha&&(L(this.s,this.da("Aborting")), this.ha=!1, this.Aa=!0, this.c.abort(), this.Aa=!1, this.Pa=a||7, this.dispatchEvent("complete"), this.dispatchEvent("abort"), this.Gb());};e.F=function(){this.c&&(this.ha&&(this.ha=!1, this.Aa=!0, this.c.abort(), this.Aa=!1), this.Gb(!0));V.L.F.call(this);};e.te=function(){this.Ka||(this.Lc||this.Qb||this.Aa?this.se():this.eg());};e.eg=function(){this.se();};
e.se=function(){if(this.ha&&"undefined"!=typeof goog)if(this.mc[1]&&4==this.ma()&&2==this.za())L(this.s,this.da("Local request error detected and ignored"));else if(this.Qb&&4==this.ma())Hb(this.te,0,this);else if(this.dispatchEvent("readystatechange"), this.Mc()){L(this.s,this.da("Request complete"));this.ha=!1;try{this.Rf()?(this.dispatchEvent("complete"), this.dispatchEvent("success")):(this.Pa=6, this.I=this.Yd()+" ["+this.za()+"]", this.Jd());}finally{this.Gb();}}};
e.re=function(a,b){this.dispatchEvent(Xc(a,"progress"));this.dispatchEvent(Xc(a,b?"downloadprogress":"uploadprogress"));};function Xc(a,b){return{type:b,lengthComputable:a.lengthComputable,loaded:a.loaded,total:a.total}}e.Gb=function(a){if(this.c){this.yd();var b=this.c,c=this.mc[0]?aa:null;this.mc=this.c=null;a||this.dispatchEvent("ready");try{b.onreadystatechange=c;}catch(d){(a=this.s)&&a.ca("Problem encountered resetting onreadystatechange: "+d.message,void 0);}}};
e.yd=function(){this.c&&this.jc&&(this.c.ontimeout=null);this.hc&&(h.clearTimeout(this.hc), this.hc=null);};e.Ba=function(){return!!this.c};e.Mc=function(){return 4==this.ma()};e.Rf=function(){var a=this.za();a:switch(a){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var b=!0;break a;default:b=!1;}return b||0===a&&!this.Of()};
e.Of=function(){var a=String(this.Tb).match(pc)[1]||null;!a&&h.self&&h.self.location&&(a=h.self.location.protocol, a=a.substr(0,a.length-1));return Uc.test(a?a.toLowerCase():"")};e.ma=function(){return this.c?this.c.readyState:0};e.za=function(){try{return 2<this.ma()?this.c.status:-1}catch(a){return-1}};e.Yd=function(){try{return 2<this.ma()?this.c.statusText:""}catch(a){return L(this.s,"Can not get status: "+a.message), ""}};
e.ya=function(){try{return this.c?this.c.responseText:""}catch(a){return L(this.s,"Can not get responseText: "+a.message), ""}};e.yf=function(a){if(this.c){var b=this.c.responseText;a&&0==b.indexOf(a)&&(b=b.substring(a.length));return Sc(b)}};e.getResponseHeader=function(a){if(this.c&&this.Mc())return a=this.c.getResponseHeader(a), null===a?void 0:a};e.getAllResponseHeaders=function(){return this.c&&this.Mc()?this.c.getAllResponseHeaders()||"":""};
e.kb=function(a){return this.c?this.c.getResponseHeader(a):null};e.Ud=function(){return this.Pa};e.Hc=function(){return l(this.I)?this.I:String(this.I)};e.da=function(a){return a+" ["+this.ge+" "+this.Tb+" "+this.za()+"]"};function Yc(a){var b="";Aa(a,function(a,d){b+=d;b+=":";b+=a;b+="\r\n";});return b}function Zc(a,b,c){a:{for(d in c){var d=!1;break a}d=!0;}if(d)return a;c=Yc(c);if(l(a)){b=encodeURIComponent(String(b));c=null!=c?"="+encodeURIComponent(String(c)):"";if(b+=c){c=a.indexOf("#");0>c&&(c=a.length);d=a.indexOf("?");if(0>d||d>c){d=c;var f="";}else f=a.substring(d+1,c);a=[a.substr(0,d),f,a.substr(c)];c=a[1];a[1]=b?c?c+"&"+b:b:c;a=a[0]+(a[1]?"?"+a[1]:"")+a[2];}return a}a.l(b,c);return a}function $c(a){this.Bd=22;this.De=0;this.M=[];this.a=new Xb;this.Ib=new Ic;this.na=this.md=this.hb=this.K=this.u=this.Kc=this.aa=this.gb=this.N=this.Rb=this.A=null;this.Te=!0;this.ag=this.Yb=0;this.kf=!!m("internalChannelParams.failFast",a);this.fd=this.Ja=this.wa=this.ia=this.ea=this.i=null;this.Se=!0;this.w=this.he=this.Sb=-1;this.rc=this.Ha=this.La=0;this.Ve=m("internalChannelParams.baseRetryDelayMs",a)||5E3;this.vg=m("internalChannelParams.retryDelaySeedMs",a)||1E4;this.nf=m("internalChannelParams.forwardChannelMaxRetries",
a)||2;this.Od=m("internalChannelParams.forwardChannelRequestTimeoutMs",a)||2E4;this.Xa=a&&a.oh||void 0;this.Db=void 0;this.Ra=0;this.gc=a&&a.supportsCrossDomainXhr||!1;this.ra="";this.G=new Mc(a&&a.concurrentRequestLimit);this.kc=new Pc;this.ta=a&&void 0!==a.backgroundChannelTest?a.backgroundChannelTest:!0;(this.Nd=a&&a.fastHandshake||!1)&&!this.ta&&(this.a.T("Force backgroundChannelTest when fastHandshake is enabled."), this.ta=!0);a&&a.Id&&this.a.Id();}e=$c.prototype;e.tc=8;e.g=1;
e.connect=function(a,b,c,d,f){this.a.debug("connect()");O(0);this.K=b;this.gb=c||{};d&&void 0!==f&&(this.gb.OSID=d, this.gb.OAID=f);this.ta&&(this.a.debug("connect() bypassed channel-test."), this.Ib.$d=[], this.Ib.od=!1);this.bf(a);};e.disconnect=function(){this.a.debug("disconnect()");this.qd();if(3==this.g){var a=this.Yb++,b=this.hb.clone();b.l("SID",this.ra);b.l("RID",a);b.l("TYPE","terminate");this.Ya(b);(new R(this,this.a,this.ra,a,void 0)).yg(b);}this.qe();};
e.bf=function(a){this.a.debug("connectTest_()");this.Ja=new Hc(this,this.a);null===this.N&&this.Ja.ga(this.A);var b=a;this.N&&this.A&&(b=Zc(a,this.N,this.A));this.Ja.connect(b);};e.af=function(){this.a.debug("connectChannel_()");this.hb=this.Sd(this.K);this.Dc();};e.qd=function(){this.Ja&&(this.Ja.abort(), this.Ja=null);this.u&&(this.u.cancel(), this.u=null);this.ia&&(h.clearTimeout(this.ia), this.ia=null);this.Hb();this.G.cancel();this.ea&&(h.clearTimeout(this.ea), this.ea=null);};
e.ga=function(a){this.A=a;};e.Eg=function(a){this.Rb=a;};e.Cg=function(a){this.N=a;};e.Dg=function(a){this.aa=a;};e.Fe=function(a){this.Kc=a;};e.He=function(a){this.Ra=a;};e.Hg=function(){this.gc=!0;};e.Ee=function(a){this.i=a;};e.Nf=function(){return!this.fd};e.Zc=function(a){1E3==this.M.length&&this.a.ca(function(){return"Already have 1000 queued maps upon queueing "+ub(a)});this.M.push(new Lc(this.ag++,a));3==this.g&&this.Dc();};e.qf=function(){return this.kf?0:this.nf};e.de=function(){return 0==this.g};
e.getState=function(){return this.g};e.Dc=function(){this.G.ee()||this.ea||(this.ea=P(u(this.we,this),0), this.La=0);};e.Yf=function(a){if(this.G.xf()>=this.G.Xb-(this.ea?1:0))return this.a.ca("Unexpected retry request is scheduled."), !1;if(this.ea)return this.a.debug("Use the retry request that is already scheduled."), this.M=a.la().concat(this.M), !0;if(1==this.g||2==this.g||this.La>=this.qf())return!1;this.a.debug("Going to retry POST");this.ea=P(u(this.we,this,a),this.Xd(this.La));this.La++;return!0};
e.we=function(a){this.ea=null;this.Mg(a);};e.Mg=function(a){this.a.debug("startForwardChannel_");1==this.g?a?this.a.ca("Not supposed to retry the open"):(this.ig(), this.g=2):3==this.g&&(a?this.le(a):0==this.M.length?this.a.debug("startForwardChannel_ returned: nothing to send"):this.G.ee()?this.a.ca("startForwardChannel_ returned: connection already in progress"):(this.le(), this.a.debug("startForwardChannel_ finished, sent request")));};
e.ig=function(){this.a.debug("open_()");this.Yb=Math.floor(1E5*Math.random());var a=this.Yb++,b=new R(this,this.a,"",a,void 0),c=this.A;this.Rb&&(c?(c=Da(c), Fa(c,this.Rb)):c=this.Rb);null===this.N&&b.ga(c);var d=this.Hd(b),f=this.hb.clone();f.l("RID",a);0<this.Bd&&f.l("CVER",this.Bd);this.ta&&this.aa&&f.l("X-HTTP-Session-Id",this.aa);this.Ya(f);this.N&&c&&Zc(f,this.N,c);this.G.oc(b);this.Nd?(f.l("$req",d), f.l("SID","null"), b.Ag(), b.kd(f,null)):b.kd(f,d);};
e.le=function(a){var b=a?a.R:this.Yb++;var c=this.hb.clone();c.l("SID",this.ra);c.l("RID",b);c.l("AID",this.Sb);this.Ya(c);this.N&&this.A&&Zc(c,this.N,this.A);b=new R(this,this.a,this.ra,b,this.La+1);null===this.N&&b.ga(this.A);a&&this.sg(a);a=this.Hd(b);b.setTimeout(Math.round(.5*this.Od)+Math.round(.5*this.Od*Math.random()));this.G.oc(b);b.kd(c,a);};e.Ya=function(a){this.i&&oc({},function(b,c){a.l(c,b);});};
e.Hd=function(a){var b=Math.min(this.M.length,1E3),c=this.i?u(this.i.Ue,this.i,this):null;c=this.kc.jf(this.M,b,c);a.Gg(this.M.splice(0,b));return c};e.sg=function(a){this.M=a.la().concat(this.M);};e.Kd=function(){if(!this.u&&!this.ia){this.rc=1;var a=this.ve;Bb||Cb();Eb||(Bb(), Eb=!0);Fb.add(a,this);this.Ha=0;}};
e.Qc=function(){if(this.u||this.ia)return this.a.ca("Request already in progress"), !1;if(3<=this.Ha)return!1;this.a.debug("Going to retry GET");this.rc++;this.ia=P(u(this.ve,this),this.Xd(this.Ha));this.Ha++;return!0};e.ve=function(){this.ia=null;this.Kg();};
e.Kg=function(){this.a.debug("Creating new HttpRequest");this.u=new R(this,this.a,this.ra,"rpc",this.rc);null===this.N&&this.u.ga(this.A);this.u.He(this.Ra);var a=this.md.clone();a.l("RID","rpc");a.l("SID",this.ra);a.l("CI",this.fd?"0":"1");a.l("AID",this.Sb);this.Ya(a);a.l("TYPE","xmlhttp");this.N&&this.A&&Zc(a,this.N,this.A);this.Db&&this.u.setTimeout(this.Db);this.u.jd(a,!0,this.na);this.a.debug("New Request created");};
e.ub=function(a,b){this.a.debug("Test Connection Finished");var c=a.Ad;c&&this.G.ld(c);this.fd=this.Se&&b;this.w=a.w;this.af();};e.dd=function(a){this.a.debug("Test Connection Failed");this.w=a.w;this.sa(2);};
e.ue=function(a,b){if(0!=this.g&&(this.u==a||this.G.Jc(a)))if(this.w=a.w, !a.lb&&this.G.Jc(a)&&3==this.g){try{var c=this.kc.zc(b);}catch(d){c=null;}n(c)&&3==c.length?this.Cf(c,a):(this.a.debug("Bad POST response data returned"), this.sa(11));}else(a.lb||this.u==a)&&this.Hb(), va(b)||(c=this.kc.zc(b), this.dg(c,a));};
e.Cf=function(a,b){0==a[0]?this.Bf(b):(this.he=a[1], b=this.he-this.Sb, 0<b&&(a=a[2], this.a.debug(a+" bytes (in "+b+" arrays) are outstanding on the BackChannel"), this.Jg(a)&&!this.wa&&(this.wa=P(u(this.bg,this),6E3))));};
e.Bf=function(a){this.a.debug("Server claims our backchannel is missing.");if(this.ia)this.a.debug("But we are currently starting the request.");else{if(this.u)if(this.u.qb+3E3<a.qb)this.Hb(), this.u.cancel(), this.u=null;else return;else this.a.T("We do not have a BackChannel established");this.Qc();O(18);}};e.Jg=function(a){return 37500>a&&!this.Nf()&&0==this.Ha};e.$a=function(a){return this.Te?this.i?this.i.$a(a):a:null};
e.bg=function(){null!=this.wa&&(this.wa=null, this.u.cancel(), this.u=null, this.Qc(), O(19));};e.Hb=function(){null!=this.wa&&(h.clearTimeout(this.wa), this.wa=null);};
e.Tc=function(a){this.a.debug("Request complete");var b=null;if(this.u==a){this.Hb();this.u=null;var c=2;}else if(this.G.Jc(a))b=a.la(), this.G.ze(a), c=1;else return;this.w=a.w;if(0!=this.g)if(a.S)1==c?(ac(a.Da?a.Da.length:0,w()-a.qb,this.La), this.Dc()):this.Kd();else{var d=a.Hc();if(3==d||0==d&&0<this.w)this.a.debug("Not retrying due to error type");else{var f=this;this.a.debug(function(){return"Maybe retrying, last error: "+kc(d,f.w)});if(1==c&&this.Yf(a)||2==c&&this.Qc())return;this.a.debug("Exceeded max number of retries");}b&&
0<b.length&&this.G.Re(b);this.a.debug("Error: HTTP request failed");switch(d){case 1:this.sa(5);break;case 4:this.sa(10);break;case 3:this.sa(6);break;default:this.sa(2);}}};e.Xd=function(a){var b=this.Ve+Math.floor(Math.random()*this.vg);this.Ba()||(this.a.debug("Inactive channel"), b*=2);return b*a};e.pc=function(a){if(this.ta&&(a=a.h)){var b=a.kb("X-Client-Wire-Protocol");b&&this.G.ld(b);this.aa&&((a=a.kb("X-HTTP-Session-Id"))?(this.Fe(a), this.hb.l(this.aa,a)):this.a.T("Missing X_HTTP_SESSION_ID in the handshake response"));}};
e.dg=function(a,b){for(var c=this.i&&this.i.sc?[]:null,d=0;d<a.length;d++){var f=a[d];this.Sb=f[0];f=f[1];if(2==this.g)if("c"==f[0]){this.ra=f[1];this.na=this.$a(f[2]);var g=f[3];null!=g&&(this.tc=g, this.a.info("VER="+this.tc));g=f[4];null!=g&&(this.De=g, this.a.info("SVER="+this.De));f=f[5];null!=f&&"number"==typeof f&&0<f&&(this.Db=f*=1.5, this.a.info("backChannelRequestTimeoutMs_="+f));this.pc(b);this.g=3;this.i&&this.i.wd();this.Lg(b);}else"stop"!=f[0]&&"close"!=f[0]||this.sa(7);else 3==this.g&&
("stop"==f[0]||"close"==f[0]?(c&&0!=c.length&&(this.i.sc(this,c), c.length=0), "stop"==f[0]?this.sa(7):this.disconnect()):"noop"!=f[0]&&(c?c.push(f):this.i&&this.i.ud(f)), this.Ha=0);}c&&0!=c.length&&this.i.sc(this,c);};e.Lg=function(a){this.md=this.Pd(this.na,this.K);a.lb?(this.a.debug("Upgrade the handshake request to a backchannel."), this.G.ze(a), a.tg(this.Db), this.u=a):this.Kd();};
e.sa=function(a){this.a.info("Error code "+a);if(2==a){var b=null;this.i&&(b=null);var c=u(this.Pg,this);b||(b=new U("//www.google.com/images/cleardot.gif"), h.location&&"http"==h.location.protocol||b.tb("https"), b.Ub());Qc(b.toString(),c);}else O(2);this.cg(a);};e.Pg=function(a){a?(this.a.info("Successfully pinged google.com"), O(2)):(this.a.info("Failed to ping google.com"), O(1));};e.cg=function(a){this.a.debug("HttpChannel: error - "+a);this.g=0;this.i&&this.i.td(a);this.qe();this.qd();};
e.qe=function(){this.g=0;this.w=-1;if(this.i){var a=this.G.la();if(0!=a.length||0!=this.M.length){var b=this;this.a.debug(function(){return"Number of undelivered maps, pending: "+a.length+", outgoing: "+b.M.length});this.G.$e();ua(this.M);this.M.length=0;}this.i.sd();}};e.Sd=function(a){a=this.Cd(null,a);this.a.debug("GetForwardChannelUri: "+a);return a};e.Pd=function(a,b){a=this.Cd(this.fc()?a:null,b);this.a.debug("GetBackChannelUri: "+a);return a};
e.Cd=function(a,b){var c=Ac(b);if(""!=c.xa)a&&c.rb(a+"."+c.xa), c.sb(c.Ca);else{var d=h.location;c=Bc(d.protocol,a?a+"."+d.hostname:d.hostname,+d.port,b);}this.gb&&Aa(this.gb,function(a,b){c.l(b,a);});a=this.aa;b=this.Kc;a&&b&&c.l(a,b);c.l("VER",this.tc);this.Ya(c);return c};e.Jb=function(a){if(a&&!this.gc)throw Error("Can't create secondary domain capable XhrIo object.");a=new V(this.Xa);a.Je(this.gc);return a};e.Ba=function(){return!!this.i&&this.i.Ba()};e.fc=function(){return this.gc};function ad(){}e=ad.prototype;e.sc=null;e.wd=function(){};e.ud=function(){};e.td=function(){};e.sd=function(){};e.Ba=function(){return!0};e.Ue=function(){};e.$a=function(a){return a};function bd(a){for(var b=arguments[0],c=1;c<arguments.length;c++){var d=arguments[c];if(0==d.lastIndexOf("/",0))b=d;else{var f;(f=""==b)||(f=b.length-1, f=0<=f&&b.indexOf("/",f)==f);b=f?b+d:b+("/"+d);}}return b}function cd(){if(C&&!(10<=Number(Ua)))throw Error("Environmental error: no available transport.");}cd.prototype.cf=function(a,b){return new W(a,b)};
function W(a,b){H.call(this);this.b=new $c(b);this.yb=a;this.Qg=b&&b.testUrl?b.testUrl:bd(this.yb,"test");this.s=Vb("goog.labs.net.webChannel.WebChannelBaseTransport");this.Rc=b&&b.messageUrlParams||null;a=b&&b.messageHeaders||null;b&&b.clientProtocolHeaderRequired&&(a?a["X-Client-Protocol"]="webchannel":a={"X-Client-Protocol":"webchannel"});this.b.ga(a);a=b&&b.initMessageHeaders||null;b&&b.messageContentType&&(a?a["X-WebChannel-Content-Type"]=b.messageContentType:a={"X-WebChannel-Content-Type":b.messageContentType});
b&&b.zd&&(a?a["X-WebChannel-Client-Profile"]=b.zd:a={"X-WebChannel-Client-Profile":b.zd});this.b.Eg(a);(a=b&&b.httpHeadersOverwriteParam)&&!va(a)&&this.b.Cg(a);this.Og=b&&b.supportsCrossDomainXhr||!1;this.zg=b&&b.sendRawJson||!1;(b=b&&b.httpSessionIdParam)&&!va(b)&&(this.b.Dg(b), a=this.Rc, null!==a&&b in a&&(a=this.Rc, b in a&&delete a[b], (a=this.s)&&a.T("Ignore httpSessionIdParam also specified with messageUrlParams: "+b,void 0)));this.vd=new X(this);}x(W,H);e=W.prototype;
e.addEventListener=function(a,b,c,d){W.L.addEventListener.call(this,a,b,c,d);};e.removeEventListener=function(a,b,c,d){W.L.removeEventListener.call(this,a,b,c,d);};e.open=function(){this.b.Ee(this.vd);this.Og&&this.b.Hg();this.b.connect(this.Qg,this.yb,this.Rc||void 0);};e.close=function(){this.b.disconnect();};e.send=function(a){if(l(a)){var b={};b.__data__=a;this.b.Zc(b);}else this.zg?(b={}, b.__data__=ub(a), this.b.Zc(b)):this.b.Zc(a);};
e.F=function(){this.b.Ee(null);delete this.vd;this.b.disconnect();delete this.b;W.L.F.call(this);};function dd(a){fc.call(this);var b=a.__sm__;if(b){a:{for(var c in b){a=c;break a}a=void 0;}if(this.ne=a)a=this.ne, b=null!==b&&a in b?b[a]:void 0;this.data=b;}else this.data=a;}x(dd,fc);function ed(a){gc.call(this);this.status=1;this.errorCode=a;}x(ed,gc);function X(a){this.b=a;}x(X,ad);X.prototype.wd=function(){Wb(this.b.s,"WebChannel opened on "+this.b.yb);this.b.dispatchEvent("a");};X.prototype.ud=function(a){this.b.dispatchEvent(new dd(a));};
X.prototype.td=function(a){Wb(this.b.s,"WebChannel aborted on "+this.b.yb+" due to channel error: "+a);this.b.dispatchEvent(new ed(a));};X.prototype.sd=function(){Wb(this.b.s,"WebChannel closed on "+this.b.yb);this.b.dispatchEvent("b");};var fd=v(function(a,b){function c(){}c.prototype=a.prototype;var d=new c;a.apply(d,Array.prototype.slice.call(arguments,1));return d},cd);function gd(){this.V=[];this.Z=[];}e=gd.prototype;e.Vf=function(){0==this.V.length&&(this.V=this.Z, this.V.reverse(), this.Z=[]);};e.enqueue=function(a){this.Z.push(a);};e.ab=function(){this.Vf();return this.V.pop()};e.C=function(){return this.V.length+this.Z.length};e.X=function(){return 0==this.V.length&&0==this.Z.length};e.clear=function(){this.V=[];this.Z=[];};e.contains=function(a){return 0<=la(this.V,a)||0<=la(this.Z,a)};
e.remove=function(a){var b=this.V;var c=ma(b,a);0<=c?(Array.prototype.splice.call(b,c,1), b=!0):b=!1;return b||sa(this.Z,a)};e.H=function(){for(var a=[],b=this.V.length-1;0<=b;--b)a.push(this.V[b]);var c=this.Z.length;for(b=0;b<c;++b)a.push(this.Z[b]);return a};function hd(a,b){z.call(this);this.oe=a||0;this.Wb=b||10;if(this.oe>this.Wb)throw Error(id);this.fa=new gd;this.oa=new Jc;this.Ac=0;this.Nc=null;this.Cb();}x(hd,z);var id="[goog.structs.Pool] Min can not be greater than max";e=hd.prototype;e.Mb=function(){var a=w();if(!(null!=this.Nc&&a-this.Nc<this.Ac)){var b=this.qg();b&&(this.Nc=a, this.oa.add(b));return b}};e.og=function(a){return this.oa.remove(a)?(this.nc(a), !0):!1};
e.qg=function(){for(var a;0<this.Td()&&(a=this.fa.ab(), !this.Sc(a));)this.Cb();!a&&this.C()<this.Wb&&(a=this.xc());return a};e.nc=function(a){this.oa.remove(a);this.Sc(a)&&this.C()<this.Wb?this.fa.enqueue(a):this.Bc(a);};e.Cb=function(){for(var a=this.fa;this.C()<this.oe;)a.enqueue(this.xc());for(;this.C()>this.Wb&&0<this.Td();)this.Bc(a.ab());};e.xc=function(){return{}};e.Bc=function(a){if("function"==typeof a.bb)a.bb();else for(var b in a)a[b]=null;};
e.Sc=function(a){return"function"==typeof a.Ye?a.Ye():!0};e.contains=function(a){return this.fa.contains(a)||this.oa.contains(a)};e.C=function(){return this.fa.C()+this.oa.C()};e.rf=function(){return this.oa.C()};e.Td=function(){return this.fa.C()};e.X=function(){return this.fa.X()&&this.oa.X()};e.F=function(){hd.L.F.call(this);if(0<this.rf())throw Error("[goog.structs.Pool] Objects not released");delete this.oa;for(var a=this.fa;!a.X();)this.Bc(a.ab());delete this.fa;};function jd(a,b){this.fe=a;this.gd=b;}jd.prototype.getKey=function(){return this.fe};jd.prototype.clone=function(){return new jd(this.fe,this.gd)};function kd(a){this.Y=[];a&&this.Lf(a);}e=kd.prototype;e.ce=function(a,b){var c=this.Y;c.push(new jd(a,b));this.$f(c.length-1);};e.Lf=function(a){if(a instanceof kd){var b=a.W();a=a.H();if(0>=this.C()){for(var c=this.Y,d=0;d<b.length;d++)c.push(new jd(b[d],a[d]));return}}else b=Ca(a), a=Ba(a);for(d=0;d<b.length;d++)this.ce(b[d],a[d]);};e.remove=function(){var a=this.Y,b=a.length,c=a[0];if(!(0>=b))return 1==b?ra(a):(a[0]=a.pop(), this.Zf()), c.gd};
e.Zf=function(){for(var a=0,b=this.Y,c=b.length,d=b[a];a<c>>1;){var f=this.tf(a),g=this.zf(a);f=g<c&&b[g].getKey()<b[f].getKey()?g:f;if(b[f].getKey()>d.getKey())break;b[a]=b[f];a=f;}b[a]=d;};e.$f=function(a){for(var b=this.Y,c=b[a];0<a;){var d=this.wf(a);if(b[d].getKey()>c.getKey())b[a]=b[d], a=d;else break}b[a]=c;};e.tf=function(a){return 2*a+1};e.zf=function(a){return 2*a+2};e.wf=function(a){return a-1>>1};e.H=function(){for(var a=this.Y,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].gd);return b};
e.W=function(){for(var a=this.Y,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].getKey());return b};e.va=function(a){return oa(this.Y,function(b){return b.getKey()==a})};e.clone=function(){return new kd(this)};e.C=function(){return this.Y.length};e.X=function(){return 0==this.Y.length};e.clear=function(){ra(this.Y);};function ld(){kd.call(this);}x(ld,kd);ld.prototype.enqueue=function(a,b){this.ce(a,b);};ld.prototype.ab=function(){return this.remove()};function Y(a,b){this.Gd=void 0;this.cc=new ld;hd.call(this,a,b);}x(Y,hd);e=Y.prototype;e.Mb=function(a,b){if(!a)return(a=Y.L.Mb.call(this))&&this.Ac&&(this.Gd=h.setTimeout(u(this.Nb,this),this.Ac)), a;this.cc.enqueue(void 0!==b?b:100,a);this.Nb();};e.Nb=function(){for(var a=this.cc;0<a.C();){var b=this.Mb();if(b)a.ab().apply(this,[b]);else break}};e.nc=function(a){Y.L.nc.call(this,a);this.Nb();};e.Cb=function(){Y.L.Cb.call(this);this.Nb();};
e.F=function(){Y.L.F.call(this);h.clearTimeout(this.Gd);this.cc.clear();this.cc=null;};function Z(a,b,c,d){this.Jf=a;this.Ab=!!d;Y.call(this,b,c);}x(Z,Y);Z.prototype.xc=function(){var a=new V,b=this.Jf;b&&b.forEach(function(b,d){a.headers.set(d,b);});this.Ab&&a.Je(!0);return a};Z.prototype.Sc=function(a){return!a.Ka&&!a.Ba()};/*

 Copyright 2017 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
cd.prototype.createWebChannel=cd.prototype.cf;W.prototype.send=W.prototype.send;W.prototype.open=W.prototype.open;W.prototype.close=W.prototype.close;bc.NO_ERROR=0;bc.TIMEOUT=8;bc.HTTP_ERROR=6;cc.COMPLETE="complete";ec.EventType=Q;Q.OPEN="a";Q.CLOSE="b";Q.ERROR="c";Q.MESSAGE="d";H.prototype.listen=H.prototype.nb;Z.prototype.getObject=Z.prototype.Mb;Z.prototype.releaseObject=Z.prototype.og;V.prototype.listenOnce=V.prototype.Oc;V.prototype.getLastError=V.prototype.Hc;V.prototype.getLastErrorCode=V.prototype.Ud;
V.prototype.getStatus=V.prototype.za;V.prototype.getStatusText=V.prototype.Yd;V.prototype.getResponseJson=V.prototype.yf;V.prototype.getResponseText=V.prototype.ya;V.prototype.getResponseText=V.prototype.ya;V.prototype.send=V.prototype.send;var src={createWebChannelTransport:fd,ErrorCode:bc,EventType:cc,WebChannel:ec,XhrIoPool:Z};
var src_1 = src.createWebChannelTransport;
var src_2 = src.ErrorCode;
var src_3 = src.EventType;
var src_4 = src.WebChannel;
var src_5 = src.XhrIoPool;

/* harmony default export */ __webpack_exports__["default"] = (src);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_1 = __webpack_require__(28);
var firebase = _interopDefault(__webpack_require__(16));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */
var errorCodeMap = {
    OK: 'ok',
    CANCELLED: 'cancelled',
    UNKNOWN: 'unknown',
    INVALID_ARGUMENT: 'invalid-argument',
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    NOT_FOUND: 'not-found',
    ALREADY_EXISTS: 'already-exists',
    PERMISSION_DENIED: 'permission-denied',
    UNAUTHENTICATED: 'unauthenticated',
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    FAILED_PRECONDITION: 'failed-precondition',
    ABORTED: 'aborted',
    OUT_OF_RANGE: 'out-of-range',
    UNIMPLEMENTED: 'unimplemented',
    INTERNAL: 'internal',
    UNAVAILABLE: 'unavailable',
    DATA_LOSS: 'data-loss'
};
/**
 * An explicit error that can be thrown from a handler to send an error to the
 * client that called the function.
 */
var HttpsErrorImpl = /** @class */ (function (_super) {
    tslib_1.__extends(HttpsErrorImpl, _super);
    function HttpsErrorImpl(code, message, details) {
        var _this = _super.call(this, message) || this;
        // This is a workaround for a bug in TypeScript when extending Error:
        // tslint:disable-next-line
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, HttpsErrorImpl.prototype);
        _this.code = code;
        _this.details = details;
        return _this;
    }
    return HttpsErrorImpl;
}(Error));
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */
function codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) {
        return 'ok';
    }
    switch (status) {
        case 0:
            // This can happen if the server returns 500.
            return 'internal';
        case 400:
            return 'invalid-argument';
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission-denied';
        case 404:
            return 'not-found';
        case 409:
            return 'aborted';
        case 429:
            return 'resource-exhausted';
        case 499:
            return 'cancelled';
        case 500:
            return 'internal';
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline-exceeded';
    }
    return 'unknown';
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */
function _errorForResponse(status, bodyJSON, serializer) {
    var code = codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    var description = code;
    var details = undefined;
    // Then look through the body for explicit details.
    try {
        var errorJSON = bodyJSON.error;
        if (errorJSON) {
            var status_1 = errorJSON.status;
            if (typeof status_1 === 'string') {
                if (!errorCodeMap[status_1]) {
                    // They must've included an unknown error code in the body.
                    return new HttpsErrorImpl('internal', 'internal');
                }
                code = errorCodeMap[status_1];
            }
            // TODO(klimt): Add better default descriptions for error enums.
            // The default description needs to be updated for the new code.
            description = status_1;
            var message = errorJSON.message;
            if (typeof message === 'string') {
                description = message;
            }
            details = errorJSON.details;
            if (details !== undefined) {
                details = serializer.decode(details);
            }
        }
    }
    catch (e) {
        // If we couldn't parse explicit error data, that's fine.
    }
    if (code === 'ok') {
        // Technically, there's an edge case where a developer could explicitly
        // return an error code of OK, and we will treat it as success, but that
        // seems reasonable.
        return null;
    }
    return new HttpsErrorImpl(code, description, details);
}

/**
 * Helper class to get metadata that should be included with a function call.
 */
var ContextProvider = /** @class */ (function () {
    function ContextProvider(app) {
        this.app = app;
    }
    ContextProvider.prototype.getAuthToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var token, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.app.INTERNAL.getToken()];
                    case 1:
                        token = _a.sent();
                        if (!token) {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/, token.accessToken];
                    case 2:
                        e_1 = _a.sent();
                        // If there's any error when trying to get the auth token, leave it off.
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContextProvider.prototype.getInstanceIdToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var messaging, token, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // HACK: Until we have a separate instanceId package, this is a quick way
                        // to load in the messaging instance for this app.
                        if (!this.app.messaging) {
                            return [2 /*return*/, undefined];
                        }
                        messaging = this.app.messaging();
                        return [4 /*yield*/, messaging.getToken()];
                    case 1:
                        token = _a.sent();
                        if (!token) {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/, token];
                    case 2:
                        e_2 = _a.sent();
                        // We don't warn on this, because it usually means messaging isn't set up.
                        // console.warn('Failed to retrieve instance id token.', e);
                        // If there's any error when trying to get the token, leave it off.
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContextProvider.prototype.getContext = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var authToken, instanceIdToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthToken()];
                    case 1:
                        authToken = _a.sent();
                        return [4 /*yield*/, this.getInstanceIdToken()];
                    case 2:
                        instanceIdToken = _a.sent();
                        return [2 /*return*/, { authToken: authToken, instanceIdToken: instanceIdToken }];
                }
            });
        });
    };
    return ContextProvider;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LONG_TYPE = 'type.googleapis.com/google.protobuf.Int64Value';
var UNSIGNED_LONG_TYPE = 'type.googleapis.com/google.protobuf.UInt64Value';
function mapValues(o, f) {
    var result = {};
    for (var key in o) {
        if (o.hasOwnProperty(key)) {
            result[key] = f(o[key]);
        }
    }
    return result;
}
var Serializer = /** @class */ (function () {
    function Serializer() {
    }
    // Takes data and encodes it in a JSON-friendly way, such that types such as
    // Date are preserved.
    Serializer.prototype.encode = function (data) {
        var _this = this;
        if (data === null || data === undefined) {
            return null;
        }
        if (data instanceof Number) {
            data = data.valueOf();
        }
        if (typeof data === 'number' && isFinite(data)) {
            // Any number in JS is safe to put directly in JSON and parse as a double
            // without any loss of precision.
            return data;
        }
        if (data === true || data === false) {
            return data;
        }
        if (Object.prototype.toString.call(data) === '[object String]') {
            return data;
        }
        if (Array.isArray(data)) {
            return data.map(function (x) { return _this.encode(x); });
        }
        if (typeof data === 'function' || typeof data === 'object') {
            return mapValues(data, function (x) { return _this.encode(x); });
        }
        // If we got this far, the data is not encodable.
        throw new Error('Data cannot be encoded in JSON: ' + data);
    };
    // Takes data that's been encoded in a JSON-friendly form and returns a form
    // with richer datatypes, such as Dates, etc.
    Serializer.prototype.decode = function (json) {
        var _this = this;
        if (json === null) {
            return json;
        }
        if (json['@type']) {
            switch (json['@type']) {
                case LONG_TYPE:
                // Fall through and handle this the same as unsigned.
                case UNSIGNED_LONG_TYPE: {
                    // Technically, this could work return a valid number for malformed
                    // data if there was a number followed by garbage. But it's just not
                    // worth all the extra code to detect that case.
                    var value = parseFloat(json.value);
                    if (isNaN(value)) {
                        throw new Error('Data cannot be decoded from JSON: ' + json);
                    }
                    return value;
                }
                default: {
                    throw new Error('Data cannot be decoded from JSON: ' + json);
                }
            }
        }
        if (Array.isArray(json)) {
            return json.map(function (x) { return _this.decode(x); });
        }
        if (typeof json === 'function' || typeof json === 'object') {
            return mapValues(json, function (x) { return _this.decode(x); });
        }
        // Anything else is safe to return.
        return json;
    };
    return Serializer;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The main class for the Firebase Functions SDK.
 */
var Service = /** @class */ (function () {
    /**
     * Creates a new Functions service for the given app and (optional) region.
     * @param app_ The FirebaseApp to use.
     * @param region_ The region to call functions in.
     */
    function Service(app_, region_) {
        if (region_ === void 0) { region_ = 'us-central1'; }
        this.app_ = app_;
        this.region_ = region_;
        this.serializer = new Serializer();
        this.emulatorOrigin = null;
        this.contextProvider = new ContextProvider(app_);
    }
    Object.defineProperty(Service.prototype, "app", {
        get: function () {
            return this.app_;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the URL for a callable with the given name.
     * @param name The name of the callable.
     */
    Service.prototype._url = function (name) {
        var projectId = this.app_.options.projectId;
        var region = this.region_;
        if (this.emulatorOrigin !== null) {
            var origin = this.emulatorOrigin;
            return origin + "/" + projectId + "/" + region + "/" + name;
        }
        return "https://" + region + "-" + projectId + ".cloudfunctions.net/" + name;
    };
    /**
     * Changes this instance to point to a Cloud Functions emulator running
     * locally. See https://firebase.google.com/docs/functions/local-emulator
     *
     * @param origin The origin of the local emulator, such as
     * "http://localhost:5005".
     */
    Service.prototype.useFunctionsEmulator = function (origin) {
        this.emulatorOrigin = origin;
    };
    /**
     * Returns a reference to the callable https trigger with the given name.
     * @param name The name of the trigger.
     */
    Service.prototype.httpsCallable = function (name) {
        var _this = this;
        var callable = function (data) {
            return _this.call(name, data);
        };
        return callable;
    };
    /**
     * Does an HTTP POST and returns the completed response.
     * @param url The url to post to.
     * @param body The JSON body of the post.
     * @param headers The HTTP headers to include in the request.
     * @return A Promise that will succeed when the request finishes.
     */
    Service.prototype.postJSON = function (url, body, headers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, e_1, json, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers.append('Content-Type', 'application/json');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: headers
                            })];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        // This could be an unhandled error on the backend, or it could be a
                        // network error. There's no way to no, since an unhandled error on the
                        // backend will fail to set the proper CORS header, and thus will be
                        // treated as a network error by fetch.
                        return [2 /*return*/, {
                                status: 0,
                                json: null
                            }];
                    case 4:
                        json = null;
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, response.json()];
                    case 6:
                        json = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _a.sent();
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/, {
                            status: response.status,
                            json: json
                        }];
                }
            });
        });
    };
    /**
     * Calls a callable function asynchronously and returns the result.
     * @param name The name of the callable trigger.
     * @param data The data to pass as params to the function.s
     */
    Service.prototype.call = function (name, data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, body, headers, context, response, error, responseData, decodedData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this._url(name);
                        // Encode any special types, such as dates, in the input data.
                        data = this.serializer.encode(data);
                        body = { data: data };
                        headers = new Headers();
                        return [4 /*yield*/, this.contextProvider.getContext()];
                    case 1:
                        context = _a.sent();
                        if (context.authToken) {
                            headers.append('Authorization', 'Bearer ' + context.authToken);
                        }
                        if (context.instanceIdToken) {
                            headers.append('Firebase-Instance-ID-Token', context.instanceIdToken);
                        }
                        return [4 /*yield*/, this.postJSON(url, body, headers)];
                    case 2:
                        response = _a.sent();
                        error = _errorForResponse(response.status, response.json, this.serializer);
                        if (error) {
                            throw error;
                        }
                        if (!response.json) {
                            throw new HttpsErrorImpl('internal', 'Response is not valid JSON object.');
                        }
                        responseData = response.json.data;
                        // TODO(klimt): For right now, allow "result" instead of "data", for
                        // backwards compatibility.
                        if (typeof responseData === 'undefined') {
                            responseData = response.json.result;
                        }
                        if (typeof responseData === 'undefined') {
                            // Consider the response malformed.
                            throw new HttpsErrorImpl('internal', 'Response is missing data field.');
                        }
                        decodedData = this.serializer.decode(responseData);
                        return [2 /*return*/, { data: decodedData }];
                }
            });
        });
    };
    return Service;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Functions.
 */
var FUNCTIONS_TYPE = 'functions';
function factory(app, unused, region) {
    return new Service(app, region);
}
function registerFunctions(instance) {
    var namespaceExports = {
        // no-inline
        Functions: Service
    };
    instance.INTERNAL.registerService(FUNCTIONS_TYPE, factory, namespaceExports, 
    // We don't need to wait on any AppHooks.
    undefined, 
    // Allow multiple functions instances per app.
    true);
}
registerFunctions(firebase);

exports.registerFunctions = registerFunctions;


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerMessaging", function() { return registerMessaging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSupported", function() { return isSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_app__);




/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_CODES = {
    AVAILABLE_IN_WINDOW: 'only-available-in-window',
    AVAILABLE_IN_SW: 'only-available-in-sw',
    SHOULD_BE_INHERITED: 'should-be-overriden',
    BAD_SENDER_ID: 'bad-sender-id',
    INCORRECT_GCM_SENDER_ID: 'incorrect-gcm-sender-id',
    PERMISSION_DEFAULT: 'permission-default',
    PERMISSION_BLOCKED: 'permission-blocked',
    UNSUPPORTED_BROWSER: 'unsupported-browser',
    NOTIFICATIONS_BLOCKED: 'notifications-blocked',
    FAILED_DEFAULT_REGISTRATION: 'failed-serviceworker-registration',
    SW_REGISTRATION_EXPECTED: 'sw-registration-expected',
    GET_SUBSCRIPTION_FAILED: 'get-subscription-failed',
    INVALID_SAVED_TOKEN: 'invalid-saved-token',
    SW_REG_REDUNDANT: 'sw-reg-redundant',
    TOKEN_SUBSCRIBE_FAILED: 'token-subscribe-failed',
    TOKEN_SUBSCRIBE_NO_TOKEN: 'token-subscribe-no-token',
    TOKEN_SUBSCRIBE_NO_PUSH_SET: 'token-subscribe-no-push-set',
    TOKEN_UNSUBSCRIBE_FAILED: 'token-unsubscribe-failed',
    TOKEN_UPDATE_FAILED: 'token-update-failed',
    TOKEN_UPDATE_NO_TOKEN: 'token-update-no-token',
    USE_SW_BEFORE_GET_TOKEN: 'use-sw-before-get-token',
    INVALID_DELETE_TOKEN: 'invalid-delete-token',
    DELETE_TOKEN_NOT_FOUND: 'delete-token-not-found',
    DELETE_SCOPE_NOT_FOUND: 'delete-scope-not-found',
    BG_HANDLER_FUNCTION_EXPECTED: 'bg-handler-function-expected',
    NO_WINDOW_CLIENT_TO_MSG: 'no-window-client-to-msg',
    UNABLE_TO_RESUBSCRIBE: 'unable-to-resubscribe',
    NO_FCM_TOKEN_FOR_RESUBSCRIBE: 'no-fcm-token-for-resubscribe',
    FAILED_TO_DELETE_TOKEN: 'failed-to-delete-token',
    NO_SW_IN_REG: 'no-sw-in-reg',
    BAD_SCOPE: 'bad-scope',
    BAD_VAPID_KEY: 'bad-vapid-key',
    BAD_SUBSCRIPTION: 'bad-subscription',
    BAD_TOKEN: 'bad-token',
    BAD_PUSH_SET: 'bad-push-set',
    FAILED_DELETE_VAPID_KEY: 'failed-delete-vapid-key',
    INVALID_PUBLIC_VAPID_KEY: 'invalid-public-vapid-key',
    USE_PUBLIC_KEY_BEFORE_GET_TOKEN: 'use-public-key-before-get-token',
    PUBLIC_KEY_DECRYPTION_FAILED: 'public-vapid-key-decryption-failed'
};
var ERROR_MAP = (_a = {}, _a[ERROR_CODES.AVAILABLE_IN_WINDOW] = 'This method is available in a Window context.', _a[ERROR_CODES.AVAILABLE_IN_SW] = 'This method is available in a service worker ' + 'context.', _a[ERROR_CODES.SHOULD_BE_INHERITED] = 'This method should be overriden by ' + 'extended classes.', _a[ERROR_CODES.BAD_SENDER_ID] = "Please ensure that 'messagingSenderId' is set " +
        'correctly in the options passed into firebase.initializeApp().', _a[ERROR_CODES.PERMISSION_DEFAULT] = 'The required permissions were not granted and ' + 'dismissed instead.', _a[ERROR_CODES.PERMISSION_BLOCKED] = 'The required permissions were not granted and ' + 'blocked instead.', _a[ERROR_CODES.UNSUPPORTED_BROWSER] = "This browser doesn't support the API's " +
        'required to use the firebase SDK.', _a[ERROR_CODES.NOTIFICATIONS_BLOCKED] = 'Notifications have been blocked.', _a[ERROR_CODES.FAILED_DEFAULT_REGISTRATION] = 'We are unable to register the ' +
        'default service worker. {$browserErrorMessage}', _a[ERROR_CODES.SW_REGISTRATION_EXPECTED] = 'A service worker registration was the ' + 'expected input.', _a[ERROR_CODES.GET_SUBSCRIPTION_FAILED] = 'There was an error when trying to get ' +
        'any existing Push Subscriptions.', _a[ERROR_CODES.INVALID_SAVED_TOKEN] = 'Unable to access details of the saved token.', _a[ERROR_CODES.SW_REG_REDUNDANT] = 'The service worker being used for push was made ' + 'redundant.', _a[ERROR_CODES.TOKEN_SUBSCRIBE_FAILED] = 'A problem occured while subscribing the ' + 'user to FCM: {$message}', _a[ERROR_CODES.TOKEN_SUBSCRIBE_NO_TOKEN] = 'FCM returned no token when subscribing ' + 'the user to push.', _a[ERROR_CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET] = 'FCM returned an invalid response ' + 'when getting an FCM token.', _a[ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED] = 'A problem occured while unsubscribing the ' + 'user from FCM: {$message}', _a[ERROR_CODES.TOKEN_UPDATE_FAILED] = 'A problem occured while updating the ' + 'user from FCM: {$message}', _a[ERROR_CODES.TOKEN_UPDATE_NO_TOKEN] = 'FCM returned no token when updating ' + 'the user to push.', _a[ERROR_CODES.USE_SW_BEFORE_GET_TOKEN] = 'The useServiceWorker() method may only be called once and must be ' +
        'called before calling getToken() to ensure your service worker is used.', _a[ERROR_CODES.INVALID_DELETE_TOKEN] = 'You must pass a valid token into ' +
        'deleteToken(), i.e. the token from getToken().', _a[ERROR_CODES.DELETE_TOKEN_NOT_FOUND] = 'The deletion attempt for token could not ' +
        'be performed as the token was not found.', _a[ERROR_CODES.DELETE_SCOPE_NOT_FOUND] = 'The deletion attempt for service worker ' +
        'scope could not be performed as the scope was not found.', _a[ERROR_CODES.BG_HANDLER_FUNCTION_EXPECTED] = 'The input to ' + 'setBackgroundMessageHandler() must be a function.', _a[ERROR_CODES.NO_WINDOW_CLIENT_TO_MSG] = 'An attempt was made to message a ' + 'non-existant window client.', _a[ERROR_CODES.UNABLE_TO_RESUBSCRIBE] = 'There was an error while re-subscribing ' +
        'the FCM token for push messaging. Will have to resubscribe the ' +
        'user on next visit. {$message}', _a[ERROR_CODES.NO_FCM_TOKEN_FOR_RESUBSCRIBE] = 'Could not find an FCM token ' +
        'and as a result, unable to resubscribe. Will have to resubscribe the ' +
        'user on next visit.', _a[ERROR_CODES.FAILED_TO_DELETE_TOKEN] = 'Unable to delete the currently saved token.', _a[ERROR_CODES.NO_SW_IN_REG] = 'Even though the service worker registration was ' +
        'successful, there was a problem accessing the service worker itself.', _a[ERROR_CODES.INCORRECT_GCM_SENDER_ID] = "Please change your web app manifest's " +
        "'gcm_sender_id' value to '103953800507' to use Firebase messaging.", _a[ERROR_CODES.BAD_SCOPE] = 'The service worker scope must be a string with at ' +
        'least one character.', _a[ERROR_CODES.BAD_VAPID_KEY] = 'The public VAPID key is not a Uint8Array with 65 bytes.', _a[ERROR_CODES.BAD_SUBSCRIPTION] = 'The subscription must be a valid ' + 'PushSubscription.', _a[ERROR_CODES.BAD_TOKEN] = 'The FCM Token used for storage / lookup was not ' +
        'a valid token string.', _a[ERROR_CODES.BAD_PUSH_SET] = 'The FCM push set used for storage / lookup was not ' +
        'not a valid push set string.', _a[ERROR_CODES.FAILED_DELETE_VAPID_KEY] = 'The VAPID key could not be deleted.', _a[ERROR_CODES.INVALID_PUBLIC_VAPID_KEY] = 'The public VAPID key must be a string.', _a[ERROR_CODES.PUBLIC_KEY_DECRYPTION_FAILED] = 'The public VAPID key did not equal ' + '65 bytes when decrypted.', _a);
var errorFactory = new __WEBPACK_IMPORTED_MODULE_0__firebase_util__["ErrorFactory"]('messaging', 'Messaging', ERROR_MAP);
var _a;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_PUBLIC_VAPID_KEY = new Uint8Array([
    0x04,
    0x33,
    0x94,
    0xf7,
    0xdf,
    0xa1,
    0xeb,
    0xb1,
    0xdc,
    0x03,
    0xa2,
    0x5e,
    0x15,
    0x71,
    0xdb,
    0x48,
    0xd3,
    0x2e,
    0xed,
    0xed,
    0xb2,
    0x34,
    0xdb,
    0xb7,
    0x47,
    0x3a,
    0x0c,
    0x8f,
    0xc4,
    0xcc,
    0xe1,
    0x6f,
    0x3c,
    0x8c,
    0x84,
    0xdf,
    0xab,
    0xb6,
    0x66,
    0x3e,
    0xf2,
    0x0c,
    0xd4,
    0x8b,
    0xfe,
    0xe3,
    0xf9,
    0x76,
    0x2f,
    0x14,
    0x1c,
    0x63,
    0x08,
    0x6a,
    0x6f,
    0x2d,
    0xb1,
    0x1a,
    0x95,
    0xb0,
    0xce,
    0x37,
    0xc0,
    0x9c,
    0x6e
]);
var ENDPOINT = 'https://fcm.googleapis.com';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MessageParameter;
(function (MessageParameter) {
    MessageParameter["TYPE_OF_MSG"] = "firebase-messaging-msg-type";
    MessageParameter["DATA"] = "firebase-messaging-msg-data";
})(MessageParameter || (MessageParameter = {}));
var MessageType;
(function (MessageType) {
    MessageType["PUSH_MSG_RECEIVED"] = "push-msg-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isArrayBufferEqual(a, b) {
    if (a == null || b == null) {
        return false;
    }
    if (a === b) {
        return true;
    }
    if (a.byteLength !== b.byteLength) {
        return false;
    }
    var viewA = new DataView(a);
    var viewB = new DataView(b);
    for (var i = 0; i < a.byteLength; i++) {
        if (viewA.getUint8(i) !== viewB.getUint8(i)) {
            return false;
        }
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function toBase64(arrayBuffer) {
    var uint8Version = new Uint8Array(arrayBuffer);
    return btoa(String.fromCharCode.apply(null, uint8Version));
}
function arrayBufferToBase64(arrayBuffer) {
    var base64String = toBase64(arrayBuffer);
    return base64String
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IidModel = /** @class */ (function () {
    function IidModel() {
    }
    IidModel.prototype.getToken = function (senderId, subscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var p256dh, auth, fcmSubscribeBody, applicationPubKey, headers, subscribeOptions, responseData, response, err_1, message;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        p256dh = arrayBufferToBase64(subscription.getKey('p256dh'));
                        auth = arrayBufferToBase64(subscription.getKey('auth'));
                        fcmSubscribeBody = "authorized_entity=" + senderId + "&" +
                            ("endpoint=" + subscription.endpoint + "&") +
                            ("encryption_key=" + p256dh + "&") +
                            ("encryption_auth=" + auth);
                        if (!isArrayBufferEqual(publicVapidKey.buffer, DEFAULT_PUBLIC_VAPID_KEY.buffer)) {
                            applicationPubKey = arrayBufferToBase64(publicVapidKey);
                            fcmSubscribeBody += "&application_pub_key=" + applicationPubKey;
                        }
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        subscribeOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmSubscribeBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/subscribe', subscribeOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_FAILED);
                    case 5:
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_FAILED, {
                                message: message
                            });
                        }
                        if (!responseData.token) {
                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_NO_TOKEN);
                        }
                        if (!responseData.pushSet) {
                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET);
                        }
                        return [2 /*return*/, {
                                token: responseData.token,
                                pushSet: responseData.pushSet
                            }];
                }
            });
        });
    };
    /**
     * Update the underlying token details for fcmToken.
     */
    IidModel.prototype.updateToken = function (senderId, fcmToken, fcmPushSet, subscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var p256dh, auth, fcmUpdateBody, applicationPubKey, headers, updateOptions, responseData, response, err_2, message;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        p256dh = arrayBufferToBase64(subscription.getKey('p256dh'));
                        auth = arrayBufferToBase64(subscription.getKey('auth'));
                        fcmUpdateBody = "push_set=" + fcmPushSet + "&" +
                            ("token=" + fcmToken + "&") +
                            ("authorized_entity=" + senderId + "&") +
                            ("endpoint=" + subscription.endpoint + "&") +
                            ("encryption_key=" + p256dh + "&") +
                            ("encryption_auth=" + auth);
                        if (!isArrayBufferEqual(publicVapidKey.buffer, DEFAULT_PUBLIC_VAPID_KEY.buffer)) {
                            applicationPubKey = arrayBufferToBase64(publicVapidKey);
                            fcmUpdateBody += "&application_pub_key=" + applicationPubKey;
                        }
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        updateOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmUpdateBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/subscribe', updateOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_FAILED);
                    case 5:
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_FAILED, {
                                message: message
                            });
                        }
                        if (!responseData.token) {
                            throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_NO_TOKEN);
                        }
                        return [2 /*return*/, responseData.token];
                }
            });
        });
    };
    /**
     * Given a fcmToken, pushSet and messagingSenderId, delete an FCM token.
     */
    IidModel.prototype.deleteToken = function (senderId, fcmToken, fcmPushSet) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var fcmUnsubscribeBody, headers, unsubscribeOptions, response, responseData, message, err_3;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fcmUnsubscribeBody = "authorized_entity=" + senderId + "&" +
                            ("token=" + fcmToken + "&") +
                            ("pushSet=" + fcmPushSet);
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        unsubscribeOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmUnsubscribeBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/unsubscribe', unsubscribeOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create(ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED, {
                                message: message
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        err_3 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED);
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return IidModel;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function base64ToArrayBuffer(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    var rawData = atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OLD_DB_NAME = 'undefined';
var OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
function handleDb(db) {
    if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
        // We found a database with the name 'undefined', but our expected object
        // store isn't defined.
        return;
    }
    var transaction = db.transaction(OLD_OBJECT_STORE_NAME);
    var objectStore = transaction.objectStore(OLD_OBJECT_STORE_NAME);
    var iidModel = new IidModel();
    var openCursorRequest = objectStore.openCursor();
    openCursorRequest.onerror = function (event) {
        // NOOP - Nothing we can do.
        console.warn('Unable to cleanup old IDB.', event);
    };
    openCursorRequest.onsuccess = function () {
        var cursor = openCursorRequest.result;
        if (cursor) {
            // cursor.value contains the current record being iterated through
            // this is where you'd do something with the result
            var tokenDetails = cursor.value;
            iidModel.deleteToken(tokenDetails.fcmSenderId, tokenDetails.fcmToken, tokenDetails.fcmPushSet);
            cursor.continue();
        }
        else {
            db.close();
            indexedDB.deleteDatabase(OLD_DB_NAME);
        }
    };
}
function cleanV1() {
    var request = indexedDB.open(OLD_DB_NAME);
    request.onerror = function (event) {
        // NOOP - Nothing we can do.
    };
    request.onsuccess = function (event) {
        var db = request.result;
        handleDb(db);
    };
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DbInterface = /** @class */ (function () {
    function DbInterface() {
        this.dbPromise = null;
    }
    /** Gets record(s) from the objectStore that match the given key. */
    DbInterface.prototype.get = function (key) {
        return this.createTransaction(function (objectStore) { return objectStore.get(key); });
    };
    /** Gets record(s) from the objectStore that match the given index. */
    DbInterface.prototype.getIndex = function (index, key) {
        function runRequest(objectStore) {
            var idbIndex = objectStore.index(index);
            return idbIndex.get(key);
        }
        return this.createTransaction(runRequest);
    };
    /** Assigns or overwrites the record for the given value. */
    // tslint:disable-next-line:no-any IndexedDB values are of type "any"
    DbInterface.prototype.put = function (value) {
        return this.createTransaction(function (objectStore) { return objectStore.put(value); }, 'readwrite');
    };
    /** Deletes record(s) from the objectStore that match the given key. */
    DbInterface.prototype.delete = function (key) {
        return this.createTransaction(function (objectStore) { return objectStore.delete(key); }, 'readwrite');
    };
    /**
     * Close the currently open database.
     */
    DbInterface.prototype.closeDatabase = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var db;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.dbPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dbPromise];
                    case 1:
                        db = _a.sent();
                        db.close();
                        this.dbPromise = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates an IndexedDB Transaction and passes its objectStore to the
     * runRequest function, which runs the database request.
     *
     * @return Promise that resolves with the result of the runRequest function
     */
    DbInterface.prototype.createTransaction = function (runRequest, mode) {
        if (mode === void 0) { mode = 'readonly'; }
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var db, transaction, request, result;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDb()];
                    case 1:
                        db = _a.sent();
                        transaction = db.transaction(this.objectStoreName, mode);
                        request = transaction.objectStore(this.objectStoreName);
                        return [4 /*yield*/, promisify(runRequest(request))];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                transaction.oncomplete = function () {
                                    resolve(result);
                                };
                                transaction.onerror = function () {
                                    reject(transaction.error);
                                };
                            })];
                }
            });
        });
    };
    /** Gets the cached db connection or opens a new one. */
    DbInterface.prototype.getDb = function () {
        var _this = this;
        if (!this.dbPromise) {
            this.dbPromise = new Promise(function (resolve, reject) {
                var request = indexedDB.open(_this.dbName, _this.dbVersion);
                request.onsuccess = function () {
                    resolve(request.result);
                };
                request.onerror = function () {
                    _this.dbPromise = null;
                    reject(request.error);
                };
                request.onupgradeneeded = function (event) { return _this.onDbUpgrade(request, event); };
            });
        }
        return this.dbPromise;
    };
    return DbInterface;
}());
/** Promisifies an IDBRequest. Resolves with the IDBRequest's result. */
function promisify(request) {
    return new Promise(function (resolve, reject) {
        request.onsuccess = function () {
            resolve(request.result);
        };
        request.onerror = function () {
            reject(request.error);
        };
    });
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TokenDetailsModel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(TokenDetailsModel, _super);
    function TokenDetailsModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dbName = 'fcm_token_details_db';
        _this.dbVersion = 3;
        _this.objectStoreName = 'fcm_token_object_Store';
        return _this;
    }
    TokenDetailsModel.prototype.onDbUpgrade = function (request, event) {
        var db = request.result;
        // Lack of 'break' statements is intentional.
        switch (event.oldVersion) {
            case 0: {
                // New IDB instance
                var objectStore = db.createObjectStore(this.objectStoreName, {
                    keyPath: 'swScope'
                });
                // Make sure the sender ID can be searched
                objectStore.createIndex('fcmSenderId', 'fcmSenderId', {
                    unique: false
                });
                objectStore.createIndex('fcmToken', 'fcmToken', { unique: true });
            }
            case 1: {
                // Prior to version 2, we were using either 'fcm_token_details_db'
                // or 'undefined' as the database name due to bug in the SDK
                // So remove the old tokens and databases.
                cleanV1();
            }
            case 2: {
                var objectStore = request.transaction.objectStore(this.objectStoreName);
                var cursorRequest_1 = objectStore.openCursor();
                cursorRequest_1.onsuccess = function () {
                    var cursor = cursorRequest_1.result;
                    if (cursor) {
                        var value = cursor.value;
                        var newValue = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"])({}, value);
                        if (!value.createTime) {
                            newValue.createTime = Date.now();
                        }
                        if (typeof value.vapidKey === 'string') {
                            newValue.vapidKey = base64ToArrayBuffer(value.vapidKey);
                        }
                        if (typeof value.auth === 'string') {
                            newValue.auth = base64ToArrayBuffer(value.auth).buffer;
                        }
                        if (typeof value.auth === 'string') {
                            newValue.p256dh = base64ToArrayBuffer(value.p256dh).buffer;
                        }
                        cursor.update(newValue);
                        cursor.continue();
                    }
                };
            }
        }
    };
    /**
     * Given a token, this method will look up the details in indexedDB.
     */
    TokenDetailsModel.prototype.getTokenDetailsFromToken = function (fcmToken) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (!fcmToken) {
                    throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
                }
                validateInputs({ fcmToken: fcmToken });
                return [2 /*return*/, this.getIndex('fcmToken', fcmToken)];
            });
        });
    };
    /**
     * Given a service worker scope, this method will look up the details in
     * indexedDB.
     * @return The details associated with that token.
     */
    TokenDetailsModel.prototype.getTokenDetailsFromSWScope = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (!swScope) {
                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                }
                validateInputs({ swScope: swScope });
                return [2 /*return*/, this.get(swScope)];
            });
        });
    };
    /**
     * Save the details for the fcm token for re-use at a later date.
     * @param input A plain js object containing args to save.
     */
    TokenDetailsModel.prototype.saveTokenDetails = function (tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (!tokenDetails.swScope) {
                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                }
                if (!tokenDetails.vapidKey) {
                    throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
                }
                if (!tokenDetails.endpoint || !tokenDetails.auth || !tokenDetails.p256dh) {
                    throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
                }
                if (!tokenDetails.fcmSenderId) {
                    throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
                }
                if (!tokenDetails.fcmToken) {
                    throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
                }
                if (!tokenDetails.fcmPushSet) {
                    throw errorFactory.create(ERROR_CODES.BAD_PUSH_SET);
                }
                validateInputs(tokenDetails);
                return [2 /*return*/, this.put(tokenDetails)];
            });
        });
    };
    /**
     * This method deletes details of the current FCM token.
     * It's returning a promise in case we need to move to an async
     * method for deleting at a later date.
     *
     * @return Resolves once the FCM token details have been deleted and returns
     * the deleted details.
     */
    TokenDetailsModel.prototype.deleteToken = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof token !== 'string' || token.length === 0) {
                            return [2 /*return*/, Promise.reject(errorFactory.create(ERROR_CODES.INVALID_DELETE_TOKEN))];
                        }
                        return [4 /*yield*/, this.getTokenDetailsFromToken(token)];
                    case 1:
                        details = _a.sent();
                        if (!details) {
                            throw errorFactory.create(ERROR_CODES.DELETE_TOKEN_NOT_FOUND);
                        }
                        return [4 /*yield*/, this.delete(details.swScope)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, details];
                }
            });
        });
    };
    return TokenDetailsModel;
}(DbInterface));
/**
 * This method takes an object and will check for known arguments and
 * validate the input.
 * @return Promise that resolves if input is valid, rejects otherwise.
 */
function validateInputs(input) {
    if (input.fcmToken) {
        if (typeof input.fcmToken !== 'string' || input.fcmToken.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
        }
    }
    if (input.swScope) {
        if (typeof input.swScope !== 'string' || input.swScope.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
        }
    }
    if (input.vapidKey) {
        if (!(input.vapidKey instanceof Uint8Array) ||
            input.vapidKey.length !== 65) {
            throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
        }
    }
    if (input.endpoint) {
        if (typeof input.endpoint !== 'string' || input.endpoint.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
        }
    }
    if (input.auth) {
        if (!(input.auth instanceof ArrayBuffer)) {
            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
        }
    }
    if (input.p256dh) {
        if (!(input.p256dh instanceof ArrayBuffer)) {
            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
        }
    }
    if (input.fcmSenderId) {
        if (typeof input.fcmSenderId !== 'string' ||
            input.fcmSenderId.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
        }
    }
    if (input.fcmPushSet) {
        if (typeof input.fcmPushSet !== 'string' || input.fcmPushSet.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_PUSH_SET);
        }
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var UNCOMPRESSED_PUBLIC_KEY_SIZE = 65;
var VapidDetailsModel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(VapidDetailsModel, _super);
    function VapidDetailsModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dbName = 'fcm_vapid_details_db';
        _this.dbVersion = 1;
        _this.objectStoreName = 'fcm_vapid_object_Store';
        return _this;
    }
    VapidDetailsModel.prototype.onDbUpgrade = function (request) {
        var db = request.result;
        db.createObjectStore(this.objectStoreName, { keyPath: 'swScope' });
    };
    /**
     * Given a service worker scope, this method will look up the vapid key
     * in indexedDB.
     */
    VapidDetailsModel.prototype.getVapidFromSWScope = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var result;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof swScope !== 'string' || swScope.length === 0) {
                            throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                        }
                        return [4 /*yield*/, this.get(swScope)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result ? result.vapidKey : undefined];
                }
            });
        });
    };
    /**
     * Save a vapid key against a swScope for later date.
     */
    VapidDetailsModel.prototype.saveVapidDetails = function (swScope, vapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (typeof swScope !== 'string' || swScope.length === 0) {
                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                }
                if (vapidKey === null || vapidKey.length !== UNCOMPRESSED_PUBLIC_KEY_SIZE) {
                    throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
                }
                details = {
                    swScope: swScope,
                    vapidKey: vapidKey
                };
                return [2 /*return*/, this.put(details)];
            });
        });
    };
    /**
     * This method deletes details of the current FCM VAPID key for a SW scope.
     * Resolves once the scope/vapid details have been deleted and returns the
     * deleted vapid key.
     */
    VapidDetailsModel.prototype.deleteVapidDetails = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var vapidKey;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVapidFromSWScope(swScope)];
                    case 1:
                        vapidKey = _a.sent();
                        if (!vapidKey) {
                            throw errorFactory.create(ERROR_CODES.DELETE_SCOPE_NOT_FOUND);
                        }
                        return [4 /*yield*/, this.delete(swScope)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, vapidKey];
                }
            });
        });
    };
    return VapidDetailsModel;
}(DbInterface));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SENDER_ID_OPTION_NAME = 'messagingSenderId';
// Database cache should be invalidated once a week.
var TOKEN_EXPIRATION_MILLIS = 7 * 24 * 60 * 60 * 1000; // 7 days
var BaseController = /** @class */ (function () {
    /**
     * An interface of the Messaging Service API
     */
    function BaseController(app) {
        var _this = this;
        if (!app.options[SENDER_ID_OPTION_NAME] ||
            typeof app.options[SENDER_ID_OPTION_NAME] !== 'string') {
            throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
        }
        this.messagingSenderId = app.options[SENDER_ID_OPTION_NAME];
        this.tokenDetailsModel = new TokenDetailsModel();
        this.vapidDetailsModel = new VapidDetailsModel();
        this.iidModel = new IidModel();
        this.app = app;
        this.INTERNAL = {
            delete: function () { return _this.delete(); }
        };
    }
    /**
     * @export
     */
    BaseController.prototype.getToken = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var currentPermission, swReg, publicVapidKey, pushSubscription, tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentPermission = this.getNotificationPermission_();
                        if (currentPermission === 'denied') {
                            throw errorFactory.create(ERROR_CODES.NOTIFICATIONS_BLOCKED);
                        }
                        else if (currentPermission !== 'granted') {
                            // We must wait for permission to be granted
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        swReg = _a.sent();
                        return [4 /*yield*/, this.getPublicVapidKey_()];
                    case 2:
                        publicVapidKey = _a.sent();
                        return [4 /*yield*/, this.getPushSubscription(swReg, publicVapidKey)];
                    case 3:
                        pushSubscription = _a.sent();
                        return [4 /*yield*/, this.tokenDetailsModel.getTokenDetailsFromSWScope(swReg.scope)];
                    case 4:
                        tokenDetails = _a.sent();
                        if (tokenDetails) {
                            return [2 /*return*/, this.manageExistingToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
                        }
                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
                }
            });
        });
    };
    /**
     * manageExistingToken is triggered if there's an existing FCM token in the
     * database and it can take 3 different actions:
     * 1) Retrieve the existing FCM token from the database.
     * 2) If VAPID details have changed: Delete the existing token and create a
     * new one with the new VAPID key.
     * 3) If the database cache is invalidated: Send a request to FCM to update
     * the token, and to check if the token is still valid on FCM-side.
     */
    BaseController.prototype.manageExistingToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var isTokenValid, now;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isTokenValid = isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails);
                        if (isTokenValid) {
                            now = Date.now();
                            if (now < tokenDetails.createTime + TOKEN_EXPIRATION_MILLIS) {
                                return [2 /*return*/, tokenDetails.fcmToken];
                            }
                            else {
                                return [2 /*return*/, this.updateToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
                            }
                        }
                        // If the token is no longer valid (for example if the VAPID details
                        // have changed), delete the existing token from the FCM client and server
                        // database. No need to unsubscribe from the Service Worker as we have a
                        // good push subscription that we'd like to use in getNewToken.
                        return [4 /*yield*/, this.deleteTokenFromDB(tokenDetails.fcmToken)];
                    case 1:
                        // If the token is no longer valid (for example if the VAPID details
                        // have changed), delete the existing token from the FCM client and server
                        // database. No need to unsubscribe from the Service Worker as we have a
                        // good push subscription that we'd like to use in getNewToken.
                        _a.sent();
                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
                }
            });
        });
    };
    BaseController.prototype.updateToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var updatedToken, allDetails, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 6]);
                        return [4 /*yield*/, this.iidModel.updateToken(this.messagingSenderId, tokenDetails.fcmToken, tokenDetails.fcmPushSet, pushSubscription, publicVapidKey)];
                    case 1:
                        updatedToken = _a.sent();
                        allDetails = {
                            swScope: swReg.scope,
                            vapidKey: publicVapidKey,
                            fcmSenderId: this.messagingSenderId,
                            fcmToken: updatedToken,
                            fcmPushSet: tokenDetails.fcmPushSet,
                            createTime: Date.now(),
                            endpoint: pushSubscription.endpoint,
                            auth: pushSubscription.getKey('auth'),
                            p256dh: pushSubscription.getKey('p256dh')
                        };
                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, updatedToken];
                    case 4:
                        e_1 = _a.sent();
                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
                    case 5:
                        _a.sent();
                        throw e_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BaseController.prototype.getNewToken = function (swReg, pushSubscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var tokenDetails, allDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.iidModel.getToken(this.messagingSenderId, pushSubscription, publicVapidKey)];
                    case 1:
                        tokenDetails = _a.sent();
                        allDetails = {
                            swScope: swReg.scope,
                            vapidKey: publicVapidKey,
                            fcmSenderId: this.messagingSenderId,
                            fcmToken: tokenDetails.token,
                            fcmPushSet: tokenDetails.pushSet,
                            createTime: Date.now(),
                            endpoint: pushSubscription.endpoint,
                            auth: pushSubscription.getKey('auth'),
                            p256dh: pushSubscription.getKey('p256dh')
                        };
                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, tokenDetails.token];
                }
            });
        });
    };
    /**
     * This method deletes tokens that the token manager looks after,
     * unsubscribes the token from FCM  and then unregisters the push
     * subscription if it exists. It returns a promise that indicates
     * whether or not the unsubscribe request was processed successfully.
     */
    BaseController.prototype.deleteToken = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var registration, pushSubscription;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Delete the token details from the database.
                    return [4 /*yield*/, this.deleteTokenFromDB(token)];
                    case 1:
                        // Delete the token details from the database.
                        _a.sent();
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 2:
                        registration = _a.sent();
                        if (!registration) return [3 /*break*/, 4];
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 3:
                        pushSubscription = _a.sent();
                        if (pushSubscription) {
                            return [2 /*return*/, pushSubscription.unsubscribe()];
                        }
                        _a.label = 4;
                    case 4: 
                    // If there's no SW, consider it a success.
                    return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * This method will delete the token from the client database, and make a
     * call to FCM to remove it from the server DB. Does not temper with the
     * push subscription.
     */
    BaseController.prototype.deleteTokenFromDB = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenDetailsModel.deleteToken(token)];
                    case 1:
                        details = _a.sent();
                        return [4 /*yield*/, this.iidModel.deleteToken(details.fcmSenderId, details.fcmToken, details.fcmPushSet)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets a PushSubscription for the current user.
     */
    BaseController.prototype.getPushSubscription = function (swRegistration, publicVapidKey) {
        return swRegistration.pushManager.getSubscription().then(function (subscription) {
            if (subscription) {
                return subscription;
            }
            return swRegistration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: publicVapidKey
            });
        });
    };
    //
    // The following methods should only be available in the window.
    //
    BaseController.prototype.requestPermission = function () {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    BaseController.prototype.useServiceWorker = function (registration) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    BaseController.prototype.usePublicVapidKey = function (b64PublicKey) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    BaseController.prototype.onMessage = function (nextOrObserver, error, completed) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    BaseController.prototype.onTokenRefresh = function (nextOrObserver, error, completed) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    //
    // The following methods are used by the service worker only.
    //
    BaseController.prototype.setBackgroundMessageHandler = function (callback) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_SW);
    };
    //
    // The following methods are used by the service themselves and not exposed
    // publicly or not expected to be used by developers.
    //
    /**
     * This method is required to adhere to the Firebase interface.
     * It closes any currently open indexdb database connections.
     */
    BaseController.prototype.delete = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.tokenDetailsModel.closeDatabase(),
                            this.vapidDetailsModel.closeDatabase()
                        ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns the current Notification Permission state.
     */
    BaseController.prototype.getNotificationPermission_ = function () {
        // TODO: Remove the cast when this issue is fixed:
        // https://github.com/Microsoft/TypeScript/issues/14701
        // tslint:disable-next-line no-any
        return Notification.permission;
    };
    BaseController.prototype.getTokenDetailsModel = function () {
        return this.tokenDetailsModel;
    };
    BaseController.prototype.getVapidDetailsModel = function () {
        return this.vapidDetailsModel;
    };
    // Visible for testing
    // TODO: make protected
    BaseController.prototype.getIidModel = function () {
        return this.iidModel;
    };
    return BaseController;
}());
/**
 * Checks if the tokenDetails match the details provided in the clients.
 */
function isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails) {
    if (!tokenDetails.vapidKey ||
        !isArrayBufferEqual(publicVapidKey.buffer, tokenDetails.vapidKey.buffer)) {
        return false;
    }
    var isEndpointEqual = pushSubscription.endpoint === tokenDetails.endpoint;
    var isAuthEqual = isArrayBufferEqual(pushSubscription.getKey('auth'), tokenDetails.auth);
    var isP256dhEqual = isArrayBufferEqual(pushSubscription.getKey('p256dh'), tokenDetails.p256dh);
    return isEndpointEqual && isAuthEqual && isP256dhEqual;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FCM_MSG = 'FCM_MSG';
var SwController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(SwController, _super);
    function SwController(app) {
        var _this = _super.call(this, app) || this;
        _this.bgMessageHandler = null;
        self.addEventListener('push', function (e) {
            _this.onPush(e);
        });
        self.addEventListener('pushsubscriptionchange', function (e) {
            _this.onSubChange(e);
        });
        self.addEventListener('notificationclick', function (e) {
            _this.onNotificationClick(e);
        });
        return _this;
    }
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onPush = function (event) {
        event.waitUntil(this.onPush_(event));
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onSubChange = function (event) {
        event.waitUntil(this.onSubChange_(event));
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onNotificationClick = function (event) {
        event.waitUntil(this.onNotificationClick_(event));
    };
    /**
     * A handler for push events that shows notifications based on the content of
     * the payload.
     *
     * The payload must be a JSON-encoded Object with a `notification` key. The
     * value of the `notification` property will be used as the NotificationOptions
     * object passed to showNotification. Additionally, the `title` property of the
     * notification object will be used as the title.
     *
     * If there is no notification data in the payload then no notification will be
     * shown.
     */
    SwController.prototype.onPush_ = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var msgPayload, hasVisibleClients, notificationDetails, notificationTitle, reg, actions, maxActions;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.data) {
                            return [2 /*return*/];
                        }
                        try {
                            msgPayload = event.data.json();
                        }
                        catch (err) {
                            // Not JSON so not an FCM message
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.hasVisibleClients_()];
                    case 1:
                        hasVisibleClients = _a.sent();
                        if (hasVisibleClients) {
                            // App in foreground. Send to page.
                            return [2 /*return*/, this.sendMessageToWindowClients_(msgPayload)];
                        }
                        notificationDetails = this.getNotificationData_(msgPayload);
                        if (!notificationDetails) return [3 /*break*/, 3];
                        notificationTitle = notificationDetails.title || '';
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 2:
                        reg = _a.sent();
                        actions = notificationDetails.actions;
                        maxActions = Notification.maxActions;
                        // tslint:enable no-any
                        if (actions && maxActions && actions.length > maxActions) {
                            console.warn("This browser only supports " + maxActions + " actions." +
                                "The remaining actions will not be displayed.");
                        }
                        return [2 /*return*/, reg.showNotification(notificationTitle, notificationDetails)];
                    case 3:
                        if (!this.bgMessageHandler) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.bgMessageHandler(msgPayload)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onSubChange_ = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var registration, err_1, err_2, tokenDetailsModel, tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        registration = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.UNABLE_TO_RESUBSCRIBE, {
                            message: err_1
                        });
                    case 3:
                        _a.trys.push([3, 5, , 8]);
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 5:
                        err_2 = _a.sent();
                        tokenDetailsModel = this.getTokenDetailsModel();
                        return [4 /*yield*/, tokenDetailsModel.getTokenDetailsFromSWScope(registration.scope)];
                    case 6:
                        tokenDetails = _a.sent();
                        if (!tokenDetails) {
                            // This should rarely occure, but could if indexedDB
                            // is corrupted or wiped
                            throw err_2;
                        }
                        // Attempt to delete the token if we know it's bad
                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
                    case 7:
                        // Attempt to delete the token if we know it's bad
                        _a.sent();
                        throw err_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onNotificationClick_ = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var msgPayload, link, windowClient, internalMsg;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.notification ||
                            !event.notification.data ||
                            !event.notification.data[FCM_MSG]) {
                            // Not an FCM notification, do nothing.
                            return [2 /*return*/];
                        }
                        else if (event.action) {
                            // User clicked on an action button.
                            // This will allow devs to act on action button clicks by using a custom
                            // onNotificationClick listener that they define.
                            return [2 /*return*/];
                        }
                        // Prevent other listeners from receiving the event
                        event.stopImmediatePropagation();
                        event.notification.close();
                        msgPayload = event.notification.data[FCM_MSG];
                        if (!msgPayload.notification) {
                            // Nothing to do.
                            return [2 /*return*/];
                        }
                        link = (msgPayload.fcmOptions && msgPayload.fcmOptions.link) ||
                            msgPayload.notification.click_action;
                        if (!link) {
                            // Nothing to do.
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getWindowClient_(link)];
                    case 1:
                        windowClient = _a.sent();
                        if (!!windowClient) return [3 /*break*/, 3];
                        return [4 /*yield*/, self.clients.openWindow(link)];
                    case 2:
                        // Unable to find window client so need to open one.
                        windowClient = _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, windowClient.focus()];
                    case 4:
                        windowClient = _a.sent();
                        _a.label = 5;
                    case 5:
                        if (!windowClient) {
                            // Window Client will not be returned if it's for a third party origin.
                            return [2 /*return*/];
                        }
                        // Delete notification and fcmOptions data from payload before sending to
                        // the page.
                        delete msgPayload.notification;
                        delete msgPayload.fcmOptions;
                        internalMsg = createNewMsg(MessageType.NOTIFICATION_CLICKED, msgPayload);
                        // Attempt to send a message to the client to handle the data
                        // Is affected by: https://github.com/slightlyoff/ServiceWorker/issues/728
                        return [2 /*return*/, this.attemptToMessageClient_(windowClient, internalMsg)];
                }
            });
        });
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.getNotificationData_ = function (msgPayload) {
        if (!msgPayload) {
            return;
        }
        if (typeof msgPayload.notification !== 'object') {
            return;
        }
        var notificationInformation = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"])({}, msgPayload.notification);
        // Put the message payload under FCM_MSG name so we can identify the
        // notification as being an FCM notification vs a notification from
        // somewhere else (i.e. normal web push or developer generated
        // notification).
        notificationInformation.data = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"])({}, msgPayload.notification.data, (_a = {}, _a[FCM_MSG] = msgPayload, _a));
        return notificationInformation;
        var _a;
    };
    /**
     * Calling setBackgroundMessageHandler will opt in to some specific
     * behaviours.
     * 1.) If a notification doesn't need to be shown due to a window already
     * being visible, then push messages will be sent to the page.
     * 2.) If a notification needs to be shown, and the message contains no
     * notification data this method will be called
     * and the promise it returns will be passed to event.waitUntil.
     * If you do not set this callback then all push messages will let and the
     * developer can handle them in a their own 'push' event callback
     *
     * @param callback The callback to be called when a push message is received
     * and a notification must be shown. The callback will be given the data from
     * the push message.
     */
    SwController.prototype.setBackgroundMessageHandler = function (callback) {
        if (!callback || typeof callback !== 'function') {
            throw errorFactory.create(ERROR_CODES.BG_HANDLER_FUNCTION_EXPECTED);
        }
        this.bgMessageHandler = callback;
    };
    /**
     * @param url The URL to look for when focusing a client.
     * @return Returns an existing window client or a newly opened WindowClient.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.getWindowClient_ = function (url) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var parsedURL, clientList, suitableClient, i, parsedClientUrl;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parsedURL = new URL(url, self.location.href).href;
                        return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        suitableClient = null;
                        for (i = 0; i < clientList.length; i++) {
                            parsedClientUrl = new URL(clientList[i].url, self.location.href)
                                .href;
                            if (parsedClientUrl === parsedURL) {
                                suitableClient = clientList[i];
                                break;
                            }
                        }
                        return [2 /*return*/, suitableClient];
                }
            });
        });
    };
    /**
     * This message will attempt to send the message to a window client.
     * @param client The WindowClient to send the message to.
     * @param message The message to send to the client.
     * @returns Returns a promise that resolves after sending the message. This
     * does not guarantee that the message was successfully received.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.attemptToMessageClient_ = function (client, message) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                // NOTE: This returns a promise in case this API is abstracted later on to
                // do additional work
                if (!client) {
                    throw errorFactory.create(ERROR_CODES.NO_WINDOW_CLIENT_TO_MSG);
                }
                client.postMessage(message);
                return [2 /*return*/];
            });
        });
    };
    /**
     * @returns If there is currently a visible WindowClient, this method will
     * resolve to true, otherwise false.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.hasVisibleClients_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var clientList;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        return [2 /*return*/, clientList.some(function (client) { return client.visibilityState === 'visible'; })];
                }
            });
        });
    };
    /**
     * @param msgPayload The data from the push event that should be sent to all
     * available pages.
     * @returns Returns a promise that resolves once the message has been sent to
     * all WindowClients.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.sendMessageToWindowClients_ = function (msgPayload) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var _this = this;
            var clientList, internalMsg;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        internalMsg = createNewMsg(MessageType.PUSH_MSG_RECEIVED, msgPayload);
                        return [4 /*yield*/, Promise.all(clientList.map(function (client) {
                                return _this.attemptToMessageClient_(client, internalMsg);
                            }))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This will register the default service worker and return the registration.
     * @return he service worker registration to be used for the push service.
     */
    SwController.prototype.getSWRegistration_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                return [2 /*return*/, self.registration];
            });
        });
    };
    /**
     * This will return the default VAPID key or the uint8array version of the
     * public VAPID key provided by the developer.
     */
    SwController.prototype.getPublicVapidKey_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var swReg, vapidKeyFromDatabase;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        swReg = _a.sent();
                        if (!swReg) {
                            throw errorFactory.create(ERROR_CODES.SW_REGISTRATION_EXPECTED);
                        }
                        return [4 /*yield*/, this.getVapidDetailsModel().getVapidFromSWScope(swReg.scope)];
                    case 2:
                        vapidKeyFromDatabase = _a.sent();
                        if (vapidKeyFromDatabase == null) {
                            return [2 /*return*/, DEFAULT_PUBLIC_VAPID_KEY];
                        }
                        return [2 /*return*/, vapidKeyFromDatabase];
                }
            });
        });
    };
    return SwController;
}(BaseController));
function getClientList() {
    return self.clients.matchAll({
        type: 'window',
        includeUncontrolled: true
        // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
    });
}
function createNewMsg(msgType, msgData) {
    return _a = {}, _a[MessageParameter.TYPE_OF_MSG] = msgType, _a[MessageParameter.DATA] = msgData, _a;
    var _a;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
var DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WindowController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(WindowController, _super);
    /**
     * A service that provides a MessagingService instance.
     */
    function WindowController(app) {
        var _this = _super.call(this, app) || this;
        _this.registrationToUse = null;
        _this.publicVapidKeyToUse = null;
        _this.manifestCheckPromise = null;
        _this.messageObserver = null;
        // @ts-ignore: Unused variable error, this is not implemented yet.
        _this.tokenRefreshObserver = null;
        _this.onMessageInternal = Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["createSubscribe"])(function (observer) {
            _this.messageObserver = observer;
        });
        _this.onTokenRefreshInternal = Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["createSubscribe"])(function (observer) {
            _this.tokenRefreshObserver = observer;
        });
        _this.setupSWMessageListener_();
        return _this;
    }
    /**
     * This method returns an FCM token if it can be generated.
     * The return promise will reject if the browser doesn't support
     * FCM, if permission is denied for notifications or it's not
     * possible to generate a token.
     *
     * @return Returns a promise that resolves to an FCM token or null if
     * permission isn't granted.
     */
    WindowController.prototype.getToken = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.manifestCheckPromise) {
                            this.manifestCheckPromise = manifestCheck();
                        }
                        return [4 /*yield*/, this.manifestCheckPromise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, _super.prototype.getToken.call(this)];
                }
            });
        });
    };
    /**
     * Request permission if it is not currently granted
     *
     * @return Resolves if the permission was granted, otherwise rejects
     */
    WindowController.prototype.requestPermission = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var permissionResult;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.getNotificationPermission_() === 'granted') {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Notification.requestPermission()];
                    case 1:
                        permissionResult = _a.sent();
                        if (permissionResult === 'granted') {
                            return [2 /*return*/];
                        }
                        else if (permissionResult === 'denied') {
                            throw errorFactory.create(ERROR_CODES.PERMISSION_BLOCKED);
                        }
                        else {
                            throw errorFactory.create(ERROR_CODES.PERMISSION_DEFAULT);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This method allows a developer to override the default service worker and
     * instead use a custom service worker.
     *
     * @param registration The service worker registration that should be used to
     * receive the push messages.
     */
    WindowController.prototype.useServiceWorker = function (registration) {
        if (!(registration instanceof ServiceWorkerRegistration)) {
            throw errorFactory.create(ERROR_CODES.SW_REGISTRATION_EXPECTED);
        }
        if (this.registrationToUse != null) {
            throw errorFactory.create(ERROR_CODES.USE_SW_BEFORE_GET_TOKEN);
        }
        this.registrationToUse = registration;
    };
    /**
     * This method allows a developer to override the default vapid key
     * and instead use a custom VAPID public key.
     *
     * @param publicKey A URL safe base64 encoded string.
     */
    WindowController.prototype.usePublicVapidKey = function (publicKey) {
        if (typeof publicKey !== 'string') {
            throw errorFactory.create(ERROR_CODES.INVALID_PUBLIC_VAPID_KEY);
        }
        if (this.publicVapidKeyToUse != null) {
            throw errorFactory.create(ERROR_CODES.USE_PUBLIC_KEY_BEFORE_GET_TOKEN);
        }
        var parsedKey = base64ToArrayBuffer(publicKey);
        if (parsedKey.length !== 65) {
            throw errorFactory.create(ERROR_CODES.PUBLIC_KEY_DECRYPTION_FAILED);
        }
        this.publicVapidKeyToUse = parsedKey;
    };
    /**
     * @export
     * @param nextOrObserver An observer object or a function triggered on
     * message.
     * @param error A function triggered on message error.
     * @param completed function triggered when the observer is removed.
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onMessage = function (nextOrObserver, error, completed) {
        if (typeof nextOrObserver === 'function') {
            return this.onMessageInternal(nextOrObserver, error, completed);
        }
        else {
            return this.onMessageInternal(nextOrObserver);
        }
    };
    /**
     * @param nextOrObserver An observer object or a function triggered on token
     * refresh.
     * @param error A function triggered on token refresh error.
     * @param completed function triggered when the observer is removed.
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onTokenRefresh = function (nextOrObserver, error, completed) {
        if (typeof nextOrObserver === 'function') {
            return this.onTokenRefreshInternal(nextOrObserver, error, completed);
        }
        else {
            return this.onTokenRefreshInternal(nextOrObserver);
        }
    };
    /**
     * Given a registration, wait for the service worker it relates to
     * become activer
     * @param registration Registration to wait for service worker to become active
     * @return Wait for service worker registration to become active
     */
    // Visible for testing
    // TODO: Make private
    WindowController.prototype.waitForRegistrationToActivate_ = function (registration) {
        var serviceWorker = registration.installing || registration.waiting || registration.active;
        return new Promise(function (resolve, reject) {
            if (!serviceWorker) {
                // This is a rare scenario but has occured in firefox
                reject(errorFactory.create(ERROR_CODES.NO_SW_IN_REG));
                return;
            }
            // Because the Promise function is called on next tick there is a
            // small chance that the worker became active or redundant already.
            if (serviceWorker.state === 'activated') {
                resolve(registration);
                return;
            }
            if (serviceWorker.state === 'redundant') {
                reject(errorFactory.create(ERROR_CODES.SW_REG_REDUNDANT));
                return;
            }
            var stateChangeListener = function () {
                if (serviceWorker.state === 'activated') {
                    resolve(registration);
                }
                else if (serviceWorker.state === 'redundant') {
                    reject(errorFactory.create(ERROR_CODES.SW_REG_REDUNDANT));
                }
                else {
                    // Return early and wait to next state change
                    return;
                }
                serviceWorker.removeEventListener('statechange', stateChangeListener);
            };
            serviceWorker.addEventListener('statechange', stateChangeListener);
        });
    };
    /**
     * This will register the default service worker and return the registration
     * @return The service worker registration to be used for the push service.
     */
    WindowController.prototype.getSWRegistration_ = function () {
        var _this = this;
        if (this.registrationToUse) {
            return this.waitForRegistrationToActivate_(this.registrationToUse);
        }
        // Make the registration null so we know useServiceWorker will not
        // use a new service worker as registrationToUse is no longer undefined
        this.registrationToUse = null;
        return navigator.serviceWorker
            .register(DEFAULT_SW_PATH, {
            scope: DEFAULT_SW_SCOPE
        })
            .catch(function (err) {
            throw errorFactory.create(ERROR_CODES.FAILED_DEFAULT_REGISTRATION, {
                browserErrorMessage: err.message
            });
        })
            .then(function (registration) {
            return _this.waitForRegistrationToActivate_(registration).then(function () {
                _this.registrationToUse = registration;
                // We update after activation due to an issue with Firefox v49 where
                // a race condition occassionally causes the service work to not
                // install
                registration.update();
                return registration;
            });
        });
    };
    /**
     * This will return the default VAPID key or the uint8array version of the public VAPID key
     * provided by the developer.
     */
    WindowController.prototype.getPublicVapidKey_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (this.publicVapidKeyToUse) {
                    return [2 /*return*/, this.publicVapidKeyToUse];
                }
                return [2 /*return*/, DEFAULT_PUBLIC_VAPID_KEY];
            });
        });
    };
    /**
     * This method will set up a message listener to handle
     * events from the service worker that should trigger
     * events in the page.
     */
    // Visible for testing
    // TODO: Make private
    WindowController.prototype.setupSWMessageListener_ = function () {
        var _this = this;
        navigator.serviceWorker.addEventListener('message', function (event) {
            if (!event.data || !event.data[MessageParameter.TYPE_OF_MSG]) {
                // Not a message from FCM
                return;
            }
            var workerPageMessage = event.data;
            switch (workerPageMessage[MessageParameter.TYPE_OF_MSG]) {
                case MessageType.PUSH_MSG_RECEIVED:
                case MessageType.NOTIFICATION_CLICKED:
                    var pushMessage = workerPageMessage[MessageParameter.DATA];
                    if (_this.messageObserver) {
                        _this.messageObserver.next(pushMessage);
                    }
                    break;
                default:
                    // Noop.
                    break;
            }
        }, false);
    };
    return WindowController;
}(BaseController));
/**
 * The method checks that a manifest is defined and has the correct GCM
 * sender ID.
 * @return Returns a promise that resolves if the manifest matches
 * our required sender ID
 */
// Exported for testing
function manifestCheck() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var manifestTag, manifestContent, response, e_1;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    manifestTag = document.querySelector('link[rel="manifest"]');
                    if (!manifestTag) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(manifestTag.href)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    manifestContent = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    // If the download or parsing fails allow check.
                    // We only want to error if we KNOW that the gcm_sender_id is incorrect.
                    return [2 /*return*/];
                case 5:
                    if (!manifestContent || !manifestContent.gcm_sender_id) {
                        return [2 /*return*/];
                    }
                    if (manifestContent.gcm_sender_id !== '103953800507') {
                        throw errorFactory.create(ERROR_CODES.INCORRECT_GCM_SENDER_ID);
                    }
                    return [2 /*return*/];
            }
        });
    });
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerMessaging(instance) {
    var messagingName = 'messaging';
    var factoryMethod = function (app) {
        if (!isSupported()) {
            throw errorFactory.create(ERROR_CODES.UNSUPPORTED_BROWSER);
        }
        if (self && 'ServiceWorkerGlobalScope' in self) {
            // Running in ServiceWorker context
            return new SwController(app);
        }
        else {
            // Assume we are in the window context.
            return new WindowController(app);
        }
    };
    var namespaceExports = {
        isSupported: isSupported
    };
    instance.INTERNAL.registerService(messagingName, factoryMethod, namespaceExports);
}
registerMessaging(__WEBPACK_IMPORTED_MODULE_2__firebase_app___default.a);
function isSupported() {
    if (self && 'ServiceWorkerGlobalScope' in self) {
        // Running in ServiceWorker context
        return isSWControllerSupported();
    }
    else {
        // Assume we are in the window context.
        return isWindowControllerSupported();
    }
}
/**
 * Checks to see if the required APIs exist.
 */
function isWindowControllerSupported() {
    return (navigator.cookieEnabled &&
        'serviceWorker' in navigator &&
        'PushManager' in window &&
        'Notification' in window &&
        'fetch' in window &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}
/**
 * Checks to see if the required APIs exist within SW Context.
 */
function isSWControllerSupported() {
    return ('PushManager' in self &&
        'Notification' in self &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}




/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerStorage", function() { return registerStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);


/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Constants used in the Firebase Storage library.
 */
/**
 * Domain and scheme for API calls.
 */
var domainBase = 'https://firebasestorage.googleapis.com';
/**
 * Domain and scheme for object downloads.
 */
var downloadBase = 'https://firebasestorage.googleapis.com';
/**
 * Base URL for non-upload calls to the API.
 */
var apiBaseUrl = '/v0';
/**
 * Base URL for upload calls to the API.
 */
var apiUploadBaseUrl = '/v0';
var configOption = 'storageBucket';
/**
 * 2 minutes
 */
var defaultMaxOperationRetryTime = 2 * 60 * 1000;
/**
 * 10 minutes
 */
var defaultMaxUploadRetryTime = 10 * 60 * 100;
/**
 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
 * enough for us to use it directly.
 */
var minSafeInteger = -9007199254740991;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FirebaseStorageError = /** @class */ (function () {
    function FirebaseStorageError(code, message) {
        this.code_ = prependCode(code);
        this.message_ = 'Firebase Storage: ' + message;
        this.serverResponse_ = null;
        this.name_ = 'FirebaseError';
    }
    FirebaseStorageError.prototype.codeProp = function () {
        return this.code;
    };
    FirebaseStorageError.prototype.codeEquals = function (code) {
        return prependCode(code) === this.codeProp();
    };
    FirebaseStorageError.prototype.serverResponseProp = function () {
        return this.serverResponse_;
    };
    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
        this.serverResponse_ = serverResponse;
    };
    Object.defineProperty(FirebaseStorageError.prototype, "name", {
        get: function () {
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "code", {
        get: function () {
            return this.code_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "message", {
        get: function () {
            return this.message_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
        get: function () {
            return this.serverResponse_;
        },
        enumerable: true,
        configurable: true
    });
    return FirebaseStorageError;
}());
var Code = {
    // Shared between all platforms
    UNKNOWN: 'unknown',
    OBJECT_NOT_FOUND: 'object-not-found',
    BUCKET_NOT_FOUND: 'bucket-not-found',
    PROJECT_NOT_FOUND: 'project-not-found',
    QUOTA_EXCEEDED: 'quota-exceeded',
    UNAUTHENTICATED: 'unauthenticated',
    UNAUTHORIZED: 'unauthorized',
    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
    INVALID_CHECKSUM: 'invalid-checksum',
    CANCELED: 'canceled',
    // JS specific
    INVALID_EVENT_NAME: 'invalid-event-name',
    INVALID_URL: 'invalid-url',
    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
    NO_DEFAULT_BUCKET: 'no-default-bucket',
    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
    NO_DOWNLOAD_URL: 'no-download-url',
    INVALID_ARGUMENT: 'invalid-argument',
    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
    APP_DELETED: 'app-deleted',
    INVALID_ROOT_OPERATION: 'invalid-root-operation',
    INVALID_FORMAT: 'invalid-format',
    INTERNAL_ERROR: 'internal-error'
};
function prependCode(code) {
    return 'storage/' + code;
}
function unknown() {
    var message = 'An unknown error occurred, please check the error payload for ' +
        'server response.';
    return new FirebaseStorageError(Code.UNKNOWN, message);
}
function objectNotFound(path) {
    return new FirebaseStorageError(Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function quotaExceeded(bucket) {
    return new FirebaseStorageError(Code.QUOTA_EXCEEDED, "Quota for bucket '" +
        bucket +
        "' exceeded, please view quota on " +
        'https://firebase.google.com/pricing/.');
}
function unauthenticated() {
    var message = 'User is not authenticated, please authenticate using Firebase ' +
        'Authentication and try again.';
    return new FirebaseStorageError(Code.UNAUTHENTICATED, message);
}
function unauthorized(path) {
    return new FirebaseStorageError(Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function retryLimitExceeded() {
    return new FirebaseStorageError(Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function canceled() {
    return new FirebaseStorageError(Code.CANCELED, 'User canceled the upload/download.');
}
function invalidUrl(url) {
    return new FirebaseStorageError(Code.INVALID_URL, "Invalid URL '" + url + "'.");
}
function invalidDefaultBucket(bucket) {
    return new FirebaseStorageError(Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function cannotSliceBlob() {
    return new FirebaseStorageError(Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function serverFileWrongSize() {
    return new FirebaseStorageError(Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function noDownloadURL() {
    return new FirebaseStorageError(Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function invalidArgument(index, fnName, message) {
    return new FirebaseStorageError(Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
}
function invalidArgumentCount(argMin, argMax, fnName, real) {
    var countPart;
    var plural;
    if (argMin === argMax) {
        countPart = argMin;
        plural = argMin === 1 ? 'argument' : 'arguments';
    }
    else {
        countPart = 'between ' + argMin + ' and ' + argMax;
        plural = 'arguments';
    }
    return new FirebaseStorageError(Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' +
        fnName +
        '`: Expected ' +
        countPart +
        ' ' +
        plural +
        ', received ' +
        real +
        '.');
}
function appDeleted() {
    return new FirebaseStorageError(Code.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name The name of the operation that was invalid.
 */
function invalidRootOperation(name) {
    return new FirebaseStorageError(Code.INVALID_ROOT_OPERATION, "The operation '" +
        name +
        "' cannot be performed on a root reference, create a non-root " +
        "reference using child, such as .child('file.png').");
}
/**
 * @param format The format that was not valid.
 * @param message A message describing the format violation.
 */
function invalidFormat(format, message) {
    return new FirebaseStorageError(Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message A message describing the internal error.
 */
function internalError(message) {
    throw new FirebaseStorageError(Code.INTERNAL_ERROR, 'Internal error: ' + message);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StringFormat = {
    RAW: 'raw',
    BASE64: 'base64',
    BASE64URL: 'base64url',
    DATA_URL: 'data_url'
};
function formatValidator(stringFormat) {
    switch (stringFormat) {
        case StringFormat.RAW:
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
        case StringFormat.DATA_URL:
            return;
        default:
            throw 'Expected one of the event types: [' +
                StringFormat.RAW +
                ', ' +
                StringFormat.BASE64 +
                ', ' +
                StringFormat.BASE64URL +
                ', ' +
                StringFormat.DATA_URL +
                '].';
    }
}
/**
 * @struct
 */
var StringData = /** @class */ (function () {
    function StringData(data, opt_contentType) {
        this.data = data;
        this.contentType = opt_contentType || null;
    }
    return StringData;
}());
function dataFromString(format, string) {
    switch (format) {
        case StringFormat.RAW:
            return new StringData(utf8Bytes_(string));
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
            return new StringData(base64Bytes_(format, string));
        case StringFormat.DATA_URL:
            return new StringData(dataURLBytes_(string), dataURLContentType_(string));
    }
    // assert(false);
    throw unknown();
}
function utf8Bytes_(string) {
    var b = [];
    for (var i = 0; i < string.length; i++) {
        var c = string.charCodeAt(i);
        if (c <= 127) {
            b.push(c);
        }
        else {
            if (c <= 2047) {
                b.push(192 | (c >> 6), 128 | (c & 63));
            }
            else {
                if ((c & 64512) == 55296) {
                    // The start of a surrogate pair.
                    var valid = i < string.length - 1 &&
                        (string.charCodeAt(i + 1) & 64512) == 56320;
                    if (!valid) {
                        // The second surrogate wasn't there.
                        b.push(239, 191, 189);
                    }
                    else {
                        var hi = c;
                        var lo = string.charCodeAt(++i);
                        c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
                        b.push(240 | (c >> 18), 128 | ((c >> 12) & 63), 128 | ((c >> 6) & 63), 128 | (c & 63));
                    }
                }
                else {
                    if ((c & 64512) == 56320) {
                        // Invalid low surrogate.
                        b.push(239, 191, 189);
                    }
                    else {
                        b.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
                    }
                }
            }
        }
    }
    return new Uint8Array(b);
}
function percentEncodedBytes_(string) {
    var decoded;
    try {
        decoded = decodeURIComponent(string);
    }
    catch (e) {
        throw invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
    }
    return utf8Bytes_(decoded);
}
function base64Bytes_(format, string) {
    switch (format) {
        case StringFormat.BASE64: {
            var hasMinus = string.indexOf('-') !== -1;
            var hasUnder = string.indexOf('_') !== -1;
            if (hasMinus || hasUnder) {
                var invalidChar = hasMinus ? '-' : '_';
                throw invalidFormat(format, "Invalid character '" +
                    invalidChar +
                    "' found: is it base64url encoded?");
            }
            break;
        }
        case StringFormat.BASE64URL: {
            var hasPlus = string.indexOf('+') !== -1;
            var hasSlash = string.indexOf('/') !== -1;
            if (hasPlus || hasSlash) {
                var invalidChar = hasPlus ? '+' : '/';
                throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
            }
            string = string.replace(/-/g, '+').replace(/_/g, '/');
            break;
        }
    }
    var bytes;
    try {
        bytes = atob(string);
    }
    catch (e) {
        throw invalidFormat(format, 'Invalid character found');
    }
    var array = new Uint8Array(bytes.length);
    for (var i = 0; i < bytes.length; i++) {
        array[i] = bytes.charCodeAt(i);
    }
    return array;
}
/**
 * @struct
 */
var DataURLParts = /** @class */ (function () {
    function DataURLParts(dataURL) {
        this.base64 = false;
        this.contentType = null;
        var matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) {
            throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        }
        var middle = matches[1] || null;
        if (middle != null) {
            this.base64 = endsWith(middle, ';base64');
            this.contentType = this.base64
                ? middle.substring(0, middle.length - ';base64'.length)
                : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
    return DataURLParts;
}());
function dataURLBytes_(string) {
    var parts = new DataURLParts(string);
    if (parts.base64) {
        return base64Bytes_(StringFormat.BASE64, parts.rest);
    }
    else {
        return percentEncodedBytes_(parts.rest);
    }
}
function dataURLContentType_(string) {
    var parts = new DataURLParts(string);
    return parts.contentType;
}
function endsWith(s, end) {
    var longEnough = s.length >= end.length;
    if (!longEnough) {
        return false;
    }
    return s.substring(s.length - end.length) === end;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TaskEvent = {
    /** Triggered whenever the task changes or progress is updated. */
    STATE_CHANGED: 'state_changed'
};
var InternalTaskState = {
    RUNNING: 'running',
    PAUSING: 'pausing',
    PAUSED: 'paused',
    SUCCESS: 'success',
    CANCELING: 'canceling',
    CANCELED: 'canceled',
    ERROR: 'error'
};
var TaskState = {
    /** The task is currently transferring data. */
    RUNNING: 'running',
    /** The task was paused by the user. */
    PAUSED: 'paused',
    /** The task completed successfully. */
    SUCCESS: 'success',
    /** The task was canceled. */
    CANCELED: 'canceled',
    /** The task failed with an error. */
    ERROR: 'error'
};
function taskStateFromInternalTaskState(state) {
    switch (state) {
        case InternalTaskState.RUNNING:
        case InternalTaskState.PAUSING:
        case InternalTaskState.CANCELING:
            return TaskState.RUNNING;
        case InternalTaskState.PAUSED:
            return TaskState.PAUSED;
        case InternalTaskState.SUCCESS:
            return TaskState.SUCCESS;
        case InternalTaskState.CANCELED:
            return TaskState.CANCELED;
        case InternalTaskState.ERROR:
            return TaskState.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return TaskState.ERROR;
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Contains methods for working with objects.
 */
function contains(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function forEach(obj, f) {
    for (var key in obj) {
        if (contains(obj, key)) {
            f(key, obj[key]);
        }
    }
}
function clone(obj) {
    if (obj == null) {
        return {};
    }
    var c = {};
    forEach(obj, function (key, val) {
        c[key] = val;
    });
    return c;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Implements the promise abstraction interface for external
 * (public SDK) packaging, which just passes through to the firebase-app impl.
 */
/**
 * @template T
 * @param {function((function(T): void),
 *                  (function(!Error): void))} resolver
 */
function make(resolver) {
    return new Promise(resolver);
}
/**
 * @template T
 */
function resolve(value) {
    return Promise.resolve(value);
}
function reject(error) {
    return Promise.reject(error);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @return False if the object is undefined or null, true otherwise.
 */
function isDef(p) {
    return p != null;
}
function isJustDef(p) {
    return p !== void 0;
}
function isFunction(p) {
    return typeof p === 'function';
}
function isObject(p) {
    return typeof p === 'object';
}
function isNonNullObject(p) {
    return isObject(p) && p !== null;
}
function isNonArrayObject(p) {
    return isObject(p) && !Array.isArray(p);
}
function isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function isNumber(p) {
    return typeof p === 'number' || p instanceof Number;
}
function isNativeBlob(p) {
    return isNativeBlobDefined() && p instanceof Blob;
}
function isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @enum{number}
 */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})(ErrorCode || (ErrorCode = {}));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
 * doesn't work in React Native on Android.
 */
var NetworkXhrIo = /** @class */ (function () {
    function NetworkXhrIo() {
        var _this = this;
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.errorCode_ = ErrorCode.NO_ERROR;
        this.sendPromise_ = make(function (resolve$$1, reject$$1) {
            _this.xhr_.addEventListener('abort', function (event) {
                _this.errorCode_ = ErrorCode.ABORT;
                resolve$$1(_this);
            });
            _this.xhr_.addEventListener('error', function (event) {
                _this.errorCode_ = ErrorCode.NETWORK_ERROR;
                resolve$$1(_this);
            });
            _this.xhr_.addEventListener('load', function (event) {
                resolve$$1(_this);
            });
        });
    }
    /**
     * @override
     */
    NetworkXhrIo.prototype.send = function (url, method, opt_body, opt_headers) {
        var _this = this;
        if (this.sent_) {
            throw internalError('cannot .send() more than once');
        }
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (isDef(opt_headers)) {
            var headers = opt_headers;
            forEach(headers, function (key, val) {
                _this.xhr_.setRequestHeader(key, val.toString());
            });
        }
        if (isDef(opt_body)) {
            this.xhr_.send(opt_body);
        }
        else {
            this.xhr_.send();
        }
        return this.sendPromise_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getErrorCode = function () {
        if (!this.sent_) {
            throw internalError('cannot .getErrorCode() before sending');
        }
        return this.errorCode_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getStatus = function () {
        if (!this.sent_) {
            throw internalError('cannot .getStatus() before sending');
        }
        try {
            return this.xhr_.status;
        }
        catch (e) {
            return -1;
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseText = function () {
        if (!this.sent_) {
            throw internalError('cannot .getResponseText() before sending');
        }
        return this.xhr_.responseText;
    };
    /**
     * Aborts the request.
     * @override
     */
    NetworkXhrIo.prototype.abort = function () {
        this.xhr_.abort();
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseHeader = function (header) {
        return this.xhr_.getResponseHeader(header);
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
        if (isDef(this.xhr_.upload)) {
            this.xhr_.upload.addEventListener('progress', listener);
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
        if (isDef(this.xhr_.upload)) {
            this.xhr_.upload.removeEventListener('progress', listener);
        }
    };
    return NetworkXhrIo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Factory-like class for creating XhrIo instances.
 */
var XhrIoPool = /** @class */ (function () {
    function XhrIoPool() {
    }
    XhrIoPool.prototype.createXhrIo = function () {
        return new NetworkXhrIo();
    };
    return XhrIoPool;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */
function jsonObjectOrNull(s) {
    var obj;
    try {
        obj = JSON.parse(s);
    }
    catch (e) {
        return null;
    }
    if (isNonArrayObject(obj)) {
        return obj;
    }
    else {
        return null;
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var Location = /** @class */ (function () {
    function Location(bucket, path) {
        this.bucket = bucket;
        this.path_ = path;
    }
    Object.defineProperty(Location.prototype, "path", {
        get: function () {
            return this.path_;
        },
        enumerable: true,
        configurable: true
    });
    Location.prototype.fullServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    };
    Location.prototype.bucketOnlyServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    };
    Location.makeFromBucketSpec = function (bucketString) {
        var bucketLocation;
        try {
            bucketLocation = Location.makeFromUrl(bucketString);
        }
        catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new Location(bucketString, '');
        }
        if (bucketLocation.path === '') {
            return bucketLocation;
        }
        else {
            throw invalidDefaultBucket(bucketString);
        }
    };
    Location.makeFromUrl = function (url) {
        var location = null;
        var bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') {
                loc.path_ = loc.path_.slice(0, -1);
            }
        }
        var gsPath = '(/(.*))?$';
        var path = '(/([^?#]*).*)?$';
        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        var gsIndices = { bucket: 1, path: 3 };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        var version = 'v[A-Za-z0-9_]+';
        var httpRegex = new RegExp('^https?://firebasestorage\\.googleapis\\.com/' +
            version +
            '/b/' +
            bucketDomain +
            '/o' +
            path, 'i');
        var httpIndices = { bucket: 1, path: 3 };
        var groups = [
            { regex: gsRegex, indices: gsIndices, postModify: gsModify },
            { regex: httpRegex, indices: httpIndices, postModify: httpModify }
        ];
        for (var i = 0; i < groups.length; i++) {
            var group = groups[i];
            var captures = group.regex.exec(url);
            if (captures) {
                var bucketValue = captures[group.indices.bucket];
                var pathValue = captures[group.indices.path];
                if (!pathValue) {
                    pathValue = '';
                }
                location = new Location(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) {
            throw invalidUrl(url);
        }
        return location;
    };
    return Location;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Contains helper methods for manipulating paths.
 */
/**
 * @return Null if the path is already at the root.
 */
function parent(path) {
    if (path.length == 0) {
        return null;
    }
    var index = path.lastIndexOf('/');
    if (index === -1) {
        return '';
    }
    var newPath = path.slice(0, index);
    return newPath;
}
function child(path, childPath) {
    var canonicalChildPath = childPath
        .split('/')
        .filter(function (component) {
        return component.length > 0;
    })
        .join('/');
    if (path.length === 0) {
        return canonicalChildPath;
    }
    else {
        return path + '/' + canonicalChildPath;
    }
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */
function lastComponent(path) {
    var index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) {
        return path;
    }
    else {
        return path.slice(index + 1);
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function makeNormalUrl(urlPart) {
    return domainBase + apiBaseUrl + urlPart;
}
function makeDownloadUrl(urlPart) {
    return downloadBase + apiBaseUrl + urlPart;
}
function makeUploadUrl(urlPart) {
    return domainBase + apiUploadBaseUrl + urlPart;
}
function makeQueryString(params) {
    var encode = encodeURIComponent;
    var queryPart = '?';
    forEach(params, function (key, val) {
        var nextPart = encode(key) + '=' + encode(val);
        queryPart = queryPart + nextPart + '&';
    });
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function noXform_(metadata, value) {
    return value;
}
/**
 * @struct
 */
var Mapping = /** @class */ (function () {
    function Mapping(server, opt_local, opt_writable, opt_xform) {
        this.server = server;
        this.local = opt_local || server;
        this.writable = !!opt_writable;
        this.xform = opt_xform || noXform_;
    }
    return Mapping;
}());
var mappings_ = null;
function xformPath(fullPath) {
    var valid = isString(fullPath);
    if (!valid || fullPath.length < 2) {
        return fullPath;
    }
    else {
        fullPath = fullPath;
        return lastComponent(fullPath);
    }
}
function getMappings() {
    if (mappings_) {
        return mappings_;
    }
    var mappings = [];
    mappings.push(new Mapping('bucket'));
    mappings.push(new Mapping('generation'));
    mappings.push(new Mapping('metageneration'));
    mappings.push(new Mapping('name', 'fullPath', true));
    function mappingsXformPath(metadata, fullPath) {
        return xformPath(fullPath);
    }
    var nameMapping = new Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */
    function xformSize(metadata, size) {
        if (isDef(size)) {
            return +size;
        }
        else {
            return size;
        }
    }
    var sizeMapping = new Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new Mapping('timeCreated'));
    mappings.push(new Mapping('updated'));
    mappings.push(new Mapping('md5Hash', null, true));
    mappings.push(new Mapping('cacheControl', null, true));
    mappings.push(new Mapping('contentDisposition', null, true));
    mappings.push(new Mapping('contentEncoding', null, true));
    mappings.push(new Mapping('contentLanguage', null, true));
    mappings.push(new Mapping('contentType', null, true));
    mappings.push(new Mapping('metadata', 'customMetadata', true));
    mappings_ = mappings;
    return mappings_;
}
function addRef(metadata, authWrapper) {
    function generateRef() {
        var bucket = metadata['bucket'];
        var path = metadata['fullPath'];
        var loc = new Location(bucket, path);
        return authWrapper.makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', { get: generateRef });
}
function fromResource(authWrapper, resource, mappings) {
    var metadata = {};
    metadata['type'] = 'file';
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    addRef(metadata, authWrapper);
    return metadata;
}
function fromResourceString(authWrapper, resourceString, mappings) {
    var obj = jsonObjectOrNull(resourceString);
    if (obj === null) {
        return null;
    }
    var resource = obj;
    return fromResource(authWrapper, resource, mappings);
}
function downloadUrlFromResourceString(metadata, resourceString) {
    var obj = jsonObjectOrNull(resourceString);
    if (obj === null) {
        return null;
    }
    if (!isString(obj['downloadTokens'])) {
        // This can happen if objects are uploaded through GCS and retrieved
        // through list, so we don't want to throw an Error.
        return null;
    }
    var tokens = obj['downloadTokens'];
    if (tokens.length === 0) {
        return null;
    }
    var encode = encodeURIComponent;
    var tokensList = tokens.split(',');
    var urls = tokensList.map(function (token) {
        var bucket = metadata['bucket'];
        var path = metadata['fullPath'];
        var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        var base = makeDownloadUrl(urlPart);
        var queryString = makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function toResourceString(metadata, mappings) {
    var resource = {};
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        if (mapping.writable) {
            resource[mapping.server] = metadata[mapping.local];
        }
    }
    return JSON.stringify(resource);
}
function metadataValidator(p) {
    var validType = p && isObject(p);
    if (!validType) {
        throw 'Expected Metadata object.';
    }
    for (var key in p) {
        var val = p[key];
        if (key === 'customMetadata') {
            if (!isObject(val)) {
                throw 'Expected object for \'customMetadata\' mapping.';
            }
        }
        else {
            if (isNonNullObject(val)) {
                throw "Mapping for '" + key + "' cannot be an object.";
            }
        }
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param name Name of the function.
 * @param specs Argument specs.
 * @param passed The actual arguments passed to the function.
 * @throws {fbs.Error} If the arguments are invalid.
 */
function validate(name, specs, passed) {
    var minArgs = specs.length;
    var maxArgs = specs.length;
    for (var i = 0; i < specs.length; i++) {
        if (specs[i].optional) {
            minArgs = i;
            break;
        }
    }
    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
    if (!validLength) {
        throw invalidArgumentCount(minArgs, maxArgs, name, passed.length);
    }
    for (var i = 0; i < passed.length; i++) {
        try {
            specs[i].validator(passed[i]);
        }
        catch (e) {
            if (e instanceof Error) {
                throw invalidArgument(i, name, e.message);
            }
            else {
                throw invalidArgument(i, name, e);
            }
        }
    }
}
/**
 * @struct
 */
var ArgSpec = /** @class */ (function () {
    function ArgSpec(validator, opt_optional) {
        var self = this;
        this.validator = function (p) {
            if (self.optional && !isJustDef(p)) {
                return;
            }
            validator(p);
        };
        this.optional = !!opt_optional;
    }
    return ArgSpec;
}());
function and_(v1, v2) {
    return function (p) {
        v1(p);
        v2(p);
    };
}
function stringSpec(opt_validator, opt_optional) {
    function stringValidator(p) {
        if (!isString(p)) {
            throw 'Expected string.';
        }
    }
    var validator;
    if (opt_validator) {
        validator = and_(stringValidator, opt_validator);
    }
    else {
        validator = stringValidator;
    }
    return new ArgSpec(validator, opt_optional);
}
function uploadDataSpec() {
    function validator(p) {
        var valid = p instanceof Uint8Array ||
            p instanceof ArrayBuffer ||
            (isNativeBlobDefined() && p instanceof Blob);
        if (!valid) {
            throw 'Expected Blob or File.';
        }
    }
    return new ArgSpec(validator);
}
function metadataSpec(opt_optional) {
    return new ArgSpec(metadataValidator, opt_optional);
}
function nonNegativeNumberSpec() {
    function validator(p) {
        var valid = isNumber(p) && p >= 0;
        if (!valid) {
            throw 'Expected a number 0 or greater.';
        }
    }
    return new ArgSpec(validator);
}
function looseObjectSpec(opt_validator, opt_optional) {
    function validator(p) {
        var isLooseObject = p === null || (isDef(p) && p instanceof Object);
        if (!isLooseObject) {
            throw 'Expected an Object.';
        }
        if (opt_validator !== undefined && opt_validator !== null) {
            opt_validator(p);
        }
    }
    return new ArgSpec(validator, opt_optional);
}
function nullFunctionSpec(opt_optional) {
    function validator(p) {
        var valid = p === null || isFunction(p);
        if (!valid) {
            throw 'Expected a Function.';
        }
    }
    return new ArgSpec(validator, opt_optional);
}

function getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') {
        return BlobBuilder;
    }
    else if (typeof WebKitBlobBuilder !== 'undefined') {
        return WebKitBlobBuilder;
    }
    else {
        return undefined;
    }
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param var_args The values that will make up the resulting blob.
 * @return The blob.
 */
function getBlob() {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var BlobBuilder = getBlobBuilder();
    if (BlobBuilder !== undefined) {
        var bb = new BlobBuilder();
        for (var i = 0; i < var_args.length; i++) {
            bb.append(var_args[i]);
        }
        return bb.getBlob();
    }
    else {
        if (isNativeBlobDefined()) {
            return new Blob(var_args);
        }
        else {
            throw Error("This browser doesn't seem to support creating Blobs");
        }
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */
function sliceBlob(blob, start, end) {
    if (blob.webkitSlice) {
        return blob.webkitSlice(start, end);
    }
    else if (blob.mozSlice) {
        return blob.mozSlice(start, end);
    }
    else if (blob.slice) {
        return blob.slice(start, end);
    }
    return null;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param opt_elideCopy If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 */
var FbsBlob = /** @class */ (function () {
    function FbsBlob(data, opt_elideCopy) {
        var size = 0;
        var blobType = '';
        if (isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        }
        else if (data instanceof ArrayBuffer) {
            if (opt_elideCopy) {
                this.data_ = new Uint8Array(data);
            }
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        }
        else if (data instanceof Uint8Array) {
            if (opt_elideCopy) {
                this.data_ = data;
            }
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    FbsBlob.prototype.size = function () {
        return this.size_;
    };
    FbsBlob.prototype.type = function () {
        return this.type_;
    };
    FbsBlob.prototype.slice = function (startByte, endByte) {
        if (isNativeBlob(this.data_)) {
            var realBlob = this.data_;
            var sliced = sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) {
                return null;
            }
            return new FbsBlob(sliced);
        }
        else {
            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new FbsBlob(slice, true);
        }
    };
    FbsBlob.getBlob = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        if (isNativeBlobDefined()) {
            var blobby = var_args.map(function (val) {
                if (val instanceof FbsBlob) {
                    return val.data_;
                }
                else {
                    return val;
                }
            });
            return new FbsBlob(getBlob.apply(null, blobby));
        }
        else {
            var uint8Arrays = var_args.map(function (val) {
                if (isString(val)) {
                    return dataFromString(StringFormat.RAW, val).data;
                }
                else {
                    // Blobs don't exist, so this has to be a Uint8Array.
                    return val.data_;
                }
            });
            var finalLength_1 = 0;
            uint8Arrays.forEach(function (array) {
                finalLength_1 += array.byteLength;
            });
            var merged_1 = new Uint8Array(finalLength_1);
            var index_1 = 0;
            uint8Arrays.forEach(function (array) {
                for (var i = 0; i < array.length; i++) {
                    merged_1[index_1++] = array[i];
                }
            });
            return new FbsBlob(merged_1, true);
        }
    };
    FbsBlob.prototype.uploadData = function () {
        return this.data_;
    };
    return FbsBlob;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns true if the object is contained in the array (compared with ===).
 * @template T
 */
function contains$1(array, elem) {
    return array.indexOf(elem) !== -1;
}
/**
 * Returns a shallow copy of the array or array-like object (e.g. arguments).
 * @template T
 */
function clone$1(arraylike) {
    return Array.prototype.slice.call(arraylike);
}
/**
 * Removes the given element from the given array, if it is contained.
 * Directly modifies the passed-in array.
 * @template T
 */
function remove(array, elem) {
    var i = array.indexOf(elem);
    if (i !== -1) {
        array.splice(i, 1);
    }
}

var RequestInfo = /** @class */ (function () {
    function RequestInfo(url, method, 
    /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */
    handler, timeout) {
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */
        this.progressCallback = null;
        this.successCodes = [200];
        this.additionalRetryCodes = [];
    }
    return RequestInfo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
 */
function handlerCheck(cndn) {
    if (!cndn) {
        throw unknown();
    }
}
function metadataHandler(authWrapper, mappings) {
    function handler(xhr, text) {
        var metadata = fromResourceString(authWrapper, text, mappings);
        handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function downloadUrlHandler(authWrapper, mappings) {
    function handler(xhr, text) {
        var metadata = fromResourceString(authWrapper, text, mappings);
        handlerCheck(metadata !== null);
        return downloadUrlFromResourceString(metadata, text);
    }
    return handler;
}
function sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        var newErr;
        if (xhr.getStatus() === 401) {
            newErr = unauthenticated();
        }
        else {
            if (xhr.getStatus() === 402) {
                newErr = quotaExceeded(location.bucket);
            }
            else {
                if (xhr.getStatus() === 403) {
                    newErr = unauthorized(location.path);
                }
                else {
                    newErr = err;
                }
            }
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function objectErrorHandler(location) {
    var shared = sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        var newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) {
            newErr = objectNotFound(location.path);
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function getMetadata(authWrapper, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeNormalUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function getDownloadUrl(authWrapper, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeNormalUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, downloadUrlHandler(authWrapper, mappings), timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function updateMetadata(authWrapper, location, metadata, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeNormalUrl(urlPart);
    var method = 'PATCH';
    var body = toResourceString(metadata, mappings);
    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function deleteObject(authWrapper, location) {
    var urlPart = location.fullServerUrl();
    var url = makeNormalUrl(urlPart);
    var method = 'DELETE';
    var timeout = authWrapper.maxOperationRetryTime();
    function handler(xhr, text) { }
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [200, 204];
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function determineContentType_(metadata, blob) {
    return ((metadata && metadata['contentType']) ||
        (blob && blob.type()) ||
        'application/octet-stream');
}
function metadataForUpload_(location, blob, opt_metadata) {
    var metadata = clone(opt_metadata);
    metadata['fullPath'] = location.path;
    metadata['size'] = blob.size();
    if (!metadata['contentType']) {
        metadata['contentType'] = determineContentType_(null, blob);
    }
    return metadata;
}
function multipartUpload(authWrapper, location, mappings, blob, opt_metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        var str = '';
        for (var i = 0; i < 2; i++) {
            str =
                str +
                    Math.random()
                        .toString()
                        .slice(2);
        }
        return str;
    }
    var boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    var metadata = metadataForUpload_(location, blob, opt_metadata);
    var metadataString = toResourceString(metadata, mappings);
    var preBlobPart = '--' +
        boundary +
        '\r\n' +
        'Content-Type: application/json; charset=utf-8\r\n\r\n' +
        metadataString +
        '\r\n--' +
        boundary +
        '\r\n' +
        'Content-Type: ' +
        metadata['contentType'] +
        '\r\n\r\n';
    var postBlobPart = '\r\n--' + boundary + '--';
    var body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) {
        throw cannotSliceBlob();
    }
    var urlParams = { name: metadata['fullPath'] };
    var url = makeUploadUrl(urlPart);
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 * @struct
 */
var ResumableUploadStatus = /** @class */ (function () {
    function ResumableUploadStatus(current, total, finalized, metadata) {
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
    return ResumableUploadStatus;
}());
function checkResumeHeader_(xhr, opt_allowed) {
    var status;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    }
    catch (e) {
        handlerCheck(false);
    }
    var allowed = opt_allowed || ['active'];
    handlerCheck(contains$1(allowed, status));
    return status;
}
function createResumableUpload(authWrapper, location, mappings, blob, opt_metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var metadata = metadataForUpload_(location, blob, opt_metadata);
    var urlParams = { name: metadata['fullPath'] };
    var url = makeUploadUrl(urlPart);
    var method = 'POST';
    var headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': blob.size(),
        'X-Goog-Upload-Header-Content-Type': metadata['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    var body = toResourceString(metadata, mappings);
    var timeout = authWrapper.maxUploadRetryTime();
    function handler(xhr, text) {
        checkResumeHeader_(xhr);
        var url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        }
        catch (e) {
            handlerCheck(false);
        }
        handlerCheck(isString(url));
        return url;
    }
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */
function getResumableUploadStatus(authWrapper, location, url, blob) {
    var headers = { 'X-Goog-Upload-Command': 'query' };
    function handler(xhr, text) {
        var status = checkResumeHeader_(xhr, ['active', 'final']);
        var sizeString;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        }
        catch (e) {
            handlerCheck(false);
        }
        var size = parseInt(sizeString, 10);
        handlerCheck(!isNaN(size));
        return new ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */
var resumableUploadChunkSize = 256 * 1024;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param opt_status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */
function continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, opt_status, opt_progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    var status = new ResumableUploadStatus(0, 0);
    if (opt_status) {
        status.current = opt_status.current;
        status.total = opt_status.total;
    }
    else {
        status.current = 0;
        status.total = blob.size();
    }
    if (blob.size() !== status.total) {
        throw serverFileWrongSize();
    }
    var bytesLeft = status.total - status.current;
    var bytesToUpload = bytesLeft;
    if (chunkSize > 0) {
        bytesToUpload = Math.min(bytesToUpload, chunkSize);
    }
    var startByte = status.current;
    var endByte = startByte + bytesToUpload;
    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
    var headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': status.current
    };
    var body = blob.slice(startByte, endByte);
    if (body === null) {
        throw cannotSliceBlob();
    }
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
        var newCurrent = status.current + bytesToUpload;
        var size = blob.size();
        var metadata;
        if (uploadStatus === 'final') {
            metadata = metadataHandler(authWrapper, mappings)(xhr, text);
        }
        else {
            metadata = null;
        }
        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = opt_progressCallback || null;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var Observer = /** @class */ (function () {
    function Observer(nextOrObserver, opt_error, opt_complete) {
        var asFunctions = isFunction(nextOrObserver) ||
            isDef(opt_error) ||
            isDef(opt_complete);
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = opt_error || null;
            this.complete = opt_complete || null;
        }
        else {
            var observer = nextOrObserver;
            this.next = observer.next || null;
            this.error = observer.error || null;
            this.complete = observer.complete || null;
        }
    }
    return Observer;
}());

var UploadTaskSnapshot = /** @class */ (function () {
    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
        this.bytesTransferred = bytesTransferred;
        this.totalBytes = totalBytes;
        this.state = state;
        this.metadata = metadata;
        this.task = task;
        this.ref = ref;
    }
    return UploadTaskSnapshot;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */
function async(f) {
    return function () {
        var argsToForward = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            argsToForward[_i] = arguments[_i];
        }
        resolve(true).then(function () {
            f.apply(null, argsToForward);
        });
    };
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 */
var UploadTask = /** @class */ (function () {
    /**
     * @param ref The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob The blob to upload.
     */
    function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
        if (metadata === void 0) { metadata = null; }
        var _this = this;
        this.transferred_ = 0;
        this.needToFetchStatus_ = false;
        this.needToFetchMetadata_ = false;
        this.observers_ = [];
        this.error_ = null;
        this.uploadUrl_ = null;
        this.request_ = null;
        this.chunkMultiplier_ = 1;
        this.resolve_ = null;
        this.reject_ = null;
        this.ref_ = ref;
        this.authWrapper_ = authWrapper;
        this.location_ = location;
        this.blob_ = blob;
        this.metadata_ = metadata;
        this.mappings_ = mappings;
        this.resumable_ = this.shouldDoResumable_(this.blob_);
        this.state_ = InternalTaskState.RUNNING;
        this.errorHandler_ = function (error) {
            _this.request_ = null;
            _this.chunkMultiplier_ = 1;
            if (error.codeEquals(Code.CANCELED)) {
                _this.needToFetchStatus_ = true;
                _this.completeTransitions_();
            }
            else {
                _this.error_ = error;
                _this.transition_(InternalTaskState.ERROR);
            }
        };
        this.metadataErrorHandler_ = function (error) {
            _this.request_ = null;
            if (error.codeEquals(Code.CANCELED)) {
                _this.completeTransitions_();
            }
            else {
                _this.error_ = error;
                _this.transition_(InternalTaskState.ERROR);
            }
        };
        this.promise_ = make(function (resolve$$1, reject$$1) {
            _this.resolve_ = resolve$$1;
            _this.reject_ = reject$$1;
            _this.start_();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this.promise_.then(null, function () { });
    }
    UploadTask.prototype.makeProgressCallback_ = function () {
        var _this = this;
        var sizeBefore = this.transferred_;
        return function (loaded, total) {
            _this.updateProgress_(sizeBefore + loaded);
        };
    };
    UploadTask.prototype.shouldDoResumable_ = function (blob) {
        return blob.size() > 256 * 1024;
    };
    UploadTask.prototype.start_ = function () {
        if (this.state_ !== InternalTaskState.RUNNING) {
            // This can happen if someone pauses us in a resume callback, for example.
            return;
        }
        if (this.request_ !== null) {
            return;
        }
        if (this.resumable_) {
            if (this.uploadUrl_ === null) {
                this.createResumable_();
            }
            else {
                if (this.needToFetchStatus_) {
                    this.fetchStatus_();
                }
                else {
                    if (this.needToFetchMetadata_) {
                        // Happens if we miss the metadata on upload completion.
                        this.fetchMetadata_();
                    }
                    else {
                        this.continueUpload_();
                    }
                }
            }
        }
        else {
            this.oneShotUpload_();
        }
    };
    UploadTask.prototype.resolveToken_ = function (callback) {
        var _this = this;
        this.authWrapper_.getAuthToken().then(function (authToken) {
            switch (_this.state_) {
                case InternalTaskState.RUNNING:
                    callback(authToken);
                    break;
                case InternalTaskState.CANCELING:
                    _this.transition_(InternalTaskState.CANCELED);
                    break;
                case InternalTaskState.PAUSING:
                    _this.transition_(InternalTaskState.PAUSED);
                    break;
                default:
            }
        });
    };
    // TODO(andysoto): assert false
    UploadTask.prototype.createResumable_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = createRequest;
            createRequest.getPromise().then(function (url) {
                _this.request_ = null;
                _this.uploadUrl_ = url;
                _this.needToFetchStatus_ = false;
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.fetchStatus_ = function () {
        var _this = this;
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo = getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = statusRequest;
            statusRequest.getPromise().then(function (status) {
                status = status;
                _this.request_ = null;
                _this.updateProgress_(status.current);
                _this.needToFetchStatus_ = false;
                if (status.finalized) {
                    _this.needToFetchMetadata_ = true;
                }
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.continueUpload_ = function () {
        var _this = this;
        var chunkSize = resumableUploadChunkSize * this.chunkMultiplier_;
        var status = new ResumableUploadStatus(this.transferred_, this.blob_.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo;
            try {
                requestInfo = continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
            }
            catch (e) {
                _this.error_ = e;
                _this.transition_(InternalTaskState.ERROR);
                return;
            }
            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = uploadRequest;
            uploadRequest
                .getPromise()
                .then(function (newStatus) {
                _this.increaseMultiplier_();
                _this.request_ = null;
                _this.updateProgress_(newStatus.current);
                if (newStatus.finalized) {
                    _this.metadata_ = newStatus.metadata;
                    _this.transition_(InternalTaskState.SUCCESS);
                }
                else {
                    _this.completeTransitions_();
                }
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.increaseMultiplier_ = function () {
        var currentSize = resumableUploadChunkSize * this.chunkMultiplier_;
        // Max chunk size is 32M.
        if (currentSize < 32 * 1024 * 1024) {
            this.chunkMultiplier_ *= 2;
        }
    };
    UploadTask.prototype.fetchMetadata_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = metadataRequest;
            metadataRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.transition_(InternalTaskState.SUCCESS);
            }, _this.metadataErrorHandler_);
        });
    };
    UploadTask.prototype.oneShotUpload_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = multipartRequest;
            multipartRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.updateProgress_(_this.blob_.size());
                _this.transition_(InternalTaskState.SUCCESS);
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.updateProgress_ = function (transferred) {
        var old = this.transferred_;
        this.transferred_ = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this.transferred_ !== old) {
            this.notifyObservers_();
        }
    };
    UploadTask.prototype.transition_ = function (state) {
        if (this.state_ === state) {
            return;
        }
        switch (state) {
            case InternalTaskState.CANCELING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case InternalTaskState.PAUSING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case InternalTaskState.RUNNING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                var wasPaused = this.state_ === InternalTaskState.PAUSED;
                this.state_ = state;
                if (wasPaused) {
                    this.notifyObservers_();
                    this.start_();
                }
                break;
            case InternalTaskState.PAUSED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.CANCELED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.error_ = canceled();
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.ERROR:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.SUCCESS:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
        }
    };
    UploadTask.prototype.completeTransitions_ = function () {
        switch (this.state_) {
            case InternalTaskState.PAUSING:
                this.transition_(InternalTaskState.PAUSED);
                break;
            case InternalTaskState.CANCELING:
                this.transition_(InternalTaskState.CANCELED);
                break;
            case InternalTaskState.RUNNING:
                this.start_();
                break;
            default:
                // TODO(andysoto): assert(false);
                break;
        }
    };
    Object.defineProperty(UploadTask.prototype, "snapshot", {
        get: function () {
            var externalState = taskStateFromInternalTaskState(this.state_);
            return new UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds a callback for an event.
     * @param type The type of event to listen for.
     */
    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
        if (nextOrObserver === void 0) { nextOrObserver = undefined; }
        if (error === void 0) { error = undefined; }
        if (completed === void 0) { completed = undefined; }
        function typeValidator(_p) {
            if (type !== TaskEvent.STATE_CHANGED) {
                throw "Expected one of the event types: [" + TaskEvent.STATE_CHANGED + "].";
            }
        }
        var nextOrObserverMessage = 'Expected a function or an Object with one of ' +
            '`next`, `error`, `complete` properties.';
        var nextValidator = nullFunctionSpec(true).validator;
        var observerValidator = looseObjectSpec(null, true).validator;
        function nextOrObserverValidator(p) {
            try {
                nextValidator(p);
                return;
            }
            catch (e) { }
            try {
                observerValidator(p);
                var anyDefined = isJustDef(p['next']) ||
                    isJustDef(p['error']) ||
                    isJustDef(p['complete']);
                if (!anyDefined) {
                    throw '';
                }
                return;
            }
            catch (e) {
                throw nextOrObserverMessage;
            }
        }
        var specs = [
            stringSpec(typeValidator),
            looseObjectSpec(nextOrObserverValidator, true),
            nullFunctionSpec(true),
            nullFunctionSpec(true)
        ];
        validate('on', specs, arguments);
        var self = this;
        function makeBinder(specs) {
            function binder(nextOrObserver, error, opt_complete) {
                if (specs !== null) {
                    validate('on', specs, arguments);
                }
                var observer = new Observer(nextOrObserver, error, completed);
                self.addObserver_(observer);
                return function () {
                    self.removeObserver_(observer);
                };
            }
            return binder;
        }
        function binderNextOrObserverValidator(p) {
            if (p === null) {
                throw nextOrObserverMessage;
            }
            nextOrObserverValidator(p);
        }
        var binderSpecs = [
            looseObjectSpec(binderNextOrObserverValidator),
            nullFunctionSpec(true),
            nullFunctionSpec(true)
        ];
        var typeOnly = !(isJustDef(nextOrObserver) ||
            isJustDef(error) ||
            isJustDef(completed));
        if (typeOnly) {
            return makeBinder(binderSpecs);
        }
        else {
            return makeBinder(null)(nextOrObserver, error, completed);
        }
    };
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
     * @param onRejected The rejection callback.
     */
    UploadTask.prototype.then = function (onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this.promise_.then(onFulfilled, onRejected);
    };
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */
    UploadTask.prototype.catch = function (onRejected) {
        return this.then(null, onRejected);
    };
    /**
     * Adds the given observer.
     */
    UploadTask.prototype.addObserver_ = function (observer) {
        this.observers_.push(observer);
        this.notifyObserver_(observer);
    };
    /**
     * Removes the given observer.
     */
    UploadTask.prototype.removeObserver_ = function (observer) {
        remove(this.observers_, observer);
    };
    UploadTask.prototype.notifyObservers_ = function () {
        var _this = this;
        this.finishPromise_();
        var observers = clone$1(this.observers_);
        observers.forEach(function (observer) {
            _this.notifyObserver_(observer);
        });
    };
    UploadTask.prototype.finishPromise_ = function () {
        if (this.resolve_ !== null) {
            var triggered = true;
            switch (taskStateFromInternalTaskState(this.state_)) {
                case TaskState.SUCCESS:
                    async(this.resolve_.bind(null, this.snapshot))();
                    break;
                case TaskState.CANCELED:
                case TaskState.ERROR:
                    var toCall = this.reject_;
                    async(toCall.bind(null, this.error_))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this.resolve_ = null;
                this.reject_ = null;
            }
        }
    };
    UploadTask.prototype.notifyObserver_ = function (observer) {
        var externalState = taskStateFromInternalTaskState(this.state_);
        switch (externalState) {
            case TaskState.RUNNING:
            case TaskState.PAUSED:
                if (observer.next !== null) {
                    async(observer.next.bind(observer, this.snapshot))();
                }
                break;
            case TaskState.SUCCESS:
                if (observer.complete !== null) {
                    async(observer.complete.bind(observer))();
                }
                break;
            case TaskState.CANCELED:
            case TaskState.ERROR:
                if (observer.error !== null) {
                    async(observer.error.bind(observer, this.error_))();
                }
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error !== null) {
                    async(observer.error.bind(observer, this.error_))();
                }
        }
    };
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.resume = function () {
        validate('resume', [], arguments);
        var valid = this.state_ === InternalTaskState.PAUSED ||
            this.state_ === InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(InternalTaskState.RUNNING);
        }
        return valid;
    };
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.pause = function () {
        validate('pause', [], arguments);
        var valid = this.state_ === InternalTaskState.RUNNING;
        if (valid) {
            this.transition_(InternalTaskState.PAUSING);
        }
        return valid;
    };
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.cancel = function () {
        validate('cancel', [], arguments);
        var valid = this.state_ === InternalTaskState.RUNNING ||
            this.state_ === InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(InternalTaskState.CANCELING);
        }
        return valid;
    };
    return UploadTask;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @param location An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */
var Reference = /** @class */ (function () {
    function Reference(authWrapper, location) {
        this.authWrapper = authWrapper;
        if (location instanceof Location) {
            this.location = location;
        }
        else {
            this.location = Location.makeFromUrl(location);
        }
    }
    /**
     * @return The URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */
    Reference.prototype.toString = function () {
        validate('toString', [], arguments);
        return 'gs://' + this.location.bucket + '/' + this.location.path;
    };
    Reference.prototype.newRef = function (authWrapper, location) {
        return new Reference(authWrapper, location);
    };
    Reference.prototype.mappings = function () {
        return getMappings();
    };
    /**
     * @return A reference to the object obtained by
     *     appending childPath, removing any duplicate, beginning, or trailing
     *     slashes.
     */
    Reference.prototype.child = function (childPath) {
        validate('child', [stringSpec()], arguments);
        var newPath = child(this.location.path, childPath);
        var location = new Location(this.location.bucket, newPath);
        return this.newRef(this.authWrapper, location);
    };
    Object.defineProperty(Reference.prototype, "parent", {
        /**
         * @return A reference to the parent of the
         *     current object, or null if the current object is the root.
         */
        get: function () {
            var newPath = parent(this.location.path);
            if (newPath === null) {
                return null;
            }
            var location = new Location(this.location.bucket, newPath);
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        /**
         * @return An reference to the root of this
         *     object's bucket.
         */
        get: function () {
            var location = new Location(this.location.bucket, '');
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "bucket", {
        get: function () {
            return this.location.bucket;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "fullPath", {
        get: function () {
            return this.location.path;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "name", {
        get: function () {
            return lastComponent(this.location.path);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "storage", {
        get: function () {
            return this.authWrapper.service();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Uploads a blob to this object's location.
     * @param data The blob to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.put = function (data, metadata) {
        if (metadata === void 0) { metadata = null; }
        validate('put', [uploadDataSpec(), metadataSpec(true)], arguments);
        this.throwIfRoot_('put');
        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data), metadata);
    };
    /**
     * Uploads a string to this object's location.
     * @param string The string to upload.
     * @param opt_format The format of the string to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.putString = function (string, format, opt_metadata) {
        if (format === void 0) { format = StringFormat.RAW; }
        validate('putString', [
            stringSpec(),
            stringSpec(formatValidator, true),
            metadataSpec(true)
        ], arguments);
        this.throwIfRoot_('putString');
        var data = dataFromString(format, string);
        var metadata = clone(opt_metadata);
        if (!isDef(metadata['contentType']) && isDef(data.contentType)) {
            metadata['contentType'] = data.contentType;
        }
        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data.data, true), metadata);
    };
    /**
     * Deletes the object at this location.
     * @return A promise that resolves if the deletion succeeds.
     */
    Reference.prototype.delete = function () {
        validate('delete', [], arguments);
        this.throwIfRoot_('delete');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = deleteObject(self.authWrapper, self.location);
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     *     A promise that resolves with the metadata for this object. If this
     *     object doesn't exist or metadata cannot be retreived, the promise is
     *     rejected.
     */
    Reference.prototype.getMetadata = function () {
        validate('getMetadata', [], arguments);
        this.throwIfRoot_('getMetadata');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = getMetadata(self.authWrapper, self.location, self.mappings());
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * Updates the metadata for this object.
     * @param metadata The new metadata for the object.
     *     Only values that have been explicitly set will be changed. Explicitly
     *     setting a value to null will remove the metadata.
     * @return A promise that resolves
     *     with the new metadata for this object.
     *     @see firebaseStorage.Reference.prototype.getMetadata
     */
    Reference.prototype.updateMetadata = function (metadata) {
        validate('updateMetadata', [metadataSpec()], arguments);
        this.throwIfRoot_('updateMetadata');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = updateMetadata(self.authWrapper, self.location, metadata, self.mappings());
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * @return A promise that resolves with the download
     *     URL for this object.
     */
    Reference.prototype.getDownloadURL = function () {
        validate('getDownloadURL', [], arguments);
        this.throwIfRoot_('getDownloadURL');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = getDownloadUrl(self.authWrapper, self.location, self.mappings());
            return self.authWrapper
                .makeRequest(requestInfo, authToken)
                .getPromise()
                .then(function (url) {
                if (url === null) {
                    throw noDownloadURL();
                }
                return url;
            });
        });
    };
    Reference.prototype.throwIfRoot_ = function (name) {
        if (this.location.path === '') {
            throw invalidRootOperation(name);
        }
    };
    return Reference;
}());

/**
 * A request whose promise always fails.
 * @struct
 * @template T
 */
var FailRequest = /** @class */ (function () {
    function FailRequest(error) {
        this.promise_ = reject(error);
    }
    /** @inheritDoc */
    FailRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    FailRequest.prototype.cancel = function (appDelete) {
        if (appDelete === void 0) { appDelete = false; }
    };
    return FailRequest;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var RequestMap = /** @class */ (function () {
    function RequestMap() {
        this.map_ = {};
        this.id_ = minSafeInteger;
    }
    /**
     * Registers the given request with this map.
     * The request is unregistered when it completes.
     * @param r The request to register.
     */
    RequestMap.prototype.addRequest = function (r) {
        var id = this.id_;
        this.id_++;
        this.map_[id] = r;
        var self = this;
        function unmap() {
            delete self.map_[id];
        }
        r.getPromise().then(unmap, unmap);
    };
    /**
     * Cancels all registered requests.
     */
    RequestMap.prototype.clear = function () {
        forEach(this.map_, function (key, val) {
            if (val) {
                val.cancel(true);
            }
        });
        this.map_ = {};
    };
    return RequestMap;
}());

/**
 * @param app If null, getAuthToken always resolves with null.
 * @param service The storage service associated with this auth wrapper.
 *     Untyped to avoid circular type dependencies.
 * @struct
 */
var AuthWrapper = /** @class */ (function () {
    function AuthWrapper(app, maker, requestMaker, service, pool) {
        this.bucket_ = null;
        this.deleted_ = false;
        this.app_ = app;
        if (this.app_ !== null) {
            var options = this.app_.options;
            if (isDef(options)) {
                this.bucket_ = AuthWrapper.extractBucket_(options);
            }
        }
        this.storageRefMaker_ = maker;
        this.requestMaker_ = requestMaker;
        this.pool_ = pool;
        this.service_ = service;
        this.maxOperationRetryTime_ = defaultMaxOperationRetryTime;
        this.maxUploadRetryTime_ = defaultMaxUploadRetryTime;
        this.requestMap_ = new RequestMap();
    }
    AuthWrapper.extractBucket_ = function (config) {
        var bucketString = config[configOption] || null;
        if (bucketString == null) {
            return null;
        }
        var loc = Location.makeFromBucketSpec(bucketString);
        return loc.bucket;
    };
    AuthWrapper.prototype.getAuthToken = function () {
        // TODO(andysoto): remove ifDef checks after firebase-app implements stubs
        // (b/28673818).
        if (this.app_ !== null &&
            isDef(this.app_.INTERNAL) &&
            isDef(this.app_.INTERNAL.getToken)) {
            return this.app_.INTERNAL.getToken().then(function (response) {
                if (response !== null) {
                    return response.accessToken;
                }
                else {
                    return null;
                }
            }, function (_error) {
                return null;
            });
        }
        else {
            return resolve(null);
        }
    };
    AuthWrapper.prototype.bucket = function () {
        if (this.deleted_) {
            throw appDeleted();
        }
        else {
            return this.bucket_;
        }
    };
    /**
     * The service associated with this auth wrapper. Untyped to avoid circular
     * type dependencies.
     */
    AuthWrapper.prototype.service = function () {
        return this.service_;
    };
    /**
     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
     * at the given Location.
     * @param loc The Location.
     * @return Actually a firebaseStorage.Reference, typing not allowed
     *     because of circular dependency problems.
     */
    AuthWrapper.prototype.makeStorageReference = function (loc) {
        return this.storageRefMaker_(this, loc);
    };
    AuthWrapper.prototype.makeRequest = function (requestInfo, authToken) {
        if (!this.deleted_) {
            var request = this.requestMaker_(requestInfo, authToken, this.pool_);
            this.requestMap_.addRequest(request);
            return request;
        }
        else {
            return new FailRequest(appDeleted());
        }
    };
    /**
     * Stop running requests and prevent more from being created.
     */
    AuthWrapper.prototype.deleteApp = function () {
        this.deleted_ = true;
        this.app_ = null;
        this.requestMap_.clear();
    };
    AuthWrapper.prototype.maxUploadRetryTime = function () {
        return this.maxUploadRetryTime_;
    };
    AuthWrapper.prototype.setMaxUploadRetryTime = function (time) {
        this.maxUploadRetryTime_ = time;
    };
    AuthWrapper.prototype.maxOperationRetryTime = function () {
        return this.maxOperationRetryTime_;
    };
    AuthWrapper.prototype.setMaxOperationRetryTime = function (time) {
        this.maxOperationRetryTime_ = time;
    };
    return AuthWrapper;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param f May be invoked
 *     before the function returns.
 * @param callback Get all the arguments passed to the function
 *     passed to f, including the initial boolean.
 */
function start(f, callback, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    var waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    var timeoutId = null;
    var hitTimeout = false;
    var cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    var triggeredCallback = false;
    function triggerCallback() {
        if (!triggeredCallback) {
            triggeredCallback = true;
            callback.apply(null, arguments);
        }
    }
    function callWithDelay(millis) {
        timeoutId = setTimeout(function () {
            timeoutId = null;
            f(handler, canceled());
        }, millis);
    }
    function handler(success) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (triggeredCallback) {
            return;
        }
        if (success) {
            triggerCallback.apply(null, arguments);
            return;
        }
        var mustStop = canceled() || hitTimeout;
        if (mustStop) {
            triggerCallback.apply(null, arguments);
            return;
        }
        if (waitSeconds < 64) {
            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
            waitSeconds *= 2;
        }
        var waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        }
        else {
            waitMillis = (waitSeconds + Math.random()) * 1000;
        }
        callWithDelay(waitMillis);
    }
    var stopped = false;
    function stop(wasTimeout) {
        if (stopped) {
            return;
        }
        stopped = true;
        if (triggeredCallback) {
            return;
        }
        if (timeoutId !== null) {
            if (!wasTimeout) {
                cancelState = 2;
            }
            clearTimeout(timeoutId);
            callWithDelay(0);
        }
        else {
            if (!wasTimeout) {
                cancelState = 1;
            }
        }
    }
    callWithDelay(0);
    setTimeout(function () {
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */
function stop(id) {
    id(false);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 * @template T
 */
var NetworkRequest = /** @class */ (function () {
    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
        this.pendingXhr_ = null;
        this.backoffId_ = null;
        this.resolve_ = null;
        this.reject_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.url_ = url;
        this.method_ = method;
        this.headers_ = headers;
        this.body_ = body;
        this.successCodes_ = successCodes.slice();
        this.additionalRetryCodes_ = additionalRetryCodes.slice();
        this.callback_ = callback;
        this.errorCallback_ = errorCallback;
        this.progressCallback_ = progressCallback;
        this.timeout_ = timeout;
        this.pool_ = pool;
        var self = this;
        this.promise_ = make(function (resolve$$1, reject$$1) {
            self.resolve_ = resolve$$1;
            self.reject_ = reject$$1;
            self.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */
    NetworkRequest.prototype.start_ = function () {
        var self = this;
        function doTheRequest(backoffCallback, canceled$$1) {
            if (canceled$$1) {
                backoffCallback(false, new RequestEndStatus(false, null, true));
                return;
            }
            var xhr = self.pool_.createXhrIo();
            self.pendingXhr_ = xhr;
            function progressListener(progressEvent) {
                var loaded = progressEvent.loaded;
                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (self.progressCallback_ !== null) {
                    self.progressCallback_(loaded, total);
                }
            }
            if (self.progressCallback_ !== null) {
                xhr.addUploadProgressListener(progressListener);
            }
            xhr
                .send(self.url_, self.method_, self.body_, self.headers_)
                .then(function (xhr) {
                if (self.progressCallback_ !== null) {
                    xhr.removeUploadProgressListener(progressListener);
                }
                self.pendingXhr_ = null;
                xhr = xhr;
                var hitServer = xhr.getErrorCode() === ErrorCode.NO_ERROR;
                var status = xhr.getStatus();
                if (!hitServer || self.isRetryStatusCode_(status)) {
                    var wasCanceled = xhr.getErrorCode() === ErrorCode.ABORT;
                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                var successCode = contains$1(self.successCodes_, status);
                backoffCallback(true, new RequestEndStatus(successCode, xhr));
            });
        }
        /**
         * @param requestWentThrough True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */
        function backoffDone(requestWentThrough, status) {
            var resolve$$1 = self.resolve_;
            var reject$$1 = self.reject_;
            var xhr = status.xhr;
            if (status.wasSuccessCode) {
                try {
                    var result = self.callback_(xhr, xhr.getResponseText());
                    if (isJustDef(result)) {
                        resolve$$1(result);
                    }
                    else {
                        resolve$$1();
                    }
                }
                catch (e) {
                    reject$$1(e);
                }
            }
            else {
                if (xhr !== null) {
                    var err = unknown();
                    err.setServerResponseProp(xhr.getResponseText());
                    if (self.errorCallback_) {
                        reject$$1(self.errorCallback_(xhr, err));
                    }
                    else {
                        reject$$1(err);
                    }
                }
                else {
                    if (status.canceled) {
                        var err = self.appDelete_
                            ? appDeleted()
                            : canceled();
                        reject$$1(err);
                    }
                    else {
                        var err = retryLimitExceeded();
                        reject$$1(err);
                    }
                }
            }
        }
        if (this.canceled_) {
            backoffDone(false, new RequestEndStatus(false, null, true));
        }
        else {
            this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
        }
    };
    /** @inheritDoc */
    NetworkRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    NetworkRequest.prototype.cancel = function (appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) {
            stop(this.backoffId_);
        }
        if (this.pendingXhr_ !== null) {
            this.pendingXhr_.abort();
        }
    };
    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
        // The codes for which to retry came from this page:
        // https://cloud.google.com/storage/docs/exponential-backoff
        var isFiveHundredCode = status >= 500 && status < 600;
        var extraRetryCodes = [
            // Request Timeout: web server didn't receive full request in time.
            408,
            // Too Many Requests: you're getting rate-limited, basically.
            429
        ];
        var isExtraRetryCode = contains$1(extraRetryCodes, status);
        var isRequestSpecificRetryCode = contains$1(this.additionalRetryCodes_, status);
        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
    };
    return NetworkRequest;
}());
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled Defaults to false.
 * @struct
 */
var RequestEndStatus = /** @class */ (function () {
    function RequestEndStatus(wasSuccessCode, xhr, opt_canceled) {
        this.wasSuccessCode = wasSuccessCode;
        this.xhr = xhr;
        this.canceled = !!opt_canceled;
    }
    return RequestEndStatus;
}());
function addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) {
        headers['Authorization'] = 'Firebase ' + authToken;
    }
}
function addVersionHeader_(headers) {
    var number = typeof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION : 'AppManager';
    headers['X-Firebase-Storage-Version'] = 'webjs/' + number;
}
/**
 * @template T
 */
function makeRequest(requestInfo, authToken, pool) {
    var queryPart = makeQueryString(requestInfo.urlParams);
    var url = requestInfo.url + queryPart;
    var headers = clone(requestInfo.headers);
    addAuthHeader_(headers, authToken);
    addVersionHeader_(headers);
    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A service that provides firebaseStorage.Reference instances.
 * @param opt_url gs:// url to a custom Storage Bucket
 *
 * @struct
 */
var Service = /** @class */ (function () {
    function Service(app, pool, url) {
        this.bucket_ = null;
        function maker(authWrapper, loc) {
            return new Reference(authWrapper, loc);
        }
        this.authWrapper_ = new AuthWrapper(app, maker, makeRequest, this, pool);
        this.app_ = app;
        if (url != null) {
            this.bucket_ = Location.makeFromBucketSpec(url);
        }
        else {
            var authWrapperBucket = this.authWrapper_.bucket();
            if (authWrapperBucket != null) {
                this.bucket_ = new Location(authWrapperBucket, '');
            }
        }
        this.internals_ = new ServiceInternals(this);
    }
    /**
     * Returns a firebaseStorage.Reference for the given path in the default
     * bucket.
     */
    Service.prototype.ref = function (path) {
        function validator(path) {
            if (/^[A-Za-z]+:\/\//.test(path)) {
                throw 'Expected child path but got a URL, use refFromURL instead.';
            }
        }
        validate('ref', [stringSpec(validator, true)], arguments);
        if (this.bucket_ == null) {
            throw new Error('No Storage Bucket defined in Firebase Options.');
        }
        var ref = new Reference(this.authWrapper_, this.bucket_);
        if (path != null) {
            return ref.child(path);
        }
        else {
            return ref;
        }
    };
    /**
     * Returns a firebaseStorage.Reference object for the given absolute URL,
     * which must be a gs:// or http[s]:// URL.
     */
    Service.prototype.refFromURL = function (url) {
        function validator(p) {
            if (!/^[A-Za-z]+:\/\//.test(p)) {
                throw 'Expected full URL but got a child path, use ref instead.';
            }
            try {
                Location.makeFromUrl(p);
            }
            catch (e) {
                throw 'Expected valid full URL but got an invalid one.';
            }
        }
        validate('refFromURL', [stringSpec(validator, false)], arguments);
        return new Reference(this.authWrapper_, url);
    };
    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
        get: function () {
            return this.authWrapper_.maxUploadRetryTime();
        },
        enumerable: true,
        configurable: true
    });
    Service.prototype.setMaxUploadRetryTime = function (time) {
        validate('setMaxUploadRetryTime', [nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxUploadRetryTime(time);
    };
    Object.defineProperty(Service.prototype, "maxOperationRetryTime", {
        get: function () {
            return this.authWrapper_.maxOperationRetryTime();
        },
        enumerable: true,
        configurable: true
    });
    Service.prototype.setMaxOperationRetryTime = function (time) {
        validate('setMaxOperationRetryTime', [nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxOperationRetryTime(time);
    };
    Object.defineProperty(Service.prototype, "app", {
        get: function () {
            return this.app_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Service.prototype, "INTERNAL", {
        get: function () {
            return this.internals_;
        },
        enumerable: true,
        configurable: true
    });
    return Service;
}());
/**
 * @struct
 */
var ServiceInternals = /** @class */ (function () {
    function ServiceInternals(service) {
        this.service_ = service;
    }
    /**
     * Called when the associated app is deleted.
     * @see {!fbs.AuthWrapper.prototype.deleteApp}
     */
    ServiceInternals.prototype.delete = function () {
        this.service_.authWrapper_.deleteApp();
        return resolve(undefined);
    };
    return ServiceInternals;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Storage.
 */
var STORAGE_TYPE = 'storage';
function factory(app, unused, opt_url) {
    return new Service(app, new XhrIoPool(), opt_url);
}
function registerStorage(instance) {
    var namespaceExports = {
        // no-inline
        TaskState: TaskState,
        TaskEvent: TaskEvent,
        StringFormat: StringFormat,
        Storage: Service,
        Reference: Reference
    };
    instance.INTERNAL.registerService(STORAGE_TYPE, factory, namespaceExports, undefined, 
    // Allow multiple storage instances per app.
    true);
}
registerStorage(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a);




/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {

    totalCasos: function totalCasos(state) {
        return state.st_casos.length;
    },
    posClick: function posClick(state, valor) {

        // console.log("[getters]-posClic, state ",state);
        // console.log("[getters]-posClic, state.getters ",state.getters);
        // console.log("[getters]-posClic, state.getters ",state.getters.posClick);
        console.log("[getters]-posClic, payload ", valor);

        var ldiv = valor / 2;
        var ldiv2 = Math.trunc(ldiv);
        console.log(ldiv, ldiv2);
        var resultado = "impar";
        if (ldiv === ldiv2) {
            resultado = "par";
        }
        console.log("[getters]-posClic, resultado ", resultado);
        return resultado;
    }
};

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(2);


var mutations = {
    ifpin: function ifpin(state, payload) {

        state.lini = payload.a;
        state.lfin = payload.b;
        state.pagina = payload.c;
        state.esLimiteInf = payload.e;
        state.esLimiteSup = payload.f;
    },
    ifpout: function ifpout(state, payload) {

        if (payload.d === "D") {

            state.Dlini = payload.a;state.Dlfin = payload.b;state.Dpagina = payload.c;
            state.DesLimiteInf = payload.e;state.DesLimiteSup = payload.f;
        } else {
            if (payload.d === "M") {
                state.Mlini = payload.a;state.Mlfin = payload.b;state.Mpagina = payload.c;
                state.MesLimiteInf = payload.e;state.MesLimiteSup = payload.f;
            } else {
                if (payload.d === "C") {
                    state.Clini = payload.a;state.Clfin = payload.b;state.Cpagina = payload.c;
                    state.CesLimiteInf = payload.e;state.CesLimiteSup = payload.f;
                } else {
                    if (payload.d === "DAS") {
                        state.DASlini = payload.a;state.DASlfin = payload.b;state.DASpagina = payload.c;
                        state.DASesLimiteInf = payload.e;state.DASesLimiteSup = payload.f;
                    } else {
                        if (payload.d === "DMS") {
                            state.DMSlini = payload.a;state.DMSlfin = payload.b;state.DMSpagina = payload.c;
                            state.DMSesLimiteInf = payload.e;state.DMSesLimiteSup = payload.f;
                        } else {
                            if (payload.d === "TS") {
                                state.TSlini = payload.a;state.TSlfin = payload.b;state.TSpagina = payload.c;
                                state.TSesLimiteInf = payload.e;state.TSesLimiteSup = payload.f;
                            } // if (SS)
                            else {
                                    if (payload.d === "SS") {
                                        state.SSlini = payload.a;state.SSlfin = payload.b;state.SSpagina = payload.c;
                                        state.SSesLimiteInf = payload.e;state.SSesLimiteSup = payload.f;
                                    } // if (SS)
                                    else {
                                            if (payload.d === "CG") {
                                                state.CGlini = payload.a;state.CGlfin = payload.b;state.CGpagina = payload.c;
                                                state.CGesLimiteInf = payload.e;state.CGesLimiteSup = payload.f;
                                            } // if (CG)
                                            else {
                                                    if (payload.d === "R") {
                                                        state.Rlini = payload.a;state.Rlfin = payload.b;state.Rpagina = payload.c;
                                                        state.ResLimiteInf = payload.e;state.ResLimiteSup = payload.f;
                                                    } // if (SS)                                                                                            
                                                }
                                        } // if (SS)
                                } // if(TS)
                        } // if (DMS)
                    } // if (DAS)
                } // IF (C)
            } // if (M)
        } // if (D)                   
    },
    // ifpout()
    alInicio: function alInicio(state, payload) {

        // console.log("[store.js]-alInicio, lista ? ",payload.lista);
        // console.log("[store.js]-alInicio, fuente ? ",payload.fuente);

        state.limite = payload.lista.length;

        /* Al entrar (in) actualiza los valores de los limites inferior y superios (if) y el de la página (p) de acuero a los valores que
           traen sus contadores correspondientes */
        if (payload.fuente === "D") {
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("ifpin", { a: state.Dlini, b: state.Dlfin, c: state.Dpagina,
                e: state.DesLimiteInf, f: state.DesLimiteSup });
        } else {
            if (payload.fuente === "M") {
                __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("ifpin", { a: state.Mlini, b: state.Mlfin, c: state.Mpagina,
                    e: state.MesLimiteInf, f: state.MesLimiteSup });
            } else {
                if (payload.fuente === "C") {
                    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("ifpin", { a: state.Clini, b: state.Clfin, c: state.Cpagina,
                        e: state.CesLimiteInf, f: state.CesLimiteSup });
                } // if(C)
                else {
                        if (payload.fuente === "DAS") {
                            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("ifpin", { a: state.DASlini, b: state.DASlfin, c: state.DASpagina,
                                e: state.DASesLimiteInf, f: state.DASesLimiteSup });
                        } //if (DAS)
                        else {
                                if (payload.fuente === "DMS") {
                                    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("ifpin", { a: state.DMSlini, b: state.DMSlfin, c: state.DMSpagina,
                                        e: state.DMSesLimiteInf, f: state.DMSesLimiteSup });
                                } //if (DMS)
                                else {
                                        if (payload.fuente === "TS") {
                                            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("ifpin", { a: state.TSlini, b: state.TSlfin, c: state.TSpagina,
                                                e: state.TSesLimiteInf, f: state.TSesLimiteSup });
                                        } //if (TS)
                                        else {
                                                if (payload.fuente === "SS") {
                                                    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("ifpin", { a: state.SSlini, b: state.SSlfin, c: state.SSpagina,
                                                        e: state.SSesLimiteInf, f: state.SSesLimiteSup });
                                                } else {
                                                    if (payload.fuente === "CG") {
                                                        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("ifpin", { a: state.CGlini, b: state.CGlfin, c: state.CGpagina,
                                                            e: state.CGesLimiteInf, f: state.CGesLimiteSup });
                                                    } // if (CG)
                                                    else {
                                                            if (payload.fuente === "R") {
                                                                __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("ifpin", { a: state.Rlini, b: state.Rlfin, c: state.Rpagina,
                                                                    e: state.ResLimiteInf, f: state.ResLimiteSup });
                                                            } // if (R)
                                                        } // if (CG)
                                                } // if (SS)
                                            } // if (TS)
                                    } // if (DMS)
                            } // if (DAS)
                    } // if (C)
            } // if (M)
        } // if (D)
    },
    // alInicio()
    anterior: function anterior(state, payload) {

        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("alInicio", payload);

        /* Si no ha llegado al limite inferior, entonces ... (!state.esLimiteInf) */
        if (!state.esLimiteInf) {

            // indicador de llegada al limite superior es falso, porque no está ahí, está en el límite inferior.
            state.esLimiteSup = false;

            /* Actualiza el límite inferior y superior */
            state.lini = state.lini - state.diferencia;
            state.lfin = state.lfin - state.diferencia;

            /** Si el límite inferior es menor que el primer registro (0), entonces */
            if (state.lini < 0) {
                state.lini = 0;
            }

            /** Si el límite inferior es exáctamente el primer registro (0), entonces */
            if (state.lini === 0) {
                state.esLimiteInf = true;
            }

            /** Decrementa el conteo de la página */
            state.pagina = state.pagina - 1;

            /* Antes de salir (out) actualiza los valores de los limites inferior y superios (if) y el de la página (p) */
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("ifpout", { a: state.lini, b: state.lfin, c: state.pagina,
                d: payload.fuente,
                e: state.esLimiteInf, f: state.esLimiteSup });
        } // If             
    },
    // anterior()
    siguiente: function siguiente(state, payload) {

        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("alInicio", payload);

        /* Si no ha llegado al límite superior, entonces ... (!state.esLimiteSup) */
        if (!state.esLimiteSup) {

            // El indicador de llegar al limite inferior es falso, porque no está ahí, está en el límite superior.
            state.esLimiteInf = false;

            /* Actualiza el límite inferior y superior */
            state.lini = state.lini + state.diferencia;
            state.lfin = state.lfin + state.diferencia;

            /** Puede ocurrir que en la última vista (bloque), la totalidad de registros que se visualizan es menor a la cantidad que deben visualizarse. 
             *  por ejemplo: la cantidad que debe visualizarse es de 10 filas, pero la totalidad de registros (filas) es 15, entonces en la
             *  primera vista (bloque) si se verán 10 filas, pero en la segunda vista (bloque) solo se verán 5 filas, no 10 ! 
             *  Por lo tanto, el espejo sirve para preservar el valor de la totalidad de registros (que ha quedado en límite superior). Esto ocurre en THEN  */
            var lespejo = "";var huboespejo = false;

            /** Si el límite superior es mayor a la cantidad de registros, entonces   */
            if (state.lfin > state.limite) {

                // console.log("[siguiente], Hubo espejo !");
                lespejo = state.lfin; // preserva en el espejo el valor del límite superior y activa (true) el indicador del espejo, y
                huboespejo = true;
                state.lfin = state.limite; // establece como límite superior la cantidad de registros
            }

            /** Si el límite superior (menos 1) es exactamente igual la totalidad de registros (menos 1) entonces */
            if (state.lfin - 1 === state.limite - 1) {

                state.esLimiteSup = true; // activa (true) el indicador del límite superior para que no hayan más deplazamientos a la derecha, y

                /** Si hubo espejo entonces actualiza el límite superior con el valor que dejó en el espejo */
                if (huboespejo) {

                    state.lfin = lespejo;
                } // if (huboespejo)
            } // if()

            /* Incrementa la página visitada */
            state.pagina = state.pagina + 1;

            /* Antes de salir (out) actualiza los valores de los limites inferior y superios (if) y el de la página (p) */
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit("ifpout", { a: state.lini, b: state.lfin, c: state.pagina, d: payload.fuente,
                e: state.esLimiteInf, f: state.esLimiteSup });
        } // If (!state.esLimiteSup)
    }
};

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chgpass_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_login_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_logout_vue__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_culturaG_vue__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ev01_tipologia_vue__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ev02_16pf_vue__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ev03_npf_vue__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ev04_cpf_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ev05_fig_vue__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ev06_moss_vue__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ev07_tav_vue__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ev08_solemp_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ev09_emoc_vue__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ev10_vtas_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ev12_aedp_vue__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ev11_auxi_vue__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pruebas_cvs_vue__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ev_consultas_vue__ = __webpack_require__(376);
/** topcg/scr/routes.js  
 
    Define las rutas (paths) que accederá el programa, definiciendo las opciones que requieren autenticación.
    Desarrollado por JC Yocop
======================================================================================================== */

/** Importaciones */
















// import versionT     from './components/version3.vue'



// import enviarmail   from './pruebas/sendmail.vue'




/** Exportaciones */
var routes = [

/* Ejemplos sencillos de la relación de un path (/saludo, p.ej) con su respectivo componente  meta: { requiresAuth: true }  */
{ path: '/', name: 'home', component: __WEBPACK_IMPORTED_MODULE_1__components_home_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/login', name: 'login', component: __WEBPACK_IMPORTED_MODULE_2__components_login_vue__["a" /* default */] }, { path: '/chgpass', name: 'chgpass', component: __WEBPACK_IMPORTED_MODULE_0__components_chgpass_vue__["a" /* default */], meta: { requiresAuth: true } },
//     { path: '/culturaG',    name: 'culturaG',   component: culturaG,    meta: { requiresAuth: true } },
//* ok
{ path: '/tipologia', name: 'tipologia', component: __WEBPACK_IMPORTED_MODULE_5__components_ev01_tipologia_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/perfil', name: 'perfil', component: __WEBPACK_IMPORTED_MODULE_9__components_ev05_fig_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/factores', name: 'factores', component: __WEBPACK_IMPORTED_MODULE_6__components_ev02_16pf_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/estabilidad', name: 'estabilidad', component: __WEBPACK_IMPORTED_MODULE_7__components_ev03_npf_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/sociabilidad', name: 'sociabilidad', component: __WEBPACK_IMPORTED_MODULE_8__components_ev04_cpf_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/supervision', name: 'supervision', component: __WEBPACK_IMPORTED_MODULE_10__components_ev06_moss_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/aptitudvtas', name: 'aptitudvtas', component: __WEBPACK_IMPORTED_MODULE_11__components_ev07_tav_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/solempleo', name: 'solempleo', component: __WEBPACK_IMPORTED_MODULE_12__components_ev08_solemp_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/emociones', name: 'emociones', component: __WEBPACK_IMPORTED_MODULE_13__components_ev09_emoc_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/orientacion', name: 'orientacion', component: __WEBPACK_IMPORTED_MODULE_14__components_ev10_vtas_vue__["a" /* default */], meta: { requiresAuth: true } },
//     { path: '/versionT',    name: 'versionT',    component: versionT,     meta: { requiresAuth: true } },
{ path: '/auxiliar', name: 'auxiliar', component: __WEBPACK_IMPORTED_MODULE_16__components_ev11_auxi_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/aedp', name: 'aedp', component: __WEBPACK_IMPORTED_MODULE_15__components_ev12_aedp_vue__["a" /* default */], meta: { requiresAuth: true } },

// { path: '/enviarmail', name: 'enviarmail', component: enviarmail, meta: { requiresAuth: true } },
// { path: '/cvs',        name: 'cvs',          component: cvs, meta: { requiresAuth: true } },

//? ok
{ path: '/consultas', name: 'consultas', component: __WEBPACK_IMPORTED_MODULE_18__components_ev_consultas_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/logout', component: __WEBPACK_IMPORTED_MODULE_3__components_logout_vue__["a" /* default */], name: 'logout', meta: { requiresAuth: true } }, { path: '*', redirect: '/login' }];

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chgpass_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36785970_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chgpass_vue__ = __webpack_require__(288);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chgpass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36785970_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chgpass_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row center"},[_c('h5',{staticClass:"center"},[_vm._v("Cambio de Password")]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordact),expression:"passwordact"}],attrs:{"type":"password"},domProps:{"value":(_vm.passwordact)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.verifPass($event)},"input":function($event){if($event.target.composing){ return; }_vm.passwordact=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Clave de Acceso Actual ?")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordnew1),expression:"passwordnew1"}],attrs:{"type":"password"},domProps:{"value":(_vm.passwordnew1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passwordnew1=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Nueva Clave ?")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordnew2),expression:"passwordnew2"}],attrs:{"type":"password"},domProps:{"value":(_vm.passwordnew2)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.verinPass($event)},"input":function($event){if($event.target.composing){ return; }_vm.passwordnew2=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Repita Nueva Clave ?")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":_vm.cambiarClave}},[_vm._v("Cambiar Clave ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb9fce0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(290);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb9fce0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"row center"},[(_vm.$store.state.st_logeado)?_c('h5',{staticClass:"center"},[_vm._v("SISTEMA DE EVALUACIONES EN LINEA")]):_vm._e(),_vm._v(" "),(_vm.$store.state.st_logeado)?_c('h5',{staticClass:"center"},[_vm._v("Bienvenido(a) "+_vm._s(_vm.$store.state.st_nusuario))]):_vm._e(),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.$store.state.st_activo ? "" : "(INACTIVO)")+" ")]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.$store.state.st_depto)+"- "+_vm._s(_vm.$store.state.st_empresa))])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s4"}),_vm._v(" "),_c('div',{staticClass:"col s4"},[_c('img',{attrs:{"src":"/topevaluaciones/src/assets/imagenes/sistemasweb.jpg"}})]),_vm._v(" "),_c('div',{staticClass:"col s4"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c212fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(294);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c212fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "/*!\r\n * Materialize v1.0.0 (http://materializecss.com)\r\n * Copyright 2014-2017 Materialize\r\n * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)\r\n */.materialize-red{background-color:#e51c23!important}.materialize-red-text{color:#e51c23!important}.materialize-red.lighten-5{background-color:#fdeaeb!important}.materialize-red-text.text-lighten-5{color:#fdeaeb!important}.materialize-red.lighten-4{background-color:#f8c1c3!important}.materialize-red-text.text-lighten-4{color:#f8c1c3!important}.materialize-red.lighten-3{background-color:#f3989b!important}.materialize-red-text.text-lighten-3{color:#f3989b!important}.materialize-red.lighten-2{background-color:#ee6e73!important}.materialize-red-text.text-lighten-2{color:#ee6e73!important}.materialize-red.lighten-1{background-color:#ea454b!important}.materialize-red-text.text-lighten-1{color:#ea454b!important}.materialize-red.darken-1{background-color:#d0181e!important}.materialize-red-text.text-darken-1{color:#d0181e!important}.materialize-red.darken-2{background-color:#b9151b!important}.materialize-red-text.text-darken-2{color:#b9151b!important}.materialize-red.darken-3{background-color:#a21318!important}.materialize-red-text.text-darken-3{color:#a21318!important}.materialize-red.darken-4{background-color:#8b1014!important}.materialize-red-text.text-darken-4{color:#8b1014!important}.red{background-color:#f44336!important}.red-text{color:#f44336!important}.red.lighten-5{background-color:#ffebee!important}.red-text.text-lighten-5{color:#ffebee!important}.red.lighten-4{background-color:#ffcdd2!important}.red-text.text-lighten-4{color:#ffcdd2!important}.red.lighten-3{background-color:#ef9a9a!important}.red-text.text-lighten-3{color:#ef9a9a!important}.red.lighten-2{background-color:#e57373!important}.red-text.text-lighten-2{color:#e57373!important}.red.lighten-1{background-color:#ef5350!important}.red-text.text-lighten-1{color:#ef5350!important}.red.darken-1{background-color:#e53935!important}.red-text.text-darken-1{color:#e53935!important}.red.darken-2{background-color:#d32f2f!important}.red-text.text-darken-2{color:#d32f2f!important}.red.darken-3{background-color:#c62828!important}.red-text.text-darken-3{color:#c62828!important}.red.darken-4{background-color:#b71c1c!important}.red-text.text-darken-4{color:#b71c1c!important}.red.accent-1{background-color:#ff8a80!important}.red-text.text-accent-1{color:#ff8a80!important}.red.accent-2{background-color:#ff5252!important}.red-text.text-accent-2{color:#ff5252!important}.red.accent-3{background-color:#ff1744!important}.red-text.text-accent-3{color:#ff1744!important}.red.accent-4{background-color:#d50000!important}.red-text.text-accent-4{color:#d50000!important}.pink{background-color:#e91e63!important}.pink-text{color:#e91e63!important}.pink.lighten-5{background-color:#fce4ec!important}.pink-text.text-lighten-5{color:#fce4ec!important}.pink.lighten-4{background-color:#f8bbd0!important}.pink-text.text-lighten-4{color:#f8bbd0!important}.pink.lighten-3{background-color:#f48fb1!important}.pink-text.text-lighten-3{color:#f48fb1!important}.pink.lighten-2{background-color:#f06292!important}.pink-text.text-lighten-2{color:#f06292!important}.pink.lighten-1{background-color:#ec407a!important}.pink-text.text-lighten-1{color:#ec407a!important}.pink.darken-1{background-color:#d81b60!important}.pink-text.text-darken-1{color:#d81b60!important}.pink.darken-2{background-color:#c2185b!important}.pink-text.text-darken-2{color:#c2185b!important}.pink.darken-3{background-color:#ad1457!important}.pink-text.text-darken-3{color:#ad1457!important}.pink.darken-4{background-color:#880e4f!important}.pink-text.text-darken-4{color:#880e4f!important}.pink.accent-1{background-color:#ff80ab!important}.pink-text.text-accent-1{color:#ff80ab!important}.pink.accent-2{background-color:#ff4081!important}.pink-text.text-accent-2{color:#ff4081!important}.pink.accent-3{background-color:#f50057!important}.pink-text.text-accent-3{color:#f50057!important}.pink.accent-4{background-color:#c51162!important}.pink-text.text-accent-4{color:#c51162!important}.purple{background-color:#9c27b0!important}.purple-text{color:#9c27b0!important}.purple.lighten-5{background-color:#f3e5f5!important}.purple-text.text-lighten-5{color:#f3e5f5!important}.purple.lighten-4{background-color:#e1bee7!important}.purple-text.text-lighten-4{color:#e1bee7!important}.purple.lighten-3{background-color:#ce93d8!important}.purple-text.text-lighten-3{color:#ce93d8!important}.purple.lighten-2{background-color:#ba68c8!important}.purple-text.text-lighten-2{color:#ba68c8!important}.purple.lighten-1{background-color:#ab47bc!important}.purple-text.text-lighten-1{color:#ab47bc!important}.purple.darken-1{background-color:#8e24aa!important}.purple-text.text-darken-1{color:#8e24aa!important}.purple.darken-2{background-color:#7b1fa2!important}.purple-text.text-darken-2{color:#7b1fa2!important}.purple.darken-3{background-color:#6a1b9a!important}.purple-text.text-darken-3{color:#6a1b9a!important}.purple.darken-4{background-color:#4a148c!important}.purple-text.text-darken-4{color:#4a148c!important}.purple.accent-1{background-color:#ea80fc!important}.purple-text.text-accent-1{color:#ea80fc!important}.purple.accent-2{background-color:#e040fb!important}.purple-text.text-accent-2{color:#e040fb!important}.purple.accent-3{background-color:#d500f9!important}.purple-text.text-accent-3{color:#d500f9!important}.purple.accent-4{background-color:#a0f!important}.purple-text.text-accent-4{color:#a0f!important}.deep-purple{background-color:#673ab7!important}.deep-purple-text{color:#673ab7!important}.deep-purple.lighten-5{background-color:#ede7f6!important}.deep-purple-text.text-lighten-5{color:#ede7f6!important}.deep-purple.lighten-4{background-color:#d1c4e9!important}.deep-purple-text.text-lighten-4{color:#d1c4e9!important}.deep-purple.lighten-3{background-color:#b39ddb!important}.deep-purple-text.text-lighten-3{color:#b39ddb!important}.deep-purple.lighten-2{background-color:#9575cd!important}.deep-purple-text.text-lighten-2{color:#9575cd!important}.deep-purple.lighten-1{background-color:#7e57c2!important}.deep-purple-text.text-lighten-1{color:#7e57c2!important}.deep-purple.darken-1{background-color:#5e35b1!important}.deep-purple-text.text-darken-1{color:#5e35b1!important}.deep-purple.darken-2{background-color:#512da8!important}.deep-purple-text.text-darken-2{color:#512da8!important}.deep-purple.darken-3{background-color:#4527a0!important}.deep-purple-text.text-darken-3{color:#4527a0!important}.deep-purple.darken-4{background-color:#311b92!important}.deep-purple-text.text-darken-4{color:#311b92!important}.deep-purple.accent-1{background-color:#b388ff!important}.deep-purple-text.text-accent-1{color:#b388ff!important}.deep-purple.accent-2{background-color:#7c4dff!important}.deep-purple-text.text-accent-2{color:#7c4dff!important}.deep-purple.accent-3{background-color:#651fff!important}.deep-purple-text.text-accent-3{color:#651fff!important}.deep-purple.accent-4{background-color:#6200ea!important}.deep-purple-text.text-accent-4{color:#6200ea!important}.indigo{background-color:#3f51b5!important}.indigo-text{color:#3f51b5!important}.indigo.lighten-5{background-color:#e8eaf6!important}.indigo-text.text-lighten-5{color:#e8eaf6!important}.indigo.lighten-4{background-color:#c5cae9!important}.indigo-text.text-lighten-4{color:#c5cae9!important}.indigo.lighten-3{background-color:#9fa8da!important}.indigo-text.text-lighten-3{color:#9fa8da!important}.indigo.lighten-2{background-color:#7986cb!important}.indigo-text.text-lighten-2{color:#7986cb!important}.indigo.lighten-1{background-color:#5c6bc0!important}.indigo-text.text-lighten-1{color:#5c6bc0!important}.indigo.darken-1{background-color:#3949ab!important}.indigo-text.text-darken-1{color:#3949ab!important}.indigo.darken-2{background-color:#303f9f!important}.indigo-text.text-darken-2{color:#303f9f!important}.indigo.darken-3{background-color:#283593!important}.indigo-text.text-darken-3{color:#283593!important}.indigo.darken-4{background-color:#1a237e!important}.indigo-text.text-darken-4{color:#1a237e!important}.indigo.accent-1{background-color:#8c9eff!important}.indigo-text.text-accent-1{color:#8c9eff!important}.indigo.accent-2{background-color:#536dfe!important}.indigo-text.text-accent-2{color:#536dfe!important}.indigo.accent-3{background-color:#3d5afe!important}.indigo-text.text-accent-3{color:#3d5afe!important}.indigo.accent-4{background-color:#304ffe!important}.indigo-text.text-accent-4{color:#304ffe!important}.blue{background-color:#2196f3!important}.blue-text{color:#2196f3!important}.blue.lighten-5{background-color:#e3f2fd!important}.blue-text.text-lighten-5{color:#e3f2fd!important}.blue.lighten-4{background-color:#bbdefb!important}.blue-text.text-lighten-4{color:#bbdefb!important}.blue.lighten-3{background-color:#90caf9!important}.blue-text.text-lighten-3{color:#90caf9!important}.blue.lighten-2{background-color:#64b5f6!important}.blue-text.text-lighten-2{color:#64b5f6!important}.blue.lighten-1{background-color:#42a5f5!important}.blue-text.text-lighten-1{color:#42a5f5!important}.blue.darken-1{background-color:#1e88e5!important}.blue-text.text-darken-1{color:#1e88e5!important}.blue.darken-2{background-color:#1976d2!important}.blue-text.text-darken-2{color:#1976d2!important}.blue.darken-3{background-color:#1565c0!important}.blue-text.text-darken-3{color:#1565c0!important}.blue.darken-4{background-color:#0d47a1!important}.blue-text.text-darken-4{color:#0d47a1!important}.blue.accent-1{background-color:#82b1ff!important}.blue-text.text-accent-1{color:#82b1ff!important}.blue.accent-2{background-color:#448aff!important}.blue-text.text-accent-2{color:#448aff!important}.blue.accent-3{background-color:#2979ff!important}.blue-text.text-accent-3{color:#2979ff!important}.blue.accent-4{background-color:#2962ff!important}.blue-text.text-accent-4{color:#2962ff!important}.light-blue{background-color:#03a9f4!important}.light-blue-text{color:#03a9f4!important}.light-blue.lighten-5{background-color:#e1f5fe!important}.light-blue-text.text-lighten-5{color:#e1f5fe!important}.light-blue.lighten-4{background-color:#b3e5fc!important}.light-blue-text.text-lighten-4{color:#b3e5fc!important}.light-blue.lighten-3{background-color:#81d4fa!important}.light-blue-text.text-lighten-3{color:#81d4fa!important}.light-blue.lighten-2{background-color:#4fc3f7!important}.light-blue-text.text-lighten-2{color:#4fc3f7!important}.light-blue.lighten-1{background-color:#29b6f6!important}.light-blue-text.text-lighten-1{color:#29b6f6!important}.light-blue.darken-1{background-color:#039be5!important}.light-blue-text.text-darken-1{color:#039be5!important}.light-blue.darken-2{background-color:#0288d1!important}.light-blue-text.text-darken-2{color:#0288d1!important}.light-blue.darken-3{background-color:#0277bd!important}.light-blue-text.text-darken-3{color:#0277bd!important}.light-blue.darken-4{background-color:#01579b!important}.light-blue-text.text-darken-4{color:#01579b!important}.light-blue.accent-1{background-color:#80d8ff!important}.light-blue-text.text-accent-1{color:#80d8ff!important}.light-blue.accent-2{background-color:#40c4ff!important}.light-blue-text.text-accent-2{color:#40c4ff!important}.light-blue.accent-3{background-color:#00b0ff!important}.light-blue-text.text-accent-3{color:#00b0ff!important}.light-blue.accent-4{background-color:#0091ea!important}.light-blue-text.text-accent-4{color:#0091ea!important}.cyan{background-color:#00bcd4!important}.cyan-text{color:#00bcd4!important}.cyan.lighten-5{background-color:#e0f7fa!important}.cyan-text.text-lighten-5{color:#e0f7fa!important}.cyan.lighten-4{background-color:#b2ebf2!important}.cyan-text.text-lighten-4{color:#b2ebf2!important}.cyan.lighten-3{background-color:#80deea!important}.cyan-text.text-lighten-3{color:#80deea!important}.cyan.lighten-2{background-color:#4dd0e1!important}.cyan-text.text-lighten-2{color:#4dd0e1!important}.cyan.lighten-1{background-color:#26c6da!important}.cyan-text.text-lighten-1{color:#26c6da!important}.cyan.darken-1{background-color:#00acc1!important}.cyan-text.text-darken-1{color:#00acc1!important}.cyan.darken-2{background-color:#0097a7!important}.cyan-text.text-darken-2{color:#0097a7!important}.cyan.darken-3{background-color:#00838f!important}.cyan-text.text-darken-3{color:#00838f!important}.cyan.darken-4{background-color:#006064!important}.cyan-text.text-darken-4{color:#006064!important}.cyan.accent-1{background-color:#84ffff!important}.cyan-text.text-accent-1{color:#84ffff!important}.cyan.accent-2{background-color:#18ffff!important}.cyan-text.text-accent-2{color:#18ffff!important}.cyan.accent-3{background-color:#00e5ff!important}.cyan-text.text-accent-3{color:#00e5ff!important}.cyan.accent-4{background-color:#00b8d4!important}.cyan-text.text-accent-4{color:#00b8d4!important}.teal{background-color:#009688!important}.teal-text{color:#009688!important}.teal.lighten-5{background-color:#e0f2f1!important}.teal-text.text-lighten-5{color:#e0f2f1!important}.teal.lighten-4{background-color:#b2dfdb!important}.teal-text.text-lighten-4{color:#b2dfdb!important}.teal.lighten-3{background-color:#80cbc4!important}.teal-text.text-lighten-3{color:#80cbc4!important}.teal.lighten-2{background-color:#4db6ac!important}.teal-text.text-lighten-2{color:#4db6ac!important}.teal.lighten-1{background-color:#26a69a!important}.teal-text.text-lighten-1{color:#26a69a!important}.teal.darken-1{background-color:#00897b!important}.teal-text.text-darken-1{color:#00897b!important}.teal.darken-2{background-color:#00796b!important}.teal-text.text-darken-2{color:#00796b!important}.teal.darken-3{background-color:#00695c!important}.teal-text.text-darken-3{color:#00695c!important}.teal.darken-4{background-color:#004d40!important}.teal-text.text-darken-4{color:#004d40!important}.teal.accent-1{background-color:#a7ffeb!important}.teal-text.text-accent-1{color:#a7ffeb!important}.teal.accent-2{background-color:#64ffda!important}.teal-text.text-accent-2{color:#64ffda!important}.teal.accent-3{background-color:#1de9b6!important}.teal-text.text-accent-3{color:#1de9b6!important}.teal.accent-4{background-color:#00bfa5!important}.teal-text.text-accent-4{color:#00bfa5!important}.green{background-color:#4caf50!important}.green-text{color:#4caf50!important}.green.lighten-5{background-color:#e8f5e9!important}.green-text.text-lighten-5{color:#e8f5e9!important}.green.lighten-4{background-color:#c8e6c9!important}.green-text.text-lighten-4{color:#c8e6c9!important}.green.lighten-3{background-color:#a5d6a7!important}.green-text.text-lighten-3{color:#a5d6a7!important}.green.lighten-2{background-color:#81c784!important}.green-text.text-lighten-2{color:#81c784!important}.green.lighten-1{background-color:#66bb6a!important}.green-text.text-lighten-1{color:#66bb6a!important}.green.darken-1{background-color:#43a047!important}.green-text.text-darken-1{color:#43a047!important}.green.darken-2{background-color:#388e3c!important}.green-text.text-darken-2{color:#388e3c!important}.green.darken-3{background-color:#2e7d32!important}.green-text.text-darken-3{color:#2e7d32!important}.green.darken-4{background-color:#1b5e20!important}.green-text.text-darken-4{color:#1b5e20!important}.green.accent-1{background-color:#b9f6ca!important}.green-text.text-accent-1{color:#b9f6ca!important}.green.accent-2{background-color:#69f0ae!important}.green-text.text-accent-2{color:#69f0ae!important}.green.accent-3{background-color:#00e676!important}.green-text.text-accent-3{color:#00e676!important}.green.accent-4{background-color:#00c853!important}.green-text.text-accent-4{color:#00c853!important}.light-green{background-color:#8bc34a!important}.light-green-text{color:#8bc34a!important}.light-green.lighten-5{background-color:#f1f8e9!important}.light-green-text.text-lighten-5{color:#f1f8e9!important}.light-green.lighten-4{background-color:#dcedc8!important}.light-green-text.text-lighten-4{color:#dcedc8!important}.light-green.lighten-3{background-color:#c5e1a5!important}.light-green-text.text-lighten-3{color:#c5e1a5!important}.light-green.lighten-2{background-color:#aed581!important}.light-green-text.text-lighten-2{color:#aed581!important}.light-green.lighten-1{background-color:#9ccc65!important}.light-green-text.text-lighten-1{color:#9ccc65!important}.light-green.darken-1{background-color:#7cb342!important}.light-green-text.text-darken-1{color:#7cb342!important}.light-green.darken-2{background-color:#689f38!important}.light-green-text.text-darken-2{color:#689f38!important}.light-green.darken-3{background-color:#558b2f!important}.light-green-text.text-darken-3{color:#558b2f!important}.light-green.darken-4{background-color:#33691e!important}.light-green-text.text-darken-4{color:#33691e!important}.light-green.accent-1{background-color:#ccff90!important}.light-green-text.text-accent-1{color:#ccff90!important}.light-green.accent-2{background-color:#b2ff59!important}.light-green-text.text-accent-2{color:#b2ff59!important}.light-green.accent-3{background-color:#76ff03!important}.light-green-text.text-accent-3{color:#76ff03!important}.light-green.accent-4{background-color:#64dd17!important}.light-green-text.text-accent-4{color:#64dd17!important}.lime{background-color:#cddc39!important}.lime-text{color:#cddc39!important}.lime.lighten-5{background-color:#f9fbe7!important}.lime-text.text-lighten-5{color:#f9fbe7!important}.lime.lighten-4{background-color:#f0f4c3!important}.lime-text.text-lighten-4{color:#f0f4c3!important}.lime.lighten-3{background-color:#e6ee9c!important}.lime-text.text-lighten-3{color:#e6ee9c!important}.lime.lighten-2{background-color:#dce775!important}.lime-text.text-lighten-2{color:#dce775!important}.lime.lighten-1{background-color:#d4e157!important}.lime-text.text-lighten-1{color:#d4e157!important}.lime.darken-1{background-color:#c0ca33!important}.lime-text.text-darken-1{color:#c0ca33!important}.lime.darken-2{background-color:#afb42b!important}.lime-text.text-darken-2{color:#afb42b!important}.lime.darken-3{background-color:#9e9d24!important}.lime-text.text-darken-3{color:#9e9d24!important}.lime.darken-4{background-color:#827717!important}.lime-text.text-darken-4{color:#827717!important}.lime.accent-1{background-color:#f4ff81!important}.lime-text.text-accent-1{color:#f4ff81!important}.lime.accent-2{background-color:#eeff41!important}.lime-text.text-accent-2{color:#eeff41!important}.lime.accent-3{background-color:#c6ff00!important}.lime-text.text-accent-3{color:#c6ff00!important}.lime.accent-4{background-color:#aeea00!important}.lime-text.text-accent-4{color:#aeea00!important}.yellow{background-color:#ffeb3b!important}.yellow-text{color:#ffeb3b!important}.yellow.lighten-5{background-color:#fffde7!important}.yellow-text.text-lighten-5{color:#fffde7!important}.yellow.lighten-4{background-color:#fff9c4!important}.yellow-text.text-lighten-4{color:#fff9c4!important}.yellow.lighten-3{background-color:#fff59d!important}.yellow-text.text-lighten-3{color:#fff59d!important}.yellow.lighten-2{background-color:#fff176!important}.yellow-text.text-lighten-2{color:#fff176!important}.yellow.lighten-1{background-color:#ffee58!important}.yellow-text.text-lighten-1{color:#ffee58!important}.yellow.darken-1{background-color:#fdd835!important}.yellow-text.text-darken-1{color:#fdd835!important}.yellow.darken-2{background-color:#fbc02d!important}.yellow-text.text-darken-2{color:#fbc02d!important}.yellow.darken-3{background-color:#f9a825!important}.yellow-text.text-darken-3{color:#f9a825!important}.yellow.darken-4{background-color:#f57f17!important}.yellow-text.text-darken-4{color:#f57f17!important}.yellow.accent-1{background-color:#ffff8d!important}.yellow-text.text-accent-1{color:#ffff8d!important}.yellow.accent-2{background-color:#ff0!important}.yellow-text.text-accent-2{color:#ff0!important}.yellow.accent-3{background-color:#ffea00!important}.yellow-text.text-accent-3{color:#ffea00!important}.yellow.accent-4{background-color:#ffd600!important}.yellow-text.text-accent-4{color:#ffd600!important}.amber{background-color:#ffc107!important}.amber-text{color:#ffc107!important}.amber.lighten-5{background-color:#fff8e1!important}.amber-text.text-lighten-5{color:#fff8e1!important}.amber.lighten-4{background-color:#ffecb3!important}.amber-text.text-lighten-4{color:#ffecb3!important}.amber.lighten-3{background-color:#ffe082!important}.amber-text.text-lighten-3{color:#ffe082!important}.amber.lighten-2{background-color:#ffd54f!important}.amber-text.text-lighten-2{color:#ffd54f!important}.amber.lighten-1{background-color:#ffca28!important}.amber-text.text-lighten-1{color:#ffca28!important}.amber.darken-1{background-color:#ffb300!important}.amber-text.text-darken-1{color:#ffb300!important}.amber.darken-2{background-color:#ffa000!important}.amber-text.text-darken-2{color:#ffa000!important}.amber.darken-3{background-color:#ff8f00!important}.amber-text.text-darken-3{color:#ff8f00!important}.amber.darken-4{background-color:#ff6f00!important}.amber-text.text-darken-4{color:#ff6f00!important}.amber.accent-1{background-color:#ffe57f!important}.amber-text.text-accent-1{color:#ffe57f!important}.amber.accent-2{background-color:#ffd740!important}.amber-text.text-accent-2{color:#ffd740!important}.amber.accent-3{background-color:#ffc400!important}.amber-text.text-accent-3{color:#ffc400!important}.amber.accent-4{background-color:#ffab00!important}.amber-text.text-accent-4{color:#ffab00!important}.orange{background-color:#ff9800!important}.orange-text{color:#ff9800!important}.orange.lighten-5{background-color:#fff3e0!important}.orange-text.text-lighten-5{color:#fff3e0!important}.orange.lighten-4{background-color:#ffe0b2!important}.orange-text.text-lighten-4{color:#ffe0b2!important}.orange.lighten-3{background-color:#ffcc80!important}.orange-text.text-lighten-3{color:#ffcc80!important}.orange.lighten-2{background-color:#ffb74d!important}.orange-text.text-lighten-2{color:#ffb74d!important}.orange.lighten-1{background-color:#ffa726!important}.orange-text.text-lighten-1{color:#ffa726!important}.orange.darken-1{background-color:#fb8c00!important}.orange-text.text-darken-1{color:#fb8c00!important}.orange.darken-2{background-color:#f57c00!important}.orange-text.text-darken-2{color:#f57c00!important}.orange.darken-3{background-color:#ef6c00!important}.orange-text.text-darken-3{color:#ef6c00!important}.orange.darken-4{background-color:#e65100!important}.orange-text.text-darken-4{color:#e65100!important}.orange.accent-1{background-color:#ffd180!important}.orange-text.text-accent-1{color:#ffd180!important}.orange.accent-2{background-color:#ffab40!important}.orange-text.text-accent-2{color:#ffab40!important}.orange.accent-3{background-color:#ff9100!important}.orange-text.text-accent-3{color:#ff9100!important}.orange.accent-4{background-color:#ff6d00!important}.orange-text.text-accent-4{color:#ff6d00!important}.deep-orange{background-color:#ff5722!important}.deep-orange-text{color:#ff5722!important}.deep-orange.lighten-5{background-color:#fbe9e7!important}.deep-orange-text.text-lighten-5{color:#fbe9e7!important}.deep-orange.lighten-4{background-color:#ffccbc!important}.deep-orange-text.text-lighten-4{color:#ffccbc!important}.deep-orange.lighten-3{background-color:#ffab91!important}.deep-orange-text.text-lighten-3{color:#ffab91!important}.deep-orange.lighten-2{background-color:#ff8a65!important}.deep-orange-text.text-lighten-2{color:#ff8a65!important}.deep-orange.lighten-1{background-color:#ff7043!important}.deep-orange-text.text-lighten-1{color:#ff7043!important}.deep-orange.darken-1{background-color:#f4511e!important}.deep-orange-text.text-darken-1{color:#f4511e!important}.deep-orange.darken-2{background-color:#e64a19!important}.deep-orange-text.text-darken-2{color:#e64a19!important}.deep-orange.darken-3{background-color:#d84315!important}.deep-orange-text.text-darken-3{color:#d84315!important}.deep-orange.darken-4{background-color:#bf360c!important}.deep-orange-text.text-darken-4{color:#bf360c!important}.deep-orange.accent-1{background-color:#ff9e80!important}.deep-orange-text.text-accent-1{color:#ff9e80!important}.deep-orange.accent-2{background-color:#ff6e40!important}.deep-orange-text.text-accent-2{color:#ff6e40!important}.deep-orange.accent-3{background-color:#ff3d00!important}.deep-orange-text.text-accent-3{color:#ff3d00!important}.deep-orange.accent-4{background-color:#dd2c00!important}.deep-orange-text.text-accent-4{color:#dd2c00!important}.brown{background-color:#795548!important}.brown-text{color:#795548!important}.brown.lighten-5{background-color:#efebe9!important}.brown-text.text-lighten-5{color:#efebe9!important}.brown.lighten-4{background-color:#d7ccc8!important}.brown-text.text-lighten-4{color:#d7ccc8!important}.brown.lighten-3{background-color:#bcaaa4!important}.brown-text.text-lighten-3{color:#bcaaa4!important}.brown.lighten-2{background-color:#a1887f!important}.brown-text.text-lighten-2{color:#a1887f!important}.brown.lighten-1{background-color:#8d6e63!important}.brown-text.text-lighten-1{color:#8d6e63!important}.brown.darken-1{background-color:#6d4c41!important}.brown-text.text-darken-1{color:#6d4c41!important}.brown.darken-2{background-color:#5d4037!important}.brown-text.text-darken-2{color:#5d4037!important}.brown.darken-3{background-color:#4e342e!important}.brown-text.text-darken-3{color:#4e342e!important}.brown.darken-4{background-color:#3e2723!important}.brown-text.text-darken-4{color:#3e2723!important}.blue-grey{background-color:#607d8b!important}.blue-grey-text{color:#607d8b!important}.blue-grey.lighten-5{background-color:#eceff1!important}.blue-grey-text.text-lighten-5{color:#eceff1!important}.blue-grey.lighten-4{background-color:#cfd8dc!important}.blue-grey-text.text-lighten-4{color:#cfd8dc!important}.blue-grey.lighten-3{background-color:#b0bec5!important}.blue-grey-text.text-lighten-3{color:#b0bec5!important}.blue-grey.lighten-2{background-color:#90a4ae!important}.blue-grey-text.text-lighten-2{color:#90a4ae!important}.blue-grey.lighten-1{background-color:#78909c!important}.blue-grey-text.text-lighten-1{color:#78909c!important}.blue-grey.darken-1{background-color:#546e7a!important}.blue-grey-text.text-darken-1{color:#546e7a!important}.blue-grey.darken-2{background-color:#455a64!important}.blue-grey-text.text-darken-2{color:#455a64!important}.blue-grey.darken-3{background-color:#37474f!important}.blue-grey-text.text-darken-3{color:#37474f!important}.blue-grey.darken-4{background-color:#263238!important}.blue-grey-text.text-darken-4{color:#263238!important}.grey{background-color:#9e9e9e!important}.grey-text{color:#9e9e9e!important}.grey.lighten-5{background-color:#fafafa!important}.grey-text.text-lighten-5{color:#fafafa!important}.grey.lighten-4{background-color:#f5f5f5!important}.grey-text.text-lighten-4{color:#f5f5f5!important}.grey.lighten-3{background-color:#eee!important}.grey-text.text-lighten-3{color:#eee!important}.grey.lighten-2{background-color:#e0e0e0!important}.grey-text.text-lighten-2{color:#e0e0e0!important}.grey.lighten-1{background-color:#bdbdbd!important}.grey-text.text-lighten-1{color:#bdbdbd!important}.grey.darken-1{background-color:#757575!important}.grey-text.text-darken-1{color:#757575!important}.grey.darken-2{background-color:#616161!important}.grey-text.text-darken-2{color:#616161!important}.grey.darken-3{background-color:#424242!important}.grey-text.text-darken-3{color:#424242!important}.grey.darken-4{background-color:#212121!important}.grey-text.text-darken-4{color:#212121!important}.black{background-color:#000!important}.black-text{color:#000!important}.white{background-color:#fff!important}.white-text{color:#fff!important}.transparent{background-color:transparent!important}.transparent-text{color:transparent!important}/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;-moz-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}html{-webkit-box-sizing:border-box;box-sizing:border-box}*,:after,:before{-webkit-box-sizing:inherit;box-sizing:inherit}button,input,optgroup,select,textarea{font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif}ul:not(.browser-default){padding-left:0;list-style-type:none}ul:not(.browser-default)>li{list-style-type:none}a{color:#039be5;-webkit-tap-highlight-color:transparent}.valign-wrapper{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.clearfix{clear:both}.z-depth-0{-webkit-box-shadow:none!important;box-shadow:none!important}.btn,.btn-floating,.btn-large,.btn-small,.card,.card-panel,.collapsible,.dropdown-content,.sidenav,.toast,.z-depth-1,nav{-webkit-box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12),0 1px 5px 0 rgba(0,0,0,.2);box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12),0 1px 5px 0 rgba(0,0,0,.2)}.btn-floating:hover,.btn-large:hover,.btn-small:hover,.btn:hover,.z-depth-1-half{-webkit-box-shadow:0 3px 3px 0 rgba(0,0,0,.14),0 1px 7px 0 rgba(0,0,0,.12),0 3px 1px -1px rgba(0,0,0,.2);box-shadow:0 3px 3px 0 rgba(0,0,0,.14),0 1px 7px 0 rgba(0,0,0,.12),0 3px 1px -1px rgba(0,0,0,.2)}.z-depth-2{-webkit-box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.3);box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.3)}.z-depth-3{-webkit-box-shadow:0 8px 17px 2px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2);box-shadow:0 8px 17px 2px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2)}.z-depth-4{-webkit-box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -7px rgba(0,0,0,.2);box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -7px rgba(0,0,0,.2)}.modal,.z-depth-5{-webkit-box-shadow:0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12),0 11px 15px -7px rgba(0,0,0,.2);box-shadow:0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12),0 11px 15px -7px rgba(0,0,0,.2)}.hoverable{-webkit-transition:-webkit-box-shadow .25s;transition:-webkit-box-shadow .25s;transition:box-shadow .25s;transition:box-shadow .25s,-webkit-box-shadow .25s}.hoverable:hover{-webkit-box-shadow:0 8px 17px 0 rgba(0,0,0,.2),0 6px 20px 0 rgba(0,0,0,.19);box-shadow:0 8px 17px 0 rgba(0,0,0,.2),0 6px 20px 0 rgba(0,0,0,.19)}.divider{height:1px;overflow:hidden;background-color:#e0e0e0}blockquote{margin:20px 0;padding-left:1.5rem;border-left:5px solid #ee6e73}i{line-height:inherit}i.left{float:left;margin-right:15px}i.right{float:right;margin-left:15px}i.tiny{font-size:1rem}i.small{font-size:2rem}i.medium{font-size:4rem}i.large{font-size:6rem}img.responsive-img,video.responsive-video{max-width:100%;height:auto}.pagination li{display:inline-block;border-radius:2px;text-align:center;vertical-align:top;height:30px}.pagination li a{color:#444;display:inline-block;font-size:1.2rem;padding:0 10px;line-height:30px}.pagination li.active a{color:#fff}.pagination li.active{background-color:#ee6e73}.pagination li.disabled a{cursor:default;color:#999}.pagination li i{font-size:2rem}.pagination li.pages ul li{display:inline-block;float:none}@media only screen and (max-width:992px){.pagination{width:100%}.pagination li.next,.pagination li.prev{width:10%}.pagination li.pages{width:80%;overflow:hidden;white-space:nowrap}}.breadcrumb{font-size:18px;color:hsla(0,0%,100%,.7)}.breadcrumb [class*=mdi-],.breadcrumb [class^=mdi-],.breadcrumb i,.breadcrumb i.material-icons{display:inline-block;float:left;font-size:24px}.breadcrumb:before{content:\"\\E5CC\";color:hsla(0,0%,100%,.7);vertical-align:top;display:inline-block;font-family:Material Icons;font-weight:400;font-style:normal;font-size:25px;margin:0 10px 0 8px;-webkit-font-smoothing:antialiased}.breadcrumb:first-child:before{display:none}.breadcrumb:last-child{color:#fff}.parallax-container{position:relative;overflow:hidden;height:500px}.parallax-container .parallax{position:absolute;top:0;left:0;right:0;bottom:0;z-index:-1}.parallax-container .parallax img{opacity:0;position:absolute;left:50%;bottom:0;min-width:100%;min-height:100%;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-transform:translateX(-50%);transform:translateX(-50%)}.pin-bottom,.pin-top{position:relative}.pinned{position:fixed!important}.fade-in,ul.staggered-list li{opacity:0}.fade-in{-webkit-transform-origin:0 50%;transform-origin:0 50%}@media only screen and (max-width:600px){.hide-on-small-and-down,.hide-on-small-only{display:none!important}}@media only screen and (max-width:992px){.hide-on-med-and-down{display:none!important}}@media only screen and (min-width:601px){.hide-on-med-and-up{display:none!important}}@media only screen and (min-width:600px) and (max-width:992px){.hide-on-med-only{display:none!important}}@media only screen and (min-width:993px){.hide-on-large-only{display:none!important}}@media only screen and (min-width:1201px){.hide-on-extra-large-only{display:none!important}}@media only screen and (min-width:1201px){.show-on-extra-large{display:block!important}}@media only screen and (min-width:993px){.show-on-large{display:block!important}}@media only screen and (min-width:600px) and (max-width:992px){.show-on-medium{display:block!important}}@media only screen and (max-width:600px){.show-on-small{display:block!important}}@media only screen and (min-width:601px){.show-on-medium-and-up{display:block!important}}@media only screen and (max-width:992px){.show-on-medium-and-down{display:block!important}}@media only screen and (max-width:600px){.center-on-small-only{text-align:center}}.page-footer{padding-top:20px;color:#fff;background-color:#ee6e73}.page-footer .footer-copyright{overflow:hidden;min-height:50px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;padding:10px 0;color:hsla(0,0%,100%,.8);background-color:rgba(51,51,51,.08)}table,td,th{border:none}table{width:100%;display:table;border-collapse:collapse;border-spacing:0}table.striped tr{border-bottom:none}table.striped>tbody>tr:nth-child(odd){background-color:hsla(0,0%,95%,.5)}table.striped>tbody>tr>td{border-radius:0}table.highlight>tbody>tr{-webkit-transition:background-color .25s ease;transition:background-color .25s ease}table.highlight>tbody>tr:hover{background-color:hsla(0,0%,95%,.5)}table.centered tbody tr td,table.centered thead tr th{text-align:center}tr{border-bottom:1px solid rgba(0,0,0,.12)}td,th{padding:15px 5px;display:table-cell;text-align:left;vertical-align:middle;border-radius:2px}@media only screen and (max-width:992px){table.responsive-table{width:100%;border-collapse:collapse;border-spacing:0;display:block;position:relative}table.responsive-table td:empty:before{content:\"\\A0\"}table.responsive-table td,table.responsive-table th{margin:0;vertical-align:top}table.responsive-table th{text-align:left}table.responsive-table thead{display:block;float:left}table.responsive-table thead tr{display:block;padding:0 10px 0 0}table.responsive-table thead tr th:before{content:\"\\A0\"}table.responsive-table tbody{display:block;width:auto;position:relative;overflow-x:auto;white-space:nowrap}table.responsive-table tbody tr{display:inline-block;vertical-align:top}table.responsive-table th{display:block;text-align:right}table.responsive-table td{display:block;min-height:1.25em;text-align:left}table.responsive-table tr{border-bottom:none;padding:0 10px}table.responsive-table thead{border:0;border-right:1px solid rgba(0,0,0,.12)}}.collection{margin:.5rem 0 1rem;border:1px solid #e0e0e0;border-radius:2px;overflow:hidden;position:relative}.collection .collection-item{background-color:#fff;line-height:1.5rem;padding:10px 20px;margin:0;border-bottom:1px solid #e0e0e0}.collection .collection-item.avatar{min-height:84px;padding-left:72px;position:relative}.collection .collection-item.avatar:not(.circle-clipper)>.circle,.collection .collection-item.avatar :not(.circle-clipper)>.circle{position:absolute;width:42px;height:42px;overflow:hidden;left:15px;display:inline-block;vertical-align:middle}.collection .collection-item.avatar i.circle{font-size:18px;line-height:42px;color:#fff;background-color:#999;text-align:center}.collection .collection-item.avatar .title{font-size:16px}.collection .collection-item.avatar p{margin:0}.collection .collection-item.avatar .secondary-content{position:absolute;top:16px;right:16px}.collection .collection-item:last-child{border-bottom:none}.collection .collection-item.active{background-color:#26a69a;color:#eafaf9}.collection .collection-item.active .secondary-content{color:#fff}.collection a.collection-item{display:block;-webkit-transition:.25s;transition:.25s;color:#26a69a}.collection a.collection-item:not(.active):hover{background-color:#ddd}.collection.with-header .collection-header{background-color:#fff;border-bottom:1px solid #e0e0e0;padding:10px 20px}.collection.with-header .collection-item{padding-left:30px}.collection.with-header .collection-item.avatar{padding-left:72px}.secondary-content{float:right;color:#26a69a}.collapsible .collection{margin:0;border:none}.video-container{position:relative;padding-bottom:56.25%;height:0;overflow:hidden}.video-container embed,.video-container iframe,.video-container object{position:absolute;top:0;left:0;width:100%;height:100%}.progress{position:relative;height:4px;display:block;width:100%;background-color:#acece6;border-radius:2px;margin:.5rem 0 1rem;overflow:hidden}.progress .determinate{position:absolute;top:0;left:0;bottom:0;-webkit-transition:width .3s linear;transition:width .3s linear}.progress .determinate,.progress .indeterminate{background-color:#26a69a}.progress .indeterminate:before{-webkit-animation:indeterminate 2.1s cubic-bezier(.65,.815,.735,.395) infinite;animation:indeterminate 2.1s cubic-bezier(.65,.815,.735,.395) infinite}.progress .indeterminate:after,.progress .indeterminate:before{content:\"\";position:absolute;background-color:inherit;top:0;left:0;bottom:0;will-change:left,right}.progress .indeterminate:after{-webkit-animation:indeterminate-short 2.1s cubic-bezier(.165,.84,.44,1) infinite;animation:indeterminate-short 2.1s cubic-bezier(.165,.84,.44,1) infinite;-webkit-animation-delay:1.15s;animation-delay:1.15s}@-webkit-keyframes indeterminate{0%{left:-35%;right:100%}60%{left:100%;right:-90%}to{left:100%;right:-90%}}@keyframes indeterminate{0%{left:-35%;right:100%}60%{left:100%;right:-90%}to{left:100%;right:-90%}}@-webkit-keyframes indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}@keyframes indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}.hide{display:none!important}.left-align{text-align:left}.right-align{text-align:right}.center,.center-align{text-align:center}.left{float:left!important}.right{float:right!important}.no-select,input[type=range],input[type=range]+.thumb{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.circle{border-radius:50%}.center-block{display:block;margin-left:auto;margin-right:auto}.truncate{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.no-padding{padding:0!important}span.badge{min-width:3rem;padding:0 6px;margin-left:14px;text-align:center;font-size:1rem;line-height:22px;height:22px;color:#757575;float:right;-webkit-box-sizing:border-box;box-sizing:border-box}span.badge.new{font-weight:300;font-size:.8rem;color:#fff;background-color:#26a69a;border-radius:2px}span.badge.new:after{content:\" new\"}span.badge[data-badge-caption]:after{content:\" \" attr(data-badge-caption)}nav ul a span.badge{display:inline-block;float:none;margin-left:4px;line-height:22px;height:22px;-webkit-font-smoothing:auto}.collection-item span.badge{margin-top:calc(.75rem - 11px)}.collapsible span.badge{margin-left:auto}.sidenav span.badge{margin-top:13px}table span.badge{display:inline-block;float:none;margin-left:auto}.material-icons{text-rendering:optimizeLegibility;-webkit-font-feature-settings:\"liga\";-moz-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.container{margin:0 auto;max-width:1280px;width:90%}@media only screen and (min-width:601px){.container{width:85%}}@media only screen and (min-width:993px){.container{width:70%}}.col .row{margin-left:-.75rem;margin-right:-.75rem}.section{padding-top:1rem;padding-bottom:1rem}.section.no-pad{padding:0}.section.no-pad-bot{padding-bottom:0}.section.no-pad-top{padding-top:0}.row{margin-left:auto;margin-right:auto;margin-bottom:20px}.row:after{content:\"\";display:table;clear:both}.row .col{float:left;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 .75rem;min-height:1px}.row .col[class*=pull-],.row .col[class*=push-]{position:relative}.row .col.s1{width:8.3333333333%}.row .col.s1,.row .col.s2{margin-left:auto;left:auto;right:auto}.row .col.s2{width:16.6666666667%}.row .col.s3{width:25%}.row .col.s3,.row .col.s4{margin-left:auto;left:auto;right:auto}.row .col.s4{width:33.3333333333%}.row .col.s5{width:41.6666666667%}.row .col.s5,.row .col.s6{margin-left:auto;left:auto;right:auto}.row .col.s6{width:50%}.row .col.s7{width:58.3333333333%}.row .col.s7,.row .col.s8{margin-left:auto;left:auto;right:auto}.row .col.s8{width:66.6666666667%}.row .col.s9{width:75%}.row .col.s9,.row .col.s10{margin-left:auto;left:auto;right:auto}.row .col.s10{width:83.3333333333%}.row .col.s11{width:91.6666666667%}.row .col.s11,.row .col.s12{margin-left:auto;left:auto;right:auto}.row .col.s12{width:100%}.row .col.offset-s1{margin-left:8.3333333333%}.row .col.pull-s1{right:8.3333333333%}.row .col.push-s1{left:8.3333333333%}.row .col.offset-s2{margin-left:16.6666666667%}.row .col.pull-s2{right:16.6666666667%}.row .col.push-s2{left:16.6666666667%}.row .col.offset-s3{margin-left:25%}.row .col.pull-s3{right:25%}.row .col.push-s3{left:25%}.row .col.offset-s4{margin-left:33.3333333333%}.row .col.pull-s4{right:33.3333333333%}.row .col.push-s4{left:33.3333333333%}.row .col.offset-s5{margin-left:41.6666666667%}.row .col.pull-s5{right:41.6666666667%}.row .col.push-s5{left:41.6666666667%}.row .col.offset-s6{margin-left:50%}.row .col.pull-s6{right:50%}.row .col.push-s6{left:50%}.row .col.offset-s7{margin-left:58.3333333333%}.row .col.pull-s7{right:58.3333333333%}.row .col.push-s7{left:58.3333333333%}.row .col.offset-s8{margin-left:66.6666666667%}.row .col.pull-s8{right:66.6666666667%}.row .col.push-s8{left:66.6666666667%}.row .col.offset-s9{margin-left:75%}.row .col.pull-s9{right:75%}.row .col.push-s9{left:75%}.row .col.offset-s10{margin-left:83.3333333333%}.row .col.pull-s10{right:83.3333333333%}.row .col.push-s10{left:83.3333333333%}.row .col.offset-s11{margin-left:91.6666666667%}.row .col.pull-s11{right:91.6666666667%}.row .col.push-s11{left:91.6666666667%}.row .col.offset-s12{margin-left:100%}.row .col.pull-s12{right:100%}.row .col.push-s12{left:100%}@media only screen and (min-width:601px){.row .col.m1{width:8.3333333333%}.row .col.m1,.row .col.m2{margin-left:auto;left:auto;right:auto}.row .col.m2{width:16.6666666667%}.row .col.m3{width:25%}.row .col.m3,.row .col.m4{margin-left:auto;left:auto;right:auto}.row .col.m4{width:33.3333333333%}.row .col.m5{width:41.6666666667%}.row .col.m5,.row .col.m6{margin-left:auto;left:auto;right:auto}.row .col.m6{width:50%}.row .col.m7{width:58.3333333333%}.row .col.m7,.row .col.m8{margin-left:auto;left:auto;right:auto}.row .col.m8{width:66.6666666667%}.row .col.m9{width:75%}.row .col.m9,.row .col.m10{margin-left:auto;left:auto;right:auto}.row .col.m10{width:83.3333333333%}.row .col.m11{width:91.6666666667%}.row .col.m11,.row .col.m12{margin-left:auto;left:auto;right:auto}.row .col.m12{width:100%}.row .col.offset-m1{margin-left:8.3333333333%}.row .col.pull-m1{right:8.3333333333%}.row .col.push-m1{left:8.3333333333%}.row .col.offset-m2{margin-left:16.6666666667%}.row .col.pull-m2{right:16.6666666667%}.row .col.push-m2{left:16.6666666667%}.row .col.offset-m3{margin-left:25%}.row .col.pull-m3{right:25%}.row .col.push-m3{left:25%}.row .col.offset-m4{margin-left:33.3333333333%}.row .col.pull-m4{right:33.3333333333%}.row .col.push-m4{left:33.3333333333%}.row .col.offset-m5{margin-left:41.6666666667%}.row .col.pull-m5{right:41.6666666667%}.row .col.push-m5{left:41.6666666667%}.row .col.offset-m6{margin-left:50%}.row .col.pull-m6{right:50%}.row .col.push-m6{left:50%}.row .col.offset-m7{margin-left:58.3333333333%}.row .col.pull-m7{right:58.3333333333%}.row .col.push-m7{left:58.3333333333%}.row .col.offset-m8{margin-left:66.6666666667%}.row .col.pull-m8{right:66.6666666667%}.row .col.push-m8{left:66.6666666667%}.row .col.offset-m9{margin-left:75%}.row .col.pull-m9{right:75%}.row .col.push-m9{left:75%}.row .col.offset-m10{margin-left:83.3333333333%}.row .col.pull-m10{right:83.3333333333%}.row .col.push-m10{left:83.3333333333%}.row .col.offset-m11{margin-left:91.6666666667%}.row .col.pull-m11{right:91.6666666667%}.row .col.push-m11{left:91.6666666667%}.row .col.offset-m12{margin-left:100%}.row .col.pull-m12{right:100%}.row .col.push-m12{left:100%}}@media only screen and (min-width:993px){.row .col.l1{width:8.3333333333%}.row .col.l1,.row .col.l2{margin-left:auto;left:auto;right:auto}.row .col.l2{width:16.6666666667%}.row .col.l3{width:25%}.row .col.l3,.row .col.l4{margin-left:auto;left:auto;right:auto}.row .col.l4{width:33.3333333333%}.row .col.l5{width:41.6666666667%}.row .col.l5,.row .col.l6{margin-left:auto;left:auto;right:auto}.row .col.l6{width:50%}.row .col.l7{width:58.3333333333%}.row .col.l7,.row .col.l8{margin-left:auto;left:auto;right:auto}.row .col.l8{width:66.6666666667%}.row .col.l9{width:75%}.row .col.l9,.row .col.l10{margin-left:auto;left:auto;right:auto}.row .col.l10{width:83.3333333333%}.row .col.l11{width:91.6666666667%}.row .col.l11,.row .col.l12{margin-left:auto;left:auto;right:auto}.row .col.l12{width:100%}.row .col.offset-l1{margin-left:8.3333333333%}.row .col.pull-l1{right:8.3333333333%}.row .col.push-l1{left:8.3333333333%}.row .col.offset-l2{margin-left:16.6666666667%}.row .col.pull-l2{right:16.6666666667%}.row .col.push-l2{left:16.6666666667%}.row .col.offset-l3{margin-left:25%}.row .col.pull-l3{right:25%}.row .col.push-l3{left:25%}.row .col.offset-l4{margin-left:33.3333333333%}.row .col.pull-l4{right:33.3333333333%}.row .col.push-l4{left:33.3333333333%}.row .col.offset-l5{margin-left:41.6666666667%}.row .col.pull-l5{right:41.6666666667%}.row .col.push-l5{left:41.6666666667%}.row .col.offset-l6{margin-left:50%}.row .col.pull-l6{right:50%}.row .col.push-l6{left:50%}.row .col.offset-l7{margin-left:58.3333333333%}.row .col.pull-l7{right:58.3333333333%}.row .col.push-l7{left:58.3333333333%}.row .col.offset-l8{margin-left:66.6666666667%}.row .col.pull-l8{right:66.6666666667%}.row .col.push-l8{left:66.6666666667%}.row .col.offset-l9{margin-left:75%}.row .col.pull-l9{right:75%}.row .col.push-l9{left:75%}.row .col.offset-l10{margin-left:83.3333333333%}.row .col.pull-l10{right:83.3333333333%}.row .col.push-l10{left:83.3333333333%}.row .col.offset-l11{margin-left:91.6666666667%}.row .col.pull-l11{right:91.6666666667%}.row .col.push-l11{left:91.6666666667%}.row .col.offset-l12{margin-left:100%}.row .col.pull-l12{right:100%}.row .col.push-l12{left:100%}}@media only screen and (min-width:1201px){.row .col.xl1{width:8.3333333333%}.row .col.xl1,.row .col.xl2{margin-left:auto;left:auto;right:auto}.row .col.xl2{width:16.6666666667%}.row .col.xl3{width:25%}.row .col.xl3,.row .col.xl4{margin-left:auto;left:auto;right:auto}.row .col.xl4{width:33.3333333333%}.row .col.xl5{width:41.6666666667%}.row .col.xl5,.row .col.xl6{margin-left:auto;left:auto;right:auto}.row .col.xl6{width:50%}.row .col.xl7{width:58.3333333333%}.row .col.xl7,.row .col.xl8{margin-left:auto;left:auto;right:auto}.row .col.xl8{width:66.6666666667%}.row .col.xl9{width:75%}.row .col.xl9,.row .col.xl10{margin-left:auto;left:auto;right:auto}.row .col.xl10{width:83.3333333333%}.row .col.xl11{width:91.6666666667%}.row .col.xl11,.row .col.xl12{margin-left:auto;left:auto;right:auto}.row .col.xl12{width:100%}.row .col.offset-xl1{margin-left:8.3333333333%}.row .col.pull-xl1{right:8.3333333333%}.row .col.push-xl1{left:8.3333333333%}.row .col.offset-xl2{margin-left:16.6666666667%}.row .col.pull-xl2{right:16.6666666667%}.row .col.push-xl2{left:16.6666666667%}.row .col.offset-xl3{margin-left:25%}.row .col.pull-xl3{right:25%}.row .col.push-xl3{left:25%}.row .col.offset-xl4{margin-left:33.3333333333%}.row .col.pull-xl4{right:33.3333333333%}.row .col.push-xl4{left:33.3333333333%}.row .col.offset-xl5{margin-left:41.6666666667%}.row .col.pull-xl5{right:41.6666666667%}.row .col.push-xl5{left:41.6666666667%}.row .col.offset-xl6{margin-left:50%}.row .col.pull-xl6{right:50%}.row .col.push-xl6{left:50%}.row .col.offset-xl7{margin-left:58.3333333333%}.row .col.pull-xl7{right:58.3333333333%}.row .col.push-xl7{left:58.3333333333%}.row .col.offset-xl8{margin-left:66.6666666667%}.row .col.pull-xl8{right:66.6666666667%}.row .col.push-xl8{left:66.6666666667%}.row .col.offset-xl9{margin-left:75%}.row .col.pull-xl9{right:75%}.row .col.push-xl9{left:75%}.row .col.offset-xl10{margin-left:83.3333333333%}.row .col.pull-xl10{right:83.3333333333%}.row .col.push-xl10{left:83.3333333333%}.row .col.offset-xl11{margin-left:91.6666666667%}.row .col.pull-xl11{right:91.6666666667%}.row .col.push-xl11{left:91.6666666667%}.row .col.offset-xl12{margin-left:100%}.row .col.pull-xl12{right:100%}.row .col.push-xl12{left:100%}}nav{color:#fff;background-color:#ee6e73;width:100%;height:56px;line-height:56px}nav.nav-extended{height:auto}nav.nav-extended .nav-wrapper{min-height:56px;height:auto}nav.nav-extended .nav-content{position:relative;line-height:normal}nav a{color:#fff}nav [class*=mdi-],nav [class^=mdi-],nav i,nav i.material-icons{display:block;font-size:24px;height:56px;line-height:56px}nav .nav-wrapper{position:relative;height:100%}@media only screen and (min-width:993px){nav a.sidenav-trigger{display:none}}nav .sidenav-trigger{float:left;position:relative;z-index:1;height:56px;margin:0 18px}nav .sidenav-trigger i{height:56px;line-height:56px}nav .brand-logo{position:absolute;color:#fff;display:inline-block;font-size:2.1rem;padding:0}nav .brand-logo.center{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}@media only screen and (max-width:992px){nav .brand-logo{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}nav .brand-logo.left,nav .brand-logo.right{padding:0;-webkit-transform:none;transform:none}nav .brand-logo.left{left:.5rem}nav .brand-logo.right{right:.5rem;left:auto}}nav .brand-logo.right{right:.5rem;padding:0}nav .brand-logo [class*=mdi-],nav .brand-logo [class^=mdi-],nav .brand-logo i,nav .brand-logo i.material-icons{float:left;margin-right:15px}nav .nav-title{display:inline-block;font-size:32px;padding:28px 0}nav ul{margin:0}nav ul li{-webkit-transition:background-color .3s;transition:background-color .3s;float:left;padding:0}nav ul li.active{background-color:rgba(0,0,0,.1)}nav ul a{-webkit-transition:background-color .3s;transition:background-color .3s;font-size:1rem;color:#fff;display:block;padding:0 15px;cursor:pointer}nav ul a.btn,nav ul a.btn-flat,nav ul a.btn-floating,nav ul a.btn-large,nav ul a.btn-small{margin-top:-2px;margin-left:15px;margin-right:15px}nav ul a.btn-flat>.material-icons,nav ul a.btn-floating>.material-icons,nav ul a.btn-large>.material-icons,nav ul a.btn-small>.material-icons,nav ul a.btn>.material-icons{height:inherit;line-height:inherit}nav ul a:hover{background-color:rgba(0,0,0,.1)}nav ul.left{float:left}nav form{height:100%}nav .input-field{margin:0;height:100%}nav .input-field input{height:100%;font-size:1.2rem;border:none;padding-left:2rem}nav .input-field input:focus,nav .input-field input[type=date]:valid,nav .input-field input[type=email]:valid,nav .input-field input[type=password]:valid,nav .input-field input[type=text]:valid,nav .input-field input[type=url]:valid{border:none;-webkit-box-shadow:none;box-shadow:none}nav .input-field label{top:0;left:0}nav .input-field label i{color:hsla(0,0%,100%,.7);-webkit-transition:color .3s;transition:color .3s}nav .input-field label.active i{color:#fff}.navbar-fixed{position:relative;height:56px;z-index:997}.navbar-fixed nav{position:fixed}@media only screen and (min-width:601px){nav.nav-extended .nav-wrapper{min-height:64px}nav,nav .nav-wrapper i,nav a.sidenav-trigger,nav a.sidenav-trigger i{height:64px;line-height:64px}.navbar-fixed{height:64px}}a{text-decoration:none}html{line-height:1.5;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif;font-weight:400;color:rgba(0,0,0,.87)}@media only screen and (min-width:0){html{font-size:14px}}@media only screen and (min-width:992px){html{font-size:14.5px}}@media only screen and (min-width:1200px){html{font-size:15px}}h1,h2,h3,h4,h5,h6{font-weight:400;line-height:1.3}h1 a,h2 a,h3 a,h4 a,h5 a,h6 a{font-weight:inherit}h1{font-size:4.2rem;margin:2.8rem 0 1.68rem}h1,h2{line-height:110%}h2{font-size:3.56rem;margin:2.3733333333rem 0 1.424rem}h3{font-size:2.92rem;margin:1.9466666667rem 0 1.168rem}h3,h4{line-height:110%}h4{font-size:2.28rem;margin:1.52rem 0 .912rem}h5{font-size:1.64rem;margin:1.0933333333rem 0 .656rem}h5,h6{line-height:110%}h6{font-size:1.15rem;margin:.7666666667rem 0 .46rem}em{font-style:italic}strong{font-weight:500}small{font-size:75%}.light{font-weight:300}.thin{font-weight:200}@media only screen and (min-width:360px){.flow-text{font-size:1.2rem}}@media only screen and (min-width:390px){.flow-text{font-size:1.224rem}}@media only screen and (min-width:420px){.flow-text{font-size:1.248rem}}@media only screen and (min-width:450px){.flow-text{font-size:1.272rem}}@media only screen and (min-width:480px){.flow-text{font-size:1.296rem}}@media only screen and (min-width:510px){.flow-text{font-size:1.32rem}}@media only screen and (min-width:540px){.flow-text{font-size:1.344rem}}@media only screen and (min-width:570px){.flow-text{font-size:1.368rem}}@media only screen and (min-width:600px){.flow-text{font-size:1.392rem}}@media only screen and (min-width:630px){.flow-text{font-size:1.416rem}}@media only screen and (min-width:660px){.flow-text{font-size:1.44rem}}@media only screen and (min-width:690px){.flow-text{font-size:1.464rem}}@media only screen and (min-width:720px){.flow-text{font-size:1.488rem}}@media only screen and (min-width:750px){.flow-text{font-size:1.512rem}}@media only screen and (min-width:780px){.flow-text{font-size:1.536rem}}@media only screen and (min-width:810px){.flow-text{font-size:1.56rem}}@media only screen and (min-width:840px){.flow-text{font-size:1.584rem}}@media only screen and (min-width:870px){.flow-text{font-size:1.608rem}}@media only screen and (min-width:900px){.flow-text{font-size:1.632rem}}@media only screen and (min-width:930px){.flow-text{font-size:1.656rem}}@media only screen and (min-width:960px){.flow-text{font-size:1.68rem}}@media only screen and (max-width:360px){.flow-text{font-size:1.2rem}}.scale-transition{-webkit-transition:-webkit-transform .3s cubic-bezier(.53,.01,.36,1.63)!important;transition:-webkit-transform .3s cubic-bezier(.53,.01,.36,1.63)!important;transition:transform .3s cubic-bezier(.53,.01,.36,1.63)!important;transition:transform .3s cubic-bezier(.53,.01,.36,1.63),-webkit-transform .3s cubic-bezier(.53,.01,.36,1.63)!important}.scale-transition.scale-out{-webkit-transform:scale(0);transform:scale(0);-webkit-transition:-webkit-transform .2s!important;transition:-webkit-transform .2s!important;transition:transform .2s!important;transition:transform .2s,-webkit-transform .2s!important}.scale-transition.scale-in{-webkit-transform:scale(1);transform:scale(1)}.card-panel{padding:24px}.card,.card-panel{-webkit-transition:-webkit-box-shadow .25s;transition:-webkit-box-shadow .25s;transition:box-shadow .25s;transition:box-shadow .25s,-webkit-box-shadow .25s;margin:.5rem 0 1rem;border-radius:2px;background-color:#fff}.card{position:relative}.card .card-title{font-size:24px;font-weight:300}.card .card-title.activator{cursor:pointer}.card.large,.card.medium,.card.small{position:relative}.card.large .card-image,.card.medium .card-image,.card.small .card-image{max-height:60%;overflow:hidden}.card.large .card-image+.card-content,.card.medium .card-image+.card-content,.card.small .card-image+.card-content{max-height:40%}.card.large .card-content,.card.medium .card-content,.card.small .card-content{max-height:100%;overflow:hidden}.card.large .card-action,.card.medium .card-action,.card.small .card-action{position:absolute;bottom:0;left:0;right:0}.card.small{height:300px}.card.medium{height:400px}.card.large{height:500px}.card.horizontal{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.card.horizontal.large .card-image,.card.horizontal.medium .card-image,.card.horizontal.small .card-image{height:100%;max-height:none;overflow:visible}.card.horizontal.large .card-image img,.card.horizontal.medium .card-image img,.card.horizontal.small .card-image img{height:100%}.card.horizontal .card-image{max-width:50%}.card.horizontal .card-image img{border-radius:2px 0 0 2px;max-width:100%;width:auto}.card.horizontal .card-stacked{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;position:relative}.card.horizontal .card-stacked .card-content{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1}.card.sticky-action .card-action{z-index:2}.card.sticky-action .card-reveal{z-index:1;padding-bottom:64px}.card .card-image{position:relative}.card .card-image img{display:block;border-radius:2px 2px 0 0;position:relative;left:0;right:0;top:0;bottom:0;width:100%}.card .card-image .card-title{color:#fff;position:absolute;bottom:0;left:0;max-width:100%;padding:24px}.card .card-content{padding:24px;border-radius:0 0 2px 2px}.card .card-content p{margin:0}.card .card-content .card-title{display:block;line-height:32px;margin-bottom:8px}.card .card-content .card-title i{line-height:32px}.card .card-action{background-color:inherit;border-top:1px solid hsla(0,0%,63%,.2);position:relative;padding:16px 24px}.card .card-action:last-child{border-radius:0 0 2px 2px}.card .card-action a:not(.btn):not(.btn-large):not(.btn-small):not(.btn-large):not(.btn-floating){color:#ffab40;margin-right:24px;-webkit-transition:color .3s ease;transition:color .3s ease;text-transform:uppercase}.card .card-action a:not(.btn):not(.btn-large):not(.btn-small):not(.btn-large):not(.btn-floating):hover{color:#ffd8a6}.card .card-reveal{padding:24px;position:absolute;background-color:#fff;width:100%;overflow-y:auto;left:0;top:100%;height:100%;z-index:3;display:none}.card .card-reveal .card-title{cursor:pointer;display:block}#toast-container{display:block;position:fixed;z-index:10000}@media only screen and (max-width:600px){#toast-container{min-width:100%;bottom:0}}@media only screen and (min-width:601px) and (max-width:992px){#toast-container{left:5%;bottom:7%;max-width:90%}}@media only screen and (min-width:993px){#toast-container{top:10%;right:7%;max-width:86%}}.toast{border-radius:2px;top:35px;width:auto;margin-top:10px;position:relative;max-width:100%;height:auto;min-height:48px;line-height:1.5em;background-color:#323232;padding:10px 25px;font-size:1.1rem;font-weight:300;color:#fff;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;cursor:default}.toast .toast-action{color:#eeff41;font-weight:500;margin-right:-25px;margin-left:3rem}.toast.rounded{border-radius:24px}@media only screen and (max-width:600px){.toast{width:100%;border-radius:0}}.tabs{position:relative;overflow-x:auto;overflow-y:hidden;height:48px;width:100%;background-color:#fff;margin:0 auto;white-space:nowrap}.tabs.tabs-transparent{background-color:transparent}.tabs.tabs-transparent .tab.disabled a,.tabs.tabs-transparent .tab.disabled a:hover,.tabs.tabs-transparent .tab a{color:hsla(0,0%,100%,.7)}.tabs.tabs-transparent .tab a.active,.tabs.tabs-transparent .tab a:hover{color:#fff}.tabs.tabs-transparent .indicator{background-color:#fff}.tabs.tabs-fixed-width{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.tabs.tabs-fixed-width .tab{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1}.tabs .tab{display:inline-block;text-align:center;line-height:48px;height:48px;padding:0;margin:0;text-transform:uppercase}.tabs .tab a{color:rgba(238,110,115,.7);display:block;width:100%;height:100%;padding:0 24px;font-size:14px;text-overflow:ellipsis;overflow:hidden;-webkit-transition:color .28s ease,background-color .28s ease;transition:color .28s ease,background-color .28s ease}.tabs .tab a:focus,.tabs .tab a:focus.active{background-color:rgba(246,178,181,.2);outline:none}.tabs .tab a.active,.tabs .tab a:hover{background-color:transparent;color:#ee6e73}.tabs .tab.disabled a,.tabs .tab.disabled a:hover{color:rgba(238,110,115,.4);cursor:default}.tabs .indicator{position:absolute;bottom:0;height:2px;background-color:#f6b2b5;will-change:left,right}@media only screen and (max-width:992px){.tabs{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.tabs .tab{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1}.tabs .tab a{padding:0 12px}}.material-tooltip{padding:10px 8px;font-size:1rem;z-index:2000;background-color:transparent;border-radius:2px;color:#fff;min-height:36px;line-height:120%;text-align:center;max-width:calc(100% - 4px);overflow:hidden;left:0;top:0;pointer-events:none}.backdrop,.material-tooltip{opacity:0;position:absolute;visibility:hidden;background-color:#323232}.backdrop{height:7px;width:14px;border-radius:0 0 50% 50%;z-index:-1;-webkit-transform-origin:50% 0;transform-origin:50% 0}.btn,.btn-flat,.btn-large,.btn-small{border:none;border-radius:2px;display:inline-block;height:36px;line-height:36px;padding:0 16px;text-transform:uppercase;vertical-align:middle;-webkit-tap-highlight-color:transparent}.btn-flat.disabled,.btn-flat:disabled,.btn-flat[disabled],.btn-floating.disabled,.btn-floating:disabled,.btn-floating[disabled],.btn-large.disabled,.btn-large:disabled,.btn-large[disabled],.btn-small.disabled,.btn-small:disabled,.btn-small[disabled],.btn.disabled,.btn:disabled,.btn[disabled],.disabled.btn-large,.disabled.btn-small{pointer-events:none;background-color:#dfdfdf!important;-webkit-box-shadow:none;box-shadow:none;color:#9f9f9f!important;cursor:default}.btn-flat.disabled:hover,.btn-flat:disabled:hover,.btn-flat[disabled]:hover,.btn-floating.disabled:hover,.btn-floating:disabled:hover,.btn-floating[disabled]:hover,.btn-large.disabled:hover,.btn-large:disabled:hover,.btn-large[disabled]:hover,.btn-small.disabled:hover,.btn-small:disabled:hover,.btn-small[disabled]:hover,.btn.disabled:hover,.btn:disabled:hover,.btn[disabled]:hover,.disabled.btn-large:hover,.disabled.btn-small:hover{background-color:#dfdfdf!important;color:#9f9f9f!important}.btn,.btn-flat,.btn-floating,.btn-large,.btn-small{font-size:14px;outline:0}.btn-flat i,.btn-floating i,.btn-large i,.btn-small i,.btn i{font-size:1.3rem;line-height:inherit}.btn-floating:focus,.btn-large:focus,.btn-small:focus,.btn:focus{background-color:#1d7d74}.btn,.btn-large,.btn-small{text-decoration:none;color:#fff;background-color:#26a69a;text-align:center;letter-spacing:.5px;-webkit-transition:background-color .2s ease-out;transition:background-color .2s ease-out;cursor:pointer}.btn-large:hover,.btn-small:hover,.btn:hover{background-color:#2bbbad}.btn-floating{display:inline-block;color:#fff;position:relative;overflow:hidden;z-index:1;width:40px;height:40px;line-height:40px;padding:0;border-radius:50%;-webkit-transition:background-color .3s;transition:background-color .3s;cursor:pointer;vertical-align:middle}.btn-floating,.btn-floating:hover{background-color:#26a69a}.btn-floating:before{border-radius:0}.btn-floating.btn-large{width:56px;height:56px;padding:0}.btn-floating.btn-large.halfway-fab{bottom:-28px}.btn-floating.btn-large i{line-height:56px}.btn-floating.btn-small{width:32.4px;height:32.4px}.btn-floating.btn-small.halfway-fab{bottom:-16.2px}.btn-floating.btn-small i{line-height:32.4px}.btn-floating.halfway-fab{position:absolute;right:24px;bottom:-20px}.btn-floating.halfway-fab.left{right:auto;left:24px}.btn-floating i{width:inherit;display:inline-block;text-align:center;color:#fff;font-size:1.6rem;line-height:40px}button.btn-floating{border:none}.fixed-action-btn{position:fixed;right:23px;bottom:23px;padding-top:15px;margin-bottom:0;z-index:997}.fixed-action-btn.active ul{visibility:visible}.fixed-action-btn.direction-left,.fixed-action-btn.direction-right{padding:0 0 0 15px}.fixed-action-btn.direction-left ul,.fixed-action-btn.direction-right ul{text-align:right;right:64px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);height:100%;left:auto;width:500px}.fixed-action-btn.direction-left ul li,.fixed-action-btn.direction-right ul li{display:inline-block;margin:7.5px 15px 0 0}.fixed-action-btn.direction-right{padding:0 15px 0 0}.fixed-action-btn.direction-right ul{text-align:left;direction:rtl;left:64px;right:auto}.fixed-action-btn.direction-right ul li{margin:7.5px 0 0 15px}.fixed-action-btn.direction-bottom{padding:0 0 15px}.fixed-action-btn.direction-bottom ul{top:64px;bottom:auto;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.fixed-action-btn.direction-bottom ul li{margin:15px 0 0}.fixed-action-btn.toolbar{padding:0;height:56px}.fixed-action-btn.toolbar.active>a i{opacity:0}.fixed-action-btn.toolbar ul{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;top:0;bottom:0;z-index:1}.fixed-action-btn.toolbar ul li{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;display:inline-block;margin:0;height:100%;-webkit-transition:none;transition:none}.fixed-action-btn.toolbar ul li a{display:block;overflow:hidden;position:relative;width:100%;height:100%;background-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#fff;line-height:56px;z-index:1}.fixed-action-btn.toolbar ul li a i{line-height:inherit}.fixed-action-btn ul{left:0;right:0;text-align:center;position:absolute;bottom:64px;margin:0;visibility:hidden}.fixed-action-btn ul li{margin-bottom:15px}.fixed-action-btn ul a.btn-floating{opacity:0}.fixed-action-btn .fab-backdrop{position:absolute;top:0;left:0;z-index:-1;width:40px;height:40px;background-color:#26a69a;border-radius:50%;-webkit-transform:scale(0);transform:scale(0)}.btn-flat{background-color:transparent;color:#343434;cursor:pointer;-webkit-transition:background-color .2s;transition:background-color .2s}.btn-flat,.btn-flat:focus,.btn-flat:hover{-webkit-box-shadow:none;box-shadow:none}.btn-flat:focus{background-color:rgba(0,0,0,.1)}.btn-flat.btn-flat[disabled],.btn-flat.disabled{background-color:transparent!important;color:#b3b2b2!important;cursor:default}.btn-large{height:54px;line-height:54px;font-size:15px;padding:0 28px}.btn-large i{font-size:1.6rem}.btn-small{height:32.4px;line-height:32.4px;font-size:13px}.btn-small i{font-size:1.2rem}.btn-block{display:block}.dropdown-content{background-color:#fff;margin:0;display:none;min-width:100px;overflow-y:auto;opacity:0;position:absolute;left:0;top:0;z-index:9999;-webkit-transform-origin:0 0;transform-origin:0 0}.dropdown-content:focus{outline:0}.dropdown-content li{clear:both;color:rgba(0,0,0,.87);cursor:pointer;min-height:50px;line-height:1.5rem;width:100%;text-align:left}.dropdown-content li.active,.dropdown-content li:hover{background-color:#eee}.dropdown-content li:focus{outline:none}.dropdown-content li.divider{min-height:0;height:1px}.dropdown-content li>a,.dropdown-content li>span{font-size:16px;color:#26a69a;display:block;line-height:22px;padding:14px 16px}.dropdown-content li>span>label{top:1px;left:0;height:18px}.dropdown-content li>a>i{height:inherit;line-height:inherit;float:left;margin:0 24px 0 0;width:24px}body.keyboard-focused .dropdown-content li:focus{background-color:#dadada}.input-field.col .dropdown-content [type=checkbox]+label{top:1px;left:0;height:18px;-webkit-transform:none;transform:none}/*!\r\n * Waves v0.6.0\r\n * http://fian.my.id/Waves\r\n *\r\n * Copyright 2014 Alfiana E. Sibuea and other contributors\r\n * Released under the MIT license\r\n * https://github.com/fians/Waves/blob/master/LICENSE\r\n */.dropdown-trigger,.waves-effect{cursor:pointer}.waves-effect{position:relative;display:inline-block;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent;vertical-align:middle;z-index:1;-webkit-transition:.3s ease-out;transition:.3s ease-out}.waves-effect .waves-ripple{position:absolute;border-radius:50%;width:20px;height:20px;margin-top:-10px;margin-left:-10px;opacity:0;background:rgba(0,0,0,.2);-webkit-transition:all .7s ease-out;transition:all .7s ease-out;-webkit-transition-property:opacity,-webkit-transform;transition-property:opacity,-webkit-transform;transition-property:transform,opacity;transition-property:transform,opacity,-webkit-transform;-webkit-transform:scale(0);transform:scale(0);pointer-events:none}.waves-effect.waves-light .waves-ripple{background-color:hsla(0,0%,100%,.45)}.waves-effect.waves-red .waves-ripple{background-color:rgba(244,67,54,.7)}.waves-effect.waves-yellow .waves-ripple{background-color:rgba(255,235,59,.7)}.waves-effect.waves-orange .waves-ripple{background-color:rgba(255,152,0,.7)}.waves-effect.waves-purple .waves-ripple{background-color:rgba(156,39,176,.7)}.waves-effect.waves-green .waves-ripple{background-color:rgba(76,175,80,.7)}.waves-effect.waves-teal .waves-ripple{background-color:rgba(0,150,136,.7)}.waves-effect input[type=button],.waves-effect input[type=reset],.waves-effect input[type=submit]{border:0;font-style:normal;font-size:inherit;text-transform:inherit;background:none}.waves-effect img{position:relative;z-index:-1}.waves-notransition{-webkit-transition:none!important;transition:none!important}.waves-circle{-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-mask-image:-webkit-radial-gradient(circle,#fff 100%,#000 0)}.waves-input-wrapper{border-radius:.2em;vertical-align:bottom}.waves-input-wrapper .waves-button-input{position:relative;top:0;left:0;z-index:1}.waves-circle{text-align:center;width:2.5em;height:2.5em;line-height:2.5em;border-radius:50%;-webkit-mask-image:none}.waves-block{display:block}.waves-effect .waves-ripple{z-index:-1}.modal{display:none;position:fixed;left:0;right:0;background-color:#fafafa;padding:0;max-height:70%;width:55%;margin:auto;overflow-y:auto;border-radius:2px;will-change:top,opacity}.modal:focus{outline:none}@media only screen and (max-width:992px){.modal{width:80%}}.modal h1,.modal h2,.modal h3,.modal h4{margin-top:0}.modal .modal-content{padding:24px}.modal .modal-close{cursor:pointer}.modal .modal-footer{border-radius:0 0 2px 2px;background-color:#fafafa;padding:4px 6px;height:56px;width:100%;text-align:right}.modal .modal-footer .btn,.modal .modal-footer .btn-flat,.modal .modal-footer .btn-large,.modal .modal-footer .btn-small{margin:6px 0}.modal-overlay{position:fixed;z-index:999;top:-25%;left:0;bottom:0;right:0;height:125%;width:100%;background:#000;display:none;will-change:opacity}.modal.modal-fixed-footer{padding:0;height:70%}.modal.modal-fixed-footer .modal-content{position:absolute;height:calc(100% - 56px);max-height:100%;width:100%;overflow-y:auto}.modal.modal-fixed-footer .modal-footer{border-top:1px solid rgba(0,0,0,.1);position:absolute;bottom:0}.modal.bottom-sheet{top:auto;bottom:-100%;margin:0;width:100%;max-height:45%;border-radius:0;will-change:bottom,opacity}.collapsible{border-top:1px solid #ddd;border-right:1px solid #ddd;border-left:1px solid #ddd;margin:.5rem 0 1rem}.collapsible-header{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;cursor:pointer;-webkit-tap-highlight-color:transparent;line-height:1.5;padding:1rem;background-color:#fff;border-bottom:1px solid #ddd}.collapsible-header:focus{outline:0}.collapsible-header i{width:2rem;font-size:1.6rem;display:inline-block;text-align:center;margin-right:1rem}.keyboard-focused .collapsible-header:focus{background-color:#eee}.collapsible-body{display:none;border-bottom:1px solid #ddd;-webkit-box-sizing:border-box;box-sizing:border-box;padding:2rem}.sidenav .collapsible,.sidenav.fixed .collapsible{border:none;-webkit-box-shadow:none;box-shadow:none}.sidenav .collapsible li,.sidenav.fixed .collapsible li{padding:0}.sidenav .collapsible-header,.sidenav.fixed .collapsible-header{background-color:transparent;border:none;line-height:inherit;height:inherit;padding:0 16px}.sidenav .collapsible-header:hover,.sidenav.fixed .collapsible-header:hover{background-color:rgba(0,0,0,.05)}.sidenav .collapsible-header i,.sidenav.fixed .collapsible-header i{line-height:inherit}.sidenav .collapsible-body,.sidenav.fixed .collapsible-body{border:0;background-color:#fff}.sidenav .collapsible-body li a,.sidenav.fixed .collapsible-body li a{padding:0 23.5px 0 31px}.collapsible.popout{border:none;-webkit-box-shadow:none;box-shadow:none}.collapsible.popout>li{-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);margin:0 24px;-webkit-transition:margin .35s cubic-bezier(.25,.46,.45,.94);transition:margin .35s cubic-bezier(.25,.46,.45,.94)}.collapsible.popout>li.active{-webkit-box-shadow:0 5px 11px 0 rgba(0,0,0,.18),0 4px 15px 0 rgba(0,0,0,.15);box-shadow:0 5px 11px 0 rgba(0,0,0,.18),0 4px 15px 0 rgba(0,0,0,.15);margin:16px 0}.chip{display:inline-block;height:32px;font-size:13px;font-weight:500;color:rgba(0,0,0,.6);line-height:32px;padding:0 12px;border-radius:16px;background-color:#e4e4e4;margin-bottom:5px;margin-right:5px}.chip:focus{outline:none;background-color:#26a69a;color:#fff}.chip>img{float:left;margin:0 8px 0 -12px;height:32px;width:32px;border-radius:50%}.chip .close{cursor:pointer;float:right;font-size:16px;line-height:32px;padding-left:8px}.chips{border:none;border-bottom:1px solid #9e9e9e;-webkit-box-shadow:none;box-shadow:none;margin:0 0 8px;min-height:45px;outline:none;-webkit-transition:all .3s;transition:all .3s}.chips.focus{border-bottom:1px solid #26a69a;-webkit-box-shadow:0 1px 0 0 #26a69a;box-shadow:0 1px 0 0 #26a69a}.chips:hover{cursor:text}.chips .input{background:none;border:0;color:rgba(0,0,0,.6);display:inline-block;font-size:16px;height:3rem;line-height:32px;outline:0;margin:0;padding:0!important;width:120px!important}.chips .input:focus{border:0!important;-webkit-box-shadow:none!important;box-shadow:none!important}.chips .autocomplete-content{margin-top:0;margin-bottom:0}.prefix~.chips{margin-left:3rem;width:92%;width:calc(100% - 3rem)}.chips:empty~label{font-size:.8rem;-webkit-transform:translateY(-140%);transform:translateY(-140%)}.materialboxed{display:block;cursor:-webkit-zoom-in;cursor:zoom-in;position:relative;-webkit-transition:opacity .4s;transition:opacity .4s;-webkit-backface-visibility:hidden}.materialboxed:hover:not(.active){opacity:.8}.materialboxed.active{cursor:-webkit-zoom-out;cursor:zoom-out}#materialbox-overlay{top:0;right:0;background-color:#292929;will-change:opacity}#materialbox-overlay,.materialbox-caption{position:fixed;bottom:0;left:0;z-index:1000}.materialbox-caption{display:none;color:#fff;line-height:50px;width:100%;text-align:center;padding:0 15%;height:50px;-webkit-font-smoothing:antialiased}select:focus{outline:1px solid #c9f3ef}button:focus{outline:none;background-color:#2ab7a9}label{font-size:.8rem;color:#9e9e9e}::-webkit-input-placeholder{color:#d1d1d1}::-moz-placeholder{color:#d1d1d1}:-ms-input-placeholder,::-ms-input-placeholder{color:#d1d1d1}::placeholder{color:#d1d1d1}input:not([type]),input[type=date]:not(.browser-default),input[type=datetime-local]:not(.browser-default),input[type=datetime]:not(.browser-default),input[type=email]:not(.browser-default),input[type=number]:not(.browser-default),input[type=password]:not(.browser-default),input[type=search]:not(.browser-default),input[type=tel]:not(.browser-default),input[type=text]:not(.browser-default),input[type=time]:not(.browser-default),input[type=url]:not(.browser-default),textarea.materialize-textarea{background-color:transparent;border:none;border-bottom:1px solid #9e9e9e;border-radius:0;outline:none;height:3rem;width:100%;font-size:16px;margin:0 0 8px;padding:0;-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:content-box;box-sizing:content-box;-webkit-transition:border .3s,-webkit-box-shadow .3s;transition:border .3s,-webkit-box-shadow .3s;transition:box-shadow .3s,border .3s;transition:box-shadow .3s,border .3s,-webkit-box-shadow .3s}input:not([type]):disabled,input:not([type])[readonly=readonly],input[type=date]:not(.browser-default):disabled,input[type=date]:not(.browser-default)[readonly=readonly],input[type=datetime-local]:not(.browser-default):disabled,input[type=datetime-local]:not(.browser-default)[readonly=readonly],input[type=datetime]:not(.browser-default):disabled,input[type=datetime]:not(.browser-default)[readonly=readonly],input[type=email]:not(.browser-default):disabled,input[type=email]:not(.browser-default)[readonly=readonly],input[type=number]:not(.browser-default):disabled,input[type=number]:not(.browser-default)[readonly=readonly],input[type=password]:not(.browser-default):disabled,input[type=password]:not(.browser-default)[readonly=readonly],input[type=search]:not(.browser-default):disabled,input[type=search]:not(.browser-default)[readonly=readonly],input[type=tel]:not(.browser-default):disabled,input[type=tel]:not(.browser-default)[readonly=readonly],input[type=text]:not(.browser-default):disabled,input[type=text]:not(.browser-default)[readonly=readonly],input[type=time]:not(.browser-default):disabled,input[type=time]:not(.browser-default)[readonly=readonly],input[type=url]:not(.browser-default):disabled,input[type=url]:not(.browser-default)[readonly=readonly],textarea.materialize-textarea:disabled,textarea.materialize-textarea[readonly=readonly]{color:rgba(0,0,0,.42);border-bottom:1px dotted rgba(0,0,0,.42)}input:not([type]):disabled+label,input:not([type])[readonly=readonly]+label,input[type=date]:not(.browser-default):disabled+label,input[type=date]:not(.browser-default)[readonly=readonly]+label,input[type=datetime-local]:not(.browser-default):disabled+label,input[type=datetime-local]:not(.browser-default)[readonly=readonly]+label,input[type=datetime]:not(.browser-default):disabled+label,input[type=datetime]:not(.browser-default)[readonly=readonly]+label,input[type=email]:not(.browser-default):disabled+label,input[type=email]:not(.browser-default)[readonly=readonly]+label,input[type=number]:not(.browser-default):disabled+label,input[type=number]:not(.browser-default)[readonly=readonly]+label,input[type=password]:not(.browser-default):disabled+label,input[type=password]:not(.browser-default)[readonly=readonly]+label,input[type=search]:not(.browser-default):disabled+label,input[type=search]:not(.browser-default)[readonly=readonly]+label,input[type=tel]:not(.browser-default):disabled+label,input[type=tel]:not(.browser-default)[readonly=readonly]+label,input[type=text]:not(.browser-default):disabled+label,input[type=text]:not(.browser-default)[readonly=readonly]+label,input[type=time]:not(.browser-default):disabled+label,input[type=time]:not(.browser-default)[readonly=readonly]+label,input[type=url]:not(.browser-default):disabled+label,input[type=url]:not(.browser-default)[readonly=readonly]+label,textarea.materialize-textarea:disabled+label,textarea.materialize-textarea[readonly=readonly]+label{color:rgba(0,0,0,.42)}input:not([type]):focus:not([readonly]),input[type=date]:not(.browser-default):focus:not([readonly]),input[type=datetime-local]:not(.browser-default):focus:not([readonly]),input[type=datetime]:not(.browser-default):focus:not([readonly]),input[type=email]:not(.browser-default):focus:not([readonly]),input[type=number]:not(.browser-default):focus:not([readonly]),input[type=password]:not(.browser-default):focus:not([readonly]),input[type=search]:not(.browser-default):focus:not([readonly]),input[type=tel]:not(.browser-default):focus:not([readonly]),input[type=text]:not(.browser-default):focus:not([readonly]),input[type=time]:not(.browser-default):focus:not([readonly]),input[type=url]:not(.browser-default):focus:not([readonly]),textarea.materialize-textarea:focus:not([readonly]){border-bottom:1px solid #26a69a;-webkit-box-shadow:0 1px 0 0 #26a69a;box-shadow:0 1px 0 0 #26a69a}input:not([type]):focus:not([readonly])+label,input[type=date]:not(.browser-default):focus:not([readonly])+label,input[type=datetime-local]:not(.browser-default):focus:not([readonly])+label,input[type=datetime]:not(.browser-default):focus:not([readonly])+label,input[type=email]:not(.browser-default):focus:not([readonly])+label,input[type=number]:not(.browser-default):focus:not([readonly])+label,input[type=password]:not(.browser-default):focus:not([readonly])+label,input[type=search]:not(.browser-default):focus:not([readonly])+label,input[type=tel]:not(.browser-default):focus:not([readonly])+label,input[type=text]:not(.browser-default):focus:not([readonly])+label,input[type=time]:not(.browser-default):focus:not([readonly])+label,input[type=url]:not(.browser-default):focus:not([readonly])+label,textarea.materialize-textarea:focus:not([readonly])+label{color:#26a69a}input:not([type]):focus.valid~label,input[type=date]:not(.browser-default):focus.valid~label,input[type=datetime-local]:not(.browser-default):focus.valid~label,input[type=datetime]:not(.browser-default):focus.valid~label,input[type=email]:not(.browser-default):focus.valid~label,input[type=number]:not(.browser-default):focus.valid~label,input[type=password]:not(.browser-default):focus.valid~label,input[type=search]:not(.browser-default):focus.valid~label,input[type=tel]:not(.browser-default):focus.valid~label,input[type=text]:not(.browser-default):focus.valid~label,input[type=time]:not(.browser-default):focus.valid~label,input[type=url]:not(.browser-default):focus.valid~label,textarea.materialize-textarea:focus.valid~label{color:#4caf50}input:not([type]):focus.invalid~label,input[type=date]:not(.browser-default):focus.invalid~label,input[type=datetime-local]:not(.browser-default):focus.invalid~label,input[type=datetime]:not(.browser-default):focus.invalid~label,input[type=email]:not(.browser-default):focus.invalid~label,input[type=number]:not(.browser-default):focus.invalid~label,input[type=password]:not(.browser-default):focus.invalid~label,input[type=search]:not(.browser-default):focus.invalid~label,input[type=tel]:not(.browser-default):focus.invalid~label,input[type=text]:not(.browser-default):focus.invalid~label,input[type=time]:not(.browser-default):focus.invalid~label,input[type=url]:not(.browser-default):focus.invalid~label,textarea.materialize-textarea:focus.invalid~label{color:#f44336}input:not([type]).validate+label,input[type=date]:not(.browser-default).validate+label,input[type=datetime-local]:not(.browser-default).validate+label,input[type=datetime]:not(.browser-default).validate+label,input[type=email]:not(.browser-default).validate+label,input[type=number]:not(.browser-default).validate+label,input[type=password]:not(.browser-default).validate+label,input[type=search]:not(.browser-default).validate+label,input[type=tel]:not(.browser-default).validate+label,input[type=text]:not(.browser-default).validate+label,input[type=time]:not(.browser-default).validate+label,input[type=url]:not(.browser-default).validate+label,textarea.materialize-textarea.validate+label{width:100%}.select-wrapper.valid>input.select-dropdown,input.valid:not([type]),input.valid:not([type]):focus,input.valid[type=date]:not(.browser-default),input.valid[type=date]:not(.browser-default):focus,input.valid[type=datetime-local]:not(.browser-default),input.valid[type=datetime-local]:not(.browser-default):focus,input.valid[type=datetime]:not(.browser-default),input.valid[type=datetime]:not(.browser-default):focus,input.valid[type=email]:not(.browser-default),input.valid[type=email]:not(.browser-default):focus,input.valid[type=number]:not(.browser-default),input.valid[type=number]:not(.browser-default):focus,input.valid[type=password]:not(.browser-default),input.valid[type=password]:not(.browser-default):focus,input.valid[type=search]:not(.browser-default),input.valid[type=search]:not(.browser-default):focus,input.valid[type=tel]:not(.browser-default),input.valid[type=tel]:not(.browser-default):focus,input.valid[type=text]:not(.browser-default),input.valid[type=text]:not(.browser-default):focus,input.valid[type=time]:not(.browser-default),input.valid[type=time]:not(.browser-default):focus,input.valid[type=url]:not(.browser-default),input.valid[type=url]:not(.browser-default):focus,textarea.materialize-textarea.valid,textarea.materialize-textarea.valid:focus{border-bottom:1px solid #4caf50;-webkit-box-shadow:0 1px 0 0 #4caf50;box-shadow:0 1px 0 0 #4caf50}.select-wrapper.invalid>input.select-dropdown,.select-wrapper.invalid>input.select-dropdown:focus,input.invalid:not([type]),input.invalid:not([type]):focus,input.invalid[type=date]:not(.browser-default),input.invalid[type=date]:not(.browser-default):focus,input.invalid[type=datetime-local]:not(.browser-default),input.invalid[type=datetime-local]:not(.browser-default):focus,input.invalid[type=datetime]:not(.browser-default),input.invalid[type=datetime]:not(.browser-default):focus,input.invalid[type=email]:not(.browser-default),input.invalid[type=email]:not(.browser-default):focus,input.invalid[type=number]:not(.browser-default),input.invalid[type=number]:not(.browser-default):focus,input.invalid[type=password]:not(.browser-default),input.invalid[type=password]:not(.browser-default):focus,input.invalid[type=search]:not(.browser-default),input.invalid[type=search]:not(.browser-default):focus,input.invalid[type=tel]:not(.browser-default),input.invalid[type=tel]:not(.browser-default):focus,input.invalid[type=text]:not(.browser-default),input.invalid[type=text]:not(.browser-default):focus,input.invalid[type=time]:not(.browser-default),input.invalid[type=time]:not(.browser-default):focus,input.invalid[type=url]:not(.browser-default),input.invalid[type=url]:not(.browser-default):focus,textarea.materialize-textarea.invalid,textarea.materialize-textarea.invalid:focus{border-bottom:1px solid #f44336;-webkit-box-shadow:0 1px 0 0 #f44336;box-shadow:0 1px 0 0 #f44336}.select-wrapper.invalid~.helper-text[data-error],.select-wrapper.valid .helper-text[data-success],input:not([type]).invalid~.helper-text[data-error],input:not([type]).valid~.helper-text[data-success],input:not([type]):focus.invalid~.helper-text[data-error],input:not([type]):focus.valid~.helper-text[data-success],input[type=date]:not(.browser-default).invalid~.helper-text[data-error],input[type=date]:not(.browser-default).valid~.helper-text[data-success],input[type=date]:not(.browser-default):focus.invalid~.helper-text[data-error],input[type=date]:not(.browser-default):focus.valid~.helper-text[data-success],input[type=datetime-local]:not(.browser-default).invalid~.helper-text[data-error],input[type=datetime-local]:not(.browser-default).valid~.helper-text[data-success],input[type=datetime-local]:not(.browser-default):focus.invalid~.helper-text[data-error],input[type=datetime-local]:not(.browser-default):focus.valid~.helper-text[data-success],input[type=datetime]:not(.browser-default).invalid~.helper-text[data-error],input[type=datetime]:not(.browser-default).valid~.helper-text[data-success],input[type=datetime]:not(.browser-default):focus.invalid~.helper-text[data-error],input[type=datetime]:not(.browser-default):focus.valid~.helper-text[data-success],input[type=email]:not(.browser-default).invalid~.helper-text[data-error],input[type=email]:not(.browser-default).valid~.helper-text[data-success],input[type=email]:not(.browser-default):focus.invalid~.helper-text[data-error],input[type=email]:not(.browser-default):focus.valid~.helper-text[data-success],input[type=number]:not(.browser-default).invalid~.helper-text[data-error],input[type=number]:not(.browser-default).valid~.helper-text[data-success],input[type=number]:not(.browser-default):focus.invalid~.helper-text[data-error],input[type=number]:not(.browser-default):focus.valid~.helper-text[data-success],input[type=password]:not(.browser-default).invalid~.helper-text[data-error],input[type=password]:not(.browser-default).valid~.helper-text[data-success],input[type=password]:not(.browser-default):focus.invalid~.helper-text[data-error],input[type=password]:not(.browser-default):focus.valid~.helper-text[data-success],input[type=search]:not(.browser-default).invalid~.helper-text[data-error],input[type=search]:not(.browser-default).valid~.helper-text[data-success],input[type=search]:not(.browser-default):focus.invalid~.helper-text[data-error],input[type=search]:not(.browser-default):focus.valid~.helper-text[data-success],input[type=tel]:not(.browser-default).invalid~.helper-text[data-error],input[type=tel]:not(.browser-default).valid~.helper-text[data-success],input[type=tel]:not(.browser-default):focus.invalid~.helper-text[data-error],input[type=tel]:not(.browser-default):focus.valid~.helper-text[data-success],input[type=text]:not(.browser-default).invalid~.helper-text[data-error],input[type=text]:not(.browser-default).valid~.helper-text[data-success],input[type=text]:not(.browser-default):focus.invalid~.helper-text[data-error],input[type=text]:not(.browser-default):focus.valid~.helper-text[data-success],input[type=time]:not(.browser-default).invalid~.helper-text[data-error],input[type=time]:not(.browser-default).valid~.helper-text[data-success],input[type=time]:not(.browser-default):focus.invalid~.helper-text[data-error],input[type=time]:not(.browser-default):focus.valid~.helper-text[data-success],input[type=url]:not(.browser-default).invalid~.helper-text[data-error],input[type=url]:not(.browser-default).valid~.helper-text[data-success],input[type=url]:not(.browser-default):focus.invalid~.helper-text[data-error],input[type=url]:not(.browser-default):focus.valid~.helper-text[data-success],textarea.materialize-textarea.invalid~.helper-text[data-error],textarea.materialize-textarea.valid~.helper-text[data-success],textarea.materialize-textarea:focus.invalid~.helper-text[data-error],textarea.materialize-textarea:focus.valid~.helper-text[data-success]{color:transparent;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none}.select-wrapper.valid~.helper-text:after,input:not([type]).valid~.helper-text:after,input:not([type]):focus.valid~.helper-text:after,input[type=date]:not(.browser-default).valid~.helper-text:after,input[type=date]:not(.browser-default):focus.valid~.helper-text:after,input[type=datetime-local]:not(.browser-default).valid~.helper-text:after,input[type=datetime-local]:not(.browser-default):focus.valid~.helper-text:after,input[type=datetime]:not(.browser-default).valid~.helper-text:after,input[type=datetime]:not(.browser-default):focus.valid~.helper-text:after,input[type=email]:not(.browser-default).valid~.helper-text:after,input[type=email]:not(.browser-default):focus.valid~.helper-text:after,input[type=number]:not(.browser-default).valid~.helper-text:after,input[type=number]:not(.browser-default):focus.valid~.helper-text:after,input[type=password]:not(.browser-default).valid~.helper-text:after,input[type=password]:not(.browser-default):focus.valid~.helper-text:after,input[type=search]:not(.browser-default).valid~.helper-text:after,input[type=search]:not(.browser-default):focus.valid~.helper-text:after,input[type=tel]:not(.browser-default).valid~.helper-text:after,input[type=tel]:not(.browser-default):focus.valid~.helper-text:after,input[type=text]:not(.browser-default).valid~.helper-text:after,input[type=text]:not(.browser-default):focus.valid~.helper-text:after,input[type=time]:not(.browser-default).valid~.helper-text:after,input[type=time]:not(.browser-default):focus.valid~.helper-text:after,input[type=url]:not(.browser-default).valid~.helper-text:after,input[type=url]:not(.browser-default):focus.valid~.helper-text:after,textarea.materialize-textarea.valid~.helper-text:after,textarea.materialize-textarea:focus.valid~.helper-text:after{content:attr(data-success);color:#4caf50}.select-wrapper.invalid~.helper-text:after,input:not([type]).invalid~.helper-text:after,input:not([type]):focus.invalid~.helper-text:after,input[type=date]:not(.browser-default).invalid~.helper-text:after,input[type=date]:not(.browser-default):focus.invalid~.helper-text:after,input[type=datetime-local]:not(.browser-default).invalid~.helper-text:after,input[type=datetime-local]:not(.browser-default):focus.invalid~.helper-text:after,input[type=datetime]:not(.browser-default).invalid~.helper-text:after,input[type=datetime]:not(.browser-default):focus.invalid~.helper-text:after,input[type=email]:not(.browser-default).invalid~.helper-text:after,input[type=email]:not(.browser-default):focus.invalid~.helper-text:after,input[type=number]:not(.browser-default).invalid~.helper-text:after,input[type=number]:not(.browser-default):focus.invalid~.helper-text:after,input[type=password]:not(.browser-default).invalid~.helper-text:after,input[type=password]:not(.browser-default):focus.invalid~.helper-text:after,input[type=search]:not(.browser-default).invalid~.helper-text:after,input[type=search]:not(.browser-default):focus.invalid~.helper-text:after,input[type=tel]:not(.browser-default).invalid~.helper-text:after,input[type=tel]:not(.browser-default):focus.invalid~.helper-text:after,input[type=text]:not(.browser-default).invalid~.helper-text:after,input[type=text]:not(.browser-default):focus.invalid~.helper-text:after,input[type=time]:not(.browser-default).invalid~.helper-text:after,input[type=time]:not(.browser-default):focus.invalid~.helper-text:after,input[type=url]:not(.browser-default).invalid~.helper-text:after,input[type=url]:not(.browser-default):focus.invalid~.helper-text:after,textarea.materialize-textarea.invalid~.helper-text:after,textarea.materialize-textarea:focus.invalid~.helper-text:after{content:attr(data-error);color:#f44336}.select-wrapper+label:after,input:not([type])+label:after,input[type=date]:not(.browser-default)+label:after,input[type=datetime-local]:not(.browser-default)+label:after,input[type=datetime]:not(.browser-default)+label:after,input[type=email]:not(.browser-default)+label:after,input[type=number]:not(.browser-default)+label:after,input[type=password]:not(.browser-default)+label:after,input[type=search]:not(.browser-default)+label:after,input[type=tel]:not(.browser-default)+label:after,input[type=text]:not(.browser-default)+label:after,input[type=time]:not(.browser-default)+label:after,input[type=url]:not(.browser-default)+label:after,textarea.materialize-textarea+label:after{display:block;content:\"\";position:absolute;top:100%;left:0;opacity:0;-webkit-transition:opacity .2s ease-out,color .2s ease-out;transition:opacity .2s ease-out,color .2s ease-out}.input-field{position:relative;margin-top:1rem;margin-bottom:1rem}.input-field.inline{display:inline-block;vertical-align:middle;margin-left:5px}.input-field.inline .select-dropdown,.input-field.inline input{margin-bottom:1rem}.input-field.col label{left:.75rem}.input-field.col .prefix~.validate~label,.input-field.col .prefix~label{width:calc(100% - 3rem - 1.5rem)}.input-field>label{color:#9e9e9e;position:absolute;top:0;left:0;font-size:1rem;cursor:text;-webkit-transition:color .2s ease-out,-webkit-transform .2s ease-out;transition:color .2s ease-out,-webkit-transform .2s ease-out;transition:transform .2s ease-out,color .2s ease-out;transition:transform .2s ease-out,color .2s ease-out,-webkit-transform .2s ease-out;-webkit-transform-origin:0 100%;transform-origin:0 100%;text-align:initial;-webkit-transform:translateY(12px);transform:translateY(12px)}.input-field>label:not(.label-icon).active{-webkit-transform:translateY(-14px) scale(.8);transform:translateY(-14px) scale(.8);-webkit-transform-origin:0 0;transform-origin:0 0}.input-field>input[type=date]:not(.browser-default)+label,.input-field>input[type=time]:not(.browser-default)+label,.input-field>input[type]:-webkit-autofill:not(.browser-default):not([type=search])+label{-webkit-transform:translateY(-14px) scale(.8);transform:translateY(-14px) scale(.8);-webkit-transform-origin:0 0;transform-origin:0 0}.input-field .helper-text{position:relative;min-height:18px;display:block;font-size:12px;color:rgba(0,0,0,.54)}.input-field .helper-text:after{opacity:1;position:absolute;top:0;left:0}.input-field .prefix{position:absolute;width:3rem;font-size:2rem;-webkit-transition:color .2s;transition:color .2s;top:.5rem}.input-field .prefix.active{color:#26a69a}.input-field .prefix~.autocomplete-content,.input-field .prefix~.helper-text,.input-field .prefix~.validate~label,.input-field .prefix~input,.input-field .prefix~label,.input-field .prefix~textarea{margin-left:3rem;width:92%;width:calc(100% - 3rem)}.input-field .prefix~label{margin-left:3rem}@media only screen and (max-width:992px){.input-field .prefix~input{width:86%;width:calc(100% - 3rem)}}@media only screen and (max-width:600px){.input-field .prefix~input{width:80%;width:calc(100% - 3rem)}}.input-field input[type=search]{display:block;line-height:inherit;-webkit-transition:background-color .3s;transition:background-color .3s}.nav-wrapper .input-field input[type=search]{height:inherit;padding-left:4rem;width:calc(100% - 4rem);border:0;-webkit-box-shadow:none;box-shadow:none}.input-field input[type=search]:focus:not(.browser-default){background-color:#fff;border:0;-webkit-box-shadow:none;box-shadow:none;color:#444}.input-field input[type=search]:focus:not(.browser-default)+label i,.input-field input[type=search]:focus:not(.browser-default)~.material-icons,.input-field input[type=search]:focus:not(.browser-default)~.mdi-navigation-close{color:#444}.input-field input[type=search]+.label-icon{-webkit-transform:none;transform:none;left:1rem}.input-field input[type=search]~.material-icons,.input-field input[type=search]~.mdi-navigation-close{position:absolute;top:0;right:1rem;color:transparent;cursor:pointer;font-size:2rem;-webkit-transition:color .3s;transition:color .3s}textarea{width:100%;height:3rem;background-color:transparent}textarea.materialize-textarea{line-height:normal;overflow-y:hidden;padding:.8rem 0;resize:none;min-height:3rem;-webkit-box-sizing:border-box;box-sizing:border-box}.hiddendiv{visibility:hidden;white-space:pre-wrap;word-wrap:break-word;overflow-wrap:break-word;padding-top:1.2rem;position:absolute;top:0;z-index:-1}.autocomplete-content li .highlight{color:#444}.autocomplete-content li img{height:40px;width:40px;margin:5px 15px}.character-counter{min-height:18px}[type=radio]:checked,[type=radio]:not(:checked){position:absolute;opacity:0;pointer-events:none}[type=radio]:checked+span,[type=radio]:not(:checked)+span{position:relative;padding-left:35px;cursor:pointer;display:inline-block;height:25px;line-height:25px;font-size:1rem;-webkit-transition:.28s ease;transition:.28s ease;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[type=radio]+span:after,[type=radio]+span:before{content:\"\";position:absolute;left:0;top:0;margin:4px;width:16px;height:16px;z-index:0;-webkit-transition:.28s ease;transition:.28s ease}[type=radio].with-gap:checked+span:after,[type=radio].with-gap:checked+span:before,[type=radio]:checked+span:after,[type=radio]:checked+span:before,[type=radio]:not(:checked)+span:after,[type=radio]:not(:checked)+span:before{border-radius:50%}[type=radio]:not(:checked)+span:after,[type=radio]:not(:checked)+span:before{border:2px solid #5a5a5a}[type=radio]:not(:checked)+span:after{-webkit-transform:scale(0);transform:scale(0)}[type=radio]:checked+span:before{border:2px solid transparent}[type=radio].with-gap:checked+span:after,[type=radio].with-gap:checked+span:before,[type=radio]:checked+span:after{border:2px solid #26a69a}[type=radio].with-gap:checked+span:after,[type=radio]:checked+span:after{background-color:#26a69a}[type=radio]:checked+span:after{-webkit-transform:scale(1.02);transform:scale(1.02)}[type=radio].with-gap:checked+span:after{-webkit-transform:scale(.5);transform:scale(.5)}[type=radio].tabbed:focus+span:before{-webkit-box-shadow:0 0 0 10px rgba(0,0,0,.1);box-shadow:0 0 0 10px rgba(0,0,0,.1)}[type=radio].with-gap:disabled:checked+span:before{border:2px solid rgba(0,0,0,.42)}[type=radio].with-gap:disabled:checked+span:after{border:none;background-color:rgba(0,0,0,.42)}[type=radio]:disabled:checked+span:before,[type=radio]:disabled:not(:checked)+span:before{background-color:transparent;border-color:rgba(0,0,0,.42)}[type=radio]:disabled+span{color:rgba(0,0,0,.42)}[type=radio]:disabled:not(:checked)+span:before{border-color:rgba(0,0,0,.42)}[type=radio]:disabled:checked+span:after{background-color:rgba(0,0,0,.42);border-color:#949494}[type=checkbox]:checked,[type=checkbox]:not(:checked){position:absolute;opacity:0;pointer-events:none}[type=checkbox]+span:not(.lever){position:relative;padding-left:35px;cursor:pointer;display:inline-block;height:25px;line-height:25px;font-size:1rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[type=checkbox]+span:not(.lever):before,[type=checkbox]:not(.filled-in)+span:not(.lever):after{content:\"\";position:absolute;top:0;left:0;width:18px;height:18px;z-index:0;border:2px solid #5a5a5a;border-radius:1px;margin-top:3px;-webkit-transition:.2s;transition:.2s}[type=checkbox]:not(.filled-in)+span:not(.lever):after{border:0;-webkit-transform:scale(0);transform:scale(0)}[type=checkbox]:not(:checked):disabled+span:not(.lever):before{border:none;background-color:rgba(0,0,0,.42)}[type=checkbox].tabbed:focus+span:not(.lever):after{-webkit-transform:scale(1);transform:scale(1);border:0;border-radius:50%;-webkit-box-shadow:0 0 0 10px rgba(0,0,0,.1);box-shadow:0 0 0 10px rgba(0,0,0,.1);background-color:rgba(0,0,0,.1)}[type=checkbox]:checked+span:not(.lever):before{top:-4px;left:-5px;width:12px;height:22px;border-top:2px solid transparent;border-left:2px solid transparent;border-right:2px solid #26a69a;border-bottom:2px solid #26a69a;-webkit-transform:rotate(40deg);transform:rotate(40deg);-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform-origin:100% 100%;transform-origin:100% 100%}[type=checkbox]:checked:disabled+span:before{border-right:2px solid rgba(0,0,0,.42);border-bottom:2px solid rgba(0,0,0,.42)}[type=checkbox]:indeterminate+span:not(.lever):before{top:-11px;left:-12px;width:10px;height:22px;border-top:none;border-left:none;border-right:2px solid #26a69a;border-bottom:none;-webkit-transform:rotate(90deg);transform:rotate(90deg);-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform-origin:100% 100%;transform-origin:100% 100%}[type=checkbox]:indeterminate:disabled+span:not(.lever):before{border-right:2px solid rgba(0,0,0,.42);background-color:transparent}[type=checkbox].filled-in+span:not(.lever):after{border-radius:2px}[type=checkbox].filled-in+span:not(.lever):after,[type=checkbox].filled-in+span:not(.lever):before{content:\"\";left:0;position:absolute;-webkit-transition:border .25s,background-color .25s,width .2s .1s,height .2s .1s,top .2s .1s,left .2s .1s;transition:border .25s,background-color .25s,width .2s .1s,height .2s .1s,top .2s .1s,left .2s .1s;z-index:1}[type=checkbox].filled-in:not(:checked)+span:not(.lever):before{width:0;height:0;border:3px solid transparent;left:6px;top:10px;-webkit-transform:rotate(37deg);transform:rotate(37deg);-webkit-transform-origin:100% 100%;transform-origin:100% 100%}[type=checkbox].filled-in:not(:checked)+span:not(.lever):after{height:20px;width:20px;background-color:transparent;border:2px solid #5a5a5a;top:0;z-index:0}[type=checkbox].filled-in:checked+span:not(.lever):before{top:0;left:1px;width:8px;height:13px;border-top:2px solid transparent;border-left:2px solid transparent;border-right:2px solid #fff;border-bottom:2px solid #fff;-webkit-transform:rotate(37deg);transform:rotate(37deg);-webkit-transform-origin:100% 100%;transform-origin:100% 100%}[type=checkbox].filled-in:checked+span:not(.lever):after{top:0;width:20px;height:20px;border:2px solid #26a69a;background-color:#26a69a;z-index:0}[type=checkbox].filled-in.tabbed:focus+span:not(.lever):after{border-radius:2px;border-color:#5a5a5a;background-color:rgba(0,0,0,.1)}[type=checkbox].filled-in.tabbed:checked:focus+span:not(.lever):after{border-radius:2px;background-color:#26a69a;border-color:#26a69a}[type=checkbox].filled-in:disabled:not(:checked)+span:not(.lever):before{background-color:transparent;border:2px solid transparent}[type=checkbox].filled-in:disabled:not(:checked)+span:not(.lever):after{border-color:transparent;background-color:#949494}[type=checkbox].filled-in:disabled:checked+span:not(.lever):before{background-color:transparent}[type=checkbox].filled-in:disabled:checked+span:not(.lever):after{background-color:#949494;border-color:#949494}.switch,.switch *{-webkit-tap-highlight-color:transparent;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.switch label{cursor:pointer}.switch label input[type=checkbox]{opacity:0;width:0;height:0}.switch label input[type=checkbox]:checked+.lever{background-color:#84c7c1}.switch label input[type=checkbox]:checked+.lever:after,.switch label input[type=checkbox]:checked+.lever:before{left:18px}.switch label input[type=checkbox]:checked+.lever:after{background-color:#26a69a}.switch label .lever{content:\"\";display:inline-block;position:relative;width:36px;height:14px;background-color:rgba(0,0,0,.38);border-radius:15px;margin-right:10px;-webkit-transition:background .3s ease;transition:background .3s ease;vertical-align:middle;margin:0 16px}.switch label .lever:after,.switch label .lever:before{content:\"\";position:absolute;display:inline-block;width:20px;height:20px;border-radius:50%;left:0;top:-3px;-webkit-transition:left .3s ease,background .3s ease,-webkit-box-shadow .1s ease,-webkit-transform .1s ease;transition:left .3s ease,background .3s ease,-webkit-box-shadow .1s ease,-webkit-transform .1s ease;transition:left .3s ease,background .3s ease,box-shadow .1s ease,transform .1s ease;transition:left .3s ease,background .3s ease,box-shadow .1s ease,transform .1s ease,-webkit-box-shadow .1s ease,-webkit-transform .1s ease}.switch label .lever:before{background-color:rgba(38,166,154,.15)}.switch label .lever:after{background-color:#f1f1f1;-webkit-box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}input[type=checkbox]:checked:not(:disabled).tabbed:focus~.lever:before,input[type=checkbox]:checked:not(:disabled)~.lever:active:before{-webkit-transform:scale(2.4);transform:scale(2.4);background-color:rgba(38,166,154,.15)}input[type=checkbox]:not(:disabled).tabbed:focus~.lever:before,input[type=checkbox]:not(:disabled)~.lever:active:before{-webkit-transform:scale(2.4);transform:scale(2.4);background-color:rgba(0,0,0,.08)}.switch input[type=checkbox][disabled]+.lever{cursor:default;background-color:rgba(0,0,0,.12)}.switch label input[type=checkbox][disabled]+.lever:after,.switch label input[type=checkbox][disabled]:checked+.lever:after{background-color:#949494}select{display:none}select.browser-default{display:block}select{background-color:hsla(0,0%,100%,.9);width:100%;padding:5px;border:1px solid #f2f2f2;border-radius:2px;height:3rem}.select-label{position:absolute}.select-wrapper{position:relative}.select-wrapper.invalid+label,.select-wrapper.valid+label{width:100%;pointer-events:none}.select-wrapper input.select-dropdown{position:relative;cursor:pointer;background-color:transparent;border:none;border-bottom:1px solid #9e9e9e;outline:none;height:3rem;line-height:3rem;width:100%;font-size:16px;margin:0 0 8px;padding:0;display:block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1}.select-wrapper input.select-dropdown:focus{border-bottom:1px solid #26a69a}.select-wrapper .caret{position:absolute;right:0;top:0;bottom:0;margin:auto 0;z-index:0;fill:rgba(0,0,0,.87)}.select-wrapper+label{position:absolute;top:-26px;font-size:.8rem}.select-wrapper.disabled+label,select:disabled{color:rgba(0,0,0,.42)}.select-wrapper.disabled .caret{fill:rgba(0,0,0,.42)}.select-wrapper input.select-dropdown:disabled{color:rgba(0,0,0,.42);cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.select-wrapper i{color:rgba(0,0,0,.3)}.select-dropdown li.disabled,.select-dropdown li.disabled>span,.select-dropdown li.optgroup{color:rgba(0,0,0,.3);background-color:transparent}.select-dropdown.dropdown-content li:hover,body.keyboard-focused .select-dropdown.dropdown-content li:focus{background-color:rgba(0,0,0,.08)}.select-dropdown.dropdown-content li.selected{background-color:rgba(0,0,0,.03)}.prefix~.select-wrapper{margin-left:3rem;width:92%;width:calc(100% - 3rem)}.prefix~label{margin-left:3rem}.select-dropdown li img{height:40px;width:40px;margin:5px 15px;float:right}.select-dropdown li.optgroup{border-top:1px solid #eee}.select-dropdown li.optgroup.selected>span{color:rgba(0,0,0,.7)}.select-dropdown li.optgroup>span{color:rgba(0,0,0,.4)}.select-dropdown li.optgroup~li.optgroup-option{padding-left:1rem}.file-field{position:relative}.file-field .file-path-wrapper{overflow:hidden;padding-left:10px}.file-field input.file-path{width:100%}.file-field .btn,.file-field .btn-large,.file-field .btn-small{float:left;height:3rem;line-height:3rem}.file-field span{cursor:pointer}.file-field input[type=file]{position:absolute;top:0;right:0;left:0;bottom:0;width:100%;margin:0;padding:0;font-size:20px;cursor:pointer;opacity:0;filter:alpha(opacity=0)}.file-field input[type=file]::-webkit-file-upload-button{display:none}.range-field{position:relative}input[type=range],input[type=range]+.thumb{cursor:pointer}input[type=range]{position:relative;background-color:transparent;border:none;outline:none;width:100%;margin:15px 0;padding:0}input[type=range]:focus{outline:none}input[type=range]+.thumb{position:absolute;top:10px;left:0;border:none;height:0;width:0;border-radius:50%;background-color:#26a69a;margin-left:7px;-webkit-transform-origin:50% 50%;transform-origin:50% 50%;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}input[type=range]+.thumb .value{display:block;width:30px;text-align:center;color:#26a69a;font-size:0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}input[type=range]+.thumb.active{border-radius:50% 50% 50% 0}input[type=range]+.thumb.active .value{color:#fff;margin-left:-1px;margin-top:8px;font-size:10px}input[type=range]{-webkit-appearance:none}input[type=range]::-webkit-slider-runnable-track{height:3px;background:#c2c0c2;border:none}input[type=range]::-webkit-slider-thumb{border:none;height:14px;width:14px;border-radius:50%;background:#26a69a;-webkit-transition:-webkit-box-shadow .3s;transition:-webkit-box-shadow .3s;transition:box-shadow .3s;transition:box-shadow .3s,-webkit-box-shadow .3s;-webkit-appearance:none;background-color:#26a69a;-webkit-transform-origin:50% 50%;transform-origin:50% 50%;margin:-5px 0 0}.keyboard-focused input[type=range]:focus:not(.active)::-webkit-slider-thumb{-webkit-box-shadow:0 0 0 10px rgba(38,166,154,.26);box-shadow:0 0 0 10px rgba(38,166,154,.26)}input[type=range]{border:1px solid #fff}input[type=range]::-moz-range-track{height:3px;background:#c2c0c2;border:none}input[type=range]::-moz-focus-inner{border:0}input[type=range]::-moz-range-thumb{border:none;height:14px;width:14px;border-radius:50%;background:#26a69a;-webkit-transition:-webkit-box-shadow .3s;transition:-webkit-box-shadow .3s;transition:box-shadow .3s;transition:box-shadow .3s,-webkit-box-shadow .3s;margin-top:-5px}input[type=range]:-moz-focusring{outline:1px solid #fff;outline-offset:-1px}.keyboard-focused input[type=range]:focus:not(.active)::-moz-range-thumb{box-shadow:0 0 0 10px rgba(38,166,154,.26)}input[type=range]::-ms-track{height:3px;background:transparent;border-color:transparent;border-width:6px 0;color:transparent}input[type=range]::-ms-fill-lower{background:#777}input[type=range]::-ms-fill-upper{background:#ddd}input[type=range]::-ms-thumb{border:none;height:14px;width:14px;border-radius:50%;background:#26a69a;-webkit-transition:-webkit-box-shadow .3s;transition:-webkit-box-shadow .3s;transition:box-shadow .3s;transition:box-shadow .3s,-webkit-box-shadow .3s}.keyboard-focused input[type=range]:focus:not(.active)::-ms-thumb{box-shadow:0 0 0 10px rgba(38,166,154,.26)}.table-of-contents.fixed{position:fixed}.table-of-contents li{padding:2px 0}.table-of-contents a{font-weight:300;color:#757575;padding-left:16px;height:1.5rem;line-height:1.5rem;letter-spacing:.4;display:inline-block}.table-of-contents a:hover{color:#a8a8a8;padding-left:15px;border-left:1px solid #ee6e73}.table-of-contents a.active{font-weight:500;padding-left:14px;border-left:2px solid #ee6e73}.sidenav{position:fixed;width:300px;left:0;top:0;margin:0;-webkit-transform:translateX(-100%);transform:translateX(-100%);height:calc(100% + 60px);height:100%;padding-bottom:60px;background-color:#fff;z-index:999;overflow-y:auto;will-change:transform;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:translateX(-105%);transform:translateX(-105%)}.sidenav.right-aligned{right:0;-webkit-transform:translateX(105%);transform:translateX(105%);left:auto;-webkit-transform:translateX(100%);transform:translateX(100%)}.sidenav .collapsible{margin:0}.sidenav li{float:none;line-height:48px}.sidenav li.active{background-color:rgba(0,0,0,.05)}.sidenav li>a{color:rgba(0,0,0,.87);display:block;font-size:14px;font-weight:500;height:48px;line-height:48px;padding:0 32px}.sidenav li>a:hover{background-color:rgba(0,0,0,.05)}.sidenav li>a.btn,.sidenav li>a.btn-flat,.sidenav li>a.btn-floating,.sidenav li>a.btn-large,.sidenav li>a.btn-small{margin:10px 15px}.sidenav li>a.btn,.sidenav li>a.btn-floating,.sidenav li>a.btn-large,.sidenav li>a.btn-small{color:#fff}.sidenav li>a.btn-flat{color:#343434}.sidenav li>a.btn-large:hover,.sidenav li>a.btn-small:hover,.sidenav li>a.btn:hover{background-color:#2bbbad}.sidenav li>a.btn-floating:hover{background-color:#26a69a}.sidenav li>a>[class^=mdi-],.sidenav li>a>i,.sidenav li>a>i.material-icons,.sidenav li>a li>a>[class*=mdi-]{float:left;height:48px;line-height:48px;margin:0 32px 0 0;width:24px;color:rgba(0,0,0,.54)}.sidenav .divider{margin:8px 0 0}.sidenav .subheader{cursor:auto;pointer-events:none;color:rgba(0,0,0,.54);font-size:14px;font-weight:500;line-height:48px}.sidenav .subheader:hover{background-color:transparent}.sidenav .user-view{position:relative;padding:32px 32px 0;margin-bottom:8px}.sidenav .user-view>a{height:auto;padding:0}.sidenav .user-view>a:hover{background-color:transparent}.sidenav .user-view .background{overflow:hidden;position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1}.sidenav .user-view .circle,.sidenav .user-view .email,.sidenav .user-view .name{display:block}.sidenav .user-view .circle{height:64px;width:64px}.sidenav .user-view .email,.sidenav .user-view .name{font-size:14px;line-height:24px}.sidenav .user-view .name{margin-top:16px;font-weight:500}.sidenav .user-view .email{padding-bottom:16px;font-weight:400}.drag-target{height:100%;width:10px;position:fixed;top:0;z-index:998}.drag-target.right-aligned{right:0}.sidenav.sidenav-fixed{left:0;-webkit-transform:translateX(0);transform:translateX(0);position:fixed}.sidenav.sidenav-fixed.right-aligned{right:0;left:auto}@media only screen and (max-width:992px){.sidenav.sidenav-fixed{-webkit-transform:translateX(-105%);transform:translateX(-105%)}.sidenav.sidenav-fixed.right-aligned{-webkit-transform:translateX(105%);transform:translateX(105%)}.sidenav>a{padding:0 16px}.sidenav .user-view{padding:16px 16px 0}}.sidenav .collapsible-body>ul:not(.collapsible)>li.active,.sidenav.sidenav-fixed .collapsible-body>ul:not(.collapsible)>li.active{background-color:#ee6e73}.sidenav .collapsible-body>ul:not(.collapsible)>li.active a,.sidenav.sidenav-fixed .collapsible-body>ul:not(.collapsible)>li.active a{color:#fff}.sidenav .collapsible-body{padding:0}.sidenav-overlay{position:fixed;top:0;left:0;right:0;opacity:0;height:120vh;background-color:rgba(0,0,0,.5);z-index:997;display:none}.preloader-wrapper{display:inline-block;position:relative;width:50px;height:50px}.preloader-wrapper.small{width:36px;height:36px}.preloader-wrapper.big{width:64px;height:64px}.preloader-wrapper.active{-webkit-animation:container-rotate 1568ms linear infinite;animation:container-rotate 1568ms linear infinite}@-webkit-keyframes container-rotate{to{-webkit-transform:rotate(1turn)}}@keyframes container-rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.spinner-layer{position:absolute;width:100%;height:100%;opacity:0;border-color:#26a69a}.spinner-blue,.spinner-blue-only{border-color:#4285f4}.spinner-red,.spinner-red-only{border-color:#db4437}.spinner-yellow,.spinner-yellow-only{border-color:#f4b400}.spinner-green,.spinner-green-only{border-color:#0f9d58}.active .spinner-layer.spinner-blue{-webkit-animation:fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,blue-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both;animation:fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,blue-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.active .spinner-layer.spinner-red{-webkit-animation:fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,red-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both;animation:fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,red-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.active .spinner-layer.spinner-yellow{-webkit-animation:fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,yellow-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both;animation:fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,yellow-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.active .spinner-layer.spinner-green{-webkit-animation:fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,green-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both;animation:fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,green-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.active .spinner-layer,.active .spinner-layer.spinner-blue-only,.active .spinner-layer.spinner-green-only,.active .spinner-layer.spinner-red-only,.active .spinner-layer.spinner-yellow-only{opacity:1;-webkit-animation:fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both;animation:fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both}@-webkit-keyframes fill-unfill-rotate{12.5%{-webkit-transform:rotate(135deg)}25%{-webkit-transform:rotate(270deg)}37.5%{-webkit-transform:rotate(405deg)}50%{-webkit-transform:rotate(540deg)}62.5%{-webkit-transform:rotate(675deg)}75%{-webkit-transform:rotate(810deg)}87.5%{-webkit-transform:rotate(945deg)}to{-webkit-transform:rotate(3turn)}}@keyframes fill-unfill-rotate{12.5%{-webkit-transform:rotate(135deg);transform:rotate(135deg)}25%{-webkit-transform:rotate(270deg);transform:rotate(270deg)}37.5%{-webkit-transform:rotate(405deg);transform:rotate(405deg)}50%{-webkit-transform:rotate(540deg);transform:rotate(540deg)}62.5%{-webkit-transform:rotate(675deg);transform:rotate(675deg)}75%{-webkit-transform:rotate(810deg);transform:rotate(810deg)}87.5%{-webkit-transform:rotate(945deg);transform:rotate(945deg)}to{-webkit-transform:rotate(3turn);transform:rotate(3turn)}}@-webkit-keyframes blue-fade-in-out{0%{opacity:1}25%{opacity:1}26%{opacity:0}89%{opacity:0}90%{opacity:1}to{opacity:1}}@keyframes blue-fade-in-out{0%{opacity:1}25%{opacity:1}26%{opacity:0}89%{opacity:0}90%{opacity:1}to{opacity:1}}@-webkit-keyframes red-fade-in-out{0%{opacity:0}15%{opacity:0}25%{opacity:1}50%{opacity:1}51%{opacity:0}}@keyframes red-fade-in-out{0%{opacity:0}15%{opacity:0}25%{opacity:1}50%{opacity:1}51%{opacity:0}}@-webkit-keyframes yellow-fade-in-out{0%{opacity:0}40%{opacity:0}50%{opacity:1}75%{opacity:1}76%{opacity:0}}@keyframes yellow-fade-in-out{0%{opacity:0}40%{opacity:0}50%{opacity:1}75%{opacity:1}76%{opacity:0}}@-webkit-keyframes green-fade-in-out{0%{opacity:0}65%{opacity:0}75%{opacity:1}90%{opacity:1}to{opacity:0}}@keyframes green-fade-in-out{0%{opacity:0}65%{opacity:0}75%{opacity:1}90%{opacity:1}to{opacity:0}}.gap-patch{position:absolute;top:0;left:45%;width:10%;height:100%;overflow:hidden;border-color:inherit}.gap-patch .circle{width:1000%;left:-450%}.circle-clipper{display:inline-block;position:relative;width:50%;height:100%;overflow:hidden;border-color:inherit}.circle-clipper .circle{width:200%;height:100%;border-width:3px;border-style:solid;border-color:inherit;border-bottom-color:transparent!important;border-radius:50%;-webkit-animation:none;animation:none;position:absolute;top:0;right:0;bottom:0}.circle-clipper.left .circle{left:0;border-right-color:transparent!important;-webkit-transform:rotate(129deg);transform:rotate(129deg)}.circle-clipper.right .circle{left:-100%;border-left-color:transparent!important;-webkit-transform:rotate(-129deg);transform:rotate(-129deg)}.active .circle-clipper.left .circle{-webkit-animation:left-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both;animation:left-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}.active .circle-clipper.right .circle{-webkit-animation:right-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both;animation:right-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}@-webkit-keyframes left-spin{0%{-webkit-transform:rotate(130deg)}50%{-webkit-transform:rotate(-5deg)}to{-webkit-transform:rotate(130deg)}}@keyframes left-spin{0%{-webkit-transform:rotate(130deg);transform:rotate(130deg)}50%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(130deg);transform:rotate(130deg)}}@-webkit-keyframes right-spin{0%{-webkit-transform:rotate(-130deg)}50%{-webkit-transform:rotate(5deg)}to{-webkit-transform:rotate(-130deg)}}@keyframes right-spin{0%{-webkit-transform:rotate(-130deg);transform:rotate(-130deg)}50%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}to{-webkit-transform:rotate(-130deg);transform:rotate(-130deg)}}#spinnerContainer.cooldown{-webkit-animation:container-rotate 1568ms linear infinite,fade-out .4s cubic-bezier(.4,0,.2,1);animation:container-rotate 1568ms linear infinite,fade-out .4s cubic-bezier(.4,0,.2,1)}@-webkit-keyframes fade-out{0%{opacity:1}to{opacity:0}}@keyframes fade-out{0%{opacity:1}to{opacity:0}}.slider{position:relative;height:400px;width:100%}.slider.fullscreen{height:100%;width:100%;position:absolute;top:0;left:0;right:0;bottom:0}.slider.fullscreen ul.slides{height:100%}.slider.fullscreen ul.indicators{z-index:2;bottom:30px}.slider .slides{background-color:#9e9e9e;margin:0;height:400px}.slider .slides li{opacity:0;position:absolute;top:0;left:0;z-index:1;width:100%;height:inherit;overflow:hidden}.slider .slides li img{height:100%;width:100%;background-size:cover;background-position:50%}.slider .slides li .caption{color:#fff;position:absolute;top:15%;left:15%;width:70%;opacity:0}.slider .slides li .caption p{color:#e0e0e0}.slider .slides li.active{z-index:2}.slider .indicators{position:absolute;text-align:center;left:0;right:0;bottom:0;margin:0}.slider .indicators .indicator-item{display:inline-block;position:relative;cursor:pointer;height:16px;width:16px;margin:0 12px;background-color:#e0e0e0;-webkit-transition:background-color .3s;transition:background-color .3s;border-radius:50%}.slider .indicators .indicator-item.active{background-color:#4caf50}.carousel{overflow:hidden;position:relative;width:100%;height:400px;-webkit-perspective:500px;perspective:500px;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform-origin:0 50%;transform-origin:0 50%}.carousel.carousel-slider{top:0;left:0}.carousel.carousel-slider .carousel-fixed-item{position:absolute;left:0;right:0;bottom:20px;z-index:1}.carousel.carousel-slider .carousel-fixed-item.with-indicators{bottom:68px}.carousel.carousel-slider .carousel-item{width:100%;height:100%;min-height:400px;position:absolute;top:0;left:0}.carousel.carousel-slider .carousel-item h2{font-size:24px;font-weight:500;line-height:32px}.carousel.carousel-slider .carousel-item p{font-size:15px}.carousel .carousel-item{visibility:hidden;width:200px;height:200px;position:absolute;top:0;left:0}.carousel .carousel-item>img{width:100%}.carousel .indicators{position:absolute;text-align:center;left:0;right:0;bottom:0;margin:0}.carousel .indicators .indicator-item{display:inline-block;position:relative;cursor:pointer;height:8px;width:8px;margin:24px 4px;background-color:hsla(0,0%,100%,.5);-webkit-transition:background-color .3s;transition:background-color .3s;border-radius:50%}.carousel .indicators .indicator-item.active{background-color:#fff}.carousel .carousel-item:not(.active) .materialboxed,.carousel.scrolling .carousel-item .materialboxed{pointer-events:none}.tap-target-wrapper{width:800px;height:800px;position:fixed;z-index:1000;visibility:hidden;-webkit-transition:visibility 0s .3s;transition:visibility 0s .3s}.tap-target-wrapper.open{visibility:visible;-webkit-transition:visibility 0s;transition:visibility 0s}.tap-target-wrapper.open .tap-target{opacity:.95;-webkit-transition:opacity .3s ease-in-out,-webkit-transform .3s ease-in-out;transition:opacity .3s ease-in-out,-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out,opacity .3s ease-in-out;transition:transform .3s ease-in-out,opacity .3s ease-in-out,-webkit-transform .3s ease-in-out}.tap-target-wrapper.open .tap-target,.tap-target-wrapper.open .tap-target-wave:before{-webkit-transform:scale(1);transform:scale(1)}.tap-target-wrapper.open .tap-target-wave:after{visibility:visible;-webkit-animation:pulse-animation 1s cubic-bezier(.24,0,.38,1) infinite;animation:pulse-animation 1s cubic-bezier(.24,0,.38,1) infinite;-webkit-transition:opacity .3s,visibility 0s 1s,-webkit-transform .3s;transition:opacity .3s,visibility 0s 1s,-webkit-transform .3s;transition:opacity .3s,transform .3s,visibility 0s 1s;transition:opacity .3s,transform .3s,visibility 0s 1s,-webkit-transform .3s}.tap-target{position:absolute;font-size:1rem;border-radius:50%;background-color:#ee6e73;-webkit-box-shadow:0 20px 20px 0 rgba(0,0,0,.14),0 10px 50px 0 rgba(0,0,0,.12),0 30px 10px -20px rgba(0,0,0,.2);box-shadow:0 20px 20px 0 rgba(0,0,0,.14),0 10px 50px 0 rgba(0,0,0,.12),0 30px 10px -20px rgba(0,0,0,.2);width:100%;height:100%;opacity:0;-webkit-transform:scale(0);transform:scale(0);-webkit-transition:opacity .3s ease-in-out,-webkit-transform .3s ease-in-out;transition:opacity .3s ease-in-out,-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out,opacity .3s ease-in-out;transition:transform .3s ease-in-out,opacity .3s ease-in-out,-webkit-transform .3s ease-in-out}.tap-target-content{position:relative;display:table-cell}.tap-target-wave{position:absolute;border-radius:50%;z-index:10001}.tap-target-wave:after,.tap-target-wave:before{content:\"\";display:block;position:absolute;width:100%;height:100%;border-radius:50%;background-color:#fff}.tap-target-wave:before{-webkit-transform:scale(0);transform:scale(0);-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.tap-target-wave:after{visibility:hidden;-webkit-transition:opacity .3s,visibility 0s,-webkit-transform .3s;transition:opacity .3s,visibility 0s,-webkit-transform .3s;transition:opacity .3s,transform .3s,visibility 0s;transition:opacity .3s,transform .3s,visibility 0s,-webkit-transform .3s;z-index:-1}.tap-target-origin{top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:10002;position:absolute!important}.tap-target-origin:not(.btn):not(.btn-large):not(.btn-small),.tap-target-origin:not(.btn):not(.btn-large):not(.btn-small):hover{background:none}@media only screen and (max-width:600px){.tap-target,.tap-target-wrapper{width:600px;height:600px}}.pulse{overflow:visible;position:relative}.pulse:before{content:\"\";display:block;position:absolute;width:100%;height:100%;top:0;left:0;background-color:inherit;border-radius:inherit;-webkit-transition:opacity .3s,-webkit-transform .3s;transition:opacity .3s,-webkit-transform .3s;transition:opacity .3s,transform .3s;transition:opacity .3s,transform .3s,-webkit-transform .3s;-webkit-animation:pulse-animation 1s cubic-bezier(.24,0,.38,1) infinite;animation:pulse-animation 1s cubic-bezier(.24,0,.38,1) infinite;z-index:-1}@-webkit-keyframes pulse-animation{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}50%{opacity:0;-webkit-transform:scale(1.5);transform:scale(1.5)}to{opacity:0;-webkit-transform:scale(1.5);transform:scale(1.5)}}@keyframes pulse-animation{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}50%{opacity:0;-webkit-transform:scale(1.5);transform:scale(1.5)}to{opacity:0;-webkit-transform:scale(1.5);transform:scale(1.5)}}.datepicker-modal{max-width:325px;min-width:300px;max-height:none}.datepicker-container.modal-content{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;padding:0}.datepicker-container.modal-content,.datepicker-controls{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.datepicker-controls{-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;width:280px;margin:0 auto}.datepicker-controls .selects-container{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.datepicker-controls .select-wrapper input{border-bottom:none;text-align:center;margin:0}.datepicker-controls .select-wrapper input:focus{border-bottom:none}.datepicker-controls .select-wrapper .caret{display:none}.datepicker-controls .select-year input{width:50px}.datepicker-controls .select-month input{width:70px}.month-next,.month-prev{margin-top:4px;cursor:pointer;background-color:transparent;border:none}.datepicker-date-display{-webkit-box-flex:1;-webkit-flex:1 auto;-ms-flex:1 auto;flex:1 auto;background-color:#26a69a;color:#fff;padding:20px 22px;font-weight:500}.datepicker-date-display .year-text{display:block;font-size:1.5rem;line-height:25px;color:hsla(0,0%,100%,.7)}.datepicker-date-display .date-text{display:block;font-size:2.8rem;line-height:47px;font-weight:500}.datepicker-calendar-container{-webkit-box-flex:2.5;-webkit-flex:2.5 auto;-ms-flex:2.5 auto;flex:2.5 auto}.datepicker-table{width:280px;font-size:1rem;margin:0 auto}.datepicker-table thead{border-bottom:none}.datepicker-table th{padding:10px 5px;text-align:center}.datepicker-table tr{border:none}.datepicker-table abbr{text-decoration:none;color:#999}.datepicker-table td{border-radius:50%;padding:0}.datepicker-table td.is-today{color:#26a69a}.datepicker-table td.is-selected{background-color:#26a69a;color:#fff}.datepicker-table td.is-disabled,.datepicker-table td.is-outside-current-month{color:rgba(0,0,0,.3);pointer-events:none}.datepicker-day-button{background-color:transparent;border:none;line-height:38px;display:block;width:100%;border-radius:50%;padding:0 5px;cursor:pointer;color:inherit}.datepicker-day-button:focus{background-color:rgba(43,161,150,.25)}.datepicker-footer{width:280px;margin:0 auto;padding-bottom:5px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.datepicker-cancel,.datepicker-clear,.datepicker-done,.datepicker-today{color:#26a69a;padding:0 1rem}.datepicker-clear{color:#f44336}@media only screen and (min-width:601px){.datepicker-modal{max-width:625px}.datepicker-container.modal-content{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row}.datepicker-date-display{-webkit-box-flex:0;-webkit-flex:0 1 270px;-ms-flex:0 1 270px;flex:0 1 270px}.datepicker-controls,.datepicker-footer,.datepicker-table{width:320px}.datepicker-day-button{line-height:44px}}.timepicker-modal{max-width:325px;max-height:none}.timepicker-container.modal-content{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;padding:0}.text-primary{color:#fff}.timepicker-digital-display{-webkit-box-flex:1;-webkit-flex:1 auto;-ms-flex:1 auto;flex:1 auto;background-color:#26a69a;padding:10px;font-weight:300}.timepicker-text-container{font-size:4rem;font-weight:700;text-align:center;color:hsla(0,0%,100%,.6);font-weight:400;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.timepicker-span-am-pm div,.timepicker-span-hours,.timepicker-span-minutes{cursor:pointer}.timepicker-span-hours{margin-right:3px}.timepicker-span-minutes{margin-left:3px}.timepicker-display-am-pm{font-size:1.3rem;position:absolute;right:1rem;bottom:1rem;font-weight:400}.timepicker-analog-display{-webkit-box-flex:2.5;-webkit-flex:2.5 auto;-ms-flex:2.5 auto;flex:2.5 auto}.timepicker-plate{background-color:#eee;border-radius:50%;width:270px;height:270px;overflow:visible;position:relative;margin:auto;margin-top:25px;margin-bottom:5px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.timepicker-canvas,.timepicker-dial{position:absolute;left:0;right:0;top:0;bottom:0}.timepicker-minutes{visibility:hidden}.timepicker-tick{border-radius:50%;color:rgba(0,0,0,.87);line-height:40px;text-align:center;width:40px;height:40px;position:absolute;cursor:pointer;font-size:15px}.timepicker-tick.active,.timepicker-tick:hover{background-color:rgba(38,166,154,.25)}.timepicker-dial{-webkit-transition:opacity .35s,-webkit-transform .35s;transition:opacity .35s,-webkit-transform .35s;transition:transform .35s,opacity .35s;transition:transform .35s,opacity .35s,-webkit-transform .35s}.timepicker-dial-out{opacity:0}.timepicker-dial-out.timepicker-hours{-webkit-transform:scale(1.1);transform:scale(1.1)}.timepicker-dial-out.timepicker-minutes{-webkit-transform:scale(.8);transform:scale(.8)}.timepicker-canvas{-webkit-transition:opacity 175ms;transition:opacity 175ms}.timepicker-canvas line{stroke:#26a69a;stroke-width:4;stroke-linecap:round}.timepicker-canvas-out{opacity:.25}.timepicker-canvas-bearing,.timepicker-canvas-bg{stroke:none;fill:#26a69a}.timepicker-footer{margin:0 auto;padding:5px 1rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.timepicker-clear{color:#f44336}.timepicker-close{color:#26a69a}.timepicker-clear,.timepicker-close{padding:0 20px}@media only screen and (min-width:601px){.timepicker-modal{max-width:600px}.timepicker-container.modal-content{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row}.timepicker-text-container{top:32%}.timepicker-display-am-pm{position:relative;right:auto;bottom:auto;text-align:center;margin-top:1.2rem}}", ""]);

// exports


/***/ }),
/* 293 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorIngreso),expression:"errorIngreso"}],staticClass:"brand-logo red center animated fadeIn",staticStyle:{"font-size":"18px"},attrs:{"transition":"fade"}},[_c('span',{staticStyle:{"color":"white"}},[_vm._v("\n            Debe ingresar un e-mail y una clave !\n        ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticStyle:{"height":"60px"}}),_vm._v(" "),_c('div',{staticClass:"col s12 l3"}),_vm._v(" "),_c('div',{staticClass:"col s12 l6 white z-depth-5 animated zoomIn",attrs:{"transition":"zoomIn"}},[_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"email_inline",staticClass:"validate",attrs:{"id":"email_inline","type":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Correo electrónico ?")]),_vm._v(" "),_c('span',{staticClass:"helper-text",attrs:{"data-error":"No valido 😓","data-success":"Correcto 😊"}})]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[(_vm.ocultarClave)?_c('div',{staticClass:"col s12 l10"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("vpn_key")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"validate",attrs:{"id":"password","type":"password"},domProps:{"value":(_vm.password)},on:{"blur":_vm.enfocar,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.signIn()},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Clave de Acceso ?")])]):_c('div',{staticClass:"col s12 l10"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("vpn_key")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"validate",attrs:{"id":"password","type":"text"},domProps:{"value":(_vm.password)},on:{"blur":_vm.enfocar,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.signIn()},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Clave de Acceso ?")])]),_vm._v(" "),_c('div',{staticClass:"col s12 l1"},[_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('a',{staticClass:"btn white tooltipped",attrs:{"data-tooltip":_vm.ocultarClave ? "Mostrar Clave" : "Ocultar Clave","data-position":"bottom"},on:{"click":_vm.toogleClave}},[_c('a',{staticStyle:{"color":"black"}},[_c('i',{staticClass:"material-icons"},[_vm._v("\n                                "+_vm._s(_vm.ocultarClave ? 'visibility_off' : 'visibility')+"\n                            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 center"},[_c('button',{ref:"idBoton",staticClass:"waves-effect waves-purple blue btn darken-2",attrs:{"id":"idBoton"},on:{"click":_vm.signIn}},[_c('a',{staticStyle:{"font-size":"16px","color":"white"}},[_vm._v("\n                            Ingresar")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s5"}),_vm._v(" "),(_vm.mostrarCargador)?_c('div',{staticClass:"col s2"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col s5"})])]),_vm._v(" "),_c('div',{staticClass:"col s12 l3"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-fading-circle"},[_c('div',{staticClass:"sk-circle1 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle2 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle3 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle4 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle5 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle6 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle7 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle8 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle9 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle10 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle11 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle12 sk-circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4f898f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logout_vue__ = __webpack_require__(296);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4f898f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row center"},[_c('div',{staticClass:"card blue-grey darken-1"},[_c('div',{staticClass:"card-action center"},[_c('button',{staticClass:"waves-effect waves-light btn-floating darken-5 z-depth-3 btn red",on:{"click":_vm.logOut}},[_vm._v("Salir del Sistema")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_culturaG_js__ = __webpack_require__(71);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e7b463e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_culturaG_vue__ = __webpack_require__(319);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_culturaG_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e7b463e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_culturaG_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.download = factory();
  }
}(this, function () {

	return function download(data, strFileName, strMimeType) {

		var self = window, // this script is only for browsers anyway...
			defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
			mimeType = strMimeType || defaultMime,
			payload = data,
			url = !strFileName && !strMimeType && payload,
			anchor = document.createElement("a"),
			toString = function(a){return String(a);},
			myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
			fileName = strFileName || "download",
			blob,
			reader;
			myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
	  
		if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
			payload=[payload, mimeType];
			mimeType=payload[0];
			payload=payload[1];
		}


		if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
			fileName = url.split("/").pop().split("?")[0];
			anchor.href = url; // assign href prop to temp anchor
		  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
        		var ajax=new XMLHttpRequest();
        		ajax.open( "GET", url, true);
        		ajax.responseType = 'blob';
        		ajax.onload= function(e){ 
				  download(e.target.response, fileName, defaultMime);
				};
        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
			    return ajax;
			} // end if valid url?
		} // end if url?


		//go ahead and download dataURLs right away
		if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
		
			if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
				payload=dataUrlToBlob(payload);
				mimeType=payload.type || defaultMime;
			}else{			
				return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
					navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
					saver(payload) ; // everyone else can save dataURLs un-processed
			}
			
		}else{//not data url, is it a string with special needs?
			if(/([\x80-\xff])/.test(payload)){			  
				var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
				for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
			 	payload=new myBlob([tempUiArr], {type: mimeType});
			}		  
		}
		blob = payload instanceof myBlob ?
			payload :
			new myBlob([payload], {type: mimeType}) ;


		function dataUrlToBlob(strUrl) {
			var parts= strUrl.split(/[:;,]/),
			type= parts[1],
			decoder= parts[2] == "base64" ? atob : decodeURIComponent,
			binData= decoder( parts.pop() ),
			mx= binData.length,
			i= 0,
			uiArr= new Uint8Array(mx);

			for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);

			return new myBlob([uiArr], {type: type});
		 }

		function saver(url, winMode){

			if ('download' in anchor) { //html5 A[download]
				anchor.href = url;
				anchor.setAttribute("download", fileName);
				anchor.className = "download-js-link";
				anchor.innerHTML = "downloading...";
				anchor.style.display = "none";
				document.body.appendChild(anchor);
				setTimeout(function() {
					anchor.click();
					document.body.removeChild(anchor);
					if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
				}, 66);
				return true;
			}

			// handle non-a[download] safari as best we can:
			if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
				if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				if(!window.open(url)){ // popup blocked, offer direct download:
					if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
				}
				return true;
			}

			//do iframe dataURL download (old ch+FF):
			var f = document.createElement("iframe");
			document.body.appendChild(f);

			if(!winMode && /^data:/.test(url)){ // force a mime that will download:
				url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
			}
			f.src=url;
			setTimeout(function(){ document.body.removeChild(f); }, 333);

		}//end saver




		if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
			return navigator.msSaveBlob(blob, fileName);
		}

		if(self.URL){ // simple fast and modern way using Blob and URL:
			saver(self.URL.createObjectURL(blob), true);
		}else{
			// handle non-Blob()+non-URL browsers:
			if(typeof blob === "string" || blob.constructor===toString ){
				try{
					return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
				}catch(y){
					return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
				}
			}

			// Blob but not URL support:
			reader=new FileReader();
			reader.onload=function(e){
				saver(this.result);
			};
			reader.readAsDataURL(blob);
		}
		return true;
	}; /* end download() */
}));


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_vm._t("default",[_vm._v("\n\t\tDownload "+_vm._s(_vm.name)+"\n\t")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chartkick__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_deep_equal__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_deepmerge__ = __webpack_require__(305);
/*
 * Vue Chartkick
 * Create beautiful JavaScript charts with one line of Vue
 * https://github.com/ankane/vue-chartkick
 * v0.4.0
 * MIT License
 */





var chartId = 1;

var createComponent = function(Vue, tagName, chartType) {
  var chartProps = [
    "colors", "curve", "dataset", "decimal", "discrete", "donut", "download", "label",
    "legend", "library", "max", "messages", "min", "points", "prefix", "refresh",
    "stacked", "suffix", "thousands", "title", "xtitle", "xtype", "ytitle"
  ];
  Vue.component(tagName, {
    props: ["data", "id", "width", "height"].concat(chartProps),
    render: function(createElement) {
      return createElement(
        "div",
        {
          attrs: {
            id: this.chartId
          },
          style: this.chartStyle
        },
        ["Loading..."]
      )
    },
    data: function() {
      return {
        chartId: null
      }
    },
    computed: {
      chartStyle: function() {
        // hack to watch data and options
        this.data;
        this.chartOptions;

        return {
          height: this.height || "300px",
          lineHeight: this.height || "300px",
          width: this.width || "100%",
          textAlign: "center",
          color: "#999",
          fontSize: "14px",
          fontFamily: "'Lucida Grande', 'Lucida Sans Unicode', Verdana, Arial, Helvetica, sans-serif"
        }
      },
      chartOptions: function() {
        var this$1 = this;

        var options = {};
        var props = chartProps;
        for (var i = 0; i < props.length; i++) {
          var prop = props[i];
          if (this$1[prop] !== undefined) {
            options[prop] = this$1[prop];
          }
        }
        return options
      }
    },
    created: function() {
      this.chartId = this.chartId || this.id || ("chart-" + chartId++);
    },
    mounted: function() {
      this.updateChart();
      this.savedState = this.currentState();
    },
    updated: function() {
      // avoid updates when literal objects are used as props
      // see https://github.com/ankane/vue-chartkick/pull/52
      // and https://github.com/vuejs/vue/issues/4060
      var currentState = this.currentState();
      if (!__WEBPACK_IMPORTED_MODULE_1_deep_equal___default()(currentState, this.savedState)) {
        this.updateChart();
        this.savedState = currentState;
      }
    },
    beforeDestroy: function() {
      if (this.chart) {
        this.chart.destroy();
      }
    },
    methods: {
      updateChart: function() {
        if (this.data !== null) {
          if (this.chart) {
            this.chart.updateData(this.data, this.chartOptions);
          } else {
            this.chart = new chartType(this.chartId, this.data, this.chartOptions);
          }
        } else if (this.chart) {
          this.chart.destroy();
          this.chart = null;
          this.$el.innerText = "Loading...";
        }
      },
      currentState: function() {
        return Object(__WEBPACK_IMPORTED_MODULE_2_deepmerge__["a" /* default */])({}, {
          data: this.data,
          chartOptions: this.chartOptions
        })
      }
    }
  });
};

var VueChartkick = {
  version: "0.4.0",
  install: function(Vue, options) {
    if (options && options.adapter) {
      __WEBPACK_IMPORTED_MODULE_0_chartkick__["a" /* default */].addAdapter(options.adapter);
    }
    createComponent(Vue, "line-chart", __WEBPACK_IMPORTED_MODULE_0_chartkick__["a" /* default */].LineChart);
    createComponent(Vue, "pie-chart", __WEBPACK_IMPORTED_MODULE_0_chartkick__["a" /* default */].PieChart);
    createComponent(Vue, "column-chart", __WEBPACK_IMPORTED_MODULE_0_chartkick__["a" /* default */].ColumnChart);
    createComponent(Vue, "bar-chart", __WEBPACK_IMPORTED_MODULE_0_chartkick__["a" /* default */].BarChart);
    createComponent(Vue, "area-chart", __WEBPACK_IMPORTED_MODULE_0_chartkick__["a" /* default */].AreaChart);
    createComponent(Vue, "scatter-chart", __WEBPACK_IMPORTED_MODULE_0_chartkick__["a" /* default */].ScatterChart);
    createComponent(Vue, "geo-chart", __WEBPACK_IMPORTED_MODULE_0_chartkick__["a" /* default */].GeoChart);
    createComponent(Vue, "timeline", __WEBPACK_IMPORTED_MODULE_0_chartkick__["a" /* default */].Timeline);
  },
  addAdapter: function(library) {
    __WEBPACK_IMPORTED_MODULE_0_chartkick__["a" /* default */].addAdapter(library);
  }
};

// in browser
if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(VueChartkick);
}

/* harmony default export */ __webpack_exports__["a"] = (VueChartkick);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Chartkick.js
 * Create beautiful charts with one line of JavaScript
 * https://github.com/ankane/chartkick.js
 * v2.3.6
 * MIT License
 */

function isArray(variable) {
  return Object.prototype.toString.call(variable) === "[object Array]";
}

function isFunction(variable) {
  return variable instanceof Function;
}

function isPlainObject(variable) {
  return !isFunction(variable) && variable instanceof Object;
}

// https://github.com/madrobby/zepto/blob/master/src/zepto.js
function extend(target, source) {
  var key;
  for (key in source) {
    if (isPlainObject(source[key]) || isArray(source[key])) {
      if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
        target[key] = {};
      }
      if (isArray(source[key]) && !isArray(target[key])) {
        target[key] = [];
      }
      extend(target[key], source[key]);
    } else if (source[key] !== undefined) {
      target[key] = source[key];
    }
  }
}

function merge(obj1, obj2) {
  var target = {};
  extend(target, obj1);
  extend(target, obj2);
  return target;
}

var DATE_PATTERN = /^(\d\d\d\d)(-)?(\d\d)(-)?(\d\d)$/i;

// https://github.com/Do/iso8601.js
var ISO8601_PATTERN = /(\d\d\d\d)(-)?(\d\d)(-)?(\d\d)(T)?(\d\d)(:)?(\d\d)?(:)?(\d\d)?([.,]\d+)?($|Z|([+-])(\d\d)(:)?(\d\d)?)/i;
var DECIMAL_SEPARATOR = String(1.5).charAt(1);

function parseISO8601(input) {
  var day, hour, matches, milliseconds, minutes, month, offset, result, seconds, type, year;
  type = Object.prototype.toString.call(input);
  if (type === "[object Date]") {
    return input;
  }
  if (type !== "[object String]") {
    return;
  }
  matches = input.match(ISO8601_PATTERN);
  if (matches) {
    year = parseInt(matches[1], 10);
    month = parseInt(matches[3], 10) - 1;
    day = parseInt(matches[5], 10);
    hour = parseInt(matches[7], 10);
    minutes = matches[9] ? parseInt(matches[9], 10) : 0;
    seconds = matches[11] ? parseInt(matches[11], 10) : 0;
    milliseconds = matches[12] ? parseFloat(DECIMAL_SEPARATOR + matches[12].slice(1)) * 1000 : 0;
    result = Date.UTC(year, month, day, hour, minutes, seconds, milliseconds);
    if (matches[13] && matches[14]) {
      offset = matches[15] * 60;
      if (matches[17]) {
        offset += parseInt(matches[17], 10);
      }
      offset *= matches[14] === "-" ? -1 : 1;
      result -= offset * 60 * 1000;
    }
    return new Date(result);
  }
}
// end iso8601.js

function negativeValues(series) {
  var i, j, data;
  for (i = 0; i < series.length; i++) {
    data = series[i].data;
    for (j = 0; j < data.length; j++) {
      if (data[j][1] < 0) {
        return true;
      }
    }
  }
  return false;
}

function toStr(n) {
  return "" + n;
}

function toFloat(n) {
  return parseFloat(n);
}

function toDate(n) {
  var matches, year, month, day;
  if (typeof n !== "object") {
    if (typeof n === "number") {
      n = new Date(n * 1000); // ms
    } else {
      n = toStr(n);
      if ((matches = n.match(DATE_PATTERN))) {
      year = parseInt(matches[1], 10);
      month = parseInt(matches[3], 10) - 1;
      day = parseInt(matches[5], 10);
      return new Date(year, month, day);
      } else { // str
        // try our best to get the str into iso8601
        // TODO be smarter about this
        var str = n.replace(/ /, "T").replace(" ", "").replace("UTC", "Z");
        n = parseISO8601(str) || new Date(n);
      }
    }
  }
  return n;
}

function toArr(n) {
  if (!isArray(n)) {
    var arr = [], i;
    for (i in n) {
      if (n.hasOwnProperty(i)) {
        arr.push([i, n[i]]);
      }
    }
    n = arr;
  }
  return n;
}

function jsOptionsFunc(defaultOptions, hideLegend, setTitle, setMin, setMax, setStacked, setXtitle, setYtitle) {
  return function (chart, opts, chartOptions) {
    var series = chart.data;
    var options = merge({}, defaultOptions);
    options = merge(options, chartOptions || {});

    if (chart.hideLegend || "legend" in opts) {
      hideLegend(options, opts.legend, chart.hideLegend);
    }

    if (opts.title) {
      setTitle(options, opts.title);
    }

    // min
    if ("min" in opts) {
      setMin(options, opts.min);
    } else if (!negativeValues(series)) {
      setMin(options, 0);
    }

    // max
    if (opts.max) {
      setMax(options, opts.max);
    }

    if ("stacked" in opts) {
      setStacked(options, opts.stacked);
    }

    if (opts.colors) {
      options.colors = opts.colors;
    }

    if (opts.xtitle) {
      setXtitle(options, opts.xtitle);
    }

    if (opts.ytitle) {
      setYtitle(options, opts.ytitle);
    }

    // merge library last
    options = merge(options, opts.library || {});

    return options;
  };
}

function sortByTime(a, b) {
  return a[0].getTime() - b[0].getTime();
}

function sortByNumberSeries(a, b) {
  return a[0] - b[0];
}

function sortByNumber(a, b) {
  return a - b;
}

function isMinute(d) {
  return d.getMilliseconds() === 0 && d.getSeconds() === 0;
}

function isHour(d) {
  return isMinute(d) && d.getMinutes() === 0;
}

function isDay(d) {
  return isHour(d) && d.getHours() === 0;
}

function isWeek(d, dayOfWeek) {
  return isDay(d) && d.getDay() === dayOfWeek;
}

function isMonth(d) {
  return isDay(d) && d.getDate() === 1;
}

function isYear(d) {
  return isMonth(d) && d.getMonth() === 0;
}

function isDate(obj) {
  return !isNaN(toDate(obj)) && toStr(obj).length >= 6;
}

function formatValue(pre, value, options) {
  pre = pre || "";
  if (options.prefix) {
    if (value < 0) {
      value = value * -1;
      pre += "-";
    }
    pre += options.prefix;
  }

  if (options.thousands || options.decimal) {
    value = toStr(value);
    var parts = value.split(".");
    value = parts[0];
    if (options.thousands) {
      value = value.replace(/\B(?=(\d{3})+(?!\d))/g, options.thousands);
    }
    if (parts.length > 1) {
      value += (options.decimal || ".") + parts[1];
    }
  }

  return pre + value + (options.suffix || "");
}

function allZeros(data) {
  var i, j, d;
  for (i = 0; i < data.length; i++) {
    d = data[i].data;
    for (j = 0; j < d.length; j++) {
      if (d[j][1] != 0) {
        return false;
      }
    }
  }
  return true;
}

var baseOptions = {
  maintainAspectRatio: false,
  animation: false,
  tooltips: {
    displayColors: false,
    callbacks: {}
  },
  legend: {},
  title: {fontSize: 20, fontColor: "#333"}
};

var defaultOptions = {
  scales: {
    yAxes: [
      {
        ticks: {
          maxTicksLimit: 4
        },
        scaleLabel: {
          fontSize: 16,
          // fontStyle: "bold",
          fontColor: "#333"
        }
      }
    ],
    xAxes: [
      {
        gridLines: {
          drawOnChartArea: false
        },
        scaleLabel: {
          fontSize: 16,
          // fontStyle: "bold",
          fontColor: "#333"
        },
        time: {},
        ticks: {}
      }
    ]
  }
};

// http://there4.io/2012/05/02/google-chart-color-list/
var defaultColors = [
  "#3366CC", "#DC3912", "#FF9900", "#109618", "#990099", "#3B3EAC", "#0099C6",
  "#DD4477", "#66AA00", "#B82E2E", "#316395", "#994499", "#22AA99", "#AAAA11",
  "#6633CC", "#E67300", "#8B0707", "#329262", "#5574A6", "#651067"
];

var hideLegend = function (options, legend, hideLegend) {
  if (legend !== undefined) {
    options.legend.display = !!legend;
    if (legend && legend !== true) {
      options.legend.position = legend;
    }
  } else if (hideLegend) {
    options.legend.display = false;
  }
};

var setTitle = function (options, title) {
  options.title.display = true;
  options.title.text = title;
};

var setMin = function (options, min) {
  if (min !== null) {
    options.scales.yAxes[0].ticks.min = toFloat(min);
  }
};

var setMax = function (options, max) {
  options.scales.yAxes[0].ticks.max = toFloat(max);
};

var setBarMin = function (options, min) {
  if (min !== null) {
    options.scales.xAxes[0].ticks.min = toFloat(min);
  }
};

var setBarMax = function (options, max) {
  options.scales.xAxes[0].ticks.max = toFloat(max);
};

var setStacked = function (options, stacked) {
  options.scales.xAxes[0].stacked = !!stacked;
  options.scales.yAxes[0].stacked = !!stacked;
};

var setXtitle = function (options, title) {
  options.scales.xAxes[0].scaleLabel.display = true;
  options.scales.xAxes[0].scaleLabel.labelString = title;
};

var setYtitle = function (options, title) {
  options.scales.yAxes[0].scaleLabel.display = true;
  options.scales.yAxes[0].scaleLabel.labelString = title;
};

// http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
var addOpacity = function(hex, opacity) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? "rgba(" + parseInt(result[1], 16) + ", " + parseInt(result[2], 16) + ", " + parseInt(result[3], 16) + ", " + opacity + ")" : hex;
};

var setLabelSize = function (chart, data, options) {
  var maxLabelSize = Math.ceil(chart.element.offsetWidth / 4.0 / data.labels.length);
  if (maxLabelSize > 25) {
    maxLabelSize = 25;
  }
  options.scales.xAxes[0].ticks.callback = function (value) {
    value = toStr(value);
    if (value.length > maxLabelSize) {
      return value.substring(0, maxLabelSize - 2) + "...";
    } else {
      return value;
    }
  };
};

var setFormatOptions = function(chart, options, chartType) {
  var formatOptions = {
    prefix: chart.options.prefix,
    suffix: chart.options.suffix,
    thousands: chart.options.thousands,
    decimal: chart.options.decimal
  };

  if (formatOptions.prefix || formatOptions.suffix || formatOptions.thousands || formatOptions.decimal) {
    if (chartType !== "pie") {
      var myAxes = options.scales.yAxes;
      if (chartType === "bar") {
        myAxes = options.scales.xAxes;
      }

      if (!myAxes[0].ticks.callback) {
        myAxes[0].ticks.callback = function (value) {
          return formatValue("", value, formatOptions);
        };
      }
    }

    if (!options.tooltips.callbacks.label) {
      if (chartType !== "pie") {
        var valueLabel = chartType === "bar" ? "xLabel" : "yLabel";
        options.tooltips.callbacks.label = function (tooltipItem, data) {
          var label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          return formatValue(label, tooltipItem[valueLabel], formatOptions);
        };
      } else {
        // need to use separate label for pie charts
        options.tooltips.callbacks.label = function (tooltipItem, data) {
          var dataLabel = data.labels[tooltipItem.index];
          var value = ': ';

          if (isArray(dataLabel)) {
            // show value on first line of multiline label
            // need to clone because we are changing the value
            dataLabel = dataLabel.slice();
            dataLabel[0] += value;
          } else {
            dataLabel += value;
          }

          return formatValue(dataLabel, data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], formatOptions);
        };
      }
    }
  }
};

var jsOptions = jsOptionsFunc(merge(baseOptions, defaultOptions), hideLegend, setTitle, setMin, setMax, setStacked, setXtitle, setYtitle);

var createDataTable = function (chart, options, chartType) {
  var datasets = [];
  var labels = [];

  var colors = chart.options.colors || defaultColors;

  var day = true;
  var week = true;
  var dayOfWeek;
  var month = true;
  var year = true;
  var hour = true;
  var minute = true;
  var detectType = (chartType === "line" || chartType === "area") && !chart.discrete;

  var series = chart.data;

  var sortedLabels = [];

  var i, j, s, d, key, rows = [];
  for (i = 0; i < series.length; i++) {
    s = series[i];

    for (j = 0; j < s.data.length; j++) {
      d = s.data[j];
      key = detectType ? d[0].getTime() : d[0];
      if (!rows[key]) {
        rows[key] = new Array(series.length);
      }
      rows[key][i] = toFloat(d[1]);
      if (sortedLabels.indexOf(key) === -1) {
        sortedLabels.push(key);
      }
    }
  }

  if (detectType || chart.options.xtype === "number") {
    sortedLabels.sort(sortByNumber);
  }

  var rows2 = [];
  for (j = 0; j < series.length; j++) {
    rows2.push([]);
  }

  var value;
  var k;
  for (k = 0; k < sortedLabels.length; k++) {
    i = sortedLabels[k];
    if (detectType) {
      value = new Date(toFloat(i));
      // TODO make this efficient
      day = day && isDay(value);
      if (!dayOfWeek) {
        dayOfWeek = value.getDay();
      }
      week = week && isWeek(value, dayOfWeek);
      month = month && isMonth(value);
      year = year && isYear(value);
      hour = hour && isHour(value);
      minute = minute && isMinute(value);
    } else {
      value = i;
    }
    labels.push(value);
    for (j = 0; j < series.length; j++) {
      // Chart.js doesn't like undefined
      rows2[j].push(rows[i][j] === undefined ? null : rows[i][j]);
    }
  }

  for (i = 0; i < series.length; i++) {
    s = series[i];

    var color = s.color || colors[i];
    var backgroundColor = chartType !== "line" ? addOpacity(color, 0.5) : color;

    var dataset = {
      label: s.name,
      data: rows2[i],
      fill: chartType === "area",
      borderColor: color,
      backgroundColor: backgroundColor,
      pointBackgroundColor: color,
      pointHoverBackgroundColor: color,
      borderWidth: 2
    };

    if (s.stack) {
      dataset.stack = s.stack;
    }

    if (chart.options.curve === false) {
      dataset.lineTension = 0;
    }

    if (chart.options.points === false) {
      dataset.pointRadius = 0;
      dataset.pointHitRadius = 5;
    }

    dataset = merge(dataset, chart.options.dataset || {});
    dataset = merge(dataset, s.library || {});
    dataset = merge(dataset, s.dataset || {});

    datasets.push(dataset);
  }

  if (detectType && labels.length > 0) {
    var minTime = labels[0].getTime();
    var maxTime = labels[0].getTime();
    for (i = 1; i < labels.length; i++) {
      value = labels[i].getTime();
      if (value < minTime) {
        minTime = value;
      }
      if (value > maxTime) {
        maxTime = value;
      }
    }

    var timeDiff = (maxTime - minTime) / (86400 * 1000.0);

    if (!options.scales.xAxes[0].time.unit) {
      var step;
      if (year || timeDiff > 365 * 10) {
        options.scales.xAxes[0].time.unit = "year";
        step = 365;
      } else if (month || timeDiff > 30 * 10) {
        options.scales.xAxes[0].time.unit = "month";
        step = 30;
      } else if (day || timeDiff > 10) {
        options.scales.xAxes[0].time.unit = "day";
        step = 1;
      } else if (hour || timeDiff > 0.5) {
        options.scales.xAxes[0].time.displayFormats = {hour: "MMM D, h a"};
        options.scales.xAxes[0].time.unit = "hour";
        step = 1 / 24.0;
      } else if (minute) {
        options.scales.xAxes[0].time.displayFormats = {minute: "h:mm a"};
        options.scales.xAxes[0].time.unit = "minute";
        step = 1 / 24.0 / 60.0;
      }

      if (step && timeDiff > 0) {
        var unitStepSize = Math.ceil(timeDiff / step / (chart.element.offsetWidth / 100.0));
        if (week && step === 1) {
          unitStepSize = Math.ceil(unitStepSize / 7.0) * 7;
        }
        options.scales.xAxes[0].time.unitStepSize = unitStepSize;
      }
    }

    if (!options.scales.xAxes[0].time.tooltipFormat) {
      if (day) {
        options.scales.xAxes[0].time.tooltipFormat = "ll";
      } else if (hour) {
        options.scales.xAxes[0].time.tooltipFormat = "MMM D, h a";
      } else if (minute) {
        options.scales.xAxes[0].time.tooltipFormat = "h:mm a";
      }
    }
  }

  var data = {
    labels: labels,
    datasets: datasets
  };

  return data;
};

var defaultExport = function defaultExport(library) {
  this.name = "chartjs";
  this.library = library;
};

defaultExport.prototype.renderLineChart = function renderLineChart (chart, chartType) {
  if (chart.options.xtype === "number") {
    return this.renderScatterChart(chart, chartType, true);
  }

  var chartOptions = {};
  // fix for https://github.com/chartjs/Chart.js/issues/2441
  if (!chart.options.max && allZeros(chart.data)) {
    chartOptions.max = 1;
  }

  var options = jsOptions(chart, merge(chartOptions, chart.options));
  setFormatOptions(chart, options, chartType);

  var data = createDataTable(chart, options, chartType || "line");

  options.scales.xAxes[0].type = chart.discrete ? "category" : "time";

  this.drawChart(chart, "line", data, options);
};

defaultExport.prototype.renderPieChart = function renderPieChart (chart) {
  var options = merge({}, baseOptions);
  if (chart.options.donut) {
    options.cutoutPercentage = 50;
  }

  if ("legend" in chart.options) {
    hideLegend(options, chart.options.legend);
  }

  if (chart.options.title) {
    setTitle(options, chart.options.title);
  }

  options = merge(options, chart.options.library || {});
  setFormatOptions(chart, options, "pie");

  var labels = [];
  var values = [];
  for (var i = 0; i < chart.data.length; i++) {
    var point = chart.data[i];
    labels.push(point[0]);
    values.push(point[1]);
  }

  var dataset = {
    data: values,
    backgroundColor: chart.options.colors || defaultColors
  };
  dataset = merge(dataset, chart.options.dataset || {});

  var data = {
    labels: labels,
    datasets: [dataset]
  };

  this.drawChart(chart, "pie", data, options);
};

defaultExport.prototype.renderColumnChart = function renderColumnChart (chart, chartType) {
  var options;
  if (chartType === "bar") {
    options = jsOptionsFunc(merge(baseOptions, defaultOptions), hideLegend, setTitle, setBarMin, setBarMax, setStacked, setXtitle, setYtitle)(chart, chart.options);
  } else {
    options = jsOptions(chart, chart.options);
  }
  setFormatOptions(chart, options, chartType);
  var data = createDataTable(chart, options, "column");
  if (chartType !== "bar") {
    setLabelSize(chart, data, options);
  }
  this.drawChart(chart, (chartType === "bar" ? "horizontalBar" : "bar"), data, options);
};

defaultExport.prototype.renderAreaChart = function renderAreaChart (chart) {
  this.renderLineChart(chart, "area");
};

defaultExport.prototype.renderBarChart = function renderBarChart (chart) {
  this.renderColumnChart(chart, "bar");
};

defaultExport.prototype.renderScatterChart = function renderScatterChart (chart, chartType, lineChart) {
  chartType = chartType || "line";

  var options = jsOptions(chart, chart.options);
  if (!lineChart) {
    setFormatOptions(chart, options, chartType);
  }

  var colors = chart.options.colors || defaultColors;

  var datasets = [];
  var series = chart.data;
  for (var i = 0; i < series.length; i++) {
    var s = series[i];
    var d = [];
    for (var j = 0; j < s.data.length; j++) {
      var point = {
        x: toFloat(s.data[j][0]),
        y: toFloat(s.data[j][1])
      };
      if (chartType === "bubble") {
        point.r = toFloat(s.data[j][2]);
      }
      d.push(point);
    }

    var color = s.color || colors[i];
    var backgroundColor = chartType === "area" ? addOpacity(color, 0.5) : color;

    datasets.push({
      label: s.name,
      showLine: lineChart || false,
      data: d,
      borderColor: color,
      backgroundColor: backgroundColor,
      pointBackgroundColor: color,
      fill: chartType === "area"
    });
  }

  if (chartType === "area") {
    chartType = "line";
  }

  var data = {datasets: datasets};

  options.scales.xAxes[0].type = "linear";
  options.scales.xAxes[0].position = "bottom";

  this.drawChart(chart, chartType, data, options);
};

defaultExport.prototype.renderBubbleChart = function renderBubbleChart (chart) {
  this.renderScatterChart(chart, "bubble");
};

defaultExport.prototype.destroy = function destroy (chart) {
  if (chart.chart) {
    chart.chart.destroy();
  }
};

defaultExport.prototype.drawChart = function drawChart (chart, type, data, options) {
  this.destroy(chart);

  chart.element.innerHTML = "<canvas></canvas>";
  var ctx = chart.element.getElementsByTagName("CANVAS")[0];
  chart.chart = new this.library(ctx, {
    type: type,
    data: data,
    options: options
  });
};

var defaultOptions$1 = {
  chart: {},
  xAxis: {
    title: {
      text: null
    },
    labels: {
      style: {
        fontSize: "12px"
      }
    }
  },
  yAxis: {
    title: {
      text: null
    },
    labels: {
      style: {
        fontSize: "12px"
      }
    }
  },
  title: {
    text: null
  },
  credits: {
    enabled: false
  },
  legend: {
    borderWidth: 0
  },
  tooltip: {
    style: {
      fontSize: "12px"
    }
  },
  plotOptions: {
    areaspline: {},
    series: {
      marker: {}
    }
  }
};

var hideLegend$1 = function (options, legend, hideLegend) {
  if (legend !== undefined) {
    options.legend.enabled = !!legend;
    if (legend && legend !== true) {
      if (legend === "top" || legend === "bottom") {
        options.legend.verticalAlign = legend;
      } else {
        options.legend.layout = "vertical";
        options.legend.verticalAlign = "middle";
        options.legend.align = legend;
      }
    }
  } else if (hideLegend) {
    options.legend.enabled = false;
  }
};

var setTitle$1 = function (options, title) {
  options.title.text = title;
};

var setMin$1 = function (options, min) {
  options.yAxis.min = min;
};

var setMax$1 = function (options, max) {
  options.yAxis.max = max;
};

var setStacked$1 = function (options, stacked) {
  options.plotOptions.series.stacking = stacked ? (stacked === true ? "normal" : stacked) : null;
};

var setXtitle$1 = function (options, title) {
  options.xAxis.title.text = title;
};

var setYtitle$1 = function (options, title) {
  options.yAxis.title.text = title;
};

var jsOptions$1 = jsOptionsFunc(defaultOptions$1, hideLegend$1, setTitle$1, setMin$1, setMax$1, setStacked$1, setXtitle$1, setYtitle$1);

var setFormatOptions$1 = function(chart, options, chartType) {
  var formatOptions = {
    prefix: chart.options.prefix,
    suffix: chart.options.suffix,
    thousands: chart.options.thousands,
    decimal: chart.options.decimal
  };

  if (formatOptions.prefix || formatOptions.suffix || formatOptions.thousands || formatOptions.decimal) {
    if (chartType !== "pie" && !options.yAxis.labels.formatter) {
      options.yAxis.labels.formatter = function () {
        return formatValue("", this.value, formatOptions);
      };
    }

    if (!options.tooltip.pointFormatter) {
      options.tooltip.pointFormatter = function () {
        return '<span style="color:' + this.color + '>\u25CF</span> ' + formatValue(this.series.name + ': <b>', this.y, formatOptions) + '</b><br/>';
      };
    }
  }
};

var defaultExport$1 = function defaultExport(library) {
  this.name = "highcharts";
  this.library = library;
};

defaultExport$1.prototype.renderLineChart = function renderLineChart (chart, chartType) {
  chartType = chartType || "spline";
  var chartOptions = {};
  if (chartType === "areaspline") {
    chartOptions = {
      plotOptions: {
        areaspline: {
          stacking: "normal"
        },
        area: {
          stacking: "normal"
        },
        series: {
          marker: {
            enabled: false
          }
        }
      }
    };
  }

  if (chart.options.curve === false) {
    if (chartType === "areaspline") {
      chartType = "area";
    } else if (chartType === "spline") {
      chartType = "line";
    }
  }

  var options = jsOptions$1(chart, chart.options, chartOptions), data, i, j;
  options.xAxis.type = chart.discrete ? "category" : "datetime";
  if (!options.chart.type) {
    options.chart.type = chartType;
  }
  setFormatOptions$1(chart, options, chartType);

  var series = chart.data;
  for (i = 0; i < series.length; i++) {
    data = series[i].data;
    if (!chart.discrete) {
      for (j = 0; j < data.length; j++) {
        data[j][0] = data[j][0].getTime();
      }
    }
    series[i].marker = {symbol: "circle"};
    if (chart.options.points === false) {
      series[i].marker.enabled = false;
    }
  }

  this.drawChart(chart, series, options);
};

defaultExport$1.prototype.renderScatterChart = function renderScatterChart (chart) {
  var options = jsOptions$1(chart, chart.options, {});
  options.chart.type = "scatter";
  this.drawChart(chart, chart.data, options);
};

defaultExport$1.prototype.renderPieChart = function renderPieChart (chart) {
  var chartOptions = merge(defaultOptions$1, {});

  if (chart.options.colors) {
    chartOptions.colors = chart.options.colors;
  }
  if (chart.options.donut) {
    chartOptions.plotOptions = {pie: {innerSize: "50%"}};
  }

  if ("legend" in chart.options) {
    hideLegend$1(chartOptions, chart.options.legend);
  }

  if (chart.options.title) {
    setTitle$1(chartOptions, chart.options.title);
  }

  var options = merge(chartOptions, chart.options.library || {});
  setFormatOptions$1(chart, options, "pie");
  var series = [{
    type: "pie",
    name: chart.options.label || "Value",
    data: chart.data
  }];

  this.drawChart(chart, series, options);
};

defaultExport$1.prototype.renderColumnChart = function renderColumnChart (chart, chartType) {
  chartType = chartType || "column";
  var series = chart.data;
  var options = jsOptions$1(chart, chart.options), i, j, s, d, rows = [], categories = [];
  options.chart.type = chartType;
  setFormatOptions$1(chart, options, chartType);

  for (i = 0; i < series.length; i++) {
    s = series[i];

    for (j = 0; j < s.data.length; j++) {
      d = s.data[j];
      if (!rows[d[0]]) {
        rows[d[0]] = new Array(series.length);
        categories.push(d[0]);
      }
      rows[d[0]][i] = d[1];
    }
  }

  if (chart.options.xtype === "number") {
    categories.sort(sortByNumber);
  }

  options.xAxis.categories = categories;

  var newSeries = [], d2;
  for (i = 0; i < series.length; i++) {
    d = [];
    for (j = 0; j < categories.length; j++) {
      d.push(rows[categories[j]][i] || 0);
    }

    d2 = {
      name: series[i].name,
      data: d
    };
    if (series[i].stack) {
      d2.stack = series[i].stack;
    }

    newSeries.push(d2);
  }

  this.drawChart(chart, newSeries, options);
};

defaultExport$1.prototype.renderBarChart = function renderBarChart (chart) {
  this.renderColumnChart(chart, "bar");
};

defaultExport$1.prototype.renderAreaChart = function renderAreaChart (chart) {
  this.renderLineChart(chart, "areaspline");
};

defaultExport$1.prototype.destroy = function destroy (chart) {
  if (chart.chart) {
    chart.chart.destroy();
  }
};

defaultExport$1.prototype.drawChart = function drawChart (chart, data, options) {
  this.destroy(chart);

  options.chart.renderTo = chart.element.id;
  options.series = data;
  chart.chart = new this.library.Chart(options);
};

var loaded = {};
var callbacks = [];

// Set chart options
var defaultOptions$2 = {
  chartArea: {},
  fontName: "'Lucida Grande', 'Lucida Sans Unicode', Verdana, Arial, Helvetica, sans-serif",
  pointSize: 6,
  legend: {
    textStyle: {
      fontSize: 12,
      color: "#444"
    },
    alignment: "center",
    position: "right"
  },
  curveType: "function",
  hAxis: {
    textStyle: {
      color: "#666",
      fontSize: 12
    },
    titleTextStyle: {},
    gridlines: {
      color: "transparent"
    },
    baselineColor: "#ccc",
    viewWindow: {}
  },
  vAxis: {
    textStyle: {
      color: "#666",
      fontSize: 12
    },
    titleTextStyle: {},
    baselineColor: "#ccc",
    viewWindow: {}
  },
  tooltip: {
    textStyle: {
      color: "#666",
      fontSize: 12
    }
  }
};

var hideLegend$2 = function (options, legend, hideLegend) {
  if (legend !== undefined) {
    var position;
    if (!legend) {
      position = "none";
    } else if (legend === true) {
      position = "right";
    } else {
      position = legend;
    }
    options.legend.position = position;
  } else if (hideLegend) {
    options.legend.position = "none";
  }
};

var setTitle$2 = function (options, title) {
  options.title = title;
  options.titleTextStyle = {color: "#333", fontSize: "20px"};
};

var setMin$2 = function (options, min) {
  options.vAxis.viewWindow.min = min;
};

var setMax$2 = function (options, max) {
  options.vAxis.viewWindow.max = max;
};

var setBarMin$1 = function (options, min) {
  options.hAxis.viewWindow.min = min;
};

var setBarMax$1 = function (options, max) {
  options.hAxis.viewWindow.max = max;
};

var setStacked$2 = function (options, stacked) {
  options.isStacked = stacked ? stacked : false;
};

var setXtitle$2 = function (options, title) {
  options.hAxis.title = title;
  options.hAxis.titleTextStyle.italic = false;
};

var setYtitle$2 = function (options, title) {
  options.vAxis.title = title;
  options.vAxis.titleTextStyle.italic = false;
};

var jsOptions$2 = jsOptionsFunc(defaultOptions$2, hideLegend$2, setTitle$2, setMin$2, setMax$2, setStacked$2, setXtitle$2, setYtitle$2);

var resize = function (callback) {
  if (window.attachEvent) {
    window.attachEvent("onresize", callback);
  } else if (window.addEventListener) {
    window.addEventListener("resize", callback, true);
  }
  callback();
};

var defaultExport$2 = function defaultExport(library) {
  this.name = "google";
  this.library = library;
};

defaultExport$2.prototype.renderLineChart = function renderLineChart (chart) {
    var this$1 = this;

  this.waitForLoaded(chart, function () {
    var chartOptions = {};

    if (chart.options.curve === false) {
      chartOptions.curveType = "none";
    }

    if (chart.options.points === false) {
      chartOptions.pointSize = 0;
    }

    var options = jsOptions$2(chart, chart.options, chartOptions);
    var columnType = chart.discrete ? "string" : "datetime";
    if (chart.options.xtype === "number") {
      columnType = "number";
    }
    var data = this$1.createDataTable(chart.data, columnType);

    this$1.drawChart(chart, this$1.library.visualization.LineChart, data, options);
  });
};

defaultExport$2.prototype.renderPieChart = function renderPieChart (chart) {
    var this$1 = this;

  this.waitForLoaded(chart, function () {
    var chartOptions = {
      chartArea: {
        top: "10%",
        height: "80%"
      },
      legend: {}
    };
    if (chart.options.colors) {
      chartOptions.colors = chart.options.colors;
    }
    if (chart.options.donut) {
      chartOptions.pieHole = 0.5;
    }
    if ("legend" in chart.options) {
      hideLegend$2(chartOptions, chart.options.legend);
    }
    if (chart.options.title) {
      setTitle$2(chartOptions, chart.options.title);
    }
    var options = merge(merge(defaultOptions$2, chartOptions), chart.options.library || {});

    var data = new this$1.library.visualization.DataTable();
    data.addColumn("string", "");
    data.addColumn("number", "Value");
    data.addRows(chart.data);

    this$1.drawChart(chart, this$1.library.visualization.PieChart, data, options);
  });
};

defaultExport$2.prototype.renderColumnChart = function renderColumnChart (chart) {
    var this$1 = this;

  this.waitForLoaded(chart, function () {
    var options = jsOptions$2(chart, chart.options);
    var data = this$1.createDataTable(chart.data, "string", chart.options.xtype);

    this$1.drawChart(chart, this$1.library.visualization.ColumnChart, data, options);
  });
};

defaultExport$2.prototype.renderBarChart = function renderBarChart (chart) {
    var this$1 = this;

  this.waitForLoaded(chart, function () {
    var chartOptions = {
      hAxis: {
        gridlines: {
          color: "#ccc"
        }
      }
    };
    var options = jsOptionsFunc(defaultOptions$2, hideLegend$2, setTitle$2, setBarMin$1, setBarMax$1, setStacked$2, setXtitle$2, setYtitle$2)(chart, chart.options, chartOptions);
    var data = this$1.createDataTable(chart.data, "string", chart.options.xtype);

    this$1.drawChart(chart, this$1.library.visualization.BarChart, data, options);
  });
};

defaultExport$2.prototype.renderAreaChart = function renderAreaChart (chart) {
    var this$1 = this;

  this.waitForLoaded(chart, function () {
    var chartOptions = {
      isStacked: true,
      pointSize: 0,
      areaOpacity: 0.5
    };

    var options = jsOptions$2(chart, chart.options, chartOptions);
    var columnType = chart.discrete ? "string" : "datetime";
    if (chart.options.xtype === "number") {
      columnType = "number";
    }
    var data = this$1.createDataTable(chart.data, columnType);

    this$1.drawChart(chart, this$1.library.visualization.AreaChart, data, options);
  });
};

defaultExport$2.prototype.renderGeoChart = function renderGeoChart (chart) {
    var this$1 = this;

  this.waitForLoaded(chart, function () {
    var chartOptions = {
      legend: "none",
      colorAxis: {
        colors: chart.options.colors || ["#f6c7b6", "#ce502d"]
      }
    };
    var options = merge(merge(defaultOptions$2, chartOptions), chart.options.library || {});

    var data = new this$1.library.visualization.DataTable();
    data.addColumn("string", "");
    data.addColumn("number", chart.options.label || "Value");
    data.addRows(chart.data);

    this$1.drawChart(chart, this$1.library.visualization.GeoChart, data, options);
  });
};

defaultExport$2.prototype.renderScatterChart = function renderScatterChart (chart) {
    var this$1 = this;

  this.waitForLoaded(chart, function () {
    var chartOptions = {};
    var options = jsOptions$2(chart, chart.options, chartOptions);

    var series = chart.data, rows2 = [], i, j, data, d;
    for (i = 0; i < series.length; i++) {
      d = series[i].data;
      for (j = 0; j < d.length; j++) {
        var row = new Array(series.length + 1);
        row[0] = d[j][0];
        row[i + 1] = d[j][1];
        rows2.push(row);
      }
    }

    data = new this$1.library.visualization.DataTable();
    data.addColumn("number", "");
    for (i = 0; i < series.length; i++) {
      data.addColumn("number", series[i].name);
    }
    data.addRows(rows2);

    this$1.drawChart(chart, this$1.library.visualization.ScatterChart, data, options);
  });
};

defaultExport$2.prototype.renderTimeline = function renderTimeline (chart) {
    var this$1 = this;

  this.waitForLoaded(chart, "timeline", function () {
    var chartOptions = {
      legend: "none"
    };

    if (chart.options.colors) {
      chartOptions.colors = chart.options.colors;
    }
    var options = merge(merge(defaultOptions$2, chartOptions), chart.options.library || {});

    var data = new this$1.library.visualization.DataTable();
    data.addColumn({type: "string", id: "Name"});
    data.addColumn({type: "date", id: "Start"});
    data.addColumn({type: "date", id: "End"});
    data.addRows(chart.data);

    chart.element.style.lineHeight = "normal";

    this$1.drawChart(chart, this$1.library.visualization.Timeline, data, options);
  });
};

defaultExport$2.prototype.destroy = function destroy (chart) {
  if (chart.chart) {
    chart.chart.clearChart();
  }
};

defaultExport$2.prototype.drawChart = function drawChart (chart, type, data, options) {
  this.destroy(chart);

  chart.chart = new type(chart.element);
  resize(function () {
    chart.chart.draw(data, options);
  });
};

defaultExport$2.prototype.waitForLoaded = function waitForLoaded (chart, pack, callback) {
    var this$1 = this;

  if (!callback) {
    callback = pack;
    pack = "corechart";
  }

  callbacks.push({pack: pack, callback: callback});

  if (loaded[pack]) {
    this.runCallbacks();
  } else {
    loaded[pack] = true;

    // https://groups.google.com/forum/#!topic/google-visualization-api/fMKJcyA2yyI
    var loadOptions = {
      packages: [pack],
      callback: function () { this$1.runCallbacks(); }
    };
    var config = chart.__config();
    if (config.language) {
      loadOptions.language = config.language;
    }
    if (pack === "corechart" && config.mapsApiKey) {
      loadOptions.mapsApiKey = config.mapsApiKey;
    }

    if (this.library.setOnLoadCallback) {
      this.library.load("visualization", "1", loadOptions);
    } else {
      this.library.charts.load("current", loadOptions);
    }
  }
};

defaultExport$2.prototype.runCallbacks = function runCallbacks () {
    var this$1 = this;

  var cb, call;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    call = this$1.library.visualization && ((cb.pack === "corechart" && this$1.library.visualization.LineChart) || (cb.pack === "timeline" && this$1.library.visualization.Timeline));
    if (call) {
      cb.callback();
      callbacks.splice(i, 1);
      i--;
    }
  }
};

// cant use object as key
defaultExport$2.prototype.createDataTable = function createDataTable (series, columnType, xtype) {
  var i, j, s, d, key, rows = [], sortedLabels = [];
  for (i = 0; i < series.length; i++) {
    s = series[i];

    for (j = 0; j < s.data.length; j++) {
      d = s.data[j];
      key = (columnType === "datetime") ? d[0].getTime() : d[0];
      if (!rows[key]) {
        rows[key] = new Array(series.length);
        sortedLabels.push(key);
      }
      rows[key][i] = toFloat(d[1]);
    }
  }

  var rows2 = [];
  var day = true;
  var value;
  for (j = 0; j < sortedLabels.length; j++) {
    i = sortedLabels[j];
    if (columnType === "datetime") {
      value = new Date(toFloat(i));
      day = day && isDay(value);
    } else if (columnType === "number") {
      value = toFloat(i);
    } else {
      value = i;
    }
    rows2.push([value].concat(rows[i]));
  }
  if (columnType === "datetime") {
    rows2.sort(sortByTime);
  } else if (columnType === "number") {
    rows2.sort(sortByNumberSeries);
  }

  if (xtype === "number") {
    rows2.sort(sortByNumberSeries);

    for (i = 0; i < rows2.length; i++) {
      rows2[i][0] = toStr(rows2[i][0]);
    }
  }

  // create datatable
  var data = new this.library.visualization.DataTable();
  columnType = columnType === "datetime" && day ? "date" : columnType;
  data.addColumn(columnType, "");
  for (i = 0; i < series.length; i++) {
    data.addColumn("number", series[i].name);
  }
  data.addRows(rows2);

  return data;
};

var pendingRequests = [], runningRequests = 0, maxRequests = 4;

function pushRequest(url, success, error) {
  pendingRequests.push([url, success, error]);
  runNext();
}

function runNext() {
  if (runningRequests < maxRequests) {
    var request = pendingRequests.shift();
    if (request) {
      runningRequests++;
      getJSON(request[0], request[1], request[2]);
      runNext();
    }
  }
}

function requestComplete() {
  runningRequests--;
  runNext();
}

function getJSON(url, success, error) {
  ajaxCall(url, success, function (jqXHR, textStatus, errorThrown) {
    var message = (typeof errorThrown === "string") ? errorThrown : errorThrown.message;
    error(message);
  });
}

function ajaxCall(url, success, error) {
  var $ = window.jQuery || window.Zepto || window.$;

  if ($) {
    $.ajax({
      dataType: "json",
      url: url,
      success: success,
      error: error,
      complete: requestComplete
    });
  } else {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = function () {
      requestComplete();
      if (xhr.status === 200) {
        success(JSON.parse(xhr.responseText), xhr.statusText, xhr);
      } else {
        error(xhr, "error", xhr.statusText);
      }
    };
    xhr.send();
  }
}

var config = (typeof window !== "undefined" && window.Chartkick) || {};
var adapters = [];

// helpers

function setText(element, text) {
  if (document.body.innerText) {
    element.innerText = text;
  } else {
    element.textContent = text;
  }
}

function chartError(element, message) {
  setText(element, "Error Loading Chart: " + message);
  element.style.color = "#ff0000";
}

function errorCatcher(chart) {
  try {
    chart.__render();
  } catch (err) {
    chartError(chart.element, err.message);
    throw err;
  }
}

function fetchDataSource(chart, dataSource) {
  if (typeof dataSource === "string") {
    pushRequest(dataSource, function (data) {
      chart.rawData = data;
      errorCatcher(chart);
    }, function (message) {
      chartError(chart.element, message);
    });
  } else {
    chart.rawData = dataSource;
    errorCatcher(chart);
  }
}

function addDownloadButton(chart) {
  var element = chart.element;
  var link = document.createElement("a");
  link.download = chart.options.download === true ? "chart.png" : chart.options.download; // http://caniuse.com/download
  link.style.position = "absolute";
  link.style.top = "20px";
  link.style.right = "20px";
  link.style.zIndex = 1000;
  link.style.lineHeight = "20px";
  link.target = "_blank"; // for safari
  var image = document.createElement("img");
  image.alt = "Download";
  image.style.border = "none";
  // icon from font-awesome
  // http://fa2png.io/
  image.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAABCFBMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMywEsqxAAAAV3RSTlMAAQIDBggJCgsMDQ4PERQaHB0eISIjJCouLzE0OTo/QUJHSUpLTU5PUllhYmltcHh5foWLjI+SlaCio6atr7S1t7m6vsHHyM7R2tze5Obo7fHz9ff5+/1hlxK2AAAA30lEQVQYGUXBhVYCQQBA0TdYWAt2d3d3YWAHyur7/z9xgD16Lw0DW+XKx+1GgX+FRzM3HWQWrHl5N/oapW5RPe0PkBu+UYeICvozTWZVK23Ao04B79oJrOsJDOoxkZoQPWgX29pHpCZEk7rEvQYiNSFq1UMqvlCjJkRBS1R8hb00Vb/TajtBL7nTHE1X1vyMQF732dQhyF2o6SAwrzP06iUQzvwsArlnzcOdrgBhJyHa1QOgO9U1GsKuvjUTjavliZYQ8nNPapG6sap/3nrIdJ6bOWzmX/fy0XVpfzZP3S8OJT3g9EEiJwAAAABJRU5ErkJggg==";
  link.appendChild(image);
  element.style.position = "relative";

  chart.__downloadAttached = true;

  // mouseenter
  chart.__enterEvent = addEvent(element, "mouseover", function(e) {
    var related = e.relatedTarget;
    // check download option again to ensure it wasn't changed
    if ((!related || (related !== this && !childOf(this, related))) && chart.options.download) {
      link.href = chart.toImage();
      element.appendChild(link);
    }
  });

  // mouseleave
  chart.__leaveEvent = addEvent(element, "mouseout", function(e) {
    var related = e.relatedTarget;
    if (!related || (related !== this && !childOf(this, related))) {
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
    }
  });
}

// http://stackoverflow.com/questions/10149963/adding-event-listener-cross-browser
function addEvent(elem, event, fn) {
  if (elem.addEventListener) {
    elem.addEventListener(event, fn, false);
    return fn;
  } else {
    var fn2 = function() {
      // set the this pointer same as addEventListener when fn is called
      return(fn.call(elem, window.event));
    };
    elem.attachEvent("on" + event, fn2);
    return fn2;
  }
}

function removeEvent(elem, event, fn) {
  if (elem.removeEventListener) {
    elem.removeEventListener(event, fn, false);
  } else {
    elem.detachEvent("on" + event, fn);
  }
}

// https://gist.github.com/shawnbot/4166283
function childOf(p, c) {
  if (p === c) { return false; }
  while (c && c !== p) { c = c.parentNode; }
  return c === p;
}

function getAdapterType(library) {
  if (library) {
    if (library.product === "Highcharts") {
      return defaultExport$1;
    } else if (library.setOnLoadCallback || library.charts) {
      return defaultExport$2;
    } else if (isFunction(library)) {
      return defaultExport;
    }
  }
  throw new Error("Unknown adapter");
}

function addAdapter(library) {
  var adapterType = getAdapterType(library);
  var adapter = new adapterType(library);

  if (adapters.indexOf(adapter) === -1) {
    adapters.push(adapter);
  }
}

function loadAdapters() {
  if ("Chart" in window) {
    addAdapter(window.Chart);
  }

  if ("Highcharts" in window) {
    addAdapter(window.Highcharts);
  }

  if (window.google && (window.google.setOnLoadCallback || window.google.charts)) {
    addAdapter(window.google);
  }
}

function dataEmpty(data, chartType) {
  if (chartType === "PieChart" || chartType === "GeoChart" || chartType === "Timeline") {
    return data.length === 0;
  } else {
    for (var i = 0; i < data.length; i++) {
      if (data[i].data.length > 0) {
        return false;
      }
    }
    return true;
  }
}

function renderChart(chartType, chart) {
  if (chart.options.messages && chart.options.messages.empty && dataEmpty(chart.data, chartType)) {
    setText(chart.element, chart.options.messages.empty);
  } else {
    callAdapter(chartType, chart);
    if (chart.options.download && !chart.__downloadAttached && chart.adapter === "chartjs") {
      addDownloadButton(chart);
    }
  }
}

// TODO remove chartType if cross-browser way
// to get the name of the chart class
function callAdapter(chartType, chart) {
  var i, adapter, fnName, adapterName;
  fnName = "render" + chartType;
  adapterName = chart.options.adapter;

  loadAdapters();

  for (i = 0; i < adapters.length; i++) {
    adapter = adapters[i];
    if ((!adapterName || adapterName === adapter.name) && isFunction(adapter[fnName])) {
      chart.adapter = adapter.name;
      chart.__adapterObject = adapter;
      return adapter[fnName](chart);
    }
  }

  if (adapters.length > 0) {
    throw new Error("No charting library found for " + chartType);
  } else {
    throw new Error("No charting libraries found - be sure to include one before your charts");
  }
}

// process data

var toFormattedKey = function (key, keyType) {
  if (keyType === "number") {
    key = toFloat(key);
  } else if (keyType === "datetime") {
    key = toDate(key);
  } else {
    key = toStr(key);
  }
  return key;
};

var formatSeriesData = function (data, keyType) {
  var r = [], key, j;
  for (j = 0; j < data.length; j++) {
    if (keyType === "bubble") {
      r.push([toFloat(data[j][0]), toFloat(data[j][1]), toFloat(data[j][2])]);
    } else {
      key = toFormattedKey(data[j][0], keyType);
      r.push([key, toFloat(data[j][1])]);
    }
  }
  if (keyType === "datetime") {
    r.sort(sortByTime);
  } else if (keyType === "number") {
    r.sort(sortByNumberSeries);
  }
  return r;
};

function detectDiscrete(series) {
  var i, j, data;
  for (i = 0; i < series.length; i++) {
    data = toArr(series[i].data);
    for (j = 0; j < data.length; j++) {
      if (!isDate(data[j][0])) {
        return true;
      }
    }
  }
  return false;
}

// creates a shallow copy of each element of the array
// elements are expected to be objects
function copySeries(series) {
  var newSeries = [], i, j;
  for (i = 0; i < series.length; i++) {
    var copy = {};
    for (j in series[i]) {
      if (series[i].hasOwnProperty(j)) {
        copy[j] = series[i][j];
      }
    }
    newSeries.push(copy);
  }
  return newSeries;
}

function processSeries(chart, keyType) {
  var i;

  var opts = chart.options;
  var series = chart.rawData;

  // see if one series or multiple
  if (!isArray(series) || typeof series[0] !== "object" || isArray(series[0])) {
    series = [{name: opts.label || "Value", data: series}];
    chart.hideLegend = true;
  } else {
    chart.hideLegend = false;
  }
  if ((opts.discrete === null || opts.discrete === undefined) && keyType !== "bubble" && keyType !== "number") {
    chart.discrete = detectDiscrete(series);
  } else {
    chart.discrete = opts.discrete;
  }
  if (chart.discrete) {
    keyType = "string";
  }
  if (chart.options.xtype) {
    keyType = chart.options.xtype;
  }

  // right format
  series = copySeries(series);
  for (i = 0; i < series.length; i++) {
    series[i].data = formatSeriesData(toArr(series[i].data), keyType);
  }

  return series;
}

function processSimple(chart) {
  var perfectData = toArr(chart.rawData), i;
  for (i = 0; i < perfectData.length; i++) {
    perfectData[i] = [toStr(perfectData[i][0]), toFloat(perfectData[i][1])];
  }
  return perfectData;
}

// define classes

var Chart = function Chart(element, dataSource, options) {
  var elementId;
  if (typeof element === "string") {
    elementId = element;
    element = document.getElementById(element);
    if (!element) {
      throw new Error("No element with id " + elementId);
    }
  }
  this.element = element;
  this.options = merge(Chartkick.options, options || {});
  this.dataSource = dataSource;

  Chartkick.charts[element.id] = this;

  fetchDataSource(this, dataSource);

  if (this.options.refresh) {
    this.startRefresh();
  }
};

Chart.prototype.getElement = function getElement () {
  return this.element;
};

Chart.prototype.getDataSource = function getDataSource () {
  return this.dataSource;
};

Chart.prototype.getData = function getData () {
  return this.data;
};

Chart.prototype.getOptions = function getOptions () {
  return this.options;
};

Chart.prototype.getChartObject = function getChartObject () {
  return this.chart;
};

Chart.prototype.getAdapter = function getAdapter () {
  return this.adapter;
};

Chart.prototype.updateData = function updateData (dataSource, options) {
  this.dataSource = dataSource;
  if (options) {
    this.__updateOptions(options);
  }
  fetchDataSource(this, dataSource);
};

Chart.prototype.setOptions = function setOptions (options) {
  this.__updateOptions(options);
  this.redraw();
};

Chart.prototype.redraw = function redraw () {
  fetchDataSource(this, this.rawData);
};

Chart.prototype.refreshData = function refreshData () {
  if (typeof this.dataSource === "string") {
    // prevent browser from caching
    var sep = this.dataSource.indexOf("?") === -1 ? "?" : "&";
    var url = this.dataSource + sep + "_=" + (new Date()).getTime();
    fetchDataSource(this, url);
  }
};

Chart.prototype.startRefresh = function startRefresh () {
    var this$1 = this;

  var refresh = this.options.refresh;

  if (!this.intervalId) {
    if (refresh) {
      this.intervalId = setInterval( function () {
        this$1.refreshData();
      }, refresh * 1000);
    } else {
      throw new Error("No refresh interval");
    }
  }
};

Chart.prototype.stopRefresh = function stopRefresh () {
  if (this.intervalId) {
    clearInterval(this.intervalId);
    this.intervalId = null;
  }
};

Chart.prototype.toImage = function toImage () {
  if (this.adapter === "chartjs") {
    return this.chart.toBase64Image();
  } else {
    return null;
  }
};

Chart.prototype.destroy = function destroy () {
  if (this.__adapterObject) {
    this.__adapterObject.destroy(this);
  }

  if (this.__enterEvent) {
    removeEvent(this.element, "mouseover", this.__enterEvent);
  }

  if (this.__leaveEvent) {
    removeEvent(this.element, "mouseout", this.__leaveEvent);
  }
};

Chart.prototype.__updateOptions = function __updateOptions (options) {
  var updateRefresh = options.refresh && options.refresh !== this.options.refresh;
  this.options = merge(Chartkick.options, options);
  if (updateRefresh) {
    this.stopRefresh();
    this.startRefresh();
  }
};

Chart.prototype.__render = function __render () {
  this.data = this.__processData();
  renderChart(this.__chartName(), this);
};

Chart.prototype.__config = function __config () {
  return config;
};

var LineChart = (function (Chart) {
  function LineChart () {
    Chart.apply(this, arguments);
  }

  if ( Chart ) LineChart.__proto__ = Chart;
  LineChart.prototype = Object.create( Chart && Chart.prototype );
  LineChart.prototype.constructor = LineChart;

  LineChart.prototype.__processData = function __processData () {
    return processSeries(this, "datetime");
  };

  LineChart.prototype.__chartName = function __chartName () {
    return "LineChart";
  };

  return LineChart;
}(Chart));

var PieChart = (function (Chart) {
  function PieChart () {
    Chart.apply(this, arguments);
  }

  if ( Chart ) PieChart.__proto__ = Chart;
  PieChart.prototype = Object.create( Chart && Chart.prototype );
  PieChart.prototype.constructor = PieChart;

  PieChart.prototype.__processData = function __processData () {
    return processSimple(this);
  };

  PieChart.prototype.__chartName = function __chartName () {
    return "PieChart";
  };

  return PieChart;
}(Chart));

var ColumnChart = (function (Chart) {
  function ColumnChart () {
    Chart.apply(this, arguments);
  }

  if ( Chart ) ColumnChart.__proto__ = Chart;
  ColumnChart.prototype = Object.create( Chart && Chart.prototype );
  ColumnChart.prototype.constructor = ColumnChart;

  ColumnChart.prototype.__processData = function __processData () {
    return processSeries(this, "string");
  };

  ColumnChart.prototype.__chartName = function __chartName () {
    return "ColumnChart";
  };

  return ColumnChart;
}(Chart));

var BarChart = (function (Chart) {
  function BarChart () {
    Chart.apply(this, arguments);
  }

  if ( Chart ) BarChart.__proto__ = Chart;
  BarChart.prototype = Object.create( Chart && Chart.prototype );
  BarChart.prototype.constructor = BarChart;

  BarChart.prototype.__processData = function __processData () {
    return processSeries(this, "string");
  };

  BarChart.prototype.__chartName = function __chartName () {
    return "BarChart";
  };

  return BarChart;
}(Chart));

var AreaChart = (function (Chart) {
  function AreaChart () {
    Chart.apply(this, arguments);
  }

  if ( Chart ) AreaChart.__proto__ = Chart;
  AreaChart.prototype = Object.create( Chart && Chart.prototype );
  AreaChart.prototype.constructor = AreaChart;

  AreaChart.prototype.__processData = function __processData () {
    return processSeries(this, "datetime");
  };

  AreaChart.prototype.__chartName = function __chartName () {
    return "AreaChart";
  };

  return AreaChart;
}(Chart));

var GeoChart = (function (Chart) {
  function GeoChart () {
    Chart.apply(this, arguments);
  }

  if ( Chart ) GeoChart.__proto__ = Chart;
  GeoChart.prototype = Object.create( Chart && Chart.prototype );
  GeoChart.prototype.constructor = GeoChart;

  GeoChart.prototype.__processData = function __processData () {
    return processSimple(this);
  };

  GeoChart.prototype.__chartName = function __chartName () {
    return "GeoChart";
  };

  return GeoChart;
}(Chart));

var ScatterChart = (function (Chart) {
  function ScatterChart () {
    Chart.apply(this, arguments);
  }

  if ( Chart ) ScatterChart.__proto__ = Chart;
  ScatterChart.prototype = Object.create( Chart && Chart.prototype );
  ScatterChart.prototype.constructor = ScatterChart;

  ScatterChart.prototype.__processData = function __processData () {
    return processSeries(this, "number");
  };

  ScatterChart.prototype.__chartName = function __chartName () {
    return "ScatterChart";
  };

  return ScatterChart;
}(Chart));

var BubbleChart = (function (Chart) {
  function BubbleChart () {
    Chart.apply(this, arguments);
  }

  if ( Chart ) BubbleChart.__proto__ = Chart;
  BubbleChart.prototype = Object.create( Chart && Chart.prototype );
  BubbleChart.prototype.constructor = BubbleChart;

  BubbleChart.prototype.__processData = function __processData () {
    return processSeries(this, "bubble");
  };

  BubbleChart.prototype.__chartName = function __chartName () {
    return "BubbleChart";
  };

  return BubbleChart;
}(Chart));

var Timeline = (function (Chart) {
  function Timeline () {
    Chart.apply(this, arguments);
  }

  if ( Chart ) Timeline.__proto__ = Chart;
  Timeline.prototype = Object.create( Chart && Chart.prototype );
  Timeline.prototype.constructor = Timeline;

  Timeline.prototype.__processData = function __processData () {
    var i, data = this.rawData;
    for (i = 0; i < data.length; i++) {
      data[i][1] = toDate(data[i][1]);
      data[i][2] = toDate(data[i][2]);
    }
    return data;
  };

  Timeline.prototype.__chartName = function __chartName () {
    return "Timeline";
  };

  return Timeline;
}(Chart));

var Chartkick = {
  LineChart: LineChart,
  PieChart: PieChart,
  ColumnChart: ColumnChart,
  BarChart: BarChart,
  AreaChart: AreaChart,
  GeoChart: GeoChart,
  ScatterChart: ScatterChart,
  BubbleChart: BubbleChart,
  Timeline: Timeline,
  charts: {},
  configure: function (options) {
    for (var key in options) {
      if (options.hasOwnProperty(key)) {
        config[key] = options[key];
      }
    }
  },
  eachChart: function (callback) {
    for (var chartId in Chartkick.charts) {
      if (Chartkick.charts.hasOwnProperty(chartId)) {
        callback(Chartkick.charts[chartId]);
      }
    }
  },
  config: config,
  options: {},
  adapters: adapters,
  addAdapter: addAdapter
};

/* harmony default export */ __webpack_exports__["a"] = (Chartkick);


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(303);
var isArguments = __webpack_require__(304);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 303 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 304 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["a"] = (deepmerge_1);


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 75,
	"./af.js": 75,
	"./ar": 76,
	"./ar-dz": 77,
	"./ar-dz.js": 77,
	"./ar-kw": 78,
	"./ar-kw.js": 78,
	"./ar-ly": 79,
	"./ar-ly.js": 79,
	"./ar-ma": 80,
	"./ar-ma.js": 80,
	"./ar-sa": 81,
	"./ar-sa.js": 81,
	"./ar-tn": 82,
	"./ar-tn.js": 82,
	"./ar.js": 76,
	"./az": 83,
	"./az.js": 83,
	"./be": 84,
	"./be.js": 84,
	"./bg": 85,
	"./bg.js": 85,
	"./bm": 86,
	"./bm.js": 86,
	"./bn": 87,
	"./bn.js": 87,
	"./bo": 88,
	"./bo.js": 88,
	"./br": 89,
	"./br.js": 89,
	"./bs": 90,
	"./bs.js": 90,
	"./ca": 91,
	"./ca.js": 91,
	"./cs": 92,
	"./cs.js": 92,
	"./cv": 93,
	"./cv.js": 93,
	"./cy": 94,
	"./cy.js": 94,
	"./da": 95,
	"./da.js": 95,
	"./de": 96,
	"./de-at": 97,
	"./de-at.js": 97,
	"./de-ch": 98,
	"./de-ch.js": 98,
	"./de.js": 96,
	"./dv": 99,
	"./dv.js": 99,
	"./el": 100,
	"./el.js": 100,
	"./en-au": 101,
	"./en-au.js": 101,
	"./en-ca": 102,
	"./en-ca.js": 102,
	"./en-gb": 103,
	"./en-gb.js": 103,
	"./en-ie": 104,
	"./en-ie.js": 104,
	"./en-il": 105,
	"./en-il.js": 105,
	"./en-nz": 106,
	"./en-nz.js": 106,
	"./eo": 107,
	"./eo.js": 107,
	"./es": 108,
	"./es-do": 109,
	"./es-do.js": 109,
	"./es-us": 110,
	"./es-us.js": 110,
	"./es.js": 108,
	"./et": 111,
	"./et.js": 111,
	"./eu": 112,
	"./eu.js": 112,
	"./fa": 113,
	"./fa.js": 113,
	"./fi": 114,
	"./fi.js": 114,
	"./fo": 115,
	"./fo.js": 115,
	"./fr": 116,
	"./fr-ca": 117,
	"./fr-ca.js": 117,
	"./fr-ch": 118,
	"./fr-ch.js": 118,
	"./fr.js": 116,
	"./fy": 119,
	"./fy.js": 119,
	"./gd": 120,
	"./gd.js": 120,
	"./gl": 121,
	"./gl.js": 121,
	"./gom-latn": 122,
	"./gom-latn.js": 122,
	"./gu": 123,
	"./gu.js": 123,
	"./he": 124,
	"./he.js": 124,
	"./hi": 125,
	"./hi.js": 125,
	"./hr": 126,
	"./hr.js": 126,
	"./hu": 127,
	"./hu.js": 127,
	"./hy-am": 128,
	"./hy-am.js": 128,
	"./id": 129,
	"./id.js": 129,
	"./is": 130,
	"./is.js": 130,
	"./it": 131,
	"./it.js": 131,
	"./ja": 132,
	"./ja.js": 132,
	"./jv": 133,
	"./jv.js": 133,
	"./ka": 134,
	"./ka.js": 134,
	"./kk": 135,
	"./kk.js": 135,
	"./km": 136,
	"./km.js": 136,
	"./kn": 137,
	"./kn.js": 137,
	"./ko": 138,
	"./ko.js": 138,
	"./ky": 139,
	"./ky.js": 139,
	"./lb": 140,
	"./lb.js": 140,
	"./lo": 141,
	"./lo.js": 141,
	"./lt": 142,
	"./lt.js": 142,
	"./lv": 143,
	"./lv.js": 143,
	"./me": 144,
	"./me.js": 144,
	"./mi": 145,
	"./mi.js": 145,
	"./mk": 146,
	"./mk.js": 146,
	"./ml": 147,
	"./ml.js": 147,
	"./mn": 148,
	"./mn.js": 148,
	"./mr": 149,
	"./mr.js": 149,
	"./ms": 150,
	"./ms-my": 151,
	"./ms-my.js": 151,
	"./ms.js": 150,
	"./mt": 152,
	"./mt.js": 152,
	"./my": 153,
	"./my.js": 153,
	"./nb": 154,
	"./nb.js": 154,
	"./ne": 155,
	"./ne.js": 155,
	"./nl": 156,
	"./nl-be": 157,
	"./nl-be.js": 157,
	"./nl.js": 156,
	"./nn": 158,
	"./nn.js": 158,
	"./pa-in": 159,
	"./pa-in.js": 159,
	"./pl": 160,
	"./pl.js": 160,
	"./pt": 161,
	"./pt-br": 162,
	"./pt-br.js": 162,
	"./pt.js": 161,
	"./ro": 163,
	"./ro.js": 163,
	"./ru": 164,
	"./ru.js": 164,
	"./sd": 165,
	"./sd.js": 165,
	"./se": 166,
	"./se.js": 166,
	"./si": 167,
	"./si.js": 167,
	"./sk": 168,
	"./sk.js": 168,
	"./sl": 169,
	"./sl.js": 169,
	"./sq": 170,
	"./sq.js": 170,
	"./sr": 171,
	"./sr-cyrl": 172,
	"./sr-cyrl.js": 172,
	"./sr.js": 171,
	"./ss": 173,
	"./ss.js": 173,
	"./sv": 174,
	"./sv.js": 174,
	"./sw": 175,
	"./sw.js": 175,
	"./ta": 176,
	"./ta.js": 176,
	"./te": 177,
	"./te.js": 177,
	"./tet": 178,
	"./tet.js": 178,
	"./tg": 179,
	"./tg.js": 179,
	"./th": 180,
	"./th.js": 180,
	"./tl-ph": 181,
	"./tl-ph.js": 181,
	"./tlh": 182,
	"./tlh.js": 182,
	"./tr": 183,
	"./tr.js": 183,
	"./tzl": 184,
	"./tzl.js": 184,
	"./tzm": 185,
	"./tzm-latn": 186,
	"./tzm-latn.js": 186,
	"./tzm.js": 185,
	"./ug-cn": 187,
	"./ug-cn.js": 187,
	"./uk": 188,
	"./uk.js": 188,
	"./ur": 189,
	"./ur.js": 189,
	"./uz": 190,
	"./uz-latn": 191,
	"./uz-latn.js": 191,
	"./uz.js": 190,
	"./vi": 192,
	"./vi.js": 192,
	"./x-pseudo": 193,
	"./x-pseudo.js": 193,
	"./yo": 194,
	"./yo.js": 194,
	"./zh-cn": 195,
	"./zh-cn.js": 195,
	"./zh-hk": 196,
	"./zh-hk.js": 196,
	"./zh-tw": 197,
	"./zh-tw.js": 197
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 306;

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_culturaGforma_js__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ae21ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_culturaGforma_vue__ = __webpack_require__(312);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_culturaGforma_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ae21ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_culturaGforma_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"date"},domProps:{"value":_vm.dateToYYYYMMDD(_vm.value)},on:{"input":function($event){_vm.updateValue($event.target)},"focus":_vm.selectAll}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 311 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_modo==='INGRESO'),expression:"$store.state.st_modo==='INGRESO'"}],staticClass:"collapsible popout"},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v("\n                Cargando caso ... "+_vm._s(_vm.cargaCaso())+"                \n            ")]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('div',[_c('label',{attrs:{"for":"empresa"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.caso.empresa),expression:"caso.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.caso.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "empresa", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('label',{attrs:{"for":"nombre"}},[_vm._v("Participante:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.caso.nombre),expression:"caso.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.caso.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "nombre", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s8"},[_c('h5',{staticClass:"center"},[_vm._v("Responder las preguntas de diagnóstico de Cultura Organizacional")]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_admin),expression:"$store.state.st_admin"}],staticClass:"waves-effect waves-light red btn",on:{"click":_vm.crearPDF}},[_vm._v("ver PDF")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_modo==='INGRESO'),expression:"$store.state.st_modo==='INGRESO'"}],staticClass:"waves-effect waves-light green btn",on:{"click":_vm.agregarCaso}},[_vm._v("grabar Formulario")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g1pg1),expression:"caso.g1pg1",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g1pg1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g1pg1", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g1pg1=_vm.validarValor(_vm.caso.g1pg1)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g1pg2),expression:"caso.g1pg2",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g1pg2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g1pg2", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g1pg2=_vm.validarValor(_vm.caso.g1pg2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g1pg3),expression:"caso.g1pg3",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g1pg3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g1pg3", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g1pg3=_vm.validarValor(_vm.caso.g1pg3)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g1pg4),expression:"caso.g1pg4",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g1pg4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g1pg4", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g1pg4=_vm.validarValor(_vm.caso.g1pg4)))])]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g1total),expression:"caso.g1total",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.caso.g1total)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g1total", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g1total=_vm.totalG1))])]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.lPendiente= 100 - _vm.caso.g1total))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.lPendiente),expression:"lPendiente",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.lPendiente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lPendiente=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g2pg1),expression:"caso.g2pg1",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g2pg1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g2pg1", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g2pg1=_vm.validarValor(_vm.caso.g2pg1)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g2pg2),expression:"caso.g2pg2",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g2pg2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g2pg2", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g2pg2=_vm.validarValor(_vm.caso.g2pg2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g2pg3),expression:"caso.g2pg3",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g2pg3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g2pg3", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g2pg3=_vm.validarValor(_vm.caso.g2pg3)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g2pg4),expression:"caso.g2pg4",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g2pg4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g2pg4", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g2pg4=_vm.validarValor(_vm.caso.g2pg4)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(21),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g2total),expression:"caso.g2total",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.caso.g2total)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g2total", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g2total=_vm.totalG2))])]),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.lPendiente= 100 - _vm.caso.g2total))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.lPendiente),expression:"lPendiente",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.lPendiente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lPendiente=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_vm._m(23),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g3pg1),expression:"caso.g3pg1",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g3pg1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g3pg1", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g3pg1=_vm.validarValor(_vm.caso.g3pg1)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g3pg2),expression:"caso.g3pg2",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g3pg2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g3pg2", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g3pg2=_vm.validarValor(_vm.caso.g3pg2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g3pg3),expression:"caso.g3pg3",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g3pg3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g3pg3", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g3pg3=_vm.validarValor(_vm.caso.g3pg3)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g3pg4),expression:"caso.g3pg4",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g3pg4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g3pg4", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g3pg4=_vm.validarValor(_vm.caso.g3pg4)))])]),_vm._v(" "),_vm._m(32),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g3total),expression:"caso.g3total",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.caso.g3total)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g3total", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g3total=_vm.totalG3))])]),_vm._v(" "),_vm._m(33),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.lPendiente= 100 - _vm.caso.g3total))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.lPendiente),expression:"lPendiente",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.lPendiente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lPendiente=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_vm._m(34),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_vm._m(35),_vm._v(" "),_vm._m(36),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g4pg1),expression:"caso.g4pg1",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g4pg1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g4pg1", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g4pg1=_vm.validarValor(_vm.caso.g4pg1)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g4pg2),expression:"caso.g4pg2",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g4pg2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g4pg2", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g4pg2=_vm.validarValor(_vm.caso.g4pg2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(39),_vm._v(" "),_vm._m(40),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g4pg3),expression:"caso.g4pg3",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g4pg3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g4pg3", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g4pg3=_vm.validarValor(_vm.caso.g4pg3)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(41),_vm._v(" "),_vm._m(42),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g4pg4),expression:"caso.g4pg4",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g4pg4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g4pg4", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g4pg4=_vm.validarValor(_vm.caso.g4pg4)))])]),_vm._v(" "),_vm._m(43),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g4total),expression:"caso.g4total",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.caso.g4total)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g4total", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g4total=_vm.totalG4))])]),_vm._v(" "),_vm._m(44),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.lPendiente= 100 - _vm.caso.g4total))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.lPendiente),expression:"lPendiente",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.lPendiente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lPendiente=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_vm._m(45),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_vm._m(46),_vm._v(" "),_vm._m(47),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g5pg1),expression:"caso.g5pg1",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g5pg1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g5pg1", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g5pg1=_vm.validarValor(_vm.caso.g5pg1)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(48),_vm._v(" "),_vm._m(49),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g5pg2),expression:"caso.g5pg2",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g5pg2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g5pg2", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g5pg2=_vm.validarValor(_vm.caso.g5pg2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(50),_vm._v(" "),_vm._m(51),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g5pg3),expression:"caso.g5pg3",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g5pg3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g5pg3", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g5pg3=_vm.validarValor(_vm.caso.g5pg3)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(52),_vm._v(" "),_vm._m(53),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g5pg4),expression:"caso.g5pg4",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g5pg4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g5pg4", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g5pg4=_vm.validarValor(_vm.caso.g5pg4)))])]),_vm._v(" "),_vm._m(54),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g5total),expression:"caso.g5total",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.caso.g5total)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g5total", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g5total=_vm.totalG5))])]),_vm._v(" "),_vm._m(55),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.lPendiente= 100 - _vm.caso.g5total))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.lPendiente),expression:"lPendiente",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.lPendiente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lPendiente=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_vm._m(56),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_vm._m(57),_vm._v(" "),_vm._m(58),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g6pg1),expression:"caso.g6pg1",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g6pg1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g6pg1", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g6pg1=_vm.validarValor(_vm.caso.g6pg1)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(59),_vm._v(" "),_vm._m(60),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g6pg2),expression:"caso.g6pg2",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g6pg2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g6pg2", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g6pg2=_vm.validarValor(_vm.caso.g6pg2)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(61),_vm._v(" "),_vm._m(62),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g6pg3),expression:"caso.g6pg3",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g6pg3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g6pg3", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g6pg3=_vm.validarValor(_vm.caso.g6pg3)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(63),_vm._v(" "),_vm._m(64),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g6pg4),expression:"caso.g6pg4",modifiers:{"number":true}}],attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.caso.g6pg4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g6pg4", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g6pg4=_vm.validarValor(_vm.caso.g6pg4)))])]),_vm._v(" "),_vm._m(65),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.caso.g6total),expression:"caso.g6total",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.caso.g6total)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.caso, "g6total", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.caso.g6total=_vm.totalG6))])]),_vm._v(" "),_vm._m(66),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.lPendiente= 100 - _vm.caso.g6total))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.lPendiente),expression:"lPendiente",modifiers:{"number":true}}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.lPendiente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lPendiente=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_admin),expression:"$store.state.st_admin"}],staticClass:"waves-effect waves-light red btn",on:{"click":_vm.crearPDF}},[_vm._v("ver PDF")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_modo==='INGRESO'),expression:"$store.state.st_modo==='INGRESO'"}],staticClass:"waves-effect waves-light green btn",on:{"click":_vm.agregarCaso}},[_vm._v("grabar Formulario")])])]),_vm._v(" "),_c('div',{staticClass:"col s4"},[_c('h5',{staticClass:"center"},[_vm._v("Tabulación de Resultados de diagnóstico de Cultura Organizacional")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('a',{staticClass:"center"},[_vm._v("Preguntas A")]),_vm._v(" "),_c('table',{staticClass:"responsive-table striped hoverable"},[_vm._m(67),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("1A")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g1pg1))])]),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("2A")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g2pg1))])]),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("3A")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g3pg1))])]),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("4A")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g4pg1))])]),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("5A")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g5pg1))])]),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("6A")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g6pg1))])]),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("Suma")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.r1suma= _vm.sumaA))])]),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("Promedio")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.r1prom= _vm.promedioA))])])])])]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('a',{staticClass:"center"},[_vm._v("Preguntas B")]),_vm._v(" "),_c('table',{staticClass:"responsive-table striped hoverable"},[_vm._m(68),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("1B")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g1pg2))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("2B")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g2pg2))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("3B")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g3pg2))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("4B")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g4pg2))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("5B")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g5pg2))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("6B")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g6pg2))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("Suma")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.r2suma= _vm.sumaB))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("Promedio")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.r2prom= _vm.promedioB))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('a',{staticClass:"center"},[_vm._v("Preguntas C")]),_vm._v(" "),_c('table',{staticClass:"responsive-table striped hoverable"},[_vm._m(69),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("1C")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g1pg3))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("2C")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g2pg3))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("3C")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g3pg3))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("4C")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g4pg3))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("5C")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g5pg3))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("6C")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g6pg3))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("Suma")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.r3suma= _vm.sumaC))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("Promedio")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.r3prom= _vm.promedioC))])])])])]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('a',{staticClass:"center"},[_vm._v("Preguntas D")]),_vm._v(" "),_c('table',{staticClass:"responsive-table striped hoverable"},[_vm._m(70),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("1D")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g1pg4))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("2D")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g2pg4))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("3D")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g3pg4))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("4D")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g4pg4))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("5D")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g5pg4))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("6D")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.g6pg4))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("Suma")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.r4suma= _vm.sumaD))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v("Promedio")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(_vm.caso.r4prom= _vm.promedioD))])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para leer las instrucciones u ocultarlas.","data-position":"top"}},[_vm._v("\n                        Leer las Instruciones\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('b',[_vm._v("Esta es una herramienta, que permitirá conocer las diferentes percepciones, acerca de la cultura organizacional de la empresa. ")]),_vm._v(" "),_c('b',[_vm._v("Sus autores Cameron y Quinn (2006), tomando como referencia las cuatro principales corrientes de la administración (relaciones humanas; mercado externo; metas y procesos internos), ")]),_vm._v(" "),_c('b',[_vm._v("han venido trabajando en este instrumento, como un primer acercamiento del estado actual y el estado deseado de la organización.")]),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Esta herramienta ha sido utilizada por diversidad de empresas desde el año 1985, la cual se integra en seis áreas importantes, que a su vez, ")]),_vm._v(" "),_c('b',[_vm._v("presentan una subdivisión en cuatro alternativas.  Para cada área, usted dispone de 100 puntos, los cuales puede distribuir entre los cuatro planteamientos, ")]),_vm._v(" "),_c('b',[_vm._v("a su mejor discreción, vale decir, que si una de las cuatro alternativas para usted es la única o mejor de todas, puede adjudicarle los 100 puntos; ")]),_vm._v(" "),_c('b',[_vm._v("caso contrario, puede distribuirlos entre dos, tres o las cuatro.  Por ejemplo, en la pregunta 1, si la organización “a” parece muy similar a la mía, ")]),_vm._v(" "),_c('b',[_vm._v("la “b” parece poco familiar, la “c” y “d” no, usted puede distribuir entre las dos primeras los puntos, como usted considere conveniente. ")]),_vm._v(" "),_c('b',[_vm._v("Primero se llenará la cultura actual.")]),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Haga click en el título de cada uno de los seis (6) recuadros para responder a las preguntas.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waves-effect waves-light collapsible-header"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para responder las preguntas de esta área","data-position":"top"}},[_vm._v("\n                                    1. Características Dominantes\n                                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("A")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("La organización A es un lugar muy personal.  Es como una familia extensa.  La gente parece compartir mucho de sí.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("B")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("La organización B es un lugar muy dinámico y activo.  La gente está dispuesta a correr riesgos.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("C")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("La organización C es un lugar muy formal y estructurado.  Los procedimientos burocráticos generalmente gobiernan lo que hace la gente.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("D")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("La organización D tiene una orientación muy competitiva. Una de las principales preocupaciones es que se haga el trabajo.  La gente está muy orientada hacia la producción y los logros.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"blue"}},[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"red"}},[_vm._v("Pendiente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waves-effect waves-light collapsible-header"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para responder las preguntas de esta área","data-position":"top"}},[_vm._v("\n                                    2. Líder Organizacional\n                                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("A")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("Generalmente se considera al jefe de la organización A un mentor, un facilitador, o una figura paternal.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("B")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("Generalmente se considera al jefe de la organización B un empresario, un innovador o alguien que corre riesgos.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("C")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("Generalmente se considera al jefe de la organización C un coordinador, un organizador o un experto en eficiencia.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("D")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("Generalmente se considera al jefe de la organización D un productor, un competidor o un hombre exigente.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"blue"}},[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"red"}},[_vm._v("Pendiente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waves-effect waves-light collapsible-header"},[_c('span',{staticClass:"center tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para responder las preguntas de esta área","data-position":"top"}},[_vm._v("\n                                    3. Cohesión Organizacional\n                                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("A")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("Lo que mantiene unida a la organización A es la lealtad y el compromiso.  La cohesión y el trabajo en equipo son características de esta organización.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("B")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("Lo que mantiene unida a la organización B es un enfoque en la innovación y el desarrollo.  Se pone énfasis en estar lo más actualizado posible.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("C")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("Lo que mantiene unida a la organización C son los procedimientos, las reglas o las políticas formales.  Mantener una organización que trabaja sin problemas es importante.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("D")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("Lo que mantiene unida a la organización D es un énfasis en la producción y el logro de metas.  La agresividad de mercado es un tema común.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"blue"}},[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"red"}},[_vm._v("Pendiente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waves-effect waves-light collapsible-header"},[_c('span',{staticClass:"center tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para responder las preguntas de esta área","data-position":"top"}},[_vm._v("\n                                    4. Clima Organizacional\n                                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("A")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("El clima en la organización A es participativo y agradable.  Existe un alto grado de confianza y apertura.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("B")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("El clima en la organización B enfatiza el dinamismo y la prontitud para enfrentar nuevos desafíos. Es común probar nuevas cosas y aprender por tanteo.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("C")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("El clima en la organización C enfatiza la estabilidad y la permanencia.  Las expectativas referentes a los procedimientos son claras y vigentes.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("D")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("El clima en la organización D es competitivo y de enfrentamiento.  Se pone énfasis en ganarle a la competencia.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"blue"}},[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"red"}},[_vm._v("Pendiente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waves-effect waves-light collapsible-header"},[_c('span',{staticClass:"center tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para responder las preguntas de esta área","data-position":"top"}},[_vm._v("\n                                    5. Criterios de Exito\n                                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("A")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("La organización A define el éxito con base en su desarrollo de recursos humanos, trabajo en equipo e interés en las personas.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("B")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("La organización B define el éxito con base en su tenencia de productos únicos o totalmente nuevos.  Es un líder e innovador de productos y servicios.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("C")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("La organización C define el éxito con base en la eficiencia.  La entrega confiable, la programación sin obstáculos y la producción a bajo costo son decisivos.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("D")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("La organización D define el éxito con base en la penetración de mercado y la participación de mercado.  Ser el número uno en relación con la competencia es un objetivo clave.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"blue"}},[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"red"}},[_vm._v("Pendiente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waves-effect waves-light collapsible-header"},[_c('span',{staticClass:"center tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para responder las preguntas de esta área","data-position":"top"}},[_vm._v("\n                                    6. Estilo Gerencial\n                                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("A")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("El estilo gerencial de la organización A se caracteriza por el trabajo en equipo, el consenso y la participación.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("B")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("El estilo gerencial de la organización B se caracteriza por iniciativa individual, innovación, libertad y originalidad.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("C")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("El estilo gerencial de la organización C se caracteriza por la seguridad del empleo, longevidad en el puesto y predecibilidad.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s1"},[_c('span',[_vm._v("D")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s9"},[_c('span',[_vm._v("El clima en la organización D es competitivo y de enfrentamiento.  Se pone énfasis en ganarle a la competencia.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"blue"}},[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s10"},[_c('span',{staticClass:"right",staticStyle:{"color":"red"}},[_vm._v("Pendiente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Punteo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Punteo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Punteo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Punteo")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_culturaGlistado_js__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2852f03e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_culturaGlistado_vue__ = __webpack_require__(318);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_culturaGlistado_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2852f03e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_culturaGlistado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_culturaGCasosTotal_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26fdc0fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_culturaGCasosTotal_vue__ = __webpack_require__(315);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_culturaGCasosTotal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26fdc0fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_culturaGCasosTotal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.totaldeCasos)+" casos en Total. "+_vm._s(_vm.laEmpresa)+" ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_culturaGPagineo_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a84b1cb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_culturaGPagineo_vue__ = __webpack_require__(317);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_culturaGPagineo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a84b1cb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_culturaGPagineo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col s9"},[_vm._v("\n        Pág. "+_vm._s(_vm.npagina)+" ["+_vm._s(_vm.liminf+1)+" - "+_vm._s(_vm.limsup)+"] | "+_vm._s(_vm.mensaje)+" encontrados "+_vm._s(_vm.lista.length)+" \n    ")]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('a',{staticClass:"btn waves-effect btn-small waves-light btn-floating secondary-content blue z-depth-5 tooltipped",class:_vm.pagina>1 ? 'pulse': '',attrs:{"data-position":"top","data-tooltip":"Página anterior"},on:{"click":function($event){_vm.anterior({lista: _vm.lista,fuente: _vm.fuente})}}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])]),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('a',{staticClass:"btn waves-effect btn-small waves-light btn-floating secondary-content blue z-depth-5 tooltipped",class:_vm.pagina===1 ? 'pulse': '',attrs:{"data-position":"top","data-tooltip":"Página siguiente"},on:{"click":function($event){_vm.siguiente({lista: _vm.lista,fuente: _vm.fuente})}}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('label',[_vm._v("Filtrar los casos participantes por Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],attrs:{"type":"text"},domProps:{"value":(_vm.busqueda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('label',[_vm._v("Filtrar los casos participantes por Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busquedaR),expression:"busquedaR"}],attrs:{"type":"text"},domProps:{"value":(_vm.busquedaR)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busquedaR=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('casosxEmpresa',{attrs:{"busqueda":_vm.busqueda}})],1),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('pagineo',{attrs:{"lista":_vm.casos,"liminf":_vm.lc_ini,"limsup":_vm.lc_fin,"npagina":_vm.c_pagina,"fuente":_vm.lfuente}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('table',{staticClass:"responsive-table striped hoverable"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.filtrarCasos),function(elcaso,index){return (index>=_vm.lc_ini && index <=_vm.lc_fin-1)?_c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(elcaso.empresa))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(elcaso.nombre))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(elcaso.r1prom))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(elcaso.r2prom))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(elcaso.r3prom))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(elcaso.r4prom))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_c('a',{staticClass:"btn btn-small darken-1 blue tooltipped",attrs:{"data-position":"top","data-tooltip":"Seleccionar Evaluación"},on:{"click":function($event){_vm.mostrarCaso(elcaso)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("remove_red_eye")])])]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_c('a',{staticClass:"btn btn-small darken-1 red tooltipped",attrs:{"data-position":"top","data-tooltip":"Eliminar Evaluación"},on:{"click":function($event){_vm.eliminarCaso(elcaso,elcaso.llave)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()}))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Empresa")]),_vm._v(" "),_c('th',[_vm._v("Partipante")]),_vm._v(" "),_c('th',[_vm._v("Prom. A")]),_vm._v(" "),_c('th',[_vm._v("Prom. B")]),_vm._v(" "),_c('th',[_vm._v("Prom. C")]),_vm._v(" "),_c('th',[_vm._v("Prom. D")]),_vm._v(" "),_c('th',[_vm._v("Acciones")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"center col s12"},[_c('ul',{staticClass:"tabs"},[_vm._m(0),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.st_admin),expression:"$store.state.st_admin"}],staticClass:"tab col s3"},[_c('a',{attrs:{"href":"#testt2"}},[_vm._v("Lista de Casos")])])])]),_vm._v(" "),_c('div',{ref:"testt1",attrs:{"id":"testt1"}},[_c('formulario')],1),_vm._v(" "),_c('div',{ref:"testt2",attrs:{"id":"testt2"}},[_c('listado')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab col s3"},[_c('a',{staticClass:"active",attrs:{"href":"#testt1"}},[_vm._v("Formulario")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev01_tipologia_js__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bec301c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev01_tipologia_vue__ = __webpack_require__(321);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev01_tipologia_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bec301c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev01_tipologia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s2"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Departamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.depto),expression:"eval_tipolo.depto"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_tipolo.depto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_tipolo, "depto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.empresa),expression:"eval_tipolo.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_tipolo.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_tipolo, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.nombre),expression:"eval_tipolo.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_tipolo.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_tipolo, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Sexo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.sexo),expression:"eval_tipolo.sexo"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_tipolo.sexo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_tipolo, "sexo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_tipolo.empezo))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finalizoeval),expression:"finalizoeval"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_tipolo.termino))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para LEER u OCULTAR las instrucciones.","data-position":"top"}},[_vm._v("\n                                   "+_vm._s(_vm.instrucciones)+"\n                              ")])]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{attrs:{"align":"justify"}},[_vm._v("\n                                   Este cuestionario sólo pretende conocer mejor las principales características de su personalidad. Por favor procure responder cada pregunta con la mayor sinceridad posible, usted será el unico beneficiado. El cuestionario está diseñado para identificar aspectos de tipo general y no pretende ser un análisis detallado de su personalidad Por favor lea cada pregunta y seleccione una respuesta, si no está seguro, seleccione la respuesta que mejor se aproxime a sus características."),_c('br'),_c('br'),_vm._v("\n                                   Seleccione sus respuetas (a) o (b) en el formulario.\n                                   Las preguntas están organizadas en tres (3) secciones. Sección 1: De la 1 a la 23, Sección 2: de la 24 a la 46 y Sección 3: de la 47 a la 70."),_c('br'),_c('br'),_vm._v("\n                                   \n                                   Inicialmente todas las preguntas estarán en color "),_c('span',{staticStyle:{"font-weight":"bold","color":"red"}},[_vm._v("rojo")]),_vm._v(" como indicador\n                                   que aún no han sido respondidas. Conforme vaya respondiendo, las preguntas se mostrarán en color negro. También tendrá un mensaje indicándole la cantidad \n                                   de preguntas que aún no han sido respondidas. El siguiente "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("ejemplo")]),_vm._v(" de tres preguntas le permitirá estar seguro que comprende lo que debe hacer en el propio cuestionario."),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.ejeSinResponder>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_ejeSinResponder))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg001===0 ? "color:red" : "color:black")},[_vm._v("01. ¿ Usted prefiere ...")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"1","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"1")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) hacer deporte ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"2","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"2")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) leer ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg002===0 ? "color:red" : "color:black")},[_vm._v("02. Cuando amanece frio, usted prefiere ... ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"1","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"1")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) seguir durmiendo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"2","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"2")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) hacer ejercicios")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg003===0 ? "color:red" : "color:black")},[_vm._v("03. Qué es peor ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg003),expression:"ejemplo.pg003"}],attrs:{"value":"1","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg003,"1")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg003", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) dejar de comprar el número de la lotería\"")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg003),expression:"ejemplo.pg003"}],attrs:{"value":"2","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg003,"2")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg003", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) \"dejar de asistir a una cita de trabajo\"")])])])])]),_vm._v("\n                                   Recuerde que no hay respuestas correctas o incorrectas. Tampoco existe un tipo menor de personalidad\n                                   que otro. Somos diferentes, pero no superiores ni inferiores a otros. Queremos entender la naturaleza de\n                                   esas diferencias para mejorar nuestro desempeño personal y profesional."),_c('br'),_vm._v(" "),_vm._m(0)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12"},[_c('div',{staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("Empezar Evaluación de TIPOLOGIA DE LA PERSONALIDAD")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s12"},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s4"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt1"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("Preguntas 01 - 23")])]),_vm._v(" "),_c('li',{staticClass:"tab col s4"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt2"},on:{"click":function($event){_vm.nadaG1(2)}}},[_vm._v("Preguntas 24 - 46")])]),_vm._v(" "),_c('li',{staticClass:"tab col s4"},[_c('a',{ref:"testtt3",class:_vm.activott3,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt3","href":"#testt3"},on:{"click":function($event){_vm.nadaG1(3)}}},[_vm._v("Preguntas 47 - 70")])])]),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.pregSinContestar>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_sinResponder))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt1"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg001===0 ? "color:red" : "color:black")},[_vm._v("01. ¿ En una fiesta interactúa usted")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg001),expression:"eval_tipolo.pg001"}],ref:"pg1",attrs:{"value":"1","name":"group1","type":"radio","checked":"","autofocus":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg001,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg001", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) con muchas personas, incluyendo desconocidas ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg001),expression:"eval_tipolo.pg001"}],attrs:{"value":"2","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg001,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg001", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) con pocas personas, conocidas por usted ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg002===0 ? "color:red" : "color:black")},[_vm._v("02. Es usted ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg002),expression:"eval_tipolo.pg002"}],attrs:{"value":"1","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg002,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg002", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Más realista que especulativo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg002),expression:"eval_tipolo.pg002"}],attrs:{"value":"2","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg002,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg002", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Más especulativo que realista")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg003===0 ? "color:red" : "color:black")},[_vm._v("03. Qué es peor ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg003),expression:"eval_tipolo.pg003"}],attrs:{"value":"1","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg003,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg003", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) tener su mente en \"las nubes\"")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg003),expression:"eval_tipolo.pg003"}],attrs:{"value":"2","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg003,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg003", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) \"vivir en una rutina\"")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg004===0 ? "color:red" : "color:black")},[_vm._v("04. Qué le impresiona a usted más ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg004),expression:"eval_tipolo.pg004"}],attrs:{"value":"1","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg004,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg004", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) los principios ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg004),expression:"eval_tipolo.pg004"}],attrs:{"value":"2","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg004,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg004", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) las emociones ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg005===0 ? "color:red" : "color:black")},[_vm._v("05. Es usted más atraído por ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg005),expression:"eval_tipolo.pg005"}],attrs:{"value":"1","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg005,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg005", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) lo convincente aunque sea teórico ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg005),expression:"eval_tipolo.pg005"}],attrs:{"value":"2","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg005,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg005", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) lo experimentable ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg006===0 ? "color:red" : "color:black")},[_vm._v("06. Prefiere usted trabajar ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg006),expression:"eval_tipolo.pg006"}],attrs:{"value":"1","name":"group6","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg006,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg006", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) con base en fechas límites ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg006),expression:"eval_tipolo.pg006"}],attrs:{"value":"2","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg006,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg006", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) de acuerdo a \"cuando se pueda\" ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg007===0 ? "color:red" : "color:black")},[_vm._v("07. Toma usted sus decisiones ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg007),expression:"eval_tipolo.pg007"}],attrs:{"value":"1","name":"group7","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg007,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg007", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Muy cuidadosamente ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg007),expression:"eval_tipolo.pg007"}],attrs:{"value":"2","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg007,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg007", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) algo impulsivamente ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg008===0 ? "color:red" : "color:black")},[_vm._v("08. Cuando usted va a una fiesta ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg008),expression:"eval_tipolo.pg008"}],attrs:{"value":"1","name":"group8","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg008,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg008", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) se queda hasta muy tarde y sus energías crecen ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg008),expression:"eval_tipolo.pg008"}],attrs:{"value":"2","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg008,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg008", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) se retira temprano y con energías reducidas ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg009===0 ? "color:red" : "color:black")},[_vm._v("09. A usted le atraen más ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg009),expression:"eval_tipolo.pg009"}],attrs:{"value":"1","name":"group9","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg009,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg009", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) las personas sensibles? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg009),expression:"eval_tipolo.pg009"}],attrs:{"value":"2","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg009,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg009", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) las personas imaginativas ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg010===0 ? "color:red" : "color:black")},[_vm._v("10. Está o es usted más interesado por")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg010),expression:"eval_tipolo.pg010"}],attrs:{"value":"1","name":"group10","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg010,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg010", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) lo que es real ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg010),expression:"eval_tipolo.pg010"}],attrs:{"value":"2","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg010,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg010", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) lo que es posible ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg011===0 ? "color:red" : "color:black")},[_vm._v("11. Cuando usted juzga a otras personas, es influido ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg011),expression:"eval_tipolo.pg011"}],attrs:{"value":"1","name":"group11","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg011,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg011", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) más por leyes o normas que p or circunstancias ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg011),expression:"eval_tipolo.pg011"}],attrs:{"value":"2","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg011,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg011", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) más por las circunstancias que por las leyes ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg012===0 ? "color:red" : "color:black")},[_vm._v("12. Cuando se relaciona o se dirige a otras personas, su inclinación es más ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg012),expression:"eval_tipolo.pg012"}],attrs:{"value":"1","name":"group12","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg012,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg012", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) objetiva ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg012),expression:"eval_tipolo.pg012"}],attrs:{"value":"2","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg012,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg012", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) personal ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg013===0 ? "color:red" : "color:black")},[_vm._v("13. En general, usted tiende a ser ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg013),expression:"eval_tipolo.pg013"}],attrs:{"value":"1","name":"group13","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg013,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg013", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) puntual en sus responsabilidades ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg013),expression:"eval_tipolo.pg013"}],attrs:{"value":"2","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg013,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg013", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) algo impuntual, a veces se atrasa?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg014===0 ? "color:red" : "color:black")},[_vm._v("14. Qué le molesta más a usted ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg014),expression:"eval_tipolo.pg014"}],attrs:{"value":"1","name":"group14","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg014,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg014", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) tener sus cosas sin terminar ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg014),expression:"eval_tipolo.pg014"}],attrs:{"value":"2","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg014,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg014", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) tener sus cosas terminadas ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg015===0 ? "color:red" : "color:black")},[_vm._v("15. En los grupos sociales se mantiene usted ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg015),expression:"eval_tipolo.pg015"}],attrs:{"value":"1","name":"group15","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg015,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg015", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) informado de lo que le pasa a otros ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg015),expression:"eval_tipolo.pg015"}],attrs:{"value":"2","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg015,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg015", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) apartado de las noticias sobre lo que le pasa a otros ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg016===0 ? "color:red" : "color:black")},[_vm._v("16. Cuando usted debe hacer cosas ordinarias o normales ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg016),expression:"eval_tipolo.pg016"}],attrs:{"value":"1","name":"group16","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg016,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg016", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) las hace en forma convencional ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg016),expression:"eval_tipolo.pg016"}],attrs:{"value":"2","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg016,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg016", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) las hace a su propia manera ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg017===0 ? "color:red" : "color:black")},[_vm._v("17.  Los escritores deberían ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg017),expression:"eval_tipolo.pg017"}],attrs:{"value":"1","name":"group17","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg017,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg017", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) decir lo que ellos quieren decir e interpretar ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg017),expression:"eval_tipolo.pg017"}],attrs:{"value":"2","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg017,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg017", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) expresar las cosas más bien en forma de analogías ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg018===0 ? "color:red" : "color:black")},[_vm._v("18. Qué le atrae a usted más ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg018),expression:"eval_tipolo.pg018"}],attrs:{"value":"1","name":"group18","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg018,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg018", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) consistencia en el razonamiento ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg018),expression:"eval_tipolo.pg018"}],attrs:{"value":"2","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg018,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg018", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) armonía en las relaciones humanas ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg019===0 ? "color:red" : "color:black")},[_vm._v("19. Usted se siente mejor emitiendo ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg019),expression:"eval_tipolo.pg019"}],attrs:{"value":"1","name":"group19","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg019,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg019", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) juicios lógicos ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg019),expression:"eval_tipolo.pg019"}],attrs:{"value":"2","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg019,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg019", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) juicios basados en valores ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg020===0 ? "color:red" : "color:black")},[_vm._v("20. Cómo prefiere usted las cosas ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg020),expression:"eval_tipolo.pg020"}],attrs:{"value":"1","name":"group20","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg020,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg020", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) establecidas y decididas ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg020),expression:"eval_tipolo.pg020"}],attrs:{"value":"2","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg020,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg020", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no establecidas y no decididas ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg021===0 ? "color:red" : "color:black")},[_vm._v("21. Diría usted que se considera ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg021),expression:"eval_tipolo.pg021"}],attrs:{"value":"1","name":"group21","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg021,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg021", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) determinado ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg021),expression:"eval_tipolo.pg021"}],attrs:{"value":"2","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg021,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg021", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) flexible ?")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg022===0 ? "color:red" : "color:black")},[_vm._v("22. Cuando usted va a hacer una llamada telefónica ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg022),expression:"eval_tipolo.pg022"}],attrs:{"value":"1","name":"group22","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg022,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg022", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) rara vez repasa que es lo que va a adecir en forma completa ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg022),expression:"eval_tipolo.pg022"}],attrs:{"value":"2","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg022,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg022", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) repasa lo que va a decir ?")])])]),_c('br')]),_vm._v(" "),_c('div',{ref:"area1",staticClass:"input-field col s4",attrs:{"id":"area1"}},[_c('span',{style:(_vm.eval_tipolo.pg023===0 ? "color:red" : "color:black")},[_vm._v("23. Los hechos ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg023),expression:"eval_tipolo.pg023"}],attrs:{"value":"1","name":"group23","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg023,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg023", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) hablan por sí mismos ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg023),expression:"eval_tipolo.pg023"}],attrs:{"value":"2","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg023,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg023", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) ilustran principios ?")])])]),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt2"}},[_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg024===0 ? "color:red" : "color:black")},[_vm._v("24. Las personas visionarias ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg024),expression:"eval_tipolo.pg024"}],attrs:{"value":"1","name":"group24","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg024,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg024", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) son algo molestas ?  ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg024),expression:"eval_tipolo.pg024"}],attrs:{"value":"2","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg024,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg024", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) son facinantes ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg025===0 ? "color:red" : "color:black")},[_vm._v("25. Usted es una persona ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg025),expression:"eval_tipolo.pg025"}],attrs:{"value":"1","name":"group25","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg025,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg025", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) que actúa con \"cabeza fría\" ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg025),expression:"eval_tipolo.pg025"}],attrs:{"value":"2","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg025,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg025", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) que actúa con \"corazón caliente\" ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg026===0 ? "color:red" : "color:black")},[_vm._v("26. Es peor ser ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg026),expression:"eval_tipolo.pg026"}],attrs:{"value":"1","name":"group26","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg026,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg026", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) injusto ?\"")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg026),expression:"eval_tipolo.pg026"}],attrs:{"value":"2","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg026,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg026", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) poco comprensivo, tener poca compasión ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg027===0 ? "color:red" : "color:black")},[_vm._v("27. Uno debería dejar que los eventos ocurrieran")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg027),expression:"eval_tipolo.pg027"}],attrs:{"value":"1","name":"group27","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg027,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg027", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) solo por cuidadosa selección ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg027),expression:"eval_tipolo.pg027"}],attrs:{"value":"2","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg027,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg027", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) de acuerdo a la suerte o al azar ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg028===0 ? "color:red" : "color:black")},[_vm._v("28. Usted se siente mejor ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg028),expression:"eval_tipolo.pg028"}],attrs:{"value":"1","name":"group28","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg028,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg028", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) habiendo comprado algo ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg028),expression:"eval_tipolo.pg028"}],attrs:{"value":"2","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg028,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg028", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) habiendo tenido la opción para comprar, aún sin haberlo comprado ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg029===0 ? "color:red" : "color:black")},[_vm._v("29. Cuando usted está con otra persona ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg029),expression:"eval_tipolo.pg029"}],attrs:{"value":"1","name":"group29","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg029,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg029", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) inicia la conversación ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg029),expression:"eval_tipolo.pg029"}],attrs:{"value":"2","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg029,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg029", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) espera que la otra persona la inice ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg030===0 ? "color:red" : "color:black")},[_vm._v("30. El sentido común es ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg030),expression:"eval_tipolo.pg030"}],attrs:{"value":"1","name":"group30","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg030,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg030", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) raramente cuestionable ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg030),expression:"eval_tipolo.pg030"}],attrs:{"value":"2","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg030,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg030", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) frecuentemente cuestionable ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg031===0 ? "color:red" : "color:black")},[_vm._v("31. Usted aprecia más en los niños ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg031),expression:"eval_tipolo.pg031"}],attrs:{"value":"1","name":"group31","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg031,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg031", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) que ellos practiquen sus propias habilidades ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg031),expression:"eval_tipolo.pg031"}],attrs:{"value":"2","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg031,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg031", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) que ellos ejerciten sus fantasías ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg032===0 ? "color:red" : "color:black")},[_vm._v("32. En la forma de decisiones se siente usted mejor considerando ___________ como base ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg032),expression:"eval_tipolo.pg032"}],attrs:{"value":"1","name":"group32","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg032,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg032", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) criterios fijos (estandares) ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg032),expression:"eval_tipolo.pg032"}],attrs:{"value":"2","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg032,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg032", "2")}}}),_vm._v(" "),_c('span',[_vm._v("¿ sentimientos ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg033===0 ? "color:red" : "color:black")},[_vm._v("33. Está o es usted más interesado porEs usted ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg033),expression:"eval_tipolo.pg033"}],attrs:{"value":"1","name":"group33","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg033,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg033", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) más firme que gentil ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg033),expression:"eval_tipolo.pg033"}],attrs:{"value":"2","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg033,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg033", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) más gentil que firme ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg034===0 ? "color:red" : "color:black")},[_vm._v("34. Qué es más admirable")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg034),expression:"eval_tipolo.pg034"}],attrs:{"value":"1","name":"group34","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg034,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg034", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) la habilidad para organizar y ser metódico ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg034),expression:"eval_tipolo.pg034"}],attrs:{"value":"2","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg034,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg034", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) la habilidad para adaptarse y ejecutar las cosas ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg035===0 ? "color:red" : "color:black")},[_vm._v("35. Qué valora usted mas ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg035),expression:"eval_tipolo.pg035"}],attrs:{"value":"1","name":"group35","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg035,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg035", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) lo definido ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg035),expression:"eval_tipolo.pg035"}],attrs:{"value":"2","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg035,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg035", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) lo flexible ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg036===0 ? "color:red" : "color:black")},[_vm._v("36. Cuando usted experimenta nuevas o interacciones personales no rutinarias ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg036),expression:"eval_tipolo.pg036"}],attrs:{"value":"1","name":"group36","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg036,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg036", "1")}}}),_vm._v(" "),_c('span',[_vm._v("a) se siente usted con más estímulo y energía ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg036),expression:"eval_tipolo.pg036"}],attrs:{"value":"2","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg036,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg036", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) siente usted que su energía se reduce ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg037===0 ? "color:red" : "color:black")},[_vm._v("37. Usted es más frecuentemente una ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg037),expression:"eval_tipolo.pg037"}],attrs:{"value":"1","name":"group37","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg037,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg037", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) persona de tipo práctico ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg037),expression:"eval_tipolo.pg037"}],attrs:{"value":"2","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg037,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg037", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) persona de tipo imaginativo ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg038===0 ? "color:red" : "color:black")},[_vm._v("38. Usted tiende más a ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg038),expression:"eval_tipolo.pg038"}],attrs:{"value":"1","name":"group38","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg038,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg038", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) ver como otros pueden ser utiles ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg038),expression:"eval_tipolo.pg038"}],attrs:{"value":"2","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg038,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg038", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) ver como otros ven y perciben ?")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg039===0 ? "color:red" : "color:black")},[_vm._v("39. Qué le satisface más ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg039),expression:"eval_tipolo.pg039"}],attrs:{"value":"1","name":"group39","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg039,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg039", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) discutir un asunto exahustivante ?  ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg039),expression:"eval_tipolo.pg039"}],attrs:{"value":"2","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg039,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg039", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) arribar a una decisión en un asunto ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg040===0 ? "color:red" : "color:black")},[_vm._v("40. Qué le controla a usted más ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg040),expression:"eval_tipolo.pg040"}],attrs:{"value":"1","name":"group40","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg040,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg040", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) la cabeza ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg040),expression:"eval_tipolo.pg040"}],attrs:{"value":"2","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg040,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg040", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) el corazón ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg041===0 ? "color:red" : "color:black")},[_vm._v("41. Se siente usted mejor con un trabajo ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg041),expression:"eval_tipolo.pg041"}],attrs:{"value":"1","name":"group41","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg041,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg041", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) siendo contratado, fijo ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg041),expression:"eval_tipolo.pg041"}],attrs:{"value":"2","name":"group41","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg041,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg041", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) hecho en forma casual ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg042===0 ? "color:red" : "color:black")},[_vm._v("42. Tiende usted a buscar ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg042),expression:"eval_tipolo.pg042"}],attrs:{"value":"1","name":"group42","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg042,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg042", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) lo ordenado ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg042),expression:"eval_tipolo.pg042"}],attrs:{"value":"2","name":"group42","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg042,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg042", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) \"lo que salga\" ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg043===0 ? "color:red" : "color:black")},[_vm._v("43. Usted prefiere ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg043),expression:"eval_tipolo.pg043"}],attrs:{"value":"1","name":"group43","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg043,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg043", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) muchos amigos y poco contacto con ellos ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg043),expression:"eval_tipolo.pg043"}],attrs:{"value":"2","name":"group43","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg043,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg043", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) pocos amigos y mucho contacto con ellos ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg044===0 ? "color:red" : "color:black")},[_vm._v("44. Usted busca mas ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg044),expression:"eval_tipolo.pg044"}],attrs:{"value":"1","name":"group44","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg044,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg044", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) los hechos ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg044),expression:"eval_tipolo.pg044"}],attrs:{"value":"2","name":"group44","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg044,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg044", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) los principios ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg045===0 ? "color:red" : "color:black")},[_vm._v("45. Que le interesa a usted más ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg045),expression:"eval_tipolo.pg045"}],attrs:{"value":"1","name":"group45","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg045,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg045", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Producción y distribución ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg045),expression:"eval_tipolo.pg045"}],attrs:{"value":"2","name":"group45","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg045,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg045", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Diseño e investigación ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg046===0 ? "color:red" : "color:black")},[_vm._v("46. Cuál frase le agradaría a usted escuchar más ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg046),expression:"eval_tipolo.pg046"}],attrs:{"value":"1","name":"group46","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg046,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg046", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) \"esa es una persona muy lógica\" ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg046),expression:"eval_tipolo.pg046"}],attrs:{"value":"2","name":"group46","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg046,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg046", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) \"esa es una persona muy sentimental\" ?")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(1)}}},[_vm._m(2)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(3)}}},[_vm._m(3)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt3),expression:"vertt3"}],ref:"testt3",attrs:{"id":"testt3"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg047===0 ? "color:red" : "color:black")},[_vm._v("47. Qué valora más, en usted mismo ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg047),expression:"eval_tipolo.pg047"}],attrs:{"value":"1","name":"group47","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg047,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg047", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) ser seguro, no dudoso. ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg047),expression:"eval_tipolo.pg047"}],attrs:{"value":"2","name":"group47","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg047,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg047", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) ser fiel, devoto, comprometido ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg048===0 ? "color:red" : "color:black")},[_vm._v("48. Que prefiere usted con más frecuencia")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg048),expression:"eval_tipolo.pg048"}],attrs:{"value":"1","name":"group48","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg048,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg048", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) afirmaciones finales e inalterables")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg048),expression:"eval_tipolo.pg048"}],attrs:{"value":"2","name":"group48","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg048,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg048", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) afirmaciones preliminares y tentativas")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg049===0 ? "color:red" : "color:black")},[_vm._v("49. Usted se siente más confortable ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg049),expression:"eval_tipolo.pg049"}],attrs:{"value":"1","name":"group49","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg049,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg049", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) después de tomar una decisión ? \"")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg049),expression:"eval_tipolo.pg049"}],attrs:{"value":"2","name":"group49","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg049,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg049", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) antes de tomar una decisión ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg050===0 ? "color:red" : "color:black")},[_vm._v("50.  Usted ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg050),expression:"eval_tipolo.pg050"}],attrs:{"value":"1","name":"group50","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg050,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg050", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) habla fácil y largamente con extraños ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg050),expression:"eval_tipolo.pg050"}],attrs:{"value":"2","name":"group50","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg050,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg050", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) encuentra poco que decir a los extraños ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg051===0 ? "color:red" : "color:black")},[_vm._v("51. Usted se siente mejor ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg051),expression:"eval_tipolo.pg051"}],attrs:{"value":"1","name":"group51","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg051,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg051", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) experiencia ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg051),expression:"eval_tipolo.pg051"}],attrs:{"value":"2","name":"group51","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg051,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg051", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) corazonadas, intuición ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg052===0 ? "color:red" : "color:black")},[_vm._v("52. Usted se percibe como una persona ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg052),expression:"eval_tipolo.pg052"}],attrs:{"value":"1","name":"group52","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg052,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg052", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) más práctica que ingeniosa ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg052),expression:"eval_tipolo.pg052"}],attrs:{"value":"2","name":"group52","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg052,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg052", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) más ingeniosa que práctica ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg053===0 ? "color:red" : "color:black")},[_vm._v("53. Cuál persona merece más reconocimiento ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg053),expression:"eval_tipolo.pg053"}],attrs:{"value":"1","name":"group53","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg053,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg053", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) una con claro razonamiento y lógica ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg053),expression:"eval_tipolo.pg053"}],attrs:{"value":"2","name":"group53","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg053,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg053", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) una con sentimientos profundos ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg054===0 ? "color:red" : "color:black")},[_vm._v("54. Usted tiende a ser más ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg054),expression:"eval_tipolo.pg054"}],attrs:{"value":"1","name":"group54","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg054,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg054", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) justo, objetivo ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg054),expression:"eval_tipolo.pg054"}],attrs:{"value":"2","name":"group54","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg054,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg054", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) empático, subjetivo ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg055===0 ? "color:red" : "color:black")},[_vm._v("55. Usted prefiere ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg055),expression:"eval_tipolo.pg055"}],attrs:{"value":"1","name":"group55","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg055,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg055", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) estar seguro de que las cosas y detalles están bien arreglados ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg055),expression:"eval_tipolo.pg055"}],attrs:{"value":"2","name":"group55","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg055,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg055", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) dejar que las cosas pasen con flexibilidad ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg056===0 ? "color:red" : "color:black")},[_vm._v("56. En las relaciones personales, las cosas deberían ser ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg056),expression:"eval_tipolo.pg056"}],attrs:{"value":"1","name":"group56","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg056,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg056", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) renegociables, redefinibles ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg056),expression:"eval_tipolo.pg056"}],attrs:{"value":"2","name":"group56","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg056,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg056", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) circunstanciales, espontáneas ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg057===0 ? "color:red" : "color:black")},[_vm._v("57. Cuando el teléfono suena ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg057),expression:"eval_tipolo.pg057"}],attrs:{"value":"1","name":"group57","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg057,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg057", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) usted quiere ser el primero en contestar ?  ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg057),expression:"eval_tipolo.pg057"}],attrs:{"value":"2","name":"group57","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg057,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg057", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) usted desea que alguien más lo conteste ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg058===0 ? "color:red" : "color:black")},[_vm._v("58. Qué aprecia usted más de una persona")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg058),expression:"eval_tipolo.pg058"}],attrs:{"value":"1","name":"group58","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg058,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg058", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) un fuerte sentido de la realidad ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg058),expression:"eval_tipolo.pg058"}],attrs:{"value":"2","name":"group58","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg058,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg058", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) una viva imaginación ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg059===0 ? "color:red" : "color:black")},[_vm._v("59. Usted es más atraído ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg059),expression:"eval_tipolo.pg059"}],attrs:{"value":"1","name":"group59","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg059,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg059", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) por lo fundamental, lo básico en cada situación ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg059),expression:"eval_tipolo.pg059"}],attrs:{"value":"2","name":"group59","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg059,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg059", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) lo sobresaliente, lo distinto en cada situación ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg060===0 ? "color:red" : "color:black")},[_vm._v("60. Qué error es más grave ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg060),expression:"eval_tipolo.pg060"}],attrs:{"value":"1","name":"group60","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg060,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg060", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) ser demasiado apasionado ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg060),expression:"eval_tipolo.pg060"}],attrs:{"value":"2","name":"group60","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg060,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg060", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) ser demasiado objetivo ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg061===0 ? "color:red" : "color:black")},[_vm._v("61. Usted se ve a sí mismo, básicamente como ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg061),expression:"eval_tipolo.pg061"}],attrs:{"value":"1","name":"group61","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg061,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg061", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) una persona \"cabeza dura\" ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg061),expression:"eval_tipolo.pg061"}],attrs:{"value":"2","name":"group61","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg061,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg061", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) una persona de \"corazón suave\" ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg062===0 ? "color:red" : "color:black")},[_vm._v("62. Qué situación le atrae más ?  ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg062),expression:"eval_tipolo.pg062"}],attrs:{"value":"1","name":"group62","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg062,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg062", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) lo estructurado y programado ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg062),expression:"eval_tipolo.pg062"}],attrs:{"value":"2","name":"group62","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg062,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg062", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) lo no estructurado y no programado ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg063===0 ? "color:red" : "color:black")},[_vm._v("63. Usted es una persona ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg063),expression:"eval_tipolo.pg063"}],attrs:{"value":"1","name":"group63","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg063,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg063", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) más rutinaria que caprichosa o antojadiza ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg063),expression:"eval_tipolo.pg063"}],attrs:{"value":"2","name":"group63","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg063,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg063", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) más caprichosa y antojadisa que rutinaria ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg064===0 ? "color:red" : "color:black")},[_vm._v("64. Usted es una persona más inclinada a ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg064),expression:"eval_tipolo.pg064"}],attrs:{"value":"1","name":"group64","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg064,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg064", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) interactuar con facilidad ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg064),expression:"eval_tipolo.pg064"}],attrs:{"value":"2","name":"group64","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg064,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg064", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) ser reservada ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg065===0 ? "color:red" : "color:black")},[_vm._v("65. En lo escrito, usted prefiere más")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg065),expression:"eval_tipolo.pg065"}],attrs:{"value":"1","name":"group65","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg065,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg065", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) lo literal ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg065),expression:"eval_tipolo.pg065"}],attrs:{"value":"2","name":"group65","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg065,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg065", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) lo figurativo ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg066===0 ? "color:red" : "color:black")},[_vm._v("66. Es más dificil para usted")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg066),expression:"eval_tipolo.pg066"}],attrs:{"value":"1","name":"group66","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg066,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg066", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) identificarse con otros ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg066),expression:"eval_tipolo.pg066"}],attrs:{"value":"2","name":"group66","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg066,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg066", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) utilizar a otros ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg067===0 ? "color:red" : "color:black")},[_vm._v("67. Qué desea usted más para usted mismo ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg067),expression:"eval_tipolo.pg067"}],attrs:{"value":"1","name":"group67","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg067,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg067", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) claridad de razonamiento ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg067),expression:"eval_tipolo.pg067"}],attrs:{"value":"2","name":"group67","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg067,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg067", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) tener fuerte compasión hacia otros ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tipolo.pg068===0 ? "color:red" : "color:black")},[_vm._v("68. Qué podría ser peor ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg068),expression:"eval_tipolo.pg068"}],attrs:{"value":"1","name":"group68","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg068,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg068", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) no ser diferente, parecido a los otros ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg068),expression:"eval_tipolo.pg068"}],attrs:{"value":"2","name":"group68","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg068,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg068", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) ser muy criticado ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_tipolo.pg069===0 ? "color:red" : "color:black")},[_vm._v("69. Usted prefiere acontecimientos y eventos ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg069),expression:"eval_tipolo.pg069"}],attrs:{"value":"1","name":"group69","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg069,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg069", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) planeados ? ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg069),expression:"eval_tipolo.pg069"}],attrs:{"value":"2","name":"group69","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg069,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg069", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no planeados ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_tipolo.pg070===0 ? "color:red" : "color:black")},[_vm._v("70. Usted tiende a ser ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg070),expression:"eval_tipolo.pg070"}],attrs:{"value":"1","name":"group70","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg070,"1")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg070", "1")}}}),_vm._v(" "),_c('span',[_vm._v("(a) más deliverado y planeador que espontáneo ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tipolo.pg070),expression:"eval_tipolo.pg070"}],attrs:{"value":"2","name":"group70","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tipolo.pg070,"2")},on:{"change":function($event){_vm.$set(_vm.eval_tipolo, "pg070", "2")}}}),_vm._v(" "),_c('span',[_vm._v("(b) más espontáneo que deliverado y planeado ?")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(4)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(2)}}},[_vm._m(5)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grabado===false),expression:"grabado===false"}],staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn tooltipped",attrs:{"data-position":"left","data-tooltip":"Grabar"},on:{"click":function($event){_vm.agregarEvaluacion()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("SELECCIONE EL SIGUIENTE BOTON PARA EMPEZAR LA EVALUACION.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("first_page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev02_16pf_js__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290a33a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev02_16pf_vue__ = __webpack_require__(323);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev02_16pf_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290a33a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev02_16pf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s2"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Departamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.depto),expression:"eval_16pf.depto"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_16pf.depto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_16pf, "depto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.empresa),expression:"eval_16pf.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_16pf.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_16pf, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.nombre),expression:"eval_16pf.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_16pf.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_16pf, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Sexo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.sexo),expression:"eval_16pf.sexo"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_16pf.sexo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_16pf, "sexo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_16pf.empezo))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finalizoeval),expression:"finalizoeval"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_16pf.termino))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para LEER u OCULTAR las instrucciones.","data-position":"top"}},[_vm._v("\n                            "+_vm._s(_vm.instrucciones)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{attrs:{"align":"justify"}},[_vm._v("\n                            Este es un cuestionario de sus actitudes. Lo que hace o lo que piensa acerca de ciertas situaciones. Las personas piensan de una manera u otra. \n                            Por lo tanto, no existen respuestas \"correctas\" o \"incorrectas\" a las preguntas de este formulario. \n\n                            Se ofrecen tres posibles respuestas para cada pregunta, que Ud. debe contestar \"A\" o \"B\" o \"C\" seleccionando con el mouse en la correspondiente respuesta. Las preguntas están organizadas en cuatro (4) secciones. Sección 1: De la 1 a la 25, Sección 2: de la 26 a la 50, Sección 3: de la 51 a la 75, y Sección 4: de la 76 a la 102."),_c('br'),_c('br'),_vm._v("\n                              \n                            Inicialmente todas las preguntas estarán en color "),_c('span',{staticStyle:{"font-weight":"bold","color":"red"}},[_vm._v("rojo")]),_vm._v(" como indicador\n                            que aún no han sido respondidas. Conforme vaya respondiendo, las preguntas se mostrarán en color negro. También tendrá un mensaje indicándole la cantidad \n                            de preguntas que aún no han sido respondidas. El siguiente "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("ejemplo")]),_vm._v(" de tres preguntas le permitirá estar seguro que comprende lo que debe hacer en el propio cuestionario."),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.ejeSinResponder>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_ejeSinResponder))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg001===0 ? "color:red" : "color:black")},[_vm._v("01. Me gustaría ser:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"a","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Maquinista; ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"b","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"c","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Vendedor;")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg002===0 ? "color:red" : "color:black")},[_vm._v("02.  Me gusta que una persona sea")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"a","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Atenta con la gente;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"b","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio; ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"c","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Apartada e indiferente con la gente ")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg003===0 ? "color:red" : "color:black")},[_vm._v("03. A veces me gusta ver una película de mucha violencia")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg003),expression:"ejemplo.pg003"}],attrs:{"value":"a","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg003,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg003", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg003),expression:"ejemplo.pg003"}],attrs:{"value":"b","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg003,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg003", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg003),expression:"ejemplo.pg003"}],attrs:{"value":"c","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg003,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg003", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])])]),_vm._v("\n                            Tenga presente las siguientes reglas:"),_c('br'),_vm._v("\n                            1. Conteste las preguntas tan franca y honradamente como le sea posible. No existe ventaja en crear una mejor impresión personal. No marque una respuesta que no sea cierta por creer que \"es lo que debe decir\". "),_c('br'),_vm._v("\n                            2. Conteste con la mayor rapidez posible. No dedique tiempo a meditar sobre las preguntas. Anote su primera reacción y pase de alli a la próxima pregunta. "),_c('br'),_vm._v("\n                            3. Marque la respusta \"A\" o la respuesta \"C\" para la mayoría de las preguntas. Solamente marque la respuesta \"B\" cuando le sea imposible contestar las otras, aunque en algunos casos le será dificil escoger. "),_c('br'),_vm._v("\n                            4. Conteste todas las preguntas sin excepción. Habrá preguntas que no reflejan sus ideas, pero debe contestalas todas. No debe saltarse ninguna. Sus respuestas serán confidenciales."),_c('br'),_vm._v(" "),_vm._m(0)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12"},[_c('div',{staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("Empezar Evaluación de FACTORES DE LA PERSONALIDAD")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s12"},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt4"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("Preguntas 01 - 25")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt5"},on:{"click":function($event){_vm.nadaG1(2)}}},[_vm._v("Preguntas 26 - 50")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt3",class:_vm.activott3,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt3","href":"#testt6"},on:{"click":function($event){_vm.nadaG1(3)}}},[_vm._v("Preguntas 51 - 75")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt4",class:_vm.activott4,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt4","href":"#testt7"},on:{"click":function($event){_vm.nadaG1(4)}}},[_vm._v("Preguntas 76 - 102")])])]),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.pregSinContestar>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_sinResponder))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt4"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg001===0 ? "color:red" : "color:black")},[_vm._v("01. Está su memoria ahora mejor que antes")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg001),expression:"eval_16pf.pg001"}],attrs:{"value":"a","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg001,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg001", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg001),expression:"eval_16pf.pg001"}],attrs:{"value":"b","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg001,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg001", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg001),expression:"eval_16pf.pg001"}],attrs:{"value":"c","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg001,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg001", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg002===0 ? "color:red" : "color:black")},[_vm._v("02. Podría tolerar usted vivir solo, lejos de todo el mundo, como un ermitaño")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg002),expression:"eval_16pf.pg002"}],attrs:{"value":"a","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg002,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg002", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg002),expression:"eval_16pf.pg002"}],attrs:{"value":"b","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg002,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg002", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg002),expression:"eval_16pf.pg002"}],attrs:{"value":"c","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg002,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg002", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg003===0 ? "color:red" : "color:black")},[_vm._v("03. Cómo llamaría a un criminal una persona que dijera que el cielo está abajo y que en invierno hace calor ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg003),expression:"eval_16pf.pg003"}],attrs:{"value":"a","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg003,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg003", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Un Ganster")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg003),expression:"eval_16pf.pg003"}],attrs:{"value":"b","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg003,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg003", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Un Santo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg003),expression:"eval_16pf.pg003"}],attrs:{"value":"c","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg003,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg003", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Una nube")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg004===0 ? "color:red" : "color:black")},[_vm._v("04. Qué hace usted cuando se encuentra con gente desarreglada y desordenada")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg004),expression:"eval_16pf.pg004"}],attrs:{"value":"a","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg004,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg004", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) la acepta")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg004),expression:"eval_16pf.pg004"}],attrs:{"value":"b","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg004,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg004", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg004),expression:"eval_16pf.pg004"}],attrs:{"value":"c","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg004,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg004", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Se siente disgustado y molesto ")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg005===0 ? "color:red" : "color:black")},[_vm._v("05. A veces trata usted de ser demasiado gentil con los meseros y las meseras")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg005),expression:"eval_16pf.pg005"}],attrs:{"value":"a","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg005,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg005", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg005),expression:"eval_16pf.pg005"}],attrs:{"value":"b","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg005,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg005", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg005),expression:"eval_16pf.pg005"}],attrs:{"value":"c","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg005,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg005", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg006===0 ? "color:red" : "color:black")},[_vm._v("06. En una fiesta, prefiere usted esperar que otra gente empiece a contar los chistes y los cuentos")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg006),expression:"eval_16pf.pg006"}],attrs:{"value":"a","name":"group6","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg006,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg006", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg006),expression:"eval_16pf.pg006"}],attrs:{"value":"b","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg006,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg006", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg006),expression:"eval_16pf.pg006"}],attrs:{"value":"c","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg006,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg006", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg007===0 ? "color:red" : "color:black")},[_vm._v("07. Cree usted que la gente debería observar las leyes morales más rígidamente ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg007),expression:"eval_16pf.pg007"}],attrs:{"value":"a","name":"group7","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg007,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg007", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg007),expression:"eval_16pf.pg007"}],attrs:{"value":"b","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg007,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg007", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg007),expression:"eval_16pf.pg007"}],attrs:{"value":"c","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg007,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg007", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg008===0 ? "color:red" : "color:black")},[_vm._v("08. A la mayoría de la gente que conoce usted le da verdadero gusto encontrarle en una fiesta ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg008),expression:"eval_16pf.pg008"}],attrs:{"value":"a","name":"group8","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg008,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg008", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg008),expression:"eval_16pf.pg008"}],attrs:{"value":"b","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg008,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg008", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg008),expression:"eval_16pf.pg008"}],attrs:{"value":"c","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg008,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg008", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg009===0 ? "color:red" : "color:black")},[_vm._v("09. Cómo aficionado, yo preferiría hacer ejercicio con: ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg009),expression:"eval_16pf.pg009"}],attrs:{"value":"a","name":"group9","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg009,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg009", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Ping Pong")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg009),expression:"eval_16pf.pg009"}],attrs:{"value":"b","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg009,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg009", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg009),expression:"eval_16pf.pg009"}],attrs:{"value":"c","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg009,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg009", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) El box y el futbol")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg010===0 ? "color:red" : "color:black")},[_vm._v("10. ¿Le dan risa las grandes diferencias entre lo que hace la gente y lo que dice que hace?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg010),expression:"eval_16pf.pg010"}],attrs:{"value":"a","name":"group10","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg010,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg010", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg010),expression:"eval_16pf.pg010"}],attrs:{"value":"b","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg010,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg010", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg010),expression:"eval_16pf.pg010"}],attrs:{"value":"c","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg010,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg010", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg011===0 ? "color:red" : "color:black")},[_vm._v("11. Cuando era niño sentía tristeza al salir de la casa para ir a la escuela cada día ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg011),expression:"eval_16pf.pg011"}],attrs:{"value":"a","name":"group11","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg011,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg011", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg011),expression:"eval_16pf.pg011"}],attrs:{"value":"b","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg011,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg011", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg011),expression:"eval_16pf.pg011"}],attrs:{"value":"c","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg011,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg011", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg012===0 ? "color:red" : "color:black")},[_vm._v("12. Qué hace usted si se pasa por alto algún comentario suyo ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg012),expression:"eval_16pf.pg012"}],attrs:{"value":"a","name":"group12","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg012,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg012", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) lo olvida")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg012),expression:"eval_16pf.pg012"}],attrs:{"value":"b","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg012,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg012", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg012),expression:"eval_16pf.pg012"}],attrs:{"value":"c","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg012,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg012", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Lo repite hasta que la gente comprenda")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg013===0 ? "color:red" : "color:black")},[_vm._v("13. Se ve usted en la necesidad de evitar la excitación porque lo cansa ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg013),expression:"eval_16pf.pg013"}],attrs:{"value":"a","name":"group13","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg013,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg013", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg013),expression:"eval_16pf.pg013"}],attrs:{"value":"b","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg013,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg013", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg013),expression:"eval_16pf.pg013"}],attrs:{"value":"c","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg013,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg013", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg014===0 ? "color:red" : "color:black")},[_vm._v("14. De ser posible, que preferiría jugar ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg014),expression:"eval_16pf.pg014"}],attrs:{"value":"a","name":"group14","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg014,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg014", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Ajedréz")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg014),expression:"eval_16pf.pg014"}],attrs:{"value":"b","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg014,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg014", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg014),expression:"eval_16pf.pg014"}],attrs:{"value":"c","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg014,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg014", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Boliche")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg015===0 ? "color:red" : "color:black")},[_vm._v("15. Cuándo piensa hacer algo solo, lo trata de hacer completamente a solas, sin solicitar ayuda de otro ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg015),expression:"eval_16pf.pg015"}],attrs:{"value":"a","name":"group15","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg015,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg015", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg015),expression:"eval_16pf.pg015"}],attrs:{"value":"b","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg015,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg015", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg015),expression:"eval_16pf.pg015"}],attrs:{"value":"c","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg015,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg015", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg016===0 ? "color:red" : "color:black")},[_vm._v("16. Se rehusa usted a dedicar tiempo pensando \"lo que podría haber sido\" ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg016),expression:"eval_16pf.pg016"}],attrs:{"value":"a","name":"group16","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg016,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg016", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg016),expression:"eval_16pf.pg016"}],attrs:{"value":"b","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg016,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg016", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg016),expression:"eval_16pf.pg016"}],attrs:{"value":"c","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg016,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg016", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg017===0 ? "color:red" : "color:black")},[_vm._v("17. Es usted una persona que se deshace fácilmente de las preocupaciones y responsabilidades ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg017),expression:"eval_16pf.pg017"}],attrs:{"value":"a","name":"group17","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg017,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg017", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg017),expression:"eval_16pf.pg017"}],attrs:{"value":"b","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg017,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg017", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg017),expression:"eval_16pf.pg017"}],attrs:{"value":"c","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg017,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg017", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg018===0 ? "color:red" : "color:black")},[_vm._v("18. En alguna ocasión, aunque haya sido por un momento, ha sentido usted resentimiento por sus padres ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg018),expression:"eval_16pf.pg018"}],attrs:{"value":"a","name":"group18","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg018,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg018", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg018),expression:"eval_16pf.pg018"}],attrs:{"value":"b","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg018,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg018", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg018),expression:"eval_16pf.pg018"}],attrs:{"value":"c","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg018,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg018", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg019===0 ? "color:red" : "color:black")},[_vm._v("19. Tomaría usted un trabajo en el que tuviera que escuchar quejas de los empleados o de los clientes durante el día entero ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg019),expression:"eval_16pf.pg019"}],attrs:{"value":"a","name":"group19","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg019,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg019", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg019),expression:"eval_16pf.pg019"}],attrs:{"value":"b","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg019,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg019", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg019),expression:"eval_16pf.pg019"}],attrs:{"value":"c","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg019,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg019", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg020===0 ? "color:red" : "color:black")},[_vm._v("20. Cuál de las siguientes palabras es el opuesto del opuesto de inexacto ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg020),expression:"eval_16pf.pg020"}],attrs:{"value":"a","name":"group20","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg020,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg020", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Casual")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg020),expression:"eval_16pf.pg020"}],attrs:{"value":"b","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg020,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg020", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Preciso")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg020),expression:"eval_16pf.pg020"}],attrs:{"value":"c","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg020,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg020", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Apropiado")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg021===0 ? "color:red" : "color:black")},[_vm._v("21. Siempre cuenta usted con bastante energá cuando más la necesita ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg021),expression:"eval_16pf.pg021"}],attrs:{"value":"a","name":"group21","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg021,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg021", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg021),expression:"eval_16pf.pg021"}],attrs:{"value":"b","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg021,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg021", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg021),expression:"eval_16pf.pg021"}],attrs:{"value":"c","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg021,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg021", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg022===0 ? "color:red" : "color:black")},[_vm._v("22. Le daría pena pertenecer a un campo nudista ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg022),expression:"eval_16pf.pg022"}],attrs:{"value":"a","name":"group22","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg022,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg022", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg022),expression:"eval_16pf.pg022"}],attrs:{"value":"b","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg022,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg022", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg022),expression:"eval_16pf.pg022"}],attrs:{"value":"c","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg022,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg022", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg023===0 ? "color:red" : "color:black")},[_vm._v("23.  Busca usted las reuniones grandes, como las fiestas o los bailes ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg023),expression:"eval_16pf.pg023"}],attrs:{"value":"a","name":"group23","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg023,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg023", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg023),expression:"eval_16pf.pg023"}],attrs:{"value":"b","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg023,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg023", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg023),expression:"eval_16pf.pg023"}],attrs:{"value":"c","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg023,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg023", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg024===0 ? "color:red" : "color:black")},[_vm._v("24. Cree usted que ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg024),expression:"eval_16pf.pg024"}],attrs:{"value":"a","name":"group24","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg024,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg024", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Hay trabajos que no requieren el mismo cuidado que otros")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg024),expression:"eval_16pf.pg024"}],attrs:{"value":"b","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg024,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg024", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg024),expression:"eval_16pf.pg024"}],attrs:{"value":"c","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg024,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg024", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Cualquier trabajo, si es que se va hacer, debe hacerse bien")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg025===0 ? "color:red" : "color:black")},[_vm._v("25. Al caminar por la calle, a veces se disgusta por la manera en que le mira alguna gente ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg025),expression:"eval_16pf.pg025"}],attrs:{"value":"a","name":"group25","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg025,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg025", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg025),expression:"eval_16pf.pg025"}],attrs:{"value":"b","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg025,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg025", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg025),expression:"eval_16pf.pg025"}],attrs:{"value":"c","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg025,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg025", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt5"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg026===0 ? "color:red" : "color:black")},[_vm._v("26. Qué preferiría usted:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg026),expression:"eval_16pf.pg026"}],attrs:{"value":"a","name":"group26","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg026,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg026", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sacerdote")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg026),expression:"eval_16pf.pg026"}],attrs:{"value":"b","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg026,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg026", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg026),expression:"eval_16pf.pg026"}],attrs:{"value":"c","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg026,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg026", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Coronel")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg027===0 ? "color:red" : "color:black")},[_vm._v("27. Si su vecino constantemente le hace trampas pequeñas, cree usted que es mejor simplemente acomodase que desenmascararlo")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg027),expression:"eval_16pf.pg027"}],attrs:{"value":"a","name":"group27","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg027,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg027", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Si ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg027),expression:"eval_16pf.pg027"}],attrs:{"value":"b","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg027,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg027", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg027),expression:"eval_16pf.pg027"}],attrs:{"value":"c","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg027,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg027", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg028===0 ? "color:red" : "color:black")},[_vm._v("28. Preferiría ver: ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg028),expression:"eval_16pf.pg028"}],attrs:{"value":"a","name":"group28","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg028,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg028", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Una buena película sobre la época dificil de la colonización; ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg028),expression:"eval_16pf.pg028"}],attrs:{"value":"b","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg028,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg028", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg028),expression:"eval_16pf.pg028"}],attrs:{"value":"c","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg028,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg028", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Una farsa ingeniosa sobre la sociedad del futuro  ?")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg029===0 ? "color:red" : "color:black")},[_vm._v("29. Cuando se le ha hecho responsable por algún proyecto, insiste usted en imponer siempre su punto de vista o renunciar ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg029),expression:"eval_16pf.pg029"}],attrs:{"value":"a","name":"group29","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg029,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg029", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg029),expression:"eval_16pf.pg029"}],attrs:{"value":"b","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg029,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg029", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg029),expression:"eval_16pf.pg029"}],attrs:{"value":"c","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg029,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg029", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg030===0 ? "color:red" : "color:black")},[_vm._v("30. Cuando en opinión suya alguien muestra mala educación: ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg030),expression:"eval_16pf.pg030"}],attrs:{"value":"a","name":"group30","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg030,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg030", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) No dice usted nada por no querer parecer fastidioso;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg030),expression:"eval_16pf.pg030"}],attrs:{"value":"b","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg030,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg030", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg030),expression:"eval_16pf.pg030"}],attrs:{"value":"c","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg030,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg030", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Le hace ver claramente a esta persona lo que piensa")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg031===0 ? "color:red" : "color:black")},[_vm._v("31. Cuando se le presenta a alguien, prefiere usted: ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg031),expression:"eval_16pf.pg031"}],attrs:{"value":"a","name":"group31","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg031,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg031", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Tener una discusión placentera sobre la política y puntos de vista sociales ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg031),expression:"eval_16pf.pg031"}],attrs:{"value":"b","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg031,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg031", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg031),expression:"eval_16pf.pg031"}],attrs:{"value":"c","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg031,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg031", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) que le cuenten unos chistes")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg032===0 ? "color:red" : "color:black")},[_vm._v("32. Cree usted que es cruel vacunar a los niños pequeños, y que los padres deben tener el derecho de aplazar la vacuna ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg032),expression:"eval_16pf.pg032"}],attrs:{"value":"a","name":"group32","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg032,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg032", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg032),expression:"eval_16pf.pg032"}],attrs:{"value":"b","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg032,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg032", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg032),expression:"eval_16pf.pg032"}],attrs:{"value":"c","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg032,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg032", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg033===0 ? "color:red" : "color:black")},[_vm._v("33. Es mejor confiar en: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg033),expression:"eval_16pf.pg033"}],attrs:{"value":"a","name":"group33","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg033,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg033", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) La suerte de la vida;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg033),expression:"eval_16pf.pg033"}],attrs:{"value":"b","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg033,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg033", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg033),expression:"eval_16pf.pg033"}],attrs:{"value":"c","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg033,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg033", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) La capacitación personal")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg034===0 ? "color:red" : "color:black")},[_vm._v("34. Cuando tiene pendiente un viaje, siente usted apuros, tension, o ansiedad. Aunque sabe que cuenta con bastante tiempo ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg034),expression:"eval_16pf.pg034"}],attrs:{"value":"a","name":"group34","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg034,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg034", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg034),expression:"eval_16pf.pg034"}],attrs:{"value":"b","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg034,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg034", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg034),expression:"eval_16pf.pg034"}],attrs:{"value":"c","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg034,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg034", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg035===0 ? "color:red" : "color:black")},[_vm._v("35. Le es dificil admitir que esta equivocado ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg035),expression:"eval_16pf.pg035"}],attrs:{"value":"a","name":"group35","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg035,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg035", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg035),expression:"eval_16pf.pg035"}],attrs:{"value":"b","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg035,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg035", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg035),expression:"eval_16pf.pg035"}],attrs:{"value":"c","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg035,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg035", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg036===0 ? "color:red" : "color:black")},[_vm._v("36. En una fábrica, preferiría usted encargarse de:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg036),expression:"eval_16pf.pg036"}],attrs:{"value":"a","name":"group36","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg036,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg036", "a")}}}),_vm._v(" "),_c('span',[_vm._v("a) Máquinas")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg036),expression:"eval_16pf.pg036"}],attrs:{"value":"b","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg036,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg036", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg036),expression:"eval_16pf.pg036"}],attrs:{"value":"c","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg036,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg036", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) entrevistar y contratar personal")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg037===0 ? "color:red" : "color:black")},[_vm._v("37. Cuál palabra no va con las otras dos ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg037),expression:"eval_16pf.pg037"}],attrs:{"value":"a","name":"group37","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg037,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg037", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Gato")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg037),expression:"eval_16pf.pg037"}],attrs:{"value":"b","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg037,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg037", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Atrás")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg037),expression:"eval_16pf.pg037"}],attrs:{"value":"c","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg037,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg037", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Sol")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg038===0 ? "color:red" : "color:black")},[_vm._v("38. Es usted de salud variable que a veces le obliga cambiar sus proyectos inesperadamente ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg038),expression:"eval_16pf.pg038"}],attrs:{"value":"a","name":"group38","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg038,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg038", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg038),expression:"eval_16pf.pg038"}],attrs:{"value":"b","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg038,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg038", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg038),expression:"eval_16pf.pg038"}],attrs:{"value":"c","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg038,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg038", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg039===0 ? "color:red" : "color:black")},[_vm._v("39. Le gustaría ser atendido por sirvientes personales")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg039),expression:"eval_16pf.pg039"}],attrs:{"value":"a","name":"group39","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg039,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg039", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg039),expression:"eval_16pf.pg039"}],attrs:{"value":"b","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg039,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg039", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg039),expression:"eval_16pf.pg039"}],attrs:{"value":"c","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg039,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg039", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg040===0 ? "color:red" : "color:black")},[_vm._v("40. Se siente usted incómodo en compañia de otras personas, de manea que nunca presenta su mejor aspecto ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg040),expression:"eval_16pf.pg040"}],attrs:{"value":"a","name":"group40","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg040,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg040", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg040),expression:"eval_16pf.pg040"}],attrs:{"value":"b","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg040,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg040", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg040),expression:"eval_16pf.pg040"}],attrs:{"value":"c","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg040,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg040", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg041===0 ? "color:red" : "color:black")},[_vm._v("41. Si le sobrara dinero de sus necesidades cotidianas, cree que debería donar gran parte del sobrante a la Iglesia o alguna otra causa merecedora ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg041),expression:"eval_16pf.pg041"}],attrs:{"value":"a","name":"group41","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg041,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg041", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg041),expression:"eval_16pf.pg041"}],attrs:{"value":"b","name":"group41","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg041,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg041", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg041),expression:"eval_16pf.pg041"}],attrs:{"value":"c","name":"group41","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg041,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg041", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg042===0 ? "color:red" : "color:black")},[_vm._v("42. Hay veces que se enfurece tanto que le parece mejor no decir nada ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg042),expression:"eval_16pf.pg042"}],attrs:{"value":"a","name":"group42","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg042,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg042", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg042),expression:"eval_16pf.pg042"}],attrs:{"value":"b","name":"group42","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg042,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg042", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg042),expression:"eval_16pf.pg042"}],attrs:{"value":"c","name":"group42","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg042,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg042", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg043===0 ? "color:red" : "color:black")},[_vm._v("43. Puede usted hacer trabajo físico duro sin fatigarse tanto como la mayoría de las personas ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg043),expression:"eval_16pf.pg043"}],attrs:{"value":"a","name":"group43","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg043,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg043", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg043),expression:"eval_16pf.pg043"}],attrs:{"value":"b","name":"group43","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg043,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg043", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A vece")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg043),expression:"eval_16pf.pg043"}],attrs:{"value":"c","name":"group43","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg043,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg043", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg044===0 ? "color:red" : "color:black")},[_vm._v("44. Cree usted que aún cuando le es penoso, la mayoría de los testigos dice la verdad ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg044),expression:"eval_16pf.pg044"}],attrs:{"value":"a","name":"group44","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg044,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg044", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg044),expression:"eval_16pf.pg044"}],attrs:{"value":"b","name":"group44","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg044,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg044", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg044),expression:"eval_16pf.pg044"}],attrs:{"value":"c","name":"group44","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg044,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg044", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg045===0 ? "color:red" : "color:black")},[_vm._v("45. Le ayuda ir y venir cuando piensa ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg045),expression:"eval_16pf.pg045"}],attrs:{"value":"a","name":"group45","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg045,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg045", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg045),expression:"eval_16pf.pg045"}],attrs:{"value":"b","name":"group45","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg045,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg045", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_vm._v(" "),_c('a',[_c('label',[_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg045),expression:"eval_16pf.pg045"}],attrs:{"value":"c","name":"group45","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg045,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg045", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg046===0 ? "color:red" : "color:black")},[_vm._v("46. Cree usted, que nuestro país debería astar más en")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg046),expression:"eval_16pf.pg046"}],attrs:{"value":"a","name":"group46","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg046,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg046", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Armamento")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg046),expression:"eval_16pf.pg046"}],attrs:{"value":"b","name":"group46","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg046,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg046", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg046),expression:"eval_16pf.pg046"}],attrs:{"value":"c","name":"group46","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg046,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg046", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) educación")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg047===0 ? "color:red" : "color:black")},[_vm._v("47. Preferiría usted pasarse la noche;")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg047),expression:"eval_16pf.pg047"}],attrs:{"value":"a","name":"group47","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg047,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg047", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) En un juego reñido de naipes;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg047),expression:"eval_16pf.pg047"}],attrs:{"value":"b","name":"group47","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg047,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg047", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg047),expression:"eval_16pf.pg047"}],attrs:{"value":"c","name":"group47","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg047,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg047", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) viendo fotos de vacaciones pasadas ")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg048===0 ? "color:red" : "color:black")},[_vm._v("48. Preferiría usted leer ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg048),expression:"eval_16pf.pg048"}],attrs:{"value":"a","name":"group48","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg048,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg048", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Una buena novela histórica;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg048),expression:"eval_16pf.pg048"}],attrs:{"value":"b","name":"group48","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg048,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg048", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg048),expression:"eval_16pf.pg048"}],attrs:{"value":"c","name":"group48","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg048,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg048", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Un ensayo por alún científico sobre la manera de aprovechar los recursos del mundo")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg049===0 ? "color:red" : "color:black")},[_vm._v("49. Está usted verdaderamente seguro que hay mas gente amable que gente tonta en el mundo ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg049),expression:"eval_16pf.pg049"}],attrs:{"value":"a","name":"group49","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg049,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg049", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg049),expression:"eval_16pf.pg049"}],attrs:{"value":"b","name":"group49","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg049,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg049", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg049),expression:"eval_16pf.pg049"}],attrs:{"value":"c","name":"group49","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg049,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg049", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg050===0 ? "color:red" : "color:black")},[_vm._v("50. Hace usted más proyectos y es usted más enérgico en cuanto a llevar a cabo su trabajo que otras personas que han tenido éxito ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg050),expression:"eval_16pf.pg050"}],attrs:{"value":"a","name":"group50","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg050,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg050", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg050),expression:"eval_16pf.pg050"}],attrs:{"value":"b","name":"group50","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg050,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg050", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg050),expression:"eval_16pf.pg050"}],attrs:{"value":"c","name":"group50","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg050,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg050", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(1)}}},[_vm._m(2)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(3)}}},[_vm._m(3)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt3),expression:"vertt3"}],ref:"testt3",attrs:{"id":"testt6"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg051===0 ? "color:red" : "color:black")},[_vm._v("51. Hay veces que prefiere no ver a nadie ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg051),expression:"eval_16pf.pg051"}],attrs:{"value":"a","name":"group51","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg051,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg051", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Muy raras veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg051),expression:"eval_16pf.pg051"}],attrs:{"value":"b","name":"group51","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg051,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg051", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg051),expression:"eval_16pf.pg051"}],attrs:{"value":"c","name":"group51","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg051,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg051", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Muy a menudo")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg052===0 ? "color:red" : "color:black")},[_vm._v("52. Cuando sabe que lo que hace es lo correcto, siempre le es fácil hacerlo ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg052),expression:"eval_16pf.pg052"}],attrs:{"value":"a","name":"group52","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg052,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg052", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg052),expression:"eval_16pf.pg052"}],attrs:{"value":"b","name":"group52","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg052,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg052", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg052),expression:"eval_16pf.pg052"}],attrs:{"value":"c","name":"group52","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg052,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg052", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg053===0 ? "color:red" : "color:black")},[_vm._v("53. Preferiría")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg053),expression:"eval_16pf.pg053"}],attrs:{"value":"a","name":"group53","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg053,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg053", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Trabajar en una oficina de neocios, organizando gente;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg053),expression:"eval_16pf.pg053"}],attrs:{"value":"b","name":"group53","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg053,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg053", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg053),expression:"eval_16pf.pg053"}],attrs:{"value":"c","name":"group53","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg053,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg053", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Ser Arquitecto, proyectando edificios")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg054===0 ? "color:red" : "color:black")},[_vm._v("54. El negro se compara con el gris como el dolor se compara con:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg054),expression:"eval_16pf.pg054"}],attrs:{"value":"a","name":"group54","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg054,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg054", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) La herida")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg054),expression:"eval_16pf.pg054"}],attrs:{"value":"b","name":"group54","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg054,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg054", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) La enfermedad")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg054),expression:"eval_16pf.pg054"}],attrs:{"value":"c","name":"group54","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg054,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg054", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) La molestia")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg055===0 ? "color:red" : "color:black")},[_vm._v("55. Siempre dureme usted bien, sin hablar o caminar dormido ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg055),expression:"eval_16pf.pg055"}],attrs:{"value":"a","name":"group55","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg055,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg055", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg055),expression:"eval_16pf.pg055"}],attrs:{"value":"b","name":"group55","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg055,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg055", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg055),expression:"eval_16pf.pg055"}],attrs:{"value":"c","name":"group55","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg055,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg055", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg056===0 ? "color:red" : "color:black")},[_vm._v("56. Si le es necesario, puede usted decirle una mentira a un desconocido sin cambiar de expresión ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg056),expression:"eval_16pf.pg056"}],attrs:{"value":"a","name":"group56","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg056,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg056", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg056),expression:"eval_16pf.pg056"}],attrs:{"value":"b","name":"group56","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg056,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg056", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg056),expression:"eval_16pf.pg056"}],attrs:{"value":"c","name":"group56","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg056,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg056", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg057===0 ? "color:red" : "color:black")},[_vm._v("57. Ha participado usted activamente en la organización de algún club, equipo, o grupo social ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg057),expression:"eval_16pf.pg057"}],attrs:{"value":"a","name":"group57","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg057,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg057", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg057),expression:"eval_16pf.pg057"}],attrs:{"value":"b","name":"group57","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg057,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg057", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg057),expression:"eval_16pf.pg057"}],attrs:{"value":"c","name":"group57","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg057,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg057", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg058===0 ? "color:red" : "color:black")},[_vm._v("58. A quien admira usted más ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg058),expression:"eval_16pf.pg058"}],attrs:{"value":"a","name":"group58","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg058,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg058", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Una persona lista pero poco confiable; ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg058),expression:"eval_16pf.pg058"}],attrs:{"value":"b","name":"group58","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg058,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg058", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg058),expression:"eval_16pf.pg058"}],attrs:{"value":"c","name":"group58","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg058,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg058", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Una persona media con la voluntad de resistir las tentaciones")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg059===0 ? "color:red" : "color:black")},[_vm._v("59. Cuando presenta usted una queja justa, siempre consigue satisfacción")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg059),expression:"eval_16pf.pg059"}],attrs:{"value":"a","name":"group59","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg059,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg059", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg059),expression:"eval_16pf.pg059"}],attrs:{"value":"b","name":"group59","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg059,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg059", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg059),expression:"eval_16pf.pg059"}],attrs:{"value":"c","name":"group59","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg059,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg059", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg060===0 ? "color:red" : "color:black")},[_vm._v("60. Las circunstancias desalentadoras lo dejan al borde de las lagrimas ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg060),expression:"eval_16pf.pg060"}],attrs:{"value":"a","name":"group60","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg060,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg060", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg060),expression:"eval_16pf.pg060"}],attrs:{"value":"b","name":"group60","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg060,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg060", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg060),expression:"eval_16pf.pg060"}],attrs:{"value":"c","name":"group60","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg060,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg060", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg061===0 ? "color:red" : "color:black")},[_vm._v("61. Cree usted que muchos países extranjeros sienten más amistad con nosotros de lo que suponemos ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg061),expression:"eval_16pf.pg061"}],attrs:{"value":"a","name":"group61","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg061,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg061", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg061),expression:"eval_16pf.pg061"}],attrs:{"value":"b","name":"group61","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg061,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg061", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg061),expression:"eval_16pf.pg061"}],attrs:{"value":"c","name":"group61","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg061,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg061", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg062===0 ? "color:red" : "color:black")},[_vm._v("62. Hay momentos del día en que le gusta estar solo con sus pensamientos, aparte de la gente ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg062),expression:"eval_16pf.pg062"}],attrs:{"value":"a","name":"group62","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg062,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg062", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg062),expression:"eval_16pf.pg062"}],attrs:{"value":"b","name":"group62","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg062,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg062", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg062),expression:"eval_16pf.pg062"}],attrs:{"value":"c","name":"group62","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg062,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg062", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg063===0 ? "color:red" : "color:black")},[_vm._v("63. Hay veces que usted se exaspera con reglas y restricciones pequeñas en momentos más calmados, usted acepta ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg063),expression:"eval_16pf.pg063"}],attrs:{"value":"a","name":"group63","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg063,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg063", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg063),expression:"eval_16pf.pg063"}],attrs:{"value":"b","name":"group63","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg063,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg063", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg063),expression:"eval_16pf.pg063"}],attrs:{"value":"c","name":"group63","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg063,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg063", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg064===0 ? "color:red" : "color:black")},[_vm._v("64. Cree usted que mucha de la educación moderna, dizque \"progresiva\", no es tan buena como las reglas discilinarias de sentido común de la escuela antigua")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg064),expression:"eval_16pf.pg064"}],attrs:{"value":"a","name":"group64","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg064,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg064", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg064),expression:"eval_16pf.pg064"}],attrs:{"value":"b","name":"group64","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg064,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg064", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg064),expression:"eval_16pf.pg064"}],attrs:{"value":"c","name":"group64","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg064,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg064", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg065===0 ? "color:red" : "color:black")},[_vm._v("65. Aprendió usted más en la escuela:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg065),expression:"eval_16pf.pg065"}],attrs:{"value":"a","name":"group65","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg065,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg065", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Asistiendo a clases")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg065),expression:"eval_16pf.pg065"}],attrs:{"value":"b","name":"group65","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg065,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg065", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg065),expression:"eval_16pf.pg065"}],attrs:{"value":"c","name":"group65","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg065,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg065", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Leyendo textos")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg066===0 ? "color:red" : "color:black")},[_vm._v("66. Trata usted de evitar mezclarse en responsabilidades sociales ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg066),expression:"eval_16pf.pg066"}],attrs:{"value":"a","name":"group66","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg066,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg066", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg066),expression:"eval_16pf.pg066"}],attrs:{"value":"b","name":"group66","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg066,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg066", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg066),expression:"eval_16pf.pg066"}],attrs:{"value":"c","name":"group66","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg066,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg066", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg067===0 ? "color:red" : "color:black")},[_vm._v("67. Cuando usted tiene mucho que hacer, y un problema se vuelve demasiado difícil, usted busca:  ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg067),expression:"eval_16pf.pg067"}],attrs:{"value":"a","name":"group67","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg067,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg067", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Un problema distinto;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg067),expression:"eval_16pf.pg067"}],attrs:{"value":"b","name":"group67","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg067,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg067", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg067),expression:"eval_16pf.pg067"}],attrs:{"value":"c","name":"group67","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg067,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg067", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Otra manera de resolver el problema ")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg068===0 ? "color:red" : "color:black")},[_vm._v("68. Deriva usted ánimos fuertes, como la ansiedad, la ira, la risa, etc. de incidentes pequeños")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg068),expression:"eval_16pf.pg068"}],attrs:{"value":"a","name":"group68","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg068,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg068", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg068),expression:"eval_16pf.pg068"}],attrs:{"value":"b","name":"group68","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg068,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg068", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg068),expression:"eval_16pf.pg068"}],attrs:{"value":"c","name":"group68","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg068,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg068", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg069===0 ? "color:red" : "color:black")},[_vm._v("69. Hay veces que su mente no funciona tan bien como en otras ocasiones ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg069),expression:"eval_16pf.pg069"}],attrs:{"value":"a","name":"group69","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg069,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg069", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg069),expression:"eval_16pf.pg069"}],attrs:{"value":"b","name":"group69","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg069,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg069", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg069),expression:"eval_16pf.pg069"}],attrs:{"value":"c","name":"group69","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg069,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg069", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg070===0 ? "color:red" : "color:black")},[_vm._v("70. Complace usted a la gente cumpliendo con citas a horas que les conviene a ellos ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg070),expression:"eval_16pf.pg070"}],attrs:{"value":"a","name":"group70","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg070,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg070", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg070),expression:"eval_16pf.pg070"}],attrs:{"value":"b","name":"group70","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg070,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg070", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg070),expression:"eval_16pf.pg070"}],attrs:{"value":"c","name":"group70","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg070,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg070", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg071===0 ? "color:red" : "color:black")},[_vm._v("71. Si la mamá de María es la hermana del papá de Federico, qué parentesco tiene Federico con el papá de María ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg071),expression:"eval_16pf.pg071"}],attrs:{"value":"a","name":"group71","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg071,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg071", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Primo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg071),expression:"eval_16pf.pg071"}],attrs:{"value":"b","name":"group71","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg071,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg071", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Sobrino")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg071),expression:"eval_16pf.pg071"}],attrs:{"value":"c","name":"group71","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg071,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg071", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Tío")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg072===0 ? "color:red" : "color:black")},[_vm._v("72. Se siente usted crítico del trabajo de mucha gente ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg072),expression:"eval_16pf.pg072"}],attrs:{"value":"a","name":"group72","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg072,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg072", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg072),expression:"eval_16pf.pg072"}],attrs:{"value":"b","name":"group72","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg072,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg072", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg072),expression:"eval_16pf.pg072"}],attrs:{"value":"c","name":"group72","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg072,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg072", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg073===0 ? "color:red" : "color:black")},[_vm._v("73. Le molesta la gente que dice que puede hacer las cosas mejor que las demás ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg073),expression:"eval_16pf.pg073"}],attrs:{"value":"a","name":"group73","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg073,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg073", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg073),expression:"eval_16pf.pg073"}],attrs:{"value":"b","name":"group73","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg073,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg073", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg073),expression:"eval_16pf.pg073"}],attrs:{"value":"c","name":"group73","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg073,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg073", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg074===0 ? "color:red" : "color:black")},[_vm._v("74. Le encanta salir de viaje casi todo el tiempo")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg074),expression:"eval_16pf.pg074"}],attrs:{"value":"a","name":"group74","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg074,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg074", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg074),expression:"eval_16pf.pg074"}],attrs:{"value":"b","name":"group74","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg074,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg074", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg074),expression:"eval_16pf.pg074"}],attrs:{"value":"c","name":"group74","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg074,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg074", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg075===0 ? "color:red" : "color:black")},[_vm._v("75. Ha llegado usted casi a desmayarse por algún dolor repentino o al ver la sangre ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg075),expression:"eval_16pf.pg075"}],attrs:{"value":"a","name":"group75","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg075,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg075", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg075),expression:"eval_16pf.pg075"}],attrs:{"value":"b","name":"group75","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg075,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg075", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg075),expression:"eval_16pf.pg075"}],attrs:{"value":"c","name":"group75","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg075,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg075", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(2)}}},[_vm._m(4)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(4)}}},[_vm._m(5)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt4),expression:"vertt4"}],ref:"testt4",attrs:{"id":"testt7"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg076===0 ? "color:red" : "color:black")},[_vm._v("76. Dedica usted mucho tiempo a platicar sobre los problemas regionales con la gentes ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg076),expression:"eval_16pf.pg076"}],attrs:{"value":"a","name":"group76","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg076,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg076", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg076),expression:"eval_16pf.pg076"}],attrs:{"value":"b","name":"group76","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg076,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg076", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg076),expression:"eval_16pf.pg076"}],attrs:{"value":"c","name":"group76","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg076,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg076", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg077===0 ? "color:red" : "color:black")},[_vm._v("77.  Preferiría usted ser: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg077),expression:"eval_16pf.pg077"}],attrs:{"value":"a","name":"group77","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg077,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg077", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Ingeniero")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg077),expression:"eval_16pf.pg077"}],attrs:{"value":"b","name":"group77","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg077,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg077", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg077),expression:"eval_16pf.pg077"}],attrs:{"value":"c","name":"group77","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg077,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg077", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Profesor de teorías sociales ")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg078===0 ? "color:red" : "color:black")},[_vm._v("78. Es necesario a menudo dominarse para no meterse a tratar de resolver los problemas de otras personas")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg078),expression:"eval_16pf.pg078"}],attrs:{"value":"a","name":"group78","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg078,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg078", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg078),expression:"eval_16pf.pg078"}],attrs:{"value":"b","name":"group78","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg078,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg078", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg078),expression:"eval_16pf.pg078"}],attrs:{"value":"c","name":"group78","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg078,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg078", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg079===0 ? "color:red" : "color:black")},[_vm._v("79. Cuántos de sus vecinos le aburren platicando ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg079),expression:"eval_16pf.pg079"}],attrs:{"value":"a","name":"group79","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg079,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg079", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) La Mayoría")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg079),expression:"eval_16pf.pg079"}],attrs:{"value":"b","name":"group79","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg079,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg079", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg079),expression:"eval_16pf.pg079"}],attrs:{"value":"c","name":"group79","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg079,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg079", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Casi ninguno")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg080===0 ? "color:red" : "color:black")},[_vm._v("80. Si hay propaganda escondida en lo que está leyendo usted generalmente lo nota antes de que alguien se lo indique ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg080),expression:"eval_16pf.pg080"}],attrs:{"value":"a","name":"group80","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg080,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg080", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg080),expression:"eval_16pf.pg080"}],attrs:{"value":"b","name":"group80","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg080,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg080", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg080),expression:"eval_16pf.pg080"}],attrs:{"value":"c","name":"group80","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg080,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg080", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg081===0 ? "color:red" : "color:black")},[_vm._v("81. Cree usted que cada cuento debe indicar alguna moraleja ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg081),expression:"eval_16pf.pg081"}],attrs:{"value":"a","name":"group81","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg081,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg081", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg081),expression:"eval_16pf.pg081"}],attrs:{"value":"b","name":"group81","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg081,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg081", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg081),expression:"eval_16pf.pg081"}],attrs:{"value":"c","name":"group81","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg081,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg081", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg082===0 ? "color:red" : "color:black")},[_vm._v("82. Causa más dificultad el hecho de que la gente:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg082),expression:"eval_16pf.pg082"}],attrs:{"value":"a","name":"group82","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg082,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg082", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Cambia y modifica métodos ya bien comprobados;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg082),expression:"eval_16pf.pg082"}],attrs:{"value":"b","name":"group82","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg082,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg082", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg082),expression:"eval_16pf.pg082"}],attrs:{"value":"c","name":"group82","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg082,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg082", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Rechaza los métodos nuevos y modernizados")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg083===0 ? "color:red" : "color:black")},[_vm._v("83. Hay veces que no se atreve a utilizar sus propias ideas porque le parecen poco prácticas ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg083),expression:"eval_16pf.pg083"}],attrs:{"value":"a","name":"group83","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg083,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg083", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg083),expression:"eval_16pf.pg083"}],attrs:{"value":"b","name":"group83","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg083,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg083", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg083),expression:"eval_16pf.pg083"}],attrs:{"value":"c","name":"group83","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg083,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg083", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg084===0 ? "color:red" : "color:black")},[_vm._v("84. Parecen molestarse algunas personas estiradas al ver que usted se acerca")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg084),expression:"eval_16pf.pg084"}],attrs:{"value":"a","name":"group84","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg084,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg084", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg084),expression:"eval_16pf.pg084"}],attrs:{"value":"b","name":"group84","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg084,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg084", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg084),expression:"eval_16pf.pg084"}],attrs:{"value":"c","name":"group84","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg084,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg084", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg085===0 ? "color:red" : "color:black")},[_vm._v("85. Puede usted confiar en que su memoria no le traiciona, aún en detalles pequeños ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg085),expression:"eval_16pf.pg085"}],attrs:{"value":"a","name":"group85","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg085,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg085", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg085),expression:"eval_16pf.pg085"}],attrs:{"value":"b","name":"group85","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg085,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg085", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg085),expression:"eval_16pf.pg085"}],attrs:{"value":"c","name":"group85","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg085,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg085", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg086===0 ? "color:red" : "color:black")},[_vm._v("86. A veces es usted menos considerado con las demás personas que ellas de usted")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg086),expression:"eval_16pf.pg086"}],attrs:{"value":"a","name":"group86","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg086,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg086", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg086),expression:"eval_16pf.pg086"}],attrs:{"value":"b","name":"group86","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg086,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg086", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg086),expression:"eval_16pf.pg086"}],attrs:{"value":"c","name":"group86","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg086,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg086", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg087===0 ? "color:red" : "color:black")},[_vm._v("87. Es usted lento para decir lo que siente, en comparación con la demás gente ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg087),expression:"eval_16pf.pg087"}],attrs:{"value":"a","name":"group87","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg087,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg087", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg087),expression:"eval_16pf.pg087"}],attrs:{"value":"b","name":"group87","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg087,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg087", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg087),expression:"eval_16pf.pg087"}],attrs:{"value":"c","name":"group87","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg087,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg087", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg088===0 ? "color:red" : "color:black")},[_vm._v("88. El número correcto para continur la serie de numeros 1,2,3,6,5 es:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg088),expression:"eval_16pf.pg088"}],attrs:{"value":"a","name":"group88","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg088,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg088", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) 5")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg088),expression:"eval_16pf.pg088"}],attrs:{"value":"b","name":"group88","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg088,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg088", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) 7")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg088),expression:"eval_16pf.pg088"}],attrs:{"value":"c","name":"group88","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg088,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg088", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) 10")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg089===0 ? "color:red" : "color:black")},[_vm._v("89. Se impacienta usted hasta enfurecerse cuando alguien lo demora")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg089),expression:"eval_16pf.pg089"}],attrs:{"value":"a","name":"group89","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg089,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg089", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg089),expression:"eval_16pf.pg089"}],attrs:{"value":"b","name":"group89","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg089,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg089", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg089),expression:"eval_16pf.pg089"}],attrs:{"value":"c","name":"group89","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg089,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg089", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg090===0 ? "color:red" : "color:black")},[_vm._v("90. Dice la gente que usted es una persona que tiende a salirse con la suya")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg090),expression:"eval_16pf.pg090"}],attrs:{"value":"a","name":"group90","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg090,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg090", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg090),expression:"eval_16pf.pg090"}],attrs:{"value":"b","name":"group90","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg090,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg090", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg090),expression:"eval_16pf.pg090"}],attrs:{"value":"c","name":"group90","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg090,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg090", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg091===0 ? "color:red" : "color:black")},[_vm._v("91. Es usted lento para quejarse sino se le da el material adecuado para su trabajo ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg091),expression:"eval_16pf.pg091"}],attrs:{"value":"a","name":"group91","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg091,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg091", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg091),expression:"eval_16pf.pg091"}],attrs:{"value":"b","name":"group91","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg091,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg091", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg091),expression:"eval_16pf.pg091"}],attrs:{"value":"c","name":"group91","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg091,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg091", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg092===0 ? "color:red" : "color:black")},[_vm._v("92. En casa:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg092),expression:"eval_16pf.pg092"}],attrs:{"value":"a","name":"group92","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg092,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg092", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Utiliza su tiempo en platicar y descansar;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg092),expression:"eval_16pf.pg092"}],attrs:{"value":"b","name":"group92","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg092,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg092", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg092),expression:"eval_16pf.pg092"}],attrs:{"value":"c","name":"group92","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg092,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg092", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Piensa ocupar su tiempo con trabajos especiales. ")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg093===0 ? "color:red" : "color:black")},[_vm._v("93. Es usted tímido y cauteloso en hacer nuevas amistades ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg093),expression:"eval_16pf.pg093"}],attrs:{"value":"a","name":"group93","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg093,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg093", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg093),expression:"eval_16pf.pg093"}],attrs:{"value":"b","name":"group93","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg093,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg093", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg093),expression:"eval_16pf.pg093"}],attrs:{"value":"c","name":"group93","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg093,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg093", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg094===0 ? "color:red" : "color:black")},[_vm._v("94. Cree usted que lo que se trata de expresar en la poesía se podría expresar con la misma claridad en lenguaje común y corriente")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg094),expression:"eval_16pf.pg094"}],attrs:{"value":"a","name":"group94","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg094,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg094", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg094),expression:"eval_16pf.pg094"}],attrs:{"value":"b","name":"group94","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg094,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg094", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg094),expression:"eval_16pf.pg094"}],attrs:{"value":"c","name":"group94","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg094,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg094", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg095===0 ? "color:red" : "color:black")},[_vm._v("95. Sospecha usted que las personas que aparentan amistad con usted a veces le son desleales en su ausencia")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg095),expression:"eval_16pf.pg095"}],attrs:{"value":"a","name":"group95","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg095,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg095", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí ?")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg095),expression:"eval_16pf.pg095"}],attrs:{"value":"b","name":"group95","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg095,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg095", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg095),expression:"eval_16pf.pg095"}],attrs:{"value":"c","name":"group95","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg095,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg095", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg096===0 ? "color:red" : "color:black")},[_vm._v("96. Dejan generalmente sin cambio su personalidad aun las experiencias más dramaticas en el curso del año ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg096),expression:"eval_16pf.pg096"}],attrs:{"value":"a","name":"group96","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg096,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg096", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg096),expression:"eval_16pf.pg096"}],attrs:{"value":"b","name":"group96","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg096,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg096", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg096),expression:"eval_16pf.pg096"}],attrs:{"value":"c","name":"group96","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg096,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg096", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg097===0 ? "color:red" : "color:black")},[_vm._v("97. Habla usted despacio o lentamente ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg097),expression:"eval_16pf.pg097"}],attrs:{"value":"a","name":"group97","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg097,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg097", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg097),expression:"eval_16pf.pg097"}],attrs:{"value":"b","name":"group97","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg097,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg097", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg097),expression:"eval_16pf.pg097"}],attrs:{"value":"c","name":"group97","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg097,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg097", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg098===0 ? "color:red" : "color:black")},[_vm._v("98. Siente usted temor o disgusto casi incontrolable hacia algunas cosas; por ejemplo algún animal, algún lugar enparticular, etc. ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg098),expression:"eval_16pf.pg098"}],attrs:{"value":"a","name":"group98","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg098,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg098", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg098),expression:"eval_16pf.pg098"}],attrs:{"value":"b","name":"group98","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg098,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg098", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg098),expression:"eval_16pf.pg098"}],attrs:{"value":"c","name":"group98","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg098,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg098", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg099===0 ? "color:red" : "color:black")},[_vm._v("99. Dentro de un grupo, preferiría usted ser la persona que")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg099),expression:"eval_16pf.pg099"}],attrs:{"value":"a","name":"group99","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg099,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg099", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Trabaja sobre desarrollos técnicos;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg099),expression:"eval_16pf.pg099"}],attrs:{"value":"b","name":"group99","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg099,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg099", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg099),expression:"eval_16pf.pg099"}],attrs:{"value":"c","name":"group99","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg099,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg099", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Se encarga de los registros y la vigilancia de los reglamentos ")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg100===0 ? "color:red" : "color:black")},[_vm._v("100. Para saber cómo votar sobre alguna cuestión social, leería usted:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg100),expression:"eval_16pf.pg100"}],attrs:{"value":"a","name":"group100","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg100,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg100", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Una novela inteligente, que ha recibido buenas reseñas, sobre el tema;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg100),expression:"eval_16pf.pg100"}],attrs:{"value":"b","name":"group100","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg100,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg100", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg100),expression:"eval_16pf.pg100"}],attrs:{"value":"c","name":"group100","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg100,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg100", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Algún texto que enumera estadísticas y otros datos")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg101===0 ? "color:red" : "color:black")},[_vm._v("101. Tiene usted sueño de noche que son algo fantásticos ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg101),expression:"eval_16pf.pg101"}],attrs:{"value":"a","name":"group101","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg101,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg101", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg101),expression:"eval_16pf.pg101"}],attrs:{"value":"b","name":"group101","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg101,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg101", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg101),expression:"eval_16pf.pg101"}],attrs:{"value":"c","name":"group101","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg101,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg101", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_16pf.pg102===0 ? "color:red" : "color:black")},[_vm._v("102. Si se le deja solo en la casa por algún tiempo, tiende a ponerse algo ansioso")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg102),expression:"eval_16pf.pg102"}],attrs:{"value":"a","name":"group102","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_16pf.pg102,"a")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg102", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg102),expression:"eval_16pf.pg102"}],attrs:{"value":"b","name":"group102","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg102,"b")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg102", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_16pf.pg102),expression:"eval_16pf.pg102"}],attrs:{"value":"c","name":"group102","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_16pf.pg102,"c")},on:{"change":function($event){_vm.$set(_vm.eval_16pf, "pg102", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(6)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(3)}}},[_vm._m(7)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grabado===false),expression:"grabado===false"}],staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn tooltipped",attrs:{"data-position":"left","data-tooltip":"Grabar"},on:{"click":function($event){_vm.agregarEvaluacion()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("SELECCIONE EL SIGUIENTE BOTON PARA EMPEZAR LA EVALUACION.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("first_page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev03_npf_js__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab8d561_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev03_npf_vue__ = __webpack_require__(325);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev03_npf_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab8d561_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev03_npf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s2"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Departamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.depto),expression:"eval_npf.depto"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_npf.depto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_npf, "depto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.empresa),expression:"eval_npf.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_npf.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_npf, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.nombre),expression:"eval_npf.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_npf.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_npf, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Sexo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.sexo),expression:"eval_npf.sexo"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_npf.sexo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_npf, "sexo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_npf.empezo))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finalizoeval),expression:"finalizoeval"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_npf.termino))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para LEER u OCULTAR las instrucciones.","data-position":"top"}},[_vm._v("\n                            "+_vm._s(_vm.instrucciones)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{attrs:{"align":"justify"}},[_vm._v("\n                            Señor aspirante a empleo: Este es un cuestionario de sus actitudes. Lo que hace o lo que piensa acerca de ciertas situaciones. Las personas piensan de una manera u otra. Por lo tanto, no existen respuestas \"correctas\" o \"incorrectas\" a las preguntas. \n                            \n                            Se ofrecen tres posibles respuestas para cada pregunta, que Ud. debe contestar \"A\" o \"B\" o \"C\" seleccionando con el mouse en la correspondiente respuesta. Las preguntas están organizadas en dos (2) secciones. Sección 1: De la 1 a la 20, Sección 2: de la 21 a la 40."),_c('br'),_c('br'),_vm._v("\n                              \n                            Inicialmente todas las preguntas estarán en color "),_c('span',{staticStyle:{"font-weight":"bold","color":"red"}},[_vm._v("rojo")]),_vm._v(" como indicador\n                            que aún no han sido respondidas. Conforme vaya respondiendo, las preguntas se mostrarán en color negro. También tendrá un mensaje indicándole la cantidad \n                            de preguntas que aún no han sido respondidas. El siguiente "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("ejemplo")]),_vm._v(" de tres preguntas le permitirá estar seguro que comprende lo que debe hacer en el propio cuestionario."),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.ejeSinResponder>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_ejeSinResponder))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg001===0 ? "color:red" : "color:black")},[_vm._v("01. Me gusta hacer ejercicio al aire libre.")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"a","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"b","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"c","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg002===0 ? "color:red" : "color:black")},[_vm._v("02. Me gustaría ser: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"a","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Maquinista;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"b","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio; ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"c","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Vendedor")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg003===0 ? "color:red" : "color:black")},[_vm._v("03. Cuando duermo sueño mucho")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg003),expression:"ejemplo.pg003"}],attrs:{"value":"a","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg003,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg003", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg003),expression:"ejemplo.pg003"}],attrs:{"value":"b","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg003,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg003", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg003),expression:"ejemplo.pg003"}],attrs:{"value":"c","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg003,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg003", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg004===0 ? "color:red" : "color:black")},[_vm._v("04. Me gusta una pesona que sea: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg004),expression:"ejemplo.pg004"}],attrs:{"value":"a","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg004,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg004", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) atenta con la gente;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg004),expression:"ejemplo.pg004"}],attrs:{"value":"b","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg004,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg004", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg004),expression:"ejemplo.pg004"}],attrs:{"value":"c","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg004,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg004", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) apartada e indiferente con la gente")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg005===0 ? "color:red" : "color:black")},[_vm._v("05. Me es difícil conversar cuando el radio está puesto")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg005),expression:"ejemplo.pg005"}],attrs:{"value":"a","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg005,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg005", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg005),expression:"ejemplo.pg005"}],attrs:{"value":"b","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg005,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg005", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Algo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg005),expression:"ejemplo.pg005"}],attrs:{"value":"c","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg005,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg005", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])])]),_vm._v("\n                            Tenga presente las siguientes reglas:"),_c('br'),_vm._v("\n                            1. Conteste las preguntas tan franca y honradamente como le sea posible. No existe ventaja en crear una mejor impresión personal. No marque una respuesta que no sea cierta por creer que \"es lo que debe decir\". "),_c('br'),_vm._v("\n                            2. Conteste con la mayor rapidez posible. No dedique tiempo a meditar sobre las preguntas. Anote su primera reacción y pase de alli a la próxima pregunta. "),_c('br'),_vm._v("\n                            3. Marque la respusta \"A\" o la respuesta \"C\" para la mayoría de las preguntas. Solamente marque la respuesta \"B\" cuando le sea imposible contestar las otras, aunque en algunos casos le será dificil escoger. "),_c('br'),_vm._v("\n                            4. Conteste todas las preguntas sin excepción. Habrá preguntas que no reflejan sus ideas, pero debe contestalas todas. No debe saltarse ninguna. Sus respuestas serán confidenciales."),_c('br'),_vm._v(" "),_vm._m(0)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12"},[_c('div',{staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("Empezar Evaluación de ESTABILIDAD")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s12"},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s6"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt4"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("Preguntas 01 - 20")])]),_vm._v(" "),_c('li',{staticClass:"tab col s6"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt5"},on:{"click":function($event){_vm.nadaG1(2)}}},[_vm._v("Preguntas 21 - 40")])])]),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.pregSinContestar>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_sinResponder))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt4"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg001===0 ? "color:red" : "color:black")},[_vm._v("01. Me parece que es mejor ayudar a los hospitales y otras instituciones caritativas con:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg001),expression:"eval_npf.pg001"}],attrs:{"value":"a","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg001,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg001", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) las donaciones particulares de los que puedan;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg001),expression:"eval_npf.pg001"}],attrs:{"value":"b","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg001,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg001", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg001),expression:"eval_npf.pg001"}],attrs:{"value":"c","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg001,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg001", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) la ayuda del gobierno")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg002===0 ? "color:red" : "color:black")},[_vm._v("02. Como aficiones preferiría")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg002),expression:"eval_npf.pg002"}],attrs:{"value":"a","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg002,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg002", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Ping pong y el baile ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg002),expression:"eval_npf.pg002"}],attrs:{"value":"b","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg002,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg002", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg002),expression:"eval_npf.pg002"}],attrs:{"value":"c","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg002,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg002", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) el fútbol y la lucha libre")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg003===0 ? "color:red" : "color:black")},[_vm._v("03. Cuando alguien se porta mal, yo:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg003),expression:"eval_npf.pg003"}],attrs:{"value":"a","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg003,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg003", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) le hago ver claramente lo que pienso;r")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg003),expression:"eval_npf.pg003"}],attrs:{"value":"b","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg003,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg003", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg003),expression:"eval_npf.pg003"}],attrs:{"value":"c","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg003,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg003", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) aparento no haberlo notado")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg004===0 ? "color:red" : "color:black")},[_vm._v("04. Es tan grande mi deseo de llegar puntualmente para la salida de un Bus que me pongo tenso y nervioso, aún cuando sé que cuento con bastante tiempo")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg004),expression:"eval_npf.pg004"}],attrs:{"value":"a","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg004,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg004", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Siempre")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg004),expression:"eval_npf.pg004"}],attrs:{"value":"b","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg004,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg004", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg004),expression:"eval_npf.pg004"}],attrs:{"value":"c","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg004,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg004", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Nunca")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg005===0 ? "color:red" : "color:black")},[_vm._v("05. Preferiría ser:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg005),expression:"eval_npf.pg005"}],attrs:{"value":"a","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg005,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg005", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) oficial de la armada o del ejercito; ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg005),expression:"eval_npf.pg005"}],attrs:{"value":"b","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg005,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg005", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg005),expression:"eval_npf.pg005"}],attrs:{"value":"c","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg005,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg005", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Músico ?")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg006===0 ? "color:red" : "color:black")},[_vm._v("06. Me molesta mucho tener que esperar innecesariamente a las personas")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg006),expression:"eval_npf.pg006"}],attrs:{"value":"a","name":"group6","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg006,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg006", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Siempre")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg006),expression:"eval_npf.pg006"}],attrs:{"value":"b","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg006,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg006", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg006),expression:"eval_npf.pg006"}],attrs:{"value":"c","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg006,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg006", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Casi nunca")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg007===0 ? "color:red" : "color:black")},[_vm._v("07. Cuando me encuentro con gente descuidada y desordenada")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg007),expression:"eval_npf.pg007"}],attrs:{"value":"a","name":"group7","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg007,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg007", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) lo tomo como \"cosas de la vida\"")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg007),expression:"eval_npf.pg007"}],attrs:{"value":"b","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg007,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg007", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg007),expression:"eval_npf.pg007"}],attrs:{"value":"c","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg007,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg007", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Me siento molesto o disgustado")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg008===0 ? "color:red" : "color:black")},[_vm._v("08. Hay veces que la memoria me sirve menos que en otras ocasiones ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg008),expression:"eval_npf.pg008"}],attrs:{"value":"a","name":"group8","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg008,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg008", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Cierto")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg008),expression:"eval_npf.pg008"}],attrs:{"value":"b","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg008,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg008", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg008),expression:"eval_npf.pg008"}],attrs:{"value":"c","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg008,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg008", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No cierto")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg009===0 ? "color:red" : "color:black")},[_vm._v("09. He econtrado que es buena idea evitar situaciones que tienden a excitarme demasiado ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg009),expression:"eval_npf.pg009"}],attrs:{"value":"a","name":"group9","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg009,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg009", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Siempre")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg009),expression:"eval_npf.pg009"}],attrs:{"value":"b","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg009,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg009", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg009),expression:"eval_npf.pg009"}],attrs:{"value":"c","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg009,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg009", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Nunca")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg010===0 ? "color:red" : "color:black")},[_vm._v("10. Si yo viera dos niños, desconocidos para mí, peleando en la calle: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg010),expression:"eval_npf.pg010"}],attrs:{"value":"a","name":"group10","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg010,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg010", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) los interrumpiría para tratar de conseguir una solución amistosa")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg010),expression:"eval_npf.pg010"}],attrs:{"value":"b","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg010,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg010", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg010),expression:"eval_npf.pg010"}],attrs:{"value":"c","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg010,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg010", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) los dejaría que se arreglaran solos")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg011===0 ? "color:red" : "color:black")},[_vm._v("11. Soy una persona de ánimos fuertes (por ejemplo, alegría o depresion) que duran, a veces sin causa")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg011),expression:"eval_npf.pg011"}],attrs:{"value":"a","name":"group11","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg011,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg011", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Cierto")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg011),expression:"eval_npf.pg011"}],attrs:{"value":"b","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg011,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg011", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg011),expression:"eval_npf.pg011"}],attrs:{"value":"c","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg011,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg011", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No cierto")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg012===0 ? "color:red" : "color:black")},[_vm._v("12. Preferiría pasar una tarde libre en:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg012),expression:"eval_npf.pg012"}],attrs:{"value":"a","name":"group12","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg012,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg012", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) una galería de arte")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg012),expression:"eval_npf.pg012"}],attrs:{"value":"b","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg012,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg012", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg012),expression:"eval_npf.pg012"}],attrs:{"value":"c","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg012,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg012", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) una buena corrida de toros")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg013===0 ? "color:red" : "color:black")},[_vm._v("13. De niño, sentía que odiaba a mis padres")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg013),expression:"eval_npf.pg013"}],attrs:{"value":"a","name":"group13","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg013,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg013", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg013),expression:"eval_npf.pg013"}],attrs:{"value":"b","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg013,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg013", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Casi nunca")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg013),expression:"eval_npf.pg013"}],attrs:{"value":"c","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg013,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg013", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Nunca")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg014===0 ? "color:red" : "color:black")},[_vm._v("14. Si soy yo el responsable de algún proyecto de grupo, insisto en que se acepte mi punto de vista en toda disputa, o renuncio")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg014),expression:"eval_npf.pg014"}],attrs:{"value":"a","name":"group14","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg014,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg014", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Absolutamente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg014),expression:"eval_npf.pg014"}],attrs:{"value":"b","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg014,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg014", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Generalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg014),expression:"eval_npf.pg014"}],attrs:{"value":"c","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg014,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg014", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Me adapto")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg015===0 ? "color:red" : "color:black")},[_vm._v("15. Creo que la gente estaría más contenta si: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg015),expression:"eval_npf.pg015"}],attrs:{"value":"a","name":"group15","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg015,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg015", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) pensara más sobre el buen comportamiento ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg015),expression:"eval_npf.pg015"}],attrs:{"value":"b","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg015,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg015", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg015),expression:"eval_npf.pg015"}],attrs:{"value":"c","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg015,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg015", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) hiciera las cosas que le dan gusto, no obstante la demás gente.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg016===0 ? "color:red" : "color:black")},[_vm._v("16. He tenido que cancelar mi viaje de placer por sentirme inesperadamente mal")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg016),expression:"eval_npf.pg016"}],attrs:{"value":"a","name":"group16","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg016,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg016", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Varias veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg016),expression:"eval_npf.pg016"}],attrs:{"value":"b","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg016,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg016", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Una ve")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg016),expression:"eval_npf.pg016"}],attrs:{"value":"c","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg016,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg016", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Nunca")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg017===0 ? "color:red" : "color:black")},[_vm._v("17. Si me encuentro solo en la casa de noche, tiendo a sentirme incómodo, y hasta temeroso")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg017),expression:"eval_npf.pg017"}],attrs:{"value":"a","name":"group17","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg017,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg017", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Generalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg017),expression:"eval_npf.pg017"}],attrs:{"value":"b","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg017,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg017", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg017),expression:"eval_npf.pg017"}],attrs:{"value":"c","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg017,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg017", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Nunca")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg018===0 ? "color:red" : "color:black")},[_vm._v("18. En tiempos de amenaza, me parece mejor que el país dedique más dinero a: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg018),expression:"eval_npf.pg018"}],attrs:{"value":"a","name":"group18","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg018,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg018", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Armamento")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg018),expression:"eval_npf.pg018"}],attrs:{"value":"b","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg018,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg018", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg018),expression:"eval_npf.pg018"}],attrs:{"value":"c","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg018,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg018", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Escuelas")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg019===0 ? "color:red" : "color:black")},[_vm._v("19. Mis amigos me consideran singularmente libre de prejuicios y novedades caprichosas ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg019),expression:"eval_npf.pg019"}],attrs:{"value":"a","name":"group19","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg019,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg019", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí, decididamente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg019),expression:"eval_npf.pg019"}],attrs:{"value":"b","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg019,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg019", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Sí, mas que la ordinaria")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg019),expression:"eval_npf.pg019"}],attrs:{"value":"c","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg019,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg019", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No, especialmente")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg020===0 ? "color:red" : "color:black")},[_vm._v("20. Una vez dormido, generalmente: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg020),expression:"eval_npf.pg020"}],attrs:{"value":"a","name":"group20","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg020,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg020", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) duermo \"como un tronco\" ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg020),expression:"eval_npf.pg020"}],attrs:{"value":"b","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg020,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg020", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg020),expression:"eval_npf.pg020"}],attrs:{"value":"c","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg020,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg020", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) tiendo a soñar mucho y hablar dormido")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt5"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg021===0 ? "color:red" : "color:black")},[_vm._v("21. Admiro más")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg021),expression:"eval_npf.pg021"}],attrs:{"value":"a","name":"group21","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg021,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg021", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) a un hombre astuto, aunque sea confiable medianamente ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg021),expression:"eval_npf.pg021"}],attrs:{"value":"b","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg021,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg021", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg021),expression:"eval_npf.pg021"}],attrs:{"value":"c","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg021,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg021", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) a un hombre concienzudo, aunque sea solamente de una capacidad mediocre")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg022===0 ? "color:red" : "color:black")},[_vm._v("22. Preferiría ser:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg022),expression:"eval_npf.pg022"}],attrs:{"value":"a","name":"group22","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg022,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg022", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Ingeniero")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg022),expression:"eval_npf.pg022"}],attrs:{"value":"b","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg022,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg022", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg022),expression:"eval_npf.pg022"}],attrs:{"value":"c","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg022,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg022", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Profesor de estudios sociales")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg023===0 ? "color:red" : "color:black")},[_vm._v("23. A veces simulo amistad siendo amable con las personas, cuando de hecho no me simpatizan")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg023),expression:"eval_npf.pg023"}],attrs:{"value":"a","name":"group23","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg023,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg023", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg023),expression:"eval_npf.pg023"}],attrs:{"value":"b","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg023,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg023", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg023),expression:"eval_npf.pg023"}],attrs:{"value":"c","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg023,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg023", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg024===0 ? "color:red" : "color:black")},[_vm._v("24. Me parece que la educacion debería")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg024),expression:"eval_npf.pg024"}],attrs:{"value":"a","name":"group24","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg024,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg024", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) apegarse a las reglas disciplinarias de sentido común de la escuela clásica")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg024),expression:"eval_npf.pg024"}],attrs:{"value":"b","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg024,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg024", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg024),expression:"eval_npf.pg024"}],attrs:{"value":"c","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg024,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg024", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) ensayar nuevas técnicas para educar a los niños")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg025===0 ? "color:red" : "color:black")},[_vm._v("25. Por poco me he desmayado al ver sangre ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg025),expression:"eval_npf.pg025"}],attrs:{"value":"a","name":"group25","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg025,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg025", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Varias veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg025),expression:"eval_npf.pg025"}],attrs:{"value":"b","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg025,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg025", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Una vez")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg025),expression:"eval_npf.pg025"}],attrs:{"value":"c","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg025,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg025", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Nunca")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg026===0 ? "color:red" : "color:black")},[_vm._v("26. Sí me es necesario estar sentado durante una junta larga, me gusta hacer dibujos o diagramas en pedacitos de papel")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg026),expression:"eval_npf.pg026"}],attrs:{"value":"a","name":"group26","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg026,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg026", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Generalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg026),expression:"eval_npf.pg026"}],attrs:{"value":"b","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg026,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg026", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg026),expression:"eval_npf.pg026"}],attrs:{"value":"c","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg026,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg026", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Nuca")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg027===0 ? "color:red" : "color:black")},[_vm._v("27.A veces me irritan reglamentos y restricciones que, en momentos más calmados, reconozco como correctos")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg027),expression:"eval_npf.pg027"}],attrs:{"value":"a","name":"group27","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg027,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg027", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) A menudo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg027),expression:"eval_npf.pg027"}],attrs:{"value":"b","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg027,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg027", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg027),expression:"eval_npf.pg027"}],attrs:{"value":"c","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg027,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg027", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Nunca")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg028===0 ? "color:red" : "color:black")},[_vm._v("28. Escucho las opiniones opuestas de un problema antes de formar mis juicios")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg028),expression:"eval_npf.pg028"}],attrs:{"value":"a","name":"group28","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg028,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg028", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Siempre")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg028),expression:"eval_npf.pg028"}],attrs:{"value":"b","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg028,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg028", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Generalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg028),expression:"eval_npf.pg028"}],attrs:{"value":"c","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg028,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg028", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Pocas veces")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg029===0 ? "color:red" : "color:black")},[_vm._v("29. Preferiría que se me presentaran las ideas básicas de la vida:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg029),expression:"eval_npf.pg029"}],attrs:{"value":"a","name":"group29","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg029,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg029", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) En lenguaje sencillo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg029),expression:"eval_npf.pg029"}],attrs:{"value":"b","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg029,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg029", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg029),expression:"eval_npf.pg029"}],attrs:{"value":"c","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg029,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg029", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) En forma de poesía")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg030===0 ? "color:red" : "color:black")},[_vm._v("30. Me parece que mucho del trabajo que se hace a mi alrededor está mal hecho")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg030),expression:"eval_npf.pg030"}],attrs:{"value":"a","name":"group30","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg030,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg030", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Muy a menudo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg030),expression:"eval_npf.pg030"}],attrs:{"value":"b","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg030,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg030", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg030),expression:"eval_npf.pg030"}],attrs:{"value":"c","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg030,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg030", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Casi nunca")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg031===0 ? "color:red" : "color:black")},[_vm._v("31. En el templo, prefiero escuchar:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg031),expression:"eval_npf.pg031"}],attrs:{"value":"a","name":"group31","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg031,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg031", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Un buen sermón")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg031),expression:"eval_npf.pg031"}],attrs:{"value":"b","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg031,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg031", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg031),expression:"eval_npf.pg031"}],attrs:{"value":"c","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg031,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg031", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) cantos")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg032===0 ? "color:red" : "color:black")},[_vm._v("32. Me siento \"muy molesto\" al escuchar que alguien dice algo desagradable de mi")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg032),expression:"eval_npf.pg032"}],attrs:{"value":"a","name":"group32","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg032,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg032", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Muy facilmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg032),expression:"eval_npf.pg032"}],attrs:{"value":"b","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg032,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg032", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No muy facilmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg032),expression:"eval_npf.pg032"}],attrs:{"value":"c","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg032,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg032", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Para nada")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg033===0 ? "color:red" : "color:black")},[_vm._v("33. Preferiría pasarme una noche: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg033),expression:"eval_npf.pg033"}],attrs:{"value":"a","name":"group33","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg033,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg033", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) En un juego reñido de naipes")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg033),expression:"eval_npf.pg033"}],attrs:{"value":"b","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg033,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg033", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg033),expression:"eval_npf.pg033"}],attrs:{"value":"c","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg033,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg033", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) mirando fotos de vacaciones pasadas")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg034===0 ? "color:red" : "color:black")},[_vm._v("34. Cuando me acuesto:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg034),expression:"eval_npf.pg034"}],attrs:{"value":"a","name":"group34","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg034,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg034", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) me olvido de todo y duermo inmediatamente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg034),expression:"eval_npf.pg034"}],attrs:{"value":"b","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg034,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg034", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg034),expression:"eval_npf.pg034"}],attrs:{"value":"c","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg034,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg034", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) me quedo despierto mucho tiempo pensando en problemas")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg035===0 ? "color:red" : "color:black")},[_vm._v("35. Cuando veo una bella puesta de sol, me siento")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg035),expression:"eval_npf.pg035"}],attrs:{"value":"a","name":"group35","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg035,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg035", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Contento")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg035),expression:"eval_npf.pg035"}],attrs:{"value":"b","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg035,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg035", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg035),expression:"eval_npf.pg035"}],attrs:{"value":"c","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg035,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg035", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) conmovido hasta las lagrimas ")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg036===0 ? "color:red" : "color:black")},[_vm._v("36. Después de un día de trabajo me siento cansado para salir")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg036),expression:"eval_npf.pg036"}],attrs:{"value":"a","name":"group36","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg036,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg036", "a")}}}),_vm._v(" "),_c('span',[_vm._v("a) Sí, a menudo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg036),expression:"eval_npf.pg036"}],attrs:{"value":"b","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg036,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg036", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg036),expression:"eval_npf.pg036"}],attrs:{"value":"c","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg036,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg036", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No, casi nunca")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg037===0 ? "color:red" : "color:black")},[_vm._v("37. Soy menos considerado con los demas que ellos conmigo")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg037),expression:"eval_npf.pg037"}],attrs:{"value":"a","name":"group37","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg037,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg037", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí, a menudo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg037),expression:"eval_npf.pg037"}],attrs:{"value":"b","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg037,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg037", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg037),expression:"eval_npf.pg037"}],attrs:{"value":"c","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg037,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg037", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Casi nunca")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg038===0 ? "color:red" : "color:black")},[_vm._v("38. Existen algunos lugares, animales o gente que me disgustan instintivamente, sin saber porqué ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg038),expression:"eval_npf.pg038"}],attrs:{"value":"a","name":"group38","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg038,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg038", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) decididamente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg038),expression:"eval_npf.pg038"}],attrs:{"value":"b","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg038,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg038", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A cierto grado")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg038),expression:"eval_npf.pg038"}],attrs:{"value":"c","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg038,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg038", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Para nada")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg039===0 ? "color:red" : "color:black")},[_vm._v("39. Pienso que la paciencia y la dedicación pueden lograr el exito para:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg039),expression:"eval_npf.pg039"}],attrs:{"value":"a","name":"group39","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg039,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg039", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Casi todos")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg039),expression:"eval_npf.pg039"}],attrs:{"value":"b","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg039,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg039", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg039),expression:"eval_npf.pg039"}],attrs:{"value":"c","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg039,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg039", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) solamente los que gozan también de buena suerte ")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_npf.pg040===0 ? "color:red" : "color:black")},[_vm._v("40. Me paree más importante ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg040),expression:"eval_npf.pg040"}],attrs:{"value":"a","name":"group40","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_npf.pg040,"a")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg040", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) resolver problemas internacionales;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg040),expression:"eval_npf.pg040"}],attrs:{"value":"b","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg040,"b")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg040", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_npf.pg040),expression:"eval_npf.pg040"}],attrs:{"value":"c","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_npf.pg040,"c")},on:{"change":function($event){_vm.$set(_vm.eval_npf, "pg040", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) resolver los problemas sexuales que tiene la juventud")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grabado===false),expression:"grabado===false"}],staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn tooltipped",attrs:{"data-position":"left","data-tooltip":"Grabar"},on:{"click":function($event){_vm.agregarEvaluacion()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("SELECCIONE EL SIGUIENTE BOTON PARA EMPEZAR LA EVALUACION.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev04_cpf_js__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffc6e96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev04_cpf_vue__ = __webpack_require__(327);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev04_cpf_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffc6e96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev04_cpf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s2"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Departamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.depto),expression:"eval_cpf.depto"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_cpf.depto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_cpf, "depto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.empresa),expression:"eval_cpf.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_cpf.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_cpf, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.nombre),expression:"eval_cpf.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_cpf.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_cpf, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Sexo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.sexo),expression:"eval_cpf.sexo"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_cpf.sexo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_cpf, "sexo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_cpf.empezo))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finalizoeval),expression:"finalizoeval"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_cpf.termino))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para LEER u OCULTAR las instrucciones.","data-position":"top"}},[_vm._v("\n                            "+_vm._s(_vm.instrucciones)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{attrs:{"align":"justify"}},[_vm._v("\n                            Señor aspirante a empleo: Este es un cuestionario de sus actitudes. Lo que hace o lo que piensa acerca de ciertas situaciones. Las personas piensan de una manera u otra. Por lo tanto, no existen respuestas \"correctas\" o \"incorrectas\" a las preguntas. \n                            \n                            Se ofrecen tres posibles respuestas para cada pregunta, que Ud. debe contestar \"A\" o \"B\" o \"C\" seleccionando con el mouse en la correspondiente respuesta. Las preguntas están organizadas en dos (2) secciones. Sección 1: De la 1 a la 20, Sección 2: de la 21 a la 40."),_c('br'),_c('br'),_vm._v("\n                              \n                            Inicialmente todas las preguntas estarán en color "),_c('span',{staticStyle:{"font-weight":"bold","color":"red"}},[_vm._v("rojo")]),_vm._v(" como indicador\n                            que aún no han sido respondidas. Conforme vaya respondiendo, las preguntas se mostrarán en color negro. También tendrá un mensaje indicándole la cantidad \n                            de preguntas que aún no han sido respondidas. El siguiente "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("ejemplo")]),_vm._v(" de tres preguntas le permitirá estar seguro que comprende lo que debe hacer en el propio cuestionario."),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.ejeSinResponder>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_ejeSinResponder))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg001===0 ? "color:red" : "color:black")},[_vm._v("01. Me gusta hacer ejercicio al aire libre.")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"a","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"b","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"c","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg002===0 ? "color:red" : "color:black")},[_vm._v("02. Me gustaría ser: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"a","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Maquinista;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"b","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio; ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"c","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Vendedor")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg003===0 ? "color:red" : "color:black")},[_vm._v("03. Cuando duermo sueño mucho")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg003),expression:"ejemplo.pg003"}],attrs:{"value":"a","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg003,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg003", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg003),expression:"ejemplo.pg003"}],attrs:{"value":"b","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg003,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg003", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg003),expression:"ejemplo.pg003"}],attrs:{"value":"c","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg003,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg003", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg004===0 ? "color:red" : "color:black")},[_vm._v("04. Me gusta una pesona que sea: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg004),expression:"ejemplo.pg004"}],attrs:{"value":"a","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg004,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg004", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Atenta con la gente;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg004),expression:"ejemplo.pg004"}],attrs:{"value":"b","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg004,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg004", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg004),expression:"ejemplo.pg004"}],attrs:{"value":"c","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg004,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg004", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Apartada e indiferente con la gente")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.ejemplo.pg005===0 ? "color:red" : "color:black")},[_vm._v("05. Me es difícil conversar cuando el radio está puesto")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg005),expression:"ejemplo.pg005"}],attrs:{"value":"a","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg005,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg005", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg005),expression:"ejemplo.pg005"}],attrs:{"value":"b","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg005,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg005", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Algo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg005),expression:"ejemplo.pg005"}],attrs:{"value":"c","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg005,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg005", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])])]),_vm._v("\n                            Tenga presente las siguientes reglas:"),_c('br'),_vm._v("\n                            1. Conteste las preguntas tan franca y honradamente como le sea posible. No existe ventaja en crear una mejor impresión personal. No marque una respuesta que no sea cierta por creer que \"es lo que debe decir\". "),_c('br'),_vm._v("\n                            2. Conteste con la mayor rapidez posible. No dedique tiempo a meditar sobre las preguntas. Anote su primera reacción y pase de alli a la próxima pregunta. "),_c('br'),_vm._v("\n                            3. Marque la respusta \"A\" o la respuesta \"C\" para la mayoría de las preguntas. Solamente marque la respuesta \"B\" cuando le sea imposible contestar las otras, aunque en algunos casos le será dificil escoger. "),_c('br'),_vm._v("\n                            4. Conteste todas las preguntas sin excepción. Habrá preguntas que no reflejan sus ideas, pero debe contestalas todas. No debe saltarse ninguna. Sus respuestas serán confidenciales."),_c('br'),_vm._v(" "),_vm._m(0)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12"},[_c('div',{staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("Empezar Evaluación de SOCIABILIDAD")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s12"},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s6"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt4"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("Preguntas 01 - 20")])]),_vm._v(" "),_c('li',{staticClass:"tab col s6"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt5"},on:{"click":function($event){_vm.nadaG1(2)}}},[_vm._v("Preguntas 21 - 40")])])]),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.pregSinContestar>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_sinResponder))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt4"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg001===0 ? "color:red" : "color:black")},[_vm._v("01. Preferiría ser")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg001),expression:"eval_cpf.pg001"}],attrs:{"value":"a","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg001,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg001", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Abogado")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg001),expression:"eval_cpf.pg001"}],attrs:{"value":"b","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg001,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg001", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg001),expression:"eval_cpf.pg001"}],attrs:{"value":"c","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg001,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg001", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Aviador")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg002===0 ? "color:red" : "color:black")},[_vm._v("02. Me irrita la gente presumida que se cree superior a los demás")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg002),expression:"eval_cpf.pg002"}],attrs:{"value":"a","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg002,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg002", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Si ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg002),expression:"eval_cpf.pg002"}],attrs:{"value":"b","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg002,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg002", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Pocas veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg002),expression:"eval_cpf.pg002"}],attrs:{"value":"c","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg002,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg002", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Nunca")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg003===0 ? "color:red" : "color:black")},[_vm._v("03. He participado activamente en la organización de un club, equipo, o grupo social parecido")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg003),expression:"eval_cpf.pg003"}],attrs:{"value":"a","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg003,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg003", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg003),expression:"eval_cpf.pg003"}],attrs:{"value":"b","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg003,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg003", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg003),expression:"eval_cpf.pg003"}],attrs:{"value":"c","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg003,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg003", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No, nunca")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg004===0 ? "color:red" : "color:black")},[_vm._v("04. Me quejo del mal servicio, aún cuando sea relativamente satisfactorio")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg004),expression:"eval_cpf.pg004"}],attrs:{"value":"a","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg004,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg004", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg004),expression:"eval_cpf.pg004"}],attrs:{"value":"b","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg004,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg004", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg004),expression:"eval_cpf.pg004"}],attrs:{"value":"c","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg004,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg004", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg005===0 ? "color:red" : "color:black")},[_vm._v("05. A veces se me ha dicho que soy una persona presumida, altanera o egoísta")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg005),expression:"eval_cpf.pg005"}],attrs:{"value":"a","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg005,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg005", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg005),expression:"eval_cpf.pg005"}],attrs:{"value":"b","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg005,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg005", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Rara vez")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg005),expression:"eval_cpf.pg005"}],attrs:{"value":"c","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg005,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg005", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Nunca")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg006===0 ? "color:red" : "color:black")},[_vm._v("06. Podría tolerar la vida de un ermitaño")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg006),expression:"eval_cpf.pg006"}],attrs:{"value":"a","name":"group6","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg006,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg006", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg006),expression:"eval_cpf.pg006"}],attrs:{"value":"b","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg006,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg006", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Talvez")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg006),expression:"eval_cpf.pg006"}],attrs:{"value":"c","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg006,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg006", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg007===0 ? "color:red" : "color:black")},[_vm._v("07. Aprendí más en el colegio")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg007),expression:"eval_cpf.pg007"}],attrs:{"value":"a","name":"group7","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg007,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg007", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Asistiendo a clases")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg007),expression:"eval_cpf.pg007"}],attrs:{"value":"b","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg007,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg007", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg007),expression:"eval_cpf.pg007"}],attrs:{"value":"c","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg007,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg007", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Leyendo textos")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg008===0 ? "color:red" : "color:black")},[_vm._v("08. Me es dificil confesar que estoy equivocado ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg008),expression:"eval_cpf.pg008"}],attrs:{"value":"a","name":"group8","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg008,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg008", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg008),expression:"eval_cpf.pg008"}],attrs:{"value":"b","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg008,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg008", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg008),expression:"eval_cpf.pg008"}],attrs:{"value":"c","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg008,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg008", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg009===0 ? "color:red" : "color:black")},[_vm._v("09. Yo gozaría más una noche")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg009),expression:"eval_cpf.pg009"}],attrs:{"value":"a","name":"group9","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg009,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg009", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Con alguna afición propiamente mía;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg009),expression:"eval_cpf.pg009"}],attrs:{"value":"b","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg009,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg009", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg009),expression:"eval_cpf.pg009"}],attrs:{"value":"c","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg009,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg009", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) En una fiesta animada")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg010===0 ? "color:red" : "color:black")},[_vm._v("10. Me parece más importante")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg010),expression:"eval_cpf.pg010"}],attrs:{"value":"a","name":"group10","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg010,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg010", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Que se mantenga un ejercito nacional fuerte; ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg010),expression:"eval_cpf.pg010"}],attrs:{"value":"b","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg010,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg010", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg010),expression:"eval_cpf.pg010"}],attrs:{"value":"c","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg010,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg010", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Fomentar la fraternidad internacional")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg011===0 ? "color:red" : "color:black")},[_vm._v("11. La mayoría de la gente reacciona desfavorablemente al ver que me acerco ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg011),expression:"eval_cpf.pg011"}],attrs:{"value":"a","name":"group11","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg011,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg011", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg011),expression:"eval_cpf.pg011"}],attrs:{"value":"b","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg011,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg011", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg011),expression:"eval_cpf.pg011"}],attrs:{"value":"c","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg011,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg011", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Nunca")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg012===0 ? "color:red" : "color:black")},[_vm._v("12. Dentro de una fábrica, preferiría ser:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg012),expression:"eval_cpf.pg012"}],attrs:{"value":"a","name":"group12","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg012,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg012", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) encargado de algún trabajo mecánico")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg012),expression:"eval_cpf.pg012"}],attrs:{"value":"b","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg012,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg012", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg012),expression:"eval_cpf.pg012"}],attrs:{"value":"c","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg012,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg012", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Especialista en la entrevisa y contratación de personal")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg013===0 ? "color:red" : "color:black")},[_vm._v("13.  He tenido varios desacuerdos con personas asociadas en el trabajo")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg013),expression:"eval_cpf.pg013"}],attrs:{"value":"a","name":"group13","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg013,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg013", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg013),expression:"eval_cpf.pg013"}],attrs:{"value":"b","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg013,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg013", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Muy poco")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg013),expression:"eval_cpf.pg013"}],attrs:{"value":"c","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg013,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg013", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No, ninguno")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg014===0 ? "color:red" : "color:black")},[_vm._v("14. Me parece cruel vacunar a los niños pequeños, y los padres deberían tener el derecho de posponer la vacuna")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg014),expression:"eval_cpf.pg014"}],attrs:{"value":"a","name":"group14","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg014,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg014", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg014),expression:"eval_cpf.pg014"}],attrs:{"value":"b","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg014,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg014", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Talvez")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg014),expression:"eval_cpf.pg014"}],attrs:{"value":"c","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg014,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg014", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg015===0 ? "color:red" : "color:black")},[_vm._v("15. Tengo pasión por viajar ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg015),expression:"eval_cpf.pg015"}],attrs:{"value":"a","name":"group15","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg015,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg015", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg015),expression:"eval_cpf.pg015"}],attrs:{"value":"b","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg015,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg015", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg015),expression:"eval_cpf.pg015"}],attrs:{"value":"c","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg015,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg015", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg016===0 ? "color:red" : "color:black")},[_vm._v("16. Tiendo a sentirme deprimido si mis opinios resultan distintas a la de mis compañeros ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg016),expression:"eval_cpf.pg016"}],attrs:{"value":"a","name":"group16","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg016,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg016", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg016),expression:"eval_cpf.pg016"}],attrs:{"value":"b","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg016,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg016", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg016),expression:"eval_cpf.pg016"}],attrs:{"value":"c","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg016,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg016", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg017===0 ? "color:red" : "color:black")},[_vm._v("17. Me sentiría fuera de lugar en un campo nudista")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg017),expression:"eval_cpf.pg017"}],attrs:{"value":"a","name":"group17","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg017,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg017", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg017),expression:"eval_cpf.pg017"}],attrs:{"value":"b","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg017,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg017", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Probablemente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg017),expression:"eval_cpf.pg017"}],attrs:{"value":"c","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg017,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg017", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg018===0 ? "color:red" : "color:black")},[_vm._v("18. Tomo un papel muy activo en asuntos sociales")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg018),expression:"eval_cpf.pg018"}],attrs:{"value":"a","name":"group18","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg018,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg018", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg018),expression:"eval_cpf.pg018"}],attrs:{"value":"b","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg018,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg018", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg018),expression:"eval_cpf.pg018"}],attrs:{"value":"c","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg018,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg018", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg019===0 ? "color:red" : "color:black")},[_vm._v("19. Siempre que emprendo un nuevo trabajo, no siento cansancio")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg019),expression:"eval_cpf.pg019"}],attrs:{"value":"a","name":"group19","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg019,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg019", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí, nunca")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg019),expression:"eval_cpf.pg019"}],attrs:{"value":"b","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg019,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg019", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Rara vez")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg019),expression:"eval_cpf.pg019"}],attrs:{"value":"c","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg019,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg019", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No es verdad")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg020===0 ? "color:red" : "color:black")},[_vm._v("20. Preferiría tener una esposa/o capaz de: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg020),expression:"eval_cpf.pg020"}],attrs:{"value":"a","name":"group20","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg020,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg020", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) impresionar a la gente y ejercer una pronunciada influencia social; ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg020),expression:"eval_cpf.pg020"}],attrs:{"value":"b","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg020,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg020", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg020),expression:"eval_cpf.pg020"}],attrs:{"value":"c","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg020,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg020", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Convivir intelectualmente en forme interesante")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt5"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg021===0 ? "color:red" : "color:black")},[_vm._v("21. Me causa dificultad, juntar mis pensamientos, sentarme a escribir una carta, trabajar con un problema, etc.")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg021),expression:"eval_cpf.pg021"}],attrs:{"value":"a","name":"group21","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg021,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg021", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg021),expression:"eval_cpf.pg021"}],attrs:{"value":"b","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg021,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg021", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No a menudo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg021),expression:"eval_cpf.pg021"}],attrs:{"value":"c","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg021,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg021", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg022===0 ? "color:red" : "color:black")},[_vm._v("22. Puedo mentirle a un amigo sin cambiar de expresión")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg022),expression:"eval_cpf.pg022"}],attrs:{"value":"a","name":"group22","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg022,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg022", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg022),expression:"eval_cpf.pg022"}],attrs:{"value":"b","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg022,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg022", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg022),expression:"eval_cpf.pg022"}],attrs:{"value":"c","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg022,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg022", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg023===0 ? "color:red" : "color:black")},[_vm._v("23. Me preocupo por saber si siempre tendré suficiente dinero para vivir")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg023),expression:"eval_cpf.pg023"}],attrs:{"value":"a","name":"group23","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg023,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg023", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg023),expression:"eval_cpf.pg023"}],attrs:{"value":"b","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg023,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg023", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Rara vez")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg023),expression:"eval_cpf.pg023"}],attrs:{"value":"c","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg023,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg023", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg024===0 ? "color:red" : "color:black")},[_vm._v("24. Creo que la sociedad debería dar mas atención al pensamiento científico sobre sus problemas ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg024),expression:"eval_cpf.pg024"}],attrs:{"value":"a","name":"group24","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg024,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg024", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg024),expression:"eval_cpf.pg024"}],attrs:{"value":"b","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg024,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg024", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg024),expression:"eval_cpf.pg024"}],attrs:{"value":"c","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg024,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg024", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg025===0 ? "color:red" : "color:black")},[_vm._v("25. Paso mucho tiempo en pensar o platicar de acontecimientos sociales pasados que me han divertido ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg025),expression:"eval_cpf.pg025"}],attrs:{"value":"a","name":"group25","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg025,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg025", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg025),expression:"eval_cpf.pg025"}],attrs:{"value":"b","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg025,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg025", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Algo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg025),expression:"eval_cpf.pg025"}],attrs:{"value":"c","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg025,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg025", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg026===0 ? "color:red" : "color:black")},[_vm._v("26. Hay veces que la ira no me permite hablar ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg026),expression:"eval_cpf.pg026"}],attrs:{"value":"a","name":"group26","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg026,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg026", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg026),expression:"eval_cpf.pg026"}],attrs:{"value":"b","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg026,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg026", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A menudo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg026),expression:"eval_cpf.pg026"}],attrs:{"value":"c","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg026,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg026", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) A veces")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg027===0 ? "color:red" : "color:black")},[_vm._v("27. Me importa lo que la gente piensa de mi ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg027),expression:"eval_cpf.pg027"}],attrs:{"value":"a","name":"group27","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg027,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg027", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg027),expression:"eval_cpf.pg027"}],attrs:{"value":"b","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg027,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg027", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Quizá")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg027),expression:"eval_cpf.pg027"}],attrs:{"value":"c","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg027,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg027", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg028===0 ? "color:red" : "color:black")},[_vm._v("28. Nunca me dedico a los chismes acerca de mis compañeros de trabajo ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg028),expression:"eval_cpf.pg028"}],attrs:{"value":"a","name":"group28","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg028,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg028", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí, nunca")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg028),expression:"eval_cpf.pg028"}],attrs:{"value":"b","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg028,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg028", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg028),expression:"eval_cpf.pg028"}],attrs:{"value":"c","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg028,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg028", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No es verdad")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg029===0 ? "color:red" : "color:black")},[_vm._v("29. Trato de no hacer cosas que me podrían hacer parecer extraño")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg029),expression:"eval_cpf.pg029"}],attrs:{"value":"a","name":"group29","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg029,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg029", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg029),expression:"eval_cpf.pg029"}],attrs:{"value":"b","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg029,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg029", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg029),expression:"eval_cpf.pg029"}],attrs:{"value":"c","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg029,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg029", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg030===0 ? "color:red" : "color:black")},[_vm._v("30. Si alguna persona se porta de manera dictatorial y altanera, yo:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg030),expression:"eval_cpf.pg030"}],attrs:{"value":"a","name":"group30","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg030,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg030", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Simplemente evito tratar con él; ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg030),expression:"eval_cpf.pg030"}],attrs:{"value":"b","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg030,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg030", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Cualquiera")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg030),expression:"eval_cpf.pg030"}],attrs:{"value":"c","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg030,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg030", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Busco oportunidad \"entenderme con él\"")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg031===0 ? "color:red" : "color:black")},[_vm._v("31. En mi opinión el divorcio debería ser más fácil ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg031),expression:"eval_cpf.pg031"}],attrs:{"value":"a","name":"group31","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg031,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg031", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg031),expression:"eval_cpf.pg031"}],attrs:{"value":"b","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg031,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg031", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Quizá")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg031),expression:"eval_cpf.pg031"}],attrs:{"value":"c","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg031,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg031", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg032===0 ? "color:red" : "color:black")},[_vm._v("32. Como afición preferiría asociarme con:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg032),expression:"eval_cpf.pg032"}],attrs:{"value":"a","name":"group32","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg032,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg032", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Un club fotográfico; ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg032),expression:"eval_cpf.pg032"}],attrs:{"value":"b","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg032,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg032", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg032),expression:"eval_cpf.pg032"}],attrs:{"value":"c","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg032,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg032", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Una sociedad de debates")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg033===0 ? "color:red" : "color:black")},[_vm._v("33. Me interesan los problemas sociales de hoy en día ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg033),expression:"eval_cpf.pg033"}],attrs:{"value":"a","name":"group33","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg033,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg033", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg033),expression:"eval_cpf.pg033"}],attrs:{"value":"b","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg033,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg033", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Algo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg033),expression:"eval_cpf.pg033"}],attrs:{"value":"c","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg033,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg033", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg034===0 ? "color:red" : "color:black")},[_vm._v("34. Me da gusto encontrarme en reuniones verdaderamente grante, como en las fiestas o en los bailes ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg034),expression:"eval_cpf.pg034"}],attrs:{"value":"a","name":"group34","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg034,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg034", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg034),expression:"eval_cpf.pg034"}],attrs:{"value":"b","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg034,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg034", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ocasionalmente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg034),expression:"eval_cpf.pg034"}],attrs:{"value":"c","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg034,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg034", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg035===0 ? "color:red" : "color:black")},[_vm._v("35. Si yo buscara informarme acerca de un problema social en particular, leería: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg035),expression:"eval_cpf.pg035"}],attrs:{"value":"a","name":"group35","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg035,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg035", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Una novela reciente sobre el tema;")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg035),expression:"eval_cpf.pg035"}],attrs:{"value":"b","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg035,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg035", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg035),expression:"eval_cpf.pg035"}],attrs:{"value":"c","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg035,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg035", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Algún texto que dé datos estadísticos ")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg036===0 ? "color:red" : "color:black")},[_vm._v("36. Tiendo a ser lento en expresar mis ideas en palabras. ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg036),expression:"eval_cpf.pg036"}],attrs:{"value":"a","name":"group36","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg036,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg036", "a")}}}),_vm._v(" "),_c('span',[_vm._v("a) Siempre")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg036),expression:"eval_cpf.pg036"}],attrs:{"value":"b","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg036,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg036", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A veces")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg036),expression:"eval_cpf.pg036"}],attrs:{"value":"c","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg036,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg036", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Rara vez")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg037===0 ? "color:red" : "color:black")},[_vm._v("37. Quizá mi aspecto personal influya en mi contra en algunos tipos de trabajo ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg037),expression:"eval_cpf.pg037"}],attrs:{"value":"a","name":"group37","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg037,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg037", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg037),expression:"eval_cpf.pg037"}],attrs:{"value":"b","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg037,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg037", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg037),expression:"eval_cpf.pg037"}],attrs:{"value":"c","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg037,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg037", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg038===0 ? "color:red" : "color:black")},[_vm._v("38. Soy partidario de la censura de películas y de las revistas ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg038),expression:"eval_cpf.pg038"}],attrs:{"value":"a","name":"group38","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg038,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg038", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg038),expression:"eval_cpf.pg038"}],attrs:{"value":"b","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg038,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg038", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) En parte")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg038),expression:"eval_cpf.pg038"}],attrs:{"value":"c","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg038,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg038", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg039===0 ? "color:red" : "color:black")},[_vm._v("39. Tengo buena memoria para acordarme de las personas")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg039),expression:"eval_cpf.pg039"}],attrs:{"value":"a","name":"group39","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg039,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg039", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg039),expression:"eval_cpf.pg039"}],attrs:{"value":"b","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg039,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg039", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Medio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg039),expression:"eval_cpf.pg039"}],attrs:{"value":"c","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg039,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg039", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_cpf.pg040===0 ? "color:red" : "color:black")},[_vm._v("40. Me gustaría ser: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg040),expression:"eval_cpf.pg040"}],attrs:{"value":"a","name":"group40","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_cpf.pg040,"a")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg040", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Profesor")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg040),expression:"eval_cpf.pg040"}],attrs:{"value":"b","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg040,"b")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg040", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_cpf.pg040),expression:"eval_cpf.pg040"}],attrs:{"value":"c","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_cpf.pg040,"c")},on:{"change":function($event){_vm.$set(_vm.eval_cpf, "pg040", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Guardia forestal")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grabado===false),expression:"grabado===false"}],staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn tooltipped",attrs:{"data-position":"left","data-tooltip":"Grabar"},on:{"click":function($event){_vm.agregarEvaluacion()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("SELECCIONE EL SIGUIENTE BOTON PARA EMPEZAR LA EVALUACION.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev05_fig_js__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed9e3662_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev05_fig_vue__ = __webpack_require__(329);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev05_fig_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed9e3662_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev05_fig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s2"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Departamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.depto),expression:"eval_fig.depto"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_fig.depto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_fig, "depto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.empresa),expression:"eval_fig.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_fig.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_fig, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.nombre),expression:"eval_fig.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_fig.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_fig, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Sexo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.sexo),expression:"eval_fig.sexo"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_fig.sexo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_fig, "sexo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_fig.empezo))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finalizoeval),expression:"finalizoeval"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_fig.termino))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para LEER u OCULTAR las instrucciones.","data-position":"top"}},[_vm._v("\n                            "+_vm._s(_vm.instrucciones)+"\n                        ")])]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12"},[_c('div',{staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("Empezar Evaluación de PERFIL DE PERSONALIDAD")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s12"},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt4"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("Preguntas 01 - 12")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt5"},on:{"click":function($event){_vm.nadaG1(2)}}},[_vm._v("Preguntas 13 - 24")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt3",class:_vm.activott3,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt3","href":"#testt6"},on:{"click":function($event){_vm.nadaG1(3)}}},[_vm._v("Preguntas 25 - 36")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt4",class:_vm.activott4,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt4","href":"#testt7"},on:{"click":function($event){_vm.nadaG1(4)}}},[_vm._v("Preguntas 37 - 48")])])]),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.pregSinContestar>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_sinResponder))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt4"}},[_c('div',{staticClass:"input-field col s12"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"left","title":"Digno de ser amado, afable, complaciente, afectuoso."}},[_vm._v("\n                                    Amable    :\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg001),expression:"eval_fig.pg001"}],attrs:{"value":"S","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg001,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg001", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg002),expression:"eval_fig.pg002"}],attrs:{"value":"S","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg002,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg002", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Inducir, mover, obligar a uno con razones a creer o hacer una cosa."}},[_vm._v("\n                                    Persuasivo:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg001),expression:"eval_fig.pg001"}],attrs:{"value":"I","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg001,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg001", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg002),expression:"eval_fig.pg002"}],attrs:{"value":"N","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg002,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg002", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Ausencia completa de orgullo, sumisión, condición inferior."}},[_vm._v("\n                                    Humilde   :\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg001),expression:"eval_fig.pg001"}],attrs:{"value":"C","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg001,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg001", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg002),expression:"eval_fig.pg002"}],attrs:{"value":"C","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg002,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg002", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona diferente, extraño contrario a lo acostumbrado."}},[_vm._v("\n                                    Original  :\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg001),expression:"eval_fig.pg001"}],attrs:{"value":"N","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg001,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg001", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg002),expression:"eval_fig.pg002"}],attrs:{"value":"D","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg002,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg002", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que atrae. Cualidad física o moral que atrae la simpatía, al amor o el afecto de otros."}},[_vm._v("\n                                    Atractivo\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg003),expression:"eval_fig.pg003"}],attrs:{"value":"I","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg003,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg003", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg004),expression:"eval_fig.pg004"}],attrs:{"value":"I","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg004,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg004", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Tímido, indeciso."}},[_vm._v("\n                                    Timorato:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg003),expression:"eval_fig.pg003"}],attrs:{"value":"C","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg003,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg003", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg004),expression:"eval_fig.pg004"}],attrs:{"value":"C","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg004,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg004", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Terquedad, persona necia."}},[_vm._v("\n                                    Obstinado:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg003),expression:"eval_fig.pg003"}],attrs:{"value":"D","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg003,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg003", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg004),expression:"eval_fig.pg004"}],attrs:{"value":"D","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg004,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg004", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Grato, gustoso y apacible. Naturalmente afable, complaciente dócil."}},[_vm._v("\n                                    Dulce:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg003),expression:"eval_fig.pg003"}],attrs:{"value":"N","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg003,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg003", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg004),expression:"eval_fig.pg004"}],attrs:{"value":"S","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg004,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg004", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona que tiene autoridad y conocimiento, ejerce predominio de algo a alguien."}},[_vm._v("\n                                    Muy influenciable:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg005),expression:"eval_fig.pg005"}],attrs:{"value":"N","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg005,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg005", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg006),expression:"eval_fig.pg006"}],attrs:{"value":"C","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg006,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg006", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"De aspecto deleitable, o capaz, por alguna circunstancia, de infundir gozo o alegría."}},[_vm._v("\n                                    Risueño:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg005),expression:"eval_fig.pg005"}],attrs:{"value":"D","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg005,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg005", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg006),expression:"eval_fig.pg006"}],attrs:{"value":"D","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg006,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg006", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que es incapaz de traicionar o engañar, que no abandona nunca a alguien."}},[_vm._v("\n                                    Leal:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg005),expression:"eval_fig.pg005"}],attrs:{"value":"S","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg005,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg005", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg006),expression:"eval_fig.pg006"}],attrs:{"value":"N","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg006,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg006", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Cautivar la atención con la hermosura o talento."}},[_vm._v("\n                                    Encantador:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg005),expression:"eval_fig.pg005"}],attrs:{"value":"I","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg005,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg005", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg006),expression:"eval_fig.pg006"}],attrs:{"value":"I","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg006,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg006", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Cualidad consistente en no sacrificar a consideraciones personales. Objetividad."}},[_vm._v("\n                                    Imparcial:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg007),expression:"eval_fig.pg007"}],attrs:{"value":"I","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg007,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg007", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg008),expression:"eval_fig.pg008"}],attrs:{"value":"N","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg008,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg008", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Digno de ser amado, afable, complaciente, afectuoso."}},[_vm._v("\n                                    Complaciente:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg007),expression:"eval_fig.pg007"}],attrs:{"value":"C","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg007,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg007", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg008),expression:"eval_fig.pg008"}],attrs:{"value":"C","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg008,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg008", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona atrevida, emprendedora."}},[_vm._v("\n                                    Determinado:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg007),expression:"eval_fig.pg007"}],attrs:{"value":"N","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg007,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg007", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg008),expression:"eval_fig.pg008"}],attrs:{"value":"D","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg008,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg008", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Buena disposición de ánimo, alegre.","required":""}},[_vm._v("\n                                    De buen humor:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg007),expression:"eval_fig.pg007"}],attrs:{"value":"S","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg007,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg007", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg008),expression:"eval_fig.pg008"}],attrs:{"value":"S","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg008,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg008", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Alegre, festivo, apacible.","required":""}},[_vm._v("\n                                    Jovial:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg009),expression:"eval_fig.pg009"}],attrs:{"value":"N","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg009,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg009", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg010),expression:"eval_fig.pg010"}],attrs:{"value":"I","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg010,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg010", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Necesario, indispensable, puntual, fijo, exacto, cierto, determinado.","required":""}},[_vm._v("\n                                    Preciso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg009),expression:"eval_fig.pg009"}],attrs:{"value":"C","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg009,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg009", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg010),expression:"eval_fig.pg010"}],attrs:{"value":"C","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg010,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg010", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona cuyo nervios se excitan fácilmente.","required":""}},[_vm._v("\n                                    Nervioso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg009),expression:"eval_fig.pg009"}],attrs:{"value":"N+","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg009,"N+")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg009", "N+")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg010),expression:"eval_fig.pg010"}],attrs:{"value":"D","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg010,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg010", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que tiene igualdad y constancia de ánimo. Imparcialidad de Juicio","required":""}},[_vm._v("\n                                    Ecuanime:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg009),expression:"eval_fig.pg009"}],attrs:{"value":"S","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg009,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg009", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg010),expression:"eval_fig.pg010"}],attrs:{"value":"S","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg010,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg010", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona que le gusta competir entre dos o más personas aspirando a una misma cosa.","required":""}},[_vm._v("\n                                    Competidor:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg011),expression:"eval_fig.pg011"}],attrs:{"value":"D","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg011,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg011", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg012),expression:"eval_fig.pg012"}],attrs:{"value":"D","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg012,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg012", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que recibe de los demás muestras de atención y respeto.","required":""}},[_vm._v("\n                                    Considerado:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg011),expression:"eval_fig.pg011"}],attrs:{"value":"S","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg011,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg011", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg012),expression:"eval_fig.pg012"}],attrs:{"value":"S","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg012,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg012", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Alegre, festivo y de buen humor.","required":""}},[_vm._v("\n                                    Divertido:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg011),expression:"eval_fig.pg011"}],attrs:{"value":"N","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg011,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg011", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg012),expression:"eval_fig.pg012"}],attrs:{"value":"I","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg012,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg012", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Alegre, festivo y de buen humor.","required":""}},[_vm._v("\n                                    Armonioso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg011),expression:"eval_fig.pg011"}],attrs:{"value":"N+","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg011,"N+")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg011", "N+")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg012),expression:"eval_fig.pg012"}],attrs:{"value":"C","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg012,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg012", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(7)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt5"}},[_c('div',{staticClass:"input-field col s12"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Pedir una cosa, requisito necesario para que se haga. Mandato.","required":""}},[_vm._v("\n                                    Exigente:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg013),expression:"eval_fig.pg013"}],attrs:{"value":"N","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg013,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg013", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg014),expression:"eval_fig.pg014"}],attrs:{"value":"C","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg014,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg014", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Acción de obedecer. Precepto del superior, especialmente en las órdenes regulares.","required":""}},[_vm._v("\n                                    Obediente:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg013),expression:"eval_fig.pg013"}],attrs:{"value":"S","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg013,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg013", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg014),expression:"eval_fig.pg014"}],attrs:{"value":"N","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg014,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg014", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Imposible de educar.","required":""}},[_vm._v("\n                                    Indomable:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg013),expression:"eval_fig.pg013"}],attrs:{"value":"D","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg013,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg013", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg014),expression:"eval_fig.pg014"}],attrs:{"value":"D","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg014,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg014", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Aficionado a jugar.","required":""}},[_vm._v("\n                                    Juguetón:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg013),expression:"eval_fig.pg013"}],attrs:{"value":"I","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg013,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg013", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg014),expression:"eval_fig.pg014"}],attrs:{"value":"I","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg014,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg014", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona fuerte, sin temor, robusta eficaz y activa. Excelente.","required":""}},[_vm._v("\n                                    Valiente:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg015),expression:"eval_fig.pg015"}],attrs:{"value":"D","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg015,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg015", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg016),expression:"eval_fig.pg016"}],attrs:{"value":"N","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg016,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg016", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Influir en el ánimo afecto, ideas designios. Que inspira.","required":""}},[_vm._v("\n                                    Inspirador:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg015),expression:"eval_fig.pg015"}],attrs:{"value":"I","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg015,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg015", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg016),expression:"eval_fig.pg016"}],attrs:{"value":"N+","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg016,"N+")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg016", "N+")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Obediente, subordinado, rendido, sometido.","required":""}},[_vm._v("\n                                    Sumiso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg015),expression:"eval_fig.pg015"}],attrs:{"value":"N","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg015,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg015", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg016),expression:"eval_fig.pg016"}],attrs:{"value":"S","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg016,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg016", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Temeroso, medroso, encogido y corto de ánimo","required":""}},[_vm._v("\n                                    Tímido:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg015),expression:"eval_fig.pg015"}],attrs:{"value":"N+","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg015,"N+")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg015", "N+")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg016),expression:"eval_fig.pg016"}],attrs:{"value":"C","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg016,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg016", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Naturalmente inclinado al trato con otras personas. Que es de trato fácil o agradable.","required":""}},[_vm._v("\n                                    Sociable:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg017),expression:"eval_fig.pg017"}],attrs:{"value":"I","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg017,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg017", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg018),expression:"eval_fig.pg018"}],attrs:{"value":"I","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg018,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg018", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que sufre y tolera los trabajos y adversidades, sin perturbaciones de ánimo.","required":""}},[_vm._v("\n                                    Paciente:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg017),expression:"eval_fig.pg017"}],attrs:{"value":"S","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg017,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg017", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg018),expression:"eval_fig.pg018"}],attrs:{"value":"S","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg018,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg018", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Firme que no está en peligro de faltar o caerse. Confianza en sí.","required":""}},[_vm._v("\n                                    Seguro de sí:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg017),expression:"eval_fig.pg017"}],attrs:{"value":"D","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg017,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg017", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg018),expression:"eval_fig.pg018"}],attrs:{"value":"D","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg018,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg018", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que habla callado.","required":""}},[_vm._v("\n                                    De voz suave:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg017),expression:"eval_fig.pg017"}],attrs:{"value":"C","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg017,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg017", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg018),expression:"eval_fig.pg018"}],attrs:{"value":"N","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg018,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg018", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que busca aventura, arriesgarse y peligro.","required":""}},[_vm._v("\n                                    Aventurero:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg019),expression:"eval_fig.pg019"}],attrs:{"value":"D","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg019,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg019", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg020),expression:"eval_fig.pg020"}],attrs:{"value":"D","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg020,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg020", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Capacidad de recibir con facilidad un mensaje.","required":""}},[_vm._v("\n                                    Receptivo:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg019),expression:"eval_fig.pg019"}],attrs:{"value":"C","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg019,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg019", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg020),expression:"eval_fig.pg020"}],attrs:{"value":"N","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg020,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg020", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que tiene virtud para fortalecer el corazón.","required":""}},[_vm._v("\n                                    Cordial:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg019),expression:"eval_fig.pg019"}],attrs:{"value":"N","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg019,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg019", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg020),expression:"eval_fig.pg020"}],attrs:{"value":"I","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg020,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg020", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que guarda el medio entre los extremos.","required":""}},[_vm._v("\n                                    Moderado:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg019),expression:"eval_fig.pg019"}],attrs:{"value":"S","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg019,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg019", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg020),expression:"eval_fig.pg020"}],attrs:{"value":"S","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg020,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg020", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona que se comunica constantemente. Dar a entender algo a través del lenguaje hablado.","required":""}},[_vm._v("\n                                    Hablador:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg021),expression:"eval_fig.pg021"}],attrs:{"value":"I","name":"group41","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg021,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg021", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg022),expression:"eval_fig.pg022"}],attrs:{"value":"I","name":"group41","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg022,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg022", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Fuerza que moldea la vida del sujeto en el sentido de completamiento o perfección.","required":""}},[_vm._v("\n                                    Dominio sobre sí:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg021),expression:"eval_fig.pg021"}],attrs:{"value":"S","name":"group42","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg021,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg021", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg022),expression:"eval_fig.pg022"}],attrs:{"value":"S","name":"group42","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg022,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg022", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Convenido o pacto. Que resulta o se establece en virtud de precedentes o de costumbre.","required":""}},[_vm._v("\n                                    Convencional:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg021),expression:"eval_fig.pg021"}],attrs:{"value":"N","name":"group43","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg021,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg021", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg022),expression:"eval_fig.pg022"}],attrs:{"value":"C","name":"group43","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg022,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg022", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Firmeza de carácter, demandar imperiosamente.","required":""}},[_vm._v("\n                                    Decisivo:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg021),expression:"eval_fig.pg021"}],attrs:{"value":"D","name":"group44","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg021,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg021", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg022),expression:"eval_fig.pg022"}],attrs:{"value":"D","name":"group44","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg022,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg022", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Fino de modales.","required":""}},[_vm._v("\n                                    Refinado:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg023),expression:"eval_fig.pg023"}],attrs:{"value":"N","name":"group45","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg023,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg023", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg024),expression:"eval_fig.pg024"}],attrs:{"value":"I","name":"group45","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg024,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg024", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Determinarse a algo, arriesgado.","required":""}},[_vm._v("\n                                    Atrevido:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg023),expression:"eval_fig.pg023"}],attrs:{"value":"D","name":"group46","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg023,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg023", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg024),expression:"eval_fig.pg024"}],attrs:{"value":"D","name":"group46","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg024,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg024", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"persona que actúa con disimulo, astucia.","required":""}},[_vm._v("\n                                    Diplomático:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg023),expression:"eval_fig.pg023"}],attrs:{"value":"C","name":"group47","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg023,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg023", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg024),expression:"eval_fig.pg024"}],attrs:{"value":"N","name":"group47","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg024,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg024", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Crédulo, imprevisor, presumido, satisfecho de sí mismo.","required":""}},[_vm._v("\n                                    Satisfecho:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg023),expression:"eval_fig.pg023"}],attrs:{"value":"S","name":"group48","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg023,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg023", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg024),expression:"eval_fig.pg024"}],attrs:{"value":"S","name":"group48","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg024,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg024", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(1)}}},[_vm._m(14)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(3)}}},[_vm._m(15)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt3),expression:"vertt3"}],ref:"testt3",attrs:{"id":"testt6"}},[_c('div',{staticClass:"input-field col s12"},[_vm._m(16),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Propenso a atacar verbal o físicamente a los demás.","required":""}},[_vm._v("\n                                    Agresivo:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg025),expression:"eval_fig.pg025"}],attrs:{"value":"D","name":"group49","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg025,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg025", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg026),expression:"eval_fig.pg026"}],attrs:{"value":"N","name":"group49","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg026,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg026", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona alegre, animada. Centro de atención.","required":""}},[_vm._v("\n                                    Alma de fiesta:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg025),expression:"eval_fig.pg025"}],attrs:{"value":"I","name":"group50","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg025,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg025", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg026),expression:"eval_fig.pg026"}],attrs:{"value":"I","name":"group50","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg026,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg026", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que cree ligera o fácilmente.","required":""}},[_vm._v("\n                                    Crédulo:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg025),expression:"eval_fig.pg025"}],attrs:{"value":"S","name":"group51","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg025,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg025", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg026),expression:"eval_fig.pg026"}],attrs:{"value":"S","name":"group51","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg026,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg026", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que de cualquier cosa tiene miedo.","required":""}},[_vm._v("\n                                    Miedoso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg025),expression:"eval_fig.pg025"}],attrs:{"value":"N","name":"group52","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg025,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg025", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg026),expression:"eval_fig.pg026"}],attrs:{"value":"C","name":"group52","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg026,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg026", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(17),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Precaución y reserva con que se procede. Astucia maña y sutileza para engañar.","required":""}},[_vm._v("\n                                    Cauteloso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg027),expression:"eval_fig.pg027"}],attrs:{"value":"C","name":"group53","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg027,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg027", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg028),expression:"eval_fig.pg028"}],attrs:{"value":"C","name":"group53","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg028,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg028", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Audaz, arrojado, decidido, pronto diligente.","required":""}},[_vm._v("\n                                    Resuelto:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg027),expression:"eval_fig.pg027"}],attrs:{"value":"D","name":"group54","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg027,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg027", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg028),expression:"eval_fig.pg028"}],attrs:{"value":"N","name":"group54","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg028,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg028", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Capacidad para convencer. Precisar a uno con razones eficaces a que mude de decisiones o abandonarlas.","required":""}},[_vm._v("\n                                    Convincente:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg027),expression:"eval_fig.pg027"}],attrs:{"value":"I","name":"group55","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg027,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg027", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg028),expression:"eval_fig.pg028"}],attrs:{"value":"I","name":"group55","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg028,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg028", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Agradable, suave en la conversación y el trato.","required":""}},[_vm._v("\n                                    Afable:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg027),expression:"eval_fig.pg027"}],attrs:{"value":"S","name":"group56","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg027,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg027", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg028),expression:"eval_fig.pg028"}],attrs:{"value":"N+","name":"group56","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg028,"N+")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg028", "N+")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(18),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"De disponer, gallardo; apuesto. Hábil despejado.","required":""}},[_vm._v("\n                                    Dispuesto:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg029),expression:"eval_fig.pg029"}],attrs:{"value":"S","name":"group57","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg029,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg029", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg030),expression:"eval_fig.pg030"}],attrs:{"value":"N","name":"group57","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg030,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg030", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Inquieto, persona en desasosiego, en espera de algo. Asociado al miedo.","required":""}},[_vm._v("\n                                    Ansioso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg029),expression:"eval_fig.pg029"}],attrs:{"value":"D","name":"group58","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg029,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg029", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg030),expression:"eval_fig.pg030"}],attrs:{"value":"D","name":"group58","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg030,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg030", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Modo agradable de tratar a las personas, voluntad, complacencia, gusto.","required":""}},[_vm._v("\n                                    Agradable:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg029),expression:"eval_fig.pg029"}],attrs:{"value":"C","name":"group59","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg029,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg029", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg030),expression:"eval_fig.pg030"}],attrs:{"value":"C","name":"group59","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg030,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg030", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona con valor, esfuerzo y energía. Tensión, voluntad. ","required":""}},[_vm._v("\n                                    Animoso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg029),expression:"eval_fig.pg029"}],attrs:{"value":"N","name":"group60","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg029,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg029", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg030),expression:"eval_fig.pg030"}],attrs:{"value":"I","name":"group60","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg030,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg030", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(19),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",staticStyle:{"font-size":"12px"},attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona llena de ánimo, aliento y vigor para obrar.","required":""}},[_vm._v("\n                                    LLeno de confianza:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg031),expression:"eval_fig.pg031"}],attrs:{"value":"I","name":"group61","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg031,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg031", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg032),expression:"eval_fig.pg032"}],attrs:{"value":"N","name":"group61","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg032,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg032", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Sentimiento de conmiseración y lástima que se tiene hacia quienes sufren penalidades o desgracias.","required":""}},[_vm._v("\n                                    Compasivo:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg031),expression:"eval_fig.pg031"}],attrs:{"value":"N","name":"group62","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg031,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg031", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg032),expression:"eval_fig.pg032"}],attrs:{"value":"S","name":"group62","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg032,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg032", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Sufrir, llevar con paciencia. Permitir algo que no se tiene por lícito sin aprobarlo expresamente. Soportar llevar Aguantar.","required":""}},[_vm._v("\n                                    Tolerante:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg031),expression:"eval_fig.pg031"}],attrs:{"value":"N+","name":"group63","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg031,"N+")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg031", "N+")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg032),expression:"eval_fig.pg032"}],attrs:{"value":"C","name":"group63","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg032,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg032", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Eficacia, poder, virtud para obrar. Fuerza de voluntad, vigor y tensión en la actividad.","required":""}},[_vm._v("\n                                    Energético:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg031),expression:"eval_fig.pg031"}],attrs:{"value":"D","name":"group64","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg031,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg031", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg032),expression:"eval_fig.pg032"}],attrs:{"value":"D","name":"group64","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg032,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg032", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(20),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que realiza una actividad con un orden estipulado.","required":""}},[_vm._v("\n                                    Disciplinado:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg033),expression:"eval_fig.pg033"}],attrs:{"value":"C","name":"group65","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg033,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg033", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg034),expression:"eval_fig.pg034"}],attrs:{"value":"N","name":"group65","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg034,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg034", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Desprendido, dadivoso, desinteresado.","required":""}},[_vm._v("\n                                    Generoso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg033),expression:"eval_fig.pg033"}],attrs:{"value":"S","name":"group66","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg033,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg033", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg034),expression:"eval_fig.pg034"}],attrs:{"value":"S","name":"group66","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg034,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg034", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Agudo de pronta acción e ingenio.","required":""}},[_vm._v("\n                                    Vivaz:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg033),expression:"eval_fig.pg033"}],attrs:{"value":"N","name":"group67","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg033,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg033", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg034),expression:"eval_fig.pg034"}],attrs:{"value":"I","name":"group67","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg034,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg034", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Insistencia, constancia en el intento o ejecución de una cosa.","required":""}},[_vm._v("\n                                    Persistente:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg033),expression:"eval_fig.pg033"}],attrs:{"value":"D","name":"group68","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg033,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg033", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg034),expression:"eval_fig.pg034"}],attrs:{"value":"D","name":"group68","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg034,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg034", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(21),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona que se admira por un talento o una actividad.","required":""}},[_vm._v("\n                                    Admirable:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg035),expression:"eval_fig.pg035"}],attrs:{"value":"I","name":"group69","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg035,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg035", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg036),expression:"eval_fig.pg036"}],attrs:{"value":"N","name":"group69","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg036,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg036", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Lleno de bondad y de carácter apacible.","required":""}},[_vm._v("\n                                    Bondadoso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg035),expression:"eval_fig.pg035"}],attrs:{"value":"S","name":"group70","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg035,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg035", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg036),expression:"eval_fig.pg036"}],attrs:{"value":"N+","name":"group70","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg036,"N+")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg036", "N+")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Entregar una autoridad. Entregar el mando a otra persona determinadas circunstancias. ","required":""}},[_vm._v("\n                                    Resignado:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg035),expression:"eval_fig.pg035"}],attrs:{"value":"N","name":"group71","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg035,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg035", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg036),expression:"eval_fig.pg036"}],attrs:{"value":"C","name":"group71","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg036,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg036", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que manda con autoridad.","required":""}},[_vm._v("\n                                    Imperioso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg035),expression:"eval_fig.pg035"}],attrs:{"value":"D","name":"group72","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg035,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg035", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg036),expression:"eval_fig.pg036"}],attrs:{"value":"D","name":"group72","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg036,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg036", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(2)}}},[_vm._m(22)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(4)}}},[_vm._m(23)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt4),expression:"vertt4"}],ref:"testt4",attrs:{"id":"testt7"}},[_c('div',{staticClass:"input-field col s12"},[_vm._m(24),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona que se acata a una situación.","required":""}},[_vm._v("\n                                    Respetuoso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg037),expression:"eval_fig.pg037"}],attrs:{"value":"C","name":"group73","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg037,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg037", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg038),expression:"eval_fig.pg038"}],attrs:{"value":"N","name":"group73","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg038,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg038", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona que da los primeros pasos en alguna actividad humana.","required":""}},[_vm._v("\n                                    Pionero:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg037),expression:"eval_fig.pg037"}],attrs:{"value":"D","name":"group74","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg037,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg037", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg038),expression:"eval_fig.pg038"}],attrs:{"value":"D","name":"group74","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg038,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg038", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Propensión a ver o juzgar las cosas en su aspecto más favorable.","required":""}},[_vm._v("\n                                    Optimista:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg037),expression:"eval_fig.pg037"}],attrs:{"value":"I","name":"group75","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg037,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg037", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg038),expression:"eval_fig.pg038"}],attrs:{"value":"I","name":"group75","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg038,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg038", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que sirve con cuidado y diligencia. Pronto a complacer y, servir a otros.","required":""}},[_vm._v("\n                                    Servicial:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg037),expression:"eval_fig.pg037"}],attrs:{"value":"S","name":"group76","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg037,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg037", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg038),expression:"eval_fig.pg038"}],attrs:{"value":"S","name":"group76","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg038,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg038", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(25),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Razonamiento que se emplea para demostrar una proposición o bien para convencer a otro de aquello que se afirma o se niega.","required":""}},[_vm._v("\n                                    Argumentador:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg039),expression:"eval_fig.pg039"}],attrs:{"value":"D","name":"group77","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg039,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg039", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg040),expression:"eval_fig.pg040"}],attrs:{"value":"D","name":"group77","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg040,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg040", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona que se acomoda, ajusta a una situación.","required":""}},[_vm._v("\n                                    Adaptable:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg039),expression:"eval_fig.pg039"}],attrs:{"value":"C","name":"group78","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg039,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg039", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg040),expression:"eval_fig.pg040"}],attrs:{"value":"N","name":"group78","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg040,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg040", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona que no le importa una situación, quejocivoaovi sea o que se haga de una u otra manera.","required":""}},[_vm._v("\n                                    Indiferente:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg039),expression:"eval_fig.pg039"}],attrs:{"value":"N","name":"group79","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg039,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg039", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg040),expression:"eval_fig.pg040"}],attrs:{"value":"S","name":"group79","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg040,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg040", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Reacción o actitud emocional caracterizada por una actitud que se vive y es agradable.","required":""}},[_vm._v("\n                                    Alegre:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg039),expression:"eval_fig.pg039"}],attrs:{"value":"I","name":"group80","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg039,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg039", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg040),expression:"eval_fig.pg040"}],attrs:{"value":"I","name":"group80","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg040,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg040", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(26),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Crédulo, imprevisor, presumido, satisfecho de sí mismo.","required":""}},[_vm._v("\n                                    Confiado:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg041),expression:"eval_fig.pg041"}],attrs:{"value":"S","name":"group81","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg041,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg041", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg042),expression:"eval_fig.pg042"}],attrs:{"value":"I","name":"group81","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg042,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg042", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Complacido contento de su labor.","required":""}},[_vm._v("\n                                    Satisfecho:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg041),expression:"eval_fig.pg041"}],attrs:{"value":"N","name":"group82","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg041,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg041", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg042),expression:"eval_fig.pg042"}],attrs:{"value":"S","name":"group82","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg042,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg042", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Libre y exento de todo daño o riesgo firme que no esta en peligro de faltar o caerse.","required":""}},[_vm._v("\n                                    Seguro:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg041),expression:"eval_fig.pg041"}],attrs:{"value":"D","name":"group83","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg041,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg041", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg042),expression:"eval_fig.pg042"}],attrs:{"value":"D","name":"group83","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg042,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg042", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Quieto sosegado y amigo de paz.","required":""}},[_vm._v("\n                                    Pacífico:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg041),expression:"eval_fig.pg041"}],attrs:{"value":"C","name":"group84","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg041,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg041", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg042),expression:"eval_fig.pg042"}],attrs:{"value":"C","name":"group84","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg042,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg042", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(27),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Trato agradable con las demás personas.","required":""}},[_vm._v("\n                                    Llevarse bien:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg043),expression:"eval_fig.pg043"}],attrs:{"value":"I","name":"group85","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg043,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg043", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg044),expression:"eval_fig.pg044"}],attrs:{"value":"I","name":"group85","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg044,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg044", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Perronas que tiene educación.","required":""}},[_vm._v("\n                                    Culto:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg043),expression:"eval_fig.pg043"}],attrs:{"value":"N","name":"group86","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg043,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg043", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg044),expression:"eval_fig.pg044"}],attrs:{"value":"C","name":"group86","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg044,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg044", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Fuerte y con actividad. Viveza o eficacia de las acciones.","required":""}},[_vm._v("\n                                    Vigoroso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg043),expression:"eval_fig.pg043"}],attrs:{"value":"D","name":"group87","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg043,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg043", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg044),expression:"eval_fig.pg044"}],attrs:{"value":"D","name":"group87","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg044,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg044", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Benévolo, poco severo, con las faltas u obligaciones de los demás.","required":""}},[_vm._v("\n                                    Indulgente:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg043),expression:"eval_fig.pg043"}],attrs:{"value":"S","name":"group88","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg043,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg043", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg044),expression:"eval_fig.pg044"}],attrs:{"value":"S","name":"group88","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg044,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg044", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(28),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona con inclinación al afectuosa, entre personas.","required":""}},[_vm._v("\n                                    Simpático:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg045),expression:"eval_fig.pg045"}],attrs:{"value":"I","name":"group89","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg045,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg045", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg046),expression:"eval_fig.pg046"}],attrs:{"value":"I","name":"group89","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg046,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg046", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que tiene buena voluntad o simpatía hacia las personas o sus obras.","required":""}},[_vm._v("\n                                    Exácto:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg045),expression:"eval_fig.pg045"}],attrs:{"value":"C","name":"group90","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg045,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg045", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg046),expression:"eval_fig.pg046"}],attrs:{"value":"N","name":"group90","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg046,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg046", "N")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Sincero, generoso, simpático, sencillo de trato.","required":""}},[_vm._v("\n                                    Franco:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg045),expression:"eval_fig.pg045"}],attrs:{"value":"D","name":"group91","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg045,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg045", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg046),expression:"eval_fig.pg046"}],attrs:{"value":"D","name":"group91","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg046,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg046", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Servicial","required":""}},[_vm._v("\n                                    Comedido:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg045),expression:"eval_fig.pg045"}],attrs:{"value":"N","name":"group92","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg045,"N")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg045", "N")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg046),expression:"eval_fig.pg046"}],attrs:{"value":"S","name":"group92","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg046,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg046", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_vm._m(29),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Que no está quieto, o es intranquilo.","required":""}},[_vm._v("\n                                    Inquieto:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg047),expression:"eval_fig.pg047"}],attrs:{"value":"D","name":"group93","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg047,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg047", "D")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg048),expression:"eval_fig.pg048"}],attrs:{"value":"D","name":"group93","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg048,"D")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg048", "D")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Persona que muestra afecto puro y desinteresado.","required":""}},[_vm._v("\n                                    Amistoso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg047),expression:"eval_fig.pg047"}],attrs:{"value":"S","name":"group94","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg047,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg047", "S")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg048),expression:"eval_fig.pg048"}],attrs:{"value":"S","name":"group94","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg048,"S")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg048", "S")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2.5"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Perronas que es aceptada y grata, todos lo conocen.","required":""}},[_vm._v("\n                                    Popular:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg047),expression:"eval_fig.pg047"}],attrs:{"value":"I","name":"group95","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg047,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg047", "I")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg048),expression:"eval_fig.pg048"}],attrs:{"value":"I","name":"group95","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg048,"I")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg048", "I")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-toggle":"tooltip","data-placement":"top","title":"Benigno, blando, misericordioso, se inclina a la piedad y conmiseración.","required":""}},[_vm._v("\n                                    Piadoso:\n                               ")]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg047),expression:"eval_fig.pg047"}],attrs:{"value":"C","name":"group96","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg047,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg047", "C")}}}),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_fig.pg048),expression:"eval_fig.pg048"}],attrs:{"value":"C","name":"group96","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_fig.pg048,"C")},on:{"change":function($event){_vm.$set(_vm.eval_fig, "pg048", "C")}}}),_vm._v(" "),_c('span',[_vm._v("-")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(30)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(3)}}},[_vm._m(31)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grabado===false),expression:"grabado===false"}],staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn tooltipped",attrs:{"data-position":"left","data-tooltip":"Grabar"},on:{"click":function($event){_vm.agregarEvaluacion()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-body"},[_c('div',{attrs:{"align":"justify"}},[_vm._v("\n                            Señor aspirante a empleo: "),_c('br'),_c('br'),_vm._v("\n                            De cada grupo conformado por cuatro palabras, seleccione en la casilla de MAS la palabra que mejor lo describa y en MENOS la palabra con la que no se identifique, por lo que en cada grupo quedará una\n                            palabra marcada en MAS, una palabra marcada en MENOS y DOS EN BLANCO.                                \n                            "),_c('div',{staticClass:"center"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("SELECCIONE EL SIGUIENTE BOTON PARA EMPEZAR LA EVALUACION.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s1"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 01 (Pgs 1 y 2)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s1"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 02 (Pgs 3 y 4)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s1"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 03 (Pgs 5 y 6)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s1"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 04 (Pgs 7 y 8)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s1"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 05 (Pgs 9 y 10)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s1"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 06 (Pgs 11 y 12)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 07 (Pgs 13 y 14)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 08 (Pgs 15 y 16)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 09 (Pgs 17 y 18)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 10 (Pgs 19 y 20)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 11 (Pgs 21 y 22)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 12 (Pgs 23 y 24)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 13 (Pgs 25 y 26)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 14 (Pgs 27 y 28)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 15 (Pgs 29 y 30)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 16 (Pgs 31 y 32)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 17 (Pgs 33 y 34)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 18 (Pgs 35 y 36)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 19 (Pgs 37 y 38)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 20 (Pgs 39 y 40)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 21 (Pgs 41 y 42)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 22 (Pgs 43 y 44)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 23 (Pgs 45 y 46)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s2"},[_c('span',{staticClass:"input-group-addon",staticStyle:{"font-weight":"bold"}},[_vm._v("BLOQUE 24 (Pgs 47 y 48)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("first_page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev06_moss_js__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c26fd71e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev06_moss_vue__ = __webpack_require__(331);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev06_moss_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c26fd71e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev06_moss_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s2"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Departamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.depto),expression:"eval_moss.depto"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_moss.depto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_moss, "depto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.empresa),expression:"eval_moss.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_moss.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_moss, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.nombre),expression:"eval_moss.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_moss.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_moss, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Sexo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.sexo),expression:"eval_moss.sexo"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_moss.sexo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_moss, "sexo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_moss.empezo))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finalizoeval),expression:"finalizoeval"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_moss.termino))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para LEER u OCULTAR las instrucciones.","data-position":"top"}},[_vm._v("\n                            "+_vm._s(_vm.instrucciones)+"\n                        ")])]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12"},[_c('div',{staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("Empezar Evaluación de SUPERVISION")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s12"},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s6"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt4"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("\n                               Preguntas 01 - 15\n                          ")])]),_vm._v(" "),_c('li',{staticClass:"tab col s6"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt5"},on:{"click":function($event){_vm.nadaG1(2)}}},[_vm._v("\n                               Preguntas 16 - 30\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.pregSinContestar>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_sinResponder))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt4"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg001==="" ? "color:red" : "color:black")},[_vm._v("01. Se le ha asignado a usted un gran puesto en una gran empresa. La mejor forma de establecer relaciones amistosas y cordiales con sus nuevos compañeros será:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg001),expression:"eval_moss.pg001"}],attrs:{"value":"a","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg001,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg001", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Evitando tener encuenta los errores en que ellos incurren.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg001),expression:"eval_moss.pg001"}],attrs:{"value":"b","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg001,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg001", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Hablando bien de ellos al jefe.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg001),expression:"eval_moss.pg001"}],attrs:{"value":"c","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg001,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg001", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Mostrándo interés en el trabajo de ellos.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg001),expression:"eval_moss.pg001"}],attrs:{"value":"d","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg001,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg001", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Pidiéndoles le permitan hacer los trabajos que usted pueda hacer mejor.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg002==="" ? "color:red" : "color:black")},[_vm._v("02. Tiene usted un empleado muy eficiente, pero constantemente se queja del trabajo. Sus quejas producen mal efecto en los demás empleados. Lo mejor será:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg002),expression:"eval_moss.pg002"}],attrs:{"value":"a","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg002,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg002", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Pedir a los demás empleados que traten de no hacer caso.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg002),expression:"eval_moss.pg002"}],attrs:{"value":"b","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg002,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg002", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Averiguar la causa de esa actitud y procurar su modificación ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg002),expression:"eval_moss.pg002"}],attrs:{"value":"c","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg002,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg002", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Cambiarlo a otro Departamento donde quede a cargo de otro jefe.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg002),expression:"eval_moss.pg002"}],attrs:{"value":"d","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg002,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg002", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Permitirle planear lo más posible acerca de su trabajo.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg003==="" ? "color:red" : "color:black")},[_vm._v("03. Un empleado de 60 años de edad, que ha sido leal a la empresa durante 25 años, se queja de exceso de trabajo. Lo mejor será:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg003),expression:"eval_moss.pg003"}],attrs:{"value":"a","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg003,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg003", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Decirle que vuelva a su trabajo, si no quiere ser despedido.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg003),expression:"eval_moss.pg003"}],attrs:{"value":"b","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg003,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg003", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Despedirlo, sustituyéndolo por alquien más joven.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg003),expression:"eval_moss.pg003"}],attrs:{"value":"c","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg003,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg003", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Darle un aumento de sueldo, que evite continúe quejándose.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg003),expression:"eval_moss.pg003"}],attrs:{"value":"d","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg003,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg003", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Aminorar su trabajo.")])])]),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg004==="" ? "color:red" : "color:black")},[_vm._v("04. Uno de sus socios sin autoridad sobre usted le ordena que haga algo en forma bien distinta de lo que planeaba usted. ¿ Qué haría usted ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg004),expression:"eval_moss.pg004"}],attrs:{"value":"a","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg004,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg004", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Acatar la orden y no crear otros problemas.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg004),expression:"eval_moss.pg004"}],attrs:{"value":"b","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg004,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg004", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ignorar las indicaciones y actuar como usted lo había planeado. ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg004),expression:"eval_moss.pg004"}],attrs:{"value":"c","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg004,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg004", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Decirle que esto es un asunto que a él no le interesa y que usted hará las cosas a su modo.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg004),expression:"eval_moss.pg004"}],attrs:{"value":"d","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg004,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg004", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Decirle que lo haga él mismo.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg005==="" ? "color:red" : "color:black")},[_vm._v("05. Usted visita a un amigo íntimo que ha estado enfermo por algún tiempo. Lo mejor sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg005),expression:"eval_moss.pg005"}],attrs:{"value":"a","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg005,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg005", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Platicarle de sus diversiones recientes.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg005),expression:"eval_moss.pg005"}],attrs:{"value":"b","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg005,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg005", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Platicarle de noticias referentes a amigos mutuos.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg005),expression:"eval_moss.pg005"}],attrs:{"value":"c","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg005,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg005", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Comentar su enfermedad")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg005),expression:"eval_moss.pg005"}],attrs:{"value":"d","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg005,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg005", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Enfatizar lo mucho que le apena verlo enfermo.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg006==="" ? "color:red" : "color:black")},[_vm._v("06. Usted trabaja en una industria, y su jefe quiere que tome un cargo relacionado con su trabajo, pero que es incompatible con el horario nocturno de su carrera. Lo mejor sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg006),expression:"eval_moss.pg006"}],attrs:{"value":"a","name":"group6","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg006,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg006", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Continuar normalmente su carrera e informar al jefe, si le pregunta.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg006),expression:"eval_moss.pg006"}],attrs:{"value":"b","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg006,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg006", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Explicarle la situación y obtener su opinión en cuanto a la importancia relativa de ambas situaciones.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg006),expression:"eval_moss.pg006"}],attrs:{"value":"c","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg006,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg006", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Dejar la escuela y atender a los intereses del trabajo.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg006),expression:"eval_moss.pg006"}],attrs:{"value":"d","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg006,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg006", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Asistir en forma alterna y no hacer comentarios.")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg007==="" ? "color:red" : "color:black")},[_vm._v("07. Un agente viajero con 15 años de antigüedad decide, presionado por su familia, dejar los viajes. Se le cambia a las oficinas generales. Es de esperar que:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg007),expression:"eval_moss.pg007"}],attrs:{"value":"a","name":"group7","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg007,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg007", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Guste de los trabajos de descanso de la oficina.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg007),expression:"eval_moss.pg007"}],attrs:{"value":"b","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg007,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg007", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Se sienta inquieto por la rutina de la oficina.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg007),expression:"eval_moss.pg007"}],attrs:{"value":"c","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg007,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg007", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Busque otro trabajo.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg007),expression:"eval_moss.pg007"}],attrs:{"value":"d","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg007,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg007", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Resulte muy ineficiente en el trabajo de oficina.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg008==="" ? "color:red" : "color:black")},[_vm._v("08. Tiene usted dos invitados a cenar: uno radical y otro conservador. Surgue una acalorada discusión sobre política. Lo mejor sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg008),expression:"eval_moss.pg008"}],attrs:{"value":"a","name":"group8","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg008,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg008", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Tomar partido.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg008),expression:"eval_moss.pg008"}],attrs:{"value":"b","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg008,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg008", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intentar cambiar el tema.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg008),expression:"eval_moss.pg008"}],attrs:{"value":"c","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg008,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg008", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Intervenir dando los propios puntos de vista y mostrar dónde ambos pecan de extremistas.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg008),expression:"eval_moss.pg008"}],attrs:{"value":"d","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg008,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg008", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Pedir que cambien el tema para evitar mayor discusión.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg009==="" ? "color:red" : "color:black")},[_vm._v("09. Un joven invita a una dama al teatro. Al llegar se da cuenta que ha olvidado su billetera. Sería mejor:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg009),expression:"eval_moss.pg009"}],attrs:{"value":"a","name":"group9","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg009,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg009", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Tratar de obtener los boletos dejando el reloj en prenda.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg009),expression:"eval_moss.pg009"}],attrs:{"value":"b","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg009,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg009", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Buscar a un amigo a quien pedir prestado.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg009),expression:"eval_moss.pg009"}],attrs:{"value":"c","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg009,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg009", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Decidir de acuerdo con ella lo procedente.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg009),expression:"eval_moss.pg009"}],attrs:{"value":"d","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg009,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg009", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Dar una excusa aceptable para ira a casa por dinero.")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg010==="" ? "color:red" : "color:black")},[_vm._v("10. Usted ha tenido experiencia como vendedor y acaba de conseguir otro trabajo en un almacén grande. La mejor forma de relacionarse con los empleados del mismo sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg010),expression:"eval_moss.pg010"}],attrs:{"value":"a","name":"group10","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg010,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg010", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Permitirles hacer la mayoría de las ventas durante unos días mientras observa sus métodos.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg010),expression:"eval_moss.pg010"}],attrs:{"value":"b","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg010,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg010", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Trata de imponer los métodos que algún día le fueron útiles.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg010),expression:"eval_moss.pg010"}],attrs:{"value":"c","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg010,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg010", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Adaptarse a las condiciones y aceptar consejo de sus compañeros.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg010),expression:"eval_moss.pg010"}],attrs:{"value":"d","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg010,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg010", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Pedir al jefe todo el consejo necesario.")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg011==="" ? "color:red" : "color:black")},[_vm._v("11. Es usted un joven empleado que va a comer con una maestra a quien conoce superficialmente. Lo mejor sería iniciar una conversación acerca de :")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg011),expression:"eval_moss.pg011"}],attrs:{"value":"a","name":"group11","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg011,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg011", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Algún tópico de actualidad de interés general.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg011),expression:"eval_moss.pg011"}],attrs:{"value":"b","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg011,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg011", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Algún aspecto interesante de su trabajo.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg011),expression:"eval_moss.pg011"}],attrs:{"value":"c","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg011,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg011", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Las tendencias actuales en el terreno docente.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg011),expression:"eval_moss.pg011"}],attrs:{"value":"d","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg011,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg011", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Las sociedades o comités de padres de familia.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg012==="" ? "color:red" : "color:black")},[_vm._v("12. Una señora de especiales méritos, que por largo tiempo ha dirigido trabajos benéficos dejando las labores de la casa a cargo de la servidumbre, se cambia a otra población. Es de esperar que ella:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg012),expression:"eval_moss.pg012"}],attrs:{"value":"a","name":"group12","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg012,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg012", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Se sienta insatisfecha en su nuevo hogar.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg012),expression:"eval_moss.pg012"}],attrs:{"value":"b","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg012,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg012", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Se interese más en los trabajos domésticos.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg012),expression:"eval_moss.pg012"}],attrs:{"value":"c","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg012,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg012", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Intervenga poco a poco en la vida de la comunidad.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg012),expression:"eval_moss.pg012"}],attrs:{"value":"d","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg012,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg012", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Adopte nuevos intereses en la nueva comunidad.")])])]),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg013==="" ? "color:red" : "color:black")},[_vm._v("13. Quiere usted pedirle un favor a un conocido con quien tiene poca confianza. La mejor forma de lograrlo sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg013),expression:"eval_moss.pg013"}],attrs:{"value":"a","name":"group13","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg013,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg013", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Haciéndole creer que será él quien se beneficie más.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg013),expression:"eval_moss.pg013"}],attrs:{"value":"b","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg013,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg013", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Enfatizando la importancia que para usted tiene que se lo conceda.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg013),expression:"eval_moss.pg013"}],attrs:{"value":"c","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg013,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg013", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Ofrecer algo en retribución.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg013),expression:"eval_moss.pg013"}],attrs:{"value":"d","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg013,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg013", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Decir lo que desea en forma breve indicando los motivos.")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg014==="" ? "color:red" : "color:black")},[_vm._v("14. Un joven de 24 años gasta bastante tiempo y dinero en diversiones. Se le ha hecho ver que así no logrará el éxito en el trabajo. Probablemente cambie sus costumbres si:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg014),expression:"eval_moss.pg014"}],attrs:{"value":"a","name":"group14","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg014,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg014", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sus hábitos nocturnos lesionan su salud.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg014),expression:"eval_moss.pg014"}],attrs:{"value":"b","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg014,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg014", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Sus amigos enfatizan el daño que se hace a sí mismo.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg014),expression:"eval_moss.pg014"}],attrs:{"value":"c","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg014,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg014", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Su jefe se da cuenta y lo previene.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg014),expression:"eval_moss.pg014"}],attrs:{"value":"d","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg014,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg014", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Se interesa en el desarrollo de alguna fase de su trabajo.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg015==="" ? "color:red" : "color:black")},[_vm._v("15. Tras haber hecho un buen numero de favores a un amigo, éste empieza a dar por hecho que usted será quien le resuelva todas sus pequeñas dificultades. La mejor forma de readaptar la situación, sin ofenderlo, sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg015),expression:"eval_moss.pg015"}],attrs:{"value":"a","name":"group15","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg015,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg015", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Explicar el daño que se está causando.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg015),expression:"eval_moss.pg015"}],attrs:{"value":"b","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg015,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg015", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Pedir a un amigo mutuo que arregle las cosas.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg015),expression:"eval_moss.pg015"}],attrs:{"value":"c","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg015,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg015", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Darle ayuda una vez mas. Pero de tal manera que sienta que mejor hubiera sido no haberla solicitado.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg015),expression:"eval_moss.pg015"}],attrs:{"value":"d","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg015,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg015", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Darle una excusa para no seguir ayudándole.")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt5"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg016==="" ? "color:red" : "color:black")},[_vm._v("16. Una persona ascendida recientemente a un puesto de autoridad, lograría mejor sus metas y la buena voluntad de los empleados:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg016),expression:"eval_moss.pg016"}],attrs:{"value":"a","name":"group16","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg016,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg016", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Tratando que cada empleado entienda qué es la verdadera eficiencia.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg016),expression:"eval_moss.pg016"}],attrs:{"value":"b","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg016,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg016", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ascendiendo cuanto antes a quienes considera lo merece.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg016),expression:"eval_moss.pg016"}],attrs:{"value":"c","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg016,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg016", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Preguntando confidencialmente a cada empleado en cuanto a los cambios que estima necesario.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg016),expression:"eval_moss.pg016"}],attrs:{"value":"d","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg016,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg016", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Seguir los sistemas del anterior jefe y gradualmente hacer los cambios necesarios.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg017==="" ? "color:red" : "color:black")},[_vm._v("17. Usted vive a 15 kms del centro y ha ofrecido llevar de regreso a un vecino a las 4pm. El lo espera desde las tres; y a las cuatro usted se entera que no podrá salir antes de las 5:30pm. Lo mejor sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg017),expression:"eval_moss.pg017"}],attrs:{"value":"a","name":"group17","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg017,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg017", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Pedirle un taxi.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg017),expression:"eval_moss.pg017"}],attrs:{"value":"b","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg017,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg017", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Explicarle el caso y dejar que él decida.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg017),expression:"eval_moss.pg017"}],attrs:{"value":"c","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg017,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg017", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Pedirle que espera hasta las 5:30pm.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg017),expression:"eval_moss.pg017"}],attrs:{"value":"d","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg017,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg017", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Proporcionarle las llaves y que se lleve su automovil.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg018==="" ? "color:red" : "color:black")},[_vm._v("18. Es usted un ejecutivo y dos de sus empleados se llevan mal; ambos son eficientes. Lo mejor será:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg018),expression:"eval_moss.pg018"}],attrs:{"value":"a","name":"group18","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg018,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg018", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Despedir al menos eficiente.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg018),expression:"eval_moss.pg018"}],attrs:{"value":"b","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg018,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg018", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Darles trabajo en común que a ambos les interese.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg018),expression:"eval_moss.pg018"}],attrs:{"value":"c","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg018,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg018", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Hacerles ver el daño que se hacen")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg018),expression:"eval_moss.pg018"}],attrs:{"value":"d","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg018,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg018", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Darles trabajos distintos.")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg019==="" ? "color:red" : "color:black")},[_vm._v("19. El Señor García ha conservado su puesto subordinado durante 10 años. Desempeña su trabajo callada y confiablemente y se le extrañará cuando se vaya. De obtener trabajo en otra empresa, muy probablemente:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg019),expression:"eval_moss.pg019"}],attrs:{"value":"a","name":"group19","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg019,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg019", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Asuma facilmente su responsabilidad como supervisor.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg019),expression:"eval_moss.pg019"}],attrs:{"value":"b","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg019,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg019", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Haga ver de inmediato su valer.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg019),expression:"eval_moss.pg019"}],attrs:{"value":"c","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg019,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg019", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Sea lento para abrirse las necesarias oportunidades.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg019),expression:"eval_moss.pg019"}],attrs:{"value":"d","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg019,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg019", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Renuncie ante la más ligera crítica a su trabajo.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg020==="" ? "color:red" : "color:black")},[_vm._v("20. Va usted a ser maestro de ceremonias en una cena el próximo sábado, día en que por la mañana y debido a una enfermedad en la familia, se ve imposibilitado en asistir. Lo indicado sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg020),expression:"eval_moss.pg020"}],attrs:{"value":"a","name":"group20","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg020,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg020", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Cancelar la cena. ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg020),expression:"eval_moss.pg020"}],attrs:{"value":"b","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg020,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg020", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) IntermedioEncontrar quien lo sustituya.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg020),expression:"eval_moss.pg020"}],attrs:{"value":"c","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg020,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg020", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Detallar los planes que tenía y enviarlos.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg020),expression:"eval_moss.pg020"}],attrs:{"value":"d","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg020,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg020", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Enviar una nota explicando la causa de su ausencia.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg021==="" ? "color:red" : "color:black")},[_vm._v("21. En igualdad de circunstancias, el empleado que mejor se adapta a un nuevo puesto es aquel que:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg021),expression:"eval_moss.pg021"}],attrs:{"value":"a","name":"group21","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg021,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg021", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Ha sido bueno en puestos anteriores.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg021),expression:"eval_moss.pg021"}],attrs:{"value":"b","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg021,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg021", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ha tenido éxito durante 10 años en su puesto.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg021),expression:"eval_moss.pg021"}],attrs:{"value":"c","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg021,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg021", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Tiene sus propias ideas e invariablemente se rigue por ellas.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg021),expression:"eval_moss.pg021"}],attrs:{"value":"d","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg021,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg021", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Tiene sus propias ideas e invariablemente se rigue por ellas.")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg022==="" ? "color:red" : "color:black")},[_vm._v("22. Un conocido le platica acerca de una afición que él tiene; su conversación le aburre. Lo mejor sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg022),expression:"eval_moss.pg022"}],attrs:{"value":"a","name":"group22","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg022,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg022", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Escuchar de manera cortés pero aburrida.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg022),expression:"eval_moss.pg022"}],attrs:{"value":"b","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg022,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg022", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Escuchar con fingido interés.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg022),expression:"eval_moss.pg022"}],attrs:{"value":"c","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg022,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg022", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Decirle francamente que el tema no le interesa.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg022),expression:"eval_moss.pg022"}],attrs:{"value":"d","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg022,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg022", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Mirar el reloj con impaciencia.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg023==="" ? "color:red" : "color:black")},[_vm._v("23. Es usted empleado en una oficina grande. El jefe entra cuando usted lee en vez de trabajar. Lo mejor sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg023),expression:"eval_moss.pg023"}],attrs:{"value":"a","name":"group23","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg023,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg023", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Doblar el periódico y volver al trabajo.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg023),expression:"eval_moss.pg023"}],attrs:{"value":"b","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg023,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg023", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Pretender que obtiene recortes necesarios al trabajo.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg023),expression:"eval_moss.pg023"}],attrs:{"value":"c","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg023,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg023", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Tratar de interesar al jefe, leyendo un encabezado importante.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg023),expression:"eval_moss.pg023"}],attrs:{"value":"d","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg023,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg023", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Seguir leyendo sin mostrar preocupación.")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg024==="" ? "color:red" : "color:black")},[_vm._v("24. Es usted Maestra(o) de Primaria. Camina a la escuela tras la primera lluvia. Algunos de sus alumnos le salpican a propósito con agua. Desde el punto de vista de la buena administración escolar, usted debería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg024),expression:"eval_moss.pg024"}],attrs:{"value":"a","name":"group24","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg024,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg024", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Castigarles ahí mismo por su indisciplina.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg024),expression:"eval_moss.pg024"}],attrs:{"value":"b","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg024,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg024", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Decirles que, de volverlo a hacer, usted los castigará.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg024),expression:"eval_moss.pg024"}],attrs:{"value":"c","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg024,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg024", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Pasar la queja a sus padres.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg024),expression:"eval_moss.pg024"}],attrs:{"value":"d","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg024,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg024", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Tomarlo como broma y no hacer nada al respecto.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg025==="" ? "color:red" : "color:black")},[_vm._v("25. Usted preside el comité de mejoras materiales de su colonia. Las últimas reuniones han sido de escasa asistencia. Se mejoraría la asitencia:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg025),expression:"eval_moss.pg025"}],attrs:{"value":"a","name":"group25","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg025,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg025", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Visitando vecinos prominentes, explicándoles problemas.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg025),expression:"eval_moss.pg025"}],attrs:{"value":"b","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg025,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg025", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Decirles que, de volverlo a hacer, usted los castigaráAvisando de un programa interesante para la reunión.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg025),expression:"eval_moss.pg025"}],attrs:{"value":"c","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg025,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg025", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Poniendo avisos en los lugares públicos.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg025),expression:"eval_moss.pg025"}],attrs:{"value":"d","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg025,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg025", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Enviando avisos personales.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg026==="" ? "color:red" : "color:black")},[_vm._v("26. El señor Pérez, eficiente, pero de esos que \"todo lo saben\" critica al señor Martinez. El jefe opina que la idea de Martinez ahorra tiempo. Probablemente el señor pérez:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg026),expression:"eval_moss.pg026"}],attrs:{"value":"a","name":"group26","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg026,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg026", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Pida otro trabajo al jefe.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg026),expression:"eval_moss.pg026"}],attrs:{"value":"b","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg026,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg026", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Lo haga a su modo sin comentarios.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg026),expression:"eval_moss.pg026"}],attrs:{"value":"c","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg026,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg026", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Lo haga como Martínez, pero sigue criticándolo.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg026),expression:"eval_moss.pg026"}],attrs:{"value":"d","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg026,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg026", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Lo haga como Martínez, pero mal a propósito.")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg027==="" ? "color:red" : "color:black")},[_vm._v("27. Un hombre de 65 años tuvo algún éxito cuando joven, como político. Sus modos directos le han impedido descollar los últimos veinte años. Lo más probable es que:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg027),expression:"eval_moss.pg027"}],attrs:{"value":"a","name":"group27","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg027,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg027", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Persista en su manera de ser.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg027),expression:"eval_moss.pg027"}],attrs:{"value":"b","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg027,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg027", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Cambie para lograr éxito.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg027),expression:"eval_moss.pg027"}],attrs:{"value":"c","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg027,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg027", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Forme un nuevo partido político.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg027),expression:"eval_moss.pg027"}],attrs:{"value":"d","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg027,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg027", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Abandone la política por inmoral.")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg028==="" ? "color:red" : "color:black")},[_vm._v("28. Es usted un joven que encuentra en la calle a una mujer de más edad, a quien apenas conoce y que parece haber estado llorando. Lo mejor sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg028),expression:"eval_moss.pg028"}],attrs:{"value":"a","name":"group28","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg028,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg028", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Preguntarle por que esta triste.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg028),expression:"eval_moss.pg028"}],attrs:{"value":"b","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg028,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg028", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Pasarle el brazo consoladoramente.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg028),expression:"eval_moss.pg028"}],attrs:{"value":"c","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg028,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg028", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Simular no advertir su pena.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg028),expression:"eval_moss.pg028"}],attrs:{"value":"d","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg028,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg028", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Simular no haberla visto.")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg029==="" ? "color:red" : "color:black")},[_vm._v("29. Un compañero flojea de tal manera que a usted le toca más que lo que le corresponde. La mejor forma de conservar las buenas relaciones es:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg029),expression:"eval_moss.pg029"}],attrs:{"value":"a","name":"group29","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg029,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg029", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Explicar el caso al jefe.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg029),expression:"eval_moss.pg029"}],attrs:{"value":"b","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg029,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg029", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Cortésmente indicarle que debe hacer lo que le corresponde o que usted se quejará con el jefe.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg029),expression:"eval_moss.pg029"}],attrs:{"value":"c","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg029,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg029", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Hacer tanto cuanto pueda eficientemente y no decir nada del caso.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg029),expression:"eval_moss.pg029"}],attrs:{"value":"d","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg029,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg029", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Hacer lo suyo y dejar pendiente lo que el compañero no haga.")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_moss.pg030==="" ? "color:red" : "color:black")},[_vm._v("30. Se le ha asignado a usted un puesto ejecutivo en organización. Para ganar el respeto y la admiración de sus subordinados sin perjuicio de sus planes, habría que:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg030),expression:"eval_moss.pg030"}],attrs:{"value":"a","name":"group30","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_moss.pg030,"a")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg030", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Ceder en todos los puntos posibles, con tal que sean pequeños.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg030),expression:"eval_moss.pg030"}],attrs:{"value":"b","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg030,"b")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg030", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Tratar de convercerlo en todas sus ideas.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg030),expression:"eval_moss.pg030"}],attrs:{"value":"c","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg030,"c")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg030", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Ceder parcialmente en todas sus cuestiones importantes.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_moss.pg030),expression:"eval_moss.pg030"}],attrs:{"value":"d","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_moss.pg030,"d")},on:{"change":function($event){_vm.$set(_vm.eval_moss, "pg030", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Abogar por muchas reformas.")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grabado===false),expression:"grabado===false"}],staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn tooltipped",attrs:{"data-position":"left","data-tooltip":"Grabar"},on:{"click":function($event){_vm.agregarEvaluacion()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-body"},[_c('div',{attrs:{"align":"justify"}},[_vm._v("\n                            Señor aspirante a empleo: Este es un cuestionario de sus actitudes. Lo que hace o lo que piensa acerca de ciertas situaciones. Las personas piensan de una manera u otra. Por lo tanto, no existen respuestas \"correctas\" o \"incorrectas\" a las preguntas. \n                            \n                            Se ofrecen cuatro (4) posibles respuestas para cada pregunta, que Ud. debe contestar \"A\" o \"B\" o \"C\" o \"D\" seleccionando con el mouse en la correspondiente respuesta. Las preguntas están organizadas en dos (2) secciones. Sección 1: De la 1 a la 15, Sección 2: de la 16 a la 30."),_c('br'),_c('br'),_vm._v("\n                              \n                            Inicialmente todas las preguntas estarán en color "),_c('span',{staticStyle:{"font-weight":"bold","color":"red"}},[_vm._v("rojo")]),_vm._v(" como indicador\n                            que aún no han sido respondidas. Conforme vaya respondiendo, las preguntas se mostrarán en color negro. También tendrá un mensaje indicándole la cantidad \n                            de preguntas que aún no han sido respondidas. El siguiente "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("ejemplo")]),_vm._v(" de tres preguntas le permitirá estar seguro que comprende lo que debe hacer en el propio cuestionario."),_c('br'),_vm._v(" "),_c('div',{staticClass:"center"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("SELECCIONE EL SIGUIENTE BOTON PARA EMPEZAR LA EVALUACION.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev07_tav_js__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53f0acaa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev07_tav_vue__ = __webpack_require__(333);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev07_tav_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53f0acaa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev07_tav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s2"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Departamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.depto),expression:"eval_tav.depto"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_tav.depto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_tav, "depto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.empresa),expression:"eval_tav.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_tav.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_tav, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.nombre),expression:"eval_tav.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_tav.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_tav, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Sexo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.sexo),expression:"eval_tav.sexo"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_tav.sexo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_tav, "sexo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_tav.empezo))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finalizoeval),expression:"finalizoeval"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_tav.termino))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para LEER u OCULTAR las instrucciones.","data-position":"top"}},[_vm._v("\n                            "+_vm._s(_vm.instrucciones)+"\n                        ")])]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12"},[_c('div',{staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("Empezar Evaluación de APTITUD EN VENTAS")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s12"},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s6"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt4"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("Preguntas 01 - 15")])]),_vm._v(" "),_c('li',{staticClass:"tab col s6"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt5"},on:{"click":function($event){_vm.nadaG1(2)}}},[_vm._v("Preguntas 16 - 30")])])]),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.pregSinContestar>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_sinResponder))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt4"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg001==="" ? "color:red" : "color:black")},[_vm._v("01.  Cuál de las siguientes acciones ayudarían más a hacer una venta ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg001),expression:"eval_tav.pg001"}],attrs:{"value":"a","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg001,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg001", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Demostrar, o bien explicar, todas las aplicaciones del producto.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg001),expression:"eval_tav.pg001"}],attrs:{"value":"b","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg001,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg001", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Saber si los posibles clientes necesitan su producto.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg001),expression:"eval_tav.pg001"}],attrs:{"value":"c","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg001,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg001", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Ofrecer el producto los días en que los clientes reciben su sueldo.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg001),expression:"eval_tav.pg001"}],attrs:{"value":"d","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg001,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg001", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Permitir a los clientes potenciales que sometan a prueba el producto.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg002==="" ? "color:red" : "color:black")},[_vm._v("02. Un vendedor de maquinaria pesada acaba de tener una conversación con un director de producción y este le ha manifestado que la empresa no dispone de dinero para comprar el producto que ofrece. La mejor reacción del vendedor es:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg002),expression:"eval_tav.pg002"}],attrs:{"value":"a","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg002,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg002", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Indicarle que, a la larga, el costo de la máquina le será compensado por nuevos beneficios.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg002),expression:"eval_tav.pg002"}],attrs:{"value":"b","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg002,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg002", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Explicarle que los pagos pueden ir haciéndose a medida que la máquina vaya amortizándose.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg002),expression:"eval_tav.pg002"}],attrs:{"value":"c","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg002,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg002", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Manifestarle que ese asunto vale la pena considerarlo más.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg002),expression:"eval_tav.pg002"}],attrs:{"value":"d","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg002,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg002", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Despedirse y más adelante enviarle material ilustrado sobre las cualidades del producto.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg003==="" ? "color:red" : "color:black")},[_vm._v("03. Una señora ha solicitado a una empresa de tapicería que le envíe un vendedor. Cuándo éste llega la señora le dice que ha cambiado de opinión. ¿ Qué es lo mejor que puede hacer el vendedor ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg003),expression:"eval_tav.pg003"}],attrs:{"value":"a","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg003,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg003", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Indicarle con delicadeza que está obligada a ver las muestras.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg003),expression:"eval_tav.pg003"}],attrs:{"value":"b","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg003,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg003", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Preguntarle: \"¿ ha comprado ya algo ?\".")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg003),expression:"eval_tav.pg003"}],attrs:{"value":"c","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg003,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg003", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Decirle que esta cometiendo un serio error.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg003),expression:"eval_tav.pg003"}],attrs:{"value":"d","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg003,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg003", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Decirle: \"ya estoy aquí puedo, de todos modos, enseñarle las muestras\".")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg004==="" ? "color:red" : "color:black")},[_vm._v("04. Un comerciante en compraventa acaba de conseguir un gran numero de máquinas fotográficas de segunda mano. Desea desprenderse de ellas rápidamente, pero obteniendo un adecuado beneficio. ¿ Cuál de los siguientes es probablemente el mejor mercado ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg004),expression:"eval_tav.pg004"}],attrs:{"value":"a","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg004,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg004", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Los establecimientos que venden material fotográfico de segunda mano.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg004),expression:"eval_tav.pg004"}],attrs:{"value":"b","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg004,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg004", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Los alumnos que siguen curso de fotografía. ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg004),expression:"eval_tav.pg004"}],attrs:{"value":"c","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg004,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg004", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Los reporteros gráficos de la prensa.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg004),expression:"eval_tav.pg004"}],attrs:{"value":"d","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg004,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg004", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Los clubes de estudiantes aficionados a la fotografía.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg005==="" ? "color:red" : "color:black")},[_vm._v("05. ¿ Qué se venderá mejor en los distrituso rurales que en las ciudades ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg005),expression:"eval_tav.pg005"}],attrs:{"value":"a","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg005,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg005", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Ropa de trabajo.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg005),expression:"eval_tav.pg005"}],attrs:{"value":"b","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg005,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg005", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Artículos deportivos.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg005),expression:"eval_tav.pg005"}],attrs:{"value":"c","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg005,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg005", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Publicaciones sobre agricultura y ganadería.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg005),expression:"eval_tav.pg005"}],attrs:{"value":"d","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg005,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg005", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Materiales de construcción.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg006==="" ? "color:red" : "color:black")},[_vm._v("06. Un presunto cliente viene a una papelería en busca de artículos de escritorio anunciados en la prensa. Después de fijarse en esos artículos y en otros no anunciados, abandona la tienda sin haber comprado nada. ¿ Cuál es la razon más probable de que ocurra esto ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg006),expression:"eval_tav.pg006"}],attrs:{"value":"a","name":"group6","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg006,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg006", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) El vendedor fracasó al no presentarle los productos de forma tan atractiva como sugería el anuncio.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg006),expression:"eval_tav.pg006"}],attrs:{"value":"b","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg006,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg006", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Los objetos estaban colocados desordenadamente, por lo que perdían atracción.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg006),expression:"eval_tav.pg006"}],attrs:{"value":"c","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg006,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg006", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) El presunto comprador no tenía idea de lo que deseaba.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg006),expression:"eval_tav.pg006"}],attrs:{"value":"d","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg006,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg006", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) El vendedor no hizo nada para lograr una venta.")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg007==="" ? "color:red" : "color:black")},[_vm._v("07. La mayor parte de los vendedores de una compañia de detergentes están obteniendo mejores resultados que nunca; pero Jorge los tiene peores que antes. El vendedor podría, probablemente, mejorar:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg007),expression:"eval_tav.pg007"}],attrs:{"value":"a","name":"group7","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg007,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg007", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Adquiriendo más conocimientoa acerca del producto que vende.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg007),expression:"eval_tav.pg007"}],attrs:{"value":"b","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg007,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg007", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Solicitando un cambio de zona.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg007),expression:"eval_tav.pg007"}],attrs:{"value":"c","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg007,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg007", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Desarrollando los rasgos de una personalidad atrayente.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg007),expression:"eval_tav.pg007"}],attrs:{"value":"d","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg007,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg007", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Estudiando los métodos de los vendedores más eficaces.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg008==="" ? "color:red" : "color:black")},[_vm._v("08. ¿ Con qué titulo se vendería mejor el mismo libro ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg008),expression:"eval_tav.pg008"}],attrs:{"value":"a","name":"group8","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg008,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg008", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) \"Canción para una cena\".")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg008),expression:"eval_tav.pg008"}],attrs:{"value":"b","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg008,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg008", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) \"Cómo cantar para ganar dinero\".")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg008),expression:"eval_tav.pg008"}],attrs:{"value":"c","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg008,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg008", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) \"Serenata del Dolar\".")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg008),expression:"eval_tav.pg008"}],attrs:{"value":"d","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg008,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg008", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) \"Manual para adiestrar la voz\".")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg009==="" ? "color:red" : "color:black")},[_vm._v("09. ¿ Qué será mas convincente para mejorar los resultados de un vendedor ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg009),expression:"eval_tav.pg009"}],attrs:{"value":"a","name":"group9","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg009,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg009", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Invitar a comer a los presuntos cllientes.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg009),expression:"eval_tav.pg009"}],attrs:{"value":"b","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg009,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg009", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Leer las más recientes publicaciones sobre sus productos.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg009),expression:"eval_tav.pg009"}],attrs:{"value":"c","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg009,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg009", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Asistir a cursos de psicología.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg009),expression:"eval_tav.pg009"}],attrs:{"value":"d","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg009,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg009", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Estudiar teorías económicas.")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg010==="" ? "color:red" : "color:black")},[_vm._v("10. Durante la conversación entre un vendedor y un jefe de compras, este tiene que ausentarse para atender una entrevista concertada previamente. En estas circunstancias, ¿ Qué debería hacer el vendedor ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg010),expression:"eval_tav.pg010"}],attrs:{"value":"a","name":"group10","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg010,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg010", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Decirle que aguardará hasta que termine.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg010),expression:"eval_tav.pg010"}],attrs:{"value":"b","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg010,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg010", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Marcharse y llamar más tarde para concertar una entrevista.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg010),expression:"eval_tav.pg010"}],attrs:{"value":"c","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg010,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg010", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Rogarle que le permita acompañarle para continuar la conversación.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg010),expression:"eval_tav.pg010"}],attrs:{"value":"d","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg010,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg010", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Pedirle otra entrevista.")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg011==="" ? "color:red" : "color:black")},[_vm._v("11. Para intentar convencer a un cliente de que suscriba una póliza de seguro contra incendios por una cuantía mayor que la que ahora tiene ¿ Cuál sería la razón más conveniente ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg011),expression:"eval_tav.pg011"}],attrs:{"value":"a","name":"group11","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg011,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg011", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Mostrarle que el seguro contra incendios es hoy más barato que nunca.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg011),expression:"eval_tav.pg011"}],attrs:{"value":"b","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg011,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg011", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Indicarle que ahora su seguro no cubre el valor actual de la vivienda.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg011),expression:"eval_tav.pg011"}],attrs:{"value":"c","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg011,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg011", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Hacerle ver cuantos millones de pesetas fueron distribuidos el año pasado a los propietarios de fincas hincendiadas.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg011),expression:"eval_tav.pg011"}],attrs:{"value":"d","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg011,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg011", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Informarle de los vecinos que ya han aumentado su poliza.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg012==="" ? "color:red" : "color:black")},[_vm._v("12. El material ilustrado es frecuentemente una ayuda para vender un producto. En una primera entrevista, ¿ Cuál será la mejor forma de utilizar este material ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg012),expression:"eval_tav.pg012"}],attrs:{"value":"a","name":"group12","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg012,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg012", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Dárselo al cliente al iniciar la entrevista.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg012),expression:"eval_tav.pg012"}],attrs:{"value":"b","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg012,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg012", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Tenerlo en su poder y mostrárselo al comprador en el momento oportuno.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg012),expression:"eval_tav.pg012"}],attrs:{"value":"c","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg012,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg012", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Entregárselo una vez asegurada la venta.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg012),expression:"eval_tav.pg012"}],attrs:{"value":"d","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg012,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg012", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Entregárselo una vez asegurada la venta.")])])]),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg013==="" ? "color:red" : "color:black")},[_vm._v("13. ¿ Cuál de los siguientes métodos es más útil a un vendedor a domicilio de enciclopedias para elegir a sus posibles clientes ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg013),expression:"eval_tav.pg013"}],attrs:{"value":"a","name":"group13","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg013,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg013", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Visitar a las personas relacionadas en el anuario telefónico.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg013),expression:"eval_tav.pg013"}],attrs:{"value":"b","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg013,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg013", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Visitar a los miembros de un club que tuviera el nombre «libro del mes».")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg013),expression:"eval_tav.pg013"}],attrs:{"value":"c","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg013,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg013", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Visitar domicilios particulares al azar.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg013),expression:"eval_tav.pg013"}],attrs:{"value":"d","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg013,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg013", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Visitar domicilios particulares de alumnos de estudios superiores.")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg014==="" ? "color:red" : "color:black")},[_vm._v("14. El vendedor que recoge pedidos de los detallistas tiene normalmente otra misión que es:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg014),expression:"eval_tav.pg014"}],attrs:{"value":"a","name":"group14","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg014,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg014", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Familiarizar al detallista con las normas de los descuentos.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg014),expression:"eval_tav.pg014"}],attrs:{"value":"b","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg014,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg014", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Suministrar muestras gratuitas para su distribución a los clientes.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg014),expression:"eval_tav.pg014"}],attrs:{"value":"c","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg014,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg014", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Reorganizar su muestrario para hacerlo más atractivo.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg014),expression:"eval_tav.pg014"}],attrs:{"value":"d","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg014,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg014", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Organizar un programa de publicidad.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg015==="" ? "color:red" : "color:black")},[_vm._v("15. ¿ Cuál de las siguientes cualidades es la más importante para vender cepillos a domicilio ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg015),expression:"eval_tav.pg015"}],attrs:{"value":"a","name":"group15","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg015,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg015", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Amabilidad.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg015),expression:"eval_tav.pg015"}],attrs:{"value":"b","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg015,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg015", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Buena presentación.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg015),expression:"eval_tav.pg015"}],attrs:{"value":"c","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg015,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg015", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Perseverancia.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg015),expression:"eval_tav.pg015"}],attrs:{"value":"d","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg015,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg015", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Personalidad.")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt5"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg016==="" ? "color:red" : "color:black")},[_vm._v("16. La objeción más frecuente para subscribir un seguro de vida es:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg016),expression:"eval_tav.pg016"}],attrs:{"value":"a","name":"group16","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg016,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg016", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) No. Yo no necesito un seguro de vida.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg016),expression:"eval_tav.pg016"}],attrs:{"value":"b","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg016,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg016", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) ¿ Para qué ? Mi trabajo no es peligroso.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg016),expression:"eval_tav.pg016"}],attrs:{"value":"c","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg016,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg016", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Bueno ... creo que debo pensarlo antes.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg016),expression:"eval_tav.pg016"}],attrs:{"value":"d","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg016,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg016", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Eso estaría bien ... pero no puedo pagarlo.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg017==="" ? "color:red" : "color:black")},[_vm._v("17. Cuando se vende material de oficina, el mejor grupo para lograr clientes es:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg017),expression:"eval_tav.pg017"}],attrs:{"value":"a","name":"group17","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg017,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg017", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Las oficinas con crédito para expansión.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg017),expression:"eval_tav.pg017"}],attrs:{"value":"b","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg017,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg017", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Todas las oficinas situadas en un mismo edificio comercial.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg017),expression:"eval_tav.pg017"}],attrs:{"value":"c","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg017,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg017", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) El grupo de clientes antiguos.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg017),expression:"eval_tav.pg017"}],attrs:{"value":"d","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg017,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg017", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Las oficinas sugeridas por los compradores.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg018==="" ? "color:red" : "color:black")},[_vm._v("18.  ¿ Cuál de los siguientes es el mejor argumento para vender viviendas ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg018),expression:"eval_tav.pg018"}],attrs:{"value":"a","name":"group18","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg018,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg018", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Es un paso dado hacia una independencia de disponibilidades económicas.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg018),expression:"eval_tav.pg018"}],attrs:{"value":"b","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg018,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg018", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Un buen valor inmueble es mejor que una cuenta de ahorro.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg018),expression:"eval_tav.pg018"}],attrs:{"value":"c","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg018,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg018", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) El propietario de su vivienda adquiere crédito para sus negocios.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg018),expression:"eval_tav.pg018"}],attrs:{"value":"d","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg018,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg018", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) La vivienda propia es una inversión rentable.")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg019==="" ? "color:red" : "color:black")},[_vm._v("19. Usted está vendiendo un servicio que, en caso de ser aceptado por su cliente, significaría un cambio en las normas establecidas hace largo tiempo. Un director de empresa se muestra interesado por su oferta, pero le dice que tendrá que comentarlo con los otros directivos ¿ Cuál sería el siguiente paso que usted daría ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg019),expression:"eval_tav.pg019"}],attrs:{"value":"a","name":"group19","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg019,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg019", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Rogarle que le permita saber sobre lo que se decida y después despedirse.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg019),expression:"eval_tav.pg019"}],attrs:{"value":"b","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg019,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg019", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Insistir para que acepte un compromiso previo, apoyándose en que su reacción es favorable.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg019),expression:"eval_tav.pg019"}],attrs:{"value":"c","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg019,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg019", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Continuar la conversación haciendo un breve resumen de modo que quede clara la forma más apropiada de presentar el asunto.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg019),expression:"eval_tav.pg019"}],attrs:{"value":"d","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg019,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg019", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Solicitar una entrevista con los directivos para exponerles el plan personalmente.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg020==="" ? "color:red" : "color:black")},[_vm._v("20. ¿ Cuál de estas causas constituye el motivo más fuerte para dedicarse a la actividad de las ventas ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg020),expression:"eval_tav.pg020"}],attrs:{"value":"a","name":"group20","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg020,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg020", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) La oportunidad de ganar más dinero.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg020),expression:"eval_tav.pg020"}],attrs:{"value":"b","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg020,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg020", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) El deseo de ser uno mismo su propio jefe.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg020),expression:"eval_tav.pg020"}],attrs:{"value":"c","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg020,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg020", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) El deseo de trabar conocimiento amistoso con diversas personas.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg020),expression:"eval_tav.pg020"}],attrs:{"value":"d","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg020,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg020", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) El desagrado por las tareas administrativas.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg021==="" ? "color:red" : "color:black")},[_vm._v("21. El jefe le indica que sus ventas han disminuido. Usted debería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg021),expression:"eval_tav.pg021"}],attrs:{"value":"a","name":"group21","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg021,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg021", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Convencerle de que está trabajando lo mejor que puede.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg021),expression:"eval_tav.pg021"}],attrs:{"value":"b","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg021,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg021", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Hacerle ver que tiene asignado los peores clientes.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg021),expression:"eval_tav.pg021"}],attrs:{"value":"c","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg021,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg021", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Rogarle que le dé algunos consejos para mejorar.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg021),expression:"eval_tav.pg021"}],attrs:{"value":"d","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg021,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg021", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Decirle que, efectivamente, no lo hizo bien, pero que se mejorará inmediatamente.")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg022==="" ? "color:red" : "color:black")},[_vm._v("22. ¿ Cuál es la característica más importante de un técnico de ventas ? Lo mejor sería:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg022),expression:"eval_tav.pg022"}],attrs:{"value":"a","name":"group22","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg022,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg022", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Conocimiento de su producto.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg022),expression:"eval_tav.pg022"}],attrs:{"value":"b","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg022,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg022", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Una agradable personalidad.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg022),expression:"eval_tav.pg022"}],attrs:{"value":"c","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg022,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg022", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Capacidad de inventiva.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg022),expression:"eval_tav.pg022"}],attrs:{"value":"d","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg022,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg022", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Conocimiento de posibilidades y tendencia de los mercados.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg023==="" ? "color:red" : "color:black")},[_vm._v("23. Hay muchos factores implicados en el precio de una vivienda. ¿ Cuál de los siguientes es el más importante ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg023),expression:"eval_tav.pg023"}],attrs:{"value":"a","name":"group23","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg023,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg023", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Cercanía a los lugares de diversión.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg023),expression:"eval_tav.pg023"}],attrs:{"value":"b","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg023,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg023", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Buenas comunicaciones.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg023),expression:"eval_tav.pg023"}],attrs:{"value":"c","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg023,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg023", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Aislamiento e independencia.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg023),expression:"eval_tav.pg023"}],attrs:{"value":"d","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg023,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg023", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Número de personas que desea comprarla.")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg024==="" ? "color:red" : "color:black")},[_vm._v("24. Usted vende, en establecimientos de comestibles, productos envasados en lata. Su jefe le ha indicado que los precios bajarán dentro de dos semanas. ¿ Cuál de las siguientes sería su mejor acción ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg024),expression:"eval_tav.pg024"}],attrs:{"value":"a","name":"group24","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg024,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg024", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Hacer sus visitas regulares y aceptar todos los pedidos sin intentar incrementar las ventas.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg024),expression:"eval_tav.pg024"}],attrs:{"value":"b","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg024,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg024", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Hacer su recorrido regular intentando vender todo lo posible mientras los precios son altos.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg024),expression:"eval_tav.pg024"}],attrs:{"value":"c","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg024,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg024", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Concentrar sus visitas a los más fuertes clientes, advertirles de la baja y aconsejarles que no adquieran más de lo necesario.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg024),expression:"eval_tav.pg024"}],attrs:{"value":"d","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg024,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg024", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Avisar a todos los clientes de su ruta de la próxima baja de precios y sugerirles que pidan solo lo que puedan vender en dos semanas")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg025==="" ? "color:red" : "color:black")},[_vm._v("25. ¿ Cuál es la mejor manera de que un vendedor tome contacto por primera vez con un jefe de compras que es conocido como un cliente difícil ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg025),expression:"eval_tav.pg025"}],attrs:{"value":"a","name":"group25","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg025,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg025", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Comenzar la conversación en un tono humorístico.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg025),expression:"eval_tav.pg025"}],attrs:{"value":"b","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg025,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg025", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Charlar con él sobre el producto como si se tratara de un buen cliente.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg025),expression:"eval_tav.pg025"}],attrs:{"value":"c","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg025,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg025", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Indicarle que usted le atenderá de todos modos aunque no le compre.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg025),expression:"eval_tav.pg025"}],attrs:{"value":"d","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg025,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg025", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Comentar las ventajas y defectos de los productos de la competencia.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg026==="" ? "color:red" : "color:black")},[_vm._v("26. Su firma trabaja con toda clase de papel. El Señor Roldán, dueño de una pequeña fábrica de bebidas refrescantes, ha rogado que le visite un representante de su compañia. ¿ Qué haría usted al entrar en su oficina ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg026),expression:"eval_tav.pg026"}],attrs:{"value":"a","name":"group26","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg026,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg026", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Presentarse y esperar a que él le diga porqué pidió le visitase un representante.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg026),expression:"eval_tav.pg026"}],attrs:{"value":"b","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg026,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg026", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Decirle: \"Nuestros envases rebajarán costes porque son más ligeros y menos rígidos que las botellas\".")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg026),expression:"eval_tav.pg026"}],attrs:{"value":"c","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg026,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg026", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Decirle: \"Nosotros poseemos envases para todas las aplicaciones. Tenemos el tipo que se ajustará perfectamente a sus necesidades\".")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg026),expression:"eval_tav.pg026"}],attrs:{"value":"d","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg026,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg026", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Decirle: \"Antes de que empecemos, Señor Roldán, me gustaría dar un vistazo a su planta. Entonces yo sabré como servirle mejor.")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg027==="" ? "color:red" : "color:black")},[_vm._v("27. Usted está visitando un cliente que le expresa unas opiniones muy extremistas respecto a los sindicatos de trabajo. Si le pregunta su parecer, y usted no está de acuerdo con su punto de vista, ¿ qué deberá hacer ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg027),expression:"eval_tav.pg027"}],attrs:{"value":"a","name":"group27","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg027,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg027", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Mostrarse conforme con él y añadir nuevas razones que apoyen su opinión.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg027),expression:"eval_tav.pg027"}],attrs:{"value":"b","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg027,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg027", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Decirle firmemente, pero correctamente, que usted no comparte su opinión; después cambiar de conversación.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg027),expression:"eval_tav.pg027"}],attrs:{"value":"c","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg027,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg027", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Intentar señalar los puntos débiles de sus argumentos.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg027),expression:"eval_tav.pg027"}],attrs:{"value":"d","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg027,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg027", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Decirle que usted ha pensado suficiente en este asunto.")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg028==="" ? "color:red" : "color:black")},[_vm._v("28. Está usted tratando de vender un sistema de aparatos de aviso, para ser usado en una factoría. Después de que ha empleado todos los posibles argumentos, el cliente se muestra bien dispuesto, pero no plenamente convencido. ¿ Qué debería hacer ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg028),expression:"eval_tav.pg028"}],attrs:{"value":"a","name":"group28","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg028,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg028", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Irse y enviar algunos prospectos sobre el producto tan pronto como le sea posible.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg028),expression:"eval_tav.pg028"}],attrs:{"value":"b","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg028,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg028", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Marcharse y volver lo antes posible con un \"especialista\" para intentar convencerle.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg028),expression:"eval_tav.pg028"}],attrs:{"value":"c","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg028,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg028", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Quedarse e insistir de nuevo en sus argumentos.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg028),expression:"eval_tav.pg028"}],attrs:{"value":"d","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg028,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg028", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Quedarse y decirle que usted no puede comprender porqué no está convencido del valor del producto.")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg029==="" ? "color:red" : "color:black")},[_vm._v("29. Usted es un vendedor reciente y mantiene su primera entrevista con un experimentado y sutil comprador. El le hace una pregunta, acerca de su producto, que usted no está en lo absoluto preparado para contestar. ¿ Qué haría ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg029),expression:"eval_tav.pg029"}],attrs:{"value":"a","name":"group29","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg029,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg029", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Inventar un respuesta de modo que él no se de cuenta de sus escasos conocimientos del producto.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg029),expression:"eval_tav.pg029"}],attrs:{"value":"b","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg029,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg029", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Evadirse del asunto intentando un nuevo tema de conversación.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg029),expression:"eval_tav.pg029"}],attrs:{"value":"c","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg029,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg029", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Decirle que usted no lo sabe porque es nuevo; pero que puede después enviarle información poniéndose en contacto con la oficina central.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg029),expression:"eval_tav.pg029"}],attrs:{"value":"d","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg029,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg029", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Contestarle que eso no es demasiado importante y continuar con alguna otra información del producto.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_tav.pg030==="" ? "color:red" : "color:black")},[_vm._v("30. ¿ Cuál de las siguientes acciones es la MEJOR, para demostrar la eficacia de un vendedor ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg030),expression:"eval_tav.pg030"}],attrs:{"value":"a","name":"group30","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_tav.pg030,"a")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg030", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Visitar a quienes lógicamente pueden ser clientes.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg030),expression:"eval_tav.pg030"}],attrs:{"value":"b","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg030,"b")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg030", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Persuadir y lograr que la gente compre su producto.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg030),expression:"eval_tav.pg030"}],attrs:{"value":"c","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg030,"c")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg030", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Saber como tratar a las personas.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_tav.pg030),expression:"eval_tav.pg030"}],attrs:{"value":"d","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_tav.pg030,"d")},on:{"change":function($event){_vm.$set(_vm.eval_tav, "pg030", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) Convencer a la gente de que necesitan su producto.")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grabado===false),expression:"grabado===false"}],staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn tooltipped",attrs:{"data-position":"left","data-tooltip":"Grabar"},on:{"click":function($event){_vm.agregarEvaluacion()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-body"},[_c('div',{attrs:{"align":"justify"}},[_vm._v("\n                            Señor aspirante a empleo: Este es un cuestionario de sus actitudes. Lo que hace o lo que piensa acerca de ciertas situaciones. Las personas piensan de una manera u otra. Por lo tanto, no existen respuestas \"correctas\" o \"incorrectas\" a las preguntas. \n                            \n                            Se ofrecen cuatro (4) posibles respuestas para cada pregunta, que Ud. debe contestar \"A\" o \"B\" o \"C\" o \"D\" seleccionando con el mouse en la correspondiente respuesta. Las preguntas están organizadas en dos (2) secciones. Sección 1: De la 1 a la 15, Sección 2: de la 16 a la 30."),_c('br'),_c('br'),_vm._v("\n                              \n                            Inicialmente todas las preguntas estarán en color "),_c('span',{staticStyle:{"font-weight":"bold","color":"red"}},[_vm._v("rojo")]),_vm._v(" como indicador\n                            que aún no han sido respondidas. Conforme vaya respondiendo, las preguntas se mostrarán en color negro. También tendrá un mensaje indicándole la cantidad \n                            de preguntas que aún no han sido respondidas. El siguiente "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("ejemplo")]),_vm._v(" de tres preguntas le permitirá estar seguro que comprende lo que debe hacer en el propio cuestionario."),_c('br'),_vm._v(" "),_c('div',{staticClass:"center"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("SELECCIONE EL SIGUIENTE BOTON PARA EMPEZAR LA EVALUACION.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev08_solemp_js__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5cac144_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev08_solemp_vue__ = __webpack_require__(335);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev08_solemp_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5cac144_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev08_solemp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:" col s4"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.empresa),expression:"eval_solemp.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_solemp.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s4"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.nombre),expression:"eval_solemp.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_solemp.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s1"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para LEER u OCULTAR las instrucciones.","data-position":"top"}},[_vm._v("\n                            "+_vm._s(_vm.instrucciones)+"\n                        ")])]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12"},[_c('div',{staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("Empezar Evaluación de SOLICITUD DE EMPLEO")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s12 l12"},[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"tabs "},[_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-size":"12px","font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt4"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("Personales")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-size":"12.5px","font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt5"},on:{"click":function($event){_vm.nadaG1(2)}}},[_vm._v("Familiares")])]),_vm._v(" "),_c('li',{staticClass:"tab col s2"},[_c('a',{ref:"testtt3",class:_vm.activott3,staticStyle:{"font-size":"13px","font-weight":"bold"},attrs:{"id":"testtt3","href":"#testt6"},on:{"click":function($event){_vm.nadaG1(3)}}},[_vm._v("Socioeconómicos")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1.5"},[_c('a',{ref:"testtt4",class:_vm.activott4,staticStyle:{"font-size":"12px","font-weight":"bold"},attrs:{"id":"testtt4","href":"#testt7"},on:{"click":function($event){_vm.nadaG1(4)}}},[_vm._v("Académicos")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt5",class:_vm.activott5,staticStyle:{"font-size":"12.5px","font-weight":"bold"},attrs:{"id":"testtt5","href":"#testt8"},on:{"click":function($event){_vm.nadaG1(5)}}},[_vm._v("Laboral-1")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt6",class:_vm.activott6,staticStyle:{"font-size":"12.5px","font-weight":"bold"},attrs:{"id":"testtt6","href":"#testt9"},on:{"click":function($event){_vm.nadaG1(6)}}},[_vm._v("Laboral-2")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt7",class:_vm.activott7,staticStyle:{"font-size":"12.5px","font-weight":"bold"},attrs:{"id":"testtt7","href":"#testt10"},on:{"click":function($event){_vm.nadaG1(7)}}},[_vm._v("Laboral-3")])]),_vm._v(" "),_c('li',{staticClass:"tab col s2"},[_c('a',{ref:"testtt8",class:_vm.activott8,staticStyle:{"font-size":"13px","font-weight":"bold"},attrs:{"id":"testtt8","href":"#testt11"},on:{"click":function($event){_vm.nadaG1(8)}}},[_vm._v("Extralaborales")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1.5"},[_c('a',{ref:"testtt9",class:_vm.activott9,staticStyle:{"font-size":"12px","font-weight":"bold"},attrs:{"id":"testtt9","href":"#testt12"},on:{"click":function($event){_vm.nadaG1(9)}}},[_vm._v("Referencias")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt4"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("01. NOMBRES Y APELLIDOS COMPLETOS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg001),expression:"eval_solemp.pg001"}],attrs:{"type":"text","name":"ncompleto"},domProps:{"value":(_vm.eval_solemp.pg001)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg001", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("02. LUGAR DE NACIMIENTO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg002),expression:"eval_solemp.pg002"}],attrs:{"type":"text","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg002)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg002", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("03. FECHA NACIMIENTO")]),_vm._v(" "),_c('input-date',{model:{value:(_vm.eval_naci),callback:function ($$v) {_vm.eval_naci=$$v},expression:"eval_naci"}})],1),_vm._v(" "),_c('div',{staticClass:" col s1"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("04. EDAD")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg004),expression:"eval_solemp.pg004"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg004)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg004", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("05. DPI")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg005),expression:"eval_solemp.pg005"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg005)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg005", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("06. EXTENDIDO EN")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg006),expression:"eval_solemp.pg006"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg006)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg006", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("07. No. AFILIACION IGSS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg007),expression:"eval_solemp.pg007"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_solemp.pg007)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg007", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticClass:"input-group-addon",staticStyle:{"font-size":"14px"}},[_vm._v("08. NIT")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg008),expression:"eval_solemp.pg008"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_solemp.pg008)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg008", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg009),expression:"eval_solemp.pg009"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.eval_solemp, "pg009", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Estado Civil ?")]),_vm._v(" "),_vm._l((_vm.estados),function(estado){return _c('option',{domProps:{"value":estado.value}},[_vm._v("\n                                         "+_vm._s(estado.text)+"\n                                    ")])})],2),_vm._v(" "),_c('label',[_vm._v("Estado Civil: "+_vm._s(_vm.eval_solemp.pg009))])]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg010),expression:"eval_solemp.pg010"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.eval_solemp, "pg010", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Nacionalidad ?")]),_vm._v(" "),_vm._l((_vm.nacionalidades),function(nacionalidad){return _c('option',{domProps:{"value":nacionalidad.value}},[_vm._v("\n                                         "+_vm._s(nacionalidad.text)+"\n                                    ")])})],2),_vm._v(" "),_c('label',[_vm._v("Nacionalidad: "+_vm._s(_vm.eval_solemp.pg010))])]),_vm._v(" "),_c('div',{staticClass:" col s8"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("11. PROFESION U OFICIO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg011),expression:"eval_solemp.pg011"}],attrs:{"type":"text","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg011)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg011", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("12. DIRECCION ACTUAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg012),expression:"eval_solemp.pg012"}],attrs:{"type":"text","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg012)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg012", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("13. E-MAIL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg013),expression:"eval_solemp.pg013"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_solemp.pg013)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg013", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("14. TELEFONO DOMICILIO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg014),expression:"eval_solemp.pg014"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_solemp.pg014)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg014", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("15. TELEFONO CELULAR")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg015),expression:"eval_solemp.pg015"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_solemp.pg015)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg015", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt5"}},[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("16. NOMBRE DEL PADRE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg016),expression:"eval_solemp.pg016"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg016)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg016", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("17. TELEFONO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg017),expression:"eval_solemp.pg017"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg017)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg017", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("18. LUGAR DEL TRABAJO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg018),expression:"eval_solemp.pg018"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg018)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg018", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("19. NOMBRE DE LA MADRE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg019),expression:"eval_solemp.pg019"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg019)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg019", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("20. TELEFONO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg020),expression:"eval_solemp.pg020"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg020)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg020", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("21. LUGAR DEL TRABAJO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg021),expression:"eval_solemp.pg021"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg021)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg021", $event.target.value)}}})]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("22. No. DE HERMANOS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg022),expression:"eval_solemp.pg022"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg022)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg022", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s10"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("23. PROFESIONES DE LOS HERMANOS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg023),expression:"eval_solemp.pg023"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg023)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg023", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("24. No. DE CARGAS FAMILIARES")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg024),expression:"eval_solemp.pg024"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg024)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg024", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s10"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("25. DESCRIBA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg025),expression:"eval_solemp.pg025"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg025)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg025", $event.target.value)}}})]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:" col s4"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("26. NOMBRE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg026),expression:"eval_solemp.pg026"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg026)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg026", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s8"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("27. OCUPACION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg027),expression:"eval_solemp.pg027"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg027)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg027", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("28. LUGAR DEL TRABAJO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg028),expression:"eval_solemp.pg028"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg028)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg028", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s10"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("29. DIRECCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg029),expression:"eval_solemp.pg029"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg029)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg029", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("30. TELEFONOS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg030),expression:"eval_solemp.pg030"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg030)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg030", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("31. CARGO QUE OCUPA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg031),expression:"eval_solemp.pg031"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg031)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg031", $event.target.value)}}})]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("32. NOMBRE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg032),expression:"eval_solemp.pg032"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg032)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg032", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s1"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("33. EDAD")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg033),expression:"eval_solemp.pg033"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg033)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg033", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("34. ESCOLARIDAD")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg034),expression:"eval_solemp.pg034"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg034)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg034", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s5"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("35. INSTITUCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg035),expression:"eval_solemp.pg035"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg035)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg035", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("36. NOMBRE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg036),expression:"eval_solemp.pg036"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg036)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg036", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s1"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("37. EDAD")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg037),expression:"eval_solemp.pg037"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg037)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg037", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("38. ESCOLARIDAD")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg038),expression:"eval_solemp.pg038"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg038)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg038", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s5"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("39. INSTITUCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg039),expression:"eval_solemp.pg039"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg039)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg039", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("40. NOMBRE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg040),expression:"eval_solemp.pg040"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg040)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg040", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s1"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("41. EDAD")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg041),expression:"eval_solemp.pg041"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg041)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg041", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("42. ESCOLARIDAD")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg042),expression:"eval_solemp.pg042"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg042)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg042", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s5"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("43. INSTITUCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg043),expression:"eval_solemp.pg043"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg043)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg043", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("44. NOMBRE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg044),expression:"eval_solemp.pg044"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg044)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg044", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s1"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("45. EDAD")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg045),expression:"eval_solemp.pg045"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg045)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg045", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("46. ESCOLARIDAD")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg046),expression:"eval_solemp.pg046"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg046)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg046", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s5"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("47. INSTITUCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg047),expression:"eval_solemp.pg047"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg047)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg047", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(1)}}},[_vm._m(9)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(3)}}},[_vm._m(10)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt3),expression:"vertt3"}],ref:"testt3",attrs:{"id":"testt6"}},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('span',[_vm._v("48. Vive en casa propia ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg048),expression:"eval_solemp.pg048"}],attrs:{"value":"si","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg048,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg048", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg048),expression:"eval_solemp.pg048"}],attrs:{"value":"no","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg048,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg048", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])])]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('span',[_vm._v("49. Alquila ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg049),expression:"eval_solemp.pg049"}],attrs:{"value":"si","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg049,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg049", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg049),expression:"eval_solemp.pg049"}],attrs:{"value":"no","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg049,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg049", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])])]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('span',[_vm._v("50. Vive en con sus padres ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg050),expression:"eval_solemp.pg050"}],attrs:{"value":"si","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg050,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg050", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg050),expression:"eval_solemp.pg050"}],attrs:{"value":"no","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg050,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg050", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])])]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('span',[_vm._v("51. Tiene vehículo propio ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg051),expression:"eval_solemp.pg051"}],attrs:{"value":"si","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg051,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg051", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg051),expression:"eval_solemp.pg051"}],attrs:{"value":"no","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg051,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg051", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])])]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("52. MARCA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg052),expression:"eval_solemp.pg052"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_solemp.pg052)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg052", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("53. MODELO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg053),expression:"eval_solemp.pg053"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_solemp.pg053)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg053", $event.target.value)}}}),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('span',[_vm._v("54. Recibe otros ingresos que no sean su sueldo ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg054),expression:"eval_solemp.pg054"}],attrs:{"value":"si","name":"group6","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg054,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg054", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg054),expression:"eval_solemp.pg054"}],attrs:{"value":"no","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg054,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg054", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])])]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("55. MONTO Q.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg055),expression:"eval_solemp.pg055"}],attrs:{"type":"number"},domProps:{"value":(_vm.eval_solemp.pg055)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg055", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("56. DE DONDE PROCEDE ESTE INGRESO ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg056),expression:"eval_solemp.pg056"}],attrs:{"type":"text","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg056)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg056", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s2"},[_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(2)}}},[_vm._m(12)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(4)}}},[_vm._m(13)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt4),expression:"vertt4"}],ref:"testt4",attrs:{"id":"testt7"}},[_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("57. INSTITUCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg057),expression:"eval_solemp.pg057"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg057)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg057", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s7"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("58. GRADO OBTENIDO Y TITULO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg058),expression:"eval_solemp.pg058"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg058)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg058", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("59. FECHA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg059),expression:"eval_solemp.pg059"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg059)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg059", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("60. INSTITUCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg060),expression:"eval_solemp.pg060"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg060)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg060", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s7"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("61. GRADO OBTENIDO Y TITULO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg061),expression:"eval_solemp.pg061"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg061)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg061", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("62. FECHA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg062),expression:"eval_solemp.pg062"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg062)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg062", $event.target.value)}}})]),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("63. INSTITUCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg063),expression:"eval_solemp.pg063"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg063)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg063", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s7"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("64. GRADO OBTENIDO Y TITULO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg064),expression:"eval_solemp.pg064"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg064)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg064", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("65. FECHA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg065),expression:"eval_solemp.pg065"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg065)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg065", $event.target.value)}}})]),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("66. INSTITUCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg066),expression:"eval_solemp.pg066"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg066)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg066", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s7"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("67. GRADO OBTENIDO Y TITULO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg067),expression:"eval_solemp.pg067"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg067)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg067", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("68. FECHA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg068),expression:"eval_solemp.pg068"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg068)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg068", $event.target.value)}}})]),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("69. CURSOS RELACIONADOS CON SU PROFESION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg069),expression:"eval_solemp.pg069"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg069)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg069", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("70. CONOCIMIENTOS O HABILIDADES QUE POSEE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg070),expression:"eval_solemp.pg070"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg070)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg070", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("71. PREMIOS O MENCIONES HONORIFICAS OBTENIDAS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg071),expression:"eval_solemp.pg071"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg071)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg071", $event.target.value)}}})]),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('div',{staticClass:" col s1"},[_c('span',[_vm._v("72. Estudia ? ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg072),expression:"eval_solemp.pg072"}],attrs:{"value":"si","name":"group7","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg072,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg072", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg072),expression:"eval_solemp.pg072"}],attrs:{"value":"no","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg072,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg072", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])])]),_vm._v(" "),_c('div',{staticClass:" col s11"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("73. ESPECIFIQUE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg073),expression:"eval_solemp.pg073"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg073)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg073", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("74. HORARIO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg074),expression:"eval_solemp.pg074"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg074)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg074", $event.target.value)}}})]),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("75. IDIOMA ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg075),expression:"eval_solemp.pg075"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg075)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg075", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s4"},[_c('span',[_vm._v("76. Lee ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg076),expression:"eval_solemp.pg076"}],attrs:{"value":"25","name":"group8","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg076,"25")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg076", "25")}}}),_vm._v(" "),_c('span',[_vm._v("(a) 25%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg076),expression:"eval_solemp.pg076"}],attrs:{"value":"50","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg076,"50")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg076", "50")}}}),_vm._v(" "),_c('span',[_vm._v("(b) 50%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg076),expression:"eval_solemp.pg076"}],attrs:{"value":"75","name":"group8","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg076,"75")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg076", "75")}}}),_vm._v(" "),_c('span',[_vm._v("(c) 75%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg076),expression:"eval_solemp.pg076"}],attrs:{"value":"100","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg076,"100")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg076", "100")}}}),_vm._v(" "),_c('span',[_vm._v("(d) 100%")])])])]),_vm._v(" "),_c('div',{staticClass:" col s4"},[_c('span',[_vm._v("77. Escribe ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg077),expression:"eval_solemp.pg077"}],attrs:{"value":"25","name":"group9","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg077,"25")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg077", "25")}}}),_vm._v(" "),_c('span',[_vm._v("(a) 25%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg077),expression:"eval_solemp.pg077"}],attrs:{"value":"50","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg077,"50")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg077", "50")}}}),_vm._v(" "),_c('span',[_vm._v("(b) 50%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg077),expression:"eval_solemp.pg077"}],attrs:{"value":"75","name":"group9","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg077,"75")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg077", "75")}}}),_vm._v(" "),_c('span',[_vm._v("(c) 75%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg077),expression:"eval_solemp.pg077"}],attrs:{"value":"100","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg077,"100")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg077", "100")}}}),_vm._v(" "),_c('span',[_vm._v("(d) 100%")])])])]),_vm._v(" "),_c('div',{staticClass:" col s4"},[_c('span',[_vm._v("78. Conversa ? ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg078),expression:"eval_solemp.pg078"}],attrs:{"value":"25","name":"group10","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg078,"25")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg078", "25")}}}),_vm._v(" "),_c('span',[_vm._v("(a) 25%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg078),expression:"eval_solemp.pg078"}],attrs:{"value":"50","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg078,"50")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg078", "50")}}}),_vm._v(" "),_c('span',[_vm._v("(b) 50%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg078),expression:"eval_solemp.pg078"}],attrs:{"value":"75","name":"group10","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg078,"75")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg078", "75")}}}),_vm._v(" "),_c('span',[_vm._v("(c) 75%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg078),expression:"eval_solemp.pg078"}],attrs:{"value":"100","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg078,"100")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg078", "100")}}}),_vm._v(" "),_c('span',[_vm._v("(d) 100%")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12"}),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("79. IDIOMA ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg079),expression:"eval_solemp.pg079"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg079)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg079", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s4"},[_c('span',[_vm._v("80. Lee ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg080),expression:"eval_solemp.pg080"}],attrs:{"value":"25","name":"group11","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg080,"25")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg080", "25")}}}),_vm._v(" "),_c('span',[_vm._v("(a) 25%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg080),expression:"eval_solemp.pg080"}],attrs:{"value":"50","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg080,"50")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg080", "50")}}}),_vm._v(" "),_c('span',[_vm._v("(b) 50%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg080),expression:"eval_solemp.pg080"}],attrs:{"value":"75","name":"group11","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg080,"75")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg080", "75")}}}),_vm._v(" "),_c('span',[_vm._v("(c) 75%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg080),expression:"eval_solemp.pg080"}],attrs:{"value":"100","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg080,"100")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg080", "100")}}}),_vm._v(" "),_c('span',[_vm._v("(d) 100%")])])])]),_vm._v(" "),_c('div',{staticClass:" col s4"},[_c('span',[_vm._v("81. Escribe ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg081),expression:"eval_solemp.pg081"}],attrs:{"value":"25","name":"group12","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg081,"25")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg081", "25")}}}),_vm._v(" "),_c('span',[_vm._v("(a) 25%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg081),expression:"eval_solemp.pg081"}],attrs:{"value":"50","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg081,"50")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg081", "50")}}}),_vm._v(" "),_c('span',[_vm._v("(b) 50%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg081),expression:"eval_solemp.pg081"}],attrs:{"value":"75","name":"group12","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg081,"75")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg081", "75")}}}),_vm._v(" "),_c('span',[_vm._v("(c) 75%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg081),expression:"eval_solemp.pg081"}],attrs:{"value":"100","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg081,"100")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg081", "100")}}}),_vm._v(" "),_c('span',[_vm._v("(d) 100%")])])])]),_vm._v(" "),_c('div',{staticClass:" col s4"},[_c('span',[_vm._v("82. Conversa ? ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg082),expression:"eval_solemp.pg082"}],attrs:{"value":"25","name":"group13","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg082,"25")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg082", "25")}}}),_vm._v(" "),_c('span',[_vm._v("(a) 25%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg082),expression:"eval_solemp.pg082"}],attrs:{"value":"50","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg082,"50")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg082", "50")}}}),_vm._v(" "),_c('span',[_vm._v("(b) 50%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg082),expression:"eval_solemp.pg082"}],attrs:{"value":"75","name":"group13","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg082,"75")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg082", "75")}}}),_vm._v(" "),_c('span',[_vm._v("(c) 75%")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg082),expression:"eval_solemp.pg082"}],attrs:{"value":"100","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg082,"100")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg082", "100")}}}),_vm._v(" "),_c('span',[_vm._v("(d) 100%")])])])]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(3)}}},[_vm._m(21)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(5)}}},[_vm._m(22)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt5),expression:"vertt5"}],ref:"testt5",attrs:{"id":"testt8"}},[_vm._m(23),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("83. NOMBRE DE LA EMPRESA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg083),expression:"eval_solemp.pg083"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg083)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg083", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s10"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("84. DIRECCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg084),expression:"eval_solemp.pg084"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg084)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg084", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("85. TELEFONO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg085),expression:"eval_solemp.pg085"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg085)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg085", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("86. GIRO DEL NEGOCIO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg086),expression:"eval_solemp.pg086"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg086)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg086", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("87. FECHA DE INGRESO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg087),expression:"eval_solemp.pg087"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg087)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg087", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("88. FECHA DE EGRESO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg088),expression:"eval_solemp.pg088"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg088)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg088", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('span',[_vm._v("89. Está trabajando actualmente ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg089),expression:"eval_solemp.pg089"}],attrs:{"value":"si","name":"group14","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg089,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg089", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg089),expression:"eval_solemp.pg089"}],attrs:{"value":"no","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg089,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg089", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])])]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("90. CARGO INICIAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg090),expression:"eval_solemp.pg090"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg090)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg090", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("91. CARGO FINAL O ACTUAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg091),expression:"eval_solemp.pg091"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg091)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg091", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("92. SALARIO INICIAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg092),expression:"eval_solemp.pg092"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg092)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg092", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("93. SALARIO FINAL O ACTUAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg093),expression:"eval_solemp.pg093"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg093)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg093", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("94. OTRAS PRESTACIONES ADICIONALES A LAS DE LEY (ALMUERZOS, GASOLINA, U OTROS BENEFICIOS)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg094),expression:"eval_solemp.pg094"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg094)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg094", $event.target.value)}}})]),_vm._v(" "),_vm._m(24),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("95. FUNCION 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg095),expression:"eval_solemp.pg095"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg095)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg095", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("96. FUNCION 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg096),expression:"eval_solemp.pg096"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg096)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg096", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("97. FUNCION 3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg097),expression:"eval_solemp.pg097"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg097)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg097", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("98. FUNCION 4")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg098),expression:"eval_solemp.pg098"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg098)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg098", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("99. FUNCION 5")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg099),expression:"eval_solemp.pg099"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg099)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg099", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("100. FUNCION 6")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg100),expression:"eval_solemp.pg100"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg100)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg100", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s5"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("101. NOMBRE DE SU JEFE INMEDIATO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg101),expression:"eval_solemp.pg101"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg101)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg101", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s5"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("102. PUESTO DE SU JEFE INMEDIATO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg102),expression:"eval_solemp.pg102"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg102)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg102", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("103. No. DE PERSONAS A SU CARGO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg103),expression:"eval_solemp.pg103"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg103)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg103", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("104. MOTIVO DE SU RETIRO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg104),expression:"eval_solemp.pg104"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg104)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg104", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('span',[_vm._v("105. Podemos pedir Referencias ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg105),expression:"eval_solemp.pg105"}],attrs:{"value":"si","name":"group15","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg105,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg105", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg105),expression:"eval_solemp.pg105"}],attrs:{"value":"no","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg105,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg105", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])])]),_vm._v(" "),_c('div',{staticClass:" col s10"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("106. PORQUE ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg106),expression:"eval_solemp.pg106"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg106)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg106", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(4)}}},[_vm._m(25)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(6)}}},[_vm._m(26)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt6),expression:"vertt6"}],ref:"testt6",attrs:{"id":"testt9"}},[_vm._m(27),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("107. NOMBRE DE LA EMPRESA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg107),expression:"eval_solemp.pg107"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg107)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg107", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s10"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("108. DIRECCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg108),expression:"eval_solemp.pg108"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg108)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg108", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("109. TELEFONO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg109),expression:"eval_solemp.pg109"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg109)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg109", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("110. GIRO DEL NEGOCIO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg110),expression:"eval_solemp.pg110"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg110)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg110", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("111. FECHA DE INGRESO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg111),expression:"eval_solemp.pg111"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg111)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg111", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("112. FECHA DE EGRESO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg112),expression:"eval_solemp.pg112"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg112)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg112", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('span',[_vm._v("113. Trabaja actualmente ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg113),expression:"eval_solemp.pg113"}],attrs:{"value":"si","name":"group16","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg113,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg113", "si")}}}),_vm._v(" "),_c('span',[_vm._v("Sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg113),expression:"eval_solemp.pg113"}],attrs:{"value":"no","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg113,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg113", "no")}}}),_vm._v(" "),_c('span',[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("114. CARGO INICIAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg114),expression:"eval_solemp.pg114"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg114)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg114", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("115. CARGO FINAL O ACTUAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg115),expression:"eval_solemp.pg115"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg115)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg115", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("116. SALARIO INICIAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg116),expression:"eval_solemp.pg116"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg116)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg116", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("117. SALARIO FINAL O ACTUAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg117),expression:"eval_solemp.pg117"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg117)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg117", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s8"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("118. OTRAS PRESTACIONES ADICIONALES A LAS DE LEY (ALMUERZOS, GASOLINA, U OTROS BENEFICIOS)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg118),expression:"eval_solemp.pg118"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg118)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg118", $event.target.value)}}})]),_vm._v(" "),_vm._m(28),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("119. FUNCION 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg119),expression:"eval_solemp.pg119"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg119)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg119", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("120. FUNCION 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg120),expression:"eval_solemp.pg120"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg120)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg120", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("121. FUNCION 3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg121),expression:"eval_solemp.pg121"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg121)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg121", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("122. FUNCION 4")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg122),expression:"eval_solemp.pg122"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg122)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg122", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("123. FUNCION 5")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg123),expression:"eval_solemp.pg123"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg123)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg123", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("124. FUNCION 6")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg124),expression:"eval_solemp.pg124"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg124)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg124", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s5"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("125. NOMBRE DE SU JEFE INMEDIATO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg125),expression:"eval_solemp.pg125"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg125)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg125", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s5"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("126. PUESTO DE SU JEFE INMEDIATO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg126),expression:"eval_solemp.pg126"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg126)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg126", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("127. No. DE PERSONAS A SU CARGO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg127),expression:"eval_solemp.pg127"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg127)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg127", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("128. MOTIVO DE SU RETIRO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg128),expression:"eval_solemp.pg128"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg128)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg128", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('span',[_vm._v("129. Podemos pedir Referencias ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg129),expression:"eval_solemp.pg129"}],attrs:{"value":"si","name":"group17","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg129,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg129", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg129),expression:"eval_solemp.pg129"}],attrs:{"value":"no","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg129,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg129", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])])]),_vm._v(" "),_c('div',{staticClass:"col s10"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("130. PORQUE ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg130),expression:"eval_solemp.pg130"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg130)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg130", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(5)}}},[_vm._m(29)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(7)}}},[_vm._m(30)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt7),expression:"vertt7"}],ref:"testt7",attrs:{"id":"testt10"}},[_vm._m(31),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("131. NOMBRE DE LA EMPRESA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg131),expression:"eval_solemp.pg131"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg131)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg131", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s10"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("132. DIRECCION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg132),expression:"eval_solemp.pg132"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg132)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg132", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("133. TELEFONO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg133),expression:"eval_solemp.pg133"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg133)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg133", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("134. GIRO DEL NEGOCIO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg134),expression:"eval_solemp.pg134"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg134)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg134", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("135. FECHA DE INGRESO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg135),expression:"eval_solemp.pg135"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg135)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg135", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("136. FECHA DE EGRESO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg136),expression:"eval_solemp.pg136"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg136)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg136", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('span',[_vm._v("137. Trabaja actualmente ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg137),expression:"eval_solemp.pg137"}],attrs:{"value":"si","name":"group19","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg137,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg137", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg137),expression:"eval_solemp.pg137"}],attrs:{"value":"no","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg137,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg137", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])]),_vm._v(" "),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("138. CARGO INICIAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg138),expression:"eval_solemp.pg138"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg138)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg138", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("139. CARGO FINAL O ACTUAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg139),expression:"eval_solemp.pg139"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg139)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg139", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("140. SALARIO INICIAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg140),expression:"eval_solemp.pg140"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg140)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg140", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("141. SALARIO FINAL O ACTUAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg141),expression:"eval_solemp.pg141"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg141)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg141", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s8"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("142. OTRAS PRESTACIONES ADICIONALES A LAS DE LEY (ALMUERZOS, GASOLINA, U OTROS BENEFICIOS)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg142),expression:"eval_solemp.pg142"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg142)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg142", $event.target.value)}}})]),_vm._v(" "),_vm._m(32),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("143. FUNCION 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg143),expression:"eval_solemp.pg143"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg143)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg143", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("144. FUNCION 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg144),expression:"eval_solemp.pg144"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg144)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg144", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("145. FUNCION 3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg145),expression:"eval_solemp.pg145"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg145)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg145", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("146. FUNCION 4")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg146),expression:"eval_solemp.pg146"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg146)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg146", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("147. FUNCION 5")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg147),expression:"eval_solemp.pg147"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg147)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg147", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("148. FUNCION 6")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg148),expression:"eval_solemp.pg148"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg148)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg148", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s5"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("149. NOMBRE DE SU JEFE INMEDIATO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg149),expression:"eval_solemp.pg149"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg149)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg149", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s5"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("150. PUESTO DE SU JEFE INMEDIATO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg150),expression:"eval_solemp.pg150"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg150)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg150", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v("151. No. DE PERSONAS A SU CARGO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg151),expression:"eval_solemp.pg151"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg151)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg151", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("152. MOTIVO DE SU RETIRO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg152),expression:"eval_solemp.pg152"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg152)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg152", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('span',[_vm._v("153. Podemos pedir Referencias ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg153),expression:"eval_solemp.pg153"}],attrs:{"value":"si","name":"group20","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg153,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg153", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg153),expression:"eval_solemp.pg153"}],attrs:{"value":"no","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg153,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg153", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])])]),_vm._v(" "),_c('div',{staticClass:" col s10"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("154. PORQUE ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg154),expression:"eval_solemp.pg154"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg154)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg154", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(6)}}},[_vm._m(33)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(8)}}},[_vm._m(34)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt8),expression:"vertt8"}],ref:"testt8",attrs:{"id":"testt11"}},[_vm._m(35),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("155. ORGANIZACION 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg155),expression:"eval_solemp.pg155"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg155)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg155", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("156. ORGANIZACION 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg156),expression:"eval_solemp.pg156"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg156)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg156", $event.target.value)}}})]),_vm._v(" "),_vm._m(36),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("157. DEPORTE O PASATIEMPO 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg157),expression:"eval_solemp.pg157"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg157)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg157", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("158. DEPORTE O PASATIEMPO 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg158),expression:"eval_solemp.pg158"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg158)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg158", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("159. DEPORTE O PASATIEMPO 3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg159),expression:"eval_solemp.pg159"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg159)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg159", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("160. DEPORTE O PASATIEMPO 4")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg160),expression:"eval_solemp.pg160"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg160)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg160", $event.target.value)}}})]),_vm._v(" "),_vm._m(37),_vm._v(" "),_c('div',{staticClass:" col s5"},[_c('span',[_vm._v("161. HA PADECIDO DE ALGUNA ENFERMEDAD LOS ULTIMOS 3 AÑOS ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg161),expression:"eval_solemp.pg161"}],attrs:{"value":"si","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg161,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg161", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg161),expression:"eval_solemp.pg161"}],attrs:{"value":"no","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg161,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg161", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])])]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("162. ESPECIFIQUE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg162),expression:"eval_solemp.pg162"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg162)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg162", $event.target.value)}}})]),_vm._v(" "),_vm._m(38),_vm._v(" "),_c('div',{staticClass:" col s10"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("163. PUESTO AL QUE APLICA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg163),expression:"eval_solemp.pg163"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg163)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg163", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("164. EXPECTATIVA SALARIAL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg164),expression:"eval_solemp.pg164"}],attrs:{"type":"number","value":""},domProps:{"value":(_vm.eval_solemp.pg164)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg164", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('span',[_vm._v("165. TIENE LIMITACIONES DE HORARIO ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg165),expression:"eval_solemp.pg165"}],attrs:{"value":"si","name":"group21","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg165,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg165", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg165),expression:"eval_solemp.pg165"}],attrs:{"value":"no","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg165,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg165", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])])]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("166. ESPECIFIQUE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg166),expression:"eval_solemp.pg166"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg166)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg166", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("167. ESTA DISPONIBLE INMEDIATAMENTE O APARTIR DE QUE FECHA ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg167),expression:"eval_solemp.pg167"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg167)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg167", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s4"},[_c('span',[_vm._v("168. ESTA DISPUESTO A VIAJAR COMO PARTE DE SU TRABAJO ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg168),expression:"eval_solemp.pg168"}],attrs:{"value":"si","name":"group22","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg168,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg168", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg168),expression:"eval_solemp.pg168"}],attrs:{"value":"no","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg168,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg168", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])])]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('span',[_vm._v("169. TIENE PASAPORTE ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg169),expression:"eval_solemp.pg169"}],attrs:{"value":"si","name":"group23","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg169,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg169", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg169),expression:"eval_solemp.pg169"}],attrs:{"value":"no","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg169,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg169", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])])]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("170. NUMERO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg170),expression:"eval_solemp.pg170"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg170)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg170", $event.target.value)}}})]),_vm._v(" "),_vm._m(39),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("171. HA TENIDO PROBLEMAS CON LA JUSTICIA ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg171),expression:"eval_solemp.pg171"}],attrs:{"value":"si","name":"group24","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg171,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg171", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg171),expression:"eval_solemp.pg171"}],attrs:{"value":"no","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg171,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg171", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])])]),_vm._v(" "),_c('div',{staticClass:" col s10"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("172. EXPLIQUE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg172),expression:"eval_solemp.pg172"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg172)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg172", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("173. HAY DEUDAS DE ALGUNA NATURALEZA ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg173),expression:"eval_solemp.pg173"}],attrs:{"value":"si","name":"group25","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg173,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg173", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg173),expression:"eval_solemp.pg173"}],attrs:{"value":"no","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg173,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg173", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])])]),_vm._v(" "),_c('div',{staticClass:" col s"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("174. EXPLIQUE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg174),expression:"eval_solemp.pg174"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg174)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg174", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('span',[_vm._v("175. TIENE TATUAJES ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg175),expression:"eval_solemp.pg175"}],attrs:{"value":"si","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_solemp.pg175,"si")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg175", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg175),expression:"eval_solemp.pg175"}],attrs:{"value":"no","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_solemp.pg175,"no")},on:{"change":function($event){_vm.$set(_vm.eval_solemp, "pg175", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) no")])])])]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(7)}}},[_vm._m(40)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(9)}}},[_vm._m(41)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt9),expression:"vertt9"}],ref:"testt9",attrs:{"id":"testt12"}},[_vm._m(42),_vm._v(" "),_vm._m(43),_vm._v(" "),_c('div',{staticClass:" col s8"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("176. NOMBRE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg176),expression:"eval_solemp.pg176"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg176)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg176", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("177. TELEFONO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg177),expression:"eval_solemp.pg177"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg177)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg177", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("178. E-MAIL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg178),expression:"eval_solemp.pg178"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg178)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg178", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("179. OCUPACION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg179),expression:"eval_solemp.pg179"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg179)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg179", $event.target.value)}}})]),_vm._v(" "),_vm._m(44),_vm._v(" "),_c('div',{staticClass:" col s8"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("180. NOMBRE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg180),expression:"eval_solemp.pg180"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg180)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg180", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("181. TELEFONO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg181),expression:"eval_solemp.pg181"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg181)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg181", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("182. E-MAIL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg182),expression:"eval_solemp.pg182"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg182)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg182", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("183. OCUPACION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg183),expression:"eval_solemp.pg183"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg183)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg183", $event.target.value)}}})]),_vm._v(" "),_vm._m(45),_vm._v(" "),_c('div',{staticClass:" col s8"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("184. NOMBRE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg184),expression:"eval_solemp.pg184"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg184)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg184", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("185. TELEFONO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg185),expression:"eval_solemp.pg185"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg185)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg185", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("186. E-MAIL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg186),expression:"eval_solemp.pg186"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg186)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg186", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("187. OCUPACION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg187),expression:"eval_solemp.pg187"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg187)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg187", $event.target.value)}}})]),_vm._v(" "),_vm._m(46),_vm._v(" "),_c('div',{staticClass:" col s8"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("188. NOMBRE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg188),expression:"eval_solemp.pg188"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg188)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg188", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("189. TELEFONO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg189),expression:"eval_solemp.pg189"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg189)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg189", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s2"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("190. E-MAIL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg190),expression:"eval_solemp.pg190"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg190)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg190", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s12"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("191. OCUPACION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg191),expression:"eval_solemp.pg191"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg191)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg191", $event.target.value)}}})]),_vm._v(" "),_vm._m(47),_vm._v(" "),_vm._m(48),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("192. EMPRESA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg192),expression:"eval_solemp.pg192"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg192)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg192", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("193. NOMBRE DEL EMPLEADO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg193),expression:"eval_solemp.pg193"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg193)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg193", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("194. TELEFONO Y E-MAIL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg194),expression:"eval_solemp.pg194"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg194)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg194", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s9"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("195. OCUPACION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg195),expression:"eval_solemp.pg195"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg195)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg195", $event.target.value)}}})]),_vm._v(" "),_vm._m(49),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("196. EMPRESA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg196),expression:"eval_solemp.pg196"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg196)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg196", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("197. NOMBRE DEL EMPLEADO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg197),expression:"eval_solemp.pg197"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg197)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg197", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("198. TELEFONO Y E-MAIL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg198),expression:"eval_solemp.pg198"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg198)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg198", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s9"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("199. OCUPACION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg199),expression:"eval_solemp.pg199"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg199)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg199", $event.target.value)}}})]),_vm._v(" "),_vm._m(50),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("200. EMPRESA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg200),expression:"eval_solemp.pg200"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg200)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg200", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("201. NOMBRE DEL EMPLEADO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg201),expression:"eval_solemp.pg201"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg201)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg201", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("202. TELEFONO Y E-MAIL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg202),expression:"eval_solemp.pg202"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg202)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg202", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s9"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("203. OCUPACION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg203),expression:"eval_solemp.pg203"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg203)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg203", $event.target.value)}}})]),_vm._v(" "),_vm._m(51),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("204. EMPRESA")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg204),expression:"eval_solemp.pg204"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg204)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg204", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("205. NOMBRE DEL EMPLEADO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg205),expression:"eval_solemp.pg205"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg205)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg205", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("206. TELEFONO Y E-MAIL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg206),expression:"eval_solemp.pg206"}],attrs:{"type":"text","value":""},domProps:{"value":(_vm.eval_solemp.pg206)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg206", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:" col s9"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("207. OCUPACION")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_solemp.pg207),expression:"eval_solemp.pg207"}],attrs:{"type":"text","value":"","maxlength":"130","placeholder":"Máximo 130 caracteres !"},domProps:{"value":(_vm.eval_solemp.pg207)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_solemp, "pg207", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(52)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(8)}}},[_vm._m(53)]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grabado===false),expression:"grabado===false"}],staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn tooltipped",attrs:{"data-position":"left","data-tooltip":"Grabar"},on:{"click":function($event){_vm.agregarEvaluacion()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-body"},[_c('div',{attrs:{"align":"justify"}},[_vm._v("\n                               Solicitamos se sirva completar la información contenida en el presente formulario. Es parte de su proceso de aplicación. Rogamos incluir la mayor información a su alcance.                                "),_c('div',{staticClass:"center"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("SELECCIONE EL SIGUIENTE BOTON PARA EMPEZAR LA EVALUACION.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("CLASIFICACION DE DATOS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("DATOS PERSONALES")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("DATOS FAMILIARES")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* DATOS DE LOS PADRES")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* DATOS DE LOS HERMANOS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* DATOS DEL CONYUGUE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* DATOS DE LOS HIJOS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("DATOS SOCIOECONOMICOS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("DATOS ACADEMICOS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* Post-Grado/Maestría/Doctorado ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* UNIVERSITARIA")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* DIVERSIFICADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* OTROS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* EN LA ACTUALIDAD")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* IDIOMAS ADICIONALES")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("DATOS LABORALES - Parte 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* FUNCIONES DESEMPEÑADAS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("DATOS LABORALES - Parte 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* FUNCIONES DESEMPEÑADAS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("DATOS LABORALES - Parte 3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" col s12"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("* FUNCIONES DESEMPEÑADAS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("DATOS EXTRA-LABORALES")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* Escriba algún deporte o pasatiempo preferido")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* Salud en General")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* Condiciones de trabajo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* Información complementaria")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("REFERENCIAS PERSONALES")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("Proporcione los datos completos de 4 personas que puedan dar referencias suyas, que no sean sus familiares")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* REFERENCIA #1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* REFERENCIA #2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* REFERENCIA #3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* REFERENCIA #4")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("REFERENCIAS LABORALES")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("Proporcione los datos completos de 4 empresas que puedan dar referencias suyas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* REFERENCIA #1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* REFERENCIA #2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* REFERENCIA #3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('span',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_vm._v("* REFERENCIA #4")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("first_page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev09_emoc_js__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3226ab71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev09_emoc_vue__ = __webpack_require__(337);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev09_emoc_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3226ab71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev09_emoc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s2"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Departamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.depto),expression:"eval_emoc.depto"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_emoc.depto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "depto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.empresa),expression:"eval_emoc.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_emoc.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.nombre),expression:"eval_emoc.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_emoc.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Sexo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.sexo),expression:"eval_emoc.sexo"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_emoc.sexo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "sexo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_emoc.empezo))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finalizoeval),expression:"finalizoeval"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_emoc.termino))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para LEER u OCULTAR las instrucciones.","data-position":"top"}},[_vm._v("\n                            "+_vm._s(_vm.instrucciones)+"\n                        ")])]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12"},[_c('div',{staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("Empezar Evaluación de EMOCIONES")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s12"},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s6"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt4"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("Preguntas 01 - 24")])]),_vm._v(" "),_c('li',{staticClass:"tab col s6"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt5"},on:{"click":function($event){_vm.nadaG1(2)}}},[_vm._v("Preguntas 25 - 45")])])]),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.pregSinContestar>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_sinResponder))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt4"}},[_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg001===0 ? "color:red" : "color:black")},[_vm._v("01. Identificar los cambios del estímulo fisiológico")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg001),expression:"eval_emoc.pg001"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg001)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg001", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg002===0 ? "color:red" : "color:black")},[_vm._v("02. Relajarnos en situaciones de presión ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg002),expression:"eval_emoc.pg002"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg002)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg002", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg003===0 ? "color:red" : "color:black")},[_vm._v("03. Actuar de modo productivo cuando estamos enfadados")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg003),expression:"eval_emoc.pg003"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg003)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg003", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg004===0 ? "color:red" : "color:black")},[_vm._v("04. Actuar de modo productivo en situaciones de ansiedad")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg004),expression:"eval_emoc.pg004"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg004)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg004", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg005===0 ? "color:red" : "color:black")},[_vm._v("05. Tranquilizarnos rápido cuando estamos enfadados")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg005),expression:"eval_emoc.pg005"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg005)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg005", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg006===0 ? "color:red" : "color:black")},[_vm._v("06. Asociar diferentes indicios físicos con emociones diversas")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg006),expression:"eval_emoc.pg006"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg006)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg006", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg007===0 ? "color:red" : "color:black")},[_vm._v("07. Usar el diálogo interior para controlar estados emocionales")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg007),expression:"eval_emoc.pg007"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg007)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg007", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg008===0 ? "color:red" : "color:black")},[_vm._v("08. Comunicar sentimientos de modo eficaz")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg008),expression:"eval_emoc.pg008"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg008)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg008", $event.target.value)}}}),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg009===0 ? "color:red" : "color:black")},[_vm._v("09. Pensar en sentimientos negativos")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg009),expression:"eval_emoc.pg009"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg009)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg009", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg010===0 ? "color:red" : "color:black")},[_vm._v("10. Mantener la calma cuando somos el blanco del enfado de otros ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg010),expression:"eval_emoc.pg010"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg010)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg010", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg011===0 ? "color:red" : "color:black")},[_vm._v("11. Saber cuándo tenemos pensamientos negativos")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg011),expression:"eval_emoc.pg011"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg011)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg011", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg012===0 ? "color:red" : "color:black")},[_vm._v("12. Saber cuándo nuestro “discurso interior” es positivo")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg012),expression:"eval_emoc.pg012"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg012)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg012", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg013===0 ? "color:red" : "color:black")},[_vm._v("13. Saber cuándo empezamos enfadarnos ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg013),expression:"eval_emoc.pg013"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg013)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg013", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg014===0 ? "color:red" : "color:black")},[_vm._v("14. Saber cómo interpretamos los acontecimientos")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg014),expression:"eval_emoc.pg014"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg014)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg014", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg015===0 ? "color:red" : "color:black")},[_vm._v("15. Conocer qué sentimientos utilizamos actualmente")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg015),expression:"eval_emoc.pg015"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg015)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg015", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg016===0 ? "color:red" : "color:black")},[_vm._v("16. Comunicar con precisión lo que experimentamos")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg016),expression:"eval_emoc.pg016"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg016)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg016", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg017===0 ? "color:red" : "color:black")},[_vm._v("17. Identificar la información que influye sobre nuestras interpretaciones ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg017),expression:"eval_emoc.pg017"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg017)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg017", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg018===0 ? "color:red" : "color:black")},[_vm._v("18. Identificar nuestros cambios de humor ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg018),expression:"eval_emoc.pg018"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg018)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg018", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg019===0 ? "color:red" : "color:black")},[_vm._v("19. Saber cuándo estamos a la defensiva")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg019),expression:"eval_emoc.pg019"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg019)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg019", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg020===0 ? "color:red" : "color:black")},[_vm._v("20. Calcular el impacto de nuestro comportamiento ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg020),expression:"eval_emoc.pg020"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg020)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg020", $event.target.value)}}}),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg021===0 ? "color:red" : "color:black")},[_vm._v("21. Saber cuándo no nos comunicamos con sentido")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg021),expression:"eval_emoc.pg021"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg021)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg021", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg022===0 ? "color:red" : "color:black")},[_vm._v("22. Ponernos en marcha cuando lo deseemos ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg022),expression:"eval_emoc.pg022"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg022)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg022", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg023===0 ? "color:red" : "color:black")},[_vm._v("23. Recuperarnos rápido después de un contratiempo ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg023),expression:"eval_emoc.pg023"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg023)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg023", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg024===0 ? "color:red" : "color:black")},[_vm._v("24. Completar tareas a largo plazo dentro del tiempo previsto ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg024),expression:"eval_emoc.pg024"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg024)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg024", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt5"}},[_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg025===0 ? "color:red" : "color:black")},[_vm._v("25. Producir energía positiva cuando realizamos un trabajo poco interesante")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg025),expression:"eval_emoc.pg025"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg025)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg025", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg026===0 ? "color:red" : "color:black")},[_vm._v("26. Abandonar o cambiar hábitos inútiles")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg026),expression:"eval_emoc.pg026"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg026)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg026", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg027===0 ? "color:red" : "color:black")},[_vm._v("27. Desarrollar pautas de conducta nuevas y más productivas ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg027),expression:"eval_emoc.pg027"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg027)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg027", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg028===0 ? "color:red" : "color:black")},[_vm._v("28. Cumplir lo que decimos")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg028),expression:"eval_emoc.pg028"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg028)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg028", $event.target.value)}}}),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg029===0 ? "color:red" : "color:black")},[_vm._v("29. Resolver conflictos")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg029),expression:"eval_emoc.pg029"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg029)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg029", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg030===0 ? "color:red" : "color:black")},[_vm._v("30. Desarrollar el consenso con los demás")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg030),expression:"eval_emoc.pg030"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg030)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg030", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg031===0 ? "color:red" : "color:black")},[_vm._v("31. Mediar en los conflictos con los demás ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg031),expression:"eval_emoc.pg031"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg031)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg031", $event.target.value)}}}),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg032===0 ? "color:red" : "color:black")},[_vm._v("32. Utilizar técnicas de comunicación interpersonal ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg032),expression:"eval_emoc.pg032"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg032)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg032", $event.target.value)}}}),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg033===0 ? "color:red" : "color:black")},[_vm._v("33. Expresar los pensamientos de un grupo")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg033),expression:"eval_emoc.pg033"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg033)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg033", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg034===0 ? "color:red" : "color:black")},[_vm._v("34. Influir sobre los demás de forma directa o indirecta")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg034),expression:"eval_emoc.pg034"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg034)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg034", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg035===0 ? "color:red" : "color:black")},[_vm._v("35. Fomentar la confianza con los demás")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg035),expression:"eval_emoc.pg035"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg035)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg035", $event.target.value)}}}),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg036===0 ? "color:red" : "color:black")},[_vm._v("36. Montar grupos de apoyo ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg036),expression:"eval_emoc.pg036"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg036)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg036", $event.target.value)}}}),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg037===0 ? "color:red" : "color:black")},[_vm._v("37. Hacer que los demás se sientan bien ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg037),expression:"eval_emoc.pg037"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg037)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg037", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg038===0 ? "color:red" : "color:black")},[_vm._v("38. Proporcionar apoyo y consejo a los demás cuando sea necesario")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg038),expression:"eval_emoc.pg038"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg038)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg038", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg039===0 ? "color:red" : "color:black")},[_vm._v("39. Reflejar con precisión los sentimientos de las personas ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg039),expression:"eval_emoc.pg039"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg039)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg039", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg040===0 ? "color:red" : "color:black")},[_vm._v("40. Reconocer la angustia en los demás ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg040),expression:"eval_emoc.pg040"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg040)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg040", $event.target.value)}}}),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg041===0 ? "color:red" : "color:black")},[_vm._v("41. Ayudar a los demás a controlar sus emocioneso")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg041),expression:"eval_emoc.pg041"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg041)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg041", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg042===0 ? "color:red" : "color:black")},[_vm._v("42. Mostrar comprensión hacia los demás")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg042),expression:"eval_emoc.pg042"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg042)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg042", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg043===0 ? "color:red" : "color:black")},[_vm._v("43. Entablar conversaciones íntimas con los demás")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg043),expression:"eval_emoc.pg043"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg043)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg043", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg044===0 ? "color:red" : "color:black")},[_vm._v("44. Ayudar a un grupo a controlar sus emociones")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg044),expression:"eval_emoc.pg044"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg044)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg044", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_emoc.pg045===0 ? "color:red" : "color:black")},[_vm._v("45. Detectar incongruencias entre las emociones o sentimientos de los demás y sus conductas ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_emoc.pg045),expression:"eval_emoc.pg045"}],attrs:{"type":"number","value":"","min":"1,","max":"7"},domProps:{"value":(_vm.eval_emoc.pg045)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_emoc, "pg045", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grabado===false),expression:"grabado===false"}],staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn tooltipped",attrs:{"data-position":"left","data-tooltip":"Grabar"},on:{"click":function($event){_vm.agregarEvaluacion()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-body"},[_c('div',{attrs:{"align":"justify"}},[_vm._v("\n                            INSTRUCCIONES Señor aspirante a empleo: El presente diagnóstico ayuda a conocer sobre administración de las emociones. Se solicita que sea lo más honesto posible al dar sus respuestas. Usted tiene una escala que va de 1 a 7. Uno significa baja capacidad en el tema consultado y 7 significa un grado o capacidad alta. \n                            UTILIZANDO EL MOUSE SELECCIONE EL VALOR HACIENDO CLICK EN LAS FLECHITAS EN CADA CAMPO. \n                              \n                            Inicialmente todas las preguntas estarán en color "),_c('span',{staticStyle:{"font-weight":"bold","color":"red"}},[_vm._v("rojo")]),_vm._v(" como indicador\n                            que aún no han sido respondidas. Conforme vaya respondiendo, las preguntas se mostrarán en color negro. También tendrá un mensaje indicándole la cantidad \n                            de preguntas que aún no han sido respondidas. El siguiente "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("ejemplo")]),_vm._v(" de tres preguntas le permitirá estar seguro que comprende lo que debe hacer en el propio cuestionario."),_c('br'),_vm._v(" "),_c('div',{staticClass:"center"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("SELECCIONE EL SIGUIENTE BOTON PARA EMPEZAR LA EVALUACION.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev10_vtas_js__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3890602_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev10_vtas_vue__ = __webpack_require__(339);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev10_vtas_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3890602_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev10_vtas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s2"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Departamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.depto),expression:"eval_vtas.depto"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_vtas.depto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_vtas, "depto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.empresa),expression:"eval_vtas.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_vtas.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_vtas, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.nombre),expression:"eval_vtas.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_vtas.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_vtas, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Sexo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.sexo),expression:"eval_vtas.sexo"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_vtas.sexo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_vtas, "sexo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Inicio")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_vtas.empezo))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finalizoeval),expression:"finalizoeval"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Finalización")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para LEER u OCULTAR las instrucciones.","data-position":"top"}},[_vm._v("\n                            "+_vm._s(_vm.instrucciones)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{attrs:{"align":"justify"}},[_vm._v("\n                            Este es un cuestionario de sus actitudes. Lo que hace o lo que piensa acerca de ciertas situaciones. Las personas piensan de una manera u otra. \n                            Por lo tanto, no existen respuestas \"correctas\" o \"incorrectas\" a las preguntas de este formulario. \n\n                            Se ofrecen tres posibles respuestas para cada pregunta, que Ud. debe contestar \"A\" o \"B\" o \"C\" o \"D\" seleccionando con el mouse en la correspondiente respuesta. Las preguntas están organizadas en cinco (5) secciones. Sección 1: De la 1 a la 25, Sección 2: de la 26 a la 50, Sección 3: de la 51 a la 75, Sección 4: de la 76 a la 87."),_c('br'),_c('br'),_vm._v("\n                              \n                            Inicialmente todas las preguntas estarán en color "),_c('span',{staticStyle:{"font-weight":"bold","color":"red"}},[_vm._v("rojo")]),_vm._v(" como indicador\n                            que aún no han sido respondidas. Conforme vaya respondiendo, las preguntas se mostrarán en color negro. También tendrá un mensaje indicándole la cantidad \n                            de preguntas que aún no han sido respondidas. El siguiente "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("ejemplo")]),_vm._v(" de tres preguntas le permitirá estar seguro que comprende lo que debe hacer en el propio cuestionario."),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.ejeSinResponder>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_ejeSinResponder))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('span',{style:(_vm.ejemplo.pg001===0 ? "color:red" : "color:black")},[_vm._v("Si usted pudiera elegir el tipo de vivienda de manera completamente libre, ¿Qué preferiría?:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"a","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Una casa en el campo con un gran jardín.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"b","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Un lujoso apartamento en una gran ciudad.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg001),expression:"ejemplo.pg001"}],attrs:{"value":"c","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg001,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg001", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Una casa situada en una calle tranquila de una pequeña ciudad.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('span',{style:(_vm.ejemplo.pg002===0 ? "color:red" : "color:black")},[_vm._v("02. J---- está comprando en un gran almacén cuando advierte que alguien esconde discretamente un disco bajo su jersey. ¿Qué hará J----?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"a","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"a")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Dar cuenta del hecho al primer vendedor que encuentre.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"b","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"b")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intermedio;No haces nada por que piensa que no es cosa suya. ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ejemplo.pg002),expression:"ejemplo.pg002"}],attrs:{"value":"c","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.ejemplo.pg002,"c")},on:{"change":function($event){_vm.$set(_vm.ejemplo, "pg002", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Indicar al infractor con el gesto o de palabra que ha visto lo que ha hecho.")]),_vm._v("\n                                         En este caso, usted contestara lo que, según su propia opinión, es más probable que haga J.... En realidad, no hay respuestas buenas ni malas: cada uno piensa y actúa como cree conveniente en función de su carácter, de sus intereses, etc. Si quiere anular una respuesta, tache (o borre) la marca correspondiente y señale la nueva elección.                                            \n                                    ")])])])]),_vm._v(" "),_vm._m(0)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12"},[_c('div',{staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("Empezar Evaluación de ORIENTACION EN VENTAS")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s12"},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt4"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("Preguntas 01 - 25")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt5"},on:{"click":function($event){_vm.nadaG2(2)}}},[_vm._v("Preguntas 26 - 50")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt3",class:_vm.activott3,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt3","href":"#testt6"},on:{"click":function($event){_vm.nadaG3(3)}}},[_vm._v("Preguntas 51 - 75")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt4",class:_vm.activott4,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt4","href":"#testt7"},on:{"click":function($event){_vm.nadaG4(4)}}},[_vm._v("Preguntas 76 - 87")])])]),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.pregSinContestar>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_sinResponder))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt4"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg001===0 ? "color:red" : "color:black")},[_vm._v("01. T... Debe salir de viaje con una persona de la que no conoce nada. ¿ Sobre cual de los siguientes aspectos de esa persona es preferible informar a T. Para que el viaje resulte mejor?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg001),expression:"eval_vtas.pg001"}],attrs:{"value":"a","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg001,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg001", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Su estilo de vida.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg001),expression:"eval_vtas.pg001"}],attrs:{"value":"b","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg001,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg001", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Su actividad y responsabilidades profesionales")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg001),expression:"eval_vtas.pg001"}],attrs:{"value":"c","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg001,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg001", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg002===0 ? "color:red" : "color:black")},[_vm._v("02. Entre los siguientes tipos de vendedores de prendas confeccionadas, ¿ Cual es el que tiene mas probabilidades de éxito?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg002),expression:"eval_vtas.pg002"}],attrs:{"value":"a","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg002,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg002", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) El que presente las últimas novedades.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg002),expression:"eval_vtas.pg002"}],attrs:{"value":"b","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg002,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg002", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) El que, tratando de conocer el estilo de su cliente, se interese por su modo de vida.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg002),expression:"eval_vtas.pg002"}],attrs:{"value":"c","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg002,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg002", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) El que posea una buena capacidad de convencer")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg003===0 ? "color:red" : "color:black")},[_vm._v("03. B...Tiene un proyecto importante para la promoción de un nuevo producto y va a exponer su idea anteael Comité de Dirección. ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg003),expression:"eval_vtas.pg003"}],attrs:{"value":"a","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg003,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg003", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Competencia técnica y un conocimiento perfecto del tema")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg003),expression:"eval_vtas.pg003"}],attrs:{"value":"b","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg003,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg003", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Capacidad para modificar sus razonamientos según la actitud del auditorio")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg003),expression:"eval_vtas.pg003"}],attrs:{"value":"c","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg003,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg003", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Facultad para mantener el orden de sus ideas a pesar de las interrupciones.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg004===0 ? "color:red" : "color:black")},[_vm._v("04. Se envía a G....contra su voluntad, a un país extranjero, por el cual no se siente atraído en principio, para una estancia de varias semanas ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg004),expression:"eval_vtas.pg004"}],attrs:{"value":"a","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg004,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg004", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Estimar que la duración de su estancia es demasiado corta para conseguir integrarse.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg004),expression:"eval_vtas.pg004"}],attrs:{"value":"b","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg004,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg004", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Tratar de aprender la lengua para comprender mejor a este país y vivir mas agusto en él.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg004),expression:"eval_vtas.pg004"}],attrs:{"value":"c","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg004,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg004", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No tener más que los contactos estrictamente necesario para la buena marcha de su trabajo.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg005===0 ? "color:red" : "color:black")},[_vm._v("05. Según su opinión, las personas que dicen siempre \"su\" verdad a los demás, aunque esta sea desagradable, lo hacen, en general, por que:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg005),expression:"eval_vtas.pg005"}],attrs:{"value":"a","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg005,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg005", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) No saben controlar sus impulsos y dicen espontáneamente lo que piensan.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg005),expression:"eval_vtas.pg005"}],attrs:{"value":"b","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg005,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg005", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No saben controlar sus impulsos y dicen espontáneamente lo que piensan.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg005),expression:"eval_vtas.pg005"}],attrs:{"value":"c","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg005,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg005", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Piensan que esto simplifica las relaciones")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg006===0 ? "color:red" : "color:black")},[_vm._v("06.  Un buen amigo de C... Había comenzado bastante brillantemente su carrera profesional, pero los resultados no han sido los que cabría esperar y terminó teniendo numerosos fracasos. ¿Qué piensa C... Acerca de esto?:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg006),expression:"eval_vtas.pg006"}],attrs:{"value":"a","name":"group6","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg006,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg006", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Que las condiciones no le han sido favorables.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg006),expression:"eval_vtas.pg006"}],attrs:{"value":"b","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg006,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg006", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Que no estaba a la altura necesaria")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg006),expression:"eval_vtas.pg006"}],attrs:{"value":"c","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg006,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg006", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Que no ha utilizado bien los medios para salir adelante.")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg007===0 ? "color:red" : "color:black")},[_vm._v("07. B...Encuentra, en casa de unos amigos, a una persona que aparenta una edad muy inferior a la que realmente tiene ¿Qué opinará B...?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg007),expression:"eval_vtas.pg007"}],attrs:{"value":"a","name":"group7","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg007,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg007", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Probablemente ha encontrado en la vida lo que le convenía.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg007),expression:"eval_vtas.pg007"}],attrs:{"value":"b","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg007,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg007", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Tiene buena suerte; es cuestión de naturaleza.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg007),expression:"eval_vtas.pg007"}],attrs:{"value":"c","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg007,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg007", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Seguramente ha tenido una vida fácil")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg008===0 ? "color:red" : "color:black")},[_vm._v("08. Para expansionarse, S...decide aprender judo. Después de unos meses de entrenamiento se da cuenta de que progresa muy lentamente ¿ Cuál será su reacción?:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg008),expression:"eval_vtas.pg008"}],attrs:{"value":"a","name":"group8","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg008,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg008", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Pensando que realmente no está hecho para el judo, elegirá otro deporte.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg008),expression:"eval_vtas.pg008"}],attrs:{"value":"b","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg008,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg008", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Convencido de que no está dotado para las actividades corporales buscará otra forma de actividad")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg008),expression:"eval_vtas.pg008"}],attrs:{"value":"c","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg008,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg008", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Continuará sus esfuerzos con la esperanza de que seguramente un día serán coronados por el éxito.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg009===0 ? "color:red" : "color:black")},[_vm._v("09. P... Se acuesta una noche muy fatigado, pero no puede dormirse por que sus vecinos del piso superior han organizado una fiesta muy ruidosa. ¿Qué hará?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg009),expression:"eval_vtas.pg009"}],attrs:{"value":"a","name":"group9","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg009,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg009", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Subir y advertir a sus vecinos.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg009),expression:"eval_vtas.pg009"}],attrs:{"value":"b","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg009,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg009", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Dar con las escoba algunos golpes en el techo.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg009),expression:"eval_vtas.pg009"}],attrs:{"value":"c","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg009,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg009", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Tomar un somnífero y tratar de dormir cueste lo que cueste")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg010===0 ? "color:red" : "color:black")},[_vm._v("10. G... Que carece de teléfono llega a una oficina de telégrafos para enviar un telegrama a la hora de cerrar. El encargado le dice que es demasiado tarde, que va a cerrar. ¿Qué hará G...?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg010),expression:"eval_vtas.pg010"}],attrs:{"value":"a","name":"group10","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg010,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg010", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Ir a casa de un amigo que tiene teléfono para poner el telegrama por teléfono.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg010),expression:"eval_vtas.pg010"}],attrs:{"value":"b","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg010,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg010", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Convencer al encargado de que su telegrama es muy urgente y que debe salir inmediatamente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg010),expression:"eval_vtas.pg010"}],attrs:{"value":"c","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg010,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg010", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Ir a una oficina de telégrafos que cierre más tarde.")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg011===0 ? "color:red" : "color:black")},[_vm._v("11.  X...Hace un viaje de turismo por un país en que es costumbre discutir los precios. ¿Cuál será su actitud?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg011),expression:"eval_vtas.pg011"}],attrs:{"value":"a","name":"group11","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg011,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg011", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Hará pocas compras por que le molesta tener que discutir siempre.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg011),expression:"eval_vtas.pg011"}],attrs:{"value":"b","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg011,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg011", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Hará numerosas compras, incluso, un poco inútiles, por que le encanta discutir los precios")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg011),expression:"eval_vtas.pg011"}],attrs:{"value":"c","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg011,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg011", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Convencido de que le timarían, preferirá los almacenes de precios fijos.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg012===0 ? "color:red" : "color:black")},[_vm._v("12. Sin tener en cuenta la formación y competencia necesarias, ¿Cuál de las siguientes direcciones de servicios le gustaría asumir?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg012),expression:"eval_vtas.pg012"}],attrs:{"value":"a","name":"group12","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg012,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg012", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Gestión.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg012),expression:"eval_vtas.pg012"}],attrs:{"value":"b","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg012,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg012", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Personal")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg012),expression:"eval_vtas.pg012"}],attrs:{"value":"c","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg012,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg012", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Publicidad")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg013===0 ? "color:red" : "color:black")},[_vm._v("13. Se ve usted en la necesidad de evitar la excitación porque lo cansUn escritor poco conocido acaba de recibir el premio planeta. ¿Qué cree usted que preferiría hacer?:  ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg013),expression:"eval_vtas.pg013"}],attrs:{"value":"a","name":"group13","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg013,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg013", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Escribir menos y aprovecharse de su éxito para salir, recibir a la gente y hacer una vida de sociedad ..")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg013),expression:"eval_vtas.pg013"}],attrs:{"value":"b","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg013,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg013", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Intentar escribir una obra maestra")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg013),expression:"eval_vtas.pg013"}],attrs:{"value":"c","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg013,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg013", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Dedicarse a la pintura e intentar triunfar también en ella")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg014===0 ? "color:red" : "color:black")},[_vm._v("14. Si usted se encontrara en una situación de examen en la que pudiera elegir entre dos temas , ¿Cual escogería ?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg014),expression:"eval_vtas.pg014"}],attrs:{"value":"a","name":"group14","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg014,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg014", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Un tema ampliamente tratado durante el curso con el que tiene, casi, la plena seguridad de alcanzar la nota media necesaria..")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg014),expression:"eval_vtas.pg014"}],attrs:{"value":"b","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg014,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg014", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Un tema que le permita, con un mínimo de conocimientos, pero con mucha lógica e imaginación, obtener una calificación muy buena pero, quizá también muy mala.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg014),expression:"eval_vtas.pg014"}],attrs:{"value":"c","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg014,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg014", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Ninguna")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg015===0 ? "color:red" : "color:black")},[_vm._v("15. Entre las siguientes actividades de descanso físico en la naturaleza, ¿Cuál prefiere usted?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg015),expression:"eval_vtas.pg015"}],attrs:{"value":"a","name":"group15","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg015,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg015", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Una vuelta por la bahía cuando el mar esta agitado.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg015),expression:"eval_vtas.pg015"}],attrs:{"value":"b","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg015,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg015", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Un baño de sol en una playa de arena fina , en un hermoso día de verano con el aire en calmae")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg015),expression:"eval_vtas.pg015"}],attrs:{"value":"c","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg015,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg015", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Un paseo por el campo en primavera.")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg016===0 ? "color:red" : "color:black")},[_vm._v("16. ¿Qué es, a su juicio lo que atrae a más gente en los viajes o estancias en el extranjero? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg016),expression:"eval_vtas.pg016"}],attrs:{"value":"a","name":"group16","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg016,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg016", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Los paisajes nuevos.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg016),expression:"eval_vtas.pg016"}],attrs:{"value":"b","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg016,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg016", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) El descubrimiento de otra civilización artística")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg016),expression:"eval_vtas.pg016"}],attrs:{"value":"c","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg016,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg016", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) El contacto con una población de costumbres muy diferentes ")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg017===0 ? "color:red" : "color:black")},[_vm._v("17. P...Camina rápidamente por la calle y parece que tiene prisa. Un joven que realiza una encuesta le detiene para hacerle algunas preguntas extrañas, pero divertidas. ¿Qué hará P...? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg017),expression:"eval_vtas.pg017"}],attrs:{"value":"a","name":"group17","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg017,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg017", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Rehusar con firmeza contestar las preguntas.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg017),expression:"eval_vtas.pg017"}],attrs:{"value":"b","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg017,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg017", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Responder rápidamente, porque lo encuentra divertido")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg017),expression:"eval_vtas.pg017"}],attrs:{"value":"c","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg017,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg017", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Excusarse de no tener tiempo para responder, sintiendo de verdad no poder hacerlo.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg018===0 ? "color:red" : "color:black")},[_vm._v("18.  L...Trabaja en una empresa en que recibe muy pocas informaciones a nivel oficial. ¿Qué opina usted de ello?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg018),expression:"eval_vtas.pg018"}],attrs:{"value":"a","name":"group18","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg018,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg018", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Que será muy difícil obtener información.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg018),expression:"eval_vtas.pg018"}],attrs:{"value":"b","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg018,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg018", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Que con los rumores de pasillo eso no constituye un problema")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg018),expression:"eval_vtas.pg018"}],attrs:{"value":"c","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg018,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg018", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Que, de hecho, es muy fácil estar informado; bastará conocer a algunas personas bien situadas.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg019===0 ? "color:red" : "color:black")},[_vm._v("19. Son las once de la noche. Hay numerosos vehículos aparcados en la calle, algunos de ellos sobre las aceras. P...Ve desde su ventana a uno que trata de abrir la puerta de un coche; parece que no tiene llave y utiliza un destornillador. ¿Qué pensará P...? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg019),expression:"eval_vtas.pg019"}],attrs:{"value":"a","name":"group19","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg019,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg019", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Probablemente es un ratero que trata de robar un coche. ¿Y si yo llamase a la policía?.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg019),expression:"eval_vtas.pg019"}],attrs:{"value":"b","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg019,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg019", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Alguien ha quedado atrapado en la acera y trata de mover un coche para salir ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg019),expression:"eval_vtas.pg019"}],attrs:{"value":"c","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg019,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg019", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) ¿Qué estará haciendo?, Parece que utiliza un desatornillador")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg020===0 ? "color:red" : "color:black")},[_vm._v("20. Cuándo un niño ha cometido una gran tontería, ¿Cuál es, a su modo ver, la mejor reacción? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg020),expression:"eval_vtas.pg020"}],attrs:{"value":"a","name":"group20","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg020,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg020", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Castigarle, explicándole por que se hace")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg020),expression:"eval_vtas.pg020"}],attrs:{"value":"b","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg020,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg020", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Explicarle la significación de su tontería situándola en su contexto")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg020),expression:"eval_vtas.pg020"}],attrs:{"value":"c","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg020,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg020", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Apelar el amor propio del niño")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg021===0 ? "color:red" : "color:black")},[_vm._v("21. B... tiene varios hijos y ha decidido intervenir en la educación sexual de cada uno de ellos. ¿Qué procedimiento le parece a usted que adoptará probablemente?:  ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg021),expression:"eval_vtas.pg021"}],attrs:{"value":"a","name":"group21","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg021,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg021", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Preparar, con el hijo mayor, un tipo de intervención que luego mantendrá con los demás hijos")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg021),expression:"eval_vtas.pg021"}],attrs:{"value":"b","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg021,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg021", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Seguir su intuición o sus sentimientos")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg021),expression:"eval_vtas.pg021"}],attrs:{"value":"c","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg021,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg021", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Adoptar un modo de proceder distinto para cada hijo")])])]),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg022===0 ? "color:red" : "color:black")},[_vm._v("22. ¿Cual es para un niño la manera más «astuta» de presentar unas calificaciones escolares poco brillantes?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg022),expression:"eval_vtas.pg022"}],attrs:{"value":"a","name":"group22","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg022,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg022", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Enseñarlas lo antes posible para librarse de ello")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg022),expression:"eval_vtas.pg022"}],attrs:{"value":"b","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg022,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg022", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Presentarlos el lunes a la hora del desayuno")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg022),expression:"eval_vtas.pg022"}],attrs:{"value":"c","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg022,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg022", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Presentarlas en el momento en que pueda aportar, además, alguna compensación")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg023===0 ? "color:red" : "color:black")},[_vm._v("23.  El hijo de G... ha entrado en el despacho de su padre a pesar de que éste se lo tiene prohibido, y ha derramado un frasco de tinta sobre papeles importantes. G..., furioso, le da un buen tortazo. ¿Qué pensará G... algún tiempo después?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg023),expression:"eval_vtas.pg023"}],attrs:{"value":"a","name":"group23","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg023,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg023", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Que un buen azote de vez en cuando no viene mal")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg023),expression:"eval_vtas.pg023"}],attrs:{"value":"b","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg023,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg023", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A Que tal vez se ha excedido un poco")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg023),expression:"eval_vtas.pg023"}],attrs:{"value":"c","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg023,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg023", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Que es conveniente enfadarse de verdad una vez para no tener que volver a hacerlo")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg024===0 ? "color:red" : "color:black")},[_vm._v("24. Una persona con la que D... se relaciona muy frecuentemente acaba de jugarle una mala pasada. ¿Cuál será la reacción de D...?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg024),expression:"eval_vtas.pg024"}],attrs:{"value":"a","name":"group24","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg024,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg024", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) No muestra ninguna, pero se da cuenta de que le será muy difícil ocultar durante mucho tiempo su resentimiento")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg024),expression:"eval_vtas.pg024"}],attrs:{"value":"b","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg024,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg024", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No dice nada porque piensa que el daño causado es tal vez menor del que había creído")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg024),expression:"eval_vtas.pg024"}],attrs:{"value":"c","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg024,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg024", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Se esfuerza en ocultar su resentimiento para no entorpecer sus futuros relaciones")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg025===0 ? "color:red" : "color:black")},[_vm._v("25. N.. asiste a una comida. Se da cuento de que, a causa de una opinión que se le ha escapado, acaba de provocar una situación tensa en el grupo. ¿Qué le parece a usted que será para él lo más desagradable?.  ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg025),expression:"eval_vtas.pg025"}],attrs:{"value":"a","name":"group25","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg025,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg025", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) El sentimiento de que algo va a dificultar notablemente el contacto")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg025),expression:"eval_vtas.pg025"}],attrs:{"value":"b","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg025,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg025", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) El pensamiento de que se le va a juzgar a causa de esta observación")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg025),expression:"eval_vtas.pg025"}],attrs:{"value":"c","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg025,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg025", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) El disgusto de haber hablado sin pensar")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt5"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg026===0 ? "color:red" : "color:black")},[_vm._v("26. P... está jugando a los cartas con sus amigos; o pesar de sus esfuerzos, pierde varias veces seguidas. ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg026),expression:"eval_vtas.pg026"}],attrs:{"value":"a","name":"group26","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg026,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg026", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Después de todo, esta tarde he aprendido bastante. Seguramente ganaré la próxima vez")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg026),expression:"eval_vtas.pg026"}],attrs:{"value":"b","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg026,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg026", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Siempre ocurre lo mismo; el juego de las cartas no se me da bien")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg026),expression:"eval_vtas.pg026"}],attrs:{"value":"c","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg026,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg026", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Realmente no estoy en forma esta tarde")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg027===0 ? "color:red" : "color:black")},[_vm._v("27. R... está sentado en un cine al lado de personas que no se callan y hacen frecuentes comentarios. ,¿Qué hará R ... ?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg027),expression:"eval_vtas.pg027"}],attrs:{"value":"a","name":"group27","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg027,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg027", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Rogarles que se callen ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg027),expression:"eval_vtas.pg027"}],attrs:{"value":"b","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg027,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg027", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Cambiarse de lugar")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg027),expression:"eval_vtas.pg027"}],attrs:{"value":"c","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg027,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg027", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Concentrarse más en la película para evitar la molestia")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg028===0 ? "color:red" : "color:black")},[_vm._v("28. T... trabaja en una gran empresa. Ha efectuado algunos cambios en la organización del trabajo y es muy criticado por gran parte de sus colegas. ¿Cual será la reacción de T ... ?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg028),expression:"eval_vtas.pg028"}],attrs:{"value":"a","name":"group28","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg028,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg028", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Tratar de justificar su posición ante sus colegas ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg028),expression:"eval_vtas.pg028"}],attrs:{"value":"b","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg028,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg028", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Pensar que, en cualquier caso, nunca se consigue la unanimidad")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg028),expression:"eval_vtas.pg028"}],attrs:{"value":"c","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg028,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg028", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Replantearse el problema")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg029===0 ? "color:red" : "color:black")},[_vm._v("29. ¿Qué piensa usted cuando ve a un niño enfrentarse a los adultos?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg029),expression:"eval_vtas.pg029"}],attrs:{"value":"a","name":"group29","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg029,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg029", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Está mal educado")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg029),expression:"eval_vtas.pg029"}],attrs:{"value":"b","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg029,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg029", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Probablemente tiene serias dificultades en sus relaciones con los demas")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg029),expression:"eval_vtas.pg029"}],attrs:{"value":"c","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg029,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg029", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Posee una fuerte personalidad")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg030===0 ? "color:red" : "color:black")},[_vm._v("30. M... debe contratar a un colaborador que se encargará de la dirección de un servicio. Teniendo en cuenta el hecho de que tendrá responsabilidades jerárquicas, ¿A cuál de las actividades siguientes dará M... más importancia?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg030),expression:"eval_vtas.pg030"}],attrs:{"value":"a","name":"group30","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg030,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg030", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Tener autoridad")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg030),expression:"eval_vtas.pg030"}],attrs:{"value":"b","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg030,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg030", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ser convincente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg030),expression:"eval_vtas.pg030"}],attrs:{"value":"c","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg030,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg030", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Ser justo")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg031===0 ? "color:red" : "color:black")},[_vm._v("31. Entre los siguientes estilos de conducir un automóvil en carretera, ¿cuál es a su parecer, el más frecuentemente adoptado por los automovilistas?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg031),expression:"eval_vtas.pg031"}],attrs:{"value":"a","name":"group31","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg031,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg031", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Pensando en la mecánica y en la seguridad, apenas fuerzan la velocidad de su vehículo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg031),expression:"eval_vtas.pg031"}],attrs:{"value":"b","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg031,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg031", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Estimando que es tan peligroso circular demasiado despacio como demasiado deprisa, adelantan a los vehículos que les obligan a ir lentamente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg031),expression:"eval_vtas.pg031"}],attrs:{"value":"c","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg031,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg031", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Toleran de mala gana no tener vía libre y adelantan sistemáticamente a los vehículos que van delante de ellos")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg032===0 ? "color:red" : "color:black")},[_vm._v("32. ¿Qué es lo que más valora cuando usted va a un restaurante?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg032),expression:"eval_vtas.pg032"}],attrs:{"value":"a","name":"group32","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg032,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg032", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Una buena cocina")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg032),expression:"eval_vtas.pg032"}],attrs:{"value":"b","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg032,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg032", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Un ambiente agradable")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg032),expression:"eval_vtas.pg032"}],attrs:{"value":"c","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg032,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg032", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) La posibilidad de comer el plato especial de la casa")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg033===0 ? "color:red" : "color:black")},[_vm._v("33. Una señora va de compras a un almacén que se encuentra bastante lejos de su casa. En la puerta del almacén se da cuenta de que ha olvidado su monedero y su talonario de cheque. Sin tener en cuento el tiempo de que dispone, ¿qué piensa usted que hará?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg033),expression:"eval_vtas.pg033"}],attrs:{"value":"a","name":"group33","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg033,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg033", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Volver a su casa a buscar lo que ha olvidado")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg033),expression:"eval_vtas.pg033"}],attrs:{"value":"b","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg033,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg033", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ver si conoce a alguien por la Zona que pueda prestarle dinero o tratar de que le venda a crédito.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg033),expression:"eval_vtas.pg033"}],attrs:{"value":"c","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg033,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg033", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Dejar las compras para otra ocasión y aprovechar la oportunidad para dar un paseo por el barrio")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg034===0 ? "color:red" : "color:black")},[_vm._v("34.  M... está soltero. Ha tenido un año de trabajo muy fuerte y debe tomar una decisión sobre sus vacaciones. ¿Qué elegirá?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg034),expression:"eval_vtas.pg034"}],attrs:{"value":"a","name":"group34","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg034,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg034", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Pasar un mes en la costa para poder leer, caminar y descansar")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg034),expression:"eval_vtas.pg034"}],attrs:{"value":"b","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg034,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg034", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Visitar una región del país que no conoce")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg034),expression:"eval_vtas.pg034"}],attrs:{"value":"c","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg034,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg034", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Hacer una larga marcha a pie o en bicicleta porque piensa que el deporte es el mejor de los descansos")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg035===0 ? "color:red" : "color:black")},[_vm._v("35. ¿Cual es, a su modo de ver, la mejor manera de descansar durante el fin de semana para un hombre que trabajo todos los demás días?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg035),expression:"eval_vtas.pg035"}],attrs:{"value":"a","name":"group35","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg035,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg035", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Reunirse con los amigos")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg035),expression:"eval_vtas.pg035"}],attrs:{"value":"b","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg035,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg035", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Ir al cine")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg035),expression:"eval_vtas.pg035"}],attrs:{"value":"c","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg035,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg035", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Leer")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg036===0 ? "color:red" : "color:black")},[_vm._v("36. Si usted dispusiera de un año de libertad, y de los medios necesarios para hacer lo que quisiera, ¿cuál elegiría entre los actividades siguientes? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg036),expression:"eval_vtas.pg036"}],attrs:{"value":"a","name":"group36","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg036,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg036", "a")}}}),_vm._v(" "),_c('span',[_vm._v("a) Dar la vuelta al mundo en solitario a bordo de un velero")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg036),expression:"eval_vtas.pg036"}],attrs:{"value":"b","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg036,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg036", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Participar en una carrera-automovilística Madrid-Bombay")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg036),expression:"eval_vtas.pg036"}],attrs:{"value":"c","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg036,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg036", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Visitar el mayor número posible de países")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg037===0 ? "color:red" : "color:black")},[_vm._v("37. Un empleado administrativo, incorporado recientemente a lo empresa, pide a X..., uno de sus compañeros, que le preste una pequeña suma de dinero hasta el mes siguiente. ¿Qué hará X .?.")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg037),expression:"eval_vtas.pg037"}],attrs:{"value":"a","name":"group37","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg037,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg037", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Le prestará el dinero sin hacerte ninguna pregunta para no ponerle en un aprieto")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg037),expression:"eval_vtas.pg037"}],attrs:{"value":"b","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg037,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg037", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Le prestará el dinero porque a él le gustaría que le hicieran lo mismo si lo necesitara")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg037),expression:"eval_vtas.pg037"}],attrs:{"value":"c","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg037,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg037", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No le dará el dinero, considerando que su compañero tiene, probablemente, buenos amigos dispuestos a ayudarle")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg038===0 ? "color:red" : "color:black")},[_vm._v("38. B... se ha puesto, sin quererlo, fuera de la legalidad y debe escoger a un abogado para que le defienda. ¿Sobre cuál de los criterios siguientes basará su elección?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg038),expression:"eval_vtas.pg038"}],attrs:{"value":"a","name":"group38","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg038,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg038", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Su reputación de elocuencia")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg038),expression:"eval_vtas.pg038"}],attrs:{"value":"b","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg038,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg038", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Sus buenas, relaciones con la magistratura")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg038),expression:"eval_vtas.pg038"}],attrs:{"value":"c","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg038,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg038", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Su perspicacia psicológica")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg039===0 ? "color:red" : "color:black")},[_vm._v("39.  E... Ha sido nombrado recientemente para un puesto que implica responsabilidades jerárquicas importantes. ¿Qué actitud tomara probablemente frente a sus subordinados?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg039),expression:"eval_vtas.pg039"}],attrs:{"value":"a","name":"group39","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg039,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg039", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Modificar su forma de mandar según las personas y las circunstancias.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg039),expression:"eval_vtas.pg039"}],attrs:{"value":"b","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg039,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg039", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Fijarse un sistema de mando bien elaborado e idéntico para todos.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg039),expression:"eval_vtas.pg039"}],attrs:{"value":"c","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg039,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg039", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Basándose en la experiencia, dejarse guiar por su intuición.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg040===0 ? "color:red" : "color:black")},[_vm._v("40. R... tiene que hablar sobre informática a empleados que no tienen ningún conocimiento de este campo. ¿Cuál de las siguiente alternativas le planteará menos problemas?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg040),expression:"eval_vtas.pg040"}],attrs:{"value":"a","name":"group40","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg040,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg040", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Utiliza un vocabulario comprensible para todo el mundo.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg040),expression:"eval_vtas.pg040"}],attrs:{"value":"b","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg040,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg040", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Interesar al auditorio y mantener su atención")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg040),expression:"eval_vtas.pg040"}],attrs:{"value":"c","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg040,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg040", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Hacer participar a todos los asistentes")])])]),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg041===0 ? "color:red" : "color:black")},[_vm._v("41. L...asiste a un partido de fútbol entre dos equipos muy conocidos. El partido es muy disputado y los dos equipos rinden al máximo. Entre los espectadores el entusiasmo es tremendo y: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg041),expression:"eval_vtas.pg041"}],attrs:{"value":"a","name":"group41","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg041,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg041", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) L...se contenta con aplaudir las jugadas mas brillantes.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg041),expression:"eval_vtas.pg041"}],attrs:{"value":"b","name":"group41","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg041,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg041", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) L..es dominado por la agitación general: grita y gesticula como los otros")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg041),expression:"eval_vtas.pg041"}],attrs:{"value":"c","name":"group41","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg041,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg041", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) L...discute con sus vecinos sobre las jugadas de los futbolistas")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg042===0 ? "color:red" : "color:black")},[_vm._v("42. B...Atraviesa la calle por un paso de peatones con el semáforo en rojo. Un coche llega a gran velocidad y se detiene repentinamente a pocos centímetros de B ¿Cuál va a ser la reacción inmediata de éste?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg042),expression:"eval_vtas.pg042"}],attrs:{"value":"a","name":"group42","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg042,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg042", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Hará una observación irónica al mismo tiempo que maldice interiormente al conductor.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg042),expression:"eval_vtas.pg042"}],attrs:{"value":"b","name":"group42","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg042,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg042", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Dará airadamente su opinión al conductor sobre su manera de conducir")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg042),expression:"eval_vtas.pg042"}],attrs:{"value":"c","name":"group42","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg042,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg042", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Lanzará al conductor algunos insultos que no puede reprimir")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg043===0 ? "color:red" : "color:black")},[_vm._v("43. A su modo de ser, ¿Cuál es, entre los siguientes aspectos, el más desatendido actualmente en la educación de su hijo?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg043),expression:"eval_vtas.pg043"}],attrs:{"value":"a","name":"group43","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg043,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg043", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) La aceptación de responsabilidades.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg043),expression:"eval_vtas.pg043"}],attrs:{"value":"b","name":"group43","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg043,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg043", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) A El gusto por el trabajo bien hecho")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg043),expression:"eval_vtas.pg043"}],attrs:{"value":"c","name":"group43","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg043,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg043", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) La capacidad para desenvolverse solo rápidamente")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg044===0 ? "color:red" : "color:black")},[_vm._v("44. T.. acaba de fracasar en un examen. Uno de sus amigos le dice que algunos fracasos son útiles en la vida. ¿Qué responderá él?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg044),expression:"eval_vtas.pg044"}],attrs:{"value":"a","name":"group44","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg044,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg044", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Se ve que no estás en mi lugar; yo preferiría no pasar por esto")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg044),expression:"eval_vtas.pg044"}],attrs:{"value":"b","name":"group44","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg044,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg044", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Puede que tengas razón")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg044),expression:"eval_vtas.pg044"}],attrs:{"value":"c","name":"group44","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg044,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg044", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Admite, por lo menos, que cuando ocurre es difícil de aceptar")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg045===0 ? "color:red" : "color:black")},[_vm._v("45.  L... se encuentra en una reunión amistosa. Sabe muy bien que la mayor parte de los personas presentes tienen opiniones muy diferentes a las suyas. ¿Qué piensa usted que hará?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg045),expression:"eval_vtas.pg045"}],attrs:{"value":"a","name":"group45","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg045,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg045", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Evitar toda discusión.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg045),expression:"eval_vtas.pg045"}],attrs:{"value":"b","name":"group45","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg045,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg045", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Provocar la discusión")])])]),_vm._v(" "),_c('a',[_c('label',[_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg045),expression:"eval_vtas.pg045"}],attrs:{"value":"c","name":"group45","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg045,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg045", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Dar su opinión si no puede evitarlo")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg046===0 ? "color:red" : "color:black")},[_vm._v("46. ¿Que cualidad le parece mas útil en las relaciones sociales? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg046),expression:"eval_vtas.pg046"}],attrs:{"value":"a","name":"group46","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg046,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg046", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) La tolerancia.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg046),expression:"eval_vtas.pg046"}],attrs:{"value":"b","name":"group46","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg046,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg046", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) La sinceridad")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg046),expression:"eval_vtas.pg046"}],attrs:{"value":"c","name":"group46","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg046,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg046", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) La aceptación de compromisos")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg047===0 ? "color:red" : "color:black")},[_vm._v("47. M... acaba de modificar totalmente su apartamento. Invita a sus amigos a la inauguración. Entre los cumplidos que le hagan, ¿cual será para él el más agradable?.")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg047),expression:"eval_vtas.pg047"}],attrs:{"value":"a","name":"group47","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg047,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg047", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Una felicitación sobre su buen gusto.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg047),expression:"eval_vtas.pg047"}],attrs:{"value":"b","name":"group47","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg047,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg047", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Un elogio sobre la forma en que ha sacado partido de la disposición de las habitaciones .")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg047),expression:"eval_vtas.pg047"}],attrs:{"value":"c","name":"group47","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg047,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg047", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Una alabanza a su originalidad, porque su decoración no se parece a ninguna otra ya vista")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg048===0 ? "color:red" : "color:black")},[_vm._v("48. S...llega en el momento de una discusión entre dos personas a las que conoce poco, el tema del que hablan, muy especifico, le es totalmente desconocido y apenas le interesa ¿Cual será su reacción? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg048),expression:"eval_vtas.pg048"}],attrs:{"value":"a","name":"group48","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg048,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg048", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Interviene para informarse, aun a riesgo de parecer ignorante.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg048),expression:"eval_vtas.pg048"}],attrs:{"value":"b","name":"group48","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg048,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg048", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Trata de interesarse por que no quiere parecer incorrecto.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg048),expression:"eval_vtas.pg048"}],attrs:{"value":"c","name":"group48","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg048,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg048", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No interviene porque no puede aportar un punto de vista interesante sobre el asunto.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg049===0 ? "color:red" : "color:black")},[_vm._v("49. R... llega con retraso a una reunión de copropietarios. ¿Qué es lo que probablemente le molestará más?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg049),expression:"eval_vtas.pg049"}],attrs:{"value":"a","name":"group49","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg049,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg049", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) La idea de que hayan podido aprovecharse de su ausencia para tomar una decisión con la que él no este de acuerdo..")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg049),expression:"eval_vtas.pg049"}],attrs:{"value":"b","name":"group49","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg049,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg049", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) El temor de tener dificultad para integrarse en la discusión")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg049),expression:"eval_vtas.pg049"}],attrs:{"value":"c","name":"group49","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg049,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg049", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Las perspectivas de parecer descortés.")])])]),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg050===0 ? "color:red" : "color:black")},[_vm._v("50. Se ha pedido a F...un informe lo más objetivo posible sobre su modo de ser. ¿Quién decidirá el que lo haga?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg050),expression:"eval_vtas.pg050"}],attrs:{"value":"a","name":"group50","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg050,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg050", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Su mujer")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg050),expression:"eval_vtas.pg050"}],attrs:{"value":"b","name":"group50","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg050,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg050", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Un grupo de amigos")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg050),expression:"eval_vtas.pg050"}],attrs:{"value":"c","name":"group50","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg050,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg050", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) El mismo")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(1)}}},[_vm._m(2)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(3)}}},[_vm._m(3)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt3),expression:"vertt3"}],ref:"testt3",attrs:{"id":"testt6"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg051===0 ? "color:red" : "color:black")},[_vm._v("51. X...quiere construir una casa. ¿Cuál de las siguientes soluciones elegirá? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg051),expression:"eval_vtas.pg051"}],attrs:{"value":"a","name":"group51","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg051,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg051", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Llamar a un arquitecto")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg051),expression:"eval_vtas.pg051"}],attrs:{"value":"b","name":"group51","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg051,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg051", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Hacer los planos el mismo y trabajar directamente con un constructor")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg051),expression:"eval_vtas.pg051"}],attrs:{"value":"c","name":"group51","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg051,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg051", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Hacer los planos con un amigo que acaba de hacer una casa")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg052===0 ? "color:red" : "color:black")},[_vm._v("52. T....Es un hombre de negocios generalmente muy ocupado. Una cita anulada a última hora le permite tener una mañana libre totalmente imprevista. ¿Cómo cree usted que lo utilizaría?.")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg052),expression:"eval_vtas.pg052"}],attrs:{"value":"a","name":"group52","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg052,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg052", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Aprovechará para levantarse pronto y pasar la mañana practicando su deporte favorito.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg052),expression:"eval_vtas.pg052"}],attrs:{"value":"b","name":"group52","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg052,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg052", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Hará el balance de la semana que acaba de pasar")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg052),expression:"eval_vtas.pg052"}],attrs:{"value":"c","name":"group52","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg052,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg052", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Constituye para él una ocasión muy poco habitual de poder << perder su tiempo >> y lo aprovechará")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg053===0 ? "color:red" : "color:black")},[_vm._v("53. D... va a Ir a un país del que no conoce nada. Para preparar su viaje, ¿qué cree usted que hará?. ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg053),expression:"eval_vtas.pg053"}],attrs:{"value":"a","name":"group53","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg053,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg053", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Leer libros y guías sobre ese país")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg053),expression:"eval_vtas.pg053"}],attrs:{"value":"b","name":"group53","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg053,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg053", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Preguntar a amigos o parientes que conocen bien el país")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg053),expression:"eval_vtas.pg053"}],attrs:{"value":"c","name":"group53","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg053,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg053", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Esperar a estar en el país para ver e informarse")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg054===0 ? "color:red" : "color:black")},[_vm._v("54. Se oye frecuentemente decir que si una persona cae de repente sobre la acera a las seis de la tarde, un momento en que las calles están abarrotadas, ningún viandante se detiene para ofrecer su ayuda a la persona en dificultades. ¿A qué cree usted que se debe esta conducta?:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg054),expression:"eval_vtas.pg054"}],attrs:{"value":"a","name":"group54","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg054,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg054", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) A una total indiferencia por lo que puede ocurrir a los demás.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg054),expression:"eval_vtas.pg054"}],attrs:{"value":"b","name":"group54","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg054,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg054", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Al miedo ante una situación inesperada")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg054),expression:"eval_vtas.pg054"}],attrs:{"value":"c","name":"group54","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg054,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg054", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Al temor de ocuparse de lo que no le compete a uno")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg055===0 ? "color:red" : "color:black")},[_vm._v("55. Una señora va a consultar a un médico sobre una infección que le parece bastante banal. El médico la interroga ampliamente antes de examinarla. Ella contesta, por supuesto, a las preguntas, pero, en el fondo, ¿qué pensará?:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg055),expression:"eval_vtas.pg055"}],attrs:{"value":"a","name":"group55","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg055,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg055", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) En su lugar, yo comenzaría por hacer el examen y preguntaría después.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg055),expression:"eval_vtas.pg055"}],attrs:{"value":"b","name":"group55","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg055,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg055", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) El debe intentar conocer en qué circunstancias he cogido esta enfermedad")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg055),expression:"eval_vtas.pg055"}],attrs:{"value":"c","name":"group55","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg055,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg055", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Está bien que me hago preguntas, pero hay algunas en los que no veo relación ninguna con lo que yo tengo")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg056===0 ? "color:red" : "color:black")},[_vm._v("56. C... tiene que contratar empleados de oficina; dispone de poco tiempo. ¿Que método empleará? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg056),expression:"eval_vtas.pg056"}],attrs:{"value":"a","name":"group56","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg056,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg056", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Tener una entrevista con los candidatos")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg056),expression:"eval_vtas.pg056"}],attrs:{"value":"b","name":"group56","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg056,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg056", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Examinar sus «curriculum vitae» y sus referencias")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg056),expression:"eval_vtas.pg056"}],attrs:{"value":"c","name":"group56","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg056,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg056", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Hacerles una prueba práctica en el trabajo")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg057===0 ? "color:red" : "color:black")},[_vm._v("57. El mejor delegado de personal es aquel que: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg057),expression:"eval_vtas.pg057"}],attrs:{"value":"a","name":"group57","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg057,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg057", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Es un buen negociador")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg057),expression:"eval_vtas.pg057"}],attrs:{"value":"b","name":"group57","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg057,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg057", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Está convencido de la justicia de la reivindicación")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg057),expression:"eval_vtas.pg057"}],attrs:{"value":"c","name":"group57","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg057,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg057", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Está bien integrado con el personal")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg058===0 ? "color:red" : "color:black")},[_vm._v("58. La señora D... trata inútilmente de hacer que coma su hijo de cinco años; éste se resiste violentamente. ¿Qué hará ella? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg058),expression:"eval_vtas.pg058"}],attrs:{"value":"a","name":"group58","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg058,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg058", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Forzarlo a comer considerando que el niño lo hace por capricho")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg058),expression:"eval_vtas.pg058"}],attrs:{"value":"b","name":"group58","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg058,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg058", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Hacerle un pequeño chantaje del tipo: Demuestra a mamá que eres bueno y que la quieres")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg058),expression:"eval_vtas.pg058"}],attrs:{"value":"c","name":"group58","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg058,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg058", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Dejar al niño, pensando que comerá más en la comida siguiente")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg059===0 ? "color:red" : "color:black")},[_vm._v("59. Se habla frecuente mente del respeto a las \"las reglas del juego\", En general se trata: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg059),expression:"eval_vtas.pg059"}],attrs:{"value":"a","name":"group59","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg059,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg059", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) De una disposición profunda, estable y claramente definida")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg059),expression:"eval_vtas.pg059"}],attrs:{"value":"b","name":"group59","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg059,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg059", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) De la aceptación a desempeñar en cada instante el papel que conviene")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg059),expression:"eval_vtas.pg059"}],attrs:{"value":"c","name":"group59","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg059,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg059", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) De una sumisión sincera a las costumbres de un grupo")])])]),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg060===0 ? "color:red" : "color:black")},[_vm._v("60. C..que es aficionado al bricolage, decide tapizar él mismo un sillón valioso. Cuando llega a la mitad de su trabajo se da cuenta de que corre el peligro de fracasar en su intento. ¿Cual será su decisión?:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg060),expression:"eval_vtas.pg060"}],attrs:{"value":"a","name":"group60","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg060,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg060", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Confiar el sillón a un especialista que realizar un trabajo impecable")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg060),expression:"eval_vtas.pg060"}],attrs:{"value":"b","name":"group60","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg060,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg060", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Deshacer lo que ya ha hecho y comenzar otra vez desde cero ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg060),expression:"eval_vtas.pg060"}],attrs:{"value":"c","name":"group60","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg060,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg060", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Dejar durante unos días su trabajo para re-emprenderlo cuando esté en mejores condiciones")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg061===0 ? "color:red" : "color:black")},[_vm._v("61. C... va a ir con su mujer al campo durante lo días de Pascua. Previendo la afluencia, ha reservado billetes de ferrocarril. Salen de su casa la hora justa, pero un embotellamiento en los alrededores de la estación les hace perder el tren ¿Como cree usted que reaccionará?:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg061),expression:"eval_vtas.pg061"}],attrs:{"value":"a","name":"group61","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg061,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg061", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Siempre pasa lo mismo. Si hubiera estado preparado antes no hubiera ocurrido esto")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg061),expression:"eval_vtas.pg061"}],attrs:{"value":"b","name":"group61","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg061,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg061", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Se han fastidiado las vacaciones…No me apetece nada viajar de pie en el tren siguiente")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg061),expression:"eval_vtas.pg061"}],attrs:{"value":"c","name":"group61","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg061,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg061", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) ¡Qué le vamos a hacer! Voy a devolver los billetes y nos quedaremos en casa")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg062===0 ? "color:red" : "color:black")},[_vm._v("62. A su juicio, la mayoría de los fracasos son debidos a:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg062),expression:"eval_vtas.pg062"}],attrs:{"value":"a","name":"group62","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg062,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg062", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Incapacidad")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg062),expression:"eval_vtas.pg062"}],attrs:{"value":"b","name":"group62","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg062,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg062", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Coincidencia de circunstancias negativas ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg062),expression:"eval_vtas.pg062"}],attrs:{"value":"c","name":"group62","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg062,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg062", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Fallos ocasionales")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg063===0 ? "color:red" : "color:black")},[_vm._v("63.  F... ha encargado un frigorífico. En su ausencia, lo depositan en casa del conserje. El embalaje está estropeado, por lo cual el frigorífico ha sufrido algunos daños. F... decide hacer una gestión ante los servicios de distribución. ¿De qué forma se comportará?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg063),expression:"eval_vtas.pg063"}],attrs:{"value":"a","name":"group63","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg063,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg063", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Escribirá a los citados servicios conservando una copia de la carta")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg063),expression:"eval_vtas.pg063"}],attrs:{"value":"b","name":"group63","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg063,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg063", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Irá personalmente a reclamar")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg063),expression:"eval_vtas.pg063"}],attrs:{"value":"c","name":"group63","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg063,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg063", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Rogará a uno de sus amigos, empleado en esa casa, que intervenga")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg064===0 ? "color:red" : "color:black")},[_vm._v("64. Con ocasión de un viaje organizado, B... se encuentra con personas que no conoce. Al cabo de unos días se da cuenta de que la mayoría de las personas le tienen poca simpatía. ¿Cómo cree usted que reaccionará?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg064),expression:"eval_vtas.pg064"}],attrs:{"value":"a","name":"group64","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg064,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg064", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Le trae sin cuidado, porque para él lo importante es que el viaje está bien organizado y que el guía sea eficaz")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg064),expression:"eval_vtas.pg064"}],attrs:{"value":"b","name":"group64","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg064,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg064", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Está un poco molesto y trato de hacer un esfuerzo para resultar más simpático")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg064),expression:"eval_vtas.pg064"}],attrs:{"value":"c","name":"group64","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg064,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg064", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Esto le amarga, en parte, sus vacaciones y propone que, en la próximo ocasión, se irá con sus amigos.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg065===0 ? "color:red" : "color:black")},[_vm._v("65. R... Hace un viaje con algunos amigos. Una tarde el grupo se separa, después de haberse puesto de acuerdo en la hora para la salida. A lo largo de está tarde, R... descubre un monumento que le interesa mucho visitar, pero si lo hace le será imposible llegar a la cita, ¿Qué hará?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg065),expression:"eval_vtas.pg065"}],attrs:{"value":"a","name":"group65","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg065,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg065", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Hace la visita por que piensa que no tendrá ya ocasión de volver a este lugar y que de todas formas habrá otros que llegarán tarde también")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg065),expression:"eval_vtas.pg065"}],attrs:{"value":"b","name":"group65","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg065,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg065", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Renuncia a está visita por que le parece más importante no hacer esperar a los demás.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg065),expression:"eval_vtas.pg065"}],attrs:{"value":"c","name":"group65","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg065,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg065", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Trata de encontrar a sus amigos para persuadirlos de que hagan las misma visita con él, aun a riesgo de desorganizar la última parte de viaje.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg066===0 ? "color:red" : "color:black")},[_vm._v("66. ¿Cual de estás profesiones le parece a usted la más envidiable?: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg066),expression:"eval_vtas.pg066"}],attrs:{"value":"a","name":"group66","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg066,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg066", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Gerente de una pequeña empresa")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg066),expression:"eval_vtas.pg066"}],attrs:{"value":"b","name":"group66","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg066,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg066", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Director adjunto de una empresa internacional")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg066),expression:"eval_vtas.pg066"}],attrs:{"value":"c","name":"group66","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg066,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg066", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Asesor científico de alto nivel")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg067===0 ? "color:red" : "color:black")},[_vm._v("67. A causa de un accidente que ha causado la muerte de los padres de un niño pequeño, J...tiene que encargarse del niño con carácter definitivo. ¿Cuál será la actitud más probable que tendrá a este respecto? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg067),expression:"eval_vtas.pg067"}],attrs:{"value":"a","name":"group67","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg067,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg067", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Teme verse obligado a revisar su sistema de educación")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg067),expression:"eval_vtas.pg067"}],attrs:{"value":"b","name":"group67","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg067,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg067", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Confía en el buen carácter del niño")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg067),expression:"eval_vtas.pg067"}],attrs:{"value":"c","name":"group67","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg067,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg067", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Busca otras alternativas para el niño")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg068===0 ? "color:red" : "color:black")},[_vm._v("68. Un amigo propone a T... llevarle en su velero a hacer un pequeño crucero. T...nunca ha practicado la vela. ¿Que cree usted que decidiría?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg068),expression:"eval_vtas.pg068"}],attrs:{"value":"a","name":"group68","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg068,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg068", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Aceptar, pensando que podría desenvolverse bien.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg068),expression:"eval_vtas.pg068"}],attrs:{"value":"b","name":"group68","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg068,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg068", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Arreglárselas para hacer antes algunas horas de vela en una escuela.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg068),expression:"eval_vtas.pg068"}],attrs:{"value":"c","name":"group68","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg068,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg068", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No aceptar, ante el temor de ser una molestia para su amigo.")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg069===0 ? "color:red" : "color:black")},[_vm._v("69. T...va hacia el trabajo por su camino habitual, una furgoneta de reparto le bloquea durante un buen rato en una calle estrecha. A juicio de usted, ¿Qué será lo más desagradable para T...?. ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg069),expression:"eval_vtas.pg069"}],attrs:{"value":"a","name":"group69","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg069,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg069", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) La perspectiva de llegar con retraso a su despacho")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg069),expression:"eval_vtas.pg069"}],attrs:{"value":"b","name":"group69","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg069,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg069", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) El hecho de tener que esperar sin poder moverse ni hacer nada.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg069),expression:"eval_vtas.pg069"}],attrs:{"value":"c","name":"group69","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg069,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg069", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Los toques de claxon - inútiles – de otros automovilistas")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg070===0 ? "color:red" : "color:black")},[_vm._v("70. G...trabaja en una empresa para la que debe efectuar frecuentes desplazamientos. Acostumbra a hacer dos horas de atletismo todas las semanas en una sesión de entrenamiento colectivo. A juicio de usted ¿cuál es su actitud en el curso de está sesión?:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg070),expression:"eval_vtas.pg070"}],attrs:{"value":"a","name":"group70","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg070,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg070", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Insiste en ciertas especialidades que le permitan mantenerse en buena forma.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg070),expression:"eval_vtas.pg070"}],attrs:{"value":"b","name":"group70","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg070,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg070", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Realiza todas las actividades propuestas, pero sin esforzarse demasiado, por que tiene un trabajo cansado.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg070),expression:"eval_vtas.pg070"}],attrs:{"value":"c","name":"group70","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg070,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg070", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Se entrega a fondo y frecuentemente termina agotado, por que no concibe el deporte de otra manera.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg071===0 ? "color:red" : "color:black")},[_vm._v("71. Según su criterio, ¿Cuál es la ventaja de tener un perro en un apartamento en la ciudad?. ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg071),expression:"eval_vtas.pg071"}],attrs:{"value":"a","name":"group71","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg071,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg071", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Permite sentirse menos solo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg071),expression:"eval_vtas.pg071"}],attrs:{"value":"b","name":"group71","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg071,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg071", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Favorece la ocasión de caminar un poco cada día paseando al perro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg071),expression:"eval_vtas.pg071"}],attrs:{"value":"c","name":"group71","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg071,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg071", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Vigila el departamento.")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg072===0 ? "color:red" : "color:black")},[_vm._v("72.  En el transcurso de una reunión en que S... se ha encontrado con amigos, les propone terminar la velada en su casa. Al enterarse se une a ellos una persona que se mantenía alejada del grupo y a la que el estima poco. ¿Cuál será la reacción de S...?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg072),expression:"eval_vtas.pg072"}],attrs:{"value":"a","name":"group72","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg072,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg072", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Piensa que, después de todo, tendrá ocasión de conocer mejor a está persona.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg072),expression:"eval_vtas.pg072"}],attrs:{"value":"b","name":"group72","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg072,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg072", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Estimando que se ha invitado a si misma, no se ocupará de ella en toda la noche")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg072),expression:"eval_vtas.pg072"}],attrs:{"value":"c","name":"group72","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg072,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg072", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Lamenta haber hablado demasiado alto")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg073===0 ? "color:red" : "color:black")},[_vm._v("73. El director de un centro de delincuentes debe contratar a una nueva educadora. ¿A cuál de estas cualidades dará más importancia?.")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg073),expression:"eval_vtas.pg073"}],attrs:{"value":"a","name":"group73","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg073,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg073", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Ser irreprochable y poder servir de modelo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg073),expression:"eval_vtas.pg073"}],attrs:{"value":"b","name":"group73","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg073,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg073", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Tener buenos conocimientos pedagógicos")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg073),expression:"eval_vtas.pg073"}],attrs:{"value":"c","name":"group73","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg073,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg073", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Saber escuchar")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg074===0 ? "color:red" : "color:black")},[_vm._v("74.  Según su opinión, ¿ Que es más importante en una persona que da una fiesta ?:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg074),expression:"eval_vtas.pg074"}],attrs:{"value":"a","name":"group74","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg074,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg074", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Permitir a todos expresarse")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg074),expression:"eval_vtas.pg074"}],attrs:{"value":"b","name":"group74","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg074,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg074", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Invitar a personas que puedan coincidir con sus intereses")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg074),expression:"eval_vtas.pg074"}],attrs:{"value":"c","name":"group74","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg074,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg074", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Cuidar de que a nadie le falte nada.")])])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s5"},[_c('span',{style:(_vm.eval_vtas.pg075===0 ? "color:red" : "color:black")},[_vm._v("75. R... ha de exponer un proyecto a un colega que no conoce. Para que R... pueda hacerse comprender por su interlocutor, es preferible que: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg075),expression:"eval_vtas.pg075"}],attrs:{"value":"a","name":"group75","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg075,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg075", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sepa cuál es su formación académica")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg075),expression:"eval_vtas.pg075"}],attrs:{"value":"b","name":"group75","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg075,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg075", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Conozca sus antecedentes profesionales")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg075),expression:"eval_vtas.pg075"}],attrs:{"value":"c","name":"group75","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg075,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg075", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Lea el informe sobre un trabajo hecho por su colega.")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(2)}}},[_vm._m(4)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(4)}}},[_vm._m(5)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt4),expression:"vertt4"}],ref:"testt4",attrs:{"id":"testt7"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg076===0 ? "color:red" : "color:black")},[_vm._v("76. Si tuviera que hacer algún reproche a la profesión médica, ¿Cuál escogería ?:")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg076),expression:"eval_vtas.pg076"}],attrs:{"value":"a","name":"group76","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg076,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg076", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) No consagra suficiente tiempo a cada enfermo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg076),expression:"eval_vtas.pg076"}],attrs:{"value":"b","name":"group76","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg076,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg076", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Da demasiada importancia al dinero")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg076),expression:"eval_vtas.pg076"}],attrs:{"value":"c","name":"group76","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg076,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg076", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Utiliza a menudo un vocabulario incomprensible")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg077===0 ? "color:red" : "color:black")},[_vm._v("77. N...tiene que escoger un plan de formación para las personas de su departamento. Desearía una formación interesante para todos, pero a la vez, eficaz y rentable. ¿Qué elegirá?.")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg077),expression:"eval_vtas.pg077"}],attrs:{"value":"a","name":"group77","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg077,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg077", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Un plan organizado en función de las necesidades del departamento y en el que todas las fases están definidas de antemano")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg077),expression:"eval_vtas.pg077"}],attrs:{"value":"b","name":"group77","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg077,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg077", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Un plan que tenga en cuenta a cada participante")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg077),expression:"eval_vtas.pg077"}],attrs:{"value":"c","name":"group77","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg077,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg077", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Un plan que incluya de manera regular exámenes de control.")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg078===0 ? "color:red" : "color:black")},[_vm._v("78. M... acaba de tener un ataque al hígado, sin embargo un amigo le llama para invitarle a comer, precisando que le ha preparado su plato favorito. Supuesto que este plato esta contraindicando para él en este momento. ¿Cuál será la reacción de M..? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg078),expression:"eval_vtas.pg078"}],attrs:{"value":"a","name":"group78","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg078,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg078", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Aceptar la invitación pensando que por una vez no hará caso de su régimen")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg078),expression:"eval_vtas.pg078"}],attrs:{"value":"b","name":"group78","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg078,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg078", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Proponer que se aplace esta invitación para más adelante, cuando acabe su régimen")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg078),expression:"eval_vtas.pg078"}],attrs:{"value":"c","name":"group78","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg078,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg078", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Denegar la invitación por problemas de salud")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg079===0 ? "color:red" : "color:black")},[_vm._v("79. M... no está satisfecha con la Seguridad Social. Lo que más le desagrada es: ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg079),expression:"eval_vtas.pg079"}],attrs:{"value":"a","name":"group79","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg079,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg079", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Lo absurdo de algunas disposiciones de esta entidad")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg079),expression:"eval_vtas.pg079"}],attrs:{"value":"b","name":"group79","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg079,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg079", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) La gran dificultad de atenerse a la complejidad de su reglamento")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg079),expression:"eval_vtas.pg079"}],attrs:{"value":"c","name":"group79","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg079,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg079", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) La falta de atención a aspectos que él cree fundamentales.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg080===0 ? "color:red" : "color:black")},[_vm._v("80. Y...ha decidido consagrar una parte de su tiempo libre a ayudar a las personas de la tercera edad. Existen varias posibilidades. ¿Cuál elegirá en último lugar cuando no hay otras alternativas?. ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg080),expression:"eval_vtas.pg080"}],attrs:{"value":"a","name":"group80","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg080,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg080", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Acompañar a las personas ancianas durante el paseo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg080),expression:"eval_vtas.pg080"}],attrs:{"value":"b","name":"group80","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg080,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg080", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Visitar una persona mayor cada semana")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg080),expression:"eval_vtas.pg080"}],attrs:{"value":"c","name":"group80","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg080,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg080", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Hacer colectas para la construcción de un lugar de ancianos")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg081===0 ? "color:red" : "color:black")},[_vm._v("81. Entre los siguientes argumentos publicitarios. ¿Cuál tiene mas probabilidades de influir en el publico? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg081),expression:"eval_vtas.pg081"}],attrs:{"value":"a","name":"group81","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg081,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg081", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) El muestrario")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg081),expression:"eval_vtas.pg081"}],attrs:{"value":"b","name":"group81","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg081,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg081", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) El slogan")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg081),expression:"eval_vtas.pg081"}],attrs:{"value":"c","name":"group81","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg081,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg081", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) El testimonio de una estrella")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg082===0 ? "color:red" : "color:black")},[_vm._v("82. En el transcurso de un viaje en tren, D... se encuentra en un compartimiento abarrotado. Su vecino fuma y el humo le molesta mucho. Ya le ha rogado que dejara de fumar, sin resultado. ¿Qué hará? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg082),expression:"eval_vtas.pg082"}],attrs:{"value":"a","name":"group82","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg082,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg082", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Pedir el parecer de otros viajeros del compartimiento")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg082),expression:"eval_vtas.pg082"}],attrs:{"value":"b","name":"group82","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg082,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg082", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Abrir la ventana")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg082),expression:"eval_vtas.pg082"}],attrs:{"value":"c","name":"group82","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg082,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg082", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Hablar de nuevo con su vecino con el objeto de convencerlo de que deje de fumar.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg083===0 ? "color:red" : "color:black")},[_vm._v("83. El director del departamento de una empresa de productos alimenticios desea lanzar al mercado un nuevo postre. Dispone de un presupuestoque puede repartir en los tres conceptos que se citan a continuación. ¿En cual de ella empleará más dinero?. ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg083),expression:"eval_vtas.pg083"}],attrs:{"value":"a","name":"group83","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg083,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg083", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) En estudios de mercado para conocer los gastos de los futuros compradores")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg083),expression:"eval_vtas.pg083"}],attrs:{"value":"b","name":"group83","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg083,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg083", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) En publicidad para dar a conocer su producto.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg083),expression:"eval_vtas.pg083"}],attrs:{"value":"c","name":"group83","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg083,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg083", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) En la investigación de envases y presentación")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg084===0 ? "color:red" : "color:black")},[_vm._v("84. B... toma parte de una discusión muy animada en el transcurso de la cual sus opiniones son muy atacadas. Entre las actitudes siguientes, ¿cuál será la que adopte?. ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg084),expression:"eval_vtas.pg084"}],attrs:{"value":"a","name":"group84","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg084,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg084", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Tratar por todos los medios de convencer a los demás.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg084),expression:"eval_vtas.pg084"}],attrs:{"value":"b","name":"group84","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg084,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg084", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Divertirse simplemente en el juego de la discusión")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg084),expression:"eval_vtas.pg084"}],attrs:{"value":"c","name":"group84","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg084,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg084", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Dejarse convencer cuando vea que sus posiciones son poco defendibles")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg085===0 ? "color:red" : "color:black")},[_vm._v("85. Cuando usted va a un restaurante, ¿qué tipo de palto prefiere? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg085),expression:"eval_vtas.pg085"}],attrs:{"value":"a","name":"group85","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg085,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg085", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Uno que ya conoce y que le gusta de modo especial")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg085),expression:"eval_vtas.pg085"}],attrs:{"value":"b","name":"group85","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg085,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg085", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) La especialidad de la casa.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg085),expression:"eval_vtas.pg085"}],attrs:{"value":"c","name":"group85","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg085,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg085", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Un plato exótico que usted desconoce en absoluto.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg086===0 ? "color:red" : "color:black")},[_vm._v("86. Después de un naufragio, C...llega sólo a una isla desierta. El clima es muy agradable y la vegetación le permitirá encontrar el alimento necesario. ¿Qué es a su modo de ver, lo que probablemente le planteará menos problemas?. ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg086),expression:"eval_vtas.pg086"}],attrs:{"value":"a","name":"group86","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg086,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg086", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) El carácter nuevo e insólito de la situación")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg086),expression:"eval_vtas.pg086"}],attrs:{"value":"b","name":"group86","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg086,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg086", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) La soledad")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg086),expression:"eval_vtas.pg086"}],attrs:{"value":"c","name":"group86","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg086,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg086", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) La falta de algunos atractivos de la vida anterior.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_vtas.pg087===0 ? "color:red" : "color:black")},[_vm._v("87. J...dirige una importante firma automovilista puede escoger entre varias políticas comerciales. ¿Cuál elegirá ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg087),expression:"eval_vtas.pg087"}],attrs:{"value":"a","name":"group87","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_vtas.pg087,"a")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg087", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Orientar sus esfuerzos para sacar de vez en cuando modelos especiales.")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg087),expression:"eval_vtas.pg087"}],attrs:{"value":"b","name":"group87","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg087,"b")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg087", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Buscar los efectos de moda y atender a una clientela particular")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_vtas.pg087),expression:"eval_vtas.pg087"}],attrs:{"value":"c","name":"group87","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_vtas.pg087,"c")},on:{"change":function($event){_vm.$set(_vm.eval_vtas, "pg087", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Ofrecer de ordinario modelos clásicos.")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(6)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(3)}}},[_vm._m(7)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grabado===false),expression:"grabado===false"}],staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn tooltipped",attrs:{"data-position":"left","data-tooltip":"Grabar"},on:{"click":function($event){_vm.agregarEvaluacion()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("SELECCIONE EL SIGUIENTE BOTON PARA EMPEZAR LA EVALUACION.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("first_page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev12_aedp_js__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f4e83e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev12_aedp_vue__ = __webpack_require__(341);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev12_aedp_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f4e83e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev12_aedp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 l2"},[_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v("*Departamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.depto),expression:"eval_aedp.depto"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_aedp.depto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_aedp, "depto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s12 l3"},[_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v("*Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.empresa),expression:"eval_aedp.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_aedp.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_aedp, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s12 l3"},[_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v("*Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.nombre),expression:"eval_aedp.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_aedp.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_aedp, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s12 l1"},[_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v("Sexo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.sexo),expression:"eval_aedp.sexo"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_aedp.sexo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_aedp, "sexo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s12 l3"},[_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v("*Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inicioeval===true),expression:"!inicioeval===true"}],staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticStyle:{"font-size":"16px","font-weight":"bold"}},[_vm._v("\n                                    "+_vm._s(_vm.instrucciones)+"\n                               ")])]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row",staticStyle:{"font-size":"16px"},attrs:{"align":"justify"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"col s12 l12"},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s4"},[_c('a',{ref:"tabul1",class:_vm.activo1,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"tabul1","href":"#tabu1"},on:{"click":function($event){_vm.nadaE(1)}}},[_vm._v("Grupo 1")])]),_vm._v(" "),_c('li',{staticClass:"tab col s4"},[_c('a',{ref:"tabul2",class:_vm.activo2,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"tabul2","href":"#tabu2"},on:{"click":function($event){_vm.nadaE(2)}}},[_vm._v("Grupo 2")])]),_vm._v(" "),_c('li',{staticClass:"tab col s4"},[_c('a',{ref:"tabul3",class:_vm.activo3,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"tabul3","href":"#tabu3"},on:{"click":function($event){_vm.nadaE(3)}}},[_vm._v("Grupo 3")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ver1),expression:"ver1"}],ref:"tabu1",attrs:{"id":"tabu1"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col s12 l8"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.prueba==="" ? "color:red" : "color:black")},[_vm._v("\n                                                        01. Despedido o renunció o se jubiló\n                                                   ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba),expression:"prueba"}],ref:"prueba",attrs:{"id":"prueba","value":"3","name":"prueba","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.prueba,"3")},on:{"change":function($event){_vm.prueba="3"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba),expression:"prueba"}],attrs:{"value":"2","name":"prueba","type":"radio"},domProps:{"checked":_vm._q(_vm.prueba,"2")},on:{"change":function($event){_vm.prueba="2"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba),expression:"prueba"}],attrs:{"value":"1","name":"prueba","type":"radio"},domProps:{"checked":_vm._q(_vm.prueba,"1")},on:{"change":function($event){_vm.prueba="1"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l4"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba),expression:"prueba"}],attrs:{"value":"0","name":"prueba","type":"radio"},domProps:{"checked":_vm._q(_vm.prueba,"0")},on:{"change":function($event){_vm.prueba="0"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueE(2)}}},[_vm._m(4)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ver2),expression:"ver2"}],ref:"tabu2",attrs:{"id":"tabu2"}},[_c('div',{staticClass:"col s12 l12"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.ver2),expression:"ver2"}],staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                                                        GRUPO NUMERO 2\n                                                        "),_c('br')])]),_vm._v(" "),_c('div',{ref:"prueba2",staticClass:"col s12 l12",attrs:{"id":"prueba2"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.prueba2==="" ? "color:red" : "color:black")},[_vm._v("\n                                                        02. Pregunta 2\n                                                   ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba2),expression:"prueba2"}],attrs:{"value":"3","name":"prueba2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.prueba2,"3")},on:{"change":function($event){_vm.prueba2="3"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba2),expression:"prueba2"}],attrs:{"value":"2","name":"prueba2","type":"radio"},domProps:{"checked":_vm._q(_vm.prueba2,"2")},on:{"change":function($event){_vm.prueba2="2"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba2),expression:"prueba2"}],attrs:{"value":"1","name":"prueba2","type":"radio"},domProps:{"checked":_vm._q(_vm.prueba2,"1")},on:{"change":function($event){_vm.prueba2="1"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba2),expression:"prueba2"}],attrs:{"value":"0","name":"prueba2","type":"radio"},domProps:{"checked":_vm._q(_vm.prueba2,"0")},on:{"change":function($event){_vm.prueba2="0"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRE(1)}}},[_vm._m(5)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueE(3)}}},[_vm._m(6)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ver3),expression:"ver3"}],ref:"tabu3",attrs:{"id":"tabu3"}},[_vm._m(7),_vm._v(" "),_c('div',{ref:"prueba3",staticClass:"col s12 l12",attrs:{"id":"prueba3"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.prueba3==="" ? "color:red" : "color:black")},[_vm._v("\n                                                        03. Pregunta 3\n                                                   ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba3),expression:"prueba3"}],attrs:{"value":"3","name":"prueba3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.prueba3,"3")},on:{"change":function($event){_vm.prueba3="3"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba3),expression:"prueba3"}],attrs:{"value":"2","name":"prueba3","type":"radio"},domProps:{"checked":_vm._q(_vm.prueba3,"2")},on:{"change":function($event){_vm.prueba3="2"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba3),expression:"prueba3"}],attrs:{"value":"1","name":"prueba3","type":"radio"},domProps:{"checked":_vm._q(_vm.prueba3,"1")},on:{"change":function($event){_vm.prueba3="1"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prueba3),expression:"prueba3"}],attrs:{"value":"0","name":"prueba3","type":"radio"},domProps:{"checked":_vm._q(_vm.prueba3,"0")},on:{"change":function($event){_vm.prueba3="0"}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueE(0)}}},[_vm._m(8)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRE(2)}}},[_vm._m(9)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12 l12 center"},[_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("\n                                              Haga CLICK aquí para empezar la Evaluación de AUTO EXPLORACIÓN EMOCIONAL PARA EL DESARROLLO PERSONAL\n                                         ")])])])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"row col s12 l12"},[_c('div',{staticClass:"col s12 l3"},[_c('span',{style:(_vm.pregSinContestar>0 ? "color:red;font-size:16px;font-weight:bold;" : "color:black;font-size:16px;font-weight:bold;")},[_vm._v("\n                     PREGUNTAS SIN RESPONDER: "+_vm._s(_vm.l_sinResponder)+" / "+_vm._s(_vm.totalPreguntas)+"\n                     "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"col s12 l3"},[_c('input',{staticClass:"waves-effect waves-light blue btn",attrs:{"id":"grupo1","type":"button","value":"SELECCIONAR PREGUNTAS DE LAS ÁREAS 1 A 10"},on:{"click":function($event){_vm.areas1_10()}}})]),_vm._v(" "),_c('div',{staticClass:"col s12 l3"},[_c('input',{staticClass:"waves-effect waves-light blue btn",attrs:{"id":"grupo2","type":"button","value":"SELECCIONAR PREGUNTAS DE LAS ÁREAS 11 A 21"},on:{"click":function($event){_vm.areas11_21()}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grupo1),expression:"grupo1"}]},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt1"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("Área 1")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt2"},on:{"click":function($event){_vm.nadaG1(2)}}},[_vm._v("Área 2")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt3",class:_vm.activott3,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt3","href":"#testt3"},on:{"click":function($event){_vm.nadaG1(3)}}},[_vm._v("Área 3")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt4",class:_vm.activott4,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt4","href":"#testt4"},on:{"click":function($event){_vm.nadaG1(4)}}},[_vm._v("Área 4")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt5",class:_vm.activott5,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt5","href":"#testt5"},on:{"click":function($event){_vm.nadaG1(5)}}},[_vm._v("Área 5")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt6",class:_vm.activott6,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt6","href":"#testt6"},on:{"click":function($event){_vm.nadaG1(6)}}},[_vm._v("Área 6")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt7",class:_vm.activott7,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt7","href":"#testt7"},on:{"click":function($event){_vm.nadaG1(7)}}},[_vm._v("Área 7")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt8",class:_vm.activott8,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt8","href":"#testt8"},on:{"click":function($event){_vm.nadaG1(8)}}},[_vm._v("Área 8")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt9",class:_vm.activott9,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt9","href":"#testt9"},on:{"click":function($event){_vm.nadaG1(9)}}},[_vm._v("Área 9")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt10",class:_vm.activott10,staticStyle:{"font-size":"17px","font-weight":"bold"},attrs:{"id":"testtt10","href":"#testt10"},on:{"click":function($event){_vm.nadaG1(10)}}},[_vm._v("Área 10")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt1"}},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg001==="" ? "color:red" : "color:black")},[_vm._v("\n                                    01. Despedido o renunció o se jubiló\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg001),expression:"eval_aedp.pg001"}],attrs:{"value":"3","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg001,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg001", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg001),expression:"eval_aedp.pg001"}],attrs:{"value":"2","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg001,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg001", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg001),expression:"eval_aedp.pg001"}],attrs:{"value":"1","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg001,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg001", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg001),expression:"eval_aedp.pg001"}],attrs:{"value":"0","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg001,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg001", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg002==="" ? "color:red" : "color:black")},[_vm._v("\n                                    02. Nuevo empleo o compañía\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg002),expression:"eval_aedp.pg002"}],attrs:{"value":"3","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg002,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg002", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg002),expression:"eval_aedp.pg002"}],attrs:{"value":"2","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg002,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg002", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg002),expression:"eval_aedp.pg002"}],attrs:{"value":"1","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg002,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg002", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg002),expression:"eval_aedp.pg002"}],attrs:{"value":"0","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg002,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg002", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg003==="" ? "color:red" : "color:black")},[_vm._v("\n                                    03. Nuevo tipo de trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg003),expression:"eval_aedp.pg003"}],attrs:{"value":"3","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg003,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg003", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg003),expression:"eval_aedp.pg003"}],attrs:{"value":"2","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg003,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg003", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg003),expression:"eval_aedp.pg003"}],attrs:{"value":"1","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg003,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg003", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg003),expression:"eval_aedp.pg003"}],attrs:{"value":"0","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg003,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg003", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg004==="" ? "color:red" : "color:black")},[_vm._v("\n                                    04. Reducción o reorganización en la compañia\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg004),expression:"eval_aedp.pg004"}],attrs:{"value":"3","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg004,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg004", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg004),expression:"eval_aedp.pg004"}],attrs:{"value":"2","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg004,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg004", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg004),expression:"eval_aedp.pg004"}],attrs:{"value":"1","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg004,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg004", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg004),expression:"eval_aedp.pg004"}],attrs:{"value":"0","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg004,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg004", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg005==="" ? "color:red" : "color:black")},[_vm._v("\n                                         05. Algún otro cambio en el trabajo, \n                                         no incluido en la lista anterior, que le \n                                         produjo angustia\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg005),expression:"eval_aedp.pg005"}],attrs:{"value":"3","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg005,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg005", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg005),expression:"eval_aedp.pg005"}],attrs:{"value":"2","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg005,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg005", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg005),expression:"eval_aedp.pg005"}],attrs:{"value":"1","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg005,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg005", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg005),expression:"eval_aedp.pg005"}],attrs:{"value":"0","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg005,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg005", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg006==="" ? "color:red" : "color:black")},[_vm._v("\n                                    06. Pérdida económica o disminución de ingresos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg006),expression:"eval_aedp.pg006"}],attrs:{"value":"3","name":"group6","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg006,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg006", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg006),expression:"eval_aedp.pg006"}],attrs:{"value":"2","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg006,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg006", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg006),expression:"eval_aedp.pg006"}],attrs:{"value":"1","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg006,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg006", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg006),expression:"eval_aedp.pg006"}],attrs:{"value":"0","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg006,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg006", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg007==="" ? "color:red" : "color:black")},[_vm._v("\n                                    07. Muerte de un amigo íntimo o miembro de familia\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg007),expression:"eval_aedp.pg007"}],attrs:{"value":"3","name":"group7","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg007,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg007", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg007),expression:"eval_aedp.pg007"}],attrs:{"value":"2","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg007,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg007", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg007),expression:"eval_aedp.pg007"}],attrs:{"value":"1","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg007,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg007", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg007),expression:"eval_aedp.pg007"}],attrs:{"value":"0","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg007,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg007", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg008==="" ? "color:red" : "color:black")},[_vm._v("\n                                    08. Mudanza o traslado\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg008),expression:"eval_aedp.pg008"}],attrs:{"value":"3","name":"group8","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg008,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg008", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg008),expression:"eval_aedp.pg008"}],attrs:{"value":"2","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg008,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg008", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg008),expression:"eval_aedp.pg008"}],attrs:{"value":"1","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg008,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg008", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg008),expression:"eval_aedp.pg008"}],attrs:{"value":"0","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg008,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg008", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg009==="" ? "color:red" : "color:black")},[_vm._v("\n                                    09. Su separación o divorcio\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg009),expression:"eval_aedp.pg009"}],attrs:{"value":"3","name":"group9","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg009,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg009", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg009),expression:"eval_aedp.pg009"}],attrs:{"value":"2","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg009,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg009", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg009),expression:"eval_aedp.pg009"}],attrs:{"value":"1","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg009,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg009", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg009),expression:"eval_aedp.pg009"}],attrs:{"value":"0","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg009,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg009", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg010==="" ? "color:red" : "color:black")},[_vm._v("\n                                    10. Matrimonio\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg010),expression:"eval_aedp.pg010"}],attrs:{"value":"3","name":"group10","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg010,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg010", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg010),expression:"eval_aedp.pg010"}],attrs:{"value":"2","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg010,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg010", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg010),expression:"eval_aedp.pg010"}],attrs:{"value":"1","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg010,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg010", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg010),expression:"eval_aedp.pg010"}],attrs:{"value":"0","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg010,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg010", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg011==="" ? "color:red" : "color:black")},[_vm._v("\n                                    11. Compró una nueva casa\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg011),expression:"eval_aedp.pg011"}],attrs:{"value":"3","name":"group11","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg011,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg011", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg011),expression:"eval_aedp.pg011"}],attrs:{"value":"2","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg011,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg011", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg011),expression:"eval_aedp.pg011"}],attrs:{"value":"1","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg011,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg011", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg011),expression:"eval_aedp.pg011"}],attrs:{"value":"0","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg011,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg011", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg012==="" ? "color:red" : "color:black")},[_vm._v("\n                                    12. Fue victima de un crimen\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg012),expression:"eval_aedp.pg012"}],attrs:{"value":"3","name":"group12","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg012,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg012", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg012),expression:"eval_aedp.pg012"}],attrs:{"value":"2","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg012,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg012", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg012),expression:"eval_aedp.pg012"}],attrs:{"value":"1","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg012,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg012", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg012),expression:"eval_aedp.pg012"}],attrs:{"value":"0","name":"group12","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg012,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg012", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg013==="" ? "color:red" : "color:black")},[_vm._v("\n                                    13. Nacimiento de un hijo, adopción, hijastros u otras personales\n                                    agregadas al hogar\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg013),expression:"eval_aedp.pg013"}],attrs:{"value":"3","name":"group13","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg013,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg013", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg013),expression:"eval_aedp.pg013"}],attrs:{"value":"2","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg013,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg013", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg013),expression:"eval_aedp.pg013"}],attrs:{"value":"1","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg013,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg013", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg013),expression:"eval_aedp.pg013"}],attrs:{"value":"0","name":"group13","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg013,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg013", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg014==="" ? "color:red" : "color:black")},[_vm._v("\n                                    14. Complicación en el sistema judicial\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg014),expression:"eval_aedp.pg014"}],attrs:{"value":"3","name":"group14","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg014,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg014", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg014),expression:"eval_aedp.pg014"}],attrs:{"value":"2","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg014,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg014", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg014),expression:"eval_aedp.pg014"}],attrs:{"value":"1","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg014,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg014", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg014),expression:"eval_aedp.pg014"}],attrs:{"value":"0","name":"group14","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg014,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg014", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg015==="" ? "color:red" : "color:black")},[_vm._v("\n                                    15. Seria enfermedad personal o heridas.\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg015),expression:"eval_aedp.pg015"}],attrs:{"value":"3","name":"group15","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg015,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg015", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg015),expression:"eval_aedp.pg015"}],attrs:{"value":"2","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg015,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg015", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg015),expression:"eval_aedp.pg015"}],attrs:{"value":"1","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg015,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg015", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg015),expression:"eval_aedp.pg015"}],attrs:{"value":"0","name":"group15","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg015,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg015", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg016==="" ? "color:red" : "color:black")},[_vm._v("\n                                    16. Serie enfermedad o lesiones de un amigo o de la familia\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg016),expression:"eval_aedp.pg016"}],attrs:{"value":"3","name":"group16","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg016,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg016", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg016),expression:"eval_aedp.pg016"}],attrs:{"value":"2","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg016,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg016", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg016),expression:"eval_aedp.pg016"}],attrs:{"value":"1","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg016,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg016", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg016),expression:"eval_aedp.pg016"}],attrs:{"value":"0","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg016,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg016", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg017==="" ? "color:red" : "color:black")},[_vm._v("\n                                    17. Aumento de responsabilidad de cuidar de un pariente viejo o invalido\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg017),expression:"eval_aedp.pg017"}],attrs:{"value":"3","name":"group17","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg017,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg017", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg017),expression:"eval_aedp.pg017"}],attrs:{"value":"2","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg017,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg017", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg017),expression:"eval_aedp.pg017"}],attrs:{"value":"1","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg017,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg017", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg017),expression:"eval_aedp.pg017"}],attrs:{"value":"0","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg017,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg017", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{ref:"area1",staticClass:"input-field col s12 l4",attrs:{"id":"area1"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg018==="" ? "color:red" : "color:black")},[_vm._v("\n                                    18. Cualquier otro cambio no incluido en la lista anterior\n                                    que le produjo angustia\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg018),expression:"eval_aedp.pg018"}],attrs:{"value":"3","name":"group18","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg018,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg018", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg018),expression:"eval_aedp.pg018"}],attrs:{"value":"2","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg018,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg018", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg018),expression:"eval_aedp.pg018"}],attrs:{"value":"1","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg018,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg018", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12 right"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg018),expression:"eval_aedp.pg018"}],attrs:{"value":"0","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg018,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg018", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(11)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt2"}},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg019==="" ? "color:red" : "color:black")},[_vm._v("\n                                    19. Seguridad del empleo \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg019),expression:"eval_aedp.pg019"}],ref:"areaDos",attrs:{"value":"3","name":"group19","type":"radio","id":"areaDos","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg019,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg019", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg019),expression:"eval_aedp.pg019"}],attrs:{"value":"2","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg019,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg019", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg019),expression:"eval_aedp.pg019"}],attrs:{"value":"1","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg019,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg019", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg019),expression:"eval_aedp.pg019"}],attrs:{"value":"0","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg019,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg019", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg020==="" ? "color:red" : "color:black")},[_vm._v("\n                                    20. Relaciones con el jefe inmediato\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg020),expression:"eval_aedp.pg020"}],attrs:{"value":"3","name":"group20","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg020,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg020", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg020),expression:"eval_aedp.pg020"}],attrs:{"value":"2","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg020,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg020", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg020),expression:"eval_aedp.pg020"}],attrs:{"value":"1","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg020,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg020", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg020),expression:"eval_aedp.pg020"}],attrs:{"value":"0","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg020,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg020", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg021==="" ? "color:red" : "color:black")},[_vm._v("\n                                    21. Cambio de prioridades en el trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg021),expression:"eval_aedp.pg021"}],attrs:{"value":"3","name":"group21","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg021,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg021", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg021),expression:"eval_aedp.pg021"}],attrs:{"value":"2","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg021,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg021", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg021),expression:"eval_aedp.pg021"}],attrs:{"value":"1","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg021,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg021", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg021),expression:"eval_aedp.pg021"}],attrs:{"value":"0","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg021,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg021", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg022==="" ? "color:red" : "color:black")},[_vm._v("\n                                    22. Relaciones con compañeros de trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg022),expression:"eval_aedp.pg022"}],attrs:{"value":"3","name":"group22","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg022,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg022", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg022),expression:"eval_aedp.pg022"}],attrs:{"value":"2","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg022,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg022", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg022),expression:"eval_aedp.pg022"}],attrs:{"value":"1","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg022,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg022", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg022),expression:"eval_aedp.pg022"}],attrs:{"value":"0","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg022,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg022", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg023==="" ? "color:red" : "color:black")},[_vm._v("\n                                         23. Oportunidades para avanzar y desarrollarse\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg023),expression:"eval_aedp.pg023"}],attrs:{"value":"3","name":"group23","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg023,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg023", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg023),expression:"eval_aedp.pg023"}],attrs:{"value":"2","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg023,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg023", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg023),expression:"eval_aedp.pg023"}],attrs:{"value":"1","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg023,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg023", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg023),expression:"eval_aedp.pg023"}],attrs:{"value":"0","name":"group23","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg023,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg023", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg024==="" ? "color:red" : "color:black")},[_vm._v("\n                                    24. Exceso de trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg024),expression:"eval_aedp.pg024"}],attrs:{"value":"3","name":"group24","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg024,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg024", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg024),expression:"eval_aedp.pg024"}],attrs:{"value":"2","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg024,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg024", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg024),expression:"eval_aedp.pg024"}],attrs:{"value":"1","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg024,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg024", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg024),expression:"eval_aedp.pg024"}],attrs:{"value":"0","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg024,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg024", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg025==="" ? "color:red" : "color:black")},[_vm._v("\n                                    25. Control de la carga de trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg025),expression:"eval_aedp.pg025"}],attrs:{"value":"3","name":"group25","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg025,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg025", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg025),expression:"eval_aedp.pg025"}],attrs:{"value":"2","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg025,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg025", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg025),expression:"eval_aedp.pg025"}],attrs:{"value":"1","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg025,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg025", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg025),expression:"eval_aedp.pg025"}],attrs:{"value":"0","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg025,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg025", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg026==="" ? "color:red" : "color:black")},[_vm._v("\n                                    26. Falta de flexibilidad para hacer frente a emergencias de familia o personales\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg026),expression:"eval_aedp.pg026"}],attrs:{"value":"3","name":"group26","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg026,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg026", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg026),expression:"eval_aedp.pg026"}],attrs:{"value":"2","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg026,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg026", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg026),expression:"eval_aedp.pg026"}],attrs:{"value":"1","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg026,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg026", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg026),expression:"eval_aedp.pg026"}],attrs:{"value":"0","name":"group26","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg026,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg026", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg027==="" ? "color:red" : "color:black")},[_vm._v("\n                                    27. Favoritismo o injusticia en políticas de contratación y ascensos en el trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg027),expression:"eval_aedp.pg027"}],attrs:{"value":"3","name":"group27","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg027,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg027", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg027),expression:"eval_aedp.pg027"}],attrs:{"value":"2","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg027,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg027", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg027),expression:"eval_aedp.pg027"}],attrs:{"value":"1","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg027,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg027", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg027),expression:"eval_aedp.pg027"}],attrs:{"value":"0","name":"group27","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg027,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg027", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg028==="" ? "color:red" : "color:black")},[_vm._v("\n                                    28. Constante vigilancia de su desempeño en el oficio\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg028),expression:"eval_aedp.pg028"}],attrs:{"value":"3","name":"group28","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg028,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg028", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg028),expression:"eval_aedp.pg028"}],attrs:{"value":"2","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg028,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg028", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg028),expression:"eval_aedp.pg028"}],attrs:{"value":"1","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg028,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg028", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg028),expression:"eval_aedp.pg028"}],attrs:{"value":"0","name":"group28","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg028,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg028", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg029==="" ? "color:red" : "color:black")},[_vm._v("\n                                    29. Trabajo aburrido o poco interesante\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg029),expression:"eval_aedp.pg029"}],attrs:{"value":"3","name":"group29","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg029,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg029", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg029),expression:"eval_aedp.pg029"}],attrs:{"value":"2","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg029,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg029", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg029),expression:"eval_aedp.pg029"}],attrs:{"value":"1","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg029,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg029", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg029),expression:"eval_aedp.pg029"}],attrs:{"value":"0","name":"group29","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg029,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg029", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg030==="" ? "color:red" : "color:black")},[_vm._v("\n                                    30. Especial reconocimiento o premio en su oficio\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg030),expression:"eval_aedp.pg030"}],attrs:{"value":"3","name":"group30","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg030,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg030", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg030),expression:"eval_aedp.pg030"}],attrs:{"value":"2","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg030,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg030", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg030),expression:"eval_aedp.pg030"}],attrs:{"value":"1","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg030,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg030", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg030),expression:"eval_aedp.pg030"}],attrs:{"value":"0","name":"group30","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg030,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg030", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg031==="" ? "color:red" : "color:black")},[_vm._v("\n                                    31. Presión por conflicto de fechas límites en su oficio\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg031),expression:"eval_aedp.pg031"}],attrs:{"value":"3","name":"group31","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg031,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg031", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg031),expression:"eval_aedp.pg031"}],attrs:{"value":"2","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg031,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg031", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg031),expression:"eval_aedp.pg031"}],attrs:{"value":"1","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg031,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg031", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg031),expression:"eval_aedp.pg031"}],attrs:{"value":"0","name":"group31","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg031,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg031", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg032==="" ? "color:red" : "color:black")},[_vm._v("\n                                    32. Pérdida de devoción al trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg032),expression:"eval_aedp.pg032"}],attrs:{"value":"3","name":"group32","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg032,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg032", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg032),expression:"eval_aedp.pg032"}],attrs:{"value":"2","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg032,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg032", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg032),expression:"eval_aedp.pg032"}],attrs:{"value":"1","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg032,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg032", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg032),expression:"eval_aedp.pg032"}],attrs:{"value":"0","name":"group32","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg032,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg032", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg033==="" ? "color:red" : "color:black")},[_vm._v("\n                                    33. Se siente aprisionado en el papeleo e incapaz de realizar cosa alguna.\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg033),expression:"eval_aedp.pg033"}],attrs:{"value":"3","name":"group33","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg033,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg033", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg033),expression:"eval_aedp.pg033"}],attrs:{"value":"2","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg033,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg033", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg033),expression:"eval_aedp.pg033"}],attrs:{"value":"1","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg033,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg033", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg033),expression:"eval_aedp.pg033"}],attrs:{"value":"0","name":"group33","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg033,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg033", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg034==="" ? "color:red" : "color:black")},[_vm._v("\n                                    34. Flexibilidad de horas de trabajo \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg034),expression:"eval_aedp.pg034"}],attrs:{"value":"3","name":"group34","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg034,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg034", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg034),expression:"eval_aedp.pg034"}],attrs:{"value":"2","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg034,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg034", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg034),expression:"eval_aedp.pg034"}],attrs:{"value":"1","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg034,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg034", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg034),expression:"eval_aedp.pg034"}],attrs:{"value":"0","name":"group34","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg034,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg034", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{ref:"area2",staticClass:"input-field col s12 l4",attrs:{"id":"area2"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg035==="" ? "color:red" : "color:black")},[_vm._v("\n                                    35. El transporte de ida y regreso al trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg035),expression:"eval_aedp.pg035"}],attrs:{"value":"3","name":"group35","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg035,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg035", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg035),expression:"eval_aedp.pg035"}],attrs:{"value":"2","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg035,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg035", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg035),expression:"eval_aedp.pg035"}],attrs:{"value":"1","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg035,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg035", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg035),expression:"eval_aedp.pg035"}],attrs:{"value":"0","name":"group35","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg035,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg035", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(1)}}},[_vm._m(13)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(3)}}},[_vm._m(14)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt3),expression:"vertt3"}],ref:"testt3",attrs:{"id":"testt3"}},[_vm._m(15),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg036==="" ? "color:red" : "color:black")},[_vm._v("\n                                    36. Dificultades financieras\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg036),expression:"eval_aedp.pg036"}],attrs:{"value":"3","name":"group36","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg036,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg036", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg036),expression:"eval_aedp.pg036"}],attrs:{"value":"2","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg036,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg036", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg036),expression:"eval_aedp.pg036"}],attrs:{"value":"1","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg036,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg036", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg036),expression:"eval_aedp.pg036"}],attrs:{"value":"0","name":"group36","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg036,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg036", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg037==="" ? "color:red" : "color:black")},[_vm._v("\n                                    37. Aumento de responsabilidades de cuidar de un adulto viejo o un pariente invalido\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg037),expression:"eval_aedp.pg037"}],attrs:{"value":"3","name":"group37","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg037,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg037", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg037),expression:"eval_aedp.pg037"}],attrs:{"value":"2","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg037,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg037", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg037),expression:"eval_aedp.pg037"}],attrs:{"value":"1","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg037,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg037", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg037),expression:"eval_aedp.pg037"}],attrs:{"value":"0","name":"group37","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg037,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg037", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg038==="" ? "color:red" : "color:black")},[_vm._v("\n                                    38. Desavenencias con socio o cónyuge\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg038),expression:"eval_aedp.pg038"}],attrs:{"value":"3","name":"group38","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg038,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg038", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg038),expression:"eval_aedp.pg038"}],attrs:{"value":"2","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg038,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg038", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg038),expression:"eval_aedp.pg038"}],attrs:{"value":"1","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg038,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg038", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg038),expression:"eval_aedp.pg038"}],attrs:{"value":"0","name":"group38","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg038,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg038", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg039==="" ? "color:red" : "color:black")},[_vm._v("\n                                    39. Crianza de un hijo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg039),expression:"eval_aedp.pg039"}],attrs:{"value":"3","name":"group39","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg039,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg039", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg039),expression:"eval_aedp.pg039"}],attrs:{"value":"2","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg039,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg039", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg039),expression:"eval_aedp.pg039"}],attrs:{"value":"1","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg039,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg039", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg039),expression:"eval_aedp.pg039"}],attrs:{"value":"0","name":"group39","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg039,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg039", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg040==="" ? "color:red" : "color:black")},[_vm._v("\n                                         40. Estar separado del marido o esposa\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg040),expression:"eval_aedp.pg040"}],attrs:{"value":"3","name":"group40","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg040,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg040", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg040),expression:"eval_aedp.pg040"}],attrs:{"value":"2","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg040,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg040", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg040),expression:"eval_aedp.pg040"}],attrs:{"value":"1","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg040,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg040", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg040),expression:"eval_aedp.pg040"}],attrs:{"value":"0","name":"group40","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg040,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg040", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg041==="" ? "color:red" : "color:black")},[_vm._v("\n                                    41. Deterioro de la salud personal\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg041),expression:"eval_aedp.pg041"}],attrs:{"value":"3","name":"group41","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg041,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg041", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg041),expression:"eval_aedp.pg041"}],attrs:{"value":"2","name":"group41","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg041,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg041", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg041),expression:"eval_aedp.pg041"}],attrs:{"value":"1","name":"group41","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg041,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg041", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg041),expression:"eval_aedp.pg041"}],attrs:{"value":"0","name":"group41","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg041,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg041", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg042==="" ? "color:red" : "color:black")},[_vm._v("\n                                    42. Encontrar quien cuide al niño, o problemas con actual situación de dicho cuidado \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg042),expression:"eval_aedp.pg042"}],attrs:{"value":"3","name":"group42","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg042,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg042", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg042),expression:"eval_aedp.pg042"}],attrs:{"value":"2","name":"group42","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg042,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg042", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg042),expression:"eval_aedp.pg042"}],attrs:{"value":"1","name":"group42","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg042,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg042", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg042),expression:"eval_aedp.pg042"}],attrs:{"value":"0","name":"group42","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg042,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg042", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg043==="" ? "color:red" : "color:black")},[_vm._v("\n                                    43. No tiene tiempo suficiente para pasar con los que están más cerca de usted\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg043),expression:"eval_aedp.pg043"}],attrs:{"value":"3","name":"group43","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg043,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg043", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg043),expression:"eval_aedp.pg043"}],attrs:{"value":"2","name":"group43","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg043,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg043", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg043),expression:"eval_aedp.pg043"}],attrs:{"value":"1","name":"group43","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg043,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg043", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg043),expression:"eval_aedp.pg043"}],attrs:{"value":"0","name":"group43","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg043,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg043", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg044==="" ? "color:red" : "color:black")},[_vm._v("\n                                    44. Vecindario peligroso o no seguro\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg044),expression:"eval_aedp.pg044"}],attrs:{"value":"3","name":"group44","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg044,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg044", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg044),expression:"eval_aedp.pg044"}],attrs:{"value":"2","name":"group44","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg044,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg044", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg044),expression:"eval_aedp.pg044"}],attrs:{"value":"1","name":"group44","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg044,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg044", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg044),expression:"eval_aedp.pg044"}],attrs:{"value":"0","name":"group44","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg044,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg044", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg045==="" ? "color:red" : "color:black")},[_vm._v("\n                                    45. Relaciones con un pariente íntimo (padres, hermanos, yerno)\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg045),expression:"eval_aedp.pg045"}],attrs:{"value":"3","name":"group45","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg045,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg045", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg045),expression:"eval_aedp.pg045"}],attrs:{"value":"2","name":"group45","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg045,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg045", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg045),expression:"eval_aedp.pg045"}],attrs:{"value":"1","name":"group45","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg045,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg045", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg045),expression:"eval_aedp.pg045"}],attrs:{"value":"0","name":"group45","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg045,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg045", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg046==="" ? "color:red" : "color:black")},[_vm._v("\n                                    46. Conflicto sexual o frustración\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg046),expression:"eval_aedp.pg046"}],attrs:{"value":"3","name":"group46","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg046,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg046", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg046),expression:"eval_aedp.pg046"}],attrs:{"value":"2","name":"group46","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg046,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg046", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg046),expression:"eval_aedp.pg046"}],attrs:{"value":"1","name":"group46","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg046,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg046", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg046),expression:"eval_aedp.pg046"}],attrs:{"value":"0","name":"group46","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg046,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg046", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg047==="" ? "color:red" : "color:black")},[_vm._v("\n                                    47. Conflicto trabajo-familia\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg047),expression:"eval_aedp.pg047"}],attrs:{"value":"3","name":"group47","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg047,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg047", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg047),expression:"eval_aedp.pg047"}],attrs:{"value":"2","name":"group47","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg047,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg047", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg047),expression:"eval_aedp.pg047"}],attrs:{"value":"1","name":"group47","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg047,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg047", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg047),expression:"eval_aedp.pg047"}],attrs:{"value":"0","name":"group47","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg047,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg047", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg048==="" ? "color:red" : "color:black")},[_vm._v("\n                                    48. Soledad o falta de intimidad\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg048),expression:"eval_aedp.pg048"}],attrs:{"value":"3","name":"group48","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg048,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg048", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg048),expression:"eval_aedp.pg048"}],attrs:{"value":"2","name":"group48","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg048,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg048", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg048),expression:"eval_aedp.pg048"}],attrs:{"value":"1","name":"group48","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg048,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg048", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg048),expression:"eval_aedp.pg048"}],attrs:{"value":"0","name":"group48","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg048,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg048", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{ref:"area3",staticClass:"input-field col s12 l4",attrs:{"id":"area3"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg049==="" ? "color:red" : "color:black")},[_vm._v("\n                                    49. Cuestiones de fecundidad o reproducción\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg049),expression:"eval_aedp.pg049"}],attrs:{"value":"3","name":"group49","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg049,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg049", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg049),expression:"eval_aedp.pg049"}],attrs:{"value":"2","name":"group49","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg049,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg049", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg049),expression:"eval_aedp.pg049"}],attrs:{"value":"1","name":"group49","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg049,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg049", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg049),expression:"eval_aedp.pg049"}],attrs:{"value":"0","name":"group49","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg049,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg049", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(2)}}},[_vm._m(16)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(4)}}},[_vm._m(17)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt4),expression:"vertt4"}],ref:"testt4",attrs:{"id":"testt4"}},[_vm._m(18),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg050==="" ? "color:red" : "color:black")},[_vm._v("\n                                    50. Puedo nombrar mis sentimientos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg050),expression:"eval_aedp.pg050"}],attrs:{"value":"3","name":"group50","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg050,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg050", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg050),expression:"eval_aedp.pg050"}],attrs:{"value":"2","name":"group50","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg050,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg050", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg050),expression:"eval_aedp.pg050"}],attrs:{"value":"1","name":"group50","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg050,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg050", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg050),expression:"eval_aedp.pg050"}],attrs:{"value":"0","name":"group50","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg050,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg050", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg051==="" ? "color:red" : "color:black")},[_vm._v("\n                                    51. He aprendido mucho acerca de mí mismo escuchando mis sentimientos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg051),expression:"eval_aedp.pg051"}],attrs:{"value":"3","name":"group51","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg051,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg051", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg051),expression:"eval_aedp.pg051"}],attrs:{"value":"2","name":"group51","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg051,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg051", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg051),expression:"eval_aedp.pg051"}],attrs:{"value":"1","name":"group51","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg051,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg051", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg051),expression:"eval_aedp.pg051"}],attrs:{"value":"0","name":"group51","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg051,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg051", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg052==="" ? "color:red" : "color:black")},[_vm._v("\n                                    52. Soy consciente de mis sentimientos la mayor parte del tiempo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg052),expression:"eval_aedp.pg052"}],attrs:{"value":"3","name":"group52","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg052,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg052", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg052),expression:"eval_aedp.pg052"}],attrs:{"value":"2","name":"group52","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg052,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg052", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg052),expression:"eval_aedp.pg052"}],attrs:{"value":"1","name":"group52","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg052,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg052", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg052),expression:"eval_aedp.pg052"}],attrs:{"value":"0","name":"group52","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg052,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg052", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg053==="" ? "color:red" : "color:black")},[_vm._v("\n                                    53. Sé cuando me estoy alterando\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg053),expression:"eval_aedp.pg053"}],attrs:{"value":"3","name":"group53","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg053,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg053", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg053),expression:"eval_aedp.pg053"}],attrs:{"value":"2","name":"group53","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg053,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg053", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg053),expression:"eval_aedp.pg053"}],attrs:{"value":"1","name":"group53","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg053,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg053", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg053),expression:"eval_aedp.pg053"}],attrs:{"value":"0","name":"group53","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg053,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg053", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg054==="" ? "color:red" : "color:black")},[_vm._v("\n                                         54. Cuando estoy triste, sé por qué\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg054),expression:"eval_aedp.pg054"}],attrs:{"value":"3","name":"group54","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg054,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg054", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg054),expression:"eval_aedp.pg054"}],attrs:{"value":"2","name":"group54","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg054,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg054", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg054),expression:"eval_aedp.pg054"}],attrs:{"value":"1","name":"group54","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg054,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg054", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg054),expression:"eval_aedp.pg054"}],attrs:{"value":"0","name":"group54","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg054,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg054", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg055==="" ? "color:red" : "color:black")},[_vm._v("\n                                    55. Cuando me juzgo a mi mismo por la manera como creo que los demás me ven\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg055),expression:"eval_aedp.pg055"}],attrs:{"value":"0","name":"group55","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg055,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg055", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg055),expression:"eval_aedp.pg055"}],attrs:{"value":"1","name":"group55","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg055,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg055", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg055),expression:"eval_aedp.pg055"}],attrs:{"value":"2","name":"group55","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg055,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg055", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg055),expression:"eval_aedp.pg055"}],attrs:{"value":"3","name":"group55","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg055,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg055", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg056==="" ? "color:red" : "color:black")},[_vm._v("\n                                    56. Gozo de mi vida emocional \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg056),expression:"eval_aedp.pg056"}],attrs:{"value":"3","name":"group56","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg056,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg056", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg056),expression:"eval_aedp.pg056"}],attrs:{"value":"2","name":"group56","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg056,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg056", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg056),expression:"eval_aedp.pg056"}],attrs:{"value":"1","name":"group56","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg056,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg056", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg056),expression:"eval_aedp.pg056"}],attrs:{"value":"0","name":"group56","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg056,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg056", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg057==="" ? "color:red" : "color:black")},[_vm._v("\n                                    57. Me asustan las personas que muestran fuertes emociones\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg057),expression:"eval_aedp.pg057"}],attrs:{"value":"0","name":"group57","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg057,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg057", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg057),expression:"eval_aedp.pg057"}],attrs:{"value":"1","name":"group57","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg057,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg057", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg057),expression:"eval_aedp.pg057"}],attrs:{"value":"2","name":"group57","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg057,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg057", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg057),expression:"eval_aedp.pg057"}],attrs:{"value":"3","name":"group57","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg057,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg057", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg058==="" ? "color:red" : "color:black")},[_vm._v("\n                                    58. A veces quisiera ser otra persona\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg058),expression:"eval_aedp.pg058"}],attrs:{"value":"0","name":"group58","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg058,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg058", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg058),expression:"eval_aedp.pg058"}],attrs:{"value":"1","name":"group58","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg058,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg058", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg058),expression:"eval_aedp.pg058"}],attrs:{"value":"2","name":"group58","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg058,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg058", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg058),expression:"eval_aedp.pg058"}],attrs:{"value":"3","name":"group58","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg058,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg058", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg059==="" ? "color:red" : "color:black")},[_vm._v("\n                                    59. Presto atención a mi estado físico para entender mis sentimientos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg059),expression:"eval_aedp.pg059"}],attrs:{"value":"3","name":"group59","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg059,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg059", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg059),expression:"eval_aedp.pg059"}],attrs:{"value":"2","name":"group59","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg059,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg059", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg059),expression:"eval_aedp.pg059"}],attrs:{"value":"1","name":"group59","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg059,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg059", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg059),expression:"eval_aedp.pg059"}],attrs:{"value":"0","name":"group59","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg059,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg059", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{ref:"area4",staticClass:"input-field col s12 l4",attrs:{"id":"area4"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg060==="" ? "color:red" : "color:black")},[_vm._v("\n                                    60. Acepto mis sentimientos como propios\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg060),expression:"eval_aedp.pg060"}],attrs:{"value":"3","name":"group60","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg060,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg060", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg060),expression:"eval_aedp.pg060"}],attrs:{"value":"2","name":"group60","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg060,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg060", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg060),expression:"eval_aedp.pg060"}],attrs:{"value":"1","name":"group60","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg060,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg060", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg060),expression:"eval_aedp.pg060"}],attrs:{"value":"0","name":"group60","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg060,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg060", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(3)}}},[_vm._m(19)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(5)}}},[_vm._m(20)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt5),expression:"vertt5"}],ref:"testt5",attrs:{"id":"testt5"}},[_vm._m(21),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg061==="" ? "color:red" : "color:black")},[_vm._v("\n                                    61. Les hago saber a los demás cuando están haciendo un buen trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg061),expression:"eval_aedp.pg061"}],attrs:{"value":"3","name":"group61","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg061,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg061", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg061),expression:"eval_aedp.pg061"}],attrs:{"value":"2","name":"group61","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg061,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg061", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg061),expression:"eval_aedp.pg061"}],attrs:{"value":"1","name":"group61","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg061,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg061", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg061),expression:"eval_aedp.pg061"}],attrs:{"value":"0","name":"group61","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg061,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg061", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg062==="" ? "color:red" : "color:black")},[_vm._v("\n                                    62. Expreso mis emociones aún cuando sean negativas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg062),expression:"eval_aedp.pg062"}],attrs:{"value":"3","name":"group62","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg062,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg062", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg062),expression:"eval_aedp.pg062"}],attrs:{"value":"2","name":"group62","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg062,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg062", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg062),expression:"eval_aedp.pg062"}],attrs:{"value":"1","name":"group62","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg062,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg062", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg062),expression:"eval_aedp.pg062"}],attrs:{"value":"0","name":"group62","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg062,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg062", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg063==="" ? "color:red" : "color:black")},[_vm._v("\n                                    63. Les hago saber a los demás lo que quiero y necesito \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg063),expression:"eval_aedp.pg063"}],attrs:{"value":"3","name":"group63","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg063,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg063", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg063),expression:"eval_aedp.pg063"}],attrs:{"value":"2","name":"group63","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg063,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg063", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg063),expression:"eval_aedp.pg063"}],attrs:{"value":"1","name":"group63","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg063,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg063", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg063),expression:"eval_aedp.pg063"}],attrs:{"value":"0","name":"group63","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg063,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg063", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg064==="" ? "color:red" : "color:black")},[_vm._v("\n                                    64. Mis amigos íntimos dirían que yo expreso mi aprecio por ellos  alterando\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg064),expression:"eval_aedp.pg064"}],attrs:{"value":"3","name":"group64","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg064,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg064", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg064),expression:"eval_aedp.pg064"}],attrs:{"value":"2","name":"group64","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg064,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg064", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg064),expression:"eval_aedp.pg064"}],attrs:{"value":"1","name":"group64","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg064,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg064", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg064),expression:"eval_aedp.pg064"}],attrs:{"value":"0","name":"group64","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg064,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg064", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg065==="" ? "color:red" : "color:black")},[_vm._v("\n                                    65. Me guardo mis sentimientos para mí solo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg065),expression:"eval_aedp.pg065"}],attrs:{"value":"0","name":"group65","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg065,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg065", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg065),expression:"eval_aedp.pg065"}],attrs:{"value":"1","name":"group65","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg065,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg065", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg065),expression:"eval_aedp.pg065"}],attrs:{"value":"2","name":"group65","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg065,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg065", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg065),expression:"eval_aedp.pg065"}],attrs:{"value":"3","name":"group65","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg065,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg065", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg066==="" ? "color:red" : "color:black")},[_vm._v("\n                                    66. Les hago saber a los demás cuando sentimientos desagradables intervienen en la manera como trabajamos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg066),expression:"eval_aedp.pg066"}],attrs:{"value":"3","name":"group66","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg066,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg066", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg066),expression:"eval_aedp.pg066"}],attrs:{"value":"2","name":"group66","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg066,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg066", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg066),expression:"eval_aedp.pg066"}],attrs:{"value":"1","name":"group66","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg066,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg066", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg066),expression:"eval_aedp.pg066"}],attrs:{"value":"0","name":"group66","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg066,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg066", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg067==="" ? "color:red" : "color:black")},[_vm._v("\n                                    67. Me cuesta pedir ayuda cuando lo necesito  \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg067),expression:"eval_aedp.pg067"}],attrs:{"value":"0","name":"group67","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg067,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg067", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg067),expression:"eval_aedp.pg067"}],attrs:{"value":"1","name":"group67","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg067,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg067", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg067),expression:"eval_aedp.pg067"}],attrs:{"value":"2","name":"group67","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg067,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg067", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg067),expression:"eval_aedp.pg067"}],attrs:{"value":"3","name":"group67","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg067,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg067", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg068==="" ? "color:red" : "color:black")},[_vm._v("\n                                    68. Al tratar con los demás puedo percibir cómo se sienten\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg068),expression:"eval_aedp.pg068"}],attrs:{"value":"3","name":"group68","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg068,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg068", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg068),expression:"eval_aedp.pg068"}],attrs:{"value":"2","name":"group68","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg068,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg068", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg068),expression:"eval_aedp.pg068"}],attrs:{"value":"1","name":"group68","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg068,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg068", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg068),expression:"eval_aedp.pg068"}],attrs:{"value":"0","name":"group68","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg068,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg068", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{ref:"area5",staticClass:"input-field col s12 l4",attrs:{"id":"area5"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg069==="" ? "color:red" : "color:black")},[_vm._v("\n                                    69. Haría cualquier cosa por no parecer tonto ante mis compañeros\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg069),expression:"eval_aedp.pg069"}],attrs:{"value":"0","name":"group69","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg069,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg069", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg069),expression:"eval_aedp.pg069"}],attrs:{"value":"1","name":"group69","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg069,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg069", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg069),expression:"eval_aedp.pg069"}],attrs:{"value":"2","name":"group69","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg069,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg069", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg069),expression:"eval_aedp.pg069"}],attrs:{"value":"3","name":"group69","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg069,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg069", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(4)}}},[_vm._m(22)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(6)}}},[_vm._m(23)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt6),expression:"vertt6"}],ref:"testt6",attrs:{"id":"testt6"}},[_vm._m(24),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg070==="" ? "color:red" : "color:black")},[_vm._v("\n                                    70. Puedo reconocer las emociones de otros mirándolos a los ojos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg070),expression:"eval_aedp.pg070"}],attrs:{"value":"3","name":"group70","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg070,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg070", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg070),expression:"eval_aedp.pg070"}],attrs:{"value":"2","name":"group70","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg070,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg070", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg070),expression:"eval_aedp.pg070"}],attrs:{"value":"1","name":"group70","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg070,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg070", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg070),expression:"eval_aedp.pg070"}],attrs:{"value":"0","name":"group70","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg070,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg070", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg071==="" ? "color:red" : "color:black")},[_vm._v("\n                                    71. Me cuesta trabajo hablar con personas que no comparten mis puntos de vista\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg071),expression:"eval_aedp.pg071"}],attrs:{"value":"0","name":"group71","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg071,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg071", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg071),expression:"eval_aedp.pg071"}],attrs:{"value":"1","name":"group71","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg071,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg071", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg071),expression:"eval_aedp.pg071"}],attrs:{"value":"2","name":"group71","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg071,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg071", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg071),expression:"eval_aedp.pg071"}],attrs:{"value":"3","name":"group71","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg071,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg071", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg072==="" ? "color:red" : "color:black")},[_vm._v("\n                                    72. Me concentro en las cualidades positivas de los demás \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg072),expression:"eval_aedp.pg072"}],attrs:{"value":"3","name":"group72","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg072,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg072", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg072),expression:"eval_aedp.pg072"}],attrs:{"value":"2","name":"group72","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg072,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg072", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg072),expression:"eval_aedp.pg072"}],attrs:{"value":"1","name":"group72","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg072,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg072", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg072),expression:"eval_aedp.pg072"}],attrs:{"value":"0","name":"group72","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg072,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg072", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg073==="" ? "color:red" : "color:black")},[_vm._v("\n                                    73. Rara vez siento ganas de reñir con otro\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg073),expression:"eval_aedp.pg073"}],attrs:{"value":"3","name":"group73","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg073,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg073", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg073),expression:"eval_aedp.pg073"}],attrs:{"value":"2","name":"group73","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg073,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg073", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg073),expression:"eval_aedp.pg073"}],attrs:{"value":"1","name":"group73","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg073,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg073", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg073),expression:"eval_aedp.pg073"}],attrs:{"value":"0","name":"group73","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg073,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg073", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg074==="" ? "color:red" : "color:black")},[_vm._v("\n                                    74. Pienso como se sentirían los demás antes de expresar mi opinión\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074),expression:"eval_aedp.pg074"}],attrs:{"value":"0","name":"group74","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074),expression:"eval_aedp.pg074"}],attrs:{"value":"1","name":"group74","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074),expression:"eval_aedp.pg074"}],attrs:{"value":"2","name":"group74","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074),expression:"eval_aedp.pg074"}],attrs:{"value":"3","name":"group74","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg074b==="" ? "color:red" : "color:black")},[_vm._v("\n                                    74b. Con cualquiera que hablo, siempre lo escucho con atención\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074b),expression:"eval_aedp.pg074b"}],attrs:{"value":"0","name":"group74b","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074b,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074b", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074b),expression:"eval_aedp.pg074b"}],attrs:{"value":"1","name":"group74b","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074b,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074b", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074b),expression:"eval_aedp.pg074b"}],attrs:{"value":"2","name":"group74b","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074b,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074b", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074b),expression:"eval_aedp.pg074b"}],attrs:{"value":"3","name":"group74b","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074b,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074b", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg074c==="" ? "color:red" : "color:black")},[_vm._v("\n                                    74c. Puedo presentir el ánimo de un grupo cuando entro en un salón \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074c),expression:"eval_aedp.pg074c"}],attrs:{"value":"0","name":"group74c","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074c,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074c", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074c),expression:"eval_aedp.pg074c"}],attrs:{"value":"1","name":"group74c","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074c,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074c", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074c),expression:"eval_aedp.pg074c"}],attrs:{"value":"2","name":"group74c","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074c,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074c", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074c),expression:"eval_aedp.pg074c"}],attrs:{"value":"3","name":"group74c","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074c,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074c", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg074d==="" ? "color:red" : "color:black")},[_vm._v("\n                                    74d. Yo puedo hacer que personas a quienes acabo de conocer hablen de sí misma\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074d),expression:"eval_aedp.pg074d"}],attrs:{"value":"0","name":"group74d","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074d,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074d", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074d),expression:"eval_aedp.pg074d"}],attrs:{"value":"1","name":"group74d","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074d,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074d", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074d),expression:"eval_aedp.pg074d"}],attrs:{"value":"2","name":"group74d","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074d,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074d", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074d),expression:"eval_aedp.pg074d"}],attrs:{"value":"3","name":"group74d","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074d,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074d", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg074e==="" ? "color:red" : "color:black")},[_vm._v("\n                                    74e. Se 'leer entre líneas' cuando alguien está hablando\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074e),expression:"eval_aedp.pg074e"}],attrs:{"value":"0","name":"group74e","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074e,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074e", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074e),expression:"eval_aedp.pg074e"}],attrs:{"value":"1","name":"group74e","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074e,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074e", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074e),expression:"eval_aedp.pg074e"}],attrs:{"value":"2","name":"group74e","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074e,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074e", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074e),expression:"eval_aedp.pg074e"}],attrs:{"value":"3","name":"group74e","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074e,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074e", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg074f==="" ? "color:red" : "color:black")},[_vm._v("\n                                    74f. Generalmente sé cómo piensan los demás sobre mí \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074f),expression:"eval_aedp.pg074f"}],attrs:{"value":"0","name":"group74f","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074f,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074f", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074f),expression:"eval_aedp.pg074f"}],attrs:{"value":"1","name":"group74f","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074f,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074f", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074f),expression:"eval_aedp.pg074f"}],attrs:{"value":"2","name":"group74f","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074f,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074f", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074f),expression:"eval_aedp.pg074f"}],attrs:{"value":"3","name":"group74f","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074f,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074f", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg074g==="" ? "color:red" : "color:black")},[_vm._v("\n                                    74g. Puedo presentir los sentimientos de una persona aunque no los exprese con palabras\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074g),expression:"eval_aedp.pg074g"}],attrs:{"value":"0","name":"group74g","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074g,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074g", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074g),expression:"eval_aedp.pg074g"}],attrs:{"value":"1","name":"group74g","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074g,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074g", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074g),expression:"eval_aedp.pg074g"}],attrs:{"value":"2","name":"group74g","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074g,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074g", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074g),expression:"eval_aedp.pg074g"}],attrs:{"value":"3","name":"group74g","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074g,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074g", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg074h==="" ? "color:red" : "color:black")},[_vm._v("\n                                    74h. Cambio mi expresión emocional según la persona con quien esté\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074h),expression:"eval_aedp.pg074h"}],attrs:{"value":"0","name":"group74h","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074h,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074h", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074h),expression:"eval_aedp.pg074h"}],attrs:{"value":"1","name":"group74h","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074h,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074h", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074h),expression:"eval_aedp.pg074h"}],attrs:{"value":"2","name":"group74h","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074h,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074h", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074h),expression:"eval_aedp.pg074h"}],attrs:{"value":"3","name":"group74h","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074h,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074h", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{ref:"area6",staticClass:"input-field col s12 l4",attrs:{"id":"area6"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg074i==="" ? "color:red" : "color:black")},[_vm._v("\n                                    74i. Sé cuando un amigo está preocupado \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074i),expression:"eval_aedp.pg074i"}],attrs:{"value":"0","name":"group74i","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074i,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074i", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074i),expression:"eval_aedp.pg074i"}],attrs:{"value":"1","name":"group74i","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074i,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074i", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074i),expression:"eval_aedp.pg074i"}],attrs:{"value":"2","name":"group74i","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074i,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074i", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg074i),expression:"eval_aedp.pg074i"}],attrs:{"value":"3","name":"group74i","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg074i,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg074i", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(5)}}},[_vm._m(25)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(7)}}},[_vm._m(26)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt7),expression:"vertt7"}],ref:"testt7",attrs:{"id":"testt7"}},[_vm._m(27),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg075==="" ? "color:red" : "color:black")},[_vm._v("\n                                    75. Puedo excluir toda distracción cuando tengo que concentrarme\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg075),expression:"eval_aedp.pg075"}],attrs:{"value":"3","name":"group75","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg075,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg075", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg075),expression:"eval_aedp.pg075"}],attrs:{"value":"2","name":"group75","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg075,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg075", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg075),expression:"eval_aedp.pg075"}],attrs:{"value":"1","name":"group75","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg075,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg075", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg075),expression:"eval_aedp.pg075"}],attrs:{"value":"0","name":"group75","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg075,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg075", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg076==="" ? "color:red" : "color:black")},[_vm._v("\n                                    76. Generalmente termino lo que comienzo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg076),expression:"eval_aedp.pg076"}],attrs:{"value":"3","name":"group76","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg076,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg076", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg076),expression:"eval_aedp.pg076"}],attrs:{"value":"2","name":"group76","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg076,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg076", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg076),expression:"eval_aedp.pg076"}],attrs:{"value":"1","name":"group76","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg076,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg076", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg076),expression:"eval_aedp.pg076"}],attrs:{"value":"0","name":"group76","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg076,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg076", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg077==="" ? "color:red" : "color:black")},[_vm._v("\n                                    77. Sé decir no cuando es necesario\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg077),expression:"eval_aedp.pg077"}],attrs:{"value":"3","name":"group77","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg077,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg077", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg077),expression:"eval_aedp.pg077"}],attrs:{"value":"2","name":"group77","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg077,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg077", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg077),expression:"eval_aedp.pg077"}],attrs:{"value":"1","name":"group77","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg077,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg077", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg077),expression:"eval_aedp.pg077"}],attrs:{"value":"0","name":"group77","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg077,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg077", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg078==="" ? "color:red" : "color:black")},[_vm._v("\n                                    78. Sé compensarme a mi mismo después de alcanzar una meta \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg078),expression:"eval_aedp.pg078"}],attrs:{"value":"3","name":"group78","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg078,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg078", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg078),expression:"eval_aedp.pg078"}],attrs:{"value":"2","name":"group78","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg078,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg078", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg078),expression:"eval_aedp.pg078"}],attrs:{"value":"1","name":"group78","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg078,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg078", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg078),expression:"eval_aedp.pg078"}],attrs:{"value":"0","name":"group78","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg078,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg078", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg079==="" ? "color:red" : "color:black")},[_vm._v("\n                                         79. Puedo hacer a un lado las recompensas a corto plazo a cambio de una meta a largo plazo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg079),expression:"eval_aedp.pg079"}],attrs:{"value":"3","name":"group79","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg079,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg079", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg079),expression:"eval_aedp.pg079"}],attrs:{"value":"2","name":"group79","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg079,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg079", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg079),expression:"eval_aedp.pg079"}],attrs:{"value":"1","name":"group79","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg079,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg079", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg079),expression:"eval_aedp.pg079"}],attrs:{"value":"0","name":"group79","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg079,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg079", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg080==="" ? "color:red" : "color:black")},[_vm._v("\n                                    80. Puedo concentrarme completamente en una tarea cuando es necesario\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg080),expression:"eval_aedp.pg080"}],attrs:{"value":"3","name":"group80","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg080,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg080", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg080),expression:"eval_aedp.pg080"}],attrs:{"value":"2","name":"group80","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg080,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg080", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg080),expression:"eval_aedp.pg080"}],attrs:{"value":"1","name":"group80","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg080,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg080", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg080),expression:"eval_aedp.pg080"}],attrs:{"value":"0","name":"group80","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg080,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg080", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg081==="" ? "color:red" : "color:black")},[_vm._v("\n                                    81. Hago cosas que después me arrepiento\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg081),expression:"eval_aedp.pg081"}],attrs:{"value":"0","name":"group81","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg081,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg081", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg081),expression:"eval_aedp.pg081"}],attrs:{"value":"1","name":"group81","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg081,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg081", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg081),expression:"eval_aedp.pg081"}],attrs:{"value":"2","name":"group81","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg081,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg081", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg081),expression:"eval_aedp.pg081"}],attrs:{"value":"3","name":"group81","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg081,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg081", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg082==="" ? "color:red" : "color:black")},[_vm._v("\n                                    82. Acepto la responsabilidad de manejar mis emociones\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg082),expression:"eval_aedp.pg082"}],attrs:{"value":"3","name":"group82","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg082,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg082", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg082),expression:"eval_aedp.pg082"}],attrs:{"value":"2","name":"group82","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg082,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg082", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg082),expression:"eval_aedp.pg082"}],attrs:{"value":"1","name":"group82","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg082,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg082", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg082),expression:"eval_aedp.pg082"}],attrs:{"value":"0","name":"group82","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg082,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg082", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg083==="" ? "color:red" : "color:black")},[_vm._v("\n                                    83. Cuando me veo ante un problema, me gusta despacharlo lo más pronto posible \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg083),expression:"eval_aedp.pg083"}],attrs:{"value":"3","name":"group83","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg083,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg083", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg083),expression:"eval_aedp.pg083"}],attrs:{"value":"2","name":"group83","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg083,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg083", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg083),expression:"eval_aedp.pg083"}],attrs:{"value":"1","name":"group83","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg083,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg083", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg083),expression:"eval_aedp.pg083"}],attrs:{"value":"0","name":"group83","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg083,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg083", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg084==="" ? "color:red" : "color:black")},[_vm._v("\n                                    84. Pienso que es lo que quiero antes de actuar\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg084),expression:"eval_aedp.pg084"}],attrs:{"value":"3","name":"group84","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg084,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg084", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg084),expression:"eval_aedp.pg084"}],attrs:{"value":"2","name":"group84","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg084,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg084", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg084),expression:"eval_aedp.pg084"}],attrs:{"value":"1","name":"group84","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg084,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg084", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg084),expression:"eval_aedp.pg084"}],attrs:{"value":"0","name":"group84","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg084,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg084", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg085==="" ? "color:red" : "color:black")},[_vm._v("\n                                    85. Puedo aplazar mi satisfacción personal a cambio de una meta más grande\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg085),expression:"eval_aedp.pg085"}],attrs:{"value":"3","name":"group85","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg085,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg085", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg085),expression:"eval_aedp.pg085"}],attrs:{"value":"2","name":"group85","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg085,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg085", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg085),expression:"eval_aedp.pg085"}],attrs:{"value":"1","name":"group85","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg085,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg085", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg085),expression:"eval_aedp.pg085"}],attrs:{"value":"0","name":"group85","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg085,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg085", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg086==="" ? "color:red" : "color:black")},[_vm._v("\n                                    86. Cuando estoy de mal humor puedo superarlo hablando\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg086),expression:"eval_aedp.pg086"}],attrs:{"value":"3","name":"group86","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg086,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg086", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg086),expression:"eval_aedp.pg086"}],attrs:{"value":"2","name":"group86","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg086,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg086", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg086),expression:"eval_aedp.pg086"}],attrs:{"value":"1","name":"group86","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg086,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg086", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg086),expression:"eval_aedp.pg086"}],attrs:{"value":"0","name":"group86","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg086,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg086", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg087==="" ? "color:red" : "color:black")},[_vm._v("\n                                    87. Me da rabia cuando me critican \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg087),expression:"eval_aedp.pg087"}],attrs:{"value":"0","name":"group87","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg087,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg087", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg087),expression:"eval_aedp.pg087"}],attrs:{"value":"1","name":"group87","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg087,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg087", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg087),expression:"eval_aedp.pg087"}],attrs:{"value":"2","name":"group87","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg087,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg087", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg087),expression:"eval_aedp.pg087"}],attrs:{"value":"3","name":"group87","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg087,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg087", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{ref:"area7",staticClass:"input-field col s12 l4",attrs:{"id":"area7"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg088==="" ? "color:red" : "color:black")},[_vm._v("\n                                    88. No sé cuando es el origen de mi enfado en muchas situaciones \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg088),expression:"eval_aedp.pg088"}],attrs:{"value":"0","name":"group88","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg088,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg088", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg088),expression:"eval_aedp.pg088"}],attrs:{"value":"1","name":"group88","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg088,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg088", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg088),expression:"eval_aedp.pg088"}],attrs:{"value":"2","name":"group88","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg088,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg088", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg088),expression:"eval_aedp.pg088"}],attrs:{"value":"3","name":"group88","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg088,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg088", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(6)}}},[_vm._m(28)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(8)}}},[_vm._m(29)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt8),expression:"vertt8"}],ref:"testt8",attrs:{"id":"testt8"}},[_vm._m(30),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg089==="" ? "color:red" : "color:black")},[_vm._v("\n                                    89. He recomendado proyectos novedosos a la compañia\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg089),expression:"eval_aedp.pg089"}],attrs:{"value":"3","name":"group89","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg089,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg089", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg089),expression:"eval_aedp.pg089"}],attrs:{"value":"2","name":"group89","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg089,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg089", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg089),expression:"eval_aedp.pg089"}],attrs:{"value":"1","name":"group89","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg089,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg089", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg089),expression:"eval_aedp.pg089"}],attrs:{"value":"0","name":"group89","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg089,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg089", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg090==="" ? "color:red" : "color:black")},[_vm._v("\n                                    90. Participo en compartir información e ideas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg090),expression:"eval_aedp.pg090"}],attrs:{"value":"3","name":"group90","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg090,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg090", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg090),expression:"eval_aedp.pg090"}],attrs:{"value":"2","name":"group90","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg090,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg090", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg090),expression:"eval_aedp.pg090"}],attrs:{"value":"1","name":"group90","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg090,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg090", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg090),expression:"eval_aedp.pg090"}],attrs:{"value":"0","name":"group90","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg090,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg090", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg091==="" ? "color:red" : "color:black")},[_vm._v("\n                                    91. Sueño con el futuro para ayudarme a pensar hacia donde voy\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg091),expression:"eval_aedp.pg091"}],attrs:{"value":"3","name":"group91","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg091,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg091", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg091),expression:"eval_aedp.pg091"}],attrs:{"value":"2","name":"group91","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg091,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg091", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg091),expression:"eval_aedp.pg091"}],attrs:{"value":"1","name":"group91","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg091,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg091", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg091),expression:"eval_aedp.pg091"}],attrs:{"value":"0","name":"group91","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg091,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg091", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg092==="" ? "color:red" : "color:black")},[_vm._v("\n                                    92. Mis mejores ideas me vienen cuando no estoy pensando en ellas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg092),expression:"eval_aedp.pg092"}],attrs:{"value":"3","name":"group92","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg092,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg092", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg092),expression:"eval_aedp.pg092"}],attrs:{"value":"2","name":"group92","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg092,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg092", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg092),expression:"eval_aedp.pg092"}],attrs:{"value":"1","name":"group92","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg092,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg092", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg092),expression:"eval_aedp.pg092"}],attrs:{"value":"0","name":"group92","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg092,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg092", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg093==="" ? "color:red" : "color:black")},[_vm._v("\n                                         93. Tengo ideas brillantes que me han venido de pronto y ya completamente formadas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg093),expression:"eval_aedp.pg093"}],attrs:{"value":"3","name":"group93","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg093,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg093", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg093),expression:"eval_aedp.pg093"}],attrs:{"value":"2","name":"group93","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg093,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg093", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg093),expression:"eval_aedp.pg093"}],attrs:{"value":"1","name":"group93","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg093,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg093", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg093),expression:"eval_aedp.pg093"}],attrs:{"value":"0","name":"group93","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg093,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg093", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg094==="" ? "color:red" : "color:black")},[_vm._v("\n                                    94. Tengo un buen sentido de cuándo las ideas tendrán éxito o fracasarán\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg094),expression:"eval_aedp.pg094"}],attrs:{"value":"3","name":"group94","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg094,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg094", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg094),expression:"eval_aedp.pg094"}],attrs:{"value":"2","name":"group94","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg094,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg094", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg094),expression:"eval_aedp.pg094"}],attrs:{"value":"1","name":"group94","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg094,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg094", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg094),expression:"eval_aedp.pg094"}],attrs:{"value":"0","name":"group94","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg094,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg094", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg095==="" ? "color:red" : "color:black")},[_vm._v("\n                                    95. Me fascinan los conceptos nuevos e inusuales\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg095),expression:"eval_aedp.pg095"}],attrs:{"value":"3","name":"group95","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg095,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg095", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg095),expression:"eval_aedp.pg095"}],attrs:{"value":"2","name":"group95","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg095,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg095", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg095),expression:"eval_aedp.pg095"}],attrs:{"value":"1","name":"group95","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg095,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg095", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg095),expression:"eval_aedp.pg095"}],attrs:{"value":"0","name":"group95","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg095,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg095", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg096==="" ? "color:red" : "color:black")},[_vm._v("\n                                    96. He impulsado proyectos novedosos en mi compañia\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg096),expression:"eval_aedp.pg096"}],attrs:{"value":"3","name":"group96","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg096,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg096", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg096),expression:"eval_aedp.pg096"}],attrs:{"value":"2","name":"group96","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg096,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg096", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg096),expression:"eval_aedp.pg096"}],attrs:{"value":"1","name":"group96","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg096,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg096", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg096),expression:"eval_aedp.pg096"}],attrs:{"value":"0","name":"group96","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg096,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg096", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg097==="" ? "color:red" : "color:black")},[_vm._v("\n                                    97. Me entusiasman las y ideas y soluciones nuevas \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg097),expression:"eval_aedp.pg097"}],attrs:{"value":"3","name":"group97","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg097,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg097", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg097),expression:"eval_aedp.pg097"}],attrs:{"value":"2","name":"group97","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg097,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg097", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg097),expression:"eval_aedp.pg097"}],attrs:{"value":"1","name":"group97","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg097,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg097", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg097),expression:"eval_aedp.pg097"}],attrs:{"value":"0","name":"group97","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg097,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg097", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{ref:"area8",staticClass:"input-field col s12 l4",attrs:{"id":"area8"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg098==="" ? "color:red" : "color:black")},[_vm._v("\n                                    98. Me desempeño bien haciendo tormentas de ideas para generar opciones sobre un problema\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg098),expression:"eval_aedp.pg098"}],attrs:{"value":"3","name":"group98","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg098,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg098", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg098),expression:"eval_aedp.pg098"}],attrs:{"value":"2","name":"group98","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg098,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg098", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg098),expression:"eval_aedp.pg098"}],attrs:{"value":"1","name":"group98","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg098,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg098", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg098),expression:"eval_aedp.pg098"}],attrs:{"value":"0","name":"group98","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg098,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg098", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(7)}}},[_vm._m(31)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(9)}}},[_vm._m(32)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt9),expression:"vertt9"}],ref:"testt9",attrs:{"id":"testt9"}},[_vm._m(33),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg099==="" ? "color:red" : "color:black")},[_vm._v("\n                                    99. Puedo reaccionar después de haberme sentido desilusionado\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg099),expression:"eval_aedp.pg099"}],attrs:{"value":"3","name":"group99","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg099,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg099", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg099),expression:"eval_aedp.pg099"}],attrs:{"value":"2","name":"group99","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg099,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg099", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg099),expression:"eval_aedp.pg099"}],attrs:{"value":"1","name":"group99","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg099,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg099", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg099),expression:"eval_aedp.pg099"}],attrs:{"value":"0","name":"group99","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg099,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg099", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg100==="" ? "color:red" : "color:black")},[_vm._v("\n                                    100. Puedo realizar lo que necesito si me dedico a ello\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg100),expression:"eval_aedp.pg100"}],attrs:{"value":"3","name":"group100","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg100,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg100", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg100),expression:"eval_aedp.pg100"}],attrs:{"value":"2","name":"group100","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg100,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg100", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg100),expression:"eval_aedp.pg100"}],attrs:{"value":"1","name":"group100","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg100,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg100", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg100),expression:"eval_aedp.pg100"}],attrs:{"value":"0","name":"group100","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg100,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg100", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg101==="" ? "color:red" : "color:black")},[_vm._v("\n                                    101. Obstáculos y problemas en mi vida han producido cambios inesperados para mejorar\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg101),expression:"eval_aedp.pg101"}],attrs:{"value":"3","name":"group101","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg101,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg101", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg101),expression:"eval_aedp.pg101"}],attrs:{"value":"2","name":"group101","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg101,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg101", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg101),expression:"eval_aedp.pg101"}],attrs:{"value":"1","name":"group101","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg101,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg101", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg101),expression:"eval_aedp.pg101"}],attrs:{"value":"0","name":"group101","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg101,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg101", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg102==="" ? "color:red" : "color:black")},[_vm._v("\n                                    102. Encuentro fácil esperar con paciencia cuando es necesario\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg102),expression:"eval_aedp.pg102"}],attrs:{"value":"3","name":"group102","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg102,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg102", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg102),expression:"eval_aedp.pg102"}],attrs:{"value":"2","name":"group102","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg102,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg102", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg102),expression:"eval_aedp.pg102"}],attrs:{"value":"1","name":"group102","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg102,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg102", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg102),expression:"eval_aedp.pg102"}],attrs:{"value":"0","name":"group102","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg102,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg102", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg103==="" ? "color:red" : "color:black")},[_vm._v("\n                                         103. Siempre hay más de una respuesta correcta\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg103),expression:"eval_aedp.pg103"}],attrs:{"value":"3","name":"group103","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg103,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg103", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg103),expression:"eval_aedp.pg103"}],attrs:{"value":"2","name":"group103","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg103,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg103", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg103),expression:"eval_aedp.pg103"}],attrs:{"value":"1","name":"group103","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg103,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg103", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg103),expression:"eval_aedp.pg103"}],attrs:{"value":"0","name":"group103","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg103,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg103", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg104==="" ? "color:red" : "color:black")},[_vm._v("\n                                    104. Sé como dar satisfacción a todas las partes de mí mismo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg104),expression:"eval_aedp.pg104"}],attrs:{"value":"3","name":"group104","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg104,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg104", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg104),expression:"eval_aedp.pg104"}],attrs:{"value":"2","name":"group104","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg104,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg104", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg104),expression:"eval_aedp.pg104"}],attrs:{"value":"1","name":"group104","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg104,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg104", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg104),expression:"eval_aedp.pg104"}],attrs:{"value":"0","name":"group104","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg104,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg104", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg105==="" ? "color:red" : "color:black")},[_vm._v("\n                                    105. No me gusta dejar para mañana lo que se pueda hacer hoy\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg105),expression:"eval_aedp.pg105"}],attrs:{"value":"0","name":"group105","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg105,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg105", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg105),expression:"eval_aedp.pg105"}],attrs:{"value":"1","name":"group105","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg105,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg105", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg105),expression:"eval_aedp.pg105"}],attrs:{"value":"2","name":"group105","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg105,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg105", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg105),expression:"eval_aedp.pg105"}],attrs:{"value":"3","name":"group105","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg105,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg105", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg106==="" ? "color:red" : "color:black")},[_vm._v("\n                                    106. Temo ensayar otra vez una cosa que ya me ha fallado antes\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg106),expression:"eval_aedp.pg106"}],attrs:{"value":"3","name":"group106","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg106,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg106", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg106),expression:"eval_aedp.pg106"}],attrs:{"value":"2","name":"group106","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg106,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg106", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg106),expression:"eval_aedp.pg106"}],attrs:{"value":"1","name":"group106","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg106,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg106", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg106),expression:"eval_aedp.pg106"}],attrs:{"value":"0","name":"group106","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg106,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg106", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg107==="" ? "color:red" : "color:black")},[_vm._v("\n                                    107. Pienso que hay problemas por los cuales no vale la pena preocuparse \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg107),expression:"eval_aedp.pg107"}],attrs:{"value":"3","name":"group107","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg107,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg107", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg107),expression:"eval_aedp.pg107"}],attrs:{"value":"2","name":"group107","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg107,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg107", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg107),expression:"eval_aedp.pg107"}],attrs:{"value":"1","name":"group107","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg107,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg107", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg107),expression:"eval_aedp.pg107"}],attrs:{"value":"0","name":"group107","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg107,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg107", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg108==="" ? "color:red" : "color:black")},[_vm._v("\n                                    108. Yo me despreocupo cuando la tensión aumenta\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg108),expression:"eval_aedp.pg108"}],attrs:{"value":"3","name":"group108","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg108,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg108", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg108),expression:"eval_aedp.pg108"}],attrs:{"value":"2","name":"group108","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg108,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg108", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg108),expression:"eval_aedp.pg108"}],attrs:{"value":"1","name":"group108","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg108,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg108", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg108),expression:"eval_aedp.pg108"}],attrs:{"value":"0","name":"group108","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg108,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg108", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg109==="" ? "color:red" : "color:black")},[_vm._v("\n                                    109. Puedo ver el aspecto humorístico de las situaciones\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg109),expression:"eval_aedp.pg109"}],attrs:{"value":"3","name":"group109","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg109,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg109", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg109),expression:"eval_aedp.pg109"}],attrs:{"value":"2","name":"group109","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg109,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg109", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg109),expression:"eval_aedp.pg109"}],attrs:{"value":"1","name":"group109","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg109,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg109", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg109),expression:"eval_aedp.pg109"}],attrs:{"value":"0","name":"group109","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg109,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg109", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg110==="" ? "color:red" : "color:black")},[_vm._v("\n                                    110. A menudo dejo una cosa a un lado por un tiempo para obtener una nueva perspectiva\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg110),expression:"eval_aedp.pg110"}],attrs:{"value":"3","name":"group110","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg110,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg110", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg110),expression:"eval_aedp.pg110"}],attrs:{"value":"2","name":"group110","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg110,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg110", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg110),expression:"eval_aedp.pg110"}],attrs:{"value":"1","name":"group110","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg110,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg110", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg110),expression:"eval_aedp.pg110"}],attrs:{"value":"0","name":"group110","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg110,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg110", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{ref:"area9",staticClass:"input-field col s12 l4",attrs:{"id":"area9"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg111==="" ? "color:red" : "color:black")},[_vm._v("\n                                    111. Cuando encuentro un problema me concentro en qué se puede hacer para resolverlo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg111),expression:"eval_aedp.pg111"}],attrs:{"value":"3","name":"group111","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg111,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg111", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg111),expression:"eval_aedp.pg111"}],attrs:{"value":"2","name":"group111","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg111,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg111", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg111),expression:"eval_aedp.pg111"}],attrs:{"value":"1","name":"group111","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg111,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg111", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg111),expression:"eval_aedp.pg111"}],attrs:{"value":"0","name":"group111","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg111,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg111", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(8)}}},[_vm._m(34)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(10)}}},[_vm._m(35)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt10),expression:"vertt10"}],ref:"testt10",attrs:{"id":"testt10"}},[_vm._m(36),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg112==="" ? "color:red" : "color:black")},[_vm._v("\n                                    112. Puedo lamentarme cuando pierdo algo que es importante para mi \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg112),expression:"eval_aedp.pg112"}],attrs:{"value":"3","name":"group112","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg112,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg112", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg112),expression:"eval_aedp.pg112"}],attrs:{"value":"2","name":"group112","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg112,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg112", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg112),expression:"eval_aedp.pg112"}],attrs:{"value":"1","name":"group112","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg112,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg112", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg112),expression:"eval_aedp.pg112"}],attrs:{"value":"0","name":"group112","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg112,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg112", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg113==="" ? "color:red" : "color:black")},[_vm._v("\n                                         113. Me siento incómodo cuando alguien se acerca demasiado a mi emocionalmente\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg113),expression:"eval_aedp.pg113"}],attrs:{"value":"3","name":"group113","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg113,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg113", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg113),expression:"eval_aedp.pg113"}],attrs:{"value":"2","name":"group113","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg113,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg113", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg113),expression:"eval_aedp.pg113"}],attrs:{"value":"1","name":"group113","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg113,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg113", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg113),expression:"eval_aedp.pg113"}],attrs:{"value":"0","name":"group113","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg113,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg113", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg114==="" ? "color:red" : "color:black")},[_vm._v("\n                                    114. Tengo varios amigos con quienes puedo contar en caso de dificultades\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg114),expression:"eval_aedp.pg114"}],attrs:{"value":"3","name":"group114","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg114,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg114", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg114),expression:"eval_aedp.pg114"}],attrs:{"value":"2","name":"group114","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg114,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg114", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg114),expression:"eval_aedp.pg114"}],attrs:{"value":"1","name":"group114","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg114,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg114", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg114),expression:"eval_aedp.pg114"}],attrs:{"value":"0","name":"group114","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg114,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg114", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg115==="" ? "color:red" : "color:black")},[_vm._v("\n                                    115. Muestro mucho amor y afecto a mis amigos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg115),expression:"eval_aedp.pg115"}],attrs:{"value":"0","name":"group115","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg115,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg115", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg115),expression:"eval_aedp.pg115"}],attrs:{"value":"1","name":"group115","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg115,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg115", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg115),expression:"eval_aedp.pg115"}],attrs:{"value":"2","name":"group115","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg115,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg115", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg115),expression:"eval_aedp.pg115"}],attrs:{"value":"3","name":"group115","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg115,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg115", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg116==="" ? "color:red" : "color:black")},[_vm._v("\n                                    116. Cuando tengo un problema, sé a quien acudir o qué hacer para ayudar a resolverlo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg116),expression:"eval_aedp.pg116"}],attrs:{"value":"3","name":"group116","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg116,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg116", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg116),expression:"eval_aedp.pg116"}],attrs:{"value":"2","name":"group116","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg116,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg116", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg116),expression:"eval_aedp.pg116"}],attrs:{"value":"1","name":"group116","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg116,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg116", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg116),expression:"eval_aedp.pg116"}],attrs:{"value":"0","name":"group116","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg116,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg116", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg117==="" ? "color:red" : "color:black")},[_vm._v("\n                                    117. Mis creencias y valores guían mi conducta diaria \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg117),expression:"eval_aedp.pg117"}],attrs:{"value":"3","name":"group117","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg117,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg117", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg117),expression:"eval_aedp.pg117"}],attrs:{"value":"2","name":"group117","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg117,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg117", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg117),expression:"eval_aedp.pg117"}],attrs:{"value":"1","name":"group117","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg117,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg117", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg117),expression:"eval_aedp.pg117"}],attrs:{"value":"0","name":"group117","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg117,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg117", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg118==="" ? "color:red" : "color:black")},[_vm._v("\n                                    118. Mi familia está siempre conmigo cuando la necesito\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg118),expression:"eval_aedp.pg118"}],attrs:{"value":"3","name":"group118","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg118,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg118", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg118),expression:"eval_aedp.pg118"}],attrs:{"value":"2","name":"group118","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg118,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg118", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg118),expression:"eval_aedp.pg118"}],attrs:{"value":"1","name":"group118","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg118,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg118", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg118),expression:"eval_aedp.pg118"}],attrs:{"value":"0","name":"group118","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg118,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg118", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg119==="" ? "color:red" : "color:black")},[_vm._v("\n                                    119. Dudo que mis colegas realmente me aprecien como persona\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg119),expression:"eval_aedp.pg119"}],attrs:{"value":"3","name":"group119","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg119,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg119", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg119),expression:"eval_aedp.pg119"}],attrs:{"value":"2","name":"group119","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg119,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg119", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg119),expression:"eval_aedp.pg119"}],attrs:{"value":"1","name":"group119","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg119,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg119", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg119),expression:"eval_aedp.pg119"}],attrs:{"value":"0","name":"group119","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg119,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg119", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg120==="" ? "color:red" : "color:black")},[_vm._v("\n                                    120. Me cuesta trabajo hacer amistades\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg120),expression:"eval_aedp.pg120"}],attrs:{"value":"3","name":"group120","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg120,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg120", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg120),expression:"eval_aedp.pg120"}],attrs:{"value":"2","name":"group120","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg120,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg120", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg120),expression:"eval_aedp.pg120"}],attrs:{"value":"1","name":"group120","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg120,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg120", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg120),expression:"eval_aedp.pg120"}],attrs:{"value":"0","name":"group120","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg120,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg120", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{ref:"area10",staticClass:"input-field col s12 l4",attrs:{"id":"area10"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg121==="" ? "color:red" : "color:black")},[_vm._v("\n                                    121. Rara vez lloro\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg121),expression:"eval_aedp.pg121"}],attrs:{"value":"3","name":"group121","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg121,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg121", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg121),expression:"eval_aedp.pg121"}],attrs:{"value":"2","name":"group121","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg121,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg121", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg121),expression:"eval_aedp.pg121"}],attrs:{"value":"1","name":"group121","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg121,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg121", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg121),expression:"eval_aedp.pg121"}],attrs:{"value":"0","name":"group121","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg121,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg121", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(37)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(9)}}},[_vm._m(38)])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grupo2),expression:"grupo2"}]},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt11",class:_vm.activott11,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt11","href":"#testt11"},on:{"click":function($event){_vm.nadaG2(1)}}},[_vm._v("ÁREA 11")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt12",class:_vm.activott12,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt12","href":"#testt12"},on:{"click":function($event){_vm.nadaG2(2)}}},[_vm._v("ÁREA 12")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt13",class:_vm.activott13,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt13","href":"#testt13"},on:{"click":function($event){_vm.nadaG2(3)}}},[_vm._v("ÁREA 13")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt14",class:_vm.activott14,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt14","href":"#testt14"},on:{"click":function($event){_vm.nadaG2(4)}}},[_vm._v("ÁREA 14")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt15",class:_vm.activott15,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt15","href":"#testt15"},on:{"click":function($event){_vm.nadaG2(5)}}},[_vm._v("ÁREA 15")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt16",class:_vm.activott16,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt16","href":"#testt16"},on:{"click":function($event){_vm.nadaG2(6)}}},[_vm._v("ÁREA 16")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt17",class:_vm.activott17,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt17","href":"#testt17"},on:{"click":function($event){_vm.nadaG2(7)}}},[_vm._v("ÁREA 17")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt18",class:_vm.activott18,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt18","href":"#testt18"},on:{"click":function($event){_vm.nadaG2(8)}}},[_vm._v("ÁREA 18")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt19",class:_vm.activott19,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt19","href":"#testt19"},on:{"click":function($event){_vm.nadaG2(9)}}},[_vm._v("ÁREA 19")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt20",class:_vm.activott20,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt20","href":"#testt20"},on:{"click":function($event){_vm.nadaG2(10)}}},[_vm._v("ÁREA 20")])]),_vm._v(" "),_c('li',{staticClass:"tab col s1"},[_c('a',{ref:"testtt21",class:_vm.activott21,staticStyle:{"font-size":"18px","font-weight":"bold"},attrs:{"id":"testtt21","href":"#testt21"},on:{"click":function($event){_vm.nadaG2(11)}}},[_vm._v("ÁREA 21")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt11),expression:"vertt11"}],ref:"testt11",attrs:{"id":"testt11"}},[_vm._m(39),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg122==="" ? "color:red" : "color:black")},[_vm._v("\n                                    122. Puedo contradecir con eficacia para producir un cambio \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg122),expression:"eval_aedp.pg122"}],attrs:{"value":"3","name":"group122","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg122,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg122", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg122),expression:"eval_aedp.pg122"}],attrs:{"value":"2","name":"group122","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg122,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg122", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg122),expression:"eval_aedp.pg122"}],attrs:{"value":"1","name":"group122","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg122,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg122", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg122),expression:"eval_aedp.pg122"}],attrs:{"value":"0","name":"group122","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg122,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg122", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg123==="" ? "color:red" : "color:black")},[_vm._v("\n                                         123. No expresaría mis sentimientos si creyera que con ello causaría un desacuerdo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg123),expression:"eval_aedp.pg123"}],attrs:{"value":"0","name":"group123","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg123,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg123", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg123),expression:"eval_aedp.pg123"}],attrs:{"value":"1","name":"group123","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg123,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg123", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg123),expression:"eval_aedp.pg123"}],attrs:{"value":"2","name":"group123","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg123,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg123", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg123),expression:"eval_aedp.pg123"}],attrs:{"value":"3","name":"group123","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg123,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg123", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg124==="" ? "color:red" : "color:black")},[_vm._v("\n                                    124. En el fondo yo solo puedo confiar en mí mismo para hacer las cosas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg124),expression:"eval_aedp.pg124"}],attrs:{"value":"0","name":"group124","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg124,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg124", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg124),expression:"eval_aedp.pg124"}],attrs:{"value":"1","name":"group124","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg124,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg124", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg124),expression:"eval_aedp.pg124"}],attrs:{"value":"2","name":"group124","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg124,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg124", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg124),expression:"eval_aedp.pg124"}],attrs:{"value":"3","name":"group124","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg124,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg124", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg125==="" ? "color:red" : "color:black")},[_vm._v("\n                                    125. Permanezco en calma aún en situaciones en que los demás se irritan\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg125),expression:"eval_aedp.pg125"}],attrs:{"value":"0","name":"group125","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg125,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg125", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg125),expression:"eval_aedp.pg125"}],attrs:{"value":"1","name":"group125","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg125,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg125", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg125),expression:"eval_aedp.pg125"}],attrs:{"value":"2","name":"group125","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg125,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg125", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg125),expression:"eval_aedp.pg125"}],attrs:{"value":"3","name":"group125","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg125,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg125", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg126==="" ? "color:red" : "color:black")},[_vm._v("\n                                    126. Es mejor no alborotar problemas si se pueden evitar\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg126),expression:"eval_aedp.pg126"}],attrs:{"value":"0","name":"group126","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg126,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg126", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg126),expression:"eval_aedp.pg126"}],attrs:{"value":"1","name":"group126","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg126,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg126", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg126),expression:"eval_aedp.pg126"}],attrs:{"value":"2","name":"group126","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg126,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg126", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg126),expression:"eval_aedp.pg126"}],attrs:{"value":"3","name":"group126","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg126,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg126", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg127==="" ? "color:red" : "color:black")},[_vm._v("\n                                    127. Me cuesta trabajo obtener consenso de mi equipo de trabajo \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg127),expression:"eval_aedp.pg127"}],attrs:{"value":"0","name":"group127","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg127,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg127", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg127),expression:"eval_aedp.pg127"}],attrs:{"value":"1","name":"group127","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg127,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg127", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg127),expression:"eval_aedp.pg127"}],attrs:{"value":"2","name":"group127","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg127,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg127", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg127),expression:"eval_aedp.pg127"}],attrs:{"value":"3","name":"group127","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg127,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg127", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg128==="" ? "color:red" : "color:black")},[_vm._v("\n                                    128. Pido retroalimentación a mis colegas sobre mi rendimiento\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg128),expression:"eval_aedp.pg128"}],attrs:{"value":"3","name":"group128","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg128,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg128", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg128),expression:"eval_aedp.pg128"}],attrs:{"value":"2","name":"group128","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg128,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg128", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg128),expression:"eval_aedp.pg128"}],attrs:{"value":"1","name":"group128","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg128,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg128", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg128),expression:"eval_aedp.pg128"}],attrs:{"value":"0","name":"group128","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg128,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg128", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg129==="" ? "color:red" : "color:black")},[_vm._v("\n                                    129. Tengo habilidad para organizar y motivar grupos de personas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg129),expression:"eval_aedp.pg129"}],attrs:{"value":"3","name":"group129","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg129,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg129", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg129),expression:"eval_aedp.pg129"}],attrs:{"value":"2","name":"group129","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg129,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg129", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg129),expression:"eval_aedp.pg129"}],attrs:{"value":"1","name":"group129","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg129,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg129", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg129),expression:"eval_aedp.pg129"}],attrs:{"value":"0","name":"group129","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg129,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg129", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg130==="" ? "color:red" : "color:black")},[_vm._v("\n                                    130. Me gusta hacer frente a los problemas en el trabajo y resolverlos \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg130),expression:"eval_aedp.pg130"}],attrs:{"value":"3","name":"group130","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg130,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg130", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg130),expression:"eval_aedp.pg130"}],attrs:{"value":"2","name":"group130","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg130,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg130", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg130),expression:"eval_aedp.pg130"}],attrs:{"value":"1","name":"group130","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg130,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg130", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg130),expression:"eval_aedp.pg130"}],attrs:{"value":"0","name":"group130","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg130,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg130", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg131==="" ? "color:red" : "color:black")},[_vm._v("\n                                    131. Escucho la crítica con mente abierta\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg131),expression:"eval_aedp.pg131"}],attrs:{"value":"3","name":"group131","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg131,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg131", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg131),expression:"eval_aedp.pg131"}],attrs:{"value":"2","name":"group131","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg131,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg131", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg131),expression:"eval_aedp.pg131"}],attrs:{"value":"1","name":"group131","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg131,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg131", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg131),expression:"eval_aedp.pg131"}],attrs:{"value":"0","name":"group131","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg131,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg131", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg132==="" ? "color:red" : "color:black")},[_vm._v("\n                                    132. Dejo que las cosas crezcan hasta el punto crítico antes de hablar de ellas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg132),expression:"eval_aedp.pg132"}],attrs:{"value":"0","name":"group132","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg132,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg132", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg132),expression:"eval_aedp.pg132"}],attrs:{"value":"1","name":"group132","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg132,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg132", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg132),expression:"eval_aedp.pg132"}],attrs:{"value":"2","name":"group132","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg132,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg132", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg132),expression:"eval_aedp.pg132"}],attrs:{"value":"3","name":"group132","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg132,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg132", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg133==="" ? "color:red" : "color:black")},[_vm._v("\n                                    133. Cuando hago un comentario crítico, me concentro en la conducta y no en la persona\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg133),expression:"eval_aedp.pg133"}],attrs:{"value":"3","name":"group133","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg133,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg133", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg133),expression:"eval_aedp.pg133"}],attrs:{"value":"2","name":"group133","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg133,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg133", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg133),expression:"eval_aedp.pg133"}],attrs:{"value":"1","name":"group133","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg133,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg133", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg133),expression:"eval_aedp.pg133"}],attrs:{"value":"0","name":"group133","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg133,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg133", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{ref:"area11",staticClass:"input-field col s12 l4",attrs:{"id":"area11"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg134==="" ? "color:red" : "color:black")},[_vm._v("\n                                    134. Evito las disputas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg134),expression:"eval_aedp.pg134"}],attrs:{"value":"3","name":"group134","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg134,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg134", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg134),expression:"eval_aedp.pg134"}],attrs:{"value":"2","name":"group134","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg134,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg134", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg134),expression:"eval_aedp.pg134"}],attrs:{"value":"1","name":"group134","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg134,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg134", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg134),expression:"eval_aedp.pg134"}],attrs:{"value":"0","name":"group134","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg134,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg134", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG2(2)}}},[_vm._m(40)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt12),expression:"vertt12"}],ref:"testt12",attrs:{"id":"testt12"}},[_vm._m(41),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg135==="" ? "color:red" : "color:black")},[_vm._v("\n                                    135. Yo puedo ver la mortificación de los demás aunque no lo mencionen\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg135),expression:"eval_aedp.pg135"}],attrs:{"value":"3","name":"group135","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg135,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg135", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg135),expression:"eval_aedp.pg135"}],attrs:{"value":"2","name":"group135","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg135,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg135", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg135),expression:"eval_aedp.pg135"}],attrs:{"value":"1","name":"group135","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg135,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg135", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg135),expression:"eval_aedp.pg135"}],attrs:{"value":"0","name":"group135","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg135,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg135", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg136==="" ? "color:red" : "color:black")},[_vm._v("\n                                    136. Puedo leer las emociones de la gente por sus ademanes\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg136),expression:"eval_aedp.pg136"}],attrs:{"value":"3","name":"group136","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg136,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg136", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg136),expression:"eval_aedp.pg136"}],attrs:{"value":"2","name":"group136","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg136,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg136", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg136),expression:"eval_aedp.pg136"}],attrs:{"value":"1","name":"group136","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg136,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg136", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg136),expression:"eval_aedp.pg136"}],attrs:{"value":"0","name":"group136","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg136,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg136", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg137==="" ? "color:red" : "color:black")},[_vm._v("\n                                    137. Actúo con ética en mi trato con los demás\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg137),expression:"eval_aedp.pg137"}],attrs:{"value":"3","name":"group137","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg137,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg137", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg137),expression:"eval_aedp.pg137"}],attrs:{"value":"2","name":"group137","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg137,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg137", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg137),expression:"eval_aedp.pg137"}],attrs:{"value":"1","name":"group137","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg137,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg137", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg137),expression:"eval_aedp.pg137"}],attrs:{"value":"0","name":"group137","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg137,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg137", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg138==="" ? "color:red" : "color:black")},[_vm._v("\n                                    138. No vacilaría en hacer un esfuerzo extra por ayudar a una persona que esté en dificultades\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg138),expression:"eval_aedp.pg138"}],attrs:{"value":"3","name":"group138","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg138,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg138", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg138),expression:"eval_aedp.pg138"}],attrs:{"value":"2","name":"group138","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg138,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg138", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg138),expression:"eval_aedp.pg138"}],attrs:{"value":"1","name":"group138","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg138,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg138", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg138),expression:"eval_aedp.pg138"}],attrs:{"value":"0","name":"group138","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg138,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg138", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg139==="" ? "color:red" : "color:black")},[_vm._v("\n                                    139. Tengo en cuenta los sentimientos de los demás en mi trato con ellos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg139),expression:"eval_aedp.pg139"}],attrs:{"value":"3","name":"group139","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg139,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg139", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg139),expression:"eval_aedp.pg139"}],attrs:{"value":"2","name":"group139","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg139,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg139", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg139),expression:"eval_aedp.pg139"}],attrs:{"value":"1","name":"group139","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg139,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg139", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg139),expression:"eval_aedp.pg139"}],attrs:{"value":"0","name":"group139","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg139,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg139", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg140==="" ? "color:red" : "color:black")},[_vm._v("\n                                    140. Me puedo poner en el lugar de la otra persona\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg140),expression:"eval_aedp.pg140"}],attrs:{"value":"3","name":"group140","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg140,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg140", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg140),expression:"eval_aedp.pg140"}],attrs:{"value":"2","name":"group140","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg140,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg140", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg140),expression:"eval_aedp.pg140"}],attrs:{"value":"1","name":"group140","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg140,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg140", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg140),expression:"eval_aedp.pg140"}],attrs:{"value":"0","name":"group140","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg140,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg140", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg141==="" ? "color:red" : "color:black")},[_vm._v("\n                                    141. Hay personas a quienes jamas perdono\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg141),expression:"eval_aedp.pg141"}],attrs:{"value":"0","name":"group141","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg141,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg141", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg141),expression:"eval_aedp.pg141"}],attrs:{"value":"1","name":"group141","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg141,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg141", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg141),expression:"eval_aedp.pg141"}],attrs:{"value":"2","name":"group141","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg141,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg141", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg141),expression:"eval_aedp.pg141"}],attrs:{"value":"3","name":"group141","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg141,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg141", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg142==="" ? "color:red" : "color:black")},[_vm._v("\n                                    142. Puedo perdonarme a mi mismo por no ser perfecto\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg142),expression:"eval_aedp.pg142"}],attrs:{"value":"3","name":"group142","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg142,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg142", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg142),expression:"eval_aedp.pg142"}],attrs:{"value":"2","name":"group142","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg142,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg142", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg142),expression:"eval_aedp.pg142"}],attrs:{"value":"1","name":"group142","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg142,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg142", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg142),expression:"eval_aedp.pg142"}],attrs:{"value":"0","name":"group142","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg142,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg142", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg143==="" ? "color:red" : "color:black")},[_vm._v("\n                                    143. Cuando tengo éxito en algo me parece que podía haberlo hecho mejor\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg143),expression:"eval_aedp.pg143"}],attrs:{"value":"0","name":"group143","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg143,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg143", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg143),expression:"eval_aedp.pg143"}],attrs:{"value":"1","name":"group143","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg143,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg143", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg143),expression:"eval_aedp.pg143"}],attrs:{"value":"2","name":"group143","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg143,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg143", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg143),expression:"eval_aedp.pg143"}],attrs:{"value":"3","name":"group143","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg143,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg143", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg144==="" ? "color:red" : "color:black")},[_vm._v("\n                                    144. Ayudo a los demás a quedar bien en las situaciones difíciles\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg144),expression:"eval_aedp.pg144"}],attrs:{"value":"3","name":"group144","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg144,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg144", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg144),expression:"eval_aedp.pg144"}],attrs:{"value":"2","name":"group144","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg144,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg144", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg144),expression:"eval_aedp.pg144"}],attrs:{"value":"1","name":"group144","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg144,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg144", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg144),expression:"eval_aedp.pg144"}],attrs:{"value":"0","name":"group144","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg144,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg144", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg145==="" ? "color:red" : "color:black")},[_vm._v("\n                                    145. Constantemente me preocupo por mis deficiencias\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg145),expression:"eval_aedp.pg145"}],attrs:{"value":"0","name":"group145","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg145,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg145", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg145),expression:"eval_aedp.pg145"}],attrs:{"value":"1","name":"group145","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg145,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg145", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg145),expression:"eval_aedp.pg145"}],attrs:{"value":"2","name":"group145","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg145,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg145", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg145),expression:"eval_aedp.pg145"}],attrs:{"value":"3","name":"group145","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg145,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg145", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{ref:"area12",staticClass:"input-field col s12 l4",attrs:{"id":"area12"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg146==="" ? "color:red" : "color:black")},[_vm._v("\n                                    146. Envidio a los que tienen más que yo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg146),expression:"eval_aedp.pg146"}],attrs:{"value":"0","name":"group146","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg146,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg146", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg146),expression:"eval_aedp.pg146"}],attrs:{"value":"1","name":"group146","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg146,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg146", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg146),expression:"eval_aedp.pg146"}],attrs:{"value":"2","name":"group146","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg146,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg146", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg146),expression:"eval_aedp.pg146"}],attrs:{"value":"3","name":"group146","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg146,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg146", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG2(1)}}},[_vm._m(42)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG2(3)}}},[_vm._m(43)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt13),expression:"vertt13"}],ref:"testt13",attrs:{"id":"testt13"}},[_vm._m(44),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg147==="" ? "color:red" : "color:black")},[_vm._v("\n                                    147. Veo el lado bueno de las cosas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg147),expression:"eval_aedp.pg147"}],attrs:{"value":"3","name":"group147","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg147,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg147", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg147),expression:"eval_aedp.pg147"}],attrs:{"value":"2","name":"group147","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg147,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg147", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg147),expression:"eval_aedp.pg147"}],attrs:{"value":"1","name":"group147","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg147,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg147", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg147),expression:"eval_aedp.pg147"}],attrs:{"value":"0","name":"group147","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg147,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg147", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg148==="" ? "color:red" : "color:black")},[_vm._v("\n                                    148. Amo mi vida\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg148),expression:"eval_aedp.pg148"}],attrs:{"value":"3","name":"group148","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg148,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg148", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg148),expression:"eval_aedp.pg148"}],attrs:{"value":"2","name":"group148","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg148,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg148", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg148),expression:"eval_aedp.pg148"}],attrs:{"value":"1","name":"group148","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg148,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg148", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg148),expression:"eval_aedp.pg148"}],attrs:{"value":"0","name":"group148","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg148,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg148", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg149==="" ? "color:red" : "color:black")},[_vm._v("\n                                    149. Se que puedo encontrar soluciones a problemas difíciles\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg149),expression:"eval_aedp.pg149"}],attrs:{"value":"3","name":"group149","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg149,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg149", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg149),expression:"eval_aedp.pg149"}],attrs:{"value":"2","name":"group149","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg149,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg149", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg149),expression:"eval_aedp.pg149"}],attrs:{"value":"1","name":"group149","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg149,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg149", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg149),expression:"eval_aedp.pg149"}],attrs:{"value":"0","name":"group149","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg149,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg149", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg150==="" ? "color:red" : "color:black")},[_vm._v("\n                                    150. Creo que las cosas generalmente salen bien\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg150),expression:"eval_aedp.pg150"}],attrs:{"value":"3","name":"group150","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg150,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg150", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg150),expression:"eval_aedp.pg150"}],attrs:{"value":"2","name":"group150","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg150,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg150", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg150),expression:"eval_aedp.pg150"}],attrs:{"value":"1","name":"group150","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg150,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg150", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg150),expression:"eval_aedp.pg150"}],attrs:{"value":"0","name":"group150","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg150,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg150", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg151==="" ? "color:red" : "color:black")},[_vm._v("\n                                    151. Contínuamente me he visto frustrado en la vida por mala suerte\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg151),expression:"eval_aedp.pg151"}],attrs:{"value":"0","name":"group151","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg151,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg151", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg151),expression:"eval_aedp.pg151"}],attrs:{"value":"1","name":"group151","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg151,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg151", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg151),expression:"eval_aedp.pg151"}],attrs:{"value":"2","name":"group151","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg151,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg151", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg151),expression:"eval_aedp.pg151"}],attrs:{"value":"3","name":"group151","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg151,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg151", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg152==="" ? "color:red" : "color:black")},[_vm._v("\n                                    152. Me gusta ser el que soy\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg152),expression:"eval_aedp.pg152"}],attrs:{"value":"3","name":"group152","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg152,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg152", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg152),expression:"eval_aedp.pg152"}],attrs:{"value":"2","name":"group152","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg152,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg152", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg152),expression:"eval_aedp.pg152"}],attrs:{"value":"1","name":"group152","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg152,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg152", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg152),expression:"eval_aedp.pg152"}],attrs:{"value":"0","name":"group152","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg152,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg152", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg153==="" ? "color:red" : "color:black")},[_vm._v("\n                                    153. Veo los retos como oportunidades para aprender\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg153),expression:"eval_aedp.pg153"}],attrs:{"value":"3","name":"group153","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg153,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg153", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg153),expression:"eval_aedp.pg153"}],attrs:{"value":"2","name":"group153","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg153,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg153", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg153),expression:"eval_aedp.pg153"}],attrs:{"value":"1","name":"group153","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg153,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg153", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg153),expression:"eval_aedp.pg153"}],attrs:{"value":"0","name":"group153","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg153,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg153", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{ref:"area13",staticClass:"input-field col s12 l4",attrs:{"id":"area13"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg154==="" ? "color:red" : "color:black")},[_vm._v("\n                                    154. Bajo presión estoy seguro de que encontraré una solución \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg154),expression:"eval_aedp.pg154"}],attrs:{"value":"3","name":"group154","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg154,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg154", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg154),expression:"eval_aedp.pg154"}],attrs:{"value":"2","name":"group154","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg154,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg154", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg154),expression:"eval_aedp.pg154"}],attrs:{"value":"1","name":"group154","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg154,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg154", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg154),expression:"eval_aedp.pg154"}],attrs:{"value":"0","name":"group154","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg154,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg154", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG2(2)}}},[_vm._m(45)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG2(4)}}},[_vm._m(46)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt14),expression:"vertt14"}],ref:"testt14",attrs:{"id":"testt14"}},[_vm._m(47),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg155==="" ? "color:red" : "color:black")},[_vm._v("\n                                    155. A veces tengo la solución correcta sin tener las razones\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg155),expression:"eval_aedp.pg155"}],attrs:{"value":"3","name":"group155","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg155,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg155", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg155),expression:"eval_aedp.pg155"}],attrs:{"value":"2","name":"group155","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg155,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg155", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg155),expression:"eval_aedp.pg155"}],attrs:{"value":"1","name":"group155","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg155,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg155", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg155),expression:"eval_aedp.pg155"}],attrs:{"value":"0","name":"group155","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg155,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg155", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg156==="" ? "color:red" : "color:black")},[_vm._v("\n                                    156. Mis corazonadas suelen ser acertadas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg156),expression:"eval_aedp.pg156"}],attrs:{"value":"3","name":"group156","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg156,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg156", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg156),expression:"eval_aedp.pg156"}],attrs:{"value":"2","name":"group156","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg156,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg156", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg156),expression:"eval_aedp.pg156"}],attrs:{"value":"1","name":"group156","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg156,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg156", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg156),expression:"eval_aedp.pg156"}],attrs:{"value":"0","name":"group156","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg156,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg156", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg157==="" ? "color:red" : "color:black")},[_vm._v("\n                                    157. Visualizo mis metas futuras\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg157),expression:"eval_aedp.pg157"}],attrs:{"value":"3","name":"group157","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg157,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg157", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg157),expression:"eval_aedp.pg157"}],attrs:{"value":"2","name":"group157","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg157,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg157", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg157),expression:"eval_aedp.pg157"}],attrs:{"value":"1","name":"group157","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg157,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg157", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg157),expression:"eval_aedp.pg157"}],attrs:{"value":"0","name":"group157","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg157,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg157", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg158==="" ? "color:red" : "color:black")},[_vm._v("\n                                    158. Puedo ver el producto terminado o el cuadro antes de que estén completos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg158),expression:"eval_aedp.pg158"}],attrs:{"value":"3","name":"group158","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg158,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg158", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg158),expression:"eval_aedp.pg158"}],attrs:{"value":"2","name":"group158","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg158,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg158", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg158),expression:"eval_aedp.pg158"}],attrs:{"value":"1","name":"group158","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg158,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg158", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg158),expression:"eval_aedp.pg158"}],attrs:{"value":"0","name":"group158","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg158,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg158", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg159==="" ? "color:red" : "color:black")},[_vm._v("\n                                    159. Creo en mis sueños aún cuando otros no los vean ni los entiendan\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg159),expression:"eval_aedp.pg159"}],attrs:{"value":"0","name":"group159","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg159,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg159", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg159),expression:"eval_aedp.pg159"}],attrs:{"value":"1","name":"group159","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg159,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg159", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg159),expression:"eval_aedp.pg159"}],attrs:{"value":"2","name":"group159","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg159,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg159", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg159),expression:"eval_aedp.pg159"}],attrs:{"value":"3","name":"group159","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg159,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg159", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg160==="" ? "color:red" : "color:black")},[_vm._v("\n                                    160. Cuando me veo ante una elección difícil, sigo mi corazón\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg160),expression:"eval_aedp.pg160"}],attrs:{"value":"3","name":"group160","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg160,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg160", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg160),expression:"eval_aedp.pg160"}],attrs:{"value":"2","name":"group160","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg160,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg160", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg160),expression:"eval_aedp.pg160"}],attrs:{"value":"1","name":"group160","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg160,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg160", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg160),expression:"eval_aedp.pg160"}],attrs:{"value":"0","name":"group160","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg160,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg160", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg161==="" ? "color:red" : "color:black")},[_vm._v("\n                                    161. Presto atención cuando las cosas no me parecen del todo bien\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg161),expression:"eval_aedp.pg161"}],attrs:{"value":"3","name":"group161","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg161,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg161", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg161),expression:"eval_aedp.pg161"}],attrs:{"value":"2","name":"group161","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg161,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg161", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg161),expression:"eval_aedp.pg161"}],attrs:{"value":"1","name":"group161","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg161,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg161", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg161),expression:"eval_aedp.pg161"}],attrs:{"value":"0","name":"group161","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg161,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg161", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg162==="" ? "color:red" : "color:black")},[_vm._v("\n                                    162. Una vez que me he decidio rara vez cambio de opinión \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg162),expression:"eval_aedp.pg162"}],attrs:{"value":"0","name":"group162","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg162,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg162", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg162),expression:"eval_aedp.pg162"}],attrs:{"value":"1","name":"group162","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg162,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg162", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg162),expression:"eval_aedp.pg162"}],attrs:{"value":"2","name":"group162","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg162,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg162", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg162),expression:"eval_aedp.pg162"}],attrs:{"value":"3","name":"group162","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg162,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg162", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg163==="" ? "color:red" : "color:black")},[_vm._v("\n                                    163. La gente dice que yo soy un visionario \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg163),expression:"eval_aedp.pg163"}],attrs:{"value":"3","name":"group163","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg163,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg163", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg163),expression:"eval_aedp.pg163"}],attrs:{"value":"2","name":"group163","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg163,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg163", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg163),expression:"eval_aedp.pg163"}],attrs:{"value":"1","name":"group163","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg163,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg163", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg163),expression:"eval_aedp.pg163"}],attrs:{"value":"0","name":"group163","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg163,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg163", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg164==="" ? "color:red" : "color:black")},[_vm._v("\n                                    164. Cuando alguien presenta una opinión distinta a la mía, me cuesta trabajo aceptarla\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg164),expression:"eval_aedp.pg164"}],attrs:{"value":"0","name":"group164","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg164,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg164", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg164),expression:"eval_aedp.pg164"}],attrs:{"value":"1","name":"group164","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg164,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg164", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg164),expression:"eval_aedp.pg164"}],attrs:{"value":"2","name":"group164","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg164,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg164", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg164),expression:"eval_aedp.pg164"}],attrs:{"value":"3","name":"group164","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg164,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg164", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{ref:"area14",staticClass:"input-field col s12 l4",attrs:{"id":"area14"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg165==="" ? "color:red" : "color:black")},[_vm._v("\n                                    165. Uso mis reacciones intuitivas para tomar decisiones difíciles \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg165),expression:"eval_aedp.pg165"}],attrs:{"value":"3","name":"group165","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg165,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg165", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg165),expression:"eval_aedp.pg165"}],attrs:{"value":"2","name":"group165","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg165,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg165", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg165),expression:"eval_aedp.pg165"}],attrs:{"value":"1","name":"group165","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg165,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg165", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg165),expression:"eval_aedp.pg165"}],attrs:{"value":"0","name":"group165","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg165,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg165", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG2(3)}}},[_vm._m(48)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG2(5)}}},[_vm._m(49)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt15),expression:"vertt15"}],ref:"testt15",attrs:{"id":"testt15"}},[_vm._m(50),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg166==="" ? "color:red" : "color:black")},[_vm._v("\n                                    166. Todos se aprovecharían de mi si yo los dejara\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg166),expression:"eval_aedp.pg166"}],attrs:{"value":"0","name":"group166","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg166,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg166", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg166),expression:"eval_aedp.pg166"}],attrs:{"value":"1","name":"group166","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg166,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg166", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg166),expression:"eval_aedp.pg166"}],attrs:{"value":"2","name":"group166","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg166,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg166", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg166),expression:"eval_aedp.pg166"}],attrs:{"value":"3","name":"group166","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg166,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg166", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg167==="" ? "color:red" : "color:black")},[_vm._v("\n                                    167. Confío en los demás hasta que tenga razones para no confiar\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg167),expression:"eval_aedp.pg167"}],attrs:{"value":"0","name":"group167","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg167,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg167", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg167),expression:"eval_aedp.pg167"}],attrs:{"value":"1","name":"group167","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg167,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg167", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg167),expression:"eval_aedp.pg167"}],attrs:{"value":"2","name":"group167","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg167,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg167", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg167),expression:"eval_aedp.pg167"}],attrs:{"value":"3","name":"group167","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg167,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg167", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg168==="" ? "color:red" : "color:black")},[_vm._v("\n                                    168. Tengo mucho cuidado para decidirme a confiar en una persona\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg168),expression:"eval_aedp.pg168"}],attrs:{"value":"0","name":"group168","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg168,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg168", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg168),expression:"eval_aedp.pg168"}],attrs:{"value":"1","name":"group168","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg168,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg168", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg168),expression:"eval_aedp.pg168"}],attrs:{"value":"2","name":"group168","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg168,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg168", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg168),expression:"eval_aedp.pg168"}],attrs:{"value":"3","name":"group168","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg168,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg168", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg169==="" ? "color:red" : "color:black")},[_vm._v("\n                                    169. Respeto a mis colegas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg169),expression:"eval_aedp.pg169"}],attrs:{"value":"3","name":"group169","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg169,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg169", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg169),expression:"eval_aedp.pg169"}],attrs:{"value":"2","name":"group169","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg169,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg169", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg169),expression:"eval_aedp.pg169"}],attrs:{"value":"1","name":"group169","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg169,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg169", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg169),expression:"eval_aedp.pg169"}],attrs:{"value":"0","name":"group169","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg169,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg169", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"12px"},style:(_vm.eval_aedp.pg170==="" ? "color:red" : "color:black")},[_vm._v("\n                                    170. Las personas parecidas a mi en mi compañía han recibido más beneficios que yo \n                                    (v.gr., aumentos de sueldo, ascensos, oportunidades, recompensas, etc.)\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg170),expression:"eval_aedp.pg170"}],attrs:{"value":"0","name":"group170","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg170,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg170", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg170),expression:"eval_aedp.pg170"}],attrs:{"value":"1","name":"group170","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg170,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg170", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg170),expression:"eval_aedp.pg170"}],attrs:{"value":"2","name":"group170","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg170,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg170", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg170),expression:"eval_aedp.pg170"}],attrs:{"value":"3","name":"group170","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg170,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg170", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg171==="" ? "color:red" : "color:black")},[_vm._v("\n                                    171. Las personas a quienes trato son dignas de confianza\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg171),expression:"eval_aedp.pg171"}],attrs:{"value":"3","name":"group171","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg171,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg171", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg171),expression:"eval_aedp.pg171"}],attrs:{"value":"2","name":"group171","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg171,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg171", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg171),expression:"eval_aedp.pg171"}],attrs:{"value":"1","name":"group171","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg171,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg171", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg171),expression:"eval_aedp.pg171"}],attrs:{"value":"0","name":"group171","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg171,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg171", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg172==="" ? "color:red" : "color:black")},[_vm._v("\n                                    172. Parece que yo siempre salgo defraudado\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg172),expression:"eval_aedp.pg172"}],attrs:{"value":"0","name":"group172","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg172,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg172", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg172),expression:"eval_aedp.pg172"}],attrs:{"value":"1","name":"group172","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg172,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg172", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg172),expression:"eval_aedp.pg172"}],attrs:{"value":"2","name":"group172","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg172,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg172", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg172),expression:"eval_aedp.pg172"}],attrs:{"value":"3","name":"group172","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg172,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg172", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg173==="" ? "color:red" : "color:black")},[_vm._v("\n                                    173. Muy poco en la vida es justo o equitativo \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg173),expression:"eval_aedp.pg173"}],attrs:{"value":"0","name":"group173","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg173,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg173", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg173),expression:"eval_aedp.pg173"}],attrs:{"value":"1","name":"group173","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg173,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg173", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg173),expression:"eval_aedp.pg173"}],attrs:{"value":"2","name":"group173","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg173,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg173", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg173),expression:"eval_aedp.pg173"}],attrs:{"value":"3","name":"group173","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg173,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg173", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg174==="" ? "color:red" : "color:black")},[_vm._v("\n                                    174. Cuando algo no funciona yo trato de presentar un plan alterno \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg174),expression:"eval_aedp.pg174"}],attrs:{"value":"3","name":"group174","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg174,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg174", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg174),expression:"eval_aedp.pg174"}],attrs:{"value":"2","name":"group174","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg174,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg174", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg174),expression:"eval_aedp.pg174"}],attrs:{"value":"1","name":"group174","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg174,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg174", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg174),expression:"eval_aedp.pg174"}],attrs:{"value":"0","name":"group174","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg174,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg174", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{ref:"area15",staticClass:"input-field col s12 l4",attrs:{"id":"area15"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg175==="" ? "color:red" : "color:black")},[_vm._v("\n                                    175. Cuando conozco a una persona nueva, descubro muy poco de información personal sobre mí mismo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg175),expression:"eval_aedp.pg175"}],attrs:{"value":"0","name":"group175","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg175,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg175", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg175),expression:"eval_aedp.pg175"}],attrs:{"value":"1","name":"group175","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg175,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg175", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg175),expression:"eval_aedp.pg175"}],attrs:{"value":"2","name":"group175","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg175,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg175", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg175),expression:"eval_aedp.pg175"}],attrs:{"value":"3","name":"group175","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg175,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg175", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG2(4)}}},[_vm._m(51)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG2(6)}}},[_vm._m(52)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt16),expression:"vertt16"}],ref:"testt16",attrs:{"id":"testt16"}},[_vm._m(53),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg176==="" ? "color:red" : "color:black")},[_vm._v("\n                                    176. Yo puedo lograr todas las cosas que se hagan\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg176),expression:"eval_aedp.pg176"}],attrs:{"value":"3","name":"group176","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg176,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg176", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg176),expression:"eval_aedp.pg176"}],attrs:{"value":"2","name":"group176","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg176,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg176", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg176),expression:"eval_aedp.pg176"}],attrs:{"value":"1","name":"group176","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg176,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg176", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg176),expression:"eval_aedp.pg176"}],attrs:{"value":"0","name":"group176","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg176,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg176", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg177==="" ? "color:red" : "color:black")},[_vm._v("\n                                    177. La suerte hace un papel muy importante en mi vida\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg177),expression:"eval_aedp.pg177"}],attrs:{"value":"0","name":"group177","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg177,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg177", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg177),expression:"eval_aedp.pg177"}],attrs:{"value":"1","name":"group177","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg177,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg177", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg177),expression:"eval_aedp.pg177"}],attrs:{"value":"2","name":"group177","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg177,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg177", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg177),expression:"eval_aedp.pg177"}],attrs:{"value":"3","name":"group177","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg177,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg177", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg178==="" ? "color:red" : "color:black")},[_vm._v("\n                                    178. Encuentro inútil luchar contra la jerarquía establecida en mi compañía\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg178),expression:"eval_aedp.pg178"}],attrs:{"value":"0","name":"group1178","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg178,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg178", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg178),expression:"eval_aedp.pg178"}],attrs:{"value":"1","name":"group178","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg178,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg178", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg178),expression:"eval_aedp.pg178"}],attrs:{"value":"2","name":"group178","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg178,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg178", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg178),expression:"eval_aedp.pg178"}],attrs:{"value":"3","name":"group178","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg178,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg178", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg179==="" ? "color:red" : "color:black")},[_vm._v("\n                                    179. Las circunstancias están fuera de mi control\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg179),expression:"eval_aedp.pg179"}],attrs:{"value":"0","name":"group179","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg179,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg179", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg179),expression:"eval_aedp.pg179"}],attrs:{"value":"1","name":"group179","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg179,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg179", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg179),expression:"eval_aedp.pg179"}],attrs:{"value":"2","name":"group179","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg179,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg179", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg179),expression:"eval_aedp.pg179"}],attrs:{"value":"3","name":"group179","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg179,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg179", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"12px"},style:(_vm.eval_aedp.pg180==="" ? "color:red" : "color:black")},[_vm._v("\n                                    180. Necesito reconocimiento de los demás para que mi trabajo valga la pena\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg180),expression:"eval_aedp.pg180"}],attrs:{"value":"0","name":"group180","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg180,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg180", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg180),expression:"eval_aedp.pg180"}],attrs:{"value":"1","name":"group180","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg180,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg180", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg180),expression:"eval_aedp.pg180"}],attrs:{"value":"2","name":"group180","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg180,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg180", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg180),expression:"eval_aedp.pg180"}],attrs:{"value":"3","name":"group180","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg180,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg180", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg181==="" ? "color:red" : "color:black")},[_vm._v("\n                                    181. Es fácil que los demás gusten de mi\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg181),expression:"eval_aedp.pg181"}],attrs:{"value":"3","name":"group181","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg181,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg181", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg181),expression:"eval_aedp.pg181"}],attrs:{"value":"2","name":"group181","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg181,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg181", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg181),expression:"eval_aedp.pg181"}],attrs:{"value":"1","name":"group181","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg181,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg181", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg181),expression:"eval_aedp.pg181"}],attrs:{"value":"0","name":"group181","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg181,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg181", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg182==="" ? "color:red" : "color:black")},[_vm._v("\n                                    182. Me cuesta mucho trabajo aceptar los cumplidos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg182),expression:"eval_aedp.pg182"}],attrs:{"value":"0","name":"group182","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg182,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg182", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg182),expression:"eval_aedp.pg182"}],attrs:{"value":"1","name":"group182","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg182,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg182", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg182),expression:"eval_aedp.pg182"}],attrs:{"value":"2","name":"group182","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg182,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg182", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg182),expression:"eval_aedp.pg182"}],attrs:{"value":"3","name":"group182","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg182,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg182", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg183==="" ? "color:red" : "color:black")},[_vm._v("\n                                    183. Tengo la habilidad de conseguir lo que quiero\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg183),expression:"eval_aedp.pg183"}],attrs:{"value":"3","name":"group183","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg183,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg183", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg183),expression:"eval_aedp.pg183"}],attrs:{"value":"2","name":"group183","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg183,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg183", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg183),expression:"eval_aedp.pg183"}],attrs:{"value":"1","name":"group183","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg183,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg183", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg183),expression:"eval_aedp.pg183"}],attrs:{"value":"0","name":"group183","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg183,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg183", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg184==="" ? "color:red" : "color:black")},[_vm._v("\n                                    184. Siento que controlo mi vida \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg184),expression:"eval_aedp.pg184"}],attrs:{"value":"3","name":"group184","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg184,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg184", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg184),expression:"eval_aedp.pg184"}],attrs:{"value":"2","name":"group184","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg184,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg184", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg184),expression:"eval_aedp.pg184"}],attrs:{"value":"1","name":"group184","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg184,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg184", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg184),expression:"eval_aedp.pg184"}],attrs:{"value":"0","name":"group184","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg184,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg184", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg185==="" ? "color:red" : "color:black")},[_vm._v("\n                                    185. Si reflexiono sobre mi vida, podría sentir que básicamente no soy feliz\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg185),expression:"eval_aedp.pg185"}],attrs:{"value":"0","name":"group185","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg185,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg185", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg185),expression:"eval_aedp.pg185"}],attrs:{"value":"1","name":"group185","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg185,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg185", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg185),expression:"eval_aedp.pg185"}],attrs:{"value":"2","name":"group185","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg185,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg185", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg185),expression:"eval_aedp.pg185"}],attrs:{"value":"3","name":"group185","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg185,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg185", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg186==="" ? "color:red" : "color:black")},[_vm._v("\n                                    186. Me siento asustado y creo que no tengo el control de las cosas cuando éstas cambian rápidamente\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg186),expression:"eval_aedp.pg186"}],attrs:{"value":"0","name":"group186","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg186,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg186", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg186),expression:"eval_aedp.pg186"}],attrs:{"value":"1","name":"group186","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg186,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg186", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg186),expression:"eval_aedp.pg186"}],attrs:{"value":"2","name":"group186","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg186,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg186", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg186),expression:"eval_aedp.pg186"}],attrs:{"value":"3","name":"group186","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg186,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg186", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg187==="" ? "color:red" : "color:black")},[_vm._v("\n                                    187. Me gusta encargarme de una cosa \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg187),expression:"eval_aedp.pg187"}],attrs:{"value":"3","name":"group187","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg187,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg187", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg187),expression:"eval_aedp.pg187"}],attrs:{"value":"2","name":"group187","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg187,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg187", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg187),expression:"eval_aedp.pg187"}],attrs:{"value":"1","name":"group187","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg187,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg187", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg187),expression:"eval_aedp.pg187"}],attrs:{"value":"0","name":"group187","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg187,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg187", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{ref:"area16",staticClass:"input-field col s12 l4",attrs:{"id":"area16"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg188==="" ? "color:red" : "color:black")},[_vm._v("\n                                    188. Yo sé lo que quiero y lo busco\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg188),expression:"eval_aedp.pg188"}],attrs:{"value":"0","name":"group188","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg188,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg188", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg188),expression:"eval_aedp.pg188"}],attrs:{"value":"1","name":"group188","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg188,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg188", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg188),expression:"eval_aedp.pg188"}],attrs:{"value":"2","name":"group188","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg188,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg188", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg188),expression:"eval_aedp.pg188"}],attrs:{"value":"3","name":"group188","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg188,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg188", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG2(5)}}},[_vm._m(54)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG2(7)}}},[_vm._m(55)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt17),expression:"vertt17"}],ref:"testt17",attrs:{"id":"testt17"}},[_vm._m(56),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg189==="" ? "color:red" : "color:black")},[_vm._v("\n                                    189. Cuando cometo un error estoy dispuesto a reconocerlo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg189),expression:"eval_aedp.pg189"}],attrs:{"value":"3","name":"group189","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg189,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg189", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg189),expression:"eval_aedp.pg189"}],attrs:{"value":"2","name":"group189","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg189,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg189", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg189),expression:"eval_aedp.pg189"}],attrs:{"value":"1","name":"group189","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg189,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg189", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg189),expression:"eval_aedp.pg189"}],attrs:{"value":"0","name":"group189","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg189,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg189", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg190==="" ? "color:red" : "color:black")},[_vm._v("\n                                    190. Siento que estoy engañando a los demás\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg190),expression:"eval_aedp.pg190"}],attrs:{"value":"0","name":"group190","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg190,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg190", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg190),expression:"eval_aedp.pg190"}],attrs:{"value":"1","name":"group190","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg190,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg190", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg190),expression:"eval_aedp.pg190"}],attrs:{"value":"2","name":"group190","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg190,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg190", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg190),expression:"eval_aedp.pg190"}],attrs:{"value":"3","name":"group190","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg190,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg190", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg191==="" ? "color:red" : "color:black")},[_vm._v("\n                                    191. Si no me apasionara mi trabajo cambiaría de oficio\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg191),expression:"eval_aedp.pg191"}],attrs:{"value":"3","name":"group191","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg191,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg191", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg191),expression:"eval_aedp.pg191"}],attrs:{"value":"2","name":"group191","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg191,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg191", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg191),expression:"eval_aedp.pg191"}],attrs:{"value":"1","name":"group191","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg191,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg191", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg191),expression:"eval_aedp.pg191"}],attrs:{"value":"0","name":"group191","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg191,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg191", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg192==="" ? "color:red" : "color:black")},[_vm._v("\n                                    192. Mi oficio es una extensión de mi sistema personal de valores\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg192),expression:"eval_aedp.pg192"}],attrs:{"value":"3","name":"group192","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg192,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg192", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg192),expression:"eval_aedp.pg192"}],attrs:{"value":"2","name":"group192","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg192,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg192", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg192),expression:"eval_aedp.pg192"}],attrs:{"value":"1","name":"group192","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg192,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg192", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg192),expression:"eval_aedp.pg192"}],attrs:{"value":"0","name":"group192","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg192,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg192", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg193==="" ? "color:red" : "color:black")},[_vm._v("\n                                    193. Jamás digo una mentira\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg193),expression:"eval_aedp.pg193"}],attrs:{"value":"3","name":"group193","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg193,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg193", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg193),expression:"eval_aedp.pg193"}],attrs:{"value":"2","name":"group193","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg193,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg193", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg193),expression:"eval_aedp.pg193"}],attrs:{"value":"1","name":"group193","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg193,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg193", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg193),expression:"eval_aedp.pg193"}],attrs:{"value":"0","name":"group193","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg193,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg193", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg194==="" ? "color:red" : "color:black")},[_vm._v("\n                                    194. Encuentro que me dejo llevar por una situación aún cuando no esté de acuerdo con ella \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg194),expression:"eval_aedp.pg194"}],attrs:{"value":"0","name":"group194","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg194,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg194", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg194),expression:"eval_aedp.pg194"}],attrs:{"value":"1","name":"group194","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg194,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg194", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg194),expression:"eval_aedp.pg194"}],attrs:{"value":"2","name":"group194","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg194,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg194", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg194),expression:"eval_aedp.pg194"}],attrs:{"value":"3","name":"group194","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg194,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg194", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg195==="" ? "color:red" : "color:black")},[_vm._v("\n                                    195. Exagero mis habilidades para poder avanzar\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg195),expression:"eval_aedp.pg195"}],attrs:{"value":"0","name":"group195","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg195,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg195", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg195),expression:"eval_aedp.pg195"}],attrs:{"value":"1","name":"group195","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg195,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg195", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg195),expression:"eval_aedp.pg195"}],attrs:{"value":"2","name":"group195","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg195,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg195", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg195),expression:"eval_aedp.pg195"}],attrs:{"value":"3","name":"group195","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg195,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg195", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg196==="" ? "color:red" : "color:black")},[_vm._v("\n                                    196. Digo la verdad aún cuando sea difícil                                   ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg196),expression:"eval_aedp.pg196"}],attrs:{"value":"3","name":"group196","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg196,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg196", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg196),expression:"eval_aedp.pg196"}],attrs:{"value":"2","name":"group196","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg196,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg196", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg196),expression:"eval_aedp.pg196"}],attrs:{"value":"1","name":"group196","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg196,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg196", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg196),expression:"eval_aedp.pg196"}],attrs:{"value":"0","name":"group196","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg196,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg196", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{ref:"area17",staticClass:"input-field col s12 l4",attrs:{"id":"area17"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg197==="" ? "color:red" : "color:black")},[_vm._v("\n                                    197. He hecho en mi oficio cosas contrarias a mis principios\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg197),expression:"eval_aedp.pg197"}],attrs:{"value":"0","name":"group197","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg197,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg197", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg197),expression:"eval_aedp.pg197"}],attrs:{"value":"1","name":"group197","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg197,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg197", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg197),expression:"eval_aedp.pg197"}],attrs:{"value":"2","name":"group197","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg197,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg197", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg197),expression:"eval_aedp.pg197"}],attrs:{"value":"3","name":"group197","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg197,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg197", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG2(6)}}},[_vm._m(57)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG2(8)}}},[_vm._m(58)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt18),expression:"vertt18"}],ref:"testt18",attrs:{"id":"testt18"}},[_vm._m(59),_vm._v(" "),_vm._m(60),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg198==="" ? "color:red" : "color:black")},[_vm._v("\n                                    198. Dolor de espalda\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg198),expression:"eval_aedp.pg198"}],attrs:{"value":"0","name":"group198","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg198,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg198", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg198),expression:"eval_aedp.pg198"}],attrs:{"value":"1","name":"group198","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg198,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg198", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg198),expression:"eval_aedp.pg198"}],attrs:{"value":"2","name":"group198","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg198,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg198", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg198),expression:"eval_aedp.pg198"}],attrs:{"value":"3","name":"group198","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg198,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg198", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg199==="" ? "color:red" : "color:black")},[_vm._v("\n                                    199. Problemas de peso (pérdida o exceso de peso)\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg199),expression:"eval_aedp.pg199"}],attrs:{"value":"0","name":"group199","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg199,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg199", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg199),expression:"eval_aedp.pg199"}],attrs:{"value":"1","name":"group199","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg199,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg199", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg199),expression:"eval_aedp.pg199"}],attrs:{"value":"2","name":"group199","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg199,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg199", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg199),expression:"eval_aedp.pg199"}],attrs:{"value":"3","name":"group199","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg199,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg199", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg200==="" ? "color:red" : "color:black")},[_vm._v("\n                                    200. Dolores de cabeza\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg200),expression:"eval_aedp.pg200"}],attrs:{"value":"0","name":"group200","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg200,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg200", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg200),expression:"eval_aedp.pg200"}],attrs:{"value":"1","name":"group200","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg200,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg200", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg200),expression:"eval_aedp.pg200"}],attrs:{"value":"2","name":"group200","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg200,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg200", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg200),expression:"eval_aedp.pg200"}],attrs:{"value":"3","name":"group200","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg200,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg200", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg201==="" ? "color:red" : "color:black")},[_vm._v("\n                                    201. Jaquecas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg201),expression:"eval_aedp.pg201"}],attrs:{"value":"0","name":"group201","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg201,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg201", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg201),expression:"eval_aedp.pg201"}],attrs:{"value":"1","name":"group201","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg201,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg201", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg201),expression:"eval_aedp.pg201"}],attrs:{"value":"2","name":"group201","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg201,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg201", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg201),expression:"eval_aedp.pg201"}],attrs:{"value":"3","name":"group201","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg201,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg201", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg202==="" ? "color:red" : "color:black")},[_vm._v("\n                                    202. Catarros o problemas o problemas respiratorios\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg202),expression:"eval_aedp.pg202"}],attrs:{"value":"3","name":"group202","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg202,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg202", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg202),expression:"eval_aedp.pg202"}],attrs:{"value":"2","name":"group202","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg202,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg202", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg202),expression:"eval_aedp.pg202"}],attrs:{"value":"1","name":"group202","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg202,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg202", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg202),expression:"eval_aedp.pg202"}],attrs:{"value":"0","name":"group202","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg202,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg202", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg203==="" ? "color:red" : "color:black")},[_vm._v("\n                                    203. Problemas del estomago (gases frecuentes, síndrome de irritabilidad intestinal o úlceras)\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg203),expression:"eval_aedp.pg203"}],attrs:{"value":"0","name":"group203","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg203,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg203", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg203),expression:"eval_aedp.pg203"}],attrs:{"value":"1","name":"group203","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg203,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg203", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg203),expression:"eval_aedp.pg203"}],attrs:{"value":"2","name":"group203","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg203,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg203", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg203),expression:"eval_aedp.pg203"}],attrs:{"value":"3","name":"group203","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg203,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg203", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg204==="" ? "color:red" : "color:black")},[_vm._v("\n                                    204. Dolor del pecho \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg204),expression:"eval_aedp.pg204"}],attrs:{"value":"0","name":"group204","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg204,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg204", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg204),expression:"eval_aedp.pg204"}],attrs:{"value":"1","name":"group204","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg204,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg204", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg204),expression:"eval_aedp.pg204"}],attrs:{"value":"2","name":"group204","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg204,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg204", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg204),expression:"eval_aedp.pg204"}],attrs:{"value":"3","name":"group204","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg204,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg204", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg205==="" ? "color:red" : "color:black")},[_vm._v("\n                                    205. Dolores inexplicables\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg205),expression:"eval_aedp.pg205"}],attrs:{"value":"0","name":"group205","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg205,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg205", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg205),expression:"eval_aedp.pg205"}],attrs:{"value":"1","name":"group205","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg205,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg205", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg205),expression:"eval_aedp.pg205"}],attrs:{"value":"2","name":"group205","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg205,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg205", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg205),expression:"eval_aedp.pg205"}],attrs:{"value":"3","name":"group205","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg205,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg205", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg206==="" ? "color:red" : "color:black")},[_vm._v("\n                                    206. Otros dolores crónicos                                   \n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg206),expression:"eval_aedp.pg206"}],attrs:{"value":"3","name":"group206","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg206,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg206", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg206),expression:"eval_aedp.pg206"}],attrs:{"value":"2","name":"group206","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg206,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg206", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg206),expression:"eval_aedp.pg206"}],attrs:{"value":"1","name":"group206","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg206,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg206", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg206),expression:"eval_aedp.pg206"}],attrs:{"value":"0","name":"group206","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg206,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg206", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_vm._m(61),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg207==="" ? "color:red" : "color:black")},[_vm._v("\n                                    207. Alimentación (pérdida del apetito, como con exceso, no tengo tiempo de comer)\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg207),expression:"eval_aedp.pg207"}],attrs:{"value":"0","name":"group207","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg207,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg207", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg207),expression:"eval_aedp.pg207"}],attrs:{"value":"1","name":"group207","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg207,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg207", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg207),expression:"eval_aedp.pg207"}],attrs:{"value":"2","name":"group207","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg207,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg207", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg207),expression:"eval_aedp.pg207"}],attrs:{"value":"3","name":"group207","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg207,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg207", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg208==="" ? "color:red" : "color:black")},[_vm._v("\n                                    208. Fumo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg208),expression:"eval_aedp.pg208"}],attrs:{"value":"0","name":"group208","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg208,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg208", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg208),expression:"eval_aedp.pg208"}],attrs:{"value":"1","name":"group208","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg208,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg208", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg208),expression:"eval_aedp.pg208"}],attrs:{"value":"2","name":"group208","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg208,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg208", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg208),expression:"eval_aedp.pg208"}],attrs:{"value":"3","name":"group208","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg208,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg208", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg209==="" ? "color:red" : "color:black")},[_vm._v("\n                                    209. Tomo bebidas alcohólicas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg209),expression:"eval_aedp.pg209"}],attrs:{"value":"0","name":"group209","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg209,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg209", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg209),expression:"eval_aedp.pg209"}],attrs:{"value":"1","name":"group209","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg209,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg209", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg209),expression:"eval_aedp.pg209"}],attrs:{"value":"2","name":"group209","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg209,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg209", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg209),expression:"eval_aedp.pg209"}],attrs:{"value":"3","name":"group209","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg209,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg209", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg210==="" ? "color:red" : "color:black")},[_vm._v("\n                                    210. Tomo calmantes\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg210),expression:"eval_aedp.pg210"}],attrs:{"value":"0","name":"group210","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg210,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg210", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg210),expression:"eval_aedp.pg210"}],attrs:{"value":"1","name":"group210","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg210,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg210", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg210),expression:"eval_aedp.pg210"}],attrs:{"value":"2","name":"group210","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg210,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg210", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg210),expression:"eval_aedp.pg210"}],attrs:{"value":"3","name":"group210","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg210,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg210", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg211==="" ? "color:red" : "color:black")},[_vm._v("\n                                    211. Tomo aspirinas u otros analgésicos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg211),expression:"eval_aedp.pg211"}],attrs:{"value":"3","name":"group211","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg211,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg211", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg211),expression:"eval_aedp.pg211"}],attrs:{"value":"2","name":"group211","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg211,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg211", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg211),expression:"eval_aedp.pg211"}],attrs:{"value":"1","name":"group211","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg211,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg211", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg211),expression:"eval_aedp.pg211"}],attrs:{"value":"0","name":"group211","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg211,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg211", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg212==="" ? "color:red" : "color:black")},[_vm._v("\n                                    212. Tomo otras drogas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg212),expression:"eval_aedp.pg212"}],attrs:{"value":"0","name":"group212","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg212,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg212", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg212),expression:"eval_aedp.pg212"}],attrs:{"value":"1","name":"group212","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg212,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg212", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg212),expression:"eval_aedp.pg212"}],attrs:{"value":"2","name":"group212","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg212,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg212", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg212),expression:"eval_aedp.pg212"}],attrs:{"value":"3","name":"group212","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg212,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg212", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg213==="" ? "color:red" : "color:black")},[_vm._v("\n                                    213. Huyo de las relaciones estrechas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg213),expression:"eval_aedp.pg213"}],attrs:{"value":"0","name":"group213","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg213,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg213", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg213),expression:"eval_aedp.pg213"}],attrs:{"value":"1","name":"group213","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg213,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg213", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg213),expression:"eval_aedp.pg213"}],attrs:{"value":"2","name":"group213","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg213,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg213", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg213),expression:"eval_aedp.pg213"}],attrs:{"value":"3","name":"group213","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg213,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg213", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg214==="" ? "color:red" : "color:black")},[_vm._v("\n                                    214. Critico, culpo o ridiculizo a los demás\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg214),expression:"eval_aedp.pg214"}],attrs:{"value":"0","name":"group214","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg214,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg214", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg214),expression:"eval_aedp.pg214"}],attrs:{"value":"1","name":"group214","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg214,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg214", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg214),expression:"eval_aedp.pg214"}],attrs:{"value":"2","name":"group214","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg214,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg214", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg214),expression:"eval_aedp.pg214"}],attrs:{"value":"3","name":"group214","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg214,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg214", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg215==="" ? "color:red" : "color:black")},[_vm._v("\n                                    215. Me siento víctima, o que se aprovechen de mi               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg215),expression:"eval_aedp.pg215"}],attrs:{"value":"3","name":"group215","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg215,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg215", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg215),expression:"eval_aedp.pg215"}],attrs:{"value":"2","name":"group215","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg215,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg215", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg215),expression:"eval_aedp.pg215"}],attrs:{"value":"1","name":"group215","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg215,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg215", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg215),expression:"eval_aedp.pg215"}],attrs:{"value":"0","name":"group215","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg215,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg215", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg216==="" ? "color:red" : "color:black")},[_vm._v("\n                                    216. Veo TV (más de dos horas al día)\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg216),expression:"eval_aedp.pg216"}],attrs:{"value":"0","name":"group216","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg216,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg216", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg216),expression:"eval_aedp.pg216"}],attrs:{"value":"1","name":"group216","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg216,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg216", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg216),expression:"eval_aedp.pg216"}],attrs:{"value":"2","name":"group216","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg216,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg216", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg216),expression:"eval_aedp.pg216"}],attrs:{"value":"3","name":"group216","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg216,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg216", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg217==="" ? "color:red" : "color:black")},[_vm._v("\n                                    217. Practico juegos de video o de computador, o uso la internet (más de dos horas al día)\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg217),expression:"eval_aedp.pg217"}],attrs:{"value":"0","name":"group217","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg217,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg217", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg217),expression:"eval_aedp.pg217"}],attrs:{"value":"1","name":"group217","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg217,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg217", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg217),expression:"eval_aedp.pg217"}],attrs:{"value":"2","name":"group217","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg217,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg217", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg217),expression:"eval_aedp.pg217"}],attrs:{"value":"3","name":"group217","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg217,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg217", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg218==="" ? "color:red" : "color:black")},[_vm._v("\n                                    218. Me fastidian las personas con quienes me encuentro           ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg218),expression:"eval_aedp.pg218"}],attrs:{"value":"3","name":"group218","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg218,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg218", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg218),expression:"eval_aedp.pg218"}],attrs:{"value":"2","name":"group218","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg218,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg218", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg218),expression:"eval_aedp.pg218"}],attrs:{"value":"1","name":"group218","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg218,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg218", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg218),expression:"eval_aedp.pg218"}],attrs:{"value":"0","name":"group218","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg218,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg218", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg219==="" ? "color:red" : "color:black")},[_vm._v("\n                                    219. Accidentes o heridas\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg219),expression:"eval_aedp.pg219"}],attrs:{"value":"0","name":"group219","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg219,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg219", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg219),expression:"eval_aedp.pg219"}],attrs:{"value":"1","name":"group219","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg219,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg219", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg219),expression:"eval_aedp.pg219"}],attrs:{"value":"2","name":"group219","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg219,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg219", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg219),expression:"eval_aedp.pg219"}],attrs:{"value":"3","name":"group219","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg219,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg219", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_vm._m(62),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg220==="" ? "color:red" : "color:black")},[_vm._v("\n                                    220. Me cuesta trabajo concentrarme\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg220),expression:"eval_aedp.pg220"}],attrs:{"value":"0","name":"group220","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg220,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg220", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg220),expression:"eval_aedp.pg220"}],attrs:{"value":"1","name":"group220","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg220,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg220", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg220),expression:"eval_aedp.pg220"}],attrs:{"value":"2","name":"group220","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg220,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg220", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg220),expression:"eval_aedp.pg220"}],attrs:{"value":"3","name":"group220","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg220,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg220", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg221==="" ? "color:red" : "color:black")},[_vm._v("\n                                    221. Me abruma el trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg221),expression:"eval_aedp.pg221"}],attrs:{"value":"0","name":"group221","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg221,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg221", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg221),expression:"eval_aedp.pg221"}],attrs:{"value":"1","name":"group221","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg221,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg221", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg221),expression:"eval_aedp.pg221"}],attrs:{"value":"2","name":"group221","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg221,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg221", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg221),expression:"eval_aedp.pg221"}],attrs:{"value":"3","name":"group221","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg221,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg221", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg222==="" ? "color:red" : "color:black")},[_vm._v("\n                                    222. Me distraigo facilmente\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg222),expression:"eval_aedp.pg222"}],attrs:{"value":"0","name":"group222","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg222,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg222", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg222),expression:"eval_aedp.pg222"}],attrs:{"value":"1","name":"group222","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg222,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg222", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg222),expression:"eval_aedp.pg222"}],attrs:{"value":"2","name":"group222","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg222,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg222", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg222),expression:"eval_aedp.pg222"}],attrs:{"value":"3","name":"group222","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg222,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg222", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg223==="" ? "color:red" : "color:black")},[_vm._v("\n                                    223. No puedo quitarme una cosa de la cabeza y estoy siempre preocupado\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg223),expression:"eval_aedp.pg223"}],attrs:{"value":"0","name":"group223","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg223,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg223", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg223),expression:"eval_aedp.pg223"}],attrs:{"value":"1","name":"group223","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg223,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg223", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg223),expression:"eval_aedp.pg223"}],attrs:{"value":"2","name":"group223","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg223,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg223", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg223),expression:"eval_aedp.pg223"}],attrs:{"value":"3","name":"group223","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg223,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg223", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg224==="" ? "color:red" : "color:black")},[_vm._v("\n                                    224. Me siento deprimido, desalentado o sin esperanza\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg224),expression:"eval_aedp.pg224"}],attrs:{"value":"0","name":"group224","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg224,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg224", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg224),expression:"eval_aedp.pg224"}],attrs:{"value":"1","name":"group224","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg224,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg224", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg224),expression:"eval_aedp.pg224"}],attrs:{"value":"2","name":"group224","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg224,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg224", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg224),expression:"eval_aedp.pg224"}],attrs:{"value":"3","name":"group224","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg224,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg224", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg225==="" ? "color:red" : "color:black")},[_vm._v("\n                                    225. Me siento solo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg225),expression:"eval_aedp.pg225"}],attrs:{"value":"0","name":"group225","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg225,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg225", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg225),expression:"eval_aedp.pg225"}],attrs:{"value":"1","name":"group225","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg225,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg225", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg225),expression:"eval_aedp.pg225"}],attrs:{"value":"2","name":"group225","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg225,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg225", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg225),expression:"eval_aedp.pg225"}],attrs:{"value":"3","name":"group225","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg225,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg225", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg226==="" ? "color:red" : "color:black")},[_vm._v("\n                                    226. Pierdo la memoria\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg226),expression:"eval_aedp.pg226"}],attrs:{"value":"0","name":"group226","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg226,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg226", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg226),expression:"eval_aedp.pg226"}],attrs:{"value":"1","name":"group226","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg226,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg226", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg226),expression:"eval_aedp.pg226"}],attrs:{"value":"2","name":"group226","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg226,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg226", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg226),expression:"eval_aedp.pg226"}],attrs:{"value":"3","name":"group226","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg226,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg226", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg227==="" ? "color:red" : "color:black")},[_vm._v("\n                                    227. Me siento fatigado o abrumado\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg227),expression:"eval_aedp.pg227"}],attrs:{"value":"0","name":"group227","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg227,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg227", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg227),expression:"eval_aedp.pg227"}],attrs:{"value":"1","name":"group227","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg227,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg227", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg227),expression:"eval_aedp.pg227"}],attrs:{"value":"2","name":"group227","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg227,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg227", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg227),expression:"eval_aedp.pg227"}],attrs:{"value":"3","name":"group227","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg227,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg227", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg228==="" ? "color:red" : "color:black")},[_vm._v("\n                                    228. Me cuesta trabajo resolverme o tomar decisiones\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg228),expression:"eval_aedp.pg228"}],attrs:{"value":"0","name":"group228","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg228,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg228", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg228),expression:"eval_aedp.pg228"}],attrs:{"value":"1","name":"group228","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg228,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg228", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg228),expression:"eval_aedp.pg228"}],attrs:{"value":"2","name":"group228","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg228,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg228", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg228),expression:"eval_aedp.pg228"}],attrs:{"value":"3","name":"group228","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg228,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg228", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{ref:"area18",staticClass:"input-field col s12 l4",attrs:{"id":"area18"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg229==="" ? "color:red" : "color:black")},[_vm._v("\n                                    229. Me cuesta trabajo empezar a tranquilizarme\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg229),expression:"eval_aedp.pg229"}],attrs:{"value":"0","name":"group229","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg229,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg229", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg229),expression:"eval_aedp.pg229"}],attrs:{"value":"1","name":"group229","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg229,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg229", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg229),expression:"eval_aedp.pg229"}],attrs:{"value":"2","name":"group229","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg229,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg229", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg229),expression:"eval_aedp.pg229"}],attrs:{"value":"3","name":"group229","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg229,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg229", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG2(7)}}},[_vm._m(63)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG2(9)}}},[_vm._m(64)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt19),expression:"vertt19"}],ref:"testt19",attrs:{"id":"testt19"}},[_vm._m(65),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg230==="" ? "color:red" : "color:black")},[_vm._v("\n                                    230. Estoy muy satisfecho con mi vida\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg230),expression:"eval_aedp.pg230"}],attrs:{"value":"3","name":"group230","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg230,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg230", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg230),expression:"eval_aedp.pg230"}],attrs:{"value":"2","name":"group230","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg230,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg230", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg230),expression:"eval_aedp.pg230"}],attrs:{"value":"1","name":"group230","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg230,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg230", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg230),expression:"eval_aedp.pg230"}],attrs:{"value":"0","name":"group230","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg230,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg230", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg231==="" ? "color:red" : "color:black")},[_vm._v("\n                                    231. Me siento enérgico, feliz y lleno de salud\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg231),expression:"eval_aedp.pg231"}],attrs:{"value":"3","name":"group231","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg231,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg231", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg231),expression:"eval_aedp.pg231"}],attrs:{"value":"2","name":"group231","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg231,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg231", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg231),expression:"eval_aedp.pg231"}],attrs:{"value":"1","name":"group231","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg231,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg231", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg231),expression:"eval_aedp.pg231"}],attrs:{"value":"0","name":"group231","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg231,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg231", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg232==="" ? "color:red" : "color:black")},[_vm._v("\n                                    232. Tengo sentimientos de paz interior y bienestar\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg232),expression:"eval_aedp.pg232"}],attrs:{"value":"3","name":"group232","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg232,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg232", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg232),expression:"eval_aedp.pg232"}],attrs:{"value":"2","name":"group232","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg232,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg232", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg232),expression:"eval_aedp.pg232"}],attrs:{"value":"1","name":"group232","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg232,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg232", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg232),expression:"eval_aedp.pg232"}],attrs:{"value":"0","name":"group232","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg232,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg232", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg233==="" ? "color:red" : "color:black")},[_vm._v("\n                                    233. Necesitaría hacer muchos cambios en mi vida para ser realmente feliz\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg233),expression:"eval_aedp.pg233"}],attrs:{"value":"0","name":"group233","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg233,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg233", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg233),expression:"eval_aedp.pg233"}],attrs:{"value":"1","name":"group233","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg233,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg233", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg233),expression:"eval_aedp.pg233"}],attrs:{"value":"2","name":"group233","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg233,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg233", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg233),expression:"eval_aedp.pg233"}],attrs:{"value":"3","name":"group233","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg233,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg233", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg234==="" ? "color:red" : "color:black")},[_vm._v("\n                                    234. Mi vida satisface mis más hondas necesidades\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg234),expression:"eval_aedp.pg234"}],attrs:{"value":"3","name":"group234","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg234,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg234", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg234),expression:"eval_aedp.pg234"}],attrs:{"value":"2","name":"group234","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg234,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg234", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg234),expression:"eval_aedp.pg234"}],attrs:{"value":"1","name":"group234","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg234,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg234", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg234),expression:"eval_aedp.pg234"}],attrs:{"value":"0","name":"group234","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg234,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg234", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg235==="" ? "color:red" : "color:black")},[_vm._v("\n                                    235. He obtenido menos de lo que esperaba de la vida\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg235),expression:"eval_aedp.pg235"}],attrs:{"value":"0","name":"group235","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg235,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg235", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg235),expression:"eval_aedp.pg235"}],attrs:{"value":"1","name":"group235","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg235,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg235", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg235),expression:"eval_aedp.pg235"}],attrs:{"value":"2","name":"group235","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg235,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg235", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg235),expression:"eval_aedp.pg235"}],attrs:{"value":"3","name":"group235","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg235,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg235", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg236==="" ? "color:red" : "color:black")},[_vm._v("\n                                    236. Me gusta ser exáctamente como soy\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg236),expression:"eval_aedp.pg236"}],attrs:{"value":"3","name":"group236","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg236,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg236", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg236),expression:"eval_aedp.pg236"}],attrs:{"value":"2","name":"group236","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg236,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg236", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg236),expression:"eval_aedp.pg236"}],attrs:{"value":"1","name":"group236","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg236,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg236", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg236),expression:"eval_aedp.pg236"}],attrs:{"value":"0","name":"group236","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg236,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg236", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg237==="" ? "color:red" : "color:black")},[_vm._v("\n                                    237. Para mi el trabajo es una diversión\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg237),expression:"eval_aedp.pg237"}],attrs:{"value":"3","name":"group237","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg237,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg237", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg237),expression:"eval_aedp.pg237"}],attrs:{"value":"2","name":"group237","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg237,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg237", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg237),expression:"eval_aedp.pg237"}],attrs:{"value":"1","name":"group237","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg237,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg237", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg237),expression:"eval_aedp.pg237"}],attrs:{"value":"0","name":"group237","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg237,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg237", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg238==="" ? "color:red" : "color:black")},[_vm._v("\n                                    238. He encontrado trabajo significativo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg238),expression:"eval_aedp.pg238"}],attrs:{"value":"3","name":"group238","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg238,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg238", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg238),expression:"eval_aedp.pg238"}],attrs:{"value":"2","name":"group238","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg238,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg238", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg238),expression:"eval_aedp.pg238"}],attrs:{"value":"1","name":"group238","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg238,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg238", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg238),expression:"eval_aedp.pg238"}],attrs:{"value":"0","name":"group238","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg238,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg238", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg239==="" ? "color:red" : "color:black")},[_vm._v("\n                                    239. Voy por un camino que me trae satisfacción\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg239),expression:"eval_aedp.pg239"}],attrs:{"value":"3","name":"group239","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg239,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg239", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg239),expression:"eval_aedp.pg239"}],attrs:{"value":"2","name":"group239","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg239,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg239", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg239),expression:"eval_aedp.pg239"}],attrs:{"value":"1","name":"group239","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg239,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg239", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg239),expression:"eval_aedp.pg239"}],attrs:{"value":"0","name":"group239","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg239,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg239", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg240==="" ? "color:red" : "color:black")},[_vm._v("\n                                    240. He aprovechado al máximo mis capacidades\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg240),expression:"eval_aedp.pg240"}],attrs:{"value":"3","name":"group240","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg240,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg240", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg240),expression:"eval_aedp.pg240"}],attrs:{"value":"2","name":"group240","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg240,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg240", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg240),expression:"eval_aedp.pg240"}],attrs:{"value":"1","name":"group240","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg240,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg240", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg240),expression:"eval_aedp.pg240"}],attrs:{"value":"0","name":"group240","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg240,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg240", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG2(8)}}},[_vm._m(66)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG2(10)}}},[_vm._m(67)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt20),expression:"vertt20"}],ref:"testt20",attrs:{"id":"testt20"}},[_vm._m(68),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg241==="" ? "color:red" : "color:black")},[_vm._v("\n                                    241. Hay personas con quienes 'me conecto' a un nivel más hondo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg241),expression:"eval_aedp.pg241"}],attrs:{"value":"3","name":"group241","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg241,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg241", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg241),expression:"eval_aedp.pg241"}],attrs:{"value":"2","name":"group241","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg241,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg241", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg241),expression:"eval_aedp.pg241"}],attrs:{"value":"1","name":"group241","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg241,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg241", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg241),expression:"eval_aedp.pg241"}],attrs:{"value":"0","name":"group241","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg241,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg241", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg242==="" ? "color:red" : "color:black")},[_vm._v("\n                                    242. Soy franco con las personas cercanas a mí y ellas son francas conmigo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg242),expression:"eval_aedp.pg242"}],attrs:{"value":"3","name":"group242","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg242,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg242", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg242),expression:"eval_aedp.pg242"}],attrs:{"value":"2","name":"group242","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg242,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg242", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg242),expression:"eval_aedp.pg242"}],attrs:{"value":"1","name":"group242","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg242,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg242", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg242),expression:"eval_aedp.pg242"}],attrs:{"value":"0","name":"group242","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg242,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg242", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg243==="" ? "color:red" : "color:black")},[_vm._v("\n                                    243. He amado profundamente a otra persona\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg243),expression:"eval_aedp.pg243"}],attrs:{"value":"3","name":"group243","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg243,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg243", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg243),expression:"eval_aedp.pg243"}],attrs:{"value":"2","name":"group243","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg243,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg243", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg243),expression:"eval_aedp.pg243"}],attrs:{"value":"1","name":"group243","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg243,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg243", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg243),expression:"eval_aedp.pg243"}],attrs:{"value":"0","name":"group243","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg243,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg243", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg244 === "" ? "color:red" : "color:black")},[_vm._v("\n                                    244. Generalmente encuentro personas con quienes hacer vida social\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg244),expression:"eval_aedp.pg244"}],attrs:{"value":"3","name":"group244","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg244,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg244", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg244),expression:"eval_aedp.pg244"}],attrs:{"value":"2","name":"group244","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg244,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg244", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg244),expression:"eval_aedp.pg244"}],attrs:{"value":"1","name":"group244","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg244,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg244", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg244),expression:"eval_aedp.pg244"}],attrs:{"value":"0","name":"group244","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg244,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg244", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg245==="" ? "color:red" : "color:black")},[_vm._v("\n                                    245. Soy capaz de hacer compromisos a largo plazo con otra persona\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg245),expression:"eval_aedp.pg245"}],attrs:{"value":"3","name":"group245","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg245,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg245", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg245),expression:"eval_aedp.pg245"}],attrs:{"value":"2","name":"group245","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg245,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg245", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg245),expression:"eval_aedp.pg245"}],attrs:{"value":"1","name":"group245","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg245,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg245", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg245),expression:"eval_aedp.pg245"}],attrs:{"value":"0","name":"group245","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg245,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg245", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg246==="" ? "color:red" : "color:black")},[_vm._v("\n                                    246. Sé que soy importante para los que están cerca de mí.\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg246),expression:"eval_aedp.pg246"}],attrs:{"value":"3","name":"group246","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg246,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg246", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg246),expression:"eval_aedp.pg246"}],attrs:{"value":"2","name":"group246","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg246,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg246", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg246),expression:"eval_aedp.pg246"}],attrs:{"value":"1","name":"group246","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg246,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg246", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg246),expression:"eval_aedp.pg246"}],attrs:{"value":"0","name":"group246","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg246,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg246", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{ref:"area20",staticClass:"input-field col s12 l4",attrs:{"id":"area20"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg247 ==="" ? "color:red" : "color:black")},[_vm._v("\n                                    247. Encuentro fácil decirle a los demás que los quiero\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg247),expression:"eval_aedp.pg247"}],attrs:{"value":"3","name":"group247","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg247,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg247", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg247),expression:"eval_aedp.pg247"}],attrs:{"value":"2","name":"group247","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg247,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg247", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg247),expression:"eval_aedp.pg247"}],attrs:{"value":"1","name":"group247","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg247,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg247", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg247),expression:"eval_aedp.pg247"}],attrs:{"value":"0","name":"group247","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg247,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg247", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG2(9)}}},[_vm._m(69)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG2(11)}}},[_vm._m(70)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt21),expression:"vertt21"}],ref:"testt21",attrs:{"id":"testt21"}},[_vm._m(71),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg248==="" ? "color:red" : "color:black")},[_vm._v("\n                                    248. Estoy satisfecho con mi desempeño en el trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg248),expression:"eval_aedp.pg248"}],attrs:{"value":"3","name":"group248","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg248,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg248", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg248),expression:"eval_aedp.pg248"}],attrs:{"value":"2","name":"group248","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg248,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg248", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg248),expression:"eval_aedp.pg248"}],attrs:{"value":"1","name":"group248","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg248,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg248", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg248),expression:"eval_aedp.pg248"}],attrs:{"value":"0","name":"group248","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg248,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg248", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg249==="" ? "color:red" : "color:black")},[_vm._v("\n                                    249. Mis compañeros de trabajo dirían que yo facilito buenas comunicaciones entre los miembros de mi grupo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg249),expression:"eval_aedp.pg249"}],attrs:{"value":"3","name":"group249","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg249,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg249", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg249),expression:"eval_aedp.pg249"}],attrs:{"value":"2","name":"group249","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg249,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg249", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg249),expression:"eval_aedp.pg249"}],attrs:{"value":"1","name":"group249","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg249,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg249", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg249),expression:"eval_aedp.pg249"}],attrs:{"value":"0","name":"group249","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg249,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg249", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg250==="" ? "color:red" : "color:black")},[_vm._v("\n                                    250. Me siento distante en el trabajo y no participante\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg250),expression:"eval_aedp.pg250"}],attrs:{"value":"0","name":"group250","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg250,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg250", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg250),expression:"eval_aedp.pg250"}],attrs:{"value":"1","name":"group250","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg250,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg250", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg250),expression:"eval_aedp.pg250"}],attrs:{"value":"2","name":"group250","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg250,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg250", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg250),expression:"eval_aedp.pg250"}],attrs:{"value":"3","name":"group250","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg250,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg250", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg251 === "" ? "color:red" : "color:black")},[_vm._v("\n                                    251. Me es difícil prestar atención a las tareas del trabajo\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg251),expression:"eval_aedp.pg251"}],attrs:{"value":"0","name":"group251","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg251,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg251", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg251),expression:"eval_aedp.pg251"}],attrs:{"value":"1","name":"group251","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg251,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg251", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg251),expression:"eval_aedp.pg251"}],attrs:{"value":"2","name":"group251","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg251,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg251", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg251),expression:"eval_aedp.pg251"}],attrs:{"value":"3","name":"group251","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg251,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg251", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg252==="" ? "color:red" : "color:black")},[_vm._v("\n                                    252. En mi equipo de trabajo participo en la toma de decisiones\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg252),expression:"eval_aedp.pg252"}],attrs:{"value":"3","name":"group252","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg252,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg252", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg252),expression:"eval_aedp.pg252"}],attrs:{"value":"2","name":"group252","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg252,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg252", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg252),expression:"eval_aedp.pg252"}],attrs:{"value":"1","name":"group252","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg252,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg252", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg252),expression:"eval_aedp.pg252"}],attrs:{"value":"0","name":"group252","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg252,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg252", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 l4"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg253==="" ? "color:red" : "color:black")},[_vm._v("\n                                    253. Me cuesta trabajo cumplir con los compromisos\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg253),expression:"eval_aedp.pg253"}],attrs:{"value":"0","name":"group253","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg253,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg253", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg253),expression:"eval_aedp.pg253"}],attrs:{"value":"1","name":"group253","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg253,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg253", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg253),expression:"eval_aedp.pg253"}],attrs:{"value":"2","name":"group253","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg253,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg253", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg253),expression:"eval_aedp.pg253"}],attrs:{"value":"3","name":"group253","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg253,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg253", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('div',{ref:"area10",staticClass:"input-field col s12 l4",attrs:{"id":"area10"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px"},style:(_vm.eval_aedp.pg254 ==="" ? "color:red" : "color:black")},[_vm._v("\n                                    254. Mi rendimiento en el trabajo es siempre el mejor de que soy capaz\n                               ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg254),expression:"eval_aedp.pg254"}],attrs:{"value":"3","name":"group254","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_aedp.pg254,"3")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg254", "3")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Mucha")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg254),expression:"eval_aedp.pg254"}],attrs:{"value":"2","name":"group254","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg254,"2")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg254", "2")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Moderada")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg254),expression:"eval_aedp.pg254"}],attrs:{"value":"1","name":"group254","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg254,"1")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg254", "1")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Poca")])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l12"},[_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_aedp.pg254),expression:"eval_aedp.pg254"}],attrs:{"value":"0","name":"group254","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_aedp.pg254,"0")},on:{"change":function($event){_vm.$set(_vm.eval_aedp, "pg254", "0")}}}),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nada/No ocurrió")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG2(0)}}},[_vm._m(72)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG2(10)}}},[_vm._m(73)])])]),_vm._v(" "),_c('div',{staticClass:"col s12 l4 center"},[_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.agregarEvaluacion()}}},[_vm._v("\n                                    GRABAR \n                               ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l11",staticStyle:{"font-size":"16.5px"}},[_vm._v("\n\n                                         Las emociones son la vida, el autoconocimiento en este campo es indispensable para el desarrollo y crecimiento personal.\n                                         "),_c('br'),_c('br'),_vm._v("                                             \n                                         Para este autoconocimiento, encontrará una serie de afirmaciones con cuatro (4) posibles respuestas para cada afirmación, todo esto relacionado a lo que usted siente o piensa acerca de las diferentes situaciones planteadas.\n                                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l1"},[_c('img',{attrs:{"src":"/topevaluaciones/src/assets/imagenes/emociones.png","width":"90","height":"120"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12",staticStyle:{"font-size":"16.5px"}},[_vm._v("\n        \n                                         Usted podrá observar que cada enunciado está marcado con las siguientes casillas: Mucha; Moderada; Poca; o, Nada/No ocurrió. Seleccione con el mouse la respuesta que mejor refleje su sentir.\n                                         "),_c('br'),_c('br'),_vm._v("                                             \n                                         Las afirmaciones están organizadas en veintiún (21) áreas. Cada área está representada por un número y contiene sus afirmaciones respectivas. Asegúrese de responderlas todas.\n                                         "),_c('br'),_vm._v("\n                                         Por ejemplo:\n                                         "),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"/topevaluaciones/src/assets/imagenes/ejemplo.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Procedimiento:")]),_vm._v(" "),_c('br'),_vm._v("\n                                         Inicialmente todas las afirmaciones le aparecerán en color "),_c('span',{staticStyle:{"font-weight":"bold","color":"red"}},[_vm._v("rojo")]),_vm._v(", como indicador que aún no han sido respondidas. Conforme vaya respondiendo, las preguntas se mostrarán en color negro. También tendrá un mensaje indicándole la cantidad de afirmaciones que aún no han sido respondidas.\n                                         "),_c('br'),_c('br'),_vm._v("\n                                         Recuerde no hay respuestas ni buenas ni malas. Dispone de tiempo suficiente para responder ¡Adelante, comience!\n                                         "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                                                        GRUPO NUMERO 1\n                                                        "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                                                        GRUPO NUMERO 3\n                                                        "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("first_page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN I. ÁREA 1.\n                               "),_c('br'),_vm._v("\n                               PIENSE EN EL AÑO PASADO. EN LA LISTA SIGUIENTE INDIQUE CUANTA AFLICCIÓN\n                               LE CAUSÓ CADA UNO DE LOS SUCESOS DE TRABAJO Y PERSONALES QUE SE ANOTAN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN I. ÁREA 2. \n                               "),_c('br'),_vm._v("                              \n                               PIENSE EN EL MES PASADO.\n                               EN LA LISTA SIGUIENTE INDIQUE CUÁNTA AFLICCIÓN\n                               LE PRODUJO CADA UNA DE LAS PRESIONES DE TRABAJO \n                               QUE SE ANOTAN.\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN I. ÁREA 3 \n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CUANTA AFLICCIÓN LE PRODUJO\n                               CADA UNA DE LAS PRESIONES PERSONALES QUE SE ANOTAN.\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN II. ÁREA 4.\n                               "),_c('br'),_vm._v("\n                               EN LA LISTA INDIQUE COMO DESCRIBE CADA RENGLÓN LA MANERA \n                               COMO USTED PIENSA Y SIENTE SOBRE USTED\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN II. ÁREA 5. \n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE COMO DESCRIBE CADA RENGLÓN LA MANERA \n                               COMO USTED PIENSA Y SIENTE SOBRE USTED MISMO ACTUALMENTE. \n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN II. ÁREA 6. \n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE COMO DESCRIBE CADA RENGLÓN LA MANERA \n                               COMO USTED PIENSA Y SIENTE SOBRE USTED MISMO ACTUALMENTE\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN III. ÁREA 7.\n                               "),_c('br'),_vm._v("\n                               PIENSE EN EL AÑO PASADO. EN LA LISTA SIGUIENTE INDIQUE COMO DESCRIBE\n                               CADA RENGLÓN SU CONDUCTA O INTENCIÓN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN III. ÁREA 8.\n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN SU CONDUCTA O INTENCIÓN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN III. ÁREA 9.\n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN SU CONDUCTA O INTENCIÓN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN III. ÁREA 10.\n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN SU CONDUCTA O INTENCIÓN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("first_page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN III. ÁREA 11.\n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN SU CONDUCTA O INTENCIÓN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN IV. ÁREA 12.\n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN SU CONDUCTA O INTENCIÓN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN IV. ÁREA 13.\n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN SU CONDUCTA O INTENCIÓN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN IV. ÁREA 14.\n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN SU CONDUCTA O INTENCIÓN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN IV. ÁREA 15.\n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN SU CONDUCTA O INTENCIÓN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN IV. ÁREA 16.\n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN SU CONDUCTA O INTENCIÓN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN IV. ÁREA 17.\n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN SU CONDUCTA O INTENCIÓN\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN V. ÁREA 18.\n                               "),_c('br'),_vm._v("\n                               INDIQUE CON QUÉ FRECUENCIA HA EXPERIMENTADO LOS SÍNTOMAS SIGUIENTES\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12 center"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_c('u',[_vm._v("SINTOMAS FÍSICOS")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12 center"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_c('u',[_vm._v("SINTOMAS DE CONDUCTA")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12 center"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_c('u',[_vm._v("SINTOMAS EMOCIONALES")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN V. ÁREA 19.\n                               "),_c('br'),_vm._v("\n                               INDIQUE CON QUÉ FRECUENCIA HA EXPERIMENTADO LOS SÍNTOMAS SIGUIENTES\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN V. ÁREA 20. \n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN LA MANERA\n                               COMO USTED PIENSA Y SIENTE SOBRE USTED MISMO ACTUALMENTE.\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 l12"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"16px","font-style":"italic"}},[_vm._v("\n                               SECCIÓN V. ÁREA 21. \n                               "),_c('br'),_vm._v("\n                               EN LA LISTA SIGUIENTE INDIQUE CÓMO DESCRIBE CADA RENGLÓN LA MANERA\n                               COMO USTED PIENSA Y SIENTE SOBRE USTED MISMO ACTUALMENTE.\n                               "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("first_page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev11_auxi_js__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fb85fb8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev11_auxi_vue__ = __webpack_require__(343);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev11_auxi_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fb85fb8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev11_auxi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s2"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Departamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.depto),expression:"eval_auxi.depto"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_auxi.depto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "depto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.empresa),expression:"eval_auxi.empresa"}],attrs:{"type":"text","id":"empresa","name":"empresa","disabled":""},domProps:{"value":(_vm.eval_auxi.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "empresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.nombre),expression:"eval_auxi.nombre"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_auxi.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Sexo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.sexo),expression:"eval_auxi.sexo"}],attrs:{"type":"text","id":"nombre","disabled":""},domProps:{"value":(_vm.eval_auxi.sexo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "sexo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s3"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Fecha Evaluación")]),_vm._v(" "),_c('input-date',{attrs:{"disabled":""},model:{value:(_vm.eval_fecha),callback:function ($$v) {_vm.eval_fecha=$$v},expression:"eval_fecha"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Inició")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_auxi.empezo))])]),_vm._v(" "),_c('div',{staticClass:"col s1"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Finaliza")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.eval_auxi.termino))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"25px","background":"cyan"}},[_vm._v(_vm._s(_vm.l_finalizando))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}]},[_c('ul',{staticClass:"collapsible popout"},[_c('li',[_c('div',{staticClass:"waves-effect waves-light collapsible-header blue white-text text-darken-4"},[_c('span',{staticClass:"tooltipped",staticStyle:{"font-size":"16px","font-weight":"bold"},attrs:{"data-tooltip":"Haga click aquí para LEER u OCULTAR las instrucciones.","data-position":"top"}},[_vm._v("\n                                "+_vm._s(_vm.instrucciones)+"\n                            ")])]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===false && _vm.grabado===false),expression:"inicioeval===false && grabado===false"}],staticClass:"col s12"},[_c('div',{staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn",on:{"click":function($event){_vm.empezarEvaluacion()}}},[_vm._v("Empezar Evaluación de AUXILIAR DE COMPUTO")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inicioeval===true),expression:"inicioeval===true"}],staticClass:"col s12"},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt1",class:_vm.activott1,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt1","href":"#testt4"},on:{"click":function($event){_vm.nadaG1(1)}}},[_vm._v("Software de Oficina")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt2",class:_vm.activott2,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt2","href":"#testt5"},on:{"click":function($event){_vm.nadaG1(2)}}},[_vm._v("Web")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt3",class:_vm.activott3,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt3","href":"#testt6"},on:{"click":function($event){_vm.nadaG1(3)}}},[_vm._v("Seguridad y redes")])]),_vm._v(" "),_c('li',{staticClass:"tab col s3"},[_c('a',{ref:"testtt4",class:_vm.activott4,staticStyle:{"font-weight":"bold"},attrs:{"id":"testtt4","href":"#testt7"},on:{"click":function($event){_vm.nadaG1(4)}}},[_vm._v("Bases de datos")])])]),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('span',{style:(_vm.pregSinContestar>0 ? "color:red;font-size:15px;font-weight:bold;" : "color:black;font-size:15px;font-weight:bold;")},[_vm._v("Preguntas sin responder: "+_vm._s(_vm.l_sinResponder))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt1),expression:"vertt1"}],ref:"testt1",attrs:{"id":"testt4"}},[_c('div',{staticClass:"input-field col s2"},[_c('span',{style:(_vm.eval_auxi.pg001===0 ? "color:red" : "color:black")},[_vm._v("01. ¿ Cuál es la última versión de Windows que usted conoce ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg001),expression:"eval_auxi.pg001"}],attrs:{"value":"a","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg001,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg001", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Vista")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg001),expression:"eval_auxi.pg001"}],attrs:{"value":"b","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg001,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg001", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) 7")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg001),expression:"eval_auxi.pg001"}],attrs:{"value":"c","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg001,"c")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg001", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) 10")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('span',{style:(_vm.eval_auxi.pg002===0 ? "color:red" : "color:black")},[_vm._v("02. ¿ Conoce algún otro sistema aparte de Windows ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg002),expression:"eval_auxi.pg002"}],attrs:{"value":"si","name":"group2","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg002,"si")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg002", "si")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg002),expression:"eval_auxi.pg002"}],attrs:{"value":"no","name":"group2","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg002,"no")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg002", "no")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("02a. ESPECIFIQUE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg02a),expression:"eval_auxi.pg02a"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg02a)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg02a", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg003===0 ? "color:red" : "color:black")},[_vm._v("03. ¿ Cuál es la última versión de Microsoft Office que usted conoce ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg003),expression:"eval_auxi.pg003"}],attrs:{"value":"a","name":"group3","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg003,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg003", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) 2007")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg003),expression:"eval_auxi.pg003"}],attrs:{"value":"b","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg003,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg003", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) 2010")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg003),expression:"eval_auxi.pg003"}],attrs:{"value":"c","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg003,"c")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg003", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) 2013")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg003),expression:"eval_auxi.pg003"}],attrs:{"value":"d","name":"group3","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg003,"d")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg003", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(c) 2016")])])]),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg004===0 ? "color:red" : "color:black")},[_vm._v("04. Open-office ¿ es la nueva versión de Microsoft Office ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg004),expression:"eval_auxi.pg004"}],attrs:{"value":"a","name":"group4","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg004,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg004", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg004),expression:"eval_auxi.pg004"}],attrs:{"value":"b","name":"group4","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg004,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg004", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg005===0 ? "color:red" : "color:black")},[_vm._v("05. ¿ Puede configurar cuentas de correo en Outlook u otro manejador de correos electrónicos ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg005),expression:"eval_auxi.pg005"}],attrs:{"value":"a","name":"group5","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg005,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg005", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg005),expression:"eval_auxi.pg005"}],attrs:{"value":"b","name":"group5","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg005,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg005", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg006===0 ? "color:red" : "color:black")},[_vm._v("06. El puerto para recibir correos en un manejador de correos como Outlook Express ¿es el 995 ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg006),expression:"eval_auxi.pg006"}],attrs:{"value":"a","name":"group6","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg006,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg006", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg006),expression:"eval_auxi.pg006"}],attrs:{"value":"b","name":"group6","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg006,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg006", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg007===0 ? "color:red" : "color:black")},[_vm._v("07. ¿Ha utilizado Microsoft Exchange Office ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg007),expression:"eval_auxi.pg007"}],attrs:{"value":"a","name":"group7","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg007,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg007", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg007),expression:"eval_auxi.pg007"}],attrs:{"value":"b","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg007,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg007", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg007),expression:"eval_auxi.pg007"}],attrs:{"value":"c","name":"group7","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg007,"c")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg007", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Me siento molesto o disgustado")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(2)}}},[_vm._m(1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt2),expression:"vertt2"}],ref:"testt2",attrs:{"id":"testt5"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg008===0 ? "color:red" : "color:black")},[_vm._v("08. ¿Sabe cómo adquirir un dominio web ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg008),expression:"eval_auxi.pg008"}],attrs:{"value":"a","name":"group8","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg008,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg008", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg008),expression:"eval_auxi.pg008"}],attrs:{"value":"b","name":"group8","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg008,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg008", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg009===0 ? "color:red" : "color:black")},[_vm._v("09. ¿sabe cómo adquirir un hosting-web ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg009),expression:"eval_auxi.pg009"}],attrs:{"value":"a","name":"group9","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg009,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg009", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg009),expression:"eval_auxi.pg009"}],attrs:{"value":"b","name":"group9","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg009,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg009", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('span',{style:(_vm.eval_auxi.pg010===0 ? "color:red" : "color:black")},[_vm._v("10. ¿Para tener un hosting no es necesario tener un dominio ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg010),expression:"eval_auxi.pg010"}],attrs:{"value":"a","name":"group10","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg010,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg010", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg010),expression:"eval_auxi.pg010"}],attrs:{"value":"b","name":"group10","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg010,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg010", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('span',{style:(_vm.eval_auxi.pg011===0 ? "color:red" : "color:black")},[_vm._v("11.  FTP significa ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg011),expression:"eval_auxi.pg011"}],attrs:{"value":"a","name":"group11","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg011,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg011", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) File Transfer Protocol y sirve para transferir archivos de un computador a un sitio web.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg011),expression:"eval_auxi.pg011"}],attrs:{"value":"b","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg011,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg011", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Full TypeProgramming el cual es una técnica de programación en redes locales.")])])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg011),expression:"eval_auxi.pg011"}],attrs:{"value":"c","name":"group11","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg011,"c")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg011", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Fatal Transfer Point y es un mensaje de error cuando el servidor falla.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("12. Indique tres recomendaciones para navegar seguro en internet")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg012),expression:"eval_auxi.pg012"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg012)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg012", $event.target.value)}}}),_vm._v(" "),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("13. ¿Qué lenguajes de programación maneja bien a nivel de redes locales o computadoras personales ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg013),expression:"eval_auxi.pg013"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg013)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg013", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("14. ¿Qué lenguajes de programación maneja bien a nivel web ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg014),expression:"eval_auxi.pg014"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg014)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg014", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("15. ¿Indique cómo administra una página web ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg015),expression:"eval_auxi.pg015"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg015)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg015", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(1)}}},[_vm._m(2)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(3)}}},[_vm._m(3)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt3),expression:"vertt3"}],ref:"testt3",attrs:{"id":"testt6"}},[_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg016===0 ? "color:red" : "color:black")},[_vm._v("16. Javascript ¿es administrador de base de datos ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg016),expression:"eval_auxi.pg016"}],attrs:{"value":"a","name":"group16","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg016,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg016", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg016),expression:"eval_auxi.pg016"}],attrs:{"value":"b","name":"group16","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg016,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg016", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg017===0 ? "color:red" : "color:black")},[_vm._v("17. ¿Cuáles antivirus conoce ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg017),expression:"eval_auxi.pg017"}],attrs:{"value":"a","name":"group17","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg017,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg017", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) mcAffe")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg017),expression:"eval_auxi.pg017"}],attrs:{"value":"b","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg017,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg017", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) EsetNod 32")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg017),expression:"eval_auxi.pg017"}],attrs:{"value":"c","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg017,"c")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg017", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Kapersky")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg017),expression:"eval_auxi.pg017"}],attrs:{"value":"d","name":"group17","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg017,"d")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg017", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(c)Otro")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("17a. ESPECIFIQUE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg017a),expression:"eval_auxi.pg017a"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg017a)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg017a", $event.target.value)}}}),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg018===0 ? "color:red" : "color:black")},[_vm._v("18. ¿Ha administrado un Firewall software ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg018),expression:"eval_auxi.pg018"}],attrs:{"value":"a","name":"group18","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg018,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg018", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Armamento")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg018),expression:"eval_auxi.pg018"}],attrs:{"value":"b","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg018,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg018", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Inseguro")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg018),expression:"eval_auxi.pg018"}],attrs:{"value":"c","name":"group18","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg018,"c")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg018", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Escuelas")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("18a. ¿Cuáles ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg018a),expression:"eval_auxi.pg018a"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg018a)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg018a", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg019===0 ? "color:red" : "color:black")},[_vm._v("19. ¿Ha administrado un Firewall físico y cuáles ?")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg019),expression:"eval_auxi.pg019"}],attrs:{"value":"a","name":"group19","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg019,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg019", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg019),expression:"eval_auxi.pg019"}],attrs:{"value":"b","name":"group19","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg019,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg019", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("19a. ¿Cuáles ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg019a),expression:"eval_auxi.pg019a"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg019a)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg019a", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg020===0 ? "color:red" : "color:black")},[_vm._v("20. ¿Ha cableado una red de computadoras y probado su interconexión ?  ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg020),expression:"eval_auxi.pg020"}],attrs:{"value":"a","name":"group20","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg020,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg020", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) duermo \"como un tronco\" ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg020),expression:"eval_auxi.pg020"}],attrs:{"value":"b","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg020,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg020", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg020),expression:"eval_auxi.pg020"}],attrs:{"value":"c","name":"group20","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg020,"c")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg020", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) No")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg021===0 ? "color:red" : "color:black")},[_vm._v("21. ¿RJ45 es el puerto para enviar correos electrónicos? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg021),expression:"eval_auxi.pg021"}],attrs:{"value":"a","name":"group21","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg021,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg021", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg021),expression:"eval_auxi.pg021"}],attrs:{"value":"b","name":"group21","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg021,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg021", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])]),_c('br'),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg022===0 ? "color:red" : "color:black")},[_vm._v("22. Si el comportamiento de un computador empieza a ser lento, ¿a qué cree que se deba ?  ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg022),expression:"eval_auxi.pg022"}],attrs:{"value":"a","name":"group22","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg022,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg022", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Vius")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg022),expression:"eval_auxi.pg022"}],attrs:{"value":"b","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg022,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg022", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) Memoria")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg022),expression:"eval_auxi.pg022"}],attrs:{"value":"c","name":"group22","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg022,"c")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg022", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) Falta de limpieza en el motherboard.")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("23. ¿Qué criterio recomendaría usted para comprar una impresora de tinta ouna de láser ??")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg023),expression:"eval_auxi.pg023"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg023)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg023", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg024===0 ? "color:red" : "color:black")},[_vm._v("24. ¿Una ponchadora es la canaleta que usa para proteger el cable de red ? ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg024),expression:"eval_auxi.pg024"}],attrs:{"value":"a","name":"group24","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg024,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg024", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) Sí")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg024),expression:"eval_auxi.pg024"}],attrs:{"value":"b","name":"group24","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg024,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg024", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) No")])])]),_c('br'),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('span',{style:(_vm.eval_auxi.pg025===0 ? "color:red" : "color:black")},[_vm._v("25. Seleccione los tipos de servidores que sabe administrar ")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg025),expression:"eval_auxi.pg025"}],attrs:{"value":"a","name":"group25","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.eval_auxi.pg025,"a")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg025", "a")}}}),_vm._v(" "),_c('span',[_vm._v("(a) De correo")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg025),expression:"eval_auxi.pg025"}],attrs:{"value":"b","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg025,"b")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg025", "b")}}}),_vm._v(" "),_c('span',[_vm._v("(b) De antivirus")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg025),expression:"eval_auxi.pg025"}],attrs:{"value":"c","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg025,"c")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg025", "c")}}}),_vm._v(" "),_c('span',[_vm._v("(c) De página web")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg025),expression:"eval_auxi.pg025"}],attrs:{"value":"d","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg025,"d")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg025", "d")}}}),_vm._v(" "),_c('span',[_vm._v("(d) De Aplicaciones Administrativas ")])])]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg025),expression:"eval_auxi.pg025"}],attrs:{"value":"e","name":"group25","type":"radio"},domProps:{"checked":_vm._q(_vm.eval_auxi.pg025,"e")},on:{"change":function($event){_vm.$set(_vm.eval_auxi, "pg025", "e")}}}),_vm._v(" "),_c('span',[_vm._v("(e) De backup")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("26. Especifique cuáles PORTABLES software ha utilizado")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg026),expression:"eval_auxi.pg026"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg026)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg026", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("27. Especifique cuál es su experiencia en configuración de ROUTERS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg027),expression:"eval_auxi.pg027"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg027)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg027", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("28. Especifique cuál es su experiencia en configuración de SWITCHS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg028),expression:"eval_auxi.pg028"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg028)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg028", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(2)}}},[_vm._m(4)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(4)}}},[_vm._m(5)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vertt4),expression:"vertt4"}],ref:"testt4",attrs:{"id":"testt7"}},[_c('div',{staticClass:"input-field col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("29. Cuales bases de datos conoce ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg029),expression:"eval_auxi.pg029"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg029)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg029", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('label',{staticStyle:{"font-size":"14px"}},[_vm._v("30. ¿Hasta qué regla de normalización ha utilizado en una base de datos ?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eval_auxi.pg030),expression:"eval_auxi.pg030"}],attrs:{"type":"text"},domProps:{"value":(_vm.eval_auxi.pg030)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eval_auxi, "pg030", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueG1(0)}}},[_vm._m(6)]),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-floating waves-effect waves-light blue darken-3 z-depth-3",on:{"click":function($event){_vm.enfoqueRG1(3)}}},[_vm._m(7)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grabado===false),expression:"grabado===false"}],staticClass:"center"},[_c('button',{staticClass:"waves-effect waves-light green btn tooltipped",attrs:{"data-position":"left","data-tooltip":"Grabar"},on:{"click":function($event){_vm.agregarEvaluacion()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-body"},[_c('div',{attrs:{"align":"justify"}},[_vm._v("\n                                En este formulario se evaluará sus conocimientos y experiencia en cuanto al uso de las herramientas de software, redes, servidores, web y hardware para una empresa pequeña o mediana. Las preguntas que incluyen la palabra: “conoce” implican que usted tiene experiencia en el uso de lo que se plantea. \n                                ** Las preguntas están organizadas en cuatro secciones: Software de Oficina, Web, Seguridad y Redes y Base de Datos. **\n                                "),_c('div',{staticClass:"center"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("SELECCIONE EL SIGUIENTE BOTON PARA EMPEZAR LA EVALUACION.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Siguiente","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Inicio","data-position":"top"}},[_c('i',{staticClass:"material-icons"},[_vm._v("first_page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltipped",attrs:{"data-tooltip":"Anterior","data-position":"buttom"}},[_c('i',{staticClass:"material-icons"},[_vm._v("navigate_before")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cvs_js__ = __webpack_require__(215);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a3f1a0b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cvs_vue__ = __webpack_require__(375);
function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cvs_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a3f1a0b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cvs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(346);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(22)("33f4a3d4", content, true, {});

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "img{border-radius:50%}", ""]);

// exports


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vuePdfNoSss_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vuePdfNoSss_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(349);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(22)("15942ebd", content, true, {});

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, ".annotationLayer{left:0;top:0;right:0;bottom:0}.annotationLayer,.annotationLayer section{position:absolute}.annotationLayer .linkAnnotation>a{position:absolute;font-size:1em;top:0;left:0;width:100%;height:100%;background:url(\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\") 0 0 repeat}.annotationLayer .linkAnnotation>a:hover{opacity:.2;background:#ff0;box-shadow:0 2px 10px #ff0}.annotationLayer .textAnnotation img{position:absolute;cursor:pointer}.annotationLayer .buttonWidgetAnnotation.checkBox input,.annotationLayer .buttonWidgetAnnotation.radioButton input,.annotationLayer .choiceWidgetAnnotation select,.annotationLayer .textWidgetAnnotation input,.annotationLayer .textWidgetAnnotation textarea{background-color:rgba(0,54,255,.13);border:1px solid transparent;box-sizing:border-box;font-size:9px;height:100%;padding:0 3px;vertical-align:top;width:100%}.annotationLayer .textWidgetAnnotation textarea{font:message-box;font-size:9px;resize:none}.annotationLayer .buttonWidgetAnnotation.checkBox input[disabled],.annotationLayer .buttonWidgetAnnotation.radioButton input[disabled],.annotationLayer .choiceWidgetAnnotation select[disabled],.annotationLayer .textWidgetAnnotation input[disabled],.annotationLayer .textWidgetAnnotation textarea[disabled]{background:none;border:1px solid transparent;cursor:not-allowed}.annotationLayer .buttonWidgetAnnotation.checkBox input:hover,.annotationLayer .buttonWidgetAnnotation.radioButton input:hover,.annotationLayer .choiceWidgetAnnotation select:hover,.annotationLayer .textWidgetAnnotation input:hover,.annotationLayer .textWidgetAnnotation textarea:hover{border:1px solid #000}.annotationLayer .choiceWidgetAnnotation select:focus,.annotationLayer .textWidgetAnnotation input:focus,.annotationLayer .textWidgetAnnotation textarea:focus{background:none;border:1px solid transparent}.annotationLayer .textWidgetAnnotation input.comb{font-family:monospace;padding-left:2px;padding-right:0}.annotationLayer .textWidgetAnnotation input.comb:focus{width:115%}.annotationLayer .buttonWidgetAnnotation.checkBox input,.annotationLayer .buttonWidgetAnnotation.radioButton input{-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none}.annotationLayer .popupWrapper{position:absolute;width:20em}.annotationLayer .popup{position:absolute;z-index:200;max-width:20em;background-color:#ff9;box-shadow:0 2px 5px #333;border-radius:2px;padding:.6em;margin-left:5px;cursor:pointer;word-wrap:break-word}.annotationLayer .popup h1{font-size:1em;border-bottom:1px solid #000;padding-bottom:.2em}.annotationLayer .popup p{padding-top:.2em}.annotationLayer .fileAttachmentAnnotation,.annotationLayer .highlightAnnotation,.annotationLayer .lineAnnotation svg line,.annotationLayer .squigglyAnnotation,.annotationLayer .strikeoutAnnotation,.annotationLayer .underlineAnnotation{cursor:pointer}", ""]);

// exports


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_resize_sensor__ = __webpack_require__(351);


/* harmony default export */ __webpack_exports__["a"] = (function(pdfjsWrapper) {

	var createLoadingTask = pdfjsWrapper.createLoadingTask;
	var PDFJSWrapper = pdfjsWrapper.PDFJSWrapper;

	return {
		createLoadingTask: createLoadingTask,
		render: function(h) {
			return h('div', {
				attrs: {
					style: 'position: relative'
				}
			}, [
				h('canvas', {
					style: {
						display: 'block',
						width: '100%',
					},
					ref:'canvas'
				}),
				h('div', {
					class: 'annotationLayer',
					ref:'annotationLayer'
				}),
				h(__WEBPACK_IMPORTED_MODULE_0_vue_resize_sensor__["a" /* default */], {
					props: {
						initial: true
					},
					on: {
						resize: this.resize
					},
				})
			])
		},
		props: {
			src: {
				type: [String, Object, Uint8Array],
				default: '',
			},
			page: {
				type: Number,
				default: 1,
			},
			rotate: {
				type: Number,
			},
		},
		watch: {
			src: function() {

				this.pdf.loadDocument(this.src);
			},
			page: function() {

				this.pdf.loadPage(this.page, this.rotate);
			},
			rotate: function() {
				this.pdf.renderPage(this.rotate);
			},
		},
		methods: {
			resize: function(size) {

				// check if the element is attached to the dom tree || resizeSensor being destroyed
				if ( this.$el.parentNode === null || (size.width === 0 && size.height === 0) )
					return;

				// on IE10- canvas height must be set
				this.$refs.canvas.style.height = this.$refs.canvas.offsetWidth * (this.$refs.canvas.height / this.$refs.canvas.width) + 'px';
				// update the page when the resolution is too poor
				var resolutionScale = this.pdf.getResolutionScale();

				if ( resolutionScale < 0.85 || resolutionScale > 1.15 )
					this.pdf.renderPage(this.rotate);

				this.$refs.annotationLayer.style.transform = 'scale('+resolutionScale+')';
			},
			print: function(dpi, pageList) {

				this.pdf.printPage(dpi, pageList);
			}
		},

		// doc: mounted hook is not called during server-side rendering.
		mounted: function() {

			this.pdf = new PDFJSWrapper(this.$refs.canvas, this.$refs.annotationLayer, this.$emit.bind(this));

			this.$on('loaded', function() {

				this.pdf.loadPage(this.page, this.rotate);
			});

			this.$on('page-size', function(width, height) {

				this.$refs.canvas.style.height = this.$refs.canvas.offsetWidth * (height / width) + 'px';
			});

			this.pdf.loadDocument(this.src);
		},

		// doc: destroyed hook is not called during server-side rendering.
		destroyed: function() {

			this.pdf.destroy();
		}
	}

});


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_resize_sensor_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_resize_sensor_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(353);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(22)("65f82d96", content, true, {});

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "@keyframes resizeSensorVisibility{0%{top:0}}", ""]);

// exports


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfjs_dist_lib_web_pdf_link_service__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfjs_dist_lib_web_pdf_link_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pdfjs_dist_lib_web_pdf_link_service__);


/* harmony default export */ __webpack_exports__["default"] = (function(PDFJS) {

	function isPDFDocumentLoadingTask(obj) {

		return typeof(obj) === 'object' && obj !== null && obj.__PDFDocumentLoadingTask === true;
	}

	function createLoadingTask(src, options) {

		var source;
		if ( typeof(src) === 'string' )
			source = { url: src };
		else if ( src instanceof Uint8Array )
			source = { data: src };
		else if ( typeof(src) === 'object' && src !== null )
			source = Object.assign({}, src);
		else
			throw new TypeError('invalid src type');

		var loadingTask = PDFJS.getDocument(source);
		loadingTask.__PDFDocumentLoadingTask = true; // since PDFDocumentLoadingTask is not public

		if ( options && options.onPassword )
			loadingTask.onPassword = options.onPassword;

		if ( options && options.onProgress )
			loadingTask.onProgress = options.onProgress;

		return loadingTask;
	}


	function PDFJSWrapper(canvasElt, annotationLayerElt, emitEvent) {

		var pdfDoc = null;
		var pdfPage = null;
		var pdfRender = null;
		var canceling = false;

		canvasElt.getContext('2d').save();

		function clearCanvas() {

			canvasElt.getContext('2d').clearRect(0, 0, canvasElt.width, canvasElt.height);
		}

		function clearAnnotations() {

			while ( annotationLayerElt.firstChild )
				annotationLayerElt.removeChild(annotationLayerElt.firstChild);
		}

		this.destroy = function() {

			if ( pdfDoc === null )
				return;
			pdfDoc.destroy();
			pdfDoc = null;
		}

		this.getResolutionScale = function() {

			return canvasElt.offsetWidth / canvasElt.width;
		}

		this.printPage = function(dpi, pageNumberOnly) {

			if ( pdfPage === null )
				return;

			// 1in == 72pt
			// 1in == 96px
			var PRINT_RESOLUTION = dpi === undefined ? 150 : dpi;
			var PRINT_UNITS = PRINT_RESOLUTION / 72.0;
			var CSS_UNITS = 96.0 / 72.0;

			var iframeElt = document.createElement('iframe');

			function removeIframe() {

				iframeElt.parentNode.removeChild(iframeElt);
			}

			new Promise(function(resolve, reject) {

				iframeElt.frameBorder = '0';
				iframeElt.scrolling = 'no';
				iframeElt.width = '0px;'
				iframeElt.height = '0px;'
				iframeElt.style.cssText = 'position: absolute; top: 0; left: 0';

				iframeElt.onload = function() {

					resolve(this.contentWindow);
				}

				window.document.body.appendChild(iframeElt);
			})
			.then(function(win) {

				win.document.title = '';

				return pdfDoc.getPage(1)
				.then(function(page) {

					var viewport = page.getViewport(1);
					win.document.head.appendChild(win.document.createElement('style')).textContent =
						'@supports ((size:A4) and (size:1pt 1pt)) {' +
							'@page { margin: 1pt; size: ' + ((viewport.width * PRINT_UNITS) / CSS_UNITS) + 'pt ' + ((viewport.height * PRINT_UNITS) / CSS_UNITS) + 'pt; }' +
						'}' +

						'@media print {' +
							'body { margin: 0 }' +
							'canvas { page-break-before: avoid; page-break-after: always; page-break-inside: avoid }' +
						'}'+

						'@media screen {' +
							'body { margin: 0 }' +
						'}'+

						''
					return win;
				})
			})
			.then(function(win) {

				var allPages = [];

				for ( var pageNumber = 1; pageNumber <= pdfDoc.numPages; ++pageNumber ) {

					if ( pageNumberOnly !== undefined && pageNumberOnly.indexOf(pageNumber) === -1 )
						continue;

					allPages.push(
						pdfDoc.getPage(pageNumber)
						.then(function(page) {

							var viewport = page.getViewport(1);

							var printCanvasElt = win.document.body.appendChild(win.document.createElement('canvas'));
							printCanvasElt.width = (viewport.width * PRINT_UNITS);
							printCanvasElt.height = (viewport.height * PRINT_UNITS);

							return page.render({
								canvasContext: printCanvasElt.getContext('2d'),
								transform: [ // Additional transform, applied just before viewport transform.
									PRINT_UNITS, 0, 0,
									PRINT_UNITS, 0, 0
								],
								viewport: viewport,
								intent: 'print'
							}).promise;
						})
					);
				}

				Promise.all(allPages)
				.then(function() {

					win.focus(); // Required for IE
					if (win.document.queryCommandSupported('print')) {
						win.document.execCommand('print', false, null);
						} else {
						win.print();
					  }
					removeIframe();
				})
				.catch(function(err) {

					removeIframe();
					emitEvent('error', err);
				})
			})
		}

		this.renderPage = function(rotate) {
			if ( pdfRender !== null ) {

				if ( canceling )
					return;
				canceling = true;
				pdfRender.cancel();
				return;
			}

			if ( pdfPage === null )
				return;

			if ( rotate === undefined )
				rotate = pdfPage.rotate;

			var scale = canvasElt.offsetWidth / pdfPage.getViewport(1).width * (window.devicePixelRatio || 1);
			var viewport = pdfPage.getViewport(scale, rotate);

			emitEvent('page-size', viewport.width, viewport.height);

			canvasElt.width = viewport.width;
			canvasElt.height = viewport.height;

			pdfRender = pdfPage.render({
				canvasContext: canvasElt.getContext('2d'),
				viewport: viewport
			});

			annotationLayerElt.style.visibility = 'hidden';
			clearAnnotations();

			var viewer = {
				scrollPageIntoView: function(params) {
					emitEvent('link-clicked', params.pageNumber)
				},
			};

			var linkService = new __WEBPACK_IMPORTED_MODULE_0_pdfjs_dist_lib_web_pdf_link_service__["PDFLinkService"]();
			linkService.setDocument(pdfDoc);
			linkService.setViewer(viewer);

			pdfPage.getAnnotations({ intent: 'display' })
			.then(function(annotations) {

				PDFJS.AnnotationLayer.render({
					viewport: viewport.clone({ dontFlip: true }),
					div: annotationLayerElt,
					annotations: annotations,
					page: pdfPage,
					linkService: linkService,
					renderInteractiveForms: false
				});
			});

			pdfRender
			.then(function() {
				annotationLayerElt.style.visibility = '';
				canceling = false;
				pdfRender = null;
			})
			.catch(function(err) {

				pdfRender = null;
				if ( err instanceof PDFJS.RenderingCancelledException ) {

					canceling = false;
					this.renderPage(rotate);
					return;
				}
				emitEvent('error', err);
			}.bind(this))
		}


		this.forEachPage = function(pageCallback) {

			var numPages = pdfDoc.numPages;

			(function next(pageNum) {

				pdfDoc.getPage(pageNum)
				.then(pageCallback)
				.then(function() {

					if ( ++pageNum <= numPages )
						next(pageNum);
				})
			})(1);
		}


		this.loadPage = function(pageNumber, rotate) {

			pdfPage = null;

			if ( pdfDoc === null )
				return;

			pdfDoc.getPage(pageNumber)
			.then(function(page) {

				pdfPage = page;
				this.renderPage(rotate);
				emitEvent('page-loaded', page.pageNumber);
			}.bind(this))
			.catch(function(err) {

				clearCanvas();
				clearAnnotations();
				emitEvent('error', err);
			});
		}

		this.loadDocument = function(src) {

			pdfDoc = null;
			pdfPage = null;

			emitEvent('num-pages', undefined);

			if ( !src ) {

				canvasElt.removeAttribute('width');
				canvasElt.removeAttribute('height');
				clearAnnotations();
				return;
			}

			if ( isPDFDocumentLoadingTask(src) ) {

				if ( src.destroyed ) {

					emitEvent('error', new Error('loadingTask has been destroyed'));
					return
				}

				var loadingTask = src;
			} else {

				var loadingTask = createLoadingTask(src, {
					onPassword: function(updatePassword, reason) {

						var reasonStr;
						switch (reason) {
							case PDFJS.PasswordResponses.NEED_PASSWORD:
								reasonStr = 'NEED_PASSWORD';
								break;
							case PDFJS.PasswordResponses.INCORRECT_PASSWORD:
								reasonStr = 'INCORRECT_PASSWORD';
								break;
						}
						emitEvent('password', updatePassword, reasonStr);
					},
					onProgress: function(status) {

						var ratio = status.loaded / status.total;
						emitEvent('progress', Math.min(ratio, 1));
					}
				});
			}

			loadingTask
			.then(function(pdf) {

				pdfDoc = pdf;
				emitEvent('num-pages', pdf.numPages);
				emitEvent('loaded');
			})
			.catch(function(err) {

				clearCanvas();
				clearAnnotations();
				emitEvent('error', err);
			})
		}

		annotationLayerElt.style.transformOrigin = '0 0';
	}

	return {
		createLoadingTask: createLoadingTask,
		PDFJSWrapper: PDFJSWrapper,
	}
});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2018 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleLinkService = exports.PDFLinkService = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom_events = __webpack_require__(356);

var _ui_utils = __webpack_require__(218);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PDFLinkService = function () {
  function PDFLinkService() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        eventBus = _ref.eventBus,
        _ref$externalLinkTarg = _ref.externalLinkTarget,
        externalLinkTarget = _ref$externalLinkTarg === undefined ? null : _ref$externalLinkTarg,
        _ref$externalLinkRel = _ref.externalLinkRel,
        externalLinkRel = _ref$externalLinkRel === undefined ? null : _ref$externalLinkRel;

    _classCallCheck(this, PDFLinkService);

    this.eventBus = eventBus || (0, _dom_events.getGlobalEventBus)();
    this.externalLinkTarget = externalLinkTarget;
    this.externalLinkRel = externalLinkRel;
    this.baseUrl = null;
    this.pdfDocument = null;
    this.pdfViewer = null;
    this.pdfHistory = null;
    this._pagesRefCache = null;
  }

  _createClass(PDFLinkService, [{
    key: 'setDocument',
    value: function setDocument(pdfDocument) {
      var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.baseUrl = baseUrl;
      this.pdfDocument = pdfDocument;
      this._pagesRefCache = Object.create(null);
    }
  }, {
    key: 'setViewer',
    value: function setViewer(pdfViewer) {
      this.pdfViewer = pdfViewer;
    }
  }, {
    key: 'setHistory',
    value: function setHistory(pdfHistory) {
      this.pdfHistory = pdfHistory;
    }
  }, {
    key: 'navigateTo',
    value: function navigateTo(dest) {
      var _this = this;

      var goToDestination = function goToDestination(_ref2) {
        var namedDest = _ref2.namedDest,
            explicitDest = _ref2.explicitDest;

        var destRef = explicitDest[0],
            pageNumber = void 0;
        if (destRef instanceof Object) {
          pageNumber = _this._cachedPageNumber(destRef);
          if (pageNumber === null) {
            _this.pdfDocument.getPageIndex(destRef).then(function (pageIndex) {
              _this.cachePageRef(pageIndex + 1, destRef);
              goToDestination({
                namedDest: namedDest,
                explicitDest: explicitDest
              });
            }).catch(function () {
              console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid page reference, for dest="' + dest + '".'));
            });
            return;
          }
        } else if (Number.isInteger(destRef)) {
          pageNumber = destRef + 1;
        } else {
          console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid destination reference, for dest="' + dest + '".'));
          return;
        }
        if (!pageNumber || pageNumber < 1 || pageNumber > _this.pagesCount) {
          console.error('PDFLinkService.navigateTo: "' + pageNumber + '" is not ' + ('a valid page number, for dest="' + dest + '".'));
          return;
        }
        if (_this.pdfHistory) {
          _this.pdfHistory.pushCurrentPosition();
          _this.pdfHistory.push({
            namedDest: namedDest,
            explicitDest: explicitDest,
            pageNumber: pageNumber
          });
        }
        _this.pdfViewer.scrollPageIntoView({
          pageNumber: pageNumber,
          destArray: explicitDest
        });
      };
      new Promise(function (resolve, reject) {
        if (typeof dest === 'string') {
          _this.pdfDocument.getDestination(dest).then(function (destArray) {
            resolve({
              namedDest: dest,
              explicitDest: destArray
            });
          });
          return;
        }
        resolve({
          namedDest: '',
          explicitDest: dest
        });
      }).then(function (data) {
        if (!Array.isArray(data.explicitDest)) {
          console.error('PDFLinkService.navigateTo: "' + data.explicitDest + '" is' + (' not a valid destination array, for dest="' + dest + '".'));
          return;
        }
        goToDestination(data);
      });
    }
  }, {
    key: 'getDestinationHash',
    value: function getDestinationHash(dest) {
      if (typeof dest === 'string') {
        return this.getAnchorUrl('#' + escape(dest));
      }
      if (Array.isArray(dest)) {
        var str = JSON.stringify(dest);
        return this.getAnchorUrl('#' + escape(str));
      }
      return this.getAnchorUrl('');
    }
  }, {
    key: 'getAnchorUrl',
    value: function getAnchorUrl(anchor) {
      return (this.baseUrl || '') + anchor;
    }
  }, {
    key: 'setHash',
    value: function setHash(hash) {
      var pageNumber = void 0,
          dest = void 0;
      if (hash.includes('=')) {
        var params = (0, _ui_utils.parseQueryString)(hash);
        if ('search' in params) {
          this.eventBus.dispatch('findfromurlhash', {
            source: this,
            query: params['search'].replace(/"/g, ''),
            phraseSearch: params['phrase'] === 'true'
          });
        }
        if ('nameddest' in params) {
          this.navigateTo(params.nameddest);
          return;
        }
        if ('page' in params) {
          pageNumber = params.page | 0 || 1;
        }
        if ('zoom' in params) {
          var zoomArgs = params.zoom.split(',');
          var zoomArg = zoomArgs[0];
          var zoomArgNumber = parseFloat(zoomArg);
          if (!zoomArg.includes('Fit')) {
            dest = [null, { name: 'XYZ' }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null, zoomArgs.length > 2 ? zoomArgs[2] | 0 : null, zoomArgNumber ? zoomArgNumber / 100 : zoomArg];
          } else {
            if (zoomArg === 'Fit' || zoomArg === 'FitB') {
              dest = [null, { name: zoomArg }];
            } else if (zoomArg === 'FitH' || zoomArg === 'FitBH' || zoomArg === 'FitV' || zoomArg === 'FitBV') {
              dest = [null, { name: zoomArg }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null];
            } else if (zoomArg === 'FitR') {
              if (zoomArgs.length !== 5) {
                console.error('PDFLinkService.setHash: Not enough parameters for "FitR".');
              } else {
                dest = [null, { name: zoomArg }, zoomArgs[1] | 0, zoomArgs[2] | 0, zoomArgs[3] | 0, zoomArgs[4] | 0];
              }
            } else {
              console.error('PDFLinkService.setHash: "' + zoomArg + '" is not ' + 'a valid zoom value.');
            }
          }
        }
        if (dest) {
          this.pdfViewer.scrollPageIntoView({
            pageNumber: pageNumber || this.page,
            destArray: dest,
            allowNegativeOffset: true
          });
        } else if (pageNumber) {
          this.page = pageNumber;
        }
        if ('pagemode' in params) {
          this.eventBus.dispatch('pagemode', {
            source: this,
            mode: params.pagemode
          });
        }
      } else {
        dest = unescape(hash);
        try {
          dest = JSON.parse(dest);
          if (!Array.isArray(dest)) {
            dest = dest.toString();
          }
        } catch (ex) {}
        if (typeof dest === 'string' || isValidExplicitDestination(dest)) {
          this.navigateTo(dest);
          return;
        }
        console.error('PDFLinkService.setHash: "' + unescape(hash) + '" is not ' + 'a valid destination.');
      }
    }
  }, {
    key: 'executeNamedAction',
    value: function executeNamedAction(action) {
      switch (action) {
        case 'GoBack':
          if (this.pdfHistory) {
            this.pdfHistory.back();
          }
          break;
        case 'GoForward':
          if (this.pdfHistory) {
            this.pdfHistory.forward();
          }
          break;
        case 'NextPage':
          if (this.page < this.pagesCount) {
            this.page++;
          }
          break;
        case 'PrevPage':
          if (this.page > 1) {
            this.page--;
          }
          break;
        case 'LastPage':
          this.page = this.pagesCount;
          break;
        case 'FirstPage':
          this.page = 1;
          break;
        default:
          break;
      }
      this.eventBus.dispatch('namedaction', {
        source: this,
        action: action
      });
    }
  }, {
    key: 'cachePageRef',
    value: function cachePageRef(pageNum, pageRef) {
      if (!pageRef) {
        return;
      }
      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
      this._pagesRefCache[refStr] = pageNum;
    }
  }, {
    key: '_cachedPageNumber',
    value: function _cachedPageNumber(pageRef) {
      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
      return this._pagesRefCache && this._pagesRefCache[refStr] || null;
    }
  }, {
    key: 'pagesCount',
    get: function get() {
      return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
  }, {
    key: 'page',
    get: function get() {
      return this.pdfViewer.currentPageNumber;
    },
    set: function set(value) {
      this.pdfViewer.currentPageNumber = value;
    }
  }, {
    key: 'rotation',
    get: function get() {
      return this.pdfViewer.pagesRotation;
    },
    set: function set(value) {
      this.pdfViewer.pagesRotation = value;
    }
  }]);

  return PDFLinkService;
}();

function isValidExplicitDestination(dest) {
  if (!Array.isArray(dest)) {
    return false;
  }
  var destLength = dest.length,
      allowNull = true;
  if (destLength < 2) {
    return false;
  }
  var page = dest[0];
  if (!((typeof page === 'undefined' ? 'undefined' : _typeof(page)) === 'object' && Number.isInteger(page.num) && Number.isInteger(page.gen)) && !(Number.isInteger(page) && page >= 0)) {
    return false;
  }
  var zoom = dest[1];
  if (!((typeof zoom === 'undefined' ? 'undefined' : _typeof(zoom)) === 'object' && typeof zoom.name === 'string')) {
    return false;
  }
  switch (zoom.name) {
    case 'XYZ':
      if (destLength !== 5) {
        return false;
      }
      break;
    case 'Fit':
    case 'FitB':
      return destLength === 2;
    case 'FitH':
    case 'FitBH':
    case 'FitV':
    case 'FitBV':
      if (destLength !== 3) {
        return false;
      }
      break;
    case 'FitR':
      if (destLength !== 6) {
        return false;
      }
      allowNull = false;
      break;
    default:
      return false;
  }
  for (var i = 2; i < destLength; i++) {
    var param = dest[i];
    if (!(typeof param === 'number' || allowNull && param === null)) {
      return false;
    }
  }
  return true;
}

var SimpleLinkService = function () {
  function SimpleLinkService() {
    _classCallCheck(this, SimpleLinkService);

    this.externalLinkTarget = null;
    this.externalLinkRel = null;
  }

  _createClass(SimpleLinkService, [{
    key: 'navigateTo',
    value: function navigateTo(dest) {}
  }, {
    key: 'getDestinationHash',
    value: function getDestinationHash(dest) {
      return '#';
    }
  }, {
    key: 'getAnchorUrl',
    value: function getAnchorUrl(hash) {
      return '#';
    }
  }, {
    key: 'setHash',
    value: function setHash(hash) {}
  }, {
    key: 'executeNamedAction',
    value: function executeNamedAction(action) {}
  }, {
    key: 'cachePageRef',
    value: function cachePageRef(pageNum, pageRef) {}
  }, {
    key: 'pagesCount',
    get: function get() {
      return 0;
    }
  }, {
    key: 'page',
    get: function get() {
      return 0;
    },
    set: function set(value) {}
  }, {
    key: 'rotation',
    get: function get() {
      return 0;
    },
    set: function set(value) {}
  }]);

  return SimpleLinkService;
}();

exports.PDFLinkService = PDFLinkService;
exports.SimpleLinkService = SimpleLinkService;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2018 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGlobalEventBus = exports.attachDOMEventsToEventBus = undefined;

var _ui_utils = __webpack_require__(218);

function attachDOMEventsToEventBus(eventBus) {
  eventBus.on('documentload', function () {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('documentload', true, true, {});
    window.dispatchEvent(event);
  });
  eventBus.on('pagerendered', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagerendered', true, true, {
      pageNumber: evt.pageNumber,
      cssTransform: evt.cssTransform
    });
    evt.source.div.dispatchEvent(event);
  });
  eventBus.on('textlayerrendered', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('textlayerrendered', true, true, { pageNumber: evt.pageNumber });
    evt.source.textLayerDiv.dispatchEvent(event);
  });
  eventBus.on('pagechange', function (evt) {
    var event = document.createEvent('UIEvents');
    event.initUIEvent('pagechange', true, true, window, 0);
    event.pageNumber = evt.pageNumber;
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('pagesinit', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagesinit', true, true, null);
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('pagesloaded', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagesloaded', true, true, { pagesCount: evt.pagesCount });
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('scalechange', function (evt) {
    var event = document.createEvent('UIEvents');
    event.initUIEvent('scalechange', true, true, window, 0);
    event.scale = evt.scale;
    event.presetValue = evt.presetValue;
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('updateviewarea', function (evt) {
    var event = document.createEvent('UIEvents');
    event.initUIEvent('updateviewarea', true, true, window, 0);
    event.location = evt.location;
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('find', function (evt) {
    if (evt.source === window) {
      return;
    }
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('find' + evt.type, true, true, {
      query: evt.query,
      phraseSearch: evt.phraseSearch,
      caseSensitive: evt.caseSensitive,
      highlightAll: evt.highlightAll,
      findPrevious: evt.findPrevious
    });
    window.dispatchEvent(event);
  });
  eventBus.on('attachmentsloaded', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('attachmentsloaded', true, true, { attachmentsCount: evt.attachmentsCount });
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('sidebarviewchanged', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('sidebarviewchanged', true, true, { view: evt.view });
    evt.source.outerContainer.dispatchEvent(event);
  });
  eventBus.on('pagemode', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagemode', true, true, { mode: evt.mode });
    evt.source.pdfViewer.container.dispatchEvent(event);
  });
  eventBus.on('namedaction', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('namedaction', true, true, { action: evt.action });
    evt.source.pdfViewer.container.dispatchEvent(event);
  });
  eventBus.on('presentationmodechanged', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('presentationmodechanged', true, true, {
      active: evt.active,
      switchInProgress: evt.switchInProgress
    });
    window.dispatchEvent(event);
  });
  eventBus.on('outlineloaded', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('outlineloaded', true, true, { outlineCount: evt.outlineCount });
    evt.source.container.dispatchEvent(event);
  });
}
var globalEventBus = null;
function getGlobalEventBus() {
  var dispatchToDOM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (!globalEventBus) {
    globalEventBus = new _ui_utils.EventBus({ dispatchToDOM: dispatchToDOM });
    if (!dispatchToDOM) {
      attachDOMEventsToEventBus(globalEventBus);
    }
  }
  return globalEventBus;
}
exports.attachDOMEventsToEventBus = attachDOMEventsToEventBus;
exports.getGlobalEventBus = getGlobalEventBus;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(358);


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(359);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2018 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist/build/pdf", [], factory);
	else if(typeof exports === 'object')
		exports["pdfjs-dist/build/pdf"] = factory();
	else
		root["pdfjs-dist/build/pdf"] = root.pdfjsLib = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __w_pdfjs_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__w_pdfjs_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__w_pdfjs_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__w_pdfjs_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__w_pdfjs_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __w_pdfjs_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__w_pdfjs_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __w_pdfjs_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__w_pdfjs_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__w_pdfjs_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pdfjsVersion = '2.0.943';
var pdfjsBuild = 'dc98bf76';
var pdfjsSharedUtil = __w_pdfjs_require__(1);
var pdfjsDisplayAPI = __w_pdfjs_require__(129);
var pdfjsDisplayTextLayer = __w_pdfjs_require__(145);
var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(146);
var pdfjsDisplayDOMUtils = __w_pdfjs_require__(130);
var pdfjsDisplaySVG = __w_pdfjs_require__(147);
var pdfjsDisplayWorkerOptions = __w_pdfjs_require__(135);
var pdfjsDisplayAPICompatibility = __w_pdfjs_require__(132);
{
  var isNodeJS = __w_pdfjs_require__(4);
  if (isNodeJS()) {
    var PDFNodeStream = __w_pdfjs_require__(148).PDFNodeStream;
    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      return new PDFNodeStream(params);
    });
  } else if (typeof Response !== 'undefined' && 'body' in Response.prototype && typeof ReadableStream !== 'undefined') {
    var PDFFetchStream = __w_pdfjs_require__(151).PDFFetchStream;
    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      return new PDFFetchStream(params);
    });
  } else {
    var PDFNetworkStream = __w_pdfjs_require__(152).PDFNetworkStream;
    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      return new PDFNetworkStream(params);
    });
  }
}
exports.build = pdfjsDisplayAPI.build;
exports.version = pdfjsDisplayAPI.version;
exports.getDocument = pdfjsDisplayAPI.getDocument;
exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
exports.CMapCompressionType = pdfjsSharedUtil.CMapCompressionType;
exports.PermissionFlag = pdfjsSharedUtil.PermissionFlag;
exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
exports.OPS = pdfjsSharedUtil.OPS;
exports.VerbosityLevel = pdfjsSharedUtil.VerbosityLevel;
exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
exports.shadow = pdfjsSharedUtil.shadow;
exports.Util = pdfjsSharedUtil.Util;
exports.ReadableStream = pdfjsSharedUtil.ReadableStream;
exports.URL = pdfjsSharedUtil.URL;
exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
exports.LinkTarget = pdfjsDisplayDOMUtils.LinkTarget;
exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;
exports.loadScript = pdfjsDisplayDOMUtils.loadScript;
exports.GlobalWorkerOptions = pdfjsDisplayWorkerOptions.GlobalWorkerOptions;
exports.apiCompatibilityParams = pdfjsDisplayAPICompatibility.apiCompatibilityParams;

/***/ }),
/* 1 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.URL = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isSpace = exports.isString = exports.isNum = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.info = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.getInheritableProperty = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.toRomanNumerals = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VerbosityLevel = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__w_pdfjs_require__(2);

var _streams_polyfill = __w_pdfjs_require__(125);

var _url_polyfill = __w_pdfjs_require__(127);

var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
var NativeImageDecoding = {
  NONE: 'none',
  DECODE: 'decode',
  DISPLAY: 'display'
};
var PermissionFlag = {
  PRINT: 0x04,
  MODIFY_CONTENTS: 0x08,
  COPY: 0x10,
  MODIFY_ANNOTATIONS: 0x20,
  FILL_INTERACTIVE_FORMS: 0x100,
  COPY_FOR_ACCESSIBILITY: 0x200,
  ASSEMBLE: 0x400,
  PRINT_HIGH_QUALITY: 0x800
};
var TextRenderingMode = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_ADD_TO_PATH: 4,
  STROKE_ADD_TO_PATH: 5,
  FILL_STROKE_ADD_TO_PATH: 6,
  ADD_TO_PATH: 7,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
};
var ImageKind = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
};
var AnnotationType = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
};
var AnnotationFlag = {
  INVISIBLE: 0x01,
  HIDDEN: 0x02,
  PRINT: 0x04,
  NOZOOM: 0x08,
  NOROTATE: 0x10,
  NOVIEW: 0x20,
  READONLY: 0x40,
  LOCKED: 0x80,
  TOGGLENOVIEW: 0x100,
  LOCKEDCONTENTS: 0x200
};
var AnnotationFieldFlag = {
  READONLY: 0x0000001,
  REQUIRED: 0x0000002,
  NOEXPORT: 0x0000004,
  MULTILINE: 0x0001000,
  PASSWORD: 0x0002000,
  NOTOGGLETOOFF: 0x0004000,
  RADIO: 0x0008000,
  PUSHBUTTON: 0x0010000,
  COMBO: 0x0020000,
  EDIT: 0x0040000,
  SORT: 0x0080000,
  FILESELECT: 0x0100000,
  MULTISELECT: 0x0200000,
  DONOTSPELLCHECK: 0x0400000,
  DONOTSCROLL: 0x0800000,
  COMB: 0x1000000,
  RICHTEXT: 0x2000000,
  RADIOSINUNISON: 0x2000000,
  COMMITONSELCHANGE: 0x4000000
};
var AnnotationBorderStyleType = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
};
var StreamType = {
  UNKNOWN: 0,
  FLATE: 1,
  LZW: 2,
  DCT: 3,
  JPX: 4,
  JBIG: 5,
  A85: 6,
  AHX: 7,
  CCF: 8,
  RL: 9
};
var FontType = {
  UNKNOWN: 0,
  TYPE1: 1,
  TYPE1C: 2,
  CIDFONTTYPE0: 3,
  CIDFONTTYPE0C: 4,
  TRUETYPE: 5,
  CIDFONTTYPE2: 6,
  TYPE3: 7,
  OPENTYPE: 8,
  TYPE0: 9,
  MMTYPE1: 10
};
var VerbosityLevel = {
  ERRORS: 0,
  WARNINGS: 1,
  INFOS: 5
};
var CMapCompressionType = {
  NONE: 0,
  BINARY: 1,
  STREAM: 2
};
var OPS = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotations: 78,
  endAnnotations: 79,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintJpegXObject: 82,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91
};
var UNSUPPORTED_FEATURES = {
  unknown: 'unknown',
  forms: 'forms',
  javaScript: 'javaScript',
  smask: 'smask',
  shadingPattern: 'shadingPattern',
  font: 'font'
};
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
var verbosity = VerbosityLevel.WARNINGS;
function setVerbosityLevel(level) {
  if (Number.isInteger(level)) {
    verbosity = level;
  }
}
function getVerbosityLevel() {
  return verbosity;
}
function info(msg) {
  if (verbosity >= VerbosityLevel.INFOS) {
    console.log('Info: ' + msg);
  }
}
function warn(msg) {
  if (verbosity >= VerbosityLevel.WARNINGS) {
    console.log('Warning: ' + msg);
  }
}
function deprecated(details) {
  console.log('Deprecated API usage: ' + details);
}
function unreachable(msg) {
  throw new Error(msg);
}
function assert(cond, msg) {
  if (!cond) {
    unreachable(msg);
  }
}
function isSameOrigin(baseUrl, otherUrl) {
  try {
    var base = new _url_polyfill.URL(baseUrl);
    if (!base.origin || base.origin === 'null') {
      return false;
    }
  } catch (e) {
    return false;
  }
  var other = new _url_polyfill.URL(otherUrl, base);
  return base.origin === other.origin;
}
function _isValidProtocol(url) {
  if (!url) {
    return false;
  }
  switch (url.protocol) {
    case 'http:':
    case 'https:':
    case 'ftp:':
    case 'mailto:':
    case 'tel:':
      return true;
    default:
      return false;
  }
}
function createValidAbsoluteUrl(url, baseUrl) {
  if (!url) {
    return null;
  }
  try {
    var absoluteUrl = baseUrl ? new _url_polyfill.URL(url, baseUrl) : new _url_polyfill.URL(url);
    if (_isValidProtocol(absoluteUrl)) {
      return absoluteUrl;
    }
  } catch (ex) {}
  return null;
}
function shadow(obj, prop, value) {
  Object.defineProperty(obj, prop, {
    value: value,
    enumerable: true,
    configurable: true,
    writable: false
  });
  return value;
}
function getLookupTableFactory(initializer) {
  var lookup;
  return function () {
    if (initializer) {
      lookup = Object.create(null);
      initializer(lookup);
      initializer = null;
    }
    return lookup;
  };
}
var PasswordException = function PasswordExceptionClosure() {
  function PasswordException(msg, code) {
    this.name = 'PasswordException';
    this.message = msg;
    this.code = code;
  }
  PasswordException.prototype = new Error();
  PasswordException.constructor = PasswordException;
  return PasswordException;
}();
var UnknownErrorException = function UnknownErrorExceptionClosure() {
  function UnknownErrorException(msg, details) {
    this.name = 'UnknownErrorException';
    this.message = msg;
    this.details = details;
  }
  UnknownErrorException.prototype = new Error();
  UnknownErrorException.constructor = UnknownErrorException;
  return UnknownErrorException;
}();
var InvalidPDFException = function InvalidPDFExceptionClosure() {
  function InvalidPDFException(msg) {
    this.name = 'InvalidPDFException';
    this.message = msg;
  }
  InvalidPDFException.prototype = new Error();
  InvalidPDFException.constructor = InvalidPDFException;
  return InvalidPDFException;
}();
var MissingPDFException = function MissingPDFExceptionClosure() {
  function MissingPDFException(msg) {
    this.name = 'MissingPDFException';
    this.message = msg;
  }
  MissingPDFException.prototype = new Error();
  MissingPDFException.constructor = MissingPDFException;
  return MissingPDFException;
}();
var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
  function UnexpectedResponseException(msg, status) {
    this.name = 'UnexpectedResponseException';
    this.message = msg;
    this.status = status;
  }
  UnexpectedResponseException.prototype = new Error();
  UnexpectedResponseException.constructor = UnexpectedResponseException;
  return UnexpectedResponseException;
}();
var MissingDataException = function MissingDataExceptionClosure() {
  function MissingDataException(begin, end) {
    this.begin = begin;
    this.end = end;
    this.message = 'Missing data [' + begin + ', ' + end + ')';
  }
  MissingDataException.prototype = new Error();
  MissingDataException.prototype.name = 'MissingDataException';
  MissingDataException.constructor = MissingDataException;
  return MissingDataException;
}();
var XRefParseException = function XRefParseExceptionClosure() {
  function XRefParseException(msg) {
    this.message = msg;
  }
  XRefParseException.prototype = new Error();
  XRefParseException.prototype.name = 'XRefParseException';
  XRefParseException.constructor = XRefParseException;
  return XRefParseException;
}();
var FormatError = function FormatErrorClosure() {
  function FormatError(msg) {
    this.message = msg;
  }
  FormatError.prototype = new Error();
  FormatError.prototype.name = 'FormatError';
  FormatError.constructor = FormatError;
  return FormatError;
}();
var AbortException = function AbortExceptionClosure() {
  function AbortException(msg) {
    this.name = 'AbortException';
    this.message = msg;
  }
  AbortException.prototype = new Error();
  AbortException.constructor = AbortException;
  return AbortException;
}();
var NullCharactersRegExp = /\x00/g;
function removeNullCharacters(str) {
  if (typeof str !== 'string') {
    warn('The argument for removeNullCharacters must be a string.');
    return str;
  }
  return str.replace(NullCharactersRegExp, '');
}
function bytesToString(bytes) {
  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
  var length = bytes.length;
  var MAX_ARGUMENT_COUNT = 8192;
  if (length < MAX_ARGUMENT_COUNT) {
    return String.fromCharCode.apply(null, bytes);
  }
  var strBuf = [];
  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
    var chunk = bytes.subarray(i, chunkEnd);
    strBuf.push(String.fromCharCode.apply(null, chunk));
  }
  return strBuf.join('');
}
function stringToBytes(str) {
  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
  var length = str.length;
  var bytes = new Uint8Array(length);
  for (var i = 0; i < length; ++i) {
    bytes[i] = str.charCodeAt(i) & 0xFF;
  }
  return bytes;
}
function arrayByteLength(arr) {
  if (arr.length !== undefined) {
    return arr.length;
  }
  assert(arr.byteLength !== undefined);
  return arr.byteLength;
}
function arraysToBytes(arr) {
  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
    return arr[0];
  }
  var resultLength = 0;
  var i,
      ii = arr.length;
  var item, itemLength;
  for (i = 0; i < ii; i++) {
    item = arr[i];
    itemLength = arrayByteLength(item);
    resultLength += itemLength;
  }
  var pos = 0;
  var data = new Uint8Array(resultLength);
  for (i = 0; i < ii; i++) {
    item = arr[i];
    if (!(item instanceof Uint8Array)) {
      if (typeof item === 'string') {
        item = stringToBytes(item);
      } else {
        item = new Uint8Array(item);
      }
    }
    itemLength = item.byteLength;
    data.set(item, pos);
    pos += itemLength;
  }
  return data;
}
function string32(value) {
  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function log2(x) {
  if (x <= 0) {
    return 0;
  }
  return Math.ceil(Math.log2(x));
}
function readInt8(data, start) {
  return data[start] << 24 >> 24;
}
function readUint16(data, offset) {
  return data[offset] << 8 | data[offset + 1];
}
function readUint32(data, offset) {
  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
}
function isLittleEndian() {
  var buffer8 = new Uint8Array(4);
  buffer8[0] = 1;
  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
  return view32[0] === 1;
}
function isEvalSupported() {
  try {
    new Function('');
    return true;
  } catch (e) {
    return false;
  }
}
function getInheritableProperty(_ref) {
  var dict = _ref.dict,
      key = _ref.key,
      _ref$getArray = _ref.getArray,
      getArray = _ref$getArray === undefined ? false : _ref$getArray,
      _ref$stopWhenFound = _ref.stopWhenFound,
      stopWhenFound = _ref$stopWhenFound === undefined ? true : _ref$stopWhenFound;

  var LOOP_LIMIT = 100;
  var loopCount = 0;
  var values = void 0;
  while (dict) {
    var value = getArray ? dict.getArray(key) : dict.get(key);
    if (value !== undefined) {
      if (stopWhenFound) {
        return value;
      }
      if (!values) {
        values = [];
      }
      values.push(value);
    }
    if (++loopCount > LOOP_LIMIT) {
      warn('getInheritableProperty: maximum loop count exceeded for "' + key + '"');
      break;
    }
    dict = dict.get('Parent');
  }
  return values;
}
var Util = function UtilClosure() {
  function Util() {}
  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
    rgbBuf[1] = r;
    rgbBuf[3] = g;
    rgbBuf[5] = b;
    return rgbBuf.join('');
  };
  Util.transform = function Util_transform(m1, m2) {
    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
  };
  Util.applyTransform = function Util_applyTransform(p, m) {
    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
    return [xt, yt];
  };
  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
    var d = m[0] * m[3] - m[1] * m[2];
    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    return [xt, yt];
  };
  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
    var p1 = Util.applyTransform(r, m);
    var p2 = Util.applyTransform(r.slice(2, 4), m);
    var p3 = Util.applyTransform([r[0], r[3]], m);
    var p4 = Util.applyTransform([r[2], r[1]], m);
    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
  };
  Util.inverseTransform = function Util_inverseTransform(m) {
    var d = m[0] * m[3] - m[1] * m[2];
    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
  };
  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
  };
  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
    var transpose = [m[0], m[2], m[1], m[3]];
    var a = m[0] * transpose[0] + m[1] * transpose[2];
    var b = m[0] * transpose[1] + m[1] * transpose[3];
    var c = m[2] * transpose[0] + m[3] * transpose[2];
    var d = m[2] * transpose[1] + m[3] * transpose[3];
    var first = (a + d) / 2;
    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
    var sx = first + second || 1;
    var sy = first - second || 1;
    return [Math.sqrt(sx), Math.sqrt(sy)];
  };
  Util.normalizeRect = function Util_normalizeRect(rect) {
    var r = rect.slice(0);
    if (rect[0] > rect[2]) {
      r[0] = rect[2];
      r[2] = rect[0];
    }
    if (rect[1] > rect[3]) {
      r[1] = rect[3];
      r[3] = rect[1];
    }
    return r;
  };
  Util.intersect = function Util_intersect(rect1, rect2) {
    function compare(a, b) {
      return a - b;
    }
    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
        result = [];
    rect1 = Util.normalizeRect(rect1);
    rect2 = Util.normalizeRect(rect2);
    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
      result[0] = orderedX[1];
      result[2] = orderedX[2];
    } else {
      return false;
    }
    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
      result[1] = orderedY[1];
      result[3] = orderedY[2];
    } else {
      return false;
    }
    return result;
  };
  return Util;
}();
var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
function toRomanNumerals(number) {
  var lowerCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  assert(Number.isInteger(number) && number > 0, 'The number should be a positive integer.');
  var pos = void 0,
      romanBuf = [];
  while (number >= 1000) {
    number -= 1000;
    romanBuf.push('M');
  }
  pos = number / 100 | 0;
  number %= 100;
  romanBuf.push(ROMAN_NUMBER_MAP[pos]);
  pos = number / 10 | 0;
  number %= 10;
  romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
  romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
  var romanStr = romanBuf.join('');
  return lowerCase ? romanStr.toLowerCase() : romanStr;
}
var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
function stringToPDFString(str) {
  var i,
      n = str.length,
      strBuf = [];
  if (str[0] === '\xFE' && str[1] === '\xFF') {
    for (i = 2; i < n; i += 2) {
      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
    }
  } else {
    for (i = 0; i < n; ++i) {
      var code = PDFStringTranslateTable[str.charCodeAt(i)];
      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
  }
  return strBuf.join('');
}
function stringToUTF8String(str) {
  return decodeURIComponent(escape(str));
}
function utf8StringToString(str) {
  return unescape(encodeURIComponent(str));
}
function isEmptyObj(obj) {
  for (var key in obj) {
    return false;
  }
  return true;
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isNum(v) {
  return typeof v === 'number';
}
function isString(v) {
  return typeof v === 'string';
}
function isArrayBuffer(v) {
  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
}
function isSpace(ch) {
  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
}
function createPromiseCapability() {
  var capability = {};
  capability.promise = new Promise(function (resolve, reject) {
    capability.resolve = resolve;
    capability.reject = reject;
  });
  return capability;
}
var createObjectURL = function createObjectURLClosure() {
  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  return function createObjectURL(data, contentType) {
    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!forceDataSchema && _url_polyfill.URL.createObjectURL) {
      var blob = new Blob([data], { type: contentType });
      return _url_polyfill.URL.createObjectURL(blob);
    }
    var buffer = 'data:' + contentType + ';base64,';
    for (var i = 0, ii = data.length; i < ii; i += 3) {
      var b1 = data[i] & 0xFF;
      var b2 = data[i + 1] & 0xFF;
      var b3 = data[i + 2] & 0xFF;
      var d1 = b1 >> 2,
          d2 = (b1 & 3) << 4 | b2 >> 4;
      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
    }
    return buffer;
  };
}();
exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
exports.OPS = OPS;
exports.VerbosityLevel = VerbosityLevel;
exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
exports.AnnotationFieldFlag = AnnotationFieldFlag;
exports.AnnotationFlag = AnnotationFlag;
exports.AnnotationType = AnnotationType;
exports.FontType = FontType;
exports.ImageKind = ImageKind;
exports.CMapCompressionType = CMapCompressionType;
exports.AbortException = AbortException;
exports.InvalidPDFException = InvalidPDFException;
exports.MissingDataException = MissingDataException;
exports.MissingPDFException = MissingPDFException;
exports.NativeImageDecoding = NativeImageDecoding;
exports.PasswordException = PasswordException;
exports.PasswordResponses = PasswordResponses;
exports.PermissionFlag = PermissionFlag;
exports.StreamType = StreamType;
exports.TextRenderingMode = TextRenderingMode;
exports.UnexpectedResponseException = UnexpectedResponseException;
exports.UnknownErrorException = UnknownErrorException;
exports.Util = Util;
exports.toRomanNumerals = toRomanNumerals;
exports.XRefParseException = XRefParseException;
exports.FormatError = FormatError;
exports.arrayByteLength = arrayByteLength;
exports.arraysToBytes = arraysToBytes;
exports.assert = assert;
exports.bytesToString = bytesToString;
exports.createPromiseCapability = createPromiseCapability;
exports.createObjectURL = createObjectURL;
exports.deprecated = deprecated;
exports.getInheritableProperty = getInheritableProperty;
exports.getLookupTableFactory = getLookupTableFactory;
exports.getVerbosityLevel = getVerbosityLevel;
exports.info = info;
exports.isArrayBuffer = isArrayBuffer;
exports.isBool = isBool;
exports.isEmptyObj = isEmptyObj;
exports.isNum = isNum;
exports.isString = isString;
exports.isSpace = isSpace;
exports.isSameOrigin = isSameOrigin;
exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
exports.isLittleEndian = isLittleEndian;
exports.isEvalSupported = isEvalSupported;
exports.log2 = log2;
exports.readInt8 = readInt8;
exports.readUint16 = readUint16;
exports.readUint32 = readUint32;
exports.removeNullCharacters = removeNullCharacters;
exports.ReadableStream = _streams_polyfill.ReadableStream;
exports.URL = _url_polyfill.URL;
exports.setVerbosityLevel = setVerbosityLevel;
exports.shadow = shadow;
exports.string32 = string32;
exports.stringToBytes = stringToBytes;
exports.stringToPDFString = stringToPDFString;
exports.stringToUTF8String = stringToUTF8String;
exports.utf8StringToString = utf8StringToString;
exports.warn = warn;
exports.unreachable = unreachable;

/***/ }),
/* 2 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var globalScope = __w_pdfjs_require__(3);
if (!globalScope._pdfjsCompatibilityChecked) {
  globalScope._pdfjsCompatibilityChecked = true;
  var isNodeJS = __w_pdfjs_require__(4);
  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
  (function checkNodeBtoa() {
    if (globalScope.btoa || !isNodeJS()) {
      return;
    }
    globalScope.btoa = function (chars) {
      return Buffer.from(chars, 'binary').toString('base64');
    };
  })();
  (function checkNodeAtob() {
    if (globalScope.atob || !isNodeJS()) {
      return;
    }
    globalScope.atob = function (input) {
      return Buffer.from(input, 'base64').toString('binary');
    };
  })();
  (function checkCurrentScript() {
    if (!hasDOM) {
      return;
    }
    if ('currentScript' in document) {
      return;
    }
    Object.defineProperty(document, 'currentScript', {
      get: function get() {
        var scripts = document.getElementsByTagName('script');
        return scripts[scripts.length - 1];
      },

      enumerable: true,
      configurable: true
    });
  })();
  (function checkChildNodeRemove() {
    if (!hasDOM) {
      return;
    }
    if (typeof Element.prototype.remove !== 'undefined') {
      return;
    }
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  })();
  (function checkDOMTokenListToggle() {
    if (!hasDOM || isNodeJS()) {
      return;
    }
    var div = document.createElement('div');
    if (div.classList.toggle('test', 0) === false) {
      return;
    }
    var originalDOMTokenListToggle = DOMTokenList.prototype.toggle;
    DOMTokenList.prototype.toggle = function (token) {
      if (arguments.length > 1) {
        var force = !!arguments[1];
        return this[force ? 'add' : 'remove'](token), force;
      }
      return originalDOMTokenListToggle(token);
    };
  })();
  (function checkStringIncludes() {
    if (String.prototype.includes) {
      return;
    }
    __w_pdfjs_require__(5);
  })();
  (function checkArrayIncludes() {
    if (Array.prototype.includes) {
      return;
    }
    __w_pdfjs_require__(33);
  })();
  (function checkObjectAssign() {
    if (Object.assign) {
      return;
    }
    __w_pdfjs_require__(42);
  })();
  (function checkMathLog2() {
    if (Math.log2) {
      return;
    }
    Math.log2 = __w_pdfjs_require__(52);
  })();
  (function checkNumberIsNaN() {
    if (Number.isNaN) {
      return;
    }
    Number.isNaN = __w_pdfjs_require__(54);
  })();
  (function checkNumberIsInteger() {
    if (Number.isInteger) {
      return;
    }
    Number.isInteger = __w_pdfjs_require__(56);
  })();
  (function checkPromise() {
    if (globalScope.Promise) {
      return;
    }
    globalScope.Promise = __w_pdfjs_require__(59);
  })();
  (function checkWeakMap() {
    if (globalScope.WeakMap) {
      return;
    }
    globalScope.WeakMap = __w_pdfjs_require__(94);
  })();
  (function checkStringCodePointAt() {
    if (String.codePointAt) {
      return;
    }
    String.codePointAt = __w_pdfjs_require__(111);
  })();
  (function checkStringFromCodePoint() {
    if (String.fromCodePoint) {
      return;
    }
    String.fromCodePoint = __w_pdfjs_require__(113);
  })();
  (function checkSymbol() {
    if (globalScope.Symbol) {
      return;
    }
    __w_pdfjs_require__(115);
  })();
  (function checkObjectValues() {
    if (Object.values) {
      return;
    }
    Object.values = __w_pdfjs_require__(122);
  })();
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : {};

/***/ }),
/* 4 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function isNodeJS() {
  return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(6);
module.exports = __w_pdfjs_require__(9).String.includes;

/***/ }),
/* 6 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
var context = __w_pdfjs_require__(25);
var INCLUDES = 'includes';
$export($export.P + $export.F * __w_pdfjs_require__(32)(INCLUDES), 'String', {
  includes: function includes(searchString) {
    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);
var core = __w_pdfjs_require__(9);
var hide = __w_pdfjs_require__(10);
var redefine = __w_pdfjs_require__(20);
var ctx = __w_pdfjs_require__(23);
var PROTOTYPE = 'prototype';
var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    own = !IS_FORCED && target && target[key] !== undefined;
    out = (own ? target : source)[key];
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    if (target) redefine(target, key, out, type & $export.U);
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
$export.F = 1;
$export.G = 2;
$export.S = 4;
$export.P = 8;
$export.B = 16;
$export.W = 32;
$export.U = 64;
$export.R = 128;
module.exports = $export;

/***/ }),
/* 8 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = global;

/***/ }),
/* 9 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core;

/***/ }),
/* 10 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var dP = __w_pdfjs_require__(11);
var createDesc = __w_pdfjs_require__(19);
module.exports = __w_pdfjs_require__(15) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(12);
var IE8_DOM_DEFINE = __w_pdfjs_require__(14);
var toPrimitive = __w_pdfjs_require__(18);
var dP = Object.defineProperty;
exports.f = __w_pdfjs_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = !__w_pdfjs_require__(15) && !__w_pdfjs_require__(16)(function () {
  return Object.defineProperty(__w_pdfjs_require__(17)('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

/***/ }),
/* 15 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = !__w_pdfjs_require__(16)(function () {
  return Object.defineProperty({}, 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);
var document = __w_pdfjs_require__(8).document;
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);
var hide = __w_pdfjs_require__(10);
var has = __w_pdfjs_require__(21);
var SRC = __w_pdfjs_require__(22)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);
__w_pdfjs_require__(9).inspectSource = function (it) {
  return $toString.call(it);
};
(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 21 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var aFunction = __w_pdfjs_require__(24);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () {
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isRegExp = __w_pdfjs_require__(26);
var defined = __w_pdfjs_require__(31);
module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);
var cof = __w_pdfjs_require__(27);
var MATCH = __w_pdfjs_require__(28)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toString = {}.toString;
module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var store = __w_pdfjs_require__(29)('wks');
var uid = __w_pdfjs_require__(22);
var _Symbol = __w_pdfjs_require__(8).Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';
var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};
$exports.store = store;

/***/ }),
/* 29 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var core = __w_pdfjs_require__(9);
var global = __w_pdfjs_require__(8);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __w_pdfjs_require__(30) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});

/***/ }),
/* 30 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = false;

/***/ }),
/* 31 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var MATCH = __w_pdfjs_require__(28)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) {}
  }
  return true;
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(34);
module.exports = __w_pdfjs_require__(9).Array.includes;

/***/ }),
/* 34 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
var $includes = __w_pdfjs_require__(35)(true);
$export($export.P, 'Array', {
  includes: function includes(el) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__w_pdfjs_require__(41)('includes');

/***/ }),
/* 35 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toIObject = __w_pdfjs_require__(36);
var toLength = __w_pdfjs_require__(38);
var toAbsoluteIndex = __w_pdfjs_require__(40);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      if (value != value) return true;
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var IObject = __w_pdfjs_require__(37);
var defined = __w_pdfjs_require__(31);
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var cof = __w_pdfjs_require__(27);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toInteger = __w_pdfjs_require__(39);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0;
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toInteger = __w_pdfjs_require__(39);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var UNSCOPABLES = __w_pdfjs_require__(28)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __w_pdfjs_require__(10)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(43);
module.exports = __w_pdfjs_require__(9).Object.assign;

/***/ }),
/* 43 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
$export($export.S + $export.F, 'Object', { assign: __w_pdfjs_require__(44) });

/***/ }),
/* 44 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var getKeys = __w_pdfjs_require__(45);
var gOPS = __w_pdfjs_require__(49);
var pIE = __w_pdfjs_require__(50);
var toObject = __w_pdfjs_require__(51);
var IObject = __w_pdfjs_require__(37);
var $assign = Object.assign;
module.exports = !$assign || __w_pdfjs_require__(16)(function () {
  var A = {};
  var B = {};
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
    }
  }
  return T;
} : $assign;

/***/ }),
/* 45 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $keys = __w_pdfjs_require__(46);
var enumBugKeys = __w_pdfjs_require__(48);
module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var has = __w_pdfjs_require__(21);
var toIObject = __w_pdfjs_require__(36);
var arrayIndexOf = __w_pdfjs_require__(35)(false);
var IE_PROTO = __w_pdfjs_require__(47)('IE_PROTO');
module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  }while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var shared = __w_pdfjs_require__(29)('keys');
var uid = __w_pdfjs_require__(22);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 49 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 50 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 51 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var defined = __w_pdfjs_require__(31);
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(53);
module.exports = __w_pdfjs_require__(9).Math.log2;

/***/ }),
/* 53 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 54 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(55);
module.exports = __w_pdfjs_require__(9).Number.isNaN;

/***/ }),
/* 55 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    return number != number;
  }
});

/***/ }),
/* 56 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(57);
module.exports = __w_pdfjs_require__(9).Number.isInteger;

/***/ }),
/* 57 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
$export($export.S, 'Number', { isInteger: __w_pdfjs_require__(58) });

/***/ }),
/* 58 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(60);
__w_pdfjs_require__(62);
__w_pdfjs_require__(72);
__w_pdfjs_require__(75);
__w_pdfjs_require__(92);
__w_pdfjs_require__(93);
module.exports = __w_pdfjs_require__(9).Promise;

/***/ }),
/* 60 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var classof = __w_pdfjs_require__(61);
var test = {};
test[__w_pdfjs_require__(28)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __w_pdfjs_require__(20)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var cof = __w_pdfjs_require__(27);
var TAG = __w_pdfjs_require__(28)('toStringTag');
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {}
};
module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T : ARG ? cof(O) : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $at = __w_pdfjs_require__(63)(true);
__w_pdfjs_require__(64)(String, 'String', function (iterated) {
  this._t = String(iterated);
  this._i = 0;
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return {
    value: undefined,
    done: true
  };
  point = $at(O, index);
  this._i += point.length;
  return {
    value: point,
    done: false
  };
});

/***/ }),
/* 63 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toInteger = __w_pdfjs_require__(39);
var defined = __w_pdfjs_require__(31);
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var LIBRARY = __w_pdfjs_require__(30);
var $export = __w_pdfjs_require__(7);
var redefine = __w_pdfjs_require__(20);
var hide = __w_pdfjs_require__(10);
var Iterators = __w_pdfjs_require__(65);
var $iterCreate = __w_pdfjs_require__(66);
var setToStringTag = __w_pdfjs_require__(70);
var getPrototypeOf = __w_pdfjs_require__(71);
var ITERATOR = __w_pdfjs_require__(28)('iterator');
var BUGGY = !([].keys && 'next' in [].keys());
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';
var returnThis = function returnThis() {
  return this;
};
module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }
    return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      setToStringTag(IteratorPrototype, TAG, true);
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = {};

/***/ }),
/* 66 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var create = __w_pdfjs_require__(67);
var descriptor = __w_pdfjs_require__(19);
var setToStringTag = __w_pdfjs_require__(70);
var IteratorPrototype = {};
__w_pdfjs_require__(10)(IteratorPrototype, __w_pdfjs_require__(28)('iterator'), function () {
  return this;
});
module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(12);
var dPs = __w_pdfjs_require__(68);
var enumBugKeys = __w_pdfjs_require__(48);
var IE_PROTO = __w_pdfjs_require__(47)('IE_PROTO');
var Empty = function Empty() {};
var PROTOTYPE = 'prototype';
var _createDict = function createDict() {
  var iframe = __w_pdfjs_require__(17)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __w_pdfjs_require__(69).appendChild(iframe);
  iframe.src = 'javascript:';
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var dP = __w_pdfjs_require__(11);
var anObject = __w_pdfjs_require__(12);
var getKeys = __w_pdfjs_require__(45);
module.exports = __w_pdfjs_require__(15) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var document = __w_pdfjs_require__(8).document;
module.exports = document && document.documentElement;

/***/ }),
/* 70 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var def = __w_pdfjs_require__(11).f;
var has = __w_pdfjs_require__(21);
var TAG = __w_pdfjs_require__(28)('toStringTag');
module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
    configurable: true,
    value: tag
  });
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var has = __w_pdfjs_require__(21);
var toObject = __w_pdfjs_require__(51);
var IE_PROTO = __w_pdfjs_require__(47)('IE_PROTO');
var ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }
  return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $iterators = __w_pdfjs_require__(73);
var getKeys = __w_pdfjs_require__(45);
var redefine = __w_pdfjs_require__(20);
var global = __w_pdfjs_require__(8);
var hide = __w_pdfjs_require__(10);
var Iterators = __w_pdfjs_require__(65);
var wks = __w_pdfjs_require__(28);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;
var DOMIterables = {
  CSSRuleList: true,
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true,
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true,
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};
for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) {
      if (!proto[key]) redefine(proto, key, $iterators[key], true);
    }
  }
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var addToUnscopables = __w_pdfjs_require__(41);
var step = __w_pdfjs_require__(74);
var Iterators = __w_pdfjs_require__(65);
var toIObject = __w_pdfjs_require__(36);
module.exports = __w_pdfjs_require__(64)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated);
  this._i = 0;
  this._k = kind;
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');
Iterators.Arguments = Iterators.Array;
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 74 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (done, value) {
  return {
    value: value,
    done: !!done
  };
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var LIBRARY = __w_pdfjs_require__(30);
var global = __w_pdfjs_require__(8);
var ctx = __w_pdfjs_require__(23);
var classof = __w_pdfjs_require__(61);
var $export = __w_pdfjs_require__(7);
var isObject = __w_pdfjs_require__(13);
var aFunction = __w_pdfjs_require__(24);
var anInstance = __w_pdfjs_require__(76);
var forOf = __w_pdfjs_require__(77);
var speciesConstructor = __w_pdfjs_require__(81);
var task = __w_pdfjs_require__(82).set;
var microtask = __w_pdfjs_require__(84)();
var newPromiseCapabilityModule = __w_pdfjs_require__(85);
var perform = __w_pdfjs_require__(86);
var userAgent = __w_pdfjs_require__(87);
var promiseResolve = __w_pdfjs_require__(88);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function empty() {};
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
var USE_NATIVE = !!function () {
  try {
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__w_pdfjs_require__(28)('species')] = function (exec) {
      exec(empty, empty);
    };
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) {}
}();
var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) {
      run(chain[i++]);
    }promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function onUnhandled(promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({
            promise: promise,
            reason: value
          });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    }
    promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function isUnhandled(promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({
        promise: promise,
        reason: promise._v
      });
    }
  });
};
var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise;
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function $resolve(value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise;
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = {
          _w: promise,
          _d: false
        };
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({
      _w: promise,
      _d: false
    }, e);
  }
};
if (!USE_NATIVE) {
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor) {
    this._c = [];
    this._a = undefined;
    this._s = 0;
    this._d = false;
    this._v = undefined;
    this._h = 0;
    this._n = false;
  };
  Internal.prototype = __w_pdfjs_require__(89)($Promise.prototype, {
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
}
$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__w_pdfjs_require__(70)($Promise, PROMISE);
__w_pdfjs_require__(90)(PROMISE);
Wrapper = __w_pdfjs_require__(9)[PROMISE];
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __w_pdfjs_require__(91)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

/***/ }),
/* 76 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }
  return it;
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ctx = __w_pdfjs_require__(23);
var call = __w_pdfjs_require__(78);
var isArrayIter = __w_pdfjs_require__(79);
var anObject = __w_pdfjs_require__(12);
var toLength = __w_pdfjs_require__(38);
var getIterFn = __w_pdfjs_require__(80);
var BREAK = {};
var RETURN = {};
var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () {
    return iterable;
  } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
_exports.BREAK = BREAK;
_exports.RETURN = RETURN;

/***/ }),
/* 78 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(12);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var Iterators = __w_pdfjs_require__(65);
var ITERATOR = __w_pdfjs_require__(28)('iterator');
var ArrayProto = Array.prototype;
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var classof = __w_pdfjs_require__(61);
var ITERATOR = __w_pdfjs_require__(28)('iterator');
var Iterators = __w_pdfjs_require__(65);
module.exports = __w_pdfjs_require__(9).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(12);
var aFunction = __w_pdfjs_require__(24);
var SPECIES = __w_pdfjs_require__(28)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ctx = __w_pdfjs_require__(23);
var invoke = __w_pdfjs_require__(83);
var html = __w_pdfjs_require__(69);
var cel = __w_pdfjs_require__(17);
var global = __w_pdfjs_require__(8);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function run() {
  var id = +this;
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function listener(event) {
  run.call(event.data);
};
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }queue[++counter] = function () {
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  if (__w_pdfjs_require__(27)(process) == 'process') {
    defer = function defer(id) {
      process.nextTick(ctx(run, id, 1));
    };
  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(ctx(run, id, 1));
    };
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function defer(id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function defer(id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  } else {
    defer = function defer(id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0:
      return un ? fn() : fn.call(that);
    case 1:
      return un ? fn(args[0]) : fn.call(that, args[0]);
    case 2:
      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
    case 3:
      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
    case 4:
      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
  }
  return fn.apply(that, args);
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);
var macrotask = __w_pdfjs_require__(82).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __w_pdfjs_require__(27)(process) == 'process';
module.exports = function () {
  var head, last, notify;
  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }
    last = undefined;
    if (parent) parent.enter();
  };
  if (isNode) {
    notify = function notify() {
      process.nextTick(flush);
    };
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true });
    notify = function notify() {
      node.data = toggle = !toggle;
    };
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve(undefined);
    notify = function notify() {
      promise.then(flush);
    };
  } else {
    notify = function notify() {
      macrotask.call(global, flush);
    };
  }
  return function (fn) {
    var task = {
      fn: fn,
      next: undefined
    };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }
    last = task;
  };
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var aFunction = __w_pdfjs_require__(24);
function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}
module.exports.f = function (C) {
  return new PromiseCapability(C);
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (exec) {
  try {
    return {
      e: false,
      v: exec()
    };
  } catch (e) {
    return {
      e: true,
      v: e
    };
  }
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);
var navigator = global.navigator;
module.exports = navigator && navigator.userAgent || '';

/***/ }),
/* 88 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(12);
var isObject = __w_pdfjs_require__(13);
var newPromiseCapability = __w_pdfjs_require__(85);
module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var redefine = __w_pdfjs_require__(20);
module.exports = function (target, src, safe) {
  for (var key in src) {
    redefine(target, key, src[key], safe);
  }return target;
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);
var dP = __w_pdfjs_require__(11);
var DESCRIPTORS = __w_pdfjs_require__(15);
var SPECIES = __w_pdfjs_require__(28)('species');
module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ITERATOR = __w_pdfjs_require__(28)('iterator');
var SAFE_CLOSING = false;
try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {}
module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {}
  return safe;
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
var core = __w_pdfjs_require__(9);
var global = __w_pdfjs_require__(8);
var speciesConstructor = __w_pdfjs_require__(81);
var promiseResolve = __w_pdfjs_require__(88);
$export($export.P + $export.R, 'Promise', {
  'finally': function _finally(onFinally) {
    var C = speciesConstructor(this, core.Promise || global.Promise);
    var isFunction = typeof onFinally == 'function';
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
var newPromiseCapability = __w_pdfjs_require__(85);
var perform = __w_pdfjs_require__(86);
$export($export.S, 'Promise', {
  'try': function _try(callbackfn) {
    var promiseCapability = newPromiseCapability.f(this);
    var result = perform(callbackfn);
    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
    return promiseCapability.promise;
  }
});

/***/ }),
/* 94 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(60);
__w_pdfjs_require__(72);
__w_pdfjs_require__(95);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
module.exports = __w_pdfjs_require__(9).WeakMap;

/***/ }),
/* 95 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var each = __w_pdfjs_require__(96)(0);
var redefine = __w_pdfjs_require__(20);
var meta = __w_pdfjs_require__(100);
var assign = __w_pdfjs_require__(44);
var weak = __w_pdfjs_require__(101);
var isObject = __w_pdfjs_require__(13);
var fails = __w_pdfjs_require__(16);
var validate = __w_pdfjs_require__(102);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;
var wrapper = function wrapper(get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};
var methods = {
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};
var $WeakMap = module.exports = __w_pdfjs_require__(103)(WEAK_MAP, wrapper, methods, weak, true, true);
if (fails(function () {
  return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
})) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      }
      return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 96 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ctx = __w_pdfjs_require__(23);
var IObject = __w_pdfjs_require__(37);
var toObject = __w_pdfjs_require__(51);
var toLength = __w_pdfjs_require__(38);
var asc = __w_pdfjs_require__(97);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res;else if (res) switch (TYPE) {
            case 3:
              return true;
            case 5:
              return val;
            case 6:
              return index;
            case 2:
              result.push(val);
          } else if (IS_EVERY) return false;
        }
      }
    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var speciesConstructor = __w_pdfjs_require__(98);
module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);
var isArray = __w_pdfjs_require__(99);
var SPECIES = __w_pdfjs_require__(28)('species');
module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }
  return C === undefined ? Array : C;
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var cof = __w_pdfjs_require__(27);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var META = __w_pdfjs_require__(22)('meta');
var isObject = __w_pdfjs_require__(13);
var has = __w_pdfjs_require__(21);
var setDesc = __w_pdfjs_require__(11).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__w_pdfjs_require__(16)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, {
    value: {
      i: 'O' + ++id,
      w: {}
    }
  });
};
var fastKey = function fastKey(it, create) {
  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    if (!isExtensible(it)) return 'F';
    if (!create) return 'E';
    setMeta(it);
  }
  return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    if (!isExtensible(it)) return true;
    if (!create) return false;
    setMeta(it);
  }
  return it[META].w;
};
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var redefineAll = __w_pdfjs_require__(89);
var getWeak = __w_pdfjs_require__(100).getWeak;
var anObject = __w_pdfjs_require__(12);
var isObject = __w_pdfjs_require__(13);
var anInstance = __w_pdfjs_require__(76);
var forOf = __w_pdfjs_require__(77);
var createArrayMethod = __w_pdfjs_require__(96);
var $has = __w_pdfjs_require__(21);
var validate = __w_pdfjs_require__(102);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;
var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function UncaughtFrozenStore() {
  this.a = [];
};
var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function get(key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function has(key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function set(key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;else this.a.push([key, value]);
  },
  'delete': function _delete(key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};
module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;
      that._i = id++;
      that._l = undefined;
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      'delete': function _delete(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);
var $export = __w_pdfjs_require__(7);
var redefine = __w_pdfjs_require__(20);
var redefineAll = __w_pdfjs_require__(89);
var meta = __w_pdfjs_require__(100);
var forOf = __w_pdfjs_require__(77);
var anInstance = __w_pdfjs_require__(76);
var isObject = __w_pdfjs_require__(13);
var fails = __w_pdfjs_require__(16);
var $iterDetect = __w_pdfjs_require__(91);
var setToStringTag = __w_pdfjs_require__(70);
var inheritIfRequired = __w_pdfjs_require__(104);
module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function fixMethod(KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY, KEY == 'delete' ? function (a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'has' ? function has(a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'get' ? function get(a) {
      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'add' ? function add(a) {
      fn.call(this, a === 0 ? 0 : a);
      return this;
    } : function set(a, b) {
      fn.call(this, a === 0 ? 0 : a, b);
      return this;
    });
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    var THROWS_ON_PRIMITIVES = fails(function () {
      instance.has(1);
    });
    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
      new C(iter);
    });
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      var $instance = new C();
      var index = 5;
      while (index--) {
        $instance[ADDER](index, index);
      }return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    if (IS_WEAK && proto.clear) delete proto.clear;
  }
  setToStringTag(C, NAME);
  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);
  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
  return C;
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);
var setPrototypeOf = __w_pdfjs_require__(105).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  }
  return that;
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);
var anObject = __w_pdfjs_require__(12);
var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? function (test, buggy, set) {
    try {
      set = __w_pdfjs_require__(23)(Function.call, __w_pdfjs_require__(106).f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pIE = __w_pdfjs_require__(50);
var createDesc = __w_pdfjs_require__(19);
var toIObject = __w_pdfjs_require__(36);
var toPrimitive = __w_pdfjs_require__(18);
var has = __w_pdfjs_require__(21);
var IE8_DOM_DEFINE = __w_pdfjs_require__(14);
var gOPD = Object.getOwnPropertyDescriptor;
exports.f = __w_pdfjs_require__(15) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(108)('WeakMap');

/***/ }),
/* 108 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, {
    of: function of() {
      var length = arguments.length;
      var A = new Array(length);
      while (length--) {
        A[length] = arguments[length];
      }return new this(A);
    }
  });
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(110)('WeakMap');

/***/ }),
/* 110 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
var aFunction = __w_pdfjs_require__(24);
var ctx = __w_pdfjs_require__(23);
var forOf = __w_pdfjs_require__(77);
module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, {
    from: function from(source) {
      var mapFn = arguments[1];
      var mapping, A, n, cb;
      aFunction(this);
      mapping = mapFn !== undefined;
      if (mapping) aFunction(mapFn);
      if (source == undefined) return new this();
      A = [];
      if (mapping) {
        n = 0;
        cb = ctx(mapFn, arguments[2], 2);
        forOf(source, false, function (nextItem) {
          A.push(cb(nextItem, n++));
        });
      } else {
        forOf(source, false, A.push, A);
      }
      return new this(A);
    }
  });
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(112);
module.exports = __w_pdfjs_require__(9).String.codePointAt;

/***/ }),
/* 112 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
var $at = __w_pdfjs_require__(63)(false);
$export($export.P, 'String', {
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(114);
module.exports = __w_pdfjs_require__(9).String.fromCodePoint;

/***/ }),
/* 114 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
var toAbsoluteIndex = __w_pdfjs_require__(40);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  fromCodePoint: function fromCodePoint(x) {
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
    }
    return res.join('');
  }
});

/***/ }),
/* 115 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(116);
__w_pdfjs_require__(60);
module.exports = __w_pdfjs_require__(9).Symbol;

/***/ }),
/* 116 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var global = __w_pdfjs_require__(8);
var has = __w_pdfjs_require__(21);
var DESCRIPTORS = __w_pdfjs_require__(15);
var $export = __w_pdfjs_require__(7);
var redefine = __w_pdfjs_require__(20);
var META = __w_pdfjs_require__(100).KEY;
var $fails = __w_pdfjs_require__(16);
var shared = __w_pdfjs_require__(29);
var setToStringTag = __w_pdfjs_require__(70);
var uid = __w_pdfjs_require__(22);
var wks = __w_pdfjs_require__(28);
var wksExt = __w_pdfjs_require__(117);
var wksDefine = __w_pdfjs_require__(118);
var enumKeys = __w_pdfjs_require__(119);
var isArray = __w_pdfjs_require__(99);
var anObject = __w_pdfjs_require__(12);
var isObject = __w_pdfjs_require__(13);
var toIObject = __w_pdfjs_require__(36);
var toPrimitive = __w_pdfjs_require__(18);
var createDesc = __w_pdfjs_require__(19);
var _create = __w_pdfjs_require__(67);
var gOPNExt = __w_pdfjs_require__(120);
var $GOPD = __w_pdfjs_require__(106);
var $DP = __w_pdfjs_require__(11);
var $keys = __w_pdfjs_require__(45);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;
var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};
var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};
var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }
    return setSymbolDesc(it, key, D);
  }
  return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }
  return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }
  return result;
};
if (!USE_NATIVE) {
  $Symbol = function _Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
      configurable: true,
      set: $set
    });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });
  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __w_pdfjs_require__(121).f = gOPNExt.f = $getOwnPropertyNames;
  __w_pdfjs_require__(50).f = $propertyIsEnumerable;
  __w_pdfjs_require__(49).f = $getOwnPropertySymbols;
  if (DESCRIPTORS && !__w_pdfjs_require__(30)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }
  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}
$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
for (var es6Symbols = 'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});
$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  create: $create,
  defineProperty: $defineProperty,
  defineProperties: $defineProperties,
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  getOwnPropertyNames: $getOwnPropertyNames,
  getOwnPropertySymbols: $getOwnPropertySymbols
});
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }$replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return;
    if (!isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __w_pdfjs_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
setToStringTag($Symbol, 'Symbol');
setToStringTag(Math, 'Math', true);
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 117 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


exports.f = __w_pdfjs_require__(28);

/***/ }),
/* 118 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);
var core = __w_pdfjs_require__(9);
var LIBRARY = __w_pdfjs_require__(30);
var wksExt = __w_pdfjs_require__(117);
var defineProperty = __w_pdfjs_require__(11).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var getKeys = __w_pdfjs_require__(45);
var gOPS = __w_pdfjs_require__(49);
var pIE = __w_pdfjs_require__(50);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }
  return result;
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var toIObject = __w_pdfjs_require__(36);
var gOPN = __w_pdfjs_require__(121).f;
var toString = {}.toString;
var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),
/* 121 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $keys = __w_pdfjs_require__(46);
var hiddenKeys = __w_pdfjs_require__(48).concat('length', 'prototype');
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(123);
module.exports = __w_pdfjs_require__(9).Object.values;

/***/ }),
/* 123 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);
var $values = __w_pdfjs_require__(124)(false);
$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var getKeys = __w_pdfjs_require__(45);
var toIObject = __w_pdfjs_require__(36);
var isEnum = __w_pdfjs_require__(50).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      if (isEnum.call(O, key = keys[i++])) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }return result;
  };
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isReadableStreamSupported = false;
if (typeof ReadableStream !== 'undefined') {
  try {
    new ReadableStream({
      start: function start(controller) {
        controller.close();
      }
    });
    isReadableStreamSupported = true;
  } catch (e) {}
}
if (isReadableStreamSupported) {
  exports.ReadableStream = ReadableStream;
} else {
  exports.ReadableStream = __w_pdfjs_require__(126).ReadableStream;
}

/***/ }),
/* 126 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports, function (modules) {
  var installedModules = {};
  function __w_pdfjs_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: false,
      exports: {}
    };
    modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
    module.l = true;
    return module.exports;
  }
  __w_pdfjs_require__.m = modules;
  __w_pdfjs_require__.c = installedModules;
  __w_pdfjs_require__.i = function (value) {
    return value;
  };
  __w_pdfjs_require__.d = function (exports, name, getter) {
    if (!__w_pdfjs_require__.o(exports, name)) {
      Object.defineProperty(exports, name, {
        configurable: false,
        enumerable: true,
        get: getter
      });
    }
  };
  __w_pdfjs_require__.n = function (module) {
    var getter = module && module.__esModule ? function getDefault() {
      return module['default'];
    } : function getModuleExports() {
      return module;
    };
    __w_pdfjs_require__.d(getter, 'a', getter);
    return getter;
  };
  __w_pdfjs_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  __w_pdfjs_require__.p = "";
  return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
}([function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  };
  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;
  function IsPropertyKey(argument) {
    return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
  }
  exports.typeIsObject = function (x) {
    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
  };
  exports.createDataProperty = function (o, p, v) {
    assert(exports.typeIsObject(o));
    Object.defineProperty(o, p, {
      value: v,
      writable: true,
      enumerable: true,
      configurable: true
    });
  };
  exports.createArrayFromList = function (elements) {
    return elements.slice();
  };
  exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
    new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
  };
  exports.CreateIterResultObject = function (value, done) {
    assert(typeof done === 'boolean');
    var obj = {};
    Object.defineProperty(obj, 'value', {
      value: value,
      enumerable: true,
      writable: true,
      configurable: true
    });
    Object.defineProperty(obj, 'done', {
      value: done,
      enumerable: true,
      writable: true,
      configurable: true
    });
    return obj;
  };
  exports.IsFiniteNonNegativeNumber = function (v) {
    if (Number.isNaN(v)) {
      return false;
    }
    if (v === Infinity) {
      return false;
    }
    if (v < 0) {
      return false;
    }
    return true;
  };
  function Call(F, V, args) {
    if (typeof F !== 'function') {
      throw new TypeError('Argument is not a function');
    }
    return Function.prototype.apply.call(F, V, args);
  }
  exports.InvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    var method = O[P];
    if (method === undefined) {
      return undefined;
    }
    return Call(method, O, args);
  };
  exports.PromiseInvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    try {
      return Promise.resolve(exports.InvokeOrNoop(O, P, args));
    } catch (returnValueE) {
      return Promise.reject(returnValueE);
    }
  };
  exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    assert(Array.isArray(argsF));
    var method = void 0;
    try {
      method = O[P];
    } catch (methodE) {
      return Promise.reject(methodE);
    }
    if (method === undefined) {
      return F.apply(null, argsF);
    }
    try {
      return Promise.resolve(Call(method, O, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  exports.TransferArrayBuffer = function (O) {
    return O.slice();
  };
  exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
    highWaterMark = Number(highWaterMark);
    if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
      throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
    }
    return highWaterMark;
  };
  exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
    if (size !== undefined && typeof size !== 'function') {
      throw new TypeError('size property of a queuing strategy must be a function');
    }
    highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
    return {
      size: size,
      highWaterMark: highWaterMark
    };
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  function rethrowAssertionErrorRejection(e) {
    if (e && e.constructor === AssertionError) {
      setTimeout(function () {
        throw e;
      }, 0);
    }
  }
  function AssertionError(message) {
    this.name = 'AssertionError';
    this.message = message || '';
    this.stack = new Error().stack;
  }
  AssertionError.prototype = Object.create(Error.prototype);
  AssertionError.prototype.constructor = AssertionError;
  function assert(value, message) {
    if (!value) {
      throw new AssertionError(message);
    }
  }
  module.exports = {
    rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
    AssertionError: AssertionError,
    assert: assert
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(0),
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      typeIsObject = _require.typeIsObject;
  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert,
      rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
  var _require3 = __w_pdfjs_require__(3),
      DequeueValue = _require3.DequeueValue,
      EnqueueValueWithSize = _require3.EnqueueValueWithSize,
      PeekQueueValue = _require3.PeekQueueValue,
      ResetQueue = _require3.ResetQueue;
  var WritableStream = function () {
    function WritableStream() {
      var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          _ref$highWaterMark = _ref.highWaterMark,
          highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
      _classCallCheck(this, WritableStream);
      this._state = 'writable';
      this._storedError = undefined;
      this._writer = undefined;
      this._writableStreamController = undefined;
      this._writeRequests = [];
      this._inFlightWriteRequest = undefined;
      this._closeRequest = undefined;
      this._inFlightCloseRequest = undefined;
      this._pendingAbortRequest = undefined;
      this._backpressure = false;
      var type = underlyingSink.type;
      if (type !== undefined) {
        throw new RangeError('Invalid type is specified');
      }
      this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
      this._writableStreamController.__startSteps();
    }
    _createClass(WritableStream, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('abort'));
        }
        if (IsWritableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
        }
        return WritableStreamAbort(this, reason);
      }
    }, {
      key: 'getWriter',
      value: function getWriter() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('getWriter');
        }
        return AcquireWritableStreamDefaultWriter(this);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }
        return IsWritableStreamLocked(this);
      }
    }]);
    return WritableStream;
  }();
  module.exports = {
    AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
    IsWritableStream: IsWritableStream,
    IsWritableStreamLocked: IsWritableStreamLocked,
    WritableStream: WritableStream,
    WritableStreamAbort: WritableStreamAbort,
    WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
    WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
    WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
    WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
    WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
  };
  function AcquireWritableStreamDefaultWriter(stream) {
    return new WritableStreamDefaultWriter(stream);
  }
  function IsWritableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
      return false;
    }
    return true;
  }
  function IsWritableStreamLocked(stream) {
    assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');
    if (stream._writer === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamAbort(stream, reason) {
    var state = stream._state;
    if (state === 'closed') {
      return Promise.resolve(undefined);
    }
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    var error = new TypeError('Requested to abort');
    if (stream._pendingAbortRequest !== undefined) {
      return Promise.reject(error);
    }
    assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');
    var wasAlreadyErroring = false;
    if (state === 'erroring') {
      wasAlreadyErroring = true;
      reason = undefined;
    }
    var promise = new Promise(function (resolve, reject) {
      stream._pendingAbortRequest = {
        _resolve: resolve,
        _reject: reject,
        _reason: reason,
        _wasAlreadyErroring: wasAlreadyErroring
      };
    });
    if (wasAlreadyErroring === false) {
      WritableStreamStartErroring(stream, error);
    }
    return promise;
  }
  function WritableStreamAddWriteRequest(stream) {
    assert(IsWritableStreamLocked(stream) === true);
    assert(stream._state === 'writable');
    var promise = new Promise(function (resolve, reject) {
      var writeRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._writeRequests.push(writeRequest);
    });
    return promise;
  }
  function WritableStreamDealWithRejection(stream, error) {
    var state = stream._state;
    if (state === 'writable') {
      WritableStreamStartErroring(stream, error);
      return;
    }
    assert(state === 'erroring');
    WritableStreamFinishErroring(stream);
  }
  function WritableStreamStartErroring(stream, reason) {
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
    assert(stream._state === 'writable', 'state must be writable');
    var controller = stream._writableStreamController;
    assert(controller !== undefined, 'controller must not be undefined');
    stream._state = 'erroring';
    stream._storedError = reason;
    var writer = stream._writer;
    if (writer !== undefined) {
      WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
    }
    if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
      WritableStreamFinishErroring(stream);
    }
  }
  function WritableStreamFinishErroring(stream) {
    assert(stream._state === 'erroring', 'stream._state === erroring');
    assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
    stream._state = 'errored';
    stream._writableStreamController.__errorSteps();
    var storedError = stream._storedError;
    for (var i = 0; i < stream._writeRequests.length; i++) {
      var writeRequest = stream._writeRequests[i];
      writeRequest._reject(storedError);
    }
    stream._writeRequests = [];
    if (stream._pendingAbortRequest === undefined) {
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }
    var abortRequest = stream._pendingAbortRequest;
    stream._pendingAbortRequest = undefined;
    if (abortRequest._wasAlreadyErroring === true) {
      abortRequest._reject(storedError);
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }
    var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
    promise.then(function () {
      abortRequest._resolve();
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    }, function (reason) {
      abortRequest._reject(reason);
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    });
  }
  function WritableStreamFinishInFlightWrite(stream) {
    assert(stream._inFlightWriteRequest !== undefined);
    stream._inFlightWriteRequest._resolve(undefined);
    stream._inFlightWriteRequest = undefined;
  }
  function WritableStreamFinishInFlightWriteWithError(stream, error) {
    assert(stream._inFlightWriteRequest !== undefined);
    stream._inFlightWriteRequest._reject(error);
    stream._inFlightWriteRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');
    WritableStreamDealWithRejection(stream, error);
  }
  function WritableStreamFinishInFlightClose(stream) {
    assert(stream._inFlightCloseRequest !== undefined);
    stream._inFlightCloseRequest._resolve(undefined);
    stream._inFlightCloseRequest = undefined;
    var state = stream._state;
    assert(state === 'writable' || state === 'erroring');
    if (state === 'erroring') {
      stream._storedError = undefined;
      if (stream._pendingAbortRequest !== undefined) {
        stream._pendingAbortRequest._resolve();
        stream._pendingAbortRequest = undefined;
      }
    }
    stream._state = 'closed';
    var writer = stream._writer;
    if (writer !== undefined) {
      defaultWriterClosedPromiseResolve(writer);
    }
    assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
  }
  function WritableStreamFinishInFlightCloseWithError(stream, error) {
    assert(stream._inFlightCloseRequest !== undefined);
    stream._inFlightCloseRequest._reject(error);
    stream._inFlightCloseRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');
    if (stream._pendingAbortRequest !== undefined) {
      stream._pendingAbortRequest._reject(error);
      stream._pendingAbortRequest = undefined;
    }
    WritableStreamDealWithRejection(stream, error);
  }
  function WritableStreamCloseQueuedOrInFlight(stream) {
    if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamHasOperationMarkedInFlight(stream) {
    if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamMarkCloseRequestInFlight(stream) {
    assert(stream._inFlightCloseRequest === undefined);
    assert(stream._closeRequest !== undefined);
    stream._inFlightCloseRequest = stream._closeRequest;
    stream._closeRequest = undefined;
  }
  function WritableStreamMarkFirstWriteRequestInFlight(stream) {
    assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
    assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
    stream._inFlightWriteRequest = stream._writeRequests.shift();
  }
  function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
    assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');
    if (stream._closeRequest !== undefined) {
      assert(stream._inFlightCloseRequest === undefined);
      stream._closeRequest._reject(stream._storedError);
      stream._closeRequest = undefined;
    }
    var writer = stream._writer;
    if (writer !== undefined) {
      defaultWriterClosedPromiseReject(writer, stream._storedError);
      writer._closedPromise.catch(function () {});
    }
  }
  function WritableStreamUpdateBackpressure(stream, backpressure) {
    assert(stream._state === 'writable');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var writer = stream._writer;
    if (writer !== undefined && backpressure !== stream._backpressure) {
      if (backpressure === true) {
        defaultWriterReadyPromiseReset(writer);
      } else {
        assert(backpressure === false);
        defaultWriterReadyPromiseResolve(writer);
      }
    }
    stream._backpressure = backpressure;
  }
  var WritableStreamDefaultWriter = function () {
    function WritableStreamDefaultWriter(stream) {
      _classCallCheck(this, WritableStreamDefaultWriter);
      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
      }
      if (IsWritableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive writing by another writer');
      }
      this._ownerWritableStream = stream;
      stream._writer = this;
      var state = stream._state;
      if (state === 'writable') {
        if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
          defaultWriterReadyPromiseInitialize(this);
        } else {
          defaultWriterReadyPromiseInitializeAsResolved(this);
        }
        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'erroring') {
        defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
        this._readyPromise.catch(function () {});
        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'closed') {
        defaultWriterReadyPromiseInitializeAsResolved(this);
        defaultWriterClosedPromiseInitializeAsResolved(this);
      } else {
        assert(state === 'errored', 'state must be errored');
        var storedError = stream._storedError;
        defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
        this._readyPromise.catch(function () {});
        defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
        this._closedPromise.catch(function () {});
      }
    }
    _createClass(WritableStreamDefaultWriter, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('abort'));
        }
        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('abort'));
        }
        return WritableStreamDefaultWriterAbort(this, reason);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('close'));
        }
        var stream = this._ownerWritableStream;
        if (stream === undefined) {
          return Promise.reject(defaultWriterLockException('close'));
        }
        if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
          return Promise.reject(new TypeError('cannot close an already-closing stream'));
        }
        return WritableStreamDefaultWriterClose(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('releaseLock');
        }
        var stream = this._ownerWritableStream;
        if (stream === undefined) {
          return;
        }
        assert(stream._writer !== undefined);
        WritableStreamDefaultWriterRelease(this);
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('write'));
        }
        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('write to'));
        }
        return WritableStreamDefaultWriterWrite(this, chunk);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('desiredSize');
        }
        if (this._ownerWritableStream === undefined) {
          throw defaultWriterLockException('desiredSize');
        }
        return WritableStreamDefaultWriterGetDesiredSize(this);
      }
    }, {
      key: 'ready',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('ready'));
        }
        return this._readyPromise;
      }
    }]);
    return WritableStreamDefaultWriter;
  }();
  function IsWritableStreamDefaultWriter(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
      return false;
    }
    return true;
  }
  function WritableStreamDefaultWriterAbort(writer, reason) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    return WritableStreamAbort(stream, reason);
  }
  function WritableStreamDefaultWriterClose(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;
    if (state === 'closed' || state === 'errored') {
      return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
    }
    assert(state === 'writable' || state === 'erroring');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var promise = new Promise(function (resolve, reject) {
      var closeRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._closeRequest = closeRequest;
    });
    if (stream._backpressure === true && state === 'writable') {
      defaultWriterReadyPromiseResolve(writer);
    }
    WritableStreamDefaultControllerClose(stream._writableStreamController);
    return promise;
  }
  function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;
    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.resolve();
    }
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    assert(state === 'writable' || state === 'erroring');
    return WritableStreamDefaultWriterClose(writer);
  }
  function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
    if (writer._closedPromiseState === 'pending') {
      defaultWriterClosedPromiseReject(writer, error);
    } else {
      defaultWriterClosedPromiseResetToRejected(writer, error);
    }
    writer._closedPromise.catch(function () {});
  }
  function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
    if (writer._readyPromiseState === 'pending') {
      defaultWriterReadyPromiseReject(writer, error);
    } else {
      defaultWriterReadyPromiseResetToRejected(writer, error);
    }
    writer._readyPromise.catch(function () {});
  }
  function WritableStreamDefaultWriterGetDesiredSize(writer) {
    var stream = writer._ownerWritableStream;
    var state = stream._state;
    if (state === 'errored' || state === 'erroring') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
  }
  function WritableStreamDefaultWriterRelease(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    assert(stream._writer === writer);
    var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
    WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
    stream._writer = undefined;
    writer._ownerWritableStream = undefined;
  }
  function WritableStreamDefaultWriterWrite(writer, chunk) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var controller = stream._writableStreamController;
    var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
    if (stream !== writer._ownerWritableStream) {
      return Promise.reject(defaultWriterLockException('write to'));
    }
    var state = stream._state;
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
    }
    if (state === 'erroring') {
      return Promise.reject(stream._storedError);
    }
    assert(state === 'writable');
    var promise = WritableStreamAddWriteRequest(stream);
    WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
    return promise;
  }
  var WritableStreamDefaultController = function () {
    function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
      _classCallCheck(this, WritableStreamDefaultController);
      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
      }
      if (stream._writableStreamController !== undefined) {
        throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
      }
      this._controlledWritableStream = stream;
      this._underlyingSink = underlyingSink;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }
    _createClass(WritableStreamDefaultController, [{
      key: 'error',
      value: function error(e) {
        if (IsWritableStreamDefaultController(this) === false) {
          throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
        }
        var state = this._controlledWritableStream._state;
        if (state !== 'writable') {
          return;
        }
        WritableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__abortSteps',
      value: function __abortSteps(reason) {
        return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
      }
    }, {
      key: '__errorSteps',
      value: function __errorSteps() {
        ResetQueue(this);
      }
    }, {
      key: '__startSteps',
      value: function __startSteps() {
        var _this = this;
        var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
        var stream = this._controlledWritableStream;
        Promise.resolve(startResult).then(function () {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
        }, function (r) {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDealWithRejection(stream, r);
        }).catch(rethrowAssertionErrorRejection);
      }
    }]);
    return WritableStreamDefaultController;
  }();
  function WritableStreamDefaultControllerClose(controller) {
    EnqueueValueWithSize(controller, 'close', 0);
    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }
  function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
    var strategySize = controller._strategySize;
    if (strategySize === undefined) {
      return 1;
    }
    try {
      return strategySize(chunk);
    } catch (chunkSizeE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
      return 1;
    }
  }
  function WritableStreamDefaultControllerGetDesiredSize(controller) {
    return controller._strategyHWM - controller._queueTotalSize;
  }
  function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
    var writeRecord = { chunk: chunk };
    try {
      EnqueueValueWithSize(controller, writeRecord, chunkSize);
    } catch (enqueueE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
      return;
    }
    var stream = controller._controlledWritableStream;
    if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }
    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }
  function IsWritableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
      return false;
    }
    return true;
  }
  function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
    var stream = controller._controlledWritableStream;
    if (controller._started === false) {
      return;
    }
    if (stream._inFlightWriteRequest !== undefined) {
      return;
    }
    var state = stream._state;
    if (state === 'closed' || state === 'errored') {
      return;
    }
    if (state === 'erroring') {
      WritableStreamFinishErroring(stream);
      return;
    }
    if (controller._queue.length === 0) {
      return;
    }
    var writeRecord = PeekQueueValue(controller);
    if (writeRecord === 'close') {
      WritableStreamDefaultControllerProcessClose(controller);
    } else {
      WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
    }
  }
  function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
    if (controller._controlledWritableStream._state === 'writable') {
      WritableStreamDefaultControllerError(controller, error);
    }
  }
  function WritableStreamDefaultControllerProcessClose(controller) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkCloseRequestInFlight(stream);
    DequeueValue(controller);
    assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');
    var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
    sinkClosePromise.then(function () {
      WritableStreamFinishInFlightClose(stream);
    }, function (reason) {
      WritableStreamFinishInFlightCloseWithError(stream, reason);
    }).catch(rethrowAssertionErrorRejection);
  }
  function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkFirstWriteRequestInFlight(stream);
    var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
    sinkWritePromise.then(function () {
      WritableStreamFinishInFlightWrite(stream);
      var state = stream._state;
      assert(state === 'writable' || state === 'erroring');
      DequeueValue(controller);
      if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
        WritableStreamUpdateBackpressure(stream, backpressure);
      }
      WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
    }, function (reason) {
      WritableStreamFinishInFlightWriteWithError(stream, reason);
    }).catch(rethrowAssertionErrorRejection);
  }
  function WritableStreamDefaultControllerGetBackpressure(controller) {
    var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
    return desiredSize <= 0;
  }
  function WritableStreamDefaultControllerError(controller, error) {
    var stream = controller._controlledWritableStream;
    assert(stream._state === 'writable');
    WritableStreamStartErroring(stream, error);
  }
  function streamBrandCheckException(name) {
    return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
  }
  function defaultWriterBrandCheckException(name) {
    return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
  }
  function defaultWriterLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released writer');
  }
  function defaultWriterClosedPromiseInitialize(writer) {
    writer._closedPromise = new Promise(function (resolve, reject) {
      writer._closedPromise_resolve = resolve;
      writer._closedPromise_reject = reject;
      writer._closedPromiseState = 'pending';
    });
  }
  function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseInitializeAsResolved(writer) {
    writer._closedPromise = Promise.resolve(undefined);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }
  function defaultWriterClosedPromiseReject(writer, reason) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
    writer._closedPromise_reject(reason);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseResetToRejected(writer, reason) {
    assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
    assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
    assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseResolve(writer) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
    writer._closedPromise_resolve(undefined);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }
  function defaultWriterReadyPromiseInitialize(writer) {
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }
  function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseInitializeAsResolved(writer) {
    writer._readyPromise = Promise.resolve(undefined);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }
  function defaultWriterReadyPromiseReject(writer, reason) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
    writer._readyPromise_reject(reason);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseReset(writer) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }
  function defaultWriterReadyPromiseResetToRejected(writer, reason) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseResolve(writer) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
    writer._readyPromise_resolve(undefined);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _require = __w_pdfjs_require__(0),
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert;
  exports.DequeueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');
    var pair = container._queue.shift();
    container._queueTotalSize -= pair.size;
    if (container._queueTotalSize < 0) {
      container._queueTotalSize = 0;
    }
    return pair.value;
  };
  exports.EnqueueValueWithSize = function (container, value, size) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');
    size = Number(size);
    if (!IsFiniteNonNegativeNumber(size)) {
      throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
    }
    container._queue.push({
      value: value,
      size: size
    });
    container._queueTotalSize += size;
  };
  exports.PeekQueueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');
    var pair = container._queue[0];
    return pair.value;
  };
  exports.ResetQueue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    container._queue = [];
    container._queueTotalSize = 0;
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(0),
      ArrayBufferCopy = _require.ArrayBufferCopy,
      CreateIterResultObject = _require.CreateIterResultObject,
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      TransferArrayBuffer = _require.TransferArrayBuffer,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
  var _require2 = __w_pdfjs_require__(0),
      createArrayFromList = _require2.createArrayFromList,
      createDataProperty = _require2.createDataProperty,
      typeIsObject = _require2.typeIsObject;
  var _require3 = __w_pdfjs_require__(1),
      assert = _require3.assert,
      rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
  var _require4 = __w_pdfjs_require__(3),
      DequeueValue = _require4.DequeueValue,
      EnqueueValueWithSize = _require4.EnqueueValueWithSize,
      ResetQueue = _require4.ResetQueue;
  var _require5 = __w_pdfjs_require__(2),
      AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
      IsWritableStream = _require5.IsWritableStream,
      IsWritableStreamLocked = _require5.IsWritableStreamLocked,
      WritableStreamAbort = _require5.WritableStreamAbort,
      WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
      WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
      WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
      WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
  var ReadableStream = function () {
    function ReadableStream() {
      var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          highWaterMark = _ref.highWaterMark;
      _classCallCheck(this, ReadableStream);
      this._state = 'readable';
      this._reader = undefined;
      this._storedError = undefined;
      this._disturbed = false;
      this._readableStreamController = undefined;
      var type = underlyingSource.type;
      var typeString = String(type);
      if (typeString === 'bytes') {
        if (highWaterMark === undefined) {
          highWaterMark = 0;
        }
        this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
      } else if (type === undefined) {
        if (highWaterMark === undefined) {
          highWaterMark = 1;
        }
        this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
      } else {
        throw new RangeError('Invalid type is specified');
      }
    }
    _createClass(ReadableStream, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('cancel'));
        }
        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
        }
        return ReadableStreamCancel(this, reason);
      }
    }, {
      key: 'getReader',
      value: function getReader() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            mode = _ref2.mode;
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('getReader');
        }
        if (mode === undefined) {
          return AcquireReadableStreamDefaultReader(this);
        }
        mode = String(mode);
        if (mode === 'byob') {
          return AcquireReadableStreamBYOBReader(this);
        }
        throw new RangeError('Invalid mode is specified');
      }
    }, {
      key: 'pipeThrough',
      value: function pipeThrough(_ref3, options) {
        var writable = _ref3.writable,
            readable = _ref3.readable;
        var promise = this.pipeTo(writable, options);
        ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
        return readable;
      }
    }, {
      key: 'pipeTo',
      value: function pipeTo(dest) {
        var _this = this;
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            preventClose = _ref4.preventClose,
            preventAbort = _ref4.preventAbort,
            preventCancel = _ref4.preventCancel;
        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('pipeTo'));
        }
        if (IsWritableStream(dest) === false) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
        }
        preventClose = Boolean(preventClose);
        preventAbort = Boolean(preventAbort);
        preventCancel = Boolean(preventCancel);
        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
        }
        if (IsWritableStreamLocked(dest) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
        }
        var reader = AcquireReadableStreamDefaultReader(this);
        var writer = AcquireWritableStreamDefaultWriter(dest);
        var shuttingDown = false;
        var currentWrite = Promise.resolve();
        return new Promise(function (resolve, reject) {
          function pipeLoop() {
            currentWrite = Promise.resolve();
            if (shuttingDown === true) {
              return Promise.resolve();
            }
            return writer._readyPromise.then(function () {
              return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
                var value = _ref5.value,
                    done = _ref5.done;
                if (done === true) {
                  return;
                }
                currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
              });
            }).then(pipeLoop);
          }
          isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
            if (preventAbort === false) {
              shutdownWithAction(function () {
                return WritableStreamAbort(dest, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesClosed(_this, reader._closedPromise, function () {
            if (preventClose === false) {
              shutdownWithAction(function () {
                return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
              });
            } else {
              shutdown();
            }
          });
          if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
            var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');
            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, destClosed);
              }, true, destClosed);
            } else {
              shutdown(true, destClosed);
            }
          }
          pipeLoop().catch(function (err) {
            currentWrite = Promise.resolve();
            rethrowAssertionErrorRejection(err);
          });
          function waitForWritesToFinish() {
            var oldCurrentWrite = currentWrite;
            return currentWrite.then(function () {
              return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
            });
          }
          function isOrBecomesErrored(stream, promise, action) {
            if (stream._state === 'errored') {
              action(stream._storedError);
            } else {
              promise.catch(action).catch(rethrowAssertionErrorRejection);
            }
          }
          function isOrBecomesClosed(stream, promise, action) {
            if (stream._state === 'closed') {
              action();
            } else {
              promise.then(action).catch(rethrowAssertionErrorRejection);
            }
          }
          function shutdownWithAction(action, originalIsError, originalError) {
            if (shuttingDown === true) {
              return;
            }
            shuttingDown = true;
            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(doTheRest);
            } else {
              doTheRest();
            }
            function doTheRest() {
              action().then(function () {
                return finalize(originalIsError, originalError);
              }, function (newError) {
                return finalize(true, newError);
              }).catch(rethrowAssertionErrorRejection);
            }
          }
          function shutdown(isError, error) {
            if (shuttingDown === true) {
              return;
            }
            shuttingDown = true;
            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(function () {
                return finalize(isError, error);
              }).catch(rethrowAssertionErrorRejection);
            } else {
              finalize(isError, error);
            }
          }
          function finalize(isError, error) {
            WritableStreamDefaultWriterRelease(writer);
            ReadableStreamReaderGenericRelease(reader);
            if (isError) {
              reject(error);
            } else {
              resolve(undefined);
            }
          }
        });
      }
    }, {
      key: 'tee',
      value: function tee() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('tee');
        }
        var branches = ReadableStreamTee(this, false);
        return createArrayFromList(branches);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }
        return IsReadableStreamLocked(this);
      }
    }]);
    return ReadableStream;
  }();
  module.exports = {
    ReadableStream: ReadableStream,
    IsReadableStreamDisturbed: IsReadableStreamDisturbed,
    ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
    ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
    ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
    ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
  };
  function AcquireReadableStreamBYOBReader(stream) {
    return new ReadableStreamBYOBReader(stream);
  }
  function AcquireReadableStreamDefaultReader(stream) {
    return new ReadableStreamDefaultReader(stream);
  }
  function IsReadableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamDisturbed(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');
    return stream._disturbed;
  }
  function IsReadableStreamLocked(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');
    if (stream._reader === undefined) {
      return false;
    }
    return true;
  }
  function ReadableStreamTee(stream, cloneForBranch2) {
    assert(IsReadableStream(stream) === true);
    assert(typeof cloneForBranch2 === 'boolean');
    var reader = AcquireReadableStreamDefaultReader(stream);
    var teeState = {
      closedOrErrored: false,
      canceled1: false,
      canceled2: false,
      reason1: undefined,
      reason2: undefined
    };
    teeState.promise = new Promise(function (resolve) {
      teeState._resolve = resolve;
    });
    var pull = create_ReadableStreamTeePullFunction();
    pull._reader = reader;
    pull._teeState = teeState;
    pull._cloneForBranch2 = cloneForBranch2;
    var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
    cancel1._stream = stream;
    cancel1._teeState = teeState;
    var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
    cancel2._stream = stream;
    cancel2._teeState = teeState;
    var underlyingSource1 = Object.create(Object.prototype);
    createDataProperty(underlyingSource1, 'pull', pull);
    createDataProperty(underlyingSource1, 'cancel', cancel1);
    var branch1Stream = new ReadableStream(underlyingSource1);
    var underlyingSource2 = Object.create(Object.prototype);
    createDataProperty(underlyingSource2, 'pull', pull);
    createDataProperty(underlyingSource2, 'cancel', cancel2);
    var branch2Stream = new ReadableStream(underlyingSource2);
    pull._branch1 = branch1Stream._readableStreamController;
    pull._branch2 = branch2Stream._readableStreamController;
    reader._closedPromise.catch(function (r) {
      if (teeState.closedOrErrored === true) {
        return;
      }
      ReadableStreamDefaultControllerError(pull._branch1, r);
      ReadableStreamDefaultControllerError(pull._branch2, r);
      teeState.closedOrErrored = true;
    });
    return [branch1Stream, branch2Stream];
  }
  function create_ReadableStreamTeePullFunction() {
    function f() {
      var reader = f._reader,
          branch1 = f._branch1,
          branch2 = f._branch2,
          teeState = f._teeState;
      return ReadableStreamDefaultReaderRead(reader).then(function (result) {
        assert(typeIsObject(result));
        var value = result.value;
        var done = result.done;
        assert(typeof done === 'boolean');
        if (done === true && teeState.closedOrErrored === false) {
          if (teeState.canceled1 === false) {
            ReadableStreamDefaultControllerClose(branch1);
          }
          if (teeState.canceled2 === false) {
            ReadableStreamDefaultControllerClose(branch2);
          }
          teeState.closedOrErrored = true;
        }
        if (teeState.closedOrErrored === true) {
          return;
        }
        var value1 = value;
        var value2 = value;
        if (teeState.canceled1 === false) {
          ReadableStreamDefaultControllerEnqueue(branch1, value1);
        }
        if (teeState.canceled2 === false) {
          ReadableStreamDefaultControllerEnqueue(branch2, value2);
        }
      });
    }
    return f;
  }
  function create_ReadableStreamTeeBranch1CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled1 = true;
      teeState.reason1 = reason;
      if (teeState.canceled2 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);
        teeState._resolve(cancelResult);
      }
      return teeState.promise;
    }
    return f;
  }
  function create_ReadableStreamTeeBranch2CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled2 = true;
      teeState.reason2 = reason;
      if (teeState.canceled1 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);
        teeState._resolve(cancelResult);
      }
      return teeState.promise;
    }
    return f;
  }
  function ReadableStreamAddReadIntoRequest(stream) {
    assert(IsReadableStreamBYOBReader(stream._reader) === true);
    assert(stream._state === 'readable' || stream._state === 'closed');
    var promise = new Promise(function (resolve, reject) {
      var readIntoRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._reader._readIntoRequests.push(readIntoRequest);
    });
    return promise;
  }
  function ReadableStreamAddReadRequest(stream) {
    assert(IsReadableStreamDefaultReader(stream._reader) === true);
    assert(stream._state === 'readable');
    var promise = new Promise(function (resolve, reject) {
      var readRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._reader._readRequests.push(readRequest);
    });
    return promise;
  }
  function ReadableStreamCancel(stream, reason) {
    stream._disturbed = true;
    if (stream._state === 'closed') {
      return Promise.resolve(undefined);
    }
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    ReadableStreamClose(stream);
    var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
    return sourceCancelPromise.then(function () {
      return undefined;
    });
  }
  function ReadableStreamClose(stream) {
    assert(stream._state === 'readable');
    stream._state = 'closed';
    var reader = stream._reader;
    if (reader === undefined) {
      return undefined;
    }
    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var _resolve = reader._readRequests[i]._resolve;
        _resolve(CreateIterResultObject(undefined, true));
      }
      reader._readRequests = [];
    }
    defaultReaderClosedPromiseResolve(reader);
    return undefined;
  }
  function ReadableStreamError(stream, e) {
    assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
    assert(stream._state === 'readable', 'state must be readable');
    stream._state = 'errored';
    stream._storedError = e;
    var reader = stream._reader;
    if (reader === undefined) {
      return undefined;
    }
    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var readRequest = reader._readRequests[i];
        readRequest._reject(e);
      }
      reader._readRequests = [];
    } else {
      assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');
      for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
        var readIntoRequest = reader._readIntoRequests[_i];
        readIntoRequest._reject(e);
      }
      reader._readIntoRequests = [];
    }
    defaultReaderClosedPromiseReject(reader, e);
    reader._closedPromise.catch(function () {});
  }
  function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readIntoRequests.length > 0);
    var readIntoRequest = reader._readIntoRequests.shift();
    readIntoRequest._resolve(CreateIterResultObject(chunk, done));
  }
  function ReadableStreamFulfillReadRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readRequests.length > 0);
    var readRequest = reader._readRequests.shift();
    readRequest._resolve(CreateIterResultObject(chunk, done));
  }
  function ReadableStreamGetNumReadIntoRequests(stream) {
    return stream._reader._readIntoRequests.length;
  }
  function ReadableStreamGetNumReadRequests(stream) {
    return stream._reader._readRequests.length;
  }
  function ReadableStreamHasBYOBReader(stream) {
    var reader = stream._reader;
    if (reader === undefined) {
      return false;
    }
    if (IsReadableStreamBYOBReader(reader) === false) {
      return false;
    }
    return true;
  }
  function ReadableStreamHasDefaultReader(stream) {
    var reader = stream._reader;
    if (reader === undefined) {
      return false;
    }
    if (IsReadableStreamDefaultReader(reader) === false) {
      return false;
    }
    return true;
  }
  var ReadableStreamDefaultReader = function () {
    function ReadableStreamDefaultReader(stream) {
      _classCallCheck(this, ReadableStreamDefaultReader);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
      }
      if (IsReadableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }
      ReadableStreamReaderGenericInitialize(this, stream);
      this._readRequests = [];
    }
    _createClass(ReadableStreamDefaultReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('cancel'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }
        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('read'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }
        return ReadableStreamDefaultReaderRead(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsReadableStreamDefaultReader(this) === false) {
          throw defaultReaderBrandCheckException('releaseLock');
        }
        if (this._ownerReadableStream === undefined) {
          return;
        }
        if (this._readRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }
        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }]);
    return ReadableStreamDefaultReader;
  }();
  var ReadableStreamBYOBReader = function () {
    function ReadableStreamBYOBReader(stream) {
      _classCallCheck(this, ReadableStreamBYOBReader);
      if (!IsReadableStream(stream)) {
        throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
      }
      if (IsReadableByteStreamController(stream._readableStreamController) === false) {
        throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
      }
      if (IsReadableStreamLocked(stream)) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }
      ReadableStreamReaderGenericInitialize(this, stream);
      this._readIntoRequests = [];
    }
    _createClass(ReadableStreamBYOBReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('cancel'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }
        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read(view) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('read'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }
        if (!ArrayBuffer.isView(view)) {
          return Promise.reject(new TypeError('view must be an array buffer view'));
        }
        if (view.byteLength === 0) {
          return Promise.reject(new TypeError('view must have non-zero byteLength'));
        }
        return ReadableStreamBYOBReaderRead(this, view);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (!IsReadableStreamBYOBReader(this)) {
          throw byobReaderBrandCheckException('releaseLock');
        }
        if (this._ownerReadableStream === undefined) {
          return;
        }
        if (this._readIntoRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }
        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }]);
    return ReadableStreamBYOBReader;
  }();
  function IsReadableStreamBYOBReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamDefaultReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
      return false;
    }
    return true;
  }
  function ReadableStreamReaderGenericInitialize(reader, stream) {
    reader._ownerReadableStream = stream;
    stream._reader = reader;
    if (stream._state === 'readable') {
      defaultReaderClosedPromiseInitialize(reader);
    } else if (stream._state === 'closed') {
      defaultReaderClosedPromiseInitializeAsResolved(reader);
    } else {
      assert(stream._state === 'errored', 'state must be errored');
      defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
      reader._closedPromise.catch(function () {});
    }
  }
  function ReadableStreamReaderGenericCancel(reader, reason) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    return ReadableStreamCancel(stream, reason);
  }
  function ReadableStreamReaderGenericRelease(reader) {
    assert(reader._ownerReadableStream !== undefined);
    assert(reader._ownerReadableStream._reader === reader);
    if (reader._ownerReadableStream._state === 'readable') {
      defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    } else {
      defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    }
    reader._closedPromise.catch(function () {});
    reader._ownerReadableStream._reader = undefined;
    reader._ownerReadableStream = undefined;
  }
  function ReadableStreamBYOBReaderRead(reader, view) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
  }
  function ReadableStreamDefaultReaderRead(reader) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;
    if (stream._state === 'closed') {
      return Promise.resolve(CreateIterResultObject(undefined, true));
    }
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    assert(stream._state === 'readable');
    return stream._readableStreamController.__pullSteps();
  }
  var ReadableStreamDefaultController = function () {
    function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
      _classCallCheck(this, ReadableStreamDefaultController);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
      }
      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
      }
      this._controlledReadableStream = stream;
      this._underlyingSource = underlyingSource;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      this._closeRequested = false;
      this._pullAgain = false;
      this._pulling = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var controller = this;
      var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }, function (r) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
      }).catch(rethrowAssertionErrorRejection);
    }
    _createClass(ReadableStreamDefaultController, [{
      key: 'close',
      value: function close() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }
        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }
        ReadableStreamDefaultControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }
        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }
        return ReadableStreamDefaultControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }
        var stream = this._controlledReadableStream;
        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }
        ReadableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;
        if (this._queue.length > 0) {
          var chunk = DequeueValue(this);
          if (this._closeRequested === true && this._queue.length === 0) {
            ReadableStreamClose(stream);
          } else {
            ReadableStreamDefaultControllerCallPullIfNeeded(this);
          }
          return Promise.resolve(CreateIterResultObject(chunk, false));
        }
        var pendingPromise = ReadableStreamAddReadRequest(stream);
        ReadableStreamDefaultControllerCallPullIfNeeded(this);
        return pendingPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }
        return ReadableStreamDefaultControllerGetDesiredSize(this);
      }
    }]);
    return ReadableStreamDefaultController;
  }();
  function IsReadableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
      return false;
    }
    return true;
  }
  function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
    if (shouldPull === false) {
      return undefined;
    }
    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }
    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;
      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }
      return undefined;
    }, function (e) {
      ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
    }).catch(rethrowAssertionErrorRejection);
    return undefined;
  }
  function ReadableStreamDefaultControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;
    if (stream._state === 'closed' || stream._state === 'errored') {
      return false;
    }
    if (controller._closeRequested === true) {
      return false;
    }
    if (controller._started === false) {
      return false;
    }
    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }
    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
    if (desiredSize > 0) {
      return true;
    }
    return false;
  }
  function ReadableStreamDefaultControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    controller._closeRequested = true;
    if (controller._queue.length === 0) {
      ReadableStreamClose(stream);
    }
  }
  function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      ReadableStreamFulfillReadRequest(stream, chunk, false);
    } else {
      var chunkSize = 1;
      if (controller._strategySize !== undefined) {
        var strategySize = controller._strategySize;
        try {
          chunkSize = strategySize(chunk);
        } catch (chunkSizeE) {
          ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
          throw chunkSizeE;
        }
      }
      try {
        EnqueueValueWithSize(controller, chunk, chunkSize);
      } catch (enqueueE) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
        throw enqueueE;
      }
    }
    ReadableStreamDefaultControllerCallPullIfNeeded(controller);
    return undefined;
  }
  function ReadableStreamDefaultControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }
  function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
    if (controller._controlledReadableStream._state === 'readable') {
      ReadableStreamDefaultControllerError(controller, e);
    }
  }
  function ReadableStreamDefaultControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;
    if (state === 'errored') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return controller._strategyHWM - controller._queueTotalSize;
  }
  var ReadableStreamBYOBRequest = function () {
    function ReadableStreamBYOBRequest(controller, view) {
      _classCallCheck(this, ReadableStreamBYOBRequest);
      this._associatedReadableByteStreamController = controller;
      this._view = view;
    }
    _createClass(ReadableStreamBYOBRequest, [{
      key: 'respond',
      value: function respond(bytesWritten) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }
        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }
        ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
      }
    }, {
      key: 'respondWithNewView',
      value: function respondWithNewView(view) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }
        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }
        if (!ArrayBuffer.isView(view)) {
          throw new TypeError('You can only respond with array buffer views');
        }
        ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
      }
    }, {
      key: 'view',
      get: function get() {
        return this._view;
      }
    }]);
    return ReadableStreamBYOBRequest;
  }();
  var ReadableByteStreamController = function () {
    function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
      _classCallCheck(this, ReadableByteStreamController);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
      }
      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
      }
      this._controlledReadableStream = stream;
      this._underlyingByteSource = underlyingByteSource;
      this._pullAgain = false;
      this._pulling = false;
      ReadableByteStreamControllerClearPendingPullIntos(this);
      this._queue = this._queueTotalSize = undefined;
      ResetQueue(this);
      this._closeRequested = false;
      this._started = false;
      this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
      var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
      if (autoAllocateChunkSize !== undefined) {
        if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
          throw new RangeError('autoAllocateChunkSize must be a positive integer');
        }
      }
      this._autoAllocateChunkSize = autoAllocateChunkSize;
      this._pendingPullIntos = [];
      var controller = this;
      var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }, function (r) {
        if (stream._state === 'readable') {
          ReadableByteStreamControllerError(controller, r);
        }
      }).catch(rethrowAssertionErrorRejection);
    }
    _createClass(ReadableByteStreamController, [{
      key: 'close',
      value: function close() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('close');
        }
        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }
        ReadableByteStreamControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('enqueue');
        }
        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }
        if (!ArrayBuffer.isView(chunk)) {
          throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
        }
        ReadableByteStreamControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('error');
        }
        var stream = this._controlledReadableStream;
        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }
        ReadableByteStreamControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        if (this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          firstDescriptor.bytesFilled = 0;
        }
        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;
        assert(ReadableStreamHasDefaultReader(stream) === true);
        if (this._queueTotalSize > 0) {
          assert(ReadableStreamGetNumReadRequests(stream) === 0);
          var entry = this._queue.shift();
          this._queueTotalSize -= entry.byteLength;
          ReadableByteStreamControllerHandleQueueDrain(this);
          var view = void 0;
          try {
            view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
          } catch (viewE) {
            return Promise.reject(viewE);
          }
          return Promise.resolve(CreateIterResultObject(view, false));
        }
        var autoAllocateChunkSize = this._autoAllocateChunkSize;
        if (autoAllocateChunkSize !== undefined) {
          var buffer = void 0;
          try {
            buffer = new ArrayBuffer(autoAllocateChunkSize);
          } catch (bufferE) {
            return Promise.reject(bufferE);
          }
          var pullIntoDescriptor = {
            buffer: buffer,
            byteOffset: 0,
            byteLength: autoAllocateChunkSize,
            bytesFilled: 0,
            elementSize: 1,
            ctor: Uint8Array,
            readerType: 'default'
          };
          this._pendingPullIntos.push(pullIntoDescriptor);
        }
        var promise = ReadableStreamAddReadRequest(stream);
        ReadableByteStreamControllerCallPullIfNeeded(this);
        return promise;
      }
    }, {
      key: 'byobRequest',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('byobRequest');
        }
        if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
          this._byobRequest = new ReadableStreamBYOBRequest(this, view);
        }
        return this._byobRequest;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('desiredSize');
        }
        return ReadableByteStreamControllerGetDesiredSize(this);
      }
    }]);
    return ReadableByteStreamController;
  }();
  function IsReadableByteStreamController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamBYOBRequest(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
      return false;
    }
    return true;
  }
  function ReadableByteStreamControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
    if (shouldPull === false) {
      return undefined;
    }
    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }
    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;
      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }
    }, function (e) {
      if (controller._controlledReadableStream._state === 'readable') {
        ReadableByteStreamControllerError(controller, e);
      }
    }).catch(rethrowAssertionErrorRejection);
    return undefined;
  }
  function ReadableByteStreamControllerClearPendingPullIntos(controller) {
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    controller._pendingPullIntos = [];
  }
  function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
    assert(stream._state !== 'errored', 'state must not be errored');
    var done = false;
    if (stream._state === 'closed') {
      assert(pullIntoDescriptor.bytesFilled === 0);
      done = true;
    }
    var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
    if (pullIntoDescriptor.readerType === 'default') {
      ReadableStreamFulfillReadRequest(stream, filledView, done);
    } else {
      assert(pullIntoDescriptor.readerType === 'byob');
      ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
    }
  }
  function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
    var bytesFilled = pullIntoDescriptor.bytesFilled;
    var elementSize = pullIntoDescriptor.elementSize;
    assert(bytesFilled <= pullIntoDescriptor.byteLength);
    assert(bytesFilled % elementSize === 0);
    return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
  }
  function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
    controller._queue.push({
      buffer: buffer,
      byteOffset: byteOffset,
      byteLength: byteLength
    });
    controller._queueTotalSize += byteLength;
  }
  function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
    var elementSize = pullIntoDescriptor.elementSize;
    var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
    var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
    var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
    var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
    var totalBytesToCopyRemaining = maxBytesToCopy;
    var ready = false;
    if (maxAlignedBytes > currentAlignedBytes) {
      totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
      ready = true;
    }
    var queue = controller._queue;
    while (totalBytesToCopyRemaining > 0) {
      var headOfQueue = queue[0];
      var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
      var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
      if (headOfQueue.byteLength === bytesToCopy) {
        queue.shift();
      } else {
        headOfQueue.byteOffset += bytesToCopy;
        headOfQueue.byteLength -= bytesToCopy;
      }
      controller._queueTotalSize -= bytesToCopy;
      ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
      totalBytesToCopyRemaining -= bytesToCopy;
    }
    if (ready === false) {
      assert(controller._queueTotalSize === 0, 'queue must be empty');
      assert(pullIntoDescriptor.bytesFilled > 0);
      assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
    }
    return ready;
  }
  function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
    assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    pullIntoDescriptor.bytesFilled += size;
  }
  function ReadableByteStreamControllerHandleQueueDrain(controller) {
    assert(controller._controlledReadableStream._state === 'readable');
    if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
      ReadableStreamClose(controller._controlledReadableStream);
    } else {
      ReadableByteStreamControllerCallPullIfNeeded(controller);
    }
  }
  function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
    if (controller._byobRequest === undefined) {
      return;
    }
    controller._byobRequest._associatedReadableByteStreamController = undefined;
    controller._byobRequest._view = undefined;
    controller._byobRequest = undefined;
  }
  function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
    assert(controller._closeRequested === false);
    while (controller._pendingPullIntos.length > 0) {
      if (controller._queueTotalSize === 0) {
        return;
      }
      var pullIntoDescriptor = controller._pendingPullIntos[0];
      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
      }
    }
  }
  function ReadableByteStreamControllerPullInto(controller, view) {
    var stream = controller._controlledReadableStream;
    var elementSize = 1;
    if (view.constructor !== DataView) {
      elementSize = view.constructor.BYTES_PER_ELEMENT;
    }
    var ctor = view.constructor;
    var pullIntoDescriptor = {
      buffer: view.buffer,
      byteOffset: view.byteOffset,
      byteLength: view.byteLength,
      bytesFilled: 0,
      elementSize: elementSize,
      ctor: ctor,
      readerType: 'byob'
    };
    if (controller._pendingPullIntos.length > 0) {
      pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
      controller._pendingPullIntos.push(pullIntoDescriptor);
      return ReadableStreamAddReadIntoRequest(stream);
    }
    if (stream._state === 'closed') {
      var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
      return Promise.resolve(CreateIterResultObject(emptyView, true));
    }
    if (controller._queueTotalSize > 0) {
      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
        ReadableByteStreamControllerHandleQueueDrain(controller);
        return Promise.resolve(CreateIterResultObject(filledView, false));
      }
      if (controller._closeRequested === true) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        return Promise.reject(e);
      }
    }
    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    controller._pendingPullIntos.push(pullIntoDescriptor);
    var promise = ReadableStreamAddReadIntoRequest(stream);
    ReadableByteStreamControllerCallPullIfNeeded(controller);
    return promise;
  }
  function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
    firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
    assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');
    var stream = controller._controlledReadableStream;
    if (ReadableStreamHasBYOBReader(stream) === true) {
      while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
        var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
      }
    }
  }
  function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
    if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
      throw new RangeError('bytesWritten out of range');
    }
    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
    if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
      return;
    }
    ReadableByteStreamControllerShiftPendingPullInto(controller);
    var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
    if (remainderSize > 0) {
      var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
    }
    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    pullIntoDescriptor.bytesFilled -= remainderSize;
    ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
  }
  function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
    var firstDescriptor = controller._pendingPullIntos[0];
    var stream = controller._controlledReadableStream;
    if (stream._state === 'closed') {
      if (bytesWritten !== 0) {
        throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
      }
      ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
    } else {
      assert(stream._state === 'readable');
      ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
    }
  }
  function ReadableByteStreamControllerShiftPendingPullInto(controller) {
    var descriptor = controller._pendingPullIntos.shift();
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    return descriptor;
  }
  function ReadableByteStreamControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;
    if (stream._state !== 'readable') {
      return false;
    }
    if (controller._closeRequested === true) {
      return false;
    }
    if (controller._started === false) {
      return false;
    }
    if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }
    if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
      return true;
    }
    if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
      return true;
    }
    return false;
  }
  function ReadableByteStreamControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    if (controller._queueTotalSize > 0) {
      controller._closeRequested = true;
      return;
    }
    if (controller._pendingPullIntos.length > 0) {
      var firstPendingPullInto = controller._pendingPullIntos[0];
      if (firstPendingPullInto.bytesFilled > 0) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        throw e;
      }
    }
    ReadableStreamClose(stream);
  }
  function ReadableByteStreamControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    var buffer = chunk.buffer;
    var byteOffset = chunk.byteOffset;
    var byteLength = chunk.byteLength;
    var transferredBuffer = TransferArrayBuffer(buffer);
    if (ReadableStreamHasDefaultReader(stream) === true) {
      if (ReadableStreamGetNumReadRequests(stream) === 0) {
        ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      } else {
        assert(controller._queue.length === 0);
        var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
        ReadableStreamFulfillReadRequest(stream, transferredView, false);
      }
    } else if (ReadableStreamHasBYOBReader(stream) === true) {
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
    } else {
      assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
    }
  }
  function ReadableByteStreamControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ReadableByteStreamControllerClearPendingPullIntos(controller);
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }
  function ReadableByteStreamControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;
    if (state === 'errored') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return controller._strategyHWM - controller._queueTotalSize;
  }
  function ReadableByteStreamControllerRespond(controller, bytesWritten) {
    bytesWritten = Number(bytesWritten);
    if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
      throw new RangeError('bytesWritten must be a finite');
    }
    assert(controller._pendingPullIntos.length > 0);
    ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
  }
  function ReadableByteStreamControllerRespondWithNewView(controller, view) {
    assert(controller._pendingPullIntos.length > 0);
    var firstDescriptor = controller._pendingPullIntos[0];
    if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
      throw new RangeError('The region specified by view does not match byobRequest');
    }
    if (firstDescriptor.byteLength !== view.byteLength) {
      throw new RangeError('The buffer of view has different capacity than byobRequest');
    }
    firstDescriptor.buffer = view.buffer;
    ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
  }
  function streamBrandCheckException(name) {
    return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
  }
  function readerLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released reader');
  }
  function defaultReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
  }
  function defaultReaderClosedPromiseInitialize(reader) {
    reader._closedPromise = new Promise(function (resolve, reject) {
      reader._closedPromise_resolve = resolve;
      reader._closedPromise_reject = reject;
    });
  }
  function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
    reader._closedPromise = Promise.reject(reason);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseInitializeAsResolved(reader) {
    reader._closedPromise = Promise.resolve(undefined);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseReject(reader, reason) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);
    reader._closedPromise_reject(reason);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseResetToRejected(reader, reason) {
    assert(reader._closedPromise_resolve === undefined);
    assert(reader._closedPromise_reject === undefined);
    reader._closedPromise = Promise.reject(reason);
  }
  function defaultReaderClosedPromiseResolve(reader) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);
    reader._closedPromise_resolve(undefined);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function byobReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
  }
  function defaultControllerBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
  }
  function byobRequestBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
  }
  function byteStreamControllerBrandCheckException(name) {
    return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
  }
  function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
    try {
      Promise.prototype.then.call(promise, undefined, function () {});
    } catch (e) {}
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var transformStream = __w_pdfjs_require__(6);
  var readableStream = __w_pdfjs_require__(4);
  var writableStream = __w_pdfjs_require__(2);
  exports.TransformStream = transformStream.TransformStream;
  exports.ReadableStream = readableStream.ReadableStream;
  exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
  exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
  exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
  exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
  exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
  exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
  exports.IsWritableStream = writableStream.IsWritableStream;
  exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
  exports.WritableStream = writableStream.WritableStream;
  exports.WritableStreamAbort = writableStream.WritableStreamAbort;
  exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
  exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
  exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
  exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;
  var _require2 = __w_pdfjs_require__(0),
      InvokeOrNoop = _require2.InvokeOrNoop,
      PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
      PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
      typeIsObject = _require2.typeIsObject;
  var _require3 = __w_pdfjs_require__(4),
      ReadableStream = _require3.ReadableStream,
      ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
      ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
      ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
      ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
  var _require4 = __w_pdfjs_require__(2),
      WritableStream = _require4.WritableStream,
      WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
  function TransformStreamCloseReadable(transformStream) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }
    TransformStreamCloseReadableInternal(transformStream);
  }
  function TransformStreamEnqueueToReadable(transformStream, chunk) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }
    var controller = transformStream._readableController;
    try {
      ReadableStreamDefaultControllerEnqueue(controller, chunk);
    } catch (e) {
      transformStream._readableClosed = true;
      TransformStreamErrorIfNeeded(transformStream, e);
      throw transformStream._storedError;
    }
    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
    var maybeBackpressure = desiredSize <= 0;
    if (maybeBackpressure === true && transformStream._backpressure === false) {
      TransformStreamSetBackpressure(transformStream, true);
    }
  }
  function TransformStreamError(transformStream, e) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    TransformStreamErrorInternal(transformStream, e);
  }
  function TransformStreamCloseReadableInternal(transformStream) {
    assert(transformStream._errored === false);
    assert(transformStream._readableClosed === false);
    try {
      ReadableStreamDefaultControllerClose(transformStream._readableController);
    } catch (e) {
      assert(false);
    }
    transformStream._readableClosed = true;
  }
  function TransformStreamErrorIfNeeded(transformStream, e) {
    if (transformStream._errored === false) {
      TransformStreamErrorInternal(transformStream, e);
    }
  }
  function TransformStreamErrorInternal(transformStream, e) {
    assert(transformStream._errored === false);
    transformStream._errored = true;
    transformStream._storedError = e;
    if (transformStream._writableDone === false) {
      WritableStreamDefaultControllerError(transformStream._writableController, e);
    }
    if (transformStream._readableClosed === false) {
      ReadableStreamDefaultControllerError(transformStream._readableController, e);
    }
  }
  function TransformStreamReadableReadyPromise(transformStream) {
    assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
    if (transformStream._backpressure === false) {
      return Promise.resolve();
    }
    assert(transformStream._backpressure === true, '_backpressure should have been initialized');
    return transformStream._backpressureChangePromise;
  }
  function TransformStreamSetBackpressure(transformStream, backpressure) {
    assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');
    if (transformStream._backpressureChangePromise !== undefined) {
      transformStream._backpressureChangePromise_resolve(backpressure);
    }
    transformStream._backpressureChangePromise = new Promise(function (resolve) {
      transformStream._backpressureChangePromise_resolve = resolve;
    });
    transformStream._backpressureChangePromise.then(function (resolution) {
      assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
    });
    transformStream._backpressure = backpressure;
  }
  function TransformStreamDefaultTransform(chunk, transformStreamController) {
    var transformStream = transformStreamController._controlledTransformStream;
    TransformStreamEnqueueToReadable(transformStream, chunk);
    return Promise.resolve();
  }
  function TransformStreamTransform(transformStream, chunk) {
    assert(transformStream._errored === false);
    assert(transformStream._transforming === false);
    assert(transformStream._backpressure === false);
    transformStream._transforming = true;
    var transformer = transformStream._transformer;
    var controller = transformStream._transformStreamController;
    var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
    return transformPromise.then(function () {
      transformStream._transforming = false;
      return TransformStreamReadableReadyPromise(transformStream);
    }, function (e) {
      TransformStreamErrorIfNeeded(transformStream, e);
      return Promise.reject(e);
    });
  }
  function IsTransformStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
      return false;
    }
    return true;
  }
  function IsTransformStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
      return false;
    }
    return true;
  }
  var TransformStreamSink = function () {
    function TransformStreamSink(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSink);
      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }
    _createClass(TransformStreamSink, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._writableController = c;
        return this._startPromise.then(function () {
          return TransformStreamReadableReadyPromise(transformStream);
        });
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        var transformStream = this._transformStream;
        return TransformStreamTransform(transformStream, chunk);
      }
    }, {
      key: 'abort',
      value: function abort() {
        var transformStream = this._transformStream;
        transformStream._writableDone = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
      }
    }, {
      key: 'close',
      value: function close() {
        var transformStream = this._transformStream;
        assert(transformStream._transforming === false);
        transformStream._writableDone = true;
        var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
        return flushPromise.then(function () {
          if (transformStream._errored === true) {
            return Promise.reject(transformStream._storedError);
          }
          if (transformStream._readableClosed === false) {
            TransformStreamCloseReadableInternal(transformStream);
          }
          return Promise.resolve();
        }).catch(function (r) {
          TransformStreamErrorIfNeeded(transformStream, r);
          return Promise.reject(transformStream._storedError);
        });
      }
    }]);
    return TransformStreamSink;
  }();
  var TransformStreamSource = function () {
    function TransformStreamSource(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSource);
      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }
    _createClass(TransformStreamSource, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._readableController = c;
        return this._startPromise.then(function () {
          assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
          if (transformStream._backpressure === true) {
            return Promise.resolve();
          }
          assert(transformStream._backpressure === false, '_backpressure should have been initialized');
          return transformStream._backpressureChangePromise;
        });
      }
    }, {
      key: 'pull',
      value: function pull() {
        var transformStream = this._transformStream;
        assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');
        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
        TransformStreamSetBackpressure(transformStream, false);
        return transformStream._backpressureChangePromise;
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        var transformStream = this._transformStream;
        transformStream._readableClosed = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
      }
    }]);
    return TransformStreamSource;
  }();
  var TransformStreamDefaultController = function () {
    function TransformStreamDefaultController(transformStream) {
      _classCallCheck(this, TransformStreamDefaultController);
      if (IsTransformStream(transformStream) === false) {
        throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
      }
      if (transformStream._transformStreamController !== undefined) {
        throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
      }
      this._controlledTransformStream = transformStream;
    }
    _createClass(TransformStreamDefaultController, [{
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }
        TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }
        TransformStreamCloseReadable(this._controlledTransformStream);
      }
    }, {
      key: 'error',
      value: function error(reason) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }
        TransformStreamError(this._controlledTransformStream, reason);
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }
        var transformStream = this._controlledTransformStream;
        var readableController = transformStream._readableController;
        return ReadableStreamDefaultControllerGetDesiredSize(readableController);
      }
    }]);
    return TransformStreamDefaultController;
  }();
  var TransformStream = function () {
    function TransformStream() {
      var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, TransformStream);
      this._transformer = transformer;
      var readableStrategy = transformer.readableStrategy,
          writableStrategy = transformer.writableStrategy;
      this._transforming = false;
      this._errored = false;
      this._storedError = undefined;
      this._writableController = undefined;
      this._readableController = undefined;
      this._transformStreamController = undefined;
      this._writableDone = false;
      this._readableClosed = false;
      this._backpressure = undefined;
      this._backpressureChangePromise = undefined;
      this._backpressureChangePromise_resolve = undefined;
      this._transformStreamController = new TransformStreamDefaultController(this);
      var startPromise_resolve = void 0;
      var startPromise = new Promise(function (resolve) {
        startPromise_resolve = resolve;
      });
      var source = new TransformStreamSource(this, startPromise);
      this._readable = new ReadableStream(source, readableStrategy);
      var sink = new TransformStreamSink(this, startPromise);
      this._writable = new WritableStream(sink, writableStrategy);
      assert(this._writableController !== undefined);
      assert(this._readableController !== undefined);
      var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
      TransformStreamSetBackpressure(this, desiredSize <= 0);
      var transformStream = this;
      var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
      startPromise_resolve(startResult);
      startPromise.catch(function (e) {
        if (transformStream._errored === false) {
          transformStream._errored = true;
          transformStream._storedError = e;
        }
      });
    }
    _createClass(TransformStream, [{
      key: 'readable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('readable');
        }
        return this._readable;
      }
    }, {
      key: 'writable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('writable');
        }
        return this._writable;
      }
    }]);
    return TransformStream;
  }();
  module.exports = { TransformStream: TransformStream };
  function defaultControllerBrandCheckException(name) {
    return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
  }
  function streamBrandCheckException(name) {
    return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
  }
}, function (module, exports, __w_pdfjs_require__) {
  module.exports = __w_pdfjs_require__(5);
}]));

/***/ }),
/* 127 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

{
  var isURLSupported = false;
  try {
    if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
      var u = new URL('b', 'http://a');
      u.pathname = 'c%20d';
      isURLSupported = u.href === 'http://a/c%20d';
    }
  } catch (ex) {}
  if (isURLSupported) {
    exports.URL = URL;
  } else {
    var PolyfillURL = __w_pdfjs_require__(128).URL;
    var OriginalURL = __w_pdfjs_require__(3).URL;
    if (OriginalURL) {
      PolyfillURL.createObjectURL = function (blob) {
        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
      };
      PolyfillURL.revokeObjectURL = function (url) {
        OriginalURL.revokeObjectURL(url);
      };
    }
    exports.URL = PolyfillURL;
  }
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


(function URLConstructorClosure() {
  'use strict';

  var relative = Object.create(null);
  relative['ftp'] = 21;
  relative['file'] = 0;
  relative['gopher'] = 70;
  relative['http'] = 80;
  relative['https'] = 443;
  relative['ws'] = 80;
  relative['wss'] = 443;
  var relativePathDotMapping = Object.create(null);
  relativePathDotMapping['%2e'] = '.';
  relativePathDotMapping['.%2e'] = '..';
  relativePathDotMapping['%2e.'] = '..';
  relativePathDotMapping['%2e%2e'] = '..';
  function isRelativeScheme(scheme) {
    return relative[scheme] !== undefined;
  }
  function invalid() {
    clear.call(this);
    this._isInvalid = true;
  }
  function IDNAToASCII(h) {
    if (h === '') {
      invalid.call(this);
    }
    return h.toLowerCase();
  }
  function percentEscape(c) {
    var unicode = c.charCodeAt(0);
    if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
      return c;
    }
    return encodeURIComponent(c);
  }
  function percentEscapeQuery(c) {
    var unicode = c.charCodeAt(0);
    if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
      return c;
    }
    return encodeURIComponent(c);
  }
  var EOF,
      ALPHA = /[a-zA-Z]/,
      ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
  function parse(input, stateOverride, base) {
    function err(message) {
      errors.push(message);
    }
    var state = stateOverride || 'scheme start',
        cursor = 0,
        buffer = '',
        seenAt = false,
        seenBracket = false,
        errors = [];
    loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
      var c = input[cursor];
      switch (state) {
        case 'scheme start':
          if (c && ALPHA.test(c)) {
            buffer += c.toLowerCase();
            state = 'scheme';
          } else if (!stateOverride) {
            buffer = '';
            state = 'no scheme';
            continue;
          } else {
            err('Invalid scheme.');
            break loop;
          }
          break;
        case 'scheme':
          if (c && ALPHANUMERIC.test(c)) {
            buffer += c.toLowerCase();
          } else if (c === ':') {
            this._scheme = buffer;
            buffer = '';
            if (stateOverride) {
              break loop;
            }
            if (isRelativeScheme(this._scheme)) {
              this._isRelative = true;
            }
            if (this._scheme === 'file') {
              state = 'relative';
            } else if (this._isRelative && base && base._scheme === this._scheme) {
              state = 'relative or authority';
            } else if (this._isRelative) {
              state = 'authority first slash';
            } else {
              state = 'scheme data';
            }
          } else if (!stateOverride) {
            buffer = '';
            cursor = 0;
            state = 'no scheme';
            continue;
          } else if (c === EOF) {
            break loop;
          } else {
            err('Code point not allowed in scheme: ' + c);
            break loop;
          }
          break;
        case 'scheme data':
          if (c === '?') {
            this._query = '?';
            state = 'query';
          } else if (c === '#') {
            this._fragment = '#';
            state = 'fragment';
          } else {
            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._schemeData += percentEscape(c);
            }
          }
          break;
        case 'no scheme':
          if (!base || !isRelativeScheme(base._scheme)) {
            err('Missing scheme.');
            invalid.call(this);
          } else {
            state = 'relative';
            continue;
          }
          break;
        case 'relative or authority':
          if (c === '/' && input[cursor + 1] === '/') {
            state = 'authority ignore slashes';
          } else {
            err('Expected /, got: ' + c);
            state = 'relative';
            continue;
          }
          break;
        case 'relative':
          this._isRelative = true;
          if (this._scheme !== 'file') {
            this._scheme = base._scheme;
          }
          if (c === EOF) {
            this._host = base._host;
            this._port = base._port;
            this._path = base._path.slice();
            this._query = base._query;
            this._username = base._username;
            this._password = base._password;
            break loop;
          } else if (c === '/' || c === '\\') {
            if (c === '\\') {
              err('\\ is an invalid code point.');
            }
            state = 'relative slash';
          } else if (c === '?') {
            this._host = base._host;
            this._port = base._port;
            this._path = base._path.slice();
            this._query = '?';
            this._username = base._username;
            this._password = base._password;
            state = 'query';
          } else if (c === '#') {
            this._host = base._host;
            this._port = base._port;
            this._path = base._path.slice();
            this._query = base._query;
            this._fragment = '#';
            this._username = base._username;
            this._password = base._password;
            state = 'fragment';
          } else {
            var nextC = input[cursor + 1];
            var nextNextC = input[cursor + 2];
            if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
              this._host = base._host;
              this._port = base._port;
              this._username = base._username;
              this._password = base._password;
              this._path = base._path.slice();
              this._path.pop();
            }
            state = 'relative path';
            continue;
          }
          break;
        case 'relative slash':
          if (c === '/' || c === '\\') {
            if (c === '\\') {
              err('\\ is an invalid code point.');
            }
            if (this._scheme === 'file') {
              state = 'file host';
            } else {
              state = 'authority ignore slashes';
            }
          } else {
            if (this._scheme !== 'file') {
              this._host = base._host;
              this._port = base._port;
              this._username = base._username;
              this._password = base._password;
            }
            state = 'relative path';
            continue;
          }
          break;
        case 'authority first slash':
          if (c === '/') {
            state = 'authority second slash';
          } else {
            err('Expected \'/\', got: ' + c);
            state = 'authority ignore slashes';
            continue;
          }
          break;
        case 'authority second slash':
          state = 'authority ignore slashes';
          if (c !== '/') {
            err('Expected \'/\', got: ' + c);
            continue;
          }
          break;
        case 'authority ignore slashes':
          if (c !== '/' && c !== '\\') {
            state = 'authority';
            continue;
          } else {
            err('Expected authority, got: ' + c);
          }
          break;
        case 'authority':
          if (c === '@') {
            if (seenAt) {
              err('@ already seen.');
              buffer += '%40';
            }
            seenAt = true;
            for (var i = 0; i < buffer.length; i++) {
              var cp = buffer[i];
              if (cp === '\t' || cp === '\n' || cp === '\r') {
                err('Invalid whitespace in authority.');
                continue;
              }
              if (cp === ':' && this._password === null) {
                this._password = '';
                continue;
              }
              var tempC = percentEscape(cp);
              if (this._password !== null) {
                this._password += tempC;
              } else {
                this._username += tempC;
              }
            }
            buffer = '';
          } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
            cursor -= buffer.length;
            buffer = '';
            state = 'host';
            continue;
          } else {
            buffer += c;
          }
          break;
        case 'file host':
          if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
            if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
              state = 'relative path';
            } else if (buffer.length === 0) {
              state = 'relative path start';
            } else {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'relative path start';
            }
            continue;
          } else if (c === '\t' || c === '\n' || c === '\r') {
            err('Invalid whitespace in file host.');
          } else {
            buffer += c;
          }
          break;
        case 'host':
        case 'hostname':
          if (c === ':' && !seenBracket) {
            this._host = IDNAToASCII.call(this, buffer);
            buffer = '';
            state = 'port';
            if (stateOverride === 'hostname') {
              break loop;
            }
          } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
            this._host = IDNAToASCII.call(this, buffer);
            buffer = '';
            state = 'relative path start';
            if (stateOverride) {
              break loop;
            }
            continue;
          } else if (c !== '\t' && c !== '\n' && c !== '\r') {
            if (c === '[') {
              seenBracket = true;
            } else if (c === ']') {
              seenBracket = false;
            }
            buffer += c;
          } else {
            err('Invalid code point in host/hostname: ' + c);
          }
          break;
        case 'port':
          if (/[0-9]/.test(c)) {
            buffer += c;
          } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
            if (buffer !== '') {
              var temp = parseInt(buffer, 10);
              if (temp !== relative[this._scheme]) {
                this._port = temp + '';
              }
              buffer = '';
            }
            if (stateOverride) {
              break loop;
            }
            state = 'relative path start';
            continue;
          } else if (c === '\t' || c === '\n' || c === '\r') {
            err('Invalid code point in port: ' + c);
          } else {
            invalid.call(this);
          }
          break;
        case 'relative path start':
          if (c === '\\') {
            err('\'\\\' not allowed in path.');
          }
          state = 'relative path';
          if (c !== '/' && c !== '\\') {
            continue;
          }
          break;
        case 'relative path':
          if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
            if (c === '\\') {
              err('\\ not allowed in relative path.');
            }
            var tmp;
            if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
              buffer = tmp;
            }
            if (buffer === '..') {
              this._path.pop();
              if (c !== '/' && c !== '\\') {
                this._path.push('');
              }
            } else if (buffer === '.' && c !== '/' && c !== '\\') {
              this._path.push('');
            } else if (buffer !== '.') {
              if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
                buffer = buffer[0] + ':';
              }
              this._path.push(buffer);
            }
            buffer = '';
            if (c === '?') {
              this._query = '?';
              state = 'query';
            } else if (c === '#') {
              this._fragment = '#';
              state = 'fragment';
            }
          } else if (c !== '\t' && c !== '\n' && c !== '\r') {
            buffer += percentEscape(c);
          }
          break;
        case 'query':
          if (!stateOverride && c === '#') {
            this._fragment = '#';
            state = 'fragment';
          } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
            this._query += percentEscapeQuery(c);
          }
          break;
        case 'fragment':
          if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
            this._fragment += c;
          }
          break;
      }
      cursor++;
    }
  }
  function clear() {
    this._scheme = '';
    this._schemeData = '';
    this._username = '';
    this._password = null;
    this._host = '';
    this._port = '';
    this._path = [];
    this._query = '';
    this._fragment = '';
    this._isInvalid = false;
    this._isRelative = false;
  }
  function JURL(url, base) {
    if (base !== undefined && !(base instanceof JURL)) {
      base = new JURL(String(base));
    }
    this._url = url;
    clear.call(this);
    var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
    parse.call(this, input, null, base);
  }
  JURL.prototype = {
    toString: function toString() {
      return this.href;
    },

    get href() {
      if (this._isInvalid) {
        return this._url;
      }
      var authority = '';
      if (this._username !== '' || this._password !== null) {
        authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
      }
      return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
    },
    set href(value) {
      clear.call(this);
      parse.call(this, value);
    },
    get protocol() {
      return this._scheme + ':';
    },
    set protocol(value) {
      if (this._isInvalid) {
        return;
      }
      parse.call(this, value + ':', 'scheme start');
    },
    get host() {
      return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
    },
    set host(value) {
      if (this._isInvalid || !this._isRelative) {
        return;
      }
      parse.call(this, value, 'host');
    },
    get hostname() {
      return this._host;
    },
    set hostname(value) {
      if (this._isInvalid || !this._isRelative) {
        return;
      }
      parse.call(this, value, 'hostname');
    },
    get port() {
      return this._port;
    },
    set port(value) {
      if (this._isInvalid || !this._isRelative) {
        return;
      }
      parse.call(this, value, 'port');
    },
    get pathname() {
      return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
    },
    set pathname(value) {
      if (this._isInvalid || !this._isRelative) {
        return;
      }
      this._path = [];
      parse.call(this, value, 'relative path start');
    },
    get search() {
      return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
    },
    set search(value) {
      if (this._isInvalid || !this._isRelative) {
        return;
      }
      this._query = '?';
      if (value[0] === '?') {
        value = value.slice(1);
      }
      parse.call(this, value, 'query');
    },
    get hash() {
      return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
    },
    set hash(value) {
      if (this._isInvalid) {
        return;
      }
      this._fragment = '#';
      if (value[0] === '#') {
        value = value.slice(1);
      }
      parse.call(this, value, 'fragment');
    },
    get origin() {
      var host;
      if (this._isInvalid || !this._scheme) {
        return '';
      }
      switch (this._scheme) {
        case 'data':
        case 'file':
        case 'javascript':
        case 'mailto':
          return 'null';
        case 'blob':
          try {
            return new JURL(this._schemeData).origin || 'null';
          } catch (_) {}
          return 'null';
      }
      host = this.host;
      if (!host) {
        return '';
      }
      return this._scheme + '://' + host;
    }
  };
  exports.URL = JURL;
})();

/***/ }),
/* 129 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.build = exports.version = exports.setPDFNetworkStreamFactory = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __w_pdfjs_require__(1);

var _dom_utils = __w_pdfjs_require__(130);

var _font_loader = __w_pdfjs_require__(131);

var _api_compatibility = __w_pdfjs_require__(132);

var _canvas = __w_pdfjs_require__(133);

var _global_scope = __w_pdfjs_require__(3);

var _global_scope2 = _interopRequireDefault(_global_scope);

var _worker_options = __w_pdfjs_require__(135);

var _message_handler = __w_pdfjs_require__(136);

var _metadata = __w_pdfjs_require__(141);

var _transport_stream = __w_pdfjs_require__(143);

var _webgl = __w_pdfjs_require__(144);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_RANGE_CHUNK_SIZE = 65536;
var isWorkerDisabled = false;
var fallbackWorkerSrc = void 0;
var fakeWorkerFilesLoader = null;
{
  var useRequireEnsure = false;
  if (typeof window === 'undefined') {
    isWorkerDisabled = true;
    if (false) {
      require.ensure = require('node-ensure');
    }
    useRequireEnsure = true;
  } else if (true) {
    useRequireEnsure = true;
  }
  if (typeof requirejs !== 'undefined' && requirejs.toUrl) {
    fallbackWorkerSrc = requirejs.toUrl('pdfjs-dist/build/pdf.worker.js');
  }
  var dynamicLoaderSupported = typeof requirejs !== 'undefined' && requirejs.load;
  fakeWorkerFilesLoader = useRequireEnsure ? function () {
    return new Promise(function (resolve, reject) {
      __webpack_require__.e/* require.ensure */(0).then((function () {
        try {
          var worker = void 0;
          worker = __webpack_require__(405);
          resolve(worker.WorkerMessageHandler);
        } catch (ex) {
          reject(ex);
        }
      }).bind(null, __webpack_require__)).catch(reject);
    });
  } : dynamicLoaderSupported ? function () {
    return new Promise(function (resolve, reject) {
      requirejs(['pdfjs-dist/build/pdf.worker'], function (worker) {
        try {
          resolve(worker.WorkerMessageHandler);
        } catch (ex) {
          reject(ex);
        }
      }, reject);
    });
  } : null;
  if (!fallbackWorkerSrc && typeof document !== 'undefined') {
    var pdfjsFilePath = document.currentScript && document.currentScript.src;
    if (pdfjsFilePath) {
      fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
    }
  }
}
var createPDFNetworkStream;
function setPDFNetworkStreamFactory(pdfNetworkStreamFactory) {
  createPDFNetworkStream = pdfNetworkStreamFactory;
}
function getDocument(src) {
  var task = new PDFDocumentLoadingTask();
  var source;
  if (typeof src === 'string') {
    source = { url: src };
  } else if ((0, _util.isArrayBuffer)(src)) {
    source = { data: src };
  } else if (src instanceof PDFDataRangeTransport) {
    source = { range: src };
  } else {
    if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object') {
      throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object');
    }
    if (!src.url && !src.data && !src.range) {
      throw new Error('Invalid parameter object: need either .data, .range or .url');
    }
    source = src;
  }
  var params = Object.create(null);
  var rangeTransport = null;
  var worker = null;
  for (var key in source) {
    if (key === 'url' && typeof window !== 'undefined') {
      params[key] = new _util.URL(source[key], window.location).href;
      continue;
    } else if (key === 'range') {
      rangeTransport = source[key];
      continue;
    } else if (key === 'worker') {
      worker = source[key];
      continue;
    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
      var pdfBytes = source[key];
      if (typeof pdfBytes === 'string') {
        params[key] = (0, _util.stringToBytes)(pdfBytes);
      } else if ((typeof pdfBytes === 'undefined' ? 'undefined' : _typeof(pdfBytes)) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
        params[key] = new Uint8Array(pdfBytes);
      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
        params[key] = new Uint8Array(pdfBytes);
      } else {
        throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.');
      }
      continue;
    }
    params[key] = source[key];
  }
  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
  params.CMapReaderFactory = params.CMapReaderFactory || _dom_utils.DOMCMapReaderFactory;
  params.ignoreErrors = params.stopAtErrors !== true;
  params.pdfBug = params.pdfBug === true;
  var NativeImageDecoderValues = Object.values(_util.NativeImageDecoding);
  if (params.nativeImageDecoderSupport === undefined || !NativeImageDecoderValues.includes(params.nativeImageDecoderSupport)) {
    params.nativeImageDecoderSupport = _api_compatibility.apiCompatibilityParams.nativeImageDecoderSupport || _util.NativeImageDecoding.DECODE;
  }
  if (!Number.isInteger(params.maxImageSize)) {
    params.maxImageSize = -1;
  }
  if (typeof params.isEvalSupported !== 'boolean') {
    params.isEvalSupported = true;
  }
  if (typeof params.disableFontFace !== 'boolean') {
    params.disableFontFace = _api_compatibility.apiCompatibilityParams.disableFontFace || false;
  }
  if (typeof params.disableRange !== 'boolean') {
    params.disableRange = false;
  }
  if (typeof params.disableStream !== 'boolean') {
    params.disableStream = false;
  }
  if (typeof params.disableAutoFetch !== 'boolean') {
    params.disableAutoFetch = false;
  }
  if (typeof params.disableCreateObjectURL !== 'boolean') {
    params.disableCreateObjectURL = _api_compatibility.apiCompatibilityParams.disableCreateObjectURL || false;
  }
  (0, _util.setVerbosityLevel)(params.verbosity);
  if (!worker) {
    var workerParams = {
      postMessageTransfers: params.postMessageTransfers,
      verbosity: params.verbosity
    };
    var workerPort = _worker_options.GlobalWorkerOptions.workerPort;
    if (workerPort) {
      workerParams.port = workerPort;
      worker = PDFWorker.fromPort(workerParams);
    } else {
      worker = new PDFWorker(workerParams);
    }
    task._worker = worker;
  }
  var docId = task.docId;
  worker.promise.then(function () {
    if (task.destroyed) {
      throw new Error('Loading aborted');
    }
    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
      if (task.destroyed) {
        throw new Error('Loading aborted');
      }
      var networkStream = void 0;
      if (rangeTransport) {
        networkStream = new _transport_stream.PDFDataTransportStream({
          length: params.length,
          initialData: params.initialData,
          disableRange: params.disableRange,
          disableStream: params.disableStream
        }, rangeTransport);
      } else if (!params.data) {
        networkStream = createPDFNetworkStream({
          url: params.url,
          length: params.length,
          httpHeaders: params.httpHeaders,
          withCredentials: params.withCredentials,
          rangeChunkSize: params.rangeChunkSize,
          disableRange: params.disableRange,
          disableStream: params.disableStream
        });
      }
      var messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
      messageHandler.postMessageTransfers = worker.postMessageTransfers;
      var transport = new WorkerTransport(messageHandler, task, networkStream, params);
      task._transport = transport;
      messageHandler.send('Ready', null);
    });
  }).catch(task._capability.reject);
  return task;
}
function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
  if (worker.destroyed) {
    return Promise.reject(new Error('Worker was destroyed'));
  }
  if (pdfDataRangeTransport) {
    source.length = pdfDataRangeTransport.length;
    source.initialData = pdfDataRangeTransport.initialData;
  }
  return worker.messageHandler.sendWithPromise('GetDocRequest', {
    docId: docId,
    apiVersion: '2.0.943',
    source: {
      data: source.data,
      url: source.url,
      password: source.password,
      disableAutoFetch: source.disableAutoFetch,
      rangeChunkSize: source.rangeChunkSize,
      length: source.length
    },
    maxImageSize: source.maxImageSize,
    disableFontFace: source.disableFontFace,
    disableCreateObjectURL: source.disableCreateObjectURL,
    postMessageTransfers: worker.postMessageTransfers,
    docBaseUrl: source.docBaseUrl,
    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
    ignoreErrors: source.ignoreErrors,
    isEvalSupported: source.isEvalSupported
  }).then(function (workerId) {
    if (worker.destroyed) {
      throw new Error('Worker was destroyed');
    }
    return workerId;
  });
}
var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
  var nextDocumentId = 0;
  function PDFDocumentLoadingTask() {
    this._capability = (0, _util.createPromiseCapability)();
    this._transport = null;
    this._worker = null;
    this.docId = 'd' + nextDocumentId++;
    this.destroyed = false;
    this.onPassword = null;
    this.onProgress = null;
    this.onUnsupportedFeature = null;
  }
  PDFDocumentLoadingTask.prototype = {
    get promise() {
      return this._capability.promise;
    },
    destroy: function destroy() {
      var _this = this;

      this.destroyed = true;
      var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
      return transportDestroyed.then(function () {
        _this._transport = null;
        if (_this._worker) {
          _this._worker.destroy();
          _this._worker = null;
        }
      });
    },

    then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
      return this.promise.then.apply(this.promise, arguments);
    }
  };
  return PDFDocumentLoadingTask;
}();

var PDFDataRangeTransport = function () {
  function PDFDataRangeTransport(length, initialData) {
    _classCallCheck(this, PDFDataRangeTransport);

    this.length = length;
    this.initialData = initialData;
    this._rangeListeners = [];
    this._progressListeners = [];
    this._progressiveReadListeners = [];
    this._readyCapability = (0, _util.createPromiseCapability)();
  }

  _createClass(PDFDataRangeTransport, [{
    key: 'addRangeListener',
    value: function addRangeListener(listener) {
      this._rangeListeners.push(listener);
    }
  }, {
    key: 'addProgressListener',
    value: function addProgressListener(listener) {
      this._progressListeners.push(listener);
    }
  }, {
    key: 'addProgressiveReadListener',
    value: function addProgressiveReadListener(listener) {
      this._progressiveReadListeners.push(listener);
    }
  }, {
    key: 'onDataRange',
    value: function onDataRange(begin, chunk) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._rangeListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var listener = _step.value;

          listener(begin, chunk);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'onDataProgress',
    value: function onDataProgress(loaded) {
      var _this2 = this;

      this._readyCapability.promise.then(function () {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _this2._progressListeners[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var listener = _step2.value;

            listener(loaded);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      });
    }
  }, {
    key: 'onDataProgressiveRead',
    value: function onDataProgressiveRead(chunk) {
      var _this3 = this;

      this._readyCapability.promise.then(function () {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = _this3._progressiveReadListeners[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var listener = _step3.value;

            listener(chunk);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      });
    }
  }, {
    key: 'transportReady',
    value: function transportReady() {
      this._readyCapability.resolve();
    }
  }, {
    key: 'requestDataRange',
    value: function requestDataRange(begin, end) {
      (0, _util.unreachable)('Abstract method PDFDataRangeTransport.requestDataRange');
    }
  }, {
    key: 'abort',
    value: function abort() {}
  }]);

  return PDFDataRangeTransport;
}();

var PDFDocumentProxy = function () {
  function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
    _classCallCheck(this, PDFDocumentProxy);

    this.loadingTask = loadingTask;
    this._pdfInfo = pdfInfo;
    this._transport = transport;
  }

  _createClass(PDFDocumentProxy, [{
    key: 'getPage',
    value: function getPage(pageNumber) {
      return this._transport.getPage(pageNumber);
    }
  }, {
    key: 'getPageIndex',
    value: function getPageIndex(ref) {
      return this._transport.getPageIndex(ref);
    }
  }, {
    key: 'getDestinations',
    value: function getDestinations() {
      return this._transport.getDestinations();
    }
  }, {
    key: 'getDestination',
    value: function getDestination(id) {
      return this._transport.getDestination(id);
    }
  }, {
    key: 'getPageLabels',
    value: function getPageLabels() {
      return this._transport.getPageLabels();
    }
  }, {
    key: 'getPageMode',
    value: function getPageMode() {
      return this._transport.getPageMode();
    }
  }, {
    key: 'getAttachments',
    value: function getAttachments() {
      return this._transport.getAttachments();
    }
  }, {
    key: 'getJavaScript',
    value: function getJavaScript() {
      return this._transport.getJavaScript();
    }
  }, {
    key: 'getOutline',
    value: function getOutline() {
      return this._transport.getOutline();
    }
  }, {
    key: 'getPermissions',
    value: function getPermissions() {
      return this._transport.getPermissions();
    }
  }, {
    key: 'getMetadata',
    value: function getMetadata() {
      return this._transport.getMetadata();
    }
  }, {
    key: 'getData',
    value: function getData() {
      return this._transport.getData();
    }
  }, {
    key: 'getDownloadInfo',
    value: function getDownloadInfo() {
      return this._transport.downloadInfoCapability.promise;
    }
  }, {
    key: 'getStats',
    value: function getStats() {
      return this._transport.getStats();
    }
  }, {
    key: 'cleanup',
    value: function cleanup() {
      this._transport.startCleanup();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      return this.loadingTask.destroy();
    }
  }, {
    key: 'numPages',
    get: function get() {
      return this._pdfInfo.numPages;
    }
  }, {
    key: 'fingerprint',
    get: function get() {
      return this._pdfInfo.fingerprint;
    }
  }, {
    key: 'loadingParams',
    get: function get() {
      return this._transport.loadingParams;
    }
  }]);

  return PDFDocumentProxy;
}();

var PDFPageProxy = function PDFPageProxyClosure() {
  function PDFPageProxy(pageIndex, pageInfo, transport) {
    var pdfBug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    this.pageIndex = pageIndex;
    this._pageInfo = pageInfo;
    this.transport = transport;
    this._stats = pdfBug ? new _dom_utils.StatTimer() : _dom_utils.DummyStatTimer;
    this._pdfBug = pdfBug;
    this.commonObjs = transport.commonObjs;
    this.objs = new PDFObjects();
    this.cleanupAfterRender = false;
    this.pendingCleanup = false;
    this.intentStates = Object.create(null);
    this.destroyed = false;
  }
  PDFPageProxy.prototype = {
    get pageNumber() {
      return this.pageIndex + 1;
    },
    get rotate() {
      return this._pageInfo.rotate;
    },
    get ref() {
      return this._pageInfo.ref;
    },
    get userUnit() {
      return this._pageInfo.userUnit;
    },
    get view() {
      return this._pageInfo.view;
    },
    getViewport: function getViewport(scale) {
      var rotate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.rotate;
      var dontFlip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      return new _dom_utils.PageViewport({
        viewBox: this.view,
        scale: scale,
        rotation: rotate,
        dontFlip: dontFlip
      });
    },

    getAnnotations: function PDFPageProxy_getAnnotations(params) {
      var intent = params && params.intent || null;
      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
        this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
        this.annotationsIntent = intent;
      }
      return this.annotationsPromise;
    },
    render: function PDFPageProxy_render(params) {
      var _this4 = this;

      var stats = this._stats;
      stats.time('Overall');
      this.pendingCleanup = false;
      var renderingIntent = params.intent === 'print' ? 'print' : 'display';
      var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
      var webGLContext = new _webgl.WebGLContext({ enable: params.enableWebGL });
      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }
      var intentState = this.intentStates[renderingIntent];
      if (!intentState.displayReadyCapability) {
        intentState.receivingOperatorList = true;
        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };
        stats.time('Page Request');
        this.transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageNumber - 1,
          intent: renderingIntent,
          renderInteractiveForms: params.renderInteractiveForms === true
        });
      }
      var complete = function complete(error) {
        var i = intentState.renderTasks.indexOf(internalRenderTask);
        if (i >= 0) {
          intentState.renderTasks.splice(i, 1);
        }
        if (_this4.cleanupAfterRender) {
          _this4.pendingCleanup = true;
        }
        _this4._tryCleanup();
        if (error) {
          internalRenderTask.capability.reject(error);
        } else {
          internalRenderTask.capability.resolve();
        }
        stats.timeEnd('Rendering');
        stats.timeEnd('Overall');
      };
      var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory, webGLContext, this._pdfBug);
      internalRenderTask.useRequestAnimationFrame = renderingIntent !== 'print';
      if (!intentState.renderTasks) {
        intentState.renderTasks = [];
      }
      intentState.renderTasks.push(internalRenderTask);
      var renderTask = internalRenderTask.task;
      intentState.displayReadyCapability.promise.then(function (transparency) {
        if (_this4.pendingCleanup) {
          complete();
          return;
        }
        stats.time('Rendering');
        internalRenderTask.initializeGraphics(transparency);
        internalRenderTask.operatorListChanged();
      }).catch(complete);
      return renderTask;
    },
    getOperatorList: function PDFPageProxy_getOperatorList() {
      function operatorListChanged() {
        if (intentState.operatorList.lastChunk) {
          intentState.opListReadCapability.resolve(intentState.operatorList);
          var i = intentState.renderTasks.indexOf(opListTask);
          if (i >= 0) {
            intentState.renderTasks.splice(i, 1);
          }
        }
      }
      var renderingIntent = 'oplist';
      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }
      var intentState = this.intentStates[renderingIntent];
      var opListTask;
      if (!intentState.opListReadCapability) {
        opListTask = {};
        opListTask.operatorListChanged = operatorListChanged;
        intentState.receivingOperatorList = true;
        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
        intentState.renderTasks = [];
        intentState.renderTasks.push(opListTask);
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };
        this._stats.time('Page Request');
        this.transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageIndex,
          intent: renderingIntent
        });
      }
      return intentState.opListReadCapability.promise;
    },
    streamTextContent: function streamTextContent() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var TEXT_CONTENT_CHUNK_SIZE = 100;
      return this.transport.messageHandler.sendWithStream('GetTextContent', {
        pageIndex: this.pageNumber - 1,
        normalizeWhitespace: params.normalizeWhitespace === true,
        combineTextItems: params.disableCombineTextItems !== true
      }, {
        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
        size: function size(textContent) {
          return textContent.items.length;
        }
      });
    },

    getTextContent: function PDFPageProxy_getTextContent(params) {
      params = params || {};
      var readableStream = this.streamTextContent(params);
      return new Promise(function (resolve, reject) {
        function pump() {
          reader.read().then(function (_ref) {
            var _textContent$items;

            var value = _ref.value,
                done = _ref.done;

            if (done) {
              resolve(textContent);
              return;
            }
            Object.assign(textContent.styles, value.styles);
            (_textContent$items = textContent.items).push.apply(_textContent$items, _toConsumableArray(value.items));
            pump();
          }, reject);
        }
        var reader = readableStream.getReader();
        var textContent = {
          items: [],
          styles: Object.create(null)
        };
        pump();
      });
    },
    _destroy: function PDFPageProxy_destroy() {
      this.destroyed = true;
      this.transport.pageCache[this.pageIndex] = null;
      var waitOn = [];
      Object.keys(this.intentStates).forEach(function (intent) {
        if (intent === 'oplist') {
          return;
        }
        var intentState = this.intentStates[intent];
        intentState.renderTasks.forEach(function (renderTask) {
          var renderCompleted = renderTask.capability.promise.catch(function () {});
          waitOn.push(renderCompleted);
          renderTask.cancel();
        });
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;
      this.pendingCleanup = false;
      return Promise.all(waitOn);
    },
    cleanup: function cleanup() {
      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.pendingCleanup = true;
      this._tryCleanup(resetStats);
    },
    _tryCleanup: function _tryCleanup() {
      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
        var intentState = this.intentStates[intent];
        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
      }, this)) {
        return;
      }
      Object.keys(this.intentStates).forEach(function (intent) {
        delete this.intentStates[intent];
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;
      if (resetStats && this._stats instanceof _dom_utils.StatTimer) {
        this._stats = new _dom_utils.StatTimer();
      }
      this.pendingCleanup = false;
    },

    _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
      var intentState = this.intentStates[intent];
      if (intentState.displayReadyCapability) {
        intentState.displayReadyCapability.resolve(transparency);
      }
    },
    _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
      var intentState = this.intentStates[intent];
      var i, ii;
      for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
      }
      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
      for (i = 0; i < intentState.renderTasks.length; i++) {
        intentState.renderTasks[i].operatorListChanged();
      }
      if (operatorListChunk.lastChunk) {
        intentState.receivingOperatorList = false;
        this._tryCleanup();
      }
    },
    get stats() {
      return this._stats instanceof _dom_utils.StatTimer ? this._stats : null;
    }
  };
  return PDFPageProxy;
}();

var LoopbackPort = function () {
  function LoopbackPort() {
    var defer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    _classCallCheck(this, LoopbackPort);

    this._listeners = [];
    this._defer = defer;
    this._deferred = Promise.resolve(undefined);
  }

  _createClass(LoopbackPort, [{
    key: 'postMessage',
    value: function postMessage(obj, transfers) {
      var _this5 = this;

      function cloneValue(value) {
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
          return value;
        }
        if (cloned.has(value)) {
          return cloned.get(value);
        }
        var result;
        var buffer;
        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
          var transferable = transfers && transfers.includes(buffer);
          if (value === buffer) {
            result = value;
          } else if (transferable) {
            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
          } else {
            result = new value.constructor(value);
          }
          cloned.set(value, result);
          return result;
        }
        result = Array.isArray(value) ? [] : {};
        cloned.set(value, result);
        for (var i in value) {
          var desc,
              p = value;
          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
            p = Object.getPrototypeOf(p);
          }
          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
            continue;
          }
          result[i] = cloneValue(desc.value);
        }
        return result;
      }
      if (!this._defer) {
        this._listeners.forEach(function (listener) {
          listener.call(this, { data: obj });
        }, this);
        return;
      }
      var cloned = new WeakMap();
      var e = { data: cloneValue(obj) };
      this._deferred.then(function () {
        _this5._listeners.forEach(function (listener) {
          listener.call(this, e);
        }, _this5);
      });
    }
  }, {
    key: 'addEventListener',
    value: function addEventListener(name, listener) {
      this._listeners.push(listener);
    }
  }, {
    key: 'removeEventListener',
    value: function removeEventListener(name, listener) {
      var i = this._listeners.indexOf(listener);
      this._listeners.splice(i, 1);
    }
  }, {
    key: 'terminate',
    value: function terminate() {
      this._listeners = [];
    }
  }]);

  return LoopbackPort;
}();

var PDFWorker = function PDFWorkerClosure() {
  var nextFakeWorkerId = 0;
  function getWorkerSrc() {
    if (_worker_options.GlobalWorkerOptions.workerSrc) {
      return _worker_options.GlobalWorkerOptions.workerSrc;
    }
    if (typeof fallbackWorkerSrc !== 'undefined') {
      return fallbackWorkerSrc;
    }
    throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
  }
  function getMainThreadWorkerMessageHandler() {
    try {
      if (typeof window !== 'undefined') {
        return window.pdfjsWorker && window.pdfjsWorker.WorkerMessageHandler;
      }
    } catch (ex) {}
    return null;
  }
  var fakeWorkerFilesLoadedCapability = void 0;
  function setupFakeWorkerGlobal() {
    if (fakeWorkerFilesLoadedCapability) {
      return fakeWorkerFilesLoadedCapability.promise;
    }
    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
    var mainWorkerMessageHandler = getMainThreadWorkerMessageHandler();
    if (mainWorkerMessageHandler) {
      fakeWorkerFilesLoadedCapability.resolve(mainWorkerMessageHandler);
      return fakeWorkerFilesLoadedCapability.promise;
    }
    var loader = fakeWorkerFilesLoader || function () {
      return (0, _dom_utils.loadScript)(getWorkerSrc()).then(function () {
        return window.pdfjsWorker.WorkerMessageHandler;
      });
    };
    loader().then(fakeWorkerFilesLoadedCapability.resolve, fakeWorkerFilesLoadedCapability.reject);
    return fakeWorkerFilesLoadedCapability.promise;
  }
  function createCDNWrapper(url) {
    var wrapper = 'importScripts(\'' + url + '\');';
    return _util.URL.createObjectURL(new Blob([wrapper]));
  }
  var pdfWorkerPorts = new WeakMap();
  function PDFWorker() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$name = _ref2.name,
        name = _ref2$name === undefined ? null : _ref2$name,
        _ref2$port = _ref2.port,
        port = _ref2$port === undefined ? null : _ref2$port,
        _ref2$postMessageTran = _ref2.postMessageTransfers,
        postMessageTransfers = _ref2$postMessageTran === undefined ? true : _ref2$postMessageTran,
        _ref2$verbosity = _ref2.verbosity,
        verbosity = _ref2$verbosity === undefined ? (0, _util.getVerbosityLevel)() : _ref2$verbosity;

    if (port && pdfWorkerPorts.has(port)) {
      throw new Error('Cannot use more than one PDFWorker per port');
    }
    this.name = name;
    this.destroyed = false;
    this.postMessageTransfers = postMessageTransfers !== false;
    this.verbosity = verbosity;
    this._readyCapability = (0, _util.createPromiseCapability)();
    this._port = null;
    this._webWorker = null;
    this._messageHandler = null;
    if (port) {
      pdfWorkerPorts.set(port, this);
      this._initializeFromPort(port);
      return;
    }
    this._initialize();
  }
  PDFWorker.prototype = {
    get promise() {
      return this._readyCapability.promise;
    },
    get port() {
      return this._port;
    },
    get messageHandler() {
      return this._messageHandler;
    },
    _initializeFromPort: function PDFWorker_initializeFromPort(port) {
      this._port = port;
      this._messageHandler = new _message_handler.MessageHandler('main', 'worker', port);
      this._messageHandler.on('ready', function () {});
      this._readyCapability.resolve();
    },
    _initialize: function PDFWorker_initialize() {
      var _this6 = this;

      if (typeof Worker !== 'undefined' && !isWorkerDisabled && !getMainThreadWorkerMessageHandler()) {
        var workerSrc = getWorkerSrc();
        try {
          if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
            workerSrc = createCDNWrapper(new _util.URL(workerSrc, window.location).href);
          }
          var worker = new Worker(workerSrc);
          var messageHandler = new _message_handler.MessageHandler('main', 'worker', worker);
          var terminateEarly = function terminateEarly() {
            worker.removeEventListener('error', onWorkerError);
            messageHandler.destroy();
            worker.terminate();
            if (_this6.destroyed) {
              _this6._readyCapability.reject(new Error('Worker was destroyed'));
            } else {
              _this6._setupFakeWorker();
            }
          };
          var onWorkerError = function onWorkerError() {
            if (!_this6._webWorker) {
              terminateEarly();
            }
          };
          worker.addEventListener('error', onWorkerError);
          messageHandler.on('test', function (data) {
            worker.removeEventListener('error', onWorkerError);
            if (_this6.destroyed) {
              terminateEarly();
              return;
            }
            if (data && data.supportTypedArray) {
              _this6._messageHandler = messageHandler;
              _this6._port = worker;
              _this6._webWorker = worker;
              if (!data.supportTransfers) {
                _this6.postMessageTransfers = false;
              }
              _this6._readyCapability.resolve();
              messageHandler.send('configure', { verbosity: _this6.verbosity });
            } else {
              _this6._setupFakeWorker();
              messageHandler.destroy();
              worker.terminate();
            }
          });
          messageHandler.on('ready', function (data) {
            worker.removeEventListener('error', onWorkerError);
            if (_this6.destroyed) {
              terminateEarly();
              return;
            }
            try {
              sendTest();
            } catch (e) {
              _this6._setupFakeWorker();
            }
          });
          var sendTest = function sendTest() {
            var testObj = new Uint8Array([_this6.postMessageTransfers ? 255 : 0]);
            try {
              messageHandler.send('test', testObj, [testObj.buffer]);
            } catch (ex) {
              (0, _util.info)('Cannot use postMessage transfers');
              testObj[0] = 0;
              messageHandler.send('test', testObj);
            }
          };
          sendTest();
          return;
        } catch (e) {
          (0, _util.info)('The worker has been disabled.');
        }
      }
      this._setupFakeWorker();
    },
    _setupFakeWorker: function PDFWorker_setupFakeWorker() {
      var _this7 = this;

      if (!isWorkerDisabled) {
        (0, _util.warn)('Setting up fake worker.');
        isWorkerDisabled = true;
      }
      setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
        if (_this7.destroyed) {
          _this7._readyCapability.reject(new Error('Worker was destroyed'));
          return;
        }
        var port = new LoopbackPort();
        _this7._port = port;
        var id = 'fake' + nextFakeWorkerId++;
        var workerHandler = new _message_handler.MessageHandler(id + '_worker', id, port);
        WorkerMessageHandler.setup(workerHandler, port);
        var messageHandler = new _message_handler.MessageHandler(id, id + '_worker', port);
        _this7._messageHandler = messageHandler;
        _this7._readyCapability.resolve();
      }).catch(function (reason) {
        _this7._readyCapability.reject(new Error('Setting up fake worker failed: "' + reason.message + '".'));
      });
    },
    destroy: function PDFWorker_destroy() {
      this.destroyed = true;
      if (this._webWorker) {
        this._webWorker.terminate();
        this._webWorker = null;
      }
      pdfWorkerPorts.delete(this._port);
      this._port = null;
      if (this._messageHandler) {
        this._messageHandler.destroy();
        this._messageHandler = null;
      }
    }
  };
  PDFWorker.fromPort = function (params) {
    if (!params || !params.port) {
      throw new Error('PDFWorker.fromPort - invalid method signature.');
    }
    if (pdfWorkerPorts.has(params.port)) {
      return pdfWorkerPorts.get(params.port);
    }
    return new PDFWorker(params);
  };
  PDFWorker.getWorkerSrc = function () {
    return getWorkerSrc();
  };
  return PDFWorker;
}();

var WorkerTransport = function () {
  function WorkerTransport(messageHandler, loadingTask, networkStream, params) {
    _classCallCheck(this, WorkerTransport);

    this.messageHandler = messageHandler;
    this.loadingTask = loadingTask;
    this.commonObjs = new PDFObjects();
    this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
    this._params = params;
    this.CMapReaderFactory = new params.CMapReaderFactory({
      baseUrl: params.cMapUrl,
      isCompressed: params.cMapPacked
    });
    this.destroyed = false;
    this.destroyCapability = null;
    this._passwordCapability = null;
    this._networkStream = networkStream;
    this._fullReader = null;
    this._lastProgress = null;
    this.pageCache = [];
    this.pagePromises = [];
    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
    this.setupMessageHandler();
  }

  _createClass(WorkerTransport, [{
    key: 'destroy',
    value: function destroy() {
      var _this8 = this;

      if (this.destroyCapability) {
        return this.destroyCapability.promise;
      }
      this.destroyed = true;
      this.destroyCapability = (0, _util.createPromiseCapability)();
      if (this._passwordCapability) {
        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
      }
      var waitOn = [];
      this.pageCache.forEach(function (page) {
        if (page) {
          waitOn.push(page._destroy());
        }
      });
      this.pageCache = [];
      this.pagePromises = [];
      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
      waitOn.push(terminated);
      Promise.all(waitOn).then(function () {
        _this8.fontLoader.clear();
        if (_this8._networkStream) {
          _this8._networkStream.cancelAllRequests();
        }
        if (_this8.messageHandler) {
          _this8.messageHandler.destroy();
          _this8.messageHandler = null;
        }
        _this8.destroyCapability.resolve();
      }, this.destroyCapability.reject);
      return this.destroyCapability.promise;
    }
  }, {
    key: 'setupMessageHandler',
    value: function setupMessageHandler() {
      var messageHandler = this.messageHandler,
          loadingTask = this.loadingTask;

      messageHandler.on('GetReader', function (data, sink) {
        var _this9 = this;

        (0, _util.assert)(this._networkStream);
        this._fullReader = this._networkStream.getFullReader();
        this._fullReader.onProgress = function (evt) {
          _this9._lastProgress = {
            loaded: evt.loaded,
            total: evt.total
          };
        };
        sink.onPull = function () {
          _this9._fullReader.read().then(function (_ref3) {
            var value = _ref3.value,
                done = _ref3.done;

            if (done) {
              sink.close();
              return;
            }
            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          }).catch(function (reason) {
            sink.error(reason);
          });
        };
        sink.onCancel = function (reason) {
          _this9._fullReader.cancel(reason);
        };
      }, this);
      messageHandler.on('ReaderHeadersReady', function (data) {
        var _this10 = this;

        var headersCapability = (0, _util.createPromiseCapability)();
        var fullReader = this._fullReader;
        fullReader.headersReady.then(function () {
          if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
            if (_this10._lastProgress && loadingTask.onProgress) {
              loadingTask.onProgress(_this10._lastProgress);
            }
            fullReader.onProgress = function (evt) {
              if (loadingTask.onProgress) {
                loadingTask.onProgress({
                  loaded: evt.loaded,
                  total: evt.total
                });
              }
            };
          }
          headersCapability.resolve({
            isStreamingSupported: fullReader.isStreamingSupported,
            isRangeSupported: fullReader.isRangeSupported,
            contentLength: fullReader.contentLength
          });
        }, headersCapability.reject);
        return headersCapability.promise;
      }, this);
      messageHandler.on('GetRangeReader', function (data, sink) {
        (0, _util.assert)(this._networkStream);
        var rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
        sink.onPull = function () {
          rangeReader.read().then(function (_ref4) {
            var value = _ref4.value,
                done = _ref4.done;

            if (done) {
              sink.close();
              return;
            }
            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          }).catch(function (reason) {
            sink.error(reason);
          });
        };
        sink.onCancel = function (reason) {
          rangeReader.cancel(reason);
        };
      }, this);
      messageHandler.on('GetDoc', function (_ref5) {
        var pdfInfo = _ref5.pdfInfo;

        this.numPages = pdfInfo.numPages;
        this.pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
        loadingTask._capability.resolve(this.pdfDocument);
      }, this);
      messageHandler.on('PasswordRequest', function (exception) {
        var _this11 = this;

        this._passwordCapability = (0, _util.createPromiseCapability)();
        if (loadingTask.onPassword) {
          var updatePassword = function updatePassword(password) {
            _this11._passwordCapability.resolve({ password: password });
          };
          try {
            loadingTask.onPassword(updatePassword, exception.code);
          } catch (ex) {
            this._passwordCapability.reject(ex);
          }
        } else {
          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
        }
        return this._passwordCapability.promise;
      }, this);
      messageHandler.on('PasswordException', function (exception) {
        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
      }, this);
      messageHandler.on('InvalidPDF', function (exception) {
        loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
      }, this);
      messageHandler.on('MissingPDF', function (exception) {
        loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
      }, this);
      messageHandler.on('UnexpectedResponse', function (exception) {
        loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
      }, this);
      messageHandler.on('UnknownError', function (exception) {
        loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
      }, this);
      messageHandler.on('DataLoaded', function (data) {
        if (loadingTask.onProgress) {
          loadingTask.onProgress({
            loaded: data.length,
            total: data.length
          });
        }
        this.downloadInfoCapability.resolve(data);
      }, this);
      messageHandler.on('StartRenderPage', function (data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageIndex];
        page._stats.timeEnd('Page Request');
        page._startRenderPage(data.transparency, data.intent);
      }, this);
      messageHandler.on('RenderPageChunk', function (data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageIndex];
        page._renderPageChunk(data.operatorList, data.intent);
      }, this);
      messageHandler.on('commonobj', function (data) {
        var _this12 = this;

        if (this.destroyed) {
          return;
        }

        var _data = _slicedToArray(data, 3),
            id = _data[0],
            type = _data[1],
            exportedData = _data[2];

        if (this.commonObjs.hasData(id)) {
          return;
        }
        switch (type) {
          case 'Font':
            var params = this._params;
            if ('error' in exportedData) {
              var exportedError = exportedData.error;
              (0, _util.warn)('Error during font loading: ' + exportedError);
              this.commonObjs.resolve(id, exportedError);
              break;
            }
            var fontRegistry = null;
            if (params.pdfBug && _global_scope2.default.FontInspector && _global_scope2.default.FontInspector.enabled) {
              fontRegistry = {
                registerFont: function registerFont(font, url) {
                  _global_scope2.default['FontInspector'].fontAdded(font, url);
                }
              };
            }
            var font = new _font_loader.FontFaceObject(exportedData, {
              isEvalSupported: params.isEvalSupported,
              disableFontFace: params.disableFontFace,
              ignoreErrors: params.ignoreErrors,
              onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
              fontRegistry: fontRegistry
            });
            var fontReady = function fontReady(fontObjs) {
              _this12.commonObjs.resolve(id, font);
            };
            this.fontLoader.bind([font], fontReady);
            break;
          case 'FontPath':
            this.commonObjs.resolve(id, exportedData);
            break;
          default:
            throw new Error('Got unknown common object type ' + type);
        }
      }, this);
      messageHandler.on('obj', function (data) {
        if (this.destroyed) {
          return;
        }

        var _data2 = _slicedToArray(data, 4),
            id = _data2[0],
            pageIndex = _data2[1],
            type = _data2[2],
            imageData = _data2[3];

        var pageProxy = this.pageCache[pageIndex];
        if (pageProxy.objs.hasData(id)) {
          return;
        }
        switch (type) {
          case 'JpegStream':
            return new Promise(function (resolve, reject) {
              var img = new Image();
              img.onload = function () {
                resolve(img);
              };
              img.onerror = function () {
                reject(new Error('Error during JPEG image loading'));
              };
              img.src = imageData;
            }).then(function (img) {
              pageProxy.objs.resolve(id, img);
            });
          case 'Image':
            pageProxy.objs.resolve(id, imageData);
            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
              pageProxy.cleanupAfterRender = true;
            }
            break;
          default:
            throw new Error('Got unknown object type ' + type);
        }
      }, this);
      messageHandler.on('DocProgress', function (data) {
        if (this.destroyed) {
          return;
        }
        if (loadingTask.onProgress) {
          loadingTask.onProgress({
            loaded: data.loaded,
            total: data.total
          });
        }
      }, this);
      messageHandler.on('PageError', function (data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageNum - 1];
        var intentState = page.intentStates[data.intent];
        if (intentState.displayReadyCapability) {
          intentState.displayReadyCapability.reject(data.error);
        } else {
          throw new Error(data.error);
        }
        if (intentState.operatorList) {
          intentState.operatorList.lastChunk = true;
          for (var i = 0; i < intentState.renderTasks.length; i++) {
            intentState.renderTasks[i].operatorListChanged();
          }
        }
      }, this);
      messageHandler.on('UnsupportedFeature', this._onUnsupportedFeature, this);
      messageHandler.on('JpegDecode', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }
        if (typeof document === 'undefined') {
          return Promise.reject(new Error('"document" is not defined.'));
        }

        var _data3 = _slicedToArray(data, 2),
            imageUrl = _data3[0],
            components = _data3[1];

        if (components !== 3 && components !== 1) {
          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
        }
        return new Promise(function (resolve, reject) {
          var img = new Image();
          img.onload = function () {
            var width = img.width;
            var height = img.height;
            var size = width * height;
            var rgbaLength = size * 4;
            var buf = new Uint8ClampedArray(size * components);
            var tmpCanvas = document.createElement('canvas');
            tmpCanvas.width = width;
            tmpCanvas.height = height;
            var tmpCtx = tmpCanvas.getContext('2d');
            tmpCtx.drawImage(img, 0, 0);
            var data = tmpCtx.getImageData(0, 0, width, height).data;
            if (components === 3) {
              for (var i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
                buf[j] = data[i];
                buf[j + 1] = data[i + 1];
                buf[j + 2] = data[i + 2];
              }
            } else if (components === 1) {
              for (var _i = 0, _j = 0; _i < rgbaLength; _i += 4, _j++) {
                buf[_j] = data[_i];
              }
            }
            resolve({
              data: buf,
              width: width,
              height: height
            });
          };
          img.onerror = function () {
            reject(new Error('JpegDecode failed to load image'));
          };
          img.src = imageUrl;
        });
      }, this);
      messageHandler.on('FetchBuiltInCMap', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }
        return this.CMapReaderFactory.fetch({ name: data.name });
      }, this);
    }
  }, {
    key: '_onUnsupportedFeature',
    value: function _onUnsupportedFeature(_ref6) {
      var featureId = _ref6.featureId;

      if (this.destroyed) {
        return;
      }
      if (this.loadingTask.onUnsupportedFeature) {
        this.loadingTask.onUnsupportedFeature(featureId);
      }
    }
  }, {
    key: 'getData',
    value: function getData() {
      return this.messageHandler.sendWithPromise('GetData', null);
    }
  }, {
    key: 'getPage',
    value: function getPage(pageNumber) {
      var _this13 = this;

      if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
        return Promise.reject(new Error('Invalid page request'));
      }
      var pageIndex = pageNumber - 1;
      if (pageIndex in this.pagePromises) {
        return this.pagePromises[pageIndex];
      }
      var promise = this.messageHandler.sendWithPromise('GetPage', { pageIndex: pageIndex }).then(function (pageInfo) {
        if (_this13.destroyed) {
          throw new Error('Transport destroyed');
        }
        var page = new PDFPageProxy(pageIndex, pageInfo, _this13, _this13._params.pdfBug);
        _this13.pageCache[pageIndex] = page;
        return page;
      });
      this.pagePromises[pageIndex] = promise;
      return promise;
    }
  }, {
    key: 'getPageIndex',
    value: function getPageIndex(ref) {
      return this.messageHandler.sendWithPromise('GetPageIndex', { ref: ref }).catch(function (reason) {
        return Promise.reject(new Error(reason));
      });
    }
  }, {
    key: 'getAnnotations',
    value: function getAnnotations(pageIndex, intent) {
      return this.messageHandler.sendWithPromise('GetAnnotations', {
        pageIndex: pageIndex,
        intent: intent
      });
    }
  }, {
    key: 'getDestinations',
    value: function getDestinations() {
      return this.messageHandler.sendWithPromise('GetDestinations', null);
    }
  }, {
    key: 'getDestination',
    value: function getDestination(id) {
      if (typeof id !== 'string') {
        return Promise.reject(new Error('Invalid destination request.'));
      }
      return this.messageHandler.sendWithPromise('GetDestination', { id: id });
    }
  }, {
    key: 'getPageLabels',
    value: function getPageLabels() {
      return this.messageHandler.sendWithPromise('GetPageLabels', null);
    }
  }, {
    key: 'getPageMode',
    value: function getPageMode() {
      return this.messageHandler.sendWithPromise('GetPageMode', null);
    }
  }, {
    key: 'getAttachments',
    value: function getAttachments() {
      return this.messageHandler.sendWithPromise('GetAttachments', null);
    }
  }, {
    key: 'getJavaScript',
    value: function getJavaScript() {
      return this.messageHandler.sendWithPromise('GetJavaScript', null);
    }
  }, {
    key: 'getOutline',
    value: function getOutline() {
      return this.messageHandler.sendWithPromise('GetOutline', null);
    }
  }, {
    key: 'getPermissions',
    value: function getPermissions() {
      return this.messageHandler.sendWithPromise('GetPermissions', null);
    }
  }, {
    key: 'getMetadata',
    value: function getMetadata() {
      var _this14 = this;

      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function (results) {
        return {
          info: results[0],
          metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
          contentDispositionFilename: _this14._fullReader ? _this14._fullReader.filename : null
        };
      });
    }
  }, {
    key: 'getStats',
    value: function getStats() {
      return this.messageHandler.sendWithPromise('GetStats', null);
    }
  }, {
    key: 'startCleanup',
    value: function startCleanup() {
      var _this15 = this;

      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
        for (var i = 0, ii = _this15.pageCache.length; i < ii; i++) {
          var page = _this15.pageCache[i];
          if (page) {
            page.cleanup();
          }
        }
        _this15.commonObjs.clear();
        _this15.fontLoader.clear();
      });
    }
  }, {
    key: 'loadingParams',
    get: function get() {
      var params = this._params;
      return (0, _util.shadow)(this, 'loadingParams', {
        disableAutoFetch: params.disableAutoFetch,
        disableCreateObjectURL: params.disableCreateObjectURL,
        disableFontFace: params.disableFontFace,
        nativeImageDecoderSupport: params.nativeImageDecoderSupport
      });
    }
  }]);

  return WorkerTransport;
}();

var PDFObjects = function PDFObjectsClosure() {
  function PDFObjects() {
    this.objs = Object.create(null);
  }
  PDFObjects.prototype = {
    ensureObj: function PDFObjects_ensureObj(objId) {
      if (this.objs[objId]) {
        return this.objs[objId];
      }
      var obj = {
        capability: (0, _util.createPromiseCapability)(),
        data: null,
        resolved: false
      };
      this.objs[objId] = obj;
      return obj;
    },
    get: function PDFObjects_get(objId, callback) {
      if (callback) {
        this.ensureObj(objId).capability.promise.then(callback);
        return null;
      }
      var obj = this.objs[objId];
      if (!obj || !obj.resolved) {
        throw new Error('Requesting object that isn\'t resolved yet ' + objId);
      }
      return obj.data;
    },
    resolve: function PDFObjects_resolve(objId, data) {
      var obj = this.ensureObj(objId);
      obj.resolved = true;
      obj.data = data;
      obj.capability.resolve(data);
    },
    isResolved: function PDFObjects_isResolved(objId) {
      var objs = this.objs;
      if (!objs[objId]) {
        return false;
      }
      return objs[objId].resolved;
    },
    hasData: function PDFObjects_hasData(objId) {
      return this.isResolved(objId);
    },
    getData: function PDFObjects_getData(objId) {
      var objs = this.objs;
      if (!objs[objId] || !objs[objId].resolved) {
        return null;
      }
      return objs[objId].data;
    },
    clear: function PDFObjects_clear() {
      this.objs = Object.create(null);
    }
  };
  return PDFObjects;
}();
var RenderTask = function RenderTaskClosure() {
  function RenderTask(internalRenderTask) {
    this._internalRenderTask = internalRenderTask;
    this.onContinue = null;
  }
  RenderTask.prototype = {
    get promise() {
      return this._internalRenderTask.capability.promise;
    },
    cancel: function RenderTask_cancel() {
      this._internalRenderTask.cancel();
    },
    then: function RenderTask_then(onFulfilled, onRejected) {
      return this.promise.then.apply(this.promise, arguments);
    }
  };
  return RenderTask;
}();
var InternalRenderTask = function InternalRenderTaskClosure() {
  var canvasInRendering = new WeakMap();
  function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory, webGLContext) {
    var pdfBug = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;

    this.callback = callback;
    this.params = params;
    this.objs = objs;
    this.commonObjs = commonObjs;
    this.operatorListIdx = null;
    this.operatorList = operatorList;
    this.pageNumber = pageNumber;
    this.canvasFactory = canvasFactory;
    this.webGLContext = webGLContext;
    this._pdfBug = pdfBug;
    this.running = false;
    this.graphicsReadyCallback = null;
    this.graphicsReady = false;
    this.useRequestAnimationFrame = false;
    this.cancelled = false;
    this.capability = (0, _util.createPromiseCapability)();
    this.task = new RenderTask(this);
    this._continueBound = this._continue.bind(this);
    this._scheduleNextBound = this._scheduleNext.bind(this);
    this._nextBound = this._next.bind(this);
    this._canvas = params.canvasContext.canvas;
  }
  InternalRenderTask.prototype = {
    initializeGraphics: function initializeGraphics(transparency) {
      if (this.cancelled) {
        return;
      }
      if (this._canvas) {
        if (canvasInRendering.has(this._canvas)) {
          throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.');
        }
        canvasInRendering.set(this._canvas, this);
      }
      if (this._pdfBug && _global_scope2.default.StepperManager && _global_scope2.default.StepperManager.enabled) {
        this.stepper = _global_scope2.default.StepperManager.create(this.pageNumber - 1);
        this.stepper.init(this.operatorList);
        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
      }
      var params = this.params;
      this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext, params.imageLayer);
      this.gfx.beginDrawing({
        transform: params.transform,
        viewport: params.viewport,
        transparency: transparency,
        background: params.background
      });
      this.operatorListIdx = 0;
      this.graphicsReady = true;
      if (this.graphicsReadyCallback) {
        this.graphicsReadyCallback();
      }
    },

    cancel: function InternalRenderTask_cancel() {
      this.running = false;
      this.cancelled = true;
      if (this._canvas) {
        canvasInRendering.delete(this._canvas);
      }
      this.callback(new _dom_utils.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'));
    },
    operatorListChanged: function InternalRenderTask_operatorListChanged() {
      if (!this.graphicsReady) {
        if (!this.graphicsReadyCallback) {
          this.graphicsReadyCallback = this._continueBound;
        }
        return;
      }
      if (this.stepper) {
        this.stepper.updateOperatorList(this.operatorList);
      }
      if (this.running) {
        return;
      }
      this._continue();
    },
    _continue: function InternalRenderTask__continue() {
      this.running = true;
      if (this.cancelled) {
        return;
      }
      if (this.task.onContinue) {
        this.task.onContinue(this._scheduleNextBound);
      } else {
        this._scheduleNext();
      }
    },
    _scheduleNext: function InternalRenderTask__scheduleNext() {
      var _this16 = this;

      if (this.useRequestAnimationFrame && typeof window !== 'undefined') {
        window.requestAnimationFrame(function () {
          _this16._nextBound().catch(_this16.callback);
        });
      } else {
        Promise.resolve().then(this._nextBound).catch(this.callback);
      }
    },
    _next: function InternalRenderTask__next() {
      var _this17 = this;

      return new Promise(function () {
        if (_this17.cancelled) {
          return;
        }
        _this17.operatorListIdx = _this17.gfx.executeOperatorList(_this17.operatorList, _this17.operatorListIdx, _this17._continueBound, _this17.stepper);
        if (_this17.operatorListIdx === _this17.operatorList.argsArray.length) {
          _this17.running = false;
          if (_this17.operatorList.lastChunk) {
            _this17.gfx.endDrawing();
            if (_this17._canvas) {
              canvasInRendering.delete(_this17._canvas);
            }
            _this17.callback();
          }
        }
      });
    }
  };
  return InternalRenderTask;
}();
var version, build;
{
  exports.version = version = '2.0.943';
  exports.build = build = 'dc98bf76';
}
exports.getDocument = getDocument;
exports.LoopbackPort = LoopbackPort;
exports.PDFDataRangeTransport = PDFDataRangeTransport;
exports.PDFWorker = PDFWorker;
exports.PDFDocumentProxy = PDFDocumentProxy;
exports.PDFPageProxy = PDFPageProxy;
exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
exports.version = version;
exports.build = build;

/***/ }),
/* 130 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadScript = exports.DummyStatTimer = exports.StatTimer = exports.DOMSVGFactory = exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.LinkTarget = exports.getFilenameFromUrl = exports.addLinkAttributes = exports.RenderingCancelledException = exports.PageViewport = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
var SVG_NS = 'http://www.w3.org/2000/svg';

var DOMCanvasFactory = function () {
  function DOMCanvasFactory() {
    _classCallCheck(this, DOMCanvasFactory);
  }

  _createClass(DOMCanvasFactory, [{
    key: 'create',
    value: function create(width, height) {
      if (width <= 0 || height <= 0) {
        throw new Error('invalid canvas size');
      }
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      return {
        canvas: canvas,
        context: context
      };
    }
  }, {
    key: 'reset',
    value: function reset(canvasAndContext, width, height) {
      if (!canvasAndContext.canvas) {
        throw new Error('canvas is not specified');
      }
      if (width <= 0 || height <= 0) {
        throw new Error('invalid canvas size');
      }
      canvasAndContext.canvas.width = width;
      canvasAndContext.canvas.height = height;
    }
  }, {
    key: 'destroy',
    value: function destroy(canvasAndContext) {
      if (!canvasAndContext.canvas) {
        throw new Error('canvas is not specified');
      }
      canvasAndContext.canvas.width = 0;
      canvasAndContext.canvas.height = 0;
      canvasAndContext.canvas = null;
      canvasAndContext.context = null;
    }
  }]);

  return DOMCanvasFactory;
}();

var DOMCMapReaderFactory = function () {
  function DOMCMapReaderFactory(_ref) {
    var _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
        _ref$isCompressed = _ref.isCompressed,
        isCompressed = _ref$isCompressed === undefined ? false : _ref$isCompressed;

    _classCallCheck(this, DOMCMapReaderFactory);

    this.baseUrl = baseUrl;
    this.isCompressed = isCompressed;
  }

  _createClass(DOMCMapReaderFactory, [{
    key: 'fetch',
    value: function fetch(_ref2) {
      var _this = this;

      var name = _ref2.name;

      if (!this.baseUrl) {
        return Promise.reject(new Error('The CMap "baseUrl" parameter must be specified, ensure that ' + 'the "cMapUrl" and "cMapPacked" API parameters are provided.'));
      }
      if (!name) {
        return Promise.reject(new Error('CMap name must be specified.'));
      }
      return new Promise(function (resolve, reject) {
        var url = _this.baseUrl + name + (_this.isCompressed ? '.bcmap' : '');
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        if (_this.isCompressed) {
          request.responseType = 'arraybuffer';
        }
        request.onreadystatechange = function () {
          if (request.readyState !== XMLHttpRequest.DONE) {
            return;
          }
          if (request.status === 200 || request.status === 0) {
            var data = void 0;
            if (_this.isCompressed && request.response) {
              data = new Uint8Array(request.response);
            } else if (!_this.isCompressed && request.responseText) {
              data = (0, _util.stringToBytes)(request.responseText);
            }
            if (data) {
              resolve({
                cMapData: data,
                compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
              });
              return;
            }
          }
          reject(new Error('Unable to load ' + (_this.isCompressed ? 'binary ' : '') + 'CMap at: ' + url));
        };
        request.send(null);
      });
    }
  }]);

  return DOMCMapReaderFactory;
}();

var DOMSVGFactory = function () {
  function DOMSVGFactory() {
    _classCallCheck(this, DOMSVGFactory);
  }

  _createClass(DOMSVGFactory, [{
    key: 'create',
    value: function create(width, height) {
      (0, _util.assert)(width > 0 && height > 0, 'Invalid SVG dimensions');
      var svg = document.createElementNS(SVG_NS, 'svg:svg');
      svg.setAttribute('version', '1.1');
      svg.setAttribute('width', width + 'px');
      svg.setAttribute('height', height + 'px');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
      return svg;
    }
  }, {
    key: 'createElement',
    value: function createElement(type) {
      (0, _util.assert)(typeof type === 'string', 'Invalid SVG element type');
      return document.createElementNS(SVG_NS, type);
    }
  }]);

  return DOMSVGFactory;
}();

var PageViewport = function () {
  function PageViewport(_ref3) {
    var viewBox = _ref3.viewBox,
        scale = _ref3.scale,
        rotation = _ref3.rotation,
        _ref3$offsetX = _ref3.offsetX,
        offsetX = _ref3$offsetX === undefined ? 0 : _ref3$offsetX,
        _ref3$offsetY = _ref3.offsetY,
        offsetY = _ref3$offsetY === undefined ? 0 : _ref3$offsetY,
        _ref3$dontFlip = _ref3.dontFlip,
        dontFlip = _ref3$dontFlip === undefined ? false : _ref3$dontFlip;

    _classCallCheck(this, PageViewport);

    this.viewBox = viewBox;
    this.scale = scale;
    this.rotation = rotation;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    var centerX = (viewBox[2] + viewBox[0]) / 2;
    var centerY = (viewBox[3] + viewBox[1]) / 2;
    var rotateA = void 0,
        rotateB = void 0,
        rotateC = void 0,
        rotateD = void 0;
    rotation = rotation % 360;
    rotation = rotation < 0 ? rotation + 360 : rotation;
    switch (rotation) {
      case 180:
        rotateA = -1;
        rotateB = 0;
        rotateC = 0;
        rotateD = 1;
        break;
      case 90:
        rotateA = 0;
        rotateB = 1;
        rotateC = 1;
        rotateD = 0;
        break;
      case 270:
        rotateA = 0;
        rotateB = -1;
        rotateC = -1;
        rotateD = 0;
        break;
      default:
        rotateA = 1;
        rotateB = 0;
        rotateC = 0;
        rotateD = -1;
        break;
    }
    if (dontFlip) {
      rotateC = -rotateC;
      rotateD = -rotateD;
    }
    var offsetCanvasX = void 0,
        offsetCanvasY = void 0;
    var width = void 0,
        height = void 0;
    if (rotateA === 0) {
      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
    } else {
      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
    }
    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
    this.width = width;
    this.height = height;
  }

  _createClass(PageViewport, [{
    key: 'clone',
    value: function clone() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$scale = _ref4.scale,
          scale = _ref4$scale === undefined ? this.scale : _ref4$scale,
          _ref4$rotation = _ref4.rotation,
          rotation = _ref4$rotation === undefined ? this.rotation : _ref4$rotation,
          _ref4$dontFlip = _ref4.dontFlip,
          dontFlip = _ref4$dontFlip === undefined ? false : _ref4$dontFlip;

      return new PageViewport({
        viewBox: this.viewBox.slice(),
        scale: scale,
        rotation: rotation,
        offsetX: this.offsetX,
        offsetY: this.offsetY,
        dontFlip: dontFlip
      });
    }
  }, {
    key: 'convertToViewportPoint',
    value: function convertToViewportPoint(x, y) {
      return _util.Util.applyTransform([x, y], this.transform);
    }
  }, {
    key: 'convertToViewportRectangle',
    value: function convertToViewportRectangle(rect) {
      var tl = _util.Util.applyTransform([rect[0], rect[1]], this.transform);
      var br = _util.Util.applyTransform([rect[2], rect[3]], this.transform);
      return [tl[0], tl[1], br[0], br[1]];
    }
  }, {
    key: 'convertToPdfPoint',
    value: function convertToPdfPoint(x, y) {
      return _util.Util.applyInverseTransform([x, y], this.transform);
    }
  }]);

  return PageViewport;
}();

var RenderingCancelledException = function RenderingCancelledException() {
  function RenderingCancelledException(msg, type) {
    this.message = msg;
    this.type = type;
  }
  RenderingCancelledException.prototype = new Error();
  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
  RenderingCancelledException.constructor = RenderingCancelledException;
  return RenderingCancelledException;
}();
var LinkTarget = {
  NONE: 0,
  SELF: 1,
  BLANK: 2,
  PARENT: 3,
  TOP: 4
};
var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];
function addLinkAttributes(link) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      url = _ref5.url,
      target = _ref5.target,
      rel = _ref5.rel;

  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';
  if (url) {
    var LinkTargetValues = Object.values(LinkTarget);
    var targetIndex = LinkTargetValues.includes(target) ? target : LinkTarget.NONE;
    link.target = LinkTargetStringMap[targetIndex];
    link.rel = typeof rel === 'string' ? rel : DEFAULT_LINK_REL;
  }
}
function getFilenameFromUrl(url) {
  var anchor = url.indexOf('#');
  var query = url.indexOf('?');
  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
  return url.substring(url.lastIndexOf('/', end) + 1, end);
}

var StatTimer = function () {
  function StatTimer() {
    var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    _classCallCheck(this, StatTimer);

    this.enabled = !!enable;
    this.started = Object.create(null);
    this.times = [];
  }

  _createClass(StatTimer, [{
    key: 'time',
    value: function time(name) {
      if (!this.enabled) {
        return;
      }
      if (name in this.started) {
        (0, _util.warn)('Timer is already running for ' + name);
      }
      this.started[name] = Date.now();
    }
  }, {
    key: 'timeEnd',
    value: function timeEnd(name) {
      if (!this.enabled) {
        return;
      }
      if (!(name in this.started)) {
        (0, _util.warn)('Timer has not been started for ' + name);
      }
      this.times.push({
        'name': name,
        'start': this.started[name],
        'end': Date.now()
      });
      delete this.started[name];
    }
  }, {
    key: 'toString',
    value: function toString() {
      var times = this.times;
      var out = '',
          longest = 0;
      for (var i = 0, ii = times.length; i < ii; ++i) {
        var name = times[i]['name'];
        if (name.length > longest) {
          longest = name.length;
        }
      }
      for (var _i = 0, _ii = times.length; _i < _ii; ++_i) {
        var span = times[_i];
        var duration = span.end - span.start;
        out += span['name'].padEnd(longest) + ' ' + duration + 'ms\n';
      }
      return out;
    }
  }]);

  return StatTimer;
}();

var DummyStatTimer = function () {
  function DummyStatTimer() {
    _classCallCheck(this, DummyStatTimer);

    (0, _util.unreachable)('Cannot initialize DummyStatTimer.');
  }

  _createClass(DummyStatTimer, null, [{
    key: 'time',
    value: function time(name) {}
  }, {
    key: 'timeEnd',
    value: function timeEnd(name) {}
  }, {
    key: 'toString',
    value: function toString() {
      return '';
    }
  }]);

  return DummyStatTimer;
}();

function loadScript(src) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = function () {
      reject(new Error('Cannot load script at: ' + script.src));
    };
    (document.head || document.documentElement).appendChild(script);
  });
}
exports.PageViewport = PageViewport;
exports.RenderingCancelledException = RenderingCancelledException;
exports.addLinkAttributes = addLinkAttributes;
exports.getFilenameFromUrl = getFilenameFromUrl;
exports.LinkTarget = LinkTarget;
exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
exports.DOMCanvasFactory = DOMCanvasFactory;
exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
exports.DOMSVGFactory = DOMSVGFactory;
exports.StatTimer = StatTimer;
exports.DummyStatTimer = DummyStatTimer;
exports.loadScript = loadScript;

/***/ }),
/* 131 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontLoader = exports.FontFaceObject = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(1);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseFontLoader = function () {
  function BaseFontLoader(docId) {
    _classCallCheck(this, BaseFontLoader);

    if (this.constructor === BaseFontLoader) {
      (0, _util.unreachable)('Cannot initialize BaseFontLoader.');
    }
    this.docId = docId;
    this.nativeFontFaces = [];
    this.styleElement = null;
    this.loadingContext = {
      requests: [],
      nextRequestId: 0
    };
  }

  _createClass(BaseFontLoader, [{
    key: 'addNativeFontFace',
    value: function addNativeFontFace(nativeFontFace) {
      this.nativeFontFaces.push(nativeFontFace);
      document.fonts.add(nativeFontFace);
    }
  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var styleElement = this.styleElement;
      if (!styleElement) {
        styleElement = this.styleElement = document.createElement('style');
        styleElement.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId;
        document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
      }
      var styleSheet = styleElement.sheet;
      styleSheet.insertRule(rule, styleSheet.cssRules.length);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.nativeFontFaces.forEach(function (nativeFontFace) {
        document.fonts.delete(nativeFontFace);
      });
      this.nativeFontFaces.length = 0;
      if (this.styleElement) {
        this.styleElement.remove();
        this.styleElement = null;
      }
    }
  }, {
    key: 'bind',
    value: function bind(fonts, callback) {
      var rules = [];
      var fontsToLoad = [];
      var fontLoadPromises = [];
      var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
        return nativeFontFace.loaded.catch(function (reason) {
          (0, _util.warn)('Failed to load font "' + nativeFontFace.family + '": ' + reason);
        });
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = fonts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var font = _step.value;

          if (font.attached || font.missingFile) {
            continue;
          }
          font.attached = true;
          if (this.isFontLoadingAPISupported) {
            var nativeFontFace = font.createNativeFontFace();
            if (nativeFontFace) {
              this.addNativeFontFace(nativeFontFace);
              fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
            }
          } else {
            var rule = font.createFontFaceRule();
            if (rule) {
              this.insertRule(rule);
              rules.push(rule);
              fontsToLoad.push(font);
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var request = this._queueLoadingCallback(callback);
      if (this.isFontLoadingAPISupported) {
        Promise.all(fontLoadPromises).then(request.complete);
      } else if (rules.length > 0 && !this.isSyncFontLoadingSupported) {
        this._prepareFontLoadEvent(rules, fontsToLoad, request);
      } else {
        request.complete();
      }
    }
  }, {
    key: '_queueLoadingCallback',
    value: function _queueLoadingCallback(callback) {
      function completeRequest() {
        (0, _util.assert)(!request.done, 'completeRequest() cannot be called twice.');
        request.done = true;
        while (context.requests.length > 0 && context.requests[0].done) {
          var otherRequest = context.requests.shift();
          setTimeout(otherRequest.callback, 0);
        }
      }
      var context = this.loadingContext;
      var request = {
        id: 'pdfjs-font-loading-' + context.nextRequestId++,
        done: false,
        complete: completeRequest,
        callback: callback
      };
      context.requests.push(request);
      return request;
    }
  }, {
    key: '_prepareFontLoadEvent',
    value: function _prepareFontLoadEvent(rules, fontsToLoad, request) {
      (0, _util.unreachable)('Abstract method `_prepareFontLoadEvent`.');
    }
  }, {
    key: 'isFontLoadingAPISupported',
    get: function get() {
      (0, _util.unreachable)('Abstract method `isFontLoadingAPISupported`.');
    }
  }, {
    key: 'isSyncFontLoadingSupported',
    get: function get() {
      (0, _util.unreachable)('Abstract method `isSyncFontLoadingSupported`.');
    }
  }, {
    key: '_loadTestFont',
    get: function get() {
      (0, _util.unreachable)('Abstract method `_loadTestFont`.');
    }
  }]);

  return BaseFontLoader;
}();

var FontLoader = void 0;
{
  exports.FontLoader = FontLoader = function (_BaseFontLoader) {
    _inherits(GenericFontLoader, _BaseFontLoader);

    function GenericFontLoader(docId) {
      _classCallCheck(this, GenericFontLoader);

      var _this = _possibleConstructorReturn(this, (GenericFontLoader.__proto__ || Object.getPrototypeOf(GenericFontLoader)).call(this, docId));

      _this.loadTestFontId = 0;
      return _this;
    }

    _createClass(GenericFontLoader, [{
      key: '_prepareFontLoadEvent',
      value: function _prepareFontLoadEvent(rules, fonts, request) {
        function int32(data, offset) {
          return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
        }
        function spliceString(s, offset, remove, insert) {
          var chunk1 = s.substring(0, offset);
          var chunk2 = s.substring(offset + remove);
          return chunk1 + insert + chunk2;
        }
        var i = void 0,
            ii = void 0;
        var canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = 1;
        var ctx = canvas.getContext('2d');
        var called = 0;
        function isFontReady(name, callback) {
          called++;
          if (called > 30) {
            (0, _util.warn)('Load test font never loaded.');
            callback();
            return;
          }
          ctx.font = '30px ' + name;
          ctx.fillText('.', 0, 20);
          var imageData = ctx.getImageData(0, 0, 1, 1);
          if (imageData.data[3] > 0) {
            callback();
            return;
          }
          setTimeout(isFontReady.bind(null, name, callback));
        }
        var loadTestFontId = 'lt' + Date.now() + this.loadTestFontId++;
        var data = this._loadTestFont;
        var COMMENT_OFFSET = 976;
        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
        var CFF_CHECKSUM_OFFSET = 16;
        var XXXX_VALUE = 0x58585858;
        var checksum = int32(data, CFF_CHECKSUM_OFFSET);
        for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
          checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
        }
        if (i < loadTestFontId.length) {
          checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
        }
        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
        var url = 'url(data:font/opentype;base64,' + btoa(data) + ');';
        var rule = '@font-face {font-family:"' + loadTestFontId + '";src:' + url + '}';
        this.insertRule(rule);
        var names = [];
        for (i = 0, ii = fonts.length; i < ii; i++) {
          names.push(fonts[i].loadedName);
        }
        names.push(loadTestFontId);
        var div = document.createElement('div');
        div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');
        for (i = 0, ii = names.length; i < ii; ++i) {
          var span = document.createElement('span');
          span.textContent = 'Hi';
          span.style.fontFamily = names[i];
          div.appendChild(span);
        }
        document.body.appendChild(div);
        isFontReady(loadTestFontId, function () {
          document.body.removeChild(div);
          request.complete();
        });
      }
    }, {
      key: 'isFontLoadingAPISupported',
      get: function get() {
        var supported = typeof document !== 'undefined' && !!document.fonts;
        if (supported && typeof navigator !== 'undefined') {
          var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
          if (m && m[1] < 63) {
            supported = false;
          }
        }
        return (0, _util.shadow)(this, 'isFontLoadingAPISupported', supported);
      }
    }, {
      key: 'isSyncFontLoadingSupported',
      get: function get() {
        var supported = false;
        if (typeof navigator === 'undefined') {
          supported = true;
        } else {
          var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
          if (m && m[1] >= 14) {
            supported = true;
          }
        }
        return (0, _util.shadow)(this, 'isSyncFontLoadingSupported', supported);
      }
    }, {
      key: '_loadTestFont',
      get: function get() {
        var getLoadTestFont = function getLoadTestFont() {
          return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQA' + 'FQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAA' + 'ALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgA' + 'AAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1' + 'AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD' + '6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACM' + 'AooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4D' + 'IP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAA' + 'AAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUA' + 'AQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgAB' + 'AAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABY' + 'AAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAA' + 'AC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAA' + 'AAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQAC' + 'AQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3' + 'Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTj' + 'FQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==');
        };
        return (0, _util.shadow)(this, '_loadTestFont', getLoadTestFont());
      }
    }]);

    return GenericFontLoader;
  }(BaseFontLoader);
}
var IsEvalSupportedCached = {
  get value() {
    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
  }
};

var FontFaceObject = function () {
  function FontFaceObject(translatedData, _ref) {
    var _ref$isEvalSupported = _ref.isEvalSupported,
        isEvalSupported = _ref$isEvalSupported === undefined ? true : _ref$isEvalSupported,
        _ref$disableFontFace = _ref.disableFontFace,
        disableFontFace = _ref$disableFontFace === undefined ? false : _ref$disableFontFace,
        _ref$ignoreErrors = _ref.ignoreErrors,
        ignoreErrors = _ref$ignoreErrors === undefined ? false : _ref$ignoreErrors,
        _ref$onUnsupportedFea = _ref.onUnsupportedFeature,
        onUnsupportedFeature = _ref$onUnsupportedFea === undefined ? null : _ref$onUnsupportedFea,
        _ref$fontRegistry = _ref.fontRegistry,
        fontRegistry = _ref$fontRegistry === undefined ? null : _ref$fontRegistry;

    _classCallCheck(this, FontFaceObject);

    this.compiledGlyphs = Object.create(null);
    for (var i in translatedData) {
      this[i] = translatedData[i];
    }
    this.isEvalSupported = isEvalSupported !== false;
    this.disableFontFace = disableFontFace === true;
    this.ignoreErrors = ignoreErrors === true;
    this._onUnsupportedFeature = onUnsupportedFeature;
    this.fontRegistry = fontRegistry;
  }

  _createClass(FontFaceObject, [{
    key: 'createNativeFontFace',
    value: function createNativeFontFace() {
      if (!this.data || this.disableFontFace) {
        return null;
      }
      var nativeFontFace = new FontFace(this.loadedName, this.data, {});
      if (this.fontRegistry) {
        this.fontRegistry.registerFont(this);
      }
      return nativeFontFace;
    }
  }, {
    key: 'createFontFaceRule',
    value: function createFontFaceRule() {
      if (!this.data || this.disableFontFace) {
        return null;
      }
      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
      var url = 'url(data:' + this.mimetype + ';base64,' + btoa(data) + ');';
      var rule = '@font-face {font-family:"' + this.loadedName + '";src:' + url + '}';
      if (this.fontRegistry) {
        this.fontRegistry.registerFont(this, url);
      }
      return rule;
    }
  }, {
    key: 'getPathGenerator',
    value: function getPathGenerator(objs, character) {
      if (this.compiledGlyphs[character] !== undefined) {
        return this.compiledGlyphs[character];
      }
      var cmds = void 0,
          current = void 0;
      try {
        cmds = objs.get(this.loadedName + '_path_' + character);
      } catch (ex) {
        if (!this.ignoreErrors) {
          throw ex;
        }
        if (this._onUnsupportedFeature) {
          this._onUnsupportedFeature({ featureId: _util.UNSUPPORTED_FEATURES.font });
        }
        (0, _util.warn)('getPathGenerator - ignoring character: "' + ex + '".');
        return this.compiledGlyphs[character] = function (c, size) {};
      }
      if (this.isEvalSupported && IsEvalSupportedCached.value) {
        var args = void 0,
            js = '';
        for (var i = 0, ii = cmds.length; i < ii; i++) {
          current = cmds[i];
          if (current.args !== undefined) {
            args = current.args.join(',');
          } else {
            args = '';
          }
          js += 'c.' + current.cmd + '(' + args + ');\n';
        }
        return this.compiledGlyphs[character] = new Function('c', 'size', js);
      }
      return this.compiledGlyphs[character] = function (c, size) {
        for (var _i = 0, _ii = cmds.length; _i < _ii; _i++) {
          current = cmds[_i];
          if (current.cmd === 'scale') {
            current.args = [size, -size];
          }
          c[current.cmd].apply(c, current.args);
        }
      };
    }
  }]);

  return FontFaceObject;
}();

exports.FontFaceObject = FontFaceObject;
exports.FontLoader = FontLoader;

/***/ }),
/* 132 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var compatibilityParams = Object.create(null);
{
  var isNodeJS = __w_pdfjs_require__(4);
  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
  var isIE = /Trident/.test(userAgent);
  var isIOSChrome = /CriOS/.test(userAgent);
  (function checkOnBlobSupport() {
    if (isIE || isIOSChrome) {
      compatibilityParams.disableCreateObjectURL = true;
    }
  })();
  (function checkFontFaceAndImage() {
    if (isNodeJS()) {
      compatibilityParams.disableFontFace = true;
      compatibilityParams.nativeImageDecoderSupport = 'none';
    }
  })();
}
exports.apiCompatibilityParams = Object.freeze(compatibilityParams);

/***/ }),
/* 133 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasGraphics = undefined;

var _util = __w_pdfjs_require__(1);

var _pattern_helper = __w_pdfjs_require__(134);

var MIN_FONT_SIZE = 16;
var MAX_FONT_SIZE = 100;
var MAX_GROUP_SIZE = 4096;
var MIN_WIDTH_FACTOR = 0.65;
var COMPILE_TYPE3_GLYPHS = true;
var MAX_SIZE_TO_COMPILE = 1000;
var FULL_CHUNK_HEIGHT = 16;
var IsLittleEndianCached = {
  get value() {
    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
  }
};
function addContextCurrentTransform(ctx) {
  if (!ctx.mozCurrentTransform) {
    ctx._originalSave = ctx.save;
    ctx._originalRestore = ctx.restore;
    ctx._originalRotate = ctx.rotate;
    ctx._originalScale = ctx.scale;
    ctx._originalTranslate = ctx.translate;
    ctx._originalTransform = ctx.transform;
    ctx._originalSetTransform = ctx.setTransform;
    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
    ctx._transformStack = [];
    Object.defineProperty(ctx, 'mozCurrentTransform', {
      get: function getCurrentTransform() {
        return this._transformMatrix;
      }
    });
    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
      get: function getCurrentTransformInverse() {
        var m = this._transformMatrix;
        var a = m[0],
            b = m[1],
            c = m[2],
            d = m[3],
            e = m[4],
            f = m[5];
        var ad_bc = a * d - b * c;
        var bc_ad = b * c - a * d;
        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
      }
    });
    ctx.save = function ctxSave() {
      var old = this._transformMatrix;
      this._transformStack.push(old);
      this._transformMatrix = old.slice(0, 6);
      this._originalSave();
    };
    ctx.restore = function ctxRestore() {
      var prev = this._transformStack.pop();
      if (prev) {
        this._transformMatrix = prev;
        this._originalRestore();
      }
    };
    ctx.translate = function ctxTranslate(x, y) {
      var m = this._transformMatrix;
      m[4] = m[0] * x + m[2] * y + m[4];
      m[5] = m[1] * x + m[3] * y + m[5];
      this._originalTranslate(x, y);
    };
    ctx.scale = function ctxScale(x, y) {
      var m = this._transformMatrix;
      m[0] = m[0] * x;
      m[1] = m[1] * x;
      m[2] = m[2] * y;
      m[3] = m[3] * y;
      this._originalScale(x, y);
    };
    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
      ctx._originalTransform(a, b, c, d, e, f);
    };
    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
      this._transformMatrix = [a, b, c, d, e, f];
      ctx._originalSetTransform(a, b, c, d, e, f);
    };
    ctx.rotate = function ctxRotate(angle) {
      var cosValue = Math.cos(angle);
      var sinValue = Math.sin(angle);
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
      this._originalRotate(angle);
    };
  }
}
var CachedCanvases = function CachedCanvasesClosure() {
  function CachedCanvases(canvasFactory) {
    this.canvasFactory = canvasFactory;
    this.cache = Object.create(null);
  }
  CachedCanvases.prototype = {
    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
      var canvasEntry;
      if (this.cache[id] !== undefined) {
        canvasEntry = this.cache[id];
        this.canvasFactory.reset(canvasEntry, width, height);
        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
      } else {
        canvasEntry = this.canvasFactory.create(width, height);
        this.cache[id] = canvasEntry;
      }
      if (trackTransform) {
        addContextCurrentTransform(canvasEntry.context);
      }
      return canvasEntry;
    },
    clear: function clear() {
      for (var id in this.cache) {
        var canvasEntry = this.cache[id];
        this.canvasFactory.destroy(canvasEntry);
        delete this.cache[id];
      }
    }
  };
  return CachedCanvases;
}();
function compileType3Glyph(imgData) {
  var POINT_TO_PROCESS_LIMIT = 1000;
  var width = imgData.width,
      height = imgData.height;
  var i,
      j,
      j0,
      width1 = width + 1;
  var points = new Uint8Array(width1 * (height + 1));
  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
  var lineSize = width + 7 & ~7,
      data0 = imgData.data;
  var data = new Uint8Array(lineSize * height),
      pos = 0,
      ii;
  for (i = 0, ii = data0.length; i < ii; i++) {
    var mask = 128,
        elem = data0[i];
    while (mask > 0) {
      data[pos++] = elem & mask ? 0 : 255;
      mask >>= 1;
    }
  }
  var count = 0;
  pos = 0;
  if (data[pos] !== 0) {
    points[0] = 1;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j] = data[pos] ? 2 : 1;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j] = 2;
    ++count;
  }
  for (i = 1; i < height; i++) {
    pos = i * lineSize;
    j0 = i * width1;
    if (data[pos - lineSize] !== data[pos]) {
      points[j0] = data[pos] ? 1 : 8;
      ++count;
    }
    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
    for (j = 1; j < width; j++) {
      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
      if (POINT_TYPES[sum]) {
        points[j0 + j] = POINT_TYPES[sum];
        ++count;
      }
      pos++;
    }
    if (data[pos - lineSize] !== data[pos]) {
      points[j0 + j] = data[pos] ? 2 : 4;
      ++count;
    }
    if (count > POINT_TO_PROCESS_LIMIT) {
      return null;
    }
  }
  pos = lineSize * (height - 1);
  j0 = i * width1;
  if (data[pos] !== 0) {
    points[j0] = 8;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j0 + j] = data[pos] ? 4 : 8;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j0 + j] = 4;
    ++count;
  }
  if (count > POINT_TO_PROCESS_LIMIT) {
    return null;
  }
  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
  var outlines = [];
  for (i = 0; count && i <= height; i++) {
    var p = i * width1;
    var end = p + width;
    while (p < end && !points[p]) {
      p++;
    }
    if (p === end) {
      continue;
    }
    var coords = [p % width1, i];
    var type = points[p],
        p0 = p,
        pp;
    do {
      var step = steps[type];
      do {
        p += step;
      } while (!points[p]);
      pp = points[p];
      if (pp !== 5 && pp !== 10) {
        type = pp;
        points[p] = 0;
      } else {
        type = pp & 0x33 * type >> 4;
        points[p] &= type >> 2 | type << 2;
      }
      coords.push(p % width1);
      coords.push(p / width1 | 0);
      --count;
    } while (p0 !== p);
    outlines.push(coords);
    --i;
  }
  var drawOutline = function drawOutline(c) {
    c.save();
    c.scale(1 / width, -1 / height);
    c.translate(0, -height);
    c.beginPath();
    for (var i = 0, ii = outlines.length; i < ii; i++) {
      var o = outlines[i];
      c.moveTo(o[0], o[1]);
      for (var j = 2, jj = o.length; j < jj; j += 2) {
        c.lineTo(o[j], o[j + 1]);
      }
    }
    c.fill();
    c.beginPath();
    c.restore();
  };
  return drawOutline;
}
var CanvasExtraState = function CanvasExtraStateClosure() {
  function CanvasExtraState() {
    this.alphaIsShape = false;
    this.fontSize = 0;
    this.fontSizeScale = 1;
    this.textMatrix = _util.IDENTITY_MATRIX;
    this.textMatrixScale = 1;
    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
    this.leading = 0;
    this.x = 0;
    this.y = 0;
    this.lineX = 0;
    this.lineY = 0;
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.textHScale = 1;
    this.textRenderingMode = _util.TextRenderingMode.FILL;
    this.textRise = 0;
    this.fillColor = '#000000';
    this.strokeColor = '#000000';
    this.patternFill = false;
    this.fillAlpha = 1;
    this.strokeAlpha = 1;
    this.lineWidth = 1;
    this.activeSMask = null;
    this.resumeSMaskCtx = null;
  }
  CanvasExtraState.prototype = {
    clone: function CanvasExtraState_clone() {
      return Object.create(this);
    },
    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
      this.x = x;
      this.y = y;
    }
  };
  return CanvasExtraState;
}();
var CanvasGraphics = function CanvasGraphicsClosure() {
  var EXECUTION_TIME = 15;
  var EXECUTION_STEPS = 10;
  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, webGLContext, imageLayer) {
    this.ctx = canvasCtx;
    this.current = new CanvasExtraState();
    this.stateStack = [];
    this.pendingClip = null;
    this.pendingEOFill = false;
    this.res = null;
    this.xobjs = null;
    this.commonObjs = commonObjs;
    this.objs = objs;
    this.canvasFactory = canvasFactory;
    this.webGLContext = webGLContext;
    this.imageLayer = imageLayer;
    this.groupStack = [];
    this.processingType3 = null;
    this.baseTransform = null;
    this.baseTransformStack = [];
    this.groupLevel = 0;
    this.smaskStack = [];
    this.smaskCounter = 0;
    this.tempSMask = null;
    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
    if (canvasCtx) {
      addContextCurrentTransform(canvasCtx);
    }
    this._cachedGetSinglePixelWidth = null;
  }
  function putBinaryImageData(ctx, imgData) {
    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
      ctx.putImageData(imgData, 0, 0);
      return;
    }
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0,
        destPos;
    var src = imgData.data;
    var dest = chunkImgData.data;
    var i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
      var srcLength = src.byteLength;
      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
      var dest32DataLength = dest32.length;
      var fullSrcDiff = width + 7 >> 3;
      var white = 0xFFFFFFFF;
      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
      for (i = 0; i < totalChunks; i++) {
        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
        destPos = 0;
        for (j = 0; j < thisChunkHeight; j++) {
          var srcDiff = srcLength - srcPos;
          var k = 0;
          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
          var kEndUnrolled = kEnd & ~7;
          var mask = 0;
          var srcByte = 0;
          for (; k < kEndUnrolled; k += 8) {
            srcByte = src[srcPos++];
            dest32[destPos++] = srcByte & 128 ? white : black;
            dest32[destPos++] = srcByte & 64 ? white : black;
            dest32[destPos++] = srcByte & 32 ? white : black;
            dest32[destPos++] = srcByte & 16 ? white : black;
            dest32[destPos++] = srcByte & 8 ? white : black;
            dest32[destPos++] = srcByte & 4 ? white : black;
            dest32[destPos++] = srcByte & 2 ? white : black;
            dest32[destPos++] = srcByte & 1 ? white : black;
          }
          for (; k < kEnd; k++) {
            if (mask === 0) {
              srcByte = src[srcPos++];
              mask = 128;
            }
            dest32[destPos++] = srcByte & mask ? white : black;
            mask >>= 1;
          }
        }
        while (destPos < dest32DataLength) {
          dest32[destPos++] = 0;
        }
        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
      j = 0;
      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
      for (i = 0; i < fullChunks; i++) {
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        srcPos += elemsInThisChunk;
        ctx.putImageData(chunkImgData, 0, j);
        j += FULL_CHUNK_HEIGHT;
      }
      if (i < totalChunks) {
        elemsInThisChunk = width * partialChunkHeight * 4;
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        ctx.putImageData(chunkImgData, 0, j);
      }
    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
      thisChunkHeight = FULL_CHUNK_HEIGHT;
      elemsInThisChunk = width * thisChunkHeight;
      for (i = 0; i < totalChunks; i++) {
        if (i >= fullChunks) {
          thisChunkHeight = partialChunkHeight;
          elemsInThisChunk = width * thisChunkHeight;
        }
        destPos = 0;
        for (j = elemsInThisChunk; j--;) {
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = 255;
        }
        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else {
      throw new Error('bad image kind: ' + imgData.kind);
    }
  }
  function putBinaryImageMask(ctx, imgData) {
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0;
    var src = imgData.data;
    var dest = chunkImgData.data;
    for (var i = 0; i < totalChunks; i++) {
      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
      var destPos = 3;
      for (var j = 0; j < thisChunkHeight; j++) {
        var mask = 0;
        for (var k = 0; k < width; k++) {
          if (!mask) {
            var elem = src[srcPos++];
            mask = 128;
          }
          dest[destPos] = elem & mask ? 0 : 255;
          destPos += 4;
          mask >>= 1;
        }
      }
      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
  }
  function copyCtxState(sourceCtx, destCtx) {
    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];
    for (var i = 0, ii = properties.length; i < ii; i++) {
      var property = properties[i];
      if (sourceCtx[property] !== undefined) {
        destCtx[property] = sourceCtx[property];
      }
    }
    if (sourceCtx.setLineDash !== undefined) {
      destCtx.setLineDash(sourceCtx.getLineDash());
      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
  }
  function resetCtxToDefault(ctx) {
    ctx.strokeStyle = '#000000';
    ctx.fillStyle = '#000000';
    ctx.fillRule = 'nonzero';
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = 'source-over';
    ctx.font = '10px sans-serif';
    if (ctx.setLineDash !== undefined) {
      ctx.setLineDash([]);
      ctx.lineDashOffset = 0;
    }
  }
  function composeSMaskBackdrop(bytes, r0, g0, b0) {
    var length = bytes.length;
    for (var i = 3; i < length; i += 4) {
      var alpha = bytes[i];
      if (alpha === 0) {
        bytes[i - 3] = r0;
        bytes[i - 2] = g0;
        bytes[i - 1] = b0;
      } else if (alpha < 255) {
        var alpha_ = 255 - alpha;
        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
      }
    }
  }
  function composeSMaskAlpha(maskData, layerData, transferMap) {
    var length = maskData.length;
    var scale = 1 / 255;
    for (var i = 3; i < length; i += 4) {
      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
      layerData[i] = layerData[i] * alpha * scale | 0;
    }
  }
  function composeSMaskLuminosity(maskData, layerData, transferMap) {
    var length = maskData.length;
    for (var i = 3; i < length; i += 4) {
      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
    }
  }
  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
    var hasBackdrop = !!backdrop;
    var r0 = hasBackdrop ? backdrop[0] : 0;
    var g0 = hasBackdrop ? backdrop[1] : 0;
    var b0 = hasBackdrop ? backdrop[2] : 0;
    var composeFn;
    if (subtype === 'Luminosity') {
      composeFn = composeSMaskLuminosity;
    } else {
      composeFn = composeSMaskAlpha;
    }
    var PIXELS_TO_PROCESS = 1048576;
    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
    for (var row = 0; row < height; row += chunkSize) {
      var chunkHeight = Math.min(chunkSize, height - row);
      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
      if (hasBackdrop) {
        composeSMaskBackdrop(maskData.data, r0, g0, b0);
      }
      composeFn(maskData.data, layerData.data, transferMap);
      maskCtx.putImageData(layerData, 0, row);
    }
  }
  function composeSMask(ctx, smask, layerCtx, webGLContext) {
    var mask = smask.canvas;
    var maskCtx = smask.context;
    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
    var backdrop = smask.backdrop || null;
    if (!smask.transferMap && webGLContext.isEnabled) {
      var composed = webGLContext.composeSMask({
        layer: layerCtx.canvas,
        mask: mask,
        properties: {
          subtype: smask.subtype,
          backdrop: backdrop
        }
      });
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
      return;
    }
    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
    ctx.drawImage(mask, 0, 0);
  }
  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
  var NORMAL_CLIP = {};
  var EO_CLIP = {};
  CanvasGraphics.prototype = {
    beginDrawing: function beginDrawing(_ref) {
      var transform = _ref.transform,
          viewport = _ref.viewport,
          transparency = _ref.transparency,
          _ref$background = _ref.background,
          background = _ref$background === undefined ? null : _ref$background;

      var width = this.ctx.canvas.width;
      var height = this.ctx.canvas.height;
      this.ctx.save();
      this.ctx.fillStyle = background || 'rgb(255, 255, 255)';
      this.ctx.fillRect(0, 0, width, height);
      this.ctx.restore();
      if (transparency) {
        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
        this.compositeCtx = this.ctx;
        this.transparentCanvas = transparentCanvas.canvas;
        this.ctx = transparentCanvas.context;
        this.ctx.save();
        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
      }
      this.ctx.save();
      resetCtxToDefault(this.ctx);
      if (transform) {
        this.ctx.transform.apply(this.ctx, transform);
      }
      this.ctx.transform.apply(this.ctx, viewport.transform);
      this.baseTransform = this.ctx.mozCurrentTransform.slice();
      if (this.imageLayer) {
        this.imageLayer.beginLayout();
      }
    },

    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
      var argsArray = operatorList.argsArray;
      var fnArray = operatorList.fnArray;
      var i = executionStartIdx || 0;
      var argsArrayLen = argsArray.length;
      if (argsArrayLen === i) {
        return i;
      }
      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
      var steps = 0;
      var commonObjs = this.commonObjs;
      var objs = this.objs;
      var fnId;
      while (true) {
        if (stepper !== undefined && i === stepper.nextBreakPoint) {
          stepper.breakIt(i, continueCallback);
          return i;
        }
        fnId = fnArray[i];
        if (fnId !== _util.OPS.dependency) {
          this[fnId].apply(this, argsArray[i]);
        } else {
          var deps = argsArray[i];
          for (var n = 0, nn = deps.length; n < nn; n++) {
            var depObjId = deps[n];
            var common = depObjId[0] === 'g' && depObjId[1] === '_';
            var objsPool = common ? commonObjs : objs;
            if (!objsPool.isResolved(depObjId)) {
              objsPool.get(depObjId, continueCallback);
              return i;
            }
          }
        }
        i++;
        if (i === argsArrayLen) {
          return i;
        }
        if (chunkOperations && ++steps > EXECUTION_STEPS) {
          if (Date.now() > endTime) {
            continueCallback();
            return i;
          }
          steps = 0;
        }
      }
    },
    endDrawing: function CanvasGraphics_endDrawing() {
      if (this.current.activeSMask !== null) {
        this.endSMaskGroup();
      }
      this.ctx.restore();
      if (this.transparentCanvas) {
        this.ctx = this.compositeCtx;
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.drawImage(this.transparentCanvas, 0, 0);
        this.ctx.restore();
        this.transparentCanvas = null;
      }
      this.cachedCanvases.clear();
      this.webGLContext.clear();
      if (this.imageLayer) {
        this.imageLayer.endLayout();
      }
    },
    setLineWidth: function CanvasGraphics_setLineWidth(width) {
      this.current.lineWidth = width;
      this.ctx.lineWidth = width;
    },
    setLineCap: function CanvasGraphics_setLineCap(style) {
      this.ctx.lineCap = LINE_CAP_STYLES[style];
    },
    setLineJoin: function CanvasGraphics_setLineJoin(style) {
      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
    },
    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
      this.ctx.miterLimit = limit;
    },
    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
      var ctx = this.ctx;
      if (ctx.setLineDash !== undefined) {
        ctx.setLineDash(dashArray);
        ctx.lineDashOffset = dashPhase;
      }
    },
    setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
    setFlatness: function CanvasGraphics_setFlatness(flatness) {},
    setGState: function CanvasGraphics_setGState(states) {
      for (var i = 0, ii = states.length; i < ii; i++) {
        var state = states[i];
        var key = state[0];
        var value = state[1];
        switch (key) {
          case 'LW':
            this.setLineWidth(value);
            break;
          case 'LC':
            this.setLineCap(value);
            break;
          case 'LJ':
            this.setLineJoin(value);
            break;
          case 'ML':
            this.setMiterLimit(value);
            break;
          case 'D':
            this.setDash(value[0], value[1]);
            break;
          case 'RI':
            this.setRenderingIntent(value);
            break;
          case 'FL':
            this.setFlatness(value);
            break;
          case 'Font':
            this.setFont(value[0], value[1]);
            break;
          case 'CA':
            this.current.strokeAlpha = state[1];
            break;
          case 'ca':
            this.current.fillAlpha = state[1];
            this.ctx.globalAlpha = state[1];
            break;
          case 'BM':
            this.ctx.globalCompositeOperation = value;
            break;
          case 'SMask':
            if (this.current.activeSMask) {
              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
                this.suspendSMaskGroup();
              } else {
                this.endSMaskGroup();
              }
            }
            this.current.activeSMask = value ? this.tempSMask : null;
            if (this.current.activeSMask) {
              this.beginSMaskGroup();
            }
            this.tempSMask = null;
            break;
        }
      }
    },
    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
      var activeSMask = this.current.activeSMask;
      var drawnWidth = activeSMask.canvas.width;
      var drawnHeight = activeSMask.canvas.height;
      var cacheId = 'smaskGroupAt' + this.groupLevel;
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var currentCtx = this.ctx;
      var currentTransform = currentCtx.mozCurrentTransform;
      this.ctx.save();
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
      this.ctx.restore();
      this.ctx.save();
      copyCtxState(groupCtx, this.ctx);
      this.current.resumeSMaskCtx = groupCtx;
      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
      this.ctx.transform.apply(this.ctx, deltaTransform);
      groupCtx.save();
      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
      groupCtx.restore();
    },
    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.current.resumeSMaskCtx;
      var currentCtx = this.ctx;
      this.ctx = groupCtx;
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
      this.ctx.restore();
      copyCtxState(groupCtx, this.ctx);
      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
      this.ctx.transform.apply(this.ctx, deltaTransform);
    },
    save: function CanvasGraphics_save() {
      this.ctx.save();
      var old = this.current;
      this.stateStack.push(old);
      this.current = old.clone();
      this.current.resumeSMaskCtx = null;
    },
    restore: function CanvasGraphics_restore() {
      if (this.current.resumeSMaskCtx) {
        this.resumeSMaskGroup();
      }
      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
        this.endSMaskGroup();
      }
      if (this.stateStack.length !== 0) {
        this.current = this.stateStack.pop();
        this.ctx.restore();
        this.pendingClip = null;
        this._cachedGetSinglePixelWidth = null;
      }
    },
    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
      this.ctx.transform(a, b, c, d, e, f);
      this._cachedGetSinglePixelWidth = null;
    },
    constructPath: function CanvasGraphics_constructPath(ops, args) {
      var ctx = this.ctx;
      var current = this.current;
      var x = current.x,
          y = current.y;
      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
        switch (ops[i] | 0) {
          case _util.OPS.rectangle:
            x = args[j++];
            y = args[j++];
            var width = args[j++];
            var height = args[j++];
            if (width === 0) {
              width = this.getSinglePixelWidth();
            }
            if (height === 0) {
              height = this.getSinglePixelWidth();
            }
            var xw = x + width;
            var yh = y + height;
            this.ctx.moveTo(x, y);
            this.ctx.lineTo(xw, y);
            this.ctx.lineTo(xw, yh);
            this.ctx.lineTo(x, yh);
            this.ctx.lineTo(x, y);
            this.ctx.closePath();
            break;
          case _util.OPS.moveTo:
            x = args[j++];
            y = args[j++];
            ctx.moveTo(x, y);
            break;
          case _util.OPS.lineTo:
            x = args[j++];
            y = args[j++];
            ctx.lineTo(x, y);
            break;
          case _util.OPS.curveTo:
            x = args[j + 4];
            y = args[j + 5];
            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
            j += 6;
            break;
          case _util.OPS.curveTo2:
            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
            x = args[j + 2];
            y = args[j + 3];
            j += 4;
            break;
          case _util.OPS.curveTo3:
            x = args[j + 2];
            y = args[j + 3];
            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
            j += 4;
            break;
          case _util.OPS.closePath:
            ctx.closePath();
            break;
        }
      }
      current.setCurrentPoint(x, y);
    },
    closePath: function CanvasGraphics_closePath() {
      this.ctx.closePath();
    },
    stroke: function CanvasGraphics_stroke(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var strokeColor = this.current.strokeColor;
      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
      ctx.globalAlpha = this.current.strokeAlpha;
      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
        ctx.save();
        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
        ctx.stroke();
        ctx.restore();
      } else {
        ctx.stroke();
      }
      if (consumePath) {
        this.consumePath();
      }
      ctx.globalAlpha = this.current.fillAlpha;
    },
    closeStroke: function CanvasGraphics_closeStroke() {
      this.closePath();
      this.stroke();
    },
    fill: function CanvasGraphics_fill(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var needRestore = false;
      if (isPatternFill) {
        ctx.save();
        if (this.baseTransform) {
          ctx.setTransform.apply(ctx, this.baseTransform);
        }
        ctx.fillStyle = fillColor.getPattern(ctx, this);
        needRestore = true;
      }
      if (this.pendingEOFill) {
        ctx.fill('evenodd');
        this.pendingEOFill = false;
      } else {
        ctx.fill();
      }
      if (needRestore) {
        ctx.restore();
      }
      if (consumePath) {
        this.consumePath();
      }
    },
    eoFill: function CanvasGraphics_eoFill() {
      this.pendingEOFill = true;
      this.fill();
    },
    fillStroke: function CanvasGraphics_fillStroke() {
      this.fill(false);
      this.stroke(false);
      this.consumePath();
    },
    eoFillStroke: function CanvasGraphics_eoFillStroke() {
      this.pendingEOFill = true;
      this.fillStroke();
    },
    closeFillStroke: function CanvasGraphics_closeFillStroke() {
      this.closePath();
      this.fillStroke();
    },
    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
      this.pendingEOFill = true;
      this.closePath();
      this.fillStroke();
    },
    endPath: function CanvasGraphics_endPath() {
      this.consumePath();
    },
    clip: function CanvasGraphics_clip() {
      this.pendingClip = NORMAL_CLIP;
    },
    eoClip: function CanvasGraphics_eoClip() {
      this.pendingClip = EO_CLIP;
    },
    beginText: function CanvasGraphics_beginText() {
      this.current.textMatrix = _util.IDENTITY_MATRIX;
      this.current.textMatrixScale = 1;
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    endText: function CanvasGraphics_endText() {
      var paths = this.pendingTextPaths;
      var ctx = this.ctx;
      if (paths === undefined) {
        ctx.beginPath();
        return;
      }
      ctx.save();
      ctx.beginPath();
      for (var i = 0; i < paths.length; i++) {
        var path = paths[i];
        ctx.setTransform.apply(ctx, path.transform);
        ctx.translate(path.x, path.y);
        path.addToPath(ctx, path.fontSize);
      }
      ctx.restore();
      ctx.clip();
      ctx.beginPath();
      delete this.pendingTextPaths;
    },
    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
      this.current.charSpacing = spacing;
    },
    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
      this.current.wordSpacing = spacing;
    },
    setHScale: function CanvasGraphics_setHScale(scale) {
      this.current.textHScale = scale / 100;
    },
    setLeading: function CanvasGraphics_setLeading(leading) {
      this.current.leading = -leading;
    },
    setFont: function CanvasGraphics_setFont(fontRefName, size) {
      var fontObj = this.commonObjs.get(fontRefName);
      var current = this.current;
      if (!fontObj) {
        throw new Error('Can\'t find font for ' + fontRefName);
      }
      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
      }
      if (size < 0) {
        size = -size;
        current.fontDirection = -1;
      } else {
        current.fontDirection = 1;
      }
      this.current.font = fontObj;
      this.current.fontSize = size;
      if (fontObj.isType3Font) {
        return;
      }
      var name = fontObj.loadedName || 'sans-serif';
      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
      var italic = fontObj.italic ? 'italic' : 'normal';
      var typeface = '"' + name + '", ' + fontObj.fallbackName;
      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
      this.current.fontSizeScale = size / browserFontSize;
      var rule = italic + ' ' + bold + ' ' + browserFontSize + 'px ' + typeface;
      this.ctx.font = rule;
    },
    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
      this.current.textRenderingMode = mode;
    },
    setTextRise: function CanvasGraphics_setTextRise(rise) {
      this.current.textRise = rise;
    },
    moveText: function CanvasGraphics_moveText(x, y) {
      this.current.x = this.current.lineX += x;
      this.current.y = this.current.lineY += y;
    },
    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
      this.setLeading(-y);
      this.moveText(x, y);
    },
    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
      this.current.textMatrix = [a, b, c, d, e, f];
      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    nextLine: function CanvasGraphics_nextLine() {
      this.moveText(0, this.current.leading);
    },
    paintChar: function paintChar(character, x, y, patternTransform) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var textRenderingMode = current.textRenderingMode;
      var fontSize = current.fontSize / current.fontSizeScale;
      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
      var patternFill = current.patternFill && font.data;
      var addToPath;
      if (font.disableFontFace || isAddToPathSet || patternFill) {
        addToPath = font.getPathGenerator(this.commonObjs, character);
      }
      if (font.disableFontFace || patternFill) {
        ctx.save();
        ctx.translate(x, y);
        ctx.beginPath();
        addToPath(ctx, fontSize);
        if (patternTransform) {
          ctx.setTransform.apply(ctx, patternTransform);
        }
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fill();
        }
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.stroke();
        }
        ctx.restore();
      } else {
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fillText(character, x, y);
        }
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.strokeText(character, x, y);
        }
      }
      if (isAddToPathSet) {
        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
        paths.push({
          transform: ctx.mozCurrentTransform,
          x: x,
          y: y,
          fontSize: fontSize,
          addToPath: addToPath
        });
      }
    },

    get isFontSubpixelAAEnabled() {
      var ctx = this.canvasFactory.create(10, 10).context;
      ctx.scale(1.5, 1);
      ctx.fillText('I', 0, 10);
      var data = ctx.getImageData(0, 0, 10, 10).data;
      var enabled = false;
      for (var i = 3; i < data.length; i += 4) {
        if (data[i] > 0 && data[i] < 255) {
          enabled = true;
          break;
        }
      }
      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
    },
    showText: function CanvasGraphics_showText(glyphs) {
      var current = this.current;
      var font = current.font;
      if (font.isType3Font) {
        return this.showType3Text(glyphs);
      }
      var fontSize = current.fontSize;
      if (fontSize === 0) {
        return;
      }
      var ctx = this.ctx;
      var fontSizeScale = current.fontSizeScale;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var fontDirection = current.fontDirection;
      var textHScale = current.textHScale * fontDirection;
      var glyphsLength = glyphs.length;
      var vertical = font.vertical;
      var spacingDir = vertical ? 1 : -1;
      var defaultVMetrics = font.defaultVMetrics;
      var widthAdvanceScale = fontSize * current.fontMatrix[0];
      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
      ctx.save();
      var patternTransform = void 0;
      if (current.patternFill) {
        ctx.save();
        var pattern = current.fillColor.getPattern(ctx, this);
        patternTransform = ctx.mozCurrentTransform;
        ctx.restore();
        ctx.fillStyle = pattern;
      }
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y + current.textRise);
      if (fontDirection > 0) {
        ctx.scale(textHScale, -1);
      } else {
        ctx.scale(textHScale, 1);
      }
      var lineWidth = current.lineWidth;
      var scale = current.textMatrixScale;
      if (scale === 0 || lineWidth === 0) {
        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          this._cachedGetSinglePixelWidth = null;
          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
        }
      } else {
        lineWidth /= scale;
      }
      if (fontSizeScale !== 1.0) {
        ctx.scale(fontSizeScale, fontSizeScale);
        lineWidth /= fontSizeScale;
      }
      ctx.lineWidth = lineWidth;
      var x = 0,
          i;
      for (i = 0; i < glyphsLength; ++i) {
        var glyph = glyphs[i];
        if ((0, _util.isNum)(glyph)) {
          x += spacingDir * glyph * fontSize / 1000;
          continue;
        }
        var restoreNeeded = false;
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var character = glyph.fontChar;
        var accent = glyph.accent;
        var scaledX, scaledY, scaledAccentX, scaledAccentY;
        var width = glyph.width;
        if (vertical) {
          var vmetric, vx, vy;
          vmetric = glyph.vmetric || defaultVMetrics;
          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
          vx = -vx * widthAdvanceScale;
          vy = vmetric[2] * widthAdvanceScale;
          width = vmetric ? -vmetric[0] : width;
          scaledX = vx / fontSizeScale;
          scaledY = (x + vy) / fontSizeScale;
        } else {
          scaledX = x / fontSizeScale;
          scaledY = 0;
        }
        if (font.remeasure && width > 0) {
          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
            var characterScaleX = width / measuredWidth;
            restoreNeeded = true;
            ctx.save();
            ctx.scale(characterScaleX, 1);
            scaledX /= characterScaleX;
          } else if (width !== measuredWidth) {
            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
          }
        }
        if (glyph.isInFont || font.missingFile) {
          if (simpleFillText && !accent) {
            ctx.fillText(character, scaledX, scaledY);
          } else {
            this.paintChar(character, scaledX, scaledY, patternTransform);
            if (accent) {
              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
            }
          }
        }
        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
        x += charWidth;
        if (restoreNeeded) {
          ctx.restore();
        }
      }
      if (vertical) {
        current.y -= x * textHScale;
      } else {
        current.x += x * textHScale;
      }
      ctx.restore();
    },
    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var fontSize = current.fontSize;
      var fontDirection = current.fontDirection;
      var spacingDir = font.vertical ? 1 : -1;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var textHScale = current.textHScale * fontDirection;
      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
      var glyphsLength = glyphs.length;
      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
      var i, glyph, width, spacingLength;
      if (isTextInvisible || fontSize === 0) {
        return;
      }
      this._cachedGetSinglePixelWidth = null;
      ctx.save();
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y);
      ctx.scale(textHScale, fontDirection);
      for (i = 0; i < glyphsLength; ++i) {
        glyph = glyphs[i];
        if ((0, _util.isNum)(glyph)) {
          spacingLength = spacingDir * glyph * fontSize / 1000;
          this.ctx.translate(spacingLength, 0);
          current.x += spacingLength * textHScale;
          continue;
        }
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var operatorList = font.charProcOperatorList[glyph.operatorListId];
        if (!operatorList) {
          (0, _util.warn)('Type3 character "' + glyph.operatorListId + '" is not available.');
          continue;
        }
        this.processingType3 = glyph;
        this.save();
        ctx.scale(fontSize, fontSize);
        ctx.transform.apply(ctx, fontMatrix);
        this.executeOperatorList(operatorList);
        this.restore();
        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
        width = transformed[0] * fontSize + spacing;
        ctx.translate(width, 0);
        current.x += width * textHScale;
      }
      ctx.restore();
      this.processingType3 = null;
    },
    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
      this.ctx.rect(llx, lly, urx - llx, ury - lly);
      this.clip();
      this.endPath();
    },
    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
      var _this = this;

      var pattern;
      if (IR[0] === 'TilingPattern') {
        var color = IR[1];
        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
        var canvasGraphicsFactory = {
          createCanvasGraphics: function createCanvasGraphics(ctx) {
            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory, _this.webGLContext);
          }
        };
        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
      } else {
        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
      }
      return pattern;
    },
    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
      this.current.strokeColor = this.getColorN_Pattern(arguments);
    },
    setFillColorN: function CanvasGraphics_setFillColorN() {
      this.current.fillColor = this.getColorN_Pattern(arguments);
      this.current.patternFill = true;
    },
    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);
      this.ctx.strokeStyle = color;
      this.current.strokeColor = color;
    },
    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);
      this.ctx.fillStyle = color;
      this.current.fillColor = color;
      this.current.patternFill = false;
    },
    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
      var ctx = this.ctx;
      this.save();
      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
      ctx.fillStyle = pattern.getPattern(ctx, this, true);
      var inv = ctx.mozCurrentTransformInverse;
      if (inv) {
        var canvas = ctx.canvas;
        var width = canvas.width;
        var height = canvas.height;
        var bl = _util.Util.applyTransform([0, 0], inv);
        var br = _util.Util.applyTransform([0, height], inv);
        var ul = _util.Util.applyTransform([width, 0], inv);
        var ur = _util.Util.applyTransform([width, height], inv);
        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
      } else {
        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
      }
      this.restore();
    },
    beginInlineImage: function CanvasGraphics_beginInlineImage() {
      (0, _util.unreachable)('Should not call beginInlineImage');
    },
    beginImageData: function CanvasGraphics_beginImageData() {
      (0, _util.unreachable)('Should not call beginImageData');
    },
    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
      this.save();
      this.baseTransformStack.push(this.baseTransform);
      if (Array.isArray(matrix) && matrix.length === 6) {
        this.transform.apply(this, matrix);
      }
      this.baseTransform = this.ctx.mozCurrentTransform;
      if (Array.isArray(bbox) && bbox.length === 4) {
        var width = bbox[2] - bbox[0];
        var height = bbox[3] - bbox[1];
        this.ctx.rect(bbox[0], bbox[1], width, height);
        this.clip();
        this.endPath();
      }
    },
    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
      this.restore();
      this.baseTransform = this.baseTransformStack.pop();
    },
    beginGroup: function CanvasGraphics_beginGroup(group) {
      this.save();
      var currentCtx = this.ctx;
      if (!group.isolated) {
        (0, _util.info)('TODO: Support non-isolated groups.');
      }
      if (group.knockout) {
        (0, _util.warn)('Knockout groups not supported.');
      }
      var currentTransform = currentCtx.mozCurrentTransform;
      if (group.matrix) {
        currentCtx.transform.apply(currentCtx, group.matrix);
      }
      if (!group.bbox) {
        throw new Error('Bounding box is required.');
      }
      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
      var offsetX = Math.floor(bounds[0]);
      var offsetY = Math.floor(bounds[1]);
      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
      var scaleX = 1,
          scaleY = 1;
      if (drawnWidth > MAX_GROUP_SIZE) {
        scaleX = drawnWidth / MAX_GROUP_SIZE;
        drawnWidth = MAX_GROUP_SIZE;
      }
      if (drawnHeight > MAX_GROUP_SIZE) {
        scaleY = drawnHeight / MAX_GROUP_SIZE;
        drawnHeight = MAX_GROUP_SIZE;
      }
      var cacheId = 'groupAt' + this.groupLevel;
      if (group.smask) {
        cacheId += '_smask_' + this.smaskCounter++ % 2;
      }
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / scaleX, 1 / scaleY);
      groupCtx.translate(-offsetX, -offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      if (group.smask) {
        this.smaskStack.push({
          canvas: scratchCanvas.canvas,
          context: groupCtx,
          offsetX: offsetX,
          offsetY: offsetY,
          scaleX: scaleX,
          scaleY: scaleY,
          subtype: group.smask.subtype,
          backdrop: group.smask.backdrop,
          transferMap: group.smask.transferMap || null,
          startTransformInverse: null
        });
      } else {
        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
        currentCtx.translate(offsetX, offsetY);
        currentCtx.scale(scaleX, scaleY);
      }
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
      this.current.activeSMask = null;
    },
    endGroup: function CanvasGraphics_endGroup(group) {
      this.groupLevel--;
      var groupCtx = this.ctx;
      this.ctx = this.groupStack.pop();
      if (this.ctx.imageSmoothingEnabled !== undefined) {
        this.ctx.imageSmoothingEnabled = false;
      } else {
        this.ctx.mozImageSmoothingEnabled = false;
      }
      if (group.smask) {
        this.tempSMask = this.smaskStack.pop();
      } else {
        this.ctx.drawImage(groupCtx.canvas, 0, 0);
      }
      this.restore();
    },
    beginAnnotations: function CanvasGraphics_beginAnnotations() {
      this.save();
      if (this.baseTransform) {
        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
      }
    },
    endAnnotations: function CanvasGraphics_endAnnotations() {
      this.restore();
    },
    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
      this.save();
      resetCtxToDefault(this.ctx);
      this.current = new CanvasExtraState();
      if (Array.isArray(rect) && rect.length === 4) {
        var width = rect[2] - rect[0];
        var height = rect[3] - rect[1];
        this.ctx.rect(rect[0], rect[1], width, height);
        this.clip();
        this.endPath();
      }
      this.transform.apply(this, transform);
      this.transform.apply(this, matrix);
    },
    endAnnotation: function CanvasGraphics_endAnnotation() {
      this.restore();
    },
    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
      var domImage = this.objs.get(objId);
      if (!domImage) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      this.save();
      var ctx = this.ctx;
      ctx.scale(1 / w, -1 / h);
      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
      if (this.imageLayer) {
        var currentTransform = ctx.mozCurrentTransformInverse;
        var position = this.getCanvasPosition(0, 0);
        this.imageLayer.appendImage({
          objId: objId,
          left: position[0],
          top: position[1],
          width: w / currentTransform[0],
          height: h / currentTransform[3]
        });
      }
      this.restore();
    },
    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
      var ctx = this.ctx;
      var width = img.width,
          height = img.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var glyph = this.processingType3;
      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
          glyph.compiled = compileType3Glyph({
            data: img.data,
            width: width,
            height: height
          });
        } else {
          glyph.compiled = null;
        }
      }
      if (glyph && glyph.compiled) {
        glyph.compiled(ctx);
        return;
      }
      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, img);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      this.paintInlineImageXObject(maskCanvas.canvas);
    },
    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
      var width = imgData.width;
      var height = imgData.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, imgData);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      var ctx = this.ctx;
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        ctx.save();
        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      for (var i = 0, ii = images.length; i < ii; i++) {
        var image = images[i];
        var width = image.width,
            height = image.height;
        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
        var maskCtx = maskCanvas.context;
        maskCtx.save();
        putBinaryImageMask(maskCtx, image);
        maskCtx.globalCompositeOperation = 'source-in';
        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
        maskCtx.fillRect(0, 0, width, height);
        maskCtx.restore();
        ctx.save();
        ctx.transform.apply(ctx, image.transform);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
      var imgData = this.objs.get(objId);
      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      this.paintInlineImageXObject(imgData);
    },
    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
      var imgData = this.objs.get(objId);
      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      var width = imgData.width;
      var height = imgData.height;
      var map = [];
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        map.push({
          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
          x: 0,
          y: 0,
          w: width,
          h: height
        });
      }
      this.paintInlineImageXObjectGroup(imgData, map);
    },
    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
      var width = imgData.width;
      var height = imgData.height;
      var ctx = this.ctx;
      this.save();
      ctx.scale(1 / width, -1 / height);
      var currentTransform = ctx.mozCurrentTransformInverse;
      var a = currentTransform[0],
          b = currentTransform[1];
      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
      var c = currentTransform[2],
          d = currentTransform[3];
      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
      var imgToPaint, tmpCanvas;
      if (typeof HTMLElement === 'function' && imgData instanceof HTMLElement || !imgData.data) {
        imgToPaint = imgData;
      } else {
        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
        var tmpCtx = tmpCanvas.context;
        putBinaryImageData(tmpCtx, imgData);
        imgToPaint = tmpCanvas.canvas;
      }
      var paintWidth = width,
          paintHeight = height;
      var tmpCanvasId = 'prescale1';
      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
        var newWidth = paintWidth,
            newHeight = paintHeight;
        if (widthScale > 2 && paintWidth > 1) {
          newWidth = Math.ceil(paintWidth / 2);
          widthScale /= paintWidth / newWidth;
        }
        if (heightScale > 2 && paintHeight > 1) {
          newHeight = Math.ceil(paintHeight / 2);
          heightScale /= paintHeight / newHeight;
        }
        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
        tmpCtx = tmpCanvas.context;
        tmpCtx.clearRect(0, 0, newWidth, newHeight);
        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
        imgToPaint = tmpCanvas.canvas;
        paintWidth = newWidth;
        paintHeight = newHeight;
        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
      }
      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
      if (this.imageLayer) {
        var position = this.getCanvasPosition(0, -height);
        this.imageLayer.appendImage({
          imgData: imgData,
          left: position[0],
          top: position[1],
          width: width / currentTransform[0],
          height: height / currentTransform[3]
        });
      }
      this.restore();
    },
    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
      var ctx = this.ctx;
      var w = imgData.width;
      var h = imgData.height;
      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
      var tmpCtx = tmpCanvas.context;
      putBinaryImageData(tmpCtx, imgData);
      for (var i = 0, ii = map.length; i < ii; i++) {
        var entry = map[i];
        ctx.save();
        ctx.transform.apply(ctx, entry.transform);
        ctx.scale(1, -1);
        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
        if (this.imageLayer) {
          var position = this.getCanvasPosition(entry.x, entry.y);
          this.imageLayer.appendImage({
            imgData: imgData,
            left: position[0],
            top: position[1],
            width: w,
            height: h
          });
        }
        ctx.restore();
      }
    },
    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
      this.ctx.fillRect(0, 0, 1, 1);
    },
    paintXObject: function CanvasGraphics_paintXObject() {
      (0, _util.warn)('Unsupported \'paintXObject\' command.');
    },
    markPoint: function CanvasGraphics_markPoint(tag) {},
    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
    beginCompat: function CanvasGraphics_beginCompat() {},
    endCompat: function CanvasGraphics_endCompat() {},
    consumePath: function CanvasGraphics_consumePath() {
      var ctx = this.ctx;
      if (this.pendingClip) {
        if (this.pendingClip === EO_CLIP) {
          ctx.clip('evenodd');
        } else {
          ctx.clip();
        }
        this.pendingClip = null;
      }
      ctx.beginPath();
    },
    getSinglePixelWidth: function getSinglePixelWidth(scale) {
      if (this._cachedGetSinglePixelWidth === null) {
        var inverse = this.ctx.mozCurrentTransformInverse;
        this._cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
      }
      return this._cachedGetSinglePixelWidth;
    },

    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
      var transform = this.ctx.mozCurrentTransform;
      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
    }
  };
  for (var op in _util.OPS) {
    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
  }
  return CanvasGraphics;
}();
exports.CanvasGraphics = CanvasGraphics;

/***/ }),
/* 134 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TilingPattern = exports.getShadingPatternFromIR = undefined;

var _util = __w_pdfjs_require__(1);

var ShadingIRs = {};
ShadingIRs.RadialAxial = {
  fromIR: function RadialAxial_fromIR(raw) {
    var type = raw[1];
    var colorStops = raw[2];
    var p0 = raw[3];
    var p1 = raw[4];
    var r0 = raw[5];
    var r1 = raw[6];
    return {
      type: 'Pattern',
      getPattern: function RadialAxial_getPattern(ctx) {
        var grad;
        if (type === 'axial') {
          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
        } else if (type === 'radial') {
          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
        }
        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
          var c = colorStops[i];
          grad.addColorStop(c[0], c[1]);
        }
        return grad;
      }
    };
  }
};
var createMeshCanvas = function createMeshCanvasClosure() {
  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    var coords = context.coords,
        colors = context.colors;
    var bytes = data.data,
        rowSize = data.width * 4;
    var tmp;
    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }
    if (coords[p2 + 1] > coords[p3 + 1]) {
      tmp = p2;
      p2 = p3;
      p3 = tmp;
      tmp = c2;
      c2 = c3;
      c3 = tmp;
    }
    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }
    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) {
      return;
    }
    var c1r = colors[c1],
        c1g = colors[c1 + 1],
        c1b = colors[c1 + 2];
    var c2r = colors[c2],
        c2g = colors[c2 + 1],
        c2b = colors[c2 + 2];
    var c3r = colors[c3],
        c3g = colors[c3 + 1],
        c3b = colors[c3 + 2];
    var minY = Math.round(y1),
        maxY = Math.round(y3);
    var xa, car, cag, cab;
    var xb, cbr, cbg, cbb;
    var k;
    for (var y = minY; y <= maxY; y++) {
      if (y < y2) {
        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
        xa = x1 - (x1 - x2) * k;
        car = c1r - (c1r - c2r) * k;
        cag = c1g - (c1g - c2g) * k;
        cab = c1b - (c1b - c2b) * k;
      } else {
        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
        xa = x2 - (x2 - x3) * k;
        car = c2r - (c2r - c3r) * k;
        cag = c2g - (c2g - c3g) * k;
        cab = c2b - (c2b - c3b) * k;
      }
      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
      xb = x1 - (x1 - x3) * k;
      cbr = c1r - (c1r - c3r) * k;
      cbg = c1g - (c1g - c3g) * k;
      cbb = c1b - (c1b - c3b) * k;
      var x1_ = Math.round(Math.min(xa, xb));
      var x2_ = Math.round(Math.max(xa, xb));
      var j = rowSize * y + x1_ * 4;
      for (var x = x1_; x <= x2_; x++) {
        k = (xa - x) / (xa - xb);
        k = k < 0 ? 0 : k > 1 ? 1 : k;
        bytes[j++] = car - (car - cbr) * k | 0;
        bytes[j++] = cag - (cag - cbg) * k | 0;
        bytes[j++] = cab - (cab - cbb) * k | 0;
        bytes[j++] = 255;
      }
    }
  }
  function drawFigure(data, figure, context) {
    var ps = figure.coords;
    var cs = figure.colors;
    var i, ii;
    switch (figure.type) {
      case 'lattice':
        var verticesPerRow = figure.verticesPerRow;
        var rows = Math.floor(ps.length / verticesPerRow) - 1;
        var cols = verticesPerRow - 1;
        for (i = 0; i < rows; i++) {
          var q = i * verticesPerRow;
          for (var j = 0; j < cols; j++, q++) {
            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
          }
        }
        break;
      case 'triangles':
        for (i = 0, ii = ps.length; i < ii; i += 3) {
          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
        }
        break;
      default:
        throw new Error('illegal figure');
    }
  }
  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases, webGLContext) {
    var EXPECTED_SCALE = 1.1;
    var MAX_PATTERN_SIZE = 3000;
    var BORDER_SIZE = 2;
    var offsetX = Math.floor(bounds[0]);
    var offsetY = Math.floor(bounds[1]);
    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var scaleX = boundsWidth / width;
    var scaleY = boundsHeight / height;
    var context = {
      coords: coords,
      colors: colors,
      offsetX: -offsetX,
      offsetY: -offsetY,
      scaleX: 1 / scaleX,
      scaleY: 1 / scaleY
    };
    var paddedWidth = width + BORDER_SIZE * 2;
    var paddedHeight = height + BORDER_SIZE * 2;
    var canvas, tmpCanvas, i, ii;
    if (webGLContext.isEnabled) {
      canvas = webGLContext.drawFigures({
        width: width,
        height: height,
        backgroundColor: backgroundColor,
        figures: figures,
        context: context
      });
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    } else {
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      var tmpCtx = tmpCanvas.context;
      var data = tmpCtx.createImageData(width, height);
      if (backgroundColor) {
        var bytes = data.data;
        for (i = 0, ii = bytes.length; i < ii; i += 4) {
          bytes[i] = backgroundColor[0];
          bytes[i + 1] = backgroundColor[1];
          bytes[i + 2] = backgroundColor[2];
          bytes[i + 3] = 255;
        }
      }
      for (i = 0; i < figures.length; i++) {
        drawFigure(data, figures[i], context);
      }
      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    }
    return {
      canvas: canvas,
      offsetX: offsetX - BORDER_SIZE * scaleX,
      offsetY: offsetY - BORDER_SIZE * scaleY,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }
  return createMeshCanvas;
}();
ShadingIRs.Mesh = {
  fromIR: function Mesh_fromIR(raw) {
    var coords = raw[2];
    var colors = raw[3];
    var figures = raw[4];
    var bounds = raw[5];
    var matrix = raw[6];
    var background = raw[8];
    return {
      type: 'Pattern',
      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
        var scale;
        if (shadingFill) {
          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
        } else {
          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
          if (matrix) {
            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
          }
        }
        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases, owner.webGLContext);
        if (!shadingFill) {
          ctx.setTransform.apply(ctx, owner.baseTransform);
          if (matrix) {
            ctx.transform.apply(ctx, matrix);
          }
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
      }
    };
  }
};
ShadingIRs.Dummy = {
  fromIR: function Dummy_fromIR() {
    return {
      type: 'Pattern',
      getPattern: function Dummy_fromIR_getPattern() {
        return 'hotpink';
      }
    };
  }
};
function getShadingPatternFromIR(raw) {
  var shadingIR = ShadingIRs[raw[0]];
  if (!shadingIR) {
    throw new Error('Unknown IR type: ' + raw[0]);
  }
  return shadingIR.fromIR(raw);
}
var TilingPattern = function TilingPatternClosure() {
  var PaintType = {
    COLORED: 1,
    UNCOLORED: 2
  };
  var MAX_PATTERN_SIZE = 3000;
  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
    this.operatorList = IR[2];
    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
    this.bbox = IR[4];
    this.xstep = IR[5];
    this.ystep = IR[6];
    this.paintType = IR[7];
    this.tilingType = IR[8];
    this.color = color;
    this.canvasGraphicsFactory = canvasGraphicsFactory;
    this.baseTransform = baseTransform;
    this.type = 'Pattern';
    this.ctx = ctx;
  }
  TilingPattern.prototype = {
    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
      var operatorList = this.operatorList;
      var bbox = this.bbox;
      var xstep = this.xstep;
      var ystep = this.ystep;
      var paintType = this.paintType;
      var tilingType = this.tilingType;
      var color = this.color;
      var canvasGraphicsFactory = this.canvasGraphicsFactory;
      (0, _util.info)('TilingType: ' + tilingType);
      var x0 = bbox[0],
          y0 = bbox[1],
          x1 = bbox[2],
          y1 = bbox[3];
      var topLeft = [x0, y0];
      var botRight = [x0 + xstep, y0 + ystep];
      var width = botRight[0] - topLeft[0];
      var height = botRight[1] - topLeft[1];
      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
      width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
      height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', width, height, true);
      var tmpCtx = tmpCanvas.context;
      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
      graphics.groupLevel = owner.groupLevel;
      this.setFillAndStrokeStyleToContext(graphics, paintType, color);
      this.setScale(width, height, xstep, ystep);
      this.transformToScale(graphics);
      var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
      graphics.transform.apply(graphics, tmpTranslate);
      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
      graphics.executeOperatorList(operatorList);
      return tmpCanvas.canvas;
    },
    setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
      this.scale = [width / xstep, height / ystep];
    },
    transformToScale: function TilingPattern_transformToScale(graphics) {
      var scale = this.scale;
      var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
      graphics.transform.apply(graphics, tmpScale);
    },
    scaleToContext: function TilingPattern_scaleToContext() {
      var scale = this.scale;
      this.ctx.scale(1 / scale[0], 1 / scale[1]);
    },
    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
      if (Array.isArray(bbox) && bbox.length === 4) {
        var bboxWidth = x1 - x0;
        var bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        graphics.clip();
        graphics.endPath();
      }
    },
    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
      var context = graphics.ctx,
          current = graphics.current;
      switch (paintType) {
        case PaintType.COLORED:
          var ctx = this.ctx;
          context.fillStyle = ctx.fillStyle;
          context.strokeStyle = ctx.strokeStyle;
          current.fillColor = ctx.fillStyle;
          current.strokeColor = ctx.strokeStyle;
          break;
        case PaintType.UNCOLORED:
          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
          context.fillStyle = cssColor;
          context.strokeStyle = cssColor;
          current.fillColor = cssColor;
          current.strokeColor = cssColor;
          break;
        default:
          throw new _util.FormatError('Unsupported paint type: ' + paintType);
      }
    },
    getPattern: function TilingPattern_getPattern(ctx, owner) {
      var temporaryPatternCanvas = this.createPatternCanvas(owner);
      ctx = this.ctx;
      ctx.setTransform.apply(ctx, this.baseTransform);
      ctx.transform.apply(ctx, this.matrix);
      this.scaleToContext();
      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
    }
  };
  return TilingPattern;
}();
exports.getShadingPatternFromIR = getShadingPatternFromIR;
exports.TilingPattern = TilingPattern;

/***/ }),
/* 135 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GlobalWorkerOptions = Object.create(null);
GlobalWorkerOptions.workerPort = GlobalWorkerOptions.workerPort === undefined ? null : GlobalWorkerOptions.workerPort;
GlobalWorkerOptions.workerSrc = GlobalWorkerOptions.workerSrc === undefined ? '' : GlobalWorkerOptions.workerSrc;
exports.GlobalWorkerOptions = GlobalWorkerOptions;

/***/ }),
/* 136 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageHandler = undefined;

var _regenerator = __w_pdfjs_require__(137);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var resolveCall = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(fn, args) {
    var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (fn) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return');

          case 2:
            return _context.abrupt('return', fn.apply(thisArg, args));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function resolveCall(_x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var _util = __w_pdfjs_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function wrapReason(reason) {
  if ((typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object') {
    return reason;
  }
  switch (reason.name) {
    case 'AbortException':
      return new _util.AbortException(reason.message);
    case 'MissingPDFException':
      return new _util.MissingPDFException(reason.message);
    case 'UnexpectedResponseException':
      return new _util.UnexpectedResponseException(reason.message, reason.status);
    default:
      return new _util.UnknownErrorException(reason.message, reason.details);
  }
}
function makeReasonSerializable(reason) {
  if (!(reason instanceof Error) || reason instanceof _util.AbortException || reason instanceof _util.MissingPDFException || reason instanceof _util.UnexpectedResponseException || reason instanceof _util.UnknownErrorException) {
    return reason;
  }
  return new _util.UnknownErrorException(reason.message, reason.toString());
}
function resolveOrReject(capability, success, reason) {
  if (success) {
    capability.resolve();
  } else {
    capability.reject(reason);
  }
}
function finalize(promise) {
  return Promise.resolve(promise).catch(function () {});
}
function MessageHandler(sourceName, targetName, comObj) {
  var _this = this;

  this.sourceName = sourceName;
  this.targetName = targetName;
  this.comObj = comObj;
  this.callbackId = 1;
  this.streamId = 1;
  this.postMessageTransfers = true;
  this.streamSinks = Object.create(null);
  this.streamControllers = Object.create(null);
  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
  var ah = this.actionHandler = Object.create(null);
  this._onComObjOnMessage = function (event) {
    var data = event.data;
    if (data.targetName !== _this.sourceName) {
      return;
    }
    if (data.stream) {
      _this._processStreamMessage(data);
    } else if (data.isReply) {
      var callbackId = data.callbackId;
      if (data.callbackId in callbacksCapabilities) {
        var callback = callbacksCapabilities[callbackId];
        delete callbacksCapabilities[callbackId];
        if ('error' in data) {
          callback.reject(wrapReason(data.error));
        } else {
          callback.resolve(data.data);
        }
      } else {
        throw new Error('Cannot resolve callback ' + callbackId);
      }
    } else if (data.action in ah) {
      var action = ah[data.action];
      if (data.callbackId) {
        var _sourceName = _this.sourceName;
        var _targetName = data.sourceName;
        Promise.resolve().then(function () {
          return action[0].call(action[1], data.data);
        }).then(function (result) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            data: result
          });
        }, function (reason) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            error: makeReasonSerializable(reason)
          });
        });
      } else if (data.streamId) {
        _this._createStreamSink(data);
      } else {
        action[0].call(action[1], data.data);
      }
    } else {
      throw new Error('Unknown action from worker: ' + data.action);
    }
  };
  comObj.addEventListener('message', this._onComObjOnMessage);
}
MessageHandler.prototype = {
  on: function on(actionName, handler, scope) {
    var ah = this.actionHandler;
    if (ah[actionName]) {
      throw new Error('There is already an actionName called "' + actionName + '"');
    }
    ah[actionName] = [handler, scope];
  },
  send: function send(actionName, data, transfers) {
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data
    };
    this.postMessage(message, transfers);
  },
  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
    var callbackId = this.callbackId++;
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data,
      callbackId: callbackId
    };
    var capability = (0, _util.createPromiseCapability)();
    this.callbacksCapabilities[callbackId] = capability;
    try {
      this.postMessage(message, transfers);
    } catch (e) {
      capability.reject(e);
    }
    return capability.promise;
  },
  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
    var _this2 = this;

    var streamId = this.streamId++;
    var sourceName = this.sourceName;
    var targetName = this.targetName;
    return new _util.ReadableStream({
      start: function start(controller) {
        var startCapability = (0, _util.createPromiseCapability)();
        _this2.streamControllers[streamId] = {
          controller: controller,
          startCall: startCapability,
          isClosed: false
        };
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          action: actionName,
          streamId: streamId,
          data: data,
          desiredSize: controller.desiredSize
        });
        return startCapability.promise;
      },
      pull: function pull(controller) {
        var pullCapability = (0, _util.createPromiseCapability)();
        _this2.streamControllers[streamId].pullCall = pullCapability;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'pull',
          streamId: streamId,
          desiredSize: controller.desiredSize
        });
        return pullCapability.promise;
      },
      cancel: function cancel(reason) {
        var cancelCapability = (0, _util.createPromiseCapability)();
        _this2.streamControllers[streamId].cancelCall = cancelCapability;
        _this2.streamControllers[streamId].isClosed = true;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'cancel',
          reason: reason,
          streamId: streamId
        });
        return cancelCapability.promise;
      }
    }, queueingStrategy);
  },
  _createStreamSink: function _createStreamSink(data) {
    var _this3 = this;

    var self = this;
    var action = this.actionHandler[data.action];
    var streamId = data.streamId;
    var desiredSize = data.desiredSize;
    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var capability = (0, _util.createPromiseCapability)();
    var sendStreamRequest = function sendStreamRequest(_ref2) {
      var stream = _ref2.stream,
          chunk = _ref2.chunk,
          transfers = _ref2.transfers,
          success = _ref2.success,
          reason = _ref2.reason;

      _this3.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        streamId: streamId,
        chunk: chunk,
        success: success,
        reason: reason
      }, transfers);
    };
    var streamSink = {
      enqueue: function enqueue(chunk) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var transfers = arguments[2];

        if (this.isCancelled) {
          return;
        }
        var lastDesiredSize = this.desiredSize;
        this.desiredSize -= size;
        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
          this.sinkCapability = (0, _util.createPromiseCapability)();
          this.ready = this.sinkCapability.promise;
        }
        sendStreamRequest({
          stream: 'enqueue',
          chunk: chunk,
          transfers: transfers
        });
      },
      close: function close() {
        if (this.isCancelled) {
          return;
        }
        this.isCancelled = true;
        sendStreamRequest({ stream: 'close' });
        delete self.streamSinks[streamId];
      },
      error: function error(reason) {
        if (this.isCancelled) {
          return;
        }
        this.isCancelled = true;
        sendStreamRequest({
          stream: 'error',
          reason: reason
        });
      },

      sinkCapability: capability,
      onPull: null,
      onCancel: null,
      isCancelled: false,
      desiredSize: desiredSize,
      ready: null
    };
    streamSink.sinkCapability.resolve();
    streamSink.ready = streamSink.sinkCapability.promise;
    this.streamSinks[streamId] = streamSink;
    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
      sendStreamRequest({
        stream: 'start_complete',
        success: true
      });
    }, function (reason) {
      sendStreamRequest({
        stream: 'start_complete',
        success: false,
        reason: reason
      });
    });
  },
  _processStreamMessage: function _processStreamMessage(data) {
    var _this4 = this;

    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var streamId = data.streamId;
    var sendStreamResponse = function sendStreamResponse(_ref3) {
      var stream = _ref3.stream,
          success = _ref3.success,
          reason = _ref3.reason;

      _this4.comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        success: success,
        streamId: streamId,
        reason: reason
      });
    };
    var deleteStreamController = function deleteStreamController() {
      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
        return capability && finalize(capability.promise);
      })).then(function () {
        delete _this4.streamControllers[data.streamId];
      });
    };
    switch (data.stream) {
      case 'start_complete':
        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
        break;
      case 'pull_complete':
        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
        break;
      case 'pull':
        if (!this.streamSinks[data.streamId]) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
          break;
        }
        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
          this.streamSinks[data.streamId].sinkCapability.resolve();
        }
        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: false,
            reason: reason
          });
        });
        break;
      case 'enqueue':
        (0, _util.assert)(this.streamControllers[data.streamId], 'enqueue should have stream controller');
        if (!this.streamControllers[data.streamId].isClosed) {
          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
        }
        break;
      case 'close':
        (0, _util.assert)(this.streamControllers[data.streamId], 'close should have stream controller');
        if (this.streamControllers[data.streamId].isClosed) {
          break;
        }
        this.streamControllers[data.streamId].isClosed = true;
        this.streamControllers[data.streamId].controller.close();
        deleteStreamController();
        break;
      case 'error':
        (0, _util.assert)(this.streamControllers[data.streamId], 'error should have stream controller');
        this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
        deleteStreamController();
        break;
      case 'cancel_complete':
        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
        deleteStreamController();
        break;
      case 'cancel':
        if (!this.streamSinks[data.streamId]) {
          break;
        }
        resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: false,
            reason: reason
          });
        });
        this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
        this.streamSinks[data.streamId].isCancelled = true;
        delete this.streamSinks[data.streamId];
        break;
      default:
        throw new Error('Unexpected stream case');
    }
  },
  postMessage: function postMessage(message, transfers) {
    if (transfers && this.postMessageTransfers) {
      this.comObj.postMessage(message, transfers);
    } else {
      this.comObj.postMessage(message);
    }
  },
  destroy: function destroy() {
    this.comObj.removeEventListener('message', this._onComObjOnMessage);
  }
};
exports.MessageHandler = MessageHandler;

/***/ }),
/* 137 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = __w_pdfjs_require__(138);

/***/ }),
/* 138 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var g = function () {
  return this;
}() || Function("return this")();
var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
var oldRuntime = hadRuntime && g.regeneratorRuntime;
g.regeneratorRuntime = undefined;
module.exports = __w_pdfjs_require__(139);
if (hadRuntime) {
  g.regeneratorRuntime = oldRuntime;
} else {
  try {
    delete g.regeneratorRuntime;
  } catch (e) {
    g.regeneratorRuntime = undefined;
  }
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined;
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  var inModule = ( false ? undefined : _typeof(module)) === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      module.exports = runtime;
    }
    return;
  }
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);
    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }
  runtime.wrap = wrap;
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };
  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    IteratorPrototype = NativeIteratorPrototype;
  }
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }
  runtime.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };
  runtime.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };
  runtime.awrap = function (arg) {
    return { __await: arg };
  };
  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }
        return Promise.resolve(value).then(function (unwrapped) {
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }
    var previousPromise;
    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }
      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }
    this._invoke = enqueue;
  }
  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;
  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
    return runtime.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };
  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }
      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }
        return doneResult();
      }
      context.method = method;
      context.arg = arg;
      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if (context.method === "next") {
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }
          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }
        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
          if (record.arg === ContinueSentinel) {
            continue;
          }
          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      context.delegate = null;
      if (context.method === "throw") {
        if (delegate.iterator.return) {
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);
          if (context.method === "throw") {
            return ContinueSentinel;
          }
        }
        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }
    var info = record.arg;
    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }
    if (info.done) {
      context[delegate.resultName] = info.value;
      context.next = delegate.nextLoc;
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      return info;
    }
    context.delegate = null;
    return ContinueSentinel;
  }
  defineIteratorMethods(Gp);
  Gp[toStringTagSymbol] = "Generator";
  Gp[iteratorSymbol] = function () {
    return this;
  };
  Gp.toString = function () {
    return "[object Generator]";
  };
  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };
    if (1 in locs) {
      entry.catchLoc = locs[1];
    }
    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }
    this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }
  runtime.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }
      next.done = true;
      return next;
    };
  };
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }
      if (typeof iterable.next === "function") {
        return iterable;
      }
      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }
          next.value = undefined;
          next.done = true;
          return next;
        };
        return next.next = next;
      }
    }
    return { next: doneResult };
  }
  runtime.values = values;
  function doneResult() {
    return {
      value: undefined,
      done: true
    };
  }
  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined;
      this.tryEntries.forEach(resetTryEntry);
      if (!skipTempReset) {
        for (var name in this) {
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }
      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        if (caught) {
          context.method = "next";
          context.arg = undefined;
        }
        return !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;
        if (entry.tryLoc === "root") {
          return handle("end");
        }
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        finallyEntry = null;
      }
      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;
      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }
      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }
      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };
      if (this.method === "next") {
        this.arg = undefined;
      }
      return ContinueSentinel;
    }
  };
}(function () {
  return this;
}() || Function("return this")());
/* WEBPACK VAR INJECTION */}.call(this, __w_pdfjs_require__(140)(module)))

/***/ }),
/* 140 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (module) {
  if (!module.webpackPolyfill) {
    module.deprecate = function () {};
    module.paths = [];
    if (!module.children) module.children = [];
    Object.defineProperty(module, "loaded", {
      enumerable: true,
      get: function get() {
        return module.l;
      }
    });
    Object.defineProperty(module, "id", {
      enumerable: true,
      get: function get() {
        return module.i;
      }
    });
    module.webpackPolyfill = 1;
  }
  return module;
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(1);

var _xml_parser = __w_pdfjs_require__(142);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Metadata = function () {
  function Metadata(data) {
    _classCallCheck(this, Metadata);

    (0, _util.assert)(typeof data === 'string', 'Metadata: input is not a string');
    data = this._repair(data);
    var parser = new _xml_parser.SimpleXMLParser();
    var xmlDocument = parser.parseFromString(data);
    this._metadata = Object.create(null);
    if (xmlDocument) {
      this._parse(xmlDocument);
    }
  }

  _createClass(Metadata, [{
    key: '_repair',
    value: function _repair(data) {
      return data.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
        var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
          return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
        }).replace(/&(amp|apos|gt|lt|quot);/g, function (str, name) {
          switch (name) {
            case 'amp':
              return '&';
            case 'apos':
              return '\'';
            case 'gt':
              return '>';
            case 'lt':
              return '<';
            case 'quot':
              return '\"';
          }
          throw new Error('_repair: ' + name + ' isn\'t defined.');
        });
        var chars = '';
        for (var i = 0, ii = bytes.length; i < ii; i += 2) {
          var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
          if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) {
            chars += String.fromCharCode(code);
          } else {
            chars += '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
          }
        }
        return '>' + chars;
      });
    }
  }, {
    key: '_parse',
    value: function _parse(xmlDocument) {
      var rdf = xmlDocument.documentElement;
      if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
        rdf = rdf.firstChild;
        while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
          rdf = rdf.nextSibling;
        }
      }
      var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
      if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
        return;
      }
      var children = rdf.childNodes;
      for (var i = 0, ii = children.length; i < ii; i++) {
        var desc = children[i];
        if (desc.nodeName.toLowerCase() !== 'rdf:description') {
          continue;
        }
        for (var j = 0, jj = desc.childNodes.length; j < jj; j++) {
          if (desc.childNodes[j].nodeName.toLowerCase() !== '#text') {
            var entry = desc.childNodes[j];
            var name = entry.nodeName.toLowerCase();
            this._metadata[name] = entry.textContent.trim();
          }
        }
      }
    }
  }, {
    key: 'get',
    value: function get(name) {
      return this._metadata[name] || null;
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      return this._metadata;
    }
  }, {
    key: 'has',
    value: function has(name) {
      return typeof this._metadata[name] !== 'undefined';
    }
  }]);

  return Metadata;
}();

exports.Metadata = Metadata;

/***/ }),
/* 142 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var XMLParserErrorCode = {
  NoError: 0,
  EndOfDocument: -1,
  UnterminatedCdat: -2,
  UnterminatedXmlDeclaration: -3,
  UnterminatedDoctypeDeclaration: -4,
  UnterminatedComment: -5,
  MalformedElement: -6,
  OutOfMemory: -7,
  UnterminatedAttributeValue: -8,
  UnterminatedElement: -9,
  ElementNeverBegun: -10
};
function isWhitespace(s, index) {
  var ch = s[index];
  return ch === ' ' || ch === '\n' || ch === '\r' || ch === '\t';
}
function isWhitespaceString(s) {
  for (var i = 0, ii = s.length; i < ii; i++) {
    if (!isWhitespace(s, i)) {
      return false;
    }
  }
  return true;
}

var XMLParserBase = function () {
  function XMLParserBase() {
    _classCallCheck(this, XMLParserBase);
  }

  _createClass(XMLParserBase, [{
    key: '_resolveEntities',
    value: function _resolveEntities(s) {
      return s.replace(/&([^;]+);/g, function (all, entity) {
        if (entity.substring(0, 2) === '#x') {
          return String.fromCharCode(parseInt(entity.substring(2), 16));
        } else if (entity.substring(0, 1) === '#') {
          return String.fromCharCode(parseInt(entity.substring(1), 10));
        }
        switch (entity) {
          case 'lt':
            return '<';
          case 'gt':
            return '>';
          case 'amp':
            return '&';
          case 'quot':
            return '\"';
        }
        return this.onResolveEntity(entity);
      });
    }
  }, {
    key: '_parseContent',
    value: function _parseContent(s, start) {
      var pos = start,
          name = void 0,
          attributes = [];
      function skipWs() {
        while (pos < s.length && isWhitespace(s, pos)) {
          ++pos;
        }
      }
      while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '>' && s[pos] !== '/') {
        ++pos;
      }
      name = s.substring(start, pos);
      skipWs();
      while (pos < s.length && s[pos] !== '>' && s[pos] !== '/' && s[pos] !== '?') {
        skipWs();
        var attrName = '',
            attrValue = '';
        while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '=') {
          attrName += s[pos];
          ++pos;
        }
        skipWs();
        if (s[pos] !== '=') {
          return null;
        }
        ++pos;
        skipWs();
        var attrEndChar = s[pos];
        if (attrEndChar !== '\"' && attrEndChar !== '\'') {
          return null;
        }
        var attrEndIndex = s.indexOf(attrEndChar, ++pos);
        if (attrEndIndex < 0) {
          return null;
        }
        attrValue = s.substring(pos, attrEndIndex);
        attributes.push({
          name: attrName,
          value: this._resolveEntities(attrValue)
        });
        pos = attrEndIndex + 1;
        skipWs();
      }
      return {
        name: name,
        attributes: attributes,
        parsed: pos - start
      };
    }
  }, {
    key: '_parseProcessingInstruction',
    value: function _parseProcessingInstruction(s, start) {
      var pos = start,
          name = void 0,
          value = void 0;
      function skipWs() {
        while (pos < s.length && isWhitespace(s, pos)) {
          ++pos;
        }
      }
      while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '>' && s[pos] !== '/') {
        ++pos;
      }
      name = s.substring(start, pos);
      skipWs();
      var attrStart = pos;
      while (pos < s.length && (s[pos] !== '?' || s[pos + 1] !== '>')) {
        ++pos;
      }
      value = s.substring(attrStart, pos);
      return {
        name: name,
        value: value,
        parsed: pos - start
      };
    }
  }, {
    key: 'parseXml',
    value: function parseXml(s) {
      var i = 0;
      while (i < s.length) {
        var ch = s[i];
        var j = i;
        if (ch === '<') {
          ++j;
          var ch2 = s[j];
          var q = void 0;
          switch (ch2) {
            case '/':
              ++j;
              q = s.indexOf('>', j);
              if (q < 0) {
                this.onError(XMLParserErrorCode.UnterminatedElement);
                return;
              }
              this.onEndElement(s.substring(j, q));
              j = q + 1;
              break;
            case '?':
              ++j;
              var pi = this._parseProcessingInstruction(s, j);
              if (s.substring(j + pi.parsed, j + pi.parsed + 2) !== '?>') {
                this.onError(XMLParserErrorCode.UnterminatedXmlDeclaration);
                return;
              }
              this.onPi(pi.name, pi.value);
              j += pi.parsed + 2;
              break;
            case '!':
              if (s.substring(j + 1, j + 3) === '--') {
                q = s.indexOf('-->', j + 3);
                if (q < 0) {
                  this.onError(XMLParserErrorCode.UnterminatedComment);
                  return;
                }
                this.onComment(s.substring(j + 3, q));
                j = q + 3;
              } else if (s.substring(j + 1, j + 8) === '[CDATA[') {
                q = s.indexOf(']]>', j + 8);
                if (q < 0) {
                  this.onError(XMLParserErrorCode.UnterminatedCdat);
                  return;
                }
                this.onCdata(s.substring(j + 8, q));
                j = q + 3;
              } else if (s.substring(j + 1, j + 8) === 'DOCTYPE') {
                var q2 = s.indexOf('[', j + 8);
                var complexDoctype = false;
                q = s.indexOf('>', j + 8);
                if (q < 0) {
                  this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                  return;
                }
                if (q2 > 0 && q > q2) {
                  q = s.indexOf(']>', j + 8);
                  if (q < 0) {
                    this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                    return;
                  }
                  complexDoctype = true;
                }
                var doctypeContent = s.substring(j + 8, q + (complexDoctype ? 1 : 0));
                this.onDoctype(doctypeContent);
                j = q + (complexDoctype ? 2 : 1);
              } else {
                this.onError(XMLParserErrorCode.MalformedElement);
                return;
              }
              break;
            default:
              var content = this._parseContent(s, j);
              if (content === null) {
                this.onError(XMLParserErrorCode.MalformedElement);
                return;
              }
              var isClosed = false;
              if (s.substring(j + content.parsed, j + content.parsed + 2) === '/>') {
                isClosed = true;
              } else if (s.substring(j + content.parsed, j + content.parsed + 1) !== '>') {
                this.onError(XMLParserErrorCode.UnterminatedElement);
                return;
              }
              this.onBeginElement(content.name, content.attributes, isClosed);
              j += content.parsed + (isClosed ? 2 : 1);
              break;
          }
        } else {
          while (j < s.length && s[j] !== '<') {
            j++;
          }
          var text = s.substring(i, j);
          this.onText(this._resolveEntities(text));
        }
        i = j;
      }
    }
  }, {
    key: 'onResolveEntity',
    value: function onResolveEntity(name) {
      return '&' + name + ';';
    }
  }, {
    key: 'onPi',
    value: function onPi(name, value) {}
  }, {
    key: 'onComment',
    value: function onComment(text) {}
  }, {
    key: 'onCdata',
    value: function onCdata(text) {}
  }, {
    key: 'onDoctype',
    value: function onDoctype(doctypeContent) {}
  }, {
    key: 'onText',
    value: function onText(text) {}
  }, {
    key: 'onBeginElement',
    value: function onBeginElement(name, attributes, isEmpty) {}
  }, {
    key: 'onEndElement',
    value: function onEndElement(name) {}
  }, {
    key: 'onError',
    value: function onError(code) {}
  }]);

  return XMLParserBase;
}();

var SimpleDOMNode = function () {
  function SimpleDOMNode(nodeName, nodeValue) {
    _classCallCheck(this, SimpleDOMNode);

    this.nodeName = nodeName;
    this.nodeValue = nodeValue;
    Object.defineProperty(this, 'parentNode', {
      value: null,
      writable: true
    });
  }

  _createClass(SimpleDOMNode, [{
    key: 'hasChildNodes',
    value: function hasChildNodes() {
      return this.childNodes && this.childNodes.length > 0;
    }
  }, {
    key: 'firstChild',
    get: function get() {
      return this.childNodes[0];
    }
  }, {
    key: 'nextSibling',
    get: function get() {
      var index = this.parentNode.childNodes.indexOf(this);
      return this.parentNode.childNodes[index + 1];
    }
  }, {
    key: 'textContent',
    get: function get() {
      if (!this.childNodes) {
        return this.nodeValue || '';
      }
      return this.childNodes.map(function (child) {
        return child.textContent;
      }).join('');
    }
  }]);

  return SimpleDOMNode;
}();

var SimpleXMLParser = function (_XMLParserBase) {
  _inherits(SimpleXMLParser, _XMLParserBase);

  function SimpleXMLParser() {
    _classCallCheck(this, SimpleXMLParser);

    var _this = _possibleConstructorReturn(this, (SimpleXMLParser.__proto__ || Object.getPrototypeOf(SimpleXMLParser)).call(this));

    _this._currentFragment = null;
    _this._stack = null;
    _this._errorCode = XMLParserErrorCode.NoError;
    return _this;
  }

  _createClass(SimpleXMLParser, [{
    key: 'parseFromString',
    value: function parseFromString(data) {
      this._currentFragment = [];
      this._stack = [];
      this._errorCode = XMLParserErrorCode.NoError;
      this.parseXml(data);
      if (this._errorCode !== XMLParserErrorCode.NoError) {
        return undefined;
      }

      var _currentFragment = _slicedToArray(this._currentFragment, 1),
          documentElement = _currentFragment[0];

      if (!documentElement) {
        return undefined;
      }
      return { documentElement: documentElement };
    }
  }, {
    key: 'onResolveEntity',
    value: function onResolveEntity(name) {
      switch (name) {
        case 'apos':
          return '\'';
      }
      return _get(SimpleXMLParser.prototype.__proto__ || Object.getPrototypeOf(SimpleXMLParser.prototype), 'onResolveEntity', this).call(this, name);
    }
  }, {
    key: 'onText',
    value: function onText(text) {
      if (isWhitespaceString(text)) {
        return;
      }
      var node = new SimpleDOMNode('#text', text);
      this._currentFragment.push(node);
    }
  }, {
    key: 'onCdata',
    value: function onCdata(text) {
      var node = new SimpleDOMNode('#text', text);
      this._currentFragment.push(node);
    }
  }, {
    key: 'onBeginElement',
    value: function onBeginElement(name, attributes, isEmpty) {
      var node = new SimpleDOMNode(name);
      node.childNodes = [];
      this._currentFragment.push(node);
      if (isEmpty) {
        return;
      }
      this._stack.push(this._currentFragment);
      this._currentFragment = node.childNodes;
    }
  }, {
    key: 'onEndElement',
    value: function onEndElement(name) {
      this._currentFragment = this._stack.pop();
      var lastElement = this._currentFragment[this._currentFragment.length - 1];
      for (var i = 0, ii = lastElement.childNodes.length; i < ii; i++) {
        lastElement.childNodes[i].parentNode = lastElement;
      }
    }
  }, {
    key: 'onError',
    value: function onError(code) {
      this._errorCode = code;
    }
  }]);

  return SimpleXMLParser;
}(XMLParserBase);

exports.SimpleXMLParser = SimpleXMLParser;

/***/ }),
/* 143 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFDataTransportStream = undefined;

var _regenerator = __w_pdfjs_require__(137);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _util = __w_pdfjs_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var PDFDataTransportStream = function PDFDataTransportStreamClosure() {
  function PDFDataTransportStream(params, pdfDataRangeTransport) {
    var _this = this;

    (0, _util.assert)(pdfDataRangeTransport);
    this._queuedChunks = [];
    var initialData = params.initialData;
    if (initialData && initialData.length > 0) {
      var buffer = new Uint8Array(initialData).buffer;
      this._queuedChunks.push(buffer);
    }
    this._pdfDataRangeTransport = pdfDataRangeTransport;
    this._isStreamingSupported = !params.disableStream;
    this._isRangeSupported = !params.disableRange;
    this._contentLength = params.length;
    this._fullRequestReader = null;
    this._rangeReaders = [];
    this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
      _this._onReceiveData({
        begin: begin,
        chunk: chunk
      });
    });
    this._pdfDataRangeTransport.addProgressListener(function (loaded) {
      _this._onProgress({ loaded: loaded });
    });
    this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
      _this._onReceiveData({ chunk: chunk });
    });
    this._pdfDataRangeTransport.transportReady();
  }
  PDFDataTransportStream.prototype = {
    _onReceiveData: function PDFDataTransportStream_onReceiveData(args) {
      var buffer = new Uint8Array(args.chunk).buffer;
      if (args.begin === undefined) {
        if (this._fullRequestReader) {
          this._fullRequestReader._enqueue(buffer);
        } else {
          this._queuedChunks.push(buffer);
        }
      } else {
        var found = this._rangeReaders.some(function (rangeReader) {
          if (rangeReader._begin !== args.begin) {
            return false;
          }
          rangeReader._enqueue(buffer);
          return true;
        });
        (0, _util.assert)(found);
      }
    },
    _onProgress: function PDFDataTransportStream_onDataProgress(evt) {
      if (this._rangeReaders.length > 0) {
        var firstReader = this._rangeReaders[0];
        if (firstReader.onProgress) {
          firstReader.onProgress({ loaded: evt.loaded });
        }
      }
    },
    _removeRangeReader: function PDFDataTransportStream_removeRangeReader(reader) {
      var i = this._rangeReaders.indexOf(reader);
      if (i >= 0) {
        this._rangeReaders.splice(i, 1);
      }
    },
    getFullReader: function PDFDataTransportStream_getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      var queuedChunks = this._queuedChunks;
      this._queuedChunks = null;
      return new PDFDataTransportStreamReader(this, queuedChunks);
    },
    getRangeReader: function PDFDataTransportStream_getRangeReader(begin, end) {
      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
      this._pdfDataRangeTransport.requestDataRange(begin, end);
      this._rangeReaders.push(reader);
      return reader;
    },
    cancelAllRequests: function PDFDataTransportStream_cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }
      var readers = this._rangeReaders.slice(0);
      readers.forEach(function (rangeReader) {
        rangeReader.cancel(reason);
      });
      this._pdfDataRangeTransport.abort();
    }
  };
  function PDFDataTransportStreamReader(stream, queuedChunks) {
    this._stream = stream;
    this._done = false;
    this._filename = null;
    this._queuedChunks = queuedChunks || [];
    this._requests = [];
    this._headersReady = Promise.resolve();
    stream._fullRequestReader = this;
    this.onProgress = null;
  }
  PDFDataTransportStreamReader.prototype = {
    _enqueue: function PDFDataTransportStreamReader_enqueue(chunk) {
      if (this._done) {
        return;
      }
      if (this._requests.length > 0) {
        var requestCapability = this._requests.shift();
        requestCapability.resolve({
          value: chunk,
          done: false
        });
        return;
      }
      this._queuedChunks.push(chunk);
    },
    get headersReady() {
      return this._headersReady;
    },
    get filename() {
      return this._filename;
    },
    get isRangeSupported() {
      return this._stream._isRangeSupported;
    },
    get isStreamingSupported() {
      return this._stream._isStreamingSupported;
    },
    get contentLength() {
      return this._stream._contentLength;
    },
    read: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var chunk, requestCapability;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._queuedChunks.length > 0)) {
                  _context.next = 3;
                  break;
                }

                chunk = this._queuedChunks.shift();
                return _context.abrupt('return', {
                  value: chunk,
                  done: false
                });

              case 3:
                if (!this._done) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', {
                  value: undefined,
                  done: true
                });

              case 5:
                requestCapability = (0, _util.createPromiseCapability)();

                this._requests.push(requestCapability);
                return _context.abrupt('return', requestCapability.promise);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _ref.apply(this, arguments);
      }

      return read;
    }(),

    cancel: function PDFDataTransportStreamReader_cancel(reason) {
      this._done = true;
      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });
      this._requests = [];
    }
  };
  function PDFDataTransportStreamRangeReader(stream, begin, end) {
    this._stream = stream;
    this._begin = begin;
    this._end = end;
    this._queuedChunk = null;
    this._requests = [];
    this._done = false;
    this.onProgress = null;
  }
  PDFDataTransportStreamRangeReader.prototype = {
    _enqueue: function PDFDataTransportStreamRangeReader_enqueue(chunk) {
      if (this._done) {
        return;
      }
      if (this._requests.length === 0) {
        this._queuedChunk = chunk;
      } else {
        var requestsCapability = this._requests.shift();
        requestsCapability.resolve({
          value: chunk,
          done: false
        });
        this._requests.forEach(function (requestCapability) {
          requestCapability.resolve({
            value: undefined,
            done: true
          });
        });
        this._requests = [];
      }
      this._done = true;
      this._stream._removeRangeReader(this);
    },
    get isStreamingSupported() {
      return false;
    },
    read: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var chunk, requestCapability;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._queuedChunk) {
                  _context2.next = 4;
                  break;
                }

                chunk = this._queuedChunk;

                this._queuedChunk = null;
                return _context2.abrupt('return', {
                  value: chunk,
                  done: false
                });

              case 4:
                if (!this._done) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return', {
                  value: undefined,
                  done: true
                });

              case 6:
                requestCapability = (0, _util.createPromiseCapability)();

                this._requests.push(requestCapability);
                return _context2.abrupt('return', requestCapability.promise);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read() {
        return _ref2.apply(this, arguments);
      }

      return read;
    }(),

    cancel: function PDFDataTransportStreamRangeReader_cancel(reason) {
      this._done = true;
      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });
      this._requests = [];
      this._stream._removeRangeReader(this);
    }
  };
  return PDFDataTransportStream;
}();
exports.PDFDataTransportStream = PDFDataTransportStream;

/***/ }),
/* 144 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebGLContext = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebGLContext = function () {
  function WebGLContext(_ref) {
    var _ref$enable = _ref.enable,
        enable = _ref$enable === undefined ? false : _ref$enable;

    _classCallCheck(this, WebGLContext);

    this._enabled = enable === true;
  }

  _createClass(WebGLContext, [{
    key: 'composeSMask',
    value: function composeSMask(_ref2) {
      var layer = _ref2.layer,
          mask = _ref2.mask,
          properties = _ref2.properties;

      return WebGLUtils.composeSMask(layer, mask, properties);
    }
  }, {
    key: 'drawFigures',
    value: function drawFigures(_ref3) {
      var width = _ref3.width,
          height = _ref3.height,
          backgroundColor = _ref3.backgroundColor,
          figures = _ref3.figures,
          context = _ref3.context;

      return WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
    }
  }, {
    key: 'clear',
    value: function clear() {
      WebGLUtils.cleanup();
    }
  }, {
    key: 'isEnabled',
    get: function get() {
      var enabled = this._enabled;
      if (enabled) {
        enabled = WebGLUtils.tryInitGL();
      }
      return (0, _util.shadow)(this, 'isEnabled', enabled);
    }
  }]);

  return WebGLContext;
}();

var WebGLUtils = function WebGLUtilsClosure() {
  function loadShader(gl, code, shaderType) {
    var shader = gl.createShader(shaderType);
    gl.shaderSource(shader, code);
    gl.compileShader(shader);
    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    if (!compiled) {
      var errorMsg = gl.getShaderInfoLog(shader);
      throw new Error('Error during shader compilation: ' + errorMsg);
    }
    return shader;
  }
  function createVertexShader(gl, code) {
    return loadShader(gl, code, gl.VERTEX_SHADER);
  }
  function createFragmentShader(gl, code) {
    return loadShader(gl, code, gl.FRAGMENT_SHADER);
  }
  function createProgram(gl, shaders) {
    var program = gl.createProgram();
    for (var i = 0, ii = shaders.length; i < ii; ++i) {
      gl.attachShader(program, shaders[i]);
    }
    gl.linkProgram(program);
    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
    if (!linked) {
      var errorMsg = gl.getProgramInfoLog(program);
      throw new Error('Error during program linking: ' + errorMsg);
    }
    return program;
  }
  function createTexture(gl, image, textureId) {
    gl.activeTexture(textureId);
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
    return texture;
  }
  var currentGL, currentCanvas;
  function generateGL() {
    if (currentGL) {
      return;
    }
    currentCanvas = document.createElement('canvas');
    currentGL = currentCanvas.getContext('webgl', { premultipliedalpha: false });
  }
  var smaskVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec2 a_texCoord;                                    \
                                                                \
  uniform vec2 u_resolution;                                    \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_texCoord = a_texCoord;                                    \
  }                                                             ';
  var smaskFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  uniform vec4 u_backdrop;                                      \
  uniform int u_subtype;                                        \
  uniform sampler2D u_image;                                    \
  uniform sampler2D u_mask;                                     \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec4 imageColor = texture2D(u_image, v_texCoord);           \
    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
    if (u_backdrop.a > 0.0) {                                   \
      maskColor.rgb = maskColor.rgb * maskColor.a +             \
                      u_backdrop.rgb * (1.0 - maskColor.a);     \
    }                                                           \
    float lum;                                                  \
    if (u_subtype == 0) {                                       \
      lum = maskColor.a;                                        \
    } else {                                                    \
      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
            maskColor.b * 0.11;                                 \
    }                                                           \
    imageColor.a *= lum;                                        \
    imageColor.rgb *= imageColor.a;                             \
    gl_FragColor = imageColor;                                  \
  }                                                             ';
  var smaskCache = null;
  function initSmaskGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
    var texCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(texCoordLocation);
    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
    gl.uniform1i(texLayerLocation, 0);
    gl.uniform1i(texMaskLocation, 1);
    smaskCache = cache;
  }
  function composeSMask(layer, mask, properties) {
    var width = layer.width,
        height = layer.height;
    if (!smaskCache) {
      initSmaskGL();
    }
    var cache = smaskCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    if (properties.backdrop) {
      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
    } else {
      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
    }
    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
    var texture = createTexture(gl, layer, gl.TEXTURE0);
    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    gl.clearColor(0, 0, 0, 0);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    gl.flush();
    gl.deleteTexture(texture);
    gl.deleteTexture(maskTexture);
    gl.deleteBuffer(buffer);
    return canvas;
  }
  var figuresVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec3 a_color;                                       \
                                                                \
  uniform vec2 u_resolution;                                    \
  uniform vec2 u_scale;                                         \
  uniform vec2 u_offset;                                        \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    vec2 position = (a_position + u_offset) * u_scale;          \
    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_color = vec4(a_color / 255.0, 1.0);                       \
  }                                                             ';
  var figuresFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    gl_FragColor = v_color;                                     \
  }                                                             ';
  var figuresCache = null;
  function initFiguresGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
    figuresCache = cache;
  }
  function drawFigures(width, height, backgroundColor, figures, context) {
    if (!figuresCache) {
      initFiguresGL();
    }
    var cache = figuresCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    var count = 0;
    var i, ii, rows;
    for (i = 0, ii = figures.length; i < ii; i++) {
      switch (figures[i].type) {
        case 'lattice':
          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
          break;
        case 'triangles':
          count += figures[i].coords.length;
          break;
      }
    }
    var coords = new Float32Array(count * 2);
    var colors = new Uint8Array(count * 3);
    var coordsMap = context.coords,
        colorsMap = context.colors;
    var pIndex = 0,
        cIndex = 0;
    for (i = 0, ii = figures.length; i < ii; i++) {
      var figure = figures[i],
          ps = figure.coords,
          cs = figure.colors;
      switch (figure.type) {
        case 'lattice':
          var cols = figure.verticesPerRow;
          rows = ps.length / cols | 0;
          for (var row = 1; row < rows; row++) {
            var offset = row * cols + 1;
            for (var col = 1; col < cols; col++, offset++) {
              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
              coords[pIndex + 6] = coords[pIndex + 2];
              coords[pIndex + 7] = coords[pIndex + 3];
              coords[pIndex + 8] = coords[pIndex + 4];
              coords[pIndex + 9] = coords[pIndex + 5];
              coords[pIndex + 10] = coordsMap[ps[offset]];
              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
              colors[cIndex + 9] = colors[cIndex + 3];
              colors[cIndex + 10] = colors[cIndex + 4];
              colors[cIndex + 11] = colors[cIndex + 5];
              colors[cIndex + 12] = colors[cIndex + 6];
              colors[cIndex + 13] = colors[cIndex + 7];
              colors[cIndex + 14] = colors[cIndex + 8];
              colors[cIndex + 15] = colorsMap[cs[offset]];
              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
              pIndex += 12;
              cIndex += 18;
            }
          }
          break;
        case 'triangles':
          for (var j = 0, jj = ps.length; j < jj; j++) {
            coords[pIndex] = coordsMap[ps[j]];
            coords[pIndex + 1] = coordsMap[ps[j] + 1];
            colors[cIndex] = colorsMap[cs[j]];
            colors[cIndex + 1] = colorsMap[cs[j] + 1];
            colors[cIndex + 2] = colorsMap[cs[j] + 2];
            pIndex += 2;
            cIndex += 3;
          }
          break;
      }
    }
    if (backgroundColor) {
      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
    } else {
      gl.clearColor(0, 0, 0, 0);
    }
    gl.clear(gl.COLOR_BUFFER_BIT);
    var coordsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    var colorsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.colorLocation);
    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
    gl.drawArrays(gl.TRIANGLES, 0, count);
    gl.flush();
    gl.deleteBuffer(coordsBuffer);
    gl.deleteBuffer(colorsBuffer);
    return canvas;
  }
  return {
    tryInitGL: function tryInitGL() {
      try {
        generateGL();
        return !!currentGL;
      } catch (ex) {}
      return false;
    },

    composeSMask: composeSMask,
    drawFigures: drawFigures,
    cleanup: function cleanup() {
      if (smaskCache && smaskCache.canvas) {
        smaskCache.canvas.width = 0;
        smaskCache.canvas.height = 0;
      }
      if (figuresCache && figuresCache.canvas) {
        figuresCache.canvas.width = 0;
        figuresCache.canvas.height = 0;
      }
      smaskCache = null;
      figuresCache = null;
    }
  };
}();
exports.WebGLContext = WebGLContext;

/***/ }),
/* 145 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTextLayer = undefined;

var _util = __w_pdfjs_require__(1);

var _global_scope = __w_pdfjs_require__(3);

var _global_scope2 = _interopRequireDefault(_global_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderTextLayer = function renderTextLayerClosure() {
  var MAX_TEXT_DIVS_TO_RENDER = 100000;
  var NonWhitespaceRegexp = /\S/;
  function isAllWhitespace(str) {
    return !NonWhitespaceRegexp.test(str);
  }
  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
  function appendText(task, geom, styles) {
    var textDiv = document.createElement('div');
    var textDivProperties = {
      style: null,
      angle: 0,
      canvasWidth: 0,
      isWhitespace: false,
      originalTransform: null,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      scale: 1
    };
    task._textDivs.push(textDiv);
    if (isAllWhitespace(geom.str)) {
      textDivProperties.isWhitespace = true;
      task._textDivProperties.set(textDiv, textDivProperties);
      return;
    }
    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
    var angle = Math.atan2(tx[1], tx[0]);
    var style = styles[geom.fontName];
    if (style.vertical) {
      angle += Math.PI / 2;
    }
    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
    var fontAscent = fontHeight;
    if (style.ascent) {
      fontAscent = style.ascent * fontAscent;
    } else if (style.descent) {
      fontAscent = (1 + style.descent) * fontAscent;
    }
    var left;
    var top;
    if (angle === 0) {
      left = tx[4];
      top = tx[5] - fontAscent;
    } else {
      left = tx[4] + fontAscent * Math.sin(angle);
      top = tx[5] - fontAscent * Math.cos(angle);
    }
    styleBuf[1] = left;
    styleBuf[3] = top;
    styleBuf[5] = fontHeight;
    styleBuf[7] = style.fontFamily;
    textDivProperties.style = styleBuf.join('');
    textDiv.setAttribute('style', textDivProperties.style);
    textDiv.textContent = geom.str;
    if (task._fontInspectorEnabled) {
      textDiv.dataset.fontName = geom.fontName;
    }
    if (angle !== 0) {
      textDivProperties.angle = angle * (180 / Math.PI);
    }
    if (geom.str.length > 1) {
      if (style.vertical) {
        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
      } else {
        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
      }
    }
    task._textDivProperties.set(textDiv, textDivProperties);
    if (task._textContentStream) {
      task._layoutText(textDiv);
    }
    if (task._enhanceTextSelection) {
      var angleCos = 1,
          angleSin = 0;
      if (angle !== 0) {
        angleCos = Math.cos(angle);
        angleSin = Math.sin(angle);
      }
      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
      var divHeight = fontHeight;
      var m, b;
      if (angle !== 0) {
        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
      } else {
        b = [left, top, left + divWidth, top + divHeight];
      }
      task._bounds.push({
        left: b[0],
        top: b[1],
        right: b[2],
        bottom: b[3],
        div: textDiv,
        size: [divWidth, divHeight],
        m: m
      });
    }
  }
  function render(task) {
    if (task._canceled) {
      return;
    }
    var textDivs = task._textDivs;
    var capability = task._capability;
    var textDivsLength = textDivs.length;
    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
      task._renderingDone = true;
      capability.resolve();
      return;
    }
    if (!task._textContentStream) {
      for (var i = 0; i < textDivsLength; i++) {
        task._layoutText(textDivs[i]);
      }
    }
    task._renderingDone = true;
    capability.resolve();
  }
  function expand(task) {
    var bounds = task._bounds;
    var viewport = task._viewport;
    var expanded = expandBounds(viewport.width, viewport.height, bounds);
    for (var i = 0; i < expanded.length; i++) {
      var div = bounds[i].div;
      var divProperties = task._textDivProperties.get(div);
      if (divProperties.angle === 0) {
        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
        divProperties.paddingTop = bounds[i].top - expanded[i].top;
        divProperties.paddingRight = expanded[i].right - bounds[i].right;
        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
        task._textDivProperties.set(div, divProperties);
        continue;
      }
      var e = expanded[i],
          b = bounds[i];
      var m = b.m,
          c = m[0],
          s = m[1];
      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
      var ts = new Float64Array(64);
      points.forEach(function (p, i) {
        var t = _util.Util.applyTransform(p, m);
        ts[i + 0] = c && (e.left - t[0]) / c;
        ts[i + 4] = s && (e.top - t[1]) / s;
        ts[i + 8] = c && (e.right - t[0]) / c;
        ts[i + 12] = s && (e.bottom - t[1]) / s;
        ts[i + 16] = s && (e.left - t[0]) / -s;
        ts[i + 20] = c && (e.top - t[1]) / c;
        ts[i + 24] = s && (e.right - t[0]) / -s;
        ts[i + 28] = c && (e.bottom - t[1]) / c;
        ts[i + 32] = c && (e.left - t[0]) / -c;
        ts[i + 36] = s && (e.top - t[1]) / -s;
        ts[i + 40] = c && (e.right - t[0]) / -c;
        ts[i + 44] = s && (e.bottom - t[1]) / -s;
        ts[i + 48] = s && (e.left - t[0]) / s;
        ts[i + 52] = c && (e.top - t[1]) / -c;
        ts[i + 56] = s && (e.right - t[0]) / s;
        ts[i + 60] = c && (e.bottom - t[1]) / -c;
      });
      var findPositiveMin = function findPositiveMin(ts, offset, count) {
        var result = 0;
        for (var i = 0; i < count; i++) {
          var t = ts[offset++];
          if (t > 0) {
            result = result ? Math.min(t, result) : t;
          }
        }
        return result;
      };
      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
      task._textDivProperties.set(div, divProperties);
    }
  }
  function expandBounds(width, height, boxes) {
    var bounds = boxes.map(function (box, i) {
      return {
        x1: box.left,
        y1: box.top,
        x2: box.right,
        y2: box.bottom,
        index: i,
        x1New: undefined,
        x2New: undefined
      };
    });
    expandBoundsLTR(width, bounds);
    var expanded = new Array(boxes.length);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i] = {
        left: b.x1New,
        top: 0,
        right: b.x2New,
        bottom: 0
      };
    });
    boxes.map(function (box, i) {
      var e = expanded[i],
          b = bounds[i];
      b.x1 = box.top;
      b.y1 = width - e.right;
      b.x2 = box.bottom;
      b.y2 = width - e.left;
      b.index = i;
      b.x1New = undefined;
      b.x2New = undefined;
    });
    expandBoundsLTR(height, bounds);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i].top = b.x1New;
      expanded[i].bottom = b.x2New;
    });
    return expanded;
  }
  function expandBoundsLTR(width, bounds) {
    bounds.sort(function (a, b) {
      return a.x1 - b.x1 || a.index - b.index;
    });
    var fakeBoundary = {
      x1: -Infinity,
      y1: -Infinity,
      x2: 0,
      y2: Infinity,
      index: -1,
      x1New: 0,
      x2New: 0
    };
    var horizon = [{
      start: -Infinity,
      end: Infinity,
      boundary: fakeBoundary
    }];
    bounds.forEach(function (boundary) {
      var i = 0;
      while (i < horizon.length && horizon[i].end <= boundary.y1) {
        i++;
      }
      var j = horizon.length - 1;
      while (j >= 0 && horizon[j].start >= boundary.y2) {
        j--;
      }
      var horizonPart, affectedBoundary;
      var q,
          k,
          maxXNew = -Infinity;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var xNew;
        if (affectedBoundary.x2 > boundary.x1) {
          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
        } else if (affectedBoundary.x2New === undefined) {
          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
        } else {
          xNew = affectedBoundary.x2New;
        }
        if (xNew > maxXNew) {
          maxXNew = xNew;
        }
      }
      boundary.x1New = maxXNew;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        if (affectedBoundary.x2New === undefined) {
          if (affectedBoundary.x2 > boundary.x1) {
            if (affectedBoundary.index > boundary.index) {
              affectedBoundary.x2New = affectedBoundary.x2;
            }
          } else {
            affectedBoundary.x2New = maxXNew;
          }
        } else if (affectedBoundary.x2New > maxXNew) {
          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
        }
      }
      var changedHorizon = [],
          lastBoundary = null;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
        if (lastBoundary === useBoundary) {
          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
        } else {
          changedHorizon.push({
            start: horizonPart.start,
            end: horizonPart.end,
            boundary: useBoundary
          });
          lastBoundary = useBoundary;
        }
      }
      if (horizon[i].start < boundary.y1) {
        changedHorizon[0].start = boundary.y1;
        changedHorizon.unshift({
          start: horizon[i].start,
          end: boundary.y1,
          boundary: horizon[i].boundary
        });
      }
      if (boundary.y2 < horizon[j].end) {
        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
        changedHorizon.push({
          start: boundary.y2,
          end: horizon[j].end,
          boundary: horizon[j].boundary
        });
      }
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        if (affectedBoundary.x2New !== undefined) {
          continue;
        }
        var used = false;
        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
          used = horizon[k].boundary === affectedBoundary;
        }
        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
          used = horizon[k].boundary === affectedBoundary;
        }
        for (k = 0; !used && k < changedHorizon.length; k++) {
          used = changedHorizon[k].boundary === affectedBoundary;
        }
        if (!used) {
          affectedBoundary.x2New = maxXNew;
        }
      }
      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
    });
    horizon.forEach(function (horizonPart) {
      var affectedBoundary = horizonPart.boundary;
      if (affectedBoundary.x2New === undefined) {
        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
      }
    });
  }
  function TextLayerRenderTask(_ref) {
    var textContent = _ref.textContent,
        textContentStream = _ref.textContentStream,
        container = _ref.container,
        viewport = _ref.viewport,
        textDivs = _ref.textDivs,
        textContentItemsStr = _ref.textContentItemsStr,
        enhanceTextSelection = _ref.enhanceTextSelection;

    this._textContent = textContent;
    this._textContentStream = textContentStream;
    this._container = container;
    this._viewport = viewport;
    this._textDivs = textDivs || [];
    this._textContentItemsStr = textContentItemsStr || [];
    this._enhanceTextSelection = !!enhanceTextSelection;
    this._fontInspectorEnabled = !!(_global_scope2.default.FontInspector && _global_scope2.default.FontInspector.enabled);
    this._reader = null;
    this._layoutTextLastFontSize = null;
    this._layoutTextLastFontFamily = null;
    this._layoutTextCtx = null;
    this._textDivProperties = new WeakMap();
    this._renderingDone = false;
    this._canceled = false;
    this._capability = (0, _util.createPromiseCapability)();
    this._renderTimer = null;
    this._bounds = [];
  }
  TextLayerRenderTask.prototype = {
    get promise() {
      return this._capability.promise;
    },
    cancel: function TextLayer_cancel() {
      if (this._reader) {
        this._reader.cancel(new _util.AbortException('text layer task cancelled'));
        this._reader = null;
      }
      this._canceled = true;
      if (this._renderTimer !== null) {
        clearTimeout(this._renderTimer);
        this._renderTimer = null;
      }
      this._capability.reject('canceled');
    },
    _processItems: function _processItems(items, styleCache) {
      for (var i = 0, len = items.length; i < len; i++) {
        this._textContentItemsStr.push(items[i].str);
        appendText(this, items[i], styleCache);
      }
    },
    _layoutText: function _layoutText(textDiv) {
      var textLayerFrag = this._container;
      var textDivProperties = this._textDivProperties.get(textDiv);
      if (textDivProperties.isWhitespace) {
        return;
      }
      var fontSize = textDiv.style.fontSize;
      var fontFamily = textDiv.style.fontFamily;
      if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
        this._layoutTextCtx.font = fontSize + ' ' + fontFamily;
        this._layoutTextLastFontSize = fontSize;
        this._layoutTextLastFontFamily = fontFamily;
      }
      var width = this._layoutTextCtx.measureText(textDiv.textContent).width;
      var transform = '';
      if (textDivProperties.canvasWidth !== 0 && width > 0) {
        textDivProperties.scale = textDivProperties.canvasWidth / width;
        transform = 'scaleX(' + textDivProperties.scale + ')';
      }
      if (textDivProperties.angle !== 0) {
        transform = 'rotate(' + textDivProperties.angle + 'deg) ' + transform;
      }
      if (transform !== '') {
        textDivProperties.originalTransform = transform;
        textDiv.style.transform = transform;
      }
      this._textDivProperties.set(textDiv, textDivProperties);
      textLayerFrag.appendChild(textDiv);
    },

    _render: function TextLayer_render(timeout) {
      var _this = this;

      var capability = (0, _util.createPromiseCapability)();
      var styleCache = Object.create(null);
      var canvas = document.createElement('canvas');
      canvas.mozOpaque = true;
      this._layoutTextCtx = canvas.getContext('2d', { alpha: false });
      if (this._textContent) {
        var textItems = this._textContent.items;
        var textStyles = this._textContent.styles;
        this._processItems(textItems, textStyles);
        capability.resolve();
      } else if (this._textContentStream) {
        var pump = function pump() {
          _this._reader.read().then(function (_ref2) {
            var value = _ref2.value,
                done = _ref2.done;

            if (done) {
              capability.resolve();
              return;
            }
            Object.assign(styleCache, value.styles);
            _this._processItems(value.items, styleCache);
            pump();
          }, capability.reject);
        };
        this._reader = this._textContentStream.getReader();
        pump();
      } else {
        throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.');
      }
      capability.promise.then(function () {
        styleCache = null;
        if (!timeout) {
          render(_this);
        } else {
          _this._renderTimer = setTimeout(function () {
            render(_this);
            _this._renderTimer = null;
          }, timeout);
        }
      }, this._capability.reject);
    },
    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
      if (!this._enhanceTextSelection || !this._renderingDone) {
        return;
      }
      if (this._bounds !== null) {
        expand(this);
        this._bounds = null;
      }
      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
        var div = this._textDivs[i];
        var divProperties = this._textDivProperties.get(div);
        if (divProperties.isWhitespace) {
          continue;
        }
        if (expandDivs) {
          var transform = '',
              padding = '';
          if (divProperties.scale !== 1) {
            transform = 'scaleX(' + divProperties.scale + ')';
          }
          if (divProperties.angle !== 0) {
            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
          }
          if (divProperties.paddingLeft !== 0) {
            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
          }
          if (divProperties.paddingTop !== 0) {
            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
          }
          if (divProperties.paddingRight !== 0) {
            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
          }
          if (divProperties.paddingBottom !== 0) {
            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
          }
          if (padding !== '') {
            div.setAttribute('style', divProperties.style + padding);
          }
          if (transform !== '') {
            div.style.transform = transform;
          }
        } else {
          div.style.padding = 0;
          div.style.transform = divProperties.originalTransform || '';
        }
      }
    }
  };
  function renderTextLayer(renderParameters) {
    var task = new TextLayerRenderTask({
      textContent: renderParameters.textContent,
      textContentStream: renderParameters.textContentStream,
      container: renderParameters.container,
      viewport: renderParameters.viewport,
      textDivs: renderParameters.textDivs,
      textContentItemsStr: renderParameters.textContentItemsStr,
      enhanceTextSelection: renderParameters.enhanceTextSelection
    });
    task._render(renderParameters.timeout);
    return task;
  }
  return renderTextLayer;
}();
exports.renderTextLayer = renderTextLayer;

/***/ }),
/* 146 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnotationLayer = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom_utils = __w_pdfjs_require__(130);

var _util = __w_pdfjs_require__(1);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnnotationElementFactory = function () {
  function AnnotationElementFactory() {
    _classCallCheck(this, AnnotationElementFactory);
  }

  _createClass(AnnotationElementFactory, null, [{
    key: 'create',
    value: function create(parameters) {
      var subtype = parameters.data.annotationType;
      switch (subtype) {
        case _util.AnnotationType.LINK:
          return new LinkAnnotationElement(parameters);
        case _util.AnnotationType.TEXT:
          return new TextAnnotationElement(parameters);
        case _util.AnnotationType.WIDGET:
          var fieldType = parameters.data.fieldType;
          switch (fieldType) {
            case 'Tx':
              return new TextWidgetAnnotationElement(parameters);
            case 'Btn':
              if (parameters.data.radioButton) {
                return new RadioButtonWidgetAnnotationElement(parameters);
              } else if (parameters.data.checkBox) {
                return new CheckboxWidgetAnnotationElement(parameters);
              }
              return new PushButtonWidgetAnnotationElement(parameters);
            case 'Ch':
              return new ChoiceWidgetAnnotationElement(parameters);
          }
          return new WidgetAnnotationElement(parameters);
        case _util.AnnotationType.POPUP:
          return new PopupAnnotationElement(parameters);
        case _util.AnnotationType.LINE:
          return new LineAnnotationElement(parameters);
        case _util.AnnotationType.SQUARE:
          return new SquareAnnotationElement(parameters);
        case _util.AnnotationType.CIRCLE:
          return new CircleAnnotationElement(parameters);
        case _util.AnnotationType.POLYLINE:
          return new PolylineAnnotationElement(parameters);
        case _util.AnnotationType.INK:
          return new InkAnnotationElement(parameters);
        case _util.AnnotationType.POLYGON:
          return new PolygonAnnotationElement(parameters);
        case _util.AnnotationType.HIGHLIGHT:
          return new HighlightAnnotationElement(parameters);
        case _util.AnnotationType.UNDERLINE:
          return new UnderlineAnnotationElement(parameters);
        case _util.AnnotationType.SQUIGGLY:
          return new SquigglyAnnotationElement(parameters);
        case _util.AnnotationType.STRIKEOUT:
          return new StrikeOutAnnotationElement(parameters);
        case _util.AnnotationType.STAMP:
          return new StampAnnotationElement(parameters);
        case _util.AnnotationType.FILEATTACHMENT:
          return new FileAttachmentAnnotationElement(parameters);
        default:
          return new AnnotationElement(parameters);
      }
    }
  }]);

  return AnnotationElementFactory;
}();

var AnnotationElement = function () {
  function AnnotationElement(parameters) {
    var isRenderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var ignoreBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, AnnotationElement);

    this.isRenderable = isRenderable;
    this.data = parameters.data;
    this.layer = parameters.layer;
    this.page = parameters.page;
    this.viewport = parameters.viewport;
    this.linkService = parameters.linkService;
    this.downloadManager = parameters.downloadManager;
    this.imageResourcesPath = parameters.imageResourcesPath;
    this.renderInteractiveForms = parameters.renderInteractiveForms;
    this.svgFactory = parameters.svgFactory;
    if (isRenderable) {
      this.container = this._createContainer(ignoreBorder);
    }
  }

  _createClass(AnnotationElement, [{
    key: '_createContainer',
    value: function _createContainer() {
      var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var data = this.data,
          page = this.page,
          viewport = this.viewport;
      var container = document.createElement('section');
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      container.setAttribute('data-annotation-id', data.id);
      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
      container.style.transform = 'matrix(' + viewport.transform.join(',') + ')';
      container.style.transformOrigin = -rect[0] + 'px ' + -rect[1] + 'px';
      if (!ignoreBorder && data.borderStyle.width > 0) {
        container.style.borderWidth = data.borderStyle.width + 'px';
        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
          width = width - 2 * data.borderStyle.width;
          height = height - 2 * data.borderStyle.width;
        }
        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
        var verticalRadius = data.borderStyle.verticalCornerRadius;
        if (horizontalRadius > 0 || verticalRadius > 0) {
          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
          container.style.borderRadius = radius;
        }
        switch (data.borderStyle.style) {
          case _util.AnnotationBorderStyleType.SOLID:
            container.style.borderStyle = 'solid';
            break;
          case _util.AnnotationBorderStyleType.DASHED:
            container.style.borderStyle = 'dashed';
            break;
          case _util.AnnotationBorderStyleType.BEVELED:
            (0, _util.warn)('Unimplemented border style: beveled');
            break;
          case _util.AnnotationBorderStyleType.INSET:
            (0, _util.warn)('Unimplemented border style: inset');
            break;
          case _util.AnnotationBorderStyleType.UNDERLINE:
            container.style.borderBottomStyle = 'solid';
            break;
          default:
            break;
        }
        if (data.color) {
          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
        } else {
          container.style.borderWidth = 0;
        }
      }
      container.style.left = rect[0] + 'px';
      container.style.top = rect[1] + 'px';
      container.style.width = width + 'px';
      container.style.height = height + 'px';
      return container;
    }
  }, {
    key: '_createPopup',
    value: function _createPopup(container, trigger, data) {
      if (!trigger) {
        trigger = document.createElement('div');
        trigger.style.height = container.style.height;
        trigger.style.width = container.style.width;
        container.appendChild(trigger);
      }
      var popupElement = new PopupElement({
        container: container,
        trigger: trigger,
        color: data.color,
        title: data.title,
        contents: data.contents,
        hideWrapper: true
      });
      var popup = popupElement.render();
      popup.style.left = container.style.width;
      container.appendChild(popup);
    }
  }, {
    key: 'render',
    value: function render() {
      (0, _util.unreachable)('Abstract method `AnnotationElement.render` called');
    }
  }]);

  return AnnotationElement;
}();

var LinkAnnotationElement = function (_AnnotationElement) {
  _inherits(LinkAnnotationElement, _AnnotationElement);

  function LinkAnnotationElement(parameters) {
    _classCallCheck(this, LinkAnnotationElement);

    var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action);
    return _possibleConstructorReturn(this, (LinkAnnotationElement.__proto__ || Object.getPrototypeOf(LinkAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(LinkAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'linkAnnotation';
      var data = this.data,
          linkService = this.linkService;

      var link = document.createElement('a');
      (0, _dom_utils.addLinkAttributes)(link, {
        url: data.url,
        target: data.newWindow ? _dom_utils.LinkTarget.BLANK : linkService.externalLinkTarget,
        rel: linkService.externalLinkRel
      });
      if (!data.url) {
        if (data.action) {
          this._bindNamedAction(link, data.action);
        } else {
          this._bindLink(link, data.dest);
        }
      }
      this.container.appendChild(link);
      return this.container;
    }
  }, {
    key: '_bindLink',
    value: function _bindLink(link, destination) {
      var _this2 = this;

      link.href = this.linkService.getDestinationHash(destination);
      link.onclick = function () {
        if (destination) {
          _this2.linkService.navigateTo(destination);
        }
        return false;
      };
      if (destination) {
        link.className = 'internalLink';
      }
    }
  }, {
    key: '_bindNamedAction',
    value: function _bindNamedAction(link, action) {
      var _this3 = this;

      link.href = this.linkService.getAnchorUrl('');
      link.onclick = function () {
        _this3.linkService.executeNamedAction(action);
        return false;
      };
      link.className = 'internalLink';
    }
  }]);

  return LinkAnnotationElement;
}(AnnotationElement);

var TextAnnotationElement = function (_AnnotationElement2) {
  _inherits(TextAnnotationElement, _AnnotationElement2);

  function TextAnnotationElement(parameters) {
    _classCallCheck(this, TextAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (TextAnnotationElement.__proto__ || Object.getPrototypeOf(TextAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(TextAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'textAnnotation';
      var image = document.createElement('img');
      image.style.height = this.container.style.height;
      image.style.width = this.container.style.width;
      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
      image.alt = '[{{type}} Annotation]';
      image.dataset.l10nId = 'text_annotation_type';
      image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
      if (!this.data.hasPopup) {
        this._createPopup(this.container, image, this.data);
      }
      this.container.appendChild(image);
      return this.container;
    }
  }]);

  return TextAnnotationElement;
}(AnnotationElement);

var WidgetAnnotationElement = function (_AnnotationElement3) {
  _inherits(WidgetAnnotationElement, _AnnotationElement3);

  function WidgetAnnotationElement() {
    _classCallCheck(this, WidgetAnnotationElement);

    return _possibleConstructorReturn(this, (WidgetAnnotationElement.__proto__ || Object.getPrototypeOf(WidgetAnnotationElement)).apply(this, arguments));
  }

  _createClass(WidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      return this.container;
    }
  }]);

  return WidgetAnnotationElement;
}(AnnotationElement);

var TextWidgetAnnotationElement = function (_WidgetAnnotationElem) {
  _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);

  function TextWidgetAnnotationElement(parameters) {
    _classCallCheck(this, TextWidgetAnnotationElement);

    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
    return _possibleConstructorReturn(this, (TextWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(TextWidgetAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(TextWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      var TEXT_ALIGNMENT = ['left', 'center', 'right'];
      this.container.className = 'textWidgetAnnotation';
      var element = null;
      if (this.renderInteractiveForms) {
        if (this.data.multiLine) {
          element = document.createElement('textarea');
          element.textContent = this.data.fieldValue;
        } else {
          element = document.createElement('input');
          element.type = 'text';
          element.setAttribute('value', this.data.fieldValue);
        }
        element.disabled = this.data.readOnly;
        if (this.data.maxLen !== null) {
          element.maxLength = this.data.maxLen;
        }
        if (this.data.comb) {
          var fieldWidth = this.data.rect[2] - this.data.rect[0];
          var combWidth = fieldWidth / this.data.maxLen;
          element.classList.add('comb');
          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
        }
      } else {
        element = document.createElement('div');
        element.textContent = this.data.fieldValue;
        element.style.verticalAlign = 'middle';
        element.style.display = 'table-cell';
        var font = null;
        if (this.data.fontRefName) {
          font = this.page.commonObjs.getData(this.data.fontRefName);
        }
        this._setTextStyle(element, font);
      }
      if (this.data.textAlignment !== null) {
        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
      }
      this.container.appendChild(element);
      return this.container;
    }
  }, {
    key: '_setTextStyle',
    value: function _setTextStyle(element, font) {
      var style = element.style;
      style.fontSize = this.data.fontSize + 'px';
      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';
      if (!font) {
        return;
      }
      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
      style.fontStyle = font.italic ? 'italic' : 'normal';
      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
      style.fontFamily = fontFamily + fallbackName;
    }
  }]);

  return TextWidgetAnnotationElement;
}(WidgetAnnotationElement);

var CheckboxWidgetAnnotationElement = function (_WidgetAnnotationElem2) {
  _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);

  function CheckboxWidgetAnnotationElement(parameters) {
    _classCallCheck(this, CheckboxWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (CheckboxWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(CheckboxWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(CheckboxWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'buttonWidgetAnnotation checkBox';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'checkbox';
      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
        element.setAttribute('checked', true);
      }
      this.container.appendChild(element);
      return this.container;
    }
  }]);

  return CheckboxWidgetAnnotationElement;
}(WidgetAnnotationElement);

var RadioButtonWidgetAnnotationElement = function (_WidgetAnnotationElem3) {
  _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);

  function RadioButtonWidgetAnnotationElement(parameters) {
    _classCallCheck(this, RadioButtonWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (RadioButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(RadioButtonWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(RadioButtonWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'buttonWidgetAnnotation radioButton';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'radio';
      element.name = this.data.fieldName;
      if (this.data.fieldValue === this.data.buttonValue) {
        element.setAttribute('checked', true);
      }
      this.container.appendChild(element);
      return this.container;
    }
  }]);

  return RadioButtonWidgetAnnotationElement;
}(WidgetAnnotationElement);

var PushButtonWidgetAnnotationElement = function (_LinkAnnotationElemen) {
  _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen);

  function PushButtonWidgetAnnotationElement() {
    _classCallCheck(this, PushButtonWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (PushButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(PushButtonWidgetAnnotationElement)).apply(this, arguments));
  }

  _createClass(PushButtonWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      var container = _get(PushButtonWidgetAnnotationElement.prototype.__proto__ || Object.getPrototypeOf(PushButtonWidgetAnnotationElement.prototype), 'render', this).call(this);
      container.className = 'buttonWidgetAnnotation pushButton';
      return container;
    }
  }]);

  return PushButtonWidgetAnnotationElement;
}(LinkAnnotationElement);

var ChoiceWidgetAnnotationElement = function (_WidgetAnnotationElem4) {
  _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);

  function ChoiceWidgetAnnotationElement(parameters) {
    _classCallCheck(this, ChoiceWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (ChoiceWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(ChoiceWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(ChoiceWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'choiceWidgetAnnotation';
      var selectElement = document.createElement('select');
      selectElement.disabled = this.data.readOnly;
      if (!this.data.combo) {
        selectElement.size = this.data.options.length;
        if (this.data.multiSelect) {
          selectElement.multiple = true;
        }
      }
      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
        var option = this.data.options[i];
        var optionElement = document.createElement('option');
        optionElement.textContent = option.displayValue;
        optionElement.value = option.exportValue;
        if (this.data.fieldValue.includes(option.displayValue)) {
          optionElement.setAttribute('selected', true);
        }
        selectElement.appendChild(optionElement);
      }
      this.container.appendChild(selectElement);
      return this.container;
    }
  }]);

  return ChoiceWidgetAnnotationElement;
}(WidgetAnnotationElement);

var PopupAnnotationElement = function (_AnnotationElement4) {
  _inherits(PopupAnnotationElement, _AnnotationElement4);

  function PopupAnnotationElement(parameters) {
    _classCallCheck(this, PopupAnnotationElement);

    var isRenderable = !!(parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (PopupAnnotationElement.__proto__ || Object.getPrototypeOf(PopupAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(PopupAnnotationElement, [{
    key: 'render',
    value: function render() {
      var IGNORE_TYPES = ['Line', 'Square', 'Circle', 'PolyLine', 'Polygon', 'Ink'];
      this.container.className = 'popupAnnotation';
      if (IGNORE_TYPES.includes(this.data.parentType)) {
        return this.container;
      }
      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
      var parentElement = this.layer.querySelector(selector);
      if (!parentElement) {
        return this.container;
      }
      var popup = new PopupElement({
        container: this.container,
        trigger: parentElement,
        color: this.data.color,
        title: this.data.title,
        contents: this.data.contents
      });
      var parentLeft = parseFloat(parentElement.style.left);
      var parentWidth = parseFloat(parentElement.style.width);
      this.container.style.transformOrigin = -(parentLeft + parentWidth) + 'px -' + parentElement.style.top;
      this.container.style.left = parentLeft + parentWidth + 'px';
      this.container.appendChild(popup.render());
      return this.container;
    }
  }]);

  return PopupAnnotationElement;
}(AnnotationElement);

var PopupElement = function () {
  function PopupElement(parameters) {
    _classCallCheck(this, PopupElement);

    this.container = parameters.container;
    this.trigger = parameters.trigger;
    this.color = parameters.color;
    this.title = parameters.title;
    this.contents = parameters.contents;
    this.hideWrapper = parameters.hideWrapper || false;
    this.pinned = false;
  }

  _createClass(PopupElement, [{
    key: 'render',
    value: function render() {
      var BACKGROUND_ENLIGHT = 0.7;
      var wrapper = document.createElement('div');
      wrapper.className = 'popupWrapper';
      this.hideElement = this.hideWrapper ? wrapper : this.container;
      this.hideElement.setAttribute('hidden', true);
      var popup = document.createElement('div');
      popup.className = 'popup';
      var color = this.color;
      if (color) {
        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
      }
      var contents = this._formatContents(this.contents);
      var title = document.createElement('h1');
      title.textContent = this.title;
      this.trigger.addEventListener('click', this._toggle.bind(this));
      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
      popup.addEventListener('click', this._hide.bind(this, true));
      popup.appendChild(title);
      popup.appendChild(contents);
      wrapper.appendChild(popup);
      return wrapper;
    }
  }, {
    key: '_formatContents',
    value: function _formatContents(contents) {
      var p = document.createElement('p');
      var lines = contents.split(/(?:\r\n?|\n)/);
      for (var i = 0, ii = lines.length; i < ii; ++i) {
        var line = lines[i];
        p.appendChild(document.createTextNode(line));
        if (i < ii - 1) {
          p.appendChild(document.createElement('br'));
        }
      }
      return p;
    }
  }, {
    key: '_toggle',
    value: function _toggle() {
      if (this.pinned) {
        this._hide(true);
      } else {
        this._show(true);
      }
    }
  }, {
    key: '_show',
    value: function _show() {
      var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (pin) {
        this.pinned = true;
      }
      if (this.hideElement.hasAttribute('hidden')) {
        this.hideElement.removeAttribute('hidden');
        this.container.style.zIndex += 1;
      }
    }
  }, {
    key: '_hide',
    value: function _hide() {
      var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (unpin) {
        this.pinned = false;
      }
      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
        this.hideElement.setAttribute('hidden', true);
        this.container.style.zIndex -= 1;
      }
    }
  }]);

  return PopupElement;
}();

var LineAnnotationElement = function (_AnnotationElement5) {
  _inherits(LineAnnotationElement, _AnnotationElement5);

  function LineAnnotationElement(parameters) {
    _classCallCheck(this, LineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (LineAnnotationElement.__proto__ || Object.getPrototypeOf(LineAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(LineAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'lineAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var line = this.svgFactory.createElement('svg:line');
      line.setAttribute('x1', data.rect[2] - data.lineCoordinates[0]);
      line.setAttribute('y1', data.rect[3] - data.lineCoordinates[1]);
      line.setAttribute('x2', data.rect[2] - data.lineCoordinates[2]);
      line.setAttribute('y2', data.rect[3] - data.lineCoordinates[3]);
      line.setAttribute('stroke-width', data.borderStyle.width);
      line.setAttribute('stroke', 'transparent');
      svg.appendChild(line);
      this.container.append(svg);
      this._createPopup(this.container, line, data);
      return this.container;
    }
  }]);

  return LineAnnotationElement;
}(AnnotationElement);

var SquareAnnotationElement = function (_AnnotationElement6) {
  _inherits(SquareAnnotationElement, _AnnotationElement6);

  function SquareAnnotationElement(parameters) {
    _classCallCheck(this, SquareAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (SquareAnnotationElement.__proto__ || Object.getPrototypeOf(SquareAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(SquareAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'squareAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var borderWidth = data.borderStyle.width;
      var square = this.svgFactory.createElement('svg:rect');
      square.setAttribute('x', borderWidth / 2);
      square.setAttribute('y', borderWidth / 2);
      square.setAttribute('width', width - borderWidth);
      square.setAttribute('height', height - borderWidth);
      square.setAttribute('stroke-width', borderWidth);
      square.setAttribute('stroke', 'transparent');
      square.setAttribute('fill', 'none');
      svg.appendChild(square);
      this.container.append(svg);
      this._createPopup(this.container, square, data);
      return this.container;
    }
  }]);

  return SquareAnnotationElement;
}(AnnotationElement);

var CircleAnnotationElement = function (_AnnotationElement7) {
  _inherits(CircleAnnotationElement, _AnnotationElement7);

  function CircleAnnotationElement(parameters) {
    _classCallCheck(this, CircleAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (CircleAnnotationElement.__proto__ || Object.getPrototypeOf(CircleAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(CircleAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'circleAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var borderWidth = data.borderStyle.width;
      var circle = this.svgFactory.createElement('svg:ellipse');
      circle.setAttribute('cx', width / 2);
      circle.setAttribute('cy', height / 2);
      circle.setAttribute('rx', width / 2 - borderWidth / 2);
      circle.setAttribute('ry', height / 2 - borderWidth / 2);
      circle.setAttribute('stroke-width', borderWidth);
      circle.setAttribute('stroke', 'transparent');
      circle.setAttribute('fill', 'none');
      svg.appendChild(circle);
      this.container.append(svg);
      this._createPopup(this.container, circle, data);
      return this.container;
    }
  }]);

  return CircleAnnotationElement;
}(AnnotationElement);

var PolylineAnnotationElement = function (_AnnotationElement8) {
  _inherits(PolylineAnnotationElement, _AnnotationElement8);

  function PolylineAnnotationElement(parameters) {
    _classCallCheck(this, PolylineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);

    var _this15 = _possibleConstructorReturn(this, (PolylineAnnotationElement.__proto__ || Object.getPrototypeOf(PolylineAnnotationElement)).call(this, parameters, isRenderable, true));

    _this15.containerClassName = 'polylineAnnotation';
    _this15.svgElementName = 'svg:polyline';
    return _this15;
  }

  _createClass(PolylineAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = this.containerClassName;
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var vertices = data.vertices;
      var points = [];
      for (var i = 0, ii = vertices.length; i < ii; i++) {
        var x = vertices[i].x - data.rect[0];
        var y = data.rect[3] - vertices[i].y;
        points.push(x + ',' + y);
      }
      points = points.join(' ');
      var borderWidth = data.borderStyle.width;
      var polyline = this.svgFactory.createElement(this.svgElementName);
      polyline.setAttribute('points', points);
      polyline.setAttribute('stroke-width', borderWidth);
      polyline.setAttribute('stroke', 'transparent');
      polyline.setAttribute('fill', 'none');
      svg.appendChild(polyline);
      this.container.append(svg);
      this._createPopup(this.container, polyline, data);
      return this.container;
    }
  }]);

  return PolylineAnnotationElement;
}(AnnotationElement);

var PolygonAnnotationElement = function (_PolylineAnnotationEl) {
  _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);

  function PolygonAnnotationElement(parameters) {
    _classCallCheck(this, PolygonAnnotationElement);

    var _this16 = _possibleConstructorReturn(this, (PolygonAnnotationElement.__proto__ || Object.getPrototypeOf(PolygonAnnotationElement)).call(this, parameters));

    _this16.containerClassName = 'polygonAnnotation';
    _this16.svgElementName = 'svg:polygon';
    return _this16;
  }

  return PolygonAnnotationElement;
}(PolylineAnnotationElement);

var InkAnnotationElement = function (_AnnotationElement9) {
  _inherits(InkAnnotationElement, _AnnotationElement9);

  function InkAnnotationElement(parameters) {
    _classCallCheck(this, InkAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);

    var _this17 = _possibleConstructorReturn(this, (InkAnnotationElement.__proto__ || Object.getPrototypeOf(InkAnnotationElement)).call(this, parameters, isRenderable, true));

    _this17.containerClassName = 'inkAnnotation';
    _this17.svgElementName = 'svg:polyline';
    return _this17;
  }

  _createClass(InkAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = this.containerClassName;
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var inkLists = data.inkLists;
      for (var i = 0, ii = inkLists.length; i < ii; i++) {
        var inkList = inkLists[i];
        var points = [];
        for (var j = 0, jj = inkList.length; j < jj; j++) {
          var x = inkList[j].x - data.rect[0];
          var y = data.rect[3] - inkList[j].y;
          points.push(x + ',' + y);
        }
        points = points.join(' ');
        var borderWidth = data.borderStyle.width;
        var polyline = this.svgFactory.createElement(this.svgElementName);
        polyline.setAttribute('points', points);
        polyline.setAttribute('stroke-width', borderWidth);
        polyline.setAttribute('stroke', 'transparent');
        polyline.setAttribute('fill', 'none');
        this._createPopup(this.container, polyline, data);
        svg.appendChild(polyline);
      }
      this.container.append(svg);
      return this.container;
    }
  }]);

  return InkAnnotationElement;
}(AnnotationElement);

var HighlightAnnotationElement = function (_AnnotationElement10) {
  _inherits(HighlightAnnotationElement, _AnnotationElement10);

  function HighlightAnnotationElement(parameters) {
    _classCallCheck(this, HighlightAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (HighlightAnnotationElement.__proto__ || Object.getPrototypeOf(HighlightAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(HighlightAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'highlightAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return HighlightAnnotationElement;
}(AnnotationElement);

var UnderlineAnnotationElement = function (_AnnotationElement11) {
  _inherits(UnderlineAnnotationElement, _AnnotationElement11);

  function UnderlineAnnotationElement(parameters) {
    _classCallCheck(this, UnderlineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (UnderlineAnnotationElement.__proto__ || Object.getPrototypeOf(UnderlineAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(UnderlineAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'underlineAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return UnderlineAnnotationElement;
}(AnnotationElement);

var SquigglyAnnotationElement = function (_AnnotationElement12) {
  _inherits(SquigglyAnnotationElement, _AnnotationElement12);

  function SquigglyAnnotationElement(parameters) {
    _classCallCheck(this, SquigglyAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (SquigglyAnnotationElement.__proto__ || Object.getPrototypeOf(SquigglyAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(SquigglyAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'squigglyAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return SquigglyAnnotationElement;
}(AnnotationElement);

var StrikeOutAnnotationElement = function (_AnnotationElement13) {
  _inherits(StrikeOutAnnotationElement, _AnnotationElement13);

  function StrikeOutAnnotationElement(parameters) {
    _classCallCheck(this, StrikeOutAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (StrikeOutAnnotationElement.__proto__ || Object.getPrototypeOf(StrikeOutAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(StrikeOutAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'strikeoutAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return StrikeOutAnnotationElement;
}(AnnotationElement);

var StampAnnotationElement = function (_AnnotationElement14) {
  _inherits(StampAnnotationElement, _AnnotationElement14);

  function StampAnnotationElement(parameters) {
    _classCallCheck(this, StampAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (StampAnnotationElement.__proto__ || Object.getPrototypeOf(StampAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(StampAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'stampAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return StampAnnotationElement;
}(AnnotationElement);

var FileAttachmentAnnotationElement = function (_AnnotationElement15) {
  _inherits(FileAttachmentAnnotationElement, _AnnotationElement15);

  function FileAttachmentAnnotationElement(parameters) {
    _classCallCheck(this, FileAttachmentAnnotationElement);

    var _this23 = _possibleConstructorReturn(this, (FileAttachmentAnnotationElement.__proto__ || Object.getPrototypeOf(FileAttachmentAnnotationElement)).call(this, parameters, true));

    var _this23$data$file = _this23.data.file,
        filename = _this23$data$file.filename,
        content = _this23$data$file.content;

    _this23.filename = (0, _dom_utils.getFilenameFromUrl)(filename);
    _this23.content = content;
    if (_this23.linkService.eventBus) {
      _this23.linkService.eventBus.dispatch('fileattachmentannotation', {
        source: _this23,
        id: (0, _util.stringToPDFString)(filename),
        filename: filename,
        content: content
      });
    }
    return _this23;
  }

  _createClass(FileAttachmentAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'fileAttachmentAnnotation';
      var trigger = document.createElement('div');
      trigger.style.height = this.container.style.height;
      trigger.style.width = this.container.style.width;
      trigger.addEventListener('dblclick', this._download.bind(this));
      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
        this._createPopup(this.container, trigger, this.data);
      }
      this.container.appendChild(trigger);
      return this.container;
    }
  }, {
    key: '_download',
    value: function _download() {
      if (!this.downloadManager) {
        (0, _util.warn)('Download cannot be started due to unavailable download manager');
        return;
      }
      this.downloadManager.downloadData(this.content, this.filename, '');
    }
  }]);

  return FileAttachmentAnnotationElement;
}(AnnotationElement);

var AnnotationLayer = function () {
  function AnnotationLayer() {
    _classCallCheck(this, AnnotationLayer);
  }

  _createClass(AnnotationLayer, null, [{
    key: 'render',
    value: function render(parameters) {
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];
        if (!data) {
          continue;
        }
        var element = AnnotationElementFactory.create({
          data: data,
          layer: parameters.div,
          page: parameters.page,
          viewport: parameters.viewport,
          linkService: parameters.linkService,
          downloadManager: parameters.downloadManager,
          imageResourcesPath: parameters.imageResourcesPath || '',
          renderInteractiveForms: parameters.renderInteractiveForms || false,
          svgFactory: new _dom_utils.DOMSVGFactory()
        });
        if (element.isRenderable) {
          parameters.div.appendChild(element.render());
        }
      }
    }
  }, {
    key: 'update',
    value: function update(parameters) {
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];
        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');
        if (element) {
          element.style.transform = 'matrix(' + parameters.viewport.transform.join(',') + ')';
        }
      }
      parameters.div.removeAttribute('hidden');
    }
  }]);

  return AnnotationLayer;
}();

exports.AnnotationLayer = AnnotationLayer;

/***/ }),
/* 147 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVGGraphics = undefined;

var _util = __w_pdfjs_require__(1);

var _dom_utils = __w_pdfjs_require__(130);

var _is_node = __w_pdfjs_require__(4);

var _is_node2 = _interopRequireDefault(_is_node);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVGGraphics = function SVGGraphics() {
  throw new Error('Not implemented: SVGGraphics');
};
{
  var SVG_DEFAULTS = {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fillColor: '#000000'
  };
  var convertImgDataToPng = function convertImgDataToPngClosure() {
    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
    var CHUNK_WRAPPER_SIZE = 12;
    var crcTable = new Int32Array(256);
    for (var i = 0; i < 256; i++) {
      var c = i;
      for (var h = 0; h < 8; h++) {
        if (c & 1) {
          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
        } else {
          c = c >> 1 & 0x7fffffff;
        }
      }
      crcTable[i] = c;
    }
    function crc32(data, start, end) {
      var crc = -1;
      for (var i = start; i < end; i++) {
        var a = (crc ^ data[i]) & 0xff;
        var b = crcTable[a];
        crc = crc >>> 8 ^ b;
      }
      return crc ^ -1;
    }
    function writePngChunk(type, body, data, offset) {
      var p = offset;
      var len = body.length;
      data[p] = len >> 24 & 0xff;
      data[p + 1] = len >> 16 & 0xff;
      data[p + 2] = len >> 8 & 0xff;
      data[p + 3] = len & 0xff;
      p += 4;
      data[p] = type.charCodeAt(0) & 0xff;
      data[p + 1] = type.charCodeAt(1) & 0xff;
      data[p + 2] = type.charCodeAt(2) & 0xff;
      data[p + 3] = type.charCodeAt(3) & 0xff;
      p += 4;
      data.set(body, p);
      p += body.length;
      var crc = crc32(data, offset + 4, p);
      data[p] = crc >> 24 & 0xff;
      data[p + 1] = crc >> 16 & 0xff;
      data[p + 2] = crc >> 8 & 0xff;
      data[p + 3] = crc & 0xff;
    }
    function adler32(data, start, end) {
      var a = 1;
      var b = 0;
      for (var i = start; i < end; ++i) {
        a = (a + (data[i] & 0xff)) % 65521;
        b = (b + a) % 65521;
      }
      return b << 16 | a;
    }
    function deflateSync(literals) {
      if (!(0, _is_node2.default)()) {
        return deflateSyncUncompressed(literals);
      }
      try {
        var input;
        if (parseInt(process.versions.node) >= 8) {
          input = literals;
        } else {
          input = new Buffer(literals);
        }
        var output = __webpack_require__(364).deflateSync(input, { level: 9 });
        return output instanceof Uint8Array ? output : new Uint8Array(output);
      } catch (e) {
        (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e);
      }
      return deflateSyncUncompressed(literals);
    }
    function deflateSyncUncompressed(literals) {
      var len = literals.length;
      var maxBlockLength = 0xFFFF;
      var deflateBlocks = Math.ceil(len / maxBlockLength);
      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
      var pi = 0;
      idat[pi++] = 0x78;
      idat[pi++] = 0x9c;
      var pos = 0;
      while (len > maxBlockLength) {
        idat[pi++] = 0x00;
        idat[pi++] = 0xff;
        idat[pi++] = 0xff;
        idat[pi++] = 0x00;
        idat[pi++] = 0x00;
        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
        pi += maxBlockLength;
        pos += maxBlockLength;
        len -= maxBlockLength;
      }
      idat[pi++] = 0x01;
      idat[pi++] = len & 0xff;
      idat[pi++] = len >> 8 & 0xff;
      idat[pi++] = ~len & 0xffff & 0xff;
      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
      idat.set(literals.subarray(pos), pi);
      pi += literals.length - pos;
      var adler = adler32(literals, 0, literals.length);
      idat[pi++] = adler >> 24 & 0xff;
      idat[pi++] = adler >> 16 & 0xff;
      idat[pi++] = adler >> 8 & 0xff;
      idat[pi++] = adler & 0xff;
      return idat;
    }
    function encode(imgData, kind, forceDataSchema, isMask) {
      var width = imgData.width;
      var height = imgData.height;
      var bitDepth, colorType, lineSize;
      var bytes = imgData.data;
      switch (kind) {
        case _util.ImageKind.GRAYSCALE_1BPP:
          colorType = 0;
          bitDepth = 1;
          lineSize = width + 7 >> 3;
          break;
        case _util.ImageKind.RGB_24BPP:
          colorType = 2;
          bitDepth = 8;
          lineSize = width * 3;
          break;
        case _util.ImageKind.RGBA_32BPP:
          colorType = 6;
          bitDepth = 8;
          lineSize = width * 4;
          break;
        default:
          throw new Error('invalid format');
      }
      var literals = new Uint8Array((1 + lineSize) * height);
      var offsetLiterals = 0,
          offsetBytes = 0;
      var y, i;
      for (y = 0; y < height; ++y) {
        literals[offsetLiterals++] = 0;
        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
        offsetBytes += lineSize;
        offsetLiterals += lineSize;
      }
      if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
        offsetLiterals = 0;
        for (y = 0; y < height; y++) {
          offsetLiterals++;
          for (i = 0; i < lineSize; i++) {
            literals[offsetLiterals++] ^= 0xFF;
          }
        }
      }
      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
      var idat = deflateSync(literals);
      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
      var data = new Uint8Array(pngLength);
      var offset = 0;
      data.set(PNG_HEADER, offset);
      offset += PNG_HEADER.length;
      writePngChunk('IHDR', ihdr, data, offset);
      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
      writePngChunk('IDATA', idat, data, offset);
      offset += CHUNK_WRAPPER_SIZE + idat.length;
      writePngChunk('IEND', new Uint8Array(0), data, offset);
      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
    }
    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
      return encode(imgData, kind, forceDataSchema, isMask);
    };
  }();
  var SVGExtraState = function SVGExtraStateClosure() {
    function SVGExtraState() {
      this.fontSizeScale = 1;
      this.fontWeight = SVG_DEFAULTS.fontWeight;
      this.fontSize = 0;
      this.textMatrix = _util.IDENTITY_MATRIX;
      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
      this.leading = 0;
      this.textRenderingMode = _util.TextRenderingMode.FILL;
      this.x = 0;
      this.y = 0;
      this.lineX = 0;
      this.lineY = 0;
      this.charSpacing = 0;
      this.wordSpacing = 0;
      this.textHScale = 1;
      this.textRise = 0;
      this.fillColor = SVG_DEFAULTS.fillColor;
      this.strokeColor = '#000000';
      this.fillAlpha = 1;
      this.strokeAlpha = 1;
      this.lineWidth = 1;
      this.lineJoin = '';
      this.lineCap = '';
      this.miterLimit = 0;
      this.dashArray = [];
      this.dashPhase = 0;
      this.dependencies = [];
      this.activeClipUrl = null;
      this.clipGroup = null;
      this.maskId = '';
    }
    SVGExtraState.prototype = {
      clone: function SVGExtraState_clone() {
        return Object.create(this);
      },
      setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
        this.x = x;
        this.y = y;
      }
    };
    return SVGExtraState;
  }();
  exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
    function opListToTree(opList) {
      var opTree = [];
      var tmp = [];
      var opListLen = opList.length;
      for (var x = 0; x < opListLen; x++) {
        if (opList[x].fn === 'save') {
          opTree.push({
            'fnId': 92,
            'fn': 'group',
            'items': []
          });
          tmp.push(opTree);
          opTree = opTree[opTree.length - 1].items;
          continue;
        }
        if (opList[x].fn === 'restore') {
          opTree = tmp.pop();
        } else {
          opTree.push(opList[x]);
        }
      }
      return opTree;
    }
    function pf(value) {
      if (Number.isInteger(value)) {
        return value.toString();
      }
      var s = value.toFixed(10);
      var i = s.length - 1;
      if (s[i] !== '0') {
        return s;
      }
      do {
        i--;
      } while (s[i] === '0');
      return s.substring(0, s[i] === '.' ? i : i + 1);
    }
    function pm(m) {
      if (m[4] === 0 && m[5] === 0) {
        if (m[1] === 0 && m[2] === 0) {
          if (m[0] === 1 && m[3] === 1) {
            return '';
          }
          return 'scale(' + pf(m[0]) + ' ' + pf(m[3]) + ')';
        }
        if (m[0] === m[3] && m[1] === -m[2]) {
          var a = Math.acos(m[0]) * 180 / Math.PI;
          return 'rotate(' + pf(a) + ')';
        }
      } else {
        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
          return 'translate(' + pf(m[4]) + ' ' + pf(m[5]) + ')';
        }
      }
      return 'matrix(' + pf(m[0]) + ' ' + pf(m[1]) + ' ' + pf(m[2]) + ' ' + pf(m[3]) + ' ' + pf(m[4]) + ' ' + pf(m[5]) + ')';
    }
    function SVGGraphics(commonObjs, objs, forceDataSchema) {
      this.svgFactory = new _dom_utils.DOMSVGFactory();
      this.current = new SVGExtraState();
      this.transformMatrix = _util.IDENTITY_MATRIX;
      this.transformStack = [];
      this.extraStack = [];
      this.commonObjs = commonObjs;
      this.objs = objs;
      this.pendingClip = null;
      this.pendingEOFill = false;
      this.embedFonts = false;
      this.embeddedFonts = Object.create(null);
      this.cssStyle = null;
      this.forceDataSchema = !!forceDataSchema;
    }
    var XML_NS = 'http://www.w3.org/XML/1998/namespace';
    var XLINK_NS = 'http://www.w3.org/1999/xlink';
    var LINE_CAP_STYLES = ['butt', 'round', 'square'];
    var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
    var clipCount = 0;
    var maskCount = 0;
    SVGGraphics.prototype = {
      save: function SVGGraphics_save() {
        this.transformStack.push(this.transformMatrix);
        var old = this.current;
        this.extraStack.push(old);
        this.current = old.clone();
      },
      restore: function SVGGraphics_restore() {
        this.transformMatrix = this.transformStack.pop();
        this.current = this.extraStack.pop();
        this.pendingClip = null;
        this.tgrp = null;
      },
      group: function SVGGraphics_group(items) {
        this.save();
        this.executeOpTree(items);
        this.restore();
      },
      loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
        var _this = this;

        var fnArray = operatorList.fnArray;
        var fnArrayLen = fnArray.length;
        var argsArray = operatorList.argsArray;
        for (var i = 0; i < fnArrayLen; i++) {
          if (_util.OPS.dependency === fnArray[i]) {
            var deps = argsArray[i];
            for (var n = 0, nn = deps.length; n < nn; n++) {
              var obj = deps[n];
              var common = obj.substring(0, 2) === 'g_';
              var promise;
              if (common) {
                promise = new Promise(function (resolve) {
                  _this.commonObjs.get(obj, resolve);
                });
              } else {
                promise = new Promise(function (resolve) {
                  _this.objs.get(obj, resolve);
                });
              }
              this.current.dependencies.push(promise);
            }
          }
        }
        return Promise.all(this.current.dependencies);
      },
      transform: function SVGGraphics_transform(a, b, c, d, e, f) {
        var transformMatrix = [a, b, c, d, e, f];
        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
        this.tgrp = null;
      },
      getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
        var _this2 = this;

        this.viewport = viewport;
        var svgElement = this._initialize(viewport);
        return this.loadDependencies(operatorList).then(function () {
          _this2.transformMatrix = _util.IDENTITY_MATRIX;
          var opTree = _this2.convertOpList(operatorList);
          _this2.executeOpTree(opTree);
          return svgElement;
        });
      },
      convertOpList: function SVGGraphics_convertOpList(operatorList) {
        var argsArray = operatorList.argsArray;
        var fnArray = operatorList.fnArray;
        var fnArrayLen = fnArray.length;
        var REVOPS = [];
        var opList = [];
        for (var op in _util.OPS) {
          REVOPS[_util.OPS[op]] = op;
        }
        for (var x = 0; x < fnArrayLen; x++) {
          var fnId = fnArray[x];
          opList.push({
            'fnId': fnId,
            'fn': REVOPS[fnId],
            'args': argsArray[x]
          });
        }
        return opListToTree(opList);
      },
      executeOpTree: function SVGGraphics_executeOpTree(opTree) {
        var opTreeLen = opTree.length;
        for (var x = 0; x < opTreeLen; x++) {
          var fn = opTree[x].fn;
          var fnId = opTree[x].fnId;
          var args = opTree[x].args;
          switch (fnId | 0) {
            case _util.OPS.beginText:
              this.beginText();
              break;
            case _util.OPS.dependency:
              break;
            case _util.OPS.setLeading:
              this.setLeading(args);
              break;
            case _util.OPS.setLeadingMoveText:
              this.setLeadingMoveText(args[0], args[1]);
              break;
            case _util.OPS.setFont:
              this.setFont(args);
              break;
            case _util.OPS.showText:
              this.showText(args[0]);
              break;
            case _util.OPS.showSpacedText:
              this.showText(args[0]);
              break;
            case _util.OPS.endText:
              this.endText();
              break;
            case _util.OPS.moveText:
              this.moveText(args[0], args[1]);
              break;
            case _util.OPS.setCharSpacing:
              this.setCharSpacing(args[0]);
              break;
            case _util.OPS.setWordSpacing:
              this.setWordSpacing(args[0]);
              break;
            case _util.OPS.setHScale:
              this.setHScale(args[0]);
              break;
            case _util.OPS.setTextMatrix:
              this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
              break;
            case _util.OPS.setTextRise:
              this.setTextRise(args[0]);
              break;
            case _util.OPS.setTextRenderingMode:
              this.setTextRenderingMode(args[0]);
              break;
            case _util.OPS.setLineWidth:
              this.setLineWidth(args[0]);
              break;
            case _util.OPS.setLineJoin:
              this.setLineJoin(args[0]);
              break;
            case _util.OPS.setLineCap:
              this.setLineCap(args[0]);
              break;
            case _util.OPS.setMiterLimit:
              this.setMiterLimit(args[0]);
              break;
            case _util.OPS.setFillRGBColor:
              this.setFillRGBColor(args[0], args[1], args[2]);
              break;
            case _util.OPS.setStrokeRGBColor:
              this.setStrokeRGBColor(args[0], args[1], args[2]);
              break;
            case _util.OPS.setDash:
              this.setDash(args[0], args[1]);
              break;
            case _util.OPS.setGState:
              this.setGState(args[0]);
              break;
            case _util.OPS.fill:
              this.fill();
              break;
            case _util.OPS.eoFill:
              this.eoFill();
              break;
            case _util.OPS.stroke:
              this.stroke();
              break;
            case _util.OPS.fillStroke:
              this.fillStroke();
              break;
            case _util.OPS.eoFillStroke:
              this.eoFillStroke();
              break;
            case _util.OPS.clip:
              this.clip('nonzero');
              break;
            case _util.OPS.eoClip:
              this.clip('evenodd');
              break;
            case _util.OPS.paintSolidColorImageMask:
              this.paintSolidColorImageMask();
              break;
            case _util.OPS.paintJpegXObject:
              this.paintJpegXObject(args[0], args[1], args[2]);
              break;
            case _util.OPS.paintImageXObject:
              this.paintImageXObject(args[0]);
              break;
            case _util.OPS.paintInlineImageXObject:
              this.paintInlineImageXObject(args[0]);
              break;
            case _util.OPS.paintImageMaskXObject:
              this.paintImageMaskXObject(args[0]);
              break;
            case _util.OPS.paintFormXObjectBegin:
              this.paintFormXObjectBegin(args[0], args[1]);
              break;
            case _util.OPS.paintFormXObjectEnd:
              this.paintFormXObjectEnd();
              break;
            case _util.OPS.closePath:
              this.closePath();
              break;
            case _util.OPS.closeStroke:
              this.closeStroke();
              break;
            case _util.OPS.closeFillStroke:
              this.closeFillStroke();
              break;
            case _util.OPS.closeEOFillStroke:
              this.closeEOFillStroke();
              break;
            case _util.OPS.nextLine:
              this.nextLine();
              break;
            case _util.OPS.transform:
              this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
              break;
            case _util.OPS.constructPath:
              this.constructPath(args[0], args[1]);
              break;
            case _util.OPS.endPath:
              this.endPath();
              break;
            case 92:
              this.group(opTree[x].items);
              break;
            default:
              (0, _util.warn)('Unimplemented operator ' + fn);
              break;
          }
        }
      },
      setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
        this.current.wordSpacing = wordSpacing;
      },
      setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
        this.current.charSpacing = charSpacing;
      },
      nextLine: function SVGGraphics_nextLine() {
        this.moveText(0, this.current.leading);
      },
      setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
        var current = this.current;
        this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        current.xcoords = [];
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.txtElement = this.svgFactory.createElement('svg:text');
        current.txtElement.appendChild(current.tspan);
      },
      beginText: function SVGGraphics_beginText() {
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        this.current.textMatrix = _util.IDENTITY_MATRIX;
        this.current.lineMatrix = _util.IDENTITY_MATRIX;
        this.current.tspan = this.svgFactory.createElement('svg:tspan');
        this.current.txtElement = this.svgFactory.createElement('svg:text');
        this.current.txtgrp = this.svgFactory.createElement('svg:g');
        this.current.xcoords = [];
      },
      moveText: function SVGGraphics_moveText(x, y) {
        var current = this.current;
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
        current.xcoords = [];
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
      },
      showText: function SVGGraphics_showText(glyphs) {
        var current = this.current;
        var font = current.font;
        var fontSize = current.fontSize;
        if (fontSize === 0) {
          return;
        }
        var charSpacing = current.charSpacing;
        var wordSpacing = current.wordSpacing;
        var fontDirection = current.fontDirection;
        var textHScale = current.textHScale * fontDirection;
        var glyphsLength = glyphs.length;
        var vertical = font.vertical;
        var widthAdvanceScale = fontSize * current.fontMatrix[0];
        var x = 0,
            i;
        for (i = 0; i < glyphsLength; ++i) {
          var glyph = glyphs[i];
          if (glyph === null) {
            x += fontDirection * wordSpacing;
            continue;
          } else if ((0, _util.isNum)(glyph)) {
            x += -glyph * fontSize * 0.001;
            continue;
          }
          var width = glyph.width;
          var character = glyph.fontChar;
          var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
          var charWidth = width * widthAdvanceScale + spacing * fontDirection;
          if (!glyph.isInFont && !font.missingFile) {
            x += charWidth;
            continue;
          }
          current.xcoords.push(current.x + x * textHScale);
          current.tspan.textContent += character;
          x += charWidth;
        }
        if (vertical) {
          current.y -= x * textHScale;
        } else {
          current.x += x * textHScale;
        }
        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
        }
        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
        }
        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          if (current.fillColor !== SVG_DEFAULTS.fillColor) {
            current.tspan.setAttributeNS(null, 'fill', current.fillColor);
          }
          if (current.fillAlpha < 1) {
            current.tspan.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
          }
        } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) {
          current.tspan.setAttributeNS(null, 'fill', 'transparent');
        } else {
          current.tspan.setAttributeNS(null, 'fill', 'none');
        }
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          this._setStrokeAttributes(current.tspan);
        }
        var textMatrix = current.textMatrix;
        if (current.textRise !== 0) {
          textMatrix = textMatrix.slice();
          textMatrix[5] += current.textRise;
        }
        current.txtElement.setAttributeNS(null, 'transform', pm(textMatrix) + ' scale(1, -1)');
        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
        current.txtElement.appendChild(current.tspan);
        current.txtgrp.appendChild(current.txtElement);
        this._ensureTransformGroup().appendChild(current.txtElement);
      },
      setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
        this.setLeading(-y);
        this.moveText(x, y);
      },
      addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
        if (!this.cssStyle) {
          this.cssStyle = this.svgFactory.createElement('svg:style');
          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
          this.defs.appendChild(this.cssStyle);
        }
        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
        this.cssStyle.textContent += '@font-face { font-family: "' + fontObj.loadedName + '";' + ' src: url(' + url + '); }\n';
      },
      setFont: function SVGGraphics_setFont(details) {
        var current = this.current;
        var fontObj = this.commonObjs.get(details[0]);
        var size = details[1];
        this.current.font = fontObj;
        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
          this.addFontStyle(fontObj);
          this.embeddedFonts[fontObj.loadedName] = fontObj;
        }
        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
        var italic = fontObj.italic ? 'italic' : 'normal';
        if (size < 0) {
          size = -size;
          current.fontDirection = -1;
        } else {
          current.fontDirection = 1;
        }
        current.fontSize = size;
        current.fontFamily = fontObj.loadedName;
        current.fontWeight = bold;
        current.fontStyle = italic;
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.xcoords = [];
      },
      endText: function endText() {
        var current = this.current;
        if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && current.txtElement && current.txtElement.hasChildNodes()) {
          current.element = current.txtElement;
          this.clip('nonzero');
          this.endPath();
        }
      },

      setLineWidth: function SVGGraphics_setLineWidth(width) {
        this.current.lineWidth = width;
      },
      setLineCap: function SVGGraphics_setLineCap(style) {
        this.current.lineCap = LINE_CAP_STYLES[style];
      },
      setLineJoin: function SVGGraphics_setLineJoin(style) {
        this.current.lineJoin = LINE_JOIN_STYLES[style];
      },
      setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
        this.current.miterLimit = limit;
      },
      setStrokeAlpha: function SVGGraphics_setStrokeAlpha(strokeAlpha) {
        this.current.strokeAlpha = strokeAlpha;
      },
      setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
        var color = _util.Util.makeCssRgb(r, g, b);
        this.current.strokeColor = color;
      },
      setFillAlpha: function SVGGraphics_setFillAlpha(fillAlpha) {
        this.current.fillAlpha = fillAlpha;
      },
      setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
        var color = _util.Util.makeCssRgb(r, g, b);
        this.current.fillColor = color;
        this.current.tspan = this.svgFactory.createElement('svg:tspan');
        this.current.xcoords = [];
      },
      setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
        this.current.dashArray = dashArray;
        this.current.dashPhase = dashPhase;
      },
      constructPath: function SVGGraphics_constructPath(ops, args) {
        var current = this.current;
        var x = current.x,
            y = current.y;
        current.path = this.svgFactory.createElement('svg:path');
        var d = [];
        var opLength = ops.length;
        for (var i = 0, j = 0; i < opLength; i++) {
          switch (ops[i] | 0) {
            case _util.OPS.rectangle:
              x = args[j++];
              y = args[j++];
              var width = args[j++];
              var height = args[j++];
              var xw = x + width;
              var yh = y + height;
              d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
              break;
            case _util.OPS.moveTo:
              x = args[j++];
              y = args[j++];
              d.push('M', pf(x), pf(y));
              break;
            case _util.OPS.lineTo:
              x = args[j++];
              y = args[j++];
              d.push('L', pf(x), pf(y));
              break;
            case _util.OPS.curveTo:
              x = args[j + 4];
              y = args[j + 5];
              d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
              j += 6;
              break;
            case _util.OPS.curveTo2:
              x = args[j + 2];
              y = args[j + 3];
              d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
              j += 4;
              break;
            case _util.OPS.curveTo3:
              x = args[j + 2];
              y = args[j + 3];
              d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
              j += 4;
              break;
            case _util.OPS.closePath:
              d.push('Z');
              break;
          }
        }
        current.path.setAttributeNS(null, 'd', d.join(' '));
        current.path.setAttributeNS(null, 'fill', 'none');
        this._ensureTransformGroup().appendChild(current.path);
        current.element = current.path;
        current.setCurrentPoint(x, y);
      },
      endPath: function SVGGraphics_endPath() {
        if (!this.pendingClip) {
          return;
        }
        var current = this.current;
        var clipId = 'clippath' + clipCount;
        clipCount++;
        var clipPath = this.svgFactory.createElement('svg:clipPath');
        clipPath.setAttributeNS(null, 'id', clipId);
        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
        var clipElement = current.element.cloneNode(true);
        if (this.pendingClip === 'evenodd') {
          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
        } else {
          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
        }
        this.pendingClip = null;
        clipPath.appendChild(clipElement);
        this.defs.appendChild(clipPath);
        if (current.activeClipUrl) {
          current.clipGroup = null;
          this.extraStack.forEach(function (prev) {
            prev.clipGroup = null;
          });
          clipPath.setAttributeNS(null, 'clip-path', current.activeClipUrl);
        }
        current.activeClipUrl = 'url(#' + clipId + ')';
        this.tgrp = null;
      },
      clip: function SVGGraphics_clip(type) {
        this.pendingClip = type;
      },
      closePath: function SVGGraphics_closePath() {
        var current = this.current;
        if (current.path) {
          var d = current.path.getAttributeNS(null, 'd');
          d += 'Z';
          current.path.setAttributeNS(null, 'd', d);
        }
      },
      setLeading: function SVGGraphics_setLeading(leading) {
        this.current.leading = -leading;
      },
      setTextRise: function SVGGraphics_setTextRise(textRise) {
        this.current.textRise = textRise;
      },
      setTextRenderingMode: function setTextRenderingMode(textRenderingMode) {
        this.current.textRenderingMode = textRenderingMode;
      },

      setHScale: function SVGGraphics_setHScale(scale) {
        this.current.textHScale = scale / 100;
      },
      setGState: function SVGGraphics_setGState(states) {
        for (var i = 0, ii = states.length; i < ii; i++) {
          var state = states[i];
          var key = state[0];
          var value = state[1];
          switch (key) {
            case 'LW':
              this.setLineWidth(value);
              break;
            case 'LC':
              this.setLineCap(value);
              break;
            case 'LJ':
              this.setLineJoin(value);
              break;
            case 'ML':
              this.setMiterLimit(value);
              break;
            case 'D':
              this.setDash(value[0], value[1]);
              break;
            case 'Font':
              this.setFont(value);
              break;
            case 'CA':
              this.setStrokeAlpha(value);
              break;
            case 'ca':
              this.setFillAlpha(value);
              break;
            default:
              (0, _util.warn)('Unimplemented graphic state ' + key);
              break;
          }
        }
      },
      fill: function SVGGraphics_fill() {
        var current = this.current;
        if (current.element) {
          current.element.setAttributeNS(null, 'fill', current.fillColor);
          current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
          this.endPath();
        }
      },
      stroke: function SVGGraphics_stroke() {
        var current = this.current;
        if (current.element) {
          this._setStrokeAttributes(current.element);
          current.element.setAttributeNS(null, 'fill', 'none');
          this.endPath();
        }
      },
      _setStrokeAttributes: function _setStrokeAttributes(element) {
        var current = this.current;
        element.setAttributeNS(null, 'stroke', current.strokeColor);
        element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha);
        element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
        element.setAttributeNS(null, 'stroke-linecap', current.lineCap);
        element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
        element.setAttributeNS(null, 'stroke-width', pf(current.lineWidth) + 'px');
        element.setAttributeNS(null, 'stroke-dasharray', current.dashArray.map(pf).join(' '));
        element.setAttributeNS(null, 'stroke-dashoffset', pf(current.dashPhase) + 'px');
      },

      eoFill: function SVGGraphics_eoFill() {
        if (this.current.element) {
          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        }
        this.fill();
      },
      fillStroke: function SVGGraphics_fillStroke() {
        this.stroke();
        this.fill();
      },
      eoFillStroke: function SVGGraphics_eoFillStroke() {
        if (this.current.element) {
          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        }
        this.fillStroke();
      },
      closeStroke: function SVGGraphics_closeStroke() {
        this.closePath();
        this.stroke();
      },
      closeFillStroke: function SVGGraphics_closeFillStroke() {
        this.closePath();
        this.fillStroke();
      },
      closeEOFillStroke: function closeEOFillStroke() {
        this.closePath();
        this.eoFillStroke();
      },

      paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
        var current = this.current;
        var rect = this.svgFactory.createElement('svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', '1px');
        rect.setAttributeNS(null, 'height', '1px');
        rect.setAttributeNS(null, 'fill', current.fillColor);
        this._ensureTransformGroup().appendChild(rect);
      },
      paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
        var imgObj = this.objs.get(objId);
        var imgEl = this.svgFactory.createElement('svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
        imgEl.setAttributeNS(null, 'width', pf(w));
        imgEl.setAttributeNS(null, 'height', pf(h));
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-h));
        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / w) + ' ' + pf(-1 / h) + ')');
        this._ensureTransformGroup().appendChild(imgEl);
      },
      paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
        var imgData = this.objs.get(objId);
        if (!imgData) {
          (0, _util.warn)('Dependent image isn\'t ready yet');
          return;
        }
        this.paintInlineImageXObject(imgData);
      },
      paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
        var width = imgData.width;
        var height = imgData.height;
        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
        var cliprect = this.svgFactory.createElement('svg:rect');
        cliprect.setAttributeNS(null, 'x', '0');
        cliprect.setAttributeNS(null, 'y', '0');
        cliprect.setAttributeNS(null, 'width', pf(width));
        cliprect.setAttributeNS(null, 'height', pf(height));
        this.current.element = cliprect;
        this.clip('nonzero');
        var imgEl = this.svgFactory.createElement('svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-height));
        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / width) + ' ' + pf(-1 / height) + ')');
        if (mask) {
          mask.appendChild(imgEl);
        } else {
          this._ensureTransformGroup().appendChild(imgEl);
        }
      },
      paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
        var current = this.current;
        var width = imgData.width;
        var height = imgData.height;
        var fillColor = current.fillColor;
        current.maskId = 'mask' + maskCount++;
        var mask = this.svgFactory.createElement('svg:mask');
        mask.setAttributeNS(null, 'id', current.maskId);
        var rect = this.svgFactory.createElement('svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', pf(width));
        rect.setAttributeNS(null, 'height', pf(height));
        rect.setAttributeNS(null, 'fill', fillColor);
        rect.setAttributeNS(null, 'mask', 'url(#' + current.maskId + ')');
        this.defs.appendChild(mask);
        this._ensureTransformGroup().appendChild(rect);
        this.paintInlineImageXObject(imgData, mask);
      },
      paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
        if (Array.isArray(matrix) && matrix.length === 6) {
          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
        }
        if (Array.isArray(bbox) && bbox.length === 4) {
          var width = bbox[2] - bbox[0];
          var height = bbox[3] - bbox[1];
          var cliprect = this.svgFactory.createElement('svg:rect');
          cliprect.setAttributeNS(null, 'x', bbox[0]);
          cliprect.setAttributeNS(null, 'y', bbox[1]);
          cliprect.setAttributeNS(null, 'width', pf(width));
          cliprect.setAttributeNS(null, 'height', pf(height));
          this.current.element = cliprect;
          this.clip('nonzero');
          this.endPath();
        }
      },
      paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
      _initialize: function _initialize(viewport) {
        var svg = this.svgFactory.create(viewport.width, viewport.height);
        var definitions = this.svgFactory.createElement('svg:defs');
        svg.appendChild(definitions);
        this.defs = definitions;
        var rootGroup = this.svgFactory.createElement('svg:g');
        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
        svg.appendChild(rootGroup);
        this.svg = rootGroup;
        return svg;
      },

      _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
        if (!this.current.clipGroup) {
          var clipGroup = this.svgFactory.createElement('svg:g');
          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
          this.svg.appendChild(clipGroup);
          this.current.clipGroup = clipGroup;
        }
        return this.current.clipGroup;
      },
      _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
        if (!this.tgrp) {
          this.tgrp = this.svgFactory.createElement('svg:g');
          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));
          if (this.current.activeClipUrl) {
            this._ensureClipGroup().appendChild(this.tgrp);
          } else {
            this.svg.appendChild(this.tgrp);
          }
        }
        return this.tgrp;
      }
    };
    return SVGGraphics;
  }();
}
exports.SVGGraphics = SVGGraphics;

/***/ }),
/* 148 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFNodeStream = undefined;

var _regenerator = __w_pdfjs_require__(137);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(1);

var _network_utils = __w_pdfjs_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fs = __webpack_require__(365);
var http = __webpack_require__(366);
var https = __webpack_require__(367);
var url = __webpack_require__(368);

var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
function parseUrl(sourceUrl) {
  var parsedUrl = url.parse(sourceUrl);
  if (parsedUrl.protocol === 'file:' || parsedUrl.host) {
    return parsedUrl;
  }
  if (/^[a-z]:[/\\]/i.test(sourceUrl)) {
    return url.parse('file:///' + sourceUrl);
  }
  if (!parsedUrl.host) {
    parsedUrl.protocol = 'file:';
  }
  return parsedUrl;
}

var PDFNodeStream = function () {
  function PDFNodeStream(source) {
    _classCallCheck(this, PDFNodeStream);

    this.source = source;
    this.url = parseUrl(source.url);
    this.isHttp = this.url.protocol === 'http:' || this.url.protocol === 'https:';
    this.isFsUrl = this.url.protocol === 'file:';
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequest = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFNodeStream, [{
    key: 'getFullReader',
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequest);
      this._fullRequest = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
      return this._fullRequest;
    }
  }, {
    key: 'getRangeReader',
    value: function getRangeReader(start, end) {
      var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
      this._rangeRequestReaders.push(rangeReader);
      return rangeReader;
    }
  }, {
    key: 'cancelAllRequests',
    value: function cancelAllRequests(reason) {
      if (this._fullRequest) {
        this._fullRequest.cancel(reason);
      }
      var readers = this._rangeRequestReaders.slice(0);
      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }]);

  return PDFNodeStream;
}();

var BaseFullReader = function () {
  function BaseFullReader(stream) {
    _classCallCheck(this, BaseFullReader);

    this._url = stream.url;
    this._done = false;
    this._storedError = null;
    this.onProgress = null;
    var source = stream.source;
    this._contentLength = source.length;
    this._loaded = 0;
    this._filename = null;
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    this._readableStream = null;
    this._readCapability = (0, _util.createPromiseCapability)();
    this._headersCapability = (0, _util.createPromiseCapability)();
  }

  _createClass(BaseFullReader, [{
    key: 'read',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var chunk, buffer;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._readCapability.promise;

              case 2:
                if (!this._done) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return', {
                  value: undefined,
                  done: true
                });

              case 4:
                if (!this._storedError) {
                  _context.next = 6;
                  break;
                }

                throw this._storedError;

              case 6:
                chunk = this._readableStream.read();

                if (!(chunk === null)) {
                  _context.next = 10;
                  break;
                }

                this._readCapability = (0, _util.createPromiseCapability)();
                return _context.abrupt('return', this.read());

              case 10:
                this._loaded += chunk.length;
                if (this.onProgress) {
                  this.onProgress({
                    loaded: this._loaded,
                    total: this._contentLength
                  });
                }
                buffer = new Uint8Array(chunk).buffer;
                return _context.abrupt('return', {
                  value: buffer,
                  done: false
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _ref.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);
        return;
      }
      this._readableStream.destroy(reason);
    }
  }, {
    key: '_error',
    value: function _error(reason) {
      this._storedError = reason;
      this._readCapability.resolve();
    }
  }, {
    key: '_setReadableStream',
    value: function _setReadableStream(readableStream) {
      var _this = this;

      this._readableStream = readableStream;
      readableStream.on('readable', function () {
        _this._readCapability.resolve();
      });
      readableStream.on('end', function () {
        readableStream.destroy();
        _this._done = true;
        _this._readCapability.resolve();
      });
      readableStream.on('error', function (reason) {
        _this._error(reason);
      });
      if (!this._isStreamingSupported && this._isRangeSupported) {
        this._error(new _util.AbortException('streaming is disabled'));
      }
      if (this._storedError) {
        this._readableStream.destroy(this._storedError);
      }
    }
  }, {
    key: 'headersReady',
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: 'filename',
    get: function get() {
      return this._filename;
    }
  }, {
    key: 'contentLength',
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: 'isRangeSupported',
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return BaseFullReader;
}();

var BaseRangeReader = function () {
  function BaseRangeReader(stream) {
    _classCallCheck(this, BaseRangeReader);

    this._url = stream.url;
    this._done = false;
    this._storedError = null;
    this.onProgress = null;
    this._loaded = 0;
    this._readableStream = null;
    this._readCapability = (0, _util.createPromiseCapability)();
    var source = stream.source;
    this._isStreamingSupported = !source.disableStream;
  }

  _createClass(BaseRangeReader, [{
    key: 'read',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var chunk, buffer;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._readCapability.promise;

              case 2:
                if (!this._done) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return', {
                  value: undefined,
                  done: true
                });

              case 4:
                if (!this._storedError) {
                  _context2.next = 6;
                  break;
                }

                throw this._storedError;

              case 6:
                chunk = this._readableStream.read();

                if (!(chunk === null)) {
                  _context2.next = 10;
                  break;
                }

                this._readCapability = (0, _util.createPromiseCapability)();
                return _context2.abrupt('return', this.read());

              case 10:
                this._loaded += chunk.length;
                if (this.onProgress) {
                  this.onProgress({ loaded: this._loaded });
                }
                buffer = new Uint8Array(chunk).buffer;
                return _context2.abrupt('return', {
                  value: buffer,
                  done: false
                });

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read() {
        return _ref2.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);
        return;
      }
      this._readableStream.destroy(reason);
    }
  }, {
    key: '_error',
    value: function _error(reason) {
      this._storedError = reason;
      this._readCapability.resolve();
    }
  }, {
    key: '_setReadableStream',
    value: function _setReadableStream(readableStream) {
      var _this2 = this;

      this._readableStream = readableStream;
      readableStream.on('readable', function () {
        _this2._readCapability.resolve();
      });
      readableStream.on('end', function () {
        readableStream.destroy();
        _this2._done = true;
        _this2._readCapability.resolve();
      });
      readableStream.on('error', function (reason) {
        _this2._error(reason);
      });
      if (this._storedError) {
        this._readableStream.destroy(this._storedError);
      }
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return BaseRangeReader;
}();

function createRequestOptions(url, headers) {
  return {
    protocol: url.protocol,
    auth: url.auth,
    host: url.hostname,
    port: url.port,
    path: url.path,
    method: 'GET',
    headers: headers
  };
}

var PDFNodeStreamFullReader = function (_BaseFullReader) {
  _inherits(PDFNodeStreamFullReader, _BaseFullReader);

  function PDFNodeStreamFullReader(stream) {
    _classCallCheck(this, PDFNodeStreamFullReader);

    var _this3 = _possibleConstructorReturn(this, (PDFNodeStreamFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFullReader)).call(this, stream));

    var handleResponse = function handleResponse(response) {
      if (response.statusCode === 404) {
        var error = new _util.MissingPDFException('Missing PDF "' + _this3._url + '".');
        _this3._storedError = error;
        _this3._headersCapability.reject(error);
        return;
      }
      _this3._headersCapability.resolve();
      _this3._setReadableStream(response);
      var getResponseHeader = function getResponseHeader(name) {
        return _this3._readableStream.headers[name.toLowerCase()];
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: stream.isHttp,
        rangeChunkSize: _this3._rangeChunkSize,
        disableRange: _this3._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      _this3._isRangeSupported = allowRangeRequests;
      _this3._contentLength = suggestedLength || _this3._contentLength;
      _this3._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
    };
    _this3._request = null;
    if (_this3._url.protocol === 'http:') {
      _this3._request = http.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
    } else {
      _this3._request = https.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
    }
    _this3._request.on('error', function (reason) {
      _this3._storedError = reason;
      _this3._headersCapability.reject(reason);
    });
    _this3._request.end();
    return _this3;
  }

  return PDFNodeStreamFullReader;
}(BaseFullReader);

var PDFNodeStreamRangeReader = function (_BaseRangeReader) {
  _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);

  function PDFNodeStreamRangeReader(stream, start, end) {
    _classCallCheck(this, PDFNodeStreamRangeReader);

    var _this4 = _possibleConstructorReturn(this, (PDFNodeStreamRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamRangeReader)).call(this, stream));

    _this4._httpHeaders = {};
    for (var property in stream.httpHeaders) {
      var value = stream.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      _this4._httpHeaders[property] = value;
    }
    _this4._httpHeaders['Range'] = 'bytes=' + start + '-' + (end - 1);
    var handleResponse = function handleResponse(response) {
      if (response.statusCode === 404) {
        var error = new _util.MissingPDFException('Missing PDF "' + _this4._url + '".');
        _this4._storedError = error;
        return;
      }
      _this4._setReadableStream(response);
    };
    _this4._request = null;
    if (_this4._url.protocol === 'http:') {
      _this4._request = http.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
    } else {
      _this4._request = https.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
    }
    _this4._request.on('error', function (reason) {
      _this4._storedError = reason;
    });
    _this4._request.end();
    return _this4;
  }

  return PDFNodeStreamRangeReader;
}(BaseRangeReader);

var PDFNodeStreamFsFullReader = function (_BaseFullReader2) {
  _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);

  function PDFNodeStreamFsFullReader(stream) {
    _classCallCheck(this, PDFNodeStreamFsFullReader);

    var _this5 = _possibleConstructorReturn(this, (PDFNodeStreamFsFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsFullReader)).call(this, stream));

    var path = decodeURIComponent(_this5._url.path);
    if (fileUriRegex.test(_this5._url.href)) {
      path = path.replace(/^\//, '');
    }
    fs.lstat(path, function (error, stat) {
      if (error) {
        if (error.code === 'ENOENT') {
          error = new _util.MissingPDFException('Missing PDF "' + path + '".');
        }
        _this5._storedError = error;
        _this5._headersCapability.reject(error);
        return;
      }
      _this5._contentLength = stat.size;
      _this5._setReadableStream(fs.createReadStream(path));
      _this5._headersCapability.resolve();
    });
    return _this5;
  }

  return PDFNodeStreamFsFullReader;
}(BaseFullReader);

var PDFNodeStreamFsRangeReader = function (_BaseRangeReader2) {
  _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);

  function PDFNodeStreamFsRangeReader(stream, start, end) {
    _classCallCheck(this, PDFNodeStreamFsRangeReader);

    var _this6 = _possibleConstructorReturn(this, (PDFNodeStreamFsRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsRangeReader)).call(this, stream));

    var path = decodeURIComponent(_this6._url.path);
    if (fileUriRegex.test(_this6._url.href)) {
      path = path.replace(/^\//, '');
    }
    _this6._setReadableStream(fs.createReadStream(path, {
      start: start,
      end: end - 1
    }));
    return _this6;
  }

  return PDFNodeStreamFsRangeReader;
}(BaseRangeReader);

exports.PDFNodeStream = PDFNodeStream;

/***/ }),
/* 149 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateResponseStatus = exports.validateRangeRequestCapabilities = exports.extractFilenameFromHeader = exports.createResponseStatusError = undefined;

var _util = __w_pdfjs_require__(1);

var _content_disposition = __w_pdfjs_require__(150);

function validateRangeRequestCapabilities(_ref) {
  var getResponseHeader = _ref.getResponseHeader,
      isHttp = _ref.isHttp,
      rangeChunkSize = _ref.rangeChunkSize,
      disableRange = _ref.disableRange;

  (0, _util.assert)(rangeChunkSize > 0, 'Range chunk size must be larger than zero');
  var returnValues = {
    allowRangeRequests: false,
    suggestedLength: undefined
  };
  var length = parseInt(getResponseHeader('Content-Length'), 10);
  if (!Number.isInteger(length)) {
    return returnValues;
  }
  returnValues.suggestedLength = length;
  if (length <= 2 * rangeChunkSize) {
    return returnValues;
  }
  if (disableRange || !isHttp) {
    return returnValues;
  }
  if (getResponseHeader('Accept-Ranges') !== 'bytes') {
    return returnValues;
  }
  var contentEncoding = getResponseHeader('Content-Encoding') || 'identity';
  if (contentEncoding !== 'identity') {
    return returnValues;
  }
  returnValues.allowRangeRequests = true;
  return returnValues;
}
function extractFilenameFromHeader(getResponseHeader) {
  var contentDisposition = getResponseHeader('Content-Disposition');
  if (contentDisposition) {
    var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
    if (/\.pdf$/i.test(filename)) {
      return filename;
    }
  }
  return null;
}
function createResponseStatusError(status, url) {
  if (status === 404 || status === 0 && /^file:/.test(url)) {
    return new _util.MissingPDFException('Missing PDF "' + url + '".');
  }
  return new _util.UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status);
}
function validateResponseStatus(status) {
  return status === 200 || status === 206;
}
exports.createResponseStatusError = createResponseStatusError;
exports.extractFilenameFromHeader = extractFilenameFromHeader;
exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
exports.validateResponseStatus = validateResponseStatus;

/***/ }),
/* 150 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function getFilenameFromContentDispositionHeader(contentDisposition) {
  var needsEncodingFixup = true;
  var tmp = toParamRegExp('filename\\*', 'i').exec(contentDisposition);
  if (tmp) {
    tmp = tmp[1];
    var filename = rfc2616unquote(tmp);
    filename = unescape(filename);
    filename = rfc5987decode(filename);
    filename = rfc2047decode(filename);
    return fixupEncoding(filename);
  }
  tmp = rfc2231getparam(contentDisposition);
  if (tmp) {
    var _filename = rfc2047decode(tmp);
    return fixupEncoding(_filename);
  }
  tmp = toParamRegExp('filename', 'i').exec(contentDisposition);
  if (tmp) {
    tmp = tmp[1];
    var _filename2 = rfc2616unquote(tmp);
    _filename2 = rfc2047decode(_filename2);
    return fixupEncoding(_filename2);
  }
  function toParamRegExp(attributePattern, flags) {
    return new RegExp('(?:^|;)\\s*' + attributePattern + '\\s*=\\s*' + '(' + '[^";\\s][^;\\s]*' + '|' + '"(?:[^"\\\\]|\\\\"?)+"?' + ')', flags);
  }
  function textdecode(encoding, value) {
    if (encoding) {
      if (!/^[\x00-\xFF]+$/.test(value)) {
        return value;
      }
      try {
        var decoder = new TextDecoder(encoding, { fatal: true });
        var bytes = new Array(value.length);
        for (var i = 0; i < value.length; ++i) {
          bytes[i] = value.charCodeAt(i);
        }
        value = decoder.decode(new Uint8Array(bytes));
        needsEncodingFixup = false;
      } catch (e) {
        if (/^utf-?8$/i.test(encoding)) {
          try {
            value = decodeURIComponent(escape(value));
            needsEncodingFixup = false;
          } catch (err) {}
        }
      }
    }
    return value;
  }
  function fixupEncoding(value) {
    if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
      value = textdecode('utf-8', value);
      if (needsEncodingFixup) {
        value = textdecode('iso-8859-1', value);
      }
    }
    return value;
  }
  function rfc2231getparam(contentDisposition) {
    var matches = [],
        match = void 0;
    var iter = toParamRegExp('filename\\*((?!0\\d)\\d+)(\\*?)', 'ig');
    while ((match = iter.exec(contentDisposition)) !== null) {
      var _match = match,
          _match2 = _slicedToArray(_match, 4),
          n = _match2[1],
          quot = _match2[2],
          part = _match2[3];

      n = parseInt(n, 10);
      if (n in matches) {
        if (n === 0) {
          break;
        }
        continue;
      }
      matches[n] = [quot, part];
    }
    var parts = [];
    for (var _n = 0; _n < matches.length; ++_n) {
      if (!(_n in matches)) {
        break;
      }

      var _matches$_n = _slicedToArray(matches[_n], 2),
          _quot = _matches$_n[0],
          _part = _matches$_n[1];

      _part = rfc2616unquote(_part);
      if (_quot) {
        _part = unescape(_part);
        if (_n === 0) {
          _part = rfc5987decode(_part);
        }
      }
      parts.push(_part);
    }
    return parts.join('');
  }
  function rfc2616unquote(value) {
    if (value.charAt(0) === '"') {
      var parts = value.slice(1).split('\\"');
      for (var i = 0; i < parts.length; ++i) {
        var quotindex = parts[i].indexOf('"');
        if (quotindex !== -1) {
          parts[i] = parts[i].slice(0, quotindex);
          parts.length = i + 1;
        }
        parts[i] = parts[i].replace(/\\(.)/g, '$1');
      }
      value = parts.join('"');
    }
    return value;
  }
  function rfc5987decode(extvalue) {
    var encodingend = extvalue.indexOf('\'');
    if (encodingend === -1) {
      return extvalue;
    }
    var encoding = extvalue.slice(0, encodingend);
    var langvalue = extvalue.slice(encodingend + 1);
    var value = langvalue.replace(/^[^']*'/, '');
    return textdecode(encoding, value);
  }
  function rfc2047decode(value) {
    if (value.slice(0, 2) !== '=?' || /[\x00-\x19\x80-\xff]/.test(value)) {
      return value;
    }
    return value.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (_, charset, encoding, text) {
      if (encoding === 'q' || encoding === 'Q') {
        text = text.replace(/_/g, ' ');
        text = text.replace(/=([0-9a-fA-F]{2})/g, function (_, hex) {
          return String.fromCharCode(parseInt(hex, 16));
        });
        return textdecode(charset, text);
      }
      try {
        text = atob(text);
      } catch (e) {}
      return textdecode(charset, text);
    });
  }
  return '';
}
exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;

/***/ }),
/* 151 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFFetchStream = undefined;

var _regenerator = __w_pdfjs_require__(137);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(1);

var _network_utils = __w_pdfjs_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createFetchOptions(headers, withCredentials, abortController) {
  return {
    method: 'GET',
    headers: headers,
    signal: abortController && abortController.signal,
    mode: 'cors',
    credentials: withCredentials ? 'include' : 'same-origin',
    redirect: 'follow'
  };
}

var PDFFetchStream = function () {
  function PDFFetchStream(source) {
    _classCallCheck(this, PDFFetchStream);

    this.source = source;
    this.isHttp = /^https?:/i.test(source.url);
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFFetchStream, [{
    key: 'getFullReader',
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      this._fullRequestReader = new PDFFetchStreamReader(this);
      return this._fullRequestReader;
    }
  }, {
    key: 'getRangeReader',
    value: function getRangeReader(begin, end) {
      var reader = new PDFFetchStreamRangeReader(this, begin, end);
      this._rangeRequestReaders.push(reader);
      return reader;
    }
  }, {
    key: 'cancelAllRequests',
    value: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }
      var readers = this._rangeRequestReaders.slice(0);
      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }]);

  return PDFFetchStream;
}();

var PDFFetchStreamReader = function () {
  function PDFFetchStreamReader(stream) {
    var _this = this;

    _classCallCheck(this, PDFFetchStreamReader);

    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    this._filename = null;
    var source = stream.source;
    this._withCredentials = source.withCredentials;
    this._contentLength = source.length;
    this._headersCapability = (0, _util.createPromiseCapability)();
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    if (typeof AbortController !== 'undefined') {
      this._abortController = new AbortController();
    }
    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    this._headers = new Headers();
    for (var property in this._stream.httpHeaders) {
      var value = this._stream.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      this._headers.append(property, value);
    }
    var url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function (response) {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }
      _this._reader = response.body.getReader();
      _this._headersCapability.resolve();
      var getResponseHeader = function getResponseHeader(name) {
        return response.headers.get(name);
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: _this._stream.isHttp,
        rangeChunkSize: _this._rangeChunkSize,
        disableRange: _this._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      _this._isRangeSupported = allowRangeRequests;
      _this._contentLength = suggestedLength || _this._contentLength;
      _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
      if (!_this._isStreamingSupported && _this._isRangeSupported) {
        _this.cancel(new _util.AbortException('streaming is disabled'));
      }
    }).catch(this._headersCapability.reject);
    this.onProgress = null;
  }

  _createClass(PDFFetchStreamReader, [{
    key: 'read',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _ref2, value, done, buffer;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._headersCapability.promise;

              case 2:
                _context.next = 4;
                return this._reader.read();

              case 4:
                _ref2 = _context.sent;
                value = _ref2.value;
                done = _ref2.done;

                if (!done) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return', {
                  value: value,
                  done: done
                });

              case 9:
                this._loaded += value.byteLength;
                if (this.onProgress) {
                  this.onProgress({
                    loaded: this._loaded,
                    total: this._contentLength
                  });
                }
                buffer = new Uint8Array(value).buffer;
                return _context.abrupt('return', {
                  value: buffer,
                  done: false
                });

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _ref.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (this._reader) {
        this._reader.cancel(reason);
      }
      if (this._abortController) {
        this._abortController.abort();
      }
    }
  }, {
    key: 'headersReady',
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: 'filename',
    get: function get() {
      return this._filename;
    }
  }, {
    key: 'contentLength',
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: 'isRangeSupported',
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return PDFFetchStreamReader;
}();

var PDFFetchStreamRangeReader = function () {
  function PDFFetchStreamRangeReader(stream, begin, end) {
    var _this2 = this;

    _classCallCheck(this, PDFFetchStreamRangeReader);

    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    var source = stream.source;
    this._withCredentials = source.withCredentials;
    this._readCapability = (0, _util.createPromiseCapability)();
    this._isStreamingSupported = !source.disableStream;
    if (typeof AbortController !== 'undefined') {
      this._abortController = new AbortController();
    }
    this._headers = new Headers();
    for (var property in this._stream.httpHeaders) {
      var value = this._stream.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      this._headers.append(property, value);
    }
    var rangeStr = begin + '-' + (end - 1);
    this._headers.append('Range', 'bytes=' + rangeStr);
    var url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function (response) {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }
      _this2._readCapability.resolve();
      _this2._reader = response.body.getReader();
    });
    this.onProgress = null;
  }

  _createClass(PDFFetchStreamRangeReader, [{
    key: 'read',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var _ref4, value, done, buffer;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._readCapability.promise;

              case 2:
                _context2.next = 4;
                return this._reader.read();

              case 4:
                _ref4 = _context2.sent;
                value = _ref4.value;
                done = _ref4.done;

                if (!done) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt('return', {
                  value: value,
                  done: done
                });

              case 9:
                this._loaded += value.byteLength;
                if (this.onProgress) {
                  this.onProgress({ loaded: this._loaded });
                }
                buffer = new Uint8Array(value).buffer;
                return _context2.abrupt('return', {
                  value: buffer,
                  done: false
                });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read() {
        return _ref3.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (this._reader) {
        this._reader.cancel(reason);
      }
      if (this._abortController) {
        this._abortController.abort();
      }
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return PDFFetchStreamRangeReader;
}();

exports.PDFFetchStream = PDFFetchStream;

/***/ }),
/* 152 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetworkManager = exports.PDFNetworkStream = undefined;

var _regenerator = __w_pdfjs_require__(137);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _util = __w_pdfjs_require__(1);

var _network_utils = __w_pdfjs_require__(149);

var _global_scope = __w_pdfjs_require__(3);

var _global_scope2 = _interopRequireDefault(_global_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

;
var OK_RESPONSE = 200;
var PARTIAL_CONTENT_RESPONSE = 206;
function NetworkManager(url, args) {
  this.url = url;
  args = args || {};
  this.isHttp = /^https?:/i.test(url);
  this.httpHeaders = this.isHttp && args.httpHeaders || {};
  this.withCredentials = args.withCredentials || false;
  this.getXhr = args.getXhr || function NetworkManager_getXhr() {
    return new XMLHttpRequest();
  };
  this.currXhrId = 0;
  this.pendingRequests = Object.create(null);
  this.loadedRequests = Object.create(null);
}
function getArrayBuffer(xhr) {
  var data = xhr.response;
  if (typeof data !== 'string') {
    return data;
  }
  var array = (0, _util.stringToBytes)(data);
  return array.buffer;
}
var supportsMozChunked = function supportsMozChunkedClosure() {
  try {
    var x = new XMLHttpRequest();
    x.open('GET', _global_scope2.default.location.href);
    x.responseType = 'moz-chunked-arraybuffer';
    return x.responseType === 'moz-chunked-arraybuffer';
  } catch (e) {
    return false;
  }
}();
NetworkManager.prototype = {
  requestRange: function NetworkManager_requestRange(begin, end, listeners) {
    var args = {
      begin: begin,
      end: end
    };
    for (var prop in listeners) {
      args[prop] = listeners[prop];
    }
    return this.request(args);
  },
  requestFull: function NetworkManager_requestFull(listeners) {
    return this.request(listeners);
  },
  request: function NetworkManager_request(args) {
    var xhr = this.getXhr();
    var xhrId = this.currXhrId++;
    var pendingRequest = this.pendingRequests[xhrId] = { xhr: xhr };
    xhr.open('GET', this.url);
    xhr.withCredentials = this.withCredentials;
    for (var property in this.httpHeaders) {
      var value = this.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      xhr.setRequestHeader(property, value);
    }
    if (this.isHttp && 'begin' in args && 'end' in args) {
      var rangeStr = args.begin + '-' + (args.end - 1);
      xhr.setRequestHeader('Range', 'bytes=' + rangeStr);
      pendingRequest.expectedStatus = 206;
    } else {
      pendingRequest.expectedStatus = 200;
    }
    var useMozChunkedLoading = supportsMozChunked && !!args.onProgressiveData;
    if (useMozChunkedLoading) {
      xhr.responseType = 'moz-chunked-arraybuffer';
      pendingRequest.onProgressiveData = args.onProgressiveData;
      pendingRequest.mozChunked = true;
    } else {
      xhr.responseType = 'arraybuffer';
    }
    if (args.onError) {
      xhr.onerror = function (evt) {
        args.onError(xhr.status);
      };
    }
    xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
    xhr.onprogress = this.onProgress.bind(this, xhrId);
    pendingRequest.onHeadersReceived = args.onHeadersReceived;
    pendingRequest.onDone = args.onDone;
    pendingRequest.onError = args.onError;
    pendingRequest.onProgress = args.onProgress;
    xhr.send(null);
    return xhrId;
  },
  onProgress: function NetworkManager_onProgress(xhrId, evt) {
    var pendingRequest = this.pendingRequests[xhrId];
    if (!pendingRequest) {
      return;
    }
    if (pendingRequest.mozChunked) {
      var chunk = getArrayBuffer(pendingRequest.xhr);
      pendingRequest.onProgressiveData(chunk);
    }
    var onProgress = pendingRequest.onProgress;
    if (onProgress) {
      onProgress(evt);
    }
  },
  onStateChange: function NetworkManager_onStateChange(xhrId, evt) {
    var pendingRequest = this.pendingRequests[xhrId];
    if (!pendingRequest) {
      return;
    }
    var xhr = pendingRequest.xhr;
    if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
      pendingRequest.onHeadersReceived();
      delete pendingRequest.onHeadersReceived;
    }
    if (xhr.readyState !== 4) {
      return;
    }
    if (!(xhrId in this.pendingRequests)) {
      return;
    }
    delete this.pendingRequests[xhrId];
    if (xhr.status === 0 && this.isHttp) {
      if (pendingRequest.onError) {
        pendingRequest.onError(xhr.status);
      }
      return;
    }
    var xhrStatus = xhr.status || OK_RESPONSE;
    var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
    if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
      if (pendingRequest.onError) {
        pendingRequest.onError(xhr.status);
      }
      return;
    }
    this.loadedRequests[xhrId] = true;
    var chunk = getArrayBuffer(xhr);
    if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
      var rangeHeader = xhr.getResponseHeader('Content-Range');
      var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
      var begin = parseInt(matches[1], 10);
      pendingRequest.onDone({
        begin: begin,
        chunk: chunk
      });
    } else if (pendingRequest.onProgressiveData) {
      pendingRequest.onDone(null);
    } else if (chunk) {
      pendingRequest.onDone({
        begin: 0,
        chunk: chunk
      });
    } else if (pendingRequest.onError) {
      pendingRequest.onError(xhr.status);
    }
  },
  hasPendingRequests: function NetworkManager_hasPendingRequests() {
    for (var xhrId in this.pendingRequests) {
      return true;
    }
    return false;
  },
  getRequestXhr: function NetworkManager_getXhr(xhrId) {
    return this.pendingRequests[xhrId].xhr;
  },
  isStreamingRequest: function NetworkManager_isStreamingRequest(xhrId) {
    return !!this.pendingRequests[xhrId].onProgressiveData;
  },
  isPendingRequest: function NetworkManager_isPendingRequest(xhrId) {
    return xhrId in this.pendingRequests;
  },
  isLoadedRequest: function NetworkManager_isLoadedRequest(xhrId) {
    return xhrId in this.loadedRequests;
  },
  abortAllRequests: function NetworkManager_abortAllRequests() {
    for (var xhrId in this.pendingRequests) {
      this.abortRequest(xhrId | 0);
    }
  },
  abortRequest: function NetworkManager_abortRequest(xhrId) {
    var xhr = this.pendingRequests[xhrId].xhr;
    delete this.pendingRequests[xhrId];
    xhr.abort();
  }
};
function PDFNetworkStream(source) {
  this._source = source;
  this._manager = new NetworkManager(source.url, {
    httpHeaders: source.httpHeaders,
    withCredentials: source.withCredentials
  });
  this._rangeChunkSize = source.rangeChunkSize;
  this._fullRequestReader = null;
  this._rangeRequestReaders = [];
}
PDFNetworkStream.prototype = {
  _onRangeRequestReaderClosed: function PDFNetworkStream_onRangeRequestReaderClosed(reader) {
    var i = this._rangeRequestReaders.indexOf(reader);
    if (i >= 0) {
      this._rangeRequestReaders.splice(i, 1);
    }
  },
  getFullReader: function PDFNetworkStream_getFullReader() {
    (0, _util.assert)(!this._fullRequestReader);
    this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
    return this._fullRequestReader;
  },
  getRangeReader: function PDFNetworkStream_getRangeReader(begin, end) {
    var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
    reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
    this._rangeRequestReaders.push(reader);
    return reader;
  },
  cancelAllRequests: function PDFNetworkStream_cancelAllRequests(reason) {
    if (this._fullRequestReader) {
      this._fullRequestReader.cancel(reason);
    }
    var readers = this._rangeRequestReaders.slice(0);
    readers.forEach(function (reader) {
      reader.cancel(reason);
    });
  }
};
function PDFNetworkStreamFullRequestReader(manager, source) {
  this._manager = manager;
  var args = {
    onHeadersReceived: this._onHeadersReceived.bind(this),
    onProgressiveData: source.disableStream ? null : this._onProgressiveData.bind(this),
    onDone: this._onDone.bind(this),
    onError: this._onError.bind(this),
    onProgress: this._onProgress.bind(this)
  };
  this._url = source.url;
  this._fullRequestId = manager.requestFull(args);
  this._headersReceivedCapability = (0, _util.createPromiseCapability)();
  this._disableRange = source.disableRange || false;
  this._contentLength = source.length;
  this._rangeChunkSize = source.rangeChunkSize;
  if (!this._rangeChunkSize && !this._disableRange) {
    this._disableRange = true;
  }
  this._isStreamingSupported = false;
  this._isRangeSupported = false;
  this._cachedChunks = [];
  this._requests = [];
  this._done = false;
  this._storedError = undefined;
  this._filename = null;
  this.onProgress = null;
}
PDFNetworkStreamFullRequestReader.prototype = {
  _onHeadersReceived: function PDFNetworkStreamFullRequestReader_onHeadersReceived() {
    var fullRequestXhrId = this._fullRequestId;
    var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
    var getResponseHeader = function getResponseHeader(name) {
      return fullRequestXhr.getResponseHeader(name);
    };

    var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
      getResponseHeader: getResponseHeader,
      isHttp: this._manager.isHttp,
      rangeChunkSize: this._rangeChunkSize,
      disableRange: this._disableRange
    }),
        allowRangeRequests = _validateRangeRequest.allowRangeRequests,
        suggestedLength = _validateRangeRequest.suggestedLength;

    if (allowRangeRequests) {
      this._isRangeSupported = true;
    }
    this._contentLength = suggestedLength || this._contentLength;
    this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
    var networkManager = this._manager;
    if (networkManager.isStreamingRequest(fullRequestXhrId)) {
      this._isStreamingSupported = true;
    } else if (this._isRangeSupported) {
      networkManager.abortRequest(fullRequestXhrId);
    }
    this._headersReceivedCapability.resolve();
  },
  _onProgressiveData: function PDFNetworkStreamFullRequestReader_onProgressiveData(chunk) {
    if (this._requests.length > 0) {
      var requestCapability = this._requests.shift();
      requestCapability.resolve({
        value: chunk,
        done: false
      });
    } else {
      this._cachedChunks.push(chunk);
    }
  },
  _onDone: function PDFNetworkStreamFullRequestReader_onDone(args) {
    if (args) {
      this._onProgressiveData(args.chunk);
    }
    this._done = true;
    if (this._cachedChunks.length > 0) {
      return;
    }
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
  },
  _onError: function PDFNetworkStreamFullRequestReader_onError(status) {
    var url = this._url;
    var exception = (0, _network_utils.createResponseStatusError)(status, url);
    this._storedError = exception;
    this._headersReceivedCapability.reject(exception);
    this._requests.forEach(function (requestCapability) {
      requestCapability.reject(exception);
    });
    this._requests = [];
    this._cachedChunks = [];
  },
  _onProgress: function PDFNetworkStreamFullRequestReader_onProgress(data) {
    if (this.onProgress) {
      this.onProgress({
        loaded: data.loaded,
        total: data.lengthComputable ? data.total : this._contentLength
      });
    }
  },
  get filename() {
    return this._filename;
  },
  get isRangeSupported() {
    return this._isRangeSupported;
  },
  get isStreamingSupported() {
    return this._isStreamingSupported;
  },
  get contentLength() {
    return this._contentLength;
  },
  get headersReady() {
    return this._headersReceivedCapability.promise;
  },
  read: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var chunk, requestCapability;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this._storedError) {
                _context.next = 2;
                break;
              }

              throw this._storedError;

            case 2:
              if (!(this._cachedChunks.length > 0)) {
                _context.next = 5;
                break;
              }

              chunk = this._cachedChunks.shift();
              return _context.abrupt('return', {
                value: chunk,
                done: false
              });

            case 5:
              if (!this._done) {
                _context.next = 7;
                break;
              }

              return _context.abrupt('return', {
                value: undefined,
                done: true
              });

            case 7:
              requestCapability = (0, _util.createPromiseCapability)();

              this._requests.push(requestCapability);
              return _context.abrupt('return', requestCapability.promise);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function read() {
      return _ref.apply(this, arguments);
    }

    return read;
  }(),

  cancel: function PDFNetworkStreamFullRequestReader_cancel(reason) {
    this._done = true;
    this._headersReceivedCapability.reject(reason);
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    if (this._manager.isPendingRequest(this._fullRequestId)) {
      this._manager.abortRequest(this._fullRequestId);
    }
    this._fullRequestReader = null;
  }
};
function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
  this._manager = manager;
  var args = {
    onDone: this._onDone.bind(this),
    onProgress: this._onProgress.bind(this)
  };
  this._requestId = manager.requestRange(begin, end, args);
  this._requests = [];
  this._queuedChunk = null;
  this._done = false;
  this.onProgress = null;
  this.onClosed = null;
}
PDFNetworkStreamRangeRequestReader.prototype = {
  _close: function PDFNetworkStreamRangeRequestReader_close() {
    if (this.onClosed) {
      this.onClosed(this);
    }
  },
  _onDone: function PDFNetworkStreamRangeRequestReader_onDone(data) {
    var chunk = data.chunk;
    if (this._requests.length > 0) {
      var requestCapability = this._requests.shift();
      requestCapability.resolve({
        value: chunk,
        done: false
      });
    } else {
      this._queuedChunk = chunk;
    }
    this._done = true;
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    this._close();
  },
  _onProgress: function PDFNetworkStreamRangeRequestReader_onProgress(evt) {
    if (!this.isStreamingSupported && this.onProgress) {
      this.onProgress({ loaded: evt.loaded });
    }
  },
  get isStreamingSupported() {
    return false;
  },
  read: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var chunk, requestCapability;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this._queuedChunk !== null)) {
                _context2.next = 4;
                break;
              }

              chunk = this._queuedChunk;

              this._queuedChunk = null;
              return _context2.abrupt('return', {
                value: chunk,
                done: false
              });

            case 4:
              if (!this._done) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt('return', {
                value: undefined,
                done: true
              });

            case 6:
              requestCapability = (0, _util.createPromiseCapability)();

              this._requests.push(requestCapability);
              return _context2.abrupt('return', requestCapability.promise);

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function read() {
      return _ref2.apply(this, arguments);
    }

    return read;
  }(),

  cancel: function PDFNetworkStreamRangeRequestReader_cancel(reason) {
    this._done = true;
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    if (this._manager.isPendingRequest(this._requestId)) {
      this._manager.abortRequest(this._requestId);
    }
    this._close();
  }
};
exports.PDFNetworkStream = PDFNetworkStream;
exports.NetworkManager = NetworkManager;

/***/ })
/******/ ]);
});
//# sourceMappingURL=pdf.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(228).Buffer, __webpack_require__(8), __webpack_require__(30)))

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 362 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 363 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 364 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 365 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 366 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 367 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(369);
var util = __webpack_require__(370);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(371);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)(module), __webpack_require__(8)))

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(372);
exports.encode = exports.stringify = __webpack_require__(373);


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "a0a835e0f295c25fce33.worker.js");
};

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"testt22"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],attrs:{"type":"text","autofocus":""},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Nombre completo ?")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.direccion),expression:"direccion"}],attrs:{"type":"text","autofocus":""},domProps:{"value":(_vm.direccion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.direccion=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Dirección")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movil),expression:"movil"}],attrs:{"type":"text","autofocus":""},domProps:{"value":(_vm.movil)},on:{"input":function($event){if($event.target.composing){ return; }_vm.movil=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("# Tel. Móvil")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","autofocus":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("E-mail")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.edad),expression:"edad"}],attrs:{"type":"number","autofocus":""},domProps:{"value":(_vm.edad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.edad=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Edad")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s2"},[_c('span',[_vm._v("Sexo")]),_c('br'),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sexo),expression:"sexo"}],attrs:{"value":"M","name":"group1","type":"radio","checked":""},domProps:{"checked":_vm._q(_vm.sexo,"M")},on:{"change":function($event){_vm.sexo="M"}}}),_vm._v(" "),_c('span',[_vm._v("(a) Masculino")]),_c('br')])]),_vm._v(" "),_c('a',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sexo),expression:"sexo"}],attrs:{"value":"F","name":"group1","type":"radio"},domProps:{"checked":_vm._q(_vm.sexo,"F")},on:{"change":function($event){_vm.sexo="F"}}}),_vm._v(" "),_c('span',[_vm._v("(b) Femenino")])])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ecivil),expression:"ecivil"}],staticStyle:{"width":"30em"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ecivil=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Seleccione una opcion")]),_vm._v(" "),_vm._l((_vm.estadocivil),function(item){return _c('option',{domProps:{"value":item}},[_vm._v("\n                                        "+_vm._s(item)+"\n                                   ")])})],2),_vm._v(" "),_c('label',[_vm._v("Estado Civil: "+_vm._s(_vm.ecivil))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.profesion),expression:"profesion"}],staticStyle:{"width":"30em"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.profesion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Seleccione una opcion")]),_vm._v(" "),_vm._l((_vm.profesiones),function(item){return _c('option',{domProps:{"value":item}},[_vm._v("\n                                        "+_vm._s(item)+"\n                                   ")])})],2),_vm._v(" "),_c('label',[_vm._v("Profesión: "+_vm._s(_vm.profesion))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.puesto),expression:"puesto"}],staticStyle:{"width":"30em"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.puesto=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Seleccione una opcion")]),_vm._v(" "),_vm._l((_vm.puestos),function(item){return _c('option',{domProps:{"value":item}},[_vm._v("\n                                        "+_vm._s(item)+"\n                                   ")])})],2),_vm._v(" "),_c('label',[_vm._v("Puesto al que aplica: "+_vm._s(_vm.puesto))])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('span',[_vm._v("Foto:")]),_vm._v(" "),_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileSelectedF}}),_c('br')]),_vm._v(" "),_c('div',{staticClass:"input-field col s6"},[_c('span',[_vm._v("CV:")]),_vm._v(" "),_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileSelected}}),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col s12 card-action center"},[_c('button',{staticClass:"btn waves-effect waves-light btn-small green tooltipped",attrs:{"data-position":"top","data-tooltip":"Grabar Participante"},on:{"click":_vm.agregaCV}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"testt23"}},[_c('table',{staticClass:"responsive-table striped hoverable"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.filtrarCVs),function(cv,index){return _c('tr',[_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(cv.nombre))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(cv.email))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_vm._v(_vm._s(cv.movil))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_c('a',{staticClass:"btn btn-small darken-1 yellow tooltipped",attrs:{"data-position":"top","data-tooltip":"Ver Foto"},on:{"click":function($event){_vm.verPDF(cv.ccv, cv.urlcv)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("picture_as_pdf")])]),_vm._v("\n                                        "+_vm._s(cv.ccv)+"\n                                   ")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_c('a',{staticClass:"btn btn-small darken-1 blue tooltipped",attrs:{"data-position":"top","data-tooltip":"Ver Foto"},on:{"click":function($event){_vm.verFoto(cv.cfoto, cv.urlfoto)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("remove_red_eye")])]),_vm._v("\n                                        "+_vm._s(cv.cfoto)+"\n                                   ")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px 5px"}},[_c('a',{staticClass:"btn btn-small darken-1 red tooltipped",attrs:{"data-position":"top","data-tooltip":"Eliminar"},on:{"click":function($event){_vm.deleteCV(cv.nombre,cv.llave)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])])}))]),_vm._v(" "),_c('div',{staticClass:"row hoverable"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"col s5"},[_c('span',[_vm._v("Foto")]),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"width":"200px"},attrs:{"src":this.currFotoT,"alt":"Avatar"}})]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.page),expression:"page",modifiers:{"number":true}}],staticStyle:{"width":"5em"},attrs:{"type":"number"},domProps:{"value":(_vm.page)},on:{"input":function($event){if($event.target.composing){ return; }_vm.page=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" /"+_vm._s(_vm.numPages)+"\n                                   "),_c('button',{on:{"click":function($event){_vm.rotate += 90}}},[_vm._v("⟳")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.rotate -= 90}}},[_vm._v("⟲")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.$refs.pdf.print()}}},[_vm._v("print")]),_vm._v(" "),_c('div',{staticStyle:{"width":"120%"}},[(_vm.loadedRatio > 0 && _vm.loadedRatio < 1)?_c('div',{staticStyle:{"background-color":"green","color":"white","text-align":"center"},style:({ width: _vm.loadedRatio * 100 + '%' })},[_vm._v(_vm._s(Math.floor(_vm.loadedRatio * 100))+"%")]):_vm._e(),_vm._v(" "),(_vm.show)?_c('pdf',{ref:"pdf",staticStyle:{"border":"1px solid red"},attrs:{"src":_vm.src,"page":_vm.page,"rotate":_vm.rotate},on:{"password":_vm.password,"progress":function($event){_vm.loadedRatio = $event},"error":_vm.error,"num-pages":function($event){_vm.numPages = $event},"link-clicked":function($event){_vm.page = $event}}}):_vm._e()],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s5"}),_vm._v(" "),(_vm.mostrarCargador)?_c('div',{staticClass:"col s2"},[_c('button',[_vm._v("Espere un momento por favor ... "+_vm._s(_vm.elporcentaje)+"%")]),_c('br'),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.exito)?_c('div',[_c('h5',[_vm._v("Datos grabados con éxito")]),_vm._v(" "),_c('div',{staticClass:"card-action center"},[_c('button',{staticClass:"btn waves-effect waves-light btn-small green tooltipped",attrs:{"data-position":"top","data-tooltip":"Limpiar"},on:{"click":_vm.limpiar}},[_c('i',{staticClass:"material-icons"},[_vm._v("cached")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col s5"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"tab col s6"},[_c('a',{staticClass:"active",attrs:{"href":"#testt22"}},[_vm._v("Aplicar")])]),_vm._v(" "),_c('li',{staticClass:"tab col s6"},[_c('a',{staticClass:"teal-text teal-background",attrs:{"href":"#testt23"}},[_vm._v("Consultas")])]),_vm._v(" "),_c('div',{staticClass:"indicator indigo darken-4",staticStyle:{"z-index":"1"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Nombre")]),_vm._v(" "),_c('th',[_vm._v("email")]),_vm._v(" "),_c('th',[_vm._v("Móvil")]),_vm._v(" "),_c('th',[_vm._v("CV")]),_vm._v(" "),_c('th',[_vm._v("Foto")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-cube-grid"},[_c('div',{staticClass:"sk-cube sk-cube1"}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube2"}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube3"}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube4"}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube5"}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube6"}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube7"}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube8"}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube9"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev_consultas_js__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc27114_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev_consultas_vue__ = __webpack_require__(377);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ev_consultas_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc27114_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ev_consultas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s4"},[_c('label',[_vm._v("Filtrar las evaluaciones por Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],attrs:{"type":"text"},domProps:{"value":(_vm.busqueda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col s4"},[_c('label',[_vm._v("Filtrar las evaluaciones por Participante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busquedaR),expression:"busquedaR"}],attrs:{"type":"text"},domProps:{"value":(_vm.busquedaR)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busquedaR=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col s4"},[_c('label',[_vm._v("Filtrar las evaluaciones por Instrumento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busquedaI),expression:"busquedaI"}],attrs:{"type":"text"},domProps:{"value":(_vm.busquedaI)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busquedaI=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('table',{staticClass:"responsive-table striped hoverable"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.filtrarEvaluaciones),function(laevaluacion,index){return (index>=_vm.lc_ini && index <=_vm.limite-1)?_c('tr',[_c('td',[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(laevaluacion.fecha))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(laevaluacion.empezo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(laevaluacion.termino))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(laevaluacion.empresa))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(laevaluacion.nombre))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-small darken-1 blue",on:{"click":function($event){_vm.mostrarEvaluacion(laevaluacion)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("remove_red_eye")]),_vm._v(" "+_vm._s(laevaluacion.steval)+"\n                               ")])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(laevaluacion.steval==='AEDP'),expression:"laevaluacion.steval==='AEDP'"}]},[(_vm.json_data.length>0)?_c('div',[_c('download-excel',{staticClass:"btn btn-default",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"meta":_vm.json_meta,"worksheet":"My Worksheet","name":"pruebaexcel.xls"}},[_vm._v("\n                                    A EXCEL\n                               ")])],1):_c('div',[_vm._v("\n                                  EXCEL PENDIENTE. OBTENGA RESULTADOS !\n                             ")])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-small darken-1 red tooltipped",attrs:{"data-position":"top","data-tooltip":"Eliminar Evaluación"},on:{"click":function($event){_vm.eliminarEvaluacion(laevaluacion,laevaluacion.llave)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()}))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Fecha")]),_vm._v(" "),_c('th',[_vm._v("Inició")]),_vm._v(" "),_c('th',[_vm._v("Terminó")]),_vm._v(" "),_c('th',[_vm._v("Empresa")]),_vm._v(" "),_c('th',[_vm._v("Participante")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreetViewPanorama = exports.MountableMixin = exports.Autocomplete = exports.MapElementFactory = exports.MapElementMixin = exports.PlaceInput = exports.Map = exports.InfoWindow = exports.Rectangle = exports.Cluster = exports.Circle = exports.Polygon = exports.Polyline = exports.Marker = exports.loadGmapApi = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Vue component imports


exports.install = install;
exports.gmapApi = gmapApi;

var _lazyValue = __webpack_require__(380);

var _lazyValue2 = _interopRequireDefault(_lazyValue);

var _manager = __webpack_require__(381);

var _marker = __webpack_require__(382);

var _marker2 = _interopRequireDefault(_marker);

var _polyline = __webpack_require__(383);

var _polyline2 = _interopRequireDefault(_polyline);

var _polygon = __webpack_require__(384);

var _polygon2 = _interopRequireDefault(_polygon);

var _circle = __webpack_require__(385);

var _circle2 = _interopRequireDefault(_circle);

var _rectangle = __webpack_require__(386);

var _rectangle2 = _interopRequireDefault(_rectangle);

var _infoWindow = __webpack_require__(387);

var _infoWindow2 = _interopRequireDefault(_infoWindow);

var _map = __webpack_require__(390);

var _map2 = _interopRequireDefault(_map);

var _streetViewPanorama = __webpack_require__(395);

var _streetViewPanorama2 = _interopRequireDefault(_streetViewPanorama);

var _placeInput = __webpack_require__(400);

var _placeInput2 = _interopRequireDefault(_placeInput);

var _autocomplete = __webpack_require__(402);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _mapElementMixin = __webpack_require__(220);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _mapElementFactory = __webpack_require__(9);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

var _mountableMixin = __webpack_require__(55);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// HACK: Cluster should be loaded conditionally
// However in the web version, it's not possible to write
// `import 'vue2-google-maps/src/components/cluster'`, so we need to
// import it anyway (but we don't have to register it)
// Therefore we use babel-plugin-transform-inline-environment-variables to
// set BUILD_DEV to truthy / falsy
var Cluster = undefined;

var GmapApi = null;

// export everything
exports.loadGmapApi = _manager.loadGmapApi;
exports.Marker = _marker2.default;
exports.Polyline = _polyline2.default;
exports.Polygon = _polygon2.default;
exports.Circle = _circle2.default;
exports.Cluster = Cluster;
exports.Rectangle = _rectangle2.default;
exports.InfoWindow = _infoWindow2.default;
exports.Map = _map2.default;
exports.PlaceInput = _placeInput2.default;
exports.MapElementMixin = _mapElementMixin2.default;
exports.MapElementFactory = _mapElementFactory2.default;
exports.Autocomplete = _autocomplete2.default;
exports.MountableMixin = _mountableMixin2.default;
exports.StreetViewPanorama = _streetViewPanorama2.default;
function install(Vue, options) {
  // Set defaults
  options = _extends({
    installComponents: true,
    autobindAllEvents: false
  }, options);

  // Update the global `GmapApi`. This will allow
  // components to use the `google` global reactively
  // via:
  //   import {gmapApi} from 'vue2-google-maps'
  //   export default {  computed: { google: gmapApi }  }
  GmapApi = new Vue({ data: { gmapApi: null } });

  var defaultResizeBus = new Vue();

  // Use a lazy to only load the API when
  // a VGM component is loaded
  var gmapApiPromiseLazy = makeGmapApiPromiseLazy(options);

  Vue.mixin({
    created: function created() {
      this.$gmapDefaultResizeBus = defaultResizeBus;
      this.$gmapOptions = options;
      this.$gmapApiPromiseLazy = gmapApiPromiseLazy;
    }
  });
  Vue.$gmapDefaultResizeBus = defaultResizeBus;
  Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy;

  if (options.installComponents) {
    Vue.component('GmapMap', _map2.default);
    Vue.component('GmapMarker', _marker2.default);
    Vue.component('GmapInfoWindow', _infoWindow2.default);
    Vue.component('GmapPolyline', _polyline2.default);
    Vue.component('GmapPolygon', _polygon2.default);
    Vue.component('GmapCircle', _circle2.default);
    Vue.component('GmapRectangle', _rectangle2.default);
    Vue.component('GmapAutocomplete', _autocomplete2.default);
    Vue.component('GmapPlaceInput', _placeInput2.default);
    Vue.component('GmapStreetViewPanorama', _streetViewPanorama2.default);
  }
}

function makeGmapApiPromiseLazy(options) {
  // Things to do once the API is loaded
  function onApiLoaded() {
    GmapApi.gmapApi = {};
    return window.google;
  }

  if (options.load) {
    // If library should load the API
    return (0, _lazyValue2.default)(function () {
      // Load the
      // This will only be evaluated once
      if (typeof window === 'undefined') {
        // server side -- never resolve this promise
        return new Promise(function () {}).then(onApiLoaded);
      } else {
        return new Promise(function (resolve, reject) {
          try {
            window['vueGoogleMapsInit'] = resolve;
            (0, _manager.loadGmapApi)(options.load, options.loadCn);
          } catch (err) {
            reject(err);
          }
        }).then(onApiLoaded);
      }
    });
  } else {
    // If library should not handle API, provide
    // end-users with the global `vueGoogleMapsInit: () => undefined`
    // when the Google Maps API has been loaded
    var promise = new Promise(function (resolve) {
      if (typeof window === 'undefined') {
        // Do nothing if run from server-side
        return;
      }
      window['vueGoogleMapsInit'] = resolve;
    }).then(onApiLoaded);

    return (0, _lazyValue2.default)(function () {
      return promise;
    });
  }
}

function gmapApi() {
  return GmapApi.gmapApi && window.google;
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by sindresorhus and can be seen here
// https://github.com/sindresorhus/lazy-value/blob/master/index.js

exports.default = function (fn) {
  var called = false;
  var ret = void 0;

  return function () {
    if (!called) {
      called = true;
      ret = fn();
    }

    return ret;
  };
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isApiSetUp = false;

/**
 * @param apiKey    API Key, or object with the URL parameters. For example
 *                  to use Google Maps Premium API, pass
 *                    `{ client: <YOUR-CLIENT-ID> }`.
 *                  You may pass the libraries and/or version (as `v`) parameter into
 *                  this parameter and skip the next two parameters
 * @param version   Google for Maps version
 * @param libraries Libraries to load (@see
 *                  https://developers.google.com/maps/documentation/javascript/libraries)
 * @param loadCn    Boolean. If set to true, the map will be loaded form goole maps China
 *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
 *
 * Example:
 * ```
 *      import {load} from 'vue-google-maps'
 *
 *      load(<YOUR-API-KEY>)
 *
 *      load({
 *              key: <YOUR-API-KEY>,
 *      })
 *
 *      load({
 *              client: <YOUR-CLIENT-ID>,
 *              channel: <YOUR CHANNEL>
 *      })
 * ```
 */
var loadGmapApi = exports.loadGmapApi = function (options, loadCn) {
  if (typeof document === 'undefined') {
    // Do nothing if run from server-side
    return;
  }
  if (!isApiSetUp) {
    isApiSetUp = true;

    var googleMapScript = document.createElement('SCRIPT');

    // Allow options to be an object.
    // This is to support more esoteric means of loading Google Maps,
    // such as Google for business
    // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      throw new Error('options should  be an object');
    }

    // libraries
    if (Array.prototype.isPrototypeOf(options.libraries)) {
      options.libraries = options.libraries.join(',');
    }
    options['callback'] = 'vueGoogleMapsInit';

    var baseUrl = 'https://maps.googleapis.com/';

    if (typeof loadCn === 'boolean' && loadCn === true) {
      baseUrl = 'http://maps.google.cn/';
    }

    var url = baseUrl + 'maps/api/js?' + Object.keys(options).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(options[key]);
    }).join('&');

    googleMapScript.setAttribute('src', url);
    googleMapScript.setAttribute('async', '');
    googleMapScript.setAttribute('defer', '');
    document.head.appendChild(googleMapScript);
  } else {
    throw new Error('You already started the loading of google maps');
  }
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(9);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  animation: {
    twoWay: true,
    type: Number
  },
  attribution: {
    type: Object
  },
  clickable: {
    type: Boolean,
    twoWay: true,
    default: true
  },
  cursor: {
    type: String,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    twoWay: true,
    default: false
  },
  icon: {
    twoWay: true
  },
  label: {},
  opacity: {
    type: Number,
    default: 1
  },
  options: {
    type: Object
  },
  place: {
    type: Object
  },
  position: {
    type: Object,
    twoWay: true
  },
  shape: {
    type: Object,
    twoWay: true
  },
  title: {
    type: String,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  },
  visible: {
    twoWay: true,
    default: true
  }
};

var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];

/**
 * @class Marker
 *
 * Marker class with extra support for
 *
 * - Embedded info windows
 * - Clustered markers
 *
 * Support for clustered markers is for backward-compatability
 * reasons. Otherwise we should use a cluster-marker mixin or
 * subclass.
 */
exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'marker',
  ctr: function ctr() {
    return google.maps.Marker;
  },

  inject: {
    '$clusterPromise': {
      default: null
    }
  },

  render: function render(h) {
    if (!this.$slots.default || this.$slots.default.length === 0) {
      return '';
    } else if (this.$slots.default.length === 1) {
      // So that infowindows can have a marker parent
      return this.$slots.default[0];
    } else {
      return h('div', this.$slots.default);
    }
  },
  destroyed: function destroyed() {
    if (!this.$markerObject) {
      return;
    }

    if (this.$clusterObject) {
      // Repaint will be performed in `updated()` of cluster
      this.$clusterObject.removeMarker(this.$markerObject, true);
    } else {
      this.$markerObject.setMap(null);
    }
  },
  beforeCreate: function beforeCreate(options) {
    if (this.$clusterPromise) {
      options.map = null;
    }

    return this.$clusterPromise;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    if (this.$clusterPromise) {
      this.$clusterPromise.then(function (co) {
        co.addMarker(inst);
        _this.$clusterObject = co;
      });
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(9);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    twoWay: false,
    type: Object
  },
  path: {
    type: Array,
    twoWay: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,

  name: 'polyline',
  ctr: function ctr() {
    return google.maps.Polyline;
  },

  afterCreate: function afterCreate() {
    var _this = this;

    var clearEvents = function () {};

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        _this.$polylineObject.setPath(path);

        var mvcPath = _this.$polylineObject.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', _this.$polylineObject.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(9);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    type: Object
  },
  path: {
    type: Array,
    twoWay: true,
    noBind: true
  },
  paths: {
    type: Array,
    twoWay: true,
    noBind: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,
  mappedProps: props,
  name: 'polygon',
  ctr: function ctr() {
    return google.maps.Polygon;
  },

  beforeCreate: function beforeCreate(options) {
    if (!options.path) delete options.path;
    if (!options.paths) delete options.paths;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    var clearEvents = function () {};

    // Watch paths, on our own, because we do not want to set either when it is
    // empty
    this.$watch('paths', function (paths) {
      if (paths) {
        clearEvents();

        inst.setPaths(paths);

        var updatePaths = function () {
          _this.$emit('paths_changed', inst.getPaths());
        };
        var eventListeners = [];

        var mvcArray = inst.getPaths();
        for (var i = 0; i < mvcArray.getLength(); i++) {
          var mvcPath = mvcArray.getAt(i);
          eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);
        }
        eventListeners.push([mvcArray, mvcArray.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        inst.setPaths(path);

        var mvcPath = inst.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', inst.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                obj = _ref4[0],
                listenerHandle = _ref4[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(9);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    type: Object,
    twoWay: true,
    required: true
  },
  radius: {
    type: Number,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'circle',
  ctr: function ctr() {
    return google.maps.Circle;
  },
  events: events
});

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(9);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  bounds: {
    type: Object,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'rectangle',
  ctr: function ctr() {
    return google.maps.Rectangle;
  },
  events: events
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__(221);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(389);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(9);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  options: {
    type: Object,
    required: false,
    default: function _default() {
      return {};
    }
  },
  position: {
    type: Object,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  }
};

var events = ['domready', 'closeclick', 'content_changed'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'infoWindow',
  ctr: function ctr() {
    return google.maps.InfoWindow;
  },
  props: {
    opened: {
      type: Boolean,
      default: true
    }
  },

  inject: {
    '$markerPromise': {
      default: null
    }
  },

  mounted: function mounted() {
    var el = this.$refs.flyaway;
    el.parentNode.removeChild(el);
  },
  beforeCreate: function beforeCreate(options) {
    var _this = this;

    options.content = this.$refs.flyaway;

    if (this.$markerPromise) {
      delete options.position;
      return this.$markerPromise.then(function (mo) {
        _this.$markerObject = mo;
        return mo;
      });
    }
  },


  methods: {
    _openInfoWindow: function _openInfoWindow() {
      if (this.opened) {
        if (this.$markerObject !== null) {
          this.$infoWindowObject.open(this.$map, this.$markerObject);
        } else {
          this.$infoWindowObject.open(this.$map);
        }
      } else {
        this.$infoWindowObject.close();
      }
    }
  },

  afterCreate: function afterCreate() {
    var _this2 = this;

    this._openInfoWindow();
    this.$watch('opened', function () {
      _this2._openInfoWindow();
    });
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__(222);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(394);
function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(392);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(22)("b6f23878", content, true, {});

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, ".vue-map-container{position:relative}.vue-map-container .vue-map{left:0;right:0;top:0;bottom:0;position:absolute}.vue-map-hidden{display:none}", ""]);

// exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(53);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(29);

var _mountableMixin = __webpack_require__(55);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(223);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(54);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    required: true,
    twoWay: true,
    type: Object,
    noBind: true
  },
  zoom: {
    required: false,
    twoWay: true,
    type: Number,
    noBind: true
  },
  heading: {
    type: Number,
    twoWay: true
  },
  mapTypeId: {
    twoWay: true,
    type: String
  },
  tilt: {
    twoWay: true,
    type: Number
  },
  options: {
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['bounds_changed', 'click', 'dblclick', 'drag', 'dragend', 'dragstart', 'idle', 'mousemove', 'mouseout', 'mouseover', 'resize', 'rightclick', 'tilesloaded'];

// Plain Google Maps methods exposed here for convenience
var linkedMethods = ['panBy', 'panTo', 'panToBounds', 'fitBounds'].reduce(function (all, methodName) {
  all[methodName] = function () {
    if (this.$mapObject) {
      this.$mapObject[methodName].apply(this.$mapObject, arguments);
    }
  };
  return all;
}, {});

// Other convenience methods exposed by Vue Google Maps
var customMethods = {
  resize: function resize() {
    if (this.$mapObject) {
      google.maps.event.trigger(this.$mapObject, 'resize');
    }
  },
  resizePreserveCenter: function resizePreserveCenter() {
    if (!this.$mapObject) {
      return;
    }

    var oldCenter = this.$mapObject.getCenter();
    google.maps.event.trigger(this.$mapObject, 'resize');
    this.$mapObject.setCenter(oldCenter);
  },


  /// Override mountableMixin::_resizeCallback
  /// because resizePreserveCenter is usually the
  /// expected behaviour
  _resizeCallback: function _resizeCallback() {
    this.resizePreserveCenter();
  }
};

exports.default = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),

  provide: function provide() {
    var _this = this;

    this.$mapPromise = new Promise(function (resolve, reject) {
      _this.$mapPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$mapPromise': this.$mapPromise
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.center && typeof this.center.lat === 'function' ? this.center.lat() : this.center.lat;
    },
    finalLng: function finalLng() {
      return this.center && typeof this.center.lng === 'function' ? this.center.lng() : this.center.lng;
    },
    finalLatLng: function finalLatLng() {
      return { lat: this.finalLat, lng: this.finalLng };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$mapObject) {
        this.$mapObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-map'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;
      _this2.$mapObject = new google.maps.Map(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$mapObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$mapObject, events);

      // manually trigger center and zoom
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        _this2.$mapObject.addListener('center_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('center_changed', _this2.$mapObject.getCenter());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$mapObject.setCenter(_this2.finalLatLng);
        });
      });
      _this2.$mapObject.addListener('zoom_changed', function () {
        _this2.$emit('zoom_changed', _this2.$mapObject.getZoom());
      });
      _this2.$mapObject.addListener('bounds_changed', function () {
        _this2.$emit('bounds_changed', _this2.$mapObject.getBounds());
      });

      _this2.$mapPromiseDeferred.resolve(_this2.$mapObject);

      return _this2.$mapObject;
    }).catch(function (error) {
      throw error;
    });
  },

  methods: _extends({}, customMethods, linkedMethods)
};

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__(224);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(399);
function injectStyle (ssrContext) {
  __webpack_require__(396)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(397);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(22)("f6bcaac0", content, true, {});

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, ".vue-street-view-pano-container{position:relative}.vue-street-view-pano-container .vue-street-view-pano{left:0;right:0;top:0;bottom:0;position:absolute}", ""]);

// exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(53);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(29);

var _mountableMixin = __webpack_require__(55);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(223);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(54);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  zoom: {
    twoWay: true,
    type: Number
  },
  pov: {
    twoWay: true,
    type: Object,
    trackProperties: ['pitch', 'heading']
  },
  position: {
    twoWay: true,
    type: Object,
    noBind: true
  },
  pano: {
    twoWay: true,
    type: String
  },
  motionTracking: {
    twoWay: false,
    type: Boolean
  },
  visible: {
    twoWay: true,
    type: Boolean,
    default: true
  },
  options: {
    twoWay: false,
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['closeclick', 'status_changed'];

exports.default = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),
  replace: false, // necessary for css styles
  methods: {
    resize: function resize() {
      if (this.$panoObject) {
        google.maps.event.trigger(this.$panoObject, 'resize');
      }
    }
  },

  provide: function provide() {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _this.$panoPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$panoPromise': promise,
      '$mapPromise': promise // so that we can use it with markers
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.position && typeof this.position.lat === 'function' ? this.position.lat() : this.position.lat;
    },
    finalLng: function finalLng() {
      return this.position && typeof this.position.lng === 'function' ? this.position.lng() : this.position.lng;
    },
    finalLatLng: function finalLatLng() {
      return {
        lat: this.finalLat,
        lng: this.finalLng
      };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$panoObject) {
        this.$panoObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-street-view-pano'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;

      _this2.$panoObject = new google.maps.StreetViewPanorama(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$panoObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$panoObject, events);

      // manually trigger position
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        // Panos take a while to load
        increment();

        _this2.$panoObject.addListener('position_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('position_changed', _this2.$panoObject.getPosition());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$panoObject.setPosition(_this2.finalLatLng);
        });
      });

      _this2.$panoPromiseDeferred.resolve(_this2.$panoObject);

      return _this2.$panoPromise;
    }).catch(function (error) {
      throw error;
    });
  }
};

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(401);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__(227);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e5bf798c_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(404);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e5bf798c_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindProps = __webpack_require__(29);

var _simulateArrowDown = __webpack_require__(226);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

var _mapElementFactory = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mappedProps = {
  bounds: {
    type: Object
  },
  componentRestrictions: {
    type: Object,
    // Do not bind -- must check for undefined
    // in the property
    noBind: true
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  }
};

var props = {
  placeholder: {
    required: false,
    type: String
  },
  selectFirstOnEnter: {
    require: false,
    type: Boolean,
    default: false
  },
  value: {
    type: String,
    default: ''
  },
  options: {
    type: Object
  }
};

exports.default = {
  mounted: function mounted() {
    var _this = this;

    this.$gmapApiPromiseLazy().then(function () {
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      /* eslint-disable no-unused-vars */
      var finalOptions = _extends({}, (0, _bindProps.getPropsValues)(_this, mappedProps), _this.options);

      _this.$autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, finalOptions);
      (0, _bindProps.bindProps)(_this, _this.$autocomplete, mappedProps);

      _this.$watch('componentRestrictions', function (v) {
        if (v !== undefined) {
          _this.$autocomplete.setComponentRestrictions(v);
        }
      });

      // Not using `bindEvents` because we also want
      // to return the result of `getPlace()`
      _this.$autocomplete.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.$autocomplete.getPlace());
      });
    });
  },

  props: _extends({}, (0, _mapElementFactory.mappedPropsToVueProps)(mappedProps), props)
};

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js